(function () {
    var config = {};

// Import variables if present (from env.js)
    if (window) {
        initForSafari();
        Object.assign(config, window.__config);
    }

    function initForSafari() {
        if (!Object.assign) {
            Object.defineProperty(Object, 'assign', {
                enumerable: false,
                configurable: true,
                writable: true,
                value: function (target, firstSource) {
                    'use strict';
                    if (target === undefined || target === null) {
                        throw new TypeError('Cannot convert first argument to object');
                    }

                    var to = Object(target);
                    for (var i = 1; i < arguments.length; i++) {
                        var nextSource = arguments[i];
                        if (nextSource === undefined || nextSource === null) {
                            continue;
                        }

                        var keysArray = Object.keys(Object(nextSource));
                        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                            var nextKey = keysArray[nextIndex];
                            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                            if (desc !== undefined && desc.enumerable) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                    return to;
                }
            });
        }

        //.....................

        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
                return this.substr(position || 0, searchString.length) === searchString;
            };
        }
    }

    var app = angular
        .module('tikonApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            // 'leaflet',
            // 'leaflet-directive',
            // 'nemLogging',
            // 'ui-leaflet',

            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'lr.upload',
            'persian_datepicker',
            'ngImgCrop',
            'thatisuday.ng-image-gallery'
            , 'ngMaterial',
            'summernote',
            'smart-table',
            'ui.bootstrap.modal',
            'angular-img-cropper',
            'angular-momentjs',
            'rzModule',
            'vcRecaptcha',
            'chart.js',
            'ngJoyRide',
            'ngMap',
            'mgo-angular-wizard',
            'ngMessages',
            'moment-picker'
            //'md.time.picker'order
            //'cmGoogleApi'
            //,'720kb.socialshare'
        ]).config(['$mdThemingProvider', function ($mdThemingProvider) {

            $mdThemingProvider.theme('default')
                .primaryPalette('blue-grey')
                .backgroundPalette('grey')
                .warnPalette('red')
                .accentPalette('orange');
        }])
        .config(['$mdGestureProvider', function ($mdGestureProvider) {
            $mdGestureProvider.skipClickHijack();
        }])
        //.config(['googleClientProvider',function (googleClientProvider) {
        //    googleClientProvider
        //        .loadPickerLibrary()
        //        .loadGoogleAuth({
        //            cookie_policy: 'single_host_origin',
        //            hosted_domain: '    localhost:8080',
        //            fetch_basic_profile: true
        //        })
        //        .setClientId('26554230915-f6jfkijap7k1arflsi80278isjjhmqko.apps.googleusercontent.com')
        //        //.addScope('a scope')
        //        //.addScope('another scope')
        //        //.addApi('myApi', 'v1', 'https://app-id.appspot.com/_ah/api')
        //        .addApi('oauth2', 'v2');
        //}])
        .constant('__config', config).run(run);


    run.$inject = ['stateHandler', 'translationHandler', 'PushNotificationService', '$timeout' , 'ENV'];


    //app.config(['$googleClientProvider',function (googleClientProvider) {
    //    googleClientProvider
    //        .loadPickerLibrary()
    //        .loadGoogleAuth({
    //            cookie_policy: 'single_host_origin',
    //            hosted_domain: '    localhost:8080',
    //            fetch_basic_profile: true
    //        })
    //        .setClientId('26554230915-f6jfkijap7k1arflsi80278isjjhmqko.apps.googleusercontent.com')
    //        //.addScope('a scope')
    //        //.addScope('another scope')
    //        //.addApi('myApi', 'v1', 'https://app-id.appspot.com/_ah/api')
    //        .addApi('oauth2', 'v2');
    // }]);
    function run(stateHandler, translationHandler, PushNotificationService, $timeout, ENV) {
        stateHandler.initialize();
        translationHandler.initialize();

        PushNotificationService.initPushNotification()


        //set cdn url of panel-vue
        window.NEWPANEL_CDN = ENV.NEWPANEL_CDN; 
        //load vue panel script
        // $timeout(loadPanelVueScript, 50);
        loadPanelVueScript()
        function loadPanelVueScript() {
            var script = document.createElement('script');
            script.type = "module";
            script.src = ENV.NEWPANEL_CDN + "planovin-panel-starter.js?v=" + new Date().getTime();
            script.defer = true;
            document.head.appendChild(script)
        }
    }


})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WizardService', WizardService);

    WizardService.$inject = ['$resource', 'ENV'];

    function WizardService($resource, ENV) {
        function saveInitSetup() {
            var url = ENV.API_BASE_URL + 'api/save-init-wizard';
            return $resource(url, {}, {});
        }

        function saveInitSetupEvent() {
            var url = ENV.API_BASE_URL + 'api/save-init-wizard-event';
            return $resource(url, {}, {});
        }

        return {
            saveInitSetup: saveInitSetup,
            saveInitSetupEvent: saveInitSetupEvent
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InitSetupV2Controller', InitSetupV2Controller);

    InitSetupV2Controller.$inject = ['$rootScope', '$scope', 'WizardHandler', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'WizardService', 'ServiceCategoryCustom', 'CompanyCustom', 'UserProfileQuery', 'ActivityTypeInfoCustom', '$stateParams', 'CompanyInfoQuery', 'entity', 'UserCustom'];

    function InitSetupV2Controller($rootScope, $scope, WizardHandler, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, WizardService, ServiceCategoryCustom, CompanyCustom, UserProfileQuery, ActivityTypeInfoCustom, $stateParams, CompanyInfoQuery, entity, UserCustom) {
        var vm = this;
        vm.entity = entity;
        vm.wizardData;
        vm.isCompanyInfoValid = false;
        vm.isScheduleInfoValid = false;
        vm.isServiceItemValid = false;
        vm.isBusy = false;
        vm.initWizardData = initWizardData;
        vm.saveWizardData = saveWizardData;
        vm.nextFromStep = nextFromStep;
        vm.isStepValid = isStepValid;
        vm.prevFromStep = prevFromStep;
        vm.initWizardData();
        vm.setScheduleInfoValid = function setScheduleInfoValid(isvalid) {
            vm.isScheduleInfoValid = isvalid;
        }
        vm.setCompanyInfoValid = function setCompanyInfoValid(isvalid) {
            vm.isCompanyInfoValid = isvalid;
        }
        vm.setServiceItemValid = function setServiceItemValid(isvalid) {
            vm.isServiceItemValid = isvalid;
        }

        vm.getCurrentStepNumber = getCurrentStepNumber;
        vm.getStepTitle = getStepTitle;
        vm.goToDashboard = goToDashboard;
        vm.isWorkSpace = false;
        vm.isResetMode = false;
        vm.userInsight;


        loadData();


        function loadData() {

            if (vm.entity && vm.entity.resetMode)
                vm.isResetMode = vm.entity.resetMode;
            checkCurrentCompany();
            getCurrentUser();
        }

        function getCurrentUser() {
            UserProfileQuery.getCurrentPersonInfo().query(function (p) {
                vm.personInfo = p;
            });
        }


        function checkCurrentCompany() {
            CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {
                if (c && c.title && !vm.isResetMode)
                    $state.go('supplierPanel-v2.dashboard');
            })
        }


        $rootScope.$broadcast('hideNavBar');

        function nextFromStep() {

            var wizard = WizardHandler.wizard();
            var currentStep = wizard.currentStepNumber();
            if (vm.isStepValid(currentStep)) {
                //end step
                if (currentStep == 3) {
                    vm.saveWizardData(function (savedDate) {
                        vm.wizardData = savedDate;
                        vm.isBusy = false;
                        addGTagData();
                        wizard.next();
                        Principal.setCurrentCompany(vm.wizardData.company);
                    }, function (error) {
                        vm.isBusy = false;
                    });
                } else {
                    wizard.next();
                }
            }
        }

        function prevFromStep() {
            var wizard = WizardHandler.wizard();
            wizard.previous();
        }

        function isStepValid(stepNumber) {
            switch (stepNumber) {
                case 1:
                    return vm.isCompanyInfoValid;
                case 2:
                    return vm.isScheduleInfoValid;
                case 3:
                    return vm.isServiceItemValid;
            }

        }

        function initWizardData() {

            vm.wizardData = {};
            vm.wizardData.serviceItem = {};
            vm.wizardData.serviceItems = [];
            vm.wizardData.serviceItems.push(vm.wizardData.serviceItem);
            vm.wizardData.newServant = {};
            vm.wizardData.newServant.personInfo = {};
            vm.wizardData.newServant.personInfo.fisrtName = null;

        }

        function collectWizardData() {
            vm.wizardData.serviceItems[0] = vm.wizardData.serviceItem;
        }

        function saveWizardData(onSuccess, onFail) {
            vm.isBusy = true;
            collectWizardData();

            //update user insight data
            UserCustom.updateUserInsight().update(vm.userInsight)
            return WizardService.saveInitSetup().save(vm.wizardData, onSuccess, onFail);

        }


        function SetDataByActivityType() {

            if (vm.wizardData.company == null || vm.wizardData.company == undefined || !vm.wizardData.company.activityType)
                return;

            ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.wizardData.company.activityType).query(function (activity) {
                vm.activityTypeInfo = activity;
                if (activity && activity.servantType == "RESOURCE") {
                    vm.isWorkSpace = true;
                    vm.wizardData.serviceItem.itemTitle = vm.activityTypeInfo.serviceSamplePlaceHolder;
                    vm.wizardData.serviceItem.duration = 60;
                    vm.wizardData.serviceItem.minPrice = 0.0;

                    vm.wizardData.newServant = {};
                    vm.wizardData.newServant.personInfo = {};
                    vm.wizardData.newServant.personInfo.fisrtName = vm.activityTypeInfo.servantTitle + ' شماره 1 ';
                    vm.wizardData.newServant.personInfo.lastname = ' ';
                } else {
                    vm.isWorkSpace = false;
                    vm.wizardData.serviceItem.itemTitle = vm.activityTypeInfo.serviceSamplePlaceHolder;
                    vm.wizardData.serviceItem.duration = 60;
                    vm.wizardData.serviceItem.minPrice = 100000.0;

                    // vm.wizardData.serviceItem = {};
                    vm.wizardData.newServant = {};
                    vm.wizardData.newServant.personInfo = vm.personInfo;
                }

            })

        }

        function addGTagData() {


            var activityType = 'NOT_SET';
            if (vm.wizardData.company && vm.wizardData.company.activityType) {
                activityType = vm.wizardData.company.activityType;
            }

            try {
                //user Free Account Started
                if (gtag()) {
                    gtag('event', 'freemium_start', {
                        "items": [
                            {
                                "id": "PL102",
                                "name": "14 Days Free Account",
                                "list_name": "",
                                "brand": "Planovin",
                                "category": vm.wizardData.company.activityType,
                                "price": '0'
                            }
                        ]
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }

        function getCurrentStepNumber() {
            var wizard = WizardHandler.wizard();
            return wizard.currentStepNumber();
        }

        function getStepTitle(stepNumber) {
            if (getCurrentStepNumber() == stepNumber) {
                switch (stepNumber) {
                    case 1 :
                        return 'wizard.initsetup.step1';
                    case 2 :
                        return 'wizard.initsetup.step2';
                    case 3 :
                        return 'wizard.initsetup.step3';
                    case 4 :
                        return 'wizard.initsetup.step4';
                }
            }
        }

        function goToDashboard() {
            $rootScope.$broadcast('reloadNavBarData');
            $state.go('supplierPanel-v2.dashboard');
        }

        $scope.$watch('vm.wizardData.company.activityType', function () {
            SetDataByActivityType();
        });


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('initSetupWizardEvent', {
                parent: 'app',
                url: '/initSetupWizardEvent',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/wizards/init-setup-event/init-setup-event.html',
                        controller: 'InitSetupEventController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })


        ;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InitSetupEventController', InitSetupEventController);

    InitSetupEventController.$inject = ['$scope', 'WizardHandler', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'WizardService', 'ServiceCategoryCustom', 'CompanyCustom'];

    function InitSetupEventController($scope, WizardHandler, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, WizardService, ServiceCategoryCustom, CompanyCustom) {
        var vm = this;
        vm.wizardData;
        vm.isCompanyInfoValid = false;
        vm.isScheduleInfoValid = false;
        vm.isServiceItemValid = false;
        vm.isBusy = false;
        vm.initWizardData = initWizardData;
        vm.saveWizardData = saveWizardData;
        vm.nextFromStep = nextFromStep;
        vm.isStepValid = isStepValid;
        vm.prevFromStep = prevFromStep;
        vm.initWizardData();
        vm.setScheduleInfoValid = function setScheduleInfoValid(isvalid) {
            vm.isScheduleInfoValid = isvalid;
        }
        vm.setCompanyInfoValid = function setCompanyInfoValid(isvalid) {
            vm.isCompanyInfoValid = isvalid;
        }
        vm.setServiceItemValid = function setServiceItemValid(isvalid) {
            vm.isServiceItemValid = isvalid;
        }


        function nextFromStep() {

            var wizard = WizardHandler.wizard();
            var currentStep = wizard.currentStepNumber();
            if (vm.isStepValid(currentStep)) {
                //end step
                if (currentStep == 1) {
                    vm.saveWizardData(function (savedDate) {
                        vm.wizardData = savedDate;
                        vm.isBusy = false;
                        wizard.next();
                        Principal.setCurrentCompany(vm.wizardData.company);
                    }, function (error) {
                        vm.isBusy = false;
                    });
                } else {
                    wizard.next();
                }
            }
        }

        function prevFromStep() {
            var wizard = WizardHandler.wizard();
            wizard.previous();
        }

        function isStepValid(stepNumber) {
            switch (stepNumber) {
                case 1:
                    return vm.isCompanyInfoValid;
                case 2:
                    return vm.isScheduleInfoValid;
                case 3:
                    return vm.isServiceItemValid;
            }

        }

        function initWizardData() {

            //CompanyCustom.getCurrentCompany().query().$promise.then(function(result){
            //    if(result != null && result != undefined )
            //    {
            //        if(result.title !=null && result.title !=undefined &&result.title != '')
            //        {
            //            $state.go('supplierPanel.dashboard');
            //        }
            //    }
            //})
            vm.wizardData = {};
            vm.wizardData.serviceItem = {};
            vm.wizardData.serviceItems = [];
            vm.wizardData.serviceItems.push(vm.wizardData.serviceItem);
            vm.wizardData.newServant = {};
            vm.wizardData.newServant.personInfo = {};
            vm.wizardData.newServant.personInfo.fisrtName = null;

        }

        function collectWizardData() {
            vm.wizardData.serviceItems[0] = vm.wizardData.serviceItem;
        }

        function saveWizardData(onSuccess, onFail) {
            vm.isBusy = true;
            collectWizardData();

            return WizardService.saveInitSetupEvent().save(vm.wizardData, onSuccess, onFail);
        }


        function SetDataByActivityType() {

            if (vm.wizardData.company == null || vm.wizardData.company == undefined)
                return;
            // if(vm.wizardData.company.activityType == 'WORK_SPACE')
            // {
            //     vm.wizardData.serviceItem.itemTitle = 'رزرو به صورت ساعتی';
            //     vm.wizardData.serviceItem.duration = 60;
            //     vm.wizardData.serviceItem.minPrice = 0.0;
            // }
        }

        $scope.$watch('vm.wizardData.company.activityType', function () {

            SetDataByActivityType();
        });


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('initSetupWizard', {
                parent: 'app',
                url: '/initSetupWizard',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/wizards/init-setup/init-setup.html',
                        controller: 'InitSetupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })


        ;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InitSetupController', InitSetupController);

    InitSetupController.$inject = ['$scope', 'WizardHandler', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'WizardService', 'ServiceCategoryCustom', 'CompanyCustom'];

    function InitSetupController($scope, WizardHandler, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, WizardService, ServiceCategoryCustom, CompanyCustom) {
        var vm = this;
        vm.wizardData;
        vm.isCompanyInfoValid = false;
        vm.isScheduleInfoValid = false;
        vm.isServiceItemValid = false;
        vm.isBusy = false;
        vm.initWizardData = initWizardData;
        vm.saveWizardData = saveWizardData;
        vm.nextFromStep = nextFromStep;
        vm.isStepValid = isStepValid;
        vm.prevFromStep = prevFromStep;
        vm.initWizardData();
        vm.setScheduleInfoValid = function setScheduleInfoValid(isvalid) {
            vm.isScheduleInfoValid = isvalid;
        }
        vm.setCompanyInfoValid = function setCompanyInfoValid(isvalid) {
            vm.isCompanyInfoValid = isvalid;
        }
        vm.setServiceItemValid = function setServiceItemValid(isvalid) {
            vm.isServiceItemValid = isvalid;
        }


        function nextFromStep() {

            var wizard = WizardHandler.wizard();
            var currentStep = wizard.currentStepNumber();
            if (vm.isStepValid(currentStep)) {
                //end step
                if (currentStep == 3) {
                    vm.saveWizardData(function (savedDate) {
                        vm.wizardData = savedDate;
                        vm.isBusy = false;
                        addGTagData();
                        wizard.next();
                        Principal.setCurrentCompany(vm.wizardData.company);
                    }, function (error) {
                        vm.isBusy = false;
                    });
                } else {
                    wizard.next();
                }
            }
        }

        function prevFromStep() {
            var wizard = WizardHandler.wizard();
            wizard.previous();
        }

        function isStepValid(stepNumber) {
            switch (stepNumber) {
                case 1:
                    return vm.isCompanyInfoValid;
                case 2:
                    return vm.isScheduleInfoValid;
                case 3:
                    return vm.isServiceItemValid;
            }

        }

        function initWizardData() {

            //CompanyCustom.getCurrentCompany().query().$promise.then(function(result){
            //    if(result != null && result != undefined )
            //    {
            //        if(result.title !=null && result.title !=undefined &&result.title != '')
            //        {
            //            $state.go('supplierPanel.dashboard');
            //        }
            //    }
            //})
            vm.wizardData = {};
            vm.wizardData.serviceItem = {};
            vm.wizardData.serviceItems = [];
            vm.wizardData.serviceItems.push(vm.wizardData.serviceItem);
            vm.wizardData.newServant = {};
            vm.wizardData.newServant.personInfo = {};
            vm.wizardData.newServant.personInfo.fisrtName = null;

        }

        function collectWizardData() {
            vm.wizardData.serviceItems[0] = vm.wizardData.serviceItem;
        }

        function saveWizardData(onSuccess, onFail) {
            vm.isBusy = true;
            collectWizardData();

            return WizardService.saveInitSetup().save(vm.wizardData, onSuccess, onFail);
        }


        function SetDataByActivityType() {

            if (vm.wizardData.company == null || vm.wizardData.company == undefined)
                return;
            if (vm.wizardData.company.activityType == 'WORK_SPACE') {
                vm.wizardData.serviceItem.itemTitle = 'رزرو به صورت ساعتی';
                vm.wizardData.serviceItem.duration = 60;
                vm.wizardData.serviceItem.minPrice = 0.0;
            }
        }

        function addGTagData() {


            var activityType = 'NOT_SET';
            if (vm.wizardData.company && vm.wizardData.company.activityType) {
                activityType = vm.wizardData.company.activityType;
            }

            try {
                //user Free Account Started
                if (gtag()) {
                    gtag('event', 'freemium_start', {
                        "items": [
                            {
                                "id": "PL102",
                                "name": "14 Days Free Account",
                                "list_name": "",
                                "brand": "Planovin",
                                "category": vm.wizardData.company.activityType,
                                "price": '0'
                            }
                        ]
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }

        $scope.$watch('vm.wizardData.company.activityType', function () {

            SetDataByActivityType();
        });


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserProfileV2Controller', UserProfileV2Controller);

    UserProfileV2Controller.$inject = ['PersonInfo', 'UserProfileQuery', 'LocationInfo', '$translate', '$scope', 'SelectorData', 'SelectorDataQuery', 'entity', '$rootScope','LegalActualInfoService'];

    function UserProfileV2Controller(PersonInfo, UserProfileQuery, LocationInfo, $translate, $scope, SelectorData, SelectorDataQuery, entity, $rootScope, LegalActualInfoService) {
        var vm = this;
        vm.personInfo = entity;
        vm.legalInfo = {}
        vm.accid = null;
        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.success = true;
        vm.selectordata = SelectorData.query();
        vm.blockEditPhoneNumber = true;

        vm.closeModal = closeModal;
        vm.okModal = okModal;

        loadData()

        function save() {
            //
            vm.isSaving = true;

            if (vm.personInfo.id !== null) {
                PersonInfo.update(vm.personInfo, onSaveSuccess, onSaveError);
            } else {
                // ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:userProfileUpdate', result);
            vm.personInfo = result;
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();
            $rootScope.modalInstance.dismiss('cancel');
        }
          function loadData(){
            const res = LegalActualInfoService.fetchInfo().query()
            vm.legalInfo = res
        }

    }
})();
;
// (function() {
//     'use strict';
//
//     angular
//         .module('tikonApp')
//         .config(stateConfig);
//
//     stateConfig.$inject = ['$stateProvider'];
//
//     function stateConfig($stateProvider) {
//         $stateProvider.state('userProfile', {
//             parent: 'app',
//             url: '/userProfile',
//             data: {
//                 authorities: ['ROLE_USER'],
//                 pageTitle: 'global.menu.account.user-profile'
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/userprofile/user-profiles.html',
//                     controller: 'UserProfileController',
//                     controllerAs: 'vm'
//                 }
//             },
//             resolve: {
//                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                     $translatePartialLoader.addPart('personInfo');
//                     return $translate.refresh();
//                 }]
//             }
//
//         })
//
//             .state('userProfile.editPerson', {
//                 parent: 'userProfile',
//                 url: '/{id}/editPerson',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//
//                         templateUrl: 'app/entities/person-info/person-info-dialog.html',
//                         controller: 'PersonInfoDialogController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg',
//                         resolve: {
//                             entity: ['PersonInfo', function(PersonInfo) {
//                                 return PersonInfo.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('userProfile', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//
//
//
//         ;
//     }
// })();
;
// (function() {
//     'use strict';
//
//     angular
//         .module('tikonApp')
//         .controller('UserProfileController', UserProfileController);
//
//     UserProfileController.$inject = ['Principal', 'Auth' , 'PersonInfo' ,'PersonInfoQuery' , '$translate','$scope'];
//
//     function UserProfileController (Principal, Auth,PersonInfo,PersonInfoQuery,  $translate,$scope) {
//         var vm = this;
//         vm.accid   = null;
//         vm.error = null;
//         vm.save = save;
//         vm.loadPersonClick= loadPersonClick;
//         vm.settingsAccount = null;
//         vm.success = null;
//         vm.myName=['saeed','majid'];
//         vm.personInfoDTO = '';
//         vm.personInfoDTOlist = ['test','mest'];
//         vm.userName = 'majiduser';
//         //vm.firstName = 'majid';
//         //vm.lastName = 'fattahi';
//         vm.email= 'magid_plus_@yahoo.com'
//         vm.success = true;
//         vm.nationalCode = null;
//         vm.personID = null;
//
//         /**
//          * Store the "settings account" in a separate variable, and not in the shared "account" variable.
//          */
//         var copyAccount = function (account) {
//             return {
//
//                 activated: account.activated,
//                 email: account.email,
//                 firstName: 'majid',//account.firstName,
//                 langKey: account.langKey,
//                 lastName: 'fattahi',//account.lastName,
//                 login: account.login,
//                 id:account.id
//             };
//         };
//
//
//
//
//         Principal.identity().then(function(account) {
//             vm.settingsAccount = copyAccount(account);
//         });
//
//          function save () {
//              vm.firstName = 'saeed';
//           }
//
//
//         function loadPersonByID(id)
//         {
//
//             // vm.personInfoDTO=  PersonInfo.get({id : id});
//             
//             vm.personInfoDTOlist= PersonInfoQuery.findByFirstName('fff').query().$promise;
//             //vm.myName= PersonInfoQuery.findByFirstName('fff').query();
//             vm.personInfoDTO = vm.personInfoDTOlist[0];
//
//             //setTimeout(500);
//             //console.log(vm.myName);
//
//         }
//
//         function loadPersonClick  () {
//             loadPersonByID(vm.accid)
//         }
//
//         //     Auth.updateAccount(vm.settingsAccount).then(function() {
//         //         vm.error = null;
//         //         vm.success = 'OK';
//         //         Principal.identity(true).then(function(account) {
//         //             vm.settingsAccount = copyAccount(account);
//         //         });
//         //         JhiLanguageService.getCurrent().then(function(current) {
//         //             if (vm.settingsAccount.langKey !== current) {
//         //                 $translate.use(vm.settingsAccount.langKey);
//         //             }
//         //         });
//         //     }).catch(function() {
//         //         vm.success = null;
//         //         vm.error = 'ERROR';
//         //     });
//         // }
//     }
// })();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('UserProfileQuery', UserProfileQuery);

    UserProfileQuery.$inject = ['$resource'];

    function UserProfileQuery($resource) {


        var getCurrentPersonInfo = function () {
            var resourceUrl = 'api/getCurrentPersonInfo';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            getCurrentPersonInfo: getCurrentPersonInfo
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('userProfile', {
                parent: 'app',
                url: '/userProfile',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.user-profile'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/userprofile/user-profiles.html',
                        controller: 'UserProfileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('userProfile');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UserProfileQuery', function ($stateParams, UserProfileQuery) {

                        return UserProfileQuery.getCurrentPersonInfo().query();
                    }]
                }

            })


        ;
    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserProfileController', UserProfileController);

    UserProfileController.$inject = ['PersonInfo', 'UserProfileQuery', 'LocationInfo', '$translate', '$scope', 'SelectorData', 'SelectorDataQuery', 'entity'];

    function UserProfileController(PersonInfo, UserProfileQuery, LocationInfo, $translate, $scope, SelectorData, SelectorDataQuery, entity) {
        var vm = this;
        vm.personInfo = entity;
        vm.accid = null;
        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.success = true;
        vm.selectordata = SelectorData.query();
        vm.blockEditPhoneNumber = true;

        function save() {
            //
            vm.isSaving = true;

            if (vm.personInfo.id !== null) {
                PersonInfo.update(vm.personInfo, onSaveSuccess, onSaveError);
            } else {
                // ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:userProfileUpdate', result);
            vm.personInfo = result;
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('timeBoard', {
                parent: 'app',
                url: '/timeBoard',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/time-board/time-board.html',
                        controller: 'TimeBoardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })


        ;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TimeBoardController', TimeBoardController);

    TimeBoardController.$inject = ['$scope', '$location', '$window', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout'];

    function TimeBoardController($scope, $location, $window, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            //  var path = $location.path();
            //if ((path == '/supplierPanel/timeBoard' || path == '/timeBoard') && result[0].company.appVersion == 'v2') {
            //    $window.location.href = '/#/supplierPanel/calendar';
            //}

            vm.categories = result;
            angular.forEach(result, function (item) {
                item.categoryName = categoryName(item.categoryName)
            })
        });

        vm.getFromDefaults();
        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateTimeBoard();
        //   }
        //
        //});
        vm.onServiceChanged = function () {
            vm.storeInDefaults();
            updateTimeBoard();
        }
        vm.onCategoryChanged = function () {

            if (vm.selectedCategoryId)
                vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCategory(vm.selectedCategoryId).query(function (list) {
                    if (list && list.length > 0) {
                        vm.selectedId = list[0].id;
                        vm.storeInDefaults();
                        updateTimeBoard();
                    }
                });
            else

                vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (list) {
                    if (list && list.length > 0) {
                        vm.getFromDefaults();
                        var isDefaultInList = false;
                        if (vm.selectedId != undefined)
                            angular.forEach(list, function (item) {
                                if (item.id == vm.selectedId)
                                    isDefaultInList = true;
                            });

                        if (vm.selectedId == undefined || !isDefaultInList) {
                            vm.selectedId = list[0].id;
                            vm.storeInDefaults();
                        }
                        updateTimeBoard();
                    }

                });

        }

        function startRefreshTimer() {
            setInterval(function () {
                vm.updateTimeBoard();
            }, 300000)


        }

        vm.updateTimeBoard = updateTimeBoard;

        function updateTimeBoard() {
            var serviceList = [];
            serviceList.push(vm.selectedId);
            TimingInfo.getTimingInfoByServiceItems.save({serviceItemIds: serviceList}, function (t) {
                vm.timingInfo = t;

            })
        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function storeInDefaults() {
            console.log('storing in storage :' + vm.selectedId)
            if (vm.selectedId != undefined)
                $localStorage.selectedId = vm.selectedId;
        }

        function getFromDefaults() {
            console.log('reading from storage :' + vm.selectedId)
            if ($localStorage.selectedId != undefined) {

                var serviceList = [];
                vm.selectedId = $localStorage.selectedId;
                console.log('exista storage :' + vm.selectedId)
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SharedTimeBoardController', SharedTimeBoardController);

    SharedTimeBoardController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout'];

    function SharedTimeBoardController($scope, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        vm.accessLevel = 'READ';


        vm.getFromDefaults();
        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateSharedTimeBoard();
        //   }
        //
        //});
        vm.onServiceChanged = function () {
            vm.storeInDefaults();
            updateSharedTimeBoard();
        }

        function startRefreshTimer() {
            setInterval(function () {
                vm.updateSharedTimeBoard();
            }, 300000)


        }

        vm.updateSharedTimeBoard = updateSharedTimeBoard;

        function updateSharedTimeBoard() {
            var serviceList = [];
            serviceList.push(vm.selectedId);
            TimingInfo.getTimingInfoByServiceItems.save({serviceItemIds: serviceList}, function (t) {
                vm.timingInfo = t;

            })
        }

        function storeInDefaults() {
            //console.log('storing in storage :'+vm.selectedId)
            //if(vm.selectedId!=undefined)
            //$localStorage.selectedId=vm.selectedId;
        }

        function getFromDefaults() {
            //console.log('reading from storage :'+vm.selectedId)
            //if($localStorage.selectedId!=undefined)
            //{
            //
            //    var serviceList=[];
            //    vm.selectedId=$localStorage.selectedId;
            //    console.log('exista storage :'+vm.selectedId)
            //}
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BookCalendarV2Controller', BookCalendarV2Controller);

    BookCalendarV2Controller.$inject = ['$scope', '$location', '$window', '$mdDialog', '$mdMedia', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout', 'ServantCustom', 'CompanyCustom', '$uibModal', '$rootScope', 'DateUtils'];

    function BookCalendarV2Controller($scope, $location, $window, $mdDialog, $mdMedia, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout, ServantCustom, CompanyCustom, $uibModal, $rootScope, DateUtils) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        vm.updateServantList = updateServantList;
        vm.onReserveOnlyChanged = onReserveOnlyChanged;
        vm.onReserveOnlyChangedReset = onReserveOnlyChangedReset;
        vm.updateTimeBoard = updateTimeBoard;
        vm.openFilterDialog = openFilterDialog;
        vm.onCategoryChanged = onCategoryChanged;
        vm.onServiceChanged = onServiceChanged;
        vm.onServantChanged = onServantChanged;
        vm.onServantChipClick = onServantChipClick;
        vm.onServiceChipClick = onServiceChipClick;
        vm.lastUpdate;
        vm.selectedServiceListChanged = false;

        vm.firstHour = 6;
        vm.lastHour = 24;
        vm.servantList = [];
        vm.selectedService = {};
        vm.selectedServiceList = [];
        vm.selectedServiceChips = [];
        vm.selectedServant = null;
        vm.selectedServantList = [];
        vm.firsthourList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        vm.lasthourList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        vm.reserveOnlyMode = true;
        vm.canSelectMultiService = false;
        var firstRun = true;
        vm.selectedServantServiceList = [];
        vm.selectedServantTitle = '';
        vm.querySearch = querySearch;
        vm.gotoNewReserve_flex = gotoNewReserve_flex;
        vm.selectionMode = null;
        vm.allServant = false;
        vm.setDayView = setDayView;
        vm.allServant_changed = allServant_changed;
        vm.servantChipsClick = servantChipsClick;
        vm.getChipsClass = getChipsClass;

        //arrow
        vm.slide = slide;
        vm.showLeftArrow = true;
        vm.showRightArrow = true;

        vm.getCalendarClass = getCalendarClass;
        vm.defaultCustomTime = false;
        vm.isSaving = false;
        vm.showEducation = showEducation;
        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.calendarApi = {};
        vm.showNewCalendarBanner = undefined;
        
        checkCompanySetting();
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            vm.categories = result;

            angular.forEach(result, function (item) {
                item.categoryName = categoryName(item.categoryName)
            })
            onCategoryChanged();
        });
        $scope.$watch('reserveOnlyMode', function (reserveOnlyMode) {


        });


        vm.filterProperties = {};
        vm.getFromDefaults();
        getAllServantList();
        // setDefaultShowNewCalendarBanner()

        // getAllServiceItemsByCurrentCompany();
        // addAllServicesAsSelected();


        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateTimeBoard();
        //   }
        //
        //});
        function checkCompanySetting() {

            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.company = result;
                if (vm.company.customSettingObject && vm.company.customSettingObject.defaultCustomTimeActive)
                    vm.defaultCustomTime = vm.company.customSettingObject.defaultCustomTimeActive;
            })

        }

        function updateServantList(then) {


            //  vm.selectedServantList = [];
            // vm.selectedServant=null;
            if (!vm.selectedServiceList || vm.selectedServiceList.length == 0) {
                // vm.selectedServantList = [];
                if (then)
                    then();
            }
                // else {
                //     vm.servantList = [];
                //     var index=0;
                //     if(vm.selectedServiceList.length>0) {
                //         angular.forEach(vm.selectedServiceList, function (service) {
                //             index++;
                //             ServiceItemCustom.getServiceServants(service).query(function (servants) {
                //                 angular.forEach(servants, function (serviceServant) {
                //                     var isInList = false;
                //                     angular.forEach(vm.servantList, function (servant) {
                //                         if (serviceServant.id == servant.id)
                //                             isInList = true;
                //                     })
                //                     if (!isInList) {
                //                         vm.servantList.push(serviceServant);
                //
                //                     }
                //
                //                 });
                //
                //                 if (index == vm.selectedServiceList.length) {
                //                     if (vm.servantList.length > 0) {
                //                         vm.selectedServant = vm.servantList[0].id;
                //
                //                         vm.selectedServantTitle = vm.servantList[0].servantName;
                //                         vm.selectedServantList.push(vm.servantList[0].id);
                //                     }
                //                     onServantChanged();
                //                     updateChipLists();
                //                     if (then)
                //                         then();
                //
                //                 }
                //
                //
                //             })
                //
                //
                //         })
            //     }
            else {
                vm.servantList = [];
                var index = 0;
                if (vm.selectedServiceList.length > 0) {

                    // ServantCustom.getServantsHaveServicesByCurrentCompany().query(function (servants) {
                    //
                    //     vm.servantList = servants;
                    // })
                    //
                    //     if (vm.servantList.length > 0) {
                    //         vm.selectedServant = vm.servantList[0].id;
                    //
                    //         vm.selectedServantTitle = vm.servantList[0].servantName;
                    //         vm.selectedServantList.push(vm.servantList[0].id);
                    //     }
                    //     onServantChanged();
                    //     updateChipLists();

                    getAllServantList();

                    if (then)
                        then();
                } else {
                    if (then)
                        then();
                }
            }

        }

        function findAvailableServiceByServant(servantId) {

        }

        vm.onServantListChanged = function () {

        }

        function addAllServicesAsSelected() {
            vm.selectedServiceList = [];
            angular.forEach(vm.serviceItems, function (si) {
                var selected = false;
                vm.selectedServiceList.push(si.id);

            });
        }

        function onServiceChanged(then) {
            vm.selectedServiceList = [];
            if (!vm.selectedServiceListChanged)
                if (vm.selectedService == 0) {
                    addAllServicesAsSelected();
                } else {
                    if (vm.selectedService)
                        vm.selectedServiceList.push(vm.selectedService);
                }


        }

        function afterSelectedServiceChanged(then) {
            checkIfSelectedServiceListIsValid();
            updateServantList(then);
        }

        function checkIfSelectedServiceListIsValid() {
            var isValid = true;
            angular.forEach(vm.selectedServiceList, function (ssi) {
                var selectedServiceIsValid = false;
                angular.forEach(vm.serviceItems, function (si) {
                    if (ssi == si.id)
                        selectedServiceIsValid = true;
                })
                if (!selectedServiceIsValid)
                    isValid = false;
            })
            if (!isValid) {

                vm.selectedService = {};
                vm.selectedServiceList = [];
                vm.selectedServantList = [];
            }

        }

        function onServantChipClick(sr) {
            if (sr) {
                vm.selectedServant = sr.id;
                vm.selectedServantTitle = sr.title;
            }
            onServantChanged();
            // updateChipLists();
            // updateTimeBoard();

        }

        function searchText() {
        }

        function onServiceChipClick(si) {

            vm.selectedServiceListChanged = true;

            si.selected = !si.selected;
            if (si.selected) {
                if (!vm.canSelectMultiService) {
                    vm.selectedServiceList = [];
                }

                vm.selectedServiceList.push(si.id);
            } else {
                vm.selectedServiceList = vm.selectedServiceList.filter(function (s) {
                    return s != si.id;
                })
            }
            afterSelectedServiceChanged(function () {
                updateChipLists();
                updateTimeBoard();
            })
        }

        function onServantChanged() {

            //  if (!vm.canSelectMultiService) {
            vm.selectedServantList = [];
            if (vm.selectedServant) {
                vm.selectedServantList.push(vm.selectedServant);

                if (!$scope.calendarFilter)
                    $scope.calendarFilter = {};

                $scope.calendarFilter.selectedServant = vm.selectedServant;
                $scope.calendarFilter.servantTitle = getServantTitle(vm.selectedServant);


                ServiceItemCustom.getServiceItemsByServantId(vm.selectedServant).query(function (result) {

                    vm.selectedServantServiceList = result;

                    // vm.selectedServiceList = result;
                    // vm.serviceItems = result;
                    updateChipLists();
                    updateTimeBoard();

                })

            }

            //  }
        }

        function getServantTitle(servantId) {
            var result;
            angular.forEach(vm.servantList, function (item) {
                if (item.id == servantId)
                    result = item.servantName;
            })

            vm.selectedServantTitle = result;
            return result;
        }

        function onReserveOnlyChanged() {

            // vm.selectedServiceListChanged=false;
            // if (vm.reserveOnlyMode) {
            //     vm.canSelectMultiService = true;
            //         addAllServicesAsSelected();
            // }
            // else {
            //     vm.selectedServiceList=[];
            //     if(vm.serviceItems && vm.serviceItems.length>0 )
            //         vm.selectedServiceList.push(vm.serviceItems[0].id);
            //     vm.canSelectMultiService = false;
            //
            // }
            // afterSelectedServiceChanged(function(){
            //     updateChipLists();
            //     updateTimeBoard();
            // });
        }

        function onReserveOnlyChangedReset() {
            onReserveOnlyChanged();
        }

        function onCategoryChanged() {
            if (vm.selectedCategoryId)
                ServiceItemCustom.getActiveServiceItemsByCategory(vm.selectedCategoryId).query(function (list) {
                    vm.serviceItems = list;
                    /*   if(list && list.length>0) {
                     vm.selectedId=list[0].id;
                     vm.storeInDefaults();
                     updateTimeBoard();
                     }*/
                    afterSelectedServiceChanged(function () {
                        updateChipLists();
                        updateTimeBoard();
                    });

                });
            else
                getAllServiceItemsByCurrentCompany();


        }

        function getAllServiceItemsByCurrentCompany() {
            // ServiceItemCustom.getServiceItemsByCurrentCompany().query(function (list) {
            //     vm.serviceItems = list;
            //     if (list && list.length > 0) {
            //         //vm.getFromDefaults();
            //         var isDefaultInList = false;
            //         if (vm.selectedId != undefined)
            //             angular.forEach(list, function (item) {
            //                 if (item.id == vm.selectedId)
            //                     isDefaultInList = true;
            //             });

            //         if (vm.selectedId == undefined || !isDefaultInList) {
            //             vm.selectedId = list[0].id;
            //             vm.storeInDefaults();
            //         }
            //         afterSelectedServiceChanged(function () {
            //             updateChipLists();
            //             updateTimeBoard();
            //         });

            //     }
            //     addAllServicesAsSelected();

            // });
            // $timeout(function() {

            // },100)
            //use fake id for service items
            vm.serviceItems = [123243];
            vm.storeInDefaults()
            afterSelectedServiceChanged(function () {
                updateChipLists();
                updateTimeBoard();
            });
            addAllServicesAsSelected();
        }

        function startRefreshTimer() {

            var timeOut = 300000;
            // if(!vm.runBefore )
            // {
            $timeout(function () {
                vm.updateTimeBoard();
                setInterval(function () {
                    if ($state.current.name == 'supplierPanel-v2.calendar') {
                        vm.updateTimeBoard();
                        vm.runBefore = true;
                    }
                }, timeOut)
            }, 1000);

            // }


        }

        // vm.updateTimeBoard = updateTimeBoard;
        function updateTimeBoard(then) {
            vm.calendarFilter = makeCalendarFilter();

            //  if ((vm.canSelectMultiService && vm.calendarFilter.serviceList.length > 0)) {
            storeInDefaults();
            //    }
            //    else {
            //  openFilterDialog();
            //     }
            if (then)
                then();
            vm.lastUpdate = new Date();
        }

        function makeCalendarFilter() {
            updateChipLists();

            var calendarFilter = {};
            calendarFilter.firstHour = vm.firstHour;
            calendarFilter.lastHour = vm.lastHour;
            calendarFilter.serviceList = [];
            calendarFilter.servantList = [];
            calendarFilter.reserveTypes = [];
            calendarFilter.reserveOnlyMode = vm.reserveOnlyMode;
            calendarFilter.selectedServant = null;
            if (vm.selectionMode)
                calendarFilter.selectionMode = vm.selectionMode;


            angular.forEach(vm.selectedServiceList, function (service) {
                calendarFilter.serviceList.push(service);
                if (!vm.selectedServantServiceList) {
                    if (calendarFilter.selectedServantServiceList)
                        vm.selectedServantServiceList = calendarFilter.selectedServantServiceList;
                }
            })

            calendarFilter.servantList = [];
            if (!vm.allServant) {
                angular.forEach(vm.selectedServantList, function (servant) {
                    if (calendarFilter.servantList.indexOf(servant) == -1)
                        calendarFilter.servantList.push(servant);
                })
            } else {
                angular.forEach(vm.selectedServantChips, function (servant) {
                    if (servant.selected && calendarFilter.servantList.indexOf(servant) == -1)
                        calendarFilter.servantList.push(servant.id);
                })
            }
            if (vm.reserveOnlyMode) {
                calendarFilter.reserveTypes.push('RESERVED')
            } else {
                calendarFilter.reserveTypes.push('RESERVED');
                calendarFilter.reserveTypes.push('CANCELED');
                calendarFilter.reserveTypes.push('FREE');
            }

            if (vm.selectedServant)
                calendarFilter.selectedServant = vm.selectedServant;
            if (vm.selectedServantTitle)
                calendarFilter.servantTitle = vm.selectedServantTitle;
            if (vm.selectedServantServiceList) {
                calendarFilter.selectedServantServiceList = vm.selectedServantServiceList;
            }


            return calendarFilter;

        }

        function updateChipLists() {

            return;
            vm.selectedServiceChips = [];
            vm.selectedServantChips = [];
            var servantFound = false;
            angular.forEach(vm.servantList, function (si) {
                var selected = false;
                if (vm.selectedServantList.indexOf(si.id) > -1) {
                    selected = true;
                }

                if (vm.selectedServant && vm.selectedServant == si.id)
                    servantFound = true;

                vm.selectedServantChips.push({id: si.id, title: si.servantName, selected: selected});

            });

            if (!servantFound && vm.servantList && vm.servantList.length > 0) {
                vm.selectedServant = vm.servantList[0].id;
                onServantChanged();
            }

            // angular.forEach(vm.serviceItems, function (si) {
            //     var selected=false;
            //     if (vm.selectedServiceList.indexOf(si.id) > -1) {
            //
            //        selected=true;
            //     }
            //     if(!si.color)
            //     si.color='COLOR';
            //     vm.selectedServiceChips.push({id: si.id, title: si.itemTitle, color: si.color,selected:selected});
            //
            // });


            //console.log('vm.serviceItems');
            //console.log(vm.serviceItems);
            /*     if (vm.selectedServiceList)
                     angular.forEach(vm.serviceItems, function (si) {
                         if (vm.selectedServiceList.indexOf(si.id) > -1) {
                             console.log(si);
                             vm.selectedServiceChips.push({id: si.id, title: si.itemTitle, color: si.color});
                         }

                     });
                 var validSelectedServantList = [];
                 if(vm.selectedServantList)
                 angular.forEach(vm.selectedServantList, function (ss) {

                     var isInList = false;
                     if(vm.servantList)
                     angular.forEach(vm.servantList, function (si) {
                         if (si.id == ss)
                             isInList = true;
                     })
                     if(isInList)
                          validSelectedServantList.push(ss);

                 });
                 vm.selectedServantList=validSelectedServantList;
                 angular.forEach(vm.servantList, function (si) {
                     if (vm.selectedServantList.indexOf(si.id) > -1) {
                         vm.selectedServantChips.push({id: si.id, title: si.servantName});
                     }

                 });*/
        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function getAllServantList() {

            vm.selectedServantList = [];
            // vm.selectedServant=null;
            vm.servantList = [];
            var index = 0;
            ServantCustom.getServantsHaveServicesByCurrentCompany().query().$promise.then(function (items) {

                vm.selectedServantList = [];
                vm.servantList = items;
                initAllServantChips();
                if (vm.servantList) {
                    vm.selectedServantList.push(vm.servantList[0].id);
                    if (!vm.calendarFilter.selectedServant) {
                        vm.selectedServant = vm.servantList[0].id;
                        vm.selectedServantTitle = vm.servantList[0].servantName;
                    } else {
                        vm.selectedServant = vm.calendarFilter.selectedServant;
                        if (vm.calendarFilter.servantTitle)
                            vm.selectedServantTitle = vm.calendarFilter.servantTitle;
                    }


                }

                onServantChanged();

            })

        }

        function storeInDefaults() {
            $localStorage.calendarFilter = vm.calendarFilter;
            $localStorage.selectedServiceList = vm.selectedServiceList;
            $localStorage.selectedServantList = vm.selectedServantList;
            $localStorage.selectedService = vm.selectedService;
            $localStorage.selectedServant = vm.selectedServant;
            $localStorage.reserveOnlyMode = vm.reserveOnlyMode;
            $localStorage.selectedServantServiceList = vm.selectedServantServiceList;
            $localStorage.calendarFilter.showAllServant = vm.allServant;

            if (!vm.selectedServantTitle) {
                getServantTitle(vm.selectedServant)
            }

            $localStorage.servantTitle = vm.selectedServantTitle;
            //if(vm.selectedId!=undefined)
            //$localStorage.selectedId=vm.selectedId;
        }

        function getFromDefaults() {

            vm.selectedService = $localStorage.selectedService;
            vm.selectedServant = $localStorage.selectedServant;
            if (!$localStorage.selectedServiceList)
                $localStorage.selectedServiceList = [];
            if (!$localStorage.selectedServantList)
                $localStorage.selectedServantList = [];
            // if(!$localStorage.reserveOnlyMode)
            $localStorage.reserveOnlyMode = true;

            // vm.selectedServiceList = $localStorage.selectedServiceList;
            // vm.selectedServantList = $localStorage.selectedServantList;

            vm.reserveOnlyMode = $localStorage.reserveOnlyMode;
            if (!$localStorage.calendarFilter)
                makeDefaultCalendarFilter()
            vm.calendarFilter = $localStorage.calendarFilter;
            // if (vm.calendarFilter)
            vm.firstHour = vm.calendarFilter.firstHour;
            vm.lastHour = vm.calendarFilter.lastHour;
            //   onReserveOnlyChanged();
            //onServiceChanged();
            //onServantChanged();

            if (!$localStorage.selectedServantServiceList)
                $localStorage.selectedServantServiceList = [];

            if ($localStorage.calendarFilter.showAllServant != null || $localStorage.calendarFilter.showAllServant != undefined) {
                vm.allServant = $localStorage.calendarFilter.showAllServant;
                vm.allServant_changed();
            }


            if (vm.calendarFilter) {
                if (vm.calendarFilter.selectedServant)
                    vm.selectedServant = vm.calendarFilter.selectedServant;
                if (vm.calendarFilter.selectedServantServiceList)
                    vm.selectedServantServiceList = vm.calendarFilter.selectedServantServiceList;
                if (vm.calendarFilter.servantTitle)
                    vm.selectedServantTitle = vm.calendarFilter.servantTitle;

            }
            // if(!$localStorage.selectedServant)
            //     $localStorage.selectedServant=null;


            //console.log('reading from storage :'+vm.selectedId)
            //if($localStorage.selectedId!=undefined)
            //{
            //
            //    var serviceList=[];
            //    vm.selectedId=$localStorage.selectedId;
            //    console.log('exista storage :'+vm.selectedId)
            //}
        }

        function querySearch(query) {

            var temp = [];


            // angular.forEach($ctrl.serviceItems, function (item) {
            //     if (item.itemTitle.indexOf(query) > -1) {
            //         temp.push(item);
            //     } else if (query == null) {
            //         temp = $ctrl.serviceItems;
            //     }
            // })

            return temp;

        }

        function makeDefaultCalendarFilter() {
            // $localStorage.calendarFilter = {firstHour: 6, lastHour: 21};
            $localStorage.calendarFilter = {firstHour: vm.firstHour, lastHour: vm.lastHour};

        }
        // window.addEventListener('calendar-add-reserve', function(e) {
        //     debugger
        // })
        function gotoNewReserve_flex() {
            var s_date, e_date = null;


            s_date = new Date();
            s_date.setMinutes(0);
            s_date = s_date.toISOString();

            $state.go('supplierPanel-v2.new-reserve-modal', {
                serviceItemId: null,
                servantId: vm.selectedServant,
                start_date: s_date,
                end_date: e_date,
                hasCustomTime: vm.defaultCustomTime
            });

        }

        function setDayView() {

        }

        function allServant_changed() {
            if (vm.allServant) {
                vm.selectionMode = 'day';
            } else
                vm.selectionMode = 'week';


            var slideVar = window.setTimeout(function () {
                checkArrowStat();
                window.clearInterval(slideVar);
            }, 20);

            vm.updateTimeBoard();
        }

        function initAllServantChips() {
            vm.selectedServantChips = [];
            angular.forEach(vm.servantList, function (srv) {
                var item = srv;
                item.selected = true;
                vm.selectedServantChips.push(item);
            })

        }

        function servantChipsClick(item) {
            if (!vm.selectedServantChips)
                return;

            angular.forEach(vm.selectedServantChips, function (srv) {

                if (srv.id == item.id)
                    srv.selected = !srv.selected;
            })

            vm.updateTimeBoard();
        }

        function getChipsClass(item) {
            if (item.selected)
                return 'chips-checked'
            else
                return 'chips-unchecked'
        }


        function slide(direction) {
            var container = document.getElementById('servantChipsList');
            var scrollCompleted = 0;
            var step = 400;

            if (direction == 'left') {
                container.scrollLeft -= step;
            } else {
                container.scrollLeft += step;
            }

            checkArrowStat();

        }

        function checkArrowStat() {
            var container = document.getElementById('servantChipsList');

            if (!container)
                return;
            //var containerSize = 900;
            var size = container.clientWidth;
            var scrollWidth = container.scrollWidth;

            if (size < scrollWidth) {
                if (container.scrollLeft >= 0) {
                    vm.showLeftArrow = true;
                    vm.showRightArrow = false;
                } else if (container.scrollLeft < 0 && size - scrollWidth < container.scrollLeft) {
                    vm.showLeftArrow = true;
                    vm.showRightArrow = true;
                }
                if (size - scrollWidth == container.scrollLeft || (size - scrollWidth >= container.scrollLeft - 2 && size - scrollWidth <= container.scrollLeft + 2)) {
                    vm.showLeftArrow = false;
                    vm.showRightArrow = true;
                }

                // vm.showLeftArrow = true;
                // vm.showRightArrow = true;
            } else {
                vm.showLeftArrow = false;
                vm.showRightArrow = false;
            }
        }

        function getCalendarClass() {
            if (vm.allServant) {
                if(vm.showNewCalendarBanner) return 'calendar-container-all-servant new-calendar-banner-visible-v2';
                return 'calendar-container-all-servant';
            }
            else {
                if(vm.showNewCalendarBanner) return 'calendar-container new-calendar-banner-visible';
                return 'calendar-container';
            }
        }

        function openFilterDialog(ev) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
            $mdDialog.show({
                controller: CalendarFilterDialogController,
                templateUrl: 'app/time-board/filter-dialog.template.html',
                locals: {dialogData: vm, refreshTimingInfoMethod: updateTimeBoard},
                controllerAs: 'vm',
                targetEvent: vm,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
                .then(function (answer) {
                    $mdDialog.hide();
                }, function () {

                });

        };


        vm.openActionMenu = function () {
            vm.showMenu();
            // gotoNewReserve_flex();
        }


        vm.newReserve_click = function () {
            // vm.showMenu2(false);
            gotoNewReserve_flex();
        }
        function save() {
            $localStorage.calendarFilter.lastHour = vm.lastHour;
            $localStorage.calendarFilter.firstHour = vm.firstHour;
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();
            $rootScope.modalInstance.dismiss('cancel');
        }

        // function showMenu(state)
        // {
        //     debugger;
        //     var box = document.getElementById('actionsMenu');
        //
        //     if(state) // open
        //         box.style.display = 'flex';
        //     else
        //         box.style.display = 'none';
        // }
        // window.addEventListener('mouseup', function(event){
        //     var box = document.getElementById('actionsMenu');
        //     if(!box)
        //         return;
        //     if (event.target != box && event.target.parentNode != box){
        //         box.style.display = 'none';
        //     }
        // });

        vm.showMenu = function () {
            document.getElementById("myDropdown").classList.toggle("show");
        }
        window.onclick = function (event) {
            var btn = document.getElementById('new-btn');

            if (!btn)
                return;
            if (event.target != btn && event.target.parentNode != btn) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                    }
                }
            }
        }

        vm.newCloseTime_click = function () {
            addServantExceptionTimes('CLOSE');
        }
        vm.newOpenTime_click = function () {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            var multiServant = false;
            if (vm.servantList && vm.servantList.length > 1)
                multiServant = true;

            $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                availabilityMode: mode,
                defaultServantId: vm.selectedServant
            });


        }
        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                         return '<div id="98344380551"><script type="text/JavaScript" src="https://www.aparat.com/embed/sooe4hx?data[rnddiv]=98344380551&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

        $scope.$on('toggleSideMenu', function () {
            if ($state.current.name == 'supplierPanel-v2.calendar')
                $timeout(function () {
                    vm.updateTimeBoard();
                }, 300);
        });

        //load vue calendar
        function loadCalendar() {
            var calendar = document.getElementById('calendar');
            calendar.addEventListener('action', function(e){
                vm.newReserve_click()
            })
            calendar.addEventListener('interval-click', function(e){
                var detail = e.detail[0];
                var date = new Date(detail.date)
                if(detail.time) {
                    date.setHours(detail.time.split(':')[0]);
                    date.setMinutes(detail.time.split(':')[1]);
                }
                var payload = {
                    start_date: date,
                    servantId: detail.resource.id,
                    servantTitle:  detail.resource.name
                }
                gotoNewReserve(payload)
            })
            calendar.addEventListener('event-details', function(e){
                var orders = e.detail[0].customerOrders;
                if(orders[0] && orders[0].orderBagId){
                    $state.go('supplierPanel-v2.editOrderBag', {id: orders[0].orderBagId});
                }
            });
            calendar.addEventListener('closed-time', function(e){
               $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                        availabilityMode: 'CLOSE'
                    });
            })
            calendar.addEventListener('exception-time', function(e){
                $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                        availabilityMode: 'OPEN'
                    });
            })
            calendar.addEventListener('backToPrevVersion', function(e){
                $state.go('supplierPanel-v2.calendar');
            })


        }
        $timeout(loadCalendar, 50)

         function gotoNewReserve(dialogData) {
                    // $mdDialog.hide();
                    var s_date, e_date = null;
                    if (dialogData.start_date) {
                        s_date = dialogData.start_date;

                        //FUCK REGIME !!!!!!!!!!
                        //Check Date - 6 month of the year
                        var pDate = DateUtils.convertToPersianDate(s_date);

                        if (pDate.getMonth() < 7) {
                            s_date = new Date(s_date.setHours(s_date.getHours()));
                        }
                        s_date = s_date.toISOString()

                    }
                    if (dialogData.end_date)
                        e_date = dialogData.end_date.toISOString();

                    //majid alan
                    $state.go('supplierPanel-v2.new-reserve-modal', {
                        serviceItemId: dialogData.serviceItemId,
                        servantId: dialogData.servantId,
                        start_date: s_date,
                        end_date: e_date,
                        hasCustomTime: true
                    });
                }

        function setDefaultShowNewCalendarBanner(){
           if($localStorage.showNewCalendarBanner === undefined) {
            vm.showNewCalendarBanner = true
           }
            else {
                var item = $localStorage.showNewCalendarBanner;
                if(Date.now() > item.expiry) {
                    vm.showNewCalendarBanner = true;
                    $localStorage.showNewCalendarBanner = {
                        value: true,
                        expiry:  Date.now() + (1 * 60 * 60 * 1000)
                    }
                }else vm.showNewCalendarBanner = item.value;
            }
                
           
        }
        vm.closeBanner = function() {
            $localStorage.showNewCalendarBanner = {
                   value: false,
                    expiry:  Date.now() + (1 * 60 * 60 * 1000)
            }
            vm.showNewCalendarBanner = false;
        };
        // $scope.$watchGroup(['vm.firstHour', 'vm.lastHour'], function(newValues, oldValues){
        //     if(firstRun) {
        //         firstRun = false;
        //         return;
        //     }
        //     var firstHour = parseInt(newValues[0]);
        //     var lastHour = parseInt(newValues[1]);
        //     if(firstHour > 23 || lastHour > 24) {
        //         return;
        //     }
            
        //     $localStorage.calendarFilter.lastHour = lastHour;
        //     $localStorage.calendarFilter.firstHour = firstHour;
        //     // makeCalendarFilter();
        //     $timeout(function () {
        //         vm.startRefreshTimer();
        //     }, 1500);
        // })


    }


    var CalendarFilterDialogController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
        var $ctrl = this;
        var vm = $ctrl.dialogData;
        $ctrl.dialogData = dialogData;
        $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;

        //$ctrl.dialogData = {
        //    id: dialogData.id,
        //    price: dialogData.price,
        //    capacity: dialogData.capacity,
        //    enable: dialogData.enable,
        //    discount: dialogData.discount,updateTimeBoard
        //    isNew:dialogData.isNew
        //};


        $ctrl.hideDialog = function () {
            $mdDialog.hide();
        };

        $ctrl.cancelDialog = function () {
            $mdDialog.cancel();
        };

    }
    CalendarFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils'];

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BookCalendarController', BookCalendarController);

    BookCalendarController.$inject = ['$scope', '$location', '$window', '$mdDialog', '$mdMedia', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout', 'ServantCustom', 'CompanyCustom'];

    function BookCalendarController($scope, $location, $window, $mdDialog, $mdMedia, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout, ServantCustom, CompanyCustom) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        vm.updateServantList = updateServantList;
        vm.onReserveOnlyChanged = onReserveOnlyChanged;
        vm.onReserveOnlyChangedReset = onReserveOnlyChangedReset;
        vm.updateTimeBoard = updateTimeBoard;
        vm.openFilterDialog = openFilterDialog;
        vm.onCategoryChanged = onCategoryChanged;
        vm.onServiceChanged = onServiceChanged;
        vm.onServantChanged = onServantChanged;
        vm.onServantChipClick = onServantChipClick;
        vm.onServiceChipClick = onServiceChipClick;
        vm.lastUpdate;
        vm.selectedServiceListChanged = false;

        vm.firstHour = 6;
        vm.lastHour = 20;
        vm.servantList = [];
        vm.selectedService = {};
        vm.selectedServiceList = [];
        vm.selectedServiceChips = [];
        vm.selectedServant = null;
        vm.selectedServantList = [];
        vm.hourList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        vm.reserveOnlyMode = true;
        vm.canSelectMultiService = false;
        vm.selectedServantServiceList = [];
        vm.selectedServantTitle = '';
        vm.querySearch = querySearch;
        vm.gotoNewReserve_flex = gotoNewReserve_flex;
        vm.selectionMode = null;
        vm.allServant = false;
        vm.setDayView = setDayView;
        vm.allServant_changed = allServant_changed;
        vm.servantChipsClick = servantChipsClick;
        vm.getChipsClass = getChipsClass;

        //arrow
        vm.slide = slide;
        vm.showLeftArrow = true;
        vm.showRightArrow = true;

        vm.getCalendarClass = getCalendarClass;
        vm.defaultCustomTime = false;


        checkCompanySetting();
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            var path = $location.path();
            if ((path == '/supplierPanel/calendar' || path == '/calendar') && (result[0].company.appVersion == 'v1' || result[0].company.appVersion == null)) {
                $window.location.href = '/#/supplierPanel/timeBoard';
            }

            vm.categories = result;

            angular.forEach(result, function (item) {
                item.categoryName = categoryName(item.categoryName)
            })
            onCategoryChanged();
        });
        $scope.$watch('reserveOnlyMode', function (reserveOnlyMode) {


        });


        vm.filterProperties = {};
        vm.getFromDefaults();
        getAllServantList();


        // getAllServiceItemsByCurrentCompany();
        // addAllServicesAsSelected();


        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateTimeBoard();
        //   }
        //
        //});

        function checkCompanySetting() {

            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.company = result;
                if (vm.company.customSettingObject && vm.company.customSettingObject.defaultCustomTimeActive)
                    vm.defaultCustomTime = vm.company.customSettingObject.defaultCustomTimeActive;
            })

        }

        function updateServantList(then) {


            //  vm.selectedServantList = [];
            // vm.selectedServant=null;
            if (!vm.selectedServiceList || vm.selectedServiceList.length == 0) {
                // vm.selectedServantList = [];
                if (then)
                    then();
            }
                // else {
                //     vm.servantList = [];
                //     var index=0;
                //     if(vm.selectedServiceList.length>0) {
                //         angular.forEach(vm.selectedServiceList, function (service) {
                //             index++;
                //             ServiceItemCustom.getServiceServants(service).query(function (servants) {
                //                 angular.forEach(servants, function (serviceServant) {
                //                     var isInList = false;
                //                     angular.forEach(vm.servantList, function (servant) {
                //                         if (serviceServant.id == servant.id)
                //                             isInList = true;
                //                     })
                //                     if (!isInList) {
                //                         vm.servantList.push(serviceServant);
                //
                //                     }
                //
                //                 });
                //
                //                 if (index == vm.selectedServiceList.length) {
                //                     if (vm.servantList.length > 0) {
                //                         vm.selectedServant = vm.servantList[0].id;
                //
                //                         vm.selectedServantTitle = vm.servantList[0].servantName;
                //                         vm.selectedServantList.push(vm.servantList[0].id);
                //                     }
                //                     onServantChanged();
                //                     updateChipLists();
                //                     if (then)
                //                         then();
                //
                //                 }
                //
                //
                //             })
                //
                //
                //         })
            //     }
            else {
                vm.servantList = [];
                var index = 0;
                if (vm.selectedServiceList.length > 0) {

                    // ServantCustom.getServantsHaveServicesByCurrentCompany().query(function (servants) {
                    //
                    //     vm.servantList = servants;
                    // })
                    //
                    //     if (vm.servantList.length > 0) {
                    //         vm.selectedServant = vm.servantList[0].id;
                    //
                    //         vm.selectedServantTitle = vm.servantList[0].servantName;
                    //         vm.selectedServantList.push(vm.servantList[0].id);
                    //     }
                    //     onServantChanged();
                    //     updateChipLists();

                    getAllServantList();

                    if (then)
                        then();
                } else {
                    if (then)
                        then();
                }
            }

        }

        function findAvailableServiceByServant(servantId) {

        }

        vm.onServantListChanged = function () {

        }

        function addAllServicesAsSelected() {
            vm.selectedServiceList = [];
            angular.forEach(vm.serviceItems, function (si) {
                var selected = false;
                vm.selectedServiceList.push(si.id);

            });
        }

        function onServiceChanged(then) {
            vm.selectedServiceList = [];
            if (!vm.selectedServiceListChanged)
                if (vm.selectedService == 0) {
                    addAllServicesAsSelected();
                } else {
                    if (vm.selectedService)
                        vm.selectedServiceList.push(vm.selectedService);
                }


        }

        function afterSelectedServiceChanged(then) {
            checkIfSelectedServiceListIsValid();
            updateServantList(then);
        }

        function checkIfSelectedServiceListIsValid() {
            var isValid = true;
            angular.forEach(vm.selectedServiceList, function (ssi) {
                var selectedServiceIsValid = false;
                angular.forEach(vm.serviceItems, function (si) {
                    if (ssi == si.id)
                        selectedServiceIsValid = true;
                })
                if (!selectedServiceIsValid)
                    isValid = false;
            })
            if (!isValid) {

                vm.selectedService = {};
                vm.selectedServiceList = [];
                vm.selectedServantList = [];
            }

        }

        function onServantChipClick(sr) {
            if (sr) {
                vm.selectedServant = sr.id;
                vm.selectedServantTitle = sr.title;
            }
            onServantChanged();
            // updateChipLists();
            // updateTimeBoard();

        }

        function searchText() {
        }

        function onServiceChipClick(si) {

            vm.selectedServiceListChanged = true;

            si.selected = !si.selected;
            if (si.selected) {
                if (!vm.canSelectMultiService) {
                    vm.selectedServiceList = [];
                }

                vm.selectedServiceList.push(si.id);
            } else {
                vm.selectedServiceList = vm.selectedServiceList.filter(function (s) {
                    return s != si.id;
                })
            }
            afterSelectedServiceChanged(function () {
                updateChipLists();
                updateTimeBoard();
            })
        }

        function onServantChanged() {

            //  if (!vm.canSelectMultiService) {
            vm.selectedServantList = [];
            if (vm.selectedServant) {
                vm.selectedServantList.push(vm.selectedServant);

                if (!$scope.calendarFilter)
                    $scope.calendarFilter = {};

                $scope.calendarFilter.selectedServant = vm.selectedServant;
                $scope.calendarFilter.servantTitle = getServantTitle(vm.selectedServant);


                ServiceItemCustom.getServiceItemsByServantId(vm.selectedServant).query(function (result) {

                    vm.selectedServantServiceList = result;

                    // vm.selectedServiceList = result;
                    // vm.serviceItems = result;
                    updateChipLists();
                    updateTimeBoard();

                })

            }

            //  }
        }

        function getServantTitle(servantId) {
            var result;
            angular.forEach(vm.servantList, function (item) {
                if (item.id == servantId)
                    result = item.servantName;
            })

            vm.selectedServantTitle = result;
            return result;
        }

        function onReserveOnlyChanged() {

            // vm.selectedServiceListChanged=false;
            // if (vm.reserveOnlyMode) {
            //     vm.canSelectMultiService = true;
            //         addAllServicesAsSelected();
            // }
            // else {
            //     vm.selectedServiceList=[];
            //     if(vm.serviceItems && vm.serviceItems.length>0 )
            //         vm.selectedServiceList.push(vm.serviceItems[0].id);
            //     vm.canSelectMultiService = false;
            //
            // }
            // afterSelectedServiceChanged(function(){
            //     updateChipLists();
            //     updateTimeBoard();
            // });
        }

        function onReserveOnlyChangedReset() {
            onReserveOnlyChanged();
        }

        function onCategoryChanged() {

            if (vm.selectedCategoryId)
                ServiceItemCustom.getActiveServiceItemsByCategory(vm.selectedCategoryId).query(function (list) {
                    vm.serviceItems = list;
                    /*   if(list && list.length>0) {
                     vm.selectedId=list[0].id;
                     vm.storeInDefaults();
                     updateTimeBoard();
                     }*/
                    afterSelectedServiceChanged(function () {
                        updateChipLists();
                        updateTimeBoard();
                    });

                });
            else
                getAllServiceItemsByCurrentCompany();


        }

        function getAllServiceItemsByCurrentCompany() {
            ServiceItemCustom.getServiceItemsByCurrentCompany().query(function (list) {
                vm.serviceItems = list;
                if (list && list.length > 0) {
                    //vm.getFromDefaults();
                    var isDefaultInList = false;
                    if (vm.selectedId != undefined)
                        angular.forEach(list, function (item) {
                            if (item.id == vm.selectedId)
                                isDefaultInList = true;
                        });

                    if (vm.selectedId == undefined || !isDefaultInList) {
                        vm.selectedId = list[0].id;
                        vm.storeInDefaults();
                    }
                    afterSelectedServiceChanged(function () {
                        updateChipLists();
                        updateTimeBoard();
                    });

                }
                addAllServicesAsSelected();

            });
        }

        function startRefreshTimer() {

            var timeOut = 300000;
            // if(!vm.runBefore )
            // {
            $timeout(function () {
                vm.updateTimeBoard();
                setInterval(function () {
                    vm.updateTimeBoard();
                    vm.runBefore = true;
                }, timeOut)
            }, 1000);

            // }


        }

        // vm.updateTimeBoard = updateTimeBoard;
        function updateTimeBoard(then) {

            vm.calendarFilter = makeCalendarFilter();


            //  if ((vm.canSelectMultiService && vm.calendarFilter.serviceList.length > 0)) {
            storeInDefaults();
            //    }
            //    else {
            //  openFilterDialog();
            //     }
            if (then)
                then();
            vm.lastUpdate = new Date();
        }

        function makeCalendarFilter() {
            updateChipLists();

            var calendarFilter = {};
            calendarFilter.firstHour = vm.firstHour;
            calendarFilter.lastHour = vm.lastHour;
            calendarFilter.serviceList = [];
            calendarFilter.servantList = [];
            calendarFilter.reserveTypes = [];
            calendarFilter.reserveOnlyMode = vm.reserveOnlyMode;
            calendarFilter.selectedServant = null;
            if (vm.selectionMode)
                calendarFilter.selectionMode = vm.selectionMode;


            angular.forEach(vm.selectedServiceList, function (service) {
                calendarFilter.serviceList.push(service);
                if (!vm.selectedServantServiceList) {
                    if (calendarFilter.selectedServantServiceList)
                        vm.selectedServantServiceList = calendarFilter.selectedServantServiceList;
                }
            })

            calendarFilter.servantList = [];
            if (!vm.allServant) {
                angular.forEach(vm.selectedServantList, function (servant) {
                    if (calendarFilter.servantList.indexOf(servant) == -1)
                        calendarFilter.servantList.push(servant);
                })
            } else {
                angular.forEach(vm.selectedServantChips, function (servant) {
                    if (servant.selected && calendarFilter.servantList.indexOf(servant) == -1)
                        calendarFilter.servantList.push(servant.id);
                })
            }
            if (vm.reserveOnlyMode) {
                calendarFilter.reserveTypes.push('RESERVED')
            } else {
                calendarFilter.reserveTypes.push('RESERVED');
                calendarFilter.reserveTypes.push('CANCELED');
                calendarFilter.reserveTypes.push('FREE');
            }

            if (vm.selectedServant)
                calendarFilter.selectedServant = vm.selectedServant;
            if (vm.selectedServantTitle)
                calendarFilter.servantTitle = vm.selectedServantTitle;
            if (vm.selectedServantServiceList) {
                calendarFilter.selectedServantServiceList = vm.selectedServantServiceList;
            }


            return calendarFilter;

        }

        function updateChipLists() {

            return;
            vm.selectedServiceChips = [];
            vm.selectedServantChips = [];
            var servantFound = false;
            angular.forEach(vm.servantList, function (si) {
                var selected = false;
                if (vm.selectedServantList.indexOf(si.id) > -1) {
                    selected = true;
                }

                if (vm.selectedServant && vm.selectedServant == si.id)
                    servantFound = true;

                vm.selectedServantChips.push({id: si.id, title: si.servantName, selected: selected});

            });

            if (!servantFound && vm.servantList && vm.servantList.length > 0) {
                vm.selectedServant = vm.servantList[0].id;
                onServantChanged();
            }

            // angular.forEach(vm.serviceItems, function (si) {
            //     var selected=false;
            //     if (vm.selectedServiceList.indexOf(si.id) > -1) {
            //
            //        selected=true;
            //     }
            //     if(!si.color)
            //     si.color='COLOR';
            //     vm.selectedServiceChips.push({id: si.id, title: si.itemTitle, color: si.color,selected:selected});
            //
            // });


            //console.log('vm.serviceItems');
            //console.log(vm.serviceItems);
            /*     if (vm.selectedServiceList)
                     angular.forEach(vm.serviceItems, function (si) {
                         if (vm.selectedServiceList.indexOf(si.id) > -1) {
                             console.log(si);
                             vm.selectedServiceChips.push({id: si.id, title: si.itemTitle, color: si.color});
                         }

                     });
                 var validSelectedServantList = [];
                 if(vm.selectedServantList)
                 angular.forEach(vm.selectedServantList, function (ss) {

                     var isInList = false;
                     if(vm.servantList)
                     angular.forEach(vm.servantList, function (si) {
                         if (si.id == ss)
                             isInList = true;
                     })
                     if(isInList)
                          validSelectedServantList.push(ss);

                 });
                 vm.selectedServantList=validSelectedServantList;
                 angular.forEach(vm.servantList, function (si) {
                     if (vm.selectedServantList.indexOf(si.id) > -1) {
                         vm.selectedServantChips.push({id: si.id, title: si.servantName});
                     }

                 });*/
        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function getAllServantList() {

            vm.selectedServantList = [];
            // vm.selectedServant=null;
            vm.servantList = [];
            var index = 0;
            ServantCustom.getServantsHaveServicesByCurrentCompany().query().$promise.then(function (items) {

                vm.selectedServantList = [];
                vm.servantList = items;
                initAllServantChips();
                if (vm.servantList) {
                    vm.selectedServantList.push(vm.servantList[0].id);
                    if (!vm.calendarFilter.selectedServant) {
                        vm.selectedServant = vm.servantList[0].id;
                        vm.selectedServantTitle = vm.servantList[0].servantName;
                    } else {
                        vm.selectedServant = vm.calendarFilter.selectedServant;
                        if (vm.calendarFilter.servantTitle)
                            vm.selectedServantTitle = vm.calendarFilter.servantTitle;
                    }


                }

                onServantChanged();

            })

        }

        function storeInDefaults() {
            $localStorage.calendarFilter = vm.calendarFilter;
            $localStorage.selectedServiceList = vm.selectedServiceList;
            $localStorage.selectedServantList = vm.selectedServantList;
            $localStorage.selectedService = vm.selectedService;
            $localStorage.selectedServant = vm.selectedServant;
            $localStorage.reserveOnlyMode = vm.reserveOnlyMode;
            $localStorage.selectedServantServiceList = vm.selectedServantServiceList;
            $localStorage.calendarFilter.showAllServant = vm.allServant;

            if (!vm.selectedServantTitle) {
                getServantTitle(vm.selectedServant)
            }

            $localStorage.servantTitle = vm.selectedServantTitle;
            //if(vm.selectedId!=undefined)
            //$localStorage.selectedId=vm.selectedId;
        }

        function getFromDefaults() {

            // vm.selectedService = $localStorage.selectedService;
            // vm.selectedServant = $localStorage.selectedServant;
            if (!$localStorage.selectedServiceList)
                $localStorage.selectedServiceList = [];
            if (!$localStorage.selectedServantList)
                $localStorage.selectedServantList = [];
            // if(!$localStorage.reserveOnlyMode)
            $localStorage.reserveOnlyMode = true;

            // vm.selectedServiceList = $localStorage.selectedServiceList;
            // vm.selectedServantList = $localStorage.selectedServantList;

            vm.reserveOnlyMode = $localStorage.reserveOnlyMode;
            if (!$localStorage.calendarFilter)
                makeDefaultCalendarFilter()
            vm.calendarFilter = $localStorage.calendarFilter;
            if (vm.calendarFilter)
                vm.firstHour = vm.calendarFilter.firstHour;
            vm.lastHour = vm.calendarFilter.lastHour;
            //   onReserveOnlyChanged();
            //onServiceChanged();
            //onServantChanged();

            if (!$localStorage.selectedServantServiceList)
                $localStorage.selectedServantServiceList = [];

            if ($localStorage.calendarFilter.showAllServant != null || $localStorage.calendarFilter.showAllServant != undefined) {
                vm.allServant = $localStorage.calendarFilter.showAllServant;
                vm.allServant_changed();
            }


            if (vm.calendarFilter) {
                if (vm.calendarFilter.selectedServant)
                    vm.selectedServant = vm.calendarFilter.selectedServant;
                if (vm.calendarFilter.selectedServantServiceList)
                    vm.selectedServantServiceList = vm.calendarFilter.selectedServantServiceList;
                if (vm.calendarFilter.servantTitle)
                    vm.selectedServantTitle = vm.calendarFilter.servantTitle;

            }

            // if(!$localStorage.selectedServant)
            //     $localStorage.selectedServant=null;


            //console.log('reading from storage :'+vm.selectedId)
            //if($localStorage.selectedId!=undefined)
            //{
            //
            //    var serviceList=[];
            //    vm.selectedId=$localStorage.selectedId;
            //    console.log('exista storage :'+vm.selectedId)
            //}
        }

        function querySearch(query) {

            var temp = [];


            // angular.forEach($ctrl.serviceItems, function (item) {
            //     if (item.itemTitle.indexOf(query) > -1) {
            //         temp.push(item);
            //     } else if (query == null) {
            //         temp = $ctrl.serviceItems;
            //     }
            // })

            return temp;

        }

        function makeDefaultCalendarFilter() {
            $localStorage.calendarFilter = {firstHour: 6, lastHour: 21};

        }

        function gotoNewReserve_flex() {
            var s_date, e_date = null;


            s_date = new Date();
            s_date.setMinutes(0);
            s_date = s_date.toISOString();

            $state.go('supplierPanel.new-reserve-modal', {
                serviceItemId: null,
                servantId: vm.selectedServant,
                start_date: s_date,
                end_date: e_date,
                hasCustomTime: vm.defaultCustomTime
            });

        }

        function setDayView() {

        }

        function allServant_changed() {
            if (vm.allServant) {
                vm.selectionMode = 'day';
            } else
                vm.selectionMode = 'week';


            var slideVar = window.setTimeout(function () {
                checkArrowStat();
                window.clearInterval(slideVar);
            }, 20);

            vm.updateTimeBoard();
        }

        function initAllServantChips() {
            vm.selectedServantChips = [];
            angular.forEach(vm.servantList, function (srv) {
                var item = srv;
                item.selected = true;
                vm.selectedServantChips.push(item);
            })

        }

        function servantChipsClick(item) {
            if (!vm.selectedServantChips)
                return;

            angular.forEach(vm.selectedServantChips, function (srv) {

                if (srv.id == item.id)
                    srv.selected = !srv.selected;
            })

            vm.updateTimeBoard();
        }

        function getChipsClass(item) {
            if (item.selected)
                return 'chips-checked'
            else
                return 'chips-unchecked'
        }


        function slide(direction) {
            var container = document.getElementById('servantChipsList');
            var scrollCompleted = 0;
            var step = 400;

            if (direction == 'left') {
                container.scrollLeft -= step;
            } else {
                container.scrollLeft += step;
            }

            checkArrowStat();

        }

        function checkArrowStat() {
            var container = document.getElementById('servantChipsList');

            if (!container)
                return;
            //var containerSize = 900;
            var size = container.clientWidth;
            var scrollWidth = container.scrollWidth;

            if (size < scrollWidth) {
                if (container.scrollLeft >= 0) {
                    vm.showLeftArrow = true;
                    vm.showRightArrow = false;
                } else if (container.scrollLeft < 0 && size - scrollWidth < container.scrollLeft) {
                    vm.showLeftArrow = true;
                    vm.showRightArrow = true;
                }
                if (size - scrollWidth == container.scrollLeft || (size - scrollWidth >= container.scrollLeft - 2 && size - scrollWidth <= container.scrollLeft + 2)) {
                    vm.showLeftArrow = false;
                    vm.showRightArrow = true;
                }

                // vm.showLeftArrow = true;
                // vm.showRightArrow = true;
            } else {
                vm.showLeftArrow = false;
                vm.showRightArrow = false;
            }
        }

        function getCalendarClass() {
            if (vm.allServant)
                return 'table-container-all-servant';
            else
                return 'table-container';
        }

        function openFilterDialog(ev) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
            $mdDialog.show({
                controller: CalendarFilterDialogController,
                templateUrl: 'app/time-board/filter-dialog.template.html',
                locals: {dialogData: vm, refreshTimingInfoMethod: updateTimeBoard},
                controllerAs: 'vm',
                targetEvent: vm,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
                .then(function (answer) {
                    $mdDialog.hide();
                }, function () {

                });

        };


        vm.openActionMenu = function () {
            vm.showMenu();
            // gotoNewReserve_flex();
        }

        vm.newReserve_click = function () {
            // vm.showMenu2(false);
            gotoNewReserve_flex();
        }

        // function showMenu(state)
        // {
        //     debugger;
        //     var box = document.getElementById('actionsMenu');
        //
        //     if(state) // open
        //         box.style.display = 'flex';
        //     else
        //         box.style.display = 'none';
        // }
        // window.addEventListener('mouseup', function(event){
        //     var box = document.getElementById('actionsMenu');
        //     if(!box)
        //         return;
        //     if (event.target != box && event.target.parentNode != box){
        //         box.style.display = 'none';
        //     }
        // });

        vm.showMenu = function () {
            document.getElementById("myDropdown").classList.toggle("show");
        }

        window.onclick = function (event) {
            var btn = document.getElementById('new-btn');

            if (!btn)
                return;
            if (event.target != btn && event.target.parentNode != btn) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                    }
                }
            }
        }

        vm.newCloseTime_click = function () {
            addServantExceptionTimes('CLOSE');
        }
        vm.newOpenTime_click = function () {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            var multiServant = false;
            if (vm.servantList && vm.servantList.length > 1)
                multiServant = true;

            $state.go('supplierPanel.calendar.servantExceptionTimes', {
                availabilityMode: mode,
                defaultServantId: vm.selectedServant
            });

            return;


            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html',
                controller: 'ServantExceptionDurationComponentController',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            defaultServantId: vm.selectedServant,
                            availabilityMode: mode,
                            canSelectServant: multiServant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
                // fullscreen : true
            }).then(function (v) {
                updateTimeBoard();
            }, function () {
                //nothing
            });

        }


    }


    var CalendarFilterDialogController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
        var $ctrl = this;
        var vm = $ctrl.dialogData;
        $ctrl.dialogData = dialogData;
        $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;

        //$ctrl.dialogData = {
        //    id: dialogData.id,
        //    price: dialogData.price,
        //    capacity: dialogData.capacity,
        //    enable: dialogData.enable,
        //    discount: dialogData.discount,updateTimeBoard
        //    isNew:dialogData.isNew
        //};


        $ctrl.hideDialog = function () {
            $mdDialog.hide();
        };

        $ctrl.cancelDialog = function () {
            $mdDialog.cancel();
        };

    }
    CalendarFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils'];

})();
;
// function getParameterByName(name, url) {
//     if (!url) url = window.location.href;
//     name = name.replace(/[\[\]]/g, '\\$&');
//     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
//         results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, ' '));
// }
//
// function removeSignFromUrl() {
//     var url = window.location.href;
//     if(url.indexOf("?#")> 0)
//     {
//         url = url.replace("?#","#");
//         window.location.href = url;
//         return;
//     }
//
//     var qIndex = url.indexOf("?");
//     var sharpIndex = url.indexOf("#");
//     if(qIndex>-1 && qIndex < sharpIndex)
//     {
//         var first = url.substring(0,qIndex);
//         var end = url.substring(sharpIndex,url.length);
//         var newUrl = first.concat(end);
//         window.location.href = newUrl;
//         return;
//     }
//
// }
//
//
// (function () {
//     'use strict';
//
//     angular
//         .module('tikonApp')
//         .config(stateConfig);
//
//     stateConfig.$inject = ['$stateProvider'];
//
//     function stateConfig($stateProvider) {
//
//         $stateProvider
//             .state('initSetupWizardV2', {
//                 parent: 'app',
//                 url: '/initSetupWizardV2',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/wizards/init-setup-v2/init-setup-v2.html',
//                         controller: 'InitSetupV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('supplierPanel');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2', {
//                 parent: 'app',
//                 url: '/supplierPanel-v2',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/supplier-v2/supplierPanel-v2.html',
//
//                         controller: 'SupplierPanelV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('supplierPanel');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.more', {
//                 parent: 'supplierPanel-v2',
//                 url: '/more',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/layouts/more/more.html',
//                         controller: 'MoreController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.dashboard', {
//                 parent: 'supplierPanel-v2',
//                 url: '/dashboard',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'supplierPanel.sideMenu.dashboard'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/dashboard/main/report.main_dashboard_v2.html',
//                         controller: 'MainDashboardV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader','$rootScope', function ($translate, $translatePartialLoader,$rootScope) {
//
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('newsType');
//                         $rootScope.$broadcast('showNavBar');
//                         removeSignFromUrl();
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.calendar', {
//                 parent: 'supplierPanel-v2',
//                 url: '/calendar',
//                 data: {
//                     authorities: ['ROLE_RESERVATION_MANAGER'],
//                     pageTitle: 'global.setup.timeBoard'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/time-board/book-calendar-v2.template.html',
//                         controller: 'BookCalendarV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.calendar.servantExceptionTimes', {
//                 parent: 'supplierPanel-v2.calendar',
//                 url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
//                         controller: 'ServantExceptionDurationController',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('scheduleInfo');
//
//                         return $translate.refresh();
//                     }],
//                     entity: ['Principal','$stateParams', function (Principal,$stateParams) {
//                         // removeSignFromUrl();
//                         // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
//                         var multiServant = true;
//                         Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
//                             multiServant = !has;
//                         });
//
//                         var availabilityMode = $stateParams.availabilityMode;
//                         var defaultServantId = $stateParams.defaultServantId;
//                         return {
//                             defaultServantId: defaultServantId,
//                             availabilityMode:availabilityMode,
//                             canSelectServant:multiServant
//
//                         };
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.new-reserve-modal', {
//                 parent: 'supplierPanel-v2.calendar',
//                 url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
//                         controller: 'ReserveV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('genderType');
//
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//                         return {
//                             customer: null,
//                             createDate: null,
//                             status: 0,
//                             id: null,
//                             orderBagServiceItems: [{}]
//                         };
//                     }
//
//                 }
//             })
//             //reserve
//             .state('supplierPanel-v2.reserveList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/reserveList?page&sort&search',
//                 data: {
//                     authorities: ['ROLE_RESERVATION_MANAGER'],
//                     pageTitle: 'supplierPanel.sideMenu.orderBagList'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/reserve/reserve-list-v2.html',
//                         controller: 'ReserveListController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     formMode: function () {
//                         return {
//                             mode: 'LoadOnHand'
//                         };
//                     }
//
//                 }
//             })
//             .state('supplierPanel-v2.reserveWithCustomerParameter', {
//                 parent: 'supplierPanel-v2',
//                 url: '/reserveWithCustomerParameter/{customerId}',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.orderBag.detail.title'
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal','$rootScope', function($stateParams, $state, $uibModal,$rootScope) {
//                     $rootScope.modalInstance = $uibModal.open({
//                         templateUrl: 'app/entities/reserve/new-reserve-modal.html',
//                         controller: 'ReserveController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg',
//                         windowClass: 'pl-modal',
//                         resolve: {
//                             translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                                 $translatePartialLoader.addPart('serviceItem');
//                                 $translatePartialLoader.addPart('orderBag');
//                                 $translatePartialLoader.addPart('orderBagServiceItem');
//                                 $translatePartialLoader.addPart('personInfo');
//                                 $translatePartialLoader.addPart('global');
//                                 $translatePartialLoader.addPart('genderType');
//
//                                 return $translate.refresh();
//                             }],
//                             entity: function () {
//                                 return {
//                                     customer: null,
//                                     createDate: null,
//                                     status: 0,
//                                     id: null,
//                                     orderBagServiceItems: [{}]
//                                 };
//                             }
//
//                         }
//                     });
//
//                     $rootScope.modalInstance.result.then(function() {
//
//                         $state.go( 'supplierPanel-v2.companyCustomer', null, { reload: true });
//                         $rootScope.modalInstance.dismiss('cancel');
//                     }, function() {
//                         var prevState = $rootScope.fromState.name ;
//                         if($rootScope.fromStateParams)
//                             $state.go(prevState,{id: $rootScope.fromStateParams.id});
//                         else
//                             $state.go(prevState);
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.editOrderBag', {
//                 parent: 'supplierPanel-v2',
//                 url: '/{id}/editOrderBag',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/order-bag/edit-order-bag-v2.html',
//                         controller: 'EditOrderBagV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('customer');
//                         $translatePartialLoader.addPart('orderBagServiceItemDtail');
//                         $translatePartialLoader.addPart('paymentLog');
//                         $translatePartialLoader.addPart('paymentType');
//
//
//                         return $translate.refresh();
//                     }],
//                     entity: ['$stateParams','OrderBagCustom', function($stateParams,OrderBagCustom) {
//                         return OrderBagCustom.getOrderBagWithEntities($stateParams.id).query();
//                     }
//                     ],
//                     invoiceInfoEntity: ['$stateParams','InvoiceInfoCustom', function($stateParams,InvoiceInfoCustom) {
//                         return InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query();
//                     }]
//
//                 }
//             })
//             .state('supplierPanel-v2.editOrderBag.editCompanyCustomer', {
//                 parent: 'supplierPanel-v2.editOrderBag',
//                 url: '/editCompanyCustomer/{id}',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-customer/company-customer-modal.html',
//                         controller: 'CompanyCustomerModalController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('personInfo');
//                         return $translate.refresh();
//                     }],
//                     entity: ['CompanyCustomer','$stateParams', function (CompanyCustomer,$stateParams) {
//                         return CompanyCustomer.get({id: $stateParams.id}).$promise;
//                     }]
//                 }
//                 // });
//             })
//             .state('supplierPanel-v2.newReserve', {
//                 parent: 'supplierPanel-v2.reserveList',
//                 url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
//                         controller: 'ReserveV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('genderType');
//
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//                         return {
//                             customer: null,
//                             createDate: null,
//                             status: 0,
//                             id: null,
//                             orderBagServiceItems: [{}]
//                         };
//                     }
//
//                 }
//             })
//             //.........................
//             //subscription
//             .state('supplierPanel-v2.companySubscriptionStatusV2', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companySubscriptionStatusV2',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'global.menu.account.subscription'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-subscription-status/company-buy-subscription.html',
//                         controller: 'CompanyBuySubscriptionController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('companySubscriptionStatus');
//                         $translatePartialLoader.addPart('subscriptionType');
//                         $translatePartialLoader.addPart('subscriptionPackage');
//                         $translatePartialLoader.addPart('packageFeatureList');
//                         return $translate.refresh();
//                     }]
//                     ,
//                     entity: ['CompanyCustom','ActivityTypeInfoCustom', function (CompanyCustom,ActivityTypeInfoCustom) {
//                        return ActivityTypeInfoCustom.getActivityTypeInfoByCurrentCompany().query().$promise;
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companySmsPackageStatus', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companySmsPackageStatus',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'global.menu.account.sms_package_status'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-subscription-status/company-sms-package-status-view-v2.html',
//                         controller: 'CompanySmsPackageStatusViewController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('companySubscriptionStatus');
//                         $translatePartialLoader.addPart('subscriptionType');
//                         $translatePartialLoader.addPart('subscriptionPackage');
//                         return $translate.refresh();
//                     }]
//                     ,
//                     entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
//                         removeSignFromUrl();
//                         // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.purchaseSubscription', {
//                 parent: 'supplierPanel-v2',
//                 url: '/{id}/purchaseSubscription',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-subscription-status/purchase-subscription-v2.html',
//                         controller: 'PurchaseSubscriptionController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('companySubscriptionStatus');
//                         $translatePartialLoader.addPart('subscriptionType');
//                         $translatePartialLoader.addPart('subscriptionPackage');
//                         $translatePartialLoader.addPart('coupon');
//                         $translatePartialLoader.addPart('supplierCoupon');
//                         return $translate.refresh();
//                     }]
//                     ,
//                     entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {
//
//                         if ($stateParams.id != '')
//
//                             return SubscriptionPackage.get({id: $stateParams.id}).$promise;
//                         return {};
//                     }]
//                 }
//             })
//             //................
//             .state('supplierPanel-v2.companyCustomer', {
//                 parent: 'supplierPanel-v2',
//                 url: '/company-customer-list',
//                 data: {
//                     authorities: ['ROLE_CUSTOMER_MANAGER'],
//                     pageTitle: 'tikonApp.companyCustomer.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-customer/company-customers-list-v2.html',
//                         controller: 'CompanyCustomerListV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('customer');
//                         $translatePartialLoader.addPart('customerStatus');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('scheduleType');
//
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyCustomer.new', {
//                 parent: 'supplierPanel-v2',
//                 url: '/company-customer-list/new',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-customer/company-customer-modal.html',
//                         controller: 'CompanyCustomerModalController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('personInfo');
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//
//                         return {
//                             id: null
//                         };
//                     }
//                 }
//             })
//             .state('supplierPanel-v2.companyCustomer.edit', {
//                 parent: 'supplierPanel-v2',
//                 url: '/company-customer-list/edit/{id}',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-customer/company-customer-modal.html',
//                         controller: 'CompanyCustomerModalController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('personInfo');
//                         return $translate.refresh();
//                     }],
//                     entity: ['CompanyCustomer','$stateParams', function (CompanyCustomer,$stateParams) {
//                         return CompanyCustomer.get({id: $stateParams.id}).$promise;
//                     }]
//                 }
//                   // });
//             })
//             .state('supplierPanel-v2.companyCustomer.delete', {
//                 parent: 'supplierPanel-v2.companyCustomer',
//                 url: '/company-customer-list/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal','$rootScope', function ($stateParams, $state, $uibModal,$rootScope) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
//                         controller: 'CompanyCustomerDeleteController',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['CompanyCustomer', function (CompanyCustomer) {
//                                 return CompanyCustomer.get({id: $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function () {
//                         if($rootScope.modalInstance)
//                         {
//                             $rootScope.modalInstance.dismiss('cancel');
//                         }
//                         $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.deleteCompanyCustomer', {
//                 parent: 'supplierPanel-v2.companyCustomer.edit',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal','$rootScope', function ($stateParams, $state, $uibModal,$rootScope) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
//                         controller: 'CompanyCustomerDeleteController',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['CompanyCustomer', function (CompanyCustomer) {
//                                 return CompanyCustomer.get({id: $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function () {
//                         if($rootScope.modalInstance)
//                         {
//                             $rootScope.modalInstance.dismiss('cancel');
//                         }
//                         $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//
//
//             .state('supplierPanel-v2.companyServants', {
//                 parent: 'supplierPanel-v2',
//                 url: '/company-servants',
//                 data: {
//                     authorities: ['ROLE_SERVANT_MANAGER'],
//                     pageTitle: 'supplierPanel.sideMenu.servantInfo'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-servants/company-servants-v2.html',
//                         controller: 'CompanyServantsV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyServants.new', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyServants/new',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
//                         controller: 'CompanyServantsV2DialogController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//
//                         return {
//                             title: null,
//                             level: null,
//                             id: null
//                         };
//                     }
//                 }
//                 // });
//             })
//             .state('supplierPanel-v2.companyServants.edit', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyServants/edit/{id}',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
//                         controller: 'CompanyServantsV2DialogController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: ['Servant','$stateParams', function(Servant,$stateParams) {
//                         return Servant.get({id : $stateParams.id}).$promise;
//                     }]
//                 }
//                 // });
//             })
//             .state('supplierPanel-v2.companyServants.delete', {
//                 parent: 'supplierPanel-v2.companyServants',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
//                         controller: 'CompanyServantsDeleteController',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['Servant', function(Servant) {
//                                 return Servant.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.companyServants', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.companyServants.edit.delete', {
//                 parent: 'supplierPanel-v2.companyServants.edit',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
//                         controller: 'CompanyServantsDeleteController',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['Servant', function(Servant) {
//                                 return Servant.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.companyServants', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.companyServants.servantExceptionTimes', {
//                 parent: 'supplierPanel-v2.companyServants.edit',
//                 url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
//                         controller: 'ServantExceptionDurationController',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('scheduleInfo');
//
//                         return $translate.refresh();
//                     }],
//                     entity: ['Principal','$stateParams', function (Principal,$stateParams) {
//                         // removeSignFromUrl();
//                         // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
//                         var multiServant = true;
//                         Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
//                             multiServant = !has;
//                         });
//
//                         var availabilityMode = $stateParams.availabilityMode;
//                         var defaultServantId = $stateParams.defaultServantId;
//                         return {
//                             defaultServantId: defaultServantId,
//                             availabilityMode:availabilityMode,
//                             canSelectServant:multiServant
//
//                         };
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.serviceItemList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/serviceItemList' + '-' + ':type',
//                 data: {
//                     authorities: ['ROLE_CATEGORY_MANAGER'],
//                     pageTitle: 'supplierPanel.sideMenu.servicelist'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/service-item-v2/service-item-list-v2.html',
//                         controller: 'ServiceItemListV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('serviceItemType');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('home');
//                         return $translate.refresh();
//                     }],
//
//                 }
//             })
//             .state('supplierPanel-v2.serviceItemList.serviceItem', {
//                 parent: 'supplierPanel-v2.serviceItemList',
//                 url: '/serviceItemList/serviceItem/{id}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
//                         controller: 'ServiceItemV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('home');
//                         $translatePartialLoader.addPart('serviceCapacityInfo');
//                         $translatePartialLoader.addPart('messages');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('servicePaymentType');
//                         $translatePartialLoader.addPart('serviceConfirmationType');
//                         $translatePartialLoader.addPart('amenitiesType');
//                         $translatePartialLoader.addPart('weekDay');
//                         return $translate.refresh();
//                     }],
//                     entity: ['$rootScope','$stateParams', 'ServiceItem', function ($rootScope,$stateParams, ServiceItem) {
//                         if ($stateParams.id != '')
//                             return ServiceItem.get({id: $stateParams.id}).$promise;
//                         return {};
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.serviceItemList.delete', {
//                 parent: 'supplierPanel-v2.serviceItemList',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//
//
//                 },
//                 onEnter: ['$state','$stateParams', '$uibModal', function( $state,$stateParams, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
//                         controller: 'ServiceItemDeleteV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceItem', function(ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.serviceItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.serviceItemList.copy', {
//                 parent: 'supplierPanel-v2.serviceItemList',
//                 url: '/{id}/copy',
//                 data: {
//                     authorities: ['ROLE_USER'],
//
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
//                         controller: 'ServiceItemCopyV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceItem', function(ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.serviceItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.serviceItemList.serviceItem.delete', {
//                 parent: 'supplierPanel-v2.serviceItemList.serviceItem',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//
//
//                 },
//                 onEnter: ['$state', '$uibModal', function( $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
//                         controller: 'ServiceItemDeleteV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['$stateParams','ServiceItem', function($stateParams,ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.serviceItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.serviceItemList.serviceItem.copy', {
//                 parent: 'supplierPanel-v2.serviceItemList.serviceItem',
//                 url: '/{id}/copy',
//                 data: {
//                     authorities: ['ROLE_USER'],
//
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
//                         controller: 'ServiceItemCopyV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceItem', function(ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.serviceItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//
//             .state('supplierPanel-v2.eventItemList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/eventItemList',
//                 data: {
//                     authorities: ['ROLE_CATEGORY_MANAGER'],
//                     pageTitle: 'supplierPanel.sideMenu.eventItemList'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/service-item-v2/event-item-list-v2.html',
//                         controller: 'EventItemListV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('eventItem');
//                         $translatePartialLoader.addPart('serviceItemType');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('home');
//                         return $translate.refresh();
//                     }],
//
//                 }
//             })
//             .state('supplierPanel-v2.eventItemList.eventItem', {
//                 parent: 'supplierPanel-v2.eventItemList',
//                 url: '/eventItem/{id}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
//                         controller: 'ServiceItemV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('home');
//                         $translatePartialLoader.addPart('serviceCapacityInfo');
//                         $translatePartialLoader.addPart('messages');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('servicePaymentType');
//                         $translatePartialLoader.addPart('serviceConfirmationType');
//                         $translatePartialLoader.addPart('amenitiesType');
//                         $translatePartialLoader.addPart('weekDay');
//                         return $translate.refresh();
//                     }],
//                     entity: ['$rootScope','$stateParams', 'ServiceItem', function ($rootScope,$stateParams, ServiceItem) {
//                         if ($stateParams.id != '')
//                             return ServiceItem.get({id: $stateParams.id}).$promise;
//                         return {
//                             serviceMode: 'EVENT',
//                             id: null
//                         }
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.eventItemList.delete', {
//                 parent: 'supplierPanel-v2.eventItemList',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams','$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
//                         controller: 'ServiceItemDeleteV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceItem', function(ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.eventItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.eventItemList.copy', {
//                 parent: 'supplierPanel-v2.eventItemList',
//                 url: '/{id}/copy',
//                 data: {
//                     authorities: ['ROLE_USER'],
//
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
//                         controller: 'ServiceItemCopyV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceItem', function(ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.eventItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.eventItemList.eventItem.delete', {
//                 parent: 'supplierPanel-v2.eventItemList.eventItem',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$state', '$uibModal', function( $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
//                         controller: 'ServiceItemDeleteV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['$stateParams','ServiceItem', function($stateParams,ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.eventItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.eventItemList.eventItem.copy', {
//                 parent: 'supplierPanel-v2.eventItemList.eventItem',
//                 url: '/{id}/copy',
//                 data: {
//                     authorities: ['ROLE_USER'],
//
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
//                         controller: 'ServiceItemCopyV2Controller',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceItem', function(ServiceItem) {
//                                 return ServiceItem.get({id : $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function() {
//                         $state.go('supplierPanel-v2.eventItemList', null, { reload: true });
//                     }, function() {
//                         $state.go('^');
//                     });
//                 }]
//             })
//
//
//             .state('supplierPanel-v2.companyServiceCategoryList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/company-service-category-list',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/service-category/company-service-category-list-v2.html',
//                         controller: 'CompanyServiceCategoryListV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     entity: function () {
//                         return {
//                             mode: 'RESERVE'
//                         };
//                     },
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceCategory');
//                         $translatePartialLoader.addPart('eventItem');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyServiceCategoryList.new', {
//                 parent: 'supplierPanel-v2.companyServiceCategoryList',
//                 url: '/new',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/service-category/company-service-category-dialog-v2.html',
//                         controller: 'CompanyServiceCategoryDialogV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     entity: function () {
//                         return {
//                             categoryName: null,
//                             id: null
//                         };
//                     }
//                 }
//             })
//             .state('supplierPanel-v2.companyServiceCategoryList.edit', {
//                 parent: 'supplierPanel-v2.companyServiceCategoryList',
//                 url: '/{id}/edit',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/service-category/company-service-category-dialog-v2.html',
//                         controller: 'CompanyServiceCategoryDialogV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     entity: ['$stateParams','ServiceCategory', function ($stateParams,ServiceCategory) {
//                         return ServiceCategory.get({id: $stateParams.id}).$promise;
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyServiceCategoryList.delete', {
//                 parent: 'supplierPanel-v2.companyServiceCategoryList',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams,$state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
//                         controller: 'ServiceCategoryDeleteController',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceCategory', function (ServiceCategory) {
//                                 return ServiceCategory.get({id: $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.companyServiceCategoryList', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.deleteCompanyServiceCategory', {
//                 parent: 'supplierPanel-v2.companyServiceCategoryList.edit',
//                 url: '/{id}/delete',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams,$state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
//                         controller: 'ServiceCategoryDeleteController',
//                         controllerAs: 'vm',
//                         size: 'md',
//                         resolve: {
//                             entity: ['ServiceCategory', function (ServiceCategory) {
//                                 return ServiceCategory.get({id: $stateParams.id}).$promise;
//                             }]
//                         }
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.companyServiceCategoryList', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//
//
//             .state('supplierPanel-v2.partialFormPersonInfo', {
//                 parent: 'supplierPanel-v2',
//                 url: '/userProfile',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'global.menu.account.userProfile'
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal','$rootScope','Principal', function($stateParams, $state, $uibModal,$rootScope,Principal) {
//                     $rootScope.modalInstance = $uibModal.open({
//                         templateUrl: 'app/userprofile/user-profiles-v2.html',
//                         controller: 'UserProfileV2Controller',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg',
//                         windowClass: 'pl-modal',
//                         resolve: {
//                             translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                                 $translatePartialLoader.addPart('personInfo');
//                                 $translatePartialLoader.addPart('locationInfo');
//                                 return $translate.refresh();
//                             }]
//                             ,
//                             entity: ['UserProfileQuery', function (UserProfileQuery) {
//                                 return UserProfileQuery.getCurrentPersonInfo().query();
//                             }]
//                         }
//                     });
//
//
//                     $rootScope.modalInstance.result.then(function() {
//                         if($rootScope.fromState.name)
//                             $state.go( $rootScope.fromState.name);
//                         else
//                             $state.go( 'supplierPanel-v2.dashboard');
//
//                     }, function() {
//                         if($rootScope.fromState.name)
//                             $state.go( $rootScope.fromState.name);
//                         else
//                             $state.go( 'supplierPanel-v2.dashboard');
//                     });
//                 }]
//
//             })
//             .state('supplierPanel-v2.password', {
//                 parent: 'supplierPanel-v2',
//                 url: '/password',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'global.menu.account.password'
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal','$rootScope','Principal', function($stateParams, $state, $uibModal,$rootScope,Principal) {
//                     $rootScope.modalInstance = $uibModal.open({
//                         templateUrl: 'app/account/password/password-v2.html',
//                         controller: 'PasswordV2Controller',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg',
//                         windowClass: 'pl-modal',
//                         resolve: {
//                             translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                                 $translatePartialLoader.addPart('password');
//                                 return $translate.refresh();
//                             }]
//                             // ,
//                             // entity: ['UserProfileQuery', function (UserProfileQuery) {
//                             //     return UserProfileQuery.getCurrentPersonInfo().query();
//                             // }]
//                         }
//                     });
//
//
//                     $rootScope.modalInstance.result.then(function() {
//                         $state.go( 'supplierPanel-v2.more');
//
//                     }, function() {
//                         $state.go('supplierPanel-v2.more');
//                     });
//                 }]
//
//             })
//             //report
//             .state('supplierPanel-v2.reportExport', {
//                 parent: 'supplierPanel-v2',
//                 url: '/reportExport',
//                 data: {
//                     authorities: ['ROLE_REPORT_MANAGER'],
//                     pageTitle: 'supplierPanel.sideMenu.reports'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/reports/report-export-v2.html',
//                         controller: 'ReportExportController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('reportExport');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.reportExport.orderbag_list_by_service', {
//                 parent: 'supplierPanel-v2.reportExport',
//                 url: '/orderbag_list_by_service',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/reports/orderbag_list_by_service/orderbag_list_by_service.html',
//                         controller: 'OrderbagListByServiceController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg'
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.reportExport.orderbag_list_by_service', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.reportExport.financial_by_customer', {
//                 parent: 'supplierPanel-v2.reportExport',
//                 url: '/financial_by_customer',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/reports/financial_by_customer/financial_by_customer.html',
//                         controller: 'FinancialByCustomerController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg'
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.reportExport.financial_by_customer', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.reportExport.reserve_list_dtail_report', {
//                 parent: 'supplierPanel-v2.reportExport',
//                 url: '/reserve_list_dtail_report',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
//                         controller: 'ReserveListDtailReportController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg'
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.reportExport.reserve_list_dtail_report', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.reportExport.reserve_list_summary_report', {
//                 parent: 'supplierPanel-v2.reportExport',
//                 url: '/reserve_list_summary_report',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
//                         controller: 'ReserveListSummaryReportController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg'
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.reportExport.reserve_list_dtail_report', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.reportExport.reserve_list_summary_with_payment_report', {
//                 parent: 'supplierPanel-v2.reportExport',
//                 url: '/reserve_list_summary_with_payment_report',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/reports/reserve_list_summary_with_payment_report/reserve_list_summary_with_payment_report.html',
//                         controller: 'ReserveListSummaryWithPaymentReportController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg'
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.reportExport.reserve_list_summary_with_payment_report', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             .state('supplierPanel-v2.reportExport.sum_of_reserve_count', {
//                 parent: 'supplierPanel-v2.reportExport',
//                 url: '/sum_of_reserve_count',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
//                     $uibModal.open({
//                         templateUrl: 'app/reports/sum_of_reserve_count/sum_of_reserve_count.html',
//                         controller: 'SumOfReserveCountController',
//                         controllerAs: 'vm',
//                         backdrop: 'static',
//                         size: 'lg'
//                     }).result.then(function () {
//                         $state.go('supplierPanel-v2.reportExport.sum_of_reserve_count', null, {reload: true});
//                     }, function () {
//                         $state.go('^');
//                     });
//                 }]
//             })
//             //.............
//             //companyPaymentLog
//             .state('supplierPanel-v2.companyPaymentLogList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyPaymentLog',
//                 data: {
//                     authorities: ['ROLE_FINANCIAL_MANAGER'],
//                     pageTitle: 'tikonApp.companyPaymentLog.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-payment-log/company-payment-log-list-v2.html',
//                         controller: 'CompanyPaymentLogListV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('companyPaymentLog');
//                         $translatePartialLoader.addPart('paymentLog');
//                         $translatePartialLoader.addPart('bankAccountInfo');
//                         $translatePartialLoader.addPart('accountClearingRequestStatus');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyAllPaymentLogList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyAllPaymentLog',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.companyPaymentLog.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-payment-log/company-all-payment-log-list-v2.html',
//                         controller: 'CompanyAllPaymentLogListController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('companyPaymentLog');
//                         $translatePartialLoader.addPart('paymentLog');
//                         $translatePartialLoader.addPart('bankAccountInfo');
//                         $translatePartialLoader.addPart('accountClearingRequestStatus');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.accountClearingList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/accountClearingList',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.accountClearingRequest.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/account-clearing-request/account-clearing-requests-v2.html',
//                         controller: 'AccountClearingRequestsV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('accountClearingRequest');
//                         $translatePartialLoader.addPart('accountClearingRequestStatus');
//                         $translatePartialLoader.addPart('companyPaymentLog');
//                         $translatePartialLoader.addPart('global');
//
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.accountClearingDetail', {
//                 parent: 'supplierPanel-v2',
//                 url: '/accountClearingDetail/detail/{id}',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.accountClearingRequest.detail.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail-v2.html',
//                         controller: 'AccountClearingRequestDetailController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('bankAccountInfo');
//                         $translatePartialLoader.addPart('accountClearingRequest');
//                         $translatePartialLoader.addPart('accountClearingRequestStatus');
//                         $translatePartialLoader.addPart('companyPaymentLog');
//                         $translatePartialLoader.addPart('paymentLog');
//                         $translatePartialLoader.addPart('global');
//
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//
//             .state('supplierPanel-v2.setting', {
//                 parent: 'supplierPanel-v2',
//                 url: '/setting',
//                 data: {
//                     authorities: ['ROLE_COMPANY_MANAGER'],
//                     pageTitle: 'supplierPanel.sideMenu.setting'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/dashboard/setting/setting-v2.html',
//                         controller: 'SettingController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('settingInfo');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyInfo', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyInfo',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company/company-info-v2.html',
//                         controller: 'CompanyInfoV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('company');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('activityType');
//                         return $translate.refresh();
//                     }]
//                     //entity: ['$stateParams', 'Company', function ($stateParams, Company) {
//                     //    return Company.get({id: $stateParams.id}).$promise;
//                     //}]
//                 }
//             })
//             .state('supplierPanel-v2.companyWorkingTimes', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyWorkingTimes',
//
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling-v2.html',
//                         controller: 'CompanySchedulingV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('home');
//                         $translatePartialLoader.addPart('serviceCapacityInfo');
//                         $translatePartialLoader.addPart('messages');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('scheduleInfo');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyLocationInfo', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyLocationInfo',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/location-info/company-location-info-v2.html',
//                         controller: 'CompanyLocationInfoController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('locationInfo');
//                         return $translate.refresh();
//                     }],
//                     entity: ['$stateParams', 'CompanyInfoQuery', function ($stateParams, CompanyInfoQuery) {
//
//                         return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
//                     }]
//
//                 }
//             })
//             .state('supplierPanel-v2.companySocialNetworkInfo', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companySocialNetworkInfo?page&sort&search',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.companySocialNetworkInfo.home.title'
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-infos-v2.html',
//                         controller: 'CompanySocialNetworkInfoControllerCustom',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('company');
//                         $translatePartialLoader.addPart('companySocialNetworkInfo');
//                         $translatePartialLoader.addPart('socialNetworkType');
//                         $translatePartialLoader.addPart('socialNetworkInfo');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companySettingInfo', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companySettingInfo/:settingFormSection',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/setting-info/company-setting-info-v2.html',
//                         controller: 'CompanySettingInfoController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('settingInfo');
//                         $translatePartialLoader.addPart('notificationSetting');
//                         $translatePartialLoader.addPart('financialSetting');
//                         $translatePartialLoader.addPart('themeSettingInfo');
//                         $translatePartialLoader.addPart('notificationType');
//                         $translatePartialLoader.addPart('currency');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyBankAccountInfo', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyBankAccountInfo',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/bank-account-info/company-bank-account-info-v2.html',
//                         controller: 'CompanyBankAccountInfoController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('bankAccountInfo');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.companyCustomSetting', {
//                 parent: 'supplierPanel-v2',
//                 url: '/companyCustomSetting',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.customSetting.home.title'
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/customSetting/custom-setting-v2.html',
//                         controller: 'CustomSettingController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     entity: ['CompanyInfoQuery', function (CompanyInfoQuery) {
//
//                         return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('customSetting');
//                         $translatePartialLoader.addPart('company');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             //coupon
//             .state('supplierPanel-v2.couponList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/coupon-list',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.coupon.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/coupon/coupons-list-v2.html',
//                         controller: 'CouponListController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//
//                         $translatePartialLoader.addPart('coupon');
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('customer');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('couponGenerateTypes');
//                         $translatePartialLoader.addPart('couponStatus');
//
//
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.newCoupon', {
//                 parent: 'supplierPanel-v2',
//                 url: '/coupon-list/new',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/coupon/coupon-v2.html',
//                         controller: 'CouponV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('coupon');
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('couponGenerateTypes');
//                         $translatePartialLoader.addPart('couponStatus');
//                         $translatePartialLoader.addPart('amountTypes');
//                         // $translatePartialLoader.addPart('serviceItem');
//                         // $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//
//                         return {
//                             id: null
//                         };
//                     }
//                 }
//             })
//             .state('supplierPanel-v2.editCoupon', {
//                 parent: 'supplierPanel-v2',
//                 url: '/coupon-list/edit/{id}',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/coupon/coupon-v2.html',
//                         controller: 'CouponV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('coupon');
//                         $translatePartialLoader.addPart('couponGenerateTypes');
//                         $translatePartialLoader.addPart('amountTypes');
//                         $translatePartialLoader.addPart('couponStatus');
//                         // $translatePartialLoader.addPart('serviceItem');
//                         // $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: ['Coupon', '$stateParams', function (Coupon, $stateParams) {
//
//                         return Coupon.get({id: $stateParams.id}).$promise;
//                     }]
//                 }
//                 // resolve: {
//                 //     entity: ['CompanyCustomer', function(CompanyCustomer) {
//                 //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
//                 //     }]
//                 // }
//             })
//             //.............
//
//             //reserve limit
//             .state('supplierPanel-v2.reserveLimitList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/reserve-limit-list',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.reserveLimit.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/reserve-limit/reserve-limits-list-v2.html',
//                         controller: 'ReserveLimitsListController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//
//                         $translatePartialLoader.addPart('reserveLimit');
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('customer');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('reserveLimitTypes');
//                         $translatePartialLoader.addPart('reserveLimitStatus');
//
//
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.editReserveLimit', {
//                 parent: 'supplierPanel-v2',
//                 url: '/reserve-limit-list/edit/{id}',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/reserve-limit/reserve-limit-v2.html',
//                         controller: 'ReserveLimitV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('reserveLimit');
//                         $translatePartialLoader.addPart('reserveLimitTypes');
//                         $translatePartialLoader.addPart('reserveLimitStatus');
//                         return $translate.refresh();
//                     }],
//                     entity: ['ReserveLimit', '$stateParams', function (ReserveLimit, $stateParams) {
//
//                         return ReserveLimit.get({id: $stateParams.id}).$promise;
//                     }]
//                 }
//                 // resolve: {
//                 //     entity: ['CompanyCustomer', function(CompanyCustomer) {
//                 //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
//                 //     }]
//                 // }
//             })
//             .state('supplierPanel-v2.newReserveLimit', {
//                 parent: 'supplierPanel-v2',
//                 url: '/reserve-limit-list/new',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/reserve-limit/reserve-limit-v2.html',
//                         controller: 'ReserveLimitV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('reserveLimit');
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('reserveLimitTypes');
//                         $translatePartialLoader.addPart('reserveLimitStatus');
//                         // $translatePartialLoader.addPart('serviceItem');
//                         // $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//
//                         return {
//                             id: null
//                         };
//                     }
//                 }
//             })
//             //...................
//             // dashboard onBoarding
//             .state('supplierPanel-v2.dashboard.companySettingInfo', {
//                 parent: 'supplierPanel-v2.dashboard',
//                 url: '/companySettingInfo/:settingFormSection',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/setting-info/company-setting-info-v2.html',
//                         controller: 'CompanySettingInfoController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('settingInfo');
//                         $translatePartialLoader.addPart('notificationSetting');
//                         $translatePartialLoader.addPart('financialSetting');
//                         $translatePartialLoader.addPart('themeSettingInfo');
//                         $translatePartialLoader.addPart('notificationType');
//                         $translatePartialLoader.addPart('currency');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.dashboard.newServiceItem', {
//                 parent: 'supplierPanel-v2.dashboard',
//                 url: '/serviceItem/{id}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
//                         controller: 'ServiceItemV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('home');
//                         $translatePartialLoader.addPart('serviceCapacityInfo');
//                         $translatePartialLoader.addPart('messages');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('servicePaymentType');
//                         $translatePartialLoader.addPart('serviceConfirmationType');
//                         $translatePartialLoader.addPart('amenitiesType');
//                         $translatePartialLoader.addPart('weekDay');
//                         return $translate.refresh();
//                     }],
//                     entity: ['$rootScope','$stateParams', 'ServiceItem', function ($rootScope,$stateParams, ServiceItem) {
//                         return {};
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.dashboard.newCompanyServant', {
//                 parent: 'supplierPanel-v2.dashboard',
//                 url: '/newCompanyServant',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
//                         controller: 'CompanyServantsV2DialogController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//
//                         return {
//                             title: null,
//                             level: null,
//                             id: null
//                         };
//                     }
//                 }
//                 // });
//             })
//             .state('supplierPanel-v2.dashboard.companyWorkingTimes', {
//                 parent: 'supplierPanel-v2.dashboard',
//                 url: '/companyWorkingTimes',
//
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling-v2.html',
//                         controller: 'CompanySchedulingV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('supplierPanel');
//                         $translatePartialLoader.addPart('home');
//                         $translatePartialLoader.addPart('serviceCapacityInfo');
//                         $translatePartialLoader.addPart('messages');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('serviceItemStatus');
//                         $translatePartialLoader.addPart('servant');
//                         $translatePartialLoader.addPart('scheduleInfo');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.dashboard.newReserve', {
//                 parent: 'supplierPanel-v2.dashboard',
//                 url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
//                 data: {
//                     authorities: []
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
//                         controller: 'ReserveV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('serviceItem');
//                         $translatePartialLoader.addPart('orderBag');
//                         $translatePartialLoader.addPart('orderBagServiceItem');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('genderType');
//
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//                         return {
//                             customer: null,
//                             createDate: null,
//                             status: 0,
//                             id: null,
//                             orderBagServiceItems: [{}]
//                         };
//                     }
//
//                 }
//             })
//             //......................
//
//             // CustomerGroup
//             .state('supplierPanel-v2.customerGroupList', {
//                 parent: 'supplierPanel-v2',
//                 url: '/customer-group-list',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                     pageTitle: 'tikonApp.customerGroup.home.title'
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/customer-group/customer-groups-list-v2.html',
//                         controller: 'CustomerGroupListController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 params: {
//                     page: {
//                         value: '1',
//                         squash: true
//                     },
//                     sort: {
//                         value: 'id,asc',
//                         squash: true
//                     },
//                     search: null
//                 },
//                 resolve: {
//                     pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                         return {
//                             page: PaginationUtil.parsePage($stateParams.page),
//                             sort: $stateParams.sort,
//                             predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                             ascending: PaginationUtil.parseAscending($stateParams.sort),
//                             search: $stateParams.search
//                         };
//                     }],
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//
//                         $translatePartialLoader.addPart('customerGroup');
//                         $translatePartialLoader.addPart('companyCustomer');
//                         $translatePartialLoader.addPart('customer');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//
//
//                         return $translate.refresh();
//                     }]
//                 }
//             })
//             .state('supplierPanel-v2.newCustomerGroup', {
//                 parent: 'supplierPanel-v2',
//                 url: '/customer-group-list/new',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/customer-group/customer-group-v2.html',
//                         controller: 'CustomerGroupV2Controller',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('customerGroup');
//                         $translatePartialLoader.addPart('personInfo');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: function () {
//
//                         return {
//                             id: null
//                         };
//                     }
//                 }
//             })
//             .state('supplierPanel-v2.editCustomerGroup', {
//                 parent: 'supplierPanel-v2',
//                 url: '/customer-group/edit/{id}',
//                 data: {
//                     authorities: ['ROLE_USER']
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/entities/customer-group/customer-group-v2.html',
//                         controller: 'CustomerGroupV2Controller',
//                         controllerAs: 'vm',
//                     }
//                 },
//                 resolve: {
//
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('customerGroup');
//                         $translatePartialLoader.addPart('global');
//                         return $translate.refresh();
//                     }],
//                     entity: ['CustomerGroup', '$stateParams', function (CustomerGroup, $stateParams) {
//
//                         return CustomerGroup.get({id: $stateParams.id}).$promise;
//                     }]
//                 }
//                 // resolve: {
//                 //     entity: ['CompanyCustomer', function(CompanyCustomer) {
//                 //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
//                 //     }]
//                 // }
//             })
//
//
//             .state('supplierPanel-v2.confirmSubscription', {
//                 parent: 'supplierPanel-v2',
//                 url: '/confirmSubscription?Authority&Status',
//                 data: {
//                     authorities: ['ROLE_USER'],
//                 },
//                 views: {
//                     'subcontent': {
//                         templateUrl: 'app/entities/company-subscription-status/confirm-subscription.html',
//                         controller: 'ConfirmSubscriptionController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('global');
//                         $translatePartialLoader.addPart('companySubscriptionStatus');
//                         $translatePartialLoader.addPart('subscriptionType');
//                         $translatePartialLoader.addPart('subscriptionPackage');
//                         return $translate.refresh();
//                     }]
//                     ,
//                     entity: ['$stateParams', 'CompanySubscriptionStatusCustom', 'Auth', '$state', function ($stateParams, CompanySubscriptionStatusCustom, Auth, $state) {
//
//                         var refid=getParameterByName('refid');
//                         var clientrefid=getParameterByName('clientrefid');
//
//                         //jibimo
//                         var trx=getParameterByName('trx');
//                         var status=getParameterByName('status');
//                         var state_code=getParameterByName('state_code');
//
//                         if ($stateParams.Authority != '' && $stateParams.Status == 'OK') {
//
//
//                             return CompanySubscriptionStatusCustom.confirmSubscription($stateParams.Authority).query(function () {
//                                 //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
//                                 //
//                                 //
//                                 //
//                                 //});
//                             });
//
//                         }
//                         else if(refid && clientrefid && refid>1)
//                         {
//                             return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid,refid).query(function () {
//                                 //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
//                                 //
//                                 //
//                                 //
//                                 //});
//                             });
//                         }
//                         else if(trx && status && state_code && status ==1 && state_code == 99 ) {
//                             return CompanySubscriptionStatusCustom.confirmSubscription(trx).query(function () {
//                             });
//                         }
//                         else{
//                             return null;
//                         }
//
//
//                     }]
//                 }
//             })
//         ;
//     }
// })();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierPanelV2Controller', SupplierPanelV2Controller);

    SupplierPanelV2Controller.$inject = ['CompanyCustom', '$location', '$scope', 'Principal', 'LoginService', '$state', 'CompanyInfoQuery', 'ServantCustom', '__config', '$localStorage', '$translate', '$translatePartialLoader', 'ActivityTypeInfoCustom', 'CompanySubscriptionStatusCustom'];

    function SupplierPanelV2Controller(CompanyCustom, $location, $scope, Principal, LoginService, $state, CompanyInfoQuery, ServantCustom, __config, $localStorage, $translate, $translatePartialLoader, ActivityTypeInfoCustom, CompanySubscriptionStatusCustom) {
        var vm = this;
        vm.collapseMenu = collapseMenu;
        vm.menuIcon = menuIcon;
        vm.account = null;
        vm.menuState = menuState;
        vm.menuWiden = false;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.guidTipsEnable = false;
        vm.goToCurrentServant = goToCurrentServant;
        vm.goto = goto;
        vm.canViewReport = true;
        vm.uncheck = uncheck;
        vm.init = init;
        var cckey = $location.search().cckey;
        // loadCompanyInfo();
        vm.isWorkSpace = false;
        ;
        vm.checkActivityType = checkActivityType;
        vm.__config = __config;
        vm.wedoMeetMode = false;
        vm.logoSource = "content/images/planovin.png";
        vm.setServantTooltip = setServantTooltip;
        vm.servantTitle = "";
        vm.servantListTitle = "";
        vm.isLiActive = isLiActive;
        vm.hasSubscription = true;
        vm.goToState = goToState;


        vm.init();

        function init() {

            $translatePartialLoader.addPart('activityType');
            $translatePartialLoader = $translate.refresh();

            if (!cckey)
                loadCompanyInfo();

            vm.servantClass = "fa fa-address-card fa-fw";
            vm.servantTranslateFile = "supplierPanel.sideMenu.servantInfo-v2";
            Principal.getCurrentCompanyFeatureList();

            // if(vm.__config.appMode =='event')
            // {
            //     vm.wedoMeetMode = true;
            //     vm.logoSource = "content/images/wedomeet.png"
            // }
            if (vm.__config.appName && vm.__config.appName == 'planovin') {
                // vm.logoSource = "content/images/planovin-white-space.svg"
                vm.logoSource = "content/images/planovin.png"
            }

        }

        function menuIcon(x) {
            x.classList.toggle("change");
        }

        function changeCurrentCompany() {
            if (cckey) {
                vm.company = null;
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {

                    loadCompanyInfo();

                });
            }

        }

        function collapseMenu() {

        }

        function loadCompanyInfo() {
            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                if (company != null && company != undefined) {
                    vm.company = company;

                    ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.company.activityType).query(function (result) {
                        vm.companyActivityTypeInfo = result;
                        checkActivityType();
                    })
                }

            })

            hasActiveSubscription();


        }

        vm.guidTipsConfig = [
            {
                type: "title",
                heading: "Welcome to the NG-Joyride demo",
                text: '<div class="row"><div id="title-text" class="col-md-12"><span class="main-text">Welcome to <strong>Ng Joyride Demo</strong></span><br><span>( This demo will walk you through the features of Ng-Joyride. )</span><br/><br/><span class="small"><em>This can have custom html too !!!</em></span></div></div>'

            }, {
                type: "element",
                selector: "#scheduleStartDate",
                heading: "Custom Title",
                text: "The demo finishes.Head over to github to learn more",
                placement: "bottom",
                scroll: false
            }

        ];


        function goToCurrentServant() {
            ServantCustom.findServantByCurrentUser().query().$promise.then(function (result) {

                if (vm.hasSubscription)
                    $state.transitionTo('supplierPanel-v2.companyServants.edit', {id: result.id});
                else
                    $state.go('supplierPanel-v2.companySubscriptionStatusV2');

            });

        }

        function goto(state) {
            $state.transitionTo('supplierPanel' + state);
        }

        function menuState() {
            vm.menuWiden = false;
        }

        function uncheck() {

            // if (vm.checked == event.target.value)
            vm.checked = false
        }

        function checkActivityType() {

            if (vm.company && vm.companyActivityTypeInfo) {
                setServantTooltip();
                if (vm.companyActivityTypeInfo.servantType && vm.companyActivityTypeInfo.servantType == 'RESOURCE') {
                    vm.isWorkSpace = true;
                    vm.servantTranslateFile = "supplierPanel.sideMenu.workSpaceInfo-v2";
                    vm.servantClass = "fa fa-building fa-fw";
                    return;
                }


            }

            vm.isWorkSpace = false;

        }


        function setServantTooltip() {

            vm.servantTranslateFileOptions = "";
            vm.servantListTitle = "";

            if (vm.company && vm.companyActivityTypeInfo && vm.companyActivityTypeInfo.servantListTitle)
                // vm.servantTranslateFileOptions = 'tikonApp.ActivityType.ActivityTypeServants.'+vm.company.activityType ;
                vm.servantListTitle = vm.companyActivityTypeInfo.servantListTitle;
        }


        function toggleSideMenu() {
            var wrapper = document.getElementById("page-wrapper");
            var side = document.getElementById("sidebarV2");
            if (wrapper && side) {
                if (side.classList.contains('open')) {
                    wrapper.classList.remove('compact');
                    side.classList.remove('open');
                } else {
                    wrapper.classList.add('compact');
                    side.classList.add('open');
                }

            }
        }

        function isLiActive(id) {
            var li = document.getElementById(id);
            if (li.classList.contains('active'))
                return true;
            else
                return false;

        }

        function hasActiveSubscription() {
            CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(hasSubscriptionSuccess, hasSubscriptionError);

            function hasSubscriptionSuccess(result) {
                if (result.status == 'DONE')
                    vm.hasSubscription = true;
                else
                    vm.hasSubscription = false;
            }

            function hasSubscriptionError() {
                vm.hasSubscription = false;
            }

        }


        function goToState(state, param) {
            if (param)
                $state.go(state, param);
            else
                $state.go(state);
        }

        $scope.$on('toggleSideMenu', function () {
            toggleSideMenu();
        });


        $scope.$on('resetToggleSideMenu', function () {
            var wrapper = document.getElementById("page-wrapper");
            var side = document.getElementById("sidebarV2");
            if (wrapper && side) {
                if (side.classList.contains('open')) {
                    wrapper.classList.remove('compact');
                    side.classList.remove('open');
                }
            }
        });


        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
    }
})();
;
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function removeSignFromUrl() {
    var url = window.location.href;
    if (url.indexOf("?#") > 0) {
        url = url.replace("?#", "#");
        window.location.href = url;
        return;
    }

    var qIndex = url.indexOf("?");
    var sharpIndex = url.indexOf("#");
    if (qIndex > -1 && qIndex < sharpIndex) {
        var first = url.substring(0, qIndex);
        var end = url.substring(sharpIndex, url.length);
        var newUrl = first.concat(end);
        window.location.href = newUrl;
        return;
    }

}


(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
            .state('initSetupWizardV2', {
                parent: 'app',
                url: '/initSetupWizardV2?resetMode',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/wizards/init-setup-v2/init-setup-v2.html',
                        controller: 'InitSetupV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', function ($stateParams) {
                        var resetMode = false;
                        if ($stateParams.resetMode != null && $stateParams.resetMode != undefined) {
                            resetMode = $stateParams.resetMode;
                        }

                        return {resetMode: resetMode};

                    }]
                }
            })
            .state('supplierPanel-v2', {
                parent: 'app',
                url: '/supplierPanel-v2',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/supplier-v2/supplierPanel-v2.html',

                        controller: 'SupplierPanelV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.more', {
                parent: 'supplierPanel-v2',
                url: '/more',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/layouts/more/more.html',
                        controller: 'MoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard', {
                parent: 'supplierPanel-v2',
                url: '/dashboard',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'supplierPanel.sideMenu.dashboard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/main/report.main_dashboard_v2.html',
                        controller: 'MainDashboardV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', '$rootScope', function ($translate, $translatePartialLoader, $rootScope) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('newsType');
                        $rootScope.$broadcast('showNavBar');
                        removeSignFromUrl();
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.calendar', {
                parent: 'supplierPanel-v2',
                url: '/calendar',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/book-calendar-v2.template.html',
                        controller: 'BookCalendarV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.calendar-v2', {
                parent: 'supplierPanel-v2',
                url: '/calendar-v2',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/calendar-vue.template.html',
                        controller: 'BookCalendarV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.caledarConfig', {
                parent: 'supplierPanel-v2',
                url: '/calendarConfig',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/time-board/filter-dialog.template-v2.html',
                        controller: 'BookCalendarV2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('locationInfo');
                                return $translate.refresh();
                            }]
                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');

                    }, function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');
                    });
                }]

            })
            .state('supplierPanel-v2.calendar.servantExceptionTimes', {
                parent: 'supplierPanel-v2.calendar',
                url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
                        controller: 'ServantExceptionDurationController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleInfo');

                        return $translate.refresh();
                    }],
                    entity: ['Principal', '$stateParams', function (Principal, $stateParams) {
                        // removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                        var multiServant = true;
                        Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
                            multiServant = !has;
                        });

                        var availabilityMode = $stateParams.availabilityMode;
                        var defaultServantId = $stateParams.defaultServantId;
                        return {
                            defaultServantId: defaultServantId,
                            availabilityMode: availabilityMode,
                            canSelectServant: multiServant

                        };
                    }]
                }
            })
            .state('supplierPanel-v2.new-reserve-modal', {
                parent: 'supplierPanel-v2.calendar-v2',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
                        controller: 'ReserveV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            //reserve
            .state('supplierPanel-v2.reserveList', {
                parent: 'supplierPanel-v2',
                url: '/reserveList?pageSize&sort&searchText&filterQuery',
                reloadOnSearch: false, 
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/reserve-list-v2.html',
                        controller: 'ReserveListController',
                        controllerAs: 'vm'
                    }
                },
               params: {
                    pageSize: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    searchText: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            // page: PaginationUtil.parsePage($stateParams.page),
                            page: parseInt($stateParams.page || 1, 10),
                             pageSize: parseInt($stateParams.pageSize || 10, 10),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.searchText
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadOnHand'
                        };
                    }

                }
            })
            .state('supplierPanel-v2.reserveWithCustomerParameter', {
                parent: 'supplierPanel-v2',
                url: '/reserveWithCustomerParameter/{customerId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/reserve/new-reserve-modal.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('serviceItem');
                                $translatePartialLoader.addPart('orderBag');
                                $translatePartialLoader.addPart('orderBagServiceItem');
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('genderType');

                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    customer: null,
                                    createDate: null,
                                    status: 0,
                                    id: null,
                                    orderBagServiceItems: [{}]
                                };
                            }

                        }
                    });

                    $rootScope.modalInstance.result.then(function () {

                        $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
                        $rootScope.modalInstance.dismiss('cancel');
                    }, function () {
                        var prevState = $rootScope.fromState.name;
                        if ($rootScope.fromStateParams)
                            $state.go(prevState, {id: $rootScope.fromStateParams.id});
                        else
                            $state.go(prevState);
                    });
                }]
            })
            .state('supplierPanel-v2.editOrderBag', {
                parent: 'supplierPanel-v2',
                url: '/{id}/editOrderBag',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag/edit-order-bag-v2.html',
                        controller: 'EditOrderBagV2Controller',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('orderBagServiceItemDtail');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('invoiceInfo');


                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagCustom', function ($stateParams, OrderBagCustom) {
                        return OrderBagCustom.getOrderBagWithEntities($stateParams.id).query();
                    }
                    ],
                    invoiceInfoEntity: ['$stateParams', 'InvoiceInfoCustom', function ($stateParams, InvoiceInfoCustom) {
                        return InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query();
                    }]

                }
            })
            .state('supplierPanel-v2.editOrderBag.editCompanyCustomer', {
                parent: 'supplierPanel-v2.editOrderBag',
                url: '/editCompanyCustomer/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            .state('supplierPanel-v2.newReserve', {
                parent: 'supplierPanel-v2.reserveList',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
                        controller: 'ReserveV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            //.........................
            //subscription
            .state('supplierPanel-v2.companySubscriptionStatusV2', {
                parent: 'supplierPanel-v2',
                url: '/companySubscriptionStatusV2',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.subscription'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-buy-subscription.html',
                        controller: 'CompanyBuySubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('packageFeatureList');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanyCustom', 'ActivityTypeInfoCustom', function (CompanyCustom, ActivityTypeInfoCustom) {
                        return ActivityTypeInfoCustom.getActivityTypeInfoByCurrentCompany().query().$promise;
                    }]
                }
            })
            .state('supplierPanel-v2.companySmsPackageStatus', {
                parent: 'supplierPanel-v2',
                url: '/companySmsPackageStatus',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.sms_package_status'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-sms-package-status-view-v2.html',
                        controller: 'CompanySmsPackageStatusViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel-v2.companySubscriptionHistory', {
                parent: 'supplierPanel-v2',
                url: '/companySubscriptionHistory' + ':packageType',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.subscription_history'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-histories.html',
                        controller: 'CompanySubscriptionHistoriesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('packageType');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel-v2.purchaseSubscription', {
                parent: 'supplierPanel-v2',
                url: '/{id}/purchaseSubscription',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/purchase-subscription-v2.html',
                        controller: 'PurchaseSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('supplierCoupon');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {

                        if ($stateParams.id != '')

                            return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            //................
            .state('supplierPanel-v2.companyCustomer', {
                parent: 'supplierPanel-v2',
                url: '/company-customer-list?page&sort&searchText',
                data: {
                    authorities: ['ROLE_CUSTOMER_MANAGER'],
                    pageTitle: 'tikonApp.companyCustomer.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers-list-v2.html',
                        controller: 'CompanyCustomerListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    searchText: { value: null },
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('customerStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleType');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyCustomer.new', {
                parent: 'supplierPanel-v2',
                url: '/company-customer-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.companyCustomer.edit', {
                parent: 'supplierPanel-v2',
                url: '/company-customer-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('wallet');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            .state('supplierPanel-v2.companyCustomer.delete', {
                parent: 'supplierPanel-v2.companyCustomer',
                url: '/company-customer-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteCompanyCustomer', {
                parent: 'supplierPanel-v2.companyCustomer.edit',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.companyCustomer.invoiceInfoDetail', {
                parent: 'supplierPanel-v2',
                url: '/company-customer/invoice-detail/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-actions-v2.html',
                        controller: 'InvoiceInfoActionsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.companyCustomer.editInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/company-customer/editInvoiceInfo/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog-v2.html',
                        controller: 'InvoiceInfoDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            //......................................................

            .state('supplierPanel-v2.companyServants', {
                parent: 'supplierPanel-v2',
                url: '/company-servants?searchText',
                data: {
                    authorities: ['ROLE_SERVANT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servantInfo'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2.html',
                        controller: 'CompanyServantsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                     searchText: { value: null },
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyServants.new', {
                parent: 'supplierPanel-v2',
                url: '/companyServants/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
                        controller: 'CompanyServantsV2DialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
                // });
            })
            .state('supplierPanel-v2.companyServants.edit', {
                parent: 'supplierPanel-v2',
                url: '/companyServants/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
                        controller: 'CompanyServantsV2DialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Servant', '$stateParams', function (Servant, $stateParams) {
                        return Servant.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            .state('supplierPanel-v2.companyServants.delete', {
                parent: 'supplierPanel-v2.companyServants',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
                        controller: 'CompanyServantsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServants', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.companyServants.edit.delete', {
                parent: 'supplierPanel-v2.companyServants.edit',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
                        controller: 'CompanyServantsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServants', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.companyServants.servantExceptionTimes', {
                parent: 'supplierPanel-v2.companyServants.edit',
                url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
                        controller: 'ServantExceptionDurationController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleInfo');

                        return $translate.refresh();
                    }],
                    entity: ['Principal', '$stateParams', function (Principal, $stateParams) {
                        // removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                        var multiServant = true;
                        Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
                            multiServant = !has;
                        });

                        var availabilityMode = $stateParams.availabilityMode;
                        var defaultServantId = $stateParams.defaultServantId;
                        return {
                            defaultServantId: defaultServantId,
                            availabilityMode: availabilityMode,
                            canSelectServant: multiServant

                        };
                    }]
                }
            })
            .state('supplierPanel-v2.serviceItemList', {
                parent: 'supplierPanel-v2',
                url: '/serviceItemList' + '-' + ':type?searchText',
                data: {
                    authorities: ['ROLE_CATEGORY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servicelist'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/service-item-list-v2.html',
                        controller: 'ServiceItemListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    searchText: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel-v2.serviceItemList.serviceItem', {
                parent: 'supplierPanel-v2.serviceItemList',
                url: '/serviceItemList/serviceItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
                        controller: 'ServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$rootScope', '$stateParams', 'ServiceItem', function ($rootScope, $stateParams, ServiceItem) {
                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel-v2.serviceItemList.delete', {
                parent: 'supplierPanel-v2.serviceItemList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$state', '$stateParams', '$uibModal', function ($state, $stateParams, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.serviceItemList.copy', {
                parent: 'supplierPanel-v2.serviceItemList',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.serviceItemList.serviceItem.delete', {
                parent: 'supplierPanel-v2.serviceItemList.serviceItem',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.serviceItemList.serviceItem.copy', {
                parent: 'supplierPanel-v2.serviceItemList.serviceItem',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel-v2.eventItemList', {
                parent: 'supplierPanel-v2',
                url: '/eventItemList?searchText',
                data: {
                    authorities: ['ROLE_CATEGORY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.eventItemList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/event-item-list-v2.html',
                        controller: 'EventItemListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    searchText: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel-v2.eventItemList.eventItem', {
                parent: 'supplierPanel-v2.eventItemList',
                url: '/eventItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
                        controller: 'ServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$rootScope', '$stateParams', 'ServiceItem', function ($rootScope, $stateParams, ServiceItem) {
                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {
                            serviceMode: 'EVENT',
                            id: null
                        }
                    }]
                }
            })
            .state('supplierPanel-v2.eventItemList.delete', {
                parent: 'supplierPanel-v2.eventItemList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.eventItemList.copy', {
                parent: 'supplierPanel-v2.eventItemList',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.eventItemList.eventItem.delete', {
                parent: 'supplierPanel-v2.eventItemList.eventItem',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.eventItemList.eventItem.copy', {
                parent: 'supplierPanel-v2.eventItemList.eventItem',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })


            .state('supplierPanel-v2.companyServiceCategoryList', {
                parent: 'supplierPanel-v2',
                url: '/company-service-category-list',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-category/company-service-category-list-v2.html',
                        controller: 'CompanyServiceCategoryListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    entity: function () {
                        return {
                            mode: 'RESERVE'
                        };
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCategory');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyServiceCategoryList.new', {
                parent: 'supplierPanel-v2.companyServiceCategoryList',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-category/company-service-category-dialog-v2.html',
                        controller: 'CompanyServiceCategoryDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            categoryName: null,
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.companyServiceCategoryList.edit', {
                parent: 'supplierPanel-v2.companyServiceCategoryList',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-category/company-service-category-dialog-v2.html',
                        controller: 'CompanyServiceCategoryDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ServiceCategory', function ($stateParams, ServiceCategory) {
                        return ServiceCategory.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel-v2.companyServiceCategoryList.delete', {
                parent: 'supplierPanel-v2.companyServiceCategoryList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteCompanyServiceCategory', {
                parent: 'supplierPanel-v2.companyServiceCategoryList.edit',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })


            .state('supplierPanel-v2.partialFormPersonInfo', {
                parent: 'supplierPanel-v2',
                url: '/userProfile',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.userProfile'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/userprofile/user-profiles-v2.html',
                        controller: 'UserProfileV2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('locationInfo');
                                return $translate.refresh();
                            }]
                            ,
                            entity: ['UserProfileQuery', function (UserProfileQuery) {
                                return UserProfileQuery.getCurrentPersonInfo().query();
                            }]
                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');

                    }, function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');
                    });
                }]

            })
            .state('supplierPanel-v2.password', {
                parent: 'supplierPanel-v2',
                url: '/password',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.password'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/account/password/password-v2.html',
                        controller: 'PasswordV2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('password');
                                return $translate.refresh();
                            }]
                            // ,
                            // entity: ['UserProfileQuery', function (UserProfileQuery) {
                            //     return UserProfileQuery.getCurrentPersonInfo().query();
                            // }]
                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        $state.go('supplierPanel-v2.more');

                    }, function () {
                        $state.go('supplierPanel-v2.more');
                    });
                }]

            })
            //report
            .state('supplierPanel-v2.reportExport', {
                parent: 'supplierPanel-v2',
                url: '/reportExport',
                data: {
                    authorities: ['ROLE_REPORT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.reports'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/reports/report-export-v2.html',
                        controller: 'ReportExportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('reportExport');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.reportExport.orderbag_list_by_service', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/orderbag_list_by_service',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/orderbag_list_by_service/orderbag_list_by_service.html',
                        controller: 'OrderbagListByServiceController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.orderbag_list_by_service', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.financial_by_customer', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/financial_by_customer',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/financial_by_customer/financial_by_customer.html',
                        controller: 'FinancialByCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.financial_by_customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.reserve_list_dtail_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/reserve_list_dtail_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListDtailReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.reserve_list_summary_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/reserve_list_summary_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListSummaryReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.reserve_list_summary_with_payment_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/reserve_list_summary_with_payment_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_summary_with_payment_report/reserve_list_summary_with_payment_report.html',
                        controller: 'ReserveListSummaryWithPaymentReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.reserve_list_summary_with_payment_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.invoice_info_item_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/invoice_info_item_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/invoice_info_item_report/invoice_info_item_report.html',
                        controller: 'InvoiceInfoItemReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.invoice_info_item_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.sum_of_reserve_count', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/sum_of_reserve_count',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/sum_of_reserve_count/sum_of_reserve_count.html',
                        controller: 'SumOfReserveCountController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.sum_of_reserve_count', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.company_customer_form_data_report', {
                parent: 'supplierPanel-v2',
                url: '/company_customer_form_data_report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.invoiceInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/reports/company-customer-form-data-report/company-customer-form-data-report.html',
                        controller: 'CompanyCustomerFormDataReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('companyCustomer');
                        // $translatePartialLoader.addPart('companyCustomerFormData');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.reportExport.company_customer_form_data_report.print', {
                parent: 'supplierPanel-v2.reportExport.company_customer_form_data_report',
                url: '/company-customer-form-data/print/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reports/company-customer-form-data-report/print-company-customer-form-data.html',
                        controller: 'PrintCompanyCustomerFormDataController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomerFormDataReportCustom', '$stateParams', function (CompanyCustomerFormDataReportCustom, $stateParams) {

                        return CompanyCustomerFormDataReportCustom.getCompanyCustomerFormDataById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.reportExport.company_form_data_list', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/company_form_data_list',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/company_form_data_list/company_form_data_list.html',
                        controller: 'CompanyFormDataListController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.company_form_data_list', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //.............
            //companyPaymentLog
            .state('supplierPanel-v2.companyPaymentLogList', {
                parent: 'supplierPanel-v2',
                url: '/companyPaymentLog?size&filterQuery&query',
                data: {
                    // authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-list-v2.html',
                        controller: 'CompanyPaymentLogListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyAllPaymentLogList', {
                parent: 'supplierPanel-v2',
                url: '/companyAllPaymentLog',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-all-payment-log-list-v2.html',
                        controller: 'CompanyAllPaymentLogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
             .state('supplierPanel-v2.companyApprovalPaymentLogList', {
                parent: 'supplierPanel-v2',
                url: '/companyApprovalPaymentLog?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-approval-payment-log-list.html',
                        controller: 'CompanyApprovalPaymentLogList',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyApprovalPaymentLogListV2', {
                parent: 'supplierPanel-v2',
                url: '/companyApprovalPaymentLog-v2?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-approval-payment-log-list-v2.html',
                        controller: 'CompanyApprovalPaymentLogListV2'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.accountClearingList', {
                parent: 'supplierPanel-v2',
                url: '/accountClearingList',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-requests-v2.html',
                        controller: 'AccountClearingRequestsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.accountClearingDetail', {
                parent: 'supplierPanel-v2',
                url: '/accountClearingDetail/detail/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail-v2.html',
                        controller: 'AccountClearingRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel-v2.setting', {
                parent: 'supplierPanel-v2',
                url: '/setting',
                data: {
                    authorities: ['ROLE_COMPANY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.setting'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/setting/setting-v2.html',
                        controller: 'SettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('settingInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyInfo', {
                parent: 'supplierPanel-v2',
                url: '/companyInfo',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company/company-info-v2.html',
                        controller: 'CompanyInfoV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                    //entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                    //    return Company.get({id: $stateParams.id}).$promise;
                    //}]
                }
            })
            .state('supplierPanel-v2.companyWorkingTimes', {
                parent: 'supplierPanel-v2',
                url: '/companyWorkingTimes',

                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling-v2.html',
                        controller: 'CompanySchedulingV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('scheduleInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyLocationInfo', {
                parent: 'supplierPanel-v2',
                url: '/companyLocationInfo',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-info/company-location-info-v2.html',
                        controller: 'CompanyLocationInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyInfoQuery', function ($stateParams, CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }]

                }
            })
            .state('supplierPanel-v2.companySocialNetworkInfo', {
                parent: 'supplierPanel-v2',
                url: '/companySocialNetworkInfo?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySocialNetworkInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-infos-v2.html',
                        controller: 'CompanySocialNetworkInfoControllerCustom',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('companySocialNetworkInfo');
                        $translatePartialLoader.addPart('socialNetworkType');
                        $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('supplierPanel-v2.companySettingInfo', {
                parent: 'supplierPanel-v2',
                url: '/companySettingInfo/:settingFormSection',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/setting-info/company-setting-info-v2.html',
                        controller: 'CompanySettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }]
                }
            })
             .state('supplierPanel-v2.companyBankAccountInfo', {
                parent: 'supplierPanel-v2',
                url: '/companyBankAccountInfo',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/company-bank-account-info-v2.html',
                        controller: 'CompanyBankAccountInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyBankAccountInfoV2', {
                parent: 'supplierPanel-v2',
                url: '/companyBankAccountInfoV2',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/company-bank-account-info-v3.html',
                        controller: 'CompanyBankAccountInfoControllerV3',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyCustomSetting', {
                parent: 'supplierPanel-v2',
                url: '/companyCustomSetting',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customSetting.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customSetting/custom-setting-v2.html',
                        controller: 'CustomSettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['CompanyInfoQuery', function (CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customSetting');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            //coupon
            .state('supplierPanel-v2.couponList', {
                parent: 'supplierPanel-v2',
                url: '/coupon-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.coupon.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupons-list-v2.html',
                        controller: 'CouponListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newCoupon', {
                parent: 'supplierPanel-v2',
                url: '/coupon-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/coupon/coupon-v2.html',
                        controller: 'CouponV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        $translatePartialLoader.addPart('amountTypes');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editCoupon', {
                parent: 'supplierPanel-v2',
                url: '/coupon-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/coupon/coupon-v2.html',
                        controller: 'CouponV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('amountTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Coupon', '$stateParams', function (Coupon, $stateParams) {

                        return Coupon.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.deleteCoupon', {
                parent: 'supplierPanel-v2.editCoupon',
                url: '/coupon-list/delete/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-delete-dialog.html',
                        controller: 'CouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Coupon', function (Coupon) {
                                return Coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.couponList', null, {reload: 'coupon'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteCouponFromList', {
                parent: 'supplierPanel-v2.couponList',
                url: '/coupon-list/delete/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-delete-dialog.html',
                        controller: 'CouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Coupon', function (Coupon) {
                                return Coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^');
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //.............

            //reserve limit
            .state('supplierPanel-v2.reserveLimitList', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limit-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.reserveLimit.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limits-list-v2.html',
                        controller: 'ReserveLimitsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        $translatePartialLoader.addPart('reserveLimitPeriod');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.editReserveLimit', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limit-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit-v2.html',
                        controller: 'ReserveLimitV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        $translatePartialLoader.addPart('reserveLimitPeriod');
                        return $translate.refresh();
                    }],
                    entity: ['ReserveLimit', '$stateParams', function (ReserveLimit, $stateParams) {

                        return ReserveLimit.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.newReserveLimit', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limit-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit-v2.html',
                        controller: 'ReserveLimitV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        $translatePartialLoader.addPart('reserveLimitPeriod');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.deleteReserveLimit', {
                parent: 'supplierPanel-v2.reserveLimitList',
                url: '/reserve-limit-ist/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/reserve-limit/reserve-limit-delete-dialog-v2.html',
                        controller: 'ReserveLimitDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ReserveLimit', function (ReserveLimit) {
                                return ReserveLimit.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.reserveLimitList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //...................
            // dashboard onBoarding
            .state('supplierPanel-v2.dashboard.companySettingInfo', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/companySettingInfo/:settingFormSection',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/setting-info/company-setting-info-v2.html',
                        controller: 'CompanySettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard.newServiceItem', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/serviceItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
                        controller: 'ServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$rootScope', '$stateParams', 'ServiceItem', function ($rootScope, $stateParams, ServiceItem) {
                        return {};
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard.newCompanyServant', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/newCompanyServant',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
                        controller: 'CompanyServantsV2DialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
                // });
            })
            .state('supplierPanel-v2.dashboard.companyWorkingTimes', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/companyWorkingTimes',

                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling-v2.html',
                        controller: 'CompanySchedulingV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('scheduleInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard.newReserve', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
                        controller: 'ReserveV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            //......................

            // CustomerGroup
            .state('supplierPanel-v2.customerGroupList', {
                parent: 'supplierPanel-v2',
                url: '/customer-group-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customerGroup.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-groups-list-v2.html',
                        controller: 'CustomerGroupListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newCustomerGroup', {
                parent: 'supplierPanel-v2',
                url: '/customer-group-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer-group/customer-group-v2.html',
                        controller: 'CustomerGroupV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editCustomerGroup', {
                parent: 'supplierPanel-v2',
                url: '/customer-group/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer-group/customer-group-v2.html',
                        controller: 'CustomerGroupV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CustomerGroup', '$stateParams', function (CustomerGroup, $stateParams) {

                        return CustomerGroup.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.newCustomerGroup_default', {
                parent: 'supplierPanel-v2',
                url: '/customer-group-list/new_default',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer-group/customer-group-v2.html',
                        controller: 'CustomerGroupV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null,
                            groupName: "DEFAULT_GROUP",
                            "accessToAllServices": true
                        };
                    }
                }
            })

            // InvoiceInfo
            .state('supplierPanel-v2.invoiceInfoList', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list?pageSize&sort&searchText&filterQuery',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.invoiceInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/invoice-info/invoice-infos.html',
                        controller: 'InvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                 params: {
                    pageSize: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    searchText: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog-v2.html',
                        controller: 'InvoiceInfoDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');
                        $translatePartialLoader.addPart('serviceAddOn');

                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog-v2.html',
                        controller: 'InvoiceInfoDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.invoiceInfoDetail', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/detail/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-actions-v2.html',
                        controller: 'InvoiceInfoActionsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.deleteInvoiceInfo', {
                parent: 'supplierPanel-v2.invoiceInfoList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.invoiceInfoList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.editInvoiceInfo.delete', {
                parent: 'supplierPanel-v2.editInvoiceInfo',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.invoiceInfoList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.invoiceInfoDetail.delete', {
                parent: 'supplierPanel-v2.invoiceInfoDetail',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.invoiceInfoList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.printInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/print/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/print-invoice-info.html',
                        controller: 'PrintInvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.invoiceInfoDetail.editCompanyCustomer', {
                parent: 'supplierPanel-v2.invoiceInfoDetail',
                url: '/editCompanyCustomer/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            //ServiceAddOn
            .state('supplierPanel-v2.serviceAddOnList', {
                parent: 'supplierPanel-v2',
                url: '/service-add-on-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.service-add-on.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-add-on/service-add-on-list.html',
                        controller: 'ServiceAddOnListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('serviceAddOn');
                        $translatePartialLoader.addPart('serviceAddOnStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newServiceAddOn', {
                parent: 'supplierPanel-v2',
                url: '/service-add-on/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-add-on/service-add-on.html',
                        controller: 'ServiceAddOnController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceAddOn');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceAddOnStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editServiceAddOn', {
                parent: 'supplierPanel-v2',
                url: '/service-add-on-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-add-on/service-add-on.html',
                        controller: 'ServiceAddOnController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceAddOn');
                        $translatePartialLoader.addPart('serviceAddOnStatus');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['ServiceAddOn', '$stateParams', function (ServiceAddOn, $stateParams) {

                        return ServiceAddOn.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            //.............

            //Marketing Campaign
            .state('supplierPanel-v2.marketingCampaignList', {
                parent: 'supplierPanel-v2',
                url: '/marketing-campaign-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketingCampaign.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-list.html',
                        controller: 'MarketingCampaignsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }],
                    smsPanel: ['$stateParams', function ($stateParams) {
                        return false;
                    }]
                }
            })

            .state('supplierPanel-v2.smsPanelMarketingCampaignList', {
                parent: 'supplierPanel-v2',
                url: '/sms-panel-marketing-campaign-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketingCampaign.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-list.html',
                        controller: 'MarketingCampaignsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }],
                    smsPanel: ['$stateParams', function ($stateParams) {
                        return true;
                    }]
                }
            })

            .state('supplierPanel-v2.editMarketingCampaign', {
                parent: 'supplierPanel-v2',
                url: '/marketing-campaign-list/edit/{id}?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign.html',
                        controller: 'MarketingCampaignController',
                        controllerAs: 'vm',
                    }
                },
                params: {
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('customerSegment');
                        return $translate.refresh();
                    }],
                    entity: ['MarketingCampaign', '$stateParams', function (MarketingCampaign, $stateParams) {
                        return MarketingCampaign.get({id: $stateParams.id}).$promise;
                    }],
                     smsPanel: ['$stateParams', function ($stateParams) {
                        return $stateParams.smsPanel === true || $stateParams.smsPanel === 'true';
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.newMarketingCampaign', {
                parent: 'supplierPanel-v2',
                url: '/marketing-campaign-list/new?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign.html',
                        controller: 'MarketingCampaignController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('customerSegment');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    },
                    smsPanel: ['$stateParams', function ($stateParams) {
                        return $stateParams.smsPanel === true || $stateParams.smsPanel === 'true';
                    }]
                }
            })
            .state('supplierPanel-v2.deleteMarketingCampaign', {
                parent: 'supplierPanel-v2.marketingCampaignList',
                url: '/marketing-campaign-list/{id}/delete?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        if($stateParams.smsPanel === true || $stateParams.smsPanel === 'true')
                            $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                        else
                            $state.go('supplierPanel-v2.marketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel-v2.deleteSmsPanelMarketingCampaign', {
                parent: 'supplierPanel-v2.smsPanelMarketingCampaignList',
                url: '/sms-panel-marketing-campaign-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel-v2.deleteMarketingCampaignFromModal', {
                parent: 'supplierPanel-v2.editMarketingCampaign',
                url: '/deleteMarketingCampaign/{id}/delete?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                            debugger;
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        if($stateParams.smsPanel === true || $stateParams.smsPanel === 'true')
                            $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                        else
                            $state.go('supplierPanel-v2.marketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteSmsPanelMarketingCampaignFromModal', {
                parent: 'supplierPanel-v2.editMarketingCampaign',
                url: '/deleteSmsPanelMarketingCampaign/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                            debugger;
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //..........................

            //Commission
            .state('supplierPanel-v2.commissionList', {
                parent: 'supplierPanel-v2',
                url: '/commission-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.commission.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/commission/commission-list.html',
                        controller: 'CommissionListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.editCommission', {
                parent: 'supplierPanel-v2',
                url: '/commission-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission/commission.html',
                        controller: 'CommissionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('commissionType');
                        $translatePartialLoader.addPart('commissionItemType');
                        return $translate.refresh();
                    }],
                    entity: ['Commission', '$stateParams', function (Commission, $stateParams) {
                        return Commission.get({id: $stateParams.id}).$promise;
                    }]
                }

            })
            .state('supplierPanel-v2.newCommission', {
                parent: 'supplierPanel-v2',
                url: '/commission-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission/commission.html',
                        controller: 'CommissionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('commissionType');
                        $translatePartialLoader.addPart('commissionItemType');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.deleteCommission', {
                parent: 'supplierPanel-v2.commissionList',
                url: '/commission-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission/commission-delete-dialog.html',
                        controller: 'CommissionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Commission', function (Commission) {
                                return Commission.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.commissionList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.calculateCommission', {
                parent: 'supplierPanel-v2',
                url: '/commission-list/calculate-commission',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission/calculate-commission.html',
                        controller: 'CalculateCommissionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('commissionType');
                        $translatePartialLoader.addPart('commissionItemType');
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.editCommission.delete', {
                parent: 'supplierPanel-v2.editCommission',
                url: '/commission-list/edit/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission/commission-delete-dialog.html',
                        controller: 'CommissionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Commission', function (Commission) {
                                return Commission.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.commissionList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //..........................
            .state('supplierPanel-v2.confirmSubscription', {
                parent: 'supplierPanel-v2',
                url: '/confirmSubscription?Authority&Status',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/confirm-subscription.html',
                        controller: 'ConfirmSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'CompanySubscriptionStatusCustom', 'Auth', '$state', 'CompanySession', function ($stateParams, CompanySubscriptionStatusCustom, Auth, $state, CompanySession) {

                        CompanySession.resetCompanySession();

                        var refid = getParameterByName('refid');
                        var clientrefid = getParameterByName('clientrefid');

                        //jibimo
                        var trx = getParameterByName('trx');
                        var status = getParameterByName('status');
                        var state_code = getParameterByName('state_code');


                        if ($stateParams.Authority != '' && $stateParams.Status == 'OK') {


                            return CompanySubscriptionStatusCustom.confirmSubscription($stateParams.Authority).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });

                        } else if (refid && clientrefid && refid > 1) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid, refid).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });
                        } else if (trx && status && state_code && status == 1 && state_code == 99) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(trx).query(function () {
                            });
                        }
                        //zify
                        else if (clientrefid) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid).query(function () {

                            });

                        } else {
                            return null;
                        }


                    }]
                }
            })

            .state('supplierPanel-v2.testServices', {
                parent: 'supplierPanel-v2',
                url: '/testServices',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/services/testServices/test-services.html',
                        controller: 'TestServiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    //translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //    return $translate.refresh();
                    //}]
                }
            })
             .state('supplierPanel-v2.legal_actualInformation', {
                            parent: 'supplierPanel-v2',
                            url: '/legal_actual-information',
                            data: {
                                 authorities: ['ROLE_USER'],
                                 pageTitle: 'global.menu.account.legal_actual'
                            },
                          onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                               $rootScope.modalInstance = $uibModal.open({
                                    templateUrl: 'app/legal-actual-info/legal-actual-info.html',
                                    controller: 'LegalActualInfoController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    windowClass: 'pl-modal',
                                    resolve: {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                                            $translatePartialLoader.addPart('legal_actualInformation');
                                            return $translate.refresh();
                                        }]
//                                         ,
//                                         entity: ['UserProfileQuery', function (UserProfileQuery) {
//                                             return UserProfileQuery.getCurrentPersonInfo().query();
//                                         }]
                                    }
                            })
                            $rootScope.modalInstance.result.then(function () {
                                 if ($rootScope.fromState.name)
                                    $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
                                else
                                    $state.go('supplierPanel-v2.dashboard');

                            }, function () {
                                 if ($rootScope.fromState.name)
                                    $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
                                else
                                    $state.go('supplierPanel-v2.dashboard');
                            });
                          }]

                        })
            .state('supplierPanel-v2.companyBlogs', {
                parent: 'supplierPanel-v2',
                url: '/companyBlogs?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'بلاگ ها'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-blogs/company-blogs.html',
                        controller: 'CompanyBlogs'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


             .state('supplierPanel-v2.baseComponentsShowCase', {
                parent: 'supplierPanel-v2',
                url: '/base-components-showcase',
                data: {
                    pageTitle: 'base components showcase'
                },
               views: {
                    'subcontent': {
                        templateUrl: 'app/entities/base-components-showcase/base-components-showcase.html',
                        controller: 'BaseComponentsShowCase',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.reserveServices', {
                parent: 'supplierPanel-v2',
                url: '/reserve-services',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'خدمات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-services/reserve-services.html',
                        controller: 'ReserveServicesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.eventServices', {
                parent: 'supplierPanel-v2',
                url: '/event-services',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'خدمات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-services/event-services.html',
                        controller: 'EventServicesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.serviceCategories', {
                parent: 'supplierPanel-v2',
                url: '/service-categories',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'خدمات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-categories/service-categories.html',
                        controller: 'ServiceCategoriesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.metaTags', {
                parent: 'supplierPanel-v2',
                url: '/meta-tags?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'متاتگ ها'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/meta-tag/meta-tags-v2.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.formBuilder', {
                parent: 'supplierPanel-v2',
                url: '/form-builder?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'فرم بیلدر'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/form-builder/form-builder.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.companyBlogCategories', {
                parent: 'supplierPanel-v2',
                url: '/blog-categories?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'دسته بندی بلاگ'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-blogs/company-blog-categories.html',
                        controller: 'BlogsCategories'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.coupons', {
                parent: 'supplierPanel-v2',
                url: '/coupons?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'کوپن ها'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupons-list-v3.html',
                        controller: 'CouponsList',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
             .state('supplierPanel-v2.reports', {
                parent: 'supplierPanel-v2',
                url: '/reports?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'گزارشات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reports/reports.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.reserveLimits', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limits?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'محدودیت های رزرو'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limits.html',
                        controller: 'ReserveLimitsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.dynamicRules', {
                parent: 'supplierPanel-v2',
                url: '/dynamic-rules?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'لیست قوانین'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/dynamic-rules/dynamic-rules.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.invoicePrint', {
                parent: 'supplierPanel-v2',
                url: '/invoice-print',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'پرینت فاکتور'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/print-invoice.html',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccessDeniedV2Controller', AccessDeniedV2Controller);

    AccessDeniedV2Controller.$inject = ['$state', '$scope', '$rootScope', 'Auth'];

    function AccessDeniedV2Controller($state, $scope, $rootScope, Auth) {
        var vm = this;

        vm.goToPrevState = function () {
            var prev = $rootScope.fromState;
            if (prev && prev.name) {
                if ($rootScope.fromStateParams && $rootScope.fromStateParams.id)
                    $state.go(prev, {id: $rootScope.fromStateParams.id});
                else
                    $state.go(prev.name);
            } else {
                $state.go('home');
            }
        }

    }
})();
;
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function removeSignFromUrl() {
    var url = window.location.href;
    if(url.indexOf("?#")> 0)
    {
        url = url.replace("?#","#");
        window.location.href = url;
        return;
    }

    var qIndex = url.indexOf("?");
    var sharpIndex = url.indexOf("#");
    if(qIndex>-1 && qIndex < sharpIndex)
    {
        var first = url.substring(0,qIndex);
        var end = url.substring(sharpIndex,url.length);
        var newUrl = first.concat(end);
        window.location.href = newUrl;
        return;
    }

}


(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
            .state('supplierPanel', {
                parent: 'app',
                url: '/supplierPanel',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/supplier/supplierPanel.html',

                        controller: 'SupplierPanelController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyLocationInfo', {
                parent: 'supplierPanel',
                url: '/companyLocationInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/location-info/company-location-info.html',
                        controller: 'CompanyLocationInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyInfoQuery', function ($stateParams, CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }]

                }
            })
            .state('supplierPanel.companyWorkingTimes', {
                parent: 'supplierPanel',
                url: '/companyWorkingTimes',

                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling.html',
                        controller: 'CompanySchedulingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servant');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyAgreementInfo', {
                parent: 'supplierPanel',
                url: '/companyAgreementInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/agreement-info/company-agreement-info.html',
                        controller: 'CompanyAgreementInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agreementInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companySettingInfo', {
                parent: 'supplierPanel',
                url: '/companySettingInfo/:settingFormSection',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/setting-info/company-setting-info.html',
                        controller: 'CompanySettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyBankAccountInfo', {
                parent: 'supplierPanel',
                url: '/companyBankAccountInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/bank-account-info/company-bank-account-info.html',
                        controller: 'CompanyBankAccountInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companySocialNetworkInfo', {
                parent: 'supplierPanel',
                url: '/companySocialNetworkInfo?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySocialNetworkInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-infos.html',
                        controller: 'CompanySocialNetworkInfoControllerCustom',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('companySocialNetworkInfo');
                        $translatePartialLoader.addPart('socialNetworkType');
                        $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('supplierPanel.companyCustomSetting', {
                parent: 'supplierPanel',
                url: '/companyCustomSetting',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customSetting.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customSetting/custom-setting.html',
                        controller: 'CustomSettingController',
                        controllerAs: 'vm'
                    }
                },
                // params: {
                //     page: {
                //         value: '1',
                //         squash: true
                //     },
                //     sort: {
                //         value: 'id,asc',
                //         squash: true
                //     },
                //     search: null
                // },
                resolve: {
                    // pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //     return {
                    //         page: PaginationUtil.parsePage($stateParams.page),
                    //         sort: $stateParams.sort,
                    //         predicate: PaginationUtil.parsePredicate($stateParams.sort),
                    //         ascending: PaginationUtil.parseAscending($stateParams.sort),
                    //         search: $stateParams.search
                    //     };
                    // }],
                    entity: ['CompanyInfoQuery', function (CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customSetting');
                         $translatePartialLoader.addPart('company');
                        // $translatePartialLoader.addPart('socialNetworkType');
                        // $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.resourcesListForm', {
                parent: 'supplierPanel',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.resourcesListForm'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/resources/resources-list-form.html',
                        controller: 'ResourcesListFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('resources');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.resources', {
                parent: 'supplierPanel',
                url: '/resources',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.resources'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/resources/resources.html',
                        controller: 'ResourcesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('resources');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companySocialNetworkInfo.new', {
                parent: 'supplierPanel.companySocialNetworkInfo',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-info-dialog.html',
                        controller: 'CompanySocialNetworkInfoDialogControllerCustom',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    orderNumber: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companySocialNetworkInfo', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.companySocialNetworkInfo');
                    });
                }]
            })
            .state('supplierPanel.companySocialNetworkInfo.edit', {
                parent: 'supplierPanel.companySocialNetworkInfo',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-info-dialog.html',
                        controller: 'CompanySocialNetworkInfoDialogControllerCustom',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanySocialNetworkInfo', function (CompanySocialNetworkInfo) {
                                return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companySocialNetworkInfo', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.companySocialNetworkInfo.delete', {
                parent: 'supplierPanel.companySocialNetworkInfo',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-info-delete-dialog.html',
                        controller: 'CompanySocialNetworkInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanySocialNetworkInfo', function (CompanySocialNetworkInfo) {
                                return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companySocialNetworkInfo', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.generalServiceItem', {
                parent: 'supplierPanel',
                url: '/generalServiceItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item/general-service-item.html',
                        controller: 'GeneralServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.generalServiceItemV2', {
                parent: 'supplierPanel',
                url: '/generalServiceItemV2/{id}',
                data: {
                    authorities: []

                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/general-service-item-v2.html',
                        controller: 'GeneralServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.generalServiceItemEventV2', {
                parent: 'supplierPanel',
                url: '/generalServiceItemEventV2/{id}',
                data: {
                    authorities: []

                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/general-service-item-v2.html',
                        controller: 'GeneralServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {
                                    serviceMode: 'EVENT',
                                    id: null
                                }
                    }]
                }
            })
            .state('supplierPanel.generalServiceItem.view', {
                parent: 'supplierPanel',
                url: '/generalServiceItem/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item/general-service-item.html',
                        controller: 'GeneralServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                        return ServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel.generalServiceItemV2.view', {
                parent: 'supplierPanel',
                url: '/generalServiceItemV2/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/general-service-item.html',
                        controller: 'GeneralServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                        return ServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel.serviceItemListV2.delete', {
                parent: 'supplierPanel.serviceItemListV2',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemEventListV2.delete', {
                parent: 'supplierPanel.serviceItemEventListV2',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemEventListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemListV2.copy', {
                parent: 'supplierPanel.serviceItemListV2',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemEventListV2.copy', {
                parent: 'supplierPanel.serviceItemEventListV2',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemEventListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemList', {
                parent: 'supplierPanel',
                url: '/serviceItemList',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item/service-item-list.html',
                        controller: 'ServiceItemListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.serviceItemListV2', {
                parent: 'supplierPanel',
                url: '/serviceItemListV2' + '-' + ':type',
                data: {
                    authorities: ['ROLE_CATEGORY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servicelist'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/service-item-list-old.html',
                        controller: 'ServiceItemListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel.serviceItemEventListV2', {
                parent: 'supplierPanel',
                url: '/serviceItemEventListV2' + '-' + ':type',
                data: {
                    authorities: ['ROLE_EVENT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servicelist'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/service-item-event-list-v2.html',
                        controller: 'ServiceItemEventListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel.companyServiceCategoryList', {
                parent: 'supplierPanel',
                url: '/company-service-category-list',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-category/company-service-category-list.html',
                        controller: 'CompanyServiceCategoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCategory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyServiceCategoryList.new', {
                parent: 'supplierPanel.companyServiceCategoryList',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/company-service-category-dialog.html',
                        controller: 'CompanyServiceCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    categoryName: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.companyServiceCategoryList');
                    });
                }]
            })
            .state('supplierPanel.companyServiceCategoryList.edit', {
                parent: 'supplierPanel.companyServiceCategoryList',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/company-service-category-dialog.html',
                        controller: 'CompanyServiceCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.companyServiceCategoryList.delete', {
                parent: 'supplierPanel.companyServiceCategoryList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.companyInfo', {
                parent: 'supplierPanel',
                url: '/companyInfo',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company/company-info.html',
                        controller: 'CompanyInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                    //entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                    //    return Company.get({id: $stateParams.id}).$promise;
                    //}]
                }
            })
            .state('supplierPanel.orderBagTest', {
                parent: 'supplierPanel',
                url: '/orderBagTest',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-test.html',
                        controller: 'OrderBagServiceItemTestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'OrderBagServiceItemCustom', function ($stateParams, OrderBagServiceItemCustom) {
                        //return OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities(3633).query();
                        return {
                            status: 0,
                            subtotalServicePrice: 1,
                            subtotalOaptionPrice: 1,
                            subtotalVAT: 1,
                            subtotalDiscount: 1,
                            totalRowPrice: 1,
                            id: null,
                            orderBagServiceItemDtail: [],
                            serviceItemId: 1427

                        };
                    }]
                    ,
                    timeSession: ['ServiceTimeSession', function (ServiceTimeSession) {
                        return ServiceTimeSession.get({id: 1651}).$promise;
                    }
                    ]
                }
            })
            .state('supplierPanel.orderBag', {
                parent: 'supplierPanel',
                url: '/orderBag',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-list.html',
                        controller: 'OrderBagServiceItemListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.orderBagTest.edit', {
                parent: 'supplierPanel',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-test.html',
                        controller: 'OrderBagServiceItemTestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagServiceItemCustom', function ($stateParams, OrderBagServiceItemCustom) {
                        return OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities($stateParams.id).query();
                    }]
                    ,
                    timeSession: ['ServiceTimeSession', function (ServiceTimeSession) {
                        return ServiceTimeSession.get({id: 1651}).$promise;
                    }
                    ]
                }
            })
            .state('supplierPanel.testServices', {
                parent: 'supplierPanel',
                url: '/testServices',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/services/testServices/test-services.html',
                        controller: 'TestServiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    //translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //    return $translate.refresh();
                    //}]
                }
            })
            .state('admin-test-services', {
                parent: 'entity',
                url: '/admin-test-services',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'admin-test-services'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/services/testServices/admin-test-services.html',
                        controller: 'TestServiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel.orderBagList', {
                parent: 'supplierPanel',
                url: '/orderBagList?page&sort&search',
                data: {
                    authorities: ['ROLE_USER']
                    //pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/order-bag-list.html',
                        controller: 'OrderBagListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadOnHand'
                        };
                    }

                }
            })
            .state('supplierPanel.reserveList', {
                parent: 'supplierPanel',
                url: '/reserveList?page&sort&search',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/reserve-list.html',
                        controller: 'ReserveListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadOnHand'
                        };
                    }

                }
            })
            .state('supplierPanel.orderBagListAll', {
                parent: 'supplierPanel',
                url: '/orderBagListAll?page&sort&search',
                data: {
                    authorities: ['ROLE_USER']
                    //pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/order-bag-list.html',
                        controller: 'OrderBagListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadAll'
                        };
                    }
                }
            })
            .state('supplierPanel.orderBagWithParameter', {
                parent: 'supplierPanel',
                url: '/orderBagWithParameter/{serviceItemId}/{timeSessionId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })
            .state('supplierPanel.orderBagWithDateRangeParameter', {
                parent: 'supplierPanel',
                url: '/orderBagWithParameter/{serviceItemId}/{start_date}/{end_date}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })
            .state('supplierPanel.reserve', {
                parent: 'supplierPanel',
                url: '/reserve/{serviceItemId}/{start_date}/{end_date}/{servantId}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader','OrderBagCustom', function ($translate, $translatePartialLoader,OrderBagCustom) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            .state('supplierPanel.orderBagWithCustomerParameter', {
                parent: 'supplierPanel',
                url: '/orderBagWithCustomerParameter/{customerId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })


            .state('supplierPanel.scheduling', {
                parent: 'supplierPanel',
                url: '/scheduling/{id}',

                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/schedule-info/scheduling/scheduling.html',
                        controller: 'SchedulingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.schedulingv2', {
                parent: 'supplierPanel',
                url: '/schedulingv2/{id}',

                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/schedule-info/scheduling/scheduling-v2.html',
                        controller: 'SchedulingV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            // .state('supplierPanel.companyCustomer', {
            //     parent: 'supplierPanel',
            //     url: '/company-customer-list',
            //     data: {
            //         authorities: ['ROLE_USER'],
            //         pageTitle: 'tikonApp.companyCustomer.home.title'
            //     },
            //     views: {
            //         'subcontent': {
            //             templateUrl: 'app/entities/company-customer/company-customers-list.html',
            //             controller: 'CompanyCustomerListController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('companyCustomer');
            //             $translatePartialLoader.addPart('customer');
            //             $translatePartialLoader.addPart('customerStatus');
            //             $translatePartialLoader.addPart('personInfo');
            //             $translatePartialLoader.addPart('global');
            //             $translatePartialLoader.addPart('scheduleType');
            //
            //             return $translate.refresh();
            //         }]
            //     }
            // })

            .state('supplierPanel.companyCustomer', {
                parent: 'supplierPanel',
                url: '/company-customer-list',
                data: {
                    authorities: ['ROLE_CUSTOMER_MANAGER'],
                    pageTitle: 'tikonApp.companyCustomer.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers-list.html',
                        controller: 'CompanyCustomerListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('customerStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleType');

                        return $translate.refresh();
                    }]
                }
            })



            .state('supplierPanel.deleteCompanyCustomer', {
                parent: 'supplierPanel.companyCustomer',
                url: '/company-customer-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyCustomer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.companyPaymentLogList', {
                parent: 'supplierPanel',
                url: '/companyPaymentLog',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-list.html',
                        controller: 'CompanyPaymentLogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyAllPaymentLogList', {
                parent: 'supplierPanel',
                url: '/companyAllPaymentLog',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-all-payment-log-list.html',
                        controller: 'CompanyAllPaymentLogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.dashboard', {
                parent: 'supplierPanel',
                url: '/dashboard',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'supplierPanel.sideMenu.dashboard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/main/report.main_dashboard.html',
                        controller: 'MainDashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('newsType');
                        removeSignFromUrl();
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.setting', {
                parent: 'supplierPanel',
                url: '/setting',
                data: {
                    authorities: ['ROLE_COMPANY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.setting'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/setting/setting.html',
                        controller: 'SettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('settingInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.partialFormPersonInfo', {
                parent: 'supplierPanel',
                url: '/userProfile',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.userProfile'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/userprofile/user-profiles.html',
                        controller: 'UserProfileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {


                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['UserProfileQuery', function (UserProfileQuery) {
                        return UserProfileQuery.getCurrentPersonInfo().query();
                    }]
                }

            })
            .state('supplierPanel.password', {
                parent: 'supplierPanel',
                url: '/password',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.password'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/account/password/password.html',
                        controller: 'PasswordController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {


                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }]
                    // ,
                    // entity: ['UserProfileQuery', function (UserProfileQuery) {
                    //     return UserProfileQuery.getCurrentPersonInfo().query();
                    // }]
                }

            })

            .state('supplierPanel.companySubscriptionStatus', {
                parent: 'supplierPanel',
                url: '/companySubscriptionStatus',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierpanel.sideMenu.companySubscriptionStatus'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-view.html',
                        controller: 'CompanySubscriptionStatusViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel.companySmsPackageStatus', {
                parent: 'supplierPanel',
                url: '/companySmsPackageStatus',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.sms_package_status'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-sms-package-status-view.html',
                        controller: 'CompanySmsPackageStatusViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel.purchaseSubscription', {
                parent: 'supplierPanel',
                url: '/{id}/purchaseSubscription',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/purchase-subscription.html',
                        controller: 'PurchaseSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('supplierCoupon');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {

                        if ($stateParams.id != '')

                        return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.confirmSubscription', {
                parent: 'supplierPanel',
                url: '/confirmSubscription?Authority&Status',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/confirm-subscription.html',
                        controller: 'ConfirmSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'CompanySubscriptionStatusCustom', 'Auth', '$state', function ($stateParams, CompanySubscriptionStatusCustom, Auth, $state) {


                        var refid=getParameterByName('refid');
                        var clientrefid=getParameterByName('clientrefid');


                        //jibimo
                        var trx=getParameterByName('trx');
                        var status=getParameterByName('status');
                        var state_code=getParameterByName('state_code');

                        if ($stateParams.Authority != '' && $stateParams.Status == 'OK') {


                            return CompanySubscriptionStatusCustom.confirmSubscription($stateParams.Authority).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });

                        }
                        else if(refid && clientrefid && refid>1)
                        {
                            return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid,refid).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });
                        }
                        else if(trx && status && state_code && status ==1 && state_code == 99 ) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(trx).query(function () {
                            });
                        }
                        else{
                            return null;
                        }


                    }]
                }
            })
            .state('supplierPanel.companySubscriptionStatusV2', {
                parent: 'supplierPanel',
                url: '/companySubscriptionStatusV2',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.subscription'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-view-v2.html',
                        controller: 'CompanySubscriptionStatusViewV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('packageFeatureList');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        // removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel.companySubscriptionStatusEvent', {
                parent: 'supplierPanel',
                url: '/companySubscriptionStatusEvent',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierpanel.sideMenu.companySubscriptionStatus'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-view-event.html',
                        controller: 'CompanySubscriptionStatusViewEventController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })

            .state('supplierPanel.agentCompanyList', {
                parent: 'supplierPanel',
                url: '/agentCompanyList',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/agent-request/company-list.html',
                        controller: 'AgentCompanyListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('agentRequest');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.agentCompanyList.new', {
                parent: 'supplierPanel.agentCompanyList',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-dialog.html',
                        controller: 'AgentRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    agentRequestType: null,
                                    createDate: null,
                                    requestMessage: null,
                                    suggestedCommision: null,
                                    replyDate: null,
                                    replyMessage: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.agentCompanyList', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.agentCompanyList');
                    });
                }]
            })
            .state('supplierPanel.agentSupplierAccessList', {
                parent: 'supplierPanel',
                url: '/agentSupplierAccessList',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/agent-access-info/set-agent-access-infos.html',
                        controller: 'SetAgentAccessInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('agentSupplierContract');
                        $translatePartialLoader.addPart('agentAccessInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.agentSupplierAccessList.mapServices', {
                parent: 'supplierPanel.agentSupplierAccessList',
                url: '/mapServices/{id}',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'AgentSupplierContractCustom', function ($stateParams, $state, $uibModal, AgentSupplierContractCustom) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/upsert-agent-access-dialog.html',
                        controller: 'UpsertAgentAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {

                                return AgentSupplierContractCustom.getAgentSupplierWithAllAccessById($stateParams.id).get().$promise;
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.agentSupplierAccessList', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.agentSupplierAccessList');
                    });
                }]
            })
            .state('supplierPanel.conversationList', {
                parent: 'supplierPanel',
                url: '/conversationList',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/conversation/conversation-list.html',
                        controller: 'ConversationListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('conversation');
                        $translatePartialLoader.addPart('conversationStatusType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.conversationList.edit', {
                parent: 'supplierPanel.conversationList',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

                    $uibModal.open({
                        templateUrl: 'app/entities/conversation/conversation-custom-dialog.html',
                        controller: 'ConversationCustomDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Conversation', function (Conversation) {
                                return Conversation.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.conversationList', null, {reload: 'supplierPanel.conversationList'});
                    }, function () {
                        $state.go('supplierPanel.conversationList', null, {reload: 'supplierPanel.conversationList'});
                    });
                }]
            })
            .state('supplierPanel.timeBoard', {
                parent: 'supplierPanel',
                url: '/timeBoard',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/time-board.html',
                        controller: 'TimeBoardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.calendar', {
                parent: 'supplierPanel',
                url: '/calendar',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/book-calendar.template.html',
                        controller: 'BookCalendarController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.calendar.servantExceptionTimes', {
                parent: 'supplierPanel.calendar',
                url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal','$rootScope','Principal', function($stateParams, $state, $uibModal,$rootScope,Principal) {

                    var multiServant = true;
                    Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
                        multiServant = !has;
                    });

                    var availabilityMode = $stateParams.availabilityMode;
                    var defaultServantId = $stateParams.defaultServantId;
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
                        controller: 'ServantExceptionDurationController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('scheduleInfo');

                                return $translate.refresh();
                            }],
                            entity: (function () {
                                return {
                                    defaultServantId: defaultServantId,
                                    availabilityMode:availabilityMode,
                                    canSelectServant:multiServant

                                };
                            })

                        }
                    });


                    $rootScope.modalInstance.result.then(function() {
                        $state.go( 'supplierPanel.calendar', null, { reload: true });
                        $rootScope.modalInstance.dismiss('cancel');
                    }, function() {
                        $state.go('supplierPanel.calendar');
                    });
                }]

            })

            .state('supplierPanel.reportexport', {
                parent: 'supplierPanel',
                url: '/reportexport',
                data: {
                    authorities: ['ROLE_REPORT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.reports'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/reports/report-export.html',
                        controller: 'ReportExportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('reportExport');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.reportexport.orderbag_list_by_service', {
                parent: 'supplierPanel.reportexport',
                url: '/orderbag_list_by_service',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/orderbag_list_by_service/orderbag_list_by_service.html',
                        controller: 'OrderbagListByServiceController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.orderbag_list_by_service', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reportexport.financial_by_customer', {
                parent: 'supplierPanel.reportexport',
                url: '/financial_by_customer',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/financial_by_customer/financial_by_customer.html',
                        controller: 'FinancialByCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.financial_by_customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reserve_v2', {
                parent: 'supplierPanel',
                url: '/reserve_v2',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })

            .state('supplierPanel.reserve_v2.newCompanyCustomerPopUp', {
                parent: 'supplierPanel.reserve_v2',
                url: '/newCompanyCustomerPopUp',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {

                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                // $translatePartialLoader.addPart('company');
                                $translatePartialLoader.addPart('personInfo');
                                // $translatePartialLoader.addPart('serviceItem');
                                // $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: function () {

                                return {
                                    // title: null,
                                    // level: null,

                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reportexport.reserve_count_by_parent_id', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_count_by_parent_id',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/province_branch_service_date_count/province_branch_service_date_count.html',
                        controller: 'ReserveCountByParentIdController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_count_by_parent_id', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reserveWithCustomerParameter', {
                parent: 'supplierPanel',
                url: '/reserveWithCustomerParameter/{customerId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {

                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })

            .state('supplierPanel.reportexport.reserve_list_dtail_report', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_list_dtail_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListDtailReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.reportexport.reserve_list_summary_report', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_list_summary_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListSummaryReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reportexport.reserve_list_summary_with_payment_report', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_list_summary_with_payment_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_summary_with_payment_report/reserve_list_summary_with_payment_report.html',
                        controller: 'ReserveListSummaryWithPaymentReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_list_summary_with_payment_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.reportexport.sum_of_reserve_count', {
                parent: 'supplierPanel.reportexport',
                url: '/sum_of_reserve_count',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/sum_of_reserve_count/sum_of_reserve_count.html',
                        controller: 'SumOfReserveCountController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.sum_of_reserve_count', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.accountClearingList', {
                parent: 'supplierPanel',
                url: '/accountClearingList',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-requests.html',
                        controller: 'AccountClearingRequestListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.accountClearingDetail', {
                parent: 'supplierPanel',
                url: '/accountClearingDetail/detail/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail.html',
                        controller: 'AccountClearingRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.eventItemList', {
                parent: 'supplierPanel',
                url: '/eventItemList',
                data: {
                    authorities: ['ROLE_EVENT_MANAGER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-item/event-item-list.html',
                        controller: 'EventItemListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('onlineMeetingType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel.generalEventItem', {
                parent: 'supplierPanel',
                url: '/generalEventItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-item/general-event-item.html',
                        controller: 'GeneralEventItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.newGeneralEventItem', {
                parent: 'supplierPanel',
                url: '/newGeneralEventItem/{onlineMeetingType}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-item/general-event-item.html',
                        controller: 'GeneralEventItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        // if ($stateParams.id != '')
                        //     return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })

            .state('supplierPanel.eventItemList.delete', {
                parent: 'supplierPanel.eventItemList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-item/event-item-delete-dialog.html',
                        controller: 'EventItemDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.eventItemList', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.couponList', {
                parent: 'supplierPanel',
                url: '/coupon-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.coupon.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupons-list.html',
                        controller: 'CouponListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.editCoupon', {
                parent: 'supplierPanel',
                url: '/coupon-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupon.html',
                        controller: 'CouponController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('amountTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Coupon', '$stateParams', function (Coupon, $stateParams) {

                        return Coupon.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel.newCoupon', {
                parent: 'supplierPanel',
                url: '/coupon-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupon.html',
                        controller: 'CouponController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        $translatePartialLoader.addPart('amountTypes');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })

            .state('supplierPanel.reserveLimitList', {
                parent: 'supplierPanel',
                url: '/reserve-limit-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.reserveLimit.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limits-list.html',
                        controller: 'ReserveLimitsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.editReserveLimit', {
                parent: 'supplierPanel',
                url: '/reserve-limit-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit.html',
                        controller: 'ReserveLimitController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        return $translate.refresh();
                    }],
                    entity: ['ReserveLimit', '$stateParams', function (ReserveLimit, $stateParams) {

                        return ReserveLimit.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel.newReserveLimit', {
                parent: 'supplierPanel',
                url: '/reserve-limit-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit.html',
                        controller: 'ReserveLimitController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })


            .state('supplierPanel.customerGroupList', {
                parent: 'supplierPanel',
                url: '/customer-group-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customerGroup.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-groups-list.html',
                        controller: 'CustomerGroupListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.newCustomerGroup', {
                parent: 'supplierPanel',
                url: '/customer-group-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-group.html',
                        controller: 'CustomerGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel.editCustomerGroup', {
                parent: 'supplierPanel',
                url: '/customer-group/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-group.html',
                        controller: 'CustomerGroupController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CustomerGroup', '$stateParams', function (CustomerGroup, $stateParams) {

                        return CustomerGroup.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })

            .state('supplierPanel.patternInfoList', {
                parent: 'supplierPanel',
                url: '/pattern-info-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.patternInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/pattern-info/pattern-info-list.html',
                        controller: 'PatternInfoListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('patternInfo');
                        $translatePartialLoader.addPart('patternStatus');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel.editPatternInfo', {
                parent: 'supplierPanel',
                url: '/pattern-info-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/pattern-info/pattern-info.html',
                        controller: 'PatternInfoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('patternInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['PatternInfo', '$stateParams', function (PatternInfo, $stateParams) {

                        return PatternInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel.newPatternInfo', {
                parent: 'supplierPanel',
                url: '/pattern-info-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/pattern-info/pattern-info.html',
                        controller: 'PatternInfoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('patternInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel.accessdeniedV2', {
                parent: 'supplierPanel',
                url: '/access-denied-v2',
                data: {
                    authorities: [],
                    pageTitle: 'global.error.accessDenied'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/supplier-v2/access-denied-v2.html',
                        controller: 'AccessDeniedV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('error');


                        return $translate.refresh();
                    }]
                }
            })

        ;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierPanelController', SetupController);

    SetupController.$inject = ['CompanyCustom', '$location', '$scope', 'Principal', 'LoginService', '$state', 'CompanyInfoQuery', 'ServantCustom', '__config', '$localStorage', '$translate', '$translatePartialLoader'];

    function SetupController(CompanyCustom, $location, $scope, Principal, LoginService, $state, CompanyInfoQuery, ServantCustom, __config, $localStorage, $translate, $translatePartialLoader) {
        var vm = this;
        vm.collapseMenu = collapseMenu;
        vm.menuIcon = menuIcon;
        vm.account = null;
        vm.menuState = menuState;
        vm.menuWiden = false;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.guidTipsEnable = false;
        vm.goToCurrentServant = goToCurrentServant;
        vm.goto = goto;
        vm.canViewReport = true;
        vm.uncheck = uncheck;
        vm.init = init;
        var cckey = $location.search().cckey;
        // loadCompanyInfo();
        vm.isWorkSpace = false;
        ;
        vm.checkActivityType = checkActivityType;
        vm.__config = __config;
        vm.wedoMeetMode = false;
        vm.logoSource = "content/images/logo-4.png";
        vm.setServantTooltip = setServantTooltip;
        vm.appVersion = 'v2';

        vm.init();

        function init() {

            $translatePartialLoader.addPart('activityType');
            $translatePartialLoader = $translate.refresh();

            if (!cckey)
                loadCompanyInfo();

            vm.servantClass = "fa fa-address-card fa-fw";
            vm.servantTranslateFile = "supplierPanel.sideMenu.servantInfo";
            Principal.getCurrentCompanyFeatureList();

            if (vm.__config.appMode == 'event') {
                vm.wedoMeetMode = true;
                vm.logoSource = "content/images/wedomeet.png"
            }
            if (vm.__config.appName && vm.__config.appName == 'planovin') {
                vm.logoSource = "content/images/planovin-white-space.svg"
            }

        }

        function menuIcon(x) {
            x.classList.toggle("change");
        }

        function changeCurrentCompany() {
            if (cckey) {
                vm.company = null;
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {

                    loadCompanyInfo();

                });
            }

        }

        function collapseMenu() {

        }

        function loadCompanyInfo() {

            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                if (company != null && company != undefined) {
                    vm.company = company;
                    if (vm.company && vm.company.keyUrl)
                        vm.websiteUrl = vm.company.keyUrl + '.reserweb.ir';
                    else
                        vm.websiteUrl = '----------------' + '.reserweb.ir';


                } else {
                    vm.websiteUrl = '----------------' + '.reserweb.ir';
                }
                checkActivityType();
                vm.appVersion = company.appVersion;
                if (vm.appVersion == 'v3') {
                    $state.go('supplierPanel-v2.dashboard');
                }
            })


        }

        vm.guidTipsConfig = [
            {
                type: "title",
                heading: "Welcome to the NG-Joyride demo",
                text: '<div class="row"><div id="title-text" class="col-md-12"><span class="main-text">Welcome to <strong>Ng Joyride Demo</strong></span><br><span>( This demo will walk you through the features of Ng-Joyride. )</span><br/><br/><span class="small"><em>This can have custom html too !!!</em></span></div></div>'

            }, {
                type: "element",
                selector: "#scheduleStartDate",
                heading: "Custom Title",
                text: "The demo finishes.Head over to github to learn more",
                placement: "bottom",
                scroll: false
            }

        ];


        function goToCurrentServant() {
            ServantCustom.findServantByCurrentUser().query().$promise.then(function (result) {

                $state.transitionTo('supplierPanel.companyServants.edit', {id: result.id});

            });

        }

        function goto(state) {
            $state.transitionTo('supplierPanel' + state);
        }

        function menuState() {
            vm.menuWiden = false;
        }

        function uncheck() {

            // if (vm.checked == event.target.value)
            vm.checked = false
        }

        function checkActivityType() {
            if (vm.company && vm.company.activityType == 'WORK_SPACE') {
                vm.isWorkSpace = true;
                vm.servantTranslateFile = "supplierPanel.sideMenu.workSpaceInfo";
                vm.servantClass = "fa fa-building fa-fw";
                return;
            }
            if (vm.company && vm.company.activityType) {
                setServantTooltip();
            }

            vm.isWorkSpace = false;


        }


        function setServantTooltip() {

            vm.servantTranslateFileOptions = "";
            if (vm.company && vm.company.activityType)
                vm.servantTranslateFileOptions = 'tikonApp.ActivityType.ActivityTypeServants.' + vm.company.activityType;
        }


        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ScheduleValidator', ScheduleValidator);

    ScheduleValidator.$inject = ['$resource'];

    function ScheduleValidator($resource) {

        return {
            scheduleStartEndDateValidator: scheduleStartEndDateValidator
        }

        /***
         * startDate and End Date validator
         * @param startDate
         * @param endDate
         * @param serviceItemId
         * @param scheduleInfoId
         * @returns {*}
         */
        function scheduleStartEndDateValidator(startDate, endDate, serviceItemId, scheduleInfoId) {

            if (startDate && endDate && serviceItemId && scheduleInfoId) {
                var parameters = '?startDate=' + (startDate).toLocalISOString() + '&endDate=' + (new Date(endDate)).toLocalISOString() + '&serviceItemId=' + serviceItemId + '&scheduleInfoId=' + scheduleInfoId;
                return $resource('api/schedule-startend-date-validator' + parameters, {}, {
                    'get': {
                        method: 'GET', params: {}, isArray: false,
                        interceptor: {
                            response: function (response) {
                                // expose response
                                return response;
                            }
                        }
                    }
                });
            }
        }


        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DialogService', DialogService);

    DialogService.$inject = ['$resource', '$mdDialog'];

    function DialogService($resource, $mdDialog) {

        return {
            showAlert: showAlert,
            showConfirm: showConfirm,
            showConfirmV2: showConfirmV2,
            showDialog: showDialog
        }

        function showDialog(templateUrl, scope) {

            return $mdDialog.show({
                clickOutsideToClose: true,
                scope: scope,
                preserveScope: true,
                templateUrl: templateUrl,
                controller: ['$scope', '$mdDialog', DialogController]
            });

        }

        function DialogController(scope, $mdDialog) {
            scope.closeDialog = function () {
                $mdDialog.hide();
            }
        }

        // DialogController.$inject = ['$scope','$mdDialog'];
        //function showDialog(controller,templateUrl)
        //{
        //  return  $mdDialog.show({
        //            controller: controller,
        //            templateUrl: templateUrl,
        //            parent: angular.element(document.body),
        //        //    targetEvent: ev,
        //            clickOutsideToClose:true,
        //            fullscreen: false // Only for -xs, -sm breakpoints.
        //        });
        //
        //}
        function showConfirm(title, contentText, okText, cancelText) {
            if (!contentText) contentText = '';
            if (!okText) okText = 'تایید';
            if (!cancelText) cancelText = 'انصراف';


            var confirm = $mdDialog.confirm({
                onComplete: function () {
                    angular.element(document.querySelector("button[ng-click='dialog.hide()']")).addClass(' md-raised ');
                    angular.element(document.querySelector("button[ng-click='dialog.abort()']")).addClass('md-warn');
                }
            })
                .title(title)
                .textContent(contentText)
                .ariaLabel('')
                // .targetEvent(event)
                .ok(okText)
                .cancel(cancelText);

            return $mdDialog.show(confirm)

        }

        function showAlert(title, contentText, okText) {
            if (!contentText) contentText = '';
            if (!okText) okText = 'تایید';
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(contentText)
                    .ariaLabel('Offscreen Demo')
                    .ok(okText)
                    // Or you can specify the rect to do the transition from
                    .openFrom({
                        top: -50,
                        width: 30,
                        height: 80
                    })
                    .closeTo({
                        left: 1500
                    })
            );

        }

        function showConfirmV2(title, contentText, okText, cancelText) {
            if (!contentText) contentText = '';
            if (!okText) okText = 'تایید';
            if (!cancelText) cancelText = 'انصراف';


            var confirm = $mdDialog.confirm({
                onComplete: function () {

                    angular.element(document.querySelector("button[ng-click='dialog.hide()']")).addClass(' md-raised pl-btn-primary pl-btn pl-btn-md ');
                    angular.element(document.querySelector("button[ng-click='dialog.abort()']")).addClass('md-warn pl-btn');
                }
            })
                .title(title)
                .textContent(contentText)
                .ariaLabel('')
                // .targetEvent(event)
                .ok(okText)
                .cancel(cancelText);

            return $mdDialog.show(confirm)

        }

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DateUtil', DateUtilService);

    DateUtilService.$inject = ['$resource', '$moment'];

    function DateUtilService($resource, $moment) {

        return {
            fromString: fromString,
            jalaliToGregorian: jalaliToGregorian,

        };

        function fromString(datestr) {

            var date = $moment(datestr, "YYYY-MM-DD[T]HH:mm:ss");

            return date;
        }
        function jalaliToGregorian(input) {
            var g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

            var dateSplitted = input.split("/");
            var j_y = parseInt(dateSplitted[0], 10);
            var j_m = parseInt(dateSplitted[1], 10);
            var j_d = parseInt(dateSplitted[2], 10);

            var jy = j_y - 979;
            var jm = j_m - 1;
            var jd = j_d - 1;

            var j_day_no = 365 * jy + Math.floor(jy / 33) * 8 + Math.floor((jy % 33 + 3) / 4);
            for (var i = 0; i < jm; ++i) j_day_no += j_days_in_month[i];
            j_day_no += jd;

            var g_day_no = j_day_no + 79;

            var gy = 1600 + 400 * Math.floor(g_day_no / 146097);
            g_day_no = g_day_no % 146097;

            var leap = true;
            if (g_day_no >= 36525) {
                g_day_no--;
                gy += 100 * Math.floor(g_day_no / 36524);
                g_day_no = g_day_no % 36524;

                if (g_day_no >= 365) g_day_no++;
                else leap = false;
            }

            gy += 4 * Math.floor(g_day_no / 1461);
            g_day_no %= 1461;

            if (g_day_no >= 366) {
                leap = false;
                g_day_no--;
                gy += Math.floor(g_day_no / 365);
                g_day_no = g_day_no % 365;
            }

            for (var i = 0; g_day_no >= g_days_in_month[i] + ((i == 1 && leap) ? 1 : 0); i++) {
                g_day_no -= g_days_in_month[i] + ((i == 1 && leap) ? 1 : 0);
            }
            var gm = i + 1;
            var gd = g_day_no + 1;
            return new Date(gy, gm - 1, gd);       
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('UserCustom', UserCustom);

    UserCustom.$inject = ['$resource'];

    function UserCustom($resource) {


        var getCurrentUserProfile = function () {
            var resourceUrl = 'api/get-current-user-profile';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var getCurrentUserCompanies = function () {
            var resourceUrl = 'api/get-current-user-companies';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getUserByLogin = function (login) {
            var resourceUrl = 'api/get-user-by-login?login=' + login;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var createUserByAdmin = function () {

            var resourceUrl = 'api/create-company-customer-user-by-admin';
            return $resource(resourceUrl, {}, {}
            );
        };
        var setUserInsight = function () {
            var resourceUrl = 'api/v2/users/insight';
            return $resource(resourceUrl, {}, {}
            );
        }
        var updateUserInsight = function () {
            var resourceUrl = 'api/v2/users/insight';
            return $resource(resourceUrl, {}, {
                'update': {method: 'PUT'}
            }
            );
        }
        var userAttribution = function () {
            var resourceUrl = 'api/v2/users/attribution';
            return $resource(resourceUrl, {}, {
                'save': {
                    method: 'POST',
                    isArray: false,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
        });
        }

        return {
            getCurrentUserProfile: getCurrentUserProfile,
            getCurrentUserCompanies: getCurrentUserCompanies,
            getUserByLogin: getUserByLogin,
            createUserByAdmin: createUserByAdmin,
            setUserInsight:setUserInsight,
            updateUserInsight: updateUserInsight,
            userAttribution: userAttribution
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User($resource) {

        var resourceUrl ='api/users/:login';
        return $resource(resourceUrl, {}, {

            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('TestServices', TestServices);

    TestServices.$inject = ['$resource', 'ENV'];

    function TestServices($resource, ENV) {


        var getCompanyInfoByKeyURL = function (keyURL) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-company-info-by-key-url?url=' + keyURL;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getRootCategoriesByKeyURL = function (keyURL) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-root-categories-by-key-url?url=' + keyURL;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getCategoriesByParentId = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-categories-by-parent/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceItemByCategoryId = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-item-by-category/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getCategoryById = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-category-by-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getServiceItemById = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-item-by-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getServiceTimeSessionFromToDate = function (serviceItemid, from, to) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-time-session-from-to-date?serviceItemId=' + serviceItemid + '&from=' + from + '&to=' + to;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceTimeSessionTimesInOneDate = function (serviceItemId, dateTimeStr) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-time-session-times-in-one-date?serviceItemId=' + serviceItemId + '&dateTimeStr=' + dateTimeStr;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getPriceInfoDtailByServiceItemFromTimeSession = function (serviceItemId, serviceTimeSessionId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/price-info-dtails-by-service-item-from-time-session?serviceItemId=' + serviceItemId + '&serviceTimeSessionId=' + serviceTimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceOptionItemsByServiceItemId = function (serviceItemId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/service-option-items-by-service-item?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceTimeSessionById = function (serviceTimeSessionId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-time-session-by-id?serviceTimeSessionId=' + serviceTimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getImageDataById = function (imageDataId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-image-data-by-id?imageDataId=' + imageDataId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var saveOrderBagVM = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/order-bags';
            return $resource(resourceUrl, {}, {}
            );
        };


        var testReminder = function (testReminder) {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-reminder';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var getImageDataVMByAlbumId = function (albumId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/image-data-vm-by-albumid?albumid=' + albumId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var sendTestSMS = function (keyUrl, phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-sms?keyUrl=' + keyUrl + '&phoneNumber=' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var generateTimeSessionsForAllServicesJustOnDate = function (untilDate) {

            var resourceUrl = ENV.API_BASE_URL + 'api/generateTimeSessionsForAllServicesJustOnDate/' + untilDate;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var generateTimeSessionsForAllServicesJustOnDateOneCompany = function (untilDate, url) {

            var resourceUrl = ENV.API_BASE_URL + 'api/generateTimeSessionsForAllServicesJustOnDateOneCompany/' + untilDate + '/' + url;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var generateTimeSessionsForAllServices = function (untilDate) {

            var resourceUrl = ENV.API_BASE_URL + 'api/generateTimeSessionsForAllServicesUntilDate/' + untilDate;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestEmail = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-email';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var finalApproveOrderBagById = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'client/final-approve-order-bag-by-id?orderBagId=' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var testSubscriptionNearToExpire = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-subscription-near-to-expire';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var testUpdateExpireCompanyStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-update-expire-company-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var confirmReserveRequest = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/confirm-reserve-request-by-order-bag-id?orderBagId=' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var insertNewConversation = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/insert-new-conversation';
            return $resource(resourceUrl, {}, {}
            );
        };

        var insertNewMessage = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/insert-new-message';
            return $resource(resourceUrl, {}, {}
            );
        };

        var cancelAllExpireTwoStepReserve = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/cancel-all-expire-two-step-reserve';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var getServiceAvailableDatesInNextDays = function (serviceItemId, nextDays) {

            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-service-available-dates-in-next-days?serviceId=' + serviceItemId + "&days=" + nextDays;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getServiceAvailableTimesInOneDate = function (serviceItemId, onDate, fromHour, toHour) {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-service-available-times-in-one-shamsi-date?serviceId=' + serviceItemId + "&onDateStr=" + onDate;
            if (fromHour != undefined)
                resourceUrl = resourceUrl + "&fromHour=" + fromHour;
            if (toHour != undefined)
                resourceUrl = resourceUrl + "&toHour=" + toHour;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var getCustomerByMobileNumber = function (mobileNumber) {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-customer-by-mobile-number/' + mobileNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var addTaminBranch = function (title, url, user, baseurl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-tamin-branch?companyurl=' + url + '&companytitle=' + title + '&username=' + user + '&basecompanyurl=' + baseurl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var addLocation = function (companyId, tel) {
            var resourceUrl = ENV.API_BASE_URL + 'api/location-info-add-to-company-title/' + companyId + "?tel=" + tel;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var findcompanyByTitle = function (title) {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-title?title=' + title;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var findcompanyByKeyUrl = function (keyUrl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-key-url?keyUrl=' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var exportOrderBagToExcel = function (serviceItemid) {

            var resourceUrl = ENV.API_BASE_URL + 'api/export-orderbags-by-service-item?serviceItemId=' + serviceItemid;
            return $resource(resourceUrl, {}, {}
            );
        }

        var sendTestCustomerSatisfactionSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-customer-satisfaction-sms/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        var addDaysToSubscriptionByCompany = function (companyKeyUrl, days) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-days-to-subscription-by-company?companyKeyUrl=' + companyKeyUrl + '&daysToAdd=' + days;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var addFreeSMSPackage = function (companyKeyUrl, starDate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-free-sms-package-to-company?companyKeyUrl=' + companyKeyUrl + '&startDate=' + starDate;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var addCustomSMSPackage = function (companyKeyUrl, packageid, starDate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-custom-sms-package-to-company?companyKeyUrl=' + companyKeyUrl + '&startDate=' + starDate + '&packageid=' + packageid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var getCompaniesSubscriptionNearToExpire = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-companies-subscription-near-to-expire';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var sendTestCustomerFirstReminderSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-customer-first-reminder-sms/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getTopNCompanyManager = function (recordCount) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-top-n-company-manager?recordCount=' + recordCount;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getServantByMarketPlaceFilter = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-servants-by-marketplace-filter';
            return $resource(resourceUrl, {}, {
                'query': {method: 'POST', isArray: true}
            });

        }

        var addDaysToSubscriptionByCompaniesCategory = function (category, days) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-days-to-subscription-by-companies-category?category=' + category + '&daysToAdd=' + days;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var setFeatureByCompanySubscriptionId = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/set-feature-by-company-subscription-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestReservationConfirmedInfoMsg = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-reservation-confirmed-info-msg/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getToken = function () {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-token';
            return $resource(resourceUrl, {}, {}
            );
        };

        var createUserAccessForServantByPhoneNumber = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/create-user-access-for-servant-by-phone-number';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getReserveListByCustomer = function (mobileNumber) {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-reserve-list-by-customer?mobileNo=' + mobileNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var addBatchCustomer = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-batch-customer';
            return $resource(resourceUrl, {}, {}
            );
        };

        var testIcalCalendat = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/test-ical-calendar';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var sendVerificationTestSMS = function (keyUrl, phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-verification-test-sms?keyUrl=' + keyUrl + '&phoneNumber=' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var sendRebookNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-rebook-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendRebookSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-rebook-sms-test/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestCustomerSecondReminderSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-customer-second-reminder-sms/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSMSPackageGoingToFinish = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-sms-package-going-finish/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSMSPackageFinished = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-sms-package-finished/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSubscriptionNearToExpireNotification = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-subscription-near-to-expire-notification/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSubscriptionIsExpiredNotification = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-subscription-is-expired-notification/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var sendTestAutomaticSubscriptionNearToExpireNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-automatic-near-to-expired-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var sendTestAutomaticApproveReserveRequest = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-automatic-approve-reserve-request';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendAllSatisfactionNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-all-satisfaction-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var sendTestSupplierFirstJourneyNotification = function (phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-supplier-first-journey/' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getInvoiceReportPdfUrl = function (id) {

            return ENV.API_BASE_URL + 'api/client/invoice-report-pdf-by-id/' + id;

        };

        var addBatchInvoiceInfo = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-batch-invoice-info';
            return $resource(resourceUrl, {}, {}
            );
        };
        var sendAutomaticMarketingCampaign = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-automatic-marketing-campaign';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var testCalculateCommission = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-calculate-commission';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var testSmsNearFinish = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-sms-near-finish';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

       var testSendMarketingCampaign = function () {
           var resourceUrl =
               ENV.API_BASE_URL +
               'api/test-send-sms-panel-marketing-campaigns';

           return $resource(resourceUrl, {}, {
               send: {
                   method: 'POST',
                   params: {
                       marketingCampaignId: '@marketingCampaignId'
                   }
               }
           });
       };
       var removePhoneNumber = function () {
           var resourceUrl =
               ENV.API_BASE_URL +
               'api/users';

           return $resource(resourceUrl, {}, {
               delete: {
                   method: 'DELETE',
                   params: {
                       phoneNumber: '@phoneNumber'
                   }
               }
           });
       };


        return {
            getCompanyInfoByKeyURL: getCompanyInfoByKeyURL,
            getRootCategoriesByKeyURL: getRootCategoriesByKeyURL,
            getCategoriesByParentId: getCategoriesByParentId,
            getServiceItemByCategoryId: getServiceItemByCategoryId,
            getCategoryById: getCategoryById,
            getServiceItemById: getServiceItemById,
            getServiceTimeSessionFromToDate: getServiceTimeSessionFromToDate,
            getServiceTimeSessionTimesInOneDate: getServiceTimeSessionTimesInOneDate,
            getPriceInfoDtailByServiceItemFromTimeSession: getPriceInfoDtailByServiceItemFromTimeSession,
            getServiceOptionItemsByServiceItemId: getServiceOptionItemsByServiceItemId,
            getServiceTimeSessionById: getServiceTimeSessionById,
            getImageDataById: getImageDataById,
            saveOrderBagVM: saveOrderBagVM,
            testReminder: testReminder,
            getImageDataVMByAlbumId: getImageDataVMByAlbumId,
            sendTestSMS: sendTestSMS,
            sendTestEmail: sendTestEmail,
            finalApproveOrderBagById: finalApproveOrderBagById,
            generateTimeSessionsForAllServices: generateTimeSessionsForAllServices,
            generateTimeSessionsForAllServicesJustOnDate: generateTimeSessionsForAllServicesJustOnDate,
            generateTimeSessionsForAllServicesJustOnDateOneCompany: generateTimeSessionsForAllServicesJustOnDateOneCompany,
            testSubscriptionNearToExpire: testSubscriptionNearToExpire,
            testUpdateExpireCompanyStatus: testUpdateExpireCompanyStatus,
            confirmReserveRequest: confirmReserveRequest,
            insertNewConversation: insertNewConversation,
            insertNewMessage: insertNewMessage,
            cancelAllExpireTwoStepReserve: cancelAllExpireTwoStepReserve,
            exportOrderBagToExcel: exportOrderBagToExcel,
            getServiceAvailableDatesInNextDays: getServiceAvailableDatesInNextDays,
            getServiceAvailableTimesInOneDate: getServiceAvailableTimesInOneDate,
            getCustomerByMobileNumber: getCustomerByMobileNumber,
            addTaminBranch: addTaminBranch,
            addLocation: addLocation,
            findcompanyByTitle: findcompanyByTitle,
            findcompanyByKeyUrl: findcompanyByKeyUrl,
            sendTestCustomerSatisfactionSMS: sendTestCustomerSatisfactionSMS,
            addDaysToSubscriptionByCompany: addDaysToSubscriptionByCompany,
            getCompaniesSubscriptionNearToExpire: getCompaniesSubscriptionNearToExpire,
            addFreeSMSPackage: addFreeSMSPackage,
            addCustomSMSPackage: addCustomSMSPackage,
            sendTestCustomerFirstReminderSMS: sendTestCustomerFirstReminderSMS,
            getTopNCompanyManager: getTopNCompanyManager,
            getServantByMarketPlaceFilter: getServantByMarketPlaceFilter,
            addDaysToSubscriptionByCompaniesCategory: addDaysToSubscriptionByCompaniesCategory,
            setFeatureByCompanySubscriptionId: setFeatureByCompanySubscriptionId,
            sendTestReservationConfirmedInfoMsg: sendTestReservationConfirmedInfoMsg,
            getToken: getToken,
            createUserAccessForServantByPhoneNumber: createUserAccessForServantByPhoneNumber,
            getReserveListByCustomer: getReserveListByCustomer,
            addBatchCustomer: addBatchCustomer,
            testIcalCalendat: testIcalCalendat,
            sendVerificationTestSMS: sendVerificationTestSMS,
            sendRebookNotification: sendRebookNotification,
            sendRebookSMS: sendRebookSMS,
            sendTestCustomerSecondReminderSMS: sendTestCustomerSecondReminderSMS,
            sendTestSMSPackageGoingToFinish: sendTestSMSPackageGoingToFinish,
            sendTestSMSPackageFinished: sendTestSMSPackageFinished,
            sendTestSubscriptionNearToExpireNotification: sendTestSubscriptionNearToExpireNotification,
            sendTestSubscriptionIsExpiredNotification: sendTestSubscriptionIsExpiredNotification,
            sendTestAutomaticSubscriptionNearToExpireNotification: sendTestAutomaticSubscriptionNearToExpireNotification,
            sendTestAutomaticApproveReserveRequest: sendTestAutomaticApproveReserveRequest,
            sendAllSatisfactionNotification: sendAllSatisfactionNotification,
            sendTestSupplierFirstJourneyNotification: sendTestSupplierFirstJourneyNotification,
            getInvoiceReportPdfUrl: getInvoiceReportPdfUrl,
            addBatchInvoiceInfo: addBatchInvoiceInfo,
            sendAutomaticMarketingCampaign: sendAutomaticMarketingCampaign,
            testCalculateCommission: testCalculateCommission,
            testSmsNearFinish: testSmsNearFinish,
            testSendMarketingCampaign:testSendMarketingCampaign,
            removePhoneNumber: removePhoneNumber


        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TestServiceController', TestServiceController);

    TestServiceController.$inject = ['$timeout', '$scope', '$stateParams', 'TestServices', 'Company', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', '$injector', 'CompanyCustom', '$window', 'DateUtils','MarketingCampaignCustom','CompanyCustomerCustom'];

    function TestServiceController($timeout, $scope, $stateParams, TestServices, Company, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, $injector, CompanyCustom, $window, DateUtils,MarketingCampaignCustom,CompanyCustomerCustom) {


        var vm = this;
        vm.branchlist = '{"list":[{"branchtitle":"ش1","branchurl":"x1","user":"u1","baseurl":"x0"},' +
            '{"branchtitle":"a2","branchurl":"x2","user":"u2","baseurl":"x0"}]}'

        vm.getCompanyInfoByKeyURL = getCompanyInfoByKeyURL;
        vm.getRootCategoriesByKeyURL = getRootCategoriesByKeyURL;
        vm.getCategoriesByParentId = getCategoriesByParentId;
        vm.getServiceItemByCategoryId = getServiceItemByCategoryId;
        vm.getCategoryById = getCategoryById;
        vm.getServiceItemById = getServiceItemById;
        vm.getServiceTimeSessionFromToDate = getServiceTimeSessionFromToDate;
        vm.getServiceTimeSessionTimesInOneDate = getServiceTimeSessionTimesInOneDate;
        vm.getPriceInfoDtailByServiceItemFromTimeSession = getPriceInfoDtailByServiceItemFromTimeSession;
        vm.getServiceOptionItemsByServiceItemId = getServiceOptionItemsByServiceItemId;
        vm.getServiceTimeSessionById = getServiceTimeSessionById;
        vm.getImageDataById = getImageDataById;
        vm.saveOrderBagVM = saveOrderBagVM;
        vm.testReminder = testReminder;
        vm.getImageDataVMByAlbumId = getImageDataVMByAlbumId;
        vm.sendTestSMS = sendTestSMS;
        vm.sendTestEmail = sendTestEmail;
        vm.generateTimeSessionsForAllServices = generateTimeSessionsForAllServices;
        vm.testSubscriptionNearToExpire = testSubscriptionNearToExpire;
        vm.testUpdateExpireCompanyStatus = testUpdateExpireCompanyStatus;
        vm.insertNewConversation = insertNewConversation;
        vm.insertNewMessage = insertNewMessage;
        vm.cancelAllExpireTwoStepReserve = cancelAllExpireTwoStepReserve;
        vm.exportOrderBagToExcel = exportOrderBagToExcel;
        vm.getServiceAvailableDatesInNextDays = getServiceAvailableDatesInNextDays;
        vm.getServiceAvailableTimesInOneDate = getServiceAvailableTimesInOneDate;
        vm.getCustomerByMobileNumber = getCustomerByMobileNumber;
        vm.addTaminBranch = addTaminBranch;
        vm.generateTimeSessionsForAllServicesJustOnDate = generateTimeSessionsForAllServicesJustOnDate;
        vm.addmultiplebranch = addmultiplebranch;
        vm.addLocationList = addLocationList;
        vm.generateTimeSessionsForAllServicesJustOnDateOneCompany = generateTimeSessionsForAllServicesJustOnDateOneCompany;
        vm.sendTestCustomerSatisfactionSMS = sendTestCustomerSatisfactionSMS;
        vm.fromDateForGenerate = "2018-09-25";
        vm.addDaysToSubscriptionByCompany = addDaysToSubscriptionByCompany;
        vm.companyKeyUrl = "";
        vm.category = "";
        vm.daysToAdd = 0;
        vm.getCompaniesSubscriptionNearToExpire = getCompaniesSubscriptionNearToExpire;
        vm.addFreeSMSPackage = addFreeSMSPackage;

        vm.addCustomSMSPackage = addCustomSMSPackage;
        vm.smsPackages = SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType('SMS', 'CUSTOM_1').query();
        vm.sendTestCustomerFirstReminderSMS = sendTestCustomerFirstReminderSMS;
        vm.getTopNCompanyManager = getTopNCompanyManager;
        vm.testToast = testToast;
        vm.getServantByMarketPlaceFilter = getServantByMarketPlaceFilter;

        vm.addDaysToSubscriptionByCompaniesCategory = addDaysToSubscriptionByCompaniesCategory;
        vm.setFeatureByCompanySubscriptionId = setFeatureByCompanySubscriptionId;
        vm.sendTestReservationConfirmedInfoMsg = sendTestReservationConfirmedInfoMsg;
        vm.getToken = getToken;
        vm.createUserAccessForServantByPhoneNumber = createUserAccessForServantByPhoneNumber;
        vm.getReserveListByCustomer = getReserveListByCustomer;
        vm.batchCompanyCustomer = [];
        vm.addBatchCompanyCustomer = addBatchCompanyCustomer;
        vm.testIcal = testIcal;
        vm.sendVerificationTestSMS = sendVerificationTestSMS;
        vm.sendRebookNotification = sendRebookNotification;
        vm.sendRebookSMS = sendRebookSMS;
        vm.addSampleGtag = addSampleGtag;
        vm.sendTestCustomerSecondReminderSMS = sendTestCustomerSecondReminderSMS;
        vm.sendTestSMSPackageGoingToFinish = sendTestSMSPackageGoingToFinish;
        vm.sendTestSMSPackageFinished = sendTestSMSPackageFinished;
        vm.sendTestSubscriptionNearToExpireNotification = sendTestSubscriptionNearToExpireNotification;
        vm.sendTestSubscriptionIsExpiredNotification = sendTestSubscriptionIsExpiredNotification;
        vm.sendTestAutomaticSubscriptionNearToExpireNotification = sendTestAutomaticSubscriptionNearToExpireNotification;
        vm.sendTestAutomaticApproveReserveRequest = sendTestAutomaticApproveReserveRequest;
        vm.sendAllSatisfactionNotification = sendAllSatisfactionNotification;
        vm.deActiveCompany = deActiveCompany;
        vm.sendTestSupplierFirstJourneyNotification = sendTestSupplierFirstJourneyNotification;
        vm.selectItems = null;
        vm.invoiceReport = invoiceReport;

        vm.batchInvoiceInfo = [];
        vm.addBatchInvoiceInfo = addBatchInvoiceInfo;
        vm.sendAutomaticMarketingCampaign = sendAutomaticMarketingCampaign;
        vm.testCalculateCommission = testCalculateCommission;

        vm.testTehranTime = testTehranTime;
        vm.testSmsNearFinish = testSmsNearFinish;
        vm.marketingCampaignId = null;
        vm.sendMarketingCampaign = sendMarketingCampaign;
        vm.sendMarketingCampaignLoading = false;
        vm.companyCustomerIds = null;
        vm.mergeCompanyCustomers=mergeCompanyCustomers;
        vm.phoneNumber = '';
        vm.removePhoneNumber = removePhoneNumber;
        vm.removePhoneNumberLoading = false;

        initSelectItems();

        function initSelectItems() {
            vm.selectItems = [];
            var item1 = {};
            item1.id = 1;
            item1.name = "name1";
            vm.selectItems.push(item1);

            var item2 = {};
            item2.id = 2;
            item2.name = "name2";
            vm.selectItems.push(item2);

            var item3 = {};
            item3.id = 3;
            item3.name = "name3";
            vm.selectItems.push(item3);

            var item4 = {};
            item4.id = 4;
            item4.name = "name4";
            vm.selectItems.push(item4);


        }

        function testToast() {

            var mdToast = $injector.get('$mdToast');

            var type = 'success';

            mdToast.show(
                mdToast.simple()
                    .content('تست می شود')
                    .hideDelay(600000)
                    .theme(type + '-toast'));

        }

        function exportOrderBagToExcel() {
            var serviceItemid = prompt("Enter ServiceId", "0");

            if (serviceItemid == null || serviceItemid == "") {

            } else {

            }
        }

        function generateTimeSessionsForAllServices() {


            var untilDate = vm.fromDateForGenerate;
            //prompt("Enter the Until Date", "2018-09-25");

            if (untilDate == null || untilDate == "") {

            } else {
                vm.company = TestServices.generateTimeSessionsForAllServices(untilDate).query();
            }

        }

        function generateTimeSessionsForAllServicesJustOnDate() {

            var untilDate = prompt("Enter the On Date", "2018-07-10");

            if (untilDate == null || untilDate == "") {

            } else {
                vm.company = TestServices.generateTimeSessionsForAllServicesJustOnDate(untilDate).query();
            }

        }

        function generateTimeSessionsForAllServicesJustOnDateOneCompany() {

            var untilDate = prompt("Enter the On Date", "2018-07-10");
            var url = prompt("Enter the company url", "");

            if (untilDate == null || untilDate == "") {

            } else {
                vm.company = TestServices.generateTimeSessionsForAllServicesJustOnDateOneCompany(untilDate, url).query();
            }

        }

        vm.finalApproveOrderBagById = finalApproveOrderBagById;

        function getCompanyInfoByKeyURL() {
            vm.company = TestServices.getCompanyInfoByKeyURL("parandeh.reserweb.com").query();

        }

        function getRootCategoriesByKeyURL() {
            vm.serviceCategories = TestServices.getRootCategoriesByKeyURL("min.tikon.com").query();
        }

        function getCategoriesByParentId() {
            vm.serviceCategories = TestServices.getCategoriesByParentId('1583').query();
        }

        function getServiceItemByCategoryId() {
            vm.serviceItems = TestServices.getServiceItemByCategoryId('6518').query();
        }

        function getCategoryById() {
            vm.serviceCategory = TestServices.getCategoryById('1579').query();
        }

        function getServiceItemById() {
            vm.serviceItem = TestServices.getServiceItemById('1427').query();
        }

        function getServiceTimeSessionFromToDate() {
            var startDate = new Date(Date.UTC(2016, 10, 10, 10, 20, 20));
            var endDate = new Date(Date.UTC(2016, 12, 8, 10, 30, 30));
            vm.serviceTimeSessions = TestServices.getServiceTimeSessionFromToDate('1167', startDate.toISOString(), endDate.toISOString()).query();
        }

        function getServiceTimeSessionTimesInOneDate() {
            var dateTime = new Date(Date.UTC(2016, 10, 10, 10, 20, 20));
            vm.serviceTimeSessionTimes = TestServices.getServiceTimeSessionTimesInOneDate('1167', dateTime.toISOString()).query();
        }

        function getPriceInfoDtailByServiceItemFromTimeSession() {
            vm.priceInfoDtails = TestServices.getPriceInfoDtailByServiceItemFromTimeSession('1427', '1651').query();
        }

        function getServiceOptionItemsByServiceItemId() {
            vm.serviceItemOptions = TestServices.getServiceOptionItemsByServiceItemId('1427').query();
        }

        function getServiceTimeSessionById() {
            vm.serviceTimeSession = TestServices.getServiceTimeSessionById('1648').query();
        }

        function getImageDataById() {
            vm.imageData = TestServices.getImageDataById('3843').query();
        }

        function saveOrderBagVM() {

            vm.orderBagVM = {
                "customerId": 1405,
                "orderBagServiceItems": [
                    /* {
                         "serviceItemId":1427,
                         "serviceItem": {
                             "id": 9552,
                             "itemTitle": "عمل بینی",
                             "description": "بینی شمارا عمل میکنیم",
                             "minPreReserveTime": null,
                             "maxPreReserveTime": null,
                             "hasWaitingList": null,
                             "mustGetParticipantInfo": null,
                             "canBeCanceled": null,
                             "minPreCancelTime": null,
                             "paymentType": null,
                             "serviceType": "INDEPENDENT_SERVICE",
                             "options": [
                                 {
                                     "id": 32513,
                                     "title": "ServiceOption"
                                 },
                                 {
                                     "id": 32509,
                                     "title": "ServiceOption"
                                 }
                             ],
                             "discountInfoId": 9549,
                             "locationId": null,
                             "imageAlbumId": 30860,
                             "capacityInfoId": 9554,
                             "categoryId": 2616,
                             "priceinfoId": null,
                             "serviceTimes": [
                                 {
                                     "id": 9939,
                                     "formState": "BASIC_SCHEDULE_INFO",
                                     "scheduleType": "PRIMARY",
                                     "timingInfo": null,
                                     "weeklyScheduleInfoId": 9933,
                                     "weeklyScheduleInfo": {
                                         "id": 9933,
                                         "datePeriods": [
                                             {
                                                 "id": 9930,
                                                 "fromDate": "2016-09-28",
                                                 "toDate": "2016-11-23",
                                                 "offdays": [
                                                     {
                                                         "id": 9929,
                                                         "offDate": "2016-11-21",
                                                         "offDayType": null
                                                     }
                                                 ]
                                             }
                                         ],
                                         "dailyDurations": [
                                             {
                                                 "id": 9931,
                                                 "startTime": "1970-01-01T04:30:00.000Z",
                                                 "endTime": "1970-01-01T13:30:00.000Z",
                                                 "duration": 20,
                                                 "gaptime": 15,
                                                 "offtimes": [
                                                     {
                                                         "id": 9932,
                                                         "i": null,
                                                         "fromTime": "1970-01-01T08:30:00.000Z",
                                                         "toTime": "1970-01-01T09:30:00.000Z",
                                                         "offTimeType": null
                                                     }
                                                 ]
                                             }
                                         ],
                                         "weekdays": [
                                             {
                                                 "id": 9934,
                                                 "weekday": "SATURDAY"
                                             },
                                             {
                                                 "id": 9936,
                                                 "weekday": "TUESDAY"
                                             },
                                             {
                                                 "id": 9938,
                                                 "weekday": "MONDAY"
                                             },
                                             {
                                                 "id": 9937,
                                                 "weekday": "WEDNESDAY"
                                             },
                                             {
                                                 "id": 9935,
                                                 "weekday": "SUNDAY"
                                             }
                                         ],
                                         "datePeriod": {
                                             "id": 9930,
                                             "fromDate": "2016-09-28",
                                             "toDate": "2016-11-23",
                                             "offdays": [
                                                 {
                                                     "id": 9929,
                                                     "offDate": "2016-11-21",
                                                     "offDayType": null
                                                 }
                                             ]
                                         },
                                         "timePeriod": {
                                             "id": 9931,
                                             "startTime": "1970-01-01T04:30:00.000Z",
                                             "endTime": "1970-01-01T13:30:00.000Z",
                                             "duration": 20,
                                             "gaptime": 15,
                                             "offtimes": [
                                                 {
                                                     "id": 9932,
                                                     "i": null,
                                                     "fromTime": "1970-01-01T08:30:00.000Z",
                                                     "toTime": "1970-01-01T09:30:00.000Z",
                                                     "offTimeType": null
                                                 }
                                             ]
                                         }
                                     },
                                     "serviceItemId": 9552,
                                     "discountAmount": 15
                                 },
                                 {
                                     "id": 9548,
                                     "formState": "BASIC_SCHEDULE_INFO",
                                     "scheduleType": "PRIMARY",
                                     "timingInfo": null,
                                     "weeklyScheduleInfoId": 9541,
                                     "weeklyScheduleInfo": {
                                         "id": 9541,
                                         "datePeriods": [
                                             {
                                                 "id": 9539,
                                                 "fromDate": "2016-12-21",
                                                 "toDate": "2017-03-20",
                                                 "offdays": []
                                             }
                                         ],
                                         "dailyDurations": [
                                             {
                                                 "id": 9540,
                                                 "startTime": "1970-01-01T04:30:00.000Z",
                                                 "endTime": "1970-01-01T14:30:00.000Z",
                                                 "duration": 90,
                                                 "gaptime": 60,
                                                 "offtimes": []
                                             }
                                         ],
                                         "weekdays": [
                                             {
                                                 "id": 9545,
                                                 "weekday": "SATURDAY"
                                             },
                                             {
                                                 "id": 9542,
                                                 "weekday": "MONDAY"
                                             },
                                             {
                                                 "id": 9546,
                                                 "weekday": "TUESDAY"
                                             },
                                             {
                                                 "id": 9543,
                                                 "weekday": "WEDNESDAY"
                                             },
                                             {
                                                 "id": 9544,
                                                 "weekday": "SUNDAY"
                                             },
                                             {
                                                 "id": 9547,
                                                 "weekday": "THURSDAY"
                                             }
                                         ],
                                         "datePeriod": {
                                             "id": 9539,
                                             "fromDate": "2016-12-21",
                                             "toDate": "2017-03-20",
                                             "offdays": []
                                         },
                                         "timePeriod": {
                                             "id": 9540,
                                             "startTime": "1970-01-01T04:30:00.000Z",
                                             "endTime": "1970-01-01T14:30:00.000Z",
                                             "duration": 90,
                                             "gaptime": 60,
                                             "offtimes": []
                                         }
                                     },
                                     "serviceItemId": 9552,
                                     "discountAmount": 10
                                 },
                                 {
                                     "id": 10748,
                                     "formState": "BASIC_SCHEDULE_INFO",
                                     "scheduleType": "PRIMARY",
                                     "timingInfo": null,
                                     "weeklyScheduleInfoId": 10747,
                                     "weeklyScheduleInfo": {
                                         "id": 10747,
                                         "datePeriods": [
                                             {
                                                 "id": 10745,
                                                 "fromDate": "2014-04-20",
                                                 "toDate": "2014-05-22",
                                                 "offdays": []
                                             }
                                         ],
                                         "dailyDurations": [
                                             {
                                                 "id": 10746,
                                                 "startTime": "1970-01-01T04:30:00.000Z",
                                                 "endTime": "1970-01-01T13:30:00.000Z",
                                                 "duration": 90,
                                                 "gaptime": 15,
                                                 "offtimes": []
                                             }
                                         ],
                                         "weekdays": [
                                             {
                                                 "id": 10752,
                                                 "weekday": "SATURDAY"
                                             },
                                             {
                                                 "id": 10754,
                                                 "weekday": "MONDAY"
                                             },
                                             {
                                                 "id": 10751,
                                                 "weekday": "TUESDAY"
                                             },
                                             {
                                                 "id": 10755,
                                                 "weekday": "WEDNESDAY"
                                             },
                                             {
                                                 "id": 10750,
                                                 "weekday": "SUNDAY"
                                             },
                                             {
                                                 "id": 10753,
                                                 "weekday": "THURSDAY"
                                             }
                                         ],
                                         "datePeriod": {
                                             "id": 10745,
                                             "fromDate": "2014-04-20",
                                             "toDate": "2014-05-22",
                                             "offdays": []
                                         },
                                         "timePeriod": {
                                             "id": 10746,
                                             "startTime": "1970-01-01T04:30:00.000Z",
                                             "endTime": "1970-01-01T13:30:00.000Z",
                                             "duration": 90,
                                             "gaptime": 15,
                                             "offtimes": []
                                         }
                                     },
                                     "serviceItemId": 9552,
                                     "discountAmount": 5
                                 }
                             ],
                             "scheduleInfo": {
                                 "id": null,
                                 "formState": null,
                                 "scheduleType": null,
                                 "timingInfo": null,
                                 "weeklyScheduleInfoId": null,
                                 "weeklyScheduleInfo": {
                                     "id": null,
                                     "datePeriods": [],
                                     "dailyDurations": [],
                                     "weekdays": [],
                                     "datePeriod": {
                                         "id": null,
                                         "fromDate": null,
                                         "toDate": null,
                                         "offdays": []
                                     },
                                     "timePeriod": {
                                         "id": null,
                                         "startTime": null,
                                         "endTime": null,
                                         "duration": null,
                                         "gaptime": null,
                                         "offtimes": []
                                     }
                                 },
                                 "serviceItemId": null,
                                 "discountAmount": null
                             },
                             "servants": [],
                             "agreementId": 9553,
                             "startDate": null,
                             "endDate": null,
                             "servicePriceInfo": [],
                             "servicePriceInfoDtail": {
                                 "id": null,
                                 "title": null,
                                 "capacityRatio": null,
                                 "price": null,
                                 "coworkerPrice": null,
                                 "priceInfoId": null,
                                 "priceInfo": null,
                                 "discount": null,
                                 "priceWithDiscount": null
                             },
                             "serviceOptionItem": {
                                 "id": null,
                                 "optionName": null,
                                 "description": null,
                                 "optionInfoId": null,
                                 "priceInfoId": null,
                                 "imagesId": null,
                                 "priceInfoDtail": null,
                                 "selected": false,
                                 "optionInfo": null
                             },
                             "capacityInfo": {
                                 "id": null,
                                 "qty": null
                             },
                             "agreement": {
                                 "id": 9553,
                                 "rules": "",
                                 "agreement": ""
                             },
                             "coverImage": null,
                             "minPrice": null,
                             "maxDiscount": null,
                             "imageAlbum": {
                                 "id": 30860,
                                 "isSingleImage": null,
                                 "caption": null,
                                 "imageList": [
                                     {
                                         "id": 32517,
                                         "fileName": null,
                                         "caption": "caption",
                                         "fileType": null,
                                         "fileDataContentType": "image/jpeg",
                                         "thumbnailData": null,
                                         "thumbnailDataContentType": null,
                                         "isCoverImage": true,
                                         "albumInfoId": 30860
                                     },
                                     {
                                         "id": 32518,
                                         "fileName": null,
                                         "caption": "caption",
                                         "fileType": null,
                                         "fileDataContentType": "image/jpeg",
                                         "thumbnailData": null,
                                         "thumbnailDataContentType": null,
                                         "isCoverImage": true,
                                         "albumInfoId": 30860
                                     }
                                 ]
                             },
                             "tags": []
                         },
                         "orderBagServiceItemDtail": [
                             {
                                 "id": null,
                                 "title": "بزرگسال",
                                 "capacityRatio": null,
                                 "price": 50000,
                                 "coworkerPrice": null,
                                 "priceInfoDtailId": 1498,
                                 "priceInfo": {
                                     "id": 1497,
                                     "fromValidDate": "2016-11-20T20:30:00.000Z",
                                     "priceType": "FIXED",
                                     "servants": []
                                 },
                                 "discount": 10,
                                 "priceWithDiscount": 45000,
                                 "gty": 1,


                             },
                             {
                                 "id": null,
                                 "title": "کودک",
                                 "capacityRatio": null,
                                 "price": 20000,
                                 "coworkerPrice": null,
                                 "priceInfoDtailId": 1502,
                                 "priceInfo": {
                                     "id": 1501,
                                     "fromValidDate": "2016-09-21T20:30:00.000Z",
                                     "priceType": "FIXED",
                                     "servants": []
                                 },
                                 "discount": 10,
                                 "priceWithDiscount": 18000,
                                 "gty": 2,

                             }
                         ],
                         "options": [
                             {
                                 "id": 1492,
                                 "optionName": "کاشت ابرو",
                                 "description": "ابرو هم میکاریم",
                                 "optionInfoId": 1491,
                                 "priceInfoId": 1497,
                                 "imagesId": null,
                                 "priceInfoDtail": {
                                     "id": 1498,
                                     "title": "ابرو!",
                                     "capacityRatio": null,
                                     "price": 200000,
                                     "coworkerPrice": null,
                                     "priceInfoId": 1497,
                                     "priceInfo": {
                                         "id": 1497,
                                         "fromValidDate": "2016-12-20T20:30:00.000Z",
                                         "priceType": null,
                                         "servants": []
                                     },
                                     "discount": null,
                                     "priceWithDiscount": 150000
                                 },
                                 "selected": true,
                                 "optionInfo": {
                                     "id": 1491,
                                     "title": "ServiceOption"
                                 }
                             },
                             {
                                 "id": 1496,
                                 "optionName": "سرویس درب منزل",
                                 "description": "استفاده از سرویس رایگان",
                                 "optionInfoId": 1495,
                                 "priceInfoId": 1509,
                                 "imagesId": null,
                                 "priceInfoDtail": {
                                     "id": 1510,
                                     "title": "صث",
                                     "capacityRatio": null,
                                     "price": 200000,
                                     "coworkerPrice": null,
                                     "priceInfoId": 1509,
                                     "priceInfo": {
                                         "id": 1509,
                                         "fromValidDate": "2016-12-20T20:30:00.000Z",
                                         "priceType": "FIXED",
                                         "servants": []
                                     },
                                     "discount": null,
                                     "priceWithDiscount": 20000
                                 },
                                 "selected": true,
                                 "optionInfo": {
                                     "id": 1495,
                                     "title": "ServiceOption"
                                 }
                             }
                         ],

                         "participantPersons": [
                             {
                                 "id":null,
                                 "personInfoId":null,
                                 "orderBagItemDtailId":null,
                                 "personInfo":{
                                     "id":null,
                                     "nationalCode":'0080338291',
                                     "fisrtName":'sara',
                                     "lastName":'rezaie',
                                     "gender":null,
                                     "phoneNumber":"091291291256"
                                 }
                             }
                         ],
                         "timeSession": {
                             "id": 1646,
                             "startTime": "2016-11-07T14:40:00.000Z",
                             "endTime": "2016-11-07T15:10:00.000Z",
                             "startDate": "2016-11-07",
                             "endDate": "2016-11-07",
                             "capacity": 55,
                             "comment": " آماده",
                             "price": 50000,
                             "discount": 10,
                             "serviceTimeSessionInfoId": 1637,
                             "sessionTimesId": null
                         }
                     }*/


                ]
            };

            vm.orderBagVM = TestServices.saveOrderBagVM().save(vm.orderBagVM, onSaveSuccess, onSaveError);

        }


        function onSaveSuccess(result) {

            vm.orderBagVM = result;
            vm.isSaving = false;
        }

        function onSaveError() {

            vm.isSaving = false;
        }

        function testReminder() {
            TestServices.testReminder().query();
        }

        function getImageDataVMByAlbumId() {
            vm.imageList = TestServices.getImageDataVMByAlbumId('3825').query();
        }

        function sendTestSMS() {
            TestServices.sendTestSMS(vm.companyKeyUrl, vm.phoneNumber).query();
        }

        function sendVerificationTestSMS() {
            TestServices.sendVerificationTestSMS(vm.companyKeyUrl, vm.phoneNumber).query();
        }

        function sendTestEmail() {
            TestServices.sendTestEmail().query();
        }

        function finalApproveOrderBagById() {
            TestServices.finalApproveOrderBagById('7601').query();
        }

        function testSubscriptionNearToExpire() {
            TestServices.testSubscriptionNearToExpire().query();
        }

        function testUpdateExpireCompanyStatus() {
            TestServices.testUpdateExpireCompanyStatus().query();
        }

        function insertNewConversation() {

            var conversationVM = {};
            conversationVM.id = null;
            conversationVM.companyId = 1003;
            conversationVM.subject = 'test 1'


            vm.conversation = TestServices.insertNewConversation().save(conversationVM, onNewConvSuccess, onNewConvError);

        }

        function onNewConvSuccess(result) {
            vm.conversation = result;
        }

        function onNewConvError() {

        }

        function insertNewMessage() {

            var messageVM = {};
            messageVM.id = null;
            messageVM.conversationId = 1484400;
            messageVM.content = 'new message'

            vm.conversation = TestServices.insertNewMessage().save(messageVM, onNewMsgSuccess, onNewConvError);
        }

        function onNewMsgSuccess(result) {
            vm.message = result;
        }

        function cancelAllExpireTwoStepReserve() {
            TestServices.cancelAllExpireTwoStepReserve().query();
        }

        function getServiceAvailableDatesInNextDays() {
            var serviceItemid = prompt("Enter ServiceId", "0");
            var nextDays = prompt('Enter number of next days', "7");
            TestServices.getServiceAvailableDatesInNextDays(serviceItemid, nextDays).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function getServiceAvailableTimesInOneDate() {
            var serviceItemid = prompt("Enter ServiceId", "0");
            var date = prompt('date', "1397/03/15");
            var fromHour = prompt('from Hour', "8");
            var toHour = prompt('to Hour', "20");
            TestServices.getServiceAvailableTimesInOneDate(serviceItemid, date, fromHour, toHour).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function getCustomerByMobileNumber() {
            var mobileNumber = prompt('Enter customer mobile number', '09123470060');
            TestServices.getCustomerByMobileNumber(mobileNumber).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function addTaminBranch() {
            var branchtitle = prompt('Enter branch title', 'شعبه');
            var branchurl = prompt('Enter bra nch url', 'tamin');
            var user = prompt('Enter user', 'acc');
            var baseurl = prompt('Enter base company url', 'tamin');
            TestServices.addTaminBranch(branchtitle, branchurl, user, baseurl).save(function (result) {
                vm.result = result;
                alert("DONE");
            }, function (res) {
                vm.message = res;
                alert("FAILED");
            });
        }

        function addmultiplebranch() {
            var branches = JSON.parse(vm.branchlist).list;
            angular.forEach(branches, function (br) {
                var yes = confirm(br.branchtitle + '/' + br.branchurl + '/' + br.user + '/' + br.baseurl);
                if (yes) {
                    TestServices.addTaminBranch(br.branchtitle, br.branchurl, br.user, br.baseurl).save(function (result) {
                        vm.result = result;
                        alert("DONE");
                    }, function (res) {
                        vm.message = res;
                        alert("FAILED");
                    });
                }
            })


        }

        function saveLocation(comapnyId, tel, address, mapX, mapY) {
            var location = {
                address: address,
                mapX: mapX,
                mapY: mapY
            }
            TestServices.addLocation(comapnyId, tel).save(location, function (data) {

            })
        }

        function addLocationList() {
            var locations = JSON.parse(vm.locationlist);
            var tocontinue = true;
            var row = 0;
            angular.forEach(locations, function (l) {
                row++;


                TestServices.findcompanyByKeyUrl(l.url).get(function (company) {
                    if (company && company.id) {
                        saveLocation(company.id, l.phone, l.address, l.lat, l.lng);
                    } else {
                        console.log('url ' + l.url + ' is not valid');
                    }

                });

            })
        }

        function sendTestCustomerSatisfactionSMS() {

            if (vm.orderBagId != null)
                TestServices.sendTestCustomerSatisfactionSMS(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function sendAllSatisfactionNotification() {

            TestServices.sendAllSatisfactionNotification().query();
        }


        function addDaysToSubscriptionByCompany() {
            if (vm.companyKeyUrl != "" && vm.daysToAdd > 0)
                TestServices.addDaysToSubscriptionByCompany(vm.companyKeyUrl, vm.daysToAdd).query();
        }


        function addFreeSMSPackage() {
            if (vm.smsPckCompanyUrl)
                TestServices.addFreeSMSPackage(vm.smsPckCompanyUrl, vm.smsPckStartDate).query(function (re) {
                    alert('free sms package added successfully');
                }, function (er) {
                    alert('error on adding sms package');
                    console.log(er);

                });
        }

        function addCustomSMSPackage() {
            if (vm.smsPckCompanyUrl)
                TestServices.addCustomSMSPackage(vm.smsPckCompanyUrl, vm.selectedSMSPackage, vm.smsPckStartDate).query(function (re) {
                    alert('free sms package added successfully');
                }, function (er) {
                    alert('error on adding sms package');
                    console.log(er);

                });
        }

        function getCompaniesSubscriptionNearToExpire() {
            var data = [];
            TestServices.getCompaniesSubscriptionNearToExpire().query().$promise.then(function (data) {
                vm.companies = data;
                var company = "";
                angular.forEach(vm.companies, function (item) {
                    company += ' || ' + item.title + ' - ' + item.keyUrl;
                });
                if (company.length > 0)
                    window.confirm(company);
                else
                    window.confirm("No Result Found !!");
            });

        }

        function sendTestCustomerFirstReminderSMS() {

            if (vm.orderBagId != null)
                TestServices.sendTestCustomerFirstReminderSMS(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function sendRebookNotification() {
            TestServices.sendRebookNotification().query();
        }

        function sendRebookSMS() {
            if (vm.orderBagId)
                TestServices.sendRebookSMS(vm.orderBagId).query();
        }


        function getTopNCompanyManager() {
            if (vm.recordCount)
                vm.companyManagers = TestServices.getTopNCompanyManager(vm.recordCount).query();
            else {
                alert(" is Null !");
            }
        }

        function getServantByMarketPlaceFilter() {
            var filter = {};
            filter.marketPlaceId = 1;
            // filter.tag = 'همایش';
            // filter.searchText = null;
            // filter.locationText = null;

            TestServices.getServantByMarketPlaceFilter().query(filter, function (result) {
                vm.marketPlaceServants = result;
            });

        }

        function addDaysToSubscriptionByCompaniesCategory() {

            if (vm.category != "" && vm.daysToAdd > 0)
                TestServices.addDaysToSubscriptionByCompaniesCategory(vm.category, vm.daysToAdd).query();
        }

        function setFeatureByCompanySubscriptionId() {
            if (vm.companySubsID != "")
                TestServices.setFeatureByCompanySubscriptionId(vm.companySubsID).query();
        }

        function sendTestReservationConfirmedInfoMsg() {

            if (vm.orderBagId != null)
                TestServices.sendTestReservationConfirmedInfoMsg(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function getToken() {

            var loginVm = {};
            loginVm.username = 'm.mansori';
            loginVm.password = '123456';
            loginVm.rememberMe = true;

            TestServices.getToken().save(loginVm, function (result) {

                console.log(result);

            }, function (result) {


                console.log("ERROR!")
            });

        }


        function createUserAccessForServantByPhoneNumber() {

            if (vm.servantPhoneNumber) {
                TestServices.createUserAccessForServantByPhoneNumber().save(vm.servantPhoneNumber, function (result) {
                    alert(result.status);
                }, function (result) {

                    alert(result.status);
                });

            }
        }

        function getReserveListByCustomer() {
            var mobileNumber = prompt('Enter customer mobile number', '09123470060');
            TestServices.getReserveListByCustomer(mobileNumber).query(function (result) {
                vm.result = result;
            }, function (res) {
                vm.message = res;
            });
        }

        function addBatchCompanyCustomer() {
        debugger;
            if (vm.batchCompanyCustomer) {
                var customers = JSON.parse(vm.batchCompanyCustomer);
                var newCompanyCustomer = [];

                angular.forEach(customers, function (customer) {

                    if (customer.fullName) {
                        var fullName = customer.fullName.trim();
                        customer.firstName = fullName.substring(0, fullName.indexOf(" ")).trim();
                        customer.lastName = fullName.substring(fullName.indexOf(" "), fullName.length).trim();

                    }

                    if (!customer.phoneNumber || !customer.firstName) {

                    } else {
                        var companyCustomer = {};
                        companyCustomer.customer = {};
                        companyCustomer.customer.personalInfo = {};

                        if (customer.phoneNumber.length == 10)
                            customer.phoneNumber = '0' + customer.phoneNumber;

                        companyCustomer.customer.personalInfo.fisrtName = customer.firstName;
                        companyCustomer.customer.personalInfo.phoneNumber = customer.phoneNumber;
                        if (customer.lastName)
                            companyCustomer.customer.personalInfo.lastName = customer.lastName;
                        if (customer.email)
                            companyCustomer.customer.personalInfo.email = customer.email;
                        if (customer.nationalCode)
                            companyCustomer.customer.personalInfo.nationalCode = customer.nationalCode;
                        if (customer.gender) {
                            if (customer.gender == 'MALE')
                                companyCustomer.customer.personalInfo.gender = true;
                            if (customer.gender == 'FEMALE')
                                companyCustomer.customer.personalInfo.gender = false;
                        }

                        if (customer.address) {
                            companyCustomer.customer.personalInfo.location = {};
                            companyCustomer.customer.personalInfo.location.address = customer.address;
                        }
//                        if(customer.birthDate) {
//                            companyCustomer.customer.personalInfo.birthDate = customer.birthDate;
//                        }
//
                        if (customer.birthDate) {
                            var dateParts = customer.birthDate.trim().split('/');

                            if (dateParts.length === 3) {
                                var gregorianDate = jalaliToGregorian(
                                    parseInt(dateParts[0], 10),
                                    parseInt(dateParts[1], 10),
                                    parseInt(dateParts[2], 10)
                                );

                                companyCustomer.customer.personalInfo.birthDate = moment({
                                    year: gregorianDate.year,
                                    month: gregorianDate.month - 1,
                                    day: gregorianDate.day,
                                    hour: 0,
                                    minute: 0,
                                    second: 0,
                                    millisecond: 0
                                }).format('YYYY-MM-DDTHH:mm:ssZ');
                            }
                        }

                        // intake fileds
                        var keyNames = Object.keys(customer);
                        var intakeFieldData = {};
                        var intakeFieldList = [];
                        angular.forEach(keyNames, function (key) {
                            if (key.includes("intake_")) {
                                var fieldName = key.replace("intake_", "");
                                var fieldValue = customer[key];
                                if (fieldValue) {
                                    var field = {};
                                    field.name = fieldName;
                                    field.value = fieldValue;
                                    field.label = null;
                                    field.field = null;

                                    intakeFieldList.push(field);
                                }
                            }
                        });

                        if (intakeFieldList && intakeFieldList.length > 0) {
                            intakeFieldData.fields = intakeFieldList;
                            companyCustomer.customerIntakeData = intakeFieldData;
                        }

                        //....................................................
                        newCompanyCustomer.push(companyCustomer);

                    }
                });

                if (newCompanyCustomer && newCompanyCustomer.length > 0) {
                    TestServices.addBatchCustomer().save(newCompanyCustomer, function (result) {
                        alert("done!");
                    }, function (result) {

                        alert("failed");
                    });
                }

            }
        }

        function testIcal() {
            TestServices.testIcalCalendat().query(function (result) {
                alert(result);
            }, function (res) {
                alert('error');
            });

        }

        function addSampleGtag() {

            //user Free Account Started
            try {
                //

                // gtag('event', 'freemium_start', {
                //     "items": [
                //         {
                //             "id": "PL102",
                //             "name": "14 Days Free Account",
                //             "list_name": "",
                //             "brand": "Planovin",
                //             "category": "CONSULT",
                //             "price": '0'
                //         }
                //     ]
                // });


                gtag('event', 'purchase_success', {
                    "transaction_id": 333334,
                    "value": 44000,
                    "currency": "USD",
                    "tax": 0,
                    "shipping": 0,
                    "items": [
                        {
                            "id": "PL104",
                            "name": "Package Base Test",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": "category_test",
                            "quantity": 1,
                            "price": 44000
                        }

                    ]
                });

            } catch (err) {
                console.log(err);
            }
        }

        function sendTestCustomerSecondReminderSMS() {

            if (vm.orderBagId != null)
                TestServices.sendTestCustomerSecondReminderSMS(vm.orderBagId).query();
            else {
                alert("OrderBagId is Null !");
            }
        }

        function sendTestSMSPackageGoingToFinish() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSMSPackageGoingToFinish(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSMSPackageFinished() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSMSPackageFinished(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSubscriptionNearToExpireNotification() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSubscriptionNearToExpireNotification(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSubscriptionIsExpiredNotification() {

            if (vm.companyKeyUrl != null)
                TestServices.sendTestSubscriptionIsExpiredNotification(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestAutomaticSubscriptionNearToExpireNotification() {

            TestServices.sendTestAutomaticSubscriptionNearToExpireNotification().query();

        }

        function sendTestAutomaticApproveReserveRequest() {

            TestServices.sendTestAutomaticApproveReserveRequest().query();

        }

        function deActiveCompany() {
            if (vm.companyKeyUrl != null)
                CompanyCustom.deActiveCompanyByKeyURL(vm.companyKeyUrl).query();
            else {
                alert("companyKeyUrl is Null !");
            }
        }

        function sendTestSupplierFirstJourneyNotification() {
            if (vm.phoneNumber)
                TestServices.sendTestSupplierFirstJourneyNotification(vm.phoneNumber).query(function (result) {
                    alert("DONE!")
                }, function (res) {
                    alert("Failed!")
                });
            else
                alert("phoneNumber is Null !");
        }


        function invoiceReport() {

            $window.open(TestServices.getInvoiceReportPdfUrl(26910632), '_blank');

        }


        function addBatchInvoiceInfo() {

            if (vm.batchInvoiceInfo) {
                var invoiceInfos = JSON.parse(vm.batchInvoiceInfo);
                var newInvoiceInfo = [];

                var iterator = 0;

                angular.forEach(invoiceInfos, function (invoiceInfo) {

                    if (!invoiceInfo.phoneNumber || !invoiceInfo.fullName) {

                    } else {
                        var companyCustomer = {};
                        companyCustomer.personalInfo = {};

                        if (invoiceInfo.phoneNumber.length == 10)
                            invoiceInfo.phoneNumber = '0' + invoiceInfo.phoneNumber;


                        invoiceInfo.fullName = invoiceInfo.fullName.trim();
                        companyCustomer.personalInfo.fisrtName = invoiceInfo.fullName.substring(0, invoiceInfo.fullName.indexOf(" ")).trim();
                        companyCustomer.personalInfo.lastName = invoiceInfo.fullName.substring(invoiceInfo.fullName.indexOf(" "), invoiceInfo.fullName.length).trim();

                        companyCustomer.personalInfo.phoneNumber = invoiceInfo.phoneNumber;

                        //.........................................
                        //add items
                        var existInvoice = newInvoiceInfo.filter(function (newItem) {
                            if (newItem.invoiceNo == invoiceInfo.invoiceNo)
                                return true;
                        });


                        if (existInvoice && existInvoice.length > 0) {
                            var item = {};
                            item.title = invoiceInfo.itemTitle;
                            item.type = "SERVICE";
                            item.price = 0;
                            item.qty = 1;
                            item.discount = 0;
                            if (invoiceInfo.serviceItemId)
                                item.referencedItemId = invoiceInfo.serviceItemId;
                            item.status = "DONE";


                            angular.forEach(newInvoiceInfo, function (info) {
                                if (info.invoiceNo == invoiceInfo.invoiceNo)
                                    info.invoiceInfoItems.push(item);
                            })

                        } else {

                            if (iterator >= 155) {
                                var x = 0;
                            }
                            var newInvoice = {};
                            newInvoice.customer = companyCustomer;
                            iterator++;
                            console.log(iterator);
                            console.log(companyCustomer);


                            var discount = 0;
                            var finalPrice = parseInt(invoiceInfo.finalPrice);

                            if (invoiceInfo.discount)
                                discount = parseInt(invoiceInfo.discount);

                            if (!invoiceInfo.totalServicePrice)
                                newInvoice.totalServicePrice = finalPrice + discount;

                            newInvoice.totalProductPrice = 0;
                            newInvoice.totalOptionPrice = 0;
                            newInvoice.totalVAT = 0;
                            newInvoice.totalDiscount = discount;
                            newInvoice.finalPrice = finalPrice;
                            newInvoice.comment = invoiceInfo.comment;
                            newInvoice.invoiceNo = invoiceInfo.invoiceNo;

                            //set invoice date

                            var dateTimeStr = invoiceInfo.invoiceDateTimeStr.split(" ");


                            var dateStr = toEnglishNumber(dateTimeStr[0]);
                            var dateSplit = dateStr.split('/');

                            var y = Number(dateSplit[0]);
                            var m = Number(dateSplit[1]);
                            var d = Number(dateSplit[2]);

                            var date = jalaali.jalaaliToDateObject(y, m, d);


                            var invoiceTime = dateTimeStr[1];
                            var split = invoiceTime.split(':');
                            date.setHours(split[0], split[1], 0);

                            newInvoice.invoiceDate = date;


                            var item = {};
                            item.title = invoiceInfo.itemTitle;
                            item.type = "SERVICE";
                            item.price = finalPrice + discount;
                            item.qty = 1;
                            item.discount = 0;
                            if (invoiceInfo.serviceItemId)
                                item.referencedItemId = invoiceInfo.serviceItemId;
                            item.status = "DONE";

                            newInvoice.invoiceInfoItems = [];

                            newInvoice.invoiceInfoItems.push(item);

                            newInvoiceInfo.push(newInvoice);
                        }

                        //....................................................

                    }
                });

                if (newInvoiceInfo && newInvoiceInfo.length > 0) {
                    TestServices.addBatchInvoiceInfo().save(newInvoiceInfo, function (result) {
                        alert("done!");
                    }, function (result) {

                        alert("failed");
                    });
                }

            }
        }


        function toEnglishNumber(str) {
            var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
                arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

            if (typeof str === 'string') {
                for (var i = 0; i < 10; i++) {
                    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
                }
            }
            return str;
        }

        function sendAutomaticMarketingCampaign() {
            TestServices.sendAutomaticMarketingCampaign().query();
        }

        function testCalculateCommission() {
            TestServices.testCalculateCommission().query();
        }

        function testTehranTime() {

            var jun = moment();
            var xx = jun.tz('Asia/Tehran').format('');  // 5am PDT
            return xx;
        }

        function testSmsNearFinish() {
            TestServices.testSmsNearFinish().query();
        }

        function sendMarketingCampaign() {
            if(vm.sendMarketingCampaignLoading || !vm.marketingCampaignId) return
            vm.sendMarketingCampaignLoading = true;

            TestServices
                .testSendMarketingCampaign()
                .send(
                    {
                        marketingCampaignId: vm.marketingCampaignId
                    },
                    onMarketingSaveSuccess,
                    onMarketingSaveError
                );

           function onMarketingSaveSuccess(result) {
               vm.sendMarketingCampaignLoading = false;
               alert(result.message);
           }

           function onMarketingSaveError(response) {
               vm.sendMarketingCampaignLoading = false;
               alert(response.data.message);
           }
        }


        function jalaliToGregorian(jy, jm, jd) {
            jy += 1595;

            var days =
                -355668 +
                (365 * jy) +
                (Math.floor(jy / 33) * 8) +
                Math.floor(((jy % 33) + 3) / 4) +
                jd +
                (jm < 7
                    ? (jm - 1) * 31
                    : ((jm - 7) * 30) + 186);

            var gy = 400 * Math.floor(days / 146097);
            days %= 146097;

            if (days > 36524) {
                gy += 100 * Math.floor(--days / 36524);
                days %= 36524;

                if (days >= 365) {
                    days++;
                }
            }

            gy += 4 * Math.floor(days / 1461);
            days %= 1461;

            if (days > 365) {
                gy += Math.floor((days - 1) / 365);
                days = (days - 1) % 365;
            }

            var gd = days + 1;
            var monthDays = [
                0,
                31,
                ((gy % 4 === 0 && gy % 100 !== 0) || gy % 400 === 0) ? 29 : 28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ];

            var gm = 1;

            while (gm <= 12 && gd > monthDays[gm]) {
                gd -= monthDays[gm];
                gm++;
            }

            return {
                year: gy,
                month: gm,
                day: gd
            };
        }

        function mergeCompanyCustomers() {
            debugger;

            if (!vm.companyCustomerIds) {
                return;
            }

            var customerIds = vm.companyCustomerIds
                .split(',')
                .map(function (id) {
                    return parseInt(id.trim(), 10);
                })
                .filter(function (id) {
                    return !isNaN(id);
                });

            if (customerIds.length === 0) {
                return;
            }

            CompanyCustomerCustom
                .mergeCompanyCustomers()
                .merge(
                    customerIds,
                    onMergeSaveSuccess,
                    onMergeSaveError
                );

            function onMergeSaveSuccess(result) {
                // alert(result.message);
                alert('success');
            }

            function onMergeSaveError(response) {
                alert(response.data.failureReason);
            }
        }

        function removePhoneNumber() {
            if(vm.removePhoneNumberLoading) return
            vm.removePhoneNumberLoading = true;
            TestServices.removePhoneNumber().delete({phoneNumber: vm.phoneNumber},
                function(res){
                    alert('User deleted Successfully');
                    vm.removePhoneNumberLoading = false;
                }, function(err){
                    alert(err.data.message)
                    vm.removePhoneNumberLoading = false;
                })
        }
    }
})();
;
(function () {
  "use strict";

  angular.module("tikonApp").factory("QueryParamsService", QueryParamsService);

  QueryParamsService.$inject = ["$location"];

  function QueryParamsService($location) {
    var filters = {};
    return {
      getFilters: function () {
        filters = angular.copy($location.search());
        return filters;
      },
      updateFilter: function (key, value) {
        filters = this.getFilters();
        filters[key] = value;
        $location.search(filters);
      },
      removeFilter: function (key) {
        filters = this.getFilters();
        delete filters[key];
        $location.search(filters);
      },
      resetFilters: function () {
        filters = {};
        $location.search({});
      },
    };
  }
})();
;
(function () {
  angular.module("tikonApp").factory("ProgressBarService", ProgressBarService);
  ProgressBarService.$inject = ["$http", "$timeout"]

  function ProgressBarService($http, $timeout) {
    var loading_screen = null;
    var isProgressOpen = false;

    function isLoading() {
      if ($http.pendingRequests.length > 0) {
        var postRequest = $http.pendingRequests.filter(function (req) {
          return req.method !== "GET";
        });
        return postRequest.length > 0;
      }
      return false;
    }

    function show() {
      if (isProgressOpen) return loading_screen;

      isProgressOpen = true;

      var html =
        "<div>" +
        '<span translate="messages.pleaseWait" > لطفا منتظر باشید...</span>' +
        "</div>" +
        '    <div class="sk-wave"> ' +
        '<div class="sk-rect sk-rect1"></div> ' +
        '<div class="sk-rect sk-rect2"></div> ' +
        '<div class="sk-rect sk-rect3"></div>' +
        ' <div class="sk-rect sk-rect4"></div> ' +
        '<div class="sk-rect sk-rect5"></div> ' +
        '<div class="sk-rect sk-rect6"></div> ' +
        '<div class="sk-rect sk-rect7"></div> ' +
        "</div>";

      loading_screen = pleaseWait({
        logo: "/content/images/logo.png",
        loadingHtml: html,
      });

      $timeout(hide, 5000);

      return loading_screen;
    }

    function hide() {
      if (loading_screen) {
        loading_screen.finish();
        isProgressOpen = false;
      }
    }

    return {
      show: show,
      hide: hide,
      isLoading: isLoading,
    };
  }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo: getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function (result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace: true,
            restrict: 'AE',
            template: '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function (response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('FileUtil', FileUtil);

    FileUtil.$inject = ['$resource'];

    function FileUtil($resource) {

        var download_uploaded_file = function (request, onSuccess, onError) {

            request.get({}, function (result) {

                var dlfile = "api/downloadUploadedFile/" + result.filename;
                result.dllink = dlfile;
                if (onSuccess) {
                    onSuccess(result);
                }
                setTimeout(function () {
                    document.location.href = dlfile;
                }, 500);


            }, function (error) {
                if (onError)
                    onError(error);
            });
        }

        var downloadFile = function (filename) {
            var resourceUrl = 'api/downloadfile?fileName=' + filename;
            return $resource(resourceUrl, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            downloadFile: downloadFile,
            downloadUploadedFile: download_uploaded_file
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService', 'PackageFeatureListCustom', 'CompanyInfoQuery', '$localStorage'];

    function Principal($q, Account, JhiTrackerService, PackageFeatureListCustom, CompanyInfoQuery, $localStorage) {
        var _identity,
            _authenticated = false;

        var _company = null;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getCurrentCompany: getCurrentCompany,
            setCurrentCompany: setCurrentCompany,
            getCurrentCompanyFeatureList: getCurrentCompanyFeatureList,
            hasSpecialFeatureAccess: hasSpecialFeatureAccess,
            canAddNewServant: canAddNewServant,
            setCurrentCompanyFeatureList: setCurrentCompanyFeatureList
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {

            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function getCurrentCompany() {
            return _company;
        }

        function setCurrentCompany(company) {
            return _company = company;
        }

        function getCurrentCompanyFeatureList() {

            console.log("NEW VERSION !!! lastCompanyFeatureCheck : " + $localStorage.lastCompanyFeatureCheck);


            var lastCheck = getTimeStamp();
            if (!$localStorage.lastCompanyFeatureCheck)
                $localStorage.lastCompanyFeatureCheck = lastCheck;

            if ($localStorage.companyFeatureList != undefined && !lastCheckExpired()) {
                console.log($localStorage.companyFeatureList.featureInfoObject);
                return $localStorage.companyFeatureList;
            } else {
                PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                    setCurrentCompanyFeatureList(result);
                    $localStorage.lastCompanyFeatureCheck = lastCheck;
                    return result;
                });
            }

        }

        function setCurrentCompanyFeatureList(featureList) {
            return $localStorage.companyFeatureList = featureList;
        }


        function hasSpecialFeatureAccess(feature) {

            console.log("hasSpecialFeatureAccess Checking . . . ");

            if (!$localStorage.companyFeatureList) {
                return false;
            }

            if (!$localStorage.companyFeatureList.featureInfoObject)
                return false;


            var _companyFeatureList = $localStorage.companyFeatureList;

            console.log("_companyFeatureList : ");
            console.log(_companyFeatureList.featureInfoObject);

            switch (feature) {

                case 'twoStepVerification':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.twoStepVerification)
                        return true;
                    break;
                case 'satisfactionMessage_SMS':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_SMS)
                        return true;
                    break;
                case 'satisfactionMessage_Email':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_Email)
                        return true;
                    break;
                case 'cancelReserveByCustomer':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.cancelReserveByCustomer)
                        return true;
                    break;
                case 'autoMultiReserveMode':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.autoMultiReserveMode)
                        return true;
                    break;
                case 'couponCode':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.couponCode)
                        return true;
                    break;
                case 'customerGroup':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerGroup)
                        return true;
                    break;
                case 'customerAccess':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerAccess)
                        return true;
                    break;
                case 'reservePattern':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.reservePattern)
                        return true;
                    break;
                case 'customPricingForServant':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customPricingForServant)
                        return true;
                    break;
                case 'reserveLimit':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.reserveLimit)
                        return true;
                    break;
                case 'customerRebookReminder_SMS':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerRebookReminder_SMS)
                        return true;
                    break;
                case 'customerSecondReminder':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.customerSecondReminder)
                        return true;
                    break;
                case 'advancedPricing':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.advancedPricing)
                        return true;
                    break;
                case 'whatsAppSupport':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.whatsAppSupport)
                        return true;
                    break;
                case 'servantServiceScheduling':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.servantServiceScheduling)
                        return true;
                    break;
                case 'serviceCapacity':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.serviceCapacity)
                        return true;
                    break;
                case 'invoice':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.invoice)
                        return true;
                    break;
                case 'marketingCampaign':
                    if (_companyFeatureList.featureInfoObject.specialFeatureInfo.marketingCampaign)
                        return true;
                    break;


            }

            return false;
        }

        function canAddNewServant(count) {
            if (!$localStorage.companyFeatureList || !$localStorage.companyFeatureList.featureInfoObject) {
                // getCurrentCompanyFeatureList();
                // if(!_companyFeatureList)
                if (count >= 2)
                    return false;
                else
                    return true;
            }

            if ($localStorage.companyFeatureList.featureInfoObject) {
                if ($localStorage.companyFeatureList.featureInfoObject.servantCount) {
                    if ($localStorage.companyFeatureList.featureInfoObject.servantCount <= count)
                        return false;
                }
            }

            return true;
        }

        function getTimeStamp() {
            var now = new Date();
            var stampMinute = Math.ceil(now.getTime() / 60000);
            return stampMinute;
        }

        function lastCheckExpired() {
            if (!$localStorage.lastCompanyFeatureCheck)
                return false;

            var now = getTimeStamp();
            if (now - $localStorage.lastCompanyFeatureCheck > 2)
                return true;

            return false;
        }

    }
})();
;
// (function() {
//     'use strict';
//
//     angular
//         .module('tikonApp')
//         .factory('Principal', Principal);
//
//     Principal.$inject = ['$q', 'Account', 'JhiTrackerService','PackageFeatureListCustom','CompanyInfoQuery','$localStorage'];
//
//     function Principal ($q, Account, JhiTrackerService,PackageFeatureListCustom,CompanyInfoQuery,$localStorage) {
//         var _identity,
//             _authenticated = false;
//
//         var _company = null;
//
//         var service = {
//             authenticate: authenticate,
//             hasAnyAuthority: hasAnyAuthority,
//             hasAuthority: hasAuthority,
//             identity: identity,
//             isAuthenticated: isAuthenticated,
//             isIdentityResolved: isIdentityResolved,
//             getCurrentCompany : getCurrentCompany,
//             setCurrentCompany :setCurrentCompany,
//             getCurrentCompanyFeatureList:getCurrentCompanyFeatureList,
//             hasSpecialFeatureAccess:hasSpecialFeatureAccess,
//             canAddNewServant:canAddNewServant,
//             setCurrentCompanyFeatureList:setCurrentCompanyFeatureList
//         };
//
//         return service;
//
//         function authenticate (identity) {
//             _identity = identity;
//             _authenticated = identity !== null;
//         }
//
//         function hasAnyAuthority (authorities) {
//             if (!_authenticated || !_identity || !_identity.authorities) {
//                 return false;
//             }
//
//             for (var i = 0; i < authorities.length; i++) {
//                 if (_identity.authorities.indexOf(authorities[i]) !== -1) {
//                     return true;
//                 }
//             }
//
//             return false;
//         }
//
//         function hasAuthority (authority) {
//             if (!_authenticated) {
//                 return $q.when(false);
//             }
//
//             return this.identity().then(function(_id) {
//                 return _id.authorities && _id.authorities.indexOf(authority) !== -1;
//             }, function(){
//                 return false;
//             });
//         }
//
//         function identity (force) {
//
//             var deferred = $q.defer();
//
//             if (force === true) {
//                 _identity = undefined;
//             }
//
//             // check and see if we have retrieved the identity data from the server.
//             // if we have, reuse it by immediately resolving
//             if (angular.isDefined(_identity)) {
//                 deferred.resolve(_identity);
//
//                 return deferred.promise;
//             }
//
//             // retrieve the identity data from the server, update the identity object, and then resolve.
//             Account.get().$promise
//                 .then(getAccountThen)
//                 .catch(getAccountCatch);
//
//             return deferred.promise;
//
//             function getAccountThen (account) {
//                 _identity = account.data;
//                 _authenticated = true;
//                 deferred.resolve(_identity);
//                 JhiTrackerService.connect();
//             }
//
//             function getAccountCatch () {
//                 _identity = null;
//                 _authenticated = false;
//                 deferred.resolve(_identity);
//             }
//         }
//
//         function isAuthenticated () {
//             return _authenticated;
//         }
//
//         function isIdentityResolved () {
//             return angular.isDefined(_identity);
//         }
//
//         function getCurrentCompany () {
//             return _company;
//         }
//
//         function setCurrentCompany (company) {
//             return _company = company;
//         }
//
//         function getCurrentCompanyFeatureList () {
//
//             console.log("NEW VERSION !!! lastCompanyFeatureCheck : " + $localStorage.lastCompanyFeatureCheck);
//             var lastCheck = getTimeStamp();
//             if(!$localStorage.lastCompanyFeatureCheck)
//                 $localStorage.lastCompanyFeatureCheck = lastCheck;
//
//             if($localStorage.companyFeatureList != undefined && !lastCheckExpired())
//                 return $localStorage.companyFeatureList;
//             else
//             {
//                 PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function(result) {
//                     setCurrentCompanyFeatureList(result);
//                     $localStorage.lastCompanyFeatureCheck = lastCheck;
//                     return result;
//                 });
//             }
//
//         }
//
//         function setCurrentCompanyFeatureList(featureList)
//         {
//             return $localStorage.companyFeatureList = featureList;
//         }
//
//
//         function hasSpecialFeatureAccess (feature) {
//
//             if (!$localStorage.companyFeatureList) {
//                 return false;
//             }
//
//             if(!$localStorage.companyFeatureList.featureInfoObject)
//                 return false;
//
//
//             var _companyFeatureList = $localStorage.companyFeatureList;
//
//             switch (feature) {
//
//                 case 'twoStepVerification':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.twoStepVerification)
//                         return true;
//                     break;
//                 case 'satisfactionMessage_SMS':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_SMS)
//                         return true;
//                     break;
//                 case 'satisfactionMessage_Email':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_Email)
//                         return true;
//                     break;
//                 case 'cancelReserveByCustomer':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.cancelReserveByCustomer)
//                         return true;
//                     break;
//                 case 'autoMultiReserveMode':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.autoMultiReserveMode)
//                         return true;
//                     break;
//                 case 'couponCode':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.couponCode)
//                         return true;
//                     break;
//                 case 'customerGroup':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.customerGroup)
//                         return true;
//                     break;
//                 case 'customerAccess':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.customerAccess)
//                         return true;
//                     break;
//                 case 'reservePattern':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.reservePattern)
//                         return true;
//                     break;
//                 case 'customPricingForServant':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.customPricingForServant)
//                         return true;
//                     break;
//                 case 'reserveLimit':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.reserveLimit)
//                         return true;
//                     break;
//                 case 'customerRebookReminder_SMS':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.customerRebookReminder_SMS)
//                         return true;
//                     break;
//                 case 'customerSecondReminder':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.customerSecondReminder)
//                         return true;
//                     break;
//                 case 'advancedPricing':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.advancedPricing)
//                         return true;
//                     break;
//                 case 'whatsAppSupport':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.whatsAppSupport)
//                         return true;
//                     break;
//                 case 'servantServiceScheduling':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.servantServiceScheduling)
//                         return true;
//                     break;
//                 case 'serviceCapacity':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.serviceCapacity)
//                         return true;
//                     break;
//                 case 'invoice':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.invoice)
//                         return true;
//                     break;
//                 case 'marketingCampaign':
//                     if(_companyFeatureList.featureInfoObject.specialFeatureInfo.marketingCampaign)
//                         return true;
//                     break;
//
//
//             }
//
//             return false;
//         }
//
//         function canAddNewServant(count){
//             if (! $localStorage.companyFeatureList || ! $localStorage.companyFeatureList.featureInfoObject) {
//                 // getCurrentCompanyFeatureList();
//                 // if(!_companyFeatureList)
//                 if(count >=2)
//                     return false;
//                 else
//                     return true;
//             }
//
//             if( $localStorage.companyFeatureList.featureInfoObject)
//             {
//                 if( $localStorage.companyFeatureList.featureInfoObject.servantCount) {
//                     if ( $localStorage.companyFeatureList.featureInfoObject.servantCount <= count)
//                         return false;
//                 }
//             }
//
//             return true;
//         }
//
//         function getTimeStamp() {
//             var now = new Date();
//             var stampMinute = Math.ceil(now.getTime()/60000);
//             return stampMinute;
//         }
//
//         function lastCheckExpired() {
//             if(!$localStorage.lastCompanyFeatureCheck)
//                 return false;
//
//             var now = getTimeStamp();
//             if(now - $localStorage.lastCompanyFeatureCheck > 2)
//                 return true;
//
//             return false;
//         }
//
//     }
// })();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PasswordCustom', PasswordCustom);

    PasswordCustom.$inject = ['$resource', 'ENV'];

    function PasswordCustom($resource, ENV) {

        var requestPasswordByPhoneNumber = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/account/reset_password_by_phone_number';
            return $resource(resourceUrl, {}, {}
            );
        };

        return {
            requestPasswordByPhoneNumber: requestPasswordByPhoneNumber
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Marketing', Marketing);

    Marketing.$inject = ['$resource'];

    function Marketing($resource) {
        // return $resource('api/register', {}, {});
        var marketingAttribution = function() {
            var resourceUrl = 'api/v2/marketing/attribution';
            return $resource(resourceUrl, {}, { });
        }

        return {
            marketingAttribution: marketingAttribution
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('hasNotAuthority', hasNotAuthority);

    hasNotAuthority.$inject = ['Principal'];

    function hasNotAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasNotAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setHidden();
                            } else {
                                setVisible();

                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySession', CompanySession);

    CompanySession.$inject = ['$http', '$localStorage', 'CompanySubscriptionStatusCustom'];

    function CompanySession($http, $localStorage, CompanySubscriptionStatusCustom) {
        var service = {
            hasValidSubscription: hasValidSubscription,
            resetCompanySession: resetCompanySession,
            checkValidSubscription: checkValidSubscription
        };

        return service;

        function hasValidSubscription() {

            var lastCheck = getTimeStamp();
            if (!$localStorage.lastSubscriptionCheck)
                $localStorage.lastSubscriptionCheck = lastCheck;

            if ($localStorage.companyHasSubscription != undefined && !lastCheckExpired())
                return $localStorage.companyHasSubscription;
            else {
                $localStorage.lastSubscriptionCheck = getTimeStamp();
                CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(function (result) {

                    var hasSubscription = true;
                    if (result.status == 'DONE')
                        hasSubscription = true;
                    else
                        hasSubscription = false;

                    $localStorage.companyHasSubscription = hasSubscription;
                    return hasSubscription;
                }, function () {
                    $localStorage.companyHasSubscription = false;
                    return false;
                });
            }
        }

        function checkValidSubscription(then) {

            var lastCheck = getTimeStamp();
            if (!$localStorage.lastSubscriptionCheck)
                $localStorage.lastSubscriptionCheck = lastCheck;

            if ($localStorage.companyHasSubscription != undefined && !lastCheckExpired()) {
                if (then)
                    then($localStorage.companyHasSubscription);

                return $localStorage.companyHasSubscription;
            } else {
                $localStorage.lastSubscriptionCheck = getTimeStamp();
                CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(function (result) {

                    var hasSubscription = true;
                    if (result.status == 'DONE')
                        hasSubscription = true;
                    else
                        hasSubscription = false;

                    $localStorage.companyHasSubscription = hasSubscription;
                    if (then)
                        then($localStorage.companyHasSubscription);
                    return hasSubscription;
                }, function () {
                    $localStorage.companyHasSubscription = false;
                    if (then)
                        then($localStorage.companyHasSubscription);
                    return false;
                });
            }
        }

        function resetCompanySession() {
            delete $localStorage.companyHasSubscription;
        }


        function getTimeStamp() {
            var now = new Date();
            var stampMinute = Math.ceil(now.getTime() / 60000);
            return stampMinute;
        }

        function lastCheckExpired() {
            if (!$localStorage.lastSubscriptionCheck)
                return false;

            if (getTimeStamp() - $localStorage.lastSubscriptionCheck > 30)
                return true;

            return false;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AuthCustom', AuthCustom);

    AuthCustom.$inject = ['$resource', 'ENV'];

    function AuthCustom($resource, ENV) {

        var sendActivationCode = function (phoneNumber) {


            var resourceUrl = ENV.API_BASE_URL + 'api/client/resetPassword/sendActivationCode/' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        };


        return {
            sendActivationCode: sendActivationCode
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'JhiTrackerService'];

    function AuthServerProvider($http, $localStorage, JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {

            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken() {
            var token = this.getToken();
            return !!token;
        }

        function login(credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout() {

            JhiTrackerService.disconnect();


            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$localStorage', 'CompanySession'];

    function Auth($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $localStorage, CompanySession) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            regenerateActivationKey: regenerateActivationKey,
            sendActivationCode: sendActivationCode,
            clearLocalStorage: clearLocalStorage
        };

        return service;

        function sendActivationCode(login) {
            return Activate.sendActivationCode(login);
        }

        function activateAccount(login, key, callback) {
            var cb = callback || angular.noop;

            return Activate.activateByKey(login, key).get(
                function (response) {
                    //
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();
                if (!isAuthenticated)
                    CompanySession.resetCompanySession();


                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('supplierPanel.accessdeniedV2');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function () {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
            clearLocalStorage();
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {"name": previousStateName, "params": previousStateParams};
            $sessionStorage.previousState = previousState;
        }

        function regenerateActivationKey(login, callback) {
            var cb = callback || angular.noop;

            return Activate.regenerateActivationKey(login).get(
                function (response) {
                    //
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function clearLocalStorage() {
            $localStorage.calendarFilter = {};
            $localStorage.selectedServiceList = null;
            $localStorage.selectedServantList = null;
            $localStorage.selectedService = null;
            $localStorage.selectedServant = null;
            // $localStorage.reserveOnlyMode = null;
            $localStorage.selectedServantServiceList = null;
            $localStorage.servantTitle = null;
            $localStorage.currentCompany = null;

        }
    }
})();
//
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('Auth', Auth);
//
//    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];
//
//    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
//        var service = {
//            activateAccount: activateAccount,
//            authorize: authorize,
//            changePassword: changePassword,
//            createAccount: createAccount,
//            getPreviousState: getPreviousState,
//            login: login,
//            logout: logout,
//            resetPasswordFinish: resetPasswordFinish,
//            resetPasswordInit: resetPasswordInit,
//            resetPreviousState: resetPreviousState,
//            storePreviousState: storePreviousState,
//            updateAccount: updateAccount,
//            regenerateActivationKey :regenerateActivationKey
//        };
//
//        return service;
//
//        function activateAccount (login,key, callback) {
//            var cb = callback || angular.noop;
//
//            return Activate.activateByKey(login,key).get(
//
//                function (response) {
//                    //
//                    return cb(response);
//                },
//                function (err) {
//                    return cb(err);
//                }.bind(this)).$promise;
//        }
//
//        function regenerateActivationKey (login, callback) {
//            var cb = callback || angular.noop;
//
//            return Activate.regenerateActivationKey(login).get(
//
//                function (response) {
//                    //
//                    return cb(response);
//                },
//                function (err) {
//                    return cb(err);
//                }.bind(this)).$promise;
//        }
//
//        function authorize (force) {
//            var authReturn = Principal.identity(force).then(authThen);
//
//            return authReturn;
//
//            function authThen () {
//                var isAuthenticated = Principal.isAuthenticated();
//
//                // an authenticated user can't access to login and register pages
//                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
//                    $state.go('home');
//                }
//
//                // recover and clear previousState after external login redirect (e.g. oauth2)
//                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
//                    var previousState = getPreviousState();
//                    resetPreviousState();
//                    $state.go(previousState.name, previousState.params);
//                }
//
//                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
//                    if (isAuthenticated) {
//                        // user is signed in but not authorized for desired state
//                        $state.go('accessdenied');
//                    }
//                    else {
//                        // user is not authenticated. stow the state they wanted before you
//                        // send them to the login service, so you can return them when you're done
//                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
//
//                        // now, send them to the signin state so they can log in
//                        $state.go('accessdenied').then(function() {
//                            LoginService.open();
//                        });
//                    }
//                }
//            }
//        }
//
//        function changePassword (newPassword, callback) {
//            var cb = callback || angular.noop;
//
//            return Password.save(newPassword, function () {
//                return cb();
//            }, function (err) {
//                return cb(err);
//            }).$promise;
//        }
//
//        function createAccount (account, callback) {
//            //
//            var cb = callback || angular.noop;
//
//            return Register.save(account,
//                function (data) {
//                    //
//                    return cb(account);
//                },
//                function (err) {
//                    this.logout();
//                    return cb(err);
//                }.bind(this)).$promise;
//        }
//
//        function login (credentials, callback) {
//
//            var cb = callback || angular.noop;
//            var deferred = $q.defer();
//
//            AuthServerProvider.login(credentials)
//                .then(loginThen)
//                .catch(function (err) {
//                    this.logout();
//                    deferred.reject(err);
//                    return cb(err);
//                }.bind(this));
//
//            function loginThen (data) {
//
//                Principal.identity(true).then(function(account) {
//                    // After the login the language will be changed to
//                    // the language selected by the user during his registration
//                    if (account!== null) {
//                        $translate.use(account.langKey).then(function () {
//                            $translate.refresh();
//                        });
//                    }
//                    JhiTrackerService.sendActivity();
//                    deferred.resolve(data);
//                });
//                return cb();
//            }
//
//            return deferred.promise;
//        }
//
//
//        function logout () {
//            AuthServerProvider.logout();
//            Principal.authenticate(null);
//        }
//
//        function resetPasswordFinish (keyAndPassword, callback) {
//            var cb = callback || angular.noop;
//
//            return PasswordResetFinish.save(keyAndPassword, function () {
//                return cb();
//            }, function (err) {
//                return cb(err);
//            }).$promise;
//        }
//
//        function resetPasswordInit (mail, callback) {
//            var cb = callback || angular.noop;
//
//            return PasswordResetInit.save(mail, function() {
//                return cb();
//            }, function (err) {
//                return cb(err);
//            }).$promise;
//        }
//
//        function updateAccount (account, callback) {
//            var cb = callback || angular.noop;
//            return Account.save(account,
//                function () {
//                    return cb(account);
//                },
//                function (err) {
//                    return cb(err);
//                }.bind(this)).$promise;
//        }
//
//        function getPreviousState() {
//            var previousState = $sessionStorage.previousState;
//            return previousState;
//        }
//
//        function resetPreviousState() {
//            delete $sessionStorage.previousState;
//        }
//
//        function storePreviousState(previousStateName, previousStateParams) {
//            var previousState = { "name": previousStateName, "params": previousStateParams };
//            $sessionStorage.previousState = previousState;
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q', '$rootScope', 'CompanySession'];

    function AuthServerProvider($http, $localStorage, $sessionStorage, $q, $rootScope, CompanySession) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login(credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe,
                captchaCode: credentials.captchaCode
            };
            var req = {
                method: 'POST',
                url: 'api/authenticate',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'

                },
                data: data
            }
            //    return $http.post('api/authenticate', data).success(authenticateSuccess);
            return $http(req).success(authenticateSuccess);

            function authenticateSuccess(data, status, headers) {

                CompanySession.resetCompanySession();

                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            $localStorage.authenticationToken = jwt;
            ///TODO : when remember me is off opening in new page will cause problem so temporarily we delet it


            //ca
            //if(rememberMe){
            //    $localStorage.authenticationToken = jwt;
            //} else {
            //    $sessionStorage.authenticationToken = jwt;
            //}
        }

        function logout() {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            CompanySession.resetCompanySession();
            $rootScope.$broadcast('Logout');

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate($resource) {

        var activateByKey = function (login, key) {

            var url = "api/activate/" + login + "/" + key;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }
        var sendActivationCode = function (login) {
            var url = "api/activate/sendActivationCodeFromPanel/" + login;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }
        var regenerateActivationKey = function (login) {
            var url = "api/activate/regenerate_key/" + login;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }

        var sendActivationCodeByVerificationType = function (login, verificationType) {
            var url = "api/activate/sendActivationCodeFromPanel-byVerificationType/" + login + '/' + verificationType;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }

        return {
            activateByKey: activateByKey,
            regenerateActivationKey: regenerateActivationKey,
            sendActivationCode: sendActivationCode
        };

        //var service = $resource('api/activate/userid/', {}, {
        //    'get': { method: 'GET', params: {}, isArray: false}
        //});
        //
        //return service;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account($resource) {
        var service = $resource('api/account', {}, {

            'get': {
                method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SumOfReserveCountController', SumOfReserveCountController);

    SumOfReserveCountController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'CompanyCustom', '$translate', 'DateUtils'];

    function SumOfReserveCountController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, CompanyCustom, translate, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';
        vm.currentCompany = null;
        vm.selectedCompanyId = null;


        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.spname = '';
        vm.parameters = [];
        vm.doBeforeExport = doBeforeExport;
        loadAll();


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                if (vm.currentCompany)
                    vm.childCompanies = CompanyCustom.getCompaniesByParentId(vm.currentCompany.id).query(function (data) {
                        vm.childCompanies = data;
                    });

            });
        }

        function getCompaniesByParentId() {

        }

        function loadAll() {
            findCurrentCompany();

        }

        function confirm() {

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_sum_of_reserve_count',
                parameters: [{
                    name: 'f_province_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'f_branch_id', value: (vm.selectedCompanyId) ? vm.selectedCompanyId : 'null', type: 'long'},
                    {name: 'f_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'f_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'}
                ]
            };

            return report_config;


        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveListSummaryWithPaymentReportController', ReserveListSummaryWithPaymentReportController);

    ReserveListSummaryWithPaymentReportController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CompanyCustom', 'DateUtils'];

    function ReserveListSummaryWithPaymentReportController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CompanyCustom, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';


        vm.orderBagStatusList = null;
        vm.orderBagStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.doBeforeExport = doBeforeExport;


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        loadAll();

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

            findCurrentCompany();

        }

        function confirm() {

            // vm.errorOnCreatingReport=true;
            // vm.reportCreatedAndDownload=false;
            // vm.errorOnCreatingReport=false;
            // var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            // ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_reserve_summary_with_payment_report',
                parameters: [{
                    name: 'p_company_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'p_status', value: (vm.orderBagStatus) ? vm.orderBagStatus : 'null', type: 'long'},
                    {name: 'p_service_id', value: (vm.serviceItemId) ? vm.serviceItemId : 'null', type: 'long'},
                    {name: 'p_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'p_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'}
                ]
            };
            return report_config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveListSummaryReportController', ReserveListSummaryReportController);

    ReserveListSummaryReportController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CompanyCustom', 'DateUtils'];

    function ReserveListSummaryReportController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CompanyCustom, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';


        vm.orderBagStatusList = null;
        vm.orderBagStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.doBeforeExport = doBeforeExport;


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        loadAll();

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

            findCurrentCompany();

        }

        function confirm() {

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;
            var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_reserve_summary_report',
                parameters: [{
                    name: 'p_company_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'p_status', value: (vm.orderBagStatus) ? vm.orderBagStatus : 'null', type: 'long'},
                    {name: 'p_service_id', value: (vm.serviceItemId) ? vm.serviceItemId : 'null', type: 'long'},
                    {name: 'p_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'p_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'}
                ]
            };
            return report_config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveListDtailReportController', ReserveListDtailReportController);

    ReserveListDtailReportController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CompanyCustom', 'DateUtils'];

    function ReserveListDtailReportController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CompanyCustom, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';


        vm.orderBagStatusList = null;
        vm.orderBagStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.doBeforeExport = doBeforeExport;


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        loadAll();

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

            findCurrentCompany();

        }

        function confirm() {

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;
            var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_reserve_dtail_report',
                parameters: [{
                    name: 'p_company_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'p_status', value: (vm.orderBagStatus) ? vm.orderBagStatus : 'null', type: 'long'},
                    {name: 'p_service_id', value: (vm.serviceItemId) ? vm.serviceItemId : 'null', type: 'long'},
                    {name: 'p_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'p_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'},
                    {name: 'p_query', value: (vm.query) ? vm.query : 'null', type: 'string'}
                ]
            };
            return report_config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReportExportController', ReportExportController);

    ReportExportController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$translate', 'CompanyCustom', '$uibModal'];

    function ReportExportController($scope, Principal, LoginService, $state, translate, CompanyCustom, $uibModal) {
        var vm = this;

        vm.report1_spname = 'search_company';
        vm.report1_parameters = [{name: 'url', value: 'tamin20'}];
        vm.currentCompany = null;
        vm.doBeforeExport_customerList = doBeforeExport_customerList;
        vm.showEducation = showEducation

        findCurrentCompany();

        function findCurrentCompany() {

            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;

            });
        }

        function doBeforeExport_customerList() {

            var report_config = {
                spname: 'sp_company_customer_list',
                parameters: [{name: 'f_company_id', value: (vm.currentCompany.id), type: 'long'}]
            };

            return report_config;

        }
         function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                         return '<div id="60236964718"><script type="text/JavaScript" src="https://www.aparat.com/embed/nkek6b9?data[rnddiv]=60236964718&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveCountByParentIdController', ReserveCountByParentIdController);

    ReserveCountByParentIdController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'CompanyCustom', '$translate', 'DateUtils'];

    function ReserveCountByParentIdController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, CompanyCustom, translate, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';
        vm.currentCompany = null;
        vm.selectedCompanyId = null;


        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.spname = '';
        vm.parameters = [];
        vm.doBeforeExport = doBeforeExport;
        loadAll();


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                if (vm.currentCompany)
                    vm.childCompanies = CompanyCustom.getCompaniesByParentId(vm.currentCompany.id).query(function (data) {
                        vm.childCompanies = data;
                    });

            });
        }

        function getCompaniesByParentId() {

        }

        function loadAll() {
            findCurrentCompany();

        }

        function confirm() {

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;
            var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_province_branch_service_date_count',
                parameters: [{
                    name: 'f_province_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'f_branch_id', value: (vm.selectedCompanyId) ? vm.selectedCompanyId : 'null', type: 'long'},
                    {name: 'f_service_id', value: 'null', type: 'long'},
                    {name: 'f_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'f_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'}
                ]
            };
            return report_config;


        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderbagListByServiceController', OrderbagListByServiceController);

    OrderbagListByServiceController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate'];

    function OrderbagListByServiceController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';


        vm.orderBagStatusList = null;
        vm.orderBagStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        loadAll()

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

        }

        function confirm() {

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;
            var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoItemReportController', InvoiceInfoItemReportController);

    InvoiceInfoItemReportController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CompanyCustom', 'DateUtils'];

    function InvoiceInfoItemReportController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CompanyCustom, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';

        vm.invoiceInfoStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.doBeforeExport = doBeforeExport;


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        loadAll();

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

            findCurrentCompany();

        }


        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_invoice_info_item_report',
                parameters: [{
                    name: 'p_company_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'p_status', value: (vm.invoiceInfoStatus) ? vm.invoiceInfoStatus : 'null', type: 'string'},
                    {name: 'p_service_item_id', value: (vm.serviceItemId) ? vm.serviceItemId : 'null', type: 'long'},
                    {name: 'p_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'p_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'},
                    {name: 'p_query', value: (vm.query) ? vm.query : 'null', type: 'string'}
                ]
            };
            return report_config;
        }
    }
})();
;
(function () {
    'use strict';


    GenericReportController.$inject = ['$scope', 'ExportService', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CustomerCustom', 'Customer'];

    function GenericReportController($scope, ExportService, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CustomerCustom, Customer) {
        var $ctrl = this;
        $ctrl.fromDateFilter = new Date();
        $ctrl.toDateFilter = new Date();
        $ctrl.selectedCustomer = null;
        $ctrl.isLoading = false;

        $ctrl.cancel = cancel;
        $ctrl.confirm = confirm;
        $ctrl.errorOnCreatingReport = false;
        $ctrl.reportCreatedAndDownload = false;
        $ctrl.errorOnCreatingReport = false;

        /*
        config object must be like this :
            config={
            spname:'nameOfStoredProcedure',
            parameters:[{name:'pname1',value:'value1'},
                        {name:'pname2',value:'value2'}]
                   }
        */
        $ctrl.config = null;


        loadAll()

        function loadAll() {

        }

        function confirm() {

            if ($ctrl.doBeforeExport)
                $ctrl.config = $ctrl.doBeforeExport()

            $ctrl.errorOnCreatingReport = true;
            $ctrl.reportCreatedAndDownload = false;
            $ctrl.errorOnCreatingReport = false;


            if ($ctrl.config) {
                $ctrl.isLoading = true;
                var config = {params: $ctrl.config.parameters};
                JSON.stringify(config)

                ExportService.export_excel_from_storedProcedure($ctrl.config.spname).save(JSON.stringify(config), function (f) {

                    $ctrl.isLoading = false;

                    ExportService.download_excel_file_by_name(f, onExportSuccess);

                }, onExportErrorr);

            } else {
                console.log('generic report config parameter has not set yet!')
            }

        }

        function onExportErrorr(error) {
            $ctrl.errorOnCreatingReport = false;
            $ctrl.reportCreatedAndDownload = false;
            $ctrl.errorOnCreatingReport = true;
            $ctrl.isLoading = false;
        }

        function onExportSuccess(result) {

            $ctrl.errorOnCreatingReport = false;
            $ctrl.reportCreatedAndDownload = true;
            $ctrl.errorOnCreatingReport = false;
            $ctrl.downloadlink = result;
            $ctrl.isLoading = false;
        }

        function cancel() {

        }
    }

    var GenericReport = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/reports/generic_report/generic_report.html',
        controller: GenericReportController,
        bindings: {

            //'spname':'<',
            //'parameters':'<',
            'config': '<',
            'doBeforeExport': '='
        }

    };

    angular
        .module('tikonApp')
        .component('eoGenericReport', GenericReport)


})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('FinancialByCustomerController', FinancialByCustomerController);

    FinancialByCustomerController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', '$state', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CustomerCustom'];

    function FinancialByCustomerController($scope, ExportService, $uibModalInstance, Principal, $state, ReportService, OrderBagServiceItemCustom, translate, CustomerCustom) {
        var vm = this;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.selectedCustomer = null;

        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;

        vm.searchCustomer = function (query) {

            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        vm.selectedCustomerChanged = function (selectedItem) {

            //if(selectedItem) {
            //
            //    var c = Customer.get({id:selectedItem.id});
            //    if (c != null) {
            //        vm.selectedCustomer = c;
            //    }
            //}
        }

        loadAll()

        function loadAll() {

        }

        function confirm() {


            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;

            var customerId = 0;
            if (vm.selectedCustomer != null) {
                customerId = vm.selectedCustomer.id;
            }

            var file = ExportService.export_excel_financial_by_customer(customerId, vm.fromDateFilter, vm.toDateFilter);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);


        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {

            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
/**
 * Created by saeed on 10/02/2018.
 */
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ExportService', ExportService);

    ExportService.$inject = ['$resource', 'DateUtils', 'ENV'];

    function ExportService($resource, DateUtils, ENV) {


        var export_excel_orderbag_list_by_service = function (serviceid, fromdate, todate, status) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/export_excel_orderbag_list_by_service?' + 'status=' + status + '&serviceid=' + serviceid + '&fromdate=' + DateUtils.convertToISOString(fromdate) + '&todate=' + DateUtils.convertToISOString(todate);
            return $resource(resourceUrl, {});
        }


        var download_excel_file = function (request, onSuccess, onError) {

            request.get({}, function (result) {
                var dlfile = ENV.API_BASE_URL + "api/client/downloadFile/" + result.filename;
                result.dllink = dlfile;
                if (onSuccess) {
                    onSuccess(result);
                }
                setTimeout(function () {
                    document.location.href = dlfile;
                }, 500);


            }, function (error) {
                if (onError)
                    onError(error);
            });
        }
        var download_excel_file_by_name = function (result, onSuccess) {
            var dlfile = ENV.API_BASE_URL + "api/client/downloadFile/" + result.filename;
            setTimeout(function () {
                if (onSuccess) {
                    onSuccess(dlfile);
                }
                document.location.href = dlfile;


            }, 500);

            //request.get({},function (result) {
            //    var dlfile="api/client/downloadFile/"+result.filename;
            //    result.dllink=dlfile;
            //    if(onSuccess) {
            //        onSuccess(result);
            //    }
            //
            //
            //
            //},function(error){
            //    if(onError)
            //        onError(error);
            //});
        }
        var export_excel_financial_by_customer = function (customerid, fromdate, todate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/export_excel_financial_by_customer?' + 'customerid=' + customerid + '&fromdate=' + DateUtils.convertToISOString(fromdate) + '&todate=' + DateUtils.convertToISOString(todate);
            return $resource(resourceUrl, {});
        }
        var export_excel_from_storedProcedure = function (spname) {
            //  var config={params:parameters};

            //  var resourceUrl = 'api/client/export_excel_sp?' + 'spName=' + spname  + '&parameters=' + JSON.stringify(config) ;
            var resourceUrl = ENV.API_BASE_URL + 'api/export_excel_sp/' + spname;
            return $resource(resourceUrl, {});
        }

        var export_company_form_data_list = function (formId, customerid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/export_excel_company_form_data_list?' + 'formId=' + formId + '&customerId=' + customerid;
            return $resource(resourceUrl, {});
        }
        return {
            export_excel_orderbag_list_by_service: export_excel_orderbag_list_by_service,
            download_excel_file: download_excel_file,
            export_excel_financial_by_customer: export_excel_financial_by_customer,
            export_excel_from_storedProcedure: export_excel_from_storedProcedure,
            download_excel_file_by_name: download_excel_file_by_name,
            export_company_form_data_list: export_company_form_data_list
        };


    }


})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PrintCompanyCustomerFormDataController', PrintCompanyCustomerFormDataController);

    PrintCompanyCustomerFormDataController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', '$window', 'CompanyCustom', '__config', 'CompanyCustomerFormDataReportCustom'];

    function PrintCompanyCustomerFormDataController($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, $window, CompanyCustom, __config, CompanyCustomerFormDataReportCustom) {

        var vm = this;

        vm.customerFormData = entity;
        vm.__config = __config;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.openPrintPreview = openPrintPreview;


        $rootScope.$broadcast('hideNavBar');


        load();

        function load() {
            initTableRows();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($rootScope.fromState && $rootScope.fromState.name) {

                if ($rootScope.fromState.name == 'supplierPanel-v2.reportExport.company_customer_form_data_report') {
                    $state.go('supplierPanel-v2.reportExport.company_customer_form_data_report');
                    return;
                } else {

                    if ($rootScope.fromStateParams) {
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }

            $state.go('supplierPanel-v2.reportExport.company_customer_form_data_report');

        }

        function okModal() {
            openPrintPreview();
        }


        function openPrintPreview() {
            $window.print();
        }

        function initTableRows() {
            vm.tableRows = [];
            var row = [];
            var j = 0;

            for (var i = 0; i < vm.customerFormData.intakeDataDTO.fields.length; i++) {
                if (vm.customerFormData.intakeDataDTO.fields[i].field.fieldType == 'TextArea') {
                    if (row.length > 0) {
                        vm.tableRows.push(row);
                        row = [];
                        j = 0;
                    }
                    var row_area = [];
                    row_area.push(vm.customerFormData.intakeDataDTO.fields[i]);
                    vm.tableRows.push(row_area);
                } else {
                    if (j % 4 == 0) {
                        if (row.length > 0)
                            vm.tableRows.push(row);
                        row = [];
                        j = 0;
                    }
                    row.push(vm.customerFormData.intakeDataDTO.fields[i])
                }
                j++;
            }

            if (row.length > 0)
                vm.tableRows.push(row);

        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustomerFormDataReportCustom', CompanyCustomerFormDataReportCustom);

    CompanyCustomerFormDataReportCustom.$inject = ['$resource', 'ENV'];

    function CompanyCustomerFormDataReportCustom($resource, ENV) {

        var searchCompanyCustomerFormDataReportByQueryPage = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-company-customer-form-data-report-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var getCompanyCustomerFormDataById = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-company-custom-form-data-by-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {


            searchCompanyCustomerFormDataReportByQueryPage: searchCompanyCustomerFormDataReportByQueryPage,
            getCompanyCustomerFormDataById: getCompanyCustomerFormDataById

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyCustomerFormDataReportSearch', CompanyCustomerFormDataReportSearch);

    CompanyCustomerFormDataReportSearch.$inject = ['$resource', 'ENV'];

    function CompanyCustomerFormDataReportSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/company-customer-form-data-report/:id';


        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerFormDataReportController', CompanyCustomerFormDataReportController);

    CompanyCustomerFormDataReportController.$inject = ['$scope', '$state', 'CompanyCustomerFormDataReportSearch', 'CompanyCustomerFormDataReportCustom', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$rootScope', '$uibModal', 'Principal', 'DialogService', '$mdDialog', 'CompanyCustomerCustom', '$localStorage', '$window'];

    function CompanyCustomerFormDataReportController($scope, $state, CompanyCustomerFormDataReportSearch, CompanyCustomerFormDataReportCustom, ParseLinks, AlertService, pagingParams, paginationConstants, $rootScope, $uibModal, Principal, DialogService, $mdDialog, CompanyCustomerCustom, $localStorage, $window) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;


        vm.editCompanyCustomerData = editCompanyCustomerData;
        vm.searchIntakeForms = search;
        vm.clearSearch = clearSearch;
        vm.filterQuery = {};

        //must set in cache
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.isSearching = false;
        vm.pageSizeChanged = pageSizeChanged;
        vm.openEditDataDialog = openEditDataDialog;
        vm.companyCustomForms = [];
        vm.printItem = printItem;

        loadData();

        // loadAll_paging();


        function loadData() {
            filterCompanyCustomerData();
            getAllCompanyCustomForms();
        }

        function getAllCompanyCustomForms() {
            CompanyCustomerCustom.getAllCompanyCustomForm().query(function (result) {
                vm.companyCustomForms = result;
            })
        }

        function loadAll_paging() {

            if (pagingParams.search) {
                CompanyCustomerDataSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyCustomerDataSearch.query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.CompanyCustomerDatas = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getCompanyCustomerDataPagesByQuery(vm.filterQuery);
            else
                getCompanyCustomerDataPagesByQuery();

        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.advancedSearch();
            }
        }


        function clearSearch() {
            vm.filterQuery.searchText = null;
            filterCompanyCustomerData_Global();
        }

        function newCompanyCustomerData() {

            var result;

            result = Principal.hasSpecialFeatureAccess("invoice");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.go('supplierPanel-v2.newCompanyCustomerData');
        }


        function editCompanyCustomerData(CompanyCustomerData) {
            if (CompanyCustomerData.status == 'TEMP')
                $state.go('supplierPanel-v2.editCompanyCustomerData', {id: CompanyCustomerData.id});
            if (CompanyCustomerData.status == 'UNPAID' || CompanyCustomerData.status == 'SETTLEMENT' || CompanyCustomerData.status == 'VOID')
                $state.go('supplierPanel-v2.CompanyCustomerDataDetail', {id: CompanyCustomerData.id});

        }


        vm.advancedSearch = function () {
            clear();
            vm.filterQuery.searchMode = true;
            filterCompanyCustomerData();
        }

        function pageSizeChanged() {
            clear();
            filterOrderBag();
        }

        function getCompanyCustomerDataPagesByQuery(customFilter) {

            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;


            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;

            CompanyCustomerFormDataReportCustom.searchCompanyCustomerFormDataReportByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyCustomerDatas = data;
                vm.isSearching = false;

                gotToTop();
                // vm.page = vm.filterQuery.pageNumber+1;
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }


        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function filterCompanyCustomerData_Global() {
            vm.filterQuery.searchMode = true;
            filterCompanyCustomerData();
            clear();

        }

        function filterCompanyCustomerData(customFilter) {

            if (vm.isSearching)
                return;
            getCompanyCustomerDataPagesByQuery(customFilter);
        }


        function printItem(companyCustomerData) {

            var url = $state.href('supplierPanel-v2.reportExport.company_customer_form_data_report.print', {id: companyCustomerData.id});
            $window.open(url, '_blank');
        }


        ComponentIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'columnCount'];

        function ComponentIntakeDataDialogController($scope, $mdDialog, dialogData, columnCount) {

            var $ctrl2 = this;
            $ctrl2.customerFormData = dialogData;
            $ctrl2.columnCount = null;
            $ctrl2.columnCount = columnCount;

            $ctrl2.save = function () {


                $ctrl2.customerFormData.companyCustomer.formsData = null;
                if (!$ctrl2.customerFormData.intakeData) {

                    CompanyCustomerCustom.companyCustomerFormData().save($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                } else {

                    CompanyCustomerCustom.companyCustomerFormData().update($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                }

                $mdDialog.hide();

            };

            $ctrl2.cancel = function () {
                $mdDialog.cancel();
            };

            $ctrl2.getContainerClass = function () {
                if ($localStorage.sideMenuStatus == 'close')
                    return 'container-wide';
                if ($localStorage.sideMenuStatus == 'open')
                    return 'container-small';
            };


        }

        function openEditDataDialog(customerFormData) {

            var columnCount = 4;
            $mdDialog.show({
                locals: {dialogData: customerFormData, columnCount: columnCount},
                controller: ComponentIntakeDataDialogController,
                templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
                controllerAs: '$ctrl',
                // parent: angular.element(document.body),
                targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });
        };


        //Filter Dialog
        var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;


            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];

        vm.showFilterDialog = function () {

            var dialogData_ = {};
            dialogData_.companyCustomForms = vm.companyCustomForms;
            dialogData_.filterQuery = vm.filterQuery;


            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/reports/company-customer-form-data-report/filter-company-customer-form-data-report-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                size: 'lg',
                fullscreen: false

            })
                .then(function (data) {
                    setFilterQuery(data.filterQuery);
                    vm.advancedSearch();
                }, function () {
                });
        }

        function setFilterQuery(filter) {
            vm.filterQuery = filter;
            countFilters();
        }

        function countFilters() {

            vm.filterCount = 0;
            var date = new Date();

            if (vm.filterQuery.companyCustomFormId)
                vm.filterCount++;
        }

        //..................................
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyFormDataListController', CompanyFormDataListController);

    CompanyFormDataListController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', '$state', 'ReportService', '$translate', 'CustomerCustom', 'CompanyCustomerCustom'];

    function CompanyFormDataListController($scope, ExportService, $uibModalInstance, Principal, $state, ReportService, translate, CustomerCustom, CompanyCustomerCustom) {
        var vm = this;

        vm.selectedCustomer = null;
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.showFormIsMandatory = false;

        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        vm.selectedCustomerChanged = function (selectedItem) {

            //if(selectedItem) {
            //
            //    var c = Customer.get({id:selectedItem.id});
            //    if (c != null) {
            //        vm.selectedCustomer = c;
            //    }
            //}
        };

        loadAll();

        function loadAll() {
            getAllCompanyCustomForms();
        }

        function confirm() {

            vm.showFormIsMandatory = false;

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;

            var customerId = 0;
            if (vm.selectedCustomer != null) {
                customerId = vm.selectedCustomer.id;
            }

            var formId = 0;
            if (vm.selectedCompanyCustomForm)
                formId = vm.selectedCompanyCustomForm;
            else {
                vm.showFormIsMandatory = true;
                return;
            }

            var file = ExportService.export_company_form_data_list(formId, customerId);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);


        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {

            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function getAllCompanyCustomForms() {
            CompanyCustomerCustom.getAllCompanyCustomForm().query(function (result) {
                vm.companyCustomForms = result;
            })
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PushNotificationService', PushNotificationService);

    PushNotificationService.$inject = ['$resource', '$localStorage', '$sessionStorage'];

    function PushNotificationService($resource, $localStorage, $sessionStorage) {
        //for test
        const firebaseConfig = {
            apiKey: "AIzaSyBI_c5nRLDb3FBRmiX7gqH7_Z7110oobTo",
            authDomain: "planovin.firebaseapp.com",
            projectId: "planovin",
            storageBucket: "planovin.appspot.com",
            messagingSenderId: "396654432408",
            appId: "1:396654432408:web:0aa1f6341b478cbbe500ed",
            measurementId: "G-YPZNSC89W1"
        }
        
        function getCurrentNotificationToken() {
            console.log("GET CURRENT NOTIFICATION TOKEN")

            new Promise(function (resolve, reject) {
                resolve("XXXXXXX")
            })
        }

        function initPushNotification() {
            if (document && document.readyState && document.readyState !== 'complete' && window) window.addEventListener("load", function () {
                registerFirebaseAndCheckNotificationStatus()
            })
            else {
                registerFirebaseAndCheckNotificationStatus()
            }
        }

        //check for support service worker
        function registerFirebaseAndCheckNotificationStatus() {
            if (navigator && navigator.permissions && 'serviceWorker' in navigator && 'PushManager' in window) {
                //service worker is ready
                navigator.serviceWorker.ready.then(function () {
                    //create firebase app
                    initializeApp(firebaseConfig)

                    //get notification permission state
                    getNotificationPermissionState()
                        .then(function (result) {
                            // state is granted and firebase token has not been subscribe to a topic yet
                            if (result.state === 'granted') subscribeAndSendToServer()
                            else if (result.state === 'prompt') getNotificationPermissionAndGetToken()
                        })

                })


            } else if (window && window.nsWebViewInterface) {
                // emit event to native app
                window.nsWebViewInterface.emit('isNativeApp', "isNativeApp");
                window.nsWebViewInterface.emit('getNotificationToken', "getNotificationToken");
                
                // register listener for any event from native app
                window.nsWebViewInterface.on('isNativeApp', getNotificationIsNativeApp);
                window.nsWebViewInterface.on('receiveNotificationToken', getNotificationFromNativeApp);
            }
        }

        // get permission and get token
        function getNotificationPermissionAndGetToken() {
            Notification.requestPermission().then(function (result) {
                if (result !== 'granted') return
                getNotificationToken().then(function (currentToken) {
                    subscribeAndSendToServer(currentToken, "web")
                })

            })

        }

        // send new user notification token to server
        function setUserToken(token, platform) {
            // REQUEST TO SERVER AS USER TO SERVER
            console.log("SET USER NOTIFICATION TOKEN")
            // var resourceUrl = 'TEST';
            // return $resource(resourceUrl, {}, {
            //         'post': {
            //             method: 'POST', params: {}, data : {token , platform}
            //         }
            //     }
            // );
        }

        // get notification token from firebase
        function getNotificationToken() {
            navigator.serviceWorker.ready.then(function () {
                var messaging = getMessagingInWindow()
                return getToken(messaging, {vapidKey: 'BEN5jt-yXfKpV84KFGaDgwOJi-axh_HlOl4NWwAsNGPm_j4SWdl_6yM0IibA0wIsfhx5y4mNlJPen5auTeGE9Jg'})
                    .then(function (result) {
                        return result
                    })
            })
        }

        // get notification permissions state
        function getNotificationPermissionState() {

            return navigator.permissions.query({name: 'notifications'})
                .then(function (result) {
                    return Promise.resolve(result)
                })
        }

        // subscribe all token to a topics
        function subscribeToATopic(token) {

            $sessionStorage.subscribedTopic = "true"
            // var data = {
            //     topics: ['ALL'],
            //     token: token
            // }
            // SEND REQUEST TO SERVER TO SUBSCRIBE TOKEN TO A TOPIC
        }

        //  receive notification token from native app (android or ios)
        function getNotificationFromNativeApp(data) {
            subscribeAndSendToServer(data.token, data.platform)
        }

        //subscribe token and send it to server if user is logged in
        function subscribeAndSendToServer(token, platform) {
            var currentToken
            new Promise(function (resolve, reject) {
                if (!token) {
                    //get notification permission status to ensure
                    getNotificationPermissionState()
                        .then(function (result) {
                            if (result.state !== 'granted') return
                            getNotificationToken().then(function (result) {
                                currentToken = result
                                resolve()
                            })
                        })


                } else currentToken = token
            })
                .then(function () {
                    if ($sessionStorage.subscribedTopic !== 'true') subscribeToATopic(currentToken)

                    if (isUserLoggedIn()) {
                        // get current user token
                        getCurrentNotificationToken().then(function (tokenResponse) {
                            if (tokenResponse !== currentToken) setUserToken(currentToken, platform)
                        })

                    }
                })
        }

        // check is user logged in
        function isUserLoggedIn() {
            if ($localStorage.authenticationToken) return true
            else return false
        }
        function getNotificationIsNativeApp(data) {
            if(data) {
                $localStorage.isNativeApp = "true";
            }else {
                delete $localStorage.isNativeApp
            }
        }

        return {
            "initPushNotification": initPushNotification
        }
    }
})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('legal_actualInformation', {
                parent: 'app',
                url: '/legal_actual-information',
                controller: 'LegalActualInfoController',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.legal_actual'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/legal-actual-info/index.html',
                        controller: 'LegalActualInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('legal_actualInformation');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UserProfileQuery', function ($stateParams, UserProfileQuery) {

                        return UserProfileQuery.getCurrentPersonInfo().query();
                    }]
                }
//                  resolve: {
//                    entity: function(MyService, $stateParams) {
//                      return MyService.get($stateParams.id).$promise;
//                    }
//                  }


            })


        ;
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('LegalActualInfoService', LegalActualInfoService);

    LegalActualInfoService.$inject = ['$resource', 'ENV'];

    function LegalActualInfoService($resource, ENV) {

        var fetchInfo = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/v2/company/legal-info';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false},
                    'update': { method: 'PUT'}
                }
            );
        };

        var fetchInfoWithCompanyId = function (company_id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/legal-info/' + company_id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            fetchInfo: fetchInfo,
            fetchInfoWithCompanyId: fetchInfoWithCompanyId
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LegalActualInfoController', LegalActualInfoController);

    LegalActualInfoController.$inject = ['LegalActualInfoService', '$translate', '$scope', 'SelectorData', 'SelectorDataQuery', '$rootScope'];

    function LegalActualInfoController(LegalActualInfoService, $translate, $scope, SelectorData, SelectorDataQuery, $rootScope) {
        var vm = this;
        vm.error = null;
        vm.success = null;
        vm.isSaving = false
        vm.legalInfo = {}

        vm.save = save;
        vm.closeModal = closeModal;
        vm.okModal = okModal;

        loadData()

        function loadData(){
            const res = LegalActualInfoService.fetchInfo().query()
            vm.legalInfo = res
        }


        function save() {
            vm.isSaving = true;
            LegalActualInfoService.fetchInfo().update(vm.legalInfo, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
           vm.legalInfo = result;
           vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();
            $rootScope.modalInstance.dismiss('cancel');
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NavbarV2Controller', NavbarV2Controller);

    NavbarV2Controller.$inject = ['__config', '$location', '$window', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'UserCustom', '$scope', 'CompanyInfoQuery', 'CompanyCustom', '$rootScope', '$translate', '$localStorage', '$uibModal', 'CompanySubscriptionStatusCustom', 'DialogService', 'ENV', '$timeout', 'DriverJsFunction', 'DeviceService'];

    function NavbarV2Controller(__config, $location, $window, $state, Auth, Principal, ProfileService, LoginService, UserCustom, $scope, CompanyInfoQuery, CompanyCustom, $rootScope, $translate, $localStorage, $uibModal, CompanySubscriptionStatusCustom, DialogService, ENV, $timeout, DriverJsFunction, DeviceService) {
        var vm = this;

        vm.appVersion = 'v2';
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = true;
        vm.swaggerDisabled = true;
        vm.showGtag = ENV.ENVIRONMENT === 'production'
        //ProfileService.getProfileInfo().then(function(response) {
        //    vm.inProduction = response.inProduction;
        //    vm.swaggerDisabled = response.swaggerDisabled;
        //});
        vm.__config = __config;
        vm.login = login;
        vm.changeCCkey = changeCCkey;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.setCurrentPersonInfo = setCurrentPersonInfo;
        vm.userProfile = null;
        vm.company = null;
        vm.gotoWebSite = gotoWebSite;
        vm.gotoReserwebHelp = gotoReserwebHelp;
        vm.openInbox = openInbox;
        vm.isInboxOpened = false;
        vm.findAppVersion = findAppVersion;
        vm.selectedCompany = null;
        vm.setChatUserInfo = setChatUserInfo;
        vm.openChat = openChat;
        vm.supportButtonClick = supportButtonClick;
        vm.openMyWebsiteBox = openMyWebsiteBox;
        vm.showHeaderNavbar = true;
        vm.subscriptionStatusTitle = "اشتراک فعال";
        vm.goToHelp = goToHelp;
        vm.goToEducationLinks = goToEducationLinks
        vm.canDowngradeVersion = canDowngradeVersion;
        vm.downgradeVersion = downgradeVersion;
        vm.upgradeVersion = upgradeVersion;
        vm.subscriptionTitleStyle = subscriptionTitleStyle;
        vm.showWizard = showWizard;
        vm.isNativeApp = null;
        vm.referralCode = ''

        // vm.companies = [{"id":64543,"title":"شم3به شماره ۹","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان ش3به شماره ۹","phoneNumber":"04143334091","activityType":"BUSINESS_CONSULTING","webSiteUrl":null,"keyUrl":"tamin20","settingId":267841,"agreementId":64544,"locationId":71404,"locationInfo":{"id":71404,"title":null,"address":"تهران - میدان انقلاب","mapX":"35.70080152485188","mapY":"51.389923095703125","isActive":null,"countryId":1011,"stateId":1010,"cityId":36174},"tags":[],"agreementInfo":{"id":64544,"rules":null,"agreement":null},"setting":{"id":267841,"settingName":null,"themeSettingInfoId":267842,"notificationSettingId":267839,"financialSettingId":267840,"themeSettingInfo":{"id":267842,"name":null,"logoImageId":null,"albumInfoId":null},"notificationSetting":{"id":267839,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"SMS_AND_EMAIL","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"NONE"},"financialSetting":{"id":267840,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"servant_label\":\"مشاور\",\"servants_label\":\"مشاوران\",\"servant_list_access_mode\":\"MENU\",\"durationViewMode\":\"HIDE\",\"isClientEmailRequired\":\"TRUE\",\"capacityViewMode\":\"SHOW\"}","domain":null,"hasDedicatedDomain":null,"appVersion":"v2","parentId":null,"companyMode":"PARENT_COMPANY","category":null,"orderNo":null},
        //     {"id":61892,"title":"sh12","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان sh12","phoneNumber":"-","activityType":"OTHER","webSiteUrl":null,"keyUrl":"tamin12","settingId":61902,"agreementId":61893,"locationId":null,"locationInfo":{"id":null,"title":null,"address":null,"mapX":null,"mapY":null,"isActive":null,"countryId":null,"stateId":null,"cityId":null},"tags":[],"agreementInfo":{"id":61893,"rules":null,"agreement":null},"setting":{"id":61902,"settingName":null,"themeSettingInfoId":61903,"notificationSettingId":61900,"financialSettingId":61901,"themeSettingInfo":{"id":61903,"name":null,"logoImageId":64894,"albumInfoId":64896},"notificationSetting":{"id":61900,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"NONE","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"SMS_AND_EMAIL"},"financialSetting":{"id":61901,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"parentId\":\"3258294\"}","domain":null,"hasDedicatedDomain":null,"appVersion":null,"parentId":64543,"companyMode":null,"category":"AGENT","orderNo":null}]

        $rootScope.$on('openNavBarHelpEvent', function (event) {
            vm.openMenu();
        })


        $scope.$on('hideNavBar', function () {

            showNavBar(false);
        });

        $scope.$on('showNavBar', function () {
            showNavBar(true);
        });

        $scope.$on('reloadNavBarData', function () {
            setCurrentPersonInfo();
            setCurrentCompany();
        });

        function showNavBar(value) {
            vm.showHeaderNavbar = value;

            if (!$state.current.parent.includes('supplierPanel-v2'))
                return;

            var elem = document.getElementById('main-content');

            if (!vm.showHeaderNavbar) {
                elem.classList.add('hide-nav-bar');
                // elem.style.paddingTop = '0';
                // elem.style.paddingBottom = '0';
            } else {
                elem.classList.remove('hide-nav-bar');
                // elem.style.paddingTop = '60px';
                // elem.style.paddingBottom = '60px';
            }
        }

        document.addEventListener('goftino_ready', function (evt) {
            vm.chatIsReady = true;
        });

        var cckey = $location.search().cckey;

        function changeCCkey(companyUrl) {
            cckey = companyUrl;
            changeCurrentCompany();

        }

        function changeCurrentCompany() {
            if (cckey) {
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {
                    $window.location.reload();
                    // setCurrentCompany();

                });
            }

        }

        // function changeCurrentCompany(key)
        // {
        //     if(key)
        //         cckey = key;
        //     changeCurrentCompany();
        // }


        setDefaultsForWeDoMeet();
        setCurrentPersonInfo();
        setCurrentCompany();

        function login() {
            collapseNavbar();
            LoginService.open();

        }

        function logout() {
            collapseNavbar();
            Auth.logout();

            $('.navbar-fixed-top').removeClass('compact');
            $('#sidebar').removeClass('open');
            $('#menuHamburgerDesktop').removeClass('change');
            $('.navbar-fixed-top').removeClass('compact');
            $('#page-wrapper').removeClass('compact');
            vm.company = null;
            vm.companies = null;
            vm.userProfile = null;

            $state.go('home');

        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function setCurrentPersonInfo() {
            if (Principal.isAuthenticated()) {
                UserCustom.getCurrentUserProfile().query(function (up) {
                    vm.userProfile = up
                });

                vm.companies = UserCustom.getCurrentUserCompanies().query();
            }
        }

        function setCurrentCompany() {
            if (Principal.isAuthenticated()) {

                CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                    vm.company = c;
                    if (c && c.appVersion && c.appVersion == 'v3') {
                        vm.appVersion = 'v3'
                    }
                    vm.selectedCompany = vm.company;
                    Principal.setCurrentCompany(vm.company);
                    Principal.getCurrentCompanyFeatureList();
                    CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
                        vm.companySubscriptionStatusList = entity;
                        if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                            vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];
                            vm.currentSubscriptionStatus = 'ACTIVE';
                            vm.subscriptionStatusTitle = 'اشتراک فعال';
                            if (vm.activePackage.subscriptionPackage.subscriptionType == 'FREE')
                                vm.subscriptionStatusTitle = 'اشتراک رایگان';
                        } else {
                            vm.currentSubscriptionStatus = 'EXPIRED';
                            vm.subscriptionStatusTitle = 'اشتراک ندارید';
                        }

                    });

                });


            }
        }

        function openInbox() {
            vm.isInboxOpened = true;
        }

        function gotoWebSite() {
            if (vm.company != null && vm.company.keyUrl != null && vm.company.keyUrl != undefined) {
                window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
            } else {
                if (Principal.isAuthenticated()) {

                    CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                        vm.company = c;
                        vm.selectedCompany = vm.company;

                        window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
                    });


                }
            }
        }

        function gotoReserwebHelp() {

            var helpUrl = getHelpUrl();
            window.open(helpUrl, '_blank');
        }

        function getHelpUrl() {
            if (vm.__config.appMode == 'reserve') {
                return "https://planovin.com/help";
            }
            if (vm.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

        function findAppVersion() {

            collapseNavbar();
            if (vm.company != null && vm.company.appVersion == 'v2') {
                $state.go('supplierPanel.calendar', { stateParamKey: null });
            } else {
                $state.go('supplierPanel.timeBoard', { stateParamKey: null });
            }


        }

        function setDefaultsForWeDoMeet() {
            $translate.use('en');
            $localStorage.appMode = 'reserve';

            if (vm.__config.appMode == 'event') {
                $translate.use('zu');
                $localStorage.appMode = 'event';
            }
            // else{
            //     if(vm.__config.appName && vm.__config.appName =="planovin")
            //     {
            //         $translate.use('pl');
            //         $localStorage.appMode = 'reserve';
            //     }
            // }


        }

        function supportButtonClick() {
            Goftino.toggle();
            setChatUserInfo();
        }

        function setChatUserInfo() {

            if (!vm.chatIsReady)
                return;
            if (!vm.userProfile)
                return;
            if (!vm.userProfile.personInfo)
                return;

            var email = 'no@Email';
            if (vm.userProfile.personInfo.email)
                email = vm.userProfile.personInfo.email;
            var fullName = vm.userProfile.personInfo.fisrtName + ' ' + vm.userProfile.personInfo.lastName;
            var company = vm.selectedCompany.title + ' - ' + vm.selectedCompany.keyUrl;
            var phoneNumber = '111111';
            if (vm.userProfile.personInfo.phoneNumber)
                phoneNumber = vm.userProfile.personInfo.phoneNumber;


            Goftino.setUser({
                email: email,
                name: fullName,
                about: company,
                phone: phoneNumber,
                forceUpdate: true
            });


        }

        vm.openMenu = function ($mdMenu, ev) {
            vm.originatorEv = ev;
            $mdMenu.open(ev);
        };

        function openChat() {
            Goftino.toggle();
            setChatUserInfo();
        }

        vm.callSupport = function () {
            window.open('tel:02191690817');
        }

        function openMyWebsiteBox() {
            $uibModal.open({
                templateUrl: 'app/layouts/navbar/my-website.html',
                controller: 'MyWebsiteController',
                controllerAs: 'vm',
                // backdrop: 'static',
                size: 'sm',
                windowClass: 'pl-modal-sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            company: vm.company
                        };
                    }
                }
            })

        }

        vm.toggleSideMenu = function () {
            var elem = document.getElementById('navbar-desktop');
            if (elem) {
                if (elem.classList.contains('navbar-desktop-side-open')) {
                    elem.classList.remove('navbar-desktop-side-open');
                    $localStorage.sideMenuStatus = 'close';
                } else {
                    elem.classList.add('navbar-desktop-side-open');
                    $localStorage.sideMenuStatus = 'open';
                }

            }

            $rootScope.$broadcast('toggleSideMenu');
        }

        $scope.$on('resetToggleSideMenu', function () {
            var elem = document.getElementById('navbar-desktop');
            if (elem) {
                if (elem.classList.contains('navbar-desktop-side-open'))
                    elem.classList.remove('navbar-desktop-side-open');
            }
        });


        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
        $scope.$watch(function () {
            return Principal.isAuthenticated();
        }, function () {
            setCurrentPersonInfo();
            setCurrentCompany();


        });


        vm.navBarShowV3 = function () {
            var isInitSetUp = false;

            if ($state.current.name == 'initSetupWizardV2') {
                isInitSetUp = true;
            }

            if ($state.current.name == 'createUserAccount')
                return true;

            if (vm.appVersion == 'v3' || isInitSetUp) {
                return true;
            } else {
                return false;
            }
        }


        function goToHelp() {
            var helpUrl = 'https://www.planovin.com/help'
            window.open(helpUrl, '_blank');
        }
         function goToEducationLinks() {
            var helpUrl = 'https://www.aparat.com/playlist/12329237'
            window.open(helpUrl, '_blank');
        }
        function canDowngradeVersion() {
            if (vm.company && vm.company.appVersion
                && vm.company.appVersion == 'v3'
                && !vm.company.wizardStatus
            ) {
                return true;
            }

            return false;
        }

        function downgradeVersion() {
            DialogService.showConfirmV2("بازگشت به نسخه قدیم را تایید می فرمایید ؟").then(function () {
                CompanyCustom.downgradeVersion().save(null, onDowngradeSuccess, onDowngradeError);
            });

        }

        function onDowngradeSuccess() {
            vm.appVersion = 'v2';
            $state.go('supplierPanel.dashboard');
        }

        function onDowngradeError() {

        }

        function upgradeVersion() {
            DialogService.showConfirmV2("بروز رسانی به نسخه جدید را تایید می فرمایید ؟").then(function () {
                CompanyCustom.upgradeVersion().save(null, onUpgradeSuccess, onUpgradeError);
            });
        }

        function onUpgradeSuccess() {
            vm.appVersion = 'v3';
            $state.go('supplierPanel-v2.dashboard');
        }

        function onUpgradeError() {

        }

        function subscriptionTitleStyle() {
            if (vm.currentSubscriptionStatus == 'EXPIRED')
                return 'subscriptionExpired';
        }
        function showWizard() {
            DriverJsFunction.drive();
        }
        $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp;
        },10)
        function findTypeOfUserDevice() {
            if($localStorage.isNativeApp == "true"){         
                vm.referralCode = "android"
            }
        }
        findTypeOfUserDevice()
        //$scope.$watch(function() {
        //    return Principal.getCurrentCompany();
        //}, function() {
        //    setCurrentCompany();
        //});
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NavbarSectionController', NavbarSectionController);

    NavbarSectionController.$inject = ['__config', '$location', '$window', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'UserCustom', '$scope', 'CompanyInfoQuery', 'CompanyCustom', '$rootScope', '$translate', '$localStorage', '$uibModal', 'CompanySubscriptionStatusCustom'];

    function NavbarSectionController(__config, $location, $window, $state, Auth, Principal, ProfileService, LoginService, UserCustom, $scope, CompanyInfoQuery, CompanyCustom, $rootScope, $translate, $localStorage, $uibModal, CompanySubscriptionStatusCustom) {
        var vm = this;

        vm.appVersion = 'v3';
        setCurrentCompany();

        function setCurrentCompany() {
            if (Principal.isAuthenticated()) {

                CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                    if (c && c.appVersion && c.appVersion == 'v3')
                        vm.appVersion = 'v3';
                    else
                        vm.appVersion = 'v2';

                });

            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['__config', '$location', '$window', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'UserCustom', '$scope', 'CompanyInfoQuery', 'CompanyCustom', '$rootScope', '$translate', '$localStorage', 'ENV'];

    function NavbarController(__config, $location, $window, $state, Auth, Principal, ProfileService, LoginService, UserCustom, $scope, CompanyInfoQuery, CompanyCustom, $rootScope, $translate, $localStorage, ENV) {
        var vm = this;

        vm.appVersion = 'v2';
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = true;
        vm.swaggerDisabled = true;
        vm.showGtag = ENV.ENVIRONMENT === 'production'
        //ProfileService.getProfileInfo().then(function(response) {
        //    vm.inProduction = response.inProduction;
        //    vm.swaggerDisabled = response.swaggerDisabled;
        //});
        vm.__config = __config;
        vm.login = login;
        vm.changeCCkey = changeCCkey;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.setCurrentPersonInfo = setCurrentPersonInfo;
        vm.userProfile = null;
        vm.company = null;
        vm.gotoWebSite = gotoWebSite;
        vm.gotoReserwebHelp = gotoReserwebHelp;
        vm.openInbox = openInbox;
        vm.isInboxOpened = false;
        vm.findAppVersion = findAppVersion;
        vm.selectedCompany = null;
        vm.setChatUserInfo = setChatUserInfo;
        vm.openChat = openChat;
        vm.supportButtonClick = supportButtonClick;


        // vm.companies = [{"id":64543,"title":"شم3به شماره ۹","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان ش3به شماره ۹","phoneNumber":"04143334091","activityType":"BUSINESS_CONSULTING","webSiteUrl":null,"keyUrl":"tamin20","settingId":267841,"agreementId":64544,"locationId":71404,"locationInfo":{"id":71404,"title":null,"address":"تهران - میدان انقلاب","mapX":"35.70080152485188","mapY":"51.389923095703125","isActive":null,"countryId":1011,"stateId":1010,"cityId":36174},"tags":[],"agreementInfo":{"id":64544,"rules":null,"agreement":null},"setting":{"id":267841,"settingName":null,"themeSettingInfoId":267842,"notificationSettingId":267839,"financialSettingId":267840,"themeSettingInfo":{"id":267842,"name":null,"logoImageId":null,"albumInfoId":null},"notificationSetting":{"id":267839,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"SMS_AND_EMAIL","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"NONE"},"financialSetting":{"id":267840,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"servant_label\":\"مشاور\",\"servants_label\":\"مشاوران\",\"servant_list_access_mode\":\"MENU\",\"durationViewMode\":\"HIDE\",\"isClientEmailRequired\":\"TRUE\",\"capacityViewMode\":\"SHOW\"}","domain":null,"hasDedicatedDomain":null,"appVersion":"v2","parentId":null,"companyMode":"PARENT_COMPANY","category":null,"orderNo":null},
        //     {"id":61892,"title":"sh12","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان sh12","phoneNumber":"-","activityType":"OTHER","webSiteUrl":null,"keyUrl":"tamin12","settingId":61902,"agreementId":61893,"locationId":null,"locationInfo":{"id":null,"title":null,"address":null,"mapX":null,"mapY":null,"isActive":null,"countryId":null,"stateId":null,"cityId":null},"tags":[],"agreementInfo":{"id":61893,"rules":null,"agreement":null},"setting":{"id":61902,"settingName":null,"themeSettingInfoId":61903,"notificationSettingId":61900,"financialSettingId":61901,"themeSettingInfo":{"id":61903,"name":null,"logoImageId":64894,"albumInfoId":64896},"notificationSetting":{"id":61900,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"NONE","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"SMS_AND_EMAIL"},"financialSetting":{"id":61901,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"parentId\":\"3258294\"}","domain":null,"hasDedicatedDomain":null,"appVersion":null,"parentId":64543,"companyMode":null,"category":"AGENT","orderNo":null}]

        document.addEventListener('goftino_ready', function (evt) {
            vm.chatIsReady = true;
        });

        var cckey = $location.search().cckey;

        function changeCCkey(companyUrl) {

            cckey = companyUrl;
            changeCurrentCompany();
            $window.location.reload();
        }

        function changeCurrentCompany() {
            if (cckey) {
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {

                    setCurrentCompany();

                });
            }

        }

        // function changeCurrentCompany(key)
        // {
        //     if(key)
        //         cckey = key;
        //     changeCurrentCompany();
        // }


        setDefaultsForWeDoMeet();
        setCurrentPersonInfo();
        setCurrentCompany();

        function login() {
            collapseNavbar();
            LoginService.open();

        }

        function logout() {
            collapseNavbar();
            Auth.logout();

            $('.navbar-fixed-top').removeClass('compact');
            $('#sidebar').removeClass('open');
            $('#menuHamburgerDesktop').removeClass('change');
            $('.navbar-fixed-top').removeClass('compact');
            $('#page-wrapper').removeClass('compact');
            vm.company = null;
            vm.companies = null;
            vm.userProfile = null;

            $state.go('home');

        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function setCurrentPersonInfo() {
            if (Principal.isAuthenticated()) {
                UserCustom.getCurrentUserProfile().query(function (up) {
                    vm.userProfile = up
                });

                vm.companies = UserCustom.getCurrentUserCompanies().query();
            }
        }

        function setCurrentCompany() {
            if (Principal.isAuthenticated()) {

                CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                    vm.company = c;

                    vm.company = c;
                    if (c && c.appVersion && c.appVersion == 'v3') {
                        vm.appVersion = 'v3'
                    }

                    vm.selectedCompany = vm.company;
                    Principal.setCurrentCompany(vm.company);
                    Principal.getCurrentCompanyFeatureList();

                });


            }
        }

        function openInbox() {
            vm.isInboxOpened = true;
        }

        function gotoWebSite() {
            if (vm.company != null && vm.company.keyUrl != null && vm.company.keyUrl != undefined) {
                window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
            } else {
                if (Principal.isAuthenticated()) {

                    CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                        vm.company = c;
                        vm.selectedCompany = vm.company;

                        window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
                    });


                }
            }
        }

        function gotoReserwebHelp() {

            var helpUrl = getHelpUrl();
            window.open(helpUrl, '_blank');
        }

        function getHelpUrl() {
            if (vm.__config.appMode == 'reserve') {
                return "https://planovin.com/help";
            }
            if (vm.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

        function findAppVersion() {

            collapseNavbar();
            if (vm.company != null && vm.company.appVersion == 'v2') {
                $state.go('supplierPanel.calendar', {stateParamKey: null});
            } else {
                $state.go('supplierPanel.timeBoard', {stateParamKey: null});
            }


        }

        function setDefaultsForWeDoMeet() {
            $translate.use('en');
            $localStorage.appMode = 'reserve';

            if (vm.__config.appMode == 'event') {
                $translate.use('zu');
                $localStorage.appMode = 'event';
            }
            // else{
            //     if(vm.__config.appName && vm.__config.appName =="planovin")
            //     {
            //         $translate.use('pl');
            //         $localStorage.appMode = 'reserve';
            //     }
            // }


        }

        function supportButtonClick() {
            Goftino.toggle();
            setChatUserInfo();
        }

        function setChatUserInfo() {

            if (!vm.chatIsReady)
                return;
            if (!vm.userProfile)
                return;
            if (!vm.userProfile.personInfo)
                return;

            var email = 'no@Email';
            if (vm.userProfile.personInfo.email)
                email = vm.userProfile.personInfo.email;
            var fullName = vm.userProfile.personInfo.fisrtName + ' ' + vm.userProfile.personInfo.lastName;
            var company = vm.selectedCompany.title + ' - ' + vm.selectedCompany.keyUrl;
            var phoneNumber = '111111';
            if (vm.userProfile.personInfo.phoneNumber)
                phoneNumber = vm.userProfile.personInfo.phoneNumber;


            Goftino.setUser({
                email: email,
                name: fullName,
                about: company,
                phone: phoneNumber,
                forceUpdate: true
            });


        }

        function openChat() {
            Goftino.toggle();
            setChatUserInfo();
        }

        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
        $scope.$watch(function () {
            return Principal.isAuthenticated();
        }, function () {
            setCurrentPersonInfo();
            setCurrentCompany();


        });

        //$scope.$watch(function() {
        //    return Principal.getCurrentCompany();
        //}, function() {
        //    setCurrentCompany();
        //});
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MyWebsiteController', MyWebsiteController);

    MyWebsiteController.$inject = ['$uibModalInstance', '$window', 'AlertToastService', '__config', 'entity'];

    function MyWebsiteController($uibModalInstance, $window, AlertToastService, __config, entity) {
        var vm = this;
        vm.copmpany = null;
        if (entity && entity.company)
            vm.company = entity.company;
        vm.closeModal = closeModal;
        vm.copyToClipboard = copyToClipboard;
        vm.gotoWebSite = gotoWebSite;
        vm.__config = __config;
        vm.companyUrl = null;
        vm.getUrl = getUrl;

        loadPage();

        function loadPage() {
            setWebsiteUrl();
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function copyToClipboard() {

            if (!vm.companyUrl) {
                AlertToastService.error('خطا در کپی کردن !', null, null);
                return;
            }
            var text = vm.companyUrl;

            var body = angular.element($window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });

            textarea.val(text);
            body.append(textarea);
            textarea[0].select();
            document.execCommand('copy');
            AlertToastService.success('global.messages.info.copySuccess', null, null);
            textarea.remove();
        }

        function gotoWebSite() {

            if (vm.companyUrl) {
                window.open('http://' + vm.companyUrl, '_blank');
            }

        }

        function setWebsiteUrl() {
            if (vm.company && vm.company.keyUrl) {
                vm.planovinUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                if (vm.company.hasDedicatedDomain && vm.company.domain) {
                    vm.companyUrl = vm.company.domain;
                } else {
                    vm.companyUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                }
            }
        }

        function getUrl(url) {
            return 'https://' + url;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function () {
                return $translate.use();
            }, function (selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function (newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoreController', MoreController);

    MoreController.$inject = ['$window', 'Auth', '$state', 'UserProfileQuery', 'ServantCustom', 'CompanyInfoQuery', 'ActivityTypeInfoCustom', 'CompanySubscriptionStatusCustom', '$timeout', '$localStorage'];

    function MoreController($window, Auth, $state, UserProfileQuery, ServantCustom, CompanyInfoQuery, ActivityTypeInfoCustom, CompanySubscriptionStatusCustom, $timeout, $localStorage) {
        var vm = this;

        vm.currentPersonInfo = {};
        vm.logout = logout;
        vm.goToCurrentServant = goToCurrentServant;
        vm.hasSubscription = true;
        vm.isNativeApp = null;

        loadPage();

        function loadPage() {
            getCurrentPersonInfo();
            loadActivityTypeInfo();
            hasActiveSubscription();
        }

        function logout() {
            Auth.logout();
            vm.currentUser = {};
            $state.go('home');

        }

        function getCurrentPersonInfo() {
            UserProfileQuery.getCurrentPersonInfo().query(function (up) {
                vm.currentPersonInfo = up;
            })
        }

        function goToCurrentServant() {
            ServantCustom.findServantByCurrentUser().query().$promise.then(function (result) {

                $state.transitionTo('supplierPanel-v2.companyServants.edit', {id: result.id});

            });

        }

        function loadActivityTypeInfo() {
            ActivityTypeInfoCustom.getActivityTypeInfoByCurrentCompany().query(function (result) {
                vm.activityTypeInfo = result;
                checkActivityType();
            })
        }

        function checkActivityType() {
            if (vm.activityTypeInfo) {
                if (vm.activityTypeInfo.servantType && vm.activityTypeInfo.servantType == 'RESOURCE') {
                    vm.isWorkSpace = true;
                    vm.servantTranslateFile = "supplierPanel.sideMenu.workSpaceInfo-v2";
                    return;
                }


            }
            vm.servantTranslateFile = "supplierPanel.sideMenu.servantInfo-v2";
            vm.isWorkSpace = false;

        }

        function hasActiveSubscription() {
            CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(hasSubscriptionSuccess, hasSubscriptionError);

            function hasSubscriptionSuccess(result) {
                if (result.status == 'DONE')
                    vm.hasSubscription = true;
                else
                    vm.hasSubscription = false;
            }

            function hasSubscriptionError() {
                vm.hasSubscription = false;
            }
            $timeout(function(){
                vm.isNativeApp = $localStorage.isNativeApp;
            },10)

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: [],
                    pageTitle: 'global.error.accessDenied'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/supplier-v2/access-denied-v2.html',
                        controller: 'AccessDeniedV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('error');

                        return $translate.refresh();
                    }]
                }
            });

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('messages');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['__config', '$scope', '$location', '$window', 'Principal', 'LoginService', '$state', 'CompanyInfoQuery', 'DeviceService', '$localStorage'];

    function HomeController(__config, $scope, $location, $window, Principal, LoginService, $state, CompanyInfoQuery, DeviceService, $localStorage) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.gotoWebSite = gotoWebSite;
        vm.getAccount = getAccount;
        vm.__config = __config;
        vm.logoSource = "content/images/planovin-farsi.jpg";
        vm.referralCode = ''

        loadCompanyInfo();


        $scope.$on('authenticationSuccess', function () {

            getAccount();
        });
        $scope.$on('Logout', function () {

            vm.company = null;
        });

        // getAccount();


        function getAccount() {


            Principal.identity().then(function (account) {

                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function loadCompanyInfo() {

            setLogoPath();

            if (Principal.isAuthenticated()) {
                CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {

                    var path = $location.path();
                    if (path == '/' && company) {
                        // $window.location.href = '/#/supplierPanel/dashboard';
                        if (company.appVersion && company.appVersion == 'v3')
                            $state.go('supplierPanel-v2.dashboard');
                        else
                            $state.go('supplierPanel.dashboard');
                        return;
                    }

                    if (company != null && company != undefined) {
                        vm.company = company;
                        if (vm.company && vm.company.keyUrl)
                            vm.websiteUrl = vm.company.keyUrl + '.reserweb.ir';
                        else
                            vm.websiteUrl = '----------------' + '.reserweb.ir';


                    } else {
                        vm.websiteUrl = '----------------' + '.reserweb.ir';
                    }

                })
            }
        }

        function gotoWebSite() {
            if (vm.company && vm.company.keyUrl) {

                window.open('http://' + vm.websiteUrl, '_blank');
            } else {
                alert('اطلاعات کسب و کار بطور کامل وارد نشده است (قدم اول را انجام دهید)');
            }
        }

        function setLogoPath() {


            if (vm.__config.appMode == 'event') {
                vm.logoSource = "content/images/wd-farsi-logo2.png"
            }
            if (vm.__config.appName && vm.__config.appName == 'planovin') {
                vm.logoSource = "content/images/planovin-farsi.jpg"
            }
        }

        function findTypeOfUserDevice() {
            if($localStorage.isNativeApp == "true"){
                vm.referralCode = "android"
            }
        }
        findTypeOfUserDevice()
    }
})();
;
 (function () {
    'use strict';

     angular.module('tikonApp').constant('ENV', {
            API_BASE_URL: 'https://api.planovin.com/',
            ENVIRONMENT: 'production',
            NEWPANEL_CDN: 'https://panel.planovin.com/v2/'
        });

})()
     
    ;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyWorkDayDialogController', WeeklyWorkDayDialogController);

    WeeklyWorkDayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WeeklyWorkDay', 'WeeklyScheduleInfo'];

    function WeeklyWorkDayDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, WeeklyWorkDay, WeeklyScheduleInfo) {
        var vm = this;

        vm.weeklyWorkDay = entity;
        vm.clear = clear;
        vm.save = save;
        vm.weeklyscheduleinfos = WeeklyScheduleInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.weeklyWorkDay.id !== null) {
                WeeklyWorkDay.update(vm.weeklyWorkDay, onSaveSuccess, onSaveError);
            } else {
                WeeklyWorkDay.save(vm.weeklyWorkDay, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:weeklyWorkDayUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyWorkDayDetailController', WeeklyWorkDayDetailController);

    WeeklyWorkDayDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WeeklyWorkDay', 'WeeklyScheduleInfo'];

    function WeeklyWorkDayDetailController($scope, $rootScope, $stateParams, entity, WeeklyWorkDay, WeeklyScheduleInfo) {
        var vm = this;

        vm.weeklyWorkDay = entity;

        var unsubscribe = $rootScope.$on('tikonApp:weeklyWorkDayUpdate', function (event, result) {
            vm.weeklyWorkDay = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyWorkDayDeleteController', WeeklyWorkDayDeleteController);

    WeeklyWorkDayDeleteController.$inject = ['$uibModalInstance', 'entity', 'WeeklyWorkDay'];

    function WeeklyWorkDayDeleteController($uibModalInstance, entity, WeeklyWorkDay) {
        var vm = this;

        vm.weeklyWorkDay = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            WeeklyWorkDay.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('weekly-work-day', {
                parent: 'entity',
                url: '/weekly-work-day?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.weeklyWorkDay.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/weekly-work-day/weekly-work-days.html',
                        controller: 'WeeklyWorkDayController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('weeklyWorkDay');
                        $translatePartialLoader.addPart('weekDay');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('weekly-work-day-detail', {
                parent: 'entity',
                url: '/weekly-work-day/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.weeklyWorkDay.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/weekly-work-day/weekly-work-day-detail.html',
                        controller: 'WeeklyWorkDayDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('weeklyWorkDay');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WeeklyWorkDay', function ($stateParams, WeeklyWorkDay) {
                        return WeeklyWorkDay.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('weekly-work-day.new', {
                parent: 'weekly-work-day',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/weekly-work-day/weekly-work-day-dialog.html',
                        controller: 'WeeklyWorkDayDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    weekday: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('weekly-work-day', null, {reload: true});
                    }, function () {
                        $state.go('weekly-work-day');
                    });
                }]
            })
            .state('weekly-work-day.edit', {
                parent: 'weekly-work-day',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/weekly-work-day/weekly-work-day-dialog.html',
                        controller: 'WeeklyWorkDayDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WeeklyWorkDay', function (WeeklyWorkDay) {
                                return WeeklyWorkDay.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('weekly-work-day', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('weekly-work-day.delete', {
                parent: 'weekly-work-day',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/weekly-work-day/weekly-work-day-delete-dialog.html',
                        controller: 'WeeklyWorkDayDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WeeklyWorkDay', function (WeeklyWorkDay) {
                                return WeeklyWorkDay.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('weekly-work-day', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WeeklyWorkDay', WeeklyWorkDay);

    WeeklyWorkDay.$inject = ['$resource'];

    function WeeklyWorkDay($resource) {
        var resourceUrl = 'api/weekly-work-days/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('WeeklyWorkDaySearch', WeeklyWorkDaySearch);

    WeeklyWorkDaySearch.$inject = ['$resource'];

    function WeeklyWorkDaySearch($resource) {
        var resourceUrl = 'api/_search/weekly-work-days/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyWorkDayController', WeeklyWorkDayController);

    WeeklyWorkDayController.$inject = ['$scope', '$state', 'WeeklyWorkDay', 'WeeklyWorkDaySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function WeeklyWorkDayController($scope, $state, WeeklyWorkDay, WeeklyWorkDaySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                WeeklyWorkDaySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                WeeklyWorkDay.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.weeklyWorkDays = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyScheduleInfoDialogController', WeeklyScheduleInfoDialogController);

    WeeklyScheduleInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WeeklyScheduleInfo', 'DatePeriod', 'TimePeriod', 'WeeklyWorkDay'];

    function WeeklyScheduleInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, WeeklyScheduleInfo, DatePeriod, TimePeriod, WeeklyWorkDay) {
        var vm = this;

        vm.weeklyScheduleInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.dateperiods = DatePeriod.query();
        vm.timeperiods = TimePeriod.query();
        vm.weeklyworkdays = WeeklyWorkDay.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.weeklyScheduleInfo.id !== null) {
                WeeklyScheduleInfo.update(vm.weeklyScheduleInfo, onSaveSuccess, onSaveError);
            } else {
                WeeklyScheduleInfo.save(vm.weeklyScheduleInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:weeklyScheduleInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyScheduleInfoDetailController', WeeklyScheduleInfoDetailController);

    WeeklyScheduleInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WeeklyScheduleInfo', 'DatePeriod', 'TimePeriod', 'WeeklyWorkDay'];

    function WeeklyScheduleInfoDetailController($scope, $rootScope, $stateParams, entity, WeeklyScheduleInfo, DatePeriod, TimePeriod, WeeklyWorkDay) {
        var vm = this;

        vm.weeklyScheduleInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:weeklyScheduleInfoUpdate', function (event, result) {
            vm.weeklyScheduleInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyScheduleInfoDeleteController', WeeklyScheduleInfoDeleteController);

    WeeklyScheduleInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'WeeklyScheduleInfo'];

    function WeeklyScheduleInfoDeleteController($uibModalInstance, entity, WeeklyScheduleInfo) {
        var vm = this;

        vm.weeklyScheduleInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            WeeklyScheduleInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('weekly-schedule-info', {
                parent: 'entity',
                url: '/weekly-schedule-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.weeklyScheduleInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/weekly-schedule-info/weekly-schedule-infos.html',
                        controller: 'WeeklyScheduleInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('weeklyScheduleInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('weekly-schedule-info-detail', {
                parent: 'entity',
                url: '/weekly-schedule-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.weeklyScheduleInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/weekly-schedule-info/weekly-schedule-info-detail.html',
                        controller: 'WeeklyScheduleInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('weeklyScheduleInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WeeklyScheduleInfo', function ($stateParams, WeeklyScheduleInfo) {
                        return WeeklyScheduleInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('weekly-schedule-info.new', {
                parent: 'weekly-schedule-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/weekly-schedule-info/weekly-schedule-info-dialog.html',
                        controller: 'WeeklyScheduleInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('weekly-schedule-info', null, {reload: true});
                    }, function () {
                        $state.go('weekly-schedule-info');
                    });
                }]
            })
            .state('weekly-schedule-info.edit', {
                parent: 'weekly-schedule-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/weekly-schedule-info/weekly-schedule-info-dialog.html',
                        controller: 'WeeklyScheduleInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WeeklyScheduleInfo', function (WeeklyScheduleInfo) {
                                return WeeklyScheduleInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('weekly-schedule-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('weekly-schedule-info.delete', {
                parent: 'weekly-schedule-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/weekly-schedule-info/weekly-schedule-info-delete-dialog.html',
                        controller: 'WeeklyScheduleInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WeeklyScheduleInfo', function (WeeklyScheduleInfo) {
                                return WeeklyScheduleInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('weekly-schedule-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WeeklyScheduleInfo', WeeklyScheduleInfo);

    WeeklyScheduleInfo.$inject = ['$resource'];

    function WeeklyScheduleInfo($resource) {
        var resourceUrl = 'api/weekly-schedule-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('WeeklyScheduleInfoSearch', WeeklyScheduleInfoSearch);

    WeeklyScheduleInfoSearch.$inject = ['$resource'];

    function WeeklyScheduleInfoSearch($resource) {
        var resourceUrl = 'api/_search/weekly-schedule-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('WeeklyScheduleInfoController', WeeklyScheduleInfoController);

    WeeklyScheduleInfoController.$inject = ['$scope', '$state', 'WeeklyScheduleInfo', 'WeeklyScheduleInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function WeeklyScheduleInfoController($scope, $state, WeeklyScheduleInfo, WeeklyScheduleInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                WeeklyScheduleInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                WeeklyScheduleInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.weeklyScheduleInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('WaitingListDialogController', WaitingListDialogController);
//
//    WaitingListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WaitingList', 'ServiceItem'];
//
//    function WaitingListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, WaitingList, ServiceItem) {
//        var vm = this;
//
//        vm.waitingList = entity;
//        vm.clear = clear;
//        vm.datePickerOpenStatus = {};
//        vm.openCalendar = openCalendar;
//        vm.save = save;
//        vm.serviceitems = ServiceItem.query();
//
//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function save () {
//            vm.isSaving = true;
//            if (vm.waitingList.id !== null) {
//                WaitingList.update(vm.waitingList, onSaveSuccess, onSaveError);
//            } else {
//                WaitingList.save(vm.waitingList, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('tikonApp:waitingListUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
//
//        vm.datePickerOpenStatus.reserveTime = false;
//
//        function openCalendar (date) {
//            vm.datePickerOpenStatus[date] = true;
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('WaitingListDetailController', WaitingListDetailController);
//
//    WaitingListDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WaitingList', 'ServiceItem'];
//
//    function WaitingListDetailController($scope, $rootScope, $stateParams, entity, WaitingList, ServiceItem) {
//        var vm = this;
//
//        vm.waitingList = entity;
//
//        var unsubscribe = $rootScope.$on('tikonApp:waitingListUpdate', function(event, result) {
//            vm.waitingList = result;
//        });
//        $scope.$on('$destroy', unsubscribe);
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('WaitingListDeleteController',WaitingListDeleteController);
//
//    WaitingListDeleteController.$inject = ['$uibModalInstance', 'entity', 'WaitingList'];
//
//    function WaitingListDeleteController($uibModalInstance, entity, WaitingList) {
//        var vm = this;
//
//        vm.waitingList = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            WaitingList.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('waiting-list', {
//            parent: 'entity',
//            url: '/waiting-list?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.waitingList.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/waiting-list/waiting-lists.html',
//                    controller: 'WaitingListController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('waitingList');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('waiting-list-detail', {
//            parent: 'entity',
//            url: '/waiting-list/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.waitingList.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/waiting-list/waiting-list-detail.html',
//                    controller: 'WaitingListDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('waitingList');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'WaitingList', function($stateParams, WaitingList) {
//                    return WaitingList.get({id : $stateParams.id}).$promise;
//                }]
//            }
//        })
//        .state('waiting-list.new', {
//            parent: 'waiting-list',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/waiting-list/waiting-list-dialog.html',
//                    controller: 'WaitingListDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                qty: null,
//                                reserveTime: null,
//                                description: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('waiting-list', null, { reload: true });
//                }, function() {
//                    $state.go('waiting-list');
//                });
//            }]
//        })
//        .state('waiting-list.edit', {
//            parent: 'waiting-list',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/waiting-list/waiting-list-dialog.html',
//                    controller: 'WaitingListDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['WaitingList', function(WaitingList) {
//                            return WaitingList.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('waiting-list', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('waiting-list.delete', {
//            parent: 'waiting-list',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/waiting-list/waiting-list-delete-dialog.html',
//                    controller: 'WaitingListDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['WaitingList', function(WaitingList) {
//                            return WaitingList.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('waiting-list', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
//(function() {
//    'use strict';
//    angular
//        .module('tikonApp')
//        .factory('WaitingList', WaitingList);
//
//    WaitingList.$inject = ['$resource', 'DateUtils'];
//
//    function WaitingList ($resource, DateUtils) {
//        var resourceUrl =  'api/waiting-lists/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                        data.reserveTime = DateUtils.convertDateTimeFromServer(data.reserveTime);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' }
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('WaitingListSearch', WaitingListSearch);
//
//    WaitingListSearch.$inject = ['$resource'];
//
//    function WaitingListSearch($resource) {
//        var resourceUrl =  'api/_search/waiting-lists/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true}
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('WaitingListController', WaitingListController);
//
//    WaitingListController.$inject = ['$scope', '$state', 'WaitingList', 'WaitingListSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];
//
//    function WaitingListController ($scope, $state, WaitingList, WaitingListSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
//        var vm = this;
//
//        vm.loadPage = loadPage;
//        vm.predicate = pagingParams.predicate;
//        vm.reverse = pagingParams.ascending;
//        vm.transition = transition;
//        vm.clear = clear;
//        vm.search = search;
//        vm.searchQuery = pagingParams.search;
//        vm.currentSearch = pagingParams.search;
//
//        loadAll();
//
//        function loadAll () {
//            if (pagingParams.search) {
//                WaitingListSearch.query({
//                    query: pagingParams.search,
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            } else {
//                WaitingList.query({
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            }
//            function sort() {
//                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
//                if (vm.predicate !== 'id') {
//                    result.push('id');
//                }
//                return result;
//            }
//            function onSuccess(data, headers) {
//                vm.links = ParseLinks.parse(headers('link'));
//                vm.totalItems = headers('X-Total-Count');
//                vm.queryCount = vm.totalItems;
//                vm.waitingLists = data;
//                vm.page = pagingParams.page;
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
//
//        function transition () {
//            $state.transitionTo($state.$current, {
//                page: vm.page,
//                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
//                search: vm.currentSearch
//            });
//        }
//
//        function search (searchQuery) {
//            if (!searchQuery){
//                return vm.clear();
//            }
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = '_score';
//            vm.reverse = false;
//            vm.currentSearch = searchQuery;
//            vm.transition();
//        }
//
//        function clear () {
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = 'id';
//            vm.reverse = true;
//            vm.currentSearch = null;
//            vm.transition();
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TimePeriodDialogController', TimePeriodDialogController);

    TimePeriodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TimePeriod', 'OffTime', 'WeeklyScheduleInfo'];

    function TimePeriodDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, TimePeriod, OffTime, WeeklyScheduleInfo) {
        var vm = this;

        vm.timePeriod = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.offtimes = OffTime.query();
        vm.weeklyscheduleinfos = WeeklyScheduleInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.timePeriod.id !== null) {
                TimePeriod.update(vm.timePeriod, onSaveSuccess, onSaveError);
            } else {
                TimePeriod.save(vm.timePeriod, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:timePeriodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TimePeriodDetailController', TimePeriodDetailController);

    TimePeriodDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TimePeriod', 'OffTime', 'WeeklyScheduleInfo'];

    function TimePeriodDetailController($scope, $rootScope, $stateParams, entity, TimePeriod, OffTime, WeeklyScheduleInfo) {
        var vm = this;

        vm.timePeriod = entity;

        var unsubscribe = $rootScope.$on('tikonApp:timePeriodUpdate', function (event, result) {
            vm.timePeriod = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TimePeriodDeleteController', TimePeriodDeleteController);

    TimePeriodDeleteController.$inject = ['$uibModalInstance', 'entity', 'TimePeriod'];

    function TimePeriodDeleteController($uibModalInstance, entity, TimePeriod) {
        var vm = this;

        vm.timePeriod = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            TimePeriod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('time-period', {
                parent: 'entity',
                url: '/time-period?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.timePeriod.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/time-period/time-periods.html',
                        controller: 'TimePeriodController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('timePeriod');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('time-period-detail', {
                parent: 'entity',
                url: '/time-period/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.timePeriod.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/time-period/time-period-detail.html',
                        controller: 'TimePeriodDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('timePeriod');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TimePeriod', function ($stateParams, TimePeriod) {
                        return TimePeriod.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('time-period.new', {
                parent: 'time-period',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/time-period/time-period-dialog.html',
                        controller: 'TimePeriodDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startTime: null,
                                    endTime: null,
                                    duration: null,
                                    gaptime: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('time-period', null, {reload: true});
                    }, function () {
                        $state.go('time-period');
                    });
                }]
            })
            .state('time-period.edit', {
                parent: 'time-period',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/time-period/time-period-dialog.html',
                        controller: 'TimePeriodDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['TimePeriod', function (TimePeriod) {
                                return TimePeriod.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('time-period', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('time-period.delete', {
                parent: 'time-period',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/time-period/time-period-delete-dialog.html',
                        controller: 'TimePeriodDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TimePeriod', function (TimePeriod) {
                                return TimePeriod.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('time-period', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('TimePeriod', TimePeriod);

    TimePeriod.$inject = ['$resource', 'DateUtils'];

    function TimePeriod($resource, DateUtils) {
        var resourceUrl = 'api/time-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('TimePeriodSearch', TimePeriodSearch);

    TimePeriodSearch.$inject = ['$resource'];

    function TimePeriodSearch($resource) {
        var resourceUrl = 'api/_search/time-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('TimePeriodController', TimePeriodController);

    TimePeriodController.$inject = ['$scope', '$state', 'TimePeriod', 'TimePeriodSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TimePeriodController($scope, $state, TimePeriod, TimePeriodSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                TimePeriodSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TimePeriod.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.timePeriods = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ThemeSettingInfoDialogController', ThemeSettingInfoDialogController);

    ThemeSettingInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ThemeSettingInfo', 'ImageData'];

    function ThemeSettingInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ThemeSettingInfo, ImageData) {
        var vm = this;

        vm.themeSettingInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.imagedata = ImageData.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.themeSettingInfo.id !== null) {
                ThemeSettingInfo.update(vm.themeSettingInfo, onSaveSuccess, onSaveError);
            } else {
                ThemeSettingInfo.save(vm.themeSettingInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:themeSettingInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ThemeSettingInfoDetailController', ThemeSettingInfoDetailController);

    ThemeSettingInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ThemeSettingInfo', 'ImageData'];

    function ThemeSettingInfoDetailController($scope, $rootScope, $stateParams, entity, ThemeSettingInfo, ImageData) {
        var vm = this;

        vm.themeSettingInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:themeSettingInfoUpdate', function (event, result) {
            vm.themeSettingInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ThemeSettingInfoDeleteController', ThemeSettingInfoDeleteController);

    ThemeSettingInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ThemeSettingInfo'];

    function ThemeSettingInfoDeleteController($uibModalInstance, entity, ThemeSettingInfo) {
        var vm = this;

        vm.themeSettingInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ThemeSettingInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('theme-setting-info', {
                parent: 'entity',
                url: '/theme-setting-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.themeSettingInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/theme-setting-info/theme-setting-infos.html',
                        controller: 'ThemeSettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('theme-setting-info-detail', {
                parent: 'entity',
                url: '/theme-setting-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.themeSettingInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/theme-setting-info/theme-setting-info-detail.html',
                        controller: 'ThemeSettingInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('themeSettingInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ThemeSettingInfo', function ($stateParams, ThemeSettingInfo) {
                        return ThemeSettingInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('theme-setting-info.new', {
                parent: 'theme-setting-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/theme-setting-info/theme-setting-info-dialog.html',
                        controller: 'ThemeSettingInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('theme-setting-info', null, {reload: true});
                    }, function () {
                        $state.go('theme-setting-info');
                    });
                }]
            })
            .state('theme-setting-info.edit', {
                parent: 'theme-setting-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/theme-setting-info/theme-setting-info-dialog.html',
                        controller: 'ThemeSettingInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ThemeSettingInfo', function (ThemeSettingInfo) {
                                return ThemeSettingInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('theme-setting-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('theme-setting-info.delete', {
                parent: 'theme-setting-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/theme-setting-info/theme-setting-info-delete-dialog.html',
                        controller: 'ThemeSettingInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ThemeSettingInfo', function (ThemeSettingInfo) {
                                return ThemeSettingInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('theme-setting-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ThemeSettingInfo', ThemeSettingInfo);

    ThemeSettingInfo.$inject = ['$resource'];

    function ThemeSettingInfo($resource) {
        var resourceUrl = 'api/theme-setting-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ThemeSettingInfoSearch', ThemeSettingInfoSearch);

    ThemeSettingInfoSearch.$inject = ['$resource'];

    function ThemeSettingInfoSearch($resource) {
        var resourceUrl = 'api/_search/theme-setting-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ThemeSettingInfoController', ThemeSettingInfoController);

    ThemeSettingInfoController.$inject = ['$scope', '$state', 'ThemeSettingInfo', 'ThemeSettingInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ThemeSettingInfoController($scope, $state, ThemeSettingInfo, ThemeSettingInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ThemeSettingInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ThemeSettingInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.themeSettingInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierCouponDialogController', SupplierCouponDialogController);

    SupplierCouponDialogController.$inject = ['$scope', '$state', 'SupplierCoupon', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'SubscriptionPackageCustom', 'CustomerGroupCustom', '$uibModalInstance', 'SubscriptionPackage'];

    function SupplierCouponDialogController($scope, $state, SupplierCoupon, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, SubscriptionPackageCustom, CustomerGroupCustom, $uibModalInstance, SubscriptionPackage) {

        var vm = this;
        vm.supplierCoupon = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allSubscriptionPackages = [];
        vm.switch_changed = switch_changed;
        vm.forAllSubscriptionPackages = true;
        vm.clear = clear;


        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.supplierCoupon.generateType)
                vm.supplierCoupon.generateType = "MANUAL";

            if (!vm.supplierCoupon.status)
                vm.supplierCoupon.status = "ACTIVE";

            if (!vm.supplierCoupon.amountType)
                vm.supplierCoupon.amountType = "PERCENT";
        }

        function loadAll() {
            $translatePartialLoader.addPart('subscriptionPackage');
            $translatePartialLoader.addPart('subscriptionType');
            $translatePartialLoader.addPart('couponGenerateTypes');
            getAllSubscriptionPackages();
        }

        function getAllSubscriptionPackages() {

            SubscriptionPackageCustom.getAllActiveSubscriptionPackages().query().$promise.then(function (result) {
                    vm.allSubscriptionPackages = result;
                    makeSubscriptionPackagesSelectedOnLoad();
                }
            );
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            addSubscriptionPackages();

            if (vm.supplierCoupon.id !== null) {
                SupplierCoupon.update(vm.supplierCoupon, onSaveSuccess, onSaveError);
            } else {

                SupplierCoupon.save(vm.supplierCoupon, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:supplierCouponUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }

        }

        function switch_changed() {
            if (vm.forAllSubscriptionPackages) {
                angular.forEach(vm.allSubscriptionPackages, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addSubscriptionPackages() {

            vm.supplierCoupon.subscriptionPackages = [];
            angular.forEach(vm.allSubscriptionPackages, function (item) {

                if (item.selected) {
                    vm.supplierCoupon.subscriptionPackages.push(item);
                }

            })
        }


        function makeSubscriptionPackagesSelectedOnLoad() {

            if (vm.supplierCoupon.subscriptionPackages && vm.supplierCoupon.subscriptionPackages.length > 0) {
                vm.forAllSubscriptionPackages = false;


                angular.forEach(vm.supplierCoupon.subscriptionPackages, function (item) {
                    angular.forEach(vm.allSubscriptionPackages, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierCouponDeleteController', SupplierCouponDeleteController);

    SupplierCouponDeleteController.$inject = ['$uibModalInstance', 'entity', 'SupplierCoupon'];

    function SupplierCouponDeleteController($uibModalInstance, entity, SupplierCoupon) {
        var vm = this;

        vm.supplierCoupon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SupplierCoupon.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SupplierCouponCustom', SupplierCouponCustom);

    SupplierCouponCustom.$inject = ['$resource'];

    function SupplierCouponCustom($resource) {


        // var getSupplierCouponByType=function(subscriptionType)
        // {
        //
        //     var resourceUrl='api/get-subscription-package-by-type?subscriptionType='+subscriptionType;
        //     return $resource(resourceUrl, {}, {
        //         'query': { method: 'GET', isArray: true}
        //         }
        //
        //     );
        // };
        // var getSupplierCouponByPTypeAndSType=function(packageType,subscriptionType)
        // {
        //
        //     var resourceUrl='api/get-package-by-ptype-and-stype?subscriptionType='+subscriptionType+'&packageType='+packageType;
        //     return $resource(resourceUrl, {}, {
        //             'query': { method: 'GET', isArray: true}
        //         }
        //
        //     );
        // };


        return {
            // getSupplierCouponByType:getSupplierCouponByType,
            // getSupplierCouponByPTypeAndSType:getSupplierCouponByPTypeAndSType
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('supplier-coupon', {
                parent: 'entity',
                url: '/supplier-coupon?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierCoupon.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupons.html',
                        controller: 'SupplierCouponController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierCoupon');
                        $translatePartialLoader.addPart('couponStatus');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('amountTypes');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplier-coupon-detail', {
                parent: 'entity',
                url: '/supplier-coupon/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierCoupon.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-detail.html',
                        controller: 'SupplierCouponDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierCoupon');
                        $translatePartialLoader.addPart('couponStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'supplierCoupon', function ($stateParams, SupplierCoupon) {
                        return SupplierCoupon.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplier-coupon.new', {
                parent: 'supplier-coupon',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-dialog.html',
                        controller: 'SupplierCouponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    durationDays: null,
                                    chargeFee: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplier-coupon', null, {reload: true});
                    }, function () {
                        $state.go('supplier-coupon');
                    });
                }]
            })
            .state('supplier-coupon.edit', {
                parent: 'supplier-coupon',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-dialog.html',
                        controller: 'SupplierCouponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SupplierCoupon', function (SupplierCoupon) {
                                return SupplierCoupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplier-coupon', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplier-coupon.delete', {
                parent: 'supplier-coupon',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/supplier-coupon/supplier-coupon-delete-dialog.html',
                        controller: 'SupplierCouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SupplierCoupon', function (SupplierCoupon) {
                                return SupplierCoupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplier-coupon', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SupplierCoupon', SupplierCoupon);

    SupplierCoupon.$inject = ['$resource', 'DateUtils'];

    function SupplierCoupon($resource, DateUtils) {
        var resourceUrl = 'api/supplier-coupon/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SupplierCouponSearch', SupplierCouponSearch);

    SupplierCouponSearch.$inject = ['$resource'];

    function SupplierCouponSearch($resource) {
        var resourceUrl = 'api/_search/supplier-coupon/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierCouponController', SupplierCouponController);

    SupplierCouponController.$inject = ['$scope', '$state', 'SupplierCoupon', 'SupplierCouponSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SupplierCouponController($scope, $state, SupplierCoupon, SupplierCouponSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                SupplierCouponSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SupplierCouponSearch.query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.supplierCoupons = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageDialogController', SubscriptionPackageDialogController);

    SubscriptionPackageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SubscriptionPackage', 'PackageFeatureList'];

    function SubscriptionPackageDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SubscriptionPackage, PackageFeatureList) {
        var vm = this;

        vm.subscriptionPackage = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.packagefeaturelists = PackageFeatureList.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.subscriptionPackage.id !== null) {
                SubscriptionPackage.update(vm.subscriptionPackage, onSaveSuccess, onSaveError);
            } else {
                SubscriptionPackage.save(vm.subscriptionPackage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:subscriptionPackageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageDetailController', SubscriptionPackageDetailController);

    SubscriptionPackageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SubscriptionPackage', 'PackageFeatureList'];

    function SubscriptionPackageDetailController($scope, $rootScope, $stateParams, entity, SubscriptionPackage, PackageFeatureList) {
        var vm = this;

        vm.subscriptionPackage = entity;

        var unsubscribe = $rootScope.$on('tikonApp:subscriptionPackageUpdate', function (event, result) {
            vm.subscriptionPackage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageDeleteController', SubscriptionPackageDeleteController);

    SubscriptionPackageDeleteController.$inject = ['$uibModalInstance', 'entity', 'SubscriptionPackage'];

    function SubscriptionPackageDeleteController($uibModalInstance, entity, SubscriptionPackage) {
        var vm = this;

        vm.subscriptionPackage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SubscriptionPackage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SubscriptionPackageCustom', SubscriptionPackageCustom);

    SubscriptionPackageCustom.$inject = ['$resource'];

    function SubscriptionPackageCustom($resource) {


        var getSubscriptionPackageByType = function (subscriptionType) {

            var resourceUrl = 'api/get-subscription-package-by-type?subscriptionType=' + subscriptionType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getSubscriptionPackageByPTypeAndSType = function (packageType, subscriptionType) {

            var resourceUrl = 'api/get-package-by-ptype-and-stype?subscriptionType=' + subscriptionType + '&packageType=' + packageType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getAllActiveSubscriptionPackages = function (packageType) {

            var resourceUrl = 'api/get-all-active-subscription-packages?packageType=' + packageType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getSubscriptionPackageByType: getSubscriptionPackageByType,
            getSubscriptionPackageByPTypeAndSType: getSubscriptionPackageByPTypeAndSType,
            getAllActiveSubscriptionPackages: getAllActiveSubscriptionPackages
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('subscription-package', {
                parent: 'entity',
                url: '/subscription-package?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.subscriptionPackage.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/subscription-package/subscription-packages.html',
                        controller: 'SubscriptionPackageController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('subscriptionPackageStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('subscription-package-detail', {
                parent: 'entity',
                url: '/subscription-package/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.subscriptionPackage.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/subscription-package/subscription-package-detail.html',
                        controller: 'SubscriptionPackageDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('subscriptionPackageStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {
                        return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('subscription-package.new', {
                parent: 'subscription-package',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/subscription-package/subscription-package-dialog.html',
                        controller: 'SubscriptionPackageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    durationDays: null,
                                    chargeFee: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('subscription-package', null, {reload: true});
                    }, function () {
                        $state.go('subscription-package');
                    });
                }]
            })
            .state('subscription-package.edit', {
                parent: 'subscription-package',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/subscription-package/subscription-package-dialog.html',
                        controller: 'SubscriptionPackageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SubscriptionPackage', function (SubscriptionPackage) {
                                return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('subscription-package', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('subscription-package.delete', {
                parent: 'subscription-package',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/subscription-package/subscription-package-delete-dialog.html',
                        controller: 'SubscriptionPackageDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SubscriptionPackage', function (SubscriptionPackage) {
                                return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('subscription-package', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SubscriptionPackage', SubscriptionPackage);

    SubscriptionPackage.$inject = ['$resource', 'DateUtils'];

    function SubscriptionPackage($resource, DateUtils) {
        var resourceUrl = 'api/subscription-packages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SubscriptionPackageSearch', SubscriptionPackageSearch);

    SubscriptionPackageSearch.$inject = ['$resource'];

    function SubscriptionPackageSearch($resource) {
        var resourceUrl = 'api/_search/subscription-packages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageController', SubscriptionPackageController);

    SubscriptionPackageController.$inject = ['$scope', '$state', 'SubscriptionPackage', 'SubscriptionPackageSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SubscriptionPackageController($scope, $state, SubscriptionPackage, SubscriptionPackageSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                SubscriptionPackageSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SubscriptionPackage.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.subscriptionPackages = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SocialNetworkInfoDialogController', SocialNetworkInfoDialogController);

    SocialNetworkInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SocialNetworkInfo', 'PersonInfo'];

    function SocialNetworkInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SocialNetworkInfo, PersonInfo) {
        var vm = this;

        vm.socialNetworkInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.personinfos = PersonInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.socialNetworkInfo.id !== null) {
                SocialNetworkInfo.update(vm.socialNetworkInfo, onSaveSuccess, onSaveError);
            } else {
                SocialNetworkInfo.save(vm.socialNetworkInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:socialNetworkInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SocialNetworkInfoDetailController', SocialNetworkInfoDetailController);

    SocialNetworkInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SocialNetworkInfo', 'PersonInfo'];

    function SocialNetworkInfoDetailController($scope, $rootScope, $stateParams, entity, SocialNetworkInfo, PersonInfo) {
        var vm = this;

        vm.socialNetworkInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:socialNetworkInfoUpdate', function (event, result) {
            vm.socialNetworkInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SocialNetworkInfoDeleteController', SocialNetworkInfoDeleteController);

    SocialNetworkInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SocialNetworkInfo'];

    function SocialNetworkInfoDeleteController($uibModalInstance, entity, SocialNetworkInfo) {
        var vm = this;

        vm.socialNetworkInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SocialNetworkInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('social-network-info', {
                parent: 'entity',
                url: '/social-network-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.socialNetworkInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/social-network-info/social-network-infos.html',
                        controller: 'SocialNetworkInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('socialNetworkType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('social-network-info-detail', {
                parent: 'entity',
                url: '/social-network-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.socialNetworkInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/social-network-info/social-network-info-detail.html',
                        controller: 'SocialNetworkInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('socialNetworkType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SocialNetworkInfo', function ($stateParams, SocialNetworkInfo) {
                        return SocialNetworkInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('social-network-info.new', {
                parent: 'social-network-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/social-network-info/social-network-info-dialog.html',
                        controller: 'SocialNetworkInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    socialNetworkType: null,
                                    title: null,
                                    url: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('social-network-info', null, {reload: true});
                    }, function () {
                        $state.go('social-network-info');
                    });
                }]
            })
            .state('social-network-info.edit', {
                parent: 'social-network-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/social-network-info/social-network-info-dialog.html',
                        controller: 'SocialNetworkInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SocialNetworkInfo', function (SocialNetworkInfo) {
                                return SocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('social-network-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('social-network-info.delete', {
                parent: 'social-network-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/social-network-info/social-network-info-delete-dialog.html',
                        controller: 'SocialNetworkInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SocialNetworkInfo', function (SocialNetworkInfo) {
                                return SocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('social-network-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SocialNetworkInfo', SocialNetworkInfo);

    SocialNetworkInfo.$inject = ['$resource'];

    function SocialNetworkInfo($resource) {
        var resourceUrl = 'api/social-network-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SocialNetworkInfoSearch', SocialNetworkInfoSearch);

    SocialNetworkInfoSearch.$inject = ['$resource'];

    function SocialNetworkInfoSearch($resource) {
        var resourceUrl = 'api/_search/social-network-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SocialNetworkInfoController', SocialNetworkInfoController);

    SocialNetworkInfoController.$inject = ['$scope', '$state', 'SocialNetworkInfo', 'SocialNetworkInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SocialNetworkInfoController($scope, $state, SocialNetworkInfo, SocialNetworkInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                SocialNetworkInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SocialNetworkInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.socialNetworkInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SmsPatternDialogController', SmsPatternDialogController);

    SmsPatternDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'SmsPattern', 'Marketplace'];

    function SmsPatternDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, SmsPattern, Marketplace) {
        var vm = this;

        vm.smsPattern = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isTemplateValid = isTemplateValid;

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.smsPattern.id !== null) {
                SmsPattern.updateItem().update({
                    id: vm.smsPattern.id,
                    template: vm.smsPattern.notificationTemplate.template,
                    approvalStatus: vm.smsPattern.approveStatus,
                    approveResult: vm.smsPattern.approveResult,

                }, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isTemplateValid() {
            if (!vm.smsPattern.notificationTemplate.template) {
                return false;
            }

            return vm.smsPattern.notificationTemplate.template.includes("لغو11");
        }

    }
})();;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SmsPatternDetailController', SmsPatternDetailController);

    SmsPatternDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag'];

    function SmsPatternDetailController($scope, $rootScope, $stateParams, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag) {
        var vm = this;

        vm.smsPattern = entity;

        // var unsubscribe = $rootScope.$on('tikonApp:companyUpdate', function (event, result) {
        //     vm.smsPattern = result;
        // });
        // $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('smsPatterns', {
                parent: 'entity',
                url: '/sms-patterns?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.smsPattern.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sms-pattern/sms-patterns.html',
                        controller: 'SmsPatternController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('smsPattern');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('smsPatterns-detail', {
                parent: 'entity',
                url: '/smsPatterns/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.smsPattern.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sms-pattern/sms-pattern-detail.html',
                        controller: 'SmsPatternDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('smsPattern');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SmsPattern', function ($stateParams, SmsPattern) {
                        return SmsPattern.getPatternItem().get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('smsPatterns-new', {
                parent: 'smsPatterns',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sms-pattern/sms-pattern-dialog.html',
                        controller: 'SmsPatternDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    state: "ACTIVE",
                                    approveStatus: "APPROVED",
                                    type: "MANUAL",
                                    count: 0,
                                    createDate: "",
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('smsPatterns', null, {reload: true});
                    }, function () {
                        $state.go('smsPatterns');
                    });
                }]
            })
            .state('smsPatterns-edit', {
                parent: 'smsPatterns',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sms-pattern/sms-pattern-dialog.html',
                        controller: 'SmsPatternDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SmsPattern', function (SmsPattern) {
                                return SmsPattern.getPatternItem().get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('smsPatterns', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            // .state('company.delete', {
            //     parent: 'company',
            //     url: '/{id}/delete',
            //     data: {
            //         authorities: ['ROLE_USER']
            //     },
            //     onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            //         $uibModal.open({
            //             templateUrl: 'app/entities/company/company-delete-dialog.html',
            //             controller: 'CompanyDeleteController',
            //             controllerAs: 'vm',
            //             size: 'md',
            //             resolve: {
            //                 entity: ['Company', function (Company) {
            //                     return Company.get({id: $stateParams.id}).$promise;
            //                 }]
            //             }
            //         }).result.then(function () {
            //             $state.go('company', null, {reload: true});
            //         }, function () {
            //             $state.go('^');
            //         });
            //     }]
            // });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SmsPattern', SmsPattern);

    SmsPattern.$inject = ['$resource', 'ENV'];

    function SmsPattern($resource, ENV) {

        var getAllPatterns = function() {
            // var resourceUrl = ENV.API_BASE_URL + 'api/v2/marketing-campaigns/get-all-checking';
            var resourceUrl = ENV.API_BASE_URL + 'api/_search/marketing-campaign';

            return $resource(resourceUrl, {}, {
                'query': {method: 'GET'},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            });
        }

        var getPatternItem = function() {
            var resourceUrl = ENV.API_BASE_URL + 'api/marketing-campaign/:id';

            return $resource(resourceUrl, {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            });
        }
        var updateItem = function() {
            var resourceUrl = ENV.API_BASE_URL + 'api/v2/marketing-campaigns';

            return $resource(resourceUrl, {}, {
                'update': {method: 'PUT'}
            });
        }
        var createItem = function() {
            var resourceUrl = ENV.API_BASE_URL + 'api/marketing-campaign';

            return $resource(resourceUrl, {}, {
                'save': {method: 'POST'}
            });
        }

        return {
            getAllPatterns:getAllPatterns ,
            getPatternItem:getPatternItem,
            updateItem:updateItem,
            createItem:createItem
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SmsPatternController', SmsPatternController);

    SmsPatternController.$inject = ['$scope', '$state', 'SmsPattern', 'CompanySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SmsPatternController($scope, $state, SmsPattern, CompanySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clearSearch = clearSearch;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.patterns = [];

        loadAll();

        function loadAll() {
            var approveStatuses = ['CHECKING'];

            if (pagingParams.search) {
                SmsPattern.getAllPatterns().query({
                    "approve-statuses": approveStatuses,
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SmsPattern.getAllPatterns().query({
                    "approve-statuses": approveStatuses,
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                // console.log('rer', data, headers('X-Total-Count'))
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patterns = data.content;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clearSearch();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clearSearch() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingInfoDialogController', SettingInfoDialogController);

    SettingInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SettingInfo', 'ThemeSettingInfo', 'NotificationSetting', 'FinancialSetting'];

    function SettingInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SettingInfo, ThemeSettingInfo, NotificationSetting, FinancialSetting) {
        var vm = this;

        vm.settingInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.themesettinginfos = ThemeSettingInfo.query();
        vm.notificationsettings = NotificationSetting.query();
        vm.financialsettings = FinancialSetting.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.settingInfo.id !== null) {
                SettingInfo.update(vm.settingInfo, onSaveSuccess, onSaveError);
            } else {
                SettingInfo.save(vm.settingInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:settingInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingInfoDetailController', SettingInfoDetailController);

    SettingInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SettingInfo', 'ThemeSettingInfo', 'NotificationSetting', 'FinancialSetting'];

    function SettingInfoDetailController($scope, $rootScope, $stateParams, entity, SettingInfo, ThemeSettingInfo, NotificationSetting, FinancialSetting) {
        var vm = this;

        vm.settingInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:settingInfoUpdate', function (event, result) {
            vm.settingInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingInfoDeleteController', SettingInfoDeleteController);

    SettingInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SettingInfo'];

    function SettingInfoDeleteController($uibModalInstance, entity, SettingInfo) {
        var vm = this;

        vm.settingInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SettingInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SettingInfoCustom', SettingInfoCustom);

    SettingInfoCustom.$inject = ['$resource'];

    function SettingInfoCustom($resource) {


        var getSettingInfoByCurrentCompany = function () {
            var resourceUrl = 'api/setting-info-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var saveWithCompany = function () {
            //
            var resourceUrl = 'api/setting-info-with-company';
            return $resource(resourceUrl, {}, {});
        };


        return {
            getSettingInfoByCurrentCompany: getSettingInfoByCurrentCompany,
            saveWithCompany: saveWithCompany
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('setting-info', {
                parent: 'entity',
                url: '/setting-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.settingInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/setting-info/setting-infos.html',
                        controller: 'SettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('setting-info-detail', {
                parent: 'entity',
                url: '/setting-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.settingInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/setting-info/setting-info-detail.html',
                        controller: 'SettingInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SettingInfo', function ($stateParams, SettingInfo) {
                        return SettingInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('setting-info.new', {
                parent: 'setting-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/setting-info/setting-info-dialog.html',
                        controller: 'SettingInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    settingName: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('setting-info', null, {reload: true});
                    }, function () {
                        $state.go('setting-info');
                    });
                }]
            })
            .state('setting-info.edit', {
                parent: 'setting-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/setting-info/setting-info-dialog.html',
                        controller: 'SettingInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SettingInfo', function (SettingInfo) {
                                return SettingInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('setting-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('setting-info.delete', {
                parent: 'setting-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/setting-info/setting-info-delete-dialog.html',
                        controller: 'SettingInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SettingInfo', function (SettingInfo) {
                                return SettingInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('setting-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SettingInfo', SettingInfo);

    SettingInfo.$inject = ['$resource'];

    function SettingInfo($resource) {
        var resourceUrl = 'api/setting-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SettingInfoSearch', SettingInfoSearch);

    SettingInfoSearch.$inject = ['$resource'];

    function SettingInfoSearch($resource) {
        var resourceUrl = 'api/_search/setting-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingInfoController', SettingInfoController);

    SettingInfoController.$inject = ['$scope', '$state', 'SettingInfo', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SettingInfoController($scope, $state, SettingInfo, SettingInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                SettingInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SettingInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.settingInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySettingInfoController', CompanySettingInfoController);

    CompanySettingInfoController.$inject = ['$rootScope', '$scope', '$state', 'SettingInfo', 'SettingInfoCustom', 'ParseLinks', 'AlertService', 'CompanyCustom', '$stateParams'];

    function CompanySettingInfoController($rootScope, $scope, $state, SettingInfo, SettingInfoCustom, ParseLinks, AlertService, CompanyCustom, $stateParams) {
        var vm = this;
        //
        vm.loadPage = loadPage;
        vm.save = save;
        vm.settingInfo = {};
        vm.isInMarketPlace = false;
        vm.settingFormSection = $stateParams.settingFormSection;
        vm.goToWebSite = goToWebSite;
        vm.saveComplete = false;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        loadPage();

        //function loadAll () {
        //
        //    function onSuccess(data, headers) {
        //        vm.settingInfos = data;
        //    }
        //    function onError(error) {
        //        AlertService.error(error.data.message);
        //    }
        //}

        function save() {
            vm.isSaving = true;
            if (vm.settingInfo.id !== null) {
                SettingInfo.update(vm.settingInfo, onSaveSuccess, onSaveError);
            } else {
                SettingInfoCustom.saveWithCompany().save(vm.settingInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:settingInfoUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
            vm.saveComplete = true;

            // if($state.current.parent == 'supplierPanel-v2.dashboard')
            //     $state.go('supplierPanel-v2.dashboard');

        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function loadPage() {
            //
            $rootScope.$broadcast('hideNavBar');
            vm.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();

            //is company in marketPlace

            CompanyCustom.isCurrentCompanyListedInAnyMarketPlaces().query().$promise.then(function (result) {

                if (result.status == 'DONE')
                    vm.isInMarketPlace = true;
                else
                    vm.isInMarketPlace = false;
            });
        }


        function goToWebSite() {
            CompanyCustom.getCompanyWebSiteAddressClearCache(function (site) {
                if (site)
                    window.open(site, '_blank');
            });

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard')
                $state.go('supplierPanel-v2.dashboard');
            else
                $state.go('supplierPanel-v2.setting');

        }

        function getModalTitle() {

            if ($stateParams.settingFormSection) {
                switch ($stateParams.settingFormSection) {
                    case 'themeSettingTab' :
                        return 'tikonApp.settingInfo.sections.themeSettingTab-v2';
                    case 'notificationSettingTab' :
                        return 'tikonApp.settingInfo.sections.notificationSettingTab';
                    case 'financialSettingTab' :
                        return 'tikonApp.settingInfo.sections.financialSettingTab';
                    case 'videoCallSettingTab' :
                        return 'tikonApp.settingInfo.sections.videoCallSettingTab';
                }
            } else
                return 'supplierPanel.sideMenu.companyInfo.setting';
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantDialogController', ServiceTimeSessionServantDialogController);

    ServiceTimeSessionServantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceTimeSessionServant', 'ServiceTimeSession', 'Servant'];

    function ServiceTimeSessionServantDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceTimeSessionServant, ServiceTimeSession, Servant) {
        var vm = this;

        vm.serviceTimeSessionServant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.servicetimesessions = ServiceTimeSession.query();
        vm.servicetimesessionservants = ServiceTimeSessionServant.query();
        vm.servants = Servant.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceTimeSessionServant.id !== null) {
                ServiceTimeSessionServant.update(vm.serviceTimeSessionServant, onSaveSuccess, onSaveError);
            } else {
                ServiceTimeSessionServant.save(vm.serviceTimeSessionServant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceTimeSessionServantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantDetailController', ServiceTimeSessionServantDetailController);

    ServiceTimeSessionServantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceTimeSessionServant', 'ServiceTimeSession', 'Servant'];

    function ServiceTimeSessionServantDetailController($scope, $rootScope, $stateParams, entity, ServiceTimeSessionServant, ServiceTimeSession, Servant) {
        var vm = this;

        vm.serviceTimeSessionServant = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceTimeSessionServantUpdate', function (event, result) {
            vm.serviceTimeSessionServant = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantDeleteController', ServiceTimeSessionServantDeleteController);

    ServiceTimeSessionServantDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceTimeSessionServant'];

    function ServiceTimeSessionServantDeleteController($uibModalInstance, entity, ServiceTimeSessionServant) {
        var vm = this;

        vm.serviceTimeSessionServant = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceTimeSessionServant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-time-session-servant', {
                parent: 'entity',
                url: '/service-time-session-servant?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSessionServant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servants.html',
                        controller: 'ServiceTimeSessionServantController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSessionServant');
                        $translatePartialLoader.addPart('reserveTypes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-time-session-servant-detail', {
                parent: 'entity',
                url: '/service-time-session-servant/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSessionServant.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-detail.html',
                        controller: 'ServiceTimeSessionServantDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSessionServant');
                        $translatePartialLoader.addPart('reserveTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceTimeSessionServant', function ($stateParams, ServiceTimeSessionServant) {
                        return ServiceTimeSessionServant.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-time-session-servant.new', {
                parent: 'service-time-session-servant',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-dialog.html',
                        controller: 'ServiceTimeSessionServantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    capacity: null,
                                    reserveType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-servant', null, {reload: true});
                    }, function () {
                        $state.go('service-time-session-servant');
                    });
                }]
            })
            .state('service-time-session-servant.edit', {
                parent: 'service-time-session-servant',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-dialog.html',
                        controller: 'ServiceTimeSessionServantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceTimeSessionServant', function (ServiceTimeSessionServant) {
                                return ServiceTimeSessionServant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-servant', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-time-session-servant.delete', {
                parent: 'service-time-session-servant',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-delete-dialog.html',
                        controller: 'ServiceTimeSessionServantDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceTimeSessionServant', function (ServiceTimeSessionServant) {
                                return ServiceTimeSessionServant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-servant', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionServant', ServiceTimeSessionServant);

    ServiceTimeSessionServant.$inject = ['$resource'];

    function ServiceTimeSessionServant($resource) {
        var resourceUrl = 'api/service-time-session-servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionServantSearch', ServiceTimeSessionServantSearch);

    ServiceTimeSessionServantSearch.$inject = ['$resource'];

    function ServiceTimeSessionServantSearch($resource) {
        var resourceUrl = 'api/_search/service-time-session-servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantController', ServiceTimeSessionServantController);

    ServiceTimeSessionServantController.$inject = ['$scope', '$state', 'ServiceTimeSessionServant', 'ServiceTimeSessionServantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceTimeSessionServantController($scope, $state, ServiceTimeSessionServant, ServiceTimeSessionServantSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceTimeSessionServantSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceTimeSessionServant.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTimeSessionServants = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionInfoDialogController', ServiceTimeSessionInfoDialogController);

    ServiceTimeSessionInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceTimeSessionInfo', 'ServiceItem', 'ScheduleInfo', 'ServiceTimeSession'];

    function ServiceTimeSessionInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceTimeSessionInfo, ServiceItem, ScheduleInfo, ServiceTimeSession) {
        var vm = this;

        vm.serviceTimeSessionInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.serviceitems = ServiceItem.query();
        vm.scheduleinfos = ScheduleInfo.query();
        vm.servicetimesessions = ServiceTimeSession.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceTimeSessionInfo.id !== null) {
                ServiceTimeSessionInfo.update(vm.serviceTimeSessionInfo, onSaveSuccess, onSaveError);
            } else {
                ServiceTimeSessionInfo.save(vm.serviceTimeSessionInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceTimeSessionInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionInfoDetailController', ServiceTimeSessionInfoDetailController);

    ServiceTimeSessionInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceTimeSessionInfo', 'ServiceItem', 'ScheduleInfo', 'ServiceTimeSession'];

    function ServiceTimeSessionInfoDetailController($scope, $rootScope, $stateParams, entity, ServiceTimeSessionInfo, ServiceItem, ScheduleInfo, ServiceTimeSession) {
        var vm = this;

        vm.serviceTimeSessionInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceTimeSessionInfoUpdate', function (event, result) {
            vm.serviceTimeSessionInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionInfoDeleteController', ServiceTimeSessionInfoDeleteController);

    ServiceTimeSessionInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceTimeSessionInfo'];

    function ServiceTimeSessionInfoDeleteController($uibModalInstance, entity, ServiceTimeSessionInfo) {
        var vm = this;

        vm.serviceTimeSessionInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceTimeSessionInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionInfoCustom', ServiceTimeSessionInfoCustom);

    ServiceTimeSessionInfoCustom.$inject = ['$resource'];

    function ServiceTimeSessionInfoCustom($resource) {


        var getServiceTimeSessionInfoByServiceItemId = function (serviceItemId) {
            //
            var resourceUrl = 'api/service-time-session-infos-by-service-item-id?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getServiceTimeSessionInfoByServiceItemId: getServiceTimeSessionInfoByServiceItemId

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-time-session-info', {
                parent: 'entity',
                url: '/service-time-session-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSessionInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session-info/service-time-session-infos.html',
                        controller: 'ServiceTimeSessionInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSessionInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-time-session-info-detail', {
                parent: 'entity',
                url: '/service-time-session-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSessionInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session-info/service-time-session-info-detail.html',
                        controller: 'ServiceTimeSessionInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSessionInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceTimeSessionInfo', function ($stateParams, ServiceTimeSessionInfo) {
                        return ServiceTimeSessionInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-time-session-info.new', {
                parent: 'service-time-session-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-info/service-time-session-info-dialog.html',
                        controller: 'ServiceTimeSessionInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    type: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-info', null, {reload: true});
                    }, function () {
                        $state.go('service-time-session-info');
                    });
                }]
            })
            .state('service-time-session-info.edit', {
                parent: 'service-time-session-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-info/service-time-session-info-dialog.html',
                        controller: 'ServiceTimeSessionInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceTimeSessionInfo', function (ServiceTimeSessionInfo) {
                                return ServiceTimeSessionInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-time-session-info.delete', {
                parent: 'service-time-session-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-info/service-time-session-info-delete-dialog.html',
                        controller: 'ServiceTimeSessionInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceTimeSessionInfo', function (ServiceTimeSessionInfo) {
                                return ServiceTimeSessionInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionInfo', ServiceTimeSessionInfo);

    ServiceTimeSessionInfo.$inject = ['$resource'];

    function ServiceTimeSessionInfo($resource) {
        var resourceUrl = 'api/service-time-session-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionInfoSearch', ServiceTimeSessionInfoSearch);

    ServiceTimeSessionInfoSearch.$inject = ['$resource'];

    function ServiceTimeSessionInfoSearch($resource) {
        var resourceUrl = 'api/_search/service-time-session-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionInfoController', ServiceTimeSessionInfoController);

    ServiceTimeSessionInfoController.$inject = ['$scope', '$state', 'ServiceTimeSessionInfo', 'ServiceTimeSessionInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceTimeSessionInfoController($scope, $state, ServiceTimeSessionInfo, ServiceTimeSessionInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceTimeSessionInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceTimeSessionInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTimeSessionInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionDialogController', ServiceTimeSessionDialogController);

    ServiceTimeSessionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceTimeSession', 'ServiceTimeSessionInfo'];

    function ServiceTimeSessionDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceTimeSession, ServiceTimeSessionInfo) {
        var vm = this;

        vm.serviceTimeSession = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.servicetimesessioninfos = ServiceTimeSessionInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceTimeSession.id !== null) {
                ServiceTimeSession.update(vm.serviceTimeSession, onSaveSuccess, onSaveError);
            } else {
                ServiceTimeSession.save(vm.serviceTimeSession, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceTimeSessionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionDetailController', ServiceTimeSessionDetailController);

    ServiceTimeSessionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceTimeSession', 'ServiceTimeSessionInfo'];

    function ServiceTimeSessionDetailController($scope, $rootScope, $stateParams, entity, ServiceTimeSession, ServiceTimeSessionInfo) {
        var vm = this;

        vm.serviceTimeSession = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceTimeSessionUpdate', function (event, result) {
            vm.serviceTimeSession = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionDeleteController', ServiceTimeSessionDeleteController);

    ServiceTimeSessionDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceTimeSession'];

    function ServiceTimeSessionDeleteController($uibModalInstance, entity, ServiceTimeSession) {
        var vm = this;

        vm.serviceTimeSession = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceTimeSession.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionCustom', ServiceTimeSessionCustom);

    ServiceTimeSessionCustom.$inject = ['$resource'];

    function ServiceTimeSessionCustom($resource) {


        var getServiceTimeSessionFromNow = function (serviceItemId) {
            //
            var resourceUrl = 'api/get-service-time-sessions-from-now?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getServiceTimeSessionInOneDate = function (serviceItemId, dateTime) {
            //
            var resourceUrl = 'api/get-service-time-sessions-in-one-date?serviceItemId=' + serviceItemId + '&dateTimeStr=' + dateTime;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getAvailableServiceTimeSessionsInOneDate = function (serviceItemId, dateTime) {
            //
            var resourceUrl = 'api/get-available-service-time-sessions-in-one-date?serviceItemId=' + serviceItemId + '&dateTimeStr=' + dateTime;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getServiceTimeSessionFromNow: getServiceTimeSessionFromNow,
            getServiceTimeSessionInOneDate: getServiceTimeSessionInOneDate,
            getAvailableServiceTimeSessionsInOneDate: getAvailableServiceTimeSessionsInOneDate
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-time-session', {
                parent: 'entity',
                url: '/service-time-session?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSession.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session/service-time-sessions.html',
                        controller: 'ServiceTimeSessionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSession');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-time-session-detail', {
                parent: 'entity',
                url: '/service-time-session/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSession.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session/service-time-session-detail.html',
                        controller: 'ServiceTimeSessionDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSession');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceTimeSession', function ($stateParams, ServiceTimeSession) {
                        return ServiceTimeSession.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-time-session.new', {
                parent: 'service-time-session',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session/service-time-session-dialog.html',
                        controller: 'ServiceTimeSessionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startTime: null,
                                    endTime: null,
                                    startDate: null,
                                    endDate: null,
                                    capacity: null,
                                    comment: null,
                                    price: null,
                                    discount: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-time-session', null, {reload: true});
                    }, function () {
                        $state.go('service-time-session');
                    });
                }]
            })
            .state('service-time-session.edit', {
                parent: 'service-time-session',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session/service-time-session-dialog.html',
                        controller: 'ServiceTimeSessionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceTimeSession', function (ServiceTimeSession) {
                                return ServiceTimeSession.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-time-session.delete', {
                parent: 'service-time-session',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session/service-time-session-delete-dialog.html',
                        controller: 'ServiceTimeSessionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceTimeSession', function (ServiceTimeSession) {
                                return ServiceTimeSession.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSession', ServiceTimeSession);

    ServiceTimeSession.$inject = ['$resource', 'DateUtils'];

    function ServiceTimeSession($resource, DateUtils) {
        var resourceUrl = 'api/service-time-sessions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionSearch', ServiceTimeSessionSearch);

    ServiceTimeSessionSearch.$inject = ['$resource'];

    function ServiceTimeSessionSearch($resource) {
        var resourceUrl = 'api/_search/service-time-sessions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionController', ServiceTimeSessionController);

    ServiceTimeSessionController.$inject = ['$scope', '$state', 'ServiceTimeSession', 'ServiceTimeSessionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceTimeSessionController($scope, $state, ServiceTimeSession, ServiceTimeSessionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceTimeSessionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceTimeSession.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceTimeSessions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionItemDialogController', ServiceOptionItemDialogController);

    ServiceOptionItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceOptionItem', 'ServiceOptionInfo', 'PriceInfo', 'AlbumInfo'];

    function ServiceOptionItemDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceOptionItem, ServiceOptionInfo, PriceInfo, AlbumInfo) {
        var vm = this;

        vm.serviceOptionItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.serviceoptioninfos = ServiceOptionInfo.query();
        vm.priceinfos = PriceInfo.query();
        vm.albuminfos = AlbumInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceOptionItem.id !== null) {
                ServiceOptionItem.update(vm.serviceOptionItem, onSaveSuccess, onSaveError);
            } else {
                ServiceOptionItem.save(vm.serviceOptionItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceOptionItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionItemDetailController', ServiceOptionItemDetailController);

    ServiceOptionItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceOptionItem', 'ServiceOptionInfo', 'PriceInfo', 'AlbumInfo'];

    function ServiceOptionItemDetailController($scope, $rootScope, $stateParams, entity, ServiceOptionItem, ServiceOptionInfo, PriceInfo, AlbumInfo) {
        var vm = this;

        vm.serviceOptionItem = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceOptionItemUpdate', function (event, result) {
            vm.serviceOptionItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionItemDeleteController', ServiceOptionItemDeleteController);

    ServiceOptionItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceOptionItem'];

    function ServiceOptionItemDeleteController($uibModalInstance, entity, ServiceOptionItem) {
        var vm = this;

        vm.serviceOptionItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceOptionItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceOptionItemCustom', ServiceOptionItemCustom);

    ServiceOptionItemCustom.$inject = ['$resource'];

    function ServiceOptionItemCustom($resource) {


        var ServiceOptionItemsByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/service-option-items-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var ServiceOptionItemsSelectedInOrderBag = function (serviceItemId, orderBagServiceItemId) {
            var resourceUrl = 'api/service-option-items-selected-in-order-bag/' + serviceItemId + '/' + orderBagServiceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var removeOptionInfoFromServiceItem = function (serviceItemId, serviceOptionInfoId) {
            var resourceUrl = 'api/remove-service-option-from-service-item/' + serviceItemId + '/' + serviceOptionInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            ServiceOptionItemsByServiceItem: ServiceOptionItemsByServiceItem,
            ServiceOptionItemsSelectedInOrderBag: ServiceOptionItemsSelectedInOrderBag,
            removeOptionInfoFromServiceItem: removeOptionInfoFromServiceItem

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-option-item', {
                parent: 'entity',
                url: '/service-option-item?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceOptionItem.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-option-item/service-option-items.html',
                        controller: 'ServiceOptionItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceOptionItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-option-item-detail', {
                parent: 'entity',
                url: '/service-option-item/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceOptionItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-option-item/service-option-item-detail.html',
                        controller: 'ServiceOptionItemDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceOptionItem');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceOptionItem', function ($stateParams, ServiceOptionItem) {
                        return ServiceOptionItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-option-item.new', {
                parent: 'service-option-item',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-option-item/service-option-item-dialog.html',
                        controller: 'ServiceOptionItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    optionName: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-option-item', null, {reload: true});
                    }, function () {
                        $state.go('service-option-item');
                    });
                }]
            })
            .state('service-option-item.edit', {
                parent: 'service-option-item',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-option-item/service-option-item-dialog.html',
                        controller: 'ServiceOptionItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceOptionItem', function (ServiceOptionItem) {
                                return ServiceOptionItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-option-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-option-item.delete', {
                parent: 'service-option-item',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-option-item/service-option-item-delete-dialog.html',
                        controller: 'ServiceOptionItemDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceOptionItem', function (ServiceOptionItem) {
                                return ServiceOptionItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-option-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceOptionItem', ServiceOptionItem);

    ServiceOptionItem.$inject = ['$resource'];

    function ServiceOptionItem($resource) {
        var resourceUrl = 'api/service-option-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceOptionItemSearch', ServiceOptionItemSearch);

    ServiceOptionItemSearch.$inject = ['$resource'];

    function ServiceOptionItemSearch($resource) {
        var resourceUrl = 'api/_search/service-option-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionItemController', ServiceOptionItemController);

    ServiceOptionItemController.$inject = ['$scope', '$state', 'ServiceOptionItem', 'ServiceOptionItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceOptionItemController($scope, $state, ServiceOptionItem, ServiceOptionItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceOptionItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceOptionItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceOptionItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionInfoDialogController', ServiceOptionInfoDialogController);

    ServiceOptionInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceOptionInfo', 'ServiceItem'];

    function ServiceOptionInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceOptionInfo, ServiceItem) {
        var vm = this;

        vm.serviceOptionInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.serviceitems = ServiceItem.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceOptionInfo.id !== null) {
                ServiceOptionInfo.update(vm.serviceOptionInfo, onSaveSuccess, onSaveError);
            } else {
                ServiceOptionInfo.save(vm.serviceOptionInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceOptionInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionInfoDetailController', ServiceOptionInfoDetailController);

    ServiceOptionInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceOptionInfo', 'ServiceItem'];

    function ServiceOptionInfoDetailController($scope, $rootScope, $stateParams, entity, ServiceOptionInfo, ServiceItem) {
        var vm = this;

        vm.serviceOptionInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceOptionInfoUpdate', function (event, result) {
            vm.serviceOptionInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionInfoDeleteController', ServiceOptionInfoDeleteController);

    ServiceOptionInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceOptionInfo'];

    function ServiceOptionInfoDeleteController($uibModalInstance, entity, ServiceOptionInfo) {
        var vm = this;

        vm.serviceOptionInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceOptionInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-option-info', {
                parent: 'entity',
                url: '/service-option-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceOptionInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-option-info/service-option-infos.html',
                        controller: 'ServiceOptionInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceOptionInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-option-info-detail', {
                parent: 'entity',
                url: '/service-option-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceOptionInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-option-info/service-option-info-detail.html',
                        controller: 'ServiceOptionInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceOptionInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceOptionInfo', function ($stateParams, ServiceOptionInfo) {
                        return ServiceOptionInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-option-info.new', {
                parent: 'service-option-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-option-info/service-option-info-dialog.html',
                        controller: 'ServiceOptionInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-option-info', null, {reload: true});
                    }, function () {
                        $state.go('service-option-info');
                    });
                }]
            })
            .state('service-option-info.edit', {
                parent: 'service-option-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-option-info/service-option-info-dialog.html',
                        controller: 'ServiceOptionInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceOptionInfo', function (ServiceOptionInfo) {
                                return ServiceOptionInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-option-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-option-info.delete', {
                parent: 'service-option-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-option-info/service-option-info-delete-dialog.html',
                        controller: 'ServiceOptionInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceOptionInfo', function (ServiceOptionInfo) {
                                return ServiceOptionInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-option-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceOptionInfo', ServiceOptionInfo);

    ServiceOptionInfo.$inject = ['$resource'];

    function ServiceOptionInfo($resource) {
        var resourceUrl = 'api/service-option-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceOptionInfoSearch', ServiceOptionInfoSearch);

    ServiceOptionInfoSearch.$inject = ['$resource'];

    function ServiceOptionInfoSearch($resource) {
        var resourceUrl = 'api/_search/service-option-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceOptionInfoController', ServiceOptionInfoController);

    ServiceOptionInfoController.$inject = ['$scope', '$state', 'ServiceOptionInfo', 'ServiceOptionInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceOptionInfoController($scope, $state, ServiceOptionInfo, ServiceOptionInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceOptionInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceOptionInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceOptionInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';


    angular
        .module('tikonApp')
        .controller('ServiceItemV2Controller', ServiceItemV2Controller);

    ServiceItemV2Controller.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceCategoryCustom', 'CompanyCustom', '$translate', '$translatePartialLoader', '$state', 'ServiceItemCustom', 'Principal', '$rootScope', 'ActivityTypeInfoCustom'];

    function ServiceItemV2Controller($timeout, $scope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceCategoryCustom, CompanyCustom, translate, translatePartialLoader, $state, ServiceItemCustom, Principal, $rootScope, ActivityTypeInfoCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.scheduleFormState = 'list';
        vm.priceInfoFormState = "'list'";
        vm.serviceOptionInfoFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.serviceItem = entity;
        vm.oldItem = angular.copy(vm.serviceItem);
        vm.mainScheduleType = 'SERVICE_SCHEDULE';
        vm.saveAndGotoScheduling = saveAndGotoScheduling;
        vm.weekDayExists = weekDayExists;
        vm.toggleWeekDay = toggleWeekDay;
        vm.weekDays = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
        // vm.isCopyChecked = false;

        //vm.clear = clear;
        vm.save = save;
        vm.categoryName = categoryName;
        vm.showFullDescription = showFullDescription;
        vm.fullDescription = false;
        vm.showAdvancedSetting = showAdvancedSetting;
        vm.advancedSetting = false;
        vm.showDuration = showDuration;
        vm.confirmationType_Change = confirmationType_Change;
        if (vm.serviceItem.multiReserveMode == undefined)
            vm.serviceItem.multiReserveMode = "DISABLE";
        vm.serviceColors = ['COLOR0', 'COLOR1', 'COLOR2', 'COLOR3', 'COLOR4', 'COLOR5'];
        vm.hasServant = hasServant;
        vm.hasServants = false;
        vm.showOnMarketPlace = false;
        vm.findMarketPlacePublishStatusStyle = findMarketPlacePublishStatusStyle;
        vm.findMarketPlacePublishStatusIcon = findMarketPlacePublishStatusIcon;

        vm.showMarketPlaceSection = false;
        vm.isVideoMeeting = false;
        vm.meetingCheckChange = meetingCheckChange;
        vm.hasAccesToTwoStpeFeature = false;
        vm.isEventMode = false;
        vm.backToList = backToList;
        vm.canEditCapacity = false;

        initDefault();


        vm.paymentType_changed = paymentType_changed;
        vm.priceInfoFormReload = false;
        vm.getArrowClass = getArrowClass;
        vm.autoApprove_Changed = autoApprove_Changed;


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.copyItem = copyItem;
        vm.deleteItem = deleteItem;
        vm.getModalTitle = getModalTitle;
        vm.tabChanged = tabChanged;
        vm.isWorkingSpace = false;


        findCurrentCompany();
        $rootScope.$broadcast('hideNavBar');


        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {


            vm.servicecategories = result;
            if (vm.serviceItem.category == null || vm.serviceItem.category == undefined || vm.serviceItem.category.id == null || vm.serviceItem.category.id == undefined) {
                angular.forEach(result, function (category) {

                    if (category.categoryName == "DEFAULT_CATEGORY") {
                        vm.serviceItem.category = category;
                    }

                });
            }

            angular.forEach(vm.servicecategories, function (category) {

                    category.categoryName = categoryName(category.categoryName)
                }
            );


            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('marketPlacePublishStatus');
            translatePartialLoader.addPart('paymentDeadlineType');
            translatePartialLoader = translate.refresh();

        });

        if (vm.serviceItem.maxPreReserveTime == null || vm.serviceItem.maxPreReserveTime == undefined)
            vm.serviceItem.maxPreReserveTime = 30;
        if (vm.serviceItem.minPreReserveTime == null || vm.serviceItem.minPreReserveTime == undefined)
            vm.serviceItem.minPreReserveTime = 0;


        // $timeout(function () {
        //     angular.element('.form-group:eq(1)>input').focus();
        // });


        if (vm.serviceItem.amenities == null || vm.serviceItem.amenities == undefined) {
            vm.serviceItem.amenities = {};
            vm.serviceItem.amenities.amenitiesList = [];
        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.currentCompany.activityType).query(function (activity) {
                    vm.activityTypeInfo = activity;
                    if (activity && activity.servantType == "RESOURCE") {
                        vm.isWorkingSpace = true;
                        // vm.priceInfoType = "fixed";
                    }
                });
            });
        }

        function save() {
            updateScheduleTypeFromMainType();
            checkIfScheduleRegenerationNeeded();
            updateMarketPlaceInfo();
            vm.priceInfoFormReload = 'false';


            if (vm.scope.editForm.$valid && !vm.isSaving) {
                vm.isSaving = true;

                if (vm.serviceItem.id !== null) {
                    ServiceItem.update(vm.serviceItem, onSaveSuccess, onSaveError);
                } else {
                    ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);

                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:serviceItemUpdate', result);
            vm.isSaving = false;
            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $rootScope.$broadcast('showNavBar');
                $state.go('supplierPanel-v2.dashboard');
            } else {
                if (vm.isEventMode)
                    $state.go('supplierPanel-v2.eventItemList.eventItem', {id: result.id})
                else
                    $state.go('supplierPanel-v2.serviceItemList.serviceItem', {id: result.id})
            }


        }

        function backToList() {

            vm.scheduleFormState = 'list';
            vm.selectedScheduleId = '';
        }

        function onSelectedScheduleChanged(data) {

            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : data.id});

        }

        function onCreateNewSchedule() {

            vm.serviceItem.scheduleInfo = {};

        }

        function onCreateNewPriceInfo() {
            //

            vm.serviceItem.priceInfo = {};

        }

        function onSelectedPriceInfoChanged(data) {
            //
            //vm.serviceItem.priceInfo= PriceInfo.get({id : data.id});

        }

        function onSaveError() {
            vm.isSaving = false;
            vm.nextGotoScheduling = false;
        }


        function paymentType_changed() {

            if (vm.serviceItem.paymentType == "PAYMENT_ALL") {
                vm.serviceItem.prePaymentAmount = 0;
            }
            if (vm.serviceItem.paymentType == "PRE_PAYMENT") {
                vm.serviceItem.inPlacePayment = false;
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function showFullDescription() {
            vm.fullDescription = !vm.fullDescription;
        }

        function showAdvancedSetting() {
            vm.advancedSetting = !vm.advancedSetting;

        }

        function initDefault() {


            if (vm.serviceItem.serviceStatus == null || vm.serviceItem.serviceStatus == undefined)
                vm.serviceItem.serviceStatus = 'PUBLISH';

            if (vm.serviceItem.paymentType == null || vm.serviceItem.paymentType == undefined)
                vm.serviceItem.paymentType = 'PAYMENT_ALL';

            if (vm.serviceItem.confirmationType == null || vm.serviceItem.confirmationType == undefined)
                vm.serviceItem.confirmationType = 'ONE_STEP';

            if (vm.serviceItem.capacityInfo == null || vm.serviceItem.capacityInfo == undefined || vm.serviceItem.capacityInfo.qty == null || vm.serviceItem.capacityInfo.qty == undefined) {
                vm.serviceItem.capacityInfo = {};
                vm.serviceItem.capacityInfo.qty = 1;
                vm.serviceItem.capacityInfo.qtyUnit = 'نفر';
                vm.serviceItem.capacityInfo.minQty = 1;
            } else {
                if (!vm.serviceItem.capacityInfo.qtyUnit) {
                    vm.serviceItem.capacityInfo.qtyUnit = 'نفر';

                }
                if (!vm.serviceItem.capacityInfo.minQty)
                    vm.serviceItem.capacityInfo.minQty = 1;
            }

            if (!vm.serviceItem.duration)
                vm.serviceItem.duration = 60;
            if (!vm.serviceItem.gapTime)
                vm.serviceItem.gapTime = 0;
            if (!vm.serviceItem.consecutiveReserveMode)
                vm.serviceItem.consecutiveReserveMode = 'DISABLE';


            if (vm.serviceItem.color == null)
                vm.serviceItem.color = 'COLOR0';


            if (vm.serviceItem.prePaymentAmount == null)
                vm.serviceItem.prePaymentAmount = 0;

            if (vm.serviceItem.servantSelectMode == null)
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';

            if (vm.serviceItem.showOnMarketPlaceStatus == null || vm.serviceItem.showOnMarketPlaceStatus == 'NOT_SHOW')
                vm.showOnMarketPlace = false;
            else
                vm.showOnMarketPlace = true;

            if (!vm.serviceItem.paymentDeadlineType)
                vm.serviceItem.paymentDeadlineType = 'UNTIL_RESERVE_TIME';

            if (!vm.serviceItem.customerConfirmationDeadline)
                vm.serviceItem.customerConfirmationDeadline = 24;

            if (vm.serviceItem.serviceMode && vm.serviceItem.serviceMode == "EVENT") {
                vm.isEventMode = true;
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';
            }

            setMainScheduleType();
            canAccessTwoStepFeature();
            checkCapacityFeature();
            hasServant();
            checkMarketPlaceInfo();
            setMeetingType();

            //must run last

        }

        function setMainScheduleType() {
            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                    if (vm.serviceItem.consecutiveReserveMode != 'DISABLE')
                        vm.serviceItem.consecutiveReserveMode = 'ENABLE';
                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    vm.mainScheduleType = 'FIXED_TIME_SESSIONS';
                } else {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                }
            }
        }

        function updateScheduleTypeFromMainType() {

            if (vm.serviceItem.scheduleInfo == null)
                vm.serviceItem.scheduleInfo = {};

            vm.serviceItem.scheduleInfo.scheduleType = vm.mainScheduleType;

            //if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
            //    var currentType = vm.serviceItem.scheduleInfo.scheduleType;
            //    if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
            //        if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //            currentType = 'FIXED_TIME_SESSIONS'
            //        }
            //
            //    } else if (currentType == 'FIXED_TIME_SESSIONS') {
            //        if (vm.mainScheduleType != 'FIXED_TIME_SESSIONS')
            //            currentType = 'SERVICE_SCHEDULE';
            //    } else {
            //        currentType = 'SERVICE_SCHEDULE';
            //    }
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //} else {
            //    var currentType = 'SERVICE_SCHEDULE';
            //    if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //        currentType = 'FIXED_TIME_SESSIONS'
            //    }
            //    if (!vm.serviceItem.scheduleInfo)vm.serviceItem.scheduleInfo = {};
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //}
        }

        function saveAndGotoScheduling() {
            vm.nextGotoScheduling = true;
            vm.save();
        }

        function checkIfScheduleRegenerationNeeded() {
            vm.serviceItem.scheduleGenerationNeeded = true;
            return;
            vm.scheduleGenerationNeeded = false;
            if (vm.oldItem && vm.oldItem.scheduleInfo && vm.serviceItem && vm.serviceItem.scheduleInfo && vm.oldItem.scheduleInfo.scheduleType != vm.serviceItem.scheduleInfo.scheduleType) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.duration != vm.serviceItem.duration ||
                (vm.oldItem.capacityInfo && vm.oldItem.capacityInfo.qty != vm.serviceItem.capacityInfo.qty) ||
                vm.oldItem.maxPreReserveTime != vm.serviceItem.maxPreReserveTime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.gaptime != vm.serviceItem.gaptime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else {
                //checking servants
                if (vm.oldItem.servants.length != vm.serviceItem.servants.length)
                    vm.serviceItem.scheduleGenerationNeeded = true;
                else {
                    if (vm.oldItem.servants.length > 0) {
                        angular.forEach(vm.oldItem.servants, function (os) {
                            var isInList = false;
                            angular.forEach(vm.serviceItem.servants, function (ns) {
                                if (ns.id == os.id)
                                    isInList = true;
                            });
                            if (!isInList)
                                vm.serviceItem.scheduleGenerationNeeded = true;
                        })
                    }
                }

            }
        }

        function showDuration() {

            if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS')
                return false;

            if (vm.serviceItem == null || vm.serviceItem.serviceTimes == null)
                return true;

            if (vm.serviceItem.serviceTimes != null && vm.serviceItem.serviceTimes != undefined
                && vm.serviceItem.serviceTimes.length == 1 && vm.serviceItem.serviceTimes[0].scheduleType == 'SERVICE_SCHEDULE'
            ) {
                return true;
            }

        }

        function confirmationType_Change() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'TWO_STEP'

            ) {
                if (vm.serviceItem.customerConfirmationDeadline == null || vm.serviceItem.customerConfirmationDeadline == undefined || vm.serviceItem.customerConfirmationDeadline == 0) {
                    vm.serviceItem.customerConfirmationDeadline = 24;
                }
            }

            checkDeadLineStates();
        }


        function autoApprove_Changed() {
            checkDeadLineStates();
        }

        function checkDeadLineStates() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'ONE_STEP') {
                vm.serviceItem.paymentDeadline = false;
            }
        }

        function weekDayExists(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            var isExist = false;
            if (selectedWeekDay != undefined)
                angular.forEach(selectedWeekDay, function (item) {
                    if (item == weekDay)
                        isExist = true;
                });
            return isExist;

        }

        function toggleWeekDay(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            if (selectedWeekDay == undefined)
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays = [];

            if (vm.weekDayExists(weekDay, selectedWeekDay)) {
                var index = selectedWeekDay.indexOf(weekDay);
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.splice(index, 1);
            } else {
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.push(weekDay);
            }

        }

        function getColorClass(color) {
            return color;

        }

        function hasServant() {
            if (vm.serviceItem.servants != null && vm.serviceItem.servants.length > 0) {
                vm.hasServants = true;
            } else {
                vm.hasServants = false;
            }
        }

        function updateMarketPlaceInfo() {

            if (vm.showOnMarketPlace)
                vm.serviceItem.showOnMarketPlaceStatus = 'SHOW'
            else
                vm.serviceItem.showOnMarketPlaceStatus = 'NOT_SHOW'


            //in every save if showOnMarketPlaceStatus = 'SHOW' must set marketPlacePublishStatus = 'REQUESTED'

            if (vm.serviceItem.showOnMarketPlaceStatus == 'SHOW') {
                vm.serviceItem.marketPlacePublishStatus = 'REQUESTED'
            } else {
                vm.serviceItem.marketPlacePublishStatus = null;
            }


        }

        function findMarketPlacePublishStatusStyle() {

            return "market-place-publish-status-" + vm.serviceItem.marketPlacePublishStatus;
        }

        function findMarketPlacePublishStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-flash";
            }
            if (status == "WAITING") {
                return "glyphicon glyphicon-time";
            }
            if (status == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "DENIED") {
                return "glyphicon glyphicon-remove";
            }

        }

        function checkMarketPlaceInfo() {
            vm.showMarketPlaceSection = false;
            // if(vm.serviceItem.id && vm.serviceItem.category.company.activityType == 'WORK_SPACE')
            // {
            //     vm.showMarketPlaceSection = false;
            // }
        }

        function meetingCheckChange() {
            if (vm.isVideoMeeting) {
                vm.serviceItem.meetingType = 'RW_VIDEO_CALL';
            } else
                vm.serviceItem.meetingType = null;
        }

        function setMeetingType() {
            if (vm.serviceItem.meetingType && vm.serviceItem.meetingType == 'RW_VIDEO_CALL') {
                vm.isVideoMeeting = true;
            } else {
                vm.isVideoMeeting = false;
            }
        }

        function canAccessTwoStepFeature() {
            vm.hasAccesToTwoStpeFeature = Principal.hasSpecialFeatureAccess('twoStepVerification');
        }

        function checkCapacityFeature() {
            if (vm.serviceItem.serviceMode && vm.serviceItem.serviceMode == "EVENT")
                vm.canEditCapacity = true;
            else
                vm.canEditCapacity = Principal.hasSpecialFeatureAccess('serviceCapacity');
        }

        function backToList() {
            if (vm.isEventMode)
                $state.go('supplierPanel.serviceItemEventListV2', {id: vm.serviceItem.id});
            else
                $state.go('supplierPanel.serviceItemListV2', {id: vm.serviceItem.id});
        }

        function getArrowClass() {
            if (vm.advancedSetting)
                return 'arrow-animate';
            else
                return 'arrow-animate-left';
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard')
                $state.go('supplierPanel-v2.dashboard');
            else {
                if (vm.isEventMode) {
                    $state.go('supplierPanel-v2.eventItemList', $rootScope.fromStateParams);
                    
                }else {
                    $state.go('supplierPanel-v2.serviceItemList', $rootScope.fromStateParams);
                        
                }
                   
            }
        }

        function copyItem() {
            if (!vm.isEventMode)
                $state.go('supplierPanel-v2.serviceItemList.serviceItem.copy', {id: vm.serviceItem.id});
            else
                $state.go('supplierPanel-v2.eventItemList.eventItem.copy', {id: vm.serviceItem.id});
        }

        function deleteItem() {
            if (!vm.isEventMode)
                $state.go('supplierPanel-v2.serviceItemList.serviceItem.delete', {id: vm.serviceItem.id});
            else
                $state.go('supplierPanel-v2.eventItemList.eventItem.delete', {id: vm.serviceItem.id});
        }

        function getModalTitle() {
            if (!vm.serviceItem.id && !vm.isEventMode)
                return 'tikonApp.serviceItem.home.createLabel-v2';
            if (vm.serviceItem.id && !vm.isEventMode)
                return 'tikonApp.serviceItem.home.viewOrEditServiceItem';
            if (!vm.serviceItem.id && vm.isEventMode)
                return 'tikonApp.eventItem.home.createLabel';
            if (vm.serviceItem.id && vm.isEventMode)
                return 'tikonApp.eventItem.home.editLabel';
        }

        function tabChanged(tabName) {
            switch (tabName) {
                case 'advancedSetting' :
                    canAccessTwoStepFeature();
                    break;
                default :
                    break;
            }
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemListV2Controller', ServiceItemListV2Controller);

    ServiceItemListV2Controller.$inject = ['$scope', '$state', '$stateParams', '$location', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate', '$uibModal', 'QueryParamsService'];

    function ServiceItemListV2Controller($scope, $state, $stateParams, $location, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate, $uibModal, QueryParamsService) {
        var vm = this;
        //

        var type = $stateParams.type;
        if (type == 'class') {
            $state.current.url = '/classes';
        } else {
            type = 'service';
        }

// alert(type);
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;

        vm.editServiceItem = editServiceItem;
        vm.searchServiceItem = searchServiceItem;
        vm.searchKeyPress = searchKeyPress;
        vm.newServiceItem = newServiceItem;
        vm.clearSearch = clearSearch;
        vm.showEducation = showEducation


        // vm.copyServiceItem = copyServiceItem;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            loadServiceItems();
        }

        function loadServiceItems() {
            ServiceItemCustom.getServiceItemByCurrentCompanyAndServiceMode('RESERVE').query().$promise.then(function(res){
                vm.serviceItems = res;
                 var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        searchServiceItem()
                }
            })
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }


        function editServiceItem(item) {
            $state.go('supplierPanel-v2.serviceItemList.serviceItem', {id: item.id});
        }

        function searchServiceItem() {

            if (!vm.searchQuery) {
                QueryParamsService.removeFilter('searchText')
                loadServiceItems();
                return;
            }else QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.serviceItems = vm.serviceItems.filter(function (srv) {
                if (srv.itemTitle.includes(vm.searchQuery) ||
                    srv.category.categoryName.includes(vm.searchQuery)
                )
                    return true;
            })
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServiceItem();
            }
        }

        function newServiceItem() {
            $state.go('supplierPanel-v2.serviceItemList.serviceItem');
        }

        function clearSearch() {
            vm.searchQuery = null;
            QueryParamsService.removeFilter('searchText')
            loadServiceItems();
        }
         function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="99431983546"><script type="text/JavaScript" src="https://www.aparat.com/embed/rhu4h4t?data[rnddiv]=99431983546&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>'
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }
    }
})();;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemEventListV2Controller', ServiceItemEventListV2Controller);

    ServiceItemEventListV2Controller.$inject = ['$scope', '$state', '$stateParams', '$location', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate'];

    function ServiceItemEventListV2Controller($scope, $state, $stateParams, $location, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate) {
        var vm = this;
        //

        var type = $stateParams.type;
        if (type == 'class') {
            $state.current.url = '/classes';
        } else {
            type = 'service';
        }
// alert(type);
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;
        // vm.copyServiceItem = copyServiceItem;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            vm.serviceItems = ServiceItemCustom.getServiceItemByCurrentCompanyAndServiceMode('EVENT').query();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        // function copyServiceItem(serviceItemId) {
        //     ServiceItemCustom.createCopyOfServiceItemById(serviceItemId).query(function (res) {
        //         vm.loadPage();
        //     });
        // }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemDeleteV2Controller', ServiceItemDeleteV2Controller);

    ServiceItemDeleteV2Controller.$inject = ['$uibModalInstance', 'entity', 'ServiceItem'];

    function ServiceItemDeleteV2Controller($uibModalInstance, entity, ServiceItem) {
        var vm = this;


        vm.serviceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemCopyV2Controller', ServiceItemCopyV2Controller);

    ServiceItemCopyV2Controller.$inject = ['$uibModalInstance', 'entity', 'ServiceItemCustom'];

    function ServiceItemCopyV2Controller($uibModalInstance, entity, ServiceItemCustom) {
        var vm = this;


        vm.serviceItem = entity;
        vm.clear = clear;
        vm.copyServiceItem = copyServiceItem;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function copyServiceItem(serviceItemId) {
            ServiceItemCustom.createCopyOfServiceItemById(serviceItemId).query(function (res) {
                // vm.loadPage();
                $uibModalInstance.close(true);
            });
        }

    }
})();
;
(function () {
    'use strict';


    angular
        .module('tikonApp')
        .controller('GeneralServiceItemV2Controller', GeneralServiceItemV2Controller);

    GeneralServiceItemV2Controller.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceCategoryCustom', 'CompanyCustom', '$translate', '$translatePartialLoader', '$state', 'ServiceItemCustom', 'Principal'];

    function GeneralServiceItemV2Controller($timeout, $scope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceCategoryCustom, CompanyCustom, translate, translatePartialLoader, $state, ServiceItemCustom, Principal) {
        var vm = this;
        vm.scope = $scope;
        vm.scheduleFormState = 'list';
        vm.priceInfoFormState = "'list'";
        vm.serviceOptionInfoFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.serviceItem = entity;
        vm.oldItem = angular.copy(vm.serviceItem);
        vm.mainScheduleType = 'SERVICE_SCHEDULE';
        vm.saveAndGotoScheduling = saveAndGotoScheduling;
        vm.weekDayExists = weekDayExists;
        vm.toggleWeekDay = toggleWeekDay;
        vm.weekDays = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
        // vm.isCopyChecked = false;

        //vm.clear = clear;
        vm.save = save;
        vm.categoryName = categoryName;
        vm.showFullDescription = showFullDescription;
        vm.fullDescription = false;
        vm.showAdvancedSetting = showAdvancedSetting;
        vm.advancedSetting = false;
        vm.showDuration = showDuration;
        vm.confirmationType_Change = confirmationType_Change;
        if (vm.serviceItem.multiReserveMode == undefined)
            vm.serviceItem.multiReserveMode = "DISABLE";
        vm.serviceColors = ['COLOR0', 'COLOR1', 'COLOR2', 'COLOR3', 'COLOR4', 'COLOR5'];
        vm.hasServant = hasServant;
        vm.hasServants = false;
        vm.showOnMarketPlace = false;
        vm.findMarketPlacePublishStatusStyle = findMarketPlacePublishStatusStyle;
        vm.findMarketPlacePublishStatusIcon = findMarketPlacePublishStatusIcon;

        vm.showMarketPlaceSection = false;
        vm.isVideoMeeting = false;
        vm.meetingCheckChange = meetingCheckChange;
        vm.hasAccesToTwoStpeFeature = false;
        vm.isEventMode = false;
        vm.backToList = backToList;
        initDefault();
        vm.paymentType_changed = paymentType_changed;
        vm.priceInfoFormReload = false;
        vm.getArrowClass = getArrowClass;
        vm.autoApprove_Changed = autoApprove_Changed;
        findCurrentCompany();


        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {


            vm.servicecategories = result;
            if (vm.serviceItem.category == null || vm.serviceItem.category == undefined || vm.serviceItem.category.id == null || vm.serviceItem.category.id == undefined) {
                angular.forEach(result, function (category) {

                    if (category.categoryName == "DEFAULT_CATEGORY") {
                        vm.serviceItem.category = category;
                    }

                });
            }

            angular.forEach(vm.servicecategories, function (category) {

                    category.categoryName = categoryName(category.categoryName)
                }
            );


            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('marketPlacePublishStatus');
            translatePartialLoader.addPart('paymentDeadlineType');
            translatePartialLoader = translate.refresh();

        });

        if (vm.serviceItem.maxPreReserveTime == null || vm.serviceItem.maxPreReserveTime == undefined)
            vm.serviceItem.maxPreReserveTime = 30;
        if (vm.serviceItem.minPreReserveTime == null || vm.serviceItem.minPreReserveTime == undefined)
            vm.serviceItem.minPreReserveTime = 0;


        // $timeout(function () {
        //     angular.element('.form-group:eq(1)>input').focus();
        // });


        if (vm.serviceItem.amenities == null || vm.serviceItem.amenities == undefined) {
            vm.serviceItem.amenities = {};
            vm.serviceItem.amenities.amenitiesList = [];
        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
                if (vm.currentCompany.activityType == 'WORK_SPACE') {
                    vm.priceInfoType = "fixed";
                }
            });
        }


        //
        //function clear () {
        //    $uibModalInstance.dismiss('cancel');
        //}

        function save() {
            updateScheduleTypeFromMainType();
            checkIfScheduleRegenerationNeeded();
            updateMarketPlaceInfo();
            vm.priceInfoFormReload = 'false';


            if (vm.scope.serviceItemForm.$valid) {
                vm.isSaving = true;

                if (vm.serviceItem.id !== null) {

                    ServiceItem.update(vm.serviceItem, onSaveSuccess, onSaveError);
                } else {
                    ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);

                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:serviceItemUpdate', result);

            ServiceItem.get({id: result.id}).$promise.then(function (serv) {
                vm.serviceItem = serv;
                vm.oldItem = angular.copy(vm.serviceItem);
                //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : result.scheduleInfo.id});
                //$uibModalInstance.close(result);

                vm.priceInfoFormReload = 'true';
                vm.priceInfoFormState = 'list';
                vm.serviceOptionInfoFormState = 'list';
                vm.isSaving = false;
                vm.hasServant();
            });


            // if (vm.nextGotoScheduling) {
            //     $state.go('supplierPanel.scheduling', {id: vm.serviceItem.id});
            // }

        }

        function backToList() {

            vm.scheduleFormState = 'list';
            vm.selectedScheduleId = '';
        }

        function onSelectedScheduleChanged(data) {

            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : data.id});

        }

        function onCreateNewSchedule() {

            vm.serviceItem.scheduleInfo = {};

        }

        function onCreateNewPriceInfo() {
            //

            vm.serviceItem.priceInfo = {};

        }

        function onSelectedPriceInfoChanged(data) {
            //
            //vm.serviceItem.priceInfo= PriceInfo.get({id : data.id});

        }

        function onSaveError() {
            vm.isSaving = false;
            vm.nextGotoScheduling = false;
        }


        function paymentType_changed() {

            if (vm.serviceItem.paymentType == "PAYMENT_ALL") {
                vm.serviceItem.prePaymentAmount = 0;
            }
            if (vm.serviceItem.paymentType == "PRE_PAYMENT") {
                vm.serviceItem.inPlacePayment = false;
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function showFullDescription() {
            vm.fullDescription = !vm.fullDescription;
        }

        function showAdvancedSetting() {
            vm.advancedSetting = !vm.advancedSetting;
            canAccessTwoStepFeature();
        }

        function initDefault() {


            if (vm.serviceItem.serviceStatus == null || vm.serviceItem.serviceStatus == undefined)
                vm.serviceItem.serviceStatus = 'PUBLISH';

            if (vm.serviceItem.paymentType == null || vm.serviceItem.paymentType == undefined)
                vm.serviceItem.paymentType = 'PAYMENT_ALL';

            if (vm.serviceItem.confirmationType == null || vm.serviceItem.confirmationType == undefined)
                vm.serviceItem.confirmationType = 'ONE_STEP';

            if (vm.serviceItem.capacityInfo == null || vm.serviceItem.capacityInfo == undefined || vm.serviceItem.capacityInfo.qty == null || vm.serviceItem.capacityInfo.qty == undefined) {
                vm.serviceItem.capacityInfo = {};
                vm.serviceItem.capacityInfo.qty = 1;
                vm.serviceItem.capacityInfo.qtyUnit = 'نفر';
                vm.serviceItem.capacityInfo.minQty = 1;
            } else {
                if (!vm.serviceItem.capacityInfo.qtyUnit) {
                    vm.serviceItem.capacityInfo.qtyUnit = 'نفر';

                }
                if (!vm.serviceItem.capacityInfo.minQty)
                    vm.serviceItem.capacityInfo.minQty = 1;
            }

            if (!vm.serviceItem.duration)
                vm.serviceItem.duration = 60;
            if (!vm.serviceItem.gapTime)
                vm.serviceItem.gapTime = 0;
            if (!vm.serviceItem.consecutiveReserveMode)
                vm.serviceItem.consecutiveReserveMode = 'DISABLE';


            if (vm.serviceItem.color == null)
                vm.serviceItem.color = 'COLOR0';


            if (vm.serviceItem.prePaymentAmount == null)
                vm.serviceItem.prePaymentAmount = 0;

            if (vm.serviceItem.servantSelectMode == null)
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';

            if (vm.serviceItem.showOnMarketPlaceStatus == null || vm.serviceItem.showOnMarketPlaceStatus == 'NOT_SHOW')
                vm.showOnMarketPlace = false;
            else
                vm.showOnMarketPlace = true;

            if (!vm.serviceItem.paymentDeadlineType)
                vm.serviceItem.paymentDeadlineType = 'UNTIL_RESERVE_TIME';

            if (!vm.serviceItem.customerConfirmationDeadline)
                vm.serviceItem.customerConfirmationDeadline = 24;

            if (vm.serviceItem.serviceMode && vm.serviceItem.serviceMode == "EVENT") {
                vm.isEventMode = true;
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';
            }

            setMainScheduleType();

            hasServant();
            checkMarketPlaceInfo();
            setMeetingType();

            //must run last

        }

        function setMainScheduleType() {
            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                    if (vm.serviceItem.consecutiveReserveMode != 'DISABLE')
                        vm.serviceItem.consecutiveReserveMode = 'ENABLE';
                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    vm.mainScheduleType = 'FIXED_TIME_SESSIONS';
                } else {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                }
            }
        }

        function updateScheduleTypeFromMainType() {

            if (vm.serviceItem.scheduleInfo == null)
                vm.serviceItem.scheduleInfo = {};

            vm.serviceItem.scheduleInfo.scheduleType = vm.mainScheduleType;

            //if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
            //    var currentType = vm.serviceItem.scheduleInfo.scheduleType;
            //    if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
            //        if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //            currentType = 'FIXED_TIME_SESSIONS'
            //        }
            //
            //    } else if (currentType == 'FIXED_TIME_SESSIONS') {
            //        if (vm.mainScheduleType != 'FIXED_TIME_SESSIONS')
            //            currentType = 'SERVICE_SCHEDULE';
            //    } else {
            //        currentType = 'SERVICE_SCHEDULE';
            //    }
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //} else {
            //    var currentType = 'SERVICE_SCHEDULE';
            //    if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //        currentType = 'FIXED_TIME_SESSIONS'
            //    }
            //    if (!vm.serviceItem.scheduleInfo)vm.serviceItem.scheduleInfo = {};
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //}
        }

        function saveAndGotoScheduling() {
            vm.nextGotoScheduling = true;
            vm.save();
        }

        function checkIfScheduleRegenerationNeeded() {
            vm.serviceItem.scheduleGenerationNeeded = true;
            return;
            vm.scheduleGenerationNeeded = false;
            if (vm.oldItem && vm.oldItem.scheduleInfo && vm.serviceItem && vm.serviceItem.scheduleInfo && vm.oldItem.scheduleInfo.scheduleType != vm.serviceItem.scheduleInfo.scheduleType) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.duration != vm.serviceItem.duration ||
                (vm.oldItem.capacityInfo && vm.oldItem.capacityInfo.qty != vm.serviceItem.capacityInfo.qty) ||
                vm.oldItem.maxPreReserveTime != vm.serviceItem.maxPreReserveTime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.gaptime != vm.serviceItem.gaptime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else {
                //checking servants
                if (vm.oldItem.servants.length != vm.serviceItem.servants.length)
                    vm.serviceItem.scheduleGenerationNeeded = true;
                else {
                    if (vm.oldItem.servants.length > 0) {
                        angular.forEach(vm.oldItem.servants, function (os) {
                            var isInList = false;
                            angular.forEach(vm.serviceItem.servants, function (ns) {
                                if (ns.id == os.id)
                                    isInList = true;
                            });
                            if (!isInList)
                                vm.serviceItem.scheduleGenerationNeeded = true;
                        })
                    }
                }

            }
        }

        function showDuration() {

            if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS')
                return false;

            if (vm.serviceItem == null || vm.serviceItem.serviceTimes == null)
                return true;

            if (vm.serviceItem.serviceTimes != null && vm.serviceItem.serviceTimes != undefined
                && vm.serviceItem.serviceTimes.length == 1 && vm.serviceItem.serviceTimes[0].scheduleType == 'SERVICE_SCHEDULE'
            ) {
                return true;
            }

        }

        function confirmationType_Change() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'TWO_STEP'

            ) {
                if (vm.serviceItem.customerConfirmationDeadline == null || vm.serviceItem.customerConfirmationDeadline == undefined || vm.serviceItem.customerConfirmationDeadline == 0) {
                    vm.serviceItem.customerConfirmationDeadline = 24;
                }
            }

            checkDeadLineStates();
        }


        function autoApprove_Changed() {
            checkDeadLineStates();
        }

        function checkDeadLineStates() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'ONE_STEP') {
                vm.serviceItem.paymentDeadline = false;
            }
        }

        function weekDayExists(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            var isExist = false;
            if (selectedWeekDay != undefined)
                angular.forEach(selectedWeekDay, function (item) {
                    if (item == weekDay)
                        isExist = true;
                });
            return isExist;

        }

        function toggleWeekDay(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            if (selectedWeekDay == undefined)
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays = [];

            if (vm.weekDayExists(weekDay, selectedWeekDay)) {
                var index = selectedWeekDay.indexOf(weekDay);
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.splice(index, 1);
            } else {
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.push(weekDay);
            }

        }

        function getColorClass(color) {
            return color;

        }

        function hasServant() {
            if (vm.serviceItem.servants != null && vm.serviceItem.servants.length > 0) {
                vm.hasServants = true;
            } else {
                vm.hasServants = false;
            }
        }

        function updateMarketPlaceInfo() {

            if (vm.showOnMarketPlace)
                vm.serviceItem.showOnMarketPlaceStatus = 'SHOW'
            else
                vm.serviceItem.showOnMarketPlaceStatus = 'NOT_SHOW'


            //in every save if showOnMarketPlaceStatus = 'SHOW' must set marketPlacePublishStatus = 'REQUESTED'

            if (vm.serviceItem.showOnMarketPlaceStatus == 'SHOW') {
                vm.serviceItem.marketPlacePublishStatus = 'REQUESTED'
            } else {
                vm.serviceItem.marketPlacePublishStatus = null;
            }


        }

        function findMarketPlacePublishStatusStyle() {

            return "market-place-publish-status-" + vm.serviceItem.marketPlacePublishStatus;
        }

        function findMarketPlacePublishStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-flash";
            }
            if (status == "WAITING") {
                return "glyphicon glyphicon-time";
            }
            if (status == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "DENIED") {
                return "glyphicon glyphicon-remove";
            }

        }

        function checkMarketPlaceInfo() {
            vm.showMarketPlaceSection = false;
            if (vm.serviceItem.id && vm.serviceItem.category.company.activityType == 'WORK_SPACE') {
                vm.showMarketPlaceSection = false;
            }
        }

        function meetingCheckChange() {
            if (vm.isVideoMeeting) {
                vm.serviceItem.meetingType = 'RW_VIDEO_CALL';
            } else
                vm.serviceItem.meetingType = null;
        }

        function setMeetingType() {
            if (vm.serviceItem.meetingType && vm.serviceItem.meetingType == 'RW_VIDEO_CALL') {
                vm.isVideoMeeting = true;
            } else {
                vm.isVideoMeeting = false;
            }
        }

        function canAccessTwoStepFeature() {
            vm.hasAccesToTwoStpeFeature = Principal.hasSpecialFeatureAccess('twoStepVerification');
        }

        function backToList() {
            if (vm.isEventMode)
                $state.go('supplierPanel.serviceItemEventListV2', {id: vm.serviceItem.id});
            else
                $state.go('supplierPanel.serviceItemListV2', {id: vm.serviceItem.id});
        }

        function getArrowClass() {
            if (vm.advancedSetting)
                return 'arrow-animate';
            else
                return 'arrow-animate-left';
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EventItemListV2Controller', EventItemListV2Controller);

    EventItemListV2Controller.$inject = ['$scope', '$state', '$stateParams', '$location', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate', '$uibModal', 'QueryParamsService'];

    function EventItemListV2Controller($scope, $state, $stateParams, $location, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate, $uibModal, QueryParamsService) {
        var vm = this;
        //

        var type = $stateParams.type;
        if (type == 'class') {
            $state.current.url = '/classes';
        } else {
            type = 'service';
        }
// alert(type);
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;
        // vm.copyServiceItem = copyServiceItem;

        vm.editServiceItem = editServiceItem;
        vm.searchServiceItem = searchServiceItem;
        vm.searchKeyPress = searchKeyPress;
        vm.newServiceItem = newServiceItem;
        vm.clearSearch = clearSearch;
        vm.showEducation = showEducation
        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            loadServiceItems();
        }

        function loadServiceItems() {
            ServiceItemCustom.getServiceItemByCurrentCompanyAndServiceMode('EVENT').query().$promise.then(function(res) {
                vm.serviceItems = res;
                var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        vm.searchServiceItem()
                }
            });
        }


        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        // function copyServiceItem(serviceItemId) {
        //     ServiceItemCustom.createCopyOfServiceItemById(serviceItemId).query(function (res) {
        //         vm.loadPage();
        //     });
        // }


        function editServiceItem(item) {
            $state.go('supplierPanel-v2.eventItemList.eventItem', {id: item.id});
        }

        function searchServiceItem() {

            if (!vm.searchQuery) {
                QueryParamsService.removeFilter('searchText')
                loadServiceItems();
                return;
            }else QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.serviceItems = vm.serviceItems.filter(function (srv) {
                if (srv.itemTitle.includes(vm.searchQuery) ||
                    srv.category.categoryName.includes(vm.searchQuery)
                )
                    return true;
            })
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServiceItem();
            }
        }

        function newServiceItem() {
            $state.go('supplierPanel-v2.eventItemList.eventItem');
        }

        function clearSearch() {
            vm.searchQuery = null;
            QueryParamsService.removeFilter('searchText')
            searchServiceItem();

        }
         function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="73777012734"><script type="text/JavaScript" src="https://www.aparat.com/embed/sjdfp65?data[rnddiv]=73777012734&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceItemCustom', ServiceItemCustom);

    ServiceItemCustom.$inject = ['$resource', 'ENV'];

    function ServiceItemCustom($resource, ENV) {


        var getServiceItemsByCurrentCompany = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/service-items-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getActiveServiceItemsByCurrentCompany = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/active-service-items-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getActiveServiceItemsByCategory = function (categoryid) {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/active-service-items-by-category/' + categoryid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceItemsWithOutSchedulingByCurrentCompany = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-items-without-scheduling-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getAllAmenitiesType = function () {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/get-all-amenities-type';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getServiceServants = function (serviceid) {
            //
            var resourceUrl = ENV.API_BASE_URL + 'api/servants-by-service-item/' + serviceid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var getAutoSelectServant = function (serviceid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/auto-select-servant?serviceId=' + serviceid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }
        var createCopyOfServiceItemById = function (serviceItemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/create-copy-of-service-item-by-id?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getServiceItemsByServantId = function (servantId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-item-list-by-servant?servantId=' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var updateServiceItemFieldByAdmin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/update-service-item-field-by-admin';
            return $resource(resourceUrl, {}, {}
            );
        }

        var getServiceItemByCurrentCompanyAndServiceMode = function (serviceMode) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-item-list-by-service-mode?serviceMode=' + serviceMode;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceItemWithServantsByCurrentCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-service-item-list-with-servant';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            getServiceItemsByCurrentCompany: getServiceItemsByCurrentCompany,
            getActiveServiceItemsByCurrentCompany: getActiveServiceItemsByCurrentCompany,
            getActiveServiceItemsByCategory: getActiveServiceItemsByCategory,
            getServiceItemsWithOutSchedulingByCurrentCompany: getServiceItemsWithOutSchedulingByCurrentCompany,
            getAllAmenitiesType: getAllAmenitiesType,
            getServiceServants: getServiceServants,
            getAutoSelectServant: getAutoSelectServant,
            createCopyOfServiceItemById: createCopyOfServiceItemById,
            getServiceItemsByServantId: getServiceItemsByServantId,
            updateServiceItemFieldByAdmin: updateServiceItemFieldByAdmin,
            getServiceItemByCurrentCompanyAndServiceMode: getServiceItemByCurrentCompanyAndServiceMode,
            getServiceItemWithServantsByCurrentCompany: getServiceItemWithServantsByCurrentCompany

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemListController', ServiceItemListController);

    ServiceItemListController.$inject = ['$scope', '$state', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate'];

    function ServiceItemListController($scope, $state, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate) {
        var vm = this;
        //
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            vm.serviceItems = ServiceItemCustom.getServiceItemByCurrentCompanyAndServiceMode('RESERVE').query();
            //vm.page = page;
            //vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemDialogController', ServiceItemDialogController);

    ServiceItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceItemCustom'];

    function ServiceItemDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceItemCustom) {
        var vm = this;
        vm.serviceItem = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.serviceoptioninfos = ServiceOptionInfo.query();
        // vm.discountinfos = DiscountInfo.query();
        // vm.locationinfos = LocationInfo.query();
        // vm.albuminfos = AlbumInfo.query();
        // vm.servicecapacityinfos = ServiceCapacityInfo.query();
        // vm.servicecategories = ServiceCategory.query();
        // vm.priceinfos = PriceInfo.query();
        // vm.scheduleinfos = ScheduleInfo.query();
        // vm.servants = Servant.query();
        // vm.agreementinfos = AgreementInfo.query();
        // vm.metatags = MetaTag.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceItem.id !== null) {
                ServiceItemCustom.updateServiceItemFieldByAdmin().save(vm.serviceItem, onSaveSuccess, onSaveError);
            } else {
                // ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        $scope.$watch('vm.serviceItem.intakeFields', function (intake) {

            if (intake == "") {
                vm.serviceItem.intakeFields = null;
            }
        })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemDetailController', ServiceItemDetailController);

    ServiceItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag'];

    function ServiceItemDetailController($scope, $rootScope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag) {
        var vm = this;

        vm.serviceItem = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceItemUpdate', function (event, result) {
            vm.serviceItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemDeleteController', ServiceItemDeleteController);

    ServiceItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceItem'];

    function ServiceItemDeleteController($uibModalInstance, entity, ServiceItem) {
        var vm = this;

        vm.serviceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-item', {
                parent: 'entity',
                url: '/service-item?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceItem.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item/service-items.html',
                        controller: 'ServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-item-detail', {
                parent: 'entity',
                url: '/service-item/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item/service-item-detail.html',
                        controller: 'ServiceItemDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                        return ServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-item.new', {
                parent: 'service-item',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item/service-item-dialog.html',
                        controller: 'ServiceItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    itemTitle: null,
                                    description: null,
                                    minPreReserveTime: null,
                                    maxPreReserveTime: null,
                                    hasWaitingList: null,
                                    mustGetParticipantInfo: null,
                                    canBeCanceled: null,
                                    minPreCancelTime: null,
                                    paymentType: null,
                                    serviceType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-item', null, {reload: true});
                    }, function () {
                        $state.go('service-item');
                    });
                }]
            })
            .state('service-item.edit', {
                parent: 'service-item',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item/service-item-dialog.html',
                        controller: 'ServiceItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-item.delete', {
                parent: 'service-item',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item/service-item-delete-dialog.html',
                        controller: 'ServiceItemDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.deletePrice', {
                parent: 'supplierPanel',
                url: '/deletePrice/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info-dtail/price-info-dtail-delete-dialog.html',
                        controller: 'PriceInfoDtailDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PriceInfoDtail', function (PriceInfoDtail) {

                                return PriceInfoDtail.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

        ;
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceItem', ServiceItem);

    ServiceItem.$inject = ['$resource'];

    function ServiceItem($resource) {
        var resourceUrl = 'api/service-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceItemSearch', ServiceItemSearch);

    ServiceItemSearch.$inject = ['$resource'];

    function ServiceItemSearch($resource) {
        var resourceUrl = 'api/_search/service-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemController', ServiceItemController);

    ServiceItemController.$inject = ['$scope', '$state', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceItemController($scope, $state, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';


    angular
        .module('tikonApp')
        .controller('GeneralServiceItemController', GeneralServiceItemController);

    GeneralServiceItemController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceCategoryCustom', 'CompanyCustom', '$translate', '$translatePartialLoader', '$state'];

    function GeneralServiceItemController($timeout, $scope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceCategoryCustom, CompanyCustom, translate, translatePartialLoader, $state) {
        var vm = this;
        vm.scope = $scope;
        vm.scheduleFormState = 'list';
        vm.priceInfoFormState = "'list'";
        vm.serviceOptionInfoFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.serviceItem = entity;
        vm.oldItem = angular.copy(vm.serviceItem);
        vm.mainScheduleType = 'BASED_ON_COMPANY_SCHEDULE';
        vm.saveAndGotoScheduling = saveAndGotoScheduling;
        vm.weekDayExists = weekDayExists;
        vm.toggleWeekDay = toggleWeekDay;
        vm.weekDays = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];


        //vm.clear = clear;
        vm.save = save;
        vm.categoryName = categoryName;
        vm.showFullDescription = showFullDescription;
        vm.fullDescription = false;
        vm.showAdvancedSetting = showAdvancedSetting;
        vm.advancedSetting = false;
        //vm.serviceoptioninfos = ServiceOptionInfo.query();
        //vm.discountinfos = DiscountInfo.query();
        //vm.locationinfos = LocationInfo.query();
        //vm.albuminfos = AlbumInfo.query();
        //vm.servicecapacityinfos = ServiceCapacityInfo.query();
        //vm.servicecategories = ServiceCategory.query();
        //
        vm.showDuration = showDuration;
        vm.confirmationType_Change = confirmationType_Change;
        if (vm.serviceItem.multiReserveMode == undefined)
            vm.serviceItem.multiReserveMode = "DISABLE";

        initDefault();

        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {


            vm.servicecategories = result;

            if (vm.serviceItem.category == null || vm.serviceItem.category == undefined || vm.serviceItem.category.id == null || vm.serviceItem.category.id == undefined) {
                angular.forEach(result, function (category) {
                    if (category.categoryName == "DEFAULT_CATEGORY") {
                        vm.serviceItem.category = category;
                    }

                });
            }
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader = translate.refresh();

        });

        if (vm.serviceItem.maxPreReserveTime == null || vm.serviceItem.maxPreReserveTime == undefined)
            vm.serviceItem.maxPreReserveTime = 20;
        if (vm.serviceItem.minPreReserveTime == null || vm.serviceItem.minPreReserveTime == undefined)
            vm.serviceItem.minPreReserveTime = 0;


        //vm.priceinfos = PriceInfo.query();
        //vm.scheduleinfos = ScheduleInfo.query();
        //vm.servants = Servant.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.metatags = MetaTag.query();
        vm.paymentType_changed = paymentType_changed;
        vm.priceInfoFormReload = false;
        //   vm.currentScheduleInfo= vm.serviceItem.scheduleInfo;
        //   vm.backToList=backToList;
        //   vm.onSelectedScheduleChanged=onSelectedScheduleChanged;
        //   vm.onCreateNewSchedule=onCreateNewSchedule;
        findCurrentCompany();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        if (vm.serviceItem.amenities == null || vm.serviceItem.amenities == undefined) {
            vm.serviceItem.amenities = {};
            vm.serviceItem.amenities.amenitiesList = [];
        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
                if (vm.currentCompany.activityType == 'WORK_SPACE') {
                    vm.priceInfoType = "fixed";
                }
            });
        }


        //
        //function clear () {
        //    $uibModalInstance.dismiss('cancel');
        //}

        function save() {
            updateScheduleTypeFromMainType();
            checkIfScheduleRegenerationNeeded();
            vm.priceInfoFormReload = 'false';

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;

                if (vm.serviceItem.id !== null) {

                    ServiceItem.update(vm.serviceItem, onSaveSuccess, onSaveError);
                } else {
                    ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);

                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:serviceItemUpdate', result);

            vm.serviceItem = result;
            vm.oldItem = angular.copy(vm.serviceItem);
            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : result.scheduleInfo.id});
            //$uibModalInstance.close(result);

            vm.priceInfoFormReload = 'true';
            vm.priceInfoFormState = 'list';
            vm.serviceOptionInfoFormState = 'list';
            vm.isSaving = false;

            if (vm.nextGotoScheduling) {
                $state.go('supplierPanel.scheduling', {id: vm.serviceItem.id});
            }

        }

        function backToList() {

            vm.scheduleFormState = 'list';
            vm.selectedScheduleId = '';
        }

        function onSelectedScheduleChanged(data) {

            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : data.id});

        }

        function onCreateNewSchedule() {

            vm.serviceItem.scheduleInfo = {};

        }

        function onCreateNewPriceInfo() {
            //

            vm.serviceItem.priceInfo = {};

        }

        function onSelectedPriceInfoChanged(data) {
            //
            //vm.serviceItem.priceInfo= PriceInfo.get({id : data.id});

        }

        function onSaveError() {
            vm.isSaving = false;
            vm.nextGotoScheduling = false;
        }


        function paymentType_changed() {

            if (vm.serviceItem.paymentType == "PAYMENT_ALL") {
                vm.serviceItem.prePaymentAmount = 0;
            }
            if (vm.serviceItem.paymentType == "PRE_PAYMENT") {
                vm.serviceItem.inPlacePayment = false;
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function showFullDescription() {
            vm.fullDescription = !vm.fullDescription;
        }

        function showAdvancedSetting() {
            vm.advancedSetting = !vm.advancedSetting;
        }

        function initDefault() {
            if (vm.serviceItem.serviceStatus == null || vm.serviceItem.serviceStatus == undefined)
                vm.serviceItem.serviceStatus = 'PUBLISH';

            if (vm.serviceItem.paymentType == null || vm.serviceItem.paymentType == undefined)
                vm.serviceItem.paymentType = 'PAYMENT_ALL';

            if (vm.serviceItem.confirmationType == null || vm.serviceItem.confirmationType == undefined)
                vm.serviceItem.confirmationType = 'ONE_STEP';

            if (vm.serviceItem.capacityInfo == null || vm.serviceItem.capacityInfo == undefined || vm.serviceItem.capacityInfo.qty == null || vm.serviceItem.capacityInfo.qty == undefined) {
                vm.serviceItem.capacityInfo = {};
                vm.serviceItem.capacityInfo.qty = 1;
            }
            if (!vm.serviceItem.duration)
                vm.serviceItem.duration = 60;

            setMainScheduleType()
        }

        function setMainScheduleType() {
            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'BASED_ON_COMPANY_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    vm.mainScheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                    if (vm.serviceItem.consecutiveReserveMode != 'DISABLE')
                        vm.serviceItem.consecutiveReserveMode = 'ENABLE';
                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    vm.mainScheduleType = 'FIXED_TIME_SESSIONS';
                } else {
                    vm.mainScheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                }
            }
        }

        function updateScheduleTypeFromMainType() {

            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'BASED_ON_COMPANY_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
                        currentType = 'FIXED_TIME_SESSIONS'
                    }

                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    if (vm.mainScheduleType != 'FIXED_TIME_SESSIONS')
                        currentType = 'BASED_ON_COMPANY_SCHEDULE';
                } else {
                    currentType = 'BASED_ON_COMPANY_SCHEDULE';
                }
                vm.serviceItem.scheduleInfo.scheduleType = currentType;
            } else {
                var currentType = 'BASED_ON_COMPANY_SCHEDULE';
                if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
                    currentType = 'FIXED_TIME_SESSIONS'
                }
                if (!vm.serviceItem.scheduleInfo) vm.serviceItem.scheduleInfo = {};
                vm.serviceItem.scheduleInfo.scheduleType = currentType;
            }
        }

        function saveAndGotoScheduling() {
            vm.nextGotoScheduling = true;
            vm.save();
        }

        function checkIfScheduleRegenerationNeeded() {

            vm.scheduleGenerationNeeded = false;
            if (vm.oldItem && vm.oldItem.scheduleInfo && vm.serviceItem && vm.serviceItem.scheduleInfo && vm.oldItem.scheduleInfo.scheduleType != vm.serviceItem.scheduleInfo.scheduleType) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.duration != vm.serviceItem.duration ||
                (vm.oldItem.capacityInfo && vm.oldItem.capacityInfo.qty != vm.serviceItem.capacityInfo.qty) ||
                vm.oldItem.maxPreReserveTime != vm.serviceItem.maxPreReserveTime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else {
                //checking servants
                if (vm.oldItem.servants.length != vm.serviceItem.servants.length)
                    vm.serviceItem.scheduleGenerationNeeded = true;
                else {
                    if (vm.oldItem.servants.length > 0) {
                        angular.forEach(vm.oldItem.servants, function (os) {
                            var isInList = false;
                            angular.forEach(vm.serviceItem.servants, function (ns) {
                                if (ns.id == os.id)
                                    isInList = true;
                            });
                            if (!isInList)
                                vm.serviceItem.scheduleGenerationNeeded = true;
                        })
                    }
                }

            }
        }

        function showDuration() {

            if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS')
                return false;

            if (vm.serviceItem == null || vm.serviceItem.serviceTimes == null)
                return true;

            if (vm.serviceItem.serviceTimes != null && vm.serviceItem.serviceTimes != undefined
                && vm.serviceItem.serviceTimes.length == 1 && vm.serviceItem.serviceTimes[0].scheduleType == 'BASED_ON_COMPANY_SCHEDULE'
            ) {
                return true;
            }

        }

        function confirmationType_Change() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'TWO_STEP'

            ) {
                if (vm.serviceItem.customerConfirmationDeadline == null || vm.serviceItem.customerConfirmationDeadline == undefined || vm.serviceItem.customerConfirmationDeadline == 0) {
                    vm.serviceItem.customerConfirmationDeadline = 24;
                }
            }
        }

        function weekDayExists(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            var isExist = false;
            if (selectedWeekDay != undefined)
                angular.forEach(selectedWeekDay, function (item) {
                    if (item == weekDay)
                        isExist = true;
                });
            return isExist;

        }

        function toggleWeekDay(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            if (selectedWeekDay == undefined)
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays = [];

            if (vm.weekDayExists(weekDay, selectedWeekDay)) {
                var index = selectedWeekDay.indexOf(weekDay);
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.splice(index, 1);
            } else {
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.push(weekDay);
            }

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCategoryDialogController', ServiceCategoryDialogController);

    ServiceCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceCategory', 'SettingInfo', 'Company', 'Servant', 'AlbumInfo'];

    function ServiceCategoryDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceCategory, SettingInfo, Company, Servant, AlbumInfo) {
        var vm = this;

        vm.serviceCategory = entity;
        vm.clear = clear;
        vm.save = save;
        vm.settinginfos = SettingInfo.query();
        vm.companies = Company.query();
        vm.servicecategories = ServiceCategory.query();
        vm.servants = Servant.query();
        vm.albuminfos = AlbumInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceCategory.id !== null) {
                ServiceCategory.update(vm.serviceCategory, onSaveSuccess, onSaveError);
            } else {
                ServiceCategory.save(vm.serviceCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCategoryDetailController', ServiceCategoryDetailController);

    ServiceCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceCategory', 'SettingInfo', 'Company', 'Servant', 'AlbumInfo'];

    function ServiceCategoryDetailController($scope, $rootScope, $stateParams, entity, ServiceCategory, SettingInfo, Company, Servant, AlbumInfo) {
        var vm = this;

        vm.serviceCategory = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceCategoryUpdate', function (event, result) {
            vm.serviceCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCategoryDeleteController', ServiceCategoryDeleteController);

    ServiceCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceCategory'];

    function ServiceCategoryDeleteController($uibModalInstance, entity, ServiceCategory) {
        var vm = this;

        vm.serviceCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceCategoryCustom', ServiceCategoryCustom);

    ServiceCategoryCustom.$inject = ['$resource'];

    function ServiceCategoryCustom($resource) {


        var getServiceCategoriesByCurrentCompany = function () {
            //
            var resourceUrl = 'api/service-categories-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceCategoriesByCompanyId = function (companyId) {
            //
            var resourceUrl = 'api/get-categories-by-company-id?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getServiceCategoriesByCurrentCompany_get = function () {

            var resourceUrl = 'api/service-categories-by-current-company';
            return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        }


        var checkCategoriesAndServicesByCurrentCompany = function () {
            //
            var resourceUrl = 'api/check-categories-and-services-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            getServiceCategoriesByCurrentCompany: getServiceCategoriesByCurrentCompany,
            getServiceCategoriesByCompanyId: getServiceCategoriesByCompanyId,
            getServiceCategoriesByCurrentCompany_get: getServiceCategoriesByCurrentCompany_get,
            checkCategoriesAndServicesByCurrentCompany: checkCategoriesAndServicesByCurrentCompany
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-category', {
                parent: 'entity',
                url: '/service-category?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceCategory.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-category/service-categories.html',
                        controller: 'ServiceCategoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCategory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-category-detail', {
                parent: 'entity',
                url: '/service-category/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceCategory.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-category/service-category-detail.html',
                        controller: 'ServiceCategoryDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCategory');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceCategory', function ($stateParams, ServiceCategory) {
                        return ServiceCategory.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-category.new', {
                parent: 'service-category',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-dialog.html',
                        controller: 'ServiceCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    categoryName: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-category', null, {reload: true});
                    }, function () {
                        $state.go('service-category');
                    });
                }]
            })
            .state('service-category.edit', {
                parent: 'service-category',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-dialog.html',
                        controller: 'ServiceCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-category', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-category.delete', {
                parent: 'service-category',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-category', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceCategory', ServiceCategory);

    ServiceCategory.$inject = ['$resource'];

    function ServiceCategory($resource) {
        var resourceUrl = 'api/service-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceCategorySearch', ServiceCategorySearch);

    ServiceCategorySearch.$inject = ['$resource'];

    function ServiceCategorySearch($resource) {
        var resourceUrl = 'api/_search/service-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCategoryController', ServiceCategoryController);

    ServiceCategoryController.$inject = ['$scope', '$state', 'ServiceCategory', 'ServiceCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceCategoryCustom'];

    function ServiceCategoryController($scope, $state, ServiceCategory, ServiceCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceCategoryCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();
        loadPage();

        function loadAll() {
            //if (pagingParams.search) {
            //    ServiceCategorySearch.query({
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceCategory.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceCategories = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            //
            vm.serviceCategories = ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query();

            //vm.page = page;
            //vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryListV2Controller', CompanyServiceCategoryListV2Controller);

    CompanyServiceCategoryListV2Controller.$inject = ['entity', '$scope', '$state', 'ServiceCategory', 'ServiceCategorySearch', 'ParseLinks', 'CompanyInfoQuery', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceCategoryCustom', 'QueryParamsService'];

    function CompanyServiceCategoryListV2Controller(entity, $scope, $state, ServiceCategory, ServiceCategorySearch, ParseLinks, CompanyInfoQuery, AlertService, pagingParams, paginationConstants, ServiceCategoryCustom, QueryParamsService) {
        var vm = this;

        vm.isEventMode = false;
        if (entity && entity.mode && entity.mode == 'EVENT')
            vm.isEventMode = true;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;


        // vm.confirmDelete = confirmDelete;


        loadAll();
        loadPage();

        function loadAll() {
            //if (pagingParams.search) {
            //    ServiceCategorySearch.query({
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceCategory.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceCategories = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            loadCompanyInfo();
        }

        function loadCompanyInfo() {

        }

        function loadPage() {
            loadCategories();
            //vm.page = page;
            //vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        vm.editCategory = function (category) {
            $state.go('supplierPanel-v2.companyServiceCategoryList.edit', {id: category.id});
        }

        vm.newCategory = function () {
            $state.go('supplierPanel-v2.companyServiceCategoryList.new');
        }

        vm.searchKeyPress = function (keyEvent) {
            if (keyEvent.which === 13) {
                searchCategories();
            }
        }

        function loadCategories() {
            ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {
                vm.serviceCategories = result.filter(function (v) {
                        return (v.categoryName != "DEFAULT_CATEGORY")
                    }
                );
                var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        vm.searchCategories()
                }

            });
        }

        vm.searchCategories = function () {

            if (!vm.searchQuery) {
                QueryParamsService.removeFilter('searchText')
                loadCategories();
                return;
            }else QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.serviceCategories = vm.serviceCategories.filter(function (c) {
                if (c.categoryName.includes(vm.searchQuery))
                    return true;
            })
        }

        vm.clearSearch = function () {
            QueryParamsService.removeFilter('searchText')
            vm.searchQuery = null;
            vm.searchCategories();
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryDialogV2Controller', CompanyServiceCategoryDialogV2Controller);

    CompanyServiceCategoryDialogV2Controller.$inject = ['$rootScope', '$timeout', '$scope', '$stateParams', 'entity', 'ServiceCategory', 'SettingInfo', 'Company', 'Servant', 'AlbumInfo', 'ServiceCategoryCustom', '$state'];

    function CompanyServiceCategoryDialogV2Controller($rootScope, $timeout, $scope, $stateParams, entity, ServiceCategory, SettingInfo, Company, Servant, AlbumInfo, ServiceCategoryCustom, $state) {
        var vm = this;
        vm.scope = $scope;
        vm.serviceCategory = entity;
        vm.clear = clear;
        vm.save = save;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;


        $rootScope.$broadcast('hideNavBar');
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            if (vm.serviceCategory != null && vm.serviceCategory.id != null && result != null) {
                vm.servicecategories = result.filter(function (v) {

                        return (v.id != vm.serviceCategory.id && v.categoryName != "DEFAULT_CATEGORY")
                    }
                );
            } else {
                vm.servicecategories = result;
            }

        });


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
        }

        function save() {
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.serviceCategory.id !== null) {
                    ServiceCategory.update(vm.serviceCategory, onSaveSuccess, onSaveError);
                } else {
                    ServiceCategory.save(vm.serviceCategory, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceCategoryUpdate', result);
            // $uibModalInstance.close(result);
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.companyServiceCategoryList', {id: result.id});
            // vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.companyServiceCategoryList');

        }

        function getModalTitle() {
            if (!vm.serviceCategory.id)
                return 'tikonApp.serviceCategory.home.createLabel';
            else
                return 'tikonApp.serviceCategory.home.viewOrEditLabel';
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryDialogController', CompanyServiceCategoryDialogController);

    CompanyServiceCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceCategory', 'SettingInfo', 'Company', 'Servant', 'AlbumInfo', 'ServiceCategoryCustom'];

    function CompanyServiceCategoryDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceCategory, SettingInfo, Company, Servant, AlbumInfo, ServiceCategoryCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.serviceCategory = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.settinginfos = SettingInfo.query();
        //vm.companies = Company.query();
        //vm.servants = Servant.query();
        //vm.albuminfos = AlbumInfo.query();


        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            if (vm.serviceCategory != null && vm.serviceCategory.id != null && result != null) {
                vm.servicecategories = result.filter(function (v) {

                        return (v.id != vm.serviceCategory.id && v.categoryName != "DEFAULT_CATEGORY")
                    }
                );
            } else {
                vm.servicecategories = result;
            }

        });


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.serviceCategory.id !== null) {
                    ServiceCategory.update(vm.serviceCategory, onSaveSuccess, onSaveError);
                } else {
                    ServiceCategory.save(vm.serviceCategory, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryController', CompanyServiceCategoryController);

    CompanyServiceCategoryController.$inject = ['$scope', '$state', 'ServiceCategory', 'ServiceCategorySearch', 'ParseLinks', 'CompanyInfoQuery', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceCategoryCustom'];

    function CompanyServiceCategoryController($scope, $state, ServiceCategory, ServiceCategorySearch, ParseLinks, CompanyInfoQuery, AlertService, pagingParams, paginationConstants, ServiceCategoryCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // vm.confirmDelete = confirmDelete;


        loadAll();
        loadPage();

        function loadAll() {
            //if (pagingParams.search) {
            //    ServiceCategorySearch.query({
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceCategory.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceCategories = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            loadCompanyInfo();
        }

        function loadCompanyInfo() {

        }

        function loadPage() {
            ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

                vm.serviceCategories = result.filter(function (v) {
                        return (v.categoryName != "DEFAULT_CATEGORY")
                    }
                );

            });
            //vm.page = page;
            //vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


    }
})();
;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("ServiceCategoriesController", ServiceCategoriesController);

  ServiceCategoriesController.$inject = ["$timeout", "$state"];

  function ServiceCategoriesController($timeout, $state) {
      function loadServiceCategories() {
            var serviceCategories = document.getElementById('service-categories');
            serviceCategories.addEventListener('toServices', function(e){
               $state.go("supplierPanel-v2.reserveServices")
           })
            serviceCategories.addEventListener('backToPrevVersion', function(e){
                $state.go("supplierPanel-v2.companyServiceCategoryList", { type: "services" }) 
            })

        }
        $timeout(loadServiceCategories, 100)

  }
})();


;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCapacityInfoDialogController', ServiceCapacityInfoDialogController);

    ServiceCapacityInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceCapacityInfo'];

    function ServiceCapacityInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceCapacityInfo) {
        var vm = this;

        vm.serviceCapacityInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceCapacityInfo.id !== null) {
                ServiceCapacityInfo.update(vm.serviceCapacityInfo, onSaveSuccess, onSaveError);
            } else {
                ServiceCapacityInfo.save(vm.serviceCapacityInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceCapacityInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCapacityInfoDetailController', ServiceCapacityInfoDetailController);

    ServiceCapacityInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceCapacityInfo'];

    function ServiceCapacityInfoDetailController($scope, $rootScope, $stateParams, entity, ServiceCapacityInfo) {
        var vm = this;

        vm.serviceCapacityInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:serviceCapacityInfoUpdate', function (event, result) {
            vm.serviceCapacityInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCapacityInfoDeleteController', ServiceCapacityInfoDeleteController);

    ServiceCapacityInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceCapacityInfo'];

    function ServiceCapacityInfoDeleteController($uibModalInstance, entity, ServiceCapacityInfo) {
        var vm = this;

        vm.serviceCapacityInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceCapacityInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceCapacityInfoCustom', ServiceCapacityInfoCustom);

    ServiceCapacityInfoCustom.$inject = ['$resource'];

    function ServiceCapacityInfoCustom($resource) {


        var ServiceCapacityInfoByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/service-capacity-info-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            ServiceCapacityInfoByServiceItem: ServiceCapacityInfoByServiceItem
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-capacity-info', {
                parent: 'entity',
                url: '/service-capacity-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceCapacityInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-capacity-info/service-capacity-infos.html',
                        controller: 'ServiceCapacityInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-capacity-info-detail', {
                parent: 'entity',
                url: '/service-capacity-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceCapacityInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-capacity-info/service-capacity-info-detail.html',
                        controller: 'ServiceCapacityInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceCapacityInfo', function ($stateParams, ServiceCapacityInfo) {
                        return ServiceCapacityInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-capacity-info.new', {
                parent: 'service-capacity-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-capacity-info/service-capacity-info-dialog.html',
                        controller: 'ServiceCapacityInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    qty: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-capacity-info', null, {reload: true});
                    }, function () {
                        $state.go('service-capacity-info');
                    });
                }]
            })
            .state('service-capacity-info.edit', {
                parent: 'service-capacity-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-capacity-info/service-capacity-info-dialog.html',
                        controller: 'ServiceCapacityInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceCapacityInfo', function (ServiceCapacityInfo) {
                                return ServiceCapacityInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-capacity-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-capacity-info.delete', {
                parent: 'service-capacity-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-capacity-info/service-capacity-info-delete-dialog.html',
                        controller: 'ServiceCapacityInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCapacityInfo', function (ServiceCapacityInfo) {
                                return ServiceCapacityInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-capacity-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceCapacityInfo', ServiceCapacityInfo);

    ServiceCapacityInfo.$inject = ['$resource'];

    function ServiceCapacityInfo($resource) {
        var resourceUrl = 'api/service-capacity-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServiceCapacityInfoSearch', ServiceCapacityInfoSearch);

    ServiceCapacityInfoSearch.$inject = ['$resource'];

    function ServiceCapacityInfoSearch($resource) {
        var resourceUrl = 'api/_search/service-capacity-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceCapacityInfoController', ServiceCapacityInfoController);

    ServiceCapacityInfoController.$inject = ['$scope', '$state', 'ServiceCapacityInfo', 'ServiceCapacityInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceCapacityInfoController($scope, $state, ServiceCapacityInfo, ServiceCapacityInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServiceCapacityInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceCapacityInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceCapacityInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceAddOnListController', ServiceAddOnListController);

    ServiceAddOnListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'ServiceAddOn', 'ServiceAddOnCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function ServiceAddOnListController($scope, $state, ParseLinks, AlertService, ServiceAddOn, ServiceAddOnCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newServiceAddOnClick = newServiceAddOnClick;
        vm.searchKeyPress = searchKeyPress;


        vm.editServiceAddOn = editServiceAddOn;
        vm.deleteServiceAddOn = deleteServiceAddOn;
        vm.searchServiceAddOns = search;
        vm.searchKeyPress = searchKeyPress;
        vm.newServiceAddOn = newServiceAddOn;
        vm.clearSearch = clearSearch;


        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                ServiceAddOnCustom.getAllCompanyServiceAddOns().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ServiceAddOnCustom.getAllCompanyServiceAddOns().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceAddOns = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }

        function newServiceAddOnClick() {

            var result;

            // result = Principal.hasSpecialFeatureAccess("ServiceAddOnCode");
            // if (!result) {
            //     DialogService.showAlert("عدم دسترسی","برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
            //     return;
            // }

            $state.transitionTo('supplierPanel.newServiceAddOn');

        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editServiceAddOn(serviceAddOn) {
            $state.go('supplierPanel-v2.editServiceAddOn', {id: serviceAddOn.id});
        }

        function deleteServiceAddOn(serviceAddOn) {
            console.log(serviceAddOn)

            function onSuccess() {
                loadAll_paging()
            }
            function onError() {

            }

            ServiceAddOnCustom.deleteServiceAddOns(serviceAddOn.id).delete({}, onSuccess, onError);
        }

        function newServiceAddOn() {
            var result;

            // result = Principal.hasSpecialFeatureAccess("ServiceAddOnCode");
            // if (!result) {
            //     DialogService.showAlert("عدم دسترسی","برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
            //     return;
            // }
            $state.go('supplierPanel-v2.newServiceAddOn');
        }

        function clearSearch() {
            vm.searchQuery = null;
            search();
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceAddOnCustom', ServiceAddOnCustom);

    ServiceAddOnCustom.$inject = ['$resource'];

    function ServiceAddOnCustom($resource) {


        var getAllCompanyServiceAddOns = function () {

            var resourceUrl = 'api/get-all-company-service-add-ons';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getActiveServiceAddOns = function () {

            var resourceUrl = 'api/active-service-add-ons-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var deleteServiceAddOns = function (id) {

            var resourceUrl = 'api/service-add-ons/'+id;
            return $resource(resourceUrl, {}, {
                    'delete': {method: 'delete', isArray: true}
                }
            );
        };


        return {
            getAllCompanyServiceAddOns: getAllCompanyServiceAddOns,
            getActiveServiceAddOns: getActiveServiceAddOns,
            deleteServiceAddOns: deleteServiceAddOns
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceAddOn', ServiceAddOn);

    ServiceAddOn.$inject = ['$resource'];

    function ServiceAddOn($resource) {
        var resourceUrl = 'api/service-add-ons/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceAddOnController', ServiceAddOnController);

    ServiceAddOnController.$inject = ['$rootScope', '$scope', '$state', 'ServiceAddOn', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'ServiceAddOnCustom', '$mdDialog', '$translatePartialLoader'];

    function ServiceAddOnController($rootScope, $scope, $state, ServiceAddOn, PersonInfo, Customer, ParseLinks, AlertService, entity, ServiceAddOnCustom, $mdDialog, $translatePartialLoader) {

        var vm = this;
        vm.serviceAddOn = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        initDefault();
        loadAll();

        function initDefault() {

            $rootScope.$broadcast('hideNavBar');

            if (!vm.serviceAddOn.status)
                vm.serviceAddOn.status = 'ACTIVE';

        }

        function loadAll() {
            $translatePartialLoader.addPart('serviceAddOn');
        }

        function save() {
            vm.isSaving = true;

            if (vm.serviceAddOn.id !== null) {
                ServiceAddOn.update(vm.serviceAddOn, onSaveSuccess, onSaveError);
            } else {

                ServiceAddOn.save(vm.serviceAddOn, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:serviceAddOnUpdate', result);
                vm.isSaving = false;
                closeModal();

            }

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.serviceAddOnList');

        }

        function getModalTitle() {
            if (vm.serviceAddOn.id)
                return 'tikonApp.serviceAddOn.home.edit';
            else
                return 'tikonApp.serviceAddOn.home.new';
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantExceptionDurationController', ServantExceptionDurationController);

    ServantExceptionDurationController.$inject = ['$rootScope', '$scope', '$state', 'ParseLinks', 'entity', 'TimingInfo', 'translatePartialLoader', 'ServantCustom', '$timeout'];

    function ServantExceptionDurationController($rootScope, $scope, $state, ParseLinks, entity, TimingInfo, translatePartialLoader, ServantCustom, $timeout) {

        var vm = this;
        vm.isSaving = false;
        vm.defaultServantId = null;
        vm.availabilityMode = "CLOSE";
        vm.canSelectServant = false;

        vm.selectedServant = null;
        vm.exdurations = [];

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        vm.newDate = null;
        vm.addDuration = addDuration;
        vm.removeDuration = removeDuration;
        vm.startDate = new Date();
        vm.endDate = null;
        vm.startTime;
        vm.endTime;
        vm.servantList = [];
        vm.loadServants = loadServants;
        vm.errorMessage = null;
        vm.isDateEqual = isDateEqual;
        vm.showEndDate = false;
        vm.getDurationBlockClass = getDurationBlockClass;
        vm.isFullDay = isFullDay;
        vm.getTitleByAvailability = getTitleByAvailability;

        $rootScope.$broadcast('hideNavBar');

        loadAll();

        function loadAll() {

            if (entity) {
                if (entity.defaultServantId)
                    vm.defaultServantId = entity.defaultServantId;
                if (entity.availabilityMode)
                    vm.availabilityMode = entity.availabilityMode;
                if (entity.canSelectServant)
                    vm.canSelectServant = entity.canSelectServant;
            }

            loadServants();

        }

        function loadServants() {
            //if servant_login just current servant must selected
            ServantCustom.findServantsByCompany().query(function (result) {
                vm.servantList = result;
                setDefaultServant();

            });
        }


        function setDefaultServant() {
            if (vm.servantList) {
                if (vm.defaultServantId) {
                    angular.forEach(vm.servantList, function (srv) {
                        if (srv.id == vm.defaultServantId) {
                            vm.selectedServant = srv;
                            return;
                        }
                    });
                }
            }

        }


        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };

        function setOffDate() {
            //
            if (vm.selectedDatePeriod != undefined) {
                vm.selectedDatePeriod.offdays = [];
                angular.forEach(vm.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        vm.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {

            vm.errorMessage = null;
            if (!vm.exdurations)
                vm.exdurations = [];
            var dur = makeDurationObject();
            if (dur && vm.startDate != null && vm.endDate != null) {

                var persianDate = new JDate(vm.newDate);
                var hasAddedBefore = false;
                angular.forEach(vm.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == vm.startDate.toLocaleString() &&
                        ((!val.startTime && !vm.startTime) || (val.startTime && vm.startTime && val.startTime.toLocaleString() == vm.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == vm.endDate.toLocaleString() &&
                        ((!val.endTime && !vm.endTime) || (val.endTime && vm.endTime && val.endTime.toLocaleString() == vm.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    vm.exdurations.push(dur);
                    scrollToDurations();
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            vm.errorMessage = msg;
        }

        function makeDurationObject(ev) {
            if (!vm.showEndDate)
                vm.endDate = vm.startDate;

            if (vm.showEndDate && !vm.endDate) {
                alert('تاریخ پایان را وارد کنید');
                return null;
            }

            if (vm.showEndDate && vm.startDate > vm.endDate) {
                alert('تاریخ پایان باید بزرگتر از تاریخ شروع باشد');
                return null;
            }

            if (!vm.startTime || !vm.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availabilityMode: vm.availabilityMode,
                    startDate: vm.startDate,
                    endDate: vm.endDate,
                    startTime: vm.startTime,
                    endTime: vm.endTime
                };
            }

        }

        function removeDuration(date) {
            if (vm.exdurations != undefined)
                vm.exdurations = vm.exdurations.filter(function (item) {
                    return item != date;
                });
        }

        function isDateEqual(startDate, endDate) {


            var start = new Date(startDate).toLocalISOString();
            var end = new Date(endDate).toLocalISOString();

            if (start == end)
                return true;

            return false;


        }

        function getDurationBlockClass(dur) {
            if (dur && dur.availabilityMode) {
                if (dur.availabilityMode == 'CLOSE')
                    return 'CloseDurationBlock';
                else
                    return 'OpenDurationBlock';
            }
        }


        function isFullDay(item) {
            var date1 = new Date(item.startTime);
            var date2 = new Date(item.endTime);
            var diffTime = Math.abs(date2 - date1);

            if (diffTime / 1000 == 86340) {
                return true;
            }
            return false;
        }

        function okModal() {

            console.error("Is Saving Maj : " + vm.isSaving);

            if (vm.isSaving)
                return;


            vm.isSaving = true;

            if (!vm.exdurations || vm.exdurations.length == 0) {
                alert("هیچ زمانی انتخاب نشده است");
                vm.isSaving = false;

                return;
            }

            if (!vm.selectedServant) {
                alert("پرسنل انتخاب نشده است");
                vm.isSaving = false;
                return;
            }

            setServant();
            var exceptionHelper = {};
            exceptionHelper.servantExceptionDurations = vm.exdurations;


            TimingInfo.insertServantExceptionDuration().save(exceptionHelper, saveSuccess, saveError);

        }

        function setServant() {

            angular.forEach(vm.exdurations, function (dur) {
                dur.servantId = vm.selectedServant.id;
            })
        }

        function saveSuccess(result) {

            // if user click more than once it causes a problem
            $timeout(function () {
                vm.isSaving = false;
                $rootScope.$broadcast('showNavBar');
                $rootScope.$broadcast('reloadServantExceptionDurationListEvent');

                if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.companyServants.edit'
                    && $rootScope.fromStateParams
                ) {
                    $state.go('supplierPanel-v2.companyServants.edit', {id: $rootScope.fromStateParams.id});
                } else {
                    $state.go('supplierPanel-v2.calendar-v2');
                }


            }, 500);


            // $state.go('supplierPanel-v2.calendar');

        }

        function saveError() {
            vm.isSaving = false;
            closeModal();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.companyServants.edit'
                && $rootScope.fromStateParams
            ) {
                $state.go('supplierPanel-v2.companyServants.edit', {id: $rootScope.fromStateParams.id});
            } else {
                $state.go('supplierPanel-v2.calendar-v2');
            }
        }

        function alert(msg) {
            vm.errorMessage = msg;
        }

        function scrollToDurations() {
            $timeout(function () {
                var el = document.getElementById("exceptionDuration");
                el.scrollIntoView();
            }, 100);

        }

        function getTitleByAvailability() {
            if (vm.availabilityMode == 'CLOSE')
                return 'tikonApp.scheduleInfo.servantExceptionDuration.closeTitle';
            if (vm.availabilityMode == 'OPEN')
                return 'tikonApp.scheduleInfo.servantExceptionDuration.openTitle';
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantDialogController', ServantDialogController);

    ServantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo'];

    function ServantDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo) {
        var vm = this;

        vm.servant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.personinfos = PersonInfo.query();
        vm.servicecategories = ServiceCategory.query();
        vm.serviceitems = ServiceItem.query();
        vm.priceinfos = PriceInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.servant.id !== null) {
                Servant.update(vm.servant, onSaveSuccess, onSaveError);
            } else {
                Servant.save(vm.servant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:servantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantDetailController', ServantDetailController);

    ServantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo'];

    function ServantDetailController($scope, $rootScope, $stateParams, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo) {
        var vm = this;

        vm.servant = entity;

        var unsubscribe = $rootScope.$on('tikonApp:servantUpdate', function (event, result) {
            vm.servant = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantDeleteController', ServantDeleteController);

    ServantDeleteController.$inject = ['$uibModalInstance', 'entity', 'Servant'];

    function ServantDeleteController($uibModalInstance, entity, Servant) {
        var vm = this;

        vm.servant = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Servant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantByCompanyDialogController', ServantByCompanyDialogController);

    ServantByCompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo', 'ActivityTypeInfoCustom', 'CompanyCustom'];

    function ServantByCompanyDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo, ActivityTypeInfoCustom, CompanyCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.servant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isWorkSpace = false;

        loadData();

        function loadData() {
            CompanyCustom.getCurrentCompany().query(function (result) {
                ActivityTypeInfoCustom.getActivityTypeInfoByType(result.activityType).query(function (activity) {
                    vm.activityTypeInfo = activity;
                    if (activity && activity.servantType == "RESOURCE") {
                        vm.isWorkSpace = true;
                    }
                })
            });
        }


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            //
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.servant.id !== null) {
                    Servant.update(vm.servant, onSaveSuccess, onSaveError);
                } else {
                    Servant.save(vm.servant, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:servantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('supplierPanel.servantListByCompany', {
                parent: 'supplierPanel',
                url: '/servant-by-company-list',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/servant/servant-by-company.html',
                        controller: 'ServantByCompanyController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


            .state('supplierPanel.servantListByCompany.new', {
                parent: 'supplierPanel.servantListByCompany',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/servant/servant-by-company-dialog.html',
                        controller: 'ServantByCompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    level: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.servantListByCompany', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.servantListByCompany');
                    });
                }]
            })
            .state('supplierPanel.servantListByCompany.edit', {
                parent: 'supplierPanel.servantListByCompany',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/servant/servant-by-company-dialog.html',
                        controller: 'ServantByCompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.servantListByCompany', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.servantListByCompany.delete', {
                parent: 'supplierPanel.servantListByCompany',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/servant/servant-delete-dialog.html',
                        controller: 'ServantDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.servantListByCompany', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantByCompanyController', ServantByCompanyController);

    ServantByCompanyController.$inject = ['$scope', '$state', 'Servant', 'ServantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServantCustom'];

    function ServantByCompanyController($scope, $state, Servant, ServantSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServantCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();
        loadPage();

        function loadAll() {
            //if (pagingParams.search) {
            //    ServantSearch.query({
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    Servant.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}
            //function sort() {
            //    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            //    if (vm.predicate !== 'id') {
            //        result.push('id');
            //    }
            //    return result;
            //}
            function onSuccess(data, headers) {
                //vm.links = ParseLinks.parse(headers('link'));
                //vm.totalItems = headers('X-Total-Count');
                //vm.queryCount = vm.totalItems;
                vm.servants = data;
                //vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            //vm.page = page;
            //vm.transition();

            //if($ctrl.companyId==undefined || $ctrl.companyId==null)$ctrl.priceInfos=[];
            //else
            vm.servants = ServantCustom.findServantsByCompany().query();

            //
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServantCustom', ServantCustom);

    ServantCustom.$inject = ['$resource', 'ENV'];

    function ServantCustom($resource, ENV) {


        var findServantsByCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/servants-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var findServantsByServiceItem = function (serviceItemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/servants-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var serviceItemScheduleByServantId = function (servantId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/service-by-servant/' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var saveScheduleList = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/service-servant-schedule-list';
            return $resource(resourceUrl, {}, {
                    'update': {method: 'PUT', isArray: true}
                }
            );
        };

        var findServantByCurrentUser = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-servant-by-current-user';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var updateServantService = function (serviceid, servantid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/update-service-servant-priceinfo/' + serviceid + '/' + servantid;
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        }

        var getServantsHaveServicesByCurrentCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-servants-have-services-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            findServantsByCompany: findServantsByCompany,
            findServantsByServiceItem: findServantsByServiceItem,
            serviceItemScheduleByServantId: serviceItemScheduleByServantId,
            saveScheduleList: saveScheduleList,
            findServantByCurrentUser: findServantByCurrentUser,
            updateServantService: updateServantService,
            getServantsHaveServicesByCurrentCompany: getServantsHaveServicesByCurrentCompany

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('servant', {
                parent: 'entity',
                url: '/servant?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.servant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servant/servants.html',
                        controller: 'ServantController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('servant-detail', {
                parent: 'entity',
                url: '/servant/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.servant.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servant/servant-detail.html',
                        controller: 'ServantDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Servant', function ($stateParams, Servant) {
                        return Servant.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('servant.new', {
                parent: 'servant',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/servant/servant-dialog.html',
                        controller: 'ServantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    level: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('servant', null, {reload: true});
                    }, function () {
                        $state.go('servant');
                    });
                }]
            })
            .state('servant.edit', {
                parent: 'servant',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/servant/servant-dialog.html',
                        controller: 'ServantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('servant', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('servant.delete', {
                parent: 'servant',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/servant/servant-delete-dialog.html',
                        controller: 'ServantDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('servant', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Servant', Servant);

    Servant.$inject = ['$resource', 'ENV'];

    function Servant($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServantSearch', ServantSearch);

    ServantSearch.$inject = ['$resource', 'ENV'];

    function ServantSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantController', ServantController);

    ServantController.$inject = ['$scope', '$state', 'Servant', 'ServantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServantController($scope, $state, Servant, ServantSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ServantSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Servant.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.servants = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataTypeDialogController', SelectorDataTypeDialogController);

    SelectorDataTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SelectorDataType'];

    function SelectorDataTypeDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SelectorDataType) {
        var vm = this;

        vm.selectorDataType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.selectorDataType.id !== null) {
                SelectorDataType.update(vm.selectorDataType, onSaveSuccess, onSaveError);
            } else {
                SelectorDataType.save(vm.selectorDataType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:selectorDataTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataTypeDetailController', SelectorDataTypeDetailController);

    SelectorDataTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SelectorDataType'];

    function SelectorDataTypeDetailController($scope, $rootScope, $stateParams, entity, SelectorDataType) {
        var vm = this;

        vm.selectorDataType = entity;

        var unsubscribe = $rootScope.$on('tikonApp:selectorDataTypeUpdate', function (event, result) {
            vm.selectorDataType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataTypeDeleteController', SelectorDataTypeDeleteController);

    SelectorDataTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'SelectorDataType'];

    function SelectorDataTypeDeleteController($uibModalInstance, entity, SelectorDataType) {
        var vm = this;

        vm.selectorDataType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SelectorDataType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('selector-data-type', {
                parent: 'entity',
                url: '/selector-data-type?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.selectorDataType.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/selector-data-type/selector-data-types.html',
                        controller: 'SelectorDataTypeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('selectorDataType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('selector-data-type-detail', {
                parent: 'entity',
                url: '/selector-data-type/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.selectorDataType.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/selector-data-type/selector-data-type-detail.html',
                        controller: 'SelectorDataTypeDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('selectorDataType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SelectorDataType', function ($stateParams, SelectorDataType) {
                        return SelectorDataType.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('selector-data-type.new', {
                parent: 'selector-data-type',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/selector-data-type/selector-data-type-dialog.html',
                        controller: 'SelectorDataTypeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    key: null,
                                    typeName: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('selector-data-type', null, {reload: true});
                    }, function () {
                        $state.go('selector-data-type');
                    });
                }]
            })
            .state('selector-data-type.edit', {
                parent: 'selector-data-type',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/selector-data-type/selector-data-type-dialog.html',
                        controller: 'SelectorDataTypeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SelectorDataType', function (SelectorDataType) {
                                return SelectorDataType.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('selector-data-type', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('selector-data-type.delete', {
                parent: 'selector-data-type',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/selector-data-type/selector-data-type-delete-dialog.html',
                        controller: 'SelectorDataTypeDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SelectorDataType', function (SelectorDataType) {
                                return SelectorDataType.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('selector-data-type', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SelectorDataType', SelectorDataType);

    SelectorDataType.$inject = ['$resource'];

    function SelectorDataType($resource) {
        var resourceUrl = 'api/selector-data-types/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SelectorDataTypeSearch', SelectorDataTypeSearch);

    SelectorDataTypeSearch.$inject = ['$resource'];

    function SelectorDataTypeSearch($resource) {
        var resourceUrl = 'api/_search/selector-data-types/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataTypeController', SelectorDataTypeController);

    SelectorDataTypeController.$inject = ['$scope', '$state', 'SelectorDataType', 'SelectorDataTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SelectorDataTypeController($scope, $state, SelectorDataType, SelectorDataTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                SelectorDataTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SelectorDataType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.selectorDataTypes = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SelectorDataQuery', SelectorDataQuery);

    SelectorDataQuery.$inject = ['$resource', 'ENV'];

    function SelectorDataQuery($resource, ENV) {

        var findByType = function (type) {
            var resourceUrl = ENV.API_BASE_URL + 'api/selector-data-by-key/' + type;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        ///client/selector-data-by-typeid/{typeid}
        var findByTypeId = function (typeid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/selector-data-by-typeid/' + typeid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var findByTypeAndParent = function (type, parent) {
            if (parent == null) parent = 0;
            var resourceUrl = ENV.API_BASE_URL + 'api/selector-data-by-key/' + type + '/' + parent;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            findByType: findByType,
            findByTypeAndParent: findByTypeAndParent,
            findByTypeId: findByTypeId

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataDialogController', SelectorDataDialogController);

    SelectorDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SelectorData', 'SelectorDataType'];

    function SelectorDataDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SelectorData, SelectorDataType) {
        var vm = this;

        vm.selectorData = entity;
        vm.clear = clear;
        vm.save = save;
        vm.selectordatatypes = SelectorDataType.query();
        vm.selectordata = SelectorData.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.selectorData.id !== null) {
                SelectorData.update(vm.selectorData, onSaveSuccess, onSaveError);
            } else {
                SelectorData.save(vm.selectorData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:selectorDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataDetailController', SelectorDataDetailController);

    SelectorDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SelectorData', 'SelectorDataType'];

    function SelectorDataDetailController($scope, $rootScope, $stateParams, entity, SelectorData, SelectorDataType) {
        var vm = this;

        vm.selectorData = entity;

        var unsubscribe = $rootScope.$on('tikonApp:selectorDataUpdate', function (event, result) {
            vm.selectorData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataDeleteController', SelectorDataDeleteController);

    SelectorDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'SelectorData'];

    function SelectorDataDeleteController($uibModalInstance, entity, SelectorData) {
        var vm = this;

        vm.selectorData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SelectorData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('selector-data', {
                parent: 'entity',
                url: '/selector-data?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.selectorData.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/selector-data/selector-data.html',
                        controller: 'SelectorDataController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('selectorData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('selector-data-detail', {
                parent: 'entity',
                url: '/selector-data/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.selectorData.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/selector-data/selector-data-detail.html',
                        controller: 'SelectorDataDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('selectorData');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SelectorData', function ($stateParams, SelectorData) {
                        return SelectorData.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('selector-data.new', {
                parent: 'selector-data',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/selector-data/selector-data-dialog.html',
                        controller: 'SelectorDataDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    key: null,
                                    text: null,
                                    orderNo: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('selector-data', null, {reload: true});
                    }, function () {
                        $state.go('selector-data');
                    });
                }]
            })
            .state('selector-data.edit', {
                parent: 'selector-data',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/selector-data/selector-data-dialog.html',
                        controller: 'SelectorDataDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SelectorData', function (SelectorData) {
                                return SelectorData.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('selector-data', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('selector-data.delete', {
                parent: 'selector-data',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/selector-data/selector-data-delete-dialog.html',
                        controller: 'SelectorDataDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SelectorData', function (SelectorData) {
                                return SelectorData.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('selector-data', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SelectorData', SelectorData);

    SelectorData.$inject = ['$resource'];

    function SelectorData($resource) {
        var resourceUrl = 'api/selector-data/:id';

        return $resource(resourceUrl, {}, {
                'query': {method: 'GET', isArray: true},

                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            }
        );
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SelectorDataSearch', SelectorDataSearch);

    SelectorDataSearch.$inject = ['$resource'];

    function SelectorDataSearch($resource) {
        var resourceUrl = 'api/_search/selector-data/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectorDataController', SelectorDataController);

    SelectorDataController.$inject = ['$scope', '$state', 'SelectorData', 'SelectorDataSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SelectorDataController($scope, $state, SelectorData, SelectorDataSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                SelectorDataSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SelectorData.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.selectorData = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('TimingInfo', TimingInfo);

    TimingInfo.$inject = ['$resource', 'DateUtils', 'ENV'];

    function TimingInfo($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/generateTimingInfo';
        var resourceUrl2 = ENV.API_BASE_URL + 'api/getTimingInfoByServiceItems';

        function getTimeSessionDtailByTimeSessionId(timesessionId) {
            var url = ENV.API_BASE_URL + 'api/getTimeSessionDtailByTimeSessionId/' + timesessionId;
            return $resource(url, {}, {});
        }

        function generateTimeSessionsForScheduleUntilDate(scheduleInfoId, untildate) {

            var url = ENV.API_BASE_URL + 'api/generateTimeSessionsForScheduleUntilDate/' + scheduleInfoId + '/' + DateUtils.convertToISOString(untildate);
            return $resource(url, {}, {});
        }

        var generateTimingInfo = $resource(resourceUrl, {}, {});
        var saveScheduleInfo = function () {
            var url = ENV.API_BASE_URL + 'api/schedule-infos';
            return $resource(url, {});
        }
        var addNewTimeSession = function () {
            var url = ENV.API_BASE_URL + 'api/add-new-time-session';
            return $resource(url, {});
        }

        var upsertFloatTimeSession = function () {
            var url = ENV.API_BASE_URL + 'api/upsert-float-time-session';
            return $resource(url, {});

        }
        var computeTimeUnitQty = function () {
            var url = ENV.API_BASE_URL + 'api/client/compute-time-unit-qty-for-timespan';
            return $resource(url, {});
        }
        var saveScheduleInfoForCompany = function () {
            var url = ENV.API_BASE_URL + 'api/company-schedule-infos';
            return $resource(url, {});
        }
        var changeTimeSessionEnable = function (id) {
            var url = ENV.API_BASE_URL + 'api/changeTimeSessionEnableFlag/' + id;
            return $resource(url, {});
        }
        var updateToSimilarTimeSessions = function (id) {
            var url = ENV.API_BASE_URL + 'api/copy_timesession_to_other_similar_days/' + id;
            return $resource(url, {});
        }
        var changeTimeSessionCapacity = function (sessionid, capacity) {
            var url = ENV.API_BASE_URL + 'api/changeTimeSessionCapacity/' + sessionid + '/' + capacity;
            return $resource(url, {});
        }
        var changeTimeSessionDiscount = function (sessionid, discount) {
            var url = ENV.API_BASE_URL + 'api/changeTimeSessionDiscount/' + sessionid + '/' + discount;
            return $resource(url, {});
        }
        var getTimingInfoByServiceItems = $resource(resourceUrl2, {}, {});


        var insertServantExceptionDuration = function () {
            var url = ENV.API_BASE_URL + 'api/insert-servant-exception-duration';
            return $resource(url, {});
        }

        var deleteServantExceptionDuration = function () {
            var url = ENV.API_BASE_URL + 'api/delete-servant-exception-duration';
            return $resource(url, {});
        }

        return {
            generateTimingInfo: generateTimingInfo,
            saveScheduleInfo: saveScheduleInfo,
            getTimingInfoByServiceItems: getTimingInfoByServiceItems,
            getTimeSessionDtailByTimeSessionId: getTimeSessionDtailByTimeSessionId,
            generateTimeSessionsForScheduleUntilDate: generateTimeSessionsForScheduleUntilDate,
            changeTimeSessionEnable: changeTimeSessionEnable,
            saveScheduleInfoForCompany: saveScheduleInfoForCompany,
            changeTimeSessionCapacity: changeTimeSessionCapacity,
            changeTimeSessionDiscount: changeTimeSessionDiscount,
            updateToSimilarTimeSessions: updateToSimilarTimeSessions,
            addNewTimeSession: addNewTimeSession,
            computeTimeUnitQty: computeTimeUnitQty,
            upsertFloatTimeSession: upsertFloatTimeSession,
            insertServantExceptionDuration: insertServantExceptionDuration,
            deleteServantExceptionDuration: deleteServantExceptionDuration
        }
            ;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SchedulingV2Controller', SchedulingV2Controller);

    SchedulingV2Controller.$inject = ['$scope', '$state', '$stateParams', 'entity'];

    function SchedulingV2Controller($scope, $state, $stateParams, entity) {
        var vm = this;
        vm.serviceItemId = $stateParams.id;
        vm.serviceItem = entity;


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SchedulingController', SchedulingController);

    SchedulingController.$inject = ['$scope', '$state', '$stateParams', 'entity'];

    function SchedulingController($scope, $state, $stateParams, entity) {
        var vm = this;
        vm.serviceItemId = $stateParams.id;
        vm.serviceItem = entity;


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySchedulingV2Controller', CompanySchedulingV2Controller);

    CompanySchedulingV2Controller.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$timeout', 'DialogService', 'CompanyInfoQuery'];

    function CompanySchedulingV2Controller($rootScope, $scope, $state, $stateParams, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, $timeout, DialogService, CompanyInfoQuery) {
        var vm = this;
        $rootScope.$broadcast('hideNavBar');
        CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
            if (comp)
                vm.companyId = comp.id;
        })


        //vm.serviceItemId=$stateParams.id;
        //vm.serviceItem=entity;
        //company-servants

        vm.selectedScheduleInfo = 1;
        vm.loadPage = loadPage;
        vm.selectedId = '';
        vm.formState = 'list';
        vm.newItem = newItem;
        vm.editItem = editItem;
        vm.backToList = backToList;
        vm.generateTimeInfo = generateTimeInfo;
        vm.showTimingInfo = showTimingInfo;
        vm.backToScheduleInfo = backToScheduleInfo;
        vm.saveSchedule = saveSchedule;
        vm.save = save;
        vm.schSelected = false;
        vm.schSaved = false;
        vm.step = 0;
        vm.isSaving = false;
        vm.schedulerApi = {refresh: 'not set'};
        vm.hasBaseOffDaySchedule = false;
        vm.defaultBaseOffDayScheduleId = null;
        vm.baseOffDayScheduleSwitch_changed = baseOffDayScheduleSwitch_changed;
        vm.showLimitDates = false;
        vm.showLimitDateChange = showLimitDateChange;

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        vm.refreshList = function () {

            vm.scheduleInfos = [];

            CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
                if (comp) {
                    ScheduleInfoCustom.primaryScheduleInfosByCompany(comp.id).query(function (schedules) {
                        vm.scheduleInfos = schedules;
                        if (vm.scheduleInfos.length == 0)
                            vm.newItem();
                        else {
                            if (!vm.selectedId) {
                                // vm.editItem(vm.scheduleInfos[0]);
                                editItemV2(vm.scheduleInfos[0]);
                            }

                        }
                        // checkShowLimitDates();
                    });


                    ScheduleInfoCustom.getDefaultBaseOffDaySchedule().query().$promise.then(function (sch) {
                        if (sch && sch.id)
                            vm.defaultBaseOffDayScheduleId = sch.id;

                    });


                }
            })
        }

        //
        vm.generateTimesUntil = generateTimesUntil;
        $timeout(function () {
            loadAll();
            loadPage();

        });


        function showTimingInfo() {
            vm.timingInfo = vm.selectedScheduleInfo.timingInfo;
            vm.step = 1;
        }

        vm.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }


        function saveSchedule() {
            vm.selectedScheduleInfo.companyId = vm.companyId;
            vm.isSaving = true;

            if (vm.hasBaseOffDaySchedule && vm.defaultBaseOffDayScheduleId) {
                vm.selectedScheduleInfo.baseOffDayScheduleInfoId = vm.defaultBaseOffDayScheduleId;
            } else {
                vm.selectedScheduleInfo.baseOffDayScheduleInfoId = null;
            }

            TimingInfo.saveScheduleInfoForCompany().save(vm.selectedScheduleInfo, function (sch) {

                vm.selectedScheduleInfo = sch;
                vm.selectedId = sch.id;
                //  vm.timingInfo = sch.timingInfo;
                vm.step = 1;
                vm.schSelected = true;
                vm.schSaved = true;
                vm.isSaving = false;
                //vm.refreshList();
            });
        }

        function save() {
            saveSchedule();
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate(vm.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save(vm.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                vm.timingInfo = timingInfo;
                vm.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if (vm.schedulerApi.refreshScheduler)
                vm.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            vm.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {

            vm.scheduleInfos = [];
            vm.refreshList();
        }

        function newItem() {
            //
            vm.formState = 'BASIC_SCHEDULE_INFO';
            vm.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            vm.selectedScheduleInfo.companyId = vm.companyId;
            vm.schSelected = true;
            vm.schSaved = false;
            updateTabs();

        }

        function editItem(id) {

            vm.formState = 'BASIC_SCHEDULE_INFO';
            vm.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                vm.selectedScheduleInfo = sch;
                checkShowLimitDates();

                var now = new Date();
                now.setDate(now.getDate() - 1);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                var tempArr = [];
                angular.forEach(vm.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                    if (new Date(exDate.startDate) > now) {
                        tempArr.push(exDate);
                        // var index = vm.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                        //
                        // vm.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                    }
                })
                vm.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
                vm.schSelected = true;
                vm.schSaved = true;


                if (vm.selectedScheduleInfo && vm.selectedScheduleInfo.baseOffDayScheduleInfo) {
                    vm.hasBaseOffDaySchedule = true;
                }

                updateTabs();
            });

        }

        function editItemV2(sch) {

            vm.formState = 'BASIC_SCHEDULE_INFO';
            vm.selectedId = sch.id;

            vm.selectedScheduleInfo = sch;
            checkShowLimitDates();

            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            angular.forEach(vm.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                    // var index = vm.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                    //
                    // vm.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                }
            })
            vm.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
            vm.schSelected = true;
            vm.schSaved = true;


            if (vm.selectedScheduleInfo && vm.selectedScheduleInfo.baseOffDayScheduleInfo) {
                vm.hasBaseOffDaySchedule = true;
            }

            updateTabs();


        }

        function updateTabs() {
            if (vm.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            vm.formState = 'list';
            vm.selectedScheduleId = '';
            vm.refreshList();
        }

        function baseOffDayScheduleSwitch_changed() {


        }

        function showLimitDateChange() {
            if (!vm.showLimitDates) {
                vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate = null;
                vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {

            if (vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate) {
                vm.showLimitDates = true;
                return;
            }

            if (vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate) {

                var date = new Date();
                var fromDate = new Date(vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate);
                if (fromDate > date)
                    vm.showLimitDates = true;
            }

        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard')
                $state.go('supplierPanel-v2.dashboard');
            else
                $state.go('supplierPanel-v2.setting');
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySchedulingController', CompanySchedulingController);

    CompanySchedulingController.$inject = ['$scope', '$state', '$stateParams', 'CompanyInfoQuery'];

    function CompanySchedulingController($scope, $state, $stateParams, CompanyInfoQuery) {
        var vm = this;
        CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
            if (comp)
                vm.companyId = comp.id;
        })
        //vm.serviceItemId=$stateParams.id;
        //vm.serviceItem=entity;
        //company-servants

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleInfoDialogController', ScheduleInfoDialogController);

    ScheduleInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ScheduleInfo', 'WeeklyScheduleInfo', 'ServiceItem'];

    function ScheduleInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ScheduleInfo, WeeklyScheduleInfo, ServiceItem) {
        var vm = this;

        vm.scheduleInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.weeklyscheduleinfos = WeeklyScheduleInfo.query();
        vm.serviceitems = ServiceItem.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.scheduleInfo.id !== null) {
                ScheduleInfo.update(vm.scheduleInfo, onSaveSuccess, onSaveError);
            } else {
                ScheduleInfo.save(vm.scheduleInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:scheduleInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleInfoDetailController', ScheduleInfoDetailController);

    ScheduleInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ScheduleInfo', 'WeeklyScheduleInfo', 'ServiceItem'];

    function ScheduleInfoDetailController($scope, $rootScope, $stateParams, entity, ScheduleInfo, WeeklyScheduleInfo, ServiceItem) {
        var vm = this;

        vm.scheduleInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:scheduleInfoUpdate', function (event, result) {
            vm.scheduleInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleInfoDeleteController', ScheduleInfoDeleteController);

    ScheduleInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduleInfo'];

    function ScheduleInfoDeleteController($uibModalInstance, entity, ScheduleInfo) {
        var vm = this;

        vm.scheduleInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ScheduleInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ScheduleInfoCustom', ScheduleInfoCustom);

    ScheduleInfoCustom.$inject = ['$resource', 'DateUtils'];

    function ScheduleInfoCustom($resource, DateUtils) {


        var primaryScheduleInfosByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/primary-schedule-info-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var primaryScheduleInfosByCompany = function (companyId) {
            var resourceUrl = 'api/schedule-info-by-company/' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDynamicAvailableDatesByServiceId = function (serviceId) {
            var resourceUrl = 'api/get-dynamic-available-dates-by-service-id?serviceId=' + serviceId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDynamicAvailableTimesByServiceIdInOneDate = function (serviceId, date) {
            var resourceUrl = 'api/get-dynamic-available-times-by-service-id-in-one-date?serviceId=' + serviceId + '&dateTimeStr=' + date;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getDynamicAvailableDatesByServiceIdAndServantId = function (serviceId, servantId, fromDate, toDate) {
            var resourceUrl = 'api/get-available-dates-by-service-servant?';
            if (serviceId)
                resourceUrl += 'serviceId=' + serviceId;
            if (servantId && servantId != null)
                resourceUrl += '&servantid=' + servantId;
            if (fromDate)
                resourceUrl += '&fromDate=' + DateUtils.convertToISOString(fromDate);
            // else
            //     resourceUrl+= '&fromDateToLoad='+0;

            if (toDate)
                resourceUrl += '&toDate=' + DateUtils.convertToISOString(toDate);
            // else
            //     resourceUrl+= '&toDaysToLoad='+180;


            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDynamicAvailableTimesByServiceIdAndServantIdInOneDate = function (serviceId, servantId, date) {
            var resourceUrl = 'api/get-available-times-by-service-servant-in-one-date?serviceId=' + serviceId + '&dateTimeStr=' + date;
            if (servantId)
                resourceUrl += '&servantid=' + servantId;

            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getCurrentScheduleInfoByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/get-current-schedule-info-by-service-item-id?serviceId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getDynamicAvailableMonthlyDatesByServiceId = function (serviceId) {
            var resourceUrl = 'api/get-dynamic-available-monthly-dates-by-service-id?serviceId=' + serviceId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDefaultBaseOffDaySchedule = function () {
            var resourceUrl = 'api/get-default-base-off-day-schedule-id';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getAllDate = function (fromDate, toDate) {
            var resourceUrl = 'api/get-all-dates?';

            if (fromDate)
                resourceUrl += '&fromDate=' + DateUtils.convertToISOString(fromDate);

            if (toDate)
                resourceUrl += '&toDate=' + DateUtils.convertToISOString(toDate);

            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var getServantExceptionDurationsByServantId = function (servantId, availabilityMode) {
            var resourceUrl = 'api/get-servant-exception-durations-by-servant-id?servantId=' + servantId + '&availabilityMode=' + availabilityMode;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        return {
            primaryScheduleInfosByServiceItem: primaryScheduleInfosByServiceItem,
            primaryScheduleInfosByCompany: primaryScheduleInfosByCompany,
            getDynamicAvailableDatesByServiceId: getDynamicAvailableDatesByServiceId,
            getDynamicAvailableTimesByServiceIdInOneDate: getDynamicAvailableTimesByServiceIdInOneDate,
            getCurrentScheduleInfoByServiceItem: getCurrentScheduleInfoByServiceItem,
            getDynamicAvailableMonthlyDatesByServiceId: getDynamicAvailableMonthlyDatesByServiceId,
            getDynamicAvailableDatesByServiceIdAndServantId: getDynamicAvailableDatesByServiceIdAndServantId,
            getDynamicAvailableTimesByServiceIdAndServantIdInOneDate: getDynamicAvailableTimesByServiceIdAndServantIdInOneDate,
            getDefaultBaseOffDaySchedule: getDefaultBaseOffDaySchedule,
            getAllDate: getAllDate,
            getServantExceptionDurationsByServantId: getServantExceptionDurationsByServantId
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('schedule-info', {
                parent: 'entity',
                url: '/schedule-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.scheduleInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-info/schedule-infos.html',
                        controller: 'ScheduleInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduleInfo');
                        $translatePartialLoader.addPart('scheduleType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('schedule-info-detail', {
                parent: 'entity',
                url: '/schedule-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.scheduleInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-info/schedule-info-detail.html',
                        controller: 'ScheduleInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduleInfo');
                        $translatePartialLoader.addPart('scheduleType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScheduleInfo', function ($stateParams, ScheduleInfo) {
                        return ScheduleInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('schedule-info.new', {
                parent: 'schedule-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/schedule-info/schedule-info-dialog.html',
                        controller: 'ScheduleInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    scheduleType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('schedule-info', null, {reload: true});
                    }, function () {
                        $state.go('schedule-info');
                    });
                }]
            })
            .state('schedule-info.edit', {
                parent: 'schedule-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/schedule-info/schedule-info-dialog.html',
                        controller: 'ScheduleInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduleInfo', function (ScheduleInfo) {
                                return ScheduleInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('schedule-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('schedule-info.delete', {
                parent: 'schedule-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/schedule-info/schedule-info-delete-dialog.html',
                        controller: 'ScheduleInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScheduleInfo', function (ScheduleInfo) {
                                return ScheduleInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('schedule-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ScheduleInfo', ScheduleInfo);

    ScheduleInfo.$inject = ['$resource'];

    function ScheduleInfo($resource) {
        var resourceUrl = 'api/schedule-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ScheduleInfoSearch', ScheduleInfoSearch);

    ScheduleInfoSearch.$inject = ['$resource'];

    function ScheduleInfoSearch($resource) {
        var resourceUrl = 'api/_search/schedule-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleInfoController', ScheduleInfoController);

    ScheduleInfoController.$inject = ['$scope', '$state', 'ScheduleInfo', 'ScheduleInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ScheduleInfoController($scope, $state, ScheduleInfo, ScheduleInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ScheduleInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ScheduleInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.scheduleInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleBaseDiscountDialogController', ScheduleBaseDiscountDialogController);

    ScheduleBaseDiscountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ScheduleBaseDiscount', 'ScheduleInfo', 'DiscountInfo'];

    function ScheduleBaseDiscountDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ScheduleBaseDiscount, ScheduleInfo, DiscountInfo) {
        var vm = this;

        vm.scheduleBaseDiscount = entity;
        vm.clear = clear;
        vm.save = save;
        vm.scheduleinfos = ScheduleInfo.query();
        vm.discountinfos = DiscountInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.scheduleBaseDiscount.id !== null) {
                ScheduleBaseDiscount.update(vm.scheduleBaseDiscount, onSaveSuccess, onSaveError);
            } else {
                ScheduleBaseDiscount.save(vm.scheduleBaseDiscount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:scheduleBaseDiscountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleBaseDiscountDetailController', ScheduleBaseDiscountDetailController);

    ScheduleBaseDiscountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ScheduleBaseDiscount', 'ScheduleInfo', 'DiscountInfo'];

    function ScheduleBaseDiscountDetailController($scope, $rootScope, $stateParams, entity, ScheduleBaseDiscount, ScheduleInfo, DiscountInfo) {
        var vm = this;

        vm.scheduleBaseDiscount = entity;

        var unsubscribe = $rootScope.$on('tikonApp:scheduleBaseDiscountUpdate', function (event, result) {
            vm.scheduleBaseDiscount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleBaseDiscountDeleteController', ScheduleBaseDiscountDeleteController);

    ScheduleBaseDiscountDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduleBaseDiscount'];

    function ScheduleBaseDiscountDeleteController($uibModalInstance, entity, ScheduleBaseDiscount) {
        var vm = this;

        vm.scheduleBaseDiscount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ScheduleBaseDiscount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('schedule-base-discount', {
                parent: 'entity',
                url: '/schedule-base-discount?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.scheduleBaseDiscount.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-base-discount/schedule-base-discounts.html',
                        controller: 'ScheduleBaseDiscountController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduleBaseDiscount');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('schedule-base-discount-detail', {
                parent: 'entity',
                url: '/schedule-base-discount/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.scheduleBaseDiscount.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-base-discount/schedule-base-discount-detail.html',
                        controller: 'ScheduleBaseDiscountDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduleBaseDiscount');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScheduleBaseDiscount', function ($stateParams, ScheduleBaseDiscount) {
                        return ScheduleBaseDiscount.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('schedule-base-discount.new', {
                parent: 'schedule-base-discount',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/schedule-base-discount/schedule-base-discount-dialog.html',
                        controller: 'ScheduleBaseDiscountDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    amount: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('schedule-base-discount', null, {reload: true});
                    }, function () {
                        $state.go('schedule-base-discount');
                    });
                }]
            })
            .state('schedule-base-discount.edit', {
                parent: 'schedule-base-discount',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/schedule-base-discount/schedule-base-discount-dialog.html',
                        controller: 'ScheduleBaseDiscountDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduleBaseDiscount', function (ScheduleBaseDiscount) {
                                return ScheduleBaseDiscount.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('schedule-base-discount', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('schedule-base-discount.delete', {
                parent: 'schedule-base-discount',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/schedule-base-discount/schedule-base-discount-delete-dialog.html',
                        controller: 'ScheduleBaseDiscountDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScheduleBaseDiscount', function (ScheduleBaseDiscount) {
                                return ScheduleBaseDiscount.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('schedule-base-discount', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ScheduleBaseDiscount', ScheduleBaseDiscount);

    ScheduleBaseDiscount.$inject = ['$resource'];

    function ScheduleBaseDiscount($resource) {
        var resourceUrl = 'api/schedule-base-discounts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ScheduleBaseDiscountSearch', ScheduleBaseDiscountSearch);

    ScheduleBaseDiscountSearch.$inject = ['$resource'];

    function ScheduleBaseDiscountSearch($resource) {
        var resourceUrl = 'api/_search/schedule-base-discounts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ScheduleBaseDiscountController', ScheduleBaseDiscountController);

    ScheduleBaseDiscountController.$inject = ['$scope', '$state', 'ScheduleBaseDiscount', 'ScheduleBaseDiscountSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ScheduleBaseDiscountController($scope, $state, ScheduleBaseDiscount, ScheduleBaseDiscountSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ScheduleBaseDiscountSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ScheduleBaseDiscount.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.scheduleBaseDiscounts = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResourcesListFormController', ResourcesListFormController);

    ResourcesListFormController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader'];

    function ResourcesListFormController($scope, $state, translate, translatePartialLoader) {
        var vm = this;

    }
})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResourcesController', ResourcesController);

    ResourcesController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader'];

    function ResourcesController($scope, $state, translate, translatePartialLoader) {
        var vm = this;

    }
})();

;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("ReserveServicesController", ReserveServicesController);

  ReserveServicesController.$inject = ["$timeout", "$state"];

  function ReserveServicesController($timeout, $state) {
      function loadReserveServices() {
            var reserveServices = document.getElementById('reserve-services');
            reserveServices.addEventListener('backToPrevVersion', function(e){
                $state.go("supplierPanel-v2.serviceItemList", { type: "services" }) 
            })
             reserveServices.addEventListener('toServiceCategories', function(e){
                $state.go("supplierPanel-v2.serviceCategories")
            })

        }
        $timeout(loadReserveServices, 100)

  }
})();


;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitsListController', ReserveLimitsListController);

    ReserveLimitsListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'ReserveLimit', 'ReserveLimitCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function ReserveLimitsListController($scope, $state, ParseLinks, AlertService, ReserveLimit, ReserveLimitCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newReserveLimitClick = newReserveLimitClick;

        vm.editReserveLimit = editReserveLimit;
        vm.searchKeyPress = searchKeyPress;
        vm.newReserveLimit = newReserveLimit;
        vm.clearSearch = clearSearch;

        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                ReserveLimitCustom.getAllCompanyReserveLimits().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ReserveLimitCustom.getAllCompanyReserveLimits().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.reserveLimits = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }

        function newReserveLimitClick() {

            var result;

            result = Principal.hasSpecialFeatureAccess("reserveLimit");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newReserveLimit');

        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editReserveLimit(servant) {
            $state.go('supplierPanel-v2.editReserveLimit', {id: servant.id});
        }

        function newReserveLimit() {
            var result;

            result = Principal.hasSpecialFeatureAccess("reserveLimit");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }
            $state.go('supplierPanel-v2.newReserveLimit');
        }

        function clearSearch() {
            vm.searchQuery = null;
            search();
        }

    }
})();
;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller(
      "ReserveLimitsController",
      ReserveLimitsController
    );

  ReserveLimitsController.$inject = ["$timeout", "$state"];

  function ReserveLimitsController($timeout, $state) {
    function loadReserveLimits() {
      var reserveLimitsEl = document.getElementById("reserve-limits");
      reserveLimitsEl.addEventListener("prevPageBtn", function () {
        $state.go("supplierPanel-v2.setting");
      });
      reserveLimitsEl.addEventListener("backToPrevVersion", function () {
        $state.go("supplierPanel-v2.reserveLimitList");
      });
    }
    $timeout(loadReserveLimits, 100);
  }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitV2Controller', ReserveLimitV2Controller);

    ReserveLimitV2Controller.$inject = ['$rootScope', '$scope', '$state', 'ReserveLimit', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'ReserveLimitCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom'];

    function ReserveLimitV2Controller($rootScope, $scope, $state, ReserveLimit, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, ReserveLimitCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom) {

        var vm = this;
        vm.reserveLimit = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = true;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];
        vm.hasDayCount = false;
        vm.dayCount_switch_changed = dayCount_switch_changed;
        vm.basedOnNationalCodeSwitch = false;
        vm.basedOnNationalCode_changed = basedOnNationalCode_changed;
        vm.limitPeriod_changed = limitPeriod_changed;

        initDefault();
        loadAll();


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {
            if (!vm.reserveLimit.limitType)
                vm.reserveLimit.limitType = "RESERVE";

            if (!vm.reserveLimit.status)
                vm.reserveLimit.status = "ACTIVE";


            if (!vm.reserveLimit.limitPeriod) {
                if (!vm.reserveLimit.dayCount)
                    vm.reserveLimit.limitPeriod = "ALL_TIME";
                else
                    vm.reserveLimit.limitPeriod = "DAY_LATER";
            }

            if (vm.reserveLimit.limitPeriod == "DAY_LATER") {
                vm.hasDayCount = true;
            }

            $rootScope.$broadcast('hideNavBar');

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('reserveLimitTypes');
            $translatePartialLoader.addPart('reserveLimitPeriod');
            getAllServices();
            getAllCustomerGroups();
            setBasedOnTypeSwitch();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {
            vm.isSaving = true;
            addServiceItems();
            addCustomerGroups();

            if (vm.reserveLimit.id !== null) {
                ReserveLimit.update(vm.reserveLimit, onSaveSuccess, onSaveError);
            } else {

                ReserveLimit.save(vm.reserveLimit, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:reserveLimitUpdate', result);
                $state.go('supplierPanel-v2.editReserveLimit', {id: result.id});
                vm.isSaving = false;

                loadAll();

            }

        }

        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.reserveLimit.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.reserveLimit.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.reserveLimit.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.reserveLimit.customerGroups.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.reserveLimit.serviceItems && vm.reserveLimit.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.reserveLimit.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.reserveLimit.customerGroups && vm.reserveLimit.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.reserveLimit.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function dayCount_switch_changed() {
            if (!vm.hasDayCount) {
                vm.reserveLimit.dayCount = 0;
            } else {
                vm.reserveLimit.dayCount = 15;
            }
        }

        function basedOnNationalCode_changed() {
            if (vm.basedOnNationalCodeSwitch) {
                vm.reserveLimit.basedOnType = 'NATIONAL_CODE';
            } else {
                vm.reserveLimit.basedOnType = 'PHONE_NUMBER';
            }
        }

        function setBasedOnTypeSwitch() {
            if (vm.reserveLimit.basedOnType && vm.reserveLimit.basedOnType == 'NATIONAL_CODE')
                vm.basedOnNationalCodeSwitch = true;
            else
                vm.basedOnNationalCodeSwitch = false;
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.reserveLimitList');

        }

        function getModalTitle() {
            if (vm.reserveLimit.id)
                return 'tikonApp.reserveLimit.home.edit';
            else
                return 'tikonApp.reserveLimit.home.new';
        }

        function limitPeriod_changed() {

            if (vm.reserveLimit.limitPeriod != 'DAY_LATER') {
                vm.hasDayCount = false;
            } else
                vm.hasDayCount = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitDeleteV2Controller', ReserveLimitDeleteV2Controller);

    ReserveLimitDeleteV2Controller.$inject = ['$uibModalInstance', 'entity', 'ReserveLimit'];

    function ReserveLimitDeleteV2Controller($uibModalInstance, entity, ReserveLimit) {
        var vm = this;


        vm.reserveLimit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ReserveLimit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ReserveLimitCustom', ReserveLimitCustom);

    ReserveLimitCustom.$inject = ['$resource'];

    function ReserveLimitCustom($resource) {


        var getAllCompanyReserveLimits = function () {

            var resourceUrl = 'api/get-all-company-reserve-limits';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getAllCompanyReserveLimits: getAllCompanyReserveLimits,

        };
    }
})();
;
// (function() {
//     'use strict';
//
//     angular
//         .module('tikonApp')
//         .config(stateConfig);
//
//     stateConfig.$inject = ['$stateProvider'];
//
//     function stateConfig($stateProvider) {
//         $stateProvider
//         .state('reserveLimit', {
//             parent: 'entity',
//             url: '/reserveLimit?page&sort&search',
//             data: {
//                 authorities: ['ROLE_USER'],
//                 pageTitle: 'tikonApp.reserveLimit.home.title'
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/entities/reserveLimit/reserve-limits-list.html',
//                     controller: 'ReserveLimitListController',
//                     controllerAs: 'vm'
//                 }
//             },
//             params: {
//                 page: {
//                     value: '1',
//                     squash: true
//                 },
//                 sort: {
//                     value: 'id,asc',
//                     squash: true
//                 },
//                 search: null
//             },
//             resolve: {
//                 pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                     return {
//                         page: PaginationUtil.parsePage($stateParams.page),
//                         sort: $stateParams.sort,
//                         predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                         ascending: PaginationUtil.parseAscending($stateParams.sort),
//                         search: $stateParams.search
//                     };
//                 }],
//                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                     $translatePartialLoader.addPart('reserveLimit');
//                     $translatePartialLoader.addPart('reserveLimitStatusType');
//                     $translatePartialLoader.addPart('global');
//                     return $translate.refresh();
//                 }]
//             }
//         })
//     }
//
// })();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ReserveLimit', ReserveLimit);

    ReserveLimit.$inject = ['$resource', 'DateUtils'];

    function ReserveLimit($resource, DateUtils) {
        var resourceUrl = 'api/reserveLimit/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitController', ReserveLimitController);

    ReserveLimitController.$inject = ['$scope', '$state', 'ReserveLimit', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'ReserveLimitCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom'];

    function ReserveLimitController($scope, $state, ReserveLimit, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, ReserveLimitCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom) {

        var vm = this;
        vm.reserveLimit = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = true;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];
        vm.hasDayCount = false;
        vm.dayCount_switch_changed = dayCount_switch_changed;
        vm.basedOnNationalCodeSwitch = false;
        vm.basedOnNationalCode_changed = basedOnNationalCode_changed;
        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.reserveLimit.limitType)
                vm.reserveLimit.limitType = "RESERVE";

            if (!vm.reserveLimit.status)
                vm.reserveLimit.status = "ACTIVE";

            if (vm.reserveLimit.dayCount != null && vm.reserveLimit.dayCount > 0) {
                vm.hasDayCount = true;
            }

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('reserveLimitTypes');
            getAllServices();
            getAllCustomerGroups();
            setBasedOnTypeSwitch();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {
            vm.isSaving = true;
            addServiceItems();
            addCustomerGroups();

            if (vm.reserveLimit.id !== null) {
                ReserveLimit.update(vm.reserveLimit, onSaveSuccess, onSaveError);
            } else {

                ReserveLimit.save(vm.reserveLimit, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:reserveLimitUpdate', result);
                $state.go('supplierPanel.editReserveLimit', {id: result.id});

                loadAll();

            }

        }

        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.reserveLimit.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.reserveLimit.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.reserveLimit.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.reserveLimit.customerGroups.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.reserveLimit.serviceItems && vm.reserveLimit.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.reserveLimit.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.reserveLimit.customerGroups && vm.reserveLimit.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.reserveLimit.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function dayCount_switch_changed() {
            if (!vm.hasDayCount) {
                vm.reserveLimit.dayCount = 0;
            } else {
                vm.reserveLimit.dayCount = 15;
            }
        }

        function basedOnNationalCode_changed() {
            if (vm.basedOnNationalCodeSwitch) {
                vm.reserveLimit.basedOnType = 'NATIONAL_CODE';
            } else {
                vm.reserveLimit.basedOnType = 'PHONE_NUMBER';
            }
        }

        function setBasedOnTypeSwitch() {
            if (vm.reserveLimit.basedOnType && vm.reserveLimit.basedOnType == 'NATIONAL_CODE')
                vm.basedOnNationalCodeSwitch = true;
            else
                vm.basedOnNationalCodeSwitch = false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveV2Controller', ReserveV2Controller);

    ReserveV2Controller.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'CouponCustom', '$window'];

    function ReserveV2Controller($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, CouponCustom, $window) {

        var vm = this;

        
        vm.scope = $scope;
        vm.scope = $scope;
        vm.orderBag = entity;
        vm.clear = clear;
        //vm.datePickerOpenStatus = {};
        //vm.openCalendar = openCalendar;
        vm.save = save;
        vm.reservesNum = [0];
        vm.computedFinalPrice = {};
        vm.hasMultipleReserveTime = false;
        vm.addReserveRow = addReserveRow;
        vm.removeReserveRow = removeReserveRow;
        //vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        //vm.selectedServiceItem = null;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.findCustomer = findCustomer;
        // vm.getCompanyCustomersStatististics = getCompanyCustomersStatististics;
        vm.newCustomer = newCustomer;
        vm.newCustomerPopUp = newCustomerPopUp;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.onItemChanged = onItemChanged;
        vm.onServiceChanged = onServiceChanged;

        vm.states = $stateParams;
        vm.formMode = 'new';
        vm.addNewCustomer = addNewCustomer;
        vm.authorityRole = authorityRole;
        vm.hasCustomTime = false;
        vm.canSelectOtherServant = false;
        vm.mode = 'DEFAULT';
        vm.orderBag.checkCapacity = true;
        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.orderBag.computeFinalPrice = true;
        vm.checkCouponCode = checkCouponCode;
        vm.couponCodeInput = '';
        vm.showUnPlannedTime = false;
        vm.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;

        $rootScope.$broadcast('hideNavBar');

        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            vm.isCustomerManager = has;
        });


        vm.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {

                vm.selectedItem = selectedItem;
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    vm.orderBag.customer = c;
                    vm.existCustomerSearchResult = [];
                }
            }
        }
        vm.selectedCustomer = null;
        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        // function getCompanyCustomersStatististics(customer){
        //
        // }


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        load();

        function load() {
            vm.orderBag.orderBagServiceItems = [{}];
            if ($stateParams.serviceItemId != null && $stateParams.serviceItemId != undefined) {
                vm.formMode = 'fromURL'
            }
            if ($stateParams.customerId != null && $stateParams.customerId != undefined) {
                vm.formMode = 'fromURLCustomer'
                findCustomerById($stateParams.customerId).then(function (result) {

                    if (result != null) {
                        vm.orderBag.customer = result;
                    }
                });


            }

            if ($stateParams.hasCustomTime != null && $stateParams.hasCustomTime != undefined) {
                vm.hasCustomTime = $stateParams.hasCustomTime;
                vm.mode = 'CALENDAR_CUSTOM';
                if (vm.hasCustomTime == 'true')
                    vm.showUnPlannedTime = true;
            }

            if ($stateParams.canSelectOtherServant != null && $stateParams.canSelectOtherServant != undefined) {
                vm.canSelectOtherServant = $stateParams.canSelectOtherServant;
                vm.mode = 'CALENDAR_CUSTOM';
                if (vm.canSelectOtherServant == 'true')
                    vm.canSelectOtherServant = true;
                else
                    vm.canSelectOtherServant = false;
            }


        }


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function addReserveRow() {

            var index = vm.orderBag.orderBagServiceItems.length;
            vm.orderBag.orderBagServiceItems.push({index: index, serviceTimeSession: {}})

            vm.hasMultipleReserveTime = true;

            if (vm.hasCustomTime)
                setDefaultTimesToNewItem();

            computeTotalPrice();
        }

        function removeReserveRow() {

            vm.orderBag.orderBagServiceItems.pop();
            computeTotalPrice();
        }

        function setDefaultTimesToNewItem() {
            var len = vm.orderBag.orderBagServiceItems.length;
            if (len > 1) {
                var lastItem = vm.orderBag.orderBagServiceItems[len - 1];
                var refItem = vm.orderBag.orderBagServiceItems[len - 2];

                lastItem.defaultStartDate = refItem.serviceTimeSession.endTime;

            }
        }

        function save() {

            //if(vm.scope.editForm.$valid) {
            var index = 0;
            if (vm.orderBag.orderBagServiceItems)
                angular.forEach(vm.orderBag.orderBagServiceItems, function (item) {
                    index++;
                    item.index = index;
                    if (item.serviceItemId)
                        item.serviceItem = {id: item.serviceItemId}

                })

            vm.isSaving = true;
            //if (vm.orderBag.id !== null) {
            OrderBagCustom.saveReserve().save(vm.orderBag, onSaveSuccess, onSaveError);
            //} else {
            //    OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            //}
            //}
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
            if ($state.current.parent == 'supplierPanel-v2.dashboard')
                $state.go('supplierPanel-v2.dashboard');
            else if($rootScope.fromState.name === "supplierPanel-v2.calendar-v2") {
                    return $state.go("supplierPanel-v2.calendar-v2")
            }
            else if ($state.current.parent == 'supplierPanel-v2.calendar') {
                $state.go('supplierPanel-v2.calendar');
            } else
                $state.transitionTo('supplierPanel-v2.editOrderBag', {id: result.id});
        }

        function onItemChanged(newItem) {
            angular.forEach(vm.orderBag.orderBagServiceItems, function (item) {
                if (item.index == newItem.index)
                    item.serviceTimeSession = newItem.serviceTimeSession;
            })
            computeTotalPrice();
        }

        function onServiceChanged() {
            vm.orderBag.orderBagServiceItems.splice(1, vm.orderBag.orderBagServiceItems.length - 1);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findCustomer() {

            vm.customerMode = "find";
            vm.orderBag.customer = {};
            if (vm.phoneNumberToFind != null && vm.phoneNumberToFind != undefined) {
                var c = CustomerCustom.getCustomerByPhoneNumber(vm.phoneNumberToFind).query();
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }

        function newCustomer() {
            vm.phoneNumberToFind = "";
            vm.orderBag.customer = {};
            vm.customerMode = "new";
            vm.myRole = "ROLE_USER";
        }

        function newCustomerPopUp() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                controller: 'CompanyCustomerModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            });

            $rootScope.modalInstance.result.then(function (v) {

                vm.orderBag.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }

        function authorityRole() {
            if (vm.customerMode == 'new') {
                return "ROLE_USER";
            } else {
                return "ROLE_CUSTOMER_MANAGER";
            }
        }

        function computeTotalPrice() {

            if (vm.mode == 'CALENDAR_CUSTOM' && !vm.orderBag.couponToCheckValidity) {
                OrderBagCustom.computeFinalPriceFixed().save(vm.orderBag, function (result) {
                    vm.computedFinalPrice = result;
                    vm.orderBag.checkCapacity = false;
                    vm.orderBag.computeFinalPrice = false;
                })
                return;
            }


            OrderBagCustom.computeFinalPrice().save(vm.orderBag, function (result) {
                vm.computedFinalPrice = result;
                vm.orderBag.computeFinalPrice = true;
            })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');
                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name) {
                if ($rootScope.fromState.name == 'supplierPanel-v2.reserveList') {
                    $state.go('supplierPanel-v2.reserveList');
                    return;
                }

                if ($rootScope.fromState.name == 'supplierPanel-v2.editOrderBag') {
                    if ($rootScope.fromStateParams)
                        $state.go('supplierPanel-v2.editOrderBag', {id: $rootScope.fromStateParams.id});
                    else
                        $state.go('supplierPanel-v2.reserveList');

                    return;
                }

                if($rootScope.fromState.name === "supplierPanel-v2.calendar") {
                    return $state.go("supplierPanel-v2.calendar-v2")
                }
            }

            $state.go('supplierPanel-v2.calendar-v2');

        }

        function okModal() {
            save();

        }


        function addNewCustomer() {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customers.html',
                controller: 'CompanyCustomerController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            companyCustomer: null
                        };
                    }]
                }
            }).result.then(function (v) {
                vm.orderBag.customer = c;
            }, function () {
                //nothing
            });
        }

        function checkCouponCode() {

            if (vm.orderBag.couponToCheckValidity) {
                CouponCustom.evaluateCoupon().save(vm.orderBag, onCheckCouponSuccess, onCheckCouponError);

            }
        }

        function onCheckCouponSuccess(result) {


            if (result.resultStatus == 'DONE') {
                vm.couponResult = result;
                computeTotalPrice();
            }
        }

        function onCheckCouponError() {

            vm.couponResult = null;
            computeTotalPrice();
        }

        function searchCustomerByPhoneNumber() {

            if (!vm.orderBag.customer.personalInfo.phoneNumber || vm.orderBag.customer.personalInfo.phoneNumber.length < 6 || vm.orderBag.customer.personalInfo.phoneNumber.length == 11) {
                vm.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch(vm.orderBag.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                vm.existCustomerSearchResult = result;
            });

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveListController', ReserveListController);

    ReserveListController.$inject = ['__config', '$scope', '$state', 'OrderBagServiceItem', 'CompanyCustomer', 'CompanyCustomerCustom', 'OrderBagServiceItemSearch', 'ParseLinks', 'InvoiceInfoCustom', 'AlertService', 'pagingParams', 'paginationConstants', '$translate', 'OrderBagServiceItemCustom', 'formMode', 'ServiceItemCustom', '$mdDialog', 'DateUtils', 'ServantCustom', 'CompanySubscriptionStatusCustom', 'DEFAULT_VIDEO_CALL_URL', '$window', 'Principal', '$uibModal', 'ProgressBarService', 'QueryParamsService', '$mdMedia'];

    function ReserveListController(__config, $scope, $state, OrderBagServiceItem, CompanyCustomer, CompanyCustomerCustom, OrderBagServiceItemSearch, ParseLinks, InvoiceInfoCustom, AlertService, pagingParams, paginationConstants, $translate, OrderBagServiceItemCustom, formMode, ServiceItemCustom, $mdDialog, DateUtils, ServantCustom, CompanySubscriptionStatusCustom, DEFAULT_VIDEO_CALL_URL, $window, Principal, $uibModal, ProgressBarService, QueryParamsService, $mdMedia) {
        var vm = this;
        vm.__config = __config;
        vm.formMode = formMode.mode;
        // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.searchOrderBag = searchOrderBag;
        vm.refresh = refresh;
        vm.getMonthCount = getMonthCount;
        vm.showSearchBoxOnMobile = showSearchBoxOnMobile;
        vm.searchBoxOnMobile = false;
        vm.serviceItem_changed = serviceItem_changed;
        vm.serviceItemId = "";
        vm.paymentLogs = [];
        vm.orderBagStatusList = null;
        vm.status_changed = status_changed;
        vm.orderBagStatus = "";
        vm.showDateSearch = showDateSearch;
        vm.showSearchByDates = false;
        vm.showSearchTextBoxOnMobile = showSearchTextBoxOnMobile;
        vm.searchTextBoxOnMobile = false;
        vm.searchOrderBagByQuery = searchOrderBagByQuery;
        vm.showIntakeData = showIntakeData;
        vm.reserveGatewayToPersian = reserveGatewayToPersian;
        vm.filterQuery = {};
        vm.filterOrderBag = filterOrderBag;
        vm.getIntakeData = getIntakeData;
        vm.checkIfSubscriptionIsExpired = checkIfSubscriptionIsExpired;
        vm.hasSubscription = true;
        vm.servants = [];
        vm.goToVideoCall = goToVideoCall;
        vm.goToVideoCallEvent = goToVideoCallEvent;
        vm.filterOrderBag_Global = filterOrderBag_Global;
        vm.advancedSearch = advancedSearch;
        vm.searchKeyPress = searchKeyPress;
        vm.statusList = [1, 4, 5, 6];
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.pageSizeChanged = pageSizeChanged;
        vm.goToCustomerDetail = goToCustomerDetail;


        vm.isSearching = false;
        vm.editReserve = editReserve;
        vm.newReserve = newReserve;
        vm.clearSearch = clearSearch;
        vm.goToCustomerDetailV2 = goToCustomerDetailV2;
        vm.goToCustomerDetailV3 = goToCustomerDetailV3;
        vm.showFilterDialog = showFilterDialog;
        vm.filterCount = 0;
        vm.showEducation = showEducation;
        vm.serviceItems = null;
        vm.getQueryParams = getQueryParams;
        var initialPageLoaded = false;
        
        $scope.filters = QueryParamsService.getFilters();
        vm.page = parseInt(QueryParamsService.getFilters().page || 1);
        loaddata();


        var ShowIntakeDataDialogController = function ($scope, $mdDialog, dialogData) {
            var $ctrl = this;
            $ctrl.orderbag = dialogData;
        };
        ShowIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData'];

        function showIntakeData(orderbag) {
            $mdDialog.show({
                locals: {dialogData: orderbag},
                controller: ShowIntakeDataDialogController,
                templateUrl: 'app/entities/order-bag/intake-data-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: orderbag,
                clickOutsideToClose: true,
                fullscreen: false// Only for -

            })
                .then(function (answer) {

                }, function () {
                });
        }

        // function loadPage(page) {
        //     console.log('pageeeeeee', page)
        //     debugger
        //     vm.page = page;
        //     vm.transition();


        // }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getReservePagesByQuery(vm.filterQuery);
            else
                getReservePagesByQuery();

        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            if (vm.isSearching)
                return;
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }


        function loaddata() {
            // vm.checkIfSubscriptionIsExpired();
            vm.filterQuery.fromDate = new Date();

            vm.servants = ServantCustom.findServantsByCompany().query();
            getQueryParams();
            vm.filterOrderBag();
        }

        function loadAll() {
            vm.orderBagServiceItems = OrderBagServiceItemCustom.getAllOrderBagServiceItemByCurrentCompany().query();
        }

        function refresh() {
            vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromNow().query();
            filterItems();
        }

        function checkIfSubscriptionIsExpired() {
            CompanySubscriptionStatusCustom.canCurrentCompanyReserve(1821).query(function (res) {
                vm.hasSubscription = res;
                // let expireDate = new Date(res.expireDate);
                // let fifteenDaysLater = new Date();
                // fifteenDaysLater.setDate(fifteenDaysLater.getDate() + 15);
                // if (expireDate > fifteenDaysLater) {
                //     vm.hasSubscription = false;
                // } else {
                //     vm.hasSubscription = true;
                // }
            })
        }

        function searchOrderBag() {
            // var fromDateTime = null;
            // var toDateTime = null;
            //
            // if ((vm.fromDateFilter == null || vm.fromDateFilter == undefined)
            //     &&
            //     (vm.toDateFilter == null || vm.toDateFilter == undefined)
            // ) {
            //     loaddata();
            //     return;
            // }
            //
            //
            // if (vm.fromDateFilter == null || vm.fromDateFilter == undefined)
            //     fromDateTime = new Date(2000, 1, 1);
            // else
            //     fromDateTime = new Date(vm.fromDateFilter.toString());
            // if (vm.toDateFilter == null || vm.toDateFilter == undefined)
            //     toDateTime = new Date(3000, 1, 1);
            // else
            //     toDateTime = new Date(vm.toDateFilter.toString());
            //
            //
            // //fromDateTime.setUTCHours(0,0,0);
            // //toDateTime.setUTCHours(0,0,0);
            //
            // vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromDateToDate(DateUtils.convertToISOString(fromDateTime), DateUtils.convertToISOString(toDateTime)).query();
            // vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
            //
            // vm.searchBoxOnMobile = false;

        }

        function getIntakeData(customerId) {

            CompanyCustomerCustom.getCompanyCustomerByCustomerId(customerId).query().$promise.then(function (result) {
                CompanyCustomer.get({id: result[0].companyCustomerId}).$promise.then(function (CompanyCustomer) {
                    vm.companyCustomer = CompanyCustomer;
                    vm.companyCustomer.formsData = result;
                });
            });


        }

        function getQueryParams() {
            var newFilters = QueryParamsService.getFilters();
            // if(newFilters.page){
            //     vm.filterQuery.pageNumber = newFilters.page;
            //     vm.page = parseInt(newFilters.page);
            // }
            if (newFilters.page) {
                vm.filterQuery.pageNumber = parseInt(newFilters.page, 10) - 1;
                vm.page = parseInt(newFilters.page, 10);
                }
       
            if(newFilters.pageSize){
                vm.filterQuery.pageSize = newFilters.pageSize;
                vm.pageSize = newFilters.pageSize;
            }
            if(newFilters.searchText){
                vm.filterQuery.searchText = newFilters.searchText;
            }
            if(newFilters.fromDate){
                vm.filterQuery.fromDate = newFilters.fromDate;
            }
            if(newFilters.toDate){
                vm.filterQuery.toDate = newFilters.toDate;
            }
            if(newFilters.servantIds){
                vm.filterQuery.servantIds = newFilters.servantIds;
            }
            if(newFilters.serviceItemIds){
                vm.filterQuery.serviceItemIds = newFilters.serviceItemIds;
            }
            if(newFilters.status){
                vm.filterQuery.status = newFilters.status;
            }
            if(newFilters.filterQuery) {
                setFilterQuery(JSON.parse(decodeURIComponent(newFilters.filterQuery)))
            }
        }

        function filterOrderBag(customFilter) { 
            if (vm.isSearching)
                return;
            getReservePagesByQuery(customFilter);
        }

        function advancedSearch() {
            clear();
            vm.filterQuery.searchMode = true;
            vm.filterQuery.dontFilterFromDate = false;
            filterOrderBag();
        }


        function filterOrderBag_Global() {
            if (vm.filterQuery.searchText) {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = true;
                QueryParamsService.updateFilter('searchText', vm.filterQuery.searchText)
            } else {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = false;
                QueryParamsService.removeFilter('searchText')
            }
            filterOrderBag();
            clear();

        }

        function reserveGatewayToPersian(gate) {
            return gate;
        }

        function getMonthCount(orderBagServiceItem) {

            var count = 0;
            var fromDate = new Date(orderBagServiceItem.serviceTimeSession.startDate);
            var endDate = new Date(orderBagServiceItem.serviceTimeSession.endDate);
            while (fromDate < endDate) {
                count = count + 1;
                fromDate.setDate(fromDate.getDate() + (30));
            }

            return count;
        }

        function showSearchBoxOnMobile() {
            vm.searchBoxOnMobile = !vm.searchBoxOnMobile;
        }

        function serviceItem_changed() {

            filterItems();
        }

        function status_changed() {
            filterItems();
        }

        function filterItems() {

            vm.orderBagServiceItems = vm.orderBagServiceItemsQuery;
            if ((vm.serviceItemId == "" || vm.serviceItemId == undefined) && (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)) {
                return;
            }

            vm.orderBagServiceItems = vm.orderBagServiceItems.filter(function (item) {

                if (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)
                    return ((item.serviceItem.id == vm.serviceItemId));
                if (vm.serviceItemId == "" || vm.serviceItemId == undefined)
                    return ((item.orderBag.status == vm.orderBagStatus));

                return (item.orderBag.status == vm.orderBagStatus
                    &&
                    item.serviceItem.id == vm.serviceItemId
                );
            })
        }

        function showDateSearch() {
            vm.showSearchByDates = !vm.showSearchByDates;
        }

        function showSearchTextBoxOnMobile() {
            vm.searchTextBoxOnMobile = !vm.searchTextBoxOnMobile;
        }

        function searchOrderBagByQuery() {

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
            if (vm.searchQuery == null || vm.searchQuery == undefined || vm.searchQuery == "") {
                //vm.companyCustomerQueryList = vm.companyCustomers;
                return;
            }

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItemsQuery.filter(function (item) {

                return ((item.orderBag.customer.personalInfo.fisrtName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.lastName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.phoneNumber.includes(vm.searchQuery))
                    || (item.serviceItem.itemTitle.includes(vm.searchQuery))
                );
            })


        }

        function goToVideoCall(orderBagItem) {

            $mdDialog.show({
                controller: 'JoinVideoMeetingComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem
                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function onCreateMeetingSuccess(result) {

            if (result.joinMeetingURL) {
                $window.open(result.joinMeetingURL, "_blank");
            }

        }

        function onCreateMeetingFailed() {

        }

        function onJoinSuccess(result) {
            if (result.joinMeetingURL) {
                $window.open(result.joinMeetingURL, "_blank");
            }
        }

        function onJoinError() {

        }

        function findMeetingPassword(orderBagItem) {
            return orderBagItem.servant.id;
        }

        function goToVideoCallEvent(orderBagItem) {

            $mdDialog.show({
                controller: 'JoinVideoMeetingEventComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            serviceItem: orderBagItem.serviceItem,
                            servant: orderBagItem.servant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function getReservePagesByQuery(customFilter) {
            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;
            // if(isTransition)
            //     filterQuery.pageNumber = vm.page;

            //must set in cache
            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;
            searchOrderBagItemsByQueryPage(filterQuery)

         
        }
        function searchOrderBagItemsByQueryPage(filterQuery) {
            OrderBagServiceItemCustom.searchOrderBagItemsByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagServiceItems = data;
                vm.isSearching = false;

                gotToTop();
                // vm.page = vm.filterQuery.pageNumber+1;
                //test MAJID
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                filterOrderBag_Global();
            }
        }

        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function pageSizeChanged() {
            QueryParamsService.updateFilter('pageSize', vm.pageSize)
            clear();
            filterOrderBag();
        }

        function goToCustomerDetail(customerId) {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(customerId).query().$promise.then(onGetCustomerSuccess);
                    }
                });
        }
        function goToCustomerDetailV3(customerId){
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
            .then(function (result) {
                if (result) {
                    CompanyCustomerCustom.findCompanyCustomerByCustomerId(customerId).query().$promise.then(showCustomerModal);
                }
            });
        }

        function onGetCustomerSuccess(result) {

            var companyCustomer = result;
            showCustomerPopUp(companyCustomer.id);
            // $state.transitionTo('supplierPanel.companyCustomerPopUp', {id: });

        }
        function showCustomerModal(companyCustomerEntity) {
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');

            $mdDialog.show({
                templateUrl:
                    'app/entities/company-customer/company-customer-detailV2.html',
                controller: [
                    '$scope',
                    '$mdDialog',
                    'companyCustomerEntity',
                    function ($scope, $mdDialog, companyCustomerEntity) {
                        $scope.companyCustomerEntity = companyCustomerEntity;

                        $scope.close = function () {
                            $mdDialog.cancel();
                        };

                        $scope.viewDetails = function () {
                            $mdDialog.hide(companyCustomerEntity);
                        };
                    }
                ],
                locals: {
                    companyCustomerEntity: companyCustomerEntity
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(
                function (res) {
                    goToCustomerDetailV2(res.customer.id)
                },
                function () {
                }
            );
        }


        function showCustomerPopUp(companyCustomerId) {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                controller: 'CompanyCustomerPopUpController',
                controllerAs: 'vm',
                backdrop: 'true',
                size: 'lg',

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', function (CompanyCustomer) {
                        return CompanyCustomer.get({id: companyCustomerId}).$promise;
                    }],
                    formData: {
                        mode: 'EDIT',
                        isPopUp: true
                    }
                }
            }).result.then(function (v) {
                reload();
            }, function () {
                //nothing
            });
        }

        function editReserve(orderBagServiceItem) {
            $state.go('supplierPanel-v2.editOrderBag', {id: orderBagServiceItem.orderBag.id})
        }

        function newReserve() {
            $state.go('supplierPanel-v2.newReserve')
        }


        function clearSearch() {
            vm.filterQuery.searchText = null;
            filterOrderBag_Global();
             QueryParamsService.removeFilter('searchText')
        }

        function goToCustomerDetailV2(customerId) {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(customerId).query().$promise.then(onGetCustomerSuccessV2);
                    }
                });
        }

        function onGetCustomerSuccessV2(result) {
            var companyCustomer = result;
            $state.go('supplierPanel-v2.companyCustomer.edit', {id: companyCustomer.id});
        }


        var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;


            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
                $ctrl.data.filterQuery.fromDate = new Date();
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];

        function showFilterDialog() {
            if(!vm.serviceItems) {
                ProgressBarService.show();
                ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.serviceItems = result;
                    dialogData_.serviceItems = result;
                    ProgressBarService.hide();
                })
            }
            var dialogData_ = {};
            dialogData_.serviceItems = vm.serviceItems;
            dialogData_.statusList = vm.statusList;
            dialogData_.filterQuery = vm.filterQuery;
            dialogData_.servants = vm.servants;


            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/entities/reserve/filter-reserve-list-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                size: 'lg',
                fullscreen: false

            })
            .then(function (data) {
                setFilterQuery(data.filterQuery, true);
                QueryParamsService.updateFilter('filterQuery', encodeURIComponent(JSON.stringify(data.filterQuery)))
                vm.advancedSearch();
            }, function () {
            });
        }

        function setFilterQuery(filter, ignorSearchText) {
            var shallowFilter = filter
            if(ignorSearchText &&  shallowFilter.searchText) delete shallowFilter.searchText
            // vm.filterQuery = filter;
            angular.extend(vm.filterQuery, filter);
            countFilters();
        }

        function countFilters() {
            vm.filterCount = 0;
            var date = new Date();
            if (vm.filterQuery.fromDate && new Date(vm.filterQuery.fromDate).getDate() != date.getDate())
                vm.filterCount++;
            if (vm.filterQuery.toDate)
                vm.filterCount++;
            if (vm.filterQuery.status && vm.filterQuery.status.length > 0)
                vm.filterCount++;
            if (vm.filterQuery.serviceItemIds && vm.filterQuery.serviceItemIds.length > 0)
                vm.filterCount++;
            if (vm.filterQuery.servantIds && vm.filterQuery.servantIds.length > 0)
                vm.filterCount++;
            if (vm.filterQuery.orderBagId)
                vm.filterCount++;
            if(vm.filterCount < 1) 
                QueryParamsService.removeFilter('filterQuery')
        }
          function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                         return '<div id="38624689961"><script type="text/JavaScript" src="https://www.aparat.com/embed/cjzfc06?data[rnddiv]=38624689961&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider


            .state('supplierPanel.reserve.new', {
                parent: 'supplierPanel',
                url: '/reserve/new/{serviceItemId}/{start_date}/{end_date}/{servantId}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })

            .state('supplierPanel.new-reserve-modal', {
                parent: 'supplierPanel.calendar',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/reserve/new-reserve-modal-old.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('serviceItem');
                                $translatePartialLoader.addPart('orderBag');
                                $translatePartialLoader.addPart('orderBagServiceItem');
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('genderType');

                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    customer: null,
                                    createDate: null,
                                    status: 0,
                                    id: null,
                                    orderBagServiceItems: [{}]
                                };
                            }

                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        $state.go('supplierPanel.calendar', null, {reload: true});
                        $rootScope.modalInstance.dismiss('cancel');
                    }, function () {
                        $state.go('supplierPanel.calendar');
                    });
                }]

            });

    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveController', ReserveController);

    ReserveController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal','$uibModal','$rootScope','CouponCustom','$window'];

    function ReserveController($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal,$uibModal,$rootScope,CouponCustom,$window) {

        var vm = this;


        vm.scope = $scope;
        vm.orderBag = entity;
        vm.clear = clear;
        //vm.datePickerOpenStatus = {};
        //vm.openCalendar = openCalendar;
        vm.save = save;
        vm.reservesNum = [0];
        vm.computedFinalPrice = {};
        vm.hasMultipleReserveTime = false;
        vm.addReserveRow = addReserveRow;
        vm.removeReserveRow = removeReserveRow;
        //vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        //vm.selectedServiceItem = null;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.findCustomer = findCustomer;
        // vm.getCompanyCustomersStatististics = getCompanyCustomersStatististics;
        vm.newCustomer = newCustomer;
        vm.newCustomerPopUp = newCustomerPopUp;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.onItemChanged = onItemChanged;
        vm.onServiceChanged = onServiceChanged;

        vm.states = $stateParams;
        vm.formMode = 'new';
        vm.addNewCustomer = addNewCustomer ;
        vm.authorityRole = authorityRole;
        vm.hasCustomTime = false;
        vm.canSelectOtherServant = false;
        vm.mode = 'DEFAULT';
        vm.orderBag.checkCapacity = true;
        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.orderBag.computeFinalPrice = true;
        vm.checkCouponCode = checkCouponCode;
        vm.couponCodeInput = '';
        vm.showUnPlannedTime = false;
        vm.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;

        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            vm.isCustomerManager = has;
        });


        vm.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {

                vm.selectedItem = selectedItem;
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    vm.orderBag.customer = c;
                    vm.existCustomerSearchResult = [];
                }
            }
        }
        vm.selectedCustomer = null;
        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        // function getCompanyCustomersStatististics(customer){
        //
        // }


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        load();

        function load() {
            vm.orderBag.orderBagServiceItems = [{}];
            if ($stateParams.serviceItemId != null && $stateParams.serviceItemId != undefined) {
                vm.formMode = 'fromURL'
            }
            if ($stateParams.customerId != null && $stateParams.customerId != undefined) {
                vm.formMode = 'fromURLCustomer'
                findCustomerById($stateParams.customerId).then(function (result) {

                    if (result != null) {
                        vm.orderBag.customer = result;
                    }
                });


            }

            if ($stateParams.hasCustomTime != null && $stateParams.hasCustomTime != undefined) {
                vm.hasCustomTime = $stateParams.hasCustomTime;
                vm.mode = 'CALENDAR_CUSTOM';
                if (vm.hasCustomTime == 'true')
                    vm.showUnPlannedTime = true;
            }

            if ($stateParams.canSelectOtherServant != null && $stateParams.canSelectOtherServant != undefined) {
                vm.canSelectOtherServant = $stateParams.canSelectOtherServant;
                vm.mode = 'CALENDAR_CUSTOM';
                if (vm.canSelectOtherServant == 'true')
                    vm.canSelectOtherServant = true;
                else
                    vm.canSelectOtherServant = false;
            }


        }


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function addReserveRow() {

            var index = vm.orderBag.orderBagServiceItems.length;
            vm.orderBag.orderBagServiceItems.push({index: index, serviceTimeSession: {}})

            vm.hasMultipleReserveTime = true;

            if (vm.hasCustomTime)
                setDefaultTimesToNewItem();

            computeTotalPrice();
        }

        function removeReserveRow() {

            vm.orderBag.orderBagServiceItems.pop();
            computeTotalPrice();
        }

        function setDefaultTimesToNewItem() {
            var len = vm.orderBag.orderBagServiceItems.length;
            if (len > 1) {
                var lastItem = vm.orderBag.orderBagServiceItems[len - 1];
                var refItem = vm.orderBag.orderBagServiceItems[len - 2];

                lastItem.defaultStartDate = refItem.serviceTimeSession.endTime;

            }
        }

        function save() {

            //if(vm.scope.editForm.$valid) {
            var index = 0;
            if (vm.orderBag.orderBagServiceItems)
                angular.forEach(vm.orderBag.orderBagServiceItems, function (item) {
                    index++;
                    item.index = index;
                    if (item.serviceItemId)
                        item.serviceItem = {id: item.serviceItemId}

                })

            vm.isSaving = true;
            //if (vm.orderBag.id !== null) {
            OrderBagCustom.saveReserve().save(vm.orderBag, onSaveSuccess, onSaveError);
            //} else {
            //    OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            //}
            //}
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.close();
            }
            $state.transitionTo('supplierPanel.editOrderBag', {id: result.id});
        }

        function onItemChanged(newItem) {
                angular.forEach(vm.orderBag.orderBagServiceItems,function(item){
                    if(item.index==newItem.index)
                        item.serviceTimeSession=newItem.serviceTimeSession;
                })
            computeTotalPrice();
        }

        function onServiceChanged() {
            vm.orderBag.orderBagServiceItems.splice(1, vm.orderBag.orderBagServiceItems.length - 1);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findCustomer() {

            vm.customerMode = "find";
            vm.orderBag.customer = {};
            if (vm.phoneNumberToFind != null && vm.phoneNumberToFind != undefined) {
                var c = CustomerCustom.getCustomerByPhoneNumber(vm.phoneNumberToFind).query();
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }

        function newCustomer() {
            vm.phoneNumberToFind = "";
            vm.orderBag.customer = {};
            vm.customerMode = "new";
            vm.myRole = "ROLE_USER";
        }

        function newCustomerPopUp() {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                controller: 'CompanyCustomerPopUpController',
                controllerAs: 'vm',
                backdrop: 'true',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            }).result.then(function (v) {

                // var c = Customer.get({id: v.id});
                // if (c != null) {
                //     vm.orderBag.customer = c;
                // }
                vm.orderBag.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }

        function authorityRole() {
            if (vm.customerMode == 'new') {
                return "ROLE_USER";
            } else {
                return "ROLE_CUSTOMER_MANAGER";
            }
        }

        function computeTotalPrice() {

            if (vm.mode == 'CALENDAR_CUSTOM') {
                OrderBagCustom.computeFinalPriceFixed().save(vm.orderBag, function (result) {
                    vm.computedFinalPrice = result;
                    vm.orderBag.checkCapacity = false;
                    vm.orderBag.computeFinalPrice = false;
                })
                return;
            }


            OrderBagCustom.computeFinalPrice().save(vm.orderBag, function (result) {
                vm.computedFinalPrice = result;
            })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();

        }


        function addNewCustomer() {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customers.html',
                controller: 'CompanyCustomerController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            companyCustomer: null
                        };
                    }]
                }
            }).result.then(function (v) {
                vm.orderBag.customer = c;
            }, function () {
                //nothing
            });
        }

        function checkCouponCode() {

            if (vm.orderBag.couponToCheckValidity) {
                CouponCustom.evaluateCoupon().save(vm.orderBag, onCheckCouponSuccess, onCheckCouponError);

            }
        }

        function onCheckCouponSuccess(result) {


            if (result.resultStatus == 'DONE') {
                vm.couponResult = result;
                computeTotalPrice();
            }
        }

        function onCheckCouponError() {

            vm.couponResult = null;
            computeTotalPrice();
        }

        function searchCustomerByPhoneNumber() {

            if (!vm.orderBag.customer.personalInfo.phoneNumber || vm.orderBag.customer.personalInfo.phoneNumber.length < 6 || vm.orderBag.customer.personalInfo.phoneNumber.length == 11) {
                vm.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch(vm.orderBag.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                vm.existCustomerSearchResult = result;
            });

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('RelatedServiceItemDialogController', RelatedServiceItemDialogController);

    RelatedServiceItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RelatedServiceItem', 'ServiceItem'];

    function RelatedServiceItemDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, RelatedServiceItem, ServiceItem) {
        var vm = this;

        vm.relatedServiceItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.serviceitems = ServiceItem.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.relatedServiceItem.id !== null) {
                RelatedServiceItem.update(vm.relatedServiceItem, onSaveSuccess, onSaveError);
            } else {
                RelatedServiceItem.save(vm.relatedServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:relatedServiceItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('RelatedServiceItemDetailController', RelatedServiceItemDetailController);

    RelatedServiceItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RelatedServiceItem', 'ServiceItem'];

    function RelatedServiceItemDetailController($scope, $rootScope, $stateParams, entity, RelatedServiceItem, ServiceItem) {
        var vm = this;

        vm.relatedServiceItem = entity;

        var unsubscribe = $rootScope.$on('tikonApp:relatedServiceItemUpdate', function (event, result) {
            vm.relatedServiceItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('RelatedServiceItemDeleteController', RelatedServiceItemDeleteController);

    RelatedServiceItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'RelatedServiceItem'];

    function RelatedServiceItemDeleteController($uibModalInstance, entity, RelatedServiceItem) {
        var vm = this;

        vm.relatedServiceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            RelatedServiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('related-service-item', {
                parent: 'entity',
                url: '/related-service-item?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.relatedServiceItem.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/related-service-item/related-service-items.html',
                        controller: 'RelatedServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('relatedServiceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('related-service-item-detail', {
                parent: 'entity',
                url: '/related-service-item/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.relatedServiceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/related-service-item/related-service-item-detail.html',
                        controller: 'RelatedServiceItemDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('relatedServiceItem');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RelatedServiceItem', function ($stateParams, RelatedServiceItem) {
                        return RelatedServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('related-service-item.new', {
                parent: 'related-service-item',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/related-service-item/related-service-item-dialog.html',
                        controller: 'RelatedServiceItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    type: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('related-service-item', null, {reload: true});
                    }, function () {
                        $state.go('related-service-item');
                    });
                }]
            })
            .state('related-service-item.edit', {
                parent: 'related-service-item',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/related-service-item/related-service-item-dialog.html',
                        controller: 'RelatedServiceItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['RelatedServiceItem', function (RelatedServiceItem) {
                                return RelatedServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('related-service-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('related-service-item.delete', {
                parent: 'related-service-item',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/related-service-item/related-service-item-delete-dialog.html',
                        controller: 'RelatedServiceItemDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['RelatedServiceItem', function (RelatedServiceItem) {
                                return RelatedServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('related-service-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('RelatedServiceItem', RelatedServiceItem);

    RelatedServiceItem.$inject = ['$resource'];

    function RelatedServiceItem($resource) {
        var resourceUrl = 'api/related-service-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('RelatedServiceItemSearch', RelatedServiceItemSearch);

    RelatedServiceItemSearch.$inject = ['$resource'];

    function RelatedServiceItemSearch($resource) {
        var resourceUrl = 'api/_search/related-service-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('RelatedServiceItemController', RelatedServiceItemController);

    RelatedServiceItemController.$inject = ['$scope', '$state', 'RelatedServiceItem', 'RelatedServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RelatedServiceItemController($scope, $state, RelatedServiceItem, RelatedServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                RelatedServiceItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RelatedServiceItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.relatedServiceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDtailDialogController', PriceInfoDtailDialogController);

    PriceInfoDtailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PriceInfoDtail'];

    function PriceInfoDtailDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PriceInfoDtail) {
        var vm = this;

        vm.priceInfoDtail = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.priceInfoDtail.id !== null) {
                PriceInfoDtail.update(vm.priceInfoDtail, onSaveSuccess, onSaveError);
            } else {
                PriceInfoDtail.save(vm.priceInfoDtail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:priceInfoDtailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDtailDetailController', PriceInfoDtailDetailController);

    PriceInfoDtailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PriceInfoDtail'];

    function PriceInfoDtailDetailController($scope, $rootScope, $stateParams, entity, PriceInfoDtail) {
        var vm = this;

        vm.priceInfoDtail = entity;

        var unsubscribe = $rootScope.$on('tikonApp:priceInfoDtailUpdate', function (event, result) {
            vm.priceInfoDtail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDtailDeleteController', PriceInfoDtailDeleteController);

    PriceInfoDtailDeleteController.$inject = ['$uibModalInstance', 'entity', 'PriceInfoDtail'];

    function PriceInfoDtailDeleteController($uibModalInstance, entity, PriceInfoDtail) {
        var vm = this;

        vm.priceInfoDtail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PriceInfoDtail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PriceInfoDtailCustom', PriceInfoDtailCustom);

    PriceInfoDtailCustom.$inject = ['$resource'];

    function PriceInfoDtailCustom($resource) {


        var PriceInfoDtailsByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/price-info-dtails-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var PriceInfoDtailByServiceTimeSession = function (serviceItemId, serviceTimeSessionId) {
            var resourceUrl = 'api/price-info-dtails-by-service-time-session/' + serviceItemId + '/' + serviceTimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var deletePriceInfoDtailById = function () {

            var resourceUrl = 'api/delete-price-info-dtail-by-id';
            return $resource(resourceUrl, {}, {}
            );
        };


        var getPriceInfoDtailByServiceItemFromDate = function (serviceId, servantId, fromDate) {
            var resourceUrl = 'api/price-info-dtails-by-service-item-from-date?serviceItemId=' + serviceId + '&fromDate=' + fromDate;
            if (servantId)
                resourceUrl += "&servantId=" + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            PriceInfoDtailsByServiceItem: PriceInfoDtailsByServiceItem,
            PriceInfoDtailByServiceTimeSession: PriceInfoDtailByServiceTimeSession,
            deletePriceInfoDtailById: deletePriceInfoDtailById,
            getPriceInfoDtailByServiceItemFromDate: getPriceInfoDtailByServiceItemFromDate
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('price-info-dtail', {
                parent: 'entity',
                url: '/price-info-dtail?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.priceInfoDtail.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/price-info-dtail/price-info-dtails.html',
                        controller: 'PriceInfoDtailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('priceInfoDtail');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('price-info-dtail-detail', {
                parent: 'entity',
                url: '/price-info-dtail/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.priceInfoDtail.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/price-info-dtail/price-info-dtail-detail.html',
                        controller: 'PriceInfoDtailDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('priceInfoDtail');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PriceInfoDtail', function ($stateParams, PriceInfoDtail) {
                        return PriceInfoDtail.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('price-info-dtail.new', {
                parent: 'price-info-dtail',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info-dtail/price-info-dtail-dialog.html',
                        controller: 'PriceInfoDtailDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    capacityRatio: null,
                                    price: null,
                                    coworkerPrice: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('price-info-dtail', null, {reload: true});
                    }, function () {
                        $state.go('price-info-dtail');
                    });
                }]
            })
            .state('price-info-dtail.edit', {
                parent: 'price-info-dtail',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info-dtail/price-info-dtail-dialog.html',
                        controller: 'PriceInfoDtailDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PriceInfoDtail', function (PriceInfoDtail) {
                                return PriceInfoDtail.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('price-info-dtail', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('price-info-dtail.delete', {
                parent: 'price-info-dtail',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info-dtail/price-info-dtail-delete-dialog.html',
                        controller: 'PriceInfoDtailDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PriceInfoDtail', function (PriceInfoDtail) {
                                return PriceInfoDtail.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('price-info-dtail', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PriceInfoDtail', PriceInfoDtail);

    PriceInfoDtail.$inject = ['$resource'];

    function PriceInfoDtail($resource) {
        var resourceUrl = 'api/price-info-dtails/:id';
        //
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PriceInfoDtailSearch', PriceInfoDtailSearch);

    PriceInfoDtailSearch.$inject = ['$resource'];

    function PriceInfoDtailSearch($resource) {
        var resourceUrl = 'api/_search/price-info-dtails/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDtailController', PriceInfoDtailController);

    PriceInfoDtailController.$inject = ['$scope', '$state', 'PriceInfoDtail', 'PriceInfoDtailSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PriceInfoDtailController($scope, $state, PriceInfoDtail, PriceInfoDtailSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                PriceInfoDtailSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PriceInfoDtail.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.priceInfoDtails = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemPriceInfoDeleteController', ServiceItemPriceInfoDeleteController);

    ServiceItemPriceInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PriceInfoCustom'];

    function ServiceItemPriceInfoDeleteController($uibModalInstance, entity, PriceInfoCustom) {
        var vm = this;

        vm.priceInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PriceInfoCustom.deletePriceInfoWithRelationsById(id).query(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDialogController', PriceInfoDialogController);

    PriceInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PriceInfo', 'Servant'];

    function PriceInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PriceInfo, Servant) {
        var vm = this;

        vm.priceInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.servants = Servant.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.priceInfo.id !== null) {
                PriceInfo.update(vm.priceInfo, onSaveSuccess, onSaveError);
            } else {
                PriceInfo.save(vm.priceInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:priceInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromValidDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDetailController', PriceInfoDetailController);

    PriceInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PriceInfo', 'Servant'];

    function PriceInfoDetailController($scope, $rootScope, $stateParams, entity, PriceInfo, Servant) {
        var vm = this;

        vm.priceInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:priceInfoUpdate', function (event, result) {
            vm.priceInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoDeleteController', PriceInfoDeleteController);

    PriceInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PriceInfo'];

    function PriceInfoDeleteController($uibModalInstance, entity, PriceInfo) {
        var vm = this;

        vm.priceInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PriceInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PriceInfoCustom', PriceInfoCustom);

    PriceInfoCustom.$inject = ['$resource'];

    function PriceInfoCustom($resource) {


        var PriceInfosByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/price-infos-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var deletePriceInfoWithRelationsById = function (priceInfoId) {
            var resourceUrl = 'api/delete-price-info-with-relations-by-price-info-id/' + priceInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getPriceInfoWithDtailById = function (priceInfoId) {
            var resourceUrl = 'api/get-price-info-with-dtails-by-price-info-id/' + priceInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getPriceInfosWithDtailsByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/get-price-infos-with-dtails-by-service-item-id/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            PriceInfosByServiceItem: PriceInfosByServiceItem,
            deletePriceInfoWithRelationsById: deletePriceInfoWithRelationsById,
            getPriceInfoWithDtailById: getPriceInfoWithDtailById,
            getPriceInfosWithDtailsByServiceItem: getPriceInfosWithDtailsByServiceItem
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('price-info', {
                parent: 'entity',
                url: '/price-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.priceInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/price-info/price-infos.html',
                        controller: 'PriceInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('priceInfo');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('price-info-detail', {
                parent: 'entity',
                url: '/price-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.priceInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/price-info/price-info-detail.html',
                        controller: 'PriceInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('priceInfo');
                        $translatePartialLoader.addPart('priceType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PriceInfo', function ($stateParams, PriceInfo) {
                        return PriceInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('price-info.new', {
                parent: 'price-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info/price-info-dialog.html',
                        controller: 'PriceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fromValidDate: null,
                                    priceType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('price-info', null, {reload: true});
                    }, function () {
                        $state.go('price-info');
                    });
                }]
            })
            .state('price-info.edit', {
                parent: 'price-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info/price-info-dialog.html',
                        controller: 'PriceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PriceInfo', function (PriceInfo) {
                                return PriceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('price-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('price-info.delete', {
                parent: 'price-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/price-info/price-info-delete-dialog.html',
                        controller: 'PriceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PriceInfo', function (PriceInfo) {
                                return PriceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('price-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PriceInfo', PriceInfo);

    PriceInfo.$inject = ['$resource', 'DateUtils'];

    function PriceInfo($resource, DateUtils) {
        var resourceUrl = 'api/price-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromValidDate = DateUtils.convertDateTimeFromServer(data.fromValidDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PriceInfoSearch', PriceInfoSearch);

    PriceInfoSearch.$inject = ['$resource'];

    function PriceInfoSearch($resource) {
        var resourceUrl = 'api/_search/price-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PriceInfoController', PriceInfoController);

    PriceInfoController.$inject = ['$scope', '$state', 'PriceInfo', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PriceInfoController($scope, $state, PriceInfo, PriceInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                PriceInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PriceInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.priceInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PersonInfoQuery', PersonInfoQuery);

    PersonInfoQuery.$inject = ['$resource'];

    function PersonInfoQuery($resource) {


        var findByFirstName = function (firstName) {
            var resourceUrl = 'api/getPersonInfoByFirstName/' + firstName;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var findPersonInfoByQuery = function (query) {
            var resourceUrl = 'api/find-person-info-by-query?query=' + query;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            findByFirstName: findByFirstName,
            findPersonInfoByQuery: findPersonInfoByQuery
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PersonInfoDialogController', PersonInfoDialogController);

    PersonInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PersonInfo', 'LocationInfo', 'SocialNetworkInfo'];

    function PersonInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PersonInfo, LocationInfo, SocialNetworkInfo) {
        var vm = this;

        vm.personInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.locationinfos = LocationInfo.query();
        vm.socialnetworkinfos = SocialNetworkInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.personInfo.id !== null) {
                PersonInfo.update(vm.personInfo, onSaveSuccess, onSaveError);
            } else {
                PersonInfo.save(vm.personInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:personInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PersonInfoDetailController', PersonInfoDetailController);

    PersonInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PersonInfo', 'LocationInfo', 'SocialNetworkInfo'];

    function PersonInfoDetailController($scope, $rootScope, $stateParams, entity, PersonInfo, LocationInfo, SocialNetworkInfo) {
        var vm = this;

        vm.personInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:personInfoUpdate', function (event, result) {
            vm.personInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PersonInfoDeleteController', PersonInfoDeleteController);

    PersonInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PersonInfo'];

    function PersonInfoDeleteController($uibModalInstance, entity, PersonInfo) {
        var vm = this;

        vm.personInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PersonInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
//(function() {
//    'use strict';
//    angular
//        .module('tikonApp')
//        .factory('PersonInfoCustom', PersonInfoCustom);
//
//    PersonInfoCustom.$inject = ['$resource'];
//
//    function PersonInfoCustom ($resource) {
//
//
//
//        var PersonInfosByServiceItem=function(serviceItemId)
//        {
//            var resourceUrl='api/Person-info-by-service-item/'+serviceItemId;
//            return $resource(resourceUrl, {}, {
//                    'query': { method: 'GET', isArray: true}
//                }
//
//            );
//        };
//
//
//
//        return {
//            PersonInfosByServiceItem:PersonInfosByServiceItem
//        };
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('person-info', {
                parent: 'entity',
                url: '/person-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.personInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/person-info/person-infos.html',
                        controller: 'PersonInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('person-info-detail', {
                parent: 'entity',
                url: '/person-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.personInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/person-info/person-info-detail.html',
                        controller: 'PersonInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PersonInfo', function ($stateParams, PersonInfo) {
                        return PersonInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('person-info.new', {
                parent: 'person-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/person-info/person-info-dialog.html',
                        controller: 'PersonInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    nationalCode: null,
                                    fisrtName: null,
                                    lastName: null,
                                    gender: null,
                                    phoneNumber: null,
                                    birthDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('person-info', null, {reload: true});
                    }, function () {
                        $state.go('person-info');
                    });
                }]
            })
            .state('person-info.edit', {
                parent: 'person-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/person-info/person-info-dialog.html',
                        controller: 'PersonInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PersonInfo', function (PersonInfo) {
                                return PersonInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('person-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('person-info.delete', {
                parent: 'person-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/person-info/person-info-delete-dialog.html',
                        controller: 'PersonInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PersonInfo', function (PersonInfo) {
                                return PersonInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('person-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PersonInfo', PersonInfo);

    PersonInfo.$inject = ['$resource', 'DateUtils'];

    function PersonInfo($resource, DateUtils) {
        var resourceUrl = 'api/person-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertDateTimeFromServer(data.birthDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PersonInfoSearch', PersonInfoSearch);

    PersonInfoSearch.$inject = ['$resource'];

    function PersonInfoSearch($resource) {
        var resourceUrl = 'api/_search/person-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PersonInfoController', PersonInfoController);

    PersonInfoController.$inject = ['$scope', '$state', 'PersonInfo', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PersonInfoController($scope, $state, PersonInfo, PersonInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                PersonInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PersonInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.personInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PaymentLogDialogController', PaymentLogDialogController);

    PaymentLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentLog', 'InvoiceInfo'];

    function PaymentLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentLog, InvoiceInfo) {
        var vm = this;

        vm.paymentLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.invoiceinfos = InvoiceInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.paymentLog.id !== null) {
                PaymentLog.update(vm.paymentLog, onSaveSuccess, onSaveError);
            } else {
                PaymentLog.save(vm.paymentLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:paymentLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PaymentLogDetailController', PaymentLogDetailController);

    PaymentLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PaymentLog', 'InvoiceInfo'];

    function PaymentLogDetailController($scope, $rootScope, $stateParams, entity, PaymentLog, InvoiceInfo) {
        var vm = this;

        vm.paymentLog = entity;

        var unsubscribe = $rootScope.$on('tikonApp:paymentLogUpdate', function (event, result) {
            vm.paymentLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PaymentLogDeleteController', PaymentLogDeleteController);

    PaymentLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaymentLog'];

    function PaymentLogDeleteController($uibModalInstance, entity, PaymentLog) {
        var vm = this;

        vm.paymentLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PaymentLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
/**
 * Created by Majid on 1/29/2017.
 */
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PaymentLogCustom', PaymentLogCustom);

    PaymentLogCustom.$inject = ['$resource'];

    function PaymentLogCustom($resource) {


        var createPaymentLogByOrderBagId = function () {

            var resourceUrl = 'api/create-payment-log-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var deletePaymentLogById = function () {
            var resourceUrl = 'api/delete-payment-log/:id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var createPaymentLogByInvoiceInfoId = function () {

            var resourceUrl = 'api/create-payment-log-by-invoice-info-id';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {
            createPaymentLogByOrderBagId: createPaymentLogByOrderBagId,
            deletePaymentLogById: deletePaymentLogById,
            createPaymentLogByInvoiceInfoId: createPaymentLogByInvoiceInfoId
        };
    }
})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('payment-log', {
                parent: 'entity',
                url: '/payment-log?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.paymentLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/payment-log/payment-logs.html',
                        controller: 'PaymentLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('payment-log-detail', {
                parent: 'entity',
                url: '/payment-log/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.paymentLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/payment-log/payment-log-detail.html',
                        controller: 'PaymentLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PaymentLog', function ($stateParams, PaymentLog) {
                        return PaymentLog.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('payment-log.new', {
                parent: 'payment-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-log/payment-log-dialog.html',
                        controller: 'PaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    traceCode: null,
                                    paymentType: null,
                                    createDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('payment-log', null, {reload: true});
                    }, function () {
                        $state.go('payment-log');
                    });
                }]
            })
            .state('payment-log.edit', {
                parent: 'payment-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-log/payment-log-dialog.html',
                        controller: 'PaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PaymentLog', function (PaymentLog) {
                                return PaymentLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('payment-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('payment-log.delete', {
                parent: 'payment-log',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-log/payment-log-delete-dialog.html',
                        controller: 'PaymentLogDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PaymentLog', function (PaymentLog) {
                                return PaymentLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('payment-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PaymentLog', PaymentLog);

    PaymentLog.$inject = ['$resource', 'DateUtils'];

    function PaymentLog($resource, DateUtils) {
        var resourceUrl = 'api/payment-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PaymentLogSearch', PaymentLogSearch);

    PaymentLogSearch.$inject = ['$resource'];

    function PaymentLogSearch($resource) {
        var resourceUrl = 'api/_search/payment-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PaymentLogController', PaymentLogController);

    PaymentLogController.$inject = ['$scope', '$state', 'PaymentLog', 'PaymentLogSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PaymentLogController($scope, $state, PaymentLog, PaymentLogSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                PaymentLogSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PaymentLog.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.paymentLogs = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagPaymentLogDialogController', OrderBagPaymentLogDialogController);

    OrderBagPaymentLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentLog', 'InvoiceInfo', 'PaymentLogCustom'];

    function OrderBagPaymentLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentLog, InvoiceInfo, PaymentLogCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.paymentLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.paymentLog.receiptPay = true;
        //vm.invoiceinfos =

        vm.closeModal = closeModal;
        vm.okModal = okModal;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.paymentLog.id !== null) {
                    //PaymentLog.update(vm.paymentLog, onSaveSuccess, onSaveError);
                } else {
                    if (vm.paymentLog.receiptPay == false)
                        vm.paymentLog.amount = -vm.paymentLog.amount;

                    PaymentLogCustom.createPaymentLogByOrderBagId().save(vm.paymentLog, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:paymentLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        function closeModal() {
            clear();

        }

        function okModal() {
            save();
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoPaymentLogDialogController', InvoiceInfoPaymentLogDialogController);

    InvoiceInfoPaymentLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentLog', 'InvoiceInfo', 'PaymentLogCustom'];

    function InvoiceInfoPaymentLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentLog, InvoiceInfo, PaymentLogCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.paymentLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.paymentLog.receiptPay = true;
        //vm.invoiceinfos =

        vm.closeModal = closeModal;
        vm.okModal = okModal;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.paymentLog.id !== null) {
                    //PaymentLog.update(vm.paymentLog, onSaveSuccess, onSaveError);
                } else {
                    if (vm.paymentLog.receiptPay == false)
                        vm.paymentLog.amount = -vm.paymentLog.amount;

                    PaymentLogCustom.createPaymentLogByInvoiceInfoId().save(vm.paymentLog, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:paymentLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        function closeModal() {
            clear();

        }

        function okModal() {
            save();
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PatternInfoListController', PatternInfoListController);

    PatternInfoListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'PatternInfo', 'PatternInfoCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function PatternInfoListController($scope, $state, ParseLinks, AlertService, PatternInfo, PatternInfoCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;


        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newPatternClick = newPatternClick;


        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                PatternInfoCustom.getAllCompanyPatterns().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PatternInfoCustom.getAllCompanyPatterns().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patterns = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }

        function newPatternClick() {

            var result;

            result = Principal.hasSpecialFeatureAccess("reservePattern");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newPatternInfo');

        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PatternInfoCustom', PatternInfoCustom);

    PatternInfoCustom.$inject = ['$resource'];

    function PatternInfoCustom($resource) {


        var getAllCompanyPatterns = function () {

            var resourceUrl = 'api/get-all-company-patterns';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getAllCompanyPatterns: getAllCompanyPatterns,

        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PatternInfo', PatternInfo);

    PatternInfo.$inject = ['$resource'];

    function PatternInfo($resource) {
        var resourceUrl = 'api/pattern-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PatternInfoController', PatternInfoController);

    PatternInfoController.$inject = ['$scope', '$state', 'PatternInfo', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'PatternInfoCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom', 'ServantCustom'];

    function PatternInfoController($scope, $state, PatternInfo, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, PatternInfoCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom, ServantCustom) {

        var vm = this;
        vm.patternInfo = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.onServiceChanged = onServiceChanged;
        vm.selectedServiceItem = null;
        vm.addServiceToPattern = addServiceToPattern;
        vm.removeFromPattern = removeFromPattern;
        vm.servantList = [];
        vm.selectedServantChanged = selectedServantChanged;


        initDefault();
        loadAll();

        function initDefault() {

            if (!vm.patternInfo || !vm.patternInfo.id) {
                vm.patternInfo.companyId = 1;
                vm.patternInfo.description = '';
                vm.patternInfo.pattern = '';
                vm.patternInfo.patternStructure = {};
            }


        }

        function loadAll() {
            $translatePartialLoader.addPart('patternInfo');
            $translatePartialLoader.addPart('patternStatus');
            $translatePartialLoader.addPart('servant');
            loadAllServants();

        }

        function loadAllServants() {
            ServantCustom.getServantsHaveServicesByCurrentCompany().query().$promise.then(function (result) {
                    vm.servantList = result;
                }
            )
        }

        function selectedServantChanged() {
            if (vm.patternInfo && vm.patternInfo.servantId) {
                getServantServices(vm.patternInfo.servantId);
            }
        }

        function getServantServices(servantId) {

            if (servantId) {
                ServiceItemCustom.getServiceItemsByServantId(servantId).query().$promise.then(function (result) {
                        vm.allServiceItems = result;
                    }
                );
            }
        }

        function save() {
            vm.isSaving = true;

            if (vm.patternInfo.id !== null) {
                vm.patternInfo.description = '';
                vm.patternInfo.pattern = '';
                PatternInfo.update(vm.patternInfo, onSaveSuccess, onSaveError);
            } else {
                PatternInfo.save(vm.patternInfo, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:patternInfoUpdate', result);
                $state.go('supplierPanel.editPatternInfo', {id: result.id});

                loadAll();

            }

        }


        function onServiceChanged(item) {
        }

        function addServiceToPattern() {
            if (vm.selectedServiceItem) {
                if (!vm.patternInfo.patternStructure) {
                    vm.patternInfo.patternStructure = {};
                }

                var item = {};
                var orderNo = 1;
                if (vm.patternInfo.patternStructure.patternItems != null && vm.patternInfo.patternStructure.patternItems.length > 0)
                    orderNo = vm.patternInfo.patternStructure.patternItems.length + 1;
                else
                    vm.patternInfo.patternStructure.patternItems = [];

                item.orderNo = orderNo;
                item.serviceId = vm.selectedServiceItem.id;
                item.maxCapacity = vm.selectedServiceItem.capacityInfo.qty;
                item.serviceItem = vm.selectedServiceItem;

                vm.patternInfo.patternStructure.patternItems.push(item);
            }
        }

        function removeFromPattern(item) {

            vm.patternInfo.patternStructure.patternItems = vm.patternInfo.patternStructure.patternItems.filter(function (value) {
                return (value.orderNo != item.orderNo)
            })

            // regenerate orderNo
            var orderNo = 1;
            angular.forEach(vm.patternInfo.patternStructure.patternItems, function (c) {

                c.orderNo = orderNo;
                orderNo++;
            });


        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ParticipantPersonDialogController', ParticipantPersonDialogController);

    ParticipantPersonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ParticipantPerson', 'PersonInfo', 'OrderBagServiceItemDtail'];

    function ParticipantPersonDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ParticipantPerson, PersonInfo, OrderBagServiceItemDtail) {
        var vm = this;

        vm.participantPerson = entity;
        vm.clear = clear;
        vm.save = save;
        vm.personinfos = PersonInfo.query();
        vm.orderbagserviceitemdtails = OrderBagServiceItemDtail.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.participantPerson.id !== null) {
                ParticipantPerson.update(vm.participantPerson, onSaveSuccess, onSaveError);
            } else {
                ParticipantPerson.save(vm.participantPerson, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:participantPersonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ParticipantPersonDetailController', ParticipantPersonDetailController);

    ParticipantPersonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ParticipantPerson', 'PersonInfo', 'OrderBagServiceItemDtail'];

    function ParticipantPersonDetailController($scope, $rootScope, $stateParams, entity, ParticipantPerson, PersonInfo, OrderBagServiceItemDtail) {
        var vm = this;

        vm.participantPerson = entity;

        var unsubscribe = $rootScope.$on('tikonApp:participantPersonUpdate', function (event, result) {
            vm.participantPerson = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ParticipantPersonDeleteController', ParticipantPersonDeleteController);

    ParticipantPersonDeleteController.$inject = ['$uibModalInstance', 'entity', 'ParticipantPerson'];

    function ParticipantPersonDeleteController($uibModalInstance, entity, ParticipantPerson) {
        var vm = this;

        vm.participantPerson = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ParticipantPerson.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('participant-person', {
                parent: 'entity',
                url: '/participant-person?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.participantPerson.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/participant-person/participant-people.html',
                        controller: 'ParticipantPersonController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('participantPerson');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('participant-person-detail', {
                parent: 'entity',
                url: '/participant-person/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.participantPerson.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/participant-person/participant-person-detail.html',
                        controller: 'ParticipantPersonDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('participantPerson');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ParticipantPerson', function ($stateParams, ParticipantPerson) {
                        return ParticipantPerson.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('participant-person.new', {
                parent: 'participant-person',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/participant-person/participant-person-dialog.html',
                        controller: 'ParticipantPersonDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('participant-person', null, {reload: true});
                    }, function () {
                        $state.go('participant-person');
                    });
                }]
            })
            .state('participant-person.edit', {
                parent: 'participant-person',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/participant-person/participant-person-dialog.html',
                        controller: 'ParticipantPersonDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ParticipantPerson', function (ParticipantPerson) {
                                return ParticipantPerson.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('participant-person', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('participant-person.delete', {
                parent: 'participant-person',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/participant-person/participant-person-delete-dialog.html',
                        controller: 'ParticipantPersonDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ParticipantPerson', function (ParticipantPerson) {
                                return ParticipantPerson.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('participant-person', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ParticipantPerson', ParticipantPerson);

    ParticipantPerson.$inject = ['$resource'];

    function ParticipantPerson($resource) {
        var resourceUrl = 'api/participant-people/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ParticipantPersonSearch', ParticipantPersonSearch);

    ParticipantPersonSearch.$inject = ['$resource'];

    function ParticipantPersonSearch($resource) {
        var resourceUrl = 'api/_search/participant-people/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ParticipantPersonController', ParticipantPersonController);

    ParticipantPersonController.$inject = ['$scope', '$state', 'ParticipantPerson', 'ParticipantPersonSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ParticipantPersonController($scope, $state, ParticipantPerson, ParticipantPersonSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ParticipantPersonSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ParticipantPerson.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.participantPeople = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagParticipantPersonDialogController', OrderBagParticipantPersonDialogController);

    OrderBagParticipantPersonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ParticipantPerson', 'PersonInfo', 'OrderBagServiceItemDtail'];

    function OrderBagParticipantPersonDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ParticipantPerson, PersonInfo, OrderBagServiceItemDtail) {
        var vm = this;
        vm.scope = $scope;
        vm.participantPerson = entity;
        vm.clear = clear;
        vm.save = save;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                onSaveSuccess(vm.participantPerson);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListDialogController', PackageFeatureListDialogController);

    PackageFeatureListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PackageFeatureList', 'CompanyCustom'];

    function PackageFeatureListDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PackageFeatureList, CompanyCustom) {
        var vm = this;

        vm.packageFeatureList = entity;
        vm.clear = clear;
        vm.save = save;
        vm.searchCompany = searchCompany;
        vm.companyKeyUrl = "";
        vm.company = {};


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.company.id)
                vm.packageFeatureList.company = vm.company;

            if (vm.packageFeatureList.id !== null) {
                PackageFeatureList.update(vm.packageFeatureList, onSaveSuccess, onSaveError);
            } else {
                PackageFeatureList.save(vm.packageFeatureList, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:packageFeatureListUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function searchCompany() {
            if (!vm.packageFeatureList.companyId && vm.companyKeyUrl != "") {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.company = result;

                    }
                })
            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListDetailController', PackageFeatureListDetailController);

    PackageFeatureListDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PackageFeatureList'];

    function PackageFeatureListDetailController($scope, $rootScope, $stateParams, entity, PackageFeatureList) {
        var vm = this;

        vm.packageFeatureList = entity;

        var unsubscribe = $rootScope.$on('tikonApp:packageFeatureListUpdate', function (event, result) {
            vm.packageFeatureList = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListDeleteController', PackageFeatureListDeleteController);

    PackageFeatureListDeleteController.$inject = ['$uibModalInstance', 'entity', 'PackageFeatureList'];

    function PackageFeatureListDeleteController($uibModalInstance, entity, PackageFeatureList) {
        var vm = this;

        vm.packageFeatureList = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PackageFeatureList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PackageFeatureListCustom', PackageFeatureListCustom);

    PackageFeatureListCustom.$inject = ['$resource'];

    function PackageFeatureListCustom($resource) {


        var getPackageFeatureListByCompanyId = function (companyId) {
            var resourceUrl = 'api/get-package-feature-list-by-company-id?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }
        var getPackageFeatureListByCurrentCompany = function () {
            var resourceUrl = 'api/get-package-feature-list-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        return {
            getPackageFeatureListByCompanyId: getPackageFeatureListByCompanyId,
            getPackageFeatureListByCurrentCompany: getPackageFeatureListByCurrentCompany

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('package-feature-list', {
                parent: 'entity',
                url: '/package-feature-list?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.packageFeatureList.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/package-feature-list/package-feature-lists.html',
                        controller: 'PackageFeatureListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('packageFeatureList');
                        $translatePartialLoader.addPart('featureStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('package-feature-list-detail', {
                parent: 'entity',
                url: '/package-feature-list/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.packageFeatureList.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-detail.html',
                        controller: 'PackageFeatureListDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('packageFeatureList');
                        $translatePartialLoader.addPart('featureStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PackageFeatureList', function ($stateParams, PackageFeatureList) {
                        return PackageFeatureList.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('package-feature-list.new', {
                parent: 'package-feature-list',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-dialog.html',
                        controller: 'PackageFeatureListDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    sendingSMS: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('package-feature-list', null, {reload: true});
                    }, function () {
                        $state.go('package-feature-list');
                    });
                }]
            })
            .state('package-feature-list.edit', {
                parent: 'package-feature-list',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-dialog.html',
                        controller: 'PackageFeatureListDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PackageFeatureList', function (PackageFeatureList) {
                                return PackageFeatureList.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('package-feature-list', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('package-feature-list.delete', {
                parent: 'package-feature-list',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/package-feature-list/package-feature-list-delete-dialog.html',
                        controller: 'PackageFeatureListDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PackageFeatureList', function (PackageFeatureList) {
                                return PackageFeatureList.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('package-feature-list', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PackageFeatureList', PackageFeatureList);

    PackageFeatureList.$inject = ['$resource'];

    function PackageFeatureList($resource) {
        var resourceUrl = 'api/package-feature-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PackageFeatureListSearch', PackageFeatureListSearch);

    PackageFeatureListSearch.$inject = ['$resource'];

    function PackageFeatureListSearch($resource) {
        var resourceUrl = 'api/_search/package-feature-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListController', PackageFeatureListController);

    PackageFeatureListController.$inject = ['$scope', '$state', 'PackageFeatureList', 'PackageFeatureListSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'CompanyCustom', 'PackageFeatureListCustom'];

    function PackageFeatureListController($scope, $state, PackageFeatureList, PackageFeatureListSearch, ParseLinks, AlertService, pagingParams, paginationConstants, CompanyCustom, PackageFeatureListCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchCompany = searchCompany;


        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                PackageFeatureListSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PackageFeatureList.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.packageFeatureLists = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function searchCompany() {
            if (vm.companyKeyUrl != "") {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.company = result;
                        PackageFeatureListCustom.getPackageFeatureListByCompanyId(vm.company.id).query().$promise.then(function (feature) {

                            if (feature.id)
                                $state.transitionTo('package-feature-list.edit', {id: feature.id});
                        })


                    }
                })
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDtailDialogController', OrderBagServiceItemDtailDialogController);

    OrderBagServiceItemDtailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBagServiceItemDtail', 'OrderBagServiceItem', 'PriceInfoDtail'];

    function OrderBagServiceItemDtailDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBagServiceItemDtail, OrderBagServiceItem, PriceInfoDtail) {
        var vm = this;

        vm.orderBagServiceItemDtail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.orderbagserviceitems = OrderBagServiceItem.query();
        vm.priceinfodtails = PriceInfoDtail.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.orderBagServiceItemDtail.id !== null) {
                OrderBagServiceItemDtail.update(vm.orderBagServiceItemDtail, onSaveSuccess, onSaveError);
            } else {
                OrderBagServiceItemDtail.save(vm.orderBagServiceItemDtail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagServiceItemDtailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.reserveTime = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDtailDetailController', OrderBagServiceItemDtailDetailController);

    OrderBagServiceItemDtailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OrderBagServiceItemDtail', 'OrderBagServiceItem', 'PriceInfoDtail'];

    function OrderBagServiceItemDtailDetailController($scope, $rootScope, $stateParams, entity, OrderBagServiceItemDtail, OrderBagServiceItem, PriceInfoDtail) {
        var vm = this;

        vm.orderBagServiceItemDtail = entity;

        var unsubscribe = $rootScope.$on('tikonApp:orderBagServiceItemDtailUpdate', function (event, result) {
            vm.orderBagServiceItemDtail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDtailDeleteController', OrderBagServiceItemDtailDeleteController);

    OrderBagServiceItemDtailDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderBagServiceItemDtail'];

    function OrderBagServiceItemDtailDeleteController($uibModalInstance, entity, OrderBagServiceItemDtail) {
        var vm = this;

        vm.orderBagServiceItemDtail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            OrderBagServiceItemDtail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('order-bag-service-item-dtail', {
                parent: 'entity',
                url: '/order-bag-service-item-dtail?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagServiceItemDtail.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-service-item-dtail/order-bag-service-item-dtails.html',
                        controller: 'OrderBagServiceItemDtailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItemDtail');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('order-bag-service-item-dtail-detail', {
                parent: 'entity',
                url: '/order-bag-service-item-dtail/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagServiceItemDtail.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-detail.html',
                        controller: 'OrderBagServiceItemDtailDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItemDtail');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagServiceItemDtail', function ($stateParams, OrderBagServiceItemDtail) {
                        return OrderBagServiceItemDtail.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('order-bag-service-item-dtail.new', {
                parent: 'order-bag-service-item-dtail',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-dialog.html',
                        controller: 'OrderBagServiceItemDtailDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    reserveTime: null,
                                    gty: null,
                                    price: null,
                                    discount: null,
                                    vat: null,
                                    totalPrice: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('order-bag-service-item-dtail', null, {reload: true});
                    }, function () {
                        $state.go('order-bag-service-item-dtail');
                    });
                }]
            })
            .state('order-bag-service-item-dtail.edit', {
                parent: 'order-bag-service-item-dtail',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-dialog.html',
                        controller: 'OrderBagServiceItemDtailDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['OrderBagServiceItemDtail', function (OrderBagServiceItemDtail) {
                                return OrderBagServiceItemDtail.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag-service-item-dtail', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('order-bag-service-item-dtail.delete', {
                parent: 'order-bag-service-item-dtail',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-delete-dialog.html',
                        controller: 'OrderBagServiceItemDtailDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['OrderBagServiceItemDtail', function (OrderBagServiceItemDtail) {
                                return OrderBagServiceItemDtail.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag-service-item-dtail', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagServiceItemDtail', OrderBagServiceItemDtail);

    OrderBagServiceItemDtail.$inject = ['$resource', 'DateUtils'];

    function OrderBagServiceItemDtail($resource, DateUtils) {
        var resourceUrl = 'api/order-bag-service-item-dtails/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reserveTime = DateUtils.convertDateTimeFromServer(data.reserveTime);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OrderBagServiceItemDtailSearch', OrderBagServiceItemDtailSearch);

    OrderBagServiceItemDtailSearch.$inject = ['$resource'];

    function OrderBagServiceItemDtailSearch($resource) {
        var resourceUrl = 'api/_search/order-bag-service-item-dtails/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDtailController', OrderBagServiceItemDtailController);

    OrderBagServiceItemDtailController.$inject = ['$scope', '$state', 'OrderBagServiceItemDtail', 'OrderBagServiceItemDtailSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrderBagServiceItemDtailController($scope, $state, OrderBagServiceItemDtail, OrderBagServiceItemDtailSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                OrderBagServiceItemDtailSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderBagServiceItemDtail.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagServiceItemDtails = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReplaceTimeOrderBagServiceItemDialogV2Controller', ReplaceTimeOrderBagServiceItemDialogV2Controller);

    ReplaceTimeOrderBagServiceItemDialogV2Controller.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBagServiceItemCustom', 'ServiceTimeSessionCustom', 'ServiceTimeSession', 'ScheduleInfoCustom'];

    function ReplaceTimeOrderBagServiceItemDialogV2Controller($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBagServiceItemCustom, ServiceTimeSessionCustom, ServiceTimeSession, ScheduleInfoCustom) {

        var vm = this;
        vm.orderBagItemId = entity.orderBagItemId;
        vm.serviceItemId = entity.serviceItemId;
        vm.currentTime = entity.currentTime;
        vm.clear = clear;
        vm.save = save;
        //vm.availableDates = [];
        vm.selectedTimeSessionId = null;
        vm.availableDates_changed = availableDates_changed;


        loadAvailableDates();
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.selectedTimeSessionId == null || vm.orderBagItemId == null) {
                return;
            } else {
                OrderBagServiceItemCustom.replaceTime(vm.orderBagItemId, vm.selectedTimeSessionId).query()
                    .$promise.then(onSaveSuccess());
            }
        }

        function onSaveSuccess() {
            //$scope.$emit('tikonApp:orderBagServiceItemUpdate', result);

            vm.result = ServiceTimeSession.get({id: vm.selectedTimeSessionId}).$promise
            $uibModalInstance.close(vm.result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function loadAvailableDates() {

            if (vm.serviceItemId == undefined || vm.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            vm.availableDates = [];
            //ServiceTimeSessionCustom.getServiceTimeSessionFromNow(vm.serviceItemId).query(function(data)
            //{
            //    vm.availableDates=data;
            //});
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow(vm.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = vm.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            vm.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });

        }

        function loadAvailableDynamicDate() {
            vm.availableDynamicDates = ScheduleInfoCustom.getDynamicAvailableDatesByServiceIdAndServantId(vm.orderBagServiceItem.serviceItemId, getServantId()).query(function (list) {
                if (list[0])
                    vm.selectedDynamicDate = list[0].spanDate;
                if (then)
                    then();
                $ctrl.updateAvailableFromTime(then);

            });
        }

        function getServantId() {
            if (vm.orderBagServiceItem.servant)
                return vm.orderBagServiceItem.servant.id;
            else
                return null;
        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function loadAvailableTimes() {
            if (vm.selectedDate == undefined || vm.selectedDate == null)
                return;

            var dateTime = new Date(vm.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            vm.availableTimes = ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate(vm.serviceItemId, dateTime.toISOString()).query();

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReplaceTimeOrderBagServiceItemDialogController', ReplaceTimeOrderBagServiceItemDialogController);

    ReplaceTimeOrderBagServiceItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBagServiceItemCustom', 'ServiceTimeSessionCustom', 'ServiceTimeSession'];

    function ReplaceTimeOrderBagServiceItemDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBagServiceItemCustom, ServiceTimeSessionCustom, ServiceTimeSession) {

        var vm = this;
        vm.orderBagItemId = entity.orderBagItemId;
        vm.serviceItemId = entity.serviceItemId;
        vm.currentTime = entity.currentTime;
        vm.clear = clear;
        vm.save = save;
        //vm.availableDates = [];
        vm.selectedTimeSessionId = null;
        vm.availableDates_changed = availableDates_changed;


        loadAvailableDates();
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.selectedTimeSessionId == null || vm.orderBagItemId == null) {
                return;
            } else {
                OrderBagServiceItemCustom.replaceTime(vm.orderBagItemId, vm.selectedTimeSessionId).query()
                    .$promise.then(onSaveSuccess());
            }
        }

        function onSaveSuccess() {
            //$scope.$emit('tikonApp:orderBagServiceItemUpdate', result);

            vm.result = ServiceTimeSession.get({id: vm.selectedTimeSessionId}).$promise
            $uibModalInstance.close(vm.result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function loadAvailableDates() {

            if (vm.serviceItemId == undefined || vm.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            vm.availableDates = [];
            //ServiceTimeSessionCustom.getServiceTimeSessionFromNow(vm.serviceItemId).query(function(data)
            //{
            //    vm.availableDates=data;
            //});
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow(vm.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = vm.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            vm.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });

        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function loadAvailableTimes() {
            if (vm.selectedDate == undefined || vm.selectedDate == null)
                return;

            var dateTime = new Date(vm.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            vm.availableTimes = ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate(vm.serviceItemId, dateTime.toISOString()).query();

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemTestController', OrderBagServiceItemTestController);

    OrderBagServiceItemTestController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'OrderBagServiceItem', 'ServiceItem', 'ServiceTimeSession', 'OrderBagServiceItemCustom', 'timeSession'];

    function OrderBagServiceItemTestController($timeout, $scope, $stateParams, entity, OrderBagServiceItem, ServiceItem, ServiceTimeSession, OrderBagServiceItemCustom, timeSession) {


        var vm = this;
        vm.orderBagServiceItem = entity;


        //vm.orderBagServiceItem = {status: 0,
        //    subtotalServicePrice: 1,
        //    subtotalOptionPrice: 1,
        //    subtotalVAT: 1,
        //    subtotalDiscount: 1,
        //    totalRowPrice: 1,
        //    id: null,
        //    orderBagServiceItemDtail :[],
        //    serviceItemId:1427
        //
        //};

        //
        // OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities(3553).query(function(result){
        //
        //    vm.orderBagServiceItem = result;
        //
        //});

        vm.clear = clear;
        vm.save = save;
        //vm.serviceitems = ServiceItem.query();
        vm.serviceItemId = 1427;
        vm.selectedServiceTimeSession = timeSession;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.orderBagServiceItem.id !== null) {
                OrderBagServiceItem.update(vm.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                OrderBagServiceItem.save(vm.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            //$scope.$emit('tikonApp:orderBagServiceItemUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemListController', OrderBagServiceItemListController);

    OrderBagServiceItemListController.$inject = ['$scope', '$state', 'OrderBagServiceItem', 'OrderBagServiceItemSearch', 'ParseLinks', 'AlertService', 'OrderBagServiceItemCustom', 'OrderBagCustom'];

    function OrderBagServiceItemListController($scope, $state, OrderBagServiceItem, OrderBagServiceItemSearch, ParseLinks, AlertService, OrderBagServiceItemCustom, OrderBagCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        //vm.predicate = pagingParams.predicate;
        //vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        //vm.searchQuery = pagingParams.search;
        //vm.currentSearch = pagingParams.search;
        vm.orderBagFinalPrice = [];
        vm.approve = approve;
        vm.orderBag = null;
        vm.formState = 'noitem';
        //loadAll();

        loadActiveOrderBagItems();


        function loadAll() {
            if (pagingParams.search) {
                OrderBagServiceItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderBagServiceItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagServiceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadActiveOrderBagItems() {

            OrderBagServiceItemCustom.getActiveOrderBagServiceItems().query(function (result) {
                vm.orderBagServiceItems = result;
                if (vm.orderBagServiceItems != null && vm.orderBagServiceItems.length != 0 && vm.orderBagServiceItems != undefined) {
                    vm.formState = 'active';
                    computeFinalPrice();
                } else {
                    vm.formState = 'noitem';
                }
            });

        }

        function computeFinalPrice() {

            var totalServicePrice = 0;
            var totalOptionPrice = 0;
            var totalVat = 0;
            var totalDiscount = 0;
            var finalPrice = 0;


            if (vm.orderBagServiceItems != null && vm.orderBagServiceItems.length != 0 && vm.orderBagServiceItems != undefined) {
                angular.forEach(vm.orderBagServiceItems, function (ob) {

                    if (ob.subtotalServicePrice != null)
                        totalServicePrice += ob.subtotalServicePrice;
                    if (ob.subtotalOptionPrice != null)
                        totalOptionPrice += ob.subtotalOptionPrice;
                    if (ob.subtotalVAT != null)
                        totalVat += ob.subtotalVAT;
                    if (ob.subtotalDiscount != null)
                        totalDiscount += ob.subtotalDiscount;
                });

                finalPrice = totalServicePrice + totalOptionPrice - totalDiscount + totalVat;

            }


            vm.orderBagFinalPrice.totalServicePrice = totalServicePrice;
            vm.orderBagFinalPrice.totalOptionPrice = totalOptionPrice;
            vm.orderBagFinalPrice.totalDiscount = totalDiscount;
            vm.orderBagFinalPrice.totalVat = totalVat;
            vm.orderBagFinalPrice.finalPrice = finalPrice;

        }

        function approve() {
            if (vm.orderBagServiceItems != null || vm.orderBagServiceItems.size != 0 || vm.orderBagServiceItems != undefined) {
                if (vm.orderBagServiceItems[0].orderBagId != null) {
                    OrderBagCustom.approveOrderBag(vm.orderBagServiceItems[0].orderBagId).query(function (result) {
                        vm.orderBag = result;
                        vm.formState = 'confirmed';
                    });
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDialogController', OrderBagServiceItemDialogController);

    OrderBagServiceItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBagServiceItem', 'OrderBag', 'ServiceItem'];

    function OrderBagServiceItemDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBagServiceItem, OrderBag, ServiceItem) {
        var vm = this;

        vm.orderBagServiceItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.orderbags = OrderBag.query();
        vm.serviceitems = ServiceItem.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.orderBagServiceItem.id !== null) {
                OrderBagServiceItem.update(vm.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                OrderBagServiceItem.save(vm.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagServiceItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDetailController', OrderBagServiceItemDetailController);

    OrderBagServiceItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OrderBagServiceItem', 'OrderBag', 'ServiceItem'];

    function OrderBagServiceItemDetailController($scope, $rootScope, $stateParams, entity, OrderBagServiceItem, OrderBag, ServiceItem) {
        var vm = this;

        vm.orderBagServiceItem = entity;

        var unsubscribe = $rootScope.$on('tikonApp:orderBagServiceItemUpdate', function (event, result) {
            vm.orderBagServiceItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemDeleteController', OrderBagServiceItemDeleteController);

    OrderBagServiceItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderBagServiceItem'];

    function OrderBagServiceItemDeleteController($uibModalInstance, entity, OrderBagServiceItem) {
        var vm = this;

        vm.orderBagServiceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            OrderBagServiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagServiceItemCustom', OrderBagServiceItemCustom);

    OrderBagServiceItemCustom.$inject = ['$resource', 'ENV'];

    function OrderBagServiceItemCustom($resource, ENV) {

        var getOrderBagServiceItemWithEntities = function (OrderBagServiceItemId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/order-bag-service-item-with-entities/' + OrderBagServiceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getActiveOrderBagServiceItems = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/active-order-bag-service-items';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getActiveReserveCountsToBeShown = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-active-reserve-count-to-be-shown';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getReserveStats = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-reserve-stats';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET'}
                }
            );
        };

        var getOrderBagServiceItemByCompanyIdFromNow = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/order-bag-service-items-by-company-from-time';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getAllOrderBagServiceItemByCurrentCompany = function () {

            var resourceUrl = 'api/get-all-order-bag-service-items-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var replaceTime = function (OrderBagServiceItemId, TimeSessionId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/replace-time-order-bag-service-item?orderBagServiceItemId=' + OrderBagServiceItemId + '&timeSessionId=' + TimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var checkinOrderBagServieItem = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/checkin-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };
        var notCheckinOrderBagServieItem = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/not-checkin-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };

        var removeCheckinOrderBagServieItem = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/remove-checkin-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getOrderBagServiceItemByCompanyIdFromDateToDate = function (fromDate, toDate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-order-bag-service-items-by-current-company-from-date-to-date?fromDate=' + fromDate + '&toDate=' + toDate;
            ;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var searchOrderBagItemsByQuery = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-order-bag-item';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var searchOrderBagItemsByQueryPagination = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-order-bag-item-page?sortDirection=desc';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var makeVideoCallLink = function (orderBagItemId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-video-link-by-order-bag-item-id?id=' + orderBagItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var createVideoMeeting = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/create-video-meeting';
            return $resource(resourceUrl, {}, {}
            );

        }

        var joinVideoMeeting = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/join-video-meeting';
            return $resource(resourceUrl, {}, {}
            );

        }

        var isMeetingRunning = function (orderbagitemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/is-meeting-running/' + orderbagitemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getMeetingUrl = function (orderbagitemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-meeting-url/' + orderbagitemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        var createVideoMeetingEvent = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/create-video-meeting-event';
            return $resource(resourceUrl, {}, {}
            );

        }

        var joinVideoMeetingEvent = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/join-video-meeting-event';
            return $resource(resourceUrl, {}, {}
            );

        }

        var isMeetingRunningEvent = function (serviceitemId, servantId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/is-meeting-running-event/' + serviceitemId + '/' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var makeVideoCallLinkEvent = function (serviceItemId, servantId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-video-link-by-service-item-id-and-servant-id?serviceItemId=' + serviceItemId + '&servantId=' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var editOrderBagServiceItem = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/edit-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        }


        var searchOrderBagItemsByQueryPage = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-order-bag-item-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var checkCapacityForItem = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/check-capacity-available-for-order-bag-item';
            return $resource(resourceUrl, {}, {}
            );

        }

        return {
            getReserveStats: getReserveStats,
            getOrderBagServiceItemWithEntities: getOrderBagServiceItemWithEntities,
            getActiveOrderBagServiceItems: getActiveOrderBagServiceItems,
            getActiveReserveCountsToBeShown: getActiveReserveCountsToBeShown,
            getOrderBagServiceItemByCompanyIdFromNow: getOrderBagServiceItemByCompanyIdFromNow,
            getAllOrderBagServiceItemByCurrentCompany: getAllOrderBagServiceItemByCurrentCompany,
            replaceTime: replaceTime,
            checkinOrderBagServieItem: checkinOrderBagServieItem,
            notCheckinOrderBagServieItem: notCheckinOrderBagServieItem,
            removeCheckinOrderBagServieItem: removeCheckinOrderBagServieItem,
            getOrderBagServiceItemByCompanyIdFromDateToDate: getOrderBagServiceItemByCompanyIdFromDateToDate,
            searchOrderBagItemsByQuery: searchOrderBagItemsByQuery,
            searchOrderBagItemsByQueryPagination: searchOrderBagItemsByQueryPagination,
            makeVideoCallLink: makeVideoCallLink,
            createVideoMeeting: createVideoMeeting,
            joinVideoMeeting: joinVideoMeeting,
            isMeetingRunning: isMeetingRunning,
            makeVideoCallLinkEvent: makeVideoCallLinkEvent,
            createVideoMeetingEvent: createVideoMeetingEvent,
            joinVideoMeetingEvent: joinVideoMeetingEvent,
            isMeetingRunningEvent: isMeetingRunningEvent,
            editOrderBagServiceItem: editOrderBagServiceItem,
            getMeetingUrl: getMeetingUrl,
            searchOrderBagItemsByQueryPage: searchOrderBagItemsByQueryPage,
            checkCapacityForItem: checkCapacityForItem
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('order-bag-service-item', {
                parent: 'entity',
                url: '/order-bag-service-item?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagServiceItem.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-items.html',
                        controller: 'OrderBagServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('order-bag-service-item-detail', {
                parent: 'entity',
                url: '/order-bag-service-item/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagServiceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-detail.html',
                        controller: 'OrderBagServiceItemDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagServiceItem', function ($stateParams, OrderBagServiceItem) {
                        return OrderBagServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('order-bag-service-item.new', {
                parent: 'order-bag-service-item',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-dialog.html',
                        controller: 'OrderBagServiceItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    status: null,
                                    subtotalServicePrice: null,
                                    subtotalOptionPrice: null,
                                    subtotalVAT: null,
                                    subtotalDiscount: null,
                                    totalRowPrice: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('order-bag-service-item', null, {reload: true});
                    }, function () {
                        $state.go('order-bag-service-item');
                    });
                }]
            })
            .state('order-bag-service-item.edit', {
                parent: 'order-bag-service-item',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-dialog.html',
                        controller: 'OrderBagServiceItemDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['OrderBagServiceItem', function (OrderBagServiceItem) {
                                return OrderBagServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag-service-item', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('order-bag-service-item.delete', {
                parent: 'supplierPanel.orderBag',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-delete-dialog.html',
                        controller: 'OrderBagServiceItemDeleteController',
                        controllerAs: 'vm',
                        size: 'md'
                        ,
                        resolve: {
                            entity: ['OrderBagServiceItem', function (OrderBagServiceItem) {
                                return OrderBagServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.orderBag', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('order-bag-service-item.list', {
                parent: 'entity',
                url: '/order-bag-service-item-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagServiceItem.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-list.html',
                        controller: 'OrderBagServiceItemListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


        ;
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagServiceItem', OrderBagServiceItem);

    OrderBagServiceItem.$inject = ['$resource'];

    function OrderBagServiceItem($resource) {
        var resourceUrl = 'api/order-bag-service-items/:id';
        //
        return $resource(resourceUrl, {}, {

            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OrderBagServiceItemSearch', OrderBagServiceItemSearch);

    OrderBagServiceItemSearch.$inject = ['$resource'];

    function OrderBagServiceItemSearch($resource) {
        var resourceUrl = 'api/_search/order-bag-service-items/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemController', OrderBagServiceItemController);

    OrderBagServiceItemController.$inject = ['$scope', '$state', 'OrderBagServiceItem', 'OrderBagServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrderBagServiceItemController($scope, $state, OrderBagServiceItem, OrderBagServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                OrderBagServiceItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderBagServiceItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagServiceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagItemOptionDialogController', OrderBagItemOptionDialogController);

    OrderBagItemOptionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBagItemOption', 'OrderBagServiceItemDtail', 'ServiceOptionItem'];

    function OrderBagItemOptionDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBagItemOption, OrderBagServiceItemDtail, ServiceOptionItem) {
        var vm = this;

        vm.orderBagItemOption = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.orderbagserviceitemdtails = OrderBagServiceItemDtail.query();
        vm.serviceoptionitems = ServiceOptionItem.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.orderBagItemOption.id !== null) {
                OrderBagItemOption.update(vm.orderBagItemOption, onSaveSuccess, onSaveError);
            } else {
                OrderBagItemOption.save(vm.orderBagItemOption, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagItemOptionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.reserveTime = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagItemOptionDetailController', OrderBagItemOptionDetailController);

    OrderBagItemOptionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OrderBagItemOption', 'OrderBagServiceItemDtail', 'ServiceOptionItem'];

    function OrderBagItemOptionDetailController($scope, $rootScope, $stateParams, entity, OrderBagItemOption, OrderBagServiceItemDtail, ServiceOptionItem) {
        var vm = this;

        vm.orderBagItemOption = entity;

        var unsubscribe = $rootScope.$on('tikonApp:orderBagItemOptionUpdate', function (event, result) {
            vm.orderBagItemOption = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagItemOptionDeleteController', OrderBagItemOptionDeleteController);

    OrderBagItemOptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderBagItemOption'];

    function OrderBagItemOptionDeleteController($uibModalInstance, entity, OrderBagItemOption) {
        var vm = this;

        vm.orderBagItemOption = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            OrderBagItemOption.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('order-bag-item-option', {
                parent: 'entity',
                url: '/order-bag-item-option?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagItemOption.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-item-option/order-bag-item-options.html',
                        controller: 'OrderBagItemOptionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagItemOption');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('order-bag-item-option-detail', {
                parent: 'entity',
                url: '/order-bag-item-option/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBagItemOption.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag-item-option/order-bag-item-option-detail.html',
                        controller: 'OrderBagItemOptionDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagItemOption');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagItemOption', function ($stateParams, OrderBagItemOption) {
                        return OrderBagItemOption.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('order-bag-item-option.new', {
                parent: 'order-bag-item-option',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-item-option/order-bag-item-option-dialog.html',
                        controller: 'OrderBagItemOptionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    reserveTime: null,
                                    qty: null,
                                    price: null,
                                    discount: null,
                                    vat: null,
                                    totalPrice: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('order-bag-item-option', null, {reload: true});
                    }, function () {
                        $state.go('order-bag-item-option');
                    });
                }]
            })
            .state('order-bag-item-option.edit', {
                parent: 'order-bag-item-option',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-item-option/order-bag-item-option-dialog.html',
                        controller: 'OrderBagItemOptionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['OrderBagItemOption', function (OrderBagItemOption) {
                                return OrderBagItemOption.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag-item-option', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('order-bag-item-option.delete', {
                parent: 'order-bag-item-option',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag-item-option/order-bag-item-option-delete-dialog.html',
                        controller: 'OrderBagItemOptionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['OrderBagItemOption', function (OrderBagItemOption) {
                                return OrderBagItemOption.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag-item-option', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagItemOption', OrderBagItemOption);

    OrderBagItemOption.$inject = ['$resource', 'DateUtils'];

    function OrderBagItemOption($resource, DateUtils) {
        var resourceUrl = 'api/order-bag-item-options/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reserveTime = DateUtils.convertDateTimeFromServer(data.reserveTime);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OrderBagItemOptionSearch', OrderBagItemOptionSearch);

    OrderBagItemOptionSearch.$inject = ['$resource'];

    function OrderBagItemOptionSearch($resource) {
        var resourceUrl = 'api/_search/order-bag-item-options/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagItemOptionController', OrderBagItemOptionController);

    OrderBagItemOptionController.$inject = ['$scope', '$state', 'OrderBagItemOption', 'OrderBagItemOptionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrderBagItemOptionController($scope, $state, OrderBagItemOption, OrderBagItemOptionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                OrderBagItemOptionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderBagItemOption.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagItemOptions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider


            .state('supplierPanel.upsertOrderBagNew', {
                parent: 'supplierPanel',
                url: '/new',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            .state('supplierPanel.editOrderBag', {
                parent: 'supplierPanel',
                url: '/{id}/editOrderBag',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/edit-order-bag.html',
                        controller: 'EditOrderBagController',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('orderBagServiceItemDtail');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');


                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagCustom', function ($stateParams, OrderBagCustom) {
                        return OrderBagCustom.getOrderBagWithEntities($stateParams.id).query();
                    }
                    ],
                    invoiceInfoEntity: ['$stateParams', 'InvoiceInfoCustom', function ($stateParams, InvoiceInfoCustom) {
                        return InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query();
                    }]

                }
            })
            .state('supplierPanel.newPaymentLog', {
                parent: 'supplierPanel',
                url: '/newPaymentLog',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog.html',
                        controller: 'OrderBagPaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['$stateParams', function ($stateParams) {
                                return {
                                    traceCode: null,
                                    paymentType: null,
                                    createDate: null,
                                    id: null,
                                    orderBagId: $stateParams.id
                                };
                            }]

                        }
                    }).result.then(function (result) {

                        $state.go('supplierPanel.editOrderBag', {id: result.orderBagId}, {reload: true});
                    }, function (result) {


                    });
                }]
            })


    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UpsertOrderBagController', UpsertOrderBagController);

    UpsertOrderBagController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal'];

    function UpsertOrderBagController($state, $timeout, $scope, entity, $stateParams, OrderBag, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal) {
        var vm = this;
        vm.scope = $scope;
        vm.orderBag = entity;
        vm.clear = clear;
        //vm.datePickerOpenStatus = {};
        //vm.openCalendar = openCalendar;
        vm.save = save;
        //vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        //vm.selectedServiceItem = null;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.findCustomer = findCustomer;
        vm.newCustomer = newCustomer;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.states = $stateParams;
        vm.formMode = 'new';
        vm.authorityRole = authorityRole;
        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            vm.isCustomerManager = has;
        });

        vm.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }
        vm.selectedCustomer = null;
        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        load();

        function load() {
            if ($stateParams.serviceItemId != null && $stateParams.serviceItemId != undefined) {
                vm.formMode = 'fromURL'
            }
            if ($stateParams.customerId != null && $stateParams.customerId != undefined) {
                vm.formMode = 'fromURLCustomer'
                findCustomerById($stateParams.customerId).then(function (result) {

                    if (result != null) {
                        vm.orderBag.customer = result;
                    }
                });


            }

        }


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function save() {

            //if(vm.scope.editForm.$valid) {

            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
            //}
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
            $state.transitionTo('supplierPanel.editOrderBag', {id: result.id});
            //$state.transitionTo('supplierPanel.orderBagList');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findCustomer() {

            vm.customerMode = "find";
            vm.orderBag.customer = {};
            if (vm.phoneNumberToFind != null && vm.phoneNumberToFind != undefined) {
                var c = CustomerCustom.getCustomerByPhoneNumber(vm.phoneNumberToFind).query();
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }

        function newCustomer() {
            vm.phoneNumberToFind = "";
            vm.orderBag.customer = {};
            vm.customerMode = "new";
            vm.myRole = "ROLE_USER";
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }

        function authorityRole() {
            if (vm.customerMode == 'new') {
                return "ROLE_USER";
            } else {
                return "ROLE_CUSTOMER_MANAGER";
            }
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagListController', OrderBagListController);

    OrderBagListController.$inject = ['$scope', '$state', 'OrderBagServiceItem', 'OrderBagServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$translate', 'OrderBagServiceItemCustom', 'formMode', 'ServiceItemCustom', '$mdDialog'];

    function OrderBagListController($scope, $state, OrderBagServiceItem, OrderBagServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, $translate, OrderBagServiceItemCustom, formMode, ServiceItemCustom, $mdDialog) {
        var vm = this;

        vm.formMode = formMode.mode;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.searchOrderBag = searchOrderBag;
        vm.getMonthCount = getMonthCount;
        vm.showSearchBoxOnMobile = showSearchBoxOnMobile;
        vm.searchBoxOnMobile = false;
        vm.serviceItem_changed = serviceItem_changed;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagServiceItemsQuery = [];
        vm.orderBagStatusList = null;
        vm.status_changed = status_changed;
        vm.orderBagStatus = "";
        vm.showDateSearch = showDateSearch;
        vm.showSearchByDates = false;
        vm.showSearchTextBoxOnMobile = showSearchTextBoxOnMobile;
        vm.searchTextBoxOnMobile = false;
        vm.searchOrderBagByQuery = searchOrderBagByQuery;
        vm.showIntakeData = showIntakeData;
        loaddata();

        var ShowIntakeDataDialogController = function ($scope, $mdDialog, dialogData) {
            var $ctrl = this;
            $ctrl.orderbag = dialogData;

        }
        ShowIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData'];

        function showIntakeData(orderbag) {
            $mdDialog.show({
                locals: {dialogData: orderbag},
                controller: ShowIntakeDataDialogController,
                templateUrl: 'app/entities/order-bag/intake-data-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: orderbag,
                clickOutsideToClose: true,
                fullscreen: false// Only for -

            })
                .then(function (answer) {

                }, function () {
                });
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();


        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }


        function loaddata() {
            if (vm.formMode == 'LoadAll') {
                loadAll();
            } else {
                vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromNow().query();
            }
            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query();
            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
        }

        function loadAll() {

            vm.orderBagServiceItems = OrderBagServiceItemCustom.getAllOrderBagServiceItemByCurrentCompany().query();
        }


        function searchOrderBag() {


            var fromDateTime = null;
            var toDateTime = null;

            if ((vm.fromDateFilter == null || vm.fromDateFilter == undefined)
                &&
                (vm.toDateFilter == null || vm.toDateFilter == undefined)
            ) {
                loaddata();
                return;
            }


            if (vm.fromDateFilter == null || vm.fromDateFilter == undefined)
                fromDateTime = new Date(2000, 1, 1);
            else
                fromDateTime = new Date(vm.fromDateFilter.toString());
            if (vm.toDateFilter == null || vm.toDateFilter == undefined)
                toDateTime = new Date(3000, 1, 1);
            else
                toDateTime = new Date(vm.toDateFilter.toString());


            fromDateTime.setUTCHours(0, 0, 0);
            toDateTime.setUTCHours(0, 0, 0);

            vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromDateToDate(fromDateTime.toISOString(), toDateTime.toISOString()).query();
            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;

            vm.searchBoxOnMobile = false;

        }

        function getMonthCount(orderBagServiceItem) {
            var count = 0;
            var fromDate = new Date(orderBagServiceItem.serviceTimeSession.startDate);
            var endDate = new Date(orderBagServiceItem.serviceTimeSession.endDate);
            while (fromDate < endDate) {
                count = count + 1;
                fromDate.setDate(fromDate.getDate() + (30));
            }

            return count;
        }

        function showSearchBoxOnMobile() {
            vm.searchBoxOnMobile = !vm.searchBoxOnMobile;
        }

        function serviceItem_changed() {

            filterItems();
        }

        function status_changed() {
            filterItems();
        }

        function filterItems() {

            vm.orderBagServiceItems = vm.orderBagServiceItemsQuery;
            if ((vm.serviceItemId == "" || vm.serviceItemId == undefined) && (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)) {
                return;
            }

            vm.orderBagServiceItems = vm.orderBagServiceItems.filter(function (item) {

                if (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)
                    return ((item.serviceItem.id == vm.serviceItemId));
                if (vm.serviceItemId == "" || vm.serviceItemId == undefined)
                    return ((item.orderBag.status == vm.orderBagStatus));

                return (item.orderBag.status == vm.orderBagStatus
                    &&
                    item.serviceItem.id == vm.serviceItemId
                );
            })
        }

        function showDateSearch() {
            vm.showSearchByDates = !vm.showSearchByDates;
        }

        function showSearchTextBoxOnMobile() {
            vm.searchTextBoxOnMobile = !vm.searchTextBoxOnMobile;
        }

        function searchOrderBagByQuery() {

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
            if (vm.searchQuery == null || vm.searchQuery == undefined || vm.searchQuery == "") {
                //vm.companyCustomerQueryList = vm.companyCustomers;
                return;
            }

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItemsQuery.filter(function (item) {

                return ((item.orderBag.customer.personalInfo.fisrtName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.lastName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.phoneNumber.includes(vm.searchQuery))
                    || (item.serviceItem.itemTitle.includes(vm.searchQuery))
                );
            })


        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagItemBottomSheetController', OrderBagItemBottomSheetController);

    OrderBagItemBottomSheetController.$inject = ['$mdBottomSheet', 'entity'];

    function OrderBagItemBottomSheetController($mdBottomSheet, entity) {
        var vm = this;

        vm.orderBagItem = entity.orderBagItem;
        vm.orderBag = entity.orderBag;
        vm.constStatus = entity.constStatus;
        vm.showReplaceTime = entity.showReplaceTime;

        vm.itemClick = itemClick;
        vm.close = close;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagDialogController', OrderBagDialogController);

    OrderBagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBag'];

    function OrderBagDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBag) {
        var vm = this;

        vm.orderBag = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagDetailController', OrderBagDetailController);

    OrderBagDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OrderBag'];

    function OrderBagDetailController($scope, $rootScope, $stateParams, entity, OrderBag) {
        var vm = this;

        vm.orderBag = entity;

        var unsubscribe = $rootScope.$on('tikonApp:orderBagUpdate', function (event, result) {
            vm.orderBag = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagDeleteController', OrderBagDeleteController);

    OrderBagDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderBag'];

    function OrderBagDeleteController($uibModalInstance, entity, OrderBag) {
        var vm = this;

        vm.orderBag = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            OrderBag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagBottomSheetController', OrderBagBottomSheetController);

    OrderBagBottomSheetController.$inject = ['$mdBottomSheet', 'entity'];

    function OrderBagBottomSheetController($mdBottomSheet, entity) {
        var vm = this;

        vm.orderBag = entity.orderBag;
        vm.invoiceInfo = entity.invoiceInfo;
        vm.mode = entity.mode; // MAIN_ACTIONS , OTHER_ACTIONS ,
        vm.constStatus = entity.constStatus;
        vm.resultStatus = entity.resultStatus;
        vm.canReApproveRequestToPay = entity.canReApproveRequestToPay;
        vm.canResendNotification = entity.canResendNotification;
        vm.canDeleteOrderBag = false;
        vm.canIssueInvoice = entity.canIssueInvoice;
        vm.showUseCredit = entity.showUseCredit;


        vm.itemClick = itemClick;
        vm.close = close;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagCustom', OrderBagCustom);

    OrderBagCustom.$inject = ['$resource', 'ENV'];

    function OrderBagCustom($resource, ENV) {


        var approveOrderBag = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/approve-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };
        var approveReserve = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/approve-reserve';
            return $resource(resourceUrl, {}, {}
            );
        };


        var getOrderBagWithEntities = function (OrderBagId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/order-bags-with-entities/' + OrderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var cancelOrderBag = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/cancel-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };
        var cancelReserve = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/cancel-reserve';
            return $resource(resourceUrl, {}, {}
            );
        };

        var checkin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/checkin-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };

        var notCheckin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/not-checkin-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };


        var canEditOrderBag = function (OrderBagId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/can-edit-order-bag?id=' + OrderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var removeCheckin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/remove-checkin-order-bag';
            return $resource(resourceUrl, {}, {}
            );
        };

        var confirmReserveRequestByOrderBagId = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/confirm-reserve-request-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };


        var computeFinalPrice = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/compute-orderbag-final-price';
            return $resource(resourceUrl, {}, {}
            );
        };
        var saveReserve = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/save-reserve';
            return $resource(resourceUrl, {}, {}
            );
        }
        var updateIntakeFormData = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/update-intake-form-data';
            return $resource(resourceUrl, {}, {}
            );

        }
        var getDefaultIntakeFormData = function (serviceid) {
            if (serviceid)
                var resourceUrl = ENV.API_BASE_URL + 'api/get-default-intakeformData-by-service/' + serviceid;
            return $resource(resourceUrl, {}, {}
            );
            return null;

        }

        var computeFinalPriceFixed = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/compute-orderbag-final-price-fixed';
            return $resource(resourceUrl, {}, {}
            );
        };

        var deleteOrderBagItem = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/delete-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };

        var reConfirmReserveRequestByOrderBagId = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/re-confirm-reserve-request-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var reSendNotificationByOrderBagId = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/re-send-notification-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        var deleteReserve = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/delete-reserve';
            return $resource(resourceUrl, {}, {}
            );
        };

        var logIntoServer = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/log-from-client';
            return $resource(resourceUrl, {}, {}
            );
        };

        var issueInvoiceInfoByOrderBagId = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/issue-invoice-info-by-order-bag-id';
            return $resource(resourceUrl, {}, {}
            );
        };

        return {
            saveReserve: saveReserve,
            approveOrderBag: approveOrderBag,
            getOrderBagWithEntities: getOrderBagWithEntities,
            cancelOrderBag: cancelOrderBag,
            checkin: checkin,
            notCheckin: notCheckin,
            canEditOrderBag: canEditOrderBag,
            removeCheckin: removeCheckin,
            confirmReserveRequestByOrderBagId: confirmReserveRequestByOrderBagId,
            computeFinalPrice: computeFinalPrice,
            approveReserve: approveReserve,
            cancelReserve: cancelReserve,
            updateIntakeFormData: updateIntakeFormData,
            getDefaultIntakeFormData: getDefaultIntakeFormData,
            computeFinalPriceFixed: computeFinalPriceFixed,
            deleteOrderBagItem: deleteOrderBagItem,
            reConfirmReserveRequestByOrderBagId: reConfirmReserveRequestByOrderBagId,
            reSendNotificationByOrderBagId: reSendNotificationByOrderBagId,
            deleteReserve: deleteReserve,
            logIntoServer: logIntoServer,
            issueInvoiceInfoByOrderBagId: issueInvoiceInfoByOrderBagId

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('order-bag', {
                parent: 'entity',
                url: '/order-bag?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag/order-bags.html',
                        controller: 'OrderBagController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('order-bag-detail', {
                parent: 'entity',
                url: '/order-bag/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag/order-bag-detail.html',
                        controller: 'OrderBagDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBag', function ($stateParams, OrderBag) {
                        return OrderBag.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('order-bag.new', {
                parent: 'order-bag',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag/order-bag-dialog.html',
                        controller: 'OrderBagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('order-bag', null, {reload: true});
                    }, function () {
                        $state.go('order-bag');
                    });
                }]
            })
            .state('order-bag.edit', {
                parent: 'order-bag',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag/order-bag-dialog.html',
                        controller: 'OrderBagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['OrderBag', function (OrderBag) {
                                return OrderBag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('order-bag.delete', {
                parent: 'order-bag',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/order-bag/order-bag-delete-dialog.html',
                        controller: 'OrderBagDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['OrderBag', function (OrderBag) {
                                return OrderBag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('order-bag', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })


        ;
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBag', OrderBag);

    OrderBag.$inject = ['$resource', 'DateUtils', 'ENV'];

    function OrderBag($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/order-bags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OrderBagSearch', OrderBagSearch);

    OrderBagSearch.$inject = ['$resource', 'ENV'];

    function OrderBagSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/order-bags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagController', OrderBagController);

    OrderBagController.$inject = ['$scope', '$state', 'OrderBag', 'OrderBagSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrderBagController($scope, $state, OrderBag, OrderBagSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                OrderBagSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderBag.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBags = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EditOrderBagV2Controller', EditOrderBagV2Controller);

    EditOrderBagV2Controller.$inject = ['$rootScope', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSessionCustom', 'CustomerCustom', '$translate', 'invoiceInfoEntity', 'OrderBagCustom', '$uibModal', 'OrderBagServiceItemCustom', 'InvoiceInfoCustom', 'ScheduleInfoCustom', 'CompanyInfoQuery', '$window', 'DEFAULT_VIDEO_CALL_URL', 'DialogService', '$mdDialog', '$state', 'PaymentLogCustom', 'PaymentLog', 'CompanyCustomerCustom', 'Principal', 'Servant', '$mdBottomSheet', 'DateUtils', '$resource', 'ENV', '$mdMedia'];

    function EditOrderBagV2Controller($rootScope, $timeout, $scope, entity, $stateParams, OrderBag, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSessionCustom, CustomerCustom, $translate, invoiceInfoEntity, OrderBagCustom, $uibModal, OrderBagServiceItemCustom, InvoiceInfoCustom, ScheduleInfoCustom, CompanyInfoQuery, $window, DEFAULT_VIDEO_CALL_URL, DialogService, $mdDialog, $state, PaymentLogCustom, PaymentLog, CompanyCustomerCustom, Principal, Servant, $mdBottomSheet, DateUtils, $resource, ENV, $mdMedia) {
        var vm = this;

        vm.orderBag = entity;

        // })
        vm.invoiceInfo = invoiceInfoEntity;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.findBalanceStyle = findBalanceStyle;

        vm.clear = clear;
        vm.save = save;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.hasParticipant = hasParticipant;
        vm.approveOrderBag = approveOrderBag;
        vm.cancelOrderBag = cancelOrderBag;
        vm.isBalanced = isBalanced;
        vm.constStatus = {};
        vm.constStatus.confirmed = 1;
        vm.constStatus.canceled = 4;
        vm.constStatus.reserveRequest = 5;
        vm.constStatus.requestConfirm = 6;
        vm.timeDiff = timeDiff;
        //vm.checkin = checkin;
        //vm.removeCheckIn = removeCheckIn;
        vm.removeCheckinOrderBagServieItem = removeCheckinOrderBagServieItem;
        vm.checkinOrderBagServieItem = checkinOrderBagServieItem;
        vm.notCheckinOrderBagServieItem = notCheckinOrderBagServieItem;
        vm.replaceTime = replaceTime;
        vm.insertPayment = insertPayment;
        vm.confirmReserveRequest = confirmReserveRequest;
        vm.showTimePeriod = showTimePeriod;
        vm.showReplaceTime = true;
        vm.goToVideoCall = goToVideoCall;
        vm.deleteOrderBagItem = deleteOrderBagItem;
        vm.canDeleteItem = false;
        vm.settlementInvoice = settlementInvoice;
        vm.deletePaymentLog = deletePaymentLog;
        vm.openMenu = openMenu;
        vm.originatorEv = null;
        vm.canReApproveRequestToPay = false;
        vm.canResendNotification = false;
        vm.reConfirmReserveRequest = reConfirmReserveRequest;
        vm.reSendNotification = reSendNotification;
        vm.goToCustomerDetail = goToCustomerDetail;
        vm.companyCustomer = null;
        vm.canDeleteOrderBag = false;
        vm.issueInvoiceInfo = issueInvoiceInfo;
        vm.findInvoiceStatusStyle = findInvoiceStatusStyle;
        vm.canEditPaymentLog = canEditPaymentLog;
        vm.viewInvoiceInfo = viewInvoiceInfo;
        vm.showWithdrawFromWalletModal = showWithdrawFromWalletModal;
        vm.showPosPayment = showPosPayment;

        vm.closeModal = closeModal;

        vm.openBottomSheet = openBottomSheet;
        vm.deleteOrderBag = deleteOrderBag;
        vm.hasInvoiceFeature = false;
        vm.showPriceTitle = false;

        // tags
        vm.metaTags = []
        vm.defaultTags = []
        vm.tags = []

        vm.newTag = null

        vm.saveTagsLoading = false
        vm.getTagsLoading = false
        vm.insertTag = insertTag
        vm.deleteTag = deleteTag
        vm.resetTag = resetTag
        vm.resetTag = resetTag
        vm.gotToTags = gotToTags
        vm.selectedTagChanged = selectedTagChanged
        vm.managerApprovalStatus = ""

        function getMetaTags() {

            var resourceUrl = ENV.API_BASE_URL + "api/v2/order-bags/meta-tags";

            $resource(resourceUrl, {}, {'query': {method: 'GET', isArray: true}}).query(function (data) {
                vm.metaTags = data
            })

        }

        function getOrderBagTags() {
            var resourceUrl = ENV.API_BASE_URL + "api/v2/order-bags/" + $stateParams.id + "/tags";

            $resource(resourceUrl, {}, {'query': {method: 'GET', isArray: true}}).query(function (data) {
                vm.tags = JSON.parse(JSON.stringify(data))
                vm.defaultTags = JSON.parse(JSON.stringify(data))
                vm.getTagsLoading = false
            })

        }


        getOrderBagTags()
        getMetaTags()


        function insertTag(tag) {

            if (vm.saveTagsLoading) return null
            vm.saveTagsLoading = true

            var saveTagsService = function () {
                var resourceUrl = ENV.API_BASE_URL + "api/v2/order-bags/" + $stateParams.id + "/tags"
                return $resource(resourceUrl, {}, {
                        update: {method: "PUT", isArray: true},

                    }
                );
            }

            var body = vm.tags.map(function (item) {
                return item.id
            })


            function onSaveSuccessTag(response) {
                vm.tags = response
                vm.defaultTags = response
                vm.newTag = ""
                vm.saveTagsLoading = false
            }

            function onSaveError() {
                vm.saveTagsLoading = false

            }


            saveTagsService().update(body, onSaveSuccessTag, onSaveError);


        }


        function deleteTag(index, tag) {
            vm.tags.splice(index, 1)
        }

        function resetTag() {
            vm.tags = JSON.parse(JSON.stringify(vm.defaultTags))
        }

        function gotToTags(id) {
            document.querySelector(id).scrollIntoView();
        }

        function selectedTagChanged(selectedItem) {
            if (vm.tags.find(function (item) {
                return item.id === vm.newTag.id
            })) return vm.newTag = null
            vm.tags.push(vm.newTag)
            vm.newTag = null
        }

        //

        $rootScope.$broadcast('hideNavBar');

        load();
        canEditOrderBag();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        $scope.$watch('vm.orderBag.orderBagServiceItems', function (ob) {

            if (ob != null) {
                if (ob != null && ob != undefined && ob.length > 0) {
                    canReplaceTime(ob[0].serviceItem.id);
                }
            }
        })

        $scope.$watch('vm.orderBag.status', function (s) {

            if (s != null) {
                checkOtherActions();
            }
        })


        function load() {
            hasInvoiceFeature();
            hasAdvancedPricingFeature();
        }

        function hasInvoiceFeature() {
            var result;

            result = Principal.hasSpecialFeatureAccess("invoice");
            if (result) {
                vm.hasInvoiceFeature = true;
                return;
            } else {
                vm.hasInvoiceFeature = false;
            }


        }

        function hasAdvancedPricingFeature() {
            var result;

            result = Principal.hasSpecialFeatureAccess("advancedPricing");
            if (result) {
                vm.showPriceTitle = true;
                return;
            }

            vm.showPriceTitle = false;
        }

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }


        function save() {

            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findStatusTitle(status) {
            var result = "";

            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-box-" + status;
        }

        function findInvoiceStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }

        function hasParticipant() {
            var hasPP = false;

            angular.forEach(vm.orderBag.orderBagServiceItems, function (v) {
                angular.forEach(v.participantPersons, function (p) {
                    hasPP = true;
                });
            });


            return hasPP;
        }

        function approveOrderBag() {

            if (vm.orderBag.id != null)
                OrderBagCustom.approveReserve().save(vm.orderBag.id, onApproveSucces, onApproveError);
            //OrderBagCustom.approveOrderBag().save(vm.orderBag.id, onApproveSucces, onApproveError);
        }

        function onApproveSucces(result) {

            reload();
        }

        function onApproveError() {

        }

        function cancelOrderBag() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("آیا از لغو اطمینان دارید ؟").then(function () {
                    OrderBagCustom.cancelReserve().save(vm.orderBag.id, onCancelSucces, onCancelError);

                });
            }
        }

        function onCancelSucces(result) {

            reload();
        }

        function onCancelError() {

        }

        function deleteOrderBag() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("آیا از حذف اطمینان دارید ؟").then(function () {
                    OrderBagCustom.deleteReserve().save(vm.orderBag.id, onDeleteSuccess, onDeleteError);

                });
            }
        }

        function onDeleteSuccess(result) {
            closeModal();
        }

        function onDeleteError() {

        }
        function reload() {
            OrderBagCustom.getOrderBagWithEntities($stateParams.id).query(function (data) {
                vm.orderBag = data;
            });
            InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query(function (data) {
                vm.invoiceInfo = data;
            });
            // getOrderBagTags();
            canEditOrderBag();

        }

        //function checkin()
        //{
        //
        //    if(vm.orderBag.id!=null )
        //    {
        //        OrderBagCustom.checkin().save(vm.orderBag.id,onCancelSucces,onCancelError);
        //    }
        //}

        function checkinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.checkinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function notCheckinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.notCheckinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function canEditOrderBag() {
            OrderBagCustom.canEditOrderBag($stateParams.id).query(function (data) {
                vm.resultStatus = data;
            });

        }

        //function removeCheckIn()
        //{
        //    if(vm.orderBag.id!=null ) {
        //        OrderBagCustom.removeCheckin().save(vm.orderBag.id,onSuccess,onError);
        //    }
        //}
        function removeCheckinOrderBagServieItem(orderBagServiceItemId) {
            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.removeCheckinOrderBagServieItem().save(orderBagServiceItemId, onSuccess, onError);
            }
        }

        function onSuccess() {
            reload();
        }

        function onError() {

        }

        function isBalanced() {
            return (vm.orderBag.remainAmount == 0);

        }

        function findBalanceStyle() {
            if (vm.orderBag.remainAmount == 0) {
                return "panel-success";
            } else {
                return "panel-danger";
            }
        }

        function replaceTime(orderBagItem) {

            // $mdDialog.show({
            //     templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
            //     controller: 'EditOrderBagServiceItemComponentController',
            //     controllerAs: '$ctrl',
            //     backdrop: 'static',
            //     size: 'lg',
            //     resolve: {
            //         entity: function () {
            //             return {
            //                 orderBagItem: orderBagItem
            //             };
            //
            //         }
            //     },
            //     clickOutsideToClose: true
            // }).then(function (v) {
            //
            //     if(v)
            //     {
            //         orderBagItem.serviceTimeSession = v.serviceTimeSession;
            //         Servant.get({id : v.servant.id}).$promise.then(function (result) {
            //             orderBagItem.servant = result;
            //         });
            //         canEditOrderBag();
            //     }
            //
            // }, function () {
            //     //nothing
            // });
            //


            $uibModal.open({
                templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item-v2.html',
                controller: 'EditOrderBagServiceItemComponentController',
                controllerAs: '$ctrl',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: function () {
                        return {
                            orderBagItem: orderBagItem
                        };

                    }
                },
                clickOutsideToClose: true
            }).result.then(function (v) {

                if (v) {
                    orderBagItem.serviceTimeSession = v.serviceTimeSession;
                    Servant.get({id: v.servant.id}).$promise.then(function (result) {
                        orderBagItem.servant = result;
                    });
                    canEditOrderBag();
                }
                //reload();
                // $uibModalInstance.close(result);
            }, function () {
                //nothing
                // $uibModalInstance.close(result);
            });

        }

        function insertPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog-v2.html',
                controller: 'OrderBagPaymentLogDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            traceCode: null,
                            paymentType: null,
                            createDate: null,
                            id: null,
                            orderBagId: $stateParams.id
                        };
                    }]
                }
            }).result.then(function (v) {

                vm.invoiceInfo.paymentLogs.push({
                    id: v.id,
                    traceCode: v.traceCode,
                    paymentType: v.paymentType,
                    createDate: v.createDate,
                    amount: v.amount,
                    moreInfo: v.moreInfo
                });

                vm.orderBag.remainAmount -= v.amount;
                //reload();
            }, function () {
                //nothing
            });
        }

        function confirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.confirmReserveRequestByOrderBagId().save(vm.orderBag.id, onConfirmReserveSuccess, onConfirmReserveError);

                });
            }
        }

        function onConfirmReserveSuccess(result) {

            reload();
        }

        function onConfirmReserveError() {

        }

        function timeDiff(orderBagItem) {

            var d1 = new Date(orderBagItem.serviceTimeSession.endTime);
            var d2 = new Date(orderBagItem.serviceTimeSession.startTime);
            var min = 1000 * 60;
            //orderBagItem.timePeriod = (d1 - d2) / min;
            orderBagItem.timePeriod = 60;
        }

        function showTimePeriod(orderBagItemDtail, orderBagItem) {
            if (orderBagItem.startDate == orderBagItem.endDate && orderBagItemDtail.timeUnitQty > 1)
                return true;

            return false;

        }

        function canReplaceTime(serviceItemId) {

            // ScheduleInfoCustom.getCurrentScheduleInfoByServiceItem(serviceItemId).query().$promise.then(function (result) {
            //
            //     if (result.scheduleType == 'FLOAT_TIME_SESSIONS')
            //         vm.showReplaceTime = false;
            // })

            // var canReplaceTime = false;
            // //check servant is in serviceSeravnt list
            // ServiceItemCustom.getServiceServants(vm.orderBagServiceItem.serviceItemId).query(function (servants) {
            //     var servantid =  vm.orderBagServiceItem.serv;
            //     angular.forEach(servants, function (s) {
            //         if (servantid == s.id) {
            //             $ctrl.canReplaceTime = true;
            //         }
            //
            //     });
            // });

            vm.showReplaceTime = true;
        }

        function goToVideoCall(orderBagItem) {


            // $state.go('supplierPanel.joinVideoMeeting', {
            //     id: orderBagItem.id
            // });

            $mdDialog.show({
                controller: 'JoinVideoMeetingComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem
                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function deleteOrderBagItem(itemId) {
            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID')) {
                DialogService.showAlert("به دلیل صدور فاکتور امکان حذف وجود ندارد");
                return;
            } else {

                if (itemId != null) {
                    DialogService.showConfirmV2("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                        OrderBagCustom.deleteOrderBagItem().save(itemId, onDeleteItemSuccess, onDeleteItemError);

                    });
                }
            }
        }

        function onDeleteItemSuccess(result) {
            reload();
        }

        function onDeleteItemError() {

        }

        function settlementInvoice() {

            if (vm.orderBag.remainAmount == 0 || vm.orderBag.finalPrice == 0)
                return;

            var paymentLog = {};
            paymentLog.amount = vm.orderBag.remainAmount;
            paymentLog.paymentType = 'UNKNOWN';
            paymentLog.orderBagId = vm.orderBag.id;

            PaymentLogCustom.createPaymentLogByOrderBagId().save(paymentLog, onSettlementSaveSuccess, onSettlementSaveError);


        }

        function onSettlementSaveSuccess(result) {
            vm.invoiceInfo.paymentLogs.push({
                id: result.id,
                traceCode: result.traceCode,
                paymentType: result.paymentType,
                createDate: result.createDate,
                amount: result.amount,
            });

            vm.orderBag.remainAmount -= result.amount;
        }

        function onSettlementSaveError() {

        }

        function deletePaymentLog(paymentLog) {
            if(paymentLog.managerApprovalStatus === 'CHECKING' || paymentLog.managerApprovalStatus === 'DENIED' || paymentLog.managerApprovalStatus === 'APPROVED') return
            if (paymentLog != null) {
                if (paymentLog.paymentType == 'ONLINE')
                    return;

                DialogService.showConfirmV2("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    PaymentLogCustom.deletePaymentLogById().delete({id: paymentLog.id},
                        function () {
                            reload();
                        });

                });
            }
        }

        function openMenu($mdOpenMenu, ev) {
            vm.originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function checkOtherActions() {
            if (!vm.orderBag || !vm.orderBag.status)
                return;
            vm.showOtherActionsButton = true;

            switch (vm.orderBag.status) {

                case vm.constStatus.confirmed :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.canceled :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.reserveRequest :
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = false;
                    vm.showOtherActionsButton = false;
                    break;
                case vm.constStatus.requestConfirm:
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = true;
                    break;
            }

            if (vm.orderBag.finalPrice == 0)
                vm.canReApproveRequestToPay = false;

        }


        function reConfirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.reConfirmReserveRequestByOrderBagId().save(vm.orderBag.id, onReConfirmReserveSuccess, onReConfirmReserveError);

                });
            }
        }

        function onReConfirmReserveSuccess(result) {

            reload();
        }

        function onReConfirmReserveError() {

        }

        function reSendNotification() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("ارسال مجدد پیام را تایید می فرمایید ؟").then(function () {
                    OrderBagCustom.reSendNotificationByOrderBagId().save(vm.orderBag.id, function (result) {
                        // reload();
                    });

                });
            }
        }

        function goToCustomerDetail() {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(vm.orderBag.customer.id).query().$promise.then(onGetSuccess);
                    }
                });
        }

        function onGetSuccess(result) {
            vm.companyCustomer = result;
            $state.go('supplierPanel-v2.editOrderBag.editCompanyCustomer', {id: vm.companyCustomer.id});

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if($rootScope.fromState.name === "supplierPanel-v2.editOrderBag.editCompanyCustomer") {
                 $state.go('supplierPanel-v2.reserveList');
            }
            else if($rootScope.fromState.name === "supplierPanel-v2.companyApprovalPaymentLogListV2") {
                $state.go($rootScope.fromState.name, $rootScope.fromStateParams)
            }else if($rootScope.fromState.name === "supplierPanel-v2.calendar-v2" || $rootScope.fromState.name === "supplierPanel-v2.calendar") {
                $state.go($rootScope.fromState.name, $rootScope.fromStateParams)
            }
            else
                $state.go('supplierPanel-v2.reserveList', $rootScope.fromStateParams);
        }


        vm.mainActions = function () {
            openBottomSheet('MAIN_ACTIONS');
        }
        vm.otherActions = function () {
            openBottomSheet('OTHER_ACTIONS');
        }

        vm.correctedTime = function (time) {
            //FUCK REGIME !!!!!!!!!!
            //Check Date - 6 month of the year
            var pDate = DateUtils.convertToPersianDate(time);
            time = new Date(time);
            if (pDate.getMonth() < 7) {
                time = new Date(time.setHours(time.getHours() - 1));
            }
            return time.toISOString();
        }

        function openBottomSheet(mode) {

            $mdBottomSheet.show({
                templateUrl: 'app/entities/order-bag/order-bag-bottom-sheet-template.html',
                controller: 'OrderBagBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: (function () {
                        return {
                            orderBag: vm.orderBag,
                            invoiceInfo: vm.invoiceInfo,
                            mode: mode,
                            constStatus: vm.constStatus,
                            resultStatus: vm.resultStatus,
                            canReApproveRequestToPay: vm.canReApproveRequestToPay,
                            canResendNotification: vm.canResendNotification,
                            canIssueInvoice: vm.hasInvoiceFeature,
                            showUseCredit: vm.orderBag.remainAmount > 0 && vm.canEditPaymentLog()
                        };
                    })


                },
            }).then(function (result) {
                switch (result) {
                    case 'approveOrderBag':
                        approveOrderBag();
                        break;
                    case 'confirmReserveRequest':
                        confirmReserveRequest();
                        break;
                    case 'cancelOrderBag':
                        cancelOrderBag();
                        break;
                    case 'settlementInvoice':
                        settlementInvoice();
                        break;
                    case 'insertPayment':
                        insertPayment();
                        break;
                    case 'reConfirmReserveRequest':
                        reConfirmReserveRequest();
                        break;
                    case 'reSendNotification':
                        reSendNotification();
                        break;
                    case 'deleteOrderBag':
                        deleteOrderBag();
                        break;
                    case 'issueInvoiceInfo':
                        issueInvoiceInfo();
                        break;
                    case 'viewInvoiceInfo':
                        viewInvoiceInfo();
                        break;
                    case 'useCredit':
                        showWithdrawFromWalletModal();
                        break;
                    case 'usePosPayment':
                        showPosPayment();
                        break;

                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

        vm.openOrderBagItemBottomSheet = function (orderBagItem) {
            $mdBottomSheet.show({
                templateUrl: 'app/entities/order-bag/order-bag-item-bottom-sheet-template.html',
                controller: 'OrderBagItemBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem,
                            orderBag: vm.orderBag,
                            constStatus: vm.constStatus,
                            showReplaceTime: vm.showReplaceTime
                        };
                    })


                },
            }).then(function (result) {
                switch (result) {
                    case 'deleteOrderBagItem':
                        deleteOrderBagItem(orderBagItem.id);
                        break;
                    case 'replaceTime':
                        replaceTime(orderBagItem);
                        break;
                    case 'notCheckinOrderBagServieItem':
                        notCheckinOrderBagServieItem(orderBagItem.id);
                        break;
                    case 'checkinOrderBagServieItem':
                        checkinOrderBagServieItem(orderBagItem.id);
                        break;
                    case 'goToVideoCall':
                        goToVideoCall(orderBagItem);
                        break;

                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }
        

        function issueInvoiceInfo() {

            console.log(vm.hasInvoiceFeature);
            if (!vm.hasInvoiceFeature) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            OrderBagCustom.issueInvoiceInfoByOrderBagId().save(vm.orderBag.id, onIssueInvoiceSuccess, onIssueInvoiceError);

            function onIssueInvoiceSuccess(result) {

                $state.transitionTo('supplierPanel-v2.editInvoiceInfo', {id: result.id});
            }

            function onIssueInvoiceError(result) {

            }

        }

        function canEditPaymentLog(paymentLog) {


            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID'))
                return false;

            if (paymentLog && paymentLog.paymentType == 'ONLINE')
                return false;

            return true;
        }

        function viewInvoiceInfo() {
            if (vm.invoiceInfo.status && vm.invoiceInfo.status == 'TEMP')
                $state.transitionTo('supplierPanel-v2.editInvoiceInfo', {id: vm.invoiceInfo.id});
            else
                $state.transitionTo('supplierPanel-v2.invoiceInfoDetail', {id: vm.invoiceInfo.id});
        }

        $scope.calcManagerApprovalStatus = function(status) {
             switch(status) {
                case 'APPROVED': return 'تایید شده';
                case 'DENIED': return 'رد شده';
                case 'CHECKING': return 'درحال بررسی';
                default: return '';
            }
        };
        $scope.getStatusClass = function(status) {
            switch(status) {
                case 'APPROVED': return 'status-approved';
                case 'DENIED': return 'status-denied';
                case 'CHECKING': return 'status-chicking';
                default: return 'status-unknown';
            }
        };
        $scope.getDynamicStyleRemoveIcon = function(paymentLog) {
            var color = "red";
            if(paymentLog.managerApprovalStatus === 'CHECKING' || paymentLog.managerApprovalStatus === 'DENIED' || paymentLog.managerApprovalStatus === 'APPROVED' || paymentLog.onlineGateway === 'WALLET_CUSTOMER_WEB')
                color = 'unset';
            
            if(!vm.canEditPaymentLog(paymentLog))
                color = "unset";
            return {
                color: color
            };
        };

        function showWithdrawFromWalletModal() {
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/wallet/wallet-withdraw-balance-dialog.html',
                controller: ['$scope', 'customerId', 'withdrawAmount', 'orderBagId', function ($scope, customerId, withdrawAmount, orderBagId) {
                    $scope.customerId = customerId;
                    $scope.withdrawAmount = withdrawAmount;
                    $scope.orderBagId = orderBagId;
                }],
                locals: {
                    customerId: vm.orderBag.customer.id,
                    withdrawAmount: vm.orderBag.remainAmount,
                    orderBagId: vm.orderBag.id
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (res) {
                if (res) {
                    reload()
                    // onSettlementSaveSuccess(res)
                }
            });
        }

        function showPosPayment(){
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/pos-payment/pos-payment-dialog.html',
                controller: ['$scope', 'customerId', 'totalAmount', 'invoiceInfoId', 'posDeviceId', function ($scope, customerId, totalAmount, invoiceInfoId, posDeviceId) {
                    $scope.customerId = customerId;
                    $scope.totalAmount = totalAmount;
                    $scope.invoiceInfoId = invoiceInfoId;
                    $scope.posDeviceId = posDeviceId
                }],
                locals: {
                    customerId: vm.orderBag.customer.id,
                    totalAmount: vm.orderBag.remainAmount,
                    invoiceInfoId: vm.invoiceInfo.id,
                    posDeviceId: 123456
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (res) {
                if (res) {
                    reload()
                    // onSettlementSaveSuccess(res)
                }
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EditOrderBagController', EditOrderBagController);

    EditOrderBagController.$inject = ['$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSessionCustom', 'CustomerCustom', '$translate', 'invoiceInfoEntity', 'OrderBagCustom', '$uibModal', 'OrderBagServiceItemCustom', 'InvoiceInfoCustom', 'ScheduleInfoCustom', 'CompanyInfoQuery', '$window', 'DEFAULT_VIDEO_CALL_URL', 'DialogService', '$mdDialog', '$state', 'PaymentLogCustom', 'PaymentLog', 'CompanyCustomerCustom', 'Principal', 'Servant'];

    function EditOrderBagController($timeout, $scope, entity, $stateParams, OrderBag, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSessionCustom, CustomerCustom, $translate, invoiceInfoEntity, OrderBagCustom, $uibModal, OrderBagServiceItemCustom, InvoiceInfoCustom, ScheduleInfoCustom, CompanyInfoQuery, $window, DEFAULT_VIDEO_CALL_URL, DialogService, $mdDialog, $state, PaymentLogCustom, PaymentLog, CompanyCustomerCustom, Principal, Servant) {
        var vm = this;

        vm.orderBag = entity;

        // })
        vm.invoiceInfo = invoiceInfoEntity;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.findBalanceStyle = findBalanceStyle;

        vm.clear = clear;
        vm.save = save;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.hasParticipant = hasParticipant;
        vm.approveOrderBag = approveOrderBag;
        vm.cancelOrderBag = cancelOrderBag;
        vm.isBalanced = isBalanced;
        vm.constStatus = {};
        vm.constStatus.confirmed = 1;
        vm.constStatus.canceled = 4;
        vm.constStatus.reserveRequest = 5;
        vm.constStatus.requestConfirm = 6;
        vm.timeDiff = timeDiff;
        //vm.checkin = checkin;
        //vm.removeCheckIn = removeCheckIn;
        vm.removeCheckinOrderBagServieItem = removeCheckinOrderBagServieItem;
        vm.checkinOrderBagServieItem = checkinOrderBagServieItem;
        vm.notCheckinOrderBagServieItem = notCheckinOrderBagServieItem;
        vm.replaceTime = replaceTime;
        vm.insertPayment = insertPayment;
        vm.confirmReserveRequest = confirmReserveRequest;
        vm.showTimePeriod = showTimePeriod;
        vm.showReplaceTime = true;
        vm.goToVideoCall = goToVideoCall;
        vm.deleteOrderBagItem = deleteOrderBagItem;
        vm.canDeleteItem = false;
        vm.settlementInvoice = settlementInvoice;
        vm.deletePaymentLog = deletePaymentLog;
        vm.openMenu = openMenu;
        vm.originatorEv = null;
        vm.canReApproveRequestToPay = false;
        vm.canResendNotification = false;
        vm.reConfirmReserveRequest = reConfirmReserveRequest;
        vm.reSendNotification = reSendNotification;
        vm.goToCustomerDetail = goToCustomerDetail;
        vm.companyCustomer = null;

        canEditOrderBag();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        $scope.$watch('vm.orderBag.orderBagServiceItems', function (ob) {

            if (ob != null) {
                if (ob != null && ob != undefined && ob.length > 0) {
                    canReplaceTime(ob[0].serviceItem.id);
                }
            }
        })

        $scope.$watch('vm.orderBag.status', function (s) {

            if (s != null) {
                checkOtherActions();
            }
        })


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }


        function save() {

            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findStatusTitle(status) {
            var result = "";

            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function hasParticipant() {
            var hasPP = false;

            angular.forEach(vm.orderBag.orderBagServiceItems, function (v) {
                angular.forEach(v.participantPersons, function (p) {
                    hasPP = true;
                });
            });


            return hasPP;
        }

        function approveOrderBag() {

            if (vm.orderBag.id != null)
                OrderBagCustom.approveReserve().save(vm.orderBag.id, onApproveSucces, onApproveError);
            //OrderBagCustom.approveOrderBag().save(vm.orderBag.id, onApproveSucces, onApproveError);
        }

        function onApproveSucces(result) {

            reload();
        }

        function onApproveError() {

        }

        function cancelOrderBag() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("آیا از لغو اطمینان دارید ؟").then(function () {
                    OrderBagCustom.cancelReserve().save(vm.orderBag.id, onCancelSucces, onCancelError);

                });
            }
        }

        function onCancelSucces(result) {

            reload();
        }

        function onCancelError() {

        }

        function reload() {
            OrderBagCustom.getOrderBagWithEntities($stateParams.id).query(function (data) {

                vm.orderBag = data;

            });
            InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query(function (data) {
                vm.invoiceInfo = data;
            });
            canEditOrderBag();

        }

        //function checkin()
        //{
        //
        //    if(vm.orderBag.id!=null )
        //    {
        //        OrderBagCustom.checkin().save(vm.orderBag.id,onCancelSucces,onCancelError);
        //    }
        //}

        function checkinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.checkinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function notCheckinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.notCheckinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function canEditOrderBag() {

            OrderBagCustom.canEditOrderBag($stateParams.id).query(function (data) {
                vm.resultStatus = data;
            });

        }

        //function removeCheckIn()
        //{
        //    if(vm.orderBag.id!=null ) {
        //        OrderBagCustom.removeCheckin().save(vm.orderBag.id,onSuccess,onError);
        //    }
        //}
        function removeCheckinOrderBagServieItem(orderBagServiceItemId) {
            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.removeCheckinOrderBagServieItem().save(orderBagServiceItemId, onSuccess, onError);
            }
        }

        function onSuccess() {
            reload();
        }

        function onError() {

        }

        function isBalanced() {
            return (vm.orderBag.remainAmount == 0);

        }

        function findBalanceStyle() {
            if (vm.orderBag.remainAmount == 0) {
                return "panel-success";
            } else {
                return "panel-danger";
            }
        }

        function replaceTime(orderBagItem) {

            // $mdDialog.show({
            //     templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
            //     controller: 'EditOrderBagServiceItemComponentController',
            //     controllerAs: '$ctrl',
            //     backdrop: 'static',
            //     size: 'lg',
            //     resolve: {
            //         entity: function () {
            //             return {
            //                 orderBagItem: orderBagItem
            //             };
            //
            //         }
            //     },
            //     clickOutsideToClose: true
            // }).then(function (v) {
            //
            //     if(v)
            //     {
            //         orderBagItem.serviceTimeSession = v.serviceTimeSession;
            //         Servant.get({id : v.servant.id}).$promise.then(function (result) {
            //             orderBagItem.servant = result;
            //         });
            //         canEditOrderBag();
            //     }
            //
            // }, function () {
            //     //nothing
            // });
            //


            $uibModal.open({
                templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
                controller: 'EditOrderBagServiceItemComponentController',
                controllerAs: '$ctrl',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            orderBagItem: orderBagItem
                        };

                    }
                },
                clickOutsideToClose: true
            }).result.then(function (v) {

                if (v) {
                    orderBagItem.serviceTimeSession = v.serviceTimeSession;
                    Servant.get({id: v.servant.id}).$promise.then(function (result) {
                        orderBagItem.servant = result;
                    });
                    canEditOrderBag();
                }
                //reload();
                // $uibModalInstance.close(result);
            }, function () {
                //nothing
                // $uibModalInstance.close(result);
            });

        }

        function insertPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog.html',
                controller: 'OrderBagPaymentLogDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            traceCode: null,
                            paymentType: null,
                            createDate: null,
                            id: null,
                            orderBagId: $stateParams.id
                        };
                    }]
                }
            }).result.then(function (v) {

                vm.invoiceInfo.paymentLogs.push({
                    id: v.id,
                    traceCode: v.traceCode,
                    paymentType: v.paymentType,
                    createDate: v.createDate,
                    amount: v.amount,
                });

                vm.orderBag.remainAmount -= v.amount;
                //reload();
            }, function () {
                //nothing
            });
        }

        function confirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.confirmReserveRequestByOrderBagId().save(vm.orderBag.id, onConfirmReserveSuccess, onConfirmReserveError);

                });
            }
        }

        function onConfirmReserveSuccess(result) {

            reload();
        }

        function onConfirmReserveError() {

        }

        function timeDiff(orderBagItem) {

            var d1 = new Date(orderBagItem.serviceTimeSession.endTime);
            var d2 = new Date(orderBagItem.serviceTimeSession.startTime);
            var min = 1000 * 60;
            //orderBagItem.timePeriod = (d1 - d2) / min;
            orderBagItem.timePeriod = 60;
        }

        function showTimePeriod(orderBagItemDtail, orderBagItem) {
            if (orderBagItem.startDate == orderBagItem.endDate && orderBagItemDtail.timeUnitQty > 1)
                return true;

            return false;

        }

        function canReplaceTime(serviceItemId) {

            // ScheduleInfoCustom.getCurrentScheduleInfoByServiceItem(serviceItemId).query().$promise.then(function (result) {
            //
            //     if (result.scheduleType == 'FLOAT_TIME_SESSIONS')
            //         vm.showReplaceTime = false;
            // })

            // var canReplaceTime = false;
            // //check servant is in serviceSeravnt list
            // ServiceItemCustom.getServiceServants(vm.orderBagServiceItem.serviceItemId).query(function (servants) {
            //     var servantid =  vm.orderBagServiceItem.serv;
            //     angular.forEach(servants, function (s) {
            //         if (servantid == s.id) {
            //             $ctrl.canReplaceTime = true;
            //         }
            //
            //     });
            // });

            vm.showReplaceTime = true;
        }

        function goToVideoCall(orderBagItem) {


            // $state.go('supplierPanel.joinVideoMeeting', {
            //     id: orderBagItem.id
            // });

            $mdDialog.show({
                controller: 'JoinVideoMeetingComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem
                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function deleteOrderBagItem(itemId) {
            if (itemId != null) {
                DialogService.showConfirm("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    OrderBagCustom.deleteOrderBagItem().save(itemId, onDeleteItemSuccess, onDeleteItemError);

                });
            }
        }

        function onDeleteItemSuccess(result) {
            reload();
        }

        function onDeleteItemError() {

        }

        function settlementInvoice() {

            if (vm.orderBag.remainAmount == 0 || vm.orderBag.finalPrice == 0)
                return;

            var paymentLog = {};
            paymentLog.amount = vm.orderBag.remainAmount;
            paymentLog.paymentType = 'UNKNOWN';
            paymentLog.orderBagId = vm.orderBag.id;

            PaymentLogCustom.createPaymentLogByOrderBagId().save(paymentLog, onSettlementSaveSuccess, onSettlementSaveError);


        }

        function onSettlementSaveSuccess(result) {
            vm.invoiceInfo.paymentLogs.push({
                id: result.id,
                traceCode: result.traceCode,
                paymentType: result.paymentType,
                createDate: result.createDate,
                amount: result.amount,
            });

            vm.orderBag.remainAmount -= result.amount;
        }

        function onSettlementSaveError() {

        }

        function deletePaymentLog(paymentLog) {

            if (paymentLog != null) {
                DialogService.showConfirm("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    PaymentLogCustom.deletePaymentLogById().delete({id: paymentLog.id},
                        function () {
                            reload();
                        });

                });
            }
        }

        function openMenu($mdOpenMenu, ev) {
            vm.originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function checkOtherActions() {
            if (!vm.orderBag || !vm.orderBag.status)
                return;
            vm.showOtherActionsButton = true;

            switch (vm.orderBag.status) {

                case vm.constStatus.confirmed :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.canceled :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.reserveRequest :
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = false;
                    vm.showOtherActionsButton = false;
                    break;
                case vm.constStatus.requestConfirm:
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = true;
                    break;
            }

            if (vm.orderBag.finalPrice == 0)
                vm.canReApproveRequestToPay = false;

        }


        function reConfirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.reConfirmReserveRequestByOrderBagId().save(vm.orderBag.id, onReConfirmReserveSuccess, onReConfirmReserveError);

                });
            }
        }

        function onReConfirmReserveSuccess(result) {

            reload();
        }

        function onReConfirmReserveError() {

        }

        function reSendNotification() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirm("ارسال مجدد پیام را تایید می فرمایید ؟").then(function () {
                    OrderBagCustom.reSendNotificationByOrderBagId().save(vm.orderBag.id, function (result) {
                        // reload();
                    });

                });
            }
        }

        function goToCustomerDetail() {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(vm.orderBag.customer.id).query().$promise.then(onGetSuccess);
                    }
                });
        }

        function onGetSuccess(result) {

            vm.companyCustomer = result;
            showCustomerPopUp(vm.companyCustomer.id);
            // $state.transitionTo('supplierPanel.companyCustomerPopUp', {id: });

        }


        function showCustomerPopUp(companyCustomerId) {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                controller: 'CompanyCustomerPopUpController',
                controllerAs: 'vm',
                backdrop: 'true',
                size: 'lg',

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', function (CompanyCustomer) {
                        return CompanyCustomer.get({id: companyCustomerId}).$promise;
                    }],
                    formData: {
                        mode: 'EDIT',
                        isPopUp: true
                    }
                }
            }).result.then(function (v) {
                reload();
            }, function () {
                //nothing
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffTimeDialogController', OffTimeDialogController);

    OffTimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OffTime', 'TimePeriod'];

    function OffTimeDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OffTime, TimePeriod) {
        var vm = this;

        vm.offTime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.timeperiods = TimePeriod.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.offTime.id !== null) {
                OffTime.update(vm.offTime, onSaveSuccess, onSaveError);
            } else {
                OffTime.save(vm.offTime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:offTimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromTime = false;
        vm.datePickerOpenStatus.toTime = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffTimeDetailController', OffTimeDetailController);

    OffTimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OffTime', 'TimePeriod'];

    function OffTimeDetailController($scope, $rootScope, $stateParams, entity, OffTime, TimePeriod) {
        var vm = this;

        vm.offTime = entity;

        var unsubscribe = $rootScope.$on('tikonApp:offTimeUpdate', function (event, result) {
            vm.offTime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffTimeDeleteController', OffTimeDeleteController);

    OffTimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'OffTime'];

    function OffTimeDeleteController($uibModalInstance, entity, OffTime) {
        var vm = this;

        vm.offTime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            OffTime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('off-time', {
                parent: 'entity',
                url: '/off-time?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.offTime.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/off-time/off-times.html',
                        controller: 'OffTimeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('offTime');
                        $translatePartialLoader.addPart('offTimeType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('off-time-detail', {
                parent: 'entity',
                url: '/off-time/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.offTime.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/off-time/off-time-detail.html',
                        controller: 'OffTimeDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('offTime');
                        $translatePartialLoader.addPart('offTimeType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OffTime', function ($stateParams, OffTime) {
                        return OffTime.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('off-time.new', {
                parent: 'off-time',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/off-time/off-time-dialog.html',
                        controller: 'OffTimeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    i: null,
                                    fromTime: null,
                                    toTime: null,
                                    offTimeType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('off-time', null, {reload: true});
                    }, function () {
                        $state.go('off-time');
                    });
                }]
            })
            .state('off-time.edit', {
                parent: 'off-time',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/off-time/off-time-dialog.html',
                        controller: 'OffTimeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['OffTime', function (OffTime) {
                                return OffTime.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('off-time', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('off-time.delete', {
                parent: 'off-time',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/off-time/off-time-delete-dialog.html',
                        controller: 'OffTimeDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['OffTime', function (OffTime) {
                                return OffTime.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('off-time', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OffTime', OffTime);

    OffTime.$inject = ['$resource', 'DateUtils', 'ENV'];

    function OffTime($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/off-times/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromTime = DateUtils.convertDateTimeFromServer(data.fromTime);
                        data.toTime = DateUtils.convertDateTimeFromServer(data.toTime);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OffTimeSearch', OffTimeSearch);

    OffTimeSearch.$inject = ['$resource', 'ENV'];

    function OffTimeSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/off-times/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffTimeController', OffTimeController);

    OffTimeController.$inject = ['$scope', '$state', 'OffTime', 'OffTimeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OffTimeController($scope, $state, OffTime, OffTimeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                OffTimeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OffTime.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.offTimes = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffDayDialogController', OffDayDialogController);

    OffDayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OffDay', 'DatePeriod'];

    function OffDayDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, OffDay, DatePeriod) {
        var vm = this;

        vm.offDay = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.dateperiods = DatePeriod.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.offDay.id !== null) {
                OffDay.update(vm.offDay, onSaveSuccess, onSaveError);
            } else {
                OffDay.save(vm.offDay, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:offDayUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.offDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffDayDetailController', OffDayDetailController);

    OffDayDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OffDay', 'DatePeriod'];

    function OffDayDetailController($scope, $rootScope, $stateParams, entity, OffDay, DatePeriod) {
        var vm = this;

        vm.offDay = entity;

        var unsubscribe = $rootScope.$on('tikonApp:offDayUpdate', function (event, result) {
            vm.offDay = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffDayDeleteController', OffDayDeleteController);

    OffDayDeleteController.$inject = ['$uibModalInstance', 'entity', 'OffDay'];

    function OffDayDeleteController($uibModalInstance, entity, OffDay) {
        var vm = this;

        vm.offDay = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            OffDay.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('off-day', {
                parent: 'entity',
                url: '/off-day?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.offDay.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/off-day/off-days.html',
                        controller: 'OffDayController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('offDay');
                        $translatePartialLoader.addPart('offDayType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('off-day-detail', {
                parent: 'entity',
                url: '/off-day/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.offDay.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/off-day/off-day-detail.html',
                        controller: 'OffDayDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('offDay');
                        $translatePartialLoader.addPart('offDayType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OffDay', function ($stateParams, OffDay) {
                        return OffDay.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('off-day.new', {
                parent: 'off-day',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/off-day/off-day-dialog.html',
                        controller: 'OffDayDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    offDate: null,
                                    offDayType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('off-day', null, {reload: true});
                    }, function () {
                        $state.go('off-day');
                    });
                }]
            })
            .state('off-day.edit', {
                parent: 'off-day',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/off-day/off-day-dialog.html',
                        controller: 'OffDayDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['OffDay', function (OffDay) {
                                return OffDay.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('off-day', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('off-day.delete', {
                parent: 'off-day',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/off-day/off-day-delete-dialog.html',
                        controller: 'OffDayDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['OffDay', function (OffDay) {
                                return OffDay.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('off-day', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OffDay', OffDay);

    OffDay.$inject = ['$resource', 'DateUtils', 'ENV'];

    function OffDay($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/off-days/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.offDate = DateUtils.convertLocalDateFromServer(data.offDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.offDate = DateUtils.convertLocalDateToServer(data.offDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.offDate = DateUtils.convertLocalDateToServer(data.offDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OffDaySearch', OffDaySearch);

    OffDaySearch.$inject = ['$resource', 'ENV'];

    function OffDaySearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/off-days/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OffDayController', OffDayController);

    OffDayController.$inject = ['$scope', '$state', 'OffDay', 'OffDaySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OffDayController($scope, $state, OffDay, OffDaySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                OffDaySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OffDay.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.offDays = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NotificationSettingDialogController', NotificationSettingDialogController);

    NotificationSettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NotificationSetting'];

    function NotificationSettingDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, NotificationSetting) {
        var vm = this;

        vm.notificationSetting = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.notificationSetting.id !== null) {
                NotificationSetting.update(vm.notificationSetting, onSaveSuccess, onSaveError);
            } else {
                NotificationSetting.save(vm.notificationSetting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:notificationSettingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NotificationSettingDetailController', NotificationSettingDetailController);

    NotificationSettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'NotificationSetting'];

    function NotificationSettingDetailController($scope, $rootScope, $stateParams, entity, NotificationSetting) {
        var vm = this;

        vm.notificationSetting = entity;

        var unsubscribe = $rootScope.$on('tikonApp:notificationSettingUpdate', function (event, result) {
            vm.notificationSetting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NotificationSettingDeleteController', NotificationSettingDeleteController);

    NotificationSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'NotificationSetting'];

    function NotificationSettingDeleteController($uibModalInstance, entity, NotificationSetting) {
        var vm = this;

        vm.notificationSetting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            NotificationSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('notification-setting', {
                parent: 'entity',
                url: '/notification-setting?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.notificationSetting.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notification-setting/notification-settings.html',
                        controller: 'NotificationSettingController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('notification-setting-detail', {
                parent: 'entity',
                url: '/notification-setting/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.notificationSetting.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notification-setting/notification-setting-detail.html',
                        controller: 'NotificationSettingDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('notificationType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotificationSetting', function ($stateParams, NotificationSetting) {
                        return NotificationSetting.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('notification-setting.new', {
                parent: 'notification-setting',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/notification-setting/notification-setting-dialog.html',
                        controller: 'NotificationSettingDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    sendBookingConfirmation: null,
                                    sendOnCancelBooking: null,
                                    sendOnMoveBooking: null,
                                    sendCustomerReminder: null,
                                    reminderTimeInAdvanced: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('notification-setting', null, {reload: true});
                    }, function () {
                        $state.go('notification-setting');
                    });
                }]
            })
            .state('notification-setting.edit', {
                parent: 'notification-setting',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/notification-setting/notification-setting-dialog.html',
                        controller: 'NotificationSettingDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['NotificationSetting', function (NotificationSetting) {
                                return NotificationSetting.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('notification-setting', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('notification-setting.delete', {
                parent: 'notification-setting',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/notification-setting/notification-setting-delete-dialog.html',
                        controller: 'NotificationSettingDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['NotificationSetting', function (NotificationSetting) {
                                return NotificationSetting.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('notification-setting', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('NotificationSetting', NotificationSetting);

    NotificationSetting.$inject = ['$resource'];

    function NotificationSetting($resource) {
        var resourceUrl = 'api/notification-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('NotificationSettingSearch', NotificationSettingSearch);

    NotificationSettingSearch.$inject = ['$resource'];

    function NotificationSettingSearch($resource) {
        var resourceUrl = 'api/_search/notification-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NotificationSettingController', NotificationSettingController);

    NotificationSettingController.$inject = ['$scope', '$state', 'NotificationSetting', 'NotificationSettingSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function NotificationSettingController($scope, $state, NotificationSetting, NotificationSettingSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                NotificationSettingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                NotificationSetting.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notificationSettings = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'News', 'Customer', 'ServiceItem', 'CompanyCustom', '$translate', '$translatePartialLoader'];

    function NewsDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, News, Customer, ServiceItem, CompanyCustom, translate, translatePartialLoader) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.addCompanyType = addCompanyType;
        vm.companyType = null;
        vm.clearCompanyTypes = clearCompanyTypes;

        vm.subscriptionType = null;
        vm.addSubscriptionType = addSubscriptionType;
        vm.clearSubscriptionTypes = clearSubscriptionTypes;

        loadPage();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function loadPage() {
            translatePartialLoader.addPart('activityType');
            loadAllCompanyTypes();
            loadAllSubscriptionTypes();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.news.id !== null) {
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:newsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAllCompanyTypes() {
            vm.allCompanyTypes = CompanyCustom.getCompanyActivityTypes();
        }

        function loadAllSubscriptionTypes() {
            vm.allSubscriptionTypes = ['FREE', 'BASIC', 'ECONOMY', 'ENTERPRISE', 'CUSTOM'];
        }

        function addCompanyType() {
            if (vm.companyType) {
                if (!vm.news.companyTypeObject)
                    vm.news.companyTypeObject = {};

                if (!vm.news.companyTypeObject.activityTypeList)
                    vm.news.companyTypeObject.activityTypeList = [];

                vm.news.companyTypeObject.activityTypeList.push(vm.companyType);

            }
        }

        function clearCompanyTypes() {
            if (!vm.news.companyTypeObject)
                vm.news.companyTypeObject = {};

            if (!vm.news.companyTypeObject.activityTypeList)
                vm.news.companyTypeObject.activityTypeList = [];

            vm.news.companyTypeObject = null;

        }

        function addSubscriptionType() {
            if (vm.subscriptionType) {
                if (!vm.news.subscriptionTypeObject)
                    vm.news.subscriptionTypeObject = {};

                if (!vm.news.subscriptionTypeObject.subscriptionTypeList)
                    vm.news.subscriptionTypeObject.subscriptionTypeList = [];

                vm.news.subscriptionTypeObject.subscriptionTypeList.push(vm.subscriptionType);

            }
        }

        function clearSubscriptionTypes() {
            if (!vm.news.subscriptionTypeObject)
                vm.news.subscriptionTypeObject = {};

            if (!vm.news.subscriptionTypeObject.subscriptionTypeList)
                vm.news.subscriptionTypeObject.subscriptionTypeList = [];

            vm.news.subscriptionTypeObject.subscriptionTypeList = [];

        }
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankDetailController', CustomerRankDetailController);
//
//    CustomerRankDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerRank', 'Customer', 'ServiceItem'];
//
//    function CustomerRankDetailController($scope, $rootScope, $stateParams, entity, CustomerRank, Customer, ServiceItem) {
//        var vm = this;
//
//        vm.customerRank = entity;
//
//        var unsubscribe = $rootScope.$on('tikonApp:customerRankUpdate', function(event, result) {
//            vm.customerRank = result;
//        });
//        $scope.$on('$destroy', unsubscribe);
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankDeleteController',CustomerRankDeleteController);
//
//    CustomerRankDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerRank'];
//
//    function CustomerRankDeleteController($uibModalInstance, entity, CustomerRank) {
//        var vm = this;
//
//        vm.customerRank = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            CustomerRank.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('NewsCustom', NewsCustom);

    NewsCustom.$inject = ['$resource', 'ENV'];

    function NewsCustom($resource, ENV) {


        var getActiveNewsByCurrentCompany = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-active-news-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getActiveNewsByCurrentCompanyWithOutSystemNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-active-news-by-current-company-with-out-system-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getActiveNewsByCurrentCompany: getActiveNewsByCurrentCompany,
            getActiveNewsByCurrentCompanyWithOutSystemNotification: getActiveNewsByCurrentCompanyWithOutSystemNotification

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('news', {
                parent: 'entity',
                url: '/news?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.news.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/news/newses.html',
                        controller: 'NewsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('news');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('subscriptionType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('news-detail', {
                parent: 'entity',
                url: '/news/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.news.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/news/news-detail.html',
                        controller: 'NewsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('news');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('subscriptionType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'news', function ($stateParams, News) {
                        return News.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('news_new', {
                parent: 'news',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/news/news-dialog.html',
                        controller: 'NewsDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    title: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('news', null, {reload: true});
                    }, function () {
                        $state.go('news');
                    });
                }]
            })
            .state('news.edit', {
                parent: 'news',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/news/news-dialog.html',
                        controller: 'NewsDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['News', function (News) {
                                return News.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('news', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('news.delete', {
                parent: 'news',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/news/news-delete-dialog.html',
                        controller: 'NewsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['News', function (News) {
                                return News.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('news', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('News', News);

    News.$inject = ['$resource', 'DateUtils', 'ENV'];

    function News($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/news/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('NewsSearch', NewsSearch);

    NewsSearch.$inject = ['$resource', 'ENV'];

    function NewsSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/news/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['$scope', '$state', 'News', 'NewsSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function NewsController($scope, $state, News, NewsSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                NewsSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                News.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.news = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogDialogController', MoneyTransferLogDialogController);

    MoneyTransferLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MoneyTransferLog'];

    function MoneyTransferLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, MoneyTransferLog) {
        var vm = this;

        vm.moneyTransferLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.moneyTransferLog.id !== null) {
                MoneyTransferLog.update(vm.moneyTransferLog, onSaveSuccess, onSaveError);
            } else {
                MoneyTransferLog.save(vm.moneyTransferLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:moneyTransferLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.transferDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogDetailController', MoneyTransferLogDetailController);

    MoneyTransferLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MoneyTransferLog'];

    function MoneyTransferLogDetailController($scope, $rootScope, $stateParams, entity, MoneyTransferLog) {
        var vm = this;

        vm.moneyTransferLog = entity;

        var unsubscribe = $rootScope.$on('tikonApp:moneyTransferLogUpdate', function (event, result) {
            vm.moneyTransferLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogDeleteController', MoneyTransferLogDeleteController);

    MoneyTransferLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'MoneyTransferLog'];

    function MoneyTransferLogDeleteController($uibModalInstance, entity, MoneyTransferLog) {
        var vm = this;

        vm.moneyTransferLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            MoneyTransferLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('money-transfer-log', {
                parent: 'entity',
                url: '/money-transfer-log?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.moneyTransferLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-logs.html',
                        controller: 'MoneyTransferLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('moneyTransferLog');
                        $translatePartialLoader.addPart('transferType');
                        $translatePartialLoader.addPart('moneyTransferLogStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('money-transfer-log-detail', {
                parent: 'entity',
                url: '/money-transfer-log/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.moneyTransferLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-detail.html',
                        controller: 'MoneyTransferLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('moneyTransferLog');
                        $translatePartialLoader.addPart('transferType');
                        $translatePartialLoader.addPart('moneyTransferLogStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MoneyTransferLog', function ($stateParams, MoneyTransferLog) {
                        return MoneyTransferLog.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('money-transfer-log.new', {
                parent: 'money-transfer-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-dialog.html',
                        controller: 'MoneyTransferLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    transferType: null,
                                    createDate: null,
                                    transactionCode: null,
                                    payeeName: null,
                                    payeeAccountNo: null,
                                    payerAcountNo: null,
                                    payerName: null,
                                    transferDate: null,
                                    status: null,
                                    refrenceCode: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('money-transfer-log', null, {reload: true});
                    }, function () {
                        $state.go('money-transfer-log');
                    });
                }]
            })
            .state('money-transfer-log.edit', {
                parent: 'money-transfer-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-dialog.html',
                        controller: 'MoneyTransferLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MoneyTransferLog', function (MoneyTransferLog) {
                                return MoneyTransferLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('money-transfer-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('money-transfer-log.delete', {
                parent: 'money-transfer-log',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-delete-dialog.html',
                        controller: 'MoneyTransferLogDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MoneyTransferLog', function (MoneyTransferLog) {
                                return MoneyTransferLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('money-transfer-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MoneyTransferLog', MoneyTransferLog);

    MoneyTransferLog.$inject = ['$resource', 'DateUtils'];

    function MoneyTransferLog($resource, DateUtils) {
        var resourceUrl = 'api/money-transfer-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.transferDate = DateUtils.convertDateTimeFromServer(data.transferDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MoneyTransferLogSearch', MoneyTransferLogSearch);

    MoneyTransferLogSearch.$inject = ['$resource'];

    function MoneyTransferLogSearch($resource) {
        var resourceUrl = 'api/_search/money-transfer-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoneyTransferLogController', MoneyTransferLogController);

    MoneyTransferLogController.$inject = ['$scope', '$state', 'MoneyTransferLog', 'MoneyTransferLogSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MoneyTransferLogController($scope, $state, MoneyTransferLog, MoneyTransferLogSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                MoneyTransferLogSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MoneyTransferLog.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.moneyTransferLogs = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MetaTagDialogController', MetaTagDialogController);

    MetaTagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MetaTag', 'Company', 'ServiceItem'];

    function MetaTagDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, MetaTag, Company, ServiceItem) {
        var vm = this;

        vm.metaTag = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.serviceitems = ServiceItem.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.metaTag.id !== null) {
                MetaTag.update(vm.metaTag, onSaveSuccess, onSaveError);
            } else {
                MetaTag.save(vm.metaTag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:metaTagUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MetaTagDetailController', MetaTagDetailController);

    MetaTagDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MetaTag', 'Company', 'ServiceItem'];

    function MetaTagDetailController($scope, $rootScope, $stateParams, entity, MetaTag, Company, ServiceItem) {
        var vm = this;

        vm.metaTag = entity;

        var unsubscribe = $rootScope.$on('tikonApp:metaTagUpdate', function (event, result) {
            vm.metaTag = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MetaTagDeleteController', MetaTagDeleteController);

    MetaTagDeleteController.$inject = ['$uibModalInstance', 'entity', 'MetaTag'];

    function MetaTagDeleteController($uibModalInstance, entity, MetaTag) {
        var vm = this;

        vm.metaTag = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            MetaTag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MetaTagCustom', MetaTagCustom);

    MetaTagCustom.$inject = ['$resource', 'ENV'];

    function MetaTagCustom($resource, ENV) {


        var getMetaTagsByType = function (tagType) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-meta-tags-by-type?tagType=' + tagType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getMetaTagsByType: getMetaTagsByType
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('meta-tag', {
                parent: 'entity',
                url: '/meta-tag?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.metaTag.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/meta-tag/meta-tags.html',
                        controller: 'MetaTagController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('metaTag');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('meta-tag-detail', {
                parent: 'entity',
                url: '/meta-tag/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.metaTag.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/meta-tag/meta-tag-detail.html',
                        controller: 'MetaTagDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('metaTag');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MetaTag', function ($stateParams, MetaTag) {
                        return MetaTag.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('meta-tag.new', {
                parent: 'meta-tag',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/meta-tag/meta-tag-dialog.html',
                        controller: 'MetaTagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    tag: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('meta-tag', null, {reload: true});
                    }, function () {
                        $state.go('meta-tag');
                    });
                }]
            })
            .state('meta-tag.edit', {
                parent: 'meta-tag',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/meta-tag/meta-tag-dialog.html',
                        controller: 'MetaTagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MetaTag', function (MetaTag) {
                                return MetaTag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('meta-tag', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('meta-tag.delete', {
                parent: 'meta-tag',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/meta-tag/meta-tag-delete-dialog.html',
                        controller: 'MetaTagDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MetaTag', function (MetaTag) {
                                return MetaTag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('meta-tag', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MetaTag', MetaTag);

    MetaTag.$inject = ['$resource', 'ENV'];

    function MetaTag($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/meta-tags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MetaTagSearch', MetaTagSearch);

    MetaTagSearch.$inject = ['$resource', 'ENV'];

    function MetaTagSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/meta-tags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MetaTagController', MetaTagController);

    MetaTagController.$inject = ['$scope', '$state', 'MetaTag', 'MetaTagSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MetaTagController($scope, $state, MetaTag, MetaTagSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                MetaTagSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MetaTag.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.metaTags = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MessageDialogController', MessageDialogController);

    MessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Message', 'Conversation'];

    function MessageDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Message, Conversation) {
        var vm = this;

        vm.message = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.conversations = Conversation.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.message.id !== null) {
                Message.update(vm.message, onSaveSuccess, onSaveError);
            } else {
                Message.save(vm.message, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:messageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MessageDetailController', MessageDetailController);

    MessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Message', 'Conversation'];

    function MessageDetailController($scope, $rootScope, $stateParams, previousState, entity, Message, Conversation) {
        var vm = this;

        vm.message = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tikonApp:messageUpdate', function (event, result) {
            vm.message = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MessageDeleteController', MessageDeleteController);

    MessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Message'];

    function MessageDeleteController($uibModalInstance, entity, Message) {
        var vm = this;

        vm.message = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Message.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MessageCustom', MessageCustom);

    MessageCustom.$inject = ['$resource', 'ENV'];

    function MessageCustom($resource, ENV) {


        var newMessageFromSupplier = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/new-message-from-supplier';
            return $resource(resourceUrl, {}, {}
            );
        };

        return {
            newMessageFromSupplier: newMessageFromSupplier

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('message', {
                parent: 'entity',
                url: '/message?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.message.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message/messages.html',
                        controller: 'MessageController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('message');
                        $translatePartialLoader.addPart('messageSenderType');
                        $translatePartialLoader.addPart('messageStatusType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('message-detail', {
                parent: 'message',
                url: '/message/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.message.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message/message-detail.html',
                        controller: 'MessageDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('message');
                        $translatePartialLoader.addPart('messageSenderType');
                        $translatePartialLoader.addPart('messageStatusType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Message', function ($stateParams, Message) {
                        return Message.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'message',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('message-detail.edit', {
                parent: 'message-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/message/message-dialog.html',
                        controller: 'MessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Message', function (Message) {
                                return Message.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('message.new', {
                parent: 'message',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/message/message-dialog.html',
                        controller: 'MessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    content: null,
                                    senderType: null,
                                    createDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('message', null, {reload: 'message'});
                    }, function () {
                        $state.go('message');
                    });
                }]
            })
            .state('message.edit', {
                parent: 'message',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/message/message-dialog.html',
                        controller: 'MessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Message', function (Message) {
                                return Message.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('message', null, {reload: 'message'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('message.delete', {
                parent: 'message',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/message/message-delete-dialog.html',
                        controller: 'MessageDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Message', function (Message) {
                                return Message.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('message', null, {reload: 'message'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Message', Message);

    Message.$inject = ['$resource', 'DateUtils', 'ENV'];

    function Message($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MessageSearch', MessageSearch);

    MessageSearch.$inject = ['$resource', 'ENV'];

    function MessageSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MessageController', MessageController);

    MessageController.$inject = ['$state', 'Message', 'MessageSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MessageController($state, Message, MessageSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                MessageSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Message.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.messages = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceDialogController', MarketplaceDialogController);

    MarketplaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Marketplace'];

    function MarketplaceDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Marketplace) {
        var vm = this;

        vm.marketplace = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.marketplace.id !== null) {
                Marketplace.update(vm.marketplace, onSaveSuccess, onSaveError);
            } else {
                Marketplace.save(vm.marketplace, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:MarketplaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceDetailController', MarketplaceDetailController);

    MarketplaceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Marketplace'];

    function MarketplaceDetailController($scope, $rootScope, $stateParams, entity, Marketplace) {
        var vm = this;

        vm.marketplace = entity;

        var unsubscribe = $rootScope.$on('tikonApp:MarketplaceUpdate', function (event, result) {
            vm.marketplace = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceDeleteController', MarketplaceDeleteController);

    MarketplaceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Marketplace'];

    function MarketplaceDeleteController($uibModalInstance, entity, Marketplace) {
        var vm = this;

        vm.marketplace = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Marketplace.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('marketplace', {
                parent: 'entity',
                url: '/marketplace?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketplace.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketplace/marketplaces.html',
                        controller: 'MarketplaceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketplace');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('marketplace-detail', {
                parent: 'entity',
                url: '/marketplace/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketplace.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketplace/marketplace-detail.html',
                        controller: 'MarketplaceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketplace');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Marketplace', function ($stateParams, Marketplace) {
                        return Marketplace.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('marketplace.new', {
                parent: 'marketplace',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketplace/marketplace-dialog.html',
                        controller: 'MarketplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    managerType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('marketplace', null, {reload: true});
                    }, function () {
                        $state.go('marketplace');
                    });
                }]
            })
            .state('marketplace.edit', {
                parent: 'marketplace',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketplace/marketplace-dialog.html',
                        controller: 'MarketplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Marketplace', function (Marketplace) {
                                return Marketplace.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('marketplace', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('marketplace.delete', {
                parent: 'marketplace',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketplace/marketplace-delete-dialog.html',
                        controller: 'MarketplaceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Marketplace', function (Marketplace) {
                                return Marketplace.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('marketplace', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Marketplace', Marketplace);

    Marketplace.$inject = ['$resource'];

    function Marketplace($resource) {
        var resourceUrl = 'api/marketplaces/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MarketplaceSearch', MarketplaceSearch);

    MarketplaceSearch.$inject = ['$resource'];

    function MarketplaceSearch($resource) {
        var resourceUrl = 'api/_search/marketplaces/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceController', MarketplaceController);

    MarketplaceController.$inject = ['$scope', '$state', 'Marketplace', 'MarketplaceSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function MarketplaceController($scope, $state, Marketplace, MarketplaceSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                MarketplaceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Marketplace.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.marketplaces = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketingCampaignsListController', MarketingCampaignsListController);

    MarketingCampaignsListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'MarketingCampaign', 'MarketingCampaignCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService', 'smsPanel', '$localStorage'];

    function MarketingCampaignsListController($scope, $state, ParseLinks, AlertService, MarketingCampaign, MarketingCampaignCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService, smsPanel, $localStorage) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.editMarketingCampaign = editMarketingCampaign;
        vm.searchKeyPress = searchKeyPress;
        vm.newMarketingCampaign = newMarketingCampaign;
        vm.clearSearch = clearSearch;
        vm.findApproveStatusStyle = findApproveStatusStyle;
        vm.smsPanel = smsPanel;
        vm.deleteMarketingCampaign = deleteMarketingCampaign;
        vm.getTitle = getTitle;

        loadAll_paging();

       function loadAll_paging() {
           var searchQuery = pagingParams.search || '';
           var actionTypes;

           if (smsPanel) {
               actionTypes = ['SMS_PANEL'];
           } else {
               actionTypes = [
                   'AFTER_INVOICE',
                   'AFTER_RESERVE',
                   'BEFORE_RESERVE',
                   'MARKETING_CAMPAIGN'
               ];
           }

           MarketingCampaignCustom
               .getAllCompanyMarketingCampaigns()
               .query({
                   'action-types': actionTypes,
                   query: searchQuery,
                   page: pagingParams.page - 1,
                   size: paginationConstants.itemsPerPage,
                   sort: sort()
               }, onSuccess, onError);


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.marketingCampaigns = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


       function search() {
           vm.links = null;
           vm.page = 1;
           vm.predicate = 'id';
           vm.reverse = true;
           vm.currentSearch = vm.searchQuery ? vm.searchQuery.trim() : null;

           vm.transition();
       }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editMarketingCampaign(marketingCampaign) {
            if(smsPanel)
                $state.go('supplierPanel-v2.editMarketingCampaign', {id: marketingCampaign.id, smsPanel: 'true'});
            else  $state.go('supplierPanel-v2.editMarketingCampaign', {id: marketingCampaign.id});
        }

        function deleteMarketingCampaign(marketingCampaign) {
            if(smsPanel)
                $state.go('supplierPanel-v2.deleteSmsPanelMarketingCampaign', {id: marketingCampaign.id});
            else  $state.go('supplierPanel-v2.deleteMarketingCampaign', {id: marketingCampaign.id});
        }

        function newMarketingCampaign() {
            var result;

//            result = Principal.hasSpecialFeatureAccess("marketingCampaign");
//            if (!result) {
//                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
//                return;
//            }
            if(smsPanel) 
                $state.go('supplierPanel-v2.newMarketingCampaign', { smsPanel: 'true' });
            else 
                $state.go('supplierPanel-v2.newMarketingCampaign');
        }

       function clearSearch() {
           vm.links = null;
           vm.page = 1;
           vm.predicate = 'id';
           vm.reverse = true;
           vm.searchQuery = null;
           vm.currentSearch = null;

           vm.transition();
       }

        function findApproveStatusStyle(approveStatus) {
            return "marketing-approve-status marketing-approve-status-" + approveStatus;
        }

        function getTitle()
        {
            return 'tikonApp.marketingCampaign.home.title';
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketingCampaignDeleteController', MarketingCampaignDeleteController);

    MarketingCampaignDeleteController.$inject = ['$uibModalInstance', 'entity', 'MarketingCampaign'];

    function MarketingCampaignDeleteController($uibModalInstance, entity, MarketingCampaign) {
        var vm = this;

        vm.marketingCampaign = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            MarketingCampaign.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MarketingCampaignCustom', MarketingCampaignCustom);

    MarketingCampaignCustom.$inject = ['$resource', 'ENV'];

    function MarketingCampaignCustom($resource,ENV) {


        var getAllCompanyMarketingCampaigns = function () {

            var resourceUrl = 'api/get-all-company-marketing-campaign';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
         var getMarketingCampaigns = function () {

            var resourceUrl = 'api/_search/marketing-campaign';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET'}
                }
            );
        };

        var getSmsPanelOverView = function () {
           var resourceUrl = 'api/marketing-campaign/get-sms-panel-overview';
           return $resource(resourceUrl, {}, {
               }
           );
       };



        return {
            getAllCompanyMarketingCampaigns: getAllCompanyMarketingCampaigns,
            getMarketingCampaigns: getMarketingCampaigns,
            getSmsPanelOverView:getSmsPanelOverView

        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MarketingCampaign', MarketingCampaign);

    MarketingCampaign.$inject = ['$resource', 'DateUtils'];

    function MarketingCampaign($resource, DateUtils) {
        var resourceUrl = 'api/marketing-campaign/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketingCampaignController', MarketingCampaignController);

    MarketingCampaignController.$inject = ['$rootScope', '$scope', '$state', 'MarketingCampaign', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'MarketingCampaignCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom', 'smsPanel'];

    function MarketingCampaignController($rootScope, $scope, $state, MarketingCampaign, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, MarketingCampaignCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom, smsPanel) {
        var vm = this;
        vm.marketingCampaign = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = false;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];
        vm.findApproveStatusStyle = findApproveStatusStyle;
        vm.smsPanel = smsPanel;
        vm.calculateSmsInfo = calculateSmsInfo;
        vm.deleteMarketingCampaign =deleteMarketingCampaign;
        vm.canEdit = true;
        vm.validateSmsPanelSendTime = validateSmsPanelSendTime;
        vm.smsPanelSendTimeWarning = null;
        vm.customerSegmentChanged = customerSegmentChanged;
        vm.openSmsPanelOverview = openSmsPanelOverview;
        vm.allCustomerSegments = [
            {
                name: 'ALL_CUSTOMERS',
                selected: false
            },
            {
                name: 'NO_RESERVATION_IN_PAST_30_DAYS',
                selected: false
            }
        ];

        initDefault();
        loadAll();

        vm.availableTimes = [
            "00:00",
            "00:30",
            "01:00",
            "01:30",
            "02:00",
            "02:30",
            "03:00",
            "03:30",
            "04:00",
            "04:30",
            "05:00",
            "05:30",
            "06:00",
            "06:30",
            "07:00",
            "07:30",
            "08:00",
            "08:30",
            "09:00",
            "09:30",
            "10:00",
            "10:30",
            "11:00",
            "11:30",
            "12:00",
            "12:30",
            "13:00",
            "13:30",
            "14:00",
            "14:30",
            "15:00",
            "15:30",
            "16:00",
            "16:30",
            "17:00",
            "17:30",
            "18:00",
            "18:30",
            "19:00",
            "19:30",
            "20:00",
            "20:30",
            "21:00",
            "21:30",
            "22:00",
            "22:30",
            "23:00",
            "23:30"
        ];


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {


            if (!vm.marketingCampaign)
                vm.marketingCampaign = {};

            if (!vm.marketingCampaign.notificationTemplate)
                vm.marketingCampaign.notificationTemplate = {};

            if (!vm.marketingCampaign.type)
                vm.marketingCampaign.type = 'AUTOMATIC';

            if (!vm.marketingCampaign.status)
                vm.marketingCampaign.status = 'ACTIVE';

            if (!vm.marketingCampaign.actionType)
                vm.marketingCampaign.actionType = "AFTER_INVOICE"

            vm.marketingCampaign.notificationType = 'SMS';
            makeCustomerSegmentsSelectedOnLoad();


            if(vm.marketingCampaign.sendStatus == 'SENT' && vm.smsPanel)
                vm.canEdit = false;

            $rootScope.$broadcast('hideNavBar');

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('customerSegment');
            // $translatePartialLoader.addPart('MarketingCampaignTypes');
            // $translatePartialLoader.addPart('MarketingCampaignPeriod');

             if(vm.marketingCampaign.fixDate) {
                    var marketingDate = new Date(vm.marketingCampaign.fixDate);
                    vm.marketingCampaign.createDate = marketingDate;
                    var hours = marketingDate.getHours();
                    var minutes = marketingDate.getMinutes();

                    // Round to the closest half-hour ("00" or "30")
                    var formattedMinutes = minutes < 30 ? "00" : "30";
                    var formattedHours = (hours < 10 ? '0' : '') + hours;

                    vm.marketingCampaign.sendTime = formattedHours + ":" + formattedMinutes;
            }


            getAllServices();
            getAllCustomerGroups();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {

            if (vm.smsPanel) {
                vm.validateSmsPanelSendTime();

                if (vm.smsPanelSendTimeWarning) {
                    vm.isSaving = false;
                    return;
                }
            }

            vm.isSaving = true;

            var datetime;

            if (vm.smsPanel) {
                if (
                    vm.marketingCampaign.sendTime &&
                    vm.marketingCampaign.createDate
                ) {
                    var timeParts = vm.marketingCampaign.sendTime.split(':');
                    var hour = parseInt(timeParts[0], 10);
                    var minute = parseInt(timeParts[1], 10);

                    var dateInstance = new Date(
                        vm.marketingCampaign.createDate
                    );

                    dateInstance.setHours(hour, minute, 0, 0);
                    datetime = dateInstance.toISOString();
                } else {
                    datetime = vm.marketingCampaign.createDate;
                }

                vm.marketingCampaign.actionType = 'SMS_PANEL';
                vm.marketingCampaign.type = 'SEMI_AUTOMATIC';
                vm.marketingCampaign.fixDate = datetime;
            }

            addServiceItems();
            addCustomerGroups();
            addCustomerSegments();

            if (vm.marketingCampaign.id) {
                MarketingCampaign.update(
                    vm.marketingCampaign,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                MarketingCampaign.save(
                    vm.marketingCampaign,
                    onSaveSuccess,
                    onSaveError
                );
            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                var currentSendTime = vm.marketingCampaign.sendTime;
                var currentCreateDate = vm.marketingCampaign.createDate;

                $scope.$emit(
                    'tikonApp:MarketingCampaignUpdate',
                    result
                );

                vm.marketingCampaign = result;

                if (vm.smsPanel) {
                    vm.marketingCampaign.sendTime = currentSendTime;
                    vm.marketingCampaign.createDate = currentCreateDate;
                }

                vm.isSaving = false;

                if (vm.smsPanel) {
                    $state.go(
                        'supplierPanel-v2.editMarketingCampaign',
                        {
                            id: result.id,
                            smsPanel: 'true'
                        }
                    );
                } else {
                    $state.go(
                        'supplierPanel-v2.editMarketingCampaign',
                        {
                            id: result.id
                        }
                    );
                }
            }
        }


        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.marketingCampaign.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.marketingCampaign.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.marketingCampaign.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.marketingCampaign.customerGroups.push(item);
                }

            })
        }
        function addCustomerSegments() {

            if (!vm.smsPanel) {
                return;
            }

            vm.marketingCampaign.customerSegments = [];

            angular.forEach(vm.allCustomerSegments, function (item) {
                if (item.selected) {
                    vm.marketingCampaign.customerSegments.push({
                        customerSegmentType: item.name
                    });
                }
            });
        }


        function makeServicesSelectedOnLoad() {


            if (vm.marketingCampaign.serviceItems && vm.marketingCampaign.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.marketingCampaign.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.marketingCampaign.customerGroups && vm.marketingCampaign.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.marketingCampaign.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function makeCustomerSegmentsSelectedOnLoad() {

            if (
                !vm.marketingCampaign.customerSegments ||
                vm.marketingCampaign.customerSegments.length === 0
            ) {
                return;
            }

            angular.forEach(
                vm.marketingCampaign.customerSegments,
                function (segmentDto) {

                    angular.forEach(
                        vm.allCustomerSegments,
                        function (availableSegment) {

                            if (
                                availableSegment.name ===
                                segmentDto.customerSegmentType
                            ) {
                                availableSegment.selected = true;
                            }
                        }
                    );
                }
            );
        }



        function okModal() {
            openSmsPanelOverview();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if(smsPanel)
                $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', $rootScope.fromStateParams);
            else
                $state.go('supplierPanel-v2.marketingCampaignList', $rootScope.fromStateParams);

        }

        function getModalTitle() {
            if (vm.marketingCampaign.id){
                if(!smsPanel) return 'tikonApp.marketingCampaign.home.edit';
                return 'tikonApp.marketingCampaign.home.edit';
            }else {
                if(!smsPanel) return 'tikonApp.marketingCampaign.home.new';
                return 'tikonApp.marketingCampaign.home.newSmsPanel';
            }

        }


        function findApproveStatusStyle() {
            return "marketing-approve-status marketing-approve-status-" + vm.marketingCampaign.approveStatus;
        }

        function deleteMarketingCampaign() {
            if(smsPanel)
                $state.go('supplierPanel-v2.deleteSmsPanelMarketingCampaignFromModal', {id: vm.marketingCampaign.id});
            else  $state.go('supplierPanel-v2.deleteMarketingCampaignFromModal', {id: vm.marketingCampaign.id});
        }


        function calculateSmsInfo(text) {
            if (!text) {
                return {
                    characters: ''
                };
            }

            var length = text.length;
            var isUnicode = /[^\u0000-\u007F]/.test(text);
            var pages;

            if (isUnicode) {
                pages = length <= 70
                    ? 1
                    : Math.ceil(length / 67);
            } else {
                pages = length <= 160
                    ? 1
                    : Math.ceil(length / 153);
            }

            return {
                characters: length,
                pages: pages,
                encoding: isUnicode ? 'Unicode' : 'GSM-7'
            };
        }

        function customerSegmentChanged(changedSegment) {

            // If ALL_CUSTOMERS is checked, uncheck everything else.
            if (changedSegment.name === 'ALL_CUSTOMERS' && changedSegment.selected) {

                angular.forEach(vm.allCustomerSegments, function (segment) {
                    if (segment.name !== 'ALL_CUSTOMERS') {
                        segment.selected = false;
                    }
                });

                return;
            }

            // If any other segment is checked, uncheck ALL_CUSTOMERS.
            if (changedSegment.name !== 'ALL_CUSTOMERS' && changedSegment.selected) {

                angular.forEach(vm.allCustomerSegments, function (segment) {
                    if (segment.name === 'ALL_CUSTOMERS') {
                        segment.selected = false;
                    }
                });
            }
        }

        function validateSmsPanelSendTime() {

            vm.smsPanelSendTimeWarning = null;

            if (
                !vm.marketingCampaign.createDate ||
                !vm.marketingCampaign.sendTime
            ) {
                return;
            }

            var timeParts = vm.marketingCampaign.sendTime.split(':');
            var hour = parseInt(timeParts[0], 10);
            var minute = parseInt(timeParts[1], 10);

            var selectedDateTime =
                new Date(vm.marketingCampaign.createDate);

            selectedDateTime.setHours(hour, minute, 0, 0);

            var minimumAllowedDateTime = new Date();
            minimumAllowedDateTime.setHours(
                minimumAllowedDateTime.getHours() + 1
            );

            if (selectedDateTime < minimumAllowedDateTime) {
                vm.smsPanelSendTimeWarning =
                    'زمان ارسال باید حداقل یک ساعت بعد از زمان فعلی باشد.';
            }
        }

        $scope.$watchGroup([
            function () {
                return vm.marketingCampaign.createDate;
            },
            function () {
                return vm.marketingCampaign.sendTime;
            }
        ], function () {
            vm.validateSmsPanelSendTime();
        });


   function openSmsPanelOverview() {

       if(!vm.smsPanel)
       {
        save();
        return;
       }

       if (vm.isLoadingSmsPanelOverview) {
           return;
       }


       vm.validateSmsPanelSendTime();

       if (vm.smsPanelSendTimeWarning) {
           return;
       }

       addServiceItems();
       addCustomerGroups();
       addCustomerSegments();

       vm.isLoadingSmsPanelOverview = true;

       $mdDialog.show({
           template:
               '<md-dialog aria-label="SMS panel overview">' +
                   '<pf-sms-panel-overview ' +
                       'marketing-campaign="$ctrl.marketingCampaign" ' +
                       'on-confirm="$ctrl.confirm(overview)" ' +
                       'on-cancel="$ctrl.cancel()">' +
                   '</pf-sms-panel-overview>' +
               '</md-dialog>',

           controller: [
               '$mdDialog',
               'marketingCampaign',
               function ($mdDialog, marketingCampaign) {
                   var $ctrl = this;

                   $ctrl.marketingCampaign = marketingCampaign;

                   $ctrl.confirm = function (overview) {
                       $mdDialog.hide(overview);
                   };

                   $ctrl.cancel = function () {
                       $mdDialog.cancel();
                   };
               }
           ],

           controllerAs: '$ctrl',
           bindToController: true,

           locals: {
               marketingCampaign: angular.copy(vm.marketingCampaign)
           },

           clickOutsideToClose: true,
           escapeToClose: true
       }).then(
           function (overview) {
               vm.smsPanelOverview = overview;
               save();
           },
           function () {
               // Dialog cancelled.
           }
       ).finally(function () {
           vm.isLoadingSmsPanelOverview = false;
       });
   }
}

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LocationInfoDialogController', LocationInfoDialogController);

    LocationInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LocationInfo', 'SelectorData'];

    function LocationInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, LocationInfo, SelectorData) {
        var vm = this;

        vm.locationInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.selectordata = SelectorData.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.locationInfo.id !== null) {
                LocationInfo.update(vm.locationInfo, onSaveSuccess, onSaveError);
            } else {
                LocationInfo.save(vm.locationInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:locationInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LocationInfoDetailController', LocationInfoDetailController);

    LocationInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LocationInfo', 'SelectorData'];

    function LocationInfoDetailController($scope, $rootScope, $stateParams, entity, LocationInfo, SelectorData) {
        var vm = this;

        vm.locationInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:locationInfoUpdate', function (event, result) {
            vm.locationInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LocationInfoDeleteController', LocationInfoDeleteController);

    LocationInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'LocationInfo'];

    function LocationInfoDeleteController($uibModalInstance, entity, LocationInfo) {
        var vm = this;

        vm.locationInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            LocationInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('LocationInfoCustom', LocationInfoCustom);

    LocationInfoCustom.$inject = ['$resource'];

    function LocationInfoCustom($resource) {


        var saveWithCompany = function () {

            var resourceUrl = 'api/location-info-with-company';
            return $resource(resourceUrl, {}, {});
        };


        return {
            saveWithCompany: saveWithCompany
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('location-info', {
                parent: 'entity',
                url: '/location-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.locationInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-info/location-infos.html',
                        controller: 'LocationInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('location-info-detail', {
                parent: 'entity',
                url: '/location-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.locationInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-info/location-info-detail.html',
                        controller: 'LocationInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'LocationInfo', function ($stateParams, LocationInfo) {
                        return LocationInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('location-info.new', {
                parent: 'location-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-info/location-info-dialog.html',
                        controller: 'LocationInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    address: null,
                                    mapX: null,
                                    mapY: null,
                                    isActive: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('location-info', null, {reload: true});
                    }, function () {
                        $state.go('location-info');
                    });
                }]
            })
            .state('location-info.edit', {
                parent: 'location-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-info/location-info-dialog.html',
                        controller: 'LocationInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['LocationInfo', function (LocationInfo) {
                                return LocationInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('location-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('location-info.delete', {
                parent: 'location-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/location-info/location-info-delete-dialog.html',
                        controller: 'LocationInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['LocationInfo', function (LocationInfo) {
                                return LocationInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('location-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('LocationInfo', LocationInfo);

    LocationInfo.$inject = ['$resource', 'ENV'];

    function LocationInfo($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/location-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('LocationInfoSearch', LocationInfoSearch);

    LocationInfoSearch.$inject = ['$resource', 'ENV'];

    function LocationInfoSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/location-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LocationInfoController', LocationInfoController);

    LocationInfoController.$inject = ['$scope', '$state', 'LocationInfo', 'LocationInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LocationInfoController($scope, $state, LocationInfo, LocationInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                LocationInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                LocationInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.locationInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyLocationInfoController', CompanyLocationInfoController);

    CompanyLocationInfoController.$inject = ['$rootScope', '$state', '$timeout', '$scope', '$stateParams', 'LocationInfo', 'SelectorData', 'SelectorDataQuery', 'CompanyInfoQuery', 'LocationInfoCustom', 'entity'];

    function CompanyLocationInfoController($rootScope, $state, $timeout, $scope, $stateParams, LocationInfo, SelectorData, SelectorDataQuery, CompanyInfoQuery, LocationInfoCustom, entity) {

        var vm = this;
        vm.scope = $scope;

        vm.companyInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.province_changed = province_changed;
        vm.country_changed = country_changed;
        vm.selectordata = SelectorData.query();

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        $rootScope.$broadcast('hideNavBar');


        function clear() {
            // $uibModalInstance.dismiss('cancel');
        }

        function country_changed() {
            //if(vm.companyInfo.locationInfo.countryId!=null)
            //vm.provinceList=SelectorDataQuery.findByTypeAndParent('province',vm.companyInfo.locationInfo.countryId).query();
            //if(vm.companyInfo.locationInfo.stateId!=null)
            //vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.companyInfo.locationInfo.stateId).query();
        }

        function province_changed() {
            //vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.companyInfo.locationInfo.stateId).query();
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.companyInfo.locationInfo.id !== null) {
                    LocationInfo.update(vm.companyInfo.locationInfo, onSaveSuccess, onSaveError);
                } else {
                    LocationInfoCustom.saveWithCompany().save(vm.companyInfo.locationInfo, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:locationInfoUpdate', result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PrintInvoiceInfoController', PrintInvoiceInfoController);

    PrintInvoiceInfoController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', '$window', 'CompanyCustom', '__config'];

    function PrintInvoiceInfoController($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, $window, CompanyCustom, __config) {

        var vm = this;

        vm.invoiceInfo = entity;
        vm.companyUrl = null;
        vm.__config = __config;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.openPrintPreview = openPrintPreview;


        $rootScope.$broadcast('hideNavBar');


        load();

        function load() {
            CompanyCustom.getCurrentCompany().query(function (result) {
                vm.company = result;
                setCompanyUrl();
            });
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($rootScope.fromState && $rootScope.fromState.name) {

                if ($rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoList') {
                    $state.go('supplierPanel-v2.invoiceInfoList');
                    return;
                } else {

                    if ($rootScope.fromStateParams) {
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }
            
            $state.go('supplierPanel-v2.invoiceInfoDetail', { id: vm.invoiceInfo.id });

        }

        function okModal() {
            openPrintPreview();
        }


        function openPrintPreview() {
            $window.print();
        }

        function setCompanyUrl() {
            if (vm.company && vm.company.keyUrl) {
                vm.planovinUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                if (vm.company.hasDedicatedDomain && vm.company.domain) {
                    vm.companyUrl = vm.company.domain;
                } else {
                    vm.companyUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                }
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoDialogV2Controller', InvoiceInfoDialogV2Controller);

    InvoiceInfoDialogV2Controller.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', 'ServantCustom', 'SettingInfoCustom'];

    function InvoiceInfoDialogV2Controller($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, ServantCustom, SettingInfoCustom) {

        var vm = this;
        vm.invoiceInfo = entity;
        vm.clear = clear;
        vm.save = save;

        vm.newCustomerPopUp = newCustomerPopUp;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.newInvoiceInfoItem = newInvoiceInfoItem;
        vm.onItemFieldChanged = onItemFieldChanged;
        vm.deleteItem = deleteItem;
        vm.invoiceItemListEmptyMessage = 'هیچ آیتمی انتخاب نشده است';

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;
        vm.taxPercentage = 0;

        $rootScope.$broadcast('hideNavBar');


        load();

        function load() {

            if (vm.invoiceInfo.id)
                loadAvailableServants();

            getCompanyFinancialSetting();
        }

        function getCompanyFinancialSetting() {
            vm.companySetting = SettingInfoCustom.getSettingInfoByCurrentCompany().query(function (data) {
                vm.taxPercentage = data.financialSetting.taxPercentage;
            });
        }

        function clear() {
        }

        function save() {
            vm.isSaving = true;
            if (vm.invoiceInfo.id !== null) {
                InvoiceInfo.update(vm.invoiceInfo, onSaveSuccess, onSaveError);
            } else {
                InvoiceInfo.save(vm.invoiceInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:invoiceInfoUpdate', result);

            vm.isSaving = false;

            if (result.status != 'TEMP')
                $state.transitionTo('supplierPanel-v2.invoiceInfoDetail', {id: result.id});
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function newCustomerPopUp() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                controller: 'CompanyCustomerModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            });

            $rootScope.modalInstance.result.then(function (v) {

                vm.invoiceInfo.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }


        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');
                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name) {

                if ($rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoList'
                    || $rootScope.fromState.name == 'supplierPanel-v2.editInvoiceInfo'
                    || $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail'
                    || $rootScope.fromState.name == 'supplierPanel-v2.editInvoiceInfo.delete') {
                        $state.go('supplierPanel-v2.invoiceInfoList', $rootScope.fromStateParams);
                    return;
                } else {

                    if ($rootScope.fromStateParams) {
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }

            $state.go('supplierPanel-v2.invoiceInfoList');

        }

        function okModal() {
            save();

        }


        function searchCustomerByPhoneNumber() {

            if (!vm.orderBag.customer.personalInfo.phoneNumber || vm.orderBag.customer.personalInfo.phoneNumber.length < 6 || vm.orderBag.customer.personalInfo.phoneNumber.length == 11) {
                vm.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch(vm.orderBag.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                vm.existCustomerSearchResult = result;
            });

        }

        function newInvoiceInfoItem() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/invoice-info/add-invoice-item-modal.html',
                controller: 'AddInvoiceItemModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

            $rootScope.modalInstance.result.then(function (items) {

                addItemsToInvoice(items);
                //reload();
            }, function () {
                //nothing
            });
        }

        function addItemsToInvoice(items) {

            if (!vm.invoiceInfo.invoiceInfoItems)
                vm.invoiceInfo.invoiceInfoItems = [];
            angular.forEach(items, function (item) {
                vm.invoiceInfo.invoiceInfoItems.push(item);
            })
        }

        function loadAvailableServants() {
            if (!vm.invoiceInfo || !vm.invoiceInfo.id)
                return;


            angular.forEach(vm.invoiceInfo.invoiceInfoItems, function (item) {
                if (item.type == 'SERVICE' && item.referencedItemId)
                    getAvailableServantForServiceItem(item);
                else
                    getAllActiveServants(item);
            })

        }

        function getAvailableServantForServiceItem(invoiceInfoItem) {

            if (invoiceInfoItem.referencedItemId) {
                ServiceItemCustom.getServiceServants(invoiceInfoItem.referencedItemId).query(function (servants) {

                    if (servants && servants.length > 0) {
                        invoiceInfoItem.availableServants = servants;
                        angular.forEach(servants, function (srv) {
                            if (srv.id == invoiceInfoItem.servant.id)
                                invoiceInfoItem.servant = srv;
                        })

                    }
                });
            }
        }

        function getAllActiveServants(invoiceInfoItem) {

            if (vm.allServants) {
                invoiceInfoItem.availableServants = vm.allServants;
                angular.forEach(vm.allServants, function (srv) {
                    if (srv.id == invoiceInfoItem.servant.id)
                        invoiceInfoItem.servant = srv;
                })
            } else {
                ServantCustom.findServantsByCompany().query(function (list) {
                    vm.allServants = list;
                    getAllActiveServants(invoiceInfoItem);
                })
            }


        }

        function computeFinalPrice() {

            vm.invoiceInfo.totalServicePrice = 0;
            vm.invoiceInfo.totalProductPrice = 0;
            vm.invoiceInfo.totalOptionPrice = 0;
            vm.invoiceInfo.totalVat = 0;
            if (vm.invoiceInfo.totalDiscount == undefined)
                vm.invoiceInfo.totalDiscount = 0;
            vm.invoiceInfo.finalPrice = 0;


            if (!vm.invoiceInfo.invoiceInfoItems)
                return;


            angular.forEach(vm.invoiceInfo.invoiceInfoItems, function (item) {

                if (item.type == 'SERVICE')
                    vm.invoiceInfo.totalServicePrice += item.price * item.qty;
                if (item.type == 'PRODUCT')
                    vm.invoiceInfo.totalProductPrice += item.price * item.qty;
                if (item.type == 'SERVICE_ADD_ON' || item.type == 'SERVICE_OPTION')
                    vm.invoiceInfo.totalOptionPrice += item.price * item.qty;

            })


            vm.invoiceInfo.finalPrice = vm.invoiceInfo.totalServicePrice + vm.invoiceInfo.totalProductPrice + vm.invoiceInfo.totalOptionPrice - vm.invoiceInfo.totalDiscount

            //MUST GET VAT FROM SETTING!!!!!!!!!!!!!!
            vm.invoiceInfo.totalVat = vm.invoiceInfo.finalPrice * vm.taxPercentage / 100;
            vm.invoiceInfo.finalPrice = vm.invoiceInfo.finalPrice + vm.invoiceInfo.totalVat;

        }

        function onItemFieldChanged() {
            computeFinalPrice();
        }

        function deleteItem(item) {
            vm.invoiceInfo.invoiceInfoItems = vm.invoiceInfo.invoiceInfoItems.filter(function (invoiceItem) {


                if (
                    (invoiceItem.id && item.id && invoiceItem.id == item.id)
                    ||
                    (invoiceItem.randomNo && item.randomNo && invoiceItem.randomNo == item.randomNo)) {
                    //nothing
                } else {
                    return invoiceItem;
                }

            })

            computeFinalPrice();
        }

        $scope.$watch('vm.invoiceInfo', function () {
            computeFinalPrice();
        })


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoDialogController', InvoiceInfoDialogController);

    InvoiceInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoiceInfo', 'OrderBag', 'PaymentLog', 'Customer'];

    function InvoiceInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoiceInfo, OrderBag, PaymentLog, Customer) {
        var vm = this;

        vm.invoiceInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.orderbags = OrderBag.query();
        vm.paymentlogs = PaymentLog.query();
        vm.customers = Customer.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.invoiceInfo.id !== null) {
                InvoiceInfo.update(vm.invoiceInfo, onSaveSuccess, onSaveError);
            } else {
                InvoiceInfo.save(vm.invoiceInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:invoiceInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoDetailController', InvoiceInfoDetailController);

    InvoiceInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'InvoiceInfo', 'OrderBag', 'PaymentLog', 'Customer'];

    function InvoiceInfoDetailController($scope, $rootScope, $stateParams, entity, InvoiceInfo, OrderBag, PaymentLog, Customer) {
        var vm = this;

        vm.invoiceInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:invoiceInfoUpdate', function (event, result) {
            vm.invoiceInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoDeleteController', InvoiceInfoDeleteController);

    InvoiceInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoiceInfo'];

    function InvoiceInfoDeleteController($uibModalInstance, entity, InvoiceInfo) {
        var vm = this;

        vm.invoiceInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            InvoiceInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoBottomSheetController', InvoiceInfoBottomSheetController);

    InvoiceInfoBottomSheetController.$inject = ['$mdBottomSheet', 'entity'];

    function InvoiceInfoBottomSheetController($mdBottomSheet, entity) {
        var vm = this;

        vm.invoiceInfo = entity.invoiceInfo;
        vm.mode = entity.mode; // MAIN_ACTIONS , OTHER_ACTIONS ,
        vm.showUseCredit = entity.showUseCredit; // MAIN_ACTIONS , OTHER_ACTIONS ,

        vm.itemClick = itemClick;
        vm.close = close;
        vm.canEditInsertPaymentLog = canEditInsertPaymentLog;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }


        function canEditInsertPaymentLog() {


            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID'))
                return false;

            return true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoActionsV2Controller', InvoiceInfoActionsV2Controller);

    InvoiceInfoActionsV2Controller.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', 'InvoiceInfoCustom', 'DialogService', 'PaymentLogCustom', '$mdBottomSheet', '$window', 'CompanyCustomerCustom', '$mdDialog', '$mdMedia'];

    function InvoiceInfoActionsV2Controller($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, InvoiceInfoCustom, DialogService, PaymentLogCustom, $mdBottomSheet, $window, CompanyCustomerCustom, $mdDialog, $mdMedia) {

        var vm = this;

        vm.invoiceInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.findStatusStyle = findStatusStyle;
        vm.finalizeInvoiceInfo = finalizeInvoiceInfo;
        vm.voidInvoice = voidInvoice;
        vm.editInvoiceInfo = editInvoiceInfo;
        vm.settlementInvoice = settlementInvoice;
        vm.insertPayment = insertPayment;
        vm.isBalanced = isBalanced;
        vm.findBalanceStyle = findBalanceStyle;
        vm.deletePaymentLog = deletePaymentLog;
        vm.openMenu = openMenu;
        vm.originatorEv = null;
        vm.showOtherActionsButton = true;
        vm.canEditPaymentLog = canEditPaymentLog;
        vm.printInvoiceInfo = printInvoiceInfo;
        vm.goToCustomerDetail = goToCustomerDetail;
        vm.sendInvoiceToCustomer = sendInvoiceToCustomer;
        vm.showWithdrawFromWalletModal = showWithdrawFromWalletModal;

        vm.closeModal = closeModal;
        vm.okModal = okModal;

        $rootScope.$broadcast('hideNavBar');

        load();

        function load() {

            setRemainAmount();

        }

        function setRemainAmount() {
            vm.invoiceInfo.remainAmount = vm.invoiceInfo.finalPrice;
            var sumPayedAmount = 0;
            if (vm.invoiceInfo && vm.invoiceInfo.paymentLogs) {
                angular.forEach(vm.invoiceInfo.paymentLogs, function (payment) {
                    sumPayedAmount += payment.amount;
                })
            }

            vm.invoiceInfo.remainAmount -= sumPayedAmount;
        }

        function clear() {
        }

        function save() {
            // vm.isSaving = true;
            // if (vm.invoiceInfo.id !== null) {
            //     InvoiceInfo.update(vm.invoiceInfo, onSaveSuccess, onSaveError);
            // } else {
            //     InvoiceInfo.save(vm.invoiceInfo, onSaveSuccess, onSaveError);
            // }
        }

        function onSaveSuccess(result) {

            vm.isSaving = false;
            // $state.transitionTo('supplierPanel-v2.editOrderBag', {id: result.id});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');

                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name) {
                if ($rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoList'
                    || $rootScope.fromState.name == 'supplierPanel-v2.newInvoiceInfo'
                    || $rootScope.fromState.name == 'supplierPanel-v2.editInvoiceInfo'
                    || $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail.editCompanyCustomer'
                    || $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail.delete'
                ) {
                        $state.go('supplierPanel-v2.invoiceInfoList', $rootScope.fromStateParams);
                   
                    return;
                } else {
                    if ($rootScope.fromStateParams) {
                        if($rootScope.fromState.name == "supplierPanel-v2.companyApprovalPaymentLogListV2") {
                            $state.go($rootScope.fromState.name, $rootScope.fromStateParams);    
                            return
                        }
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }

            $state.go('supplierPanel-v2.invoiceInfoList');

        }

        function okModal() {
            save();

        }


        function findStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }

        function voidInvoice() {

        }


        function editInvoiceInfo() {
            InvoiceInfoCustom.makeInvoiceEditable().save(vm.invoiceInfo.id, onMakeEditableSuccess, onMakeEditableError);

            function onMakeEditableSuccess(result) {
                $state.transitionTo('supplierPanel-v2.editInvoiceInfo', {id: vm.invoiceInfo.id});
            }

            function onMakeEditableError(result) {

            }
        }

        function insertPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog-v2.html',
                controller: 'InvoiceInfoPaymentLogDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            traceCode: null,
                            paymentType: null,
                            createDate: null,
                            id: null,
                            invoiceInfoId: vm.invoiceInfo.id
                        };
                    }]
                }
            }).result.then(function (v) {

                vm.invoiceInfo.paymentLogs.push({
                    id: v.id,
                    traceCode: v.traceCode,
                    paymentType: v.paymentType,
                    createDate: v.createDate,
                    amount: v.amount,
                    moreInfo: v.moreInfo
                });

                reload();
            }, function () {
                //nothing
            });
        }

        function settlementInvoice() {
            if (vm.invoiceInfo.remainAmount == 0 || vm.invoiceInfo.finalPrice == 0)
                return;

            var paymentLog = {};
            paymentLog.amount = vm.invoiceInfo.remainAmount;
            paymentLog.paymentType = 'UNKNOWN';
            paymentLog.invoiceInfoId = vm.invoiceInfo.id;

            PaymentLogCustom.createPaymentLogByInvoiceInfoId().save(paymentLog, onSettlementSaveSuccess, onSettlementSaveError);


            function onSettlementSaveSuccess(result) {
                vm.invoiceInfo.paymentLogs.push({
                    id: result.id,
                    traceCode: result.traceCode,
                    paymentType: result.paymentType,
                    createDate: result.createDate,
                    amount: result.amount
                });

                vm.invoiceInfo.remainAmount -= result.amount;
            }

            function onSettlementSaveError() {

            }
        }

        function isBalanced() {
            return (vm.invoiceInfo.remainAmount == 0);

        }

        function findBalanceStyle() {
            if (vm.invoiceInfo.remainAmount == 0) {
                return "panel-success";
            } else {
                return "panel-danger";
            }
        }

        function reload() {
            InvoiceInfoCustom.getInvoiceWithItemsById(vm.invoiceInfo.id).query(function (data) {
                vm.invoiceInfo = data;
                setRemainAmount();
            });


        }


        function finalizeInvoiceInfo() {

            if (vm.invoiceInfo.status == "SETTLEMENT") {
                DialogService.showAlert("هشدار", "وضعیت فاکتور نهایی شده است");
                return;
            }

            if (vm.invoiceInfo.finalPrice > 0 && vm.invoiceInfo.remainAmount > 0) {
                DialogService.showAlert("هشدار", "برای نهایی کردن فاکتور، باید مبلغ فاکتور تسویه شده باشد");
                return;
            }

            DialogService.showConfirmV2("بعد از نهایی کردن فاکتور امکان ویرایش وجود ندارد. ادامه عملیات را تایید می فرمایید ؟").then(function () {

                InvoiceInfoCustom.finalizeInvoiceInfo().save(vm.invoiceInfo.id, finalizeSuccess, finalizeError);

            });


            function finalizeSuccess(result) {
                vm.invoiceInfo.status = "SETTLEMENT";
                reload();
            }

            function finalizeError(result) {

            }
        }

        function deletePaymentLog(paymentLog) {
            if(paymentLog.managerApprovalStatus === 'CHECKING' || paymentLog.managerApprovalStatus === 'DENIED' || paymentLog.managerApprovalStatus === 'APPROVED') return
            if (paymentLog != null) {
                if (paymentLog.paymentType == 'ONLINE')
                    return;

                DialogService.showConfirmV2("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    PaymentLogCustom.deletePaymentLogById().delete({id: paymentLog.id},
                        function () {
                            reload();
                        });

                });
            }
        }

        function openMenu($mdOpenMenu, ev) {
            vm.originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function canEditPaymentLog(paymentLog) {


            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID'))
                return false;

            if (paymentLog && paymentLog.paymentType == 'ONLINE')
                return false;

            return true;
        }

        function deleteInvoiceInfo() {
            $state.go('supplierPanel-v2.invoiceInfoDetail.delete', {id: vm.invoiceInfo.id});
        }

        vm.mainActions = function () {
            openBottomSheet('MAIN_ACTIONS');
        }
        vm.otherActions = function () {
            openBottomSheet('OTHER_ACTIONS');
        }


        function openBottomSheet(mode) {
            $mdBottomSheet.show({
                templateUrl: 'app/entities/invoice-info/invoice-info-bottom-sheet-template.html',
                controller: 'InvoiceInfoBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: (function () {
                        return {
                            invoiceInfo: vm.invoiceInfo,
                            mode: mode,
                            showUseCredit: vm.invoiceInfo.remainAmount > 0 && vm.canEditPaymentLog()
                        };
                    })


                },
            }).then(function (result) {
                switch (result) {
                    case 'editInvoiceInfo':
                        editInvoiceInfo();
                        break;
                    case 'finalizeInvoiceInfo':
                        finalizeInvoiceInfo();
                        break;
                    case 'deleteInvoiceInfo':
                        deleteInvoiceInfo();
                        break;
                    case 'settlementInvoice':
                        settlementInvoice();
                        break;
                    case 'insertPayment':
                        insertPayment();
                        break;
                    case 'sendInvoiceToCustomer':
                        sendInvoiceToCustomer();
                        break;
                    case 'useCredit':
                        showWithdrawFromWalletModal();
                        break;

                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

        function printInvoiceInfo() {
            var url = $state.href('supplierPanel-v2.printInvoiceInfo', {id: vm.invoiceInfo.id});
            $window.open(url, '_blank');
        }


        function goToCustomerDetail() {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(vm.invoiceInfo.customer.id).query().$promise.then(onGetSuccess);
                    }
                });
        }

        function onGetSuccess(result) {

            vm.companyCustomer = result;
            $state.go('supplierPanel-v2.invoiceInfoDetail.editCompanyCustomer', {id: vm.companyCustomer.id});

        }

        function sendInvoiceToCustomer() {

            InvoiceInfoCustom.sendInvoiceInfoToCustomer().save(vm.invoiceInfo.id, onSuccess, onError);

            function onSuccess() {

            }

            function onError() {

            }
        }
        $scope.calcManagerApprovalStatus = function(status) {
             switch(status) {
                case 'APPROVED': return 'تایید شده';
                case 'DENIED': return 'رد شده';
                case 'CHECKING': return 'درحال بررسی';
                default: return '';
            }
        };
        $scope.getStatusClass = function(status) {
            switch(status) {
                case 'APPROVED': return 'status-approved';
                case 'DENIED': return 'status-denied';
                case 'CHECKING': return 'status-chicking';
                default: return 'status-unknown';
            }
        };

        function showWithdrawFromWalletModal() {
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/wallet/wallet-withdraw-balance-dialog.html',
                controller: ['$scope', 'customerId', 'withdrawAmount', 'invoiceInfoId', function ($scope, customerId, withdrawAmount, invoiceInfoId) {
                    $scope.customerId = customerId;
                    $scope.withdrawAmount = withdrawAmount;
                    $scope.invoiceInfoId = invoiceInfoId;
                }],
                locals: {
                    customerId: vm.invoiceInfo.customer.id, 
                    withdrawAmount: vm.invoiceInfo.remainAmount,
                    invoiceInfoId: vm.invoiceInfo.id
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (res) {
                if (res) {
                    reload()
                    // onSettlementSaveSuccess(res)
                }
            });
        }
         $scope.getDynamicStyleRemoveIcon = function(paymentLog) {
            var color = "red";
            if(paymentLog.onlineGateway === "WALLET_CUSTOMER_WEB")
                color = 'unset';
            return {
                color: color
            };
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('InvoiceInfoCustom', InvoiceInfoCustom);

    InvoiceInfoCustom.$inject = ['$resource'];

    function InvoiceInfoCustom($resource) {


        var getInvoiceByOrderBagId = function (OrderBagId) {

            var resourceUrl = 'api/get-invoice-by-order-bag/' + OrderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var getInvoiceWithItemsById = function (invoiceInfoId) {

            var resourceUrl = 'api/get-invoice-with-items-by-id/' + invoiceInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var makeInvoiceEditable = function () {
            var resourceUrl = 'api/make-invoice-editable';
            return $resource(resourceUrl, {}, {}
            );
        };

        var finalizeInvoiceInfo = function () {
            var resourceUrl = 'api/finalize-invoice-info';
            return $resource(resourceUrl, {}, {}
            );
        };


        var sendInvoiceInfoToCustomer = function () {
            var resourceUrl = 'api/send-invoice-info-to-customer';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getInvoiceByCustomerId = function (customerId) {

            var resourceUrl = 'api/get-invoice-infos-by-customer-id/' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var searchInvoiceInfoByQueryPage = function () {
            var resourceUrl = 'api/search-invoice-info-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        return {
            getInvoiceByOrderBagId: getInvoiceByOrderBagId,
            getInvoiceWithItemsById: getInvoiceWithItemsById,
            makeInvoiceEditable: makeInvoiceEditable,
            finalizeInvoiceInfo: finalizeInvoiceInfo,
            sendInvoiceInfoToCustomer: sendInvoiceInfoToCustomer,
            getInvoiceByCustomerId: getInvoiceByCustomerId,
            searchInvoiceInfoByQueryPage: searchInvoiceInfoByQueryPage


        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('invoice-info', {
                parent: 'entity',
                url: '/invoice-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.invoiceInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-infos.html',
                        controller: 'InvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-info-detail', {
                parent: 'entity',
                url: '/invoice-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.invoiceInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-detail.html',
                        controller: 'InvoiceInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'InvoiceInfo', function ($stateParams, InvoiceInfo) {
                        return InvoiceInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('invoice-info.new', {
                parent: 'invoice-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog.html',
                        controller: 'InvoiceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('invoice-info');
                    });
                }]
            })
            .state('invoice-info.edit', {
                parent: 'invoice-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog.html',
                        controller: 'InvoiceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('invoice-info.delete', {
                parent: 'invoice-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('InvoiceInfo', InvoiceInfo);

    InvoiceInfo.$inject = ['$resource', 'DateUtils'];

    function InvoiceInfo($resource, DateUtils) {
        var resourceUrl = 'api/invoice-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('InvoiceInfoSearch', InvoiceInfoSearch);

    InvoiceInfoSearch.$inject = ['$resource'];

    function InvoiceInfoSearch($resource) {
        var resourceUrl = 'api/_search/invoice-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoController', InvoiceInfoController);

    InvoiceInfoController.$inject = ['$scope', '$state', 'InvoiceInfo', 'InvoiceInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$rootScope', '$uibModal', 'Principal', 'DialogService', 'InvoiceInfoCustom', '$mdDialog', 'QueryParamsService'];

    function InvoiceInfoController($scope, $state, InvoiceInfo, InvoiceInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants, $rootScope, $uibModal, Principal, DialogService, InvoiceInfoCustom, $mdDialog, QueryParamsService) {

        var vm = this;

        // vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;


        vm.editInvoiceInfo = editInvoiceInfo;
        vm.searchInvoiceInfos = search;
        vm.newInvoiceInfo = newInvoiceInfo;
        vm.clearSearch = clearSearch;
        vm.findStatusStyle = findStatusStyle;
        vm.filterQuery = {};

        //must set in cache
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.isSearching = false;
        vm.pageSizeChanged = pageSizeChanged;
        vm.showEducation = showEducation;
        $scope.filters = QueryParamsService.getFilters();
        
        loadData();

        // loadAll_paging();


        function loadData() {
            filterInvoiceInfo();
        }

        // function loadAll_paging() {

        //     if (pagingParams.search) {
        //         InvoiceInfoSearch.query({
        //             query: pagingParams.search,
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     } else {
        //         InvoiceInfoSearch.query({
        //             query: "",
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     }

        //     function sort() {
        //         var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        //         if (vm.predicate !== 'id') {
        //             result.push('id');
        //         }
        //         return result;
        //     }

        //     function onSuccess(data, headers) {
        //         vm.links = ParseLinks.parse(headers('link'));
        //         vm.totalItems = headers('X-Total-Count');
        //         vm.queryCount = vm.totalItems;
        //         vm.invoiceInfos = data;
        //         vm.page = pagingParams.page;
        //     }

        //     function onError(error) {
        //         AlertService.error(error.data.message);
        //     }
        // }

        // function loadPage(page) {
        //     vm.page = page;
        //     vm.transition();
        // }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getInvoiceInfoPagesByQuery(vm.filterQuery);
            else
                getInvoiceInfoPagesByQuery();

        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.advancedSearch();
            }
        }


        function clearSearch() {
            QueryParamsService.removeFilter('searchText')
            vm.filterQuery.searchText = null;
            filterInvoiceInfo_Global();
        }

        function newInvoiceInfo() {

            var result;

            result = Principal.hasSpecialFeatureAccess("invoice");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.go('supplierPanel-v2.newInvoiceInfo');
        }


        function editInvoiceInfo(invoiceInfo) {
            if (invoiceInfo.status == 'TEMP')
                $state.go('supplierPanel-v2.editInvoiceInfo', {id: invoiceInfo.id});
            if (invoiceInfo.status == 'UNPAID' || invoiceInfo.status == 'SETTLEMENT' || invoiceInfo.status == 'VOID')
                $state.go('supplierPanel-v2.invoiceInfoDetail', {id: invoiceInfo.id});

        }

        function findStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }


        vm.advancedSearch = function () {
            QueryParamsService.updateFilter('searchText', vm.filterQuery.searchText)
            clear();
            vm.filterQuery.searchMode = true;
            filterInvoiceInfo();
        }

        function pageSizeChanged() {
            QueryParamsService.updateFilter('pageSize', vm.pageSize)
            clear();
            filterOrderBag();
        }

        function getInvoiceInfoPagesByQuery(customFilter) {

            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;


            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;

            InvoiceInfoCustom.searchInvoiceInfoByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoiceInfos = data;
                vm.isSearching = false;

                gotToTop();
                // vm.page = vm.filterQuery.pageNumber+1;
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }


        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function filterInvoiceInfo_Global() {
            vm.filterQuery.searchMode = true;
            filterInvoiceInfo();
            clear();

        }

        function filterInvoiceInfo(customFilter) {

            if (vm.isSearching)
                return;
            getQueryParams()
            getInvoiceInfoPagesByQuery(customFilter);
        }

        //Filter Dialog
        var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;


            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];

        vm.showFilterDialog = function () {

            var dialogData_ = {};
            dialogData_.statusList = ["TEMP", "SETTLEMENT", "UNPAID", "VOID"];
            dialogData_.filterQuery = vm.filterQuery;


            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/entities/invoice-info/filter-invoice-info-list-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                size: 'lg',
                fullscreen: false

            })
                .then(function (data) {
                    setFilterQuery(data.filterQuery, true);
                    QueryParamsService.updateFilter('filterQuery', encodeURIComponent(JSON.stringify(data.filterQuery)))
                    vm.advancedSearch();
                }, function () {
                });
        }

        function setFilterQuery(filter,  ignorSearchText) {
            var shallowFilter = filter
            if(ignorSearchText &&  shallowFilter.searchText) delete shallowFilter.searchText
            angular.extend(vm.filterQuery, filter);
            countFilters();
        }

        function countFilters() {

            vm.filterCount = 0;
            var date = new Date();

            if (vm.filterQuery.fromDate)
                vm.filterCount++;
            if (vm.filterQuery.toDate)
                vm.filterCount++;
            if (vm.filterQuery.status && vm.filterQuery.status.length > 0)
                vm.filterCount++;
            if(vm.filterCount < 1) 
                QueryParamsService.removeFilter('filterQuery')
        }
        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="51442125157"><script type="text/JavaScript" src="https://www.aparat.com/embed/ees396e?data[rnddiv]=51442125157&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

        function getQueryParams() {
            var newFilters = QueryParamsService.getFilters();
            // if(newFilters.page){
            //     vm.filterQuery.pageNumber = newFilters.page;
            //     vm.page = parseInt(newFilters.page);
            // }
        
            if (newFilters.page) {
                vm.filterQuery.pageNumber = parseInt(newFilters.page, 10) - 1;
                vm.page = parseInt(newFilters.page, 10);
                }
       
            if(newFilters.pageSize){
                vm.filterQuery.pageSize = newFilters.pageSize;
                vm.pageSize = newFilters.pageSize;
            }
            if(newFilters.searchText){
                vm.filterQuery.searchText = newFilters.searchText;
            }
            if(newFilters.fromDate){
                vm.filterQuery.fromDate = newFilters.fromDate;
            }
            if(newFilters.toDate){
                vm.filterQuery.toDate = newFilters.toDate;
            }
            if(newFilters.servantIds){
                vm.filterQuery.servantIds = newFilters.servantIds;
            }
            if(newFilters.serviceItemIds){
                vm.filterQuery.serviceItemIds = newFilters.serviceItemIds;
            }
            if(newFilters.status){
                vm.filterQuery.status = newFilters.status;
            }
            if(newFilters.filterQuery) {
                var newF = angular.extend(JSON.parse(decodeURIComponent(newFilters.filterQuery)), vm.filterQuery);
                setFilterQuery(newF)
            }
        }


        //..................................

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AddInvoiceItemModalController', AddInvoiceItemModalController);

    AddInvoiceItemModalController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout', 'ServiceItemCustom', 'ServiceAddOnCustom', 'ServantCustom'];

    function AddInvoiceItemModalController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout, ServiceItemCustom, ServiceAddOnCustom, ServantCustom) {

        var vm = this;
        vm.invoiceInfoItems = [];
        vm.loadAll = loadAll;
        vm.itemSelectionType = "SERVICE";
        vm.onServiceChanged = onServiceChanged;
        vm.servant_changed = servant_changed;
        vm.canEditCapacity = true;
        vm.addServiceItem = addServiceItem;
        vm.serviceItemList = null;
        vm.onServiceItemClick = onServiceItemClick;
        vm.onServiceAddOnClick = onServiceAddOnClick;
        vm.deleteItem = deleteItem;
        vm.tabChanged = tabChanged;
        vm.noItemMsg = 'هیچ آیتمی انتخاب نشده است';
        vm.noServiceAddOnMsg = 'هیچ خدمت ویژه ای تعریف نشده است';
        vm.goToServiceAddOn = goToServiceAddOn;
        vm.allServants = [];

        vm.activityTypeInfo = {};
        vm.activityTypeInfo.servantTitle = "پرسنل";


        loadAll();


        vm.closeModal = closeModal;
        vm.okModal = okModal;

        vm.getModalTitle = getModalTitle;


        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);

            getAllActiveServants();
            getAllServiceItems();
            getAllServiceAddOns();

        }

        function okModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.close(vm.invoiceInfoItems);
            }
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
                return;
            }
        }

        function getModalTitle() {
            return 'tikonApp.invoiceInfo.addInvoiceInfoItem.title';
        }


        function getAllServiceItems() {
            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (list) {
                vm.serviceItemList = list;
            })

        }


        function onServiceChanged() {

            // if(vm.selectedServiceItem)
            //     ;

        }

        function servant_changed() {

        }

        function updateServantList(then) {

            vm.servantList = [];
            if (vm.selectedServiceItem.id) {
                ServiceItemCustom.getServiceServants(vm.selectedServiceItem.id).query(function (servants) {
                    vm.servantList = servants;
                    if (vm.servantList && vm.servantList.length > 0) {
                        vm.selectedServant = vm.servantList[0];
                        if (then)
                            then();
                    } else {

                    }
                });
            }
        }

        function getAllActiveServants() {
            ServantCustom.findServantsByCompany().query(function (list) {
                vm.allServants = list;
            })
        }

        function addServiceItem() {
            if (!vm.selectedServiceItem)
                return;

            var item = {};
            item.title = vm.selectedServiceItem.itemTitle;
            item.type = vm.itemSelectionType;
            item.description = "";
            item.price = vm.selectedServiceItem.minPrice; //vm.itemPrice;
            item.qty = 1; //vm.itemQty;
            // item.discount = 0;
            // item.vat = 0;
            item.totalRowPrice = computeRowTotalPrice(item);

            item.referencedItemId = vm.selectedServiceItem.id;

            item.randomNo = Math.floor(Math.random() * 10000);

            if (vm.selectedServant) {
                item.servant = vm.selectedServant;
                item.servantName = vm.selectedServant.personInfo.fullName;
            }

            if (vm.servantList)
                item.availableServants = vm.servantList;

            vm.invoiceInfoItems.push(item);


            resetSelectedItems();
        }


        function computeRowTotalPrice(item) {
            var total = 0;
            if (item && item.price && item.qty) {
                total = item.price && item.qty;
                if (item.discount)
                    total = total - item.discount;
            }

            return total;
        }

        function resetSelectedItems() {
            vm.selectedServiceItem = null;
        }

        function onServiceItemClick(serviceItem) {

            vm.selectedServiceItem = serviceItem;
        }

        function onServiceAddOnClick(addOn) {
            addServiceAddOn(addOn);
        }

        function addServiceAddOn(addOn) {

            if (!addOn)
                return;

            var item = {};
            item.title = addOn.title;
            item.type = vm.itemSelectionType;
            item.description = "";
            item.price = addOn.price;
            item.qty = 1;
            // item.discount = 0;
            // item.vat = 0;
            item.totalRowPrice = computeRowTotalPrice(item);
            item.referencedItemId = addOn.id;
            item.randomNo = Math.floor(Math.random() * 10000);

            if (vm.allServants)
                item.availableServants = vm.allServants;

            vm.invoiceInfoItems.push(item);
        }

        function deleteItem(item) {
            vm.invoiceInfoItems = vm.invoiceInfoItems.filter(function (invoiceItem) {
                if (invoiceItem.randomNo != item.randomNo) {
                    return invoiceItem;
                }

            })

        }

        function getAllServiceAddOns() {
            ServiceAddOnCustom.getActiveServiceAddOns().query(function (list) {
                vm.serviceAddOnList = list;
            })

        }

        function tabChanged(tabName) {
            if (tabName == 'serviceAddOnTab')
                vm.itemSelectionType = 'SERVICE_ADD_ON';
            else
                vm.itemSelectionType = 'SERVICE';

        }

        function goToServiceAddOn() {
            $state.go('supplierPanel-v2.serviceAddOnList');
            closeModal();
        }

        $scope.$watch('vm.selectedServiceItem', function () {

            if (!vm.selectedServiceItem) {
                vm.servantList = [];
                vm.selectedServant = [];

                var elem = document.getElementById("serviceListId");
                if (elem)
                    elem.focus();

                return;
            }
            updateServantList(addServiceItem);


            //set default price
            // in future must read from servant price too

            if (vm.selectedServiceItem.minPrice)
                vm.itemPrice = vm.selectedServiceItem.minPrice;
            else
                vm.itemPrice = 0;

            vm.itemQty = 1;

        })

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SingleImageDataController', SingleImageDataController);

    SingleImageDataController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ImageData', 'AlbumInfo'];

    function SingleImageDataController($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ImageData, AlbumInfo) {
        var vm = this;

        vm.imageData = entity;
        vm.file1 = entity.imageData
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.imagesrc = DataUtils.imagesrc;
        vm.save = save;
        vm.albuminfos = AlbumInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.imageData.id !== null) {
                ImageData.update(vm.imageData, onSaveSuccess, onSaveError);
            } else {
                ImageData.save(vm.imageData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:imageDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.setFileData = function ($file, imageData) {
            //
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        imageData.fileData = base64Data;
                        imageData.fileDataContentType = $file.type;

                        //        vm.setThumbnailData(imageData.fileData,imageData.fileDataContentType);
                    });
                });
            }
        };
        vm.setThumbnailData = function (fileData, fileType) {
            $scope.$apply(function () {
                imageData.thumbnailData = fileData;
                imageData.thumbnailDataContentType = fileType;
            });


        }

        vm.setThumbnailData = function ($file, imageData) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        imageData.thumbnailData = base64Data;
                        imageData.thumbnailDataContentType = $file.type;
                    });
                });
            }
        };

    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ImageDataExtended', ImageDataExtended);

    ImageDataExtended.$inject = ['$resource'];

    function ImageDataExtended($resource) {
        return {
            uploadImage: uploadImage
        };

        function uploadImage(file, caption, albumInfo) {
            var resourceUrl = 'api/upload-image';

            return $resource(resourceUrl, {
                save: {
                    method: "POST"
                    //transformRequest: angular.identity,
                    //   headers: { 'Content-Type': undefined }
                }
            }, {});
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ImageDataDialogController', ImageDataDialogController);

    ImageDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ImageData', 'AlbumInfo'];

    function ImageDataDialogController($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ImageData, AlbumInfo) {
        var vm = this;

        vm.imageData = entity;
        vm.file1 = entity.imageData
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.imagesrc = DataUtils.imagesrc;
        vm.save = save;
        vm.albuminfos = AlbumInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.imageData.id !== null) {
                ImageData.update(vm.imageData, onSaveSuccess, onSaveError);
            } else {
                ImageData.save(vm.imageData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:imageDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.setFileData = function ($file, imageData) {
            //
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        imageData.fileData = base64Data;
                        imageData.fileDataContentType = $file.type;

                        //        vm.setThumbnailData(imageData.fileData,imageData.fileDataContentType);
                    });
                });
            }
        };
        vm.setThumbnailData = function (fileData, fileType) {
            $scope.$apply(function () {
                imageData.thumbnailData = fileData;
                imageData.thumbnailDataContentType = fileType;
            });


        }

        vm.setThumbnailData = function ($file, imageData) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        imageData.thumbnailData = base64Data;
                        imageData.thumbnailDataContentType = $file.type;
                    });
                });
            }
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ImageDataDetailController', ImageDataDetailController);

    ImageDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'ImageData', 'AlbumInfo'];

    function ImageDataDetailController($scope, $rootScope, $stateParams, DataUtils, entity, ImageData, AlbumInfo) {
        var vm = this;

        vm.imageData = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('tikonApp:imageDataUpdate', function (event, result) {
            vm.imageData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ImageDataDeleteController', ImageDataDeleteController);

    ImageDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'ImageData'];

    function ImageDataDeleteController($uibModalInstance, entity, ImageData) {
        var vm = this;

        vm.imageData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ImageData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('image-data', {
                parent: 'entity',
                url: '/image-data?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.imageData.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/image-data/image-data.html',
                        controller: 'ImageDataController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('imageData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('image-data-detail', {
                parent: 'entity',
                url: '/image-data/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.imageData.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/image-data/image-data-detail.html',
                        controller: 'ImageDataDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('imageData');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ImageData', function ($stateParams, ImageData) {
                        return ImageData.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('image-data.new', {
                parent: 'image-data',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/image-data/image-data-dialog.html',
                        controller: 'ImageDataDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileName: null,
                                    caption: null,
                                    fileType: null,
                                    fileData: null,
                                    fileDataContentType: null,
                                    thumbnailData: null,
                                    thumbnailDataContentType: null,
                                    isCoverImage: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('image-data', null, {reload: true});
                    }, function () {
                        $state.go('image-data');
                    });
                }]
            })
            .state('image-data.edit', {
                parent: 'image-data',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/image-data/image-data-dialog.html',
                        controller: 'ImageDataDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ImageData', function (ImageData) {
                                return ImageData.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('image-data', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('image-data.delete', {
                parent: 'image-data',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/image-data/image-data-delete-dialog.html',
                        controller: 'ImageDataDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ImageData', function (ImageData) {
                                return ImageData.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('image-data', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ImageData', ImageData);

    ImageData.$inject = ['$resource'];

    function ImageData($resource) {
        var resourceUrl = 'api/image-data/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ImageDataSearch', ImageDataSearch);

    ImageDataSearch.$inject = ['$resource'];

    function ImageDataSearch($resource) {
        var resourceUrl = 'api/_search/image-data/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ImageDataController', ImageDataController);

    ImageDataController.$inject = ['$scope', '$state', 'DataUtils', 'ImageData', 'ImageDataSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ImageDataController($scope, $state, DataUtils, ImageData, ImageDataSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ImageDataSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ImageData.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.imageData = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('FinancialSettingDialogController', FinancialSettingDialogController);

    FinancialSettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FinancialSetting'];

    function FinancialSettingDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, FinancialSetting) {
        var vm = this;

        vm.financialSetting = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.financialSetting.id !== null) {
                FinancialSetting.update(vm.financialSetting, onSaveSuccess, onSaveError);
            } else {
                FinancialSetting.save(vm.financialSetting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:financialSettingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('FinancialSettingDetailController', FinancialSettingDetailController);

    FinancialSettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FinancialSetting'];

    function FinancialSettingDetailController($scope, $rootScope, $stateParams, entity, FinancialSetting) {
        var vm = this;

        vm.financialSetting = entity;

        var unsubscribe = $rootScope.$on('tikonApp:financialSettingUpdate', function (event, result) {
            vm.financialSetting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('FinancialSettingDeleteController', FinancialSettingDeleteController);

    FinancialSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'FinancialSetting'];

    function FinancialSettingDeleteController($uibModalInstance, entity, FinancialSetting) {
        var vm = this;

        vm.financialSetting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            FinancialSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('financial-setting', {
                parent: 'entity',
                url: '/financial-setting?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.financialSetting.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/financial-setting/financial-settings.html',
                        controller: 'FinancialSettingController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('currency');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('financial-setting-detail', {
                parent: 'entity',
                url: '/financial-setting/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.financialSetting.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/financial-setting/financial-setting-detail.html',
                        controller: 'FinancialSettingDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'FinancialSetting', function ($stateParams, FinancialSetting) {
                        return FinancialSetting.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('financial-setting.new', {
                parent: 'financial-setting',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/financial-setting/financial-setting-dialog.html',
                        controller: 'FinancialSettingDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    taxPercentage: null,
                                    hasDiscount: null,
                                    currency: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('financial-setting', null, {reload: true});
                    }, function () {
                        $state.go('financial-setting');
                    });
                }]
            })
            .state('financial-setting.edit', {
                parent: 'financial-setting',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/financial-setting/financial-setting-dialog.html',
                        controller: 'FinancialSettingDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FinancialSetting', function (FinancialSetting) {
                                return FinancialSetting.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('financial-setting', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('financial-setting.delete', {
                parent: 'financial-setting',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/financial-setting/financial-setting-delete-dialog.html',
                        controller: 'FinancialSettingDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['FinancialSetting', function (FinancialSetting) {
                                return FinancialSetting.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('financial-setting', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('FinancialSetting', FinancialSetting);

    FinancialSetting.$inject = ['$resource'];

    function FinancialSetting($resource) {
        var resourceUrl = 'api/financial-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('FinancialSettingSearch', FinancialSettingSearch);

    FinancialSettingSearch.$inject = ['$resource'];

    function FinancialSettingSearch($resource) {
        var resourceUrl = 'api/_search/financial-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('FinancialSettingController', FinancialSettingController);

    FinancialSettingController.$inject = ['$scope', '$state', 'FinancialSetting', 'FinancialSettingSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FinancialSettingController($scope, $state, FinancialSetting, FinancialSettingSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                FinancialSettingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FinancialSetting.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.financialSettings = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ExtraSettingDialogController', ExtraSettingDialogController);

    ExtraSettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExtraSetting', 'SettingInfo'];

    function ExtraSettingDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ExtraSetting, SettingInfo) {
        var vm = this;

        vm.extraSetting = entity;
        vm.clear = clear;
        vm.save = save;
        vm.settinginfos = SettingInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.extraSetting.id !== null) {
                ExtraSetting.update(vm.extraSetting, onSaveSuccess, onSaveError);
            } else {
                ExtraSetting.save(vm.extraSetting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:extraSettingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ExtraSettingDetailController', ExtraSettingDetailController);

    ExtraSettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ExtraSetting', 'SettingInfo'];

    function ExtraSettingDetailController($scope, $rootScope, $stateParams, entity, ExtraSetting, SettingInfo) {
        var vm = this;

        vm.extraSetting = entity;

        var unsubscribe = $rootScope.$on('tikonApp:extraSettingUpdate', function (event, result) {
            vm.extraSetting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ExtraSettingDeleteController', ExtraSettingDeleteController);

    ExtraSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExtraSetting'];

    function ExtraSettingDeleteController($uibModalInstance, entity, ExtraSetting) {
        var vm = this;

        vm.extraSetting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ExtraSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('extra-setting', {
                parent: 'entity',
                url: '/extra-setting?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.extraSetting.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/extra-setting/extra-settings.html',
                        controller: 'ExtraSettingController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('extraSetting');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('extra-setting-detail', {
                parent: 'entity',
                url: '/extra-setting/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.extraSetting.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/extra-setting/extra-setting-detail.html',
                        controller: 'ExtraSettingDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('extraSetting');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ExtraSetting', function ($stateParams, ExtraSetting) {
                        return ExtraSetting.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('extra-setting.new', {
                parent: 'extra-setting',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/extra-setting/extra-setting-dialog.html',
                        controller: 'ExtraSettingDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    key: null,
                                    value: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('extra-setting', null, {reload: true});
                    }, function () {
                        $state.go('extra-setting');
                    });
                }]
            })
            .state('extra-setting.edit', {
                parent: 'extra-setting',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/extra-setting/extra-setting-dialog.html',
                        controller: 'ExtraSettingDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ExtraSetting', function (ExtraSetting) {
                                return ExtraSetting.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('extra-setting', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('extra-setting.delete', {
                parent: 'extra-setting',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/extra-setting/extra-setting-delete-dialog.html',
                        controller: 'ExtraSettingDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ExtraSetting', function (ExtraSetting) {
                                return ExtraSetting.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('extra-setting', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ExtraSetting', ExtraSetting);

    ExtraSetting.$inject = ['$resource'];

    function ExtraSetting($resource) {
        var resourceUrl = 'api/extra-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ExtraSettingSearch', ExtraSettingSearch);

    ExtraSettingSearch.$inject = ['$resource'];

    function ExtraSettingSearch($resource) {
        var resourceUrl = 'api/_search/extra-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ExtraSettingController', ExtraSettingController);

    ExtraSettingController.$inject = ['$scope', '$state', 'ExtraSetting', 'ExtraSettingSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ExtraSettingController($scope, $state, ExtraSetting, ExtraSettingSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ExtraSettingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ExtraSetting.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.extraSettings = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("EventServicesController", EventServicesController);

  EventServicesController.$inject = ["$timeout"];

  function EventServicesController($timeout) {
  }
})();


;
(function () {
    'use strict';


    angular
        .module('tikonApp')
        .controller('GeneralEventItemController', GeneralEventItemController);

    GeneralEventItemController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceCategoryCustom', 'CompanyCustom', '$translate', '$translatePartialLoader', '$state', 'ServiceItemCustom', 'TimingInfo', '$mdDialog', 'AlertToastService', '$window'];

    function GeneralEventItemController($timeout, $scope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceCategoryCustom, CompanyCustom, translate, translatePartialLoader, $state, ServiceItemCustom, TimingInfo, $mdDialog, AlertToastService, $window) {
        var vm = this;
        vm.scope = $scope;
        vm.scheduleFormState = 'list';
        vm.priceInfoFormState = "'list'";
        vm.serviceOptionInfoFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.serviceItem = entity;
        vm.oldItem = angular.copy(vm.serviceItem);
        vm.mainScheduleType = 'SERVICE_SCHEDULE';
        vm.saveAndGotoScheduling = saveAndGotoScheduling;
        vm.weekDayExists = weekDayExists;
        vm.toggleWeekDay = toggleWeekDay;
        vm.weekDays = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
        // vm.isCopyChecked = false;

        //vm.clear = clear;
        vm.save = save;
        vm.categoryName = categoryName;
        vm.showFullDescription = showFullDescription;
        vm.fullDescription = false;
        vm.showAdvancedSetting = showAdvancedSetting;
        vm.advancedSetting = false;
        //vm.serviceoptioninfos = ServiceOptionInfo.query();
        //vm.discountinfos = DiscountInfo.query();
        //vm.locationinfos = LocationInfo.query();
        //vm.albuminfos = AlbumInfo.query();
        //vm.servicecapacityinfos = ServiceCapacityInfo.query();
        //vm.servicecategories = ServiceCategory.query();
        //
        vm.showDuration = showDuration;
        vm.confirmationType_Change = confirmationType_Change;
        if (vm.serviceItem.multiReserveMode == undefined)
            vm.serviceItem.multiReserveMode = "DISABLE";
        vm.serviceColors = ['COLOR0', 'COLOR1', 'COLOR2', 'COLOR3', 'COLOR4', 'COLOR5'];
        vm.hasServant = hasServant;
        vm.hasServants = false;
        vm.showOnMarketPlace = false;
        vm.findMarketPlacePublishStatusStyle = findMarketPlacePublishStatusStyle;
        vm.findMarketPlacePublishStatusIcon = findMarketPlacePublishStatusIcon;

        vm.showMarketPlaceSection = false;
        vm.isVideoMeeting = false;
        vm.meetingCheckChange = meetingCheckChange;
        vm.meetingPrefixLink = '';
        vm.meetingServantPrefixLink = '';
        vm.meetingLink = '';
        vm.servantMeetingLink = '';
        vm.goToVideoCallEvent = goToVideoCallEvent;
        vm.onlineMeetingAccessType_Change = onlineMeetingAccessType_Change;
        vm.showSection = showSection;
        vm.copyEventInfo = copyEventInfo;

        initDefault();
        // vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {


            vm.servicecategories = result;
            if (vm.serviceItem.category == null || vm.serviceItem.category == undefined || vm.serviceItem.category.id == null || vm.serviceItem.category.id == undefined) {
                angular.forEach(result, function (category) {

                    if (category.categoryName == "DEFAULT_CATEGORY") {
                        vm.serviceItem.category = category;
                    }

                });
            }

            angular.forEach(vm.servicecategories, function (category) {

                    category.categoryName = categoryName(category.categoryName)
                }
            );


            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('marketPlacePublishStatus');
            translatePartialLoader.addPart('onlineMeetingType');
            translatePartialLoader.addPart('onlineMeetingAccessType');
            translatePartialLoader = translate.refresh();

        });

        if (vm.serviceItem.maxPreReserveTime == null || vm.serviceItem.maxPreReserveTime == undefined)
            vm.serviceItem.maxPreReserveTime = 30;
        if (vm.serviceItem.minPreReserveTime == null || vm.serviceItem.minPreReserveTime == undefined)
            vm.serviceItem.minPreReserveTime = 0;


        //vm.priceinfos = PriceInfo.query();
        //vm.scheduleinfos = ScheduleInfo.query();
        //vm.servants = Servant.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.metatags = MetaTag.query();
        vm.paymentType_changed = paymentType_changed;
        vm.priceInfoFormReload = false;
        //   vm.currentScheduleInfo= vm.serviceItem.scheduleInfo;
        //   vm.backToList=backToList;
        //   vm.onSelectedScheduleChanged=onSelectedScheduleChanged;
        //   vm.onCreateNewSchedule=onCreateNewSchedule;
        findCurrentCompany();


        // $timeout(function () {
        //     angular.element('.form-group:eq(1)>input').focus();
        // });


        if (vm.serviceItem.amenities == null || vm.serviceItem.amenities == undefined) {
            vm.serviceItem.amenities = {};
            vm.serviceItem.amenities.amenitiesList = [];
        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {


                vm.currentCompany = result;
                if (vm.currentCompany.activityType == 'WORK_SPACE') {
                    vm.priceInfoType = "fixed";
                }


                //set meeting prefix link
                vm.meetingPrefixLink = 'https://';
                vm.meetingPrefixLink += vm.currentCompany.keyUrl + __config.defaultVideoCallAddress;

                //set servant meeting prefix link
                vm.meetingServantPrefixLink = 'https://';
                vm.meetingServantPrefixLink += vm.currentCompany.keyUrl + __config.defaultServantVideoCallAddress;


                setMeetingLink();

            });
        }


        //
        //function clear () {
        //    $uibModalInstance.dismiss('cancel');
        //}

        function save() {
            updateScheduleTypeFromMainType();
            checkIfScheduleRegenerationNeeded();
            updateMarketPlaceInfo();


            vm.priceInfoFormReload = 'false';


            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;

                if (vm.serviceItem.id !== null) {

                    ServiceItem.update(vm.serviceItem, onSaveSuccess, onSaveError);
                } else {
                    ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);

                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:serviceItemUpdate', result);

            saveSchedule();

            vm.serviceItem = result;
            vm.oldItem = angular.copy(vm.serviceItem);
            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : result.scheduleInfo.id});
            //$uibModalInstance.close(result);

            vm.priceInfoFormReload = 'true';
            vm.priceInfoFormState = 'list';
            vm.serviceOptionInfoFormState = 'list';
            vm.isSaving = false;
            vm.hasServant();


            $state.go('supplierPanel.generalEventItem', {id: vm.serviceItem.id});


            if (vm.nextGotoScheduling) {
                $state.go('supplierPanel.scheduling', {id: vm.serviceItem.id});
            }

        }

        function backToList() {

            vm.scheduleFormState = 'list';
            vm.selectedScheduleId = '';
        }

        function onSelectedScheduleChanged(data) {

            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : data.id});

        }

        function onCreateNewSchedule() {

            vm.serviceItem.scheduleInfo = {};

        }

        function onCreateNewPriceInfo() {
            //

            vm.serviceItem.priceInfo = {};

        }

        function onSelectedPriceInfoChanged(data) {
            //
            //vm.serviceItem.priceInfo= PriceInfo.get({id : data.id});

        }

        function onSaveError() {
            vm.isSaving = false;
            vm.nextGotoScheduling = false;
        }


        function paymentType_changed() {

            if (vm.serviceItem.paymentType == "PAYMENT_ALL") {
                vm.serviceItem.prePaymentAmount = 0;
            }
            if (vm.serviceItem.paymentType == "PRE_PAYMENT") {
                vm.serviceItem.inPlacePayment = false;
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function showFullDescription() {
            vm.fullDescription = !vm.fullDescription;
        }

        function showAdvancedSetting() {
            vm.advancedSetting = !vm.advancedSetting;
        }

        function initDefault() {

            if ($stateParams.onlineMeetingType != null && $stateParams.onlineMeetingType != undefined) {
                vm.serviceItem.onlineMeetingType = $stateParams.onlineMeetingType;
            }

            if (vm.serviceItem.serviceStatus == null || vm.serviceItem.serviceStatus == undefined)
                vm.serviceItem.serviceStatus = 'PUBLISH_JUST_PANEL';

            if (vm.serviceItem.paymentType == null || vm.serviceItem.paymentType == undefined)
                vm.serviceItem.paymentType = 'PAYMENT_ALL';

            if (vm.serviceItem.confirmationType == null || vm.serviceItem.confirmationType == undefined)
                vm.serviceItem.confirmationType = 'ONE_STEP';

            if (vm.serviceItem.capacityInfo == null || vm.serviceItem.capacityInfo == undefined || vm.serviceItem.capacityInfo.qty == null || vm.serviceItem.capacityInfo.qty == undefined) {
                vm.serviceItem.capacityInfo = {};
                vm.serviceItem.capacityInfo.qty = 1;
            }

            if (!vm.serviceItem.duration)
                vm.serviceItem.duration = 60;
            if (!vm.serviceItem.gapTime)
                vm.serviceItem.gapTime = 0;
            if (!vm.serviceItem.consecutiveReserveMode)
                vm.serviceItem.consecutiveReserveMode = 'DISABLE';


            if (vm.serviceItem.color == null)
                vm.serviceItem.color = 'COLOR0';


            if (vm.serviceItem.prePaymentAmount == null)
                vm.serviceItem.prePaymentAmount = 0;

            if (vm.serviceItem.servantSelectMode == null)
                vm.serviceItem.servantSelectMode = 'SELECT_BY_CUSTOMER';

            if (vm.serviceItem.showOnMarketPlaceStatus == null || vm.serviceItem.showOnMarketPlaceStatus == 'NOT_SHOW')
                vm.showOnMarketPlace = false;
            else
                vm.showOnMarketPlace = true;

            vm.serviceItem.serviceMode = 'EVENT';


            if (vm.serviceItem.id == null || vm.serviceItem.id == undefined) {
                vm.serviceItem.meetingType = 'RW_VIDEO_CALL';
                vm.isVideoMeeting = true;
                vm.serviceItem.minPrice = 0;
            }


            setMainScheduleType();

            hasServant();
            checkMarketPlaceInfo();
            setMeetingType();

            if (vm.serviceItem.customMeetingLink == null || vm.serviceItem.customMeetingLink == undefined || vm.serviceItem.customMeetingLink == '') {

                var x = Math.floor(Math.random() * 999999) + 11111;
                vm.serviceItem.customMeetingLink = 'm' + x.toString();
            }

            if (vm.serviceItem.customMeetingPassword == null || vm.serviceItem.customMeetingPassword == undefined || vm.serviceItem.customMeetingPassword == '') {

                var x = Math.floor(Math.random() * 999999) + 11111;
                vm.serviceItem.customMeetingPassword = x.toString();
            }

            if (vm.serviceItem.onlineMeetingAccessType == null || vm.serviceItem.onlineMeetingAccessType == undefined) {
                vm.serviceItem.onlineMeetingAccessType = 'PUBLIC';
            }

            if (vm.serviceItem.servantMeetingPassword == null || vm.serviceItem.servantMeetingPassword == undefined || vm.serviceItem.servantMeetingPassword == '') {

                var x = Math.floor(Math.random() * 999999) + 11111;
                vm.serviceItem.servantMeetingPassword = x.toString();
            }


        }

        function setMainScheduleType() {
            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                    if (vm.serviceItem.consecutiveReserveMode != 'DISABLE')
                        vm.serviceItem.consecutiveReserveMode = 'ENABLE';
                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    vm.mainScheduleType = 'FIXED_TIME_SESSIONS';
                } else {
                    vm.mainScheduleType = 'SERVICE_SCHEDULE';
                }
            }
        }

        function updateScheduleTypeFromMainType() {

            if (vm.serviceItem.scheduleInfo == null)
                vm.serviceItem.scheduleInfo = {};

            vm.serviceItem.scheduleInfo.scheduleType = vm.mainScheduleType;

            //if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
            //    var currentType = vm.serviceItem.scheduleInfo.scheduleType;
            //    if (currentType == 'SERVICE_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
            //        if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //            currentType = 'FIXED_TIME_SESSIONS'
            //        }
            //
            //    } else if (currentType == 'FIXED_TIME_SESSIONS') {
            //        if (vm.mainScheduleType != 'FIXED_TIME_SESSIONS')
            //            currentType = 'SERVICE_SCHEDULE';
            //    } else {
            //        currentType = 'SERVICE_SCHEDULE';
            //    }
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //} else {
            //    var currentType = 'SERVICE_SCHEDULE';
            //    if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
            //        currentType = 'FIXED_TIME_SESSIONS'
            //    }
            //    if (!vm.serviceItem.scheduleInfo)vm.serviceItem.scheduleInfo = {};
            //    vm.serviceItem.scheduleInfo.scheduleType = currentType;
            //}
        }

        function saveAndGotoScheduling() {
            vm.nextGotoScheduling = true;
            vm.save();
        }

        function checkIfScheduleRegenerationNeeded() {
            vm.serviceItem.scheduleGenerationNeeded = true;
            return;
            vm.scheduleGenerationNeeded = false;
            if (vm.oldItem && vm.oldItem.scheduleInfo && vm.serviceItem && vm.serviceItem.scheduleInfo && vm.oldItem.scheduleInfo.scheduleType != vm.serviceItem.scheduleInfo.scheduleType) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.duration != vm.serviceItem.duration ||
                (vm.oldItem.capacityInfo && vm.oldItem.capacityInfo.qty != vm.serviceItem.capacityInfo.qty) ||
                vm.oldItem.maxPreReserveTime != vm.serviceItem.maxPreReserveTime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.gaptime != vm.serviceItem.gaptime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else {
                //checking servants
                if (vm.oldItem.servants.length != vm.serviceItem.servants.length)
                    vm.serviceItem.scheduleGenerationNeeded = true;
                else {
                    if (vm.oldItem.servants.length > 0) {
                        angular.forEach(vm.oldItem.servants, function (os) {
                            var isInList = false;
                            angular.forEach(vm.serviceItem.servants, function (ns) {
                                if (ns.id == os.id)
                                    isInList = true;
                            });
                            if (!isInList)
                                vm.serviceItem.scheduleGenerationNeeded = true;
                        })
                    }
                }

            }
        }

        function showDuration() {

            if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS')
                return false;

            if (vm.serviceItem == null || vm.serviceItem.serviceTimes == null)
                return true;

            if (vm.serviceItem.serviceTimes != null && vm.serviceItem.serviceTimes != undefined
                && vm.serviceItem.serviceTimes.length == 1 && vm.serviceItem.serviceTimes[0].scheduleType == 'SERVICE_SCHEDULE'
            ) {
                return true;
            }

        }

        function confirmationType_Change() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'TWO_STEP'

            ) {
                if (vm.serviceItem.customerConfirmationDeadline == null || vm.serviceItem.customerConfirmationDeadline == undefined || vm.serviceItem.customerConfirmationDeadline == 0) {
                    vm.serviceItem.customerConfirmationDeadline = 24;
                }
            }
        }

        function weekDayExists(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            var isExist = false;
            if (selectedWeekDay != undefined)
                angular.forEach(selectedWeekDay, function (item) {
                    if (item == weekDay)
                        isExist = true;
                });
            return isExist;

        }

        function toggleWeekDay(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            if (selectedWeekDay == undefined)
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays = [];

            if (vm.weekDayExists(weekDay, selectedWeekDay)) {
                var index = selectedWeekDay.indexOf(weekDay);
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.splice(index, 1);
            } else {
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.push(weekDay);
            }

        }

        function getColorClass(color) {
            return color;

        }

        function hasServant() {
            if (vm.serviceItem.servants != null && vm.serviceItem.servants.length > 0) {
                vm.hasServants = true;
            } else {
                vm.hasServants = false;
            }
        }

        function updateMarketPlaceInfo() {

            if (vm.showOnMarketPlace)
                vm.serviceItem.showOnMarketPlaceStatus = 'SHOW'
            else
                vm.serviceItem.showOnMarketPlaceStatus = 'NOT_SHOW'


            //in every save if showOnMarketPlaceStatus = 'SHOW' must set marketPlacePublishStatus = 'REQUESTED'

            if (vm.serviceItem.showOnMarketPlaceStatus == 'SHOW') {
                vm.serviceItem.marketPlacePublishStatus = 'REQUESTED'
            } else {
                vm.serviceItem.marketPlacePublishStatus = null;
            }


        }

        function findMarketPlacePublishStatusStyle() {

            return "market-place-publish-status-" + vm.serviceItem.marketPlacePublishStatus;
        }

        function findMarketPlacePublishStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-flash";
            }
            if (status == "WAITING") {
                return "glyphicon glyphicon-time";
            }
            if (status == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "DENIED") {
                return "glyphicon glyphicon-remove";
            }

        }

        function checkMarketPlaceInfo() {
            vm.showMarketPlaceSection = false;
            if (vm.serviceItem.id && vm.serviceItem.category.company.activityType == 'WORK_SPACE') {
                vm.showMarketPlaceSection = true;
            }
        }

        function meetingCheckChange() {
            if (vm.isVideoMeeting) {
                vm.serviceItem.meetingType = 'RW_VIDEO_CALL';
            } else {
                vm.serviceItem.meetingType = null;
            }
        }

        function setMeetingType() {
            if (vm.serviceItem.meetingType && vm.serviceItem.meetingType == 'RW_VIDEO_CALL') {
                vm.isVideoMeeting = true;
            } else {
                vm.isVideoMeeting = false;
            }
        }

        function saveSchedule() {
            // vm.serviceItem.scheduleInfo.serviceItemId=vm.serviceItem.id;

            if (!vm.serviceItem.id)
                return;


            if (!vm.serviceItem.scheduleInfo) {
                vm.serviceItem.scheduleInfo = {};
            }

            vm.serviceItem.scheduleInfo.serviceItemId = vm.serviceItem.id;
            vm.serviceItem.scheduleInfo.scheduleType = 'SERVICE_SCHEDULE';
            vm.serviceItem.scheduleInfo.dependencyMode = 'NON';


        }

        function setMeetingLink() {
            if (vm.meetingPrefixLink != '' && vm.serviceItem.customMeetingLink != null && vm.serviceItem.customMeetingLink != undefined && vm.serviceItem.customMeetingLink != '') {
                vm.meetingLink = vm.meetingPrefixLink + vm.serviceItem.customMeetingLink;
            }

            if (vm.meetingServantPrefixLink != '' && vm.serviceItem.customMeetingLink != null && vm.serviceItem.customMeetingLink != undefined && vm.serviceItem.customMeetingLink != '') {
                vm.servantMeetingLink = vm.meetingServantPrefixLink + vm.serviceItem.customMeetingLink;
            }
        }


        function goToVideoCallEvent() {
            var servant = {};


            if (vm.serviceItem.servants.length > 0)
                servant = vm.serviceItem.servants[0];

            $mdDialog.show({
                controller: 'JoinVideoMeetingEventComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            serviceItem: vm.serviceItem,
                            servant: servant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function onlineMeetingAccessType_Change() {


        }

        function showSection(section) {
            switch (section) {
                case 'agreementSection':
                    if (vm.serviceItem.onlineMeetingType && vm.serviceItem.onlineMeetingType != 'CONFERENCE') {
                        return true;
                    }
                    break;
                case 'reserveSettingSection':
                    if (vm.serviceItem.onlineMeetingType && vm.serviceItem.onlineMeetingType != 'CONFERENCE') {
                        if (vm.serviceItem.serviceStatus && vm.serviceItem.serviceStatus == 'PUBLISH')
                            return true;
                    }
                    break;
                case 'meetingSettingSection':
                case 'timeSection':
                case 'gallerySection':
                    if (vm.serviceItem.onlineMeetingType) {
                        return true;
                    }
                    break;
                default :
                    return false;
            }

            return false;
        }

        function copyEventInfo(forServant) {
            if (!vm.serviceItem.id) {
                AlertToastService.error('tikonApp.eventItem.copyFailed', null, null);
                return;
            }
            var text = vm.serviceItem.itemTitle;

            if (forServant) {
                text = text + '\n' + 'رمز ورود به جلسه : ' + vm.serviceItem.servantMeetingPassword
                text = text + '\n' + 'لینک ورود : ' + vm.servantMeetingLink
            } else {

                if (vm.serviceItem.onlineMeetingAccessType == 'PRIVATE')
                    text = text + '\n' + 'رمز ورود به جلسه : ' + vm.serviceItem.customMeetingPassword
                text = text + '\n' + 'لینک ورود : ' + vm.meetingLink
            }

            var body = angular.element($window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });

            textarea.val(text);
            body.append(textarea);
            textarea[0].select();
            document.execCommand('copy');
            AlertToastService.success('tikonApp.eventItem.copySuccess', null, null);


            textarea.remove();

        }

        $scope.$watch('vm.serviceItem.customMeetingLink', function (ob) {


            if (ob != null) {
                setMeetingLink();
            }
        })

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EventItemListController', EventItemListController);

    EventItemListController.$inject = ['$scope', '$state', '$stateParams', '$location', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate', '$mdDialog'];

    function EventItemListController($scope, $state, $stateParams, $location, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate, $mdDialog) {
        var vm = this;
        //

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;
        vm.copyServiceItem = copyServiceItem;
        vm.goToVideoCallEvent = goToVideoCallEvent;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function copyServiceItem(serviceItemId) {
            ServiceItemCustom.createCopyOfServiceItemById(serviceItemId).query(function (res) {
                vm.loadPage();
            });
        }

        function goToVideoCallEvent(serviceItem) {
            var servant = {};

            if (serviceItem.servants.length > 0)
                servant = serviceItem.servants[0];

            $mdDialog.show({
                controller: 'JoinVideoMeetingEventComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            serviceItem: serviceItem,
                            servant: servant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EventItemDeleteController', EventItemDeleteController);

    EventItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceItem'];

    function EventItemDeleteController($uibModalInstance, entity, ServiceItem) {
        var vm = this;


        vm.serviceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ServiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DiscountInfoDialogController', DiscountInfoDialogController);

    DiscountInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiscountInfo'];

    function DiscountInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, DiscountInfo) {
        var vm = this;

        vm.discountInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.discountInfo.id !== null) {
                DiscountInfo.update(vm.discountInfo, onSaveSuccess, onSaveError);
            } else {
                DiscountInfo.save(vm.discountInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:discountInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DiscountInfoDetailController', DiscountInfoDetailController);

    DiscountInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'DiscountInfo'];

    function DiscountInfoDetailController($scope, $rootScope, $stateParams, entity, DiscountInfo) {
        var vm = this;

        vm.discountInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:discountInfoUpdate', function (event, result) {
            vm.discountInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DiscountInfoDeleteController', DiscountInfoDeleteController);

    DiscountInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiscountInfo'];

    function DiscountInfoDeleteController($uibModalInstance, entity, DiscountInfo) {
        var vm = this;

        vm.discountInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            DiscountInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('discount-info', {
                parent: 'entity',
                url: '/discount-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.discountInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/discount-info/discount-infos.html',
                        controller: 'DiscountInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('discountInfo');
                        $translatePartialLoader.addPart('discountType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('discount-info-detail', {
                parent: 'entity',
                url: '/discount-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.discountInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/discount-info/discount-info-detail.html',
                        controller: 'DiscountInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('discountInfo');
                        $translatePartialLoader.addPart('discountType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DiscountInfo', function ($stateParams, DiscountInfo) {
                        return DiscountInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('discount-info.new', {
                parent: 'discount-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/discount-info/discount-info-dialog.html',
                        controller: 'DiscountInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fixedDiscount: null,
                                    discountType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('discount-info', null, {reload: true});
                    }, function () {
                        $state.go('discount-info');
                    });
                }]
            })
            .state('discount-info.edit', {
                parent: 'discount-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/discount-info/discount-info-dialog.html',
                        controller: 'DiscountInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['DiscountInfo', function (DiscountInfo) {
                                return DiscountInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('discount-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('discount-info.delete', {
                parent: 'discount-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/discount-info/discount-info-delete-dialog.html',
                        controller: 'DiscountInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DiscountInfo', function (DiscountInfo) {
                                return DiscountInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('discount-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('DiscountInfo', DiscountInfo);

    DiscountInfo.$inject = ['$resource'];

    function DiscountInfo($resource) {
        var resourceUrl = 'api/discount-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DiscountInfoSearch', DiscountInfoSearch);

    DiscountInfoSearch.$inject = ['$resource'];

    function DiscountInfoSearch($resource) {
        var resourceUrl = 'api/_search/discount-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DiscountInfoController', DiscountInfoController);

    DiscountInfoController.$inject = ['$scope', '$state', 'DiscountInfo', 'DiscountInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DiscountInfoController($scope, $state, DiscountInfo, DiscountInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                DiscountInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DiscountInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.discountInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DatePeriodDialogController', DatePeriodDialogController);

    DatePeriodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DatePeriod', 'OffDay', 'WeeklyScheduleInfo'];

    function DatePeriodDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, DatePeriod, OffDay, WeeklyScheduleInfo) {
        var vm = this;

        vm.datePeriod = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.offdays = OffDay.query();
        vm.weeklyscheduleinfos = WeeklyScheduleInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.datePeriod.id !== null) {
                DatePeriod.update(vm.datePeriod, onSaveSuccess, onSaveError);
            } else {
                DatePeriod.save(vm.datePeriod, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:datePeriodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DatePeriodDetailController', DatePeriodDetailController);

    DatePeriodDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'DatePeriod', 'OffDay', 'WeeklyScheduleInfo'];

    function DatePeriodDetailController($scope, $rootScope, $stateParams, entity, DatePeriod, OffDay, WeeklyScheduleInfo) {
        var vm = this;

        vm.datePeriod = entity;

        var unsubscribe = $rootScope.$on('tikonApp:datePeriodUpdate', function (event, result) {
            vm.datePeriod = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DatePeriodDeleteController', DatePeriodDeleteController);

    DatePeriodDeleteController.$inject = ['$uibModalInstance', 'entity', 'DatePeriod'];

    function DatePeriodDeleteController($uibModalInstance, entity, DatePeriod) {
        var vm = this;

        vm.datePeriod = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            DatePeriod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('date-period', {
                parent: 'entity',
                url: '/date-period?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.datePeriod.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/date-period/date-periods.html',
                        controller: 'DatePeriodController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('datePeriod');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('date-period-detail', {
                parent: 'entity',
                url: '/date-period/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.datePeriod.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/date-period/date-period-detail.html',
                        controller: 'DatePeriodDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('datePeriod');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DatePeriod', function ($stateParams, DatePeriod) {
                        return DatePeriod.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('date-period.new', {
                parent: 'date-period',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/date-period/date-period-dialog.html',
                        controller: 'DatePeriodDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fromDate: null,
                                    toDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('date-period', null, {reload: true});
                    }, function () {
                        $state.go('date-period');
                    });
                }]
            })
            .state('date-period.edit', {
                parent: 'date-period',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/date-period/date-period-dialog.html',
                        controller: 'DatePeriodDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['DatePeriod', function (DatePeriod) {
                                return DatePeriod.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('date-period', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('date-period.delete', {
                parent: 'date-period',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/date-period/date-period-delete-dialog.html',
                        controller: 'DatePeriodDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DatePeriod', function (DatePeriod) {
                                return DatePeriod.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('date-period', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('DatePeriod', DatePeriod);

    DatePeriod.$inject = ['$resource', 'DateUtils'];

    function DatePeriod($resource, DateUtils) {
        var resourceUrl = 'api/date-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.toDate = DateUtils.convertLocalDateFromServer(data.toDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                    data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
                    data.toDate = DateUtils.convertLocalDateToServer(data.toDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DatePeriodSearch', DatePeriodSearch);

    DatePeriodSearch.$inject = ['$resource'];

    function DatePeriodSearch($resource) {
        var resourceUrl = 'api/_search/date-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('DatePeriodController', DatePeriodController);
//
//    DatePeriodController.$inject = ['$scope', '$state', 'DatePeriod', 'DatePeriodSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];
//
//    function DatePeriodController ($scope, $state, DatePeriod, DatePeriodSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
//        var vm = this;
//
//        vm.loadPage = loadPage;
//        vm.predicate = pagingParams.predicate;
//        vm.reverse = pagingParams.ascending;
//        vm.transition = transition;
//        vm.clear = clear;
//        vm.search = search;
//        vm.searchQuery = pagingParams.search;
//        vm.currentSearch = pagingParams.search;
//
//        loadAll();
//
//        function loadAll () {
//            if (pagingParams.search) {
//                DatePeriodSearch.query({
//                    query: pagingParams.search,
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            } else {
//                DatePeriod.query({
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            }
//            function sort() {
//                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
//                if (vm.predicate !== 'id') {
//                    result.push('id');
//                }
//                return result;
//            }
//            function onSuccess(data, headers) {
//                vm.links = ParseLinks.parse(headers('link'));
//                vm.totalItems = headers('X-Total-Count');
//                vm.queryCount = vm.totalItems;
//                vm.datePeriods = data;
//                vm.page = pagingParams.page;
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
//
//        function transition () {
//            $state.transitionTo($state.$current, {
//                page: vm.page,
//                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
//                search: vm.currentSearch
//            });
//        }
//
//        function search (searchQuery) {
//            if (!searchQuery){
//                return vm.clear();
//            }
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = '_score';
//            vm.reverse = false;
//            vm.currentSearch = searchQuery;
//            vm.transition();
//        }
//
//        function clear () {
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = 'id';
//            vm.reverse = true;
//            vm.currentSearch = null;
//            vm.transition();
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomSettingController', CustomSettingController);

    CustomSettingController.$inject = ['$rootScope', '$scope', '$state', 'entity', 'Company', 'CompanyCustom', 'AlertService', '$translate', '$translatePartialLoader', 'Principal'];

    function CustomSettingController($rootScope, $scope, $state, entity, Company, CompanyCustom, AlertService, translate, translatePartialLoader, Principal) {
        var vm = this;

        vm.save = save;
        vm.changeCapacityViewMode = changeCapacityViewMode;
        vm.scope = $scope;
        translatePartialLoader.addPart('customSetting');
        translatePartialLoader.addPart('global');
        translatePartialLoader = translate.refresh();

        vm.company = entity;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.sys_birthdate = false;
        vm.sys_national_code = false;
        vm.sysBirthdateChange = sysBirthdateChange;
        vm.sysNationalCodeChange = sysNationalCodeChange;

        if ($state.current.parent == 'supplierPanel-v2')
            $rootScope.$broadcast('hideNavBar');


        if (vm.company.customSettingObject != undefined) {
            vm.company.customSettingObject.isClientEmailRequired = (entity.customSettingObject.isClientEmailRequired == true);
            vm.company.customSettingObject.canReserveByClient = (entity.customSettingObject.canReserveByClient != false);
            vm.company.customSettingObject.canReserveByWidget = (entity.customSettingObject.canReserveByWidget != false);
            vm.capacityViewMode = (vm.company.customSettingObject.capacityViewMode === 'SHOW');
            // vm.customSettingObject.companyCustomerCustomSettings.fields.find()


        } else {
            vm.company.customSettingObject = {};
            vm.company.customSettingObject.canReserveByClient = null;
            vm.company.customSettingObject.canReserveByClient = true;
            vm.company.customSettingObject.canReserveByWidget = null;
            vm.company.customSettingObject.canReserveByWidget = true;
            vm.capacityViewMode = (vm.company.customSettingObject.capacityViewMode === 'SHOW');
        }
        if(!vm.company.customSettingObject.companyCustomerCustomSettings) {
            vm.company.customSettingObject.companyCustomerCustomSettings = {
                fields: [
                    { name:"sys_birthdate",required: false, fieldType:"Date" ,label:"تاریخ تولد" },
                    { name:"sys_national_code",required: false, fieldType:"TextBox" ,label:"کدملی" }
                ]
            }
        }

        angular.forEach(vm.company.customSettingObject.companyCustomerCustomSettings.fields, function (field) {
            if(field.name === "sys_birthdate") vm.sys_birthdate = field.required
            if(field.name === "sys_national_code") vm.sys_national_code = field.required
        })



        function save() {

            if (vm.scope.editForm.$valid) {
                vm.changeCapacityViewMode(vm.capacityViewMode);
                vm.isSaving = true;
                if (vm.company.id !== null) {
                    // Company.update(vm.company, onSaveSuccess, onSaveError);
                    CompanyCustom.companyCustomSettingField().save(vm.company.customSettingObject, onSaveSuccess, onSaveError);
                } else {
                    //Company.save(vm.company, onSaveSuccess, onSaveError);
                }
            }
        }

        function changeCapacityViewMode(capacityViewMode) {
            if (capacityViewMode == false) {
                vm.company.customSettingObject.capacityViewMode = "HIDE";
                vm.capacityViewMode = false;
            } else {
                vm.company.customSettingObject.capacityViewMode = "SHOW";
                vm.capacityViewMode = true;
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);

            if (result)
                vm.company = result;

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }


        function sysBirthdateChange(e) {
           var item = vm.company.customSettingObject.companyCustomerCustomSettings.fields.find(function(field) {
                return field.name === 'sys_birthdate';
            });
            item.required = vm.sys_birthdate
        }
        function sysNationalCodeChange(e) {
             var item = vm.company.customSettingObject.companyCustomerCustomSettings.fields.find(function(field) {
                return field.name === 'sys_national_code';
            });
            item.required = vm.sys_national_code;
            item.fieldType = "TextBox";
        }
    }

})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankDialogController', CustomerRankDialogController);
//
//    CustomerRankDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerRank', 'Customer', 'ServiceItem'];
//
//    function CustomerRankDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerRank, Customer, ServiceItem) {
//        var vm = this;
//
//        vm.customerRank = entity;
//        vm.clear = clear;
//        vm.datePickerOpenStatus = {};
//        vm.openCalendar = openCalendar;
//        vm.save = save;
//        vm.customers = Customer.query();
//        vm.serviceitems = ServiceItem.query();
//
//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function save () {
//            vm.isSaving = true;
//            if (vm.customerRank.id !== null) {
//                CustomerRank.update(vm.customerRank, onSaveSuccess, onSaveError);
//            } else {
//                CustomerRank.save(vm.customerRank, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('tikonApp:customerRankUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
//
//        vm.datePickerOpenStatus.createDate = false;
//
//        function openCalendar (date) {
//            vm.datePickerOpenStatus[date] = true;
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankDetailController', CustomerRankDetailController);
//
//    CustomerRankDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerRank', 'Customer', 'ServiceItem'];
//
//    function CustomerRankDetailController($scope, $rootScope, $stateParams, entity, CustomerRank, Customer, ServiceItem) {
//        var vm = this;
//
//        vm.customerRank = entity;
//
//        var unsubscribe = $rootScope.$on('tikonApp:customerRankUpdate', function(event, result) {
//            vm.customerRank = result;
//        });
//        $scope.$on('$destroy', unsubscribe);
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankDeleteController',CustomerRankDeleteController);
//
//    CustomerRankDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerRank'];
//
//    function CustomerRankDeleteController($uibModalInstance, entity, CustomerRank) {
//        var vm = this;
//
//        vm.customerRank = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            CustomerRank.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('customer-rank', {
//            parent: 'entity',
//            url: '/customer-rank?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.customerRank.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/customer-rank/customer-ranks.html',
//                    controller: 'CustomerRankController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('customerRank');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('customer-rank-detail', {
//            parent: 'entity',
//            url: '/customer-rank/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.customerRank.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/customer-rank/customer-rank-detail.html',
//                    controller: 'CustomerRankDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('customerRank');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'CustomerRank', function($stateParams, CustomerRank) {
//                    return CustomerRank.get({id : $stateParams.id}).$promise;
//                }]
//            }
//        })
//        .state('customer-rank.new', {
//            parent: 'customer-rank',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/customer-rank/customer-rank-dialog.html',
//                    controller: 'CustomerRankDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                createDate: null,
//                                rankValue: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('customer-rank', null, { reload: true });
//                }, function() {
//                    $state.go('customer-rank');
//                });
//            }]
//        })
//        .state('customer-rank.edit', {
//            parent: 'customer-rank',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/customer-rank/customer-rank-dialog.html',
//                    controller: 'CustomerRankDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['CustomerRank', function(CustomerRank) {
//                            return CustomerRank.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('customer-rank', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('customer-rank.delete', {
//            parent: 'customer-rank',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/customer-rank/customer-rank-delete-dialog.html',
//                    controller: 'CustomerRankDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['CustomerRank', function(CustomerRank) {
//                            return CustomerRank.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('customer-rank', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
//(function() {
//    'use strict';
//    angular
//        .module('tikonApp')
//        .factory('CustomerRank', CustomerRank);
//
//    CustomerRank.$inject = ['$resource', 'DateUtils'];
//
//    function CustomerRank ($resource, DateUtils) {
//        var resourceUrl =  'api/customer-ranks/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' }
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('CustomerRankSearch', CustomerRankSearch);
//
//    CustomerRankSearch.$inject = ['$resource'];
//
//    function CustomerRankSearch($resource) {
//        var resourceUrl =  'api/_search/customer-ranks/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true}
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankController', CustomerRankController);
//
//    CustomerRankController.$inject = ['$scope', '$state', 'CustomerRank', 'CustomerRankSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];
//
//    function CustomerRankController ($scope, $state, CustomerRank, CustomerRankSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
//        var vm = this;
//
//        vm.loadPage = loadPage;
//        vm.predicate = pagingParams.predicate;
//        vm.reverse = pagingParams.ascending;
//        vm.transition = transition;
//        vm.clear = clear;
//        vm.search = search;
//        vm.searchQuery = pagingParams.search;
//        vm.currentSearch = pagingParams.search;
//
//        loadAll();
//
//        function loadAll () {
//            if (pagingParams.search) {
//                CustomerRankSearch.query({
//                    query: pagingParams.search,
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            } else {
//                CustomerRank.query({
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            }
//            function sort() {
//                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
//                if (vm.predicate !== 'id') {
//                    result.push('id');
//                }
//                return result;
//            }
//            function onSuccess(data, headers) {
//                vm.links = ParseLinks.parse(headers('link'));
//                vm.totalItems = headers('X-Total-Count');
//                vm.queryCount = vm.totalItems;
//                vm.customerRanks = data;
//                vm.page = pagingParams.page;
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
//
//        function transition () {
//            $state.transitionTo($state.$current, {
//                page: vm.page,
//                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
//                search: vm.currentSearch
//            });
//        }
//
//        function search (searchQuery) {
//            if (!searchQuery){
//                return vm.clear();
//            }
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = '_score';
//            vm.reverse = false;
//            vm.currentSearch = searchQuery;
//            vm.transition();
//        }
//
//        function clear () {
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = 'id';
//            vm.reverse = true;
//            vm.currentSearch = null;
//            vm.transition();
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerGroupListController', CustomerGroupListController);

    CustomerGroupListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'CustomerGroupCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function CustomerGroupListController($scope, $state, ParseLinks, AlertService, CustomerGroupCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;


        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newCustomerGroupClick = newCustomerGroupClick;


        vm.newCustomerGroup = newCustomerGroup;
        vm.editCustomerGroup = editCustomerGroup;
        vm.clearSearch = clearSearch;

        loadAll_paging();

        function loadAll_paging() {

            if (pagingParams.search) {
                CustomerGroupCustom.getAllCompanyCustomerGroups().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomerGroupCustom.getAllCompanyCustomerGroups().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customerGroups = data;
                setDefaultGroup();
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function setDefaultGroup() {
            var hasDefault = false;
            angular.forEach(vm.customerGroups, function (group) {
                if (group.groupName == 'DEFAULT_GROUP')
                    hasDefault = true;
            })

            if (!hasDefault) {
                var defaultGroup = {};
                defaultGroup.groupName = 'DEFAULT_GROUP';
                defaultGroup.accessToAllServices = true;
                vm.customerGroups.push(defaultGroup);

            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }

        function newCustomerGroupClick() {
            var result;

            result = Principal.hasSpecialFeatureAccess("customerGroup");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newCustomerGroup');

        }


        function newCustomerGroup() {
            var result;

            result = Principal.hasSpecialFeatureAccess("customerGroup");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel-v2.newCustomerGroup');

        }

        function editCustomerGroup(cc) {
            $state.go('supplierPanel-v2.editCustomerGroup', {id: cc.id});
        }

        function clearSearch() {
            vm.searchQuery = null;
            pagingParams.search = null;
            loadAll_paging();
        }

        function editCustomerGroup(customerGroup) {

            if (customerGroup.groupName == 'DEFAULT_GROUP' && !customerGroup.id)
                $state.go('supplierPanel-v2.newCustomerGroup_default');
            else
                $state.transitionTo('supplierPanel-v2.editCustomerGroup', {id: customerGroup.id});
        }

    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerGroupV2Controller', CustomerGroupV2Controller);

    CustomerGroupV2Controller.$inject = ['$rootScope', '$scope', '$state', 'CustomerGroup', 'PersonInfo', 'ParseLinks', 'AlertService', 'entity', 'CustomerGroupCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', '$translate'];

    function CustomerGroupV2Controller($rootScope, $scope, $state, CustomerGroup, PersonInfo, ParseLinks, AlertService, entity, CustomerGroupCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, translate) {

        var vm = this;
        vm.customerGroup = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;


        initDefault();
        loadAll();

        function initDefault() {
            $rootScope.$broadcast('hideNavBar');
        }

        function loadAll() {
            if (vm.customerGroup.accessToAllServices == undefined)
                vm.customerGroup.accessToAllServices = true;

            if (vm.customerGroup.groupName == 'DEFAULT_GROUP') {
                vm.defaultGroupTranslate = translate.instant('tikonApp.customerGroup.DEFAULT_GROUP');
            }

            $translatePartialLoader.addPart('companyCustomer');
            getAllServices();

        }

        function save() {
            vm.isSaving = true;
            addServiceItems();

            if (vm.customerGroup.id !== null) {
                CustomerGroup.update(vm.customerGroup, onSaveSuccess, onSaveError);
            } else {

                CustomerGroup.save(vm.customerGroup, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:customerGroupUpdate', result);
                vm.isSaving = false;
                $state.go('supplierPanel-v2.editCustomerGroup', {id: result.id});
                loadAll();

            }

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.customerGroupList');

        }

        function getModalTitle() {
            if (vm.customerGroup.id)
                return 'tikonApp.customerGroup.home.edit';
            else
                return 'tikonApp.customerGroup.home.new';
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function switch_changed() {

            angular.forEach(vm.allServiceItems, function (item) {
                if (vm.customerGroup.accessToAllServices)
                    item.selected = true;
                else
                    item.selected = false;
            })


        }

        function addServiceItems() {

            vm.customerGroup.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.customerGroup.serviceItems.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.customerGroup.serviceItems && vm.customerGroup.serviceItems.length > 0) {


                angular.forEach(vm.customerGroup.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;

                    })

                })

            }
        }


    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CustomerGroupCustom', CustomerGroupCustom);

    CustomerGroupCustom.$inject = ['$resource'];

    function CustomerGroupCustom($resource) {


        var getAllCompanyCustomerGroups = function () {

            var resourceUrl = 'api/get-all-company-customer-groups';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getCustomerGroupsByCurrentCompany = function () {

            var resourceUrl = 'api/customer-groups-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getAllCompanyCustomerGroups: getAllCompanyCustomerGroups,
            getCustomerGroupsByCurrentCompany: getCustomerGroupsByCurrentCompany

        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CustomerGroup', CustomerGroup);

    CustomerGroup.$inject = ['$resource', 'DateUtils'];

    function CustomerGroup($resource, DateUtils) {
        var resourceUrl = 'api/customer-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerGroupController', CustomerGroupController);

    CustomerGroupController.$inject = ['$scope', '$state', 'CustomerGroup', 'PersonInfo', 'ParseLinks', 'AlertService', 'entity', 'CustomerGroupCustom', '$mdDialog', '$translatePartialLoader'];

    function CustomerGroupController($scope, $state, CustomerGroup, PersonInfo, ParseLinks, AlertService, entity, CustomerGroupCustom, $mdDialog, $translatePartialLoader) {

        var vm = this;
        vm.customerGroup = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;

        initDefault();
        loadAll();

        function initDefault() {

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');


        }

        function save() {
            vm.isSaving = true;


            if (vm.customerGroup.id !== null) {
                CustomerGroup.update(vm.customerGroup, onSaveSuccess, onSaveError);
            } else {

                CustomerGroup.save(vm.customerGroup, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:customerGroupUpdate', result);
                $state.go('supplierPanel.editCustomerGroup', {id: result.id});

                loadAll();

            }

        }

    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerCommentDialogController', CustomerCommentDialogController);
//
//    CustomerCommentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerComment', 'Customer', 'ServiceItem'];
//
//    function CustomerCommentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerComment, Customer, ServiceItem) {
//        var vm = this;
//
//        vm.customerComment = entity;
//        vm.clear = clear;
//        vm.datePickerOpenStatus = {};
//        vm.openCalendar = openCalendar;
//        vm.save = save;
//        vm.customers = Customer.query();
//        vm.serviceitems = ServiceItem.query();
//
//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function save () {
//            vm.isSaving = true;
//            if (vm.customerComment.id !== null) {
//                CustomerComment.update(vm.customerComment, onSaveSuccess, onSaveError);
//            } else {
//                CustomerComment.save(vm.customerComment, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('tikonApp:customerCommentUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
//
//        vm.datePickerOpenStatus.createDate = false;
//
//        function openCalendar (date) {
//            vm.datePickerOpenStatus[date] = true;
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerCommentDetailController', CustomerCommentDetailController);
//
//    CustomerCommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CustomerComment', 'Customer', 'ServiceItem'];
//
//    function CustomerCommentDetailController($scope, $rootScope, $stateParams, entity, CustomerComment, Customer, ServiceItem) {
//        var vm = this;
//
//        vm.customerComment = entity;
//
//        var unsubscribe = $rootScope.$on('tikonApp:customerCommentUpdate', function(event, result) {
//            vm.customerComment = result;
//        });
//        $scope.$on('$destroy', unsubscribe);
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerCommentDeleteController',CustomerCommentDeleteController);
//
//    CustomerCommentDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerComment'];
//
//    function CustomerCommentDeleteController($uibModalInstance, entity, CustomerComment) {
//        var vm = this;
//
//        vm.customerComment = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            CustomerComment.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('customer-comment', {
//            parent: 'entity',
//            url: '/customer-comment?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.customerComment.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/customer-comment/customer-comments.html',
//                    controller: 'CustomerCommentController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('customerComment');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('customer-comment-detail', {
//            parent: 'entity',
//            url: '/customer-comment/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.customerComment.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/customer-comment/customer-comment-detail.html',
//                    controller: 'CustomerCommentDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('customerComment');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'CustomerComment', function($stateParams, CustomerComment) {
//                    return CustomerComment.get({id : $stateParams.id}).$promise;
//                }]
//            }
//        })
//        .state('customer-comment.new', {
//            parent: 'customer-comment',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/customer-comment/customer-comment-dialog.html',
//                    controller: 'CustomerCommentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                createDate: null,
//                                commentText: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('customer-comment', null, { reload: true });
//                }, function() {
//                    $state.go('customer-comment');
//                });
//            }]
//        })
//        .state('customer-comment.edit', {
//            parent: 'customer-comment',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/customer-comment/customer-comment-dialog.html',
//                    controller: 'CustomerCommentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['CustomerComment', function(CustomerComment) {
//                            return CustomerComment.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('customer-comment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('customer-comment.delete', {
//            parent: 'customer-comment',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/customer-comment/customer-comment-delete-dialog.html',
//                    controller: 'CustomerCommentDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['CustomerComment', function(CustomerComment) {
//                            return CustomerComment.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('customer-comment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
//(function() {
//    'use strict';
//    angular
//        .module('tikonApp')
//        .factory('CustomerComment', CustomerComment);
//
//    CustomerComment.$inject = ['$resource', 'DateUtils'];
//
//    function CustomerComment ($resource, DateUtils) {
//        var resourceUrl =  'api/customer-comments/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' }
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('CustomerCommentSearch', CustomerCommentSearch);
//
//    CustomerCommentSearch.$inject = ['$resource'];
//
//    function CustomerCommentSearch($resource) {
//        var resourceUrl =  'api/_search/customer-comments/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true}
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerCommentController', CustomerCommentController);
//
//    CustomerCommentController.$inject = ['$scope', '$state', 'CustomerComment', 'CustomerCommentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];
//
//    function CustomerCommentController ($scope, $state, CustomerComment, CustomerCommentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
//        var vm = this;
//
//        vm.loadPage = loadPage;
//        vm.predicate = pagingParams.predicate;
//        vm.reverse = pagingParams.ascending;
//        vm.transition = transition;
//        vm.clear = clear;
//        vm.search = search;
//        vm.searchQuery = pagingParams.search;
//        vm.currentSearch = pagingParams.search;
//
//        loadAll();
//
//        function loadAll () {
//            if (pagingParams.search) {
//                CustomerCommentSearch.query({
//                    query: pagingParams.search,
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            } else {
//                CustomerComment.query({
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            }
//            function sort() {
//                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
//                if (vm.predicate !== 'id') {
//                    result.push('id');
//                }
//                return result;
//            }
//            function onSuccess(data, headers) {
//                vm.links = ParseLinks.parse(headers('link'));
//                vm.totalItems = headers('X-Total-Count');
//                vm.queryCount = vm.totalItems;
//                vm.customerComments = data;
//                vm.page = pagingParams.page;
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
//
//        function transition () {
//            $state.transitionTo($state.$current, {
//                page: vm.page,
//                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
//                search: vm.currentSearch
//            });
//        }
//
//        function search (searchQuery) {
//            if (!searchQuery){
//                return vm.clear();
//            }
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = '_score';
//            vm.reverse = false;
//            vm.currentSearch = searchQuery;
//            vm.transition();
//        }
//
//        function clear () {
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = 'id';
//            vm.reverse = true;
//            vm.currentSearch = null;
//            vm.transition();
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Customer', 'PersonInfo'];

    function CustomerDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Customer, PersonInfo) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.save = save;
        vm.personinfos = PersonInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:customerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerDetailController', CustomerDetailController);

    CustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Customer', 'PersonInfo'];

    function CustomerDetailController($scope, $rootScope, $stateParams, entity, Customer, PersonInfo) {
        var vm = this;

        vm.customer = entity;

        var unsubscribe = $rootScope.$on('tikonApp:customerUpdate', function (event, result) {
            vm.customer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerDeleteController', CustomerDeleteController);

    CustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customer'];

    function CustomerDeleteController($uibModalInstance, entity, Customer) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Customer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CustomerCustom', CustomerCustom);

    CustomerCustom.$inject = ['$resource', 'ENV'];

    function CustomerCustom($resource, ENV) {


        var getCustomerByPhoneNumber = function (phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-customer-by-phone-number?phoneNumber=' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var searchCustomerBySearch = function (query) {

            var resourceUrl = ENV.API_BASE_URL + 'api/search-current-company-customers?query=' + query;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCustomerStatistics = function (customerId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-company-customer-statistics?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var saveCompanyCustomer = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/service-customer-schedule-list';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        };

        var getCustomerUserInfoByCustomerId = function (customerId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-customer-user-info-by-customer-id?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getCustomerStatisticsV2 = function (customerId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-company-customer-statistics-v2?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            getCustomerByPhoneNumber: getCustomerByPhoneNumber,
            searchCustomerBySearch: searchCustomerBySearch,
            saveCompanyCustomer: saveCompanyCustomer,
            getCustomerStatistics: getCustomerStatistics,
            getCustomerUserInfoByCustomerId: getCustomerUserInfoByCustomerId,
            getCustomerStatisticsV2: getCustomerStatisticsV2


        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customer', {
                parent: 'entity',
                url: '/customer?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer/customers.html',
                        controller: 'CustomerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('customer-detail', {
                parent: 'entity',
                url: '/customer/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customer.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer/customer-detail.html',
                        controller: 'CustomerDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Customer', function ($stateParams, Customer) {
                        return Customer.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('customer.new', {
                parent: 'customer',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    userAccountId: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('customer', null, {reload: true});
                    }, function () {
                        $state.go('customer');
                    });
                }]
            })
            .state('customer.edit', {
                parent: 'customer',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('customer.delete', {
                parent: 'customer',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                        controller: 'CustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'ENV'];

    function Customer($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CustomerSearch', CustomerSearch);

    CustomerSearch.$inject = ['$resource', 'ENV'];

    function CustomerSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['$scope', '$state', 'Customer', 'CustomerSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CustomerController($scope, $state, Customer, CustomerSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CustomerSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Customer.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customers = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
  "use strict";

  angular.module("tikonApp").controller("CouponsList", CouponsList);

  CouponsList.$inject = ["$timeout", "$state", "$rootScope"];

  function CouponsList($timeout, $state, $rootScope) {
    function initCouponsList() {
      var CouponsListElement = document.getElementById("coupons-list");
      CouponsListElement.addEventListener("prevPageBtn", function () {
        $state.go("supplierPanel-v2.setting");
      });
      CouponsListElement.addEventListener("backToPrevVersion", function () {
        $state.go("supplierPanel-v2.couponList");
      });
    }
    $timeout(initCouponsList, 50);
  }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CouponListController', CouponListController);

    CouponListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'Coupon', 'CouponCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function CouponListController($scope, $state, ParseLinks, AlertService, Coupon, CouponCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {


        var vm = this;


        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newCouponClick = newCouponClick;
        vm.searchKeyPress = searchKeyPress;


        vm.editCoupon = editCoupon;
        vm.searchCoupons = search;
        vm.searchKeyPress = searchKeyPress;
        vm.newCoupon = newCoupon;
        vm.clearSearch = clearSearch;
        vm.deleteCoupon = deleteCoupon;


        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                CouponCustom.getAllCompanyCoupons().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CouponCustom.getAllCompanyCoupons().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.coupons = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }

        function newCouponClick() {

            var result;

            result = Principal.hasSpecialFeatureAccess("couponCode");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newCoupon');

        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editCoupon(coupon) {
            $state.go('supplierPanel-v2.editCoupon', {id: coupon.id});
        }

        function newCoupon() {
            var result;

            result = Principal.hasSpecialFeatureAccess("couponCode");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }
            $state.go('supplierPanel-v2.newCoupon');
        }

        function clearSearch() {
            vm.searchQuery = null;
            search();
        }

        function deleteCoupon(coupon) {
           Coupon.delete(coupon, onDeleteSuccess);
        }

        function onDeleteSuccess(res) {
            loadAll_paging()
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CouponV2Controller', CouponV2Controller);

    CouponV2Controller.$inject = ['$rootScope', '$scope', '$state', 'Coupon', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom'];

    function CouponV2Controller($rootScope, $scope, $state, Coupon, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom) {

        var vm = this;
        vm.coupon = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = true;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;
        vm.deleteCoupon = deleteCoupon;


        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.coupon.generateType)
                vm.coupon.generateType = "MANUAL";

            if (!vm.coupon.status)
                vm.coupon.status = "ACTIVE";

            if (!vm.coupon.amountType)
                vm.coupon.amountType = "PERCENT";

            $rootScope.$broadcast('hideNavBar');
        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('couponGenerateTypes');
            getAllServices();
            getAllCustomerGroups();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {
            vm.isSaving = true;
            addServiceItems();
            addCustomerGroups();

            if (vm.coupon.id !== null) {
                Coupon.update(vm.coupon, onSaveSuccess, onSaveError);
            } else {

                Coupon.save(vm.coupon, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:couponUpdate', result);
                vm.isSaving = false;
                $state.go('supplierPanel-v2.editCoupon', {id: result.id});
                loadAll();
                vm.coupon.couponCode = vm.coupon.couponCode.toLowerCase();

            }

        }
        
        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.coupon.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.coupon.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.coupon.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.coupon.customerGroups.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.coupon.serviceItems && vm.coupon.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.coupon.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.coupon.customerGroups && vm.coupon.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.coupon.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.couponList');

        }

        function getModalTitle() {
            if (vm.coupon.id)
                return 'tikonApp.coupon.home.edit';
            else
                return 'tikonApp.coupon.home.new';
        }

        function deleteCoupon() {
            Coupon.delete(vm.coupon, onDeleteSuccess);
        }

        function onDeleteSuccess(res) {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.couponList');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CouponDeleteController', CouponDeleteController);

    CouponDeleteController.$inject = ['$uibModalInstance', 'entity', 'Coupon'];

    function CouponDeleteController($uibModalInstance, entity, Coupon) {
        var vm = this;

        vm.coupon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Coupon.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CouponCustom', CouponCustom);

    CouponCustom.$inject = ['$resource', 'ENV'];

    function CouponCustom($resource, ENV) {


        var getAllCompanyCoupons = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-all-company-coupons';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var evaluateCoupon = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/evaluate-coupon';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {
            getAllCompanyCoupons: getAllCompanyCoupons,
            evaluateCoupon: evaluateCoupon


        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('coupon', {
                parent: 'entity',
                url: '/coupon?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.coupon.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/coupon/coupons-list-v2.html',
                        controller: 'CouponListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        // $translatePartialLoader.addPart('detatusType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('coupon-detail', {
                parent: 'coupon',
                url: '/coupon/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.coupon.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/coupon/coupon-detail.html',
                        controller: 'couponDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        // $translatePartialLoader.addPart('detatusType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'coupon', function ($stateParams, coupon) {
                        return coupon.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'coupon',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('coupon-detail.edit', {
                parent: 'coupon-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-dialog.html',
                        controller: 'couponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['coupon', function (coupon) {
                                return coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('coupon.new', {
                parent: 'coupon',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-dialog.html',
                        controller: 'couponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    status: null,
                                    createDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('coupon', null, {reload: 'coupon'});
                    }, function () {
                        $state.go('coupon');
                    });
                }]
            })
            .state('coupon.edit', {
                parent: 'coupon',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-dialog.html',
                        controller: 'couponDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['coupon', function (coupon) {
                                return coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('coupon', null, {reload: 'coupon'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('coupon.delete', {
                parent: 'coupon',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-delete-dialog.html',
                        controller: 'CouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Coupon', function (Coupon) {
                                return Coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('coupon', null, {reload: 'coupon'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Coupon', Coupon);

    Coupon.$inject = ['$resource', 'DateUtils', 'ENV'];

    function Coupon($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/coupon/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CouponController', CouponController);

    CouponController.$inject = ['$scope', '$state', 'Coupon', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom'];

    function CouponController($scope, $state, Coupon, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom) {

        var vm = this;
        vm.coupon = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = true;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];


        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.coupon.generateType)
                vm.coupon.generateType = "MANUAL";

            if (!vm.coupon.status)
                vm.coupon.status = "ACTIVE";

            if (!vm.coupon.amountType)
                vm.coupon.amountType = "PERCENT";
        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('couponGenerateTypes');
            getAllServices();
            getAllCustomerGroups();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {
            vm.isSaving = true;
            addServiceItems();
            addCustomerGroups();

            if (vm.coupon.id !== null) {
                Coupon.update(vm.coupon, onSaveSuccess, onSaveError);
            } else {

                Coupon.save(vm.coupon, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:couponUpdate', result);
                $state.go('supplierPanel.editCoupon', {id: result.id});

                loadAll();

            }

        }

        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.coupon.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.coupon.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.coupon.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.coupon.customerGroups.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.coupon.serviceItems && vm.coupon.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.coupon.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.coupon.customerGroups && vm.coupon.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.coupon.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationListController', ConversationListController);

    ConversationListController.$inject = ['$state', 'Conversation', 'ConversationSearch', 'ConversationCustom'];

    function ConversationListController($state, Conversation, ConversationSearch, ConversationCustom) {

        var vm = this;

        vm.conversationList = [];
        vm.loadAll = loadAll;
        vm.findStatusStyle = findStatusStyle;
        vm.getSeeStatusStyle = getSeeStatusStyle;

        loadAll();

        function loadAll() {
            vm.conversationList = ConversationCustom.getConversationByCurrentCompany().query();
        }

        function findStatusStyle(status) {
            return "conversation-status-" + status;
        }

        function getSeeStatusStyle(conversation) {
            if (conversation != null && conversation != undefined) {

                if (hasNotSeenMessages(conversation)) {
                    return "message-not-seen";
                }

            }

        }

        function hasNotSeenMessages(conv) {
            var result = false;
            if (conv != null && conv.messages != null && conv.messages.length > 0) {
                angular.forEach(conv.messages, function (msg) {
                    if (msg.senderType == "CUSTOMER" && msg.status == "NEW") {
                        result = true;
                    }

                });

            }

            return result;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationDialogController', ConversationDialogController);

    ConversationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Conversation', 'Company', 'ServiceItem', 'PersonInfo', 'Message'];

    function ConversationDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Conversation, Company, ServiceItem, PersonInfo, Message) {
        var vm = this;

        vm.conversation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();
        vm.serviceitems = ServiceItem.query();
        vm.personinfos = PersonInfo.query();
        vm.messages = Message.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.conversation.id !== null) {
                Conversation.update(vm.conversation, onSaveSuccess, onSaveError);
            } else {
                Conversation.save(vm.conversation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:conversationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationDetailController', ConversationDetailController);

    ConversationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Conversation', 'Company', 'ServiceItem', 'PersonInfo', 'Message'];

    function ConversationDetailController($scope, $rootScope, $stateParams, previousState, entity, Conversation, Company, ServiceItem, PersonInfo, Message) {
        var vm = this;

        vm.conversation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tikonApp:conversationUpdate', function (event, result) {
            vm.conversation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationDeleteController', ConversationDeleteController);

    ConversationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Conversation'];

    function ConversationDeleteController($uibModalInstance, entity, Conversation) {
        var vm = this;

        vm.conversation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Conversation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationCustomDialogController', ConversationCustomDialogController);

    ConversationCustomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Conversation', 'Company', 'ServiceItem', 'PersonInfo', 'Message', 'MessageCustom', 'ConversationCustom'];

    function ConversationCustomDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Conversation, Company, ServiceItem, PersonInfo, Message, MessageCustom, ConversationCustom) {
        var vm = this;

        vm.conversation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();
        vm.serviceitems = ServiceItem.query();
        vm.personinfos = PersonInfo.query();
        vm.messages = Message.query();


        vm.findMessageStyle = findMessageStyle;
        vm.senderName = senderName;


        updateMessagesStatus();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            //if (vm.conversation.id !== null) {
            //    Conversation.update(vm.conversation, onSaveSuccess, onSaveError);
            //} else {
            //    Conversation.save(vm.conversation, onSaveSuccess, onSaveError);
            //}

            newMessageFromSupplier();
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:conversationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function findMessageStyle(senderType) {
            return "message-" + senderType;
        }

        function senderName(message) {
            var result;
            if (message.senderType == "SUPPLIER") {
                result = vm.conversation.toPerson;
            }
            if (message.senderType == "CUSTOMER") {
                result = vm.conversation.fromPerson;
            }


            return result.fisrtName + ' ' + result.lastName;
        }

        function newMessageFromSupplier() {
            if (vm.newMessage == null || vm.newMessage == undefined) {
                return;
            }
            if (vm.conversation.id == null || vm.conversation.id == undefined) {
                return;
            }

            var messageDto = {};
            messageDto.id = null;
            messageDto.senderType = null;
            messageDto.createDate = null;
            messageDto.status = null;
            messageDto.conversationId = vm.conversation.id;
            messageDto.content = vm.newMessage;

            MessageCustom.newMessageFromSupplier().save(messageDto, onSaveSuccess, onSaveError);

        }

        function updateMessagesStatus() {
            if (vm.conversation != null && vm.conversation != undefined)
                ConversationCustom.setConversationMessageSeenBySupplier().save(vm.conversation.id, onUpdateSuccess, onUpdateError);
        }

        function onUpdateSuccess() {
        }

        function onUpdateError() {
        }


    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ConversationCustom', ConversationCustom);

    ConversationCustom.$inject = ['$resource'];

    function ConversationCustom($resource) {


        var getConversationByCurrentCompany = function () {

            var resourceUrl = 'api/get-conversation-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var setConversationMessageSeenBySupplier = function () {

            var resourceUrl = 'api/set-seen-by-supplier';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {
            getConversationByCurrentCompany: getConversationByCurrentCompany,
            setConversationMessageSeenBySupplier: setConversationMessageSeenBySupplier

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('conversation', {
                parent: 'entity',
                url: '/conversation?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.conversation.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/conversation/conversations.html',
                        controller: 'ConversationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('conversation');
                        $translatePartialLoader.addPart('conversationStatusType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('conversation-detail', {
                parent: 'conversation',
                url: '/conversation/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.conversation.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/conversation/conversation-detail.html',
                        controller: 'ConversationDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('conversation');
                        $translatePartialLoader.addPart('conversationStatusType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Conversation', function ($stateParams, Conversation) {
                        return Conversation.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'conversation',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('conversation-detail.edit', {
                parent: 'conversation-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/conversation/conversation-dialog.html',
                        controller: 'ConversationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Conversation', function (Conversation) {
                                return Conversation.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('conversation.new', {
                parent: 'conversation',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/conversation/conversation-dialog.html',
                        controller: 'ConversationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    status: null,
                                    createDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('conversation', null, {reload: 'conversation'});
                    }, function () {
                        $state.go('conversation');
                    });
                }]
            })
            .state('conversation.edit', {
                parent: 'conversation',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/conversation/conversation-dialog.html',
                        controller: 'ConversationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Conversation', function (Conversation) {
                                return Conversation.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('conversation', null, {reload: 'conversation'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('conversation.delete', {
                parent: 'conversation',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/conversation/conversation-delete-dialog.html',
                        controller: 'ConversationDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Conversation', function (Conversation) {
                                return Conversation.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('conversation', null, {reload: 'conversation'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Conversation', Conversation);

    Conversation.$inject = ['$resource', 'DateUtils'];

    function Conversation($resource, DateUtils) {
        var resourceUrl = 'api/conversations/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ConversationSearch', ConversationSearch);

    ConversationSearch.$inject = ['$resource'];

    function ConversationSearch($resource) {
        var resourceUrl = 'api/_search/conversations/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationController', ConversationController);

    ConversationController.$inject = ['$state', 'Conversation', 'ConversationSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ConversationController($state, Conversation, ConversationSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ConversationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Conversation.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.conversations = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PurchaseSubscriptionController', PurchaseSubscriptionController);

    PurchaseSubscriptionController.$inject = ['$window', '$scope', '$state', '$rootScope', '$stateParams', 'entity', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom','LegalActualInfoService'];

    function PurchaseSubscriptionController($window, $scope, $state, $rootScope, $stateParams, entity, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, LegalActualInfoService) {
        var vm = this;

        vm.subscriptionPackage = entity;
        vm.subscriptionPackages = [];
        vm.subscriptionPackages.push(vm.subscriptionPackage);
        vm.companySubscriptionStatus = {};
        vm.isSaving = false;
        vm.issueBill = false;
        vm.billingName = "";
        vm.billingNationalCode = "";
        vm.issueBillCheckChange = issueBillCheckChange;

        if (vm.subscriptionPackage != null && vm.subscriptionPackage != undefined) {
            vm.companySubscriptionStatus.subscriptionPackage = vm.subscriptionPackage;
        }


        vm.companySubscriptionStatus.couponCodeToValidate = null;


        computeFinalPrice();


        vm.insertCompanySubscription = insertCompanySubscription;
        vm.checkCouponCode = checkCouponCode;
        vm.isSMSPAckage = false;

        if (vm.subscriptionPackage.packageType == 'SMS')
            vm.isSMSPAckage = true;

        function computeFinalPrice() {
            CompanySubscriptionStatusCustom.computeSubscriptionFinalPrice().save(vm.companySubscriptionStatus, function (result) {

                vm.companySubscriptionStatus = result;
            });

        }

        function checkCouponCode() {
            if (!vm.companySubscriptionStatus.couponCodeToValidate)
                return;

            CompanySubscriptionStatusCustom.evaluateSupplierCoupon().save(vm.companySubscriptionStatus, onEvaluateSuccess, onEvaluateError)

        }

        function onEvaluateSuccess(result) {
            if (result.resultStatus == 'DONE') {
                vm.couponResult = result;
                computeFinalPrice();
            }
        }

        function onEvaluateError() {
            vm.couponResult = null;
            computeFinalPrice();
        }


        function insertCompanySubscription() {
            vm.isSaving = true;
            if(vm.issueBill) {
                 LegalActualInfoService.fetchInfo().query(function(result){
                    if(result.id && result.nationalCode) {
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo = {};
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.fisrtName = result.name;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.lastName = result.name;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.nationalCode = result.nationalCode;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.address = result.address;
                        vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.zipCode = result.zipCode;
                        CompanySubscriptionStatusCustom.insertCompanySubscriptionStatus().save(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
                    }
                    else {
                        $state.go('supplierPanel-v2.legal_actualInformation');
                    }
                })
            }else {
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo = {};
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.fisrtName = vm.billingName;
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.lastName = vm.billingName;
                vm.companySubscriptionStatus.companyInvoiceInfo.billingInfo.nationalCode = vm.billingNationalCode;
                CompanySubscriptionStatusCustom.insertCompanySubscriptionStatus().save(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
            }
           
            // if (vm.issueBill && (!vm.billingName || !vm.billingNationalCode)) {
            //     vm.isSaving = false;
            //     return;
            // }
        }

        function onSaveSuccess(result) {

            vm.isSaving = false;
            if (result && result.payUrl) {
                addGTagData();
                $window.location.href = result.payUrl;
            }

        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function issueBillCheckChange() {
            if (!vm.issueBill) {
                // vm.companySubscriptionStatus.companyInvoiceInfo = {};
                return;
            }
            if (!vm.companySubscriptionStatus.companyInvoiceInfo) {
                vm.companySubscriptionStatus.companyInvoiceInfo = {};
                vm.companySubscriptionStatus.companyInvoiceInfo.billingIssueType = 'PERSONAL';
            } else {
                if (!vm.companySubscriptionStatus.companyInvoiceInfo.billingIssueType)
                    vm.companySubscriptionStatus.companyInvoiceInfo.billingIssueType = 'PERSONAL';
            }

        }

        function addGTagData() {

            if (!vm.subscriptionPackage || !vm.subscriptionPackage.subscriptionType) {
                return;
            }

            try {
                //user Start Purchase
                gtag('event', 'purchase_start', {
                    "items": [
                        {
                            "id": "PL103",
                            "name": vm.subscriptionPackage.title + "--" + vm.subscriptionPackage.durationDays + " Days",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": vm.subscriptionPackage.subscriptionType,
                            "price": vm.subscriptionPackage.chargeFee
                        }
                    ]
                });
            } catch (err) {
                console.log(err);
            }

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConfirmSubscriptionController', ConfirmSubscriptionController);

    ConfirmSubscriptionController.$inject = ['LoginService', 'Auth', '$state', '$resource', '$scope', '$rootScope', '$stateParams', 'entity', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', '$timeout'];

    function ConfirmSubscriptionController(LoginService, Auth, $state, $resource, $scope, $rootScope, $stateParams, entity, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, $timeout) {
        var vm = this;

        vm.isPayed = false;
        vm.companySubscriptionStatus = entity;
        vm.showLogin = showLogin;
        vm.isSMSPAckage = false;

        $scope.$watch('vm.companySubscriptionStatus.subscriptionPackage', function (ob) {

            if (ob && vm.companySubscriptionStatus != null && vm.companySubscriptionStatus != undefined && entity.subscriptionPackage) {

                vm.companySubscriptionStatusList = [];
                vm.companySubscriptionStatusList.push(vm.companySubscriptionStatus);
                vm.isPayed = true;
                addGTagData();

                if (entity.subscriptionPackage.packageType && entity.subscriptionPackage.packageType == 'SMS') {
                    vm.isSMSPAckage = true;
                }

            }
        })


        function showLogin() {

            if (vm.isSMSPAckage) {
                gotoSMSPackages();
            } else {
                Auth.logout();
                LoginService.open(gotoSubscription);
            }
        }

        function gotoSubscription() {
            $state.go('supplierPanel.companySubscriptionStatusV2');
        }

        function gotoSMSPackages() {
            $state.go('supplierPanel.companySmsPackageStatus');
        }

        function addGTagData() {

            if (!entity.subscriptionPackage || !entity.subscriptionPackage.subscriptionType) {
                return;
            }
            if (vm.isSMSPAckage)
                return;

            try {
                //user Purchase Success
                // gtag('event', 'purchase_success', {
                //     "items": [
                //         {
                //             "id": "PL104",
                //             "name": entity.subscriptionPackage.title + "--" + entity.subscriptionPackage.durationDays + " Days",
                //             "list_name": "",
                //             "brand": "Planovin",
                //             "category": entity.subscriptionPackage.subscriptionType,
                //             "price": entity.subscriptionPackage.chargeFee
                //         }
                //     ]
                // });
                gtag('event', 'purchase', {
                    "transaction_id": entity.subscriptionPackage.id,
                    "value": entity.subscriptionPackage.chargeFee,
                    "currency": "USD",
                    "tax": 0,
                    "shipping": 0,
                    "items": [
                        {
                            "id": "PL104",
                            "name": entity.subscriptionPackage.title + "--" + entity.subscriptionPackage.durationDays + " Days",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": entity.subscriptionPackage.subscriptionType,
                            "quantity": 1,
                            "price": entity.subscriptionPackage.chargeFee
                        }

                    ]
                });


            } catch (err) {
                console.log(err);
            }

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusViewV2Controller', CompanySubscriptionStatusViewV2Controller);

    CompanySubscriptionStatusViewV2Controller.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom', '$sce', '$location', '$anchorScroll', 'PackageFeatureListCustom', 'ActivityTypeInfoCustom', '$timeout', '$localStorage'];

    function CompanySubscriptionStatusViewV2Controller(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom, $sce, $location, $anchorScroll, PackageFeatureListCustom, ActivityTypeInfoCustom, $timeout, $localStorage) {
        var vm = this;
        vm.subscriptionTypeList = [{type: 'BASIC', packages: '', isSelected: false},
            {type: 'ECONOMY', packages: '', isSelected: false},
            {type: 'ENTERPRISE', packages: '', isSelected: false}];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.lastSubsriptionType = "BASIC";

        CompanySubscriptionStatusCustom.findLastSubscriptionByCurrentCompany().query(function (lastSubsription) {

            if (lastSubsription) {
                vm.lastSubsriptionType = lastSubsription.subscriptionPackage.subscriptionType;
                if (vm.lastSubsriptionType == "ECONOMY") {
                    vm.subscriptionTypeList = [{type: 'ECONOMY', packages: '', isSelected: false},
                        {type: 'ENTERPRISE', packages: '', isSelected: false}];
                }
                if (vm.lastSubsriptionType == "ENTERPRISE") {
                    vm.subscriptionTypeList = [{type: 'ENTERPRISE', packages: '', isSelected: false}];

                }
            }
        })

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();
        vm.selectSubscriptionBaseType = selectSubscriptionBaseType;
        vm.selectedSubscriptionType = null;
        vm.isAnyPackageSelected = false;
        vm.availablePackagePeriods = [];
        vm.getAvailablePackagePeriod = getAvailablePackagePeriod;
        vm.makeFeatureDesc = makeFeatureDesc;
        vm.PackageFeatureList = null;
        vm.showFeaturesClick = showFeaturesClick;
        vm.showFeatures = false;
        vm.isNativeApp = null;


        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });


        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();

            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: '', isSelected: false}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {

            var classname = "";

            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                classname = "btn-DEFAULT";
            } else {
                classname = "btn-" + type;
            }

            if (vm.isAnyPackageSelected && vm.selectedSubscriptionType != type) {
                classname += " btn-not-selected";
            }

            return classname;
        }

        function packageCardStyle(ptype) {
            if (ptype == undefined)
                return;

            var cls = "package-card-" + ptype.type;
            if (vm.isAnyPackageSelected && ptype.isSelected != true) {
                cls += " package-card-not-selected"
            }

            return cls;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                loadPackageFeatureList();


            });
        }

        function selectSubscriptionBaseType(pType) {

            if (pType == undefined)
                return;
            vm.selectedSubscriptionType = pType.type;
            setAllTypeAsUnSelected();
            pType.isSelected = true;
            vm.isAnyPackageSelected = true;
            getAvailablePackagePeriod();

            scrollDown();

        }

        function scrollDown() {
            $location.hash('periodSelection');
            // call $anchorScroll()
            $anchorScroll();
        }

        function setAllTypeAsUnSelected() {
            angular.forEach(vm.subscriptionTypeList, function (type) {
                type.isSelected = false;
            });
        }

        function getAvailablePackagePeriod() {
            if (!vm.isAnyPackageSelected)
                return;

            vm.availablePackagePeriods = [];

            vm.subscriptionTypeList.forEach(function (stype) {

                if (stype.type == vm.selectedSubscriptionType) {
                    vm.availablePackagePeriods = stype.packages;

                    vm.availablePackagePeriods.sort(
                        function (a, b) {
                            if (a.durationDays > b.durationDays)
                                return 1;
                            if (a.durationDays < b.durationDays)
                                return -1;
                            return 0;

                        }
                    );
                }
            });
        }

        function makeFeatureDesc(ptype) {

            var desc = "";

            if (ptype.type == "BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 1 امکان ویژه سیستم</strong> </li>';
                desc += '<li>   رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>   ارسال پیامک یادآوری </li>';
                desc += '<li>   <strong> 150 </strong> پیامک رایگان </li>';
                desc += '<li>   پشتیبانی 24 ساعته  </li>';
                desc += '<li>   حداکثر <strong> 2 پرسنل </strong> </li>';
                // desc += '<li>   پرسنل اضافه 15 هزار تومان/ماه</li>';

            }
            if (ptype.type == "ECONOMY") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 4 امکان ویژه سیستم</strong> </li>';
                desc += '<li>   رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>   ارسال پیامک یادآوری </li>';
                desc += '<li>   <strong> 300 </strong> پیامک رایگان </li>';
                desc += '<li>   پشتیبانی 24 ساعته  </li>';
                desc += '<li>   حداکثر <strong> 5 پرسنل </strong> </li>';
                // desc += '<li>   پرسنل اضافه 10 هزار تومان/ماه</li>';

            }
            if (ptype.type == "ENTERPRISE") {
                desc += '<li>  تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 10 امکان ویژه سیستم</strong> </li>';
                desc += '<li>  رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>  ارسال پیامک یادآوری </li>';
                desc += '<li>  <strong> 500 </strong> پیامک رایگان </li>';
                desc += '<li>  پشتیبانی 24 ساعته  </li>';
                desc += '<li>  حداکثر <strong> 10 پرسنل </strong> </li>';
                // desc += '<li>  پرسنل اضافه 8 هزار تومان/ماه</li>';


            }

            desc = $sce.trustAsHtml(desc);

            return desc;


        }

        function loadPackageFeatureList() {
            if (vm.currentCompany) {
                PackageFeatureListCustom.getPackageFeatureListByCompanyId(vm.currentCompany.id).query().$promise.then(function (packages) {


                    vm.packageFeatureList = packages;
                })
            }
        }

        function showFeaturesClick() {
            vm.showFeatures = !vm.showFeatures;
        }
         $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp;
        },10)

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusViewEventController', CompanySubscriptionStatusViewEventController);

    CompanySubscriptionStatusViewEventController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom', '$sce', '$location', '$anchorScroll'];

    function CompanySubscriptionStatusViewEventController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom, $sce, $location, $anchorScroll) {
        var vm = this;
        vm.subscriptionTypeList = [];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.lastSubsriptionType = "BASIC";

        CompanySubscriptionStatusCustom.findLastSubscriptionByCurrentCompany().query(function (lastSubsription) {

            // if(lastSubsription)
            // {
            //     vm.lastSubsriptionType =lastSubsription.subscriptionPackage.subscriptionType;
            //     if(vm.lastSubsriptionType=="ECONOMY")
            //     {
            //         vm.subscriptionTypeList=[{type:'ECONOMY',packages:'',isSelected:false},
            //             {type:'ENTERPRISE',packages:'',isSelected:false}];
            //     }
            //     if(vm.lastSubsriptionType=="ENTERPRISE")
            //     {
            //         vm.subscriptionTypeList=[{type:'ENTERPRISE',packages:'',isSelected:false}];
            //
            //     }
            // }
        })

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();
        vm.selectSubscriptionBaseType = selectSubscriptionBaseType;
        vm.selectedSubscriptionType = null;
        vm.isAnyPackageSelected = false;
        vm.availablePackagePeriods = [];
        vm.getAvailablePackagePeriod = getAvailablePackagePeriod;
        vm.makeFeatureDesc = makeFeatureDesc;

        //-------------------------------------
        vm.loadEventSubscriptionTypeList = loadEventSubscriptionTypeList;


        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });

        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();
            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }


                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {


            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: '', isSelected: false}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {

            var classname = "";

            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                classname = "btn-DEFAULT";
            } else {
                classname = "btn-" + type;
            }

            if (vm.isAnyPackageSelected && vm.selectedSubscriptionType != type) {
                classname += " btn-not-selected";
            }

            return classname;
        }

        function packageCardStyle(ptype) {
            if (ptype == undefined)
                return;

            var cls = "package-card-" + ptype.type;
            if (vm.isAnyPackageSelected && ptype.isSelected != true) {
                cls += " package-card-not-selected"
            }

            return cls;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
            });
        }

        function selectSubscriptionBaseType(pType) {

            if (pType == undefined)
                return;

            vm.availablePackagePeriods = [];
            vm.selectedSubscriptionType = pType.type;
            setAllTypeAsUnSelected();
            pType.isSelected = true;
            vm.isAnyPackageSelected = true;

            loadSubscriptionPackages(pType);
            // getAvailablePackagePeriod();

            scrollDown();

        }

        function scrollDown() {
            $location.hash('periodSelection');
            // call $anchorScroll()
            $anchorScroll();
        }

        function setAllTypeAsUnSelected() {
            angular.forEach(vm.subscriptionTypeList, function (type) {
                type.isSelected = false;
            });
        }

        function getAvailablePackagePeriod() {

            if (!vm.isAnyPackageSelected)
                return;

            vm.availablePackagePeriods = [];

            vm.subscriptionTypeList.forEach(function (stype) {

                if (stype.type == vm.selectedSubscriptionType) {
                    vm.availablePackagePeriods = stype.packages;

                    vm.availablePackagePeriods.sort(
                        function (a, b) {
                            if (a.durationDays > b.durationDays)
                                return 1;
                            if (a.durationDays < b.durationDays)
                                return -1;
                            return 0;

                        }
                    );
                }
            });
        }

        function makeFeatureDesc(ptype) {

            var desc = "";


            if (ptype.type == "WEBINAR_BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 30 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 5 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   ماژول کد تخفیف </li>';

            }
            if (ptype.type == "WEBINAR_STANDARD") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 50 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 10 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   ماژول کد تخفیف </li>';
                desc += '<li>   فرم اختصاصی دریافت اطلاعات </li>';

            }
            if (ptype.type == "WEBINAR_PRO") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 100 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 10 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 5 وبکم</strong> فعال </li>';
                desc += '<li>   ماژول کد تخفیف </li>';
                desc += '<li>   فرم اختصاصی دریافت اطلاعات </li>';
                desc += '<li>   ضبط جلسات </li>';
                desc += '<li>   برندینگ اختصاصی </li>';

            }

            if (ptype.type == "CONFERENCE_BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 30 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 5 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   زمانبندی جلسات </li>';

            }
            if (ptype.type == "CONFERENCE_STANDARD") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 50 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 10 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 5 وبکم</strong> فعال </li>';
                desc += '<li>   زمانبندی جلسات </li>';
                desc += '<li>   برندینگ اختصاصی </li>';

            }
            if (ptype.type == "CONFERENCE_PRO") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 100 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 15 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 10 وبکم</strong> فعال </li>';
                desc += '<li>   ضبط جلسات </li>';
                desc += '<li>   زمانبندی جلسات </li>';
                desc += '<li>   برندینگ اختصاصی </li>';

            }

            if (ptype.type == "WEDOMEET_UNLIMITED") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    زمان برگزاری  <strong> نامحدود </strong> </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   زمانبندی جلسات </li>';

            }

            desc = $sce.trustAsHtml(desc);

            return desc;


        }

        function loadEventSubscriptionTypeList(type) {
            vm.availablePackagePeriods = [];
            switch (type) {
                case "WEBINAR":
                    vm.subscriptionTypeList = [{type: 'WEBINAR_BASIC', packages: '', isSelected: false},
                        {type: 'WEBINAR_STANDARD', packages: '', isSelected: false},
                        {type: 'WEBINAR_PRO', packages: '', isSelected: false}];
                    break;
                case "CONFERENCE":
                    vm.subscriptionTypeList = [{type: 'CONFERENCE_BASIC', packages: '', isSelected: false},
                        {type: 'CONFERENCE_STANDARD', packages: '', isSelected: false},
                        {type: 'CONFERENCE_PRO', packages: '', isSelected: false}];
                    break;
                case "UNLIMITED":
                    vm.subscriptionTypeList = [{type: 'WEDOMEET_UNLIMITED', packages: '', isSelected: false}];
                    break;
            }

        }

        function loadSubscriptionPackages(pType) {
            if (!vm.selectedSubscriptionType)
                return;

            SubscriptionPackageCustom.getSubscriptionPackageByType(vm.selectedSubscriptionType).query().$promise.then(function (result) {
                vm.subscriptionPackages = result;

                vm.availablePackagePeriods = result;

                vm.availablePackagePeriods.sort(
                    function (a, b) {
                        if (a.durationDays > b.durationDays)
                            return 1;
                        if (a.durationDays < b.durationDays)
                            return -1;
                        if (a.durationDays == b.durationDays) {

                            if (a.id > b.id)
                                return 1;
                            if (a.id < b.id)
                                return -1;
                        }
                        return 0;

                    }
                );

            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusViewController', CompanySubscriptionStatusViewController);

    CompanySubscriptionStatusViewController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom'];

    function CompanySubscriptionStatusViewController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom) {
        var vm = this;
        vm.subscriptionTypeList = [{type: 'BASIC', packages: ''},
            {type: 'ECONOMY', packages: ''},
            {type: 'ENTERPRISE', packages: ''}];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();


        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });

        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();
            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: ''}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {
            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                return "btn-DEFAULT";
            }
            return "btn-" + type;
        }

        function packageCardStyle(type) {
            return "package-card-" + type;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusDialogController', CompanySubscriptionStatusDialogController);

    CompanySubscriptionStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanySubscriptionStatus', 'MoneyTransferLog', 'SubscriptionPackage', 'Company', 'CompanyCustom', 'SubscriptionPackageCustom', 'CompanySubscriptionStatusCustom'];

    function CompanySubscriptionStatusDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanySubscriptionStatus, MoneyTransferLog, SubscriptionPackage, Company, CompanyCustom, SubscriptionPackageCustom, CompanySubscriptionStatusCustom) {
        var vm = this;

        vm.companySubscriptionStatus = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.moneytransferlogs = MoneyTransferLog.query();
        vm.subscriptionpackages = [];
        vm.findCompany = findCompany;
        vm.subscriptionPackage_changed = subscriptionPackage_changed;
        vm.onPackageType_changed = onPackageType_changed;
        vm.packageType = "SUBSCRIPTION";
        vm.finalPrice = 0;
        vm.computeFinalPrice = computeFinalPrice;

        loadAll();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadAll() {
            //
            if (vm.companySubscriptionStatus && vm.companySubscriptionStatus.subscriptionPackage && vm.companySubscriptionStatus.subscriptionPackage.packageType)
                vm.packageType = vm.companySubscriptionStatus.subscriptionPackage.packageType;

            getAllSubscriptionPackages();

            if (vm.companySubscriptionStatus.companyInvoiceInfo && vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice)
                vm.finalPrice = vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice;

        }

        function getAllSubscriptionPackages() {

            SubscriptionPackageCustom.getAllActiveSubscriptionPackages(vm.packageType).query().$promise.then(function (result) {
                    vm.subscriptionpackages = result;
                    SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType(vm.packageType, "ADMIN").query().$promise.then(
                        function (data) {
                            vm.subscriptionpackages.push(data);
                        })
                }
            );
        }

        function save() {
            vm.isSaving = true;
            if (vm.companySubscriptionStatus.id !== null) {
                CompanySubscriptionStatusCustom.companySubscriptionStatusManual().update(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
            } else {
                CompanySubscriptionStatusCustom.companySubscriptionStatusManual().save(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companySubscriptionStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function findCompany() {

            if (vm.companyKeyUrl) {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.companySubscriptionStatus.company = result;
                    }
                })
            }

        }

        function subscriptionPackage_changed() {

            if (!vm.companySubscriptionStatus.subscriptionPackage.id)
                return;

            var packageItem = null;

            angular.forEach(vm.subscriptionpackages, function (item) {
                if (item.id == vm.companySubscriptionStatus.subscriptionPackage.id)
                    packageItem = item;
            });

            if (!packageItem)
                return;

            if (!vm.companySubscriptionStatus.companyInvoiceInfo)
                vm.companySubscriptionStatus.companyInvoiceInfo = {};
            if (packageItem.chargeFee) {
                vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice = packageItem.chargeFee;
            }
            computeFinalPrice();
        }

        function onPackageType_changed() {
            getAllSubscriptionPackages();
        }

        function computeFinalPrice() {

            if (!vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice)
                return;

            var price = vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice;
            var discount = vm.companySubscriptionStatus.companyInvoiceInfo.discount ? vm.companySubscriptionStatus.companyInvoiceInfo.discount : 0;
            var vat = (price - discount) * 10 / 100;
            vm.companySubscriptionStatus.companyInvoiceInfo.vat = vat;

            vm.finalPrice = price - discount + vat;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusDetailController', CompanySubscriptionStatusDetailController);

    CompanySubscriptionStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanySubscriptionStatus', 'MoneyTransferLog', 'SubscriptionPackage', 'Company'];

    function CompanySubscriptionStatusDetailController($scope, $rootScope, $stateParams, entity, CompanySubscriptionStatus, MoneyTransferLog, SubscriptionPackage, Company) {
        var vm = this;

        vm.companySubscriptionStatus = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companySubscriptionStatusUpdate', function (event, result) {
            vm.companySubscriptionStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusDeleteController', CompanySubscriptionStatusDeleteController);

    CompanySubscriptionStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanySubscriptionStatus'];

    function CompanySubscriptionStatusDeleteController($uibModalInstance, entity, CompanySubscriptionStatus) {
        var vm = this;

        vm.companySubscriptionStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanySubscriptionStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySubscriptionStatusCustom', CompanySubscriptionStatusCustom);

    CompanySubscriptionStatusCustom.$inject = ['$resource', 'ENV'];

    function CompanySubscriptionStatusCustom($resource, ENV) {


        var getCurrentCompanySubscriptionStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findActiveCompanySubscription = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/find-active-company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var insertCompanySubscriptionStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/insert-company-subscription-status';
            return $resource(resourceUrl, {}, {}
            );
        };

        var confirmSubscription = function (token, refid) {

            var resourceUrl = ENV.API_BASE_URL + 'api/subscription-confirmation?token=' + token + "&refid=" + refid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var getCompanyTotalStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var canCurrentCompanyReserve = function (companyId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/can-current-company-reserve?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findLastSubscriptionByCurrentCompany = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/find-last-subscription-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var evaluateSupplierCoupon = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/evaluate-supplier-coupon';
            return $resource(resourceUrl, {}, {}
            );
        };

        var computeSubscriptionFinalPrice = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/compute-subscription-final-price';
            return $resource(resourceUrl, {}, {}
            );
        };

        var findTestCompanySubscriptionStatus = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-first-company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var companySubscriptionStatusManual = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/company-subscription-statuses-manual';
            return $resource(resourceUrl, {}, {
                    'update': {method: 'PUT'}
                }
            );
        };


        var isCurrentCompanyHasActiveSubscription = function () {

            var resourceUrl = 'api/is-current-company-has-active-subscription';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var searchCompanySubscriptionStatusByQueryPage = function () {
            var resourceUrl = 'api/search-company-subscription-status-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };


        return {
            getCompanyTotalStatus: getCompanyTotalStatus,
            getCurrentCompanySubscriptionStatus: getCurrentCompanySubscriptionStatus,
            insertCompanySubscriptionStatus: insertCompanySubscriptionStatus,
            confirmSubscription: confirmSubscription,
            findActiveCompanySubscription: findActiveCompanySubscription,
            canCurrentCompanyReserve: canCurrentCompanyReserve,
            findLastSubscriptionByCurrentCompany: findLastSubscriptionByCurrentCompany,
            evaluateSupplierCoupon: evaluateSupplierCoupon,
            computeSubscriptionFinalPrice: computeSubscriptionFinalPrice,
            findTestCompanySubscriptionStatus: findTestCompanySubscriptionStatus,
            companySubscriptionStatusManual: companySubscriptionStatusManual,
            isCurrentCompanyHasActiveSubscription: isCurrentCompanyHasActiveSubscription,
            searchCompanySubscriptionStatusByQueryPage: searchCompanySubscriptionStatusByQueryPage

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-subscription-status', {
                parent: 'entity',
                url: '/company-subscription-status?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySubscriptionStatus.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-statuses.html',
                        controller: 'CompanySubscriptionStatusController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-subscription-status-detail', {
                parent: 'entity',
                url: '/company-subscription-status/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySubscriptionStatus.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-detail.html',
                        controller: 'CompanySubscriptionStatusDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanySubscriptionStatus', function ($stateParams, CompanySubscriptionStatus) {
                        return CompanySubscriptionStatus.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-subscription-status.new', {
                parent: 'company-subscription-status',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-dialog.html',
                        controller: 'CompanySubscriptionStatusDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    startDate: null,
                                    expireDate: null,
                                    wageFeePercentage: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-subscription-status', null, {reload: true});
                    }, function () {
                        $state.go('company-subscription-status');
                    });
                }]
            })
            .state('company-subscription-status.edit', {
                parent: 'company-subscription-status',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-dialog.html',
                        controller: 'CompanySubscriptionStatusDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanySubscriptionStatus', function (CompanySubscriptionStatus) {
                                return CompanySubscriptionStatus.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-subscription-status', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-subscription-status.delete', {
                parent: 'company-subscription-status',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-delete-dialog.html',
                        controller: 'CompanySubscriptionStatusDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanySubscriptionStatus', function (CompanySubscriptionStatus) {
                                return CompanySubscriptionStatus.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-subscription-status', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySubscriptionStatus', CompanySubscriptionStatus);

    CompanySubscriptionStatus.$inject = ['$resource', 'DateUtils'];

    function CompanySubscriptionStatus($resource, DateUtils) {
        var resourceUrl = 'api/company-subscription-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.expireDate = DateUtils.convertDateTimeFromServer(data.expireDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySubscriptionStatusSearch', CompanySubscriptionStatusSearch);

    CompanySubscriptionStatusSearch.$inject = ['$resource'];

    function CompanySubscriptionStatusSearch($resource) {
        var resourceUrl = 'api/_search/company-subscription-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusController', CompanySubscriptionStatusController);

    CompanySubscriptionStatusController.$inject = ['$scope', '$state', 'CompanySubscriptionStatus', 'CompanySubscriptionStatusSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'CompanySubscriptionStatusCustom'];

    function CompanySubscriptionStatusController($scope, $state, CompanySubscriptionStatus, CompanySubscriptionStatusSearch, ParseLinks, AlertService, pagingParams, paginationConstants, CompanySubscriptionStatusCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {

            if (pagingParams.search) {
                CompanySubscriptionStatusSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanySubscriptionStatus.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companySubscriptionStatuses = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionHistoriesController', CompanySubscriptionHistoriesController);

    CompanySubscriptionHistoriesController.$inject = ['$scope', '$state', 'CompanySubscriptionStatusCustom', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$stateParams'];

    function CompanySubscriptionHistoriesController($scope, $state, CompanySubscriptionStatusCustom, ParseLinks, AlertService, pagingParams, paginationConstants, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;
        vm.clearSearch = clearSearch;
        vm.filterQuery = {};
        vm.packageType = $stateParams.packageType;
        vm.filterQuery.packageType = vm.packageType;


        //must set in cache
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.isSearching = false;
        vm.pageSizeChanged = pageSizeChanged;

        vm.back = back;


        loadData();

        // loadAll_paging();


        function loadData() {
            filter();
        }

        // function loadAll_paging() {
        //
        //     if (pagingParams.search) {
        //         CompanyCustomerDataSearch.query({
        //             query: pagingParams.search,
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     } else {
        //         CompanyCustomerDataSearch.query({
        //             query: "",
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     }
        //
        //     function sort() {
        //         var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        //         if (vm.predicate !== 'id') {
        //             result.push('id');
        //         }
        //         return result;
        //     }
        //
        //     function onSuccess(data, headers) {
        //         vm.links = ParseLinks.parse(headers('link'));
        //         vm.totalItems = headers('X-Total-Count');
        //         vm.queryCount = vm.totalItems;
        //         vm.CompanyCustomerDatas = data;
        //         vm.page = pagingParams.page;
        //     }
        //
        //     function onError(error) {
        //         AlertService.error(error.data.message);
        //     }
        // }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getPagesByQuery(vm.filterQuery);
            else
                getPagesByQuery();

        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }


        function search() {

            // loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.advancedSearch();
            }
        }


        function clearSearch() {
            vm.filterQuery.searchText = null;
            filter_Global();
        }


        vm.advancedSearch = function () {
            clear();
            vm.filterQuery.searchMode = true;
            filter();
        }

        function pageSizeChanged() {
            clear();
            filter();
        }

        function getPagesByQuery(customFilter) {

            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;


            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;

            CompanySubscriptionStatusCustom.searchCompanySubscriptionStatusByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companySubscriptionStatuses = data;
                vm.isSearching = false;

                gotToTop();

            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }


        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function filter_Global() {
            vm.filterQuery.searchMode = true;
            filter();
            clear();

        }

        function filter(customFilter) {

            if (vm.isSearching)
                return;
            getPagesByQuery(customFilter);
        }

        function back() {
            if (vm.packageType && vm.packageType == 'SMS')
                $state.transitionTo('supplierPanel-v2.companySmsPackageStatus');
            else
                $state.transitionTo('supplierPanel-v2.companySubscriptionStatusV2');
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySmsPackageStatusViewController', CompanySmsPackageStatusViewController);

    CompanySmsPackageStatusViewController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery'];

    function CompanySmsPackageStatusViewController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery) {
        var vm = this;
        vm.subscriptionTypeList = [{type: '', packages: ''}
        ];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = '';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.getCompanyTotalStatus().query(function (entity) {
            vm.companyPackageStatus = entity;
        });

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;

        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                console.log(entity);
                loadData();
            }


        });

        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();
            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType('SMS', '').query(function (pks) {
                    if (pks)
                        var arr = [];
                        arr = pks.filter(function (pk) {
                            return pk.chargeFee > 0;
                        });
                        vm.subscriptionPackages = arr.sort(function(a, b){
                            return a.chargeFee - b.chargeFee;
                        });
                });

            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                /* if(result.subscriptionType != null && result.subscriptionType!='')
                 {
                     vm.subscriptionType = result.subscriptionType;
                     vm.showSubscriptionType= false;
                     vm.hasCustomSubscriptionType=false;
                     vm.subscriptionTypeList=[{type:vm.subscriptionType,packages:''}];
                 }
                 else
                 {

                 }*/
                vm.subscriptionTypeList.forEach(function (stype) {
                    // stype.packages=SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType('SMS','').query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {
            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                return "btn-DEFAULT";
            }
            return "btn-" + type;
        }

        function packageCardStyle(type) {
            return "package-card-" + type;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyBuySubscriptionController', CompanyBuySubscriptionController);

    CompanyBuySubscriptionController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom', '$sce', '$location', '$anchorScroll', 'PackageFeatureListCustom', 'CompanySession', '$timeout', '$localStorage'];

    function CompanyBuySubscriptionController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom, $sce, $location, $anchorScroll, PackageFeatureListCustom, CompanySession, $timeout, $localStorage) {
        var vm = this;
        vm.activityTypeInfo = entity;
        // vm.subscriptionTypeList=[{type:'BASIC',packages:'',isSelected:false},
        //                          {type:'ECONOMY',packages:'',isSelected:false},
        //                          {type:'ENTERPRISE',packages:'',isSelected:false}];
        vm.subscriptionTypeList = [{type: 'ENTERPRISE', packages: '', isSelected: false}];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;
        vm.isNativeApp = null;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.lastSubsriptionType = "BASIC";

        CompanySubscriptionStatusCustom.findLastSubscriptionByCurrentCompany().query(function (lastSubsription) {

            if (lastSubsription) {
                vm.lastSubsriptionType = lastSubsription.subscriptionPackage.subscriptionType;
                // if(vm.lastSubsriptionType=="ECONOMY")
                // {
                //     vm.subscriptionTypeList=[{type:'ECONOMY',packages:'',isSelected:false},
                //         {type:'ENTERPRISE',packages:'',isSelected:false}];
                // }
                // if(vm.lastSubsriptionType=="ENTERPRISE")
                // {
                //     vm.subscriptionTypeList=[{type:'ENTERPRISE',packages:'',isSelected:false}];
                //
                // }
            }
        })

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();
        vm.selectSubscriptionBaseType = selectSubscriptionBaseType;
        vm.selectedSubscriptionType = null;
        vm.isAnyPackageSelected = false;
        vm.availablePackagePeriods = [];
        vm.getAvailablePackagePeriod = getAvailablePackagePeriod;
        vm.makeFeatureDesc = makeFeatureDesc;
        vm.PackageFeatureList = null;
        vm.showFeaturesClick = showFeaturesClick;
        vm.showFeatures = false;

        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });


        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();

            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: '', isSelected: false}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
                CompanySession.resetCompanySession();
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {

            var classname = "";

            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                classname = "btn-DEFAULT";
            } else {
                classname = "btn-" + type;
            }

            if (vm.isAnyPackageSelected && vm.selectedSubscriptionType != type) {
                classname += " btn-not-selected";
            }

            return classname;
        }

        function packageCardStyle(ptype) {
            if (ptype == undefined)
                return;

            var cls = "package-card-" + ptype.type;
            if (vm.isAnyPackageSelected && ptype.isSelected != true) {
                cls += " package-card-not-selected"
            }

            return cls;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                loadPackageFeatureList();

            });
        }

        function selectSubscriptionBaseType(pType) {

            if (pType == undefined)
                return;
            vm.selectedSubscriptionType = pType.type;
            setAllTypeAsUnSelected();
            pType.isSelected = true;
            vm.isAnyPackageSelected = true;
            getAvailablePackagePeriod();

            scrollDown();

        }

        function scrollDown() {
            $location.hash('periodSelection');
            // call $anchorScroll()
            $anchorScroll();
        }

        function setAllTypeAsUnSelected() {
            angular.forEach(vm.subscriptionTypeList, function (type) {
                type.isSelected = false;
            });
        }

        function getAvailablePackagePeriod() {
            if (!vm.isAnyPackageSelected)
                return;

            vm.availablePackagePeriods = [];

            vm.subscriptionTypeList.forEach(function (stype) {

                if (stype.type == vm.selectedSubscriptionType) {
                    vm.availablePackagePeriods = stype.packages;

                    vm.availablePackagePeriods.sort(
                        function (a, b) {
                            if (a.durationDays > b.durationDays)
                                return 1;
                            if (a.durationDays < b.durationDays)
                                return -1;
                            return 0;

                        }
                    );
                }
            });
        }

        function makeFeatureDesc(ptype) {
            var desc = "";
            var servantTitle = 'پرسنل';
            if (vm.activityTypeInfo && vm.activityTypeInfo.servantType == 'RESOURCE')
                servantTitle = vm.activityTypeInfo.servantTitle;


            if (ptype.type == "BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 1 امکان ویژه سیستم</strong> </li>';
                desc += '<li>   رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>   ارسال پیامک یادآوری </li>';
                desc += '<li>   <strong> 150 </strong> پیامک رایگان </li>';
                desc += '<li>   پشتیبانی 24 ساعته  </li>';
                desc += '<li>   حداکثر <strong> 2 ' + servantTitle + '</strong> </li>';
                // desc += '<li>   پرسنل اضافه 15 هزار تومان/ماه</li>';

            }
            if (ptype.type == "ECONOMY") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 4 امکان ویژه سیستم</strong> </li>';
                desc += '<li>   رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>   ارسال پیامک یادآوری </li>';
                desc += '<li>   <strong> 300 </strong> پیامک رایگان </li>';
                desc += '<li>   پشتیبانی 24 ساعته  </li>';
                desc += '<li>   حداکثر <strong> 5 ' + servantTitle + '</strong> </li>';
                // desc += '<li>   پرسنل اضافه 10 هزار تومان/ماه</li>';

            }
            if (ptype.type == "ENTERPRISE") {
                desc += '<li>  تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 10 امکان ویژه سیستم</strong> </li>';
                desc += '<li>  رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>  ارسال پیامک یادآوری </li>';
                desc += '<li>  <strong> 1000 </strong> پیامک رایگان </li>';
                desc += '<li>  پشتیبانی 24 ساعته  </li>';
                // desc += '<li>   حداکثر <strong> 10 '+ servantTitle +'</strong> </li>';
                // desc += '<li>  پرسنل اضافه 8 هزار تومان/ماه</li>';


            }

            desc = $sce.trustAsHtml(desc);

            return desc;


        }

        function loadPackageFeatureList() {
            if (vm.currentCompany) {
                PackageFeatureListCustom.getPackageFeatureListByCompanyId(vm.currentCompany.id).query().$promise.then(function (packages) {


                    vm.packageFeatureList = packages;
                })
            }
        }

        function showFeaturesClick() {
            vm.showFeatures = !vm.showFeatures;
        }
        $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp;
        },10)

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoDialogControllerCustom', CompanySocialNetworkInfoDialogControllerCustom);

    CompanySocialNetworkInfoDialogControllerCustom.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanySocialNetworkInfo', 'Company', 'SocialNetworkInfo'];

    function CompanySocialNetworkInfoDialogControllerCustom($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanySocialNetworkInfo, Company, SocialNetworkInfo) {
        var vm = this;
        vm.scope = $scope;
        vm.companySocialNetworkInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.socialnetworkinfos = SocialNetworkInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.companySocialNetworkInfo.id !== null) {
                    CompanySocialNetworkInfo.update(vm.companySocialNetworkInfo, onSaveSuccess, onSaveError);
                } else {
                    CompanySocialNetworkInfo.save(vm.companySocialNetworkInfo, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companySocialNetworkInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoControllerCustom', CompanySocialNetworkInfoControllerCustom);

    CompanySocialNetworkInfoControllerCustom.$inject = ['$rootScope', '$scope', '$state', 'CompanySocialNetworkInfo', 'CompanySocialNetworkInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'CompanySocialNetworkCustom', '$translate', '$translatePartialLoader', 'PackageFeatureListCustom', 'Principal'];

    function CompanySocialNetworkInfoControllerCustom($rootScope, $scope, $state, CompanySocialNetworkInfo, CompanySocialNetworkInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants, CompanySocialNetworkCustom, translate, translatePartialLoader, PackageFeatureListCustom, Principal) {
        var vm = this;

        vm.save = save;
        vm.companySocialNetworkInfoList = null;
        vm.scope = $scope;
        vm.findClass = findClass;
        vm.placeHolder = placeHolder;
        vm.isDisabled = isDisabled;
        vm.hasWhatsAppFeature = false;


        vm.okModal = okModal;
        vm.closeModal = closeModal;


        loadAll();

        function loadAll() {

            translatePartialLoader.addPart('companySocialNetworkInfo');
            translatePartialLoader = translate.refresh();

            $rootScope.$broadcast('hideNavBar');

            hasWhatsAppFeature();


            CompanySocialNetworkCustom.getCompanySocialNetwork().query(onSuccess, onError);

            function onSuccess(data, headers) {

                vm.companySocialNetworkInfoList = {};
                vm.companySocialNetworkInfoList.companySocialNetworkInfos = data;
                if (vm.companySocialNetworkInfoList.companySocialNetworkInfos == null || vm.companySocialNetworkInfoList.companySocialNetworkInfos == 0) {
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos = [];
                    // add telegram
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 1,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "TELEGRAM",
                                title: "تلگرام",
                                url: ""
                            }
                        }
                    )

                    // add instagram
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 2,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "INSTAGRAM",
                                title: "اینستاگرام",
                                url: ""
                            }
                        }
                    )

                    // add linkedin
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 3,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "LINKEDIN",
                                title: "لینکدین",
                                url: ""
                            }
                        }
                    )


                }
                if (vm.companySocialNetworkInfoList.companySocialNetworkInfos.length == 3) {
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 4,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "WHATSAPP",
                                title: "واتساپ",
                                url: ""
                            }
                        }
                    )
                }
                //vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.companySocialNetworkInfoList !== null && vm.companySocialNetworkInfoList.companySocialNetworkInfos != null && vm.companySocialNetworkInfoList.companySocialNetworkInfos.length > 0) {
                    {

                        CompanySocialNetworkCustom.saveCompanySocialNetworkList().save(vm.companySocialNetworkInfoList, onSaveSuccess, onSaveError);
                    }

                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companySocialNetworkInfoUpdate', result);
            vm.isSaving = false;
            loadAll();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findClass(companySocialNetworkInfo) {
            return "socialNetwork" + "-" + companySocialNetworkInfo.socialNetworkInfo.socialNetworkType;
        }

        function placeHolder(companySocialNetworkInfo) {
            var type = companySocialNetworkInfo.socialNetworkInfo.socialNetworkType;
            if (type == 'WHATSAPP' && !vm.hasWhatsAppFeature) {
                return translate.instant('feature-info.whatsAppSupport');
                ;
            } else
                return translate.instant('tikonApp.companySocialNetworkInfo.' + type + '-placeHolder');


        }

        function isDisabled(companySocialNetworkInfo) {
            var type = companySocialNetworkInfo.socialNetworkInfo.socialNetworkType;
            if (type == 'WHATSAPP' && !vm.hasWhatsAppFeature)
                return true;

            return false;
        }

        function hasWhatsAppFeature() {

            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                vm.hasWhatsAppFeature = Principal.hasSpecialFeatureAccess('whatsAppSupport');
            })

        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoDialogController', CompanySocialNetworkInfoDialogController);

    CompanySocialNetworkInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanySocialNetworkInfo', 'Company', 'SocialNetworkInfo'];

    function CompanySocialNetworkInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanySocialNetworkInfo, Company, SocialNetworkInfo) {
        var vm = this;

        vm.companySocialNetworkInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.socialnetworkinfos = SocialNetworkInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companySocialNetworkInfo.id !== null) {
                CompanySocialNetworkInfo.update(vm.companySocialNetworkInfo, onSaveSuccess, onSaveError);
            } else {
                CompanySocialNetworkInfo.save(vm.companySocialNetworkInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companySocialNetworkInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoDetailController', CompanySocialNetworkInfoDetailController);

    CompanySocialNetworkInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanySocialNetworkInfo', 'Company', 'SocialNetworkInfo'];

    function CompanySocialNetworkInfoDetailController($scope, $rootScope, $stateParams, entity, CompanySocialNetworkInfo, Company, SocialNetworkInfo) {
        var vm = this;

        vm.companySocialNetworkInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companySocialNetworkInfoUpdate', function (event, result) {
            vm.companySocialNetworkInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoDeleteController', CompanySocialNetworkInfoDeleteController);

    CompanySocialNetworkInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanySocialNetworkInfo'];

    function CompanySocialNetworkInfoDeleteController($uibModalInstance, entity, CompanySocialNetworkInfo) {
        var vm = this;

        vm.companySocialNetworkInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanySocialNetworkInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySocialNetworkCustom', CompanySocialNetworkCustom);

    CompanySocialNetworkCustom.$inject = ['$resource'];

    function CompanySocialNetworkCustom($resource) {


        var getCompanySocialNetwork = function () {
            var resourceUrl = 'api/get-company-social-network-infos-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var saveCompanySocialNetworkList = function () {
            var resourceUrl = 'api/save-company-social-network-infos';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {

            getCompanySocialNetwork: getCompanySocialNetwork,
            saveCompanySocialNetworkList: saveCompanySocialNetworkList

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-social-network-info', {
                parent: 'entity',
                url: '/company-social-network-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySocialNetworkInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-infos.html',
                        controller: 'CompanySocialNetworkInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companySocialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-social-network-info-detail', {
                parent: 'entity',
                url: '/company-social-network-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySocialNetworkInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-info-detail.html',
                        controller: 'CompanySocialNetworkInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companySocialNetworkInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanySocialNetworkInfo', function ($stateParams, CompanySocialNetworkInfo) {
                        return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-social-network-info.new', {
                parent: 'company-social-network-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-info-dialog.html',
                        controller: 'CompanySocialNetworkInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    orderNumber: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-social-network-info', null, {reload: true});
                    }, function () {
                        $state.go('company-social-network-info');
                    });
                }]
            })
            .state('company-social-network-info.edit', {
                parent: 'company-social-network-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-info-dialog.html',
                        controller: 'CompanySocialNetworkInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanySocialNetworkInfo', function (CompanySocialNetworkInfo) {
                                return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-social-network-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-social-network-info.delete', {
                parent: 'company-social-network-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-info-delete-dialog.html',
                        controller: 'CompanySocialNetworkInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanySocialNetworkInfo', function (CompanySocialNetworkInfo) {
                                return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-social-network-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySocialNetworkInfo', CompanySocialNetworkInfo);

    CompanySocialNetworkInfo.$inject = ['$resource'];

    function CompanySocialNetworkInfo($resource) {
        var resourceUrl = 'api/company-social-network-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySocialNetworkInfoSearch', CompanySocialNetworkInfoSearch);

    CompanySocialNetworkInfoSearch.$inject = ['$resource'];

    function CompanySocialNetworkInfoSearch($resource) {
        var resourceUrl = 'api/_search/company-social-network-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoController', CompanySocialNetworkInfoController);

    CompanySocialNetworkInfoController.$inject = ['$scope', '$state', 'CompanySocialNetworkInfo', 'CompanySocialNetworkInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanySocialNetworkInfoController($scope, $state, CompanySocialNetworkInfo, CompanySocialNetworkInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CompanySocialNetworkInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanySocialNetworkInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companySocialNetworkInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsV2DialogController', CompanyServantsV2DialogController);

    CompanyServantsV2DialogController.$inject = ['__config', '$timeout', '$scope', '$stateParams', '$state', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo', 'ServantCustom', 'CompanyCustom', '$translate', '$mdToast', '$mdDialog', '$rootScope', 'Principal', 'ActivityTypeInfoCustom', 'ServiceItemCustom', 'PackageFeatureListCustom'];

    function CompanyServantsV2DialogController(__config, $timeout, $scope, $stateParams, $state, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo, ServantCustom, CompanyCustom, $translate, $mdToast, $mdDialog, $rootScope, Principal, ActivityTypeInfoCustom, ServiceItemCustom, PackageFeatureListCustom) {
        var vm = this;

        vm.scope = $scope;
        vm.servant = entity;
        vm.$state = $state;
        vm.hasEoTimeRange = false;
        if (vm.servant && vm.servant.id != null) {
            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            vm.showAmenities = false;
            vm.showImageGallery = false;
            vm.showTags = false;
            vm.isWorkSpace = false;
            vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
            vm.__config = __config;
            vm.showLimitDates = false;
            vm.showLimitDateChange = showLimitDateChange;
            vm.addClosedTimes = addClosedTimes;
            vm.addOpenTimes = addOpenTimes;
            vm.setTabActive = setTabActive;


            angular.forEach(vm.servant.scheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                }
            })
            vm.servant.scheduleInfo.scheduleExceptionDurations = tempArr;
        }
        // vm.servant.status = 'ACTIVE';
        vm.clear = clear;
        vm.save = save;
        vm.tabSelector = tabSelector;
        vm.orderedTabSelected = true;
        //vm.personinfos = PersonInfo.query();
        vm.serviceList = [];
        vm.hasNotNewSchedule = hasNotNewSchedule;
        vm.hasNewSchedule = hasNewSchedule;
        vm.setEdited = setEdited;
        vm.updatePrice = updatePrice;
        vm.editBtnPressed = [];
        vm.showServantSchedule = true;
        vm.showServantCloseTimes = false;
        vm.getNavItemClass = getNavItemClass;
        vm.serviceListEmptyMessage = "این پرسنل هیچ خدمتی ارائه نمی دهد";


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;
        vm.allCompanyServiceList = [];
        vm.onServantServiceCheckChange = onServantServiceCheckChange;
        vm.onServiceServantScheduleTabClick = onServiceServantScheduleTabClick;
        vm.isServiceScheduleLoading = false;
        vm.isServiceScheduleLoaded = false;
        vm.hasServantServiceSchedulingFeature = false;
        vm.customPricingForServant = false;

        loadAll();

        function loadAll() {


            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);
            loadAllCompanyServiceList();
            // loadServantServiceSchedules();
            hasServantServiceSchedulingFeature();
            hasCustomPricingForServantFeature();

            checkAccess();
            checkShowLimitDates();
        }

        function checkAccess() {

            vm.isServantLogin = false;

            Principal.hasAuthority('ROLE_SERVANT_LOGIN')
                .then(function (result) {
                    if (result)
                        vm.isServantLogin = true;
                    else
                        vm.isServantLogin = false;
                })
        }

        function hasServantServiceSchedulingFeature() {

            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                vm.hasServantServiceSchedulingFeature = Principal.hasSpecialFeatureAccess('servantServiceScheduling');
            })

        }

        function hasCustomPricingForServantFeature() {

            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                vm.customPricingForServant = Principal.hasSpecialFeatureAccess('customPricingForServant');
            })

        }

        checkCompanyActivityType();
        // $scope.$watch('vm.servant', function (servant) {
        // })

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function loadAllCompanyServiceList() {
            if (!vm.servant || !vm.servant.id)
                return;
            ServiceItemCustom.getServiceItemWithServantsByCurrentCompany().query(function (result) {
                vm.allCompanyServiceList = result;
                ServiceItemCustom.getServiceItemsByServantId(vm.servant.id).query(function (list) {
                    vm.allServantServices = list;
                    makeServantServiceList();
                })

            });
        }

        function makeServantServiceList() {
            angular.forEach(vm.allCompanyServiceList, function (allItem) {
                angular.forEach(vm.allServantServices, function (service) {
                    if (allItem.id == service.id)
                        allItem.checked = true;
                })
                if (allItem.serviceMode && allItem.serviceMode == 'EVENT')
                    allItem.canRemoveCheck = false;
                else {
                    if (allItem.servants && allItem.servants.length > 1) {
                        allItem.canRemoveCheck = true;
                    } else {
                        allItem.canRemoveCheck = false;
                    }
                }
            })
        }

        function clear() {
            // $uibModalInstance.dismiss('cancel');
        }

        function tabSelector() {
            vm.orderedTabSelected = !vm.orderedTabSelected;
        }

        function save() {

            if (vm.isWorkSpace)
                vm.servant.personInfo.lastName = ' ';

            prepareServiceItemListForSave();

            vm.isSaving = true;

            if (vm.servant.id !== null) {
                Servant.update(vm.servant, onSaveSuccess, onSaveError);
            } else {
                Servant.save(vm.servant, function (result) {

                    if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                        $rootScope.$broadcast('showNavBar');
                        $state.go('supplierPanel-v2.dashboard');
                    } else
                        $state.go('supplierPanel-v2.companyServants.edit', {id: result.id});

                }, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            if (vm.isServiceScheduleLoaded) {
                ServantCustom.saveScheduleList().update(vm.serviceList, function () {
                    $scope.$emit('tikonApp:servantUpdate', result);
                    // vm.serviceList=ServantCustom.serviceItemScheduleByServantId(servant.id).query(function(result){
                    //     vm.servant=result;
                    // });

                    vm.isSaving = false;

                })
            } else {
                vm.isSaving = false;
            }


            if (result.videoCallSettingInfo && result.videoCallSettingInfo.id) {
                vm.servant.videoCallSettingInfo = result.videoCallSettingInfo;
            }

            $timeout(function() {
                loadAllCompanyServiceList();
                loadServantServiceSchedules();
            },100)

        }

        function loadServantServiceSchedules() {

            if (!vm.hasServantServiceSchedulingFeature && !vm.customPricingForServant) {
                vm.isServiceScheduleLoading = false;
                vm.isServiceScheduleLoaded = false;
                return;
            }


            if (vm.servant) {
                if (vm.servant.scheduleInfo && !vm.servant.scheduleInfo.baseScheduleMode)
                    vm.servant.scheduleInfo.baseScheduleMode = 'BASED_ON_COMPANY';
                if (vm.servant.id)
                    vm.isServiceScheduleLoading = true;
                vm.isServiceScheduleLoaded = false;

                ServantCustom.serviceItemScheduleByServantId(vm.servant.id).query(function (result) {
                    vm.serviceList = result;
                    checkShowLimitDates();
                    vm.isServiceScheduleLoading = false;
                    vm.isServiceScheduleLoaded = true;

                });

            }
        }

        function setEdited(ssi) {

            ssi.edited = (!ssi.edited);
        }

        function hasNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = true;
        }

        function hasNotNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function updatePrice(serviceItemId, priceInfo, index) {

            ServantCustom.updateServantService(serviceItemId, vm.servant.id).save(priceInfo, function (result) {

                priceInfo = result;
                $scope.$emit('tikonApp:servantUpdate', result);
                vm.isSaving = false;
                vm.editBtnPressed[index] = false;
            })

        }

        function checkCompanyActivityType() {

            if (vm.servant.company) {
                getActivityTYpeInfo(vm.servant.company.activityType);
            } else {
                CompanyCustom.getCurrentCompany().query(function (result) {
                    getActivityTYpeInfo(result.activityType);
                })
            }
        }

        function getActivityTYpeInfo(at) {
            ActivityTypeInfoCustom.getActivityTypeInfoByType(at).query(function (activity) {
                vm.activityTypeInfo = activity;
                if (activity && activity.servantType == "RESOURCE") {
                    vm.isWorkSpace = true;

                    vm.showAmenities = false;
                    vm.showImageGallery = false;
                    vm.showTags = false;
                    vm.isWorkSpace = true;
                    vm.serviceListEmptyMessage = 'هیچ خدماتی انتخاب نشده است.';

                    setServantTranslate();
                }
            })
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space-v2');
            }
        }


        $scope.ActiveServiceFilter = function (item) {
            return item.serviceItem.serviceStatus != 'DISABLE';
        };
        $scope.ValidPriceInfoFilter = function (item) {
            return true;
            //   return (item.priceInfoDtails && item.priceInfoDtails.length>0);
        };


        var last = {
            bottom: false,
            top: true,
            left: true,
            right: false
        };

        vm.toastPosition = angular.extend({}, last);

        vm.getToastPosition = function () {
            sanitizePosition();

            return Object.keys(vm.toastPosition)
                .filter(function (pos) {
                    return vm.toastPosition[pos];
                }).join(' ');
        };

        function sanitizePosition() {
            var current = vm.toastPosition;

            if (current.bottom && last.top) {
                current.top = false;
            }
            if (current.top && last.bottom) {
                current.bottom = false;
            }
            if (current.right && last.left) {
                current.left = false;
            }
            if (current.left && last.right) {
                current.right = false;
            }

            last = angular.extend({}, current);
        }

        function showLimitDateChange(showLimitDates, datePeriod) {
            if (!showLimitDates) {
                datePeriod.fromDate = null;
                datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {
            if (!vm.servant.scheduleInfo || !vm.servant.scheduleInfo.weeklyScheduleInfo)
                return;

            if (vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.endDate
            ) {
                vm.showLimitDates = true;
            }


            angular.forEach(vm.serviceList, function (ssi) {
                if (ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                    ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate
                ) {
                    ssi.showLimitDates = true;
                }
            })

        }

        function setTabActive(tabName) {
            switch (tabName) {
                case 'servantSchedule':
                    vm.showServantSchedule = true;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantCloseTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = true;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantOpenTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = true;
                    break;
            }
        }

        function getNavItemClass(itemName) {
            switch (itemName) {
                case 'servantSchedule':
                    if (vm.showServantSchedule)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantCloseTimes':
                    if (vm.showServantCloseTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantOpenTimes':
                    if (vm.showServantOpenTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
            }
        }

        function addClosedTimes() {
            addServantExceptionTimes('CLOSE');
        }

        function addOpenTimes() {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            $state.go('supplierPanel-v2.companyServants.servantExceptionTimes', {
                availabilityMode: mode,
                defaultServantId: vm.servant.id
            });

        }

        function reloadServantExceptionDurations() {
            $rootScope.$broadcast('reloadServantExceptionDurationListEvent');
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');
                return;
            }

            Principal.hasAuthority('ROLE_SERVANT_LOGIN')
                .then(function (result) {
                    if (result) {
                        if ($rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.more')
                            $state.go('supplierPanel-v2.more');
                        else
                            $state.go('supplierPanel-v2.dashboard');

                    } else {
                        $state.go('supplierPanel-v2.companyServants', $rootScope.fromStateParams);
                    }
                });
            // $state.go('supplierPanel-v2.companyServants');

        }

        function getModalTitle() {
            if (vm.servant.id)
                return 'tikonApp.servant.home.edit';
            else
                return 'tikonApp.servant.home.create';
        }

        function prepareServiceItemListForSave() {

            if (vm.allCompanyServiceList) {
                vm.servant.serviceItemList = [];
                angular.forEach(vm.allCompanyServiceList, function (item) {
                    if (item.checked)
                        vm.servant.serviceItemList.push(item);
                })
            }
        }

        function onServantServiceCheckChange(item) {
            if (item.checked)
                item.canRemoveCheck = true;
        }

        function onServiceServantScheduleTabClick() {
            if (!vm.isServiceScheduleLoading && !vm.isServiceScheduleLoaded) {
                vm.isServiceScheduleLoading = true;
                $timeout(function () {
                    loadServantServiceSchedules();
                }, 100);
            }

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsV2Controller', CompanyServantsV2Controller);

    CompanyServantsV2Controller.$inject = ['$scope', '$state', 'Servant', 'ServantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServantCustom', 'CompanyCustom', '$translate', 'Principal', 'DialogService', 'ActivityTypeInfoCustom', '$uibModal', 'QueryParamsService'];

    function CompanyServantsV2Controller($scope, $state, Servant, ServantSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServantCustom, CompanyCustom, $translate, Principal, DialogService, ActivityTypeInfoCustom, $uibModal, QueryParamsService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.isWorkSpace = false;
        vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
        vm.newServantClick = newServantClick;


        vm.editServant = editServant;
        vm.searchServants = searchServants;
        vm.searchKeyPress = searchKeyPress;
        vm.newServant = newServant;
        vm.clearSearch = clearSearch;
        vm.showEducation = showEducation

        loadAll();
        loadPage();

        function loadAll() {


        }

        function loadPage(page) {
            //vm.page = page;
            //vm.transition();

            //if($ctrl.companyId==undefined || $ctrl.companyId==null)$ctrl.priceInfos=[];
            //else
            CompanyCustom.getCurrentCompany().query(function (result) {
                
                ActivityTypeInfoCustom.getActivityTypeInfoByType(result.activityType).query(function (activity) {
                    if (activity && activity.servantType == "RESOURCE") {
                        vm.isWorkSpace = true;
                    }
                    setServantTranslate();
                })
                
            });
            
            loadServants();
        }
        
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space-v2');
            }
        }

        function newServantClick() {
            var result;
            if (vm.servants) {
                result = Principal.canAddNewServant(vm.servants.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }

            $state.transitionTo('supplierPanel.companyServants.new');

        }

        function loadAccessToAddNew() {
            var _company = Principal.getCurrentCompany();
            if (_company && _company.id) {
                PackageFeatureListCustom.getPackageFeatureListByCompanyId(_company.id).query().$promise.then(function (result) {
                    Principal.setCurrentCompanyFeatureList(result);
                });
            }
        }


        function editServant(servant) {
            $state.go('supplierPanel-v2.companyServants.edit', {id: servant.id});
        }

        function newServant() {
            var result;
            if (vm.servants) {
                result = Principal.canAddNewServant(vm.servants.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }

            $state.go('supplierPanel-v2.companyServants.new');
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServants();
            }
        }

        function loadServants() {
            ServantCustom.findServantsByCompany().query().$promise.then(function(res) {
                vm.servants = res;
                var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        searchServants()
                }
            })
        }

        function searchServants() {
            if (!vm.searchQuery) {
                 QueryParamsService.removeFilter('searchText')
                loadServants();
                return;
            }else  QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.servants = vm.servants.filter(function (srv) {
                if (srv.personInfo.fisrtName.includes(vm.searchQuery) ||
                    srv.personInfo.lastName.includes(vm.searchQuery) ||
                    (srv.personInfo.phoneNumber && srv.personInfo.phoneNumber.includes(vm.searchQuery))

                )
                    return true;
            })
        }

        function clearSearch() {
            vm.searchQuery = null;
            QueryParamsService.removeFilter('searchText')
            loadServants();
        }
        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="34479560706"><script type="text/JavaScript" src="https://www.aparat.com/embed/yiywlpx?data[rnddiv]=34479560706&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>'
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsDialogController', CompanyServantsDialogController);

    CompanyServantsDialogController.$inject = ['__config', '$timeout', '$scope', '$stateParams', '$state', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo', 'ServantCustom', 'CompanyCustom', '$translate', '$mdToast', '$mdDialog', '$rootScope', 'ServiceItemCustom'];

    function CompanyServantsDialogController(__config, $timeout, $scope, $stateParams, $state, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo, ServantCustom, CompanyCustom, $translate, $mdToast, $mdDialog, $rootScope, ServiceItemCustom) {
        var vm = this;

        vm.scope = $scope;
        vm.servant = entity;
        vm.hasEoTimeRange = false;
        if (vm.servant && vm.servant.id != null) {
            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            vm.showAmenities = false;
            vm.showImageGallery = false;
            vm.showTags = false;
            vm.isWorkSpace = false;
            vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
            vm.__config = __config;
            vm.showLimitDates = false;
            vm.showLimitDateChange = showLimitDateChange;
            vm.addClosedTimes = addClosedTimes;
            vm.addOpenTimes = addOpenTimes;
            vm.setTabActive = setTabActive;


            angular.forEach(vm.servant.scheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                }
            })
            vm.servant.scheduleInfo.scheduleExceptionDurations = tempArr;
        }
        // vm.servant.status = 'ACTIVE';
        vm.clear = clear;
        vm.save = save;
        vm.tabSelector = tabSelector;
        vm.orderedTabSelected = true;
        //vm.personinfos = PersonInfo.query();
        vm.serviceList = [];
        vm.hasNotNewSchedule = hasNotNewSchedule;
        vm.hasNewSchedule = hasNewSchedule;
        vm.setEdited = setEdited;
        vm.updatePrice = updatePrice;
        vm.editBtnPressed = [];
        vm.showServantSchedule = true;
        vm.showServantCloseTimes = false;
        vm.getNavItemClass = getNavItemClass;
        vm.serviceListEmptyMessage = "این پرسنل هیچ سرویسی ارائه نمی دهد";


        vm.allCompanyServiceList = [];


        loadAll();

        function loadAll() {
            loadAllCompanyServiceList();
        }

        checkCompanyActivityType();
        $scope.$watch('vm.servant', function (servant) {

            if (servant) {
                if (servant.scheduleInfo && !servant.scheduleInfo.baseScheduleMode)
                    servant.scheduleInfo.baseScheduleMode = 'BASED_ON_COMPANY';
                if (servant.id)
                    ServantCustom.serviceItemScheduleByServantId(servant.id).query(function (result) {
                        vm.serviceList = result;
                        checkShowLimitDates();

                    });

            }


        })

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function tabSelector() {
            vm.orderedTabSelected = !vm.orderedTabSelected;
        }

        function save() {

            if (vm.isWorkSpace)
                vm.servant.personInfo.lastName = ' ';

            prepareServiceItemListForSave();
            vm.isSaving = true;
            if (vm.servant.id !== null) {
                Servant.update(vm.servant, onSaveSuccess, onSaveError);
            } else {
                Servant.save(vm.servant, function (result) {

                    $state.go('supplierPanel.companyServants.edit', {id: result.id});

                }, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            ServantCustom.saveScheduleList().update(vm.serviceList, function () {
                $scope.$emit('tikonApp:servantUpdate', result);
                // vm.serviceList=ServantCustom.serviceItemScheduleByServantId(servant.id).query(function(result){
                //     vm.servant=result;
                // });

                vm.isSaving = false;

            })

            if (result.videoCallSettingInfo && result.videoCallSettingInfo.id) {
                vm.servant.videoCallSettingInfo = result.videoCallSettingInfo;
            }

        }

        function setEdited(ssi) {

            ssi.edited = (!ssi.edited);
        }

        function hasNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = true;
        }

        function hasNotNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function updatePrice(serviceItemId, priceInfo, index) {

            ServantCustom.updateServantService(serviceItemId, vm.servant.id).save(priceInfo, function (result) {

                priceInfo = result;
                $scope.$emit('tikonApp:servantUpdate', result);
                vm.isSaving = false;
                vm.editBtnPressed[index] = false;
            })

        }

        function checkCompanyActivityType() {

            if (vm.servant.company) {
                if (vm.servant.company.activityType == "WORK_SPACE")
                    vm.isWorkSpace = true;

            } else {
                CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                    if (result.activityType == "WORK_SPACE")
                        vm.isWorkSpace = true;
                })
            }

            if (vm.isWorkSpace) {
                vm.showAmenities = false;
                vm.showImageGallery = false;
                vm.showTags = false;
                vm.isWorkSpace = true;
                setServantTranslate();
            }
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space');
            }
        }


        $scope.ActiveServiceFilter = function (item) {
            return item.serviceItem.serviceStatus != 'DISABLE';
        };
        $scope.ValidPriceInfoFilter = function (item) {
            return true;
            //   return (item.priceInfoDtails && item.priceInfoDtails.length>0);
        };


        var last = {
            bottom: false,
            top: true,
            left: true,
            right: false
        };

        vm.toastPosition = angular.extend({}, last);

        vm.getToastPosition = function () {
            sanitizePosition();

            return Object.keys(vm.toastPosition)
                .filter(function (pos) {
                    return vm.toastPosition[pos];
                }).join(' ');
        };

        function sanitizePosition() {
            var current = vm.toastPosition;

            if (current.bottom && last.top) {
                current.top = false;
            }
            if (current.top && last.bottom) {
                current.bottom = false;
            }
            if (current.right && last.left) {
                current.left = false;
            }
            if (current.left && last.right) {
                current.right = false;
            }

            last = angular.extend({}, current);
        }

        function showLimitDateChange(showLimitDates, datePeriod) {
            if (!showLimitDates) {
                datePeriod.fromDate = null;
                datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {
            if (vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.endDate
            ) {
                vm.showLimitDates = true;
            }


            angular.forEach(vm.serviceList, function (ssi) {
                if (ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                    ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate
                ) {
                    ssi.showLimitDates = true;
                }
            })

        }

        function setTabActive(tabName) {
            switch (tabName) {
                case 'servantSchedule':
                    vm.showServantSchedule = true;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantCloseTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = true;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantOpenTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = true;
                    break;
            }
        }

        function getNavItemClass(itemName) {
            switch (itemName) {
                case 'servantSchedule':
                    if (vm.showServantSchedule)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantCloseTimes':
                    if (vm.showServantCloseTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantOpenTimes':
                    if (vm.showServantOpenTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
            }
        }

        function loadAllCompanyServiceList() {
            if (!vm.servant || !vm.servant.id)
                return;
            ServiceItemCustom.getServiceItemWithServantsByCurrentCompany().query(function (result) {
                vm.allCompanyServiceList = result;
                ServiceItemCustom.getServiceItemsByServantId(vm.servant.id).query(function (list) {
                    vm.allServantServices = list;
                    makeServantServiceList();
                })

            });
        }

        function makeServantServiceList() {
            angular.forEach(vm.allCompanyServiceList, function (allItem) {
                angular.forEach(vm.allServantServices, function (service) {
                    if (allItem.id == service.id)
                        allItem.checked = true;
                })
                if (allItem.serviceMode && allItem.serviceMode == 'EVENT')
                    allItem.canRemoveCheck = false;
                else {
                    if (allItem.servants && allItem.servants.length > 1) {
                        allItem.canRemoveCheck = true;
                    } else {
                        allItem.canRemoveCheck = false;
                    }
                }
            })
        }

        function prepareServiceItemListForSave() {

            if (vm.allCompanyServiceList) {
                vm.servant.serviceItemList = [];
                angular.forEach(vm.allCompanyServiceList, function (item) {
                    if (item.checked)
                        vm.servant.serviceItemList.push(item);
                })
            }
        }

        function addClosedTimes() {
            addServantExceptionTimes('CLOSE');
        }

        function addOpenTimes() {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html',
                controller: 'ServantExceptionDurationComponentController',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            defaultServantId: vm.servant.id,
                            availabilityMode: mode,
                            canSelectServant: false

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            }).then(function (v) {
                reloadServantExceptionDurations();
            }, function () {
                //nothing
            });


        }

        function reloadServantExceptionDurations() {
            $rootScope.$broadcast('reloadServantExceptionDurationListEvent');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsDeleteController', CompanyServantsDeleteController);

    CompanyServantsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Servant'];

    function CompanyServantsDeleteController($uibModalInstance, entity, servant) {
        var vm = this;

        vm.comapnyServants = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {

            servant.delete({id: vm.comapnyServants.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('supplierPanel.companyServants', {
                parent: 'supplierPanel',
                url: '/company-servants',
                data: {
                    authorities: ['ROLE_SERVANT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servantInfo'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants.html',
                        controller: 'CompanyServantsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyServants.new', {
                parent: 'supplierPanel',
                url: '/companyServants/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants-dialog.html',
                        controller: 'CompanyServantsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel.companyServants.edit', {
                parent: 'supplierPanel',
                url: '/companyServants/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants-dialog.html',
                        controller: 'CompanyServantsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Servant', '$stateParams', function (Servant, $stateParams) {
                        return Servant.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel.companyServants.delete', {
                parent: 'supplierPanel.companyServants',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
                        controller: 'CompanyServantsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServants', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsController', CompanyServantsController);

    CompanyServantsController.$inject = ['$scope', '$state', 'Servant', 'ServantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServantCustom', 'CompanyCustom', '$translate', 'Principal', 'DialogService'];

    function CompanyServantsController($scope, $state, Servant, ServantSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServantCustom, CompanyCustom, $translate, Principal, DialogService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.isWorkSpace = false;
        vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
        vm.newServantClick = newServantClick;
        loadAll();
        loadPage();

        function loadAll() {

            //if (pagingParams.search) {
            //    ServantSearch.query({
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    Servant.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}
            //function sort() {
            //    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            //    if (vm.predicate !== 'id') {
            //        result.push('id');
            //    }
            //    return result;
            //}
            function onSuccess(data, headers) {
                //vm.links = ParseLinks.parse(headers('link'));
                //vm.totalItems = headers('X-Total-Count');
                //vm.queryCount = vm.totalItems;
                vm.servants = data;
                //vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            //vm.page = page;
            //vm.transition();

            //if($ctrl.companyId==undefined || $ctrl.companyId==null)$ctrl.priceInfos=[];
            //else
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                if (result.activityType == "WORK_SPACE") {
                    vm.isWorkSpace = true;
                    setServantTranslate();
                }
            });
            vm.servants = ServantCustom.findServantsByCompany().query();


            //


        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space');
            }
        }

        function newServantClick() {
            var result;
            if (vm.servants) {
                result = Principal.canAddNewServant(vm.servants.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }

            $state.transitionTo('supplierPanel.companyServants.new');

        }

        function loadAccessToAddNew() {
            var _company = Principal.getCurrentCompany();
            if (_company && _company.id) {
                PackageFeatureListCustom.getPackageFeatureListByCompanyId(_company.id).query().$promise.then(function (result) {
                    Principal.setCurrentCompanyFeatureList(result);
                });
            }
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyRuleDialogController', CompanyRuleDialogController);

    CompanyRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyRule', 'Customer', 'ServiceItem', 'CompanyCustom', '$translate', '$translatePartialLoader'];

    function CompanyRuleDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyRule, Customer, ServiceItem, CompanyCustom, translate, translatePartialLoader) {
        var vm = this;

        vm.companyRule = entity;
        vm.clear = clear;
        vm.save = save;
        vm.findCompany = findCompany;


        vm.customField1Translate = "customField1";
        vm.customField2Translate = "customField2";
        vm.customField3Translate = "customField3";

        loadPage();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function loadPage() {
            translatePartialLoader.addPart('activityType');

            initValue();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyRule.id !== null) {
                CompanyRule.update(vm.companyRule, onSaveSuccess, onSaveError);
            } else {
                CompanyRule.save(vm.companyRule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findCompany() {

            if (vm.companyKeyUrl) {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.companyRule.company = result;
                    }
                })
            }

        }

        function initValue() {
            if (vm.companyRule && vm.companyRule.ruleType) {
                switch (vm.companyRule.ruleType) {
                    case "SSAA_MALEKIAT_API" :
                    case "CLIENT_RESERVE_TIME_LIMIT" :
                    case "SSAA_NOTARY_PERSONNEL" :
                    case "SSAA_INQUIRY_PERSONNEL" :
                    case "SSAA_ORDINARY_PEOPLE" :
                        vm.customField1Translate = "customField1";
                        vm.customField2Translate = "customField2";
                        vm.customField3Translate = "customField3";
                        break;
                    case "SSAA_EJRA":

                        vm.customField1Translate = "UserName";
                        vm.customField2Translate = "Password";
                        vm.customField3Translate = "UnitId";
                        break;

                }
            }
        }

    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CustomerRankDeleteController',CustomerRankDeleteController);
//
//    CustomerRankDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerRank'];
//
//    function CustomerRankDeleteController($uibModalInstance, entity, CustomerRank) {
//        var vm = this;
//
//        vm.customerRank = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            CustomerRank.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('companyRule', {
                parent: 'entity',
                url: '/CompanyRule?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyRule.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-rule/company-rules.html',
                        controller: 'CompanyRuleController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyRule');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companyRuleType');
                        return $translate.refresh();
                    }]
                }
            })

            .state('companyRule_new', {
                parent: 'companyRule',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-rule/company-rule-dialog.html',
                        controller: 'CompanyRuleDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('companyRule', null, {reload: true});
                    }, function () {
                        $state.go('companyRule');
                    });
                }]
            })
            .state('companyRule.edit', {
                parent: 'companyRule',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-rule/company-rule-dialog.html',
                        controller: 'CompanyRuleDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanyRule', function (CompanyRule) {
                                return CompanyRule.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('companyRule', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('companyRule.delete', {
                parent: 'companyRule',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-rule/company-rule-delete-dialog.html',
                        controller: 'CompanyRuleDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyRule', function (CompanyRule) {
                                return CompanyRule.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('companyRule', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyRule', CompanyRule);

    CompanyRule.$inject = ['$resource'];

    function CompanyRule($resource) {
        var resourceUrl = 'api/company-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyRuleSearch', CompanyRuleSearch);

    CompanyRuleSearch.$inject = ['$resource'];

    function CompanyRuleSearch($resource) {
        var resourceUrl = 'api/_search/company-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyRuleController', CompanyRuleController);

    CompanyRuleController.$inject = ['$scope', '$state', 'CompanyRule', 'CompanyRuleSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyRuleController($scope, $state, CompanyRule, CompanyRuleSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CompanyRuleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyRule.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyRules = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DeterminStatusPaymentController', DeterminStatusPaymentController);

    DeterminStatusPaymentController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentLog', 'InvoiceInfo', 'PaymentLogCustom', 'CompanyPaymentLogCustom'];

    function DeterminStatusPaymentController($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentLog, InvoiceInfo, PaymentLogCustom, CompanyPaymentLogCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.paymentLog = entity.paymentLog;
        vm.clear = clear;
        vm.save = save;
        vm.status = entity.paymentLog.managerApprovalStatus || "NONE";
        vm.statusList = ["CHECKING", "APPROVED", "DENIED"];
        vm.managerApprovalComment = entity.paymentLog.managerApprovalComment;
        vm.price = vm.paymentLog.amount;
        vm.fullName = vm.paymentLog.customer.fisrtName + ' '+ vm.paymentLog.customer.lastName;
        //vm.invoiceinfos =
        vm.closeModal = closeModal;
        vm.okModal = okModal;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if(vm.status !== "NONE") {
                vm.isSaving = true;
                var data = JSON.stringify({
                    managerApprovalStatus: vm.status,
                    comment: vm.managerApprovalComment
                })
                CompanyPaymentLogCustom.updateCompanyPayment(vm.paymentLog.id).update(data).$promise.then(onSaveSuccess, onSaveError)
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function closeModal() {
            clear();

        }

        function okModal() {
            save();
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogListV2Controller', CompanyPaymentLogListV2Controller);

    CompanyPaymentLogListV2Controller.$inject = ['$scope', '$state', 'CompanyPaymentLog', 'ParseLinks', 'AlertService', '$mdDialog', 'CompanyPaymentLogCustom', 'AccountClearingRequestCustom', 'QueryParamsService', 'InvoiceInfoCustom', 'Principal', '$uibModal'];

    function CompanyPaymentLogListV2Controller($scope, $state, CompanyPaymentLog, ParseLinks, AlertService, $mdDialog, CompanyPaymentLogCustom, AccountClearingRequestCustom, QueryParamsService, InvoiceInfoCustom, Principal, $uibModal) {
        var vm = this;
        vm.sumPaymentAmount = 0;
        vm.sumWage = 0;
        vm.sumRemaindAmount = 0;
        vm.accountClearRequest = accountClearRequest;
        vm.activeClearRequest = {};
        vm.canSendRequest = false;
        vm.pageSizeChanged = pageSizeChanged;
        vm.transition = transition;
        vm.pageSizeList = [10, 20, 50];
        vm.size = 10;
        vm.page = 1;
        vm.newAccountClearingRequestLoading = false;

        loadAll();

        function loadAll() {


            vm.companyPaymentLogs = CompanyPaymentLogCustom.getActiveCompanyPaymentLogs().query(function (result) {
                calculateSum();
            });


            AccountClearingRequestCustom.getActiveCompanyAccountClearingRequest().query().$promise.then(function (result) {


                    vm.activeClearRequest = result;
                }
            );

        }


        function calculateSum() {
            sumPaymentAmount();
            sumWage();
            vm.sumPaymentAmount = Math.round(vm.sumPaymentAmount);
//            vm.sumWage = Math.round(vm.sumWage);
            vm.sumRemaindAmount = vm.sumPaymentAmount ;
            if (vm.sumRemaindAmount >= 200000)
                vm.canSendRequest = true;
            else
                vm.canSendRequest = false;
        }

        function sumPaymentAmount() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumPaymentAmount += p.paymentAmount;
            });

        }

        function sumWage() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumWage += p.wageFeeAmount;
            });

        }

        function accountClearRequest() {
            vm.newAccountClearingRequestLoading = true;
            AccountClearingRequestCustom.createNewAccountClearingRequest().save(function (result) {
                    $scope.$emit('tikonApp:accountClearingRequestUpdate', result);
                    loadAll();
                    vm.newAccountClearingRequestLoading = false;
                },
                function(error) {
                    console.log(error);
                    vm.newAccountClearingRequestLoading = false;
                }
            );

        }




        function pageSizeChanged() {
            QueryParamsService.updateFilter('size', vm.size)
            clear();
        }


         function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getPaymentLogsPagesByQuery(vm.filterQuery);
            else
                getPaymentLogsPagesByQuery();

        }

        //function transition () {
        //    $state.transitionTo($state.$current, {
        //        page: vm.page,
        //        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //        search: vm.currentSearch
        //    });
        //}
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogListController', CompanyPaymentLogListController);

    CompanyPaymentLogListController.$inject = ['$scope', '$state', 'CompanyPaymentLog', 'ParseLinks', 'AlertService', 'CompanyPaymentLogCustom', 'AccountClearingRequestCustom'];

    function CompanyPaymentLogListController($scope, $state, CompanyPaymentLog, ParseLinks, AlertService, CompanyPaymentLogCustom, AccountClearingRequestCustom) {
        var vm = this;
        vm.sumPaymentAmount = 0;
        vm.sumWage = 0;
        vm.sumRemaindAmount = 0;
        vm.accountClearRequest = accountClearRequest;
        vm.activeClearRequest = {};
        loadAll();

        function loadAll() {


            vm.companyPaymentLogs = CompanyPaymentLogCustom.getActiveCompanyPaymentLogs().query(function (result) {
                calculateSum();
            });


            AccountClearingRequestCustom.getActiveCompanyAccountClearingRequest().query().$promise.then(function (result) {


                    vm.activeClearRequest = result;
                }
            );

        }


        function calculateSum() {
            sumPaymentAmount();
            sumWage();
            vm.sumPaymentAmount = Math.round(vm.sumPaymentAmount);
            vm.sumWage = Math.round(vm.sumWage);
            vm.sumRemaindAmount = vm.sumPaymentAmount - vm.sumWage;
        }

        function sumPaymentAmount() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumPaymentAmount += p.paymentAmount;
            });

        }

        function sumWage() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumWage += p.wageFeeAmount;
            });

        }

        function accountClearRequest() {
            AccountClearingRequestCustom.createNewAccountClearingRequest().save(function (result) {
                    $scope.$emit('tikonApp:accountClearingRequestUpdate', result);
                    loadAll();
                }
            );


        }


        //function transition () {
        //    $state.transitionTo($state.$current, {
        //        page: vm.page,
        //        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //        search: vm.currentSearch
        //    });
        //}
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogDialogController', CompanyPaymentLogDialogController);

    CompanyPaymentLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyPaymentLog', 'AccountClearingRequest', 'Company'];

    function CompanyPaymentLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyPaymentLog, AccountClearingRequest, Company) {
        var vm = this;

        vm.companyPaymentLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.accountclearingrequests = AccountClearingRequest.query();
        vm.companies = Company.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyPaymentLog.id !== null) {
                CompanyPaymentLog.update(vm.companyPaymentLog, onSaveSuccess, onSaveError);
            } else {
                CompanyPaymentLog.save(vm.companyPaymentLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyPaymentLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogDetailController', CompanyPaymentLogDetailController);

    CompanyPaymentLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyPaymentLog', 'AccountClearingRequest', 'Company'];

    function CompanyPaymentLogDetailController($scope, $rootScope, $stateParams, entity, CompanyPaymentLog, AccountClearingRequest, Company) {
        var vm = this;

        vm.companyPaymentLog = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companyPaymentLogUpdate', function (event, result) {
            vm.companyPaymentLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogDeleteController', CompanyPaymentLogDeleteController);

    CompanyPaymentLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyPaymentLog'];

    function CompanyPaymentLogDeleteController($uibModalInstance, entity, CompanyPaymentLog) {
        var vm = this;

        vm.companyPaymentLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanyPaymentLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyPaymentLogCustom', CompanyPaymentLogCustom);

    CompanyPaymentLogCustom.$inject = ['$resource'];

    function CompanyPaymentLogCustom($resource) {


        var getActiveCompanyPaymentLogs = function () {
            var resourceUrl = 'api/get-active-company-payment-logs';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyPaymentLogs = function () {
            var resourceUrl = 'api/get-company-payment-logs';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getCompanyPaymentLogsByAccountClearingRequestId = function (accountClearingRequestId) {
            var resourceUrl = 'api/get-company-payment-logs-by-account-clearing-request-id?accountClearingRequestId=' + accountClearingRequestId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyPaymentLogList = function() {
            var resourceUrl = 'api/_search/payment-logs';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET'}
                }
            );
        }

        var updateCompanyPayment = function(id) {
            var resourceUrl = "api/payment-logs/"+ id +"/approval"
            return $resource(resourceUrl, {}, {
                    'update': { method: 'PUT' }
                })
        }


        return {
            getActiveCompanyPaymentLogs: getActiveCompanyPaymentLogs,
            getCompanyPaymentLogs: getCompanyPaymentLogs,
            getCompanyPaymentLogsByAccountClearingRequestId: getCompanyPaymentLogsByAccountClearingRequestId,
            getCompanyPaymentLogList: getCompanyPaymentLogList,
            updateCompanyPayment: updateCompanyPayment

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-payment-log', {
                parent: 'entity',
                url: '/company-payment-log?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-logs.html',
                        controller: 'CompanyPaymentLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-payment-log-detail', {
                parent: 'entity',
                url: '/company-payment-log/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-detail.html',
                        controller: 'CompanyPaymentLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyPaymentLog', function ($stateParams, CompanyPaymentLog) {
                        return CompanyPaymentLog.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-payment-log.new', {
                parent: 'company-payment-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-dialog.html',
                        controller: 'CompanyPaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    paymentAmount: null,
                                    wageFeeAmount: null,
                                    status: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-payment-log', null, {reload: true});
                    }, function () {
                        $state.go('company-payment-log');
                    });
                }]
            })
            .state('company-payment-log.edit', {
                parent: 'company-payment-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-dialog.html',
                        controller: 'CompanyPaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanyPaymentLog', function (CompanyPaymentLog) {
                                return CompanyPaymentLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-payment-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-payment-log.delete', {
                parent: 'company-payment-log',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-delete-dialog.html',
                        controller: 'CompanyPaymentLogDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyPaymentLog', function (CompanyPaymentLog) {
                                return CompanyPaymentLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-payment-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyPaymentLog', CompanyPaymentLog);

    CompanyPaymentLog.$inject = ['$resource', 'DateUtils'];

    function CompanyPaymentLog($resource, DateUtils) {
        var resourceUrl = 'api/company-payment-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyPaymentLogSearch', CompanyPaymentLogSearch);

    CompanyPaymentLogSearch.$inject = ['$resource'];

    function CompanyPaymentLogSearch($resource) {
        var resourceUrl = 'api/_search/company-payment-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogController', CompanyPaymentLogController);

    CompanyPaymentLogController.$inject = ['$scope', '$state', 'CompanyPaymentLog', 'CompanyPaymentLogSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyPaymentLogController($scope, $state, CompanyPaymentLog, CompanyPaymentLogSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CompanyPaymentLogSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyPaymentLog.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyPaymentLogs = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller(
      "CompanyApprovalPaymentLogListV2",
      CompanyApprovalPaymentLogListV2
    );

  CompanyApprovalPaymentLogListV2.$inject = ["$timeout", "$state"];

  function CompanyApprovalPaymentLogListV2($timeout, $state) {
    function loadCompanyApprocalPaymentLogs() {
      var approvalPaymentLogsEl = document.getElementById("payment-logs");
      approvalPaymentLogsEl.addEventListener("prevPageBtn", function () {
        $state.go("supplierPanel-v2.companyPaymentLogList");
      });
      approvalPaymentLogsEl.addEventListener("backToPrevVersion", function () {
        $state.go("supplierPanel-v2.companyApprovalPaymentLogList", {
          type: "services",
        });
      });
      approvalPaymentLogsEl.addEventListener("trigger-edit-order-bag",function (e) {
          var orderBagId = e.detail[0];
          $state.go("supplierPanel-v2.editOrderBag", { id: orderBagId });
        }
      );
      approvalPaymentLogsEl.addEventListener("trigger-edit-invoice", function (e) {
        var invoiceId = e.detail[0];
        $state.go("supplierPanel-v2.invoiceInfoDetail", { id: invoiceId });
      });
    }
    $timeout(loadCompanyApprocalPaymentLogs, 100);
  }
})();
;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("CompanyApprovalPaymentLogList", CompanyApprovalPaymentLogList);

  CompanyApprovalPaymentLogList.$inject = [
    "$scope",
    "$state",
    "CompanyPaymentLog",
    "ParseLinks",
    "AlertService",
    "CompanyPaymentLogCustom",
    "QueryParamsService",
    "$mdDialog",
    "$uibModal"
  ];

  function CompanyApprovalPaymentLogList(
    $scope,
    $state,
    CompanyPaymentLog,
    ParseLinks,
    AlertService,
    CompanyPaymentLogCustom,
    QueryParamsService,
    $mdDialog,
    $uibModal
  ) {

    var vm = this;

    vm.filterQuery = {};
    vm.isSearching = false;
    vm.searchKeyPress = searchKeyPress;
    vm.clearSearch = clearSearch;
    vm.pageSizeChanged = pageSizeChanged;
    vm.transition = transition;
    vm.pageSizeList = [10, 20, 50];
    vm.size = 10;
    vm.page = 1;


    loadAll();

    function loadAll() {
      filterCompanyPaymentLogsInfo();
    }

    function filterCompanyPaymentLogsInfo(customFilter) {
      if (vm.isSearching) return;
      getQueryParams();
      getPaymentLogsPagesByQuery(customFilter);
    }
    function getQueryParams() {
      var newFilters = QueryParamsService.getFilters();
      // if(newFilters.page){
      //     vm.filterQuery.page = newFilters.page;
      //     vm.page = parseInt(newFilters.page);
      // }

      if (newFilters.page) {
        vm.filterQuery.page = parseInt(newFilters.page, 10) - 1;
        vm.page = parseInt(newFilters.page, 10);
      }

      if (newFilters.size) {
        vm.filterQuery.size = newFilters.size;
        vm.size = newFilters.size;
      }
      if (newFilters.query) {
        vm.filterQuery.query = newFilters.query;
      }
      if (newFilters["from-date"]) {
        vm.filterQuery["from-date"] = newFilters["from-date"];
      }
      if (newFilters["to-date"]) {
        vm.filterQuery["to-date"] = newFilters["to-date"];
      }
      if (newFilters["payment-type"]) {
        vm.filterQuery["payment-type"] = newFilters["payment-type"];
      }
      if (newFilters["approval-status"]) {
        vm.filterQuery["approval-status"] = newFilters["approval-status"];
      }
      if (newFilters["order-bag-id"]) {
        vm.filterQuery["order-bag-id"] = newFilters["order-bag-id"];
      }
      if (newFilters["invoice-id"]) {
        vm.filterQuery["invoice-id"] = newFilters["invoice-id"];
      }
      if (newFilters.filterQuery) {
        var newF = angular.extend(JSON.parse(decodeURIComponent(newFilters.filterQuery)), vm.filterQuery);
        // if (newF["order-bag-id"]) newF.orderBagId = newF["order-bag-id"];
        // if (newF["invoice-id"]) newF.invoiceId = newF["invoice-id"];
        setFilterQuery(newF);
      }
    }
    function getPaymentLogsPagesByQuery(customFilter) {
      if (vm.isSearching) return;

      vm.isSearching = true;
      var filterQ = vm.filterQuery;
      if (customFilter) filterQ = customFilter;

      if (vm.page) filterQ.page = vm.page - 1;
      else filterQ.page = 0;

      filterQ.size = vm.size;
      CompanyPaymentLogCustom.getCompanyPaymentLogList().query(filterQ).$promise.then(onSuccess, onError);

      // InvoiceInfoCustom.searchInvoiceInfoByQueryPage().save(filterQ, onSuccess, onError);

      function onSuccess(data) {
        // vm.links = ParseLinks.parse(headers('link'));
        vm.totalItems = data.totalElements;
        vm.queryCount = data.totalElements;
        vm.paymentLogList = data.content;
        vm.isSearching = false;
        gotToTop();
        // vm.page = vm.filterQuery.page+1;
      }

      function onError(error) {
        vm.isSearching = false;
        AlertService.error(error.data.message);
      }
    }
    function gotToTop() {
      // window.scroll(0, 0);
      if (vm.page > 1) {
        document.getElementsByClassName("topOfList")[0].scrollIntoView();
        document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
      }
    }
    function filterPaymentLogInfo_Global() {
      vm.filterQuery.searchMode = true;
      filterCompanyPaymentLogsInfo();
      clear();
    }
    function transition() {
      // $state.transitionTo($state.$current, {
      //     page: vm.page,
      //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
      //     search: vm.currentSearch
      // });
      if (vm.filterQuery.searchMode) getPaymentLogsPagesByQuery(vm.filterQuery);
      else getPaymentLogsPagesByQuery();
    }
    vm.findStatusStyle = function (status) {
      return "company-payment-log-status-" + status;
    };
    vm.findStatusIcon = function(status) {
            if (status == "DENIED") {
                return "glyphicon glyphicon-remove-sign";
            }
            if (status == "APPROVED") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "CHECKING") {
                return "glyphicon glyphicon-eye-open";
            }

        }
    vm.determinStatus = function (paymentLog) {
      $uibModal.open({
          templateUrl:"app/entities/company-payment-log/determin-status-dialog.html",
          controller: "DeterminStatusPaymentController",
          controllerAs: "vm",
          backdrop: "static",
          size: "lg",
          windowClass: "pl-modal",
          resolve: {
            entity: function() {
              return {
                paymentLog: paymentLog,
              }
            },
          },
        }).result.then(function (v) {
          loadAll()
         },
          function () {
            
          });
    };
    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = "id";
      vm.reverse = true;
      vm.currentSearch = null;
      vm.filterQuery.page = 0;
      vm.transition();
    }
    function pageSizeChanged() {
      QueryParamsService.updateFilter("size", vm.size);
      clearSearch();
    }
    function countFilters() {
      vm.filterCount = 0;

      if (vm.filterQuery["from-date"]) vm.filterCount++;
      if (vm.filterQuery["to-date"]) vm.filterCount++;
      if (vm.filterQuery["order-bag-id"]) vm.filterCount++;
      if (vm.filterQuery["approval-status"] && vm.filterQuery["approval-status"].length > 0) vm.filterCount++;
      if (vm.filterQuery["invoice-id"]) vm.filterCount++;
      if (vm.filterQuery["payment-type"] && vm.filterQuery["payment-type"].length > 0)
        vm.filterCount++;
      if (vm.filterCount < 1) QueryParamsService.removeFilter("filterQuery");
    }
    //Filter Dialog
    var ShowFilterDialogController = function ($scope,$mdDialog,dialogData,$mdSelect) {
      var $ctrl = this;
      $ctrl.data = dialogData;
      $ctrl.okModal = okModal;
      $ctrl.closeModal = closeModal;
      $ctrl.clearFilter = clearFilter;

      //for closing the select box
      document.body.onclick = function (e) {
        $mdSelect.hide();
      };

      function okModal() {
        $mdDialog.hide($ctrl.data);
      }

      function closeModal() {
        $mdDialog.cancel();
      }

      function clearFilter() {
        $ctrl.data.filterQuery = {};
      }
    };
    ShowFilterDialogController.$inject = ["$scope","$mdDialog","dialogData","$mdSelect"];
    vm.showFilterDialog = function () {
      var dialogData_ = {};
      dialogData_.statusList = ["CHECKING", "APPROVED", "DENIED"];
      dialogData_.filterQuery = vm.filterQuery;

      $mdDialog.show({
          locals: { dialogData: dialogData_ },
          controller: ShowFilterDialogController,
          templateUrl:"app/entities/company-payment-log/filter-payment-log-list-dialog.html",
          controllerAs: "$ctrl",
          parent: angular.element(document.body),
          targetEvent: dialogData_,
          clickOutsideToClose: true,
          size: "lg",
          fullscreen: false,
        })
        .then(function (data) {
            vm.filterQuery = {};
            setFilterQuery(data.filterQuery, true);
            QueryParamsService.updateFilter("filterQuery", encodeURIComponent(JSON.stringify(data.filterQuery)));
            vm.advancedSearch();
          })
    };
    function clearSearch() {
      QueryParamsService.removeFilter("query");
      vm.filterQuery.query = null;
      filterPaymentLogInfo_Global();
    }
    vm.advancedSearch = function () {
      QueryParamsService.updateFilter("query", vm.filterQuery.query);
      clear();
      vm.filterQuery.searchMode = true;
      filterCompanyPaymentLogsInfo();
    };
    function searchKeyPress(keyEvent) {
      if (keyEvent.which === 13) {
        vm.advancedSearch();
      }
    }

    function setFilterQuery(filter, ignorQuery) {
      var shallowFilter = filter;
      if (ignorQuery && shallowFilter.query) delete shallowFilter.query;
      angular.extend(vm.filterQuery, filter);
      countFilters();
    }
  }
})();


;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyAllPaymentLogListController', CompanyAllPaymentLogListController);

    CompanyAllPaymentLogListController.$inject = ['$scope', '$state', 'CompanyPaymentLog', 'ParseLinks', 'AlertService', 'CompanyPaymentLogCustom', 'AccountClearingRequestCustom'];

    function CompanyAllPaymentLogListController($scope, $state, CompanyPaymentLog, ParseLinks, AlertService, CompanyPaymentLogCustom, AccountClearingRequestCustom) {
        var vm = this;
        vm.sumPaymentAmount = 0;
        vm.sumWage = 0;
        vm.sumRemaindAmount = 0;
        vm.accountClearRequest = accountClearRequest;
        vm.activeClearRequest = {};
        loadAll();

        function loadAll() {


            vm.companyPaymentLogs = CompanyPaymentLogCustom.getCompanyPaymentLogs().query(function (result) {
                calculateSum();
            });
        }


        function calculateSum() {
            sumPaymentAmount();
            sumWage();
            vm.sumPaymentAmount = Math.round(vm.sumPaymentAmount);
            vm.sumWage = Math.round(vm.sumWage);
            vm.sumRemaindAmount = vm.sumPaymentAmount - vm.sumWage;
        }

        function sumPaymentAmount() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumPaymentAmount += p.paymentAmount;
            });

        }

        function sumWage() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumWage += p.wageFeeAmount;
            });

        }

        function accountClearRequest() {
            AccountClearingRequestCustom.createNewAccountClearingRequest().save(function (result) {
                    loadAll();
                }
            );


        }


        //function transition () {
        //    $state.transitionTo($state.$current, {
        //        page: vm.page,
        //        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //        search: vm.currentSearch
        //    });
        //}
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyManagerDialogController', CompanyManagerDialogController);

    CompanyManagerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyManager', 'Company', 'PersonInfo', 'CompanyCustom', 'PersonInfoQuery'];

    function CompanyManagerDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyManager, Company, PersonInfo, CompanyCustom, PersonInfoQuery) {
        var vm = this;

        vm.companyManager = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.personinfos = PersonInfo.query();
        vm.findCompany = findCompany;
        vm.findPersonInfo = findPersonInfo;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyManager.id !== null) {
                CompanyManager.update(vm.companyManager, onSaveSuccess, onSaveError);
            } else {
                CompanyManager.save(vm.companyManager, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyManagerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findCompany() {

            if (vm.companyManager.companyName != null && vm.companyManager.companyName != undefined) {
                var c = CompanyCustom.findCompanyByQuery(vm.companyManager.companyName).query();
                if (c != null && c != undefined) {
                    vm.companyManager.company = c;
                    vm.companyManager.companyId = vm.companyManager.company.id;
                }
            }

        }

        function findPersonInfo() {
            if (vm.companyManager.personInfoName != null && vm.companyManager.personInfoName != undefined) {
                var c = PersonInfoQuery.findPersonInfoByQuery(vm.companyManager.personInfoName).query();
                if (c != null && c != undefined) {
                    vm.companyManager.personInfo = c;
                    vm.companyManager.companyId = vm.companyManager.personInfo.id;
                }
            }

        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyManagerDetailController', CompanyManagerDetailController);

    CompanyManagerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyManager', 'Company', 'PersonInfo'];

    function CompanyManagerDetailController($scope, $rootScope, $stateParams, entity, CompanyManager, Company, PersonInfo) {
        var vm = this;

        vm.companyManager = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companyManagerUpdate', function (event, result) {
            vm.companyManager = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyManagerDeleteController', CompanyManagerDeleteController);

    CompanyManagerDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyManager'];

    function CompanyManagerDeleteController($uibModalInstance, entity, CompanyManager) {
        var vm = this;

        vm.companyManager = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanyManager.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-manager', {
                parent: 'entity',
                url: '/company-manager?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyManager.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-manager/company-managers.html',
                        controller: 'CompanyManagerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyManager');
                        $translatePartialLoader.addPart('managerType');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('company-manager-detail', {
                parent: 'entity',
                url: '/company-manager/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyManager.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-manager/company-manager-detail.html',
                        controller: 'CompanyManagerDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyManager');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyManager', function ($stateParams, CompanyManager) {
                        return CompanyManager.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-manager.new', {
                parent: 'company-manager',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-manager/company-manager-dialog.html',
                        controller: 'CompanyManagerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    managerType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-manager', null, {reload: true});
                    }, function () {
                        $state.go('company-manager');
                    });
                }]
            })
            .state('company-manager.edit', {
                parent: 'company-manager',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-manager/company-manager-dialog.html',
                        controller: 'CompanyManagerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanyManager', function (CompanyManager) {
                                return CompanyManager.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-manager', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-manager.delete', {
                parent: 'company-manager',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-manager/company-manager-delete-dialog.html',
                        controller: 'CompanyManagerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyManager', function (CompanyManager) {
                                return CompanyManager.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-manager', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyManager', CompanyManager);

    CompanyManager.$inject = ['$resource'];

    function CompanyManager($resource) {
        var resourceUrl = 'api/company-managers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyManagerSearch', CompanyManagerSearch);

    CompanyManagerSearch.$inject = ['$resource'];

    function CompanyManagerSearch($resource) {
        var resourceUrl = 'api/_search/company-managers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyManagerController', CompanyManagerController);

    CompanyManagerController.$inject = ['$scope', '$state', 'CompanyManager', 'CompanyManagerSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyManagerController($scope, $state, CompanyManager, CompanyManagerSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CompanyManagerSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyManager.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyManagers = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInvoiceInfoDialogController', CompanyInvoiceInfoDialogController);

    CompanyInvoiceInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyInvoiceInfo', 'Company', 'PersonInfo', 'CompanyCustom', 'PersonInfoQuery'];

    function CompanyInvoiceInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyInvoiceInfo, Company, PersonInfo, CompanyCustom, PersonInfoQuery) {
        var vm = this;

        vm.companyInvoiceInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.findCompany = findCompany;
        vm.newItem = newItem;
        vm.onFieldChanged = onFieldChanged;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyInvoiceInfo.id !== null) {
                CompanyInvoiceInfo.update(vm.companyInvoiceInfo, onSaveSuccess, onSaveError);
            } else {
                CompanyInvoiceInfo.save(vm.companyInvoiceInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:CompanyInvoiceInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findCompany() {

            if (vm.companyKeyUrl != null && vm.companyKeyUrl != undefined) {
                var c = CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query(function (c) {
                    if (c != null && c != undefined) {
                        vm.companyInvoiceInfo.company = c;
                        vm.companyInvoiceInfo.companyId = vm.companyInvoiceInfo.company.id;
                    }
                });

            }

        }

        function newItem() {
            var newItem = {};
            newItem.title = 'عنوان';
            newItem.price = 0;
            newItem.qty = 1;


            if (!vm.companyInvoiceInfo.companyInvoiceInfoItems)
                vm.companyInvoiceInfo.companyInvoiceInfoItems = [];

            vm.companyInvoiceInfo.companyInvoiceInfoItems.push(newItem);
        }


        function onFieldChanged() {
            computeFinalPrice();
        }

        function computeFinalPrice() {

            if (vm.companyInvoiceInfo.discount == undefined)
                vm.companyInvoiceInfo.discount = 0;

            vm.companyInvoiceInfo.subscriptionPrice = 0;
            // vm.companyInvoiceInfo.discount = 0;
            vm.companyInvoiceInfo.finalPrice = 0;

            if (!vm.companyInvoiceInfo.companyInvoiceInfoItems)
                return;

            angular.forEach(vm.companyInvoiceInfo.companyInvoiceInfoItems, function (item) {
                vm.companyInvoiceInfo.subscriptionPrice += item.price * item.qty;
            })

            vm.companyInvoiceInfo.finalPrice = vm.companyInvoiceInfo.subscriptionPrice - vm.companyInvoiceInfo.discount;

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-invoice-info', {
                parent: 'entity',
                url: '/company-invoice-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyInvoiceInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-infos.html',
                        controller: 'CompanyInvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyInvoiceInfo');
                        $translatePartialLoader.addPart('companyInvoiceInfoItem');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('company-invoice-info.new', {
                parent: 'company-invoice-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-info-dialog.html',
                        controller: 'CompanyInvoiceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    managerType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('company-invoice-info');
                    });
                }]
            })
            .state('company-invoice-info.edit', {
                parent: 'company-invoice-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-info-dialog.html',
                        controller: 'CompanyInvoiceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanyInvoiceInfo', function (CompanyInvoiceInfo) {
                                return CompanyInvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-invoice-info.delete', {
                parent: 'company-invoice-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-info-delete-dialog.html',
                        controller: 'CompanyInvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyInvoiceInfo', function (CompanyInvoiceInfo) {
                                return CompanyInvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyInvoiceInfo', CompanyInvoiceInfo);

    CompanyInvoiceInfo.$inject = ['$resource'];

    function CompanyInvoiceInfo($resource) {
        var resourceUrl = 'api/company-invoice-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyInvoiceInfoSearch', CompanyInvoiceInfoSearch);

    CompanyInvoiceInfoSearch.$inject = ['$resource'];

    function CompanyInvoiceInfoSearch($resource) {
        var resourceUrl = 'api/_search/company-invoice-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInvoiceInfoController', CompanyInvoiceInfoController);

    CompanyInvoiceInfoController.$inject = ['$scope', '$state', 'CompanyInvoiceInfo', 'CompanyInvoiceInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyInvoiceInfoController($scope, $state, CompanyInvoiceInfo, CompanyInvoiceInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CompanyInvoiceInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyInvoiceInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyInvoiceInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerSlideController', CompanyCustomerSlideController);

    CompanyCustomerSlideController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout', '$mdSidenav'];

    function CompanyCustomerSlideController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout, $mdSidenav) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        vm.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;

        vm.closeSlide = closeSlide;
        vm.okSlide = okSlide;
        vm.gotoNewReserve = gotoNewReserve;

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $mdSidenav('customerSide').toggle();
        }

        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {

            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                vm.customerFormData = res;
                vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                vm.customerFormData.companyCustomer = vm.companyCustomer;
                openEditDataDialog(vm.customerFormData);

            });
        }

        // function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {
        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            vm.customerFormData = data;
            vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            vm.customerFormData.companyCustomer = vm.companyCustomer;
            openEditDataDialog(vm.customerFormData);
        }

        // function openEditDataDialog(customerFormData) {
        //     vm.columnCount = 4 ;
        //     $mdDialog.show({
        //         locals: {dialogData: customerFormData , columnCount: vm.columnCount},
        //         controller: ComponentIntakeDataDialogController,
        //         templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
        //         controllerAs: '$ctrl',
        //         parent: angular.element(document.body),
        //         targetEvent: customerFormData,
        //         clickOutsideToClose: true
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // };

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:companyCustomerUpdate', result);

                // $state.go('company-customer.edit', {id: result.id});

                loadAll();
            }

        }

        function okSlide() {
            save();

        }

        function closeSlide() {
            // if($rootScope.SlideInstance)
            // {
            //     $rootScope.SlideInstance.dismiss('cancel');
            // }

        }

        function gotoNewReserve() {

            $state.go('supplierPanel-v2.reserveWithCustomerParameter', {
                customerId: vm.companyCustomer.customerId
            });

        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerPopUpController', CompanyCustomerPopUpController);

    CompanyCustomerPopUpController.$inject = ['$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$uibModalInstance', '$stateParams'];

    function CompanyCustomerPopUpController($scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $uibModalInstance, $stateParams) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;
        vm.cancel = cancel;
        vm.mode = 'NEW';
        vm.isPopUp = true;

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');

            if ($scope.$resolve && $scope.$resolve.formData) {
                if ($scope.$resolve.formData.mode)
                    vm.mode = $scope.$resolve.formData.mode;
                if ($scope.$resolve.formData.isPopUp != null)
                    vm.isPopUp = $scope.$resolve.formData.isPopUp;
            }


        }

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                // $scope.$emit('tikonApp:companyCustomerUpdate', result);
                $uibModalInstance.close(result);
                // $state.go('company-customer.edit', {id: result.id});

                // loadAll();


            }

        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerModalController', CompanyCustomerModalController);

    CompanyCustomerModalController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout'];

    function CompanyCustomerModalController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        vm.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.gotoNewReserve = gotoNewReserve;
        vm.getModalTitle = getModalTitle;
        vm.callCustomer = callCustomer;


        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);

        }

        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {

            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                vm.customerFormData = res;
                vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                vm.customerFormData.companyCustomer = vm.companyCustomer;
                openEditDataDialog(vm.customerFormData);

            });
        }

        // function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {
        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            vm.customerFormData = data;
            vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            vm.customerFormData.companyCustomer = vm.companyCustomer;
            openEditDataDialog(vm.customerFormData);
        }

        // function openEditDataDialog(customerFormData) {
        //     vm.columnCount = 4 ;
        //     $mdDialog.show({
        //         locals: {dialogData: customerFormData , columnCount: vm.columnCount},
        //         controller: ComponentIntakeDataDialogController,
        //         templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
        //         controllerAs: '$ctrl',
        //         parent: angular.element(document.body),
        //         targetEvent: customerFormData,
        //         clickOutsideToClose: true
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // };

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:companyCustomerUpdate', result);
                vm.isSaving = false;

                if ($state.current.name
                    && ($state.current.name == 'supplierPanel-v2.newReserve'
                        || $state.current.name == 'supplierPanel-v2.new-reserve-modal'
                        || $state.current.name == 'supplierPanel-v2.dashboard.newReserve'
                        || $state.current.name == 'supplierPanel-v2.newInvoiceInfo'
                        || $state.current.name == 'supplierPanel-v2.invoiceInfoDetail'
                    )
                ) {
                    if ($rootScope.modalInstance) {
                        $rootScope.modalInstance.close(result);
                        return;
                    }
                }

                if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail'
                    && $rootScope.fromStateParams
                ) {
                    $state.go('supplierPanel-v2.invoiceInfoDetail', {id: $rootScope.fromStateParams.id});
                    return;
                }


                if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.editOrderBag'
                    && $rootScope.fromStateParams
                ) {
                    $state.go('supplierPanel-v2.editOrderBag', {id: $rootScope.fromStateParams.id});
                } else if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.reserveList') {
                    $state.go('supplierPanel-v2.reserveList');
                } else {
                    $state.go('supplierPanel-v2.companyCustomer.edit', {id: result.id});
                }

                loadAll();
            }

        }

        function okModal() {
            save();

        }

        function closeModal() {

            if ($state.current.name
                && ($state.current.name == 'supplierPanel-v2.newReserve'
                    || $state.current.name == 'supplierPanel-v2.new-reserve-modal'
                    || $state.current.name == 'supplierPanel-v2.dashboard.newReserve'
                    || $state.current.name == 'supplierPanel-v2.newInvoiceInfo'
                    || $state.current.name == 'supplierPanel-v2.editInvoiceInfo'
                    || $state.current.name == 'supplierPanel-v2.invoiceInfoDetail'
                )
            ) {
                if ($rootScope.modalInstance) {
                    $rootScope.modalInstance.dismiss('cancel');
                    return;
                }
            }

            $rootScope.$broadcast('showNavBar');

            if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoDetail'
                && $rootScope.fromStateParams && $rootScope.fromStateParams.id
            ) {
                $state.go('supplierPanel-v2.invoiceInfoDetail', {id: $rootScope.fromStateParams.id});
                return;
            }

            if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.editOrderBag'
                && $rootScope.fromStateParams && $rootScope.fromStateParams.id
            ) {
                $state.go('supplierPanel-v2.editOrderBag', {id: $rootScope.fromStateParams.id});
            } else if ($rootScope.fromState && $rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.reserveList') {
                $state.go('supplierPanel-v2.reserveList');
            } else {
                $state.go('supplierPanel-v2.companyCustomer', $rootScope.fromStateParams);
            }

        }


        function gotoNewReserve() {
            $state.go('supplierPanel-v2.reserveWithCustomerParameter', {
                customerId: vm.companyCustomer.customer.id
            });
        }

        function getModalTitle() {
            if (vm.companyCustomer.id)
                return 'tikonApp.companyCustomer.home.viewAndEditCustomer';
            else
                return 'tikonApp.companyCustomer.home.createLabel';
        }

        function callCustomer() {
            if (vm.companyCustomer && vm.companyCustomer.customer && vm.companyCustomer.customer.personalInfo.phoneNumber)
                window.open("tel:" + vm.companyCustomer.customer.personalInfo.phoneNumber);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerListV2Controller', CompanyCustomerListV2Controller);

    CompanyCustomerListV2Controller.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'pagingParams', 'paginationConstants', '$mdDialog', '$uibModal', 'QueryParamsService', 'CustomerGroupCustom', '$localStorage'];

    function CompanyCustomerListV2Controller($scope, $state, ParseLinks, AlertService, CompanyCustomerCustom, pagingParams, paginationConstants, $mdDialog, $uibModal, QueryParamsService, CustomerGroupCustom, $localStorage) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clearSearch = clearSearch;
        vm.gotoNewReserve = gotoNewReserve;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search || "";
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;

        vm.isSearching = false;
        vm.newCustomer = newCustomer;
        vm.editCustomer = editCustomer;
        vm.showEducation = showEducation;
        vm.showFilterDialog = showFilterDialog;
        vm.advancedSearch = advancedSearch;
        vm.filterCompnayCustomers = filterCompnayCustomers;
        vm.filterCompanyCustomers_global = filterCompanyCustomers_global;
        vm.clear = clear;
        vm.filterQuery = {};
        vm.filterCount = 0;
        vm.customerGroups = [];
        vm.getCompanyCustomerDuplicatesItems = [];
        vm.showDuplicatesBanner = undefined;
        vm.closeDuplicatesBanner = closeDuplicatesBanner;
        $scope.modelValue = false;
        vm.showDuplicatesModal = showDuplicatesModal;

        var dialog = document.querySelector(
            'panel-pln-merge-duplicates-dialog'
        );
        dialog.modelValue = $scope.modelValue;

        dialog.addEventListener('update:modelValue', function (event) {
            $scope.$apply(function () {
                $scope.modelValue = false;
            });
        });
         dialog.addEventListener('submitted', function (event) {
            $scope.$apply(function () {
                vm.getCompanyCustomerDuplicates();
            });
        });
        $scope.$watch('modelValue', function(newVal) {
            if (dialog.modelValue !== newVal) {
                dialog.modelValue = newVal;
            }
        });

        function showDuplicatesModal(){
            $scope.modelValue = true;
        }

        $scope.filters = QueryParamsService.getFilters();
        loadAll_paging();

        function loadAll_paging() {
            getCompanyCustomerDuplicates()
            getCustomerGroups()
            getQueryParams();
            vm.filterCompnayCustomers();
            setDefaultShowDuplicatesBanner()
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     query: vm.searchQuery
            // });
            if (vm.filterQuery.searchMode)
                getCompanyCustomersByQuery(vm.filterQuery);
            else
                getCompanyCustomersByQuery();
            
        }


        function clearSearch() {
            vm.filterQuery.query = null
            filterCompanyCustomers_global();
            QueryParamsService.removeFilter('query')
        }

        function gotoNewReserve(customerId) {

            $state.go('supplierPanel-v2.reserveWithCustomerParameter', {
                customerId: customerId
            });


        }


        function search(searchQuery) { 
            if (!searchQuery) {
                return vm.clear();
            }
            if (vm.isSearching)
                return;
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function newCustomer() {
            $state.go('supplierPanel-v2.companyCustomer.new')
        }

        function editCustomer(companyCustomer) {
            // $state.go('supplierPanel-v2.companyCustomer.edit', {id: companyCustomer.id});
            $state.go('supplierPanel-v2.companyCustomer.edit', {id: companyCustomer.id});
        }

        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="89680098133"><script type="text/JavaScript" src="https://www.aparat.com/embed/lvxdy6c?data[rnddiv]=89680098133&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>'
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }
        function getQueryParams() {
            var newFilters = QueryParamsService.getFilters();
            if (newFilters.page) {
                pagingParams.search = parseInt(newFilters.page, 10) - 1;
                vm.page = parseInt(newFilters.page, 10);
            }
            if(newFilters.size){
                vm.size = newFilters.size;
            }
            if(newFilters.query){
                vm.filterQuery.query = newFilters.query;
            }
            if(newFilters.filterQuery) {
                setFilterQuery(JSON.parse(decodeURIComponent(newFilters.filterQuery)))
            }
          
        }
        function advancedSearch() {
            clear();
            vm.filterQuery.searchMode = true;
            vm.filterQuery.dontFilterFromDate = false;
            filterCompnayCustomers();
        }
        function showFilterDialog() {
            // if(!vm.companyCustomers.length) return
            var dialogData_ = {};
            dialogData_.companyCustomers = vm.companyCustomers;
            dialogData_.filterQuery = vm.filterQuery;

            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/entities/company-customer/filter-company-customer-list-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                
                fullscreen: false

            })
            .then(function (data) {
                setFilterQuery(data.filterQuery, true);
                QueryParamsService.updateFilter('filterQuery', encodeURIComponent(JSON.stringify(data.filterQuery)))
                vm.advancedSearch();
            }, function () {
            });
        }
        function setFilterQuery(filter, ignorQuery) {
            var shallowFilter = filter
            if(ignorQuery &&  shallowFilter.query) delete shallowFilter.query
            if(filter.groupIds && filter.groupIds.includes('1')) {
                vm.filterQuery["includeUngrouped"] = true;
            }else delete vm.filterQuery["includeUngrouped"]
            angular.extend(vm.filterQuery, filter);
            countFilters(filter);
        }
        function countFilters(filter) {
            vm.filterCount = 0;
            if (filter.customerFullName)
                vm.filterCount++;
            if (filter.groupIds && filter.groupIds.length)
                vm.filterCount++;
            if(vm.filterCount < 1) 
                QueryParamsService.removeFilter('filterQuery')
        }
        
        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            // vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.page = 0;
            vm.transition();
        }
        function filterCompnayCustomers(customFilter) { 
            if (vm.isSearching)
                return;
            getCompanyCustomersByQuery(customFilter);
        }
        function getCompanyCustomersByQuery(customFilter) {
            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.page = vm.page - 1;
            else
                filterQuery.page = 0;
            //must set in cache
            filterQuery.size = vm.size; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.size;
            searchCompanyCustomersByQueryPage(filterQuery)
        }
        function searchCompanyCustomersByQueryPage(filterQuery) {
            // {
            //     query: vm.searchQuery,
            //     page: pagingParams.page - 1,
            //     size: paginationConstants.itemsPerPage,
            //     sort: sort()
            // }
            CompanyCustomerCustom.getAllCompanyCustomers().query(filterQuery, onSuccess, onError);
            

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.isSearching = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyCustomers = data;
                // vm.page = pagingParams.page;
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }
        function getCustomerGroups() {
             CustomerGroupCustom
                .getCustomerGroupsByCurrentCompany()
                .query()
                .$promise
                .then(function (items) {
                     vm.customerGroups = items || [];
                })
                .catch(function(error) {
                    console.error('Company customer request failed:', error);
                });
        }
        function filterCompanyCustomers_global() {
             if (vm.filterQuery.query) {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = true;
                QueryParamsService.updateFilter('query', vm.filterQuery.query)
            } else {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = false;
                QueryParamsService.removeFilter('query')
            }
            filterCompnayCustomers();
            clear();
        }

        function getCompanyCustomerDuplicates() {
            CompanyCustomerCustom.getCompanyCustomerDuplicates().query().$promise.then(function(res) {
                vm.getCompanyCustomerDuplicatesItems = res;
                dialog.rows = res;
            }).catch(function(err) {
                console.log(err);
            })
        }
        function setDefaultShowDuplicatesBanner(){
           if($localStorage.showDuplicatesBanner === undefined) {
            vm.showDuplicatesBanner = true
           }
            else {
                var item = $localStorage.showDuplicatesBanner;
                if(Date.now() > item.expiry) {
                    vm.showDuplicatesBanner = true;
                    $localStorage.showDuplicatesBanner = {
                        value: true,
                        expiry:  Date.now() + (1 * 60 * 60 * 1000)
                    }
                }else vm.showDuplicatesBanner = item.value;
            }
                
           
        }
        function closeDuplicatesBanner() {
            $localStorage.showDuplicatesBanner = {
                value: false,
                expiry:  Date.now() + (1 * 60 * 60 * 1000)
            }
            vm.showDuplicatesBanner = false;
        }

           var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;
            $ctrl.customerGroups = vm.customerGroups;

            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
                delete vm.filterQuery.customerFullName;
                delete vm.filterQuery.groupIds;
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerListController', CompanyCustomerListController);

    CompanyCustomerListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'pagingParams', 'paginationConstants', '$mdDialog'];

    function CompanyCustomerListController($scope, $state, ParseLinks, AlertService, CompanyCustomerCustom, pagingParams, paginationConstants, $mdDialog) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.gotoNewReserve = gotoNewReserve;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;


        loadAll_paging();

        function loadAll_paging() {

            if (pagingParams.search) {
                CompanyCustomerCustom.getAllCompanyCustomers().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyCustomerCustom.getAllCompanyCustomers().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyCustomers = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function gotoNewReserve(customerId) {


            $state.go('supplierPanel.reserveWithCustomerParameter', {
                customerId: customerId
            });


        }


        function search() {
            if (!vm.searchQuery) {
                return clear();
            }
            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerDialogController', CompanyCustomerDialogController);

    CompanyCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyCustomer', 'Company', 'Customer'];

    function CompanyCustomerDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyCustomer, Company, Customer) {
        var vm = this;

        vm.companyCustomer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();
        vm.customers = Customer.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyCustomer.id !== null) {
                CompanyCustomer.update(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                CompanyCustomer.save(vm.companyCustomer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerDetailController', CompanyCustomerDetailController);

    CompanyCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyCustomer', 'Company', 'Customer'];

    function CompanyCustomerDetailController($scope, $rootScope, $stateParams, entity, CompanyCustomer, Company, Customer) {
        var vm = this;

        vm.companyCustomer = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companyCustomerUpdate', function (event, result) {
            vm.companyCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerDeleteController', CompanyCustomerDeleteController);

    CompanyCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyCustomer'];

    function CompanyCustomerDeleteController($uibModalInstance, entity, CompanyCustomer) {
        var vm = this;

        vm.companyCustomer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanyCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustomerCustom', CompanyCustomerCustom);

    CompanyCustomerCustom.$inject = ['$resource', 'ENV'];

    function CompanyCustomerCustom($resource,ENV) {


        var getCompanyCustomerByCurrentCompany = function () {
            var resourceUrl = 'api/get-company-customer-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyCustomForm = function (companyId) {

            var resourceUrl = 'api/get-company-custom-form-by-company-id?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyCustomFormDataByCompanyCustomerId = function (companyCustomerId) {

            var resourceUrl = 'api/get-company-custom-form-data-by-company-customer-id?companyCustomerId=' + companyCustomerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyCustomerByCustomerId = function (customerId) {

            var resourceUrl = 'api/get-company-custom-form-data-by-customer-id?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getNewCompanyCustomerFormData = function (companyCustomFormId) {

            var resourceUrl = 'api/get-new-company-customer-form-data-by-company-custom-form-id?companyCustomFormId=' + companyCustomFormId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        // var getCompanyCustomerFormData = function (id) {
        //
        //     var resourceUrl = 'api/get-company-customer-form-data?Id='+id;
        //     return $resource(resourceUrl, {}, {
        //             'query': {method: 'GET', isArray: true}
        //         }
        //     );
        // };

        var addNewCustomer = function () {
            var resourceUrl = 'api/add-new-customer';
            return $resource(resourceUrl, {}, {}
            );
        }

        var companyCustomerFormData = function () {
            var resourceUrl = 'api/company-customer-form-data/:id';
            // return $resource(resourceUrl, {}, {}
            // );
            return $resource(resourceUrl, {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            });
        }
        var editCompanyCustomerFormData = function () {
            var resourceUrl = 'api/edit-company-customer-form-data';
            return $resource(resourceUrl, {}, {}
            );
        }


        var updateCompanyCustomer = function () {
            var resourceUrl = 'api/update-company-customer';
            return $resource(resourceUrl, {}, {}
            );
        }

        var updateCustomerIntakeFormData = function () {
            var resourceUrl = 'api/update-customer-intake-form-data';
            return $resource(resourceUrl, {}, {}
            );

        }

        var getAllCompanyCustomers = function () {

            var resourceUrl = 'api/get-all-company-customers';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        // var getCompanyCustomerWithForms = function (companyCustomerId) {
        //
        //     var resourceUrl = 'api/get-company-customer-with-forms-by-id?companyCustomerId='+companyCustomerId;
        //     return $resource(resourceUrl, {}, {
        //             'query': {method: 'GET', isArray: true}
        //         }
        //     );
        // };

        var getEmptyCompanyCustomerIntakeData = function () {

            var resourceUrl = 'api/get-empty-company-customer-intake-data';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findCompanyCustomerByCustomerId = function (customerId) {

            var resourceUrl = 'api/get-company-customer-by-customer-id?customerId=' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getAllCompanyCustomForm = function () {

            var resourceUrl = 'api/get-all-company-custom-form';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var sendWelcomeMessage = function(customerId) {
            var resourceUrl = 'api/company-customers/' + customerId + '/welcome';
            return $resource(resourceUrl, {}, {});
        }

        var mergeCompanyCustomers = function () {
               var resourceUrl =
                   ENV.API_BASE_URL +
                   'api/company-customers/merge';

               return $resource(resourceUrl, {}, {
                   merge: {
                       method: 'POST',
                       isArray: false
                   }
               });
           };
        var getCompanyCustomerDuplicates = function () {
            var resourceUrl = 'api/company-customers/duplicates';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getCompanyCustomerByCurrentCompany: getCompanyCustomerByCurrentCompany,
            addNewCustomer: addNewCustomer,
            updateCompanyCustomer: updateCompanyCustomer,
            updateCustomerIntakeFormData: updateCustomerIntakeFormData,
            getCompanyCustomForm: getCompanyCustomForm,
            getCompanyCustomFormDataByCompanyCustomerId: getCompanyCustomFormDataByCompanyCustomerId,
            getCompanyCustomerByCustomerId: getCompanyCustomerByCustomerId,
            getNewCompanyCustomerFormData: getNewCompanyCustomerFormData,
            companyCustomerFormData: companyCustomerFormData,
            getAllCompanyCustomers: getAllCompanyCustomers,
            getEmptyCompanyCustomerIntakeData: getEmptyCompanyCustomerIntakeData,
            findCompanyCustomerByCustomerId: findCompanyCustomerByCustomerId,
            getAllCompanyCustomForm: getAllCompanyCustomForm,
            sendWelcomeMessage: sendWelcomeMessage,
            mergeCompanyCustomers:mergeCompanyCustomers,
            getCompanyCustomerDuplicates: getCompanyCustomerDuplicates


        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-customer', {
                parent: 'entity',
                url: '/company-customer?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyCustomer.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customers.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customerStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-customer-detail', {
                parent: 'entity',
                url: '/company-customer/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyCustomer.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-detail.html',
                        controller: 'CompanyCustomerDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customerStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyCustomer', function ($stateParams, CompanyCustomer) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-customer.new', {
                parent: 'supplierPanel',
                url: '/company-customer-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            })
            .state('company-customer.edit', {
                parent: 'supplierPanel',
                url: '/company-customer-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {

                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })

            .state('company-customer.edit2', {
                parent: 'supplierPanel',
                url: '/company-customer-list-2/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

                    var paramId = $stateParams.id;
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                // $translatePartialLoader.addPart('company');
                                $translatePartialLoader.addPart('personInfo');
                                // $translatePartialLoader.addPart('serviceItem');
                                // $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: ['CompanyCustomer', function (CompanyCustomer) {

                                return CompanyCustomer.get({id: paramId}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-customer.new-pop-up', {
                parent: 'supplierPanel',
                url: '/company-customer-list-2/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

                    var paramId = $stateParams.id;
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                // $translatePartialLoader.addPart('company');
                                $translatePartialLoader.addPart('personInfo');
                                // $translatePartialLoader.addPart('serviceItem');
                                // $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: ['CompanyCustomer', function (CompanyCustomer) {

                                return CompanyCustomer.get({id: paramId}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('company-customer.delete', {
                parent: 'supplierPanel',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})
();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustomer', CompanyCustomer);

    CompanyCustomer.$inject = ['$resource', 'DateUtils'];

    function CompanyCustomer($resource, DateUtils) {
        var resourceUrl = 'api/company-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertLocalDateFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.createDate = DateUtils.convertLocalDateToServer(data.createDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.createDate = DateUtils.convertLocalDateToServer(data.createDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyCustomerSearch', CompanyCustomerSearch);

    CompanyCustomerSearch.$inject = ['$resource'];

    function CompanyCustomerSearch($resource) {
        var resourceUrl = 'api/_search/company-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerController', CompanyCustomerController);

    CompanyCustomerController.$inject = ['$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader'];

    function CompanyCustomerController($scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        vm.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');

            // if (vm.companyCustomer && vm.companyCustomer.id) {
            //     // vm.companyCustomer.forms = CompanyCustomerCustom.getCompanyCustomForm(vm.companyCustomer.companyId).query();
            //     CompanyCustomerCustom.getCompanyCustomFormDataByCompanyCustomerId(vm.companyCustomer.id).query(function (res) {
            //
            //         vm.companyCustomer.formsData = res;
            //         console.log(vm.companyCustomer);
            //
            //         vm.companyCustomer.formsData.sort(function (a, b) { //to sort by id desc
            //             return b.id - a.id;
            //         });
            //         console.log(vm.companyCustomer.formsData);
            //     });
            // }
        }

        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {

            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                vm.customerFormData = res;
                vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                vm.customerFormData.companyCustomer = vm.companyCustomer;
                openEditDataDialog(vm.customerFormData);

            });
        }

        // function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {
        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            vm.customerFormData = data;
            vm.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            vm.customerFormData.companyCustomer = vm.companyCustomer;
            openEditDataDialog(vm.customerFormData);
        }

        // function openEditDataDialog(customerFormData) {
        //     vm.columnCount = 4 ;
        //     $mdDialog.show({
        //         locals: {dialogData: customerFormData , columnCount: vm.columnCount},
        //         controller: ComponentIntakeDataDialogController,
        //         templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
        //         controllerAs: '$ctrl',
        //         parent: angular.element(document.body),
        //         targetEvent: customerFormData,
        //         clickOutsideToClose: true
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // };

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:companyCustomerUpdate', result);
                // vm.companyCustomer = result;

                //  if($state.current.url.includes('new'))
                $state.go('company-customer.edit', {id: result.id});

                loadAll();

                // CustomerCustom.saveScheduleList().update(vm.serviceList, function () {
                //     $scope.$emit('tikonApp:customerUpdate', result);
                //     vm.serviceList = CompanyCustomer.serviceItemScheduleByCustomerId(customer.id).query(function (result) {
                //         vm.companyCustomer.customer = result;
                //     });
                //     vm.isSaving = false;
                // })


            }

        }
    }
})();
;
(function () {
  "use strict";

  angular.module("tikonApp").controller("BlogsCategories", BlogsCategories);

  BlogsCategories.$inject = ["$timeout", "$state", "$rootScope"];

  function BlogsCategories($timeout, $state, $rootScope) {
    function initBlogsCategories() {
      var blogsCategoriesElement = document.getElementById("blogs-categories");
      blogsCategoriesElement.addEventListener("prevPageBtn", function (e) {
        if ($rootScope.fromState.name)
          $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
        else $state.go("supplierPanel-v2.setting");
        // closeModal()
      });
      blogsCategoriesElement.addEventListener("toBlogs", function (e) {
        $state.go("supplierPanel-v2.companyBlogs");
        // closeModal()
      });
    }
    $timeout(initBlogsCategories, 50);
  }
})();
;
(function () {
  "use strict";

  angular.module("tikonApp").controller("CompanyBlogs", CompanyBlogs);

  CompanyBlogs.$inject = ["$timeout", "$state", "$rootScope"];

  function CompanyBlogs($timeout, $state, $rootScope) {
    function initBlogs() {
      var blogsElement = document.getElementById("company-blogs");
      blogsElement.addEventListener("prevPageBtn", function (e) {
        if ($rootScope.fromState.name)
          $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
        else $state.go("supplierPanel-v2.setting");
        // closeModal()
      });
      blogsElement.addEventListener("toBlogCategories", function (e) {
        $state.go("supplierPanel-v2.companyBlogCategories");
        // closeModal()
      });
    }
    $timeout(initBlogs, 50);
  }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInfoV2Controller', CompanyInfoV2Controller);

    CompanyInfoV2Controller.$inject = ['$rootScope', '$state', '__config', '$timeout', '$scope', '$stateParams', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'CompanyInfoQuery', 'Principal', 'CompanyCustom', 'ActivityTypeInfo', 'ActivityTypeInfoCustom'];

    function CompanyInfoV2Controller($rootScope, $state, __config, $timeout, $scope, $stateParams, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, CompanyInfoQuery, Principal, CompanyCustom, ActivityTypeInfo, ActivityTypeInfoCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.__config = __config;
        vm.isCompanyNameValid = isCompanyNameValid;
        vm.isUrlValid = true;
        //
        //vm.company = entity;
        vm.company = CompanyInfoQuery.getCurrentCompanyInfo().query();
        vm.clear = clear;
        vm.save = save;
        //vm.settinginfos = SettingInfo.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.locationinfos = LocationInfo.query();
        vm.metatags = MetaTag.query();
        vm.metatagOptions = {
            placeholder: "--",
            dataTextField: "tag",
            //dataValueField: "id",
            valuePrimitive: true,
            autoBind: false,
            dataSource: vm.metatags
        };

        vm.activityTypes = [];


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        $rootScope.$broadcast('hideNavBar');


        loadAllActivityTypes();

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {

        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.company.id !== null) {
                    Company.update(vm.company, onSaveSuccess, onSaveError);
                } else {
                    //Company.save(vm.company, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);

            if (result)
                Principal.setCurrentCompany(result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isCompanyNameValid() {
            vm.isUrlValid = field_keyUrl.checkValidity();
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

        function loadAllActivityTypes() {
            ActivityTypeInfoCustom.getAllActivityTypeInfos().query(function (result) {
                vm.activityTypes = result;
                categorizeActivityTypes();
            });
        }

        function categorizeActivityTypes() {

            vm.typeCategories = [];

            vm.beauty = {};
            vm.beauty.title = 'زیبایی';
            vm.beauty.items = [];

            vm.health = [];
            vm.health.title = 'سلامتی';
            vm.health.items = [];

            vm.serviceBase = [];
            vm.serviceBase.title = 'خدماتی';
            vm.serviceBase.items = [];

            vm.education = [];
            vm.education.title = 'آموزشی';
            vm.education.items = [];

            vm.entertainment = [];
            vm.entertainment.title = 'تفریحی ورزشی';
            vm.entertainment.items = [];

            vm.enterprise = [];
            vm.enterprise.title = 'سازمان و شرکت';
            vm.enterprise.items = [];

            if (vm.activityTypes) {
                angular.forEach(vm.activityTypes, function (item) {

                    switch (item.category) {
                        case 'BEAUTY' :
                            vm.beauty.items.push(item);
                            break;
                        case 'HEALTH' :
                            vm.health.items.push(item);
                            break;
                        case 'EDUCATION' :
                            vm.education.items.push(item);
                            break;
                        case 'ENTERTAINMENT' :
                            vm.entertainment.items.push(item);
                            break;
                        case 'SERVICE_BASE' :
                            vm.serviceBase.items.push(item);
                            break;
                        case 'ENTERPRISE' :
                            vm.enterprise.items.push(item);
                            break;

                    }
                })

                vm.typeCategories.push(vm.beauty);
                vm.typeCategories.push(vm.health);
                vm.typeCategories.push(vm.serviceBase);
                vm.typeCategories.push(vm.education);
                vm.typeCategories.push(vm.enterprise);
                vm.typeCategories.push(vm.entertainment);


            }
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyInfoQuery', CompanyInfoQuery);

    CompanyInfoQuery.$inject = ['$resource', 'ENV'];

    function CompanyInfoQuery($resource, ENV) {


        var getCurrentCompanyInfo = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/getCurrentCompanyInfo';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false},
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        };


        return {
            getCurrentCompanyInfo: getCurrentCompanyInfo
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInfoController', CompanyInfoController);

    CompanyInfoController.$inject = ['__config', '$timeout', '$scope', '$stateParams', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'CompanyInfoQuery', 'Principal', 'CompanyCustom'];

    function CompanyInfoController(__config, $timeout, $scope, $stateParams, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, CompanyInfoQuery, Principal, CompanyCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.__config = __config;
        vm.isCompanyNameValid = isCompanyNameValid;
        vm.isUrlValid = true;
        //
        //vm.company = entity;
        vm.company = CompanyInfoQuery.getCurrentCompanyInfo().query();
        vm.clear = clear;
        vm.save = save;
        //vm.settinginfos = SettingInfo.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.locationinfos = LocationInfo.query();
        vm.metatags = MetaTag.query();
        vm.metatagOptions = {
            placeholder: "--",
            dataTextField: "tag",
            //dataValueField: "id",
            valuePrimitive: true,
            autoBind: false,
            dataSource: vm.metatags
        };

        vm.activityTypes = CompanyCustom.getCompanyActivityTypes();

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.company.id !== null) {
                    Company.update(vm.company, onSaveSuccess, onSaveError);
                } else {
                    //Company.save(vm.company, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);

            if (result)
                Principal.setCurrentCompany(result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isCompanyNameValid() {
            vm.isUrlValid = field_keyUrl.checkValidity();
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'CompanyCustom', 'Marketplace'];

    function CompanyDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, CompanyCustom, Marketplace) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.save = save;
        vm.allMarketplaces = [];
        // vm.settinginfos = SettingInfo.query();
        // vm.agreementinfos = AgreementInfo.query();
        // vm.locationinfos = LocationInfo.query();
        // vm.metatags = MetaTag.query();
        loadAll();

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });


        function loadAll() {
            getAllMarketplaces();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            addMarketplaces();
            if (vm.company.id !== null) {
                CompanyCustom.updateCompanyFieldByAdmin().save(vm.company, onSaveSuccess, onSaveError);
            } else {
                // Company.save(vm.company, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function addMarketplaces() {

            vm.company.marketplaces = [];
            angular.forEach(vm.allMarketplaces, function (item) {
                if (item.selected) {
                    vm.company.marketplaces.push(item);
                }

            })
        }

        function getAllMarketplaces() {

            Marketplace.query().$promise.then(function (result) {
                    vm.allMarketplaces = result;
                    makeMarketplacesSelectedOnLoad();
                }
            );
        }

        function makeMarketplacesSelectedOnLoad() {
            if (vm.company.marketplaces && vm.company.marketplaces.length > 0) {
                angular.forEach(vm.company.marketplaces, function (item) {
                    angular.forEach(vm.allMarketplaces, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyDetailController', CompanyDetailController);

    CompanyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag'];

    function CompanyDetailController($scope, $rootScope, $stateParams, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag) {
        var vm = this;

        vm.company = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companyUpdate', function (event, result) {
            vm.company = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyDeleteController', CompanyDeleteController);

    CompanyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Company'];

    function CompanyDeleteController($uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Company.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustom', CompanyCustom);

    CompanyCustom.$inject = ['$resource', '__config', 'ENV'];

    function CompanyCustom($resource, __config, ENV) {


        var findCompanyByQuery = function (query) {

            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-query?query=' + query;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findCompaniesForAgentRequest = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-companies-for-agent-request';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var getCurrentCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var findCompanyByKeyURL = function (keyUrl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-key-url?keyUrl=' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getCompaniesByParentId = function (parentId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-companies-by-parent-id?parentId=' + parentId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var changeCurrentCompany = function (keyurl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/change-current-company/' + keyurl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }


        var companyCustomSettingField = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/company-custom-setting-field';
            return $resource(resourceUrl, {}, {}
            );
        }


        var getCompanyActivityTypes = function () {
            var activityTypes = [];

            if (__config.appMode == 'reserve') {
                activityTypes.push('PSYCHOLOGIST');
                activityTypes.push('BUSINESS_CONSULTING');
                activityTypes.push('MEN_SALON');
                activityTypes.push('WOMEN_SALON');
                activityTypes.push('DOCTOR');
                activityTypes.push('SPA');
                activityTypes.push('WORK_SPACE');
                activityTypes.push('ATELIER');
                activityTypes.push('IMMIGRATION');
                activityTypes.push('COACHING');
                activityTypes.push('SCAPE_ROOM');
                activityTypes.push('BEAUTY_CLINIC');
                activityTypes.push('CAR_SERVICE');
                activityTypes.push('ENTERPRISE');
                activityTypes.push('ACUPUNCTURE');
                activityTypes.push('HOBBY');
                activityTypes.push('BEAUTY');
                activityTypes.push('TRAVEL');
                activityTypes.push('HEALTH');
                activityTypes.push('SPORT');
                activityTypes.push('EDUCATION');
                activityTypes.push('OTHER');
            }

            if (__config.appMode == 'event') {
                activityTypes.push('INSTITUTE');
                activityTypes.push('SCHOOL');
                activityTypes.push('UNIVERSITY');
                activityTypes.push('BUSINESS_CONSULTING');
                activityTypes.push('PSYCHOLOGIST');
                activityTypes.push('EDUCATION');
                activityTypes.push('DOCTOR');
                activityTypes.push('HOBBY');
                activityTypes.push('HEALTH');
                activityTypes.push('DIGITAL_MARKETING_AGENCY');
                activityTypes.push('OTHER');
            }

            return activityTypes;
        }


        var updateCompanyFieldByAdmin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/update-company-field-by-admin';
            return $resource(resourceUrl, {}, {}
            );
        }

        var isCurrentCompanyListedInAnyMarketPlaces = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/is-current-company-listed-in-any-marketplaces';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var deActiveCompanyByKeyURL = function (keyUrl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/de-active-company-by-key-url?keyUrl=' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        var getCompanyWebSiteAddressClearCache = function (then) {
            this.getCurrentCompany().query().$promise.then(function (com) {
                var site = com.keyUrl;
                site = site + '.' + __config.domain;

                if (com.hasDedicatedDomain && com.domain) {
                    site = com.domain;
                }
                site = "https://" + site + "/#/home/true";
                if (then)
                    then(site);
            })
        }

        var getCurrentCompanyOnBoardingMode = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company-on-boarding-mode';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getCurrentCompanyWizardSteps = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company-wizard-steps';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var setCompanyWizardStepsDone = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/company-wizard-steps-done';
            return $resource(resourceUrl, {}, {}
            );
        }

        var downgradeVersion = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/downgrade-version';
            return $resource(resourceUrl, {}, {}
            );
        }

        var upgradeVersion = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/upgrade-version';
            return $resource(resourceUrl, {}, {}
            );
        }


        var skipCompanyWizardSteps = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/skip-company-wizard-steps';
            return $resource(resourceUrl, {}, {}
            );
        }

        return {
            findCompanyByQuery: findCompanyByQuery,
            findCompaniesForAgentRequest: findCompaniesForAgentRequest,
            getCurrentCompany: getCurrentCompany,
            findCompanyByKeyURL: findCompanyByKeyURL,
            getCompaniesByParentId: getCompaniesByParentId,
            changeCurrentCompany: changeCurrentCompany,
            companyCustomSettingField: companyCustomSettingField,
            getCompanyActivityTypes: getCompanyActivityTypes,
            updateCompanyFieldByAdmin: updateCompanyFieldByAdmin,
            isCurrentCompanyListedInAnyMarketPlaces: isCurrentCompanyListedInAnyMarketPlaces,
            deActiveCompanyByKeyURL: deActiveCompanyByKeyURL,
            getCompanyWebSiteAddressClearCache: getCompanyWebSiteAddressClearCache,
            getCurrentCompanyOnBoardingMode: getCurrentCompanyOnBoardingMode,
            getCurrentCompanyWizardSteps: getCurrentCompanyWizardSteps,
            setCompanyWizardStepsDone: setCompanyWizardStepsDone,
            downgradeVersion: downgradeVersion,
            upgradeVersion: upgradeVersion,
            skipCompanyWizardSteps: skipCompanyWizardSteps

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company', {
                parent: 'entity',
                url: '/company?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.company.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company/companies.html',
                        controller: 'CompanyController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-detail', {
                parent: 'entity',
                url: '/company/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.company.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company/company-detail.html',
                        controller: 'CompanyDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                        return Company.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company.new', {
                parent: 'company',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    phoneNumber: null,
                                    activityType: null,
                                    webSiteUrl: null,
                                    keyUrl: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: true});
                    }, function () {
                        $state.go('company');
                    });
                }]
            })
            .state('company.edit', {
                parent: 'company',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company.delete', {
                parent: 'company',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company/company-delete-dialog.html',
                        controller: 'CompanyDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Company', Company);

    Company.$inject = ['$resource', 'ENV'];

    function Company($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySearch', CompanySearch);

    CompanySearch.$inject = ['$resource', 'ENV'];

    function CompanySearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['$scope', '$state', 'Company', 'CompanySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyController($scope, $state, Company, CompanySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                CompanySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Company.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companies = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectBatchItemModalController', SelectBatchItemModalController);

    SelectBatchItemModalController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout', 'ServiceItemCustom', 'ServiceAddOnCustom', 'ServantCustom'];

    function SelectBatchItemModalController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout, ServiceItemCustom, ServiceAddOnCustom, ServantCustom) {

        var vm = this;
        vm.items = [];
        vm.loadAll = loadAll;
        vm.itemSelectionType = "SERVICE";
        vm.onServiceChanged = onServiceChanged;
        vm.servant_changed = servant_changed;
        vm.canEditCapacity = true;
        vm.addServiceItem = addServiceItem;
        vm.serviceItemList = null;
        vm.onServiceItemClick = onServiceItemClick;
        vm.onServiceAddOnClick = onServiceAddOnClick;
        vm.deleteItem = deleteItem;
        vm.tabChanged = tabChanged;
        vm.noItemMsg = 'هیچ آیتمی انتخاب نشده است';
        vm.noServiceAddOnMsg = 'هیچ خدمت ویژه ای تعریف نشده است';
        vm.goToServiceAddOn = goToServiceAddOn;
        vm.allServants = [];

        vm.activityTypeInfo = {};
        vm.activityTypeInfo.servantTitle = "پرسنل";


        loadAll();


        vm.closeModal = closeModal;
        vm.okModal = okModal;

        vm.getModalTitle = getModalTitle;


        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('commissionItemType');
            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);

            // getAllActiveServants();
            getAllServiceItems();
            getAllServiceAddOns();

        }

        function okModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.close(vm.items);
            }
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
                return;
            }
        }

        function getModalTitle() {
            return 'tikonApp.commission.addBatchItem.title';
        }


        function getAllServiceItems() {
            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (list) {
                vm.serviceItemList = list;
            })

        }


        function onServiceChanged() {

            // if(vm.selectedServiceItem)
            //     ;

        }

        function servant_changed() {

        }


        function addServiceItem() {
            if (!vm.selectedServiceItem)
                return;

            var item = {};
            item.title = vm.selectedServiceItem.itemTitle;
            item.id = vm.selectedServiceItem.id;
            item.type = 'SERVICE';
            item.randomNo = Math.floor(Math.random() * 10000);

            vm.items.push(item);
            resetSelectedItems();
        }


        function resetSelectedItems() {
            vm.selectedServiceItem = null;
        }

        function onServiceItemClick(serviceItem) {

            vm.selectedServiceItem = serviceItem;
            addServiceItem();
        }

        function onServiceAddOnClick(addOn) {
            addServiceAddOn(addOn);
        }

        function addServiceAddOn(addOn) {

            if (!addOn)
                return;
            var item = {};
            item.title = addOn.title;
            item.id = addOn.id;
            item.type = 'SERVICE_ADD_ON';
            item.randomNo = Math.floor(Math.random() * 10000);

            vm.items.push(item);
        }

        function deleteItem(selectedItem) {
            vm.items = vm.items.filter(function (item) {
                if (selectedItem.randomNo != item.randomNo) {
                    return selectedItem;
                }

            })

        }

        function getAllServiceAddOns() {
            ServiceAddOnCustom.getActiveServiceAddOns().query(function (list) {
                vm.serviceAddOnList = list;
            })

        }

        function tabChanged(tabName) {
            if (tabName == 'serviceAddOnTab')
                vm.itemSelectionType = 'SERVICE_ADD_ON';
            else
                vm.itemSelectionType = 'SERVICE';

        }

        function goToServiceAddOn() {
            $state.go('supplierPanel-v2.serviceAddOnList');
            closeModal();
        }

        $scope.$watch('vm.selectedServiceItem', function () {

            if (!vm.selectedServiceItem) {
                var elem = document.getElementById("serviceListId");
                if (elem)
                    elem.focus();

                return;
            }

        })

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CommissionListController', CommissionListController);

    CommissionListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'Commission', 'CommissionCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function CommissionListController($scope, $state, ParseLinks, AlertService, Commission, CommissionCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.editCommission = editCommission;
        vm.searchKeyPress = searchKeyPress;
        vm.newCommission = newCommission;
        vm.clearSearch = clearSearch;

        vm.findApproveStatusStyle = findApproveStatusStyle;

        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                CommissionCustom.getAllCompanyCommission().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CommissionCustom.getAllCompanyCommission().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.commissions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editCommission(commission) {
            $state.go('supplierPanel-v2.editCommission', {id: commission.id});
        }

        function newCommission() {
            var result;

            // result = Principal.hasSpecialFeatureAccess("Commission");
            // if (!result) {
            //     DialogService.showAlert("عدم دسترسی","برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
            //     return;
            // }
            $state.go('supplierPanel-v2.newCommission');
        }

        function clearSearch() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findApproveStatusStyle(approveStatus) {
            return "marketing-approve-status marketing-approve-status-" + approveStatus;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CommissionDeleteController', CommissionDeleteController);

    CommissionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Commission'];

    function CommissionDeleteController($uibModalInstance, entity, Commission) {
        var vm = this;

        vm.commission = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Commission.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CommissionCustom', CommissionCustom);

    CommissionCustom.$inject = ['$resource', 'DateUtils'];

    function CommissionCustom($resource, DateUtils) {


        var getAllCompanyCommission = function () {

            var resourceUrl = 'api/get-all-company-commissions';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getLastServantCommission = function (id) {
            var resourceUrl = 'api/get-last-servant-commission' + '/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var calculateCommission = function () {
            var resourceUrl = 'api/calculate-commission';
            //?servantId=' + servantId+ '&fromDate=' + DateUtils.convertToISOString(fromdate) + '&toDate=' + DateUtils.convertToISOString(todate)
            return $resource(resourceUrl, {}, {}
            );
        }

        return {
            getAllCompanyCommission: getAllCompanyCommission,
            getLastServantCommission: getLastServantCommission,
            calculateCommission: calculateCommission

        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Commission', Commission);

    Commission.$inject = ['$resource', 'DateUtils'];

    function Commission($resource, DateUtils) {
        var resourceUrl = 'api/commissions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CommissionController', CommissionController);

    CommissionController.$inject = ['$rootScope', '$scope', '$state', 'Commission', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CommissionCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'ServantCustom', 'ServiceAddOnCustom', '$uibModal'];

    function CommissionController($rootScope, $scope, $state, Commission, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CommissionCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, ServantCustom, ServiceAddOnCustom, $uibModal) {

        var vm = this;
        vm.commission = entity;
        vm.servantList = {};
        vm.serviceList = {};
        vm.serviceAddOnList = {};
        vm.lastCommission = null;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.newCommissionItem = newCommissionItem;
        vm.deleteItem = deleteItem;
        vm.selectBatchItem = selectBatchItem;
        vm.onServant_changed = onServant_changed;
        vm.itemListEmptyMessage = 'هیچ آیتمی انتخاب نشده است';

        initDefault();
        loadAll();


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {


            if (!vm.commission)
                vm.commission = {};

            if (!vm.commission.status)
                vm.commission.status = 'ACTIVE';


            $rootScope.$broadcast('hideNavBar');

        }

        function loadAll() {
            $translatePartialLoader.addPart('servant');
            // $translatePartialLoader.addPart('CommissionTypes');
            // $translatePartialLoader.addPart('CommissionPeriod');

            angular.forEach(vm.commission.items, function (item) {
                item.randomNo = Math.floor(Math.random() * 10000);
            });

            getAllServant();
            getAllServiceItem();
            getAllServiceAddOn();
        }

        function getAllServant() {
            ServantCustom.findServantsByCompany().query(function (result) {
                vm.servantList = result;
            })
        }

        function getAllServiceItem() {
            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (result) {
                vm.serviceList = result;

            })
        }

        function getAllServiceAddOn() {
            ServiceAddOnCustom.getActiveServiceAddOns().query(function (result) {
                vm.serviceAddOnList = result;

            })
        }

        function save() {
            vm.isSaving = true;

            if (vm.commission.id !== null) {
                Commission.update(vm.commission, onSaveSuccess, onSaveError);
            } else {

                Commission.save(vm.commission, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:commissionUpdate', result);
                vm.commission = result;
                $state.go('supplierPanel-v2.editCommission', {id: result.id});
                vm.isSaving = false;

                loadAll();

            }

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.commissionList');

        }

        function getModalTitle() {
            if (vm.commission.id)
                return 'tikonApp.commission.home.edit';
            else
                return 'tikonApp.commission.home.new';
        }

        function newCommissionItem(type, referencedId) {

            var item = {};
            item.amount = 0;
            item.type = type;
            item.commissionType = 'PERCENT';

            if (!vm.commission.items)
                vm.commission.items = [];

            item.randomNo = Math.floor(Math.random() * 10000);

            if (referencedId)
                item.referencedItemId = referencedId;

            vm.commission.items.push(item);

        }

        function deleteItem(item) {
            vm.commission.items = vm.commission.items.filter(function (commissionItem) {
                if (commissionItem.randomNo != item.randomNo)
                    return commissionItem;
            })
        }

        function selectBatchItem() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/commission/select-batch-item-modal.html',
                controller: 'SelectBatchItemModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

            $rootScope.modalInstance.result.then(function (items) {

                addItemsToCommission(items);
                //reload();
            }, function () {
                //nothing
            });
        }

        function addItemsToCommission(items) {
            angular.forEach(items, function (item) {
                newCommissionItem(item.type, item.id);
            });
        }

        function onServant_changed() {

            if (!vm.commission.servant.id)
                return;
            vm.lastCommission = null;

            CommissionCustom.getLastServantCommission(vm.commission.servant.id).query(function (result) {

                if (!result.id) {
                    return;
                }

                if (result.id != vm.commission.id || !vm.commission.id)
                    vm.lastCommission = result;
                else
                    vm.lastCommission = null;
            })
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CalculateCommissionController', CalculateCommissionController);

    CalculateCommissionController.$inject = ['$rootScope', '$scope', '$state', 'Commission', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'CustomerCustom', 'CommissionCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'ServantCustom', 'ServiceAddOnCustom', '$uibModal', 'DateUtils'];

    function CalculateCommissionController($rootScope, $scope, $state, Commission, PersonInfo, Customer, ParseLinks, AlertService, CustomerCustom, CommissionCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, ServantCustom, ServiceAddOnCustom, $uibModal, DateUtils) {

        var vm = this;

        vm.fromDate = null;
        vm.toDate = null;
        vm.servant = {};
        vm.servantList = [];
        vm.calculateFinalizeInvoices = true;

        vm.loadAll = loadAll;
        vm.findInvoiceInfoStatusStyle = findInvoiceInfoStatusStyle;


        loadAll();

        vm.save = save;

        initDefault();
        loadAll();


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {
            $rootScope.$broadcast('hideNavBar');
        }

        function loadAll() {
            $translatePartialLoader.addPart('servant');
            $translatePartialLoader.addPart('invoiceInfo');
            $translatePartialLoader.addPart('invoiceInfoItem');
            $translatePartialLoader.addPart('invoiceStatus');
            $translatePartialLoader.addPart('commission');
            getAllServant();
        }

        function getAllServant() {
            ServantCustom.findServantsByCompany().query(function (result) {
                vm.servantList = result;
            })
        }

        function save() {
            vm.isSaving = true;
            if (!vm.fromDate || !vm.toDate) {
                AlertService.error("error.calculate_commission_date_is_required");
                vm.isSaving = false;
                return;
            }

            var setting = {};
            setting.servantId = vm.servant.id;
            setting.fromDateStr = DateUtils.convertToISOString(vm.fromDate);
            setting.toDateStr = DateUtils.convertToISOString(vm.toDate);
            setting.calculateNotFinalizeInvoices = !vm.calculateFinalizeInvoices;

            CommissionCustom.calculateCommission().save(setting, function (result) {
                vm.calculatedCommission = result;
                vm.isSaving = false;
            });
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.commissionList');

        }

        function getModalTitle() {
            return 'tikonApp.commission.calculate';
        }

        function findInvoiceInfoStatusStyle(status) {
            return "invoice-status-" + status;
        }
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CapacityExceptionDialogController', CapacityExceptionDialogController);
//
//    CapacityExceptionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CapacityException', 'ServiceCapacityInfo'];
//
//    function CapacityExceptionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CapacityException, ServiceCapacityInfo) {
//        var vm = this;
//
//        vm.capacityException = entity;
//        vm.clear = clear;
//        vm.datePickerOpenStatus = {};
//        vm.openCalendar = openCalendar;
//        vm.save = save;
//        vm.servicecapacityinfos = ServiceCapacityInfo.query();
//
//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function save () {
//            vm.isSaving = true;
//            if (vm.capacityException.id !== null) {
//                CapacityException.update(vm.capacityException, onSaveSuccess, onSaveError);
//            } else {
//                CapacityException.save(vm.capacityException, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('tikonApp:capacityExceptionUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
//
//        vm.datePickerOpenStatus.reserveTime = false;
//
//        function openCalendar (date) {
//            vm.datePickerOpenStatus[date] = true;
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CapacityExceptionDetailController', CapacityExceptionDetailController);
//
//    CapacityExceptionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CapacityException', 'ServiceCapacityInfo'];
//
//    function CapacityExceptionDetailController($scope, $rootScope, $stateParams, entity, CapacityException, ServiceCapacityInfo) {
//        var vm = this;
//
//        vm.capacityException = entity;
//
//        var unsubscribe = $rootScope.$on('tikonApp:capacityExceptionUpdate', function(event, result) {
//            vm.capacityException = result;
//        });
//        $scope.$on('$destroy', unsubscribe);
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CapacityExceptionDeleteController',CapacityExceptionDeleteController);
//
//    CapacityExceptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CapacityException'];
//
//    function CapacityExceptionDeleteController($uibModalInstance, entity, CapacityException) {
//        var vm = this;
//
//        vm.capacityException = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            CapacityException.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('capacity-exception', {
//            parent: 'entity',
//            url: '/capacity-exception?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.capacityException.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/capacity-exception/capacity-exceptions.html',
//                    controller: 'CapacityExceptionController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('capacityException');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('capacity-exception-detail', {
//            parent: 'entity',
//            url: '/capacity-exception/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.capacityException.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/capacity-exception/capacity-exception-detail.html',
//                    controller: 'CapacityExceptionDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('capacityException');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'CapacityException', function($stateParams, CapacityException) {
//                    return CapacityException.get({id : $stateParams.id}).$promise;
//                }]
//            }
//        })
//        .state('capacity-exception.new', {
//            parent: 'capacity-exception',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/capacity-exception/capacity-exception-dialog.html',
//                    controller: 'CapacityExceptionDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                exceptionType: null,
//                                reserveTime: null,
//                                newQty: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('capacity-exception', null, { reload: true });
//                }, function() {
//                    $state.go('capacity-exception');
//                });
//            }]
//        })
//        .state('capacity-exception.edit', {
//            parent: 'capacity-exception',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/capacity-exception/capacity-exception-dialog.html',
//                    controller: 'CapacityExceptionDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['CapacityException', function(CapacityException) {
//                            return CapacityException.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('capacity-exception', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('capacity-exception.delete', {
//            parent: 'capacity-exception',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/capacity-exception/capacity-exception-delete-dialog.html',
//                    controller: 'CapacityExceptionDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['CapacityException', function(CapacityException) {
//                            return CapacityException.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('capacity-exception', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
//(function() {
//    'use strict';
//    angular
//        .module('tikonApp')
//        .factory('CapacityException', CapacityException);
//
//    CapacityException.$inject = ['$resource', 'DateUtils'];
//
//    function CapacityException ($resource, DateUtils) {
//        var resourceUrl =  'api/capacity-exceptions/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                        data.reserveTime = DateUtils.convertDateTimeFromServer(data.reserveTime);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' }
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('CapacityExceptionSearch', CapacityExceptionSearch);
//
//    CapacityExceptionSearch.$inject = ['$resource'];
//
//    function CapacityExceptionSearch($resource) {
//        var resourceUrl =  'api/_search/capacity-exceptions/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true}
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CapacityExceptionController', CapacityExceptionController);
//
//    CapacityExceptionController.$inject = ['$scope', '$state', 'CapacityException', 'CapacityExceptionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];
//
//    function CapacityExceptionController ($scope, $state, CapacityException, CapacityExceptionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
//        var vm = this;
//
//        vm.loadPage = loadPage;
//        vm.predicate = pagingParams.predicate;
//        vm.reverse = pagingParams.ascending;
//        vm.transition = transition;
//        vm.clear = clear;
//        vm.search = search;
//        vm.searchQuery = pagingParams.search;
//        vm.currentSearch = pagingParams.search;
//
//        loadAll();
//
//        function loadAll () {
//            if (pagingParams.search) {
//                CapacityExceptionSearch.query({
//                    query: pagingParams.search,
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            } else {
//                CapacityException.query({
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            }
//            function sort() {
//                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
//                if (vm.predicate !== 'id') {
//                    result.push('id');
//                }
//                return result;
//            }
//            function onSuccess(data, headers) {
//                vm.links = ParseLinks.parse(headers('link'));
//                vm.totalItems = headers('X-Total-Count');
//                vm.queryCount = vm.totalItems;
//                vm.capacityExceptions = data;
//                vm.page = pagingParams.page;
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
//
//        function transition () {
//            $state.transitionTo($state.$current, {
//                page: vm.page,
//                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
//                search: vm.currentSearch
//            });
//        }
//
//        function search (searchQuery) {
//            if (!searchQuery){
//                return vm.clear();
//            }
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = '_score';
//            vm.reverse = false;
//            vm.currentSearch = searchQuery;
//            vm.transition();
//        }
//
//        function clear () {
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = 'id';
//            vm.reverse = true;
//            vm.currentSearch = null;
//            vm.transition();
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CancelingInfoDialogController', CancelingInfoDialogController);
//
//    CancelingInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CancelingInfo'];
//
//    function CancelingInfoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CancelingInfo) {
//        var vm = this;
//
//        vm.cancelingInfo = entity;
//        vm.clear = clear;
//        vm.save = save;
//
//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function save () {
//            vm.isSaving = true;
//            if (vm.cancelingInfo.id !== null) {
//                CancelingInfo.update(vm.cancelingInfo, onSaveSuccess, onSaveError);
//            } else {
//                CancelingInfo.save(vm.cancelingInfo, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('tikonApp:cancelingInfoUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
//
//
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CancelingInfoDetailController', CancelingInfoDetailController);
//
//    CancelingInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CancelingInfo'];
//
//    function CancelingInfoDetailController($scope, $rootScope, $stateParams, entity, CancelingInfo) {
//        var vm = this;
//
//        vm.cancelingInfo = entity;
//
//        var unsubscribe = $rootScope.$on('tikonApp:cancelingInfoUpdate', function(event, result) {
//            vm.cancelingInfo = result;
//        });
//        $scope.$on('$destroy', unsubscribe);
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CancelingInfoDeleteController',CancelingInfoDeleteController);
//
//    CancelingInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'CancelingInfo'];
//
//    function CancelingInfoDeleteController($uibModalInstance, entity, CancelingInfo) {
//        var vm = this;
//
//        vm.cancelingInfo = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            CancelingInfo.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('canceling-info', {
//            parent: 'entity',
//            url: '/canceling-info?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.cancelingInfo.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/canceling-info/canceling-infos.html',
//                    controller: 'CancelingInfoController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('cancelingInfo');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('canceling-info-detail', {
//            parent: 'entity',
//            url: '/canceling-info/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'tikonApp.cancelingInfo.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/canceling-info/canceling-info-detail.html',
//                    controller: 'CancelingInfoDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('cancelingInfo');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'CancelingInfo', function($stateParams, CancelingInfo) {
//                    return CancelingInfo.get({id : $stateParams.id}).$promise;
//                }]
//            }
//        })
//        .state('canceling-info.new', {
//            parent: 'canceling-info',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/canceling-info/canceling-info-dialog.html',
//                    controller: 'CancelingInfoDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                description: null,
//                                status: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('canceling-info', null, { reload: true });
//                }, function() {
//                    $state.go('canceling-info');
//                });
//            }]
//        })
//        .state('canceling-info.edit', {
//            parent: 'canceling-info',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/canceling-info/canceling-info-dialog.html',
//                    controller: 'CancelingInfoDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['CancelingInfo', function(CancelingInfo) {
//                            return CancelingInfo.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('canceling-info', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('canceling-info.delete', {
//            parent: 'canceling-info',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/canceling-info/canceling-info-delete-dialog.html',
//                    controller: 'CancelingInfoDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['CancelingInfo', function(CancelingInfo) {
//                            return CancelingInfo.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('canceling-info', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
//(function() {
//    'use strict';
//    angular
//        .module('tikonApp')
//        .factory('CancelingInfo', CancelingInfo);
//
//    CancelingInfo.$inject = ['$resource'];
//
//    function CancelingInfo ($resource) {
//        var resourceUrl =  'api/canceling-infos/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' }
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('CancelingInfoSearch', CancelingInfoSearch);
//
//    CancelingInfoSearch.$inject = ['$resource'];
//
//    function CancelingInfoSearch($resource) {
//        var resourceUrl =  'api/_search/canceling-infos/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true}
//        });
//    }
//})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('CancelingInfoController', CancelingInfoController);
//
//    CancelingInfoController.$inject = ['$scope', '$state', 'CancelingInfo', 'CancelingInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];
//
//    function CancelingInfoController ($scope, $state, CancelingInfo, CancelingInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
//        var vm = this;
//
//        vm.loadPage = loadPage;
//        vm.predicate = pagingParams.predicate;
//        vm.reverse = pagingParams.ascending;
//        vm.transition = transition;
//        vm.clear = clear;
//        vm.search = search;
//        vm.searchQuery = pagingParams.search;
//        vm.currentSearch = pagingParams.search;
//
//        loadAll();
//
//        function loadAll () {
//            if (pagingParams.search) {
//                CancelingInfoSearch.query({
//                    query: pagingParams.search,
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            } else {
//                CancelingInfo.query({
//                    page: pagingParams.page - 1,
//                    size: paginationConstants.itemsPerPage,
//                    sort: sort()
//                }, onSuccess, onError);
//            }
//            function sort() {
//                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
//                if (vm.predicate !== 'id') {
//                    result.push('id');
//                }
//                return result;
//            }
//            function onSuccess(data, headers) {
//                vm.links = ParseLinks.parse(headers('link'));
//                vm.totalItems = headers('X-Total-Count');
//                vm.queryCount = vm.totalItems;
//                vm.cancelingInfos = data;
//                vm.page = pagingParams.page;
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
//
//        function transition () {
//            $state.transitionTo($state.$current, {
//                page: vm.page,
//                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
//                search: vm.currentSearch
//            });
//        }
//
//        function search (searchQuery) {
//            if (!searchQuery){
//                return vm.clear();
//            }
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = '_score';
//            vm.reverse = false;
//            vm.currentSearch = searchQuery;
//            vm.transition();
//        }
//
//        function clear () {
//            vm.links = null;
//            vm.page = 1;
//            vm.predicate = 'id';
//            vm.reverse = true;
//            vm.currentSearch = null;
//            vm.transition();
//        }
//    }
//})();
;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("BaseComponentsShowCase", BaseComponentsShowCase);

  function BaseComponentsShowCase() {
  }
})();


;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyBankAccountInfoControllerV3', CompanyBankAccountInfoControllerV3);

    CompanyBankAccountInfoControllerV3.$inject = ['$rootScope', '$state', '$timeout', '$scope', '$stateParams', 'BankAccountInfo', 'BankAccountInfoCustom', 'CompanyCustom', '$window', '$http', 'ENV'];

    function CompanyBankAccountInfoControllerV3($rootScope, $state, $timeout, $scope, $stateParams, BankAccountInfo, BankAccountInfoCustom, CompanyCustom, $window, $http, ENV) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.onlinePaymentGatewayType = '';
        vm.currentCompany = {};
        vm.onGatewayChange = onGatewayChange;


        vm.okModal = okModal;
        vm.closeModal = closeModal;

        $rootScope.$broadcast('hideNavBar');

        // loadData();

        // function loadData() {
        //     vm.bankAccountInfo = BankAccountInfoCustom.findBankAccountInfoByCurrentCompnay().query();
        //     findCurrentCompany();
        // }

        // function findCurrentCompany() {
        //     CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
        //         vm.currentCompany = result;
        //     });
        // }


        function save() {
            vm.isSaving = true;
            if (vm.bankAccountInfo.id !== null) {
                BankAccountInfo.update(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            } else {
                BankAccountInfo.save(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:bankAccountInfoUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

        vm.goToRequestForm = function goToRequestForm() {
            $window.open('https://podform.ir/f/cEaNaE3l95Oby3pTVYF-dA==', '_blank');
        }

        function onGatewayChange() {
            if (vm.bankAccountInfo.gateway && (vm.bankAccountInfo.gateway == 'SUPPLIER_AP' || vm.bankAccountInfo.gateway == 'SUPPLIER_SEP')
                && !vm.bankAccountInfo.gatewaySettingObject
            ) {
                vm.bankAccountInfo.gatewaySettingObject = {};
            }
        }

        function loadKyc() {
            var kyc = document.getElementById('kyc');
            kyc.addEventListener('backEvent', function(e){
                closeModal()
            })

        }
        $timeout(loadKyc, 50)

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyBankAccountInfoController', CompanyBankAccountInfoController);

    CompanyBankAccountInfoController.$inject = ['$rootScope', '$state', '$timeout', '$scope', '$stateParams', 'BankAccountInfo', 'BankAccountInfoCustom', 'CompanyCustom', '$window'];

    function CompanyBankAccountInfoController($rootScope, $state, $timeout, $scope, $stateParams, BankAccountInfo, BankAccountInfoCustom, CompanyCustom, $window) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.onlinePaymentGatewayType = '';
        vm.currentCompany = {};
        vm.onGatewayChange = onGatewayChange;


        vm.okModal = okModal;
        vm.closeModal = closeModal;

        $rootScope.$broadcast('hideNavBar');

        loadData();

        function loadData() {
            vm.bankAccountInfo = BankAccountInfoCustom.findBankAccountInfoByCurrentCompnay().query();
            findCurrentCompany();
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        function save() {
            vm.isSaving = true;
            if (vm.bankAccountInfo.id !== null) {
                BankAccountInfo.update(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            } else {
                BankAccountInfo.save(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:bankAccountInfoUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

        vm.goToRequestForm = function goToRequestForm() {
            $window.open('https://podform.ir/f/cEaNaE3l95Oby3pTVYF-dA==', '_blank');
        }

        function onGatewayChange() {
            if (vm.bankAccountInfo.gateway && (vm.bankAccountInfo.gateway == 'SUPPLIER_AP' || vm.bankAccountInfo.gateway == 'SUPPLIER_SEP')
                && !vm.bankAccountInfo.gatewaySettingObject
            ) {
                vm.bankAccountInfo.gatewaySettingObject = {};
            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoDialogController', BankAccountInfoDialogController);

    BankAccountInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BankAccountInfo'];

    function BankAccountInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, BankAccountInfo) {
        var vm = this;

        vm.bankAccountInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.bankAccountInfo.id !== null) {
                BankAccountInfo.update(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            } else {
                BankAccountInfo.save(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:bankAccountInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoDetailController', BankAccountInfoDetailController);

    BankAccountInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BankAccountInfo'];

    function BankAccountInfoDetailController($scope, $rootScope, $stateParams, entity, BankAccountInfo) {
        var vm = this;

        vm.bankAccountInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:bankAccountInfoUpdate', function (event, result) {
            vm.bankAccountInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoDeleteController', BankAccountInfoDeleteController);

    BankAccountInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'BankAccountInfo'];

    function BankAccountInfoDeleteController($uibModalInstance, entity, BankAccountInfo) {
        var vm = this;

        vm.bankAccountInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            BankAccountInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('BankAccountInfoCustom', BankAccountInfoCustom);

    BankAccountInfoCustom.$inject = ['$resource'];

    function BankAccountInfoCustom($resource) {


        var findBankAccountInfoByCurrentCompnay = function () {

            var resourceUrl = 'api/find-bank-account-info-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            findBankAccountInfoByCurrentCompnay: findBankAccountInfoByCurrentCompnay
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bank-account-info', {
                parent: 'entity',
                url: '/bank-account-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.bankAccountInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/bank-account-infos.html',
                        controller: 'BankAccountInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('bankAccountType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('bank-account-info-detail', {
                parent: 'entity',
                url: '/bank-account-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.bankAccountInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-detail.html',
                        controller: 'BankAccountInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('bankAccountType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'BankAccountInfo', function ($stateParams, BankAccountInfo) {
                        return BankAccountInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('bank-account-info.new', {
                parent: 'bank-account-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-dialog.html',
                        controller: 'BankAccountInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    ownerTitle: null,
                                    createDate: null,
                                    bankName: null,
                                    accountType: null,
                                    accountNo: null,
                                    cardNo: null,
                                    shabaNo: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('bank-account-info', null, {reload: true});
                    }, function () {
                        $state.go('bank-account-info');
                    });
                }]
            })
            .state('bank-account-info.edit', {
                parent: 'bank-account-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-dialog.html',
                        controller: 'BankAccountInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['BankAccountInfo', function (BankAccountInfo) {
                                return BankAccountInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('bank-account-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('bank-account-info.delete', {
                parent: 'bank-account-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-delete-dialog.html',
                        controller: 'BankAccountInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['BankAccountInfo', function (BankAccountInfo) {
                                return BankAccountInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('bank-account-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('BankAccountInfo', BankAccountInfo);

    BankAccountInfo.$inject = ['$resource', 'DateUtils'];

    function BankAccountInfo($resource, DateUtils) {
        var resourceUrl = 'api/bank-account-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('BankAccountInfoSearch', BankAccountInfoSearch);

    BankAccountInfoSearch.$inject = ['$resource'];

    function BankAccountInfoSearch($resource) {
        var resourceUrl = 'api/_search/bank-account-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoController', BankAccountInfoController);

    BankAccountInfoController.$inject = ['$scope', '$state', 'BankAccountInfo', 'BankAccountInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function BankAccountInfoController($scope, $state, BankAccountInfo, BankAccountInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                BankAccountInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                BankAccountInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bankAccountInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SingleAlbumInfoController', SingleAlbumInfoController);

    SingleAlbumInfoController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'AlbumInfo'];

    function SingleAlbumInfoController($timeout, $scope, $stateParams, entity, AlbumInfo) {
        var vm = this;

        vm.albumInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save() {
            vm.isSaving = true;
            if (vm.albumInfo.id !== null) {
                AlbumInfo.update(vm.albumInfo, onSaveSuccess, onSaveError);
            } else {
                AlbumInfo.save(vm.albumInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:albumInfoUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AlbumInfoExtend', AlbumInfoExtend);

    AlbumInfoExtend.$inject = ['$resource'];

    function AlbumInfoExtend($resource) {


        var findAlbumImages = function (albumId) {
            if (albumId)
                var resourceUrl = 'api/image-data-by-albumid/' + albumId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var findAlbumImagesByType = function (albumId, sizeType) {
            if (albumId)
                var resourceUrl = 'api/image-data-by-album-id-and-size-type/' + albumId + '/' + sizeType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            findAlbumImages: findAlbumImages,
            findAlbumImagesByType: findAlbumImagesByType
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AlbumInfoDialogController', AlbumInfoDialogController);

    AlbumInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AlbumInfo'];

    function AlbumInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AlbumInfo) {
        var vm = this;

        vm.albumInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.albumInfo.id !== null) {
                AlbumInfo.update(vm.albumInfo, onSaveSuccess, onSaveError);
            } else {
                AlbumInfo.save(vm.albumInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:albumInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AlbumInfoDetailController', AlbumInfoDetailController);

    AlbumInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AlbumInfo'];

    function AlbumInfoDetailController($scope, $rootScope, $stateParams, entity, AlbumInfo) {
        var vm = this;

        vm.albumInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:albumInfoUpdate', function (event, result) {
            vm.albumInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AlbumInfoDeleteController', AlbumInfoDeleteController);

    AlbumInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'AlbumInfo'];

    function AlbumInfoDeleteController($uibModalInstance, entity, AlbumInfo) {
        var vm = this;

        vm.albumInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AlbumInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('album-info', {
                parent: 'entity',
                url: '/album-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.albumInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/album-info/album-infos.html',
                        controller: 'AlbumInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('albumInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('album-info-detail', {
                parent: 'entity',
                url: '/album-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.albumInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/album-info/album-info-detail.html',
                        controller: 'AlbumInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('albumInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlbumInfo', function ($stateParams, AlbumInfo) {
                        return AlbumInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('album-info.new', {
                parent: 'album-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/album-info/album-info-dialog.html',
                        controller: 'AlbumInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    isSingleImage: null,
                                    caption: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('album-info', null, {reload: true});
                    }, function () {
                        $state.go('album-info');
                    });
                }]
            })
            .state('album-info.edit', {
                parent: 'album-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/album-info/album-info-dialog.html',
                        controller: 'AlbumInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AlbumInfo', function (AlbumInfo) {
                                return AlbumInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('album-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('album-info.delete', {
                parent: 'album-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/album-info/album-info-delete-dialog.html',
                        controller: 'AlbumInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AlbumInfo', function (AlbumInfo) {
                                return AlbumInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('album-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AlbumInfo', AlbumInfo);

    AlbumInfo.$inject = ['$resource'];

    function AlbumInfo($resource) {
        var resourceUrl = 'api/album-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AlbumInfoSearch', AlbumInfoSearch);

    AlbumInfoSearch.$inject = ['$resource'];

    function AlbumInfoSearch($resource) {
        var resourceUrl = 'api/_search/album-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AlbumInfoController', AlbumInfoController);

    AlbumInfoController.$inject = ['$scope', '$state', 'AlbumInfo', 'AlbumInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AlbumInfoController($scope, $state, AlbumInfo, AlbumInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AlbumInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AlbumInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.albumInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyAgreementInfoController', CompanyAgreementInfoController);

    CompanyAgreementInfoController.$inject = ['$timeout', '$scope', '$stateParams', 'AgreementInfo', 'CompanyInfoQuery'];

    function CompanyAgreementInfoController($timeout, $scope, $stateParams, AgreementInfo, CompanyInfoQuery) {
        var vm = this;
        //
        //vm.agreementInfo = entity;
        vm.companyInfo = CompanyInfoQuery.getCurrentCompanyInfo().query();
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyInfo.agreementInfo.id !== null) {
                AgreementInfo.update(vm.companyInfo.agreementInfo, onSaveSuccess, onSaveError);
            } else {
                AgreementInfo.save(vm.companyInfo.agreementInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agreementInfoUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgreementInfoDialogController', AgreementInfoDialogController);

    AgreementInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgreementInfo'];

    function AgreementInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgreementInfo) {
        var vm = this;

        vm.agreementInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agreementInfo.id !== null) {
                AgreementInfo.update(vm.agreementInfo, onSaveSuccess, onSaveError);
            } else {
                AgreementInfo.save(vm.agreementInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agreementInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgreementInfoDetailController', AgreementInfoDetailController);

    AgreementInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgreementInfo'];

    function AgreementInfoDetailController($scope, $rootScope, $stateParams, entity, AgreementInfo) {
        var vm = this;

        vm.agreementInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agreementInfoUpdate', function (event, result) {
            vm.agreementInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgreementInfoDeleteController', AgreementInfoDeleteController);

    AgreementInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgreementInfo'];

    function AgreementInfoDeleteController($uibModalInstance, entity, AgreementInfo) {
        var vm = this;

        vm.agreementInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgreementInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgreementInfoCustom', AgreementInfoCustom);

    AgreementInfoCustom.$inject = ['$resource'];

    function AgreementInfoCustom($resource) {


        var AgreementInfoByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/agreement-info-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            AgreementInfoByServiceItem: AgreementInfoByServiceItem
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agreement-info', {
                parent: 'entity',
                url: '/agreement-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agreementInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agreement-info/agreement-infos.html',
                        controller: 'AgreementInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agreementInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agreement-info-detail', {
                parent: 'entity',
                url: '/agreement-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agreementInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agreement-info/agreement-info-detail.html',
                        controller: 'AgreementInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agreementInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgreementInfo', function ($stateParams, AgreementInfo) {
                        return AgreementInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agreement-info.new', {
                parent: 'agreement-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agreement-info/agreement-info-dialog.html',
                        controller: 'AgreementInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    rules: null,
                                    agreement: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agreement-info', null, {reload: true});
                    }, function () {
                        $state.go('agreement-info');
                    });
                }]
            })
            .state('agreement-info.edit', {
                parent: 'agreement-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agreement-info/agreement-info-dialog.html',
                        controller: 'AgreementInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgreementInfo', function (AgreementInfo) {
                                return AgreementInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agreement-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agreement-info.delete', {
                parent: 'agreement-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agreement-info/agreement-info-delete-dialog.html',
                        controller: 'AgreementInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgreementInfo', function (AgreementInfo) {
                                return AgreementInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agreement-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgreementInfo', AgreementInfo);

    AgreementInfo.$inject = ['$resource'];

    function AgreementInfo($resource) {
        var resourceUrl = 'api/agreement-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgreementInfoSearch', AgreementInfoSearch);

    AgreementInfoSearch.$inject = ['$resource'];

    function AgreementInfoSearch($resource) {
        var resourceUrl = 'api/_search/agreement-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgreementInfoController', AgreementInfoController);

    AgreementInfoController.$inject = ['$scope', '$state', 'AgreementInfo', 'AgreementInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgreementInfoController($scope, $state, AgreementInfo, AgreementInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AgreementInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgreementInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agreementInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractDialogController', AgentSupplierContractDialogController);

    AgentSupplierContractDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentSupplierContract', 'AgentAccessInfo', 'AgentRequest', 'Company'];

    function AgentSupplierContractDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentSupplierContract, AgentAccessInfo, AgentRequest, Company) {
        var vm = this;

        vm.agentSupplierContract = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.agentaccessinfos = AgentAccessInfo.query();
        vm.agentrequests = AgentRequest.query();
        vm.companies = Company.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentSupplierContract.id !== null) {
                AgentSupplierContract.update(vm.agentSupplierContract, onSaveSuccess, onSaveError);
            } else {
                AgentSupplierContract.save(vm.agentSupplierContract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentSupplierContractUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractDetailController', AgentSupplierContractDetailController);

    AgentSupplierContractDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentSupplierContract', 'AgentAccessInfo', 'AgentRequest', 'Company'];

    function AgentSupplierContractDetailController($scope, $rootScope, $stateParams, entity, AgentSupplierContract, AgentAccessInfo, AgentRequest, Company) {
        var vm = this;

        vm.agentSupplierContract = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentSupplierContractUpdate', function (event, result) {
            vm.agentSupplierContract = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractDeleteController', AgentSupplierContractDeleteController);

    AgentSupplierContractDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentSupplierContract'];

    function AgentSupplierContractDeleteController($uibModalInstance, entity, AgentSupplierContract) {
        var vm = this;

        vm.agentSupplierContract = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentSupplierContract.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentSupplierContractCustom', AgentSupplierContractCustom);

    AgentSupplierContractCustom.$inject = ['$resource', 'DateUtils'];

    function AgentSupplierContractCustom($resource) {
        var getCurrentAgentSuppliers = function () {
            var resourceUrl = 'api/get-current-agent-suppliers';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var saveAgentSuppliersAccess = function () {
            var resourceUrl = 'api/save-agent-supplier-access';
            return $resource(resourceUrl, {}, {}
            );
        }

        var getAgentSupplierWithAllAccessById = function (contractId) {

            var resourceUrl = 'api/get-agent-supplier-with-all-access-by-id?contractId=' + contractId;
            return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        }

        return {
            getCurrentAgentSuppliers: getCurrentAgentSuppliers,
            saveAgentSuppliersAccess: saveAgentSuppliersAccess,
            getAgentSupplierWithAllAccessById: getAgentSupplierWithAllAccessById

        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-supplier-contract', {
                parent: 'entity',
                url: '/agent-supplier-contract?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentSupplierContract.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contracts.html',
                        controller: 'AgentSupplierContractController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentSupplierContract');
                        $translatePartialLoader.addPart('agentSupplierContractStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-supplier-contract-detail', {
                parent: 'entity',
                url: '/agent-supplier-contract/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentSupplierContract.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-detail.html',
                        controller: 'AgentSupplierContractDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentSupplierContract');
                        $translatePartialLoader.addPart('agentSupplierContractStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentSupplierContract', function ($stateParams, AgentSupplierContract) {
                        return AgentSupplierContract.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-supplier-contract.new', {
                parent: 'agent-supplier-contract',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-dialog.html',
                        controller: 'AgentSupplierContractDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    commision: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-supplier-contract', null, {reload: true});
                    }, function () {
                        $state.go('agent-supplier-contract');
                    });
                }]
            })
            .state('agent-supplier-contract.edit', {
                parent: 'agent-supplier-contract',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-dialog.html',
                        controller: 'AgentSupplierContractDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentSupplierContract', function (AgentSupplierContract) {
                                return AgentSupplierContract.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-supplier-contract', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-supplier-contract.delete', {
                parent: 'agent-supplier-contract',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-delete-dialog.html',
                        controller: 'AgentSupplierContractDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentSupplierContract', function (AgentSupplierContract) {
                                return AgentSupplierContract.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-supplier-contract', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentSupplierContract', AgentSupplierContract);

    AgentSupplierContract.$inject = ['$resource', 'DateUtils'];

    function AgentSupplierContract($resource, DateUtils) {
        var resourceUrl = 'api/agent-supplier-contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentSupplierContractSearch', AgentSupplierContractSearch);

    AgentSupplierContractSearch.$inject = ['$resource'];

    function AgentSupplierContractSearch($resource) {
        var resourceUrl = 'api/_search/agent-supplier-contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractController', AgentSupplierContractController);

    AgentSupplierContractController.$inject = ['$scope', '$state', 'AgentSupplierContract', 'AgentSupplierContractSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgentSupplierContractController($scope, $state, AgentSupplierContract, AgentSupplierContractSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AgentSupplierContractSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgentSupplierContract.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agentSupplierContracts = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessDialogController', AgentServiceItemAccessDialogController);

    AgentServiceItemAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentServiceItemAccess', 'ServiceItem', 'AgentAccessInfo'];

    function AgentServiceItemAccessDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentServiceItemAccess, ServiceItem, AgentAccessInfo) {
        var vm = this;

        vm.agentServiceItemAccess = entity;
        vm.clear = clear;
        vm.save = save;
        vm.serviceitems = ServiceItem.query();
        vm.agentaccessinfos = AgentAccessInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentServiceItemAccess.id !== null) {
                AgentServiceItemAccess.update(vm.agentServiceItemAccess, onSaveSuccess, onSaveError);
            } else {
                AgentServiceItemAccess.save(vm.agentServiceItemAccess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentServiceItemAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessDetailController', AgentServiceItemAccessDetailController);

    AgentServiceItemAccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentServiceItemAccess', 'ServiceItem', 'AgentAccessInfo'];

    function AgentServiceItemAccessDetailController($scope, $rootScope, $stateParams, entity, AgentServiceItemAccess, ServiceItem, AgentAccessInfo) {
        var vm = this;

        vm.agentServiceItemAccess = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentServiceItemAccessUpdate', function (event, result) {
            vm.agentServiceItemAccess = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessDeleteController', AgentServiceItemAccessDeleteController);

    AgentServiceItemAccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentServiceItemAccess'];

    function AgentServiceItemAccessDeleteController($uibModalInstance, entity, AgentServiceItemAccess) {
        var vm = this;

        vm.agentServiceItemAccess = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentServiceItemAccess.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-service-item-access', {
                parent: 'entity',
                url: '/agent-service-item-access?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentServiceItemAccess.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-accesses.html',
                        controller: 'AgentServiceItemAccessController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentServiceItemAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-service-item-access-detail', {
                parent: 'entity',
                url: '/agent-service-item-access/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentServiceItemAccess.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-detail.html',
                        controller: 'AgentServiceItemAccessDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentServiceItemAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentServiceItemAccess', function ($stateParams, AgentServiceItemAccess) {
                        return AgentServiceItemAccess.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-service-item-access.new', {
                parent: 'agent-service-item-access',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-dialog.html',
                        controller: 'AgentServiceItemAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accessType: null,
                                    viewMode: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-service-item-access', null, {reload: true});
                    }, function () {
                        $state.go('agent-service-item-access');
                    });
                }]
            })
            .state('agent-service-item-access.edit', {
                parent: 'agent-service-item-access',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-dialog.html',
                        controller: 'AgentServiceItemAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentServiceItemAccess', function (AgentServiceItemAccess) {
                                return AgentServiceItemAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-service-item-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-service-item-access.delete', {
                parent: 'agent-service-item-access',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-delete-dialog.html',
                        controller: 'AgentServiceItemAccessDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentServiceItemAccess', function (AgentServiceItemAccess) {
                                return AgentServiceItemAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-service-item-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentServiceItemAccess', AgentServiceItemAccess);

    AgentServiceItemAccess.$inject = ['$resource'];

    function AgentServiceItemAccess($resource) {
        var resourceUrl = 'api/agent-service-item-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentServiceItemAccessSearch', AgentServiceItemAccessSearch);

    AgentServiceItemAccessSearch.$inject = ['$resource'];

    function AgentServiceItemAccessSearch($resource) {
        var resourceUrl = 'api/_search/agent-service-item-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessController', AgentServiceItemAccessController);

    AgentServiceItemAccessController.$inject = ['$scope', '$state', 'AgentServiceItemAccess', 'AgentServiceItemAccessSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgentServiceItemAccessController($scope, $state, AgentServiceItemAccess, AgentServiceItemAccessSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AgentServiceItemAccessSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgentServiceItemAccess.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agentServiceItemAccesses = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCompanyListController', AgentCompanyListController);

    AgentCompanyListController.$inject = ['$timeout', '$scope', '$stateParams', 'CompanyCustom'];

    function AgentCompanyListController($timeout, $scope, $stateParams, CompanyCustom) {
        var vm = this;
        vm.companies = [];

        loadData();

        function loadData() {
            vm.companies = CompanyCustom.findCompaniesForAgentRequest().query();
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestDialogController', AgentRequestDialogController);

    AgentRequestDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentRequest', 'Company'];

    function AgentRequestDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentRequest, Company) {
        var vm = this;

        vm.agentRequest = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentRequest.id !== null) {
                AgentRequest.update(vm.agentRequest, onSaveSuccess, onSaveError);
            } else {
                AgentRequest.save(vm.agentRequest, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentRequestUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.replyDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestDetailController', AgentRequestDetailController);

    AgentRequestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentRequest', 'Company'];

    function AgentRequestDetailController($scope, $rootScope, $stateParams, entity, AgentRequest, Company) {
        var vm = this;

        vm.agentRequest = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentRequestUpdate', function (event, result) {
            vm.agentRequest = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestDeleteController', AgentRequestDeleteController);

    AgentRequestDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentRequest'];

    function AgentRequestDeleteController($uibModalInstance, entity, AgentRequest) {
        var vm = this;

        vm.agentRequest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentRequest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-request', {
                parent: 'entity',
                url: '/agent-request?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentRequest.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-request/agent-requests.html',
                        controller: 'AgentRequestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentRequest');
                        $translatePartialLoader.addPart('agentRequestType');
                        $translatePartialLoader.addPart('agentRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-request-detail', {
                parent: 'entity',
                url: '/agent-request/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentRequest.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-request/agent-request-detail.html',
                        controller: 'AgentRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentRequest');
                        $translatePartialLoader.addPart('agentRequestType');
                        $translatePartialLoader.addPart('agentRequestStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentRequest', function ($stateParams, AgentRequest) {
                        return AgentRequest.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-request.new', {
                parent: 'agent-request',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-dialog.html',
                        controller: 'AgentRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    agentRequestType: null,
                                    createDate: null,
                                    requestMessage: null,
                                    suggestedCommision: null,
                                    replyDate: null,
                                    replyMessage: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-request', null, {reload: true});
                    }, function () {
                        $state.go('agent-request');
                    });
                }]
            })
            .state('agent-request.edit', {
                parent: 'agent-request',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-dialog.html',
                        controller: 'AgentRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentRequest', function (AgentRequest) {
                                return AgentRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-request.delete', {
                parent: 'agent-request',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-delete-dialog.html',
                        controller: 'AgentRequestDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentRequest', function (AgentRequest) {
                                return AgentRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentRequest', AgentRequest);

    AgentRequest.$inject = ['$resource', 'DateUtils'];

    function AgentRequest($resource, DateUtils) {
        var resourceUrl = 'api/agent-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.replyDate = DateUtils.convertDateTimeFromServer(data.replyDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentRequestSearch', AgentRequestSearch);

    AgentRequestSearch.$inject = ['$resource'];

    function AgentRequestSearch($resource) {
        var resourceUrl = 'api/_search/agent-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestController', AgentRequestController);

    AgentRequestController.$inject = ['$scope', '$state', 'AgentRequest', 'AgentRequestSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgentRequestController($scope, $state, AgentRequest, AgentRequestSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AgentRequestSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgentRequest.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agentRequests = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessDialogController', AgentCategoryAccessDialogController);

    AgentCategoryAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentCategoryAccess', 'AgentAccessInfo', 'ServiceCategory'];

    function AgentCategoryAccessDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentCategoryAccess, AgentAccessInfo, ServiceCategory) {
        var vm = this;

        vm.agentCategoryAccess = entity;
        vm.clear = clear;
        vm.save = save;
        vm.agentaccessinfos = AgentAccessInfo.query();
        vm.servicecategories = ServiceCategory.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentCategoryAccess.id !== null) {
                AgentCategoryAccess.update(vm.agentCategoryAccess, onSaveSuccess, onSaveError);
            } else {
                AgentCategoryAccess.save(vm.agentCategoryAccess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentCategoryAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessDetailController', AgentCategoryAccessDetailController);

    AgentCategoryAccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentCategoryAccess', 'AgentAccessInfo', 'ServiceCategory'];

    function AgentCategoryAccessDetailController($scope, $rootScope, $stateParams, entity, AgentCategoryAccess, AgentAccessInfo, ServiceCategory) {
        var vm = this;

        vm.agentCategoryAccess = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentCategoryAccessUpdate', function (event, result) {
            vm.agentCategoryAccess = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessDeleteController', AgentCategoryAccessDeleteController);

    AgentCategoryAccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentCategoryAccess'];

    function AgentCategoryAccessDeleteController($uibModalInstance, entity, AgentCategoryAccess) {
        var vm = this;

        vm.agentCategoryAccess = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentCategoryAccess.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-category-access', {
                parent: 'entity',
                url: '/agent-category-access?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentCategoryAccess.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-category-access/agent-category-accesses.html',
                        controller: 'AgentCategoryAccessController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentCategoryAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-category-access-detail', {
                parent: 'entity',
                url: '/agent-category-access/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentCategoryAccess.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-detail.html',
                        controller: 'AgentCategoryAccessDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentCategoryAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentCategoryAccess', function ($stateParams, AgentCategoryAccess) {
                        return AgentCategoryAccess.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-category-access.new', {
                parent: 'agent-category-access',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-dialog.html',
                        controller: 'AgentCategoryAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accessType: null,
                                    viewMode: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-category-access', null, {reload: true});
                    }, function () {
                        $state.go('agent-category-access');
                    });
                }]
            })
            .state('agent-category-access.edit', {
                parent: 'agent-category-access',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-dialog.html',
                        controller: 'AgentCategoryAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentCategoryAccess', function (AgentCategoryAccess) {
                                return AgentCategoryAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-category-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-category-access.delete', {
                parent: 'agent-category-access',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-delete-dialog.html',
                        controller: 'AgentCategoryAccessDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentCategoryAccess', function (AgentCategoryAccess) {
                                return AgentCategoryAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-category-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentCategoryAccess', AgentCategoryAccess);

    AgentCategoryAccess.$inject = ['$resource'];

    function AgentCategoryAccess($resource) {
        var resourceUrl = 'api/agent-category-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentCategoryAccessSearch', AgentCategoryAccessSearch);

    AgentCategoryAccessSearch.$inject = ['$resource'];

    function AgentCategoryAccessSearch($resource) {
        var resourceUrl = 'api/_search/agent-category-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessController', AgentCategoryAccessController);

    AgentCategoryAccessController.$inject = ['$scope', '$state', 'AgentCategoryAccess', 'AgentCategoryAccessSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgentCategoryAccessController($scope, $state, AgentCategoryAccess, AgentCategoryAccessSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AgentCategoryAccessSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgentCategoryAccess.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agentCategoryAccesses = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UpsertAgentAccessDialogController', UpsertAgentAccessDialogController);

    UpsertAgentAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceCategoryCustom', 'AgentSupplierContractCustom'];

    function UpsertAgentAccessDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceCategoryCustom, AgentSupplierContractCustom) {
        var vm = this;


        vm.agentSupplierContract = entity;
        vm.clear = clear;
        vm.save = save;
        vm.supplierServiceCategories = ServiceCategoryCustom.getServiceCategoriesByCompanyId(vm.agentSupplierContract.supplier.id).query();
        vm.agentServiceCategories = ServiceCategoryCustom.getServiceCategoriesByCompanyId(vm.agentSupplierContract.agent.id).query();
        vm.addCategoryAccess = addCategoryAccess;
        vm.selectedAgentServiceCategory = null;
        vm.selectedSupplierServiceCategory = null;
        vm.removeItem = removeItem;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            vm.isSaving = true;
            if (vm.agentSupplierContract.id !== null) {
                AgentSupplierContractCustom.saveAgentSuppliersAccess().save(vm.agentSupplierContract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentCategoryAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function addCategoryAccess() {

            if (vm.selectedAgentServiceCategory != null && vm.selectedSupplierServiceCategory != null) {
                if (vm.agentSupplierContract.agentAccessInfo == null || vm.agentSupplierContract.agentAccessInfo == undefined)
                    vm.agentSupplierContract.agentAccessInfo = {id: null, accessType: 'FULL', agentCategoryAccess: []};

                if (vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess == null || vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess == undefined)
                    vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess = [];

                var supplierCat = vm.supplierServiceCategories.filter(function (v) {
                        if (v.id == vm.selectedSupplierServiceCategory)
                            return v;
                    }
                );

                var agentCat = vm.agentServiceCategories.filter(function (v) {
                        if (v.id == vm.selectedAgentServiceCategory)
                            return v;
                    }
                );

                vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess.push({
                    id: null,
                    accessType: 'VIEW_ACCESS',
                    viewMode: null,
                    supplierCategory: supplierCat[0],
                    mapToAgentCategory: agentCat[0]
                });

            }
        }

        function removeItem(data) {
            vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess = vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess.filter(function (v) {
                if (v.supplierCategory.categoryName != data.supplierCategory.categoryName &&
                    v.mapToAgentCategory.categoryName != data.mapToAgentCategory.categoryName
                ) {
                    return v;
                }
            });
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SetAgentAccessInfoController', SetAgentAccessInfoController);

    SetAgentAccessInfoController.$inject = ['$scope', '$state', 'AgentSupplierContractCustom'];

    function SetAgentAccessInfoController($scope, $state, AgentSupplierContractCustom) {
        var vm = this;

        vm.loadPage = loadPage;

        loadAll();

        function loadAll() {

            vm.agentSupplierContracts = AgentSupplierContractCustom.getCurrentAgentSuppliers().query();

        }

        function loadPage(page) {

        }

        function transition() {

        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoDialogController', AgentAccessInfoDialogController);

    AgentAccessInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentAccessInfo'];

    function AgentAccessInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentAccessInfo) {
        var vm = this;

        vm.agentAccessInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentAccessInfo.id !== null) {
                AgentAccessInfo.update(vm.agentAccessInfo, onSaveSuccess, onSaveError);
            } else {
                AgentAccessInfo.save(vm.agentAccessInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentAccessInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoDetailController', AgentAccessInfoDetailController);

    AgentAccessInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentAccessInfo'];

    function AgentAccessInfoDetailController($scope, $rootScope, $stateParams, entity, AgentAccessInfo) {
        var vm = this;

        vm.agentAccessInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentAccessInfoUpdate', function (event, result) {
            vm.agentAccessInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoDeleteController', AgentAccessInfoDeleteController);

    AgentAccessInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentAccessInfo'];

    function AgentAccessInfoDeleteController($uibModalInstance, entity, AgentAccessInfo) {
        var vm = this;

        vm.agentAccessInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentAccessInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-access-info', {
                parent: 'entity',
                url: '/agent-access-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentAccessInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-access-info/agent-access-infos.html',
                        controller: 'AgentAccessInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentAccessInfo');
                        $translatePartialLoader.addPart('agentAccessType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-access-info-detail', {
                parent: 'entity',
                url: '/agent-access-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentAccessInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-detail.html',
                        controller: 'AgentAccessInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentAccessInfo');
                        $translatePartialLoader.addPart('agentAccessType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentAccessInfo', function ($stateParams, AgentAccessInfo) {
                        return AgentAccessInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-access-info.new', {
                parent: 'agent-access-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-dialog.html',
                        controller: 'AgentAccessInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accessType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-access-info', null, {reload: true});
                    }, function () {
                        $state.go('agent-access-info');
                    });
                }]
            })
            .state('agent-access-info.edit', {
                parent: 'agent-access-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-dialog.html',
                        controller: 'AgentAccessInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentAccessInfo', function (AgentAccessInfo) {
                                return AgentAccessInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-access-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-access-info.delete', {
                parent: 'agent-access-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/agent-access-info-delete-dialog.html',
                        controller: 'AgentAccessInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentAccessInfo', function (AgentAccessInfo) {
                                return AgentAccessInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-access-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentAccessInfo', AgentAccessInfo);

    AgentAccessInfo.$inject = ['$resource'];

    function AgentAccessInfo($resource) {
        var resourceUrl = 'api/agent-access-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AgentAccessInfoSearch', AgentAccessInfoSearch);

    AgentAccessInfoSearch.$inject = ['$resource'];

    function AgentAccessInfoSearch($resource) {
        var resourceUrl = 'api/_search/agent-access-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoController', AgentAccessInfoController);

    AgentAccessInfoController.$inject = ['$scope', '$state', 'AgentAccessInfo', 'AgentAccessInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgentAccessInfoController($scope, $state, AgentAccessInfo, AgentAccessInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                AgentAccessInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AgentAccessInfo.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agentAccessInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActivityTypeInfoDialogController', ActivityTypeInfoDialogController);

    ActivityTypeInfoDialogController.$inject = ['$scope', '$state', 'ActivityTypeInfo', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'SubscriptionPackageCustom', 'CustomerGroupCustom', '$uibModalInstance', 'SubscriptionPackage'];

    function ActivityTypeInfoDialogController($scope, $state, ActivityTypeInfo, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, SubscriptionPackageCustom, CustomerGroupCustom, $uibModalInstance, SubscriptionPackage) {

        var vm = this;
        vm.activityTypeInfo = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.clear = clear;


        initDefault();
        loadAll();

        function initDefault() {
        }

        function loadAll() {
        }


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.activityTypeInfo.id !== null) {
                ActivityTypeInfo.update(vm.activityTypeInfo, onSaveSuccess, onSaveError);
            } else {

                ActivityTypeInfo.save(vm.activityTypeInfo, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:ActivityTypeInfoUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }

        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('activity-type-info', {
                parent: 'entity',
                url: '/activity-type-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.activityTypeInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/activity-type/activity-type-infos.html',
                        controller: 'ActivityTypeInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('activityTypeInfo');
                        $translatePartialLoader.addPart('activityType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('activity-type-info.new', {
                parent: 'activity-type-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/activity-type/activity-type-info-dialog.html',
                        controller: 'ActivityTypeInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    durationDays: null,
                                    chargeFee: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('activity-type-info', null, {reload: true});
                    }, function () {
                        $state.go('activity-type-info');
                    });
                }]
            })
            .state('activity-type-info.edit', {
                parent: 'activity-type-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/activity-type/activity-type-info-dialog.html',
                        controller: 'ActivityTypeInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ActivityTypeInfo', function (ActivityTypeInfo) {
                                return ActivityTypeInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('activity-type-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
        // .state('activity-type-info.delete', {
        //     parent: 'activity-type-info',
        //     url: '/{id}/delete',
        //     data: {
        //         authorities: ['ROLE_USER']
        //     },
        //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        //         $uibModal.open({
        //             templateUrl: 'app/entities/activity-type/activity-type-info-delete-dialog.html',
        //             controller: 'activityTypeInfoDeleteController',
        //             controllerAs: 'vm',
        //             size: 'md',
        //             resolve: {
        //                 entity: ['activityTypeInfo', function(activityTypeInfo) {
        //                     return activityTypeInfo.get({id : $stateParams.id}).$promise;
        //                 }]
        //             }
        //         }).result.then(function() {
        //             $state.go('activity-type-info', null, { reload: true });
        //         }, function() {
        //             $state.go('^');
        //         });
        //     }]
        // });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ActivityTypeInfoSearch', ActivityTypeInfoSearch);

    ActivityTypeInfoSearch.$inject = ['$resource'];

    function ActivityTypeInfoSearch($resource) {
        var resourceUrl = 'api/_search/activity-type-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActivityTypeInfoController', ActivityTypeInfoController);

    ActivityTypeInfoController.$inject = ['$scope', '$state', 'ActivityTypeInfo', 'ActivityTypeInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ActivityTypeInfoController($scope, $state, ActivityTypeInfo, ActivityTypeInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                ActivityTypeInfoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ActivityTypeInfoSearch.query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.activityTypeInfos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ActivityTypeInfoCustom', ActivityTypeInfoCustom);

    ActivityTypeInfoCustom.$inject = ['$resource'];

    function ActivityTypeInfoCustom($resource) {


        var getActivityTypeInfoByType = function (type) {

            var resourceUrl = 'api/get-activity-type-info-by-type?type=' + type;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getActivityTypeInfoByCurrentCompany = function () {

            var resourceUrl = 'api/get-activity-type-info-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getAllActivityTypeInfos = function () {

            var resourceUrl = 'api/get-all-activity-type-infos';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getActivityTypeInfoByType: getActivityTypeInfoByType,
            getActivityTypeInfoByCurrentCompany: getActivityTypeInfoByCurrentCompany,
            getAllActivityTypeInfos: getAllActivityTypeInfos

        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ActivityTypeInfo', ActivityTypeInfo);

    ActivityTypeInfo.$inject = ['$resource'];

    function ActivityTypeInfo($resource) {
        var resourceUrl = 'api/activity-type-infos/:id';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccountClearingRequestsV2Controller', AccountClearingRequestsV2Controller);

    AccountClearingRequestsV2Controller.$inject = ['$scope', '$state', 'AccountClearingRequestCustom'];

    function AccountClearingRequestsV2Controller($scope, $state, AccountClearingRequestCustom) {
        var vm = this;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;

        loadAll();

        function loadAll() {
            AccountClearingRequestCustom.getAllClearanceRequests().query().$promise.then(function (result) {

                vm.accountClearingRequests = result;
            });
        }

        function findStatusStyle(status) {
            return "account-clearing-request-status-" + status;
        }

        function findStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-hourglass";
            }
            if (status == "DONE") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "UNDERWAY") {
                return "glyphicon glyphicon-eye-open";
            }

        }


    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('AccountClearingRequestDialogController', AccountClearingRequestDialogController);
//
//    AccountClearingRequestDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AccountClearingRequest', 'Company'];
//
//    function AccountClearingRequestDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AccountClearingRequest, Company) {
//        var vm = this;
//
//        vm.accountClearingRequest = entity;
//        vm.clear = clear;
//        vm.datePickerOpenStatus = {};
//        vm.openCalendar = openCalendar;
//        vm.save = save;
//        vm.companies = Company.query();
//
//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function save () {
//            vm.isSaving = true;
//            if (vm.accountClearingRequest.id !== null) {
//                AccountClearingRequest.update(vm.accountClearingRequest, onSaveSuccess, onSaveError);
//            } else {
//                AccountClearingRequest.save(vm.accountClearingRequest, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('tikonApp:accountClearingRequestUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }
//
//        vm.datePickerOpenStatus.createDate = false;
//        vm.datePickerOpenStatus.fromDate = false;
//        vm.datePickerOpenStatus.toDate = false;
//
//        function openCalendar (date) {
//            vm.datePickerOpenStatus[date] = true;
//        }
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccountClearingRequestDetailController', AccountClearingRequestDetailController);

    AccountClearingRequestDetailController.$inject = ['$stateParams', 'AccountClearingRequest', 'CompanyPaymentLogCustom'];

    function AccountClearingRequestDetailController($stateParams, AccountClearingRequest, CompanyPaymentLogCustom) {
        var vm = this;
        vm.accountClearingRequest = null;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;

        loadData();

        function loadData() {
            AccountClearingRequest.get({id: $stateParams.id}).$promise.then(function (result) {

                vm.accountClearingRequest = result;
            });

            vm.companyPaymentLogs = CompanyPaymentLogCustom.getCompanyPaymentLogsByAccountClearingRequestId($stateParams.id).query(function (result) {
                vm.companyPaymentLogs = result;
            });

        }


        function findStatusStyle(status) {
            return "account-clearing-request-status-" + status;
        }

        function findStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-hourglass";
            }
            if (status == "DONE") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "UNDERWAY") {
                return "glyphicon glyphicon-eye-open";
            }

        }


    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .controller('AccountClearingRequestDeleteController',AccountClearingRequestDeleteController);
//
//    AccountClearingRequestDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccountClearingRequest'];
//
//    function AccountClearingRequestDeleteController($uibModalInstance, entity, AccountClearingRequest) {
//        var vm = this;
//
//        vm.accountClearingRequest = entity;
//        vm.clear = clear;
//        vm.confirmDelete = confirmDelete;
//
//        function clear () {
//            $uibModalInstance.dismiss('cancel');
//        }
//
//        function confirmDelete (id) {
//            AccountClearingRequest.delete({id: id},
//                function () {
//                    $uibModalInstance.close(true);
//                });
//        }
//    }
//})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AccountClearingRequestCustom', AccountClearingRequestCustom);

    AccountClearingRequestCustom.$inject = ['$resource'];

    function AccountClearingRequestCustom($resource) {


        var getActiveCompanyAccountClearingRequest = function () {
            var resourceUrl = 'api/get-active-company-account-clearing-request';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var createNewAccountClearingRequest = function () {
            var resourceUrl = 'api/create-new-account-clearing-request';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getAllClearanceRequests = function () {
            var resourceUrl = 'api/get-all-clearance-requests';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getActiveCompanyAccountClearingRequest: getActiveCompanyAccountClearingRequest,
            createNewAccountClearingRequest: createNewAccountClearingRequest,
            getAllClearanceRequests: getAllClearanceRequests
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('account-clearing-request', {
                parent: 'entity',
                url: '/account-clearing-request?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-requests.html',
                        controller: 'AccountClearingRequestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('account-clearing-request-detail', {
                parent: 'entity',
                url: '/account-clearing-request/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail.html',
                        controller: 'AccountClearingRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AccountClearingRequest', function ($stateParams, AccountClearingRequest) {
                        return AccountClearingRequest.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('account-clearing-request.new', {
                parent: 'account-clearing-request',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-dialog.html',
                        controller: 'AccountClearingRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    fromDate: null,
                                    toDate: null,
                                    totalPaymentAmount: null,
                                    totalWageFeeAmount: null,
                                    status: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('account-clearing-request', null, {reload: true});
                    }, function () {
                        $state.go('account-clearing-request');
                    });
                }]
            })
            .state('account-clearing-request.edit', {
                parent: 'account-clearing-request',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-dialog.html',
                        controller: 'AccountClearingRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AccountClearingRequest', function (AccountClearingRequest) {
                                return AccountClearingRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('account-clearing-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('account-clearing-request.delete', {
                parent: 'account-clearing-request',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-delete-dialog.html',
                        controller: 'AccountClearingRequestDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AccountClearingRequest', function (AccountClearingRequest) {
                                return AccountClearingRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('account-clearing-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AccountClearingRequest', AccountClearingRequest);

    AccountClearingRequest.$inject = ['$resource', 'DateUtils'];

    function AccountClearingRequest($resource, DateUtils) {
        var resourceUrl = 'api/account-clearing-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.toDate = DateUtils.convertDateTimeFromServer(data.toDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('tikonApp')
//        .factory('AccountClearingRequestSearch', AccountClearingRequestSearch);
//
//    AccountClearingRequestSearch.$inject = ['$resource'];
//
//    function AccountClearingRequestSearch($resource) {
//        var resourceUrl =  'api/_search/account-clearing-requests/:id';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true}
//        });
//    }
//})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccountClearingRequestListController', AccountClearingRequestListController);

    AccountClearingRequestListController.$inject = ['$scope', '$state', 'AccountClearingRequestCustom'];

    function AccountClearingRequestListController($scope, $state, AccountClearingRequestCustom) {
        var vm = this;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;

        loadAll();

        function loadAll() {
            AccountClearingRequestCustom.getAllClearanceRequests().query().$promise.then(function (result) {

                vm.accountClearingRequests = result;
            });
        }

        function findStatusStyle(status) {
            return "account-clearing-request-status-" + status;
        }

        function findStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-hourglass";
            }
            if (status == "DONE") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "UNDERWAY") {
                return "glyphicon glyphicon-eye-open";
            }

        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingController', SettingController);

    SettingController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', "CompanyInfoQuery", "ServiceItemCustom", "$translatePartialLoader", "$translate", "ServiceCategoryCustom"];

    function SettingController(__config, $scope, $state, ParseLinks, AlertService, CompanyCustomerCustom, CompanyInfoQuery, ServiceItemCustom, translatePartialLoader, translate, ServiceCategoryCustom) {
        var vm = this;
        vm.__config = __config;
        vm.settingFormSection = '';
        vm.setFormSection = setFormSection;

        function setFormSection(p) {
            vm.settingFormSection = p;
        }
    }
})();

;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ReportService', ReportService);

    ReportService.$inject = ['$resource'];

    function ReportService($resource) {
        var getSalesCountReportOfCurrentCompany = function () {
            var resourceUrl = 'api/getSalesCountReportOfCurrentCompany';
            return $resource(resourceUrl);
        }

        return {

            getSalesCountReportOfCurrentCompany: getSalesCountReportOfCurrentCompany
        };


    }
})();
;
(function () {
    'use strict';

    function SalesCountController($uibModal, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ReportService) {
        var $ctrl = this;
        $ctrl.labels = [];
        $ctrl.series = ['تعداد'];
        $ctrl.data = [
            // [42, 17, 28, 73, 50, 12, 68]
        ];

        $ctrl.weekStartDate = '';
        $ctrl.weekEndDate = '';
        $ctrl.lastWeekReserveNumber = 0;
        $ctrl.lastMonthReserveNumber = 0;

        var s1 = [];
        $ctrl.chartData = ReportService.getSalesCountReportOfCurrentCompany().get(function (chartData) {

            if (chartData)

                var item = [];

            angular.forEach(chartData.data, function (item) {
                $ctrl.lastMonthReserveNumber += +item.value;

                $ctrl.labels.push(item.label);
                s1.push(item.value);
            })

            for (var i = 25; i <= 31; i++) {
                if (chartData.data[i]) {
                    item = chartData.data[i];
                    // $ctrl.labels.push(item.label);
                    // s1.push(item.value);

                    $ctrl.lastWeekReserveNumber += +item.value;

                }
            }


            if (chartData.data[31]) {


                $ctrl.weekStartDate = chartData.data[25].label;
                $ctrl.weekEndDate = chartData.data[31].label;
            } else {


                $ctrl.weekStartDate = chartData.data[24].label;
                $ctrl.weekEndDate = chartData.data[chartData.data.length - 1].label;
            }


            $scope.$emit('weekInfo', $ctrl.lastWeekReserveNumber, $ctrl.lastMonthReserveNumber, $ctrl.weekStartDate, $ctrl.weekEndDate); // going up to parent!

            $ctrl.data.push(s1);

        });

        $ctrl.onClick = function (points, evt) {
            //console.log(points, evt);
        };
        $ctrl.datasetOverride = [{yAxisID: 'y-axis-1'}, {yAxisID: 'y-axis-2'}];
        $ctrl.options = {
            title: {
                display: true,
                text: 'نمودار فعالیت یک ماه گذشته'
            },
            scales: {
                yAxes: [

                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left',

                        ticks: {
                            beginAtZero: true,
                            userCallback: function (label, index, labels) {
                                // when the floored value is the same as the value we have a whole number
                                if (Math.floor(label) === label) {
                                    return label;
                                }

                            },
                        }
                    }
                ]
            }
        };

    };
    var SalesCountComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/dashboard/sales_report/report.sales_count.template.html',
        controller: SalesCountController,
        bindings:
            {
                date: '=?',
            }

    };
    angular
        .module('tikonApp')
        .component('rpSalesCount', SalesCountComponent);

    SalesCountController.$inject = ['$uibModal', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ReportService'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MainDashboardV2Controller', MainDashboardV2Controller);

    MainDashboardV2Controller.$inject = ['__config', '$scope', '$state', '$interval', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'CompanyCustom', 'ServiceItemCustom', '$translatePartialLoader', '$translate', 'ServiceCategoryCustom', 'OrderBagServiceItemCustom', 'NewsCustom', '$uibModal', '$rootScope', 'Principal', 'UserCustom', '$translate', 'ActivityTypeInfoCustom', '$timeout', '$localStorage'];

    function MainDashboardV2Controller(__config, $scope, $state, $interval, ParseLinks, AlertService, CompanyCustomerCustom, CompanyCustom, ServiceItemCustom, translatePartialLoader, translate, ServiceCategoryCustom, OrderBagServiceItemCustom, NewsCustom, $uibModal, $rootScope, Principal, UserCustom, $translate, ActivityTypeInfoCustom, $timeout, $localStorage) {
        var vm = this;

        vm.loadPage = loadPage;
        // vm.nextReserveNumber_Func = nextReserveNumber_Func;
        vm.lengthChecker = lengthChecker;
        vm.fadingNumbers = fadingNumbers;

        vm.companyInfoStatus = false;
        vm.companyWorkingTimeStatus = false;
        vm.companySettingStatus = false;
        vm.initialCheck = null;
        vm.lastWeekReserveNumber = 0;
        vm.lastMonthReserveNumber = 0;
        vm.nextReserveNumber = 0;
        vm.tomorrowReserveCount = 0;
        vm.totalReservesNumber = 0;
        vm.numberOfReservesTitlesCompleted = 0;
        vm.time = 0;
        vm.timeNew = '';
        vm.tomorrowPeopleCount = 0;
        vm.appMode = __config.appMode;
        vm.slideIndex = 0;
        vm.showSlides = showSlides;
        vm.getNewsTagClass = getNewsTagClass;
        vm.openNewsUrl = openNewsUrl;
        vm.prevNews = prevNews;
        vm.nextNews = nextNews;


        vm.mode = 'PurchasedUser'; // OnBoarding - FreeUser - PurchasedUser
        vm.onStepClick = onStepClick;
        vm.wizardSteps = [];
        vm.companyWizardSteps = null;
        vm.openInfoDialog = openInfoDialog;
        vm.callSupport = callSupport;
        vm.getStepNumberClass = getStepNumberClass;
        vm.getStepTextClass = getStepTextClass;
        vm.editReserve = editReserve;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.skipWizard = skipWizard;
        vm.sendMsgToSupport = sendMsgToSupport;
        vm.isNativeApp = null;


        loadAll();

        function loadAll() {
            loadCompanyInfo();
            getCurrentPersonInfo();
            setInterval(function () {
                showNextHighPriorityNews()
            }, 20000);
        }

        function fillSteps() {

            vm.wizardSteps = [];
            var step1 = {};
            var step2 = {};
            var step3 = {};
            var step4 = {};
            var step5 = {};
            var step6 = {};


            step1.id = 1;
            step1.title = "اضافه کردن خدمات جدید";
            step1.type = "ADD_SERVICE";
            step1.status = "IN_PROGRESS";

            vm.wizardSteps.push(step1);

            step2.id = 2;
            step2.title = "تغییر عکس، رنگ و لوگو سایت شما";
            step2.type = "CHANGE_THEME";
            step2.status = "IN_PROGRESS";
            vm.wizardSteps.push(step2);

            step3.id = 3;
            if (vm.activityTypeInfo && vm.activityTypeInfo.servantType == 'RESOURCE')
                step3.title = "اضافه کردن منابع" + "(" + vm.activityTypeInfo.servantTitle + ") جدید";
            else
                step3.title = "اضافه کردن پرسنل" + "(" + vm.activityTypeInfo.servantTitle + ") جدید";


            step3.type = "ADD_SERVANT";
            step3.status = "IN_PROGRESS";
            vm.wizardSteps.push(step3);

            step4.id = 4;
            step4.title = "تغییر ساعت کاری";
            step4.type = "CHANGE_COMPANY_SCHEDULE";
            step4.status = "IN_PROGRESS";
            vm.wizardSteps.push(step4);

            step5.id = 5;
            step5.title = "اتصال به اینستاگرام";
            step5.type = "CONNECT_INSTAGRAM";
            step5.status = "IN_PROGRESS";
            vm.wizardSteps.push(step5);

            step6.id = 6;
            step6.title = "ثبت اولین رزرو(نوبت) برای مشتری";
            step6.type = "ADD_RESERVE";
            step6.status = "IN_PROGRESS";
            vm.wizardSteps.push(step6);

            vm.activeStepId = 0;
            angular.forEach(vm.wizardSteps, function (item) {
                angular.forEach(vm.companyWizardSteps, function (wStep) {
                    if (item.type == wStep.wizardStepType)
                        item.status = "DONE";
                })
            })

            angular.forEach(vm.wizardSteps, function (item) {
                if (item.status != "DONE" && vm.activeStepId == 0) {
                    vm.activeStepId = item.id;
                }
            })

        }

        function loadPage(page) {

        }

        function loadCompanyInfo() {
            CompanyCustom.getCurrentCompany().get(function (company) {
                vm.company = company;
                ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.company.activityType).query(function (activity) {
                    vm.activityTypeInfo = activity;
                    fillSteps();
                })
                getCompanyOnBoardingMode();


            })
        }

        function getCompanyOnBoardingMode() {
            CompanyCustom.getCurrentCompanyOnBoardingMode().get(function (result) {
                if (result)
                    vm.mode = result.mode;

                getActiveNews();
                loadReserveList();
                loadReserveStats();
                $interval(showSlides, 30000); // Change image every 20 seconds


                if (vm.mode == "OnBoarding") {
                    getCurrentCompanyWizardSteps();
                }

            })
        }

        function getCurrentCompanyWizardSteps() {
            CompanyCustom.getCurrentCompanyWizardSteps().query().$promise.then(function (wizardSteps) {
                if (wizardSteps)
                    vm.companyWizardSteps = wizardSteps;
                fillSteps();
            })
        }

        function lengthChecker(num) {
            if (num > 0 && num <= 10) {
                vm.time = 100;
            } else if (num > 10 && num <= 100) {
                vm.time = 20
            } else if (num > 100 && num <= 200) {
                vm.time = 15
            } else if (num > 200 && num <= 500) {
                vm.time = 10
            } else if (num > 500 && num <= 1000) {
                vm.time = 5
            } else if (num > 1000) {
                vm.time = 1
            }
        }

        function fadingNumbers() {
            if (vm.numberOfReservesTitlesCompleted === 4) {
                for (var i = 1; i <= 6; i++) {
                    $('#lastWeekReserveNumber').fadeToggle();
                    $('#lastMonthReserveNumber').fadeToggle();
                    $('#totalReservesNumber').fadeToggle();
                    // $('#nextReserveNumber').fadeToggle();
                    $('#tomorrowReserveNumber').fadeToggle();
                }
            }
        }


        function getActiveNews() {


            vm.highPriorityNews = [];
            vm.news = [];
            vm.activeHighPriorityNews = null;

            NewsCustom.getActiveNewsByCurrentCompany().query().$promise.then(function (news) {

                    if (news) {
                        if (news.length > 0) {
                            var i = 0;
                            var j = 0;
                            angular.forEach(news, function (newsItem) {


                                if (newsItem.newsType == "WARNING" || newsItem.newsType == "NEW_FEATURE" || newsItem.newsType == "SPECIAL_OFFER") {
                                    newsItem.index = j;
                                    j++;
                                    vm.highPriorityNews.push(newsItem);
                                } else {
                                    newsItem.index = i;
                                    i++;
                                    vm.news.push(newsItem);
                                }

                                showNextHighPriorityNews();

                            });

                            if (vm.news && vm.news.length > 0)
                                vm.activeNews = vm.news[0];

                            // showSlides();
                        }
                    }

                }
            );
        }

        function showSlides() {
            vm.slideIndex++;
            if (vm.slideIndex == vm.news.length) {
                vm.slideIndex = 0
            }
            // vm.activeNews = vm.news[vm.slideIndex];

            angular.forEach(vm.news, function (item) {
                if (item.index == vm.slideIndex) {
                    item.cssClass = 'show-slide'
                    vm.activeNews = item;
                } else {
                    item.cssClass = 'hide-slide'
                }
            });


        }

        function showNextHighPriorityNews() {

            if (!vm.highPriorityNews || vm.highPriorityNews.length == 0)
                return;

            if (!vm.activeHighPriorityNews || vm.highPriorityNews.length == 1) {
                vm.activeHighPriorityNews = vm.highPriorityNews[0];
                return;
            }

            var next = vm.activeHighPriorityNews.index + 1;
            if (next >= vm.highPriorityNews.length)
                next = 0;

            vm.activeHighPriorityNews = vm.highPriorityNews[next];

        }


        function getNewsTagClass(news) {
            if (news && news.newsType) {
                switch (news.newsType) {
                    case 'INFO':
                        return 'news-INFO';
                    case 'HELP':
                        return 'news-HELP';
                    case 'WARNING':
                        return 'news-WARNING';
                    case 'EXPERT_HELP':
                        return 'news-EXPERT_HELP';
                    case 'NEW_FEATURE':
                        return 'news-NEW_FEATURE';
                    case 'SPECIAL_OFFER':
                        return 'news-SPECIAL_OFFER';

                }
            }
        }

        function openNewsUrl(news) {
            if (news && news.actionUrl) {
                window.open(news.actionUrl, '_blank');
            }

        }

        function prevNews() {
            vm.slideIndex--;
            if (vm.slideIndex == -1 && vm.news && vm.news.length > 0) {
                vm.slideIndex = vm.news.length - 1;
            }
            vm.slideIndex--;
            showSlides();
        }

        function nextNews() {
            vm.slideIndex++;
            if (vm.news && vm.news.length == vm.slideIndex) {
                vm.slideIndex = 0;
            }

            showSlides();
        }


        function loadReserveStats() {
            OrderBagServiceItemCustom.getReserveStats().query(function (reserve) {

                vm.tomorrowPeopleCount = reserve.tomorrowPeopleCount;

                setTimeout(function () {
                    $("#analogClock_container").animate({left: "0"});
                }, 1000);

                lengthChecker(reserve.weeklyReserveCount);
                if (reserve.weeklyReserveCount !== 0) {
                    if (reserve.weeklyReserveCount > 10)
                        vm.lastWeekReserveNumber += reserve.weeklyReserveCount - 10;
                    var setInterval = $interval(function myTimer() {


                        if (vm.lastWeekReserveNumber === reserve.weeklyReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }
//////------------

                lengthChecker(reserve.monthlyReserveCount);

                if (reserve.monthlyReserveCount !== 0) {
                    if (reserve.monthlyReserveCount > 10)
                        vm.lastMonthReserveNumber = reserve.monthlyReserveCount - 10;
                    var setInterval2 = $interval(function myTimer() {
                        vm.lastMonthReserveNumber += 1;
                        if (vm.lastMonthReserveNumber === reserve.monthlyReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval2);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }
//////----------

                lengthChecker(reserve.totalReserveCount);
                if (reserve.totalReserveCount !== 0) {
                    if (reserve.totalReserveCount > 10)
                        vm.totalReservesNumber = reserve.totalReserveCount - 10;
                    var setInterval3 = $interval(function myTimer() {

                        vm.totalReservesNumber += 1;
                        if (vm.totalReservesNumber === reserve.totalReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval3);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }
//////----------

                // lengthChecker(reserve.totalReserveCount);
                // if(reserve.activeReserveCount !== 0) {
                //     if(reserve.activeReserveCount>10)
                //         vm.nextReserveNumber = reserve.activeReserveCount-10;
                //     var setInterval4 = $interval(function myTimer() {
                //
                //         vm.nextReserveNumber += 1;
                //         if (vm.nextReserveNumber === reserve.activeReserveCount) {
                //             vm.numberOfReservesTitlesCompleted += 1;
                //             fadingNumbers();
                //             $interval.cancel(setInterval4);
                //         }
                //
                //     }, vm.time);
                // } else {
                //     vm.numberOfReservesTitlesCompleted += 1;
                // }


//////----------

                lengthChecker(reserve.tomorrowReserveCount);
                if (reserve.tomorrowReserveCount !== 0) {
                    if (reserve.tomorrowReserveCount > 10)
                        vm.tomorrowReserveCount = reserve.tomorrowReserveCount - 10;
                    var setInterval5 = $interval(function myTimer() {

                        vm.tomorrowReserveCount += 1;
                        if (vm.tomorrowReserveCount === reserve.tomorrowReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval5);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }


            });
        }

        function loadReserveList() {
            vm.orderBagServiceItems = [];
            var filter = {};
            filter.maxResult = 10;
            OrderBagServiceItemCustom.searchOrderBagItemsByQuery().save(filter, function (data) {
                vm.orderBagServiceItems = data;

            });

        }

        function onStepClick(step) {

            openInfoDialog(step.type);
            // setStepDone(step);

        }


        function openInfoDialog(type) {
            $uibModal.open({
                templateUrl: 'app/dashboard/company-wizard-step/company-wizard-step.html',
                controller: 'CompanyWizardStepController',
                controllerAs: 'vm',
                // backdrop: 'static',
                size: 'sm',
                windowClass: 'pl-modal-sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            wizardStepType: type,
                            activityTypeInfo: vm.activityTypeInfo
                        };
                    }
                }
            }).result.then(function () {
                getCompanyOnBoardingMode();
            }, function () {

            });

        }

        function getStepNumberClass(step) {
            if (vm.activeStepId == 0)
                return '';
            if (vm.activeStepId == step.id)
                return 'animation-pulsate-fwd step-item-number-active';

        }

        function getStepTextClass(step) {
            if (step.status == 'DONE')
                return 'step-text-done';
        }

        function callSupport() {
            window.open('tel:02191690817');
        }

        function getCurrentPersonInfo() {
            if (Principal.isAuthenticated()) {
                UserCustom.getCurrentUserProfile().query(function (up) {
                    vm.userProfile = up;
                });
            }
        }

        function editReserve(orderBagServiceItem) {
            $state.go('supplierPanel-v2.editOrderBag', {id: orderBagServiceItem.orderBag.id})
        }


        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function skipWizard() {
            CompanyCustom.skipCompanyWizardSteps().save(null, onSkipSuccess, onSkipError);
        }

        function onSkipSuccess(result) {
            getCompanyOnBoardingMode();
        }

        function onSkipError() {

        }

        function sendMsgToSupport() {
            Goftino.toggle();
        }
         $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp
        },10)

    }
})();


;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MainDashboardController', MainDashboardController);

    MainDashboardController.$inject = ['__config', '$scope', '$state', '$interval', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'CompanyInfoQuery', 'ServiceItemCustom', '$translatePartialLoader', '$translate', 'ServiceCategoryCustom', 'OrderBagServiceItemCustom', 'NewsCustom'];

    function MainDashboardController(__config, $scope, $state, $interval, ParseLinks, AlertService, CompanyCustomerCustom, CompanyInfoQuery, ServiceItemCustom, translatePartialLoader, translate, ServiceCategoryCustom, OrderBagServiceItemCustom, NewsCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        // vm.nextReserveNumber_Func = nextReserveNumber_Func;
        vm.lengthChecker = lengthChecker;
        vm.fadingNumbers = fadingNumbers;

        vm.gotoNewReserve = gotoNewReserve;
        vm.gotoWebSite = gotoWebSite;

        vm.companyInfoStatus = false;
        vm.companyWorkingTimeStatus = false;
        vm.companySettingStatus = false;
        vm.initialCheck = null;
        vm.lastWeekReserveNumber = 0;
        vm.lastMonthReserveNumber = 0;
        vm.nextReserveNumber = 0;
        vm.tomorrowReserveCount = 0;
        vm.totalReservesNumber = 0;
        vm.numberOfReservesTitlesCompleted = 0;
        vm.time = 0;
        vm.timeNew = '';
        vm.tomorrowPeopleCount = 0;
        vm.appMode = __config.appMode;
        vm.goToEventState = goToEventState;
        vm.slideIndex = 0;
        vm.showSlides = showSlides;
        vm.getNewsTagClass = getNewsTagClass;
        vm.openNewsUrl = openNewsUrl;
        vm.prevNews = prevNews;
        vm.nextNews = nextNews;

///////////////Numbers Start//////////

        OrderBagServiceItemCustom.getReserveStats().query(function (reserve) {

            vm.tomorrowPeopleCount = reserve.tomorrowPeopleCount;

            setTimeout(function () {
                $("#analogClock_container").animate({left: "0"});
            }, 1000);

            lengthChecker(reserve.weeklyReserveCount);
            if (reserve.weeklyReserveCount !== 0) {
                if (reserve.weeklyReserveCount > 10)
                    vm.lastWeekReserveNumber += reserve.weeklyReserveCount - 10;
                var setInterval = $interval(function myTimer() {


                    if (vm.lastWeekReserveNumber === reserve.weeklyReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }
//////------------

            lengthChecker(reserve.monthlyReserveCount);

            if (reserve.monthlyReserveCount !== 0) {
                if (reserve.monthlyReserveCount > 10)
                    vm.lastMonthReserveNumber = reserve.monthlyReserveCount - 10;
                var setInterval2 = $interval(function myTimer() {
                    vm.lastMonthReserveNumber += 1;
                    if (vm.lastMonthReserveNumber === reserve.monthlyReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval2);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }
//////----------

            lengthChecker(reserve.totalReserveCount);
            if (reserve.totalReserveCount !== 0) {
                if (reserve.totalReserveCount > 10)
                    vm.totalReservesNumber = reserve.totalReserveCount - 10;
                var setInterval3 = $interval(function myTimer() {

                    vm.totalReservesNumber += 1;
                    if (vm.totalReservesNumber === reserve.totalReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval3);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }
//////----------

            // lengthChecker(reserve.totalReserveCount);
            // if(reserve.activeReserveCount !== 0) {
            //     if(reserve.activeReserveCount>10)
            //         vm.nextReserveNumber = reserve.activeReserveCount-10;
            //     var setInterval4 = $interval(function myTimer() {
            //
            //         vm.nextReserveNumber += 1;
            //         if (vm.nextReserveNumber === reserve.activeReserveCount) {
            //             vm.numberOfReservesTitlesCompleted += 1;
            //             fadingNumbers();
            //             $interval.cancel(setInterval4);
            //         }
            //
            //     }, vm.time);
            // } else {
            //     vm.numberOfReservesTitlesCompleted += 1;
            // }


//////----------

            lengthChecker(reserve.tomorrowReserveCount);
            if (reserve.tomorrowReserveCount !== 0) {
                if (reserve.tomorrowReserveCount > 10)
                    vm.tomorrowReserveCount = reserve.tomorrowReserveCount - 10;
                var setInterval5 = $interval(function myTimer() {

                    vm.tomorrowReserveCount += 1;
                    if (vm.tomorrowReserveCount === reserve.tomorrowReserveCount) {
                        vm.numberOfReservesTitlesCompleted += 1;
                        fadingNumbers();
                        $interval.cancel(setInterval5);
                    }

                }, vm.time);
            } else {
                vm.numberOfReservesTitlesCompleted += 1;
            }


        });
///////////////Numbers End//////////


        loadAll();


        function loadAll() {

            vm.orderBagServiceItems = [];

            var filter = {};

            filter.maxResult = 10;
            OrderBagServiceItemCustom.searchOrderBagItemsByQuery().save(filter, function (data) {
                vm.orderBagServiceItems = data;

            });


            loadCompanyInfo();
            isCompanyInfoCompleted();
            getActiveNews();
            $interval(showSlides, 30000); // Change image every 20 seconds
        }

        function loadPage(page) {
        }

        function loadCompanyInfo() {
            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {

                if (company != null && company != undefined) {
                    vm.company = company;
                    if (vm.company && vm.company.keyUrl)
                        vm.websiteUrl = vm.company.keyUrl + '.reserweb.ir';
                    else
                        vm.websiteUrl = '----------------' + '.reserweb.ir';


                } else {
                    vm.websiteUrl = '----------------' + '.reserweb.ir';
                }

            })
        }

        function gotoWebSite() {
            if (vm.company && vm.company.keyUrl) {

                window.open('http://' + vm.websiteUrl, '_blank');
            } else {
                alert('اطلاعات کسب و کار بطور کامل وارد نشده است (قدم اول را انجام دهید)');
            }
        }

        function gotoNewReserve(customerId) {

            var url = $state.href('supplierPanel.orderBagWithCustomerParameter', {
                customerId: customerId
            });

            window.open(url, '_blank');

        }

        function isCompanyInfoCompleted() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (company) {

                    if (company != undefined && company != null) {
                        if (company.title != null && company.title != "" && company.phoneNumber != null && company.phoneNumber != "")
                            vm.companyInfoStatus = true;
                        else
                            vm.companyInfoStatus = false;


                        if (company.setting != undefined && company.setting != null && company.setting.id != null && company.setting.id != undefined)
                            vm.companySettingStatus = true;
                        else
                            vm.companySettingStatus = false;


                    }
                }
            )


        }

        function lengthChecker(num) {
            if (num > 0 && num <= 10) {
                vm.time = 100;
            } else if (num > 10 && num <= 100) {
                vm.time = 20
            } else if (num > 100 && num <= 200) {
                vm.time = 15
            } else if (num > 200 && num <= 500) {
                vm.time = 10
            } else if (num > 500 && num <= 1000) {
                vm.time = 5
            } else if (num > 1000) {
                vm.time = 1
            }
        }

        function fadingNumbers() {
            if (vm.numberOfReservesTitlesCompleted === 4) {
                for (var i = 1; i <= 6; i++) {
                    $('#lastWeekReserveNumber').fadeToggle();
                    $('#lastMonthReserveNumber').fadeToggle();
                    $('#totalReservesNumber').fadeToggle();
                    // $('#nextReserveNumber').fadeToggle();
                    $('#tomorrowReserveNumber').fadeToggle();
                }
            }
        }

        function goToEventState(type) {
            $state.go('supplierPanel.newGeneralEventItem', {
                onlineMeetingType: type
            });
        }

        function getActiveNews() {
            NewsCustom.getActiveNewsByCurrentCompany().query().$promise.then(function (news) {

                    if (news) {
                        vm.news = news;
                        if (vm.news.length > 0) {
                            var i = 0;
                            angular.forEach(vm.news, function (newsItem) {

                                newsItem.index = i;
                                i++

                            });

                            vm.activeNews = vm.news[0];
                            // showSlides();
                        }
                    }

                }
            );
        }


        function showSlides() {
            vm.slideIndex++;
            if (vm.slideIndex == vm.news.length) {
                vm.slideIndex = 0
            }
            // vm.activeNews = vm.news[vm.slideIndex];

            angular.forEach(vm.news, function (item) {
                if (item.index == vm.slideIndex) {
                    item.cssClass = 'show-slide'
                    vm.activeNews = item;
                } else {
                    item.cssClass = 'hide-slide'
                }
            });


        }

        function getNewsTagClass() {
            if (vm.activeNews && vm.activeNews.newsType) {
                switch (vm.activeNews.newsType) {
                    case 'INFO':
                        return 'news-INFO';
                    case 'HELP':
                        return 'news-HELP';
                    case 'WARNING':
                        return 'news-WARNING';
                    case 'EXPERT_HELP':
                        return 'news-EXPERT_HELP';
                    case 'NEW_FEATURE':
                        return 'news-NEW_FEATURE';
                    case 'SPECIAL_OFFER':
                        return 'news-SPECIAL_OFFER';

                }
            }
        }

        function openNewsUrl() {
            if (vm.activeNews && vm.activeNews.actionUrl) {
                window.open(vm.activeNews.actionUrl, '_blank');
            }

        }

        function prevNews() {
            vm.slideIndex--;
            if (vm.slideIndex == -1 && vm.news && vm.news.length > 0) {
                vm.slideIndex = vm.news.length - 1;
            }
            vm.slideIndex--;
            showSlides();
        }

        function nextNews() {
            vm.slideIndex++;
            if (vm.news && vm.news.length == vm.slideIndex) {
                vm.slideIndex = 0;
            }

            showSlides();
        }

    }
})();


;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyWizardStepController', CompanyWizardStepController);

    CompanyWizardStepController.$inject = ['$uibModalInstance', '$window', 'AlertToastService', '__config', 'entity', 'CompanyCustom', '$state'];

    function CompanyWizardStepController($uibModalInstance, $window, AlertToastService, __config, entity, CompanyCustom, $state) {
        var vm = this;
        vm.type = "UNKNOWN";
        if (entity && entity.wizardStepType)
            vm.type = entity.wizardStepType;
        if (entity && entity.activityTypeInfo)
            vm.activityTypeInfo = entity.activityTypeInfo;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.__config = __config;
        vm.buttonText = "بستن";
        vm.title = "";
        vm.state = "dashboard";
        vm.canCancel = false;
        vm.cancel = cancel;
        vm.isWorkingSpace = false;

        if (vm.activityTypeInfo.servantType == 'RESOURCE')
            vm.isWorkingSpace = true;


        loadPage();

        function loadPage() {
            initDefault();
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function initDefault() {
            switch (vm.type) {
                case "ADD_SERVICE":
                    vm.buttonText = "ایجاد خدمت جدید";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "خدمات";
                    vm.state = "supplierPanel-v2.dashboard.newServiceItem";
                    vm.canCancel = true;
                    break;
                case "ADD_SERVANT":
                    if (!vm.isWorkingSpace) {
                        vm.buttonText = "ایجاد پرسنل جدید";
                        vm.cancelButtonText = "متوجه شدم";
                        vm.title = "پرسنل";
                    } else {
                        vm.buttonText = "ایجاد منابع(" + vm.activityTypeInfo.servantTitle + ") جدید";
                        vm.cancelButtonText = "متوجه شدم";
                        vm.title = "منابع";
                    }

                    vm.state = "supplierPanel-v2.dashboard.newCompanyServant";
                    vm.canCancel = true;
                    break;
                case "CHANGE_COMPANY_SCHEDULE":
                    vm.buttonText = "تنظیم ساعت کاری";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "ساعت کاری";
                    vm.state = "supplierPanel-v2.dashboard.companyWorkingTimes";
                    vm.canCancel = true;
                    break;
                case "CHANGE_THEME":
                    vm.buttonText = "تنظیم تصویر و لوگو";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "تصویر و لوگو";
                    vm.state = "supplierPanel-v2.dashboard.companySettingInfo";
                    vm.canCancel = true;
                    break;
                case "CONNECT_INSTAGRAM":
                    vm.buttonText = "متوجه شدم";
                    vm.title = "اینستاگرام";
                    vm.state = "supplierPanel-v2.dashboard";
                    vm.canCancel = false;
                    break;
                case "ADD_RESERVE":
                    vm.buttonText = "ثبت رزرو جدید";
                    vm.cancelButtonText = "متوجه شدم";
                    vm.title = "رزرو جدید";
                    vm.state = "supplierPanel-v2.dashboard.newReserve"
                    vm.canCancel = true;
                    break;
                default:
                    vm.buttonText = "بستن ";
                    vm.title = "نامشخص";
                    break;

            }
        }

        function okModal() {
            setStepDone(vm.type);
        }

        function setStepDone(type) {
            var wizardStep = {};
            if (type) {
                wizardStep.wizardStepType = type;
                CompanyCustom.setCompanyWizardStepsDone().save(wizardStep, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            if (vm.isCanceling) {
                $uibModalInstance.close(vm.type);
                vm.isCanceling = false;
                return;
            }

            if (vm.type != "CHANGE_THEME")
                $state.go(vm.state);
            else
                $state.go(vm.state, {settingFormSection: 'themeSettingTab'});

            $uibModalInstance.close(vm.type);
        }

        function onSaveError(error) {
            if (vm.type != "CHANGE_THEME")
                $state.go(vm.state);
            else
                $state.go(vm.state, {settingFormSection: 'themeSettingTab'});

            closeModal();
        }


        function cancel() {
            vm.isCanceling = true;
            setStepDone(vm.type);
        }


    }
})();
;
(function () {
    'use strict';

    function AnalogClockController($uibModal, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ReportService) {

    };
    var AnalogClockController = {

        templateUrl: 'app/dashboard/analogClock/analogClock.template.html',
        controller: AnalogClockController,
        bindings:
            {
                date: '=?',
            }

    };
    angular
        .module('tikonApp')
        .component('analogClock', AnalogClockController);

    AnalogClockController.$inject = ['$uibModal', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ReportService'];


})();
;
angular.module("tikonApp").factory("TrackingService", [
  "$window",
  "$q",
  "$location",
  "$timeout",
  function ($window, $q, $location, $timeout) {
    var GA_MEASUREMENT_ID = "G-XXXXXXXXXX";

    var STORAGE_KEY = "tikon_tracking_data";

    // function decodeBase64Url(str) {
    //   if (!str) {
    //     return "";
    //   }

    //   var base64 = str.replace(/-/g, "+").replace(/_/g, "/");

    //   while (base64.length % 4) {
    //     base64 += "=";
    //   }

    //   try {
    //     return $window.atob(base64);
    //   } catch (e) {
    //     return "";
    //   }
    // }

    // function extractGclidFromGl(gl) {
    //     if (!gl) {
    //         return "";
    //     }

    //     var parts = gl.split("*");

    //     for (var i = 0; i < parts.length - 1; i++) {
    //         var key = parts[i];
    //         var value = parts[i + 1];

    //         console.log("GL key:", key);
    //         console.log("GL value:", value);

    //         if (key === "gclid" || key === "_gclid") {
    //             var directGclid = decodeBase64Url(value);

    //             console.log("Decoded direct gclid:", directGclid);

    //             return directGclid || value || "";
    //         }

    //         if (key === "_gcl_aw") {
    //             var decoded = decodeBase64Url(value);

    //             console.log("Decoded _gcl_aw:", decoded);

    //             if (decoded) {
    //                 var decodedParts = decoded.split(".");

    //                 console.log("Decoded parts:", decodedParts);

    //                 if (
    //                     decodedParts.length >= 3 &&
    //                     decodedParts[0] === "GCL"
    //                 ) {
    //                     var gclid = decodedParts[decodedParts.length - 1];

    //                     console.log("Extracted gclid from _gcl_aw:", gclid);

    //                     return gclid;
    //                 }
    //             }
    //         }
    //     }

    //     return "";
    // }
    function getUrlParams() {
      var angularParams = $location.search();
      var rawSearch = $window.location.search;
      var nativeParams = {};
      
      if (rawSearch) {
        var queryParts = rawSearch.replace(/^\?/, '').split('&');
        for (var i = 0; i < queryParts.length; i++) {
          var pair = queryParts[i].split('=');
          if (pair.length === 2) {
            try {
              nativeParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            } catch (e) {
              nativeParams[pair[0]] = pair[1];
            }
          }
        }
      }
      var params = angular.extend({}, nativeParams, angularParams);

      return {
        _gl: params._gl || "",
        gclid: params.gclid || "",
        utm_source: params.utm_source || "",
        utm_medium: params.utm_medium || "",
        utm_campaign: params.utm_campaign || "",
        gad_source: params.gad_source || "",
        gad_campaignid: params.gad_campaignid || ""
      };
    }

    function getFromGtag() {

        var result = {
            ga_client_id: "",
            ga_session_id: ""
        };

        if (typeof $window.gtag !== "function") {
            return $q.when(result);
        }

        var deferred = $q.defer();
        var finished = false;

        function finish() {
            if (finished) {
                return;
            }

            finished = true;
            deferred.resolve(result);
        }

        try {

            $window.gtag(
                "get",
                GA_MEASUREMENT_ID,
                "client_id",
                function (clientId) {

                    if (clientId) {
                        result.ga_client_id = clientId;
                    }

                    try {

                        $window.gtag(
                            "get",
                            GA_MEASUREMENT_ID,
                            "session_id",
                            function (sessionId) {

                                if (sessionId) {
                                    result.ga_session_id = sessionId;
                                }

                                finish();
                            }
                        );

                    } catch (e) {
                        console.error("gtag session_id error:", e);
                        finish();
                    }
                }
            );

        } catch (e) {
            console.error("gtag client_id error:", e);
            finish();
        }

        $timeout(function () {
            finish();
        }, 2000);

        return deferred.promise;
    }

    function collect() {
      var deferred = $q.defer();

      var urlData = getUrlParams();

      getFromGtag().then(function (gaData) {
        var trackingData = {
          gaClientId: gaData.ga_client_id || "",
          gaSessionId: gaData.ga_session_id || "",
          gclId: urlData.gclid || "",
          _gl: urlData._gl || "",
          utmSource: urlData.utm_source || "",
          utmMedium: urlData.utm_medium || "",
          utmCampaign: urlData.utm_campaign || "",
          gad_source: urlData.gad_source || "",
          gad_campaignid: urlData.gad_campaignid || ""
        };
        deferred.resolve(trackingData);
      });

      return deferred.promise;
    }

    function save(data) {
      try {
        $window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        // localStorage ممکن است در بعضی شرایط unavailable باشد
      }
    }

    function getSaved() {
      try {
        var value = $window.localStorage.getItem(STORAGE_KEY);

        if (!value) {
          return null;
        }

        return JSON.parse(value);
      } catch (e) {
        return null;
      }
    }

    function clear() {
      try {
        $window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        // ignore
      }
    }

    return {
      collect: collect,
      save: save,
      getSaved: getSaved,
      clear: clear,
    };
  },
]);
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResetPasswordWithSMSController', ResetPasswordWithSMSController);


    ResetPasswordWithSMSController.$inject = ['$translate', '$timeout', 'AuthCustom', 'PasswordCustom', '$state', 'LoginService'];

    function ResetPasswordWithSMSController($translate, $timeout, AuthCustom, PasswordCustom, $state, LoginService) {
        var vm = this;

        vm.formMode = 'Request';
        vm.requestPasswordReset = requestPasswordReset;
        vm.sendActivationCode = sendActivationCode;
        vm.changePasswordReq = {};
        vm.login = LoginService.open;

        function requestPasswordReset() {
            if (vm.changePasswordReq != null && vm.changePasswordReq.password != null)
                PasswordCustom.requestPasswordByPhoneNumber().save(vm.changePasswordReq, saveSuccess, saveError);
        }

        function saveSuccess(result) {
            vm.formMode = 'Done'
        }

        function saveError() {

        }

        function sendActivationCode() {
            if (vm.changePasswordReq.phoneNumber != null && vm.changePasswordReq.phoneNumber != undefined)
                AuthCustom.sendActivationCode(vm.changePasswordReq.phoneNumber).get(onSuccess);
        }

        function onSuccess() {
            vm.formMode = 'Activate'
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('createUserAccount', {
                parent: 'app',
                url: '/createUserAccount?referralCode',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/createUserAccount/create-user-account.html',
                        controller: 'CreateUserAccountController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                }
            })
            .state('activeUserAccount', {
                parent: 'app',
                url: '/activeUserAccount/{userName}',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/createUserAccount/activate-user.html',
                        controller: 'ActiveUserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UserCustom', function ($stateParams, UserCustom) {

                        return ($stateParams.userName);
                    }]
                }
            })
            .state('resetPasswordByPhoneNumber', {
                parent: 'app',
                url: '/resetPasswordByPhoneNumber',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/createUserAccount/reset-password-with-sms.html',
                        controller: 'ResetPasswordWithSMSController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('password');

                        return $translate.refresh();
                    }]
                }
            })

        ;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CreateUserAccountController', CreateUserAccountController);


    CreateUserAccountController.$inject = ['$rootScope', '__config', '$translate', '$timeout', 'Auth', 'LoginService', 'PersonInfo', '$state', '$element', 'OrderBagCustom', 'User','UserCustom', '$localStorage', 'TrackingService', 'Marketing'];

    function CreateUserAccountController($rootScope, __config, $translate, $timeout, Auth, LoginService, PersonInfo, $state, $element, OrderBagCustom, User,UserCustom, $localStorage, TrackingService, Marketing) {
        var vm = this;
        vm.isSaving = false;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.activatedSuccess = null;
        vm.activateUser = activateUser;
        vm.submited = submited;
        vm.formMode = 'REGISTER';
        vm.errorPhoneNumberExists = null;
        vm.regenerateActivationKey = regenerateActivationKey;
        vm.activatedSuccess = null;
        vm.regenerateSuccess = null;
        vm.showError = false;
        vm.findImageClass = findImageClass;
        vm.__config = __config;
        vm.questions = {
            findUsOtherWayDesc: "",
            howDidYouFindUs: "",
        }
        vm.howDidYouFindUsOptions = [
            {
                name: 'جستجو در گوگل',
                value: 'GOOGLE_SEARCH'
            },
             {
                name: 'شبکه های اجتماعی',
                value: 'SOCIAL_NETWORKS'
            },
             {
                name: 'پیامک',
                value: 'SMS'
            },
            {
                name: 'دوستان',
                value: 'FRIENDS'
            },
            {
                name: 'chatgpt ',
                value: 'CHATGPT'
            },
            {
                name: 'سایر',
                value: 'OTHER'
            },
        ]

        vm.referralCode = null;
        // $rootScope.$broadcast('hideNavBar');
        checkUserIsLoggedIn()
        initTracking()
        if ($state && $state.params && $state.params.referralCode) {
            vm.referralCode = $state.params.referralCode;
        }

        $timeout(function () {
            angular.element('#login').focus();
        });

        function submited(formName) {
            vm.showError = false;
            // not register yet
            if (vm.formMode == 'REGISTER') {
                if (formName.$invalid) {
                    vm.showError = true;
                    return;
                }
                register();
            }
            if (vm.formMode == 'ACTIVEUSER') {
                activateUser();
            }

        }

        function register() {
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.errorPhoneNumberExists = null;

            vm.registerAccount.login = vm.registerAccount.phoneNumber;

            vm.isSaving = true;
            Auth.sendActivationCode(vm.registerAccount.login).get(function () {
                vm.isSaving = false;
                vm.success = 'OK';
                vm.formMode = 'ACTIVEUSER';
                vm.resetTimer();

            }, function (response) {

                if (response.status === 400 && response.data === 'login_already_in_use') {
                    vm.errorPhoneNumberExists = 'ERROR';
                } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
                    vm.errorEmailExists = 'ERROR';
                } else if (response.status === 400 && response.data === 'PhoneNumber_already_in_use') {
                    vm.errorPhoneNumberExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
                vm.isSaving = false;
            })
            //Auth.createAccount(vm.registerAccount).then(function () {
            //    //
            //    vm.success = 'OK';
            //    vm.formMode = 'ACTIVEUSER';
            //    vm.resetTimer();
            //
            //}).catch(function (response) {
            //    vm.success = null;
            //    if (response.status === 400 && response.data === 'login_already_in_use') {
            //        vm.errorPhoneNumberExists = 'ERROR';
            //    } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
            //        vm.errorEmailExists = 'ERROR';
            //    } else if (response.status === 400 && response.data === 'PhoneNumber_already_in_use') {
            //        vm.errorPhoneNumberExists = 'ERROR';
            //    } else {
            //        vm.error = 'ERROR';
            //    }
            //
            //
            //});

        }

        vm.counter = 60;
        var stopped;
        vm.onCounterEnded = onCounterEnded;
        vm.resetTimer = resetTimer;
        vm.counterIsEnded = false;
        vm.countdown = function () {
            stopped = $timeout(function () {

                vm.counter--;
                if (vm.counter == 0) {
                    vm.onCounterEnded();
                } else
                    vm.countdown();
            }, 1000);
        };
        vm.stop = function () {
            $timeout.cancel(stopped);

        };

        function resetTimer() {
            vm.counter = 60;
            vm.counterIsEnded = false;
            vm.countdown();
        }

        function onCounterEnded() {
            vm.counterIsEnded = true;
        }


        function activateUser() {

            // console.log('active user S1');
            OrderBagCustom.logIntoServer().save('PLLOG active user S1');
            //
            if (vm.key != null) {
                vm.isSaving = true;
                vm.registerAccount.activationCode = vm.key;

                // console.log('active user S2 : ' + vm.key);
                OrderBagCustom.logIntoServer().save('PLLOG active user S2 ' + vm.key);

                if (vm.referralCode)
                    vm.registerAccount.referralCode = vm.referralCode;

                // console.log('active user S3');
                OrderBagCustom.logIntoServer().save('PLLOG active user S3');


                Auth.createAccount(vm.registerAccount).then(function () {
                    OrderBagCustom.logIntoServer().save('PLLOG active user S4');
                    Auth.activateAccount(vm.registerAccount.login, vm.key).then(function () {

                        OrderBagCustom.logIntoServer().save('PLLOG active user S5');

                        Auth.login({
                            username: vm.registerAccount.login,
                            password: vm.registerAccount.password,
                            rememberMe: false,
                            captchaCode: null
                        }).then(function () {
                            UserCustom.setUserInsight().save(vm.questions)
                            vm.isSaving = false;
                            vm.activateError = null;
                            vm.activatedSuccess = 'OK';
                            // initTracking();
                            if($localStorage.trackingData) {
                                marketingAttribution($localStorage.trackingData);
                            }
                            addGTagData();
                            $state.go('initSetupWizardV2');

                        })
                    }).catch(function () {
                        //

                        OrderBagCustom.logIntoServer().save('PLLOG active user Error 1');
                        vm.isSaving = false;
                        vm.activatedSuccess = null;
                        vm.activateError = 'ERROR';
                    });

                }).catch(function (response) {
                    OrderBagCustom.logIntoServer().save('PLLOG active user Error 2');
                    vm.isSaving = false;
                    vm.success = null;
                    vm.isSaving = false;
                    vm.activatedSuccess = null;
                    vm.activateError = 'ERROR';
                    if (response.status === 400 && response.data === 'login_already_in_use') {
                        vm.errorPhoneNumberExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
                        vm.errorEmailExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'PhoneNumber_already_in_use') {
                        vm.errorPhoneNumberExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }


                });

            } else {
                //
                vm.activatedSuccess = null;
                vm.activateError = 'ERROR';
            }

        }

        function regenerateActivationKey() {
            vm.register();
            //
            //Auth.regenerateActivationKey(vm.registerAccount.login)
            //    .then(function(){
            //        //
            //    vm.regenerateSuccess ='OK';
            //    vm.regenerateError =null;
            //        vm.resetTimer();
            //}).catch(function () {
            //    //
            //    vm.regenerateSuccess = null;
            //    vm.regenerateError = 'ERROR';
            //});
        }

        function findImageClass() {
            if (vm.__config.appMode == 'reserve')
                return 'left-register-image';
            if (vm.__config.appMode == 'event')
                return 'left-register-image-wd';
        }

        function addGTagData() {
            //user  registered
            try {
                gtag('event', 'user_start_register', {
                    "items": [
                        {
                            "id": "PL101",
                            "name": "User Activated Account",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": "UNKNOWN",
                            "price": '0'
                        }
                    ]
                });
            } catch (err) {
                console.log(err);
            }
        }

        function checkUserIsLoggedIn() {
            if($localStorage.authenticationToken) {
                $state.go('supplierPanel-v2.dashboard')
            }
        }
        function initTracking() {
            TrackingService.collect().then(function(trackingData) {
                if(trackingData.gclId || trackingData._gl) {
                    $localStorage.trackingData = trackingData;
                }
            }).catch(function (error) {
                console.error("TrackingService.collect failed:", error);
            });
        }
        function marketingAttribution(trackingData) {
            Marketing.marketingAttribution().save(trackingData, function(res) {
                if(res.leadId) {
                    var newData = trackingData;
                    newData['leadId'] = res.leadId;
                    UserCustom.userAttribution().save(newData, onSuccessUserAttribution, onErrorUserAttribution);
                }
            }, onErrorAttribution)
            function onSuccessUserAttribution() {
                delete $localStorage.trackingData;
            }
            function onErrorUserAttribution() {
                delete $localStorage.trackingData;
            }
                
        }
        function onErrorAttribution(error) {
            console.log(error);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActiveUserController', ActiveUserController);


    ActiveUserController.$inject = ['$translate', '$timeout', 'Auth', 'PersonInfo', '$state', 'entity', 'LoginService'];

    function ActiveUserController($translate, $timeout, Auth, PersonInfo, $state, entity, LoginService) {
        var vm = this;


        vm.userName = entity;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.registerAccount = {};
        vm.success = null;
        vm.activatedSuccess = null;
        vm.activateUser = activateUser;
        vm.submited = submited;
        vm.formMode = 'ACTIVEUSER';
        vm.errorPhoneNumberExists = null;
        vm.regenerateActivationKey = regenerateActivationKey;
        vm.activatedSuccess = null;

        $timeout(function () {
            angular.element('#login').focus();
        });

        function submited() {
            if (vm.formMode == 'ACTIVEUSER') {
                activateUser();
            }
        }

        function activateUser() {
            //
            if (vm.key != null) {
                Auth.activateAccount(vm.userName, vm.key).then(function () {
                    //
                    vm.activateError = null;
                    vm.activatedSuccess = 'OK';

                }).catch(function () {
                    //
                    //vm.activatedSuccess = null;
                    //vm.activateError = 'ERROR';
                });
            } else {
                //
                vm.activatedSuccess = null;
                vm.activateError = 'ERROR';
            }

        }

        function regenerateActivationKey() {

            Auth.regenerateActivationKey(vm.userName)
                .then(function () {

                    vm.regenerateSuccess = 'OK';
                    vm.regenerateError = null;
                }).catch(function () {

                vm.regenerateSuccess = null;
                vm.regenerateError = 'ERROR';
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PersonInfoDialogControllerCopy', PersonInfoDialogControllerCopy);

    PersonInfoDialogControllerCopy.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'PersonInfo', 'LocationInfo', 'SocialNetworkInfo'];

    // PersonInfoDialogControllerCopy.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PersonInfo', 'LocationInfo', 'SocialNetworkInfo'];

    function PersonInfoDialogControllerCopy($timeout, $scope, $stateParams, entity, PersonInfo, LocationInfo, SocialNetworkInfo) {
        var vm = this;

        vm.personInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.locationinfos = LocationInfo.query();
        vm.socialnetworkinfos = SocialNetworkInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            // $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.personInfo.id !== null) {
                PersonInfo.update(vm.personInfo, onSaveSuccess, onSaveError);
            } else {
                PersonInfo.save(vm.personInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:personInfoUpdate', result);
            // $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('createAccount', {
            parent: 'app',
            url: '/createAccount',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.create-account'
            },
            views: {
                'content@': {
                    templateUrl: 'app/createAccount/create-account.html',
                    controller: 'CreateAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        })
            .state('createAccount.personInfo', {
                parent: 'createAccount',
                url: '/PersonInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent2': {
                        templateUrl: 'app/entities/person-info/person-info-dialog.html',
                        controller: 'PersonInfoDialogControllerCopy',
                        controllerAs: 'vm'
                    },
                    'subcontent1': {
                        templateUrl: 'app/account/register/register.html',
                        controller: 'RegisterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            nationalCode: null,
                            fisrtName: null,
                            lastName: null,
                            gender: null,
                            phoneNumber: null,
                            birthDate: null,
                            id: null
                        };
                    }
                }
            })
        // .state('createAccount.Register', {
        //     parent: 'createAccount',
        //     url: '/userAccount/register',
        //     data: {
        //         authorities: []
        //     },
        //     views: {
        //         'subcontent1': {
        //             templateUrl: 'app/account/register/register.html',
        //             controller: 'RegisterController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     resolve: {
        //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
        //             $translatePartialLoader.addPart('register');
        //             return $translate.refresh();
        //         }],
        //         // entity: ['$stateParams', 'Register', function ($stateParams, Register) {
        //         //     return Register.get({id: $stateParams.id}).$promise;
        //         // }]
        //     }
        // })


        ;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CreateAccountController', CreateAccountController);


    CreateAccountController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function CreateAccountController($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#login').focus();
        });

        function register() {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login_already_in_use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoScheduleStartEndDateValidator', ['AlertService', 'ScheduleValidator', '$timeout', function (alertService, ScheduleValidator, $timeout) {

    return {
        restrict: 'E',
        scope: {startDate: '<', endDate: '<', serviceItemId: '<', scheduleInfoId: '<', targetElementId: '@'},

        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;

                //validation message to show
                var message1 = 'messages.schedule.ScheduleStartEndDateValidator.startDateIsBigger';
                var message2 = 'messages.schedule.ScheduleStartEndDateValidator.conflictWithOtherSchedules';
                elm = $('#' + scope.targetElementId);


                //adding validation message for element
                //    validationService.addMessage();
                scope.$watchGroup(['startDate', 'endDate'], function (newValues, oldValues, scope) {
                    //

                    var startDate = new Date(newValues[0]);
                    var endDate = new Date(newValues[1]);


                    //   scope.editForm.fromDate.$setValidity("eoScheduleStartEndDateValidator", true);
                    if (startDate && endDate) {

                        if (startDate >= endDate) {
                            alertService.showValidationMessage(elm, message1);
                        } else {
                            //    validationService.hide();
                            checkDatesWithOtherSchedules(startDate, endDate);


                        }
                    }


                });

                function checkDatesWithOtherSchedules(startDate, endDate) {
                    if (scope.serviceItemId && scope.scheduleInfoId)
                        ScheduleValidator.scheduleStartEndDateValidator(startDate, endDate, scope.serviceItemId, scope.scheduleInfoId).get(
                            function (result) {

                                if (result.data.valid) {

                                } else {
                                    alertService.showValidationMessage(elm, message2);
                                }
                            }
                        );
                }

                //validator function


            });

        }
    };
}]);
;
/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoDurationValidator', ['AlertService', '$timeout', function (alertService, $timeout) {

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;

                //validation message to show
                var message = 'messages.schedule.durationValidator';

                //validator function
                ctrl.$validators.durationValidator = function (modelValue, viewValue) {

                    if (modelValue)
                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty models to be valid
                            alertService.showValidationMessage(elm, message);
                            return false;
                        }

                    if (modelValue < 15 || modelValue > 10000) {
                        // it is invalid
                        //
                        alertService.showValidationMessage(elm, message);
                        return false;
                    } else {

                        return true;
                    }
                };

            });

        }
    };
}]);
;
/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoMinValidator', ['$timeout', function ($timeout) {

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;
                //validator function
                ctrl.$validators.minValidator = function (modelValue, viewValue) {

                    if (modelValue) {
                        if ((+modelValue) < (+attrs.eoMinValidator)) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                };

            });

        }
    };
}]);
;
/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoMinLengthValidator', ['$timeout', function ($timeout) {

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;

                //validator function
                ctrl.$validators.minLengthValidator = function (modelValue, viewValue) {
                    if (modelValue && attrs.eoMinLengthValidator) {
                        if (modelValue.length < +attrs.eoMinLengthValidator) {
                            return false;
                        } else {
                            return true;
                        }
                    }

                    return true;
                };

            });

        }
    };
}]);
;
/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoRequired', ['AlertService', '$timeout', function (alertService, $timeout) {

    return {

        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {

            if (attrs.eoRequired == 'false') return;
            $timeout(function () {

                var vm = this;
                //validation message to show
                var message = 'messages.common.eoRequired';


                //validator function
                ctrl.$validators.eoRequired = function (modelValue, viewValue) {

                    if (modelValue)
                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty models to be valid
                            alertService.showValidationMessage(elm, message);
                            return false;
                        } else {

                            return true;
                        }

                };
            });


        }
    };
}]);
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }

            return input;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .filter('characters', characters);

    function characters() {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length - 1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('jhSort', jhSort);

    function jhSort() {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass(element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses() {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort(field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply(values) {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('scrollHitBottom', scrollHitBottom);

    function scrollHitBottom() {
        var directive = {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var container = element.find('md-content');
                container.css('height', '300px');
                var visibleHeight = 300;
                var threshold = 100;

                container.on('scroll', function (e) {
                    var scrollableHeight = container.prop('scrollHeight');
                    var hiddenContentHeight = scrollableHeight - visibleHeight;
                    if (hiddenContentHeight - container[0].scrollTop <= threshold) {
                        scope.$apply(attrs.scrollHitBottom);
                    }
                });

            }
        }
        return directive;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks() {

        var service = {
            parse: parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function ($0, $1, $2, $3) {
                        queryString[$1] = $3;
                    }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil() {

        var service = {
            parseAscending: parseAscending,
            parsePage: parsePage,
            parsePredicate: parsePredicate
        };

        return service;

        function parseAscending(sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1) {
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage(page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate(sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1) {
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('onFileChange', onFileChange);

    function onFileChange() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.onFileChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function () {
                    element.off();
                });

            }
        };
    }
})();
;
/*
sample :
Add "valid-number" and also include required parameter.
    Positive Number
<input valid-number ng-model="mynumber"  allow-decimal="false" allow-negative="false" type="text">
    Negative Number
<input valid-number ng-model="mynumber"   allow-decimal="false" allow-negative="true" type="text">
    Decimal Numbers Default Decimal-Upto 2
<input valid-number ng-model="mynumber"  allow-decimal="true" allow-negative="false" type="text">
    Decimal Numbers Default Decimal-Upto 3
<input valid-number ng-model="mynumber"  allow-decimal="true" allow-negative="false" decimal-upto="3" type="text">
*/


angular.module('tikonApp').directive('validNumber', function () {
    return {
        controller: ['$scope', function ($scope) {
            $scope.positiveNumber = 0;
            $scope.negativeNumber = 0;
            $scope.decimal = 0;
            $scope.decimalUpto = 0
            $scope.negativedecimal = 0;
            $scope.negativedecimalUpto = 0
            $scope.total = 0;
        }],
        require: '?ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {

            element.on('keydown', function (event) {
                var keyCode = []
                if (attrs.allowNegative == "true") {
                    keyCode = [8, 9, 36, 35, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109, 110, 173, 190, 189];
                    //console.log('majid');
                } else {
                    var keyCode = [8, 9, 36, 35, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 173, 190];
                }


                if (attrs.allowDecimal == "false") {

                    var index = keyCode.indexOf(190);


                    if (index > -1) {
                        keyCode.splice(index, 1);
                    }

                }

                if ($.inArray(event.which, keyCode) == -1) event.preventDefault();
                else {//console.log(2);
                    var oVal = ngModelCtrl.$modelValue || '';
                    if ($.inArray(event.which, [109, 173]) > -1 && oVal.indexOf('-') > -1) event.preventDefault();
                    else if ($.inArray(event.which, [110, 190]) > -1 && oVal.indexOf('.') > -1) event.preventDefault();
                }
            })
                .on('blur', function () {

                    if (element.val() == '' || parseFloat(element.val()) == 0.0 || element.val() == '-') {
                        ngModelCtrl.$setViewValue('0.00');
                    } else if (attrs.allowDecimal == "false") {
                        ngModelCtrl.$setViewValue(element.val());
                    } else {
                        if (attrs.decimalUpto) {
                            var fixedValue = parseFloat(element.val()).toFixed(attrs.decimalUpto);
                        } else {
                            var fixedValue = parseFloat(element.val()).toFixed(2);
                        }
                        ngModelCtrl.$setViewValue(fixedValue);
                    }


                    ngModelCtrl.$render();
                    scope.$apply();
                });

            ngModelCtrl.$parsers.push(function (text) {
                var oVal = ngModelCtrl.$modelValue;
                var nVal = ngModelCtrl.$viewValue;
                //console.log(nVal);
                if (parseFloat(nVal) != nVal) {

                    if (nVal === null || nVal === undefined || nVal == '' || nVal == '-') oVal = nVal;

                    ngModelCtrl.$setViewValue(oVal);
                    ngModelCtrl.$render();
                    return oVal;
                } else {
                    var decimalCheck = nVal.split('.');
                    if (!angular.isUndefined(decimalCheck[1])) {
                        if (attrs.decimalUpto)
                            decimalCheck[1] = decimalCheck[1].slice(0, attrs.decimalUpto);
                        else
                            decimalCheck[1] = decimalCheck[1].slice(0, 2);
                        nVal = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    ngModelCtrl.$setViewValue(nVal);
                    ngModelCtrl.$render();
                    return nVal;
                }
            });

            ngModelCtrl.$formatters.push(function (text) {
                if (text == '0' || text == null && attrs.allowDecimal == "false") return '0';
                else if (text == '0' || text == null && attrs.allowDecimal != "false" && attrs.decimalUpto == undefined) return '0.00';
                else if (text == '0' || text == null && attrs.allowDecimal != "false" && attrs.decimalUpto != undefined) return parseFloat(0).toFixed(attrs.decimalUpto);
                else if (attrs.allowDecimal != "false" && attrs.decimalUpto != undefined) return parseFloat(text).toFixed(attrs.decimalUpto);
                else return parseFloat(text).toFixed(2);
            });
        }
    };
});

//
//
//var positiveNumbersFilter  = function ($filter) {
//       return function(input) {
//
//           var posValues = [];
//           var counter = 0;
//           for(var i = 0; i < input.length; i++){
//               if(input[i] >= 0){
//                   posValues[counter] = input[i];
//                   counter++;
//               }
//           }
//           return posValues;
//       }
//   }
//
//angular.module('tikonApp').filter('positiveNumber', positiveNumbersFilter);
//positiveNumbersFilter.$inject = ['$filter'];
;
(function () {
    'use strict';

    var jhiItemCount = {

        template: '<div class="info">' +
            'نمایش {{(($ctrl.page-1) * $ctrl.itemsPerPage)==0 ? 1:(($ctrl.page-1) * $ctrl.itemsPerPage + 1)}} - ' +
            '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
            '  از {{$ctrl.queryCount}}  مورد' +
            '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: "=?"
        },
        controller: JhiItemCountController
    };

    JhiItemCountController.$inject = ['$scope', '$element', 'paginationConstants'];

    function JhiItemCountController($scope, $element, paginationConstants) {
        var $ctrl = this;

        if (!$ctrl.itemsPerPage)
            $ctrl.itemsPerPage = 20;


    }

    angular
        .module('tikonApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function (f) {
    if (typeof exports === "object" && typeof module !== "undefined") {
        module.exports = f()
    } else if (typeof define === "function" && define.amd) {
        define([], f)
    } else {
        var g;
        if (typeof window !== "undefined") {
            g = window
        } else if (typeof global !== "undefined") {
            g = global
        } else if (typeof self !== "undefined") {
            g = self
        } else {
            g = this
        }
        g.jalaali = f()
    }
})(function () {
    var define, module, exports;
    return (function () {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = "function" == typeof require && require;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a
                    }
                    var p = n[i] = {exports: {}};
                    e[i][0].call(p.exports, function (r) {
                        var n = e[i][1][r];
                        return o(n || r)
                    }, p, p.exports, r, e, n, t)
                }
                return n[i].exports
            }

            for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
            return o
        }

        return r
    })()({
        1: [function (require, module, exports) {
            /*
              Expose functions.
            */
            module.exports =
                {
                    toJalaali: toJalaali
                    , toGregorian: toGregorian
                    , isValidJalaaliDate: isValidJalaaliDate
                    , isLeapJalaaliYear: isLeapJalaaliYear
                    , jalaaliMonthLength: jalaaliMonthLength
                    , jalCal: jalCal
                    , j2d: j2d
                    , d2j: d2j
                    , g2d: g2d
                    , d2g: d2g
                    , jalaaliToDateObject: jalaaliToDateObject
                    , jalaaliWeek: jalaaliWeek
                }

            /*
              Jalaali years starting the 33-year rule.
            */
            var breaks = [-61, 9, 38, 199, 426, 686, 756, 818, 1111, 1181, 1210
                , 1635, 2060, 2097, 2192, 2262, 2324, 2394, 2456, 3178
            ]

            /*
              Converts a Gregorian date to Jalaali.
            */
            function toJalaali(gy, gm, gd) {
                if (Object.prototype.toString.call(gy) === '[object Date]') {
                    gd = gy.getDate()
                    gm = gy.getMonth() + 1
                    gy = gy.getFullYear()
                }
                return d2j(g2d(gy, gm, gd))
            }

            /*
              Converts a Jalaali date to Gregorian.
            */
            function toGregorian(jy, jm, jd) {
                return d2g(j2d(jy, jm, jd))
            }

            /*
              Checks whether a Jalaali date is valid or not.
            */
            function isValidJalaaliDate(jy, jm, jd) {
                return jy >= -61 && jy <= 3177 &&
                    jm >= 1 && jm <= 12 &&
                    jd >= 1 && jd <= jalaaliMonthLength(jy, jm)
            }

            /*
              Is this a leap year or not?
            */
            function isLeapJalaaliYear(jy) {
                return jalCalLeap(jy) === 0
            }

            /*
              Number of days in a given month in a Jalaali year.
            */
            function jalaaliMonthLength(jy, jm) {
                if (jm <= 6) return 31
                if (jm <= 11) return 30
                if (isLeapJalaaliYear(jy)) return 30
                return 29
            }

            /*
                This function determines if the Jalaali (Persian) year is
                leap (366-day long) or is the common year (365 days)

                @param jy Jalaali calendar year (-61 to 3177)
                @returns number of years since the last leap year (0 to 4)
             */
            function jalCalLeap(jy) {
                var bl = breaks.length
                    , jp = breaks[0]
                    , jm
                    , jump
                    , leap
                    , n
                    , i

                if (jy < jp || jy >= breaks[bl - 1])
                    throw new Error('Invalid Jalaali year ' + jy)

                for (i = 1; i < bl; i += 1) {
                    jm = breaks[i]
                    jump = jm - jp
                    if (jy < jm)
                        break
                    jp = jm
                }
                n = jy - jp

                if (jump - n < 6)
                    n = n - jump + div(jump + 4, 33) * 33
                leap = mod(mod(n + 1, 33) - 1, 4)
                if (leap === -1) {
                    leap = 4
                }

                return leap
            }

            /*
              This function determines if the Jalaali (Persian) year is
              leap (366-day long) or is the common year (365 days), and
              finds the day in March (Gregorian calendar) of the first
              day of the Jalaali year (jy).

              @param jy Jalaali calendar year (-61 to 3177)
              @param withoutLeap when don't need leap (true or false) default is false
              @return
                leap: number of years since the last leap year (0 to 4)
                gy: Gregorian year of the beginning of Jalaali year
                march: the March day of Farvardin the 1st (1st day of jy)
              @see: http://www.astro.uni.torun.pl/~kb/Papers/EMP/PersianC-EMP.htm
              @see: http://www.fourmilab.ch/documents/calendar/
            */
            function jalCal(jy, withoutLeap) {
                var bl = breaks.length
                    , gy = jy + 621
                    , leapJ = -14
                    , jp = breaks[0]
                    , jm
                    , jump
                    , leap
                    , leapG
                    , march
                    , n
                    , i

                if (jy < jp || jy >= breaks[bl - 1])
                    throw new Error('Invalid Jalaali year ' + jy)

                // Find the limiting years for the Jalaali year jy.
                for (i = 1; i < bl; i += 1) {
                    jm = breaks[i]
                    jump = jm - jp
                    if (jy < jm)
                        break
                    leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4)
                    jp = jm
                }
                n = jy - jp

                // Find the number of leap years from AD 621 to the beginning
                // of the current Jalaali year in the Persian calendar.
                leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4)
                if (mod(jump, 33) === 4 && jump - n === 4)
                    leapJ += 1

                // And the same in the Gregorian calendar (until the year gy).
                leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150

                // Determine the Gregorian date of Farvardin the 1st.
                march = 20 + leapJ - leapG

                // return with gy and march when we don't need leap
                if (withoutLeap) return {gy: gy, march: march};


                // Find how many years have passed since the last leap year.
                if (jump - n < 6)
                    n = n - jump + div(jump + 4, 33) * 33
                leap = mod(mod(n + 1, 33) - 1, 4)
                if (leap === -1) {
                    leap = 4
                }

                return {
                    leap: leap
                    , gy: gy
                    , march: march
                }
            }

            /*
              Converts a date of the Jalaali calendar to the Julian Day number.

              @param jy Jalaali year (1 to 3100)
              @param jm Jalaali month (1 to 12)
              @param jd Jalaali day (1 to 29/31)
              @return Julian Day number
            */
            function j2d(jy, jm, jd) {
                var r = jalCal(jy, true)
                return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1
            }

            /*
              Converts the Julian Day number to a date in the Jalaali calendar.

              @param jdn Julian Day number
              @return
                jy: Jalaali year (1 to 3100)
                jm: Jalaali month (1 to 12)
                jd: Jalaali day (1 to 29/31)
            */
            function d2j(jdn) {
                var gy = d2g(jdn).gy // Calculate Gregorian year (gy).
                    , jy = gy - 621
                    , r = jalCal(jy, false)
                    , jdn1f = g2d(gy, 3, r.march)
                    , jd
                    , jm
                    , k

                // Find number of days that passed since 1 Farvardin.
                k = jdn - jdn1f
                if (k >= 0) {
                    if (k <= 185) {
                        // The first 6 months.
                        jm = 1 + div(k, 31)
                        jd = mod(k, 31) + 1
                        return {
                            jy: jy
                            , jm: jm
                            , jd: jd
                        }
                    } else {
                        // The remaining months.
                        k -= 186
                    }
                } else {
                    // Previous Jalaali year.
                    jy -= 1
                    k += 179
                    if (r.leap === 1)
                        k += 1
                }
                jm = 7 + div(k, 30)
                jd = mod(k, 30) + 1
                return {
                    jy: jy
                    , jm: jm
                    , jd: jd
                }
            }

            /*
              Calculates the Julian Day number from Gregorian or Julian
              calendar dates. This integer number corresponds to the noon of
              the date (i.e. 12 hours of Universal Time).
              The procedure was tested to be good since 1 March, -100100 (of both
              calendars) up to a few million years into the future.

              @param gy Calendar year (years BC numbered 0, -1, -2, ...)
              @param gm Calendar month (1 to 12)
              @param gd Calendar day of the month (1 to 28/29/30/31)
              @return Julian Day number
            */
            function g2d(gy, gm, gd) {
                var d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4)
                    + div(153 * mod(gm + 9, 12) + 2, 5)
                    + gd - 34840408
                d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752
                return d
            }

            /*
              Calculates Gregorian and Julian calendar dates from the Julian Day number
              (jdn) for the period since jdn=-34839655 (i.e. the year -100100 of both
              calendars) to some millions years ahead of the present.

              @param jdn Julian Day number
              @return
                gy: Calendar year (years BC numbered 0, -1, -2, ...)
                gm: Calendar month (1 to 12)
                gd: Calendar day of the month M (1 to 28/29/30/31)
            */
            function d2g(jdn) {
                var j
                    , i
                    , gd
                    , gm
                    , gy
                j = 4 * jdn + 139361631
                j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908
                i = div(mod(j, 1461), 4) * 5 + 308
                gd = div(mod(i, 153), 5) + 1
                gm = mod(div(i, 153), 12) + 1
                gy = div(j, 1461) - 100100 + div(8 - gm, 6)
                return {
                    gy: gy
                    , gm: gm
                    , gd: gd
                }
            }

            /**
             * Return Saturday and Friday day of current week(week start in Saturday)
             * @param {number} jy jalaali year
             * @param {number} jm jalaali month
             * @param {number} jd jalaali day
             * @returns Saturday and Friday of current week
             */
            function jalaaliWeek(jy, jm, jd) {
                var dayOfWeek = jalaaliToDateObject(jy, jm, jd).getDay();

                var startDayDifference = dayOfWeek == 6 ? 0 : -(dayOfWeek + 1);
                var endDayDifference = 6 + startDayDifference;

                return {
                    saturday: d2j(j2d(jy, jm, jd + startDayDifference)),
                    friday: d2j(j2d(jy, jm, jd + endDayDifference))
                }
            }

            /**
             * Convert Jalaali calendar dates to javascript Date object
             * @param {number} jy jalaali year
             * @param {number} jm jalaali month
             * @param {number} jd jalaali day
             * @param {number} [h] hours
             * @param {number} [m] minutes
             * @param {number} [s] seconds
             * @param {number} [ms] milliseconds
             * @returns Date object of the jalaali calendar dates
             */
            function jalaaliToDateObject(
                jy,
                jm,
                jd,
                h,
                m,
                s,
                ms
            ) {
                var gregorianCalenderDate = toGregorian(jy, jm, jd);

                return new Date(
                    gregorianCalenderDate.gy,
                    gregorianCalenderDate.gm - 1,
                    gregorianCalenderDate.gd,
                    h || 0,
                    m || 0,
                    s || 0,
                    ms || 0
                );
            }

            /*
              Utility helper functions.
            */

            function div(a, b) {
                return ~~(a / b)
            }

            function mod(a, b) {
                return a - ~~(a / b) * b
            }

        }, {}], 2: [function (require, module, exports) {
            module.exports = require('./index.js');
        }, {"./index.js": 1}]
    }, {}, [2])(2)
});
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('FileUtilCustom', FileUtilCustom);

    FileUtilCustom.$inject = ['$resource', 'ENV'];

    function FileUtilCustom($resource, ENV) {


        var supplierFileUploadToServer = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/supplier-upload-file';
            return $resource(resourceUrl, {}, {
                    'upload': {
                        method: "POST",
                        // transformRequest: angular.identity,
                        headers: {'Content-Type': undefined}
                    }
                }
            );
        }
        var getFileUrlPrefix = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-file-url-prefix-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        // var downloadSupplierFileByName = function (fileName) {
        //     var resourceUrl='api/download-supplier-file-by-name/'+fileName;
        //     return $resource(resourceUrl, {}, {
        //             'get': { method: 'GET', isArray: false}
        //         }
        //
        //     );
        // }

        var downloadSupplierFileByName = function (fileName, directory) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/download-supplier-file-by-name?fileName=' + fileName + '&directory=' + directory;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getSupplierFileDownloadLink = function (fileName) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-supplier-file-download-link?fileName=' + fileName;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        return {
            supplierFileUploadToServer: supplierFileUploadToServer,
            getFileUrlPrefix: getFileUrlPrefix,
            downloadSupplierFileByName: downloadSupplierFileByName,
            getSupplierFileDownloadLink: getSupplierFileDownloadLink


        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DriverJsFunction', DriverJsFunction);

    DriverJsFunction.$inject = ['CompanyInfoQuery', 'ActivityTypeInfoCustom', '$localStorage', '$timeout', '$q'];

    function DriverJsFunction(CompanyInfoQuery, ActivityTypeInfoCustom, $localStorage, $timeout, $q) {
        var servant_label = "پرسنل";

        var drive = function () {
            var driverObj = null;
            var driver = window.driver.js.driver;
            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                if (company != null && company != undefined) {
                    ActivityTypeInfoCustom.getActivityTypeInfoByType(company.activityType).query(function (result) {
                        if (result.servantListTitle) {
                            servant_label = result.servantListTitle
                        }
                        driverObj = driver({
                            nextBtnText: 'بعدی',
                            doneBtnText: 'تمام',
                            closeBtnText: 'بستن',
                            prevBtnText: 'قبلی',
                            showProgress: true,
                            onPopoverRender: function (popover) {
                                const dontShowBtn = document.createElement("button");
                                dontShowBtn.textContent = "دیگه نشان نده";
                                dontShowBtn.className = "driverjs-dont-show-again-btn";
                                dontShowBtn.style.padding = "6px 10px";
                                dontShowBtn.addEventListener("click", function () {
                                    $localStorage.driverjs_dontShowAgain = "true"
                                    driverObj.destroy();
                                })

                                const footer = popover.footer
                                if (footer) {
                                    footer.appendChild(dontShowBtn);
                                }
                            },
                            steps: [
                                {
                                    popover: {
                                        title: 'به پلنوین خوش آمدید',
                                        description: 'با پلنوین می‌تونید همه رزروها، مشتری‌ها و خدماتتون رو تو یه پلتفرم ساده و کاربردی مدیریت کنید' +
                                            'برای آشنایی با بخش‌های مختلف پنل، همراه ما باشید.',
                                        progressText: 'مرحله ۱ از ۱۶',
                                    }
                                },
                                {
                                    element: '#pl-profile',
                                    popover: {
                                        description: 'با پلنوین می‌تونید همه رزروها، مشتری‌ها و خدماتتون رو تو یه پلتفرم ساده و کاربردی مدیریت کنیدبا کلیک روی این آیکون می‌تونید به اطلاعات پروفایل کاربری، تمدید اشتراک و خرید بسته پیامکی دسترسی داشته باشید. همچنین اطلاعات حقیقی و حقوقی در این بخش قابل تنظیم هستن.',
                                        progressText: 'مرحله ۲ از ۱۶',
                                        side: "right",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#pl-my-site',
                                    popover: {
                                        description: 'با کلیک روی این آیکون، وارد سایت اختصاصی خودتون می‌شید.' +
                                            ' جایی که مشتری‌ها می‌تونن آنلاین رزرو انجام بدن و خدمات شما رو ببینن. حالا می‌تونید ببینید سایتتون چقدر شیک‌تر شده!',
                                        progressText: 'مرحله ۳ از ۱۶',
                                        side: "right",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#pl-help',
                                    popover: {
                                        description: ' اگر به هر راهنمایی نیاز داشتید، از این بخش می‌تونید به واحد پشتیبانی پلنوین یا آموزش ها دسترسی داشته باشید و سوالات یا مشکلاتتون رو مطرح کنید. پشتیبانی پلنوین هر زمانی که به کمک نیاز داشتید در کنارتونه. ',
                                        progressText: 'مرحله ۴ از ۱۶',
                                        side: "right",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#home-li svg',
                                    popover: {
                                        description: 'در این صفحه می‌تونید همیشه یه دید سریع از اوضاع کسب‌و‌کارتون داشته باشید، خلاصه ای از وضعیت رزروها رو مشاهده کنید و در صورت نیاز ویرایششون کنید. ',
                                        progressText: 'مرحله ۵ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#servant-li svg',
                                    popover: {
                                        description: 'اینجا می‌تونید ' + servant_label + ' جدید اضافه کنید، ساعت کاری‌شون رو تنظیم کنید یا اطلاعات‌شون رو ویرایش کنید.',
                                        progressText: 'مرحله ۶ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#service-li svg',
                                    popover: {
                                        description: 'در این بخش می‌تونید خدمات جدید تعریف کنید یا موارد قبلی رو ویرایش کنید.' +
                                            ' تعرفه، مدت‌زمان و توضیحات هر خدمت به‌راحتی قابل تغییر هست.',
                                        progressText: 'مرحله ۷ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#event-li svg',
                                    popover: {
                                        description: 'میتونید کارگاه یا رویداد اموزشی برگزار کنید. بخش رویدادها مخصوص برنامه‌هایی‌ هست که فقط یک‌بار و در یک تاریخ خاص برگزار میشود . اینجا می‌تونید تنظیم و مدیریتشون کنید.',
                                        progressText: 'مرحله ۸ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#reserve-list-li svg',
                                    popover: {
                                        description: 'در این بخش می‌تونید تمام رزروهایی که ثبت‌شدن رو مدیریت کنید. همچنین امکان ثبت نوبت به صورت پذیرش حضوری یا تلفنی به وجود داره.',
                                        progressText: 'مرحله ۹ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#calendar-li svg',
                                    popover: {
                                        description: 'تقویم کامل رزروها اینجاست!' +
                                            ' زمان‌های آزاد، رزروشده و تعطیلی‌ها رو به‌صورت تصویری روی تقویم ببینید.' +
                                            ' حتی می‌تونید استثناهایی مثل مرخصی یا مناسبت خاص رو هم اینجا وارد کنید.',
                                        progressText: 'مرحله ۱۰ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#invoice-li svg',
                                    popover: {
                                        description: 'در این قسمت می‌تونید فاکتور جدید ثبت کنید و سوابق فیش‌های فروش قبلی رو بررسی کنید.',
                                        progressText: 'مرحله ۱۱ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#customer-li svg',
                                    popover: {
                                        description: 'اینجا پرونده کامل مشتریان شما قرار داره؛ یک سیستم CRM برای مدیریت بهتر ارتباط با مشتریان.' +
                                            'می‌تونید مشتری جدید اضافه کنید، اون‌ها رو دسته‌بندی کنید(مثلا مشتریان VIP و نقره‌ای)، فرم‌های دریافتی و تمامی اطلاعات ثبت‌شده رو مشاهده کنید و به سوابق رزرو هر مشتری دسترسی داشته باشید.',
                                        progressText: 'مرحله ۱۲ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#report-li svg',
                                    popover: {
                                        description: 'در این بخش می‌تونید گزارش‌هایی با فرمت اکسل از کسب‌وکارتون دریافت کنید، مثل جزئیات رزروها و لیست مشتریان.',
                                        progressText: 'مرحله ۱۳ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#finance-li svg',
                                    popover: {
                                        description: 'در بخش مالی پنل به اطلاعات تمامی پرداخت‌هایی که  از طریق درگاه پرداخت پلنوین انجام شدن دسترسی دارید.' +
                                            'درخواست تسویه‌حساب هم از همین قسمت انجام می‌شه.',
                                        progressText: 'مرحله ۱۴ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    element: '#setting-li svg',
                                    popover: {
                                        description: 'تنظیمات حرفه‌ای کسب‌وکارتون در این بخش قرار داره!' +
                                            'اینجا می‌تونید تنظیمات کسب‌وکار، تنظیمات مالی و امکانات ویژه مثل ایجاد کد تخفیف، تنطیم پیامک‌های خودکار و محاسبه کمیسون پرسنل رو مدیریت کنید.',
                                        progressText: 'مرحله ۱۵ از ۱۶',
                                        side: "left",
                                        align: 'start'

                                    }
                                },
                                {
                                    popover: {
                                        description: 'تبریک می‌گم! با قسمت‌های مختلف پنل آشنا شدید.' +
                                            'حالا می‌تونید کسب‌وکارتون رو با پلنوین چندین پله ارتقا بدید. اگه بازم به راهنماییم نیاز  داشتید از منوی راهنما می‌تونید بهم دسترسی داشته باشید.',
                                        progressText: 'مرحله ۱۶ از ۱۶',
                                    }
                                }
                            ]
                        });
                        driverObj.drive();

                    })
                }
            })
        }
        if (!$localStorage.driverjs_dontShowAgain && window.innerWidth >= 768) {
            $timeout(drive, 5000);
        }

        return {
            drive: drive
        };
    }
})();;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DeviceService', DeviceService);


    function DeviceService() {
        const userAgent = navigator.userAgent || window.opera;

        function isMobile() {
            return /android|iphone|ipad|ipod|windows phone/i.test(userAgent);
        }

        function isAndroid() {
            return /android/i.test(userAgent);
        }

        function isIOS() {
            return /iphone|ipad|ipod/i.test(userAgent);
        }

        function isDesktop() {
            return !isMobile();
        }

        return {
            isMobile: isMobile,
            isAndroid: isAndroid,
            isIOS: isIOS,
            isDesktop: isDesktop
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            convertToISOString: convertToISOString,
            dateformat: dateformat,
            jdateToDate: jdateToDate,
            addDays: addDays,
            newDate: newDate,
            toTehranTime: toTehranTime,
            changeJDateTimeToTehran: changeJDateTimeToTehran,
            convertToPersianDate: convertToPersianDate

        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return newDate(date);
            } else {
                return null;
            }
        }

        function convertToISOString(date) {

            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var dt = date.getDate();

            if (dt < 10) {
                dt = '0' + dt;
            }
            if (month < 10) {
                month = '0' + month;
            }
            return (year + '-' + month + '-' + dt);
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }

        function jdateToDate(jdate) {
            var date = jdate.to_gregorian();
            date.setTime(jdate.getTime());
            return date;
        }

        function addDays(date, days) {

            date.setDate(date.getDate() + days);
            return date;
        }

        function newDate(date) {

            if (!date)
                return new Date();
            var ad = new Date(date); /// not work on safari !!

            if (!isDateValid(ad))
                ad = new Date(date.replace(/-/g, "/"));

            return ad;

        }

        function toTehranTime(date) {

            var d = moment(date);
            var tehranTime = d.tz("Asia/Tehran");
            return tehranTime;
        }

        function isDateValid(date) {
            if (isNaN(date.getTime())) {
            } else {
                return true;
            }
        }

        function changeJDateTimeToTehran(jdate) {
            //check time of the year
            var isDST = true;
            if (isDST) {
                var hours = jdate.getHours();
                jdate._d.setHours(hours + 1);
            }

            return jdate;
        }

        function convertToPersianDate(input) {
            var inputDate = new Date(input);
            var tehranTimeZone = convertTZ(inputDate, 'Asia/Tehran')
            var date = new JDate(tehranTimeZone);
            return date;
        }

        function convertTZ(date, tzString) {
            return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
        }


    }

})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            imagesrc: imagesrc,
            toBase64: toBase64
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function imagesrc(type, data) {

            return 'data:' + type + ';base64,' + data;
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter(input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function () {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('tikonApp')
        .factory('Base64', Base64);

    function Base64() {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode: decode,
            encode: encode
        };

        return service;

        function encode(input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode(input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function () {
    'use strict';

    function WZServiceItemV2Controller($scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;

        loadPage();


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader.addPart('supplierPanel');
            translatePartialLoader = translate.refresh();

            //

            // if ($ctrl.activityTypeInfo) {
            //     if ($ctrl.activityTypeInfo.servantType == 'RESOURCE') {
            //         $ctrl.serviceItem.itemTitle = $ctrl.activityTypeInfo.serviceSamplePlaceHolder;
            //         $ctrl.serviceItem.minPrice = 0.0;
            //         $ctrl.serviceItem.duration = 60;
            //     } else {
            //         $ctrl.serviceItem.itemTitle =  $ctrl.activityTypeInfo.serviceSamplePlaceHolder;
            //         $ctrl.serviceItem.minPrice = 100000.0;
            //         $ctrl.serviceItem.duration = 60;
            //     }
            // }
            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


        $scope.$watch('ServiceItemform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })
    }

    var WZServiceItemV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms-v2/service-item-v2/wizard-form.service-item-v2.html',
        controller: WZServiceItemV2Controller,
        bindings:
            {
                serviceItem: '=?',
                isFormValid: '=?',
                activityTypeInfo: '=?',
                servant: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfServiceItemV2', WZServiceItemV2)

    WZServiceItemV2Controller.$inject = ['$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function WZLastStepV2Controller(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        $ctrl.__config = __config;
        loadPage();
        $ctrl.goToSite = goToSite;
        $ctrl.getWebSiteUrl = getWebSiteUrl;
        $ctrl.getFeatureListUrl = getFeatureListUrl;
        $ctrl.getHelpUrl = getHelpUrl;


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();

            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        function goToSite() {

            if ($ctrl.wizardData.company && $ctrl.wizardData.company.keyUrl) {
                var websiteUrl = $ctrl.wizardData.company.keyUrl + '.' + __config.domain;
                window.open('http://' + websiteUrl, '_blank');
            }

        }

        function getWebSiteUrl() {
            if ($ctrl.wizardData.company && $ctrl.wizardData.company.keyUrl)
                return ($ctrl.wizardData.company.keyUrl + '.' + __config.domain);
        }

        function getFeatureListUrl() {
            if ($ctrl.__config.appMode == 'reserve') {
                if ($ctrl.__config.appName && $ctrl.__config.appName == "planovin") {
                    return "https://planovin.com/features";
                } else {
                    return "https://www.reserweb.ir/intro/featurelist.html";
                }

            }
        }

        function getHelpUrl() {
            if ($ctrl.__config.appMode == 'reserve') {
                if ($ctrl.__config.appName && $ctrl.__config.appName == "planovin") {
                    return "https://planovin.com/help";
                } else
                    return "https://help.reserweb.ir/";
            }
            if ($ctrl.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

    }

    var WZLastStepV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms-v2/last-step-v2/wizard-form.last-step-v2.html',
        controller: WZLastStepV2Controller,
        bindings:
            {
                wizardData: '='
            }

    };

    angular
        .module('tikonApp')
        .component('wzfLastStepV2', WZLastStepV2)

    WZLastStepV2Controller.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function WZCompanyScheduleV2Controller($scope, $timeout, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        loadPage();

        function initSchedule() {
            $timeout(function () {
                $ctrl.schedule = {};
                $ctrl.schedule.weeklyScheduleInfo = {};
                $ctrl.schedule.weeklyScheduleInfo.timePeriod = {};
                var startTime = new Date();
                startTime.setHours(8, 0, 0, 0);
                var endTime = new Date();
                endTime.setHours(17, 0, 0, 0);
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime = startTime;
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime = endTime;
                $ctrl.schedule.weeklyScheduleInfo.weekdays = [];
                angular.forEach(DAYS_VALUES, function (val) {
                    var weekday = {};
                    if (val != 'FRIDAY') {
                        weekday.weekday = val;
                        //weekday.timePeriod = $ctrl.schedule.weeklyScheduleInfo.timePeriod;
                        $ctrl.schedule.weeklyScheduleInfo.weekdays.push(weekday);
                    }
                });
            }, 500);


        }

        function loadAll() {
            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            initSchedule();
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        $scope.$watch('CompanyScheduleform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })


    }

    var wzfCompanyScheduleV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms-v2/company-schedule-v2/wizard-form.company-schedule-v2.html',
        controller: WZCompanyScheduleV2Controller,
        bindings:
            {
                schedule: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanyScheduleV2', wzfCompanyScheduleV2)

    WZCompanyScheduleV2Controller.$inject = ['$scope', '$timeout', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function WZCompanyInfoV2Controller(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, CompanyCustom, ActivityTypeInfo, CompanyInfoQuery, ActivityTypeInfoCustom) {

        var $ctrl = this;
        $ctrl.checkCompanyKeyUrlIsValid = checkCompanyKeyUrlIsValid;
        $ctrl.isUrlValid = null;
        $ctrl.searchText = '';
        $ctrl.querySearch = querySearch;
        $ctrl.activityTypes = [];
        $ctrl.isDisabled = false;
        $ctrl.__config = __config;
        $ctrl.servant_label = 'پرسنل'


        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {


            translatePartialLoader.addPart('activityType');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();

        }

        function checkCompanyKeyUrlIsValid(onValidate) {
            if ($ctrl.company == null || $ctrl.company == undefined)
                return;

            if ($ctrl.company.keyUrl != undefined && $ctrl.company.keyUrl != null && $ctrl.company.keyUrl.length > 2) {
                $ctrl.company.keyUrl = $ctrl.company.keyUrl.toLowerCase();
                CompanyCustom.findCompanyByKeyURL($ctrl.company.keyUrl.trim()).query().$promise.then(onValidate);
            }
        }

        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.activityTypes, function (item) {
                if (item.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.activityTypes;
                }
            })

            return temp;

        }


        $scope.$watch('companyinfoform.$valid', function (isValid) {
            $ctrl.formisValid = isValid;
            if (isValid && $ctrl.isUrlValid) {
                $ctrl.isFormValid(isValid);
            } else {
                $ctrl.isFormValid(false);
            }

        })

        $scope.$watch('$ctrl.company.keyUrl', function () {

            checkCompanyKeyUrlIsValid(function (result) {
                if (result != null && result.id != null) {
                    $ctrl.isUrlValid = false;
                } else {
                    $ctrl.isUrlValid = true;
                }

                if ($ctrl.isUrlValid && $ctrl.formisValid) {
                    $ctrl.isFormValid(true);
                } else {
                    $ctrl.isFormValid(false);
                }
            });

        });

    $scope.$watch(
        '$ctrl.company.activityType',
        function (newActivityType, oldActivityType) {
            if (!newActivityType || newActivityType === oldActivityType) {
                return;
            }
            ActivityTypeInfoCustom
                .getActivityTypeInfoByType(newActivityType)
                .query()
                .$promise
                .then(function (result) {
                    if (result && result.servantListTitle) {
                        $ctrl.servant_label = result.servantListTitle;
                    }
                })
                .catch(function (error) {
                    console.error('Could not load activity type information', error);
                });
        }
    );


    }

    var WZCompanyInfoV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms-v2/company-info-v2/wizard-form.company-info-v2.html',
        controller: WZCompanyInfoV2Controller,
        bindings:
            {
                company: '=?',
                userInsight: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanyInfoV2', WZCompanyInfoV2)

    WZCompanyInfoV2Controller.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'CompanyCustom', 'ActivityTypeInfo',  'CompanyInfoQuery', 'ActivityTypeInfoCustom'];


})();

;
(function () {
    'use strict';

    function WZServiceItemController($scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;

        loadPage();


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader.addPart('supplierPanel');
            translatePartialLoader = translate.refresh();

            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


        $scope.$watch('ServiceItemform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })
    }

    var WZServiceItem = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/service-item/wizard-form.service-item.html',
        controller: WZServiceItemController,
        bindings:
            {
                serviceItem: '=?',
                isFormValid: '=?',
                companyActivityType: '=?',
                servant: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfServiceItem', WZServiceItem)

    WZServiceItemController.$inject = ['$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function WZLastStepController(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        $ctrl.__config = __config;
        loadPage();
        $ctrl.goToSite = goToSite;
        $ctrl.getWebSiteUrl = getWebSiteUrl;
        $ctrl.getFeatureListUrl = getFeatureListUrl;
        $ctrl.getHelpUrl = getHelpUrl;


        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();

            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        function goToSite() {

            if ($ctrl.wizardData.company && $ctrl.wizardData.company.keyUrl) {
                var websiteUrl = $ctrl.wizardData.company.keyUrl + '.' + __config.domain;
                window.open('http://' + websiteUrl, '_blank');
            }

        }

        function getWebSiteUrl() {
            if ($ctrl.wizardData.company && $ctrl.wizardData.company.keyUrl)
                return ($ctrl.wizardData.company.keyUrl + '.' + __config.domain);
        }

        function getFeatureListUrl() {
            if ($ctrl.__config.appMode == 'reserve') {
                if ($ctrl.__config.appName && $ctrl.__config.appName == "planovin") {
                    return "https://planovin.com/features";
                } else {
                    return "https://www.reserweb.ir/intro/featurelist.html";
                }

            }
        }

        function getHelpUrl() {
            if ($ctrl.__config.appMode == 'reserve') {
                if ($ctrl.__config.appName && $ctrl.__config.appName == "planovin") {
                    return "https://planovin.com/help";
                } else
                    return "https://help.reserweb.ir/";
            }
            if ($ctrl.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

    }

    var WZLastStep = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/last-step/wizard-form.last-step.html',
        controller: WZLastStepController,
        bindings:
            {
                wizardData: '='
            }

    };

    angular
        .module('tikonApp')
        .component('wzfLastStep', WZLastStep)

    WZLastStepController.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function WZCompanyScheduleController($scope, $timeout, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        loadPage();

        function initSchedule() {
            $timeout(function () {
                $ctrl.schedule = {};
                $ctrl.schedule.weeklyScheduleInfo = {};
                $ctrl.schedule.weeklyScheduleInfo.timePeriod = {};
                var startTime = new Date();
                startTime.setHours(8, 0, 0, 0);
                var endTime = new Date();
                endTime.setHours(17, 0, 0, 0);
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime = startTime;
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime = endTime;
                $ctrl.schedule.weeklyScheduleInfo.weekdays = [];
                angular.forEach(DAYS_VALUES, function (val) {
                    var weekday = {};
                    if (val != 'FRIDAY') {
                        weekday.weekday = val;
                        //weekday.timePeriod = $ctrl.schedule.weeklyScheduleInfo.timePeriod;
                        $ctrl.schedule.weeklyScheduleInfo.weekdays.push(weekday);
                    }
                });
            }, 500);


        }

        function loadAll() {
            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            initSchedule();
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        $scope.$watch('CompanyScheduleform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })


    }

    var WZCompanySchedule = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/company-schedule/wizard-form.company-schedule.html',
        controller: WZCompanyScheduleController,
        bindings:
            {
                schedule: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanySchedule', WZCompanySchedule)

    WZCompanyScheduleController.$inject = ['$scope', '$timeout', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function WZCompanyInfoController(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, CompanyCustom) {

        var $ctrl = this;
        $ctrl.checkCompanyKeyUrlIsValid = checkCompanyKeyUrlIsValid;
        $ctrl.isUrlValid = null;
        $ctrl.searchText = '';
        $ctrl.querySearch = querySearch;
        $ctrl.activityTypes = [];
        $ctrl.isDisabled = false;
        $ctrl.__config = __config;

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {


            translatePartialLoader.addPart('activityType');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            //

            loadAllActivityTypes();

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        function loadAllActivityTypes() {
            $ctrl.activityTypes = CompanyCustom.getCompanyActivityTypes();
        }

        function checkCompanyKeyUrlIsValid(onValidate) {
            if ($ctrl.company == null || $ctrl.company == undefined)
                return;

            if ($ctrl.company.keyUrl != undefined && $ctrl.company.keyUrl != null && $ctrl.company.keyUrl.length > 2) {
                $ctrl.company.keyUrl = $ctrl.company.keyUrl.toLowerCase();
                CompanyCustom.findCompanyByKeyURL($ctrl.company.keyUrl.trim()).query().$promise.then(onValidate);
            }
        }

        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.activityTypes, function (item) {
                if (item.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.activityTypes;
                }
            })

            return temp;

        }


        $scope.$watch('companyinfoform.$valid', function (isValid) {

            $ctrl.formisValid = isValid;
            if (isValid && $ctrl.isUrlValid) {
                $ctrl.isFormValid(isValid);
            } else {
                $ctrl.isFormValid(false);
            }

        })

        $scope.$watch('$ctrl.company.keyUrl', function () {

            checkCompanyKeyUrlIsValid(function (result) {
                if (result != null && result.id != null) {
                    $ctrl.isUrlValid = false;
                } else {
                    $ctrl.isUrlValid = true;
                }

                if ($ctrl.isUrlValid && $ctrl.formisValid) {
                    $ctrl.isFormValid(true);
                } else {
                    $ctrl.isFormValid(false);
                }
            });

        });


    }

    var WZCompanyInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/company-info/wizard-form.company-info.html',
        controller: WZCompanyInfoController,
        bindings:
            {
                company: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanyInfo', WZCompanyInfo)

    WZCompanyInfoController.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'CompanyCustom'];


})();

;
var DAYS_NAMES = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
var DAYS_VALUES = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
(function () {
    'use strict';

    function WeeklyWorkDaysV2Controller($scope, $state, translate, translatePartialLoader, $mdDialog) {
        var $ctrl = this;

        $ctrl.checkedDays = checkAllAsDefault();
        $ctrl.checkedDays = getCheckedDays();
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.allWeekDays = getAllWeekDays();
        //console.log('checked days :')
        //console.log($ctrl.checkedDays);
        //console.log('all week days :')
        //console.log($ctrl.allWeekDays);
        var defaultStartTime = new Date();
        var defaultEndTime = new Date();
        var inited = false;


        //
        $scope.$watch('$ctrl.selectedWeeklyScheduleInfo', function () {
            //   console.log($ctrl.selectedWeeklyScheduleInfo);
            //       if($ctrl.selectedWeeklyScheduleInfo.weekdays!=undefined) {
            $scope.$watch('$ctrl.selectedWeeklyScheduleInfo.weekdays', function () {
                if ($ctrl.selectedWeeklyScheduleInfo && $ctrl.selectedWeeklyScheduleInfo.weekdays) {

                    if (!inited) {
                        inited = true;
                        $ctrl.checkedDays = getCheckedDays();
                        $ctrl.allWeekDays = getAllWeekDays();
                    }
                }

            }, true);


            //     }


        }, true);

        function onCheckChanged() {
            setCheckedDays();
        }

        function checkAllAsDefault() {
            var retChekDays = [];
            //angular.forEach(DAYS_VALUES, function (val) {
            //    retChekDays.push(val);
            //});
            return retChekDays;
        }

        function getCheckedDays() {


            if ($ctrl.selectedWeeklyScheduleInfo != undefined && $ctrl.selectedWeeklyScheduleInfo.weekdays != undefined) {
                var weekDays = $ctrl.selectedWeeklyScheduleInfo.weekdays;
                if (weekDays.length > 0) {
                    var retChekDays = [];
                    angular.forEach(weekDays, function (val) {
                        retChekDays.push(val.weekday);
                    });
                    return retChekDays;

                }
            }
            return $ctrl.checkedDays;
        }

        function setCheckedDays() {

            $ctrl.selectedWeeklyScheduleInfo.weekdays = [];
            angular.forEach($ctrl.allWeekDays, function (val) {
                if (val.checked) {

                    $ctrl.selectedWeeklyScheduleInfo.weekdays.push({weekday: val.value, timePeriod: val.timePeriod});
                }
            });


        }

        function getAllWeekDays() {
            var retList = [];

            for (var i = 0; i < 7; i++) {
                var tp = null;

                var hasChecked = $ctrl.checkedDays.indexOf(DAYS_VALUES[i]) > -1;
                if (hasChecked) {
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == DAYS_VALUES[i]) {

                            tp = val.timePeriod;


                        }
                    });

                    // timePeriod = $ctrl.checkedDays[$ctrl.checkedDays.indexOf(DAYS_VALUES[i])].timePeriod;
                    // console.log('it has checked and time priod is:');
                    // console.log(timePeriod);
                }
                var weekDay = {
                    value: DAYS_VALUES[i],
                    name: DAYS_NAMES[i],
                    checked: hasChecked,
                    timePeriod: tp
                };
                retList.push(weekDay);

            }
            return retList;
        }

        function openEditTimeDialog(day) {

            $mdDialog.show({
                controller: EditTimeDialogController,
                templateUrl: 'app/components/partial-forms/weekly-work-days-v2/select-time-dialog-v2.template.html',
                locals: {dialogData: day},
                controllerAs: 'vm',
                targetEvent: day,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false
            })
                .then(function (answer) {
                    setCheckedDays();
                }, function () {
                    setCheckedDays();
                });

        };


        $ctrl.open = function (selectedDay) {

            //if the selected day has it own time period
            if (selectedDay.checked) {


                getDefaultTimePeriod(selectedDay, $ctrl.selectedWeeklyScheduleInfo.timePeriod);


                openEditTimeDialog(selectedDay);
                //show the time period dialog
                //DialogService.showDialog('app/components/partial-forms/weekly-work-days-v2/select-time-dialog-v2.template.html', $scope).then(function (e) {
                //    //if time has changed
                //
                //    if ($scope.startTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime ||
                //        $scope.endTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime
                //    ) {
                //
                //        var timePeriod = {startTime: $scope.startTime, endTime: $scope.endTime}
                //        selectedDay.timePeriod = timePeriod;
                //        angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                //            //  console.log(val.weekday);
                //
                //            if (val.weekday == selectedDay.value) {
                //
                //                val.timePeriod = selectedDay.timePeriod;
                //
                //            }
                //        });
                //        //angular.forEach( $ctrl.allWeekDays,function(val){
                //        //    //  console.log(val.weekday);
                //        //
                //        //    if(val.value==selectedDay.value) {
                //        //
                //        //        val.timePeriod=selectedDay.timePeriod;
                //        //
                //        //    }
                //        //});
                //
                //    }
                //
                //}, function (e) {//console.log('dialog result');
                //});
            }
        };

        function getDefaultTimePeriod(day, defaultTimePeriod) {
            if (!day.timePeriod) {
                if (defaultTimePeriod && defaultTimePeriod.startTime)
                    defaultStartTime = defaultTimePeriod.startTime;
                if (defaultTimePeriod && defaultTimePeriod.endTime)
                    defaultEndTime = defaultTimePeriod.endTime;
                day.timePeriod = {startTime: defaultStartTime, endTime: defaultEndTime, offtimes: []}
            }

        }

        $ctrl.ok = function () {
            $scope.showModal = false;
        };

        $ctrl.cancel = function () {
            $scope.showModal = false;
        };

    }

    var WeeklyWorkDaysV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/weekly-work-days-v2/partial-form.weekly-work-days-v2.html',
        controller: WeeklyWorkDaysV2Controller,
        bindings: {
            selectedWeeklyScheduleInfo: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfWeeklyWorkDaysV2', WeeklyWorkDaysV2)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    WeeklyWorkDaysV2Controller.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog'];
    var EditTimeDialogController = function ($scope, $mdDialog, dialogData) {

        var vm = this;
        vm.tp = dialogData.timePeriod;
        vm.day = dialogData;


        vm.hideDialog = function () {
            $mdDialog.hide();
        };

        vm.cancelDialog = function () {
            $mdDialog.cancel();
        };

    }
    EditTimeDialogController.$inject = ['$scope', '$mdDialog', 'dialogData'];


})();

;
var DAYS_NAMES = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
var DAYS_VALUES = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
(function () {
    'use strict';

    function WeeklyWorkDaysController($scope, $state, translate, translatePartialLoader, DialogService) {
        var $ctrl = this;

        $ctrl.checkedDays = checkAllAsDefault();
        $ctrl.checkedDays = getCheckedDays();
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.allWeekDays = getAllWeekDays();

        //
        $scope.$watch('$ctrl.selectedWeeklyScheduleInfo', function () {
            //       if($ctrl.selectedWeeklyScheduleInfo.weekdays!=undefined) {
            $scope.$watch('$ctrl.selectedWeeklyScheduleInfo.weekdays', function () {

                $ctrl.checkedDays = getCheckedDays();
                $ctrl.allWeekDays = getAllWeekDays();

            }, true);


            //     }


        }, true);

        function onCheckChanged() {


            setCheckedDays();
        }

        function checkAllAsDefault() {
            var retChekDays = [];
            //angular.forEach(DAYS_VALUES, function (val) {
            //    retChekDays.push(val);
            //});
            return retChekDays;
        }

        function getCheckedDays() {


            if ($ctrl.selectedWeeklyScheduleInfo != undefined && $ctrl.selectedWeeklyScheduleInfo.weekdays != undefined) {
                var weekDays = $ctrl.selectedWeeklyScheduleInfo.weekdays;
                if (weekDays.length > 0) {
                    var retChekDays = [];
                    angular.forEach(weekDays, function (val) {
                        retChekDays.push(val.weekday);
                    });
                    return retChekDays;

                }
            }
            return $ctrl.checkedDays;
        }

        function setCheckedDays() {

            $ctrl.selectedWeeklyScheduleInfo.weekdays = [];
            angular.forEach($ctrl.allWeekDays, function (val) {
                if (val.checked) {

                    $ctrl.selectedWeeklyScheduleInfo.weekdays.push({weekday: val.value, timePeriod: val.timePeriod});
                }
            });


        }

        function getAllWeekDays() {
            var retList = [];

            for (var i = 0; i < 7; i++) {
                var timePeriod;
                var hasChecked = $ctrl.checkedDays.indexOf(DAYS_VALUES[i]) > -1;
                if (hasChecked) {
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == DAYS_VALUES[i]) {

                            timePeriod = val.timePeriod;

                        }
                    });

                    // timePeriod = $ctrl.checkedDays[$ctrl.checkedDays.indexOf(DAYS_VALUES[i])].timePeriod;
                    // console.log('it has checked and time priod is:');
                    // console.log(timePeriod);
                }
                var weekDay = {
                    value: DAYS_VALUES[i],
                    name: DAYS_NAMES[i],
                    checked: hasChecked,
                    timePeriod: timePeriod
                };
                retList.push(weekDay);

            }
            return retList;
        }


        $ctrl.open = function (selectedDay) {
            //if the selected day has it own time period
            if (selectedDay.timePeriod) {
                $scope.startTime = selectedDay.timePeriod.startTime;
                $scope.endTime = selectedDay.timePeriod.endTime;
            }
            //if not use the general time period
            else {
                $scope.startTime = $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime;
                $scope.endTime = $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime;
            }
            //show the time period dialog
            DialogService.showDialog('app/components/partial-forms/weekly-work-days/select-time-dialog.template.html', $scope).then(function (e) {
                //if time has changed
                if ($scope.startTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime ||
                    $scope.endTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime
                ) {

                    var timePeriod = {startTime: $scope.startTime, endTime: $scope.endTime}
                    selectedDay.timePeriod = timePeriod;
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == selectedDay.value) {

                            val.timePeriod = selectedDay.timePeriod;

                        }
                    });
                    //angular.forEach( $ctrl.allWeekDays,function(val){
                    //    //  console.log(val.weekday);
                    //
                    //    if(val.value==selectedDay.value) {
                    //
                    //        val.timePeriod=selectedDay.timePeriod;
                    //
                    //    }
                    //});

                }

            }, function (e) {//console.log('dialog result');
            });
        };

        $ctrl.ok = function () {
            $scope.showModal = false;
        };

        $ctrl.cancel = function () {
            $scope.showModal = false;
        };

    }

    var WeeklyWorkDays = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/weekly-work-days/partial-form.weekly-work-days.html',
        controller: WeeklyWorkDaysController,
        bindings: {
            selectedWeeklyScheduleInfo: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfWeeklyWorkDays', WeeklyWorkDays)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    WeeklyWorkDaysController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', 'DialogService'];


})();

;
var DAYS_NAMES = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
var DAYS_VALUES = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
(function () {
    'use strict';

    function WeeklyDaySelectController($scope, $state, translate, translatePartialLoader, DialogService) {
        var $ctrl = this;

        $ctrl.checkedDays = checkAllAsDefault();
        $ctrl.checkedDays = getCheckedDays();
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.allWeekDays = getAllWeekDays();

        //
        $scope.$watch('$ctrl.selectedWeeklyScheduleInfo', function () {
            //       if($ctrl.selectedWeeklyScheduleInfo.weekdays!=undefined) {
            $scope.$watch('$ctrl.selectedWeeklyScheduleInfo.weekdays', function () {

                $ctrl.checkedDays = getCheckedDays();
                $ctrl.allWeekDays = getAllWeekDays();

            }, true);


            //     }


        }, true);

        function onCheckChanged() {


            setCheckedDays();
        }

        function checkAllAsDefault() {
            var retChekDays = [];
            //angular.forEach(DAYS_VALUES, function (val) {
            //    retChekDays.push(val);
            //});
            return retChekDays;
        }

        function getCheckedDays() {


            if ($ctrl.selectedWeeklyScheduleInfo != undefined && $ctrl.selectedWeeklyScheduleInfo.weekdays != undefined) {
                var weekDays = $ctrl.selectedWeeklyScheduleInfo.weekdays;
                if (weekDays.length > 0) {
                    var retChekDays = [];
                    angular.forEach(weekDays, function (val) {
                        retChekDays.push(val.weekday);
                    });
                    return retChekDays;

                }
            }
            return $ctrl.checkedDays;
        }

        function setCheckedDays() {

            $ctrl.selectedWeeklyScheduleInfo.weekdays = [];
            angular.forEach($ctrl.allWeekDays, function (val) {
                if (val.checked) {

                    $ctrl.selectedWeeklyScheduleInfo.weekdays.push({weekday: val.value, timePeriod: val.timePeriod});
                }
            });


        }

        function getAllWeekDays() {
            var retList = [];

            for (var i = 0; i < 7; i++) {
                var timePeriod;
                var hasChecked = $ctrl.checkedDays.indexOf(DAYS_VALUES[i]) > -1;
                if (hasChecked) {
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == DAYS_VALUES[i]) {

                            timePeriod = val.timePeriod;

                        }
                    });

                    // timePeriod = $ctrl.checkedDays[$ctrl.checkedDays.indexOf(DAYS_VALUES[i])].timePeriod;
                    // console.log('it has checked and time priod is:');
                    // console.log(timePeriod);
                }
                var weekDay = {
                    value: DAYS_VALUES[i],
                    name: DAYS_NAMES[i],
                    checked: hasChecked,
                    timePeriod: timePeriod
                };
                retList.push(weekDay);

            }
            return retList;
        }


        $ctrl.open = function (selectedDay) {
            //if the selected day has it own time period
            if (selectedDay.timePeriod) {
                $scope.startTime = selectedDay.timePeriod.startTime;
                $scope.endTime = selectedDay.timePeriod.endTime;
            }
            //if not use the general time period
            else {
                $scope.startTime = $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime;
                $scope.endTime = $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime;
            }
            //show the time period dialog
            DialogService.showDialog('app/components/partial-forms/weekly-work-days/select-time-dialog.template.html', $scope).then(function (e) {
                //if time has changed
                if ($scope.startTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime ||
                    $scope.endTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime
                ) {

                    var timePeriod = {startTime: $scope.startTime, endTime: $scope.endTime}
                    selectedDay.timePeriod = timePeriod;
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == selectedDay.value) {

                            val.timePeriod = selectedDay.timePeriod;

                        }
                    });
                    //angular.forEach( $ctrl.allWeekDays,function(val){
                    //    //  console.log(val.weekday);
                    //
                    //    if(val.value==selectedDay.value) {
                    //
                    //        val.timePeriod=selectedDay.timePeriod;
                    //
                    //    }
                    //});

                }

            }, function (e) {//console.log('dialog result');
            });
        };

        $ctrl.ok = function () {
            $scope.showModal = false;
        };

        $ctrl.cancel = function () {
            $scope.showModal = false;
        };

    }

    var WeeklyDaySelect = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/weekly-day-select/partial-form.weekly-day-select.html',
        controller: WeeklyDaySelectController,
        bindings: {
            selectedDays: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfWeeklyDaySelect', WeeklyDaySelect)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    WeeklyDaySelectController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', 'DialogService'];


})();

;
(function () {
  "use strict";

  function WithdrawWalletBalanceController(
    $mdDialog,
    $mdToast,
    WalletService,
    AlertToastService
  ) {
    var $ctrl = this;

    $ctrl.walletBalance = 0;
    $ctrl.selectionMode = "all";
    $ctrl.customAmount = 0;

    $ctrl.$onInit = function () {
      loadWallet();
      // Default: if balance is less than request, prep the custom amount
      $ctrl.customAmount = Math.min($ctrl.walletBalance, $ctrl.withdrawAmount);
    };

    function loadWallet() {
      WalletService.getCustomerWalletByCustomerId($ctrl.customerId).query(
        function (data) {
          $ctrl.walletBalance = data.totalBalance || 0;
          // Re-calculate default in case data was empty initially
          $ctrl.customAmount = Math.min(
            $ctrl.walletBalance,
            $ctrl.withdrawAmount
          );
        }
      );
    }

    $ctrl.onModeChange = function () {
      if ($ctrl.selectionMode === "all") {
        $ctrl.customAmount = Math.min(
          $ctrl.walletBalance,
          $ctrl.withdrawAmount
        );
      }
    };

    $ctrl.getAppliedAmount = function () {
      if ($ctrl.selectionMode === "all")
        return Math.min($ctrl.walletBalance, $ctrl.withdrawAmount);
      return Math.min(
        $ctrl.customAmount,
        $ctrl.walletBalance,
        $ctrl.withdrawAmount
      );
    };

    $ctrl.getRemainingAmount = function () {
      return Math.max(0, $ctrl.withdrawAmount - $ctrl.getAppliedAmount());
    };

    $ctrl.cancel = function () {
      $mdDialog.cancel();
    };

    $ctrl.approveWithdraw = function () {
      var payload = {
        customerId: $ctrl.customerId,
        amount: $ctrl.getAppliedAmount(),
        amountUnit: "TOMAN"
      };

      if ($ctrl.orderBagId) payload["orderBagId"] = $ctrl.orderBagId;
      if ($ctrl.invoiceInfoId) payload["invoiceInfoId"] = $ctrl.invoiceInfoId;

      WalletService.payWalletForCusomerByAdmin().save(
        payload,
        onSuccess,
        onError
      );
    };

    function onSuccess(res) {
      $mdDialog.hide(res);
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("پرداخت با موفقیت انجام شد")
          .position("top left")
      );
    }

    function onError(err) {
      var message = "خطا در پردازش کیف پول";
      if (err && err.data && err.data.result)
        message = "error.wallet." + err.data.result;
      AlertToastService.error(message, message, null);
    }

    $ctrl.getMaxAllowed = function () {
      return Math.min($ctrl.walletBalance, $ctrl.withdrawAmount);
    };
  }

  // Explicit dependency injection
  WithdrawWalletBalanceController.$inject = [
    "$mdDialog",
    "$mdToast",
    "WalletService",
    "AlertToastService"
  ];

  angular.module("tikonApp").component("pfWithdrawWalletBalance", {
    templateUrl: "app/components/partial-forms/wallet/withdraw-balance-wallet.html",
    controller: WithdrawWalletBalanceController,
    bindings: {
      customerId: "<",
      withdrawAmount: "<",
      orderBagId: "<?",
      invoiceInfoId: "<?"
    }
  });
})();
;
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WalletService', WalletService);

    WalletService.$inject = ['$resource'];

    function WalletService($resource) {

        //see wallet amount

        var getCustomerWalletByCustomerId = function (customerId) {
            var resourceUrl = 'api/customer-wallets/' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var addWalletBallanceByCustomerId = function (customerId) {
            var resourceUrl = 'api/customer-credits/'+ customerId ;
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        };

         var payWalletForCusomerByAdmin = function (customerId) {
            var resourceUrl = 'api/wallet/pay';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        };

        var getCreditOfCusomerId = function (customerId) {
            var resourceUrl = 'api/customer-credits/' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var deleteCredit = function (customerId, creditId) {
            var resourceUrl = 'api/customer-credits/' + customerId + '/' + creditId;
            return $resource(resourceUrl, {}, {
                    'delete': {method: 'DELETE', isArray: false}
                }
            );
        };


        return {
            getCustomerWalletByCustomerId: getCustomerWalletByCustomerId,
            addWalletBallanceByCustomerId: addWalletBallanceByCustomerId,
            payWalletForCusomerByAdmin: payWalletForCusomerByAdmin,
            getCreditOfCusomerId: getCreditOfCusomerId,
            deleteCredit: deleteCredit

        };
    }
})();
;
(function () {
    'use strict';

    function AddWalletBalanceController($scope, $translate, $mdDialog, $mdToast, WalletService) {

        var $ctrl = this;

        $ctrl.balance = {
            amount: null,
            method: null,
            note: '',
            sourceType: 'MANUAL',
            amountUnit: 'TOMAN'
        };

        $ctrl.addBalance = function () {
            addWalletBalanceByCustomerId($ctrl.balance);
        };

        $ctrl.cancel = function () {
            $mdDialog.cancel();
        };

        function addWalletBalanceByCustomerId(balance) {
            WalletService.addWalletBallanceByCustomerId($ctrl.customerId)
                .save(balance, onSuccess, onError);
        }

        function onSuccess(res) {

            $mdDialog.hide(res);

            $mdToast.show(
                $mdToast.simple()
                    .textContent('افزایش موجودی با موفقیت انجام شد')
                    .position('top left')
                    .hideDelay(4000)
                    .theme('success-toast')
            );
        }

        function onError() {

            $mdDialog.hide();

            $mdToast.show(
                $mdToast.simple()
                    .textContent('خطایی در افزایش موجودی رخ داده است')
                    .position('top left')
                    .hideDelay(4000)
                    .theme('error-toast')
            );
        }
    }

    var AddWalletBalanceComponent = {
        templateUrl: 'app/components/partial-forms/wallet/add-balance-wallet.html',
        controller: AddWalletBalanceController,
        bindings: {
           customerId: '<'
        }
    };

    angular
        .module('tikonApp')
        .component('pfAddWalletBalance', AddWalletBalanceComponent);

    AddWalletBalanceController.$inject = ['$scope', '$translate', '$mdDialog', '$mdToast', 'WalletService'];

})();
;
(function () {
    'use strict';

    function VideoCallSettingComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.videoPlatformChanged = videoPlatformChanged;

        loadAll();
        loadPage();

        function loadAll() {
        }

        function loadPage(page) {
            translatePartialLoader.addPart('videoCallSettingInfo');
            translatePartialLoader.addPart('videoPlatformType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            if (!$ctrl.mode) {
                $ctrl.mode = 'COMPANY_SETTING';
            }

        }

        function videoPlatformChanged() {

        }

    }

    var VideoCallSettingComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/video-call-setting/partial-form.video-call-setting.html',
        controller: VideoCallSettingComponentController,
        bindings:
            {
                videoCallSettingInfo: '=',
                mode: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfVideoCallSetting', VideoCallSettingComponent)

    VideoCallSettingComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function TimePeriodOffTimesController($scope, $state, translate, translatePartialLoader, AlertService) {
        var $ctrl = this;

        $ctrl.offTimes = getOfftimes();
        $ctrl.onAddtime = onAddtime;
        $ctrl.onRemovetime = onRemovetime;


        function setOffTime() {
            if ($ctrl.selectedTimePeriod != undefined) {
                $ctrl.selectedTimePeriod.offtimes = [];
                angular.forEach($ctrl.offTimes, function (val) {
                    $ctrl.selectedTimePeriod.offtimes.push({fromTime: val.fromTime, toTime: val.toTime});
                });
            }
        }

        function onAddtime() {
            //
            if ($ctrl.fromTime != null && $ctrl.toTime != null) {


                var isValid = true;
                angular.forEach($ctrl.offTimes, function (val) {
                    if (timesHasConflict(val, {fromTime: $ctrl.fromTime, toTime: $ctrl.toTime}))
                        isValid = false;
                });
                if (isValid) {
                    $ctrl.offTimes.push({
                        name: TimeDurationAsString({fromTime: $ctrl.fromTime, toTime: $ctrl.toTime}),
                        fromTime: $ctrl.fromTime,
                        toTime: $ctrl.toTime
                    });

                }
            }
            setOffTime();

        }

        $scope.$watch('$ctrl.selectedTimePeriod', function () {
            //   if( $ctrl.selectedDatePeriod.offdays!=undefined) {
            $scope.$watch('$ctrl.selectedTimePeriod.offtimes', function () {

                $ctrl.offTimes = getOfftimes();

            });
            //   }


        }, true);

        function timesHasConflict(t1, t2) {
            var hasConflict = ((t1.fromTime > t1.toTime) || (t2.fromTime > t2.toTime) || (t1.fromTime < t2.fromTime && t2.fromTime < t1.toTime) ||
                (t1.fromTime < t2.toTime && t2.toTime < t1.toTime)
            );
            if (hasConflict) AlertService.warning('در زمانهای اضاقه شده تداخل وجود دارد');
            return hasConflict;
        }

        function onRemovetime(date) {
            if ($ctrl.offTimes != undefined)
                $ctrl.offTimes = $ctrl.offTimes.filter(function (item) {
                    //
                    return item.fromTime !== date.fromTime || item.toTime !== date.toTime;
                });
            setOffTime();

        }

        function getOfftimes() {
            //
            var retoffTimes = [];

            if ($ctrl.selectedTimePeriod != undefined && $ctrl.selectedTimePeriod.offtimes != undefined) {
                var offtimes = $ctrl.selectedTimePeriod.offtimes;
                angular.forEach(offtimes, function (val) {
                    var persianDate = TimeDurationAsString({
                        fromTime: new Date(val.fromTime),
                        toTime: new Date(val.toTime)
                    });
                    retoffTimes.push({
                        name: persianDate,
                        fromTime: new Date(val.fromTime),
                        toTime: new Date(val.toTime)
                    });
                });
            }
            return retoffTimes;
        }

        function TimeDurationAsString(duration) {
            return duration.fromTime.getHours() + ':' + duration.fromTime.getMinutes() + ' - ' + duration.toTime.getHours() + ':' + duration.toTime.getMinutes();
        }

    }

    var TimePeriodOffTimes = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/time-period-off-times/partial-form.time-period-off-times.html',
        controller: TimePeriodOffTimesController,
        bindings: {
            selectedTimePeriod: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfTimePeriodOffTimes', TimePeriodOffTimes)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    TimePeriodOffTimesController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', 'AlertService'];


})();

;
(function () {
    'use strict';

    function SmsTextEditorComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.equivalentList = [];
        $ctrl.onEquivalentClick = onEquivalentClick;
        $ctrl.id = "field_sms_editor_" + Math.floor(Math.random() * 10000) + 1;


        loadAll();
        loadPage();

        function loadAll() {
            init();
        }

        function loadPage(page) {
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

        }

        function init() {
            initEquivalents();
        }

        function onEquivalentClick(item) {


            var textarea = document.getElementById($ctrl.id);
            var start_position = textarea.selectionStart;
            var end_position = textarea.selectionEnd;


            if (item) {
                var temp = textarea.value;
                textarea.value = temp.substring(0, start_position) + item.action + temp.substring(end_position, textarea.value.length);
            }
            $ctrl.smsText = textarea.value
        }

        function initEquivalents() {
            $ctrl.equivalentList = [];

            var eq = {};
            eq.title = 'نام کوچک مشتری';
            eq.action = '$CustomerFirstName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام خانوادگی مشتری';
            eq.action = '$CustomerLastName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام کامل مشتری';
            eq.action = '$CustomerName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'موبایل مشتری';
            eq.action = '$CustomerPhoneNumber$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'شماره رزرو';
            eq.action = '$ReserveNumber$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'تاریخ رزرو';
            eq.action = '$ReserveDate$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'زمان رزرو';
            eq.action = '$ReserveTime$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'زمان پایان رزرو';
            eq.action = '$ReserveEndTime$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'عنوان کسب و کار';
            eq.action = '$CompanyTitle$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'تلفن کسب و کار';
            eq.action = '$CompanyPhoneNumber$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'آدرس کسب و کار';
            eq.action = '$CompanyAddress$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام خدمت';
            eq.action = '$ServiceTitle$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام پرسنل';
            eq.action = '$ServantName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'تاریخ مهلت پرداخت';
            eq.action = '$ConfirmationDeadlineDate$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'زمان مهلت پرداخت';
            eq.action = '$ConfirmationDeadlineTime$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'قیمت نهایی(str)';
            eq.action = '$FinalPriceStr$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'قیمت نهایی';
            eq.action = '$FinalPrice$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'خدمات افزوده';
            eq.action = '$ServiceItemOptionTitle$';
            $ctrl.equivalentList.push(eq);
            //.................................

        }

    }

    var SmsTextEditorComponent = {

        templateUrl: 'app/components/partial-forms/sms-text-editor/partial-form.sms-text-editor.html',
        controller: SmsTextEditorComponentController,
        bindings:
            {
                smsText: '=',
                label: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfSmsTextEditor', SmsTextEditorComponent)

    SmsTextEditorComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .component('pfSmsPanelOverview', {
            templateUrl: 'app/components/partial-forms/sms-panel-overview/partial-form.sms-panel-overview.html',
            controller: SmsPanelOverviewComponentController,
            bindings: {
                marketingCampaign: '<',
                onConfirm: '&?',
                onCancel: '&?',
                showActionButtons: '<?'
            }
        });

    SmsPanelOverviewComponentController.$inject = [
        'MarketingCampaignCustom',
        'AlertToastService'
    ];

    function SmsPanelOverviewComponentController(
        MarketingCampaignCustom,
        AlertToastService
    ) {
        var $ctrl = this;

        $ctrl.smsPanelOverview = null;
        $ctrl.loading = false;
        $ctrl.error = false;
        $ctrl.noCustomerSelected = false;

        $ctrl.$onInit = onInit;
        $ctrl.$onChanges = onChanges;
        $ctrl.getSmsPanelOverview = getSmsPanelOverview;
        $ctrl.confirm = confirm;
        $ctrl.cancel = cancel;

        function onInit() {

            if (angular.isUndefined($ctrl.showActionButtons)) {
                $ctrl.showActionButtons = true;
            }

            if ($ctrl.marketingCampaign) {
                getSmsPanelOverview();
            }
        }

        function onChanges(changes) {
            if (
                changes.marketingCampaign &&
                !changes.marketingCampaign.isFirstChange() &&
                changes.marketingCampaign.currentValue
            ) {
                getSmsPanelOverview();
            }
        }

        function getSmsPanelOverview() {
            if (!$ctrl.marketingCampaign) {
                return;
            }

            $ctrl.loading = true;
            $ctrl.error = false;
            $ctrl.noCustomerSelected = false;
            $ctrl.smsPanelOverview = null;

            MarketingCampaignCustom
                .getSmsPanelOverView()
                .save(
                    angular.copy($ctrl.marketingCampaign),
                    onSaveSuccess,
                    onSaveError
                );
        }

        function onSaveSuccess(data) {
            $ctrl.loading = false;
            $ctrl.smsPanelOverview = data;

            $ctrl.noCustomerSelected =
                !data ||
                !data.totalCompanyCustomersCount ||
                data.totalCompanyCustomersCount <= 0;
        }

        function onSaveError(error) {
            $ctrl.loading = false;
            $ctrl.error = true;
            $ctrl.noCustomerSelected = false;

            AlertToastService.error(
                'خطا در دریافت اطلاعات پیامک',
                null,
                null
            );
        }

        function confirm() {
            if (
                !$ctrl.smsPanelOverview ||
                $ctrl.noCustomerSelected
            ) {
                return;
            }

            if ($ctrl.onConfirm) {
                $ctrl.onConfirm({
                    overview: $ctrl.smsPanelOverview
                });
            }
        }

        function cancel() {
            if ($ctrl.onCancel) {
                $ctrl.onCancel();
            }
        }
    }

})();;
(function () {
    'use strict';

    function SettingInfoComponentController(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $stateParams, CompanyCustom) {
        //
        var color_red = '#e1655d';
        var color_blue = '#00A4CC';
        var color_green = '#2BAE66';
        var color_pink = '#DF6589';
        var color_purple = '#5D4494';
        var color_darkBlue = '#1A2238';
        var color_orange = '#F2AA4C';


        var $ctrl = this;
        $ctrl.__config = __config;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.resultx = 'x';
        $ctrl.sendBookingConfirmationSMS = false;
        $ctrl.sendBookingConfirmationEMAIL = false;
        $ctrl.switch_changed = switch_changed;
        $ctrl.sampleCheck = sampleCheck;
        $ctrl.sendBookingConfirmationMSGsample = false;
        $ctrl.sendBookingConfirmationSupplierMSGsample = false;
        $ctrl.sendBookingCancellationSupplierMSGsample = false;
        $ctrl.sendCustomerReminder = false;
        $ctrl.sendCustomerSecondReminder = false;
        $ctrl.sendCustomerBirthdateNotice = false;
        $ctrl.sendCustomerWelcome = false;

        $ctrl.sendBookingConfirmationSupplierSMS = false;
        $ctrl.sendBookingConfirmationSupplierEMAIL = false;
        $ctrl.sendUserRegistrationMessageSMS = false;
        $ctrl.sendUserRegistrationMessageEMAIL = false;
        $ctrl.sendCustomerSatisfactionMessageSMS = false;
        $ctrl.sendCustomerSatisfactionMessageEMAIL = false;
        $ctrl.sendCustomerReminderSMS = false;
        $ctrl.sendCustomerReminderEMAIL = false;

        $ctrl.sendCustomerSecondReminderSMS = false;
        $ctrl.sendCustomerSecondReminderEMAIL = false;

        $ctrl.sendCustomerRebookReminderSMS = false;
        $ctrl.sendCustomerRebookReminderEMAIL = false;

        $ctrl.sendBookingCancellationSupplierSMS = false;
        $ctrl.sendBookingCancellationSupplierEMAIL = false;
        $ctrl.sendCustomerBirthdateNoticeSMS = false;
        $ctrl.sendCustomerBirthdateNoticeEmail = false;
        $ctrl.sendCustomerWelcomeSMS = false;
        $ctrl.sendCustomerWelcomeEMAIL = false;

        $ctrl.settingFormSection = $stateParams.settingFormSection;
        $ctrl.isModernTheme = isModernTheme;
        $ctrl.primaryColorSet = 'PURPLE';
        $ctrl.primaryColorSetChanged = primaryColorSetChanged;
        $ctrl.colorSetStyle = colorSetStyle;
        $ctrl.colorList = ['RED', 'BLUE', 'GREEN', 'PINK', 'PURPLE', 'ORANGE', 'DARKBLUE', 'CUSTOM']
        $ctrl.company = null

        $ctrl.test = loadSwitches;
        $ctrl.videoPlatformChanged = videoPlatformChanged;
        $ctrl.imageUploaded = imageUploaded;

        loadAll();
        loadPage();


        //loadSwitches();
        function loadAll() {


            function onSuccess(data, headers) {


            }

            function onError(error) {
                AlertService.error(error.data.message);
            }


        }

        function loadPage(page) {
            translatePartialLoader.addPart('settingInfo');
            translatePartialLoader.addPart('notificationSetting');
            translatePartialLoader.addPart('financialSetting');
            translatePartialLoader.addPart('themeSettingInfo');
            translatePartialLoader.addPart('notificationType');
            translatePartialLoader.addPart('currency');
            translatePartialLoader.addPart('imageData');
            translatePartialLoader.addPart('themeType');
            translatePartialLoader.addPart('themeHeaderType');
            translatePartialLoader.addPart('themeServiceListType');
            translatePartialLoader.addPart('videoCallSettingInfo');
            translatePartialLoader.addPart('videoPlatformType');
            translatePartialLoader.addPart('visibilityStatus');

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            findCurrentCompany()
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


        function country_changed() {
            //
            //if(vm.SettingInfo.locationInfo.countryId!=null)
            //    vm.provinceList=SelectorDataQuery.findByTypeAndParent('province',vm.SettingInfo.locationInfo.countryId).query();
            //if(vm.SettingInfo.locationInfo.stateId!=null)
            //    vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.SettingInfo.locationInfo.stateId).query();
        }

        function province_changed() {
            //vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.locationInfo.stateId).query();
        }

        function sampleCheck(msg) {
            $ctrl.sendBookingConfirmationMSGsample = false;
            $ctrl.sendBookingConfirmationSupplierMSGsample = false;
            $ctrl.sendCustomerReminder = false;
            $ctrl.sendCustomerRebookReminder = false;
            $ctrl.sendCustomerSecondReminder = false;
            $ctrl.sendCustomerBirthdateNotice = false

            msg === 'sendBookingConfirmation' ? $ctrl.sendBookingConfirmationMSGsample = true : false;
            msg === 'sendBookingConfirmationSupplier' ? $ctrl.sendBookingConfirmationSupplierMSGsample = true : false;
            msg === 'sendCustomerReminder' ? $ctrl.sendCustomerReminder = true : false;
            msg === 'sendCustomerRebookReminder' ? $ctrl.sendCustomerRebookReminder = true : false;
            msg === 'sendCustomerSecondReminder' ? $ctrl.sendCustomerSecondReminder = true : false;
            msg === 'sendBookingCancellationSupplier' ? $ctrl.sendBookingCancellationSupplierMSGsample = true : false;
            msg === 'customerBirthdateNoticeMsg' ? $ctrl.sendCustomerBirthdateNotice = true : false;
            msg === 'customerWelcom' ? $ctrl.sendCustomerWelcome = true : false;
        }

        function switch_changed() {
            $ctrl.settingInfo.notificationSetting.sendBookingConfirmation = setNotificationTypes($ctrl.sendBookingConfirmationSMS, $ctrl.sendBookingConfirmationEMAIL);
            $ctrl.settingInfo.notificationSetting.sendBookingConfirmationSupplier = setNotificationTypes($ctrl.sendBookingConfirmationSupplierSMS, $ctrl.sendBookingConfirmationSupplierEMAIL);
            $ctrl.settingInfo.notificationSetting.sendUserRegistrationMessage = setNotificationTypes($ctrl.sendUserRegistrationMessageSMS, $ctrl.sendUserRegistrationMessageEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerSatisfactionMessage = setNotificationTypes($ctrl.sendCustomerSatisfactionMessageSMS, $ctrl.sendCustomerSatisfactionMessageEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerReminder = setNotificationTypes($ctrl.sendCustomerReminderSMS, $ctrl.sendCustomerReminderEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerRebookReminder = setNotificationTypes($ctrl.sendCustomerRebookReminderSMS, $ctrl.sendCustomerRebookReminderEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerSecondReminder = setNotificationTypes($ctrl.sendCustomerSecondReminderSMS, $ctrl.sendCustomerSecondReminderEMAIL);
            $ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier = setNotificationTypes($ctrl.sendBookingCancellationSupplierSMS, $ctrl.sendBookingCancellationSupplierEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerBirthdateNotice = setNotificationTypes($ctrl.sendCustomerBirthdateNoticeSMS, $ctrl.sendCustomerBirthdateNoticeEmail)
            $ctrl.settingInfo.notificationSetting.sendCustomerWelcome = setNotificationTypes($ctrl.sendCustomerWelcomeSMS, $ctrl.sendCustomerWelcomeEMAIL)
            
        }

        function setNotificationTypes(smsType, emailType) {
            var result = "NONE";
            if (smsType && !emailType)
                result = "SMS";
            if (!smsType && emailType)
                result = "EMAIL";
            if (smsType && emailType)
                result = "SMS_AND_EMAIL";

            return result;

        }


        function loadSwitches() {
            //SendBookingConfirmation
            var switchSendBookingConfirmation = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendBookingConfirmation);
            var switchSendBookingConfirmationSupplier = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendBookingConfirmationSupplier);
            var switchSendUserRegistrationMessage = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendUserRegistrationMessage);
            var switchSendCustomerSatisfactionMessage = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerSatisfactionMessage);
            var switchSendCustomerReminder = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerReminder);
            var switchSendCustomerRebookReminder = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerRebookReminder);
            var switchSendCustomerSecondReminder = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerSecondReminder);
            var switchSendBookingCancellationSupplier = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier);
            var switchSendCustomerBirthdateNotice = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerBirthdateNotice);
            var switchSendCustomerWelcome = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerWelcome);

            $ctrl.sendBookingConfirmationSMS = switchSendBookingConfirmation.SMS;
            $ctrl.sendBookingConfirmationEMAIL = switchSendBookingConfirmation.EMAIL;

            $ctrl.sendBookingConfirmationSupplierSMS = switchSendBookingConfirmationSupplier.SMS;
            $ctrl.sendBookingConfirmationSupplierEMAIL = switchSendBookingConfirmationSupplier.EMAIL;

            $ctrl.sendUserRegistrationMessageSMS = switchSendUserRegistrationMessage.SMS;
            $ctrl.sendUserRegistrationMessageEMAIL = switchSendUserRegistrationMessage.EMAIL;

            $ctrl.sendCustomerSatisfactionMessageSMS = switchSendCustomerSatisfactionMessage.SMS;
            $ctrl.sendCustomerSatisfactionMessageEMAIL = switchSendCustomerSatisfactionMessage.EMAIL;

            $ctrl.sendCustomerReminderSMS = switchSendCustomerReminder.SMS;
            $ctrl.sendCustomerReminderEMAIL = switchSendCustomerReminder.EMAIL;

            $ctrl.sendCustomerRebookReminderSMS = switchSendCustomerRebookReminder.SMS;
            $ctrl.sendCustomerRebookReminderEMAIL = switchSendCustomerRebookReminder.EMAIL;

            $ctrl.sendCustomerSecondReminderSMS = switchSendCustomerSecondReminder.SMS;
            $ctrl.sendCustomerSecondReminderEMAIL = switchSendCustomerSecondReminder.EMAIL;

            $ctrl.sendBookingCancellationSupplierSMS = switchSendBookingCancellationSupplier.SMS;
            $ctrl.sendBookingCancellationSupplierEMAIL = switchSendBookingCancellationSupplier.EMAIL;
            
            $ctrl.sendCustomerBirthdateNoticeSMS = switchSendCustomerBirthdateNotice.SMS;
            $ctrl.sendCustomerBirthdateNoticeEmail = switchSendCustomerBirthdateNotice.EMAIL;

            $ctrl.sendCustomerWelcomeSMS = switchSendCustomerWelcome.SMS;
            $ctrl.sendCustomerWelcomeEMAIL = switchSendCustomerWelcome.EMAIL;

        }

        function switchesByNotificationType(DataType) {
            var result = {};
            result.SMS = false;
            result.EMAIL = false;
            if (DataType == null)
                return result;

            if (DataType == "SMS" || DataType == "SMS_AND_EMAIL") {
                result.SMS = true;
            }
            if (DataType == "EMAIL" || DataType == "SMS_AND_EMAIL") {
                result.EMAIL = true;
            }

            return result;
        }


        function isModernTheme() {
            if ($ctrl.settingInfo.themeSettingInfo && $ctrl.settingInfo.themeSettingInfo.themeType && $ctrl.settingInfo.themeSettingInfo.themeType == 'MODERN_THEME') {
                return true;
            }

        }

        function primaryColorSetChanged() {
            switch ($ctrl.primaryColorSet) {
                case 'RED':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_red;
                    break;
                case 'BLUE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_blue;
                    break;
                case 'GREEN':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_green;
                    break;
                case 'PINK':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_pink;
                    break;
                case 'PURPLE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_purple;
                    break;
                case 'ORANGE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_orange;
                    break;
                case 'DARKBLUE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_darkBlue;
                    break;
            }
        }

        function loadPrimaryColorSet() {
            if ($ctrl.settingInfo.themeSettingInfo.themePrimaryColor) {
                switch ($ctrl.settingInfo.themeSettingInfo.themePrimaryColor) {
                    case color_red:
                        $ctrl.primaryColorSet = 'RED';
                        break;
                    case color_blue:
                        $ctrl.primaryColorSet = 'BLUE';
                        break;
                    case color_green:
                        $ctrl.primaryColorSet = 'GREEN';
                        break;
                    case color_pink:
                        $ctrl.primaryColorSet = 'PINK';
                        break;
                    case color_purple:
                        $ctrl.primaryColorSet = 'PURPLE';
                        break;
                    case color_orange:
                        $ctrl.primaryColorSet = 'ORANGE';
                        break;
                    case color_darkBlue:
                        $ctrl.primaryColorSet = 'DARKBLUE';
                        break;
                    default :
                        $ctrl.primaryColorSet = 'CUSTOM';
                        break;
                }
            }
        }

        function colorSetStyle(colorName) {

            return 'color-' + colorName;
        }

        function videoPlatformChanged() {

        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                $ctrl.company = result
            });
        }

        $scope.$watch('$ctrl.settingInfo.notificationSetting', function () {
            if ($ctrl.settingInfo.notificationSetting) {
                if (!$ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier) {
                    $ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier = 'SMS';
                }

                loadSwitches();
            }
        })

        $scope.$watch('$ctrl.settingInfo.themeSettingInfo ', function () {

            if ($ctrl.settingInfo.themeSettingInfo) {

                if (!$ctrl.settingInfo.themeSettingInfo.themeType) {
                    $ctrl.settingInfo.themeSettingInfo.themeType = 'DEFAULT_THEME';
                }
                if (!$ctrl.settingInfo.themeSettingInfo.themeHeaderType)
                    $ctrl.settingInfo.themeSettingInfo.themeHeaderType = 'MODERN_HEADER';
                if (!$ctrl.settingInfo.themeSettingInfo.themeServiceListType)
                    $ctrl.settingInfo.themeSettingInfo.themeServiceListType = 'CARD';

                loadPrimaryColorSet();
            }
        })

        function imageUploaded(image) {
            if ($ctrl.onImageUploaded)
                $ctrl.onImageUploaded();
        }

    }

    var SettingInfoComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/setting-info/partial-form.setting-info.html',
        controller: SettingInfoComponentController,
        bindings:
            {
                settingInfo: '=',
                isInMarketPlace: '=',
                onImageUploaded: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfSettingInfo', SettingInfoComponent)

    SettingInfoComponentController.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$stateParams', 'CompanyCustom'];


})();

;
(function () {
    'use strict';

    function ServiceItemServantsController($scope, $state, ServantCustom, ServantSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $uibModal, Principal, DialogService) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        // $ctrl.activityType = '';
        $ctrl.newItem = newItem;
        $ctrl.removeServant = removeServant;
        //$ctrl.servants = null;

        $ctrl.servantToAdd = null;
        $ctrl.checkChange = checkChange;
        $ctrl.newServant = newServant;
        $ctrl.radioButtonChange = radioButtonChange;
        $ctrl.rbSelectedServantId = null;
        $ctrl.search = search;
        $ctrl.transition = transition;
        $ctrl.searchQuery = pagingParams.search;
        $ctrl.currentSearch = pagingParams.search;
        $ctrl.searchServantItem = searchServantItem;
        $ctrl.searchKeyPress = searchKeyPress;
        $ctrl.clearSearch = clearSearch;
        $ctrl.clear = clear
        $ctrl.servantItems = []
        loadAll();

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //


            ServantCustom.findServantsByCompany().query().$promise.then(function (result) {
                $ctrl.servantsByCompany = result;
                if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) {
                    if($ctrl.searchAble) {
                        $ctrl.servantItems = result;
                    }else {
                        $ctrl.servants = [];
                    }
                }
                else {
                    ServantCustom.findServantsByServiceItem($ctrl.serviceItemId).query().$promise.then(function (result) {
                        $ctrl.servants = result;
                        initSelectedItems();
                    });
                }
            });


        }

        function initSelectedItems() {

            angular.forEach($ctrl.servantsByCompany, function (v) {
                angular.forEach($ctrl.servants, function (savedServant) {
                    $ctrl.rbSelectedServantId = savedServant.id;
                    if (v.id == savedServant.id) {
                        v.selected = true;
                    }
                })
            })
            $ctrl.servantItems = $ctrl.servantsByCompany
        }

        function newItem() {
            if ($ctrl.servantToAdd) {
                var filtered = $ctrl.servants.filter(function (v) {
                    return (v.id == $ctrl.servantToAdd.id)
                });
                if (filtered.length == 0) {
                    $ctrl.servants.push({
                        id: $ctrl.servantToAdd.id,
                        title: $ctrl.servantToAdd.title,
                        level: $ctrl.servantToAdd.level,
                        personInfo: {
                            fisrtName: $ctrl.servantToAdd.personInfo.fisrtName,
                            lastName: $ctrl.servantToAdd.personInfo.lastName,
                            phoneNumber: $ctrl.servantToAdd.personInfo.phoneNumber
                        }
                    });
                    $ctrl.servantToAdd = null;
                }
            }
        }

        function removeServant(id) {

            //
            if (id) {
                $ctrl.servants = $ctrl.servants.filter(function (v) {
                        return (v.id != id)
                    }
                );
            }

        }

        function checkChange() {
            $ctrl.servants = [];
            angular.forEach($ctrl.servantsByCompany, function (servant) {
                if (servant.selected) {
                    $ctrl.servants.push({
                        id: servant.id,
                        title: servant.title,
                        level: servant.level,
                        personInfo: {
                            fisrtName: servant.personInfo.fisrtName,
                            lastName: servant.personInfo.lastName,
                            phoneNumber: servant.personInfo.phoneNumber
                        }
                    });
                }
            })


        }

        function newServant() {

            var result;
            Principal.getCurrentCompanyFeatureList();
            if ($ctrl.servantsByCompany) {
                result = Principal.canAddNewServant($ctrl.servantsByCompany.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }


            $uibModal.open({
                templateUrl: 'app/entities/servant/servant-by-company-dialog.html',
                controller: 'ServantByCompanyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: function () {
                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (v) {
                $ctrl.servantsByCompany.push(v);
                //reload();
            }, function () {
                //nothing
            });

        }


        function radioButtonChange() {
            $ctrl.servants = [];
            if ($ctrl.rbSelectedServantId) {
                angular.forEach($ctrl.servantsByCompany, function (servant) {
                    if (servant.id == $ctrl.rbSelectedServantId) {
                        $ctrl.servants.push({
                            id: servant.id,
                            title: servant.title,
                            level: servant.level,
                            personInfo: {
                                fisrtName: servant.personInfo.fisrtName,
                                lastName: servant.personInfo.lastName,
                                phoneNumber: servant.personInfo.phoneNumber
                            }
                        });
                    }
                })
            }

        }


        function search(searchQuery) {
            if (!searchQuery) {
                return  $ctrl.clear();
            }
            $ctrl.links = null;
            $ctrl.page = 1;
            $ctrl.predicate = '_score';
            $ctrl.reverse = false;
            $ctrl.currentSearch = searchQuery;
            $ctrl.transition();
        }
        function transition() {
            $state.transitionTo($state.$current, {
                page: $ctrl.page,
                sort: $ctrl.predicate + ',' + ($ctrl.reverse ? 'asc' : 'desc'),
                search: $ctrl.currentSearch
            });
        }

        function clear() {
            $ctrl.links = null;
            $ctrl.page = 1;
            $ctrl.predicate = 'id';
            $ctrl.reverse = true;
            $ctrl.currentSearch = null;
            $ctrl.transition();
        }
        function searchServantItem() {
            if (!$ctrl.searchQuery) {
                loadServantItems();
                return;
            }
            $ctrl.servantItems = $ctrl.servantsByCompany.filter(function (srv) {
                if (srv.servantName.includes($ctrl.searchQuery)) return true;
            })
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServantItem();
            }
        }
        function clearSearch() {
            $ctrl.searchQuery = null;
            searchServantItem();

        }
        function loadServantItems() {
            $ctrl.servantItems = $ctrl.servantsByCompany
        }


    }

    var ServiceItemServants = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-servants/partial-form.service-item-servants.html',
        controller: ServiceItemServantsController,
        bindings: {
            serviceItemId: '<',
            servants: '=',
            selectedId: '=?',
            formState: '=',
            activityType: '=?',
            singleSelection: '=',
            disableAddNew: '=?',
            searchAble: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemServants', ServiceItemServants)

    ServiceItemServantsController.$inject = ['$scope', '$state', 'ServantCustom', 'ServantSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$uibModal', 'Principal', 'DialogService'];


})();

;
(function () {
    'use strict';

    function ServiceItemSchedulesV2Controller($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.generateTimeInfo = generateTimeInfo;
        $ctrl.showTimingInfo = showTimingInfo;
        $ctrl.backToScheduleInfo = backToScheduleInfo;
        $ctrl.saveSchedule = saveSchedule;
        $ctrl.schSelected = false;
        $ctrl.schSaved = false;
        $ctrl.step = 0;
        $ctrl.schedulerApi = {refresh: 'not set'};
        $ctrl.generateTimesUntil = generateTimesUntil;
        $ctrl.session_date = new Date();
        $ctrl.scheduleType_changed = scheduleType_changed;
        $ctrl.canSelectMultipleTimes = false;
        $ctrl.hasDedicateSchedule = false;
        $ctrl.session_capacity = 1;
        $ctrl.gapTime = 0;
        $ctrl.session_discount = 0;
        $ctrl.showAdvancedSetting = false;


        $timeout(function () {
            loadAll();
            loadPage();

        });

        function setScheduleTypeFlags() {
            if ($ctrl.selectedScheduleInfo) {
                switch ($ctrl.selectedScheduleInfo.scheduleType) {
                    case 'BASED_ON_COMPANY_SCHEDULE':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = false;
                        break;
                    case 'PRIMARY':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = true;
                        break;
                    case 'FIXED_TIME_SESSIONS':
                        break;
                    case 'FLOAT_TIME_SESSIONS':
                        $ctrl.canSelectMultipleTimes = true;
                        $ctrl.hasDedicateSchedule = true;
                        break;

                }
            }
        }

        function updateScheduleTypeFromFlags() {
            if ($ctrl.selectedScheduleInfo.scheduleType != 'FIXED_TIME_SESSIONS') {
                $ctrl.selectedScheduleInfo.scheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                if ($ctrl.hasDedicateSchedule) {
                    $ctrl.selectedScheduleInfo.scheduleType = 'PRIMARY';

                } else {
                    $ctrl.canSelectMultipleTimes = false;
                }
                if ($ctrl.canSelectMultipleTimes)
                    $ctrl.selectedScheduleInfo.scheduleType = 'FLOAT_TIME_SESSIONS';
            }

        }

        function showTimingInfo() {
            $ctrl.timingInfo = $ctrl.selectedScheduleInfo.timingInfo;
            $ctrl.step = 1;
        }

        $ctrl.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }

        function saveSchedule() {
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            $ctrl.selectedScheduleInfo.scheduleType = 'SERVICE_SCHEDULE';
            if ($ctrl.selectedScheduleInfo.baseScheduleMode == 'BASED_ON_RESOURCE') {
                $ctrl.selectedScheduleInfo.dependencyMode = 'ON_SERVANT';
            } else {
                $ctrl.selectedScheduleInfo.dependencyMode = 'NON';
            }

            //    updateScheduleTypeFromFlags();
            TimingInfo.saveScheduleInfo().save($ctrl.selectedScheduleInfo, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.selectedId = sch.id;
                $ctrl.timingInfo = sch.timingInfo;
                $ctrl.step = 1;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                refreshList();
            });
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate($ctrl.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save($ctrl.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                $ctrl.timingInfo = timingInfo;
                $ctrl.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if ($ctrl.schedulerApi.refreshScheduler)
                $ctrl.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            $ctrl.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('scheduleType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            if ($ctrl.showExceptionDurationTab == null)
                $ctrl.showExceptionDurationTab = true;

            refreshList();


        }

        function refreshList() {
            if (!$ctrl.serviceItemId) $ctrl.scheduleInfos = [];
            else {
                ScheduleInfoCustom.primaryScheduleInfosByServiceItem($ctrl.serviceItemId).query(function (schs) {
                    $ctrl.scheduleInfos = schs;

                    if (!$ctrl.schSelected) {
                        if (schs.length == 0) $ctrl.newItem();
                        else $ctrl.editItem(schs[0]);
                    }
                });
            }
        }

        function newItem() {
            //
            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            $ctrl.schSelected = true;
            $ctrl.schSaved = false;
            updateTabs();

        }

        $ctrl.add_session = addSession;
        $ctrl.remove_session = removeSession;

        function removeSession(item) {
            var index = $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.indexOf(item);

            if (index > -1) {
                $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(index, 1);
            }

        }

        function addSession() {

            var isValid = validateTimesession();
            if (isValid) {
                var sessions = splitDurationIntoTimeSession();
                var i = 0;
                angular.forEach(sessions, function (ts) {
                    if (!isInList(ts)) {
                        i++
                        $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(0, 0, ts);
                    }
                })

                $('#closeDialog').click();
                AlertService.info('global.messages.info.newFixedTimeSessionAdded', {n: i});
            }
        }

        function validateTimesession() {
            if (!$ctrl.gapTime)
                $ctrl.gapTime = 0;

            var isValid = true;
            if (!$ctrl.session_date) {
                AlertService.error("error.time_session_date_is_required");
                isValid = false;
            } else if (!$ctrl.from_session_time || !$ctrl.to_session_time) {
                AlertService.error("error.start_and_end_time_is_required");
                isValid = false;
            } else if (!$ctrl.session_capacity) {
                AlertService.error("error.time_session_capacity_is_required");
                isValid = false;
            } else

                return isValid;
        }

        function splitDurationIntoTimeSession() {

            var retList = [];
            var from = $ctrl.from_session_time;
            var to = $ctrl.to_session_time;
            var duration = $ctrl.duration;
            var gap = $ctrl.gapTime;
            var dur_in_min = (to.getHours() - from.getHours()) * 60 + (to.getMinutes() - from.getMinutes());
            if (dur_in_min > 15) {
                if ($ctrl.duration && $ctrl.duration >= 15) {
                    if ($ctrl.duration > dur_in_min) {
                        $ctrl.duration = dur_in_min;
                        var newTimeSession = {
                            spanDate: $ctrl.session_date,
                            startTime: from,
                            endTime: to,
                            capacity: $ctrl.session_capacity,
                            discount: $ctrl.session_discount,
                            comment: $ctrl.session_comment,
                            timeSessionType: 'FIXED'
                        };
                        retList.push(newTimeSession);
                    } else {
                        var partsCount = dur_in_min / (duration + gap);
                        var start = moment(from);

                        for (var i = 0; i < partsCount; i++) {

                            var newTimeSession = {
                                spanDate: $ctrl.session_date,
                                startTime: start.toDate(),
                                endTime: start.add(duration, 'minutes').toDate(),
                                capacity: $ctrl.session_capacity,
                                discount: $ctrl.session_discount,
                                comment: $ctrl.session_comment,
                                timeSessionType: 'FIXED'
                            };
                            retList.splice(0, 0, newTimeSession);
                            start = start.add(gap, 'minutes');
                        }
                    }
                } else {
                    $ctrl.duration = dur_in_min;
                    var newTimeSession = {
                        spanDate: $ctrl.session_date,
                        startTime: from,
                        endTime: to,
                        capacity: $ctrl.session_capacity,
                        discount: $ctrl.session_discount,
                        comment: $ctrl.session_comment,
                        timeSessionType: 'FIXED'
                    };
                    retList.push(newTimeSession);
                }
            } else {
                AlertService.error("error.start_time_must_be_before_end_time");
            }
            return retList;
        }

        function isInList(timeSession) {
            if (timeSession.spanDate && timeSession.startTime && timeSession.endTime) {
                var exists = false;
                angular.forEach($ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes, function (time) {
                    if (datesAreEqual(time.spanDate, timeSession.spanDate) &&
                        timesAreEqual(time.startTime, timeSession.startTime) &&
                        timesAreEqual(time.endTime, timeSession.endTime))
                        exists = true;
                });
                if (exists) {
                    AlertService.error("error.time_session_date_time_is_repeated");
                    return true;
                } else {
                    return false;
                }


            }
            return false;
        }

        function editItem(id) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                updateTabs();
            });

        }

        function updateTabs() {
            setScheduleTypeFlags();
            if ($ctrl.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            $ctrl.formState = 'list';
            $ctrl.selectedScheduleId = '';
            refreshList();
        }

        function datesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("YYMMDD") == dm2.format("YYMMDD"))

        }

        function timesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("HH:mm") == dm2.format("HH:mm"))

        }


        function scheduleType_changed() {

        }

    }

    var ServiceItemSchedulesV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-schedules/partial-form.service-item-schedules-v2.html',
        controller: ServiceItemSchedulesV2Controller,
        bindings: {
            serviceItemId: '<',
            selectedScheduleInfo: '=',
            showExceptionDurationTab: '=?'
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemSchedulesV2', ServiceItemSchedulesV2)

    //  ServiceItemSchedulesV2Controller.$inject = ['$scope','$attrs','$element'];
    ServiceItemSchedulesV2Controller.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService'];


})();

;
(function () {
    'use strict';

    function ServiceItemSchedulesController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.generateTimeInfo = generateTimeInfo;
        $ctrl.showTimingInfo = showTimingInfo;
        $ctrl.backToScheduleInfo = backToScheduleInfo;
        $ctrl.saveSchedule = saveSchedule;
        $ctrl.schSelected = false;
        $ctrl.schSaved = false;
        $ctrl.step = 0;
        $ctrl.schedulerApi = {refresh: 'not set'};
        $ctrl.generateTimesUntil = generateTimesUntil;
        $ctrl.session_date = new Date();
        $ctrl.scheduleType_changed = scheduleType_changed;
        $ctrl.canSelectMultipleTimes = false;
        $ctrl.hasDedicateSchedule = false;
        $ctrl.session_capacity = 1;
        $ctrl.gapTime = 0;
        $ctrl.session_discount = 0;
        $ctrl.showAdvanced = showAdvanced;
        $ctrl.showAdvancedSetting = false;


        $timeout(function () {
            loadAll();
            loadPage();

        });

        function setScheduleTypeFlags() {
            if ($ctrl.selectedScheduleInfo) {
                switch ($ctrl.selectedScheduleInfo.scheduleType) {
                    case 'BASED_ON_COMPANY_SCHEDULE':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = false;
                        break;
                    case 'PRIMARY':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = true;
                        break;
                    case 'FIXED_TIME_SESSIONS':
                        break;
                    case 'FLOAT_TIME_SESSIONS':
                        $ctrl.canSelectMultipleTimes = true;
                        $ctrl.hasDedicateSchedule = true;
                        break;

                }
            }
        }

        function updateScheduleTypeFromFlags() {
            if ($ctrl.selectedScheduleInfo.scheduleType != 'FIXED_TIME_SESSIONS') {
                $ctrl.selectedScheduleInfo.scheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                if ($ctrl.hasDedicateSchedule) {
                    $ctrl.selectedScheduleInfo.scheduleType = 'PRIMARY';

                } else {
                    $ctrl.canSelectMultipleTimes = false;
                }
                if ($ctrl.canSelectMultipleTimes)
                    $ctrl.selectedScheduleInfo.scheduleType = 'FLOAT_TIME_SESSIONS';
            }

        }

        function showTimingInfo() {
            $ctrl.timingInfo = $ctrl.selectedScheduleInfo.timingInfo;
            $ctrl.step = 1;
        }

        $ctrl.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }

        function saveSchedule() {
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            updateScheduleTypeFromFlags();
            TimingInfo.saveScheduleInfo().save($ctrl.selectedScheduleInfo, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.selectedId = sch.id;
                $ctrl.timingInfo = sch.timingInfo;
                $ctrl.step = 1;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                refreshList();
            });
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate($ctrl.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save($ctrl.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                $ctrl.timingInfo = timingInfo;
                $ctrl.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if ($ctrl.schedulerApi.refreshScheduler)
                $ctrl.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            $ctrl.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('scheduleType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            refreshList();


        }

        function refreshList() {
            if (!$ctrl.serviceItemId) $ctrl.scheduleInfos = [];
            else {
                ScheduleInfoCustom.primaryScheduleInfosByServiceItem($ctrl.serviceItemId).query(function (schs) {
                    $ctrl.scheduleInfos = schs;

                    if (!$ctrl.schSelected) {
                        if (schs.length == 0) $ctrl.newItem();
                        else $ctrl.editItem(schs[0]);
                    }
                });
            }
        }

        function newItem() {
            //
            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            $ctrl.schSelected = true;
            $ctrl.schSaved = false;
            updateTabs();

        }

        $ctrl.add_session = addSession;
        $ctrl.remove_session = removeSession;

        function removeSession(item) {
            var index = $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.indexOf(item);

            if (index > -1) {
                $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(index, 1);
            }

        }

        function addSession() {

            var isValid = validateTimesession();
            if (isValid) {
                var sessions = splitDurationIntoTimeSession();
                var i = 0;
                angular.forEach(sessions, function (ts) {
                    if (!isInList(ts)) {
                        i++
                        $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(0, 0, ts);
                    }
                })

                $('#closeDialog').click();
                AlertService.info('global.messages.info.newFixedTimeSessionAdded', {n: i});
            }
        }

        function validateTimesession() {
            if (!$ctrl.gapTime)
                $ctrl.gapTime = 0;

            var isValid = true;
            if (!$ctrl.session_date) {
                AlertService.error("error.time_session_date_is_required");
                isValid = false;
            } else if (!$ctrl.from_session_time || !$ctrl.to_session_time) {
                AlertService.error("error.start_and_end_time_is_required");
                isValid = false;
            } else if (!$ctrl.session_capacity) {
                AlertService.error("error.time_session_capacity_is_required");
                isValid = false;
            } else

                return isValid;
        }

        function splitDurationIntoTimeSession() {

            var retList = [];
            var from = $ctrl.from_session_time;
            var to = $ctrl.to_session_time;
            var duration = $ctrl.duration;
            var gap = $ctrl.gapTime;
            var dur_in_min = (to.getHours() - from.getHours()) * 60 + (to.getMinutes() - from.getMinutes());
            if (dur_in_min > 15) {
                if ($ctrl.duration && $ctrl.duration >= 15) {
                    if ($ctrl.duration > dur_in_min) {
                        $ctrl.duration = dur_in_min;
                        var newTimeSession = {
                            spanDate: $ctrl.session_date,
                            startTime: from,
                            endTime: to,
                            capacity: $ctrl.session_capacity,
                            discount: $ctrl.session_discount,
                            comment: $ctrl.session_comment,
                            timeSessionType: 'FIXED'
                        };
                        retList.push(newTimeSession);
                    } else {
                        var partsCount = dur_in_min / (duration + gap);
                        var start = moment(from);

                        for (var i = 0; i < partsCount; i++) {

                            var newTimeSession = {
                                spanDate: $ctrl.session_date,
                                startTime: start.toDate(),
                                endTime: start.add(duration, 'minutes').toDate(),
                                capacity: $ctrl.session_capacity,
                                discount: $ctrl.session_discount,
                                comment: $ctrl.session_comment,
                                timeSessionType: 'FIXED'
                            };
                            retList.splice(0, 0, newTimeSession);
                            start = start.add(gap, 'minutes');
                        }
                    }
                } else {
                    $ctrl.duration = dur_in_min;
                    var newTimeSession = {
                        spanDate: $ctrl.session_date,
                        startTime: from,
                        endTime: to,
                        capacity: $ctrl.session_capacity,
                        discount: $ctrl.session_discount,
                        comment: $ctrl.session_comment,
                        timeSessionType: 'FIXED'
                    };
                    retList.push(newTimeSession);
                }
            } else {
                AlertService.error("error.start_time_must_be_before_end_time");
            }
            return retList;
        }

        function isInList(timeSession) {
            if (timeSession.spanDate && timeSession.startTime && timeSession.endTime) {
                var exists = false;
                angular.forEach($ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes, function (time) {
                    if (datesAreEqual(time.spanDate, timeSession.spanDate) &&
                        timesAreEqual(time.startTime, timeSession.startTime) &&
                        timesAreEqual(time.endTime, timeSession.endTime))
                        exists = true;
                });
                if (exists) {
                    AlertService.error("error.time_session_date_time_is_repeated");
                    return true;
                } else {
                    return false;
                }


            }
            return false;
        }

        function editItem(id) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                updateTabs();
            });

        }

        function updateTabs() {
            setScheduleTypeFlags();
            if ($ctrl.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            $ctrl.formState = 'list';
            $ctrl.selectedScheduleId = '';
            refreshList();
        }

        function datesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("YYMMDD") == dm2.format("YYMMDD"))

        }

        function timesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("HH:mm") == dm2.format("HH:mm"))

        }


        function scheduleType_changed() {
            updateScheduleTypeFromFlags();
            // for now just support HOURLY
            if ($ctrl.selectedScheduleInfo != null && $ctrl.selectedScheduleInfo.scheduleType != null
                && $ctrl.selectedScheduleInfo.scheduleType == 'FLOAT_TIME_SESSIONS') {
                $ctrl.selectedScheduleInfo.floatingTimeType = 'HOURLY';
            } else {
                $ctrl.selectedScheduleInfo.floatingTimeType = null;
            }
        }

        function showAdvanced() {
            $ctrl.showAdvancedSetting = !$ctrl.showAdvancedSetting;
        }
    }

    var ServiceItemSchedules = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-schedules/partial-form.service-item-schedules.html',
        controller: ServiceItemSchedulesController,
        bindings: {
            serviceItemId: '<',
            selectedScheduleInfo: '='
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemSchedules', ServiceItemSchedules)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    ServiceItemSchedulesController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService'];


})();

;
(function () {
    'use strict';

    function ServiceItemPriceInfoController($uibModal, $window, $scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, PriceInfoDtailCustom, PriceInfoDtail, Principal, PackageFeatureListCustom) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.priceInfoDtails = null;
        $ctrl.confirmDelete = confirmDelete;
        $ctrl.addNewPriceInfoDtail = addNewPriceInfoDtail;
        $ctrl.priceInfos = [];
        $ctrl.removePriceInfoDtail = removePriceInfoDtail;
        $ctrl.reload = 'false';
        $ctrl.fixedPriceInfoEnum = ['HOURLY', 'DAILY', 'MONTHLY'];
        $ctrl.initFixedPriceInfo = initFixedPriceInfo;
        $ctrl.fixedPriceInfoDetails = [];
        $ctrl.priceInfoType = 'dynamic';
        $ctrl.hasAdvancedPricingFeatureAccess = true;

        loadAll();

        loadPage();

        function loadAll() {

            //
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) {
                $ctrl.priceInfos = [];
                initFixedPriceInfo();
            } else {
                $ctrl.priceInfos = [];
                PriceInfoCustom.getPriceInfosWithDtailsByServiceItem($ctrl.serviceItemId).query().$promise.then(function (result) {
                    $ctrl.priceInfos = result;
                    initFixedPriceInfo();
                });
            }


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            $ctrl.reload == 'false';


        }

        function loadPage(page) {
            translatePartialLoader.addPart('priceInfo');
            translatePartialLoader.addPart('priceInfoDtail');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //
            loadAll();
            checkFeatureAccess();
        }

        function newItem() {
            //
            $ctrl.formState = 'new';
            $ctrl.priceInfoDtail = {};
            $ctrl.priceInfoDtail.capacityRatio = 1;  //
            $ctrl.priceInfoDtail.title = '';  //
            $ctrl.newPriceInfo = {};

            addNewPriceInfoDtail();

            //$ctrl.onCreateNewPriceInfo();

        }

        function editItem(id) {
            //
            $ctrl.formState = 'edit';
            //$ctrl.selectedId=id;
            //$ctrl.onSelectedPriceInfoChanged(id);

            $ctrl.newPriceInfo = PriceInfoCustom.getPriceInfoWithDtailById(id).query();

            //

        }

        function backToList() {
            $ctrl.formState = 'list';
            loadAll();
        }


        function confirmDelete(id) {

            $uibModal.open({
                templateUrl: 'app/entities/price-info/service-item-price-info-delete-dialog.html',
                controller: 'ServiceItemPriceInfoDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {

                    entity: ['PriceInfo', function (PriceInfo) {
                        return PriceInfo.get({id: id}).$promise;
                    }]
                }
            }).result.then(function (result) {
                $ctrl.priceInfos = $ctrl.priceInfos.filter(function (v) {
                        return (v.id != id)
                    }
                );
            }, function () {
                //nothing
            });


        }

        function addNewPriceInfoDtail() {
            if ($ctrl.newPriceInfo == null || $ctrl.newPriceInfo == undefined)
                $ctrl.newPriceInfo = {};
            if ($ctrl.newPriceInfo.priceInfoDtails == null || $ctrl.newPriceInfo.priceInfoDtails == undefined)
                $ctrl.newPriceInfo.priceInfoDtails = [];


            $ctrl.newPriceInfo.priceInfoDtails.push({
                title: "",
                price: ""
            });

        }

        function removePriceInfoDtail(title) {
            $ctrl.newPriceInfo.priceInfoDtails = $ctrl.newPriceInfo.priceInfoDtails.filter(function (v) {
                return (v.title != title)
            });

        }

        function initFixedPriceInfo() {


            if ($ctrl.priceInfoType == 'fixed') {
                if ($ctrl.priceInfos == null || $ctrl.priceInfos == undefined || $ctrl.priceInfos.length == 0) {
                    $ctrl.priceInfos = [];
                    $ctrl.newPriceInfo = {};

                    var priceInfo = {};
                    priceInfo.id = null;
                    priceInfo.fromValidDate = null;
                    priceInfo.priceType = 'FIXED';

                    priceInfo.priceInfoDtails = [];

                    priceInfo.priceInfoDtails.push({
                        title: "HOURLY",
                        price: 0,
                        capacityRatio: 1,
                    });
                    priceInfo.priceInfoDtails.push({
                        title: "DAILY",
                        price: 0,
                        capacityRatio: 1,
                    });
                    priceInfo.priceInfoDtails.push({
                        title: "MONTHLY",
                        price: 0,
                        capacityRatio: 1,
                    });

                    $ctrl.newPriceInfo = priceInfo;

                    $ctrl.fixedPriceInfoDetails = $ctrl.newPriceInfo.priceInfoDtails;

                } else if ($ctrl.priceInfos.length > 0) {
                    $ctrl.newPriceInfo = $ctrl.priceInfos[0];
                    $ctrl.fixedPriceInfoDetails = $ctrl.newPriceInfo.priceInfoDtails;
                }
            }
        }

        function checkFeatureAccess() {
            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                $ctrl.hasAdvancedPricingFeatureAccess = Principal.hasSpecialFeatureAccess('advancedPricing');
            })
        }

        $scope.$watch('$ctrl.formState', function () {
            if ($ctrl.formState == 'list') {
                loadAll();
            }
        });

        $scope.$watch('$ctrl.reload', function () {
            if ($ctrl.reload == 'true') {
                loadAll();

            }
        });

        $scope.$watch('$ctrl.priceInfoType', function () {
            if ($ctrl.priceInfoType == 'fixed') {
                loadAll();
            }
        });


    }

    var ServiceItemPriceInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-price-info/partial-form.service-item-price-info.html',
        controller: ServiceItemPriceInfoController,
        bindings: {
            serviceItemId: '<',
            selectedId: '=?',
            formState: '=',
            onSelectedPriceInfoChanged: '=',
            newPriceInfo: '=',
            reload: '=',
            priceInfos: '=',
            priceInfoType: '='
            //onCreateNewPriceInfo:'='


            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemPriceInfo', ServiceItemPriceInfo)

    ServiceItemPriceInfoController.$inject = ['$uibModal', '$window', '$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'PriceInfoDtailCustom', 'PriceInfoDtail', 'Principal', 'PackageFeatureListCustom'];


})();

;
(function () {
    'use strict';

    function ServiceItemPickerComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery, ServiceItemCustom) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.noCache = false;
        $ctrl.servicesNames = [];
        $ctrl.querySearch = querySearch;
        // $ctrl.serviceItems = [];
        $ctrl.serviceItem_changed = serviceItem_changed;

        loadAll();
        loadPage();

        function loadAll() {

            loadAllServiceItems();

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


        }

        function loadAllServiceItems() {

            if ($ctrl.servantId) {
                ServiceItemCustom.getServiceItemsByServantId($ctrl.servantId).query(function (items) {
                    $ctrl.serviceItems = items;
                });
            } else {
                ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {
                    $ctrl.serviceItems = items;
                });
            }

        }

        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.serviceItems, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.serviceItems;
                }
            })

            return temp;

        }

        function serviceItem_changed(item) {

        }


        $scope.$watch('$ctrl.servantId', function () {

            if ($ctrl.servantId) {
                loadAllServiceItems();
            }
        })
        $scope.$watch('$ctrl.selectedService', function () {

            if (!$ctrl.selectedService && $ctrl.searchText) {
                $ctrl.searchText = '';
            }
        })

    }

    var ServiceItemPickerComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-picker/partial-form.service-item-picker.html',
        controller: ServiceItemPickerComponentController,
        bindings:
            {
                isDisabled: '=',
                selectedService: "=",
                servantId: "=",
                onServiceChanged: "&"
            }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemPicker', ServiceItemPickerComponent)

    ServiceItemPickerComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery', 'ServiceItemCustom'];


})();

;
//(function() {
//    'use strict';
//
//    function ServiceItemOptionInfoController ($scope, $state, ParseLinks, AlertService, paginationConstants,translate, translatePartialLoader,ServiceOptionItemCustom,ServiceOptionItem,$uibModal) {
//        //
//        var $ctrl = this;
//        var pagingParams={};
//        $ctrl.loadPage = loadPage;
//        $ctrl.selectedId='';
//        $ctrl.formState='list';
//        $ctrl.newItem=newItem;
//        $ctrl.editItem=editItem;
//        $ctrl.backToList=backToList;
//        $ctrl.serviceOptionItems =null;
//        $ctrl.removeItem = removeItem;
//
//
//        loadAll();
//
//        loadPage();
//
//        function loadAll () {
//
//            if($ctrl.serviceItemId==undefined || $ctrl.serviceItemId==null)$ctrl.serviceOptionItems=[];
//            else
//                $ctrl.serviceOptionItems =  ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query();
//
//            function onSuccess(data, headers) {
//
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            translatePartialLoader.addPart('serviceOptionInfo');
//            translatePartialLoader.addPart('serviceOptionItem');
//            translatePartialLoader.addPart('priceInfoDtail');
//            translatePartialLoader.addPart('global');
//            translatePartialLoader=translate.refresh();
//            //
//          loadAll();
//        }
//        function newItem()
//        {
//            //
//            $ctrl.formState='new';
//            $ctrl.serviceOptionItem = null;
//            $ctrl.serviceOptionItem.optionInfo.title = 'serviceOption';
//            $ctrl.onCreateNewPriceInfo();
//
//        }
//        function editItem(id)
//        {
//            //
//            $ctrl.formState='edit';
//            //$ctrl.selectedId=id;
//            //$ctrl.onSelectedPriceInfoChanged(id);
//
//            $ctrl.serviceOptionItem =  ServiceOptionItem.get(id);
//
//            //
//
//        }
//        function backToList()
//        {
//            $ctrl.formState='list';
//            if($ctrl.serviceItemId==undefined || $ctrl.serviceItemId==null)$ctrl.serviceOptionItems=[];
//            else
//              $ctrl.serviceOptionItems =  ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query();
//
//        }
//
//        function removeItem(id) {
//
//            $uibModal.open({
//                templateUrl: 'app/entities/service-option-item/service-option-item-delete-dialog.html',
//                controller: 'ServiceOptionItemDeleteController',
//                controllerAs: 'vm',
//                backdrop: 'static',
//                size: 'md',
//                resolve: {
//                    entity: ['ServiceOptionItem', function(ServiceOptionItem) {
//                        return ServiceOptionItem.get({id : id}).$promise;
//                    }]
//                }
//            }).result.then(function(result) {
//                $ctrl.serviceOptionItems= $ctrl.serviceOptionItems.filter(function (v) {
//                        return (v.id != id )
//                    }
//                );
//            }, function() {
//                //nothing
//            });
//
//        }
//
//
//
//        $scope.$watch('$ctrl.formState',function(){
//            if($ctrl.formState == 'list')
//                loadAll();
//        });
//
//    }
//
//    var ServiceItemOptionInfo = {
//       // template:'tets:{{$ctrl.testStr}}',
//        templateUrl: 'app/components/partial-forms/service-item-option-info/partial-form.service-item-option-info.html',
//        controller:ServiceItemOptionInfoController,
//        bindings:
//        {
//            serviceItemId:'<',
//            serviceOptionItem:'=',
//            selectedId:'=?',
//            formState:'=',
//            onSelectedServiceOptionInfoChanged:'=',
//            onCreateNewServiceOptionInfo:'='
//
//
//          /*  items :'<',
//            displaytag:'@?',
//            displayitem:'@?',
//            list:'='*/
//
//        }
//
//    };
//
//    angular
//        .module('tikonApp')
//        .component('pfServiceItemOptionInfo', ServiceItemOptionInfo)
//
//    ServiceItemOptionInfoController.$inject = ['$scope', '$state',  'ParseLinks', 'AlertService', 'paginationConstants','$translate', '$translatePartialLoader','ServiceOptionItemCustom','ServiceOptionItem','$uibModal'];
//
//
//
//})();
//
;
(function () {
    'use strict';

    function ServiceItemOptionInfoController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItemCustom, ServiceOptionItem, $uibModal, DialogService) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.serviceOptionItems = null;
        $ctrl.removeItem = removeItem;
        $ctrl.onQtyType_Change = onQtyType_Change;

        loadAll();

        loadPage();

        function loadAll() {


            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null)
                $ctrl.serviceOptionItems = [];
            else
                $ctrl.serviceOptionItems = ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query();


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceOptionInfo');
            translatePartialLoader.addPart('serviceOptionItem');
            translatePartialLoader.addPart('priceInfoDtail');
            translatePartialLoader.addPart('qtyType');
            translatePartialLoader.addPart('qtyUnitType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //
            loadAll();
        }

        function newItem() {
            //
            $ctrl.formState = 'new';
            $ctrl.serviceOptionItem = {};
            $ctrl.serviceOptionItem.qtyType = 'NONE';
            $ctrl.serviceOptionItem.optionInfo.title = 'serviceOption';
            $ctrl.serviceOptionItem.minQty = 0;
            $ctrl.serviceOptionItem.maxQty = 0;
            $ctrl.onCreateNewPriceInfo();

        }

        function editItem(id) {
            //
            $ctrl.formState = 'edit';
            //$ctrl.selectedId=id;
            //$ctrl.onSelectedPriceInfoChanged(id);

            $ctrl.serviceOptionItem = ServiceOptionItem.get(id);

            //

        }

        function backToList() {
            $ctrl.formState = 'list';
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) $ctrl.serviceOptionItems = [];
            else
                loadOptionList();

        }

        function loadOptionList() {
            $ctrl.serviceOptionItems = ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query();
        }

        function onQtyType_Change() {
            if (!$ctrl.serviceOptionItem.maxQty)
                $ctrl.serviceOptionItem.maxQty = 100;
            if (!$ctrl.serviceOptionItem.minQty)
                $ctrl.serviceOptionItem.minQty = 0;
        }

        function removeItem(optionItem) {

            if ($ctrl.serviceItemId != null && optionItem.optionInfoId) {
                DialogService.showConfirm("عملیات حذف را تائید می فرمایید ؟").then(function () {
                    ServiceOptionItemCustom.removeOptionInfoFromServiceItem($ctrl.serviceItemId, optionItem.optionInfoId).query().$promise.then(function () {
                        loadOptionList();
                    })

                });
            }


            // $uibModal.open({
            //     templateUrl: 'app/entities/service-option-item/service-option-item-delete-dialog.html',
            //     controller: 'ServiceOptionItemDeleteController',
            //     controllerAs: 'vm',
            //     backdrop: 'static',
            //     size: 'md',
            //     resolve: {
            //         entity: ['ServiceOptionItem', function(ServiceOptionItem) {
            //             return ServiceOptionItem.get({id : id}).$promise;
            //         }]
            //     }
            // }).result.then(function(result) {
            //     $ctrl.serviceOptionItems= $ctrl.serviceOptionItems.filter(function (v) {
            //             return (v.id != id )
            //         }
            //     );
            // }, function() {
            //     //nothing
            // });


        }


        $scope.$watch('$ctrl.formState', function () {
            if ($ctrl.formState == 'list')
                loadAll();
        });

    }

    var ServiceItemOptionInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-option-info/partial-form.service-item-option-info.html',
        controller: ServiceItemOptionInfoController,
        bindings:
            {
                serviceItemId: '<',
                serviceOptionItem: '=',
                selectedId: '=?',
                formState: '=',
                onSelectedServiceOptionInfoChanged: '=',
                onCreateNewServiceOptionInfo: '='


                /*  items :'<',
                  displaytag:'@?',
                  displayitem:'@?',
                  list:'='*/

            }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemOptionInfo', ServiceItemOptionInfo)

    ServiceItemOptionInfoController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItemCustom', 'ServiceOptionItem', '$uibModal', 'DialogService'];


})();

;
(function () {
    'use strict';

    function ServiceCapacityInfoCustomController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceCapacityInfoCustom, ServiceCapacityInfo) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';

        loadAll();

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceCapacityInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) ;
            else
                $ctrl.serviceCapacityInfo = serviceCapacityInfoCustom.serviceCapacityInfoByServiceItem($ctrl.serviceItemId).query();
        }


    }

    var ServiceCapacityInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-capacity-info/partial-form.service-capacity-info.html',
        controller: ServiceCapacityInfoCustomController,
        bindings:
            {
                serviceItemId: '<',
                serviceCapacityInfo: '=',
                selectedId: '=?',
                onSelectedServiceOptionInfoChanged: '=',
                onCreateNewServiceOptionInfo: '='


                /*  items :'<',
                  displaytag:'@?',
                  displayitem:'@?',
                  list:'='*/

            }

    };

    angular
        .module('tikonApp')
        .component('pfServiceCapacityInfo', ServiceCapacityInfo)

    ServiceCapacityInfoCustomController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceCapacityInfoCustom', 'ServiceCapacityInfo'];


})();

;
(function () {
    'use strict';

    function ServiceItemAmenitiesController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $uibModal, ServiceItemCustom) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;


        loadAll();
        loadPage();

        function loadAll() {

            ServiceItemCustom.getAllAmenitiesType().query().$promise.then(function (result) {

                if ($ctrl.amenities == null || $ctrl.amenities == undefined || $ctrl.amenities.length == 0) {
                    $ctrl.amenities = result;
                    return;
                }
                angular.forEach(result, function (v) {

                    var isFound = false;
                    angular.forEach($ctrl.amenities, function (am) {

                        if (am.amenitiesType == v.amenitiesType) {
                            isFound = true;
                        }

                    });

                    if (isFound == false) {
                        $ctrl.amenities.push({
                            amenitiesType: v.amenitiesType,
                            price: 0.0,
                            qty: 1.0,
                            selected: false
                        });
                    }
                });


            });


        }

        function loadPage(page) {
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('amenitiesType');
            translatePartialLoader = translate.refresh();
            //

        }

    }

    var ServiceItemAmenities = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-amenities/partial-form.service-item-amenities.html',
        controller: ServiceItemAmenitiesController,
        bindings: {
            amenities: '='
        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemAmenities', ServiceItemAmenities)

    ServiceItemAmenitiesController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$uibModal', 'ServiceItemCustom'];


})();

;
(function () {
    'use strict';

    function ServiceItemAgreementInfoController($scope, $state, AgreementInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, __config) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        var hasConditions = false;
        $ctrl.__config = __config;

        loadAll();

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('agreementInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //
            //if($ctrl.serviceItemId==undefined || $ctrl.serviceItemId==null);
            // else
            //   $ctrl.agreementInfo =  AgreementInfoDtailCustom.AgreementInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


    }

    var ServiceItemAgreementInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-agreement-info/partial-form.service-item-agreement-info.html',
        controller: ServiceItemAgreementInfoController,
        bindings:
            {
                agreement: '=',
            }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemAgreementInfo', ServiceItemAgreementInfo)

    ServiceItemAgreementInfoController.$inject = ['$scope', '$state', 'AgreementInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '__config'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantExceptionDurationListComponentController', ServantExceptionDurationListComponentController);

    function ServantExceptionDurationListComponentController($scope, $rootScope, $state, translate, translatePartialLoader, ScheduleInfoCustom, TimingInfo, DialogService) {
        var $ctrl = this;
        $ctrl.removeDuration = removeDuration;
        $ctrl.exdurations = [];
        $ctrl.isDateEqual = isDateEqual;
        $ctrl.getDurationBlockClass = getDurationBlockClass;
        $ctrl.noDataMessage = 'هیچ زمانی ثبت نشده است';
        $ctrl.isFullDay = isFullDay;

        loadAll();

        $rootScope.$on('reloadServantExceptionDurationListEvent', function () {
            reload();
        });


        function loadAll() {

            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader = translate.refresh();

            if (!$ctrl.availabilityMode)
                $ctrl.availabilityMode = 'CLOSE';

            getExceptionDurations();
        }

        function reload() {
            getExceptionDurations();
        }

        function getExceptionDurations() {
            if (!$ctrl.servantId)
                return;

            ScheduleInfoCustom.getServantExceptionDurationsByServantId($ctrl.servantId, $ctrl.availabilityMode).query(function (result) {
                $ctrl.exdurations = result;
            });

        }

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function removeDuration(id) {

            DialogService.showConfirm("عملیات حذف را تائید می فرمایید ؟").then(function () {
                TimingInfo.deleteServantExceptionDuration().save(id,
                    function () {
                        reload();
                    }, function () {
                        //nothing
                    });
            });

        }

        function isDateEqual(startDate, endDate) {


            var start = new Date(startDate).toLocalISOString();
            var end = new Date(endDate).toLocalISOString();

            if (start == end)
                return true;

            return false;


        }

        function getDurationBlockClass(dur) {
            if (dur && dur.availabilityMode) {
                if (dur.availabilityMode == 'CLOSE')
                    return 'CloseDurationBlock';
                else
                    return 'OpenDurationBlock';
            }
        }

        function isFullDay(item) {
            var date1 = new Date(item.startTime);
            var date2 = new Date(item.endTime);
            var diffTime = Math.abs(date2 - date1);

            if (diffTime / 1000 == 86340) {
                return true;
            }
            return false;
        }


    }

    var ServantExceptionDurationListComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/servant-exception-duration-list/partial-form.servant-exception-duration-list.html',
        controller: ServantExceptionDurationListComponentController,
        bindings: {
            servantId: '=',
            availabilityMode: '='
        }

    };

    angular
        .module('tikonApp')
        .component('pfServantExceptionDurationList', ServantExceptionDurationListComponent)

    ServantExceptionDurationListComponentController.$inject = ['$scope', '$rootScope', '$state', '$translate', '$translatePartialLoader', 'ScheduleInfoCustom', 'TimingInfo', 'DialogService'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantExceptionDurationComponentController', ServantExceptionDurationComponentController);

    function ServantExceptionDurationComponentController($scope, $state, translate, translatePartialLoader, $mdDialog, ServantCustom, entity, TimingInfo) {
        var $ctrl = this;
        $ctrl.newDate = null;
        $ctrl.addDuration = addDuration;
        $ctrl.removeDuration = removeDuration;
        $ctrl.startDate = new Date();
        $ctrl.endDate = null;
        $ctrl.startTime;
        $ctrl.endTime;
        // $ctrl.availablityMode='CLOSE';
        $ctrl.servantList = [];
        $ctrl.selectedServant = null;
        $ctrl.loadServants = loadServants;
        $ctrl.exdurations = [];
        $ctrl.errorMessage = null;
        $ctrl.isDateEqual = isDateEqual;
        $ctrl.showEndDate = false;
        $ctrl.getDurationBlockClass = getDurationBlockClass;
        $ctrl.okModal = okModal;
        $ctrl.closeModal = closeModal;
        $ctrl.isFullDay = isFullDay;

        loadAll();

        function loadAll() {

            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader = translate.refresh();

            if (entity && entity.defaultServantId)
                $ctrl.defaultServantId = entity.defaultServantId;

            if (entity && entity.availabilityMode)
                $ctrl.availabilityMode = entity.availabilityMode;
            else
                $ctrl.availabilityMode = 'CLOSE';

            if (entity && entity.canSelectServant != null && entity.canSelectServant != undefined)
                $ctrl.canSelectServant = entity.canSelectServant;
            else
                $ctrl.canSelectServant = true;


            loadServants();
        }

        function loadServants() {
            //if servant_login just current servant must selected
            ServantCustom.findServantsByCompany().query(function (result) {
                $ctrl.servantList = result;
                setDefaultServant();

            });
        }


        function setDefaultServant() {
            if ($ctrl.servantList) {
                if ($ctrl.defaultServantId) {
                    angular.forEach($ctrl.servantList, function (srv) {
                        if (srv.id == $ctrl.defaultServantId) {
                            $ctrl.selectedServant = srv;
                            return;
                        }
                    });
                }
            }

        }


        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {

            $ctrl.errorMessage = null;
            if (!$ctrl.exdurations)
                $ctrl.exdurations = [];
            var dur = makeDurationObject();
            if (dur && $ctrl.startDate != null && $ctrl.endDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == $ctrl.startDate.toLocaleString() &&
                        ((!val.startTime && !$ctrl.startTime) || (val.startTime && $ctrl.startTime && val.startTime.toLocaleString() == $ctrl.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == $ctrl.endDate.toLocaleString() &&
                        ((!val.endTime && !$ctrl.endTime) || (val.endTime && $ctrl.endTime && val.endTime.toLocaleString() == $ctrl.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    $ctrl.exdurations.push(dur);
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            $ctrl.errorMessage = msg;
        }

        function makeDurationObject(ev) {
            if (!$ctrl.showEndDate)
                $ctrl.endDate = $ctrl.startDate;

            if ($ctrl.showEndDate && !$ctrl.endDate) {
                alert('تاریخ پایان را وارد کنید');
                return null;
            }

            if ($ctrl.showEndDate && $ctrl.startDate > $ctrl.endDate) {
                alert('تاریخ پایان باید بزرگتر از تاریخ شروع باشد');
                return null;
            }

            if (!$ctrl.startTime || !$ctrl.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availabilityMode: $ctrl.availabilityMode,
                    startDate: $ctrl.startDate,
                    endDate: $ctrl.endDate,
                    startTime: $ctrl.startTime,
                    endTime: $ctrl.endTime
                };
            }

        }

        function removeDuration(date) {
            if ($ctrl.exdurations != undefined)
                $ctrl.exdurations = $ctrl.exdurations.filter(function (item) {
                    return item != date;
                });
        }

        function isDateEqual(startDate, endDate) {


            var start = new Date(startDate).toLocalISOString();
            var end = new Date(endDate).toLocalISOString();

            if (start == end)
                return true;

            return false;


        }

        function getDurationBlockClass(dur) {
            if (dur && dur.availabilityMode) {
                if (dur.availabilityMode == 'CLOSE')
                    return 'CloseDurationBlock';
                else
                    return 'OpenDurationBlock';
            }
        }


        function okModal() {
            if (!$ctrl.exdurations || $ctrl.exdurations.length == 0) {
                alert("هیچ زمانی انتخاب نشده است")
                return;
            }

            if (!$ctrl.selectedServant) {
                alert("پرسنل انتخاب نشده است")
                return;
            }

            setServant();
            var exceptionHelper = {};
            exceptionHelper.servantExceptionDurations = $ctrl.exdurations;

            TimingInfo.insertServantExceptionDuration().save(exceptionHelper, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                closeModal();
            }

            function onSaveError() {
                // alert("خطا در ثبت اطلاعات")
                return;
            }
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function setServant() {


            angular.forEach($ctrl.exdurations, function (dur) {
                dur.servantId = $ctrl.selectedServant.id;
            })
        }

        function isFullDay(item) {
            var date1 = new Date(item.startTime);
            var date2 = new Date(item.endTime);
            var diffTime = Math.abs(date2 - date1);

            if (diffTime / 1000 == 86340) {
                return true;
            }
            return false;
        }

    }

    var ServantExceptionDurationComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html',
        controller: ServantExceptionDurationComponentController,
        bindings: {
            defaultServantId: '=',
            availabilityMode: '=',
            canSelectServant: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfServantExceptionDuration', ServantExceptionDurationComponent)

    ServantExceptionDurationComponentController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog', 'ServantCustom', 'entity', 'TimingInfo'];


})();

;
(function () {
    'use strict';

    function ReserveListV2ComponentController(__config, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, $translate) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.orderBagServiceItems = [];
        $ctrl.__config = __config;
        $ctrl.findStatusStyle = findStatusStyle;
        $ctrl.findStatusTitle = findStatusTitle;

        $ctrl.editReserve = editReserve;
        $ctrl.totalItems = 0
        $ctrl.page = 0
        $ctrl.pageSize = 10
        $ctrl.transition = transition

        loadAll();
        loadPage();

        function transition() {
            searchOrderBag()
        }

        function loadAll() {

            searchOrderBag();
        }

        function loadPage() {
            translatePartialLoader.addPart('orderBag');
            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader = translate.refresh();
        }


        function searchOrderBag() {

            makeSearchQuery();

            OrderBagServiceItemCustom.searchOrderBagItemsByQueryPagination().save($ctrl.searchQuery, function (data, headers) {
                $ctrl.totalItems = headers("X-Total-Count")
                $ctrl.orderBagServiceItems = data;
            });
        }


        function makeSearchQuery() {
            $ctrl.searchQuery = {};
            if ($ctrl.customerId)
                $ctrl.searchQuery.customerId = $ctrl.customerId;

            if ($ctrl.page > 0) $ctrl.searchQuery.pageNumber = $ctrl.page - 1;
            else $ctrl.searchQuery.pageNumber = $ctrl.page
            $ctrl.searchQuery.pageSize = $ctrl.pageSize;

            if (!$ctrl.fromDate)
                $ctrl.searchQuery.fromDate = new Date(2000, 1, 1);

            $ctrl.searchQuery.status = [1, 4, 5, 6];

        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function editReserve(orderBagServiceItem) {
            $state.go('supplierPanel-v2.editOrderBag', {id: orderBagServiceItem.orderBag.id})
        }
    }

    var ReserveListV2Component = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/reserve-list-v2/partial-form.reserve-list-v2.html',
        controller: ReserveListV2ComponentController,
        bindings:
            {
                customerId: '=',
                fromDate: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfReserveListV2', ReserveListV2Component)

    ReserveListV2ComponentController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', '$translate'];


})();

;
(function () {
    'use strict';

    function ReserveListComponentController(__config, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, $translate) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.orderBagServiceItems = [];
        $ctrl.__config = __config;
        $ctrl.findStatusStyle = findStatusStyle;
        $ctrl.findStatusTitle = findStatusTitle;

        loadAll();
        loadPage();

        function loadAll() {

            searchOrderBag();
        }

        function loadPage() {
            translatePartialLoader.addPart('orderBag');
            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader = translate.refresh();
        }


        function searchOrderBag() {

            makeSearchQuery();

            OrderBagServiceItemCustom.searchOrderBagItemsByQuery().save($ctrl.searchQuery, function (data) {
                $ctrl.orderBagServiceItems = data;
            });
        }


        function makeSearchQuery() {
            $ctrl.searchQuery = {};
            if ($ctrl.customerId)
                $ctrl.searchQuery.customerId = $ctrl.customerId;

            if (!$ctrl.fromDate)
                $ctrl.searchQuery.fromDate = new Date(2000, 1, 1);

            $ctrl.searchQuery.status = [1, 4, 5, 6];

        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }
    }

    var ReserveListComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/reserve-list/partial-form.reserve-list.html',
        controller: ReserveListComponentController,
        bindings:
            {
                customerId: '=',
                fromDate: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfReserveList', ReserveListComponent)

    ReserveListComponentController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', '$translate'];


})();

;
(function () {
    'use strict';

    function QuickAccessToolsComponentController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.findVersion = findVersion;


        loadAll();

        loadPage();


        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

        }

        function findVersion() {

        }

        $scope.$watch('$ctrl.company', function () {
            findVersion();
        })

    }

    var QuickAccessToolsComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/quick-access-tools/partial-form.quick-access-tools.html',
        controller: QuickAccessToolsComponentController,
        bindings:
            {
                company: '=',
            }

    };

    angular
        .module('tikonApp')
        .component('pfQuickAccessTools', QuickAccessToolsComponent)

    QuickAccessToolsComponentController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

;
(function () {
  "use strict";

  angular
    .module("tikonApp")
    .factory("PosPaymentService", PosPaymentService);

  PosPaymentService.$inject = ["$resource"];

  function PosPaymentService($resource) {
    var baseUrl = "api/payment-logs/pos";

    return {

      sendToPos: function () {
        return $resource(
          baseUrl,
          {},
          {
            save: {
              method: "POST"
            }
          }
        );
      },
      
      checkStatus: function () {
        return $resource(
          baseUrl + "/:authorityToken",
          {
            authorityToken: "@authorityToken"
          },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        );
      }
    };
  }
})();
;
(function () {
  "use strict";

  function PosPaymentController(
    $mdDialog,
    $mdToast,
    PosPaymentService,
    AlertToastService
  ) {
    var $ctrl = this;

    // INPUT | PENDING | SUCCESS | FAILED | TIMEOUT
    $ctrl.step = "INPUT";
    $ctrl.payableAmount = 0;
    $ctrl.errorMessage = "";
    $ctrl.receiptData = null;
    $ctrl.isEditing = false;

    $ctrl.$onInit = function () {
      $ctrl.payableAmount = $ctrl.totalAmount || 0;
      $ctrl.paymentUnit = $ctrl.paymentUnit || "TOMAN";
    };

    $ctrl.cancel = function () {
      $mdDialog.cancel();
    };

    $ctrl.toggleEdit = function () {
      $ctrl.isEditing = !$ctrl.isEditing;
    };

    $ctrl.sendToPos = function () {
      var payload;

      if (!$ctrl.payableAmount || $ctrl.payableAmount <= 0) {
        handleError("مبلغ پرداخت باید بیشتر از صفر باشد.");
        return;
      }

      if (!$ctrl.invoiceInfoId) {
        handleError("شناسه اطلاعات فاکتور ارسال نشده است.");
        return;
      }

      if (!$ctrl.terminalId) {
        handleError("شناسه ترمینال کارتخوان ارسال نشده است.");
        return;
      }

      $ctrl.step = "PENDING";
      $ctrl.errorMessage = "";
      $ctrl.receiptData = null;

      payload = {
        amount: Number($ctrl.payableAmount),
        invoiceInfoId: $ctrl.invoiceInfoId,
        terminalId: $ctrl.terminalId
      };

      if ($ctrl.paymentUnit) {
        payload.unit = $ctrl.paymentUnit;
      }

      PosPaymentService.sendToPos().save(
        payload,
        function (res) {
          var authorityToken = getAuthorityToken(res);

          if (!authorityToken) {
            handleError(
              (res && res.message) ||
                "توکن استعلام تراکنش (authorityToken) از سرویس دریافت نشد."
            );
            return;
          }
          checkStatusOnce(authorityToken);
        },
        function (err) {
          if (err && err.status === 408) {
            $ctrl.step = "TIMEOUT";
            return;
          }

          handleError(getErrorMessage(err));
        }
      );
    };

    function checkStatusOnce(authorityToken) {
      PosPaymentService.checkStatus().get(
        {
          authorityToken: authorityToken
        },
        function (paymentLogs) {
          var paymentLog;
          var status;

          paymentLog = getLatestPaymentLog(paymentLogs);

          if (!paymentLog) {
            handleError("پاسخی برای وضعیت تراکنش دریافت نشد.");
            return;
          }

          status = getPaymentStatus(paymentLog);

          if (isSuccessfulStatus(status)) {
            handleSuccess(paymentLog);
            return;
          }

          if (isFailedStatus(status)) {
            handleError(
              paymentLog.message ||
                paymentLog.description ||
                "تراکنش توسط مشتری لغو شد یا ناموفق بود."
            );
            return;
          }

          /*
           * در حالت جدید، سرویس باید نتیجه نهایی را برگرداند.
           * بنابراین ACTIVE / PENDING نباید به کلاینت بازگردد.
           */
          handleError(
            paymentLog.message ||
              paymentLog.description ||
              "وضعیت نهایی تراکنش از سرویس دریافت نشد."
          );
        },
        function (err) {
          if (err && err.status === 408) {
            $ctrl.step = "TIMEOUT";
            return;
          }

          handleError(
            getErrorMessage(err) ||
              "استعلام وضعیت تراکنش با خطا مواجه شد."
          );
        }
      );
    }

    function getAuthorityToken(response) {
      if (!response) {
        return null;
      }

      if (response.authorityToken) {
        return response.authorityToken;
      }

      if (response.authority) {
        return response.authority;
      }

      if (response.token) {
        return response.token;
      }

      if (response.data && response.data.authorityToken) {
        return response.data.authorityToken;
      }

      if (response.result && response.result.authorityToken) {
        return response.result.authorityToken;
      }

      return null;
    }

    function getLatestPaymentLog(paymentLogs) {
      if (!paymentLogs) {
        return null;
      }

      if (angular.isArray(paymentLogs)) {
        if (paymentLogs.length === 0) {
          return null;
        }

        return paymentLogs[paymentLogs.length - 1];
      }

      return paymentLogs;
    }

    function getPaymentStatus(paymentLog) {
      var status;

      if (!paymentLog) {
        return "";
      }

      status =
        paymentLog.status ||
        paymentLog.paymentStatus ||
        paymentLog.transactionStatus ||
        paymentLog.state ||
        "";

      return String(status).toUpperCase();
    }

    function isSuccessfulStatus(status) {
      return (
        status === "OK" ||
        status === "SUCCESS" ||
        status === "SUCCEEDED" ||
        status === "PAID" ||
        status === "COMPLETED" ||
        status === "SUCCESSFUL"
      );
    }

    function isFailedStatus(status) {
      return (
        status === "NOK" ||
        status === "FAILED" ||
        status === "FAIL" ||
        status === "CANCELED" ||
        status === "CANCELLED" ||
        status === "REJECTED" ||
        status === "ERROR"
      );
    }

    function getErrorMessage(err) {
      if (err && err.data && err.data.message) {
        return err.data.message;
      }

      if (err && err.data && err.data.error) {
        return err.data.error;
      }

      if (err && err.statusText) {
        return err.statusText;
      }

      return "ارسال تراکنش به دستگاه کارتخوان با خطا مواجه شد.";
    }

    function handleSuccess(data) {
      $ctrl.receiptData = data || {};
      $ctrl.step = "SUCCESS";

      $mdToast.show(
        $mdToast
          .simple()
          .textContent("پرداخت با موفقیت انجام شد")
          .position("top left")
      );
    }

    function handleError(message) {
      $ctrl.errorMessage = message || "تراکنش ناموفق بود.";
      $ctrl.step = "FAILED";
    }

    $ctrl.retry = function () {
      $ctrl.sendToPos();
    };

    $ctrl.closeSuccess = function () {
      $mdDialog.hide($ctrl.receiptData);
    };
  }

  PosPaymentController.$inject = [
    "$mdDialog",
    "$mdToast",
    "PosPaymentService",
    "AlertToastService"
  ];

  angular.module("tikonApp").component("pfPosPayment", {
    templateUrl: "app/components/partial-forms/pos-payment/pos-payment.html",
    controller: PosPaymentController,
    bindings: {
      totalAmount: "<",
      invoiceInfoId: "<?",
      terminalId: "<?",
      paymentUnit: "<?"
    }
  });
})();
;
// (function () {
//   "use strict";

//   function PosPaymentController(
//     $mdDialog,
//     $mdToast,
//     $interval,
//     PosPaymentService,
//     AlertToastService
//   ) {
//     var $ctrl = this;

//     // INPUT | PENDING | SUCCESS | FAILED | TIMEOUT
//     $ctrl.step = "INPUT";
//     $ctrl.payableAmount = 0;
//     $ctrl.errorMessage = "";
//     $ctrl.receiptData = null;
//     $ctrl.isEditing = false;

//     var statusPollingPromise = null;
//     var isCheckingStatus = false;

//     $ctrl.$onInit = function () {
//       $ctrl.payableAmount = $ctrl.totalAmount || 0;

//       $ctrl.paymentUnit = $ctrl.paymentUnit || "TOMAN";
//     };

//     $ctrl.cancel = function () {
//       stopPolling();
//       $mdDialog.cancel();
//     };

//     $ctrl.toggleEdit = function () {
//       $ctrl.isEditing = !$ctrl.isEditing;
//     };

//     $ctrl.sendToPos = function () {
//       var payload;

//       if (!$ctrl.payableAmount || $ctrl.payableAmount <= 0) {
//         handleError("مبلغ پرداخت باید بیشتر از صفر باشد.");
//         return;
//       }

//       if (!$ctrl.invoiceInfoId) {
//         handleError("شناسه اطلاعات فاکتور ارسال نشده است.");
//         return;
//       }

//       if (!$ctrl.terminalId) {
//         handleError("شناسه ترمینال کارتخوان ارسال نشده است.");
//         return;
//       }

//       stopPolling();

//       $ctrl.step = "PENDING";
//       $ctrl.errorMessage = "";
//       $ctrl.receiptData = null;

//       payload = {
//         amount: Number($ctrl.payableAmount),
//         invoiceInfoId: $ctrl.invoiceInfoId,
//         terminalId: $ctrl.terminalId
//       };

//       /*
//        * اگر بک‌اند به unit نیاز دارد، ارسال می‌شود.
//        * اگر بعداً مشخص شد unit نباید ارسال شود، این بلوک را حذف کنید.
//        */
//       if ($ctrl.paymentUnit) {
//         payload.unit = $ctrl.paymentUnit;
//       }

//       PosPaymentService.sendToPos().save(
//         payload,
//         function (res) {
//           var authorityToken = getAuthorityToken(res);

//           if (!authorityToken) {
//             handleError(
//               (res && res.message) ||
//                 "توکن استعلام تراکنش (authorityToken) از سرویس دریافت نشد."
//             );
//             return;
//           }

//           startPolling(authorityToken);
//         },
//         function (err) {
//           if (err && err.status === 408) {
//             stopPolling();
//             $ctrl.step = "TIMEOUT";
//             return;
//           }

//           handleError(getErrorMessage(err));
//         }
//       );
//     };

//     function startPolling(authorityToken) {
//       var counter = 0;
//       var maxAttempts = 30;

//       stopPolling();

//       statusPollingPromise = $interval(function () {
//         if (isCheckingStatus) {
//           return;
//         }

//         counter++;

//         if (counter > maxAttempts) {
//           stopPolling();
//           $ctrl.step = "TIMEOUT";
//           return;
//         }

//         isCheckingStatus = true;

//         PosPaymentService.checkStatus().get(
//           {
//             authorityToken: authorityToken
//           },
//           function (paymentLogs) {
//             var paymentLog;
//             var status;

//             isCheckingStatus = false;

//             /*
//              * طبق مستند، پاسخ GET آرایه PaymentLogDto[] است.
//              */
//             paymentLog = getLatestPaymentLog(paymentLogs);

//             if (!paymentLog) {
//               return;
//             }

//             status = getPaymentStatus(paymentLog);

//             /*
//              * مطابق پاسخ فعلی سرویس شما:
//              * OK  => موفق
//              * NOK => ناموفق
//              *
//              * مقادیر دیگر مثل PENDING / PROCESSING باعث ادامه polling می‌شوند.
//              */
//             if (isSuccessfulStatus(status)) {
//               stopPolling();
//               handleSuccess(paymentLog);
//               return;
//             }

//             if (isFailedStatus(status)) {
//               stopPolling();

//               handleError(
//                 paymentLog.message ||
//                   paymentLog.description ||
//                   "تراکنش توسط مشتری لغو شد یا ناموفق بود."
//               );
//             }
//           },
//           function (err) {
//             isCheckingStatus = false;

//             /*
//              * خطای timeout از سمت سرور
//              */
//             if (err && err.status === 408) {
//               stopPolling();
//               $ctrl.step = "TIMEOUT";
//             }

//             /*
//              * خطاهای موقت دیگر در استعلام نادیده گرفته می‌شوند
//              * تا polling تا رسیدن به maxAttempts ادامه داشته باشد.
//              */
//           }
//         );
//       }, 2000);
//     }

//     /**
//      * استخراج authorityToken بدون استفاده از optional chaining.
//      * کاملاً سازگار با ES5.
//      */
//     function getAuthorityToken(response) {
//       if (!response) {
//         return null;
//       }

//       if (response.authorityToken) {
//         return response.authorityToken;
//       }

//       if (response.authority) {
//         return response.authority;
//       }

//       if (response.token) {
//         return response.token;
//       }

//       if (response.data && response.data.authorityToken) {
//         return response.data.authorityToken;
//       }

//       if (response.result && response.result.authorityToken) {
//         return response.result.authorityToken;
//       }

//       return null;
//     }

//     /**
//      * پاسخ API طبق مستند آرایه PaymentLogDto[] است.
//      * آخرین آیتم به عنوان تازه‌ترین وضعیت در نظر گرفته می‌شود.
//      */
//     function getLatestPaymentLog(paymentLogs) {
//       if (!paymentLogs) {
//         return null;
//       }

//       if (angular.isArray(paymentLogs)) {
//         if (paymentLogs.length === 0) {
//           return null;
//         }

//         return paymentLogs[paymentLogs.length - 1];
//       }

//       /*
//        * برای سازگاری با پاسخ احتمالی غیرآرایه‌ای.
//        */
//       return paymentLogs;
//     }

//     /**
//      * نام قطعی فیلد وضعیت در PaymentLogDto باید با نمونه پاسخ بک‌اند
//      * نهایی شود. فعلاً چند نام متداول پشتیبانی شده‌اند.
//      */
//     function getPaymentStatus(paymentLog) {
//       var status;

//       if (!paymentLog) {
//         return "";
//       }

//       status =
//         paymentLog.status ||
//         paymentLog.paymentStatus ||
//         paymentLog.transactionStatus ||
//         paymentLog.state ||
//         "";

//       return String(status).toUpperCase();
//     }

//     function isSuccessfulStatus(status) {
//       return (
//         status === "OK" ||
//         status === "SUCCESS" ||
//         status === "SUCCEEDED" ||
//         status === "PAID" ||
//         status === "COMPLETED" ||
//         status === "SUCCESSFUL"
//       );
//     }

//     function isFailedStatus(status) {
//       return (
//         status === "NOK" ||
//         status === "FAILED" ||
//         status === "FAIL" ||
//         status === "CANCELED" ||
//         status === "CANCELLED" ||
//         status === "REJECTED" ||
//         status === "ERROR"
//       );
//     }

//     function getErrorMessage(err) {
//       if (err && err.data && err.data.message) {
//         return err.data.message;
//       }

//       if (err && err.data && err.data.error) {
//         return err.data.error;
//       }

//       if (err && err.statusText) {
//         return err.statusText;
//       }

//       return "ارسال تراکنش به دستگاه کارتخوان با خطا مواجه شد.";
//     }

//     function stopPolling() {
//       isCheckingStatus = false;

//       if (angular.isDefined(statusPollingPromise) && statusPollingPromise) {
//         $interval.cancel(statusPollingPromise);
//         statusPollingPromise = null;
//       }
//     }

//     function handleSuccess(data) {
//       stopPolling();

//       $ctrl.receiptData = data || {};
//       $ctrl.step = "SUCCESS";

//       $mdToast.show(
//         $mdToast
//           .simple()
//           .textContent("پرداخت با موفقیت انجام شد")
//           .position("top left")
//       );
//     }

//     function handleError(message) {
//       stopPolling();

//       $ctrl.errorMessage = message || "تراکنش ناموفق بود.";
//       $ctrl.step = "FAILED";
//     }

//     $ctrl.retry = function () {
//       stopPolling();
//       $ctrl.sendToPos();
//     };

//     $ctrl.closeSuccess = function () {
//       stopPolling();
//       $mdDialog.hide($ctrl.receiptData);
//     };

//     $ctrl.$onDestroy = function () {
//       stopPolling();
//     };
//   }

//   PosPaymentController.$inject = [
//     "$mdDialog",
//     "$mdToast",
//     "$interval",
//     "PosPaymentService",
//     "AlertToastService"
//   ];

//   angular.module("tikonApp").component("pfPosPayment", {
//     templateUrl: "app/components/partial-forms/pos-payment/pos-payment.html",
//     controller: PosPaymentController,
//     bindings: {
//       totalAmount: "<",
//       invoiceInfoId: "<?",
//       terminalId: "<?",
//       paymentUnit: "<?"
//     }
//   });
// })();
;
(function () {
    'use strict';

    function PersonInfoComponentV2Controller($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.gender;
        $ctrl.loadPage = loadPage;
        $ctrl.necessaryFieldsCheck = necessaryFieldsCheck;
        $ctrl.selectedId = '';
        $ctrl.provinceList = [];
        $ctrl.cityList = [];

        loadAll();
        loadPage();

        function loadAll() {

            if ($ctrl.showImage == undefined)
                $ctrl.showImage = true;

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function necessaryFieldsCheck() {

            try {
                if (($ctrl.personInfo.fisrtName != '' && $ctrl.personInfo.fisrtName != undefined) &&
                    ($ctrl.personInfo.lastName != '' && $ctrl.personInfo.lastName != undefined)) {
                    // $scope.$parent.vm.hasAllNecessaryFields = true;
                    $ctrl.canSave = true;
                } else {
                    // $scope.$parent.vm.hasAllNecessaryFields = false;
                    $ctrl.canSave = false;
                }
            } catch (ex) {
                // nothing
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            if ($ctrl.userAccountId) {
                $ctrl.blockedEdit = true;
            } else {
                $ctrl.blockedEdit = false;
            }

            if ($ctrl.personInfo != undefined && $ctrl.personInfo.location != undefined && $ctrl.personInfo.location.countryId != null && $ctrl.personInfo.location.countryId != undefined) {
                $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.personInfo.location.countryId).query();
                if ($ctrl.personInfo.location.stateId != null && $ctrl.personInfo.location.stateId != undefined) {
                    $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.personInfo.location.stateId).query();
                }

            }

            if ($ctrl.blockEditPhoneNumber == null || $ctrl.blockEditPhoneNumber == undefined)
                $ctrl.blockEditPhoneNumber = false;

            if ($ctrl.personInfo && $ctrl.personInfo)
                $ctrl.necessaryFieldsCheck();

        }

        function country_changed() {
            $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.personInfo.location.countryId).query();
        }

        function province_changed() {
            $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.personInfo.location.stateId).query();
        }

    }

    var PersonInfoComponentV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/person-info-v2/partial-form.person-info-v2.html',
        controller: PersonInfoComponentV2Controller,
        bindings:
            {
                personInfo: '=',
                servantCode: '=',
                userAccountId: '=',
                isCustomer: '=',
                isServant: '=',
                blockEditPhoneNumber: '=?',
                canSave: '=?',
                showImage: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfPersonInfoV2', PersonInfoComponentV2)

    PersonInfoComponentV2Controller.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

;
(function () {
    'use strict';

    function PersonInfoSpaceComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.necessaryFieldsCheck = necessaryFieldsCheck;
        $ctrl.selectedId = '';

        loadAll();
        loadPage();

        function loadAll() {


            if ($ctrl.personInfo == null || $ctrl.personInfo == undefined)
                $ctrl.personInfo = {};

            $ctrl.personInfo.lastName = ' ';

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function necessaryFieldsCheck() {

        }

        function loadPage(page) {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

        }

    }

    var PersonInfoSpaceComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/person-info-space/partial-form.person-info-space.html',
        controller: PersonInfoSpaceComponentController,
        bindings:
            {
                personInfo: '=',
                servantCode: '=',
                userAccountId: '=',
                isCustomer: '=',
                isServant: '=',
                blockEditPhoneNumber: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfPersonInfoSpace', PersonInfoSpaceComponent)

    PersonInfoSpaceComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

;
(function () {
    'use strict';

    function PersonInfoComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.gender;
        $ctrl.loadPage = loadPage;
        $ctrl.necessaryFieldsCheck = necessaryFieldsCheck;
        $ctrl.selectedId = '';
        // $ctrl.country_changed = country_changed;
        // $ctrl.province_changed = province_changed;
        // $ctrl.selectordata = SelectorData.query();
        // $ctrl.countryList = SelectorDataQuery.findByType('country').query();
        // $ctrl.editable = true;
        $ctrl.provinceList = [];
        $ctrl.cityList = [];

        loadAll();

        loadPage();

        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function necessaryFieldsCheck() {

            try {
                if (($ctrl.personInfo.fisrtName != '' && $ctrl.personInfo.fisrtName != undefined) &&
                    ($ctrl.personInfo.lastName != '' && $ctrl.personInfo.lastName != undefined)) {
                    // $scope.$parent.vm.hasAllNecessaryFields = true;
                    $ctrl.canSave = true;
                } else {
                    // $scope.$parent.vm.hasAllNecessaryFields = false;
                    $ctrl.canSave = false;
                }
            } catch (ex) {
                // nothing
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            if ($ctrl.userAccountId) {
                $ctrl.blockedEdit = true;
            } else {
                $ctrl.blockedEdit = false;
            }

            if ($ctrl.personInfo != undefined && $ctrl.personInfo.location != undefined && $ctrl.personInfo.location.countryId != null && $ctrl.personInfo.location.countryId != undefined) {
                $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.personInfo.location.countryId).query();
                if ($ctrl.personInfo.location.stateId != null && $ctrl.personInfo.location.stateId != undefined) {
                    $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.personInfo.location.stateId).query();
                }

            }

            if ($ctrl.blockEditPhoneNumber == null || $ctrl.blockEditPhoneNumber == undefined)
                $ctrl.blockEditPhoneNumber = false;

            if ($ctrl.personInfo && $ctrl.personInfo)
                $ctrl.necessaryFieldsCheck();

        }

        function country_changed() {
            $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.personInfo.location.countryId).query();
        }

        function province_changed() {
            $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.personInfo.location.stateId).query();
        }

    }

    var PersonInfoComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/person-info/partial-form.person-info.html',
        controller: PersonInfoComponentController,
        bindings:
            {
                personInfo: '=',
                servantCode: '=',
                userAccountId: '=',
                isCustomer: '=',
                isServant: '=',
                blockEditPhoneNumber: '=?',
                canSave: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfPersonInfo', PersonInfoComponent)

    PersonInfoComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

;
(function () {
    'use strict';

     function ReserveServiceItemV2Controller($uibModal, $scope, $state, $stateParams, $timeout, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem, ServiceItemCustom, ServiceTimeSessionCustom, SettingInfoCustom, ServiceTimeSession, dateUtil, ScheduleInfoCustom, TimingInfo, OrderBagCustom, Servant, DateUtils, OrderBagServiceItemCustom,ServantCustom,Principal,ActivityTypeInfoCustom,CompanyCustom) {

        var firstHourInDay = 8;
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.formState = 'orderbagitem';
        // $ctrl.initMode ='DEFAULT';
        $ctrl.options = null;
        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
        $ctrl.priceInfoDtails = null;
        $ctrl.addOrderBagDtails = addOrderBagDtails;
        $ctrl.computeTotalPrice = computeTotalPrice;
        $ctrl.isSaving = false;
        //$ctrl.findFormState = findFormState;
        $ctrl.prev = prev;

        $ctrl.serviceItem_changed = serviceItem_changed;
        $ctrl.openPersonInfoModal = openPersonInfoModal;
        $ctrl.serviceItems = null;
        $ctrl.qtyChanged = qtyChanged;
        $ctrl.availableDates_changed = availableDates_changed;
        $ctrl.availableTimes_changed = availableTimes_changed;
        $ctrl.servant_changed = servant_changed;
        $ctrl.availableDynamicDates_changed = availableDynamicDates_changed;
        $ctrl.availableDynamicFromTime_changed = availableDynamicFromTime_changed;
        $ctrl.availableDynamicToTime_changed = availableDynamicToTime_changed;

        $ctrl.updateAvailableDates = updateAvailableDates;
        $ctrl.updateAvailableFromTime = updateAvailableFromTime;
        $ctrl.updateAvailableToTime = updateAvailableToTime;
        $ctrl.updateServantList = updateServantList;
        $ctrl.updateServiceList = updateServiceList;

        $ctrl.servantList = [];
        $ctrl.selectedServiceTimeSession = {};
        $ctrl.selectedDynamicDate = null;
        $ctrl.selectedDynamicTime = null;
        $ctrl.allAvailableDynamicTimes = null;
        $ctrl.selectedServant = null;
        $ctrl.timeUnitQty = 1;
        $ctrl.selectedToTime = null;
        $ctrl.showPrices = showPrices;
        if (!$ctrl.editMode)
            $ctrl.editMode = 'NONE'; // 'EDIT' , 'NONE'

        $ctrl.scheduleType = 'PRIMARY';
        $ctrl.floatingTimeType = null;
        $ctrl.availableQty = [];
        $ctrl.maxAvailableQty = 0;
        $ctrl.showCountBox = true;
        $ctrl.selectedService = null;
        $ctrl.selectedServiceDuration = null;


        $ctrl.availableTimeUnitQty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        $ctrl.timeUnitQty_Changed = timeUnitQty_Changed;


        // $ctrl.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();
        //test
        //--------------------
        $ctrl.simulateQuery = false;
        $ctrl.isDisabled = false;
        $ctrl.servicesNames = [];
        $ctrl.querySearch = querySearch;
        //--------------------
        $ctrl.fromDateToLoad = new Date();
        $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
        $ctrl.isDatesLoading = false;
        $ctrl.loadMoreAvailableDates = loadMoreAvailableDates;
        //$ctrl.showUnPlannedTime = false;
        $ctrl.showUnPlannedTimeChange = showUnPlannedTimeChange;

        $ctrl.isCapacityAvailable = true;

        $ctrl.checkCapacityInProgress = false;

        $ctrl.canSelectOtherServant = false;
        $ctrl.canSelectOtherServant = !Principal.hasAnyAuthority(["ROLE_SERVANT_LOGIN"])
        $ctrl.activityTypeInfo = {};
        //-------------------------------
        loadPage();

        function loadPage(page) {
            translatePartialLoader.addPart('orderBagServiceItemDtail');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader.addPart('orderBagItemOption');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('participantPerson');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            if ($ctrl.showUnPlannedTime == null)
                $ctrl.showUnPlannedTime = false;


            if ($ctrl.showOptionItems == null)
                $ctrl.showOptionItems = true;

            initServiceItem();
            // updateServiceList(setDefaultValues);


            if (!$ctrl.defaultServantId)
                loadAllServiceItems(setDefaultValues);
            else {
                if (!$ctrl.canSelectOtherServant) {
                    loadServiceItemsByServantId(setDefaultValues);
                    loadDefaultServant();
                } else {
                    loadAllServiceItems(setDefaultValues);
                    loadAllServants();
                }

            }

            if ($ctrl.showUnPlannedTime) {
                $ctrl.checkCapacity = false;
                if ($ctrl.defaultStartDate)
                    makeDateList();
            }

            getActivityTypeInfo();

        }

        function getActivityTypeInfo() {
            CompanyCustom.getCurrentCompany().query(function (result) {
                ActivityTypeInfoCustom.getActivityTypeInfoByType(result.activityType).query(function (activity) {
                    $ctrl.activityTypeInfo = activity;
                    if (activity && activity.servantType == "RESOURCE") {
                        $ctrl.isWorkSpace = true;
                    }

                })

            });
        }

        function loadAllServants() {
            //if servant_login just current servant must selected
            ServantCustom.findServantsByCompany().query(function (result) {
                $ctrl.servantList = result;
                setDefaultServant();
            });
        }


        function loadDefaultServant() {
            if (!$ctrl.defaultServantId)
                return;
            $ctrl.servantList = [];
            Servant.get({id: $ctrl.defaultServantId}).$promise.then(function (result) {
                $ctrl.servantList.push(result);
                $ctrl.orderBagServiceItem.servant = result;
            });

        }

        function querySearch(query) {

            var temp = [];


            angular.forEach($ctrl.serviceItems, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.serviceItems;
                }
            })

            return temp;

        }

        function loadAllServiceItems(then) {


            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {
                $ctrl.serviceItems = items;
                if (then) {
                    then();
                }
            });
        }

        function loadServiceItemsByServantId(then) {

            if ($ctrl.defaultServantId) {
                if (!$ctrl.canSelectOtherServant) {
                    ServiceItemCustom.getServiceItemsByServantId($ctrl.defaultServantId).query(function (items) {
                        $ctrl.serviceItems = items;
                        if (then)
                            then();
                    });
                }
            }
        }

        function serviceItem_changed(item) {

            $ctrl.selectedDate = null;
            $ctrl.selectedServiceTimeSession = {};

            if (item) {
                $ctrl.orderBagServiceItem.serviceItemId = item.id;
                if (item.duration)
                    $ctrl.selectedServiceDuration = item.duration;

                updateServantList();
            } else {
                $ctrl.orderBagServiceItem.serviceItemId = null;
                $ctrl.servantList = [];
            }
            $timeout(function(){
                orderBagItem_Changed();
                $ctrl.onServiceChanged();
            }, 1000)
            //


        }

        function setServant(servantid) {
            $ctrl.orderBagServiceItem.servant = null;

            //in edit mode always must select default servant
            if($ctrl.defaultServantId && $ctrl.editMode == 'EDIT')
            {
                servantid = $ctrl.defaultServantId;
            }
            if (servantid) {
                $ctrl.orderBagServiceItem.servant = {};
                $ctrl.orderBagServiceItem.servant.id = servantid;

            }

        }

        function getServantId() {

            if ($ctrl.orderBagServiceItem.servant)
                return $ctrl.orderBagServiceItem.servant.id;
            if ($ctrl.selectedServant)
                return $ctrl.selectedServant.id;

            return null;
        }

        function updateServantList(then) {
            //for now if 'REPLACE_TIME' return

            // if ($ctrl.editMode == 'EDIT')
            //     return;

            resetLoadDatesDefault();

            // if ($ctrl.showUnPlannedTime == true) {
            //     updateServantListWithDefault();
            //     setDefaultToTime();
            //     availableDynamicToTime_changed();
            //     return;
            // }


            setServant();
            $ctrl.servantList = [];
            if ($ctrl.orderBagServiceItem.serviceItemId) {
                ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                        $ctrl.servantList = servants;

                        if ($ctrl.defaultServantId && !$ctrl.canSelectOtherServant) {
                            $ctrl.servantList = [];
                            angular.forEach(servants, function (srv) {
                                if (srv.id == $ctrl.defaultServantId)
                                    $ctrl.servantList.push(srv);
                            })
                        }
                        if ($ctrl.servantList && $ctrl.servantList.length > 1) {
                            ServiceItemCustom.getAutoSelectServant($ctrl.orderBagServiceItem.serviceItemId).query(function (selecedServant) {

                                    if (selecedServant && selecedServant.id) {
                                        angular.forEach($ctrl.servantList, function (s) {
                                            if (s.id == selecedServant.id)
                                                setServant(selecedServant.id);
                                        });
                                    } else {
                                        if ($ctrl.servantList[0])
                                            setServant($ctrl.servantList[0].id);

                                        if (then)
                                            then();
                                    }
                                    if (then)
                                        then();

                                    $ctrl.updateAvailableDates(then);
                                },
                                function () {
                                    if ($ctrl.servantList[0])
                                        setServant($ctrl.servantList[0].id);

                                    if (then)
                                        then();
                                    $ctrl.updateAvailableDates(then);
                                })

                        } else {
                            if ($ctrl.servantList[0])
                                setServant($ctrl.servantList[0].id);

                            if (then)
                                then();
                            $ctrl.updateAvailableDates(then);
                        }
                    }
                    , function () {
                        if (then)
                            then();
                        $ctrl.updateAvailableDates(then);

                    });
            }
        }

        function updateServantListWithDefault() {
            $ctrl.servantList = [];

            if ($ctrl.defaultServantId) {
                loadDefaultServant();
                setServant($ctrl.defaultServantId);
            } else {
                if ($ctrl.orderBagServiceItem.serviceItemId) {
                    ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                        $ctrl.servantList = servants;
                    });
                }
            }
        }

        function updateServiceList(then) {

            $ctrl.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(onSuccess);

            function onSuccess() {
                if (then) {
                    then();
                }
                $ctrl.updateServantList(then);

            }
        }

        function setDefaultValues() {

            initDefaultSelectedItems();
            setDefaultServiceItem();
            setDefaultDateAndTime();
            setDefaultServant();
        }

        function initDefaultSelectedItems() {

            if ($ctrl.defaultSelectedService != null) {
                $ctrl.selectedService = $ctrl.defaultSelectedService;
                $ctrl.serviceItem_changed($ctrl.selectedService)
            }
            if ($ctrl.defaultSelectedServant != null) {
                $ctrl.selectedServant = $ctrl.defaultSelectedServant;
                setServant($ctrl.defaultSelectedServant.id)
                // $ctrl.orderBagServiceItem.servant = $ctrl.defaultSelectedServant;
                $ctrl.servant_changed();
            }
            if ($ctrl.defaultSelectedServantId != null) {
                setServantSelected($ctrl.defaultSelectedServantId);
                $ctrl.servant_changed();
            }

        }

        function setServantSelected(servantId) {

            var selectedServant = null;
            angular.forEach($ctrl.servantList, function (servant) {
                if (servant.id == servantId) {
                    selectedServant = servant;
                }
            });
            $ctrl.selectedServant = selectedServant;
            setServant(servantId);
        }

        function initServiceItem() {
            // if ($ctrl.editMode == 'EDIT')
            //     return;


            if (!$ctrl.orderBagServiceItem)
                $ctrl.orderBagServiceItem = {};
            $ctrl.orderBagServiceItem.servant = {};
            if (!$ctrl.orderBagServiceItem.index)
                $ctrl.orderBagServiceItem.index = 0;
        }

        function setDefaultServiceItem() {

            if ($ctrl.defaultServiceItemId != null && $ctrl.defaultServiceItemId != undefined) {
                $ctrl.orderBagServiceItem.serviceItemId = Number($ctrl.defaultServiceItemId);
                //$ctrl.serviceItem_changed();
                //setDefaultTimeSession();
                //setDefaultDateAndTime();
                //setDefaultServant();
                // loadAvailableDates();
            }
        }

        function setDefaultServant() {
            if ($ctrl.defaultServantId)
                setServant($ctrl.defaultServantId);

        }

        function setDefaultDateAndTime() {

            if (!$ctrl.showUnPlannedTime)
                return;

            if ($ctrl.defaultStartDate != null && $ctrl.defaultStartDate != undefined) {
                $ctrl.selectedDynamicDate = dateUtil.convertToISOString(new Date($ctrl.defaultStartDate));

            }
            if ($ctrl.defaultEndDate != null && $ctrl.defaultEndDate != "" && $ctrl.defaultEndDate != undefined) {

                $ctrl.selectedToTime = new Date($ctrl.defaultEndDate).toISOString();
                $ctrl.selectedDynamicTime = new Date($ctrl.defaultStartDate).toISOString();
            }
        }

        function getPriceInfoDtail(then) {
            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null) {
                // error
                // have to evaluate
                return;
            }
            if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                //do nothing
                // in view mode and not editable
            } else {
                var servantId = null;
                if($ctrl.orderBagServiceItem.servant){
                     if ($ctrl.orderBagServiceItem.servant.id)
                            servantId = $ctrl.orderBagServiceItem.servant.id;
                        PriceInfoDtailCustom.getPriceInfoDtailByServiceItemFromDate($ctrl.orderBagServiceItem.serviceItemId, servantId, $ctrl.orderBagServiceItem.serviceTimeSession.startTime).query(function (result) {

                            $ctrl.priceInfoDtails = result;
                            addOrderBagDtails();
                            // $ctrl.serviceItem_changed();
                            //reloadPrices();
                            changeControlsData();
                        });
                }

            }

             if (then)
                 then();
        }

        function addOrderBagDtails() {

            clearOrderBagDetails();

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
            }

            var x;
            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {

                x = $ctrl.priceInfoDtails[i];
                if (x == null)
                    continue;

                //if priceInfoDetailID set in ReserveServiceItemDtail must Update Quantity
                //if (UpdateExistReserveServiceItemDtail(x, orderbagOptions))
                if (false) {
                    //do nothing
                } else {
                    var defaultQty = 0;
                    if (i == 0) defaultQty = 1;
                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
                        gty: defaultQty,
                        price: x.price,
                        discount: x.discount,
                        vat: 0,
                        totalPrice: 0,
                        serviceTimeSession: $ctrl.orderBagServiceItem.serviceTimeSession,
                        //priceInfoDtailId: x.id,
                        priceInfoDtail: x,
                        orderBagItemOptions: null,
                        timeUnitQty: $ctrl.timeUnitQty
                    });
                }
            }

            //   computeTotalPrice();
            setShowCountBox();
        }

        function computeTotalPrice() {
            if ($ctrl.onItemChanged)
                $ctrl.onItemChanged($ctrl.orderBagServiceItem);
        }

        function prev() {
            $ctrl.formState = 'orderbagitem';
            //  reloadPrices();
        }


        function openPersonInfoModal() {
            $uibModal.open({
                templateUrl: 'app/entities/participant-person/order-bag-item-participant-person-dialog.html',
                controller: 'OrderBagParticipantPersonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function (result) {
                // addParticipantPerson(result);
            }, function () {
                //nothing
            });


        }


        function clearOrderBagDetails() {
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = null;
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
        }

        function changeControlsData() {
            computeTotalPrice();
        }

        function qtyChanged() {
            changeControlsData();
        }

        function servant_changed() {

            resetLoadDatesDefault();
            updateAvailableDates();
            orderBagItem_Changed();

        }

        function availableDates_changed() {
            loadAvailableTimes();
            orderBagItem_Changed();
        }

        function resetLoadDatesDefault() {
            $ctrl.availableDynamicDates = [];
            $ctrl.fromDateToLoad = new Date();
            $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
            $ctrl.loadedMore = false;
        }

        function loadAvailableTimes(then) {

            if ($ctrl.selectedDate == undefined || $ctrl.selectedDate == null)
                return;

            $ctrl.orderBagServiceItem.serviceTimeSession = null;

            var dateTime = new Date($ctrl.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query(function (list) {
                $ctrl.availableTimes = list;
                if (then)
                    then();

            });

        }

        function availableTimes_changed() {
            // getPriceInfoDtail();
            //changeControlsData();
            orderBagItem_Changed();
        }

        function updateAvailableDates(then) {


            // if ($ctrl.showUnPlannedTime) {
            //     initDefaultUnPLannedDates();
            //     setDefaultToTime();
            //     availableDynamicToTime_changed();
            //     return;
            // }


            if ($ctrl.isDatesLoading)
                return;


            $ctrl.isDatesLoading = true;

            if ($ctrl.showUnPlannedTime)
                ScheduleInfoCustom.getAllDate($ctrl.fromDateToLoad, $ctrl.toDateToLoad).query(function (result) {
                    onLoadDatesSuccess(result, then)
                });
            else
                ScheduleInfoCustom.getDynamicAvailableDatesByServiceIdAndServantId($ctrl.orderBagServiceItem.serviceItemId, getServantId(), $ctrl.fromDateToLoad, $ctrl.toDateToLoad).query(function (result) {
                    onLoadDatesSuccess(result, then)
                });


        }

        function onLoadDatesSuccess(list, then) {

            var filteredList = [];
            var filteredDate = [];
            list.forEach(function (item) {
                if (filteredDate.indexOf(item.spanDate) < 0) {
                    filteredList.push(item);
                    filteredDate.push(item.spanDate);
                }
            });

            filteredList = filteredList.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(a.spanDate) - new Date(b.spanDate);
            });

            if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                // add new dates to old list
                filteredList.forEach(function (item) {
                    $ctrl.availableDynamicDates.push(item);
                });

            } else {

                $ctrl.availableDynamicDates = filteredList;
                if (filteredList[0]) {
                    $ctrl.selectedDynamicDate = filteredList[0].spanDate;
                    setDefaultDateAndTime();
                }
            }
            $ctrl.isDatesLoading = false;

            if (then)
                then();

            $ctrl.updateAvailableFromTime(then);


        };

        function updateAvailableFromTime(then) {

            $ctrl.selectedDynamicTime = null;
            $ctrl.selectedToTime = null;
            if (!$ctrl.selectedDynamicDate) {
                $ctrl.availableDynamicTimes = [];
                $ctrl.selectedDynamicTime = null;
                $ctrl.updateAvailableToTime(then);
                return;
            }
            var dateTime = new Date($ctrl.selectedDynamicDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            if ($ctrl.showUnPlannedTime)
                makeUnPlannedFromTimeList();
            else
                ScheduleInfoCustom.getDynamicAvailableTimesByServiceIdAndServantIdInOneDate($ctrl.orderBagServiceItem.serviceItemId, getServantId(), dateTime.toISOString()).query(function (result) {
                    onLoadAvailableTimeSuccess(result, then);
                });

        }

        function onLoadAvailableTimeSuccess(result, then) {
            $ctrl.allAvailableDynamicTimes = result;
            $ctrl.availableDynamicTimes = result.filter(function (v) {
                    return (v.capacity > 0)
                }
            );

            $ctrl.availableDynamicTimes = $ctrl.availableDynamicTimes.sort(function (a, b) {
                return new Date(a.startTime) - new Date(b.startTime);
            });

            if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {

                setDefaultFromTime();
                $ctrl.updateAvailableToTime(then);
                if (then)
                    then();

            }
        }

        function setDefaultFromTime() {
            if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                $ctrl.selectedDynamicTime = $ctrl.availableDynamicTimes[0].startTime;

                if ($ctrl.showUnPlannedTime) {
                    if ($ctrl.defaultStartDate) {
                        var defaultDate = new Date($ctrl.defaultStartDate);
                        var myToday = new Date($ctrl.selectedDynamicDate);
                        myToday = new Date(myToday.getFullYear(), myToday.getMonth(), myToday.getDate(), defaultDate.getHours(), defaultDate.getMinutes(), 0);
                        $ctrl.selectedDynamicTime = myToday.toISOString();
                    } else {
                        var today = new Date($ctrl.selectedDynamicTime.getFullYear(), $ctrl.selectedDynamicTime.getMonth(), $ctrl.selectedDynamicTime.getDate(), firstHourInDay, 0, 0);
                        $ctrl.selectedDynamicTime = today.toISOString();
                    }
                }

                availableDynamicFromTime_changed();

            }
        }

        function makeUnPlannedFromTimeList() {

            // if($ctrl.selectedServiceDuration)
            //     date = new Date(date.getTime() + $ctrl.selectedServiceDuration*60000);

            if (!$ctrl.selectedDynamicDate)
                return;

            $ctrl.fromTimePeriodList = [];
            var startTimes = getSelectableTimes(new Date($ctrl.selectedDynamicDate), true);
            $ctrl.fromTimePeriodList = startTimes;

            onLoadAvailableTimeSuccess($ctrl.fromTimePeriodList);
        }

        function availableDynamicDates_changed() {

            updateAvailableFromTime();
        }

        function availableDynamicFromTime_changed() {
            updateAvailableToTime();
            setDefaultToTime();

            orderBagItem_Changed();

        }

        function updateTimeSessionData() {
            if ($ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                $ctrl.orderBagServiceItem.serviceTimeSession = createTimeSession($ctrl.selectedDynamicTime, $ctrl.selectedToTime);
        }

        function setMaxAvailableCapacity() {
            var capacity = 1000;
            if ($ctrl.selectedDynamicTime && $ctrl.selectedToTime) {
                if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                    angular.forEach($ctrl.availableDynamicTimes, function (ts) {

                        if (ts.startTime >= $ctrl.selectedDynamicTime && ts.endTime <= $ctrl.selectedToTime) {
                            if (capacity > ts.capacity)
                                capacity = ts.capacity;
                        }

                    })
                } else {
                    capacity = 0;
                }
            }

            $ctrl.availableQty = [0];
            $ctrl.maxAvailableQty = capacity;
            if (capacity > 0) {

                var i = 0;
                while (i < capacity) {
                    i++;
                    $ctrl.availableQty.push(i);
                }
            }

        }

        function updateAvailableToTime(then) {

            if ($ctrl.showUnPlannedTime) {
                if ($ctrl.selectedDynamicDate) {
                    var dateTime = new Date($ctrl.selectedDynamicDate.toString());
                    makeToTimeList(dateTime);
                    return;
                }
            }


            if ($ctrl.selectedDynamicTime == undefined || $ctrl.selectedDynamicTime == null) {
                $ctrl.selectedToTime = null;
                $ctrl.toTimePeriodList = [];
                return;
            }
            $ctrl.selectedToTime = null;

            $ctrl.toTimePeriodList = [];

            var list = $ctrl.allAvailableDynamicTimes.filter(function (v) {
                    return (v.startTime >= $ctrl.selectedDynamicTime)
                }
            );


            var keepGoing = true;
            angular.forEach(list, function (time) {

                if (keepGoing) {
                    if (time.capacity == 0) {
                        keepGoing = false;
                    }
                    if (keepGoing == true)
                        $ctrl.toTimePeriodList.push(time);
                }
            })
            if ($ctrl.toTimePeriodList.length > 0)
                $ctrl.selectedToTime = new Date($ctrl.toTimePeriodList[0].endTime).toISOString();
            if (then)
                then();
            availableDynamicToTime_changed();

        }

        function availableDynamicToTime_changed() {
            //  computeTimeUnitQty();
            updateTimeSessionData();
            setMaxAvailableCapacity();
            // getPriceInfoDtail();
            orderBagItem_Changed();

        }

        function createTimeSession(fromTime, toTime) {
            var newTimeSession = {};

            var fromDate = new Date(fromTime.toString());
            var toDate = new Date(toTime.toString());


            newTimeSession.startTime = fromTime;
            newTimeSession.endTime = toTime;
            newTimeSession.startDate = fromDate;
            newTimeSession.endDate = toDate;
            newTimeSession.capacity = $ctrl.dynamicCapacity;

            return newTimeSession;


        }

        function showPrices() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceTimeSession != undefined && $ctrl.orderBagServiceItem.serviceTimeSession.id != undefined)
                    return true;
            }
            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.floatingTimeType == 'HOURLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                        return true;
                }
                if ($ctrl.floatingTimeType == 'MONTHLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null)
                        return true;
                }
            }
        }

        function timeUnitQty_Changed() {

            computeTotalPrice();
            orderBagItem_Changed();
        }

        function setShowCountBox() {

            $ctrl.showCountBox = true;
            if ($ctrl.showUnPlannedTime)
                $ctrl.showCountBox = false;

            if ($ctrl.orderBagServiceItem == null)
                return;

            var selectedServiceItem = findSelectedServiceItem();


            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail != null && $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 1) {
                if (
                    ($ctrl.maxAvailableQty == 1
                        && (selectedServiceItem.servant == null || selectedServiceItem.servant == undefined
                            || (selectedServiceItem.servant != null
                                && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                                    || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))))
                    ||
                    ($ctrl.maxAvailableQty > 1
                        && selectedServiceItem.servant != null && selectedServiceItem.servant != undefined
                        && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                            || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))
                ) {
                    $ctrl.showCountBox = false;
                }
            }


        }

        function findSelectedServiceItem() {

            if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceItemId != undefined) {
                var temp = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })
                if (temp && temp.length > 0)
                    $ctrl.selectedService = temp[0];
            }

            var selectedServiceItem = null;

            if ($ctrl.orderBagServiceItem.serviceItemId != null) {
                selectedServiceItem = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })

            }
            return selectedServiceItem;
        }

        function makeDateList() {
            var date = new Date($ctrl.defaultStartDate);
            var dates = [];

            var timeSpan = makeTimeSpanObject(date);
            for (var i = 9; i > 0; i--) {
                var before = {};
                before = new Date(Number(date));
                ;
                before.setDate(date.getDate() - i);

                var beforeTimeSpan = makeTimeSpanObject(before);
                dates.push(beforeTimeSpan);
            }

            dates.push(timeSpan);

            for (var i = 1; i < 10; i++) {
                var after = {};
                after = new Date(Number(date));
                ;
                after.setDate(date.getDate() + i);

                var afterTimeSpan = makeTimeSpanObject(after);
                dates.push(afterTimeSpan);
            }


            $ctrl.availableDynamicDates = dates;
            $ctrl.selectedDynamicDate = timeSpan.spanDate;

            makeTimeList(date);

        }

        function makeTimeSpanObject(date, hour, minute) {
            var timeSpan = {};
            var startTime, endTime = new Date();
            startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
            if (hour != null)
                startTime.setHours(hour);
            if (minute != null)
                startTime.setMinutes(minute);

            timeSpan.spanDate = date.toISOString().split('T')[0];
            timeSpan.startTime = startTime.toISOString();
            timeSpan.endTime = startTime.toISOString();
            if ($ctrl.selectedService && $ctrl.selectedService.capacity)
                timeSpan.capacity = $ctrl.selectedService.capacity;
            else
                timeSpan.capacity = 1;
            timeSpan.comment = "";
            timeSpan.discount = 0;
            timeSpan.edited = false;
            timeSpan.enable = true;
            timeSpan.id = null;
            timeSpan.price = 0;
            timeSpan.reservedCapacity = null;
            timeSpan.servantId = null;
            timeSpan.serviceItemId = null;
            timeSpan.sessionInfoId = null;
            timeSpan.timeSessionType = null;
            timeSpan.timeUnitQty = 0;

            return timeSpan;
        }

        function makeTimeList(date) {

            var selectedFromTime = makeTimeSpanObject(date);
            var startTimes = getSelectableTimes(date, false);
            $ctrl.availableDynamicTimes = startTimes;
            $ctrl.selectedDynamicTime = selectedFromTime.startTime;
            availableDynamicFromTime_changed();

        }

        function makeToTimeList(date) {

            // if($ctrl.selectedServiceDuration)
            //     date = new Date(date.getTime() + $ctrl.selectedServiceDuration*60000);
            $ctrl.toTimePeriodList = [];
            var startTimes = getSelectableTimes(date, true);
            $ctrl.toTimePeriodList = startTimes;
            availableDynamicToTime_changed();
        }

        function getSelectableTimes(date, mustFilter) {
            var startMinute = 0;
            var startHour = 0;
            var stepper = 5;
            var selectableTimes = [];
            for (var h = startHour; h < 24; h++) {
                for (var m = startMinute; m < 60; m = m + stepper) {
                    var time = {};
                    time = makeTimeSpanObject(date, h, m);
                    if (mustFilter) {
                        if (!isInRange(time)) {
                            continue;
                        }

                    }
                    selectableTimes.push(time);
                }

            }
            return selectableTimes;

        }

        function isInRange(timeSpan) {

            var isInRange = true;
            if ($ctrl.selectedDynamicTime) {
                var min = new Date($ctrl.selectedDynamicTime);
                var temp = new Date(timeSpan.startTime);
                if (temp.getHours() > min.getHours()) {

                } else if (temp.getHours() == min.getHours()) {
                    if (temp.getMinutes() <= min.getMinutes()) {
                        isInRange = false;
                    }
                } else {

                    isInRange = false;
                }
            }
            return isInRange;

        }

        function setDefaultToTime() {

            if ($ctrl.selectedServiceDuration) {

                var x = $ctrl.selectedDynamicTime;
                var date = new Date($ctrl.selectedDynamicTime);
                date.setMinutes(date.getMinutes() + $ctrl.selectedServiceDuration);
                $ctrl.selectedToTime = date.toISOString();
                availableDynamicToTime_changed();
                // updateTimeSessionData();
                // getPriceInfoDtail();
            }
        }

        function loadMoreAvailableDates() {
            if (!$ctrl.isDatesLoading) {
                if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                    $ctrl.fromDateToLoad = new Date($ctrl.availableDynamicDates[$ctrl.availableDynamicDates.length - 1].spanDate);
                    $ctrl.fromDateToLoad = DateUtils.addDays($ctrl.fromDateToLoad, 1);
                    $ctrl.toDateToLoad = DateUtils.addDays($ctrl.toDateToLoad, 30);
                    updateAvailableDates();
                }

            }
        }


        function showUnPlannedTimeChange() {
            if ($ctrl.selectedService)
                serviceItem_changed($ctrl.selectedService);
        }

        // $scope.$watch('$ctrl.orderBagServiceItem',function(){
        //
        // });

        function orderBagItem_Changed() {
            if ($ctrl.orderBagServiceItem
                && $ctrl.orderBagServiceItem.serviceItemId
                && $ctrl.orderBagServiceItem.serviceTimeSession
                && $ctrl.orderBagServiceItem.serviceTimeSession.startTime
                && $ctrl.orderBagServiceItem.serviceTimeSession.endTime
            // && $ctrl.orderBagServiceItem.orderBagServiceItemDtail
            ) {
                if (!$ctrl.checkCapacityInProgress) {
                    $ctrl.checkCapacityInProgress = true;
                    getPriceInfoDtail(checkCapacity);
                }
            }
        }

        function checkCapacity() {

            OrderBagServiceItemCustom.checkCapacityForItem().save($ctrl.orderBagServiceItem, onSuccess, onError);

            function onSuccess(result) {
                if (result.status == 'CAPACITY_FULL')
                    $ctrl.isCapacityAvailable = false;
                else
                    $ctrl.isCapacityAvailable = true;

                $ctrl.checkCapacityInProgress = false;
            }

            function onError() {
                $ctrl.isCapacityAvailable = false;
                $ctrl.checkCapacityInProgress = false;
            }

        }

    }


    var ReserveServiceItemOptions = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/orderbag-service-item/partial-form.reserve-service-item-v2.html',
        controller: ReserveServiceItemV2Controller,
        bindings: {
            onItemChanged:"&",
            onServiceChanged:"&",
            orderBagServiceItem: '=',
            defaultServiceItemId: '=',
            defaultServiceTimeSessionId: '=',
            defaultStartDate: '=',
            defaultEndDate: '=',
            defaultServantId: '=',
            indexOfOrderbag: '=',
            // checkCapacity: '=',
            defaultSelectedService: '=',
            defaultSelectedServant: '=',
            editMode: '=',
            showUnPlannedTime: '=?',
            hasMultipleReserveTime: '=?',
            showOptionItems:'=?'


            //formState:'=',

        }


    };

    angular
        .module('tikonApp')
        .component('pfReserveServiceItemV2', ReserveServiceItemOptions)

    ReserveServiceItemV2Controller.$inject = ['$uibModal', '$scope', '$state', '$stateParams', '$timeout', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem', 'ServiceItemCustom', 'ServiceTimeSessionCustom', 'SettingInfoCustom', 'ServiceTimeSession', 'DateUtils', 'ScheduleInfoCustom', 'TimingInfo', 'OrderBagCustom', 'Servant', 'DateUtils', 'OrderBagServiceItemCustom','ServantCustom','Principal','ActivityTypeInfoCustom','CompanyCustom'];


})();

;
(function () {
    'use strict';

    function ReserveServiceItemController($uibModal, $scope, $state, $stateParams, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem, ServiceItemCustom, ServiceTimeSessionCustom, SettingInfoCustom, ServiceTimeSession, dateUtil, ScheduleInfoCustom, TimingInfo, OrderBagCustom, Servant, DateUtils) {
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.formState = 'orderbagitem';
        // $ctrl.initMode ='DEFAULT';
        $ctrl.options = null;
        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
        $ctrl.priceInfoDtails = null;
        $ctrl.addOrderBagDtails = addOrderBagDtails;
        $ctrl.computeTotalPrice = computeTotalPrice;
        $ctrl.isSaving = false;
        $ctrl.saveDtail = saveDtail;
        //$ctrl.findFormState = findFormState;
        $ctrl.prev = prev;

        $ctrl.FinalApprove = FinalApprove;
        $ctrl.serviceItem_changed = serviceItem_changed;
        $ctrl.openPersonInfoModal = openPersonInfoModal;
        $ctrl.serviceItems = null;
        $ctrl.qtyChanged = qtyChanged;
        $ctrl.availableDates_changed = availableDates_changed;
        $ctrl.availableTimes_changed = availableTimes_changed;
        $ctrl.servant_changed = servant_changed;
        $ctrl.availableDynamicDates_changed = availableDynamicDates_changed;
        $ctrl.availableDynamicFromTime_changed = availableDynamicFromTime_changed;
        $ctrl.availableDynamicToTime_changed = availableDynamicToTime_changed;

        $ctrl.updateAvailableDates = updateAvailableDates;
        $ctrl.updateAvailableFromTime = updateAvailableFromTime;
        $ctrl.updateAvailableToTime = updateAvailableToTime;
        $ctrl.updateServantList = updateServantList;
        $ctrl.updateServiceList = updateServiceList;

        $ctrl.servantList = [];
        $ctrl.selectedServiceTimeSession = {};
        $ctrl.selectedDynamicDate = null;
        $ctrl.selectedDynamicTime = null;
        $ctrl.allAvailableDynamicTimes = null;
        $ctrl.selectedServant = null;
        $ctrl.timeUnitQty = 1;
        $ctrl.selectedToTime = null;
        $ctrl.showPrices = showPrices;
        if (!$ctrl.editMode)
            $ctrl.editMode = 'NONE'; // 'REPLACE_TIME' , 'EDIT_ORDER_BAG_ITEM'

        // console.log('hasMultipleReserveTime: ' + $ctrl.hasMultipleReserveTime);


        $ctrl.scheduleType = 'PRIMARY';
        $ctrl.floatingTimeType = null;
        $ctrl.availableQty = [];
        $ctrl.maxAvailableQty = 0;
        $ctrl.showCountBox = true;
        $ctrl.selectedService = null;
        $ctrl.selectedServiceDuration = null;


        $ctrl.availableTimeUnitQty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        $ctrl.timeUnitQty_Changed = timeUnitQty_Changed;


        $ctrl.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();
        //test


        loadPage();


        //--------------------
        $ctrl.simulateQuery = false;
        $ctrl.isDisabled = false;

        $ctrl.servicesNames = [];

        $ctrl.querySearch = querySearch;


        //--------------------
        $ctrl.fromDateToLoad = new Date();
        $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
        $ctrl.isDatesLoading = false;
        $ctrl.loadMoreAvailableDates = loadMoreAvailableDates;

//-------------------------------


        function querySearch(query) {
            var temp = [];


            angular.forEach($ctrl.serviceItems, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.serviceItems;
                }
            })

            return temp;

        }


        function loadAllServiceItems() {

            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                $ctrl.serviceItems = items;
            });
        }

        function loadServiceItemsByServantId() {

            if ($ctrl.defaultServantId) {
                ServiceItemCustom.getServiceItemsByServantId($ctrl.defaultServantId).query(function (items) {
                    $ctrl.serviceItems = items;
                });
            }
        }


//-------------------------------


        function setServant(servantid) {
            $ctrl.orderBagServiceItem.servant = null;
            if (servantid) {
                $ctrl.orderBagServiceItem.servant = {id: servantid}
            }
        }

        function getServantId() {

            if ($ctrl.orderBagServiceItem.servant)
                return $ctrl.orderBagServiceItem.servant.id;
            if ($ctrl.selectedServant)
                return $ctrl.selectedServant.id;

            return null;
        }


        function updateServantList(then) {
            //for now if 'REPLACE_TIME' return
            if ($ctrl.editMode == 'REPLACE_TIME')
                return;

            resetLoadDatesDefault();

            if ($ctrl.initMode == 'CALENDAR_CUSTOM' && $ctrl.defaultServantId) {
                updateServantListWithDefault();
                return;
            }


            setServant();
            $ctrl.servantList = [];
            if ($ctrl.orderBagServiceItem.serviceItemId) {
                ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                        $ctrl.servantList = servants;

                        if (servants && servants.length > 1) {
                            ServiceItemCustom.getAutoSelectServant($ctrl.orderBagServiceItem.serviceItemId).query(function (selecedServant) {

                                    if (selecedServant && selecedServant.id) {
                                        angular.forEach(servants, function (s) {
                                            if (s.id == selecedServant.id)
                                                setServant(selecedServant.id);
                                        });
                                    } else {
                                        if (servants[0])
                                            setServant(servants[0].id);

                                        if (then)
                                            then();
                                    }
                                    if (then)
                                        then();

                                    $ctrl.updateAvailableDates(then);
                                },
                                function () {
                                    if (servants[0])
                                        setServant(servants[0].id);

                                    if (then)
                                        then();
                                    $ctrl.updateAvailableDates(then);
                                })

                        } else {
                            if (servants[0])
                                setServant(servants[0].id);

                            if (then)
                                then();
                            $ctrl.updateAvailableDates(then);
                        }
                    }
                    , function () {
                        if (then)
                            then();
                        $ctrl.updateAvailableDates(then);

                    });

            }
        }

        function updateServantListWithDefault() {
            $ctrl.servantList = [];
            if ($ctrl.orderBagServiceItem.serviceItemId) {
                ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                    $ctrl.servantList = servants;
                    setServant($ctrl.defaultServantId);
                });
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('orderBagServiceItemDtail');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader.addPart('orderBagItemOption');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('participantPerson');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            initServiceItem();
            updateServiceList(setDefaultValues);

            if ($ctrl.initMode == 'DEFAULT')
                loadAllServiceItems();
            else if ($ctrl.initMode == 'CALENDAR_CUSTOM') {
                $ctrl.checkCapacity = false;
                loadServiceItemsByServantId();
                if ($ctrl.defaultServantId) {
                    $ctrl.servantList = [];
                    Servant.get({id: $ctrl.defaultServantId}).$promise.then(function (result) {
                        $ctrl.servantList.push(result);
                        setServant($ctrl.defaultServantId);
                    });

                }

                if ($ctrl.defaultStartDate)
                    makeDateList();
            }

        }

        function updateServiceList(then) {

            $ctrl.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(onSuccess);

            function onSuccess() {
                if (then) {
                    then();
                }
                $ctrl.updateServantList(then);

            }
        }

        function setDefaultValues() {

            initDefaultSelectedItems();
            setDefaultServiceItem();
            setDefaultDateAndTime();
            setDefaultServant();
        }

        function initDefaultSelectedItems() {

            if ($ctrl.defaultSelectedService != null) {
                $ctrl.selectedService = $ctrl.defaultSelectedService;
                $ctrl.serviceItem_changed($ctrl.selectedService)
            }
            if ($ctrl.defaultSelectedServant != null) {
                $ctrl.selectedServant = $ctrl.defaultSelectedServant;
                $ctrl.servant_changed();
            }

        }

        function initServiceItem() {
            if ($ctrl.editMode == 'REPLACE_TIME')
                return;


            if (!$ctrl.orderBagServiceItem)
                $ctrl.orderBagServiceItem = {};
            $ctrl.orderBagServiceItem.servant = {};
            if (!$ctrl.orderBagServiceItem.index)
                $ctrl.orderBagServiceItem.index = 0;
        }

        function setDefaultServiceItem() {

            if ($ctrl.defaultServiceItemId != null && $ctrl.defaultServiceItemId != undefined) {
                $ctrl.orderBagServiceItem.serviceItemId = Number($ctrl.defaultServiceItemId);
                //$ctrl.serviceItem_changed();
                //setDefaultTimeSession();
                //setDefaultDateAndTime();
                //setDefaultServant();
                // loadAvailableDates();
            }
        }

        function setDefaultServant() {
            if ($ctrl.defaultServantId)
                setServant($ctrl.defaultServantId);

        }


        function setDefaultDateAndTime() {

            if ($ctrl.defaultStartDate != null && $ctrl.defaultStartDate != undefined &&
                $ctrl.defaultEndDate != null && $ctrl.defaultEndDate != "" && $ctrl.defaultEndDate != undefined) {
                $ctrl.selectedDynamicTime = new Date($ctrl.defaultStartDate).toISOString();
                $ctrl.selectedToTime = new Date($ctrl.defaultEndDate).toISOString();
                $ctrl.selectedDynamicDate = dateUtil.convertToISOString(new Date($ctrl.defaultStartDate));
                /*     updateAvailableDates(function(){
                 $ctrl.updateAvailableFromTime(function(){
                 $ctrl.selectedDynamicTime=new Date($ctrl.defaultStartDate).toISOString();
                 $ctrl.availableDynamicFromTime_changed();
                 $ctrl.selectedToTime=new Date($ctrl.defaultEndDate).toISOString();
                 $ctrl.availableDynamicToTime_changed();

                 });


                 });*/


                //loadAvailableTimes(function () {
                //
                //    availableTimes_changed();
                //});
            }
        }

        function getPriceInfoDtail() {

            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null) {
                // error
                // have to evaluate
                return;
            }
            if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                //do nothing
                // in view mode and not editable
            } else {
                var servantId = null
                if ($ctrl.orderBagServiceItem.servant && $ctrl.orderBagServiceItem.servant.id)
                    servantId = $ctrl.orderBagServiceItem.servant.id;
                PriceInfoDtailCustom.getPriceInfoDtailByServiceItemFromDate($ctrl.orderBagServiceItem.serviceItemId, servantId, $ctrl.orderBagServiceItem.serviceTimeSession.startTime).query(function (result) {

                    $ctrl.priceInfoDtails = result;
                    addOrderBagDtails();
                    // $ctrl.serviceItem_changed();
                    //reloadPrices();
                    changeControlsData()
                });

            }


        }

        function saveDtail() {
            $ctrl.isSaving = true;
            if ($ctrl.orderBagServiceItem.id !== null && $ctrl.orderBagServiceItem.id != undefined) {
                OrderBagServiceItem.update($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                $ctrl.orderBagServiceItem.id = null;
                OrderBagServiceItem.save($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {


            $ctrl.isSaving = false;
            $ctrl.orderBagServiceItem = result;
            //reloadPrices();
            //findFormState();
            //  initParticipant();
            //$ctrl.formState ='participant';
        }

        function onSaveError() {
            $ctrl.isSaving = false;
        }

        function reloadPrices() {

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
                || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            ) {
                return;
            }

            angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
                angular.forEach($ctrl.priceInfoDtails, function (p) {
                    if (v.priceInfoDtail.id == p.id) {
                        p.gty = v.gty;
                        if (v.options != null && v.options != undefined) {
                            p.options = [];
                            p.options = v.options;
                        }
                    }

                });

            });

        }

        function addOrderBagDtails() {

            clearOrderBagDetails();

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
            }

            var x;
            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {

                x = $ctrl.priceInfoDtails[i];
                if (x == null)
                    continue;

                //if priceInfoDetailID set in ReserveServiceItemDtail must Update Quantity
                //if (UpdateExistReserveServiceItemDtail(x, orderbagOptions))
                if (false) {
                    //do nothing
                } else {
                    var defaultQty = 0;
                    if (i == 0) defaultQty = 1;
                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
                        gty: defaultQty,
                        price: x.price,
                        discount: x.discount,
                        vat: 0,
                        totalPrice: 0,
                        serviceTimeSession: $ctrl.orderBagServiceItem.serviceTimeSession,
                        //priceInfoDtailId: x.id,
                        priceInfoDtail: x,
                        orderBagItemOptions: null,
                        timeUnitQty: $ctrl.timeUnitQty
                    });
                }
            }

            //   computeTotalPrice();
            setShowCountBox();
        }

        function computeTotalPrice() {
            if ($ctrl.onItemChanged)
                $ctrl.onItemChanged($ctrl.orderBagServiceItem);
            // var orderBag = {};
            // orderBag.orderBagServiceItems = [];
            // orderBag.orderBagServiceItems.push($ctrl.orderBagServiceItem);
            // OrderBagCustom.computeFinalPrice().save(orderBag, function (result) {
            //
            //     if (result.orderBagServiceItems[0])
            //         $ctrl.orderBagServiceItem = result.orderBagServiceItems[0];
            // })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function calculateOptionPrice(qty) {

            var sumOfOptionPrice = 0;
            var row;
            if ($ctrl.orderBagServiceItem.options)
                for (var i = 0, len = $ctrl.orderBagServiceItem.options.length; i < len; i++) {

                    row = $ctrl.orderBagServiceItem.options[i];
                    if (row.selected) {
                        sumOfOptionPrice += row.priceInfoDtail.price * qty;
                    }
                }

            return sumOfOptionPrice;
        }


        function UpdateExistReserveServiceItemDtail(priceInfoDtail, options) {
            //
            //var hasChanged = false;
            //if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
            //    || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            //) {
            //    hasChanged = false;
            //}
            //
            //
            //angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
            //    if (v.priceInfoDtail.id == priceInfoDtail.id) {
            //        v.gty = priceInfoDtail.gty;
            //        v.orderBagItemOptions = options;
            //        hasChanged = true;
            //    }
            //
            //});
            //
            //
            //return hasChanged;
        }

        function prev() {
            $ctrl.formState = 'orderbagitem';
            //  reloadPrices();
        }


        function FinalApprove() {
            //saveDtail();
        }

        function serviceItem_changed(item) {

            $ctrl.selectedDate = null;
            $ctrl.selectedServiceTimeSession = {};


            if (item) {
                $ctrl.orderBagServiceItem.serviceItemId = item.id;
                if (item.duration)
                    $ctrl.selectedServiceDuration = item.duration;

                updateServantList();
            } else {
                $ctrl.orderBagServiceItem.serviceItemId = null;
                $ctrl.servantList = [];
            }


            $ctrl.onServiceChanged();

            if ($ctrl.initMode == 'CALENDAR_CUSTOM') {
                setDefaultToTime();
                availableDynamicToTime_changed();
            }
        }


        function openPersonInfoModal() {
            $uibModal.open({
                templateUrl: 'app/entities/participant-person/order-bag-item-participant-person-dialog.html',
                controller: 'OrderBagParticipantPersonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function (result) {
                addParticipantPerson(result);
            }, function () {
                //nothing
            });


        }


        function clearOrderBagDetails() {
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = null;
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
        }

        function changeControlsData() {
            computeTotalPrice();

        }

        function qtyChanged() {

            changeControlsData();
        }

        function loadAvailableDates() {

            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            $ctrl.orderBagServiceItem.serviceTimeSession = null;
            $ctrl.availableDates = [];
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow($ctrl.orderBagServiceItem.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = $ctrl.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            $ctrl.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });


        }

        function servant_changed() {

            resetLoadDatesDefault();
            updateAvailableDates();

        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function resetLoadDatesDefault() {
            $ctrl.availableDynamicDates = [];
            $ctrl.fromDateToLoad = new Date();
            $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
            $ctrl.loadedMore = false;
        }

        function loadAvailableTimes(then) {

            if ($ctrl.selectedDate == undefined || $ctrl.selectedDate == null)
                return;

            $ctrl.orderBagServiceItem.serviceTimeSession = null;

            var dateTime = new Date($ctrl.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query(function (list) {
                $ctrl.availableTimes = list;
                if (then)
                    then();

            });

        }

        function availableTimes_changed() {
            //getPriceInfoDtail();
            //changeControlsData();
        }

        function uniqBy(a, key) {
            var seen = {};
            return a.filter(function (item) {
                var k = key(item);
                return seen.hasOwnProperty(k) ? false : (seen[k] = true);
            })
        }


        function updateAvailableDates(then) {

            if ($ctrl.isDatesLoading)
                return;

            $ctrl.isDatesLoading = true;
            ScheduleInfoCustom.getDynamicAvailableDatesByServiceIdAndServantId($ctrl.orderBagServiceItem.serviceItemId, getServantId(), $ctrl.fromDateToLoad, $ctrl.toDateToLoad).query(function (list) {
                var filteredList = [];
                var filteredDate = [];
                list.forEach(function (item) {
                    if (filteredDate.indexOf(item.spanDate) < 0) {
                        filteredList.push(item);
                        filteredDate.push(item.spanDate);
                    }
                });

                filteredList = filteredList.sort(function (a, b) {
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(a.spanDate) - new Date(b.spanDate);
                });

                if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                    // add new dates to old list
                    filteredList.forEach(function (item) {
                        $ctrl.availableDynamicDates.push(item);
                    });

                } else {

                    $ctrl.availableDynamicDates = filteredList;
                    if (filteredList[0]) {
                        $ctrl.selectedDynamicDate = filteredList[0].spanDate;
                        setDefaultDateAndTime();
                    }
                }
                if (then)
                    then();
                $ctrl.updateAvailableFromTime(then);
                $ctrl.isDatesLoading = false;

                // in some cases dates not loaded completely
                // if(!$ctrl.loadedMore && $ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length >=0 && $ctrl.availableDynamicDates.length <6)
                // {
                //     if(!$ctrl.isDatesLoading)
                //     {
                //         $ctrl.loadedMore = true ;
                //         $ctrl.fromDaysToLoad +=30 ;
                //         $ctrl.toDaysToLoad +=180 ;
                //         updateAvailableDates();
                //     }
                //
                // }
            });


        }

        function updateAvailableFromTime(then) {


            $ctrl.selectedDynamicTime = null;
            $ctrl.selectedToTime = null;
            if (!$ctrl.selectedDynamicDate) {
                $ctrl.availableDynamicTimes = [];
                $ctrl.selectedDynamicTime = null;
                $ctrl.updateAvailableToTime(then);
                return;
            }
            var dateTime = new Date($ctrl.selectedDynamicDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ScheduleInfoCustom.getDynamicAvailableTimesByServiceIdAndServantIdInOneDate($ctrl.orderBagServiceItem.serviceItemId, getServantId(), dateTime.toISOString()).query().$promise.then(function (result) {

                $ctrl.allAvailableDynamicTimes = result;
                $ctrl.availableDynamicTimes = result.filter(function (v) {
                        return (v.capacity > 0)
                    }
                );

                $ctrl.availableDynamicTimes = $ctrl.availableDynamicTimes.sort(function (a, b) {
                    return new Date(a.startTime) - new Date(b.startTime);
                });

                if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                    $ctrl.selectedDynamicTime = $ctrl.availableDynamicTimes[0].startTime;
                    if (then)
                        then();
                    $ctrl.updateAvailableToTime(then);
                }
            });

        }

        function availableDynamicDates_changed() {

            updateAvailableFromTime();
        }

        function availableDynamicFromTime_changed() {


            updateAvailableToTime();
            setDefaultToTime();
        }

        function setMaxAvailableCapacity() {
            var capacity = 1000;
            if ($ctrl.selectedDynamicTime && $ctrl.selectedToTime) {
                if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                    angular.forEach($ctrl.availableDynamicTimes, function (ts) {

                        if (ts.startTime >= $ctrl.selectedDynamicTime && ts.endTime <= $ctrl.selectedToTime) {
                            if (capacity > ts.capacity)
                                capacity = ts.capacity;
                        }

                    })
                } else {
                    capacity = 0;
                }
            }

            $ctrl.availableQty = [0];
            $ctrl.maxAvailableQty = capacity;
            if (capacity > 0) {

                var i = 0;
                while (i < capacity) {
                    i++;
                    $ctrl.availableQty.push(i);
                }
            }

        }

        function updateAvailableToTime(then) {

            if ($ctrl.initMode == 'CALENDAR_CUSTOM') {

                if ($ctrl.selectedDynamicDate) {
                    var dateTime = new Date($ctrl.selectedDynamicDate.toString());
                    makeToTimeList(dateTime);
                    return;
                }
            }


            if ($ctrl.selectedDynamicTime == undefined || $ctrl.selectedDynamicTime == null) {
                $ctrl.selectedToTime = null;
                $ctrl.toTimePeriodList = [];
                return;
            }
            $ctrl.selectedToTime = null;

            $ctrl.toTimePeriodList = [];

            var list = $ctrl.allAvailableDynamicTimes.filter(function (v) {
                    return (v.startTime >= $ctrl.selectedDynamicTime)
                }
            );


            var keepGoing = true;
            angular.forEach(list, function (time) {

                if (keepGoing) {
                    if (time.capacity == 0) {
                        keepGoing = false;
                    }
                    if (keepGoing == true)
                        $ctrl.toTimePeriodList.push(time);
                }
            })
            if ($ctrl.toTimePeriodList.length > 0)
                $ctrl.selectedToTime = new Date($ctrl.toTimePeriodList[0].endTime).toISOString();
            if (then)
                then();
            availableDynamicToTime_changed();

        }

        function availableDynamicToTime_changed() {
            //  computeTimeUnitQty();
            if ($ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                $ctrl.orderBagServiceItem.serviceTimeSession = createTimeSession($ctrl.selectedDynamicTime, $ctrl.selectedToTime);
            setMaxAvailableCapacity();
            getPriceInfoDtail();

        }

        function computeTimeUnitQty() {

            var span = {
                startTime: $ctrl.selectedDynamicTime,
                endTime: $ctrl.selectedToTime,
                serviceItemId: $ctrl.orderBagServiceItem.serviceItemId
            }
            TimingInfo.computeTimeUnitQty().save(span, function (result) {
                $ctrl.timeUnitQty = result.timeUnitQty;
            })

            //;
            //if ($ctrl.toTimePeriodList == undefined || $ctrl.toTimePeriodList == null || $ctrl.toTimePeriodList.length == 0) {
            //    $ctrl.timeUnitQty = 1;
            //    return;
            //}
            //if ($ctrl.selectedToTime == undefined || $ctrl.selectedToTime == null) {
            //    $ctrl.timeUnitQty = 0;
            //    return;
            //}
            //
            //
            //var keepGoing = true;
            //var timeUnitCount = 0;
            //var capacity = 100;
            //angular.forEach($ctrl.toTimePeriodList, function (toTime) {
            //    ;
            //    if (keepGoing) {
            //
            //            if(toTime.capacity!=null && toTime.capacity < capacity)
            //                capacity = toTime.capacity;
            //            if (toTime.endTime == $ctrl.selectedToTime) {
            //                keepGoing = false;
            //            }
            //
            //            timeUnitCount++;
            //
            //        }
            //    }
            //);
            //
            //if (timeUnitCount > 0)
            //    $ctrl.timeUnitQty = timeUnitCount;
            //
            //$ctrl.dynamicCapacity = capacity;

        }

        function createTimeSession(fromTime, toTime) {
            var newTimeSession = {};

            var fromDate = new Date(fromTime.toString());
            var toDate = new Date(toTime.toString());


            newTimeSession.startTime = fromTime;
            newTimeSession.endTime = toTime;
            newTimeSession.startDate = fromDate;
            newTimeSession.endDate = toDate;
            newTimeSession.capacity = $ctrl.dynamicCapacity;

            return newTimeSession;


        }

        function showPrices() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceTimeSession != undefined && $ctrl.orderBagServiceItem.serviceTimeSession.id != undefined)
                    return true;
            }
            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.floatingTimeType == 'HOURLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                        return true;
                }
                if ($ctrl.floatingTimeType == 'MONTHLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null)
                        return true;
                }
            }
        }


        function timeUnitQty_Changed() {

            computeTotalPrice();
        }

        function setShowCountBox() {

            $ctrl.showCountBox = true;
            if ($ctrl.orderBagServiceItem == null)
                return;

            var selectedServiceItem = findSelectedServiceItem();


            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail != null && $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 1) {
                if (
                    ($ctrl.maxAvailableQty == 1
                        && (selectedServiceItem.servant == null || selectedServiceItem.servant == undefined
                            || (selectedServiceItem.servant != null
                                && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                                    || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))))
                    ||
                    ($ctrl.maxAvailableQty > 1
                        && selectedServiceItem.servant != null && selectedServiceItem.servant != undefined
                        && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                            || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))
                ) {
                    $ctrl.showCountBox = false;
                }
            }


        }

        function findSelectedServiceItem() {

            if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceItemId != undefined) {
                var temp = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })
                $ctrl.selectedService = temp[0];
            }

            var selectedServiceItem = null;

            if ($ctrl.orderBagServiceItem.serviceItemId != null) {
                selectedServiceItem = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })

            }
            return selectedServiceItem;
        }

        function makeDateList() {
            var date = new Date($ctrl.defaultStartDate);
            var dates = [];

            var timeSpan = makeTimeSpanObject(date);
            for (var i = 9; i > 0; i--) {
                var before = {};
                before = new Date(Number(date));
                ;
                before.setDate(date.getDate() - i);

                var beforeTimeSpan = makeTimeSpanObject(before);
                dates.push(beforeTimeSpan);
            }

            dates.push(timeSpan);

            for (var i = 1; i < 10; i++) {
                var after = {};
                after = new Date(Number(date));
                ;
                after.setDate(date.getDate() + i);

                var afterTimeSpan = makeTimeSpanObject(after);
                dates.push(afterTimeSpan);
            }


            $ctrl.availableDynamicDates = dates;
            $ctrl.selectedDynamicDate = timeSpan.spanDate;

            makeTimeList(date);

        }

        function makeTimeSpanObject(date, hour, minute) {
            var timeSpan = {};
            var startTime, endTime = new Date();
            startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
            if (hour != null)
                startTime.setHours(hour);
            if (minute != null)
                startTime.setMinutes(minute);

            timeSpan.spanDate = date.toISOString().split('T')[0];
            timeSpan.startTime = startTime.toISOString();
            timeSpan.endTime = startTime.toISOString();
            if ($ctrl.selectedService && $ctrl.selectedService.capacity)
                timeSpan.capacity = $ctrl.selectedService.capacity;
            else
                timeSpan.capacity = 1;
            timeSpan.comment = "";
            timeSpan.discount = 0;
            timeSpan.edited = false;
            timeSpan.enable = true;
            timeSpan.id = null;
            timeSpan.price = 0;
            timeSpan.reservedCapacity = null;
            timeSpan.servantId = null;
            timeSpan.serviceItemId = null;
            timeSpan.sessionInfoId = null;
            timeSpan.timeSessionType = null;
            timeSpan.timeUnitQty = 0;

            return timeSpan;
        }

        function makeTimeList(date) {

            var selectedFromTime = makeTimeSpanObject(date);
            var startTimes = getSelectableTimes(date, false);
            $ctrl.availableDynamicTimes = startTimes;
            $ctrl.selectedDynamicTime = selectedFromTime.startTime;
            availableDynamicFromTime_changed();

        }

        function makeToTimeList(date) {

            // if($ctrl.selectedServiceDuration)
            //     date = new Date(date.getTime() + $ctrl.selectedServiceDuration*60000);
            $ctrl.toTimePeriodList = [];
            var startTimes = getSelectableTimes(date, true);
            $ctrl.toTimePeriodList = startTimes;
            availableDynamicToTime_changed();
        }

        function getSelectableTimes(date, mustFilter) {
            var startMinute = 0;
            var startHour = 0;
            var stepper = 5;
            var selectableTimes = [];
            for (var h = startHour; h < 24; h++) {
                for (var m = startMinute; m < 60; m = m + stepper) {
                    var time = {};
                    time = makeTimeSpanObject(date, h, m);
                    if (mustFilter) {
                        if (!isInRange(time)) {
                            continue;
                        }

                    }
                    selectableTimes.push(time);
                }

            }
            return selectableTimes;

        }

        function isInRange(timeSpan) {

            var isInRange = true;
            if ($ctrl.selectedDynamicTime) {
                var min = new Date($ctrl.selectedDynamicTime);
                var temp = new Date(timeSpan.startTime);
                if (temp.getHours() > min.getHours()) {

                } else if (temp.getHours() == min.getHours()) {
                    if (temp.getMinutes() <= min.getMinutes()) {
                        isInRange = false;
                    }
                } else {

                    isInRange = false;
                }
            }
            return isInRange;

        }

        function setDefaultToTime() {

            if ($ctrl.selectedServiceDuration) {

                var x = $ctrl.selectedDynamicTime;
                var date = new Date($ctrl.selectedDynamicTime);
                date.setMinutes(date.getMinutes() + $ctrl.selectedServiceDuration);
                $ctrl.selectedToTime = date.toISOString();
            }
        }

        function loadMoreAvailableDates() {
            if (!$ctrl.isDatesLoading) {
                if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                    $ctrl.fromDateToLoad = new Date($ctrl.availableDynamicDates[$ctrl.availableDynamicDates.length - 1].spanDate);
                    $ctrl.fromDateToLoad = DateUtils.addDays($ctrl.fromDateToLoad, 1);
                    $ctrl.toDateToLoad = DateUtils.addDays($ctrl.toDateToLoad, 30);
                    updateAvailableDates();
                }

            }
        }

        // $scope.$watch('$ctrl.availableDynamicDates',function(){
        //     if($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0 && $ctrl.availableDynamicDates.length < 6)
        //     {
        //
        //         loadMoreAvailableDates();
        //     }
        // });


    }


    var ReserveServiceItem = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/orderbag-service-item/partial-form.reserve-service-item.html',
        controller: ReserveServiceItemController,
        bindings: {
            //serviceItemId: '<',
            //selectedServiceTimeSession: '=',
            orderBagServiceItem: '=',
            defaultServiceItemId: '=',
            defaultServiceTimeSessionId: '=',
            defaultStartDate: '=',
            defaultEndDate: '=',
            defaultServantId: '=',
            hasMultipleReserveTime: '=',
            indexOfOrderbag: '=',
            initMode: '=',
            onItemChanged: '&',
            onServiceChanged: '&',
            checkCapacity: '=',
            defaultSelectedService: '=',
            defaultSelectedServant: '=',
            editMode: '='


            //formState:'=',

        }


    };

    angular
        .module('tikonApp')
        .component('pfReserveServiceItem', ReserveServiceItem)

    ReserveServiceItemController.$inject = ['$uibModal', '$scope', '$state', '$stateParams', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem', 'ServiceItemCustom', 'ServiceTimeSessionCustom', 'SettingInfoCustom', 'ServiceTimeSession', 'DateUtils', 'ScheduleInfoCustom', 'TimingInfo', 'OrderBagCustom', 'Servant', 'DateUtils'];


})();

;
(function () {
    'use strict';

    function OrderBagServiceItemController($uibModal, $scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem, ServiceItemCustom, ServiceTimeSessionCustom, SettingInfoCustom, ServiceTimeSession, dateUtil, ScheduleInfoCustom, TimingInfo, OrderBagCustom) {
        ;
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.formState = 'orderbagitem';
        $ctrl.options = null;
        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
        $ctrl.priceInfoDtails = null;
        $ctrl.addOrderBagDtails = addOrderBagDtails;
        $ctrl.computeTotalPrice = computeTotalPrice;
        $ctrl.isSaving = false;
        $ctrl.saveDtail = saveDtail;
        //$ctrl.findFormState = findFormState;
        $ctrl.prev = prev;
        $ctrl.initParticipant = initParticipant;
        $ctrl.FinalApprove = FinalApprove;
        $ctrl.serviceItem_changed = serviceItem_changed;
        $ctrl.openPersonInfoModal = openPersonInfoModal;
        $ctrl.serviceItems = null;
        $ctrl.removeParticipantPerson = removeParticipantPerson;
        $ctrl.qtyChanged = qtyChanged;
        $ctrl.availableDates_changed = availableDates_changed;
        $ctrl.availableTimes_changed = availableTimes_changed;
        $ctrl.selectedServiceTimeSession = {};
        $ctrl.servant_changed = servant_changed;
        $ctrl.getAvailableDynamicDates = getAvailableDynamicDates;
        $ctrl.getAvailableDynamicTimes = getAvailableDynamicTimes;
        $ctrl.selectedDynamicDate = null;
        $ctrl.selectedDynamicTime = null;
        $ctrl.availableDynamicDates_changed = availableDynamicDates_changed;
        $ctrl.availableDynamicTimes_changed = availableDynamicTimes_changed;
        $ctrl.allAvailableDynamicTimes = null;
        $ctrl.ToTime_changed = ToTime_changed;
        $ctrl.timeUnitQty = 1;
        $ctrl.selectedToTime = null;
        $ctrl.showPrices = showPrices;
        $ctrl.scheduleType = 'PRIMARY';
        $ctrl.floatingTimeType = null;
        $ctrl.showFloatingHourlyTime = showFloatingHourlyTime;
        $ctrl.availableDynamicMonthlyDates_changed = availableDynamicMonthlyDates_changed;
        $ctrl.selectedDynamicMonthlyDate = null;
        $ctrl.getAvailableDynamicMonthlyDates = getAvailableDynamicMonthlyDates;

        $ctrl.availableTimeUnitQty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        $ctrl.timeUnitQty_Changed = timeUnitQty_Changed;


        $ctrl.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();
        //test


        loadAll();

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('orderBagServiceItemDtail');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader.addPart('orderBagItemOption');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('participantPerson');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();


            $ctrl.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(onSuccess);

            function onSuccess() {

                setDefualtValues();


            }


            getPriceInfoDtail();

        }

        function setDefualtValues() {
            if ($ctrl.initMode == 'fromURL') {
                setDefualtServiceItem();

            }


        }

        function setDefualtServiceItem() {
            if ($ctrl.defaultServiceItemId != null && $ctrl.defaultServiceItemId != undefined) {
                $ctrl.orderBagServiceItem.serviceItemId = Number($ctrl.defaultServiceItemId);
                $ctrl.serviceItem_changed();
                setDefualtTimeSession();
                setDefualtDateAndTime();
                // loadAvailableDates();
            }
        }

        function setDefualtTimeSession() {
            if ($ctrl.defaultServiceTimeSessionId != null && $ctrl.defaultServiceTimeSessionId != undefined) {
                ;
                ServiceTimeSession.get({id: $ctrl.defaultServiceTimeSessionId}).$promise.then(function (serviceTimeSession) {
                    $ctrl.selectedDate = dateUtil.convertToISOString(serviceTimeSession.startDate);
                    //$ctrl.selectedDate = serviceTimeSession.startDate.toISOString().split('T')[0];
                    loadAvailableTimes(function () {
                        $ctrl.orderBagServiceItem.serviceTimeSession = {};
                        $ctrl.orderBagServiceItem.serviceTimeSession.id = Number($ctrl.defaultServiceTimeSessionId);
                        availableTimes_changed();
                    });

                });
            }
        }

        function setDefualtDateAndTime() {
            if ($ctrl.defaultStartDate != null && $ctrl.defaultStartDate != undefined &&
                $ctrl.defaultEndDate != null && $ctrl.defaultEndDate != undefined) {


                $ctrl.selectedDynamicDate = dateUtil.convertToISOString(new Date($ctrl.defaultStartDate));
                getAvailableDynamicDates(function () {
                    $ctrl.getAvailableDynamicTimes(function () {
                        $ctrl.selectedDynamicTime = new Date($ctrl.defaultStartDate).toISOString();
                        $ctrl.availableDynamicTimes_changed();
                        $ctrl.selectedToTime = new Date($ctrl.defaultEndDate).toISOString();
                        $ctrl.ToTime_changed();

                    });


                });


                //loadAvailableTimes(function () {
                //
                //    availableTimes_changed();
                //});
            }
        }

        function getPriceInfoDtail() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null || $ctrl.orderBagServiceItem.serviceTimeSession.id == null) {
                    // error
                    // have to evaluate
                    return;
                }
                if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                    //do nothing
                    // in view mode and not editable
                } else {

                    PriceInfoDtailCustom.PriceInfoDtailByServiceTimeSession($ctrl.orderBagServiceItem.serviceItemId, $ctrl.orderBagServiceItem.serviceTimeSession.id).query(function (result) {

                        $ctrl.priceInfoDtails = result;
                        addOrderBagDtails();
                        //reloadPrices();
                    });

                }
            } else {
                if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null) {
                    // error
                    // have to evaluate
                    return;
                }
                if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                    //do nothing
                    // in view mode and not editable
                } else {

                    PriceInfoDtailCustom.getPriceInfoDtailByServiceItemFromDate($ctrl.orderBagServiceItem.serviceItemId, $ctrl.orderBagServiceItem.serviceTimeSession.startTime).query(function (result) {

                        $ctrl.priceInfoDtails = result;
                        addOrderBagDtails();
                        //reloadPrices();
                    });

                }

            }
        }

        function saveDtail() {
            $ctrl.isSaving = true;
            if ($ctrl.orderBagServiceItem.id !== null && $ctrl.orderBagServiceItem.id != undefined) {
                OrderBagServiceItem.update($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                $ctrl.orderBagServiceItem.id = null;
                OrderBagServiceItem.save($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {


            $ctrl.isSaving = false;
            $ctrl.orderBagServiceItem = result;
            //reloadPrices();
            //findFormState();
            initParticipant();
            //$ctrl.formState ='participant';
        }

        function onSaveError() {
            $ctrl.isSaving = false;
        }

        function reloadPrices() {

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
                || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            ) {
                return;
            }

            angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
                angular.forEach($ctrl.priceInfoDtails, function (p) {
                    if (v.priceInfoDtail.id == p.id) {
                        p.gty = v.gty;
                        if (v.options != null && v.options != undefined) {
                            p.options = [];
                            p.options = v.options;
                        }
                    }

                });

            });

        }

        function addOrderBagDtails() {

            clearOrderBagDetails();

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
            }

            var x;
            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {

                x = $ctrl.priceInfoDtails[i];
                if (x == null)
                    continue;

                //if priceInfoDetailID set in OrderBagServiceItemDtail must Update Quantity
                //if (UpdateExistOrderBagServiceItemDtail(x, orderbagOptions))
                if (false) {
                    //do nothing
                } else {


                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
                        gty: 1,
                        price: x.price,
                        discount: x.discount,
                        vat: 0,
                        totalPrice: 0,
                        serviceTimeSession: $ctrl.orderBagServiceItem.serviceTimeSession,
                        //priceInfoDtailId: x.id,
                        priceInfoDtail: x,
                        orderBagItemOptions: null,
                        timeUnitQty: $ctrl.timeUnitQty
                    });
                }
            }

            computeTotalPrice();
        }

        function computeTotalPrice() {
            var orderBag = {};
            orderBag.orderBagServiceItems = [];
            orderBag.orderBagServiceItems.push($ctrl.orderBagServiceItem);
            OrderBagCustom.computeFinalPrice().save(orderBag, function (result) {
                console.log(result);
                if (result.orderBagServiceItems[0])
                    $ctrl.orderBagServiceItem = result.orderBagServiceItems[0];
            })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function calculateOptionPrice(qty) {

            var sumOfOptionPrice = 0;
            var row;
            if ($ctrl.orderBagServiceItem.options)
                for (var i = 0, len = $ctrl.orderBagServiceItem.options.length; i < len; i++) {

                    row = $ctrl.orderBagServiceItem.options[i];
                    if (row.selected) {
                        sumOfOptionPrice += row.priceInfoDtail.price * qty;
                    }
                }

            return sumOfOptionPrice;
        }


        function UpdateExistOrderBagServiceItemDtail(priceInfoDtail, options) {
            //
            //var hasChanged = false;
            //if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
            //    || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            //) {
            //    hasChanged = false;
            //}
            //
            //
            //angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
            //    if (v.priceInfoDtail.id == priceInfoDtail.id) {
            //        v.gty = priceInfoDtail.gty;
            //        v.orderBagItemOptions = options;
            //        hasChanged = true;
            //    }
            //
            //});
            //
            //
            //return hasChanged;
        }

        function prev() {
            $ctrl.formState = 'orderbagitem';
            //  reloadPrices();
        }

        function initParticipant() {
            $ctrl.orderBagServiceItem.participantPersons = [];

            for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
                for (var j = 0, jlen = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i].gty; j < jlen; j++) {
                    $ctrl.orderBagServiceItem.participantPersons.push(
                        {
                            personInfoId: null,
                            orderBagItemDtailId: $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i].id,
                            personInfo: null
                        }
                    );
                }
            }

        }

        function FinalApprove() {
            //saveDtail();
        }

        function serviceItem_changed() {

            $ctrl.selectedDate = null;
            $ctrl.selectedServiceTimeSession = {};

            loadServiceItemServants();
            loadAvailableDates();


            getAvailableDynamicDates();
            getAvailableDynamicMonthlyDates();

            loadCurrentScheduleInfo();


        }

        function loadCurrentScheduleInfo() {
            $ctrl.currentScheduleInfo = null;
            if ($ctrl.orderBagServiceItem.serviceItemId == null && $ctrl.orderBagServiceItem.serviceItemId == undefined) {
                return;
            }

            ScheduleInfoCustom.getCurrentScheduleInfoByServiceItem($ctrl.orderBagServiceItem.serviceItemId).query().$promise.then(function (result) {

                $ctrl.currentScheduleInfo = result;
                if ($ctrl.currentScheduleInfo.floatingTimeType != null) {
                    $ctrl.floatingTimeType = $ctrl.currentScheduleInfo.floatingTimeType;
                }
                if ($ctrl.currentScheduleInfo.scheduleType != null) {
                    $ctrl.scheduleType = $ctrl.currentScheduleInfo.scheduleType;
                }

            });

        }

        function openPersonInfoModal() {
            $uibModal.open({
                templateUrl: 'app/entities/participant-person/order-bag-item-participant-person-dialog.html',
                controller: 'OrderBagParticipantPersonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function (result) {
                addParticipantPerson(result);
            }, function () {
                //nothing
            });


        }

        function addParticipantPerson(participant) {

            if (participant == null || participant == undefined || participant.personInfo == null)
                return;
            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.participantPersons == null || $ctrl.orderBagServiceItem.participantPersons == undefined) {
                $ctrl.orderBagServiceItem.participantPersons = [];
            }

            $ctrl.orderBagServiceItem.participantPersons.push(
                {
                    id: null,
                    personInfoId: null,
                    orderBagItemDtailId: null,
                    personInfo: participant.personInfo
                }
            );


        }

        function removeParticipantPerson(person) {


            if (person != null) {
                $ctrl.orderBagServiceItem.participantPersons = $ctrl.orderBagServiceItem.participantPersons.filter(function (v) {
                        return (v.personInfo.fisrtName != person.fisrtName || v.personInfo.lastName != person.lastName)
                    }
                );
            }

        }

        function clearOrderBagDetails() {
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = null;
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
        }

        function changeControlsData() {
            computeTotalPrice();

        }

        function qtyChanged() {

            changeControlsData();
        }

        function loadAvailableDates() {


            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            $ctrl.orderBagServiceItem.serviceTimeSession = null;
            $ctrl.availableDates = [];
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow($ctrl.orderBagServiceItem.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = $ctrl.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            $ctrl.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });


        }

        function servant_changed() {

        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function loadAvailableTimes(then) {

            if ($ctrl.selectedDate == undefined || $ctrl.selectedDate == null)
                return;

            $ctrl.orderBagServiceItem.serviceTimeSession = null;

            var dateTime = new Date($ctrl.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query(function (list) {
                $ctrl.availableTimes = list;
                if (then)
                    then();

            });

        }

        function availableTimes_changed() {
            getPriceInfoDtail();
            changeControlsData();
        }

        function loadServiceItemServants() {
            $ctrl.orderBagServiceItem.servant = null;
            if ($ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceItemId == undefined)
                return;

            $ctrl.serviceItems.filter(function (v) {
                    if (v.id == $ctrl.orderBagServiceItem.serviceItemId) {
                        $ctrl.servants = v.servants;
                    }
                }
            );
        }

        function getAvailableDynamicDates(then) {
            $ctrl.availableDynamicDates = ScheduleInfoCustom.getDynamicAvailableDatesByServiceId($ctrl.orderBagServiceItem.serviceItemId).query(function (list) {
                if (then)
                    then();


            });
        }

        function getAvailableDynamicTimes(then) {
            $ctrl.selectedDynamicTime = null;
            $ctrl.selectedToTime = null;
            var dateTime = new Date($ctrl.selectedDynamicDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ScheduleInfoCustom.getDynamicAvailableTimesByServiceIdInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query().$promise.then(function (result) {

                $ctrl.allAvailableDynamicTimes = result;
                if (then)
                    then();
                $ctrl.availableDynamicTimes = result.filter(function (v) {
                        return (v.capacity > 0)
                    }
                );
            });

        }

        function availableDynamicDates_changed() {

            getAvailableDynamicTimes();
        }

        function availableDynamicTimes_changed() {
            findToTimePeriod();
        }

        function findToTimePeriod() {

            if ($ctrl.selectedDynamicTime == undefined || $ctrl.selectedDynamicTime == null)
                return null;

            $ctrl.selectedToTime = null;

            $ctrl.toTimePeriodList = [];

            var list = $ctrl.allAvailableDynamicTimes.filter(function (v) {
                    return (v.startTime >= $ctrl.selectedDynamicTime)
                }
            );


            var keepGoing = true;
            angular.forEach(list, function (time) {

                if (keepGoing) {
                    if (time.capacity == 0) {
                        keepGoing = false;
                    }
                    if (keepGoing == true)
                        $ctrl.toTimePeriodList.push(time);
                }
            })


        }

        function ToTime_changed() {
            computeTimeUnitQty();
            if ($ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                $ctrl.orderBagServiceItem.serviceTimeSession = createTimeSession($ctrl.selectedDynamicTime, $ctrl.selectedToTime);

            getPriceInfoDtail();
        }

        function computeTimeUnitQty() {

            var span = {
                startTime: $ctrl.selectedDynamicTime,
                endTime: $ctrl.selectedToTime,
                serviceItemId: $ctrl.orderBagServiceItem.serviceItemId
            }
            TimingInfo.computeTimeUnitQty().save(span, function (result) {
                $ctrl.timeUnitQty = result.timeUnitQty;
            })

            //;
            //if ($ctrl.toTimePeriodList == undefined || $ctrl.toTimePeriodList == null || $ctrl.toTimePeriodList.length == 0) {
            //    $ctrl.timeUnitQty = 1;
            //    return;
            //}
            //if ($ctrl.selectedToTime == undefined || $ctrl.selectedToTime == null) {
            //    $ctrl.timeUnitQty = 0;
            //    return;
            //}
            //
            //
            //var keepGoing = true;
            //var timeUnitCount = 0;
            //var capacity = 100;
            //angular.forEach($ctrl.toTimePeriodList, function (toTime) {
            //    ;
            //    if (keepGoing) {
            //
            //            if(toTime.capacity!=null && toTime.capacity < capacity)
            //                capacity = toTime.capacity;
            //            if (toTime.endTime == $ctrl.selectedToTime) {
            //                keepGoing = false;
            //            }
            //
            //            timeUnitCount++;
            //
            //        }
            //    }
            //);
            //
            //if (timeUnitCount > 0)
            //    $ctrl.timeUnitQty = timeUnitCount;
            //
            //$ctrl.dynamicCapacity = capacity;

        }

        function createTimeSession(fromTime, toTime) {
            var newTimeSession = {};

            var fromDate = new Date(fromTime.toString());
            var toDate = new Date(toTime.toString());


            newTimeSession.startTime = fromTime;
            newTimeSession.endTime = toTime;
            newTimeSession.startDate = fromDate;
            newTimeSession.endDate = toDate;
            newTimeSession.capacity = $ctrl.dynamicCapacity;

            return newTimeSession;


        }

        function showPrices() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceTimeSession != undefined && $ctrl.orderBagServiceItem.serviceTimeSession.id != undefined)
                    return true;
            }
            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.floatingTimeType == 'HOURLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                        return true;
                }
                if ($ctrl.floatingTimeType == 'MONTHLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null)
                        return true;
                }
            }
        }

        function showFloatingHourlyTime() {
            if ($ctrl.scheduleType == null || $ctrl.floatingTimeType == null || $ctrl.floatingTimeType == undefined)
                return false;

            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS' && $ctrl.floatingTimeType == 'HOURLY')
                return true;
        }


        function getAvailableDynamicMonthlyDates() {
            ;
            $ctrl.availableDynamicMonthlyDates = [];
            //if($ctrl.scheduleType!='FLOAT_TIME_SESSIONS' || $ctrl.floatingTimeType != 'MONTHLY')
            //{
            //    return null;
            //}

            $ctrl.availableDynamicMonthlyDates = ScheduleInfoCustom.getDynamicAvailableMonthlyDatesByServiceId($ctrl.orderBagServiceItem.serviceItemId).query();


        }

        function availableDynamicMonthlyDates_changed() {
            ;
            if ($ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null) {
                var newTimeSession = {};

                var fromDate = new Date($ctrl.selectedDynamicMonthlyDate.spanDate.toString());
                var toDate = new Date($ctrl.selectedDynamicMonthlyDate.spanDate.toString());

                toDate.setDate(toDate.getDate() + (30 * $ctrl.timeUnitQty));

                var startTime = new Date($ctrl.selectedDynamicMonthlyDate.startTime.toString());
                var endTime = new Date($ctrl.selectedDynamicMonthlyDate.endTime.toString());
                endTime.setDate(endTime.getDate() + (30 * $ctrl.timeUnitQty));


                newTimeSession.startTime = startTime.toISOString();
                newTimeSession.endTime = endTime.toISOString();
                newTimeSession.startDate = fromDate.toISOString();
                newTimeSession.endDate = toDate.toISOString();
                //newTimeSession.capacity = $ctrl.dynamicCapacity;
                newTimeSession.capacity = 1;

                $ctrl.orderBagServiceItem.serviceTimeSession = newTimeSession;

                getPriceInfoDtail();
            }

        }

        function timeUnitQty_Changed() {
            availableDynamicMonthlyDates_changed();
            computeTotalPrice();
        }


        //$scope.$watch('$ctrl.orderBagServiceItem.options',function(si){
        //    ;
        //    changeControlsData();
        //});

    }


    var OrderBagServiceItem = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/orderbag-service-item/partial-form.orderbag-service-item.html',
        controller: OrderBagServiceItemController,
        bindings: {
            //serviceItemId: '<',
            //selectedServiceTimeSession: '=',
            orderBagServiceItem: '=',
            defaultServiceItemId: '=',
            defaultServiceTimeSessionId: '=',
            defaultStartDate: '=',
            defaultEndDate: '=',
            initMode: '='

            //formState:'=',

        }


    };

    angular
        .module('tikonApp')
        .component('pfOrderBagServiceItem', OrderBagServiceItem)

    OrderBagServiceItemController.$inject = ['$uibModal', '$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem', 'ServiceItemCustom', 'ServiceTimeSessionCustom', 'SettingInfoCustom', 'ServiceTimeSession', 'DateUtils', 'ScheduleInfoCustom', 'TimingInfo', 'OrderBagCustom'];


})();

;
//(function () {
//    'use strict';
//
//    function OrderBagServiceItemController($scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem,ServiceItem) {
//        var $ctrl = this;
//        var pagingParams = {};
//        $ctrl.loadPage = loadPage;
//        $ctrl.formState = 'orderbagitem';
//        $ctrl.options = null;
//        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
//        $ctrl.priceInfoDtails = null;
//        $ctrl.addPricesToOrderbag = addPricesToOrderbag;
//        $ctrl.computeTotalPrice = computeTotalPrice;
//        $ctrl.isSaving = false;
//        $ctrl.saveDtail = saveDtail;
//        $ctrl.findFormState = findFormState;
//        $ctrl.prev = prev;
//        $ctrl.initParticipant = initParticipant;
//        $ctrl.FinalApprove = FinalApprove;
//
//        loadAll();
//
//        loadPage();
//
//        function loadAll() {
//
//
//            function onSuccess(data, headers) {
//
//            }
//
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage(page) {
//            translatePartialLoader.addPart('orderBagServiceItemDtail');
//            translatePartialLoader.addPart('orderBagServiceItem');
//            translatePartialLoader.addPart('orderBagItemOption');
//            translatePartialLoader.addPart('global');
//            translatePartialLoader = translate.refresh();
//
//            getPriceInfoDtail();
//
//        }
//
//        function getPriceInfoDtail() {
//            if($ctrl.serviceItemId==undefined || $ctrl.serviceItemId==null ||$ctrl.selectedServiceTimeSession == undefined  ||$ctrl.selectedServiceTimeSession == null )
//            {
//                // error
//                // have to evaluate
//                return;
//            }
//            if($ctrl.orderBagServiceItem !=null && $ctrl.orderBagServiceItem != undefined &&$ctrl.orderBagServiceItem.status !=null &&$ctrl.orderBagServiceItem.status == 1)
//            {
//                //do nothing
//                // in view mode and not editable
//            }
//            else
//             {
//                 PriceInfoDtailCustom.PriceInfoDtailByServiceTimeSession($ctrl.serviceItemId, $ctrl.selectedServiceTimeSession.id).query(function(result){
//
//                      $ctrl.priceInfoDtails = result;
//                      reloadPrices();
//                 });
//
//             }
//        }
//
//        function saveDtail() {
//            $ctrl.isSaving = true;
//            if ($ctrl.orderBagServiceItem.id !== null && $ctrl.orderBagServiceItem.id != undefined) {
//                OrderBagServiceItem.update($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
//            } else {
//                $ctrl.orderBagServiceItem.id = null;
//                OrderBagServiceItem.save($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess(result) {
//
//
//            $ctrl.isSaving = false;
//            $ctrl.orderBagServiceItem = result;
//            reloadPrices();
//            findFormState();
//            initParticipant();
//            $ctrl.formState ='participant';
//        }
//
//        function onSaveError() {
//            $ctrl.isSaving = false;
//        }
//
//        function reloadPrices()
//        {
//            
//            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
//                || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
//                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
//                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
//            )
//            {
//                return;
//            }
//
//            angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
//                angular.forEach($ctrl.priceInfoDtails, function (p) {
//                    if (v.priceInfoDtail.id == p.id) {
//                        p.gty = v.gty;
//                        if(v.options != null && v.options != undefined)
//                        {
//                            p.options =[];
//                            p.options = v.options;
//                        }
//                    }
//
//                });
//
//            });
//
//        }
//
//        function addPricesToOrderbag() {
//            if($ctrl.orderBagServiceItem ==null ||$ctrl.orderBagServiceItem ==undefined)
//            {
//                $ctrl.orderBagServiceItem = {};
//            }
//            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
//                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
//            }
//
//            var x;
//            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {
//
//                x = $ctrl.priceInfoDtails[i];
//                if (x == null)
//                    continue;
//                if (x.gty == null)
//                    continue;
//                if (x.gty == 0)
//                    continue;
//
//
//                var opts = x.options;
//                var orderbagOptions = [];
//
//                if(opts != null && opts != undefined  ) {
//                    for (var t = 0, mm = opts.length; t < mm; t++) {
//                        // if (opts[t].selected == true) {
//
//                        var opPrice = 0;
//                        var opDiscount = 0;
//                        var opVat = 0;
//                        var OpTotalPrice = 0;
//
//                        if (opts[t].priceInfoDtail != null) {
//                            if (opts[t].priceInfoDtail.price != null)
//                                opPrice = opts[t].priceInfoDtail.price;
//                            if (opts[t].priceInfoDtail.discount != null)
//                                opDiscount = opts[t].priceInfoDtail.discount;
//
//
//                            OpTotalPrice = (opPrice * x.gty) - (opPrice * x.gty * opDiscount / 100) + (opPrice * x.gty * opVat / 100 );
//                        }
//
//
//                        orderbagOptions.push({
//
//                                qty: x.gty,
//                                price: opPrice,
//                                discount: opDiscount,
//                                vat: opVat,
//                                totalPrice: OpTotalPrice,
//                                serviceOptionItem: opts[t]
//
//                            }
//                        )
//
//                        // }
//
//                    }
//
//                }
//                //if priceInfoDetailID set in OrderBagServiceItemDtail must Update Quantity
//                if (UpdateExistOrderBagServiceItemDtail(x, orderbagOptions)) {
//                    //do nothing
//                }
//                else {
//
//
//                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
//
//                        gty: x.gty,
//                        price: x.price,
//                        discount: x.discount,
//                        vat: 3,
//                        totalPrice: 1,
//                        serviceTimeSession: $ctrl.selectedServiceTimeSession,
//                        //priceInfoDtailId: x.id,
//                        priceInfoDtail: x,
//                        orderBagItemOptions: orderbagOptions
//
//                    });
//                }
//            }
//            computeTotalPrice();
//            saveDtail();
//
//        }
//
//        function computeTotalPrice() {
//
//            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
//                return;
//            var row;
//            var price;
//            var discount;
//            var vat;
//
//            var rowDiscount ;
//            var rowVat;
//
//            var subtotalService;
//            var subtotalOptions;
//            var subtotalDiscount;
//            var subtotalVat;
//            var finalPrice;
//
//            for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
//
//                row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
//                if (row.price != null)
//                    price = row.price;
//                else
//                    price = 0
//
//                if (row.discount != null)
//                    discount = row.discount;
//                else
//                    discount = 0
//
//                if (row.vat != null)
//                    vat = row.vat;
//                else
//                    vat = 0
//
//                if(discount>0)
//                {
//                    rowDiscount = (discount*price/100) * row.gty;
//                    row.totalPrice = (price *row.gty ) - rowDiscount ;
//                }
//                else
//                {
//                    rowDiscount=0;
//                    row.totalPrice = price * row.gty;
//                }
//
//                if (vat > 0) {
//                    rowVat = (row.totalPrice * vat) / 100;
//                    row.totalPrice = row.totalPrice + rowVat;
//                }
//
//                subtotalService = subtotalService + price*row.gty;
//                subtotalDiscount = subtotalDiscount + rowDiscount;
//                subtotalVat = subtotalVat + rowVat;
//            }
//
//
//
//        }
//
//        function findFormState() {
//            //
//            //$ctrl.formState = 'OrderBagItemDtail';
//            //
//            //if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined
//            //    && $ctrl.orderBagServiceItem.id != null
//            //    && $ctrl.orderBagServiceItem.orderBagServiceItemDtail != null && $ctrl.orderBagServiceItem.orderBagServiceItemDtail != undefined
//            //) {
//            //    $ctrl.formState = 'OrderBagItemOptions';
//            //
//            //}
//
//        }
//
//        function UpdateExistOrderBagServiceItemDtail(priceInfoDtail, options) {
//
//            var hasChanged = false;
//            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
//                || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
//                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
//                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
//            ) {
//                hasChanged = false;
//            }
//
//
//            angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
//                if (v.priceInfoDtail.id == priceInfoDtail.id) {
//                    v.gty = priceInfoDtail.gty;
//                    v.orderBagItemOptions = options;
//                    hasChanged = true;
//                }
//
//            });
//
//
//            return hasChanged;
//        }
//
//        function prev()
//        {
//            $ctrl.formState ='orderbagitem';
//          //  reloadPrices();
//        }
//        function initParticipant()
//        {
//            $ctrl.orderBagServiceItem.participantPersons = [];
//
//            for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
//                for (var j = 0, jlen = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i].gty; j < jlen; j++) {
//                    $ctrl.orderBagServiceItem.participantPersons.push(
//                        {
//                            personInfoId: null,
//                            orderBagItemDtailId: $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i].id,
//                            personInfo: null
//                        }
//                    );
//                }
//            }
//
//        }
//        function FinalApprove()
//        {
//            saveDtail();
//        }
//
//
//    }
//
//
//
//    var OrderBagServiceItem = {
//        // template:'tets:{{$ctrl.testStr}}',
//        templateUrl: 'app/components/partial-forms/orderbag-service-item/_copy_partial-form.orderbag-service-item.html',
//        controller: OrderBagServiceItemController,
//        bindings: {
//            serviceItemId: '<',
//            selectedServiceTimeSession: '=',
//            orderBagServiceItem: '=',
//            //formState:'=',
//
//        }
//
//    };
//
//    angular
//        .module('tikonApp')
//        .component('pfOrderBagServiceItem', OrderBagServiceItem)
//
//    OrderBagServiceItemController.$inject = ['$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem','ServiceItem'];
//
//
//})();
//
;
(function () {
    'use strict';

    function OrderBagItemOptionCustomController($scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItemCustom) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.allOptions = [];
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.optionsNoQty = [];
        $ctrl.optionsWithQty = [];
        $ctrl.getQtyList = getQtyList;
        $ctrl.onQtyChange = onQtyChange;


        loadAll();
        loadPage();


        //$scope.$watch('$ctrl.serviceOptionItems', function () {
        //    console.log('$ctrl.serviceOptionItems watched');
        //    setSelectedItems();
        //
        //}, true);

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceOptionItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            loadData();

        }

        function loadData() {
            $ctrl.optionsNoQty = []
            $ctrl.optionsWithQty = []
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null)
                $ctrl.allOptions = [];
            else {
                ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query(function (result) {
                    //$ctrl.allOptions = result;
                    angular.forEach(result, function (item) {
                        if (item.qtyType && item.qtyType == "HAS_QTY") {
                            $ctrl.optionsWithQty.push(item);
                            item.selected = true;
                        } else
                            $ctrl.optionsNoQty.push(item);
                    })

                    setOptions();
                });

            }
        }

        function setOptions() {
            var options = $ctrl.optionsNoQty.concat($ctrl.optionsWithQty);
            $ctrl.serviceOptionItems = options;
        }

        function onCheckChanged() {

            if ($ctrl.onSelectedChange) {
                $ctrl.onSelectedChange();

            }
            //$ctrl.serviceOptionItems = $ctrl.allOptions.filter(function (v) {
            //    return (v.selected == true)
            //});

        }

        function onQtyChange() {
            if ($ctrl.onSelectedChange) {
                $ctrl.onSelectedChange();
            }
        }

        function getQtyList(option) {
            var qtyList = [];
            for (var i = 0; i <= option.maxQty; i++) {
                qtyList.push(i);
            }
            return qtyList;
        }

        function setSelectedItems() {

            //if($ctrl.serviceOptionItems ==null || $ctrl.serviceOptionItems ==undefined)
            //    return;
            //
            //angular.forEach($ctrl.serviceOptionItems, function (p) {
            //    var filtered = $ctrl.allOptions.filter(function (v) {
            //        return(v.id == p.id)
            //    });
            //    if(filtered.length>0)
            //    {
            //        filtered[0].selected = true;
            //    }
            //});
        }

        $scope.$watch('$ctrl.serviceItemId', function (si) {
            loadData();
        });

        $scope.$watch('$ctrl.optionsNoQty', function () {
            setOptions();
        });
        $scope.$watch('$ctrl.optionsWithQty', function () {
            setOptions();
        });

    }

    var OrderBagItemOptions = {
        templateUrl: 'app/components/partial-forms/orderbag-item-options/partial-form.orderbag-item-options.html',
        controller: OrderBagItemOptionCustomController,
        bindings:
            {
                serviceItemId: '<',
                serviceOptionItems: '=',
                onSelectedChange: "&"
            }

    };

    angular
        .module('tikonApp')
        .component('pfOrderBagItemOptions', OrderBagItemOptions)

    OrderBagItemOptionCustomController.$inject = ['$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItemCustom'];


})();

;
//(function() {
//    'use strict';
//
//    function OrderBagItemOptionCustomController ($scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants,translate, translatePartialLoader,ServiceOptionItemCustom) {
//
//        var $ctrl = this;
//        var pagingParams={};
//        $ctrl.loadPage = loadPage;
//        $ctrl.selectedId='';
//        $ctrl.formState='list';
//        $ctrl.allOptions =[];
//        $ctrl.checkChanged=onCheckChanged;
//
//        loadAll();
//        loadPage();
//
//
//        //$scope.$watch('$ctrl.serviceOptionItems', function () {
//        //    console.log('$ctrl.serviceOptionItems watched');
//        //    setSelectedItems();
//        //
//        //}, true);
//
//        function loadAll () {
//
//
//            function onSuccess(data, headers) {
//
//            }
//            function onError(error) {
//                AlertService.error(error.data.message);
//            }
//        }
//
//        function loadPage (page) {
//            translatePartialLoader.addPart('serviceOptionItem');
//            translatePartialLoader.addPart('global');
//            translatePartialLoader=translate.refresh();
//
//            //if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null)
//            //    $ctrl.serviceOptionItems = [];
//            //else
//            //    $ctrl.serviceOptionItems = ServiceOptionItemCustom.ServiceOptionItemsSelectedInOrderBag($ctrl.serviceItemId,$ctrl.orderBagServiceItemDtailId).query();
//
//            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null)
//                $ctrl.allOptions = [];
//            else {
//                ServiceOptionItemCustom.ServiceOptionItemsSelectedInOrderBag($ctrl.serviceItemId, -1).query(function (result) {
//                    $ctrl.allOptions = result;
//                    setSelectedItems();
//
//                });
//
//            }
//
//        }
//
//
//        function onCheckChanged()
//        {
//            $ctrl.serviceOptionItems = $ctrl.allOptions.filter(function (v) {
//                return (v.selected == true)
//            });
//
//        }
//
//        function setSelectedItems()
//        {
//
//            if($ctrl.serviceOptionItems ==null || $ctrl.serviceOptionItems ==undefined)
//                return;
//
//            angular.forEach($ctrl.serviceOptionItems, function (p) {
//                var filtered = $ctrl.allOptions.filter(function (v) {
//                    return(v.id == p.id)
//                });
//                if(filtered.length>0)
//                {
//                    filtered[0].selected = true;
//                }
//            });
//        }
//
//    }
//
//    var OrderBagItemOptions = {
//        templateUrl: 'app/components/partial-forms/orderbag-item-options/partial-form.orderbag-item-options.html',
//        controller:OrderBagItemOptionCustomController,
//        bindings:
//        {
//            serviceItemId:'<',
//            serviceOptionItems:'=',
//            //orderBagServiceItemDtailId:'='
//        }
//
//    };
//
//    angular
//        .module('tikonApp')
//        .component('pfOrderBagItemOptions', OrderBagItemOptions)
//
//    OrderBagItemOptionCustomController.$inject = ['$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants','$translate', '$translatePartialLoader','ServiceOptionItemCustom'];
//
//
//
//})();
//
;
(function () {
    'use strict';

    function LocationInfoComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.country_changed = country_changed;
        $ctrl.province_changed = province_changed;
        $ctrl.selectordata = SelectorData.query();
        $ctrl.countryList = SelectorDataQuery.findByType('country').query();

        $ctrl.provinceList = [];
        $ctrl.cityList = [];
        $ctrl.getCurrentLocation = getCurrentLocation;

        $ctrl.markerDragEnd = markerDragEnd;

        $ctrl.positions = [
            {pos: [35.71, 50.21]},
        ];

        $ctrl.map = null;
        $ctrl.mapMarker = null;

        loadAll();

        loadPage();

        // loadMapBox();
        loadLeafletMap();


        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


            // loadSavedLocation();

            if ($ctrl.locationInfo == null || $ctrl.locationInfo == undefined) {
                $ctrl.locationInfo = {};
            }
            if ($ctrl.locationInfo != undefined && $ctrl.locationInfo.countryId != null && $ctrl.locationInfo.countryId != undefined) {
                $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.locationInfo.countryId).query();
                if ($ctrl.locationInfo.stateId != null && $ctrl.locationInfo.stateId != undefined) {
                    $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.locationInfo.stateId).query();
                }


            }

        }

        function country_changed() {
            console.log($ctrl.countryList);
            console.log($ctrl.provinceList);
            $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.locationInfo.countryId).query();
        }

        function province_changed() {
            $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.locationInfo.stateId).query();
        }


        function getCurrentLocation() {

            if (navigator.geolocation) {

                var options = {
                    enableHighAccuracy: true,
                    maximumAge: 0
                };

                navigator.geolocation.getCurrentPosition(success, error, options);
            } else {
                x.innerHTML = "Geolocation is not supported by this browser.";
            }
        }

        function success(pos) {
            var crd = pos.coords;

            $ctrl.locationInfo.mapX = crd.latitude;
            $ctrl.locationInfo.mapY = crd.longitude;

            showLeafletMap($ctrl.locationInfo.mapX, $ctrl.locationInfo.mapY);
            $ctrl.positions = [
                {pos: [$ctrl.locationInfo.mapX, $ctrl.locationInfo.mapY]}
            ];
        }

        function error(err) {

            console.warn(err.message);
        }


        // function loadSavedLocation()
        // {
        //     if($ctrl.locationInfo != null &&$ctrl.locationInfo != undefined) {
        //         if ($ctrl.locationInfo.mapX != null && $ctrl.locationInfo.mapX != undefined && $ctrl.locationInfo.mapY != null && $ctrl.locationInfo.mapY != undefined) {
        //             $ctrl.positions = [
        //                 {pos: [$ctrl.locationInfo.mapX, $ctrl.locationInfo.mapY]}
        //             ];
        //             return;
        //         }
        //     }
        //
        //     getCurrentLocation();
        // }

        function markerDragEnd(position) {

            $ctrl.locationInfo.mapX = position.latLng.lat();
            $ctrl.locationInfo.mapY = position.latLng.lng();

        }

        function loadMapBox() {


            setTimeout(function () {

                // L.Icon.Default.imagePath = '';
                var mapX;
                var mapY;
                var mymap;
                var initZoom = 16;

                // mapboxgl.accessToken = 'pk.eyJ1IjoibWptYWppZGYiLCJhIjoiY2tjNGpzcWFzMDhpOTJxbnU1OTk1ZjQyZyJ9.pWVBFzPmuog2zlf1MD2ubg';
                mapboxgl.accessToken = 'pk.eyJ1IjoibWotbWFqaWQtZmF0dGFoaSIsImEiOiJja3U1YjN3djUwNjE5MnFwYXZzcm1tczJhIn0.FLWOyjGqBEh9C5CT3gNyyQ';

                mapboxgl.setRTLTextPlugin(
                    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
                    null,
                    true // Lazy load the plugin
                );

                if ($ctrl.locationInfo.mapX && $ctrl.locationInfo.mapY) {
                    mapX = $ctrl.locationInfo.mapX;
                    mapY = $ctrl.locationInfo.mapY;
                    //   mymap = L.map('mapid').setView([mapX, mapY], 15);
                } else {
                    mapX = 35.69439;
                    mapY = 51.42151;
                    //    mymap = L.map('mapid').setView([mapX, mapY], 13);
                }
                mymap = new mapboxgl.Map({
                    container: 'mapid',
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: [mapY, mapX], // starting position
                    zoom: initZoom // starting zoom
                });


                // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
                //     // attribution: 'Mapسامانه نوبت دهی و رزرو آنلاین data &copy; <a href="https://www.reserweb.ir/">رزروب</a>',
                //     attribution: 'سامانه نوبت دهی و رزرو آنلاین &copy; <a style="font-weight: bold;" href="https://www.reserweb.ir/">رزروب</a>',
                //     maxZoom: 18,
                //     // id: 'mapbox.streets',
                //     // accessToken: 'your.mapbox.access.token'
                //     id: 'rakshak.l937n12c',
                //     accessToken: 'pk.eyJ1IjoicmFrc2hhayIsImEiOiJ5cHhqeHlRIn0.Vi87VjI1cKbl1lhOn95Lpw'
                // }).addTo(mymap);
                // if (!L.Icon.Default.imagePath) {
                var defaultIcon = L.icon({
                    iconUrl: '../../../bower_components/leaflet/dist/images/marker-icon-2x.png',
                    shadowUrl: '../../../bower_components/leaflet/dist/images/marker-shadow.png',

                    iconSize: [25, 41], // size of the icon
                    shadowSize: [41, 41], // size of the shadow
                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                    shadowAnchor: [12, 41],  // the same for the shadow
                    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
                });
                // }
                mymap.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        trackUserLocation: true
                    })
                );
                var marker = new mapboxgl.Marker({draggable: true})
                    .setLngLat([mapY, mapX])
                    .addTo(mymap);

                // var marker = L.marker([mapX, mapY], {
                //     title: 'موقعیت ثبت شده کنونی',
                //     draggable: true,
                //     icon: defaultIcon
                // }).addTo(mymap);

                marker.on('dragend', function (m) {
                    // get and display lanLng of the marker while dragging
                    var coordinate = marker.getLngLat();

                    $ctrl.locationInfo.mapX = coordinate.lat;
                    $ctrl.locationInfo.mapY = coordinate.lng;

                });
            }, 1000);
        }

        function loadLeafletMap() {


            setTimeout(function () {

                var mapX;
                var mapY;

                L.Icon.Default.imagePath = '../bower_components/leaflet/dist/images';

                if ($ctrl.locationInfo.mapX && $ctrl.locationInfo.mapY) {
                    mapX = $ctrl.locationInfo.mapX;
                    mapY = $ctrl.locationInfo.mapY;
                } else {
                    mapX = 35.69439;
                    mapY = 51.42151;
                }

                $ctrl.map = L.map('mapid').setView([mapX, mapY], 13);

                $ctrl.map.addEventListener("click", function (event) {
                    setMarker(event.latlng.lat, event.latlng.lng)
                })

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.planovin.com">Planovin</a>'
                }).addTo($ctrl.map);

                showLeafletMap(mapX, mapY);

            }, 1000);
        }

        function showLeafletMap(lat, lng) {

            if ($ctrl.map) {
                $ctrl.map.setView([lat, lng], 13);

                setMarker(lat, lng)


            }
        }

        function setMarker(lat, lng) {
            if ($ctrl.mapMarker)
                $ctrl.map.removeLayer($ctrl.mapMarker);
            // $ctrl.mapMarker = L.marker([lat, lng]).addTo($ctrl.map);


            $ctrl.mapMarker = L.marker([lat, lng], {title: "موقعیت کسب و کار", draggable: true})
                .addTo($ctrl.map)
                .on('dragend', function () {
                    var coord = $ctrl.mapMarker.getLatLng();
                    var lat = coord.lat;
                    var lng = coord.lng;

                    $ctrl.locationInfo.mapX = lat;
                    $ctrl.locationInfo.mapY = lng;


                    $ctrl.mapMarker.bindPopup("Moved to : " + lat[1] + ", " + lng[0] + ".");
                });
        }


    }

    var LocationInfoComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/location-info/partial-form.location-info.html',
        controller: LocationInfoComponentController,
        bindings:
            {
                locationInfo: '=',
            }

    };

    angular
        .module('tikonApp')
        .component('pfLocationInfo', LocationInfoComponent)

    LocationInfoComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JoinVideoMeetingEventComponentController', JoinVideoMeetingEventComponentController);

    function JoinVideoMeetingEventComponentController($scope, $state, $stateParams, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, entity, $window, $mdDialog) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.joinMeetingURL = "";
        $ctrl.entity = entity;
        // $ctrl.orderBagItem = {};
        $ctrl.moderatorName = "";
        $ctrl.createMeeting = createMeeting;
        $ctrl.errorMsg = "";
        $ctrl.successMsg = "";
        $ctrl.goToMeetingRoom = goToMeetingRoom;

        loadAll();
        loadPage();

        function loadAll() {
            $ctrl.serviceItem = entity.serviceItem;

            if (entity.servant && entity.servant.personInfo.fullName) {
                $ctrl.servant = entity.servant;
                $ctrl.moderatorName = entity.servant.personInfo.fullName;
            }
        }

        function createMeeting() {

            getVideoMeetingUrl();
        }


        function getVideoMeetingUrl() {
            var newMeeting = {};

            newMeeting.serviceItemId = $ctrl.serviceItem.id;
            newMeeting.servantId = $ctrl.servant.id;
            newMeeting.mode = 'event';
            newMeeting.password = $ctrl.serviceItem.servantMeetingPassword;
            newMeeting.fullName = $ctrl.moderatorName;


            OrderBagServiceItemCustom.createVideoMeetingEvent().save(newMeeting, onCreateMeetingSuccess, onCreateMeetingFailed);

            function onCreateMeetingSuccess(result) {


                if (result.joinMeetingURL) {
                    $ctrl.joinMeetingURL = result.joinMeetingURL;
                    $ctrl.successMsg = "createSuccess";
                    $ctrl.errorMsg = "";
                }

            }

            function onCreateMeetingFailed() {
                $ctrl.joinMeetingURL = "";
                $ctrl.successMsg = "";
                $ctrl.errorMsg = "createError";
            }


        }


        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader = translate.refresh();
        }

        function goToMeetingRoom() {
            $window.open($ctrl.joinMeetingURL, "_blank");
            $mdDialog.hide();
        }


    }

    var JoinVideoMeetingEventComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
        controller: JoinVideoMeetingEventComponentController,
        bindings:
            {
                serviceItem: '=',
                serviceItemId: '=',
                servant: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfJoinVideoMeetingEvent', JoinVideoMeetingEventComponent)

    JoinVideoMeetingEventComponentController.$inject = ['$scope', '$state', '$stateParams', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', 'entity', '$window', '$mdDialog'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JoinVideoMeetingComponentController', JoinVideoMeetingComponentController);

    function JoinVideoMeetingComponentController($scope, $state, $stateParams, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, entity, SettingInfoCustom, AlertToastService, $window) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.joinMeetingURL = "";
        $ctrl.entity = entity;
        // $ctrl.orderBagItem = {};
        $ctrl.moderatorName = "";
        $ctrl.createMeeting = createMeeting;
        $ctrl.errorMsg = "";
        $ctrl.successMsg = "";
        $ctrl.platformType = '';
        $ctrl.needToCreate = true;
        $ctrl.copyMeetingLink = copyMeetingLink;


        loadAll();
        loadPage();

        function loadAll() {
            $ctrl.orderBagItem = entity.orderBagItem;

            if ($ctrl.orderBagItem.servant) {
                $ctrl.moderatorName = $ctrl.orderBagItem.servant.personInfo.fullName;

                if ($ctrl.orderBagItem.servant.videoCallSettingInfo && $ctrl.orderBagItem.servant.videoCallSettingInfo.id) {
                    getMeetingURLByVideoSetting($ctrl.orderBagItem.servant.videoCallSettingInfo);
                    return;
                }
            }

            SettingInfoCustom.getSettingInfoByCurrentCompany().query().$promise.then(function (setting) {

                if (setting && setting.videoCallSettingInfo) {
                    getMeetingURLByVideoSetting(setting.videoCallSettingInfo);
                }
            })

        }

        function getMeetingURLByVideoSetting(videoCallSetting) {
            if (videoCallSetting && videoCallSetting.platformType) {
                $ctrl.platformType = videoCallSetting.platformType;

                if ($ctrl.platformType == 'JITSI_MEET' ||
                    $ctrl.platformType == 'GOOGLE_MEET' ||
                    $ctrl.platformType == 'SKYPE' ||
                    $ctrl.platformType == 'CUSTOM'
                ) {
                    $ctrl.needToCreate = false;
                    OrderBagServiceItemCustom.getMeetingUrl($ctrl.orderBagItem.id).query().$promise.then(onGetMeetingSuccess, onGetMeetingFailed);

                }
            }
        }

        function onGetMeetingSuccess(result) {

            if (result && result.joinMeetingURL) {
                $ctrl.joinMeetingURL = result.joinMeetingURL;
                // $ctrl.successMsg = "createSuccess";
                $ctrl.errorMsg = "";
            } else {
                onGetMeetingFailed();
            }

        }

        function onGetMeetingFailed() {
            $ctrl.joinMeetingURL = "";
            $ctrl.successMsg = "";
            $ctrl.errorMsg = "linkNotFoundError";
        }


        function createMeeting() {

            getVideoMeetingUrl($ctrl.orderBagItem.id);
        }


        function getVideoMeetingUrl(orderBagItemId) {
            var newMeeting = {};
            newMeeting.orderBagItemId = orderBagItemId;
            newMeeting.password = $ctrl.orderBagItem.servant.id;
            newMeeting.fullName = $ctrl.moderatorName;


            OrderBagServiceItemCustom.createVideoMeeting().save(newMeeting, onCreateMeetingSuccess, onCreateMeetingFailed);

            function onCreateMeetingSuccess(result) {


                if (!result.joinMeetingURL) {
                    $ctrl.joinMeetingURL = result.joinMeetingURL;
                    $ctrl.successMsg = "createSuccess";
                    $ctrl.errorMsg = "";
                } else {
                    onCreateMeetingFailed();
                }

            }

            function onCreateMeetingFailed() {
                $ctrl.joinMeetingURL = "";
                $ctrl.successMsg = "";
                $ctrl.errorMsg = "linkNotFoundError";
            }


        }


        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();
        }

        function copyMeetingLink() {
            if (!$ctrl.joinMeetingURL) {
                AlertToastService.error('لینک جلسه موجود نیست', null, null);
                return;
            }
            var text = $ctrl.joinMeetingURL;

            var body = angular.element($window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });

            textarea.val(text);
            body.append(textarea);
            textarea[0].select();
            document.execCommand('copy');
            AlertToastService.success('tikonApp.orderBagServiceItem.videoMeeting.copySuccess', null, null);

            textarea.remove();

        }


    }

    var JoinVideoMeetingComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
        controller: JoinVideoMeetingComponentController,
        bindings:
            {
                orderBagItemId: '=',
                orderBagItem: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfJoinVideoMeeting', JoinVideoMeetingComponent)

    JoinVideoMeetingComponentController.$inject = ['$scope', '$state', '$stateParams', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', 'entity', 'SettingInfoCustom', 'AlertToastService', '$window'];


})();

;
(function () {
    'use strict';

    function InvoiceInfoListComponentController(__config, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, InvoiceInfoCustom, $translate) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.__config = __config;
        $ctrl.findStatusStyle = findStatusStyle;
        $ctrl.findStatusTitle = findStatusTitle;

        $ctrl.editInvoiceInfo = editInvoiceInfo;


        loadAll();
        loadPage();

        function loadAll() {


        }

        function loadPage() {
            translatePartialLoader.addPart('invoiceStatus');
            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader.addPart('invoiceInfo');
            translatePartialLoader = translate.refresh();
        }


        function findStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function editInvoiceInfo(invoiceInfo) {
            if (invoiceInfo.status == 'TEMP')
                $state.go('supplierPanel-v2.companyCustomer.editInvoiceInfo', {id: invoiceInfo.id});
            if (invoiceInfo.status == 'UNPAID' || invoiceInfo.status == 'SETTLEMENT' || invoiceInfo.status == 'VOID')
                $state.go('supplierPanel-v2.companyCustomer.invoiceInfoDetail', {id: invoiceInfo.id});

        }
    }

    var InvoiceInfoListComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/invoice-info-list/partial-form.invoice-info-list.html',
        controller: InvoiceInfoListComponentController,
        bindings:
            {
                invoiceInfoList: '=',
                fromDate: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfInvoiceInfoList', InvoiceInfoListComponent)

    InvoiceInfoListComponentController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'InvoiceInfoCustom', '$translate'];


})();

;
(function () {
    'use strict';

    function GeneralScheduleController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService, CompanyInfoQuery) {

        var $ctrl = this;
        $ctrl.loadPage = loadPage;


        $timeout(function () {

            loadPage();

        });


        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            $ctrl.scheduleInfos = [];


        }


    }

    var GeneralSchedule = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/general-schedule/partial-form.general-schedules.html',
        controller: GeneralScheduleController,
        bindings: {

            scheduleInfo: '='
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfGeneralSchedule', GeneralSchedule)

    //  GeneralScheduleController.$inject = ['$scope','$attrs','$element'];
    GeneralScheduleController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService', 'CompanyInfoQuery'];


})();

;
(function () {
    'use strict';

    function ExceptionDurationV2Controller($scope, $state, translate, translatePartialLoader, $mdDialog) {
        var $ctrl = this;
        $ctrl.newDate = null;

        $ctrl.addDuration = addDuration;
        $ctrl.removeDuration = removeDuration;
        $ctrl.startDate = new Date();
        $ctrl.endDate = new Date();
        $ctrl.startTime;
        $ctrl.endTime;
        $ctrl.availablityMode = 'CLOSE';

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {
            if (!$ctrl.exdurations)
                $ctrl.exdurations = [];
            var dur = makeDurationObject();
            if (dur && $ctrl.startDate != null && $ctrl.endDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == $ctrl.startDate.toLocaleString() &&
                        ((!val.startTime && !$ctrl.startTime) || (val.startTime && $ctrl.startTime && val.startTime.toLocaleString() == $ctrl.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == $ctrl.endDate.toLocaleString() &&
                        ((!val.endTime && !$ctrl.endTime) || (val.endTime && $ctrl.endTime && val.endTime.toLocaleString() == $ctrl.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    $ctrl.exdurations.push(dur);
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            $mdDialog.show(
                $mdDialog.alert()
                    //  .parent(angular.element(document.querySelector('#addExceptionDuration')))
                    .clickOutsideToClose(true)
                    .title('خطا')
                    .textContent(msg)
                    .ariaLabel('error')
                    .ok('بستن')
                    .targetEvent(null)
            );
        }

        function makeDurationObject(ev) {
            $ctrl.endDate = $ctrl.startDate;
            if (!$ctrl.startTime || !$ctrl.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availablityMode: $ctrl.availablityMode,
                    startDate: $ctrl.startDate,
                    endDate: $ctrl.endDate,
                    startTime: $ctrl.startTime,
                    endTime: $ctrl.endTime
                };
            }

        }

        function removeDuration(date) {
            if ($ctrl.exdurations != undefined)
                $ctrl.exdurations = $ctrl.exdurations.filter(function (item) {
                    return item != date;
                });
        }


    }

    var ExceptionDurationV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/exception-duration-v2/partial-form.exception-duration-v2.html',
        controller: ExceptionDurationV2Controller,
        bindings: {
            exdurations: '='
        }

    };

    angular
        .module('tikonApp')
        .component('pfExceptionDurationV2', ExceptionDurationV2)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    ExceptionDurationV2Controller.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog'];


})();

;
(function () {
    'use strict';

    function ExceptionDurationController($scope, $state, translate, translatePartialLoader, $mdDialog) {
        var $ctrl = this;
        $ctrl.newDate = null;

        $ctrl.addDuration = addDuration;
        $ctrl.removeDuration = removeDuration;
        $ctrl.startDate = new Date();
        $ctrl.endDate = new Date();
        $ctrl.startTime;
        $ctrl.endTime;
        $ctrl.availablityMode = 'CLOSE';

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {
            if (!$ctrl.exdurations)
                $ctrl.exdurations = [];
            var dur = makeDurationObject();
            if (dur && $ctrl.startDate != null && $ctrl.endDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == $ctrl.startDate.toLocaleString() &&
                        ((!val.startTime && !$ctrl.startTime) || (val.startTime && $ctrl.startTime && val.startTime.toLocaleString() == $ctrl.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == $ctrl.endDate.toLocaleString() &&
                        ((!val.endTime && !$ctrl.endTime) || (val.endTime && $ctrl.endTime && val.endTime.toLocaleString() == $ctrl.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    $ctrl.exdurations.push(dur);
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            $mdDialog.show(
                $mdDialog.alert()
                    //  .parent(angular.element(document.querySelector('#addExceptionDuration')))
                    .clickOutsideToClose(true)
                    .title('خطا')
                    .textContent(msg)
                    .ariaLabel('error')
                    .ok('بستن')
                    .targetEvent(null)
            );
        }

        function makeDurationObject(ev) {
            $ctrl.endDate = $ctrl.startDate;
            if (!$ctrl.startTime || !$ctrl.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availablityMode: $ctrl.availablityMode,
                    startDate: $ctrl.startDate,
                    endDate: $ctrl.endDate,
                    startTime: $ctrl.startTime,
                    endTime: $ctrl.endTime
                };
            }

        }

        function removeDuration(date) {
            if ($ctrl.exdurations != undefined)
                $ctrl.exdurations = $ctrl.exdurations.filter(function (item) {
                    return item != date;
                });
        }


    }

    var ExceptionDuration = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/exception-duration/partial-form.exception-duration.html',
        controller: ExceptionDurationController,
        bindings: {
            exdurations: '='
        }

    };

    angular
        .module('tikonApp')
        .component('pfExceptionDuration', ExceptionDuration)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    ExceptionDurationController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog'];


})();

;
(function () {
    'use strict';

    function EventItemSchedulesController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService) {


        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.generateTimeInfo = generateTimeInfo;
        $ctrl.showTimingInfo = showTimingInfo;
        $ctrl.backToScheduleInfo = backToScheduleInfo;
        $ctrl.saveSchedule = saveSchedule;
        $ctrl.schSelected = false;
        $ctrl.schSaved = false;
        $ctrl.step = 0;
        $ctrl.schedulerApi = {refresh: 'not set'};
        $ctrl.generateTimesUntil = generateTimesUntil;
        $ctrl.session_date = new Date();
        $ctrl.scheduleType_changed = scheduleType_changed;
        $ctrl.canSelectMultipleTimes = false;
        $ctrl.hasDedicateSchedule = false;
        $ctrl.session_capacity = 1;
        $ctrl.gapTime = 0;
        $ctrl.session_discount = 0;
        $ctrl.showAdvancedSetting = false;


        $timeout(function () {
            loadAll();
            loadPage();

        });


        function setScheduleTypeFlags() {

            if ($ctrl.selectedScheduleInfo) {
                switch ($ctrl.selectedScheduleInfo.scheduleType) {
                    case 'BASED_ON_COMPANY_SCHEDULE':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = false;
                        break;
                    case 'PRIMARY':
                        $ctrl.canSelectMultipleTimes = false;
                        $ctrl.hasDedicateSchedule = true;
                        break;
                    case 'FIXED_TIME_SESSIONS':
                        break;
                    case 'FLOAT_TIME_SESSIONS':
                        $ctrl.canSelectMultipleTimes = true;
                        $ctrl.hasDedicateSchedule = true;
                        break;

                }
            }
        }

        function updateScheduleTypeFromFlags() {
            if ($ctrl.selectedScheduleInfo.scheduleType != 'FIXED_TIME_SESSIONS') {
                $ctrl.selectedScheduleInfo.scheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                if ($ctrl.hasDedicateSchedule) {
                    $ctrl.selectedScheduleInfo.scheduleType = 'PRIMARY';

                } else {
                    $ctrl.canSelectMultipleTimes = false;
                }
                if ($ctrl.canSelectMultipleTimes)
                    $ctrl.selectedScheduleInfo.scheduleType = 'FLOAT_TIME_SESSIONS';
            }

        }

        function showTimingInfo() {
            $ctrl.timingInfo = $ctrl.selectedScheduleInfo.timingInfo;
            $ctrl.step = 1;
        }

        $ctrl.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }

        function saveSchedule() {
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            $ctrl.selectedScheduleInfo.scheduleType = 'SERVICE_SCHEDULE';
            if ($ctrl.selectedScheduleInfo.baseScheduleMode == 'BASED_ON_RESOURCE') {
                $ctrl.selectedScheduleInfo.dependencyMode = 'ON_SERVANT';
            } else {
                $ctrl.selectedScheduleInfo.dependencyMode = 'NON';
            }

            //    updateScheduleTypeFromFlags();
            TimingInfo.saveScheduleInfo().save($ctrl.selectedScheduleInfo, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.selectedId = sch.id;
                $ctrl.timingInfo = sch.timingInfo;
                $ctrl.step = 1;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                refreshList();
            });
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate($ctrl.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save($ctrl.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                $ctrl.timingInfo = timingInfo;
                $ctrl.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if ($ctrl.schedulerApi.refreshScheduler)
                $ctrl.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            $ctrl.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('scheduleType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            refreshList();


        }

        function refreshList() {
            if (!$ctrl.serviceItemId) $ctrl.scheduleInfos = [];
            else {
                ScheduleInfoCustom.primaryScheduleInfosByServiceItem($ctrl.serviceItemId).query(function (schs) {
                    $ctrl.scheduleInfos = schs;

                    if (!$ctrl.schSelected) {
                        if (schs.length == 0) $ctrl.newItem();
                        else $ctrl.editItem(schs[0]);
                    }
                });
            }
        }

        function newItem() {
            //
            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            $ctrl.selectedScheduleInfo.serviceItemId = $ctrl.serviceItemId;
            $ctrl.schSelected = true;
            $ctrl.schSaved = false;
            updateTabs();

        }

        $ctrl.add_session = addSession;
        $ctrl.remove_session = removeSession;

        function removeSession(item) {
            var index = $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.indexOf(item);

            if (index > -1) {
                $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(index, 1);
            }

        }

        function addSession() {


            var isValid = validateTimesession();
            if (isValid) {
                var sessions = splitDurationIntoTimeSession();
                var i = 0;
                angular.forEach(sessions, function (ts) {
                    if (!isInList(ts)) {
                        i++
                        $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes.splice(0, 0, ts);
                    }
                })

                $('#closeDialog').click();
                AlertService.info('global.messages.info.newFixedTimeSessionAdded', {n: i});
            }
        }

        function validateTimesession() {
            if (!$ctrl.gapTime)
                $ctrl.gapTime = 0;

            var isValid = true;
            if (!$ctrl.session_date) {
                AlertService.error("error.time_session_date_is_required");
                isValid = false;
            } else if (!$ctrl.from_session_time || !$ctrl.to_session_time) {
                AlertService.error("error.start_and_end_time_is_required");
                isValid = false;
            } else if (!$ctrl.session_capacity) {
                AlertService.error("error.time_session_capacity_is_required");
                isValid = false;
            } else

                return isValid;
        }

        function splitDurationIntoTimeSession() {

            var retList = [];
            var from = $ctrl.from_session_time;
            var to = $ctrl.to_session_time;
            var duration = $ctrl.duration;
            var gap = $ctrl.gapTime;
            var dur_in_min = (to.getHours() - from.getHours()) * 60 + (to.getMinutes() - from.getMinutes());
            if (dur_in_min > 15) {
                if ($ctrl.duration && $ctrl.duration >= 15) {
                    if ($ctrl.duration > dur_in_min) {
                        $ctrl.duration = dur_in_min;
                        var newTimeSession = {
                            spanDate: $ctrl.session_date,
                            startTime: from,
                            endTime: to,
                            capacity: $ctrl.session_capacity,
                            discount: $ctrl.session_discount,
                            comment: $ctrl.session_comment,
                            timeSessionType: 'FIXED'
                        };
                        retList.push(newTimeSession);
                    } else {
                        var partsCount = dur_in_min / (duration + gap);
                        var start = moment(from);

                        for (var i = 0; i < partsCount; i++) {

                            var newTimeSession = {
                                spanDate: $ctrl.session_date,
                                startTime: start.toDate(),
                                endTime: start.add(duration, 'minutes').toDate(),
                                capacity: $ctrl.session_capacity,
                                discount: $ctrl.session_discount,
                                comment: $ctrl.session_comment,
                                timeSessionType: 'FIXED'
                            };
                            retList.splice(0, 0, newTimeSession);
                            start = start.add(gap, 'minutes');
                        }
                    }
                } else {
                    $ctrl.duration = dur_in_min;
                    var newTimeSession = {
                        spanDate: $ctrl.session_date,
                        startTime: from,
                        endTime: to,
                        capacity: $ctrl.session_capacity,
                        discount: $ctrl.session_discount,
                        comment: $ctrl.session_comment,
                        timeSessionType: 'FIXED'
                    };
                    retList.push(newTimeSession);
                }
            } else {
                AlertService.error("error.start_time_must_be_before_end_time");
            }
            return retList;
        }

        function isInList(timeSession) {
            if (timeSession.spanDate && timeSession.startTime && timeSession.endTime) {
                var exists = false;
                angular.forEach($ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes, function (time) {
                    if (datesAreEqual(time.spanDate, timeSession.spanDate) &&
                        timesAreEqual(time.startTime, timeSession.startTime) &&
                        timesAreEqual(time.endTime, timeSession.endTime))
                        exists = true;
                });
                if (exists) {
                    AlertService.error("error.time_session_date_time_is_repeated");
                    return true;
                } else {
                    return false;
                }


            }
            return false;
        }

        function editItem(id) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                updateTabs();
            });

        }

        function updateTabs() {
            setScheduleTypeFlags();
            if ($ctrl.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            $ctrl.formState = 'list';
            $ctrl.selectedScheduleId = '';
            refreshList();
        }

        function datesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("YYMMDD") == dm2.format("YYMMDD"))

        }

        function timesAreEqual(date1, date2) {
            var dm1 = moment(date1);
            var dm2 = moment(date2);
            return (dm1.format("HH:mm") == dm2.format("HH:mm"))

        }


        function scheduleType_changed() {

        }

    }

    var EventItemSchedules = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/event-item-schedules/partial-form.event-item-schedules.html',
        controller: EventItemSchedulesController,
        bindings: {
            serviceItemId: '<',
            selectedScheduleInfo: '=',
            eventDuration: '=?'
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfEventItemSchedules', EventItemSchedules)


    EventItemSchedulesController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService'];


})();

;
(function () {
    'use strict';

    function EventExceptionDurationController($scope, $state, translate, translatePartialLoader, $mdDialog) {
        var $ctrl = this;
        $ctrl.newDate = null;

        $ctrl.addDuration = addDuration;
        $ctrl.removeDuration = removeDuration;
        $ctrl.startDate = new Date();
        $ctrl.endDate = new Date();
        $ctrl.startTime;
        $ctrl.endTime;
        $ctrl.availablityMode = 'OPEN';

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {
            if (!$ctrl.exdurations)
                $ctrl.exdurations = [];
            var dur = makeDurationObject();
            if (dur && $ctrl.startDate != null && $ctrl.endDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == $ctrl.startDate.toLocaleString() &&
                        ((!val.startTime && !$ctrl.startTime) || (val.startTime && $ctrl.startTime && val.startTime.toLocaleString() == $ctrl.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == $ctrl.endDate.toLocaleString() &&
                        ((!val.endTime && !$ctrl.endTime) || (val.endTime && $ctrl.endTime && val.endTime.toLocaleString() == $ctrl.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    $ctrl.exdurations.push(dur);
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            $mdDialog.show(
                $mdDialog.alert()
                    //  .parent(angular.element(document.querySelector('#addExceptionDuration')))
                    .clickOutsideToClose(true)
                    .title('خطا')
                    .textContent(msg)
                    .ariaLabel('error')
                    .ok('بستن')
                    .targetEvent(null)
            );
        }

        function makeDurationObject(ev) {
            $ctrl.endDate = $ctrl.startDate;

            if (!$ctrl.startTime || !$ctrl.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availablityMode: $ctrl.availablityMode,
                    startDate: $ctrl.startDate,
                    endDate: $ctrl.endDate,
                    startTime: $ctrl.startTime,
                    endTime: $ctrl.endTime
                };
            }

        }

        function removeDuration(date) {
            if ($ctrl.exdurations != undefined)
                $ctrl.exdurations = $ctrl.exdurations.filter(function (item) {
                    return item != date;
                });
        }


    }

    var EventExceptionDuration = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/event-exception-duration/partial-form.event-exception-duration.html',
        controller: EventExceptionDurationController,
        bindings: {
            exdurations: '=',
            eventDuration: '=',
        }

    };

    angular
        .module('tikonApp')
        .component('pfEventExceptionDuration', EventExceptionDuration)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    EventExceptionDurationController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog'];


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EditOrderBagServiceItemComponentController', EditOrderBagServiceItemComponentController);

    function EditOrderBagServiceItemComponentController($rootScope, $scope, $state, $stateParams, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, entity, $uibModalInstance) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        if (entity)
            $ctrl.orderBagItem = entity.orderBagItem;
        $ctrl.errorMsg = "";
        $ctrl.successMsg = "";
        $ctrl.mode = 'DEFAULT'
        $ctrl.onItemChanged = onItemChanged;
        // $ctrl.orderBagItem = {};
        $ctrl.save = save;
        $ctrl.cancel = cancel;
        $ctrl.editableOrderBagItem = {};


        $ctrl.closeModal = closeModal;
        $ctrl.okModal = okModal;


        loadAll();
        loadPage();

        function loadAll() {
            if ($ctrl.orderBagItem) {
                $ctrl.editableOrderBagItem = angular.copy($ctrl.orderBagItem);

            }

            // if($ctrl.orderBagItemId )
            // {
            //     OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities($ctrl.orderBagItemId).query().$promise.then(function (result) {
            //
            //         if(result)
            //         {
            //             $ctrl.orderBagItem = result;
            //         }
            //     })
            // }
        }


        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();
        }


        function onItemChanged(item) {

        }

        function save() {
            if ($ctrl.editableOrderBagItem.id) {
                OrderBagServiceItemCustom.editOrderBagServiceItem().save($ctrl.editableOrderBagItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagServiceItemUpdate', result);

            $ctrl.isSaving = false;
            $uibModalInstance.close(result);

        }

        function onSaveError() {
            $ctrl.isSaving = false;

        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }


        function closeModal() {
            cancel();

        }

        function okModal() {
            save();
        }

    }

    var EditOrderBagServiceItemComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
        controller: EditOrderBagServiceItemComponentController,
        bindings:
            {
                orderBagItem: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfEditOrderBagServiceItem', EditOrderBagServiceItemComponent)

    EditOrderBagServiceItemComponentController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', 'entity', '$uibModalInstance'];


})();

;
(function () {
    'use strict';

    function DatePeriodOffDaysController($scope, $state, translate, translatePartialLoader) {
        var $ctrl = this;
        $ctrl.newDate = null;
        $ctrl.offDates = getOffDates();
        $ctrl.onAdddate = onAdddate;
        $ctrl.onRemoveDate = onRemoveDate;

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function onAdddate() {

            if ($ctrl.newDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.offDates, function (val) {
                    if (val.value.toLocaleString() == $ctrl.newDate.toLocaleString()) hasAddedBefore = true;
                });
                if (!hasAddedBefore)
                    $ctrl.offDates.push({name: persianDate.format('DD/ MMMM/YYYY'), value: $ctrl.newDate});
            }
            setOffDate();

        }

        function onRemoveDate(date) {
            if ($ctrl.offDates != undefined)
                $ctrl.offDates = $ctrl.offDates.filter(function (item) {
                    return item.value !== date.value;
                });
            setOffDate();

        }

        $scope.$watch('$ctrl.selectedDatePeriod', function () {
            //   if( $ctrl.selectedDatePeriod.offdays!=undefined) {
            $scope.$watch('$ctrl.selectedDatePeriod.offdays', function () {

                $ctrl.offDates = getOffDates();

            }, true);
            //   }


        }, true);

        function getOffDates() {

            var retOffDates = [];

            if ($ctrl.selectedDatePeriod != undefined && $ctrl.selectedDatePeriod.offdays != undefined) {
                var offDays = $ctrl.selectedDatePeriod.offdays;
                angular.forEach(offDays, function (val) {


                    var now = new Date();
                    now.setDate(now.getDate() - 1);
                    now.setHours(0);
                    now.setMinutes(0);
                    now.setSeconds(0);

                    if (now < new Date(val.offDate)) {
                        var persianDate = new JDate(new Date(val.offDate));
                        retOffDates.push({name: persianDate.format('DD/ MMMM/YYYY'), value: val.offDate});
                    }
                });
            }

            retOffDates.sort(function (a, b) {
                return new Date(a.value) - new Date(b.value);
            });
            return retOffDates;
        }

    }

    var DatePeriodOffDays = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/date-period-off-days/partial-form.date-period-off-days.html',
        controller: DatePeriodOffDaysController,
        bindings: {
            selectedDatePeriod: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfDatePeriodOffDays', DatePeriodOffDays)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    DatePeriodOffDaysController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function CustomerStatisticsV2ComponentController($scope, $state, CustomerCustom, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $stateParams) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.customerStatisticsObject = {};
        $ctrl.customerStatisticsObject.totalReserveNumber = 0;

        loadPage();

        function loadPage() {
            translatePartialLoader.addPart('customerStatistics');

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


        }


        $scope.$watch('$ctrl.selectedCustomerId', function () {
            if ($ctrl.selectedCustomerId) {
                loadCustomerStatistics();
            }
        })


        function loadCustomerStatistics() {
            $ctrl.customerStatisticsObject = CustomerCustom.getCustomerStatisticsV2($ctrl.selectedCustomerId).query();
            if (!$ctrl.customerStatisticsObject)
                $ctrl.customerStatisticsObject = {};

            if (!$ctrl.customerStatisticsObject.totalReserveNumber)
                $ctrl.customerStatisticsObject.totalReserveNumber = 0;

            if (!$ctrl.customerStatisticsObject.totalCanceledNumber)
                $ctrl.customerStatisticsObject.totalCanceledNumber = 0;


        }

    }

    var CustomerStatisticsV2Component = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/customer-statistics-v2/partial-form.customer-statistics-v2.html',
        controller: CustomerStatisticsV2ComponentController,
        bindings:
            {
                selectedCustomerId: '<',
            }

    };

    angular
        .module('tikonApp')
        .component('pfCustomerStatisticsV2', CustomerStatisticsV2Component)

    CustomerStatisticsV2ComponentController.$inject = ['$scope', '$state', 'CustomerCustom', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$stateParams'];


})();

;
(function () {
    'use strict';

    function CustomerStatisticsComponentController($scope, $state, CustomerCustom, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $stateParams) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;


        loadPage();

        function loadPage() {
            translatePartialLoader.addPart('customerStatistics');

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
        }


        $scope.$watch('$ctrl.selectedCustomerId', function () {
            if ($ctrl.selectedCustomerId) {
                loadCustomerStatistics();
            }
        })


        function loadCustomerStatistics() {
            $ctrl.customerStatisticsObject = CustomerCustom.getCustomerStatistics($ctrl.selectedCustomerId).query();
            console.log($ctrl.customerStatisticsObject);
        }

    }

    var CustomerStatisticsComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/customer-statistics/partial-form.customer-statistics.html',
        controller: CustomerStatisticsComponentController,
        bindings:
            {
                selectedCustomerId: '<',
            }

    };

    angular
        .module('tikonApp')
        .component('pfCustomerStatistics', CustomerStatisticsComponent)

    CustomerStatisticsComponentController.$inject = ['$scope', '$state', 'CustomerCustom', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$stateParams'];


})();

;
(function () {
    'use strict';

    function CustomerPickerComponentController($state, $timeout, $scope, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.noCache = false;
        $ctrl.querySearch = querySearch;
        $ctrl.customer_changed = customer_changed;

        $ctrl.newCustomerPopUp = newCustomerPopUp;
        $ctrl.newCustomer = newCustomer;
        $ctrl.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;

        $ctrl.selectedCustomer = null;
        $ctrl.isCustomerManager = false;

        $ctrl.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {
                $ctrl.selectedItem = selectedItem;
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    $ctrl.customer = c;
                    $ctrl.existCustomerSearchResult = [];
                }
            }
        }
        $ctrl.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            $ctrl.isCustomerManager = has;
        });


        loadAll();
        loadPage();

        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {

            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


        }


        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.customers, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.customers;
                }
            })

            return temp;

        }

        function customer_changed(item) {

        }

        function searchCustomerByPhoneNumber() {

            if (!$ctrl.customer.personalInfo.phoneNumber || $ctrl.customer.personalInfo.phoneNumber.length < 6 || $ctrl.customer.personalInfo.phoneNumber.length == 11) {
                $ctrl.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch($ctrl.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                $ctrl.existCustomerSearchResult = result;
            });

        }

        function newCustomer() {
            $ctrl.phoneNumberToFind = "";
            $ctrl.customer = {};
            $ctrl.customerMode = "new";
            $ctrl.myRole = "ROLE_USER";
        }

        function newCustomerPopUp() {

            if ($ctrl.onNewCustomerPopUpClick) {
                $ctrl.onNewCustomerPopUpClick();
                return;
            }

            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                controller: 'CompanyCustomerModalController',
                controllerAs: '$ctrl',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            });

            $rootScope.modalInstance.result.then(function (v) {

                $ctrl.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

    }

    var CustomerPickerComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/customer-picker/partial-form.customer-picker.html',
        controller: CustomerPickerComponentController,
        bindings:
            {
                customer: '=',
                onNewCustomerPopUpClick: "&",
                onCustomerChanged: "&",
                readOnly: '=?',
                showStatistic: '=?'

            }

    };

    angular
        .module('tikonApp')
        .component('pfCustomerPicker', CustomerPickerComponent)

    CustomerPickerComponentController.$inject = ['$state', '$timeout', '$scope', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', '$translate', '$translatePartialLoader'];


})();

;
(function () {
    'use strict';

    function CompanySchedulesController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService, CompanyInfoQuery) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.generateTimeInfo = generateTimeInfo;
        $ctrl.showTimingInfo = showTimingInfo;
        $ctrl.backToScheduleInfo = backToScheduleInfo;
        $ctrl.saveSchedule = saveSchedule;
        $ctrl.schSelected = false;
        $ctrl.schSaved = false;
        $ctrl.step = 0;
        $ctrl.isSaving = false;
        $ctrl.schedulerApi = {refresh: 'not set'};
        $ctrl.hasBaseOffDaySchedule = false;
        $ctrl.defaultBaseOffDayScheduleId = null;
        $ctrl.baseOffDayScheduleSwitch_changed = baseOffDayScheduleSwitch_changed;
        $ctrl.showLimitDates = false;
        $ctrl.showLimitDateChange = showLimitDateChange;


        $ctrl.refreshList = function () {

            $ctrl.scheduleInfos = [];

            CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
                if (comp) {
                    ScheduleInfoCustom.primaryScheduleInfosByCompany(comp.id).query(function (schedules) {
                        $ctrl.scheduleInfos = schedules;
                        if ($ctrl.scheduleInfos.length == 0)
                            $ctrl.newItem();
                        else {
                            if (!$ctrl.selectedId) {
                                // $ctrl.editItem($ctrl.scheduleInfos[0]);
                                editItemV2($ctrl.scheduleInfos[0]);
                            }

                        }
                        // checkShowLimitDates();
                    });


                    ScheduleInfoCustom.getDefaultBaseOffDaySchedule().query().$promise.then(function (sch) {
                        if (sch && sch.id)
                            $ctrl.defaultBaseOffDayScheduleId = sch.id;

                    });


                }
            })
        }

        //
        $ctrl.generateTimesUntil = generateTimesUntil;
        $timeout(function () {
            loadAll();
            loadPage();

        });


        function showTimingInfo() {
            $ctrl.timingInfo = $ctrl.selectedScheduleInfo.timingInfo;
            $ctrl.step = 1;
        }

        $ctrl.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }

        function saveSchedule() {
            $ctrl.selectedScheduleInfo.companyId = $ctrl.companyId;
            $ctrl.isSaving = true;

            if ($ctrl.hasBaseOffDaySchedule && $ctrl.defaultBaseOffDayScheduleId) {
                $ctrl.selectedScheduleInfo.baseOffDayScheduleInfoId = $ctrl.defaultBaseOffDayScheduleId;
            } else {
                $ctrl.selectedScheduleInfo.baseOffDayScheduleInfoId = null;
            }

            TimingInfo.saveScheduleInfoForCompany().save($ctrl.selectedScheduleInfo, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.selectedId = sch.id;
                //  $ctrl.timingInfo = sch.timingInfo;
                $ctrl.step = 1;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                $ctrl.isSaving = false;
                //$ctrl.refreshList();
            });
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate($ctrl.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save($ctrl.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                $ctrl.timingInfo = timingInfo;
                $ctrl.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if ($ctrl.schedulerApi.refreshScheduler)
                $ctrl.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            $ctrl.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            $ctrl.scheduleInfos = [];

            $ctrl.refreshList();
        }

        function newItem() {
            //
            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            $ctrl.selectedScheduleInfo.companyId = $ctrl.companyId;
            $ctrl.schSelected = true;
            $ctrl.schSaved = false;
            updateTabs();

        }

        function editItem(id) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                checkShowLimitDates();

                var now = new Date();
                now.setDate(now.getDate() - 1);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                var tempArr = [];
                angular.forEach($ctrl.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                    if (new Date(exDate.startDate) > now) {
                        tempArr.push(exDate);
                        // var index = $ctrl.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                        //
                        // $ctrl.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                    }
                })
                $ctrl.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;


                if ($ctrl.selectedScheduleInfo && $ctrl.selectedScheduleInfo.baseOffDayScheduleInfo) {
                    $ctrl.hasBaseOffDaySchedule = true;
                }

                updateTabs();
            });

        }

        function editItemV2(sch) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = sch.id;

            $ctrl.selectedScheduleInfo = sch;
            checkShowLimitDates();

            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            angular.forEach($ctrl.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                    // var index = $ctrl.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                    //
                    // $ctrl.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                }
            })
            $ctrl.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
            $ctrl.schSelected = true;
            $ctrl.schSaved = true;


            if ($ctrl.selectedScheduleInfo && $ctrl.selectedScheduleInfo.baseOffDayScheduleInfo) {
                $ctrl.hasBaseOffDaySchedule = true;
            }

            updateTabs();


        }

        function updateTabs() {
            if ($ctrl.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            $ctrl.formState = 'list';
            $ctrl.selectedScheduleId = '';
            $ctrl.refreshList();
        }

        function baseOffDayScheduleSwitch_changed() {


        }

        function showLimitDateChange() {
            if (!$ctrl.showLimitDates) {
                $ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate = null;
                $ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {

            if ($ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate) {
                $ctrl.showLimitDates = true;
                return;
            }

            if ($ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate) {

                var date = new Date();
                var fromDate = new Date($ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate);
                if (fromDate > date)
                    $ctrl.showLimitDates = true;
            }

        }


    }

    var CompanySchedules = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/company-schedules/partial-form.company-schedules.html',
        controller: CompanySchedulesController,
        bindings: {
            companyId: '<',
            selectedScheduleInfo: '='
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfCompanySchedules', CompanySchedules)

    //  CompanySchedulesController.$inject = ['$scope','$attrs','$element'];
    CompanySchedulesController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService', 'CompanyInfoQuery'];


})();

;
(function () {
    'use strict';

    CompanyCustomerV2ComponentController.$inject = [
        '$scope',
        '$state',
        'PersonInfoSearch',
        'ParseLinks',
        'AlertService',
        'paginationConstants',
        '$translate',
        '$translatePartialLoader',
        'CompanyCustomerCustom',
        '$mdDialog',
        'DialogService',
        'CustomerGroupCustom',
        'UserCustom',
        'CustomerCustom',
        'InvoiceInfoCustom',
        'WalletService',
        'AlertToastService',
        '$mdToast',
        '$mdMedia'
    ];

    function CompanyCustomerV2ComponentController(
        $scope,
        $state,
        PersonInfoSearch,
        ParseLinks,
        AlertService,
        paginationConstants,
        $translate,
        $translatePartialLoader,
        CompanyCustomerCustom,
        $mdDialog,
        DialogService,
        CustomerGroupCustom,
        UserCustom,
        CustomerCustom,
        InvoiceInfoCustom,
        WalletService,
        AlertToastService,
        $mdToast,
        $mdMedia
    ) {

        var $ctrl = this;

        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;

        $ctrl.selectedId = '';

        $ctrl.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        $ctrl.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        $ctrl.deleteCustomerFormData = deleteCustomerFormData;
        $ctrl.customerGroupChanged = customerGroupChanged;

        $ctrl.createUser = createUser;
        $ctrl.onInvoiceHistoryTabClick = onInvoiceHistoryTabClick;
        $ctrl.sendWelcomeMessage = sendWelcomeMessage;
        $ctrl.openAddBalanceDialog = openAddBalanceDialog;

        $ctrl.customerFormData = null;
        $ctrl.columnCount = null;
        $ctrl.reserveHistorySearchQuery = null;
        $ctrl.customerStatuses = [
            'NEW_CUSTOMER',
            'VALID_CUSTOMER',
            'BLOCKED_CUSTOMER'
        ];

        $ctrl.user = {};
        $ctrl.hasUser = false;
        $ctrl.existUser = {};
        $ctrl.customerId = null;

        $ctrl.invoiceInfoList = null;
        $ctrl.invoiceHistoryLoaded = false;

        $ctrl.sendWelcomeMessageLoading = false;
        $ctrl.removeCreditLoading = false;

        $ctrl.totalBalance = 0;
        $ctrl.walletTransactions = [];

        if (!$ctrl.companyCustomer) {
            $ctrl.companyCustomer = {};
        }

        initializeFormCollections();

        loadAll();
        loadPage();

        function initializeFormCollections() {
            $ctrl.companyCustomer.singleRecordForms = [];
            $ctrl.companyCustomer.multiRecordForms = [];
            $ctrl.companyCustomer.singleRecordFormDatas = [];
            $ctrl.companyCustomer.multiRecordFormDatas = [];
        }

        function loadAll() {
            initializeFormCollections();

            if ($ctrl.companyCustomer.id) {
                loadCompanyCustomForms();
                loadCompanyCustomFormData();
                loadCustomerUserInfo();
            } else {
                initNewCustomerIntakeData();
            }

            loadAllCustomerGroups();
            loadCustomerWalletData();
        }

        function loadCompanyCustomForms() {
            var companyId = $ctrl.companyCustomer.companyId;

            if (!companyId) {
                return;
            }

            $ctrl.companyCustomer.forms =
                CompanyCustomerCustom
                    .getCompanyCustomForm(companyId)
                    .query(
                        function (forms) {
                            angular.forEach(forms, function (item) {
                                if (item.recordType === 'SINGLE_RECORD') {
                                    $ctrl.companyCustomer.singleRecordForms.push(item);
                                } else {
                                    $ctrl.companyCustomer.multiRecordForms.push(item);
                                }
                            });
                        },
                        handleRequestError
                    );
        }

        function loadCompanyCustomFormData() {
            CompanyCustomerCustom
                .getCompanyCustomFormDataByCompanyCustomerId(
                    $ctrl.companyCustomer.id
                )
                .query()
                .$promise
                .then(function (res) {
                    $ctrl.companyCustomer.singleRecordFormDatas = [];
                    $ctrl.companyCustomer.multiRecordFormDatas = [];
                    $ctrl.companyCustomer.formsData = res || [];

                    $ctrl.companyCustomer.formsData.sort(function (a, b) {
                        return b.id - a.id;
                    });

                    angular.forEach(
                        $ctrl.companyCustomer.formsData,
                        function (item) {
                            if (
                                !item.companyCustomForm ||
                                !item.companyCustomForm.recordType
                            ) {
                                return;
                            }

                            if (
                                item.companyCustomForm.recordType ===
                                'SINGLE_RECORD'
                            ) {
                                $ctrl.companyCustomer.singleRecordFormDatas.push(
                                    item
                                );

                                removeSingleRecordButton(
                                    item.companyCustomForm
                                );
                            } else {
                                $ctrl.companyCustomer.multiRecordFormDatas.push(
                                    item
                                );
                            }
                        }
                    );
                })
                .catch(handleRequestError);
        }

        function removeSingleRecordButton(companyCustomForm) {
            if (!companyCustomForm || !companyCustomForm.id) {
                return;
            }

            $ctrl.companyCustomer.singleRecordForms =
                $ctrl.companyCustomer.singleRecordForms.filter(
                    function (item) {
                        return item.id !== companyCustomForm.id;
                    }
                );
        }

        function loadPage() {
            $translatePartialLoader.addPart('personInfo');
            $translatePartialLoader.addPart('locationInfo');
            $translatePartialLoader.addPart('global');
            $translatePartialLoader.addPart('servant');
            $translatePartialLoader.addPart('customerStatus');

            $translate.refresh();
        }

        function getCompanyCustomerFormDataFunc(
            companyCustomFormId,
            companyCustomFormTitle
        ) {
            if (!companyCustomFormId) {
                return;
            }

            CompanyCustomerCustom
                .getNewCompanyCustomerFormData(companyCustomFormId)
                .query(
                    function (res) {
                        $ctrl.customerFormData = res;
                        $ctrl.customerFormData.companyCustomFormTitle =
                            companyCustomFormTitle;
                        $ctrl.customerFormData.companyCustomer =
                            $ctrl.companyCustomer;

                        openEditDataDialog($ctrl.customerFormData);
                    },
                    handleRequestError
                );
        }

        function editCompanyCustomerFormDataFunc(
            companyCustomFormId,
            companyCustomFormTitle,
            data
        ) {
            if (!data) {
                return;
            }

            $ctrl.customerFormData = angular.copy(data);
            $ctrl.customerFormData.companyCustomFormTitle =
                companyCustomFormTitle;
            $ctrl.customerFormData.companyCustomerId =
                $ctrl.companyCustomer.id;

            if (!$ctrl.customerFormData.companyCustomer) {
                $ctrl.customerFormData.companyCustomer =
                    $ctrl.companyCustomer;
            }

            openEditDataDialog($ctrl.customerFormData);
        }

        function openEditDataDialog(customerFormData) {
            if (!customerFormData) {
                return;
            }

            $ctrl.columnCount = 4;

            $mdDialog.show({
                locals: {
                    dialogData: customerFormData,
                    columnCount: $ctrl.columnCount
                },
                controller: ComponentIntakeDataDialogController,
                templateUrl:
                    'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
                controllerAs: '$ctrl',
                targetEvent: null,
                clickOutsideToClose: true
            });
        }

        function deleteCustomerFormData(formData) {
            if (!formData || !formData.id) {
                return;
            }

            DialogService
                .showConfirm(
                    'آیا از حذف اطلاعات مورد نظر اطمینان دارید؟'
                )
                .then(function () {
                    CompanyCustomerCustom
                        .companyCustomerFormData()
                        .delete(
                            {
                                id: formData.id
                            },
                            function () {
                                loadAll();
                            },
                            handleRequestError
                        );
                });
        }

        function loadAllCustomerGroups() {
            CustomerGroupCustom
                .getCustomerGroupsByCurrentCompany()
                .query()
                .$promise
                .then(function (items) {
                    $ctrl.customerGroups = items || [];
                })
                .catch(handleRequestError);
        }

        function customerGroupChanged() {
            if (
                $ctrl.companyCustomer.customerGroup &&
                $ctrl.companyCustomer.customerGroup.id === 1
            ) {
                $ctrl.companyCustomer.customerGroup = null;
            }
        }

        function initNewCustomerIntakeData() {
            CompanyCustomerCustom
                .getEmptyCompanyCustomerIntakeData()
                .query()
                .$promise
                .then(function (res) {
                    if (res) {
                        $ctrl.companyCustomer.customerIntakeData = res;
                    }
                })
                .catch(handleRequestError);
        }

        function createUser() {
            if (!$ctrl.companyCustomer.id) {
                return;
            }

            UserCustom
                .createUserByAdmin()
                .save(
                    $ctrl.companyCustomer,
                    function () {
                        loadAll();
                    },
                    handleRequestError
                );
        }

        function loadCustomerUserInfo() {
            var customerId = getCustomerId();

            if (!customerId) {
                return;
            }

            CustomerCustom
                .getCustomerUserInfoByCustomerId(customerId)
                .query()
                .$promise
                .then(function (res) {
                    $ctrl.existUser = res || {};
                    $ctrl.hasUser = Boolean($ctrl.existUser.id);
                })
                .catch(function (error) {
                    $ctrl.existUser = {};
                    $ctrl.hasUser = false;
                    handleRequestError(error);
                });
        }

        function onInvoiceHistoryTabClick() {
            if (!$ctrl.invoiceInfoList) {
                getInvoiceInfos();
            }
        }

        function getInvoiceInfos() {
            var customerId = getCustomerId();

            if (!customerId) {
                return;
            }

            InvoiceInfoCustom
                .getInvoiceByCustomerId(customerId)
                .query(
                    function (data) {
                        $ctrl.invoiceInfoList = data || [];
                        $ctrl.invoiceHistoryLoaded = true;
                    },
                    function (error) {
                        $ctrl.invoiceHistoryLoaded = true;
                        handleRequestError(error);
                    }
                );
        }

        function sendWelcomeMessage() {
            if (!$ctrl.companyCustomer.id) {
                return;
            }

            $ctrl.sendWelcomeMessageLoading = true;

            CompanyCustomerCustom
                .sendWelcomeMessage($ctrl.companyCustomer.id)
                .save(
                    {},
                    function () {
                        $ctrl.sendWelcomeMessageLoading = false;
                    },
                    function (error) {
                        $ctrl.sendWelcomeMessageLoading = false;
                        handleRequestError(error);
                    }
                );
        }

        function loadCustomerWalletData() {
            var customerId = getCustomerId();

            if (!customerId) {
                $ctrl.totalBalance = 0;
                $ctrl.walletTransactions = [];
                return;
            }

            getCustomerWalletByCustomerId(customerId);
            getWalletCreditOfCustomerId(customerId);
        }

        function getCustomerWalletByCustomerId(customerId) {
            WalletService
                .getCustomerWalletByCustomerId(customerId)
                .query(
                    function (data) {
                        $ctrl.totalBalance =
                            data && data.totalBalance
                                ? data.totalBalance
                                : 0;
                    },
                    handleRequestError
                );
        }

        function getWalletCreditOfCustomerId(customerId) {
            WalletService
                .getCreditOfCusomerId(customerId)
                .query(
                    function (data) {
                        $ctrl.walletTransactions =
                            data && data.content
                                ? data.content
                                : [];
                    },
                    handleRequestError
                );
        }

        function openAddBalanceDialog() {
            var customerId = getCustomerId();
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            if (!customerId) {
                return;
            }

            $mdDialog
                .show({
                    templateUrl:
                        'app/components/partial-forms/wallet/wallet-add-balance-dialog.html',
                    controller: [
                        '$scope',
                        'customerId',
                        function ($scope, customerId) {
                            $scope.customerId = customerId;
                        }
                    ],
                    locals: {
                        customerId: customerId
                    },
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
                .then(function (res) {
                    if (res && res.amount) {
                        $ctrl.totalBalance += res.amount;
                    }

                    // getCustomerWalletByCustomerId(customerId);
                    getWalletCreditOfCustomerId(customerId);
                });
        }

        function getCustomerId() {
            if (
                !$ctrl.companyCustomer ||
                !$ctrl.companyCustomer.customer
            ) {
                return null;
            }

            return $ctrl.companyCustomer.customer.id || null;
        }

        function handleRequestError(error) {
            console.error('Company customer request failed:', error);
        }

        ComponentIntakeDataDialogController.$inject = [
            '$scope',
            '$mdDialog',
            'dialogData',
            'columnCount'
        ];

        function ComponentIntakeDataDialogController(
            $scope,
            $mdDialog,
            dialogData,
            columnCount
        ) {
            var $ctrl2 = this;

            $ctrl2.customerFormData = dialogData;
            $ctrl2.columnCount = columnCount;
            $ctrl2.sidebarStatus =
                localStorage.getItem('userFavoriteSideMenu');

            $ctrl2.save = save;
            $ctrl2.cancel = cancel;
            $ctrl2.getContainerClass = getContainerClass;

            function save() {
                if (
                    !$ctrl2.customerFormData ||
                    !$ctrl2.customerFormData.companyCustomer
                ) {
                    return;
                }

                $ctrl2.customerFormData.companyCustomer.formsData = null;

                if (!$ctrl2.customerFormData.intakeData) {
                    CompanyCustomerCustom
                        .companyCustomerFormData()
                        .save(
                            $ctrl2.customerFormData,
                            saveSuccess,
                            handleRequestError
                        );
                } else {
                    CompanyCustomerCustom
                        .companyCustomerFormData()
                        .update(
                            $ctrl2.customerFormData,
                            saveSuccess,
                            handleRequestError
                        );
                }
            }

            function saveSuccess() {
                loadAll();
                $mdDialog.hide();
            }

            function cancel() {
                $mdDialog.cancel();
            }

            function getContainerClass() {
                if ($ctrl2.sidebarStatus === 'close') {
                    return 'container-wide';
                }

                if ($ctrl2.sidebarStatus === 'open') {
                    return 'container-small';
                }

                return '';
            }
        }
        
        $scope.getDynamicStyleRemoveIcon = function(tx) {
            var color = "red";
            if(tx.sourceType !== 'MANUAL') color = "unset";
            return {
                color: color
            };
        }

        $ctrl.deleteCredit = function(tx) {
            var customerId = getCustomerId()
            if(tx.sourceType !== 'MANUAL' || $ctrl.removeCreditLoading || !customerId) return
           
            DialogService
                .showConfirm('آیا از حذف این اعتبار اطمینان دارید؟')
                .then(
                    function () {
                        $ctrl.removeCreditLoading = true;
                        WalletService
                            .deleteCredit(customerId, tx.id)
                            .delete(
                                function (res) {
                                    $ctrl.removeCreditLoading = false;
                                    if (res && res.result === 'SUCCESS') {
                                        $ctrl.totalBalance =
                                            res.remainingBalance || 0;
                                        getWalletCreditOfCustomerId(customerId);
                                        $mdToast.show(
                                            $mdToast
                                                .simple()
                                                .textContent(
                                                    'مبلغ مورد نظر با موفقیت از اعتبار کم شد'
                                                )
                                                .position('top left')
                                                .hideDelay(4000)
                                                .theme('success-toast')
                                        );

                                        return;
                                    }

                                    handleRequestError(res);
                                },
                                function (err) {
                                    $ctrl.removeCreditLoading = false;
                                    handleRequestError(err);
                                }
                            );
                    },
                    function () {
                        /*
                        * کاربر دیالوگ را لغو/بسته است.
                        * نیاز به انجام کاری نیست.
                        */
                    }
                );

        }
    }

    var CompanyCustomerV2Component = {
        templateUrl:
            'app/components/partial-forms/company-customer-v2/partial-form.company-customer-v2.html',
        controller: CompanyCustomerV2ComponentController,
        bindings: {
            companyCustomer: '=',
            mode: '=',
            canSave: '='
        }
    };

    angular
        .module('tikonApp')
        .component(
            'pfCompanyCustomerV2',
            CompanyCustomerV2Component
        );

})();;
(function () {
    'use strict';

    function CompanyCustomerComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, CompanyCustomerCustom, $mdDialog, DialogService, CustomerGroupCustom, UserCustom, CustomerCustom) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';

        $ctrl.loadAll = loadAll;

        $ctrl.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        $ctrl.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        $ctrl.customerFormData = null;
        $ctrl.columnCount = null;
        $ctrl.companyCustomer.singleRecordForms = [];
        $ctrl.companyCustomer.multiRecordForms = [];

        $ctrl.companyCustomer.singleRecordFormDatas = [];
        $ctrl.companyCustomer.multiRecordFormDatas = [];

        $ctrl.deleteCustomerFormData = deleteCustomerFormData;
        $ctrl.customerGroupChanged = customerGroupChanged;
        $ctrl.customerStatuses = ["NEW_CUSTOMER", "VALID_CUSTOMER", "BLOCKED_CUSTOMER"];

        $ctrl.reserveHistorySearchQuery = null;

        $ctrl.createUser = createUser;
        $ctrl.user = {};
        $ctrl.hasUser = false;
        $ctrl.existUser = {};


        loadAll();
        loadPage();

        function loadAll() {
            $ctrl.companyCustomer.singleRecordForms = [];
            $ctrl.companyCustomer.multiRecordForms = [];
            // $ctrl.companyCustomer.forms = [];

            if ($ctrl.companyCustomer && $ctrl.companyCustomer.id) {
                $ctrl.companyCustomer.forms = CompanyCustomerCustom.getCompanyCustomForm($ctrl.companyCustomer.companyId).query(function (forms) {
                    angular.forEach(forms, function (item) {
                        if (item.recordType && item.recordType == 'SINGLE_RECORD') {
                            $ctrl.companyCustomer.singleRecordForms.push(item);
                        } else {
                            $ctrl.companyCustomer.multiRecordForms.push(item);
                        }

                    })


                });

                CompanyCustomerCustom.getCompanyCustomFormDataByCompanyCustomerId($ctrl.companyCustomer.id).query().$promise.then(function (res) {


                    $ctrl.companyCustomer.singleRecordFormDatas = [];
                    $ctrl.companyCustomer.multiRecordFormDatas = [];
                    $ctrl.companyCustomer.formsData = res;
                    $ctrl.companyCustomer.formsData.sort(function (a, b) { //to sort by id desc
                        return b.id - a.id;
                    });

                    angular.forEach($ctrl.companyCustomer.formsData, function (item) {

                        if (item.companyCustomForm.recordType == 'SINGLE_RECORD') {
                            $ctrl.companyCustomer.singleRecordFormDatas.push(item);
                            removeSingleRecordButton(item.companyCustomForm);
                        } else {
                            $ctrl.companyCustomer.multiRecordFormDatas.push(item);
                        }

                    })

                });
            }

            loadAllCustomerGroups();
            if (!$ctrl.companyCustomer.id) {
                initNewCustomerIntakeData();
            }

            // has user
            if ($ctrl.companyCustomer.id && $ctrl.companyCustomer.customer.id) {
                CustomerCustom.getCustomerUserInfoByCustomerId($ctrl.companyCustomer.customer.id).query().$promise.then(function (res) {
                        $ctrl.existUser = res;
                        if ($ctrl.existUser.id)
                            $ctrl.hasUser = true;
                        else
                            $ctrl.hasUser = false;
                    }
                )
            }

        }


        function removeSingleRecordButton(companyCustomForm) {

            $ctrl.companyCustomer.singleRecordForms = $ctrl.companyCustomer.singleRecordForms.filter(function (item) {
                return item.id != companyCustomForm.id;
            })
        }

        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader = translate.refresh();
        }


        function getCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle) {


            CompanyCustomerCustom.getNewCompanyCustomerFormData(companyCustomFormId).query(function (res) {

                $ctrl.customerFormData = res;
                $ctrl.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
                $ctrl.customerFormData.companyCustomer = $ctrl.companyCustomer;
                openEditDataDialog($ctrl.customerFormData);

            });
        }

        function editCompanyCustomerFormDataFunc(companyCustomFormId, companyCustomFormTitle, data) {

            $ctrl.customerFormData = data;
            $ctrl.customerFormData.companyCustomFormTitle = companyCustomFormTitle;
            $ctrl.customerFormData.companyCustomerId = $ctrl.companyCustomer.id;
            openEditDataDialog($ctrl.customerFormData);
        }

        function openEditDataDialog(customerFormData) {


            $ctrl.columnCount = 4;
            $mdDialog.show({
                locals: {dialogData: customerFormData, columnCount: $ctrl.columnCount},
                controller: ComponentIntakeDataDialogController,
                templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
                controllerAs: '$ctrl',
                // parent: angular.element(document.body),
                targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });
        };

        function deleteCustomerFormData(formData) {

            DialogService.showConfirm("آیا از حذف اطلاعات مورد نظر اطمینان دارید؟").then(function () {
                CompanyCustomerCustom.companyCustomerFormData().delete({id: formData.id},
                    function () {
                        loadAll();
                    });

            });
        }


        function loadAllCustomerGroups() {


            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (items) {

                $ctrl.customerGroups = items;
            });
        }

        function customerGroupChanged() {
            if ($ctrl.companyCustomer.customerGroup.id == 1) {
                $ctrl.companyCustomer.customerGroup = null;
            }
        }

        function initNewCustomerIntakeData() {
            CompanyCustomerCustom.getEmptyCompanyCustomerIntakeData().query().$promise.then(function (res) {

                if (res) {
                    $ctrl.companyCustomer.customerIntakeData = res;
                }

            });
        }

        function createUser() {
            if ($ctrl.companyCustomer && $ctrl.companyCustomer.id) {
                UserCustom.createUserByAdmin().save($ctrl.companyCustomer, function (result) {
                    loadAll();
                });
            }
        }

        ComponentIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'columnCount'];

        function ComponentIntakeDataDialogController($scope, $mdDialog, dialogData, columnCount) {

            var $ctrl2 = this;
            $ctrl2.customerFormData = dialogData;
            $ctrl2.columnCount = null;
            $ctrl2.columnCount = columnCount;
            $ctrl.sidebarStatus = localStorage.getItem("userFavoriteSideMenu");


            $ctrl2.save = function () {

                // $ctrl2.customerFormData.companyCustomerId = vm.companyCustomer.id;
                // $ctrl2.customerFormData.companyCustomer = vm.companyCustomer;

                $ctrl2.customerFormData.companyCustomer.formsData = null;
                // $ctrl2.customerFormData.companyCustomForm = $ctrl.companyCustomer.forms[0];
                if (!$ctrl2.customerFormData.intakeData) {

                    CompanyCustomerCustom.companyCustomerFormData().save($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                } else {

                    CompanyCustomerCustom.companyCustomerFormData().update($ctrl2.customerFormData, function (result) {
                        loadAll();
                    });

                }

                $mdDialog.hide();

            };

            $ctrl2.cancel = function () {
                $mdDialog.cancel();
            };

            $ctrl2.getContainerClass = function () {
                if ($ctrl.sidebarStatus == 'close')
                    return 'container-wide';
                if ($ctrl.sidebarStatus == 'open')
                    return 'container-small';
            }


        }


        // $scope.$watch('$ctrl.companyCustomer',function(companyCustomer){
        //
        //     if($ctrl.mode=='NEW')
        //         return;
        //     if(companyCustomer && companyCustomer.id)
        //     {
        //         $ctrl.companyCustomer = companyCustomer;
        //         loadAll();
        //     }
        //
        // })


    }

    var CompanyCustomerComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/company-customer/partial-form.company-customer.html',
        controller: CompanyCustomerComponentController,
        bindings:
            {
                companyCustomer: '=',
                mode: "=",
                canSave: "=",
                isPopUp: "=?"
            }

    };

    angular
        .module('tikonApp')
        .component('pfCompanyCustomer', CompanyCustomerComponent)

    CompanyCustomerComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'CompanyCustomerCustom', '$mdDialog', 'DialogService', 'CustomerGroupCustom', 'UserCustom', 'CustomerCustom'];


})();

;
(function () {
    'use strict';

    function ActivityTypeSelectorComponentController($scope, $state, ActivityTypeInfo, ActivityTypeInfoCustom) {
        //

        var $ctrl = this;
        $ctrl.activityTypes = [];
        $ctrl.loadAll = loadAll;

        loadAll();

        function loadAll() {
            loadAllActivityTypes();
        }

        function loadAllActivityTypes() {

            ActivityTypeInfoCustom.getAllActivityTypeInfos().query(function (result) {
                $ctrl.activityTypes = result;
                categorizeActivityTypes();
            });
        }

        function categorizeActivityTypes() {

            $ctrl.typeCategories = [];

            $ctrl.beauty = {};
            $ctrl.beauty.title = 'زیبایی';
            $ctrl.beauty.items = [];

            $ctrl.health = [];
            $ctrl.health.title = 'سلامتی';
            $ctrl.health.items = [];

            $ctrl.serviceBase = [];
            $ctrl.serviceBase.title = 'خدماتی';
            $ctrl.serviceBase.items = [];

            $ctrl.education = [];
            $ctrl.education.title = 'آموزشی';
            $ctrl.education.items = [];

            $ctrl.entertainment = [];
            $ctrl.entertainment.title = 'تفریحی ورزشی';
            $ctrl.entertainment.items = [];

            $ctrl.enterprise = [];
            $ctrl.enterprise.title = 'سازمان و شرکت';
            $ctrl.enterprise.items = [];

            if ($ctrl.activityTypes) {
                angular.forEach($ctrl.activityTypes, function (item) {

                    switch (item.category) {
                        case 'BEAUTY' :
                            $ctrl.beauty.items.push(item);
                            break;
                        case 'HEALTH' :
                            $ctrl.health.items.push(item);
                            break;
                        case 'EDUCATION' :
                            $ctrl.education.items.push(item);
                            break;
                        case 'ENTERTAINMENT' :
                            $ctrl.entertainment.items.push(item);
                            break;
                        case 'SERVICE_BASE' :
                            $ctrl.serviceBase.items.push(item);
                            break;
                        case 'ENTERPRISE' :
                            $ctrl.enterprise.items.push(item);
                            break;

                    }
                })

                $ctrl.typeCategories.push($ctrl.beauty);
                $ctrl.typeCategories.push($ctrl.health);
                $ctrl.typeCategories.push($ctrl.serviceBase);
                $ctrl.typeCategories.push($ctrl.education);
                $ctrl.typeCategories.push($ctrl.enterprise);
                $ctrl.typeCategories.push($ctrl.entertainment);


            }
        }

    }

    var ActivityTypeSelectorComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/activity-type-selector/partial-form.activity-type-selector.html',
        controller: ActivityTypeSelectorComponentController,
        bindings:
            {
                activityType: '=',
                isRequired: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfActivityTypeSelector', ActivityTypeSelectorComponent)

    ActivityTypeSelectorComponentController.$inject = ['$scope', '$state', 'ActivityTypeInfo', 'ActivityTypeInfoCustom'];


})();

;

(function () {
    'use strict';

    angular.module('tikonApp')
        .controller('EducationMovieController', EducationMovieController);

    EducationMovieController.$inject = ['$uibModalInstance', 'link', '$sce'];

    function EducationMovieController($uibModalInstance, link, $sce) {
        var vm = this;

        vm.closeModal = closeModal;
        vm.link = $sce.trustAsHtml(link)

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService($uibModal) {
        var afterLogin;
        var service = {
            open: open
        };

        var modalInstance = null;

        var resetModal = function () {
            modalInstance = null;
            if (afterLogin)
                afterLogin();
        };

        return service;

        function open(then) {
            afterLogin = then;
            //
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['__config', '$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'CompanyInfoQuery', 'PushNotificationService', 'DeviceService', '$location', '$localStorage'];

    function LoginController(__config, $rootScope, $state, $timeout, Auth, $uibModalInstance, CompanyInfoQuery, PushNotificationService, DeviceService, $location, $localStorage) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.rememberMe = false;
        vm.__config = __config;


        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {

            event.preventDefault();
            if (vm.username != null && vm.username != undefined) {
                vm.username = vm.username.toLowerCase();

            }
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                captchaCode: vm.captchaCode
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();

                var currentCompany = null;
                $rootScope.$broadcast('authenticationSuccess');
                $rootScope.$broadcast('resetToggleSideMenu');

                CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                    if (company != null && company != undefined) {
                        currentCompany = company;
                        if (company.status != "ACTIVE") {
                            PushNotificationService.initPushNotification()
                            if (company.appVersion && company.appVersion == 'v3')
                                $state.go('supplierPanel-v2.companySubscriptionStatusV2');
                            else
                                $state.go('supplierPanel.companySubscriptionStatusV2');
                            return;
                        }

                        if (!company.title) {
                            $state.go('initSetupWizardV2');
                            return;
                        }


                    }

                    if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                        $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                        $state.current.name === 'home' || $state.current.name == 'activeUserAccount' ||
                        $state.current.name === 'createUserAccount' ||
                        $state.current.name === 'confirmSubscription' ||
                        $state.current.name === 'resetPasswordByPhoneNumber'

                    ) {
                        PushNotificationService.initPushNotification()
                        if (currentCompany && currentCompany.appVersion && currentCompany.appVersion == 'v3')
                            $state.go('supplierPanel-v2.dashboard');
                        else
                            $state.go('supplierPanel.dashboard');
                        return;
                    }


                })

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (response) {

                if (response.status == '423') {
                    $uibModalInstance.dismiss('cancel');
                    $state.go('activeUserAccount', {userName: vm.username});
                }
                vm.authenticationError = true;
            });
        }

        function register() {
            var type = ''
            if($localStorage.isNativeApp == "true"){
                type = "android"
            }
            $uibModalInstance.dismiss('cancel');
            $state.go('createUserAccount', { referralCode: type });

        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            //$state.go('requestReset');
            $state.go('resetPasswordByPhoneNumber');
        }
    }
})();
;
/**
 * Created by saeed on 25/01/2018.
 */

//var GoogleAuth;
//var SCOPE = 'https://www.googleapis.com/auth/drive.metadata.readonly';
//$(document).ready(function(){
//
//    handleClientLoad();
//})
//function handleClientLoad() {
//    // Load the API's client and auth2 modules.
//    // Call the initClient function after the modules load.
//
//    gapi.load('client:auth2', initClient);
//}
//
//function initClient() {
//
//    // Retrieve the discovery document for version 3 of Google Drive API.
//    // In practice, your app can retrieve one or more discovery documents.
//    var discoveryUrl = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';
//
//    // Initialize the gapi.client object, which app uses to make API requests.
//    // Get API key and client ID from API Console.
//    // 'scope' field specifies space-delimited list of access scopes.
//    gapi.client.init({
//        'apiKey': 'AIzaSyDNt3-LItURGrIguKe0PnmVH6UZ1kJqsR0',
//        'discoveryDocs': [discoveryUrl],
//        'clientId': '26554230915-f6jfkijap7k1arflsi80278isjjhmqko.apps.googleusercontent.com',
//        'scope': SCOPE
//    }).then(function () {
//        alert('successful init')
//        GoogleAuth = gapi.auth2.getAuthInstance();
//
//        // Listen for sign-in state changes.
//        GoogleAuth.isSignedIn.listen(updateSigninStatus);
//
//        // Handle initial sign-in state. (Determine if user is already signed in.)
//        var user = GoogleAuth.currentUser.get();
//        setSigninStatus();
//
//        // Call handleAuthClick function when user clicks on
//        //      "Sign In/Authorize" button.
//        $('#sign-in-or-out-button').click(function() {
//
//        });
//        $('#revoke-access-button').click(function() {
//            revokeAccess();
//        });
//    });
//}
//
//function handleAuthClick() {
//
//    if (GoogleAuth.isSignedIn.get()) {
//        // User is authorized and has clicked 'Sign out' button.
//        GoogleAuth.signOut();
//    } else {
//        // User is not signed in. Start Google auth flow.
//        GoogleAuth.signIn();
//    }
//}
//
//function revokeAccess() {
//    GoogleAuth.disconnect();
//}
//
//function setSigninStatus(isSignedIn) {
//    var user = GoogleAuth.currentUser.get();
//    var isAuthorized = user.hasGrantedScopes(SCOPE);
//    if (isAuthorized) {
//        $('#sign-in-or-out-button').html('Sign out');
//        $('#revoke-access-button').css('display', 'inline-block');
//        $('#auth-status').html('You are currently signed in and have granted ' +
//            'access to this app.');
//    } else {
//        $('#sign-in-or-out-button').html('Sign In/Authorize');
//        $('#revoke-access-button').css('display', 'none');
//        $('#auth-status').html('You have not authorized this app or you are ' +
//            'signed out.');
//    }
//}
//
//function updateSigninStatus(isSignedIn) {
//    setSigninStatus();
//}
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage(languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
                'en',
                'tr',
                'zu',
                'pl'
                // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
            ]
        );
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('showValidation', showValidation);

    function showValidation() {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element) {
            element.find('.form-group').each(function () {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function () {
                        var $input = angular.element(this);
                        scope.$watch(function () {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function (isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('minbytes', minbytes);

    function minbytes() {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('maxbytes', maxbytes);

    function maxbytes() {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function () {
    'use strict';
    EO_TimeRangeV2Controller.$inject = ['$scope', '$attrs', '$element'];

    function EO_TimeRangeV2Controller($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.disableEndTime = false;
        $ctrl.allDay = false;
        $ctrl.allDay_changed = allDay_changed;


        if ($ctrl.lockEndTime != undefined && $ctrl.lockEndTime) {
            $ctrl.disableEndTime = true;
        }

        function allDay_changed() {
            if ($ctrl.allDay) {
                var startTimeValue = new Date(1970, 0, 1, 0, 0, 0);
                var endTimeValue = new Date(1970, 0, 1, 23, 59, 0);

                $ctrl.startTime = startTimeValue;
                $ctrl.endTime = endTimeValue;
            } else {
                var startTimeValue = new Date(1970, 0, 1, 8, 0, 0);
                var endTimeValue = new Date(1970, 0, 1, 17, 0, 0);

                $ctrl.startTime = startTimeValue;
                $ctrl.endTime = endTimeValue;
            }
        }


        $scope.$watch('$ctrl.startTime', function () {

            if ($ctrl.duration && $ctrl.startTime) {
                $ctrl.endTime = moment($ctrl.startTime).add($ctrl.duration, 'm').toDate();
            }
        });

    }


    var EO_TimeRangeV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/time-range-v2/eyeson.time-range-v2.template.html',
        controller: EO_TimeRangeV2Controller,
        bindings: {
            startTime: '=',
            endTime: '=',
            duration: '=?',
            lockEndTime: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('eoTimeRangeV2', EO_TimeRangeV2)


})();

;
(function () {
    'use strict';
    EO_TimeRangeController.$inject = ['$scope', '$attrs', '$element'];

    function EO_TimeRangeController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.disableEndTime = false;

        if ($ctrl.lockEndTime != undefined && $ctrl.lockEndTime) {
            $ctrl.disableEndTime = true;
        }


        $scope.$watch('$ctrl.startTime', function () {

            if ($ctrl.duration && $ctrl.startTime) {
                $ctrl.endTime = moment($ctrl.startTime).add($ctrl.duration, 'm').toDate();
            }
            // if (momentTime && $ctrl.momentTime!=$ctrl.init_momentTime) {
            //     var hour = momentTime.split(":")[0].trim();
            //     var min = momentTime.split(":")[1].trim();
            //     $ctrl.timeValue = new Date(1970, 0, 1, hour, min, 0);
            //     if($ctrl.selectedTime)
            //         $ctrl.timeValue=$ctrl.selectedTime;
            //
            //
            // }
        });

    }


    var EO_TimeRange = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/time-range/eyeson.time-range.template.html',
        controller: EO_TimeRangeController,
        bindings: {
            startTime: '=',
            endTime: '=',
            duration: '=?',
            lockEndTime: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('eoTimeRange', EO_TimeRange)


})();

//angular.module('tikonApp').directive('eoTimeRange',['$timeout', function ($timeout) {
//        return {
//            restrict: 'E',
//            templateUrl: 'app/components/eyeson/time-range/eyeson.time-range.template.html',
//
//            //   template: '<input class="datePickerClass" />',
//            scope: {
//                startTime:'=',
//                endTime:'='
//
//
//            },
//            link: function (scope, element, attributes) {
//
//                var el = $(element);
//                scope.inited=false;
//
//
//                scope.$watch('startTime', function (timeValue) {
//              //     scope.slider.minValue=TimeToValue( timeValue);
//                 //  initSlider();
//                });
//                scope.$watch('endTime', function (timeValue) {
//               //     scope.slider.maxValue=TimeToValue( timeValue);
//                 //   initSlider();
//                });
//                function initSlider(){
//                    scope.dstartTime=TimeToValue(scope.startTime);
//                    scope.dendTime=TimeToValue(scope.endTime);
//                    if(scope.dendTime==0)scope.dendTime=24*60;
//                    $timeout(function(){
//                        scope.slider = {
//
//                            options: {
//                                floor: 0,
//                                ceil: 24*60,
//                                step:15,
//                                noSwitching: true,
//                                minRange: 120,
//                                from: 'white',
//                                to: '#FC0',
//                                showTicks: false,
//                                //id: value,
//                                onStart: function(id) {
//
//                                },
//                                onChange: function(id) {
//
//
//                                },
//                                onEnd: function(sliderId, modelValue, highValue, pointerType) {
//                                    scope.startTime=(ValueToTime(modelValue));
//                                    scope.endTime=(ValueToTime(highValue));
//                                    scope.$apply();
//
//                                },
//
//                                translate: function(value, sliderId, label) {
//                                  //  console.log(sliderId);
//                                    var intValue=value;
//                                    var hour= Math.floor( value/60);
//                                    var hourstr=hour;
//                                    if(hour<10)hourstr='0'+hourstr;
//                                    var min= value%60;
//                                    var minstr=min;
//                                    if(min<10)minstr='0'+minstr;
//                                    value= hourstr+':'+minstr;
//
//                                    switch (label) {
//                                        case 'model':
//
//                                           //this.startTime=ValueToTime(intValue);
//                                            return '<div style="text-align: center" ><b>ساعت شروع</b><br/> ' + value + "</div>";
//                                         break;
//                                        case 'high':
//                                            //this.endTime=ValueToTime(intValue);
//                                            return '<div style="text-align: center" ><b>ساعت پایان</b><br/> ' + value+"</div>";;
//                                        default:
//
//                                            return  value
//                                    }
//                                    return value;
//
//
//
//                                }
//                            }
//                        };
//
//
//
//                    },0);
//                    $timeout(function(){
//                        scope.inited=true;
//
//                        scope.$broadcast('rzSliderForceRender');
//
//
//                    },500);
//
//                }
//                function onRangeCanged()
//                {
//
//                    scope.$apply();
//                }
//                function ValueToTime(value)
//                {
//                    var hour= Math.floor( value/60);
//                    var min= value%60;
//                    return new Date(1970, 0, 1, hour, min, 0);
//
//                }
//                function  TimeToValue(timeValue)
//                {
//                    var timeValueStr =15;
//                    var temp = new Date(timeValue);
//                    if (temp != 'Invalid Date') {
//
//                        timeValueStr = temp.getHours()*60 + temp.getMinutes();
//                    }
//
//                    return timeValueStr
//                }
//            }
//        };
//    }]
//);
;
(function () {
    'use strict';
    EO_TimePickerController.$inject = ['$scope', '$attrs', '$element'];

    function EO_TimePickerController($scope, $attrs, $element) {
//
        var $ctrl = this;


        // Model bound to input fields and modal
        $ctrl.label = 'ساعت';
        $ctrl.time = new Date();
        $ctrl.selectableTimes = [];
        $ctrl.selectedTime = {};

        // Optional message to display below each input field
        /*   $ctrl.message = {
               hour: 'Hour is required',
               minute: 'Minute is required',
               meridiem: 'Meridiem is required'
           }

           $ctrl.readonly = false;

           $ctrl.required = true;*/


        $ctrl.init_momentTime = "";
        $ctrl.minMomentTime = "00:00";
        $ctrl.momentTime = $ctrl.init_momentTime;
        $ctrl.timeIsSet = false;
        $ctrl.inited = false;
        $ctrl.selectedTimeChanged = selectedTimeChanged;
        fillSelectableTimes();
        $scope.$watch('$ctrl.momentTime', function (momentTime) {

            if (momentTime && $ctrl.momentTime != $ctrl.init_momentTime) {
                var hour = momentTime.split(":")[0].trim();
                var min = momentTime.split(":")[1].trim();
                $ctrl.timeValue = new Date(1970, 0, 1, hour, min, 0);
                if ($ctrl.selectedTime)
                    $ctrl.timeValue = $ctrl.selectedTime;


            }
        });

        $scope.$watch('$ctrl.timeValue', function (timeValue) {

            if (timeValue && (!$ctrl.inited || ($ctrl.inited && $ctrl.lock) || $ctrl.canSetFromOutSide)) {
                setTime(timeValue);
                $ctrl.inited = true;
                $ctrl.selectedTime = timeValue;
                setSelectedTime();

            }
        });
        $scope.$watch('$ctrl.minValue', function (timeValue) {

            if (timeValue) {
                setMinTime(timeValue)
                fillSelectableTimes();


            }
        });

        // $scope.$on('time-range-set-time', function(event, timeValue) {
        //     // profileObj contains; name, country and email from emitted event
        //     $ctrl.timeValue = timeValue;
        //     setTime(timeValue);
        //     $ctrl.selectedTime=timeValue;
        //     setSelectedTime();
        // });

        function selectedTimeChanged() {
            if ($ctrl.selectedTime)
                $ctrl.timeValue = $ctrl.selectedTime;
        }

        function setSelectedTime() {
            if ($ctrl.selectedTime) {
                var temp = new Date($ctrl.selectedTime);
                angular.forEach($ctrl.selectableTimes, function (to) {
                    if (to.value.getHours() == temp.getHours() && to.value.getMinutes() == temp.getMinutes()) {
                        to.value = $ctrl.selectedTime;
                        to.selected = true;
                    }

                })
            }
        }

        function fillSelectableTimes() {
            var startMinute = 0;
            var startHour = 0;
            var stepper = 5;
            $ctrl.selectableTimes = [];
            for (var h = startHour; h < 24; h++) {
                for (var m = startMinute; m < 60; m = m + stepper) {
                    var time = makeTimeObject(h, m);
                    if (isInRange(time))
                        $ctrl.selectableTimes.push(time);

                }

            }
            $ctrl.selectableTimes.push(makeTimeObject(23, 59));
            setSelectedTime();

        }

        function isInRange(t) {

            var isInRange = true;
            if ($ctrl.minValue) {
                var min = new Date($ctrl.minValue);
                var temp = new Date(t.value);
                if (temp.getHours() > min.getHours()) {

                } else if (temp.getHours() == min.getHours()) {
                    if (temp.getMinutes() <= min.getMinutes()) {
                        isInRange = false;
                    }
                } else {

                    isInRange = false;
                }
            }
            return isInRange;

        }

        function makeTimeObject(h, m) {
            var value = new Date(1970, 0, 1, h, m, 0);
            var title = 'ق.ظ';
            if (h > 12)
                title = 'ب.ظ';
            title = "  " + title + "  ";
            if (h < 10)
                h = "0" + h;
            if (m < 10)
                m = "0" + m;
            var text = " " + m + " : " + h;
            return {value: value, text: text, title: title};
        }

        var setTime = function (timeValue) {
            if (timeValue) {
                //  console.log(timeValue);
                var temp = new Date(timeValue);
                if (temp != 'Invalid Date') {
                    $ctrl.momentTime = temp.getHours() + ":" + temp.getMinutes();
                }


            }
        }
        var setMinTime = function (timeValue) {
            if (timeValue) {
                //  console.log(timeValue);
                var temp = new Date(timeValue);
                if (temp != 'Invalid Date') {
                    $ctrl.minMomentTime = temp.getHours() + ":" + temp.getMinutes();
                }

            }
        }


    }


    var EO_TimePicker = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/time-picker/eyeson.time-picker.template.html',
        controller: EO_TimePickerController,
        bindings: {
            timeValue: '=',
            id: '<',
            'minValue': '<',
            'label': '<',
            lock: '=?',
            canSetFromOutSide: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('eoTimePicker', EO_TimePicker)


})();

;
(function () {
    'use strict';

    function eoTagsController($scope, MetaTagCustom) {
        var $ctrl = this;


        $ctrl.selectedItem = null;
        $ctrl.searchText = null;
        $ctrl.querySearch = querySearch;
        $ctrl.tags = [];

        $ctrl.selectedTagsArray = [];
        $ctrl.selectedTagsChange = selectedTagsChange;
        var isInternalChange = false;


        loadTags();
        $scope.$watch('$ctrl.selectedTags', function () {
            if (isInternalChange)
                return;
            if ($ctrl.selectedTags != undefined && $ctrl.selectedTags != null && $ctrl.selectedTags != "") {
                var arr = $ctrl.selectedTags.split(',');
                $ctrl.selectedTagsArray = [];
                for (var i = 0; i < arr.length; i++) {
                    var item = {};
                    item.name = arr[i];
                    $ctrl.selectedTagsArray.push(item);
                }
            }

        });

        function loadTags() {

            var type = 'ALL';
            if ($ctrl.tagType != null && $ctrl.tagType != undefined && $ctrl.tagType != '')
                type = $ctrl.tagType;

            MetaTagCustom.getMetaTagsByType(type).query().$promise.then(function (result) {

                $ctrl.tags = [];
                for (var i = 0; i < result.length; i++) {
                    var item = {};
                    item.name = result[i].tag;
                    $ctrl.tags.push(item);
                }


            });

            // var tags = [
            //     {
            //         'name': 'فضا'
            //     },{
            //         'name': 'اتاق'
            //     },{
            //         'name': 'جلسه'
            //     },{
            //         'name': 'استخر'
            //     },{
            //         'name': 'استادیوم'
            //     },{
            //         'name': 'استودیو'
            //     }
            // ];

            // return tags ;
        }

        function querySearch(query) {

            return $ctrl.tags.filter(function (el) {
                return el.name.indexOf(query) !== -1
            })

        }

        function selectedTagsChange() {

            isInternalChange = true;
            $ctrl.selectedTags = "";
            for (var i = 0; i < $ctrl.selectedTagsArray.length; i++) {

                $ctrl.selectedTags += $ctrl.selectedTagsArray[i].name.toString();
                if (i + 1 != $ctrl.selectedTagsArray.length) {
                    $ctrl.selectedTags += ",";
                }
            }

            // isInternalChange = false;
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */


    }

    var eoTagsController = {

        templateUrl: 'app/components/eyeson/tags/eyeson.tags.template.html',
        controller: eoTagsController,
        bindings: {

            selectedTags: '=',
            tagType: '<?'
        }
    };
    angular
        .module('tikonApp')
        .component('eoTags', eoTagsController);
    eoTagsController.$inject = ['$scope', 'MetaTagCustom'];
})();

;
angular.module('tikonApp').directive('eoSchedulerLazy', ['DateUtil', '$mdDialog', '$timeout', 'TimingInfo', '$localStorage', 'ENV',
    function (dateUtil, $mdDialog, $timeout, timingInfo, $localStorage, ENV) {
        return {
            restrict: 'A',
            scope: {serviceItemId: '=?', timingInfo: '=?', refreshTimingInfo: '&?', accessLevel: '<?'},
            transclude: true,
            templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler.template.html',

            link: function ($scope, $element, $attrs, $controller) {

                var scheduleIsLoaded = false;
                var eventsInited = false;
                var onCratingNewEvent = false;
                var serviceId;
                var canSeeReserve = true;
                +
                    //  $scope.schedulerApi.refreshScheduler = refreshScheduler;
                    //adjust size of a scheduler
                    $timeout(function () {
                        $scope.$watch('serviceItemId', function (serviceItemId) {
                            serviceId = serviceItemId;

                            if (serviceItemId) {
                                // alert(serviceItemId);
                                $scope.$watch('timingInfo', function (timingInfo) {
                                    if (timingInfo) {
                                        initSchedule();
                                        configScheduler(timingInfo);
                                        setSchedulerDataSource();
                                        $scope.$watch(function () {
                                            return $element[0].offsetWidth + "." + $element[0].offsetHeight;
                                        }, function () {
                                            scheduler.setCurrentView();
                                        });

                                    }
                                });

                            }
                        });
                    }, 0);


                function refreshScheduler() {
                    //   alert('refresh called');
                    regenerateEvents($scope.timingInfo);
                }

                function configScheduler(timingInfo) {


                    scheduleIsLoaded = false;
                    var first_hour = 0;
                    var last_hour = 24;
                    var limit_start = new Date();
                    var limit_end = new Date('3000-01-01');
                    if (timingInfo && timingInfo.startTime)
                        first_hour = (new Date(timingInfo.startTime)).getHours();
                    if (timingInfo && timingInfo.endTime)
                        last_hour = (new Date(timingInfo.endTime)).getHours();
                    if (timingInfo && timingInfo.fromDate)
                        limit_start = new Date(timingInfo.fromDate);
                    if (timingInfo && timingInfo.toDate)
                        limit_end = new Date(timingInfo.toDate);
                    scheduler.config.first_hour = first_hour;
                    scheduler.config.last_hour = last_hour;
                    scheduler.config.limit_start = limit_start;
                    scheduler.config.limit_end = limit_end;
                    scheduler.config.limit_view = true;


                    clearSchedule();
                }

                function regenerateEvents(timingInfo) {


                    scheduleIsLoaded = false;
                    var first_hour = 0;
                    var last_hour = 23;
                    var limit_start = new Date();
                    var limit_end = new Date('3000-01-01');
                    if (timingInfo && timingInfo.startTime)
                        first_hour = (new Date(timingInfo.startTime)).getHours();
                    if (timingInfo && timingInfo.endTime)
                        last_hour = (new Date(timingInfo.endTime)).getHours();
                    if (timingInfo && timingInfo.fromDate)
                        limit_start = new Date(timingInfo.fromDate);
                    if (timingInfo && timingInfo.toDate)
                        limit_end = new Date(timingInfo.toDate);
                    scheduler.config.first_hour = first_hour;
                    scheduler.config.last_hour = last_hour;
                    scheduler.config.limit_start = limit_start;
                    scheduler.config.limit_end = limit_end;
                    scheduler.config.limit_view = true;


                    scheduler.updateView(limit_start);


                    clearSchedule();
                    if (timingInfo != undefined && timingInfo.availableTimes != undefined) {
                        //adding offtimes
                        angular.forEach(timingInfo.offDates, function (date) {

                            var eid = scheduler.addMarkedTimespan({
                                    days: new Date(date),
                                    // end_date:    new Date(date),
                                    //  type: "dhx_time_block"
                                    type: "dhx_offTime_block",
                                    css: "sch-offDate",
                                    zones: "fullday"
                                }
                            );
                        });
                        angular.forEach(timingInfo.offDaysOfWeek, function (day) {
                            //
                            var offdays = [];
                            offdays.push(convertWeekNameToOrder(day));
                            var eid = scheduler.addMarkedTimespan({
                                    days: offdays,
                                    // end_date:    new Date(date),
                                    //  type: "dhx_time_block"
                                    type: "dhx_offTime_block",
                                    css: "sch-offDate",
                                    zones: "fullday"
                                }
                            );
                        });
                        angular.forEach(timingInfo.offTimes, function (time) {

                            var zones = [];
                            var startTime = new Date(time.startTime);
                            var endTime = new Date(time.endTime);
                            var startMin = startTime.getMinutes();
                            var endMin = endTime.getMinutes();

                            zones.push(startTime.getHours() * 60 + startMin);
                            zones.push(endTime.getHours() * 60 + endMin);
                            //console.log(zones);
                            var eid = scheduler.addMarkedTimespan({
                                    zones: zones,
                                    days: "fullweek",
                                    css: "sch-offDate",
                                    // end_date:    new Date(date),
                                    //  type: "dhx_time_block"
                                    type: "dhx_offTime_block"

                                }
                            );
                        });

                        //adding events
                        var events = [];
                        scheduleIsLoaded = false;
                        var i = 0;
                        angular.forEach(timingInfo.availableTimes, function (time) {

                            i++;
                            //
                            //var startTime=dateUtil.fromString(time.startTime);
                            //console.log('startTime:');
                            //console.log(startTime);
                            var eid = scheduler.addEvent(
                                new Date(time.startTime),
                                new Date(time.endTime),
                                '',
                                time.id,   //userdata

                                //time.id,
                                time
                            );
                            time.id = eid;
                            eid.readonly = true;
                            if (i == timingInfo.availableTimes.length) {
                                scheduleIsLoaded = true;
                                eventsInited = true;
                                //  alert(i+scheduleIsLoaded);
                            }
                            //    events.push(time);
                            //  console.log('event added : ' + eid);

                        });

                        scheduler.updateView(limit_start);
                        scheduleIsLoaded = true;
                    }
                }


                function onDoubleClick(id, e) {
                    if (!onCratingNewEvent)
                        scheduler.showLightbox(id);
                }


                function convertWeekNameToOrder(day) {
                    var index = DAYS_VALUES.indexOf(day);
                    if (index == 0) return 6;
                    return index - 1;

                }

                function clearSchedule() {
                    scheduler.clearAll();
                    scheduler.deleteMarkedTimespan();
                }


                function setSchedulerDataSource() {
                    scheduler.setLoadMode("week");
                    scheduler.load(ENV.API_BASE_URL + "api/client/getSchedulerEventByServiceItem/" + $scope.serviceItemId, "json", function (data) {

                        //alert(data);
                    });
                }

                function AddNewTimeSession(ev) {
                    var timeSpan = {
                        startTime: new Date(ev.start_date),
                        endTime: new Date(ev.end_date),
                        serviceItemId: serviceId
                    };
                    timingInfo.addNewTimeSession().save(timeSpan);
                    console.log('time session create');
                    console.log(ev);
                    onCratingNewEvent = false;

                }

                function initSchedule() {


                    //styling for dhtmlx scheduler
                    $element.addClass("dhx_cal_container");

                    scheduler.config.start_on_monday = false;
                    //scheduler.config.show_loading = true;
                    //init scheduler
                    //
                    scheduler.templates.event_class = function (start, end, ev) {
                        if (ev.hidden) {
                            console.log(ev.id + ' is hidden');
                            return "scheduler_hidden_event";
                        }


                        if (ev.reserveRequestCount > 0) {
                            return "scheduler_has_orders_to_confirm"
                        }
                        if (ev.waitToPayRequestCount > 0) {
                            return "scheduler_has_orders_to_pay"
                        }
                        if (!ev.enable) {
                            return "scheduler_not_enable";
                        }
                        if (!ev.capacity > 0) {
                            return "scheduler_no_capacity";

                        }
                        if (ev.confirmedRequestCount > 0) {
                            return "scheduler_has_confirmed_orders"
                        }


                        return "scheduler_available";
                    }
                    var mode = "week";
                    var start_date = new JDate();
                    if ($localStorage.timeline_mode != undefined)
                        mode = $localStorage.timeline_mode;

                    if ($localStorage.timeline_startDate != undefined) {
                        start_date.date[0]
                        var d = $localStorage.timeline_startDate;
                        if (d.date != undefined && d.date[0] != undefined)
                            start_date = new JDate(d.date[0], d.date[1], d.date[2]);
                    }
                    if (screen.width <= 480) {
                        scheduler.init($element[0], start_date, "day");
                    } else {
                        scheduler.init($element[0], start_date, mode);
                    }

                    scheduler.config.icons_select = [
                        //"icon_details",
                        //
                        //"icon_delete"
                    ];

                    scheduler.attachEvent("onClick", onDoubleClick);
                    scheduler.attachEvent("onEventAdded", function (e, event) {
                        //   AddNewTimeSession(event);
                    });
                    scheduler.attachEvent("onEventCreated", function (e) {
                        onCratingNewEvent = true;
                    });
                    scheduler.attachEvent("onEventCancel", function (e) {
                        onCratingNewEvent = false;
                    });
                    scheduler.attachEvent("onBeforeViewChange", function (old_mode, old_date, mode, date) {
                        console.log(old_mode + ":" + old_date);
                        $localStorage.timeline_mode = mode;

                        $localStorage.timeline_startDate = date;
                        //any custom logic here
                        return true;
                    });
                    scheduler.templates.event_text = eventTextTemplate;
                    scheduler.templates.tooltip_text = eventTooltipTemplate;
                    dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip';
                    dhtmlXTooltip.config.timeout_to_display = 500000000;
                    scheduler.config.separate_short_events = true;
                    //scheduler.config.hour_size_px = 70;
                    dhtmlXTooltip.config.delta_x = 15;
                    dhtmlXTooltip.config.delta_y = -20;

                    function eventTextTemplate(start, end, event) {
                        return '<span>' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';


                    }

                    function eventTooltipTemplate(start, end, event) {

                        if (!event.price) event.price = 0;
                        if (!event.discount) event.discount = 0;

                        var tooltipHtml = '<div class="scheduler_tooltip" >' +
                            '<p>' + event.text + '</p>' +
                            '<li> ظرفیت موجود : ' + event.capacity + '</li>' +
                            '<li> قیمت : ' + event.price + '</li>' +
                            '<li> تخفیف : ' + event.discount + '</li>' +
                            '</div>';
                        return tooltipHtml;
                    };

                    var lightBoxForm = document.getElementById("light_box_form");
                    isShowing = false;
                    scheduler.showLightbox = function (id) {

                        //console.log('dialog show');
                        var ev = scheduler.getEvent(id);
                        console.log(ev);
                        ev.updateEvent = function () {
                            scheduler.updateEvent(id);
                        };
                        if (!isShowing) {

                            showCustomLightBox(ev, $scope.refreshTimingInfo);
                            isShowing = true;
                        }
                        //     scheduler.startLightbox(id, lightBoxForm);
                        //...'here you need to set values in the form'...
                        //document.getElementById("some_input").value = ev.text;
                    }

                    //clearSchedule();
                    //scheduler.updateView();
                    //clearSchedule();
                }

                function showCustomLightBox(dialogData, refreshTimingInfoMethod) {

                    $mdDialog.show({
                        locals: {dialogData: dialogData, refreshTimingInfoMethod: refreshTimingInfoMethod},
                        controller: SchedulerTimeSessionController,
                        controllerAs: '$ctrl',
                        templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler-time-session-dialog.template.html',
                        parent: angular.element(document.body),
                        targetEvent: dialogData,
                        clickOutsideToClose: true,
                        fullscreen: false// Only for -xs, -sm breakpoints.
                    })
                        .then(function (ev) {

                            isShowing = false;


                        }, function () {

                            isShowing = false;
                        });
                };
                var SchedulerTimeSessionController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
                    var $ctrl = this;
                    $ctrl.dialogData = dialogData;
                    $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;
                    //$ctrl.dialogData = {
                    //    id: dialogData.id,
                    //    price: dialogData.price,
                    //    capacity: dialogData.capacity,
                    //    enable: dialogData.enable,
                    //    discount: dialogData.discount,
                    //    isNew:dialogData.isNew
                    //};

                    var startDate = new JDate(dialogData.start_date);
                    var endDate = new JDate(dialogData.end_date);
                    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                    if (startDate && endDate) {
                        $ctrl.title = startDate.format('dddd DD MMMM ') + '-' + 'ساعت' +
                            startDate.format('HH:SS') + ' - ' + endDate.format('HH:SS');


                    }


                    $ctrl.hideDialog = function () {
                        $mdDialog.hide();
                    };

                    $ctrl.cancelDialog = function () {
                        $mdDialog.cancel();
                    };
                    $ctrl.copyTSimilarTimes = function () {
                        if (confirm("در صورت تایید ، خصوصیات این زمان در دیگر زمانهای این سرویس که ساعت مشابهی دارند کپی می شود. آیا اطمینان دارید؟")) {
                            TimingInfo.updateToSimilarTimeSessions($ctrl.dialogData.id).get(function () {
                                alert("تغییرات با موفقیت انجام شد. برای مشاهده دکمه بازیابی تقویم کاری را بزنید")
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        }
                    }

                    $ctrl.gotoNewReserve = function (serviceItemId) {
                        $mdDialog.hide();
                        console.log(dialogData);
                        if (dialogData.floatTime) {

                            $state.go('supplierPanel.orderBagWithDateRangeParameter', {
                                serviceItemId: dialogData.serviceItemId,
                                start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
                                end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
                            });


                        } else {
                            $state.go('supplierPanel.orderBagWithParameter', {
                                serviceItemId: dialogData.serviceItemId,
                                timeSessionId: dialogData.id
                            });


                        }
                        /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                              serviceItemId: serviceItemId,
                              timeSessionId: dialogData.id
                          });

                          window.open(url,'_blank');*/
                        //   window.open(url,'_self');

                    }

                    $ctrl.updateCapacity = function (value) {

                        if ($ctrl.dialogData.floatTime) {
                            $ctrl.dialogData.capacity = value;
                            $ctrl.upsertFloatTimeSession($ctrl.dialogData);
                        } else
                            TimingInfo.changeTimeSessionCapacity($ctrl.dialogData.id, value).get(function () {
                                dialogData.capacity = value;
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                                $ctrl.refreshTimingInfoMethod();
                            });
                        return true;
                    }
                    $ctrl.updateDiscount = function (value) {
                        if (data.floatTime) {
                            $ctrl.dialogData.discount = value;
                            $ctrl.upsertFloatTimeSession(data);
                        } else
                            TimingInfo.changeTimeSessionDiscount($ctrl.dialogData.id, value).get(function () {
                                dialogData.discount = value;
                                //   $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        return true;
                    }
                    $ctrl.gotoOrderBag = function (id) {
                        $mdDialog.hide();
                        $state.go('supplierPanel.editOrderBag', {id: id});

                    }
                    $ctrl.changeEnable = function (data) {

                        //if(data.floatTime)
                        //{
                        data.enable = !data.enable;
                        $ctrl.upsertFloatTimeSession(data);
                        //}
                        //else
                        //TimingInfo.changeTimeSessionEnable(data.id).get(function () {
                        //    $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
                        //    dialogData.enable = $ctrl.dialogData.enable;
                        //    dialogData.updateEvent();
                        //});
                    }
                    $ctrl.upsertFloatTimeSession = function (ev) {
                        ev.start_date = new Date(ev.start_date);
                        ev.end_date = new Date(ev.end_date);
                        ev.orderBagStatusList = [0, 1];
                        //      var timeSpan={startTime:new Date(ev.start_date),endTime: new Date( ev.end_date),serviceItemId:serviceId};
                        timingInfo.upsertFloatTimeSession().save(ev, function (result) {

                            $ctrl.refreshTimingInfoMethod();
                            $ctrl.cancelDialog();
                        });
                        console.log('time session create');
                        console.log(ev);
                        onCratingNewEvent = false;

                    }
                    $ctrl.saveDialog = function (answer) {
                        dialogData.price = $ctrl.dialogData.price;
                        dialogData.discount = $ctrl.dialogData.discount;
                        dialogData.capacity = $ctrl.dialogData.capacity;
                        dialogData.enable = $ctrl.dialogData.enable;
                        dialogData.updateEvent();
                        $mdDialog.hide(answer);
                    };
                }
                SchedulerTimeSessionController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils', 'ENV'];


            }//end of link method
        }
    }]);
;
angular.module('tikonApp').directive('eoScheduler', ['DateUtil', '$mdDialog', '$timeout', function (dateUtil, $mdDialog, $timeout) {
    return {
        restrict: 'A',
        scope: {timingInfo: '=?', schedulerApi: '=?'},
        transclude: true,
        templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler.template.html',

        link: function ($scope, $element, $attrs, $controller) {
            $timeout(function () {
                var scheduleIsLoaded = false;
                var eventsInited = false;
                //console.log($scope.schedulerApi);
                $scope.schedulerApi.refreshScheduler = refreshScheduler;
                //adjust size of a scheduler
                $scope.$watch(function () {
                    return $element[0].offsetWidth + "." + $element[0].offsetHeight;
                }, function () {
                    scheduler.setCurrentView();
                });
                $scope.$watch('timingInfo', function (timingInfo) {

                    //console.log(" $scope.$watch('timingInfo', function (timingInfo) ");
                    regenerateEvents(timingInfo);

                });

                initSchedule();
            }, 0);

            function refreshScheduler() {
                //   alert('refresh called');
                regenerateEvents($scope.timingInfo);
            }

            function regenerateEvents(timingInfo) {


                scheduleIsLoaded = false;
                var first_hour = 0;
                var last_hour = 23;
                var limit_start = new Date();
                var limit_end = new Date('3000-01-01');
                if (timingInfo && timingInfo.startTime)
                    first_hour = (new Date(timingInfo.startTime)).getHours();
                if (timingInfo && timingInfo.endTime)
                    last_hour = (new Date(timingInfo.endTime)).getHours();
                if (timingInfo && timingInfo.fromDate)
                    limit_start = new Date(timingInfo.fromDate);
                if (timingInfo && timingInfo.toDate)
                    limit_end = new Date(timingInfo.toDate);
                scheduler.config.first_hour = first_hour;
                scheduler.config.last_hour = last_hour;
                scheduler.config.limit_start = limit_start;
                scheduler.config.limit_end = limit_end;
                scheduler.config.limit_view = true;


                scheduler.updateView(limit_start);


                clearSchedule();
                if (timingInfo != undefined && timingInfo.availableTimes != undefined) {
                    //adding offtimes
                    angular.forEach(timingInfo.offDates, function (date) {

                        var eid = scheduler.addMarkedTimespan({
                                days: new Date(date),
                                // end_date:    new Date(date),
                                //  type: "dhx_time_block"
                                type: "dhx_offTime_block",
                                css: "sch-offDate",
                                zones: "fullday"
                            }
                        );
                    });
                    angular.forEach(timingInfo.offDaysOfWeek, function (day) {
                        //
                        var offdays = [];
                        offdays.push(convertWeekNameToOrder(day));
                        var eid = scheduler.addMarkedTimespan({
                                days: offdays,
                                // end_date:    new Date(date),
                                //  type: "dhx_time_block"
                                type: "dhx_offTime_block",
                                css: "sch-offDate",
                                zones: "fullday"
                            }
                        );
                    });
                    angular.forEach(timingInfo.offTimes, function (time) {

                        var zones = [];
                        var startTime = new Date(time.startTime);
                        var endTime = new Date(time.endTime);
                        var startMin = startTime.getMinutes();
                        var endMin = endTime.getMinutes();

                        zones.push(startTime.getHours() * 60 + startMin);
                        zones.push(endTime.getHours() * 60 + endMin);
                        //console.log(zones);
                        var eid = scheduler.addMarkedTimespan({
                                zones: zones,
                                days: "fullweek",
                                css: "sch-offDate",
                                // end_date:    new Date(date),
                                //  type: "dhx_time_block"
                                type: "dhx_offTime_block"

                            }
                        );
                    });

                    //adding events
                    var events = [];
                    scheduleIsLoaded = false;
                    var i = 0;
                    angular.forEach(timingInfo.availableTimes, function (time) {
                        i++;
                        //
                        //var startTime=dateUtil.fromString(time.startTime);
                        //console.log('startTime:');
                        //console.log(startTime);
                        var eid = scheduler.addEvent(
                            new Date(time.startTime),
                            new Date(time.endTime),
                            time.id,   //userdata
                            time.id,
                            time
                        );
                        time.id = eid;
                        eid.readonly = true;
                        if (i == timingInfo.availableTimes.length) {
                            scheduleIsLoaded = true;
                            eventsInited = true;
                            //  alert(i+scheduleIsLoaded);
                        }
                        //    events.push(time);
                        //  console.log('event added : ' + eid);

                    });

                    scheduler.updateView(limit_start);
                    scheduleIsLoaded = true;
                }
            }

            function onEventCreated(id, e) {
                //   refreshEvents();
            }

            function onEventDeleted(id, e) {
                refreshEvents();
            }

            function onEventChanged() {
                refreshEvents();
            }

            function onEventAdded() {
                refreshEvents();
            }

            function onDoubleClick(id, e) {
                scheduler.showLightbox(id);
            }

            function refreshEvents() {

                if (scheduleIsLoaded && eventsInited) {
                    //
                    //console.log('refresh called');
                    var evs = scheduler.getEvents();
                    var evsDto = [];

                    angular.forEach(evs, function (e) {
                        //
                        //console.log(ev);
                        var newE = {

                            startTime: e.start_date,
                            endTime: e.end_date,
                            id: e.id,
                            comment: e.text,
                            discount: e.discount,
                            capacity: e.capacity,
                            enable: e.enable,
                            price: e.price
                        };
                        evsDto.push(newE);
                    });
                    $scope.timingInfo.availableTimes = evsDto;
                }

            }

            function convertWeekNameToOrder(day) {
                var index = DAYS_VALUES.indexOf(day);
                if (index == 0) return 6;
                return index - 1;

            }

            function clearSchedule() {
                scheduler.clearAll();
                scheduler.deleteMarkedTimespan();
            }

            function initSchedule() {
                //styling for dhtmlx scheduler
                $element.addClass("dhx_cal_container");

                scheduler.config.start_on_monday = false;
                scheduler.config.show_loading = true;
                //init scheduler
                //
                scheduler.templates.event_class = function (start, end, ev) {

                    if (!ev.enable) {
                        return "scheduler_not_enable";
                    }
                    if (!ev.capacity > 0) {
                        return "scheduler_no_capacity";

                    }

                    return "scheduler_available";
                }
                scheduler.init($element[0], new JDate(), "week");
                scheduler.config.icons_select = [
                    //"icon_details",
                    //
                    //"icon_delete"
                ];

                scheduler.attachEvent("onEventCreated", onEventCreated);
                scheduler.attachEvent("onEventAdded", onEventAdded);
                scheduler.attachEvent("onEventDeleted", onEventDeleted);
                scheduler.attachEvent("onEventChanged", onEventChanged);
                scheduler.attachEvent("onDblClick", onDoubleClick);
                scheduler.templates.event_text = eventTextTemplate;
                scheduler.templates.tooltip_text = eventTooltipTemplate;
                dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip';
                dhtmlXTooltip.config.timeout_to_display = 500000000;
                scheduler.config.separate_short_events = true;
                //scheduler.config.hour_size_px = 70;
                dhtmlXTooltip.config.delta_x = 15;
                dhtmlXTooltip.config.delta_y = -20;

                function eventTextTemplate(start, end, event) {
                    return '<span>' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';


                }

                function eventTooltipTemplate(start, end, event) {

                    if (!event.price) event.price = 0;
                    if (!event.discount) event.discount = 0;

                    var tooltipHtml = '<div class="scheduler_tooltip" >' +
                        '<p>' + event.text + '</p>' +
                        '<li> ظرفیت موجود : ' + event.capacity + '</li>' +
                        '<li> قیمت : ' + event.price + '</li>' +
                        '<li> تخفیف : ' + event.discount + '</li>' +
                        '</div>';
                    return tooltipHtml;
                };

                var lightBoxForm = document.getElementById("light_box_form");
                isShowing = false;
                scheduler.showLightbox = function (id) {

                    //console.log('dialog show');
                    var ev = scheduler.getEvent(id);
                    ev.updateEvent = function () {
                        scheduler.updateEvent(id);
                    };
                    if (!isShowing) {
                        ev.serviceItemId =
                            showCustomLightBox(ev);
                        isShowing = true;
                    }
                    //     scheduler.startLightbox(id, lightBoxForm);
                    //...'here you need to set values in the form'...
                    //document.getElementById("some_input").value = ev.text;
                }

//needs to be attached to the 'save' button
                function save_form() {
                    var ev = scheduler.getEvent(scheduler.getState().lightbox_id);
                    //...'here you need to retrieve values from the form'...
                    //ev.text = document.getElementById("some_input").value;
                    scheduler.endLightbox(true, lightBoxForm);
                }

//needs to be attached to the 'cancel' button
                function close_form(argument) {
                    scheduler.endLightbox(false, lightBoxForm);
                }

                scheduler.updateView();
            }

            function showCustomLightBox(dialogData) {

                $mdDialog.show({
                    locals: {dialogData: dialogData},
                    controller: SchedulerTimeSessionController,
                    controllerAs: '$ctrl',
                    templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler-time-session-dialog.template.html',
                    parent: angular.element(document.body),
                    targetEvent: dialogData,
                    clickOutsideToClose: true,
                    fullscreen: false// Only for -xs, -sm breakpoints.
                })
                    .then(function (ev) {

                        isShowing = false;

                    }, function () {
                        isShowing = false;
                    });
            };
            var SchedulerTimeSessionController = function ($scope, $mdDialog, dialogData, TimingInfo, $state) {
                var $ctrl = this;
                $ctrl.dialogData = {
                    id: dialogData.id,
                    price: dialogData.price,
                    capacity: dialogData.capacity,
                    enable: dialogData.enable,
                    discount: dialogData.discount
                };
                //
                var startDate = new JDate(dialogData.start_date);
                var endDate = new JDate(dialogData.end_date);
                $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                if (startDate && endDate) {
                    $ctrl.title = startDate.format('dddd DD MMMM ') + '-' + 'ساعت' +
                        startDate.format('HH:SS') + ' - ' + endDate.format('HH:SS');


                }


                $ctrl.hideDialog = function () {
                    $mdDialog.hide();
                };

                $ctrl.cancelDialog = function () {
                    $mdDialog.cancel();
                };

                $ctrl.gotoNewReserve = function (serviceItemId) {
                    $mdDialog.hide();
                    $state.go('supplierPanel.orderBagWithParameter', {
                        serviceItemId: serviceItemId,
                        timeSessionId: dialogData.id
                    });

                }
                $ctrl.gotoOrderBag = function (id) {
                    $mdDialog.hide();
                    $state.go('supplierPanel.editOrderBag', {id: id});

                }
                $ctrl.changeEnable = function (data) {
                    TimingInfo.changeTimeSessionEnable(data.id).get(function () {
                        $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
                        dialogData.enable = $ctrl.dialogData.enable;
                        dialogData.updateEvent();
                    });
                }
                $ctrl.saveDialog = function (answer) {
                    dialogData.price = $ctrl.dialogData.price;
                    dialogData.discount = $ctrl.dialogData.discount;
                    dialogData.capacity = $ctrl.dialogData.capacity;
                    dialogData.enable = $ctrl.dialogData.enable;
                    dialogData.updateEvent();
                    $mdDialog.hide(answer);
                };
            }
            SchedulerTimeSessionController.$inject = ['$scope', '$mdDialog', 'dialogData', 'TimingInfo', '$state'];


        }//end of link method
    }
}]);
;
(function () {
    'use strict';
    eoRichTextEditorController.$inject = ['$scope', '$attrs', '$element'];

    function eoRichTextEditorController($scope, $attrs, $element) {
        var $ctrl = this;
        $ctrl.hasHtmlTags = false;

        $scope.$watch('$ctrl.inputValue', function () {
            if ($ctrl.inputValue) {
                if ($ctrl.inputValue.indexOf('<p>') > -1
                    || $ctrl.inputValue.indexOf('<div>') > -1
                    || $ctrl.inputValue.indexOf('<b>') > -1
                    || $ctrl.inputValue.indexOf('<font') > -1
                    || $ctrl.inputValue.indexOf('<span>') > -1
                )
                    $ctrl.hasHtmlTags = true;
            }

        });
    }

    var eo_RichTextEditor = {

        templateUrl: 'app/components/eyeson/rich-text-editor/eyeson.rich-text-editor.template.html',
        controller: eoRichTextEditorController,
        bindings: {
            inputValue: "=",
            height: "=?"

        }
    };
    angular
        .module('tikonApp')
        .component('eoRichTextEditor', eo_RichTextEditor);

})();

;
(function () {
        'use strict';
        EO_ProgressBarController.$inject = ['$scope', '$attrs', '$element', '$http', '$timeout'];

        function EO_ProgressBarController($scope, $attrs, $element, $http, $timeout) {
            //       console.log('loading progress bar...');
//
            var $ctrl = this;
            $ctrl.disableProgress = true;
            $ctrl.isProgressOpen = false;
            $scope.isLoading = isLoading;
            $scope.$watch($scope.isLoading, function (isloading) {
                manageProgressBar();
            });
            var loading_screen;

            function manageProgressBar() {
                if (!$ctrl.isProgressOpen)
                    $timeout(function () {

                        //    hideProgressBar();


                        if (isLoading()) {
                            //   console.log($http)
                            //
                            loading_screen = showProgressBar();


                        } else
                            hideProgressBar();

                    }, 10000);
            }

            function isLoading() {

                if ($http.pendingRequests.length > 0) {
                    var postRequest = $http.pendingRequests.filter(function (req) {
                        return (req.method != "GET")
                    });
                    return postRequest.length > 0;

                }


            }

            function showProgressBar() {
                //
                var html = '<div>' +
                    '<span translate="messages.pleaseWait" > لطفا منتظر باشید...</span>' +
                    '</div>' + '    <div class="sk-wave"> ' +
                    '<div class="sk-rect sk-rect1"></div> ' +
                    '<div class="sk-rect sk-rect2"></div> ' +
                    '<div class="sk-rect sk-rect3"></div>' +
                    ' <div class="sk-rect sk-rect4"></div> ' +
                    '<div class="sk-rect sk-rect5"></div> ' +
                    '<div class="sk-rect sk-rect6"></div> ' +
                    '<div class="sk-rect sk-rect7"></div> ' +
                    '</div>';
                if (!$ctrl.isProgressOpen) {
                    $ctrl.isProgressOpen = true;
                    $timeout(function () {
                        hideProgressBar();
                    }, 5000);
                    return pleaseWait({
                        logo: "/content/images/logo.png",
                        //    backgroundColor: '#f46d3b',
                        loadingHtml: html
                    });


                } else {
                    return loading_screen;
                }
            }

            function hideProgressBar() {
                if (loading_screen) {
                    loading_screen.finish();
                    $ctrl.isProgressOpen = false;
                }

            }
        }

        var EO_ProgressBar = {
            // template:'tets:{{$ctrl.testStr}}',
            templateUrl: 'app/components/eyeson/progress-bar/eyeson.progress-bar.template.html',
            controller: EO_ProgressBarController,
            bindings: {}

        };
        angular
            .module('tikonApp')
            .component('eoProgressBar', EO_ProgressBar)
    }

)();
;
;
(function () {
    'use strict';
    EO_PlSearchBoxController.$inject = ['$scope', '$attrs', '$element'];

    function EO_PlSearchBoxController($scope, $attrs, $element) {
//
        var $ctrl = this;


        onLoad();

        function onLoad() {
            if (!$ctrl.searchPlaceHolder)
                $ctrl.searchPlaceHolder = 'جستجو';
            if ($ctrl.canFilter === undefined)
                $ctrl.canFilter = false;
            if ($ctrl.filterCount === undefined)
                $ctrl.filterCount = 0;

        }

        $ctrl.search = function () {
            $ctrl.onSearch();
        }

        $ctrl.searchKeyPress = function (keyEvent) {
            if (keyEvent.which === 13) {
                $ctrl.search();
            }
        }

        $ctrl.clearSearch = function () {
            $ctrl.onClearSearch();
        }

        $ctrl.filterClick = function () {
            if ($ctrl.onFilterClick)
                $ctrl.onFilterClick();
        }

    }


    var EO_PlSearchBox = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-search-box/eyeson.pl-search-box.template.html',
        controller: EO_PlSearchBoxController,
        bindings: {

            'searchQuery': '=',
            'searchPlaceHolder': '=?',
            'onSearch': '&',
            'onClearSearch': '&',
            'canFilter': '=?',
            'onFilterClick': '=?',
            'filterCount': '=?'

        }


    };

    angular
        .module('tikonApp')
        .component('eoPlSearchBox', EO_PlSearchBox)


})();

;
(function () {
    'use strict';
    EO_PlModalHeaderController.$inject = ['$scope', '$attrs', '$element'];

    function EO_PlModalHeaderController($scope, $attrs, $element) {
//
        var $ctrl = this;

        $ctrl.okModal = function () {
            $ctrl.onOk();
        }
        $ctrl.closeModal = function () {
            $ctrl.onClose();
        }

    }


    var EO_PlModalHeader = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-modal-header/eyeson.pl-modal-header.template.html',
        controller: EO_PlModalHeaderController,
        bindings: {

            'title': '=',
            'isDisabled': '=',
            'onOk': '&',
            'onClose': '&',
            'okTitle': '=?'
        }


    };

    angular
        .module('tikonApp')
        .component('eoPlModalHeader', EO_PlModalHeader)


})();

;
(function () {
    'use strict';
    EO_PlModalFooterController.$inject = ['$scope', '$attrs', '$element'];

    function EO_PlModalFooterController($scope, $attrs, $element) {
//
        var $ctrl = this;

        $ctrl.okModal = function () {
            $ctrl.onOk();
        }
        $ctrl.closeModal = function () {
            $ctrl.onClose();
        }

    }


    var EO_PlModalFooter = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-modal-footer/eyeson.pl-modal-footer.template.html',
        controller: EO_PlModalFooterController,
        bindings: {

            'isDisabled': '=',
            'onOk': '&',
            'onClose': '&',
            'okTitle': '=?'

        }


    };

    angular
        .module('tikonApp')
        .component('eoPlModalFooter', EO_PlModalFooter)


})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('GeneralActionsBottomSheetController', GeneralActionsBottomSheetController);

    GeneralActionsBottomSheetController.$inject = ['$mdBottomSheet', '$state'];

    function GeneralActionsBottomSheetController($mdBottomSheet, $state) {
        var vm = this;

        vm.itemClick = itemClick;
        vm.close = close;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
            runAction(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }

        function runAction(txt) {
            switch (txt) {
                case 'newReserve' :
                    $state.go('supplierPanel-v2.new-reserve-modal');
                    break;
                case 'closeDates' :
                    $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                        availabilityMode: 'CLOSE'
                    });
                    break;
                case 'openDates' :
                    $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                        availabilityMode: 'OPEN'
                    });
                    break;
            }
        }
    }
})();
;
(function () {
    'use strict';
    EO_PlGeneralActionsController.$inject = ['$scope', '$attrs', '$element', '$mdBottomSheet'];

    function EO_PlGeneralActionsController($scope, $attrs, $element, $mdBottomSheet) {
//
        var $ctrl = this;
        $ctrl.openActions = function () {
            $mdBottomSheet.show({
                templateUrl: 'app/components/eyeson/pl-general-actions/general-actions-bottom-sheet-template.html',
                controller: 'GeneralActionsBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true
                // resolve: {
                //     // entity: (function () {
                //     //     return {
                //     //
                //     //     };
                //     // })
                //
                //
                // },
            }).then(function (result) {
                switch (result) {
                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

    }


    var EO_PlGeneralActions = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-general-actions/eyeson.pl-general-actions.template.html',
        controller: EO_PlGeneralActionsController,
        bindings: {}


    };

    angular
        .module('tikonApp')
        .component('eoPlGeneralActions', EO_PlGeneralActions)


})();

;
var PersianDateFilter = function ($filter) {
    return function (input) {

        if (input == null) {
            return "";
        }

        var inputDate = new Date(input);
        var tehranTimeZone = convertTZ(inputDate, 'Asia/Tehran')
        var date = new JDate(tehranTimeZone);
        if (date != undefined) {

            //var month = date.getMonth();
            //var day = date.getDay();
            //if (month < 10) {
            //    month = "0" + month;
            //}
            //if (day < 10) {
            //    day = "0" + day;
            //}
            //
            //return date.getFullYear()+"/"+month+"/"+day;

            return date.format('YYYY/MM/DD');
        } else {
            return input;
        }
        ;
    }
}

function convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}

var FullPersianDateFilter = function ($filter) {
    return function (input) {

        if (input == null) {
            return "";
        }

        var inputDate = new Date(input);
        var tehranTimeZone = convertTZ(inputDate, 'Asia/Tehran')
        var date = new JDate(tehranTimeZone);
        if (date != undefined) {

            //var month = date.getMonth();
            //var day = date.getDay();
            //if (month < 10) {
            //    month = "0" + month;
            //}
            //if (day < 10) {
            //    day = "0" + day;
            //}
            //
            //return date.getFullYear()+"/"+month+"/"+day;

            //return date.format('ddd DD MMM YYYY   ');
            return date.format('ddd DD/MMM/YYYY ');
        } else {
            return input;
        }
        ;
    }
}
var PersianTimeFilter = function ($filter) {
    return function (input) {

            if (input == null) {
                return "";
            }
            var inputDate = new moment(input);
//            var tehranTime    = inputDate.tz("Asia/Tehran");
            var date = inputDate.format("HH:mm") ;

            return date;

    };
}
angular.module('tikonApp').filter('toPersianDate', PersianDateFilter);
angular.module('tikonApp').filter('toFullPersianDate', FullPersianDateFilter);
angular.module('tikonApp').filter('toPersianTime', PersianTimeFilter);
PersianDateFilter.$inject = ['$filter'];
PersianTimeFilter.$inject = ['$filter'];
FullPersianDateFilter.$inject = ['$filter'];
;
(function () {
    'use strict';
    eoNumericInputTestController.$inject = ['$scope', '$attrs', '$element'];

    function eoNumericInputTestController($scope, $attrs, $element) {
        var $ctrl = this;
        $ctrl.inputValueCurrency = $ctrl.inputValue


        $scope.$watch($ctrl.formReference.$invalid, function (invalid) {
            //this code check the form errors
            // DO NOT DELETE THIS !!!!
        })
        handleChanges();

        $ctrl.onValueChange = handleChanges;
        function handleChanges() {
            replaceIosNumbers();
            replaceAndroidNumbers();
            removeInvalidCharacter();
            if($ctrl.currencyFormat){
                currencyFormat()
            }
            if ($ctrl.onChange)
                $ctrl.onChange();
        }

        $ctrl.getClass = function () {
            return $ctrl.customClass;
        }


        function replaceIosNumbers() {
            if (!$ctrl.inputValueCurrency)
                return;
            var corrected = $ctrl.inputValueCurrency;
            for (var i = 0; i < $ctrl.inputValueCurrency.length; i++) {
                var charCode = $ctrl.inputValueCurrency.charCodeAt(i);
                if (charCode == 1632)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "0");
                if (charCode == 1633)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "1");
                if (charCode == 1634)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "2");
                if (charCode == 1635)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "3");
                if (charCode == 1636)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "4");
                if (charCode == 1637)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "5");
                if (charCode == 1638)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "6");
                if (charCode == 1639)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "7");
                if (charCode == 1640)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "8");
                if (charCode == 1641)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "9");


            }
            $ctrl.inputValueCurrency = corrected;
        }

        function replaceAndroidNumbers() {
            if (!$ctrl.inputValueCurrency)
                return;
            var corrected = $ctrl.inputValueCurrency;
            for (var i = 0; i < $ctrl.inputValueCurrency.length; i++) {
                var charCode = $ctrl.inputValueCurrency.charCodeAt(i);
                if (charCode == 1776)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "0");
                if (charCode == 1777)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "1");
                if (charCode == 1778)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "2");
                if (charCode == 1779)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "3");
                if (charCode == 1780)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "4");
                if (charCode == 1781)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "5");
                if (charCode == 1782)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "6");
                if (charCode == 1783)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "7");
                if (charCode == 1784)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "8");
                if (charCode == 1785)
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), "9");


            }
            $ctrl.inputValueCurrency = corrected;
        }

        function isValidNumber(char) {

            if (char == '0'
                || char == '1'
                || char == '2'
                || char == '3'
                || char == '4'
                || char == '5'
                || char == '6'
                || char == '7'
                || char == '8'
                || char == '9'
            )
                return true;

            return false;

        }

        function removeInvalidCharacter() {
            if (!$ctrl.inputValueCurrency)
                return;
            var corrected = $ctrl.inputValueCurrency;
            for (var i = 0; i < $ctrl.inputValueCurrency.length; i++) {
                var ccc = $ctrl.inputValueCurrency.charCodeAt(i);
                if (!isValidNumber($ctrl.inputValueCurrency.charAt(i))) {
                    corrected = corrected.replace($ctrl.inputValueCurrency.charAt(i), '');
                }
            }

            $ctrl.inputValueCurrency = corrected;
            $ctrl.inputValue = corrected

        }

        function currencyFormat() {
            // var res = new Intl.NumberFormat('fa-IR', {
            //     style: 'currency',
            //     currency: "IRR",
            //      minimumFractionDigits: 0,
            //     maximumFractionDigits: 0
            // }).format($ctrl.inputValueCurrency)
            // $ctrl.inputValueCurrency = res.replaceAll('ریال','').replaceAll('٬',',')
            if (!$ctrl.inputValueCurrency) return;

            var num = String($ctrl.inputValueCurrency).replace(/[^\d]/g, "");

            num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            $ctrl.inputValueCurrency = num;
        }

    }

    var eo_NumericInput = {

        templateUrl: 'app/components/eyeson/numeric-input/eyeson.numeric-input-v2.template.html',
        controller: eoNumericInputTestController,
        bindings: {
            name: '@',
            inputValue: "=",
            customClass: "@",
            isDisabled: "=?",
            isRequired: "=?",
            formReference: '<',
            min: '@',
            max: '@',
            maxlength: "=?",
            minlength: '@',
            placeholder: '@',
            onChange: '=?',
            currencyFormat: "=?"

        }
    };
    angular
        .module('tikonApp')
        .component('eoNumericInputV2', eo_NumericInput);

})();;
(function () {
    'use strict';
    eoNumericInputController.$inject = ['$scope', '$attrs', '$element'];

    function eoNumericInputController($scope, $attrs, $element) {
        var $ctrl = this;


        $scope.$watch($ctrl.formReference.$invalid, function (invalid) {
            //this code check the form errors
            // DO NOT DELETE THIS !!!!
        })


        $ctrl.onValueChange = function () {
            replaceIosNumbers();
            replaceAndroidNumbers();
            removeInvalidCharacter();

            if ($ctrl.onChange)
                $ctrl.onChange();
        }

        $ctrl.getClass = function () {
            return $ctrl.customClass;
        }


        function replaceIosNumbers() {
            if (!$ctrl.inputValue)
                return;
            var corrected = $ctrl.inputValue;
            for (var i = 0; i < $ctrl.inputValue.length; i++) {
                var charCode = $ctrl.inputValue.charCodeAt(i);
                if (charCode == 1632)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "0");
                if (charCode == 1633)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "1");
                if (charCode == 1634)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "2");
                if (charCode == 1635)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "3");
                if (charCode == 1636)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "4");
                if (charCode == 1637)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "5");
                if (charCode == 1638)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "6");
                if (charCode == 1639)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "7");
                if (charCode == 1640)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "8");
                if (charCode == 1641)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "9");


            }
            $ctrl.inputValue = corrected;
        }

        function replaceAndroidNumbers() {
            if (!$ctrl.inputValue)
                return;
            var corrected = $ctrl.inputValue;
            for (var i = 0; i < $ctrl.inputValue.length; i++) {
                var charCode = $ctrl.inputValue.charCodeAt(i);
                if (charCode == 1776)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "0");
                if (charCode == 1777)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "1");
                if (charCode == 1778)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "2");
                if (charCode == 1779)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "3");
                if (charCode == 1780)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "4");
                if (charCode == 1781)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "5");
                if (charCode == 1782)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "6");
                if (charCode == 1783)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "7");
                if (charCode == 1784)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "8");
                if (charCode == 1785)
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), "9");


            }
            $ctrl.inputValue = corrected;
        }

        function isValidNumber(char) {

            if (char == '0'
                || char == '1'
                || char == '2'
                || char == '3'
                || char == '4'
                || char == '5'
                || char == '6'
                || char == '7'
                || char == '8'
                || char == '9'
            )
                return true;

            return false;

        }

        function removeInvalidCharacter() {
            if (!$ctrl.inputValue)
                return;
            var corrected = $ctrl.inputValue;
            for (var i = 0; i < $ctrl.inputValue.length; i++) {
                var ccc = $ctrl.inputValue.charCodeAt(i);
                if (!isValidNumber($ctrl.inputValue.charAt(i))) {
                    corrected = corrected.replace($ctrl.inputValue.charAt(i), '');
                }
            }

            $ctrl.inputValue = corrected;

        }

    }

    var eo_NumericInput = {

        templateUrl: 'app/components/eyeson/numeric-input/eyeson.numeric-input.template.html',
        controller: eoNumericInputController,
        bindings: {
            name: '@',
            inputValue: "=",
            customClass: "@",
            isDisabled: "=?",
            isRequired: "=?",
            formReference: '<',
            min: '@',
            maxlength: "=?",
            minlength: '@',
            placeholder: '@',
            onChange: '=?'

        }
    };
    angular
        .module('tikonApp')
        .component('eoNumericInput', eo_NumericInput);

})();

;
(function () {
    'use strict';
    EO_NoDataController.$inject = ['$scope', '$attrs', '$element'];

    function EO_NoDataController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.initDefault = initDefault;
        initDefault();

        function initDefault() {

            if (!$ctrl.message)
                $ctrl.message = 'اطلاعاتی جهت نمایش موجود نیست';

        }


    }


    var EO_NoData = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/no-data/eyeson.no-data.template.html',
        controller: EO_NoDataController,
        bindings: {
            message: "=?"
        }


    };

    angular
        .module('tikonApp')
        .component('eoNoData', EO_NoData)


})();

;
(function () {
    'use strict';

    function eoMultiselectController($scope, $attrs, $element) {
//
        var $ctrl = this;
        var blur = false;
        $ctrl.focused = false;
        $ctrl.testStr = 'It is test Str';

        //$ctrl.list = [];
        $ctrl.filteredItems = $ctrl.items;
        $ctrl.selPos = 0;
        $ctrl.elem = $element;

        $ctrl.focusIn = function () {
            //
            if (!$ctrl.focused) {
                $ctrl.focused = true;
                blur = false;
                $ctrl.selPos = 0;
            }
        };

        $ctrl.focusOut = function () {
            //
            $ctrl.itemsearch = "";
            if (!blur) {
                $ctrl.focused = false;
            } else {
                angular.element($ctrl.elem).find('input')[0].focus();
                blur = false;
            }
        };

        // Change me for custom display name on select list
        $ctrl.getDisplayItem = function (item) {
            //
            return item[$ctrl.displayitem];
        };

        // Change me for custom display name on tags (chips)
        $ctrl.getDisplayTag = function (item) {
            //
            return item[$ctrl.displaytag];
        };

        $ctrl.addItem = function (item) {
            //
            if (item) {
                $ctrl.list.push(item);
                $ctrl.itemsearch = "";
                blur = true;
                if ($ctrl.selPos >= $ctrl.filteredItems.length - 1) {
                    $ctrl.selPos--; // To keep hover selection
                }
                //   ngModel.$setViewValue($ctrl.list);
            }
            //   console.log($ctrl.list);
        };

        $ctrl.removeItem = function (item) {
            $ctrl.list.splice($ctrl.list.indexOf(item), 1);
            //     ngModel.$setViewValue($ctrl.list);
        };

        $ctrl.hover = function (index) {
            $ctrl.selPos = index;
        };

        $ctrl.keyPress = function (evt) {
            //console.log(evt.keyCode);
            var keys = {
                38: 'up',
                40: 'down',
                8: 'backspace',
                13: 'enter',
                9: 'tab',
                27: 'esc'
            };

            switch (evt.keyCode) {
                case 27:
                    $ctrl.focusOut();
                    break;
                case 13:
                    if ($ctrl.selPos > -1) {
                        $ctrl.addItem($ctrl.filteredItems[$ctrl.selPos]);
                    }
                    break;
                case 8:
                    if (!$ctrl.itemsearch || $ctrl.itemsearch.length == 0) {
                        if ($ctrl.list.length > 0) {
                            $ctrl.list.pop();
                        }
                    }
                    break;
                case 38:
                    if ($ctrl.selPos > 0) {
                        $ctrl.selPos--;
                    }
                    break;
                case 40:
                    if ($ctrl.selPos < $ctrl.filteredItems.length - 1) {
                        $ctrl.selPos++;
                    }
                    break;
                default:
                    $ctrl.selPos = 0;
                    $ctrl.focusIn();
            }
        };


    }

    var eoMultiselect = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/multi-select-autocomplete/eyeson.multi-select-autocomplete.template.html',
        controller: eoMultiselectController,
        bindings:
            {
                items: '<',
                displaytag: '@?',
                displayitem: '@?',
                list: '='

            }

    };

    angular
        .module('tikonApp')
        .component('eoMultiSelect', eoMultiselect)
        .directive('focus', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    attrs.$observe('focus', function (newValue) {
                        if (newValue == 'true') {
                            element[0].focus();
                        }
                    });
                }
            }
        }).filter('notin', function () {
        return function (listin, listout) {

            return listin.filter(function (el) {
                if (!listin || !listout) return false;
                return listout.indexOf(el) == -1;
            });
        };
    });

    eoMultiselectController.$inject = ['$scope', '$attrs', '$element'];


})();


/*
angular.module('tikonAppdirective',[])
        .directive('eo-multi-select', function () {
            return {
                restict: 'AEC',
                scope: {
                    items: '='
                },
                require: 'ngModel',
                link: function (scope, elem, attrs, ngModel) {
                    //
                    var blur = false;
                    scope.focused = false;
                    scope.list = [];
                    scope.filteredItems = scope.items;
                    scope.selPos = 0;

                    scope.focusIn = function () {
                        if (!scope.focused) {
                            scope.focused = true;
                            blur = false;
                            scope.selPos = 0;
                        }
                    };

                    scope.focusOut = function () {
                        scope.itemsearch = "";
                        if (!blur) {
                            scope.focused = false;
                        } else {
                            angular.element(elem).find('input')[0].focus();
                            blur = false;
                        }
                    };

                    // Change me for custom display name on select list
                    scope.getDisplayItem = function (item) {
                        return item[attrs.displayitem];
                    };

                    // Change me for custom display name on tags (chips)
                    scope.getDisplayTag = function (item) {
                        return item[attrs.displaytag];
                    };

                    scope.addItem = function (item) {
                        if (item) {
                            scope.list.push(item);
                            scope.itemsearch = "";
                            blur = true;
                            if (scope.selPos >= scope.filteredItems.length - 1) {
                                scope.selPos--; // To keep hover selection
                            }
                            ngModel.$setViewValue(scope.list);
                        }
                    };

                    scope.removeItem = function (item) {
                        scope.list.splice(scope.list.indexOf(item), 1);
                        ngModel.$setViewValue(scope.list);
                    };

                    scope.hover = function (index) {
                        scope.selPos = index;
                    };

                    scope.keyPress = function (evt) {
                        console.log(evt.keyCode);
                        var keys = {
                            38: 'up',
                            40: 'down',
                            8: 'backspace',
                            13: 'enter',
                            9: 'tab',
                            27: 'esc'
                        };

                        switch (evt.keyCode) {
                            case 27:
                                scope.focusOut();
                                break;
                            case 13:
                                if (scope.selPos > -1) {
                                    scope.addItem(scope.filteredItems[scope.selPos]);
                                }
                                break;
                            case 8:
                                if (!scope.itemsearch || scope.itemsearch.length == 0) {
                                    if (scope.list.length > 0) {
                                        scope.list.pop();
                                    }
                                }
                                break;
                            case 38:
                                if (scope.selPos > 0) {
                                    scope.selPos--;
                                }
                                break;
                            case 40:
                                if (scope.selPos < scope.filteredItems.length - 1) {
                                    scope.selPos++;
                                }
                                break;
                            default:
                                scope.selPos = 0;
                                scope.focusIn();
                        }
                    };
                },
                template: 'MULTI SELECT <div ng-cloak="" class="typeahead">\
        <ul data-ng-class="{\'focused\': focused}" \
            class="tags" data-ng-click="focusIn()">\
          <li class="tag" data-ng-repeat="s in list track by $index">\
            {{getDisplayTag(s)}} <span data-ng-click="removeItem(s)">x</span>\
          </li> \
          <li class="inputtag">\
            <input data-ng-blur="focusOut()" focus="{{focused}}" data-ng-model-options="{debounce: 500}" \
            type="text" data-ng-model="itemsearch" data-ng-keydown="keyPress($event)"/>\
          </li>\
        </ul>\
        <ul class="list" data-ng-show="focused">\
          <li data-ng-class="{\'active\': selPos == $index}" \
              data-ng-repeat="item in (filteredItems = (items | notin: list | filter: itemsearch | limitTo: 10)) track by $index" \
              data-ng-mousedown="addItem(item)" data-ng-mouseover="hover($index)">\
          {{getDisplayItem(item)}}\
          </li>\
        </ul>\
      </div>'
            };
        }).directive('focus', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('focus', function (newValue) {
                    if (newValue == 'true') {
                        element[0].focus();
                    }
                });
            }
        }
    }).filter('notin', function () {
        return function (listin, listout) {
            return listin.filter(function (el) {
                return listout.indexOf(el) == -1;
            });
        };
    });
*/



;
(function () {
    'use strict';
    Component_IntakeFieldController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'SelectorDataQuery'];

    function Component_IntakeFieldController($scope, $attrs, $element, FileUtil, SelectorDataQuery) {
//
        var $ctrl = this;
        $ctrl.selectableItems = [];
        $ctrl.selectableItemsFilled = false;
        $ctrl.checkChange = checkChange;

        $scope.$watch('$ctrl.field', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });
        $scope.$watch('$ctrl.isEditMode', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });

        function fillSelectableItems() {
            if ($ctrl.isEditMode && !$ctrl.selectableItemsFilled && $ctrl.field.field && $ctrl.field.field.selectorDataTypeId) {
                SelectorDataQuery.findByTypeId($ctrl.field.field.selectorDataTypeId).query(function (data) {

                    if (data) {
                        $ctrl.selectableItems = [];
                        angular.forEach(data, function (item) {
                            $ctrl.selectableItems.push(item.text);
                        })
                        $ctrl.selectableItemsFilled = true;
                    }

                })
            }
        }

        function checkChange() {
            $ctrl.field.value = $ctrl.field.checkValue;
        }

    }


    var Component_IntakeFieldViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data-component/component-intake-field.template.html',
        controller: Component_IntakeFieldController,
        bindings: {
            field: '=',
            isEditMode: '<'
        }

    };

    angular
        .module('tikonApp')
        .component('componentIntakeField', Component_IntakeFieldViewer)

})();
;
(function () {
    'use strict';
    Component_IntakeDataViewerController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'OrderBagCustom', 'CompanyCustomerCustom', 'ENV'];

    function Component_IntakeDataViewerController($scope, $attrs, $element, FileUtil, OrderBagCustom, CompanyCustomerCustom, ENV) {
//
        var $ctrl = this;
        $ctrl.isDataLoaded = false;
        $ctrl.downloadFile = downloadFile;
        $ctrl.isEditMode = true;
        $ctrl.save = save;
        $ctrl.cancelEditing = cancelEditing;
        $ctrl.gotoEditMode = gotoEditMode;
        $ctrl.tempIntakeData = null;
        $ctrl.findColumnCountClass = findColumnCountClass;
        $ctrl.values = {}
        function save() {
            if ($ctrl.intakeData.intakeParentType == "ORDER_BAG") {
                OrderBagCustom.updateIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;

                })
            }
            if ($ctrl.intakeData.intakeParentType == "COMPANY_CUSTOMER") {
                CompanyCustomerCustom.updateCustomerIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;
                })
            }


        }

        function gotoEditMode() {
            $ctrl.tempIntakeData = JSON.parse(JSON.stringify($ctrl.intakeData));
            $ctrl.isEditMode = true;
        }

        function cancelEditing() {
            $ctrl.intakeData = $ctrl.tempIntakeData;
            $ctrl.isEditMode = false;
        }

        function downloadFile(field) {

            var filename = field.value.replace('file:uploadroot/', '');
            FileUtil.downloadUploadedFile(filename);
        }

        function findColumnCountClass() {
            switch ($ctrl.columnCount) {
                case 1 :
                    return "col-sm-12";
                case 2 :
                    return "col-sm-6";
                case 3 :
                    return "col-sm-4";
                case 4 :
                    return "col-sm-3";
                case 6 :
                    return "col-sm-2";
            }
        }

        $scope.$watch('$ctrl.intakeData', function (intakeData) {
            if (intakeData) {
                $ctrl.isDataLoaded = true;
                angular.forEach(intakeData.fields, function (field) {
                    if (field.value) {
                        $ctrl.values[field.name] = field.value
                        if (field.value.startsWith('file:uploadroot')) {
                            field.isFile = true;
                            var filename = field.value.replace('file:uploadroot/', '');
                            field.href = ENV.API_BASE_URL + 'api/client/downloadfile?fileName=' + filename;
                        }


                        if (field.field.fieldType == 'CheckBox') {
                            field.checkValue = convertStringToBoolean(field.value);
                        }

                    }
                });

            }


        },true);

    }


    var Component_IntakeDataViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-viewer.template.html',
        controller: Component_IntakeDataViewerController,
        bindings: {
            intakeData: '=',
            columnCount: '='
        }

    };

    angular
        .module('tikonApp')
        .component('componentIntakeDataViewer', Component_IntakeDataViewer)

})();
;
(function () {
    'use strict';
    EO_IntakeFieldController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'SelectorDataQuery', 'DateUtil', 'DateUtils'];

    function EO_IntakeFieldController($scope, $attrs, $element, FileUtil, SelectorDataQuery, DateUtil, DateUtils) {
//  
        var $ctrl = this;
        $ctrl.selectableItems = [];
        $ctrl.selectableItemsFilled = false;
        $ctrl.dateValue = '';

        $scope.$watch('$ctrl.field', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });
        $scope.$watch('$ctrl.isEditMode', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });
        $scope.$watch('$ctrl.dateValue', function (val) {
            if (val) {
                var splitedDate = DateUtils.convertToPersianDate(val).date;
                $ctrl.field.value = splitedDate[0]+ "/" + splitedDate[1] + "/" + splitedDate[2];
            }


        });

        function fillSelectableItems() {
            if ($ctrl.isEditMode && !$ctrl.selectableItemsFilled && $ctrl.field.field && $ctrl.field.field.selectorDataTypeId) {
                SelectorDataQuery.findByTypeId($ctrl.field.field.selectorDataTypeId).query(function (data) {

                    if (data) {
                        $ctrl.selectableItems = [];
                        angular.forEach(data, function (item) {
                            $ctrl.selectableItems.push(item.text);
                        })
                        $ctrl.selectableItemsFilled = true;
                    }

                })
            }
        }
        if($ctrl.field.field.fieldType=='Date') {
            $ctrl.dateValue = DateUtil.jalaliToGregorian($ctrl.field.value);
        }

    }


    var EO_IntakeFieldViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data/eyeson.intake-field.template.html',
        controller: EO_IntakeFieldController,
        bindings: {
            field: '=',
            isEditMode: '<'
        }

    };

    angular
        .module('tikonApp')
        .component('eoIntakeField', EO_IntakeFieldViewer)

})();
;
(function () {
    'use strict';
    EO_IntakeDataViewerController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'OrderBagCustom', 'CompanyCustomerCustom', 'ENV'];

    function EO_IntakeDataViewerController($scope, $attrs, $element, FileUtil, OrderBagCustom, CompanyCustomerCustom, ENV) {
//
        var $ctrl = this;
        $ctrl.isDataLoaded = false;
        $ctrl.downloadFile = downloadFile;
        $ctrl.isEditMode = false;
        $ctrl.save = save;
        $ctrl.cancelEditing = cancelEditing;
        $ctrl.gotoEditMode = gotoEditMode;
        $ctrl.tempIntakeData = null;


        function save() {

            if ($ctrl.intakeData.intakeParentType != "COMPANY_CUSTOMER") {
                OrderBagCustom.updateIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;

                })
            }
            if ($ctrl.intakeData.intakeParentType == "COMPANY_CUSTOMER") {
                CompanyCustomerCustom.updateCustomerIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;

                })
            }


        }

        function gotoEditMode() {
            $ctrl.tempIntakeData = JSON.parse(JSON.stringify($ctrl.intakeData));
            $ctrl.isEditMode = true;
        }

        function cancelEditing() {
            $ctrl.intakeData = $ctrl.tempIntakeData;
            $ctrl.isEditMode = false;
        }

        function downloadFile(field) {

            var filename = field.value.replace('file:uploadroot/', '');
            FileUtil.downloadUploadedFile(filename);
        }

        $scope.$watch('$ctrl.intakeData', function (intakeData) {
            if (intakeData) {
                $ctrl.isDataLoaded = true;
                angular.forEach(intakeData.fields, function (field) {
                    if (field.value) {
                        if (field.value.startsWith('file:uploadroot')) {
                            field.isFile = true;
                            var filename = field.value.replace('file:uploadroot/', '');
                            field.href = ENV.API_BASE_URL + 'api/client/downloadfile?fileName=' + filename;
                        }

                    }
                });

            }


        });

    }


    var EO_IntakeDataViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data/eyeson.intake-data-viewer.template.html',
        controller: EO_IntakeDataViewerController,
        bindings: {
            intakeData: '<'
        }

    };

    angular
        .module('tikonApp')
        .component('eoIntakeDataViewer', EO_IntakeDataViewer)

})();
;
(function () {
    'use strict';

    function ImageUploadController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.myImage = '';
        $ctrl.myCroppedImage = '';
        $ctrl.cropImage = cropImage;

        // var el = document.getElementById('image-cropper');
        // debugger;
        // $ctrl.imageCropper = new Croppie(el, {
        //     viewport: { width: $ctrl.cropWidth, height: $ctrl.cropHeight },
        //     boundary: { width: $ctrl.minWidth, height: $ctrl.minHeight},
        //     showZoomer: true
        // });


        var handleFileSelect = function (evt) {

            var file = evt.currentTarget.files[0];

            var tempUrl = URL.createObjectURL(file);


            $ctrl.imageCropper.bind({
                url: tempUrl,
                zoom: 0.5
            });
        };

        function cropImage() {

            $ctrl.imageCropper.result('blob').then(function (blob) {

                $ctrl.myCroppedImage = "";
                var tempUrl = URL.createObjectURL(blob);
                $ctrl.myCroppedImage = tempUrl;

                if ($ctrl.onCroppedDone)
                    $ctrl.onCroppedDone();

                // var reader = new FileReader();
                // reader.onload = function (blob) {
                //     $scope.$apply(function($scope){
                //
                //
                //     });
                // };
            });
        }


        var handleFileSelect2 = function (evt) {


            var reader = new FileReader();
            reader.onload = function (e) {
                $ctrl.imageSrc = evt.target.result;
            };

            var file = evt.currentTarget.files[0];
            reader.readAsDataURL(file);
            setTimeout(initCropper, 1000);
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect2);

        setTimeout(initCropper, 1000);

        function initCropper() {
            var imageElem = document.getElementById('original-image');

            var minCroppedWidth = 119;
            var minCroppedHeight = 119;
            var maxCroppedWidth = 120;
            var maxCroppedHeight = 120;

            var cropper = new Cropper(imageElem, {
                // aspectRatio: 40 / 24,
                movable: false,
                zoomable: false,
                rotatable: false,
                scalable: false,
                cropBoxResizable: false,
                viewMode: 2,
                // data: {
                //     // width: 400,
                //     // height: 240,
                //     width: maxCroppedWidth
                //     // height: (minCroppedHeight + maxCroppedHeight) / 2,
                // },
                //
                crop: function (event) {
                    var width = event.detail.width;
                    var height = event.detail.height;

                    if (
                        width < minCroppedWidth
                        || height < minCroppedHeight
                        || width > maxCroppedWidth
                        || height > maxCroppedHeight
                    ) {
                        cropper.setData({
                            width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
                            height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
                        });
                    }

                }
            });
        }
    }

    var ImageUpload = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-upload/eyeson.image-upload.html',
        controller: ImageUploadController,
        bindings:
            {
                cropWidth: '<?',
                cropHeight: '<?',
                minWidth: '<?',
                minHeight: '<?',
                croppedImage: '=?',
                onCroppedDone: "=?"

            }

    };

    angular
        .module('tikonApp')
        .component('eoImageUpload', ImageUpload)

    ImageUploadController.$inject = ['$scope', '$attrs', '$element'];


})();

;
(function () {
    'use strict';
    ImageGalleryManagerV2Controller.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageData', 'ImageDataExtended', '$mdDialog', '$uibModal'];

    function ImageGalleryManagerV2Controller($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageData, ImageDataExtended, $mdDialog, $uibModal) {
//
        var $ctrl = this;
        $ctrl.keep_aspect = this.keepAspect || true;
        $ctrl.disableCropping = false || this.disableCropping;
        $ctrl.maxImageCount = this.maxImageCount || 10;
        $ctrl.cropWidth = this.cropWidth || 200;
        $ctrl.cropHeight = this.cropHeight || 200;
        $ctrl.minHeight = this.minHeight || $ctrl.cropHeight;
        $ctrl.minWidth = this.minWidth || $ctrl.cropWidth;
        $ctrl.bounds = {};
        $ctrl.bounds.left = 0;
        $ctrl.bounds.right = 0;
        $ctrl.bounds.top = 0;
        $ctrl.bounds.bottom = 0;
        $ctrl.caption = '';
        $ctrl.description = '';
        var albumInfoEntity;
        $ctrl.editMode = false;
        $ctrl.uploadImage = uploadImage;
        $ctrl.croppedDataUrl = '';
        $ctrl.croppedThumbDataUrl = '';
        $ctrl.sizeType = this.sizeType || 'CLIENT_SIZE';
        $ctrl.imageList = [];
        $ctrl.islargeFile = false;


        $ctrl.handleFileSelect = function (file) {

            $ctrl.islargeFile = false;
            var MAX_SIZE = 2048000;
            if (!file)
                return;

            if (file && file.size > MAX_SIZE) {
                $ctrl.islargeFile = true;
                $ctrl.file = null;
                if ($ctrl.cropper)
                    $ctrl.cropper.destroy();
                return;
            }

            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $ctrl.file = evt.target.result;
                    if ($ctrl.file.size > 2048) {
                        console.log("majid");
                        return;
                    }

                    var img = document.createElement("img");
                    img.onload = function (event) {
                        // Dynamically create a canvas element
                        var canvas = document.createElement("canvas");

                        // var canvas = document.getElementById("canvas");
                        var ctx = canvas.getContext("2d");


                        var imgWidth = img.width;
                        var imgHeight = img.height;


                        var ratioW = $ctrl.cropWidth / imgWidth;
                        var ratioH = $ctrl.cropHeight / imgHeight;

                        var ratio = Math.max(ratioH, ratioW);

                        if (ratio > 1) {
                            imgWidth = imgWidth * ratio;
                            imgHeight = imgHeight * ratio;
                        }

                        if (ratio < 0.5) {
                            imgWidth = imgWidth * (ratio + 0.05);
                            imgHeight = imgHeight * (ratio + 0.05);
                        }

                        canvas.width = imgWidth;
                        canvas.height = imgHeight;

                        // Actual resizing
                        ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

                        // Show resized image in preview element
                        var dataurl = canvas.toDataURL($ctrl.file.type);
                        document.getElementById("original-image").src = dataurl;


                        // document.getElementById("image-preview").src = dataurl;

                    }
                    img.src = evt.target.result;


                });
            };
            reader.readAsDataURL(file);
            setTimeout(initCropper, 1000);
        };

        function cropImage() {
            var canvas = $ctrl.cropper.getCroppedCanvas();
            var croppedDataUri = canvas.toDataURL("image/jpeg", 0.9);
            $ctrl.croppedDataUrl = croppedDataUri;
        }


        var imageList = [];
        $scope.$watch('$ctrl.albumId', function (albumId) {
            if ($ctrl.albumId) {

                $ctrl.albumInfoEntity = AlbumInfo.get({id: $ctrl.albumId});
                //$ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumId).query();
                $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
            }

        });


        $ctrl.currentImage = {};
        $ctrl.addImage = function () {
            $ctrl.editMode = true;
        }

        function initCropper() {
            var imageElem = document.getElementById('original-image');

            var croppedWidth = $ctrl.cropWidth;
            var croppedHeight = $ctrl.cropHeight;

            var minCroppedWidth = $ctrl.cropWidth - 1;
            var minCroppedHeight = $ctrl.cropHeight - 1;

            if ($ctrl.cropper)
                $ctrl.cropper.destroy();

            $ctrl.cropper = new Cropper(imageElem, {
                // aspectRatio: 1 / 2,
                movable: false,
                zoomable: false,
                rotatable: false,
                scalable: false,
                cropBoxResizable: false,
                viewMode: 2,
                // data: {
                //     width: $ctrl.minWidth + padding,
                //     height: $ctrl.minHeight + padding,
                // },

                crop: function (event) {
                    var width = event.detail.width;
                    var height = event.detail.height;

                    if (
                        width < minCroppedWidth
                        || height < minCroppedHeight
                        || width > croppedWidth
                        || height > croppedHeight
                    ) {
                        $ctrl.cropper.setData({
                            width: Math.max(minCroppedWidth, Math.min(croppedWidth, width)),
                            height: Math.max(minCroppedHeight, Math.min(croppedHeight, height)),
                        });
                    }

                }
            });
        }

        $ctrl.canBeAdded = function () {
            if ($ctrl.imageList)
                return ($ctrl.imageList.length >= $ctrl.maxImageCount);
            return false;
        }
        $ctrl.cancelEditing = function () {
            $ctrl.file = null;
            $ctrl.editMode = false;
        }
        $ctrl.deleteImage = function (img) {

            ImageData.delete({id: img.id},
                function () {
                    if ($ctrl.albumId)
                        $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                });
        }
        $ctrl.imagesrc = function (img) {
            //
            return DataUtils.imagesrc(img.fileDataContentType, img.fileData);
        }

        function addImage() {

        }

        function save() {
            $ctrl.isSaving = true;

            if ($ctrl.albumInfoEntity.id !== null) {
                AlbumInfo.update($ctrl.albumInfo);
            } else {
                AlbumInfo.save($ctrl.albumInfo, function (d) {
                    $ctrl.albumInfoEntity = d;
                });
            }
        }

        function uploadImage() {


            if (!($ctrl.albumInfoEntity && $ctrl.albumInfoEntity.id)) {
                albumInfoEntity = {caption: $ctrl.albumCaption};
                AlbumInfo.save(albumInfoEntity, function (d) {
                    $ctrl.albumInfoEntity = d;
                    $ctrl.albumId = d.id;
                    saveImage();
                }, function (e) {
                    //console.log(e)
                });

            } else {
                saveImage();
            }

        }

        function saveImage() {

            cropImage();

            var imageToUpload = {
                caption: $ctrl.caption,
                description: $ctrl.description,
                albumInfoId: $ctrl.albumInfoEntity.id
            }
            imageToUpload.sizeType = $ctrl.sizeType;

            if (!$ctrl.disableCropping) {
                imageToUpload.fileData = $ctrl.croppedDataUrl.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.croppedThumbDataUrl.split(',')[1];
            } else {
                console.log('not cropped');
                console.log($ctrl.file);
                imageToUpload.fileData = $ctrl.file.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.file.split(',')[1];
            }

            ImageDataExtended.uploadImage().save(imageToUpload, function (imageData) {
                if ($ctrl.albumInfoEntity.id) {
                    // $ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumInfoEntity.id).query();
                    $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                    $ctrl.editMode = false;
                    $ctrl.file = null;
                    if ($ctrl.onImageUploaded) {
                        $ctrl.onImageUploaded(imageToUpload);
                    }
                }
            });
        }

        $ctrl.chooseImage = function () {
            document.getElementById('fileSelector').click();
        }


    }


    var ImageGalleryManagerV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-gallery-manager-v2/eyeson.image-gallery-manager-v2.html',
        controller: ImageGalleryManagerV2Controller,
        bindings: {
            label: '<',
            albumId: '=',
            albumCaption: '<',
            cropWidth: '<?',
            cropHeight: '<?',
            minWidth: '<?',
            minHeight: '<?',
            maxImageCount: '<?',
            disableCropping: '<?',
            keepAspect: '<?',
            onImageUploaded: '=?',
            sizeType: '<?'
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('eoImageGalleryManagerV2', ImageGalleryManagerV2)


})();

;
(function () {
    'use strict';
    ImageGalleryManagerController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageData', 'ImageDataExtended', '$mdDialog'];

    function ImageGalleryManagerController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageData, ImageDataExtended, $mdDialog) {
//
        var $ctrl = this;
        $ctrl.keep_aspect = this.keepAspect || true;
        $ctrl.disableCropping = false || this.disableCropping;
        $ctrl.maxImageCount = this.maxImageCount || 10;
        $ctrl.cropWidth = this.cropWidth || 10;
        $ctrl.cropHeight = this.cropHeight || 10;
        $ctrl.minHeight = this.minHeight || $ctrl.cropHeight;
        $ctrl.minWidth = this.minWidth || $ctrl.cropWidth;
        $ctrl.bounds = {};
        $ctrl.bounds.left = 0;
        $ctrl.bounds.right = 0;
        $ctrl.bounds.top = 0;
        $ctrl.bounds.bottom = 0;
        $ctrl.caption = '';
        $ctrl.description = '';
        var albumInfoEntity;
        $ctrl.editMode = false;
        $ctrl.uploadImage = uploadImage;
        $ctrl.croppedDataUrl = '';
        $ctrl.croppedThumbDataUrl = '';
        $ctrl.sizeType = this.sizeType || 'CLIENT_SIZE';
        $ctrl.imageList = [];

        var imageList = [];
        $scope.$watch('$ctrl.albumId', function (albumId) {
            if ($ctrl.albumId) {

                $ctrl.albumInfoEntity = AlbumInfo.get({id: $ctrl.albumId});
                //$ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumId).query();
                $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
            }

        });


        $ctrl.currentImage = {};
        $ctrl.addImage = function () {
            $ctrl.editMode = true;
        }
        $ctrl.canBeAdded = function () {
            if ($ctrl.imageList)
                return ($ctrl.imageList.length >= $ctrl.maxImageCount);
            return false;
        }
        $ctrl.cancelEditing = function () {
            $ctrl.editMode = false;
        }
        $ctrl.deleteImage = function (img) {

            ImageData.delete({id: img.id},
                function () {
                    if ($ctrl.albumId)
                        $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                });
        }
        $ctrl.imagesrc = function (img) {
            //
            return DataUtils.imagesrc(img.fileDataContentType, img.fileData);
        }

        function addImage() {

        }

        function save() {
            $ctrl.isSaving = true;

            if ($ctrl.albumInfoEntity.id !== null) {
                AlbumInfo.update($ctrl.albumInfo);
            } else {
                AlbumInfo.save($ctrl.albumInfo, function (d) {
                    $ctrl.albumInfoEntity = d;
                });
            }
        }

        function uploadImage() {


            if (!($ctrl.albumInfoEntity && $ctrl.albumInfoEntity.id)) {
                albumInfoEntity = {caption: $ctrl.albumCaption};
                AlbumInfo.save(albumInfoEntity, function (d) {
                    $ctrl.albumInfoEntity = d;
                    $ctrl.albumId = d.id;
                    saveImage();
                }, function (e) {
                    //console.log(e)
                });

            } else {
                saveImage();
            }

        }

        function saveImage() {


            var imageToUpload = {
                caption: $ctrl.caption,
                description: $ctrl.description,
                albumInfoId: $ctrl.albumInfoEntity.id
            }
            imageToUpload.sizeType = $ctrl.sizeType;

            if (!$ctrl.disableCropping) {
                imageToUpload.fileData = $ctrl.croppedDataUrl.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.croppedThumbDataUrl.split(',')[1];
            } else {
                console.log('not cropped');
                console.log($ctrl.file);
                imageToUpload.fileData = $ctrl.file.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.file.split(',')[1];
            }

            ImageDataExtended.uploadImage().save(imageToUpload, function (imageData) {
                if ($ctrl.albumInfoEntity.id) {
                    // $ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumInfoEntity.id).query();
                    $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                    $ctrl.editMode = false;
                    if ($ctrl.onImageUploaded) {
                        $ctrl.onImageUploaded(imageToUpload);
                    }
                }
            });
        }

        $ctrl.handleFileSelect = function (file) {


            //  var file=evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $ctrl.file = evt.target.result;

                });
            };
            // if(file)
            reader.readAsDataURL(file);
        };

    }


    var ImageGalleryManager = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-gallery-manager/eyeson.image-gallery-manager.html',
        controller: ImageGalleryManagerController,
        bindings: {
            label: '<',
            albumId: '=',
            albumCaption: '<',
            cropWidth: '<?',
            cropHeight: '<?',
            minWidth: '<?',
            minHeight: '<?',
            maxImageCount: '<?',
            disableCropping: '<?',
            keepAspect: '<?',
            onImageUploaded: '&?',
            sizeType: '<?'
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('eoImageGalleryManager', ImageGalleryManager)


})();

;
(function () {
    'use strict';
    ImageGalleryController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageDataExtended', '$timeout'];

    function ImageGalleryController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageDataExtended, $timeout) {
//
        var $ctrl = this;
        var preparedImageList = [];

        $ctrl.preparedImageList = preparedImageList;
        var imageList = [];
        $ctrl.delete = function (index) {

            if ($ctrl.methods && $ctrl.methods.delete) {
                $ctrl.methods.delete($ctrl.imageList[index]);
            }

        }
        $scope.$watch('$ctrl.imageList', function (images) {

            $timeout(function () {
                if (images) {
                    preparedImageList = [];

                    angular.forEach(images, function (img) {
                        //console.log(img);
                        var title = img.caption;
                        if (img.description)
                            title = title + ":" + img.description;

                        preparedImageList.push({url: $ctrl.imagesrc(img), title: title});

                    });
                    $ctrl.preparedImageList = preparedImageList;
                    // $ctrl.addImageThumb();

                }
            }, 0);


        }, true)


        $ctrl.currentImage = {};
        $ctrl.imagesrc = function (img) {
            //
            if (img.thumbnailData)
                return DataUtils.imagesrc(img.fileDataContentType, img.thumbnailData);
            else
                return DataUtils.imagesrc(img.fileDataContentType, img.fileData);
        }

        $ctrl.addImageThumb = function () {
            $ctrl.defaultImage = $ctrl.preparedImageList[0];
            if ($ctrl.defaultImage) {
                var image = $ctrl.defaultImage.thumbUrl || $ctrl.defaultImage.url;
                // var node = document.createElement("div");
                //
                // node.id = 'imageThumb';
                // node.classList.add('pl-image-thumb');
                // node.style.backgroundImage = 'url('+image + ')';
                // node.ngClick = $ctrl.openImage();
                //
                var url = 'url(' + image + ')';

                var preview = document.getElementById("preview");
                preview.innerHTML += '<div class="pl-image-thumb" '
                    + ' style="background-image:' + url + '">' + '</div>';


            }
        }

        $ctrl.openImage = function () {
            console.log('sssssss');
        }

    }


    var ImageGallery = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-gallery/eyeson.image-gallery.html',
        controller: ImageGalleryController,
        bindings: {
            imageList: '<',
            methods: '=?'


        }

    };

    angular
        .module('tikonApp')
        .component('eoImageGallery', ImageGallery)


})();

;
angular.module("tikonApp")
    .directive("eoHelpTooltip", ['AlertService', function (alertService) {
        return {
            restrict: 'AE',
            replace: 'false',
            template: "",
            link: function (scope, elem, attrs) {
                var helpIcon = $('<a id=""' + attrs.eoHelpTooltip + '"><span  style="color: #a3ddf9;font-size: 17px;margin: 5px; top: 5px;" class="glyphicon glyphicon-question-sign"></span></a>');
                helpIcon.bind('click', function () {
                    alertService.showHelpMessage(helpIcon, attrs.eoHelpTooltip);
                    //alert(attrs.eoHelpTooltip);
                })
                helpIcon.insertAfter(elem);
                //elem.bind('click', function () {
                //    elem.css('background-color', 'white');
                //    scope.$apply(function () {
                //        scope.color = "white";
                //    });
                //});
                //elem.bind('mouseover', function () {
                //    elem.css('cursor', 'pointer');
                //});
            }
        };
    }]);


(function () {
    'use strict';
    HelpTipController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageDataExtended', '$timeout'];

    function HelpTipController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageDataExtended, $timeout) {
//
        var $ctrl = this;


    }


    var HelpTip = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/help-tip/eyeson.help-tip.html',
        controller: HelpTipController,
        bindings: {
            text: '@'
        }

    };

    angular
        .module('tikonApp')
        .component('eoHelpTip', HelpTip)


})();

;
(function () {
    'use strict';
    EO_FixedButtonController.$inject = ['$scope', '$attrs', '$element'];

    function EO_FixedButtonController($scope, $attrs, $element) {
//
        var $ctrl = this;

        document.addEventListener('scroll', function (e) {
            if (window.scrollY > 100)
                hideElement('fixedButtonText');
            else
                showElement('fixedButtonText');
        })

        function hideElement(id) {

            var fixedBtn = document.getElementById('fixedButton');
            if (!fixedBtn)
                return;
            var elem = document.getElementById(id);

            if (fixedBtn && elem && !elem.classList.contains('hide-element')) {
                elem.classList.add('hide-element');
                fixedBtn.style.width = '60px';
            }


        }

        function showElement(id) {
            var fixedBtn = document.getElementById('fixedButton');
            if (!fixedBtn)
                return;
            var elem = document.getElementById(id);
            if (elem.classList.contains('hide-element')) {
                elem.classList.remove('hide-element');
                fixedBtn.style.width = '120px';
            }


        }


    }


    var EO_FixedButton = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/fixed-button/eyeson.fixed-button.template.html',
        controller: EO_FixedButtonController,
        bindings: {
            'label': '@',
            'onClick': '&'
        }


    };

    angular
        .module('tikonApp')
        .component('eoFixedButton', EO_FixedButton)


})();

;
(function () {
    'use strict';

    function FileUploadController($scope, $attrs, $element, FileUtilCustom) {
//
        var $ctrl = this;
        $ctrl.myFile = '';
        $ctrl.file = '';
        $ctrl.openFile = openFile;
        $ctrl.prefixUrl = '';
        $ctrl.removeFile = removeFile;
        $ctrl.downloadFile = downloadFile;
        $ctrl.isUploading = false;
        $ctrl.randomId = (Math.random() + 1).toString(36).substring(7);

        // $ctrl.filePath = '';
        // $ctrl.myCroppedImage='';
        $ctrl.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0];
            $ctrl.file = file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                uploadToServer();
                // $scope.$apply(function($scope){
                //     $ctrl.myFile=evt.target.result;
                //
                // });
            };
            reader.readAsDataURL(file);
        };


        // angular.element(document.querySelectorAll('#fileInput')).on('change',handleFileSelect);


        function uploadToServer() {
            if (!$ctrl.file)
                return;
            var fd = new FormData();
            //Take the first selected file
            fd.append("file", $ctrl.file);
            $ctrl.isUploading = true;

            FileUtilCustom.supplierFileUploadToServer().upload(fd, onSaveSuccess, onSaveError);


        }


        function onSaveError() {
            $ctrl.isUploading = false;
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:fileUtilUpdate', result);

            $ctrl.isUploading = false;
            $ctrl.file = result;
            $ctrl.fileName = result.fileName;

        }

        function openFile() {
            if (!$ctrl.fileName)
                return;
            if (!$ctrl.prefixUrl) {
                FileUtilCustom.getFileUrlPrefix().query().$promise.then(function (result) {
                    $ctrl.prefixUrl = result.filePrefix;
                    var link = $ctrl.prefixUrl + '\\' + $ctrl.fileName;
                    window.open(link, '_blank');
                });


            } else {
                var link = $ctrl.prefixUrl + '\\' + $ctrl.fileName;
                window.open(link, '_blank');
            }
        }

        function downloadFile() {
            if (!$ctrl.fileName)
                return;

            FileUtilCustom.getSupplierFileDownloadLink($ctrl.fileName).query().$promise.then(function (result) {
                window.open(result.fileLink, '_blank');
            });
        }

        function removeFile() {
            $ctrl.file = null;
            $ctrl.fileName = null;
        }

        // $scope.$watch('$ctrl.fileName', function (fileName) {
        //
        //
        // })

    }

    var FileUpload = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/file-upload/eyeson.file-upload.html',
        controller: FileUploadController,
        bindings:
            {
                fileName: '='
            }

    };

    angular
        .module('tikonApp')
        .component('eoFileUpload', FileUpload)

    FileUploadController.$inject = ['$scope', '$attrs', '$element', 'FileUtilCustom'];


})();

;
angular.module("tikonApp")
    .directive("eoFeatureChecker", ['AlertService', 'Principal', 'PackageFeatureListCustom', function (alertService, Principal, PackageFeatureListCustom) {
        return {
            restrict: 'AE',
            replace: 'false',
            template: "",
            link: function (scope, element, attrs) {

                var helpIcon = $('<a id="' + attrs.eoFeatureChecker + '"><span  class="special-feature-style glyphicon glyphicon-lock"><div class="special-feature-text">ویژه</div></span></a>');
                var accessType = attrs.eoFeatureChecker;
                checkAccess(accessType);
                // element.addClass('package-no-access');

                helpIcon.bind('click', function () {
                    alertService.showHelpMessage(helpIcon, 'feature-info.' + attrs.eoFeatureChecker);
                    //alert(attrs.eoHelpTooltip);
                })

                helpIcon.insertBefore(element);


                function setAccessToFeature() {

                    element.removeAttr("disabled", "disabled");
                    element.removeAttr("ng-disabled", "true");
                    var myEl = angular.element(document.querySelector('#' + accessType));
                    myEl.addClass('package-no-access');

                }

                function setNoAccessToFeature() {
                    element.attr("disabled", "disabled");
                    element.attr("ng-disabled", "true");

                }

                function checkAccess(reset) {
                    var result;

                    if (reset) {
                        setAccessToFeature();
                    }


                    var _company = Principal.getCurrentCompany();

                    PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                        Principal.setCurrentCompanyFeatureList(result);


                        var accessResult = Principal.hasSpecialFeatureAccess(accessType);
                        if (accessResult) {
                            setAccessToFeature();
                        } else {
                            setNoAccessToFeature();
                        }


                    });


                };

                //elem.bind('click', function () {
                //    elem.css('background-color', 'white');
                //    scope.$apply(function () {
                //        scope.color = "white";
                //    });
                //});
                //elem.bind('mouseover', function () {
                //    elem.css('cursor', 'pointer');
                //});
            }
        };
    }]);


(function () {
    'use strict';
    FeatureCheckerController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', '$timeout'];

    function FeatureCheckerController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, $timeout) {
//
        var $ctrl = this;


    }


    var FeatureChecker = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/feature-checker/eyeson.feature-checker.html',
        controller: FeatureCheckerController,
        bindings: {
            text: '@'
        }

    };

    angular
        .module('tikonApp')
        .component('eoFeatureChecker', FeatureChecker)


})();

;
(function () {
    'use strict';
    EditableInputController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageDataExtended', '$timeout'];

    function EditableInputController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageDataExtended, $timeout) {
//
        var $ctrl = this;
        $ctrl.mode = 0;
        $ctrl.isReadonly = true;
        $ctrl.gotoEditMode = gotoEditMode;
        $ctrl.confirmEdit = confirmEdit;
        $ctrl.cancelEdit = cancelEdit;
        $ctrl.isEditable = true;
        var oldValue = $ctrl.value;


        function gotoEditMode() {

            var oldValue = $ctrl.value;
            $ctrl.mode = 1;
            $ctrl.isReadonly = false;
        }

        function confirmEdit() {

            var ok = $ctrl.onConfirmEdit({value: $ctrl.value});
            if (ok) {
                $ctrl.mode = 0;
                $ctrl.isReadonly = true;
            }
        }

        function cancelEdit() {

            $ctrl.value = oldValue;
            $ctrl.mode = 0;
            $ctrl.isReadonly = true;
        }


    }


    var EditableInput = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/editable-input/eyeson.editable-input.html',
        controller: EditableInputController,
        bindings: {
            value: '=',
            onConfirmEdit: '&',
            isEditable: '<?'

        }

    };

    angular
        .module('tikonApp')
        .component('eoEditableInput', EditableInput)


})();

;
(function () {
    'use strict';
    EO_PersianDatePicker.$inject = ['$scope', '$attrs', '$element'];

    function EO_PersianDatePicker($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.makeOffDateListFormat = function (offDateList) {
            var offDateListAsString = '';
            if ($ctrl.offDateList && $ctrl.offDateList != undefined && Array.isArray($ctrl.offDateList))
                offDateListAsString = offDateList.join();
            return offDateListAsString;

        }
        $ctrl.offDays = $ctrl.makeOffDateListFormat($ctrl.offDateList);

        $ctrl.today = function () {
            $ctrl.dateValue = new Date();
        };
        //  $ctrl.today();

        $ctrl.clear = function () {
            $ctrl.dateValue = null;
        };


        $scope.$watch('$ctrl.dateValue', function (newValue, oldValue) {
            $element[0].querySelector(".input").value = new Date(newValue).toLocaleDateString("fa")
        });


        setTimeout(function () {
            if ($ctrl.dateValue) $element[0].querySelector(".input").value = new Date($ctrl.dateValue).toLocaleDateString("fa")

        }, 10)

        // Disable weekend selection
        $ctrl.disabled = function (date, mode) {
            var hasoffDaysOfWeek = ($ctrl.offDaysOfWeek && $ctrl.offDaysOfWeek != undefined && Array.isArray($ctrl.offDaysOfWeek));
            return (mode === 'day' && hasoffDaysOfWeek && $ctrl.offDaysOfWeek.indexOf(date.getDay()) >= 0);
        };

        //$ctrl.toggleMin = function() {
        //    $ctrl.minDate = $ctrl.minDate ? null : new Date();
        //};
        //   $ctrl.toggleMin();

        $ctrl.openPersian = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $ctrl.persianIsOpen = true;
            $ctrl.gregorianIsOpen = false;
        };
        $ctrl.openGregorian = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $ctrl.gregorianIsOpen = true;
            $ctrl.persianIsOpen = false;
        };

        $ctrl.dateOptions = {
            formatYear: 'yy',
            startingDay: 6

        };

        $ctrl.initDate = new Date();
        $ctrl.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $ctrl.format = $ctrl.formats[1];
        $ctrl.showWeeks = false;

        console.log($ctrl.input)

    }


    var EO_PersianDatePicker = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/date-picker/eyeson.date-picker.template.html',
        controller: EO_PersianDatePicker,
        bindings: {
            dateValue: '=',
            offDateList: '<?',
            minDate: '<?',
            maxDate: '<?',
            offDaysOfWeek: '<?',
            isRequired: '<?',
            id: '<',
            label: '<'

            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('eoDatePicker', EO_PersianDatePicker)


})();


//
//angular.module('tikonApp').directive('eoDatePicker', function() {
//    return {
//        restrict: 'E',
//        scope: false,
//        transclude: true,
//        templateUrl: 'app/components/eyeson/date-picker/eyeson.date-picker.template.html',
//
//        link: function ($scope, $element, $attrs, $controller) {
//            $scope.today = function() {
//                $scope.dt = new Date();
//            };
//            $scope.today();
//
//            $scope.clear = function () {
//                $scope.dt = null;
//            };
//
//            // Disable weekend selection
//            $scope.disabled = function(date, mode) {
//                return ( mode === 'day' &&date.getDay() === 5  );
//            };
//
//            $scope.toggleMin = function() {
//                $scope.minDate = $scope.minDate ? null : new Date();
//            };
//            $scope.toggleMin();
//
//            $scope.openPersian = function($event) {
//                $event.preventDefault();
//                $event.stopPropagation();
//
//                $scope.persianIsOpen = true;
//                $scope.gregorianIsOpen = false;
//            };
//            $scope.openGregorian = function($event) {
//                $event.preventDefault();
//                $event.stopPropagation();
//
//                $scope.gregorianIsOpen = true;
//                $scope.persianIsOpen = false;
//            };
//
//            $scope.dateOptions = {
//                formatYear: 'yy',
//                startingDay: 6
//            };
//
//            $scope.initDate =new Date();
//            $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
//            $scope.format = $scope.formats[1];
//            $scope.showWeeks=false;
//
//        }
//    }
//});
;
(function () {
    'use strict';
    EO_DateDurationSelectorController.$inject = ['$scope', '$attrs', '$element'];

    function EO_DateDurationSelectorController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.showEndDate = false;
        $ctrl.disableEndTime = false;

        $ctrl.showEndDate_changed = showEndDate_changed;
        $ctrl.getClass = getClass;
        $ctrl.minStartDate = new Date();

        loadAll();

        function loadAll() {
            if (!$ctrl.displayMode)
                $ctrl.displayMode = 'HORIZONTAL'; // HORIZONTAL - VERTICAL
        }

        function showEndDate_changed() {
            if (!$ctrl.showEndDate)
                $ctrl.endDate = null;
        }

        function getClass() {
            if ($ctrl.displayMode == 'VERTICAL')
                return 'col-lg-12 col-md-12 vertical-mode';
            else
                return 'col-lg-4 col-md-4';
        }

    }


    var EO_DateDurationSelector = {
        templateUrl: 'app/components/eyeson/date-duration-selector/eyeson.date-duration-selector.template.html',
        controller: EO_DateDurationSelectorController,
        bindings: {
            startDate: '=',
            endDate: '=',
            onlyShowStartDate: '=?',
            showEndDate: "=?",
            displayMode: "=?"
        }

    };

    angular
        .module('tikonApp')
        .component('eoDateDurationSelector', EO_DateDurationSelector)


})();
;
angular.module('tikonApp').directive('eoCalendar', ['DateUtil', '$mdDialog', '$timeout', 'TimingInfo', '$localStorage', '$state', 'CompanyCustom', 'DateUtils', 'Principal', 'ENV',
    function (dateUtil, $mdDialog, $timeout, timingInfo, $localStorage, $state, CompanyCustom, DateUtils, Principal, ENV) {
        return {
            restrict: 'A',
            scope: {calendarFilter: '=', refreshTimingInfo: '&?', accessLevel: '<?', lastUpdate: '='},
            transclude: true,
            templateUrl: 'app/components/eyeson/calendar/eyeson.calendar.template.html',

            link: function ($scope, $element, $attrs, $controller) {

                var scheduleIsLoaded = false;
                var eventsInited = false;
                var onCratingNewEvent = false;
                var serviceId;
                var canSeeReserve = true;
                var currentCompany = null;
                var appVersion = 'v3';
                var hasNewReserveAuthority = true;
                //console.log($scope.schedulerApi);
                //  $scope.schedulerApi.refreshScheduler = refreshScheduler;
                //adjust size of a scheduler
                $timeout(function () {
                    if ($scope.calendarFilter) {
                        CompanyCustom.getCurrentCompany().query().$promise.then(function (com) {
                            currentCompany = com;
                            appVersion = com.appVersion;
                            initSchedule();
                            configScheduler();
                        })
                    }
                }, 0);

                $timeout(function () {
                    $scope.$watch('lastUpdate', function (serviceItemId) {
                        if ($scope.lastUpdate && $scope.calendarFilter && $scope.calendarFilter.serviceList && $scope.calendarFilter.serviceList.length > 0)
                            refreshScheduler();
                    });


                    /*   $scope.$watch('calendarFilter', function (serviceItemId) {
                           if ($scope.calendarFilter.serviceList && $scope.calendarFilter.serviceList.length > 0)
                               refreshScheduler();
                       });*/
                }, 50);


                function refreshScheduler() {
                    //   alert('refresh called');
                    initSchedule();
                    configScheduler();
                    setSchedulerDataSource();
                }

                function checkAuthority() {

                    hasNewReserveAuthority = true;

                    // Principal.hasAuthority("ROLE_RESERVATION_MODIFIER").then(function (has) {
                    //     if(has)
                    //         hasNewReserveAuthority = true;
                    //     else
                    //         hasNewReserveAuthority = false;
                    // })
                }

                function configScheduler() {


                    checkAuthority();
                    scheduleIsLoaded = false;
                    var first_hour = 0;
                    var last_hour = 24;
                    if ($scope.calendarFilter) {
                        if ($scope.calendarFilter.firstHour || $scope.calendarFilter.firstHour === 0)
                            first_hour = $scope.calendarFilter.firstHour;
                        else
                            first_hour = $scope.calendarFilter.firstHour = 6;
                        if ($scope.calendarFilter.lastHour && $scope.calendarFilter.lastHour <= 24)
                            last_hour = $scope.calendarFilter.lastHour;
                        else
                            last_hour = $scope.calendarFilter.lastHour = 24;

                    }
                    var limit_start = new Date();
                    // var limit_end = new Date('3000-01-01')
                    var limit_end = DateUtils.newDate('3000-01-01');

                    scheduler.config.first_hour = first_hour;
                    scheduler.config.last_hour = last_hour;
                    scheduler.config.limit_start = limit_start;
                    scheduler.config.limit_end = limit_end;
                    scheduler.config.limit_view = true;


                    clearSchedule();
                }

                function onDoubleClick(id, e) {
                    if (!onCratingNewEvent)
                        scheduler.showLightbox(id);
                }


                function convertWeekNameToOrder(day) {
                    var index = DAYS_VALUES.indexOf(day);
                    if (index == 0) return 6;
                    return index - 1;

                }

                function clearSchedule() {
                    scheduler.clearAll();
                    scheduler.deleteMarkedTimespan();
                }

                function makeListToString(list) {
                    var retString = "";
                    if (list && list.length > 0) {
                        angular.forEach(list, function (item) {
                            retString = retString + "," + item;
                        })
                    } else {
                        return 'any';
                    }

                    return retString;
                }


                function setSchedulerDataSource() {


                    scheduler.setLoadMode("week");

                    var servants = $scope.calendarFilter.servantList;

                    // if(servants && servants.length>1 && $scope.calendarFilter.selectedServant != 'SHOW_ALL')
                    // {
                    //     var old = servants ;
                    //     servants = [];
                    //     servants.push(old[0]);
                    // }

                    var services = [];
                    if ($scope.calendarFilter.filterServices)
                        services = $scope.calendarFilter.serviceList;

                    if (currentCompany) {
                        scheduler.load(ENV.API_BASE_URL + "api/client/getSchedulerEventByFilter/" + makeListToString(services) + "/" + makeListToString(servants) + "/" + makeListToString($scope.calendarFilter.reserveTypes) + "/" + currentCompany.id, "json", function (data) {
                        });
                        refreshBlockTime();
                    }

                }

                function refreshBlockTime() {
                    var types = [];
                    types.push("FREE");

                    var serviceListId = $scope.calendarFilter.serviceList;
                    if ($scope.calendarFilter.selectedServantServiceList) {
                        serviceListId = [];
                        for (var i = 0; i < $scope.calendarFilter.selectedServantServiceList.length; i++) {
                            if ($scope.calendarFilter.selectedServantServiceList[i].serviceMode && $scope.calendarFilter.selectedServantServiceList[i].serviceMode == 'EVENT')
                                continue;
                            else
                                serviceListId.push($scope.calendarFilter.selectedServantServiceList[i].id);
                        }

                    }
                    var selectedServantId = [];
                    for (var i = 0; i < $scope.calendarFilter.servantList.length; i++) {
                        // selectedServantId.push($scope.calendarFilter.servantList[i].id);
                        selectedServantId.push($scope.calendarFilter.servantList[i]);
                    }

                    // if($scope.calendarFilter.selectedServant)
                    // {
                    //     if($scope.calendarFilter.selectedServant == 'SHOW_ALL')
                    //     {
                    //         for(var i=0;i<$scope.calendarFilter.servantList.length;i++)
                    //         {
                    //             selectedServantId.push($scope.calendarFilter.servantList[i].id);
                    //         }
                    //     }
                    //     else
                    //         selectedServantId.push($scope.calendarFilter.selectedServant);
                    // }

                    var multiServant = false;
                    if (selectedServantId.length > 1)
                        multiServant = true;
                    scheduler._set_block_url(ENV.API_BASE_URL + "api/getScheduledFreeDayTimesByFilter/" + makeListToString(serviceListId) + "/" + makeListToString(selectedServantId) + "/" + makeListToString(types) + "/" + $scope.calendarFilter.firstHour + "/" + $scope.calendarFilter.lastHour, multiServant);
                    // scheduler._load_block_time();

                }

                function AddNewTimeSession(ev) {
                    var timeSpan = {
                        startTime: DateUtils.newDate(ev.start_date),
                        endTime: DateUtils.newDate(ev.end_date),
                        serviceItemId: serviceId
                    };
                    timingInfo.addNewTimeSession().save(timeSpan);

                    onCratingNewEvent = false;

                }

                function setEventStyle(start, end, ev) {
                    var retclass = "event-box ";

                    if (ev.serviceImage) {
                        retclass = retclass + "Calendar-" + ev.serviceImage;
                    } else {
                        retclass += "COLOR0";
                    }
                    if (ev.orderBagStatusList && ev.orderBagStatusList.length > 0) {

                    } else {
                        retclass += ' inactive'
                    }
                    return retclass;

                    //if(ev.hidden)
                    //{
                    //    return "scheduler_hidden_event";
                    //}


                    //if(ev.reserveRequestCount>0)
                    //{
                    //    return "scheduler_has_orders_to_confirm"
                    //}
                    //if(ev.waitToPayRequestCount>0)
                    //{
                    //    return "scheduler_has_orders_to_pay"
                    //}
                    //if (!ev.enable) {
                    //    return "scheduler_not_enable";
                    //}
                    //if (!ev.capacity > 0) {
                    //    return "scheduler_no_capacity";
                    //
                    //}
                    //if(ev.confirmedRequestCount>0)
                    //{
                    //    return "scheduler_has_confirmed_orders"
                    //}


                }

                function initSchedule() {

                    //styling for dhtmlx scheduler
                    $element.addClass("dhx_cal_container schedule_container");

                    scheduler.config.start_on_monday = false;
                    //scheduler.config.show_loading = true;
                    //init scheduler
                    //
                    scheduler.templates.event_class = setEventStyle;

                    var mode = "week";
                    var start_date = new JDate();
                    if ($localStorage.timeline_mode != undefined)
                        mode = $localStorage.timeline_mode;

                    if ($localStorage.timeline_startDate != undefined) {
                        start_date.date[0]
                        var d = $localStorage.timeline_startDate;
                        if (d.date != undefined && d.date[0] != undefined)
                            start_date = new JDate(d.date[0], d.date[1], d.date[2]);
                    }
                    if ($localStorage.calendarFilter.selectionMode) {
                        mode = $localStorage.calendarFilter.selectionMode;
                        setWeekTabButtonStatus($localStorage.calendarFilter.selectionMode);

                    }

                    if (screen.width <= 480) {
                        mode = "day";
                        scheduler.init($element[0], start_date, "day");
                    }
                    scheduler.init($element[0], start_date, mode);

                    scheduler.config.icons_select = [
                        //"icon_details",
                        //
                        //"icon_delete"
                    ];

                    scheduler.attachEvent("onClick", onDoubleClick);
                    scheduler.attachEvent("onEventAdded", function (e, event) {
                        //   AddNewTimeSession(event);
                    });
                    scheduler.attachEvent("onEventCreated", function (e) {
                        onCratingNewEvent = true;
                    });
                    scheduler.attachEvent("onEventCancel", function (e) {
                        onCratingNewEvent = false;
                    });
                    scheduler.attachEvent("onBeforeViewChange", function (old_mode, old_date, mode, date) {
                        $localStorage.timeline_mode = mode;

                        $localStorage.timeline_startDate = date;
                        //any custom logic here
                        return true;
                    });
                    //   scheduler.templates.event_text = eventTextTemplate;
                    scheduler.templates.tooltip_text = eventTooltipTemplate;
                    scheduler.renderEvent = function (container, ev) {

                        var container_width = container.style.width; // e.g. "105px"
                        var colorstyle = '';

                        // move section
                        var html = "<div class='dhx_event_move my_event_move' style='width: " +
                            container_width + "'></div>";

                        // container for event's content
                        html += "<div class='my_event_body'>";
                        html += "<div class='event_first_line'>";
                        html += "<span class='event_date'>";
                        //two options here:show only start date for short events or start+end for long
                        if ((ev.end_date - ev.start_date) / 60000 > 40) {//if event is longer than 40 minutes
                            html += scheduler.templates.event_header(ev.end_date, ev.start_date, ev);
                            html += "</span><br/>";
                        } else {

                            // var w = DateUtils.changeJDateTimeToTehran(ev.start_date);
                            html += scheduler.templates.event_date(ev.start_date) + "</span>";
                        }

                        html += "</div>";

                        html += makeCustomerHtml(ev.customerName, ev.customerPhoneNumber, ev.multiCustomer);

                        if ((ev.end_date - ev.start_date) / 60000 > 40) {//if event is longer than 40 minutes
                            html += makeServantTitleHtml(ev.servantTitle);

                        }
                        if ((ev.end_date - ev.start_date) / 60000 >= 60) {
                            html += makeTagsHtml(ev.tags);
                        }

                        // displaying event's text
                        html += "<span>" + scheduler.templates.event_text(ev.start_date, ev.end_date, ev) +
                            "</span>" + "</div>";

                        // resize section
                        html += "<div class='dhx_event_resize my_event_resize' style='width: " +
                            container_width + "'></div>";

                        container.innerHTML = html;
                        return true; //required, true - display a custom form, false - the default form
                    };
                    dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip pl-tooltip';
                    dhtmlXTooltip.config.timeout_to_display = 500;
                    scheduler.config.separate_short_events = true;
                    //scheduler.config.hour_size_px = 70;
                    dhtmlXTooltip.config.delta_x = 15;
                    dhtmlXTooltip.config.delta_y = -20;
                    function eventTextTemplate(start, end, event) {
                        return '<span style="background-color: yellow">' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';


                    }

                    function setWeekTabButtonStatus(selectionMode) {
                        var element = document.getElementById('week_tab');
                        if (selectionMode && selectionMode == 'day') {
                            if (!element.classList.contains('hide-week-tab'))
                                element.classList.add("hide-week-tab");
                        } else {
                            if (element.classList.contains('hide-week-tab'))
                                element.classList.remove("hide-week-tab");
                        }
                    }

                    function eventTooltipTemplate(start, end, event) {


                        var time = "<p style='text-align:center;font-weight: bold'>" + getTimeFormat(end) + " - " + getTimeFormat(start) +
                            "</p>";
                        var status = "<p class='pl-tooltip-status pl-tooltip-status-" + event.orderBagStatus + "'>" + findStatusTitle(event) + "</p>";
                        var tooltipHtml = '<div class="scheduler_tooltip" >'
                            + '<div class="pl-tooltip-header">'
                            + time
                            + status
                            + '</div>' +

                            '<p>' + event.serviceTitle + '</p>';

                        if (event.servantTitle)
                            tooltipHtml += '<p>' + event.servantTitle + '</p>';

                        if (event.customerName)
                            tooltipHtml += '<p style="font-weight: bold">' + event.customerName + '</p>';


                        tooltipHtml += '</div>';
                        return tooltipHtml;
                    };
                    var lightBoxForm = document.getElementById("light_box_form");
                    isShowing = false;
                    scheduler.showLightbox = function (id) {
                        var ev = scheduler.getEvent(id);


                        ev.updateEvent = function () {
                            scheduler.updateEvent(id);
                        };
                        if (!isShowing) {

                            showCustomLightBox(ev, $scope.refreshTimingInfo);
                            isShowing = true;
                        }
                        //     scheduler.startLightbox(id, lightBoxForm);
                        //...'here you need to set values in the form'...
                        //document.getElementById("some_input").value = ev.text;
                    }
                    scheduler.showLightbox_addNew = function (id) {
                        var date_to_add = scheduler._make_date_time_from_splice_id(id);
                        var _dialogData = {};

                        _dialogData.start_date = date_to_add;
                        _dialogData.servantId = $scope.calendarFilter.selectedServant;
                        _dialogData.servantTitle = $scope.calendarFilter.servantTitle;
                        gotoNewReserve(_dialogData);
                        // showCustomLightBox(_dialogData, $scope.refreshTimingInfo);
                        // isShowing = true;

                        //     scheduler.startLightbox(id, lightBoxForm);
                        //...'here you need to set values in the form'...
                        //document.getElementById("some_input").value = ev.text;
                    }

                    //clearSchedule();
                    //scheduler.updateView();
                    //clearSchedule();
                }

                gotoNewReserve = function (_dialogData) {
                    // $mdDialog.hide();
                    if (!hasNewReserveAuthority)
                        return;

                    var s_date, e_date = null;
                    if (_dialogData.start_date) {
                        s_date = _dialogData.start_date;


                        //FUCK REGIME !!!!!!!!!!
                        //Check Date - 6 month of the year
                        var pDate = DateUtils.convertToPersianDate(s_date);

                        if (pDate.getMonth() < 7) {
                            s_date = new Date(s_date.setHours(s_date.getHours()));
                        }
                        s_date = s_date.toISOString()

                    }
                    if (_dialogData.end_date)
                        e_date = _dialogData.end_date.toISOString();


                    if (appVersion == 'v3') {
                        //majid alan
                        $state.go('supplierPanel-v2.new-reserve-modal', {
                            serviceItemId: _dialogData.serviceItemId,
                            servantId: _dialogData.servantId,
                            start_date: s_date,
                            end_date: e_date,
                            hasCustomTime: true
                        });

                    }

                    if (appVersion == 'v2') {
                        $state.go('supplierPanel.new-reserve-modal', {
                            serviceItemId: _dialogData.serviceItemId,
                            servantId: _dialogData.servantId,
                            start_date: s_date,
                            end_date: e_date,
                            hasCustomTime: true
                        });

                    }

                    /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                     serviceItemId: serviceItemId,
                     timeSessionId: dialogData.id
                     });

                     window.open(url,'_blank');*/
                    //   window.open(url,'_self');

                }

                function getTimeFormat(d) {
                    var date = DateUtils.newDate(d);
                    // date = DateUtils.toTehranTime(date);

                    date = moment(date);

                    return date.format("HH:mm");
                }

                function makeServantTitleHtml(servantTitle) {
                    var retHtml = "";
                    if (servantTitle) {
                        retHtml += "<div class='servant-section'> <span class='material-icons' style='font-size: 13px ; float:right'>assignment_ind</span>" + "<span class='servant-title-on-event' >"
                            + servantTitle + "</span> </div>";
                    }
                    return retHtml;

                }

                function makeTagsHtml(tags) {

                    var retHtml = "";


                    if (tags && tags.length) {
                        if(tags[0]) retHtml+= "<span>"+tags[0].tag+"</span>"
                        if(tags[1]) retHtml+= "<span>"+tags[1].tag+"</span>"
                        if(tags.length > 2) retHtml+= "<span>+"+ (tags.length-2) +"</span>"
                        return '<div class="orderbag-tags">'+retHtml+'</div>'
                    }
                    else  return ""

                }

                function makeCustomerHtml(customerName, customerPhone, isMultiCustomer) {
                    var retHtml = "";
                    if (customerName) {
                        retHtml += "<div class='servant-section'> <span class='material-icons' style='font-size: 13px ; float:right'>person</span>" + "<span class='customer-title-on-event' >"
                            + customerName + "</span> </div>";
                    }


                    return retHtml;

                }

                function findStatusTitle(event) {
                    switch (event.orderBagStatus) {
                        case 1 :
                            return 'تائید شده';
                        case 5 :
                            return 'درخواست رزرو';
                        case 6 :
                            return 'در انتظار پرداخت';
                    }
                }

                function showCustomLightBox(dialogData, refreshTimingInfoMethod) {

                    $mdDialog.show({
                        locals: {dialogData: dialogData, refreshTimingInfoMethod: refreshTimingInfoMethod},
                        controller: TimeSessionDetailController,
                        controllerAs: '$ctrl',
                        templateUrl: 'app/components/eyeson/calendar/eyeson.scheduler-time-session-dialog.template.html',
                        parent: angular.element(document.body),
                        targetEvent: dialogData,
                        clickOutsideToClose: true,
                        fullscreen: false// Only for -xs, -sm breakpoints.
                    })
                        .then(function (ev) {

                            isShowing = false;


                        }, function () {

                            isShowing = false;
                        });
                };
                var TimeSessionDetailController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
                    var $ctrl = this;
                    $ctrl.dialogData = dialogData;
                    $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;
                    //$ctrl.dialogData = {
                    //    id: dialogData.id,
                    //    price: dialogData.price,
                    //    capacity: dialogData.capacity,
                    //    enable: dialogData.enable,
                    //    discount: dialogData.discount,
                    //    isNew:dialogData.isNew
                    //};

                    var startDate = new JDate(dialogData.start_date);
                    // var startTime = toDateTimeTehranZone(dialogData.start_date);
                    var endDate = null;
                    var endTime = null;
                    if (dialogData.end_date)
                        endDate = new JDate(dialogData.end_date);
                    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                    if (startDate) {
                        $ctrl.title = startDate.format('dddd DD MMMM ');
                        $ctrl.title += formatTime(startDate);
                        if (endDate)
                            $ctrl.title += ' تا ' + formatTime(endDate);


                    }

                    function formatTime(time) {

                        var hour = time.format('HH');
                        var minute = time.format('SS');

                        hour = twoDigitFormat(hour);
                        minute = twoDigitFormat(minute);

                        return hour + ":" + minute;
                    }

                    function twoDigitFormat(input) {

                        var str = input.toString();
                        if (str.length < 2)
                            str = "0" + str;

                        return str;
                    }

                    function toDateTimeTehranZone(date) {
                        var x = new JDate(date);
                        var y = x._d;
                        var inputDate = new moment(y);
                        var tehranTime = inputDate.tz("Asia/Tehran");
                        return tehranTime;
                    }


                    $ctrl.hideDialog = function () {
                        $mdDialog.hide();
                    };

                    $ctrl.cancelDialog = function () {
                        $mdDialog.cancel();
                    };
                    $ctrl.copyTSimilarTimes = function () {
                        if (confirm("در صورت تایید ، خصوصیات این زمان در دیگر زمانهای این سرویس که ساعت مشابهی دارند کپی می شود. آیا اطمینان دارید؟")) {
                            TimingInfo.updateToSimilarTimeSessions($ctrl.dialogData.id).get(function () {
                                alert("تغییرات با موفقیت انجام شد. برای مشاهده دکمه بازیابی تقویم کاری را بزنید")
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        }
                    }

                    $ctrl.gotoNewReserve = function (serviceItemId) {

                        $mdDialog.hide();
                        if (appVersion == 'v3') {
                            $state.go('supplierPanel-v2.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
                                end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
                            });
                        }
                        if (appVersion == 'v2') {
                            $state.go('supplierPanel.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
                                end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
                            });
                        }
                        /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                         serviceItemId: serviceItemId,
                         timeSessionId: dialogData.id
                         });

                         window.open(url,'_blank');*/
                        //   window.open(url,'_self');

                    }

                    $ctrl.gotoNewReserve_flex = function () {
                        $mdDialog.hide();

                        var s_date, e_date = null;
                        if (dialogData.start_date)
                            s_date = dialogData.start_date.toISOString();
                        if (dialogData.end_date)
                            e_date = dialogData.end_date.toISOString();


                        if (appVersion == 'v3') {
                            $state.go('supplierPanel-v2.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: s_date,
                                end_date: e_date,
                                hasCustomTime: true
                            });

                        }
                        if (appVersion == 'v2') {
                            $state.go('supplierPanel.new-reserve-modal', {
                                serviceItemId: dialogData.serviceItemId,
                                servantId: dialogData.servantId,
                                start_date: s_date,
                                end_date: e_date,
                                hasCustomTime: true
                            });

                        }


                        /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                         serviceItemId: serviceItemId,
                         timeSessionId: dialogData.id
                         });

                         window.open(url,'_blank');*/
                        //   window.open(url,'_self');

                    }

                    $ctrl.updateCapacity = function (value) {

                        $ctrl.dialogData.capacity = null;

                        if ($ctrl.dialogData.floatTime) {
                            $ctrl.dialogData.capacity = value;
                            $ctrl.upsertFloatTimeSession($ctrl.dialogData);
                        } else
                            TimingInfo.changeTimeSessionCapacity($ctrl.dialogData.id, value).get(function () {
                                dialogData.capacity = value;
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                                $ctrl.refreshTimingInfoMethod();
                            });
                        return true;
                    }
                    $ctrl.updateDiscount = function (value) {
                        if (data.floatTime) {
                            $ctrl.dialogData.discount = value;
                            $ctrl.upsertFloatTimeSession(data);
                        } else
                            TimingInfo.changeTimeSessionDiscount($ctrl.dialogData.id, value).get(function () {
                                dialogData.discount = value;
                                //   $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        return true;
                    }
                    $ctrl.gotoOrderBag = function (id) {
                        $mdDialog.hide();
                        $state.go('supplierPanel-v2.editOrderBag', {id: id});

                    }
                    $ctrl.changeEnable = function (data) {

                        //if(data.floatTime)
                        //{
                        data.enable = !data.enable;
                        $ctrl.upsertFloatTimeSession(data);
                        //}
                        //else
                        //TimingInfo.changeTimeSessionEnable(data.id).get(function () {
                        //    $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
                        //    dialogData.enable = $ctrl.dialogData.enable;
                        //    dialogData.updateEvent();
                        //});
                    }
                    $ctrl.upsertFloatTimeSession = function (ev) {
                        ev.start_date = DateUtils.newDate(ev.start_date);
                        ev.end_date = new Date(ev.end_date);
                        ev.orderBagStatusList = [0, 1];
                        //      var timeSpan={startTime:new Date(ev.start_date),endTime: new Date( ev.end_date),serviceItemId:serviceId};
                        timingInfo.upsertFloatTimeSession().save(ev, function (result) {

                            $ctrl.refreshTimingInfoMethod();
                            $ctrl.cancelDialog();
                        });

                        onCratingNewEvent = false;

                    }
                    $ctrl.saveDialog = function (answer) {
                        dialogData.price = $ctrl.dialogData.price;
                        dialogData.discount = $ctrl.dialogData.discount;
                        dialogData.capacity = $ctrl.dialogData.capacity;
                        dialogData.enable = $ctrl.dialogData.enable;
                        dialogData.updateEvent();
                        $mdDialog.hide(answer);
                    };
                }
                TimeSessionDetailController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils'];


            }//end of link method
        }
    }]);
;
// angular.module('tikonApp').directive('eoCalendar', ['DateUtil', '$mdDialog', '$timeout', 'TimingInfo', '$localStorage','$state','CompanyCustom','DateUtils',
//     function (dateUtil, $mdDialog, $timeout, timingInfo, $localStorage,$state,CompanyCustom,DateUtils) {
//         return {
//             restrict: 'A',
//             scope: {calendarFilter: '=', refreshTimingInfo: '&?', accessLevel: '<?',lastUpdate:'='},
//             transclude: true,
//             templateUrl: 'app/components/eyeson/calendar/eyeson.calendar.template.html',
//
//             link: function ($scope, $element, $attrs, $controller) {
//
//                 var scheduleIsLoaded = false;
//                 var eventsInited = false;
//                 var onCratingNewEvent = false;
//                 var serviceId;
//                 var canSeeReserve = true;
//                 var currentCompany = null;
//                 var appVersion = 'v3';
//                 //console.log($scope.schedulerApi);
//                 //  $scope.schedulerApi.refreshScheduler = refreshScheduler;
//                 //adjust size of a scheduler
//                 $timeout(function () {
//                     if($scope.calendarFilter)
//                     {
//                       CompanyCustom.getCurrentCompany().query().$promise.then(function (com) {
//                           currentCompany =com;
//                           appVersion = com.appVersion;
//                           initSchedule();
//                           configScheduler();
//                       })
//                     }
//                 }, 0);
//
//                 $timeout(function () {
//                     $scope.$watch('lastUpdate', function (serviceItemId) {
//                         if ($scope.lastUpdate && $scope.calendarFilter && $scope.calendarFilter.serviceList && $scope.calendarFilter.serviceList.length > 0)
//                         refreshScheduler();
//                     });
//
//
//                  /*   $scope.$watch('calendarFilter', function (serviceItemId) {
//                         if ($scope.calendarFilter.serviceList && $scope.calendarFilter.serviceList.length > 0)
//                             refreshScheduler();
//                     });*/
//                 }, 50);
//
//
//
//                 function refreshScheduler() {
//                     //   alert('refresh called');
//                     initSchedule();
//                     configScheduler();
//                     setSchedulerDataSource();
//                 }
//
//                 function configScheduler() {
//
//
//
//                     scheduleIsLoaded = false;
//                     var first_hour = 0;
//                     var last_hour = 24;
//
//                     if($scope.calendarFilter )
//                     {
//                         if($scope.calendarFilter.firstHour)
//                             first_hour=$scope.calendarFilter.firstHour;
//                         else
//                             first_hour=$scope.calendarFilter.firstHour = 6;
//                         if($scope.calendarFilter.lastHour && $scope.calendarFilter.lastHour>23 )
//                             last_hour=$scope.calendarFilter.lastHour;
//                         else
//                             last_hour=$scope.calendarFilter.lastHour = 24;
//
//                     }
//                     var limit_start = new Date();
//                     // var limit_end = new Date('3000-01-01')
//                     var limit_end = DateUtils.newDate('3000-01-01');
//
//                     scheduler.config.first_hour = first_hour;
//                     scheduler.config.last_hour = last_hour;
//                     scheduler.config.limit_start = limit_start;
//                     scheduler.config.limit_end = limit_end;
//                     scheduler.config.limit_view = true;
//
//
//
//                     clearSchedule();
//                 }
//
//                 function onDoubleClick(id, e) {
//                     if (!onCratingNewEvent)
//                         scheduler.showLightbox(id);
//                 }
//
//
//                 function convertWeekNameToOrder(day) {
//                     var index = DAYS_VALUES.indexOf(day);
//                     if (index == 0)return 6;
//                     return index - 1;
//
//                 }
//
//                 function clearSchedule() {
//                     scheduler.clearAll();
//                     scheduler.deleteMarkedTimespan();
//                 }
//
//                 function makeListToString(list) {
//                     var retString = "";
//                     if (list && list.length > 0) {
//                         angular.forEach(list, function (item) {
//                             retString = retString + "," + item;
//                         })
//                     } else {
//                         return 'any';
//                     }
//
//                     return retString;
//                 }
//
//
//                 function setSchedulerDataSource() {
//
//
//                     scheduler.setLoadMode("week");
//
//                     var servants = $scope.calendarFilter.servantList;
//
//                     // if(servants && servants.length>1 && $scope.calendarFilter.selectedServant != 'SHOW_ALL')
//                     // {
//                     //     var old = servants ;
//                     //     servants = [];
//                     //     servants.push(old[0]);
//                     // }
//
//                     var services = [];
//                     if($scope.calendarFilter.filterServices)
//                         services = $scope.calendarFilter.serviceList;
//
//                     if(currentCompany)
//                     {
//                     scheduler.load("api/getSchedulerEventByFilter/" + makeListToString(services) + "/" + makeListToString(servants) + "/" + makeListToString($scope.calendarFilter.reserveTypes)+ "/" + currentCompany.id, "json", function (data) {
//                     });
//                     refreshBlockTime();
//                     }
//
//                 }
//
//                 function refreshBlockTime()
//                 {
//                     var types = [];
//                     types.push("FREE");
//
//                     var serviceListId = $scope.calendarFilter.serviceList ;
//                     if($scope.calendarFilter.selectedServantServiceList)
//                     {
//                         serviceListId = [];
//                         for(var i=0;i<$scope.calendarFilter.selectedServantServiceList.length;i++)
//                         {
//                             if($scope.calendarFilter.selectedServantServiceList[i].serviceMode && $scope.calendarFilter.selectedServantServiceList[i].serviceMode == 'EVENT' )
//                                 continue;
//                             else
//                                 serviceListId.push($scope.calendarFilter.selectedServantServiceList[i].id);
//                         }
//
//                     }
//                     var selectedServantId = [] ;
//                     for(var i=0;i<$scope.calendarFilter.servantList.length;i++)
//                     {
//                         // selectedServantId.push($scope.calendarFilter.servantList[i].id);
//                         selectedServantId.push($scope.calendarFilter.servantList[i]);
//                     }
//
//                     // if($scope.calendarFilter.selectedServant)
//                     // {
//                     //     if($scope.calendarFilter.selectedServant == 'SHOW_ALL')
//                     //     {
//                     //         for(var i=0;i<$scope.calendarFilter.servantList.length;i++)
//                     //         {
//                     //             selectedServantId.push($scope.calendarFilter.servantList[i].id);
//                     //         }
//                     //     }
//                     //     else
//                     //         selectedServantId.push($scope.calendarFilter.selectedServant);
//                     // }
//
//                     var multiServant = false;
//                     if(selectedServantId.length > 1)
//                         multiServant = true;
//
//                     scheduler._set_block_url( "api/client/getScheduledFreeDayTimesByFilter/" + makeListToString(serviceListId) + "/" + makeListToString(selectedServantId) + "/" + makeListToString(types)+"/" + $scope.calendarFilter.firstHour +"/" + $scope.calendarFilter.lastHour,multiServant);
//                     // scheduler._load_block_time();
//
//                 }
//
//                 function AddNewTimeSession(ev) {
//                     var timeSpan = {
//                         startTime: DateUtils.newDate(ev.start_date),
//                         endTime: DateUtils.newDate(ev.end_date),
//                         serviceItemId: serviceId
//                     };
//                     timingInfo.addNewTimeSession().save(timeSpan);
//
//                     onCratingNewEvent = false;
//
//                 }
//
//                 function setEventStyle(start, end, ev) {
//                     var retclass = "event-box ";
//
//                     if (ev.serviceImage ) {
//                         retclass = retclass + "Calendar-"+ ev.serviceImage;
//                     }
//                     else {
//                         retclass += "COLOR0";
//                     }
//                     if(ev.orderBagStatusList && ev.orderBagStatusList.length>0)
//                     {
//
//                     }
//                     else
//                     {
//                         retclass +=' inactive'
//                     }
//                     return retclass;
//
//                     //if(ev.hidden)
//                     //{
//                     //    return "scheduler_hidden_event";
//                     //}
//
//
//                     //if(ev.reserveRequestCount>0)
//                     //{
//                     //    return "scheduler_has_orders_to_confirm"
//                     //}
//                     //if(ev.waitToPayRequestCount>0)
//                     //{
//                     //    return "scheduler_has_orders_to_pay"
//                     //}
//                     //if (!ev.enable) {
//                     //    return "scheduler_not_enable";
//                     //}
//                     //if (!ev.capacity > 0) {
//                     //    return "scheduler_no_capacity";
//                     //
//                     //}
//                     //if(ev.confirmedRequestCount>0)
//                     //{
//                     //    return "scheduler_has_confirmed_orders"
//                     //}
//
//
//                 }
//
//                 function initSchedule() {
//
//
//                     //styling for dhtmlx scheduler
//                     $element.addClass("dhx_cal_container schedule_container");
//
//                     scheduler.config.start_on_monday = false;
//                     //scheduler.config.show_loading = true;
//                     //init scheduler
//                     //
//                     scheduler.templates.event_class = setEventStyle;
//
//                     var mode = "week";
//                     var start_date = new JDate();
//                     if ($localStorage.timeline_mode != undefined)
//                         mode = $localStorage.timeline_mode;
//
//                     if ($localStorage.timeline_startDate != undefined) {
//                         start_date.date[0]
//                         var d = $localStorage.timeline_startDate;
//                         if (d.date != undefined && d.date[0] != undefined)
//                             start_date = new JDate(d.date[0], d.date[1], d.date[2]);
//                     }
//
//                     if($localStorage.calendarFilter.selectionMode)
//                     {
//                         mode = $localStorage.calendarFilter.selectionMode ;
//                         setWeekTabButtonStatus($localStorage.calendarFilter.selectionMode);
//
//                     }
//
//                     if (screen.width <= 480 ) {
//                         mode="day";
//                         scheduler.init($element[0], start_date, "day");
//                     }
//                         scheduler.init($element[0], start_date, mode);
//
//                     scheduler.config.icons_select = [
//                         //"icon_details",
//                         //
//                         //"icon_delete"
//                     ];
//
//                     scheduler.attachEvent("onClick", onDoubleClick);
//                     scheduler.attachEvent("onEventAdded", function (e, event) {
//                         //   AddNewTimeSession(event);
//                     });
//                     scheduler.attachEvent("onEventCreated", function (e) {
//                         onCratingNewEvent = true;
//                     });
//                     scheduler.attachEvent("onEventCancel", function (e) {
//                         onCratingNewEvent = false;
//                     });
//                     scheduler.attachEvent("onBeforeViewChange", function (old_mode, old_date, mode, date) {
//                         $localStorage.timeline_mode = mode;
//
//                         $localStorage.timeline_startDate = date;
//                         //any custom logic here
//                         return true;
//                     });
//                     //   scheduler.templates.event_text = eventTextTemplate;
//                     scheduler.templates.tooltip_text = eventTooltipTemplate;
//                     scheduler.renderEvent = function (container, ev) {
//
//                         var container_width = container.style.width; // e.g. "105px"
//                         var colorstyle = '';
//
//                         // move section
//                         var html = "<div class='dhx_event_move my_event_move' style='width: " +
//                             container_width + "'></div>";
//
//                         // container for event's content
//                         html += "<div class='my_event_body'>";
//                         html += "<div class='event_first_line'>";
//                             html += "<span class='event_date'>";
//                             //two options here:show only start date for short events or start+end for long
//                             if ((ev.end_date - ev.start_date) / 60000 > 40) {//if event is longer than 40 minutes
//                                 html += scheduler.templates.event_header(ev.end_date,ev.start_date, ev);
//                                 html += "</span><br/>";
//                             } else {
//
//                                 // var w = DateUtils.changeJDateTimeToTehran(ev.start_date);
//                                 // debugger;
//                                 html += scheduler.templates.event_date(ev.start_date) + "</span>";
//                             }
//
//                         html += "</div>";
//
//                             html += makeCustomerHtml(ev.customerName,ev.customerPhoneNumber,ev.multiCustomer);
//
//                             if ((ev.end_date - ev.start_date) / 60000 > 40) {//if event is longer than 40 minutes
//                                 html += makeServantTitleHtml(ev.servantTitle);
//                             }
//
//                         // displaying event's text
//                         html += "<span>" + scheduler.templates.event_text(ev.start_date, ev.end_date, ev) +
//                             "</span>" + "</div>";
//
//                         // resize section
//                         html += "<div class='dhx_event_resize my_event_resize' style='width: " +
//                             container_width + "'></div>";
//
//                         container.innerHTML = html;
//                         return true; //required, true - display a custom form, false - the default form
//                     };
//                     dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip pl-tooltip';
//                     dhtmlXTooltip.config.timeout_to_display = 500;
//                     scheduler.config.separate_short_events = true;
//                     //scheduler.config.hour_size_px = 70;
//                     dhtmlXTooltip.config.delta_x = 15;
//                     dhtmlXTooltip.config.delta_y = -20;
//                     function eventTextTemplate(start, end, event) {
//                         return '<span style="background-color: yellow">' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';
//
//
//                     }
//
//                     function setWeekTabButtonStatus(selectionMode){
//                         var element = document.getElementById('week_tab');
//                         if(selectionMode && selectionMode == 'day')
//                         {
//                             if(!element.classList.contains('hide-week-tab'))
//                                 element.classList.add("hide-week-tab");
//                         }
//                         else{
//                             if(element.classList.contains('hide-week-tab'))
//                                 element.classList.remove("hide-week-tab");
//                         }
//                     }
//
//                     function eventTooltipTemplate(start, end, event) {
//
//
//                         var time= "<p style='text-align:center;font-weight: bold'>" + getTimeFormat(end)+" - "+getTimeFormat(start)+
//                             "</p>" ;
//                         var status = "<p class='pl-tooltip-status pl-tooltip-status-"+event.orderBagStatus +"'>"+findStatusTitle(event)+"</p>";
//                         var tooltipHtml = '<div class="scheduler_tooltip" >'
//                             +'<div class="pl-tooltip-header">'
//                             + time
//                             + status
//                             +'</div>'+
//
//                             '<p>' + event.serviceTitle + '</p>';
//
//                         if (event.servantTitle)
//                             tooltipHtml += '<p>' + event.servantTitle + '</p>';
//
//                         if (event.customerName)
//                             tooltipHtml += '<p style="font-weight: bold">'+ event.customerName+ '</p>';
//
//
//                         tooltipHtml += '</div>';
//                         return tooltipHtml;
//                     };
//
//                     var lightBoxForm = document.getElementById("light_box_form");
//                     isShowing = false;
//                     scheduler.showLightbox = function (id) {
//                         var ev = scheduler.getEvent(id);
//
//
//                         ev.updateEvent = function () {
//                             scheduler.updateEvent(id);
//                         };
//                         if (!isShowing) {
//
//                             showCustomLightBox(ev, $scope.refreshTimingInfo);
//                             isShowing = true;
//                         }
//                         //     scheduler.startLightbox(id, lightBoxForm);
//                         //...'here you need to set values in the form'...
//                         //document.getElementById("some_input").value = ev.text;
//                     }
//                     scheduler.showLightbox_addNew = function (id) {
//                         var date_to_add = scheduler._make_date_time_from_splice_id(id);
//                         var _dialogData = {};
//
//                         _dialogData.start_date =date_to_add;
//                         _dialogData.servantId = $scope.calendarFilter.selectedServant;
//                         _dialogData.servantTitle = $scope.calendarFilter.servantTitle;
//                         gotoNewReserve(_dialogData);
//                         // showCustomLightBox(_dialogData, $scope.refreshTimingInfo);
//                         // isShowing = true;
//
//                         //     scheduler.startLightbox(id, lightBoxForm);
//                         //...'here you need to set values in the form'...
//                         //document.getElementById("some_input").value = ev.text;
//                     }
//
//                     //clearSchedule();
//                     //scheduler.updateView();
//                     //clearSchedule();
//                 }
//
//                 gotoNewReserve = function (_dialogData) {
//                     // $mdDialog.hide();
//                     var s_date ,e_date = null;
//                     if(_dialogData.start_date)
//                     {
//                         s_date =_dialogData.start_date;
//
//                         debugger;
//
//                         //FUCK REGIME !!!!!!!!!!
//                         //Check Date - 6 month of the year
//                         var pDate = DateUtils.convertToPersianDate(s_date);
//                         alert(pDate._d.toString());
//                         if(pDate.getMonth() < 7 )
//                         {
//                             s_date = new Date(s_date.setHours(s_date.getHours()-1));
//                         }
//                         s_date =s_date.toISOString()
//
//                     }
//                     if(_dialogData.end_date)
//                         e_date = _dialogData.end_date.toISOString();
//
//
//
//                     if(appVersion == 'v3')
//                     {
//                         $state.go('supplierPanel-v2.new-reserve-modal', {
//                             serviceItemId: _dialogData.serviceItemId,
//                             servantId:_dialogData.servantId,
//                             start_date: s_date,
//                             end_date: e_date,
//                             hasCustomTime:true
//                         });
//
//                     }
//
//                     if(appVersion == 'v2')
//                     {
//                         $state.go('supplierPanel.new-reserve-modal', {
//                             serviceItemId: _dialogData.serviceItemId,
//                             servantId:_dialogData.servantId,
//                             start_date: s_date,
//                             end_date: e_date,
//                             hasCustomTime:true
//                         });
//
//                     }
//
//                     /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
//                      serviceItemId: serviceItemId,
//                      timeSessionId: dialogData.id
//                      });
//
//                      window.open(url,'_blank');*/
//                     //   window.open(url,'_self');
//
//                 }
//                 function getTimeFormat(d)
//                 {
//                     var date= DateUtils.newDate(d);
//                     // date = DateUtils.toTehranTime(date);
//
//                     date = moment(date);
//
//                     return date.format("hh:mm");
//                 }
//                 function makeServantTitleHtml(servantTitle)
//                 {
//                     var retHtml="";
//                     if(servantTitle)
//                     {
//                         retHtml+="<div class='servant-section'> <span class='material-icons' style='font-size: 13px ; float:right'>assignment_ind</span>"+"<span class='servant-title-on-event' >"
//                             +servantTitle+"</span> </div>";
//                     }
//                     return retHtml;
//
//                 }
//                 function makeCustomerHtml(customerName,customerPhone,isMultiCustomer)
//                 {
//                     var retHtml="";
//                     if(customerName)
//                     {
//                         retHtml+="<div class='servant-section'> <span class='material-icons' style='font-size: 13px ; float:right'>person</span>"+"<span class='customer-title-on-event' >"
//                             +customerName+"</span> </div>";
//                     }
//                     return retHtml;
//
//                 }
//
//                 function findStatusTitle(event) {
//                     switch (event.orderBagStatus) {
//                         case 1 :
//                             return 'تائید شده';
//                         case 5 :
//                             return 'درخواست رزرو';
//                         case 6 :
//                             return 'در انتظار پرداخت';
//                     }
//                 }
//                 function showCustomLightBox(dialogData, refreshTimingInfoMethod) {
//
//                     $mdDialog.show({
//                             locals: {dialogData: dialogData, refreshTimingInfoMethod: refreshTimingInfoMethod},
//                             controller: TimeSessionDetailController,
//                             controllerAs: '$ctrl',
//                             templateUrl: 'app/components/eyeson/calendar/eyeson.scheduler-time-session-dialog.template.html',
//                             parent: angular.element(document.body),
//                             targetEvent: dialogData,
//                             clickOutsideToClose: true,
//                             fullscreen: false// Only for -xs, -sm breakpoints.
//                         })
//                         .then(function (ev) {
//
//                             isShowing = false;
//
//
//                         }, function () {
//
//                             isShowing = false;
//                         });
//                 };
//                 var TimeSessionDetailController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
//                     var $ctrl = this;
//                     $ctrl.dialogData = dialogData;
//                     $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;
//                     //$ctrl.dialogData = {
//                     //    id: dialogData.id,
//                     //    price: dialogData.price,
//                     //    capacity: dialogData.capacity,
//                     //    enable: dialogData.enable,
//                     //    discount: dialogData.discount,
//                     //    isNew:dialogData.isNew
//                     //};
//
//                     var startDate = new JDate(dialogData.start_date);
//                     // var startTime = toDateTimeTehranZone(dialogData.start_date);
//                      var endDate = null;
//                     var endTime = null;
//                     if(dialogData.end_date)
//                         endDate = new JDate(dialogData.end_date);
//                     $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
//                     if (startDate) {
//                         $ctrl.title = startDate.format('dddd DD MMMM ')  ;
//                         $ctrl.title += formatTime(startDate);
//                         if(endDate)
//                             $ctrl.title += ' تا ' + formatTime(endDate);
//
//
//                     }
//
//                     function formatTime(time) {
//
//                         var hour = time.format('HH');
//                         var minute = time.format('SS');
//
//                         hour = twoDigitFormat(hour);
//                         minute = twoDigitFormat(minute);
//
//                         return hour+":"+minute;
//                     }
//
//                     function twoDigitFormat(input) {
//
//                         var str = input.toString();
//                         if(str.length < 2 )
//                             str ="0"+str;
//
//                         return str;
//                     }
//
//                     function toDateTimeTehranZone(date){
//                         var x = new JDate(date);
//                         var y = x._d;
//                         var inputDate = new moment(y);
//                         var tehranTime    = inputDate.tz("Asia/Tehran");
//                         return tehranTime;
//                     }
//
//
//
//                     $ctrl.hideDialog = function () {
//                         $mdDialog.hide();
//                     };
//
//                     $ctrl.cancelDialog = function () {
//                         $mdDialog.cancel();
//                     };
//                     $ctrl.copyTSimilarTimes = function () {
//                         if (confirm("در صورت تایید ، خصوصیات این زمان در دیگر زمانهای این سرویس که ساعت مشابهی دارند کپی می شود. آیا اطمینان دارید؟")) {
//                             TimingInfo.updateToSimilarTimeSessions($ctrl.dialogData.id).get(function () {
//                                 alert("تغییرات با موفقیت انجام شد. برای مشاهده دکمه بازیابی تقویم کاری را بزنید")
//                                 //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
//                                 dialogData.updateEvent();
//                             });
//                         }
//                     }
//
//                     $ctrl.gotoNewReserve = function (serviceItemId) {
//
//                         $mdDialog.hide();
//                         if(appVersion=='v3')
//                         {
//                             $state.go('supplierPanel-v2.new-reserve-modal', {
//                                 serviceItemId: dialogData.serviceItemId,
//                                 servantId:dialogData.servantId,
//                                 start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
//                                 end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
//                             });
//                         }
//                         if(appVersion=='v2')
//                         {
//                             $state.go('supplierPanel.new-reserve-modal', {
//                                 serviceItemId: dialogData.serviceItemId,
//                                 servantId:dialogData.servantId,
//                                 start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
//                                 end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
//                             });
//                         }
//                         /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
//                          serviceItemId: serviceItemId,
//                          timeSessionId: dialogData.id
//                          });
//
//                          window.open(url,'_blank');*/
//                         //   window.open(url,'_self');
//
//                     }
//
//                     $ctrl.gotoNewReserve_flex = function () {
//                         $mdDialog.hide();
//
//                         var s_date ,e_date = null;
//                         if(dialogData.start_date)
//                             s_date = dialogData.start_date.toISOString();
//                         if(dialogData.end_date)
//                             e_date = dialogData.end_date.toISOString();
//
//
//                         if(appVersion == 'v3')
//                         {
//                             $state.go('supplierPanel-v2.new-reserve-modal', {
//                                 serviceItemId: dialogData.serviceItemId,
//                                 servantId:dialogData.servantId,
//                                 start_date: s_date,
//                                 end_date: e_date,
//                                 hasCustomTime:true
//                             });
//
//                         }
//                         if(appVersion =='v2')
//                         {
//                             $state.go('supplierPanel.new-reserve-modal', {
//                                 serviceItemId: dialogData.serviceItemId,
//                                 servantId:dialogData.servantId,
//                                 start_date: s_date,
//                                 end_date: e_date,
//                                 hasCustomTime:true
//                             });
//
//                         }
//
//
//                         /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
//                          serviceItemId: serviceItemId,
//                          timeSessionId: dialogData.id
//                          });
//
//                          window.open(url,'_blank');*/
//                         //   window.open(url,'_self');
//
//                     }
//
//                     $ctrl.updateCapacity = function (value) {
//
//                         $ctrl.dialogData.capacity = null;
//
//                         if ($ctrl.dialogData.floatTime) {
//                             $ctrl.dialogData.capacity = value;
//                             $ctrl.upsertFloatTimeSession($ctrl.dialogData);
//                         }
//                         else
//                             TimingInfo.changeTimeSessionCapacity($ctrl.dialogData.id, value).get(function () {
//                                 dialogData.capacity = value;
//                                 //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
//                                 dialogData.updateEvent();
//                                 $ctrl.refreshTimingInfoMethod();
//                             });
//                         return true;
//                     }
//                     $ctrl.updateDiscount = function (value) {
//                         if (data.floatTime) {
//                             $ctrl.dialogData.discount = value;
//                             $ctrl.upsertFloatTimeSession(data);
//                         }
//                         else
//                             TimingInfo.changeTimeSessionDiscount($ctrl.dialogData.id, value).get(function () {
//                                 dialogData.discount = value;
//                                 //   $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
//                                 dialogData.updateEvent();
//                             });
//                         return true;
//                     }
//                     $ctrl.gotoOrderBag = function (id) {
//                         $mdDialog.hide();
//                         $state.go('supplierPanel-v2.editOrderBag', {id: id});
//
//                     }
//                     $ctrl.changeEnable = function (data) {
//
//                         //if(data.floatTime)
//                         //{
//                         data.enable = !data.enable;
//                         $ctrl.upsertFloatTimeSession(data);
//                         //}
//                         //else
//                         //TimingInfo.changeTimeSessionEnable(data.id).get(function () {
//                         //    $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
//                         //    dialogData.enable = $ctrl.dialogData.enable;
//                         //    dialogData.updateEvent();
//                         //});
//                     }
//                     $ctrl.upsertFloatTimeSession = function (ev) {
//                         ev.start_date = DateUtils.newDate(ev.start_date);
//                         ev.end_date = new Date(ev.end_date);
//                         ev.orderBagStatusList = [0, 1];
//                         //      var timeSpan={startTime:new Date(ev.start_date),endTime: new Date( ev.end_date),serviceItemId:serviceId};
//                         timingInfo.upsertFloatTimeSession().save(ev, function (result) {
//
//                             $ctrl.refreshTimingInfoMethod();
//                             $ctrl.cancelDialog();
//                         });
//
//                         onCratingNewEvent = false;
//
//                     }
//                     $ctrl.saveDialog = function (answer) {
//                         dialogData.price = $ctrl.dialogData.price;
//                         dialogData.discount = $ctrl.dialogData.discount;
//                         dialogData.capacity = $ctrl.dialogData.capacity;
//                         dialogData.enable = $ctrl.dialogData.enable;
//                         dialogData.updateEvent();
//                         $mdDialog.hide(answer);
//                     };
//                 }
//                 TimeSessionDetailController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils'];
//
//
//             }//end of link method
//         }
//     }]);
;
(function () {
    'use strict';
    EO_ButtonController.$inject = ['$scope', '$attrs', '$element'];

    function EO_ButtonController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.buttonClass = 'md-raised md-primary';
        $ctrl.initDefualt = initDefualt;
        $ctrl.initDefualt();

        function initDefualt() {

            if (!$ctrl.isValid)
                $ctrl.isValid = true;

            if (!$ctrl.theme)
                $ctrl.theme = 'primary'

            if ($ctrl.theme == 'primary') {
                $ctrl.buttonClass = ' md-primary eoButtonPrimary';
            } else if ($ctrl.type == 'accent') {
                $ctrl.buttonClass = ' md-accent';
            } else if ($ctrl.type == 'warn') {
                $ctrl.buttonClass = ' md-warn';
            } else {
                $ctrl.buttonClass = '';
            }

        }


    }


    var EO_Button = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/button/eyeson.button.template.html',
        controller: EO_ButtonController,
        bindings: {
            'label': '@',
            'loadingLabel': '@?',
            'icon': '@?',
            'onClick': '&',
            'isLoading': '<',
            'disabled': '<',
            'isValid': '<',
            'theme': '@?',
            "customClass": '=?'

        }


    };

    angular
        .module('tikonApp')
        .component('eoButton', EO_Button)


})();


//
//
//angular.module('tikonApp').directive('eoTimePicker', function () {
//        return {
//            restrict: 'E',
//            templateUrl: 'app/components/eyeson/time-picker/eyeson.time-picker.template.html',
//
//            //   template: '<input class="datePickerClass" />',
//            scope: {
//                timeValue: '=', //use =? for optionality,
//                id: '@'
//
//            },
//            link: function (scope, element, attributes) {
//             //
//
//                var el = $(element);
//
//
//
//                //the $watch method works when the model values have not yet been processed by the time this directive runs
//                scope.$watch('timeValue', function (timeValue) {
//
//              //   setTime(timeValue);
//                });
//
//                //$observe is useless here, as there is no interpolation whatsoever, the $watch will react to changes from both parent scope and current scope, furthermore any change to the value here, changes the parent value as well
//
//                //=? is required if you want to assign values to the current isolated scope property, but the DOM attribute or parent scope property was never defined, checking if it exists or logging its current value won't result in an error
//
//            }
//        };
//    }
//);
/*
 angular.module('tikonApp').directive('eoTimePicker', function () {
 return {
 restrict: 'E',
 //   templateUrl: 'app/components/eyeson/time-picker/eyeson.time-picker.template.html',

 //   template: '<input class="datePickerClass" />',
 scope: {
 timeValue: '=', //use =? for optionality,
 id: '@'

 },
 link: function (scope, element, attributes) {
 //
 var defaultTime='00 : 00';
 var timeValueStr =defaultTime ;

 var hasInited = false;
 var el = $(element);
 var onChange = function (str) {
 //
 if (hasInited && str!=defaultTime) {
 //
 var hour = str.split(":")[0].trim();
 var min = str.split(":")[1].trim();
 scope.timeValue = new Date(1970, 0, 1, hour, min, 0);
 scope.$apply();
 }
 }
 var makeTimePicker = function (time) {
 //
 $(el).empty();
 var div=$('<div class=" input-group date-picker"></div>');
 div.append('<input class="form-control text-center timepicker"  type="text" style="direction: ltr"  />');
 $(el).append(div);
 var options = {
 now: time, //hh:mm 24 hour format only, defaults to current time
 twentyFour: true,  //Display 24 hour format, defaults to false
 upArrow: 'wickedpicker__controls__control-up',  //The up arrow class selector to use, for custom CSS
 downArrow: 'wickedpicker__controls__control-down', //The down arrow class selector to use, for custom CSS
 close: 'wickedpicker__close', //The close class selector to use, for custom CSS
 hoverState: 'hover-state', //The hover state class to use, for custom CSS
 title: 'انتخاب ساعت', //The Wickedpicker's title,
 showSeconds: false, //Whether or not to show seconds,
 secondsInterval: 1, //Change interval for seconds, defaults to 1,
 minutesInterval: 1, //Change interval for minutes, defaults to 1
 beforeShow: null, //A function to be called before the Wickedpicker is shown
 show: null, //A function to be called when the Wickedpicker is shown
 clearable: true, //Make the picker's input clearable (has clickable "x")
 valueChanged: onChange,
 };

 //var div = $('<div ></div>').addClass('input-group date-picker');
 //var input = $('<input  id="' + $attrs.id + '" class="form-control text-center timepicker"  type="text" style="direction: ltr"  ng-model="$ctrl.timeValueStr"   />');
 //
 //div.append(input);
 //input.wickedpicker(options);
 //$($element).append(div);
 $('.timepicker', el).wickedpicker(options,0);
 }

 var setTime=function(timeValue)
 {
 if (timeValue) {
 //  console.log(timeValue);
 var temp = new Date(timeValue);
 if (temp != 'Invalid Date') {
 //on post link
 //     alert('in'+temp);
 //


 timeValueStr = temp.getHours() + ":" + temp.getMinutes();
 }
 else {
 timeValueStr =defaultTime;
 }
 hasInited=false;
 makeTimePicker(timeValueStr);
 hasInited=true;


 }
 }
 //       makeTimePicker(timeValueStr);
 //   if(scope.timeValue==undefined)
 //  console.log('inited...');
 setTime(defaultTime);

 hasInited=true;

 //the $watch method works when the model values have not yet been processed by the time this directive runs
 scope.$watch('timeValue', function (timeValue) {
 setTime(timeValue);
 });

 //$observe is useless here, as there is no interpolation whatsoever, the $watch will react to changes from both parent scope and current scope, furthermore any change to the value here, changes the parent value as well

 //=? is required if you want to assign values to the current isolated scope property, but the DOM attribute or parent scope property was never defined, checking if it exists or logging its current value won't result in an error

 }
 };
 }
 );
 */
;
(function () {
    'use strict';
    EO_AvatarNameController.$inject = ['$scope', '$attrs', '$element'];

    function EO_AvatarNameController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.summary = "";

        $ctrl.getSummary = function () {
            if ($ctrl.name)
                return $ctrl.name.substring(0, 1);
            else
                return "ا";
        }

    }


    var EO_AvatarName = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/avatar-name/eyeson.avatar-name.template.html',
        controller: EO_AvatarNameController,
        bindings: {
            'name': '@'
        }


    };

    angular
        .module('tikonApp')
        .component('eoAvatarName', EO_AvatarName)


})();

;
(function () {
    'use strict';

    function eoAutoCompleteController($scope, $attrs, $element, $timeout) {
        var $ctrl = this;


        $ctrl.simulateQuery = false;
        $ctrl.isDisabled = false;

        // list of `state` value/display objects


        $ctrl.onSelectedItemChange = onSelectedItemChange;
        $ctrl.onSearchTextChange = searchTextChange;
        $ctrl.onSearchMethod = onSearchMethod;
        $ctrl.items = [];
        var isSerching = false;

        function onSearchMethod(query) {

            if (query && query.length > 0 && !isSerching) {

                return searchTextChange(query);


            }
        }

        $ctrl.newState = newState;

        function newState(state) {
            alert("Sorry! You'll need to create a Constitution for " + state + " first!");
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */

        function searchTextChange(query) {

            if (query && query.length > 0 && !isSerching) {
                //console.log('start searching for'+query);
                isSerching = true;
                //  $ctrl.items=[];

                $ctrl.searchMethod(query).$promise.then(function (data) {

                    $ctrl.items = data;
                    console.log('search done by:' + query);
                    console.log(data);
                    isSerching = false;

                });
                ;


            }
        }

        function onSelectedItemChange(item) {
            if ($ctrl.selectedItemChange && item)
                $ctrl.selectedItemChange(item);
        }


    }

    var eoAutoComplete = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/autocomplete/eyeson.autocomplete.template.html',
        controller: eoAutoCompleteController,
        bindings: {

            placeholder: '@?',
            selectedItem: '=',
            searchMethod: '=',
            searchTextChange: '=?',
            selectedItemChange: '=?',
            isDisabled: '<?'
        }
    };
    angular
        .module('tikonApp')
        .component('eoAutocomplete', eoAutoComplete);
    eoAutoCompleteController.$inject = ['$scope', '$attrs', '$element', '$timeout'];
})();

;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .provider('AlertToastService', AlertToastService);

    function AlertToastService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$translate', '$injector'];

        function getService($timeout, $translate, $injector) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 3000; // default timeout


            return {
                success: success,
                error: error
            };


            function showToast(msg, type, params, position) {
                var mdToast = $injector.get('$mdToast');

                if (type == '' || type == null)
                    type = 'success';

                mdToast.show(
                    mdToast.simple()
                        .content(msg)
                        .hideDelay(timeout)
                        .theme(type + '-toast'));

            }

            function success(msg, params, position) {
                $translate(msg).then(function (m) {
                    showToast(m, 'success', params, position);
                });
            }

            function error(msg, params, position) {
                $translate(msg).then(function (m) {
                    showToast(m, 'error', params, position);
                });
            }


        }


    }
})();
;
(function () {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
            '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
            '</div>' +
            '</div>',


        controller: jhiAlertErrorController
    };

    angular
        .module('tikonApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate', 'AlertToastService'];

    function jhiAlertErrorController($scope, AlertService, $rootScope, $translate, AlertToastService) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert(message, key, data) {

            AlertToastService.error(key, message, null);

            // key = key && key !== null ? key : message;
            // vm.alerts.push(
            //     AlertService.add(
            //         {
            //             type: 'danger',
            //             msg: key,
            //             params: data,
            //             timeout: 5000,
            //             toast: AlertService.isToast(),
            //             scoped: true
            //         },
            //         vm.alerts
            //     )
            // );


        }

        var cleanHttpErrorListener = $rootScope.$on('tikonApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;

                case 400:
                    var alertError = httpResponse.headers('x-tikonapp-alert');
                    if (alertError)
                        console.log(alertError)

                    var errorHeader = httpResponse.headers('X-tikonApp-error');
                    var entityKey = httpResponse.headers('X-tikonApp-params');
                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('tikonApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                        }
                    } else if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                    } else {
                        //  addErrorAlert(httpResponse.data);
                    }
                    break;

                case 404:
                    addErrorAlert('Not found', 'error.url.not.found');
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message);
                    } else {
                        addErrorAlert(angular.toJson(httpResponse));
                    }
            }
        });

        $scope.$on('$destroy', function () {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate', 'AlertToastService'];

        function getService($timeout, $sce, $translate, AlertToastService) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 8000; // default timeout


            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning,
                showHelpMessage: help,
                showValidationMessage: validationMessage
            };

            function validationMessage(element, message, theme, timer, openAction) {
                if (!openAction) openAction = 'custom';
                if (!theme) theme = 'tooltipster-error';
                if (!timer) timer = 5000;
                var elementid = $(element).attr('id');

                destroyAllTooltips();
                if (message) {
                    var messageId = message.split('.').join('');
                    var tooltipClass = elementid + messageId + '-tooltip';
                    var tooltipContentId = elementid + messageId + '-tooltip-content';
                    addValidationMessage();
                }


                function getTooltipInstance() {
                    var instances = $.tooltipster.instances(element);
                    var rightInstance = instances[0];
                    angular.forEach(instances, function (ins) {
                        //
                        if (!ins.status().destroyed && !ins.status().destroying && ins.content()[0].id == tooltipContentId)
                            rightInstance = ins
                    });
                    return rightInstance;

                }

                function destroyAllTooltips() {
                    //
                    var instances = $.tooltipster.instances(element);
                    for (var i = 0; i < instances.length; i++) {
                        instances[i].destroy();
                    }


                }

                function addValidationMessage() {
                    //
                    $translate(message).then(function (m) {

                        message = m;
                        makeTooltip();
                    }, function (translationId) {
                        //   console.log('translation not found for :' + message);
                        //   destroyAllTooltips();
                        makeTooltip();
                    });
                }

                function makeTooltip() {
                    var errorMessage =
                        $('<div class="validation-message-container" >' +

                            '<div class="' + tooltipClass + '" id="' + tooltipContentId + '" ><span >' + message + '</span></div>' +
                            '</div>');

                    $(element).addClass(tooltipClass);

                    errorMessage.insertAfter($(element));
                    $(element).attr('data-tooltip-content', '#' + tooltipContentId);
                    var side = getSide();

                    $(element).tooltipster({
                        theme: theme,
                        side: side,
                        trigger: openAction,
                        triggerOpen: {},
                        triggerClose: ['click', 'originClick', 'tap'],
                        timer: timer,
                        multiple: true,
                        contentCloning: true,
                        animation: 'grow',
                        arrow: true,
                        contentAsHTML: true,
                        maxWidth: 500,
                        minWidth: 200,

                        animationDuration: [500, 1000],
                        functionBefore: beforeOpen,
                        viewportAware: false,


                    });
                    getTooltipInstance().open();


                }

                function beforeOpen(tooltip) {
                    //if left of tooltip==0
                    //so it is in wrong place
                    //and shoulb be stopped!
                    return (tooltip.__geometry().origin.offset.left > 0);
                }

                //this method return the tooltip side based on the available tooltip instance on
                //current element
                function getSide() {
                    return ['left', 'bottom'];

                    //var allSides = [ 'bottom','left', 'top', 'right'];
                    //var instancesCount = $.tooltipster.instances(element).length;
                    //if (instancesCount > 3)instancesCount = 0;
                    //return allSides[instancesCount];

                }
            }

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }


            function success(msg, params, position) {


                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {

                AlertToastService.error(msg, params, position);
                //
                // return this.add({
                //     type: 'danger',
                //     msg: msg,
                //     params: params,
                //     timeout: timeout,
                //     toast: toast,
                //     position: position
                // });
            }

            function warning(msg, params, position) {

                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {

                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function help(element, msg, params, position) {
                validationMessage(element, msg, 'tooltipster-light', 30000, 'click');
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'bottom right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {

                alertOptions.alertId = alertId++;
                var mes = alertOptions.msg;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                if (alertOptions.msg == mes) {
                    //console.log(mes);
                    return;
                    //   alertOptions.msg="پیغام های خطا را بررسی کنید";
                }
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function (e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function () {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
            '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
            '</div>' +
            '</div>',
        controller: jhiAlertController
    };

    angular
        .module('tikonApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function () {
    'use strict';

    function ActionBarController($scope, $attrs, $element) {
//
        var $ctrl = this;

    }

    var actionbar = {
        //    template:'TTETTET',
        templateUrl: 'app/components/action-bar/action-bar.template.html',
        controller: ActionBarController,
        transclude: true,
        bindings:
            {}

    };

    angular
        .module('tikonApp')
        .component('actionBar', actionbar);

    ActionBarController.$inject = ['$scope', '$attrs', '$element'];


})();




;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService', 'AlertToastService'];

    function notificationInterceptor($q, AlertService, AlertToastService) {
        var service = {
            response: response
        };

        return service;

        function response(response) {

            var alertKey = response.headers('X-tikonApp-alert');

            if (angular.isString(alertKey)) {
                // AlertService.success(alertKey, { param : response.headers('X-tikonApp-params')});
                AlertToastService.success(alertKey, {param: response.headers('X-tikonApp-params')});
            }
            return response;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // return response;
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))) {
                $rootScope.$emit('tikonApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                if($rootScope.toState.name !== "createUserAccount"){
                    LoginService.open();
                }
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function () {
                    return afterCSRFRenewed(response);
                });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request(config) {
            //  if(config.url && config.url.startsWith('api/'))
            //  config.url="http://reserweb.ir/admin/"+config.url;
            /*jshint camelcase: false */
            //
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token && (!(config.url && config.url.startsWith("api/authenticate")))) {
                if(config.url != "https://panel2.plnstage.ir/urls.json"){
                    config.headers.Authorization = 'Bearer ' + token;
                }
            }

            return config;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['CompanySession', '$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler(CompanySession, $rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
                          Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromStateParams) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;
                $rootScope.fromStateParams = fromStateParams;
                $rootScope.showHeaderNavbar = true;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                //checkHeaderToShow
                if ($rootScope.toState) {
                    if ($rootScope.toState.views && $rootScope.toState.name.includes('supplierPanel-v2')) {

                        var content = $rootScope.toState.views['content@'];
                        if (content)
                            $rootScope.$broadcast('hideNavBar');

                        var subContent = $rootScope.toState.views['subcontent'];
                        if (subContent)
                            $rootScope.$broadcast('showNavBar');

                    }
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });


            });

            function hasValidSubscription() {


            }

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);

                //check company subscription
                checkValidSubscription();


            });

            function checkValidSubscription() {
                CompanySession.checkValidSubscription(function (valid) {

                    if ($rootScope.toState.views && !valid) {
                        if ($rootScope.toState.name.includes('supplierPanel-v2.reserveList')
                            || $rootScope.toState.name.includes('supplierPanel-v2.newReserve')
                            || $rootScope.toState.name.includes('supplierPanel-v2.companyCustomer')
                            || $rootScope.toState.name.includes('supplierPanel-v2.companyServants')
                            || $rootScope.toState.name.includes('supplierPanel-v2.reserveServices')
                            || $rootScope.toState.name.includes('supplierPanel-v2.eventItemList')
                            || $rootScope.toState.name.includes('supplierPanel-v2.reportExport')
                            || $rootScope.toState.name.includes('supplierPanel-v2.setting')
                            || $rootScope.toState.name.includes('supplierPanel-v2.calendar-v2')
                            || $rootScope.toState.name.includes('supplierPanel-v2.dashboard')
                            || $rootScope.toState.name.includes('supplierPanel-v2.invoiceInfoList')
                            || $rootScope.toState.name.includes('supplierPanel-v2.companyPaymentLog')
                        ) {
                            //its not valid
                            $state.go('supplierPanel-v2.companySubscriptionStatusV2');
                        }
                    }

                })

            }

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {

            $cookies.putObject(name, value);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}-v11/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(httpConfig);
    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider', 'ENV'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider, ENV) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push(['$q', function ($q) {
            const baseUrl = ENV.API_BASE_URL; // Define your base URL here
            return {
                'request': function (config) {
                    // Prepend base URL if it's a relative path
                    if (config.url.startsWith(ENV.API_BASE_URL)) return config;
                    if (config.url.startsWith('api/')) config.url = baseUrl + config.url;
                    return config;
                },
                'responseError':

                    function (rejection) {
                        return $q.reject(rejection);
                    }
            };
        }]);
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function (val) {
                return val === true || val === 'true';
            },
            encode: function (val) {
                return val ? 1 : 0;
            },
            equals: function (a, b) {
                return this.is(a) && a === b;
            },
            is: function (val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }

})();
;
angular.module('tikonApp').constant('ENV', {
    API_BASE_URL: 'http://your-api-url.com'
});
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider, DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                // 'navbar@': {
                //     templateUrl: 'app/layouts/navbar/navbar.html',
                //     controller: 'NavbarController',
                //     controllerAs: 'vm'
                // },
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar-v2.html',
                    controller: 'NavbarV2Controller',
                    controllerAs: 'vm'
                },

            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('tikonApp')
        .constant('VERSION', "1.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('DEFAULT_VIDEO_CALL_URL', "https://meet.jit.si/RWB-")
;
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Principal'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Principal) {
        var vm = this;

        vm.authoritiesConstant = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPPLIER', 'ROLE_MANAGER', 'ROLE_CUSTOMER_MANAGER', 'ROLE_FINANCIAL_MANAGER', 'ROLE_RESERVATION_MODIFIER', 'ROLE_RESERVATION_MANAGER', 'ROLE_SERVANT_MANAGER', 'ROLE_CATEGORY_MANAGER', 'ROLE_COMPANY_MANAGER', 'ROLE_OFFICE_MANAGER', 'ROLE_SERVANT_LOGIN', 'ROLE_REPORT_MANAGER', 'ROLE_DENY_REPORT_MANAGER', 'ROLE_FREEMIUM_USER', 'ROLE_EVENT_MANAGER', 'ROLE_SUPER_ADMIN_BASIC_ACCESS', 'ROLE_SUPER_ADMIN_ADVANCED_ACCESS', 'ROLE_SUPER_ADMIN_FULL_ACCESS'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.authorities = [];
        vm.isAdmin = Principal.hasAnyAuthority(["ROLE_SUPER_ADMIN_FULL_ACCESS"]);

        loadAuthorities();

        function loadAuthorities() {

            angular.forEach(vm.authoritiesConstant, function (auth) {
                var authObj = {};
                authObj.key = auth;
                authObj.value = false;
                authObj.disable = false;
                angular.forEach(vm.user.authorities, function (userAuth) {
                    if (authObj.key == userAuth)
                        authObj.value = true;
                })

                if (!vm.isAdmin
                    && (authObj.key == "ROLE_SUPER_ADMIN_BASIC_ACCESS"
                        || authObj.key == "ROLE_SUPER_ADMIN_ADVANCED_ACCESS"
                        || authObj.key == "ROLE_SUPER_ADMIN_FULL_ACCESS"
                    )
                ) {
                    authObj.disable = true;

                }

                vm.authorities.push(authObj);
            })
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            createUserAuthorities();
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function createUserAuthorities() {
            vm.user.authorities = [];
            angular.forEach(vm.authorities, function (auth) {
                if (auth.value)
                    vm.user.authorities.push(auth.key);
            })
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.service.get({login: login}, function (result) {
                vm.user = result;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'user-management.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management-detail', {
                parent: 'admin',
                url: '/user/:login',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'user-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management.new', {
                parent: 'user-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null, login: null, firstName: null, lastName: null, email: null,
                                    activated: true, langKey: null, createdBy: null, createdDate: null,
                                    lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                    resetKey: null, authorities: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('user-management');
                    });
                }]
            })
            .state('user-management.edit', {
                parent: 'user-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('user-management.delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', '$state'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService, $state) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.setActive = setActive;
        vm.totalItems = null;
        vm.users = [];
        vm.login = null;


        vm.loadAll();


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });


        function loadAll() {
            User.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');

                //hide anonymous user from user management: it's a required user for Spring Security
                for (var i in result) {
                    if (result[i]['login'] === 'anonymoususer') {
                        result.splice(i, 1);
                    }
                }
                vm.users = result;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
        }

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: function (JhiTrackerService) {
                JhiTrackerService.subscribe();
            },
            onExit: function (JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }
        });
    }
})();
;
(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('tikonApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {

            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
            stompClient.connect(headers, function () {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
            });
        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                        {},
                        angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe() {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/topic/tracker', function (data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        /*    JhiTrackerService.receive().then(null, null, function(activity) {
                showActivity(activity);
            });
    */
        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if (vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics() {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump() {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function (value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass(threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope', 'JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh() {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData() {
            JhiMetricsService.threadDump().then(function (data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function () {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': {method: 'GET', isArray: true},
            'changeLevel': {method: 'PUT'}
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController(LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel(name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth() {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData(data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName(name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName(name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData(result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject(result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, {'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName(path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            } else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem(healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject(healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function () {
    'use strict';

    angular.module('tikonApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController(JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass(statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh() {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth(health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function () {
                        return health;
                    },
                    baseName: function () {
                        return vm.baseName;
                    },
                    subSystemName: function () {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get() {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete(response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv() {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete(response) {
                var properties = {};
                angular.forEach(response.data, function (val, key) {
                    var vals = [];
                    angular.forEach(val, function (v, k) {
                        vals.push({key: k, val: v});
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter', 'JhiConfigurationService'];

    function JhiConfigurationController(filter, JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function (configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({
                page: vm.page - 1,
                size: 20,
                fromDate: fromDate,
                toDate: toDate
            }, function (result, headers) {
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today() {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth() {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage(page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController(Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save() {
            Auth.updateAccount(vm.settingsAccount).then(function () {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController(Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function (account) {
            vm.account = account;
        });

        function invalidate(series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#email').focus();
        });

        function requestReset() {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController($translate, $timeout, Auth, LoginService) {
        var vm = this;

        //
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#login').focus();
        });

        function register() {
            //

            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';

                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login_already_in_use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail_address_already_in_use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PasswordV2Controller', PasswordV2Controller);

    PasswordV2Controller.$inject = ['Auth', 'Principal', '$rootScope'];

    function PasswordV2Controller(Auth, Principal, $rootScope) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    $rootScope.modalInstance.dismiss('cancel');
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            changePassword();
        }

    }
})();
;
/* globals $ */
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar() {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    } else if (s <= 20) {
                        idx = 1;
                    } else if (s <= 30) {
                        idx = 2;
                    } else if (s <= 40) {
                        idx = 3;
                    } else {
                        idx = 4;
                    }

                    return {idx: idx + 1, col: this.colors[idx]};
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({'background-color': '#DDD'})
                        .slice(0, c.idx)
                        .css({'background-color': c.col});
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController(Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
            .state('activateUserBySMS', {

                parent: 'account',
                url: '/activateUserBySMS/{login}',
                data: {
                    authorities: [],
                    pageTitle: 'activate.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/activate/activateUserBySMS.html',
                        controller: 'ActivationBySMSController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('activate');
                        return $translate.refresh();
                    }]
                    , entity: ['$stateParams', 'User', function ($stateParams, User) {
                        //
                        return User.get({login: $stateParams.login}).$promise;
                    }]
                }

            })


        ;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActivationBySMSController', ActivationBySMSController);

    ActivationBySMSController.$inject = ['$stateParams', 'Auth', 'entity', 'LoginService'];

    function ActivationBySMSController($stateParams, Auth, entity, LoginService) {

        //
        var vm = this;
        vm.User = entity;
        vm.phoneNumber = null;
        vm.activateUser = activateUser;


        //Auth.activateAccount({key: $stateParams.key}).then(function () {
        //    vm.error = null;
        //    vm.success = 'OK'
        //    vm.error = 'ERROR';;
        //}).catch(function () {
        //    vm.success = null;
        //});


        function activateUser() {
            //
            if (vm.phoneNumber != null) {
                vm.key = vm.phoneNumber;
                Auth.activateAccount({key: vm.key}).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    //
                    vm.success = null;
                    vm.error = 'ERROR';
                });
                //
                vm.login = LoginService.open;
            } else {
                vm.success = null;
                vm.error = 'ERROR';
            }


        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]

            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module("tikonApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/createAccount/create-account.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><a ui-sref=\".personInfo\">new </a><!-- Page Content --><div id=\"page-wrapper\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-lg-12\"><jhi-alert></jhi-alert><div class=\"\"><div ui-view=\"subcontent1\"></div><div ui-view=\"subcontent2\"></div></div></div><!-- /.col-lg-12 --></div><!-- /.row --></div><!-- /.container-fluid --></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button></form><p></p><div class=\"alert alert-warning\" translate=\"global.messages.info.authenticated\" translate-compile>If you want to <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div></div></div></div>");
$templateCache.put("app/createUserAccount/activate-user.html","<div><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 ng-if=\"vm.formMode == \'ACTIVATED\'\" translate=\"register.activated.title\">Activation</h1><div ng-if=\"!vm.activatedSuccess\"><eo-help-tip text=\'{{\"register.activated.messages.accountMustBeActivated\" | translate}}\'></eo-help-tip></div><div ng-if=\"!vm.activatedSuccess\"><div class=\"alert alert-success\" ng-show=\"vm.success && !vm.activateError && !vm.regenerateSuccess \" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div class=\"alert alert-danger\" ng-show=\"vm.errorPhoneNumberExists\" translate=\"register.messages.error.phonenumberexists\"><strong>Phone Number is already in use!</strong> Please choose another one.</div></div><div class=\"alert alert-success\" ng-show=\"vm.activatedSuccess \" translate=\"register.activated.messages.success\"><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.activateError\" translate=\"register.activated.messages.error\"><strong>Activation code is invalid!.</strong></div><div ng-if=\"!vm.activatedSuccess\"><div class=\"alert alert-success\" ng-show=\"vm.regenerateSuccess\" translate=\"register.activated.messages.sendActivationKey\"><strong>Activation code Resend.</strong></div><!--<div class=\"alert alert-danger\" ng-show=\"vm.regenerateError\"--><!--translate=\"register.activated.messages.reSendActivationKeyError\">--><!--<strong>Error in Resend Activation Code.Try Later .</strong>--><!--</div>--></div></div><div class=\"col-md-8 col-md-offset-2\"><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.submited()\" show-validation><div ng-if=\"vm.formMode == \'ACTIVEUSER\'\"><div class=\"form-group\" ng-show=\"!vm.activatedSuccess\"><label class=\"control-label\" for=\"key\" translate=\"register.activated.key\">Key</label><input type=\"key\" class=\"form-control\" id=\"key\" name=\"key\" placeholder=\"{{\'register.activated.keyPlaceHolder\' | translate}}\" ng-model=\"vm.key\" ng-minlength=\"5\" ng-maxlength=\"5\" required><div><button type=\"button\" ng-disabled=\"form.$invalid\" class=\"btn btn-success\" ng-click=\"vm.activateUser()\" translate=\"register.activated.title\">Activate</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.regenerateActivationKey()\" translate=\"register.activated.sendActivationKey\">Activate</button></div></div><div class=\"form-group\" ng-show=\"vm.activatedSuccess\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.login()\" translate=\"register.activated.messages.enter\">Enter</button></div></div></form></div></div></div>");
$templateCache.put("app/createUserAccount/create-user-account.html","<style>.svg-picture {\n        background-color: #f6f7ff;\n        border-right: 2px solid #e4e5e6;\n        border-top-right-radius: 0%;\n        /*border-bottom-right-radius: 25%;*/\n    }\n\n    .logo {\n        background-image: url(/content/images/reserweb_icon.png);\n        background-size: contain;\n        width: 100px;\n        height: 100px;\n        margin: auto;\n    }\n\n    .btn-success-large {\n        margin: 10px;\n        padding: 10px 20px;\n        width: 300px;\n        border: none;\n        border-radius: 3px;\n        background-color: #F19C00;\n        color: white;\n        font-size: 1.2em;\n        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.38);\n        -webkit-transition: 0.5s;\n        -moz-transition: 0.5s;\n        -ms-transition: 0.5s;\n        -o-transition: 0.5s;\n        transition: 0.5s;\n    }\n\n    .already-register {\n\n    }\n\n\n    .btn-success-large:hover {\n        background-color: #e89200;\n        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.6);\n    }\n\n    .register-bg {\n        /*background-image: url(\"content/images/reserweb-icon.png\");*/\n        background-repeat: no-repeat;\n        background-position: right;\n        width: 90%;\n        height: 90%;\n        position: absolute;\n        opacity: 0.1;\n        margin-right: 100px;\n    }\n\n    .button-disabled-class {\n        background-color: #afafaf;\n    }\n\n    .button-disabled-class:hover {\n        background-color: #afafaf;\n    }\n\n    .inner-addon {\n        position: relative;\n    }\n\n    /* style glyph */\n    .inner-addon .glyphicon {\n        position: absolute;\n        padding: 10px;\n        pointer-events: none;\n    }\n\n    /* align glyph */\n    .left-addon .glyphicon {\n        left: 0px;\n        color: #005D53;\n    }\n\n    .right-addon .glyphicon {\n        right: 0px;\n    }\n\n    /* add padding  */\n    .left-addon input {\n        padding-left: 30px;\n    }\n\n    .right-addon input {\n        padding-right: 30px;\n    }\n\n    .fixed-height-form {\n        /*min-height: 450px;*/\n    }\n\n    /*.form-title {*/\n    /*color: #009688;*/\n    /*font-size: 1.3em;*/\n    /*background-color: rgba(186, 222, 218, 0.51);*/\n    /*width: 100%;*/\n    /*padding: 10px;*/\n    /*border-radius: 5px;*/\n    /*border-bottom: solid 3px rgba(0, 150, 136, 0.22);*/\n    /*}*/\n\n    .active-key-input {\n        font-size: 2em;\n        width: 200px;\n        margin: 25px;\n        padding: 7px;\n        border: solid 1px #eee;\n        text-align: center;\n    }\n\n\n    .left-register-image {\n        background: url(\'/content/images/hello.png\');\n        background-repeat: no-repeat;\n        background-size: contain;\n        width: 100%;\n        height: 90vh;\n        background-position: center;\n        opacity: 0.8;\n    }\n\n    .left-register-image-wd {\n        background: url(\'/content/images/homepage-cover.jpg\');\n        background-repeat: no-repeat;\n        background-size: contain;\n        width: 100%;\n        height: 90vh;\n        background-position: center;\n        opacity: 0.8;\n    }\n\n    .isloadingimage {\n        background: url(\'/content/css/isloading.gif\');\n        background-repeat: no-repeat;\n        background-size: cover;\n        width: 20px;\n        height: 20px;\n        opacity: 0.8;\n    }\n\n    .latin-input {\n        text-align: left;\n        direction: ltr;\n    }\n\n    .error-message {\n\n    }\n\n    .error-block {\n        color: rgb(255, 61, 3);\n\n\n    }\n\n    .phoneNumber-input {\n        text-align: center;\n        direction: ltr;\n    }\n\n    @media (min-width: 992px) {\n        #footer {\n            display: none;\n        }\n    }</style><div class=\"pl-content\" style=\"padding: 20px 10px\"><div class=\"container-fluid pl-container-fluid\"><div class=\"register-form\"><div class=\"row\"><div class=\"col-md-6\" style=\"padding: 0\"><div class=\"register-form-right\"><h4 class=\"register-form-title\">ثبت نام</h4><!--<jhi-alert-error></jhi-alert-error>--><div><div class=\"row\"><div class=\"col-md-12\" style=\"padding:0\"><div ng-if=\"!vm.activatedSuccess\"><div class=\"alert alert-success\" ng-show=\"vm.regenerateSuccess\" translate=\"register.activated.messages.reSendActivationKey\"><strong>Activation code Resend.</strong></div></div></div></div><div class=\"\"><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.submited(form)\" show-validation><div ng-if=\"vm.formMode == \'REGISTER\'\"><div class=\"row fixed-height-form\"><div class=\"form-group col-sm-12\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber-desc\">Phone Number</label><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-phone\"></i><!--<input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\"--><!--name=\"phoneNumber\" maxlength=\"11\"--><!--style=\"direction: ltr;text-align: center; padding-left: 30px !important;\"--><!--placeholder=\"{{\'tikonApp.personInfo.phoneNumber-sample-placeHolder\' | translate}}\"--><!--ng-model=\"vm.registerAccount.phoneNumber\" ng-minlength=11--><!--ng-maxlength=11 required>--><eo-numeric-input id=\"phoneNumber\" name=\"phoneNumber\" custom-class=\"form-control phoneNumber-input\" input-value=\"vm.registerAccount.phoneNumber\" form-reference=\"form\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-sample-placeHolder\' | translate}}\" is-required=\"true\" minlength=\"11\" maxlength=\"11\"></eo-numeric-input></div><div ng-show=\" form.phoneNumber.$invalid && form.phoneNumber.$touched \"><p class=\"error-block\" translate=\"register.messages.error.phonenumberIsNotValid\" ng-show=\"form.phoneNumber.$error.minlength || form.phoneNumber.$error.maxlength\"></p><p class=\"error-block\" ng-show=\"form.phoneNumber.$error.required\" translate=\"register.messages.error.phoneNumberIsRequired\"></p></div><div class=\"error-message\" data-ng-show=\"vm.errorPhoneNumberExists \"><p class=\"error-block\" translate=\"register.messages.error.phonenumberexists\"></p></div></div></div><div class=\"row\"><div class=\"form-group col-md-6 col-xs-6\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"fisrtName\">Fisrt Name</label><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-user\"></i> <input style=\"padding-left: 30px !important\" type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"fisrtName\" required ng-model=\"vm.registerAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\"></div><div ng-show=\"form.fisrtName.$touched && form.fisrtName.$invalid\"><p class=\"error-block\" ng-show=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.fisrtName.required\">Your username is required.</p></div></div><div class=\"form-group col-md-6 col-xs-6\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"lastName\">last Name</label><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-user\"></i> <input style=\"padding-left: 30px !important\" type=\"text\" class=\"form-control\" name=\"lastName\" id=\"lastName\" required ng-model=\"vm.registerAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\"></div><div ng-show=\"form.lastName.$touched && form.lastName.$invalid\"><p class=\"error-block\" ng-show=\"form.lastName.$error.required\" translate=\"register.messages.validate.lastName.required\">Your username is required.</p><p class=\"error-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minLength\">Your username is required to be at least 1 character.</p><p class=\"error-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxLength\">Your username cannot be longer than 50 characters.</p><p class=\"error-block\" ng-show=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-envelope\"></i> <input autocomplete=\"off\" type=\"email\" class=\"form-control latin-input\" id=\"email\" name=\"email\" style=\"text-align: left; padding-left: 30px !important\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required></div><p class=\"error-block\" ng-show=\"vm.errorEmailExists && !form.email.$invalid\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</p><div ng-show=\"form.email.$dirty && form.email.$invalid\"><div><p class=\"error-block\" ng-show=\"form.email.$touched && form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p></div><div><p class=\"error-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div><div><!--<p class=\"error-block\"--><!--ng-show=\"form.email.$error.minlength\"--><!--translate=\"global.messages.validate.email.minlength\">--><!--Your e-mail is required to be at least 5 characters.--><!--</p>--></div><p class=\"error-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxLength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><label class=\"control-label\" for=\"password\" translate=\"global.form.password\">New password</label><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-lock\"></i> <input style=\"padding-left: 30px !important\" autocomplete=\"off\" type=\"password\" class=\"form-control latin-input\" id=\"password\" name=\"new_password\" placeholder=\"{{\'global.form.password.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"6\" ng-maxlength=\"50\" required></div><div ng-show=\"form.new_password.$dirty && form.new_password.$invalid\"><div class=\"error-block\" ng-show=\"form.new_password.$error.minlength\" translate=\"register.messages.validate.newPassword.minLength\">Your password is required to be at least 4 characters.</div><div class=\"error-block\" ng-show=\"form.new_password.$error.maxlength\" translate=\"register.messages.validate.newPassword.maxLength\">Your password cannot be longer than 50 characters.</div></div></div></div><div class=\"row\"><div class=\"form-group col-md-6 col-xs-6\"><label class=\"control-label\" translate=\"tikonApp.personInfo.howFimilaredWithPlanovin\" for=\"howDidYouFindUs\"></label><md-select class=\"rwMdSelect\" ng-model=\"vm.questions.howDidYouFindUs\" id=\"howDidYouFindUs\" name=\"howDidYouFindUs\" ng-change=\"vm.onServantChanged()\" aria-required=\"true\" required style=\"margin-bottom: 8px!important\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.howDidYouFindUsOptions\">{{option.name}}</md-option></md-select><div ng-show=\"form.howDidYouFindUs.$touched && form.howDidYouFindUs.$invalid\"><div class=\"error-block\" ng-show=\"form.howDidYouFindUs.$error.required\" translate=\"register.messages.validate.howDidYouFindUs.required\"></div></div></div><div ng-if=\"vm.questions.howDidYouFindUs === \'OTHER\'\" class=\"form-group col-md-6 col-xs-6\" style=\"margin-top: 34px\"><input style=\"max-height: 127px; font-size: 16px\" class=\"form-control\" placeholder=\"{{ \'tikonApp.personInfo.findUsOtherWayDesc\' | translate }}\" id=\"findUsOtherWayDesc\" name=\"findUsOtherWayDesc\" required ng-model=\"vm.questions.findUsOtherWayDesc\"><div ng-show=\"form.findUsOtherWayDesc.$touched && form.findUsOtherWayDesc.$invalid\"><div class=\"error-block\" ng-show=\"form.findUsOtherWayDesc.$error.required\" translate=\"register.messages.validate.findUsOtherWayDesc.required\"></div></div></div><div ng-if=\"!vm.referralCode && vm.questions.howDidYouFindUs !== \'OTHER\'\" class=\"form-group col-md-6 col-xs-6\"><label class=\"control-label\" for=\"referralCode\">کد معرف(اختیاری)</label><div class=\"inner-addon left-addon\"><!-- <i class=\"glyphicon glyphicon-share-alt\"></i> --> <input style=\"padding-left: 30px !important\" type=\"text\" class=\"form-control\" name=\"referralCode\" id=\"referralCode\" ng-model=\"vm.registerAccount.referralCode\" ng-minlength=\"1\" ng-maxlength=\"50\"></div></div></div><div ng-if=\"!vm.referralCode && vm.questions.howDidYouFindUs === \'OTHER\'\" class=\"row\"><div class=\"form-group col-md-6 col-xs-6\"><label class=\"control-label\" for=\"referralCode\">کد معرف(اختیاری)</label><div class=\"inner-addon left-addon\"><!-- <i class=\"glyphicon glyphicon-share-alt\"></i> --> <input style=\"padding-left: 30px !important\" type=\"text\" class=\"form-control\" name=\"referralCode\" id=\"referralCode\" ng-model=\"vm.registerAccount.referralCode\" ng-minlength=\"1\" ng-maxlength=\"50\"></div></div></div><div class=\"row\"><div class=\"col-md-12 text-center\"><span style=\"color: #000\">با کلیک روی «ثبت نام» <a href=\"https://planovin.com/terms-and-conditions\" style=\"text-decoration: underline;color: #2196f3\" target=\"_blank\">شرایط استفاده از خدمات</a> و <a href=\"https://planovin.com/privacy-policy\" style=\"text-decoration: underline;color: #2196f3\" target=\"_blank\">حریم خصوصی</a> را می پذیرم.</span></div><div class=\"col-md-12 text-center\"><eo-button label=\"{{\'register.form.button\' | translate}}\" loading-label=\"{{\'register.form.wait\' | translate}}\" icon=\"done\" is-valid=\"form.$invalid\" is-loading=\"vm.isSaving\" on-click=\"vm.submited(form)\" type=\"1\"></eo-button></div><div class=\"col-md-12 text-center\"><span class=\"already-register\">قبلا ثبت نام کرده اید؟ </span><span ng-click=\"vm.login()\" class=\"login-text\">وارد شوید</span></div></div></div><div ng-if=\"vm.formMode == \'ACTIVEUSER\'\"><div class=\"row\"><div class=\"col-md-12 text-center\"><div style=\"min-height: 80px\"><div><div class=\"alert alert-success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><!--<div class=\"alert alert-danger\" ng-show=\"vm.error || vm.activateError\" translate=\"register.messages.error.fail\">--><!--<strong>Registration failed!</strong> Please try again later.--><!--</div>--><div class=\"alert alert-danger\" ng-show=\"vm.activateError\" translate=\"register.activated.messages.error\"><strong>Registration failed!</strong> Please try again later.</div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"key\" translate=\"register.activated.key\">Key</label><eo-numeric-input id=\"key\" name=\"key\" style=\"font-size: 2rem\" input-value=\"vm.key\" custom-class=\"active-key-input\" form-reference=\"form\" is-required=\"true\" placeholder=\"_ _ _ _ _\" minlength=\"5\" maxlength=\"5\"></eo-numeric-input><!--<input type=\"key\" class=\" active-key-input\" maxlength=\"5\" id=\"key\"--><!--style=\"font-size: 2em;\" name=\"key\"--><!--placeholder=\"_ _ _ _ _\"--><!--ng-model=\"vm.key\" ng-minlength=5 ng-maxlength=5 required>--><div><eo-button label=\"{{\'register.activated.title\' | translate}}\" loading-label=\"{{\'register.form.wait\' | translate}}\" icon=\"done\" is-valid=\"form.$invalid\" is-loading=\"vm.isSaving\" on-click=\"vm.activateUser()\" theme=\"primary\"></eo-button><span data-ng-show=\"!vm.counterIsEnded\" style=\"color: rgb(0, 150, 136)\">لطفا منتظر باشید... <span style=\"font-weight: bold;width: 50px;text-align: center\">{{vm.counter}}</span></span><eo-button id=\"resendKeyBtn\" data-ng-show=\"vm.counterIsEnded\" label=\"{{\'register.activated.resendkey\' | translate}}\" icon=\"replay\" on-click=\"vm.regenerateActivationKey()\"></eo-button></div></div></div></div></div></form></div></div></div></div><div class=\"col-md-6 svg-picture hidden-xs hidden-sm\"><!--<div style=\"position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0;\">--><!--<div class=\"hidden-xs hidden-sm logo\"></div>--><div style=\"font-size: 19px; text-align: center; left: 0; right: 0; margin-top: 30px; position: absolute\" translate=\"register.reserwebSystemOfComprehensiveOnlineReservation\"></div><!--</div>--><div ng-class=\"vm.findImageClass()\"></div></div></div></div></div></div>");
$templateCache.put("app/createUserAccount/reset-password-with-sms.html","<div><jhi-alert-error></jhi-alert-error><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.submited()\" show-validation><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\" ng-show=\"vm.formMode==\'Done\'\"><div class=\"alert alert-success\"><strong><span translate=\"password.messages.success\"></span> </strong><u><a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\" translate=\"register.activated.messages.login\"></a></u></div></div><div class=\"col-md-4 col-md-offset-2\"><div ng-if=\"vm.formMode==\'Request\'\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\" ng-model=\"vm.changePasswordReq.phoneNumber\"> <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.validationCodeButton\" ng-click=\"vm.sendActivationCode()\">Register</button></div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-md-offset-2\"><div ng-if=\"vm.formMode==\'Activate\'\"><div class=\"form-group\"><label class=\"control-label\" for=\"key\" translate=\"register.validationCode\">Key</label><input type=\"key\" class=\"form-control\" id=\"key\" name=\"key\" placeholder=\"{{\'register.validationCode\' | translate}}\" ng-model=\"vm.changePasswordReq.verificationCode\" ng-minlength=\"5\" ng-maxlength=\"5\" required></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.changePasswordReq.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\" ng-click=\"vm.requestPasswordReset()\">Register</button></div></div></div></form></div>");
$templateCache.put("app/home/home.html","<div ng-cloak><div id=\"homePage\" class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"container\" ng-if=\"!vm.company\"><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-6 text-center\"><span><img class=\"home-logo\" style=\"\" ng-src=\"{{vm.logoSource}}\"> </span><!--<div>--><!--<h3>--><!--<span id=\"appDescription\" translate=\"global.appInfo.appDescription\"></span>--><!--</h3>--><!--</div>--><div><h2 style=\"color: #217289;font-weight: bold;font-size: 30px\"><!--<span translate=\"global.appInfo.appTitle\"></span>--></h2></div></div><div class=\"col-md-3\"></div></div><!-- Marketing Icons Section --><div class=\"row\"><br><div style=\"text-align: center\"><button type=\"button\" ng-click=\"vm.login()\" class=\"btn btn-primary pl-btn-primary btn-xl\">وارد شوید</button> <button id=\"homeRegisterBtn\" ui-sref=\"createUserAccount({ referralCode: vm.referralCode })\" class=\"btn btn-info pl-btn-default btn-xl\">ثبت نام کنید</button></div></div><!--<div class=\"row\" ng-if=\"vm.company\">--><!--<pf-quick-access-tools  company =\"vm.company\">--><!--</pf-quick-access-tools>--><!--</div>--></div></div></div></div>");
$templateCache.put("app/legal-actual-info/legal-actual-info.html","<eo-pl-modal-header title=\"\'global.menu.account.legal_actual\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"global.menu.account.legal_actual\"></span></div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert></jhi-alert><div><h2>اطلاعات حقیقی/حقوقی</h2><div class=\"row\"><div class=\"form-group col-md-12\"><md-radio-group ng-model=\"vm.legalInfo.legalType\" ng-change=\"vm.issueBillingType_Change()\" layout=\"row\" class=\"setting-radio-box-inside\"><md-radio-button class=\"md-primary\" value=\"NATURAL\"><span>حقیقی</span></md-radio-button><md-radio-button class=\"md-primary\" value=\"LEGAL\"><span>حقوقی</span></md-radio-button></md-radio-group></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label ng-if=\"vm.legalInfo.legalType ==\'NATURAL\'\" class=\"control-label\" required for=\"field_billingName\">نام شخص</label><label ng-if=\"vm.legalInfo.legalType ==\'LEGAL\'\" class=\"control-label\" required for=\"field_billingName\">نام شرکت</label><input ng-model=\"vm.legalInfo.name\" type=\"text\" class=\"form-control\" name=\"billingName\" id=\"field_billingName\" ng-model=\"vm.billingName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label ng-if=\"vm.legalInfo.legalType ==\'NATURAL\'\" class=\"control-label\" required for=\"field_billingNationalCode\">کد ملی</label><label ng-if=\"vm.legalInfo.legalType ==\'LEGAL\'\" class=\"control-label\" required for=\"field_billingNationalCode\">شناسه ملی</label><input ng-model=\"vm.legalInfo.nationalCode\" type=\"text\" class=\"form-control\" name=\"billingNationalCode\" id=\"field_billingNationalCode\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" required for=\"postal_code\">کدپستی</label><input ng-model=\"vm.legalInfo.zipCode\" type=\"text\" class=\"form-control\" name=\"billingName\" id=\"postal_code\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" required for=\"address\">آدرس</label><input ng-model=\"vm.legalInfo.address\" type=\"text\" class=\"form-control\" name=\"billingNationalCode\" id=\"address\"></div></div></div></form></div></div></div></div><eo-pl-modal-footer title=\"\'global.menu.account.legal_actual\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/reports/report-export-v2.html","<style>.report-list {\n\n    }\n\n    .report-item:hover {\n        background-color: whitesmoke;\n    }\n\n    .report-item {\n        /*width: 100%;*/\n        border: solid 1px #d8d8cf;\n        border-radius: 5px;\n        padding: 10px 15px;\n        background-color: #f8f8f866;\n        margin: 5px;\n        min-height: 100px;\n    }\n\n    .report-icon {\n        float: right;\n        width: 40px;\n        font-size: 20px;\n        color: #f19c00;\n    }\n\n    .report-title {\n        /*color: rgb(96, 125, 139);*/\n        margin: 3px;\n        font-size: 16px;\n    }\n\n    .report-action {\n        width: 100%;\n        float: left;\n        text-align: left;\n\n    }\n\n    .report-action .pl-btn-primary {\n        max-width: 150px;\n        width: 100%;\n    }\n\n\n    @media (max-width: 768px) {\n        .report-action {\n            float: none;\n        }\n\n    }</style><div class=\"pl-form-container\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span translate=\"reportExport.title\">reportExport.title</span><div class=\"education-link hidden-xs\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body\"><div class=\"container-fluid\"><eo-progress-bar></eo-progress-bar><jhi-alert></jhi-alert><md-content class=\"\"><div class=\"report-list\"><div class=\"report-item\"><div><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.orderbag_list_by_service.title\' | translate}}</div></div><div class=\"report-action\"><md-button ui-sref=\".reserve_list_dtail_report\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.orderbag_list_summary_by_service.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".reserve_list_summary_report\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.financial_by_customer.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".financial_by_customer\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.company_customer_list.title\' | translate}}</div><div class=\"report-action\"><eo-generic-report do-before-export=\"vm.doBeforeExport_customerList\"></eo-generic-report></div></div></div><div class=\"report-list\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.reserve_summary_with_payment_report.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".reserve_list_summary_with_payment_report\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.invoice_info_item_report.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".invoice_info_item_report\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.company_customer_form_data_report.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".company_customer_form_data_report\" class=\"md-raised md-primary pl-btn-primary\">مشاهده <i class=\"fa fa-eye\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.company_form_data_list.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".company_form_data_list\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div ng-if=\"vm.currentCompany.companyMode == \'PARENT_COMPANY\'\"><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">گزارش تعداد رزرو به تفکیک مراکز و خدمات</div><div class=\"report-action\"><md-button ui-sref=\".reserve_count_by_parent_id\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">گزارش مجموع رزروها به تفکیک مراکز</div><div class=\"report-action\"><md-button ui-sref=\".sum_of_reserve_count\" class=\"md-raised md-primary pl-btn-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/reports/report-export.html","<style>.report-list {\n\n    }\n\n    .report-item:hover {\n        background-color: whitesmoke;\n    }\n\n    .report-item {\n        width: 100%;\n        border: solid 1px #d8d8cf;\n        border-radius: 5px;\n        padding: 10px 15px;\n        background-color: #f8f8f866;\n        margin: 5px;\n        min-height: 100px;\n    }\n\n    .report-icon {\n        float: right;\n        width: 40px;\n        font-size: 20px;\n        color: #f19c00;\n    }\n\n    .report-title {\n        color: rgb(96, 125, 139);\n        margin: 3px;\n        font-size: 16px;\n    }\n\n    .report-action {\n        width: 100%;\n        float: left;\n        text-align: left;\n\n    }\n\n    @media (max-width: 768px) {\n        .report-action {\n            float: none;\n        }\n\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"reportExport.title\">reportExport.title</div><div class=\"panel-body\"><div class=\"container-fluid\"><eo-progress-bar></eo-progress-bar><jhi-alert></jhi-alert><md-content class=\"rwMdContent\"><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.orderbag_list_by_service.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".reserve_list_dtail_report\" class=\"md-raised md-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.orderbag_list_summary_by_service.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".reserve_list_summary_report\" class=\"md-raised md-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.financial_by_customer.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".financial_by_customer\" class=\"md-raised md-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.company_customer_list.title\' | translate}}</div><div class=\"report-action\"><eo-generic-report do-before-export=\"vm.doBeforeExport_customerList\"></eo-generic-report></div></div></div><div class=\"report-list\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">{{\'reportExport.reports.reserve_summary_with_payment_report.title\' | translate}}</div><div class=\"report-action\"><md-button ui-sref=\".reserve_list_summary_with_payment_report\" class=\"md-raised md-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div ng-if=\"vm.currentCompany.companyMode == \'PARENT_COMPANY\'\"><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">گزارش تعداد رزرو به تفکیک مراکز و خدمات</div><div class=\"report-action\"><md-button ui-sref=\".reserve_count_by_parent_id\" class=\"md-raised md-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div><div class=\"report-list\"><div class=\"report-item\"><div class=\"report-icon\"><i class=\"fa fa-bar-chart\"></i></div><div class=\"report-title\">گزارش مجموع رزروها به تفکیک مراکز</div><div class=\"report-action\"><md-button ui-sref=\".sum_of_reserve_count\" class=\"md-raised md-primary\">{{\'reportExport.export_to_excel\' | translate}} <i class=\"fa fa-file-excel-o\"></i></md-button></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/supplier/access-denied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-8 col-sm-offset-2\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div><!--<a ui-sref=\"supplierPanel.dashboard\">--><!--بازگشت--><!--</a>--></div><div class=\"row\"><div class=\"col-md-4 col-sm-offset-4\"><span class=\"no-access img-responsive img-rounded\"></span></div></div></div>");
$templateCache.put("app/supplier/supplierPanel.html","<!--cropper--><!--<script src=\"../../js/tools/cropper.min.js\"></script>--><!--<link rel=\"stylesheet\" href=\"../../content/css/cropper.min.css\"/>--><!--<script src=\"https://cdnjs.cloudflare.com/ajax/libs/cropperjs/2.0.0-alpha.2/cropper.min.js\" integrity=\"sha512-IlZV3863HqEgMeFLVllRjbNOoh8uVj0kgx0aYxgt4rdBABTZCl/h5MfshHD9BrnVs6Rs9yNN7kUQpzhcLkNmHw==\" crossorigin=\"anonymous\" referrerpolicy=\"no-referrer\"></script>--><!--<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/cropperjs/2.0.0-alpha.2/cropper.min.css\" integrity=\"sha512-6QxSiaKfNSQmmqwqpTNyhHErr+Bbm8u8HHSiinMEz0uimy9nu7lc/2NaXJiUJj2y4BApd5vgDjSHyLzC8nP6Ng==\" crossorigin=\"anonymous\" referrerpolicy=\"no-referrer\" />--><!--......................--><style>#sidebar::-webkit-scrollbar {\n        width: 7px;\n        height: 7px;\n\n    }\n\n    /* Track */\n    #sidebar::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 7px;\n    }\n\n    /* Handle */\n    #sidebar::-webkit-scrollbar-thumb {\n        background: rgba(230, 230, 230, 0.6);\n        border-radius: 7px;\n    }\n\n    /* Handle on hover */\n    #sidebar::-webkit-scrollbar-thumb:hover {\n        background: rgba(230, 230, 230, 0.2);\n    }\n\n    .company-title-on-menu {\n        color: #217289;\n        font-size: 1.1em;\n        font-weight: bold;\n        text-align: center;\n        margin: 5px;\n    }\n\n    #sidebar {\n        margin-top: 0;\n        width: 80px;\n        position: fixed;\n        top: 0;\n        right: 0px;\n        height: 100vh;\n        z-index: 1031;\n        /*background-color: #f8f8f8;*/\n        border-color: #e7e7e7;\n        transition: all 0.5s;\n        overflow-x: hidden;\n        overflow-y: auto;\n        white-space: nowrap;\n        box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\n    }\n\n    #sidebar.open {\n        width: 250px;\n    }\n\n    #logo:hover {\n        background: none !important;\n    }\n\n    /*menuIcon*/\n    #menuHamburgerDesktop {\n        cursor: pointer;\n\n        height: 65px;\n        padding: 20px 16px;\n    }\n\n    .bar1, .bar2, .bar3 {\n        width: 28px;\n        height: 3px;\n        /*background-color: #009688;*/\n        margin: 3px 0;\n        transition: 0.5s;\n    }\n\n    .change .bar1 {\n        -webkit-transform: rotate(-45deg) translate(-6px, 8px);\n        transform: rotate(-35deg) translate(-6px, 8px);\n    }\n\n    .change .bar2 {\n        opacity: 0;\n    }\n\n    .change .bar3 {\n        -webkit-transform: rotate(45deg) translate(-1px, -2px);\n        transform: rotate(35deg) translate(-1px, -2px);\n    }\n\n    /*menuIcon*/\n\n    #menuPin {\n        float: left;\n        display: none;\n    }\n\n\n    /* ---------------------------------------------------\n        SIDEBAR STYLE\n    ----------------------------------------------------- */\n    #sidebar.active {\n        right: 0;\n    }\n\n\n    /*#sidebar .sidebar-header {*/\n    /*padding: 20px;*/\n    /*background: #009688;*/\n    /*color: #cfebd9;*/\n    /*}*/\n\n    #sidebar ul.components {\n        padding: 0;\n        /*border-bottom: 1px solid #47748b;*/\n    }\n\n    #sidebar ul p {\n        color: #fff;\n        padding: 10px;\n    }\n\n    #sidebar ul li {\n        /*height: 65px;*/\n    }\n\n    #sidebar ul li a {\n        font-size: 1.5em;\n        display: block;\n        /*border-top: 1px solid #eee;*/\n        padding: 14px 23px 11px 0px;\n        margin: 0;\n        /*text-align: center;*/\n        text-decoration: none;\n    }\n\n    #sidebar ul li a span {\n        font-size: 0.7em;\n        /*padding-right: 32px;*/\n    }\n\n    a[data-toggle=\"collapse\"] {\n        position: relative;\n    }\n\n\n    .sub-menu {\n\n        font-size: 0.85em !important;\n        background: rgba(253, 253, 253, 1);\n        font-size: 1.1em;\n    }\n\n    ul.CTAs {\n        padding: 20px;\n    }\n\n    ul.CTAs a {\n        text-align: center;\n        font-size: 0.9em !important;\n        display: block;\n        border-radius: 5px;\n        margin-bottom: 5px;\n    }\n\n    .sub-menu-arrow {\n        display: none;\n        float: left;\n        margin-left: 10px;\n        font-size: 0.8em;\n    }\n\n    @media (max-width: 767px) {\n        #menuHamburgerDesktop {\n            display: none;\n        }\n\n        #sidebar {\n            width: 0px;\n        }\n\n        #overlay {\n            position: fixed; /* Sit on top of the page content */\n            display: none; /* Hidden by default */\n            width: 100%; /* Full width (cover the whole page) */\n            height: 100%; /* Full height (cover the whole page) */\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */\n            z-index: 1030; /* Specify a stack order in case you\'re using a different order for other elements */\n            cursor: pointer; /* Add a pointer on hover */\n        }\n\n    }\n\n    .icon-class {\n        margin-left: 30px;\n    }\n\n    html {\n        overflow-y: scroll !important;\n    }\n\n    /*.icon-class:before {*/\n    /*color: #000;*/\n    /*}*/</style><div ng-cloak><eo-progress-bar></eo-progress-bar><div ng-joy-ride=\"vm.guidTipsEnable\" config=\"vm.guidTipsConfig\" on-finish=\"vm.guidTipsonFinish()\" on-skip=\"vm.guidTipsonFinish()\"></div><!--&lt;!&ndash; Page Content &ndash;&gt;--><div id=\"page-wrapper\" style=\"overflow: hidden\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-lg-12\"><jhi-alert></jhi-alert><div class=\"\"><!--<button type=\"button\" id=\"sidebarCollapse\" class=\"btn btn-info navbar-btn\">--><!--<i class=\"glyphicon 	glyphicon glyphicon-th-list\"></i>--><!--<i class=\"glyphicon glyphicon-arrow-left\"></i>--><!--</button>--><div ui-view=\"subcontent\"></div></div></div><!-- /.col-lg-12 --></div><!-- /.row --></div><!-- /.container-fluid --></div><!-- /#page-wrapper --><div class=\"wrapper\"><nav id=\"sidebar\"><ul class=\"components\"><li style=\"height: 65px\"><!--<a id=\"logo\" class=\"navbar-brand logo\" style=\"padding-right: 7px;\" href=\"#/\" ng-click=\"vm.collapseNavbar()\">--> <a id=\"logo\" class=\"navbar-brand logo\" style=\"padding-right: 7px\" href=\"#/supplierPanel/dashboard\" ng-click=\"vm.collapseNavbar()\"><img class=\"logo-img\" ng-src=\"{{vm.logoSource}}\"> <span style=\"padding-right: 3px; font-size: larger\" translate=\"global.title\">reserwebTitle</span></a></li><li style=\"color: red\" has-any-authority=\"ROLE_RESERVATION_MANAGER_EXPIRE,ROLE_CUSTOMER_MANAGER_EXPIRE,ROLE_CATEGORY_MANAGER_EXPIRE,ROLE_COMPANY_MANAGER_EXPIRE\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.purchaseCompanySubscriptionStatus\' | translate}}\"><!--<span>اشتراک شما به پایان رسیده است</span>--> <a ui-sref=\".companySubscriptionStatusV2\"><i class=\"icon-class fa fa-unlock-alt fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.purchaseCompanySubscriptionStatus\">purchaseCompanySubscriptionStatus</span></a></li><li data-toggle=\"tooltip\" title=\"{{\'global.menu.home\' | translate}}\"><a ui-sref=\"supplierPanel.dashboard\" ng-click=\"vm.collapseNavbar()\"><i class=\"icon-class fa fa-home fa-lg\"></i> <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span></a></li><li has-authority=\"ROLE_SERVANT_MANAGER\" data-toggle=\"tooltip\" title=\"{{vm.servantTranslateFile | translate}} {{vm.servantTranslateFileOptions | translate}}\"><a ui-sref=\".companyServants\"><i class=\"icon-class\" ng-class=\"vm.servantClass\"></i> <span>{{vm.servantTranslateFile | translate}}</span> <span style=\"font-size: 10px\" translate=\"tikonApp.ActivityType.ActivityTypeServants.{{vm.company.activityType}}\"></span></a></li><li has-authority=\"ROLE_SERVANT_LOGIN\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.servantTimeSchedule\' | translate}}\"><a ng-click=\"vm.goToCurrentServant()\"><i class=\"icon-class fa fa-clock-o fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.servantTimeSchedule\">servantTimeSchedule</span></a></li><li has-authority=\"ROLE_CATEGORY_MANAGER\" data-toggle=\"tooltip\" ng-show=\"!vm.wedoMeetMode\" title=\"{{\'supplierPanel.sideMenu.serviceItem.title\' | translate}}\"><a class=\"\" ui-sref=\".serviceItemListV2({type: \'service\'})\"><!--<i class=\"fa fa-handshake-o fa-fw \"></i>--> <i class=\"icon-class fa fa-briefcase fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.serviceItem.title\">serviceInfo </span><i class=\"fa fa-chevron-down sub-menu-arrow\" aria-hidden=\"true\"></i></a></li><li has-authority=\"ROLE_EVENT_MANAGER\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.eventItem\' | translate}}\"><a class=\"\" ui-sref=\".serviceItemEventListV2\"><!--<i class=\"fa fa-handshake-o fa-fw \"></i>--> <i class=\"icon-class fa fa-calendar-plus-o fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.eventItem\">eventItem</span> <span style=\"font-size: 10px\" translate=\"supplierPanel.sideMenu.eventItemDesc\"></span> <i class=\"fa fa-chevron-down sub-menu-arrow\" aria-hidden=\"true\"></i></a></li><li has-authority=\"ROLE_RESERVATION_MANAGER\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.orderBagList\' | translate}}\"><a class=\"\" ui-sref=\".reserveList\"><i class=\"icon-class fa fa-list-ol fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.orderBagList\">OrderBag List</span></a></li><li has-authority=\"ROLE_RESERVATION_MANAGER\" data-toggle=\"tooltip\" ng-show=\"!vm.wedoMeetMode\" title=\"{{\'global.setup.timeBoard\' | translate}}\"><a ui-sref=\".calendar\"><i class=\"icon-class fa fa-calendar fa-fw\"></i> <span translate=\"global.setup.timeBoard\">Time Board</span></a></li><li has-authority=\"ROLE_CUSTOMER_MANAGER\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.companyCustomer\' | translate}}\"><a ui-sref=\".companyCustomer\"><i class=\"icon-class fa fa-user fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyCustomer\">Company Customer</span></a></li><li has-authority=\"ROLE_REPORT_MANAGER\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.reports\' | translate}}\"><a ui-sref=\".reportexport\"><i class=\"icon-class fa fa-bar-chart fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.reports\">Conversation List</span></a></li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.accounting.title\' | translate}}\"><a ui-sref=\"supplierPanel.companyPaymentLogList\"><i class=\"icon-class fa fa-usd fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.accounting.title\">Accounting </span><i class=\"fa fa-chevron-down sub-menu-arrow\" aria-hidden=\"true\"></i></a></li><!--<ul id=\"Accounting\" class=\"collapse list-unstyled\" aria-expanded=\"true\">--><!--<li class=\"sub-menu\">--><!--<a ui-sref=\".companyAllPaymentLogList\"><i class=\"fa fa-money fa-fw\"> </i> <span--><!--translate=\"supplierPanel.sideMenu.accounting.companyOnlinePayments\">companyOnlinePayments</span></a>--><!--</li>--><!--<li class=\"sub-menu\">--><!--<a ui-sref=\".companyPaymentLogList\"><i class=\"fa fa-money fa-fw\"> </i> <span--><!--translate=\"supplierPanel.sideMenu.accounting.companyRemaindNotPayed\">companyRemaindNotPayed</span></a>--><!--</li>--><!--</ul>--><li has-authority=\"ROLE_COMPANY_MANAGER\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.setting\' | translate}}\"><a class=\"\" data-target=\"#companyInfo\" ui-sref=\"supplierPanel.setting\"><i class=\"icon-class fa fa-cogs fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.setting\">companyInfo</span></a></li><!--<li>--><!--&lt;!&ndash;<a class=\"\" data-target=\"#\" data-toggle=\"tooltip\" onclick=\"window.Raychat.open();\"&ndash;&gt;--><!--&lt;!&ndash;title=\"{{\'supplierPanel.sideMenu.onlineSupport.title\' | translate}}\"><i&ndash;&gt;--><!--&lt;!&ndash;class=\"icon-class fa fa-volume-control-phone fa-fw\" ></i>&ndash;&gt;--><!--&lt;!&ndash;<span&ndash;&gt;--><!--&lt;!&ndash;translate=\"supplierPanel.sideMenu.onlineSupport.title\">Online Support </span>&ndash;&gt;--><!--&lt;!&ndash;</a>&ndash;&gt;--><!--<a id=\"onlineSupportBtn\" data-target=\"#\" data-toggle=\"tooltip\" onclick=\"$crisp.push([\'do\', \'chat:open\'])\"--><!--title=\"{{\'supplierPanel.sideMenu.onlineSupport.title\' | translate}}\"><i--><!--class=\"icon-class fa fa-volume-control-phone fa-fw\"></i>--><!--<span--><!--translate=\"supplierPanel.sideMenu.onlineSupport.title\">Online Support </span>--><!--</a>--><!--</li>--></ul></nav></div><div id=\"overlay\"></div></div><script type=\"text/javascript\">$(document).ready(function () {\n\n//opens sidePanel from the begining\n        if (localStorage.getItem(\"userFavoriteSideMenu\") == \'close\' || screen.width < 768) {\n            closeSideMenu();\n        } else {\n            openSideMenu();\n        }\n\n        function openSideMenu() {\n            $(\'#sidebar\').addClass(\'open\');\n            $(\'#menuHamburgerDesktop\').addClass(\'change\');\n            $(\'.navbar-fixed-top\').addClass(\'compact\');\n            $(\'#page-wrapper\').addClass(\'compact\');\n            localStorage.setItem(\"userFavoriteSideMenu\", \"open\");\n        }\n\n        function closeSideMenu() {\n            $(\'#sidebar\').removeClass(\'open\');\n            $(\'#menuHamburgerDesktop\').removeClass(\'change\');\n            $(\'.navbar-fixed-top\').removeClass(\'compact\');\n            $(\'#page-wrapper\').removeClass(\'compact\');\n            localStorage.setItem(\"userFavoriteSideMenu\", \"close\");\n        }\n\n        function toggleSidePanel() {\n            if ($(\'#sidebar\').hasClass(\'open\')) {\n                closeSideMenu();\n\n            } else {\n                openSideMenu();\n            }\n        }\n\n        $(\'#menuHamburgerDesktop\').unbind(\'click\'); //unbind is to avert multiple events of click on one click event\n        $(\'#menuHamburgerDesktop\').on(\'click\', function () {\n            toggleSidePanel();\n        });\n\n        $(\'#sidebar ul li\').on(\'click\', function () {\n            if ($(this).attr(\'id\') != \"menuHamburgerDesktop\") {\n                $(\'*\').removeClass(\'active\');\n                $(this).addClass(\'active\');\n            }\n            if (screen.width < 768) {\n                $(\'#sidebar\').css(\'width\', \'0px\');\n                $(\'#ellipsisMobile\').css(\'width\', \'0px\');\n                $(\'#overlay\').css(\'display\', \'none\');\n                $(\'[data-toggle=\"tooltip\"]\').tooltip({\n                    title: \'\'\n                });\n            }\n        });\n\n        $(\'li\').hover(function () {\n            $(\'[data-toggle=\"tooltip\"]\').tooltip({\n                placement: \'left\',\n                // title: \'heyo\',\n                container: \'body\', //<--- use the container option\n                trigger: \'hover\'\n            });\n        })\n        $(\'#menuHamburgerMobile\').on(\'click\', function () {\n            if ($(\'#sidebar\').width() == \'0\') {\n                // openSideMenu();\n                $(\'#sidebar\').css(\'width\', \'250px\');\n                $(\'#overlay\').css(\'display\', \'block\');\n            }\n\n        });\n        $(\'#overlay\').on(\'click\', function () {\n            $(\'#sidebar\').css(\'width\', \'0px\');\n            $(\'#ellipsisMobile\').css(\'width\', \'0px\');\n            $(\'#overlay\').css(\'display\', \'none\');\n\n        });\n\n\n        var removerInterval = setInterval(crispIconRemover, 10);\n        var isClassDeleted = false;\n\n        function crispIconRemover() {\n            var a = $(\".crisp-client > #crisp-chatbox > div > a > span\").remove();\n            if (a.length > 0 && !a[0].className === \'\') {\n                isClassDeleted = true;\n            }\n            if (a.length > 0 && !isClassDeleted) {\n                isClassDeleted = true;\n            } else if (isClassDeleted) {\n                clearInterval(removerInterval);\n            }\n        };\n        $(\"#onlineSupportBtn\").on(\'click\', function () {\n            var removerInterval = setInterval(crispIconRemover, 10);\n        })\n\n    });</script>");
$templateCache.put("app/supplier-v2/access-denied-v2.html","<div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div ng-cloak style=\"padding-top: 80px\"><div class=\"row\"><div class=\"access-denied-header\"><h1 translate=\"error.title\">Error Page!</h1><span class=\"no-access img-responsive img-rounded\"></span></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-offset-2\"><div class=\"alert alert-danger\" style=\"background-color: #f93d3d1c;color: red;text-align: center\" translate=\"error.403\">You are not authorized to access the page.</div></div></div><div class=\"row\" style=\"padding-top: 50px\"><div class=\"col-md-12\" style=\"display: flex\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px;width: 80%; margin: auto\" ng-click=\"vm.goToPrevState()\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div></div></div></div>");
$templateCache.put("app/supplier-v2/supplierPanel-v2.html","<!--cropper--><!--<script src=\"../../js/tools/cropper.min.js\"></script>--><!--<link rel=\"stylesheet\" href=\"../../content/css/cropper.min.css\"/>--><!--......................--><style>#sidebarV2::-webkit-scrollbar {\n        width: 7px;\n        height: 7px;\n\n    }\n\n    /* Track */\n    #sidebarV2::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 7px;\n    }\n\n    /* Handle */\n    #sidebarV2::-webkit-scrollbar-thumb {\n        background: rgba(230, 230, 230, 0.6);\n        border-radius: 7px;\n    }\n\n    /* Handle on hover */\n    #sidebarV2::-webkit-scrollbar-thumb:hover {\n        background: rgba(230, 230, 230, 0.2);\n    }\n\n    .company-title-on-menu {\n        color: #217289;\n        font-size: 1.1em;\n        font-weight: bold;\n        text-align: center;\n        margin: 5px;\n    }\n\n\n    /*menuIcon*/\n    #menuHamburgerDesktopV2 {\n        cursor: pointer;\n\n        height: 65px;\n        padding: 20px 16px;\n    }\n\n    .bar1, .bar2, .bar3 {\n        width: 28px;\n        height: 3px;\n        /*background-color: #009688;*/\n        margin: 3px 0;\n        transition: 0.5s;\n    }\n\n    .change .bar1 {\n        -webkit-transform: rotate(-45deg) translate(-6px, 8px);\n        transform: rotate(-35deg) translate(-6px, 8px);\n    }\n\n    .change .bar2 {\n        opacity: 0;\n    }\n\n    .change .bar3 {\n        -webkit-transform: rotate(45deg) translate(-1px, -2px);\n        transform: rotate(35deg) translate(-1px, -2px);\n    }\n\n    /*menuIcon*/\n\n    #menuPin {\n        float: left;\n        display: none;\n    }\n\n\n    /* ---------------------------------------------------\n        SIDEBAR STYLE\n    ----------------------------------------------------- */\n    #sidebarV2.active {\n        right: 0;\n    }\n\n\n    /*#sidebar .sidebar-header {*/\n    /*padding: 20px;*/\n    /*background: #009688;*/\n    /*color: #cfebd9;*/\n    /*}*/\n\n    #sidebarV2 ul.components {\n        padding: 0;\n        /*border-bottom: 1px solid #47748b;*/\n    }\n\n    #sidebarV2 ul p {\n        color: #fff;\n        padding: 10px;\n    }\n\n    #sidebarV2 ul li {\n        /*height: 65px;*/\n    }\n\n    #sidebarV2 ul li a {\n        font-size: 1.5em;\n        display: block;\n        /*border-top: 1px solid #eee;*/\n        margin: 0;\n        /*text-align: center;*/\n        text-decoration: none;\n        display: flex;\n        align-items: center;\n        padding: 11px 0;\n        gap: 3px;\n    }\n\n    #sidebarV2 ul li a span {\n        font-size: 0.7em;\n        /*padding-right: 32px;*/\n    }\n\n    a[data-toggle=\"collapse\"] {\n        position: relative;\n    }\n\n\n    .sub-menu {\n\n        font-size: 0.85em !important;\n        background: rgba(253, 253, 253, 1);\n        font-size: 1.1em;\n    }\n\n    ul.CTAs {\n        padding: 20px;\n    }\n\n    ul.CTAs a {\n        text-align: center;\n        font-size: 0.9em !important;\n        display: block;\n        border-radius: 5px;\n        margin-bottom: 5px;\n    }\n\n    .sub-menu-arrow {\n        display: none;\n        float: left;\n        margin-left: 10px;\n        font-size: 0.8em;\n    }\n\n    @media (max-width: 767px) {\n        #menuHamburgerDesktopV2 {\n            display: none;\n        }\n\n        #sidebarV2 {\n            width: 0px;\n        }\n\n        #overlay {\n            position: fixed; /* Sit on top of the page content */\n            display: none; /* Hidden by default */\n            width: 100%; /* Full width (cover the whole page) */\n            height: 100%; /* Full height (cover the whole page) */\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */\n            z-index: 1030; /* Specify a stack order in case you\'re using a different order for other elements */\n            cursor: pointer; /* Add a pointer on hover */\n        }\n\n    }\n\n    .icon-class {\n        margin-left: 30px;\n    }\n\n    html {\n        overflow-y: scroll !important;\n    }\n\n    /*.icon-class:before {*/\n    /*color: #000;*/\n    /*}*/</style><div ng-cloak><eo-progress-bar></eo-progress-bar><div ng-joy-ride=\"vm.guidTipsEnable\" config=\"vm.guidTipsConfig\" on-finish=\"vm.guidTipsonFinish()\" on-skip=\"vm.guidTipsonFinish()\"></div><!--&lt;!&ndash; Page Content &ndash;&gt;--><div id=\"page-wrapper\" style=\"overflow: hidden\"><div class=\"pl-container-fluid\"><div class=\"row\"><div class=\"\"><jhi-alert></jhi-alert><div class=\"\"><!--<button type=\"button\" id=\"sidebarCollapse\" class=\"btn btn-info navbar-btn\">--><!--<i class=\"glyphicon 	glyphicon glyphicon-th-list\"></i>--><!--<i class=\"glyphicon glyphicon-arrow-left\"></i>--><!--</button>--><div ui-view=\"subcontent\"></div></div></div><!-- /.col-lg-12 --></div><!-- /.row --></div><!-- /.container-fluid --></div><!-- /#page-wrapper --><div class=\"wrapper hidden-xs\"><nav id=\"sidebarV2\"><ul class=\"components\"><div style=\"height: 65px;background-color: white;color: black\"><!--<a id=\"logo\" class=\"navbar-brand logo\" style=\"padding-right: 7px;\" href=\"#/\" ng-click=\"vm.collapseNavbar()\">--> <a id=\"logoV2\" class=\"navbar-brand logo\" style=\"padding-right: 17px;padding-top: 11px\" ng-click=\"vm.collapseNavbar()\"><img class=\"logo-img\" ng-src=\"{{vm.logoSource}}\"> <span style=\"padding-right: 15px; font-size: larger\" translate=\"global.title\">reserwebTitle</span></a></div><div><li id=\"expired-li\" style=\"color: red\" has-any-authority=\"ROLE_RESERVATION_MANAGER_EXPIRE,ROLE_CUSTOMER_MANAGER_EXPIRE,ROLE_CATEGORY_MANAGER_EXPIRE,ROLE_COMPANY_MANAGER_EXPIRE\" data-toggle=\"tooltip\" title=\"{{\'supplierPanel.sideMenu.purchaseCompanySubscriptionStatus\' | translate}}\"><!--<span>اشتراک شما به پایان رسیده است</span>--> <a ui-sref=\".companySubscriptionStatusV2\"><span ng-switch on=\"vm.isLiActive(\'expired-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.623\" height=\"37.431\" viewBox=\"0 0 37.623 37.431\"><g data-name=\"Group 1042\"><path data-name=\"Path 2409\" d=\"M16.551 30.672a3.891 3.891 0 0 0-2.741-1.092 3.907 3.907 0 0 0-2.634 6.72 3.859 3.859 0 0 0 2.678 1.13h.061a4.018 4.018 0 0 0 2.793-1.238 3.829 3.829 0 0 0 1.106-2.734 3.994 3.994 0 0 0-1.263-2.788m-4.025 2.762a1.351 1.351 0 0 1 1.356-1.323h.039a1.415 1.415 0 0 1 1.366 1.4 1.346 1.346 0 0 1-.392.973 1.45 1.45 0 0 1-1.043.4 1.33 1.33 0 0 1-.969-.392 1.418 1.418 0 0 1-.357-1.056\" transform=\"translate(.001 -.001)\" style=\"fill:#161615\"/><path data-name=\"Path 2410\" d=\"M32.552 30.711a3.9 3.9 0 1 0-2.719 6.72h.031a3.838 3.838 0 0 0 2.714-1.131 3.905 3.905 0 0 0 1.171-2.791 3.969 3.969 0 0 0-1.2-2.8m-2.7 1.4a1.419 1.419 0 0 1 .995.433 1.384 1.384 0 0 1 .417.989 1.407 1.407 0 0 1-1.4 1.355 1.392 1.392 0 0 1-1.417-1.4 1.431 1.431 0 0 1 1.389-1.377z\" transform=\"translate(.001 -.001)\" style=\"fill:#161615\"/><path data-name=\"Path 2411\" d=\"M36.756 6.533a4.336 4.336 0 0 0-3.419-1.265q-8.207-.01-16.417 0H9.5L9.421 4.8a38.225 38.225 0 0 0-.28-1.623A3.478 3.478 0 0 0 6.19.1C5.329.015 2.233 0 1.216 0a1.221 1.221 0 0 0 0 2.441c.7 0 3.136.006 3.835.013 1.07.01 1.488.375 1.649 1.446l1.6 10.236c.663 4.231.556 5.534 1.19 9.769.415 2.762 1.869 4.049 4.578 4.051h17.514a1.243 1.243 0 1 0 0-2.486h-4.651q-6.511-.006-13.023.011h-.018c-.946 0-1.469-.315-1.693-1.02-.045-.14-.243-1.482-.5-3.334h20.517a4.051 4.051 0 0 0 4.321-3.8c.3-2.039-.083.262.231-1.776l.549-3.584c.061-.4.109-.8.158-1.2l.085-.682a4.324 4.324 0 0 0-.8-3.549M35.1 9.4c-.32 2.335-.977 7.218-1.055 7.7v.026a1.833 1.833 0 0 1-1.828 1.5H11.343c-.592-4.266-1.292-9.435-1.414-10.219a5.177 5.177 0 0 1-.046-.6H32.995a4.4 4.4 0 0 1 1.032.094c.911.225 1.192.617 1.071 1.494\" transform=\"translate(.001 -.001)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.622\" height=\"37.432\" viewBox=\"0 0 37.622 37.432\"><g data-name=\"Group 1041\"><path data-name=\"Path 2412\" d=\"M66.586 30.672a3.891 3.891 0 0 0-2.741-1.092 3.907 3.907 0 0 0-2.634 6.72 3.859 3.859 0 0 0 2.678 1.13h.061a4.018 4.018 0 0 0 2.793-1.238 3.829 3.829 0 0 0 1.106-2.734 3.994 3.994 0 0 0-1.263-2.788m-4.025 2.762a1.351 1.351 0 0 1 1.356-1.323h.039a1.415 1.415 0 0 1 1.366 1.4 1.346 1.346 0 0 1-.392.973 1.45 1.45 0 0 1-1.043.4 1.33 1.33 0 0 1-.969-.392 1.418 1.418 0 0 1-.357-1.056\" transform=\"translate(-50.035)\" style=\"fill:#161615\"/><path data-name=\"Path 2413\" d=\"M82.587 30.711a3.9 3.9 0 1 0-2.719 6.72h.032a3.838 3.838 0 0 0 2.713-1.131 3.905 3.905 0 0 0 1.171-2.791 3.969 3.969 0 0 0-1.2-2.8m-2.7 1.4a1.419 1.419 0 0 1 1 .433 1.384 1.384 0 0 1 .417.989 1.407 1.407 0 0 1-1.4 1.355 1.392 1.392 0 0 1-1.417-1.4 1.431 1.431 0 0 1 1.389-1.377z\" transform=\"translate(-50.035)\" style=\"fill:#161615\"/><path data-name=\"Path 2414\" d=\"M86.791 6.532a4.334 4.334 0 0 0-3.418-1.265q-8.208-.009-16.418 0h-7.423l-.075-.467c-.089-.56-.173-1.094-.281-1.623A3.479 3.479 0 0 0 56.226.1c-.862-.086-3.958-.1-4.975-.1a1.221 1.221 0 0 0 0 2.441c.7 0 3.136.006 3.835.013 1.072.01 1.489.374 1.654 1.443l1.6 10.237c.663 4.23.556 5.534 1.191 9.768.414 2.762 1.868 4.049 4.577 4.051H81.618a1.243 1.243 0 0 0 0-2.486h-4.652q-6.512-.006-13.023.01h-.017c-.947 0-1.47-.315-1.694-1.019-.045-.14-.243-1.483-.5-3.334h20.516a4.052 4.052 0 0 0 4.321-3.8c.3-2.039-.083.262.231-1.775l.55-3.584c.06-.4.108-.8.157-1.2l.085-.682a4.324 4.324 0 0 0-.8-3.549\" transform=\"translate(-50.035)\" style=\"fill:#161615\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.purchaseCompanySubscriptionStatus\">purchaseCompanySubscriptionStatus</span></a></li><li id=\"home-li\"><md-tooltip md-direction=\"left\">{{\'global.menu.home\' | translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.dashboard\"><!--<i class=\"icon-class fa fa-home fa-lg\"></i>--><!--<img src=\"/content/images/svg/home.svg\">--> <span ng-switch on=\"vm.isLiActive(\'home-li\')\" class=\"icon-box\"><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"38.136\" height=\"37.14\" viewBox=\"0 0 38.136 37.14\"><path data-name=\"Path 2385\" d=\"M37.066 61.791 21.661 46.383a3.661 3.661 0 0 0-2.582-1.075h-.19a3.231 3.231 0 0 0-2.406 1.072l-15.4 15.4a3.661 3.661 0 0 0 2.435 6.26h.525v10.144A4.269 4.269 0 0 0 8.3 82.441h6.025a1.3 1.3 0 0 0 1.294-1.294v-7.879A1.675 1.675 0 0 1 17.29 71.6h3.555a1.675 1.675 0 0 1 1.67 1.67v7.888a1.3 1.3 0 0 0 1.3 1.293h6.027a4.28 4.28 0 0 0 4.255-4.255V68.043h.382a3.664 3.664 0 0 0 2.591-6.252\" transform=\"translate(0 -45.308)\" style=\"fill:#161615\"/></svg></div><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"38.136\" height=\"37.14\" viewBox=\"0 0 38.136 37.14\"><path data-name=\"Path 2388\" d=\"m37.716 61.791-15.4-15.408a3.661 3.661 0 0 0-2.582-1.075h-.19a3.231 3.231 0 0 0-2.406 1.072l-15.4 15.4a3.661 3.661 0 0 0 2.435 6.26H4.7v10.144a4.268 4.268 0 0 0 4.257 4.257h6.025a1.3 1.3 0 0 0 1.294-1.294v-7.879A1.675 1.675 0 0 1 17.94 71.6h3.56a1.675 1.675 0 0 1 1.67 1.67v7.888a1.3 1.3 0 0 0 1.3 1.293h6.027a4.28 4.28 0 0 0 4.255-4.255V68.043h.382a3.664 3.664 0 0 0 2.591-6.252M36.154 65.4l-.3-.231a1.083 1.083 0 0 1-.724.283h-1.681a1.3 1.3 0 0 0-1.291 1.293v11.446a1.681 1.681 0 0 1-1.671 1.67h-4.733v-6.6a4.279 4.279 0 0 0-4.254-4.249h-3.557a4.275 4.275 0 0 0-4.255 4.255v6.594H8.953a1.676 1.676 0 0 1-1.672-1.669V66.749a1.3 1.3 0 0 0-1.294-1.293H4.294a1.078 1.078 0 0 1-.742-1.839L18.96 48.21a1.086 1.086 0 0 1 1.522 0l15.4 15.4a1.09 1.09 0 0 1 .006 1.529z\" transform=\"translate(-.65 -45.308)\" style=\"fill:#161615\"/></svg></div></span><span translate=\"global.menu.home\">Home</span></a></li><li id=\"servant-li\" has-authority=\"ROLE_SERVANT_MANAGER\"><md-tooltip md-direction=\"left\">{{vm.servantTranslateFile | translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.companyServants\"><!--<i class=\"icon-class\" ng-class=\"vm.servantClass\">--><!--</i>\n                            --> <span ng-if=\"!vm.isWorkSpace\" ng-switch on=\"vm.isLiActive(\'servant-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.365\" height=\"37.365\" viewBox=\"0 0 37.365 37.365\"><g data-name=\"Group 948\"><path data-name=\"Path 2335\" d=\"M31.049 129.66a14.448 14.448 0 0 0-7.46-6.28 7.7 7.7 0 1 0-9.59-.14 14.364 14.364 0 0 0-7.62 6.01 13.165 13.165 0 0 0-1.21 2.4 17.611 17.611 0 0 0 1.99 1.87 11.976 11.976 0 0 1 11.33-8.54h.1c.1 0 .2 0 .3.01a11.934 11.934 0 0 1 10.3 6.47 10.962 10.962 0 0 1 .93 2.45 16.892 16.892 0 0 0 2.06-1.81 13.889 13.889 0 0 0-1.13-2.44m-12.16-7.18a5.2 5.2 0 1 1 5.2-5.2 5.211 5.211 0 0 1-5.2 5.2\" transform=\"translate(-.203 -100.313)\" style=\"fill:#161615\"/><path data-name=\"Path 2336\" d=\"M18.886 137.678A18.682 18.682 0 1 1 37.568 119a18.7 18.7 0 0 1-18.682 18.682m0-34.862A16.18 16.18 0 1 0 35.066 119a16.2 16.2 0 0 0-16.18-16.18\" transform=\"translate(-.203 -100.313)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.365\" height=\"37.365\" viewBox=\"0 0 37.365 37.365\"><g data-name=\"Group 991\"><path data-name=\"Path 2378\" d=\"M19.068 137.678A18.682 18.682 0 1 1 37.75 119a18.7 18.7 0 0 1-18.682 18.682\" transform=\"translate(-.385 -100.313)\" style=\"fill:#101928\"/><path data-name=\"Path 2379\" d=\"M31.231 129.66a14.448 14.448 0 0 0-7.46-6.28 7.7 7.7 0 1 0-9.59-.14 14.364 14.364 0 0 0-7.62 6.01 13.165 13.165 0 0 0-1.21 2.4 17.611 17.611 0 0 0 1.99 1.87 11.976 11.976 0 0 1 11.33-8.54h.1c.1 0 .2 0 .3.01a11.934 11.934 0 0 1 10.3 6.47 10.962 10.962 0 0 1 .93 2.45 16.892 16.892 0 0 0 2.06-1.81 13.889 13.889 0 0 0-1.13-2.44m-12.16-7.18a5.2 5.2 0 1 1 5.2-5.2 5.211 5.211 0 0 1-5.2 5.2\" transform=\"translate(-.385 -100.313)\" style=\"fill:#fff\"/></g></svg></div></span><span ng-if=\"vm.isWorkSpace\" ng-switch on=\"vm.isLiActive(\'servant-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.624\" height=\"37.623\" viewBox=\"0 0 37.624 37.623\"><defs><style>.cls-1 {\n                                          fill: #161615;\n                                      }</style></defs><g id=\"Group_957\" data-name=\"Group 957\" transform=\"translate(-1949.091 -699.681)\"><path id=\"Path_2337\" data-name=\"Path 2337\" class=\"cls-1\" d=\"M32.206,663.3H5.6A5.515,5.515,0,0,1,.091,657.8V631.189A5.515,5.515,0,0,1,5.6,625.681H32.206a5.515,5.515,0,0,1,5.509,5.508V657.8a5.515,5.515,0,0,1-5.509,5.508M5.6,628.2a2.994,2.994,0,0,0-2.99,2.99V657.8a2.994,2.994,0,0,0,2.99,2.99H32.206a2.993,2.993,0,0,0,2.989-2.99V631.189a2.993,2.993,0,0,0-2.989-2.99Z\" transform=\"translate(1949 74)\"/><path id=\"Path_2338\" data-name=\"Path 2338\" class=\"cls-1\" d=\"M16.559,657.519H6.609a1.26,1.26,0,0,1-1.26-1.259v-9.95a1.26,1.26,0,0,1,1.26-1.259h9.95a1.26,1.26,0,0,1,1.26,1.259v9.95a1.26,1.26,0,0,1-1.26,1.259M7.869,655H15.3V647.57H7.869Z\" transform=\"translate(1949 74)\"/><path id=\"Path_2339\" data-name=\"Path 2339\" class=\"cls-1\" d=\"M17.014,643.283a6.69,6.69,0,1,1,6.69-6.69,6.7,6.7,0,0,1-6.69,6.69m0-10.861a4.172,4.172,0,1,0,4.17,4.171,4.175,4.175,0,0,0-4.17-4.171\" transform=\"translate(1949 74)\"/><path id=\"Path_2340\" data-name=\"Path 2340\" class=\"cls-1\" d=\"M33.319,652.544H20.373a1.259,1.259,0,0,1-1.09-1.888l6.472-11.211a1.259,1.259,0,0,1,2.181,0l6.473,11.211a1.259,1.259,0,0,1-1.09,1.888m-10.764-2.518h8.582l-4.291-7.432Z\" transform=\"translate(1949 74)\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.624\" height=\"37.624\" viewBox=\"0 0 37.624 37.624\"><defs><style>.cls-1 {\n                                          fill: #161615;\n                                      }\n\n                                      .cls-2 {\n                                          fill: #fff;\n                                      }</style></defs><g id=\"Group_990\" data-name=\"Group 990\" transform=\"translate(-1933.383 -758.68)\"><path id=\"Path_2380\" data-name=\"Path 2380\" class=\"cls-1\" d=\"M32.5,663.3H5.891A5.514,5.514,0,0,1,.383,657.8V631.189a5.515,5.515,0,0,1,5.508-5.509H32.5a5.515,5.515,0,0,1,5.509,5.509V657.8A5.515,5.515,0,0,1,32.5,663.3\" transform=\"translate(1933 133)\"/><path id=\"Path_2381\" data-name=\"Path 2381\" class=\"cls-2\" d=\"M16.851,657.519H6.9a1.26,1.26,0,0,1-1.26-1.259v-9.95a1.26,1.26,0,0,1,1.26-1.259h9.95a1.259,1.259,0,0,1,1.259,1.259v9.95a1.259,1.259,0,0,1-1.259,1.259M8.16,655h7.431V647.57H8.16Z\" transform=\"translate(1933 133)\"/><path id=\"Path_2382\" data-name=\"Path 2382\" class=\"cls-2\" d=\"M17.306,643.283a6.69,6.69,0,1,1,6.69-6.69,6.7,6.7,0,0,1-6.69,6.69m0-10.861a4.172,4.172,0,1,0,4.17,4.171,4.175,4.175,0,0,0-4.17-4.171\" transform=\"translate(1933 133)\"/><path id=\"Path_2383\" data-name=\"Path 2383\" class=\"cls-2\" d=\"M33.611,652.544H20.665a1.259,1.259,0,0,1-1.09-1.888l6.472-11.211a1.259,1.259,0,0,1,2.181,0L34.7,650.656a1.259,1.259,0,0,1-1.09,1.888m-10.764-2.518h8.582l-4.291-7.432Z\" transform=\"translate(1933 133)\"/></g></svg></div></span><span>{{vm.servantTranslateFile | translate}}</span> <span style=\"font-size: 10px;padding-right: 5px\">( {{vm.servantListTitle}} )</span></a></li><li id=\"servant-login-li\" has-authority=\"ROLE_SERVANT_LOGIN\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.servantTimeSchedule\'| translate}}</md-tooltip><a ng-click=\"vm.goToCurrentServant()\"><span ng-switch on=\"vm.isLiActive(\'servant-login-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.614\" viewBox=\"0 0 37.615 37.614\"><g data-name=\"Group 1052\"><path data-name=\"Path 2443\" d=\"M18.807 37.614a18.807 18.807 0 1 1 18.808-18.807 18.829 18.829 0 0 1-18.808 18.807m0-35.1A16.289 16.289 0 1 0 35.1 18.807 16.307 16.307 0 0 0 18.807 2.518\" style=\"fill:#101928\"/><path data-name=\"Path 2444\" d=\"M18.862 31.729a12.922 12.922 0 1 1 12.922-12.922 12.936 12.936 0 0 1-12.922 12.922m0-23.344a10.422 10.422 0 1 0 10.422 10.422A10.433 10.433 0 0 0 18.862 8.385\" style=\"fill:#101928\"/><path data-name=\"Path 2445\" d=\"M14.493 25.29a1.25 1.25 0 0 1-.884-2.134l3.948-3.948v-7.9a1.25 1.25 0 0 1 2.5 0v8.414a1.246 1.246 0 0 1-.366.883l-4.314 4.315a1.246 1.246 0 0 1-.884.366\" style=\"fill:#101928\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.614\" viewBox=\"0 0 37.615 37.614\"><g data-name=\"Group 1051\"><path data-name=\"Path 2446\" d=\"M72.543 37.614a18.807 18.807 0 1 1 18.808-18.807 18.829 18.829 0 0 1-18.808 18.807m0-35.1a16.289 16.289 0 1 0 16.288 16.293A16.307 16.307 0 0 0 72.543 2.518\" transform=\"translate(-53.736)\" style=\"fill:#101928\"/><path data-name=\"Path 2447\" d=\"M72.6 31.729a12.922 12.922 0 1 1 12.92-12.922A12.936 12.936 0 0 1 72.6 31.729\" transform=\"translate(-53.736)\" style=\"fill:#101928\"/><path data-name=\"Path 2448\" d=\"M68.229 25.29a1.25 1.25 0 0 1-.884-2.134l3.948-3.948v-7.9a1.25 1.25 0 0 1 2.5 0v8.414a1.246 1.246 0 0 1-.366.883l-4.314 4.315a1.246 1.246 0 0 1-.884.366\" transform=\"translate(-53.736)\" style=\"fill:#fff\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.servantTimeSchedule\">servantTimeSchedule</span></a></li><li id=\"service-li\" has-authority=\"ROLE_CATEGORY_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.serviceItem.title-v2\'| translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.reserveServices({type:\'service\'})\" class=\"\"><!--<i class=\"fa fa-handshake-o fa-fw \"></i>--><!--<i class=\"icon-class fa fa-briefcase fa-fw\">--><!--</i>--> <span ng-switch on=\"vm.isLiActive(\'service-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.705\" height=\"37.682\" viewBox=\"0 0 37.705 37.682\"><g data-name=\"Group 949\"><path data-name=\"Path 2294\" d=\"M32.167 201.7h-26.5A5.629 5.629 0 0 1 .12 196v-19.084a5.629 5.629 0 0 1 5.547-5.7h26.5a5.63 5.63 0 0 1 5.548 5.7V196a5.63 5.63 0 0 1-5.548 5.7m-26.5-27.758a2.943 2.943 0 0 0-2.9 2.977V196a2.942 2.942 0 0 0 2.9 2.977h26.5a2.942 2.942 0 0 0 2.9-2.977v-19.084a2.943 2.943 0 0 0-2.9-2.977z\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2295\" d=\"M26.463 173.939H11.371a1.342 1.342 0 0 1-1.324-1.359v-4.125a4.389 4.389 0 0 1 4.325-4.44h9.09a4.389 4.389 0 0 1 4.325 4.44v4.125a1.342 1.342 0 0 1-1.324 1.359m-13.768-2.718h12.444v-2.766a1.7 1.7 0 0 0-1.677-1.722h-9.09a1.7 1.7 0 0 0-1.677 1.722z\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2296\" d=\"M36.281 185.142H1.334a1.359 1.359 0 0 1 0-2.718h34.947a1.359 1.359 0 0 1 0 2.718\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2297\" d=\"M11.372 188.9a1.342 1.342 0 0 1-1.324-1.359v-7.52a1.324 1.324 0 1 1 2.648 0v7.52a1.342 1.342 0 0 1-1.324 1.359\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2298\" d=\"M26.463 188.9a1.342 1.342 0 0 1-1.324-1.359v-7.52a1.324 1.324 0 1 1 2.648 0v7.52a1.342 1.342 0 0 1-1.324 1.359\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.595\" height=\"37.683\" viewBox=\"0 0 37.595 37.683\"><g data-name=\"Group 984\"><path data-name=\"Path 2345\" d=\"M32.453 201.7h-26.5A5.63 5.63 0 0 1 .405 196v-19.084a5.63 5.63 0 0 1 5.548-5.7h26.5a5.629 5.629 0 0 1 5.547 5.7V196a5.629 5.629 0 0 1-5.547 5.695\" transform=\"translate(-.405 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2346\" d=\"M26.749 173.939H11.657a1.342 1.342 0 0 1-1.324-1.359v-4.125a4.389 4.389 0 0 1 4.325-4.44h9.09a4.389 4.389 0 0 1 4.325 4.44v4.125a1.342 1.342 0 0 1-1.324 1.359m-13.768-2.718h12.444v-2.766a1.7 1.7 0 0 0-1.677-1.722h-9.09a1.7 1.7 0 0 0-1.677 1.722z\" transform=\"translate(-.405 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2347\" d=\"M11.657 188.9a1.342 1.342 0 0 1-1.324-1.359v-7.52a1.324 1.324 0 1 1 2.648 0v7.52a1.342 1.342 0 0 1-1.324 1.359\" transform=\"translate(-.405 -164.015)\" style=\"fill:#fff\"/><path data-name=\"Path 2348\" d=\"M26.749 188.9a1.342 1.342 0 0 1-1.324-1.359v-7.52a1.324 1.324 0 1 1 2.648 0v7.52a1.342 1.342 0 0 1-1.324 1.359\" transform=\"translate(-.405 -164.015)\" style=\"fill:#fff\"/><path data-name=\"Rectangle 65\" transform=\"translate(0 18.409)\" style=\"fill:#fff\" d=\"M0 0h37.595v2.718H0z\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.serviceItem.title-v2\">serviceInfo </span><i class=\"fa fa-chevron-down sub-menu-arrow\" aria-hidden=\"true\"></i></a></li><li id=\"event-li\" has-authority=\"ROLE_EVENT_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.eventItem\'| translate}}</md-tooltip><a class=\"\" ui-sref=\"supplierPanel-v2.eventItemList\"><!--<i class=\"fa fa-handshake-o fa-fw \"></i>--><!--<i class=\"icon-class fa fa-calendar-plus-o fa-fw\">--><!--</i>--> <span ng-switch on=\"vm.isLiActive(\'event-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.715\" height=\"37.595\" viewBox=\"0 0 37.715 37.595\"><g data-name=\"Group 950\"><path data-name=\"Path 2299\" d=\"M31.348 255.366H6.379A6.374 6.374 0 0 1 .012 249v-22.2a6.375 6.375 0 0 1 6.367-6.368h24.969a6.375 6.375 0 0 1 6.367 6.368V249a6.374 6.374 0 0 1-6.367 6.367m-24.969-32.4a3.835 3.835 0 0 0-3.83 3.83V249a3.835 3.835 0 0 0 3.83 3.83h24.969a3.835 3.835 0 0 0 3.829-3.83v-22.2a3.834 3.834 0 0 0-3.829-3.83z\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2300\" d=\"M36.446 232.128H1.263a1.263 1.263 0 0 1 0-2.526h35.183a1.263 1.263 0 0 1 0 2.526\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2301\" d=\"M12.991 225.769a1.263 1.263 0 0 1-1.264-1.263v-5.472a1.263 1.263 0 1 1 2.526 0v5.472a1.262 1.262 0 0 1-1.262 1.263\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2302\" d=\"M24.719 225.769a1.263 1.263 0 0 1-1.263-1.263v-5.472a1.263 1.263 0 1 1 2.526 0v5.472a1.263 1.263 0 0 1-1.263 1.263\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2303\" d=\"M17.089 248.138a1.258 1.258 0 0 1-.893-.37l-4.882-4.882A1.263 1.263 0 0 1 13.1 241.1l3.989 3.989 9.293-9.293a1.263 1.263 0 0 1 1.786 1.786l-10.186 10.186a1.258 1.258 0 0 1-.893.37\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.714\" height=\"37.595\" viewBox=\"0 0 37.714 37.595\"><g data-name=\"Group 985\"><path data-name=\"Path 2349\" d=\"M31.633 220.433H6.665A6.375 6.375 0 0 0 .3 226.8v4.005c0 .021-.012.038-.012.059s.011.038.012.059V249a6.374 6.374 0 0 0 6.367 6.367h24.966A6.374 6.374 0 0 0 38 249v-22.2a6.375 6.375 0 0 0-6.367-6.368m-24.968 2.539h24.968a3.834 3.834 0 0 1 3.829 3.83v2.8H2.835v-2.8a3.835 3.835 0 0 1 3.83-3.83\" transform=\"translate(-.286 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2350\" d=\"M13.276 225.769a1.263 1.263 0 0 1-1.263-1.263v-5.472a1.263 1.263 0 1 1 2.526 0v5.472a1.263 1.263 0 0 1-1.263 1.263\" transform=\"translate(-.286 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2351\" d=\"M25 225.769a1.263 1.263 0 0 1-1.263-1.263v-5.472a1.263 1.263 0 1 1 2.526 0v5.472A1.263 1.263 0 0 1 25 225.769\" transform=\"translate(-.286 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2352\" d=\"M17.375 248.138a1.258 1.258 0 0 1-.893-.37l-4.882-4.882a1.263 1.263 0 0 1 1.786-1.786l3.989 3.989 9.293-9.293a1.263 1.263 0 0 1 1.786 1.786l-10.186 10.186a1.258 1.258 0 0 1-.893.37\" transform=\"translate(-.286 -217.771)\" style=\"fill:#fff\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.eventItem\">eventItem</span> <span style=\"font-size: 10px;padding-right: 5px\" translate=\"supplierPanel.sideMenu.eventItemDesc\"></span> <i class=\"fa fa-chevron-down sub-menu-arrow\" aria-hidden=\"true\"></i></a></li><li id=\"reserve-list-li\" has-authority=\"ROLE_RESERVATION_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.orderBagList\'| translate}}</md-tooltip><a class=\"\" ui-sref=\"supplierPanel-v2.reserveList({page: 1, pageSize: 10, searchText: \'\' })\"><!--<i class=\"icon-class fa fa-list-ol fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'reserve-list-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"33.615\" viewBox=\"0 0 37.614 33.615\"><g data-name=\"Group 1011\"><path data-name=\"Path 2389\" d=\"M209.586 283.685h-23.855a6.888 6.888 0 0 0-6.88 6.88v19.855a6.887 6.887 0 0 0 6.88 6.88h23.855a6.887 6.887 0 0 0 6.879-6.88v-19.855a6.888 6.888 0 0 0-6.879-6.88m4.352 26.735a4.357 4.357 0 0 1-4.352 4.352h-23.855a4.357 4.357 0 0 1-4.353-4.352v-19.855a4.357 4.357 0 0 1 4.353-4.352h23.855a4.357 4.357 0 0 1 4.352 4.352z\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2390\" d=\"M205.437 292.605h-15.559a1.263 1.263 0 1 0 0 2.527h15.559a1.263 1.263 0 1 0 0-2.527\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2391\" d=\"M205.437 299.229h-15.559a1.264 1.264 0 1 0 0 2.527h15.559a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2392\" d=\"M205.437 305.853h-15.559a1.264 1.264 0 1 0 0 2.527h15.559a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"33.615\" viewBox=\"0 0 37.615 33.615\"><g data-name=\"Group 1010\"><path data-name=\"Path 2393\" d=\"M258.545 283.685H234.69a6.888 6.888 0 0 0-6.88 6.88v19.855a6.889 6.889 0 0 0 6.88 6.88h23.855a6.888 6.888 0 0 0 6.88-6.88v-19.855a6.887 6.887 0 0 0-6.88-6.88\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2394\" d=\"M254.4 292.605h-15.562a1.263 1.263 0 1 0 0 2.527H254.4a1.263 1.263 0 1 0 0-2.527\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#fff\"/><path data-name=\"Path 2395\" d=\"M254.4 299.229h-15.562a1.264 1.264 0 1 0 0 2.527H254.4a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#fff\"/><path data-name=\"Path 2396\" d=\"M254.4 305.853h-15.562a1.264 1.264 0 1 0 0 2.527H254.4a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#fff\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.orderBagList\">OrderBag List</span></a></li><li id=\"calendar-li\" has-authority=\"ROLE_RESERVATION_MANAGER\"><md-tooltip md-direction=\"left\">{{\'global.setup.timeBoard\'| translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.calendar-v2\"><!--<i class=\"icon-class fa fa-calendar fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'calendar-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.495\" viewBox=\"0 0 37.614 37.495\"><g data-name=\"Group 952\"><path data-name=\"Path 2304\" d=\"M31.364 376.634H6.462a6.358 6.358 0 0 1-6.35-6.35v-22.14a6.358 6.358 0 0 1 6.35-6.35h24.9a6.358 6.358 0 0 1 6.351 6.35v22.14a6.358 6.358 0 0 1-6.351 6.35m-24.9-32.309a3.824 3.824 0 0 0-3.819 3.819v22.14a3.823 3.823 0 0 0 3.819 3.816h24.9a3.824 3.824 0 0 0 3.82-3.819v-22.14a3.825 3.825 0 0 0-3.82-3.819z\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2305\" d=\"M36.45 353.458H1.36a1.26 1.26 0 0 1 0-2.519h35.09a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2306\" d=\"M14.628 360.474H9.49a1.26 1.26 0 0 1 0-2.519h5.138a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2307\" d=\"M14.628 368.279H9.49a1.259 1.259 0 0 1 0-2.519h5.138a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2308\" d=\"M28.319 360.474h-5.138a1.26 1.26 0 0 1 0-2.519h5.138a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2309\" d=\"M28.319 368.279h-5.138a1.259 1.259 0 0 1 0-2.519h5.138a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2310\" d=\"M13.056 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2311\" d=\"M24.753 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.495\" viewBox=\"0 0 37.615 37.495\"><g data-name=\"Group 986\"><path data-name=\"Path 2353\" d=\"M31.65 341.794H6.748a6.358 6.358 0 0 0-6.35 6.35v3.995c0 .021-.012.038-.012.059s.011.038.012.059v18.027a6.358 6.358 0 0 0 6.35 6.35h24.9a6.358 6.358 0 0 0 6.352-6.35v-22.14a6.358 6.358 0 0 0-6.351-6.35m-24.9 2.531h24.9a3.825 3.825 0 0 1 3.82 3.819v2.795H2.929v-2.795a3.824 3.824 0 0 1 3.819-3.819\" transform=\"translate(-.386 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2354\" d=\"M14.914 360.474H9.776a1.26 1.26 0 0 1 0-2.519h5.138a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2355\" d=\"M14.914 368.279H9.776a1.259 1.259 0 0 1 0-2.519h5.138a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2356\" d=\"M28.6 360.474h-5.134a1.26 1.26 0 0 1 0-2.519H28.6a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2357\" d=\"M28.6 368.279h-5.134a1.259 1.259 0 0 1 0-2.519H28.6a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2358\" d=\"M13.342 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.386 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2359\" d=\"M25.039 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.386 -339.139)\" style=\"fill:#161615\"/></g></svg></div></span><span translate=\"global.setup.timeBoard\">Time Board</span></a></li><li id=\"invoice-li\" has-authority=\"ROLE_COMPANY_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.invoiceInfo\'| translate}}</md-tooltip><a class=\"\" data-target=\"#companyInfo\" ui-sref=\"supplierPanel-v2.invoiceInfoList\"><!--<i class=\"icon-class fa fa-cogs fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'invoice-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.623\" height=\"37.431\" viewBox=\"0 0 37.623 37.431\"><g data-name=\"Group 1042\"><path data-name=\"Path 2409\" d=\"M16.551 30.672a3.891 3.891 0 0 0-2.741-1.092 3.907 3.907 0 0 0-2.634 6.72 3.859 3.859 0 0 0 2.678 1.13h.061a4.018 4.018 0 0 0 2.793-1.238 3.829 3.829 0 0 0 1.106-2.734 3.994 3.994 0 0 0-1.263-2.788m-4.025 2.762a1.351 1.351 0 0 1 1.356-1.323h.039a1.415 1.415 0 0 1 1.366 1.4 1.346 1.346 0 0 1-.392.973 1.45 1.45 0 0 1-1.043.4 1.33 1.33 0 0 1-.969-.392 1.418 1.418 0 0 1-.357-1.056\" transform=\"translate(.001 -.001)\" style=\"fill:#101928\"/><path data-name=\"Path 2410\" d=\"M32.552 30.711a3.9 3.9 0 1 0-2.719 6.72h.031a3.838 3.838 0 0 0 2.714-1.131 3.905 3.905 0 0 0 1.171-2.791 3.969 3.969 0 0 0-1.2-2.8m-2.7 1.4a1.419 1.419 0 0 1 .995.433 1.384 1.384 0 0 1 .417.989 1.407 1.407 0 0 1-1.4 1.355 1.392 1.392 0 0 1-1.417-1.4 1.431 1.431 0 0 1 1.389-1.377z\" transform=\"translate(.001 -.001)\" style=\"fill:#101928\"/><path data-name=\"Path 2411\" d=\"M36.756 6.533a4.336 4.336 0 0 0-3.419-1.265q-8.207-.01-16.417 0H9.5L9.421 4.8a38.225 38.225 0 0 0-.28-1.623A3.478 3.478 0 0 0 6.19.1C5.329.015 2.233 0 1.216 0a1.221 1.221 0 0 0 0 2.441c.7 0 3.136.006 3.835.013 1.07.01 1.488.375 1.649 1.446l1.6 10.236c.663 4.231.556 5.534 1.19 9.769.415 2.762 1.869 4.049 4.578 4.051h17.514a1.243 1.243 0 1 0 0-2.486h-4.651q-6.511-.006-13.023.011h-.018c-.946 0-1.469-.315-1.693-1.02-.045-.14-.243-1.482-.5-3.334h20.517a4.051 4.051 0 0 0 4.321-3.8c.3-2.039-.083.262.231-1.776l.549-3.584c.061-.4.109-.8.158-1.2l.085-.682a4.324 4.324 0 0 0-.8-3.549M35.1 9.4c-.32 2.335-.977 7.218-1.055 7.7v.026a1.833 1.833 0 0 1-1.828 1.5H11.343c-.592-4.266-1.292-9.435-1.414-10.219a5.177 5.177 0 0 1-.046-.6H32.995a4.4 4.4 0 0 1 1.032.094c.911.225 1.192.617 1.071 1.494\" transform=\"translate(.001 -.001)\" style=\"fill:#101928\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.622\" height=\"37.432\" viewBox=\"0 0 37.622 37.432\"><g data-name=\"Group 1041\"><path data-name=\"Path 2412\" d=\"M66.586 30.672a3.891 3.891 0 0 0-2.741-1.092 3.907 3.907 0 0 0-2.634 6.72 3.859 3.859 0 0 0 2.678 1.13h.061a4.018 4.018 0 0 0 2.793-1.238 3.829 3.829 0 0 0 1.106-2.734 3.994 3.994 0 0 0-1.263-2.788m-4.025 2.762a1.351 1.351 0 0 1 1.356-1.323h.039a1.415 1.415 0 0 1 1.366 1.4 1.346 1.346 0 0 1-.392.973 1.45 1.45 0 0 1-1.043.4 1.33 1.33 0 0 1-.969-.392 1.418 1.418 0 0 1-.357-1.056\" transform=\"translate(-50.035)\" style=\"fill:#101928\"/><path data-name=\"Path 2413\" d=\"M82.587 30.711a3.9 3.9 0 1 0-2.719 6.72h.032a3.838 3.838 0 0 0 2.713-1.131 3.905 3.905 0 0 0 1.171-2.791 3.969 3.969 0 0 0-1.2-2.8m-2.7 1.4a1.419 1.419 0 0 1 1 .433 1.384 1.384 0 0 1 .417.989 1.407 1.407 0 0 1-1.4 1.355 1.392 1.392 0 0 1-1.417-1.4 1.431 1.431 0 0 1 1.389-1.377z\" transform=\"translate(-50.035)\" style=\"fill:#101928\"/><path data-name=\"Path 2414\" d=\"M86.791 6.532a4.334 4.334 0 0 0-3.418-1.265q-8.208-.009-16.418 0h-7.423l-.075-.467c-.089-.56-.173-1.094-.281-1.623A3.479 3.479 0 0 0 56.226.1c-.862-.086-3.958-.1-4.975-.1a1.221 1.221 0 0 0 0 2.441c.7 0 3.136.006 3.835.013 1.072.01 1.489.374 1.654 1.443l1.6 10.237c.663 4.23.556 5.534 1.191 9.768.414 2.762 1.868 4.049 4.577 4.051H81.618a1.243 1.243 0 0 0 0-2.486h-4.652q-6.512-.006-13.023.01h-.017c-.947 0-1.47-.315-1.694-1.019-.045-.14-.243-1.483-.5-3.334h20.516a4.052 4.052 0 0 0 4.321-3.8c.3-2.039-.083.262.231-1.775l.55-3.584c.06-.4.108-.8.157-1.2l.085-.682a4.324 4.324 0 0 0-.8-3.549\" transform=\"translate(-50.035)\" style=\"fill:#101928\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.invoiceInfo\">invoiceInfo</span></a></li><li id=\"customer-li\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.companyCustomer-v2\'| translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.companyCustomer\"><!--<i class=\"icon-class fa fa-user fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'customer-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.705\" height=\"37.705\" viewBox=\"0 0 37.705 37.705\"><g data-name=\"Group 1013\"><path data-name=\"Path 2397\" d=\"M33.613 593.99a11.781 11.781 0 0 0-6.8-7.688 6.93 6.93 0 1 0-11.166-7.061 6.924 6.924 0 0 0-6.921 11.766 11.823 11.823 0 0 0-4.49 3.293 12.421 12.421 0 0 0-1.57 2.394 18.273 18.273 0 0 0 1.749 2.451 9.188 9.188 0 0 1 7.033-6.323 8.379 8.379 0 0 1 1.684-.168h.068a8.449 8.449 0 0 1 1.085.065 9.193 9.193 0 0 1 8.091 9.119 9.382 9.382 0 0 1-.851 3.863 17.636 17.636 0 0 0 2.917-.664h.01a11.456 11.456 0 0 0 .439-2.843c.009-.113.009-.234.009-.356a11.731 11.731 0 0 0-7.229-10.821 6.911 6.911 0 0 0 1.937-2.665h.008a9.025 9.025 0 0 1 2.722-.412h.01a9.184 9.184 0 0 1 9.166 9.175v.225a9.12 9.12 0 0 1-1.6 4.947 18.656 18.656 0 0 0 4.069-4.022c.036-.383.056-.766.056-1.15a11.838 11.838 0 0 0-.422-3.124m-20.425-3.862a1.854 1.854 0 0 1-.235-.01 4.4 4.4 0 0 1 .243-8.8 4.256 4.256 0 0 1 2.292.654 4.368 4.368 0 0 1 2.113 3.751c0 .112 0 .215-.009.318a2.74 2.74 0 0 1-.056.4 4.394 4.394 0 0 1-4.274 3.685zm9.128-4.714h-.038a4.06 4.06 0 0 1-2.226-.655 6.774 6.774 0 0 0-2.1-4.068 4.406 4.406 0 1 1 4.479 4.723z\" transform=\"translate(0 -568.186)\" style=\"fill:#0d141e\"/><path data-name=\"Path 2398\" d=\"M18.853 605.891a18.853 18.853 0 1 1 18.852-18.853 18.874 18.874 0 0 1-18.852 18.853m0-35.18a16.327 16.327 0 1 0 16.327 16.327 16.346 16.346 0 0 0-16.327-16.327\" transform=\"translate(0 -568.186)\" style=\"fill:#0d141e\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.705\" height=\"37.705\" viewBox=\"0 0 37.705 37.705\"><g data-name=\"Group 1012\"><path data-name=\"Path 2399\" d=\"M121.806 605.891a18.853 18.853 0 1 1 18.852-18.852 18.874 18.874 0 0 1-18.852 18.852\" transform=\"translate(-102.953 -568.186)\" style=\"fill:#0d141e\"/><path data-name=\"Path 2400\" d=\"M136.567 593.99a11.781 11.781 0 0 0-6.8-7.688 6.931 6.931 0 1 0-11.167-7.061 6.867 6.867 0 0 0-2.451-.449 6.923 6.923 0 0 0-4.47 12.215 11.82 11.82 0 0 0-4.49 3.292 12.426 12.426 0 0 0-1.571 2.394 18.274 18.274 0 0 0 1.749 2.451 9.194 9.194 0 0 1 7.033-6.323 8.379 8.379 0 0 1 1.684-.168h.065a8.471 8.471 0 0 1 1.085.065 9.163 9.163 0 0 1 8.015 10.27 9.052 9.052 0 0 1-.776 2.712 17.624 17.624 0 0 0 2.918-.664h.009a11.41 11.41 0 0 0 .44-2.843c.009-.113.009-.234.009-.356a11.731 11.731 0 0 0-7.229-10.821 6.9 6.9 0 0 0 1.936-2.665h.009a9.025 9.025 0 0 1 2.722-.412h.009a9.183 9.183 0 0 1 9.166 9.175v.225a9.1 9.1 0 0 1-1.6 4.947 18.612 18.612 0 0 0 4.069-4.022q.055-.574.056-1.15a11.838 11.838 0 0 0-.421-3.124m-20.426-3.862a1.83 1.83 0 0 1-.234-.01 4.4 4.4 0 0 1 .243-8.8 4.258 4.258 0 0 1 2.292.654 4.368 4.368 0 0 1 2.113 3.751c0 .112 0 .215-.009.318a2.739 2.739 0 0 1-.056.4 4.394 4.394 0 0 1-4.274 3.685zm9.128-4.714h-.037a4.058 4.058 0 0 1-2.226-.655 6.77 6.77 0 0 0-2.1-4.068 4.406 4.406 0 1 1 4.48 4.723z\" transform=\"translate(-102.953 -568.186)\" style=\"fill:#fff\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.companyCustomer-v2\">Company Customer</span></a></li><li id=\"report-li\" has-authority=\"ROLE_REPORT_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.reports\'| translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.reportExport\"><!--<i class=\"icon-class fa fa-bar-chart fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'report-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"33.615\" viewBox=\"0 0 37.614 33.615\"><g data-name=\"Group 953\"><path data-name=\"Path 2317\" d=\"M30.876 397.486H7.021a6.888 6.888 0 0 0-6.88 6.88v19.855a6.887 6.887 0 0 0 6.88 6.88h23.855a6.887 6.887 0 0 0 6.879-6.88v-19.855a6.888 6.888 0 0 0-6.879-6.88m4.352 26.735a4.357 4.357 0 0 1-4.352 4.352H7.021a4.357 4.357 0 0 1-4.353-4.352v-19.855a4.357 4.357 0 0 1 4.353-4.352h23.855a4.357 4.357 0 0 1 4.352 4.352z\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2318\" d=\"M7.7 417.934v3.559a1.264 1.264 0 1 0 2.527 0v-3.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2319\" d=\"M14.356 411.934v9.559a1.263 1.263 0 1 0 2.527 0v-9.559a1.263 1.263 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2320\" d=\"M21.012 413.934v7.559a1.264 1.264 0 1 0 2.527 0v-7.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2321\" d=\"M27.668 407.934v13.559a1.264 1.264 0 1 0 2.527 0v-13.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"33.615\" viewBox=\"0 0 37.615 33.615\"><g data-name=\"Group 988\"><path data-name=\"Path 2365\" d=\"M31.161 397.486H7.306a6.888 6.888 0 0 0-6.88 6.88v19.855a6.889 6.889 0 0 0 6.88 6.88h23.855a6.888 6.888 0 0 0 6.88-6.88v-19.855a6.887 6.887 0 0 0-6.88-6.88\" transform=\"translate(-.426 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2366\" d=\"M7.985 417.934v3.559a1.264 1.264 0 1 0 2.527 0v-3.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.426 -397.486)\" style=\"fill:#fff\"/><path data-name=\"Path 2367\" d=\"M14.641 411.934v9.559a1.263 1.263 0 1 0 2.527 0v-9.559a1.263 1.263 0 1 0-2.527 0\" transform=\"translate(-.426 -397.486)\" style=\"fill:#fff\"/><path data-name=\"Path 2368\" d=\"M21.3 413.934v7.559a1.264 1.264 0 1 0 2.527 0v-7.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.426 -397.486)\" style=\"fill:#fff\"/><path data-name=\"Path 2369\" d=\"M27.954 407.934v13.559a1.264 1.264 0 1 0 2.527 0v-13.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.426 -397.486)\" style=\"fill:#fff\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.reports\">Conversation List</span></a></li><li id=\"finance-li\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.accounting.title\'| translate}}</md-tooltip><a ui-sref=\"supplierPanel-v2.companyPaymentLogList\"><!--<i class=\"icon-class fa fa-usd fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'finance-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.615\" viewBox=\"0 0 37.614 37.615\"><g data-name=\"Group 954\"><path data-name=\"Path 2322\" d=\"M18.908 490.979a18.807 18.807 0 1 1 18.807-18.808 18.829 18.829 0 0 1-18.807 18.808m0-35.1A16.3 16.3 0 1 0 35.2 472.171a16.314 16.314 0 0 0-16.295-16.295\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2323\" d=\"M18.907 485.562a1.3 1.3 0 0 1-1.3-1.3v-3.176a1.3 1.3 0 0 1 2.6 0v3.176a1.3 1.3 0 0 1-1.3 1.3\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2324\" d=\"M18.907 465.156a1.3 1.3 0 0 1-1.3-1.3v-3.177a1.3 1.3 0 0 1 2.6 0v3.177a1.3 1.3 0 0 1-1.3 1.3\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2325\" d=\"M18.651 481.675c3.738 0 6.348-2.224 6.348-5.407 0-2.3-1.18-3.849-3.713-4.884l-.01-.005-2.408-1.108c-1.51-.614-2.936-1.194-2.936-2.686 0-1.392 1.139-2.293 2.9-2.293a5.9 5.9 0 0 1 3.183.851 1.259 1.259 0 0 0 1.932-1.244 1.143 1.143 0 0 0-.457-.766 7.741 7.741 0 0 0-4.509-1.463c-3.444 0-5.943 2.149-5.943 5.109 0 2.16 1.26 3.823 3.646 4.808l2.669 1.23c1.578.7 2.714 1.211 2.714 2.861 0 1.464-1.238 2.374-3.233 2.374a6.887 6.887 0 0 1-3.882-1.273 1.4 1.4 0 0 0-.787-.248 1.263 1.263 0 0 0-.995.476l-.07.089a1.314 1.314 0 0 0-.274.99 1.221 1.221 0 0 0 .489.833 8.959 8.959 0 0 0 5.334 1.756\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.615\" viewBox=\"0 0 37.614 37.615\"><g data-name=\"Group 989\"><path data-name=\"Path 2370\" d=\"M19.193 490.979A18.807 18.807 0 1 1 38 472.171a18.829 18.829 0 0 1-18.807 18.808\" transform=\"translate(-.386 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2371\" d=\"M19.193 485.562a1.3 1.3 0 0 1-1.3-1.3v-3.176a1.3 1.3 0 0 1 2.6 0v3.176a1.3 1.3 0 0 1-1.3 1.3\" transform=\"translate(-.386 -453.364)\" style=\"fill:#fff\"/><path data-name=\"Path 2372\" d=\"M19.193 465.156a1.3 1.3 0 0 1-1.3-1.3v-3.177a1.3 1.3 0 0 1 2.6 0v3.177a1.3 1.3 0 0 1-1.3 1.3\" transform=\"translate(-.386 -453.364)\" style=\"fill:#fff\"/><path data-name=\"Path 2373\" d=\"M18.936 481.675c3.738 0 6.348-2.224 6.348-5.407 0-2.3-1.18-3.849-3.713-4.884l-.01-.005-2.408-1.108c-1.51-.614-2.936-1.194-2.936-2.686 0-1.392 1.139-2.293 2.9-2.293a5.9 5.9 0 0 1 3.183.851 1.259 1.259 0 0 0 1.932-1.244 1.143 1.143 0 0 0-.457-.766 7.741 7.741 0 0 0-4.509-1.463c-3.444 0-5.943 2.149-5.943 5.109 0 2.16 1.26 3.823 3.646 4.808l2.669 1.23c1.578.7 2.714 1.211 2.714 2.861 0 1.464-1.238 2.374-3.233 2.374a6.887 6.887 0 0 1-3.882-1.273 1.4 1.4 0 0 0-.787-.248 1.263 1.263 0 0 0-.995.476l-.07.089a1.314 1.314 0 0 0-.274.99 1.221 1.221 0 0 0 .489.833 8.959 8.959 0 0 0 5.334 1.756\" transform=\"translate(-.386 -453.364)\" style=\"fill:#fff\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.accounting.title\">Accounting </span><!--<i class=\"fa fa-chevron-down sub-menu-arrow\" aria-hidden=\"true\"></i>--></a></li><li id=\"setting-li\" has-authority=\"ROLE_COMPANY_MANAGER\"><md-tooltip md-direction=\"left\">{{\'supplierPanel.sideMenu.setting\'| translate}}</md-tooltip><a class=\"\" data-target=\"#companyInfo\" ui-sref=\"supplierPanel-v2.setting\"><!--<i class=\"icon-class fa fa-cogs fa-fw\"></i>--> <span ng-switch on=\"vm.isLiActive(\'setting-li\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.636\" viewBox=\"0 0 37.614 37.636\"><g data-name=\"Group 955\"><path data-name=\"Path 2291\" d=\"M34.631 522.995H33.61a.613.613 0 0 1-.571-.4c-.118-.31-.243-.61-.373-.9a.613.613 0 0 1 .127-.692l.724-.725a3.083 3.083 0 0 0 0-4.351l-2.617-2.62a3.085 3.085 0 0 0-4.35 0l-.729.725a.606.606 0 0 1-.691.123c-.3-.132-.585-.253-.9-.378a.61.61 0 0 1-.4-.567v-1.018a3.081 3.081 0 0 0-3.078-3.079h-3.7a3.083 3.083 0 0 0-3.079 3.079v1.018a.609.609 0 0 1-.4.573c-.311.121-.611.245-.9.373a.618.618 0 0 1-.694-.127l-.724-.724a3.088 3.088 0 0 0-4.351 0l-2.623 2.628a3.081 3.081 0 0 0 0 4.351l.727.727a.613.613 0 0 1 .123.691c-.135.3-.257.585-.375.9a.617.617 0 0 1-.581.4h-1A3.084 3.084 0 0 0 .1 526.074v3.708a3.082 3.082 0 0 0 3.078 3.08h1.013a.608.608 0 0 1 .572.4q.162.424.373.9a.614.614 0 0 1-.125.693l-.724.725a3.084 3.084 0 0 0 0 4.35l2.622 2.623a3.084 3.084 0 0 0 4.352 0l.724-.724a.614.614 0 0 1 .693-.124c.3.134.583.255.895.381a.607.607 0 0 1 .4.567v1.017a3.084 3.084 0 0 0 3.079 3.08h3.7a3.081 3.081 0 0 0 3.078-3.08v-1.017a.607.607 0 0 1 .4-.573c.312-.121.6-.242.9-.374a.616.616 0 0 1 .692.127l.727.724a3.082 3.082 0 0 0 4.35 0l2.622-2.623a3.084 3.084 0 0 0 0-4.35l-.724-.725a.609.609 0 0 1-.126-.691c.121-.26.236-.534.381-.9a.61.61 0 0 1 .566-.4h1.02a3.083 3.083 0 0 0 3.078-3.08v-3.7a3.081 3.081 0 0 0-3.078-3.079m-3.892 9.391c-.1.257-.206.512-.314.757a3.115 3.115 0 0 0 .617 3.446l.726.727a.619.619 0 0 1 0 .876l-2.624 2.625a.616.616 0 0 1-.874 0l-.726-.724a3.1 3.1 0 0 0-3.446-.615 10.08 10.08 0 0 1-.754.309 3.071 3.071 0 0 0-1.983 2.874v1a.622.622 0 0 1-.622.623h-3.695a.625.625 0 0 1-.624-.623v-1.018a3.063 3.063 0 0 0-1.979-2.873c-.255-.1-.51-.206-.757-.312a3.073 3.073 0 0 0-1.267-.271 3.121 3.121 0 0 0-2.178.888l-.726.725a.64.64 0 0 1-.882 0l-2.621-2.612a.607.607 0 0 1-.18-.438.616.616 0 0 1 .182-.44l.724-.726a3.1 3.1 0 0 0 .615-3.444c-.122-.273-.224-.52-.307-.754a3.077 3.077 0 0 0-2.863-2H3.172a.623.623 0 0 1-.623-.622v-3.7a.623.623 0 0 1 .623-.621h1.019a3.1 3.1 0 0 0 2.87-1.978c.1-.258.206-.514.314-.758a3.11 3.11 0 0 0-.62-3.446l-.726-.726a.623.623 0 0 1 0-.879l2.621-2.622a.625.625 0 0 1 .879 0l.726.729a3.1 3.1 0 0 0 3.445.615c.272-.123.515-.224.747-.311a3.068 3.068 0 0 0 1.98-2.862V512.2a.623.623 0 0 1 .624-.621h3.7a.622.622 0 0 1 .622.621v1.02a3.068 3.068 0 0 0 1.98 2.871c.258.1.512.206.757.309a3.1 3.1 0 0 0 3.444-.612l.728-.725a.624.624 0 0 1 .883 0l2.621 2.619a.623.623 0 0 1 0 .879l-.727.726a3.108 3.108 0 0 0-.617 3.444c.121.264.222.509.312.755a3.065 3.065 0 0 0 2.872 1.983h1.019a.625.625 0 0 1 .621.623v2.863l-.012-.015v.837a.623.623 0 0 1-.621.622h-1.02a3.066 3.066 0 0 0-2.87 1.98\" transform=\"translate(-.101 -509.113)\" style=\"fill:#161615\"/><path data-name=\"Path 2292\" d=\"M27.513 527.543a8.583 8.583 0 0 0-.175-1.417c-.018-.086-.04-.17-.062-.254l-.057-.212a7.716 7.716 0 0 0-.181-.583c-.048-.132-.095-.26-.149-.4a9.715 9.715 0 0 0-.433-.918l-.024-.049a8.407 8.407 0 0 0-.857-1.25l-.092-.108a6.59 6.59 0 0 0-.41-.447l-.126-.12-.1-.094a5.984 5.984 0 0 0-.266-.245l-.029-.024c-.1-.085-.233-.2-.368-.3l-.15-.108a8.628 8.628 0 0 0-5.142-1.711 1.086 1.086 0 0 0-.186.011h-.09a5.665 5.665 0 0 0-.625.038c-.108.011-.22.024-.318.039a9.166 9.166 0 0 0-.932.175 8.63 8.63 0 0 0 .012 16.722h.036a9.021 9.021 0 0 0 1.006.192c.182.023.364.032.548.041h.137a2.068 2.068 0 0 1 .208.014c.072 0 .149.014.219.014.254 0 .539-.017.842-.045a.676.676 0 0 0 .1-.013c.233-.024.466-.062.7-.109a1.825 1.825 0 0 0 .185-.039l.133-.032c.157-.038.314-.076.476-.123.1-.03.195-.063.312-.1l.081-.03c.131-.044.266-.094.4-.15a2.974 2.974 0 0 0 .286-.128l.094-.046c.163-.075.323-.15.481-.233a11.224 11.224 0 0 0 2.435-1.759 3.3 3.3 0 0 0 .55-.669 10.188 10.188 0 0 0 1.43-3.92 8.719 8.719 0 0 0 .093-1.086v-.118a2.107 2.107 0 0 0 0-.337zm-2.447.457-.01.161a1.443 1.443 0 0 1-.011.208c-.013.206-.04.416-.076.639a6.156 6.156 0 0 1-3.1 4.322c-.107.057-.215.11-.329.163l-.071.034a6.477 6.477 0 0 1-1.609.488l-.12.018c-.109.017-.216.03-.322.038-.149.01-.285.019-.429.022h-.185a5.913 5.913 0 0 1-.625-.037l-.106-.011a6.435 6.435 0 0 1-.718-.136 6.173 6.173 0 0 1 0-11.96 6.052 6.052 0 0 1 2.309-.149l.112.016.087.015a5.172 5.172 0 0 1 .564.115l.181.046a6.31 6.31 0 0 1 1.344.563l.206.124c.138.088.273.175.422.291l.036.026a1.58 1.58 0 0 1 .161.121 6.021 6.021 0 0 1 .5.447c.032.03.062.063.108.115l.075.084c.1.109.2.221.3.339a5.68 5.68 0 0 1 .447.652l.132.215a6.12 6.12 0 0 1 .3.648c.016.04.03.079.045.121l.054.149a4.425 4.425 0 0 1 .149.488l.034.127c.011.042.023.082.032.129a5.756 5.756 0 0 1 .109.692 1.388 1.388 0 0 0 .01.214c0 .157.009.315 0 .467\" transform=\"translate(-.101 -509.113)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.62\" height=\"37.64\" viewBox=\"0 0 37.62 37.64\"><g data-name=\"Group 983\"><path data-name=\"Path 2342\" d=\"m34.924 523.01-.01-.01h-1.02a.628.628 0 0 1-.57-.41c-.12-.31-.24-.61-.37-.89a.608.608 0 0 1 .12-.69l.73-.73a3.078 3.078 0 0 0 0-4.35l-2.62-2.62a3.078 3.078 0 0 0-4.35 0l-.73.72a.6.6 0 0 1-.69.13c-.3-.14-.59-.26-.9-.38a.615.615 0 0 1-.4-.57v-1.02a3.088 3.088 0 0 0-3.08-3.08h-3.7a3.094 3.094 0 0 0-3.08 3.08v1.02a.6.6 0 0 1-.4.57c-.31.12-.61.25-.9.38a.631.631 0 0 1-.69-.13l-.72-.72a3.09 3.09 0 0 0-4.36 0l-2.62 2.62a3.08 3.08 0 0 0 0 4.35l.731.73a.612.612 0 0 1 .119.69c-.129.3-.26.59-.369.9a.641.641 0 0 1-.581.4H3.455a3.077 3.077 0 0 0-3.071 3.07v3.71a3.081 3.081 0 0 0 3.08 3.08h1.01a.593.593 0 0 1 .571.41c.109.28.24.58.379.89a.629.629 0 0 1-.129.69l-.721.73a3.08 3.08 0 0 0 0 4.35l2.62 2.62a3.078 3.078 0 0 0 4.35 0l.73-.72a.628.628 0 0 1 .69-.13c.3.14.58.26.89.39a.592.592 0 0 1 .4.56v1.02a3.081 3.081 0 0 0 3.08 3.08h3.7a3.081 3.081 0 0 0 3.08-3.08v-1.02a.615.615 0 0 1 .4-.57c.32-.12.6-.24.9-.37a.611.611 0 0 1 .69.12l.73.73a3.1 3.1 0 0 0 4.35 0l2.62-2.63a3.078 3.078 0 0 0 0-4.35l-.72-.72a.6.6 0 0 1-.13-.69c.12-.26.24-.54.38-.9a.619.619 0 0 1 .57-.4h1.02A3.088 3.088 0 0 0 38 529.79v-3.7a3.094 3.094 0 0 0-3.08-3.08m-13.17 10.52a6.824 6.824 0 0 1-1.61.49l-.12.01a3.121 3.121 0 0 1-.32.04c-.15.01-.28.02-.43.02h-.18q-.315 0-.63-.03l-.1-.01c-.24-.04-.48-.08-.72-.14a6.173 6.173 0 0 1 0-11.96 6 6 0 0 1 2.31-.15l.11.02.09.01a5.049 5.049 0 0 1 .56.12l.18.04a6.669 6.669 0 0 1 1.35.57l.2.12a3.523 3.523 0 0 1 .42.29l.04.03a.611.611 0 0 1 .16.12c.18.14.34.29.5.44.03.03.06.07.11.12l.07.08c.1.11.2.22.3.34l.19.25c.09.13.17.26.26.4l.13.22a6.446 6.446 0 0 1 .3.65c.01.04.03.08.04.12l.06.15.15.48.03.13c.01.04.02.08.03.13a5.5 5.5 0 0 1 .11.69 1.62 1.62 0 0 0 .01.22c0 .15.01.31 0 .46l-.01.16c0 .07-.01.14-.01.21-.02.2-.04.42-.08.64a6.139 6.139 0 0 1-3.1 4.32 2.53 2.53 0 0 1-.33.16z\" transform=\"translate(-.384 -509.11)\" style=\"fill:#161615\"/><path data-name=\"Path 2343\" d=\"M27.744 526.85c-.04-.3-.08-.53-.12-.72l-.06-.26-.06-.21a5.578 5.578 0 0 0-.18-.58c-.05-.13-.1-.26-.15-.4-.13-.31-.27-.62-.43-.92l-.03-.05a8.1 8.1 0 0 0-.85-1.25l-.1-.1a4.382 4.382 0 0 0-.41-.45l-.22-.22c-.07-.06-.17-.16-.27-.24l-.02-.02c-.1-.09-.24-.2-.37-.3l-.15-.11a8.6 8.6 0 0 0-5.14-1.71 1.209 1.209 0 0 0-.19.01H18.9a4.447 4.447 0 0 0-.63.04c-.1.01-.21.02-.31.04a8.928 8.928 0 0 0-.929.17 8.628 8.628 0 0 0 .009 16.72h.03a8.581 8.581 0 0 0 1.01.2c.18.02.36.03.55.04h.13a1.484 1.484 0 0 1 .21.01c.07 0 .15.01.22.01a8.4 8.4 0 0 0 .84-.04c.04 0 .07-.01.11-.01.23-.03.46-.06.7-.11.06-.01.12-.03.18-.04l.14-.03c.15-.04.31-.08.47-.13.1-.03.2-.06.31-.1l.09-.03a3.118 3.118 0 0 0 .39-.15 1.445 1.445 0 0 0 .29-.13l.09-.04c.17-.08.33-.15.49-.24a11.278 11.278 0 0 0 2.43-1.75 3.5 3.5 0 0 0 .55-.67 10.247 10.247 0 0 0 1.43-3.92 5.321 5.321 0 0 0 .06-.56 4.843 4.843 0 0 0 .03-.53v-.12a1.93 1.93 0 0 0 0-.34v-.07c-.01-.24-.03-.47-.05-.69M25.354 528l-.01.16c0 .07-.01.14-.01.21-.02.2-.04.42-.08.64a6.139 6.139 0 0 1-3.1 4.32 2.53 2.53 0 0 1-.33.16l-.07.04a6.824 6.824 0 0 1-1.61.49l-.12.01a3.121 3.121 0 0 1-.32.04c-.15.01-.28.02-.43.02h-.18q-.315 0-.63-.03l-.1-.01a9.074 9.074 0 0 1-.721-.14 6.173 6.173 0 0 1 0-11.96 6 6 0 0 1 2.31-.15l.11.02.09.01a5.049 5.049 0 0 1 .56.12l.18.04a6.669 6.669 0 0 1 1.35.57l.2.12a3.523 3.523 0 0 1 .42.29l.04.03a.611.611 0 0 1 .16.12c.18.14.34.29.5.44.03.03.06.07.11.12l.07.08c.1.11.2.22.3.34l.19.25c.09.13.17.26.26.4l.13.22a6.446 6.446 0 0 1 .3.65c.01.04.03.08.04.12l.06.15.15.48.03.13c.01.04.02.08.03.13a5.5 5.5 0 0 1 .11.69 1.62 1.62 0 0 0 .01.22c0 .15.01.31 0 .46\" transform=\"translate(-.384 -509.11)\" style=\"fill:#161615\"/></g></svg></div></span><span translate=\"supplierPanel.sideMenu.setting\">companyInfo</span></a></li></div></ul></nav></div><div id=\"mobile-menu\" class=\"visible-xs\"><div class=\"pl-footer-menu-container\"><div class=\"pl-footer-menu\"><ul><li id=\"home-li-mobile\" ng-click=\"vm.goToState(\'supplierPanel-v2.dashboard\')\"><span ng-switch on=\"vm.isLiActive(\'home-li-mobile\')\" class=\"icon-box\"><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"38.136\" height=\"37.14\" viewBox=\"0 0 38.136 37.14\"><path data-name=\"Path 2385\" d=\"M37.066 61.791 21.661 46.383a3.661 3.661 0 0 0-2.582-1.075h-.19a3.231 3.231 0 0 0-2.406 1.072l-15.4 15.4a3.661 3.661 0 0 0 2.435 6.26h.525v10.144A4.269 4.269 0 0 0 8.3 82.441h6.025a1.3 1.3 0 0 0 1.294-1.294v-7.879A1.675 1.675 0 0 1 17.29 71.6h3.555a1.675 1.675 0 0 1 1.67 1.67v7.888a1.3 1.3 0 0 0 1.3 1.293h6.027a4.28 4.28 0 0 0 4.255-4.255V68.043h.382a3.664 3.664 0 0 0 2.591-6.252\" transform=\"translate(0 -45.308)\" style=\"fill:#161615\"/></svg></div><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"38.136\" height=\"37.14\" viewBox=\"0 0 38.136 37.14\"><path data-name=\"Path 2388\" d=\"m37.716 61.791-15.4-15.408a3.661 3.661 0 0 0-2.582-1.075h-.19a3.231 3.231 0 0 0-2.406 1.072l-15.4 15.4a3.661 3.661 0 0 0 2.435 6.26H4.7v10.144a4.268 4.268 0 0 0 4.257 4.257h6.025a1.3 1.3 0 0 0 1.294-1.294v-7.879A1.675 1.675 0 0 1 17.94 71.6h3.56a1.675 1.675 0 0 1 1.67 1.67v7.888a1.3 1.3 0 0 0 1.3 1.293h6.027a4.28 4.28 0 0 0 4.255-4.255V68.043h.382a3.664 3.664 0 0 0 2.591-6.252M36.154 65.4l-.3-.231a1.083 1.083 0 0 1-.724.283h-1.681a1.3 1.3 0 0 0-1.291 1.293v11.446a1.681 1.681 0 0 1-1.671 1.67h-4.733v-6.6a4.279 4.279 0 0 0-4.254-4.249h-3.557a4.275 4.275 0 0 0-4.255 4.255v6.594H8.953a1.676 1.676 0 0 1-1.672-1.669V66.749a1.3 1.3 0 0 0-1.294-1.293H4.294a1.078 1.078 0 0 1-.742-1.839L18.96 48.21a1.086 1.086 0 0 1 1.522 0l15.4 15.4a1.09 1.09 0 0 1 .006 1.529z\" transform=\"translate(-.65 -45.308)\" style=\"fill:#161615\"/></svg></div></span></li><li id=\"calendar-li-mobile\" ng-click=\"vm.goToState(\'supplierPanel-v2.calendar-v2\')\"><span ng-switch on=\"vm.isLiActive(\'calendar-li-mobile\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.495\" viewBox=\"0 0 37.614 37.495\"><g data-name=\"Group 952\"><path data-name=\"Path 2304\" d=\"M31.364 376.634H6.462a6.358 6.358 0 0 1-6.35-6.35v-22.14a6.358 6.358 0 0 1 6.35-6.35h24.9a6.358 6.358 0 0 1 6.351 6.35v22.14a6.358 6.358 0 0 1-6.351 6.35m-24.9-32.309a3.824 3.824 0 0 0-3.819 3.819v22.14a3.823 3.823 0 0 0 3.819 3.816h24.9a3.824 3.824 0 0 0 3.82-3.819v-22.14a3.825 3.825 0 0 0-3.82-3.819z\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2305\" d=\"M36.45 353.458H1.36a1.26 1.26 0 0 1 0-2.519h35.09a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2306\" d=\"M14.628 360.474H9.49a1.26 1.26 0 0 1 0-2.519h5.138a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2307\" d=\"M14.628 368.279H9.49a1.259 1.259 0 0 1 0-2.519h5.138a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2308\" d=\"M28.319 360.474h-5.138a1.26 1.26 0 0 1 0-2.519h5.138a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2309\" d=\"M28.319 368.279h-5.138a1.259 1.259 0 0 1 0-2.519h5.138a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2310\" d=\"M13.056 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2311\" d=\"M24.753 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.101 -339.139)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.495\" viewBox=\"0 0 37.615 37.495\"><g data-name=\"Group 986\"><path data-name=\"Path 2353\" d=\"M31.65 341.794H6.748a6.358 6.358 0 0 0-6.35 6.35v3.995c0 .021-.012.038-.012.059s.011.038.012.059v18.027a6.358 6.358 0 0 0 6.35 6.35h24.9a6.358 6.358 0 0 0 6.352-6.35v-22.14a6.358 6.358 0 0 0-6.351-6.35m-24.9 2.531h24.9a3.825 3.825 0 0 1 3.82 3.819v2.795H2.929v-2.795a3.824 3.824 0 0 1 3.819-3.819\" transform=\"translate(-.386 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2354\" d=\"M14.914 360.474H9.776a1.26 1.26 0 0 1 0-2.519h5.138a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2355\" d=\"M14.914 368.279H9.776a1.259 1.259 0 0 1 0-2.519h5.138a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2356\" d=\"M28.6 360.474h-5.134a1.26 1.26 0 0 1 0-2.519H28.6a1.26 1.26 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2357\" d=\"M28.6 368.279h-5.134a1.259 1.259 0 0 1 0-2.519H28.6a1.259 1.259 0 0 1 0 2.519\" transform=\"translate(-.386 -339.139)\" style=\"fill:#fff\"/><path data-name=\"Path 2358\" d=\"M13.342 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.386 -339.139)\" style=\"fill:#161615\"/><path data-name=\"Path 2359\" d=\"M25.039 347.115a1.259 1.259 0 0 1-1.259-1.259V340.4a1.259 1.259 0 1 1 2.518 0v5.458a1.259 1.259 0 0 1-1.259 1.259\" transform=\"translate(-.386 -339.139)\" style=\"fill:#161615\"/></g></svg></div></span></li><li id=\"reserve-list-li-mobile\" ng-click=\"vm.goToState(\'supplierPanel-v2.reserveList\')\"><span ng-switch on=\"vm.isLiActive(\'reserve-list-li-mobile\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"33.615\" viewBox=\"0 0 37.614 33.615\"><g data-name=\"Group 1011\"><path data-name=\"Path 2389\" d=\"M209.586 283.685h-23.855a6.888 6.888 0 0 0-6.88 6.88v19.855a6.887 6.887 0 0 0 6.88 6.88h23.855a6.887 6.887 0 0 0 6.879-6.88v-19.855a6.888 6.888 0 0 0-6.879-6.88m4.352 26.735a4.357 4.357 0 0 1-4.352 4.352h-23.855a4.357 4.357 0 0 1-4.353-4.352v-19.855a4.357 4.357 0 0 1 4.353-4.352h23.855a4.357 4.357 0 0 1 4.352 4.352z\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2390\" d=\"M205.437 292.605h-15.559a1.263 1.263 0 1 0 0 2.527h15.559a1.263 1.263 0 1 0 0-2.527\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2391\" d=\"M205.437 299.229h-15.559a1.264 1.264 0 1 0 0 2.527h15.559a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2392\" d=\"M205.437 305.853h-15.559a1.264 1.264 0 1 0 0 2.527h15.559a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-178.851 -283.685)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"33.615\" viewBox=\"0 0 37.615 33.615\"><g data-name=\"Group 1010\"><path data-name=\"Path 2393\" d=\"M258.545 283.685H234.69a6.888 6.888 0 0 0-6.88 6.88v19.855a6.889 6.889 0 0 0 6.88 6.88h23.855a6.888 6.888 0 0 0 6.88-6.88v-19.855a6.887 6.887 0 0 0-6.88-6.88\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#161615\"/><path data-name=\"Path 2394\" d=\"M254.4 292.605h-15.562a1.263 1.263 0 1 0 0 2.527H254.4a1.263 1.263 0 1 0 0-2.527\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#fff\"/><path data-name=\"Path 2395\" d=\"M254.4 299.229h-15.562a1.264 1.264 0 1 0 0 2.527H254.4a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#fff\"/><path data-name=\"Path 2396\" d=\"M254.4 305.853h-15.562a1.264 1.264 0 1 0 0 2.527H254.4a1.264 1.264 0 1 0 0-2.527\" transform=\"translate(-227.81 -283.685)\" style=\"fill:#fff\"/></g></svg></div></span></li><li id=\"customer-li-mobile\" ng-click=\"vm.goToState(\'supplierPanel-v2.companyCustomer\')\"><span ng-switch on=\"vm.isLiActive(\'customer-li-mobile\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.705\" height=\"37.705\" viewBox=\"0 0 37.705 37.705\"><g data-name=\"Group 1013\"><path data-name=\"Path 2397\" d=\"M33.613 593.99a11.781 11.781 0 0 0-6.8-7.688 6.93 6.93 0 1 0-11.166-7.061 6.924 6.924 0 0 0-6.921 11.766 11.823 11.823 0 0 0-4.49 3.293 12.421 12.421 0 0 0-1.57 2.394 18.273 18.273 0 0 0 1.749 2.451 9.188 9.188 0 0 1 7.033-6.323 8.379 8.379 0 0 1 1.684-.168h.068a8.449 8.449 0 0 1 1.085.065 9.193 9.193 0 0 1 8.091 9.119 9.382 9.382 0 0 1-.851 3.863 17.636 17.636 0 0 0 2.917-.664h.01a11.456 11.456 0 0 0 .439-2.843c.009-.113.009-.234.009-.356a11.731 11.731 0 0 0-7.229-10.821 6.911 6.911 0 0 0 1.937-2.665h.008a9.025 9.025 0 0 1 2.722-.412h.01a9.184 9.184 0 0 1 9.166 9.175v.225a9.12 9.12 0 0 1-1.6 4.947 18.656 18.656 0 0 0 4.069-4.022c.036-.383.056-.766.056-1.15a11.838 11.838 0 0 0-.422-3.124m-20.425-3.862a1.854 1.854 0 0 1-.235-.01 4.4 4.4 0 0 1 .243-8.8 4.256 4.256 0 0 1 2.292.654 4.368 4.368 0 0 1 2.113 3.751c0 .112 0 .215-.009.318a2.74 2.74 0 0 1-.056.4 4.394 4.394 0 0 1-4.274 3.685zm9.128-4.714h-.038a4.06 4.06 0 0 1-2.226-.655 6.774 6.774 0 0 0-2.1-4.068 4.406 4.406 0 1 1 4.479 4.723z\" transform=\"translate(0 -568.186)\" style=\"fill:#0d141e\"/><path data-name=\"Path 2398\" d=\"M18.853 605.891a18.853 18.853 0 1 1 18.852-18.853 18.874 18.874 0 0 1-18.852 18.853m0-35.18a16.327 16.327 0 1 0 16.327 16.327 16.346 16.346 0 0 0-16.327-16.327\" transform=\"translate(0 -568.186)\" style=\"fill:#0d141e\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.705\" height=\"37.705\" viewBox=\"0 0 37.705 37.705\"><g data-name=\"Group 1012\"><path data-name=\"Path 2399\" d=\"M121.806 605.891a18.853 18.853 0 1 1 18.852-18.852 18.874 18.874 0 0 1-18.852 18.852\" transform=\"translate(-102.953 -568.186)\" style=\"fill:#0d141e\"/><path data-name=\"Path 2400\" d=\"M136.567 593.99a11.781 11.781 0 0 0-6.8-7.688 6.931 6.931 0 1 0-11.167-7.061 6.867 6.867 0 0 0-2.451-.449 6.923 6.923 0 0 0-4.47 12.215 11.82 11.82 0 0 0-4.49 3.292 12.426 12.426 0 0 0-1.571 2.394 18.274 18.274 0 0 0 1.749 2.451 9.194 9.194 0 0 1 7.033-6.323 8.379 8.379 0 0 1 1.684-.168h.065a8.471 8.471 0 0 1 1.085.065 9.163 9.163 0 0 1 8.015 10.27 9.052 9.052 0 0 1-.776 2.712 17.624 17.624 0 0 0 2.918-.664h.009a11.41 11.41 0 0 0 .44-2.843c.009-.113.009-.234.009-.356a11.731 11.731 0 0 0-7.229-10.821 6.9 6.9 0 0 0 1.936-2.665h.009a9.025 9.025 0 0 1 2.722-.412h.009a9.183 9.183 0 0 1 9.166 9.175v.225a9.1 9.1 0 0 1-1.6 4.947 18.612 18.612 0 0 0 4.069-4.022q.055-.574.056-1.15a11.838 11.838 0 0 0-.421-3.124m-20.426-3.862a1.83 1.83 0 0 1-.234-.01 4.4 4.4 0 0 1 .243-8.8 4.258 4.258 0 0 1 2.292.654 4.368 4.368 0 0 1 2.113 3.751c0 .112 0 .215-.009.318a2.739 2.739 0 0 1-.056.4 4.394 4.394 0 0 1-4.274 3.685zm9.128-4.714h-.037a4.058 4.058 0 0 1-2.226-.655 6.77 6.77 0 0 0-2.1-4.068 4.406 4.406 0 1 1 4.48 4.723z\" transform=\"translate(-102.953 -568.186)\" style=\"fill:#fff\"/></g></svg></div></span></li><li id=\"more-mobile\" ui-sref=\"supplierPanel-v2.more\"><span ng-switch on=\"vm.isLiActive(\'more-mobile\')\" class=\"icon-box\"><div ng-switch-when=\"false\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.614\" viewBox=\"0 0 37.615 37.614\"><g data-name=\"Group 996\"><path data-name=\"Path 2326\" d=\"M12.93 16.962h-8.7A4.137 4.137 0 0 1 .1 12.83v-8.7A4.137 4.137 0 0 1 4.233 0h8.7a4.137 4.137 0 0 1 4.133 4.132v8.7a4.137 4.137 0 0 1-4.133 4.132m-8.7-14.445A1.615 1.615 0 0 0 2.62 4.132v8.7a1.615 1.615 0 0 0 1.613 1.613h8.7a1.616 1.616 0 0 0 1.614-1.613v-8.7a1.616 1.616 0 0 0-1.617-1.613z\" transform=\"translate(-.1)\" style=\"fill:#161615\"/><path data-name=\"Path 2327\" d=\"M33.582 16.962h-8.7a4.137 4.137 0 0 1-4.133-4.132v-8.7A4.137 4.137 0 0 1 24.885 0h8.7a4.137 4.137 0 0 1 4.133 4.132v8.7a4.137 4.137 0 0 1-4.133 4.132m-8.7-14.443a1.615 1.615 0 0 0-1.613 1.613v8.7a1.615 1.615 0 0 0 1.613 1.613h8.7A1.616 1.616 0 0 0 35.2 12.83v-8.7a1.616 1.616 0 0 0-1.614-1.613z\" transform=\"translate(-.1)\" style=\"fill:#161615\"/><path data-name=\"Path 2328\" d=\"M12.93 37.614h-8.7A4.137 4.137 0 0 1 .1 33.482v-8.7a4.137 4.137 0 0 1 4.133-4.132h8.7a4.137 4.137 0 0 1 4.133 4.132v8.7a4.137 4.137 0 0 1-4.133 4.132m-8.7-14.443a1.614 1.614 0 0 0-1.613 1.613v8.7A1.615 1.615 0 0 0 4.233 35.1h8.7a1.616 1.616 0 0 0 1.614-1.613v-8.7a1.615 1.615 0 0 0-1.614-1.613z\" transform=\"translate(-.1)\" style=\"fill:#161615\"/><path data-name=\"Path 2329\" d=\"M33.582 37.614h-8.7a4.137 4.137 0 0 1-4.133-4.132v-8.7a4.137 4.137 0 0 1 4.133-4.132h8.7a4.137 4.137 0 0 1 4.133 4.132v8.7a4.137 4.137 0 0 1-4.133 4.132m-8.7-14.443a1.614 1.614 0 0 0-1.613 1.613v8.7a1.615 1.615 0 0 0 1.616 1.616h8.7a1.616 1.616 0 0 0 1.615-1.618v-8.7a1.615 1.615 0 0 0-1.614-1.613z\" transform=\"translate(-.1)\" style=\"fill:#161615\"/></g></svg></div><div ng-switch-when=\"true\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.615\" viewBox=\"0 0 37.615 37.615\"><g data-name=\"Group 997\"><path data-name=\"Path 2374\" d=\"M13.216 16.962h-8.7a4.138 4.138 0 0 1-4.13-4.133v-8.7A4.137 4.137 0 0 1 4.519 0h8.7a4.137 4.137 0 0 1 4.133 4.132v8.7a4.138 4.138 0 0 1-4.133 4.133\" transform=\"translate(-.386)\" style=\"fill:#161615\"/><path data-name=\"Path 2375\" d=\"M33.868 16.962h-8.7a4.138 4.138 0 0 1-4.133-4.133v-8.7A4.137 4.137 0 0 1 25.171 0h8.7A4.137 4.137 0 0 1 38 4.132v8.7a4.138 4.138 0 0 1-4.133 4.133\" transform=\"translate(-.386)\" style=\"fill:#161615\"/><path data-name=\"Path 2376\" d=\"M13.216 37.615h-8.7a4.138 4.138 0 0 1-4.13-4.133v-8.7a4.138 4.138 0 0 1 4.133-4.133h8.7a4.138 4.138 0 0 1 4.133 4.133v8.7a4.138 4.138 0 0 1-4.133 4.133\" transform=\"translate(-.386)\" style=\"fill:#161615\"/><path data-name=\"Path 2377\" d=\"M33.868 37.615h-8.7a4.138 4.138 0 0 1-4.133-4.133v-8.7a4.138 4.138 0 0 1 4.133-4.133h8.7A4.138 4.138 0 0 1 38 24.785v8.7a4.138 4.138 0 0 1-4.133 4.133\" transform=\"translate(-.386)\" style=\"fill:#161615\"/></g></svg></div></span></li></ul></div></div></div><div id=\"overlay\"></div></div><script type=\"text/javascript\">$(document).ready(function () {\n\n        $(\'#sidebarV2 ul li\').on(\'click\', function () {\n            if ($(this).attr(\'id\') != \"menuHamburgerDesktop\") {\n                $(\'*\').removeClass(\'active\');\n                $(this).addClass(\'active\');\n            }\n        });\n        $(\'#mobile-menu ul li\').on(\'click\', function () {\n            $(\'*\').removeClass(\'active\');\n            $(this).addClass(\'active\');\n        });\n    });</script>");
$templateCache.put("app/time-board/book-calendar-v2.template.html","<style>.scheduleSession {\n    margin: 30px;\n    padding: 20px;\n    margin-top: 0px;\n    padding-top: 0px;\n  }\n\n  @media (max-width: 400px) {\n    .scheduleSession {\n      margin: 3px;\n      padding: 2px;\n      font-size: 0.8em;\n    }\n  }\n\n  .select-servant {\n    margin-right: 35px;\n  }\n\n  .servant-chips-list-container {\n    display: flex;\n    margin: 0 35px 0 0;\n  }\n\n  .servant-chips-list {\n    padding: 5px 6px 5px 50px;\n    font-size: 11px;\n    display: flex;\n    gap: 5px;\n    width: 700px;\n    overflow-x: auto;\n    overflow: hidden;\n    border: 1px solid lightgray;\n    /* right: 0; */\n    /* left: 0; */\n    /* position: absolute; */\n    border-radius: 5px;\n  }\n\n  .servant-chips {\n    background-color: rgba(211, 211, 211, 0.25);\n    border: 1px solid lightgray;\n    padding: 3px 6px;\n    border-radius: 20px;\n    min-width: fit-content;\n  }\n\n  .chips-checked {\n    background-color: rgb(238 249 238);\n    color: green;\n    border: 1px solid green;\n  }\n\n  .chips-unchecked {\n  }\n\n  .chips-checked:before,\n  .chips-unchecked:before {\n    font-family: \"FontAwesome\";\n    font-size: 14px;\n    vertical-align: middle;\n  }\n\n  .chips-checked:before {\n    content: \"\\f058\";\n    color: green;\n  }\n\n  .chips-unchecked:before {\n    content: \"\\f10c\";\n    color: grey;\n  }\n\n  .left-arrow,\n  .right-arrow {\n    /*content: \"\\f054\";*/\n    /*font-family: \'FontAwesome\';*/\n    font-size: 20px;\n    font-weight: bold;\n    background-color: #e1e1e1;\n    color: #4c4c4c !important;\n    display: flex;\n    align-items: center;\n    z-index: 10;\n    padding: 0 4px;\n  }\n\n  .left-arrow {\n    margin-right: -5px;\n    border-bottom-left-radius: 5px;\n    border-top-left-radius: 5px;\n    border: 1px solid lightgray;\n  }\n\n  .right-arrow {\n    margin-left: -5px;\n    border-bottom-right-radius: 5px;\n    border-top-right-radius: 5px;\n    border: 1px solid lightgray;\n  }\n\n  .actions-menu {\n    background: white;\n    box-shadow: 0 4px 6px 0 rgb(214 215 218);\n    border: 1px solid #d5d7da;\n    border-radius: 4px;\n    display: none;\n    position: absolute;\n    top: 47px;\n    flex-flow: column;\n    z-index: 100;\n    /*transition: transform 120ms ease-out, opacity 120ms ease-out;*/\n  }\n\n  .action-item {\n    padding: 10px;\n  }\n\n  .action-item:hover {\n    background-color: #f2f2f7;\n    cursor: pointer;\n  }\n\n  .pl-button-icon {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    justify-content: center;\n  }\n\n  @media (max-width: 768px) {\n    .select-servant {\n      margin: auto;\n    }\n\n    .servant-chips-list-container {\n      margin: 0 0 0 0;\n    }\n  }\n\n  @media (max-width: 590px) {\n    /*.table-container {*/\n    /*margin-top: 75px;*/\n    /*}*/\n    .tools-button {\n      padding-left: 10px !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .md-button-xs-size {\n      min-width: 55px;\n    }\n  }\n\n  #selectCategory {\n    display: none;\n  }\n\n  .filterchips {\n    cursor: default;\n    border-radius: 16px;\n    display: block;\n    height: 32px;\n    line-height: 32px;\n    margin: 8px 8px 0 0;\n    padding: 0 12px 0 12px;\n    float: left;\n    box-sizing: border-box;\n    max-width: 100%;\n    position: relative;\n    font-family: yekan !important;\n    font-size: 12px !important;\n    border: 1px solid beige;\n    color: white;\n    /*background-color: beige;*/\n  }\n\n  .filterchips:hover {\n    opacity: 0.9;\n  }\n\n  .servantFilterChips {\n    cursor: default;\n    border-radius: 16px;\n    display: block;\n    height: 32px;\n    line-height: 32px;\n    margin: 8px 8px 0 0;\n    padding: 0 12px 0 12px;\n    float: left;\n    box-sizing: border-box;\n    max-width: 100%;\n    position: relative;\n    font-family: yekan !important;\n    font-size: 12px !important;\n    border: 1px solid #686161;\n    color: #8c8c8c;\n    background-color: #eeeeee7a;\n  }\n\n  .servantFilterChips.not-selected {\n    border: 1px solid #bdbdbd;\n  }\n\n  .servantFilterChips:hover {\n    opacity: 0.9;\n  }\n\n  .servantFilterChips .icon {\n    font-size: 25px;\n    float: right;\n  }\n\n  .lastupdate {\n    font-size: 10px;\n    color: #8b8282;\n    float: left;\n    margin-left: 6px;\n  }\n\n  .not-selected {\n    opacity: 0.5;\n  }\n\n  .tools-button {\n    display: flex;\n    justify-content: flex-end;\n    padding-left: 50px;\n  }\n\n  /**/\n  .dropbtn {\n    background-color: #3498db;\n    color: white;\n    padding: 16px;\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n  }\n\n  .dropbtn:hover,\n  .dropbtn:focus {\n    background-color: #2980b9;\n  }\n\n  .dropdown {\n    position: relative;\n    display: inline-block;\n    float: right;\n  }\n\n  .dropdown-content {\n    display: none;\n    position: absolute;\n    /*background-color: #f1f1f1;*/\n    min-width: 160px;\n    overflow: auto;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 1;\n  }\n\n  .dropdown-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n  }\n\n  .dropdown a:hover {\n    background-color: #ddd;\n  }\n\n  .show {\n    display: block;\n  }\n\n  /* banner styles */\n  .new-calendar-banner {\n    max-width: 100%;\n    background-color: #f3effa;\n    border: 1px solid #dcd3ef;\n    border-radius: 8px;\n    margin: 5px 48px 5px 0;\n    padding: 40px 25px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n  }\n\n  .new-calendar-banner .close-btn {\n    position: absolute;\n    top: 5px;\n    left: 10px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #666;\n  }\n\n  .new-calendar-banner .banner-content {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    /* text-align: center; */\n    justify-content: space-between;\n  }\n\n  .new-calendar-banner .calendar-icon {\n    font-size: 40px;\n    color: #673ab7;\n  }\n\n  .new-calendar-banner .text-container {\n    font-size: 14px;\n    color: #333;\n    text-align: right;\n  }\n\n  .new-calendar-banner .view-btn {\n    background-color: #673ab7;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n\n  /* حالت موبایل: تغییر چیدمان به عمودی */\n  @media (max-width: 600px) {\n    .new-calendar-banner .banner-content {\n      flex-direction: column;\n      gap: 10px;\n      padding-top: 10px;\n    }\n  }\n\n  .new-calendar-banner-visible {\n    margin-top: 191px;\n  }\n    .new-calendar-banner-visible-v2 {\n    margin-top: 251px;\n  }\n\n  @media (max-width: 767px) {\n    .new-calendar-banner-visible {\n      margin-top: 276px;\n    }\n    .new-calendar-banner-visible-v2 {\n    margin-top: 316px;\n  }\n     .new-calendar-banner {\n        padding: 20px 10px;\n        max-width: 100%;\n        /* margin: auto!important; */\n        margin-right: 25px;\n     }\n  }</style><div has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><eo-pl-general-actions class=\"visible-xs\"></eo-pl-general-actions></div><div class=\"pl-book-calendar-fixed-bar\"><!--<div class=\"panel-heading\" translate=\"global.setup.timeBoard\">--><!--global.setup.timeBoard--><!--</div>--><div class=\"\"><div class=\"container-fluid pl-container-fluid\"><div class=\"row\" style=\"display: flex; align-items: center\"><div class=\"col-md-3 col-sm-4 col-xs-10\" ng-if=\"vm.servantList && vm.servantList.length>0\"><div class=\"select-servant\"><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.servant.selectServant\' | translate}}\" ng-model=\"vm.selectedServant\" style=\"margin-top: 6px !important\" id=\"field_category\" ng-change=\"vm.onServantChanged()\" ng-disabled=\"vm.allServant\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servantList\">{{si.servantName}}</md-option></md-select></div></div><div ng-if=\"vm.servantList && vm.servantList.length>1\"><md-checkbox id=\"showAll\" ng-model=\"vm.allServant\" ng-change=\"vm.allServant_changed()\">نمایش همه</md-checkbox></div><div id=\"toolBtns\" class=\"col-sm-8 col-xs-8 pull-left\"><div style=\"display: flex;\n              flex-wrap: nowrap;\n              justify-content: space-between\"><div class=\"pull-right\"><div><div class=\"dropdown\"><!--<button ng-click=\"vm.showMenu2()\" class=\"dropbtn\">Dropdown</button>--><md-button id=\"new-btn\" class=\"hidden-xs md-raised md-primary pull-right md-button-xs-size pl-button-icon pl-btn-primary pl-btn\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-click=\"vm.openActionMenu()\"><i class=\"material-icons\">add</i> <span class=\"hidden-xs hidden-sm\">افزودن</span></md-button><div id=\"myDropdown\" class=\"dropdown-content actions-menu\"><div class=\"action-item\" ng-click=\"vm.newReserve_click()\"><md-icon>add</md-icon>رزرو جدید</div><div class=\"action-item\" ng-click=\"vm.newCloseTime_click()\"><md-icon style=\"font-size: 22px\">alarm_off</md-icon>زمان تعطیل</div><div class=\"action-item\" ng-click=\"vm.newOpenTime_click()\"><md-icon>alarm_on</md-icon>زمان استثنا (باز)</div></div></div><div class=\"dropdown\" id=\"dropDownSettingContainer\"><!--<button ng-click=\"vm.showMenu2()\" class=\"dropbtn\">Dropdown</button>--><md-button id=\"settings-btn\" class=\"md-raised pull-right md-button-xs-size pl-button-icon pl-btn pl-btn-default\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ui-sref=\"supplierPanel-v2.caledarConfig\"><i class=\"material-icons\">settings</i> <span class=\"hidden-xs hidden-sm\">تنظیمات</span></md-button></div><div style=\"display: flex; flex-direction: column\"><md-button type=\"button\" id=\"refreshCalendar\" class=\"md-raised pull-right md-button-xs-size pl-button-icon pl-btn pl-btn-default\" ng-click=\"vm.updateTimeBoard()\"><i class=\"fa fa-refresh\" aria-hidden=\"true\" style=\"font-size: 17px; padding: 3px\"></i> <span class=\"hidden-xs hidden-sm\" translate=\"tikonApp.serviceItem.refreshTimeBoard\"></span></md-button><div ng-if=\"vm.lastUpdate\" class=\"lastupdate hidden-xs hidden-sm\" style=\"padding-right: 6px\">آخرین به روز رسانی: <span>{{vm.lastUpdate | toPersianTime}}</span></div></div></div></div><div class=\"education-link hidden-xs\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div><!--<div class=\"pull-right hidden-xs hidden-sm\">--><!--<md-button class=\"md-raised md-secondary pl-button-icon\" ng-click=\"vm.openFilterDialog()\">--><!--<i class=\"material-icons\">filter_list</i>--><!--<span class=\"hidden-xs\">فیلتر</span>--><!--</md-button>--><!--</div>--></div></div><!--<div class=\"row visible-xs \">--><!--<div class=\"col-sm-2\" ng-if=\"vm.servantList && vm.servantList.length>1\">--><!--<md-checkbox ng-model=\"vm.allServant\" ng-change=\"vm.allServant_changed()\">--><!--نمایش همه--><!--</md-checkbox>--><!--</div>--><!--</div>--><div class=\"servant-chips-list-container\" ng-if=\"vm.allServant\"><div class=\"right-arrow\" ng-click=\"vm.slide(\'right\')\" ng-if=\"vm.showRightArrow\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></div><div id=\"servantChipsList\" class=\"servant-chips-list\"><div class=\"servant-chips\" ng-class=\"vm.getChipsClass(si)\" ng-value=\"si.id\" ng-repeat=\"si in vm.selectedServantChips\" ng-click=\"vm.servantChipsClick(si)\"><!--<md-icon ng-if=\"si.selected\" style=\"color:green\">check</md-icon>--><!--<md-icon ng-if=\"!si.selected\" style=\"color:#eee\">check</md-icon>--> {{si.servantName}}</div></div><div class=\"left-arrow\" ng-click=\"vm.slide(\'left\')\" ng-if=\"vm.showLeftArrow\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></div></div><div class=\"new-calendar-banner\" ng-if=\"vm.showNewCalendarBanner\"><button class=\"close-btn\" ng-click=\"vm.closeBanner()\">×</button><div class=\"banner-content\"><div style=\"display: flex; align-items: flex-start; gap: 15px\"><i class=\"material-icons calendar-icon\" style=\"font-size: 48px\">date_range</i><div class=\"text-container\"><p>تقویم جدید پلنوین آماده‌ست تا برنامه‌هات راحت‌تر و منظم‌تر از همیشه پیش برن.<br>دوست داریم نظرت رو بدونیم تا کارها رو برات ساده‌تر کنیم.</p></div></div><button ui-sref=\"supplierPanel-v2.calendar-v2\" class=\"view-btn\">امتحان تقویم جدید</button></div></div></div></div></div><div ng-class=\"vm.getCalendarClass()\"><div class=\"row\"><!--<md-content class=\"rwMdContent\">--><div class=\"\"><div eo-calendar calendar-filter=\"vm.calendarFilter\" last-update=\"vm.lastUpdate\" refresh-timing-info=\"vm.updateTimeBoard()\" style=\"width: 100%; height: 1200px; padding: 5px\"></div></div><!--</md-content>--></div></div>");
$templateCache.put("app/time-board/book-calendar.template.html","<style>.scheduleSession {\n        margin: 30px;\n        padding: 20px;\n        margin-top: 0px;\n        padding-top: 0px;\n    }\n\n    .fixedBar {\n        position: fixed;\n        top: 66px;\n        z-index: 10;\n        width: 100%;\n        background-color: white;\n        padding: 5px 0 5px 5%;\n        margin-right: -32px;\n        border-bottom: 1px solid #cecece;\n    }\n\n    .table-container {\n        margin-top: 50px;\n    }\n\n    .table-container-all-servant {\n        margin-top: 90px !important;\n    }\n\n    @media (max-width: 400px) {\n        .scheduleSession {\n            margin: 3px;\n            padding: 2px;\n            font-size: 0.8em;\n        }\n\n    }\n\n    .select-servant {\n        margin-right: 35px;\n    }\n\n    .servant-chips-list-container {\n        display: flex;\n        margin: 0 35px 0 0;\n    }\n\n    .servant-chips-list {\n        padding: 5px 6px 5px 50px;\n        font-size: 11px;\n        display: flex;\n        gap: 5px;\n        width: 700px;\n        overflow-x: auto;\n        overflow: hidden;\n        border: 1px solid lightgray;\n        /* right: 0; */\n        /* left: 0; */\n        /* position: absolute; */\n        border-radius: 5px;\n\n    }\n\n    .servant-chips {\n        background-color: rgba(211, 211, 211, 0.25);\n        border: 1px solid lightgray;\n        padding: 3px 6px;\n        border-radius: 20px;\n        min-width: fit-content;\n    }\n\n\n    .chips-checked {\n        background-color: rgb(238 249 238);\n        color: green;\n        border: 1px solid green;\n    }\n\n    .chips-unchecked {\n    }\n\n    .chips-checked:before, .chips-unchecked:before {\n        font-family: \'FontAwesome\';\n        font-size: 14px;\n        vertical-align: middle;\n    }\n\n    .chips-checked:before {\n        content: \'\\f058\';\n        color: green;\n    }\n\n    .chips-unchecked:before {\n        content: \'\\f10c\';\n        color: grey;\n    }\n\n\n    .left-arrow, .right-arrow {\n        /*content: \"\\f054\";*/\n        /*font-family: \'FontAwesome\';*/\n        font-size: 20px;\n        font-weight: bold;\n        background-color: #e1e1e1;\n        color: #4c4c4c !important;\n        display: flex;\n        align-items: center;\n        z-index: 10;\n        padding: 0 4px;\n    }\n\n    .left-arrow {\n        margin-right: -5px;\n        border-bottom-left-radius: 5px;\n        border-top-left-radius: 5px;\n        border: 1px solid lightgray;\n    }\n\n    .right-arrow {\n        margin-left: -5px;\n        border-bottom-right-radius: 5px;\n        border-top-right-radius: 5px;\n        border: 1px solid lightgray;\n    }\n\n    .actions-menu {\n        background: white;\n        box-shadow: 0 4px 6px 0 rgb(214 215 218);\n        border: 1px solid #d5d7da;\n        border-radius: 4px;\n        display: none;\n        position: absolute;\n        top: 47px;\n        flex-flow: column;\n        z-index: 100;\n        /*transition: transform 120ms ease-out, opacity 120ms ease-out;*/\n\n    }\n\n    .action-item {\n\n        padding: 10px;\n    }\n\n    .action-item:hover {\n\n        background-color: #f2f2f7;\n        cursor: pointer;\n    }\n\n    .pl-button-icon {\n        display: flex;\n        align-items: center;\n        gap: 3px;\n        justify-content: center;\n    }\n\n    @media (max-width: 768px) {\n        .table-container {\n            margin-top: 55px;\n        }\n\n        .fixedBar {\n            margin: auto;\n        }\n\n        .select-servant {\n            margin: auto;\n        }\n\n        .servant-chips-list-container {\n            margin: 0 0 0 0;\n        }\n\n        .table-container-all-servant {\n            margin-top: 150px !important;\n        }\n\n        .table-container {\n            margin-top: 110px;\n        }\n\n\n    }\n\n    @media (max-width: 590px) {\n        /*.table-container {*/\n        /*margin-top: 75px;*/\n        /*}*/\n        .tools-button {\n            padding-left: 10px !important;\n        }\n    }\n\n    @media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }\n\n    #selectCategory {\n        display: none;\n    }\n\n    .filterchips {\n        cursor: default;\n        border-radius: 16px;\n        display: block;\n        height: 32px;\n        line-height: 32px;\n        margin: 8px 8px 0 0;\n        padding: 0 12px 0 12px;\n        float: left;\n        box-sizing: border-box;\n        max-width: 100%;\n        position: relative;\n        font-family: yekan !important;\n        font-size: 12px !important;\n        border: 1px solid beige;\n        color: white;\n        /*background-color: beige;*/\n    }\n\n    .filterchips:hover {\n\n        opacity: 0.9;\n    }\n\n    .servantFilterChips {\n        cursor: default;\n        border-radius: 16px;\n        display: block;\n        height: 32px;\n        line-height: 32px;\n        margin: 8px 8px 0 0;\n        padding: 0 12px 0 12px;\n        float: left;\n        box-sizing: border-box;\n        max-width: 100%;\n        position: relative;\n        font-family: yekan !important;\n        font-size: 12px !important;\n        border: 1px solid #686161;\n        color: #8c8c8c;\n        background-color: #eeeeee7a\n    }\n\n    .servantFilterChips.not-selected {\n        border: 1px solid #bdbdbd;\n    }\n\n    .servantFilterChips:hover {\n\n        opacity: 0.9;\n    }\n\n    .servantFilterChips .icon {\n        font-size: 25px;\n        float: right;\n\n    }\n\n    .lastupdate {\n        font-size: 10px;\n        color: #8b8282;\n        float: left;\n        margin-left: 6px;\n    }\n\n    .not-selected {\n        opacity: 0.5;\n    }\n\n\n    .tools-button {\n        display: flex;\n        justify-content: flex-end;\n        padding-left: 50px;\n    }\n\n\n    /**/\n    .dropbtn {\n        background-color: #3498DB;\n        color: white;\n        padding: 16px;\n        font-size: 16px;\n        border: none;\n        cursor: pointer;\n    }\n\n    .dropbtn:hover, .dropbtn:focus {\n        background-color: #2980B9;\n    }\n\n    .dropdown {\n        position: relative;\n        display: inline-block;\n        float: right;\n    }\n\n    .dropdown-content {\n        display: none;\n        position: absolute;\n        /*background-color: #f1f1f1;*/\n        min-width: 160px;\n        overflow: auto;\n        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n        z-index: 1;\n    }\n\n    .dropdown-content a {\n        color: black;\n        padding: 12px 16px;\n        text-decoration: none;\n        display: block;\n    }\n\n    .dropdown a:hover {\n        background-color: #ddd;\n    }\n\n    .show {\n        display: block;\n    }</style><div class=\"fixedBar\"><!--<div class=\"panel-heading\" translate=\"global.setup.timeBoard\">--><!--global.setup.timeBoard--><!--</div>--><div class=\"\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4 col-sm-5 col-xs-6\" ng-if=\"vm.servantList && vm.servantList.length>0\"><div class=\"select-servant\"><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.servant.selectServant\' | translate}}\" ng-model=\"vm.selectedServant\" style=\"margin-top: 6px !important\" id=\"field_category\" ng-change=\"vm.onServantChanged()\" ng-disabled=\"vm.allServant\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servantList\">{{si.servantName}}</md-option></md-select></div></div><div class=\"col-md-2 col-sm-2 hidden-xs\" style=\"margin-top: 16px\" ng-if=\"vm.servantList && vm.servantList.length>1\"><md-checkbox ng-model=\"vm.allServant\" ng-change=\"vm.allServant_changed()\">نمایش همه</md-checkbox></div><div id=\"toolBtns\" class=\"col-sm-5 pull-left\"><!--<div class=\"pull-right\" style=\"padding-top: 14px;padding-right: 10px\">--><!--&lt;!&ndash;<md-checkbox ng-model=\"vm.reserveOnlyMode\" aria-label=\"Switch 1\"&ndash;&gt;--><!--&lt;!&ndash;fixedBarng-change=\"vm.onReserveOnlyChangedReset()\">&ndash;&gt;--><!--&lt;!&ndash;فقط رزرو شده ها نمایش داده شود&ndash;&gt;--><!--&lt;!&ndash;</md-checkbox>&ndash;&gt;--><!--</div>--><div class=\"pull-right\"><div><div class=\"dropdown\"><!--<button ng-click=\"vm.showMenu2()\" class=\"dropbtn\">Dropdown</button>--><md-button id=\"new-btn\" class=\"hidden-xs hidden-sm md-raised md-primary pull-right md-button-xs-size pl-button-icon\" ng-click=\"vm.openActionMenu()\"><i class=\"material-icons\">add</i> <span class=\"hidden-xs hidden-sm\">افزودن</span></md-button><div id=\"myDropdown\" class=\"dropdown-content actions-menu\"><div class=\"action-item\" ng-click=\"vm.newReserve_click()\"><md-icon>add</md-icon>رزرو جدید</div><div class=\"action-item\" ng-click=\"vm.newCloseTime_click()\"><md-icon style=\"font-size:22px\">alarm_off</md-icon>زمان تعطیل</div><div class=\"action-item\" ng-click=\"vm.newOpenTime_click()\"><md-icon>alarm_on</md-icon>زمان استثنا (باز)</div></div></div><!--<div id=\"actionsMenu\" class=\"actions-menu\">--><!--<div class=\"action-item\" ng-click=\"vm.newReserve_click()\">--><!--<md-icon> add</md-icon>--><!--رزرو جدید--><!--</div>--><!--<div class=\"action-item\" ng-click=\"vm.newCloseTime_click()\">--><!--<md-icon style=\"font-size:22px;\"> alarm_off</md-icon>--><!--زمان تعطیل--><!--</div>--><!--<div class=\"action-item\" ng-click=\"vm.newOpenTime_click()\">--><!--<md-icon> alarm_on</md-icon>--><!--زمان استثنا (باز)--><!--</div>--><!--</div>--><md-button class=\"visible-xs visible-sm md-raised md-primary pull-right md-button-xs-size pl-button-icon\" ng-click=\"vm.newReserve_click()\"><i class=\"material-icons\" style=\"top: 6px;position: absolute;left: 15px;right: 17px\">add</i> <span class=\"hidden-xs hidden-sm\">افزودن</span></md-button><md-button type=\"button\" class=\"md-raised pull-right md-button-xs-size pl-button-icon\" ng-click=\"vm.updateTimeBoard()\"><i class=\"fa fa-refresh\" aria-hidden=\"true\" style=\"font-size: 17px; padding: 3px\"></i> <span class=\"hidden-xs hidden-sm\" translate=\"tikonApp.serviceItem.refreshTimeBoard\"></span></md-button></div><div ng-if=\"vm.lastUpdate\" class=\"lastupdate hidden-xs hidden-sm\">آخرین به روز رسانی: <span>{{vm.lastUpdate | toPersianTime}}</span></div></div><div class=\"pull-right hidden-xs hidden-sm\"><md-button class=\"md-raised md-secondary pl-button-icon\" ng-click=\"vm.openFilterDialog()\"><i class=\"material-icons\">filter_list</i> <span class=\"hidden-xs\">فیلتر</span></md-button></div></div></div><div class=\"row visible-xs\"><div class=\"col-sm-2\" ng-if=\"vm.servantList && vm.servantList.length>1\"><md-checkbox ng-model=\"vm.allServant\" ng-change=\"vm.allServant_changed()\">نمایش همه</md-checkbox></div></div><div class=\"servant-chips-list-container\" ng-if=\"vm.allServant\"><div class=\"right-arrow\" ng-click=\"vm.slide(\'right\')\" ng-if=\"vm.showRightArrow\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></div><div id=\"servantChipsList\" class=\"servant-chips-list\"><div class=\"servant-chips\" ng-class=\"vm.getChipsClass(si)\" ng-value=\"si.id\" ng-repeat=\"si in vm.selectedServantChips\" ng-click=\"vm.servantChipsClick(si)\"><!--<md-icon ng-if=\"si.selected\" style=\"color:green\">check</md-icon>--><!--<md-icon ng-if=\"!si.selected\" style=\"color:#eee\">check</md-icon>--> {{si.servantName}}</div></div><div class=\"left-arrow\" ng-click=\"vm.slide(\'left\')\" ng-if=\"vm.showLeftArrow\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></div></div></div></div></div><div ng-class=\"vm.getCalendarClass()\"><div class=\"row\"><!--<md-content class=\"rwMdContent\">--><div class=\"col-sm-12\"><div eo-calendar calendar-filter=\"vm.calendarFilter\" last-update=\"vm.lastUpdate\" refresh-timing-info=\"vm.updateTimeBoard()\" style=\"width: 100%;height:1200px;padding: 5px\"></div></div><!--</md-content>--></div></div>");
$templateCache.put("app/time-board/calendar-vue.template.html","<div id=\"container-calendar\"><panel-pln-calendar id=\"calendar\"></panel-pln-calendar></div>");
$templateCache.put("app/time-board/filter-dialog.template-v2.html","<style>.pl-modal-content{\n    padding-top: 35px;\n}</style><eo-pl-modal-header title=\"\'فیلتر تقویم\'\" is-disabled=\"editForm.$invalid || vm.isSaving || vm.firstHour >= vm.lastHour\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span>فیلتر تقویم</span></div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"firstHour\">ساعت شروع</label><md-select class=\"rwMdSelect\" ng-model=\"vm.firstHour\"><md-option ng-value=\"h\" ng-repeat=\"h in vm.firsthourList\">{{h}}</md-option></md-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"lastHour\">ساعت پایان</label><!-- <input id=\"lastHour\" type=\"number\" class=\"form-control\" ng-model=\"vm.lastHour\" max=\"24\"> --><md-select class=\"rwMdSelect\" ng-model=\"vm.lastHour\"><md-option ng-value=\"h\" ng-repeat=\"h in vm.lasthourList\">{{h}}</md-option></md-select></div></div></div></form></div></div></div></div></div><eo-pl-modal-footer title=\"\'فیلتر تقویم\'\" is-disabled=\"editForm.$invalid || vm.isSaving || vm.firstHour >= vm.lastHour\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/time-board/filter-dialog.template.html","<style>.filterLabel {\n        padding: 5px 0 !important;\n    }\n\n    .filter-dialog-content {\n        min-height: 360px;\n        min-width: 300px;\n        max-width: 600px;\n        padding: 10px;;\n    }\n\n    .demo-md-panel {\n        min-height: 500px;\n    }\n\n    .demo-dialog-example {\n        background: white;\n        border-radius: 4px;\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),\n        0 13px 19px 2px rgba(0, 0, 0, 0.14),\n        0 5px 24px 4px rgba(0, 0, 0, 0.12);\n        width: 500px;\n    }\n\n    .demo-dialog-content {\n        padding: 0 15px;\n        width: 100%;\n    }\n\n    .demo-dialog-content img {\n        height: 300px;\n        margin: auto;\n    }\n\n    .demo-dialog-button {\n        width: 100%;\n    }\n\n    .demo-dialog-custom-animation-open {\n        opacity: 1;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(390deg);\n    }\n\n    .demo-dialog-custom-animation-close {\n        opacity: 0;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(0deg);\n    }</style><div role=\"dialog\" layout=\"column\" layout-align=\"center center\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>فیلتر تقویم</h2></div></md-toolbar><div class=\"demo-dialog-content filter-dialog-content\" style=\"margin: 15px 0px 0px\"><div class=\"container-fluid\"><div class=\"row\"><md-input-container style=\"margin-right: 10px\"><label class=\"control-label filterLabel\">از ساعت</label><md-select class=\"rwMdSelect\" ng-model=\"vm.dialogData.firstHour\" style=\"min-width: 50px\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.dialogData.hourList\">{{si}}</md-option></md-select></md-input-container><md-input-container style=\"margin-right: 10px\"><label class=\"control-label filterLabel\">تا ساعت</label><md-select class=\"rwMdSelect\" ng-model=\"vm.dialogData.lastHour\" style=\"min-width: 50px\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.dialogData.hourList\">{{si}}</md-option></md-select></md-input-container></div><div class=\"row\"><md-input-container style=\"margin-right: 10px\"><label class=\"control-label filterLabel\" translate=\"tikonApp.serviceItem.selectCategory\">Capacity</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\" ng-model=\"vm.dialogData.selectedCategoryId\" ng-change=\"vm.dialogData.onCategoryChanged()\" style=\"min-width: 200px\" disabled=\"true\"><md-option ng-value=\"0\" selected=\"selected\"><span translate=\"tikonApp.serviceItem.allCategory\"></span></md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.dialogData.categories\">{{si.categoryName}}</md-option></md-select></md-input-container></div><div class=\"row\"><md-input-container style=\"margin-right: 10px\"><label class=\"control-label hidden-xs filterLabel\" translate=\"tikonApp.serviceItem.selectService\">selectService</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectService\' | translate}}\" ng-model=\"vm.dialogData.selectedService\" ng-change=\"vm.dialogData.onServiceChanged()\" style=\"min-width: 300px\" disabled=\"true\"><!--<md-option ng-if=\"vm.dialogData.canSelectMultiService\"  ng-value=\"0\" selected=\"selected\"><span--><md-option ng-value=\"0\" selected=\"selected\"><span></span> همه سرویس ها</md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.dialogData.serviceItems\"><small ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} -</small> {{si.itemTitle}}</md-option></md-select></md-input-container></div><!--<div class=\"row\" >--><!--<md-input-container   style=\"margin-right: 10px;\">--><!--<label class=\"control-label hidden-xs filterLabel\"--><!--translate=\"tikonApp.serviceItem.selectServant\">selectServant</label>--><!--<md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectServant\' | translate}}\"--><!--ng-model=\"vm.dialogData.selectedServant\" ng-change=\"vm.dialogData.onServantChanged()\"--><!--style=\"min-width: 300px;\">--><!--&lt;!&ndash;<md-option ng-value=\"0\" selected=\"selected\"><span&ndash;&gt;--><!--&lt;!&ndash;&gt;</span>&ndash;&gt;--><!--&lt;!&ndash;نمایش همه&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--<md-option ng-value=\"si.id\" ng-repeat=\"si in vm.dialogData.servantList\">--><!--{{si.servantName}}--><!--</md-option>--><!--</md-select>--><!--</md-input-container>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"pull-right\">--><!--<md-checkbox ng-model=\"vm.dialogData.reserveOnlyMode\" aria-label=\"Switch 1\" ng-change=\"vm.dialogData.onReserveOnlyChanged()\">--><!--فقط رزرو شده ها نمایش داده شود--><!--</md-checkbox>--><!--</div>--><!--</div>--></div></div><div layout=\"row\" class=\"demo-dialog-button\" style=\"direction: ltr\"><div class=\"col-md-3\"><md-button type=\"button\" class=\"md-raised md-primary\" ng-click=\"vm.dialogData.updateTimeBoard(vm.hideDialog)\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.refreshTimeBoard\"></span></md-button></div></div></div><!--<div class=\"filter-dialog-content\">--> <!--</div>-->");
$templateCache.put("app/time-board/shared-time-board.html","<style>.scheduleSession {\n        margin: 30px;\n        padding: 20px;\n        margin-top: 0px;\n        padding-top: 0px;\n    }\n\n    @media (max-width: 400px) {\n        .scheduleSession {\n            margin: 3px;\n            padding: 2px;\n            font-size: 0.8em;\n        }\n\n        #selectCategory {\n            display: none;\n        }\n    }</style><div><eo-progress-bar></eo-progress-bar><div class=\"\"><div eo-scheduler-lazy service-item-id=\"vm.selectedId\" access-level=\"vm.accessLevel\" timing-info=\"vm.timingInfo\" refresh-timing-info=\"vm.updateTimeBoard()\" style=\"width: 100%;height:800px\"></div></div><!--<div class=\"scheduleSession\">--><!----><!--</div>--></div>");
$templateCache.put("app/time-board/time-board.html","<style>.scheduleSession {\n        margin: 30px;\n        padding: 20px;\n        margin-top: 0px;\n        padding-top: 0px;\n    }\n\n    @media (max-width: 400px) {\n        .scheduleSession {\n            margin: 3px;\n            padding: 2px;\n            font-size: 0.8em;\n        }\n\n        #selectCategory {\n            display: none;\n        }\n    }</style><div><eo-progress-bar></eo-progress-bar><div class=\"\"><div class=\"row\"><div class=\"col-sm-1\"></div><div id=\"selectCategory\" class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.selectCategory\">Capacity</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\" ng-model=\"vm.selectedCategoryId\" ng-change=\"vm.onCategoryChanged()\" style=\"min-width: 200px\"><md-option ng-value=\"0\" selected=\"selected\"><span translate=\"tikonApp.serviceItem.allCategory\"></span></md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.categories\">{{si.categoryName}}</md-option></md-select></div></div><div class=\"col-sm-7\"><table><tr><td><div class=\"form-group\"><label class=\"control-label hidden-xs\" translate=\"tikonApp.serviceItem.selectService\">selectService</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectService\' | translate}}\" ng-model=\"vm.selectedId\" ng-change=\"vm.onServiceChanged()\" style=\"min-width: 300px\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceItems\"><small ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} -</small> {{si.itemTitle}}</md-option></md-select></div></td><td><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.updateTimeBoard()\" style=\"font-size: 10px;padding: 10px\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.refreshTimeBoard\"></span></button></td></tr></table></div></div></div><div class=\"\"><div eo-scheduler-lazy service-item-id=\"vm.selectedId\" timing-info=\"vm.timingInfo\" refresh-timing-info=\"vm.updateTimeBoard()\" style=\"width: 100%;height:800px\"></div></div><!--<div class=\"scheduleSession\">--><!----><!--</div>--></div>");
$templateCache.put("app/userprofile/user-profiles-test.html","<!--<form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\">--><!--<div>--><!--<button type=\"submit\"--><!--ui-sref=\"person-info-detail({id:\'1035\'})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"userProfile.editPerson({id:\'1035\'})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button class=\"btn btn-info\" ng-click=\"vm.loadPersonClick()\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</button>--><!--<div>--><!--Last Name : {{vm.personInfoDTO.lastName}}--><!--</div>--><!--<div>--><!--<div ng-repeat=\"p in vm.personInfoDTOlist\">--><!--{{p}}--><!--</div>--><!--</div>--><!--<div ui-view=\"subcontent\"></div>--><!--&lt;!&ndash;<div class=\"tab-content panel panel-default\">&ndash;&gt;--><!--&lt;!&ndash;<div id=\"personInfoTab\" class=\"tab-pane fade\">&ndash;&gt;--><!--&lt;!&ndash;<div ui-view=\"subcontent\"> </div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--> <!--</form>-->");
$templateCache.put("app/userprofile/user-profiles-v2.html","<style>.pl-modal-content .legalInfo {\n        margin-top: 25px;\n    }\n    .pl-modal-content .legalInfo .form-group input {\n        background-color: rgb(228, 227, 227)!important;\n    }\n    .pl-modal-content .legalInfo .legalInfo__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }</style><eo-pl-modal-header title=\"\'global.menu.account.userProfile\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"global.menu.account.userProfile\"></span></div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert></jhi-alert><div id=\"personInfoComp\"><pf-person-info person-info=\"vm.personInfo\" block-edit-phone-number=\"vm.blockEditPhoneNumber\"></pf-person-info><div class=\"row legalInfo\" ng-if=\"vm.legalInfo.id && vm.legalInfo.legalType\"><div class=\"col-md-2\"></div><div class=\"col-md-10\"><div class=\"legalInfo__header\"><h4>اطلاعات حقیقی‌‌ -‌ حقوقی (جهت ثبت فاکتور)</h4><!-- TODO reDo edit action --><!-- <div class=\"pl-menu-item\" ui-sref=\"supplierPanel-v2.legal_actualInformation\" style=\"border-radius: 4px;\">\n                                        ویرایش\n                                    </div> --></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label ng-if=\"vm.legalInfo.legalType ==\'NATURAL\'\" class=\"control-label\" required for=\"field_billingName\">نام شخص</label><label ng-if=\"vm.legalInfo.legalType ==\'LEGAL\'\" class=\"control-label\" required for=\"field_billingName\">نام شرکت</label><input ng-model=\"vm.legalInfo.name\" type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"billingName\" id=\"field_billingName\" ng-model=\"vm.billingName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label ng-if=\"vm.legalInfo.legalType ==\'NATURAL\'\" class=\"control-label\" required for=\"field_billingNationalCode\">کد ملی</label><label ng-if=\"vm.legalInfo.legalType ==\'LEGAL\'\" class=\"control-label\" required for=\"field_billingNationalCode\">شناسه ملی</label><input ng-model=\"vm.legalInfo.nationalCode\" readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"billingNationalCode\" id=\"field_billingNationalCode\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" required for=\"postal_code\">کدپستی</label><input ng-model=\"vm.legalInfo.zipCode\" type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"billingName\" id=\"postal_code\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" required for=\"address\">آدرس</label><input ng-model=\"vm.legalInfo.address\" type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"billingNationalCode\" id=\"address\"></div></div></div></div></div></div></form></div></div></div></div><eo-pl-modal-footer title=\"\'global.menu.account.userProfile\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/userprofile/user-profiles.html","<div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"global.menu.account.userProfile\"></span></div><div class=\"panel-body\"><md-content class=\"rwMdContent\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert></jhi-alert><action-bar></action-bar><div id=\"personInfoComp\"><pf-person-info person-info=\"vm.personInfo\" block-edit-phone-number=\"vm.blockEditPhoneNumber\"></pf-person-info></div></form></md-content></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/activate/activateUserBySMS.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"global.form.email\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.phoneNumber\" ng-minlength=\"5\" ng-maxlength=\"5\" required><div><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.activateUser()\" translate=\"reset.request.form.button\">Activate</button></div><div>{{vm.phoneNumber}}</div></div><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/password/password-v2.html","<eo-pl-modal-header title=\"\'global.menu.account.password\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"global.menu.account.password\"></span></div><div class=\"panel-body\"><div><div class=\"row\"><div class=\"col-md-8\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input style=\"max-width: 320px\" type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p><br></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmnewpassword\">New password confirmation</label><input style=\"max-width: 320px\" type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmnewpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><md-button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary pl-btn pl-btn-primary\" translate=\"password.form.button\">Save</md-button></form></div></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/account/password/password.html","<div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"global.menu.account.password\">global.menu.account.password</span></div><div class=\"panel-body\"><md-content class=\"rwMdContent\"><div><div class=\"row\"><div class=\"col-md-8\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input style=\"max-width: 320px\" type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p><br></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmnewpassword\">New password confirmation</label><input style=\"max-width: 320px\" type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmnewpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div></md-content></div></div>");
$templateCache.put("app/account/register/register.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" submited class=\"btn btn-primary\" translate=\"register.form.button\">Register</button></form><p></p><div class=\"alert alert-warning\" translate=\"global.messages.info.authenticated\" translate-compile>If you want to <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div></div></div></div>");
$templateCache.put("app/account/sessions/sessions.html","<div><h2 translate=\"sessions.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"sessions.messages.success\"><strong>Session invalidated!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"sessions.messages.error\"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"sessions.table.ipaddress\">IP Address</th><th translate=\"sessions.table.useragent\">User agent</th><th translate=\"sessions.table.date\">Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"session in vm.sessions\"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.invalidate(session.series)\" translate=\"sessions.table.button\">Invalidate</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/logs/logs.html","<div class=\"table-responsive\"><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/tracker/tracker.html","<div><h2 translate=\"tracker.title\">Real-time user activities</h2><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"tracker.table.userlogin\">User</th><th translate=\"tracker.table.ipaddress\">IP Address</th><th translate=\"tracker.table.page\">Current page</th><th translate=\"tracker.table.time\">Time</th><th></th></tr></thead><tbody><tr ng-repeat=\"activity in vm.activities\"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><!--<div class=\"form-group\">--><!--<label translate=\"userManagement.profiles\">Profiles</label>--><!--<select class=\"form-control\" multiple name=\"authority\" ng-model=\"vm.user.authorities\"--><!--ng-options=\"authority for authority in vm.authorities\">--><!--</select>--><!--</div>--><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><div ng-repeat=\"authority in vm.authorities\"><label><input type=\"checkbox\" ng-model=\"authority.value\" ng-disabled=\"authority.disable\"> {{authority.key}}</label></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\" has-authority=\"ROLE_SUPER_ADMIN_FULL_ACCESS\"><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\" for=\"field_userSearch\">Search User</label><input type=\"text\" class=\"form-control\" name=\"userLogin\" id=\"field_userSearch\" ng-model=\"vm.login\"></div></div><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.edit({login:vm.login})\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\">Edit By Login</span></button></div></div>{{vm.foundedUser}}<div class=\"table-responsive\"><table st-safe-src=\"vm.users\" st-table=\"collection\" st-safe- class=\"jh-table table table-striped\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control\" placeholder=\"{{ \'tikonApp.orderBag.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th translate=\"global.field.id\">ID</th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th></th><th translate=\"userManagement.langKey\">Lang Key</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.createdDate\">Created Date</th><th translate=\"userManagement.lastModifiedBy\">Last Modified By</th><th translate=\"userManagement.lastModifiedDate\">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in collection track by user.id\"><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Deactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"20\"></div></td></tr></tfoot></table></div><!--<div class=\"text-center\">--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination>--><!--</div>--></div>");
$templateCache.put("app/components/action-bar/action-bar.template.html","<div class=\"row\"><div class=\"col-lg-12\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button><div ng-transclude></div><!--<jhi-alert-error></jhi-alert-error>--></div></div>");
$templateCache.put("app/components/login/login.html","<style>.big-input {\n        text-align: center;\n        font-size: 20px;\n        font-family: tahoma;\n        color: #032c24 !important;\n        /*padding: 22px;*/\n    }</style><div class=\"panelLogin\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-unlock\" aria-hidden=\"true\"></i> <span translate=\"login.panelLogin\"></span></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.email_or_phone\">Login</label><input type=\"text\" class=\"form-control big-input\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control big-input\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><!--<div class=\"g-recaptcha\" data-sitekey=\"6LfiuhIUAAAAACl9FuB2ZwNQwjf8NC7jlx_oHyTP\"></div>--><!--<re-captcha (captchaResponse)=\"handleCorrectCaptcha($event)\" language=\"fa-ir\"   site_key=\"6Lc2qhsUAAAAAFtylEVRyjLCCpsiBrOc2XNOGDBN\"></re-captcha>--><!--<div--><!--vc-recaptcha--><!--ng-model=\"vm.captchaCode\"--><!--lang=\"fa-ir\"--><!--key=\"\'6Lc2qhsUAAAAAFtylEVRyjLCCpsiBrOc2XNOGDBN\'\"--><!--&gt;</div>--><!--<div class=\"my-recaptcha\" data-sitekey=\"6LfiuhIUAAAAACl9FuB2ZwNQwjf8NC7jlx_oHyTP\"></div>--> <button ng-disabled=\"!(vm.username && vm.password )\" type=\"submit\" class=\"btn btn-success btn-block btn-lg pl-btn pl-btn-primary loginbtn\"><i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i> <span translate=\"login.form.button\"></span></button></form><!--<a class=\"btn btn-lg\" href=\" https://accounts.google.com/o/oauth2/auth?scope=email&redirect_uri=http://localhost:8080/google-auth-redirect&response_type=code&client_id=26554230915-f6jfkijap7k1arflsi80278isjjhmqko.apps.googleusercontent.com&approval_prompt=force\" >--><!--Login with google--><!--</a>--><p></p><div style=\"padding-top: 10px;line-height: 2.2\"><a class=\"forgetLink\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a><div><span>حساب کاربری ندارید ؟ </span><span><a id=\"loginRegisterBtn\" ng-click=\"vm.register()\">ثبت نام کنید</a></span></div></div></div></div></div></div>");
$templateCache.put("app/components/modal/educationMovie.html","<style>#player-overlay {\n    width: 100%;\n    max-height: 100%;\n  }</style><div style=\"text-align: left\"><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span--><!--translate=\"entity.action.cancel\">Cancel</span>--> <span>بازگشت</span><md-icon style=\"color: #000\">keyboard_backspace</md-icon></md-button></div><div><div id=\"player-overlay\"><div ng-bind-html=\"vm.link\"></div></div></div>");
$templateCache.put("app/dashboard/analogClock/analogClock.template.html","<style>.outer_face {\n        position: relative;\n        width: 90px;\n        height: 90px;\n        border-radius: 200px;\n        background: white;\n        border: 0 solid gray;\n        float: left;\n    }\n\n    .outer_face::before, .outer_face::after, .outer_face .marker { /* time markers syle */\n        content: \"\";\n        position: absolute;\n        width: 7px;\n        height: 100%;\n\n        z-index: 0;\n        left: 50%;\n        margin-left: -3.5px;\n        top: 0\n    }\n\n    .outer_face::after {\n        -moz-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n        -webkit-transform: rotate(90deg);\n        transform: rotate(90deg)\n    }\n\n    .outer_face .marker {\n\n        width: 4px;\n        margin-left: -2px\n    }\n\n    .outer_face .marker.oneseven {\n        -moz-transform: rotate(30deg);\n        -ms-transform: rotate(30deg);\n        -webkit-transform: rotate(30deg);\n        transform: rotate(30deg)\n    }\n\n    .outer_face .marker.twoeight {\n        -moz-transform: rotate(60deg);\n        -ms-transform: rotate(60deg);\n        -webkit-transform: rotate(60deg);\n        transform: rotate(60deg)\n    }\n\n    .outer_face .marker.fourten {\n        -moz-transform: rotate(120deg);\n        -ms-transform: rotate(120deg);\n        -webkit-transform: rotate(120deg);\n        transform: rotate(120deg)\n    }\n\n    .outer_face .marker.fiveeleven {\n        -moz-transform: rotate(150deg);\n        -ms-transform: rotate(150deg);\n        -webkit-transform: rotate(150deg);\n        transform: rotate(150deg)\n    }\n\n    .inner_face {\n        position: relative;\n        width: 86%;\n        height: 86%;\n        background: white;\n        -moz-border-radius: 1000px;\n        -webkit-border-radius: 1000px;\n        border-radius: 1000px;\n        z-index: 1000;\n        left: -6.5%;\n        top: 7%;\n    }\n\n    .inner_face::before {\n        /* clock center circle small */\n        content: \"\";\n        width: 12px;\n        height: 12px;\n        border-radius: 18px;\n        margin-left: -6px;\n        margin-top: -6px;\n        background: black;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n\n    }\n\n    .inner_face::after {\n        content: \"== RW ==\";\n        position: absolute;\n        width: 100%;\n        font: normal 0.8em Arial;\n\n        text-align: center;\n        top: 63%;\n        font-size: 10px;\n        z-index: 1;\n    }\n\n    .hand, .hand.hour {\n        position: absolute;\n        width: 3px;\n        height: 30%;\n        top: 20%;\n        left: 50%;\n        margin-left: -2px;\n        background: black;\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n        -moz-transform-origin: bottom;\n        -ms-transform-origin: bottom;\n        -webkit-transform-origin: bottom;\n        transform-origin: bottom;\n        z-index: -1;\n        -moz-box-shadow: 0 0 3px gray;\n        -webkit-box-shadow: 0 0 3px gray;\n        box-shadow: 0 0 3px gray;\n        z-index: 3;\n    }\n\n    .hand.minute {\n        height: 45%;\n        top: 5%;\n        width: 3px;\n        margin-left: -1px;\n        z-index: 4;\n    }\n\n    .hand.second {\n        height: 50%;\n        width: 1px;\n        margin-left: -1px;\n        top: 0;\n        background: red;\n        z-index: 2;\n\n    }</style><!--Developed by Mohammadreza Alikarami--><div id=\"liveclock\" class=\"outer_face\"><div class=\"marker oneseven\"></div><div class=\"marker twoeight\"></div><div class=\"marker fourten\"></div><div class=\"marker fiveeleven\"></div><div class=\"inner_face\"><div class=\"hand hour\"></div><div class=\"hand minute\"></div><div class=\"hand second\"></div></div></div><script type=\"text/javascript\">var $hands = $(\'#liveclock div.hand\')\n\n    window.requestAnimationFrame = window.requestAnimationFrame\n        || window.mozRequestAnimationFrame\n        || window.webkitRequestAnimationFrame\n        || window.msRequestAnimationFrame\n        || function (f) {\n            setTimeout(f, 60)\n        }\n\n\n    function updateclock() {\n        var curdate = new Date()\n        var hour_as_degree = (curdate.getHours() + curdate.getMinutes() / 60) / 12 * 360;\n        var minute_as_degree = curdate.getMinutes() / 60 * 360;\n        var second_as_degree = (curdate.getSeconds() + curdate.getMilliseconds() / 1000) / 60 * 360;\n        $hands.filter(\'.hour\').css({transform: \'rotate(\' + hour_as_degree + \'deg)\'});\n        $hands.filter(\'.minute\').css({transform: \'rotate(\' + minute_as_degree + \'deg)\'});\n        $hands.filter(\'.second\').css({transform: \'rotate(\' + second_as_degree + \'deg)\'});\n        requestAnimationFrame(updateclock)\n    }\n\n    requestAnimationFrame(updateclock)</script>");
$templateCache.put("app/dashboard/company-wizard-step/company-wizard-step.html","<div id=\"reserveModal\" class=\"modal-header pl-modal-header pl-modal-border pl-modal-header-sm\" style=\"position: sticky\"><div id=\"company-wizard-modal-header\" class=\"pl-modal-title\">{{vm.title}}</div><div class=\"pl-modal-header-close-icon\" ng-click=\"vm.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid pl-container-flex\" style=\"padding: 20px\"><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'ADD_SERVICE\'\">برای شروع کار با پلنوین ابتدا باید خدمات خود را تعریف کنید. کافی است نام خدماتی که ارائه می‌دهید را به همراه قیمت و مدت زمان آن تعریف و ثبت کنید!</div><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'ADD_SERVANT\' && !vm.isWorkingSpace\">منظور از پرسنل همکارانی هستند که در کسب‌وکار شما کار می‌کنند. این همکاران می‌توانند آرایشگر، پزشک، کارمند، عکاس و…. باشند. با تعریف پرسنل میتوانید زمان کاری مجزا برای آنها تعریف کنید و سوابق خدماتی که ارائه میدهند را مشاهده کنید.</div><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'ADD_SERVANT\' && vm.isWorkingSpace\">شما باید منابعی(میزها) که قابل رزرو هستند را مشخص کنید. تا سیستم با استفاده از این تعاریف بتواند از تداخل زمانی جلوگیری کند.</div><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'CHANGE_COMPANY_SCHEDULE\'\">شما می‌توانید در هر زمانی روزها و ساعت کاری کسب‌وکار خود را تعییر و مدیریت کنید یا روزهای تعطیل اضافه کنید. شما حتی می‌توانید برای هر پرسنل ساعت و روزهای کاری جداگانه تغریف کنید!</div><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'ADD_RESERVE\'\">هدف اصلی پلنوین تسریع کارها و مدیریت هرچه بهتر مشتریان شماست! با پلنوین دیگر هیچ نیازی به دفتر ندارید! شما خودتان هم می‌توانید برای مشتری در پلنوین رزرو ثبت کنید و از تقویم کاری پلنوین به عنوان تنها مرجع مدیریت زمان خود استفاده کنید!</div><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'CHANGE_THEME\'\">شما می‌توانید سایت اختصاصی خود را مطابق سلیقه و نظر خود تغییر دهید. برای شروع می‌توانید رنگ سایت و عکس اول آن را مطابق میل خود عوض کرده و لوگوی کسب‌وکار خود را بارگزاری کنید.</div><div class=\"wizard-step-desc\" ng-if=\"vm.type==\'CONNECT_INSTAGRAM\'\">برای اتصال به اینستاگرام و دریافت سفارش از طریق آن، کافی است لینک سایت اختصاصی خود را از در قسمت بایو اینستاگرام خود درج کنید. یا از \"یک لینک\" استفاده کنید.</div></div></div><div class=\"pl-modal-footer-sm\"><md-button class=\"md-raised md-primary pl-btn pl-btn-primary pl-btn-lg\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" style=\"font-size: 1.5rem\" ng-click=\"vm.okModal()\"><span>{{vm.buttonText}}</span></md-button><md-button ng-if=\"vm.canCancel\" type=\"button\" class=\"md-raised md-secondary pull-left pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\" style=\"font-size: 1.5rem\"><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;--> <span>{{vm.cancelButtonText}}</span></md-button></div>");
$templateCache.put("app/dashboard/main/report.main_dashboard.html","<style xmlns=\"http://www.w3.org/1999/html\">/*#page-wrapper {*/\n    /*background-image: url(\"/content/images/background/wave.jpg\");*/\n    /*background-position: bottom;*/\n    /*background-size: cover;*/\n    /*background-attachment: fixed;*/\n    /*}*/\n\n    .news-tag {\n        padding: 2px 10px;\n        margin: 0 0 0 10px;\n        font-size: 10px;\n        border-radius: 5px;\n        font-weight: bold;\n        /*border: 1px solid;*/\n    }\n\n    .news-INFO {\n        background-color: #c1dae9 !important;\n        color: #2b6b7f !important;\n    }\n\n    .news-HELP {\n        background-color: #dfcff3 !important;\n        color: purple;\n    }\n\n    .news-EXPERT_HELP {\n        background-color: #f1cff3 !important;\n        color: purple;\n    }\n\n    .news-WARNING {\n        background-color: #f7dada !important;\n        color: #d74646;\n    }\n\n    .news-SPECIAL_OFFER {\n        background-color: #f5e1a6 !important;\n        color: #cd804a;\n    }\n\n    .news-NEW_FEATURE {\n        background-color: #ddf3c4 !important;\n        color: green;\n    }\n\n\n    #dashboardTitleBar_content {\n        z-index: 2;\n        width: 100%;\n    }\n\n    .dashboardTitleBar_col {\n        padding: 0 4px;\n        text-align: center;\n        margin-bottom: 10px;\n    }\n\n    .dashboardTitleBar_col > div {\n        margin: 0 1px;\n        background-color: rgba(255, 255, 255, 0.8);\n        height: 102px;\n        border-radius: 5px;\n        border: 1px solid lightgray;\n    }\n\n    .dashboardTitleBar_col .textInTitleBar {\n        font-size: 10px;\n    }\n\n    .dashboardTitleBar_col hr {\n        border: none;\n        width: 45%;\n        margin: 0 auto 20px;\n        background-color: whitesmoke;\n    }\n\n    .numbersInTitleBar {\n        width: 100%;\n        font-size: 32px;\n        font-weight: bold;\n    }\n\n\n    #analogClock_container {\n        left: -150px;\n        width: 118px;\n        /*margin: auto;*/\n        margin: 6px 15px;\n        position: absolute;\n    }\n\n    .container {\n        width: 100%;\n    }\n\n    .bg-white-opaq {\n        margin: 5px;\n        background-color: rgba(200, 200, 200, 0.1);\n        border-radius: 7px;\n        border: 1px solid lightgray;\n    }\n\n    /*.table {*/\n    /*width: 99%;*/\n    /*}*/\n    .table > thead > tr {\n        background-color: rgba(230, 230, 255, 0.5);\n    }\n\n    .contentSections div {\n        padding-right: 0;\n        padding-left: 0;\n    }\n\n    #footer {\n        margin-top: 0;\n    }\n\n    .tableOfReserves {\n        overflow: auto;\n    }\n\n    /*::-webkit-scrollbar {*/\n    /*width: 7px;*/\n    /*height: 7px;*/\n\n    /*}*/\n\n    /*!* Track *!*/\n    /*::-webkit-scrollbar-track {*/\n    /*background: #f1f1f1;*/\n    /*border-radius: 7px;*/\n    /*}*/\n\n    /*!* Handle *!*/\n    /*::-webkit-scrollbar-thumb {*/\n    /*background: rgba(230, 230, 230, 0.6);*/\n    /*border-radius: 7px;*/\n    /*}*/\n\n    /*!* Handle on hover *!*/\n    /*::-webkit-scrollbar-thumb:hover {*/\n    /*background: rgba(230, 230, 230, 0.2);*/\n    /*}*/\n\n    a, a:hover, a:focus {\n        color: #607d8b;\n        text-decoration: none;\n    }\n\n    @media (max-width: 991px) {\n        .tableOfReserves, .md-button.md-raised {\n            font-size: x-small;\n        }\n    }\n\n    @media (max-width: 767px) {\n\n        #analogClock_container {\n            display: none;\n        }\n\n    }\n\n    .newFeatures {\n        margin: 0px -10px;\n        padding: 15px;\n        background-color: rgb(246, 247, 255);\n        /*height: 50px;*/\n        border-radius: 5px;\n        border: 1px solid lightgray;\n        margin-bottom: 20px;\n    }\n\n    .quickAccessIcon {\n        width: 40px;\n    }\n\n    .quickAccessTitle {\n        padding-right: 10px;\n    }\n\n    .new-features-button {\n        font-weight: bold;\n        border: 1px solid;\n        padding: 1px 10px;\n        border-radius: 5px;\n        /*margin: 0 10px;*/\n    }\n\n    .new-features-button:hover {\n        box-shadow: 0px 0px 4px;\n    }\n\n    .hide-slide {\n        display: none;\n    }\n\n    .show-slide {\n        display: block;\n    }\n\n    /* Fading animation */\n    .fade {\n        -webkit-animation-name: fade;\n        -webkit-animation-duration: 1.5s;\n        animation-name: fade;\n        animation-duration: 1.5s;\n    }\n\n    @-webkit-keyframes fade {\n        from {\n            opacity: .4\n        }\n        to {\n            opacity: 1\n        }\n    }\n\n    @keyframes fade {\n        from {\n            opacity: .4\n        }\n        to {\n            opacity: 1\n        }\n    }</style><div class=\"container\"><div class=\"row newFeatures\" ng-if=\"vm.appMode==\'reserve\' && vm.news && vm.news.length > 0\"><div class=\"col-md-12\" style=\"text-align: center\"><!--<div >--><!--<i class=\"material-icons\" style=\"margin-top: -10px;color: darkorange; top: 6px;--><!--position: relative;\">--><!--new_releases--><!--</i>--><div><i ng-if=\"vm.news && vm.news.length > 1\" class=\"material-icons\" style=\"margin-top: -10px;color: #2b6b7f; top: 10px;\n                    position: relative\" ng-click=\"vm.showSlides()\">autorenew </i><span class=\"news-tag\" ng-class=\"vm.getNewsTagClass()\">{{\'tikonApp.newsType.\'+vm.activeNews.newsType | translate}} </span><span style=\"font-weight: bold;line-height: 1.8\">{{vm.activeNews.title}} </span><a class=\"new-features-button\" ng-click=\"vm.openNewsUrl()\" target=\"_blank\">{{vm.activeNews.actionTitle}}</a></div><!--<a class=\"new-features-button\" ng-click=\"vm.showSlides()\" target=\"_blank\">--><!--next--><!--</a>--><!--<i class=\"fa fa-telegram fa-2x socialNetwork-TELEGRAM\" style=\"vertical-align: middle;\"></i>--><!--<span style=\"font-weight: bold;line-height: 1.8\">--><!--جهت دریافت آموزش ، بروزرسانی ها و اخبار جدید به کانال تلگرامی ما بپیوندید--><!--</span>--><!--<a class=\"new-features-button\" href=\"https://t.me/planovin_com\" target=\"_blank\">--><!--عضویت--><!--</a>--></div></div><div id=\"quickAccess\" ng-if=\"vm.appMode==\'event\'\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"quick-access-box\" ng-click=\"vm.goToEventState(\'WEBINAR\')\"><span><img style=\"width: 43px\" class=\"quickAccessIcon\" src=\"content/images/webinar.svg\"> </span><span class=\"quickAccessTitle\">ایجاد وبینار یا دوره آنلاین</span></div></div><div class=\"col-md-3\"><div class=\"quick-access-box\" ng-click=\"vm.goToEventState(\'CONFERENCE\')\"><span><img style=\"width: 50px;padding-top: 4px\" class=\"quickAccessIcon\" src=\"content/images/wconference.svg\"> </span><span class=\"quickAccessTitle\">ایجاد وب کنفرانس</span></div></div><div class=\"col-md-3\"><div class=\"quick-access-box\" ui-sref=\"supplierPanel.newCoupon\"><span><img style=\"width: 41px\" class=\"quickAccessIcon\" src=\"content/images/discount.png\"> </span><span class=\"quickAccessTitle\">ایجاد کد تخفیف</span></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"quick-access-box\" ui-sref=\"supplierPanel.reserve_v2\"><span><img class=\"quickAccessIcon\" src=\"content/images/new-register.png\"> </span><span class=\"quickAccessTitle\">ثبت نام دستی</span></div></div><div class=\"col-md-3\"><div class=\"quick-access-box\" disabled=\"disabled\"><span><img style=\"width: 40px\" class=\"quickAccessIcon\" src=\"content/images/mail.svg\"> </span><span class=\"quickAccessTitle\">ارسال خبرنامه (به زودی !)</span></div></div></div><hr></div><div id=\"dashboardTitleBar_content\"><div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-sm-2 dashboardTitleBar_col\"><div style=\"height: 102px; line-height: 102px; text-align: center\"><span translate=\"supplierPanel.sideMenu.home.reservesNumber\">reservesNumber</span></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.reservesNumber_LastWeek\">supplierPanel.sideMenu.home.reservesNumber_LastWeek</span><hr><div id=\"lastWeekReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.lastWeekReserveNumber}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.reservesNumber_LastMonth\">supplierPanel.sideMenu.home.reservesNumber_LastMonth</span><hr><div id=\"lastMonthReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.lastMonthReserveNumber}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.total\">supplierPanel.sideMenu.home.total</span><hr><div id=\"totalReservesNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.totalReservesNumber}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\" ng-if=\"vm.appMode==\'reserve\'\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.tomorrowReserveNumber\">supplierPanel.sideMenu.home.tomorrowReserveNumber</span><hr><div id=\"tomorrowReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.tomorrowPeopleCount}}<!--<span style=\"font-size: 12px\"> /  {{vm.tomorrowPeopleCount}} نفر </span>--></div></div></div><!--<div class=\"col-sm-2\">--><!--<div>--><!--<div id=\"analogClock_container\">--><!--<analog-clock></analog-clock>--><!--</div>--><!--</div>--><!--</div>--></div><hr></div><!--</div>--><!--<div class=\"container-fluid\">--><div class=\"row\" ng-if=\"vm.appMode==\'reserve\'\"><div class=\"contentSections\"><div class=\"col-sm-6\"><div class=\"bg-white-opaq tableOfReserves\"><div><div style=\"font-weight: bold;font-size: 12px; width: 100px; margin: 0px auto 9px; padding-top: 7px\"><span>{{\'tikonApp.orderBag.home.onGoingReserve\' | translate}}</span></div><md-button class=\"md-raised md-primary\" style=\"display: inline-table\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><a ui-sref=\"supplierPanel.reserve_v2\" style=\"color: white\"><span class=\"glyphicon glyphicon-plus\" style=\"top: 3px;padding-left: 3px\"></span> <span class=\"hidden-xs\">{{\'tikonApp.orderBag.home.createLabel\' | translate}}</span></a></md-button><md-button class=\"md-raised md-secondary\"><a ui-sref=\"supplierPanel.reserveList\"><i class=\"material-icons\">visibility </i><span class=\"hidden-xs\">{{\'supplierPanel.sideMenu.home.seeAllReserves\' | translate}}</span></a></md-button></div><div id=\"upcomming_clients\" class=\"rw-dashboardSection\"><table st-safe-src=\"vm.orderBagServiceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th st-sort=\"orderBagId\" style=\"min-width: 104px\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceItemTitle\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"servant.servantName\"><span translate=\"tikonApp.servant.home.title\">Servant</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a></td><td>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}<!--<div has-authority=\"ROLE_CUSTOMER_MANAGER\">--><!--{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}--><!--</div>--><!--<div>--><!--{{orderBagServiceItem.orderBag.customer.personalInfo.email}}--><!--</div>--></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div><!--</div>--></td><td><div>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}}</div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startTime\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div><div class=\"col-sm-6\" id=\"\" style=\"padding-left: 2px\"><div id=\"chart\" class=\"bg-white-opaq\"><rp-sales-count></rp-sales-count></div></div></div></div></div><script>// $(\"#upcomming_clients\").mCustomScrollbar({\n    //     theme: \"minimal\"\n    // });\n\n    setInterval(function () {\n\n        // var tableOriginalSize = parseInt($(\".tableOfReserves\").css(\"height\"));\n\n        var chartHeight_int = parseInt($(\"#chart\").css(\"height\"));\n        var chartHeight = $(\"#chart\").css(\"height\");\n        if (chartHeight_int > 200) {\n            $(\".tableOfReserves\").css(\"height\", chartHeight);\n        }\n    }, 5000);</script>");
$templateCache.put("app/dashboard/main/report.main_dashboard_v2.html","<style xmlns=\"http://www.w3.org/1999/html\">/*#page-wrapper {*/\n    /*background-image: url(\"/content/images/background/wave.jpg\");*/\n    /*background-position: bottom;*/\n    /*background-size: cover;*/\n    /*background-attachment: fixed;*/\n    /*}*/\n\n    .news-tag {\n        padding: 2px 10px;\n        margin: 0 0 0 10px;\n        font-size: 10px;\n        border-radius: 5px;\n        font-weight: bold;\n        /*border: 1px solid;*/\n    }\n\n    .news-INFO {\n        background-color: #c1dae9 !important;\n        color: #2b6b7f !important;\n    }\n\n    .news-HELP {\n        background-color: #dfcff3 !important;\n        color: purple;\n    }\n\n    .news-EXPERT_HELP {\n        background-color: #f1cff3 !important;\n        color: purple;\n    }\n\n    .news-WARNING {\n        background-color: #f7dada !important;\n        color: #d74646;\n    }\n\n    .news-SPECIAL_OFFER {\n        background-color: #f5e1a6 !important;\n        color: #cd804a;\n    }\n\n    .news-NEW_FEATURE {\n        background-color: #ddf3c4 !important;\n        color: green;\n    }\n\n\n    #dashboardTitleBar_content {\n        z-index: 2;\n        width: 100%;\n    }\n\n    .dashboardTitleBar_col {\n        padding: 0 4px;\n        text-align: center;\n        margin-bottom: 10px;\n    }\n\n\n    .dashboardTitleBar_col hr {\n        border: none;\n        width: 45%;\n        margin: 0 auto 20px;\n        background-color: whitesmoke;\n    }\n\n    .numbersInTitleBar {\n        width: 100%;\n        font-size: 32px;\n        font-weight: bold;\n    }\n\n\n    #analogClock_container {\n        left: -150px;\n        width: 118px;\n        /*margin: auto;*/\n        margin: 6px 15px;\n        position: absolute;\n    }\n\n    .container {\n        width: 100%;\n    }\n\n    .bg-white-opaq {\n        margin: 5px;\n        background-color: rgba(200, 200, 200, 0.1);\n        border-radius: 7px;\n        border: 1px solid lightgray;\n    }\n\n    /*.table {*/\n    /*width: 99%;*/\n    /*}*/\n    .table > thead > tr {\n        background-color: rgba(230, 230, 255, 0.5);\n    }\n\n    .contentSections div {\n        padding-right: 0;\n        padding-left: 0;\n    }\n\n    #footer {\n        margin-top: 0;\n    }\n\n    .tableOfReserves {\n        overflow: auto;\n    }\n\n    /*::-webkit-scrollbar {*/\n    /*width: 7px;*/\n    /*height: 7px;*/\n\n    /*}*/\n\n    /*!* Track *!*/\n    /*::-webkit-scrollbar-track {*/\n    /*background: #f1f1f1;*/\n    /*border-radius: 7px;*/\n    /*}*/\n\n    /*!* Handle *!*/\n    /*::-webkit-scrollbar-thumb {*/\n    /*background: rgba(230, 230, 230, 0.6);*/\n    /*border-radius: 7px;*/\n    /*}*/\n\n    /*!* Handle on hover *!*/\n    /*::-webkit-scrollbar-thumb:hover {*/\n    /*background: rgba(230, 230, 230, 0.2);*/\n    /*}*/\n\n\n    .pl-news-system {\n        display: flex;\n        margin: 5px;\n        width: 100%;\n        border: 1px solid #c9c9c9;\n        background-color: var(--rw-main-background-color);\n        justify-content: flex-start;\n        padding: 5px 10px;\n        gap: 10px;\n        align-items: center;\n    }\n\n    .news-system-button {\n        padding: 2px 20px;\n        background-color: var(--rw-btn-primary-color);\n        border-radius: 5px;\n\n    }\n\n    a, a:hover, a:focus {\n        color: #607d8b;\n        text-decoration: none;\n    }\n\n    @media (max-width: 991px) {\n        .tableOfReserves, .md-button.md-raised {\n            font-size: x-small;\n        }\n    }\n\n    @media (max-width: 767px) {\n\n        #analogClock_container {\n            display: none;\n        }\n\n        .pl-news-system {\n            flex-flow: column;\n        }\n\n        .news-system-button {\n            align-self: flex-end;\n            display: flex;\n        }\n\n    }\n\n    .newFeatures {\n        margin: 0px -10px;\n        padding: 15px;\n        background-color: rgb(246, 247, 255);\n        /*height: 50px;*/\n        border-radius: 5px;\n        border: 1px solid lightgray;\n        margin-bottom: 20px;\n    }\n\n    .quickAccessIcon {\n        width: 40px;\n    }\n\n    .quickAccessTitle {\n        padding-right: 10px;\n    }\n\n    .new-features-button {\n        font-weight: bold;\n        border: 1px solid;\n        padding: 1px 10px;\n        border-radius: 5px;\n        /*margin: 0 10px;*/\n    }\n\n    .new-features-button:hover {\n        box-shadow: 0px 0px 4px;\n    }\n\n    .hide-slide {\n        display: none;\n    }\n\n    .show-slide {\n        display: block;\n    }\n\n    /* Fading animation */\n    .fade {\n        -webkit-animation-name: fade;\n        -webkit-animation-duration: 0.1s;\n        animation-name: fade;\n        animation-duration: 0.1s;\n    }\n\n    @-webkit-keyframes fade {\n        from {\n            opacity: .4\n        }\n        to {\n            opacity: 1\n        }\n    }\n\n    @keyframes fade {\n        from {\n            opacity: .4\n        }\n        to {\n            opacity: 1\n        }\n    }</style><div class=\"container\"><div has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><eo-pl-general-actions class=\"visible-xs\"></eo-pl-general-actions></div><div class=\"dashboard-news-system-container pl-container\" ng-if=\"vm.activeHighPriorityNews\"><div class=\"pl-news-system pl-container\"><div class=\"news-tag pl-news-tag\" ng-class=\"vm.getNewsTagClass(vm.activeHighPriorityNews)\" style=\"margin: auto 0 auto 10px\">{{\'tikonApp.newsType.\'+vm.activeHighPriorityNews.newsType | translate}}</div><div ng-click=\"vm.openNewsUrl(vm.activeHighPriorityNews)\" style=\"font-weight: bold\">{{vm.activeHighPriorityNews.title}}</div><div class=\"news-system-button\" ng-if=\"vm.activeHighPriorityNews.actionUrl\"><a class=\"pl-priority-news-button\" ng-click=\"vm.openNewsUrl(vm.activeHighPriorityNews)\" target=\"_blank\">{{vm.activeHighPriorityNews.actionTitle}}</a></div></div></div><div ng-if=\"vm.mode == \'OnBoarding\'\" class=\"pl-container pl-wizard-step-container pl-wizard-step-welcome\"><h4 has-authority=\"ROLE_USER\" ng-if=\"vm.userProfile\"><b>{{vm.userProfile.personInfo.fullName}}</b> عزیز ،به پلنوین خوش آمدید !</h4><div class=\"pl-welcome-contact-us\">در صورت نیاز به مشاوره یا انجام راه‌اندازی کامل توسط تیم پشتیبانی پلنوین با شماره 02191690817 تماس بگیرید.</div><div class=\"pl-welcome-support-msg\"><div class=\"pl-my-site pl-welcome-button pl-btn-auto\" style=\"max-width: unset;margin: auto 0\" ng-click=\"vm.sendMsgToSupport()\"><md-icon style=\"color: black\">chat</md-icon><div class=\"\">درخواست راهنمایی از پشتیبانی</div></div><div class=\"visible-xs\"><div class=\"pl-my-site pl-welcome-button\" ng-click=\"vm.callSupport()\"><md-icon style=\"color: black\">call</md-icon><div class=\"\">تماس با پشتیبانی</div></div></div></div></div><div ng-if=\"vm.mode == \'FreeUser\' && vm.isNativeApp != \'true\'\" has-authority=\"ROLE_USER\" class=\"pl-container free-user-alert-container\"><div class=\"pl-welcome-contact-us\">شما از اشتراک 14 روزه رایگان استفاده می‌کنید!</div><div><div class=\"pl-my-site pl-welcome-button\" ui-sref=\"supplierPanel-v2.companySubscriptionStatusV2\" style=\"min-width: 8rem\"><md-icon style=\"color: var(--rw-secondary-color)\">shopping_cart</md-icon><div class=\"\">ارتقا</div></div></div></div><div ng-if=\"vm.mode == \'OnBoarding\'\" class=\"pl-container pl-wizard-step-container\"><div><h4 style=\"font-weight: bold\"><span>برای شروع، ابتدا باید تنظیمات اولیه را انجام دهید. </span><span class=\"do-it-later\" ng-click=\"vm.skipWizard()\">بعدا انجام میدم ></span></h4></div><div class=\"row\" style=\"padding-right: 10px\"><div class=\"step-item col-md-6\" ng-repeat=\"step in vm.wizardSteps track by step.id\" ng-click=\"vm.onStepClick(step)\"><span class=\"step-item-number\" ng-if=\"step.status!=\'DONE\'\" ng-class=\"vm.getStepNumberClass(step)\">{{step.id}}</span> <span ng-if=\"step.status==\'DONE\'\"><md-icon style=\"color: green\">check</md-icon></span><span class=\"step-item-text\" ng-class=\"vm.getStepTextClass(step)\">{{step.title}}</span></div></div></div><div id=\"dashboardTitleBar_content\" class=\"pl-container\"><div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-sm-2\"><div class=\"dashboard-reserve-stat-title\"><span translate=\"supplierPanel.sideMenu.home.reservesNumber\">reservesNumber</span></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><div class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.reservesNumber_LastWeek\">supplierPanel.sideMenu.home.reservesNumber_LastWeek</div><div id=\"lastWeekReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.lastWeekReserveNumber}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><div class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.reservesNumber_LastMonth\">supplierPanel.sideMenu.home.reservesNumber_LastMonth</div><div id=\"lastMonthReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.lastMonthReserveNumber}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><div class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.total\">supplierPanel.sideMenu.home.total</div><div id=\"totalReservesNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.totalReservesNumber}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\" ng-if=\"vm.appMode==\'reserve\'\"><div><div class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.home.tomorrowReserveNumber\">supplierPanel.sideMenu.home.tomorrowReserveNumber</div><div id=\"tomorrowReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.tomorrowPeopleCount}}<!--<span style=\"font-size: 12px\"> /  {{vm.tomorrowPeopleCount}} نفر </span>--></div></div></div><!--<div class=\"col-sm-2\">--><!--<div>--><!--<div id=\"analogClock_container\">--><!--<analog-clock></analog-clock>--><!--</div>--><!--</div>--><!--</div>--></div></div><!--</div>--><!--<div class=\"container-fluid\">--><div class=\"row pl-container visible-xs\" ng-if=\"vm.orderBagServiceItems && vm.orderBagServiceItems.length \"><div class=\"contentSections\"><div class=\"col-sm-6\"><div class=\"tableOfReserves\"><div><div class=\"dashboard-reserve-stat-title\"><span>{{\'tikonApp.orderBag.home.onGoingReserve\' | translate}}</span> <a class=\"pl-news-button\" style=\"font-size: 12px; font-weight: normal;padding-right: 10px\" ui-sref=\"supplierPanel-v2.reserveList\">مشاهده همه</a></div></div><div id=\"pl-upcoming_clients\" class=\"rw-dashboardSection\" ng-if=\"vm.orderBagServiceItems && vm.orderBagServiceItems.length\"><div class=\"reserve-list-item\" ng-repeat=\"orderBagServiceItem in vm.orderBagServiceItems track by orderBagServiceItem.id\" ng-click=\"vm.editReserve(orderBagServiceItem)\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"service-color-line\"></div><div class=\"reserve-list-item-detail\"><div><div class=\"reserve-list-icons\"><div class=\"\" style=\"font-weight: bold;font-size: 12px\">{{orderBagServiceItem.orderBag.id}}</div><div class=\"service-list-icons-video\" style=\"align-items: initial\"><span ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\" class=\"glyphicon glyphicon-stop\"></span> <span style=\"font-size: 12px;font-weight: bold\">{{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</span></div></div></div><div class=\"\" name=\"customerInfo\"><div class=\"reserve-list-customer-info\"><div><md-icon class=\"pl-icon\">person</md-icon>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</div><!--<div class=\"reserve-list-customer-contacts\" has-authority=\"ROLE_CUSTOMER_MANAGER\">--><!--&lt;!&ndash;<i class=\"fa fa-phone\"></i>&ndash;&gt;--><!--&lt;!&ndash;<div>{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div>&ndash;&gt;--><!--&lt;!&ndash;<div>{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div>&ndash;&gt;--><!--</div>--></div></div><div class=\"\" name=\"dateTimeInfo\"><div style=\"display: flex;gap:10px\"><div class=\"\" style=\"font-weight: bold\"><md-icon class=\"pl-icon\">event</md-icon><span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianDate}} - </span>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}} <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\"><!--<div>--><!--{{vm.getMonthCount(orderBagServiceItem)}}--><!--(ماه)--><!--</div>--></span></div><div class=\"\" style=\"font-weight: bold\" ng-if=\"orderBagServiceItem.serviceTimeSession.startDate == orderBagServiceItem.serviceTimeSession.endDate\"><md-icon class=\"pl-icon\">schedule</md-icon>{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></div></div><div class=\"\" name=\"serviceInfo\" style=\"display: flex\"><div><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: black\">videocam</md-icon></div><div class=\"\" style=\"padding-right: 5px\">{{orderBagServiceItem.serviceItem.itemTitle}}</div><div class=\"\" ng-if=\"orderBagServiceItem.servant\" style=\"padding-right: 24px;  font-size: 12px\">{{orderBagServiceItem.servant.servantName}}</div><!--<div class=\"orderBag-mobile-float\">--><!--{{orderBagServiceItem.orderBag.finalPrice | number}}--><!--<span translate=\"global.currency\"></span>--><!--</div>--></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div></div></div><div class=\"row pl-container hidden-xs\" ng-if=\"vm.orderBagServiceItems && vm.orderBagServiceItems.length \"><div class=\"contentSections\"><div class=\"tableOfReserves\"><div><div class=\"dashboard-reserve-stat-title\"><span>{{\'tikonApp.orderBag.home.onGoingReserve\' | translate}}</span> <a class=\"pl-news-button\" style=\"font-size: 12px; font-weight: normal;padding-right: 10px\" ui-sref=\"supplierPanel-v2.reserveList\">مشاهده همه</a></div></div><div id=\"pl-upcoming_clients-desktop\" class=\"rw-dashboardSection\" ng-if=\"vm.orderBagServiceItems && vm.orderBagServiceItems.length\"><div style=\"overflow-x: auto\"><table st-safe-src=\"vm.orderBagServiceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr class=\"pl-table-header\"><th st-sort=\"orderBagId\" style=\"min-width: 104px\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"serviceItemTitle\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.orderBag.status.title\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><a ng-click=\"vm.editReserve(orderBagServiceItem)\">{{orderBagServiceItem.orderBag.id}}</a><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.startVideoCall\' | translate}}</md-tooltip><a><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a></div></td><td style=\"padding: 0\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"serviceColorCircle\"></div></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div><!--</div>--></td><td><div><span>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</span></div><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></td><td ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</td><td>{{orderBagServiceItem.orderBag.finalPrice | number}}<div ng-if=\"orderBagServiceItem.orderBag.finalPrice\"><div class=\"check-out-ok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount==0.0\">{{\'tikonApp.orderBag.CheckOut-Ok\' | translate }}</div><div class=\"check-out-nok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount > 0\">{{\'tikonApp.orderBag.CheckOut-NOk\' | translate }}</div></div></td><td><div>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}}</div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startTime\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editReserve(orderBagServiceItem)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div></div></div></div></div><div class=\"dashboard-news-container pl-container\" ng-if=\"vm.news && vm.news.length > 0\"><div class=\"pl-news-item pl-container col-sm-6\" ng-repeat=\"news in vm.news track by news.id\"><div class=\"news-tag pl-news-tag\" ng-class=\"vm.getNewsTagClass(news)\">{{\'tikonApp.newsType.\'+news.newsType | translate}}</div><div ng-click=\"vm.openNewsUrl(news)\" style=\"font-weight: bold;line-height: 1.8\">{{news.title}}</div><a class=\"pl-news-button\" ng-click=\"vm.openNewsUrl(news)\" target=\"_blank\">{{news.actionTitle}}</a></div></div></div><script>// $(\"#upcomming_clients\").mCustomScrollbar({\n    //     theme: \"minimal\"\n    // });\n\n    setInterval(function () {\n\n        // var tableOriginalSize = parseInt($(\".tableOfReserves\").css(\"height\"));\n\n        var chartHeight_int = parseInt($(\"#chart\").css(\"height\"));\n        var chartHeight = $(\"#chart\").css(\"height\");\n        if (chartHeight_int > 200) {\n            $(\".tableOfReserves\").css(\"height\", chartHeight);\n        }\n    }, 5000);</script>");
$templateCache.put("app/dashboard/sales_report/report.sales_count.template.html","<!--<div style=\"width: 700px;height: 500px;\" >--><div class=\"row\"><div class=\"col-sm-12\"><!--گزارش تعداد رزرو های انجام شده--><canvas style=\"padding: 0 14px 0 4px\" id=\"\" class=\"chart chart-bar\" chart-data=\"$ctrl.data\" chart-labels=\"$ctrl.labels\" chart-series=\"$ctrl.series\" chart-options=\"$ctrl.options\" chart-dataset-override=\"$ctrl.datasetOverride\" chart-click=\"$ctrl.onClick\"></canvas></div></div><!--</div>-->");
$templateCache.put("app/dashboard/setting/setting-v2.html","<div class=\"hidden-xs\"><div class=\"setting-container\"><div id=\"mainSetting\" class=\"\"><div class=\"setting-section-header\">تنظیمات کسب و کار</div><div class=\"pl-container-flex setting-box-container\"><ul><li ui-sref=\"supplierPanel-v2.companyInfo\"><span><md-icon>store</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.general-v2\">generalCompanyInfo</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyWorkingTimes\"><span><md-icon>event</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.companyWorkingTimes\">companyWorkingTimes </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyLocationInfo\"><span><md-icon>map</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.location\">companyLocation </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companySocialNetworkInfo\"><span><md-icon>public</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo\">companySocialNetworkInfo </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'themeSettingTab\')\"><span><md-icon>dashboard_customize</md-icon><span translate=\"tikonApp.settingInfo.sections.themeSettingTab-v2\">tikonApp.settingInfo.sections.themeSettingTab </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'notificationSettingTab\')\"><span><md-icon>notifications</md-icon><span translate=\"tikonApp.settingInfo.sections.notificationSettingTab\">tikonApp.settingInfo.sections.notificationSettingTab </span><span style=\"font-size: 14px\">( {{\"tikonApp.settingInfo.sections.smsEmail\" | translate}} ) </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div></div><div id=\"other\" class=\"\"><div class=\"setting-section-header\">مالی</div><div class=\"pl-container-flex setting-box-container\"><ul><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'financialSettingTab\')\"><span><md-icon>payments</md-icon><span translate=\"tikonApp.settingInfo.sections.financialSettingTab\">tikonApp.settingInfo.sections.financialSettingTab </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyBankAccountInfoV2\"><span><md-icon>account_balance</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.companyBankAccountInfo\">companyBankAccountInfo</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div><div class=\"setting-section-header\">سایر</div><div class=\"pl-container-flex setting-box-container\"><ul><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'videoCallSettingTab\')\"><span><md-icon>videocam</md-icon><span translate=\"tikonApp.settingInfo.sections.videoCallSettingTab\">videoCallSettingTab </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyCustomSetting\"><span><md-icon>settings</md-icon><span>تنظیمات سامانه</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.metaTags\"><span><md-icon>local_offer</md-icon><span>تگ ها</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyBlogs\"><span><md-icon>local_offer</md-icon><span>بلاگ ها</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div></div><div id=\"specialFeature\" class=\"\"><div class=\"setting-section-header\">امکانات ویژه</div><div class=\"pl-container-flex setting-box-container\"><ul><li ui-sref=\"supplierPanel-v2.coupons\"><span><md-icon>redeem</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.coupon\">coupon</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.reserveLimits\"><span><md-icon>lock</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.reserveLimit\">reserveLimit</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.serviceAddOnList\"><span><md-icon>star</md-icon><span>خدمات ویژه</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.marketingCampaignList\"><span><md-icon>forum</md-icon><span>الگوهای ارسال پیامک</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.smsPanelMarketingCampaignList\"><span><md-icon>forum</md-icon><span>ارسال پیامک</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.commissionList\"><span><md-icon>attach_money</md-icon><span>کمیسیون پرسنل</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div></div></div></div><div class=\"setting-container visible-xs\"><div class=\"setting-section-header\">تنظیمات کسب و کار</div><div class=\"pl-container-flex user-profile-mobile-container\"><ul><li ui-sref=\"supplierPanel-v2.companyInfo\"><span><md-icon>store</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.general-v2\">generalCompanyInfo</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyWorkingTimes\"><span><md-icon>event</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.companyWorkingTimes\">companyWorkingTimes </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyLocationInfo\"><span><md-icon>map</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.location\">companyLocation </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companySocialNetworkInfo\"><span><md-icon>public</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo\">companySocialNetworkInfo </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'themeSettingTab\')\"><span><md-icon>dashboard_customize</md-icon><span translate=\"tikonApp.settingInfo.sections.themeSettingTab-v2\">tikonApp.settingInfo.sections.themeSettingTab </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'notificationSettingTab\')\"><span><md-icon>notifications</md-icon><span translate=\"tikonApp.settingInfo.sections.notificationSettingTab\">tikonApp.settingInfo.sections.notificationSettingTab </span><span style=\"font-size: 14px\">( {{\"tikonApp.settingInfo.sections.smsEmail\" | translate}} ) </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div><div class=\"setting-section-header\">مالی</div><div class=\"pl-container-flex user-profile-mobile-container\"><ul><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'financialSettingTab\')\"><span><md-icon>payments</md-icon><span translate=\"tikonApp.settingInfo.sections.financialSettingTab\">tikonApp.settingInfo.sections.financialSettingTab </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyBankAccountInfoV2\"><span><md-icon>account_balance</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.companyBankAccountInfo\">companyBankAccountInfo</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div><div class=\"setting-section-header\">سایر</div><div class=\"pl-container-flex user-profile-mobile-container\"><ul><li ui-sref=\"supplierPanel-v2.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'videoCallSettingTab\')\"><span><md-icon>videocam</md-icon><span translate=\"tikonApp.settingInfo.sections.videoCallSettingTab\">videoCallSettingTab </span></span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyCustomSetting\"><span><md-icon>settings</md-icon><span>تنظیمات سامانه</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.metaTags\"><span><md-icon>local_offer</md-icon><span>تگ ها</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyBlogs\"><span><md-icon>local_offer</md-icon><span>بلاگ ها</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><!--<li ui-sref=\"supplierPanel-v2.patternInfoList\">--><!--<span>--><!--<md-icon>history</md-icon>--><!--<span translate=\"supplierPanel.sideMenu.companyInfo.patternInfo\">patternInfo</span></a>--><!--</span>--><!--<span>--><!--<md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black;\" class=\"material-icons\">chevron_left</md-icon>--><!--</span>--><!--</li>--></ul></div><div class=\"setting-section-header\">امکانات ویژه</div><div class=\"pl-container-flex user-profile-mobile-container\"><ul><li ui-sref=\"supplierPanel-v2.couponList\"><span><md-icon>redeem</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.coupon\">coupon</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.reserveLimits\"><span><md-icon>lock</md-icon><span translate=\"supplierPanel.sideMenu.companyInfo.reserveLimit\">reserveLimit</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.serviceAddOnList\"><span><md-icon>star</md-icon><span>خدمات ویژه</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.marketingCampaignList\"><span><md-icon>forum</md-icon><span>الگوهای ارسال پیامک</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.smsPanelMarketingCampaignList\"><span><md-icon>forum</md-icon><span>ارسال پیامک</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.commissionList\"><span><md-icon>attach_money</md-icon><span>کمیسیون پرسنل</span> </span><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><!--<li ui-sref=\"supplierPanel-v2.patternInfoList\">--><!--<span>--><!--<md-icon>history</md-icon>--><!--<span translate=\"supplierPanel.sideMenu.companyInfo.patternInfo\">patternInfo</span></a>--><!--</span>--><!--<span>--><!--<md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black;\" class=\"material-icons\">chevron_left</md-icon>--><!--</span>--><!--</li>--></ul></div></div>");
$templateCache.put("app/dashboard/setting/setting.html","<div class=\"row rw-Container\"><div class=\"col-md-2\"></div><div class=\"col-md-4 rw-divSection\"><h3>{{\'tikonApp.settingInfo.division.generalSettings\' | translate}}</h3><a ui-sref=\"supplierPanel.companyInfo\"><i class=\"fa fa-info fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.general\">generalCompanyInfo</span></a> <a ui-sref=\"supplierPanel.companyWorkingTimes\"><i class=\"fa fa-calendar fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.companyWorkingTimes\">companyWorkingTimes </span></a><a ui-sref=\"supplierPanel.companyLocationInfo\"><i class=\"fa fa-map-marker fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.location\">companyLocation </span></a><a ui-sref=\"supplierPanel.companySocialNetworkInfo\"><i class=\"fa fa-globe fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo\">companySocialNetworkInfo </span></a><a ui-sref=\"supplierPanel.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'themeSettingTab\')\"><i class=\"fa fa-puzzle-piece fa-fw\" style=\"padding-left: 3px\"></i> <span translate=\"tikonApp.settingInfo.sections.themeSettingTab\">tikonApp.settingInfo.sections.themeSettingTab </span></a><a ui-sref=\"supplierPanel.companyCustomSetting\"><i class=\"fa fa-cog fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.setting\">setting</span></a><!--<a ui-sref=\"supplierPanel.resources\"><i class=\"fa fa-lightbulb-o fa-fw\"></i>                    this option is temporarily commented--><!--<span translate=\"supplierPanel.sideMenu.companyInfo.resourcesListForm\">resourcesListForm </span></a>--></div><div class=\"col-md-4 rw-divSection\"><h3>{{\'tikonApp.settingInfo.division.specialSettings\' | translate}}</h3><!--this part has sections which will be shown separately--> <a ui-sref=\"supplierPanel.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'notificationSettingTab\')\"><i class=\"fa fa-exclamation-circle fa-fw\"></i> <span translate=\"tikonApp.settingInfo.sections.notificationSettingTab\">tikonApp.settingInfo.sections.notificationSettingTab </span>({{\"tikonApp.settingInfo.sections.smsEmail\" | translate}})</a> <a ui-sref=\"supplierPanel.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'financialSettingTab\')\"><i class=\"fa fa-money fa-fw\"></i> <span translate=\"tikonApp.settingInfo.sections.financialSettingTab\">tikonApp.settingInfo.sections.financialSettingTab </span></a><!--this part has sections which will be shown separately--> <a ui-sref=\"supplierPanel.companyBankAccountInfo\"><i class=\"fa fa-credit-card fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.companyBankAccountInfo\">companyBankAccountInfo</span></a> <a ui-sref=\"supplierPanel.coupons\"><i class=\"fa fa-percent fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.coupon\">coupon</span></a> <a ng-if=\"vm.__config.appMode == \'reserve\'\" ui-sref=\"supplierPanel.patternInfoList\"><i class=\"fa fa-calendar-check-o fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.patternInfo\">patternInfo</span></a> <a ng-if=\"vm.__config.appMode == \'reserve\'\" ui-sref=\"supplierPanel.reserveLimitList\"><i class=\"fa fa-user-times fa-fw\"></i> <span translate=\"supplierPanel.sideMenu.companyInfo.reserveLimit\">reserveLimit</span></a> <a ui-sref=\"supplierPanel.companySettingInfo({settingFormSection:{{\'vm.settingFormSection\'}}})\" ng-click=\"vm.setFormSection(\'videoCallSettingTab\')\"><i class=\"fa fa-video-camera fa-fw\" style=\"padding-left: 3px\"></i> <span translate=\"tikonApp.settingInfo.sections.videoCallSettingTab\">videoCallSettingTab</span></a></div><div class=\"col-md-2\"></div></div>");
$templateCache.put("app/entities/account-clearing-request/account-clearing-request-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.accountClearingRequest.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.accountClearingRequest.delete.question\" translate-values=\"{id: \'{{vm.accountClearingRequest.id}}\'}\">Are you sure you want to delete this Account Clearing Request?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/account-clearing-request/account-clearing-request-detail-v2.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }\n\n    .content-style {\n        font-weight: bold;\n    }</style><div class=\"pl-form-container\"><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 category-list-title\" style=\"display: flex\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.accountClearingRequest.detail.title\">title-list</h3><div style=\"display: flex\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.accountClearingList\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon><span>بازگشت</span></md-button></div></div></div></div></div><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><md-content class=\"\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.accountClearingRequest.payedToInfo\"></span> <span translate=\"tikonApp.accountClearingRequest.accountClearingRequestId\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.id}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.createDate\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.createDate | toPersianTime}} - {{vm.accountClearingRequest.createDate | toPersianDate}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.totalPaymentAmount | number }} <span ng-if=\"vm.accountClearingRequest.totalPaymentAmount \" translate=\"global.currency\"></span></span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.status\"></span> <span class=\"content-style\">: <span ng-class=\"vm.findStatusStyle(vm.accountClearingRequest.status)\"><span translate=\"{{\'tikonApp.accountClearingRequest.Statuses.\' + vm.accountClearingRequest.status}}\">{{vm.accountClearingRequest.status}}</span> <span ng-class=\"vm.findStatusIcon(vm.accountClearingRequest.status)\"></span></span></span></div></div><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToSupplierDate\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToSupplierDate | toPersianDate}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToSupplierAmount\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToSupplierAmount | number }} <span ng-if=\"vm.accountClearingRequest.payedToSupplierAmount \" translate=\"global.currency\"></span></span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToSupplierWageAmount\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToSupplierWageAmount | number }} <span ng-if=\"vm.accountClearingRequest.payedToSupplierWageAmount \" translate=\"global.currency\"></span></span></div></div><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToBankName\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToBankName}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToBankAccountOwnerName\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToBankAccountOwnerName}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToTraceCode\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToTraceCode}}</span></div></div><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-6\"><span translate=\"tikonApp.accountClearingRequest.payedToBankAccountNumber\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToBankAccountNumber}}</span></div><div class=\"col-md-6\" ng-if=\"vm.accountClearingRequest.description\"><span translate=\"tikonApp.accountClearingRequest.description\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.description}}</span></div></div></div></div></div><br><h3 translate=\"tikonApp.companyPaymentLog.transactionDtails\"></h3><div class=\"table-responsive\"><table st-safe-src=\"vm.companyPaymentLogs\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>مشتری</span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.paymentLog.onlineGateway\">onlineGateway</span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.paymentLog.traceCode\">trace Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in collection track by companyPaymentLog.id\"><td>{{companyPaymentLog.orderBag.id}}</td><td><span data-ng-if=\"companyPaymentLog.orderBag.customer && companyPaymentLog.orderBag.customer.personalInfo\">{{companyPaymentLog.orderBag.customer.personalInfo.fisrtName+\" \"+companyPaymentLog.orderBag.customer.personalInfo.lastName}}<p style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.orderBag.customer.personalInfo.phoneNumber}}</p></span></td><td>{{companyPaymentLog.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{companyPaymentLog.paymentAmount | number}}</strong></td><td><div class=\"row\" ng-if=\"companyPaymentLog.paymentLog &&  companyPaymentLog.paymentLog.onlineGateway\"><div class=\"col-sm-4\" ng-class=\"companyPaymentLog.paymentLog.onlineGateway\"></div><div class=\"col-sm-8\" style=\"line-height: 2\">{{\'tikonApp.bankAccountInfo.onlinePaymentGateway.\'+ companyPaymentLog.paymentLog.onlineGateway | translate}}</div></div></td><td><span ng-if=\"companyPaymentLog.paymentLog\">{{companyPaymentLog.paymentLog.traceCode }}</span></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div><!--<div>--><!--<h2><span translate=\"tikonApp.accountClearingRequest.detail.title\">Account Clearing Request</span> {{vm.accountClearingRequest.id}}</h2>--><!--<hr>--><!--<jhi-alert-error></jhi-alert-error>--><!--<dl class=\"dl-horizontal jh-entity-details\">--><!--<dt><span translate=\"tikonApp.accountClearingRequest.createDate\">Create Date</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.createDate | date:\'medium\'}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.fromDate\">From Date</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.fromDate | date:\'medium\'}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.toDate\">To Date</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.toDate | date:\'medium\'}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\">Total Payment Amount</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.totalPaymentAmount}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.totalWageFeeAmount\">Total Wage Fee Amount</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.totalWageFeeAmount}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.status\">Status</span></dt>--><!--<dd>--><!--<span translate=\"{{\'tikonApp.AccountClearingRequestStatus.\' + vm.accountClearingRequest.status}}\">{{vm.accountClearingRequest.status}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.description\">Description</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.description}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.company\">Company</span></dt>--><!--<dd>--><!--<a ui-sref=\"company-detail({id:vm.accountClearingRequest.companyId})\">{{vm.accountClearingRequest.companyId}}</a>--><!--</dd>--><!--</dl>--><!--<button type=\"submit\"--><!--onclick=\"window.history.back()\"--><!--class=\"btn btn-info\">--><!--<span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span>--><!--</button>--> <!--</div>-->");
$templateCache.put("app/entities/account-clearing-request/account-clearing-request-detail.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }\n\n    .content-style {\n        font-weight: bold;\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.accountClearingRequest.detail.title\">title</div><div class=\"panel-body\"><div class=\"container-fluid\"><br><md-button class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.accountClearingList\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.accountClearingList\">accountClearingList</span></md-button><md-content class=\"rwMdContent\"><br><br><div class=\"panel panel-default\" style=\"margin-top: -20px\"><div class=\"panel-heading\"><span translate=\"tikonApp.accountClearingRequest.payedToInfo\"></span> <span translate=\"tikonApp.accountClearingRequest.accountClearingRequestId\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.id}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.createDate\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.createDate | toPersianTime}} - {{vm.accountClearingRequest.createDate | toPersianDate}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.totalPaymentAmount | number }} <span ng-if=\"vm.accountClearingRequest.totalPaymentAmount \" translate=\"global.currency\"></span></span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.status\"></span> <span class=\"content-style\">: <span ng-class=\"vm.findStatusStyle(vm.accountClearingRequest.status)\"><span translate=\"{{\'tikonApp.accountClearingRequest.Statuses.\' + vm.accountClearingRequest.status}}\">{{vm.accountClearingRequest.status}}</span> <span ng-class=\"vm.findStatusIcon(vm.accountClearingRequest.status)\"></span></span></span></div></div><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToSupplierDate\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToSupplierDate | toPersianDate}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToSupplierAmount\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToSupplierAmount | number }} <span ng-if=\"vm.accountClearingRequest.payedToSupplierAmount \" translate=\"global.currency\"></span></span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToSupplierWageAmount\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToSupplierWageAmount | number }} <span ng-if=\"vm.accountClearingRequest.payedToSupplierWageAmount \" translate=\"global.currency\"></span></span></div></div><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToBankName\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToBankName}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToBankAccountOwnerName\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToBankAccountOwnerName}}</span></div><div class=\"col-md-4\"><span translate=\"tikonApp.accountClearingRequest.payedToTraceCode\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToTraceCode}}</span></div></div><div class=\"row\" style=\"padding-bottom: 10px\"><div class=\"col-md-6\"><span translate=\"tikonApp.accountClearingRequest.payedToBankAccountNumber\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.payedToBankAccountNumber}}</span></div><div class=\"col-md-6\" ng-if=\"vm.accountClearingRequest.description\"><span translate=\"tikonApp.accountClearingRequest.description\"></span> <span class=\"content-style\">: {{vm.accountClearingRequest.description}}</span></div></div></div></div></div><br><h3 translate=\"tikonApp.companyPaymentLog.transactionDtails\"></h3><div class=\"table-responsive\"><table st-safe-src=\"vm.companyPaymentLogs\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>مشتری</span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.paymentLog.onlineGateway\">onlineGateway</span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.paymentLog.traceCode\">trace Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in collection track by companyPaymentLog.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:companyPaymentLog.orderBag.id})\">{{companyPaymentLog.orderBag.id}}</a></td><td><span data-ng-if=\"companyPaymentLog.orderBag.customer && companyPaymentLog.orderBag.customer.personalInfo\">{{companyPaymentLog.orderBag.customer.personalInfo.fisrtName+\" \"+companyPaymentLog.orderBag.customer.personalInfo.lastName}}<p style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.orderBag.customer.personalInfo.phoneNumber}}</p></span></td><td>{{companyPaymentLog.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{companyPaymentLog.paymentAmount | number}}</strong></td><td><div class=\"row\" ng-if=\"companyPaymentLog.paymentLog &&  companyPaymentLog.paymentLog.onlineGateway\"><div class=\"col-sm-4\" ng-class=\"companyPaymentLog.paymentLog.onlineGateway\"></div><div class=\"col-sm-8\" style=\"line-height: 2\">{{\'tikonApp.bankAccountInfo.onlinePaymentGateway.\'+ companyPaymentLog.paymentLog.onlineGateway | translate}}</div></div></td><td><span ng-if=\"companyPaymentLog.paymentLog\">{{companyPaymentLog.paymentLog.traceCode }}</span></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div><!--<div>--><!--<h2><span translate=\"tikonApp.accountClearingRequest.detail.title\">Account Clearing Request</span> {{vm.accountClearingRequest.id}}</h2>--><!--<hr>--><!--<jhi-alert-error></jhi-alert-error>--><!--<dl class=\"dl-horizontal jh-entity-details\">--><!--<dt><span translate=\"tikonApp.accountClearingRequest.createDate\">Create Date</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.createDate | date:\'medium\'}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.fromDate\">From Date</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.fromDate | date:\'medium\'}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.toDate\">To Date</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.toDate | date:\'medium\'}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\">Total Payment Amount</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.totalPaymentAmount}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.totalWageFeeAmount\">Total Wage Fee Amount</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.totalWageFeeAmount}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.status\">Status</span></dt>--><!--<dd>--><!--<span translate=\"{{\'tikonApp.AccountClearingRequestStatus.\' + vm.accountClearingRequest.status}}\">{{vm.accountClearingRequest.status}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.description\">Description</span></dt>--><!--<dd>--><!--<span>{{vm.accountClearingRequest.description}}</span>--><!--</dd>--><!--<dt><span translate=\"tikonApp.accountClearingRequest.company\">Company</span></dt>--><!--<dd>--><!--<a ui-sref=\"company-detail({id:vm.accountClearingRequest.companyId})\">{{vm.accountClearingRequest.companyId}}</a>--><!--</dd>--><!--</dl>--><!--<button type=\"submit\"--><!--onclick=\"window.history.back()\"--><!--class=\"btn btn-info\">--><!--<span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span>--><!--</button>--> <!--</div>-->");
$templateCache.put("app/entities/account-clearing-request/account-clearing-request-dialog.html","<!--<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\">--><!--<div class=\"modal-header\">--><!--<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"--><!--ng-click=\"vm.clear()\">&times;</button>--><!--<h4 class=\"modal-title\" id=\"myAccountClearingRequestLabel\" translate=\"tikonApp.accountClearingRequest.home.createOrEditLabel\">Create or edit a Account Clearing Request</h4>--><!--</div>--><!--<div class=\"modal-body\">--><!--<jhi-alert-error></jhi-alert-error>--><!--<div class=\"form-group\" ng-show=\"vm.accountClearingRequest.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"vm.accountClearingRequest.id\" readonly />--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.createDate\" for=\"field_createDate\">Create Date</label>--><!--<div class=\"input-group\">--><!--<input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.accountClearingRequest.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"--><!--/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.fromDate\" for=\"field_fromDate\">From Date</label>--><!--<div class=\"input-group\">--><!--<input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.accountClearingRequest.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\"--><!--/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.toDate\" for=\"field_toDate\">To Date</label>--><!--<div class=\"input-group\">--><!--<input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.accountClearingRequest.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\"--><!--/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\" for=\"field_totalPaymentAmount\">Total Payment Amount</label>--><!--<input type=\"number\" class=\"form-control\" name=\"totalPaymentAmount\" id=\"field_totalPaymentAmount\"--><!--ng-model=\"vm.accountClearingRequest.totalPaymentAmount\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.totalWageFeeAmount\" for=\"field_totalWageFeeAmount\">Total Wage Fee Amount</label>--><!--<input type=\"number\" class=\"form-control\" name=\"totalWageFeeAmount\" id=\"field_totalWageFeeAmount\"--><!--ng-model=\"vm.accountClearingRequest.totalWageFeeAmount\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.status\" for=\"field_status\">Status</label>--><!--<select class=\"form-control\" name=\"status\" ng-model=\"vm.accountClearingRequest.status\" id=\"field_status\">--><!--<option value=\"REQUESTED\" translate=\"tikonApp.AccountClearingRequestStatus.REQUESTED\">REQUESTED</option>--><!--<option value=\"UNDERWAY\" translate=\"tikonApp.AccountClearingRequestStatus.UNDERWAY\">UNDERWAY</option>--><!--<option value=\"DONE\" translate=\"tikonApp.AccountClearingRequestStatus.DONE\">DONE</option>--><!--<option value=\"CANCELED\" translate=\"tikonApp.AccountClearingRequestStatus.CANCELED\">CANCELED</option>--><!--<option value=\"FAILED\" translate=\"tikonApp.AccountClearingRequestStatus.FAILED\">FAILED</option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.accountClearingRequest.description\" for=\"field_description\">Description</label>--><!--<input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\"--><!--ng-model=\"vm.accountClearingRequest.description\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.accountClearingRequest.company\" for=\"field_company\">Company</label>--><!--<select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.accountClearingRequest.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class=\"modal-footer\">--><!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>--><!--</button>--><!--<button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">--><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>--><!--</button>--><!--</div>--> <!--</form>-->");
$templateCache.put("app/entities/account-clearing-request/account-clearing-requests-v2.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }</style><div class=\"pl-form-container\"><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 category-list-title\" style=\"display: flex\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.accountClearingRequest.home.title\">title-list</h3><div style=\"display: flex\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.companyPaymentLogList\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon><span class=\"\">بازگشت</span></md-button></div></div></div><div class=\"pl-container-fluid\"><div class=\"table-responsive\"><table st-safe-src=\"vm.accountClearingRequests\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.accountClearingRequest.accountClearingRequestId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.accountClearingRequest.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"totalPaymentAmount\"><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\">totalPaymentAmount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.accountClearingRequest.status\">status</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"accountClearingRequest in collection track by accountClearingRequest.id\"><td><a ui-sref=\"supplierPanel-v2.accountClearingDetail({id:accountClearingRequest.id})\">{{accountClearingRequest.id}}</a></td><td>{{accountClearingRequest.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{accountClearingRequest.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{accountClearingRequest.totalPaymentAmount | number}}</strong></td><td ng-class=\"vm.findStatusStyle(accountClearingRequest.status)\"><span ng-class=\"vm.findStatusIcon(accountClearingRequest.status)\"></span> <span translate=\"{{\'tikonApp.accountClearingRequest.Statuses.\' + accountClearingRequest.status}}\">{{accountClearingRequest.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel-v2.accountClearingDetail({id:accountClearingRequest.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.viewDetail\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div><!--<div class=\"panel panel-default\">--><!--<div class=\"panel-heading\" translate=\"tikonApp.accountClearingRequest.home.title\">--><!--accountClearingRequest--><!--</div>--><!--<div class=\"panel-body\">--><!--<div class=\"container-fluid\">--><!--&lt;!&ndash;<h2 translate=\"tikonApp.companyPaymentLog.home.title\">Company Payment Logs</h2>&ndash;&gt;--><!--<jhi-alert></jhi-alert>--><!--</md-button>--><!--<md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0;\" ui-sref=\"supplierPanel.companyPaymentLogList\">--><!--<i class=\"fa fa-undo\" aria-hidden=\"true\"></i>--><!--<span class=\"hidden-xs\" translate=\"tikonApp.companyPaymentLog.buttons.companyRemaindNotPaid\">--><!--tikonApp.buttons.companyRemaindNotPaid--><!--</span>--><!--</md-button>--><!--<md-content class=\"rwMdContent\">--><!--<div class=\"table-responsive\">--><!--<table st-safe-src=\"vm.accountClearingRequests\" st-table=\"collection\" st-safe- --><!--class=\"jh-table table rwTable\">--><!--<thead>--><!--<tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\">--><!--<th st-sort=\"id\"><span translate=\"tikonApp.accountClearingRequest.accountClearingRequestId\">ID</span>--><!--<span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th st-sort=\"createDate\"><span--><!--translate=\"tikonApp.accountClearingRequest.createDate\">Create Date</span>--><!--<span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th st-sort=\"totalPaymentAmount\"><span--><!--translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\">totalPaymentAmount</span> <span--><!--translate=\"global.currencyBracket\"></span></th>--><!--<th ><span--><!--translate=\"tikonApp.accountClearingRequest.status\">status</span> </th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"accountClearingRequest in collection track by accountClearingRequest.id\">--><!--<td><a ui-sref=\"supplierPanel.accountClearingDetail({id:accountClearingRequest.id})\">{{accountClearingRequest.id}}</a>--><!--</td>--><!--<td>{{accountClearingRequest.createDate | toPersianDate}}--><!--<br/>--><!--<span style=\"font-size: 11px ; color: #5c5c5c\">  {{accountClearingRequest.createDate | toPersianTime}}</span>--><!--</td>--><!--<td><strong class=\"text-center\">{{accountClearingRequest.totalPaymentAmount | number}}</strong></td>--><!--<td><strong class=\"text-center\"></strong></td>--><!--<td ng-class=\"vm.findStatusStyle(accountClearingRequest.status)\">--><!--<span ng-class=\"vm.findStatusIcon(accountClearingRequest.status)\"></span>--><!--<span translate=\"{{\'tikonApp.accountClearingRequest.Statuses.\' + accountClearingRequest.status}}\">{{accountClearingRequest.status}}</span>--><!--</td>--><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"supplierPanel.accountClearingDetail({id:accountClearingRequest.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.viewDetail\"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--><!--</table>--><!--</div>--><!--</md-content>--><!--</div>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/account-clearing-request/account-clearing-requests.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.accountClearingRequest.home.title\">accountClearingRequest</div><div class=\"panel-body\"><div class=\"container-fluid\"><!--<h2 translate=\"tikonApp.companyPaymentLog.home.title\">Company Payment Logs</h2>--><jhi-alert></jhi-alert><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.companyPaymentLogList\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"tikonApp.companyPaymentLog.buttons.companyRemaindNotPaid\">tikonApp.buttons.companyRemaindNotPaid</span></md-button><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.accountClearingRequests\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.accountClearingRequest.accountClearingRequestId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.accountClearingRequest.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"totalPaymentAmount\"><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\">totalPaymentAmount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.accountClearingRequest.status\">status</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"accountClearingRequest in collection track by accountClearingRequest.id\"><td><a ui-sref=\"supplierPanel.accountClearingDetail({id:accountClearingRequest.id})\">{{accountClearingRequest.id}}</a></td><td>{{accountClearingRequest.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{accountClearingRequest.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{accountClearingRequest.totalPaymentAmount | number}}</strong></td><td><strong class=\"text-center\"></strong></td><td ng-class=\"vm.findStatusStyle(accountClearingRequest.status)\"><span ng-class=\"vm.findStatusIcon(accountClearingRequest.status)\"></span> <span translate=\"{{\'tikonApp.accountClearingRequest.Statuses.\' + accountClearingRequest.status}}\">{{accountClearingRequest.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.accountClearingDetail({id:accountClearingRequest.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.viewDetail\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div><!--<div>--><!--<h2 translate=\"tikonApp.accountClearingRequest.home.title\">Account Clearing Requests</h2>--><!--<jhi-alert></jhi-alert>--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-4 no-padding-left\">--><!--<button class=\"btn btn-primary\" ui-sref=\"account-clearing-request.new\" >--><!--<span class=\"glyphicon glyphicon-plus\"></span>--><!--<span class=\"hidden-xs\"  translate=\"tikonApp.accountClearingRequest.home.createLabel\">--><!--Create new Account Clearing Request--><!--</span>--><!--</button>--><!--</div>--><!--<div class=\"col-xs-8 no-padding-right\">--><!--<form name=\"searchForm\" class=\"form-inline\">--><!--<div class=\"input-group pull-right\" >--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.accountClearingRequest.home.search\' | translate }}\">--><!--<span  class=\"input-group-btn width-min\" >--><!--<button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</button>--><!--</span>--><!--<span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\">--><!--<button class=\"btn btn-info\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-trash\"></span>--><!--</button>--><!--</span>--><!--</div>--><!--</form>--><!--</div>--><!--</div>--><!--</div>--><!--<br/>--><!--<div class=\"table-responsive\">--><!--<table class=\"jh-table table table-striped\">--><!--<thead>--><!--<tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\">--><!--<th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"createDate\"><span translate=\"tikonApp.accountClearingRequest.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"fromDate\"><span translate=\"tikonApp.accountClearingRequest.fromDate\">From Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"toDate\"><span translate=\"tikonApp.accountClearingRequest.toDate\">To Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"totalPaymentAmount\"><span translate=\"tikonApp.accountClearingRequest.totalPaymentAmount\">Total Payment Amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"totalWageFeeAmount\"><span translate=\"tikonApp.accountClearingRequest.totalWageFeeAmount\">Total Wage Fee Amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"status\"><span translate=\"tikonApp.accountClearingRequest.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"description\"><span translate=\"tikonApp.accountClearingRequest.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"companyId\"><span translate=\"tikonApp.accountClearingRequest.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"accountClearingRequest in vm.accountClearingRequests track by accountClearingRequest.id\">--><!--<td><a ui-sref=\"account-clearing-request-detail({id:accountClearingRequest.id})\">{{accountClearingRequest.id}}</a></td>--><!--<td>{{accountClearingRequest.createDate | date:\'medium\'}}</td>--><!--<td>{{accountClearingRequest.fromDate | date:\'medium\'}}</td>--><!--<td>{{accountClearingRequest.toDate | date:\'medium\'}}</td>--><!--<td>{{accountClearingRequest.totalPaymentAmount}}</td>--><!--<td>{{accountClearingRequest.totalWageFeeAmount}}</td>--><!--<td translate=\"{{\'tikonApp.AccountClearingRequestStatus.\' + accountClearingRequest.status}}\">{{accountClearingRequest.status}}</td>--><!--<td>{{accountClearingRequest.description}}</td>--><!--<td>--><!--<a ui-sref=\"company-detail({id:accountClearingRequest.companyId})\">{{accountClearingRequest.companyId}}</a>--><!--</td>--><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"account-clearing-request-detail({id:accountClearingRequest.id})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"account-clearing-request.edit({id:accountClearingRequest.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"account-clearing-request.delete({id:accountClearingRequest.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/activity-type/activity-type-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myactivityTypeInfoLabel\" translate=\"tikonApp.activityTypeInfo.home.createOrEditLabel\">Create or edit a Subscription Package</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                        border-bottom: solid 1px #ff9d1a;\n                    }</style><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.activityTypeInfo.title\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.type\" for=\"field_type\">type</label><input type=\"text\" class=\"form-control\" name=\"type\" id=\"field_type\" ng-model=\"vm.activityTypeInfo.type\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.category\" for=\"field_category\">type</label><md-select class=\"rwMdSelect\" ng-model=\"vm.activityTypeInfo.category\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_category\"><md-option value=\"BEAUTY\">زیبایی</md-option><md-option value=\"HEALTH\">سلامتی</md-option><md-option value=\"SERVICE_BASE\">خدماتی</md-option><md-option value=\"EDUCATION\">آموزشی</md-option><md-option value=\"ENTERTAINMENT\">تفریحی ورزشی</md-option><md-option value=\"ENTERPRISE\">شرکت ها و سازمان ها</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.servantType\" for=\"field_servantType\">servantType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.activityTypeInfo.servantType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_servantType\"><md-option value=\"SERVANT\">SERVANT</md-option><md-option value=\"RESOURCE\">RESOURCE</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.servantTitle\" for=\"field_servantTitle\">servantTitle</label><input type=\"text\" class=\"form-control\" name=\"servantTitle\" id=\"field_servantTitle\" ng-model=\"vm.activityTypeInfo.servantTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.servantListTitle\" for=\"field_servantListTitle\">servantListTitle</label><input type=\"text\" class=\"form-control\" name=\"servantListTitle\" id=\"field_servantListTitle\" ng-model=\"vm.activityTypeInfo.servantListTitle\"></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.serviceSamplePlaceHolder\" for=\"field_serviceSamplePlaceHolder\">serviceSamplePlaceHolder</label><input type=\"text\" class=\"form-control\" name=\"serviceSamplePlaceHolder\" id=\"field_serviceSamplePlaceHolder\" ng-model=\"vm.activityTypeInfo.serviceSamplePlaceHolder\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.activityTypeInfo.orderNo\" for=\"field_orderNo\">orderNo</label><input type=\"text\" class=\"form-control\" name=\"orderNo\" id=\"field_orderNo\" ng-model=\"vm.activityTypeInfo.orderNo\"></div></div></div></md-content></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/activity-type/activity-type-infos.html","<div><h2 translate=\"tikonApp.activityTypeInfo.home.title\">Supplier Coupon</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"activity-type-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.activityTypeInfo.home.createLabel\">Create new Supplier Coupon</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.activityTypeInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.activityTypeInfo.title\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"tikonApp.activityTypeInfo.type\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"category\"><span translate=\"tikonApp.activityTypeInfo.category\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"servantType\"><span translate=\"tikonApp.activityTypeInfo.servantType\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"servantTitle\"><span translate=\"tikonApp.activityTypeInfo.servantTitle\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"servantListTitle\"><span translate=\"tikonApp.activityTypeInfo.servantListTitle\">amountType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceSamplePlaceHolder\"><span translate=\"tikonApp.activityTypeInfo.serviceSamplePlaceHolder\">amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"activityTypeInfo in vm.activityTypeInfos track by activityTypeInfo.id\"><td><a ui-sref=\"activity-type-info-detail({id:activityTypeInfo.id})\">{{activityTypeInfo.id}}</a></td><td>{{activityTypeInfo.title}}</td><td>{{activityTypeInfo.type}}</td><td>{{activityTypeInfo.category}}</td><td>{{activityTypeInfo.servantType}}</td><td>{{activityTypeInfo.servantTitle}}</td><td>{{activityTypeInfo.servantListTitle}}</td><td>{{activityTypeInfo.serviceSamplePlaceHolder}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"activity-type-info.edit({id:activityTypeInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"activity-type-info.delete({id:activityTypeInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agent-access-info/agent-access-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agentAccessInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.agentAccessInfo.delete.question\" translate-values=\"{id: \'{{vm.agentAccessInfo.id}}\'}\">Are you sure you want to delete this Agent Access Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agent-access-info/agent-access-info-detail.html","<div><h2><span translate=\"tikonApp.agentAccessInfo.detail.title\">Agent Access Info</span> {{vm.agentAccessInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.agentAccessInfo.accessType\">Access Type</span></dt><dd><span translate=\"{{\'tikonApp.AgentAccessType.\' + vm.agentAccessInfo.accessType}}\">{{vm.agentAccessInfo.accessType}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agent-access-info/agent-access-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgentAccessInfoLabel\" translate=\"tikonApp.agentAccessInfo.home.createOrEditLabel\">Create or edit a Agent Access Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agentAccessInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agentAccessInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentAccessInfo.accessType\" for=\"field_accessType\">Access Type</label><select class=\"form-control\" name=\"accessType\" ng-model=\"vm.agentAccessInfo.accessType\" id=\"field_accessType\"><option value=\"LIMITED\" translate=\"tikonApp.AgentAccessType.LIMITED\">LIMITED</option><option value=\"FULL\" translate=\"tikonApp.AgentAccessType.FULL\">FULL</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agent-access-info/agent-access-infos.html","<div><h2 translate=\"tikonApp.agentAccessInfo.home.title\">Agent Access Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agent-access-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agentAccessInfo.home.createLabel\">Create new Agent Access Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.agentAccessInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"accessType\"><span translate=\"tikonApp.agentAccessInfo.accessType\">Access Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentAccessInfo in vm.agentAccessInfos track by agentAccessInfo.id\"><td><a ui-sref=\"agent-access-info-detail({id:agentAccessInfo.id})\">{{agentAccessInfo.id}}</a></td><td translate=\"{{\'tikonApp.AgentAccessType.\' + agentAccessInfo.accessType}}\">{{agentAccessInfo.accessType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agent-access-info-detail({id:agentAccessInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agent-access-info.edit({id:agentAccessInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agent-access-info.delete({id:agentAccessInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agent-access-info/set-agent-access-infos.html","<div><h2 translate=\"tikonApp.agentAccessInfo.myCompaniesAccess\">Agent Access Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"supplierName\"><span translate=\"tikonApp.company.title\">Supplier Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentSupplierContract in vm.agentSupplierContracts track by agentSupplierContract.id\"><td>{{agentSupplierContract.supplier.title}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ui-sref=\"supplierPanel.agentSupplierAccessList.mapServices({id:agentSupplierContract.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"tikonApp.agentAccessInfo.selectService\"></span></button></div></td></tr></tbody></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div>");
$templateCache.put("app/entities/agent-access-info/upsert-agent-access-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgentCategoryAccessLabel\" translate=\"tikonApp.agentAccessInfo.selectService\">Create or edit a Agent Category Access</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label translate=\"tikonApp.agentAccessInfo.supplierServiceCategory\" for=\"field_supplierCategoryItem\">Supplier Service Category Item</label><select class=\"form-control\" id=\"field_supplierCategoryItem\" name=\"supplierServiceCategoryItem\" ng-model=\"vm.selectedSupplierServiceCategory\" ng-options=\"serviceCategory.id as serviceCategory.categoryName for serviceCategory in vm.supplierServiceCategories\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label translate=\"tikonApp.agentAccessInfo.agentServiceCategory\" for=\"field_agentCategoryItem\">Agent Service Category Item</label><select class=\"form-control\" id=\"field_agentCategoryItem\" name=\"agentServiceCategoryItem\" ng-model=\"vm.selectedAgentServiceCategory\" ng-options=\"serviceCategory.id as serviceCategory.categoryName for serviceCategory in vm.agentServiceCategories\"></select></div></div><div class=\"col-xs-4 no-padding-left\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addCategoryAccess()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agentAccessInfo.select\">Add New Category Map</span></button></div></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"supplierCagetoryTitle\"><span translate=\"tikonApp.agentAccessInfo.supplierServiceCategory\">Supplier Cagetory Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentCagetoryTitle\"><span translate=\"tikonApp.agentAccessInfo.agentServiceCategory\">Agent Cagetory Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentCategoryAccess in vm.agentSupplierContract.agentAccessInfo.agentCategoryAccess \"><td>{{agentCategoryAccess.supplierCategory.categoryName}}</td><td>{{agentCategoryAccess.mapToAgentCategory.categoryName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ng-click=\"vm.removeItem(agentCategoryAccess)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!--<div class=\"form-group\" ng-show=\"vm.agentCategoryAccess.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"vm.agentCategoryAccess.id\" readonly />--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.agentCategoryAccess.accessType\" for=\"field_accessType\">Access Type</label>--><!--<select class=\"form-control\" name=\"accessType\" ng-model=\"vm.agentCategoryAccess.accessType\" id=\"field_accessType\">--><!--<option value=\"NO_ACCESS\" translate=\"tikonApp.AgentCategoryAccessType.NO_ACCESS\">NO_ACCESS</option>--><!--<option value=\"VIEW_ACCESS\" translate=\"tikonApp.AgentCategoryAccessType.VIEW_ACCESS\">VIEW_ACCESS</option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.agentCategoryAccess.viewMode\" for=\"field_viewMode\">View Mode</label>--><!--<select class=\"form-control\" name=\"viewMode\" ng-model=\"vm.agentCategoryAccess.viewMode\" id=\"field_viewMode\">--><!--<option value=\"HIDE\" translate=\"tikonApp.AgentCategoryViewMode.HIDE\">HIDE</option>--><!--<option value=\"SHOW\" translate=\"tikonApp.AgentCategoryViewMode.SHOW\">SHOW</option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.agentCategoryAccess.agentAccessInfo\" for=\"field_agentAccessInfo\">Agent Access Info</label>--><!--<select class=\"form-control\" id=\"field_agentAccessInfo\" name=\"agentAccessInfo\" ng-model=\"vm.agentCategoryAccess.agentAccessInfoId\" ng-options=\"agentAccessInfo.id as agentAccessInfo.id for agentAccessInfo in vm.agentaccessinfos\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.agentCategoryAccess.supplierCategory\" for=\"field_supplierCategory\">Supplier Category</label>--><!--<select class=\"form-control\" id=\"field_supplierCategory\" name=\"supplierCategory\" ng-model=\"vm.agentCategoryAccess.supplierCategoryId\" ng-options=\"serviceCategory.id as serviceCategory.id for serviceCategory in vm.servicecategories\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.agentCategoryAccess.mapToAgentCategory\" for=\"field_mapToAgentCategory\">Map To Agent Category</label>--><!--<select class=\"form-control\" id=\"field_mapToAgentCategory\" name=\"mapToAgentCategory\" ng-model=\"vm.agentCategoryAccess.mapToAgentCategoryId\" ng-options=\"serviceCategory.id as serviceCategory.id for serviceCategory in vm.servicecategories\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agent-category-access/agent-category-access-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agentCategoryAccess.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.agentCategoryAccess.delete.question\" translate-values=\"{id: \'{{vm.agentCategoryAccess.id}}\'}\">Are you sure you want to delete this Agent Category Access?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agent-category-access/agent-category-access-detail.html","<div><h2><span translate=\"tikonApp.agentCategoryAccess.detail.title\">Agent Category Access</span> {{vm.agentCategoryAccess.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.agentCategoryAccess.accessType\">Access Type</span></dt><dd><span translate=\"{{\'tikonApp.AgentCategoryAccessType.\' + vm.agentCategoryAccess.accessType}}\">{{vm.agentCategoryAccess.accessType}}</span></dd><dt><span translate=\"tikonApp.agentCategoryAccess.viewMode\">View Mode</span></dt><dd><span translate=\"{{\'tikonApp.AgentCategoryViewMode.\' + vm.agentCategoryAccess.viewMode}}\">{{vm.agentCategoryAccess.viewMode}}</span></dd><dt><span translate=\"tikonApp.agentCategoryAccess.agentAccessInfo\">Agent Access Info</span></dt><dd><a ui-sref=\"agent-access-info-detail({id:vm.agentCategoryAccess.agentAccessInfoId})\">{{vm.agentCategoryAccess.agentAccessInfoId}}</a></dd><dt><span translate=\"tikonApp.agentCategoryAccess.supplierCategory\">Supplier Category</span></dt><dd><a ui-sref=\"service-category-detail({id:vm.agentCategoryAccess.supplierCategoryId})\">{{vm.agentCategoryAccess.supplierCategoryId}}</a></dd><dt><span translate=\"tikonApp.agentCategoryAccess.mapToAgentCategory\">Map To Agent Category</span></dt><dd><a ui-sref=\"service-category-detail({id:vm.agentCategoryAccess.mapToAgentCategoryId})\">{{vm.agentCategoryAccess.mapToAgentCategoryId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agent-category-access/agent-category-access-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgentCategoryAccessLabel\" translate=\"tikonApp.agentCategoryAccess.home.createOrEditLabel\">Create or edit a Agent Category Access</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agentCategoryAccess.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agentCategoryAccess.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentCategoryAccess.accessType\" for=\"field_accessType\">Access Type</label><select class=\"form-control\" name=\"accessType\" ng-model=\"vm.agentCategoryAccess.accessType\" id=\"field_accessType\"><option value=\"NO_ACCESS\" translate=\"tikonApp.AgentCategoryAccessType.NO_ACCESS\">NO_ACCESS</option><option value=\"VIEW_ACCESS\" translate=\"tikonApp.AgentCategoryAccessType.VIEW_ACCESS\">VIEW_ACCESS</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentCategoryAccess.viewMode\" for=\"field_viewMode\">View Mode</label><select class=\"form-control\" name=\"viewMode\" ng-model=\"vm.agentCategoryAccess.viewMode\" id=\"field_viewMode\"><option value=\"HIDE\" translate=\"tikonApp.AgentCategoryViewMode.HIDE\">HIDE</option><option value=\"SHOW\" translate=\"tikonApp.AgentCategoryViewMode.SHOW\">SHOW</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentCategoryAccess.agentAccessInfo\" for=\"field_agentAccessInfo\">Agent Access Info</label><select class=\"form-control\" id=\"field_agentAccessInfo\" name=\"agentAccessInfo\" ng-model=\"vm.agentCategoryAccess.agentAccessInfoId\" ng-options=\"agentAccessInfo.id as agentAccessInfo.id for agentAccessInfo in vm.agentaccessinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentCategoryAccess.supplierCategory\" for=\"field_supplierCategory\">Supplier Category</label><select class=\"form-control\" id=\"field_supplierCategory\" name=\"supplierCategory\" ng-model=\"vm.agentCategoryAccess.supplierCategoryId\" ng-options=\"serviceCategory.id as serviceCategory.id for serviceCategory in vm.servicecategories\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentCategoryAccess.mapToAgentCategory\" for=\"field_mapToAgentCategory\">Map To Agent Category</label><select class=\"form-control\" id=\"field_mapToAgentCategory\" name=\"mapToAgentCategory\" ng-model=\"vm.agentCategoryAccess.mapToAgentCategoryId\" ng-options=\"serviceCategory.id as serviceCategory.id for serviceCategory in vm.servicecategories\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agent-category-access/agent-category-accesses.html","<div><h2 translate=\"tikonApp.agentCategoryAccess.home.title\">Agent Category Accesses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agent-category-access.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agentCategoryAccess.home.createLabel\">Create new Agent Category Access</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.agentCategoryAccess.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"accessType\"><span translate=\"tikonApp.agentCategoryAccess.accessType\">Access Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"viewMode\"><span translate=\"tikonApp.agentCategoryAccess.viewMode\">View Mode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentAccessInfoId\"><span translate=\"tikonApp.agentCategoryAccess.agentAccessInfo\">Agent Access Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"supplierCategoryId\"><span translate=\"tikonApp.agentCategoryAccess.supplierCategory\">Supplier Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mapToAgentCategoryId\"><span translate=\"tikonApp.agentCategoryAccess.mapToAgentCategory\">Map To Agent Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentCategoryAccess in vm.agentCategoryAccesses track by agentCategoryAccess.id\"><td><a ui-sref=\"agent-category-access-detail({id:agentCategoryAccess.id})\">{{agentCategoryAccess.id}}</a></td><td translate=\"{{\'tikonApp.AgentCategoryAccessType.\' + agentCategoryAccess.accessType}}\">{{agentCategoryAccess.accessType}}</td><td translate=\"{{\'tikonApp.AgentCategoryViewMode.\' + agentCategoryAccess.viewMode}}\">{{agentCategoryAccess.viewMode}}</td><td><a ui-sref=\"agent-access-info-detail({id:agentCategoryAccess.agentAccessInfoId})\">{{agentCategoryAccess.agentAccessInfoId}}</a></td><td><a ui-sref=\"service-category-detail({id:agentCategoryAccess.supplierCategoryId})\">{{agentCategoryAccess.supplierCategoryId}}</a></td><td><a ui-sref=\"service-category-detail({id:agentCategoryAccess.mapToAgentCategoryId})\">{{agentCategoryAccess.mapToAgentCategoryId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agent-category-access-detail({id:agentCategoryAccess.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agent-category-access.edit({id:agentCategoryAccess.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agent-category-access.delete({id:agentCategoryAccess.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agent-request/agent-request-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agentRequest.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.agentRequest.delete.question\" translate-values=\"{id: \'{{vm.agentRequest.id}}\'}\">Are you sure you want to delete this Agent Request?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agent-request/agent-request-detail.html","<div><h2><span translate=\"tikonApp.agentRequest.detail.title\">Agent Request</span> {{vm.agentRequest.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.agentRequest.agentRequestType\">Agent Request Type</span></dt><dd><span translate=\"{{\'tikonApp.AgentRequestType.\' + vm.agentRequest.agentRequestType}}\">{{vm.agentRequest.agentRequestType}}</span></dd><dt><span translate=\"tikonApp.agentRequest.createDate\">Create Date</span></dt><dd><span>{{vm.agentRequest.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.agentRequest.requestMessage\">Request Message</span></dt><dd><span>{{vm.agentRequest.requestMessage}}</span></dd><dt><span translate=\"tikonApp.agentRequest.suggestedCommision\">Suggested Commision</span></dt><dd><span>{{vm.agentRequest.suggestedCommision}}</span></dd><dt><span translate=\"tikonApp.agentRequest.replyDate\">Reply Date</span></dt><dd><span>{{vm.agentRequest.replyDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.agentRequest.replyMessage\">Reply Message</span></dt><dd><span>{{vm.agentRequest.replyMessage}}</span></dd><dt><span translate=\"tikonApp.agentRequest.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.AgentRequestStatus.\' + vm.agentRequest.status}}\">{{vm.agentRequest.status}}</span></dd><dt><span translate=\"tikonApp.agentRequest.requestedBy\">Requested By</span></dt><dd><a ui-sref=\"company-detail({id:vm.agentRequest.requestedById})\">{{vm.agentRequest.requestedById}}</a></dd><dt><span translate=\"tikonApp.agentRequest.requestedTo\">Requested To</span></dt><dd><a ui-sref=\"company-detail({id:vm.agentRequest.requestedToId})\">{{vm.agentRequest.requestedToId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agent-request/agent-request-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgentRequestLabel\" translate=\"tikonApp.agentRequest.home.createOrEditLabel\">Create or edit a Agent Request</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agentRequest.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agentRequest.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.agentRequestType\" for=\"field_agentRequestType\">Agent Request Type</label><select class=\"form-control\" name=\"agentRequestType\" ng-model=\"vm.agentRequest.agentRequestType\" id=\"field_agentRequestType\"><option value=\"REQUEST_AS_AGENT\" translate=\"tikonApp.AgentRequestType.REQUEST_AS_AGENT\">REQUEST_AS_AGENT</option><option value=\"REQUEST_AS_SUPPLIER\" translate=\"tikonApp.AgentRequestType.REQUEST_AS_SUPPLIER\">REQUEST_AS_SUPPLIER</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.agentRequest.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.requestMessage\" for=\"field_requestMessage\">Request Message</label><input type=\"text\" class=\"form-control\" name=\"requestMessage\" id=\"field_requestMessage\" ng-model=\"vm.agentRequest.requestMessage\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.suggestedCommision\" for=\"field_suggestedCommision\">Suggested Commision</label><input type=\"number\" class=\"form-control\" name=\"suggestedCommision\" id=\"field_suggestedCommision\" ng-model=\"vm.agentRequest.suggestedCommision\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.replyDate\" for=\"field_replyDate\">Reply Date</label><div class=\"input-group\"><input id=\"field_replyDate\" type=\"text\" class=\"form-control\" name=\"replyDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.agentRequest.replyDate\" is-open=\"vm.datePickerOpenStatus.replyDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'replyDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.replyMessage\" for=\"field_replyMessage\">Reply Message</label><input type=\"text\" class=\"form-control\" name=\"replyMessage\" id=\"field_replyMessage\" ng-model=\"vm.agentRequest.replyMessage\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentRequest.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.agentRequest.status\" id=\"field_status\"><option value=\"REQUESTED\" translate=\"tikonApp.AgentRequestStatus.REQUESTED\">REQUESTED</option><option value=\"CONFIRMED\" translate=\"tikonApp.AgentRequestStatus.CONFIRMED\">CONFIRMED</option><option value=\"REJECTED\" translate=\"tikonApp.AgentRequestStatus.REJECTED\">REJECTED</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentRequest.requestedBy\" for=\"field_requestedBy\">Requested By</label><select class=\"form-control\" id=\"field_requestedBy\" name=\"requestedBy\" ng-model=\"vm.agentRequest.requestedById\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentRequest.requestedTo\" for=\"field_requestedTo\">Requested To</label><select class=\"form-control\" id=\"field_requestedTo\" name=\"requestedTo\" ng-model=\"vm.agentRequest.requestedToId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agent-request/agent-requests.html","<div><h2 translate=\"tikonApp.agentRequest.home.title\">Agent Requests</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agent-request.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agentRequest.home.createLabel\">Create new Agent Request</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.agentRequest.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentRequestType\"><span translate=\"tikonApp.agentRequest.agentRequestType\">Agent Request Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.agentRequest.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestMessage\"><span translate=\"tikonApp.agentRequest.requestMessage\">Request Message</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"suggestedCommision\"><span translate=\"tikonApp.agentRequest.suggestedCommision\">Suggested Commision</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"replyDate\"><span translate=\"tikonApp.agentRequest.replyDate\">Reply Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"replyMessage\"><span translate=\"tikonApp.agentRequest.replyMessage\">Reply Message</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.agentRequest.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestedById\"><span translate=\"tikonApp.agentRequest.requestedBy\">Requested By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestedToId\"><span translate=\"tikonApp.agentRequest.requestedTo\">Requested To</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentRequest in vm.agentRequests track by agentRequest.id\"><td><a ui-sref=\"agent-request-detail({id:agentRequest.id})\">{{agentRequest.id}}</a></td><td translate=\"{{\'tikonApp.AgentRequestType.\' + agentRequest.agentRequestType}}\">{{agentRequest.agentRequestType}}</td><td>{{agentRequest.createDate | date:\'medium\'}}</td><td>{{agentRequest.requestMessage}}</td><td>{{agentRequest.suggestedCommision}}</td><td>{{agentRequest.replyDate | date:\'medium\'}}</td><td>{{agentRequest.replyMessage}}</td><td translate=\"{{\'tikonApp.AgentRequestStatus.\' + agentRequest.status}}\">{{agentRequest.status}}</td><td><a ui-sref=\"company-detail({id:agentRequest.requestedById})\">{{agentRequest.requestedById}}</a></td><td><a ui-sref=\"company-detail({id:agentRequest.requestedToId})\">{{agentRequest.requestedToId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agent-request-detail({id:agentRequest.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agent-request.edit({id:agentRequest.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agent-request.delete({id:agentRequest.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agent-request/company-list.html","<div><h2 translate=\"tikonApp.company.home.title\">Companies</h2><jhi-alert></jhi-alert><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.company.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phoneNumber\"><span translate=\"tikonApp.company.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activityType\"><span translate=\"tikonApp.company.activityType\">Activity Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"keyUrl\"><span translate=\"tikonApp.company.keyUrl\">Key Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"company in vm.companies track by company.id\"><td><a ui-sref=\"company-detail({id:company.id})\">{{company.id}}</a></td><td>{{company.title}}</td><td>{{company.phoneNumber}}</td><td translate=\"{{\'tikonApp.ActivityType.\' + company.activityType}}\">{{company.activityType}}</td><td>{{company.keyUrl}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.agentCompanyList.new\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button></div></td></tr></tbody></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div>");
$templateCache.put("app/entities/agent-service-item-access/agent-service-item-access-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agentServiceItemAccess.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.agentServiceItemAccess.delete.question\" translate-values=\"{id: \'{{vm.agentServiceItemAccess.id}}\'}\">Are you sure you want to delete this Agent Service Item Access?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agent-service-item-access/agent-service-item-access-detail.html","<div><h2><span translate=\"tikonApp.agentServiceItemAccess.detail.title\">Agent Service Item Access</span> {{vm.agentServiceItemAccess.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.agentServiceItemAccess.accessType\">Access Type</span></dt><dd><span translate=\"{{\'tikonApp.AgentCategoryAccessType.\' + vm.agentServiceItemAccess.accessType}}\">{{vm.agentServiceItemAccess.accessType}}</span></dd><dt><span translate=\"tikonApp.agentServiceItemAccess.viewMode\">View Mode</span></dt><dd><span translate=\"{{\'tikonApp.AgentCategoryViewMode.\' + vm.agentServiceItemAccess.viewMode}}\">{{vm.agentServiceItemAccess.viewMode}}</span></dd><dt><span translate=\"tikonApp.agentServiceItemAccess.supplierServiceItem\">Supplier Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.agentServiceItemAccess.supplierServiceItemId})\">{{vm.agentServiceItemAccess.supplierServiceItemId}}</a></dd><dt><span translate=\"tikonApp.agentServiceItemAccess.mapToAgentServiceItem\">Map To Agent Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.agentServiceItemAccess.mapToAgentServiceItemId})\">{{vm.agentServiceItemAccess.mapToAgentServiceItemId}}</a></dd><dt><span translate=\"tikonApp.agentServiceItemAccess.agentAccessInfo\">Agent Access Info</span></dt><dd><a ui-sref=\"agent-access-info-detail({id:vm.agentServiceItemAccess.agentAccessInfoId})\">{{vm.agentServiceItemAccess.agentAccessInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agent-service-item-access/agent-service-item-access-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgentServiceItemAccessLabel\" translate=\"tikonApp.agentServiceItemAccess.home.createOrEditLabel\">Create or edit a Agent Service Item Access</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agentServiceItemAccess.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agentServiceItemAccess.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentServiceItemAccess.accessType\" for=\"field_accessType\">Access Type</label><select class=\"form-control\" name=\"accessType\" ng-model=\"vm.agentServiceItemAccess.accessType\" id=\"field_accessType\"><option value=\"NO_ACCESS\" translate=\"tikonApp.AgentCategoryAccessType.NO_ACCESS\">NO_ACCESS</option><option value=\"VIEW_ACCESS\" translate=\"tikonApp.AgentCategoryAccessType.VIEW_ACCESS\">VIEW_ACCESS</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentServiceItemAccess.viewMode\" for=\"field_viewMode\">View Mode</label><select class=\"form-control\" name=\"viewMode\" ng-model=\"vm.agentServiceItemAccess.viewMode\" id=\"field_viewMode\"><option value=\"HIDE\" translate=\"tikonApp.AgentCategoryViewMode.HIDE\">HIDE</option><option value=\"SHOW\" translate=\"tikonApp.AgentCategoryViewMode.SHOW\">SHOW</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentServiceItemAccess.supplierServiceItem\" for=\"field_supplierServiceItem\">Supplier Service Item</label><select class=\"form-control\" id=\"field_supplierServiceItem\" name=\"supplierServiceItem\" ng-model=\"vm.agentServiceItemAccess.supplierServiceItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentServiceItemAccess.mapToAgentServiceItem\" for=\"field_mapToAgentServiceItem\">Map To Agent Service Item</label><select class=\"form-control\" id=\"field_mapToAgentServiceItem\" name=\"mapToAgentServiceItem\" ng-model=\"vm.agentServiceItemAccess.mapToAgentServiceItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentServiceItemAccess.agentAccessInfo\" for=\"field_agentAccessInfo\">Agent Access Info</label><select class=\"form-control\" id=\"field_agentAccessInfo\" name=\"agentAccessInfo\" ng-model=\"vm.agentServiceItemAccess.agentAccessInfoId\" ng-options=\"agentAccessInfo.id as agentAccessInfo.id for agentAccessInfo in vm.agentaccessinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agent-service-item-access/agent-service-item-accesses.html","<div><h2 translate=\"tikonApp.agentServiceItemAccess.home.title\">Agent Service Item Accesses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agent-service-item-access.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agentServiceItemAccess.home.createLabel\">Create new Agent Service Item Access</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.agentServiceItemAccess.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"accessType\"><span translate=\"tikonApp.agentServiceItemAccess.accessType\">Access Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"viewMode\"><span translate=\"tikonApp.agentServiceItemAccess.viewMode\">View Mode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"supplierServiceItemId\"><span translate=\"tikonApp.agentServiceItemAccess.supplierServiceItem\">Supplier Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mapToAgentServiceItemId\"><span translate=\"tikonApp.agentServiceItemAccess.mapToAgentServiceItem\">Map To Agent Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentAccessInfoId\"><span translate=\"tikonApp.agentServiceItemAccess.agentAccessInfo\">Agent Access Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentServiceItemAccess in vm.agentServiceItemAccesses track by agentServiceItemAccess.id\"><td><a ui-sref=\"agent-service-item-access-detail({id:agentServiceItemAccess.id})\">{{agentServiceItemAccess.id}}</a></td><td translate=\"{{\'tikonApp.AgentCategoryAccessType.\' + agentServiceItemAccess.accessType}}\">{{agentServiceItemAccess.accessType}}</td><td translate=\"{{\'tikonApp.AgentCategoryViewMode.\' + agentServiceItemAccess.viewMode}}\">{{agentServiceItemAccess.viewMode}}</td><td><a ui-sref=\"service-item-detail({id:agentServiceItemAccess.supplierServiceItemId})\">{{agentServiceItemAccess.supplierServiceItemId}}</a></td><td><a ui-sref=\"service-item-detail({id:agentServiceItemAccess.mapToAgentServiceItemId})\">{{agentServiceItemAccess.mapToAgentServiceItemId}}</a></td><td><a ui-sref=\"agent-access-info-detail({id:agentServiceItemAccess.agentAccessInfoId})\">{{agentServiceItemAccess.agentAccessInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agent-service-item-access-detail({id:agentServiceItemAccess.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agent-service-item-access.edit({id:agentServiceItemAccess.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agent-service-item-access.delete({id:agentServiceItemAccess.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agent-supplier-contract/agent-supplier-contract-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agentSupplierContract.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.agentSupplierContract.delete.question\" translate-values=\"{id: \'{{vm.agentSupplierContract.id}}\'}\">Are you sure you want to delete this Agent Supplier Contract?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agent-supplier-contract/agent-supplier-contract-detail.html","<div><h2><span translate=\"tikonApp.agentSupplierContract.detail.title\">Agent Supplier Contract</span> {{vm.agentSupplierContract.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.agentSupplierContract.createDate\">Create Date</span></dt><dd><span>{{vm.agentSupplierContract.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.agentSupplierContract.commision\">Commision</span></dt><dd><span>{{vm.agentSupplierContract.commision}}</span></dd><dt><span translate=\"tikonApp.agentSupplierContract.startDate\">Start Date</span></dt><dd><span>{{vm.agentSupplierContract.startDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.agentSupplierContract.endDate\">End Date</span></dt><dd><span>{{vm.agentSupplierContract.endDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.agentSupplierContract.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.AgentSupplierContractStatus.\' + vm.agentSupplierContract.status}}\">{{vm.agentSupplierContract.status}}</span></dd><dt><span translate=\"tikonApp.agentSupplierContract.agentAccessInfo\">Agent Access Info</span></dt><dd><a ui-sref=\"agent-access-info-detail({id:vm.agentSupplierContract.agentAccessInfoId})\">{{vm.agentSupplierContract.agentAccessInfoId}}</a></dd><dt><span translate=\"tikonApp.agentSupplierContract.agentRequest\">Agent Request</span></dt><dd><a ui-sref=\"agent-request-detail({id:vm.agentSupplierContract.agentRequestId})\">{{vm.agentSupplierContract.agentRequestId}}</a></dd><dt><span translate=\"tikonApp.agentSupplierContract.supplier\">Supplier</span></dt><dd><a ui-sref=\"company-detail({id:vm.agentSupplierContract.supplierId})\">{{vm.agentSupplierContract.supplierId}}</a></dd><dt><span translate=\"tikonApp.agentSupplierContract.agent\">Agent</span></dt><dd><a ui-sref=\"company-detail({id:vm.agentSupplierContract.agentId})\">{{vm.agentSupplierContract.agentId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agent-supplier-contract/agent-supplier-contract-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgentSupplierContractLabel\" translate=\"tikonApp.agentSupplierContract.home.createOrEditLabel\">Create or edit a Agent Supplier Contract</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agentSupplierContract.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agentSupplierContract.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentSupplierContract.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.agentSupplierContract.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentSupplierContract.commision\" for=\"field_commision\">Commision</label><input type=\"number\" class=\"form-control\" name=\"commision\" id=\"field_commision\" ng-model=\"vm.agentSupplierContract.commision\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentSupplierContract.startDate\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.agentSupplierContract.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentSupplierContract.endDate\" for=\"field_endDate\">End Date</label><div class=\"input-group\"><input id=\"field_endDate\" type=\"text\" class=\"form-control\" name=\"endDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.agentSupplierContract.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agentSupplierContract.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.agentSupplierContract.status\" id=\"field_status\"><option value=\"ACTIVE\" translate=\"tikonApp.AgentSupplierContractStatus.ACTIVE\">ACTIVE</option><option value=\"EXPIRED\" translate=\"tikonApp.AgentSupplierContractStatus.EXPIRED\">EXPIRED</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentSupplierContract.agentAccessInfo\" for=\"field_agentAccessInfo\">Agent Access Info</label><select class=\"form-control\" id=\"field_agentAccessInfo\" name=\"agentAccessInfo\" ng-model=\"vm.agentSupplierContract.agentAccessInfoId\" ng-options=\"agentAccessInfo.id as agentAccessInfo.id for agentAccessInfo in vm.agentaccessinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentSupplierContract.agentRequest\" for=\"field_agentRequest\">Agent Request</label><select class=\"form-control\" id=\"field_agentRequest\" name=\"agentRequest\" ng-model=\"vm.agentSupplierContract.agentRequestId\" ng-options=\"agentRequest.id as agentRequest.id for agentRequest in vm.agentrequests\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentSupplierContract.supplier\" for=\"field_supplier\">Supplier</label><select class=\"form-control\" id=\"field_supplier\" name=\"supplier\" ng-model=\"vm.agentSupplierContract.supplierId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.agentSupplierContract.agent\" for=\"field_agent\">Agent</label><select class=\"form-control\" id=\"field_agent\" name=\"agent\" ng-model=\"vm.agentSupplierContract.agentId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agent-supplier-contract/agent-supplier-contracts.html","<div><h2 translate=\"tikonApp.agentSupplierContract.home.title\">Agent Supplier Contracts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agent-supplier-contract.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agentSupplierContract.home.createLabel\">Create new Agent Supplier Contract</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.agentSupplierContract.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.agentSupplierContract.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"commision\"><span translate=\"tikonApp.agentSupplierContract.commision\">Commision</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"tikonApp.agentSupplierContract.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endDate\"><span translate=\"tikonApp.agentSupplierContract.endDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.agentSupplierContract.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentAccessInfoId\"><span translate=\"tikonApp.agentSupplierContract.agentAccessInfo\">Agent Access Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentRequestId\"><span translate=\"tikonApp.agentSupplierContract.agentRequest\">Agent Request</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"supplierId\"><span translate=\"tikonApp.agentSupplierContract.supplier\">Supplier</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agentId\"><span translate=\"tikonApp.agentSupplierContract.agent\">Agent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agentSupplierContract in vm.agentSupplierContracts track by agentSupplierContract.id\"><td><a ui-sref=\"agent-supplier-contract-detail({id:agentSupplierContract.id})\">{{agentSupplierContract.id}}</a></td><td>{{agentSupplierContract.createDate | date:\'medium\'}}</td><td>{{agentSupplierContract.commision}}</td><td>{{agentSupplierContract.startDate | date:\'medium\'}}</td><td>{{agentSupplierContract.endDate | date:\'medium\'}}</td><td translate=\"{{\'tikonApp.AgentSupplierContractStatus.\' + agentSupplierContract.status}}\">{{agentSupplierContract.status}}</td><td><a ui-sref=\"agent-access-info-detail({id:agentSupplierContract.agentAccessInfoId})\">{{agentSupplierContract.agentAccessInfoId}}</a></td><td><a ui-sref=\"agent-request-detail({id:agentSupplierContract.agentRequestId})\">{{agentSupplierContract.agentRequestId}}</a></td><td><a ui-sref=\"company-detail({id:agentSupplierContract.supplierId})\">{{agentSupplierContract.supplierId}}</a></td><td><a ui-sref=\"company-detail({id:agentSupplierContract.agentId})\">{{agentSupplierContract.agentId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agent-supplier-contract-detail({id:agentSupplierContract.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agent-supplier-contract.edit({id:agentSupplierContract.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agent-supplier-contract.delete({id:agentSupplierContract.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agreement-info/agreement-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agreementInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.agreementInfo.delete.question\" translate-values=\"{id: \'{{vm.agreementInfo.id}}\'}\">Are you sure you want to delete this Agreement Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/agreement-info/agreement-info-detail.html","<div><h2><span translate=\"tikonApp.agreementInfo.detail.title\">Agreement Info</span> {{vm.agreementInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.agreementInfo.rules\">Rules</span></dt><dd><span>{{vm.agreementInfo.rules}}</span></dd><dt><span translate=\"tikonApp.agreementInfo.agreement\">Agreement</span></dt><dd><span>{{vm.agreementInfo.agreement}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/agreement-info/agreement-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgreementInfoLabel\" translate=\"tikonApp.agreementInfo.home.createOrEditLabel\">Create or edit a Agreement Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.agreementInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agreementInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agreementInfo.rules\" for=\"field_rules\">Rules</label><input type=\"text\" class=\"form-control\" name=\"rules\" id=\"field_rules\" ng-model=\"vm.agreementInfo.rules\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.agreementInfo.agreement\" for=\"field_agreement\">Agreement</label><input type=\"text\" class=\"form-control\" name=\"agreement\" id=\"field_agreement\" ng-model=\"vm.agreementInfo.agreement\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/agreement-info/agreement-infos.html","<div><h2 translate=\"tikonApp.agreementInfo.home.title\">Agreement Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agreement-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.agreementInfo.home.createLabel\">Create new Agreement Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.agreementInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"rules\"><span translate=\"tikonApp.agreementInfo.rules\">Rules</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agreement\"><span translate=\"tikonApp.agreementInfo.agreement\">Agreement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agreementInfo in vm.agreementInfos track by agreementInfo.id\"><td><a ui-sref=\"agreement-info-detail({id:agreementInfo.id})\">{{agreementInfo.id}}</a></td><td>{{agreementInfo.rules}}</td><td>{{agreementInfo.agreement}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agreement-info-detail({id:agreementInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agreement-info.edit({id:agreementInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agreement-info.delete({id:agreementInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/agreement-info/company-agreement-info.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-body\"><action-bar></action-bar><!--  <div class=\"form-group\" ng-show=\"vm.agreementInfo.id\">\n              <label for=\"id\" translate=\"global.field.id\">ID</label>\n              <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                      ng-model=\"vm.agreementInfo.id\" readonly />\n          </div>--><div class=\"form-group\"><label style=\"padding: 10px\" active=\"active\" class=\"control-label\" translate=\"tikonApp.agreementInfo.rules\" for=\"field_rules\">Rules</label><div height=\"300\" style=\"padding: 10px\" type=\"text\" summernote class=\"form-control\" name=\"rules\" id=\"field_rules\" ng-model=\"vm.companyInfo.agreementInfo.rules\"></div></div><div class=\"form-group\" style=\"height: 310px\"><label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.agreementInfo.agreement\" for=\"field_agreement\">Agreement</label><div height=\"300\" type=\"text\" summernote class=\"form-control\" name=\"agreement\" id=\"field_agreement\" ng-model=\"vm.companyInfo.agreementInfo.agreement\"></div></div></div></form>");
$templateCache.put("app/entities/album-info/album-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.albumInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.albumInfo.delete.question\" translate-values=\"{id: \'{{vm.albumInfo.id}}\'}\">Are you sure you want to delete this Album Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/album-info/album-info-detail.html","<div><h2><span translate=\"tikonApp.albumInfo.detail.title\">Album Info</span> {{vm.albumInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.albumInfo.isSingleImage\">Is Single Image</span></dt><dd><span>{{vm.albumInfo.isSingleImage}}</span></dd><dt><span translate=\"tikonApp.albumInfo.caption\">Caption</span></dt><dd><span>{{vm.albumInfo.caption}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/album-info/album-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAlbumInfoLabel\" translate=\"tikonApp.albumInfo.home.createOrEditLabel\">Create or edit a Album Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.albumInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.albumInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.albumInfo.isSingleImage\" for=\"field_isSingleImage\">Is Single Image</label><input type=\"checkbox\" class=\"form-control\" name=\"isSingleImage\" id=\"field_isSingleImage\" ng-model=\"vm.albumInfo.isSingleImage\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.albumInfo.caption\" for=\"field_caption\">Caption</label><input type=\"text\" class=\"form-control\" name=\"caption\" id=\"field_caption\" ng-model=\"vm.albumInfo.caption\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/album-info/album-infos.html","<div><h2 translate=\"tikonApp.albumInfo.home.title\">Album Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"album-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.albumInfo.home.createLabel\">Create new Album Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.albumInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isSingleImage\"><span translate=\"tikonApp.albumInfo.isSingleImage\">Is Single Image</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"caption\"><span translate=\"tikonApp.albumInfo.caption\">Caption</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"albumInfo in vm.albumInfos track by albumInfo.id\"><td><a ui-sref=\"album-info-detail({id:albumInfo.id})\">{{albumInfo.id}}</a></td><td>{{albumInfo.isSingleImage}}</td><td>{{albumInfo.caption}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"album-info-detail({id:albumInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"album-info.edit({id:albumInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"album-info.delete({id:albumInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/album-info/single-album-info.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAlbumInfoLabel\" translate=\"tikonApp.albumInfo.home.createOrEditLabel\">Create or edit a Album Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.albumInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.albumInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.albumInfo.isSingleImage\" for=\"field_isSingleImage\">Is Single Image</label><input type=\"checkbox\" class=\"form-control\" name=\"isSingleImage\" id=\"field_isSingleImage\" ng-model=\"vm.albumInfo.isSingleImage\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.albumInfo.caption\" for=\"field_caption\">Caption</label><input type=\"text\" class=\"form-control\" name=\"caption\" id=\"field_caption\" ng-model=\"vm.albumInfo.caption\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/bank-account-info/bank-account-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.bankAccountInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.bankAccountInfo.delete.question\" translate-values=\"{id: \'{{vm.bankAccountInfo.id}}\'}\">Are you sure you want to delete this Bank Account Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/bank-account-info/bank-account-info-detail.html","<div><h2><span translate=\"tikonApp.bankAccountInfo.detail.title\">Bank Account Info</span> {{vm.bankAccountInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.bankAccountInfo.ownerTitle\">Owner Title</span></dt><dd><span>{{vm.bankAccountInfo.ownerTitle}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.createDate\">Create Date</span></dt><dd><span>{{vm.bankAccountInfo.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.bankName\">Bank Name</span></dt><dd><span>{{vm.bankAccountInfo.bankName}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.accountType\">Account Type</span></dt><dd><span translate=\"{{\'tikonApp.BankAccountType.\' + vm.bankAccountInfo.accountType}}\">{{vm.bankAccountInfo.accountType}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.accountNo\">Account No</span></dt><dd><span>{{vm.bankAccountInfo.accountNo}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.cardNo\">Card No</span></dt><dd><span>{{vm.bankAccountInfo.cardNo}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.shabaNo\">Shaba No</span></dt><dd><span>{{vm.bankAccountInfo.shabaNo}}</span></dd><dt><span translate=\"tikonApp.bankAccountInfo.description\">Description</span></dt><dd><span>{{vm.bankAccountInfo.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/bank-account-info/bank-account-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBankAccountInfoLabel\" translate=\"tikonApp.bankAccountInfo.home.createOrEditLabel\">Create or edit a Bank Account Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.bankAccountInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.bankAccountInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.ownerTitle\" for=\"field_ownerTitle\">Owner Title</label><input type=\"text\" class=\"form-control\" name=\"ownerTitle\" id=\"field_ownerTitle\" ng-model=\"vm.bankAccountInfo.ownerTitle\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.bankAccountInfo.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.bankName\" for=\"field_bankName\">Bank Name</label><input type=\"text\" class=\"form-control\" name=\"bankName\" id=\"field_bankName\" ng-model=\"vm.bankAccountInfo.bankName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.accountType\" for=\"field_accountType\">Account Type</label><select class=\"form-control\" name=\"accountType\" ng-model=\"vm.bankAccountInfo.accountType\" id=\"field_accountType\"><option value=\"DEPOSIT\" translate=\"tikonApp.BankAccountType.DEPOSIT\">DEPOSIT</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.accountNo\" for=\"field_accountNo\">Account No</label><input type=\"text\" class=\"form-control\" name=\"accountNo\" id=\"field_accountNo\" ng-model=\"vm.bankAccountInfo.accountNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.cardNo\" for=\"field_cardNo\">Card No</label><input type=\"text\" class=\"form-control\" name=\"cardNo\" id=\"field_cardNo\" ng-model=\"vm.bankAccountInfo.cardNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.shabaNo\" for=\"field_shabaNo\">Shaba No</label><input type=\"text\" class=\"form-control\" name=\"shabaNo\" id=\"field_shabaNo\" ng-model=\"vm.bankAccountInfo.shabaNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.bankAccountInfo.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/bank-account-info/bank-account-infos.html","<div><h2 translate=\"tikonApp.bankAccountInfo.home.title\">Bank Account Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"bank-account-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.bankAccountInfo.home.createLabel\">Create new Bank Account Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.bankAccountInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ownerTitle\"><span translate=\"tikonApp.bankAccountInfo.ownerTitle\">Owner Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.bankAccountInfo.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"bankName\"><span translate=\"tikonApp.bankAccountInfo.bankName\">Bank Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"accountType\"><span translate=\"tikonApp.bankAccountInfo.accountType\">Account Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"accountNo\"><span translate=\"tikonApp.bankAccountInfo.accountNo\">Account No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cardNo\"><span translate=\"tikonApp.bankAccountInfo.cardNo\">Card No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shabaNo\"><span translate=\"tikonApp.bankAccountInfo.shabaNo\">Shaba No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.bankAccountInfo.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"bankAccountInfo in vm.bankAccountInfos track by bankAccountInfo.id\"><td><a ui-sref=\"bank-account-info-detail({id:bankAccountInfo.id})\">{{bankAccountInfo.id}}</a></td><td>{{bankAccountInfo.ownerTitle}}</td><td>{{bankAccountInfo.createDate | date:\'medium\'}}</td><td>{{bankAccountInfo.bankName}}</td><td translate=\"{{\'tikonApp.BankAccountType.\' + bankAccountInfo.accountType}}\">{{bankAccountInfo.accountType}}</td><td>{{bankAccountInfo.accountNo}}</td><td>{{bankAccountInfo.cardNo}}</td><td>{{bankAccountInfo.shabaNo}}</td><td>{{bankAccountInfo.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"bank-account-info-detail({id:bankAccountInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"bank-account-info.edit({id:bankAccountInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"bank-account-info.delete({id:bankAccountInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/bank-account-info/company-bank-account-info-v2.html","<style>@media screen and (min-width: 768px) {\n        .gateway-percent {\n            padding-top: 40px;\n        }\n    }</style><eo-pl-modal-header title=\"\'supplierPanel.sideMenu.companyInfo.companyBankAccountInfo\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companyBankAccountInfo\">supplierPanel.sideMenu.companyInfo.companyBankAccountInfo</div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar>--><jhi-alert-error></jhi-alert-error><div class=\"\"><!--<div ng-if=\"vm.currentCompany.paymentGatewayAccess != \'ACCESS_ALL\'\">--><!--<md-button class=\"md-raised md-primary pl-btn pl-btn-primary\"--><!--ng-click=\"vm.goToRequestForm()\">--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-save\"></span>&nbsp;&ndash;&gt;--><!--<span>درخواست فعالسازی درگاه اشتراکی</span>--><!--</md-button>--><!--</div>--><fieldset class=\"standard-fieldset\"><legend translate=\"tikonApp.bankAccountInfo.fieldsets.privateGatewaySettings\">accountInfoToPayoff</legend><div class=\"row\"><div class=\"col-sm-6\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.title\" for=\"dropdown_gateWay\">dropdown_gateWay</label><md-select class=\"rwMdSelect\" ng-model=\"vm.bankAccountInfo.gateway\" id=\"dropdown_gateWay\" ng-change=\"vm.onGatewayChange()\"><md-option value=\"NONE\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.NONE\" selected=\"true\">NONE</md-option><md-option ng-disabled=\"vm.currentCompany.paymentGatewayAccess != \'ACCESS_ALL\'\" value=\"RESERWEB_DEFAULT_GATEWAY\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.reserwebDefaultGateWay\">reserwebDefaultGateWay</md-option><md-option value=\"SUPPLIER_PAYPING\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.supplierPayPing\">supplierPayPing</md-option><md-option value=\"SUPPLIER_ZARRINPAL\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.supplierZarrinPal\">supplierZarrinPal</md-option><md-option value=\"SUPPLIER_JIBIMO\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.supplierJibimo\">supplierJibimo</md-option><md-option value=\"SUPPLIER_AP\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.SUPPLIER_AP\">supplierAP</md-option><md-option value=\"SUPPLIER_SEP\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.SUPPLIER_SEP\">supplierSEP</md-option></md-select><div class=\"form-field-description\" style=\"padding-bottom: 10px\" ng-if=\"vm.bankAccountInfo.gateway == \'NONE\'\">* در این حالت مشتریان گزینه پرداخت در محل را انتخاب خواهند کرد</div></div><div ng-if=\"vm.bankAccountInfo.gateway == \'RESERWEB_DEFAULT_GATEWAY\'\" class=\"form-group col-sm-6 gateway-percent\"><div>* میزان کارمزد: <span style=\"font-weight:bold\"><span class=\"font-bold\">{{ vm.bankAccountInfo.feePercent ? vm.bankAccountInfo.feePercent : 5 }}</span>%</span></div></div><div class=\"form-group col-sm-6\" ng-if=\"vm.bankAccountInfo.gateway !== \'RESERWEB_DEFAULT_GATEWAY\' && vm.bankAccountInfo.gateway !== \'NONE\'\"><label ng-if=\"vm.bankAccountInfo.gateway != \'SUPPLIER_SEP\' && vm.bankAccountInfo.gateway != \'SUPPLIER_AP\'\" class=\"control-label\" translate=\"tikonApp.bankAccountInfo.gatewayAccessToken\" for=\"accessToken\">accessToken</label><label ng-if=\"vm.bankAccountInfo.gateway == \'SUPPLIER_AP\'\" class=\"control-label\" translate=\"tikonApp.bankAccountInfo.ap.terminalId\" for=\"accessToken\">accessToken</label><label ng-if=\"vm.bankAccountInfo.gateway == \'SUPPLIER_SEP\'\" class=\"control-label\" translate=\"tikonApp.bankAccountInfo.gatewayTerminalId\" for=\"accessToken\">accessToken</label><input type=\"text\" class=\"form-control\" name=\"accessToken\" id=\"accessToken\" ng-model=\"vm.bankAccountInfo.gatewayAccessToken\"></div></div><div class=\"row\" ng-if=\"vm.bankAccountInfo.gateway == \'SUPPLIER_AP\'\"><div class=\"form-group col-sm-4\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.ap.user\" for=\"user\">user</label><input type=\"text\" class=\"form-control\" name=\"user\" id=\"user\" ng-model=\"vm.bankAccountInfo.gatewaySettingObject.user\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.ap.password\" for=\"password\">password</label><input type=\"text\" class=\"form-control\" name=\"password\" id=\"password\" ng-model=\"vm.bankAccountInfo.gatewaySettingObject.password\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.ap.merchantConfigurationId\" for=\"merchantConfigurationId\">merchantConfigurationId</label><input type=\"text\" class=\"form-control\" name=\"merchantConfigurationId\" id=\"merchantConfigurationId\" ng-model=\"vm.bankAccountInfo.gatewaySettingObject.merchantConfigurationId\"></div></div><div class=\"row\" ng-if=\"vm.bankAccountInfo.gateway == \'SUPPLIER_SEP\'\"><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.sep.password\" for=\"sepPassword\">sepPassword</label><input type=\"text\" class=\"form-control\" name=\"sepPassword\" id=\"sepPassword\" ng-model=\"vm.bankAccountInfo.gatewaySettingObject.password\"></div></div></fieldset><fieldset class=\"standard-fieldset\" ng-if=\"vm.bankAccountInfo.gateway == \'RESERWEB_DEFAULT_GATEWAY\'\"><legend translate=\"tikonApp.bankAccountInfo.fieldsets.accountInfoToPayoff\">privateGatewaySettings</legend><div class=\"row\"><div class=\"form-group col-sm-4\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.ownerTitle\" for=\"field_ownerTitle\">Owner Title</label><input type=\"text\" class=\"form-control\" name=\"ownerTitle\" id=\"field_ownerTitle\" ng-model=\"vm.bankAccountInfo.ownerTitle\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.ownerNationalCode\" for=\"field_ownerTitle\">Owner National Code</label><input type=\"text\" class=\"form-control\" name=\"ownerNationalCode\" id=\"field_ownerNationalCode\" ng-model=\"vm.bankAccountInfo.ownerNationalCode\" maxlength=\"10\" minlength=\"10\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.ownerPhoneNumber\" for=\"field_ownerPhoneNumber\">Owner Phone Number</label><input type=\"text\" class=\"form-control\" name=\"ownerPhoneNumber\" id=\"field_ownerPhoneNumber\" ng-model=\"vm.bankAccountInfo.ownerPhoneNumber\" maxlength=\"11\" minlength=\"11\"></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.ownerAddress\" for=\"field_ownerAddress\">ownerAddress</label><input type=\"text\" class=\"form-control\" name=\"ownerAddress\" id=\"field_ownerAddress\" ng-model=\"vm.bankAccountInfo.ownerAddress\"></div></div><div class=\"row\"><div class=\"form-group col-sm-4\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.shabaNo\" for=\"field_shabaNo\">Shaba No</label><input type=\"text\" class=\"form-control\" name=\"shabaNo\" id=\"field_shabaNo\" ng-model=\"vm.bankAccountInfo.shabaNo\" placeholder=\"IR590640011101110001111001\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.cardNo\" for=\"field_cardNo\">Card No</label><input type=\"text\" class=\"form-control\" name=\"cardNo\" id=\"field_cardNo\" ng-model=\"vm.bankAccountInfo.cardNo\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.bankName\" for=\"field_bankName\">Bank Name</label><input type=\"text\" class=\"form-control\" name=\"bankName\" id=\"field_bankName\" ng-model=\"vm.bankAccountInfo.bankName\"></div></div></fieldset></div><!--<div class=\"modal-footer\">--><!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>--><!--</button>--><!--<button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">--><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>--><!--</button>--><!--</div>--></form></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/bank-account-info/company-bank-account-info-v3.html","<style>#main-content {padding-top: 15px!important;}\n    @media screen and (max-width: 768px) {\n        #main-content {\n            padding-top: 70px!important;\n        }\n    }\n    html {\n        font-size: 1rem!important;\n    }</style><div id=\"container-kyc\"><panel-pln-kyc id=\"kyc\"></panel-pln-kyc></div>");
$templateCache.put("app/entities/bank-account-info/company-bank-account-info.html","<div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companyBankAccountInfo\">supplierPanel.sideMenu.companyInfo.companyBankAccountInfo</div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar>--><jhi-alert-error></jhi-alert-error><md-content class=\"rwMdContent\"><fieldset class=\"standard-fieldset\"><legend translate=\"tikonApp.bankAccountInfo.fieldsets.privateGatewaySettings\">accountInfoToPayoff</legend><div class=\"row\"><div class=\"col-sm-6\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.title\" for=\"dropdown_gateWay\">dropdown_gateWay</label><md-select class=\"rwMdSelect\" ng-model=\"vm.bankAccountInfo.gateway\" id=\"dropdown_gateWay\"><md-option value=\"RESERWEB_DEFAULT_GATEWAY\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.reserwebDefaultGateWay\" selected=\"true\">reserwebDefaultGateWay</md-option><md-option value=\"SUPPLIER_PAYPING\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.supplierPayPing\">supplierPayPing</md-option><md-option value=\"SUPPLIER_ZARRINPAL\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.supplierZarrinPal\">supplierZarrinPal</md-option><md-option value=\"SUPPLIER_JIBIMO\" translate=\"tikonApp.bankAccountInfo.onlinePaymentGateway.supplierJibimo\">supplierJibimo</md-option></md-select></div><div class=\"form-group col-sm-6\" ng-if=\"vm.bankAccountInfo.gateway !== \'RESERWEB_DEFAULT_GATEWAY\'\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.gatewayAccessToken\" for=\"accessToken\">accessToken</label><input type=\"text\" class=\"form-control\" name=\"accessToken\" id=\"accessToken\" ng-model=\"vm.bankAccountInfo.gatewayAccessToken\"></div></div></fieldset><fieldset class=\"standard-fieldset\" ng-if=\"vm.bankAccountInfo.gateway == \'RESERWEB_DEFAULT_GATEWAY\'\"><legend translate=\"tikonApp.bankAccountInfo.fieldsets.accountInfoToPayoff\">privateGatewaySettings</legend><div class=\"row\"><div class=\"form-group col-sm-6\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.ownerTitle\" for=\"field_ownerTitle\">Owner Title</label><input type=\"text\" class=\"form-control\" name=\"ownerTitle\" id=\"field_ownerTitle\" ng-model=\"vm.bankAccountInfo.ownerTitle\"></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.bankName\" for=\"field_bankName\">Bank Name</label><input type=\"text\" class=\"form-control\" name=\"bankName\" id=\"field_bankName\" ng-model=\"vm.bankAccountInfo.bankName\"></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.shabaNo\" for=\"field_shabaNo\">Shaba No</label><input type=\"text\" class=\"form-control\" name=\"shabaNo\" id=\"field_shabaNo\" ng-model=\"vm.bankAccountInfo.shabaNo\" placeholder=\"IR590640011101110001111001\"></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" required translate=\"tikonApp.bankAccountInfo.cardNo\" for=\"field_cardNo\">Card No</label><input type=\"text\" class=\"form-control\" name=\"cardNo\" id=\"field_cardNo\" ng-model=\"vm.bankAccountInfo.cardNo\"></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.accountNo\" for=\"field_accountNo\">Account No</label><input type=\"text\" class=\"form-control\" name=\"accountNo\" id=\"field_accountNo\" ng-model=\"vm.bankAccountInfo.accountNo\"></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"tikonApp.bankAccountInfo.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.bankAccountInfo.description\"></div></div></fieldset></md-content><!--<div class=\"modal-footer\">--><!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>--><!--</button>--><!--<button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">--><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>--><!--</button>--><!--</div>--></form></div></div></div>");
$templateCache.put("app/entities/base-components-showcase/base-components-showcase.html","<div><panel-pln-base-components-showcase style=\"overflow: auto\"></panel-pln-base-components-showcase></div>");
$templateCache.put("app/entities/canceling-info/canceling-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.cancelingInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.cancelingInfo.delete.question\" translate-values=\"{id: \'{{vm.cancelingInfo.id}}\'}\">Are you sure you want to delete this Canceling Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/canceling-info/canceling-info-detail.html","<div><h2><span translate=\"tikonApp.cancelingInfo.detail.title\">Canceling Info</span> {{vm.cancelingInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.cancelingInfo.description\">Description</span></dt><dd><span>{{vm.cancelingInfo.description}}</span></dd><dt><span translate=\"tikonApp.cancelingInfo.status\">Status</span></dt><dd><span>{{vm.cancelingInfo.status}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/canceling-info/canceling-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCancelingInfoLabel\" translate=\"tikonApp.cancelingInfo.home.createOrEditLabel\">Create or edit a Canceling Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.cancelingInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.cancelingInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.cancelingInfo.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.cancelingInfo.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.cancelingInfo.status\" for=\"field_status\">Status</label><input type=\"number\" class=\"form-control\" name=\"status\" id=\"field_status\" ng-model=\"vm.cancelingInfo.status\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/canceling-info/canceling-infos.html","<div><h2 translate=\"tikonApp.cancelingInfo.home.title\">Canceling Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"canceling-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.cancelingInfo.home.createLabel\">Create new Canceling Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.cancelingInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.cancelingInfo.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.cancelingInfo.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"cancelingInfo in vm.cancelingInfos track by cancelingInfo.id\"><td><a ui-sref=\"canceling-info-detail({id:cancelingInfo.id})\">{{cancelingInfo.id}}</a></td><td>{{cancelingInfo.description}}</td><td>{{cancelingInfo.status}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"canceling-info-detail({id:cancelingInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"canceling-info.edit({id:cancelingInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"canceling-info.delete({id:cancelingInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/capacity-exception/capacity-exception-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.capacityException.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.capacityException.delete.question\" translate-values=\"{id: \'{{vm.capacityException.id}}\'}\">Are you sure you want to delete this Capacity Exception?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/capacity-exception/capacity-exception-detail.html","<div><h2><span translate=\"tikonApp.capacityException.detail.title\">Capacity Exception</span> {{vm.capacityException.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.capacityException.exceptionType\">Exception Type</span></dt><dd><span>{{vm.capacityException.exceptionType}}</span></dd><dt><span translate=\"tikonApp.capacityException.reserveTime\">Reserve Time</span></dt><dd><span>{{vm.capacityException.reserveTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.capacityException.newQty\">New Qty</span></dt><dd><span>{{vm.capacityException.newQty}}</span></dd><dt><span translate=\"tikonApp.capacityException.serviceCapacityInfo\">Service Capacity Info</span></dt><dd><a ui-sref=\"service-capacity-info-detail({id:vm.capacityException.serviceCapacityInfoId})\">{{vm.capacityException.serviceCapacityInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/capacity-exception/capacity-exception-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCapacityExceptionLabel\" translate=\"tikonApp.capacityException.home.createOrEditLabel\">Create or edit a Capacity Exception</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.capacityException.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.capacityException.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.capacityException.exceptionType\" for=\"field_exceptionType\">Exception Type</label><input type=\"number\" class=\"form-control\" name=\"exceptionType\" id=\"field_exceptionType\" ng-model=\"vm.capacityException.exceptionType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.capacityException.reserveTime\" for=\"field_reserveTime\">Reserve Time</label><div class=\"input-group\"><input id=\"field_reserveTime\" type=\"text\" class=\"form-control\" name=\"reserveTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.capacityException.reserveTime\" is-open=\"vm.datePickerOpenStatus.reserveTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'reserveTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.capacityException.newQty\" for=\"field_newQty\">New Qty</label><input type=\"number\" class=\"form-control\" name=\"newQty\" id=\"field_newQty\" ng-model=\"vm.capacityException.newQty\"></div><div class=\"form-group\"><label translate=\"tikonApp.capacityException.serviceCapacityInfo\" for=\"field_serviceCapacityInfo\">Service Capacity Info</label><select class=\"form-control\" id=\"field_serviceCapacityInfo\" name=\"serviceCapacityInfo\" ng-model=\"vm.capacityException.serviceCapacityInfoId\" ng-options=\"serviceCapacityInfo.id as serviceCapacityInfo.id for serviceCapacityInfo in vm.servicecapacityinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/capacity-exception/capacity-exceptions.html","<div><h2 translate=\"tikonApp.capacityException.home.title\">Capacity Exceptions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"capacity-exception.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.capacityException.home.createLabel\">Create new Capacity Exception</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.capacityException.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"exceptionType\"><span translate=\"tikonApp.capacityException.exceptionType\">Exception Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reserveTime\"><span translate=\"tikonApp.capacityException.reserveTime\">Reserve Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"newQty\"><span translate=\"tikonApp.capacityException.newQty\">New Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceCapacityInfoId\"><span translate=\"tikonApp.capacityException.serviceCapacityInfo\">Service Capacity Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"capacityException in vm.capacityExceptions track by capacityException.id\"><td><a ui-sref=\"capacity-exception-detail({id:capacityException.id})\">{{capacityException.id}}</a></td><td>{{capacityException.exceptionType}}</td><td>{{capacityException.reserveTime | date:\'medium\'}}</td><td>{{capacityException.newQty}}</td><td><a ui-sref=\"service-capacity-info-detail({id:capacityException.serviceCapacityInfoId})\">{{capacityException.serviceCapacityInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"capacity-exception-detail({id:capacityException.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"capacity-exception.edit({id:capacityException.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"capacity-exception.delete({id:capacityException.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/commission/calculate-commission.html","<style></style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\" ok-title=\"\'tikonApp.commission.calculate\'\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span style=\"display: inline-block\">{{vm.getModalTitle() | translate}}</span></div><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><form name=\"editForm\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div><div class=\"row\"><div class=\"col-sm-4 col-small-h\" data-ng-if=\"vm.servantList\"><label class=\"control-label\" required translate=\"tikonApp.commission.servant\" for=\"field_servant\">servant</label><md-input-container class=\"full-width\" style=\"margin: 0\"><md-select class=\"rwMdSelect\" required placeholder=\"{{\'tikonApp.commission.selectServant\' | translate}}\" ng-model=\"vm.servant.id\" ng-change=\"vm.onServant_changed()\" id=\"field_servant\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servantList\">{{si.servantName}}</md-option></md-select></md-input-container><!--<select>--><!--<option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.servantList\">--><!--{{si.servantName}}--><!--</option>--><!--</select>--></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.commission.calculateFrom\" for=\"field_fromDate\">fromDate</label><div><eo-date-picker id=\"field_fromDate\" date-value=\"vm.fromDate\"></eo-date-picker></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.commission.calculateTo\" for=\"field_toDate\">fromValidDate</label><div><eo-date-picker id=\"field_toDate\" date-value=\"vm.toDate\"></eo-date-picker></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><md-switch class=\"auto-payment-switch\" style=\"white-space: normal\" ng-model=\"vm.calculateFinalizeInvoices\">فقط فاکتورهای نهایی شده محاسبه شوند</md-switch></div></div><!--<div style=\"text-align: center;padding: 10px\">--><!--<md-button type=\"button\"--><!--ng-click=\"vm.save()\" style=\"width: 200px; height: 40px;\"--><!--class=\"md-raised md-primary pl-btn pl-btn-ordinary\"--><!--ng-disabled=\"editForm.$invalid || vm.isSaving\"--><!--&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--<span translate=\"tikonApp.commission.calculate\">calculate</span>--><!--</md-button>--><!--</div>--><div ng-if=\"vm.calculatedCommission\" style=\"text-align: center;padding: 10px;font-size: 16px;border: 2px solid\"><span translate=\"tikonApp.commission.totalCalculatedCommissionAmount\">totalCalculatedCommissionAmount</span> <span style=\"font-weight: bold\">: {{vm.calculatedCommission.totalCommissionAmount | number}} </span><span translate=\"global.currencyBracket\">currencyBracket</span></div><div id=\"items\" ng-if=\"vm.calculatedCommission.calculatedCommissionItems\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend><span>جزئیات</span></legend><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.calculatedCommission.calculatedCommissionItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"></th></tr><tr class=\"pl-table-header\"><th st-sort=\"id\"><span translate=\"tikonApp.invoiceInfo.invoiceId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"invoiceDate\"><span translate=\"tikonApp.invoiceInfo.invoiceDate\">invoiceDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customer\"><span translate=\"tikonApp.invoiceInfo.customer\">customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"title\"><span translate=\"tikonApp.invoiceInfoItem.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"price\"><span translate=\"tikonApp.invoiceInfoItem.price\">price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"commissionAmount\"><span translate=\"tikonApp.commission.commissionFormula\">commissionFormula</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"calculatedCommissionAmount\"><span translate=\"tikonApp.commission.calculatedCommissionAmount\">calculatedCommissionAmount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in collection\"><td>{{item.invoiceInfoItem.invoiceInfo.id}}<div ng-class=\"vm.findInvoiceInfoStatusStyle(item.invoiceInfoItem.invoiceInfo.status)\" style=\"font-size: 8px;    background: transparent; border: none\" translate=\"{{\'tikonApp.invoiceStatus.\' + item.invoiceInfoItem.invoiceInfo.status}}\">{{item.invoiceInfoItem.invoiceInfo.status}}</div></td><td>{{item.invoiceInfoItem.invoiceInfo.invoiceDate |toPersianDate}}</td><td>{{item.invoiceInfoItem.invoiceInfo.customer.personalInfo.fisrtName}} {{item.invoiceInfoItem.invoiceInfo.customer.personalInfo.lastName}}</td><td>{{item.invoiceInfoItem.title}}</td><td>{{item.invoiceInfoItem.price | number}}</td><td>{{item.commissionItem.amount | number}} <span ng-if=\"item.commissionItem.commissionType\">{{\'tikonApp.commissionType.\'+item.commissionItem.commissionType+\'_SHORT\' | translate}}</span></td><td>{{item.commissionAmount | number}}</td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"20\"></div></td></tr></tfoot></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\"--><!--total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"--><!--ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div></fieldset></div></div></div></div></form></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\" ok-title=\"\'tikonApp.commission.calculate\'\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/commission/commission-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.commission.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.commission.delete.question\" translate-values=\"{id: \'{{vm.commission.id}}\'}\">Are you sure you want to delete this Company Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/commission/commission-list.html","<div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.commission.home.title\">tikonApp.commission.home.title</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newCommission()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.commission.home.new\">Create new commission</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.calculateCommission\"><span><md-icon>payments</md-icon></span><span translate=\"tikonApp.commission.home.calculateCommission\">calculateCommission</span></md-button></div></div></div><jhi-alert></jhi-alert><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.commissions\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.commission.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"title\"><span translate=\"tikonApp.commission.fromValidDate\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"servant\"><span translate=\"tikonApp.commission.servant\">servant</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.commission.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"commission in collection track by commission.id\"><td><a ng-click=\"vm.editCommission(commission)\">{{commission.id }}</a></td><td>{{commission.fromValidDate | toPersianDate}}</td><td>{{commission.servant.personInfo.fullName}}</td><td><span translate=\"{{\'tikonApp.commissionStatus.\' + commission.status}}\">{{commission.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editCommission(commission)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.deleteCommission({id:commission.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newCommission()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 coupon-list-title\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.commission.home.title\">title-list</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.calculateCommission\"><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--> محاسبه کمیسیون</md-button><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.setting\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.commission.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"commission in vm.commissions track by commission.id\" class=\"customer-list-item\" ng-click=\"vm.editCommission(commission)\"><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\">{{commission.id}}</div><div class=\"customer-list-customer-name\">{{commission.fromValidDate | toPersianDate }}</div></div><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\" style=\"font-size: 16px\"><span>{{commission.servant.personInfo.fullName}}</span></div></div><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\"><span translate=\"{{\'tikonApp.commissionStatus.\' + commission.status}}\">{{commission.status}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/commission/commission.html","<style>md-select.md-default-theme[disabled] .md-select-value, md-select[disabled] .md-select-value {\n        color: rgb(0 0 0) !important;\n        background-image: none !important;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-icon, md-select[disabled] .md-select-icon {\n        display: none;\n    }\n\n    .delete-item {\n        margin: 24px 0px 1px 0px;\n        /* color: red; */\n        float: right;\n        border: none;\n        font-size: 20px;\n    }\n\n    @media screen and (max-width: 768px) {\n        .delete-item {\n            width: unset;\n        }\n    }</style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.commission && vm.commission.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\"><span translate=\"tikonApp.commission.home.editTitle\"></span> : {{vm.commission.id}}</div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.editCommission.delete({id:vm.commission.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span style=\"display: inline-block\">{{vm.getModalTitle() | translate}}</span></div><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><form name=\"editForm\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div><div class=\"row\"><div class=\"col-sm-4 col-small-h\" data-ng-if=\"vm.servantList\"><label class=\"control-label\" required translate=\"tikonApp.commission.servant\" for=\"field_servant\">servant</label><md-input-container class=\"full-width\" style=\"margin: 0\"><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.commission.selectServant\' | translate}}\" ng-model=\"vm.commission.servant.id\" ng-change=\"vm.onServant_changed()\" id=\"field_servant\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servantList\">{{si.servantName}}</md-option></md-select></md-input-container><div class=\"form-field-description\" ng-if=\"vm.lastCommission\">*آخرین کمیسیون ثبت شده با تاریخ اعتبار {{vm.lastCommission.fromValidDate | toPersianDate}} است</div><!--<select>--><!--<option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.servantList\">--><!--{{si.servantName}}--><!--</option>--><!--</select>--></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.commission.fromValidDate\" for=\"field_fromValidDate\">fromValidDate</label><div><eo-date-picker id=\"field_fromValidDate\" date-value=\"vm.commission.fromValidDate\"></eo-date-picker></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.commission.status\" for=\"field_status\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.commission.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.commissionStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.commissionStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><!--<div  style=\"color: var(&#45;&#45;rw-planovin-dark-color); font-size: 13px;\">--><!--</div>--><div style=\"text-align: center\"><md-button type=\"button\" ng-click=\"vm.selectBatchItem()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.commission.newItem\">newItem</span></md-button></div><div id=\"services\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.commission.itemsList\"></span></legend><div ng-if=\"vm.commission.items && vm.commission.items.length > 0\" ng-repeat=\"item in vm.commission.items\"><div class=\"row\"><div class=\"col-md-5 col-xs-12\" style=\"display: flex\"><md-button type=\"button\" ng-click=\"vm.deleteItem(item)\" class=\"md-raised pl-btn-default pl-btn md-button md-ink-ripple pl-btn-auto delete-item\"><span class=\"glyphicon glyphicon-remove\" style=\"color: red\"></span><!--<span translate=\"tikonApp.commission.deleteItem\">delete</span>--></md-button><div style=\"width: 100%\" data-ng-if=\"vm.serviceList && item.type==\'SERVICE\'\"><label class=\"control-label\" required translate=\"tikonApp.commission.serviceItem\" for=\"field_serviceItem\">servant</label><md-input-container class=\"full-width\" style=\"margin: 0\"><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.commission.selectServices\' | translate}}\" ng-model=\"item.referencedItemId\" id=\"field_serviceItem\" disabled=\"true\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceList\">{{si.itemTitle}}</md-option></md-select></md-input-container></div><div style=\"width: 100%\" data-ng-if=\"vm.serviceAddOnList && item.type==\'SERVICE_ADD_ON\'\"><label class=\"control-label\" required translate=\"tikonApp.commission.serviceAddOn\" for=\"field_serviceAddOn\">servant</label><md-input-container class=\"full-width\" style=\"margin: 0\"><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.commission.selectServiceAddOn\' | translate}}\" ng-model=\"item.referencedItemId\" id=\"field_serviceAddOn\" disabled=\"true\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceAddOnList\">{{si.title}}</md-option></md-select></md-input-container></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.commission.commissionType\" for=\"field_commissionType\">commissionType</label><md-select class=\"rwMdSelect\" ng-model=\"item.commissionType\" style=\"margin-top: 6px\" id=\"field_commissionType\"><md-option value=\"PERCENT\" translate=\"tikonApp.commissionType.PERCENT\">PERCENT</md-option><md-option value=\"CASH\" translate=\"tikonApp.commissionType.CASH\">CASH</md-option></md-select></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.commission.amount\" for=\"field_amount\">Amount</label><!--<input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\"--><!--ng-model=\"vm.coupon.amount\" min=\"0\"--><!--/>--><div style=\"display: flex;align-items: center;gap: 10px\"><eo-numeric-input-v2 id=\"field_amount\" name=\"amount\" custom-class=\"form-control\" input-value=\"item.amount\" form-reference=\"editForm\" is-required=\"true\" currency-format=\"true\"></eo-numeric-input-v2><div ng-if=\"item.commissionType == \'CASH\'\">(تومان)</div><div ng-if=\"item.commissionType == \'PERCENT\'\">(درصد)</div></div></div></div></div><hr style=\"margin: 0\"></div><div ng-if=\"!vm.commission.items || vm.commission.items.length ==0 \"><eo-no-data message=\"vm.itemListEmptyMessage\"></eo-no-data></div></fieldset></div></div></div></div></form></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/commission/select-batch-item-modal.html","<style>md-icon {\n        color: unset;\n    }</style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><jhi-alert-error></jhi-alert-error><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><form name=\"editForm\"><div class=\"row\" style=\"padding-top: 80px\"><div class=\"col-md-6 invoice-selection-items-container\"><ul class=\"pl-nav-tabs\"><li class=\"active\" ng-click=\"vm.tabChanged(\'serviceTab\')\"><a data-target=\"#serviceTab\" data-toggle=\"tab\"><md-icon>business_center</md-icon>خدمات</a></li><li ng-click=\"vm.tabChanged(\'serviceAddOnTab\')\"><a data-target=\"#serviceAddOnTab\" data-toggle=\"tab\"><md-icon>star</md-icon><span>خدمات ویژه</span></a></li></ul><div class=\"tab-pane active\" style=\"background: none\" id=\"serviceTab\"><div class=\"container-fluid pl-container-fluid\"><div id=\"selectServiceItem\" class=\"row\" ng-if=\"vm.itemSelectionType==\'SERVICE\'\"><div><div class=\"col-md-12\"><label class=\"control-label\">جستجو</label><pf-service-item-picker selected-service=\"vm.selectedServiceItem\" is-disabled=\"false\" servant-id=\"null\" on-service-changed=\"vm.onServiceChanged()\"></pf-service-item-picker><div class=\"invoice-item-selection-container\"><div id=\"serviceListId\" ng-repeat=\"si in vm.serviceItemList\"><div ng-click=\"vm.onServiceItemClick(si)\" class=\"invoice-item-service-selection\"><div ng-class=\"si.color\" class=\"invoice-item-select-service-color-circle\"></div><div>{{si.itemTitle}}</div></div></div></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"serviceAddOnTab\"><div class=\"container-fluid pl-container-fluid\"><div id=\"selectServiceAddOn\" class=\"row\" ng-if=\"vm.itemSelectionType==\'SERVICE_ADD_ON\'\"><div class=\"col-md-12\"><div class=\"invoice-item-selection-container\" ng-if=\"vm.serviceAddOnList && vm.serviceAddOnList.length > 0\"><div id=\"serviceAddOnListId\" ng-repeat=\"si in vm.serviceAddOnList\"><div ng-click=\"vm.onServiceAddOnClick(si)\" class=\"invoice-item-service-selection\"><div ng-class=\"\'COLOR\'\" class=\"invoice-item-select-service-color-circle\"></div><div>{{si.title}}</div></div></div></div><div ng-if=\"!vm.serviceAddOnList || vm.serviceAddOnList.length == 0\"><eo-no-data message=\"vm.noServiceAddOnMsg\"></eo-no-data><div style=\"text-align: center\"><md-button type=\"button\" ng-click=\"vm.goToServiceAddOn()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.serviceAddOn.home.new\">new</span></md-button></div></div></div></div></div></div></div><div class=\"col-md-6\"><div class=\"pl-panel\" style=\"margin: 0\"><div class=\"panel-heading pl-panel-heading\">آیتم های انتخاب شده</div><div class=\"panel-body pl-panel-body\" style=\"padding: 50px 6px\"><div ng-if=\"vm.items && vm.items.length > 0\" class=\"table-responsive\"><table class=\"table rwTable\"><thead><th><span translate=\"tikonApp.commission.addBatchItem.itemTitle\"></span></th><th><span translate=\"tikonApp.commission.addBatchItem.itemType\"></span></th><th></th><!--<th><span translate=\"tikonApp.invoiceInfoItem.qty\"></span></th>--><!--<th></th>--></thead><tbody><tr ng-repeat=\"item in vm.items\"><td><span>{{item.title}}</span></td><td><span>{{\'tikonApp.commissionItemType.\'+ item.type | translate}}</span></td><td><span ng-click=\"vm.deleteItem(item)\"><i style=\"color: red\" class=\"fa fa-remove\"></i></span></td></tr></tbody></table></div><div ng-if=\"!vm.items || vm.items.length == 0\"><eo-no-data message=\"vm.noItemMsg\"></eo-no-data></div></div></div></div></div></form></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/company/companies.html","<div><h2 translate=\"tikonApp.company.home.title\">Companies</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.company.home.createLabel\">Create new Company</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.company.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.company.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"description\"><span translate=\"tikonApp.company.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"phoneNumber\"><span translate=\"tikonApp.company.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activityType\"><span translate=\"tikonApp.company.activityType\">Activity Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"webSiteUrl\"><span translate=\"tikonApp.company.webSiteUrl\">Web Site Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"keyUrl\"><span translate=\"tikonApp.company.keyUrl\">Key Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"settingId\"><span translate=\"tikonApp.company.setting\">Setting</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agreementId\"><span translate=\"tikonApp.company.agreement\">Agreement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"locationId\"><span translate=\"tikonApp.company.location\">Location</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"company in vm.companies track by company.id\"><td><a ui-sref=\"company-detail({id:company.id})\">{{company.id}}</a></td><td>{{company.title}}</td><!--<td>{{company.description}}</td>--><td>{{company.phoneNumber}}</td><td translate=\"{{\'tikonApp.ActivityType.\' + company.activityType}}\">{{company.activityType}}</td><td>{{company.webSiteUrl}}</td><td>{{company.keyUrl}}</td><td><a ui-sref=\"setting-info-detail({id:company.settingId})\">{{company.settingId}}</a></td><td><a ui-sref=\"agreement-info-detail({id:company.agreementId})\">{{company.agreementId}}</a></td><td><a ui-sref=\"location-info-detail({id:company.locationId})\">{{company.locationId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-detail({id:company.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company.edit({id:company.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company.delete({id:company.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company/company-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.company.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.company.delete.question\" translate-values=\"{id: \'{{vm.company.id}}\'}\">Are you sure you want to delete this Company?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company/company-detail.html","<div><h2><span translate=\"tikonApp.company.detail.title\">Company</span> {{vm.company.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.company.title\">Title</span></dt><dd><span>{{vm.company.title}}</span></dd><dt><span translate=\"tikonApp.company.description\">Description</span></dt><dd><span>{{vm.company.description}}</span></dd><dt><span translate=\"tikonApp.company.phoneNumber\">Phone Number</span></dt><dd><span>{{vm.company.phoneNumber}}</span></dd><dt><span translate=\"tikonApp.company.activityType\">Activity Type</span></dt><dd><span translate=\"{{\'tikonApp.ActivityType.\' + vm.company.activityType}}\">{{vm.company.activityType}}</span></dd><dt><span translate=\"tikonApp.company.webSiteUrl\">Web Site Url</span></dt><dd><span>{{vm.company.webSiteUrl}}</span></dd><dt><span translate=\"tikonApp.company.keyUrl\">Key Url</span></dt><dd><span>{{vm.company.keyUrl}}</span></dd><dt><span translate=\"tikonApp.company.setting\">Setting</span></dt><dd><a ui-sref=\"setting-info-detail({id:vm.company.settingId})\">{{vm.company.settingId}}</a></dd><dt><span translate=\"tikonApp.company.agreement\">Agreement</span></dt><dd><a ui-sref=\"agreement-info-detail({id:vm.company.agreementId})\">{{vm.company.agreementId}}</a></dd><dt><span translate=\"tikonApp.company.location\">Location</span></dt><dd><a ui-sref=\"location-info-detail({id:vm.company.locationId})\">{{vm.company.locationId}}</a></dd><dt><span translate=\"tikonApp.company.tags\">Tags</span></dt><dd><span ng-repeat=\"tags in vm.company.tags\"><a ui-sref=\"meta-tag-detail({id: {{tags.id}}})\">{{tags.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company/company-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyLabel\" translate=\"tikonApp.company.home.createOrEditLabel\">Create or edit a Company</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><md-content class=\"rwMdContent\"><ul class=\"nav nav-tabs lightnav\"><li class=\"active\"><a data-target=\"#mainInfoTab\" data-toggle=\"tab\"><md-icon>person_outline</md-icon>اطلاعات اصلی </a></li><li class=\"\"><a data-target=\"#customSettingTab\" data-toggle=\"tab\"><md-icon>history</md-icon>تنظیمات </a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"mainInfoTab\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-show=\"vm.company.id\"><label for=\"id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.company.id\" readonly=\"readonly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_domain\">Domain</label><input type=\"text\" class=\"form-control\" name=\"domain\" id=\"field_domain\" ng-model=\"vm.company.domain\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">HasDedicatedDomain</label><md-checkbox ng-model=\"vm.company.hasDedicatedDomain\"></md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_parentId\">ParentId</label><input type=\"number\" class=\"form-control\" name=\"parentId\" id=\"field_parentId\" ng-model=\"vm.company.parentId\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_companyMode\">CompanyMode</label><input type=\"text\" class=\"form-control\" name=\"companyMode\" id=\"field_companyMode\" ng-model=\"vm.company.companyMode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_category\">category</label><input type=\"text\" class=\"form-control\" name=\"category\" id=\"field_category\" ng-model=\"vm.company.category\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_subscriptionType\">Subscription Type</label><input type=\"text\" class=\"form-control\" name=\"subscriptionType\" id=\"field_subscriptionType\" ng-model=\"vm.company.subscriptionType\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_paymentGatewayAccess\">paymentGatewayAccess</label><select class=\"form-control\" name=\"paymentGatewayAccess\" ng-model=\"vm.company.paymentGatewayAccess\" id=\"field_paymentGatewayAccess\"><option value=\"ACCESS_JUST_PERSONAL_GATEWAY\">ACCESS_JUST_PERSONAL_GATEWAY</option><option value=\"ACCESS_ALL\">ACCESS_ALL</option><option value=\"ACCESS_NOTHING\">ACCESS_NOTHING</option></select></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_customerIntakeFields\">CustomerIntakeFields</label><input type=\"text\" class=\"form-control\" name=\"customerIntakeFields\" id=\"field_customerIntakeFields\" ng-model=\"vm.company.customerIntakeFields\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_clientBookingWidgetType\">clientBookingWidgetType</label><select class=\"form-control\" name=\"clientBookingWidgetType\" ng-model=\"vm.company.customSettingObject.clientBookingWidgetType\" id=\"field_clientBookingWidgetType\"><option value=\"DEFAULT\">DEFAULT</option><option value=\"VUE_COMPONENT\">VUE_COMPONENT</option></select></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_keyUrl\">Key Url</label><input type=\"text\" class=\"form-control\" name=\"keyUrl\" id=\"field_keyUrl\" ng-model=\"vm.company.keyUrl\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"customPaymentReturnUrl\">customPaymentReturnUrl</label><input type=\"text\" class=\"form-control\" name=\"keyUrl\" id=\"customPaymentReturnUrl\" ng-model=\"vm.company.customSettingObject.customPaymentReturnUrl\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.company.status\" id=\"field_status\"><option value=\"ACTIVE\">ACTIVE</option><option value=\"NOT_ACTIVE_EXPIRE\">NOT_ACTIVE_EXPIRE</option></select></div><div class=\"form-group\"><label class=\"control-label\">marketplaces</label><div class=\"row\"><div class=\"col-md-3\" ng-repeat=\"marketplace in vm.allMarketplaces\"><md-checkbox ng-model=\"marketplace.selected\" aria-label=\"Checkbox 1\">{{marketplace.title}} {{marketplace.keyUrl}}</md-checkbox></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"customSettingTab\"><div class=\"container-fluid\"><pf-sms-text-editor label=\"\'پیامک یادآوری\'\" sms-text=\"vm.company.customSettingObject.customerFirstReminderMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک  ثبت رزرو به مشتری\'\" sms-text=\"vm.company.customSettingObject.clientConfirmMessageCustomEnding\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک تایید پرداخت\'\" sms-text=\"vm.company.customSettingObject.requestConfirmationMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک درخواست رزرو\'\" sms-text=\"vm.company.customSettingObject.reserveRequestMsgToClient\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک لغو رزرو\'\" sms-text=\"vm.company.customSettingObject.reserveCancelationEndingMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک لغو درخواست رزرو\'\" sms-text=\"vm.company.customSettingObject.reserveRequestCanceledMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک ثبت رزرو به پرسنل\'\" sms-text=\"vm.company.customSettingObject.supplierConfirmMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک ویرایش رزرو به مشتری\'\" sms-text=\"vm.company.customSettingObject.reservationEditedMsgFromSupplier\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک رزرو مجدد\'\" sms-text=\"vm.company.customSettingObject.rebookMessage\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک بعد از خدمات\'\" sms-text=\"vm.company.customSettingObject.customerSatisfactionMessage\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک خوش‌آمد گویی\'\" sms-text=\"vm.company.customSettingObject.customerWelcomeMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک تبریک تولد\'\" sms-text=\"vm.company.customSettingObject.customerBirthdateNoticeMsg\"></pf-sms-text-editor><pf-sms-text-editor label=\"\'پیامک تایید نهایی پرداخت\'\" sms-text=\"vm.company.customSettingObject.reserveRequestApprovedMsgToClient\"></pf-sms-text-editor><div class=\"form-group\"><label for=\"id\">نمایش فوتر</label><input type=\"text\" class=\"form-control\" id=\"footerViewMode\" name=\"footerViewMode\" ng-model=\"vm.company.customSettingObject.footerViewMode\"></div><div class=\"form-group\"><label class=\"control-label\">IsParent</label><md-checkbox ng-model=\"vm.company.customSettingObject.isParent\"></md-checkbox></div><div class=\"form-group\"><label for=\"id\">External Company Id</label><input type=\"text\" class=\"form-control\" id=\"externalCompanyId\" name=\"externalCompanyId\" ng-model=\"vm.company.customSettingObject.externalCompanyId\"></div></div></div></div></md-content></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company/company-info-v2.html","<style>.keyurl {\n        /*width: 60%;*/\n        text-align: center;\n        font-size: 1em;\n        font-weight: bold;\n        color: #1a2c51;\n\n        background-color: rgba(210, 210, 210, 0.56);\n    }\n\n    .keyurl input {\n        text-align: center;\n        /*width: 190px;*/\n        /*color: #04796e;*/\n        font-size: 1.1em;\n        border-radius: 6px;\n        border: solid 1px;\n    }\n\n    .keyurl input:focus {\n        transition-duration: 0.31s;\n        -webkit-transition-duration: 0.3s;\n        border: solid 1px;\n        box-shadow: 1px 1px 20px 3px lightgray;\n    }</style><eo-pl-modal-header title=\"\'supplierPanel.sideMenu.companyInfo.general-v2\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.general-v2\">generalInformation_header</div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\">--><!--</action-bar>--><md-content class=\"\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.company.title\" maxlength=\"50\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.activityType\" for=\"field_activityType\">Activity Type</label><pf-activity-type-selector id=\"field_activityType\" activity-type=\"vm.company.activityType\" is-required=\"true\"></pf-activity-type-selector></div></div></div><div class=\"row\" style=\"padding-bottom: 20px\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.keyUrl\" for=\"field_keyUrl\">Key Url</label><div class=\"keyurl text-ltr\" style=\"width: 90%;margin: auto\"><input type=\"text\" name=\"keyUrl\" id=\"field_keyUrl\" pattern=\"[a-zA-Z0-9]{3,22}$\" ng-model=\"vm.company.keyUrl\" ng-change=\"vm.isCompanyNameValid()\" required> .{{vm.__config.domain}}</div><div ng-if=\"!vm.isUrlValid\" class=\"error-message\" style=\"position: absolute\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> <span translate=\"tikonApp.company.keyUrlInvalidityMessage\">tikonApp.company.keyUrlInvalidityMessage</span></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control text-ltr\" name=\"phoneNumber\" id=\"field_phoneNumber\" ng-model=\"vm.company.phoneNumber\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.webSiteUrl\" for=\"field_webSiteUrl\">Web Site Url</label><input type=\"text\" class=\"form-control text-ltr\" name=\"webSiteUrl\" id=\"field_webSiteUrl\" ng-model=\"vm.company.webSiteUrl\" placeholder=\"{{\'tikonApp.company.webSiteUrl-placeHolder\' | translate}}\"></div></div></div><div class=\"row\" style=\"display: none\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.telegramBotName\" for=\"field_telegramBotName\">telegramBotName</label><input type=\"text\" class=\"form-control\" name=\"telegramBotName\" id=\"field_telegramBotName\" ng-model=\"vm.company.telegramBotName\" placeholder=\"{{\'tikonApp.company.telegramBotName-placeHolder\' | translate}}\"></div></div><div class=\"col-md-9\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.telegramBotToken\" for=\"field_telegramBotToken\">telegramBotToken</label><input type=\"text\" class=\"form-control\" name=\"telegramBotToken\" id=\"field_telegramBotToken\" ng-model=\"vm.company.telegramBotToken\" placeholder=\"{{\'tikonApp.company.telegramBotToken-placeHolder\' | translate}}\"></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group\"><label class=\"control-label\" translate=\"tikonApp.company.description\" for=\"field_description\">Description</label><br><div style=\"padding: 20px\"><!--<div summernote height=\"300\" name=\"description\" id=\"field_description\"--><!--ng-model=\"vm.company.description\"--><!--/>--><eo-rich-text-editor id=\"field_description\" input-value=\"vm.company.description\"></eo-rich-text-editor></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-md-12\">--><!--<eo-tags selected-tags=\"vm.company.tags\" tag-type=\"\'COMPANY\'\">--><!--</eo-tags>--><!--</div>--><!--</div>--></md-content></form></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/company/company-info.html","<style>.keyurl {\n        /*width: 60%;*/\n        text-align: center;\n        font-size: 1em;\n        font-weight: bold;\n        color: #1a2c51;\n\n        background-color: rgba(210, 210, 210, 0.56);\n    }\n\n    .keyurl input {\n        text-align: center;\n        width: 190px;\n        color: #04796e;\n        font-size: 1.1em;\n        border-radius: 6px;\n        border: solid 1px rgba(4, 121, 110, 0.1);\n    }\n\n    .keyurl input:focus {\n        transition-duration: 0.31s;\n        -webkit-transition-duration: 0.3s;\n        border: solid 1px rgba(4, 121, 110, 0.65);\n        box-shadow: 1px 1px 20px 3px lightgray;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.general\">generalInformation_header</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\">--><!--</action-bar>--><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.company.title\" maxlength=\"50\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.activityType\" for=\"field_activityType\">Activity Type</label><md-select class=\"rwMdSelect\" name=\"activityType\" ng-model=\"vm.company.activityType\" eo-required=\"\" id=\"field_activityType\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.activityTypes\">{{\"tikonApp.ActivityType.\"+ si | translate}}</md-option></md-select></div></div></div><div class=\"row\" style=\"padding-bottom: 20px\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.keyUrl\" for=\"field_keyUrl\">Key Url</label><div class=\"keyurl text-ltr\"><input type=\"text\" name=\"keyUrl\" id=\"field_keyUrl\" pattern=\"[a-zA-Z0-9]{3,22}$\" ng-model=\"vm.company.keyUrl\" ng-change=\"vm.isCompanyNameValid()\" required> .{{vm.__config.domain}}</div><div ng-if=\"!vm.isUrlValid\" class=\"error-message\" style=\"position: absolute\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> <span translate=\"tikonApp.company.keyUrlInvalidityMessage\">tikonApp.company.keyUrlInvalidityMessage</span></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.company.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control text-ltr\" name=\"phoneNumber\" id=\"field_phoneNumber\" ng-model=\"vm.company.phoneNumber\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.webSiteUrl\" for=\"field_webSiteUrl\">Web Site Url</label><input type=\"text\" class=\"form-control text-ltr\" name=\"webSiteUrl\" id=\"field_webSiteUrl\" ng-model=\"vm.company.webSiteUrl\" placeholder=\"{{\'tikonApp.company.webSiteUrl-placeHolder\' | translate}}\"></div></div></div><div class=\"row\" style=\"display: none\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.telegramBotName\" for=\"field_telegramBotName\">telegramBotName</label><input type=\"text\" class=\"form-control\" name=\"telegramBotName\" id=\"field_telegramBotName\" ng-model=\"vm.company.telegramBotName\" placeholder=\"{{\'tikonApp.company.telegramBotName-placeHolder\' | translate}}\"></div></div><div class=\"col-md-9\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.telegramBotToken\" for=\"field_telegramBotToken\">telegramBotToken</label><input type=\"text\" class=\"form-control\" name=\"telegramBotToken\" id=\"field_telegramBotToken\" ng-model=\"vm.company.telegramBotToken\" placeholder=\"{{\'tikonApp.company.telegramBotToken-placeHolder\' | translate}}\"></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group\"><label class=\"control-label\" translate=\"tikonApp.company.description\" for=\"field_description\">Description</label><br><div style=\"padding: 20px\"><!--<div summernote height=\"300\" name=\"description\" id=\"field_description\"--><!--ng-model=\"vm.company.description\"--><!--/>--><eo-rich-text-editor id=\"field_description\" input-value=\"vm.company.description\"></eo-rich-text-editor></div></div></div><div class=\"row\"><div class=\"col-md-12\"><eo-tags selected-tags=\"vm.company.tags\" tag-type=\"\'COMPANY\'\"></eo-tags></div></div></md-content></form></div></div></div></div>");
$templateCache.put("app/entities/company-blogs/company-blog-categories.html","<div id=\"company-blogs-categories-container\"><panel-pln-blog-categories id=\"blogs-categories\"></panel-pln-blog-categories></div>");
$templateCache.put("app/entities/company-blogs/company-blogs.html","<div id=\"company-blogs-container\"><panel-pln-blogs id=\"company-blogs\"></panel-pln-blogs></div>");
$templateCache.put("app/entities/company-customer/company-customer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.companyCustomer.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.companyCustomer.delete.question\" translate-values=\"{fullName: \'{{vm.companyCustomer.customerFullName}}\'}\">Are you sure you want to delete this Company Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-customer/company-customer-detail.html","<div><h2><span translate=\"tikonApp.companyCustomer.detail.title\">Company Customer</span> {{vm.companyCustomer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.companyCustomer.createDate\">Create Date</span></dt><dd><span>{{vm.companyCustomer.createDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"tikonApp.companyCustomer.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.CustomerStatus.\' + vm.companyCustomer.status}}\">{{vm.companyCustomer.status}}</span></dd><dt><span translate=\"tikonApp.companyCustomer.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.companyCustomer.companyId})\">{{vm.companyCustomer.companyId}}</a></dd><dt><span translate=\"tikonApp.companyCustomer.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.companyCustomer.customerId})\">{{vm.companyCustomer.customerId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company-customer/company-customer-detailV2.html","<md-dialog class=\"company-customer-popup\" aria-label=\"اطلاعات مشتری\" dir=\"rtl\"><!-- Header --><md-toolbar class=\"company-customer-popup__toolbar\"><div class=\"md-toolbar-tools company-customer-popup__toolbar-content\"><div class=\"company-customer-popup__customer-header\" ng-if=\"companyCustomerEntity\"><div class=\"company-customer-popup__avatar\">{{ ( companyCustomerEntity.customer.personalInfo.fisrtName || companyCustomerEntity.customerFullName || \'?\' ).charAt(0) }}</div><div class=\"company-customer-popup__customer-text\"><strong class=\"company-customer-popup__customer-name\">{{ companyCustomerEntity.customerFullName || \'-\' }} </strong><span class=\"company-customer-popup__phone-number\">{{ companyCustomerEntity.customer.personalInfo.phoneNumber || \'-\' }}</span></div></div><md-button class=\"md-icon-button company-customer-popup__close-button\" ng-click=\"close()\" aria-label=\"بستن\"><md-icon md-svg-icon=\"md-close\" class=\"company-customer-popup__close-icon\"></md-icon></md-button></div></md-toolbar><!-- Content --><md-dialog-content class=\"company-customer-popup__content\"><!-- Basic information --><section class=\"company-customer-popup__section\"><h3 class=\"company-customer-popup__section-title\">اطلاعات اصلی</h3><div class=\"company-customer-popup__row\"><span class=\"company-customer-popup__label\">نام و نام خانوادگی </span><strong class=\"company-customer-popup__value\">{{ companyCustomerEntity.customerFullName || \'-\' }}</strong></div><div class=\"company-customer-popup__row\"><span class=\"company-customer-popup__label\">شماره موبایل </span><strong class=\"company-customer-popup__value company-customer-popup__ltr\">{{ companyCustomerEntity.customer.personalInfo.phoneNumber || \'-\' }}</strong></div><div class=\"company-customer-popup__row\"><span class=\"company-customer-popup__label\">کد ملی </span><strong class=\"company-customer-popup__value company-customer-popup__ltr\">{{ companyCustomerEntity.customer.personalInfo.nationalCode || \'-\' }}</strong></div><div class=\"company-customer-popup__row\"><span class=\"company-customer-popup__label\">گروه مشتری </span><strong class=\"company-customer-popup__value\"><span class=\"company-customer-popup__group-dot\" ng-if=\"companyCustomerEntity.customerGroup || companyCustomerEntity.group\"></span> {{ companyCustomerEntity.customerGroup.title || companyCustomerEntity.customerGroup.name || companyCustomerEntity.group.title || companyCustomerEntity.group.name || \'ندارد\' }}</strong></div></section><!-- Dynamic intake fields --><section class=\"company-customer-popup__section intake-data\" ng-if=\"\n                companyCustomerEntity.customerIntakeData &&\n                companyCustomerEntity.customerIntakeData.fields &&\n                companyCustomerEntity.customerIntakeData.fields.length\n            \"><h3 class=\"company-customer-popup__section-title\">فیلدهای تکمیلی</h3><div class=\"company-customer-popup__row\" ng-repeat=\"item in companyCustomerEntity.customerIntakeData.fields\" ng-if=\"item.value !== null && item.value !== undefined && item.value !== \'\'\"><span class=\"company-customer-popup__label\">{{ item.label || item.field.label || item.name }} </span><strong class=\"company-customer-popup__value\" ng-class=\"{\n                        \'company-customer-popup__ltr\':\n                            item.name === \'phoneNumber\' ||\n                            item.name === \'phone_number\' ||\n                            item.name === \'instagram\' ||\n                            item.name === \'instagram_link\' ||\n                            item.name === \'email\' ||\n                            item.name === \'car_body_number\'\n                    }\">{{ item.value }}</strong></div><div class=\"company-customer-popup__empty\" ng-if=\"!(companyCustomerEntity.customerIntakeData.fields | filter:{ value: \'!!\' }).length\">اطلاعات تکمیلی ثبت نشده است.</div></section><!-- Description --><section class=\"company-customer-popup__section\" ng-if=\"companyCustomerEntity.description\"><h3 class=\"company-customer-popup__section-title\">توضیحات</h3><p class=\"company-customer-popup__description\">{{ companyCustomerEntity.description }}</p></section></md-dialog-content><!-- Actions --><md-dialog-actions class=\"company-customer-popup__actions\" layout=\"row\" layout-align=\"start\"><!-- <md-button\n            class=\"company-customer-popup__button\"\n            ng-click=\"close()\"\n        >\n            <md-icon md-svg-icon=\"md-close\"></md-icon>\n            بستن\n        </md-button> --><md-button class=\"company-customer-popup__button\" ng-click=\"viewDetails()\">مشاهده جزئیات<!-- <md-icon class=\"material-icons\">arrow_back</md-icon> --></md-button></md-dialog-actions></md-dialog><style>.company-customer-popup {\n    width: 540px;\n    max-width: 95vw;\n    border-radius: 14px;\n    direction: rtl;\n    overflow: hidden;\n  }\n\n  .company-customer-popup__toolbar {\n    min-height: 125px;\n    color: #202124;\n    background: #ffffff !important;\n    border-bottom: 1px solid #eeeeee;\n  }\n\n  .company-customer-popup__toolbar-content {\n    height: 125px;\n    padding: 48px 26px;\n    justify-content: space-between;\n  }\n\n  .company-customer-popup__close-button,\n  .company-customer-popup__close-icon, .arrow-icon {\n    color: #222222 !important;\n    margin: 0 !important;\n  }\n\n  .company-customer-popup__customer-header {\n    display: flex;\n    align-items: center;\n    gap: 13px;\n  }\n\n  .company-customer-popup__customer-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 7px;\n  }\n\n  .company-customer-popup__customer-name {\n    font-size: 16px;\n    font-weight: 700;\n    color: #1f1f1f;\n  }\n\n  .company-customer-popup__phone-number {\n    direction: ltr;\n    font-size: 13px;\n    color: #4b4b4b;\n  }\n\n  .company-customer-popup__avatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 54px;\n    height: 54px;\n    border-radius: 50%;\n    background: #f0f0f2;\n    color: #2e2e35;\n    font-size: 18px;\n    font-weight: bold;\n  }\n\n  .company-customer-popup__content {\n    max-height: 60vh;\n    padding: 0 28px;\n    overflow-y: auto;\n    background-color: #ffffff;\n  }\n\n  .company-customer-popup__section {\n    padding: 22px 0 18px;\n    border-bottom: 1px solid #eeeeee;\n  }\n\n  .company-customer-popup__section.intake-data {\n    max-height: 300px;\n    overflow-y: auto;\n  }\n\n  .company-customer-popup__section:last-child {\n    border-bottom: 0;\n  }\n\n  .company-customer-popup__section-title {\n    margin: 0 0 15px;\n    color: #222222;\n    font-size: 15px;\n    font-weight: 700;\n  }\n\n  .company-customer-popup__row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 24px;\n    min-height: 38px;\n  }\n\n  .company-customer-popup__label {\n    color: #838891;\n    font-size: 13px;\n  }\n\n  .company-customer-popup__value {\n    color: #34363a;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: left;\n    overflow-wrap: anywhere;\n  }\n\n  .company-customer-popup__group-dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin-left: 6px;\n    vertical-align: middle;\n    border-radius: 50%;\n    background-color: #8b18e6;\n  }\n\n  .company-customer-popup__ltr {\n    direction: ltr;\n    unicode-bidi: plaintext;\n  }\n\n  .company-customer-popup__description {\n    margin: 0;\n    color: #444444;\n    font-size: 14px;\n    line-height: 1.9;\n    white-space: pre-line;\n  }\n\n  .company-customer-popup__empty {\n    color: #888888;\n    font-size: 13px;\n  }\n\n  .company-customer-popup__actions {\n    min-height: 76px;\n    padding: 15px 28px 20px;\n    border-top: 1px solid #eeeeee;\n    background-color: #ffffff;\n  }\n\n  .company-customer-popup__button {\n    min-width: 112px;\n    min-height: 40px;\n    margin: 0 0 0 8px;\n    padding: 0 14px;\n    color: #30343a !important;\n    border: 1px solid #d9dde1;\n    border-radius: 7px;\n    background-color: #ffffff !important;\n  }\n\n  .company-customer-popup__button:hover {\n    background-color: #f7f7f7 !important;\n  }\n  @media (max-width: 599px) {\n    .company-customer-popup {\n      width: 100%;\n      max-width: 100%;\n    }\n\n    .company-customer-popup__content {\n      max-height: calc(100vh - 210px);\n      padding: 0 20px;\n    }\n\n    .company-customer-popup__toolbar-content {\n      padding-right: 20px;\n      padding-left: 20px;\n    }\n\n    .company-customer-popup__actions {\n      padding-right: 20px;\n      padding-left: 20px;\n    }\n\n    .company-customer-popup__row {\n      align-items: flex-start;\n      flex-direction: column;\n      gap: 5px;\n      padding-bottom: 8px;\n    }\n\n    .company-customer-popup__value {\n      text-align: right;\n    }\n  }</style>");
$templateCache.put("app/entities/company-customer/company-customer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyCustomerLabel\" translate=\"tikonApp.companyCustomer.home.createOrEditLabel\">Create or edit a Company Customer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companyCustomer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companyCustomer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomer.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.companyCustomer.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomer.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.companyCustomer.status\" id=\"field_status\"><option value=\"ACTIVE_CUSTOMER\" translate=\"tikonApp.CustomerStatus.ACTIVE_CUSTOMER\">ACTIVE_CUSTOMER</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.companyCustomer.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.companyCustomer.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.companyCustomer.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.companyCustomer.customerId\" ng-options=\"customer.id as customer.id for customer in vm.customers\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-customer/company-customer-modal.html","<eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><jhi-alert-error></jhi-alert-error><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"customer-header-container\" ng-if=\"vm.companyCustomer && vm.companyCustomer.id \"><div class=\"customer-header-info-summary\"><div class=\"customer-header-info\"><div><eo-avatar-name name=\"vm.companyCustomer.customer.personalInfo.fisrtName\"></eo-avatar-name></div><div><div class=\"customer-list-customer-name\">{{vm.companyCustomer.customer.personalInfo.fisrtName}} {{vm.companyCustomer.customer.personalInfo.lastName}}</div><div class=\"customer-list-customer-phone\">{{vm.companyCustomer.customer.personalInfo.phoneNumber}}</div></div></div><div><pf-customer-statistics-v2 selected-customer-id=\"vm.companyCustomer.customer.id\"></pf-customer-statistics-v2></div></div><div class=\"customer-header-buttons\"><div ng-click=\"vm.gotoNewReserve()\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">event</md-icon></div><div class=\"customer-header-button-box-text\">رزرو جدید</div></div><div ng-click=\"vm.callCustomer()\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">call</md-icon></div><div class=\"customer-header-button-box-text\">تماس</div></div><div ui-sref=\"supplierPanel-v2.deleteCompanyCustomer({id:vm.companyCustomer.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"customer-component-container\"><pf-company-customer-v2 company-customer=\"vm.companyCustomer\" mode=\"EDIT\" can-save=\"vm.hasAllNecessaryFields\"></pf-company-customer-v2></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/company-customer/company-customer-pop-up.html","<div><pf-company-customer company-customer=\"vm.companyCustomer\" mode=\"vm.mode\" can-save=\"vm.hasAllNecessaryFields\" is-pop-up=\"vm.isPopUp\"></pf-company-customer><div class=\"modal-footer\"><md-button type=\"button\" class=\"md-raised md-secondary\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button style=\"margin: 0\" type=\"submit\" ng-click=\"vm.save()\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"md-raised md-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><!--<md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\"--><!--&gt;--><!--<span><md-icon>save</md-icon></span>--><!--<span translate=\"entity.action.save\">--><!--&lt;!&ndash;ثبت اطلاعات&ndash;&gt;--><!--</span>--><!--</md-button>--></div>");
$templateCache.put("app/entities/company-customer/company-customer-slide.html","<md-sidenav class=\"md-sidenav-left\" md-component-id=\"customerSide\" md-disable-backdrop=\"\" md-whiteframe=\"4\"><div id=\"reserveModal\" class=\"row pl-modal-header modal-header pl-modal-border hidden-xs\"><div ng-if=\"!vm.companyCustomer.id\" class=\"pl-modal-title col-md-8 col-sm-6 col-xs-6\" translate=\"tikonApp.companyCustomer.home.createLabel\">Create New Customer</div><div ng-if=\"vm.companyCustomer.id\" class=\"pl-modal-title col-md-8 col-sm-6 col-xs-6\" translate=\"tikonApp.companyCustomer.home.viewAndEditCustomer\">viewAndEditCustomer</div><div class=\"col-md-4\"><md-button class=\"md-raised md-primary pull-left pl-btn pl-btn-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.okModal()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button><md-button type=\"button\" class=\"md-raised md-secondary pull-left pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button></div></div><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"customer-header-container\" ng-if=\"vm.companyCustomer && vm.companyCustomer.id \"><div class=\"customer-header-info\"><div><eo-avatar-name name=\"vm.companyCustomer.customer.personalInfo.fisrtName\"></eo-avatar-name></div><div><div class=\"customer-list-customer-name\">{{vm.companyCustomer.customer.personalInfo.fisrtName}} {{vm.companyCustomer.customer.personalInfo.lastName}}</div><div class=\"customer-list-customer-phone\">{{vm.companyCustomer.customer.personalInfo.phoneNumber}}</div></div></div><div class=\"customer-header-buttons\"><div ng-click=\"vm.gotoNewReserve()\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">event</md-icon></div><div class=\"customer-header-button-box-text\">رزرو جدید</div></div><div><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">call</md-icon></div><div class=\"customer-header-button-box-text\">تماس</div></div><div ui-sref=\"supplierPanel-v2.deleteCompanyCustomer({id:vm.companyCustomer.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"customer-component-container\"><pf-company-customer-v2 company-customer=\"vm.companyCustomer\" mode=\"EDIT\" can-save=\"vm.hasAllNecessaryFields\"></pf-company-customer-v2></div></div></div><div class=\"pl-modal-footer visible-xs\"><div class=\"row\" style=\"display: flex\"><md-button class=\"col-xs-6 md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.okModal()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button><md-button type=\"button\" class=\"col-xs-6 md-raised md-secondary pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button></div></div></md-sidenav>");
$templateCache.put("app/entities/company-customer/company-customers-list-v2.html","<style>@media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }\n\n      /* banner styles */\n  .company-customer-banner {\n    max-width: 100%;\n    background-color: #f3effa;\n    border: 1px solid #dcd3ef;\n    border-radius: 8px;\n    margin: 8px;\n    padding: 40px 25px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n  }\n\n  .company-customer-banner .close-btn {\n    position: absolute;\n    top: 5px;\n    left: 10px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #666;\n  }\n\n  .company-customer-banner .banner-content {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    /* text-align: center; */\n    justify-content: space-between;\n  }\n\n  .company-customer-banner .calendar-icon {\n    font-size: 40px;\n    color: #673ab7;\n  }\n\n  .company-customer-banner .text-container {\n    font-size: 14px;\n    color: #333;\n    text-align: right;\n  }\n  .text-container .title {\n    color: #673ab7;\n    font-weight: bold;\n    font-size: 1.5rem;\n  }\n\n  .company-customer-banner .view-btn {\n    background-color: #673ab7;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n\n    .icon-wrapper {\n    position: relative;\n    display: inline-block;\n  }\n  \n  /* تنظیم موقعیت دقیق برای نشان هشدار */\n  .alert-badge {\n    position: absolute;\n    bottom: 10px; /* تنظیم موقعیت عمودی */\n    right: -5px;  /* تنظیم موقعیت افقی */\n    font-size: 20px !important; /* اندازه بَج باید کوچکتر باشد */\n    color: #E8113D;\n    background: white; /* برای جدا شدن از پس‌زمینه */\n    border-radius: 50%;\n  }\n\n  /* حالت موبایل: تغییر چیدمان به عمودی */\n  @media (max-width: 600px) {\n    .company-customer-banner .banner-content {\n      flex-direction: column;\n      gap: 10px;\n      padding-top: 10px;\n    }\n  }\n\n  .company-customer-banner-visible {\n    margin-top: 191px;\n  }\n    .company-customer-banner-visible-v2 {\n    margin-top: 251px;\n  }\n\n  @media (max-width: 767px) {\n    .company-customer-banner-visible {\n      margin-top: 276px;\n    }\n    .company-customer-banner-visible-v2 {\n    margin-top: 316px;\n  }\n     .company-customer-banner {\n        padding: 20px 10px;\n        max-width: 100%;\n        /* margin: auto!important; */\n        margin-right: 25px;\n     }\n  }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span translate=\"tikonApp.companyCustomer.home.title\">tikonApp.companyCustomer.home.title</span><div class=\"education-link\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body pl-panel-body\"><jhi-alert></jhi-alert><div class=\"\"><!-- Do not show on production.\n                     ng-if=\"vm.showDuplicatesBanner && vm.getCompanyCustomerDuplicatesItems.length\"\n                    --><!-- <div ng-if=\"vm.showDuplicatesBanner && vm.getCompanyCustomerDuplicatesItems.length\" class=\"company-customer-banner\">\n                        <button class=\"close-btn\" ng-click=\"vm.closeDuplicatesBanner()\">×</button>\n                        <div class=\"banner-content\">\n                        <div style=\"display: flex; align-items: flex-start; gap: 15px\">\n                            <span class=\"icon-wrapper\">\n                                <i class=\"material-icons\" style=\"font-size: 48px\">group</i>\n                                <i class=\"material-icons alert-badge\">error</i>\n                            </span>\n                            <div class=\"text-container\">\n                                <p class=\"title\">\n                                    {{vm.getCompanyCustomerDuplicatesItems.length}} مشتری تکراری شناسایی شد\n                                </p>\n                                <p>\n                                مشتریان تکراری می توانند گزارش ها و ارسال پیامک هارا تحت تاثیر قرار دهند. برای مشاهده و ادغام آن ها  اقدام کنید.\n                                </p>\n                            </div>\n                        </div>\n                        <button class=\"view-btn\" ng-click=\"vm.showDuplicatesModal()\">\n                            مشاهده و ادغام مشتریان\n                        </button>\n                        </div>\n                    </div> --><div class=\"\" style=\"display: flex\"><md-button class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newCustomer()\"><span><md-icon>add</md-icon></span><span translate=\"tikonApp.companyCustomer.home.new\">Create new Servant</span></md-button><md-button class=\"md-raised md-secondary pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.customerGroupList\"><span translate=\"tikonApp.companyCustomer.customerGroup\">customerGroup</span></md-button></div></div><div><div class=\"table-responsive\"><table st-safe-src=\"vm.companyCustomers\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><eo-pl-search-box search-query=\"vm.filterQuery.query\" search-place-holder=\"\'tikonApp.companyCustomer.home.searchPlaceHolder\'\" on-search=\"vm.filterCompanyCustomers_global()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"fisrtName\"><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyCustomer.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"email\"><span translate=\"tikonApp.customer.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"email\"><span translate=\"tikonApp.customer.group\">group</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.companyCustomer.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyCustomer in collection track by companyCustomer.id\"><!--<td>{{companyCustomer.customer.id }} </td>--><td><a ui-sref=\"supplierPanel-v2.companyCustomer.edit({id: companyCustomer.id})\"><!--<a ui-sref=\"company-customer.edit({id:companyCustomer.id})\">--> {{companyCustomer.customer.personalInfo.fisrtName}} {{companyCustomer.customer.personalInfo.lastName}}</a></td><td>{{companyCustomer.customer.personalInfo.phoneNumber}}<div ng-if=\"companyCustomer.customer.personalInfo.nationalCode && companyCustomer.customer.personalInfo.nationalCode!=\' \'\" style=\"font-size: 10px\"><span translate=\"tikonApp.personInfo.nationalCode\">National Code </span><span>: {{companyCustomer.customer.personalInfo.nationalCode}}</span></div></td><td>{{companyCustomer.createDate | toPersianDate}}</td><td>{{companyCustomer.customer.personalInfo.email}}</td><td>{{companyCustomer.group}}</td><td><span ng-if=\"companyCustomer.status\"><md-tooltip md-direction=\"top\">{{\"tikonApp.CustomerStatus.\"+ companyCustomer.status | translate}}</md-tooltip><span ng-if=\"companyCustomer.status==\'BLOCKED_CUSTOMER\'\"><md-icon style=\"color: red;margin-bottom: 7px\">block</md-icon></span><span ng-if=\"companyCustomer.status==\'VALID_CUSTOMER\'\"><md-icon style=\"color: green;margin-bottom: 7px\">person</md-icon></span><span ng-if=\"companyCustomer.status==\'NEW_CUSTOMER\'\"><md-icon style=\"color: dodgerblue;margin-bottom: 7px\">person_add</md-icon></span></span><span ng-if=\"!companyCustomer.status\"><md-tooltip md-direction=\"top\">{{\"tikonApp.companyCustomer.notDefine\"| translate}}</md-tooltip><md-icon style=\"color: gray;margin-bottom: 7px\">error</md-icon></span></td><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.edit({id:companyCustomer.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.delete({id:companyCustomer.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ng-click=\"vm.editCustomer(companyCustomer)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.companyCustomer.delete({id:companyCustomer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newCustomer()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 service-item-title-container\"><div style=\"display: flex; align-items: center\"><h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.companyCustomer.home.title\">tikonApp.companyCustomer.home.title</h3><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.customerGroupList\"><md-icon style=\"color: #000\">folder_copy</md-icon><span class=\"\" translate=\"tikonApp.companyCustomer.customerGroup-small\">serviceCategory</span></md-button></div></div></div><div class=\"row\"><div class=\"\"><div class=\"\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.filterQuery.query\" search-place-holder=\"\'tikonApp.companyCustomer.home.searchPlaceHolder\'\" on-search=\"vm.filterCompanyCustomers_global()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box><!--<div class=\"form-group pl-customer-search-container\">--><!--&lt;!&ndash;<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>&ndash;&gt;--><!--<input class=\"form-control pl-search-input\"--><!--ng-model=\"vm.searchQuery\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.searchPlaceHolder\' | translate }}\"--><!--type=\"text\"--><!--ng-keypress=\"vm.searchKeyPress($event)\"--><!--/>--><!--<div id=\"search-btn-xs\" class=\"pl-search-btn\"--><!--ng-click=\"vm.search()\"--><!--&gt;--><!--&lt;!&ndash;<i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative;\">&ndash;&gt;--><!--&lt;!&ndash;search&ndash;&gt;--><!--&lt;!&ndash;</i>&ndash;&gt;--><!--<md-icon style=\"width: 33px; height: 35px; font-size: 35px; padding-top: 6px;color: #000;\">search</md-icon>--><!--</div>--><!--</div>--><div ng-repeat=\"companyCustomer in vm.companyCustomers track by companyCustomer.id\" class=\"customer-list-item\" ng-click=\"vm.editCustomer(companyCustomer)\"><eo-avatar-name name=\"{{companyCustomer.customer.personalInfo.fisrtName}}\"></eo-avatar-name><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-name\">{{companyCustomer.customer.personalInfo.fisrtName}} {{companyCustomer.customer.personalInfo.lastName}}</div><div class=\"customer-list-customer-phone\">{{companyCustomer.customer.personalInfo.phoneNumber}}</div><div class=\"customer-list-customer-email\" ng-if=\"companyCustomer.customer.personalInfo.email\">{{companyCustomer.customer.personalInfo.email}}</div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"></ul>--><!--</div>--><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div><panel-pln-merge-duplicates-dialog></panel-pln-merge-duplicates-dialog>");
$templateCache.put("app/entities/company-customer/company-customers-list.html","<div class=\"hidden-xs\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.companyCustomer.home.title\">tikonApp.companyCustomer.home.title</div><div class=\"panel-body\"><div class=\"container-fluid\"><jhi-alert></jhi-alert><md-button ng-if=\"true\" class=\"md-raised md-primary\" ui-sref=\"company-customer.new\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.companyCustomer.home.new\">Create new Servant</span></md-button><md-button class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.customerGroupList\"><span class=\"hidden-xs\" translate=\"tikonApp.companyCustomer.customerGroup\">customerGroup</span></md-button><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.companyCustomers\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><!--<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>--> <input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\" type=\"text\" ng-keypress=\"vm.searchKeyPress($event)\"></div></div><div class=\"col-sm-6\"><md-button id=\"search-btn\" class=\"search-btn md-raised md-secondary\" ng-click=\"vm.search()\" style=\"margin-top: 0px; margin-right: -10px\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div></div></th></tr><tr><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"fisrtName\"><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyCustomer.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"email\"><span translate=\"tikonApp.customer.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.companyCustomer.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyCustomer in collection track by companyCustomer.id\"><!--<td>{{companyCustomer.customer.id }} </td>--><td><a ui-sref=\"company-customer.edit({id:companyCustomer.id})\">{{companyCustomer.customer.personalInfo.fisrtName}} {{companyCustomer.customer.personalInfo.lastName}}</a></td><td>{{companyCustomer.customer.personalInfo.phoneNumber}}<div ng-if=\"companyCustomer.customer.personalInfo.nationalCode && companyCustomer.customer.personalInfo.nationalCode!=\' \'\" style=\"font-size: 10px\"><span translate=\"tikonApp.personInfo.nationalCode\">National Code </span><span>: {{companyCustomer.customer.personalInfo.nationalCode}}</span></div></td><td>{{companyCustomer.createDate | toPersianDate}}</td><td>{{companyCustomer.customer.personalInfo.email}}</td><td><span ng-if=\"companyCustomer.status\"><md-tooltip md-direction=\"top\">{{\"tikonApp.CustomerStatus.\"+ companyCustomer.status | translate}}</md-tooltip><span ng-if=\"companyCustomer.status==\'BLOCKED_CUSTOMER\'\"><md-icon style=\"color: red;margin-bottom: 7px\">block</md-icon></span><span ng-if=\"companyCustomer.status==\'VALID_CUSTOMER\'\"><md-icon style=\"color: green;margin-bottom: 7px\">person</md-icon></span><span ng-if=\"companyCustomer.status==\'NEW_CUSTOMER\'\"><md-icon style=\"color: dodgerblue;margin-bottom: 7px\">person_add</md-icon></span></span><span ng-if=\"!companyCustomer.status\"><md-tooltip md-direction=\"top\">{{\"tikonApp.companyCustomer.notDefine\"| translate}}</md-tooltip><md-icon style=\"color: gray;margin-bottom: 7px\">error</md-icon></span></td><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.edit({id:companyCustomer.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.delete({id:companyCustomer.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ng-click=\"vm.gotoNewReserve(companyCustomer.customer.id)\" class=\"btn btn-primary btn-sm\" style=\"background-color: rgb(96,125,139)\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.companyCustomer.newReserveForCustomer\"></span></button> <button type=\"submit\" ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.deleteCompanyCustomer({id:companyCustomer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></md-content></div></div></div></div><div class=\"visible-xs\"><div class=\"\"><div class=\"row\"><div class=\"col-xs-8\"><h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.companyCustomer.home.title\">tikonApp.companyCustomer.home.title</h3></div><div class=\"col-xs-3\" style=\"margin-right: -7px\"><md-button class=\"md-raised md-primary\" ui-sref=\"company-customer.new\"><i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i></md-button></div></div><div class=\"row\"><div class=\"\"><div class=\"\"><jhi-alert></jhi-alert><div class=\"row\" style=\"padding-right: 8px\"><div class=\"form-group\"><!--<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>--><div class=\"col-xs-10\"><input class=\"form-control rwTableSearchBox\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\" type=\"text\" ng-keypress=\"vm.searchKeyPress($event)\"></div><div class=\"col-xs-2\" style=\"margin-right: -30px;margin-top: -7px\"><md-button id=\"search-btn-xs\" class=\"search-btn md-raised md-secondary\" ng-click=\"vm.search()\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div></div></div><div ng-repeat=\"companyCustomer in vm.companyCustomers track by companyCustomer.id\" class=\"orderBag-mobile-block\"><!--<td>{{companyCustomer.customer.id }} </td>--><div><div ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"row\"><div class=\"orderBag-mobile-float\"><i class=\"glyphicon glyphicon-user\"></i> {{companyCustomer.customer.personalInfo.fisrtName}} {{companyCustomer.customer.personalInfo.lastName}}</div></div><div class=\"row\" ng-if=\"companyCustomer.customer.personalInfo.email\" style=\"padding-right: 8px\"><i class=\"glyphicon glyphicon-envelope\"></i> {{companyCustomer.customer.personalInfo.email}}</div><div><div class=\"orderBag-mobile-float companyCustomer-make-call\"><i class=\"fa fa-phone\"></i> <a href=\"tel:{{companyCustomer.customer.personalInfo.phoneNumber}}\">{{companyCustomer.customer.personalInfo.phoneNumber}}</a><!--{{companyCustomer.customer.personalInfo.phoneNumber}}--></div><div style=\"text-align: left\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-click=\"vm.gotoNewReserve(companyCustomer.customer.id)\" class=\"btn btn-primary btn-sm\" style=\"background-color: rgb(96,125,139)\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"tikonApp.companyCustomer.newReserveForCustomer\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.deleteCompanyCustomer({id:companyCustomer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></div></div></div></div></div></div></div></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\" ng-model=\"vm.page\"></ul></div></div>");
$templateCache.put("app/entities/company-customer/company-customers.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.companyCustomer.home.newAndEditCustomer\" style=\"display: inline-block\">tikonApp.companyCustomer.home.newAndEditCustomer </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.companyCustomer.customer.id != null\">{{vm.companyCustomer.customer.personalInfo.fisrtName}} {{vm.companyCustomer.customer.personalInfo.lastName}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\"><!--</div>--><!--</div>--><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                                border-bottom: solid 1px #ff9d1a;\n                            }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\" ng-if=\"true\"><md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.hasAllNecessaryFields\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\"><!--ثبت اطلاعات--></span></md-button></div><div class=\"pull-right\" has-authority=\"ROLE_SERVANT_MANAGER\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.companyCustomer\"><span><md-icon>list</md-icon></span><span>بازگشت به لیست مشتریان</span></md-button></div></div><!--<div>--><!--{{vm.customer}}--><!--</div>--><!--<md-content class=\"rwMdContent\">--><!--<ul class=\"nav nav-tabs lightnav\">--><!--<li class=\"active\"><a data-target=\"#1b\" data-toggle=\"tab\">--><!--<md-icon> person</md-icon>--><!--{{\'tikonApp.companyCustomer.tabs.profileInfo\' | translate}}--><!--</a></li>--><!--&lt;!&ndash;<li class=\"\"><a data-target=\"#2b\" data-toggle=\"tab\">&ndash;&gt;--><!--&lt;!&ndash;<md-icon> info</md-icon>&ndash;&gt;--><!--&lt;!&ndash;{{\'tikonApp.companyCustomer.tabs.complementaryInfo\' | translate}}&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;--><!--<li class=\"\"><a data-target=\"#3b\" data-toggle=\"tab\">--><!--<md-icon>featured_play_list</md-icon>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</a></li>--><!--</ul>--><!--<div class=\"tab-content clearfix\">--><!--<div class=\"tab-pane  active\" style=\"background: none;\" id=\"1b\">--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<pf-person-info person-info=\"vm.companyCustomer.customer.personalInfo\"--><!--user-Account-Id=\"vm.companyCustomer.customer.userAccountId\"--><!--is-customer=\"true\"--><!--&gt;--><!--</pf-person-info>--><!--</div>--><!--<div class=\"row\"--><!--ng-if=\" (vm.companyCustomer.customerIntakeData!= undefined && vm.companyCustomer.customerIntakeData!=\'\' && vm.companyCustomer.customerIntakeData != null )\">--><!--<div class=\"col-md-2\">--><!--</div>--><!--<fieldset class=\"standard-fieldset\">--><!--<legend>--><!--<i class=\"fa fa-address-card fa-2x\" style=\"color: #bac6d1;margin-top: -6px;\">--><!--<span style=\"font-size: 14px;font-family: yekan;color: #2b6b7f;padding-right: 5px;\">--><!--اطلاعات تکمیلی--><!--</span>--><!--</i>--><!--</legend>--><!--<div class=\"container-fluid\">--><!--<div class=\"col-md-10\" style=\"margin: 0\"--><!--&gt;--><!--&lt;!&ndash;<hr>&ndash;&gt;--><!--<div id=\"company_customer_intakeformData\" class=\"row\">--><!--<component-intake-data-viewer--><!--intake-data=\"vm.companyCustomer.customerIntakeData\"--><!--column-count=\"3\"></component-intake-data-viewer>--><!--</div>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--&lt;!&ndash;<div style=\"background: none;\" class=\"tab-pane fade \" id=\"2b\">&ndash;&gt;--><!--&lt;!&ndash;&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<div style=\"background: none;\" class=\"tab-pane fade \" id=\"3b\">--><!--<fieldset class=\"standard-fieldset\"--><!--ng-if=\" (vm.companyCustomer.customerIntakeData!= undefined && vm.companyCustomer.customerIntakeData!=\'\' && vm.companyCustomer.customerIntakeData != null )\">--><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><!--<div id=\"company_customer_form_data\">--><!--<div ng-repeat=\"form in vm.companyCustomer.forms\">--><!--<md-button class=\"md-raised md-primary\"--><!--ng-click=\"vm.getCompanyCustomerFormDataFunc(form.id, form.title)\">--><!--{{form.title}} +--><!--</md-button>--><!--&lt;!&ndash;<component-intake-data-viewer intake-data=\"vm.customerFormData.intakeDataDTO\"></component-intake-data-viewer>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-12\" ng-if=\"vm.companyCustomer.formsData\"--><!--ng-repeat=\"formData in vm.companyCustomer.formsData\">--><!--<div class=\"exCards\"--><!--ng-click=\"vm.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\">--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-9\">--><!--<div class=\"col-sm-6\"--><!--ng-repeat=\"field in formData.intakeDataDTO.fields\">--><!--<span--><!--ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \">--><!--<i class=\"fa fa-check\"></i>--><!--<span style=\"font-weight: bold\">--><!--{{field.label}}--><!--</span>--><!--</span>--><!--<span--><!--ng-if=\"field.field.fieldType != \'CheckBox\'\">--><!--<span>{{field.label}} :</span>--><!--<span style=\"font-weight: bold\">{{field.value}}</span>--><!--</span>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-3\">--><!--<md-button class=\"btn btn-primary btn-sm\"--><!--style=\"float: left\"--><!--ng-click=\"vm.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\">--><!--{{\'tikonApp.companyCustomer.tabs.button.edit\' |--><!--translate}}--><!--</md-button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</md-content>--><pf-company-customer company-customer=\"vm.companyCustomer\" mode=\"EDIT\" can-save=\"vm.hasAllNecessaryFields\" is-pop-up=\"false\"></pf-company-customer></div></div></div></div></div></div>");
$templateCache.put("app/entities/company-customer/filter-company-customer-list-dialog.html","<style>.panel {\n        margin: 0;\n\n    }\n    .md-select-value span {\n        display: flex;\n    }</style><md-dialog class=\"pl-md-dialog\"><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div>اعمال فیلتر (جستجوی پیشرفته)</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><md-dialog-content class=\"pl-dialog-content\"><div class=\"\"><div class=\"panel-body\"><div id=\"filters_content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyCustomer.customerGroup\" for=\"field_customerGroup\">Category</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" placeholder=\"{{ \'tikonApp.companyCustomer.filter.select\' | translate }}\" ng-model=\"$ctrl.data.filterQuery.groupIds\" id=\"field_customerGroup\" multiple=\"true\" style=\"min-width: 100px; overflow: hidden\"><md-option value=\"1\">بدون گروه بندی</md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.customerGroups\">{{si.groupName}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyCustomer.filter.search\">search</label><input class=\"form-control rwTableSearchBox pl-col-no-margin\" style=\"max-width: unset\" ng-model=\"$ctrl.data.filterQuery.customerFullName\" placeholder=\"{{ \'tikonApp.companyCustomer.filter.customerFullNamePlaceholder\' | translate }}\" type=\"text\"></div></div></div></div></div></div></md-dialog-content><md-dialog-actions class=\"pl-dialog-actions\"><div class=\"pl-filter-dialog-footer\" style=\"width: 100%\"><div class=\"\" style=\"display: flex;justify-content: flex-end\"><a class=\"delete-filters\" ng-click=\"$ctrl.clearFilter()\"><i class=\"material-icons\" style=\"font-size: 12px\">cancel</i> حذف فیلترها</a><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default hidden-xs\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span>بازگشت</span><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--></md-button><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-click=\"$ctrl.okModal()\"><span>اعمال</span></md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/entities/company-invoice-info/company-invoice-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyInvoiceInfoLabel\" translate=\"tikonApp.companyInvoiceInfo.home.createOrEditLabel\">Create or edit a Company Manager</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companyInvoiceInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companyInvoiceInfo.id\" readonly=\"readonly\"></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.keyUrl\" for=\"field_companyKeyUrl\" required>companyKeyUrl</label><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" id=\"field_companyKeyUrl\" ng-model=\"vm.companyKeyUrl\"></div></div><div class=\"col-md-3\" style=\"margin-top: 24px\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.findCompany()\"><span class=\"glyphicon glyphicon-search\"></span>&nbsp; <span>جستجوی کمپانی</span></button></div><div class=\"col-md-3\"><div ng-if=\"vm.companyInvoiceInfo.company\">Company : {{vm.companyInvoiceInfo.company.title}}</div></div></div><div ng-if=\"vm.companyInvoiceInfo.company\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"company-invoice-info-items-section\"><div name=\"items\" style=\"width: 100%\"><div class=\"pl-panel\" style=\"min-height: 304px\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.companyInvoiceInfo.itemsInfo\"></span></div><div class=\"panel-body\"><div class=\"\" ng-repeat=\"item in vm.companyInvoiceInfo.companyInvoiceInfoItems\"><div class=\"\" style=\"font-weight: bold\">{{item.title}} <span ng-click=\"vm.deleteItem(item)\"><i style=\"color: red\" class=\"fa fa-remove\"></i></span></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyInvoiceInfoItem.title\" for=\"field_title\">Min Price</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"item.title\"></div></div><div class=\"col-md-4 col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyInvoiceInfoItem.price\" for=\"field_servicePrice\">Min Price</label><!--<span translate=\"global.currencyBracket\"></span>--><eo-numeric-input-v2 id=\"field_servicePrice\" name=\"servicePrice\" custom-class=\"form-control\" input-value=\"item.price\" is-required=\"true\" form-reference=\"editForm\" on-change=\"vm.onFieldChanged()\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-2 col-xs-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyInvoiceInfoItem.qty\" for=\"field_serviceQty\">Qty</label><eo-numeric-input id=\"field_serviceQty\" name=\"serviceQty\" input-value=\"item.qty\" custom-class=\"form-control\" is-disabled=\"false\" form-reference=\"editForm\" min=\"1\" on-change=\"vm.onFieldChanged()\"></eo-numeric-input></div></div></div></div><div ng-if=\"!vm.companyInvoiceInfo.companyInvoiceInfoItems || vm.companyInvoiceInfo.companyInvoiceInfoItems.length ==0 \"><eo-no-data message=\"vm.companyInvoiceInfoItemListEmptyMessage\"></eo-no-data><!--<span--><!--translate=\"tikonApp.servant.customSetting.noAvailableService\">--><!--</span>--></div><div style=\"text-align: center\"><md-button type=\"button\" ng-click=\"vm.newItem()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.companyInvoiceInfoItem.home.new\">newItem</span></md-button></div></div></div></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"tikonApp.companyInvoiceInfo.subscriptionPrice\" for=\"field_subscriptionPrice\" required>Subscription Price</label><input type=\"number\" class=\"form-control\" name=\"subscriptionPrice\" id=\"field_subscriptionPrice\" ng-model=\"vm.companyInvoiceInfo.subscriptionPrice\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyInvoiceInfo.discount\" for=\"field_discount\">discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.companyInvoiceInfo.discount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyInvoiceInfo.finalPrice\" for=\"field_finalPrice\">finalPrice</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_finalPrice\" ng-model=\"vm.companyInvoiceInfo.finalPrice\" readonly=\"readonly\"></div><div style=\"font-size: 20px;font-weight: bold;text-align: center\">{{vm.companyInvoiceInfo.finalPrice | number}} <span translate=\"global.currencyBracket\"></span></div></div></div><div class=\"row\"><div name=\"description\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.companyInvoiceInfo.description\"></span></div><div class=\"panel-body\"><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"description\" placeholder=\"{{\'tikonApp.companyInvoiceInfo.description\' | translate}}\" ng-model=\"vm.companyInvoiceInfo.description\"></textarea></div></div></div></div><div><h4>وضعیت پرداخت</h4><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.amount\" for=\"field_amount\">amount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.amount\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.paymentType\" for=\"field_paymentType\">Payment Type</label><md-select class=\"rwMdSelect\" name=\"paymentType\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.paymentType\" id=\"field_paymentType\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><md-option value=\"CASH\" translate=\"tikonApp.PaymentType.CASH\">CASH</md-option><md-option value=\"CREDIT_CARD\" translate=\"tikonApp.PaymentType.CREDIT_CARD\">CREDIT_CARD</md-option><md-option value=\"MONEY_TRANSFER\" translate=\"tikonApp.PaymentType.MONEY_TRANSFER\">MONEY_TRANSFER</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.createDate\" for=\"field_paymentCreateDate\">Create Date</label><eo-date-picker style=\"display: block\" id=\"field_paymentCreateDate\" date-value=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.createDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyInvoiceInfo.howInvoiceSettlement\" for=\"field_howInvoiceSettlement\">howInvoiceSettlement</label><input type=\"text\" class=\"form-control\" name=\"amount\" id=\"field_howInvoiceSettlement\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.moreInfo\"></div></div></div></div></div></md-content></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-invoice-info/company-invoice-infos.html","<div><h2 translate=\"tikonApp.companyInvoiceInfo.home.title\">Company Managers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company-invoice-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.companyInvoiceInfo.home.createLabel\">Create new Company Manager</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.companyInvoiceInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span translate=\"tikonApp.companyInvoiceInfo.companyTitle\">Company Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subscriptionPrice\"><span translate=\"tikonApp.companyInvoiceInfo.subscriptionPrice\">subscriptionPrice</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.companyInvoiceInfo.discount\">discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.companyInvoiceInfo.finalPrice\">finalPrice</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.companyInvoiceInfo.status\">status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.companyInvoiceInfo.invoiceType\">invoiceType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.paymentLog.paymentType\">paymentType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.paymentLog.amount\">amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.paymentLog.moreInfo\">moreInfo</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyInvoiceInfo in vm.companyInvoiceInfos track by companyInvoiceInfo.id\"><td><a ui-sref=\"company-invoice-info.edit\">{{companyInvoiceInfo.id}}</a></td><td>{{companyInvoiceInfo.company.title}}</td><td>{{companyInvoiceInfo.subscriptionPrice | number}}</td><td>{{companyInvoiceInfo.discount | number}}</td><td>{{companyInvoiceInfo.finalPrice | number}}</td><td>{{companyInvoiceInfo.status}}</td><td>{{companyInvoiceInfo.invoiceType}}</td><td>{{companyInvoiceInfo.paymentLog.paymentType}} {{companyInvoiceInfo.paymentLog.createDate | toPersianDate}}</td><td>{{companyInvoiceInfo.paymentLog.amount}}</td><td>{{companyInvoiceInfo.paymentLog.moreInfo}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-invoice-info.edit({id:companyInvoiceInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company-manager.delete({id:companyInvoiceInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-manager/company-manager-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.companyManager.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.companyManager.delete.question\" translate-values=\"{id: \'{{vm.companyManager.id}}\'}\">Are you sure you want to delete this Company Manager?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-manager/company-manager-detail.html","<div><h2><span translate=\"tikonApp.companyManager.detail.title\">Company Manager</span> {{vm.companyManager.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.companyManager.managerType\">Manager Type</span></dt><dd><span>{{vm.companyManager.managerType}}</span></dd><dt><span translate=\"tikonApp.companyManager.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.companyManager.companyId})\">{{vm.companyManager.companyId}}</a></dd><dt><span translate=\"tikonApp.companyManager.personInfo\">Person Info</span></dt><dd><a ui-sref=\"person-info-detail({id:vm.companyManager.personInfoId})\">{{vm.companyManager.personInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company-manager/company-manager-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyManagerLabel\" translate=\"tikonApp.companyManager.home.createOrEditLabel\">Create or edit a Company Manager</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companyManager.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companyManager.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyManager.managerType\" for=\"field_managerType\">Manager Type</label><select class=\"form-control\" name=\"managerType\" ng-model=\"vm.companyManager.managerType\" id=\"field_managerType\" required eo-required=\"\"><option value=\"MANAGER\" translate=\"tikonApp.ManagerType.MANAGER\">MANAGER</option><option value=\"SERVANT\" translate=\"tikonApp.ManagerType.SERVANT\">SERVANT</option><option value=\"SECRETARY\" translate=\"tikonApp.ManagerType.SECRETARY\">SECRETARY</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.companyManager.companyName\" for=\"field_companyName\">CompanyName</label><input type=\"text\" class=\"form-control\" name=\"companyName\" id=\"field_companyName\" ng-model=\"vm.companyManager.companyName\"> <span><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.findCompany()\"><span class=\"glyphicon glyphicon-search\"></span></button></span><div><span>{{vm.companyManager.company.title}}</span></div></div><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.companyManager.company\" for=\"field_company\">Company</label>--><!--<select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.companyManager.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--><div class=\"form-group\"><label translate=\"tikonApp.companyManager.personInfoName\" for=\"field_personInfoName\">personInfoName</label><input type=\"text\" class=\"form-control\" name=\"personInfoName\" id=\"field_personInfoName\" ng-model=\"vm.companyManager.personInfoName\"> <span><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.findPersonInfo()\"><span class=\"glyphicon glyphicon-search\"></span></button></span><div><span>{{vm.companyManager.personInfo.fisrtName}}</span> <span>{{vm.companyManager.personInfo.lastName}}</span></div></div><div class=\"form-group\"><label translate=\"tikonApp.companyManager.personInfo\" for=\"field_personInfo\">Person Info</label><select class=\"form-control\" id=\"field_personInfo\" name=\"personInfo\" ng-model=\"vm.companyManager.personInfoId\" ng-options=\"personInfo.id as personInfo.id for personInfo in vm.personinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-manager/company-managers.html","<div><h2 translate=\"tikonApp.companyManager.home.title\">Company Managers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company-manager.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.companyManager.home.createLabel\">Create new Company Manager</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.companyManager.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"managerType\"><span translate=\"tikonApp.companyManager.managerType\">Manager Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span translate=\"tikonApp.companyManager.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.companyManager.companyName\">Company Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personInfoId\"><span translate=\"tikonApp.companyManager.personInfo\">Person Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.companyManager.personInfoName\">Person Info Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyManager in vm.companyManagers track by companyManager.id\"><td><a ui-sref=\"company-manager-detail({id:companyManager.id})\">{{companyManager.id}}</a></td><!--<td>{{companyManager.managerType}}</td>--><td translate=\"{{\'tikonApp.ManagerType.\' + companyManager.managerType}}\">{{companyManager.managerType}}</td><td><a ui-sref=\"company-detail({id:companyManager.companyId})\">{{companyManager.companyId}}</a></td><td>{{companyManager.company.title}}</td><td><a ui-sref=\"person-info-detail({id:companyManager.personInfoId})\">{{companyManager.personInfoId}}</a></td><td>{{companyManager.personInfo.fisrtName}} {{companyManager.personInfo.lastName}}<div>{{companyManager.personInfo.phoneNumber}}</div></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-manager-detail({id:companyManager.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company-manager.edit({id:companyManager.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company-manager.delete({id:companyManager.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-payment-log/company-all-payment-log-list-v2.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }</style><div class=\"pl-form-container\"><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 category-list-title\" style=\"display: flex\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"supplierPanel.sideMenu.accounting.companyOnlinePayments\">title-list</h3><div style=\"display: flex\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.companyPaymentLogList\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon><span class=\"\">بازگشت</span></md-button></div></div></div><div class=\"pl-container-fluid\"><div class=\"table-responsive\"><table st-safe-src=\"vm.companyPaymentLogs\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>مشتری</span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.paymentLog.onlineGateway\">onlineGateway</span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.paymentLog.traceCode\">trace Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in collection track by companyPaymentLog.id\"><td>{{companyPaymentLog.orderBag.id}}</td><td><span data-ng-if=\"companyPaymentLog.orderBag.customer && companyPaymentLog.orderBag.customer.personalInfo\">{{companyPaymentLog.orderBag.customer.personalInfo.fisrtName+\" \"+companyPaymentLog.orderBag.customer.personalInfo.lastName}}<p style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.orderBag.customer.personalInfo.phoneNumber}}</p></span></td><td>{{companyPaymentLog.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{companyPaymentLog.paymentAmount | number}}</strong></td><td><div class=\"row\" ng-if=\"companyPaymentLog.paymentLog &&  companyPaymentLog.paymentLog.onlineGateway\"><div class=\"col-sm-4\" ng-class=\"companyPaymentLog.paymentLog.onlineGateway\"></div><div class=\"col-sm-8\" style=\"line-height: 2\">{{\'tikonApp.bankAccountInfo.onlinePaymentGateway.\'+ companyPaymentLog.paymentLog.onlineGateway | translate}}</div></div></td><td><span ng-if=\"companyPaymentLog.paymentLog\">{{companyPaymentLog.paymentLog.traceCode }}</span></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/entities/company-payment-log/company-all-payment-log-list.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.accounting.companyOnlinePayments\">companyOnlinePayments</div><div class=\"panel-body\"><div class=\"container-fluid\"><!--<h2 translate=\"tikonApp.companyPaymentLog.home.title\">Company Payment Logs</h2>--><jhi-alert></jhi-alert><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.companyPaymentLogList\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"tikonApp.companyPaymentLog.buttons.companyRemaindNotPaid\">tikonApp.buttons.companyRemaindNotPaid</span></md-button><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.companyPaymentLogs\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>مشتری</span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.paymentLog.onlineGateway\">onlineGateway</span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.paymentLog.traceCode\">trace Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in collection track by companyPaymentLog.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:companyPaymentLog.orderBag.id})\">{{companyPaymentLog.orderBag.id}}</a></td><td><span data-ng-if=\"companyPaymentLog.orderBag.customer && companyPaymentLog.orderBag.customer.personalInfo\">{{companyPaymentLog.orderBag.customer.personalInfo.fisrtName+\" \"+companyPaymentLog.orderBag.customer.personalInfo.lastName}}<p style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.orderBag.customer.personalInfo.phoneNumber}}</p></span></td><td>{{companyPaymentLog.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{companyPaymentLog.paymentAmount | number}}</strong></td><td><div class=\"row\" ng-if=\"companyPaymentLog.paymentLog &&  companyPaymentLog.paymentLog.onlineGateway\"><div class=\"col-sm-4\" ng-class=\"companyPaymentLog.paymentLog.onlineGateway\"></div><div class=\"col-sm-8\" style=\"line-height: 2\">{{\'tikonApp.bankAccountInfo.onlinePaymentGateway.\'+ companyPaymentLog.paymentLog.onlineGateway | translate}}</div></div></td><td><span ng-if=\"companyPaymentLog.paymentLog\">{{companyPaymentLog.paymentLog.traceCode }}</span></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div>");
$templateCache.put("app/entities/company-payment-log/company-approval-payment-log-list-v2.html","<div id=\"container-payment-logs\"><panel-pln-company-approval-payment-logs id=\"payment-logs\"></panel-pln-company-approval-payment-logs></div>");
$templateCache.put("app/entities/company-payment-log/company-approval-payment-log-list.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }\n    \n    @media (max-width: 768px) {\n        .pageSize {\n            display: none;\n        }\n        .topOfList {\n            margin: 15px auto!important;\n        }\n    }</style><div class=\"pl-form-container\"><div class=\"row\"><div class=\"col-xs-12 category-list-title\" style=\"display: flex\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.companyPaymentLog.approveTransactions.title\">title-list</h3><div style=\"display: flex\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.companyPaymentLogList\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon><span class=\"\">بازگشت</span></md-button></div></div></div><div class=\"pl-container-fluid\"><div><div class=\"form-field-description\" style=\"padding-bottom: 10px\"><span>* برای اعمال فیلتر (جستجوی پیشرفته) گزینه </span><span><md-icon>filter_list</md-icon></span><span>را انتخاب کنید.</span></div><div class=\"row topOfList\" style=\"display: flex; align-items: center\"><div class=\"col-xs-12 col-sm-10\"><eo-pl-search-box search-query=\"vm.filterQuery.query\" search-place-holder=\"\'tikonApp.companyPaymentLog.serachPlaceHolder\'\" on-search=\"vm.advancedSearch()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box></div><div class=\"col-sm-2 pageSize\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.pageSize\">pageSize</label><md-select class=\"rwMdSelect\" id=\"field_pageSize\" ng-model=\"vm.size\" ng-change=\"vm.pageSizeChanged()\" style=\"min-width: 100px;margin-bottom: 5px !important\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.pageSizeList\">{{si}}</md-option></md-select></div></div></div><div class=\"\"><div class=\"table-responsive\"><table st-safe-src=\"vm.paymentLogList\" st-table=\"collection2\" st-safe- class=\"jh-table table rwTable\"><thead><tr class=\"pl-table-header\"><th st-sort=\"invoiceInfoId\"><span translate=\"tikonApp.companyPaymentLog.transactionId\">transaction id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customer\"><span translate=\"tikonApp.companyPaymentLog.createDate\">create date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customer\"><span translate=\"tikonApp.companyPaymentLog.transactionType\">ransaction type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\"><span translate=\"tikonApp.companyPaymentLog.price\">price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">orderBagId</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"orderBagId\"><span translate=\"tikonApp.companyPaymentLog.customerName\">customer name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"comment\"><span translate=\"tikonApp.companyPaymentLog.invoiceId\">invoice id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th>یادداشت</th><th><span translate=\"tikonApp.companyPaymentLog.approvalStatus\">approval status</span></th><th has-authority=\"ROLE_FINANCIAL_MANAGER\"><span translate=\"tikonApp.companyPaymentLog.operations\">operations</span></th></tr></thead><tbody><tr ng-repeat=\"paymentLog in collection2 track by paymentLog.id\"><td><span>{{paymentLog.id}}</span></td><td><div>{{paymentLog.createDate | toPersianDate}}</div><div style=\"font-size: 12px\">{{paymentLog.createDate | toPersianTime}}</div></td><td><span translate=\"{{\'tikonApp.PaymentType.\'+ paymentLog.paymentType}}\">{{paymentLog.paymentType}}</span><!-- <span translate=\"{{\'tikonApp.PaymentType.\'+ paymentLog.paymentType}}\">paymentLog.paymentType</span> --></td><td>{{paymentLog.amount | number}}</td><td><a ui-sref=\"supplierPanel-v2.editOrderBag({id:paymentLog.orderBagId})\">{{paymentLog.orderBagId}}</a></td><td>{{paymentLog.customer.fisrtName}} {{paymentLog.customer.lastName}}</td><td><a ng-if=\"!paymentLog.orderBagId\" ui-sref=\"supplierPanel-v2.invoiceInfoDetail({id:paymentLog.invoiceInfoId})\">{{paymentLog.invoiceInfoId}}</a></td><td style=\"max-width: 210px; overflow-x: auto; font-weight: normal\">{{paymentLog.managerApprovalComment}}</td><td ng-class=\"vm.findStatusStyle(paymentLog.managerApprovalStatus)\"><span ng-class=\"vm.findStatusIcon(paymentLog.managerApprovalStatus)\"></span> <span translate=\"{{\'tikonApp.companyPaymentLog.paymentStatus.\' + paymentLog.managerApprovalStatus}}\">{{paymentLog.managerApprovalStatus}}</span></td><td class=\"text-right\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><button type=\"submit\" ng-click=\"vm.determinStatus(paymentLog)\" ng-disabled=\"paymentLog.managerApprovalStatus === \'APPROVED\'\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\" style=\"width: auto\"><span translate=\"tikonApp.companyPaymentLog.determinStaus\"></span></button></td></tr></tbody></table></div></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.size\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.size\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/entities/company-payment-log/company-payment-log-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.companyPaymentLog.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.companyPaymentLog.delete.question\" translate-values=\"{id: \'{{vm.companyPaymentLog.id}}\'}\">Are you sure you want to delete this Company Payment Log?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-payment-log/company-payment-log-detail.html","<div><h2><span translate=\"tikonApp.companyPaymentLog.detail.title\">Company Payment Log</span> {{vm.companyPaymentLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span></dt><dd><span>{{vm.companyPaymentLog.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span></dt><dd><span>{{vm.companyPaymentLog.paymentAmount}}</span></dd><dt><span translate=\"tikonApp.companyPaymentLog.wageFeeAmount\">Wage Fee Amount</span></dt><dd><span>{{vm.companyPaymentLog.wageFeeAmount}}</span></dd><dt><span translate=\"tikonApp.companyPaymentLog.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.AccountClearingRequestStatus.\' + vm.companyPaymentLog.status}}\">{{vm.companyPaymentLog.status}}</span></dd><dt><span translate=\"tikonApp.companyPaymentLog.description\">Description</span></dt><dd><span>{{vm.companyPaymentLog.description}}</span></dd><dt><span translate=\"tikonApp.companyPaymentLog.clearingRequest\">Clearing Request</span></dt><dd><a ui-sref=\"account-clearing-request-detail({id:vm.companyPaymentLog.clearingRequestId})\">{{vm.companyPaymentLog.clearingRequestId}}</a></dd><dt><span translate=\"tikonApp.companyPaymentLog.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.companyPaymentLog.companyId})\">{{vm.companyPaymentLog.companyId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company-payment-log/company-payment-log-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyPaymentLogLabel\" translate=\"tikonApp.companyPaymentLog.home.createOrEditLabel\">Create or edit a Company Payment Log</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companyPaymentLog.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companyPaymentLog.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.companyPaymentLog.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.paymentAmount\" for=\"field_paymentAmount\">Payment Amount</label><input type=\"number\" class=\"form-control\" name=\"paymentAmount\" id=\"field_paymentAmount\" ng-model=\"vm.companyPaymentLog.paymentAmount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.wageFeeAmount\" for=\"field_wageFeeAmount\">Wage Fee Amount</label><input type=\"number\" class=\"form-control\" name=\"wageFeeAmount\" id=\"field_wageFeeAmount\" ng-model=\"vm.companyPaymentLog.wageFeeAmount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.companyPaymentLog.status\" id=\"field_status\"><option value=\"REQUESTED\" translate=\"tikonApp.AccountClearingRequestStatus.REQUESTED\">REQUESTED</option><option value=\"UNDERWAY\" translate=\"tikonApp.AccountClearingRequestStatus.UNDERWAY\">UNDERWAY</option><option value=\"DONE\" translate=\"tikonApp.AccountClearingRequestStatus.DONE\">DONE</option><option value=\"CANCELED\" translate=\"tikonApp.AccountClearingRequestStatus.CANCELED\">CANCELED</option><option value=\"FAILED\" translate=\"tikonApp.AccountClearingRequestStatus.FAILED\">FAILED</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.companyPaymentLog.description\"></div><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.clearingRequest\" for=\"field_clearingRequest\">Clearing Request</label><select class=\"form-control\" id=\"field_clearingRequest\" name=\"clearingRequest\" ng-model=\"vm.companyPaymentLog.clearingRequestId\" ng-options=\"accountClearingRequest.id as accountClearingRequest.id for accountClearingRequest in vm.accountclearingrequests\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.companyPaymentLog.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-payment-log/company-payment-log-list-v2.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }</style><div class=\"pl-content\"><jhi-alert-error></jhi-alert-error><div class=\"container-fluid pl-container-fluid\"><div class=\"customer-header-container\"><div class=\"customer-header-info\" style=\"flex-flow: column\"><div><div class=\"customer-list-customer-name\">جمع مبلغ تسویه نشده : {{vm.sumPaymentAmount | number}} <span translate=\"global.currency\"></span></div></div><div><div class=\"customer-list-customer-name\">جمع پرداخت های آنلاین : {{vm.sumPaymentAmount | number}} <span translate=\"global.currency\"></span></div></div><div ng-if=\"vm.activeClearRequest.id != null\" style=\"color: #0e8dd8\"><h4>درخواست تسویه در تاریخ <span>{{vm.activeClearRequest.createDate | toPersianDate}} ساعت {{vm.activeClearRequest.createDate | toPersianTime}} </span>ثبت شده است و در حال بررسی توسط بخش مالی است.</h4></div><md-button ng-if=\"vm.activeClearRequest.id == null\" ng-click=\"vm.accountClearRequest()\" ng-disabled=\"!vm.canSendRequest || vm.newAccountClearingRequestLoading\" class=\"md-raised md-primary pl-btn-primary pl-btn\" style=\"width: 100%; max-width: 250px\"><span class=\"\" translate=\"tikonApp.companyPaymentLog.accountClearRequest\">accountClearRequest</span></md-button><div ng-if=\"!vm.canSendRequest\" style=\"color: red\">حداقل مبلغ قابل تسویه 200 هزار تومان است. امکان ثبت تسویه وجود ندارد.</div></div><div class=\"customer-header-buttons\"><div class=\"payment-log-actions-item\" ui-sref=\"supplierPanel-v2.accountClearingList\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">list</md-icon></div><div class=\"customer-header-button-box-text\"><span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.accountClearingList\"></span></div></div><div class=\"payment-log-actions-item\" ui-sref=\"supplierPanel-v2.companyAllPaymentLogList\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">list</md-icon></div><div class=\"customer-header-button-box-text\"><span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.companyOnlinePayments\"></span></div></div><div has-authority=\"ROLE_FINANCIAL_MANAGER\" class=\"payment-log-actions-item\" ui-sref=\"supplierPanel-v2.companyApprovalPaymentLogListV2\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">list</md-icon></div><div class=\"customer-header-button-box-text\"><span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.approvalPaymentsList\"></span></div></div></div></div><div class=\"customer-component-container\"><h3 translate=\"tikonApp.companyPaymentLog.transactionDtails\"></h3><div class=\"table-responsive\"><table st-safe-src=\"vm.companyPaymentLogs\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>مشتری</span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.paymentLog.onlineGateway\">onlineGateway</span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.paymentLog.traceCode\">trace Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in collection track by companyPaymentLog.id\"><td>{{companyPaymentLog.orderBag.id}}</td><td><span data-ng-if=\"companyPaymentLog.orderBag.customer && companyPaymentLog.orderBag.customer.personalInfo\">{{companyPaymentLog.orderBag.customer.personalInfo.fisrtName+\" \"+companyPaymentLog.orderBag.customer.personalInfo.lastName}}<p style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.orderBag.customer.personalInfo.phoneNumber}}</p></span></td><td>{{companyPaymentLog.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{companyPaymentLog.paymentAmount | number}}</strong></td><td><div class=\"row\" ng-if=\"companyPaymentLog.paymentLog &&  companyPaymentLog.paymentLog.onlineGateway\"><div class=\"col-sm-4\" ng-class=\"companyPaymentLog.paymentLog.onlineGateway\"></div><div class=\"col-sm-8\" style=\"line-height: 2\">{{\'tikonApp.bankAccountInfo.onlinePaymentGateway.\'+ companyPaymentLog.paymentLog.onlineGateway | translate}}</div></div></td><td><span ng-if=\"companyPaymentLog.paymentLog\">{{companyPaymentLog.paymentLog.traceCode }}</span></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div><!--<div class=\"panel panel-default\">--><!--<div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.accounting.companyRemaindNotPayed\">--><!--supplierPanel.sideMenu.accounting.companyRemaindNotPayed--><!--</div>--><!--<div class=\"panel-body\">--><!--<div class=\"container-fluid\">--><!--&lt;!&ndash;<h2 translate=\"tikonApp.companyPaymentLog.home.title\">Company Payment Logs</h2>&ndash;&gt;--><!--<jhi-alert-error></jhi-alert-error>--><!--<br/>--><!--<md-button ng-if=\"vm.activeClearRequest.id == null\"--><!--ng-click=\"vm.accountClearRequest()\"--><!--class=\"md-raised md-primary pull-right\">--><!--<span class=\"\" translate=\"tikonApp.companyPaymentLog.accountClearRequest\">--><!--accountClearRequest--><!--</span>--><!--</md-button>--><!--<md-button  class=\"md-raised md-secondary\"--><!--ui-sref=\"supplierPanel.accountClearingList\">--><!--<i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i>--><!--<span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.accountClearingList\">--><!--accountClearingList--><!--</span>--><!--</md-button>--><!--<md-button ng-if=\"vm.activeClearRequest.id != null\" class=\"md-raised md-secondary\"--><!--ui-sref=\"supplierPanel.companyAllPaymentLogList\">--><!--<i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i>--><!--<span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.companyOnlinePayments\">--><!--tikonApp.buttons.companyOnlinePayments--><!--</span>--><!--</md-button>--><!--<md-button ng-if=\"vm.activeClearRequest.id == null\" class=\"md-raised md-secondary\"--><!--ui-sref=\"supplierPanel.companyAllPaymentLogList\">--><!--<i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i>--><!--<span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.companyOnlinePayments\">--><!--tikonApp.buttons.companyOnlinePayments--><!--</span>--><!--</md-button>--><!--<md-content class=\"rwMdContent\">--><!--<br/>--><!--<br/>--><!--<div class=\"table-responsive\">--><!--<table class=\"table table-striped tableOfPayment\">--><!--<thead>--><!--<tr>--><!--<th><span--><!--translate=\"tikonApp.companyPaymentLog.sumPaymentAmount\">sumPaymentAmount</span><span--><!--translate=\"global.currencyBracket\"></span></th>--><!--&lt;!&ndash;<th><span translate=\"tikonApp.companyPaymentLog.sumWageFeeAmount\">sumWageFeeAmount</span><span translate=\"global.currencyBracket\"></span> </th>&ndash;&gt;--><!--<th><span--><!--translate=\"tikonApp.companyPaymentLog.sumRemaindAmount\">sumRemaindAmount</span><span--><!--translate=\"global.currencyBracket\"></span></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr class=\"info\">--><!--<td>{{vm.sumPaymentAmount | number}}</td>--><!--&lt;!&ndash;<td>{{vm.sumWage | number}}</td>&ndash;&gt;--><!--&lt;!&ndash;<td>{{vm.sumRemaindAmount | number}}</td>&ndash;&gt;--><!--&lt;!&ndash;فعلا به دلیل باگ سیستم اینجوری در نظر میگیریم&ndash;&gt;--><!--<td>{{vm.sumPaymentAmount | number}}</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<br/>--><!--</md-content>--><!--</div>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/company-payment-log/company-payment-log-list.html","<style>.tableOfPayment {\n        background-color: whitesmoke;\n    }\n\n    .tableOfPayment > tbody > tr > td {\n        background-color: #eeeeee !important;\n    }\n\n    table > thead > tr {\n        background-color: whitesmoke;\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.accounting.companyRemaindNotPayed\">supplierPanel.sideMenu.accounting.companyRemaindNotPayed</div><div class=\"panel-body\"><div class=\"container-fluid\"><!--<h2 translate=\"tikonApp.companyPaymentLog.home.title\">Company Payment Logs</h2>--><jhi-alert-error></jhi-alert-error><br><div ng-if=\"vm.activeClearRequest.id != null\" style=\"color: #0e8dd8\"><h4>درخواست تسویه در تاریخ <span>{{vm.activeClearRequest.createDate | toPersianDate}} ساعت {{vm.activeClearRequest.createDate | toPersianTime}} </span>ثبت شده است و در حال بررسی توسط بخش مالی است.</h4></div><md-button ng-if=\"vm.activeClearRequest.id == null\" ng-click=\"vm.accountClearRequest()\" class=\"md-raised md-primary pull-right\"><span class=\"\" translate=\"tikonApp.companyPaymentLog.accountClearRequest\">accountClearRequest</span></md-button><md-button class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.accountClearingList\"><i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> <span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.accountClearingList\">accountClearingList</span></md-button><md-button ng-if=\"vm.activeClearRequest.id != null\" class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.companyAllPaymentLogList\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> <span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.companyOnlinePayments\">tikonApp.buttons.companyOnlinePayments</span></md-button><md-button ng-if=\"vm.activeClearRequest.id == null\" class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.companyAllPaymentLogList\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> <span class=\"\" translate=\"tikonApp.companyPaymentLog.buttons.companyOnlinePayments\">tikonApp.buttons.companyOnlinePayments</span></md-button><md-content class=\"rwMdContent\"><br><br><div class=\"table-responsive\"><table class=\"table table-striped tableOfPayment\"><thead><tr><th><span translate=\"tikonApp.companyPaymentLog.sumPaymentAmount\">sumPaymentAmount</span><span translate=\"global.currencyBracket\"></span></th><!--<th><span translate=\"tikonApp.companyPaymentLog.sumWageFeeAmount\">sumWageFeeAmount</span><span translate=\"global.currencyBracket\"></span> </th>--><th><span translate=\"tikonApp.companyPaymentLog.sumRemaindAmount\">sumRemaindAmount</span><span translate=\"global.currencyBracket\"></span></th></tr></thead><tbody><tr class=\"info\"><td>{{vm.sumPaymentAmount | number}}</td><!--<td>{{vm.sumWage | number}}</td>--><!--<td>{{vm.sumRemaindAmount | number}}</td>--><!--فعلا به دلیل باگ سیستم اینجوری در نظر میگیریم--><td>{{vm.sumPaymentAmount | number}}</td></tr></tbody></table></div><br><h3 translate=\"tikonApp.companyPaymentLog.transactionDtails\"></h3><div class=\"table-responsive\"><table st-safe-src=\"vm.companyPaymentLogs\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th st-sort=\"id\"><span translate=\"tikonApp.companyPaymentLog.orderBagId\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>مشتری</span></th><th st-sort=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span translate=\"global.currencyBracket\"></span></th><th><span translate=\"tikonApp.paymentLog.onlineGateway\">onlineGateway</span></th><th st-sort=\"paymentAmount\"><span translate=\"tikonApp.paymentLog.traceCode\">trace Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in collection track by companyPaymentLog.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:companyPaymentLog.orderBag.id})\">{{companyPaymentLog.orderBag.id}}</a></td><td><span data-ng-if=\"companyPaymentLog.orderBag.customer && companyPaymentLog.orderBag.customer.personalInfo\">{{companyPaymentLog.orderBag.customer.personalInfo.fisrtName+\" \"+companyPaymentLog.orderBag.customer.personalInfo.lastName}}<p style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.orderBag.customer.personalInfo.phoneNumber}}</p></span></td><td>{{companyPaymentLog.createDate | toPersianDate}}<br><span style=\"font-size: 11px ; color: #5c5c5c\">{{companyPaymentLog.createDate | toPersianTime}}</span></td><td><strong class=\"text-center\">{{companyPaymentLog.paymentAmount | number}}</strong></td><td><div class=\"row\" ng-if=\"companyPaymentLog.paymentLog &&  companyPaymentLog.paymentLog.onlineGateway\"><div class=\"col-sm-4\" ng-class=\"companyPaymentLog.paymentLog.onlineGateway\"></div><div class=\"col-sm-8\" style=\"line-height: 2\">{{\'tikonApp.bankAccountInfo.onlinePaymentGateway.\'+ companyPaymentLog.paymentLog.onlineGateway | translate}}</div></div></td><td><span ng-if=\"companyPaymentLog.paymentLog\">{{companyPaymentLog.paymentLog.traceCode }}</span></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div>");
$templateCache.put("app/entities/company-payment-log/company-payment-logs.html","<div><h2 translate=\"tikonApp.companyPaymentLog.home.title\">Company Payment Logs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company-payment-log.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.companyPaymentLog.home.createLabel\">Create new Company Payment Log</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.companyPaymentLog.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.companyPaymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paymentAmount\"><span translate=\"tikonApp.companyPaymentLog.paymentAmount\">Payment Amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"wageFeeAmount\"><span translate=\"tikonApp.companyPaymentLog.wageFeeAmount\">Wage Fee Amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.companyPaymentLog.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.companyPaymentLog.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"clearingRequestId\"><span translate=\"tikonApp.companyPaymentLog.clearingRequest\">Clearing Request</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span translate=\"tikonApp.companyPaymentLog.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyPaymentLog in vm.companyPaymentLogs track by companyPaymentLog.id\"><td><a ui-sref=\"company-payment-log-detail({id:companyPaymentLog.id})\">{{companyPaymentLog.id}}</a></td><td>{{companyPaymentLog.createDate | date:\'medium\'}}</td><td>{{companyPaymentLog.paymentAmount}}</td><td>{{companyPaymentLog.wageFeeAmount}}</td><td translate=\"{{\'tikonApp.AccountClearingRequestStatus.\' + companyPaymentLog.status}}\">{{companyPaymentLog.status}}</td><td>{{companyPaymentLog.description}}</td><td><a ui-sref=\"account-clearing-request-detail({id:companyPaymentLog.clearingRequestId})\">{{companyPaymentLog.clearingRequestId}}</a></td><td><a ui-sref=\"company-detail({id:companyPaymentLog.companyId})\">{{companyPaymentLog.companyId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-payment-log-detail({id:companyPaymentLog.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company-payment-log.edit({id:companyPaymentLog.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company-payment-log.delete({id:companyPaymentLog.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-payment-log/determin-status-dialog.html","<eo-pl-modal-header title=\"\'تایید تراکنش\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" style=\"margin-top: 40px\"><span>اطلاعات تراکنش:</span></div><div class=\"panel-body\" style=\"padding-inline: 40px\"><div id=\"insertOrderBagPayment\" class=\"container-fluid pl-container-fluid\"><div class=\"row\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"row\"><div class=\"row\"><div class=\"col-md-4\"><div ng-if=\"vm.paymentLog.orderBagId\" class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.orderBagId\" for=\"field_traceCode\">orderBagId</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" ng-model=\"vm.paymentLog.orderBagId\"></div><div ng-if=\"!vm.paymentLog.orderBagId\" class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.invoiceId\" for=\"field_traceCode\">orderBagId</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" ng-model=\"vm.paymentLog.invoiceId\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.customerName\" for=\"field_moreInfo\">customer name</label><input type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"moreInfo\" id=\"field_moreInfo\" ng-model=\"vm.fullName\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.price\" for=\"field_moreInfo\">price</label><input type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"moreInfo\" id=\"field_moreInfo\" ng-model=\"vm.price\"><!-- <eo-numeric-input-v2 id=\"field_minPrice\"\n                                            name=\"minPrice\"\n                                            custom-class=\"form-control\"\n                                            input-value=\"vm.paymentLog.amount\"\n                                            is-required=\"true\"\n                                            form-reference=\"editForm\"\n                                            currency-format=\"true\"\n                                            readonly\n                                            disabled\n                                            >\n                                            </eo-numeric-input-v2> --></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyPaymentLog.approvalStatus\" for=\"field_paymentType\">approval status</label><md-select class=\"rwMdSelect\" name=\"paymentType\" ng-model=\"vm.status\" id=\"field_paymentType\" required eo-required=\"\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><md-option ng-value=\"status\" ng-repeat=\"status in vm.statusList\" translate=\"{{\'tikonApp.companyPaymentLog.paymentStatus.\'+status }}\">CASH</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyPaymentLog.approvalComment\" for=\"field_paymentType\">approval comment</label><textarea ng-model=\"vm.managerApprovalComment\" class=\"form-control\" rows=\"5\"></textarea></div></div></div></form></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/company-payment-log/filter-payment-log-list-dialog.html","<style>.panel {\n        margin: 0;\n\n    }\n\n    .filter_by_select > md-select-value > span {\n        display: -webkit-inline-box;\n    }\n\n    .custom-panel-style {\n        min-height: 320px;\n    }\n\n    @media (max-width: 767px) {\n        .custom-panel-style {\n            min-height: 415px;\n        }\n    }</style><md-dialog class=\"pl-md-dialog\"><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div>اعمال فیلتر (جستجوی پیشرفته)</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><md-dialog-content class=\"pl-dialog-content\"><div class=\"\"><div class=\"panel-body custom-panel-style\"><div id=\"filters_content\"><div class=\"row\"><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"$ctrl.data.filterQuery[\'from-date\']\"></eo-date-picker></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"$ctrl.data.filterQuery[\'to-date\']\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.approvalStatus\">approval status</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\" id=\"field_filterStatus\" placeholder=\"{{\'tikonApp.companyPaymentLog.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery[\'approval-status\']\" style=\"min-width: 100px\"><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.data.statusList\">{{\"tikonApp.companyPaymentLog.paymentStatus.\"+si | translate}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.transactionType\">transaction type</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\" id=\"field_filterStatus\" placeholder=\"{{\'tikonApp.companyPaymentLog.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery[\'payment-type\']\" style=\"min-width: 100px\"><md-option value=\"CASH\">{{\"tikonApp.PaymentType.CASH\" | translate}}</md-option><md-option value=\"CREDIT_CARD\">{{\"tikonApp.PaymentType.CREDIT_CARD\" | translate}}</md-option><md-option value=\"MONEY_TRANSFER\">{{\"tikonApp.PaymentType.MONEY_TRANSFER\" | translate}}</md-option><md-option value=\"CARD_TO_CARD\">{{\"tikonApp.PaymentType.CARD_TO_CARD\" | translate}}</md-option><md-option value=\"SHABA\">{{\"tikonApp.PaymentType.SHABA\" | translate}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.orderBagId\"></label><input class=\"form-control rwTableSearchBox pl-col-no-margin\" style=\"max-width: unset\" ng-model=\"$ctrl.data.filterQuery[\'order-bag-id\']\" placeholder=\"جستجو براساس شماره رزرو\" type=\"text\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyPaymentLog.invoiceId\"></label><input class=\"form-control rwTableSearchBox pl-col-no-margin\" style=\"max-width: unset\" ng-model=\"$ctrl.data.filterQuery[\'invoice-id\']\" placeholder=\"جستجو براساس شماره فاکتور\" type=\"text\"></div></div></div></div></div></div></md-dialog-content><md-dialog-actions class=\"pl-dialog-actions\"><div class=\"pl-filter-dialog-footer\" style=\"width: 100%\"><div class=\"\" style=\"display: flex;justify-content: flex-end\"><a class=\"delete-filters\" ng-click=\"$ctrl.clearFilter()\"><i class=\"material-icons\" style=\"font-size: 12px\">cancel</i> حذف فیلترها</a><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default hidden-xs\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span>بازگشت</span><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--></md-button><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-click=\"$ctrl.okModal()\"><span>اعمال</span></md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/entities/company-rule/company-rule-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerRank.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.customerRank.delete.question\" translate-values=\"{id: \'{{vm.customerRank.id}}\'}\">Are you sure you want to delete this Customer Rank?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-rule/company-rule-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myNewsLabel\" translate=\"tikonApp.companyRule.home.createOrEditLabel\">Create or edit a News</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companyRule.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companyRule.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyRule.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.companyRule.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyRule.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.companyRule.description\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.companyRule.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.companyRule.status\" id=\"field_status\"><option value=\"ACTIVE\">ACTIVE</option><option value=\"INACTIVE\">INACTIVE</option></select></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.companyRule.ruleType\" for=\"field_ruleType\">ruleType</label><select class=\"form-control\" name=\"ruleType\" ng-model=\"vm.companyRule.ruleType\" id=\"field_ruleType\"><option value=\"SSAA_MALEKIAT_API\" data-translate=\"tikonApp.CompanyRuleType.SSAA_MALEKIAT_API\">SSAA_MALEKIAT_API</option><option value=\"CLIENT_RESERVE_TIME_LIMIT\" data-translate=\"tikonApp.CompanyRuleType.CLIENT_RESERVE_TIME_LIMIT\">CLIENT_RESERVE_TIME_LIMIT</option><option value=\"SSAA_NOTARY_PERSONNEL\" data-translate=\"tikonApp.CompanyRuleType.SSAA_NOTARY_PERSONNEL\">SSAA_NOTARY_PERSONNEL</option><option value=\"SSAA_INQUIRY_PERSONNEL\" data-translate=\"tikonApp.CompanyRuleType.SSAA_INQUIRY_PERSONNEL\">SSAA_INQUIRY_PERSONNEL</option><option value=\"SSAA_ORDINARY_PEOPLE\" data-translate=\"tikonApp.CompanyRuleType.SSAA_ORDINARY_PEOPLE\">SSAA_ORDINARY_PEOPLE</option><option value=\"SSAA_EJRA\" data-translate=\"tikonApp.CompanyRuleType.SSAA_EJRA\">SSAA_EJRA</option></select></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.companyRule.actionType\" for=\"field_actionType\">actionType</label><select class=\"form-control\" name=\"actionType\" ng-model=\"vm.companyRule.actionType\" id=\"field_actionType\"><option value=\"CLIENT_RESERVATION\">CLIENT_RESERVATION</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyRule.mainRule\" for=\"field_mainRule\">MainRule</label><input type=\"text\" class=\"form-control\" name=\"mainRule\" id=\"field_mainRule\" ng-model=\"vm.companyRule.mainRule\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_customField1\">{{vm.customField1Translate}}</label><input type=\"text\" class=\"form-control\" name=\"customField1\" id=\"field_customField1\" ng-model=\"vm.companyRule.customField1\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_customField2\">{{vm.customField2Translate}}</label><input type=\"text\" class=\"form-control\" name=\"customField2\" id=\"field_customField2\" ng-model=\"vm.companyRule.customField2\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_customField3\">{{vm.customField3Translate}}</label><input type=\"text\" class=\"form-control\" name=\"customField3\" id=\"field_customField3\" ng-model=\"vm.companyRule.customField3\"></div><div ng-if=\"vm.companyRule.company\">Company : {{vm.companyRule.company.title}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.keyUrl\" for=\"field_companyKeyUrl\">companyKeyUrl</label><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" id=\"field_companyKeyUrl\" ng-model=\"vm.companyKeyUrl\"></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.findCompany()\"><span class=\"glyphicon glyphicon-search\"></span>&nbsp; <span>جستجوی کمپانی</span></button></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-rule/company-rules.html","<div><h2 translate=\"tikonApp.companyRule.home.title\">companyRule</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"companyRule_new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.companyRule.home.createLabel\">Create new companyRule</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.news.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.companyRule.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.companyRule.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ruleType\"><span translate=\"tikonApp.companyRule.ruleType\">RuleType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"company\"><span translate=\"tikonApp.companyRule.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyRule in vm.companyRules track by companyRule.id\"><td><a ui-sref=\"companyRule-edit({id:companyRule.id})\">{{companyRule.id}}</a></td><td>{{companyRule.title}}</td><td>{{companyRule.status}}</td><td>{{companyRule.ruleType}}</td><td>{{companyRule.company.title }}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"companyRule.edit({id:companyRule.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"companyRule.delete({id:companyRule.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-servants/company-servants-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.ComapnyServants.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.servant.delete.question\" translate-values=\"{fullName: \'{{vm.comapnyServants.personInfo.fullName}}\'}\">Are you sure you want to delete this Servant?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-servants/company-servants-dialog.html","<jhi-alert-error></jhi-alert-error><style>md-icon {\n        color: unset;\n    }\n\n    i.text-success, i.text-danger {\n        margin: auto 10px;\n    }\n\n    md-pagination-wrapper {\n        width: auto !important;\n    }\n\n    .rwMdContent {\n        overflow-x: hidden;\n    }\n\n    .service-schedule-block {\n        border-bottom: solid 1px #ff9d1a;\n    }\n\n    .nav-tabs > li > a {\n        margin-right: 0px !important;\n    }\n\n    .my-nav-button {\n        padding: 10px;\n        /*background-color: #ededed;*/\n        background-color: #f4f4f7;\n        color: #fff;\n        border-radius: 5px;\n        color: #585858;\n        border: 1px solid #c1c1c1;\n        box-shadow: 0 0px 4px -2px grey;\n    }\n\n    .my-nav {\n        display: flex;\n        gap: 10px;\n    }\n\n    .my-nav-button-active {\n        background-color: #ffffff;\n        color: #2b6b7f;\n        border-color: #2b6b7f;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.servant.home.createAndEditLabel\">tikonApp.servant.home.createAndEditLabel </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black\" ng-if=\"vm.servant.id != null\">{{vm.servant.personInfo.fisrtName}} {{vm.servant.personInfo.lastName}}</span></div><div class=\"panel-body\"><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\"><!--ثبت اطلاعات--></span></md-button></div><div class=\"pull-right\" has-authority=\"ROLE_SERVANT_MANAGER\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.companyServants\"><span><md-icon>list</md-icon></span><span>بازگشت به لیست</span></md-button></div></div><md-content class=\"rwMdContent\" style=\"overflow-x: hidden\"><div><ul class=\"nav nav-tabs lightnav\"><li class=\"active\"><a data-target=\"#2b\" data-toggle=\"tab\"><md-icon>person</md-icon>اطلاعات عمومی </a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.scheduleInfo\" data-target=\"#1b\" data-toggle=\"tab\"><md-icon>schedule</md-icon><span>ساعت کاری</span></a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.id\" style=\"width: 102%\" data-target=\"#servantServices\" data-toggle=\"tab\"><i class=\"material-icons\">list </i><span>سرویسها (خدمات)</span></a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.id\" data-target=\"#3b\" data-toggle=\"tab\"><i class=\"material-icons\">attach_money </i><span>قیمت گذاری </span></a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.id\" style=\"width: 102%\" data-target=\"#8b\" data-toggle=\"tab\"><i class=\"material-icons\">videocam </i><span>تنظیمات ارتباط تصویری</span></a></li><li><a ng-if=\"vm.showAmenities\" data-target=\"#4b\" data-toggle=\"tab\"><i class=\"material-icons\">domain </i><span>امکانات </span></a></li><li><a ng-if=\"vm.showImageGallery\" data-target=\"#5b\" data-toggle=\"tab\"><i class=\"material-icons\">wallpaper </i><span>گالری تصاویر </span></a></li><li><a ng-if=\"vm.showTags\" data-target=\"#6b\" data-toggle=\"tab\"><i class=\"material-icons\">notes </i><span>تگ ها </span></a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"2b\"><div class=\"container-fluid\"><div class=\"row\"><div ng-if=\"!vm.isWorkSpace\"><pf-person-info person-info=\"vm.servant.personInfo\" is-servant=\"true\" servant-code=\"vm.servant.code\"></pf-person-info></div><div ng-if=\"vm.isWorkSpace\"><pf-person-info-space person-info=\"vm.servant.personInfo\" is-servant=\"true\" servant-code=\"vm.servant.code\"></pf-person-info-space></div></div><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-10\" style=\"padding-right: 5px\"><div class=\"form-group\" style=\"max-width: 200px\"><label class=\"control-label\" translate=\"tikonApp.personInfo.status.title\" for=\"status\">titleOfSelect</label><md-select class=\"rwMdSelect\" ng-model=\"vm.servant.status\" id=\"status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.personInfo.status.active\">ACTIVE</md-option><md-option value=\"NOT_ACTIVE\" translate=\"tikonApp.personInfo.status.notActive\">NOT_ACTIVE</md-option><!--<md-option value=\"NOT_SHOW_IN_LIST\" translate=\"tikonApp.personInfo.status.notShowInList\">--><!--NOT_SHOW_IN_LIST--><!--</md-option>--></md-select></div><div class=\"row\"><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendNotificationByCustomerReserve\">{{\'tikonApp.servant.checkbox.sendSmsByConfirmingResFromCustomer\' | translate}}</md-checkbox></div><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendEmailByCustomerReserve\">{{\'tikonApp.servant.checkbox.sendEmailByConfirmingResFromCustomer\' | translate}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendNotificationBySupplierReserve\">{{\'tikonApp.servant.checkbox.sendSmsByConfirmingResFromManagementPanel\' | translate}}</md-checkbox></div><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendEmailBySupplierReserve\">{{\'tikonApp.servant.checkbox.sendEmailByConfirmingResFromManagementPanel\' | translate}}</md-checkbox></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.servant.description\" for=\"description\">description</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"description\" ng-model=\"vm.servant.description\"></div></div></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"1b\"><!--<ul class=\"nav nav-pills\">--><!--<li class=\"nav-item\">--><!--<a class=\"nav-link active\" ng-click=\"vm.setTabActive(\'servantSchedule\')\">--><!--<md-icon> person</md-icon>--><!--ساعت کاری--><!--</a>--><!--</li>--><!--<li class=\"nav-item\">--><!--<a class=\"nav-link\" ng-click=\"vm.setTabActive(\'servantCloseTimes\')\">--><!--<md-icon> schedule</md-icon>--><!--زمان های تعطیل--><!--</a>--><!--</li>--><!--</ul>--><div class=\"my-nav\"><div class=\"my-nav-button\" ng-class=\"vm.getNavItemClass(\'servantSchedule\')\" ng-click=\"vm.setTabActive(\'servantSchedule\')\"><md-icon>schedule</md-icon>ساعت کاری</div><div class=\"my-nav-button\" ng-class=\"vm.getNavItemClass(\'servantCloseTimes\')\" ng-click=\"vm.setTabActive(\'servantCloseTimes\')\"><md-icon>alarm_off</md-icon>زمان های تعطیل</div><div class=\"my-nav-button\" ng-class=\"vm.getNavItemClass(\'servantOpenTimes\')\" ng-click=\"vm.setTabActive(\'servantOpenTimes\')\"><md-icon>alarm_on</md-icon>زمان های استثنا (باز)</div></div><div id=\"servantSchedule\" ng-if=\"vm.servant.scheduleInfo && vm.showServantSchedule\" class=\"nav-link active\" aria-current=\"page\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری</legend><div><md-radio-group ng-model=\"vm.servant.scheduleInfo.baseScheduleMode\"><md-radio-button class=\"md-p\" value=\"BASED_ON_COMPANY\">بر اساس زمانبندی کسب و کار است</md-radio-button><md-radio-button value=\"BASED_ON_RESOURCE\">زمانبندی مخصوص به خود را دارد</md-radio-button><!--<md-radio-button class=\"md-accent\"  value=\"FIXED_DURATIONS\" >--><!--زمانبندی منظمی ندارد--><!--</md-radio-button>--></md-radio-group></div><div ng-if=\"vm.servant.scheduleInfo.baseScheduleMode==\'BASED_ON_RESOURCE\'\"><md-tabs md-border-bottom md-dynamic-height=\"true\" md-swipe-content=\"false\" md-stretch-tabs=\"auto\" md-selected=\"1\"><md-tab ng-click=\"vm.tabSelector()\"><md-tab-label><md-icon>event</md-icon><span>ساعت کاری <b>نامنظم</b></span></md-tab-label><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"alert alert-danger\" style=\"background-color: #ffd2d2;color: red\">این بخش به زودی غیرفعال میشود. جهت ثبت روزهای تعطیل و استثنا به بخش های بالای همین قسمت مراجعه فرمایید.</div><pf-exception-duration exdurations=\"vm.servant.scheduleInfo.scheduleExceptionDurations\"></pf-exception-duration></div></div></md-content></md-tab-body></md-tab><md-tab ng-click=\"vm.tabSelector()\"><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><div class=\"row\"><div class=\"col-md-6\"><eo-time-range start-time=\"vm.servant.scheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"vm.servant.scheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range></div></div><div class=\"row\"><div class=\"col-md-4\"><md-switch ng-model=\"vm.showLimitDates\" ng-change=\"vm.showLimitDateChange(vm.showLimitDates,vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod)\" style=\"padding-right: 23px;white-space: pre-wrap\">محدود سازی تاریخ شروع و پایان زمانبندی</md-switch></div><div class=\"col-md-4\" ng-if=\"vm.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.fromDate\">fromDate</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div><div class=\"col-md-4\" ng-if=\"vm.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.toDate\">toDate</label><eo-date-picker id=\"field_endDateFilter\" date-value=\"vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker></div></div></div></fieldset></div><div class=\"row\"><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"vm.servant.scheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></div></div></md-content></md-tab-body><md-tab-label><md-icon>history</md-icon><span>ساعت کاری <b>منظم</b></span></md-tab-label></md-tab></md-tabs></div></fieldset></div></div><div id=\"servantCloseTimes\" ng-if=\"vm.servant.scheduleInfo && vm.showServantCloseTimes\" class=\"nav-link\"><div><fieldset class=\"standard-fieldset\"><legend>زمان های تعطیل</legend><div><div><md-button class=\"md-raised md-primary\" ng-click=\"vm.addClosedTimes()\"><span><md-icon>add</md-icon></span>زمان تعطیل جدید</md-button></div><pf-servant-exception-duration-list servant-id=\"vm.servant.id\" availability-mode=\"\'CLOSE\'\"></pf-servant-exception-duration-list></div></fieldset></div></div><div id=\"servantOpenTimes\" ng-if=\"vm.servant.scheduleInfo && vm.showServantOpenTimes\" class=\"nav-link\"><div><fieldset class=\"standard-fieldset\"><legend>زمان های استثنا (باز)</legend><div><div><md-button class=\"md-raised md-primary\" ng-click=\"vm.addOpenTimes()\"><span><md-icon>add</md-icon></span>زمان استثنا جدید</md-button></div><pf-servant-exception-duration-list servant-id=\"vm.servant.id\" availability-mode=\"\'OPEN\'\"></pf-servant-exception-duration-list></div></fieldset></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"3b\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"vm.isWorkSpace\"><div class=\"form-group\"><label class=\"control-label\" for=\"basePrice\"><span translate=\"tikonApp.servant.customSetting.basePrice\"></span> <span translate=\"global.currencyBracket\"></span></label><input type=\"text\" style=\"width: 120px;direction: ltr\" class=\"form-control\" name=\"basePrice\" id=\"basePrice\" ng-model=\"vm.servant.customSetting.basePrice\"></div></div><div ng-if=\"vm.serviceList.length==0\"><eo-no-data message=\"vm.serviceListEmptyMessage\"></eo-no-data><!--<span--><!--translate=\"tikonApp.servant.customSetting.noAvailableService\">--><!--</span>--></div><div ng-if=\"vm.serviceList.length>0\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.servant.customSetting.hasAdvancedPricing\" aria-label=\"Switch 1\" eo-feature-checker=\"customPricingForServant\"><span translate=\"tikonApp.servant.customSetting.hasAdvancedPricing\"></span></md-switch></div></div></div><div class=\"row\" ng-if=\"vm.servant.customSetting.hasAdvancedPricing\"><fieldset ng-repeat=\"ssi in vm.serviceList | filter: ActiveServiceFilter \" ng-init=\"sectionIndex = $index\" class=\"standard-fieldset\"><legend>قیمت برای سرویس : <b>{{ssi.serviceItem.itemTitle}}</b></legend><div ng-repeat=\"pi in ssi.serviceItem.servicePriceInfo | filter: ValidPriceInfoFilter\" class=\"row\"><div class=\"col-sm-8\"><div class=\"row\"><div ng-repeat=\"pid in pi.priceInfoDtails\" class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"price\" ng-if=\"!(pid.title==ssi.serviceItem.itemTitle)\">{{pid.title}} (تومان)</label><label class=\"control-label\" ng-if=\"pid.title==ssi.serviceItem.itemTitle\" for=\"price\">قیمت (تومان)</label><input type=\"text\" style=\"width: 120px;direction: ltr\" class=\"form-control\" name=\"price\" id=\"price\" ng-model=\"pid.price\" ng-disabled=\"!vm.editBtnPressed[sectionIndex]\"></div></div></div></div><div class=\"col-sm-4\" style=\"text-align: left\"><button ng-if=\"!vm.editBtnPressed[sectionIndex]\" type=\"button\" ng-click=\"vm.editBtnPressed[sectionIndex] = true\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"tikonApp.servant.edit\"></span></button> <button ng-if=\"vm.editBtnPressed[sectionIndex]\" type=\"button\" ng-click=\"vm.updatePrice(ssi.serviceItem.id,pi,sectionIndex)\" class=\"btn btn-success btn-sm\"><i class=\"fa fa-check text-success\" aria-hidden=\"true\"></i> <span class=\"hidden-xs hidden-sm\">تایید</span></button> <button ng-if=\"vm.editBtnPressed[sectionIndex]\" type=\"button\" ng-click=\"vm.editBtnPressed[sectionIndex] = false\" class=\"btn btn-sm\"><i class=\"fa fa-times text-danger\" aria-hidden=\"true\"></i> <span class=\"hidden-xs hidden-sm\">لغو</span></button><!--<i class=\"fa fa-check text-success\" ng-if=\"vm.editBtnPressed[sectionIndex]\"--><!--ng-click=\"vm.updatePrice(ssi.serviceItem.id,pi,sectionIndex)\"--><!--aria-hidden=\"true\"></i>--></div></div></fieldset></div></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"8b\"><pf-video-call-setting video-call-setting-info=\"vm.servant.videoCallSettingInfo\" mode=\"SERVANT_SETTING\"></pf-video-call-setting></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"servantServices\"><div ng-if=\"vm.serviceList.length==0\"><eo-no-data message=\"vm.serviceListEmptyMessage\"></eo-no-data><!--<span--><!--translate=\"tikonApp.servant.customSetting.noAvailableService\">--><!--</span>--></div><div id=\"servantServiceSchedule\" class=\"row\"><fieldset data-ng-repeat=\"ssi in vm.serviceList | filter: ActiveServiceFilter \" class=\"standard-fieldset\"><legend>ساعت کاری برای سرویس : <b>{{ssi.serviceItem.itemTitle}}</b></legend><md-switch ng-model=\"ssi.edited\" ng-disabled=\"ssi.serviceItem.serviceMode && ssi.serviceItem.serviceMode==\'EVENT\'\"><span style=\"white-space: pre-wrap\" translate=\"tikonApp.servant.schedule.customServiceSchedule\" translate-values=\"{ itemTitle : ssi.serviceItem.itemTitle , servantLabel : vm.servantTranslate}\"></span><!--ساعت کاری این پرسنل برای سرویس--><!--<b>--><!--{{ssi.serviceItem.itemTitle}}--><!--</b>--><!--متفاوت است.--></md-switch><div data-ng-if=\"ssi.edited\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.duration\" required for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" eo-required=\"\" ng-model=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.duration\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Duration</label><input type=\"number\" id=\"field_gapTime\" class=\"form-control shortInput\" ng-model=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"></div></div></div><md-tabs md-border-bottom md-dynamic-height=\"true\" md-swipe-content=\"false\" md-stretch-tabs=\"auto\" md-selected=\"1\"><md-tab><md-tab-label><md-icon>event</md-icon><span>ساعت کاری <b>نامنظم</b></span></md-tab-label><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><!--<div class=\"hint-point\">--><!--بازه های زمانی استثناُ زمان هایی هستند که بدون در نظر گرفتن دیگر تنظیمات زمانی در نظر گرفته می شوند.--><!--</div>--><pf-exception-duration exdurations=\"ssi.scheduleInfo.scheduleExceptionDurations\"></pf-exception-duration></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><eo-time-range start-time=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range><div class=\"row\"><div class=\"col-md-4\"><md-switch style=\"white-space: pre-wrap\" ng-model=\"ssi.showLimitDates\" ng-change=\"vm.showLimitDateChange(ssi.showLimitDates,ssi.scheduleInfo.weeklyScheduleInfo.datePeriod)\">محدود سازی تاریخ شروع و پایان زمانبندی</md-switch></div><div class=\"col-md-4\" ng-if=\"ssi.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.fromDate\">fromDate</label><eo-date-picker id=\"field_SSI_fromDateFilter\" date-value=\"ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div><div class=\"col-md-4\" ng-if=\"ssi.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.toDate\">toDate</label><eo-date-picker id=\"field_SSI_endDateFilter\" date-value=\"ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker></div></div></div></fieldset></div><div class=\"row\"><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"ssi.scheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></div></div></md-content></md-tab-body><md-tab-label><md-icon>history</md-icon><span>ساعت کاری <b>منظم</b></span></md-tab-label></md-tab></md-tabs></div><!--  <div data-ng-if=\"!ssi.edited\">\n                                                          <span class=\"hint-point\" style=\"text-align: center\">\n                                                              بر اساس ساعت کاری کلی پرسنل است.\n                                                          </span>\n                                              <md-button  class=\"md-accent\" ng-click=\"vm.setEdited(ssi)\">\n                                                  ویرایش\n                                              </md-button>\n                                          </div>--></fieldset></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"4b\"><div ng-if=\"vm.showAmenities\" class=\"container-fluid\"><div><div id=\"amenitiesSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.amenitiesTab\">amenitiesTab</span></div><div class=\"panel-body\"><pf-service-item-amenities amenities=\"vm.servant.amenities.amenitiesList\"></pf-service-item-amenities></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"5b\"><div ng-if=\"vm.showImageGallery\" class=\"container-fluid\"><div><div id=\"imageGallerySection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.imageGalleryTab\">imageGalleryTab</span></div><div class=\"panel-body\"><eo-image-gallery-manager-v2 album-id=\"vm.servant.personInfo.image\" max-image-count=\"5\" crop-width=\"1920\" crop-height=\"1080\" album-caption=\"\'عنوان\'\" size-type=\"\'MARKETPLACE_SIZE\'\"></eo-image-gallery-manager-v2></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"6b\"><div ng-if=\"vm.showTags\" class=\"container-fluid\"><div><div id=\"tagsSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.tagsTab\">tagsTab</span></div><div class=\"panel-body\"><eo-tags selected-tags=\"vm.servant.tags\" tag-type=\"\'SERVANT\'\"></eo-tags></div></div></div></div></div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/entities/company-servants/company-servants-v2-dialog.html","<eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><jhi-alert-error></jhi-alert-error><div class=\"servant-header-container\" ng-if=\"vm.servant && vm.servant.id \"><div class=\"customer-header-info\"><div><eo-avatar-name name=\"vm.servant.personInfo.fisrtName\"></eo-avatar-name></div><div><div class=\"customer-list-customer-name\">{{vm.servant.personInfo.fisrtName}} {{vm.servant.personInfo.lastName}}</div><div class=\"customer-list-customer-phone\">{{vm.servant.personInfo.phoneNumber}}</div><div class=\"servant-list-access\" ng-if=\"vm.servant.hasAccessToPanel\"><md-icon class=\"access-icon\">verified_user</md-icon><span>دسترسی ورود به پنل</span></div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.companyServants.edit.delete({id:vm.servant.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"customer-component-container\"><div><ul class=\"pl-nav-tabs\" ng-if=\"vm.servant && vm.servant.id \"><li class=\"active\"><a data-target=\"#2b\" data-toggle=\"tab\"><md-icon>person</md-icon>اطلاعات عمومی </a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.scheduleInfo\" data-target=\"#1b\" data-toggle=\"tab\"><md-icon>schedule</md-icon><span>ساعت کاری</span></a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.id\" style=\"width: 102%\" data-target=\"#servantServices\" data-toggle=\"tab\"><i class=\"material-icons\">list </i><span>لیست خدمات</span></a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\" ng-click=\"vm.onServiceServantScheduleTabClick()\"><a ng-if=\"vm.servant.id\" data-target=\"#3b\" data-toggle=\"tab\"><i class=\"material-icons\">attach_money </i><span>قیمت گذاری </span></a></li><li ng-if=\"vm.__config.appMode==\'reserve\'\"><a ng-if=\"vm.servant.id\" style=\"width: 102%\" data-target=\"#8b\" data-toggle=\"tab\"><md-icon>settings</md-icon><span>تنظیمات</span></a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"2b\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.servant.tabs.profileInfo\"></span></div><div class=\"panel-body\"><div ng-if=\"!vm.isWorkSpace\"><pf-person-info person-info=\"vm.servant.personInfo\" is-servant=\"true\" servant-code=\"vm.servant.code\" block-edit-phone-number=\"vm.servant.hasAccessToPanel\"></pf-person-info></div><div ng-if=\"vm.isWorkSpace\"><pf-person-info-space person-info=\"vm.servant.personInfo\" is-servant=\"true\" servant-code=\"vm.servant.code\" block-edit-phone-number=\"vm.servant.hasAccessToPanel\"></pf-person-info-space></div><div class=\"\"><div class=\"col-md-2\"></div><div class=\"col-md-10\" style=\"padding-right: 5px\"><div class=\"form-group\" style=\"max-width: 200px\"><label class=\"control-label\" translate=\"tikonApp.personInfo.status.title\" for=\"status\">titleOfSelect</label><md-select class=\"rwMdSelect\" ng-model=\"vm.servant.status\" id=\"status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.personInfo.status.active\">ACTIVE</md-option><md-option value=\"NOT_ACTIVE\" translate=\"tikonApp.personInfo.status.notActive\">NOT_ACTIVE</md-option><!--<md-option value=\"NOT_SHOW_IN_LIST\" translate=\"tikonApp.personInfo.status.notShowInList\">--><!--NOT_SHOW_IN_LIST--><!--</md-option>--></md-select></div><div class=\"row\"><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendNotificationByCustomerReserve\">{{\'tikonApp.servant.checkbox.sendSmsByConfirmingResFromCustomer\' | translate}}</md-checkbox></div><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendEmailByCustomerReserve\">{{\'tikonApp.servant.checkbox.sendEmailByConfirmingResFromCustomer\' | translate}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendNotificationBySupplierReserve\">{{\'tikonApp.servant.checkbox.sendSmsByConfirmingResFromManagementPanel\' | translate}}</md-checkbox></div><div class=\"col-md-6\"><md-checkbox ng-model=\"vm.servant.customSetting.sendEmailBySupplierReserve\">{{\'tikonApp.servant.checkbox.sendEmailByConfirmingResFromManagementPanel\' | translate}}</md-checkbox></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.servant.description\" for=\"description\">description</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"description\" ng-model=\"vm.servant.description\"></div></div></div></div></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"1b\"><ul class=\"pl-nav-tabs\"><li class=\"active\"><a data-target=\"#servantSchedule\" data-toggle=\"tab\"><md-icon>schedule</md-icon>ساعت کاری</a></li><li><a data-target=\"#servantCloseTimes\" data-toggle=\"tab\"><md-icon>alarm_off</md-icon>زمان های تعطیل</a></li><li><a data-target=\"#servantOpenTimes\" data-toggle=\"tab\"><md-icon>alarm_on</md-icon>زمان های استثنا (باز)</a></li></ul><div class=\"tab-content clearfix\"><div id=\"servantSchedule\" class=\"tab-pane pl-tab-pane active\" ng-if=\"vm.servant.scheduleInfo && vm.showServantSchedule\" aria-current=\"page\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> ساعت کاری</div><div class=\"panel-body\"><div><md-radio-group ng-model=\"vm.servant.scheduleInfo.baseScheduleMode\"><md-radio-button class=\"md-p\" value=\"BASED_ON_COMPANY\">بر اساس زمانبندی کسب و کار است</md-radio-button><md-radio-button value=\"BASED_ON_RESOURCE\">زمانبندی مخصوص به خود را دارد</md-radio-button><!--<md-radio-button class=\"md-accent\"  value=\"FIXED_DURATIONS\" >--><!--زمانبندی منظمی ندارد--><!--</md-radio-button>--></md-radio-group></div><div ng-if=\"vm.servant.scheduleInfo.baseScheduleMode==\'BASED_ON_RESOURCE\'\"><div ng-click=\"vm.tabSelector()\"><div class=\"container-fluid\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><div class=\"row\"><div class=\"col-md-6\"><eo-time-range start-time=\"vm.servant.scheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"vm.servant.scheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range></div></div><div class=\"row\"><div class=\"col-md-4\"><md-switch ng-model=\"vm.showLimitDates\" ng-change=\"vm.showLimitDateChange(vm.showLimitDates,vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod)\" class=\"time-limit-switch\" style=\"\">محدود سازی تاریخ شروع و پایان زمانبندی</md-switch></div><div class=\"col-md-4 col-sm-6\" ng-if=\"vm.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.fromDate\">fromDate</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div><div class=\"col-md-4 col-sm-6\" ng-if=\"vm.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.toDate\">toDate</label><eo-date-picker id=\"field_endDateFilter\" date-value=\"vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker></div></div></div></fieldset></div><div class=\"row\"><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"vm.servant.scheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></div></div></div></div></div></div></div></div><div id=\"servantCloseTimes\" class=\"tab-pane fade\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> زمان های تعطیل</div><div class=\"panel-body\"><div><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" ng-click=\"vm.addClosedTimes()\"><span><md-icon>add</md-icon></span>زمان تعطیل جدید</md-button></div><pf-servant-exception-duration-list servant-id=\"vm.servant.id\" availability-mode=\"\'CLOSE\'\"></pf-servant-exception-duration-list></div></div></div></div><div id=\"servantOpenTimes\" class=\"tab-pane fade\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> زمان های استثنا (باز)</div><div class=\"panel-body\"><div><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" ng-click=\"vm.addOpenTimes()\"><span><md-icon>add</md-icon></span>زمان استثنا جدید</md-button></div><pf-servant-exception-duration-list servant-id=\"vm.servant.id\" availability-mode=\"\'OPEN\'\"></pf-servant-exception-duration-list></div></div></div></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"3b\"><div class=\"container-fluid\"><div ng-if=\"!vm.customPricingForServant\" style=\"text-align: center\"><md-icon class=\"pl-icon\">lock</md-icon><span>این امکان ویژه برای شما غیر فعال است</span></div><div ng-if=\"vm.isServiceScheduleLoading\">در حال دریافت اطلاعات ...</div><div ng-if=\"vm.serviceList.length==0 && !vm.isServiceScheduleLoading && vm.customPricingForServant\"><eo-no-data message=\"vm.serviceListEmptyMessage\"></eo-no-data><!--<span--><!--translate=\"tikonApp.servant.customSetting.noAvailableService\">--><!--</span>--></div><div ng-if=\"vm.serviceList.length>0\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.servant.customSetting.hasAdvancedPricing\" aria-label=\"Switch 1\" eo-feature-checker=\"customPricingForServant\"><span translate=\"tikonApp.servant.customSetting.hasAdvancedPricing\"></span></md-switch></div></div></div><div class=\"row\" ng-if=\"vm.servant.customSetting.hasAdvancedPricing\"><fieldset ng-repeat=\"ssi in vm.serviceList | filter: ActiveServiceFilter \" ng-init=\"sectionIndex = $index\" class=\"standard-fieldset\"><legend>قیمت برای : <b>{{ssi.serviceItem.itemTitle}}</b></legend><div ng-repeat=\"pi in ssi.serviceItem.servicePriceInfo | filter: ValidPriceInfoFilter\" class=\"row\"><div class=\"col-sm-8\"><div class=\"row\"><div ng-repeat=\"pid in pi.priceInfoDtails\" class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"price\" ng-if=\"!(pid.title==ssi.serviceItem.itemTitle)\">{{pid.title}} (تومان)</label><label class=\"control-label\" ng-if=\"pid.title==ssi.serviceItem.itemTitle\" for=\"price\">قیمت (تومان)</label><input type=\"text\" style=\"width: 120px;direction: ltr\" class=\"form-control\" name=\"price\" id=\"price\" ng-model=\"pid.price\" ng-disabled=\"!vm.editBtnPressed[sectionIndex]\"></div></div></div></div><div class=\"col-sm-4\" style=\"text-align: left\"><button ng-if=\"!vm.editBtnPressed[sectionIndex]\" type=\"button\" ng-click=\"vm.editBtnPressed[sectionIndex] = true\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"tikonApp.servant.edit\"></span></button> <button ng-if=\"vm.editBtnPressed[sectionIndex]\" type=\"button\" ng-click=\"vm.updatePrice(ssi.serviceItem.id,pi,sectionIndex)\" class=\"btn btn-success btn-sm\"><i class=\"fa fa-check text-success\" aria-hidden=\"true\"></i> <span class=\"hidden-xs hidden-sm\">تایید</span></button> <button ng-if=\"vm.editBtnPressed[sectionIndex]\" type=\"button\" ng-click=\"vm.editBtnPressed[sectionIndex] = false\" class=\"btn btn-sm\"><i class=\"fa fa-times text-danger\" aria-hidden=\"true\"></i> <span class=\"hidden-xs hidden-sm\">لغو</span></button><!--<i class=\"fa fa-check text-success\" ng-if=\"vm.editBtnPressed[sectionIndex]\"--><!--ng-click=\"vm.updatePrice(ssi.serviceItem.id,pi,sectionIndex)\"--><!--aria-hidden=\"true\"></i>--></div></div></fieldset></div></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"8b\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> تنظیمات ارتباط تصویری</div><div class=\"panel-body\"><pf-video-call-setting video-call-setting-info=\"vm.servant.videoCallSettingInfo\" mode=\"SERVANT_SETTING\"></pf-video-call-setting></div></div></div></div><div ng-if=\"vm.__config.appMode==\'reserve\'\" style=\"background: none\" class=\"tab-pane fade\" id=\"servantServices\"><ul class=\"pl-nav-tabs\"><li class=\"active\"><a data-target=\"#servantSelectServices\" data-toggle=\"tab\"><i class=\"material-icons\">list </i>انتخاب خدمات</a></li><li ng-click=\"vm.onServiceServantScheduleTabClick()\"><a data-target=\"#servantServiceSchedule\" data-toggle=\"tab\"><md-icon>schedule</md-icon>زمانبندی جداگانه برای خدمات</a></li></ul><div class=\"tab-content clearfix\"><div id=\"servantSelectServices\" class=\"tab-pane pl-tab-pane active\" aria-current=\"page\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> انتخاب خدمات</div><div class=\"panel-body\"><div><!--<md-checkbox ng-model=\"vm.selectAllServices\"--><!--ng-change=\"vm.onSelectAllServicesChanged()\">--><!--انتخاب همه--><!--</md-checkbox>--><div ng-repeat=\"si in vm.allCompanyServiceList\"><md-checkbox ng-model=\"si.checked\" ng-disabled=\"(!si.canRemoveCheck && si.checked) || si.serviceStatus ==\'DISABLE\' || si.serviceMode ==\'EVENT\' || vm.isServantLogin\" ng-change=\"vm.onServantServiceCheckChange(si)\">{{si.itemTitle}} <span ng-if=\"!si.canRemoveCheck && si.checked && si.serviceStatus !=\'DISABLE\' && si.serviceMode!=\'EVENT\' \">(برای حذف این گزینه باید {{vm.activityTypeInfo.servantTitle}} دیگری را در خدمت مورد نظر جایگزین کنید) </span><span ng-if=\"si.serviceStatus ==\'DISABLE\'\">(این آیتم غیر فعال است) </span><span ng-if=\"si.serviceStatus !=\'DISABLE\' && si.serviceMode ==\'EVENT\'\">(در بخش رویدادها قابل ویرایش است)</span></md-checkbox></div></div></div></div></div></div><div id=\"servantServiceSchedule\" class=\"tab-pane pl-tab-pane fade\" aria-current=\"page\"><div class=\"container-fluid pl-container-fluid\"><div ng-if=\"!vm.hasServantServiceSchedulingFeature\" style=\"text-align: center\"><md-icon class=\"pl-icon\">lock</md-icon><span>این امکان ویژه برای شما غیر فعال است</span></div><div ng-if=\"vm.isServiceScheduleLoading\">در حال دریافت اطلاعات ...</div><div class=\"pl-panel\" ng-if=\"!vm.isServiceScheduleLoading && vm.isServiceScheduleLoaded && vm.hasServantServiceSchedulingFeature\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> زمانبندی جداگانه برای خدمات</div><div class=\"panel-body\"><div ng-if=\"vm.serviceList.length==0\"><eo-no-data message=\"vm.serviceListEmptyMessage\"></eo-no-data><!--<span--><!--translate=\"tikonApp.servant.customSetting.noAvailableService\">--><!--</span>--></div><div class=\"row\"><fieldset data-ng-repeat=\"ssi in vm.serviceList | filter: ActiveServiceFilter \" class=\"standard-fieldset\" style=\"border-color: #000\"><legend>ساعت کاری برای : <b>{{ssi.serviceItem.itemTitle}}</b></legend><div style=\"position: relative\"><md-switch ng-model=\"ssi.edited\" ng-disabled=\"ssi.serviceItem.serviceMode && ssi.serviceItem.serviceMode==\'EVENT\' \"><span style=\"white-space: pre-wrap\" translate=\"tikonApp.servant.schedule.customServiceSchedule\" translate-values=\"{ itemTitle : ssi.serviceItem.itemTitle , servantLabel : vm.servantTranslate}\"></span></md-switch></div><div data-ng-if=\"ssi.edited\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.duration\" required for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" eo-required=\"\" ng-model=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.duration\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Duration</label><input type=\"number\" id=\"field_gapTime\" class=\"form-control shortInput\" ng-model=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"></div></div></div><ul class=\"pl-nav-tabs\"><li class=\"active\"><a data-target=\"#serviceWorkingTime{{ssi.serviceItem.id}}\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">history</md-icon><span>ساعت کاری <b>منظم </b></span></a></li><li><a data-target=\"#serviceExceptions{{ssi.serviceItem.id}}\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">event</md-icon><span>ساعت کاری <b>نامنظم</b></span></a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"serviceWorkingTime{{ssi.serviceItem.id}}\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companyWorkingTimes\">supplierPanel.sideMenu.companyInfo.companyWorkingTimes<!--{{vm.serviceItem.itemTitle}}--></div><div class=\"panel-body\"><div class=\"\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><eo-time-range start-time=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"ssi.scheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range><div class=\"row\"><div class=\"col-md-4\"><md-switch ng-model=\"ssi.showLimitDates\" ng-change=\"vm.showLimitDateChange(ssi.showLimitDates,ssi.scheduleInfo.weeklyScheduleInfo.datePeriod)\" style=\"padding-right: 23px;white-space: normal\">محدود سازی تاریخ شروع و پایان زمانبندی</md-switch></div><div class=\"col-md-4\" ng-if=\"ssi.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.fromDate\">fromDate</label><eo-date-picker id=\"field_fromDateFilter1\" date-value=\"ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div><div class=\"col-md-4\" ng-if=\"ssi.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.toDate\">toDate</label><eo-date-picker id=\"field_endDateFilter1\" date-value=\"ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker></div></div></div><div class=\"\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری هفتگی</legend><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"ssi.scheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></fieldset></div></fieldset></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"serviceExceptions{{ssi.serviceItem.id}}\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\">ساعت کاری نامنظم</div><div class=\"panel-body\"><pf-exception-duration-v2 exdurations=\"ssi.scheduleInfo.scheduleExceptionDurations\"></pf-exception-duration-v2></div></div></div></div></div></fieldset></div></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"4b\"><div ng-if=\"vm.showAmenities\" class=\"container-fluid\"><div><div id=\"amenitiesSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.amenitiesTab\">amenitiesTab</span></div><div class=\"panel-body\"><pf-service-item-amenities amenities=\"vm.servant.amenities.amenitiesList\"></pf-service-item-amenities></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"5b\"><div ng-if=\"vm.showImageGallery\" class=\"container-fluid\"><div><div id=\"imageGallerySection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.imageGalleryTab\">imageGalleryTab</span></div><div class=\"panel-body\"><eo-image-gallery-manager-v2 album-id=\"vm.servant.personInfo.image\" max-image-count=\"5\" crop-width=\"1920\" crop-height=\"1080\" album-caption=\"\'عنوان\'\" size-type=\"\'MARKETPLACE_SIZE\'\"></eo-image-gallery-manager-v2></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"6b\"><div ng-if=\"vm.showTags\" class=\"container-fluid\"><div><div id=\"tagsSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.tagsTab\">tagsTab</span></div><div class=\"panel-body\"><eo-tags selected-tags=\"vm.servant.tags\" tag-type=\"\'SERVANT\'\"></eo-tags></div></div></div></div></div></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer><style>md-icon {\n        color: unset;\n    }\n\n    i.text-success, i.text-danger {\n        margin: auto 10px;\n    }\n\n    md-pagination-wrapper {\n        width: auto !important;\n    }\n\n    .rwMdContent {\n        overflow-x: hidden;\n    }\n\n    .service-schedule-block {\n        border-bottom: solid 1px #ff9d1a;\n    }\n\n    .nav-tabs > li > a {\n        margin-right: 0px !important;\n    }\n\n    .my-nav-button {\n        padding: 10px;\n        /*background-color: #ededed;*/\n        background-color: #f4f4f7;\n        color: #fff;\n        border-radius: 5px;\n        color: #585858;\n        border: 1px solid #c1c1c1;\n        box-shadow: 0 0px 4px -2px grey;\n    }\n\n    .my-nav {\n        display: flex;\n        gap: 10px;\n    }\n\n    .my-nav-button-active {\n        background-color: #ffffff;\n        color: #2b6b7f;\n        border-color: #2b6b7f;\n    }</style>");
$templateCache.put("app/entities/company-servants/company-servants-v2.html","<style>@media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span ng-if=\"!vm.isWorkSpace\" translate=\"supplierPanel.sideMenu.servantInfo\">supplierPanel.sideMenu.servantInfo</span> <span ng-if=\"vm.isWorkSpace\" translate=\"tikonApp.servant.home.title-list-space-v2\">title-list-space</span><div class=\"education-link\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body pl-panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newServant()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.servant.home.createLabel\" translate-values=\"{servantLabel : vm.servantTranslate}\">Create new Servant</span></md-button><div class=\"table-responsive\"><table st-safe-src=\"vm.servants\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.servant.home.search\'\" on-search=\"vm.searchServants()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"title\"><span translate=\"tikonApp.servant.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"personInfoId\"><span translate=\"tikonApp.servant.personInfo\">Person Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"fisrtName\"><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-if=\"!vm.isWorkSpace\" st-sort=\"lastName\"><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-if=\"!vm.isWorkSpace\" st-sort=\"code\"><span translate=\"tikonApp.servant.personnelCode\">personnelCode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.personInfo.status.title\">tikonApp.personInfo.status.title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.servant.accessToPanelStatus\">tikonApp.servant.accessToPanelStatus</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"servant in collection track by servant.id\"><td><a ui-sref=\"supplierPanel-v2.companyServants.edit({id:servant.id})\">{{servant.id}}</a></td><td>{{servant.personInfo.fisrtName}}</td><td ng-if=\"!vm.isWorkSpace\">{{servant.personInfo.lastName}}</td><td>{{servant.personInfo.phoneNumber}}</td><td ng-if=\"!vm.isWorkSpace\">{{servant.code}}</td><td ng-if=\"servant.status === \'ACTIVE\'\">{{\'tikonApp.personInfo.status.active\' | translate}}</td><td ng-if=\"servant.status === \'NOT_ACTIVE\'\">{{\'tikonApp.personInfo.status.notActive\' | translate}}</td><td><span ng-if=\"servant.hasAccessToPanel\"><md-tooltip md-direction=\"top\">{{\'tikonApp.servant.hasAccessToPanel\' | translate}}</md-tooltip><md-icon style=\"color: forestgreen\">verified_user</md-icon></span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ng-click=\"vm.editServant(servant)\" class=\"btn btn-primary pl-btn pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.companyServants.delete({id:servant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newServant()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div style=\"display: flex; justify-content: space-between; align-items: center; margin: 15px 0\"><h3 ng-if=\"!vm.isWorkSpace\" class=\"\" style=\"padding-right: 7px; margin: 0\" translate=\"tikonApp.servant.home.title-list\">title-list</h3><h3 ng-if=\"vm.isWorkSpace\" class=\"\" style=\"padding-right: 7px; margin: 0\" translate=\"tikonApp.servant.home.title-list-space-v2\">title-list</h3></div></div></div><!--<div class=\"col-xs-3\" style=\"margin-right: -7px\">--><!--<md-button class=\"md-raised md-primary\" ui-sref=\"company-customer.new\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!--</md-button>--><!--</div>--></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.servant.home.search\'\" on-search=\"vm.searchServants()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"servant in vm.servants track by servant.id\" class=\"customer-list-item\" ng-click=\"vm.editServant(servant)\"><eo-avatar-name name=\"{{servant.personInfo.fisrtName}}\"></eo-avatar-name><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-name\">{{servant.personInfo.fisrtName}} {{servant.personInfo.lastName}}</div><div class=\"customer-list-customer-phone\" ng-if=\"servant.personInfo.phoneNumber\">{{servant.personInfo.phoneNumber}}</div><!--<div class=\"servant-list-access\" ng-if=\"servant.hasAccessToPanel\">--><!--<md-icon class=\"access-icon\">verified_user</md-icon>--><!--<span>دسترسی به پنل</span>--><!--</div>--></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div>");
$templateCache.put("app/entities/company-servants/company-servants.html","<div class=\"hidden-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span ng-if=\"!vm.isWorkSpace\" translate=\"supplierPanel.sideMenu.servantInfo\">supplierPanel.sideMenu.servantInfo</span> <span ng-if=\"vm.isWorkSpace\" translate=\"tikonApp.servant.home.title-list-space\">title-list-space</span></div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" ng-click=\"vm.newServantClick()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.servant.home.createLabel\" translate-values=\"{servantLabel : vm.servantTranslate}\">Create new Servant</span></md-button><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.servants\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control rwTableSearchBox\" placeholder=\"{{ \'tikonApp.servant.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"title\"><span translate=\"tikonApp.servant.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"personInfoId\"><span translate=\"tikonApp.servant.personInfo\">Person Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"fisrtName\"><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-if=\"!vm.isWorkSpace\" st-sort=\"lastName\"><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-if=\"!vm.isWorkSpace\" st-sort=\"code\"><span translate=\"tikonApp.servant.personnelCode\">personnelCode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.personInfo.status.title\">tikonApp.personInfo.status.title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.servant.accessToPanelStatus\">tikonApp.servant.accessToPanelStatus</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"servant in collection track by servant.id\"><td><a ui-sref=\"supplierPanel.companyServants.edit({id:servant.id})\">{{servant.id}}</a></td><td>{{servant.personInfo.fisrtName}}</td><td ng-if=\"!vm.isWorkSpace\">{{servant.personInfo.lastName}}</td><td>{{servant.personInfo.phoneNumber}}</td><td ng-if=\"!vm.isWorkSpace\">{{servant.code}}</td><td ng-if=\"servant.status === \'ACTIVE\'\">{{\'tikonApp.personInfo.status.active\' | translate}}</td><td ng-if=\"servant.status === \'NOT_ACTIVE\'\">{{\'tikonApp.personInfo.status.notActive\' | translate}}</td><td><span ng-if=\"servant.hasAccessToPanel\"><md-tooltip md-direction=\"top\">{{\'tikonApp.servant.hasAccessToPanel\' | translate}}</md-tooltip><md-icon style=\"color: forestgreen\">verified_user</md-icon></span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.companyServants.edit({id:servant.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel.companyServants.delete({id:servant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div></div></div><div class=\"visible-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.servantInfo\">supplierPanel.sideMenu.servantInfo</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.companyServants.new\"><i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i></md-button><md-content class=\"rwMdContent\"><div class=\"orderBag-mobile-block\" ng-repeat=\"servant in vm.servants track by servant.id\"><div class=\"row\"><div class=\"col-sm-6 text-right\" style=\"padding-right: 20px\" ui-sref=\"supplierPanel.companyServants.edit({id:servant.id})\"><a>{{servant.personInfo.fisrtName}} {{servant.personInfo.lastName}}</a><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"servant.personInfo.phoneNumber\">{{servant.personInfo.phoneNumber}}</div></div><div class=\"com-sm-3\" style=\"text-align: left;padding-left: 10px\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.companyServants.edit({id:servant.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.companyServants.delete({id:servant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></div></div></div></md-content></div></div></div></div></div>");
$templateCache.put("app/entities/company-social-network-info/company-social-network-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.companySocialNetworkInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.companySocialNetworkInfo.delete.question\" translate-values=\"{id: \'{{vm.companySocialNetworkInfo.id}}\'}\">Are you sure you want to delete this Company Social Network Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-social-network-info/company-social-network-info-detail.html","<div><h2><span translate=\"tikonApp.companySocialNetworkInfo.detail.title\">Company Social Network Info</span> {{vm.companySocialNetworkInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.companySocialNetworkInfo.orderNumber\">Order Number</span></dt><dd><span>{{vm.companySocialNetworkInfo.orderNumber}}</span></dd><dt><span translate=\"tikonApp.companySocialNetworkInfo.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.companySocialNetworkInfo.companyId})\">{{vm.companySocialNetworkInfo.companyId}}</a></dd><dt><span translate=\"tikonApp.companySocialNetworkInfo.socialNetworkInfo\">Social Network Info</span></dt><dd><a ui-sref=\"social-network-info-detail({id:vm.companySocialNetworkInfo.socialNetworkInfoId})\">{{vm.companySocialNetworkInfo.socialNetworkInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company-social-network-info/company-social-network-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanySocialNetworkInfoLabel\" translate=\"tikonApp.companySocialNetworkInfo.home.createOrEditLabel\">Create or edit a Company Social Network Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companySocialNetworkInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companySocialNetworkInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companySocialNetworkInfo.orderNumber\" for=\"field_orderNumber\">Order Number</label><input type=\"number\" class=\"form-control\" name=\"orderNumber\" id=\"field_orderNumber\" ng-model=\"vm.companySocialNetworkInfo.orderNumber\"></div><div class=\"form-group\"><label translate=\"tikonApp.companySocialNetworkInfo.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.companySocialNetworkInfo.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.companySocialNetworkInfo.socialNetworkInfo\" for=\"field_socialNetworkInfo\">Social Network Info</label><select class=\"form-control\" id=\"field_socialNetworkInfo\" name=\"socialNetworkInfo\" ng-model=\"vm.companySocialNetworkInfo.socialNetworkInfoId\" ng-options=\"socialNetworkInfo.id as socialNetworkInfo.id for socialNetworkInfo in vm.socialnetworkinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-social-network-info/company-social-network-infos.html","<div><h2 translate=\"tikonApp.companySocialNetworkInfo.home.title\">Company Social Network Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company-social-network-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.companySocialNetworkInfo.home.createLabel\">Create new Company Social Network Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.companySocialNetworkInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderNumber\"><span translate=\"tikonApp.companySocialNetworkInfo.orderNumber\">Order Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span translate=\"tikonApp.companySocialNetworkInfo.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"socialNetworkInfoId\"><span translate=\"tikonApp.companySocialNetworkInfo.socialNetworkInfo\">Social Network Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companySocialNetworkInfo in vm.companySocialNetworkInfos track by companySocialNetworkInfo.id\"><td><a ui-sref=\"company-social-network-info-detail({id:companySocialNetworkInfo.id})\">{{companySocialNetworkInfo.id}}</a></td><td>{{companySocialNetworkInfo.orderNumber}}</td><td><a ui-sref=\"company-detail({id:companySocialNetworkInfo.companyId})\">{{companySocialNetworkInfo.companyId}}</a></td><td><a ui-sref=\"social-network-info-detail({id:companySocialNetworkInfo.socialNetworkInfoId})\">{{companySocialNetworkInfo.socialNetworkInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-social-network-info-detail({id:companySocialNetworkInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company-social-network-info.edit({id:companySocialNetworkInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company-social-network-info.delete({id:companySocialNetworkInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-social-network-info/custom-company-social-network-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanySocialNetworkInfoLabel\" translate=\"tikonApp.companySocialNetworkInfo.home.createOrEditLabel\">Create or edit a Company Social Network Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companySocialNetworkInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.companySocialNetworkInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.socialNetworkInfo.socialNetworkType\" for=\"field_socialNetworkType\">Social Network Type</label><select class=\"form-control\" name=\"socialNetworkType\" ng-model=\"vm.companySocialNetworkInfo.socialNetworkInfo.socialNetworkType\" id=\"field_socialNetworkType\" required eo-required=\"\"><option value=\"\" translate=\"global.pleaseSelectItem\"></option><option value=\"FACEBOOK\" translate=\"tikonApp.SocialNetworkType.FACEBOOK\">FACEBOOK</option><!--<option value=\"TWITTER\" translate=\"tikonApp.SocialNetworkType.TWITTER\">TWITTER</option>--><option value=\"INSTAGRAM\" translate=\"tikonApp.SocialNetworkType.INSTAGRAM\">INSTAGRAM</option><option value=\"TELEGRAM\" translate=\"tikonApp.SocialNetworkType.TELEGRAM\">TELEGRAM</option><!--<option value=\"GOOGLE\" translate=\"tikonApp.SocialNetworkType.GOOGLE\">GOOGLE</option>--><!--<option value=\"YAHOO\" translate=\"tikonApp.SocialNetworkType.YAHOO\">YAHOO</option>--></select></div><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.socialNetworkInfo.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.companySocialNetworkInfo.socialNetworkInfo.title\" required eo-required=\"\"></div><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.socialNetworkInfo.url\" for=\"field_url\">Url</label><input type=\"text\" class=\"form-control\" name=\"url\" id=\"field_url\" ng-model=\"vm.companySocialNetworkInfo.socialNetworkInfo.url\" required eo-required=\"\"></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.companySocialNetworkInfo.orderNumber\" for=\"field_orderNumber\">Order Number</label>--><!--<input type=\"number\" class=\"form-control\" name=\"orderNumber\" id=\"field_orderNumber\"--><!--ng-model=\"vm.companySocialNetworkInfo.orderNumber\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.companySocialNetworkInfo.company\" for=\"field_company\">Company</label>--><!--<select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.companySocialNetworkInfo.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.companySocialNetworkInfo.socialNetworkInfo\" for=\"field_socialNetworkInfo\">Social Network Info</label>--><!--<select class=\"form-control\" id=\"field_socialNetworkInfo\" name=\"socialNetworkInfo\" ng-model=\"vm.companySocialNetworkInfo.socialNetworkInfoId\" ng-options=\"socialNetworkInfo.id as socialNetworkInfo.id for socialNetworkInfo in vm.companySocialNetworkInfo.socialNetworkInfos\"            >--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-social-network-info/custom-company-social-network-infos-v2.html","<style>.form-field-description {\n        font-size: 12px;\n        color: #607d8b;\n    }</style><eo-pl-modal-header title=\"\'supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo\">supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo</div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert></jhi-alert><div id=\"border\" class=\"socialNetwork-border\"><div class=\"form-group\" ng-repeat=\"companySocialNetworkInfo in vm.companySocialNetworkInfoList.companySocialNetworkInfos \"><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><!--<span--><!--translate=\"{{\'tikonApp.SocialNetworkType.\' + companySocialNetworkInfo.socialNetworkInfo.socialNetworkType}}\">{{companySocialNetworkInfo.socialNetworkInfo.socialNetworkType}}</span>--></div></div><div class=\"col-md-1\"><span ng-class=\"vm.findClass(companySocialNetworkInfo)\"><i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'TELEGRAM\'\" class=\"fa fa-telegram fa-3x\"></i> <i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'INSTAGRAM\'\" class=\"fa fa-instagram fa-3x\"></i> <i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'LINKEDIN\'\" class=\"fa fa-linkedin-square fa-3x\"></i> <i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'WHATSAPP\'\" class=\"fa fa-whatsapp fa-3x\"></i></span></div><div class=\"col-lg-5 col-md-7\"><div class=\"form-group\"><!--<label class=\"control-label\" translate=\"tikonApp.socialNetworkInfo.url\"--><!--for=\"field_url\">url</label>--> <input type=\"text\" class=\"form-control\" style=\"direction: ltr\" name=\"url\" id=\"field_url\" ng-disabled=\"vm.isDisabled(companySocialNetworkInfo)\" ng-model=\"companySocialNetworkInfo.socialNetworkInfo.url\" placeholder=\"{{vm.placeHolder(companySocialNetworkInfo)}}\" type=\"text\"><div ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'WHATSAPP\'\" class=\"form-field-description\">**پشتیبانی واتساپی سایت رزرو</div></div></div></div></div></div></form></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/company-social-network-info/custom-company-social-network-infos.html","<style>.form-field-description {\n        font-size: 12px;\n        color: #607d8b;\n    }</style><div class=\"container-fluid\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo\">supplierPanel.sideMenu.companyInfo.companySocialNetworkInfo</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<h2 translate=\"tikonApp.companySocialNetworkInfo.home.title\">Company Social Network Infos</h2>--><jhi-alert></jhi-alert><!--<div class=\"container-fluid\">--><!--<button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\"--><!--class=\"btn btn-primary\">--><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span--><!--translate=\"entity.action.save\">Save</span>--><!--</button>--><!--</div>--><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar>--><md-content class=\"rwMdContent\"><div id=\"border\" class=\"socialNetwork-border\"><div class=\"form-group\" ng-repeat=\"companySocialNetworkInfo in vm.companySocialNetworkInfoList.companySocialNetworkInfos \"><div class=\"row\"><div class=\"col-md-1\"><div class=\"form-group\"><!--<span--><!--translate=\"{{\'tikonApp.SocialNetworkType.\' + companySocialNetworkInfo.socialNetworkInfo.socialNetworkType}}\">{{companySocialNetworkInfo.socialNetworkInfo.socialNetworkType}}</span>--></div></div><div class=\"col-md-1\"><span ng-class=\"vm.findClass(companySocialNetworkInfo)\"><i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'TELEGRAM\'\" class=\"fa fa-telegram fa-3x\"></i> <i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'INSTAGRAM\'\" class=\"fa fa-instagram fa-3x\"></i> <i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'LINKEDIN\'\" class=\"fa fa-linkedin-square fa-3x\"></i> <i ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'WHATSAPP\'\" class=\"fa fa-whatsapp fa-3x\"></i></span></div><div class=\"col-lg-5 col-md-7\"><div class=\"form-group\"><!--<label class=\"control-label\" translate=\"tikonApp.socialNetworkInfo.url\"--><!--for=\"field_url\">url</label>--> <input type=\"text\" class=\"form-control\" style=\"direction: ltr\" name=\"url\" id=\"field_url\" ng-disabled=\"vm.isDisabled(companySocialNetworkInfo)\" ng-model=\"companySocialNetworkInfo.socialNetworkInfo.url\" placeholder=\"{{vm.placeHolder(companySocialNetworkInfo)}}\" type=\"text\"><div ng-if=\"companySocialNetworkInfo.socialNetworkInfo.socialNetworkType == \'WHATSAPP\'\" class=\"form-field-description\">**پشتیبانی واتساپی سایت رزرو</div></div></div></div></div></div></md-content><!--<div class=\"table-responsive\">--><!--<table st-safe-src=\"vm.companySocialNetworkInfos\" st-table=\"collection\" st-safe- --><!--class=\"jh-table table table-striped\">--><!--<thead>--><!--<tr>--><!--<th colspan=\"5\"><input st-search=\"\" class=\"form-control\"--><!--placeholder=\"{{ \'tikonApp.companySocialNetworkInfo.home.search\' | translate }}\"--><!--type=\"text\"/>--><!--</th>--><!--</tr>--><!--<tr>--><!--<th st-sortt=\"id\"><span translate=\"global.field.id\">ID</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th st-sort=\"socialNetworkType\"><span translate=\"tikonApp.socialNetworkInfo.socialNetworkType\">Social Network Type</span>--><!--<span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th st-sort=\"title\"><span translate=\"tikonApp.socialNetworkInfo.title\">Title</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th st-sort=\"url\"><span translate=\"tikonApp.socialNetworkInfo.url\">Url</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--&lt;!&ndash;<th st-sort=\"orderNumber\"><span translate=\"tikonApp.companySocialNetworkInfo.orderNumber\">Order Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;<th jh-sort-by=\"companyId\"><span translate=\"tikonApp.companySocialNetworkInfo.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;<th jh-sort-by=\"socialNetworkInfoId\"><span translate=\"tikonApp.companySocialNetworkInfo.socialNetworkInfo\">Social Network Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"companySocialNetworkInfo in collection track by companySocialNetworkInfo.id\">--><!--<td><a ui-sref=\"supplierPanel.companySocialNetworkInfo.edit({id:companySocialNetworkInfo.id})\">{{companySocialNetworkInfo.id}}</a>--><!--</td>--><!--<td translate=\"{{\'tikonApp.SocialNetworkType.\' + companySocialNetworkInfo.socialNetworkInfo.socialNetworkType}}\">--><!--{{companySocialNetworkInfo.socialNetworkInfo.socialNetworkType}}--><!--</td>--><!--<td>{{companySocialNetworkInfo.socialNetworkInfo.title}}</td>--><!--<td>{{companySocialNetworkInfo.socialNetworkInfo.url}}</td>--><!--&lt;!&ndash;<td>{{companySocialNetworkInfo.companySocialNetworkInfo.orderNumber}}</td>&ndash;&gt;--><!--&lt;!&ndash;<td>&ndash;&gt;--><!--&lt;!&ndash;<a ui-sref=\"company-detail({id:companySocialNetworkInfo.companyId})\">{{companySocialNetworkInfo.companyId}}</a>&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--&lt;!&ndash;<td>&ndash;&gt;--><!--&lt;!&ndash;<a ui-sref=\"social-network-info-detail({id:companySocialNetworkInfo.socialNetworkInfoId})\">{{companySocialNetworkInfo.socialNetworkInfoId}}</a>&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"supplierPanel.companySocialNetworkInfo.edit({id:companySocialNetworkInfo.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"supplierPanel.companySocialNetworkInfo.delete({id:companySocialNetworkInfo.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--><!--</table>--><!--</div>--><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></form></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-buy-subscription.html","<style>.btn-show-feature {\n        background-color: #eaeaea;\n        color: #2b6b7f;\n        border: 1px solid #2b6b7f;\n    }\n\n    .btn-show-feature:hover {\n        background-color: #c3c3c3 !important;\n    }\n\n    .btn-all-feature:hover {\n        background-color: #2b6b7f;\n        /*color: white;*/\n    }\n\n    .btn-all-feature {\n        /*background-color: #73cac4;*/\n        color: #2b6b7f;\n        border: 1px solid #2b6b7f;\n    }\n\n    .feature-info {\n        font-size: 12px;\n    }\n\n    .special-feature-info {\n        display: flex;\n        justify-content: center;\n        gap: 8px;\n        padding: 10px 0;\n        flex-wrap: wrap;\n    }\n\n    .price {\n        font-size: 14px;\n        font-weight: bold;\n    }\n\n    .period-discount {\n        color: red;\n        background-color: #ff000017;\n        margin: 0 31px;\n        border-radius: 5px;\n        font-size: 13px;\n    }\n\n    .centerBox {\n        /*background-color: #4caf50;*/\n        margin: auto;\n        width: 300px;\n        padding: 8px 0;\n    }\n\n    .cardStatusIconContainer {\n        color: green;\n        font-weight: bold;\n        font-size: 30px;\n    }\n\n    .package-box {\n        text-align: center;\n        padding-right: 10px;\n    }\n\n    .period-package-box {\n        text-align: center;\n        padding-right: 10px;\n\n    }\n\n    .package-card, .package-card-period, .package-card-BASIC, .package-card-ECONOMY, .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        border-radius: 3px;\n        box-shadow: none;\n        min-height: 100px;\n    }\n\n    .package-card-period {\n        border-color: #2b6b7f;\n        min-height: 200px;\n    }\n\n    .price_unit {\n        font-size: 12px;\n        color: #0e5a41;\n    }\n\n    .package-category {\n        /*border-top: solid 2px #e4e4e1;*/\n        /*padding: 10px;*/\n        vertical-align: middle;\n        text-align: center;\n        margin: auto;\n    }\n\n    .category-title {\n\n        width: 170px;\n        color: #0e5a41;\n        /*margin-top: 30px;*/\n        margin-bottom: 10px;\n        font-size: 17px;\n        font-weight: bold;\n        text-align: center;\n\n    }\n\n    .subscription-status {\n        min-height: 100px;\n        width: 100%;\n\n    }\n\n    .subscription-active, .package-feature-list {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n\n        border-radius: 5px;\n        /*background: #4caf50;*/\n\n    }\n\n    .package-feature-list {\n        background-color: #eaeaea;\n        color: black;\n        font-size: 12px;\n    }\n\n    .subscription-expired {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n        background: darkorange;\n        border-radius: 5px;\n\n    }\n\n    .subscription-status-detail {\n        text-align: center;\n        /*color: #f1ffd6;*/\n        font-size: 12px;\n    }\n\n    .feature-list {\n        font-size: 12px;\n        color: #001b24;\n        text-align: right;\n        padding-top: 14px;\n        font-weight: normal;\n        /*padding-right: 18px;*/\n    }\n\n    .basic-package-box {\n        background-color: #f3fdff;\n    }\n\n    .ul-box {\n        padding-right: 20px;\n    }\n\n    .ul-period-box {\n        padding-right: 20px;\n    }\n\n    .ul-box li:before {\n        content: \'✓\';\n        color: #00AA00;\n    }\n\n    .md-subhead {\n        font-size: 20px !important;\n        font-weight: 600 !important;\n    }\n\n    .BASIC {\n        color: #73cac4;\n    }\n\n    .ECONOMY {\n        color: darkorange;\n    }\n\n    .ENTERPRISE {\n        color: #019fde;\n    }\n\n    .btn-BASIC {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-ECONOMY {\n        background-color: darkorange;\n        color: #ffffff;\n    }\n\n    .btn-ENTERPRISE {\n        background-color: #019fde;\n        color: #ffffff;\n    }\n\n    .btn-DEFAULT {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-BASIC:hover {\n        color: #73cac4;\n\n    }\n\n    .btn-ECONOMY:hover {\n        color: darkorange;\n\n    }\n\n    .btn-ENTERPRISE:hover {\n        color: #019fde;\n    }\n\n    .package-card-BASIC {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .package-card-ECONOMY {\n        background-color: #ffffff;\n        border-color: darkorange;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #019fde;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .border-BASIC {\n        border-color: #73cac4;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ECONOMY {\n        border-color: darkorange;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ENTERPRISE {\n        border-color: #019fde;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .discount-box {\n        position: absolute;\n        left: 11px;\n        top: 20px;\n        font-weight: bold;\n        color: white;\n        border-bottom: 18px solid #fd301b;\n        border-left: 10px solid transparent;\n        border-right: 38px solid transparent;\n        height: 0;\n        width: 134px;\n        transform: rotate(-26deg);\n    }\n\n    .package-card-not-selected {\n        color: #c3c2c2;\n        border-color: #eeeeee;\n    }\n\n    .btn-not-selected {\n        background-color: #cecece;\n        color: #ffffff;\n    }\n\n    .package-period {\n        border: 1px solid gray;\n        border-radius: 5px;\n        padding: 20px;\n\n    }\n\n    .select-period-button {\n        background-color: #2b6b7f;\n        color: #ffffff;\n    }\n\n    .select-period-button:hover {\n        color: #2b6b7f;\n    }\n\n    .period-title {\n        font-size: 16px;\n    }\n\n    @media (max-width: 767px) {\n        .discount-box {\n            top: 12px;\n        }\n    }</style><div id=\"subscriptionStatus\" class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div ng-if=\"vm.isNativeApp != \'true\'\"><div class=\"row\"><div class=\"subscription-active\" ng-if=\"vm.currentSubscriptionStatus==\'ACTIVE\' && vm.activePackage\"><div class=\"centerBox\">اشتراک شما تا تاریخ <strong>{{vm.activePackage.expireDate | toPersianDate}} </strong>فعال است<br><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet></leaflet></div>--><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet-directive></leaflet-directive></div>--><div class=\"subscription-status-detail\"><span>{{\"tikonApp.SubscriptionType.\"+vm.activePackage.subscriptionPackage.subscriptionType| translate}} </span>- <span>{{vm.activePackage.subscriptionPackage.title}}</span><!--:--><!--<span>--><!--{{vm.activePackage.startDate | toPersianDate}}--><!--</span>--><!-- - --><!--<span>--><!--{{vm.activePackage.expireDate | toPersianDate}}--><!--</span>--></div></div><div class=\"feature-info\"><span ng-if=\"vm.packageFeatureList.featureInfoObject.servantCount\" style=\"padding-left: 20px\">تعداد پرسنل : {{vm.packageFeatureList.featureInfoObject.servantCount}}</span><md-button class=\"btn-show-feature\" ng-click=\"vm.showFeaturesClick()\">مشاهده امکانات ویژه فعال</md-button><span><!--تعداد امکان ویژه قابل استفاده--><!--: {{vm.packageFeatureList.featureInfoObject.specialFeatureCount}}--></span></div></div><div class=\"package-feature-list\" ng-if=\"vm.currentSubscriptionStatus==\'ACTIVE\' && vm.activePackage && vm.showFeatures\"><div class=\"\"><div id=\"packageFeatureList\"><div style=\"font-size: 18px\">امکانات ویژه فعال</div><div id=\"specialFeatureInfo\" class=\"special-feature-info\"><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.twoStepVerification\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.twoStepVerification\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.dedicateDomain\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.dedicateDomain\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_SMS\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.satisfactionMessage_SMS\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_Email\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.satisfactionMessage_Email\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.widget\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.widget\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.notifyReserveToServant\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.notifyReserveToServant\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.smsTextEdit\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.smsTextEdit\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.servantLogin\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.servantLogin\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.intakeForm\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.intakeForm\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.uploadFile\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.uploadFile\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.cancelReserveByCustomer\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.cancelReserveByCustomer\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.daftareShoma\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.daftareShoma\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.autoMultiReserveMode\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.autoMultiReserveMode\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.couponCode\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.couponCode\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerGroup\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerGroup\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerAccess\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerAccess\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.reservePattern\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.reservePattern\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.serviceWithoutServant\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.serviceWithoutServant\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customPricingForServant\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customPricingForServant\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.recordOnlineMeeting\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.recordOnlineMeeting\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.reserveLimit\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.reserveLimit\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerRebookReminder_SMS\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerRebookReminder_SMS\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerSecondReminder\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerSecondReminder\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.advancedPricing\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.advancedPricing\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.whatsAppSupport\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.whatsAppSupport\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.servantServiceScheduling\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.servantServiceScheduling\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.serviceCapacity\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.serviceCapacity\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.invoice\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.invoice\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.marketingCampaign\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.marketingCampaign\"| translate}}</div></div><md-button class=\"btn-all-feature\" href=\"https://planovin.com/allfeatures\" target=\"_blank\">مشاهده تمامی امکانات ویژه</md-button></div></div></div><div class=\"subscription-expired\" ng-if=\"vm.currentSubscriptionStatus==\'EXPIRED\'\"><div class=\"centerBox\" style=\"background-color: darkorange\"><strong>اشتراک شما به پایان رسیده است.</strong></div></div></div><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب بسته اشتراک</div><div class=\"row\"><div ng-repeat=\"ptype  in vm.subscriptionTypeList\"><div class=\"package-category\"><div class=\"col-sm-4\"><div class=\"package-box\"><md-card md-theme-watch class=\"package-card\" ng-class=\"vm.packageCardStyle(ptype)\"><md-card-title><md-card-title-text><span class=\"md-subhead\"><!--{{package.title}}--> {{\"tikonApp.SubscriptionType.\"+ptype.type | translate}} </span><span><ul class=\"ul-box\"><div ng-bind-html=\"vm.makeFeatureDesc(ptype)\" class=\"feature-list\"></div></ul></span></md-card-title-text></md-card-title><md-card-actions ng-if=\"!ptype.isSelected\" style=\"margin-top: 15px\"><md-button ng-class=\"vm.buttonClass(ptype.type)\" ng-click=\"vm.selectSubscriptionBaseType(ptype)\"><!--ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"--> <span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions><div ng-if=\"ptype.isSelected\" class=\"cardStatusIconContainer\"><i class=\"glyphicon glyphicon-ok-circle\" aria-hidden=\"true\"></i><!--<span>انتخاب شده</span>--></div></md-card></div></div></div></div></div><div id=\"periodSelection\" ng-if=\"vm.isAnyPackageSelected\"><hr><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب مدت زمان</div><div class=\"row period-package-box text-center\"><div ng-repeat=\"package  in vm.availablePackagePeriods\"><div class=\"col-sm-3\"><!--<div class=\"\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\">--><!--<ul class=\"ul-period-box\">--><!--<li>{{package.title}}</li>--><!--<li>{{package.chargeFee}}</li>--><!--<li>{{package.description}}</li>--><!--</ul>--><!--<md-button >--><!--<span class=\"glyphicon glyphicon-ok\"></span>--><!--انتخاب--><!--</md-button>--><!--</div>--><md-card md-theme-watch class=\"package-card-period\" style=\"min-height: 200px\" ng-class=\"vm.packageCardStyle(ptype)\"><md-card-title><md-card-title-text><span class=\"period-title\">{{package.title}} </span><span class=\"price\">{{package.chargeFee | number}} <small class=\"price_unit\">تومان </small></span><span class=\"period-discount\">{{package.description}}</span></md-card-title-text></md-card-title><md-card-actions style=\"margin-top: 15px\"><md-button class=\"select-period-button\" ui-sref=\"supplierPanel-v2.purchaseSubscription({id:package.id})\"><span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions></md-card><!--{{package}}--></div></div></div></div></div><div ng-if=\"vm.isNativeApp == \'true\'\" style=\"padding-right: 15px\"><div class=\"subscription-expired\"><div style=\"background-color: darkorange\"><strong>برای رفع مشکل دسترسی با پشتیبانی تماس بگیرید.</strong></div></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-sms-package-status-view-v2.html","<style>.centerBox {\n        /*background-color: #4caf50;*/\n        margin: auto;\n        width: 300px;\n        padding: 8px 0;\n    }\n\n    .numbersInTitleBar {\n        font-size: x-large;\n    }\n\n    .cardStatusIconContainer {\n        position: absolute;\n        opacity: 0.1;\n        margin-left: 26px;\n        left: 0;\n    }\n\n    .dashboardTitleBar_col {\n        padding: 0 4px;\n        text-align: center;\n        margin-bottom: 10px;\n    }\n\n    .dashboardTitleBar_col > div {\n        margin: 0 1px;\n        background-color: rgba(0, 0, 0, 0.05);\n        height: 102px;\n        border-radius: 5px;\n    }\n\n    .dashboardTitleBar_col .textInTitleBar {\n        font-size: 10px;\n    }\n\n    .dashboardTitleBar_col hr {\n        border: none;\n        width: 45%;\n        margin: 0 auto 20px;\n        background-color: lightgray;\n    }\n\n    .package-box {\n        text-align: center;\n    }\n\n    .package-card {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        border-radius: 3px;\n    }\n\n    .price_unit {\n        font-size: 12px;\n        color: #0e5a41;\n    }\n\n    .package-category {\n        border-top: solid 2px #e4e4e1;\n        padding: 10px;\n        vertical-align: middle;\n        text-align: center;\n        margin: auto;\n    }\n\n    .category-title {\n\n        /*width: 120px;*/\n        color: #0e5a41;\n        /*margin-top: 30px;*/\n        margin-bottom: 10px;\n        font-size: 17px;\n        font-weight: bold;\n        text-align: center;\n\n    }\n\n    .subscription-status {\n        min-height: 100px;\n        width: 100%;\n\n    }\n\n    .subscription-active {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n\n        border-radius: 5px;\n        /*background: #4caf50;*/\n\n    }\n\n    .subscription-expired {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n        background: darkorange;\n        border-radius: 5px;\n\n    }\n\n    .subscription-status-detail {\n        text-align: center;\n        /*color: #f1ffd6;*/\n        font-size: 12px;\n    }\n\n    .feature-list {\n        font-size: 12px;\n        color: #001b24;\n        text-align: right;\n        padding-top: 14px;\n        font-weight: normal;\n        /*padding-right: 18px;*/\n    }\n\n    .basic-package-box {\n        background-color: #f3fdff;\n    }\n\n    .ul-box {\n        padding-right: 20px;\n    }\n\n    .BASIC {\n        color: #73cac4;\n    }\n\n    .ECONOMY {\n        color: darkorange;\n    }\n\n    .ENTERPRISE {\n        color: #019fde;\n    }\n\n    .btn-BASIC {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-ECONOMY {\n        background-color: darkorange;\n        color: #ffffff;\n    }\n\n    .btn-ENTERPRISE {\n        background-color: #019fde;\n        color: #ffffff;\n    }\n\n    .btn-DEFAULT {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-BASIC:hover {\n        color: #73cac4;\n\n    }\n\n    .btn-ECONOMY:hover {\n        color: darkorange;\n\n    }\n\n    .btn-ENTERPRISE:hover {\n        color: #019fde;\n    }\n\n    .package-card-BASIC {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .package-card-ECONOMY {\n        background-color: #ffffff;\n        border-color: darkorange;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #019fde;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .border-BASIC {\n        border-color: #73cac4;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ECONOMY {\n        border-color: darkorange;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ENTERPRISE {\n        border-color: #019fde;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .discount-box {\n        position: absolute;\n        left: 11px;\n        top: 20px;\n        font-weight: bold;\n        color: white;\n        border-bottom: 18px solid #fd301b;\n        border-left: 10px solid transparent;\n        border-right: 38px solid transparent;\n        height: 0;\n        width: 134px;\n        transform: rotate(-26deg);\n    }\n\n    @media (max-width: 767px) {\n        .discount-box {\n            top: 12px;\n        }\n    }</style><div id=\"smsSubscriptionStatus\" class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"row\" style=\"margin: 0\"><div class=\"col-sm-3 hidden-xs\"></div><div class=\"col-sm-2 hidden-xs dashboardTitleBar_col\"><div style=\"height: 102px; line-height: 102px; text-align: center\"><span translate=\"supplierPanel.sideMenu.smsPackages.smsCount\">supplierPanel.sideMenu.smsPackages.smsCount</span></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.smsPackages.sentSMS\">supplierPanel.sideMenu.tikonApp.smsPackages.sentSMS</span><hr><div id=\"lastWeekReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.companyPackageStatus.consumedSMS}}</div></div></div><div class=\"col-sm-2 col-xs-6 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.smsPackages.remainedSMS\">supplierPanel.sideMenu.smsPackages.remainedSMS</span><hr><div id=\"lastMonthReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\"><span ng-if=\"vm.companyPackageStatus.availableSMS < 1000000\">{{vm.companyPackageStatus.availableSMS}}</span> <span ng-if=\"vm.companyPackageStatus.availableSMS >= 1000000\" translate=\"supplierPanel.sideMenu.smsPackages.unlimited\">supplierPanel.sideMenu.smsPackages.unlimited</span></div></div></div><div class=\"col-sm-3\"></div></div><div class=\"row\" style=\"text-align: center\"><div><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.companySubscriptionHistory({packageType:\'SMS\'})\">مشاهده سوابق خرید <span><i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i></span></md-button></div></div><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب بسته پیامکی</div><div ng-repeat=\"ptype  in vm.subscriptionTypeList\"><div class=\"row package-category\"><div class=\"col-sm-2\" data-ng-if=\"!vm.hasCustomSubscriptionType\" style=\"position: relative\"><div class=\"category-title\"><div ng-class=\"ptype.type\"></div><div ng-class=\"vm.borderStyle(ptype.type)\"></div></div></div><div class=\"col-md-1\"></div><div class=\"col-sm-7 col-md-6\"><div class=\"col-sm-6\" ng-repeat=\"package in vm.subscriptionPackages\"><div class=\"package-box\"><md-card md-theme-watch class=\"package-card\" ng-class=\"vm.packageCardStyle(ptype.type)\"><md-card-title><md-card-title-text><span class=\"md-subhead\">{{package.title}}</span> <span class=\"md-headline\">{{package.chargeFee | number:0 }} <small class=\"price_unit\">تومان </small></span><span><div ng-if=\"package.description\"><div class=\"discount-box\">{{package.description}}</div></div></span></md-card-title-text></md-card-title><md-card-actions style=\"margin-top: 15px\"><md-button ng-class=\"vm.buttonClass(ptype.type)\" ui-sref=\"supplierPanel-v2.purchaseSubscription({id:package.id})\"><span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions><div class=\"cardStatusIconContainer\"><i class=\"fa fa-envelope-o fa-2x\" aria-hidden=\"true\"></i></div></md-card></div></div></div><div class=\"col-sm-3 col-md-2\"></div></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-sms-package-status-view.html","<style>.centerBox {\n        /*background-color: #4caf50;*/\n        margin: auto;\n        width: 300px;\n        padding: 8px 0;\n    }\n\n    .numbersInTitleBar {\n        font-size: x-large;\n    }\n\n    .cardStatusIconContainer {\n        position: absolute;\n        opacity: 0.1;\n        margin-left: 26px;\n        left: 0;\n    }\n\n    .dashboardTitleBar_col {\n        padding: 0 4px;\n        text-align: center;\n        margin-bottom: 10px;\n    }\n\n    .dashboardTitleBar_col > div {\n        margin: 0 1px;\n        background-color: rgba(0, 0, 0, 0.05);\n        height: 102px;\n        border-radius: 5px;\n    }\n\n    .dashboardTitleBar_col .textInTitleBar {\n        font-size: 10px;\n    }\n\n    .dashboardTitleBar_col hr {\n        border: none;\n        width: 45%;\n        margin: 0 auto 20px;\n        background-color: lightgray;\n    }\n\n    .package-box {\n        text-align: center;\n    }\n\n    .package-card {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        border-radius: 3px;\n    }\n\n    .price_unit {\n        font-size: 12px;\n        color: #0e5a41;\n    }\n\n    .package-category {\n        border-top: solid 2px #e4e4e1;\n        padding: 10px;\n        vertical-align: middle;\n        text-align: center;\n        margin: auto;\n    }\n\n    .category-title {\n\n        /*width: 120px;*/\n        color: #0e5a41;\n        /*margin-top: 30px;*/\n        margin-bottom: 10px;\n        font-size: 17px;\n        font-weight: bold;\n        text-align: center;\n\n    }\n\n    .subscription-status {\n        min-height: 100px;\n        width: 100%;\n\n    }\n\n    .subscription-active {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n\n        border-radius: 5px;\n        /*background: #4caf50;*/\n\n    }\n\n    .subscription-expired {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n        background: darkorange;\n        border-radius: 5px;\n\n    }\n\n    .subscription-status-detail {\n        text-align: center;\n        /*color: #f1ffd6;*/\n        font-size: 12px;\n    }\n\n    .feature-list {\n        font-size: 12px;\n        color: #001b24;\n        text-align: right;\n        padding-top: 14px;\n        font-weight: normal;\n        /*padding-right: 18px;*/\n    }\n\n    .basic-package-box {\n        background-color: #f3fdff;\n    }\n\n    .ul-box {\n        padding-right: 20px;\n    }\n\n    .BASIC {\n        color: #73cac4;\n    }\n\n    .ECONOMY {\n        color: darkorange;\n    }\n\n    .ENTERPRISE {\n        color: #019fde;\n    }\n\n    .btn-BASIC {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-ECONOMY {\n        background-color: darkorange;\n        color: #ffffff;\n    }\n\n    .btn-ENTERPRISE {\n        background-color: #019fde;\n        color: #ffffff;\n    }\n\n    .btn-DEFAULT {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-BASIC:hover {\n        color: #73cac4;\n\n    }\n\n    .btn-ECONOMY:hover {\n        color: darkorange;\n\n    }\n\n    .btn-ENTERPRISE:hover {\n        color: #019fde;\n    }\n\n    .package-card-BASIC {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .package-card-ECONOMY {\n        background-color: #ffffff;\n        border-color: darkorange;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #019fde;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .border-BASIC {\n        border-color: #73cac4;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ECONOMY {\n        border-color: darkorange;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ENTERPRISE {\n        border-color: #019fde;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .discount-box {\n        position: absolute;\n        left: 11px;\n        top: 20px;\n        font-weight: bold;\n        color: white;\n        border-bottom: 18px solid #fd301b;\n        border-left: 10px solid transparent;\n        border-right: 38px solid transparent;\n        height: 0;\n        width: 134px;\n        transform: rotate(-26deg);\n    }\n\n    @media (max-width: 767px) {\n        .discount-box {\n            top: 12px;\n        }\n    }</style><div class=\"container-fluid\"><!--<div class=\"row \">--><!--<div class=\"subscription-active\" ng-if=\"vm.companyPackageStatus.hasActiveSubscription\">--><!--<div class=\"centerBox\">--><!--اشتراک شما تا تاریخ--><!--<strong>--><!--{{vm.companyPackageStatus.subscriptionExpireDate | toPersianDate}}--><!--</strong>--><!--فعال است--><!--<br/>--><!--&lt;!&ndash;<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet></leaflet></div>&ndash;&gt;--><!--&lt;!&ndash;<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet-directive></leaflet-directive></div>&ndash;&gt;--><!--<div class=\"subscription-status-detail\">--><!--<span>{{vm.companyPackageStatus.lastSubscriptionPackageTitle}}</span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"subscription-expired\"--><!--ng-if=\"vm.companyPackageStatus && !vm.companyPackageStatus.hasActiveSubscription\">--><!--<div class=\"centerBox\" style=\"background-color: darkorange;\">--><!--<strong>--><!--اشتراک شما به پایان رسیده است.--><!--</strong>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row\"><div class=\"col-sm-3\"></div><div class=\"col-sm-2 dashboardTitleBar_col\"><div style=\"height: 102px; line-height: 102px; text-align: center\"><span translate=\"supplierPanel.sideMenu.smsPackages.smsCount\">supplierPanel.sideMenu.smsPackages.smsCount</span></div></div><div class=\"col-sm-2 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.smsPackages.sentSMS\">supplierPanel.sideMenu.tikonApp.smsPackages.sentSMS</span><hr><div id=\"lastWeekReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\">{{vm.companyPackageStatus.consumedSMS}}</div></div></div><div class=\"col-sm-2 dashboardTitleBar_col\"><div><span class=\"textInTitleBar\" translate=\"supplierPanel.sideMenu.smsPackages.remainedSMS\">supplierPanel.sideMenu.smsPackages.remainedSMS</span><hr><div id=\"lastMonthReserveNumber\" class=\"numbersInTitleBar\" style=\"margin-top: 10px\"><span ng-if=\"vm.companyPackageStatus.availableSMS < 1000000\">{{vm.companyPackageStatus.availableSMS}}</span> <span ng-if=\"vm.companyPackageStatus.availableSMS >= 1000000\" translate=\"supplierPanel.sideMenu.smsPackages.unlimited\">supplierPanel.sideMenu.smsPackages.unlimited</span></div></div></div><div class=\"col-sm-3\"></div></div><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب بسته پیامکی</div><div ng-repeat=\"ptype  in vm.subscriptionTypeList\"><div class=\"row package-category\"><div class=\"col-sm-2\" data-ng-if=\"!vm.hasCustomSubscriptionType\" style=\"position: relative\"><div class=\"category-title\"><div ng-class=\"ptype.type\"></div><div ng-class=\"vm.borderStyle(ptype.type)\"></div></div></div><div class=\"col-md-1\"></div><div class=\"col-sm-7 col-md-6\"><div class=\"col-sm-6\" ng-repeat=\"package in vm.subscriptionPackages\"><div class=\"package-box\"><md-card md-theme-watch class=\"package-card\" ng-class=\"vm.packageCardStyle(ptype.type)\"><md-card-title><md-card-title-text><span class=\"md-subhead\">{{package.title}}</span> <span class=\"md-headline\">{{package.chargeFee | number:0 }} <small class=\"price_unit\">تومان </small></span><span><div ng-if=\"package.description\"><div class=\"discount-box\">{{package.description}}</div></div></span></md-card-title-text></md-card-title><md-card-actions style=\"margin-top: 15px\"><md-button ng-class=\"vm.buttonClass(ptype.type)\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"><span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions><div class=\"cardStatusIconContainer\"><i class=\"fa fa-envelope-o fa-2x\" aria-hidden=\"true\"></i></div></md-card></div></div></div><div class=\"col-sm-3 col-md-2\"></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-histories.html","<div class=\"\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.companySubscriptionStatus.home.title\">tikonApp.companySubscriptionStatus.home.searchPlaceHolder.title</div><div class=\"panel-body pl-panel-body\"><div class=\"row hidden-xs\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ng-click=\"vm.back()\"><span><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> </span><span translate=\"entity.action.back\">entity.action.back</span></md-button></div></div></div><!--<div class=\"container-fluid\">--><jhi-alert></jhi-alert><div class=\"\"><div class=\"row topOfList\" style=\"display: flex; align-items: center\"><div class=\"col-sm-10 col-xs-12\"><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.companySubscriptionStatus.home.searchPlaceHolder\'\" on-search=\"vm.advancedSearch()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"false\"></eo-pl-search-box></div><div class=\"col-sm-2 hidden-xs\"><div class=\"form-group\"><label translate=\"global.pageSize\">pageSize</label><md-select class=\"rwMdSelect\" id=\"field_pageSize\" ng-model=\"vm.pageSize\" ng-change=\"vm.pageSizeChanged()\" style=\"min-width: 100px;margin-bottom: 5px !important\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.pageSizeList\">{{si}}</md-option></md-select></div></div></div><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.companySubscriptionStatuses\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr class=\"pl-table-header\"><th><span translate=\"tikonApp.companySubscriptionStatus.id\">formId</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.companySubscriptionStatus.createDate\">CreateDate</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.subscriptionPackage.title\">Title</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.subscriptionPackage.packageType\">packageType</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.paymentLog.paymentTypePay\">transferType</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.paymentLog.amount\">Amount</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"data in collection track by data.id\"><!--<td>{{invoiceInfo.id }} </td>--><td>{{data.id}}</td><td>{{data.createDate|toPersianDate}}</td><td>{{data.subscriptionPackage.title}}</td><td>{{\"tikonApp.packageType.\"+data.subscriptionPackage.packageType | translate}}</td><td>{{\"tikonApp.PaymentType.\"+data.companyInvoiceInfo.paymentLog.paymentType | translate}}</td><td>{{data.companyInvoiceInfo.paymentLog.amount | number}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.pageSize\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\"></uib-pagination></div></div><!--</div>--></div></div></div></div><!--<div class=\"visible-xs pl-form-container \">--><!--<div class=\"\">--><!--<div class=\"\">--><!--<div class=\"col-xs-12 invoiceInfo-list-title\">--><!--<h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0;\">--><!--{{\'tikonApp.companyCustomer.companyCustomerFormData.home.title\' | translate}}--><!--</h3>--><!--<div style=\"align-self: flex-end;\">--><!--<md-button class=\"pl-btn-default\" style=\"border-radius: 10px;\"--><!--ui-sref=\"supplierPanel-v2.reportExport\">--><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--><!--بازگشت--><!--</span>--><!--</md-button>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<jhi-alert></jhi-alert>--><!--<eo-pl-search-box search-query=\"vm.filterQuery.searchText\"--><!--search-place-holder=\"\'tikonApp.companyCustomer.companyCustomerFormData.home.searchPlaceHolder\'\"--><!--on-search=\"vm.advancedSearch()\"--><!--on-clear-search=\"vm.clearSearch()\"--><!--can-filter=\"false\"--><!--on-filter-click=\"vm.showFilterDialog\"--><!--filter-count=\"vm.filterCount\"--><!--&gt;</eo-pl-search-box>--><!--<div ng-repeat=\"companyCustomerData in vm.companyCustomerDatas track by companyCustomerData.id\"--><!--class=\"customer-list-item\"--><!--ng-click=\"vm.openEditDataDialog(companyCustomerData)\"--><!--&gt;--><!--&lt;!&ndash;<eo-avatar-name name=\"{{invoiceInfo.invoiceInfoCode}}\"></eo-avatar-name>&ndash;&gt;--><!--<div class=\"customer-list-item-detail\" style=\"padding-right: 20px\">--><!--<div class=\"customer-list-customer-name\" style=\"font-weight: bold;font-size: 16px;\">--><!--{{companyCustomerData.id}}--><!--</div>--><!--<div class=\"customer-list-customer-name\">--><!--{{companyCustomerData.companyCustomer.customerFullName}}--><!--</div>--><!--</div>--><!--<div class=\"customer-list-item-detail\">--><!--<div class=\"customer-list-customer-phone\">--><!--<span>--><!--{{companyCustomerData.companyCustomForm.title}}--><!--</span>--><!--</div>--><!--<div class=\"customer-list-customer-phone\">--><!--&lt;!&ndash;<span>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;{{companyCustomer.createDate | toPersianDate}}</td>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;{{invoiceInfo.finalPrice}}&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"global.currencyBracket\"></span>&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--</div>--><!--</div>--><!--&lt;!&ndash;<div class=\"customer-list-item-detail\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"customer-list-customer-phone\">&ndash;&gt;--><!--&lt;!&ndash;<span ng-class=\"vm.findStatusStyle(invoiceInfo.status)\" style=\"font-size: 12px\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"{{\'tikonApp.invoiceStatus.\' + invoiceInfo.status}}\">{{invoiceInfo.status}}</span>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black;\">chevron_left</md-icon>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px;\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\"--><!--ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/company-subscription-status/company-subscription-status-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.companySubscriptionStatus.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.companySubscriptionStatus.delete.question\" translate-values=\"{id: \'{{vm.companySubscriptionStatus.id}}\'}\">Are you sure you want to delete this Company Subscription Status?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-status-detail.html","<div><h2><span translate=\"tikonApp.companySubscriptionStatus.detail.title\">Company Subscription Status</span> {{vm.companySubscriptionStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.companySubscriptionStatus.createDate\">Create Date</span></dt><dd><span>{{vm.companySubscriptionStatus.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.startDate\">Start Date</span></dt><dd><span>{{vm.companySubscriptionStatus.startDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.expireDate\">Expire Date</span></dt><dd><span>{{vm.companySubscriptionStatus.expireDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.wageFeePercentage\">Wage Fee Percentage</span></dt><dd><span>{{vm.companySubscriptionStatus.wageFeePercentage}}</span></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.SubscriptionStatus.\' + vm.companySubscriptionStatus.status}}\">{{vm.companySubscriptionStatus.status}}</span></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.moneyTransferLog\">Money Transfer Log</span></dt><dd><a ui-sref=\"money-transfer-log-detail({id:vm.companySubscriptionStatus.moneyTransferLogId})\">{{vm.companySubscriptionStatus.moneyTransferLogId}}</a></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.subscriptionPackage\">Subscription Package</span></dt><dd><a ui-sref=\"subscription-package-detail({id:vm.companySubscriptionStatus.subscriptionPackageId})\">{{vm.companySubscriptionStatus.subscriptionPackageId}}</a></dd><dt><span translate=\"tikonApp.companySubscriptionStatus.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.companySubscriptionStatus.companyId})\">{{vm.companySubscriptionStatus.companyId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanySubscriptionStatusLabel\" translate=\"tikonApp.companySubscriptionStatus.home.createOrEditLabel\">Create or edit a Company Subscription Status</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.companySubscriptionStatus.id\"><label translate=\"global.field.id\">ID</label><span>{{vm.companySubscriptionStatus.id}}</span><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"vm.companySubscriptionStatus.id\" readonly/>--></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"form-group col-md-6\"><md-radio-group ng-model=\"vm.packageType\" ng-change=\"vm.onPackageType_changed()\" layout=\"row\" class=\"setting-radio-box-inside\"><md-radio-button class=\"md-primary\" value=\"SUBSCRIPTION\"><span>اشتراک</span></md-radio-button><md-radio-button class=\"md-primary\" value=\"SMS\"><span>پیامک</span></md-radio-button></md-radio-group></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.keyUrl\" for=\"field_companyKeyUrl\" required>companyKeyUrl</label><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" id=\"field_companyKeyUrl\" ng-model=\"vm.companyKeyUrl\"></div></div><div class=\"col-md-3\" style=\"margin-top: 24px\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.findCompany()\"><span class=\"glyphicon glyphicon-search\"></span>&nbsp; <span>جستجوی کمپانی</span></button></div><div class=\"col-md-3\"><div ng-if=\"vm.companySubscriptionStatus.company\">Company : {{vm.companySubscriptionStatus.company.title}}</div></div></div><div ng-if=\"vm.companySubscriptionStatus.company\"><div class=\"row\" ng-if=\"vm.packageType==\'SUBSCRIPTION\'\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companySubscriptionStatus.startDate\" for=\"field_startDate\">Start Date</label><eo-date-picker id=\"field_startDate\" date-value=\"vm.companySubscriptionStatus.startDate\"></eo-date-picker></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companySubscriptionStatus.expireDate\" for=\"field_expireDate\">Expire Date</label><eo-date-picker id=\"field_expireDate\" date-value=\"vm.companySubscriptionStatus.expireDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"tikonApp.companySubscriptionStatus.subscriptionPackage\" for=\"field_subscriptionPackage\" required>Subscription Package</label><!--<select class=\"form-control\" id=\"field_subscriptionPackage\" name=\"subscriptionPackage\" ng-model=\"vm.companySubscriptionStatus.subscriptionPackageId\"--><!--ng-options=\"subscriptionPackage.title + subscriptionPackage.packageType as subscriptionPackage.title for subscriptionPackage in vm.subscriptionpackages\"            >--><!--<option value=\"\"></option>--><!--</select>--><md-select class=\"rwMdSelect\" id=\"field_subscriptionPackage\" ng-model=\"vm.companySubscriptionStatus.subscriptionPackage.id\" ng-change=\"vm.subscriptionPackage_changed()\" required eo-required=\"\"><md-option ng-value=\"sp.id\" ng-repeat=\"sp in vm.subscriptionpackages\">{{sp.title}} -- {{sp.subscriptionType}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice\" for=\"field_subscriptionPrice\">SubscriptionPrice</label><input type=\"number\" class=\"form-control\" name=\"subscriptionPrice\" id=\"field_SubscriptionPrice\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice\" ng-change=\"vm.computeFinalPrice()\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companySubscriptionStatus.companyInvoiceInfo.discount\" for=\"field_discount\">discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.discount\" ng-change=\"vm.computeFinalPrice()\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"ارزش افزوده\" for=\"field_discount\">vat</label><input type=\"number\" class=\"form-control\" name=\"vat\" id=\"field_vat\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.vat\" disabled=\"true\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"قیمت نهایی\" for=\"field_discount\">finalPrice</label><input type=\"number\" class=\"form-control\" name=\"vat\" id=\"field_finalPrice\" ng-model=\"vm.finalPrice\" disabled=\"true\"></div></div></div><h4>وضعیت پرداخت</h4><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.amount\" for=\"field_amount\">amount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.amount\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.paymentType\" for=\"field_paymentType\">Payment Type</label><md-select class=\"rwMdSelect\" name=\"paymentType\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.paymentType\" id=\"field_paymentType\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><md-option value=\"CASH\" translate=\"tikonApp.PaymentType.CASH\">CASH</md-option><md-option value=\"CREDIT_CARD\" translate=\"tikonApp.PaymentType.CREDIT_CARD\">CREDIT_CARD</md-option><md-option value=\"MONEY_TRANSFER\" translate=\"tikonApp.PaymentType.MONEY_TRANSFER\">MONEY_TRANSFER</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.createDate\" for=\"field_paymentCreateDate\">Create Date</label><eo-date-picker style=\"display: block\" id=\"field_paymentCreateDate\" date-value=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.createDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companySubscriptionStatus.howInvoiceSettlement\" for=\"field_howInvoiceSettlement\">howInvoiceSettlement</label><input type=\"text\" class=\"form-control\" name=\"amount\" id=\"field_howInvoiceSettlement\" ng-model=\"vm.companySubscriptionStatus.companyInvoiceInfo.paymentLog.moreInfo\"></div></div></div></div></md-content></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-status-view-event.html","<style>.price {\n        font-size: 14px;\n        font-weight: bold;\n    }\n\n    .period-discount {\n        color: red;\n        background-color: #ff000017;\n        margin: 0 31px;\n        border-radius: 5px;\n        font-size: 13px;\n    }\n\n    .centerBox {\n        /*background-color: #4caf50;*/\n        margin: auto;\n        width: 300px;\n        padding: 8px 0;\n    }\n\n    .cardStatusIconContainer {\n        color: green;\n        font-weight: bold;\n        font-size: 30px;\n    }\n\n    .package-box {\n        text-align: center;\n        padding-right: 10px;\n    }\n\n    .period-package-box {\n        text-align: center;\n        padding-right: 10px;\n\n    }\n\n    .package-card, .package-card-period, .package-card-BASIC, .package-card-ECONOMY, .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        border-radius: 3px;\n        box-shadow: none;\n        min-height: 100px;\n    }\n\n    .package-card-period {\n        border-color: #2b6b7f;\n        min-height: 200px;\n    }\n\n    .price_unit {\n        font-size: 12px;\n        color: #0e5a41;\n    }\n\n    .package-category {\n        /*border-top: solid 2px #e4e4e1;*/\n        /*padding: 10px;*/\n        vertical-align: middle;\n        text-align: center;\n        margin: auto;\n    }\n\n    .category-title {\n\n        width: 170px;\n        color: #0e5a41;\n        /*margin-top: 30px;*/\n        margin-bottom: 10px;\n        font-size: 17px;\n        font-weight: bold;\n        text-align: center;\n\n    }\n\n    .subscription-status {\n        min-height: 100px;\n        width: 100%;\n\n    }\n\n    .subscription-active {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n\n        border-radius: 5px;\n        /*background: #4caf50;*/\n\n    }\n\n    .subscription-expired {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n        background: darkorange;\n        border-radius: 5px;\n\n    }\n\n    .subscription-status-detail {\n        text-align: center;\n        /*color: #f1ffd6;*/\n        font-size: 12px;\n    }\n\n    .feature-list {\n        font-size: 12px;\n        color: #001b24;\n        text-align: right;\n        padding-top: 14px;\n        font-weight: normal;\n        min-height: 150px;\n        /*padding-right: 18px;*/\n    }\n\n    .basic-package-box {\n        background-color: #f3fdff;\n    }\n\n    .ul-box {\n        padding-right: 20px;\n    }\n\n    .ul-period-box {\n        padding-right: 20px;\n    }\n\n    .ul-box li:before {\n        content: \'✓\';\n        color: #00AA00;\n    }\n\n    .md-subhead {\n        font-size: 20px !important;\n        font-weight: 600 !important;\n    }\n\n    .BASIC {\n        color: #73cac4;\n    }\n\n    .ECONOMY {\n        color: darkorange;\n    }\n\n    .ENTERPRISE {\n        color: #019fde;\n    }\n\n    .btn-BASIC {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-ECONOMY {\n        background-color: darkorange;\n        color: #ffffff;\n    }\n\n    .btn-ENTERPRISE {\n        background-color: #019fde;\n        color: #ffffff;\n    }\n\n    .btn-DEFAULT {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-BASIC:hover {\n        color: #73cac4;\n\n    }\n\n    .btn-ECONOMY:hover {\n        color: darkorange;\n\n    }\n\n    .btn-ENTERPRISE:hover {\n        color: #019fde;\n    }\n\n    .package-card-BASIC {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .package-card-ECONOMY {\n        background-color: #ffffff;\n        border-color: darkorange;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #019fde;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .border-BASIC {\n        border-color: #73cac4;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ECONOMY {\n        border-color: darkorange;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ENTERPRISE {\n        border-color: #019fde;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .discount-box {\n        position: absolute;\n        left: 11px;\n        top: 20px;\n        font-weight: bold;\n        color: white;\n        border-bottom: 18px solid #fd301b;\n        border-left: 10px solid transparent;\n        border-right: 38px solid transparent;\n        height: 0;\n        width: 134px;\n        transform: rotate(-26deg);\n    }\n\n    .package-card-not-selected {\n        color: #c3c2c2;\n        border-color: #eeeeee;\n    }\n\n    .btn-not-selected {\n        background-color: #cecece;\n        color: #ffffff;\n    }\n\n    .package-period {\n        border: 1px solid gray;\n        border-radius: 5px;\n        padding: 20px;\n\n    }\n\n    .select-period-button {\n        background-color: #2b6b7f;\n        color: #ffffff;\n    }\n\n    .select-period-button:hover {\n        color: #2b6b7f;\n    }\n\n    .period-title {\n        font-size: 16px;\n    }\n\n    .event-type-box {\n        border: 1px solid #c0c0c0;\n        border-radius: 5px;\n        padding: 20px 10px;\n        text-align: center;\n        /* max-width: 200px; */\n        min-width: 200px;\n        background-color: #b1e2f140;\n        box-shadow: 0px 0px 17px -10px;\n    }\n\n    .event-type {\n        display: flex;\n        justify-content: center;\n        column-gap: 60px;\n        margin: 40px 0px;\n    }\n\n\n    @media (max-width: 767px) {\n        .discount-box {\n            top: 12px;\n        }\n\n        .event-type {\n            flex-flow: column;\n        }\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"subscription-active\" ng-if=\"vm.currentSubscriptionStatus==\'ACTIVE\' && vm.activePackage\"><div class=\"centerBox\">اشتراک شما تا تاریخ <strong>{{vm.activePackage.expireDate | toPersianDate}} </strong>فعال است<br><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet></leaflet></div>--><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet-directive></leaflet-directive></div>--><div class=\"subscription-status-detail\"><span>{{\"tikonApp.SubscriptionType.\"+vm.activePackage.subscriptionPackage.subscriptionType| translate}} </span>- <span>{{vm.activePackage.subscriptionPackage.title}}</span> : <span>{{vm.activePackage.startDate | toPersianDate}} </span>- <span>{{vm.activePackage.expireDate | toPersianDate}}</span></div></div></div><div class=\"subscription-expired\" ng-if=\"vm.currentSubscriptionStatus==\'EXPIRED\'\"><div class=\"centerBox\" style=\"background-color: darkorange\"><strong>اشتراک شما به پایان رسیده است.</strong></div></div></div><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب بسته اشتراک</div><div class=\"row\"><div class=\"col-md-12 event-type\"><div class=\"event-type-box\" ng-click=\"vm.loadEventSubscriptionTypeList(\'WEBINAR\')\">وبینار</div><div class=\"event-type-box\" ng-click=\"vm.loadEventSubscriptionTypeList(\'CONFERENCE\')\">وب کنفرانس</div><div class=\"event-type-box\" ng-click=\"vm.loadEventSubscriptionTypeList(\'UNLIMITED\')\">کلاس آموزشی (نامحدود)</div></div></div><div class=\"row\"><div ng-repeat=\"ptype  in vm.subscriptionTypeList\"><div class=\"package-category\"><div><!--<div class=\"col-sm-2  \" data-ng-if=\"!vm.hasCustomSubscriptionType\" style=\"position: relative;\">--><!--<div class=\"category-title\">--><!--<div ng-class=\"ptype.type\">--><!--{{\"tikonApp.SubscriptionType.\"+ptype.type | translate}}--><!--</div>--><!--<div ng-class=\"vm.borderStyle(ptype.type)\">--><!--<div data-ng-if=\"ptype.type == \'BASIC\'\">--><!--<ul class=\"ul-box\">--><!--<div class=\"feature-list\">--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--تمامی امکانات سیستم--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--انتخاب--><!--<strong>--><!--1 امکان ویژه سیستم--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--رزرو--><!--<strong>--><!--نامحدود--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--ارسال پیامک یادآوری--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--<strong>--><!--150--><!--</strong>--><!--پیامک رایگان--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پشتیبانی 24 ساعته--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--حداکثر--><!--<strong>--><!--2 پرسنل--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پرسنل اضافه 15 هزار تومان--><!--</li>--><!--</div>--><!--</ul>--><!--</div>--><!--<div data-ng-if=\"ptype.type == \'ECONOMY\'\">--><!--<ul class=\"ul-box\">--><!--<div class=\"feature-list\">--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--تمامی امکانات سیستم--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--انتخاب--><!--<strong>--><!--4 امکان ویژه سیستم--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--رزرو--><!--<strong>--><!--نامحدود--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--ارسال پیامک یادآوری--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--<strong>--><!--300--><!--</strong>--><!--پیامک رایگان--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پشتیبانی 24 ساعته--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--حداکثر--><!--<strong>--><!--5 پرسنل--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پرسنل اضافه 10 هزار تومان--><!--</li>--><!--</div>--><!--</ul>--><!--</div>--><!--<div data-ng-if=\"ptype.type == \'ENTERPRISE\'\">--><!--<ul class=\"ul-box\">--><!--<div class=\"feature-list\">--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--تمامی امکانات سیستم--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--انتخاب--><!--<strong>--><!--تمامی امکانات ویژه--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--رزرو--><!--<strong>--><!--نامحدود--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--ارسال پیامک یادآوری--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--<strong>--><!--500--><!--</strong>--><!--پیامک رایگان--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پشتیبانی--><!--<strong>--><!--اختصاصی--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--حداکثر--><!--<strong>--><!--10 پرسنل--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پرسنل اضافه 8 هزار تومان--><!--</li>--><!--</div>--><!--</ul>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--></div><div class=\"col-sm-4\"><div class=\"package-box\"><md-card md-theme-watch class=\"package-card\" ng-class=\"vm.packageCardStyle(ptype)\"><md-card-title><md-card-title-text><span class=\"md-subhead\"><!--{{package.title}}--> {{\"tikonApp.SubscriptionType.\"+ptype.type | translate}} </span><span><ul class=\"ul-box\"><div ng-bind-html=\"vm.makeFeatureDesc(ptype)\" class=\"feature-list\"></div></ul></span></md-card-title-text></md-card-title><md-card-actions ng-if=\"!ptype.isSelected\" style=\"margin-top: 15px\"><md-button ng-class=\"vm.buttonClass(ptype.type)\" ng-click=\"vm.selectSubscriptionBaseType(ptype)\"><!--ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"--> <span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions><div ng-if=\"ptype.isSelected\" class=\"cardStatusIconContainer\"><i class=\"glyphicon glyphicon-ok-circle\" aria-hidden=\"true\"></i><!--<span>انتخاب شده</span>--></div></md-card></div></div></div></div></div><div id=\"periodSelection\" ng-if=\"vm.isAnyPackageSelected\"><hr><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب مدت زمان</div><div class=\"row period-package-box text-center\"><div ng-repeat=\"package  in vm.availablePackagePeriods\"><div class=\"col-sm-3\"><!--<div class=\"\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\">--><!--<ul class=\"ul-period-box\">--><!--<li>{{package.title}}</li>--><!--<li>{{package.chargeFee}}</li>--><!--<li>{{package.description}}</li>--><!--</ul>--><!--<md-button >--><!--<span class=\"glyphicon glyphicon-ok\"></span>--><!--انتخاب--><!--</md-button>--><!--</div>--><md-card md-theme-watch class=\"package-card-period\" style=\"min-height: 200px\" ng-class=\"vm.packageCardStyle(ptype)\"><md-card-title><md-card-title-text><span class=\"period-title\">{{package.title}} </span><span class=\"price\">{{package.chargeFee | number}} <small class=\"price_unit\">تومان </small></span><span class=\"period-discount\">{{package.description}}</span></md-card-title-text></md-card-title><md-card-actions style=\"margin-top: 15px\"><md-button class=\"select-period-button\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"><span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions></md-card><!--{{package}}--></div></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-status-view-v2.html","<style>.btn-show-feature {\n        background-color: #eaeaea;\n        color: #2b6b7f;\n        border: 1px solid #2b6b7f;\n    }\n\n    .btn-show-feature:hover {\n        background-color: #c3c3c3 !important;\n    }\n\n    .btn-all-feature:hover {\n        background-color: #2b6b7f;\n        /*color: white;*/\n    }\n\n    .btn-all-feature {\n        /*background-color: #73cac4;*/\n        color: #2b6b7f;\n        border: 1px solid #2b6b7f;\n    }\n\n    .feature-info {\n        font-size: 12px;\n    }\n\n    .special-feature-info {\n        display: flex;\n        justify-content: center;\n        gap: 8px;\n        padding: 10px 0;\n        flex-wrap: wrap;\n    }\n\n    .price {\n        font-size: 14px;\n        font-weight: bold;\n    }\n\n    .period-discount {\n        color: red;\n        background-color: #ff000017;\n        margin: 0 31px;\n        border-radius: 5px;\n        font-size: 13px;\n    }\n\n    .centerBox {\n        /*background-color: #4caf50;*/\n        margin: auto;\n        width: 300px;\n        padding: 8px 0;\n    }\n\n    .cardStatusIconContainer {\n        color: green;\n        font-weight: bold;\n        font-size: 30px;\n    }\n\n    .package-box {\n        text-align: center;\n        padding-right: 10px;\n    }\n\n    .period-package-box {\n        text-align: center;\n        padding-right: 10px;\n\n    }\n\n    .package-card, .package-card-period, .package-card-BASIC, .package-card-ECONOMY, .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        border-radius: 3px;\n        box-shadow: none;\n        min-height: 100px;\n    }\n\n    .package-card-period {\n        border-color: #2b6b7f;\n        min-height: 200px;\n    }\n\n    .price_unit {\n        font-size: 12px;\n        color: #0e5a41;\n    }\n\n    .package-category {\n        /*border-top: solid 2px #e4e4e1;*/\n        /*padding: 10px;*/\n        vertical-align: middle;\n        text-align: center;\n        margin: auto;\n    }\n\n    .category-title {\n\n        width: 170px;\n        color: #0e5a41;\n        /*margin-top: 30px;*/\n        margin-bottom: 10px;\n        font-size: 17px;\n        font-weight: bold;\n        text-align: center;\n\n    }\n\n    .subscription-status {\n        min-height: 100px;\n        width: 100%;\n\n    }\n\n    .subscription-active, .package-feature-list {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n\n        border-radius: 5px;\n        /*background: #4caf50;*/\n\n    }\n\n    .package-feature-list {\n        background-color: #eaeaea;\n        color: black;\n        font-size: 12px;\n    }\n\n    .subscription-expired {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n        background: darkorange;\n        border-radius: 5px;\n\n    }\n\n    .subscription-status-detail {\n        text-align: center;\n        /*color: #f1ffd6;*/\n        font-size: 12px;\n    }\n\n    .feature-list {\n        font-size: 12px;\n        color: #001b24;\n        text-align: right;\n        padding-top: 14px;\n        font-weight: normal;\n        /*padding-right: 18px;*/\n    }\n\n    .basic-package-box {\n        background-color: #f3fdff;\n    }\n\n    .ul-box {\n        padding-right: 20px;\n    }\n\n    .ul-period-box {\n        padding-right: 20px;\n    }\n\n    .ul-box li:before {\n        content: \'✓\';\n        color: #00AA00;\n    }\n\n    .md-subhead {\n        font-size: 20px !important;\n        font-weight: 600 !important;\n    }\n\n    .BASIC {\n        color: #73cac4;\n    }\n\n    .ECONOMY {\n        color: darkorange;\n    }\n\n    .ENTERPRISE {\n        color: #019fde;\n    }\n\n    .btn-BASIC {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-ECONOMY {\n        background-color: darkorange;\n        color: #ffffff;\n    }\n\n    .btn-ENTERPRISE {\n        background-color: #019fde;\n        color: #ffffff;\n    }\n\n    .btn-DEFAULT {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-BASIC:hover {\n        color: #73cac4;\n\n    }\n\n    .btn-ECONOMY:hover {\n        color: darkorange;\n\n    }\n\n    .btn-ENTERPRISE:hover {\n        color: #019fde;\n    }\n\n    .package-card-BASIC {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .package-card-ECONOMY {\n        background-color: #ffffff;\n        border-color: darkorange;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #019fde;\n        border-style: solid;\n        border-width: thin;\n        min-height: 300px;\n    }\n\n    .border-BASIC {\n        border-color: #73cac4;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ECONOMY {\n        border-color: darkorange;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ENTERPRISE {\n        border-color: #019fde;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .discount-box {\n        position: absolute;\n        left: 11px;\n        top: 20px;\n        font-weight: bold;\n        color: white;\n        border-bottom: 18px solid #fd301b;\n        border-left: 10px solid transparent;\n        border-right: 38px solid transparent;\n        height: 0;\n        width: 134px;\n        transform: rotate(-26deg);\n    }\n\n    .package-card-not-selected {\n        color: #c3c2c2;\n        border-color: #eeeeee;\n    }\n\n    .btn-not-selected {\n        background-color: #cecece;\n        color: #ffffff;\n    }\n\n    .package-period {\n        border: 1px solid gray;\n        border-radius: 5px;\n        padding: 20px;\n\n    }\n\n    .select-period-button {\n        background-color: #2b6b7f;\n        color: #ffffff;\n    }\n\n    .select-period-button:hover {\n        color: #2b6b7f;\n    }\n\n    .period-title {\n        font-size: 16px;\n    }\n\n    @media (max-width: 767px) {\n        .discount-box {\n            top: 12px;\n        }\n    }</style><div class=\"container-fluid\"><div ng-if=\"vm.isNativeApp != \'true\'\"><div class=\"row\"><div class=\"subscription-active\" ng-if=\"vm.currentSubscriptionStatus==\'ACTIVE\' && vm.activePackage\"><div class=\"centerBox\">اشتراک شما تا تاریخ <strong>{{vm.activePackage.expireDate | toPersianDate}} </strong>فعال است<br><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet></leaflet></div>--><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet-directive></leaflet-directive></div>--><div class=\"subscription-status-detail\"><span>{{\"tikonApp.SubscriptionType.\"+vm.activePackage.subscriptionPackage.subscriptionType| translate}} </span>- <span>{{vm.activePackage.subscriptionPackage.title}}</span><!--:--><!--<span>--><!--{{vm.activePackage.startDate | toPersianDate}}--><!--</span>--><!-- - --><!--<span>--><!--{{vm.activePackage.expireDate | toPersianDate}}--><!--</span>--></div></div><div class=\"feature-info\"><span ng-if=\"vm.packageFeatureList.featureInfoObject.servantCount\" style=\"padding-left: 20px\">تعداد پرسنل : {{vm.packageFeatureList.featureInfoObject.servantCount}}</span><md-button class=\"btn-show-feature\" ng-click=\"vm.showFeaturesClick()\">مشاهده امکانات ویژه فعال</md-button><span><!--تعداد امکان ویژه قابل استفاده--><!--: {{vm.packageFeatureList.featureInfoObject.specialFeatureCount}}--></span></div></div><div class=\"package-feature-list\" ng-if=\"vm.currentSubscriptionStatus==\'ACTIVE\' && vm.activePackage && vm.showFeatures\"><div class=\"\"><div id=\"packageFeatureList\"><div style=\"font-size: 18px\">امکانات ویژه فعال</div><div id=\"specialFeatureInfo\" class=\"special-feature-info\"><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.twoStepVerification\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.twoStepVerification\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.dedicateDomain\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.dedicateDomain\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_SMS\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.satisfactionMessage_SMS\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_Email\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.satisfactionMessage_Email\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.widget\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.widget\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.notifyReserveToServant\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.notifyReserveToServant\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.smsTextEdit\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.smsTextEdit\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.servantLogin\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.servantLogin\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.intakeForm\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.intakeForm\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.uploadFile\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.uploadFile\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.cancelReserveByCustomer\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.cancelReserveByCustomer\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.daftareShoma\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.daftareShoma\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.autoMultiReserveMode\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.autoMultiReserveMode\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.couponCode\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.couponCode\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerGroup\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerGroup\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerAccess\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerAccess\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.reservePattern\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.reservePattern\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.serviceWithoutServant\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.serviceWithoutServant\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customPricingForServant\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customPricingForServant\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.recordOnlineMeeting\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.recordOnlineMeeting\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.reserveLimit\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.reserveLimit\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerRebookReminder_SMS\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerRebookReminder_SMS\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerSecondReminder\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.customerSecondReminder\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.advancedPricing\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.advancedPricing\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.whatsAppSupport\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.whatsAppSupport\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.servantServiceScheduling\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.servantServiceScheduling\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.serviceCapacity\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.serviceCapacity\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.invoice\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.invoice\"| translate}}</div><div class=\"special-feature-info-item\" ng-if=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.marketingCampaign\"><span class=\"glyphicon glyphicon-ok\"></span> {{\"tikonApp.packageFeatureList.specialFeatureInfo.marketingCampaign\"| translate}}</div></div><md-button class=\"btn-all-feature\" href=\"https://planovin.com/allfeatures\" target=\"_blank\">مشاهده تمامی امکانات ویژه</md-button></div></div></div><div class=\"subscription-expired\" ng-if=\"vm.currentSubscriptionStatus==\'EXPIRED\'\"><div class=\"centerBox\" style=\"background-color: darkorange\"><strong>اشتراک شما به پایان رسیده است.</strong></div></div></div><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب بسته اشتراک</div><div class=\"row\"><div ng-repeat=\"ptype  in vm.subscriptionTypeList\"><div class=\"package-category\"><div><!--<div class=\"col-sm-2  \" data-ng-if=\"!vm.hasCustomSubscriptionType\" style=\"position: relative;\">--><!--<div class=\"category-title\">--><!--<div ng-class=\"ptype.type\">--><!--{{\"tikonApp.SubscriptionType.\"+ptype.type | translate}}--><!--</div>--><!--<div ng-class=\"vm.borderStyle(ptype.type)\">--><!--<div data-ng-if=\"ptype.type == \'BASIC\'\">--><!--<ul class=\"ul-box\">--><!--<div class=\"feature-list\">--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--تمامی امکانات سیستم--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--انتخاب--><!--<strong>--><!--1 امکان ویژه سیستم--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--رزرو--><!--<strong>--><!--نامحدود--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--ارسال پیامک یادآوری--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--<strong>--><!--150--><!--</strong>--><!--پیامک رایگان--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پشتیبانی 24 ساعته--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--حداکثر--><!--<strong>--><!--2 پرسنل--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پرسنل اضافه 15 هزار تومان--><!--</li>--><!--</div>--><!--</ul>--><!--</div>--><!--<div data-ng-if=\"ptype.type == \'ECONOMY\'\">--><!--<ul class=\"ul-box\">--><!--<div class=\"feature-list\">--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--تمامی امکانات سیستم--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--انتخاب--><!--<strong>--><!--4 امکان ویژه سیستم--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--رزرو--><!--<strong>--><!--نامحدود--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--ارسال پیامک یادآوری--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--<strong>--><!--300--><!--</strong>--><!--پیامک رایگان--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پشتیبانی 24 ساعته--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--حداکثر--><!--<strong>--><!--5 پرسنل--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پرسنل اضافه 10 هزار تومان--><!--</li>--><!--</div>--><!--</ul>--><!--</div>--><!--<div data-ng-if=\"ptype.type == \'ENTERPRISE\'\">--><!--<ul class=\"ul-box\">--><!--<div class=\"feature-list\">--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--تمامی امکانات سیستم--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--انتخاب--><!--<strong>--><!--تمامی امکانات ویژه--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--رزرو--><!--<strong>--><!--نامحدود--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--ارسال پیامک یادآوری--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--<strong>--><!--500--><!--</strong>--><!--پیامک رایگان--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پشتیبانی--><!--<strong>--><!--اختصاصی--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--حداکثر--><!--<strong>--><!--10 پرسنل--><!--</strong>--><!--</li>--><!--<li>--><!--<span style=\"color: #00AA00\">&#10004;</span>--><!--پرسنل اضافه 8 هزار تومان--><!--</li>--><!--</div>--><!--</ul>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--></div><div class=\"col-sm-4\"><div class=\"package-box\"><md-card md-theme-watch class=\"package-card\" ng-class=\"vm.packageCardStyle(ptype)\"><md-card-title><md-card-title-text><span class=\"md-subhead\"><!--{{package.title}}--> {{\"tikonApp.SubscriptionType.\"+ptype.type | translate}} </span><span><ul class=\"ul-box\"><div ng-bind-html=\"vm.makeFeatureDesc(ptype)\" class=\"feature-list\"></div></ul></span></md-card-title-text></md-card-title><md-card-actions ng-if=\"!ptype.isSelected\" style=\"margin-top: 15px\"><md-button ng-class=\"vm.buttonClass(ptype.type)\" ng-click=\"vm.selectSubscriptionBaseType(ptype)\"><!--ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"--> <span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions><div ng-if=\"ptype.isSelected\" class=\"cardStatusIconContainer\"><i class=\"glyphicon glyphicon-ok-circle\" aria-hidden=\"true\"></i><!--<span>انتخاب شده</span>--></div></md-card></div></div></div></div></div><div id=\"periodSelection\" ng-if=\"vm.isAnyPackageSelected\"><hr><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب مدت زمان</div><div class=\"row period-package-box text-center\"><div ng-repeat=\"package  in vm.availablePackagePeriods\"><div class=\"col-sm-3\"><!--<div class=\"\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\">--><!--<ul class=\"ul-period-box\">--><!--<li>{{package.title}}</li>--><!--<li>{{package.chargeFee}}</li>--><!--<li>{{package.description}}</li>--><!--</ul>--><!--<md-button >--><!--<span class=\"glyphicon glyphicon-ok\"></span>--><!--انتخاب--><!--</md-button>--><!--</div>--><md-card md-theme-watch class=\"package-card-period\" style=\"min-height: 200px\" ng-class=\"vm.packageCardStyle(ptype)\"><md-card-title><md-card-title-text><span class=\"period-title\">{{package.title}} </span><span class=\"price\">{{package.chargeFee | number}} <small class=\"price_unit\">تومان </small></span><span class=\"period-discount\">{{package.description}}</span></md-card-title-text></md-card-title><md-card-actions style=\"margin-top: 15px\"><md-button class=\"select-period-button\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"><span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions></md-card><!--{{package}}--></div></div></div></div></div><div ng-if=\"vm.isNativeApp == \'true\'\"><div class=\"subscription-expired\" ng-if=\"vm.currentSubscriptionStatus==\'EXPIRED\'\"><div style=\"background-color: darkorange\"><strong>برای رفع مشکل دسترسی با پشتیبانی تماس بگیرید.</strong></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-status-view.html","<style>.centerBox {\n        /*background-color: #4caf50;*/\n        margin: auto;\n        width: 300px;\n        padding: 8px 0;\n    }\n\n    .cardStatusIconContainer {\n        position: absolute;\n        opacity: 0.1;\n        margin-left: 26px;\n        left: 0;\n    }\n\n    .package-box {\n        text-align: center;\n        padding-right: 10px;\n    }\n\n    .package-card {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n        border-radius: 3px;\n    }\n\n    .price_unit {\n        font-size: 12px;\n        color: #0e5a41;\n    }\n\n    .package-category {\n        border-top: solid 2px #e4e4e1;\n        padding: 10px;\n        vertical-align: middle;\n        text-align: center;\n        margin: auto;\n    }\n\n    .category-title {\n\n        width: 170px;\n        color: #0e5a41;\n        /*margin-top: 30px;*/\n        margin-bottom: 10px;\n        font-size: 17px;\n        font-weight: bold;\n        text-align: center;\n\n    }\n\n    .subscription-status {\n        min-height: 100px;\n        width: 100%;\n\n    }\n\n    .subscription-active {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n\n        border-radius: 5px;\n        /*background: #4caf50;*/\n\n    }\n\n    .subscription-expired {\n        color: white;\n        padding: 14px;\n        margin: 5px 5px 8px;\n        text-align: center;\n        font-size: 16px;\n        background: darkorange;\n        border-radius: 5px;\n\n    }\n\n    .subscription-status-detail {\n        text-align: center;\n        /*color: #f1ffd6;*/\n        font-size: 12px;\n    }\n\n    .feature-list {\n        font-size: 12px;\n        color: #001b24;\n        text-align: right;\n        padding-top: 14px;\n        font-weight: normal;\n        /*padding-right: 18px;*/\n    }\n\n    .basic-package-box {\n        background-color: #f3fdff;\n    }\n\n    .ul-box {\n        padding-right: 20px;\n    }\n\n    .BASIC {\n        color: #73cac4;\n    }\n\n    .ECONOMY {\n        color: darkorange;\n    }\n\n    .ENTERPRISE {\n        color: #019fde;\n    }\n\n    .btn-BASIC {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-ECONOMY {\n        background-color: darkorange;\n        color: #ffffff;\n    }\n\n    .btn-ENTERPRISE {\n        background-color: #019fde;\n        color: #ffffff;\n    }\n\n    .btn-DEFAULT {\n        background-color: #73cac4;\n        color: #ffffff;\n    }\n\n    .btn-BASIC:hover {\n        color: #73cac4;\n\n    }\n\n    .btn-ECONOMY:hover {\n        color: darkorange;\n\n    }\n\n    .btn-ENTERPRISE:hover {\n        color: #019fde;\n    }\n\n    .package-card-BASIC {\n        background-color: #ffffff;\n        border-color: #73cac4;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .package-card-ECONOMY {\n        background-color: #ffffff;\n        border-color: darkorange;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .package-card-ENTERPRISE {\n        background-color: #ffffff;\n        border-color: #019fde;\n        border-style: solid;\n        border-width: thin;\n    }\n\n    .border-BASIC {\n        border-color: #73cac4;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ECONOMY {\n        border-color: darkorange;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .border-ENTERPRISE {\n        border-color: #019fde;\n        border-top-style: solid;\n        margin-top: 10px;\n        /*border-width: thin;*/\n    }\n\n    .discount-box {\n        position: absolute;\n        left: 11px;\n        top: 20px;\n        font-weight: bold;\n        color: white;\n        border-bottom: 18px solid #fd301b;\n        border-left: 10px solid transparent;\n        border-right: 38px solid transparent;\n        height: 0;\n        width: 134px;\n        transform: rotate(-26deg);\n    }\n\n    @media (max-width: 767px) {\n        .discount-box {\n            top: 12px;\n        }\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"subscription-active\" ng-if=\"vm.currentSubscriptionStatus==\'ACTIVE\' && vm.activePackage\"><div class=\"centerBox\">اشتراک شما تا تاریخ <strong>{{vm.activePackage.expireDate | toPersianDate}} </strong>فعال است<br><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet></leaflet></div>--><!--<div style=\"width: 300px; height: 300px; border: 1px solid red;\"><leaflet-directive></leaflet-directive></div>--><div class=\"subscription-status-detail\"><span>{{\"tikonApp.SubscriptionType.\"+vm.activePackage.subscriptionPackage.subscriptionType| translate}} </span>- <span>{{vm.activePackage.subscriptionPackage.title}}</span> : <span>{{vm.activePackage.startDate | toPersianDate}} </span>- <span>{{vm.activePackage.expireDate | toPersianDate}}</span></div></div></div><div class=\"subscription-expired\" ng-if=\"vm.currentSubscriptionStatus==\'EXPIRED\'\"><div class=\"centerBox\" style=\"background-color: darkorange\"><strong>اشتراک شما به پایان رسیده است.</strong></div></div></div><div class=\"row\"><span class=\"glyphicon glyphicon-list\" style=\"padding-right: 5px\"></span> انتخاب بسته اشتراک</div><div ng-repeat=\"ptype  in vm.subscriptionTypeList\"><div class=\"row package-category\"><div class=\"col-sm-2\" data-ng-if=\"!vm.hasCustomSubscriptionType\" style=\"position: relative\"><div class=\"category-title\"><div ng-class=\"ptype.type\">{{\"tikonApp.SubscriptionType.\"+ptype.type | translate}}</div><div ng-class=\"vm.borderStyle(ptype.type)\"><div data-ng-if=\"ptype.type == \'BASIC\'\"><ul class=\"ul-box\"><div class=\"feature-list\"><li><span style=\"color: #00AA00\">&#10004;</span> تمامی امکانات سیستم</li><li><span style=\"color: #00AA00\">&#10004;</span> انتخاب <strong>1 امکان ویژه سیستم</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> رزرو <strong>نامحدود</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> ارسال پیامک یادآوری</li><li><span style=\"color: #00AA00\">&#10004;</span> <strong>150 </strong>پیامک رایگان</li><li><span style=\"color: #00AA00\">&#10004;</span> پشتیبانی 24 ساعته</li><li><span style=\"color: #00AA00\">&#10004;</span> حداکثر <strong>2 پرسنل</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> پرسنل اضافه 15 هزار تومان</li></div></ul></div><div data-ng-if=\"ptype.type == \'ECONOMY\'\"><ul class=\"ul-box\"><div class=\"feature-list\"><li><span style=\"color: #00AA00\">&#10004;</span> تمامی امکانات سیستم</li><li><span style=\"color: #00AA00\">&#10004;</span> انتخاب <strong>4 امکان ویژه سیستم</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> رزرو <strong>نامحدود</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> ارسال پیامک یادآوری</li><li><span style=\"color: #00AA00\">&#10004;</span> <strong>300 </strong>پیامک رایگان</li><li><span style=\"color: #00AA00\">&#10004;</span> پشتیبانی 24 ساعته</li><li><span style=\"color: #00AA00\">&#10004;</span> حداکثر <strong>5 پرسنل</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> پرسنل اضافه 10 هزار تومان</li></div></ul></div><div data-ng-if=\"ptype.type == \'ENTERPRISE\'\"><ul class=\"ul-box\"><div class=\"feature-list\"><li><span style=\"color: #00AA00\">&#10004;</span> تمامی امکانات سیستم</li><li><span style=\"color: #00AA00\">&#10004;</span> انتخاب <strong>تمامی امکانات ویژه</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> رزرو <strong>نامحدود</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> ارسال پیامک یادآوری</li><li><span style=\"color: #00AA00\">&#10004;</span> <strong>500 </strong>پیامک رایگان</li><li><span style=\"color: #00AA00\">&#10004;</span> پشتیبانی <strong>اختصاصی</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> حداکثر <strong>10 پرسنل</strong></li><li><span style=\"color: #00AA00\">&#10004;</span> پرسنل اضافه 8 هزار تومان</li></div></ul></div></div></div></div><div class=\"col-sm-10\"><div class=\"row\"><div class=\"col-sm-4\" ng-repeat=\"package in ptype.packages\"><div class=\"package-box\"><md-card md-theme-watch class=\"package-card\" ng-class=\"vm.packageCardStyle(ptype.type)\"><md-card-title><md-card-title-text><span class=\"md-subhead\">{{package.title}}</span> <span class=\"md-headline\">{{package.chargeFee | number:0 }} <small class=\"price_unit\">تومان </small></span><span><div ng-if=\"package.description\"><div class=\"discount-box\">{{package.description}}</div></div></span></md-card-title-text></md-card-title><md-card-actions style=\"margin-top: 15px\"><md-button ng-class=\"vm.buttonClass(ptype.type)\" ui-sref=\"supplierPanel.purchaseSubscription({id:package.id})\"><span class=\"glyphicon glyphicon-ok\"></span> انتخاب</md-button></md-card-actions><div class=\"cardStatusIconContainer\"><i class=\"fa fa-gift fa-2x\" aria-hidden=\"true\"></i></div></md-card></div></div></div></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/company-subscription-statuses.html","<div><h2 translate=\"tikonApp.companySubscriptionStatus.home.title\">Company Subscription Statuses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company-subscription-status.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.companySubscriptionStatus.home.createLabel\">Create</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.companySubscriptionStatus.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.companySubscriptionStatus.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"tikonApp.companySubscriptionStatus.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expireDate\"><span translate=\"tikonApp.companySubscriptionStatus.expireDate\">Expire Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"wageFeePercentage\"><span translate=\"tikonApp.companySubscriptionStatus.wageFeePercentage\">Wage Fee Percentage</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"status\"><span translate=\"tikonApp.companySubscriptionStatus.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"moneyTransferLogId\"><span translate=\"tikonApp.companySubscriptionStatus.moneyTransferLog\">Money Transfer Log</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subscriptionPackageId\"><span translate=\"tikonApp.companySubscriptionStatus.subscriptionPackage\">Subscription Package</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span translate=\"tikonApp.companySubscriptionStatus.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companySubscriptionStatus in vm.companySubscriptionStatuses track by companySubscriptionStatus.id\"><td><a ui-sref=\"company-subscription-status-detail({id:companySubscriptionStatus.id})\">{{companySubscriptionStatus.id}}</a></td><td>{{companySubscriptionStatus.createDate | toPersianDate}}</td><td>{{companySubscriptionStatus.startDate | toPersianDate}}</td><td>{{companySubscriptionStatus.expireDate | toPersianDate}}</td><!--<td>{{companySubscriptionStatus.wageFeePercentage}}</td>--><td translate=\"{{\'tikonApp.SubscriptionStatus.\' + companySubscriptionStatus.status}}\">{{companySubscriptionStatus.status}}</td><td>{{companySubscriptionStatus.moneyTransferLog.status}}</td><td>{{companySubscriptionStatus.subscriptionPackage.title}} {{\'tikonApp.SubscriptionType.\' + companySubscriptionStatus.subscriptionPackage.subscriptionType | translate}}</td><td>{{companySubscriptionStatus.company.title}} ({{companySubscriptionStatus.company.keyUrl}})</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-subscription-status-detail({id:companySubscriptionStatus.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company-subscription-status.edit({id:companySubscriptionStatus.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company-subscription-status.delete({id:companySubscriptionStatus.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/company-subscription-status/confirm-subscription.html","<style>.fail {\n        border: thin solid #ff0000;\n        color: red;\n        box-shadow: 0px 0px 4px red;\n    }</style><div><!--<h2><span translate=\"tikonApp.companySubscriptionStatus.detail.title\">Company Subscription Status</span>--><!--{{vm.companySubscriptionStatus.id}}</h2>--><!--<hr>--><jhi-alert-error></jhi-alert-error><div ng-if=\"vm.isPayed\"><div class=\"panel panel-success\"><div class=\"panel-heading\"><span>خرید اشتراک با موفقیت انجام شد</span></div><div class=\"panel-body\"><div><table class=\"table table-striped\"><thead><tr><th><span translate=\"tikonApp.subscriptionPackage.title\"></span></th><th ng-if=\"!vm.isSMSPAckage\"><span translate=\"tikonApp.companySubscriptionStatus.startDate\"></span></th><th ng-if=\"!vm.isSMSPAckage\"><span translate=\"tikonApp.companySubscriptionStatus.expireDate\"></span></th><th ng-if=\"vm.isSMSPAckage\"><span translate=\"tikonApp.companySubscriptionStatus.smsCountCharge\"></span></th><th><span translate=\"tikonApp.companySubscriptionStatus.chargeFee\"></span></th></tr></thead><tbody><tr ng-repeat=\"package in vm.companySubscriptionStatusList\"><td>{{package.subscriptionPackage.title}}</td><td ng-if=\"!vm.isSMSPAckage\">{{package.startDate | toPersianDate}}</td><td ng-if=\"!vm.isSMSPAckage\">{{package.expireDate | toPersianDate}}</td><td ng-if=\"vm.isSMSPAckage\">{{package.subscriptionPackage.smsCountCharge}} <span translate=\"tikonApp.companySubscriptionStatus.sms\"></span></td><td>{{package.companyInvoiceInfo.finalPrice}} تومان</td></tr></tbody></table></div></div></div></div><div ng-if=\"vm.isPayed==true\"><div ng-if=\"!vm.isSMSPAckage\" class=\"panel panel-default\"><!-- Add Panel Heading Here --><div class=\"panel-body\">پرداخت با موفقیت انجام شد. لطفا مجددا وارد شوید . <button class=\"btn btn-primary pl-btn-primary\" data-ng-click=\"vm.showLogin()\">ورود</button></div></div><div ng-if=\"vm.isSMSPAckage\" class=\"panel panel-default\"><!-- Add Panel Heading Here --><div class=\"panel-body panel-body-subscription\">پرداخت با موفقیت انجام شد و بسته پیامکی اضافه شد.</div></div></div><div ng-if=\"vm.isPayed==false  \"><div class=\"panel panel-default\"><!-- Add Panel Heading Here --><div class=\"panel-body panel-body-subscription fail\">خطا در انجام عملیات پرداخت .لطفا مجدد اقدام به خرید اشتراک فرمایید</div></div></div><!--<button type=\"submit\"--><!--onclick=\"window.history.back()\"--><!--class=\"btn btn-info\">--><!--<span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span>--><!--</button>--></div>");
$templateCache.put("app/entities/company-subscription-status/purchase-subscription-v2.html","<style>.price-on-button {\n        font-size: 18px;\n        color: #f9dba5;\n        line-height: 29px;\n    }\n\n    .invoice {\n        width: 60%;\n        margin: auto;\n        align-content: space-between;\n        line-height: 3;\n        /*border: 1px solid gray;*/\n        /*border-radius: 5px;*/\n        padding: 10px;\n        text-align: center;\n    }\n\n    .odd-row {\n        background-color: #dcdfe2;\n    }\n\n    .even-row {\n        background-color: white;\n    }\n\n    .final-price-row {\n        background-color: #e3f7e3;\n    }\n\n    .coupon-code {\n        width: 50%;\n        margin: auto;\n        padding-bottom: 20px\n    }\n\n    @media (max-width: 768px) {\n        .invoice {\n            width: 90%;\n        }\n\n        .coupon-code {\n            width: 90%;\n        }\n\n    }</style><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><jhi-alert-error></jhi-alert-error><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span>بسته انتخاب شده</span></div><div class=\"panel-body\"><div class=\"invoice\"><div class=\"row odd-row\"><div class=\"col-md-6 col-xs-6\"><span translate=\"tikonApp.subscriptionPackage.title\"></span></div><div class=\"col-md-6 col-xs-6\">{{vm.subscriptionPackage.title}} - {{\'tikonApp.SubscriptionType.\' + vm.subscriptionPackage.subscriptionType | translate}}<!--اشتراک سالیانه - اقتصادی--></div></div><div class=\"row even-row\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">مدت(روز)</div><div class=\"col-md-6 col-xs-6\">{{vm.subscriptionPackage.durationDays}}</div></div><div class=\"row even-row\" ng-if=\"vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">تعداد پیامک</div><div class=\"col-md-6 col-xs-6\">{{vm.subscriptionPackage.smsCountCharge}}</div></div><div class=\"row odd-row\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">قیمت</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice | number:0}} تومان</div></div><div class=\"row even-row\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">تخفیف</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.discount | number:0}} تومان</div></div><div class=\"row odd-row\" ng-if=\"vm.companySubscriptionStatus.companyInvoiceInfo.vat\"><div class=\"col-md-6 col-xs-6\">ارزش افزوده</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.vat | number:0}} تومان</div></div><div class=\"row final-price-row\" style=\"font-weight: bold\"><div class=\"col-md-6 col-xs-6\">قیمت نهایی</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice | number:0}} تومان</div></div></div><div id=\"couponCode\" class=\"row coupon-code\" style=\"margin: auto\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-8 col-xs-8\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.companySubscriptionStatus.couponCodeToValidate\"></div><div class=\"text-success\" ng-if=\"vm.couponResult.resultStatus==\'DONE\'\"><span>کد تخفیف </span>{{vm.couponResult.supplierCoupon.couponCode}} <span>با موفقیت اعمال شد</span></div></div><div class=\"col-md-4 col-xs-4\"><md-button class=\"md-raised align-bottom\" ng-click=\"vm.checkCouponCode()\" style=\"margin-top: 33px\"><span translate=\"tikonApp.supplierCoupon.evaluateCoupon\">couponCode</span></md-button></div></div><div id=\"billingInfo\" class=\"coupon-code\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.issueBill\" ng-change=\"vm.issueBillCheckChange()\">برای این خرید فاکتور رسمی صادر شود</md-checkbox></div></div></div></div><div style=\"text-align: center\"><button class=\"btn-lg pl-btn pl-btn-primary\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.insertCompanySubscription()\"><div ng-if=\"vm.isSaving\" style=\"color: black\">در حال انتقال به درگاه ...</div><div ng-if=\"!vm.isSaving\">تائید و پرداخت آنلاین<br><span class=\"price-on-button\">{{ vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice | number:0}} تومان</span></div></button></div></div></div></div></div>");
$templateCache.put("app/entities/company-subscription-status/purchase-subscription.html","<style>.price-on-button {\n        font-size: 18px;\n        color: #f9dba5;\n        line-height: 29px;\n    }\n\n    .invoice {\n        width: 60%;\n        margin: auto;\n        align-content: space-between;\n        line-height: 3;\n        /*border: 1px solid gray;*/\n        /*border-radius: 5px;*/\n        padding: 10px;\n        text-align: center;\n    }\n\n    .odd-row {\n        background-color: #dcdfe2;\n    }\n\n    .even-row {\n        background-color: white;\n    }\n\n    .final-price-row {\n        background-color: #e3f7e3;\n    }\n\n    .coupon-code {\n        width: 50%;\n        margin: auto;\n        padding-bottom: 20px\n    }\n\n    @media (max-width: 768px) {\n        .invoice {\n            width: 90%;\n        }\n\n        .coupon-code {\n            width: 90%;\n        }\n\n    }</style><div><jhi-alert-error></jhi-alert-error><!--<h2><span translate=\"tikonApp.companySubscriptionStatus.detail.title\">Company Subscription Status</span>--><!--{{vm.companySubscriptionStatus.id}}</h2>--><!--<hr>--><!--<hr>--><!--<jhi-alert-error></jhi-alert-error>--><div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>بسته انتخاب شده</span></div><div class=\"panel-body\"><!--<div class=\"row\">--><!--<div class=\"col-md-6\">--><!--<table class=\"table table-striped\">--><!--<thead>--><!--<tr>--><!--<th><span translate=\"tikonApp.subscriptionPackage.title\"></span></th>--><!--<th ng-if=\"!vm.isSMSPAckage\"><span translate=\"tikonApp.subscriptionPackage.subscriptionType\"></span></th>--><!--<th ng-if=\"!vm.isSMSPAckage\" ><span translate=\"tikonApp.subscriptionPackage.durationDays\"></span>--><!--<i translate=\"tikonApp.subscriptionPackage.dayBracket\"></i>--><!--</th>--><!--<th></th>--><!--<th><span translate=\"tikonApp.subscriptionPackage.chargeFee\"></span>--><!--<i translate=\"global.currencyBracket\"></i>--><!--</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"package in vm.subscriptionPackages\">--><!--<td>--><!--{{package.title}}--><!--</td>--><!--<td ng-if=\"!vm.isSMSPAckage\" translate=\"{{\'tikonApp.SubscriptionType.\' + package.subscriptionType}}\">--><!--{{package.subscriptionType}}--><!--</td>--><!--<td ng-if=\"!vm.isSMSPAckage\">--><!--{{package.durationDays}}--><!--</td>--><!--&lt;!&ndash;<td>&ndash;&gt;--><!--&lt;!&ndash;{{package.chargeFee | number}}&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><div class=\"invoice\"><div class=\"row odd-row\"><div class=\"col-md-6 col-xs-6\"><span translate=\"tikonApp.subscriptionPackage.title\"></span></div><div class=\"col-md-6 col-xs-6\">{{vm.subscriptionPackage.title}} - {{\'tikonApp.SubscriptionType.\' + vm.subscriptionPackage.subscriptionType | translate}}<!--اشتراک سالیانه - اقتصادی--></div></div><div class=\"row even-row\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">مدت(روز)</div><div class=\"col-md-6 col-xs-6\">{{vm.subscriptionPackage.durationDays}}</div></div><div class=\"row even-row\" ng-if=\"vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">تعداد پیامک</div><div class=\"col-md-6 col-xs-6\">{{vm.subscriptionPackage.smsCountCharge}}</div></div><div class=\"row odd-row\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">قیمت</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice | number:0}} تومان</div></div><div class=\"row even-row\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-6 col-xs-6\">تخفیف</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.discount | number:0}} تومان</div></div><div class=\"row final-price-row\" style=\"font-weight: bold\"><div class=\"col-md-6 col-xs-6\">قیمت نهایی</div><div class=\"col-md-6 col-xs-6\">{{vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice | number:0}} تومان</div></div></div><div id=\"couponCode\" class=\"row coupon-code\" ng-if=\"!vm.isSMSPAckage\"><div class=\"col-md-8 col-xs-8\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.companySubscriptionStatus.couponCodeToValidate\"></div><div class=\"text-success\" ng-if=\"vm.couponResult.resultStatus==\'DONE\'\"><span>کد تخفیف </span>{{vm.couponResult.supplierCoupon.couponCode}} <span>با موفقیت اعمال شد</span></div></div><div class=\"col-md-4 col-xs-4\"><md-button class=\"md-raised align-bottom\" ng-click=\"vm.checkCouponCode()\" style=\"margin-top: 33px\"><!--<span translate=\"entity.action.backToReserveList\">--><!--entity.action.backToReserveList--><!--</span>--> <span translate=\"tikonApp.supplierCoupon.evaluateCoupon\">couponCode</span></md-button></div></div><div style=\"text-align: center\"><button class=\"btn-primary btn-lg\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.insertCompanySubscription()\"><div ng-if=\"vm.isSaving\" style=\"color: black\">در حال انتقال به درگاه ...</div><div ng-if=\"!vm.isSaving\">تائید و پرداخت آنلاین<br><span class=\"price-on-button\">{{ vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice | number:0}} تومان</span></div></button></div></div></div></div><!--<button type=\"submit\"--><!--onclick=\"window.history.back()\"--><!--class=\"btn btn-info\">--><!--<span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span>--><!--</button>--></div>");
$templateCache.put("app/entities/conversation/conversation-custom-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myConversationLabel\" data-translate=\"tikonApp.conversation.home.createOrEditLabel\">Create or edit a Conversation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--<div class=\"form-group\" ng-show=\"vm.conversation.id\">--><!--<label for=\"id\" data-translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"vm.conversation.id\" readonly />--><!--</div>--><div id=\"conversationSummary\"><div class=\"panel panel-success\"><div class=\"panel-heading\"><span translate=\"tikonApp.conversation.conversationSummary\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><span translate=\"tikonApp.conversation.fromPerson\"></span> : {{vm.conversation.fromPerson.fisrtName}} {{vm.conversation.fromPerson.lastName}}</div><div class=\"col-md-2\"><span translate=\"tikonApp.conversation.createDate\"></span> : {{vm.conversation.createDate | toPersianDate}}</div><div class=\"col-md-2\"><span translate=\"tikonApp.conversation.status\"></span> :<td data-translate=\"{{\'tikonApp.ConversationStatusType.\' + conversation.status}}\">{{conversation.status}}</td></div><div class=\"col-md-5\"><span translate=\"tikonApp.conversation.subject\"></span> : {{vm.conversation.subject}}</div></div></div></div></div><div id=\"messages\"><div ng-repeat=\"message in vm.conversation.messages track by message.id\"><div ng-class=\"vm.findMessageStyle(message.senderType)\"><div class=\"row\"><div class=\"col-md-10\"><div>{{vm.senderName(message)}} :</div></div><div class=\"col-sm-2\"><div style=\"font-size: 10px\">{{message.createDate | toPersianTime}} - {{message.createDate | toPersianDate}}</div></div></div><div>{{message.content }}</div></div></div></div><div id=\"sendNewMessage\"><div class=\"form-group\"><label class=\"control-label\" for=\"newMessage\" translate=\"tikonApp.conversation.newMessage\">Message</label><textarea type=\"text\" class=\"form-control\" id=\"newMessage\" name=\"newMessage\" rows=\"5\" placeholder=\"{{\'tikonApp.conversation.newMessage\' | translate}}\" ng-model=\"vm.newMessage\">\n                </textarea></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/conversation/conversation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.conversation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"tikonApp.conversation.delete.question\" translate-values=\"{id: \'{{vm.conversation.id}}\'}\">Are you sure you want to delete this Conversation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/conversation/conversation-detail.html","<div><h2><span data-translate=\"tikonApp.conversation.detail.title\">Conversation</span> {{vm.conversation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"tikonApp.conversation.status\">Status</span></dt><dd><span data-translate=\"{{\'tikonApp.ConversationStatusType.\' + vm.conversation.status}}\">{{vm.conversation.status}}</span></dd><dt><span data-translate=\"tikonApp.conversation.createDate\">Create Date</span></dt><dd><span>{{vm.conversation.createDate | date:\'medium\'}}</span></dd><dt><span data-translate=\"tikonApp.conversation.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.conversation.companyId})\">{{vm.conversation.companyId}}</a></dd><dt><span data-translate=\"tikonApp.conversation.relatedService\">Related Service</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.conversation.relatedServiceId})\">{{vm.conversation.relatedServiceId}}</a></dd><dt><span data-translate=\"tikonApp.conversation.fromPerson\">From Person</span></dt><dd><a ui-sref=\"person-info-detail({id:vm.conversation.fromPersonId})\">{{vm.conversation.fromPersonId}}</a></dd><dt><span data-translate=\"tikonApp.conversation.toPerson\">To Person</span></dt><dd><a ui-sref=\"person-info-detail({id:vm.conversation.toPersonId})\">{{vm.conversation.toPersonId}}</a></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"conversation-detail.edit({id:vm.conversation.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/conversation/conversation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myConversationLabel\" data-translate=\"tikonApp.conversation.home.createOrEditLabel\">Create or edit a Conversation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.conversation.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.conversation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.conversation.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.conversation.status\" id=\"field_status\"><option value=\"NEW\" data-translate=\"tikonApp.ConversationStatusType.NEW\">NEW</option><option value=\"OPEN\" data-translate=\"tikonApp.ConversationStatusType.OPEN\">OPEN</option><option value=\"RESOLVED\" data-translate=\"tikonApp.ConversationStatusType.RESOLVED\">RESOLVED</option></select></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.conversation.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.conversation.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label data-translate=\"tikonApp.conversation.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.conversation.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label data-translate=\"tikonApp.conversation.relatedService\" for=\"field_relatedService\">Related Service</label><select class=\"form-control\" id=\"field_relatedService\" name=\"relatedService\" ng-model=\"vm.conversation.relatedServiceId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div><div class=\"form-group\"><label data-translate=\"tikonApp.conversation.fromPerson\" for=\"field_fromPerson\">From Person</label><select class=\"form-control\" id=\"field_fromPerson\" name=\"fromPerson\" ng-model=\"vm.conversation.fromPersonId\" ng-options=\"personInfo.id as personInfo.id for personInfo in vm.personinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label data-translate=\"tikonApp.conversation.toPerson\" for=\"field_toPerson\">To Person</label><select class=\"form-control\" id=\"field_toPerson\" name=\"toPerson\" ng-model=\"vm.conversation.toPersonId\" ng-options=\"personInfo.id as personInfo.id for personInfo in vm.personinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/conversation/conversation-list.html","<div class=\"hidden-xs\"><h2 data-translate=\"tikonApp.conversation.home.title\">Conversations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><!--<div class=\"col-xs-4 no-padding-left\">--><!--<button class=\"btn btn-primary\" ui-sref=\"conversation.new\" >--><!--<span class=\"glyphicon glyphicon-plus\"></span>--><!--<span class=\"hidden-xs-down\"  data-translate=\"tikonApp.conversation.home.createLabel\">--><!--Create new Conversation--><!--</span>--><!--</button>--><!--</div>--><!--<div class=\"col-xs-8 no-padding-right\">--><!--<form name=\"searchForm\" class=\"form-inline\">--><!--<div class=\"input-group pull-right\" >--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.conversation.home.search\' | translate }}\">--><!--<span  class=\"input-group-btn width-min\" >--><!--<button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</button>--><!--</span>--><!--<span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\">--><!--<button class=\"btn btn-info\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-trash\"></span>--><!--</button>--><!--</span>--><!--</div>--><!--</form>--><!--</div>--></div></div><br><div class=\"table-responsive\"><table st-safe-src=\"vm.conversationList\" st-table=\"collection\" st-safe- class=\"jh-table table table-striped table-hover table-hover-custom\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control\" placeholder=\"{{ \'tikonApp.conversation.home.search\' | translate }}\" type=\"text\"></th></tr><!--<tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\">--><!--<th st-sort=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"fromPersonId\"><span data-translate=\"tikonApp.conversation.fromPerson\">From Person</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"createDate\"><span data-translate=\"tikonApp.conversation.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"companyId\"><span data-translate=\"tikonApp.conversation.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"status\"><span data-translate=\"tikonApp.conversation.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"subject\"><span data-translate=\"tikonApp.conversation.subject\">Subject</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"relatedServiceId\"><span data-translate=\"tikonApp.conversation.relatedService\">Related Service</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"toPersonId\"><span data-translate=\"tikonApp.conversation.toPerson\">To Person</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></thead><tbody><tr ng-class=\"vm.getSeeStatusStyle(conversation)\" class=\"clickable-row\" ui-sref=\"supplierPanel.conversationList.edit({id:conversation.id})\" ng-repeat=\"conversation in collection track by conversation.id\"><!--<td><a ui-sref=\"conversation-detail({id:conversation.id})\">{{conversation.id}}</a></td>--><td>{{conversation.fromPerson.fisrtName}} {{conversation.fromPerson.lastName}}</td><td>{{conversation.createDate | toPersianDate}}</td><td><div ng-class=\"vm.findStatusStyle(conversation.status)\"><span class=\"glyphicon glyphicon-stop\"></span> <span data-translate=\"{{\'tikonApp.ConversationStatusType.\' + conversation.status}}\">{{conversation.status}}</span></div></td><td>{{conversation.subject}}</td><td>{{conversation.relatedService.itemTitle}}</td><!--<td>--><!--<a ui-sref=\"person-info-detail({id:conversation.toPersonId})\">{{conversation.toPersonId}}</a>--><!--</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.conversationList.edit({id:conversation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div><div class=\"text-center\"><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--></div></div><div class=\"visible-xs\"><h4 style=\"padding-right: 10px\" data-translate=\"tikonApp.conversation.home.title\">Conversations</h4><jhi-alert></jhi-alert><div class=\"orderBag-mobile-block\" ng-class=\"vm.getSeeStatusStyle(conversation)\" ui-sref=\"supplierPanel.conversationList.edit({id:conversation.id})\" ng-repeat=\"conversation in collection track by conversation.id\"><!--<td><a ui-sref=\"conversation-detail({id:conversation.id})\">{{conversation.id}}</a></td>--><div class=\"row\"><div class=\"orderBag-mobile-float\"><i class=\"fa fa-calendar\"></i> {{conversation.createDate | toPersianDate}}</div><div><div ng-class=\"vm.findStatusStyle(conversation.status)\" style=\"text-align: left\"><span class=\"glyphicon glyphicon-stop\"></span> <span data-translate=\"{{\'tikonApp.ConversationStatusType.\' + conversation.status}}\">{{conversation.status}}</span></div></div></div><div class=\"row\"><div class=\"orderBag-mobile-float\"><i class=\"glyphicon glyphicon-user\"></i> {{conversation.fromPerson.fisrtName}} {{conversation.fromPerson.lastName}}</div></div><div class=\"row\"><div class=\"orderBag-mobile-float\"><i class=\"fa fa-commenting-o\"></i> {{conversation.subject}}</div></div><!--<div class=\"row\">--><!--<div class=\"orderBag-mobile-float\">--><!--{{conversation.relatedService.itemTitle}}--><!--</div>--><!--</div>--></div></div>");
$templateCache.put("app/entities/conversation/conversations.html","<div><h2 data-translate=\"tikonApp.conversation.home.title\">Conversations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"conversation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs-down\" data-translate=\"tikonApp.conversation.home.createLabel\">Create new Conversation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.conversation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span data-translate=\"tikonApp.conversation.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span data-translate=\"tikonApp.conversation.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span data-translate=\"tikonApp.conversation.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"relatedServiceId\"><span data-translate=\"tikonApp.conversation.relatedService\">Related Service</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromPersonId\"><span data-translate=\"tikonApp.conversation.fromPerson\">From Person</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toPersonId\"><span data-translate=\"tikonApp.conversation.toPerson\">To Person</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"conversation in vm.conversations track by conversation.id\"><td><a ui-sref=\"conversation-detail({id:conversation.id})\">{{conversation.id}}</a></td><td data-translate=\"{{\'tikonApp.ConversationStatusType.\' + conversation.status}}\">{{conversation.status}}</td><td>{{conversation.createDate | date:\'medium\'}}</td><td><a ui-sref=\"company-detail({id:conversation.companyId})\">{{conversation.companyId}}</a></td><td><a ui-sref=\"service-item-detail({id:conversation.relatedServiceId})\">{{conversation.relatedServiceId}}</a></td><td><a ui-sref=\"person-info-detail({id:conversation.fromPersonId})\">{{conversation.fromPersonId}}</a></td><td><a ui-sref=\"person-info-detail({id:conversation.toPersonId})\">{{conversation.toPersonId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"conversation-detail({id:conversation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"conversation.edit({id:conversation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"conversation.delete({id:conversation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/coupon/coupon-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.coupon.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p>آیا مطمئنید میخواهید کد تخفیف <span style=\"font-weight: bold\">{{ vm.coupon.couponCode }}</span> را حذف کنید؟</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/coupon/coupon-v2.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }\n\n    .usedCouponClass-v2 {\n        border: 1px solid #dee3e7;\n        border-radius: 5px;\n        padding: 5px;\n        margin-top: 5px;\n        background-color: antiquewhite;\n    }\n\n    .service-schedule-block {\n        border-bottom: solid 1px #ff9d1a;\n    }</style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.coupon && vm.coupon.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\">{{vm.coupon.couponCode}}</div><div ng-if=\"vm.coupon.usedCouponCount != null\"><div class=\"usedCouponClass-v2\"><div ng-if=\"vm.coupon.usedCouponCount>0\"><span>این کد تخفیف </span><span>{{vm.coupon.usedCouponCount}}</span> <span>بار استفاده شده است .</span></div><div ng-if=\"vm.coupon.usedCouponCount==0\"><span>از این کد هنوز استفاده نشده است.</span></div></div></div></div></div><div class=\"customer-header-buttons\"><!-- <div ng-click=\"vm.deleteCoupon()\"> --><div ui-sref=\"supplierPanel-v2.deleteCoupon({id:vm.coupon.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span>{{vm.getModalTitle() | translate}} </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.coupon.id != null\">{{vm.coupon.couponCode}}</span></div><form name=\"editForm\"><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.coupon.couponCode\"><div class=\"form-field-description\" translate=\"tikonApp.coupon.fieldsDescription.couponCodeLowerCase\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.generateType\" for=\"field_generateType\">generateType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.coupon.generateType\" style=\"margin-top: 6px\" id=\"field_generateType\"><md-option value=\"MANUAL\" translate=\"tikonApp.couponGenerateTypes.MANUAL\">MANUAL</md-option><md-option value=\"AUTOMATIC\" disabled=\"disabled\" translate=\"tikonApp.couponGenerateTypes.AUTOMATIC\">AUTOMATIC</md-option><md-option value=\"GENERATED_By_SYSTEM\" disabled=\"disabled\" translate=\"tikonApp.couponGenerateTypes.GENERATED_By_SYSTEM\">GENERATED_By_SYSTEM</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.status\" for=\"field_amountType\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.coupon.status\" style=\"margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.couponStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.couponStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.amountType\" for=\"field_amountType\">amountType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.coupon.amountType\" style=\"margin-top: 6px\" id=\"field_amountType\"><md-option value=\"PERCENT\" translate=\"tikonApp.amountTypes.PERCENT\">PERCENT</md-option><md-option value=\"CASH\" translate=\"tikonApp.amountTypes.CASH\">CASH</md-option></md-select></div></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.amount\" for=\"field_amount\">Amount</label><!--<input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\"--><!--ng-model=\"vm.coupon.amount\" min=\"0\"--><!--/>--><eo-numeric-input id=\"field_amount\" name=\"amount\" custom-class=\"form-control\" input-value=\"vm.coupon.amount\" form-reference=\"editForm\" is-required=\"true\"></eo-numeric-input></div></div><div class=\"col-md-1 col-xs-6\"><div class=\"\" style=\"margin-top: 46px; margin-right: -20px\"><div ng-if=\"vm.coupon.amountType==\'PERCENT\'\">%</div><div ng-if=\"vm.coupon.amountType==\'CASH\'\"><span translate=\"global.currencyBracket\"></span></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.expireDate\" for=\"field_expireDate\">expireDate</label><eo-date-picker id=\"field_expireDate\" date-value=\"vm.coupon.expireDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.generalUseCount\" for=\"field_generalUseCount\">generalUseCount</label><!--<input type=\"number\" class=\"form-control\" name=\"amount\"--><!--id=\"field_generalUseCount\"--><!--ng-model=\"vm.coupon.generalUseCount\" min=\"1\"--><!--/>--><eo-numeric-input id=\"field_generalUseCount\" name=\"generalUseCount\" custom-class=\"form-control\" input-value=\"vm.coupon.generalUseCount\" form-reference=\"editForm\"></eo-numeric-input><div class=\"form-field-description\" translate=\"tikonApp.coupon.fieldsDescription.generalUseCount\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.customerUseCount\" for=\"field_customerUseCount\">customerUseCount</label><!--<input type=\"number\" class=\"form-control\" name=\"amount\"--><!--id=\"field_customerUseCount\"--><!--ng-model=\"vm.coupon.customerUseCount\" min=\"1\"--><!--/>--><eo-numeric-input id=\"field_customerUseCount\" name=\"customerUseCount\" custom-class=\"form-control\" input-value=\"vm.coupon.customerUseCount\" form-reference=\"editForm\"></eo-numeric-input><div class=\"form-field-description\" translate=\"tikonApp.coupon.fieldsDescription.customerUseCount\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.maxApplyAmount\" for=\"field_maxApplyAmount\">maxApplyAmount</label><!--<input type=\"number\" class=\"form-control\" name=\"maxApplyAmount\"--><!--id=\"field_maxApplyAmount\"--><!--ng-model=\"vm.coupon.maxApplyAmount\" min=\"0\"--><!--/>--><eo-numeric-input-v2 id=\"field_maxApplyAmount\" name=\"maxApplyAmount\" custom-class=\"form-control\" input-value=\"vm.coupon.maxApplyAmount\" form-reference=\"editForm\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.minPurchase\" for=\"field_minPurchase\">minPurchase</label><!--<input type=\"number\" class=\"form-control\" name=\"minPurchase\"--><!--id=\"field_minPurchase\"--><!--ng-model=\"vm.coupon.minPurchase\" min=\"0\"--><!--/>--><eo-numeric-input-v2 id=\"field_minPurchase\" name=\"minPurchase\" custom-class=\"form-control\" input-value=\"vm.coupon.minPurchase\" form-reference=\"editForm\" currency-format=\"true\"></eo-numeric-input-v2></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllServices\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.coupon.forAllServices\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllServices\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.coupon.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"serviceItem in vm.allServiceItems\"><md-checkbox ng-model=\"serviceItem.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.serviceCheckChange(serviceItem)\">{{serviceItem.itemTitle}}</md-checkbox></div></fieldset></div></div><div id=\"customerGroups\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllCustomerGroups\" aria-label=\"Switch 1\" ng-change=\"vm.switch_customerGroup_changed()\"><span translate=\"tikonApp.coupon.forAllCustomerGroups\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllCustomerGroups\"><fieldset class=\"standard-fieldset\"><legend>انتخاب گروه مشتری برای اعمال کوپن</legend><div class=\"col-md-3\" ng-repeat=\"customerGroup in vm.allCustomerGroups\"><md-checkbox ng-model=\"customerGroup.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.customerGroupCheckChange(customerGroup)\">{{customerGroup.groupName}}</md-checkbox></div></fieldset></div></div></div></div></div></form></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/coupon/coupon.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }\n\n    .usedCouponClass {\n        border: 1px solid #dee3e7;\n        border-radius: 5px;\n        padding: 9px;\n        margin-top: 5px;\n        background-color: antiquewhite;\n        color: #607d8b;\n        margin-right: 10px;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.coupon.home.createOrEditLabel\" style=\"display: inline-block\">tikonApp.coupon.home.createOrEditLabel </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.coupon.id != null\">{{vm.coupon.couponCode}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                                border-bottom: solid 1px #ff9d1a;\n                            }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\" ng-if=\"true\"><md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.hasAllNecessaryFields\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\"><!--ثبت اطلاعات--></span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.couponList\"><span><md-icon>list</md-icon></span><span>بازگشت به لیست</span></md-button></div><div ng-if=\"vm.coupon.usedCouponCount != null\"><div class=\"pull-right usedCouponClass\"><div ng-if=\"vm.coupon.usedCouponCount>0\"><span>این کد تخفیف </span><span>{{vm.coupon.usedCouponCount}}</span> <span>بار استفاده شده است .</span></div><div ng-if=\"vm.coupon.usedCouponCount==0\"><span>از این کد هنوز استفاده نشده است.</span></div></div></div></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.coupon.couponCode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.generateType\" for=\"field_generateType\">generateType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.coupon.generateType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_generateType\"><md-option value=\"MANUAL\" translate=\"tikonApp.couponGenerateTypes.MANUAL\">MANUAL</md-option><md-option value=\"AUTOMATIC\" disabled=\"disabled\" translate=\"tikonApp.couponGenerateTypes.AUTOMATIC\">AUTOMATIC</md-option><md-option value=\"GENERATED_By_SYSTEM\" disabled=\"disabled\" translate=\"tikonApp.couponGenerateTypes.GENERATED_By_SYSTEM\">GENERATED_By_SYSTEM</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.status\" for=\"field_amountType\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.coupon.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.couponStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.couponStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.amountType\" for=\"field_amountType\">amountType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.coupon.amountType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_amountType\"><md-option value=\"PERCENT\" translate=\"tikonApp.amountTypes.PERCENT\">PERCENT</md-option><md-option value=\"CASH\" translate=\"tikonApp.amountTypes.CASH\">CASH</md-option></md-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.coupon.amount\" for=\"field_amount\">Amount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.coupon.amount\" min=\"0\"></div></div><div class=\"col-md-1\"><div class=\"\" style=\"margin-top: 46px; margin-right: -20px\"><div ng-if=\"vm.coupon.amountType==\'PERCENT\'\">%</div><div ng-if=\"vm.coupon.amountType==\'CASH\'\"><span translate=\"global.currencyBracket\"></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"margin-top: 20px\"><label class=\"control-label\" translate=\"tikonApp.coupon.expireDate\" for=\"field_expireDate\">expireDate</label><eo-date-picker id=\"field_expireDate\" date-value=\"vm.coupon.expireDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.generalUseCount\" for=\"field_generalUseCount\">generalUseCount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_generalUseCount\" ng-model=\"vm.coupon.generalUseCount\" min=\"1\"><div class=\"form-field-description\" translate=\"tikonApp.coupon.fieldsDescription.generalUseCount\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.customerUseCount\" for=\"field_customerUseCount\">customerUseCount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_customerUseCount\" ng-model=\"vm.coupon.customerUseCount\" min=\"1\"><div class=\"form-field-description\" translate=\"tikonApp.coupon.fieldsDescription.customerUseCount\"></div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\" style=\"margin-top: 20px;\">--><!--<label class=\"control-label\" translate=\"tikonApp.coupon.startDate\"--><!--for=\"field_startDate\">startDate--><!--</label>--><!--<eo-date-picker id=\"field_startDate\"--><!--date-value=\"vm.coupon.startDate\"></eo-date-picker>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.maxApplyAmount\" for=\"field_maxApplyAmount\">maxApplyAmount</label><input type=\"number\" class=\"form-control\" name=\"maxApplyAmount\" id=\"field_maxApplyAmount\" ng-model=\"vm.coupon.maxApplyAmount\" min=\"0\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.coupon.minPurchase\" for=\"field_minPurchase\">minPurchase</label><input type=\"number\" class=\"form-control\" name=\"minPurchase\" id=\"field_minPurchase\" ng-model=\"vm.coupon.minPurchase\" min=\"0\"></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllServices\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.coupon.forAllServices\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllServices\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.coupon.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"serviceItem in vm.allServiceItems\"><md-checkbox ng-model=\"serviceItem.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.serviceCheckChange(serviceItem)\">{{serviceItem.itemTitle}}</md-checkbox></div></fieldset></div></div><div id=\"customerGroups\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllCustomerGroups\" aria-label=\"Switch 1\" ng-change=\"vm.switch_customerGroup_changed()\"><span translate=\"tikonApp.coupon.forAllCustomerGroups\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllCustomerGroups\"><fieldset class=\"standard-fieldset\"><legend>انتخاب گروه مشتری برای اعمال کوپن</legend><div class=\"col-md-3\" ng-repeat=\"customerGroup in vm.allCustomerGroups\"><md-checkbox ng-model=\"customerGroup.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.customerGroupCheckChange(customerGroup)\">{{customerGroup.groupName}}</md-checkbox></div></fieldset></div></div></md-content></div></div></div></div></div></div>");
$templateCache.put("app/entities/coupon/coupons-list-v2.html","<div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.coupon.home.title\">tikonApp.coupon.home.title</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newCoupon()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.coupon.home.new\">Create new Servant</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><!--<div class=\"container-fluid\">--><jhi-alert></jhi-alert><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.coupons\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.coupon.home.searchPlaceHolder\'\" on-search=\"vm.searchCoupons()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"couponCode\"><span translate=\"tikonApp.coupon.couponCode\">couponCode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"generateType\"><span translate=\"tikonApp.coupon.generateType\">generateType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"amountType\"><span--><!--translate=\"tikonApp.coupon.amountType\">amountType</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"amount\"><span translate=\"tikonApp.coupon.amount\">amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.coupon.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"coupon in collection track by coupon.id\"><!--<td>{{coupon.id }} </td>--><td><!--<a ui-sref=\"coupon.edit({id:coupon.id})\">{{coupon.couponCode}}</a>--> {{coupon.couponCode}}</td><td class=\"hidden-xs\"><span translate=\"{{\'tikonApp.couponGenerateTypes.\' + coupon.generateType}}\">{{coupon.generateType}}</span></td><!--<td>--><!--{{coupon.amountType}}--><!--</td>--><td><!--{{companyCustomer.createDate | toPersianDate}}</td>--> {{coupon.amount}} <span ng-if=\"coupon.amountType==\'PERCENT\'\">% </span><span ng-if=\"coupon.amountType==\'CASH\'\"><span translate=\"global.currencyBracket\"></span></span></td><td><span translate=\"{{\'tikonApp.couponStatus.\' + coupon.status}}\">{{coupon.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editCoupon(coupon)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.deleteCouponFromList({id:coupon.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!--</div>--></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newCoupon()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 coupon-list-title\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.coupon.home.title\">title-list</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.setting\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.coupon.home.searchPlaceHolder\'\" on-search=\"vm.searchCoupons()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"coupon in vm.coupons track by coupon.id\" class=\"customer-list-item\" ng-click=\"vm.editCoupon(coupon)\"><!--<eo-avatar-name name=\"{{coupon.couponCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\">{{coupon.couponCode}}</div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span><!--{{companyCustomer.createDate | toPersianDate}}</td>--> {{coupon.amount}} <span ng-if=\"coupon.amountType==\'PERCENT\'\">% </span><span ng-if=\"coupon.amountType==\'CASH\'\"><span translate=\"global.currencyBracket\"></span></span></span></div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span translate=\"{{\'tikonApp.couponStatus.\' + coupon.status}}\">{{coupon.status}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/coupon/coupons-list-v3.html","<div id=\"coupons-container\"><panel-pln-coupons id=\"coupons-list\"></panel-pln-coupons></div>");
$templateCache.put("app/entities/coupon/coupons-list.html","<div class=\"container-fluid\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.coupon.home.title\">tikonApp.coupon.home.title</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary\" ng-click=\"vm.newCouponClick()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.coupon.home.new\">Create new Servant</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><!--<div class=\"container-fluid\">--><jhi-alert></jhi-alert><md-content class=\"rwMdContent\"><div colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><div class=\"col-sm-6 col-xs-8\"><div class=\"form-group\"><!--<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>--> <input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'tikonApp.coupon.home.search\' | translate }}\" type=\"text\" ng-keypress=\"vm.searchKeyPress($event)\"></div></div><div class=\"col-sm-6 col-xs-4\"><md-button id=\"search-btn\" class=\"search-btn md-raised md-secondary\" ng-click=\"vm.search()\" style=\"margin-top: 0px; margin-right: -10px\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div></div></div><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.coupons\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr></tr><tr><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"couponCode\"><span translate=\"tikonApp.coupon.couponCode\">couponCode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"generateType\"><span translate=\"tikonApp.coupon.generateType\">generateType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"amountType\"><span--><!--translate=\"tikonApp.coupon.amountType\">amountType</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"amount\"><span translate=\"tikonApp.coupon.amount\">amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.coupon.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"coupon in collection track by coupon.id\"><!--<td>{{coupon.id }} </td>--><td><!--<a ui-sref=\"coupon.edit({id:coupon.id})\">{{coupon.couponCode}}</a>--> {{coupon.couponCode}}</td><td class=\"hidden-xs\"><span translate=\"{{\'tikonApp.couponGenerateTypes.\' + coupon.generateType}}\">{{coupon.generateType}}</span></td><!--<td>--><!--{{coupon.amountType}}--><!--</td>--><td><!--{{companyCustomer.createDate | toPersianDate}}</td>--> {{coupon.amount}} <span ng-if=\"coupon.amountType==\'PERCENT\'\">% </span><span ng-if=\"coupon.amountType==\'CASH\'\"><span translate=\"global.currencyBracket\"></span></span></td><td><span translate=\"{{\'tikonApp.couponStatus.\' + coupon.status}}\">{{coupon.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editCoupon({id:coupon.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.deleteCoupon({id:coupon.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></md-content><!--</div>--></div></div></div><!--<div class=\"visible-xs \">--><!--<div class=\"\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-8\">--><!--<h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.companyCustomer.home.title\">--><!--tikonApp.companyCustomer.home.title--><!--</h3>--><!--</div>--><!--<div class=\"col-xs-3\" style=\"margin-right: -7px\">--><!--<md-button class=\"md-raised md-primary\" ui-sref=\"company-customer.new\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!--</md-button>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"\">--><!--<div class=\"\">--><!--<jhi-alert></jhi-alert>--><!--<div class=\"row\" style=\"padding-right: 8px\">--><!--<div class=\"form-group\">--><!--&lt;!&ndash;<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>&ndash;&gt;--><!--<div class=\"col-xs-10\">--><!--<input class=\"form-control rwTableSearchBox\"--><!--ng-model=\"vm.searchQuery\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><!--</div>--><!--<div class=\"col-xs-2\" style=\"margin-right: -30px;margin-top: -7px;\">--><!--<md-button id=\"search-btn-xs\" class=\"search-btn md-raised md-secondary\"--><!--ng-click=\"vm.search()\"--><!--&gt;--><!--<i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative;\">--><!--search--><!--</i>--><!--</md-button>--><!--</div>--><!--</div>--><!--</div>--><!--<div ng-repeat=\"companyCustomer in vm.companyCustomers track by companyCustomer.id\"--><!--class=\"orderBag-mobile-block\">--><!--&lt;!&ndash;<td>{{companyCustomer.customer.id }} </td>&ndash;&gt;--><!--<div>--><!--<div ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"row\">--><!--<div class=\"orderBag-mobile-float\">--><!--<i class=\"glyphicon glyphicon-user\"></i>--><!--{{companyCustomer.customer.personalInfo.fisrtName}}--><!--{{companyCustomer.customer.personalInfo.lastName}}--><!--</div>--><!--</div>--><!--<div class=\"row\" ng-if=\"companyCustomer.customer.personalInfo.email!=null\"--><!--style=\"padding-right: 8px\">--><!--<i class=\"glyphicon glyphicon-envelope\"></i>--><!--{{companyCustomer.customer.personalInfo.email}}--><!--</div>--><!--<div>--><!--<div class=\"orderBag-mobile-float companyCustomer-make-call\">--><!--<i class=\"fa fa-phone\"></i>--><!--<a href=\"tel:{{companyCustomer.customer.personalInfo.phoneNumber}}\">{{companyCustomer.customer.personalInfo.phoneNumber}}</a>--><!--&lt;!&ndash;{{companyCustomer.customer.personalInfo.phoneNumber}}&ndash;&gt;--><!--</div>--><!--<div style=\"text-align: left\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.edit({id:companyCustomer.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"vm.gotoNewReserve(companyCustomer.customer.id)\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-primary btn-sm\" style=\"background-color: rgb(96,125,139)\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"tikonApp.companyCustomer.newReserveForCustomer\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--<button type=\"button\"--><!--ui-sref=\"supplierPanel.deleteCompanyCustomer({id:companyCustomer.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"></ul>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/customSetting/custom-setting-v2.html","<eo-pl-modal-header title=\"\'tikonApp.companyCustomSetting.home.title\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.companyCustomSetting.home.title\">tikonApp.companyCustomSetting.home.title</div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div class=\"\"><fieldset class=\"standard-fieldset\"><legend><!--<md-icon> attach_money</md-icon>--> <span translate=\"tikonApp.companyCustomSetting.home.websiteSetting\">tikonApp.companyCustomSetting.home.websiteSetting</span></legend><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.servantLabel\" for=\"servantLabel\">servantLabel</label><input type=\"text\" class=\"form-control\" name=\"servantLabel\" id=\"servantLabel\" ng-model=\"vm.company.customSettingObject.servant_label\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.companiesListLabel\" for=\"companiesListLabel\">companiesListLabel</label><input type=\"text\" class=\"form-control\" name=\"companiesListLabel\" id=\"companiesListLabel\" ng-model=\"vm.company.customSettingObject.servants_label\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.fullDescriptionTitle\" for=\"fullDescriptionTitle\">fullDescriptionTitle</label><input type=\"text\" class=\"form-control\" name=\"fullDescriptionTitle\" id=\"fullDescriptionTitle\" ng-model=\"vm.company.customSettingObject.fullDescriptionTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.agreementTitle\" for=\"agreementTitle\">agreementTitle</label><input type=\"text\" class=\"form-control\" name=\"agreementTitle\" id=\"agreementTitle\" ng-model=\"vm.company.customSettingObject.agreementTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.durationViewMode\" for=\"durationViewMode\">durationViewMode</label><!--<input type=\"text\" class=\"form-control\" name=\"durationViewMode\"--><!--id=\"durationViewMode\"--><!--ng-model=\"vm.company.customSettingObject.durationViewMode\"/>--><md-select id=\"durationViewMode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.durationViewMode\" style=\"min-width: 100px\"><md-option value=\"\"></md-option><md-option value=\"SHOW\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option><md-option value=\"HIDE\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.priceViewMode\" for=\"priceViewMode\">priceViewMode</label><!--<input type=\"text\" class=\"form-control\" name=\"priceViewMode\"--><!--id=\"priceViewMode\"--><!--ng-model=\"vm.company.customSettingObject.priceViewMode\"/>--><md-select id=\"priceViewMode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.priceViewMode\" style=\"min-width: 100px\"><md-option value=\"SHOW\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option><md-option value=\"HIDE\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.qty_unit\" for=\"qty_unit\" eo-help-tooltip=\"tikonApp.companyCustomSetting.tips.unitTipDescription\">qty_unit</label><input type=\"text\" class=\"form-control\" name=\"qty_unit\" id=\"qty_unit\" ng-model=\"vm.company.customSettingObject.qty_unit\" disabled=\"disabled\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.servant_list_access_mode\" for=\"servant_list_access_mode\">servant_list_access_mode</label><!--<input type=\"text\" class=\"form-control\" name=\"servant_list_access_mode\"--><!--id=\"servant_list_access_mode\"--><!--ng-model=\"vm.company.customSettingObject.servant_list_access_mode\"/>--><md-select id=\"servant_list_access_mode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.servant_list_access_mode\" style=\"min-width: 100px\"><md-option value=\"\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option><md-option value=\"MENU\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.footerViewMode\" for=\"footerViewMode\">footerViewMode</label><!--<input type=\"text\" class=\"form-control\" name=\"servant_list_access_mode\"--><!--id=\"servant_list_access_mode\"--><!--ng-model=\"vm.company.customSettingObject.servant_list_access_mode\"/>--><md-select id=\"footerViewMode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.footerViewMode\" style=\"min-width: 100px\"><md-option value=\"HIDDEN\" disabled=\"true\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option><md-option value=\"SHOW\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"canReserveByClient\" id=\"canReserveByClient\" ng-model=\"vm.company.customSettingObject.canReserveByClient\" disabled=\"disabled\"><span translate=\"tikonApp.companyCustomSetting.home.canReserveByClient\"></span></md-switch></div></div><!--<div class=\"col-md-3\">--><!--<div class=\"form-group\">--><!--<md-switch class=\"pl-switch\" name=\"canReserveByWidget\"--><!--id=\"canReserveByWidget\"--><!--ng-model=\"vm.company.customSettingObject.canReserveByWidget\"--><!--disabled>--><!--<span translate=\"tikonApp.companyCustomSetting.home.canReserveByWidget\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--><div class=\"col-md-4\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"isClientEmailRequired\" id=\"isClientEmailRequired\" ng-model=\"vm.company.customSettingObject.isClientEmailRequired\"><span translate=\"tikonApp.companyCustomSetting.home.isClientEmailRequired\"></span></md-switch></div></div><div class=\"col-md-4\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"capacityViewMode\" id=\"capacityViewMode\" ng-model=\"vm.capacityViewMode\" disabled=\"true\"><span translate=\"tikonApp.companyCustomSetting.home.capacityViewMode\"></span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"noPassLoginEnabled\" id=\"noPassLoginEnabled\" ng-model=\"vm.company.customSettingObject.noPassLoginEnabled\"><span translate=\"tikonApp.companyCustomSetting.home.noPassLoginEnabled\"></span></md-switch></div></div><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"justApprovedCustomerCanReserve\" id=\"justApprovedCustomerCanReserve\" ng-model=\"vm.company.customSettingObject.justApprovedCustomerCanReserve\" eo-feature-checker=\"customerAccess\"><span translate=\"tikonApp.companyCustomSetting.home.justApprovedCustomerCanReserve\"></span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"defaultCustomTimeActive\" ng-model=\"vm.company.customSettingObject.defaultCustomTimeActive\"><span translate=\"tikonApp.companyCustomSetting.home.defaultCustomTimeActive\"></span></md-switch></div></div><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"justShowStartTime\" ng-model=\"vm.company.customSettingObject.justShowStartTime\"><span translate=\"tikonApp.companyCustomSetting.home.justShowStartTime\"></span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"isAutomaticCustomerWelcomeMsgEnabled\" ng-model=\"vm.company.customSettingObject.isAutomaticCustomerWelcomeMsgEnabled\"><span translate=\"tikonApp.companyCustomSetting.home.isAutomaticCustomerWelcomeMsgEnabled\"></span></md-switch></div></div></div></div></fieldset><!--<fieldset class=\"standard-fieldset\">--><!--<legend>--><!--&lt;!&ndash;<md-icon> attach_money</md-icon>&ndash;&gt;--><!--<span translate=\"tikonApp.companyCustomSetting.home.smsSetting\">tikonApp.companyCustomSetting.home.smsSetting</span>--><!--</legend>--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-12\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.requestConfirmationMsg\"--><!--for=\"requestConfirmationMsg\">requestConfirmationMsg </label>--><!--<input type=\"text\" class=\"form-control\" name=\"requestConfirmationMsg\"--><!--id=\"requestConfirmationMsg\"--><!--ng-model=\"vm.company.customSettingObject.requestConfirmationMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.customerSatisfactionMessage\"--><!--for=\"customerSatisfactionMessage\">customerSatisfactionMessage</label>--><!--<input type=\"text\" class=\"form-control\" name=\"customerSatisfactionMessage\"--><!--id=\"customerSatisfactionMessage\"--><!--ng-model=\"vm.company.customSettingObject.customerSatisfactionMessage\"--><!--disabled/>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.addingServantToMessageMode\"--><!--for=\"addingServantToMessageMode\">addingServantToMessageMode</label>--><!--<input type=\"text\" class=\"form-control\" name=\"addingServantToMessageMode\"--><!--id=\"addingServantToMessageMode\"--><!--ng-model=\"vm.company.customSettingObject.addingServantToMessageMode\"/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.reserveCancelationEndingMsg\"--><!--for=\"reserveCancelationEndingMsg\">reserveCancelationEndingMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"reserveCancelationEndingMsg\"--><!--id=\"reserveCancelationEndingMsg\"--><!--ng-model=\"vm.company.customSettingObject.reserveCancelationEndingMsg\"--><!--disabled/>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.reserveRequestCanceledMsg\"--><!--for=\"reserveRequestCanceledMsg\">reserveRequestCanceledMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"reserveRequestCanceledMsg\"--><!--id=\"reserveRequestCanceledMsg\"--><!--ng-model=\"vm.company.customSettingObject.reserveRequestCanceledMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.customerFirstReminderMsg\"--><!--for=\"customerFirstReminderMsg\">customerFirstReminderMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"customerFirstReminderMsg\"--><!--id=\"customerFirstReminderMsg\"--><!--ng-model=\"vm.company.customSettingObject.customerFirstReminderMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.clientConfirmMessageCustomEnding\"--><!--for=\"clientConfirmMessageCustomEnding\">clientConfirmMessageCustomEnding</label>--><!--<input type=\"text\" class=\"form-control\"--><!--name=\"clientConfirmMessageCustomEnding\"--><!--id=\"clientConfirmMessageCustomEnding\"--><!--ng-model=\"vm.company.customSettingObject.clientConfirmMessageCustomEnding\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.supplierConfirmMsg\"--><!--for=\"supplierConfirmMsg\">supplierConfirmMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"supplierConfirmMsg\"--><!--id=\"supplierConfirmMsg\"--><!--ng-model=\"vm.company.customSettingObject.supplierConfirmMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--</fieldset>--></div><div class=\"\"><fieldset class=\"standard-fieldset\"><legend><!--<md-icon> attach_money</md-icon>--> <span translate=\"tikonApp.companyCustomSetting.home.userFields\">tikonApp.companyCustomSetting.home.userFields</span></legend><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.sys_birthdate\" ng-change=\"vm.sysBirthdateChange()\">{{\'tikonApp.companyCustomSetting.home.birthDateRequiredOnRegister\' | translate}}</md-checkbox></div></div><div class=\"col-md-4\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.sys_national_code\" ng-change=\"vm.sysNationalCodeChange()\">{{\'tikonApp.companyCustomSetting.home.nationalCodeRequiredOnRegister\' | translate}}</md-checkbox></div></div></div></div></fieldset></div></form></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/customSetting/custom-setting.html","<style>md-switch {\n        display: table;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.companyCustomSetting.home.title\">tikonApp.companyCustomSetting.home.title</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><md-content class=\"rwMdContent\"><fieldset class=\"standard-fieldset\"><legend><!--<md-icon> attach_money</md-icon>--> <span translate=\"tikonApp.companyCustomSetting.home.websiteSetting\">tikonApp.companyCustomSetting.home.websiteSetting</span></legend><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.servantLabel\" for=\"servantLabel\">servantLabel</label><input type=\"text\" class=\"form-control\" name=\"servantLabel\" id=\"servantLabel\" ng-model=\"vm.company.customSettingObject.servant_label\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.companiesListLabel\" for=\"companiesListLabel\">companiesListLabel</label><input type=\"text\" class=\"form-control\" name=\"companiesListLabel\" id=\"companiesListLabel\" ng-model=\"vm.company.customSettingObject.servants_label\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.fullDescriptionTitle\" for=\"fullDescriptionTitle\">fullDescriptionTitle</label><input type=\"text\" class=\"form-control\" name=\"fullDescriptionTitle\" id=\"fullDescriptionTitle\" ng-model=\"vm.company.customSettingObject.fullDescriptionTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.agreementTitle\" for=\"agreementTitle\">agreementTitle</label><input type=\"text\" class=\"form-control\" name=\"agreementTitle\" id=\"agreementTitle\" ng-model=\"vm.company.customSettingObject.agreementTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.durationViewMode\" for=\"durationViewMode\">durationViewMode</label><!--<input type=\"text\" class=\"form-control\" name=\"durationViewMode\"--><!--id=\"durationViewMode\"--><!--ng-model=\"vm.company.customSettingObject.durationViewMode\"/>--><md-select id=\"durationViewMode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.durationViewMode\" style=\"min-width: 100px\"><md-option value=\"\"></md-option><md-option value=\"SHOW\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option><md-option value=\"HIDE\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.priceViewMode\" for=\"priceViewMode\">priceViewMode</label><!--<input type=\"text\" class=\"form-control\" name=\"priceViewMode\"--><!--id=\"priceViewMode\"--><!--ng-model=\"vm.company.customSettingObject.priceViewMode\"/>--><md-select id=\"priceViewMode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.priceViewMode\" style=\"min-width: 100px\"><md-option value=\"SHOW\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option><md-option value=\"HIDE\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.qty_unit\" for=\"qty_unit\" eo-help-tooltip=\"tikonApp.companyCustomSetting.tips.unitTipDescription\">qty_unit</label><input type=\"text\" class=\"form-control\" name=\"qty_unit\" id=\"qty_unit\" ng-model=\"vm.company.customSettingObject.qty_unit\" disabled=\"disabled\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.servant_list_access_mode\" for=\"servant_list_access_mode\">servant_list_access_mode</label><!--<input type=\"text\" class=\"form-control\" name=\"servant_list_access_mode\"--><!--id=\"servant_list_access_mode\"--><!--ng-model=\"vm.company.customSettingObject.servant_list_access_mode\"/>--><md-select id=\"servant_list_access_mode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.servant_list_access_mode\" style=\"min-width: 100px\"><md-option value=\"\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option><md-option value=\"MENU\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomSetting.home.footerViewMode\" for=\"footerViewMode\">footerViewMode</label><!--<input type=\"text\" class=\"form-control\" name=\"servant_list_access_mode\"--><!--id=\"servant_list_access_mode\"--><!--ng-model=\"vm.company.customSettingObject.servant_list_access_mode\"/>--><md-select id=\"footerViewMode\" class=\"rwMdSelect\" ng-model=\"vm.company.customSettingObject.footerViewMode\" style=\"min-width: 100px\"><md-option value=\"HIDDEN\" disabled=\"true\">{{\'tikonApp.companyCustomSetting.dropDown.hide\' | translate}}</md-option><md-option value=\"SHOW\">{{\'tikonApp.companyCustomSetting.dropDown.show\' | translate}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"canReserveByClient\" id=\"canReserveByClient\" ng-model=\"vm.company.customSettingObject.canReserveByClient\" disabled=\"disabled\"><span translate=\"tikonApp.companyCustomSetting.home.canReserveByClient\"></span></md-switch></div></div><!--<div class=\"col-md-3\">--><!--<div class=\"form-group\">--><!--<md-switch class=\"pl-switch\" name=\"canReserveByWidget\"--><!--id=\"canReserveByWidget\"--><!--ng-model=\"vm.company.customSettingObject.canReserveByWidget\"--><!--disabled>--><!--<span translate=\"tikonApp.companyCustomSetting.home.canReserveByWidget\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--><div class=\"col-md-4\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"isClientEmailRequired\" id=\"isClientEmailRequired\" ng-model=\"vm.company.customSettingObject.isClientEmailRequired\"><span translate=\"tikonApp.companyCustomSetting.home.isClientEmailRequired\"></span></md-switch></div></div><div class=\"col-md-4\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"capacityViewMode\" id=\"capacityViewMode\" ng-model=\"vm.capacityViewMode\" disabled=\"true\"><span translate=\"tikonApp.companyCustomSetting.home.capacityViewMode\"></span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"noPassLoginEnabled\" id=\"noPassLoginEnabled\" ng-model=\"vm.company.customSettingObject.noPassLoginEnabled\"><span translate=\"tikonApp.companyCustomSetting.home.noPassLoginEnabled\"></span></md-switch></div></div><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"justApprovedCustomerCanReserve\" id=\"justApprovedCustomerCanReserve\" ng-model=\"vm.company.customSettingObject.justApprovedCustomerCanReserve\" eo-feature-checker=\"customerAccess\"><span translate=\"tikonApp.companyCustomSetting.home.justApprovedCustomerCanReserve\"></span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"defaultCustomTimeActive\" ng-model=\"vm.company.customSettingObject.defaultCustomTimeActive\"><span translate=\"tikonApp.companyCustomSetting.home.defaultCustomTimeActive\"></span></md-switch></div></div><div class=\"col-md-6\"><div class=\"form-group\"><md-switch class=\"pl-switch\" name=\"justShowStartTime\" ng-model=\"vm.company.customSettingObject.justShowStartTime\"><span translate=\"tikonApp.companyCustomSetting.home.justShowStartTime\"></span></md-switch></div></div></div></div></fieldset><!--<fieldset class=\"standard-fieldset\">--><!--<legend>--><!--&lt;!&ndash;<md-icon> attach_money</md-icon>&ndash;&gt;--><!--<span translate=\"tikonApp.companyCustomSetting.home.smsSetting\">tikonApp.companyCustomSetting.home.smsSetting</span>--><!--</legend>--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-12\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.requestConfirmationMsg\"--><!--for=\"requestConfirmationMsg\">requestConfirmationMsg </label>--><!--<input type=\"text\" class=\"form-control\" name=\"requestConfirmationMsg\"--><!--id=\"requestConfirmationMsg\"--><!--ng-model=\"vm.company.customSettingObject.requestConfirmationMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.customerSatisfactionMessage\"--><!--for=\"customerSatisfactionMessage\">customerSatisfactionMessage</label>--><!--<input type=\"text\" class=\"form-control\" name=\"customerSatisfactionMessage\"--><!--id=\"customerSatisfactionMessage\"--><!--ng-model=\"vm.company.customSettingObject.customerSatisfactionMessage\"--><!--disabled/>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.addingServantToMessageMode\"--><!--for=\"addingServantToMessageMode\">addingServantToMessageMode</label>--><!--<input type=\"text\" class=\"form-control\" name=\"addingServantToMessageMode\"--><!--id=\"addingServantToMessageMode\"--><!--ng-model=\"vm.company.customSettingObject.addingServantToMessageMode\"/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.reserveCancelationEndingMsg\"--><!--for=\"reserveCancelationEndingMsg\">reserveCancelationEndingMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"reserveCancelationEndingMsg\"--><!--id=\"reserveCancelationEndingMsg\"--><!--ng-model=\"vm.company.customSettingObject.reserveCancelationEndingMsg\"--><!--disabled/>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.reserveRequestCanceledMsg\"--><!--for=\"reserveRequestCanceledMsg\">reserveRequestCanceledMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"reserveRequestCanceledMsg\"--><!--id=\"reserveRequestCanceledMsg\"--><!--ng-model=\"vm.company.customSettingObject.reserveRequestCanceledMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.customerFirstReminderMsg\"--><!--for=\"customerFirstReminderMsg\">customerFirstReminderMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"customerFirstReminderMsg\"--><!--id=\"customerFirstReminderMsg\"--><!--ng-model=\"vm.company.customSettingObject.customerFirstReminderMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.clientConfirmMessageCustomEnding\"--><!--for=\"clientConfirmMessageCustomEnding\">clientConfirmMessageCustomEnding</label>--><!--<input type=\"text\" class=\"form-control\"--><!--name=\"clientConfirmMessageCustomEnding\"--><!--id=\"clientConfirmMessageCustomEnding\"--><!--ng-model=\"vm.company.customSettingObject.clientConfirmMessageCustomEnding\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.companyCustomSetting.home.supplierConfirmMsg\"--><!--for=\"supplierConfirmMsg\">supplierConfirmMsg</label>--><!--<input type=\"text\" class=\"form-control\" name=\"supplierConfirmMsg\"--><!--id=\"supplierConfirmMsg\"--><!--ng-model=\"vm.company.customSettingObject.supplierConfirmMsg\"--><!--disabled/>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--</fieldset>--></md-content></form></div></div></div></div>");
$templateCache.put("app/entities/customer/customer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.customer.delete.question\" translate-values=\"{id: \'{{vm.customer.id}}\'}\">Are you sure you want to delete this Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer/customer-detail.html","<div><h2><span translate=\"tikonApp.customer.detail.title\">Customer</span> {{vm.customer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.customer.userAccountId\">User Account Id</span></dt><dd><span>{{vm.customer.userAccountId}}</span></dd><dt><span translate=\"tikonApp.customer.personalInfo\">Personal Info</span></dt><dd><a ui-sref=\"person-info-detail({id:vm.customer.personalInfoId})\">{{vm.customer.personalInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer/customer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerLabel\" translate=\"tikonApp.customer.home.createOrEditLabel\">Create or edit a Customer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customer.userAccountId\" for=\"field_userAccountId\">User Account Id</label><input type=\"number\" class=\"form-control\" name=\"userAccountId\" id=\"field_userAccountId\" ng-model=\"vm.customer.userAccountId\"></div><div class=\"form-group\"><label translate=\"tikonApp.customer.personalInfo\" for=\"field_personalInfo\">Personal Info</label><select class=\"form-control\" id=\"field_personalInfo\" name=\"personalInfo\" ng-model=\"vm.customer.personalInfoId\" ng-options=\"personInfo.id as personInfo.id for personInfo in vm.personinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer/customers.html","<div><h2 translate=\"tikonApp.customer.home.title\">Customers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.customer.home.createLabel\">Create new Customer</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.customer.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userAccountId\"><span translate=\"tikonApp.customer.userAccountId\">User Account Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personalInfoId\"><span translate=\"tikonApp.customer.personalInfo\">Personal Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customer in vm.customers track by customer.id\"><td><a ui-sref=\"customer-detail({id:customer.id})\">{{customer.id}}</a></td><td>{{customer.userAccountId}}</td><td><a ui-sref=\"person-info-detail({id:customer.personalInfoId})\">{{customer.personalInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-detail({id:customer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer.edit({id:customer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer.delete({id:customer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-comment/customer-comment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerComment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.customerComment.delete.question\" translate-values=\"{id: \'{{vm.customerComment.id}}\'}\">Are you sure you want to delete this Customer Comment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-comment/customer-comment-detail.html","<div><h2><span translate=\"tikonApp.customerComment.detail.title\">Customer Comment</span> {{vm.customerComment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.customerComment.createDate\">Create Date</span></dt><dd><span>{{vm.customerComment.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.customerComment.commentText\">Comment Text</span></dt><dd><span>{{vm.customerComment.commentText}}</span></dd><dt><span translate=\"tikonApp.customerComment.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.customerComment.customerId})\">{{vm.customerComment.customerId}}</a></dd><dt><span translate=\"tikonApp.customerComment.serviceItem\">Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.customerComment.serviceItemId})\">{{vm.customerComment.serviceItemId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer-comment/customer-comment-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerCommentLabel\" translate=\"tikonApp.customerComment.home.createOrEditLabel\">Create or edit a Customer Comment</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerComment.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerComment.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customerComment.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.customerComment.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customerComment.commentText\" for=\"field_commentText\">Comment Text</label><input type=\"text\" class=\"form-control\" name=\"commentText\" id=\"field_commentText\" ng-model=\"vm.customerComment.commentText\"></div><div class=\"form-group\"><label translate=\"tikonApp.customerComment.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.customerComment.customerId\" ng-options=\"customer.id as customer.id for customer in vm.customers\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.customerComment.serviceItem\" for=\"field_serviceItem\">Service Item</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.customerComment.serviceItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-comment/customer-comments.html","<div><h2 translate=\"tikonApp.customerComment.home.title\">Customer Comments</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-comment.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.customerComment.home.createLabel\">Create new Customer Comment</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.customerComment.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.customerComment.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"commentText\"><span translate=\"tikonApp.customerComment.commentText\">Comment Text</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerId\"><span translate=\"tikonApp.customerComment.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceItemId\"><span translate=\"tikonApp.customerComment.serviceItem\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerComment in vm.customerComments track by customerComment.id\"><td><a ui-sref=\"customer-comment-detail({id:customerComment.id})\">{{customerComment.id}}</a></td><td>{{customerComment.createDate | date:\'medium\'}}</td><td>{{customerComment.commentText}}</td><td><a ui-sref=\"customer-detail({id:customerComment.customerId})\">{{customerComment.customerId}}</a></td><td><a ui-sref=\"service-item-detail({id:customerComment.serviceItemId})\">{{customerComment.serviceItemId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-comment-detail({id:customerComment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-comment.edit({id:customerComment.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-comment.delete({id:customerComment.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-group/customer-group-v2.html","<eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.customerGroup && vm.customerGroup.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\">{{vm.customerGroup.groupName == \'DEFAULT_GROUP\' ? \'tikonApp.customerGroup.\'+ vm.customerGroup.groupName : vm.customerGroup.groupName | translate}}</div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.customerGroup.delete({id:vm.customerGroup.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span style=\"display: inline-block\">{{vm.getModalTitle() | translate}}</span></div><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div><div class=\"row\"><div class=\"col-md-4\" ng-if=\"vm.customerGroup.groupName != \'DEFAULT_GROUP\'\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.customerGroup.groupName\" for=\"field_groupName\">groupName</label><input type=\"text\" class=\"form-control\" name=\"groupName\" id=\"field_groupName\" ng-model=\"vm.customerGroup.groupName\"></div></div><div class=\"col-md-4\" ng-if=\"vm.customerGroup.groupName == \'DEFAULT_GROUP\'\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.customerGroup.groupName\" for=\"field_groupName_default\">groupName</label><input type=\"text\" class=\"form-control\" name=\"groupNameDefault\" id=\"field_groupName_default\" ng-model=\"vm.defaultGroupTranslate\" readonly=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customerGroup.description\" for=\"field_description\">description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.customerGroup.description\"></div></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.customerGroup.accessToAllServices\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.customerGroup.accessToAllServices\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.customerGroup.accessToAllServices\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.customerGroup.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"serviceItem in vm.allServiceItems\"><md-checkbox ng-model=\"serviceItem.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.serviceCheckChange(serviceItem)\">{{serviceItem.itemTitle}}</md-checkbox></div></fieldset></div></div></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/customer-group/customer-group.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.customerGroup.home.createOrEditLabel\" style=\"display: inline-block\">tikonApp.customerGroup.home.createOrEditLabel </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.customerGroup.id != null\">{{vm.customerGroup.groupName}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                                border-bottom: solid 1px #ff9d1a;\n                            }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\" ng-if=\"true\"><md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.hasAllNecessaryFields\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\"><!--ثبت اطلاعات--></span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.customerGroupList\"><span><md-icon>list</md-icon></span><span>بازگشت به لیست</span></md-button></div></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.customerGroup.groupName\" for=\"field_groupName\">groupName</label><input type=\"text\" class=\"form-control\" name=\"groupName\" id=\"field_groupName\" ng-model=\"vm.customerGroup.groupName\"></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customerGroup.description\" for=\"field_description\">description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.customerGroup.description\"></div></div></div></md-content></div></div></div></div></div></div>");
$templateCache.put("app/entities/customer-group/customer-groups-list-v2.html","<div class=\"hidden-xs\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.customerGroup.home.title\">tikonApp.customerGroup.home.title</div><div class=\"panel-body pl-panel-body\"><div class=\"container-fluid pl-container-fluid\"><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-xs-12\"><md-button class=\"md-raised md-primary pl-btn-primary pl-btn\" style=\"margin-bottom: 10px\" ng-click=\"vm.newCustomerGroup()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.customerGroup.home.new\">Create new Customer Group</span></md-button><md-button class=\"md-raised md-secondary pl-btn-default pl-btn\" style=\"margin-bottom: -14px\" ui-sref=\"supplierPanel-v2.companyCustomer\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"supplierPanel.sideMenu.companyCustomer\">companyCustomer</span></md-button></div></div><div class=\"\"><div class=\"table-responsive\"><table st-safe-src=\"vm.customerGroups\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.companyCustomer.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"groupName\"><span translate=\"tikonApp.customerGroup.groupName\">groupName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"accessToAllServices\"><span translate=\"tikonApp.customerGroup.accessToAllServices\">accessToAllServices</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"groupName\"><span translate=\"tikonApp.customerGroup.description\">description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerGroup in collection track by customerGroup.id\"><!--<td>{{coupon.id }} </td>--><td>{{customerGroup.groupName == \'DEFAULT_GROUP\' ? \'tikonApp.customerGroup.\'+ customerGroup.groupName : customerGroup.groupName | translate}}</td><td><span ng-if=\"customerGroup.accessToAllServices\"><md-tooltip md-direction=\"top\">{{\'tikonApp.customerGroup.accessToAllServices\' | translate}}</md-tooltip><md-icon style=\"color: forestgreen\">verified_user</md-icon></span></td><td>{{customerGroup.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editCustomerGroup(customerGroup)\" class=\"btn btn-primary btn-sm pl-btn-primary pl-btn-auto\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.deleteCustomerGroup({id:customerGroup.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newCustomerGroup()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 coupon-list-title\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.customerGroup.home.title\">title-list</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.companyCustomer\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.companyCustomer.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"customerGroup in vm.customerGroups track by customerGroup.id\" class=\"customer-list-item\" ng-click=\"vm.editCustomerGroup(customerGroup)\"><!--<eo-avatar-name name=\"{{coupon.couponCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\">{{customerGroup.groupName}}</div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/customer-group/customer-groups-list.html","<div class=\"hidden-xs\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.customerGroup.home.title\">tikonApp.customerGroup.home.title</div><div class=\"panel-body\"><div class=\"container-fluid\"><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-xs-12\"><md-button class=\"md-raised md-primary\" style=\"margin-bottom: 10px\" ng-click=\"vm.newCustomerGroupClick()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.customerGroup.home.new\">Create new Customer Group</span></md-button><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: -14px\" ui-sref=\"supplierPanel.companyCustomer\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"supplierPanel.sideMenu.companyCustomer\">companyCustomer</span></md-button></div></div><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.customerGroups\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><!--<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>--> <input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'tikonApp.customerGroup.home.search\' | translate }}\" type=\"text\"></div></div><div class=\"col-sm-6\"><md-button id=\"search-btn\" class=\"search-btn md-raised md-secondary\" ng-click=\"vm.search()\" style=\"margin-top: 0px; margin-right: -10px\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div></div></th></tr><tr><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"groupName\"><span translate=\"tikonApp.customerGroup.groupName\">groupName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"groupName\"><span translate=\"tikonApp.customerGroup.description\">description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerGroup in collection track by customerGroup.id\"><!--<td>{{coupon.id }} </td>--><td>{{customerGroup.groupName}}</td><td>{{customerGroup.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editCustomerGroup({id:customerGroup.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.deleteCustomerGroup({id:customerGroup.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></md-content></div></div></div></div><!--<div class=\"visible-xs \">--><!--<div class=\"\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-8\">--><!--<h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.companyCustomer.home.title\">--><!--tikonApp.companyCustomer.home.title--><!--</h3>--><!--</div>--><!--<div class=\"col-xs-3\" style=\"margin-right: -7px\">--><!--<md-button class=\"md-raised md-primary\" ui-sref=\"company-customer.new\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!--</md-button>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"\">--><!--<div class=\"\">--><!--<jhi-alert></jhi-alert>--><!--<div class=\"row\" style=\"padding-right: 8px\">--><!--<div class=\"form-group\">--><!--&lt;!&ndash;<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>&ndash;&gt;--><!--<div class=\"col-xs-10\">--><!--<input class=\"form-control rwTableSearchBox\"--><!--ng-model=\"vm.searchQuery\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><!--</div>--><!--<div class=\"col-xs-2\" style=\"margin-right: -30px;margin-top: -7px;\">--><!--<md-button id=\"search-btn-xs\" class=\"search-btn md-raised md-secondary\"--><!--ng-click=\"vm.search()\"--><!--&gt;--><!--<i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative;\">--><!--search--><!--</i>--><!--</md-button>--><!--</div>--><!--</div>--><!--</div>--><!--<div ng-repeat=\"companyCustomer in vm.companyCustomers track by companyCustomer.id\"--><!--class=\"orderBag-mobile-block\">--><!--&lt;!&ndash;<td>{{companyCustomer.customer.id }} </td>&ndash;&gt;--><!--<div>--><!--<div ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"row\">--><!--<div class=\"orderBag-mobile-float\">--><!--<i class=\"glyphicon glyphicon-user\"></i>--><!--{{companyCustomer.customer.personalInfo.fisrtName}}--><!--{{companyCustomer.customer.personalInfo.lastName}}--><!--</div>--><!--</div>--><!--<div class=\"row\" ng-if=\"companyCustomer.customer.personalInfo.email!=null\"--><!--style=\"padding-right: 8px\">--><!--<i class=\"glyphicon glyphicon-envelope\"></i>--><!--{{companyCustomer.customer.personalInfo.email}}--><!--</div>--><!--<div>--><!--<div class=\"orderBag-mobile-float companyCustomer-make-call\">--><!--<i class=\"fa fa-phone\"></i>--><!--<a href=\"tel:{{companyCustomer.customer.personalInfo.phoneNumber}}\">{{companyCustomer.customer.personalInfo.phoneNumber}}</a>--><!--&lt;!&ndash;{{companyCustomer.customer.personalInfo.phoneNumber}}&ndash;&gt;--><!--</div>--><!--<div style=\"text-align: left\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.edit({id:companyCustomer.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"vm.gotoNewReserve(companyCustomer.customer.id)\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-primary btn-sm\" style=\"background-color: rgb(96,125,139)\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"tikonApp.companyCustomer.newReserveForCustomer\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--<button type=\"button\"--><!--ui-sref=\"supplierPanel.deleteCompanyCustomer({id:companyCustomer.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"></ul>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/customer-rank/customer-rank-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerRank.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.customerRank.delete.question\" translate-values=\"{id: \'{{vm.customerRank.id}}\'}\">Are you sure you want to delete this Customer Rank?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/customer-rank/customer-rank-detail.html","<div><h2><span translate=\"tikonApp.customerRank.detail.title\">Customer Rank</span> {{vm.customerRank.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.customerRank.createDate\">Create Date</span></dt><dd><span>{{vm.customerRank.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.customerRank.rankValue\">Rank Value</span></dt><dd><span>{{vm.customerRank.rankValue}}</span></dd><dt><span translate=\"tikonApp.customerRank.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.customerRank.customerId})\">{{vm.customerRank.customerId}}</a></dd><dt><span translate=\"tikonApp.customerRank.serviceItem\">Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.customerRank.serviceItemId})\">{{vm.customerRank.serviceItemId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/customer-rank/customer-rank-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCustomerRankLabel\" translate=\"tikonApp.customerRank.home.createOrEditLabel\">Create or edit a Customer Rank</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.customerRank.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.customerRank.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customerRank.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.customerRank.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.customerRank.rankValue\" for=\"field_rankValue\">Rank Value</label><input type=\"number\" class=\"form-control\" name=\"rankValue\" id=\"field_rankValue\" ng-model=\"vm.customerRank.rankValue\"></div><div class=\"form-group\"><label translate=\"tikonApp.customerRank.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.customerRank.customerId\" ng-options=\"customer.id as customer.id for customer in vm.customers\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.customerRank.serviceItem\" for=\"field_serviceItem\">Service Item</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.customerRank.serviceItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/customer-rank/customer-ranks.html","<div><h2 translate=\"tikonApp.customerRank.home.title\">Customer Ranks</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"customer-rank.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.customerRank.home.createLabel\">Create new Customer Rank</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.customerRank.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.customerRank.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"rankValue\"><span translate=\"tikonApp.customerRank.rankValue\">Rank Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"customerId\"><span translate=\"tikonApp.customerRank.customer\">Customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceItemId\"><span translate=\"tikonApp.customerRank.serviceItem\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"customerRank in vm.customerRanks track by customerRank.id\"><td><a ui-sref=\"customer-rank-detail({id:customerRank.id})\">{{customerRank.id}}</a></td><td>{{customerRank.createDate | date:\'medium\'}}</td><td>{{customerRank.rankValue}}</td><td><a ui-sref=\"customer-detail({id:customerRank.customerId})\">{{customerRank.customerId}}</a></td><td><a ui-sref=\"service-item-detail({id:customerRank.serviceItemId})\">{{customerRank.serviceItemId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"customer-rank-detail({id:customerRank.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"customer-rank.edit({id:customerRank.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"customer-rank.delete({id:customerRank.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/date-period/date-period-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.datePeriod.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.datePeriod.delete.question\" translate-values=\"{id: \'{{vm.datePeriod.id}}\'}\">Are you sure you want to delete this Date Period?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/date-period/date-period-detail.html","<div><h2><span translate=\"tikonApp.datePeriod.detail.title\">Date Period</span> {{vm.datePeriod.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.datePeriod.fromDate\">From Date</span></dt><dd><span>{{vm.datePeriod.fromDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"tikonApp.datePeriod.toDate\">To Date</span></dt><dd><span>{{vm.datePeriod.toDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"tikonApp.datePeriod.offdays\">Offdays</span></dt><dd><span ng-repeat=\"offdays in vm.datePeriod.offdays\"><a ui-sref=\"off-day-detail({id: {{offdays.id}}})\">{{offdays.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/date-period/date-period-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDatePeriodLabel\" translate=\"tikonApp.datePeriod.home.createOrEditLabel\">Create or edit a Date Period</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.datePeriod.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.datePeriod.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.datePeriod.fromDate\" for=\"field_fromDate\">From Date</label><div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.datePeriod.fromDate\" is-open=\"vm.datePickerOpenStatus.fromDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.datePeriod.toDate\" for=\"field_toDate\">To Date</label><div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.datePeriod.toDate\" is-open=\"vm.datePickerOpenStatus.toDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"tikonApp.datePeriod.offdays\" for=\"field_offdays\">Offdays</label><select class=\"form-control\" id=\"field_offdays\" multiple=\"multiple\" name=\"offdays\" ng-model=\"vm.datePeriod.offdays\" ng-options=\"offDay as offDay.id for offDay in vm.offdays track by offDay.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/date-period/date-periods.html","<div><h2 translate=\"tikonApp.datePeriod.home.title\">Date Periods</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"date-period.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.datePeriod.home.createLabel\">Create new Date Period</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.datePeriod.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromDate\"><span translate=\"tikonApp.datePeriod.fromDate\">From Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toDate\"><span translate=\"tikonApp.datePeriod.toDate\">To Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"datePeriod in vm.datePeriods track by datePeriod.id\"><td><a ui-sref=\"date-period-detail({id:datePeriod.id})\">{{datePeriod.id}}</a></td><td>{{datePeriod.fromDate | date:\'mediumDate\'}}</td><td>{{datePeriod.toDate | date:\'mediumDate\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"date-period-detail({id:datePeriod.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"date-period.edit({id:datePeriod.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"date-period.delete({id:datePeriod.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/discount-info/discount-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.discountInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.discountInfo.delete.question\" translate-values=\"{id: \'{{vm.discountInfo.id}}\'}\">Are you sure you want to delete this Discount Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/discount-info/discount-info-detail.html","<div><h2><span translate=\"tikonApp.discountInfo.detail.title\">Discount Info</span> {{vm.discountInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.discountInfo.fixedDiscount\">Fixed Discount</span></dt><dd><span>{{vm.discountInfo.fixedDiscount}}</span></dd><dt><span translate=\"tikonApp.discountInfo.discountType\">Discount Type</span></dt><dd><span translate=\"{{\'tikonApp.DiscountType.\' + vm.discountInfo.discountType}}\">{{vm.discountInfo.discountType}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/discount-info/discount-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDiscountInfoLabel\" translate=\"tikonApp.discountInfo.home.createOrEditLabel\">Create or edit a Discount Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.discountInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.discountInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.discountInfo.fixedDiscount\" for=\"field_fixedDiscount\">Fixed Discount</label><input type=\"number\" class=\"form-control\" name=\"fixedDiscount\" id=\"field_fixedDiscount\" ng-model=\"vm.discountInfo.fixedDiscount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.discountInfo.discountType\" for=\"field_discountType\">Discount Type</label><select class=\"form-control\" name=\"discountType\" ng-model=\"vm.discountInfo.discountType\" id=\"field_discountType\"><option value=\"FIXED\" translate=\"tikonApp.DiscountType.FIXED\">FIXED</option><option value=\"SCHEDULE_BASED\" translate=\"tikonApp.DiscountType.SCHEDULE_BASED\">SCHEDULE_BASED</option><option value=\"ITEM_QUANTITY_BASED\" translate=\"tikonApp.DiscountType.ITEM_QUANTITY_BASED\">ITEM_QUANTITY_BASED</option><option value=\"CUSTOMER_BASED\" translate=\"tikonApp.DiscountType.CUSTOMER_BASED\">CUSTOMER_BASED</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/discount-info/discount-infos.html","<div><h2 translate=\"tikonApp.discountInfo.home.title\">Discount Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"discount-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.discountInfo.home.createLabel\">Create new Discount Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.discountInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fixedDiscount\"><span translate=\"tikonApp.discountInfo.fixedDiscount\">Fixed Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountType\"><span translate=\"tikonApp.discountInfo.discountType\">Discount Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"discountInfo in vm.discountInfos track by discountInfo.id\"><td><a ui-sref=\"discount-info-detail({id:discountInfo.id})\">{{discountInfo.id}}</a></td><td>{{discountInfo.fixedDiscount}}</td><td translate=\"{{\'tikonApp.DiscountType.\' + discountInfo.discountType}}\">{{discountInfo.discountType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"discount-info-detail({id:discountInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"discount-info.edit({id:discountInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"discount-info.delete({id:discountInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/dynamic-rules/dynamic-rules.html","<div id=\"container-dynamic-rules\"><panel-pln-dynamic-rules id=\"dynamic-rules\"></panel-pln-dynamic-rules></div>");
$templateCache.put("app/entities/event-item/event-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceItem.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.eventItem.delete.question\" translate-values=\"{itemTitle: \'{{vm.serviceItem.itemTitle}}\'}\">Are you sure you want to delete this Service Item?</p></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></md-button></div></form>");
$templateCache.put("app/entities/event-item/event-item-list.html","<style>.serviceColorCircle {\n        width: 15px;\n        height: 15px;\n        /*padding: 13px;*/\n        /* margin: 13px; */\n\n        border-radius: 25px;\n    }\n\n    .modal-content {\n        border-radius: 4px;\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.eventItemList\">supplierPanel.sideMenu.eventItemList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.generalEventItem\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.eventItem.home.createLabel\">Create new Service Item</span></md-button><!--<md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0;\" ui-sref=\"supplierPanel.companyServiceCategoryList\">--><!--<span class=\"hidden-xs\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory\">--><!--serviceCategory--><!--</span>--><!--</md-button>--><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control rwTableSearchBox\" placeholder=\"{{ \'tikonApp.eventItem.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th><span></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"itemTitle\"><span translate=\"tikonApp.eventItem.itemTitle\">Item Title</span></th><!--<th st-sort=\"categoryId\"><span--><!--translate=\"tikonApp.eventItem.category\">Category</span></th>--><th st-sort=\"description\"><span translate=\"tikonApp.eventItem.description\">Description</span></th><th st-sort=\"onlineMeetingType\"><span translate=\"tikonApp.eventItem.onlineMeetingType\">onlineMeetingType</span></th><th st-sort=\"serviceStatus\"><span translate=\"tikonApp.eventItem.serviceStatus\">Service Status</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceItem in collection track by serviceItem.id\"><td><div><md-tooltip md-direction=\"top\">{{\'tikonApp.serviceItem.startVideoCall\' | translate}}</md-tooltip><a ng-click=\"vm.goToVideoCallEvent(serviceItem)\"><md-icon ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a></div></td><td><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div></td><td><a ui-sref=\"supplierPanel.generalEventItem({id:serviceItem.id})\">{{serviceItem.itemTitle}}</a></td><!--<td>--><!--{{vm.categoryName(serviceItem.category.categoryName)}}--><!--</td>--><td>{{serviceItem.description}}</td><td><span translate=\"{{\'tikonApp.OnlineMeetingType.\' + serviceItem.onlineMeetingType}}\">{{serviceItem.onlineMeetingType}}</span></td><td ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.generalEventItem({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.copyServiceItem(serviceItem.id)\" class=\"btn btn-secondary btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel.eventItemList.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.eventItemList\">supplierPanel.sideMenu.eventItemList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.generalEventItem\"><i class=\"fa fa-plus fa-lg\"></i></md-button><!--<md-button class=\"md-raised md-secondary\"    ui-sref=\"supplierPanel.companyServiceCategoryList\">--><!--<span class=\"\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory\">--><!--serviceCategory--><!--</span>--><!--</md-button>--><md-content class=\"rwMdContent\"><div class=\"orderBag-mobile-block\" ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\" ui-sref=\"supplierPanel.generalEventItem({id:serviceItem.id})\"><div class=\"row\"><div class=\"text-center\">{{serviceItem.itemTitle}}<!--<div style=\"font-size: 10px;color: #8c8c8c\"--><!--ng-if=\"serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">--><!--{{serviceItem.category.categoryName}}--><!--</div>--></div></div></div></md-content></div></div></div></div></div>");
$templateCache.put("app/entities/event-item/general-event-item.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><style>.shortTextBox {\n            width: 50px;\n            font-size: 16px;\n            font-weight: bold;\n            text-align: center;\n        }\n\n        .largeTextBox {\n            width: 100px;\n            font-size: 16px;\n            font-weight: bold;\n            text-align: center;\n        }\n\n        .serviceColorPick {\n            width: 100px;\n            height: 25px;\n            /*padding: 13px;*/\n            /* margin: 13px; */\n            margin: 0 5px 9px;\n            border-radius: 8px;\n        }\n\n        .shortInputEvent {\n            width: 130px;\n        }\n\n        .meetingLink {\n            direction: ltr;\n            text-align: end;\n            margin-top: 45px;\n            margin-right: -20px;\n        }\n\n        .eventInfoCopy {\n            display: flex;\n            flex-flow: column;\n            padding: 20px;\n            border: 1px solid gray;\n            border-radius: 5px;\n            background-color: #f5f5f5;\n        }\n\n        .copyButton {\n            margin-bottom: 10px;\n            font-size: 12px;\n            color: #2b6b7f;\n            max-width: fit-content;\n        }\n\n        @media screen and (max-width: 768px) {\n            .meetingLink {\n                direction: ltr;\n                text-align: unset;\n                margin-top: unset;\n                margin-right: unset;\n            }\n        }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\" class=\"md-raised md-primary\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.eventItemList\"><span><md-icon>list</md-icon></span><span translate=\"tikonApp.eventItem.backToEventList\">tikonApp.eventItem.backToEventList</span></md-button></div><div class=\"pull-right\" ng-if=\"vm.serviceItem.id!=null\"><md-button class=\"md-raised\" ng-click=\"vm.goToVideoCallEvent()\"><span><md-icon aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></span><span translate=\"tikonApp.eventItem.startVideoCall\">tikonApp.eventItem.startVideoCall</span></md-button></div><!--<a ui-sref=\"supplierPanel.schedulingv2({id:vm.serviceItem.id})\">--><!--<md-button--><!--class=\"md-raised\"--><!--&gt;--><!--<span><md-icon>schedule</md-icon></span>--><!--<span translate=\"tikonApp.serviceItem.scheduling\"></span>--><!--</md-button>--><!--</a>--></div><!--&#45;&#45; to be develope ......--><div class=\"\"></div><div class=\"panel\"><div class=\"panel-heading\" autofocus><span translate=\"supplierPanel.sideMenu.serviceItem.generalTab\">generalTab</span></div><div class=\"panel-body\"><div><div id=\"general\" class=\"\"><div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.onlineMeetingType\" for=\"field_onlineMeetingType\">onlineMeetingType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.onlineMeetingType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_onlineMeetingType\"><md-option value=\"WEBINAR\" translate=\"tikonApp.OnlineMeetingType.WEBINAR\">WEBINAR</md-option><md-option value=\"CONFERENCE\" translate=\"tikonApp.OnlineMeetingType.CONFERENCE\">CONFERENCE</md-option><md-option value=\"CLASS\" translate=\"tikonApp.OnlineMeetingType.CLASS\">CLASS</md-option></md-select></div></div></div><div ng-if=\"vm.serviceItem.onlineMeetingType\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"vm.serviceItem.itemTitle\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.duration\" required for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInputEvent\" eo-required=\"\" ng-model=\"vm.serviceItem.duration\"></div><!--<div class=\"col-sm-6\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.eventItem.gapTime\"--><!--for=\"field_gapTime\">Duration</label>--><!--<input type=\"number\" id=\"field_gapTime\" class=\"form-control shortInput\"--><!--ng-model=\"vm.serviceItem.gaptime\">--><!--</div>--></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.eventCapacity\" for=\"field_qty\" eo-help-tooltip=\"tips.service_capacity\">Qty</label><input type=\"number\" class=\"form-control shortInputEvent\" min=\"1\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.serviceItem.capacityInfo.qty\" max=\"100\"></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceItem.description\"></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"padding-top: 32px\"><md-checkbox ng-model=\"vm.isVideoMeeting\" disabled=\"true\" ng-change=\"vm.meetingCheckChange()\"><!--eo-help-tooltip=\"tips.service_meeting_type\" --> {{\'tikonApp.eventItem.meetingType.RW_VIDEO_CALL\' | translate}}<md-icon aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px;padding-top: 4px\">videocam</md-icon></md-checkbox></div></div></div><div class=\"row\"><div class=\"col-sm-4\" ng-if=\"vm.serviceItem.onlineMeetingType !=\'CONFERENCE\'\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.serviceStatus\" for=\"field_serviceStatus\" eo-help-tooltip=\"tips.service_status\">Service Status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.serviceStatus\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_serviceStatus\"><md-option value=\"DISABLE\" translate=\"tikonApp.ServiceItemStatus.DISABLE\">DISABLE</md-option><md-option value=\"PUBLISH\" translate=\"tikonApp.ServiceItemStatus.PUBLISH\">PUBLISH</md-option><md-option value=\"RESERVE_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.RESERVE_JUST_PANEL\">RESERVE_JUST_PANEL</md-option><md-option value=\"PUBLISH_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.PUBLISH_JUST_PANEL\">PUBLISH_JUST_PANEL</md-option></md-select></div></div><div class=\"col-sm-4\" ng-if=\"vm.serviceItem.onlineMeetingType ==\'CONFERENCE\'\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.serviceStatus\" for=\"field_serviceStatusConference\" eo-help-tooltip=\"tips.service_status\">Service Status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.serviceStatus\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_serviceStatusConference\"><md-option value=\"DISABLE\" translate=\"tikonApp.ServiceItemStatus.DISABLE\">DISABLE</md-option><md-option value=\"PUBLISH_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.ACTIVE\">PUBLISH_JUST_PANEL</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.category\" required for=\"field_category\" eo-help-tooltip=\"tips.service_category\">Category</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.eventItem.selectCategory\' | translate}}\" ng-model=\"vm.serviceItem.category.id\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_category\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servicecategories\">{{si.categoryName}}</md-option></md-select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.serviceColor\" for=\"field_description\">Description</label><div><md-select class=\"rwMdSelect\" name=\"serviceColor\" ng-model=\"vm.serviceItem.color\" required><md-option ng-repeat=\"color in vm.serviceColors\" ng-value=\"color\"><div ng-class=\"color\" class=\"serviceColorPick\"></div></md-option></md-select></div></div></div></div></div></div><br></div><div class=\"form-group\" ng-if=\"vm.serviceItem.onlineMeetingType\"><div><label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.eventItem.fullDescription\" for=\"field_fullDescription\">Full Description</label><div height=\"150\" type=\"text\" summernote class=\"form-control\" name=\"fullDescription\" id=\"field_fullDescription\" ng-model=\"vm.serviceItem.fullDescription\"></div></div></div></div></div></div><div id=\"meetingSettingSection\" ng-if=\"vm.showSection(\'meetingSettingSection\')\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.meetingSettingSession\">meetingSettingSession</span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"form-group col-md-3\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.onlineMeetingAccessType\">onlineMeetingAccessType</label><md-radio-group ng-model=\"vm.serviceItem.onlineMeetingAccessType\" ng-change=\"vm.onlineMeetingAccessType_Change()\" layout=\"row\" class=\"setting-radio-box-inside\"><md-radio-button class=\"md-primary\" value=\"PUBLIC\"><span translate=\"tikonApp.OnlineMeetingAccessType.PUBLIC\">PUBLIC</span></md-radio-button><md-radio-button class=\"md-primary\" value=\"PRIVATE\"><span translate=\"tikonApp.OnlineMeetingAccessType.PRIVATE\">PRIVATE</span></md-radio-button></md-radio-group></div><div class=\"col-md-3\" ng-if=\"vm.serviceItem.onlineMeetingAccessType ==\'PRIVATE\'\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.customMeetingPassword\" for=\"field_customMeetingPassword\">customMeetingPassword</label><input type=\"text\" class=\"form-control\" name=\"customMeetingPassword\" id=\"field_customMeetingPassword\" ng-model=\"vm.serviceItem.customMeetingPassword\" style=\"direction: ltr\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.servantMeetingPassword\" for=\"field_servantMeetingPassword\">servantMeetingPassword</label><input type=\"text\" class=\"form-control\" name=\"servantMeetingPassword\" id=\"field_servantMeetingPassword\" ng-model=\"vm.serviceItem.servantMeetingPassword\" style=\"direction: ltr\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.customMeetingLink\" for=\"field_customMeetingLink\">customMeetingLink</label><input type=\"text\" class=\"form-control\" name=\"customMeetingLink\" id=\"field_customMeetingLink\" ng-model=\"vm.serviceItem.customMeetingLink\" pattern=\"[a-zA-Z0-9]{3,22}$\" style=\"direction: ltr\"><div class=\"error-message\" ng-messages=\"editForm.customMeetingLink.$error\" ng-show=\"editForm.customMeetingLink.$touched\"><p ng-message=\"pattern\"><span translate=\"tikonApp.eventItem.errorMsg.customMeetingLink_isnotvalid\"></span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.onlineMeetingInfoToCopy\" for=\"field_customMeetingLink\">onlineMeetingInfoToCopy</label><div class=\"eventInfoCopy\"><div class=\"copyButton\" ng-click=\"vm.copyEventInfo(false)\"><md-icon style=\"color: #2b6b7f;font-size: 22px\">content_copy</md-icon><span>کپی</span></div><div>{{vm.serviceItem.itemTitle}}</div><div ng-if=\"vm.serviceItem.onlineMeetingAccessType == \'PRIVATE\'\">رمز ورود به جلسه : {{vm.serviceItem.customMeetingPassword}}</div><div class=\"form-group\"><span>لینک ورود : </span><a ng-href=\"{{vm.meetingLink}}\" target=\"_blank\">{{vm.meetingLink}}</a></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.onlineServantMeetingInfoToCopy\">onlineServantMeetingInfoToCopy</label><div class=\"eventInfoCopy\"><div class=\"copyButton\" ng-click=\"vm.copyEventInfo(true)\"><md-icon style=\"color: #2b6b7f;font-size: 22px\">content_copy</md-icon><span>کپی</span></div><div>{{vm.serviceItem.itemTitle}}</div><div>رمز ورود به جلسه : {{vm.serviceItem.servantMeetingPassword}}</div><div class=\"form-group\"><span>لینک ورود : </span><a ng-href=\"{{vm.servantMeetingLink}}\" target=\"_blank\">{{vm.servantMeetingLink}}</a></div></div></div></div></div></div></div></div><div id=\"timeSection\" ng-if=\"vm.showSection(\'timeSection\')\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.eventItemSessions\" eo-help-tooltip=\"tips.event_times\">eventItemSessionsTab</span></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel-body\"><pf-event-item-schedules service-item-id=\"vm.serviceItemId\" selected-schedule-info=\"vm.serviceItem.scheduleInfo\" event-duration=\"vm.serviceItem.duration\"></pf-event-item-schedules></div></div></div></div></div><div id=\"servantSection\" ng-if=\"vm.serviceItem.onlineMeetingType\" class=\"panel\"><div class=\"panel-heading\"><span ng-if=\"vm.serviceItem.onlineMeetingType != \'CONFERENCE\'\" translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">servantTab</span> <span ng-if=\"vm.serviceItem.onlineMeetingType != \'CONFERENCE\'\" translate=\"tikonApp.eventItem.ServantSampleByActivityType.ActivityType.{{vm.currentCompany.activityType}}\" eo-help-tooltip=\"tips.service_servants\"></span> <span ng-if=\"vm.serviceItem.onlineMeetingType == \'CONFERENCE\'\" translate=\"tikonApp.eventItem.ServantSampleByActivityType.meetingManager\">Meeting Manager</span></div><div class=\"panel-body\"><div id=\"servants\"><pf-service-item-servants servants=\"vm.serviceItem.servants\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.servantFormState\" activity-type=\"vm.currentCompany.activityType\" single-selection=\"true\"></pf-service-item-servants></div><!--<hr/>--><!--<div style=\"max-width: 400px\" ng-if=\"vm.serviceItem.servants && vm.serviceItem.servants.length>0\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.eventItem.servantSelectMode\"--><!--for=\"field_servantSelectMode\"--><!--&gt;servantSelectMode--><!--</label>--><!--<md-select class=\"rwMdSelect\"--><!--ng-model=\"vm.serviceItem.servantSelectMode\"--><!--style=\"min-width: 250px;margin-top: 6px;\"--><!--id=\"field_serviceStatus\"--><!--&gt;--><!--<md-option value=\"SELECT_BY_CUSTOMER\" translate=\"tikonApp.ServantSelectMode.SELECT_BY_CUSTOMER\">--><!--SELECT_BY_CUSTOMER--><!--</md-option>--><!--<md-option value=\"AUTO_SELECT_MOST_FREE_SERVANT\"--><!--translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_MOST_FREE_SERVANT\">--><!--AUTO_SELECT_MOST_FREE_SERVANT--><!--</md-option>--><!--<md-option value=\"AUTO_SELECT_ROTATORY\"--><!--translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_ROTATORY\">--><!--AUTO_SELECT_ROTATORY--><!--</md-option>--><!--<md-option value=\"AUTO_SELECT_RANDOM\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_RANDOM\">--><!--AUTO_SELECT_RANDOM--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--></div></div><div id=\"gallerySection\" ng-if=\"vm.showSection(\'gallerySection\')\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.imageAlbumTab\" eo-help-tooltip=\"tips.service_images\">imageAlbumTab</span></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel-body\"><eo-image-gallery-manager album-id=\"vm.serviceItem.imageAlbumId\" max-image-count=\"1\" crop-width=\"348\" crop-height=\"248\" album-caption=\"vm.serviceItem.item_title\"></eo-image-gallery-manager></div></div></div></div></div><div id=\"agreementSection\" ng-if=\"vm.showSection(\'agreementSection\')\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.agreementTab\">agreementTab</span></div><div class=\"panel-body\"><pf-service-item-agreement-info agreement=\"vm.serviceItem.agreement\"></pf-service-item-agreement-info></div></div></div><!--<a ng-click=\"vm.showAdvancedSetting()\">--><!--تنظیمات پیشرفته +--><!--</a>--><div id=\"reserveSettingSection\" ng-if=\"vm.showSection(\'reserveSettingSection\')\"><div id=\"settingSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"tikonApp.eventItem.settingTab\">settingTab</span></div><div class=\"panel-body\"><div id=\"setting\" class=\"\"><!--<fieldset class=\"standard-fieldset\">--><!--<legend>--><!--<span--><!--eo-help-tooltip=\"tips.service_confirmation_type\"--><!--translate=\"tikonApp.eventItem.confirmationTypeFieldSet\"--><!--&gt;Confirmation Type</span>--><!--</legend>--><!--<div class=\"row\">--><!--<div class=\"form-group col-md-4\">--><!--<span--><!--translate=\"tikonApp.eventItem.customerConfirmationDeadline\"--><!--eo-help-tooltip=\"tips.service_customer_confirmation_deadline\"--><!--&gt;customerConfirmationDeadline</span>--><!--</div>--><!--<div class=\"form-group col-md-6\" style=\"direction: ltr\">--><!--<span>--><!--www.wedomeet.ir/meet/--><!--</span>--><!--<span>--><!--<input type=\"text\" class=\"shortTextBox\" name=\"customMeetingLink\"--><!--id=\"field_customMeetingLink\"--><!--ng-model=\"vm.serviceItem.customMeetingLink\"--><!--required--><!--/>--><!--</span>--><!--</div>--><!--</div>--><!--</fieldset>--><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.eventItem.minPrice\" for=\"field_minPrice\">Min Price</label><!--<span translate=\"global.currencyBracket\"></span>--> <input type=\"number\" class=\"form-control\" name=\"minPrice\" id=\"field_minPrice\" ng-model=\"vm.serviceItem.minPrice\" min=\"0\"></div></div></div><fieldset class=\"standard-fieldset\"><legend><span eo-help-tooltip=\"tips.service_confirmation_type\" translate=\"tikonApp.eventItem.confirmationTypeFieldSet\">Confirmation Type</span></legend><div class=\"row\"><div class=\"form-group col-md-4\"><md-radio-group ng-model=\"vm.serviceItem.confirmationType\" ng-change=\"vm.confirmationType_Change()\" layout=\"row\" class=\"setting-radio-box-inside\"><md-radio-button class=\"md-primary\" value=\"ONE_STEP\"><span translate=\"tikonApp.ServiceConfirmationType.ONE_STEP\">ONE_STEP</span></md-radio-button><md-radio-button eo-feature-checker=\"twoStepVerification\" class=\"md-primary\" value=\"TWO_STEP\"><span translate=\"tikonApp.ServiceConfirmationType.TWO_STEP\">TWO_STEP</span></md-radio-button></md-radio-group></div><div class=\"col-md-5\" ng-if=\"vm.serviceItem.confirmationType==\'TWO_STEP\'\" style=\"margin-top: -5px\"><span translate=\"tikonApp.eventItem.customerConfirmationDeadline\" eo-help-tooltip=\"tips.service_customer_confirmation_deadline\">customerConfirmationDeadline</span> <input type=\"number\" class=\"shortTextBox\" name=\"customerConfirmationDeadline\" id=\"field_customerConfirmationDeadline\" ng-model=\"vm.serviceItem.customerConfirmationDeadline\" min=\"1\"></div><!--content here --></div></fieldset><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.eventItem.paymentTypeFieldSet\">Payment Type</span></legend><div class=\"row\"><md-radio-group ng-model=\"vm.serviceItem.paymentType\" ng-change=\"vm.paymentType_changed()\"><div class=\"col-md-2\"><md-radio-button class=\"md-primary\" value=\"PAYMENT_ALL\"><span translate=\"tikonApp.ServicePaymentType.PAYMENT_ALL\">PAYMENT_ALL</span></md-radio-button></div><div class=\"col-md-3\"><md-radio-button class=\"md-primary\" value=\"PRE_PAYMENT\"><span translate=\"tikonApp.ServicePaymentType.PRE_PAYMENT\">PRE_PAYMENT</span></md-radio-button></div></md-radio-group><div class=\"col-md-5\" ng-if=\"vm.serviceItem.paymentType==\'PRE_PAYMENT\'\" style=\"margin-top: -5px\"><span translate=\"tikonApp.eventItem.prePaymentAmount\" for=\"field_prePaymentAmount\">Pre Payment Amount</span> <span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"largeTextBox\" name=\"prePaymentAmount\" id=\"field_prePaymentAmount\" ng-model=\"vm.serviceItem.prePaymentAmount\" min=\"0\"></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"onlineReserveLimitFieldSet\"><legend><span translate=\"tikonApp.eventItem.onlineReserveLimitFieldSet\">Online Reserve Limit</span></legend><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><span translate=\"tikonApp.eventItem.minPreReserveTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"minPreReserveTime\" id=\"field_minPreReserveTime\" ng-model=\"vm.serviceItem.minPreReserveTime\" min=\"0\"> <span translate=\"tikonApp.eventItem.minPreReserveTime2\"><!--eo-help-tooltip=\"tips.min_pre_reserve_time\"--> ></span></div></div><div class=\"col-md-5\"><div class=\"form-group\"><span translate=\"tikonApp.eventItem.maxPreReserveTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\" ng-model=\"vm.serviceItem.maxPreReserveTime\" min=\"0\"> <span translate=\"tikonApp.eventItem.maxPreReserveTime2\"><!--eo-help-tooltip=\"tips.max_pre_reserve_time\"--> ></span></div></div></div></fieldset><!--this line commented--><!--ng-if=\"vm.serviceItem.servants == null || vm.serviceItem.servants.length==0\"--><!--<fieldset class=\"standard-fieldset\" name=\"capacity\">--><!--<legend>--><!--<span--><!--translate=\"tikonApp.eventItem.capacityFieldSet\"--><!--&gt;Capacity</span>--><!--</legend>--><!--<div class=\"row\">--><!--</div>--><!--</fieldset>--><!--<fieldset class=\"standard-fieldset\" name=\"consecutiveReserveMode\">--><!--<legend>--><!--<span--><!--translate=\"tikonApp.eventItem.consecutiveReserveMode\"--><!--eo-help-tooltip=\"tips.consecutiveReserveMode\"--><!--&gt;Online Reserve Limit</span>--><!--</legend>--><!--<div class=\"row\">--><!--<div class=\"col-md-12\">--><!--<div class=\"form-group\">--><!--<md-radio-group class=\"setting-radio-box-inside\"--><!--ng-model=\"vm.serviceItem.consecutiveReserveMode\"--><!--layout=\"row\">--><!--<md-radio-button value=\"DISABLE\" class=\"md-primary\">--><!--<span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span>--><!--</md-radio-button>--><!--<md-radio-button value=\"ENABLE\" class=\"md-primary\">--><!--<span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span>--><!--</md-radio-button>--><!--</md-radio-group>--><!--</div>--><!--</div>--><!--</div>--><!--</fieldset>--><fieldset class=\"standard-fieldset\" name=\"cancellingSetting\"><legend><span translate=\"tikonApp.eventItem.cancellingSetting\">Cancelling Setting</span></legend><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.canBeCanceled\" layout=\"row\"><md-radio-button ng-value=\"false\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span></md-radio-button><md-radio-button ng-value=\"true\" class=\"md-primary\" eo-feature-checker=\"cancelReserveByCustomer\"><span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span></md-radio-button></md-radio-group></div></div><div class=\"col-md-9\" ng-if=\"vm.serviceItem.canBeCanceled\"><div class=\"form-group\"><span translate=\"tikonApp.eventItem.minPreCancelTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"maxPreReserveTime\" id=\"field_minPreCancelTime\" ng-model=\"vm.serviceItem.minPreCancelTime\" min=\"0\"> <span translate=\"tikonApp.eventItem.minPreCancelTime2\"></span></div></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"multiReserveMode\"><legend><span translate=\"tikonApp.eventItem.multiReserveMode\" eo-help-tooltip=\"tips.multiReserveMode\">multiReserveMode</span></legend><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"MANUAL\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.MANUAL\"></span></md-radio-button><md-radio-button value=\"AUTO\" class=\"md-primary\" eo-feature-checker=\"autoMultiReserveMode\"><span translate=\"tikonApp.MultiReserveMode.AUTO\"></span></md-radio-button></md-radio-group></div></div></div><div class=\"row\" data-ng-if=\"vm.serviceItem.multiReserveMode==\'AUTO\'\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.multiReserveModeConfig\">multiReserveModeConfig</label></div></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.multiReserveConfig.repeatCount\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatCount\">repeatCount</label><input type=\"number\" class=\"shortTextBox\" min=\"1\" name=\"repeatCount\" id=\"repeatCount\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatCount\"></div></div></div><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.eventItem.multiReserveConfig.repeatMode\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatMode\">repeatMode</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatMode\" layout=\"row\"><md-radio-button value=\"DAY_PERIOD\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.DAY_PERIOD\"></span></md-radio-button><md-radio-button value=\"WEEK_DAY\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.WEEK_DAY\"></span></md-radio-button></md-radio-group></div></div></div></div></div></fieldset></div></div></div></div><div id=\"serviceOptionSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.optionTab\" eo-help-tooltip=\"tips.service_options\">optionTab</span></div><div class=\"panel-body\"><pf-service-item-option-info service-option-item=\"vm.serviceItem.serviceOptionItem\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.serviceOptionInfoFormState\"></pf-service-item-option-info></div></div></div><div id=\"priceInfoSection\" ng-if=\"false\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.priceTab\" eo-help-tooltip=\"tips.service_price_info\">priceTab</span></div><div class=\"panel-body\"><pf-service-item-price-info service-item-id=\"vm.serviceItem.id\" on-create-new-price-info=\"vm.onCreateNewPriceInfo\" on-selected-price-info-changed=\"vm.onSelectedPriceInfoChanged\" form-state=\"vm.priceInfoFormState\" new-price-info=\"vm.serviceItem.newPriceInfo\" reload=\"vm.priceInfoFormReload\" price-infos=\"vm.serviceItem.servicePriceInfo\" price-info-type=\"vm.priceInfoType\"></pf-service-item-price-info></div></div></div><div id=\"marketPlaceSection\" ng-if=\"vm.showMarketPlaceSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"tikonApp.eventItem.marketPlaceTab\">marketPlaceTab</span> <span ng-if=\"vm.serviceItem.marketPlacePublishStatus\" ng-class=\"vm.findMarketPlacePublishStatusStyle()\">- <span translate=\"{{\'tikonApp.MarketPlacePublishStatus.\' + vm.serviceItem.marketPlacePublishStatus}}\">{{vm.serviceItem.marketPlacePublishStatus}} </span><span ng-class=\"vm.findMarketPlacePublishStatusIcon(vm.serviceItem.marketPlacePublishStatus)\"></span></span></div><div class=\"panel-body\"><md-switch ng-model=\"vm.showOnMarketPlace\">نمایش در سایتهای دیگر (جذب مشتری)</md-switch></div></div></div><md-button ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\" class=\"md-raised md-primary\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\">Save</span></md-button></div></form>");
$templateCache.put("app/entities/event-services/event-services.html","<div id=\"container-event-services\"><panel-pln-event-services id=\"event-services\"></panel-pln-event-services></div>");
$templateCache.put("app/entities/extra-setting/extra-setting-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.extraSetting.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.extraSetting.delete.question\" translate-values=\"{id: \'{{vm.extraSetting.id}}\'}\">Are you sure you want to delete this Extra Setting?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/extra-setting/extra-setting-detail.html","<div><h2><span translate=\"tikonApp.extraSetting.detail.title\">Extra Setting</span> {{vm.extraSetting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.extraSetting.key\">Key</span></dt><dd><span>{{vm.extraSetting.key}}</span></dd><dt><span translate=\"tikonApp.extraSetting.value\">Value</span></dt><dd><span>{{vm.extraSetting.value}}</span></dd><dt><span translate=\"tikonApp.extraSetting.settingInfo\">Setting Info</span></dt><dd><a ui-sref=\"setting-info-detail({id:vm.extraSetting.settingInfoId})\">{{vm.extraSetting.settingInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/extra-setting/extra-setting-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myExtraSettingLabel\" translate=\"tikonApp.extraSetting.home.createOrEditLabel\">Create or edit a Extra Setting</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.extraSetting.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.extraSetting.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.extraSetting.key\" for=\"field_key\">Key</label><input type=\"text\" class=\"form-control\" name=\"key\" id=\"field_key\" ng-model=\"vm.extraSetting.key\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.extraSetting.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.extraSetting.value\"></div><div class=\"form-group\"><label translate=\"tikonApp.extraSetting.settingInfo\" for=\"field_settingInfo\">Setting Info</label><select class=\"form-control\" id=\"field_settingInfo\" name=\"settingInfo\" ng-model=\"vm.extraSetting.settingInfoId\" ng-options=\"settingInfo.id as settingInfo.id for settingInfo in vm.settinginfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/extra-setting/extra-settings.html","<div><h2 translate=\"tikonApp.extraSetting.home.title\">Extra Settings</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"extra-setting.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.extraSetting.home.createLabel\">Create new Extra Setting</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.extraSetting.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"key\"><span translate=\"tikonApp.extraSetting.key\">Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"tikonApp.extraSetting.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"settingInfoId\"><span translate=\"tikonApp.extraSetting.settingInfo\">Setting Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"extraSetting in vm.extraSettings track by extraSetting.id\"><td><a ui-sref=\"extra-setting-detail({id:extraSetting.id})\">{{extraSetting.id}}</a></td><td>{{extraSetting.key}}</td><td>{{extraSetting.value}}</td><td><a ui-sref=\"setting-info-detail({id:extraSetting.settingInfoId})\">{{extraSetting.settingInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"extra-setting-detail({id:extraSetting.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"extra-setting.edit({id:extraSetting.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"extra-setting.delete({id:extraSetting.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/financial-setting/financial-setting-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.financialSetting.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.financialSetting.delete.question\" translate-values=\"{id: \'{{vm.financialSetting.id}}\'}\">Are you sure you want to delete this Financial Setting?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/financial-setting/financial-setting-detail.html","<div><h2><span translate=\"tikonApp.financialSetting.detail.title\">Financial Setting</span> {{vm.financialSetting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.financialSetting.taxPercentage\">Tax Percentage</span></dt><dd><span>{{vm.financialSetting.taxPercentage}}</span></dd><dt><span translate=\"tikonApp.financialSetting.hasDiscount\">Has Discount</span></dt><dd><span>{{vm.financialSetting.hasDiscount}}</span></dd><dt><span translate=\"tikonApp.financialSetting.currency\">Currency</span></dt><dd><span translate=\"{{\'tikonApp.Currency.\' + vm.financialSetting.currency}}\">{{vm.financialSetting.currency}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/financial-setting/financial-setting-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFinancialSettingLabel\" translate=\"tikonApp.financialSetting.home.createOrEditLabel\">Create or edit a Financial Setting</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.financialSetting.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.financialSetting.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.financialSetting.taxPercentage\" for=\"field_taxPercentage\">Tax Percentage</label><input type=\"number\" class=\"form-control\" name=\"taxPercentage\" id=\"field_taxPercentage\" ng-model=\"vm.financialSetting.taxPercentage\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.financialSetting.hasDiscount\" for=\"field_hasDiscount\">Has Discount</label><input type=\"checkbox\" class=\"form-control\" name=\"hasDiscount\" id=\"field_hasDiscount\" ng-model=\"vm.financialSetting.hasDiscount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.financialSetting.currency\" for=\"field_currency\">Currency</label><select class=\"form-control\" name=\"currency\" ng-model=\"vm.financialSetting.currency\" id=\"field_currency\"><option value=\"RIAL\" translate=\"tikonApp.Currency.RIAL\">RIAL</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/financial-setting/financial-settings.html","<div><h2 translate=\"tikonApp.financialSetting.home.title\">Financial Settings</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"financial-setting.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.financialSetting.home.createLabel\">Create new Financial Setting</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.financialSetting.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxPercentage\"><span translate=\"tikonApp.financialSetting.taxPercentage\">Tax Percentage</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"hasDiscount\"><span translate=\"tikonApp.financialSetting.hasDiscount\">Has Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"currency\"><span translate=\"tikonApp.financialSetting.currency\">Currency</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"financialSetting in vm.financialSettings track by financialSetting.id\"><td><a ui-sref=\"financial-setting-detail({id:financialSetting.id})\">{{financialSetting.id}}</a></td><td>{{financialSetting.taxPercentage}}</td><td>{{financialSetting.hasDiscount}}</td><td translate=\"{{\'tikonApp.Currency.\' + financialSetting.currency}}\">{{financialSetting.currency}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"financial-setting-detail({id:financialSetting.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"financial-setting.edit({id:financialSetting.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"financial-setting.delete({id:financialSetting.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/form-builder/form-builder.html","<div id=\"container-form-builder\"><panel-pln-form-builder id=\"form-builder\"></panel-pln-form-builder></div>");
$templateCache.put("app/entities/image-data/image-data-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.imageData.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.imageData.delete.question\" translate-values=\"{id: \'{{vm.imageData.id}}\'}\">Are you sure you want to delete this Image Data?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/image-data/image-data-detail.html","<div><h2><span translate=\"tikonApp.imageData.detail.title\">Image Data</span> {{vm.imageData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.imageData.fileName\">File Name</span></dt><dd><span>{{vm.imageData.fileName}}</span></dd><dt><span translate=\"tikonApp.imageData.caption\">Caption</span></dt><dd><span>{{vm.imageData.caption}}</span></dd><dt><span translate=\"tikonApp.imageData.fileType\">File Type</span></dt><dd><span>{{vm.imageData.fileType}}</span></dd><dt><span translate=\"tikonApp.imageData.fileData\">File Data</span></dt><dd><div ng-if=\"vm.imageData.fileData\"><a ng-click=\"vm.openFile(vm.imageData.fileDataContentType, vm.imageData.fileData)\" translate=\"entity.action.open\">open</a> {{vm.imageData.fileDataContentType}}, {{vm.byteSize(vm.imageData.fileData)}}</div></dd><dt><span translate=\"tikonApp.imageData.thumbnailData\">Thumbnail Data</span></dt><dd><div ng-if=\"vm.imageData.thumbnailData\"><a ng-click=\"vm.openFile(vm.imageData.thumbnailDataContentType, vm.imageData.thumbnailData)\" translate=\"entity.action.open\">open</a> {{vm.imageData.thumbnailDataContentType}}, {{vm.byteSize(vm.imageData.thumbnailData)}}</div></dd><dt><span translate=\"tikonApp.imageData.isCoverImage\">Is Cover Image</span></dt><dd><span>{{vm.imageData.isCoverImage}}</span></dd><dt><span translate=\"tikonApp.imageData.albumInfo\">Album Info</span></dt><dd><a ui-sref=\"album-info-detail({id:vm.imageData.albumInfoId})\">{{vm.imageData.albumInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/image-data/image-data-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImageDataLabel\" translate=\"tikonApp.imageData.home.createOrEditLabel\">Create or edit a Image Data</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.imageData.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.imageData.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.fileName\" for=\"field_fileName\">File Name</label><input type=\"text\" class=\"form-control\" name=\"fileName\" id=\"field_fileName\" ng-model=\"vm.imageData.fileName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.caption\" for=\"field_caption\">Caption</label><input type=\"text\" class=\"form-control\" name=\"caption\" id=\"field_caption\" ng-model=\"vm.imageData.caption\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.fileType\" for=\"field_fileType\">File Type</label><input type=\"text\" class=\"form-control\" name=\"fileType\" id=\"field_fileType\" ng-model=\"vm.imageData.fileType\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setFileData($file, vm.imageData)\"><label class=\"control-label\" translate=\"tikonApp.imageData.fileData\" for=\"field_fileData\">File Data</label><div><div class=\"row\"><div class=\"col-sm-4\"></div><div class=\"col-sm-4\"><!--<div ng-if=\"vm.imageData.fileData\" class=\"help-block clearfix\">--><!--<a class=\"pull-left\" ng-click=\"vm.openFile(vm.imageData.fileDataContentType, vm.imageData.fileData)\" translate=\"entity.action.open\">open</a><br>--><!--<span class=\"pull-left\">{{vm.imageData.fileDataContentType}}, {{vm.byteSize(vm.imageData.fileData)}}</span>--><!--<button ng-click=\"vm.imageData.fileData=null;vm.imageData.fileDataContentType=null;\"--><!--class=\"btn btn-default btn-xs pull-right\">--><!--<span class=\"glyphicon glyphicon-remove\"></span>--><!--</button>--><!--</div>--> <button type=\"file\" ngf-pattern=\"\'image/*\'\" ng-model=\"vm.file1\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"1MB\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setFileData($file, vm.imageData)\" translate=\"entity.action.addblob\">Add blob</button><!--<img  ngf-size=\"{width: 100, height: 100, quality: 0.9}\"  ngf-thumbnail=\"vm.file1 || \'/thumb.jpg\'\"/>--><div ng-class=\"  {\'noimage imageholder \' :vm.imageData.fileData==null,\'imageholder\':vm.imageData.fileData!=null}\"><img ng-src=\"{{vm.imagesrc(vm.imageData.fileDataContentType, vm.imageData.fileData)}}\"></div><div class=\"col-sm-4\"></div></div></div></div><input type=\"hidden\" class=\"form-control\" name=\"fileData\" id=\"field_fileData\" ng-model=\"vm.imageData.fileData\"> <input type=\"hidden\" class=\"form-control\" name=\"fileDataContentType\" id=\"field_fileDataContentType\" ng-model=\"vm.imageData.fileDataContentType\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setThumbnailData($file, vm.imageData)\"><label class=\"control-label\" translate=\"tikonApp.imageData.thumbnailData\" for=\"field_thumbnailData\">Thumbnail Data</label><div><div ng-if=\"vm.imageData.thumbnailData\" class=\"help-block clearfix\"><a class=\"pull-left\" ng-click=\"vm.openFile(vm.imageData.thumbnailDataContentType, vm.imageData.thumbnailData)\" translate=\"entity.action.open\">open</a><br><span class=\"pull-left\">{{vm.imageData.thumbnailDataContentType}}, {{vm.byteSize(vm.imageData.thumbnailData)}}</span> <button ng-click=\"vm.imageData.thumbnailData=null;vm.imageData.thumbnailDataContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setThumbnailData($file, vm.imageData)\" translate=\"entity.action.addblob\">Add blob</button></div><input type=\"hidden\" class=\"form-control\" name=\"thumbnailData\" id=\"field_thumbnailData\" ng-model=\"vm.imageData.thumbnailData\"> <input type=\"hidden\" class=\"form-control\" name=\"thumbnailDataContentType\" id=\"field_thumbnailDataContentType\" ng-model=\"vm.imageData.thumbnailDataContentType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.isCoverImage\" for=\"field_isCoverImage\">Is Cover Image</label><input type=\"checkbox\" class=\"form-control\" name=\"isCoverImage\" id=\"field_isCoverImage\" ng-model=\"vm.imageData.isCoverImage\"></div><div class=\"form-group\"><label translate=\"tikonApp.imageData.albumInfo\" for=\"field_albumInfo\">Album Info</label><select class=\"form-control\" id=\"field_albumInfo\" name=\"albumInfo\" ng-model=\"vm.imageData.albumInfoId\" ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/image-data/image-data.html","<div><h2 translate=\"tikonApp.imageData.home.title\">Image Data</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"image-data.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.imageData.home.createLabel\">Create new Image Data</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.imageData.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileName\"><span translate=\"tikonApp.imageData.fileName\">File Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"caption\"><span translate=\"tikonApp.imageData.caption\">Caption</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileType\"><span translate=\"tikonApp.imageData.fileType\">File Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileData\"><span translate=\"tikonApp.imageData.fileData\">File Data</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"thumbnailData\"><span translate=\"tikonApp.imageData.thumbnailData\">Thumbnail Data</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isCoverImage\"><span translate=\"tikonApp.imageData.isCoverImage\">Is Cover Image</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"albumInfoId\"><span translate=\"tikonApp.imageData.albumInfo\">Album Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"imageData in vm.imageData track by imageData.id\"><td><a ui-sref=\"image-data-detail({id:imageData.id})\">{{imageData.id}}</a></td><td>{{imageData.fileName}}</td><td>{{imageData.caption}}</td><td>{{imageData.fileType}}</td><td><a ng-if=\"imageData.fileData\" ng-click=\"vm.openFile(imageData.fileDataContentType, imageData.fileData)\" translate=\"entity.action.open\">open</a> <span ng-if=\"imageData.fileData\">{{imageData.fileDataContentType}}, {{vm.byteSize(imageData.fileData)}}</span></td><td><a ng-if=\"imageData.thumbnailData\" ng-click=\"vm.openFile(imageData.thumbnailDataContentType, imageData.thumbnailData)\" translate=\"entity.action.open\">open</a> <span ng-if=\"imageData.thumbnailData\">{{imageData.thumbnailDataContentType}}, {{vm.byteSize(imageData.thumbnailData)}}</span></td><td>{{imageData.isCoverImage}}</td><td><a ui-sref=\"album-info-detail({id:imageData.albumInfoId})\">{{imageData.albumInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"image-data-detail({id:imageData.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"image-data.edit({id:imageData.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"image-data.delete({id:imageData.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/image-data/single-image-data.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImageDataLabel\" translate=\"tikonApp.imageData.home.createOrEditLabel\">Create or edit a Image Data</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.imageData.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.imageData.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.fileName\" for=\"field_fileName\">File Name</label><input type=\"text\" class=\"form-control\" name=\"fileName\" id=\"field_fileName\" ng-model=\"vm.imageData.fileName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.caption\" for=\"field_caption\">Caption</label><input type=\"text\" class=\"form-control\" name=\"caption\" id=\"field_caption\" ng-model=\"vm.imageData.caption\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.fileType\" for=\"field_fileType\">File Type</label><input type=\"text\" class=\"form-control\" name=\"fileType\" id=\"field_fileType\" ng-model=\"vm.imageData.fileType\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setFileData($file, vm.imageData)\"><label class=\"control-label\" translate=\"tikonApp.imageData.fileData\" for=\"field_fileData\">File Data</label><div><div class=\"row\"><div class=\"col-sm-4\"></div><div class=\"col-sm-4\"><!--<div ng-if=\"vm.imageData.fileData\" class=\"help-block clearfix\">--><!--<a class=\"pull-left\" ng-click=\"vm.openFile(vm.imageData.fileDataContentType, vm.imageData.fileData)\" translate=\"entity.action.open\">open</a><br>--><!--<span class=\"pull-left\">{{vm.imageData.fileDataContentType}}, {{vm.byteSize(vm.imageData.fileData)}}</span>--><!--<button ng-click=\"vm.imageData.fileData=null;vm.imageData.fileDataContentType=null;\"--><!--class=\"btn btn-default btn-xs pull-right\">--><!--<span class=\"glyphicon glyphicon-remove\"></span>--><!--</button>--><!--</div>--> <button type=\"file\" ngf-pattern=\"\'image/*\'\" ng-model=\"vm.file1\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"1MB\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setFileData($file, vm.imageData)\" translate=\"entity.action.addblob\">Add blob</button><!--<img  ngf-size=\"{width: 100, height: 100, quality: 0.9}\"  ngf-thumbnail=\"vm.file1 || \'/thumb.jpg\'\"/>--><div ng-class=\"  {\'noimage imageholder \' :vm.imageData.fileData==null,\'imageholder\':vm.imageData.fileData!=null}\"><img ng-src=\"{{vm.imagesrc(vm.imageData.fileDataContentType, vm.imageData.fileData)}}\"></div><div class=\"col-sm-4\"></div></div></div></div><input type=\"hidden\" class=\"form-control\" name=\"fileData\" id=\"field_fileData\" ng-model=\"vm.imageData.fileData\"> <input type=\"hidden\" class=\"form-control\" name=\"fileDataContentType\" id=\"field_fileDataContentType\" ng-model=\"vm.imageData.fileDataContentType\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setThumbnailData($file, vm.imageData)\"><label class=\"control-label\" translate=\"tikonApp.imageData.thumbnailData\" for=\"field_thumbnailData\">Thumbnail Data</label><div><div ng-if=\"vm.imageData.thumbnailData\" class=\"help-block clearfix\"><a class=\"pull-left\" ng-click=\"vm.openFile(vm.imageData.thumbnailDataContentType, vm.imageData.thumbnailData)\" translate=\"entity.action.open\">open</a><br><span class=\"pull-left\">{{vm.imageData.thumbnailDataContentType}}, {{vm.byteSize(vm.imageData.thumbnailData)}}</span> <button ng-click=\"vm.imageData.thumbnailData=null;vm.imageData.thumbnailDataContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setThumbnailData($file, vm.imageData)\" translate=\"entity.action.addblob\">Add blob</button></div><input type=\"hidden\" class=\"form-control\" name=\"thumbnailData\" id=\"field_thumbnailData\" ng-model=\"vm.imageData.thumbnailData\"> <input type=\"hidden\" class=\"form-control\" name=\"thumbnailDataContentType\" id=\"field_thumbnailDataContentType\" ng-model=\"vm.imageData.thumbnailDataContentType\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.imageData.isCoverImage\" for=\"field_isCoverImage\">Is Cover Image</label><input type=\"checkbox\" class=\"form-control\" name=\"isCoverImage\" id=\"field_isCoverImage\" ng-model=\"vm.imageData.isCoverImage\"></div><div class=\"form-group\"><label translate=\"tikonApp.imageData.albumInfo\" for=\"field_albumInfo\">Album Info</label><select class=\"form-control\" id=\"field_albumInfo\" name=\"albumInfo\" ng-model=\"vm.imageData.albumInfoId\" ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/invoice-info/add-invoice-item-modal.html","<style>md-icon {\n        color: unset;\n    }</style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><jhi-alert-error></jhi-alert-error><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><form name=\"editForm\"><div class=\"row\" style=\"padding-top: 80px\"><div class=\"col-md-6 invoice-selection-items-container\"><ul class=\"pl-nav-tabs\"><li class=\"active\" ng-click=\"vm.tabChanged(\'serviceTab\')\"><a data-target=\"#serviceTab\" data-toggle=\"tab\"><md-icon>business_center</md-icon>خدمات</a></li><li ng-click=\"vm.tabChanged(\'serviceAddOnTab\')\"><a data-target=\"#serviceAddOnTab\" data-toggle=\"tab\"><md-icon>star</md-icon><span>خدمات ویژه</span></a></li></ul><div class=\"tab-pane active\" style=\"background: none\" id=\"serviceTab\"><div class=\"container-fluid pl-container-fluid\"><div id=\"selectServiceItem\" class=\"row\" ng-if=\"vm.itemSelectionType==\'SERVICE\'\"><div><div class=\"col-md-12\"><label class=\"control-label\">جستجو</label><pf-service-item-picker selected-service=\"vm.selectedServiceItem\" is-disabled=\"false\" servant-id=\"null\" on-service-changed=\"vm.onServiceChanged()\"></pf-service-item-picker><div class=\"invoice-item-selection-container\"><div id=\"serviceListId\" ng-repeat=\"si in vm.serviceItemList\"><div ng-click=\"vm.onServiceItemClick(si)\" class=\"invoice-item-service-selection\"><div ng-class=\"si.color\" class=\"invoice-item-select-service-color-circle\"></div><div>{{si.itemTitle}}</div></div></div></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"serviceAddOnTab\"><div class=\"container-fluid pl-container-fluid\"><div id=\"selectServiceAddOn\" class=\"row\" ng-if=\"vm.itemSelectionType==\'SERVICE_ADD_ON\'\"><div class=\"col-md-12\"><div class=\"invoice-item-selection-container\" ng-if=\"vm.serviceAddOnList && vm.serviceAddOnList.length > 0\"><div id=\"serviceAddOnListId\" ng-repeat=\"si in vm.serviceAddOnList\"><div ng-click=\"vm.onServiceAddOnClick(si)\" class=\"invoice-item-service-selection\"><div ng-class=\"\'COLOR\'\" class=\"invoice-item-select-service-color-circle\"></div><div>{{si.title}}</div></div></div></div><div ng-if=\"!vm.serviceAddOnList || vm.serviceAddOnList.length == 0\"><eo-no-data message=\"vm.noServiceAddOnMsg\"></eo-no-data><div style=\"text-align: center\"><md-button type=\"button\" ng-click=\"vm.goToServiceAddOn()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.serviceAddOn.home.new\">new</span></md-button></div></div></div></div></div></div></div><div class=\"col-md-6\"><div class=\"pl-panel\" style=\"margin: 0\"><div class=\"panel-heading pl-panel-heading\">آیتم های انتخاب شده</div><div class=\"panel-body pl-panel-body\" style=\"padding: 50px 6px\"><div ng-if=\"vm.invoiceInfoItems && vm.invoiceInfoItems.length > 0\" class=\"table-responsive\"><table class=\"table rwTable\"><thead><th><span translate=\"tikonApp.invoiceInfoItem.title\"></span></th><th><span translate=\"tikonApp.invoiceInfoItem.priceCurrency\"></span></th><th></th><!--<th><span translate=\"tikonApp.invoiceInfoItem.qty\"></span></th>--><!--<th></th>--></thead><tbody><tr ng-repeat=\"item in vm.invoiceInfoItems\"><td><span>{{item.title}}</span></td><td><span>{{item.price | number}}</span></td><td><span ng-click=\"vm.deleteItem(item)\"><i style=\"color: red\" class=\"fa fa-remove\"></i></span></td></tr></tbody></table></div><div ng-if=\"!vm.invoiceInfoItems || vm.invoiceInfoItems.length == 0\"><eo-no-data message=\"vm.noItemMsg\"></eo-no-data></div></div></div></div></div></form></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/invoice-info/filter-invoice-info-list-dialog.html","<style>.panel {\n        margin: 0;\n\n    }\n\n    .filter_by_select > md-select-value > span {\n        display: -webkit-inline-box;\n    }\n\n    .custom-panel-style {\n        min-height: 320px;\n    }\n\n    @media (max-width: 767px) {\n        .custom-panel-style {\n            min-height: 415px;\n        }\n    }</style><md-dialog class=\"pl-md-dialog\"><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div>اعمال فیلتر (جستجوی پیشرفته)</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><md-dialog-content class=\"pl-dialog-content\"><div class=\"\"><div class=\"panel-body custom-panel-style\"><div id=\"filters_content\"><div class=\"row\"><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"$ctrl.data.filterQuery.fromDate\"></eo-date-picker></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"$ctrl.data.filterQuery.toDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.filterStatus\">Status</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\" id=\"field_filterStatus\" placeholder=\"{{\'tikonApp.invoiceInfo.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery.status\" style=\"min-width: 100px\"><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.data.statusList\">{{\"tikonApp.invoiceStatus.\"+si | translate}}</md-option></md-select></div></div><!--<div class=\"col-sm-6\">--><!--<div class=\"form-group\">--><!--<label--><!--translate=\"tikonApp.orderBagServiceItem.filterServiceItem\">ServiceItem</label>--><!--<md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\"--><!--placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\"--><!--ng-model=\"$ctrl.data.filterQuery.serviceItemIds\"--><!--style=\"min-width: 100px;\">--><!--&lt;!&ndash;<md-option value=\"0\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--<md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.data.serviceItems\">--><!--<small class=\"hidden-xs\"--><!--ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\"--><!--style=\"color: #a2a2a2;\">{{si.category.categoryName}} - --><!--</small>--><!--{{si.itemTitle}}--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--></div></div></div></div></md-dialog-content><md-dialog-actions class=\"pl-dialog-actions\"><div class=\"pl-filter-dialog-footer\" style=\"width: 100%\"><div class=\"\" style=\"display: flex;justify-content: flex-end\"><a class=\"delete-filters\" ng-click=\"$ctrl.clearFilter()\"><i class=\"material-icons\" style=\"font-size: 12px\">cancel</i> حذف فیلترها</a><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default hidden-xs\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span>بازگشت</span><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--></md-button><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-click=\"$ctrl.okModal()\"><span>اعمال</span></md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/entities/invoice-info/invoice-info-actions-v2.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }\n\n    .usedCouponClass-v2 {\n        border: 1px solid #dee3e7;\n        border-radius: 5px;\n        padding: 5px;\n        margin-top: 5px;\n        background-color: antiquewhite;\n    }\n\n    .service-schedule-block {\n        border-bottom: solid 1px #ff9d1a;\n    }\n    .status-approved {\n        color: #277312;\n        font-weight: bold;\n    }\n    .status-pending {\n        color: orange;\n    }\n    .status-rejected {\n        color: red;\n        text-decoration: line-through;\n    }\n    .status-unknown {\n        color: gray;\n        font-style: italic;\n    }</style><div class=\"pl-modal-header modal-header pl-modal-border\"><div class=\"pl-modal-title\">جزئیات فاکتور</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"vm.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div><div class=\"hidden-xs\"><md-button type=\"button\" class=\"md-raised md-secondary pull-left pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span>بازگشت</span><md-icon style=\"color: #000\">keyboard_backspace</md-icon></md-button></div></div><div class=\"hidden-xs pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"reserve-header-container-desktop\"><div class=\"reserve-main-info\"><div ng-class=\"vm.findStatusStyle(vm.invoiceInfo.status)\"><span>{{\'tikonApp.invoiceStatus.\'+vm.invoiceInfo.status | translate}}</span></div><div><span>شماره فاکتور : </span><span style=\"font-size: 16px;font-weight: bold\">{{vm.invoiceInfo.id}}</span></div><div><span translate=\"tikonApp.invoiceInfo.invoiceDate\">invoiceDate </span>: <span style=\"font-size: 14px\">{{vm.invoiceInfo.invoiceDate | toPersianDate}}</span></div><div ng-if=\"vm.invoiceInfo.issueType == \'BY_RESERVE\'\"><span>شماره رزرو : </span><a style=\"font-size: 14px\" ui-sref=\"supplierPanel-v2.editOrderBag({id:vm.invoiceInfo.orderBagId})\">{{vm.invoiceInfo.orderBagId}}</a></div></div><div class=\"reserve-customer-container\" ng-click=\"vm.goToCustomerDetail()\"><eo-avatar-name name=\"vm.invoiceInfo.customer.personalInfo.fisrtName\"></eo-avatar-name><div style=\"width: 60%\"><div class=\"customer-list-customer-name\"><span>{{vm.invoiceInfo.customer.personalInfo.fisrtName}} </span><span>{{vm.invoiceInfo.customer.personalInfo.lastName}}</span></div><div has-authority=\"ROLE_CUSTOMER_MANAGER\"><div>{{vm.invoiceInfo.customer.personalInfo.phoneNumber}}</div><div ng-if=\"vm.invoiceInfo.customer.personalInfo.email\">{{vm.invoiceInfo.customer.personalInfo.email}}</div></div></div><md-icon has-authority=\"ROLE_CUSTOMER_MANAGER\" style=\"font-size: 30px; width: 30px; height: 30px; color: black\">edit</md-icon></div><div class=\"reserve-finance-summary\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.invoiceInfo.totalServicePrice > 0 || vm.invoiceInfo.totalProductPrice != 0 || vm.invoiceInfo.remainAmount != 0\"><div ng-class=\"vm.isBalanced() ? \'pl-box-success\' : \'pl-box-danger\'\"><div ng-class=\"vm.isBalanced() ? \'text-success\' : \'text-danger\'\"><div ng-if=\"!vm.isBalanced()\"><span translate=\"tikonApp.invoiceInfo.CheckOut-NOk\"></span></div><div ng-if=\"vm.isBalanced()\"><span translate=\"tikonApp.invoiceInfo.CheckOut-Ok\"></span></div></div></div><div><div><span><span translate=\"tikonApp.invoiceInfo.finalPrice\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.invoiceInfo.finalPrice | number}}</span> <span translate=\"global.currency\"></span></span></div><div><span><span translate=\"tikonApp.invoiceInfo.remainAmount\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.invoiceInfo.remainAmount | number}}</span> <span translate=\"global.currency\"></span></span></div></div></div></div><div class=\"reserve-header-buttons\"><div style=\"display: flex;padding-left: 80px\"><div style=\"margin-right: -12px\"><md-button ng-if=\"vm.invoiceInfo.status != \'VOID\'\" ui-sref=\"supplierPanel-v2.invoiceInfoDetail.delete({id:vm.invoiceInfo.id})\" class=\"md-raised md-warn pl-btn pl-btn-hover\"><div ng-if=\"vm.invoiceInfo.status == \'SETTLEMENT\'\"><i class=\"fa fa-times\"></i> <span translate=\"tikonApp.invoiceInfo.home.void\">Void</span></div><div ng-if=\"vm.invoiceInfo.status == \'UNPAID\'\"><i class=\"fa fa-trash\"></i> <span translate=\"tikonApp.invoiceInfo.home.delete\">delete</span></div></md-button></div><div ng-if=\"vm.invoiceInfo.status ==\'UNPAID\'\"><md-button ng-click=\"vm.finalizeInvoiceInfo()\" class=\"md-raised md-primary pl-btn pl-btn-hover\" style=\"background-color: green\"><i class=\"fa fa-lock\"></i> <span translate=\"tikonApp.invoiceInfo.home.complete\">Complete</span></md-button></div><div ng-if=\"vm.invoiceInfo.status ==\'UNPAID\'\"><md-button ng-click=\"vm.editInvoiceInfo()\" class=\"md-raised md-primary pl-btn-primary pl-btn pl-btn-hover\"><i class=\"fa fa-pencil\"></i> <span class=\"\">ویرایش</span></md-button></div><div class=\"pull-left\" ng-if=\"vm.showOtherActionsButton\" has-any-authority=\"ROLE_COMPANY_MANAGER\"><md-menu md-offset=\"0 60\"><md-button class=\"md-raised pl-btn\" style=\"border: 1px solid;padding-left: 0\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><span translate=\"tikonApp.invoiceInfo.otherActions\">otherActions </span><span><md-icon aria-hidden=\"true\" style=\"transform: rotate(90deg)\">chevron_right</md-icon></span></md-button><!--<md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\">--><!--<md-icon aria-hidden=\"true\">videocam</md-icon>--><!--</md-button>--><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.printInvoiceInfo()\"><md-icon md-menu-align-target class=\"pl-icon\">print</md-icon><span translate=\"tikonApp.invoiceInfo.otherAction.printInvoice\">printInvoice</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.sendInvoiceToCustomer()\"><md-icon md-menu-align-target class=\"pl-icon\">email</md-icon><span translate=\"tikonApp.invoiceInfo.otherAction.sendInvoice\">emailInvoice</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div><form name=\"editForm\"><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\">آیتم ها</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><th><span translate=\"tikonApp.invoiceInfoItem.title\"></span></th><th><span translate=\"tikonApp.invoiceInfoItem.priceCurrency\"></span></th><!--<th><span translate=\"tikonApp.invoiceInfoItem.qty\"></span></th>--><!--<th></th>--></thead><tbody><tr ng-repeat=\"item in vm.invoiceInfo.invoiceInfoItems\"><td><span>{{item.title}} <span ng-if=\"item.servant!=null\" style=\"font-size: 10px\">({{item.servant.personInfo.fisrtName}} {{item.servant.personInfo.lastName}})</span></span></td><td><span>{{item.price*item.qty | number}}</span></td></tr><tr name=\"totalDiscount\"><td>تخفیف</td><td>{{vm.invoiceInfo.totalDiscount | number}}</td></tr><tr name=\"totalVat\" ng-if=\"vm.invoiceInfo.totalVAT\"><td>مالیات بر ارزش افزوده</td><td>{{vm.invoiceInfo.totalVAT| number}}</td></tr><tr name=\"finalPrice\"><td>جمع کل</td><td style=\"font-size: 14px;font-weight: bold\">{{vm.invoiceInfo.finalPrice | number}}</td></tr></tbody></table></div></div></div></div></div><div class=\"pl-panel\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.invoiceInfo.paymentList\"></span></div><div class=\"panel-body pl-panel-body\"><div class=\"col-sm-12\"><div><md-button ng-if=\"vm.canEditPaymentLog()\" ng-click=\"vm.insertPayment()\" class=\"md-raised md-primary pl-btn-primary pl-btn\"><span style=\"font-weight: bold\">+</span> <span class=\"\" translate=\"tikonApp.invoiceInfo.insertPayment\">Insert Payment</span></md-button><md-button ng-if=\"vm.canEditPaymentLog()\" ng-click=\"vm.settlementInvoice()\" class=\"md-raised pl-btn-default pl-btn\"><span style=\"font-weight: bold\">+</span> <span class=\"\" translate=\"tikonApp.invoiceInfo.settlementInvoice\">Settlement Invoice</span></md-button><md-button ng-if=\"vm.invoiceInfo.remainAmount > 0 && vm.canEditPaymentLog()\" ng-click=\"vm.showWithdrawFromWalletModal()\" class=\"md-raised pl-btn-default pl-btn\"><span style=\"font-weight: bold\">+</span> <span class=\"\">استفاده از اعتبار مشتری</span></md-button></div><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><tr><th><span translate=\"tikonApp.paymentLog.amount\">Amount</span> <span translate=\"global.currencyBracket\"></span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.paymentType\">Payment Type</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.moreInfo\">moreInfo</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.traceCode\">Trace Code</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.createDate\">Create Date</span> <span class=\"\"></span></th><th>یادداشت</th><th>وضعیت</th><th></th></tr></thead><tbody><tr ng-repeat=\"paymentLog in vm.invoiceInfo.paymentLogs track by paymentLog.id\"><td>{{paymentLog.amount | number}}</td><td translate=\"{{\'tikonApp.PaymentType.\' + paymentLog.paymentType}}\">{{paymentLog.paymentType}}</td><td>{{paymentLog.moreInfo}}</td><td>{{paymentLog.traceCode}}</td><td>{{paymentLog.createDate | toPersianDate}}</td><td style=\"max-width: 210px; overflow-x: auto; font-weight: normal\">{{paymentLog.managerApprovalComment}}</td><td ng-class=\"getStatusClass(paymentLog.managerApprovalStatus)\">{{calcManagerApprovalStatus(paymentLog.managerApprovalStatus)}}</td><td><md-button ng-click=\"vm.deletePaymentLog(paymentLog)\" style=\"color: red\" ng-if=\"vm.canEditPaymentLog(paymentLog)\" ng-disabled=\"paymentLog.managerApprovalStatus === \'CHECKING\' || paymentLog.managerApprovalStatus === \'DENIED\' || paymentLog.managerApprovalStatus === \'APPROVED\' || paymentLog.onlineGateway === \'WALLET_CUSTOMER_WEB\'\" class=\"deleteIcon\"><md-tooltip ng-if=\"paymentLog.onlineGateway !== \'WALLET_CUSTOMER_WEB\'\" md-direction=\"top\">{{\'tikonApp.invoiceInfo.deletePaymentItemTip\' | translate}}</md-tooltip><md-icon ng-style=\"getDynamicStyleRemoveIcon(paymentLog)\" aria-hidden=\"true\">delete_forever</md-icon></md-button></td></tr></tbody></table></div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.invoiceInfo.comment\"></span></div><div class=\"panel-body\"><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"comment\" disabled=\"true\" placeholder=\"{{\'tikonApp.invoiceInfo.comment\' | translate}}\" ng-model=\"vm.invoiceInfo.comment\"></textarea></div></div></div></div></div></form></div></div></div><div class=\"visible-xs\" style=\"background-color: white;min-height: 87vh\"><div class=\"container-fluid pl-container-fluid\"><div class=\"reserve-header-container\"><div class=\"reserve-main-info\"><div><div><span>شماره فاکتور : </span><span style=\"font-size: 16px;font-weight: bold\">{{vm.invoiceInfo.id}}</span></div><div><span translate=\"tikonApp.invoiceInfo.invoiceDate\">invoiceDate </span>: <span style=\"font-size: 14px\">{{vm.invoiceInfo.invoiceDate | toPersianDate}}</span></div><div ng-if=\"vm.invoiceInfo.issueType == \'BY_RESERVE\'\"><span>شماره رزرو : </span><a style=\"font-size: 14px\" ui-sref=\"supplierPanel-v2.editOrderBag({id:vm.invoiceInfo.orderBagId})\">{{vm.invoiceInfo.orderBagId}}</a></div></div><div ng-class=\"vm.findStatusStyle(vm.invoiceInfo.status)\"><span>{{\'tikonApp.invoiceStatus.\'+vm.invoiceInfo.status | translate}}</span></div></div><div class=\"reserve-finance-summary\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.invoiceInfo.totalServicePrice > 0 || vm.invoiceInfo.totalProductPrice != 0 || vm.invoiceInfo.remainAmount != 0\"><div><div><span><span translate=\"tikonApp.invoiceInfo.finalPrice\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.invoiceInfo.finalPrice | number}}</span> <span translate=\"global.currency\"></span></span></div><div><span><span translate=\"tikonApp.invoiceInfo.remainAmount\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.invoiceInfo.remainAmount | number}}</span> <span translate=\"global.currency\"></span></span></div></div><div ng-class=\"vm.isBalanced() ? \'pl-box-success\' : \'pl-box-danger\'\"><div ng-class=\"vm.isBalanced() ? \'text-success\' : \'text-danger\'\"><div ng-if=\"!vm.isBalanced()\"><span translate=\"tikonApp.invoiceInfo.CheckOut-NOk\"></span></div><div ng-if=\"vm.isBalanced()\"><span translate=\"tikonApp.invoiceInfo.CheckOut-Ok\"></span></div></div></div></div></div><div class=\"reserve-customer-container\" ng-click=\"vm.goToCustomerDetail()\"><eo-avatar-name name=\"vm.invoiceInfo.customer.personalInfo.fisrtName\"></eo-avatar-name><div style=\"width: 60%\"><div class=\"customer-list-customer-name\"><span>{{vm.invoiceInfo.customer.personalInfo.fisrtName}} </span><span>{{vm.invoiceInfo.customer.personalInfo.lastName}}</span></div><div has-authority=\"ROLE_CUSTOMER_MANAGER\"><div>{{vm.invoiceInfo.customer.personalInfo.phoneNumber}}</div><div ng-if=\"vm.invoiceInfo.customer.personalInfo.email\" class=\"customer-summary-email\">{{vm.invoiceInfo.customer.personalInfo.email}}</div></div></div><md-icon has-authority=\"ROLE_CUSTOMER_MANAGER\" style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div><div class=\"reserve-section-header\">آیتمها</div><div class=\"container-fluid pl-container-fluid\"><div class=\"invoice-item-container\" ng-repeat=\"item in vm.invoiceInfo.invoiceInfoItems\"><div id=\"item-info\" style=\"width: 90%\"><div id=\"serviceTitleSection\" class=\"invoice-item-info\" style=\"gap:5px\"><div>{{item.title}}</div><div style=\"font-size: 12px\" ng-if=\"item.servant!=null\">({{item.servant.personInfo.fisrtName}} {{item.servant.personInfo.lastName}})</div></div></div><div id=\"dtailItemSection\" class=\"reserve-item-info\">{{item.price*item.qty | number}}</div></div><div class=\"reserve-section-header\">جمع کل</div><div id=\"total\" class=\"\"><div class=\"invoice-item-container\"><div id=\"totalDiscount\" class=\"reserve-item-info\" style=\"gap:5px\"><div>تخفیف</div></div><div>{{vm.invoiceInfo.totalDiscount | number}}</div></div><div class=\"invoice-item-container\"><div id=\"totalVAT\" class=\"reserve-item-info\" style=\"gap:5px\"><div>مالیات بر ارزش افزوده</div></div><div>{{vm.invoiceInfo.totalVAT | number}}</div></div><div class=\"invoice-item-container\"><div id=\"finalPrice\" class=\"reserve-item-info\" style=\"gap:5px;font-weight: bold\"><div>جمع کل</div></div><div style=\"font-weight: bold\">{{vm.invoiceInfo.finalPrice | number}}</div></div></div><div class=\"reserve-section-header\" has-authority=\"ROLE_FINANCIAL_MANAGER\">جزئیات پرداختی ها</div><div has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"reserve-customer-container\" ng-repeat=\"paymentLog in vm.invoiceInfo.paymentLogs track by paymentLog.id\"><div class=\"payment-list-info\"><div class=\"payment-list-info-row\"><div>{{paymentLog.amount | number}} <span translate=\"global.currency\"></span></div><div>{{paymentLog.createDate | toPersianDate}}</div></div><div class=\"payment-list-info-row\"><div translate=\"{{\'tikonApp.PaymentType.\' + paymentLog.paymentType}}\">{{paymentLog.paymentType}}</div><div ng-if=\"paymentLog.traceCode\">کد پیگیری : {{paymentLog.traceCode}}</div></div></div><div><div ng-click=\"vm.deletePaymentLog(paymentLog)\" style=\"color: red\" ng-if=\"paymentLog.paymentType != \'ONLINE\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.deleteItemTip\' | translate}}</md-tooltip><md-icon style=\"color: red\" aria-hidden=\"true\">delete_forever</md-icon></div></div></div><div style=\"text-align: center; padding: 20px\" ng-if=\"!vm.invoiceInfo.paymentLogs || vm.invoiceInfo.paymentLogs.length ==0 \">هیچ پرداختی ثبت نشده است</div></div><div ng-if=\"vm.invoiceInfo.comment\"><div class=\"reserve-section-header\">توضیحات</div><div><div class=\"reserve-customer-container\">{{vm.invoiceInfo.comment}}</div></div></div></div></div><div class=\"pl-modal-footer visible-xs\"><div class=\"\" style=\"display: flex\"><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" style=\"width: 100%; font-size: 18px\" ng-click=\"vm.mainActions()\"><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;--> <span>عملیات</span></md-button><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default\" ng-click=\"vm.otherActions()\" style=\"font-size: 18px;width: 20%\"><md-icon>more_horiz</md-icon></md-button></div></div>");
$templateCache.put("app/entities/invoice-info/invoice-info-bottom-sheet-template.html","<div class=\"pl-bottom-sheet-container\"><div class=\"pl-bottom-sheet-content\"><ul ng-if=\"vm.mode==\'MAIN_ACTIONS\'\"><li ng-click=\"vm.itemClick(\'editInvoiceInfo\')\" ng-if=\"vm.invoiceInfo.status ==\'UNPAID\'\"><span class=\"\">ویرایش فاکتور</span></li><li ng-click=\"vm.itemClick(\'finalizeInvoiceInfo\')\" ng-if=\"vm.invoiceInfo.status ==\'UNPAID\'\"><span class=\"\" translate=\"tikonApp.invoiceInfo.home.complete\">complete</span></li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-click=\"vm.itemClick(\'settlementInvoice\')\" ng-if=\"vm.invoiceInfo.remainAmount > 0 && vm.canEditInsertPaymentLog()\">ثبت تسویه</li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.canEditInsertPaymentLog()\" ng-click=\"vm.itemClick(\'insertPayment\')\">ثبت پرداختی ها</li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.showUseCredit\" ng-click=\"vm.itemClick(\'useCredit\')\">استفاده از اعتبار مشتری</li><li ng-click=\"vm.itemClick(\'deleteInvoiceInfo\')\" style=\"color: red\"><span ng-if=\"vm.invoiceInfo.status == \'SETTLEMENT\'\" class=\"\" translate=\"tikonApp.invoiceInfo.home.void\">void </span><span class=\"\" ng-if=\"vm.invoiceInfo.status == \'UNPAID\'\" translate=\"tikonApp.invoiceInfo.home.delete\">delete</span></li></ul><ul ng-if=\"vm.mode==\'OTHER_ACTIONS\'\"><li ng-click=\"vm.itemClick(\'sendInvoiceToCustomer\')\"><span translate=\"tikonApp.invoiceInfo.otherAction.sendInvoice\">sendInvoice</span></li></ul></div><div class=\"pl-bottom-sheet-content\"><div class=\"pl-bottom-sheet-close-btn\" ng-click=\"vm.close()\">بستن</div></div></div>");
$templateCache.put("app/entities/invoice-info/invoice-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.invoiceInfo.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" ng-if=\"vm.invoiceInfo.status != \'SETTLEMENT\'\" translate=\"entity.delete.title\">Confirm delete operation</h4><h4 class=\"modal-title\" ng-if=\"vm.invoiceInfo.status == \'SETTLEMENT\'\" translate=\"tikonApp.invoiceInfo.delete.voidTitle\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p ng-if=\"vm.invoiceInfo.status == \'TEMP\' || vm.invoiceInfo.status == \'UNPAID\'\" translate=\"tikonApp.invoiceInfo.delete.question\" translate-values=\"{id: \'{{vm.invoiceInfo.id}}\'}\">Are you sure you want to delete this Invoice Info?</p><p ng-if=\"vm.invoiceInfo.status == \'SETTLEMENT\'\" translate=\"tikonApp.invoiceInfo.delete.voidQuestion\" translate-values=\"{id: \'{{vm.invoiceInfo.id}}\'}\">Are you sure you want to delete this Invoice Info?</p><p ng-if=\"vm.invoiceInfo.status == \'VOID\'\" translate=\"tikonApp.invoiceInfo.delete.canNotVoid\" translate-values=\"{id: \'{{vm.invoiceInfo.id}}\'}\">Are you sure you want to delete this Invoice Info?</p></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp; <span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button ng-if=\"vm.invoiceInfo.status != \'VOID\'\" type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp; <span ng-if=\"vm.invoiceInfo.status == \'TEMP\' || vm.invoiceInfo.status == \'UNPAID\'\" translate=\"entity.action.delete\">Delete</span> <span ng-if=\"vm.invoiceInfo.status == \'SETTLEMENT\'\" translate=\"tikonApp.invoiceInfo.home.void\">Delete</span></md-button></div></form>");
$templateCache.put("app/entities/invoice-info/invoice-info-detail.html","<div><h2><span translate=\"tikonApp.invoiceInfo.detail.title\">Invoice Info</span> {{vm.invoiceInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.invoiceInfo.createDate\">Create Date</span></dt><dd><span>{{vm.invoiceInfo.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.invoiceInfo.orderBag\">Order Bag</span></dt><dd><a ui-sref=\"order-bag-detail({id:vm.invoiceInfo.orderBagId})\">{{vm.invoiceInfo.orderBagId}}</a></dd><dt><span translate=\"tikonApp.invoiceInfo.paymentLog\">Payment Log</span></dt><dd><span ng-repeat=\"paymentLog in vm.invoiceInfo.paymentLogs\"><a ui-sref=\"payment-log-detail({id: {{paymentLog.id}}})\">{{paymentLog.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.invoiceInfo.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.invoiceInfo.customerId})\">{{vm.invoiceInfo.customerId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/invoice-info/invoice-info-dialog-v2.html","<style>.alerts > :first-child {\n        position: absolute;\n        display: none;\n    }\n\n    .price-item-table {\n        float: left;\n        margin-left: 30px;\n    }\n\n    .no-data-class {\n        padding-bottom: 10px !important;\n    }\n\n    .servant-dropdown {\n        margin-top: 15px;\n        margin-bottom: -15px;\n    }\n\n\n    @media screen and (max-width: 768px) {\n        .servant-dropdown {\n            margin-top: -10px;\n            margin-bottom: -15px;\n        }\n    }</style><eo-pl-modal-header title=\"\'tikonApp.invoiceInfo.home.createLabel\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.invoiceInfo && vm.invoiceInfo.id \"><div class=\"customer-header-info\"><div style=\"display: flex;gap: 10px;flex-flow: column\"><div class=\"customer-list-customer-name\">شماره فاکتور : {{vm.invoiceInfo.id}}</div><div style=\"display: flex;gap: 10px\"><div class=\"customer-list-customer-name\"><span translate=\"tikonApp.invoiceInfo.invoiceDate\">invoiceDate</span></div><div><eo-date-picker id=\"field_invoiceDate\" date-value=\"vm.invoiceInfo.invoiceDate\"></eo-date-picker></div></div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.editInvoiceInfo.delete({id:vm.invoiceInfo.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div name=\"customer\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.invoiceInfo.customerInfo\"></span></div><div class=\"panel-body\"><pf-customer-picker customer=\"vm.invoiceInfo.customer\" on-new-customer-pop-up-click=\"vm.newCustomerPopUp()\" read-only=\"vm.invoiceInfo.orderBagId\"></pf-customer-picker></div></div></div><div class=\"invoice-info-items-section\"><div name=\"items\" style=\"width: 100%\"><div class=\"pl-panel\" style=\"min-height: 304px\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.invoiceInfo.itemsInfo\"></span></div><div class=\"panel-body\"><div class=\"\" ng-repeat=\"item in vm.invoiceInfo.invoiceInfoItems\"><div class=\"\" style=\"font-weight: bold\">{{item.title}} <span ng-click=\"vm.deleteItem(item)\"><i style=\"color: red\" class=\"fa fa-remove\"></i></span></div><div class=\"row\"><div class=\"col-md-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.invoiceInfoItem.price\" for=\"field_servicePrice\">Min Price</label><!--<span translate=\"global.currencyBracket\"></span>--><eo-numeric-input-v2 id=\"field_servicePrice\" name=\"servicePrice\" custom-class=\"form-control\" input-value=\"item.price\" is-required=\"true\" form-reference=\"editForm\" on-change=\"vm.onItemFieldChanged()\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-2 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.invoiceInfoItem.qty\" for=\"field_serviceQty\">Qty</label><eo-numeric-input id=\"field_serviceQty\" name=\"serviceQty\" input-value=\"item.qty\" custom-class=\"form-control\" is-disabled=\"false\" form-reference=\"editForm\" min=\"1\" on-change=\"vm.onItemFieldChanged()\"></eo-numeric-input></div></div><div class=\"col-sm-6 col-small-h col-xs-12 servant-dropdown\" data-ng-if=\"item.availableServants && item.availableServants.length>0\" style=\"\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.invoiceInfoItem.servant\" translate-values=\"{servantTitle: \'{{vm.activityTypeInfo.servantTitle}}\'}\">selectServant</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.invoiceInfo.selectServant\' | translate}}\" ng-model=\"item.servant\" ng-change=\"vm.onItemFieldChanged()\"><md-option ng-value=\"\">بدون انتخاب</md-option><md-option ng-value=\"si\" ng-repeat=\"si in item.availableServants track by si.id\">{{si.servantName}}</md-option></md-select></md-input-container></div></div></div><div ng-if=\"!vm.invoiceInfo.invoiceInfoItems || vm.invoiceInfo.invoiceInfoItems.length ==0 \"><eo-no-data message=\"vm.invoiceItemListEmptyMessage\"></eo-no-data><!--<span--><!--translate=\"tikonApp.servant.customSetting.noAvailableService\">--><!--</span>--></div><div style=\"text-align: center\"><md-button type=\"button\" ng-click=\"vm.newInvoiceInfoItem()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.invoiceInfo.newItem\">newItem</span></md-button></div></div></div></div><div name=\"invoiceSummary\" ng-if=\"vm.invoiceInfo.invoiceInfoItems\" class=\"invoice-summary\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.invoiceInfo.priceInfo\"></span></div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><th><span translate=\"tikonApp.invoiceInfoItem.title\"></span></th><th style=\"width: 50%\"><span translate=\"tikonApp.invoiceInfoItem.priceCurrency\"></span></th><!--<th><span translate=\"tikonApp.invoiceInfoItem.qty\"></span></th>--><!--<th></th>--></thead><tbody><tr><td style=\"width: 65%\">قیمت خدمات</td><td>{{vm.invoiceInfo.totalServicePrice | number}}</td></tr><!--<tr>--><!--<td>--><!--قیمت کالاها--><!--</td>--><!--<td>--><!--{{vm.invoiceInfo.totalProductPrice | number}}--><!--</td>--><!--</tr>--><tr><td>قیمت خدمات افزوده</td><td>{{vm.invoiceInfo.totalOptionPrice | number}}</td></tr></tbody><tfoot><!--<tr style=\"height: 20px;\"></tr>--><tr name=\"totalDiscount\"><td>تخفیف</td><td><eo-numeric-input-v2 id=\"field_totalDiscount\" name=\"totalDiscount\" input-value=\"vm.invoiceInfo.totalDiscount\" custom-class=\"form-control\" is-disabled=\"false\" form-reference=\"editForm\" on-change=\"vm.onItemFieldChanged()\" currency-format=\"true\"></eo-numeric-input-v2></td></tr><tr name=\"vat\" ng-if=\"vm.invoiceInfo.totalVat\"><td>مالیات بر ارزش افزوده</td><td>{{vm.invoiceInfo.totalVat | number}}</td></tr><tr name=\"finalPrice\" style=\"font-size: 14px;font-weight: bold\"><td>جمع کل</td><td>{{vm.invoiceInfo.finalPrice | number}}</td></tr></tfoot></table></div></div></div></div></div></div></div><div><div name=\"description\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.invoiceInfo.comment\"></span></div><div class=\"panel-body\"><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"comment\" placeholder=\"{{\'tikonApp.invoiceInfo.comment\' | translate}}\" ng-model=\"vm.invoiceInfo.comment\"></textarea></div></div></div></div></form></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/invoice-info/invoice-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInvoiceInfoLabel\" translate=\"tikonApp.invoiceInfo.home.createOrEditLabel\">Create or edit a Invoice Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.invoiceInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.invoiceInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.invoiceInfo.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.invoiceInfo.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.orderBag\" for=\"field_orderBag\">Order Bag</label><select class=\"form-control\" id=\"field_orderBag\" name=\"orderBag\" ng-model=\"vm.invoiceInfo.orderBagId\" ng-options=\"orderBag.id as orderBag.id for orderBag in vm.orderbags\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.paymentLog\" for=\"field_paymentLog\">Payment Log</label><select class=\"form-control\" id=\"field_paymentLog\" multiple=\"multiple\" name=\"paymentLog\" ng-model=\"vm.invoiceInfo.paymentLogs\" ng-options=\"paymentLog as paymentLog.id for paymentLog in vm.paymentlogs track by paymentLog.id\"></select></div><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.customer\" for=\"field_customer\">Customer</label><select class=\"form-control\" id=\"field_customer\" name=\"customer\" ng-model=\"vm.invoiceInfo.customerId\" ng-options=\"customer.id as customer.id for customer in vm.customers\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/invoice-info/invoice-infos.html","<style>@media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span translate=\"tikonApp.invoiceInfo.home.title\">tikonApp.invoiceInfo.home.title</span><div class=\"education-link\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body pl-panel-body\"><jhi-alert></jhi-alert><div class=\"col-xs-12\"><div class=\"row\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newInvoiceInfo()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.invoiceInfo.home.new\">Create new Invoice</span></md-button></div></div></div><div><div class=\"form-field-description\" style=\"padding-bottom: 10px\"><span>* برای اعمال فیلتر (جستجوی پیشرفته) گزینه </span><span><md-icon>filter_list</md-icon></span><span>را انتخاب کنید.</span></div><div class=\"row topOfList\" style=\"display: flex; align-items: center\"><div class=\"col-sm-10\"><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.invoiceInfo.home.searchPlaceHolder\'\" on-search=\"vm.advancedSearch()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.pageSize\">pageSize</label><md-select class=\"rwMdSelect\" id=\"field_pageSize\" ng-model=\"vm.pageSize\" ng-change=\"vm.pageSizeChanged()\" style=\"min-width: 100px;margin-bottom: 5px !important\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.pageSizeList\">{{si}}</md-option></md-select></div></div></div><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.invoiceInfos\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><!--<tr>--><!--<th colspan=\"5\">--><!--<div class=\"row \" >--><!--<eo-pl-search-box search-query=\"vm.filterQuery.searchText\"--><!--search-place-holder=\"\'tikonApp.invoiceInfo.home.searchPlaceHolder\'\"--><!--on-search=\"vm.searchInvoiceInfos()\"--><!--on-clear-search=\"vm.clearSearch()\"--><!--&gt;</eo-pl-search-box>--><!--</div>--><!--</th>--><!--</tr>--><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"invoiceInfoId\"><span translate=\"tikonApp.invoiceInfo.id\">id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"invoiceInfoId\"><span--><!--translate=\"tikonApp.invoiceInfo.invoiceNo\">invoiceNo</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th class=\"hidden-xs\" st-sort=\"customer\"><span translate=\"tikonApp.invoiceInfo.customer\">customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"customer\"><span translate=\"tikonApp.invoiceInfo.invoiceDate\">invoiceDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"finalPrice\"><span translate=\"tikonApp.invoiceInfo.finalPrice\">finalPrice</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.invoiceInfo.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"orderBagId\"><span translate=\"tikonApp.invoiceInfo.orderBagId\">orderBagId</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"comment\"><span translate=\"tikonApp.invoiceInfo.comment\">comment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"invoiceInfo in collection track by invoiceInfo.id\"><!--<td>{{invoiceInfo.id }} </td>--><td><!--<a ng-click=\"vm.editInvoiceInfo(invoiceInfo)\">{{invoiceInfo.id}}</a>--> <a ng-if=\"invoiceInfo.status == \'TEMP\'\" ui-sref=\"supplierPanel-v2.editInvoiceInfo({id:invoiceInfo.id})\">{{invoiceInfo.id}}</a> <a ng-if=\"invoiceInfo.status == \'UNPAID\' || invoiceInfo.status == \'SETTLEMENT\' || invoiceInfo.status == \'VOID\'\" ui-sref=\"supplierPanel-v2.invoiceInfoDetail({id:invoiceInfo.id})\">{{invoiceInfo.id}}</a></td><!--<td>--><!--{{invoiceInfo.invoiceNo}}--><!--</td>--><td>{{invoiceInfo.customer.personalInfo.fullName}}<div style=\"font-size: 12px\" has-authority=\"ROLE_CUSTOMER_MANAGER\">{{invoiceInfo.customer.personalInfo.phoneNumber}}</div></td><td><div>{{invoiceInfo.invoiceDate | toPersianDate}}</div><div style=\"font-size: 10px\">{{invoiceInfo.invoiceDate | toPersianTime}}</div></td><td>{{invoiceInfo.finalPrice | number}}</td><td><span ng-class=\"vm.findStatusStyle(invoiceInfo.status)\" style=\"font-size: 12px;white-space: nowrap\" translate=\"{{\'tikonApp.invoiceStatus.\' + invoiceInfo.status}}\">{{invoiceInfo.status}}</span></td><td>{{invoiceInfo.orderBagId}}</td><td>{{invoiceInfo.comment}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editInvoiceInfo(invoiceInfo)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.deleteInvoiceInfo({id:invoiceInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.pageSize\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\"></uib-pagination></div></div></div><!--<div class=\"container-fluid\">--><!--</div>--></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newInvoiceInfo()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 invoiceInfo-list-title\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.invoiceInfo.home.title\">title-list</h3></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.invoiceInfo.home.searchPlaceHolder\'\" on-search=\"vm.filterOrderBag_Global()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box><div ng-repeat=\"invoiceInfo in vm.invoiceInfos track by invoiceInfo.id\" class=\"customer-list-item\" ng-click=\"vm.editInvoiceInfo(invoiceInfo)\"><!--<eo-avatar-name name=\"{{invoiceInfo.invoiceInfoCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\" style=\"font-weight: bold;font-size: 16px\">{{invoiceInfo.id}}</div><div class=\"customer-list-customer-name\">{{invoiceInfo.customer.personalInfo.fullName}}</div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span>{{invoiceInfo.invoiceDate | toPersianDate}}</span></div><div class=\"customer-list-customer-phone\"><span><!--{{companyCustomer.createDate | toPersianDate}}</td>--> {{invoiceInfo.finalPrice}} <span translate=\"global.currencyBracket\"></span></span></div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span ng-class=\"vm.findStatusStyle(invoiceInfo.status)\" style=\"font-size: 12px\" translate=\"{{\'tikonApp.invoiceStatus.\' + invoiceInfo.status}}\">{{invoiceInfo.status}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/invoice-info/print-invoice-info.html","<style>md-icon {\n        color: unset;\n    }\n\n    .invoice-table, .invoice-item-table, .invoice-summary-table {\n        width: 100%;\n    }\n\n    .invoice-table-container {\n        padding: 10px;\n        border-top: 1px solid;\n    }\n\n    .invoice-item-table {\n        border-top: 6px solid;\n        border-bottom: 6px solid;\n    }\n\n    .print-container {\n        padding: 0 0;\n        display: flex;\n        justify-content: center;\n    }\n\n    .print-content {\n        border: 1px solid;\n        width: 40%;\n    }\n\n    .invoice-table > tbody > tr > td {\n        /*border: 1px solid;*/\n        padding: 0 5px;\n    }\n\n    .invoice-item-table > thead {\n        border-bottom: 1px solid;\n    }\n\n\n    .invoice-item-table > thead > tr > th {\n        padding: 10px 5px;\n    }\n\n    .invoice-item-table > tbody > tr > td {\n\n        padding: 10px 5px;\n    }\n\n\n    .company-title, .customer-title {\n        text-align: center;\n        padding: 10px 0;\n        font-weight: bold;\n        font-size: 16px;\n\n    }\n\n    .payment-amount {\n        font-weight: bold;\n        font-size: 18px;\n        text-align: center;\n        border: 1px solid;\n        padding: 10px;\n    }\n\n    .payment-summary {\n        padding: 10px 20px 20px 20px;\n        display: flex;\n        justify-content: center;\n        flex-flow: column;\n        align-items: center;\n    }\n\n    .footer-company-info {\n\n        border-top: 1px solid;\n        padding: 10px;\n        text-align: center;\n    }\n\n\n    @media print {\n        .noPrint {\n            display: none;\n        }\n\n        .pl-content {\n            padding: 0;\n        }\n\n        .print-container {\n            padding: 0 0;\n        }\n\n        .print-content {\n            border: 1px solid;\n            width: 100%;\n        }\n\n\n    }</style><eo-pl-modal-header class=\"noPrint\" title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\" ok-title=\"\'tikonApp.invoiceInfo.otherAction.printInvoice\'\"></eo-pl-modal-header><jhi-alert-error></jhi-alert-error><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"print-container\"><div class=\"print-content\"><div class=\"company-title\">{{vm.company.title}}</div><div class=\"invoice-table-container\"><table class=\"invoice-table\"><tr><td>شماره : {{vm.invoiceInfo.id}}</td><td>تاریخ : {{vm.invoiceInfo.invoiceDate | toPersianDate}}</td></tr><tr><td>مشتری : {{vm.invoiceInfo.customer.personalInfo.fullName}}</td><td>ساعت : {{vm.invoiceInfo.invoiceDate | toPersianTime}}</td></tr></table></div><!--<div class=\"customer-title\">--><!--</div>--><table class=\"invoice-item-table\"><thead><tr><th><span translate=\"tikonApp.invoiceInfoItem.title\">Item Title</span></th><th><span translate=\"tikonApp.invoiceInfoItem.price\">Item Price</span></th><th><span translate=\"tikonApp.invoiceInfoItem.qty\">QTY</span></th><th><span translate=\"tikonApp.invoiceInfoItem.totalRowPrice\">Total</span></th></tr></thead><tr ng-repeat=\"item in vm.invoiceInfo.invoiceInfoItems track by item.id\"><td>{{item.title}}</td><td>{{item.price | number}}</td><td>{{item.qty | number}}</td><td>{{item.totalRowPrice | number}}</td></tr></table><div class=\"payment-summary\" style=\"border-top: 1px solid\"><div style=\"width: 50%\"><table style=\"width: 100%\"><tr><td style=\"padding: 5px 0\">جمع کل :</td><td style=\"text-align: left\">{{vm.invoiceInfo.finalPrice + vm.invoiceInfo.totalDiscount | number}}</td></tr><tr><td style=\"padding: 5px 0\">تخفیف :</td><td style=\"text-align: left\">{{vm.invoiceInfo.totalDiscount | number}}</td></tr></table></div><div class=\"payment-amount\">مبلغ نهایی : {{vm.invoiceInfo.finalPrice | number}} <span translate=\"global.currency\"></span></div></div><div class=\"footer-company-info\"><div style=\"padding-bottom: 10px\">به امید دیدار مجدد</div><div ng-if=\"vm.company.phoneNumber\">تلفن : {{vm.company.phoneNumber}}</div><div>رزرو اینترنتی : {{vm.companyUrl}}</div></div></div></div></div></div><eo-pl-modal-footer class=\"noPrint\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/invoice-info/print-invoice.html","<div id=\"container-print-invoice\"><panel-pln-custom-invoice id=\"print-invoice\"></panel-pln-custom-invoice></div>");
$templateCache.put("app/entities/location-info/company-location-info-v2.html","<eo-pl-modal-header title=\"\'supplierPanel.sideMenu.companyInfo.location\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"\">supplierPanel.sideMenu.companyInfo.location</div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar>--><div name=\"locationInfo\"><pf-location-info location-info=\"vm.companyInfo.locationInfo\"></pf-location-info></div></form></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/location-info/company-location-info.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.location\">supplierPanel.sideMenu.companyInfo.location</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar>--><md-content class=\"rwMdContent\"><div name=\"locationInfo\"><pf-location-info location-info=\"vm.companyInfo.locationInfo\"></pf-location-info></div></md-content></form></div></div></div></div>");
$templateCache.put("app/entities/location-info/location-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.locationInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.locationInfo.delete.question\" translate-values=\"{id: \'{{vm.locationInfo.id}}\'}\">Are you sure you want to delete this Location Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/location-info/location-info-detail.html","<div><h2><span translate=\"tikonApp.locationInfo.detail.title\">Location Info</span> {{vm.locationInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.locationInfo.title\">Title</span></dt><dd><span>{{vm.locationInfo.title}}</span></dd><dt><span translate=\"tikonApp.locationInfo.address\">Address</span></dt><dd><span>{{vm.locationInfo.address}}</span></dd><dt><span translate=\"tikonApp.locationInfo.mapX\">Map X</span></dt><dd><span>{{vm.locationInfo.mapX}}</span></dd><dt><span translate=\"tikonApp.locationInfo.mapY\">Map Y</span></dt><dd><span>{{vm.locationInfo.mapY}}</span></dd><dt><span translate=\"tikonApp.locationInfo.isActive\">Is Active</span></dt><dd><span>{{vm.locationInfo.isActive}}</span></dd><dt><span translate=\"tikonApp.locationInfo.country\">Country</span></dt><dd><a ui-sref=\"selector-data-detail({id:vm.locationInfo.countryId})\">{{vm.locationInfo.countryId}}</a></dd><dt><span translate=\"tikonApp.locationInfo.state\">State</span></dt><dd><a ui-sref=\"selector-data-detail({id:vm.locationInfo.stateId})\">{{vm.locationInfo.stateId}}</a></dd><dt><span translate=\"tikonApp.locationInfo.city\">City</span></dt><dd><a ui-sref=\"selector-data-detail({id:vm.locationInfo.cityId})\">{{vm.locationInfo.cityId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/location-info/location-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLocationInfoLabel\" translate=\"tikonApp.locationInfo.home.createOrEditLabel\">Create or edit a Location Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.locationInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.locationInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.locationInfo.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.locationInfo.address\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.mapX\" for=\"field_mapX\">Map X</label><input type=\"text\" class=\"form-control\" name=\"mapX\" id=\"field_mapX\" ng-model=\"vm.locationInfo.mapX\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.mapY\" for=\"field_mapY\">Map Y</label><input type=\"text\" class=\"form-control\" name=\"mapY\" id=\"field_mapY\" ng-model=\"vm.locationInfo.mapY\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.isActive\" for=\"field_isActive\">Is Active</label><input type=\"checkbox\" class=\"form-control\" name=\"isActive\" id=\"field_isActive\" ng-model=\"vm.locationInfo.isActive\"></div><div class=\"form-group\"><label translate=\"tikonApp.locationInfo.country\" for=\"field_country\">Country</label><select class=\"form-control\" id=\"field_country\" name=\"country\" ng-model=\"vm.locationInfo.countryId\" ng-options=\"selectorData.id as selectorData.id for selectorData in vm.selectordata\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.locationInfo.state\" for=\"field_state\">State</label><select class=\"form-control\" id=\"field_state\" name=\"state\" ng-model=\"vm.locationInfo.stateId\" ng-options=\"selectorData.id as selectorData.id for selectorData in vm.selectordata\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.locationInfo.city\" for=\"field_city\">City</label><select class=\"form-control\" id=\"field_city\" name=\"city\" ng-model=\"vm.locationInfo.cityId\" ng-options=\"selectorData.id as selectorData.id for selectorData in vm.selectordata\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/location-info/location-infos.html","<div><h2 translate=\"tikonApp.locationInfo.home.title\">Location Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"location-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.locationInfo.home.createLabel\">Create new Location Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.locationInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.locationInfo.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span translate=\"tikonApp.locationInfo.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mapX\"><span translate=\"tikonApp.locationInfo.mapX\">Map X</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mapY\"><span translate=\"tikonApp.locationInfo.mapY\">Map Y</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isActive\"><span translate=\"tikonApp.locationInfo.isActive\">Is Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"countryId\"><span translate=\"tikonApp.locationInfo.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"stateId\"><span translate=\"tikonApp.locationInfo.state\">State</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cityId\"><span translate=\"tikonApp.locationInfo.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"locationInfo in vm.locationInfos track by locationInfo.id\"><td><a ui-sref=\"location-info-detail({id:locationInfo.id})\">{{locationInfo.id}}</a></td><td>{{locationInfo.title}}</td><td>{{locationInfo.address}}</td><td>{{locationInfo.mapX}}</td><td>{{locationInfo.mapY}}</td><td>{{locationInfo.isActive}}</td><td><a ui-sref=\"selector-data-detail({id:locationInfo.countryId})\">{{locationInfo.countryId}}</a></td><td><a ui-sref=\"selector-data-detail({id:locationInfo.stateId})\">{{locationInfo.stateId}}</a></td><td><a ui-sref=\"selector-data-detail({id:locationInfo.cityId})\">{{locationInfo.cityId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"location-info-detail({id:locationInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"location-info.edit({id:locationInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"location-info.delete({id:locationInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/marketing-campaign/marketing-campaign-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.marketingCampaign.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.marketingCampaign.delete.question\" translate-values=\"{id: \'{{vm.marketingCampaign.id}}\'}\">Are you sure you want to delete this Company Customer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/marketing-campaign/marketing-campaign-list.html","<div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div ng-if=\"!vm.smsPanel\" class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.marketingCampaign.home.title\">tikonApp.marketingCampaign.home.title</div><div ng-if=\"vm.smsPanel\" class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.marketingCampaign.home.smsPanelTitle\">tikonApp.marketingCampaign.home.smsPanelTitle</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newMarketingCampaign()\"><span><md-icon>add</md-icon></span><span ng-if=\"!vm.smsPanel\" class=\"hidden-xs\" translate=\"tikonApp.marketingCampaign.home.new\">Create new marketingCampaign </span><span ng-if=\"vm.smsPanel\" class=\"hidden-xs\" translate=\"tikonApp.marketingCampaign.home.newSmsPanel\">New sms panel</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><jhi-alert></jhi-alert><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.marketingCampaigns\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.marketingCampaign.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"title\"><span translate=\"\">عنوان</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-if=\"!vm.smsPanel\"><span translate=\"tikonApp.marketingCampaign.type\">type</span> <span></span></th><th st-sort=\"type\"><span translate=\"tikonApp.marketingCampaign.timeToSend\">timeToSend</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.marketingCampaign.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"marketingCampaign in collection track by marketingCampaign.id\"><td><a ng-click=\"vm.editMarketingCampaign(marketingCampaign)\">{{marketingCampaign.id }}</a></td><td>{{marketingCampaign.title}}</td><td ng-if=\"!vm.smsPanel\"><span translate=\"{{\'tikonApp.marketingCampaignType.\'+ marketingCampaign.type}}\"></span></td><td><div ng-if=\"!vm.smsPanel\"><span ng-if=\"marketingCampaign.count\">{{marketingCampaign.count}} ساعت</span> <span translate=\"{{\'tikonApp.marketingCampaignActionType.\' + marketingCampaign.actionType}}\">{{marketingCampaign.actionType}}</span></div><div ng-if=\"vm.smsPanel\"><!-- <span ng-if=\"marketingCampaign.count\">{{marketingCampaign.count | toPersianTime:\'hh:mm\'}}</span> --> {{marketingCampaign.fixDate | toPersianDate}}<br>{{marketingCampaign.fixDate | toPersianTime:\'hh:mm\'}}<!-- <span translate=\"{{\'tikonApp.marketingCampaignActionType.\' + marketingCampaign.actionType}}\">{{marketingCampaign.actionType}}</span> --></div><div ng-if=\"marketingCampaign.type == \'MANUAL\'\">{{marketingCampaign.fixDate | toPersianTime}} {{marketingCampaign.fixDate | toPersianDate}}</div></td><!-- <td>\n                                    <span translate=\"{{\'tikonApp.marketingCampaignStatus.\' + marketingCampaign.status}}\">{{marketingCampaign.status}}</span>\n                                </td> --><td><span ng-class=\"vm.findApproveStatusStyle(marketingCampaign.approveStatus)\" translate=\"{{\'tikonApp.marketingCampaignApproveStatus.\' + marketingCampaign.approveStatus}}\">{{marketingCampaign.approveStatus}}</span> <span ng-if=\"marketingCampaign.sendStatus == \'SENT\'\" ng-class=\"vm.findApproveStatusStyle(marketingCampaign.approveStatus)\" style=\"background-color:#f3f5e6;color:#396431\" translate=\"tikonApp.marketingCampaign.sendStatus.SENT\">ارسال شده</span><div ng-if=\"marketingCampaign.approveStatus == \'DENIED\' && marketingCampaign.approveResult\" style=\"font-size: 10px;padding-top:5px\">{{marketingCampaign.approveResult}}</div></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-if=\"marketingCampaign.sendStatus !== \'SENT\' && vm.smsPanel\" type=\"submit\" ng-click=\"vm.editMarketingCampaign(marketingCampaign)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button ng-if=\"!vm.smsPanel\" type=\"submit\" ng-click=\"vm.editMarketingCampaign(marketingCampaign)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-if=\"marketingCampaign.sendStatus !=\'SENT\'\" ng-click=\"vm.deleteMarketingCampaign(marketingCampaign)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newMarketingCampaign()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 coupon-list-title\"><h3 ng-if=\"!vm.smsPanel\" class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.marketingCampaign.home.title\">title-list</h3><h3 ng-if=\"vm.smsPanel\" class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.marketingCampaign.home.smsPanelTitle\">title-list</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.setting\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.marketingCampaign.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"marketingCampaign in vm.marketingCampaigns track by marketingCampaign.id\" class=\"customer-list-item\" ng-click=\"vm.editMarketingCampaign(marketingCampaign)\"><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\">{{marketingCampaign.title}}</div></div><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div ng-if=\"!vm.smsPanel\" class=\"customer-list-customer-name\" style=\"font-size: 12px\"><span>{{marketingCampaign.count}} ساعت {{\'tikonApp.marketingCampaignActionType.\' + marketingCampaign.actionType | translate}}</span></div><div ng-if=\"vm.smsPanel\" class=\"customer-list-customer-name\" style=\"font-size: 12px\"><span>زمان ارسال {{marketingCampaign.fixDate | toPersianDate}}<br>{{marketingCampaign.fixDate | toPersianTime:\'hh:mm\'}}</span></div></div><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\" style=\"font-weight: bold;font-size: 16px\"><span ng-class=\"vm.findApproveStatusStyle(marketingCampaign.approveStatus)\" translate=\"{{\'tikonApp.marketingCampaignApproveStatus.\' + marketingCampaign.approveStatus}}\">{{marketingCampaign.approveStatus}}</span> <span ng-if=\"marketingCampaign.sendStatus == \'SENT\'\" ng-class=\"vm.findApproveStatusStyle(marketingCampaign.approveStatus)\" style=\"background-color:#f3f5e6;color:#396431\" translate=\"tikonApp.marketingCampaign.sendStatus.SENT\">ارسال شده</span></div><div ng-if=\"marketingCampaign.approveStatus == \'DENIED\' && marketingCampaign.approveResult\" style=\"font-size: 10px;padding-top:5px\">{{marketingCampaign.approveResult}}</div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/marketing-campaign/marketing-campaign.html","<style></style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving || !vm.canEdit\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><!-- edit mode --><div class=\"servant-header-container\" ng-if=\"vm.marketingCampaign && vm.marketingCampaign.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\">{{vm.marketingCampaign.title}}</div><div><span ng-class=\"vm.findApproveStatusStyle()\" style=\"margin-left:5px\">{{\'tikonApp.marketingCampaignApproveStatus.\' + vm.marketingCampaign.approveStatus | translate}} </span><span ng-if=\"vm.marketingCampaign.sendStatus == \'SENT\'\" ng-class=\"vm.findApproveStatusStyle()\" style=\"background-color:#f3f5e6;color:#396431\" translate=\"tikonApp.marketingCampaign.sendStatus.SENT\">ارسال شده</span></div><div ng-if=\"vm.marketingCampaign.approveStatus == \'DENIED\' && vm.marketingCampaign.approveResult\">{{vm.marketingCampaign.approveResult}}</div></div></div><div class=\"customer-header-buttons\"><div ng-if=\"vm.marketingCampaign.sendStatus!=\'SENT\'\" ng-click=\"vm.deleteMarketingCampaign()\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span style=\"display: inline-block\">{{vm.getModalTitle() | translate}}</span></div><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><form name=\"editForm\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"\" for=\"field_title\">عنوان</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.marketingCampaign.title\" required></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.marketingCampaign.status\" for=\"field_status\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.marketingCampaign.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\" required><md-option value=\"ACTIVE\" translate=\"tikonApp.marketingCampaignStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.marketingCampaignStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div><!--<div class=\"col-md-3\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required--><!--translate=\"tikonApp.marketingCampaign.approveStatus\"--><!--for=\"field_approveStatus\"--><!--&gt;status--><!--</label>--><!--<md-select class=\"rwMdSelect\"--><!--ng-model=\"vm.marketingCampaign.approveStatus\"--><!--style=\"min-width: 250px;margin-top: 6px;\"--><!--id=\"field_approveStatus\"--><!--&gt;--><!--<md-option value=\"APPROVED\" translate=\"tikonApp.marketingCampaignApproveStatus.APPROVED\">--><!--APPROVED--><!--</md-option>--><!--<md-option value=\"DENIED\" translate=\"tikonApp.marketingCampaignApproveStatus.DENIED\">--><!--DENIED--><!--</md-option>--><!--<md-option value=\"CHECKING\" translate=\"tikonApp.marketingCampaignApproveStatus.CHECKING\">--><!--CHECKING--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--><!--<div class=\"col-md-3\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required--><!--translate=\"tikonApp.marketingCampaign.notificationType\"--><!--for=\"field_notificationType\"--><!--&gt;status--><!--</label>--><!--<md-select class=\"rwMdSelect\"--><!--ng-model=\"vm.marketingCampaign.notificationType\"--><!--style=\"min-width: 250px;margin-top: 6px;\"--><!--id=\"field_notificationType\"--><!--&gt;--><!--<md-option value=\"SMS\" translate=\"tikonApp.marketingCampaignNotificationType.SMS\">--><!--SMS--><!--</md-option>--><!--<md-option value=\"EMAIL\" translate=\"tikonApp.marketingCampaignNotificationType.EMAIL\">--><!--EMAIL--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--></div><div class=\"row\"><div ng-if=\"!vm.smsPanel\" class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.marketingCampaign.type\" for=\"field_type\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.marketingCampaign.type\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_type\"><!--<md-option value=\"MANUAL\" translate=\"tikonApp.marketingCampaignType.MANUAL\">--><!--MANUAL--><!--</md-option>--><md-option value=\"AUTOMATIC\" translate=\"tikonApp.marketingCampaignType.AUTOMATIC\">AUTOMATIC</md-option></md-select></div></div><div class=\"col-md-4\" ng-if=\"vm.marketingCampaign.type == \'AUTOMATIC\' && !vm.smsPanel\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.marketingCampaign.actionType\" for=\"field_actionType\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.marketingCampaign.actionType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_actionType\"><md-option value=\"AFTER_INVOICE\" translate=\"tikonApp.marketingCampaignActionType.AFTER_INVOICE\">AFTER_INVOICE</md-option><!--<md-option value=\"AFTER_RESERVE\" translate=\"tikonApp.marketingCampaignActionType.AFTER_RESERVE\">--><!--AFTER_RESERVE--><!--</md-option>--><!--<md-option value=\"CUSTOMER_BIRTHDAY\" translate=\"tikonApp.marketingCampaignActionType.CUSTOMER_BIRTHDAY\">--><!--CUSTOMER_BIRTHDAY--><!--</md-option>--></md-select></div></div><div ng-if=\"vm.smsPanel\" class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.marketingCampaignType.sendDate\" required>تاریخ ارسال</label><eo-date-picker date-value=\"vm.marketingCampaign.createDate\" required></eo-date-picker></div></div><div class=\"col-md-4\" ng-if=\"vm.marketingCampaign.type == \'AUTOMATIC\' || vm.smsPanel\"><div class=\"form-group\"><label ng-if=\"!vm.smsPanel\" class=\"control-label\" translate=\"tikonApp.marketingCampaign.count\" for=\"field_count\" required>count</label><label ng-if=\"vm.smsPanel\" class=\"control-label\" translate=\"tikonApp.marketingCampaign.hour\" for=\"field_count\" required>Hour</label><div><eo-numeric-input ng-if=\"!vm.smsPanel\" id=\"field_count\" name=\"count\" custom-class=\"form-control\" input-value=\"vm.marketingCampaign.count\" form-reference=\"editForm\" required></eo-numeric-input><md-input-container ng-if=\"vm.smsPanel\" class=\"full-width\" style=\"margin: 0\"><md-select class=\"rwMdSelect\" id=\"field_availableFromTimes\" ng-model=\"vm.marketingCampaign.sendTime\"><!--style=\"min-width: 100px;\"--><md-option ng-repeat=\"timeSpan in vm.availableTimes\" ng-value=\"timeSpan\">{{timeSpan}}</md-option></md-select><!--{{$ctrl.selectedDynamicTime}}--></md-input-container><div style=\"width: 90%\" ng-if=\"vm.marketingCampaign.actionType && !vm.smsPanel\"><span>( ساعت </span><span>{{\'tikonApp.marketingCampaignActionType.\'+vm.marketingCampaign.actionType | translate}} )</span></div></div></div></div><div class=\"row\" ng-if=\"vm.smsPanel && vm.smsPanelSendTimeWarning && vm.canEdit\"><div class=\"col-md-12\"><div class=\"text-danger\" ng-if=\"vm.smsPanelSendTimeWarning\" style=\"margin-top: 8px\"><i class=\"fa fa-warning\"></i> {{vm.smsPanelSendTimeWarning}}</div></div></div></div><div id=\"template\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.marketingCampaign.template\" for=\"field_template\" required>template</label><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"field_template\" placeholder=\"{{\'tikonApp.marketingCampaign.template\' | translate}}\" ng-model=\"vm.marketingCampaign.notificationTemplate.template\" required></textarea><div style=\"font-size: 1.3rem; height: 18px; padding-right: 5px\"><div ng-if=\"vm.calculateSmsInfo(vm.marketingCampaign.notificationTemplate.template).characters\" style=\"display: flex; align-items: center\"><div style=\"width: 78px\"><span style=\"font-weight: 500\">کاراکتر:</span> {{vm.calculateSmsInfo(vm.marketingCampaign.notificationTemplate.template).characters}}</div><span><span style=\"font-weight: 500\">پیام:</span> {{vm.calculateSmsInfo(vm.marketingCampaign.notificationTemplate.template).pages}}</span></div></div></div></div></div></div><div ng-if=\"!vm.smsPanel\" id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllServices\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.marketingCampaign.forAllServices\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllServices\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.marketingCampaign.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"serviceItem in vm.allServiceItems\"><md-checkbox ng-model=\"serviceItem.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.serviceCheckChange(serviceItem)\">{{serviceItem.itemTitle}}</md-checkbox></div></fieldset></div></div><div id=\"customerGroups\"><div class=\"row\" ng-if=\"!vm.smsPanel\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllCustomerGroups\" aria-label=\"Switch 1\" ng-change=\"vm.switch_customerGroup_changed()\"><span translate=\"tikonApp.marketingCampaign.forAllCustomerGroups\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllCustomerGroups\"><fieldset class=\"standard-fieldset\"><legend>انتخاب گروه مشتری</legend><div ng-if=\"!vm.allCustomerGroups||vm.allCustomerGroups.length==0\">هیچ گروهی تعریف نشده است.</div><div class=\"col-md-3\" ng-repeat=\"customerGroup in vm.allCustomerGroups\"><md-checkbox ng-model=\"customerGroup.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.customerGroupCheckChange(customerGroup)\">{{customerGroup.groupName}}</md-checkbox></div></fieldset></div><div class=\"row\" ng-if=\"vm.smsPanel\"><fieldset class=\"standard-fieldset\"><legend>گروههای هدف مشتریان</legend><div class=\"col-md-4\" ng-repeat=\"customerSegment in vm.allCustomerSegments\"><md-checkbox ng-model=\"customerSegment.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.customerSegmentChanged(customerSegment)\">{{\'tikonApp.CustomerSegment.\'+customerSegment.name | translate}}</md-checkbox></div></fieldset></div></div></div></div></form></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving || !vm.canEdit\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/marketing-campaign/sms-panel-overview-dialog.html","<!-- <md-dialog aria-label=\"Withdraw Balance\" class=\"withdraw-balance-dialog\" style=\"min-width:400px;\">\n     --><form name=\"withdrawForm\" style=\"min-width: 350px\"><!-- Header --><md-toolbar><div class=\"md-toolbar-tools\"><h2>برداشت از کیف پول</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\"><md-icon md-svg-icon=\"md-close\"></md-icon></md-button></div></md-toolbar><!-- Content --><md-dialog-content style=\"max-width:600px;max-height:600px\"><div class=\"md-dialog-content\"><!-- Current Balance --><div layout=\"row\" layout-align=\"space-between center\" class=\"wallet-balance-box\"><span>موجودی فعلی:</span> <span><strong>{{ $ctrl.walletBalance | number }}</strong> <span ng-if=\"$ctrl.walletBalance\">تومان</span></span></div><!-- Requested Withdrawal Amount --><div layout=\"row\" layout-align=\"space-between center\" class=\"wallet-balance-box\"><span>مبلغ درخواست برداشت:</span> <span><strong>{{ $ctrl.withdrawAmount | number }}</strong> <span ng-if=\"$ctrl.withdrawAmount\">تومان</span></span></div><!-- Warning if not enough --><div ng-if=\"$ctrl.walletBalance < $ctrl.withdrawAmount\" class=\"text-danger\" style=\"margin-top:10px\">موجودی کیف پول کافی نیست.</div><!-- Optional admin note --><div style=\"margin-top: 25px\"><label class=\"control-label\">توضیحات (اختیاری)</label><textarea class=\"form-control\" ng-model=\"$ctrl.note\" maxlength=\"200\"></textarea></div></div></md-dialog-content><!-- Actions --><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"$ctrl.cancel()\">انصراف</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.approveWithdraw()\" ng-disabled=\"$ctrl.walletBalance < $ctrl.withdrawAmount\">تایید برداشت</md-button></md-dialog-actions></form><!-- \n</md-dialog> -->");
$templateCache.put("app/entities/marketplace/marketplace-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.marketplace.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.marketplace.delete.question\" translate-values=\"{id: \'{{vm.Marketplace.id}}\'}\">Are you sure you want to delete this Marketplace?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/marketplace/marketplace-detail.html","<div><h2><span translate=\"tikonApp.marketplace.detail.title\">Marketplace</span> {{vm.marketplace.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.marketplace.activityType\">activityType</span></dt><dd><span>{{vm.marketplace.activityType}}</span></dd><dt><span translate=\"tikonApp.marketplace.title\">Title</span></dt></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/marketplace/marketplace-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMarketplaceLabel\" translate=\"tikonApp.marketplace.home.createOrEditLabel\">Create or edit a Marketplace</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.marketplace.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.marketplace.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.marketplace.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" id=\"field_title\" name=\"title\" ng-model=\"vm.marketplace.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.marketplace.keyUrl\" for=\"field_keyUrl\">keyUrl</label><input type=\"text\" class=\"form-control\" id=\"field_keyUrl\" name=\"keyUrl\" ng-model=\"vm.marketplace.keyUrl\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.marketplace.description\" for=\"field_description\">description</label><input type=\"text\" class=\"form-control\" id=\"field_description\" name=\"description\" ng-model=\"vm.marketplace.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/marketplace/marketplaces.html","<div><h2 translate=\"tikonApp.marketplace.home.title\">Managers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"marketplace.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.marketplace.home.createLabel\">Create new MarketPlace</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.marketplace.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.marketplace.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.marketplace.description\">description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"keyUrl\"><span translate=\"tikonApp.marketplace.keyUrl\">keyUrl</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"marketplace in vm.marketplaces track by marketplace.id\"><td><a ui-sref=\"marketplace-detail({id:marketplace.id})\">{{marketplace.id}}</a></td><!--<td>{{Marketplace.managerType}}</td>--><td>{{marketplace.title}}</td><td>{{marketplace.description}}</td><td>{{marketplace.keyUrl}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"marketplace-detail({id:marketplace.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"marketplace.edit({id:marketplace.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"marketplace.delete({id:marketplace.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/message/message-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.message.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"tikonApp.message.delete.question\" translate-values=\"{id: \'{{vm.message.id}}\'}\">Are you sure you want to delete this Message?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/message/message-detail.html","<div><h2><span data-translate=\"tikonApp.message.detail.title\">Message</span> {{vm.message.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"tikonApp.message.content\">Content</span></dt><dd><span>{{vm.message.content}}</span></dd><dt><span data-translate=\"tikonApp.message.senderType\">Sender Type</span></dt><dd><span data-translate=\"{{\'tikonApp.MessageSenderType.\' + vm.message.senderType}}\">{{vm.message.senderType}}</span></dd><dt><span data-translate=\"tikonApp.message.createDate\">Create Date</span></dt><dd><span>{{vm.message.createDate | date:\'medium\'}}</span></dd><dt><span data-translate=\"tikonApp.message.status\">Status</span></dt><dd><span data-translate=\"{{\'tikonApp.MessageStatusType.\' + vm.message.status}}\">{{vm.message.status}}</span></dd><dt><span data-translate=\"tikonApp.message.conversation\">Conversation</span></dt><dd><a ui-sref=\"conversation-detail({id:vm.message.conversationId})\">{{vm.message.conversationId}}</a></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"message-detail.edit({id:vm.message.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/message/message-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMessageLabel\" data-translate=\"tikonApp.message.home.createOrEditLabel\">Create or edit a Message</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.message.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.message.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.message.content\" for=\"field_content\">Content</label><input type=\"text\" class=\"form-control\" name=\"content\" id=\"field_content\" ng-model=\"vm.message.content\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.message.senderType\" for=\"field_senderType\">Sender Type</label><select class=\"form-control\" name=\"senderType\" ng-model=\"vm.message.senderType\" id=\"field_senderType\"><option value=\"SUPPLIER\" data-translate=\"tikonApp.MessageSenderType.SUPPLIER\">SUPPLIER</option><option value=\"CUSTOMER\" data-translate=\"tikonApp.MessageSenderType.CUSTOMER\">CUSTOMER</option></select></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.message.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.message.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.message.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.message.status\" id=\"field_status\"><option value=\"NEW\" data-translate=\"tikonApp.MessageStatusType.NEW\">NEW</option><option value=\"SEEN\" data-translate=\"tikonApp.MessageStatusType.SEEN\">SEEN</option><option value=\"REPLIED\" data-translate=\"tikonApp.MessageStatusType.REPLIED\">REPLIED</option></select></div><div class=\"form-group\"><label data-translate=\"tikonApp.message.conversation\" for=\"field_conversation\">Conversation</label><select class=\"form-control\" id=\"field_conversation\" name=\"conversation\" ng-model=\"vm.message.conversationId\" ng-options=\"conversation.id as conversation.id for conversation in vm.conversations\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/message/messages.html","<div><h2 data-translate=\"tikonApp.message.home.title\">Messages</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"message.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs-down\" data-translate=\"tikonApp.message.home.createLabel\">Create new Message</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.message.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"content\"><span data-translate=\"tikonApp.message.content\">Content</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"senderType\"><span data-translate=\"tikonApp.message.senderType\">Sender Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span data-translate=\"tikonApp.message.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span data-translate=\"tikonApp.message.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"conversationId\"><span data-translate=\"tikonApp.message.conversation\">Conversation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"message in vm.messages track by message.id\"><td><a ui-sref=\"message-detail({id:message.id})\">{{message.id}}</a></td><td>{{message.content}}</td><td data-translate=\"{{\'tikonApp.MessageSenderType.\' + message.senderType}}\">{{message.senderType}}</td><td>{{message.createDate | date:\'medium\'}}</td><td data-translate=\"{{\'tikonApp.MessageStatusType.\' + message.status}}\">{{message.status}}</td><td><a ui-sref=\"conversation-detail({id:message.conversationId})\">{{message.conversationId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"message-detail({id:message.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"message.edit({id:message.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"message.delete({id:message.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/meta-tag/meta-tag-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.metaTag.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.metaTag.delete.question\" translate-values=\"{id: \'{{vm.metaTag.id}}\'}\">Are you sure you want to delete this Meta Tag?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/meta-tag/meta-tag-detail.html","<div><h2><span translate=\"tikonApp.metaTag.detail.title\">Meta Tag</span> {{vm.metaTag.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.metaTag.tag\">Tag</span></dt><dd><span>{{vm.metaTag.tag}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/meta-tag/meta-tag-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMetaTagLabel\" translate=\"tikonApp.metaTag.home.createOrEditLabel\">Create or edit a Meta Tag</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.metaTag.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.metaTag.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.metaTag.tag\" for=\"field_tag\">Tag</label><input type=\"text\" class=\"form-control\" name=\"tag\" id=\"field_tag\" ng-model=\"vm.metaTag.tag\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/meta-tag/meta-tags-v2.html","<div id=\"container-meta-tags\"><panel-pln-meta-tags id=\"meta-tags\"></panel-pln-meta-tags></div>");
$templateCache.put("app/entities/meta-tag/meta-tags.html","<div><h2 translate=\"tikonApp.metaTag.home.title\">Meta Tags</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"meta-tag.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.metaTag.home.createLabel\">Create new Meta Tag</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.metaTag.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tag\"><span translate=\"tikonApp.metaTag.tag\">Tag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"metaTag in vm.metaTags track by metaTag.id\"><td><a ui-sref=\"meta-tag-detail({id:metaTag.id})\">{{metaTag.id}}</a></td><td>{{metaTag.tag}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"meta-tag-detail({id:metaTag.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"meta-tag.edit({id:metaTag.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"meta-tag.delete({id:metaTag.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/money-transfer-log/money-transfer-log-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.moneyTransferLog.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.moneyTransferLog.delete.question\" translate-values=\"{id: \'{{vm.moneyTransferLog.id}}\'}\">Are you sure you want to delete this Money Transfer Log?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/money-transfer-log/money-transfer-log-detail.html","<div><h2><span translate=\"tikonApp.moneyTransferLog.detail.title\">Money Transfer Log</span> {{vm.moneyTransferLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.moneyTransferLog.transferType\">Transfer Type</span></dt><dd><span translate=\"{{\'tikonApp.TransferType.\' + vm.moneyTransferLog.transferType}}\">{{vm.moneyTransferLog.transferType}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.createDate\">Create Date</span></dt><dd><span>{{vm.moneyTransferLog.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.transactionCode\">Transaction Code</span></dt><dd><span>{{vm.moneyTransferLog.transactionCode}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.payeeName\">Payee Name</span></dt><dd><span>{{vm.moneyTransferLog.payeeName}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.payeeAccountNo\">Payee Account No</span></dt><dd><span>{{vm.moneyTransferLog.payeeAccountNo}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.payerAcountNo\">Payer Acount No</span></dt><dd><span>{{vm.moneyTransferLog.payerAcountNo}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.payerName\">Payer Name</span></dt><dd><span>{{vm.moneyTransferLog.payerName}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.transferDate\">Transfer Date</span></dt><dd><span>{{vm.moneyTransferLog.transferDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.MoneyTransferLogStatus.\' + vm.moneyTransferLog.status}}\">{{vm.moneyTransferLog.status}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.refrenceCode\">Refrence Code</span></dt><dd><span>{{vm.moneyTransferLog.refrenceCode}}</span></dd><dt><span translate=\"tikonApp.moneyTransferLog.description\">Description</span></dt><dd><span>{{vm.moneyTransferLog.description}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/money-transfer-log/money-transfer-log-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMoneyTransferLogLabel\" translate=\"tikonApp.moneyTransferLog.home.createOrEditLabel\">Create or edit a Money Transfer Log</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.moneyTransferLog.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.moneyTransferLog.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.transferType\" for=\"field_transferType\">Transfer Type</label><select class=\"form-control\" name=\"transferType\" ng-model=\"vm.moneyTransferLog.transferType\" id=\"field_transferType\"><option value=\"CASH\" translate=\"tikonApp.TransferType.CASH\">CASH</option><option value=\"CARD_TO_CARD\" translate=\"tikonApp.TransferType.CARD_TO_CARD\">CARD_TO_CARD</option><option value=\"SHABA\" translate=\"tikonApp.TransferType.SHABA\">SHABA</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.moneyTransferLog.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.transactionCode\" for=\"field_transactionCode\">Transaction Code</label><input type=\"text\" class=\"form-control\" name=\"transactionCode\" id=\"field_transactionCode\" ng-model=\"vm.moneyTransferLog.transactionCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.payeeName\" for=\"field_payeeName\">Payee Name</label><input type=\"text\" class=\"form-control\" name=\"payeeName\" id=\"field_payeeName\" ng-model=\"vm.moneyTransferLog.payeeName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.payeeAccountNo\" for=\"field_payeeAccountNo\">Payee Account No</label><input type=\"text\" class=\"form-control\" name=\"payeeAccountNo\" id=\"field_payeeAccountNo\" ng-model=\"vm.moneyTransferLog.payeeAccountNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.payerAcountNo\" for=\"field_payerAcountNo\">Payer Acount No</label><input type=\"text\" class=\"form-control\" name=\"payerAcountNo\" id=\"field_payerAcountNo\" ng-model=\"vm.moneyTransferLog.payerAcountNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.payerName\" for=\"field_payerName\">Payer Name</label><input type=\"text\" class=\"form-control\" name=\"payerName\" id=\"field_payerName\" ng-model=\"vm.moneyTransferLog.payerName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.transferDate\" for=\"field_transferDate\">Transfer Date</label><div class=\"input-group\"><input id=\"field_transferDate\" type=\"text\" class=\"form-control\" name=\"transferDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.moneyTransferLog.transferDate\" is-open=\"vm.datePickerOpenStatus.transferDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'transferDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.moneyTransferLog.status\" id=\"field_status\"><option value=\"DONE\" translate=\"tikonApp.MoneyTransferLogStatus.DONE\">DONE</option><option value=\"FAILED\" translate=\"tikonApp.MoneyTransferLogStatus.FAILED\">FAILED</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.refrenceCode\" for=\"field_refrenceCode\">Refrence Code</label><input type=\"text\" class=\"form-control\" name=\"refrenceCode\" id=\"field_refrenceCode\" ng-model=\"vm.moneyTransferLog.refrenceCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.moneyTransferLog.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.moneyTransferLog.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/money-transfer-log/money-transfer-logs.html","<div><h2 translate=\"tikonApp.moneyTransferLog.home.title\">Money Transfer Logs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"money-transfer-log.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.moneyTransferLog.home.createLabel\">Create new Money Transfer Log</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.moneyTransferLog.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"transferType\"><span translate=\"tikonApp.moneyTransferLog.transferType\">Transfer Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.moneyTransferLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"transactionCode\"><span translate=\"tikonApp.moneyTransferLog.transactionCode\">Transaction Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"payeeName\"><span translate=\"tikonApp.moneyTransferLog.payeeName\">Payee Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"payeeAccountNo\"><span translate=\"tikonApp.moneyTransferLog.payeeAccountNo\">Payee Account No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"payerAcountNo\"><span translate=\"tikonApp.moneyTransferLog.payerAcountNo\">Payer Acount No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"payerName\"><span translate=\"tikonApp.moneyTransferLog.payerName\">Payer Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"transferDate\"><span translate=\"tikonApp.moneyTransferLog.transferDate\">Transfer Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.moneyTransferLog.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"refrenceCode\"><span translate=\"tikonApp.moneyTransferLog.refrenceCode\">Refrence Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.moneyTransferLog.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"moneyTransferLog in vm.moneyTransferLogs track by moneyTransferLog.id\"><td><a ui-sref=\"money-transfer-log-detail({id:moneyTransferLog.id})\">{{moneyTransferLog.id}}</a></td><td translate=\"{{\'tikonApp.TransferType.\' + moneyTransferLog.transferType}}\">{{moneyTransferLog.transferType}}</td><td>{{moneyTransferLog.createDate | date:\'medium\'}}</td><td>{{moneyTransferLog.transactionCode}}</td><td>{{moneyTransferLog.payeeName}}</td><td>{{moneyTransferLog.payeeAccountNo}}</td><td>{{moneyTransferLog.payerAcountNo}}</td><td>{{moneyTransferLog.payerName}}</td><td>{{moneyTransferLog.transferDate | date:\'medium\'}}</td><td translate=\"{{\'tikonApp.MoneyTransferLogStatus.\' + moneyTransferLog.status}}\">{{moneyTransferLog.status}}</td><td>{{moneyTransferLog.refrenceCode}}</td><td>{{moneyTransferLog.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"money-transfer-log-detail({id:moneyTransferLog.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"money-transfer-log.edit({id:moneyTransferLog.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"money-transfer-log.delete({id:moneyTransferLog.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/news/news-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.customerRank.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.customerRank.delete.question\" translate-values=\"{id: \'{{vm.customerRank.id}}\'}\">Are you sure you want to delete this Customer Rank?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/news/news-detail.html","<div><h2><span translate=\"tikonApp.customerRank.detail.title\">Customer Rank</span> {{vm.customerRank.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.customerRank.createDate\">Create Date</span></dt><dd><span>{{vm.customerRank.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.customerRank.rankValue\">Rank Value</span></dt><dd><span>{{vm.customerRank.rankValue}}</span></dd><dt><span translate=\"tikonApp.customerRank.customer\">Customer</span></dt><dd><a ui-sref=\"customer-detail({id:vm.customerRank.customerId})\">{{vm.customerRank.customerId}}</a></dd><dt><span translate=\"tikonApp.customerRank.serviceItem\">Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.customerRank.serviceItemId})\">{{vm.customerRank.serviceItemId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/news/news-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myNewsLabel\" translate=\"tikonApp.news.home.createOrEditLabel\">Create or edit a News</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.news.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.news.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.news.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.news.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.news.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.news.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.news.actionTitle\" for=\"field_actionTitle\">ActionTitle</label><input type=\"text\" class=\"form-control\" name=\"actionTitle\" id=\"field_actionTitle\" ng-model=\"vm.news.actionTitle\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.news.actionUrl\" for=\"field_actionUrl\">ActionUrl</label><input type=\"text\" class=\"form-control\" name=\"actionUrl\" id=\"field_actionUrl\" ng-model=\"vm.news.actionUrl\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.news.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.news.status\" id=\"field_status\"><option value=\"ACTIVE\" data-translate=\"tikonApp.newsStatus.ACTIVE\">ACTIVE</option><option value=\"NOT_ACTIVE\" data-translate=\"tikonApp.newsStatus.NOT_ACTIVE\">NOT_ACTIVE</option></select></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"tikonApp.news.newsType\" for=\"field_newsType\">newsType</label><select class=\"form-control\" name=\"newsType\" ng-model=\"vm.news.newsType\" id=\"field_newsType\"><option value=\"INFO\" data-translate=\"tikonApp.newsType.INFO\">INFO</option><option value=\"HELP\" data-translate=\"tikonApp.newsType.HELP\">HELP</option><option value=\"EXPERT_HELP\" data-translate=\"tikonApp.newsType.EXPERT_HELP\">EXPERT_HELP</option><option value=\"WARNING\" data-translate=\"tikonApp.newsType.WARNING\">WARNING</option><option value=\"NEW_FEATURE\" data-translate=\"tikonApp.newsType.NEW_FEATURE\">NEW_FEATURE</option><option value=\"SPECIAL_OFFER\" data-translate=\"tikonApp.newsType.SPECIAL_OFFER\">SPECIAL_OFFER</option></select></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.news.createDate\" for=\"field_createDate\">Create Date</label>--><!--<div class=\"input-group\">--><!--<input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.news.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"--><!--/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</div>--><!--</div>--><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.news.fromDate\" for=\"field_fromDate\">From Date</label><eo-date-picker id=\"field_fromDate\" date-value=\"vm.news.fromDate\"></eo-date-picker></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.news.toDate\" for=\"field_toDate\">To Date</label><eo-date-picker id=\"field_toDate\" date-value=\"vm.news.toDate\"></eo-date-picker></div></div></div><div class=\"form-group\"><eo-image-gallery-manager-v2 album-id=\"vm.news.imageId\" max-image-count=\"1\" crop-width=\"200\" crop-height=\"200\" album-caption=\"\'\'\"></eo-image-gallery-manager-v2></div><div class=\"form-group\"><!--<md-select class=\"rwMdSelect\" name=\"companyType\" ng-model=\"vm.companyType\"--><!--eo-required=\"\" id=\"field_companyType\">--><!--<md-option ng-value=\"si\" ng-repeat=\"si in vm.allCompanyTypes\">--><!--{{\"tikonApp.ActivityType.\"+ si | translate}}--><!--</md-option>--><!--</md-select>--><pf-activity-type-selector activity-type=\"vm.companyType\" is-required=\"false\"></pf-activity-type-selector><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addCompanyType()\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;<span>Add</span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clearCompanyTypes()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span>Clear</span></button><div>{{vm.news.companyTypeObject.activityTypeList}}</div></div><div class=\"form-group\"><md-select class=\"rwMdSelect\" name=\"subscriptionType\" ng-model=\"vm.subscriptionType\" eo-required=\"\" id=\"field_subscriptionType\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.allSubscriptionTypes\">{{\"tikonApp.SubscriptionType.\"+ si | translate}}</md-option></md-select><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addSubscriptionType()\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;<span>Add</span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clearSubscriptionTypes()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span>Clear</span></button><div>{{vm.news.subscriptionTypeObject.subscriptionTypeList}}</div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/news/newses.html","<div><h2 translate=\"tikonApp.news.home.title\">News</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"news_new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.news.home.createLabel\">Create new News</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.news.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.news.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.news.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"newsType\"><span translate=\"tikonApp.news.newsType\">NewsType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromDate\"><span translate=\"tikonApp.news.fromDate\">From Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toDate\"><span translate=\"tikonApp.news.toDate\">To Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"news in vm.news track by news.id\"><td><a ui-sref=\"news-detail({id:news.id})\">{{news.id}}</a></td><td>{{news.title}}</td><td>{{news.status}}</td><td>{{news.newsType}}</td><td>{{news.fromDate | toPersianDate}}</td><td>{{news.toDate | toPersianDate}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"news-detail({id:news.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"news.edit({id:news.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"news.delete({id:news.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/notification-setting/notification-setting-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.notificationSetting.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.notificationSetting.delete.question\" translate-values=\"{id: \'{{vm.notificationSetting.id}}\'}\">Are you sure you want to delete this Notification Setting?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/notification-setting/notification-setting-detail.html","<div><h2><span translate=\"tikonApp.notificationSetting.detail.title\">Notification Setting</span> {{vm.notificationSetting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.notificationSetting.sendBookingConfirmation\">Send Booking Confirmation</span></dt><dd><span translate=\"{{\'tikonApp.NotificationType.\' + vm.notificationSetting.sendBookingConfirmation}}\">{{vm.notificationSetting.sendBookingConfirmation}}</span></dd><dt><span translate=\"tikonApp.notificationSetting.sendOnCancelBooking\">Send On Cancel Booking</span></dt><dd><span translate=\"{{\'tikonApp.NotificationType.\' + vm.notificationSetting.sendOnCancelBooking}}\">{{vm.notificationSetting.sendOnCancelBooking}}</span></dd><dt><span translate=\"tikonApp.notificationSetting.sendOnMoveBooking\">Send On Move Booking</span></dt><dd><span translate=\"{{\'tikonApp.NotificationType.\' + vm.notificationSetting.sendOnMoveBooking}}\">{{vm.notificationSetting.sendOnMoveBooking}}</span></dd><dt><span translate=\"tikonApp.notificationSetting.sendCustomerReminder\">Send Customer Reminder</span></dt><dd><span translate=\"{{\'tikonApp.NotificationType.\' + vm.notificationSetting.sendCustomerReminder}}\">{{vm.notificationSetting.sendCustomerReminder}}</span></dd><dt><span translate=\"tikonApp.notificationSetting.reminderTimeInAdvanced\">Reminder Time In Advanced</span></dt><dd><span>{{vm.notificationSetting.reminderTimeInAdvanced}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/notification-setting/notification-setting-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myNotificationSettingLabel\" translate=\"tikonApp.notificationSetting.home.createOrEditLabel\">Create or edit a Notification Setting</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.notificationSetting.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.notificationSetting.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendBookingConfirmation\" for=\"field_sendBookingConfirmation\">Send Booking Confirmation</label><select class=\"form-control\" name=\"sendBookingConfirmation\" ng-model=\"vm.notificationSetting.sendBookingConfirmation\" id=\"field_sendBookingConfirmation\"><option value=\"NONE\" translate=\"tikonApp.NotificationType.NONE\">NONE</option><option value=\"SMS\" translate=\"tikonApp.NotificationType.SMS\">SMS</option><option value=\"EMAIL\" translate=\"tikonApp.NotificationType.EMAIL\">EMAIL</option><option value=\"SMS_AND_EMAIL\" translate=\"tikonApp.NotificationType.SMS_AND_EMAIL\">SMS_AND_EMAIL</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendOnCancelBooking\" for=\"field_sendOnCancelBooking\">Send On Cancel Booking</label><select class=\"form-control\" name=\"sendOnCancelBooking\" ng-model=\"vm.notificationSetting.sendOnCancelBooking\" id=\"field_sendOnCancelBooking\"><option value=\"NONE\" translate=\"tikonApp.NotificationType.NONE\">NONE</option><option value=\"SMS\" translate=\"tikonApp.NotificationType.SMS\">SMS</option><option value=\"EMAIL\" translate=\"tikonApp.NotificationType.EMAIL\">EMAIL</option><option value=\"SMS_AND_EMAIL\" translate=\"tikonApp.NotificationType.SMS_AND_EMAIL\">SMS_AND_EMAIL</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendOnMoveBooking\" for=\"field_sendOnMoveBooking\">Send On Move Booking</label><select class=\"form-control\" name=\"sendOnMoveBooking\" ng-model=\"vm.notificationSetting.sendOnMoveBooking\" id=\"field_sendOnMoveBooking\"><option value=\"NONE\" translate=\"tikonApp.NotificationType.NONE\">NONE</option><option value=\"SMS\" translate=\"tikonApp.NotificationType.SMS\">SMS</option><option value=\"EMAIL\" translate=\"tikonApp.NotificationType.EMAIL\">EMAIL</option><option value=\"SMS_AND_EMAIL\" translate=\"tikonApp.NotificationType.SMS_AND_EMAIL\">SMS_AND_EMAIL</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendCustomerReminder\" for=\"field_sendCustomerReminder\">Send Customer Reminder</label><select class=\"form-control\" name=\"sendCustomerReminder\" ng-model=\"vm.notificationSetting.sendCustomerReminder\" id=\"field_sendCustomerReminder\"><option value=\"NONE\" translate=\"tikonApp.NotificationType.NONE\">NONE</option><option value=\"SMS\" translate=\"tikonApp.NotificationType.SMS\">SMS</option><option value=\"EMAIL\" translate=\"tikonApp.NotificationType.EMAIL\">EMAIL</option><option value=\"SMS_AND_EMAIL\" translate=\"tikonApp.NotificationType.SMS_AND_EMAIL\">SMS_AND_EMAIL</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.reminderTimeInAdvanced\" for=\"field_reminderTimeInAdvanced\">Reminder Time In Advanced</label><input type=\"number\" class=\"form-control\" name=\"reminderTimeInAdvanced\" id=\"field_reminderTimeInAdvanced\" ng-model=\"vm.notificationSetting.reminderTimeInAdvanced\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/notification-setting/notification-settings.html","<div><h2 translate=\"tikonApp.notificationSetting.home.title\">Notification Settings</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"notification-setting.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.notificationSetting.home.createLabel\">Create new Notification Setting</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.notificationSetting.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sendBookingConfirmation\"><span translate=\"tikonApp.notificationSetting.sendBookingConfirmation\">Send Booking Confirmation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sendOnCancelBooking\"><span translate=\"tikonApp.notificationSetting.sendOnCancelBooking\">Send On Cancel Booking</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sendOnMoveBooking\"><span translate=\"tikonApp.notificationSetting.sendOnMoveBooking\">Send On Move Booking</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sendCustomerReminder\"><span translate=\"tikonApp.notificationSetting.sendCustomerReminder\">Send Customer Reminder</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reminderTimeInAdvanced\"><span translate=\"tikonApp.notificationSetting.reminderTimeInAdvanced\">Reminder Time In Advanced</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"notificationSetting in vm.notificationSettings track by notificationSetting.id\"><td><a ui-sref=\"notification-setting-detail({id:notificationSetting.id})\">{{notificationSetting.id}}</a></td><td translate=\"{{\'tikonApp.NotificationType.\' + notificationSetting.sendBookingConfirmation}}\">{{notificationSetting.sendBookingConfirmation}}</td><td translate=\"{{\'tikonApp.NotificationType.\' + notificationSetting.sendOnCancelBooking}}\">{{notificationSetting.sendOnCancelBooking}}</td><td translate=\"{{\'tikonApp.NotificationType.\' + notificationSetting.sendOnMoveBooking}}\">{{notificationSetting.sendOnMoveBooking}}</td><td translate=\"{{\'tikonApp.NotificationType.\' + notificationSetting.sendCustomerReminder}}\">{{notificationSetting.sendCustomerReminder}}</td><td>{{notificationSetting.reminderTimeInAdvanced}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"notification-setting-detail({id:notificationSetting.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"notification-setting.edit({id:notificationSetting.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"notification-setting.delete({id:notificationSetting.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/off-day/off-day-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.offDay.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.offDay.delete.question\" translate-values=\"{id: \'{{vm.offDay.id}}\'}\">Are you sure you want to delete this Off Day?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/off-day/off-day-detail.html","<div><h2><span translate=\"tikonApp.offDay.detail.title\">Off Day</span> {{vm.offDay.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.offDay.offDate\">Off Date</span></dt><dd><span>{{vm.offDay.offDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"tikonApp.offDay.offDayType\">Off Day Type</span></dt><dd><span translate=\"{{\'tikonApp.OffDayType.\' + vm.offDay.offDayType}}\">{{vm.offDay.offDayType}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/off-day/off-day-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOffDayLabel\" translate=\"tikonApp.offDay.home.createOrEditLabel\">Create or edit a Off Day</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.offDay.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.offDay.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.offDay.offDate\" for=\"field_offDate\">Off Date</label><div class=\"input-group\"><input id=\"field_offDate\" type=\"text\" class=\"form-control\" name=\"offDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.offDay.offDate\" is-open=\"vm.datePickerOpenStatus.offDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'offDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.offDay.offDayType\" for=\"field_offDayType\">Off Day Type</label><select class=\"form-control\" name=\"offDayType\" ng-model=\"vm.offDay.offDayType\" id=\"field_offDayType\"><option value=\"WEEKEND\" translate=\"tikonApp.OffDayType.WEEKEND\">WEEKEND</option><option value=\"NEW_YEAR_HOLYDAY\" translate=\"tikonApp.OffDayType.NEW_YEAR_HOLYDAY\">NEW_YEAR_HOLYDAY</option><option value=\"CALENDAR_HOLYDAY\" translate=\"tikonApp.OffDayType.CALENDAR_HOLYDAY\">CALENDAR_HOLYDAY</option><option value=\"COMPANY_HOLYDAY\" translate=\"tikonApp.OffDayType.COMPANY_HOLYDAY\">COMPANY_HOLYDAY</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/off-day/off-days.html","<div><h2 translate=\"tikonApp.offDay.home.title\">Off Days</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"off-day.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.offDay.home.createLabel\">Create new Off Day</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.offDay.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"offDate\"><span translate=\"tikonApp.offDay.offDate\">Off Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"offDayType\"><span translate=\"tikonApp.offDay.offDayType\">Off Day Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"offDay in vm.offDays track by offDay.id\"><td><a ui-sref=\"off-day-detail({id:offDay.id})\">{{offDay.id}}</a></td><td>{{offDay.offDate | date:\'mediumDate\'}}</td><td translate=\"{{\'tikonApp.OffDayType.\' + offDay.offDayType}}\">{{offDay.offDayType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"off-day-detail({id:offDay.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"off-day.edit({id:offDay.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"off-day.delete({id:offDay.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/off-time/off-time-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.offTime.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.offTime.delete.question\" translate-values=\"{id: \'{{vm.offTime.id}}\'}\">Are you sure you want to delete this Off Time?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/off-time/off-time-detail.html","<div><h2><span translate=\"tikonApp.offTime.detail.title\">Off Time</span> {{vm.offTime.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.offTime.i\">I</span></dt><dd><span>{{vm.offTime.i}}</span></dd><dt><span translate=\"tikonApp.offTime.fromTime\">From Time</span></dt><dd><span>{{vm.offTime.fromTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.offTime.toTime\">To Time</span></dt><dd><span>{{vm.offTime.toTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.offTime.offTimeType\">Off Time Type</span></dt><dd><span translate=\"{{\'tikonApp.OffTimeType.\' + vm.offTime.offTimeType}}\">{{vm.offTime.offTimeType}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/off-time/off-time-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOffTimeLabel\" translate=\"tikonApp.offTime.home.createOrEditLabel\">Create or edit a Off Time</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.offTime.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.offTime.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.offTime.i\" for=\"field_i\">I</label><input type=\"number\" class=\"form-control\" name=\"i\" id=\"field_i\" ng-model=\"vm.offTime.i\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.offTime.fromTime\" for=\"field_fromTime\">From Time</label><div class=\"input-group\"><input id=\"field_fromTime\" type=\"text\" class=\"form-control\" name=\"fromTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.offTime.fromTime\" is-open=\"vm.datePickerOpenStatus.fromTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.offTime.toTime\" for=\"field_toTime\">To Time</label><div class=\"input-group\"><input id=\"field_toTime\" type=\"text\" class=\"form-control\" name=\"toTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.offTime.toTime\" is-open=\"vm.datePickerOpenStatus.toTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.offTime.offTimeType\" for=\"field_offTimeType\">Off Time Type</label><select class=\"form-control\" name=\"offTimeType\" ng-model=\"vm.offTime.offTimeType\" id=\"field_offTimeType\"><option value=\"REST_TIME\" translate=\"tikonApp.OffTimeType.REST_TIME\">REST_TIME</option><option value=\"DINNER_TIME\" translate=\"tikonApp.OffTimeType.DINNER_TIME\">DINNER_TIME</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/off-time/off-times.html","<div><h2 translate=\"tikonApp.offTime.home.title\">Off Times</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"off-time.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.offTime.home.createLabel\">Create new Off Time</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.offTime.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"i\"><span translate=\"tikonApp.offTime.i\">I</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromTime\"><span translate=\"tikonApp.offTime.fromTime\">From Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toTime\"><span translate=\"tikonApp.offTime.toTime\">To Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"offTimeType\"><span translate=\"tikonApp.offTime.offTimeType\">Off Time Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"offTime in vm.offTimes track by offTime.id\"><td><a ui-sref=\"off-time-detail({id:offTime.id})\">{{offTime.id}}</a></td><td>{{offTime.i}}</td><td>{{offTime.fromTime | date:\'medium\'}}</td><td>{{offTime.toTime | date:\'medium\'}}</td><td translate=\"{{\'tikonApp.OffTimeType.\' + offTime.offTimeType}}\">{{offTime.offTimeType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"off-time-detail({id:offTime.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"off-time.edit({id:offTime.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"off-time.delete({id:offTime.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/order-bag/edit-order-bag-v2.html","<style>.table-responsive {\n        margin: 40px 0 0;\n    }\n\n    .reserveDetails-card {\n        box-shadow: 0 0px 10px lightgrey;\n        border-radius: 5px;\n        max-width: 250px;\n        margin: auto;\n        padding: 8px 26px 26px;\n        text-align: center;\n        height: 180px;\n    }\n\n    .reserveDetails-btn {\n        margin: auto;\n        max-width: 200px;\n    }\n\n    #alert .row {\n        display: inline-flex;\n    }\n\n    #alert .lbl {\n        margin-left: 10px;\n    }\n\n    #alert .prc {\n        margin-right: 10px;\n    }\n\n    .customer-name {\n        color: #2b6b7f;\n        text-decoration: underline;\n        text-underline-offset: 3px;\n    }\n\n    .price-summary-table {\n        width: 100%;\n    }\n\n    @media (max-width: 450px) {\n        .md-raised, #alert {\n            font-size: x-small;\n        }\n    }\n\n    .tags .container {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .tags md-input-container {\n        margin-bottom: 0;\n        max-width: 300px;\n    }\n\n    .tags .new-tag {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n    }\n\n    .tags .new-tag input {\n        max-width: 300px;\n    }\n\n    .tags .loading,\n    .tags .no-result {\n        text-align: center;\n        padding: 20px 0\n    }\n\n    .tags .buttons {\n        margin-top: 20px;\n    }\n\n\n    .tags .items-list {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n        align-items: center;\n    }\n\n    .tags .items-list .item {\n        background-color: #d7d7d7;\n        border-radius: 8px;\n        padding: 4px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        border: 0;\n    }\n\n    .tags-preview {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n        align-items: center;\n        margin: 20px 0;\n        font-size: 14px;\n    }\n\n    .tags-preview .item {\n        background-color: #d7d7d7;\n        border-radius: 8px;\n        padding: 4px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        border: 0;\n    }\n\n    .mobile-tags {\n        padding: 16px;\n    }\n\n    .mobile-tags .buttons {\n        display: flex;\n    }\n\n    .reserve-main-info {\n        border-bottom: 0;\n    }\n\n    .tag-preview-mobile-container {\n        width: 100%;\n        border-bottom: 1px solid var(--rw-panel-border-color)\n    }\n\n    .tag-preview-mobile-container .tags-preview {\n        padding: 0 16px;\n\n    }\n\n    .tag-preview-mobile-container .more {\n        margin-bottom: 10px;\n        padding: 0 16px;\n    }\n\n\n    .reserve-finance-summary, .reserve-customer-container {\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .reserve-customer-container .material-icons {\n        margin: 0;\n\n    }\n    .md-select-menu-container.md-active md-select-menu {\n        max-height: 140px;\n        overflow: auto;\n    }\n    .status-approved {\n        color: #277312;\n        font-weight: bold;\n    }\n    .status-pending {\n        color: orange;\n    }\n    .status-rejected {\n        color: red;\n        text-decoration: line-through;\n    }\n    .status-unknown {\n        color: gray;\n        font-style: italic;\n    }</style><div class=\"pl-modal-header modal-header pl-modal-border\"><div class=\"pl-modal-title\">جزئیات رزرو</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"vm.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div><div class=\"hidden-xs\"><md-button type=\"button\" class=\"md-raised md-secondary pull-left pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span>بازگشت</span><md-icon style=\"color: #000\">keyboard_backspace</md-icon></md-button></div></div><div class=\"hidden-xs pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"reserve-header-container-desktop\"><div class=\"reserve-main-info\"><div ng-class=\"vm.findStatusStyle(vm.orderBag.status)\">{{vm.findStatusTitle(vm.orderBag.status)}}</div><div><span>شماره رزرو : </span><span style=\"font-size: 16px;font-weight: bold\">{{vm.orderBag.id}}</span></div><div><div class=\"reserve-info-gateway-box\" ng-if=\"vm.orderBag.reserveGateway !== \'SUPPLIER_PANEL_WEB\'\"><i class=\"fa fa-internet-explorer\" aria-hidden=\"true\"></i> <span>{{\'tikonApp.orderBagServiceItem.online\' |translate}}</span></div><div class=\"reserve-info-gateway-box\" ng-if=\"vm.orderBag.reserveGateway == \'SUPPLIER_PANEL_WEB\'\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i> <span>{{\'tikonApp.orderBagServiceItem.panel\' | translate}}</span></div></div><div ng-if=\"vm.tags.length\"><div class=\"tags-preview\"><span type=\"button\" ng-repeat=\"item in vm.tags.slice(0,3) track by $index\" class=\"item\"><span>{{item.tag}}</span> </span><span ng-if=\"vm.tags.length > 3\" class=\"item\">+{{vm.tags.length -3}}</span></div><div ng-if=\"vm.tags.length > 3\"><button ng-click=\"vm.gotToTags(\'#tags-desktop\')\">مشاهده بیشتر</button></div></div></div><div class=\"reserve-customer-container\" ng-click=\"vm.goToCustomerDetail()\"><eo-avatar-name name=\"vm.orderBag.customer.personalInfo.fisrtName\"></eo-avatar-name><div style=\"width: 60%\"><div class=\"customer-list-customer-name\"><span>{{vm.orderBag.customer.personalInfo.fisrtName}} </span><span>{{vm.orderBag.customer.personalInfo.lastName}}</span></div><div has-authority=\"ROLE_CUSTOMER_MANAGER\"><div>{{vm.orderBag.customer.personalInfo.phoneNumber}}</div><div ng-if=\"vm.orderBag.customer.personalInfo.email\">{{vm.orderBag.customer.personalInfo.email}}</div></div></div><md-icon has-authority=\"ROLE_CUSTOMER_MANAGER\" style=\"font-size: 30px; width: 30px; height: 30px; color: black\">edit</md-icon></div><div class=\"reserve-finance-summary\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.orderBag.totalServicePrice > 0 || vm.orderBag.totalOptionPrice != 0 || vm.orderBag.remainAmount != 0\"><div style=\"display: flex; gap: 10px\"><div ng-class=\"vm.isBalanced() ? \'pl-box-success\' : \'pl-box-danger\'\"><div ng-class=\"vm.isBalanced() ? \'text-success\' : \'text-danger\'\"><div ng-if=\"!vm.isBalanced()\"><span translate=\"tikonApp.orderBag.CheckOut-NOk\"></span></div><div ng-if=\"vm.isBalanced()\"><span translate=\"tikonApp.orderBag.CheckOut-Ok\"></span></div></div></div><div class=\"order-bag-invoice-status\" ng-if=\"vm.invoiceInfo.issueType\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> <span>{{\'tikonApp.invoiceStatus.\'+vm.invoiceInfo.status | translate}}</span></div></div><div><div><span><span translate=\"tikonApp.orderBag.finalPrice\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.orderBag.finalPrice | number}}</span> <span translate=\"global.currency\"></span></span></div><div><span><span translate=\"tikonApp.orderBag.remainAmount\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.orderBag.remainAmount | number}}</span> <span translate=\"global.currency\"></span></span></div></div></div></div><div class=\"reserve-header-buttons\"><div style=\"display: flex;padding-left: 80px\"><div style=\"margin-right: -12px\" ng-if=\"vm.orderBag.status == vm.constStatus.reserveRequest && vm.orderBag.finalPrice>0 && vm.resultStatus.status==\'DONE\'\"><md-button ng-click=\"vm.confirmReserveRequest()\" class=\"md-raised pl-btn approve-to-pay-btn pl-btn pl-btn-hover\"><i class=\"fa fa-check\"></i> <span class=\"\" translate=\"tikonApp.orderBag.confirmReserveRequest\">Confirm Reserve Request</span></md-button></div><div ng-if=\"(vm.orderBag.status != vm.constStatus.confirmed && vm.resultStatus.status==\'DONE\') || vm.orderBag.status == vm.constStatus.requestConfirm\"><md-button ng-click=\"vm.approveOrderBag()\" class=\"md-raised md-primary pl-btn pl-btn-hover\" style=\"background-color: green\"><i class=\"fa fa-check\"></i> <span class=\"\" translate=\"tikonApp.orderBag.approveOrderBag\">Approve</span></md-button></div><div ng-if=\"(vm.orderBag.status != vm.constStatus.canceled && vm.resultStatus.status==\'DONE\') || vm.orderBag.status == vm.constStatus.requestConfirm || vm.orderBag.status == vm.constStatus.reserveRequest\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><md-button ng-click=\"vm.cancelOrderBag()\" class=\"md-raised md-warn pl-btn pl-btn-hover\"><i class=\"fa fa-ban\"></i> <span class=\"\" translate=\"tikonApp.orderBag.cancelOrderBag\">Cancel</span></md-button></div></div><div class=\"customer-header-buttons\" style=\"margin-top: 0;gap:0\"><md-button class=\"md-raised md-primary pl-btn-primary pl-btn\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ui-sref=\"supplierPanel-v2.newReserve\"><span><md-icon aria-hidden=\"true\">add</md-icon></span><span translate=\"tikonApp.orderBag.home.createLabel\">Create new Order Bag Service Item</span></md-button><md-button class=\"md-raised pl-btn pl-btn-hover\" style=\"border: 1px solid\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-if=\"!vm.invoiceInfo.issueType\" ng-click=\"vm.issueInvoiceInfo()\"><span><md-icon aria-hidden=\"true\">receipt</md-icon></span><span translate=\"tikonApp.orderBag.issueInvoiceInfo\">View Invoice</span></md-button><md-button class=\"md-raised pl-btn pl-btn-hover\" style=\"border: 1px solid\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-if=\"vm.invoiceInfo.issueType\" ng-click=\"vm.viewInvoiceInfo()\"><span><md-icon aria-hidden=\"true\">visibility</md-icon></span><span translate=\"tikonApp.orderBag.viewInvoice\">View Invoice</span></md-button><div class=\"pull-left\" ng-if=\"vm.resultStatus.status==\'DONE\' && vm.showOtherActionsButton\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><md-menu md-offset=\"0 60\"><md-button class=\"md-raised pl-btn\" style=\"border: 1px solid;padding-left: 0\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><span translate=\"tikonApp.orderBag.otherActions\">otherActions </span><span><md-icon aria-hidden=\"true\" style=\"transform: rotate(90deg)\">chevron_right</md-icon></span></md-button><!--<md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\">--><!--<md-icon aria-hidden=\"true\">videocam</md-icon>--><!--</md-button>--><md-menu-content width=\"4\"><md-menu-item ng-if=\"vm.canReApproveRequestToPay\"><md-button ng-click=\"vm.reConfirmReserveRequest()\"><md-icon md-menu-align-target class=\"pl-icon\">restore</md-icon><span translate=\"tikonApp.orderBag.otherAction.reApproveRequest\">reApproveRequest</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.canResendNotification\"><md-button ng-click=\"vm.reSendNotification()\"><md-icon md-menu-align-target class=\"pl-icon\">email</md-icon><span>{{\'tikonApp.orderBag.otherAction.resendNotification_\'+ vm.orderBag.status | translate}}</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.canDeleteOrderBag\" has-not-authority=\"ROLE_SERVANT_LOGIN\"><md-button ng-click=\"vm.deleteOrderBag()\"><md-icon md-menu-align-target class=\"pl-icon\" style=\"color: red\">delete</md-icon><span>حذف کامل رزرو</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><form name=\"editForm\" role=\"form\" novalidate><jhi-alert-error></jhi-alert-error><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\">آیتم های رزرو شده</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><th></th><th></th><th><span translate=\"tikonApp.orderBag.serviceItemTitle\"></span></th><th><span translate=\"tikonApp.orderBag.reservedDate\"></span></th><th><span translate=\"tikonApp.orderBag.priceQty\"></span></th><th></th></thead><tbody><tr ng-repeat=\"orderBagItem in vm.orderBag.orderBagServiceItems | orderBy: \'serviceTimeSession.startTime\' \"><td><!--<div name=\"itemActions\" ng-if=\"vm.resultStatus.status==\'DONE\'\">--><!--</div>--><md-button has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-click=\"vm.deleteOrderBagItem(orderBagItem.id)\" class=\"md-raised pl-btn pl-btn-default\" style=\"color: red\" ng-if=\"vm.orderBag.orderBagServiceItems.length > 1\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.deleteItemTip\' | translate}}</md-tooltip><md-icon style=\"color: red\" aria-hidden=\"true\">delete_forever</md-icon><span class=\"\" translate=\"tikonApp.orderBagServiceItem.deleteItem\">not Check In</span></md-button><span ng-if=\"vm.orderBag.status != vm.constStatus.canceled \"><md-button ng-if=\"orderBagItem.checkinStatus!=\'CHECKIN\' && vm.showReplaceTime\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.replaceTime(orderBagItem)\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><span class=\"glyphicon glyphicon-time\" style=\"vertical-align: middle\"></span> <span translate=\"tikonApp.orderBag.replaceTime\">Replace Time</span></md-button></span></td><td><div ng-if=\"orderBagItem.checkinStatus==\'CHECKIN\'\"><div class=\"order-bag-checkin-status\"><span class=\"glyphicon glyphicon-clos\"></span> <span class=\"\" translate=\"tikonApp.orderBag.checkedin\">Checked In</span></div><div><!--                                                    {{vm.correctedTime(orderBagItem.checkinTime) | toPersianTime}}--> {{orderBagItem.checkinTime | toPersianTime}} - {{orderBagItem.checkinTime | toFullPersianDate}} <span><button ng-click=\"vm.removeCheckinOrderBagServieItem(orderBagItem.id)\" class=\"glyphicon glyphicon-remove\"></button></span></div></div><div ng-if=\"orderBagItem.checkinStatus==\'NOT_CHECKIN\'\"><div class=\"order-bag-notcheckin-status\"><span class=\"glyphicon glyphicon-check\"></span> <span class=\"\" translate=\"tikonApp.orderBag.notcheckedin\">Checked In </span><button ng-click=\"vm.removeCheckinOrderBagServieItem(orderBagItem.id)\" class=\"glyphicon glyphicon-remove\"></button></div></div></td><td><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.startVideoCall\' | translate}}</md-tooltip><a ng-click=\"vm.goToVideoCall(orderBagItem)\"><md-icon ng-if=\"orderBagItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" class=\"pl-icon\" aria-hidden=\"true\">videocam</md-icon></a></span><span>{{orderBagItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagItem.serviceItem.category.categoryName}}</div><div ng-if=\"orderBagItem.servant!=null\">({{orderBagItem.servant.personInfo.fisrtName}} {{orderBagItem.servant.personInfo.lastName}})</div></span></td><td><div><i class=\"fa fa-calendar\"></i> {{orderBagItem.serviceTimeSession.startTime | toFullPersianDate}}</div><div><i class=\"fa fa-clock-o\"></i> {{orderBagItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagItem.serviceTimeSession.startTime | toPersianTime}}</div><div id=\"timePeriod\">{{vm.timeDiff(orderBagItem)}}</div></td><td><span ng-repeat=\"orderBagItemDtail in orderBagItem.orderBagServiceItemDtail\"><div class=\"form-group\"><table><tr ng-if=\"orderBagItemDtail.gty > 0\"><td><div><div has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"orderBagItemDtail.price\"><span ng-if=\"vm.showPriceTitle\">{{orderBagItemDtail.priceInfoDtail.title}} : </span><span>{{orderBagItemDtail.price | number}} </span><span translate=\"global.currency\"></span></div><div><span translate=\"tikonApp.orderBagServiceItemDtail.gty\">QtyY</span> {{orderBagItemDtail.gty}} <i class=\"fa fa-user\"></i></div><div ng-if=\"vm.showTimePeriod(orderBagItemDtail,orderBagItem)\"><span translate=\"tikonApp.orderBagServiceItem.timePeriod\">QtyY</span><!--{{orderBagItem.timePeriod/orderBagItemDtail.timeUnitQty}} *--> {{orderBagItem.timePeriod}} * {{orderBagItemDtail.timeUnitQty}}</div></div></td><td><span ng-repeat=\"option in orderBagItemDtail.orderBagItemOptions\"><div class=\"form-group\"><div class=\"glyphicon glyphicon-ok\"></div>{{option.serviceOptionItem.optionName}}<!--{{option.priceInfoDtail.price}}--> * {{option.qty}}</div></span></td></tr></table></div><!--<label class=\"control-label\"--><!--translate=\"tikonApp.orderBagServiceItemDtail.options\">Options</label>--></span></td><td style=\"font-size: 10px\"><md-button ng-if=\"orderBagItem.checkinStatus!=\'CHECKIN\'\" ng-click=\"vm.checkinOrderBagServieItem(orderBagItem.id)\" class=\"md-flat pl-btn-default\" style=\"border: 1px solid gray;color: green;font-size: 12px\"><span class=\"\" translate=\"tikonApp.orderBag.checkin\">Check In</span></md-button><md-button ng-if=\"orderBagItem.checkinStatus!=\'NOT_CHECKIN\'\" ng-click=\"vm.notCheckinOrderBagServieItem(orderBagItem.id)\" class=\"md-flat pl-btn-default\" style=\"border: 1px solid gray;color: red;font-size: 12px\"><span class=\"\" translate=\"tikonApp.orderBag.not_checkin\">not Check In</span></md-button></td><!--<td>--><!--<span ng-repeat=\"participant in orderBagItem.participantPersons\">--><!--<div>--><!--<span>{{$index+1}}-</span> <span> {{participant.personInfo.fisrtName}}</span><span> {{participant.personInfo.lastName}}</span>--><!--</div>--><!--</span>--><!--</td>--></tr></tbody></table></div></div></div></div></div><div class=\"pl-panel\" ng-if=\"(vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\') || (vm.orderBag.intakeData!= undefined && vm.orderBag.intakeData!=\'\' && vm.orderBag.intakeData != null )\"><div class=\"panel-heading pl-panel-heading\">اطلاعات تکمیلی</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-md-6\"><fieldset class=\"standard-fieldset\" ng-if=\"(vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\') || (vm.orderBag.intakeData!= undefined && vm.orderBag.intakeData!=\'\' && vm.orderBag.intakeData != null )\"><legend>اطلاعات تکمیلی (درج توسط مشتری)</legend><div id=\"orderBag_intakeformData_1\"><eo-intake-data-viewer intake-data=\"vm.orderBag.intakeData\"></eo-intake-data-viewer></div><div ng-if=\"vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\'\"><hr><div class=\"row\"><div class=\"col-sm-2\">توضیحات رزرو :</div><div class=\"col-sm-10\">{{vm.orderBag.comment}}</div></div></div></fieldset></div><div class=\"col-md-6\"><fieldset class=\"standard-fieldset\" ng-if=\" (vm.orderBag.supplierIntakeData!= undefined && vm.orderBag.supplierIntakeData!=\'\' && vm.orderBag.supplierIntakeData != null )\"><legend>اطلاعات تکمیلی (درج توسط کسب و کار)</legend><div id=\"orderBag_Supplier_intakeformData\"><eo-intake-data-viewer intake-data=\"vm.orderBag.supplierIntakeData\"></eo-intake-data-viewer></div></fieldset></div></div></div></div><div class=\"pl-panel\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.orderBag.totalServicePrice > 0 || vm.orderBag.totalOptionPrice > 0\"><div class=\"panel-heading pl-panel-heading\">جزئیات قیمت</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalOptionPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalServicePrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalVat\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalVAT | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalDiscount\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalDiscount | number}} <span translate=\"global.currency\"></span></div></td></tr><tr ng-if=\"vm.orderBag.usedCouponCodes\"><td class=\"td-label\"><span translate=\"tikonApp.orderBag.couponCode\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.usedCouponCodes}}</div></td></tr></table></div><div class=\"col-sm-6\"></div><div class=\"col-sm-6\"><table class=\"price-summary-table text-success\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.finalPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.finalPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div></div></div></div><div class=\"pl-panel\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"panel-heading pl-panel-heading\">جزئیات دریافتی ها</div><div class=\"panel-body pl-panel-body\"><div class=\"col-sm-12\"><div><md-button ng-if=\"vm.canEditPaymentLog()\" ng-click=\"vm.insertPayment()\" class=\"md-raised md-primary pl-btn-primary pl-btn\"><span style=\"font-weight: bold\">+</span> <span class=\"\" translate=\"tikonApp.orderBag.insertPayment\">Insert Payment</span></md-button><md-button ng-if=\"vm.orderBag.remainAmount > 0 && vm.canEditPaymentLog()\" ng-click=\"vm.settlementInvoice()\" class=\"md-raised pl-btn-default pl-btn\"><span style=\"font-weight: bold\">+</span> <span class=\"\" translate=\"tikonApp.orderBag.settlementInvoice\">Settlement Invoice</span></md-button><md-button ng-if=\"vm.orderBag.remainAmount > 0 && vm.canEditPaymentLog()\" ng-click=\"vm.showWithdrawFromWalletModal()\" class=\"md-raised pl-btn-default pl-btn\"><span style=\"font-weight: bold\">+</span> <span class=\"\">استفاده از اعتبار مشتری</span></md-button><!-- Do not show on production. --><!-- <md-button \n                                    ng-if=\"vm.orderBag.remainAmount > 0 && vm.canEditPaymentLog()\"\n                                    ng-click=\"vm.showPosPayment()\"\n                                    class=\"md-raised pl-btn-default pl-btn \">\n                                <span style=\"font-weight: bold;\">+</span>\n                                <span class=\"\">\n                                               پرداخت با دستگاه کارت‌خوان(pos)\n                                            </span>\n                            </md-button> --></div><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><tr><th><span translate=\"tikonApp.paymentLog.amount\">Amount</span> <span translate=\"global.currencyBracket\"></span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.paymentType\">Payment Type</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.moreInfo\">moreInfo</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.traceCode\">Trace Code</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.createDate\">Create Date</span> <span class=\"\"></span></th><th>یادداشت</th><th>وضعیت</th><th></th></tr></thead><tbody><tr ng-repeat=\"paymentLog in vm.invoiceInfo.paymentLogs track by paymentLog.id\"><td>{{paymentLog.amount | number}}</td><td translate=\"{{\'tikonApp.PaymentType.\' + paymentLog.paymentType}}\">{{paymentLog.paymentType}}</td><td>{{paymentLog.moreInfo}}</td><td>{{paymentLog.traceCode}}</td><td>{{paymentLog.createDate | toPersianDate}}</td><td style=\"max-width: 210px; overflow-x: auto\">{{paymentLog.managerApprovalComment}}</td><td ng-class=\"getStatusClass(paymentLog.managerApprovalStatus)\">{{calcManagerApprovalStatus(paymentLog.managerApprovalStatus)}}</td><td><md-button ng-click=\"vm.deletePaymentLog(paymentLog)\" ng-disabled=\"(paymentLog.managerApprovalStatus === \'CHECKING\' || paymentLog.managerApprovalStatus === \'DENIED\' || paymentLog.managerApprovalStatus === \'APPROVED\' ) || !vm.canEditPaymentLog(paymentLog) || paymentLog.onlineGateway === \'WALLET_CUSTOMER_WEB\'\"><md-tooltip ng-if=\"!(paymentLog.managerApprovalStatus === \'CHECKING\' || paymentLog.managerApprovalStatus === \'DENIED\' || paymentLog.managerApprovalStatus === \'APPROVED\' ) && vm.canEditPaymentLog(paymentLog) &&  paymentLog.onlineGateway !== \'WALLET_CUSTOMER_WEB\'\" md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.deleteItemTip\' | translate}}</md-tooltip><md-icon ng-style=\"getDynamicStyleRemoveIcon(paymentLog)\" aria-hidden=\"true\">delete_forever</md-icon></md-button></td></tr></tbody></table></div></div></div><div style=\"text-align: center; padding: 20px\" ng-if=\"!vm.invoiceInfo.paymentLogs || vm.invoiceInfo.paymentLogs.length ==0 \">هیچ پرداختی ثبت نشده است</div></div><!--     tags     --><div class=\"pl-panel\" id=\"tags-desktop\"><div class=\"panel-heading pl-panel-heading\">تگ ها</div><div class=\"panel-body pl-panel-body tags\"><div class=\"col-sm-12 container\"><div class=\"new-tag\"><md-input-container class=\"full-width\"><label for=\"field_availableTags\">انتحاب تگ</label><md-select class=\"rwMdSelect\" id=\"field_availableTags\" ng-change=\"vm.selectedTagChanged()\" ng-model=\"vm.newTag\"><!--style=\"min-width: 100px;\"--><md-option ng-value=\"item\" ng-repeat=\"item in vm.metaTags\">{{item.tag}}</md-option></md-select><!--{{$ctrl.selectedDynamicTime}}--></md-input-container></div><div ng-if=\"vm.getTagsLoading\" class=\"loading\">درحال دریافت اطلاعات...</div><div ng-if=\"!vm.tags.length && !vm.getTagsLoading\" class=\"no-result\">هیچ تگی اختصاص داده نشده است</div><div ng-if=\"vm.tags.length\" class=\"items-list\"><button type=\"button\" ng-repeat=\"item in vm.tags track by $index\" class=\"item\" ng-click=\"vm.deleteTag($index,item)\"><span>{{item.tag}}</span> <svg width=\"24\" height=\"24\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z\"/></svg></button></div><div ng-if=\"vm.defaultTags.length || vm.tags.length\" class=\"buttons\"><button type=\"button\" class=\"md-raised md-primary pl-btn-primary pl-btn md-button md-ink-ripple\" ng-click=\"vm.insertTag()\">ذخیره تغییرات</button> <button ng-click=\"vm.resetTag()\" class=\"md-raised pl-btn-default pl-btn md-button md-ink-ripple\" type=\"button\">انصراف</button></div></div></div></div></form></div></div><div class=\"visible-xs\" style=\"background-color: white;min-height: 87vh\"><div class=\"container-fluid pl-container-fluid\"><div class=\"reserve-header-container\"><div class=\"reserve-main-info\"><div><div><span>شماره رزرو : </span><span style=\"font-size: 16px;font-weight: bold\">{{vm.orderBag.id}}</span></div><div><div class=\"reserve-info-gateway-box\" ng-if=\"vm.orderBag.reserveGateway !== \'SUPPLIER_PANEL_WEB\'\"><i class=\"fa fa-internet-explorer\" aria-hidden=\"true\"></i> <span>{{\'tikonApp.orderBagServiceItem.online\' |translate}}</span></div><div class=\"reserve-info-gateway-box\" ng-if=\"vm.orderBag.reserveGateway == \'SUPPLIER_PANEL_WEB\'\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i> <span>{{\'tikonApp.orderBagServiceItem.panel\' | translate}}</span></div></div></div><div ng-class=\"vm.findStatusStyle(vm.orderBag.status)\">{{vm.findStatusTitle(vm.orderBag.status)}}</div></div><!--            --><div class=\"tag-preview-mobile-container\"><div ng-if=\"vm.tags.length\"><div class=\"tags-preview\"><span type=\"button\" ng-repeat=\"item in vm.tags.slice(0,3) track by $index\" class=\"item\"><span>{{item.tag}}</span> </span><span ng-if=\"vm.tags.length > 3\" class=\"item\">+{{vm.tags.length -3}}</span></div><div ng-if=\"vm.tags.length > 3\" class=\"more\"><button ng-click=\"vm.gotToTags(\'#tags-mobile\')\">مشاهده بیشتر</button></div></div></div><div class=\"reserve-finance-summary\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.orderBag.totalServicePrice > 0 || vm.orderBag.totalOptionPrice != 0 || vm.orderBag.remainAmount != 0\"><div><div><span><span translate=\"tikonApp.orderBag.finalPrice\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.orderBag.finalPrice | number}}</span> <span translate=\"global.currency\"></span></span></div><div><span><span translate=\"tikonApp.orderBag.remainAmount\"></span> : </span><span style=\"font-weight: bold;font-size: 16px\"><span>{{vm.orderBag.remainAmount | number}}</span> <span translate=\"global.currency\"></span></span></div></div><div style=\"gap: 5px;display: flex; flex-flow: column\"><div ng-class=\"vm.isBalanced() ? \'pl-box-success\' : \'pl-box-danger\'\"><div ng-class=\"vm.isBalanced() ? \'text-success\' : \'text-danger\'\"><div ng-if=\"!vm.isBalanced()\"><span translate=\"tikonApp.orderBag.CheckOut-NOk\"></span></div><div ng-if=\"vm.isBalanced()\"><span translate=\"tikonApp.orderBag.CheckOut-Ok\"></span></div></div></div><div class=\"order-bag-invoice-status\" ng-if=\"vm.invoiceInfo.issueType\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> <span>{{\'tikonApp.invoiceStatus.\'+vm.invoiceInfo.status | translate}}</span></div></div></div></div><div class=\"reserve-customer-container\" ng-click=\"vm.goToCustomerDetail()\"><eo-avatar-name name=\"vm.orderBag.customer.personalInfo.fisrtName\"></eo-avatar-name><div style=\"width: 60%\"><div class=\"customer-list-customer-name\"><span>{{vm.orderBag.customer.personalInfo.fisrtName}} </span><span>{{vm.orderBag.customer.personalInfo.lastName}}</span></div><div has-authority=\"ROLE_CUSTOMER_MANAGER\"><div>{{vm.orderBag.customer.personalInfo.phoneNumber}}</div><div ng-if=\"vm.orderBag.customer.personalInfo.email\" class=\"customer-summary-email\">{{vm.orderBag.customer.personalInfo.email}}</div></div></div><md-icon has-authority=\"ROLE_CUSTOMER_MANAGER\" style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div><div class=\"reserve-section-header\">آیتمهای رزرو شده</div><div class=\"container-fluid pl-container-fluid\"><div class=\"reserve-item-container\" ng-repeat=\"orderBagItem in vm.orderBag.orderBagServiceItems | orderBy: \'serviceTimeSession.startTime\' \" ng-click=\"vm.openOrderBagItemBottomSheet(orderBagItem)\"><div ng-class=\"orderBagItem.serviceItem.color\" class=\"service-color-line\"></div><div id=\"item-info\" style=\"width: 90%\"><div id=\"DateSectin\" style=\"font-weight: bold\" class=\"reserve-item-info\"><div><i class=\"fa fa-calendar\"></i> {{orderBagItem.serviceTimeSession.startTime | toFullPersianDate}}</div></div><div id=\"timeSectin\" style=\"font-weight: bold\" class=\"reserve-item-info\"><div><i class=\"fa fa-clock-o\"></i> {{orderBagItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagItem.serviceTimeSession.startTime | toPersianTime}}</div><div id=\"timePeriod2\">{{vm.timeDiff(orderBagItem)}}</div></div><div id=\"serviceTitleSection\" class=\"reserve-item-info\" style=\"gap:5px\"><div>{{orderBagItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagItem.serviceItem.category.categoryName}}</div></div><div style=\"font-size: 12px\" ng-if=\"orderBagItem.servant!=null\">({{orderBagItem.servant.personInfo.fisrtName}} {{orderBagItem.servant.personInfo.lastName}})</div></div><div id=\"dtailItemSection\" class=\"reserve-item-info\"><div ng-repeat=\"orderBagItemDtail in orderBagItem.orderBagServiceItemDtail\"><div ng-if=\"orderBagItemDtail.gty > 0\"><div><div style=\"display: flex; gap: 10px\"><div has-authority=\"ROLE_FINANCIAL_MANAGER\"><!--{{orderBagItemDtail.priceInfoDtail.title}}--> {{orderBagItemDtail.price | number}} <span translate=\"global.currency\"></span></div><div ng-if=\"orderBagItemDtail.gty>1\"><span translate=\"tikonApp.orderBagServiceItemDtail.gty\">QtyY</span> {{orderBagItemDtail.gty}} <i class=\"fa fa-user\"></i></div></div><div ng-if=\"vm.showTimePeriod(orderBagItemDtail,orderBagItem)\"><span translate=\"tikonApp.orderBagServiceItem.timePeriod\">QtyY</span> {{orderBagItem.timePeriod}} * {{orderBagItemDtail.timeUnitQty}}</div></div><div style=\"display: flex; gap: 10px\"><div ng-repeat=\"option in orderBagItemDtail.orderBagItemOptions\" style=\"display: flex\">{{option.serviceOptionItem.optionName}}</div></div></div></div></div><div id=\"lastRow\" class=\"reserve-item-info\"><div style=\"font-size: 13px\" ng-if=\"orderBagItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\"><md-icon>videocam</md-icon>ارتباط تصویری</div><div ng-if=\"orderBagItem.checkinStatus==\'CHECKIN\'\"><div class=\"order-bag-checkin-status\"><span class=\"\" translate=\"tikonApp.orderBag.checkedin\">Checked In </span><span style=\"font-size: 12px;color: black\">( {{orderBagItem.checkinTime | toPersianTime}} - {{orderBagItem.checkinTime | toPersianDate}} )</span></div></div><div ng-if=\"orderBagItem.checkinStatus==\'NOT_CHECKIN\'\"><div class=\"order-bag-notcheckin-status\" style=\"font-weight: normal\"><span class=\"\" translate=\"tikonApp.orderBag.notcheckedin\">Checked In</span></div></div></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div><div class=\"reserve-section-header\" ng-if=\"(vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\') || (vm.orderBag.intakeData!= undefined && vm.orderBag.intakeData!=\'\' && vm.orderBag.intakeData != null )\">اطلاعات تکمیلی</div><div id=\"intakeFieldSection\" class=\"\"><div class=\"col-md-6\"><fieldset class=\"standard-fieldset\" ng-if=\"(vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\') || (vm.orderBag.intakeData!= undefined && vm.orderBag.intakeData!=\'\' && vm.orderBag.intakeData != null )\"><legend>اطلاعات تکمیلی (درج توسط مشتری)</legend><div id=\"orderBag_intakeformData\"><eo-intake-data-viewer intake-data=\"vm.orderBag.intakeData\"></eo-intake-data-viewer></div><div ng-if=\"vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\'\"><hr><div class=\"row\"><div class=\"col-sm-2\">توضیحات رزرو :</div><div class=\"col-sm-10\">{{vm.orderBag.comment}}</div></div></div></fieldset></div><div class=\"col-md-6\"><fieldset class=\"standard-fieldset\" ng-if=\" (vm.orderBag.supplierIntakeData!= undefined && vm.orderBag.supplierIntakeData!=\'\' && vm.orderBag.supplierIntakeData != null )\"><legend>اطلاعات تکمیلی (درج توسط کسب و کار)</legend><div id=\"orderBag_Supplier_intakeformData\"><eo-intake-data-viewer intake-data=\"vm.orderBag.supplierIntakeData\"></eo-intake-data-viewer></div></fieldset></div></div><div class=\"reserve-section-header\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.orderBag.totalServicePrice > 0 || vm.orderBag.totalOptionPrice > 0\">جزئیات قیمت</div><div id=\"priceSection\" has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.orderBag.totalServicePrice > 0 || vm.orderBag.totalOptionPrice > 0\"><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalOptionPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalServicePrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalVat\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalVAT | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table class=\"price-summary-table\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalDiscount\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalDiscount | number}} <span translate=\"global.currency\"></span></div></td></tr><tr ng-if=\"vm.orderBag.usedCouponCodes\"><td class=\"td-label\"><span translate=\"tikonApp.orderBag.couponCode\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.usedCouponCodes}}</div></td></tr></table></div><div class=\"col-sm-6\"></div><div class=\"col-sm-6\"><table class=\"price-summary-table text-success\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.finalPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.finalPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div></div><div class=\"reserve-section-header\" has-authority=\"ROLE_FINANCIAL_MANAGER\">جزئیات دریافتی ها</div><div has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"reserve-customer-container\" ng-repeat=\"paymentLog in vm.invoiceInfo.paymentLogs track by paymentLog.id\"><div class=\"payment-list-info\"><div class=\"payment-list-info-row\"><div>{{paymentLog.amount | number}} <span translate=\"global.currency\"></span></div><div>{{paymentLog.createDate | toPersianDate}}</div></div><div class=\"payment-list-info-row\"><div translate=\"{{\'tikonApp.PaymentType.\' + paymentLog.paymentType}}\">{{paymentLog.paymentType}}</div><div ng-if=\"paymentLog.traceCode\">کد پیگیری : {{paymentLog.traceCode}}</div></div></div><div><div ng-click=\"vm.deletePaymentLog(paymentLog)\" style=\"color: red\" ng-if=\"paymentLog.paymentType != \'ONLINE\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.deleteItemTip\' | translate}}</md-tooltip><md-icon style=\"color: red\" aria-hidden=\"true\">delete_forever</md-icon></div></div></div><div style=\"text-align: center; padding: 20px\" ng-if=\"!vm.invoiceInfo.paymentLogs || vm.invoiceInfo.paymentLogs.length ==0 \">هیچ پرداختی ثبت نشده است</div></div><!-- tags --><div><div class=\"reserve-section-header\" id=\"tags-mobile\">تگ ها</div><div class=\"tags mobile-tags\"><div class=\"new-tag\"><md-input-container class=\"full-width\"><label for=\"field_availableTags\">انتحاب تگ</label><md-select class=\"rwMdSelect\" id=\"field_availableTags\" ng-change=\"vm.selectedTagChanged()\" ng-model=\"vm.newTag\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.metaTags\">{{item.tag}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.getTagsLoading\" class=\"loading\">درحال دریافت اطلاعات...</div><div ng-if=\"!vm.tags.length && !vm.getTagsLoading\" class=\"no-result\">هیچ تگی اختصاص داده نشده است</div><div ng-if=\"vm.tags.length\" class=\"items-list\"><button type=\"button\" ng-repeat=\"item in vm.tags track by $index\" class=\"item\" ng-click=\"vm.deleteTag($index,item)\"><span>{{item.tag}}</span> <svg width=\"24\" height=\"24\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z\"/></svg></button></div><div ng-if=\"vm.defaultTags.length || vm.tags.length\" class=\"buttons\"><button type=\"button\" class=\"md-raised md-primary pl-btn-primary pl-btn md-button md-ink-ripple\" ng-click=\"vm.insertTag()\">ذخیره تغییرات</button> <button ng-click=\"vm.resetTag()\" class=\"md-raised pl-btn-default pl-btn md-button md-ink-ripple\" type=\"button\">انصراف</button></div></div></div></div></div><div class=\"pl-modal-footer visible-xs\"><div class=\"\" style=\"display: flex\"><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" style=\"width: 100%; font-size: 18px\" ng-click=\"vm.mainActions()\"><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;--> <span>عملیات</span></md-button><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default\" ng-click=\"vm.otherActions()\" style=\"font-size: 18px;width: 20%\"><md-icon>more_horiz</md-icon></md-button></div></div>");
$templateCache.put("app/entities/order-bag/edit-order-bag.html","<style>.table-responsive {\n        margin: 40px 0 0;\n    }\n\n    .reserveDetails-card {\n        box-shadow: 0 0px 10px lightgrey;\n        border-radius: 5px;\n        max-width: 250px;\n        margin: auto;\n        padding: 8px 26px 26px;\n        text-align: center;\n        height: 180px;\n    }\n\n    .reserveDetails-btn {\n        margin: auto;\n        max-width: 200px;\n    }\n\n    #alert .row {\n        display: inline-flex;\n    }\n\n    #alert .lbl {\n        margin-left: 10px;\n    }\n\n    #alert .prc {\n        margin-right: 10px;\n    }\n\n    .customer-name {\n        color: #2b6b7f;\n        text-decoration: underline;\n        text-underline-offset: 3px;\n    }\n\n    @media (max-width: 450px) {\n        .md-raised, #alert {\n            font-size: x-small;\n        }\n    }</style><div class=\"container-fluid\"><div class=\"row\"><!--<div class=\"col-md-3 col-sm-6 no-padding-left\">--><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ui-sref=\"supplierPanel.reserve_v2\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.home.createLabel\">Create new Order Bag Service Item</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.reserveList\"><span><md-icon>list</md-icon></span><span class=\"hidden-xs\" translate=\"entity.action.backToReserveList\">entity.action.backToReserveList </span><!--<span class=\"visible-xs\" translate=\"entity.action.back\">--><!--entity.action.back--><!--</span>--></md-button></div><!--has-authority=\"ROLE_RESERVATION_MODIFIER\"--><div class=\"pull-left\" ng-if=\"vm.resultStatus.status==\'DONE\' && vm.showOtherActionsButton\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><md-menu md-offset=\"0 60\"><md-button class=\"md-raised\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><span><md-icon aria-hidden=\"true\" style=\"transform: rotate(90deg)\">chevron_right</md-icon></span><span translate=\"tikonApp.orderBag.otherActions\">otherActions</span></md-button><!--<md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\">--><!--<md-icon aria-hidden=\"true\">videocam</md-icon>--><!--</md-button>--><md-menu-content width=\"4\"><md-menu-item ng-if=\"vm.canReApproveRequestToPay\"><md-button ng-click=\"vm.reConfirmReserveRequest()\"><md-icon md-menu-align-target style=\"color: #2b6b7f\">restore</md-icon><span translate=\"tikonApp.orderBag.otherAction.reApproveRequest\">reApproveRequest</span></md-button></md-menu-item><md-menu-item ng-if=\"vm.canResendNotification\"><md-button ng-click=\"vm.reSendNotification()\"><md-icon md-menu-align-target style=\"color: #2b6b7f\">email</md-icon><span>{{\'tikonApp.orderBag.otherAction.resendNotification_\'+ vm.orderBag.status | translate}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"row\"><div class=\"panel panel-default\"><!--<div class=\"panel-heading\" translate=\"entity.action.edit\">--><!--entity.action.edit--><!--</div> --><div class=\"panel-heading\">رزرو شماره <span>:</span> <span>{{vm.orderBag.id}}</span></div><div class=\"panel-body\"><md-content class=\"rwMdContent\"><form name=\"editForm\" role=\"form\" novalidate><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-sm-4\"><div class=\"reserveDetails-card\"><h4><div ng-class=\"vm.findStatusStyle(vm.orderBag.status)\"><i ng-if=\"vm.orderBag.status == vm.constStatus.canceled\" class=\"fa fa-ban\"></i> <i ng-if=\"vm.orderBag.status == vm.constStatus.confirmed\" class=\"fa fa-check-circle-o\"></i><!--<span class=\"glyphicon glyphicon-stop\"></span>--> {{vm.findStatusTitle(vm.orderBag.status)}}</div></h4><hr><div class=\"\" style=\"margin-top: -10px\" ng-class=\"vm.orderBag.status != vm.constStatus.canceled  ? \'success\' : \'danger\'\"><div><div style=\"text-align: left; margin: 10px 0\" name=\"actions\"><div class=\"reserveDetails-btn\"><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-10\" style=\"margin-right: -12px\" ng-if=\"vm.orderBag.status == vm.constStatus.reserveRequest && vm.orderBag.finalPrice>0 && vm.resultStatus.status==\'DONE\'\"><md-button ng-click=\"vm.confirmReserveRequest()\" class=\"md-raised md-primary\"><i class=\"fa fa-check\"></i> <span class=\"\" translate=\"tikonApp.orderBag.confirmReserveRequest\">Confirm Reserve Request</span></md-button></div></div><div class=\"row\" style=\"text-align: center\"><span class=\"\" style=\"\" ng-if=\"(vm.orderBag.status != vm.constStatus.confirmed && vm.resultStatus.status==\'DONE\') || vm.orderBag.status == vm.constStatus.requestConfirm\"><md-button ng-click=\"vm.approveOrderBag()\" class=\"md-raised md-primary\" style=\"background-color: green\"><i class=\"fa fa-check\"></i> <span class=\"\" translate=\"tikonApp.orderBag.approveOrderBag\">Approve</span></md-button></span><span class=\"\" ng-if=\"(vm.orderBag.status != vm.constStatus.canceled && vm.resultStatus.status==\'DONE\') || vm.orderBag.status == vm.constStatus.requestConfirm || vm.orderBag.status == vm.constStatus.reserveRequest\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><md-button ng-click=\"vm.cancelOrderBag()\" class=\"md-raised md-warn\"><i class=\"fa fa-ban\"></i> <span class=\"\" translate=\"tikonApp.orderBag.cancelOrderBag\">Cancel</span></md-button></span></div></div></div></div></div></div></div><div class=\"col-sm-4\"><div class=\"reserveDetails-card\"><h5 translate=\"tikonApp.orderBag.customerName\">customer</h5><hr><div id=\"customerCard\" style=\"height: 60px; text-align: center\"><div style=\"line-height: normal\"><div class=\"row\"><i class=\"glyphicon glyphicon-user\"></i><!--<span translate=\"tikonApp.customer.customerName\"></span>--><!--:--> <a class=\"customer-name\" ng-click=\"vm.goToCustomerDetail()\"><span>{{vm.orderBag.customer.personalInfo.fisrtName}} </span><span>{{vm.orderBag.customer.personalInfo.lastName}}</span></a></div><div class=\"row\"><span class=\"td-label\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><i class=\"fa fa-phone\"></i><!--<span translate=\"tikonApp.personInfo.phoneNumber\"></span>--> </span><span class=\"td-text\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><span>{{vm.orderBag.customer.personalInfo.phoneNumber}}</span></span></div><div class=\"row\" style=\"font-size: 12px\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><span class=\"td-label\" ng-if=\"vm.orderBag.customer.personalInfo.email\"><i class=\"fa fa-envelope\"></i><!--<span translate=\"tikonApp.personInfo.phoneNumber\"></span>--> </span><span class=\"td-text\" ng-if=\"vm.orderBag.customer.personalInfo.email!=null\"><span>{{vm.orderBag.customer.personalInfo.email}}</span></span></div></div></div></div></div><div class=\"col-sm-4\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"reserveDetails-card\"><h5 translate=\"tikonApp.orderBag.paymentStatusSummary\">paymentStatusSummary</h5><hr><div id=\"alert\" ng-class=\"vm.isBalanced() ? \'success\' : \'danger\'\" style=\"height: 60px; text-align: center\"><div ng-class=\"vm.isBalanced() ? \'text-success\' : \'text-danger\'\"><div ng-if=\"!vm.isBalanced()\"><i class=\"fa fa-exclamation-triangle\"></i> <span translate=\"tikonApp.orderBag.CheckOut-NOk\"></span></div><div ng-if=\"vm.isBalanced()\"><i class=\"fa fa-check-circle\"></i> <span translate=\"tikonApp.orderBag.CheckOut-Ok\"></span></div></div><div class=\"\"><div class=\"row lbl\"><span translate=\"tikonApp.orderBag.finalPrice\"></span> :</div><div class=\"row prc\"><div style=\"margin: 2px\">{{vm.orderBag.finalPrice | number}} <span translate=\"global.currency\"></span></div></div></div><div class=\"row\"><div class=\"col-6 lbl\"><span translate=\"tikonApp.orderBag.remainAmount\"></span> :</div><div class=\"col-6 prc\"><div style=\"margin: 2px\">{{vm.orderBag.remainAmount | number}} <span translate=\"global.currency\"></span></div></div></div></div></div></div></div><fieldset class=\"standard-fieldset\"><legend>موارد رزرو شده<!--<span>-</span>--><!--<span>{{vm.orderBag.id}}</span>--></legend><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><th></th><th></th><th><span translate=\"tikonApp.orderBag.serviceItemTitle\"></span></th><th><span translate=\"tikonApp.orderBag.reservedDate\"></span></th><th><span translate=\"tikonApp.orderBag.priceQty\"></span></th><th></th></thead><tbody><tr ng-repeat=\"orderBagItem in vm.orderBag.orderBagServiceItems | orderBy: \'serviceTimeSession.startTime\' \" style=\"background-color: #f5f5f5\"><td><!--<div name=\"itemActions\" ng-if=\"vm.resultStatus.status==\'DONE\'\">--><!--</div>--><md-button has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-click=\"vm.deleteOrderBagItem(orderBagItem.id)\" class=\"md-raised\" style=\"color: red\" ng-if=\"vm.orderBag.orderBagServiceItems.length > 1\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.deleteItemTip\' | translate}}</md-tooltip><md-icon style=\"color: red\" aria-hidden=\"true\">delete_forever</md-icon><span class=\"\" translate=\"tikonApp.orderBagServiceItem.deleteItem\">not Check In</span></md-button><span ng-if=\"vm.orderBag.status != vm.constStatus.canceled \"><md-button ng-if=\"orderBagItem.checkinStatus!=\'CHECKIN\' && vm.showReplaceTime\" class=\"md-raised md-primary\" ng-click=\"vm.replaceTime(orderBagItem)\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><span class=\"glyphicon glyphicon-time\" style=\"vertical-align: middle\"></span> <span translate=\"tikonApp.orderBag.replaceTime\">Replace Time</span></md-button></span></td><td><div ng-if=\"orderBagItem.checkinStatus==\'CHECKIN\'\"><div class=\"order-bag-checkin-status\"><span class=\"glyphicon glyphicon-clos\"></span> <span class=\"\" translate=\"tikonApp.orderBag.checkedin\">Checked In</span></div><div>{{orderBagItem.checkinTime | toPersianTime}} - {{orderBagItem.checkinTime | toFullPersianDate}} <span><button ng-click=\"vm.removeCheckinOrderBagServieItem(orderBagItem.id)\" class=\"glyphicon glyphicon-remove\"></button></span></div></div><div ng-if=\"orderBagItem.checkinStatus==\'NOT_CHECKIN\'\"><div class=\"order-bag-notcheckin-status\"><span class=\"glyphicon glyphicon-check\"></span> <span class=\"\" translate=\"tikonApp.orderBag.notcheckedin\">Checked In </span><button ng-click=\"vm.removeCheckinOrderBagServieItem(orderBagItem.id)\" class=\"glyphicon glyphicon-remove\"></button></div></div></td><td><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.startVideoCall\' | translate}}</md-tooltip><a ng-click=\"vm.goToVideoCall(orderBagItem)\"><md-icon ng-if=\"orderBagItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a></span><span>{{orderBagItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagItem.serviceItem.category.categoryName}}</div><div ng-if=\"orderBagItem.servant!=null\">({{orderBagItem.servant.personInfo.fisrtName}} {{orderBagItem.servant.personInfo.lastName}})</div></span></td><td><div><i class=\"fa fa-calendar\"></i> {{orderBagItem.serviceTimeSession.startTime | toFullPersianDate}}</div><div><i class=\"fa fa-clock-o\"></i> {{orderBagItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagItem.serviceTimeSession.startTime | toPersianTime}}</div><div id=\"timePeriod\">{{vm.timeDiff(orderBagItem)}}</div></td><td><span ng-repeat=\"orderBagItemDtail in orderBagItem.orderBagServiceItemDtail\"><div class=\"form-group\"><table><tr ng-if=\"orderBagItemDtail.gty > 0\"><td><div><div has-authority=\"ROLE_FINANCIAL_MANAGER\">{{orderBagItemDtail.priceInfoDtail.title}} : {{orderBagItemDtail.price | number}} <span translate=\"global.currency\"></span></div><div><span translate=\"tikonApp.orderBagServiceItemDtail.gty\">QtyY</span> {{orderBagItemDtail.gty}} <i class=\"fa fa-user\"></i></div><div ng-if=\"vm.showTimePeriod(orderBagItemDtail,orderBagItem)\"><span translate=\"tikonApp.orderBagServiceItem.timePeriod\">QtyY</span><!--{{orderBagItem.timePeriod/orderBagItemDtail.timeUnitQty}} *--> {{orderBagItem.timePeriod}} * {{orderBagItemDtail.timeUnitQty}}</div></div></td><td><span ng-repeat=\"option in orderBagItemDtail.orderBagItemOptions\"><div class=\"form-group\"><div class=\"glyphicon glyphicon-ok\"></div>{{option.serviceOptionItem.optionName}}<!--{{option.priceInfoDtail.price}}--></div></span></td></tr></table></div><!--<label class=\"control-label\"--><!--translate=\"tikonApp.orderBagServiceItemDtail.options\">Options</label>--></span></td><td style=\"font-size: 10px\"><md-button ng-if=\"orderBagItem.checkinStatus!=\'CHECKIN\'\" ng-click=\"vm.checkinOrderBagServieItem(orderBagItem.id)\" class=\"md-flat\" style=\"border: 1px solid gray;color: green;font-size: 12px\"><span class=\"\" translate=\"tikonApp.orderBag.checkin\">Check In</span></md-button><md-button ng-if=\"orderBagItem.checkinStatus!=\'NOT_CHECKIN\'\" ng-click=\"vm.notCheckinOrderBagServieItem(orderBagItem.id)\" class=\"md-flat\" style=\"border: 1px solid gray;color: red;font-size: 12px\"><span class=\"\" translate=\"tikonApp.orderBag.not_checkin\">not Check In</span></md-button></td><!--<td>--><!--<span ng-repeat=\"participant in orderBagItem.participantPersons\">--><!--<div>--><!--<span>{{$index+1}}-</span> <span> {{participant.personInfo.fisrtName}}</span><span> {{participant.personInfo.lastName}}</span>--><!--</div>--><!--</span>--><!--</td>--></tr></tbody></table></div></div></div></fieldset><div class=\"row\"><div class=\"col-md-6\"><fieldset class=\"standard-fieldset\" ng-if=\"(vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\') || (vm.orderBag.intakeData!= undefined && vm.orderBag.intakeData!=\'\' && vm.orderBag.intakeData != null )\"><legend>اطلاعات تکمیلی (درج توسط مشتری)</legend><div id=\"orderBag_intakeformData\"><eo-intake-data-viewer intake-data=\"vm.orderBag.intakeData\"></eo-intake-data-viewer></div><div ng-if=\"vm.orderBag.comment != null && vm.orderBag.comment != undefined && vm.orderBag.comment != \'\'\"><hr><div class=\"row\"><div class=\"col-sm-2\">توضیحات رزرو :</div><div class=\"col-sm-10\">{{vm.orderBag.comment}}</div></div></div></fieldset></div><div class=\"col-md-6\"><fieldset class=\"standard-fieldset\" ng-if=\" (vm.orderBag.supplierIntakeData!= undefined && vm.orderBag.supplierIntakeData!=\'\' && vm.orderBag.supplierIntakeData != null )\"><legend>اطلاعات تکمیلی (درج توسط کسب و کار)</legend><div id=\"orderBag_Supplier_intakeformData\"><eo-intake-data-viewer intake-data=\"vm.orderBag.supplierIntakeData\"></eo-intake-data-viewer></div></fieldset></div></div><fieldset class=\"standard-fieldset\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><legend><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></legend><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalOptionPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalServicePrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalVat\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalVAT | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.totalDiscount\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.totalDiscount | number}} <span translate=\"global.currency\"></span></div></td></tr><tr ng-if=\"vm.orderBag.usedCouponCodes\"><td class=\"td-label\"><span translate=\"tikonApp.orderBag.couponCode\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.usedCouponCodes}}</div></td></tr></table></div><div class=\"col-sm-6\"></div><div class=\"col-sm-6\"><table class=\"text-success\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBag.finalPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.orderBag.finalPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div></div></div><!--<legend><span--><!--translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></legend>--><!--<div class=\"row\" style=\"margin-top: 10px;\">--><!--&lt;!&ndash;<div class=\"col-sm-7 col-md-5\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBag.totalServicePrice\"></span>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"text-input rwInfoInputBox\">{{vm.orderBag.totalServicePrice | number}} <span&ndash;&gt;--><!--&lt;!&ndash;translate=\"global.currency\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-sm-7 col-md-5\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBag.totalOptionPrice\"></span>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"text-input rwInfoInputBox\"> {{vm.orderBag.totalOptionPrice | number}}&ndash;&gt;--><!--&lt;!&ndash;<span&ndash;&gt;--><!--&lt;!&ndash;translate=\"global.currency\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-sm-7 col-md-5\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBag.totalVat\"></span>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"text-input rwInfoInputBox\"> {{vm.orderBag.totalVAT | number}} <span&ndash;&gt;--><!--&lt;!&ndash;translate=\"global.currency\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-sm-7 col-md-5\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBag.totalDiscount\"></span>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"text-input rwInfoInputBox\"> {{vm.orderBag.totalDiscount | number}}<span&ndash;&gt;--><!--&lt;!&ndash;translate=\"global.currency\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-sm-7 col-md-5 text-success\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBag.finalPrice\"></span>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"text-input rwInfoInputBox\"> {{vm.orderBag.finalPrice | number}} <span&ndash;&gt;--><!--&lt;!&ndash;translate=\"global.currency\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row\" style=\"margin-top: 30px;\">--><!--</div>--></fieldset><fieldset class=\"standard-fieldset\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><legend><span translate=\"tikonApp.orderBag.detailsOfPayment\"></span></legend><div class=\"col-sm-12\"><div><md-button ng-click=\"vm.insertPayment()\" class=\"md-raised md-primary\"><span style=\"font-weight: bold\">+</span> <span class=\"\" translate=\"tikonApp.orderBag.insertPayment\">Insert Payment</span></md-button><md-button ng-if=\"vm.orderBag.remainAmount > 0\" ng-click=\"vm.settlementInvoice()\" class=\"md-raised\"><span style=\"font-weight: bold\">+</span> <span class=\"\" translate=\"tikonApp.orderBag.settlementInvoice\">Settlement Invoice</span></md-button></div><div class=\"table-responsive\"><table class=\"table rwTable\"><thead><tr><th><span translate=\"tikonApp.paymentLog.amount\">Amount</span> <span translate=\"global.currencyBracket\"></span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.paymentType\">Payment Type</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.traceCode\">Trace Code</span> <span class=\"\"></span></th><th><span translate=\"tikonApp.paymentLog.createDate\">Create Date</span> <span class=\"\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"paymentLog in vm.invoiceInfo.paymentLogs track by paymentLog.id\"><td>{{paymentLog.amount | number}}</td><td translate=\"{{\'tikonApp.PaymentType.\' + paymentLog.paymentType}}\">{{paymentLog.paymentType}}</td><td>{{paymentLog.traceCode}}</td><td>{{paymentLog.createDate | toPersianDate}}</td><td><div ng-click=\"vm.deletePaymentLog(paymentLog)\" style=\"color: red\" ng-if=\"paymentLog.paymentType != \'ONLINE\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.deleteItemTip\' | translate}}</md-tooltip><md-icon style=\"color: red\" aria-hidden=\"true\">delete_forever</md-icon></div></td></tr></tbody></table></div></div></fieldset></form></md-content></div></div></div></div>");
$templateCache.put("app/entities/order-bag/intake-data-dialog.html","<style>.panel {\n        margin: 0;\n\n    }</style><md-dialog><div class=\"panel\"><div class=\"panel-heading\">اطلاعات تکمیلی<!--<button type=\"button\" class=\"close\" onclick=\"closePanel()\">&times;</button>--></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><fieldset class=\"standard-fieldset\" ng-if=\"($ctrl.orderbag.intakeData!= undefined && $ctrl.orderbag.intakeData!=\'\' && $ctrl.orderbag.intakeData != null )\"><legend>(درج توسط مشتری)</legend><div id=\"orderBag_intakeformData\"><eo-intake-data-viewer intake-data=\"$ctrl.orderbag.intakeData\"></eo-intake-data-viewer></div></fieldset></div><div class=\"col-md-12\"><fieldset class=\"standard-fieldset\" ng-if=\"($ctrl.orderbag.supplierIntakeData!= undefined && $ctrl.orderbag.supplierIntakeData!=\'\' && $ctrl.orderbag.supplierIntakeData != null )\"><legend>(درج توسط کسب و کار)</legend><div id=\"orderBag_Supplier_intakeformData\"><eo-intake-data-viewer intake-data=\"$ctrl.orderbag.supplierIntakeData\"></eo-intake-data-viewer></div></fieldset></div></div><!--<button type=\"button\" class=\"btn btn-secondary\" ng-click=\"$mdDialog.cancel()\">بستن</button>--></div></div></md-dialog><!--<script>--><!--function closePanel() {--><!--alert(\'ok\');--><!--}--><!--</script>--><!--<div class=\"modal fade\">--><!--<div class=\"modal-dialog modal-dialog-centered modal-sm\">--><!--<div class=\"modal-content\">--><!--&lt;!&ndash; Modal Header &ndash;&gt;--><!--<div class=\"modal-header\">--><!--&lt;!&ndash;<h4 class=\"modal-title\">Modal Heading</h4>&ndash;&gt;--><!--<button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button>--><!--</div>--><!--&lt;!&ndash; Modal body &ndash;&gt;--><!--<div class=\"modal-body\">--><!--<eo-intake-data-viewer intake-data=\"$ctrl.orderbag.intakeData\"></eo-intake-data-viewer>--><!--</div>--><!--&lt;!&ndash; Modal footer &ndash;&gt;--><!--<div class=\"modal-footer\">--><!--<button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">{{\'tikonApp.notificationSetting.close\' | translate}}</button>--><!--</div>--><!--</div>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/order-bag/order-bag-bottom-sheet-template.html","<div class=\"pl-bottom-sheet-container\"><div class=\"pl-bottom-sheet-content\"><ul ng-if=\"vm.mode==\'MAIN_ACTIONS\'\"><li ng-click=\"vm.itemClick(\'confirmReserveRequest\')\" ng-if=\"vm.orderBag.status == vm.constStatus.reserveRequest && vm.orderBag.finalPrice>0 && vm.resultStatus.status==\'DONE\'\"><span class=\"\" translate=\"tikonApp.orderBag.confirmReserveRequest\">Confirm Reserve Request</span></li><li ng-click=\"vm.itemClick(\'approveOrderBag\')\" ng-if=\"(vm.orderBag.status != vm.constStatus.confirmed && vm.resultStatus.status==\'DONE\') || vm.orderBag.status == vm.constStatus.requestConfirm\"><span class=\"\" translate=\"tikonApp.orderBag.approveOrderBag\">Approve</span></li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-click=\"vm.itemClick(\'settlementInvoice\')\" ng-if=\"vm.orderBag.remainAmount > 0\">ثبت تسویه</li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-click=\"vm.itemClick(\'insertPayment\')\">ثبت دریافتی ها</li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.showUseCredit\" ng-click=\"vm.itemClick(\'useCredit\')\">استفاده از اعتبار مشتری</li><!-- Do not show on production. --><!-- <li has-authority=\"ROLE_FINANCIAL_MANAGER\"\n                ng-if=\"vm.showUseCredit\"\n                ng-click=\"vm.itemClick(\'usePosPayment\')\">\n               پرداخت با دستگاه کارت‌خوان(pos)\n            </li> --><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.canIssueInvoice && !vm.invoiceInfo.issueType\" ng-click=\"vm.itemClick(\'issueInvoiceInfo\')\"><span class=\"\" translate=\"tikonApp.orderBag.issueInvoiceInfo\">issueInvoiceInfo</span></li><li has-authority=\"ROLE_FINANCIAL_MANAGER\" ng-if=\"vm.invoiceInfo.issueType\" ng-click=\"vm.itemClick(\'viewInvoiceInfo\')\"><span class=\"\" translate=\"tikonApp.orderBag.viewInvoice\">viewInvoice</span></li><li ng-click=\"vm.itemClick(\'cancelOrderBag\')\" style=\"color: red\" ng-if=\"(vm.orderBag.status != vm.constStatus.canceled && vm.resultStatus.status==\'DONE\') || vm.orderBag.status == vm.constStatus.requestConfirm || vm.orderBag.status == vm.constStatus.reserveRequest\"><span class=\"\" translate=\"tikonApp.orderBag.cancelOrderBag\">Cancel</span></li></ul><ul ng-if=\"vm.mode==\'OTHER_ACTIONS\'\"><li ng-click=\"vm.itemClick(\'reConfirmReserveRequest\')\" ng-if=\"vm.canReApproveRequestToPay && vm.resultStatus.status==\'DONE\' &&  vm.orderBag.status != vm.constStatus.reserveRequest\"><span translate=\"tikonApp.orderBag.otherAction.reApproveRequest\">reApproveRequest</span></li><li ng-click=\"vm.itemClick(\'reSendNotification\')\" ng-if=\"vm.canResendNotification && vm.resultStatus.status==\'DONE\' &&  vm.orderBag.status != vm.constStatus.reserveRequest\"><span>{{\'tikonApp.orderBag.otherAction.resendNotification_\'+ vm.orderBag.status | translate}}</span></li><!--<hr>--><li ng-if=\"vm.canDeleteOrderBag\" ng-click=\"vm.itemClick(\'deleteOrderBag\')\" has-not-authority=\"ROLE_SERVANT_LOGIN\" style=\"color: red\">حذف کامل رزرو</li></ul></div><div class=\"pl-bottom-sheet-content\"><div class=\"pl-bottom-sheet-close-btn\" ng-click=\"vm.close()\">بستن</div></div></div>");
$templateCache.put("app/entities/order-bag/order-bag-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.orderBag.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.orderBag.delete.question\" translate-values=\"{id: \'{{vm.orderBag.id}}\'}\">Are you sure you want to delete this Order Bag?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/order-bag/order-bag-detail.html","<div><h2><span translate=\"tikonApp.orderBag.detail.title\">Order Bag</span> {{vm.orderBag.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.orderBag.createDate\">Create Date</span></dt><dd><span>{{vm.orderBag.createDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.orderBag.status\">Status</span></dt><dd><span>{{vm.orderBag.status}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/order-bag/order-bag-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderBagLabel\" translate=\"tikonApp.orderBag.home.createOrEditLabel\">Create or edit a Order Bag</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.orderBag.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.orderBag.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.orderBag.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.status\" for=\"field_status\">Status</label><input type=\"number\" class=\"form-control\" name=\"status\" id=\"field_status\" ng-model=\"vm.orderBag.status\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-bag/order-bag-item-bottom-sheet-template.html","<div class=\"pl-bottom-sheet-container\"><div class=\"pl-bottom-sheet-content\"><ul><li ng-click=\"vm.itemClick(\'replaceTime\')\" ng-if=\"vm.orderBag.status != vm.constStatus.canceled && vm.showReplaceTime \" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><span translate=\"tikonApp.orderBag.replaceTime\">Replace Time</span></li><li ng-click=\"vm.itemClick(\'goToVideoCall\')\" ng-if=\"vm.orderBagItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\">ورود به جلسه تصویری</li><li ng-click=\"vm.itemClick(\'notCheckinOrderBagServieItem\')\" ng-if=\"vm.orderBagItem.checkinStatus!=\'NOT_CHECKIN\'\"><span class=\"\" translate=\"tikonApp.orderBag.notcheckedin\">Not Checked In</span></li><li ng-click=\"vm.itemClick(\'checkinOrderBagServieItem\')\" ng-if=\"vm.orderBagItem.checkinStatus!=\'CHECKIN\'\"><span class=\"\" translate=\"tikonApp.orderBag.checkedin\">Checked In</span></li><li ng-click=\"vm.itemClick(\'deleteOrderBagItem\')\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-if=\"vm.orderBag.orderBagServiceItems.length > 1\" style=\"color: red\">حذف آیتم</li></ul></div><div class=\"pl-bottom-sheet-content\"><div class=\"pl-bottom-sheet-close-btn\" ng-click=\"vm.close()\">بستن</div></div></div>");
$templateCache.put("app/entities/order-bag/order-bag-list.html","<style>.view-intake-data-link {\n        color: #00b09f;\n        cursor: pointer;\n    }</style><div class=\"hidden-xs\"><h2 translate=\"tikonApp.orderBag.orderBagList\">Order Bag List</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-3 no-padding-left\"><button has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" class=\"btn btn-primary\" ui-sref=\"supplierPanel.upsertOrderBagNew\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBag.home.createLabel\">Create new Order Bag Service Item</span></button> <button class=\"btn btn-info\" ng-click=\"vm.searchOrderBag()\"><span class=\"glyphicon glyphicon-refresh\"></span></button></div><div class=\"col-xs-4\" style=\"padding-top: 18px ; margin-right: 0px\"><a ng-click=\"vm.showDateSearch()\" translate=\"tikonApp.orderBag.searchByDates\">search by Date</a></div></div><div class=\"row\" ng-if=\"vm.showSearchByDates\"><div class=\"col-sm-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div><div class=\"col-xs-4\" style=\"padding-top: 20px\"><button class=\"btn btn-primary\" ng-click=\"vm.searchOrderBag()\"><span class=\"glyphicon glyphicon-search\"></span></button></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\" for=\"field_serviceItem\">ServiceItem</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.serviceItemId\" ng-change=\"vm.serviceItem_changed()\" pastyle=\"min-width: 100px;\"><md-option value=\"\"><span translate=\"tikonApp.orderBagServiceItem.showAll\"></span></md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceItems\"><small ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} -</small> {{si.itemTitle}}</md-option></md-select><!--<select class=\"form-control\" id=\"field_serviceItem\" ng-change=\"vm.serviceItem_changed()\"--><!--name=\"serviceItem\" ng-model=\"vm.serviceItemId\" required--><!--eo-required=\"\"--><!--ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in vm.serviceItems\">--><!--<option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\">--><!--</option>--><!--</select>--></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\" for=\"field_status\">Status</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.orderBagStatus\" ng-change=\"vm.status_changed()\" style=\"min-width: 100px\"><md-option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\"></md-option><md-option value=\"1\" translate=\"tikonApp.orderBag.status.1\">CONFIRMED</md-option><md-option value=\"4\" translate=\"tikonApp.orderBag.status.4\">CANCELED</md-option><md-option value=\"5\" translate=\"tikonApp.orderBag.status.5\">RESERVE_REQUEST</md-option><md-option value=\"6\" translate=\"tikonApp.orderBag.status.6\">REQUEST_CONFIRMED</md-option></md-select><!--<select class=\"form-control\" name=\"status\"--><!--ng-model=\"vm.orderBagStatus\"--><!--id=\"field_status\"--><!--ng-change=\"vm.status_changed()\"--><!--&gt;--><!--<option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\">--><!--</option>--><!--<option value=\"1\" translate=\"tikonApp.orderBag.status.1\">--><!--CONFIRMED--><!--</option>--><!--<option value=\"4\" translate=\"tikonApp.orderBag.status.4\">--><!--CANCELED--><!--</option>--><!--<option value=\"5\" translate=\"tikonApp.orderBag.status.5\">--><!--RESERVE_REQUEST--><!--</option>--><!--<option value=\"6\" translate=\"tikonApp.orderBag.status.6\">--><!--REQUEST_CONFIRMED--><!--</option>--><!--</select>--></div></div><div class=\"col-sm-2\"></div></div></div><div class=\"table-responsive\"><table st-safe-src=\"vm.orderBagServiceItems\" st-table=\"collection\" st-safe- class=\"jh-table table table-striped\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control\" placeholder=\"{{ \'tikonApp.orderBag.home.search\' | translate }}\" type=\"text\"></th></tr><tr><!--<th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"orderBagId\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceItemTitle\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.orderBag.status.title\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\"><span translate=\"tikonApp.orderBag.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"servant.servantName\"><span translate=\"tikonApp.servant.home.title\">Servant</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th>اطلاعات تکمیلی</th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div></td><td>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}<div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div>{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></td><td ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</td><td>{{orderBagServiceItem.orderBag.finalPrice | number}}</td><td><div><span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianDate}} - </span>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}} <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\"><div>{{vm.getMonthCount(orderBagServiceItem)}} (ماه)</div></span></div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startDate == orderBagServiceItem.serviceTimeSession.endDate\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td><!--<td>--><!--<div>{{orderBagServiceItem.servant.servantName}} </div>--><!--</td>--><!--<td>--><!--<a ui-sref=\"order-bag-detail({id:orderBagServiceItem.orderBagId})\">{{orderBagServiceItem.orderBagId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"service-item-detail({id:orderBagServiceItem.serviceItemId})\">{{orderBagServiceItem.serviceItemId}}</a>--><!--</td>--><td><span class=\"view-intake-data-link\" data-ng-click=\"vm.showIntakeData(orderBagServiceItem.orderBag)\" ng-if=\"orderBagServiceItem.orderBag.intakeData\"><i class=\"fa fa-clone\"></i> مشاهده</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs\"><div class=\"row\"><div class=\"float-mobile-button\" ui-sref=\"supplierPanel.upsertOrderBagNew\"><i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i><!--<button class=\"btn btn-primary\" >--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--<span class=\"hidden-xs\" translate=\"tikonApp.orderBag.home.createLabel\">--><!--Create new Order Bag Service Item--><!--</span>--><!--</button>--></div><div class=\"orderBag-mobile-float\" style=\"padding-right: 10px\"><h4 translate=\"tikonApp.orderBag.orderBagList\">Order Bag List</h4></div><div style=\"text-align: left ;color: #00acc1;padding-top: 20px;padding-left: 20px\"><span translate=\"tikonApp.orderBag.searchFilter\" ng-click=\"vm.showSearchBoxOnMobile()\">Search</span> <i class=\"fa fa-filter\"></i></div></div><div ng-if=\"vm.searchBoxOnMobile\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div><div class=\"col-xs-4\" style=\"padding-top: 20px\"><button class=\"btn btn-primary\" ng-click=\"vm.searchOrderBag()\"><span class=\"glyphicon glyphicon-search\"></span></button></div></div></div><div class=\"row\"><div ng-click=\"vm.showSearchTextBoxOnMobile()\" style=\"text-align: left ;color: #00acc1;padding-top: 10px;padding-left: 20px\"><span translate=\"tikonApp.orderBag.home.search\">Search</span> <i class=\"fa fa-search\"></i></div></div><div ng-if=\"vm.searchTextBoxOnMobile\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"searchQuery\" name=\"searchQuery\" ng-model=\"vm.searchQuery\" ng-change=\"vm.searchOrderBagByQuery()\" placeholder=\"{{ \'tikonApp.orderBag.home.search\' | translate }}\"></div></div></div></div><div class=\"orderBag-mobile-block\" ng-repeat=\"orderBagServiceItem in vm.orderBagServiceItemsQuery track by orderBagServiceItem.id\" ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\"><div class=\"row\" name=\"serviceInfo\"><div class=\"orderBag-mobile-float\"><a ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a></div><div class=\"orderBag-mobile-float\"><div ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</div></div></div><div class=\"row\" name=\"serviceInfo\"><div class=\"orderBag-mobile-float\">{{orderBagServiceItem.serviceItem.itemTitle}}</div><div class=\"orderBag-mobile-float\">{{orderBagServiceItem.orderBag.finalPrice | number}} <span translate=\"global.currency\"></span></div></div><div class=\"row\" name=\"dateTimeInfo\"><div><div class=\"orderBag-mobile-float\"><i class=\"fa fa-calendar\"></i> <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianDate}} - </span>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}} <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\"><!--<div>--><!--{{vm.getMonthCount(orderBagServiceItem)}}--><!--(ماه)--><!--</div>--></span></div><div class=\"orderBag-mobile-float\" ng-if=\"orderBagServiceItem.serviceTimeSession.startDate == orderBagServiceItem.serviceTimeSession.endDate\"><i class=\"fa fa-clock-o\"></i> {{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></div></div><div class=\"row\" name=\"customerInfo\"><div class=\"orderBag-mobile-float\"><i class=\"glyphicon glyphicon-user\"></i> {{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</div><div class=\"orderBag-mobile-float\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><i class=\"fa fa-phone\"></i> {{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div>{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></div><!--<td>--><!--<div>{{orderBagServiceItem.servant.servantName}} </div>--><!--</td>--><!--<td>--><!--<a ui-sref=\"order-bag-detail({id:orderBagServiceItem.orderBagId})\">{{orderBagServiceItem.orderBagId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"service-item-detail({id:orderBagServiceItem.serviceItemId})\">{{orderBagServiceItem.serviceItemId}}</a>--><!--</td>--><!--<div class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--&lt;!&ndash;<button type=\"submit\"&ndash;&gt;--><!--&lt;!&ndash;ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-danger btn-sm\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-remove-circle\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--</div>--><!--</div>--></div></div>");
$templateCache.put("app/entities/order-bag/order-bags.html","<div><h2 translate=\"tikonApp.orderBag.home.title\">Order Bags</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"order-bag.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBag.home.createLabel\">Create new Order Bag</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.orderBag.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.orderBag.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.orderBag.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBag in vm.orderBags track by orderBag.id\"><td><a ui-sref=\"order-bag-detail({id:orderBag.id})\">{{orderBag.id}}</a></td><td>{{orderBag.createDate | date:\'medium\'}}</td><td>{{orderBag.status}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"order-bag-detail({id:orderBag.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"order-bag.edit({id:orderBag.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order-bag.delete({id:orderBag.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/order-bag/upsert-order-bag.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><!--<action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar>--><action-bar ng-disabled=\"editForm.$invalid || vm.isSaving\"></action-bar><!--<div class=\"modal-header\">--><!--<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"--><!--ng-click=\"vm.clear()\">&times;</button>--><!--<h4 class=\"modal-title\" id=\"myOrderBagLabel\" translate=\"tikonApp.orderBag.home.createOrEditLabel\">Create or edit a Order Bag</h4>--><!--</div>--><!--<div class=\"modal-body\">--><!--<jhi-alert-error></jhi-alert-error>--><!--<div class=\"form-group\" ng-if=\"vm.orderBag.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"vm.orderBag.id\" readonly />--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.orderBag.createDate\" for=\"field_createDate\">Create Date</label>--><!--<div class=\"input-group\">--><!--<input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.orderBag.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"--><!--/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.orderBag.status\" for=\"field_status\">Status</label>--><!--<input type=\"number\" class=\"form-control\" name=\"status\" id=\"field_status\"--><!--ng-model=\"vm.orderBag.status\"--><!--/>--><!--</div>--><!--</div>--><!--<div class=\"modal-footer\">--><!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>--><!--</button>--><!--<button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">--><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>--><!--</button>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.orderBag.status.title\" for=\"field_status\">Orderbag--><!--Status</label>--><!--<select class=\"form-control\" name=\"status\" ng-model=\"vm.orderBag.status\" id=\"field_status\">--><!--<option value=\"0\" translate=\"tikonApp.orderBag.status.active\">Active</option>--><!--<option value=\"1\" translate=\"tikonApp.orderBag.status.confirmed\">Confirmed</option>--><!--<option value=\"4\" translate=\"tikonApp.orderBag.status.canceled\">Canceled</option>--><!--</select>--><!--</div>--><div name=\"customer\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.customerInfo\"></span></div><div class=\"panel-body\"><div name=\"findCustomer\"><div class=\"row\"><div class=\"col-sm-7\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete><!--  <label  for=\"phoneNumberToFined\" translate=\"tikonApp.personInfo.phoneNumber\">Phone\n                                  Number</label>\n                              <input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumberToFined\" name=\"phoneNumberToFind\"\n                                     ng-keypress=\"vm.findCustomerKeyPress($event)\"\n                                     placeholder=\"{{\'tikonApp.personInfo.phoneNumber\' | translate}}\"\n                                     ng-model=\"vm.phoneNumberToFind\" ng-minlength=11 ng-maxlength=11 required>\n  --><!--<span>--><!--{{vm.orderBag.customer.personalInfo.fisrtName}}--><!--{{vm.orderBag.customer.personalInfo.lastName}}--><!--</span>--></div><div class=\"col-sm-3\" style=\"padding-top: 26px\"><!--<button type=\"button\"--><!--ng-click=\"vm.findCustomer()\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--<span class=\"hidden-xs\" translate=\"tikonApp.orderBag.selectCustomerByPhoneNumber\">Select customer by phone number </span>--><!--</button>--> <button type=\"button\" ng-click=\"vm.newCustomer()\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomer\">New customer</span></button></div></div><div class=\"row\" ng-if=\"vm.customerMode == \'new\' || vm.orderBag.customer.personalInfo.fisrtName\"><div class=\"col-md-2\" ng-if=\"vm.isCustomerManager || vm.customerMode == \'new\' \"><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-placeHolder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.phoneNumber\" required></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.orderBag.customer.personalInfo.fisrtName\"><div ng-if=\"form.fisrtName.$dirty && form.fisrtName.$invalid\"><p class=\"help-block\" ng-if=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.orderBag.customer.personalInfo.lastName\"><div ng-if=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-if=\"form.lastName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><!--<div class=\"col-md-4\" ng-if=\"vm.customerMode == \'new\'\" >--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"login\" translate=\"global.form.usernameEnglishCharacter\">Username--><!--</label>--><!--<input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\"--><!--placeholder=\"{{\'global.form.username.placeholder\' | translate}}\"--><!--ng-model=\"vm.orderBag.customer.userAccount.login\" ng-minlength=1 ng-maxlength=50--><!--ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required>--><!--<div ng-if=\"form.login.$dirty && form.login.$invalid\">--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.required\"--><!--translate=\"register.messages.validate.login.required\">--><!--Your username is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.minlength\"--><!--translate=\"register.messages.validate.login.minlength\">--><!--Your username is required to be at least 1 character.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.maxlength\"--><!--translate=\"register.messages.validate.login.maxlength\">--><!--Your username cannot be longer than 50 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">--><!--Your username can only contain lower-case letters and digits.--><!--</p>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-3\" ng-if=\"vm.customerMode == \'new\'\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"tikonApp.orderBag.customer.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" style=\"direction: ltr\" placeholder=\"{{\'tikonApp.orderBag.customer.email-placeholder\' | translate}}\" ng-model=\"vm.orderBag.customer.userAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\"><div ng-if=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-if=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-if=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-if=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-if=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div></div></div></div></div><div data-ng-if=\"vm.formState==\'orderBagItem\'\"><div><pf-order-bag-service-item order-bag-service-item=\"vm.orderBag.orderBagServiceItems[0]\" init-mode=\"vm.formMode\" default-service-item-id=\"vm.states.serviceItemId\" default-start-date=\"vm.states.start_date\" default-end-date=\"vm.states.end_date\" default-service-time-session-id=\"vm.states.timeSessionId\"></pf-order-bag-service-item></div></div><div name=\"orderbagComment\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBag.comment\"></span></div><div class=\"panel-body\"><!--<input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\"--><!--ng-model=--><!--/>--><textarea class=\"form-control\" rows=\"5\" id=\"comment\" placeholder=\"{{\'tikonApp.orderBag.comment\' | translate}}\" ng-model=\"vm.orderBag.comment\"></textarea></div></div></div><div><button type=\"button\" ng-click=\"vm.serviceSelected()\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.formState==\'selectService\'\"><span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span></button> <button type=\"button\" ng-click=\"vm.prev()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span></button></div><div><!--{{vm.orderBag}}--><!--{{vm.orderBag.orderBagServiceItems}}--><!--{{vm.orderBag.orderBagServiceItems[0].orderBagServiceItemDtail}}--></div></form>");
$templateCache.put("app/entities/order-bag-item-option/order-bag-item-option-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.orderBagItemOption.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.orderBagItemOption.delete.question\" translate-values=\"{id: \'{{vm.orderBagItemOption.id}}\'}\">Are you sure you want to delete this Order Bag Item Option?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/order-bag-item-option/order-bag-item-option-detail.html","<div><h2><span translate=\"tikonApp.orderBagItemOption.detail.title\">Order Bag Item Option</span> {{vm.orderBagItemOption.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.orderBagItemOption.reserveTime\">Reserve Time</span></dt><dd><span>{{vm.orderBagItemOption.reserveTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.orderBagItemOption.qty\">Qty</span></dt><dd><span>{{vm.orderBagItemOption.qty}}</span></dd><dt><span translate=\"tikonApp.orderBagItemOption.price\">Price</span></dt><dd><span>{{vm.orderBagItemOption.price}}</span></dd><dt><span translate=\"tikonApp.orderBagItemOption.discount\">Discount</span></dt><dd><span>{{vm.orderBagItemOption.discount}}</span></dd><dt><span translate=\"tikonApp.orderBagItemOption.vat\">Vat</span></dt><dd><span>{{vm.orderBagItemOption.vat}}</span></dd><dt><span translate=\"tikonApp.orderBagItemOption.totalPrice\">Total Price</span></dt><dd><span>{{vm.orderBagItemOption.totalPrice}}</span></dd><dt><span translate=\"tikonApp.orderBagItemOption.orderbagItemDtail\">Orderbag Item Dtail</span></dt><dd><a ui-sref=\"order-bag-service-item-dtail-detail({id:vm.orderBagItemOption.orderbagItemDtailId})\">{{vm.orderBagItemOption.orderbagItemDtailId}}</a></dd><dt><span translate=\"tikonApp.orderBagItemOption.orderbagItem\">Orderbag Item</span></dt><dd><a ui-sref=\"service-option-item-detail({id:vm.orderBagItemOption.orderbagItemId})\">{{vm.orderBagItemOption.orderbagItemId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/order-bag-item-option/order-bag-item-option-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderBagItemOptionLabel\" translate=\"tikonApp.orderBagItemOption.home.createOrEditLabel\">Create or edit a Order Bag Item Option</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.orderBagItemOption.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.orderBagItemOption.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagItemOption.reserveTime\" for=\"field_reserveTime\">Reserve Time</label><div class=\"input-group\"><input id=\"field_reserveTime\" type=\"text\" class=\"form-control\" name=\"reserveTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.orderBagItemOption.reserveTime\" is-open=\"vm.datePickerOpenStatus.reserveTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'reserveTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagItemOption.qty\" for=\"field_qty\">Qty</label><input type=\"number\" class=\"form-control\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.orderBagItemOption.qty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagItemOption.price\" for=\"field_price\">Price</label><input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"vm.orderBagItemOption.price\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagItemOption.discount\" for=\"field_discount\">Discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.orderBagItemOption.discount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagItemOption.vat\" for=\"field_vat\">Vat</label><input type=\"number\" class=\"form-control\" name=\"vat\" id=\"field_vat\" ng-model=\"vm.orderBagItemOption.vat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagItemOption.totalPrice\" for=\"field_totalPrice\">Total Price</label><input type=\"number\" class=\"form-control\" name=\"totalPrice\" id=\"field_totalPrice\" ng-model=\"vm.orderBagItemOption.totalPrice\"></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagItemOption.orderbagItemDtail\" for=\"field_orderbagItemDtail\">Orderbag Item Dtail</label><select class=\"form-control\" id=\"field_orderbagItemDtail\" name=\"orderbagItemDtail\" ng-model=\"vm.orderBagItemOption.orderbagItemDtailId\" ng-options=\"orderBagServiceItemDtail.id as orderBagServiceItemDtail.id for orderBagServiceItemDtail in vm.orderbagserviceitemdtails\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagItemOption.orderbagItem\" for=\"field_orderbagItem\">Orderbag Item</label><select class=\"form-control\" id=\"field_orderbagItem\" name=\"orderbagItem\" ng-model=\"vm.orderBagItemOption.orderbagItemId\" ng-options=\"serviceOptionItem.id as serviceOptionItem.id for serviceOptionItem in vm.serviceoptionitems\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-bag-item-option/order-bag-item-options.html","<div><h2 translate=\"tikonApp.orderBagItemOption.home.title\">Order Bag Item Options</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"order-bag-item-option.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBagItemOption.home.createLabel\">Create new Order Bag Item Option</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.orderBagItemOption.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reserveTime\"><span translate=\"tikonApp.orderBagItemOption.reserveTime\">Reserve Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"qty\"><span translate=\"tikonApp.orderBagItemOption.qty\">Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"price\"><span translate=\"tikonApp.orderBagItemOption.price\">Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discount\"><span translate=\"tikonApp.orderBagItemOption.discount\">Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vat\"><span translate=\"tikonApp.orderBagItemOption.vat\">Vat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalPrice\"><span translate=\"tikonApp.orderBagItemOption.totalPrice\">Total Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderbagItemDtailId\"><span translate=\"tikonApp.orderBagItemOption.orderbagItemDtail\">Orderbag Item Dtail</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderbagItemId\"><span translate=\"tikonApp.orderBagItemOption.orderbagItem\">Orderbag Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagItemOption in vm.orderBagItemOptions track by orderBagItemOption.id\"><td><a ui-sref=\"order-bag-item-option-detail({id:orderBagItemOption.id})\">{{orderBagItemOption.id}}</a></td><td>{{orderBagItemOption.reserveTime | date:\'medium\'}}</td><td>{{orderBagItemOption.qty}}</td><td>{{orderBagItemOption.price}}</td><td>{{orderBagItemOption.discount}}</td><td>{{orderBagItemOption.vat}}</td><td>{{orderBagItemOption.totalPrice}}</td><td><a ui-sref=\"order-bag-service-item-dtail-detail({id:orderBagItemOption.orderbagItemDtailId})\">{{orderBagItemOption.orderbagItemDtailId}}</a></td><td><a ui-sref=\"service-option-item-detail({id:orderBagItemOption.orderbagItemId})\">{{orderBagItemOption.orderbagItemId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"order-bag-item-option-detail({id:orderBagItemOption.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-item-option.edit({id:orderBagItemOption.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-item-option.delete({id:orderBagItemOption.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/order-bag-service-item/order-bag-service-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.orderBagServiceItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.orderBagServiceItem.delete.question\" translate-values=\"{id: \'{{vm.orderBagServiceItem.id}}\'}\">Are you sure you want to delete this Order Bag Service Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/order-bag-service-item/order-bag-service-item-detail.html","<div><h2><span translate=\"tikonApp.orderBagServiceItem.detail.title\">Order Bag Service Item</span> {{vm.orderBagServiceItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.orderBagServiceItem.status\">Status</span></dt><dd><span>{{vm.orderBagServiceItem.status}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\">Subtotal Service Price</span></dt><dd><span>{{vm.orderBagServiceItem.subtotalServicePrice}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\">Subtotal Option Price</span></dt><dd><span>{{vm.orderBagServiceItem.subtotalOptionPrice}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\">Subtotal VAT</span></dt><dd><span>{{vm.orderBagServiceItem.subtotalVAT}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\">Subtotal Discount</span></dt><dd><span>{{vm.orderBagServiceItem.subtotalDiscount}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\">Total Row Price</span></dt><dd><span>{{vm.orderBagServiceItem.totalRowPrice}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItem.orderBag\">Order Bag</span></dt><dd><a ui-sref=\"order-bag-detail({id:vm.orderBagServiceItem.orderBagId})\">{{vm.orderBagServiceItem.orderBagId}}</a></dd><dt><span translate=\"tikonApp.orderBagServiceItem.serviceItem\">Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.orderBagServiceItem.serviceItemId})\">{{vm.orderBagServiceItem.serviceItemId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/order-bag-service-item/order-bag-service-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderBagServiceItemLabel\" translate=\"tikonApp.orderBagServiceItem.home.createOrEditLabel\">Create or edit a Order Bag Service Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.orderBagServiceItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.orderBagServiceItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.status\" for=\"field_status\">Status</label><input type=\"number\" class=\"form-control\" name=\"status\" id=\"field_status\" ng-model=\"vm.orderBagServiceItem.status\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\" for=\"field_subtotalServicePrice\">Subtotal Service Price</label><input type=\"number\" class=\"form-control\" name=\"subtotalServicePrice\" id=\"field_subtotalServicePrice\" ng-model=\"vm.orderBagServiceItem.subtotalServicePrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\" for=\"field_subtotalOptionPrice\">Subtotal Option Price</label><input type=\"number\" class=\"form-control\" name=\"subtotalOptionPrice\" id=\"field_subtotalOptionPrice\" ng-model=\"vm.orderBagServiceItem.subtotalOptionPrice\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalVAT\" for=\"field_subtotalVAT\">Subtotal VAT</label><input type=\"number\" class=\"form-control\" name=\"subtotalVAT\" id=\"field_subtotalVAT\" ng-model=\"vm.orderBagServiceItem.subtotalVAT\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\" for=\"field_subtotalDiscount\">Subtotal Discount</label><input type=\"number\" class=\"form-control\" name=\"subtotalDiscount\" id=\"field_subtotalDiscount\" ng-model=\"vm.orderBagServiceItem.subtotalDiscount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.totalRowPrice\" for=\"field_totalRowPrice\">Total Row Price</label><input type=\"number\" class=\"form-control\" name=\"totalRowPrice\" id=\"field_totalRowPrice\" ng-model=\"vm.orderBagServiceItem.totalRowPrice\"></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.orderBag\" for=\"field_orderBag\">Order Bag</label><select class=\"form-control\" id=\"field_orderBag\" name=\"orderBag\" ng-model=\"vm.orderBagServiceItem.orderBagId\" ng-options=\"orderBag.id as orderBag.id for orderBag in vm.orderbags\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.serviceItem\" for=\"field_serviceItem\">Service Item</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.orderBagServiceItem.serviceItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-bag-service-item/order-bag-service-item-list.html","<div><h2 translate=\"tikonApp.orderBagServiceItem.home.title\">Order Bag Service Items</h2><jhi-alert></jhi-alert><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-xs-4 no-padding-left\">&ndash;&gt;--><!--&lt;!&ndash;<button class=\"btn btn-primary\" ui-sref=\"order-bag-service-item.new\" >&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs\"  translate=\"tikonApp.orderBagServiceItem.home.createLabel\">&ndash;&gt;--><!--&lt;!&ndash;Create new Order Bag Service Item&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<div class=\"col-xs-8 no-padding-right\">--><!--<form name=\"searchForm\" class=\"form-inline\">--><!--<div class=\"input-group pull-right\" >--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.orderBagServiceItem.home.search\' | translate }}\">--><!--<span  class=\"input-group-btn width-min\" >--><!--<button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</button>--><!--</span>--><!--<span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\">--><!--<button class=\"btn btn-info\" ng-click=\"vm.clear()\">--><!--<span class=\"glyphicon glyphicon-trash\"></span>--><!--</button>--><!--</span>--><!--</div>--><!--</form>--><!--</div>--><!--</div>--><!--</div>--><div data-ng-show=\"vm.formState ==\'noitem\'\">there is no row in orderbag!</div><br><div class=\"table-responsive\" data-ng-show=\"vm.formState == \'active\'\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dtails\"><span translate=\"tikonApp.orderBagServiceItem.status\">Dtails</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.orderBagServiceItem.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalServicePrice\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\">Subtotal Service Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalOptionPrice\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\">Subtotal Option Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalVAT\"><span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\">Subtotal VAT</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalDiscount\"><span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\">Subtotal Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalRowPrice\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\">Total Row Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"orderBagId\"><span translate=\"tikonApp.orderBagServiceItem.orderBag\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"serviceItemId\"><span translate=\"tikonApp.orderBagServiceItem.serviceItem\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in vm.orderBagServiceItems track by orderBagServiceItem.id\"><td><a ui-sref=\"supplierPanel.orderBagTest.edit({id:orderBagServiceItem.id})\">{{orderBagServiceItem.id}}</a></td><td><ul><li ng-repeat=\"orderBagServiceItemDtail in orderBagServiceItem.orderBagServiceItemDtail track by orderBagServiceItemDtail.id\"><ul><li>{{orderBagServiceItemDtail.priceInfoDtail.title}}</li><li>{{orderBagServiceItemDtail.gty}}</li><!--{{orderBagServiceItemDtail.orderBagItemOptions}}--><ul><li ng-repeat=\"orderBagItemOption in orderBagServiceItemDtail.orderBagItemOptions track by orderBagItemOption.id\">{{orderBagItemOption.serviceOptionItem.optionName}}</li></ul></ul></li></ul></td><td>{{orderBagServiceItem.status}}</td><td>{{orderBagServiceItem.subtotalServicePrice}}</td><td>{{orderBagServiceItem.subtotalOptionPrice}}</td><td>{{orderBagServiceItem.subtotalVAT}}</td><td>{{orderBagServiceItem.subtotalDiscount}}</td><td>{{orderBagServiceItem.totalRowPrice}}</td><!--<td>--><!--<a ui-sref=\"order-bag-detail({id:orderBagServiceItem.orderBagId})\">{{orderBagServiceItem.orderBagId}}</a>--><!--</td>--><td><a ui-sref=\"service-item-detail({id:orderBagServiceItem.serviceItemId})\">{{orderBagServiceItem.serviceItemId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item-detail({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>--> <button type=\"submit\" ui-sref=\"supplierPanel.orderBagTest.edit({id:orderBagServiceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--><div class=\"panel panel-info\" data-ng-show=\"vm.formState == \'active\' ||vm.formState == \'confirmed\' \"><div class=\"panel-heading\">Price Summary</div><div class=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.totalServicePrice\" for=\"field_totalServicePrice\">TotalServicePrice</label>{{vm.orderBagFinalPrice.totalServicePrice}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.totalOptionPrice\" for=\"field_totalOptionPrice\">totalOptionPrice</label>{{vm.orderBagFinalPrice.totalOptionPrice}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.totalDiscount\" for=\"field_totalOptionPrice\">totalDiscount</label>{{vm.orderBagFinalPrice.totalDiscount}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.totalVat\" for=\"field_totalVat\">totalDiscount</label>{{vm.orderBagFinalPrice.totalVat}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.finalPrice\" for=\"field_finalPrice\">finalPrice</label>{{vm.orderBagFinalPrice.finalPrice}}</div></div></div><div><button data-ng-show=\"vm.formState==\'active\'\" ng-click=\"vm.approve()\" class=\"btn btn-primary btn-sm\"><span translate=\"tikonApp.orderBag.approve\"></span></button></div></div>");
$templateCache.put("app/entities/order-bag-service-item/order-bag-service-item-test.html","<!--<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\">--><div><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBagServiceItem.serviceItem\" for=\"field_serviceItem\">Service Item</label>--><!--<select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\"--><!--ng-model=\"vm.orderBagServiceItem.serviceItemId\"--><!--ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\">--><!--<option value=\"\"></option>--><!--</select>--><!--</div>--><div><pf-order-bag-service-item service-item-id=\"vm.serviceItemId\" order-bag-service-item=\"vm.orderBagServiceItem\" selected-service-time-session=\"vm.selectedServiceTimeSession\"></pf-order-bag-service-item></div><!--<div>--><!--{{vm.orderBagServiceItem}}--><!--</div>--></div><!--</form>-->");
$templateCache.put("app/entities/order-bag-service-item/order-bag-service-items.html","<div><h2 translate=\"tikonApp.orderBagServiceItem.home.title\">Order Bag Service Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"order-bag-service-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBagServiceItem.home.createLabel\">Create new Order Bag Service Item</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.orderBagServiceItem.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.orderBagServiceItem.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalServicePrice\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\">Subtotal Service Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalOptionPrice\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\">Subtotal Option Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalVAT\"><span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\">Subtotal VAT</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subtotalDiscount\"><span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\">Subtotal Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalRowPrice\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\">Total Row Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderBagId\"><span translate=\"tikonApp.orderBagServiceItem.orderBag\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceItemId\"><span translate=\"tikonApp.orderBagServiceItem.serviceItem\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in vm.orderBagServiceItems track by orderBagServiceItem.id\"><td><a ui-sref=\"order-bag-service-item-detail({id:orderBagServiceItem.id})\">{{orderBagServiceItem.id}}</a></td><td>{{orderBagServiceItem.status}}</td><td>{{orderBagServiceItem.subtotalServicePrice}}</td><td>{{orderBagServiceItem.subtotalOptionPrice}}</td><td>{{orderBagServiceItem.subtotalVAT}}</td><td>{{orderBagServiceItem.subtotalDiscount}}</td><td>{{orderBagServiceItem.totalRowPrice}}</td><td><a ui-sref=\"order-bag-detail({id:orderBagServiceItem.orderBagId})\">{{orderBagServiceItem.orderBagId}}</a></td><td><a ui-sref=\"service-item-detail({id:orderBagServiceItem.serviceItemId})\">{{orderBagServiceItem.serviceItemId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"order-bag-service-item-detail({id:orderBagServiceItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-service-item.edit({id:orderBagServiceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/order-bag-service-item/replace-time-order-bag-service-item-dialog-v2.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderBagServiceItemLabel\" translate=\"tikonApp.orderBag.replaceTime\">Replace Time</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"tikonApp.orderBag.currentTime\">Current Time</label><div><i class=\"fa fa-calendar\"></i> {{vm.currentTime | toPersianDate}} <i class=\"fa fa-clock-o\"></i> {{vm.currentTime | toPersianTime}}</div></div><div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableDates\">AvailableDates</label><select class=\"form-control\" id=\"field_availableDates\" ng-change=\"vm.availableDates_changed()\" name=\"availableDates\" ng-model=\"vm.selectedDate\" ng-options=\"dates.date as dates.date | toPersianDate   for dates in vm.availableDates\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectTime\" for=\"field_availableTimes\">AvailableTimes</label><select class=\"form-control\" id=\"field_availableTimes\" ng-change=\"vm.availableTimes_changed()\" name=\"availableTimes\" ng-model=\"vm.selectedTimeSessionId\" ng-options=\"serviceTimeSession.id as serviceTimeSession.startTime | toPersianTime for serviceTimeSession in vm.availableTimes\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-bag-service-item/replace-time-order-bag-service-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderBagServiceItemLabel\" translate=\"tikonApp.orderBag.replaceTime\">Replace Time</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"tikonApp.orderBag.currentTime\">Current Time</label><div><i class=\"fa fa-calendar\"></i> {{vm.currentTime | toPersianDate}} <i class=\"fa fa-clock-o\"></i> {{vm.currentTime | toPersianTime}}</div></div><div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableDates\">AvailableDates</label><select class=\"form-control\" id=\"field_availableDates\" ng-change=\"vm.availableDates_changed()\" name=\"availableDates\" ng-model=\"vm.selectedDate\" ng-options=\"dates.date as dates.date | toPersianDate   for dates in vm.availableDates\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectTime\" for=\"field_availableTimes\">AvailableTimes</label><select class=\"form-control\" id=\"field_availableTimes\" ng-change=\"vm.availableTimes_changed()\" name=\"availableTimes\" ng-model=\"vm.selectedTimeSessionId\" ng-options=\"serviceTimeSession.id as serviceTimeSession.startTime | toPersianTime for serviceTimeSession in vm.availableTimes\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.orderBagServiceItemDtail.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.orderBagServiceItemDtail.delete.question\" translate-values=\"{id: \'{{vm.orderBagServiceItemDtail.id}}\'}\">Are you sure you want to delete this Order Bag Service Item Dtail?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-detail.html","<div><h2><span translate=\"tikonApp.orderBagServiceItemDtail.detail.title\">Order Bag Service Item Dtail</span> {{vm.orderBagServiceItemDtail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.orderBagServiceItemDtail.reserveTime\">Reserve Time</span></dt><dd><span>{{vm.orderBagServiceItemDtail.reserveTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.gty\">Gty</span></dt><dd><span>{{vm.orderBagServiceItemDtail.gty}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.price\">Price</span></dt><dd><span>{{vm.orderBagServiceItemDtail.price}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.discount\">Discount</span></dt><dd><span>{{vm.orderBagServiceItemDtail.discount}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.vat\">Vat</span></dt><dd><span>{{vm.orderBagServiceItemDtail.vat}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrice\">Total Price</span></dt><dd><span>{{vm.orderBagServiceItemDtail.totalPrice}}</span></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.orderBagItem\">Order Bag Item</span></dt><dd><a ui-sref=\"order-bag-service-item-detail({id:vm.orderBagServiceItemDtail.orderBagItemId})\">{{vm.orderBagServiceItemDtail.orderBagItemId}}</a></dd><dt><span translate=\"tikonApp.orderBagServiceItemDtail.priceInfoDtail\">Price Info Dtail</span></dt><dd><a ui-sref=\"price-info-dtail-detail({id:vm.orderBagServiceItemDtail.priceInfoDtailId})\">{{vm.orderBagServiceItemDtail.priceInfoDtailId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/order-bag-service-item-dtail/order-bag-service-item-dtail-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderBagServiceItemDtailLabel\" translate=\"tikonApp.orderBagServiceItemDtail.home.createOrEditLabel\">Create or edit a Order Bag Service Item Dtail</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.orderBagServiceItemDtail.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.orderBagServiceItemDtail.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.reserveTime\" for=\"field_reserveTime\">Reserve Time</label><div class=\"input-group\"><input id=\"field_reserveTime\" type=\"text\" class=\"form-control\" name=\"reserveTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.orderBagServiceItemDtail.reserveTime\" is-open=\"vm.datePickerOpenStatus.reserveTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'reserveTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.gty\" for=\"field_gty\">Gty</label><input type=\"number\" class=\"form-control\" name=\"gty\" id=\"field_gty\" ng-model=\"vm.orderBagServiceItemDtail.gty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.price\" for=\"field_price\">Price</label><input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"vm.orderBagServiceItemDtail.price\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.discount\" for=\"field_discount\">Discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.orderBagServiceItemDtail.discount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.vat\" for=\"field_vat\">Vat</label><input type=\"number\" class=\"form-control\" name=\"vat\" id=\"field_vat\" ng-model=\"vm.orderBagServiceItemDtail.vat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.totalPrice\" for=\"field_totalPrice\">Total Price</label><input type=\"number\" class=\"form-control\" name=\"totalPrice\" id=\"field_totalPrice\" ng-model=\"vm.orderBagServiceItemDtail.totalPrice\"></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItemDtail.orderBagItem\" for=\"field_orderBagItem\">Order Bag Item</label><select class=\"form-control\" id=\"field_orderBagItem\" name=\"orderBagItem\" ng-model=\"vm.orderBagServiceItemDtail.orderBagItemId\" ng-options=\"orderBagServiceItem.id as orderBagServiceItem.id for orderBagServiceItem in vm.orderbagserviceitems\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItemDtail.priceInfoDtail\" for=\"field_priceInfoDtail\">Price Info Dtail</label><select class=\"form-control\" id=\"field_priceInfoDtail\" name=\"priceInfoDtail\" ng-model=\"vm.orderBagServiceItemDtail.priceInfoDtailId\" ng-options=\"priceInfoDtail.id as priceInfoDtail.id for priceInfoDtail in vm.priceinfodtails\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-bag-service-item-dtail/order-bag-service-item-dtails.html","<div><h2 translate=\"tikonApp.orderBagServiceItemDtail.home.title\">Order Bag Service Item Dtails</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"order-bag-service-item-dtail.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBagServiceItemDtail.home.createLabel\">Create new Order Bag Service Item Dtail</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.orderBagServiceItemDtail.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reserveTime\"><span translate=\"tikonApp.orderBagServiceItemDtail.reserveTime\">Reserve Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"gty\"><span translate=\"tikonApp.orderBagServiceItemDtail.gty\">Gty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"price\"><span translate=\"tikonApp.orderBagServiceItemDtail.price\">Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discount\"><span translate=\"tikonApp.orderBagServiceItemDtail.discount\">Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vat\"><span translate=\"tikonApp.orderBagServiceItemDtail.vat\">Vat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalPrice\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrice\">Total Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderBagItemId\"><span translate=\"tikonApp.orderBagServiceItemDtail.orderBagItem\">Order Bag Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"priceInfoDtailId\"><span translate=\"tikonApp.orderBagServiceItemDtail.priceInfoDtail\">Price Info Dtail</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItemDtail in vm.orderBagServiceItemDtails track by orderBagServiceItemDtail.id\"><td><a ui-sref=\"order-bag-service-item-dtail-detail({id:orderBagServiceItemDtail.id})\">{{orderBagServiceItemDtail.id}}</a></td><td>{{orderBagServiceItemDtail.reserveTime | date:\'medium\'}}</td><td>{{orderBagServiceItemDtail.gty}}</td><td>{{orderBagServiceItemDtail.price}}</td><td>{{orderBagServiceItemDtail.discount}}</td><td>{{orderBagServiceItemDtail.vat}}</td><td>{{orderBagServiceItemDtail.totalPrice}}</td><td><a ui-sref=\"order-bag-service-item-detail({id:orderBagServiceItemDtail.orderBagItemId})\">{{orderBagServiceItemDtail.orderBagItemId}}</a></td><td><a ui-sref=\"price-info-dtail-detail({id:orderBagServiceItemDtail.priceInfoDtailId})\">{{orderBagServiceItemDtail.priceInfoDtailId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"order-bag-service-item-dtail-detail({id:orderBagServiceItemDtail.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-service-item-dtail.edit({id:orderBagServiceItemDtail.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order-bag-service-item-dtail.delete({id:orderBagServiceItemDtail.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/package-feature-list/package-feature-list-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.packageFeatureList.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.packageFeatureList.delete.question\" translate-values=\"{id: \'{{vm.packageFeatureList.id}}\'}\">Are you sure you want to delete this Package Feature List?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/package-feature-list/package-feature-list-detail.html","<div><h2><span translate=\"tikonApp.packageFeatureList.detail.title\">Package Feature List</span> {{vm.packageFeatureList.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.packageFeatureList.sendingSMS\">Sending SMS</span></dt><dd><span translate=\"{{\'tikonApp.FeatureStatus.\' + vm.packageFeatureList.sendingSMS}}\">{{vm.packageFeatureList.sendingSMS}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/package-feature-list/package-feature-list-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPackageFeatureListLabel\" translate=\"tikonApp.packageFeatureList.home.createOrEditLabel\">Create or edit a Package Feature List</h4><span class=\"form-group\" ng-show=\"vm.packageFeatureList.id\"><label translate=\"global.field.id\">ID</label>{{vm.packageFeatureList.id}}</span></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\" ng-show=\"!vm.packageFeatureList.companyId\"><div class=\"form-group col-md-5\"><label class=\"control-label\" translate=\"tikonApp.packageFeatureList.company.keyUrl\" for=\"field_keyUrl\">Key Url</label><input type=\"text\" class=\"form-control\" name=\"keyUrl\" id=\"field_keyUrl\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"form-group col-md-3\" ng-show=\"!vm.packageFeatureList.companyId\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.searchCompany()\"><span class=\"glyphicon glyphicon-search\"></span> &nbsp; <span translate=\"tikonApp.packageFeatureList.company.search\">Search Company</span></button></div><div class=\"form-group col-md-4\" ng-show=\"vm.company.title\">{{vm.company.title}}</div></div><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\" translate=\"tikonApp.packageFeatureList.featureInfo.servantCount\" for=\"field_servantCount\">servantCount</label><input type=\"text\" class=\"form-control\" name=\"servantCount\" id=\"field_servantCount\" ng-model=\"vm.packageFeatureList.featureInfoObject.servantCount\"></div><div class=\"col-md-3\"><label class=\"control-label\" translate=\"tikonApp.packageFeatureList.featureInfo.specialFeatureCount\" for=\"field_specialFeatureCount\">specialFeatureCount</label><input type=\"text\" class=\"form-control\" name=\"specialFeatureCount\" id=\"field_specialFeatureCount\" ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureCount\"></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.twoStepVerification\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.twoStepVerification\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.dedicateDomain\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.dedicateDomain\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_SMS\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.satisfactionMessage_SMS\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.satisfactionMessage_Email\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.satisfactionMessage_Email\' | translate}}</md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.widget\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.widget\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.cancelReserveByCustomer\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.cancelReserveByCustomer\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.autoMultiReserveMode\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.autoMultiReserveMode\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.reservePattern\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.reservePattern\' | translate}}</md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.couponCode\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.couponCode\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerGroup\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.customerGroup\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerAccess\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.customerAccess\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customPricingForServant\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.customPricingForServant\' | translate}}</md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.servantLogin\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.servantLogin\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.intakeForm\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.intakeForm\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.serviceWithoutServant\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.serviceWithoutServant\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.recordOnlineMeeting\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.recordOnlineMeeting\' | translate}}</md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.reserveLimit\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.reserveLimit\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.smsTextEdit\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.smsTextEdit\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerRebookReminder_SMS\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.customerRebookReminder_SMS\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.customerSecondReminder\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.customerSecondReminder\' | translate}}</md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.advancedPricing\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.advancedPricing\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.whatsAppSupport\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.whatsAppSupport\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.servantServiceScheduling\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.servantServiceScheduling\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.serviceCapacity\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.serviceCapacity\' | translate}}</md-checkbox></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.invoice\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.invoice\' | translate}}</md-checkbox></div></div><div class=\"col-md-3\"><div class=\"form-group\"><md-checkbox ng-model=\"vm.packageFeatureList.featureInfoObject.specialFeatureInfo.marketingCampaign\">{{\'tikonApp.packageFeatureList.specialFeatureInfo.marketingCampaign\' | translate}}</md-checkbox></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/package-feature-list/package-feature-lists.html","<div><h2 translate=\"tikonApp.packageFeatureList.home.title\">Package Feature Lists</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-2 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"package-feature-list.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.packageFeatureList.home.createLabel\">Create new Package Feature List</span></button></div><div class=\"col-xs-5 no-padding-right\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.packageFeatureList.company.keyUrl\" for=\"field_keyUrl\">Key Url</label><input type=\"text\" class=\"form-control\" name=\"keyUrl\" id=\"field_keyUrl\" ng-model=\"vm.companyKeyUrl\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.searchCompany()\"><span class=\"glyphicon glyphicon-search\"></span> &nbsp; <span translate=\"tikonApp.packageFeatureList.company.search\">Search Company</span></button><div class=\"form-group\" ng-show=\"vm.company.title\">{{vm.company.title}}</div></div></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>Company Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span>KeyUrl</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sendingSMS\"><span translate=\"tikonApp.packageFeatureList.sendingSMS\">Sending SMS</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"packageFeatureList in vm.packageFeatureLists track by packageFeatureList.id\"><td><a ui-sref=\"package-feature-list-detail({id:packageFeatureList.id})\">{{packageFeatureList.id}}</a></td><td>{{packageFeatureList.company.title}}</td><td>{{packageFeatureList.company.keyUrl}}</td><td translate=\"{{\'tikonApp.FeatureStatus.\' + packageFeatureList.sendingSMS}}\">{{packageFeatureList.sendingSMS}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"package-feature-list-detail({id:packageFeatureList.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"package-feature-list.edit({id:packageFeatureList.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"package-feature-list.delete({id:packageFeatureList.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/participant-person/order-bag-item-participant-person-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myParticipantPersonLabel\" translate=\"tikonApp.participantPerson.home.createOrEditLabel\">Create or edit a Participant Person</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div id=\"basicInfo\" class=\"tab-pane fade in active\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.participantPerson.personInfo.fisrtName\" required eo-required=\"\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.participantPerson.personInfo.lastName\" required eo-required=\"\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.gender.title\">Gender</label><input type=\"radio\" name=\"gender_male\" id=\"field_genderMale\" ng-model=\"vm.participantPerson.personInfo.gender\" ng-value=\"true\"> <span translate=\"tikonApp.personInfo.gender.male\">Male</span><input type=\"radio\" name=\"gender_female\" id=\"field_genderFemale\" ng-model=\"vm.participantPerson.personInfo.gender\" ng-value=\"false\"> <span translate=\"tikonApp.personInfo.gender.female\">Female</span></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label>--><!--<input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\"--><!--ng-model=\"$ctrl.personInfo.phoneNumber\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.nationalCode\" for=\"field_nationalCode\">National Code</label>--><!--<input type=\"text\" class=\"form-control\" name=\"nationalCode\" id=\"field_nationalCode\"--><!--ng-model=\"$ctrl.personInfo.nationalCode\"--><!--/>--><!--</div>--><!--<div class=\"form-group\" >--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\" for=\"field_birthDate\">Birth Date</label>--><!--<eo-date-picker id=\"field_birthDate\"  date-value=\"$ctrl.personInfo.birthDate\" > </eo-date-picker>--><!--</div>--></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/participant-person/participant-people.html","<div><h2 translate=\"tikonApp.participantPerson.home.title\">Participant People</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"participant-person.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.participantPerson.home.createLabel\">Create new Participant Person</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.participantPerson.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personInfoId\"><span translate=\"tikonApp.participantPerson.personInfo\">Person Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderBagItemDtailId\"><span translate=\"tikonApp.participantPerson.orderBagItemDtail\">Order Bag Item Dtail</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"participantPerson in vm.participantPeople track by participantPerson.id\"><td><a ui-sref=\"participant-person-detail({id:participantPerson.id})\">{{participantPerson.id}}</a></td><td><a ui-sref=\"person-info-detail({id:participantPerson.personInfoId})\">{{participantPerson.personInfoId}}</a></td><td><a ui-sref=\"order-bag-service-item-dtail-detail({id:participantPerson.orderBagItemDtailId})\">{{participantPerson.orderBagItemDtailId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"participant-person-detail({id:participantPerson.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"participant-person.edit({id:participantPerson.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"participant-person.delete({id:participantPerson.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/participant-person/participant-person-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.participantPerson.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.participantPerson.delete.question\" translate-values=\"{id: \'{{vm.participantPerson.id}}\'}\">Are you sure you want to delete this Participant Person?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/participant-person/participant-person-detail.html","<div><h2><span translate=\"tikonApp.participantPerson.detail.title\">Participant Person</span> {{vm.participantPerson.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.participantPerson.personInfo\">Person Info</span></dt><dd><a ui-sref=\"person-info-detail({id:vm.participantPerson.personInfoId})\">{{vm.participantPerson.personInfoId}}</a></dd><dt><span translate=\"tikonApp.participantPerson.orderBagItemDtail\">Order Bag Item Dtail</span></dt><dd><a ui-sref=\"order-bag-service-item-dtail-detail({id:vm.participantPerson.orderBagItemDtailId})\">{{vm.participantPerson.orderBagItemDtailId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/participant-person/participant-person-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myParticipantPersonLabel\" translate=\"tikonApp.participantPerson.home.createOrEditLabel\">Create or edit a Participant Person</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.participantPerson.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.participantPerson.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"tikonApp.participantPerson.personInfo\" for=\"field_personInfo\">Person Info</label><select class=\"form-control\" id=\"field_personInfo\" name=\"personInfo\" ng-model=\"vm.participantPerson.personInfoId\" ng-options=\"personInfo.id as personInfo.id for personInfo in vm.personinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.participantPerson.orderBagItemDtail\" for=\"field_orderBagItemDtail\">Order Bag Item Dtail</label><select class=\"form-control\" id=\"field_orderBagItemDtail\" name=\"orderBagItemDtail\" ng-model=\"vm.participantPerson.orderBagItemDtailId\" ng-options=\"orderBagServiceItemDtail.id as orderBagServiceItemDtail.id for orderBagServiceItemDtail in vm.orderbagserviceitemdtails\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/pattern-info/pattern-info-list.html","<div class=\"container-fluid\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.patternInfo.home.title\">tikonApp.patternInfo.home.title</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary\" ng-click=\"vm.newPatternClick()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.patternInfo.home.new\">Create new patternInfo</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><jhi-alert></jhi-alert><md-content class=\"rwMdContent\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.patterns\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><div class=\"col-sm-6 col-xs-6\"><div class=\"form-group\"><!--<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>--> <input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'tikonApp.patternInfo.home.search\' | translate }}\" type=\"text\"></div></div><div class=\"col-sm-6\"><md-button id=\"search-btn\" class=\"search-btn md-raised md-secondary\" ng-click=\"vm.search()\" style=\"margin-top: 0px; margin-right: -10px\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div></div></th></tr><tr><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th st-sort=\"id\"><span--><!--translate=\"tikonApp.patternInfo.id\">id</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"title\"><span translate=\"tikonApp.patternInfo.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"amountType\"><span--><!--translate=\"tikonApp.coupon.amountType\">amountType</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"description\"><span translate=\"tikonApp.patternInfo.servantName\">servantName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"description\" class=\"hidden-xs\"><span translate=\"tikonApp.patternInfo.patternDate\">patternDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.patternInfo.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"patternInfo in collection track by patternInfo.id\"><!--<td><a ui-sref=\"supplierPanel.editPatternInfo({id:patternInfo.id})\">{{patternInfo.id}}</a></td>--><td><a ui-sref=\"supplierPanel.editPatternInfo({id:patternInfo.id})\">{{patternInfo.title}}</a></td><td>{{patternInfo.servant.servantName}}</td><td class=\"hidden-xs\">{{patternInfo.patternDate | toPersianDate}}</td><td><span translate=\"{{\'tikonApp.patternStatus.\' + patternInfo.status}}\">{{patternInfo.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editPatternInfo({id:patternInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.deletePatternInfo({id:patternInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></md-content></div></div></div><!--<div class=\"visible-xs \">--><!--<div class=\"\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-8\">--><!--<h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.companyCustomer.home.title\">--><!--tikonApp.companyCustomer.home.title--><!--</h3>--><!--</div>--><!--<div class=\"col-xs-3\" style=\"margin-right: -7px\">--><!--<md-button class=\"md-raised md-primary\" ui-sref=\"company-customer.new\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!--</md-button>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"\">--><!--<div class=\"\">--><!--<jhi-alert></jhi-alert>--><!--<div class=\"row\" style=\"padding-right: 8px\">--><!--<div class=\"form-group\">--><!--&lt;!&ndash;<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>&ndash;&gt;--><!--<div class=\"col-xs-10\">--><!--<input class=\"form-control rwTableSearchBox\"--><!--ng-model=\"vm.searchQuery\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><!--</div>--><!--<div class=\"col-xs-2\" style=\"margin-right: -30px;margin-top: -7px;\">--><!--<md-button id=\"search-btn-xs\" class=\"search-btn md-raised md-secondary\"--><!--ng-click=\"vm.search()\"--><!--&gt;--><!--<i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative;\">--><!--search--><!--</i>--><!--</md-button>--><!--</div>--><!--</div>--><!--</div>--><!--<div ng-repeat=\"companyCustomer in vm.companyCustomers track by companyCustomer.id\"--><!--class=\"orderBag-mobile-block\">--><!--&lt;!&ndash;<td>{{companyCustomer.customer.id }} </td>&ndash;&gt;--><!--<div>--><!--<div ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"row\">--><!--<div class=\"orderBag-mobile-float\">--><!--<i class=\"glyphicon glyphicon-user\"></i>--><!--{{companyCustomer.customer.personalInfo.fisrtName}}--><!--{{companyCustomer.customer.personalInfo.lastName}}--><!--</div>--><!--</div>--><!--<div class=\"row\" ng-if=\"companyCustomer.customer.personalInfo.email!=null\"--><!--style=\"padding-right: 8px\">--><!--<i class=\"glyphicon glyphicon-envelope\"></i>--><!--{{companyCustomer.customer.personalInfo.email}}--><!--</div>--><!--<div>--><!--<div class=\"orderBag-mobile-float companyCustomer-make-call\">--><!--<i class=\"fa fa-phone\"></i>--><!--<a href=\"tel:{{companyCustomer.customer.personalInfo.phoneNumber}}\">{{companyCustomer.customer.personalInfo.phoneNumber}}</a>--><!--&lt;!&ndash;{{companyCustomer.customer.personalInfo.phoneNumber}}&ndash;&gt;--><!--</div>--><!--<div style=\"text-align: left\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.edit({id:companyCustomer.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"vm.gotoNewReserve(companyCustomer.customer.id)\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-primary btn-sm\" style=\"background-color: rgb(96,125,139)\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"tikonApp.companyCustomer.newReserveForCustomer\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--<button type=\"button\"--><!--ui-sref=\"supplierPanel.deleteCompanyCustomer({id:companyCustomer.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"></ul>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/pattern-info/pattern-info.html","<style>.patternItem {\n        border: 1px solid #80808078;\n        border-radius: 5px;\n        padding: 5px;\n        color: white;\n    }\n\n    .pattern-row {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n    }\n\n    .pattern-item-box {\n        margin-top: 10px;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.patternInfo.home.createOrEditLabel\" style=\"display: inline-block\">tikonApp.patternInfo.home.createOrEditLabel </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.patternInfo.id != null\">{{vm.patternInfo.title}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                                border-bottom: solid 1px #ff9d1a;\n                            }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\" ng-if=\"true\"><md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.hasAllNecessaryFields\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\"><!--ثبت اطلاعات--></span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.patternInfoList\"><span><md-icon>list</md-icon></span><span>بازگشت به لیست</span></md-button></div></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.patternInfo.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.patternInfo.title\"></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.patternInfo.status\" for=\"field_status\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.patternInfo.status\" style=\"min-width: 50px;margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.patternStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"NOT_ACTIVE\" translate=\"tikonApp.patternStatus.NOT_ACTIVE\">NOT_ACTIVE</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"margin-top: 13px\"><!--<label class=\"control-label\" translate=\"tikonApp.patternInfo.patternStartTime\"--><!--for=\"field_patternStartTime\">patternStartTime--><!--</label>--><eo-time-picker label=\"\'از ساعت\'\" id=\"field_patternStartTime\" time-value=\"vm.patternInfo.patternStartTime\"></eo-time-picker></div></div></div><div class=\"row\"><div class=\"col-sm-4\" data-ng-if=\"vm.servantList && vm.servantList.length>0\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.serviceItem.selectServant\">selectServant</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectServant\' | translate}}\" ng-model=\"vm.patternInfo.servantId\" ng-change=\"vm.selectedServantChanged()\"><!--style=\"min-width: 300px;\"--><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servantList \">{{si.servantName}}</md-option></md-select></md-input-container></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"margin-top: 5px\"><label class=\"control-label\" translate=\"tikonApp.patternInfo.patternDate\" for=\"field_patternDate\">patternDate</label><eo-date-picker id=\"field_patternDate\" date-value=\"vm.patternInfo.patternDate\"></eo-date-picker></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"col-md-4\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.patternInfo.selectService\">selectService</label><pf-service-item-picker selected-service=\"vm.selectedServiceItem\" is-disabled=\"false\" servant-id=\"vm.patternInfo.servantId\" on-service-changed=\"vm.onServiceChanged()\"></pf-service-item-picker></md-input-container></div><div class=\"col-md-4\"><md-button ng-click=\"vm.addServiceToPattern()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.selectedServiceItem && !vm.selectedServiceItem.id\" style=\"margin-top: 25px\"><span><md-icon>add</md-icon></span><span translate=\"tikonApp.patternInfo.addService\"></span></md-button></div></div><hr><div ng-if=\" vm.patternInfo.patternStructure.patternItems && vm.patternInfo.patternStructure.patternItems.length>0\" class=\"row\"><div class=\"col-md-12\" style=\"padding-bottom: 20px\">ترتیب الگو از راست به چپ</div></div><div class=\"pattern-row\"><div class=\"pattern-item-box\" ng-repeat=\"item in vm.patternInfo.patternStructure.patternItems track by item.orderNo\"><span class=\"patternItem\" ng-class=\"item.serviceItem.color\"><span>{{item.orderNo}}. </span>{{item.serviceItem.itemTitle}} <span><a style=\"color: #ffffff\" ng-click=\"vm.removeFromPattern(item)\">X</a></span></span></div></div></div></md-content></div></div></div></div></div></div>");
$templateCache.put("app/entities/payment-log/order-bag-payment-log-dialog-v2.html","<eo-pl-modal-header title=\"\'tikonApp.paymentLog.home.createOrEditLabel\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.paymentLog.home.createOrEditLabel\"></span></div><div class=\"panel-body\"><div id=\"insertOrderBagPayment\" class=\"container-fluid pl-container-fluid\"><div class=\"row\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.paymentLog.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.paymentLog.id\" readonly=\"readonly\"></div><md-radio-group ng-model=\"vm.paymentLog.receiptPay\" class=\"md-primary\"><md-radio-button ng-value=\"true\"><span translate=\"tikonApp.paymentLog.receipt\">Receipt</span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"tikonApp.paymentLog.pay\">Pay</span></md-radio-button></md-radio-group><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.paymentLog.amount\" for=\"field_amount\">Amount</label><span translate=\"global.currencyBracket\"></span><!--<input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\"--><!--ng-model=\"vm.paymentLog.amount\" min=\"0\" required eo-required=\"\"--><!--/>--><eo-numeric-input-v2 id=\"field_amount\" name=\"amount\" custom-class=\"form-control\" input-value=\"vm.paymentLog.amount\" form-reference=\"editForm\" is-required=\"true\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.paymentLog.paymentType\" for=\"field_paymentType\">Payment Type</label><md-select class=\"rwMdSelect\" name=\"paymentType\" ng-model=\"vm.paymentLog.paymentType\" id=\"field_paymentType\" required eo-required=\"\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><md-option value=\"CASH\" translate=\"tikonApp.PaymentType.CASH\">CASH</md-option><md-option value=\"CREDIT_CARD\" translate=\"tikonApp.PaymentType.CREDIT_CARD\">CREDIT_CARD</md-option><md-option value=\"MONEY_TRANSFER\" translate=\"tikonApp.PaymentType.MONEY_TRANSFER\">MONEY_TRANSFER</md-option><md-option value=\"CARD_TO_CARD\">کارت به کارت</md-option><md-option value=\"SHABA\">شبا</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.createDate\" for=\"field_createDate\">Create Date</label><eo-date-picker style=\"display: block\" id=\"field_createDate\" date-value=\"vm.paymentLog.createDate\"></eo-date-picker></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.traceCode\" for=\"field_traceCode\">Trace Code</label><input type=\"text\" class=\"form-control\" name=\"traceCode\" id=\"field_traceCode\" ng-model=\"vm.paymentLog.traceCode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.moreInfo\" for=\"field_moreInfo\">moreInfo</label><input type=\"text\" class=\"form-control\" name=\"moreInfo\" id=\"field_moreInfo\" ng-model=\"vm.paymentLog.moreInfo\"></div></div></div></form></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/payment-log/order-bag-payment-log-dialog.html","<div role=\"dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"tikonApp.paymentLog.home.createOrEditLabel\">Create or edit a Payment Log</h2><button type=\"button\" class=\"close\" style=\"position: absolute;\n    left: 30px\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button></div></md-toolbar><div class=\"container-fluid\" style=\"margin: 15px\"><div class=\"row\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.paymentLog.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.paymentLog.id\" readonly=\"readonly\"></div><md-radio-group ng-model=\"vm.paymentLog.receiptPay\" class=\"md-primary\"><md-radio-button ng-value=\"true\"><span translate=\"tikonApp.paymentLog.receipt\">Receipt</span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"tikonApp.paymentLog.pay\">Pay</span></md-radio-button></md-radio-group><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.paymentLog.amount\" for=\"field_amount\">Amount</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.paymentLog.amount\" min=\"0\" required eo-required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.paymentLog.paymentType\" for=\"field_paymentType\">Payment Type</label><md-select class=\"rwMdSelect\" name=\"paymentType\" ng-model=\"vm.paymentLog.paymentType\" id=\"field_paymentType\" required eo-required=\"\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><md-option value=\"CASH\" translate=\"tikonApp.PaymentType.CASH\">CASH</md-option><md-option value=\"CREDIT_CARD\" translate=\"tikonApp.PaymentType.CREDIT_CARD\">CREDIT_CARD</md-option><md-option value=\"MONEY_TRANSFER\" translate=\"tikonApp.PaymentType.MONEY_TRANSFER\">MONEY_TRANSFER</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.createDate\" for=\"field_createDate\">Create Date</label><eo-date-picker style=\"display: block\" id=\"field_createDate\" date-value=\"vm.paymentLog.createDate\"></eo-date-picker></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.traceCode\" for=\"field_traceCode\">Trace Code</label><input type=\"text\" class=\"form-control\" name=\"traceCode\" id=\"field_traceCode\" ng-model=\"vm.paymentLog.traceCode\"></div></div></div><!--</div>--><div class=\"modal-footer\"><md-button type=\"button\" class=\"md-warn\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button style=\"margin: 0\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"md-raised md-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div></form></div></div><!--</div>--></div>");
$templateCache.put("app/entities/payment-log/payment-log-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.paymentLog.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.paymentLog.delete.question\" translate-values=\"{id: \'{{vm.paymentLog.id}}\'}\">Are you sure you want to delete this Payment Log?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/payment-log/payment-log-detail.html","<div><h2><span translate=\"tikonApp.paymentLog.detail.title\">Payment Log</span> {{vm.paymentLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.paymentLog.traceCode\">Trace Code</span></dt><dd><span>{{vm.paymentLog.traceCode}}</span></dd><dt><span translate=\"tikonApp.paymentLog.paymentType\">Payment Type</span></dt><dd><span translate=\"{{\'tikonApp.PaymentType.\' + vm.paymentLog.paymentType}}\">{{vm.paymentLog.paymentType}}</span></dd><dt><span translate=\"tikonApp.paymentLog.createDate\">Create Date</span></dt><dd><span>{{vm.paymentLog.createDate | date:\'medium\'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/payment-log/payment-log-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPaymentLogLabel\" translate=\"tikonApp.paymentLog.home.createOrEditLabel\">Create or edit a Payment Log</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.paymentLog.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.paymentLog.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.traceCode\" for=\"field_traceCode\">Trace Code</label><input type=\"text\" class=\"form-control\" name=\"traceCode\" id=\"field_traceCode\" ng-model=\"vm.paymentLog.traceCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.paymentType\" for=\"field_paymentType\">Payment Type</label><select class=\"form-control\" name=\"paymentType\" ng-model=\"vm.paymentLog.paymentType\" id=\"field_paymentType\"><option value=\"CASH\" translate=\"tikonApp.PaymentType.CASH\">CASH</option><option value=\"CREDIT_CARD\" translate=\"tikonApp.PaymentType.CREDIT_CARD\">CREDIT_CARD</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.paymentLog.createDate\" for=\"field_createDate\">Create Date</label><div class=\"input-group\"><input id=\"field_createDate\" type=\"text\" class=\"form-control\" name=\"createDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.paymentLog.createDate\" is-open=\"vm.datePickerOpenStatus.createDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/payment-log/payment-logs.html","<div><h2 translate=\"tikonApp.paymentLog.home.title\">Payment Logs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"payment-log.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.paymentLog.home.createLabel\">Create new Payment Log</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.paymentLog.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"traceCode\"><span translate=\"tikonApp.paymentLog.traceCode\">Trace Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paymentType\"><span translate=\"tikonApp.paymentLog.paymentType\">Payment Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.paymentLog.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"paymentLog in vm.paymentLogs track by paymentLog.id\"><td><a ui-sref=\"payment-log-detail({id:paymentLog.id})\">{{paymentLog.id}}</a></td><td>{{paymentLog.traceCode}}</td><td translate=\"{{\'tikonApp.PaymentType.\' + paymentLog.paymentType}}\">{{paymentLog.paymentType}}</td><td>{{paymentLog.createDate | date:\'medium\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"payment-log-detail({id:paymentLog.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"payment-log.edit({id:paymentLog.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"payment-log.delete({id:paymentLog.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/person-info/person-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.personInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.personInfo.delete.question\" translate-values=\"{id: \'{{vm.personInfo.id}}\'}\">Are you sure you want to delete this Person Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/person-info/person-info-detail.html","<div><h2><span translate=\"tikonApp.personInfo.detail.title\">Person Info</span> {{vm.personInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.personInfo.nationalCode\">National Code</span></dt><dd><span>{{vm.personInfo.nationalCode}}</span></dd><dt><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span></dt><dd><span>{{vm.personInfo.fisrtName}}</span></dd><dt><span translate=\"tikonApp.personInfo.lastName\">Last Name</span></dt><dd><span>{{vm.personInfo.lastName}}</span></dd><dt><span translate=\"tikonApp.personInfo.gender\">Gender</span></dt><dd><span>{{vm.personInfo.gender}}</span></dd><dt><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span></dt><dd><span>{{vm.personInfo.phoneNumber}}</span></dd><dt><span translate=\"tikonApp.personInfo.birthDate\">Birth Date</span></dt><dd><span>{{vm.personInfo.birthDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.personInfo.location\">Location</span></dt><dd><a ui-sref=\"location-info-detail({id:vm.personInfo.locationId})\">{{vm.personInfo.locationId}}</a></dd><dt><span translate=\"tikonApp.personInfo.socialNetworkInfo\">Social Network Info</span></dt><dd><span ng-repeat=\"socialNetworkInfo in vm.personInfo.socialNetworkInfos\"><a ui-sref=\"social-network-info-detail({id: {{socialNetworkInfo.id}}})\">{{socialNetworkInfo.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/person-info/person-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPersonInfoLabel\" translate=\"tikonApp.personInfo.home.createOrEditLabel\">Create or edit a Person Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.personInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.personInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.nationalCode\" for=\"field_nationalCode\">National Code</label><input type=\"text\" class=\"form-control\" name=\"nationalCode\" id=\"field_nationalCode\" ng-model=\"vm.personInfo.nationalCode\" maxlength=\"10\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.personInfo.fisrtName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.personInfo.lastName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.gender\" for=\"field_gender\">Gender</label><input type=\"checkbox\" class=\"form-control\" name=\"gender\" id=\"field_gender\" ng-model=\"vm.personInfo.gender\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\" ng-model=\"vm.personInfo.phoneNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\" for=\"field_birthDate\">Birth Date</label><div class=\"input-group\"><input id=\"field_birthDate\" type=\"text\" class=\"form-control\" name=\"birthDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.personInfo.birthDate\" is-open=\"vm.datePickerOpenStatus.birthDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'birthDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"tikonApp.personInfo.location\" for=\"field_location\">Location</label><select class=\"form-control\" id=\"field_location\" name=\"location\" ng-model=\"vm.personInfo.locationId\" ng-options=\"locationInfo.id as locationInfo.id for locationInfo in vm.locationinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.personInfo.socialNetworkInfo\" for=\"field_socialNetworkInfo\">Social Network Info</label><select class=\"form-control\" id=\"field_socialNetworkInfo\" multiple=\"multiple\" name=\"socialNetworkInfo\" ng-model=\"vm.personInfo.socialNetworkInfos\" ng-options=\"socialNetworkInfo as socialNetworkInfo.id for socialNetworkInfo in vm.socialnetworkinfos track by socialNetworkInfo.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/person-info/person-infos.html","<div><h2 translate=\"tikonApp.personInfo.home.title\">Person Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"person-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.personInfo.home.createLabel\">Create new Person Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.personInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nationalCode\"><span translate=\"tikonApp.personInfo.nationalCode\">National Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fisrtName\"><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"gender\"><span translate=\"tikonApp.personInfo.gender\">Gender</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"birthDate\"><span translate=\"tikonApp.personInfo.birthDate\">Birth Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"locationId\"><span translate=\"tikonApp.personInfo.location\">Location</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"personInfo in vm.personInfos track by personInfo.id\"><td><a ui-sref=\"person-info-detail({id:personInfo.id})\">{{personInfo.id}}</a></td><td>{{personInfo.nationalCode}}</td><td>{{personInfo.fisrtName}}</td><td>{{personInfo.lastName}}</td><td>{{personInfo.gender}}</td><td>{{personInfo.phoneNumber}}</td><td>{{personInfo.birthDate | date:\'medium\'}}</td><td><a ui-sref=\"location-info-detail({id:personInfo.locationId})\">{{personInfo.locationId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"person-info-detail({id:personInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"person-info.edit({id:personInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"person-info.delete({id:personInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/person-info/user-profile-basic-info.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><action-bar></action-bar><ul class=\"nav nav-tabs nav-justified lightnav\"><li class=\"active\"><a data-toggle=\"tab\" data-target=\"#basicInfoTab\"><span translate=\"supplierPanel.sideMenu.serviceItem.generalTab\">generalTab </span></a></li><li><a data-toggle=\"tab\" data-target=\"#scheduleTab\"><span translate=\"supplierPanel.sideMenu.serviceItem.scheduleTab\">scheduleTab </span></a></li></ul><div class=\"tab-content panel panel-default\"><div id=\"basicInfoTab\" class=\"tab-pane fade in active\"><div class=\"modal-body\"><!--<div class=\"form-group\" ng-show=\"vm.serviceItem.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"vm.serviceItem.id\" readonly />--><!--</div>--><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.nationalCode\" for=\"field_nationalCode\">National Code</label><input type=\"text\" class=\"form-control\" name=\"nationalCode\" id=\"field_nationalCode\" ng-model=\"vm.personInfo.nationalCode\" maxlength=\"10\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.personInfo.fisrtName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.personInfo.lastName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.gender\" for=\"field_gender\">Gender</label><input type=\"checkbox\" class=\"form-control\" name=\"gender\" id=\"field_gender\" ng-model=\"vm.personInfo.gender\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\" ng-model=\"vm.personInfo.phoneNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\" for=\"field_birthDate\">Birth Date</label><div class=\"input-group\"><input id=\"field_birthDate\" type=\"text\" class=\"form-control\" name=\"birthDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.personInfo.birthDate\" is-open=\"vm.datePickerOpenStatus.birthDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'birthDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div id=\"scheduleTab\" class=\"tab-pane fade\"><div eo-scheduler style=\"width: 100%;height: 600px\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.serviceTimes\" for=\"field_serviceTimes\">Service Times</label><select class=\"form-control\" id=\"field_serviceTimes\" multiple=\"multiple\" name=\"serviceTimes\" ng-model=\"vm.serviceItem.serviceTimes\" ng-options=\"scheduleInfo as scheduleInfo.id for scheduleInfo in vm.scheduleinfos track by scheduleInfo.id\"></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.minPreReserveTime\" for=\"field_minPreReserveTime\">Min Pre Reserve Time</label><input type=\"number\" class=\"form-control\" name=\"minPreReserveTime\" id=\"field_minPreReserveTime\" ng-model=\"vm.serviceItem.minPreReserveTime\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.maxPreReserveTime\" for=\"field_maxPreReserveTime\">Max Pre Reserve Time</label><input type=\"number\" class=\"form-control\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\" ng-model=\"vm.serviceItem.maxPreReserveTime\"></div></div><div id=\"capacityTab\" class=\"tab-pane fade\"><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.capacityInfo\" for=\"field_capacityInfo\">Capacity Info</label><select class=\"form-control\" id=\"field_capacityInfo\" name=\"capacityInfo\" ng-model=\"vm.serviceItem.capacityInfoId\" ng-options=\"serviceCapacityInfo.id as serviceCapacityInfo.id for serviceCapacityInfo in vm.servicecapacityinfos\"><option value=\"\"></option></select></div></div><div id=\"settingTab\" class=\"tab-pane fade\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.hasWaitingList\" for=\"field_hasWaitingList\">Has Waiting List</label><input type=\"checkbox\" class=\"form-control\" name=\"hasWaitingList\" id=\"field_hasWaitingList\" ng-model=\"vm.serviceItem.hasWaitingList\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.mustGetParticipantInfo\" for=\"field_mustGetParticipantInfo\">Must Get Participant Info</label><input type=\"checkbox\" class=\"form-control\" name=\"mustGetParticipantInfo\" id=\"field_mustGetParticipantInfo\" ng-model=\"vm.serviceItem.mustGetParticipantInfo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.canBeCanceled\" for=\"field_canBeCanceled\">Can Be Canceled</label><input type=\"checkbox\" class=\"form-control\" name=\"canBeCanceled\" id=\"field_canBeCanceled\" ng-model=\"vm.serviceItem.canBeCanceled\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.minPreCancelTime\" for=\"field_minPreCancelTime\">Min Pre Cancel Time</label><input type=\"number\" class=\"form-control\" name=\"minPreCancelTime\" id=\"field_minPreCancelTime\" ng-model=\"vm.serviceItem.minPreCancelTime\"></div></div><div id=\"discountTab\" class=\"tab-pane fade\"><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.discountInfo\" for=\"field_discountInfo\">Discount Info</label><select class=\"form-control\" id=\"field_discountInfo\" name=\"discountInfo\" ng-model=\"vm.serviceItem.discountInfoId\" ng-options=\"discountInfo.id as discountInfo.id for discountInfo in vm.discountinfos\"><option value=\"\"></option></select></div></div><div id=\"imageAlbumTab\" class=\"tab-pane fade\"><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.imageAlbum\" for=\"field_imageAlbum\">Image Album</label><select class=\"form-control\" id=\"field_imageAlbum\" name=\"imageAlbum\" ng-model=\"vm.serviceItem.imageAlbumId\" ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\"><option value=\"\"></option></select></div></div><div id=\"optionTab\" class=\"tab-pane fade\"></div><div id=\"priceTab\" class=\"tab-pane fade\"><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.priceinfo\" for=\"field_priceinfo\">Priceinfo</label><select class=\"form-control\" id=\"field_priceinfo\" name=\"priceinfo\" ng-model=\"vm.serviceItem.priceinfoId\" ng-options=\"priceInfo.id as priceInfo.id for priceInfo in vm.priceinfos\"><option value=\"\"></option></select></div><div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.paymentType\" for=\"field_paymentType\">Payment Type</label><input type=\"number\" class=\"form-control\" name=\"paymentType\" id=\"field_paymentType\" ng-model=\"vm.serviceItem.paymentType\"></div></div></div><div id=\"agreementTab\" class=\"tab-pane fade\"><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.agreement\" for=\"field_agreement\">Agreement</label><select class=\"form-control\" id=\"field_agreement\" name=\"agreement\" ng-model=\"vm.serviceItem.agreementId\" ng-options=\"agreementInfo.id as agreementInfo.id for agreementInfo in vm.agreementinfos\"><option value=\"\"></option></select></div></div></div><!--  <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n          </button>\n          <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n          </button>\n      </div>--></form>");
$templateCache.put("app/entities/price-info/price-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.priceInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.priceInfo.delete.question\" translate-values=\"{id: \'{{vm.priceInfo.id}}\'}\">Are you sure you want to delete this Price Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/price-info/price-info-detail.html","<div><h2><span translate=\"tikonApp.priceInfo.detail.title\">Price Info</span> {{vm.priceInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.priceInfo.fromValidDate\">From Valid Date</span></dt><dd><span>{{vm.priceInfo.fromValidDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.priceInfo.priceType\">Price Type</span></dt><dd><span translate=\"{{\'tikonApp.PriceType.\' + vm.priceInfo.priceType}}\">{{vm.priceInfo.priceType}}</span></dd><dt><span translate=\"tikonApp.priceInfo.servant\">Servant</span></dt><dd><span ng-repeat=\"servant in vm.priceInfo.servants\"><a ui-sref=\"servant-detail({id: {{servant.id}}})\">{{servant.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/price-info/price-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPriceInfoLabel\" translate=\"tikonApp.priceInfo.home.createOrEditLabel\">Create or edit a Price Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.priceInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.priceInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.priceInfo.fromValidDate\" for=\"field_fromValidDate\">From Valid Date</label><div class=\"input-group\"><input id=\"field_fromValidDate\" type=\"text\" class=\"form-control\" name=\"fromValidDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.priceInfo.fromValidDate\" is-open=\"vm.datePickerOpenStatus.fromValidDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromValidDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.priceInfo.priceType\" for=\"field_priceType\">Price Type</label><select class=\"form-control\" name=\"priceType\" ng-model=\"vm.priceInfo.priceType\" id=\"field_priceType\"><option value=\"FIXED\" translate=\"tikonApp.PriceType.FIXED\">FIXED</option><option value=\"SCHEDULE_BASED\" translate=\"tikonApp.PriceType.SCHEDULE_BASED\">SCHEDULE_BASED</option><option value=\"ITEM_QUANTITY_BASED\" translate=\"tikonApp.PriceType.ITEM_QUANTITY_BASED\">ITEM_QUANTITY_BASED</option><option value=\"CUSTOMER_BASED\" translate=\"tikonApp.PriceType.CUSTOMER_BASED\">CUSTOMER_BASED</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.priceInfo.servant\" for=\"field_servant\">Servant</label><select class=\"form-control\" id=\"field_servant\" multiple=\"multiple\" name=\"servant\" ng-model=\"vm.priceInfo.servants\" ng-options=\"servant as servant.id for servant in vm.servants track by servant.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/price-info/price-infos.html","<div><h2 translate=\"tikonApp.priceInfo.home.title\">Price Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"price-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.priceInfo.home.createLabel\">Create new Price Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.priceInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromValidDate\"><span translate=\"tikonApp.priceInfo.fromValidDate\">From Valid Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"priceType\"><span translate=\"tikonApp.priceInfo.priceType\">Price Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"priceInfo in vm.priceInfos track by priceInfo.id\"><td><a ui-sref=\"price-info-detail({id:priceInfo.id})\">{{priceInfo.id}}</a></td><td>{{priceInfo.fromValidDate | date:\'medium\'}}</td><td translate=\"{{\'tikonApp.PriceType.\' + priceInfo.priceType}}\">{{priceInfo.priceType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"price-info-detail({id:priceInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"price-info.edit({id:priceInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"price-info.delete({id:priceInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/price-info/service-item-price-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.priceInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><!--<jhi-alert-error></jhi-alert-error>--><p translate=\"tikonApp.priceInfo.delete.question\" translate-values=\"{id: \'{{vm.priceInfo.id}}\'}\">Are you sure you want to delete this Price Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/price-info-dtail/price-info-dtail-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.priceInfoDtail.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.priceInfoDtail.delete.question\" translate-values=\"{id: \'{{vm.priceInfoDtail.id}}\'}\">Are you sure you want to delete this Price Info Dtail?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/price-info-dtail/price-info-dtail-detail.html","<div><h2><span translate=\"tikonApp.priceInfoDtail.detail.title\">Price Info Dtail</span> {{vm.priceInfoDtail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.priceInfoDtail.title\">Title</span></dt><dd><span>{{vm.priceInfoDtail.title}}</span></dd><dt><span translate=\"tikonApp.priceInfoDtail.capacityRatio\">Capacity Ratio</span></dt><dd><span>{{vm.priceInfoDtail.capacityRatio}}</span></dd><dt><span translate=\"tikonApp.priceInfoDtail.price\">Price</span></dt><dd><span>{{vm.priceInfoDtail.price}}</span></dd><dt><span translate=\"tikonApp.priceInfoDtail.coworkerPrice\">Coworker Price</span></dt><dd><span>{{vm.priceInfoDtail.coworkerPrice}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/price-info-dtail/price-info-dtail-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPriceInfoDtailLabel\" translate=\"tikonApp.priceInfoDtail.home.createOrEditLabel\">Create or edit a Price Info Dtail</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.priceInfoDtail.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.priceInfoDtail.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.priceInfoDtail.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.capacityRatio\" for=\"field_capacityRatio\">Capacity Ratio</label><input type=\"number\" class=\"form-control\" name=\"capacityRatio\" id=\"field_capacityRatio\" ng-model=\"vm.priceInfoDtail.capacityRatio\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.price\" for=\"field_price\">Price</label><input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"vm.priceInfoDtail.price\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.coworkerPrice\" for=\"field_coworkerPrice\">Coworker Price</label><input type=\"number\" class=\"form-control\" name=\"coworkerPrice\" id=\"field_coworkerPrice\" ng-model=\"vm.priceInfoDtail.coworkerPrice\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/price-info-dtail/price-info-dtails.html","<div><h2 translate=\"tikonApp.priceInfoDtail.home.title\">Price Info Dtails</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"price-info-dtail.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.priceInfoDtail.home.createLabel\">Create new Price Info Dtail</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.priceInfoDtail.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.priceInfoDtail.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"capacityRatio\"><span translate=\"tikonApp.priceInfoDtail.capacityRatio\">Capacity Ratio</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"price\"><span translate=\"tikonApp.priceInfoDtail.price\">Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"coworkerPrice\"><span translate=\"tikonApp.priceInfoDtail.coworkerPrice\">Coworker Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"priceInfoDtail in vm.priceInfoDtails track by priceInfoDtail.id\"><td><a ui-sref=\"price-info-dtail-detail({id:priceInfoDtail.id})\">{{priceInfoDtail.id}}</a></td><td>{{priceInfoDtail.title}}</td><td>{{priceInfoDtail.capacityRatio}}</td><td>{{priceInfoDtail.price}}</td><td>{{priceInfoDtail.coworkerPrice}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"price-info-dtail-detail({id:priceInfoDtail.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"price-info-dtail.edit({id:priceInfoDtail.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"price-info-dtail.delete({id:priceInfoDtail.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/related-service-item/related-service-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.relatedServiceItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.relatedServiceItem.delete.question\" translate-values=\"{id: \'{{vm.relatedServiceItem.id}}\'}\">Are you sure you want to delete this Related Service Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/related-service-item/related-service-item-detail.html","<div><h2><span translate=\"tikonApp.relatedServiceItem.detail.title\">Related Service Item</span> {{vm.relatedServiceItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.relatedServiceItem.type\">Type</span></dt><dd><span>{{vm.relatedServiceItem.type}}</span></dd><dt><span translate=\"tikonApp.relatedServiceItem.firstItem\">First Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.relatedServiceItem.firstItemId})\">{{vm.relatedServiceItem.firstItemId}}</a></dd><dt><span translate=\"tikonApp.relatedServiceItem.secondItem\">Second Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.relatedServiceItem.secondItemId})\">{{vm.relatedServiceItem.secondItemId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/related-service-item/related-service-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRelatedServiceItemLabel\" translate=\"tikonApp.relatedServiceItem.home.createOrEditLabel\">Create or edit a Related Service Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.relatedServiceItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.relatedServiceItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.relatedServiceItem.type\" for=\"field_type\">Type</label><input type=\"number\" class=\"form-control\" name=\"type\" id=\"field_type\" ng-model=\"vm.relatedServiceItem.type\"></div><div class=\"form-group\"><label translate=\"tikonApp.relatedServiceItem.firstItem\" for=\"field_firstItem\">First Item</label><select class=\"form-control\" id=\"field_firstItem\" name=\"firstItem\" ng-model=\"vm.relatedServiceItem.firstItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.relatedServiceItem.secondItem\" for=\"field_secondItem\">Second Item</label><select class=\"form-control\" id=\"field_secondItem\" name=\"secondItem\" ng-model=\"vm.relatedServiceItem.secondItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/related-service-item/related-service-items.html","<div><h2 translate=\"tikonApp.relatedServiceItem.home.title\">Related Service Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"related-service-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.relatedServiceItem.home.createLabel\">Create new Related Service Item</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.relatedServiceItem.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"tikonApp.relatedServiceItem.type\">Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstItemId\"><span translate=\"tikonApp.relatedServiceItem.firstItem\">First Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"secondItemId\"><span translate=\"tikonApp.relatedServiceItem.secondItem\">Second Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"relatedServiceItem in vm.relatedServiceItems track by relatedServiceItem.id\"><td><a ui-sref=\"related-service-item-detail({id:relatedServiceItem.id})\">{{relatedServiceItem.id}}</a></td><td>{{relatedServiceItem.type}}</td><td><a ui-sref=\"service-item-detail({id:relatedServiceItem.firstItemId})\">{{relatedServiceItem.firstItemId}}</a></td><td><a ui-sref=\"service-item-detail({id:relatedServiceItem.secondItemId})\">{{relatedServiceItem.secondItemId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"related-service-item-detail({id:relatedServiceItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"related-service-item.edit({id:relatedServiceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"related-service-item.delete({id:relatedServiceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/reports/reports.html","<div id=\"coupons-reports\"><panel-pln-reports></panel-pln-reports></div>");
$templateCache.put("app/entities/reserve/filter-reserve-list-dialog.html","<style>.panel {\n        margin: 0;\n\n    }</style><md-dialog class=\"pl-md-dialog\"><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div>اعمال فیلتر (جستجوی پیشرفته)</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><md-dialog-content class=\"pl-dialog-content\"><div class=\"\"><div class=\"panel-body\"><div id=\"filters_content\"><div class=\"row\"><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"$ctrl.data.filterQuery.fromDate\"></eo-date-picker></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"$ctrl.data.filterQuery.toDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\">Status</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\" id=\"field_filterStatus\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery.status\" style=\"min-width: 100px\"><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.data.statusList\">{{\"tikonApp.orderBag.status.\"+si | translate}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\">ServiceItem</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery.serviceItemIds\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.data.serviceItems\"><small class=\"hidden-xs\" ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} - </small>{{si.itemTitle}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServant\">servant</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" multiple=\"true\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery.servantIds\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.data.servants\">{{si.servantName}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.home.search\">servant</label><input class=\"form-control rwTableSearchBox pl-col-no-margin\" style=\"max-width: unset\" ng-model=\"$ctrl.data.filterQuery.orderBagId\" placeholder=\"{{ \'tikonApp.orderBagServiceItem.filterOrderBagId\' | translate }}\" type=\"text\"></div></div></div></div></div></div></md-dialog-content><md-dialog-actions class=\"pl-dialog-actions\"><div class=\"pl-filter-dialog-footer\" style=\"width: 100%\"><div class=\"\" style=\"display: flex;justify-content: flex-end\"><a class=\"delete-filters\" ng-click=\"$ctrl.clearFilter()\"><i class=\"material-icons\" style=\"font-size: 12px\">cancel</i> حذف فیلترها</a><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default hidden-xs\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span>بازگشت</span><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--></md-button><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-click=\"$ctrl.okModal()\"><span>اعمال</span></md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/entities/reserve/new-reserve-modal-old.html","<style>.alerts > :first-child {\n        position: absolute;\n        display: none;\n    }\n\n    .price-item-table {\n        float: left;\n        margin-left: 30px;\n    }</style><div class=\"container-fluid\"><div class=\"row\" style=\"margin: auto\"></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div name=\"customer\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.customerInfo\"></span></div><div class=\"panel-body\"><div name=\"findCustomer\"><div class=\"row\"><div class=\"col-sm-7\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete></div><div class=\"col-sm-3\" style=\"padding-top: 26px\"><!--ng-click=\"vm.addNewCustomer()\"--><md-button type=\"button\" ng-click=\"vm.newCustomer()\" class=\"md-raised md-primary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomer\">New customer</span></md-button></div></div><div class=\"row\" ng-if=\"vm.customerMode == \'new\' || vm.orderBag.customer.personalInfo.fisrtName\"><div class=\"col-md-2\" ng-if=\"vm.isCustomerManager || vm.customerMode == \'new\' \"><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-placeHolder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.phoneNumber\" required autocomplete=\"off\" ng-change=\"vm.searchCustomerByPhoneNumber()\"><div class=\"customer-search-list\" ng-if=\"vm.existCustomerSearchResult && vm.existCustomerSearchResult.length>0\"><div class=\"customer-search-item\" ng-repeat=\"item in vm.existCustomerSearchResult track by item.id\" ng-click=\"vm.selectedCustomerChanged(item)\"><span>{{item.title}}</span> <span style=\"font-size: smaller;color: #95999b\">({{item.description}})</span></div></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.orderBag.customer.personalInfo.fisrtName\"><div ng-if=\"form.fisrtName.$dirty && form.fisrtName.$invalid\"><p class=\"help-block\" ng-if=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.orderBag.customer.personalInfo.lastName\"><div ng-if=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-if=\"form.lastName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><!--<div class=\"col-md-4\" ng-if=\"vm.customerMode == \'new\'\" >--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"login\" translate=\"global.form.usernameEnglishCharacter\">Username--><!--</label>--><!--<input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\"--><!--placeholder=\"{{\'global.form.username.placeholder\' | translate}}\"--><!--ng-model=\"vm.orderBag.customer.userAccount.login\" ng-minlength=1 ng-maxlength=50--><!--ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required>--><!--<div ng-if=\"form.login.$dirty && form.login.$invalid\">--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.required\"--><!--translate=\"register.messages.validate.login.required\">--><!--Your username is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.minlength\"--><!--translate=\"register.messages.validate.login.minlength\">--><!--Your username is required to be at least 1 character.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.maxlength\"--><!--translate=\"register.messages.validate.login.maxlength\">--><!--Your username cannot be longer than 50 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">--><!--Your username can only contain lower-case letters and digits.--><!--</p>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"tikonApp.orderBag.customer.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" style=\"direction: ltr\" placeholder=\"{{\'tikonApp.orderBag.customer.email-placeholder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.email\" ng-minlength=\"5\" ng-maxlength=\"100\"><div ng-if=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-if=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-if=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-if=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-if=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div ng-if=\"vm.selectedCustomer\" class=\"row\"><pf-customer-statistics selected-customer-id=\"vm.selectedItem.id\"></pf-customer-statistics></div></div></div></div></div><div data-ng-if=\"vm.formState==\'orderBagItem\'\"><div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div><div class=\"panel-body\"><!--<div ng-if=\"vm.orderBag.orderBagServiceItems[0]\">--><!--{{vm.orderBag.orderBagServiceItems[0].index}}--><!--{{vm.orderBag.orderBagServiceItems[0].serviceTimeSession}}--><!--<pf-reserve-service-item--><!--order-bag-service-item=\"vm.orderBag.orderBagServiceItems[0]\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--&gt;--><!--</pf-reserve-service-item>--><!--</div>--><!--  <div ng-if=\"vm.orderBag.orderBagServiceItems[1]\">\n                              {{vm.orderBag.orderBagServiceItems[1].index}}\n                              {{vm.orderBag.orderBagServiceItems[1].serviceTimeSession}}\n                              <pf-reserve-service-item\n                                  order-bag-service-item=\"vm.orderBag.orderBagServiceItems[1]\" init-mode=\"vm.formMode\"\n                                  default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                  default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                  has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                              >\n                              </pf-reserve-service-item>\n                          </div>\n                          <div ng-if=\"vm.orderBag.orderBagServiceItems[2]\">\n                              {{vm.orderBag.orderBagServiceItems[2].index}}\n                              {{vm.orderBag.orderBagServiceItems[2].serviceTimeSession}}\n                              <pf-reserve-service-item\n                                  order-bag-service-item=\"vm.orderBag.orderBagServiceItems[2]\" init-mode=\"vm.formMode\"\n                                  default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                  default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                  has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                              >\n                              </pf-reserve-service-item>\n                          </div>\n                          <div class=\"btn-group flex-btn-group-container\" style=\"float: right\" >\n                              <button type=\"button\" class=\"btn btn-primary btn-sm\"\n                                      ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\"\n                                      ng-click=\"vm.addReserveRow()\">\n                                  <span class=\"glyphicon glyphicon-plus\"></span>\n                                  <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.add\">entity.action.add</span>\n                              </button>\n\n                          </div>--><div ng-repeat=\"item in vm.orderBag.orderBagServiceItems track by $index\"><div ng-if=\"$index == 0\"><!--<pf-reserve-service-item--><!--order-bag-service-item=\"item\"--><!--on-item-changed=\"vm.onItemChanged(item)\"--><!--on-service-changed=\"vm.onServiceChanged()\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--index-of-orderbag=\"$index\"--><!--init-mode=\"vm.mode\"--><!--check-capacity=\"vm.orderBag.checkCapacity\"--><!--edit-mode=\"\'NONE\'\"--><!--&gt;--><!--</pf-reserve-service-item>--><pf-reserve-service-item-v2 order-bag-service-item=\"item\" on-item-changed=\"vm.onItemChanged(item)\" on-service-changed=\"vm.onServiceChanged()\" default-service-item-id=\"vm.states.serviceItemId\" default-start-date=\"vm.states.start_date\" default-end-date=\"vm.states.end_date\" default-servant-id=\"vm.states.servantId\" default-service-time-session-id=\"vm.states.timeSessionId\" index-of-orderbag=\"$index\" edit-mode=\"\'NONE\'\" show-un-planned-time=\"vm.showUnPlannedTime\"></pf-reserve-service-item-v2></div><div ng-if=\"$index != 0 \"><hr><pf-reserve-service-item-v2 order-bag-service-item=\"item\" init-mode=\"vm.formMode\" on-item-changed=\"vm.onItemChanged(item)\" default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\" default-start-date=\"item.defaultStartDate\" has-multiple-reserve-time=\"vm.hasMultipleReserveTime\" index-of-orderbag=\"$index\" init-mode=\"vm.mode\" check-capacity=\"vm.orderBag.checkCapacity\" edit-mode=\"\'NONE\'\" show-un-planned-time=\"vm.showUnPlannedTime\"></pf-reserve-service-item-v2></div><div class=\"btn-group flex-btn-group-container\" style=\"float: right\" ng-if=\"$last\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\" ng-click=\"vm.addReserveRow()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"\" translate=\"tikonApp.orderBag.addItem\">tikonApp.orderBag.addItem</span></button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[1].serviceItemId\" type=\"button\" ng-click=\"vm.removeReserveRow()\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"\" translate=\"tikonApp.orderBag.removeItem\">tikonApp.orderBag.addItem</span></button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" name=\"orderbagComment\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBag.comment\"></span></div><div class=\"panel-body\"><!--<input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\"--><!--ng-model=--><!--/>--><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"comment\" placeholder=\"{{\'tikonApp.orderBag.comment\' | translate}}\" ng-model=\"vm.orderBag.comment\"></textarea></div></div></div><div class=\"col-md-6\"><div ng-show=\"vm.computedFinalPrice.finalPrice>=0\" class=\"panel panel-success\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></div></div><div class=\"row\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></div></div><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{vm.computedFinalPrice.totalDiscount | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{vm.computedFinalPrice.totalVAT | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><div class=\"row\"><br></div><div class=\"row text-success\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.finalPrice | number}} <span translate=\"global.currency\"></span></div></div></div></div></div></div></div><div><button type=\"button\" ng-click=\"vm.serviceSelected()\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.formState==\'selectService\'\"><span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span></button> <button type=\"button\" ng-click=\"vm.prev()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span></button></div><div><!--{{vm.orderBag}}--><!--{{vm.orderBag.orderBagServiceItems}}--><!--{{vm.orderBag.orderBagServiceItems[0].orderBagServiceItemDtail}}--></div><!--<div ng-repeat=\"item in vm.orderBag.orderBagServiceItems \">--><!--</div>--></form><div class=\"pull-left\"><md-button type=\"button\" class=\"md-raised md-secondary\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.okModal()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div></div>");
$templateCache.put("app/entities/reserve/new-reserve-modal-v2.html","<style>.alerts > :first-child {\n        position: absolute;\n        display: none;\n    }\n\n    .price-item-table {\n        float: left;\n        margin-left: 30px;\n    }</style><eo-pl-modal-header title=\"\'tikonApp.orderBag.home.createLabel\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"row\" style=\"margin: auto\"></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div name=\"customer\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.customerInfo\"></span></div><div class=\"panel-body\"><div name=\"findCustomer\"><div class=\"row\"><div class=\"col-sm-6\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete></div><div class=\"col-sm-6 col-xs-12\" style=\"padding-top: 26px;display: flex\"><md-button type=\"button\" ng-click=\"vm.newCustomer()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomer\">New customer</span></md-button><md-button type=\"button\" ng-click=\"vm.newCustomerPopUp()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomerPopUp\">newCustomerPopUp</span></md-button></div></div><div class=\"row\" ng-if=\"vm.customerMode == \'new\' || vm.orderBag.customer.personalInfo.fisrtName\"><div class=\"col-md-2\" ng-if=\"vm.isCustomerManager || vm.customerMode == \'new\' \"><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-placeHolder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.phoneNumber\" required autocomplete=\"off\" ng-change=\"vm.searchCustomerByPhoneNumber()\"><div class=\"customer-search-list\" ng-if=\"vm.existCustomerSearchResult && vm.existCustomerSearchResult.length>0\"><div class=\"customer-search-item\" ng-repeat=\"item in vm.existCustomerSearchResult track by item.id\" ng-click=\"vm.selectedCustomerChanged(item)\"><span>{{item.title}}</span> <span style=\"font-size: smaller;color: #95999b\">({{item.description}})</span></div></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.orderBag.customer.personalInfo.fisrtName\"><div ng-if=\"form.fisrtName.$dirty && form.fisrtName.$invalid\"><p class=\"help-block\" ng-if=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.orderBag.customer.personalInfo.lastName\"><div ng-if=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-if=\"form.lastName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><!--<div class=\"col-md-4\" ng-if=\"vm.customerMode == \'new\'\" >--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"login\" translate=\"global.form.usernameEnglishCharacter\">Username--><!--</label>--><!--<input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\"--><!--placeholder=\"{{\'global.form.username.placeholder\' | translate}}\"--><!--ng-model=\"vm.orderBag.customer.userAccount.login\" ng-minlength=1 ng-maxlength=50--><!--ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required>--><!--<div ng-if=\"form.login.$dirty && form.login.$invalid\">--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.required\"--><!--translate=\"register.messages.validate.login.required\">--><!--Your username is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.minlength\"--><!--translate=\"register.messages.validate.login.minlength\">--><!--Your username is required to be at least 1 character.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.maxlength\"--><!--translate=\"register.messages.validate.login.maxlength\">--><!--Your username cannot be longer than 50 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">--><!--Your username can only contain lower-case letters and digits.--><!--</p>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"tikonApp.orderBag.customer.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" style=\"direction: ltr\" placeholder=\"{{\'tikonApp.orderBag.customer.email-placeholder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.email\" ng-minlength=\"5\" ng-maxlength=\"100\"><div ng-if=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-if=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-if=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-if=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-if=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div ng-if=\"vm.selectedCustomer\" class=\"row\"><pf-customer-statistics selected-customer-id=\"vm.selectedItem.id\"></pf-customer-statistics></div></div></div></div></div><div data-ng-if=\"vm.formState==\'orderBagItem\'\"><div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div><div class=\"panel-body\"><!--<div ng-if=\"vm.orderBag.orderBagServiceItems[0]\">--><!--{{vm.orderBag.orderBagServiceItems[0].index}}--><!--{{vm.orderBag.orderBagServiceItems[0].serviceTimeSession}}--><!--<pf-reserve-service-item--><!--order-bag-service-item=\"vm.orderBag.orderBagServiceItems[0]\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--&gt;--><!--</pf-reserve-service-item>--><!--</div>--><!--  <div ng-if=\"vm.orderBag.orderBagServiceItems[1]\">\n                                  {{vm.orderBag.orderBagServiceItems[1].index}}\n                                  {{vm.orderBag.orderBagServiceItems[1].serviceTimeSession}}\n                                  <pf-reserve-service-item\n                                      order-bag-service-item=\"vm.orderBag.orderBagServiceItems[1]\" init-mode=\"vm.formMode\"\n                                      default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                      default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                      has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                                  >\n                                  </pf-reserve-service-item>\n                              </div>\n                              <div ng-if=\"vm.orderBag.orderBagServiceItems[2]\">\n                                  {{vm.orderBag.orderBagServiceItems[2].index}}\n                                  {{vm.orderBag.orderBagServiceItems[2].serviceTimeSession}}\n                                  <pf-reserve-service-item\n                                      order-bag-service-item=\"vm.orderBag.orderBagServiceItems[2]\" init-mode=\"vm.formMode\"\n                                      default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                      default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                      has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                                  >\n                                  </pf-reserve-service-item>\n                              </div>\n                              <div class=\"btn-group flex-btn-group-container\" style=\"float: right\" >\n                                  <button type=\"button\" class=\"btn btn-primary btn-sm\"\n                                          ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\"\n                                          ng-click=\"vm.addReserveRow()\">\n                                      <span class=\"glyphicon glyphicon-plus\"></span>\n                                      <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.add\">entity.action.add</span>\n                                  </button>\n\n                              </div>--><div ng-repeat=\"item in vm.orderBag.orderBagServiceItems track by $index\"><div ng-if=\"$index == 0\"><!--<pf-reserve-service-item--><!--order-bag-service-item=\"item\"--><!--on-item-changed=\"vm.onItemChanged(item)\"--><!--on-service-changed=\"vm.onServiceChanged()\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--index-of-orderbag=\"$index\"--><!--init-mode=\"vm.mode\"--><!--check-capacity=\"vm.orderBag.checkCapacity\"--><!--edit-mode=\"\'NONE\'\"--><!--&gt;--><!--</pf-reserve-service-item>--><pf-reserve-service-item-v2 order-bag-service-item=\"item\" on-item-changed=\"vm.onItemChanged(item)\" on-service-changed=\"vm.onServiceChanged()\" default-service-item-id=\"vm.states.serviceItemId\" default-start-date=\"vm.states.start_date\" default-end-date=\"vm.states.end_date\" default-servant-id=\"vm.states.servantId\" default-service-time-session-id=\"vm.states.timeSessionId\" index-of-orderbag=\"$index\" edit-mode=\"\'NONE\'\" show-un-planned-time=\"vm.showUnPlannedTime\"></pf-reserve-service-item-v2></div><div ng-if=\"$index != 0 \"><hr><pf-reserve-service-item-v2 order-bag-service-item=\"item\" init-mode=\"vm.formMode\" on-item-changed=\"vm.onItemChanged(item)\" default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\" default-start-date=\"item.defaultStartDate\" has-multiple-reserve-time=\"vm.hasMultipleReserveTime\" index-of-orderbag=\"$index\" init-mode=\"vm.mode\" check-capacity=\"vm.orderBag.checkCapacity\" edit-mode=\"\'NONE\'\" show-un-planned-time=\"vm.showUnPlannedTime\"></pf-reserve-service-item-v2></div><div class=\"btn-group flex-btn-group-container\" style=\"float: right\" ng-if=\"$last\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\" ng-click=\"vm.addReserveRow()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"\" translate=\"tikonApp.orderBag.addItem\">tikonApp.orderBag.addItem</span></button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[1].serviceItemId\" type=\"button\" ng-click=\"vm.removeReserveRow()\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"\" translate=\"tikonApp.orderBag.removeItem\">tikonApp.orderBag.addItem</span></button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" name=\"orderbagComment\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBag.comment\"></span></div><div class=\"panel-body\"><!--<input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\"--><!--ng-model=--><!--/>--><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"comment\" placeholder=\"{{\'tikonApp.orderBag.comment\' | translate}}\" ng-model=\"vm.orderBag.comment\"></textarea></div></div></div><div class=\"col-md-6\"><div ng-show=\"vm.computedFinalPrice.finalPrice>=0\" class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></div></div><div class=\"row\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></div></div><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{vm.computedFinalPrice.totalDiscount | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{vm.computedFinalPrice.totalVAT | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--COUPON-CODE--><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.orderBag.couponToCheckValidity\"></div><div class=\"text-success\" ng-if=\"vm.couponResult.resultStatus==\'DONE\'\"><span>کد تخفیف </span>{{vm.couponResult.coupon.couponCode}} <span>با موفقیت اعمال شد</span></div></div><div class=\"col-md-5\"><md-button class=\"md-raised align-bottom\" ng-click=\"vm.checkCouponCode()\" style=\"margin-top: 33px\"><!--<span translate=\"entity.action.backToReserveList\">--><!--entity.action.backToReserveList--><!--</span>--> <span translate=\"tikonApp.orderBag.evaluateCoupon\">couponCode</span></md-button></div></div><div class=\"row\"><br></div><div class=\"row text-success\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.finalPrice | number}} <span translate=\"global.currency\"></span></div></div></div></div></div></div></div><div><button type=\"button\" ng-click=\"vm.serviceSelected()\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.formState==\'selectService\'\"><span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span></button> <button type=\"button\" ng-click=\"vm.prev()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span></button></div><div><!--{{vm.orderBag}}--><!--{{vm.orderBag.orderBagServiceItems}}--><!--{{vm.orderBag.orderBagServiceItems[0].orderBagServiceItemDtail}}--></div><!--<div ng-repeat=\"item in vm.orderBag.orderBagServiceItems \">--><!--</div>--></form></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/reserve/new-reserve-modal.html","<style>.alerts > :first-child {\n        position: absolute;\n        display: none;\n    }\n\n    .price-item-table {\n        float: left;\n        margin-left: 30px;\n    }</style><div id=\"reserveModal\" class=\"row pl-modal-header modal-header pl-modal-border hidden-xs\"><div class=\"pl-modal-title col-md-8 col-sm-6 col-xs-6\" id=\"newReserveModal\" translate=\"tikonApp.orderBag.home.createLabel\">Create New Reserve</div><div class=\"col-md-4\"><md-button class=\"md-raised md-primary pull-left pl-btn pl-btn-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.okModal()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button><md-button type=\"button\" class=\"md-raised md-secondary pull-left pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button></div></div><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"row\" style=\"margin: auto\"></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div name=\"customer\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.customerInfo\"></span></div><div class=\"panel-body\"><div name=\"findCustomer\"><div class=\"row\"><div class=\"col-sm-7\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete></div><div class=\"col-sm-3\" style=\"padding-top: 26px\"><!--ng-click=\"vm.addNewCustomer()\"--><md-button type=\"button\" ng-click=\"vm.newCustomer()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomer\">New customer</span></md-button></div></div><div class=\"row\" ng-if=\"vm.customerMode == \'new\' || vm.orderBag.customer.personalInfo.fisrtName\"><div class=\"col-md-2\" ng-if=\"vm.isCustomerManager || vm.customerMode == \'new\' \"><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-placeHolder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.phoneNumber\" required autocomplete=\"off\" ng-change=\"vm.searchCustomerByPhoneNumber()\"><div class=\"customer-search-list\" ng-if=\"vm.existCustomerSearchResult && vm.existCustomerSearchResult.length>0\"><div class=\"customer-search-item\" ng-repeat=\"item in vm.existCustomerSearchResult track by item.id\" ng-click=\"vm.selectedCustomerChanged(item)\"><span>{{item.title}}</span> <span style=\"font-size: smaller;color: #95999b\">({{item.description}})</span></div></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.orderBag.customer.personalInfo.fisrtName\"><div ng-if=\"form.fisrtName.$dirty && form.fisrtName.$invalid\"><p class=\"help-block\" ng-if=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.orderBag.customer.personalInfo.lastName\"><div ng-if=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-if=\"form.lastName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><!--<div class=\"col-md-4\" ng-if=\"vm.customerMode == \'new\'\" >--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"login\" translate=\"global.form.usernameEnglishCharacter\">Username--><!--</label>--><!--<input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\"--><!--placeholder=\"{{\'global.form.username.placeholder\' | translate}}\"--><!--ng-model=\"vm.orderBag.customer.userAccount.login\" ng-minlength=1 ng-maxlength=50--><!--ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required>--><!--<div ng-if=\"form.login.$dirty && form.login.$invalid\">--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.required\"--><!--translate=\"register.messages.validate.login.required\">--><!--Your username is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.minlength\"--><!--translate=\"register.messages.validate.login.minlength\">--><!--Your username is required to be at least 1 character.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.maxlength\"--><!--translate=\"register.messages.validate.login.maxlength\">--><!--Your username cannot be longer than 50 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">--><!--Your username can only contain lower-case letters and digits.--><!--</p>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"tikonApp.orderBag.customer.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" style=\"direction: ltr\" placeholder=\"{{\'tikonApp.orderBag.customer.email-placeholder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.email\" ng-minlength=\"5\" ng-maxlength=\"100\"><div ng-if=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-if=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-if=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-if=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-if=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div ng-if=\"vm.selectedCustomer\" class=\"row\"><pf-customer-statistics selected-customer-id=\"vm.selectedItem.id\"></pf-customer-statistics></div></div></div></div></div><div data-ng-if=\"vm.formState==\'orderBagItem\'\"><div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div><div class=\"panel-body\"><!--<div ng-if=\"vm.orderBag.orderBagServiceItems[0]\">--><!--{{vm.orderBag.orderBagServiceItems[0].index}}--><!--{{vm.orderBag.orderBagServiceItems[0].serviceTimeSession}}--><!--<pf-reserve-service-item--><!--order-bag-service-item=\"vm.orderBag.orderBagServiceItems[0]\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--&gt;--><!--</pf-reserve-service-item>--><!--</div>--><!--  <div ng-if=\"vm.orderBag.orderBagServiceItems[1]\">\n                                  {{vm.orderBag.orderBagServiceItems[1].index}}\n                                  {{vm.orderBag.orderBagServiceItems[1].serviceTimeSession}}\n                                  <pf-reserve-service-item\n                                      order-bag-service-item=\"vm.orderBag.orderBagServiceItems[1]\" init-mode=\"vm.formMode\"\n                                      default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                      default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                      has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                                  >\n                                  </pf-reserve-service-item>\n                              </div>\n                              <div ng-if=\"vm.orderBag.orderBagServiceItems[2]\">\n                                  {{vm.orderBag.orderBagServiceItems[2].index}}\n                                  {{vm.orderBag.orderBagServiceItems[2].serviceTimeSession}}\n                                  <pf-reserve-service-item\n                                      order-bag-service-item=\"vm.orderBag.orderBagServiceItems[2]\" init-mode=\"vm.formMode\"\n                                      default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                      default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                      has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                                  >\n                                  </pf-reserve-service-item>\n                              </div>\n                              <div class=\"btn-group flex-btn-group-container\" style=\"float: right\" >\n                                  <button type=\"button\" class=\"btn btn-primary btn-sm\"\n                                          ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\"\n                                          ng-click=\"vm.addReserveRow()\">\n                                      <span class=\"glyphicon glyphicon-plus\"></span>\n                                      <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.add\">entity.action.add</span>\n                                  </button>\n\n                              </div>--><div ng-repeat=\"item in vm.orderBag.orderBagServiceItems track by $index\"><div ng-if=\"$index == 0\"><!--<pf-reserve-service-item--><!--order-bag-service-item=\"item\"--><!--on-item-changed=\"vm.onItemChanged(item)\"--><!--on-service-changed=\"vm.onServiceChanged()\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--index-of-orderbag=\"$index\"--><!--init-mode=\"vm.mode\"--><!--check-capacity=\"vm.orderBag.checkCapacity\"--><!--edit-mode=\"\'NONE\'\"--><!--&gt;--><!--</pf-reserve-service-item>--><pf-reserve-service-item-v2 order-bag-service-item=\"item\" on-item-changed=\"vm.onItemChanged(item)\" on-service-changed=\"vm.onServiceChanged()\" default-service-item-id=\"vm.states.serviceItemId\" default-start-date=\"vm.states.start_date\" default-end-date=\"vm.states.end_date\" default-servant-id=\"vm.states.servantId\" default-service-time-session-id=\"vm.states.timeSessionId\" index-of-orderbag=\"$index\" edit-mode=\"\'NONE\'\" show-un-planned-time=\"vm.showUnPlannedTime\"></pf-reserve-service-item-v2></div><div ng-if=\"$index != 0 \"><hr><pf-reserve-service-item-v2 order-bag-service-item=\"item\" init-mode=\"vm.formMode\" on-item-changed=\"vm.onItemChanged(item)\" default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\" default-start-date=\"item.defaultStartDate\" has-multiple-reserve-time=\"vm.hasMultipleReserveTime\" index-of-orderbag=\"$index\" init-mode=\"vm.mode\" check-capacity=\"vm.orderBag.checkCapacity\" edit-mode=\"\'NONE\'\" show-un-planned-time=\"vm.showUnPlannedTime\"></pf-reserve-service-item-v2></div><div class=\"btn-group flex-btn-group-container\" style=\"float: right\" ng-if=\"$last\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\" ng-click=\"vm.addReserveRow()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"\" translate=\"tikonApp.orderBag.addItem\">tikonApp.orderBag.addItem</span></button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[1].serviceItemId\" type=\"button\" ng-click=\"vm.removeReserveRow()\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"\" translate=\"tikonApp.orderBag.removeItem\">tikonApp.orderBag.addItem</span></button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" name=\"orderbagComment\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBag.comment\"></span></div><div class=\"panel-body\"><!--<input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\"--><!--ng-model=--><!--/>--><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"comment\" placeholder=\"{{\'tikonApp.orderBag.comment\' | translate}}\" ng-model=\"vm.orderBag.comment\"></textarea></div></div></div><div class=\"col-md-6\"><div ng-show=\"vm.computedFinalPrice.finalPrice>=0\" class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></div></div><div class=\"row\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></div></div><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{vm.computedFinalPrice.totalDiscount | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{vm.computedFinalPrice.totalVAT | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--COUPON-CODE--><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.orderBag.couponToCheckValidity\"></div><div class=\"text-success\" ng-if=\"vm.couponResult.resultStatus==\'DONE\'\"><span>کد تخفیف </span>{{vm.couponResult.coupon.couponCode}} <span>با موفقیت اعمال شد</span></div></div><div class=\"col-md-5\"><md-button class=\"md-raised align-bottom\" ng-click=\"vm.checkCouponCode()\" style=\"margin-top: 33px\"><!--<span translate=\"entity.action.backToReserveList\">--><!--entity.action.backToReserveList--><!--</span>--> <span translate=\"tikonApp.orderBag.evaluateCoupon\">couponCode</span></md-button></div></div><div class=\"row\"><br></div><div class=\"row text-success\"><div class=\"col-sm-8 pull-right\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span></div><div class=\"col-sm-4 pull-left\"><div class=\"text-input\">{{vm.computedFinalPrice.finalPrice | number}} <span translate=\"global.currency\"></span></div></div></div></div></div></div></div><div><button type=\"button\" ng-click=\"vm.serviceSelected()\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.formState==\'selectService\'\"><span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span></button> <button type=\"button\" ng-click=\"vm.prev()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span></button></div><div><!--{{vm.orderBag}}--><!--{{vm.orderBag.orderBagServiceItems}}--><!--{{vm.orderBag.orderBagServiceItems[0].orderBagServiceItemDtail}}--></div><!--<div ng-repeat=\"item in vm.orderBag.orderBagServiceItems \">--><!--</div>--></form></div></div><div class=\"pl-modal-footer visible-xs\"><div class=\"row\" style=\"display: flex\"><md-button class=\"col-xs-6 md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.okModal()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button><md-button type=\"button\" class=\"col-xs-6 md-raised md-secondary pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"vm.closeModal()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button></div></div>");
$templateCache.put("app/entities/reserve/new-reserve.html","<style>.alerts > :first-child {\n        position: absolute;\n        display: none;\n    }</style><div class=\"container-fluid\"><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.reserveList\"><span><md-icon>list</md-icon></span><span translate=\"entity.action.backToReserveList\">entity.action.backToReserveList</span></md-button></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><div name=\"customer\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.customerInfo\"></span></div><div class=\"panel-body\"><div name=\"findCustomer\"><div class=\"row\"><div class=\"col-sm-6\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete></div><div class=\"col-sm-6\" style=\"padding-top: 26px\"><!--ng-click=\"vm.addNewCustomer()\"--><md-button type=\"button\" ng-click=\"vm.newCustomer()\" class=\"md-raised md-primary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomer\">New customer</span></md-button><md-button type=\"button\" ng-click=\"vm.newCustomerPopUp()\" class=\"md-raised md-primary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newCustomerPopUp\">newCustomerPopUp</span></md-button></div></div><div class=\"row\" ng-if=\"vm.customerMode == \'new\' || vm.orderBag.customer.personalInfo.fisrtName\"><div class=\"col-md-2\" ng-if=\"vm.isCustomerManager || vm.customerMode == \'new\' \"><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-placeHolder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.phoneNumber\" required autocomplete=\"off\" ng-change=\"vm.searchCustomerByPhoneNumber()\"><div class=\"customer-search-list\" ng-if=\"vm.existCustomerSearchResult && vm.existCustomerSearchResult.length>0\"><div class=\"customer-search-item\" ng-repeat=\"item in vm.existCustomerSearchResult track by item.id\" ng-click=\"vm.selectedCustomerChanged(item)\"><span>{{item.title}}</span> <span style=\"font-size: smaller;color: #95999b\">({{item.description}})</span></div></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"vm.orderBag.customer.personalInfo.fisrtName\" autocomplete=\"off\"><div ng-if=\"form.fisrtName.$dirty && form.fisrtName.$invalid\"><p class=\"help-block\" ng-if=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"vm.orderBag.customer.personalInfo.lastName\" autocomplete=\"off\"><div ng-if=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-if=\"form.lastName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><!--<div class=\"col-md-4\" ng-if=\"vm.customerMode == \'new\'\" >--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" for=\"login\" translate=\"global.form.usernameEnglishCharacter\">Username--><!--</label>--><!--<input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\"--><!--placeholder=\"{{\'global.form.username.placeholder\' | translate}}\"--><!--ng-model=\"vm.orderBag.customer.userAccount.login\" ng-minlength=1 ng-maxlength=50--><!--ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required>--><!--<div ng-if=\"form.login.$dirty && form.login.$invalid\">--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.required\"--><!--translate=\"register.messages.validate.login.required\">--><!--Your username is required.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.minlength\"--><!--translate=\"register.messages.validate.login.minlength\">--><!--Your username is required to be at least 1 character.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.maxlength\"--><!--translate=\"register.messages.validate.login.maxlength\">--><!--Your username cannot be longer than 50 characters.--><!--</p>--><!--<p class=\"help-block\"--><!--ng-if=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">--><!--Your username can only contain lower-case letters and digits.--><!--</p>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"tikonApp.orderBag.customer.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" style=\"direction: ltr\" placeholder=\"{{\'tikonApp.orderBag.customer.email-placeholder\' | translate}}\" ng-model=\"vm.orderBag.customer.personalInfo.email\" ng-minlength=\"5\" ng-maxlength=\"100\" autocomplete=\"off\"><div ng-if=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-if=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-if=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-if=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-if=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div ng-if=\"vm.selectedCustomer\" class=\"row\"><pf-customer-statistics selected-customer-id=\"vm.selectedItem.id\"></pf-customer-statistics></div></div></div></div></div><div data-ng-if=\"vm.formState==\'orderBagItem\'\"><div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div><div class=\"panel-body\"><!--<div ng-if=\"vm.orderBag.orderBagServiceItems[0]\">--><!--{{vm.orderBag.orderBagServiceItems[0].index}}--><!--{{vm.orderBag.orderBagServiceItems[0].serviceTimeSession}}--><!--<pf-reserve-service-item--><!--order-bag-service-item=\"vm.orderBag.orderBagServiceItems[0]\"--><!--default-service-item-id=\"vm.states.serviceItemId\"--><!--default-start-date=\"vm.states.start_date\"--><!--default-end-date=\"vm.states.end_date\"--><!--default-servant-id=\"vm.states.servantId\"--><!--default-service-time-session-id=\"vm.states.timeSessionId\"--><!--&gt;--><!--</pf-reserve-service-item>--><!--</div>--><!--  <div ng-if=\"vm.orderBag.orderBagServiceItems[1]\">\n                              {{vm.orderBag.orderBagServiceItems[1].index}}\n                              {{vm.orderBag.orderBagServiceItems[1].serviceTimeSession}}\n                              <pf-reserve-service-item\n                                  order-bag-service-item=\"vm.orderBag.orderBagServiceItems[1]\" init-mode=\"vm.formMode\"\n                                  default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                  default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                  has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                              >\n                              </pf-reserve-service-item>\n                          </div>\n                          <div ng-if=\"vm.orderBag.orderBagServiceItems[2]\">\n                              {{vm.orderBag.orderBagServiceItems[2].index}}\n                              {{vm.orderBag.orderBagServiceItems[2].serviceTimeSession}}\n                              <pf-reserve-service-item\n                                  order-bag-service-item=\"vm.orderBag.orderBagServiceItems[2]\" init-mode=\"vm.formMode\"\n                                  default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"\n                                  default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\"\n                                  has-multiple-reserve-time=\"vm.hasMultipleReserveTime\"\n                              >\n                              </pf-reserve-service-item>\n                          </div>\n                          <div class=\"btn-group flex-btn-group-container\" style=\"float: right\" >\n                              <button type=\"button\" class=\"btn btn-primary btn-sm\"\n                                      ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\"\n                                      ng-click=\"vm.addReserveRow()\">\n                                  <span class=\"glyphicon glyphicon-plus\"></span>\n                                  <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.add\">entity.action.add</span>\n                              </button>\n\n                          </div>--><div ng-repeat=\"item in vm.orderBag.orderBagServiceItems track by $index\"><div ng-if=\"$index == 0\"><pf-reserve-service-item order-bag-service-item=\"item\" on-item-changed=\"vm.onItemChanged(item)\" on-service-changed=\"vm.onServiceChanged()\" default-service-item-id=\"vm.states.serviceItemId\" default-start-date=\"vm.states.start_date\" default-end-date=\"vm.states.end_date\" default-servant-id=\"vm.states.servantId\" default-service-time-session-id=\"vm.states.timeSessionId\" index-of-orderbag=\"$index\" edit-mode=\"\'NONE\'\"></pf-reserve-service-item></div><div ng-if=\"$index != 0 \"><hr><pf-reserve-service-item order-bag-service-item=\"item\" init-mode=\"vm.formMode\" on-item-changed=\"vm.onItemChanged(item)\" default-servant-id=\"vm.orderBag.orderBagServiceItems[0].servant.id\" has-multiple-reserve-time=\"vm.hasMultipleReserveTime\" index-of-orderbag=\"$index\" edit-mode=\"\'NONE\'\"></pf-reserve-service-item><!--default-service-item-id=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\"--></div><div class=\"btn-group flex-btn-group-container\" style=\"float: right\" ng-if=\"$last\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[0].serviceItemId\" type=\"button\" ng-click=\"vm.addReserveRow()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"\" translate=\"tikonApp.orderBag.addItem\">tikonApp.orderBag.addItem</span></button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.orderBag.orderBagServiceItems[1].serviceItemId\" type=\"button\" ng-click=\"vm.removeReserveRow()\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"\" translate=\"tikonApp.orderBag.removeItem\">tikonApp.orderBag.removeItem</span></button></div></div></div></div></div></div><div name=\"orderbagComment\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBag.comment\"></span></div><div class=\"panel-body\"><!--<input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\"--><!--ng-model=--><!--/>--><textarea class=\"form-control\" rows=\"5\" id=\"comment\" placeholder=\"{{\'tikonApp.orderBag.comment\' | translate}}\" ng-model=\"vm.orderBag.comment\"></textarea></div></div></div><div><button type=\"button\" ng-click=\"vm.serviceSelected()\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.formState==\'selectService\'\"><span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span></button> <button type=\"button\" ng-click=\"vm.prev()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span></button></div><div><!--{{vm.orderBag}}--><!--{{vm.orderBag.orderBagServiceItems}}--><!--{{vm.orderBag.orderBagServiceItems[0].orderBagServiceItemDtail}}--></div><!--<div ng-repeat=\"item in vm.orderBag.orderBagServiceItems \">--><div ng-show=\"vm.computedFinalPrice.totalServicePrice>0\" class=\"panel panel-success\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.computedFinalPrice.totalOptionPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.computedFinalPrice.totalServicePrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.computedFinalPrice.totalVAT | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.computedFinalPrice.totalDiscount | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"></div><div class=\"col-sm-6\"><table class=\"text-success\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{vm.computedFinalPrice.finalPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div></div><hr><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBag.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.orderBag.couponToCheckValidity\"></div><div class=\"text-success\" ng-if=\"vm.couponResult.resultStatus==\'DONE\'\"><span>کد تخفیف </span>{{vm.couponResult.coupon.couponCode}} <span>با موفقیت اعمال شد</span></div></div><div class=\"col-md-5\"><md-button class=\"md-raised align-bottom\" ng-click=\"vm.checkCouponCode()\" style=\"margin-top: 33px\"><!--<span translate=\"entity.action.backToReserveList\">--><!--entity.action.backToReserveList--><!--</span>--> <span translate=\"tikonApp.orderBag.evaluateCoupon\">couponCode</span></md-button></div></div></div></div><!--</div>--></form></div>");
$templateCache.put("app/entities/reserve/reserve-limits.html","<div id=\"container-reserve-limits\"><panel-pln-reserve-limits id=\"reserve-limits\"></panel-pln-reserve-limits></div>");
$templateCache.put("app/entities/reserve/reserve-list-v2.html","<style>.view-intake-data-link {\n        color: #00b09f;\n        cursor: pointer;\n    }\n\n    .serviceColorCircle {\n        width: 17px;\n        height: 17px;\n        border-radius: 50%;\n    }\n\n    #moreFilters_content {\n        display: none;\n    }\n\n    #moreFilters_btn {\n        margin-bottom: 20px;\n        cursor: pointer;\n    }\n\n\n    .filter_by_select > md-select-value > span {\n        display: -webkit-inline-box;\n    }\n\n\n    /*md-select-menu md-option[selected] {*/\n    /*color: white;*/\n    /*background-color: rgb(96, 125, 139);*/\n    /*}*/\n\n    /*md-select-menu md-option[selected]:focus {*/\n    /*color: white;*/\n    /*background-color: rgb(96, 125, 139);*/\n    /*}*/\n\n    /*md-select-menu[multiple] md-option.md-checkbox-enabled .md-container {*/\n    /*background-color: white;*/\n    /*}*/\n\n    /*.search-btn-advanced {*/\n    /*margin-top: 25px;*/\n    /*border-radius: 50%;*/\n    /*min-width: unset;*/\n    /*width: 40px;*/\n    /*color: #2b6b7f !important;*/\n    /*}*/\n\n    /*.search-btn-advanced {*/\n    /*width: 90%;*/\n    /*border-radius: 4px;*/\n    /*margin-top: 24px;*/\n    /*}*/\n\n    .rwTable {\n        font-size: small;\n    }\n\n    .rwTable tr td {\n        max-width: 185px;\n        word-wrap: break-word;\n    }\n\n    .inline-divs > div {\n        display: inline;\n    }\n\n    .check-out-ok {\n        background-color: #3fb53f2e;\n        color: #004c00;\n        padding: 2px 4px;\n        /* border: 1px solid #004c00; */\n        border-radius: 4px;\n        text-align: center;\n        font-size: 10px;\n        /* max-width: fit-content; */\n        display: unset;\n    }\n\n    .check-out-nok {\n        background-color: #ffe2e7;\n        color: #bd0101;\n        padding: 2px 4px;\n        /* border: 1px solid #004c00; */\n        border-radius: 4px;\n        text-align: center;\n        font-size: 10px;\n        /* max-width: fit-content; */\n        display: unset;\n    }\n\n    .customer-name-link {\n        color: rgba(0, 0, 0, 0.87);\n    }\n\n    .orderbag-tags {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    .orderbag-tags span {\n        background-color: #d7d7d7;\n        color: #000;\n        border-radius: 8px;\n        padding: 4px;\n        font-size: 10px;\n    }\n        @media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span translate=\"supplierPanel.sideMenu.orderBagList\">supplierPanel.sideMenu.orderBagList</span><div class=\"education-link\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body pl-panel-body\"><eo-progress-bar></eo-progress-bar><jhi-alert></jhi-alert><!--<div class=\"container-fluid\">--><div class=\"col-xs-12\"><div class=\"row\"><div class=\"pull-right\"><!--<div class=\"col-md-3 col-sm-6 no-padding-left\">--><md-button class=\"md-raised md-primary pl-btn-primary pl-btn\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ng-click=\"vm.newReserve()\" ng-disabled=\"!vm.hasSubscription\"><!-- <span class=\"glyphicon glyphicon-plus\"></span> --><md-icon>add</md-icon><span class=\"hidden-xs\" translate=\"tikonApp.orderBag.home.createLabel\">Create new Order Bag Service Item</span></md-button></div><!--<div class=\"pull-right\">--><!--&lt;!&ndash;<md-button class=\"md-raised md-secondary\" ng-click=\"vm.showDateSearch()\"&ndash;&gt;--><!--<div id=\"moreFilters_btn\">--><!--<md-button class=\"md-raised md-secondary\"--><!--style=\"height: 37px;\">--><!--<i class=\"material-icons\" style=\"top: 10px; position: relative;\">--><!--search--><!--</i>+--><!--{{\'tikonApp.orderBag.advancedSearch\' | translate}}--><!--</md-button>--><!--</div>--><!--</div>--></div></div><div><div class=\"form-field-description\" style=\"padding-bottom: 10px\"><span>* برای اعمال فیلتر (جستجوی پیشرفته) گزینه </span><span><md-icon>filter_list</md-icon></span><span>را انتخاب کنید.</span></div><!--<div id=\"moreFilters_btn\">--><!--<a><i class=\"material-icons\">add</i>--><!--{{\'tikonApp.orderBag.advancedSearch\' | translate}}--><!--</a>--><!--</div>--><!--<div id=\"moreFilters_content\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-3 col-md-3 col-lg-3\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label>--><!--<eo-date-picker id=\"field_fromDateFilter\"--><!--date-value=\"vm.filterQuery.fromDate\"></eo-date-picker>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-3 col-md-3 col-lg-3\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label>--><!--<eo-date-picker id=\"field_toDateFilter\"--><!--date-value=\"vm.filterQuery.toDate\"></eo-date-picker>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-3 col-md-2\">--><!--<div class=\"form-group\">--><!--<md-button id=\"search-btn-advanced\"--><!--class=\"md-raised md-secondary search-btn-advanced\"--><!--ng-disabled=\"vm.isSearching\"--><!--ng-click=\"vm.advancedSearch()\">--><!--<i class=\"material-icons\"--><!--style=\"top: 9px; right: -2px; position: relative;\">--><!--search--><!--</i>--><!--<span> جستجو </span>--><!--</md-button>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"col-sm-6\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBagServiceItem.filterStatus\">Status</label>--><!--<md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" id =\"field_filterStatus\"--><!--placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\"--><!--ng-model=\"vm.filterQuery.status\"--><!--style=\"min-width: 100px;\">--><!--&lt;!&ndash;<md-option value=\"0\" translate=\"tikonApp.orderBagServiceItem.showAll\">&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--&lt;!&ndash;<md-option value=\"1\" translate=\"tikonApp.orderBag.status.1\">&ndash;&gt;--><!--&lt;!&ndash;CONFIRMED&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--&lt;!&ndash;<md-option value=\"4\" translate=\"tikonApp.orderBag.status.4\">&ndash;&gt;--><!--&lt;!&ndash;CANCELED&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--&lt;!&ndash;<md-option value=\"5\" translate=\"tikonApp.orderBag.status.5\">&ndash;&gt;--><!--&lt;!&ndash;RESERVE_REQUEST&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--&lt;!&ndash;<md-option value=\"6\" translate=\"tikonApp.orderBag.status.6\">&ndash;&gt;--><!--&lt;!&ndash;REQUEST_CONFIRMED&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--<md-option ng-value=\"si\" ng-repeat=\"si in vm.statusList\">--><!--{{\"tikonApp.orderBag.status.\"+si | translate}}--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<div class=\"form-group\">--><!--<label--><!--translate=\"tikonApp.orderBagServiceItem.filterServiceItem\">ServiceItem</label>--><!--<md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\"--><!--placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\"--><!--ng-model=\"vm.filterQuery.serviceItemIds\"--><!--style=\"min-width: 100px;\">--><!--&lt;!&ndash;<md-option value=\"0\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--<md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceItems\">--><!--<small--><!--ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\"--><!--style=\"color: #a2a2a2;\">{{si.category.categoryName}} - --><!--</small>--><!--{{si.itemTitle}}--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"col-sm-6\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBagServiceItem.filterServant\">servant</label>--><!--<md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\"--><!--placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\"--><!--ng-model=\"vm.filterQuery.servantIds\"--><!--style=\"min-width: 100px;\">--><!--&lt;!&ndash;<md-option value=\"0\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>&ndash;&gt;--><!--&lt;!&ndash;</md-option>&ndash;&gt;--><!--<md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servants\">--><!--{{si.servantName}}--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBagServiceItem.home.search\">servant</label>--><!--<input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\"--><!--ng-model=\"vm.filterQuery.orderBagId\"--><!--placeholder=\"{{ \'tikonApp.orderBagServiceItem.filterOrderBagId\' | translate }}\"--><!--type=\"text\"/>--><!--</div>--><!--</div>--><!--</div>--><!--<hr>--><!--</div>--><div class=\"row topOfList\" style=\"display: flex; align-items: center\"><div class=\"col-sm-10\"><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.orderBag.home.searchPlaceHolder\'\" on-search=\"vm.filterOrderBag_Global()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.pageSize\">pageSize</label><md-select class=\"rwMdSelect\" id=\"field_pageSize\" ng-model=\"vm.pageSize\" ng-change=\"vm.pageSizeChanged()\" style=\"min-width: 100px;margin-bottom: 5px !important\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.pageSizeList\">{{si}}</md-option></md-select></div></div></div><div style=\"overflow-x: auto\"><table st-safe-src=\"vm.orderBagServiceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr class=\"pl-table-header\"><th st-sort=\"orderBagId\" style=\"min-width: 104px\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"serviceItemTitle\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.orderBag.status.title\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.reserveType\">Reserve Type</span></th><th><span translate=\"tikonApp.orderBag.number\">number</span></th><th><span translate=\"tikonApp.orderBag.detailedDescription\">detailedDescription</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><!--<a ng-click=\"vm.editReserve(orderBagServiceItem)\">{{orderBagServiceItem.orderBag.id}}</a>--> <a ui-sref=\"supplierPanel-v2.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.startVideoCall\' | translate}}</md-tooltip><a ng-click=\"vm.goToVideoCall(orderBagServiceItem)\"><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a></div></td><td style=\"padding: 0\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"serviceColorCircle\"></div></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div><!--</div>--></td><td><!-- <a class=\"customer-name-link\"\n                                       ng-click=\"vm.goToCustomerDetailV2(orderBagServiceItem.orderBag.customer.id)\">\n                                        <i has-authority=\"ROLE_CUSTOMER_MANAGER\" class=\"fa fa-pencil\"\n                                           aria-hidden=\"true\"></i>\n                                        <span>\n                                                {{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}}\n                                                {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}\n                                            </span>\n\n                                    </a> --> <span class=\"customer-name-link\" ng-click=\"vm.goToCustomerDetailV3(orderBagServiceItem.orderBag.customer.id)\"><i has-authority=\"ROLE_CUSTOMER_MANAGER\" class=\"fa fa-pencil\" aria-hidden=\"true\"></i> <span>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</span></span><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></td><td ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</td><td>{{orderBagServiceItem.orderBag.finalPrice | number}} <span ng-if=\"orderBagServiceItem.orderBag.invoiceInfo.issueType\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.hasInvoiceInfo\' | translate}}</md-tooltip><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i></span><div ng-if=\"orderBagServiceItem.orderBag.finalPrice\"><div class=\"check-out-ok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount==0.0\">{{\'tikonApp.orderBag.CheckOut-Ok\' | translate }}</div><div class=\"check-out-nok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount > 0\">{{\'tikonApp.orderBag.CheckOut-NOk\' | translate }}</div></div></td><td><div>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}}</div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startTime\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td><td class=\"inline-divs\"><!--{{vm.reserveGatewayToPersian(orderBagServiceItem.orderBag.reserveGateway)}}--><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway !== \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.online\' | translate}}</md-tooltip><i class=\"fa fa-internet-explorer\" aria-hidden=\"true\"></i></div><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway == \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.panel\' | translate}}</md-tooltip><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.hasSomePayment\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.paymentLogs\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i></div></td><td class=\"text-center\"><span ng-if=\"orderBagServiceItem.orderBagServiceItemDtail[0]\">{{orderBagServiceItem.orderBagServiceItemDtail[0].gty}} </span><span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.checkedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: green\">alarm_on</i> </span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.notcheckedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'NOT_CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: red\">alarm_off</i></span></span></td><td><span class=\"view-intake-data-link\" data-ng-click=\"vm.showIntakeData(orderBagServiceItem.orderBag)\" ng-if=\"orderBagServiceItem.orderBag.intakeData\"><i class=\"fa fa-clone\"></i> مشاهده</span><div class=\"orderbag-tags\" ng-if=\"orderBagServiceItem.orderBag.tags && orderBagServiceItem.orderBag.tags.length\"><span ng-if=\"orderBagServiceItem.orderBag.tags[0]\">{{orderBagServiceItem.orderBag.tags[0].tag}}</span> <span ng-if=\"orderBagServiceItem.orderBag.tags[1]\">{{orderBagServiceItem.orderBag.tags[1].tag}}</span> <span ng-if=\"orderBagServiceItem.orderBag.tags.length > 2\">+{{orderBagServiceItem.orderBag.tags.length-2}}</span></div></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editReserve(orderBagServiceItem)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.pageSize\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\"></uib-pagination></div></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" on-click=\"vm.newReserve()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 service-item-title-container\"><h3 translate=\"tikonApp.orderBag.orderBagList\">title-list</h3></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.orderBag.home.searchPlaceHolder\'\" on-search=\"vm.filterOrderBag_Global()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box><div class=\"customer-list-item\" ng-repeat=\"orderBagServiceItem in vm.orderBagServiceItems track by orderBagServiceItem.id\" ng-click=\"vm.editReserve(orderBagServiceItem)\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"service-color-line\"></div><div class=\"reserve-list-item-detail\"><div><div class=\"reserve-list-icons\"><div class=\"\" style=\"font-weight: bold;font-size: 12px\">{{orderBagServiceItem.orderBag.id}}</div><div class=\"service-list-icons-video\" style=\"align-items: initial\"><span ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\" class=\"glyphicon glyphicon-stop\"></span> <span style=\"font-size: 12px;font-weight: bold\">{{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</span></div><!--<div ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\">--><!--</div>--><div class=\"reserve-list-icons-payment-status\" ng-if=\"orderBagServiceItem.orderBag.finalPrice\"><span class=\"check-out-ok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount==0.0\">{{\'tikonApp.orderBag.CheckOut-Ok\' | translate }}</span><div class=\"reserve-list-check-out-nok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount > 0\">{{\'tikonApp.orderBag.CheckOut-NOk\' | translate }}</div></div><div ng-if=\"orderBagServiceItem.orderBag.invoiceInfo.issueType\"><i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i></div><!--<div class=\"view-intake-data-link\"--><!--ng-if=\"orderBagServiceItem.orderBag.intakeData\">--><!--<md-icon class=\"pl-icon\">description</md-icon>--><!--</div>--></div></div><div class=\"\" name=\"customerInfo\"><div class=\"reserve-list-customer-info\"><div><md-icon class=\"pl-icon\">person</md-icon>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</div><!--<div class=\"reserve-list-customer-contacts\" has-authority=\"ROLE_CUSTOMER_MANAGER\">--><!--&lt;!&ndash;<i class=\"fa fa-phone\"></i>&ndash;&gt;--><!--&lt;!&ndash;<div>{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div>&ndash;&gt;--><!--&lt;!&ndash;<div>{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div>&ndash;&gt;--><!--</div>--></div></div><div class=\"\" name=\"dateTimeInfo\"><div style=\"display: flex;gap:10px\"><div class=\"\" style=\"font-weight: bold\"><md-icon class=\"pl-icon\">event</md-icon><span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianDate}} - </span>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}} <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\"><!--<div>--><!--{{vm.getMonthCount(orderBagServiceItem)}}--><!--(ماه)--><!--</div>--></span></div><div class=\"\" style=\"font-weight: bold\" ng-if=\"orderBagServiceItem.serviceTimeSession.startDate == orderBagServiceItem.serviceTimeSession.endDate\"><md-icon class=\"pl-icon\">schedule</md-icon>{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></div></div><div class=\"\" name=\"serviceInfo\" style=\"display: flex\"><div><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: black\">videocam</md-icon></div><div class=\"\" style=\"padding-right: 5px\">{{orderBagServiceItem.serviceItem.itemTitle}}</div><div class=\"\" ng-if=\"orderBagServiceItem.servant\" style=\"padding-right: 24px;  font-size: 12px\">{{orderBagServiceItem.servant.servantName}}</div><!--<div class=\"orderBag-mobile-float\">--><!--{{orderBagServiceItem.orderBag.finalPrice | number}}--><!--<span translate=\"global.currency\"></span>--><!--</div>--></div><div class=\"orderbag-tags\" ng-if=\"orderBagServiceItem.orderBag.tags && orderBagServiceItem.orderBag.tags.length\"><span ng-if=\"orderBagServiceItem.orderBag.tags[0]\">{{orderBagServiceItem.orderBag.tags[0].tag}}</span> <span ng-if=\"orderBagServiceItem.orderBag.tags[1]\">{{orderBagServiceItem.orderBag.tags[1].tag}}</span> <span ng-if=\"orderBagServiceItem.orderBag.tags.length > 2\">+{{orderBagServiceItem.orderBag.tags.length-2}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"4\" items-per-page=\"vm.pageSize\"></uib-pagination></div></div><script>// $(document).ready(function () {\n    //     $(\"#moreFilters_btn\").click(function () {\n    //         $(\"#moreFilters_content\").slideToggle();\n    //\n    //         if ($(\"#moreFilters_btn i.material-icons\").html() == \'add\') {\n    //             $(\"#moreFilters_btn i.material-icons\").html(\'remove\');\n    //         } else {\n    //             $(\"#moreFilters_btn i.material-icons\").html(\'add\');\n    //         }\n    //\n    //     });\n    // });</script>");
$templateCache.put("app/entities/reserve/reserve-list.html","<style>.view-intake-data-link {\n        color: #00b09f;\n        cursor: pointer;\n    }\n\n    .serviceColorCircle {\n        width: 17px;\n        height: 17px;\n        border-radius: 50%;\n    }\n\n    #moreFilters_content {\n        display: none;\n    }\n\n    #moreFilters_btn {\n        margin-bottom: 20px;\n        cursor: pointer;\n    }\n\n\n    .filter_by_select > md-select-value > span {\n        display: -webkit-inline-box;\n    }\n\n\n    md-select-menu md-option[selected] {\n        color: white;\n        background-color: rgb(96, 125, 139);\n    }\n\n    md-select-menu md-option[selected]:focus {\n        color: white;\n        background-color: rgb(96, 125, 139);\n    }\n\n    md-select-menu[multiple] md-option.md-checkbox-enabled .md-container {\n        background-color: white;\n    }\n\n    .search-btn, .search-btn-advanced {\n        margin-top: 25px;\n        border-radius: 50%;\n        min-width: unset;\n        width: 40px;\n        color: #2b6b7f !important;\n    }\n\n    .search-btn-advanced {\n        width: 90%;\n        border-radius: 4px;\n        margin-top: 24px;\n    }\n\n    .rwTable {\n        font-size: small;\n    }\n\n    .rwTable tr td {\n        max-width: 185px;\n        word-wrap: break-word;\n    }\n\n    .inline-divs > div {\n        display: inline;\n    }\n\n    .check-out-ok {\n        background-color: #d9ffd9;\n        color: #004c00;\n        padding: 2px 4px;\n        /* border: 1px solid #004c00; */\n        border-radius: 4px;\n        text-align: center;\n        font-size: 10px;\n        /* max-width: fit-content; */\n        display: unset;\n    }\n\n    .check-out-nok {\n        background-color: #ffe2e7;\n        color: #bd0101;\n        padding: 2px 4px;\n        /* border: 1px solid #004c00; */\n        border-radius: 4px;\n        text-align: center;\n        font-size: 10px;\n        /* max-width: fit-content; */\n        display: unset;\n    }\n\n    .customer-name-link {\n        color: rgba(0, 0, 0, 0.87);\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.orderBagList\">supplierPanel.sideMenu.orderBagList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><!--<div class=\"container-fluid\">--><div class=\"col-xs-12\"><div class=\"row\"><div class=\"pull-right\"><!--<div class=\"col-md-3 col-sm-6 no-padding-left\">--><md-button class=\"md-raised md-primary\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" ui-sref=\"supplierPanel.reserve_v2\" ng-disabled=\"!vm.hasSubscription\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBag.home.createLabel\">Create new Order Bag Service Item</span></md-button></div><!--<div class=\"pull-right\">--><!--&lt;!&ndash;<md-button class=\"md-raised md-secondary\" ng-click=\"vm.showDateSearch()\"&ndash;&gt;--><!--<div id=\"moreFilters_btn\">--><!--<md-button class=\"md-raised md-secondary\"--><!--style=\"height: 37px;\">--><!--<i class=\"material-icons\" style=\"top: 10px; position: relative;\">--><!--search--><!--</i>+--><!--{{\'tikonApp.orderBag.advancedSearch\' | translate}}--><!--</md-button>--><!--</div>--><!--</div>--></div></div><md-content class=\"rwMdContent\"><div id=\"moreFilters_btn\"><a><i class=\"material-icons\">add</i> {{\'tikonApp.orderBag.advancedSearch\' | translate}}</a></div><div id=\"moreFilters_content\"><div class=\"row\"><div class=\"col-sm-3 col-md-3 col-lg-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.filterQuery.fromDate\"></eo-date-picker></div></div><div class=\"col-sm-3 col-md-3 col-lg-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.filterQuery.toDate\"></eo-date-picker></div></div><div class=\"col-sm-3 col-md-2\"><div class=\"form-group\"><md-button id=\"search-btn-advanced\" class=\"md-raised md-secondary search-btn-advanced\" ng-click=\"vm.advancedSearch()\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search </i><span>جستجو</span></md-button></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\">Status</label><md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" id=\"field_filterStatus\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.filterQuery.status\" style=\"min-width: 100px\"><!--<md-option value=\"0\" translate=\"tikonApp.orderBagServiceItem.showAll\">--><!--</md-option>--><!--<md-option value=\"1\" translate=\"tikonApp.orderBag.status.1\">--><!--CONFIRMED--><!--</md-option>--><!--<md-option value=\"4\" translate=\"tikonApp.orderBag.status.4\">--><!--CANCELED--><!--</md-option>--><!--<md-option value=\"5\" translate=\"tikonApp.orderBag.status.5\">--><!--RESERVE_REQUEST--><!--</md-option>--><!--<md-option value=\"6\" translate=\"tikonApp.orderBag.status.6\">--><!--REQUEST_CONFIRMED--><!--</md-option>--><md-option ng-value=\"si\" ng-repeat=\"si in vm.statusList\">{{\"tikonApp.orderBag.status.\"+si | translate}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\">ServiceItem</label><md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.filterQuery.serviceItemIds\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceItems\"><small ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} - </small>{{si.itemTitle}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServant\">servant</label><md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.filterQuery.servantIds\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servants\">{{si.servantName}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.home.search\">servant</label><input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.filterQuery.orderBagId\" placeholder=\"{{ \'tikonApp.orderBagServiceItem.filterOrderBagId\' | translate }}\" type=\"text\"></div></div></div><hr></div><div class=\"row topOfList\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.home.search\">servant</label><input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.filterQuery.searchText\" placeholder=\"{{ \'tikonApp.orderBag.home.publicSearch\' | translate }}\" type=\"text\" ng-keypress=\"vm.searchKeyPress($event)\"></div></div><div class=\"col-sm-4\"><md-button id=\"search-btn\" class=\"md-raised md-secondary search-btn\" ng-click=\"vm.filterOrderBag_Global()\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.pageSize\">pageSize</label><md-select class=\"rwMdSelect\" id=\"field_pageSize\" ng-model=\"vm.pageSize\" ng-change=\"vm.pageSizeChanged()\" style=\"min-width: 100px\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.pageSizeList\">{{si}}</md-option></md-select></div></div></div><div><table st-safe-src=\"vm.orderBagServiceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th st-sort=\"orderBagId\" style=\"min-width: 104px\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"serviceItemTitle\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.orderBag.status.title\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.reserveType\">Reserve Type</span></th><th><span translate=\"tikonApp.orderBag.number\">number</span></th><th><span translate=\"tikonApp.orderBag.detailedDescription\">detailedDescription</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.startVideoCall\' | translate}}</md-tooltip><a ng-if=\"vm.__config.appMode==\'reserve\'\" ng-click=\"vm.goToVideoCall(orderBagServiceItem)\"><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a><a ng-if=\"vm.__config.appMode==\'event\'\" ng-click=\"vm.goToVideoCallEvent(orderBagServiceItem)\"><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a></div></td><td style=\"padding: 0\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"serviceColorCircle\"></div></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div><!--</div>--></td><td><a class=\"customer-name-link\" ng-click=\"vm.goToCustomerDetail(orderBagServiceItem.orderBag.customer.id)\"><i has-authority=\"ROLE_CUSTOMER_MANAGER\" class=\"fa fa-pencil\" aria-hidden=\"true\"></i> <span>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</span></a><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></td><td ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</td><td>{{orderBagServiceItem.orderBag.finalPrice | number}}<div ng-if=\"orderBagServiceItem.orderBag.finalPrice\"><div class=\"check-out-ok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount==0.0\">{{\'tikonApp.orderBag.CheckOut-Ok\' | translate }}</div><div class=\"check-out-nok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount > 0\">{{\'tikonApp.orderBag.CheckOut-NOk\' | translate }}</div></div></td><td><div>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}}</div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startTime\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td><td class=\"inline-divs\"><!--{{vm.reserveGatewayToPersian(orderBagServiceItem.orderBag.reserveGateway)}}--><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway !== \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.online\' | translate}}</md-tooltip><i class=\"fa fa-internet-explorer\" aria-hidden=\"true\"></i></div><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway == \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.panel\' | translate}}</md-tooltip><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.hasSomePayment\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.paymentLogs\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i></div></td><td class=\"text-center\"><span ng-if=\"orderBagServiceItem.orderBagServiceItemDtail[0]\">{{orderBagServiceItem.orderBagServiceItemDtail[0].gty}} </span><span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.checkedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: green\">alarm_on</i> </span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.notcheckedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'NOT_CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: red\">alarm_off</i></span></span></td><td><span class=\"view-intake-data-link\" data-ng-click=\"vm.showIntakeData(orderBagServiceItem.orderBag)\" ng-if=\"orderBagServiceItem.orderBag.intakeData\"><i class=\"fa fa-clone\"></i> مشاهده</span></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.pageSize\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\"></uib-pagination></div></md-content></div></div></div></div></div><div class=\"visible-xs\"><div class=\"\"><div class=\"row\"><div class=\"col-xs-8\"><h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.orderBag.orderBagList\">tikonApp.orderBag.orderBagList</h3></div><div class=\"col-xs-3\" style=\"margin-right: -7px\"><md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.reserve_v2\" ng-disabled=\"vm.subscriptionExpired\"><i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i></md-button></div></div><div class=\"row\"><div class=\"\"><div class=\"\"><jhi-alert></jhi-alert><!--<md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.reserve_v2\" ng-disabled=\"vm.subscriptionExpired\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!--</md-button>--><md-content class=\"rwMdContent\"><!--<div class=\"float-mobile-button\" ui-sref=\"supplierPanel.reserve_v2\"--><!--has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" class=\"btn btn-primary\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!----><!--</div>--><div style=\"text-align: left ;color: #00acc1;padding-top: 20px;padding-left: 6px\"><span translate=\"tikonApp.orderBag.searchFilter\" ng-click=\"vm.showSearchBoxOnMobile()\">Search</span> <i class=\"fa fa-filter\"></i></div><div ng-if=\"vm.searchBoxOnMobile\"><!--<div class=\"row\">--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label>--><!--<eo-date-picker id=\"field_fromDateFilter\"--><!--date-value=\"vm.fromDateFilter\"></eo-date-picker>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label>--><!--<eo-date-picker id=\"field_toDateFilter\"--><!--date-value=\"vm.toDateFilter\"></eo-date-picker>--><!--</div>--><!--</div>--><!--<div class=\"col-xs-4\" style=\"padding-top: 20px\">--><!--<md-button class=\"btn btn-primary\" ng-click=\"vm.searchOrderBag()\">--><!--<span class=\"glyphicon glyphicon-search\"></span>--><!--</md-button>--><!--</div>--><!--</div>--><div id=\"moreFilters_content_mobile\"><div class=\"row\"><div class=\"col-xs-6 col-sm-5 col-md-4 col-lg-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter_mobile\" date-value=\"vm.filterQuery.fromDate\"></eo-date-picker></div></div><div class=\"col-xs-6 col-sm-5 col-md-4 col-lg-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter_mobile\" date-value=\"vm.filterQuery.toDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\">Status</label><md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.filterQuery.status\" style=\"min-width: 100px\"><!--<md-option value=\"0\" translate=\"tikonApp.orderBagServiceItem.showAll\">--><!--</md-option>--><!--<md-option value=\"1\" translate=\"tikonApp.orderBag.status.1\">--><!--CONFIRMED--><!--</md-option>--><!--<md-option value=\"4\" translate=\"tikonApp.orderBag.status.4\">--><!--CANCELED--><!--</md-option>--><!--<md-option value=\"5\" translate=\"tikonApp.orderBag.status.5\">--><!--RESERVE_REQUEST--><!--</md-option>--><!--<md-option value=\"6\" translate=\"tikonApp.orderBag.status.6\">--><!--REQUEST_CONFIRMED--><!--</md-option>--><md-option ng-value=\"si\" ng-repeat=\"si in vm.statusList\">{{\"tikonApp.orderBag.status.\"+si | translate}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\">ServiceItem</label><md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.filterQuery.serviceItemIds\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.serviceItems\"><small ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} - </small>{{si.itemTitle}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServant\">servant</label><md-select class=\"rwMdSelect filter_by_select\" multiple=\"true\" id=\"filter_by_servant\" placeholder=\"{{\'tikonApp.orderBagServiceItem.showAll\' | translate}}\" ng-model=\"vm.filterQuery.servantIds\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servants\">{{si.servantName}}</md-option></md-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.home.search\">servant</label><input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.filterQuery.orderBagId\" placeholder=\"{{ \'tikonApp.orderBagServiceItem.filterOrderBagId\' | translate }}\" type=\"text\"></div></div><div class=\"col-sm-2 col-md-4\"><md-button class=\"btn btn-primary\" ng-click=\"vm.advancedSearch()\"><span class=\"glyphicon glyphicon-search\"></span></md-button></div></div><hr></div></div><div class=\"row topOfListMobile\"><div ng-click=\"vm.showSearchTextBoxOnMobile()\" style=\"text-align: left ;color: #00acc1;padding-top: 10px;padding-left: 20px\"><span translate=\"tikonApp.orderBag.home.search\">Search</span> <i class=\"fa fa-search\"></i></div></div><div ng-if=\"vm.searchTextBoxOnMobile\"><div class=\"row\" style=\"margin: auto\"><div class=\"col-sm-4 col-xs-8\" style=\"padding-top: 9px\"><div class=\"form-group\"><input type=\"text\" class=\"form-control rwTableSearchBox\" id=\"searchQuery\" name=\"searchQuery\" ng-model=\"vm.filterQuery.searchText\" placeholder=\"{{ \'tikonApp.orderBag.home.search\' | translate }}\"></div></div><div class=\"col-xs-4\"><md-button class=\"btn btn-primary\" ng-click=\"vm.filterOrderBag_Global()\"><span class=\"glyphicon glyphicon-search\"></span></md-button></div></div></div><div class=\"orderBag-mobile-block\" ng-repeat=\"orderBagServiceItem in vm.orderBagServiceItems track by orderBagServiceItem.id\" ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\"><div class=\"row\" name=\"serviceInfo\"><div class=\"orderBag-mobile-float\"><a ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a></div><div class=\"orderBag-mobile-float\"><div ng-class=\"vm.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{vm.findStatusTitle(orderBagServiceItem.orderBag.status)}}</div></div><div class=\"orderBag-mobile-float\"><a ng-click=\"vm.goToVideoCall(orderBagServiceItem)\"><md-icon ng-if=\"orderBagServiceItem.serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon></a></div></div><div class=\"row\" name=\"serviceInfo\"><div class=\"orderBag-mobile-float\">{{orderBagServiceItem.serviceItem.itemTitle}}</div><div class=\"orderBag-mobile-float\">{{orderBagServiceItem.orderBag.finalPrice | number}} <span translate=\"global.currency\"></span></div><div class=\"orderBag-mobile-float\" ng-if=\"orderBagServiceItem.orderBag.finalPrice\"><span class=\"check-out-ok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount==0.0\">{{\'tikonApp.orderBag.CheckOut-Ok\' | translate }} </span><span class=\"check-out-nok\" ng-if=\"orderBagServiceItem.orderBag.remainAmount > 0\">{{\'tikonApp.orderBag.CheckOut-NOk\' | translate }}</span></div></div><div class=\"row\" name=\"dateTimeInfo\"><div><div class=\"orderBag-mobile-float\"><i class=\"fa fa-calendar\"></i> <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianDate}} - </span>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}} <span ng-if=\"orderBagServiceItem.serviceTimeSession.startDate != orderBagServiceItem.serviceTimeSession.endDate\"><!--<div>--><!--{{vm.getMonthCount(orderBagServiceItem)}}--><!--(ماه)--><!--</div>--></span></div><div class=\"orderBag-mobile-float\" ng-if=\"orderBagServiceItem.serviceTimeSession.startDate == orderBagServiceItem.serviceTimeSession.endDate\"><i class=\"fa fa-clock-o\"></i> {{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></div></div><div class=\"row\" name=\"customerInfo\"><div class=\"orderBag-mobile-float\"><i class=\"glyphicon glyphicon-user\"></i> {{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}</div><div class=\"orderBag-mobile-float\" has-authority=\"ROLE_CUSTOMER_MANAGER\"><i class=\"fa fa-phone\"></i> {{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></div><div style=\"text-align: left\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button></div></div></div></md-content></div></div></div></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.pageSize\"></jhi-item-count><ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" items-per-page=\"vm.pageSize\"></ul><!--<pagination total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" --><!--class=\"pagination-sm\" items-per-page=\"vm.pageSize\"></pagination>--></div></div><script>$(document).ready(function () {\n        $(\"#moreFilters_btn\").click(function () {\n            $(\"#moreFilters_content\").slideToggle();\n\n            if ($(\"#moreFilters_btn i.material-icons\").html() == \'add\') {\n                $(\"#moreFilters_btn i.material-icons\").html(\'remove\');\n            } else {\n                $(\"#moreFilters_btn i.material-icons\").html(\'add\');\n            }\n\n        });\n    });</script>");
$templateCache.put("app/entities/reserve-limit/reserve-limit-delete-dialog-v2.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.reserveLimit.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.reserveLimit.delete.question\" translate-values=\"{itemTitle: \'{{vm.reserveLimit.itemTitle}}\'}\">Are you sure you want to delete this Service Item?</p></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></md-button></div></form>");
$templateCache.put("app/entities/reserve-limit/reserve-limit-v2.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }\n\n    .service-schedule-block {\n        border-bottom: solid 1px #ff9d1a;\n    }</style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.reserveLimit && vm.reserveLimit.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\">{{vm.reserveLimit.title}}</div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.deleteReserveLimit({id:vm.reserveLimit.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span style=\"display: inline-block\">{{vm.getModalTitle() | translate}}</span></div><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><form name=\"editForm\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.reserveLimit.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.reserveLimit.title\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.reserveLimit.status\" for=\"field_status\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.reserveLimit.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.reserveLimitStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.reserveLimitStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required=\"\" translate=\"tikonApp.reserveLimit.limitCount\" for=\"field_limitCount\">limitCount</label><!--<input type=\"number\" class=\"form-control\" name=\"limitCount\"--><!--id=\"field_limitCount\"--><!--ng-model=\"vm.reserveLimit.limitCount\" min=\"0\"--><!--/>--><eo-numeric-input id=\"field_limitCount\" name=\"limitCount\" custom-class=\"form-control\" input-value=\"vm.reserveLimit.limitCount\" is-required=\"true\" form-reference=\"editForm\"></eo-numeric-input></div></div><!--<div class=\"col-md-3\" style=\"margin-top: 19px;\">--><!--<div class=\"form-group\">--><!--<div class=\"rw-radioBtn\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"vm.hasDayCount\"--><!--aria-label=\"Switch 1\"--><!--ng-change=\"vm.dayCount_switch_changed()\">--><!--<span translate=\"tikonApp.reserveLimit.hasDayCount\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.reserveLimit.limitPeriod\" for=\"field_limitPeriod\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.reserveLimit.limitPeriod\" style=\"min-width: 250px;margin-top: 6px\" ng-change=\"vm.limitPeriod_changed()\" id=\"field_limitPeriod\"><md-option value=\"ALL_TIME\" translate=\"tikonApp.reserveLimitPeriod.ALL_TIME\">ALL_TIME</md-option><md-option value=\"DAY\" translate=\"tikonApp.reserveLimitPeriod.DAY\">DAY</md-option><md-option value=\"WEEK\" translate=\"tikonApp.reserveLimitPeriod.WEEK\">WEEK</md-option><md-option value=\"MONTH\" translate=\"tikonApp.reserveLimitPeriod.MONTH\">MONTH</md-option><md-option value=\"DAY_LATER\" translate=\"tikonApp.reserveLimitPeriod.DAY_LATER\">DAY_LATER</md-option></md-select></div></div><div class=\"col-md-4\" ng-if=\"vm.hasDayCount\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.reserveLimit.dayCount\" for=\"field_dayCount\" eo-help-tooltip=\"tips.reserve_limit_day_count\">dayCount</label><!--<input type=\"number\" class=\"form-control\" name=\"dayCount\" id=\"field_dayCount\"--><!--ng-model=\"vm.reserveLimit.dayCount\" min=\"0\"--><!--/>--><eo-numeric-input id=\"field_dayCount\" name=\"dayCount\" custom-class=\"form-control\" input-value=\"vm.reserveLimit.dayCount\" form-reference=\"editForm\"></eo-numeric-input><!--<div class=\"form-field-description\"--><!--translate=\"tikonApp.reserveLimit.fieldsDescription.dayCount\">--><!--</div>--></div></div></div><div id=\"nationalCode\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.basedOnNationalCodeSwitch\" aria-label=\"Switch 1\" ng-change=\"vm.basedOnNationalCode_changed()\"><span translate=\"tikonApp.reserveLimit.basedOnNationalCode\"></span></md-switch></div></div></div></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllServices\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.reserveLimit.forAllServices\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllServices\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.reserveLimit.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"serviceItem in vm.allServiceItems\"><md-checkbox ng-model=\"serviceItem.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.serviceCheckChange(serviceItem)\">{{serviceItem.itemTitle}}</md-checkbox></div></fieldset></div></div><div id=\"customerGroups\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllCustomerGroups\" aria-label=\"Switch 1\" ng-change=\"vm.switch_customerGroup_changed()\"><span translate=\"tikonApp.reserveLimit.forAllCustomerGroups\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllCustomerGroups\"><fieldset class=\"standard-fieldset\"><legend>انتخاب گروه مشتری برای اعمال محدودسازی</legend><div class=\"col-md-3\" ng-repeat=\"customerGroup in vm.allCustomerGroups\"><md-checkbox ng-model=\"customerGroup.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.customerGroupCheckChange(customerGroup)\">{{customerGroup.groupName}}</md-checkbox></div></fieldset></div></div></div></div></form></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/reserve-limit/reserve-limit.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.reserveLimit.home.createOrEditLabel\" style=\"display: inline-block\">tikonApp.reserveLimit.home.createOrEditLabel </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.reserveLimit.id != null\">{{vm.reserveLimit.id}}</span></div><div class=\"panel-body\"><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                                border-bottom: solid 1px #ff9d1a;\n                            }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\" ng-if=\"true\"><md-button ng-click=\"vm.save()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.hasAllNecessaryFields\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\"><!--ثبت اطلاعات--></span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.reserveLimitList\"><span><md-icon>list</md-icon></span><span>بازگشت به لیست</span></md-button></div></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.reserveLimit.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.reserveLimit.title\"></div></div><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required--><!--translate=\"tikonApp.reserveLimit.limitType\"--><!--for=\"field_limitType\"--><!--&gt;limitType--><!--</label>--><!--<md-select class=\"rwMdSelect\"--><!--ng-model=\"vm.reserveLimit.limitType\"--><!--style=\"min-width: 250px;margin-top: 6px;\"--><!--id=\"field_limitType\"--><!--&gt;--><!--<md-option value=\"RESERVE\" translate=\"tikonApp.reserveLimitTypes.RESERVE\">--><!--RESERVE--><!--</md-option>--><!--<md-option value=\"HOUR\" translate=\"tikonApp.reserveLimitTypes.HOUR\" disabled>--><!--HOUR--><!--</md-option>--><!--<md-option value=\"MINUTES\" translate=\"tikonApp.reserveLimitTypes.MINUTES\" disabled>--><!--MINUTES--><!--</md-option>--><!--</md-select>--><!--</div>--><!--</div>--><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.reserveLimit.status\" for=\"field_status\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.reserveLimit.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.reserveLimitStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.reserveLimitStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required=\"\" translate=\"tikonApp.reserveLimit.limitCount\" for=\"field_limitCount\">limitCount</label><input type=\"number\" class=\"form-control\" name=\"limitCount\" id=\"field_limitCount\" ng-model=\"vm.reserveLimit.limitCount\" min=\"0\"></div></div><div class=\"col-md-3\" style=\"margin-top: 19px\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"pull-right\"><md-switch ng-model=\"vm.hasDayCount\" aria-label=\"Switch 1\" ng-change=\"vm.dayCount_switch_changed()\"><span translate=\"tikonApp.reserveLimit.hasDayCount\"></span></md-switch></div></div></div></div><div class=\"col-md-4\" ng-if=\"vm.hasDayCount\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.reserveLimit.dayCount\" for=\"field_dayCount\" eo-help-tooltip=\"tips.reserve_limit_day_count\">dayCount</label><input type=\"number\" class=\"form-control\" name=\"dayCount\" id=\"field_dayCount\" ng-model=\"vm.reserveLimit.dayCount\" min=\"0\"><div class=\"form-field-description\" translate=\"tikonApp.reserveLimit.fieldsDescription.dayCount\"></div></div></div></div><div id=\"nationalCode\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.basedOnNationalCodeSwitch\" aria-label=\"Switch 1\" ng-change=\"vm.basedOnNationalCode_changed()\"><span translate=\"tikonApp.reserveLimit.basedOnNationalCode\"></span></md-switch></div></div></div></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllServices\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.reserveLimit.forAllServices\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllServices\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.reserveLimit.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"serviceItem in vm.allServiceItems\"><md-checkbox ng-model=\"serviceItem.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.serviceCheckChange(serviceItem)\">{{serviceItem.itemTitle}}</md-checkbox></div></fieldset></div></div><div id=\"customerGroups\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllCustomerGroups\" aria-label=\"Switch 1\" ng-change=\"vm.switch_customerGroup_changed()\"><span translate=\"tikonApp.reserveLimit.forAllCustomerGroups\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllCustomerGroups\"><fieldset class=\"standard-fieldset\"><legend>انتخاب گروه مشتری برای اعمال محدودسازی</legend><div class=\"col-md-3\" ng-repeat=\"customerGroup in vm.allCustomerGroups\"><md-checkbox ng-model=\"customerGroup.selected\" aria-label=\"Checkbox 1\" ng-change=\"vm.customerGroupCheckChange(customerGroup)\">{{customerGroup.groupName}}</md-checkbox></div></fieldset></div></div></md-content></div></div></div></div></div></div>");
$templateCache.put("app/entities/reserve-limit/reserve-limits-list-v2.html","<div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.reserveLimit.home.title\">tikonApp.reserveLimit.home.title</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newReserveLimit()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.reserveLimit.home.new\">Create new reserveLimit</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><jhi-alert></jhi-alert><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.reserveLimits\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.reserveLimit.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"title\"><span translate=\"tikonApp.reserveLimit.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th class=\"hidden-xs\" st-sort=\"limitType\"><span translate=\"tikonApp.reserveLimit.limitType\">limitType</span>--><!--<span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th class=\"hidden-xs\" st-sort=\"limitPeriod\"><span translate=\"tikonApp.reserveLimit.limitPeriod\">limitPeriod</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"limitCount\"><span translate=\"tikonApp.reserveLimit.limitCount\">limitCount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"amount\"><span--><!--translate=\"tikonApp.reserveLimit.amount\">amount</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"status\"><span translate=\"tikonApp.reserveLimit.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"reserveLimit in collection track by reserveLimit.id\"><td><a ng-click=\"vm.editReserveLimit(reserveLimit)\">{{reserveLimit.id }}</a></td><td>{{reserveLimit.title}}</td><td class=\"hidden-xs\"><span translate=\"{{\'tikonApp.reserveLimitPeriod.\' + reserveLimit.limitPeriod}}\">{{reserveLimit.limitPeriod}}</span></td><td>{{reserveLimit.limitCount}}</td><!--<td>--><!--{{reserveLimit.amountType}}--><!--</td>--><!--<td>--><!--&lt;!&ndash;{{companyCustomer.createDate | toPersianDate}}</td>&ndash;&gt;--><!--{{reserveLimit.amount}}--><!--<span ng-if=\"reserveLimit.amountType==\'PERCENT\'\">--><!--%--><!--</span>--><!--<span ng-if=\"reserveLimit.amountType==\'CASH\'\">--><!--<span translate=\"global.currencyBracket\"></span>--><!--</span>--><td><span translate=\"{{\'tikonApp.reserveLimitStatus.\' + reserveLimit.status}}\">{{reserveLimit.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editReserveLimit(reserveLimit)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.deleteReserveLimit({id:reserveLimit.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newReserveLimit()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 coupon-list-title\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.reserveLimit.home.title\">title-list</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.setting\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.reserveLimit.home.searchPlaceHolder\'\" on-search=\"vm.search()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"reserveLimit in vm.reserveLimits track by reserveLimit.id\" class=\"customer-list-item\" ng-click=\"vm.editReserveLimit(reserveLimit)\"><!--<eo-avatar-name name=\"{{coupon.couponCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\">{{reserveLimit.title}}</div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span translate=\"{{\'tikonApp.reserveLimitPeriod.\' + reserveLimit.limitPeriod}}\">{{reserveLimit.limitPeriod}}</span></div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span translate=\"{{\'tikonApp.reserveLimitStatus.\' + reserveLimit.status}}\">{{reserveLimit.status}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/reserve-limit/reserve-limits-list.html","<style></style><div class=\"container-fluid\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"tikonApp.reserveLimit.home.title\">tikonApp.reserveLimit.home.title</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary\" ng-click=\"vm.newReserveLimitClick()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.reserveLimit.home.new\">Create new reserveLimit</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><jhi-alert></jhi-alert><md-content class=\"rwMdContent\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.reserveLimits\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><!--<input st-search=\"\" class=\"form-control rwTableSearchBox\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><div class=\"row\"><div class=\"col-sm-6 col-xs-6\"><div class=\"form-group\"><!--<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>--> <input class=\"form-control rwTableSearchBox\" style=\"max-width: unset\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'tikonApp.reserveLimit.home.search\' | translate }}\" type=\"text\"></div></div><div class=\"col-sm-6\"><md-button id=\"search-btn\" class=\"search-btn md-raised md-secondary\" ng-click=\"vm.search()\" style=\"margin-top: 0px; margin-right: -10px\"><i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative\">search</i></md-button></div></div></th></tr><tr><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"title\"><span translate=\"tikonApp.reserveLimit.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"limitType\"><span translate=\"tikonApp.reserveLimit.limitType\">limitType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"amount\"><span--><!--translate=\"tikonApp.reserveLimit.amount\">amount</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"status\"><span translate=\"tikonApp.reserveLimit.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"reserveLimit in collection track by reserveLimit.id\"><td><a ui-sref=\"supplierPanel.editReserveLimit({id:reserveLimit.id})\">{{reserveLimit.id }}</a></td><td>{{reserveLimit.title}}</td><td class=\"hidden-xs\"><span translate=\"{{\'tikonApp.reserveLimitTypes.\' + reserveLimit.limitType}}\">{{reserveLimit.limitType}}</span></td><!--<td>--><!--{{reserveLimit.amountType}}--><!--</td>--><!--<td>--><!--&lt;!&ndash;{{companyCustomer.createDate | toPersianDate}}</td>&ndash;&gt;--><!--{{reserveLimit.amount}}--><!--<span ng-if=\"reserveLimit.amountType==\'PERCENT\'\">--><!--%--><!--</span>--><!--<span ng-if=\"reserveLimit.amountType==\'CASH\'\">--><!--<span translate=\"global.currencyBracket\"></span>--><!--</span>--><td><span translate=\"{{\'tikonApp.reserveLimitStatus.\' + reserveLimit.status}}\">{{reserveLimit.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editReserveLimit({id:reserveLimit.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.deleteReserveLimit({id:reserveLimit.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></md-content></div></div></div><!--<div class=\"visible-xs \">--><!--<div class=\"\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-8\">--><!--<h3 class=\"\" style=\"padding-right: 7px\" translate=\"tikonApp.companyCustomer.home.title\">--><!--tikonApp.companyCustomer.home.title--><!--</h3>--><!--</div>--><!--<div class=\"col-xs-3\" style=\"margin-right: -7px\">--><!--<md-button class=\"md-raised md-primary\" ui-sref=\"company-customer.new\">--><!--<i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i>--><!--</md-button>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"\">--><!--<div class=\"\">--><!--<jhi-alert></jhi-alert>--><!--<div class=\"row\" style=\"padding-right: 8px\">--><!--<div class=\"form-group\">--><!--&lt;!&ndash;<label translate=\"tikonApp.companyCustomer.home.search\">Search</label>&ndash;&gt;--><!--<div class=\"col-xs-10\">--><!--<input class=\"form-control rwTableSearchBox\"--><!--ng-model=\"vm.searchQuery\"--><!--placeholder=\"{{ \'tikonApp.companyCustomer.home.search\' | translate }}\"--><!--type=\"text\"/>--><!--</div>--><!--<div class=\"col-xs-2\" style=\"margin-right: -30px;margin-top: -7px;\">--><!--<md-button id=\"search-btn-xs\" class=\"search-btn md-raised md-secondary\"--><!--ng-click=\"vm.search()\"--><!--&gt;--><!--<i class=\"material-icons\" style=\"top: 9px; right: -2px; position: relative;\">--><!--search--><!--</i>--><!--</md-button>--><!--</div>--><!--</div>--><!--</div>--><!--<div ng-repeat=\"companyCustomer in vm.companyCustomers track by companyCustomer.id\"--><!--class=\"orderBag-mobile-block\">--><!--&lt;!&ndash;<td>{{companyCustomer.customer.id }} </td>&ndash;&gt;--><!--<div>--><!--<div ui-sref=\"company-customer.edit({id:companyCustomer.id})\" class=\"row\">--><!--<div class=\"orderBag-mobile-float\">--><!--<i class=\"glyphicon glyphicon-user\"></i>--><!--{{companyCustomer.customer.personalInfo.fisrtName}}--><!--{{companyCustomer.customer.personalInfo.lastName}}--><!--</div>--><!--</div>--><!--<div class=\"row\" ng-if=\"companyCustomer.customer.personalInfo.email!=null\"--><!--style=\"padding-right: 8px\">--><!--<i class=\"glyphicon glyphicon-envelope\"></i>--><!--{{companyCustomer.customer.personalInfo.email}}--><!--</div>--><!--<div>--><!--<div class=\"orderBag-mobile-float companyCustomer-make-call\">--><!--<i class=\"fa fa-phone\"></i>--><!--<a href=\"tel:{{companyCustomer.customer.personalInfo.phoneNumber}}\">{{companyCustomer.customer.personalInfo.phoneNumber}}</a>--><!--&lt;!&ndash;{{companyCustomer.customer.personalInfo.phoneNumber}}&ndash;&gt;--><!--</div>--><!--<div style=\"text-align: left\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--<button type=\"submit\"--><!--ui-sref=\"company-customer.edit({id:companyCustomer.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"vm.gotoNewReserve(companyCustomer.customer.id)\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-primary btn-sm\" style=\"background-color: rgb(96,125,139)\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"tikonApp.companyCustomer.newReserveForCustomer\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--<button type=\"button\"--><!--ui-sref=\"supplierPanel.deleteCompanyCustomer({id:companyCustomer.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<ul uib-pager ng-change=\"vm.transition()\" next-text=\"بعدی >\" previous-text=\"< قبلی\" total-items=\"vm.totalItems\"--><!--ng-model=\"vm.page\"></ul>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/entities/reserve-limit/reserve-limits.html","<div id=\"container-reserve-limits\"><panel-pln-reserve-limits id=\"reserve-limits\"></panel-pln-reserve-limits></div>");
$templateCache.put("app/entities/reserve-services/reserve-services.html","<div id=\"container-resrve-services\"><panel-pln-reserve-services id=\"reserve-services\"></panel-pln-reserve-services></div>");
$templateCache.put("app/entities/resources/resources-list-form.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.companyInfo.resourcesListForm\">resourcesListForm</span></div><div class=\"panel-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.resources\"><span><span class=\"glyphicon glyphicon-repeat\"></span> </span><span translate=\"entity.action.back\">entity.action.back</span></md-button></div></div><md-content class=\"rwMdContent\"><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"tikonApp.resourcesListForm.title\" for=\"title\">title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"title\" ng-model=\"vm.resource.title\"></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"tikonApp.resourcesListForm.category\" for=\"category\">category</label><md-select class=\"rwMdSelect\" ng-model=\"\" id=\"category\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option></md-select></div><!--</div>--><!--</div>--></md-content></div></div></div></div>");
$templateCache.put("app/entities/resources/resources.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.companyInfo.resourcesListForm\">resourcesListForm</span></div><div class=\"panel-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.resourcesListForm\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.resourcesListForm.newResource\">newResource</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"tikonApp.resourcesListForm.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.resourcesListForm.category\">category</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"\"><td></td><td></td><!--<td translate=\"{{\'tikonApp.genderType.\' + participantPerson.personInfo.gender}}\">{{participantPerson.personInfo.gender}}</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button></div></td></tr></tbody></table></div></md-content></div></div></div></div>");
$templateCache.put("app/entities/schedule-base-discount/schedule-base-discount-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.scheduleBaseDiscount.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.scheduleBaseDiscount.delete.question\" translate-values=\"{id: \'{{vm.scheduleBaseDiscount.id}}\'}\">Are you sure you want to delete this Schedule Base Discount?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/schedule-base-discount/schedule-base-discount-detail.html","<div><h2><span translate=\"tikonApp.scheduleBaseDiscount.detail.title\">Schedule Base Discount</span> {{vm.scheduleBaseDiscount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.scheduleBaseDiscount.amount\">Amount</span></dt><dd><span>{{vm.scheduleBaseDiscount.amount}}</span></dd><dt><span translate=\"tikonApp.scheduleBaseDiscount.scheduleInfo\">Schedule Info</span></dt><dd><a ui-sref=\"schedule-info-detail({id:vm.scheduleBaseDiscount.scheduleInfoId})\">{{vm.scheduleBaseDiscount.scheduleInfoId}}</a></dd><dt><span translate=\"tikonApp.scheduleBaseDiscount.discountInfo\">Discount Info</span></dt><dd><a ui-sref=\"discount-info-detail({id:vm.scheduleBaseDiscount.discountInfoId})\">{{vm.scheduleBaseDiscount.discountInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/schedule-base-discount/schedule-base-discount-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myScheduleBaseDiscountLabel\" translate=\"tikonApp.scheduleBaseDiscount.home.createOrEditLabel\">Create or edit a Schedule Base Discount</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.scheduleBaseDiscount.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.scheduleBaseDiscount.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.scheduleBaseDiscount.amount\" for=\"field_amount\">Amount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.scheduleBaseDiscount.amount\"></div><div class=\"form-group\"><label translate=\"tikonApp.scheduleBaseDiscount.scheduleInfo\" for=\"field_scheduleInfo\">Schedule Info</label><select class=\"form-control\" id=\"field_scheduleInfo\" name=\"scheduleInfo\" ng-model=\"vm.scheduleBaseDiscount.scheduleInfoId\" ng-options=\"scheduleInfo.id as scheduleInfo.id for scheduleInfo in vm.scheduleinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.scheduleBaseDiscount.discountInfo\" for=\"field_discountInfo\">Discount Info</label><select class=\"form-control\" id=\"field_discountInfo\" name=\"discountInfo\" ng-model=\"vm.scheduleBaseDiscount.discountInfoId\" ng-options=\"discountInfo.id as discountInfo.id for discountInfo in vm.discountinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/schedule-base-discount/schedule-base-discounts.html","<div><h2 translate=\"tikonApp.scheduleBaseDiscount.home.title\">Schedule Base Discounts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"schedule-base-discount.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.scheduleBaseDiscount.home.createLabel\">Create new Schedule Base Discount</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.scheduleBaseDiscount.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amount\"><span translate=\"tikonApp.scheduleBaseDiscount.amount\">Amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"scheduleInfoId\"><span translate=\"tikonApp.scheduleBaseDiscount.scheduleInfo\">Schedule Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountInfoId\"><span translate=\"tikonApp.scheduleBaseDiscount.discountInfo\">Discount Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"scheduleBaseDiscount in vm.scheduleBaseDiscounts track by scheduleBaseDiscount.id\"><td><a ui-sref=\"schedule-base-discount-detail({id:scheduleBaseDiscount.id})\">{{scheduleBaseDiscount.id}}</a></td><td>{{scheduleBaseDiscount.amount}}</td><td><a ui-sref=\"schedule-info-detail({id:scheduleBaseDiscount.scheduleInfoId})\">{{scheduleBaseDiscount.scheduleInfoId}}</a></td><td><a ui-sref=\"discount-info-detail({id:scheduleBaseDiscount.discountInfoId})\">{{scheduleBaseDiscount.discountInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"schedule-base-discount-detail({id:scheduleBaseDiscount.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"schedule-base-discount.edit({id:scheduleBaseDiscount.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"schedule-base-discount.delete({id:scheduleBaseDiscount.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/schedule-info/schedule-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.scheduleInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.scheduleInfo.delete.question\" translate-values=\"{id: \'{{vm.scheduleInfo.id}}\'}\">Are you sure you want to delete this Schedule Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/schedule-info/schedule-info-detail.html","<div><h2><span translate=\"tikonApp.scheduleInfo.detail.title\">Schedule Info</span> {{vm.scheduleInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.scheduleInfo.scheduleType\">Schedule Type</span></dt><dd><span translate=\"{{\'tikonApp.ScheduleType.\' + vm.scheduleInfo.scheduleType}}\">{{vm.scheduleInfo.scheduleType}}</span></dd><dt><span translate=\"tikonApp.scheduleInfo.weeklyScheduleInfo\">Weekly Schedule Info</span></dt><dd><a ui-sref=\"weekly-schedule-info-detail({id:vm.scheduleInfo.weeklyScheduleInfoId})\">{{vm.scheduleInfo.weeklyScheduleInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/schedule-info/schedule-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myScheduleInfoLabel\" translate=\"tikonApp.scheduleInfo.home.createOrEditLabel\">Create or edit a Schedule Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.scheduleInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.scheduleInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.scheduleInfo.scheduleType\" for=\"field_scheduleType\">Schedule Type</label><select class=\"form-control\" name=\"scheduleType\" ng-model=\"vm.scheduleInfo.scheduleType\" id=\"field_scheduleType\"><option value=\"DAILY\" translate=\"tikonApp.ScheduleType.DAILY\">DAILY</option><option value=\"WEEKLY\" translate=\"tikonApp.ScheduleType.WEEKLY\">WEEKLY</option><option value=\"MONTHLY\" translate=\"tikonApp.ScheduleType.MONTHLY\">MONTHLY</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.scheduleInfo.weeklyScheduleInfo\" for=\"field_weeklyScheduleInfo\">Weekly Schedule Info</label><select class=\"form-control\" id=\"field_weeklyScheduleInfo\" name=\"weeklyScheduleInfo\" ng-model=\"vm.scheduleInfo.weeklyScheduleInfoId\" ng-options=\"weeklyScheduleInfo.id as weeklyScheduleInfo.id for weeklyScheduleInfo in vm.weeklyscheduleinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/schedule-info/schedule-infos.html","<div><h2 translate=\"tikonApp.scheduleInfo.home.title\">Schedule Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"schedule-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.scheduleInfo.home.createLabel\">Create new Schedule Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.scheduleInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"scheduleType\"><span translate=\"tikonApp.scheduleInfo.scheduleType\">Schedule Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"weeklyScheduleInfoId\"><span translate=\"tikonApp.scheduleInfo.weeklyScheduleInfo\">Weekly Schedule Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"scheduleInfo in vm.scheduleInfos track by scheduleInfo.id\"><td><a ui-sref=\"schedule-info-detail({id:scheduleInfo.id})\">{{scheduleInfo.id}}</a></td><td translate=\"{{\'tikonApp.ScheduleType.\' + scheduleInfo.scheduleType}}\">{{scheduleInfo.scheduleType}}</td><td><a ui-sref=\"weekly-schedule-info-detail({id:scheduleInfo.weeklyScheduleInfoId})\">{{scheduleInfo.weeklyScheduleInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"schedule-info-detail({id:scheduleInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"schedule-info.edit({id:scheduleInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"schedule-info.delete({id:scheduleInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/selector-data/selector-data-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.selectorData.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.selectorData.delete.question\" translate-values=\"{id: \'{{vm.selectorData.id}}\'}\">Are you sure you want to delete this Selector Data?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/selector-data/selector-data-detail.html","<div><h2><span translate=\"tikonApp.selectorData.detail.title\">Selector Data</span> {{vm.selectorData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.selectorData.key\">Key</span></dt><dd><span>{{vm.selectorData.key}}</span></dd><dt><span translate=\"tikonApp.selectorData.text\">Text</span></dt><dd><span>{{vm.selectorData.text}}</span></dd><dt><span translate=\"tikonApp.selectorData.orderNo\">Order No</span></dt><dd><span>{{vm.selectorData.orderNo}}</span></dd><dt><span translate=\"tikonApp.selectorData.type\">Type</span></dt><dd><a ui-sref=\"selector-data-type-detail({id:vm.selectorData.typeId})\">{{vm.selectorData.typeId}}</a></dd><dt><span translate=\"tikonApp.selectorData.parent\">Parent</span></dt><dd><a ui-sref=\"selector-data-detail({id:vm.selectorData.parentId})\">{{vm.selectorData.parentId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/selector-data/selector-data-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySelectorDataLabel\" translate=\"tikonApp.selectorData.home.createOrEditLabel\">Create or edit a Selector Data</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.selectorData.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.selectorData.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.selectorData.key\" for=\"field_key\">Key</label><input type=\"text\" class=\"form-control\" name=\"key\" id=\"field_key\" ng-model=\"vm.selectorData.key\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.selectorData.text\" for=\"field_text\">Text</label><input type=\"text\" class=\"form-control\" name=\"text\" id=\"field_text\" ng-model=\"vm.selectorData.text\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.selectorData.orderNo\" for=\"field_orderNo\">Order No</label><input type=\"number\" class=\"form-control\" name=\"orderNo\" id=\"field_orderNo\" ng-model=\"vm.selectorData.orderNo\"></div><div class=\"form-group\"><label translate=\"tikonApp.selectorData.type\" for=\"field_type\">Type</label><select class=\"form-control\" id=\"field_type\" name=\"type\" ng-model=\"vm.selectorData.typeId\" ng-options=\"selectorDataType.id as selectorDataType.typeName for selectorDataType in vm.selectordatatypes\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.selectorData.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.selectorData.parentId\" ng-options=\"selectorData.id as selectorData.text for selectorData in vm.selectordata\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/selector-data/selector-data.html","<div><h2 translate=\"tikonApp.selectorData.home.title\">Selector Data</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"selector-data.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.selectorData.home.createLabel\">Create new Selector Data</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.selectorData.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"key\"><span translate=\"tikonApp.selectorData.key\">Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"text\"><span translate=\"tikonApp.selectorData.text\">Text</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderNo\"><span translate=\"tikonApp.selectorData.orderNo\">Order No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"typeId\"><span translate=\"tikonApp.selectorData.type\">Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parentId\"><span translate=\"tikonApp.selectorData.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"selectorData in vm.selectorData track by selectorData.id\"><td><a ui-sref=\"selector-data-detail({id:selectorData.id})\">{{selectorData.id}}</a></td><td>{{selectorData.key}}</td><td>{{selectorData.text}}</td><td>{{selectorData.orderNo}}</td><td><a ui-sref=\"selector-data-type-detail({id:selectorData.typeId})\">{{selectorData.typeId}}</a></td><td><a ui-sref=\"selector-data-detail({id:selectorData.parentId})\">{{selectorData.parentId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"selector-data-detail({id:selectorData.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"selector-data.edit({id:selectorData.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"selector-data.delete({id:selectorData.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/selector-data-type/selector-data-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.selectorDataType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.selectorDataType.delete.question\" translate-values=\"{id: \'{{vm.selectorDataType.id}}\'}\">Are you sure you want to delete this Selector Data Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/selector-data-type/selector-data-type-detail.html","<div><h2><span translate=\"tikonApp.selectorDataType.detail.title\">Selector Data Type</span> {{vm.selectorDataType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.selectorDataType.key\">Key</span></dt><dd><span>{{vm.selectorDataType.key}}</span></dd><dt><span translate=\"tikonApp.selectorDataType.typeName\">Type Name</span></dt><dd><span>{{vm.selectorDataType.typeName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/selector-data-type/selector-data-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySelectorDataTypeLabel\" translate=\"tikonApp.selectorDataType.home.createOrEditLabel\">Create or edit a Selector Data Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.selectorDataType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.selectorDataType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.selectorDataType.key\" for=\"field_key\">Key</label><input type=\"text\" class=\"form-control\" name=\"key\" id=\"field_key\" ng-model=\"vm.selectorDataType.key\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.selectorDataType.typeName\" for=\"field_typeName\">Type Name</label><input type=\"text\" class=\"form-control\" name=\"typeName\" id=\"field_typeName\" ng-model=\"vm.selectorDataType.typeName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/selector-data-type/selector-data-types.html","<div><h2 translate=\"tikonApp.selectorDataType.home.title\">Selector Data Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"selector-data-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.selectorDataType.home.createLabel\">Create new Selector Data Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.selectorDataType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"key\"><span translate=\"tikonApp.selectorDataType.key\">Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"typeName\"><span translate=\"tikonApp.selectorDataType.typeName\">Type Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"selectorDataType in vm.selectorDataTypes track by selectorDataType.id\"><td><a ui-sref=\"selector-data-type-detail({id:selectorDataType.id})\">{{selectorDataType.id}}</a></td><td>{{selectorDataType.key}}</td><td>{{selectorDataType.typeName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"selector-data-type-detail({id:selectorDataType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"selector-data-type.edit({id:selectorDataType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"selector-data-type.delete({id:selectorDataType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/servant/servant-by-company-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServantLabel\" translate=\"tikonApp.servant.home.createOrEditLabel\">Create or edit a Servant</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.servant.level\" for=\"field_level\">Level</label>--><!--<input type=\"number\" class=\"form-control\" name=\"level\" id=\"field_level\"--><!--ng-model=\"vm.servant.level\"--><!--/>--><!--</div>--><div id=\"personInfoComp\"><div ng-if=\"!vm.isWorkSpace\"><pf-person-info person-info=\"vm.servant.personInfo\"></pf-person-info></div><div ng-if=\"vm.isWorkSpace\"><pf-person-info-space person-info=\"vm.servant.personInfo\" is-servant=\"true\"></pf-person-info-space></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/servant/servant-by-company.html","<div><h2 translate=\"tikonApp.servant.home.title\">Servants</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"supplierPanel.servantListByCompany.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.servant.home.createLabel\">Create new Servant</span></button></div></div></div><br><div class=\"table-responsive\"><table st-safe-src=\"vm.servants\" st-table=\"collection\" st-safe- class=\"jh-table table table-striped\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control\" placeholder=\"{{ \'tikonApp.servant.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"title\"><span translate=\"tikonApp.servant.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"personInfoId\"><span translate=\"tikonApp.servant.personInfo\">Person Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"fisrtName\"><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"lastName\"><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"level\"><span translate=\"tikonApp.servant.level\">Level</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat=\"servant in collection track by servant.id\"><td><a ui-sref=\"supplierPanel.servantListByCompany.edit({id:servant.id})\">{{servant.id}}</a></td><td>{{servant.personInfo.fisrtName}}</td><td>{{servant.personInfo.lastName}}</td><td>{{servant.personInfo.phoneNumber}}</td><!--<td>{{servant.level}}</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><!--<button type=\"submit\"--><!--ui-sref=\"servant-detail({id:servant.id})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>--> <button type=\"submit\" ui-sref=\"supplierPanel.servantListByCompany.edit({id:servant.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel.servantListByCompany.delete({id:servant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div>");
$templateCache.put("app/entities/servant/servant-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.servant.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.servant.delete.question\" translate-values=\"{id: \'{{vm.servant.id}}\'}\">Are you sure you want to delete this Servant?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/servant/servant-detail.html","<div><h2><span translate=\"tikonApp.servant.detail.title\">Servant</span> {{vm.servant.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.servant.title\">Title</span></dt><dd><span>{{vm.servant.title}}</span></dd><dt><span translate=\"tikonApp.servant.level\">Level</span></dt><dd><span>{{vm.servant.level}}</span></dd><dt><span translate=\"tikonApp.servant.personInfo\">Person Info</span></dt><dd><a ui-sref=\"person-info-detail({id:vm.servant.personInfoId})\">{{vm.servant.personInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/servant/servant-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServantLabel\" translate=\"tikonApp.servant.home.createOrEditLabel\">Create or edit a Servant</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.servant.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.servant.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.servant.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.servant.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.servant.level\" for=\"field_level\">Level</label><input type=\"number\" class=\"form-control\" name=\"level\" id=\"field_level\" ng-model=\"vm.servant.level\"></div><div class=\"form-group\"><label translate=\"tikonApp.servant.personInfo\" for=\"field_personInfo\">Person Info</label><select class=\"form-control\" id=\"field_personInfo\" name=\"personInfo\" ng-model=\"vm.servant.personInfoId\" ng-options=\"personInfo.id as personInfo.id for personInfo in vm.personinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/servant/servants.html","<div><h2 translate=\"tikonApp.servant.home.title\">Servants</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"servant.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.servant.home.createLabel\">Create new Servant</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.servant.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.servant.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"level\"><span translate=\"tikonApp.servant.level\">Level</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personInfoId\"><span translate=\"tikonApp.servant.personInfo\">Person Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"servant in vm.servants track by servant.id\"><td><a ui-sref=\"servant-detail({id:servant.id})\">{{servant.id}}</a></td><td>{{servant.title}}</td><td>{{servant.level}}</td><td><a ui-sref=\"person-info-detail({id:servant.personInfoId})\">{{servant.personInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"servant-detail({id:servant.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"servant.edit({id:servant.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"servant.delete({id:servant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/servant-exception-duration/servant-exception-duration.html","<eo-pl-modal-header title=\"vm.getTitleByAvailability()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\" style=\"max-width: 600px\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span>{{vm.getTitleByAvailability() | translate}}</span> <span ng-if=\"vm.selectedServant\" style=\"font-weight: normal\">- {{vm.selectedServant.personInfo.fullName}}</span></div><div class=\"panel-body\"><div class=\"row\" ng-if=\"vm.canSelectServant\"><div class=\"col-md-6\"><label class=\"control-label\" style=\"margin-bottom: 3px\">انتخاب</label><md-select class=\"rwMdSelect\" name=\"servantList\" ng-model=\"vm.selectedServant\"><md-option ng-repeat=\"srv in vm.servantList\" ng-value=\"srv\">{{srv.personInfo.fullName}}</md-option></md-select></div></div><div class=\"row\" style=\"margin-top: -15px;\n    padding-bottom: 15px\"><div class=\"col-md-12 col-xs-6\"><eo-date-duration-selector start-date=\"vm.startDate\" end-date=\"vm.endDate\" show-end-date=\"vm.showEndDate\" only-show-start-date=\"true\"></eo-date-duration-selector></div></div><div class=\"row\" style=\"padding-left: 20px\"><div class=\"col-md-12\"><eo-time-range-v2 start-time=\"vm.startTime\" end-time=\"vm.endTime\"></eo-time-range-v2></div></div><div class=\"row\"><div class=\"col-md-12 text-left\"><md-button id=\"addExceptionDuration\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\" ng-click=\"vm.addDuration()\"><!--<i class=\"material-icons\">add</i>--> <span class=\"glyphicon glyphicon-plus\"></span> <span>اضافه شود</span></md-button></div></div><div class=\"row\" id=\"errorMessageSection\" ng-if=\"vm.errorMessage\"><div class=\"col-md-12 alert alert-warning fade in alert-dismissible show\">{{vm.errorMessage}}</div></div><div class=\"row\" style=\"padding: 0 15px\"><hr ng-if=\"vm.exdurations && vm.exdurations.length>0\"><div id=\"exceptionDuration\" class=\"exception-duration-block col-sm-3 col-xs-12\" ng-class=\"vm.getDurationBlockClass(item)\" ng-repeat=\"item in vm.exdurations | orderBy: \'startDate\':reverse \" ng-click=\"vm.removeDuration(item)\"><span class=\"glyphicon glyphicon-remove\" style=\"float: left; margin-left: -11px\"></span><div class=\"exception-duration-dates-text\"><div>{{item.startDate | toPersianDate}}</div><div ng-if=\"!vm.isDateEqual(item.startDate,item.endDate) \">{{item.endDate | toPersianDate}}</div><div class=\"full-day\" ng-if=\"vm.isFullDay(item)\">تمام روز</div><div ng-if=\"!vm.isFullDay(item)\">{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/service-add-on/service-add-on-list.html","<div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.serviceAddOn.home.title\">tikonApp.serviceAddOn.home.title</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button ng-if=\"true\" class=\"md-raised md-primary pl-btn-primary pl-btn\" ng-click=\"vm.newServiceAddOn()\"><span><md-icon>add</md-icon></span><span class=\"hidden-xs\" translate=\"tikonApp.serviceAddOn.home.new\">Create new Servant</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div></div><!--<div class=\"container-fluid\">--><jhi-alert></jhi-alert><div class=\"\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.serviceAddOns\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceAddOn.home.searchPlaceHolder\'\" on-search=\"vm.searchServiceAddOns()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"ServiceAddOnCode\"><span translate=\"tikonApp.serviceAddOn.id\">id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"title\"><span translate=\"tikonApp.serviceAddOn.title\">title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"amountType\"><span--><!--translate=\"tikonApp.serviceAddOn.amountType\">amountType</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"amount\"><span translate=\"tikonApp.serviceAddOn.price\">price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.serviceAddOn.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"ServiceAddOn in collection track by ServiceAddOn.id\"><!--<td>{{ServiceAddOn.id }} </td>--><td><a ui-sref=\"supplierPanel-v2.editServiceAddOn({id:ServiceAddOn.id})\">{{ServiceAddOn.id}}</a></td><td>{{ServiceAddOn.title}}</td><td>{{ServiceAddOn.price | number}} <span translate=\"global.currencyBracket\"></span></td><td><span translate=\"{{\'tikonApp.serviceAddOnStatus.\' + ServiceAddOn.status}}\">{{ServiceAddOn.status}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.editServiceAddOn(ServiceAddOn)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-click=\"vm.deleteServiceAddOn({id:ServiceAddOn.id , index : $index})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!--</div>--></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newServiceAddOn()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"\"><div class=\"col-xs-12 ServiceAddOn-list-title\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.serviceAddOn.home.title\">title-list</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.setting\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceAddOn.home.searchPlaceHolder\'\" on-search=\"vm.searchServiceAddOns()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"ServiceAddOn in vm.serviceAddOns track by ServiceAddOn.id\" class=\"customer-list-item\" ng-click=\"vm.editServiceAddOn(ServiceAddOn)\"><!--<eo-avatar-name name=\"{{ServiceAddOn.ServiceAddOnCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\">{{ServiceAddOn.title}}</div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span><!--{{companyCustomer.createDate | toPersianDate}}</td>--> {{ServiceAddOn.price}} <span translate=\"global.currencyBracket\"></span></span></div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span translate=\"{{\'tikonApp.serviceAddOnStatus.\' + ServiceAddOn.status}}\">{{ServiceAddOn.status}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-add-on/service-add-on.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }\n\n    .usedCouponClass-v2 {\n        border: 1px solid #dee3e7;\n        border-radius: 5px;\n        padding: 5px;\n        margin-top: 5px;\n        background-color: antiquewhite;\n    }\n\n    .service-schedule-block {\n        border-bottom: solid 1px #ff9d1a;\n    }</style><eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.serviceAddOn && vm.serviceAddOn.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\">{{vm.serviceAddOn.title}}</div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.companyServants.delete({id:vm.servant.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span>{{vm.getModalTitle() | translate}} </span><span class=\"panel-heading\" style=\"font-weight: bold; color: black; display: inline\" ng-if=\"vm.serviceAddOn.id != null\">{{vm.serviceAddOn.id}}</span></div><form name=\"editForm\"><div class=\"panel-body\"><div class=\"container-fluid pl-container-fluid\"><div class=\"\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceAddOn.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"field_title\" id=\"field_title\" ng-model=\"vm.serviceAddOn.title\"></div></div><div class=\"col-md-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceAddOn.price\" for=\"field_price\">price</label><eo-numeric-input-v2 id=\"field_price\" name=\"price\" custom-class=\"form-control\" input-value=\"vm.serviceAddOn.price\" form-reference=\"editForm\" is-required=\"true\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceAddOn.status\" for=\"field_status\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceAddOn.status\" style=\"margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.serviceAddOnStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.serviceAddOnStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceAddOn.description\" for=\"field_description\">title</label><input type=\"text\" class=\"form-control\" name=\"field_description\" id=\"field_description\" ng-model=\"vm.serviceAddOn.description\"></div></div></div></div></div></div></form></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/service-capacity-info/service-capacity-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceCapacityInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceCapacityInfo.delete.question\" translate-values=\"{id: \'{{vm.serviceCapacityInfo.id}}\'}\">Are you sure you want to delete this Service Capacity Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-capacity-info/service-capacity-info-detail.html","<div><h2><span translate=\"tikonApp.serviceCapacityInfo.detail.title\">Service Capacity Info</span> {{vm.serviceCapacityInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceCapacityInfo.qty\">Qty</span></dt><dd><span>{{vm.serviceCapacityInfo.qty}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-capacity-info/service-capacity-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceCapacityInfoLabel\" translate=\"tikonApp.serviceCapacityInfo.home.createOrEditLabel\">Create or edit a Service Capacity Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceCapacityInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceCapacityInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qty\" for=\"field_qty\">Qty</label><input type=\"number\" class=\"form-control\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.serviceCapacityInfo.qty\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-capacity-info/service-capacity-infos.html","<div><h2 translate=\"tikonApp.serviceCapacityInfo.home.title\">Service Capacity Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-capacity-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceCapacityInfo.home.createLabel\">Create new Service Capacity Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceCapacityInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"qty\"><span translate=\"tikonApp.serviceCapacityInfo.qty\">Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceCapacityInfo in vm.serviceCapacityInfos track by serviceCapacityInfo.id\"><td><a ui-sref=\"service-capacity-info-detail({id:serviceCapacityInfo.id})\">{{serviceCapacityInfo.id}}</a></td><td>{{serviceCapacityInfo.qty}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-capacity-info-detail({id:serviceCapacityInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-capacity-info.edit({id:serviceCapacityInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-capacity-info.delete({id:serviceCapacityInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-categories/service-categories.html","<div id=\"container-service-categories\"><panel-pln-service-categories id=\"service-categories\"></panel-pln-service-categories></div>");
$templateCache.put("app/entities/service-category/company-service-category-dialog-v2.html","<eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"servant-header-container\" ng-if=\"vm.serviceCategory && vm.serviceCategory.id \"><div class=\"customer-header-info\"><!--<div>--><!--<eo-avatar-name name=\"vm.servant.personInfo.fisrtName\"></eo-avatar-name>--><!--</div>--><div><div class=\"customer-list-customer-name\">{{vm.serviceCategory.categoryName}}</div></div></div><div class=\"customer-header-buttons\"><div ui-sref=\"supplierPanel-v2.deleteCompanyServiceCategory({id:vm.serviceCategory.id})\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"customer-component-container\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><ul class=\"pl-nav-tabs\"><li class=\"active\"><a data-toggle=\"tab\" data-target=\"#serviceCategoryTab\"><md-icon class=\"pl-icon\">subject</md-icon><span translate=\"tikonApp.serviceCategory.sections.serviceCategoryTab\">serviceCategoryTab </span></a></li><li><a data-toggle=\"tab\" data-target=\"#serviceCategoryImagesTab\"><md-icon class=\"pl-icon\">image</md-icon><span translate=\"tikonApp.serviceCategory.sections.imageTab\">imageTab</span> </a></li></ul><div class=\"tab-content clearfix\"><div id=\"serviceCategoryTab\" class=\"tab-pane active\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.serviceCategory.sections.serviceCategoryTab\"></span></div><div class=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceCategory.categoryName\" for=\"field_categoryName\">Category Name</label><input type=\"text\" class=\"form-control\" name=\"categoryName\" id=\"field_categoryName\" ng-model=\"vm.serviceCategory.categoryName\" required eo-required=\"\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCategory.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceCategory.description\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.serviceCategory.parentId\" ng-options=\"serviceCategory.id as serviceCategory.categoryName for serviceCategory in vm.servicecategories\"><option value=\"\" style=\"font-style: italic\" translate=\"tikonApp.serviceCategory.noValue\"></option></select></div></div></div></div></div><div id=\"serviceCategoryImagesTab\" class=\"tab-pane fade\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><!--<span translate=\"tikonApp.servant.tabs.profileInfo\"></span>--> تصاویر</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><eo-image-gallery-manager-v2 album-id=\"vm.serviceCategory.imagesId\" max-image-count=\"1\" crop-width=\"400\" crop-height=\"240\" album-caption=\"vm.serviceCategory.categoryName\"></eo-image-gallery-manager-v2></div></div></div></div></div></div></div></div></form></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer><!--<jhi-alert></jhi-alert>-->");
$templateCache.put("app/entities/service-category/company-service-category-dialog.html","<style>.modal-dialog {\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        padding: 0;\n    }\n\n    .modal-content {\n        height: auto;\n        min-height: 100%;\n        border-radius: 0;\n    }</style><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<jhi-alert></jhi-alert>--><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceCategoryLabel\" translate=\"tikonApp.serviceCategory.home.createOrEditLabel\">Create or edit a Service Category</h4></div><div class=\"modal-body\"><ul class=\"nav nav-tabs nav-justified lightnav\"><li class=\"active\"><a data-toggle=\"tab\" data-target=\"#serviceCategoryTab\"><span translate=\"tikonApp.serviceCategory.sections.serviceCategoryTab\">serviceCategoryTab </span></a></li><li><a data-toggle=\"tab\" data-target=\"#serviceCategoryImagesTab\"><span translate=\"tikonApp.serviceCategory.images\">settingInfoTab</span> </a></li><!--<li ><a data-toggle=\"tab\" data-target=\"#settingInfoTab\">--><!--<span translate=\"tikonApp.serviceCategory.sections.settingInfoTab\">settingInfoTab</span>--><!--</a></li>--></ul><!--<jhi-alert-error></jhi-alert-error>--><!--   <div class=\"form-group\" ng-show=\"vm.serviceCategory.id\">\n               <label for=\"id\" translate=\"global.field.id\">ID</label>\n               <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                       ng-model=\"vm.serviceCategory.id\" readonly />\n           </div>--><div class=\"tab-content panel panel-default\"><div id=\"serviceCategoryTab\" class=\"tab-pane fade in active\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceCategory.categoryName\" for=\"field_categoryName\">Category Name</label><input type=\"text\" class=\"form-control\" name=\"categoryName\" id=\"field_categoryName\" ng-model=\"vm.serviceCategory.categoryName\" required eo-required=\"\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCategory.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceCategory.description\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.serviceCategory.parentId\" ng-options=\"serviceCategory.id as serviceCategory.categoryName for serviceCategory in vm.servicecategories\"><option value=\"\" style=\"font-style: italic\" translate=\"tikonApp.serviceCategory.noValue\"></option></select></div></div><div id=\"serviceCategoryImagesTab\" class=\"tab-pane fade in\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><eo-image-gallery-manager-v2 album-id=\"vm.serviceCategory.imagesId\" max-image-count=\"1\" crop-width=\"400\" crop-height=\"240\" album-caption=\"vm.serviceCategory.categoryName\"></eo-image-gallery-manager-v2></div></div></div><!--  <div class=\"form-group\">\n                      <label translate=\"tikonApp.serviceCategory.servants\" for=\"field_servants\">Servants</label>\n                      <select class=\"form-control\" id=\"field_servants\" multiple name=\"servants\" ng-model=\"vm.serviceCategory.servants\" ng-options=\"servant as servant.id for servant in vm.servants track by servant.id\"></select>\n                  </div>\n                  <div class=\"form-group\">\n                      <label translate=\"tikonApp.serviceCategory.images\" for=\"field_images\">Images</label>\n                      <select class=\"form-control\" id=\"field_images\" name=\"images\" ng-model=\"vm.serviceCategory.imagesId\" ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\"            >\n                          <option value=\"\"></option>\n                      </select>\n                  </div>--></div><!--<div id=\"settingInfoTab\" class=\"tab-pane fade in\">--><!--<div id=\"settingInfo\">--><!--<pf-setting-info setting-info=\"vm.serviceCategory.setting\"   >--><!--</pf-setting-info>--><!--</div>--><!--</div>--></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-category/company-service-category-list-v2.html","<style>.button-title {\n    }\n\n    @media screen and (max-width: 768px) {\n        .button-title {\n            font-size: x-small !important;\n        }\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory-v2\">supplierPanel.sideMenu.serviceItem.serviceCategory</div><div class=\"panel-body pl-panel-body\"><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-xs-12\"><md-button class=\"pl-btn-primary pl-btn\" style=\"margin-bottom: 0\" ui-sref=\".new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceCategory.home.createLabel\">Create new Service Category</span></md-button><md-button class=\"md-raised md-secondary pl-btn-default pl-btn\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel-v2.serviceItemList\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"button-title\" translate=\"supplierPanel.sideMenu.serviceItem.title-v2\">supplierPanel.sideMenu.servicelist</span></md-button><md-button class=\"md-raised md-secondary pl-btn-default pl-btn\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel-v2.eventItemList\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"button-title\" translate=\"supplierPanel.sideMenu.eventItem\">supplierPanel.sideMenu.eventItemList</span></md-button></div></div><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceCategories\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceCategory.home.searchPlaceHolder\'\" on-search=\"vm.searchCategories()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"categoryName\"><span translate=\"tikonApp.serviceCategory.categoryName\">Category Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"parentName\"><span translate=\"tikonApp.serviceCategory.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat=\"serviceCategory in collection track by serviceCategory.id\"><td><a ui-sref=\".edit({id:serviceCategory.id})\">{{serviceCategory.id}}</a></td><td>{{serviceCategory.categoryName}}</td><!--<td>{{serviceCategory.parentName}}</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ui-sref=\".edit({id:serviceCategory.id})\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel-v2.companyServiceCategoryList.delete({id:serviceCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newCategory()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 category-list-title\" style=\"display: flex\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.serviceCategory.home.title-list\">title-list</h3><div style=\"display: flex\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.serviceItemList\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon><span class=\"\" translate=\"tikonApp.serviceItem.home.title-v2\">serviceCategory</span></md-button><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.eventItemList\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon><span class=\"\" translate=\"tikonApp.eventItem.home.title\">serviceCategory</span></md-button></div></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceCategory.home.searchPlaceHolder\'\" on-search=\"vm.searchCategories()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"category in vm.serviceCategories track by category.id\" class=\"customer-list-item\" ng-click=\"vm.editCategory(category)\"><!--<eo-avatar-name name=\"{{category.categoryName}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-name\">{{category.categoryName}}</div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div>");
$templateCache.put("app/entities/service-category/company-service-category-list.html","<style>.button-title {\n    }\n\n    @media screen and (max-width: 768px) {\n        .button-title {\n            font-size: x-small !important;\n        }\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory\">supplierPanel.sideMenu.serviceItem.serviceCategory</div><div class=\"panel-body\"><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-xs-12\"><md-button class=\"md-raised md-primary\" style=\"margin-bottom: 0\" ui-sref=\".new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceCategory.home.createLabel\">Create new Service Category</span></md-button><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.serviceItemListV2\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"button-title\" translate=\"supplierPanel.sideMenu.servicelist\">supplierPanel.sideMenu.servicelist</span></md-button><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.serviceItemEventListV2\"><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> <span class=\"button-title\" translate=\"supplierPanel.sideMenu.eventItemList\">supplierPanel.sideMenu.eventItemList</span></md-button></div></div><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceCategories\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control rwTableSearchBox\" placeholder=\"{{ \'tikonApp.serviceCategory.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"categoryName\"><span translate=\"tikonApp.serviceCategory.categoryName\">Category Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"parentName\"><span translate=\"tikonApp.serviceCategory.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat=\"serviceCategory in collection track by serviceCategory.id\"><td><a ui-sref=\".edit({id:serviceCategory.id})\">{{serviceCategory.id}}</a></td><td>{{serviceCategory.categoryName}}</td><!--<td>{{serviceCategory.parentName}}</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ui-sref=\".edit({id:serviceCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.companyServiceCategoryList.delete({id:serviceCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div></div>");
$templateCache.put("app/entities/service-category/service-categories.html","<div><h2 translate=\"tikonApp.serviceCategory.home.title\">Service Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceCategory.home.createLabel\">Create new Service Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"categoryName\"><span translate=\"tikonApp.serviceCategory.categoryName\">Category Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"settingId\"><span translate=\"tikonApp.serviceCategory.setting\">Setting</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyId\"><span translate=\"tikonApp.serviceCategory.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parentId\"><span translate=\"tikonApp.serviceCategory.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"imagesId\"><span translate=\"tikonApp.serviceCategory.images\">Images</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceCategory in vm.serviceCategories track by serviceCategory.id\"><td><a ui-sref=\"service-category-detail({id:serviceCategory.id})\">{{serviceCategory.id}}</a></td><td><div>{{serviceCategory.categoryName}}</div><!--<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"serviceCategory.parentName && serviceCategory.parentName!=\'DEFAULT_CATEGORY\'\">--><!--{{serviceCategory.parentName}}--><!--</div>--></td><td><a ui-sref=\"setting-info-detail({id:serviceCategory.settingId})\">{{serviceCategory.settingId}}</a></td><td><a ui-sref=\"company-detail({id:serviceCategory.companyId})\">{{serviceCategory.companyId}}</a></td><td><a ui-sref=\"service-category-detail({id:serviceCategory.parentId})\">{{serviceCategory.parentId}}</a></td><td><a ui-sref=\"album-info-detail({id:serviceCategory.imagesId})\">{{serviceCategory.imagesId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-category-detail({id:serviceCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-category.edit({id:serviceCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-category.delete({id:serviceCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-category/service-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceCategory.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceCategory.delete.question\" translate-values=\"{categoryName: \'{{vm.serviceCategory.categoryName}}\'}\">Are you sure you want to delete this Service Category?</p></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></md-button></div></form>");
$templateCache.put("app/entities/service-category/service-category-detail.html","<div><h2><span translate=\"tikonApp.serviceCategory.detail.title\">Service Category</span> {{vm.serviceCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceCategory.categoryName\">Category Name</span></dt><dd><span>{{vm.serviceCategory.categoryName}}</span></dd><dt><span translate=\"tikonApp.serviceCategory.setting\">Setting</span></dt><dd><a ui-sref=\"setting-info-detail({id:vm.serviceCategory.settingId})\">{{vm.serviceCategory.settingId}}</a></dd><dt><span translate=\"tikonApp.serviceCategory.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.serviceCategory.companyId})\">{{vm.serviceCategory.companyId}}</a></dd><dt><span translate=\"tikonApp.serviceCategory.parent\">Parent</span></dt><dd><a ui-sref=\"service-category-detail({id:vm.serviceCategory.parentId})\">{{vm.serviceCategory.parentId}}</a></dd><dt><span translate=\"tikonApp.serviceCategory.servants\">Servants</span></dt><dd><span ng-repeat=\"servants in vm.serviceCategory.servants\"><a ui-sref=\"servant-detail({id: {{servants.id}}})\">{{servants.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.serviceCategory.images\">Images</span></dt><dd><a ui-sref=\"album-info-detail({id:vm.serviceCategory.imagesId})\">{{vm.serviceCategory.imagesId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-category/service-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCategory.categoryName\" for=\"field_categoryName\">Category Name</label><input type=\"text\" class=\"form-control\" name=\"categoryName\" id=\"field_categoryName\" ng-model=\"vm.serviceCategory.categoryName\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.setting\" for=\"field_setting\">Setting</label><select class=\"form-control\" id=\"field_setting\" name=\"setting\" ng-model=\"vm.serviceCategory.settingId\" ng-options=\"settingInfo.id as settingInfo.id for settingInfo in vm.settinginfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.serviceCategory.companyId\" ng-options=\"company.id as company.id for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.serviceCategory.parentId\" ng-options=\"serviceCategory.id as serviceCategory.id for serviceCategory in vm.servicecategories\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.servants\" for=\"field_servants\">Servants</label><select class=\"form-control\" id=\"field_servants\" multiple=\"multiple\" name=\"servants\" ng-model=\"vm.serviceCategory.servants\" ng-options=\"servant as servant.id for servant in vm.servants track by servant.id\"></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceCategory.images\" for=\"field_images\">Images</label><select class=\"form-control\" id=\"field_images\" name=\"images\" ng-model=\"vm.serviceCategory.imagesId\" ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-item/general-service-item.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><style>.shortTextBox {\n            width: 50px;\n            font-size: 16px;\n            font-weight: bold;\n            text-align: center;\n        }</style><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><!--<span class=\"glyphicon glyphicon-save\"></span>--> <i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> &nbsp;<span translate=\"entity.action.save\">Save</span></button><!--<a ui-sref=\"supplierPanel.serviceItemList\">--><!--<span translate=\"supplierPanel.sideMenu.servicelist\">Service List</span>--><!--</a>--> <a ng-if=\"vm.serviceItem.id\" class=\"btn btn-info\" ui-sref=\"supplierPanel.scheduling({id:vm.serviceItem.id})\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> <span translate=\"tikonApp.serviceItem.scheduling\"></span></a><div class=\"panel\"><div class=\"panel-heading\" autofocus><span translate=\"supplierPanel.sideMenu.serviceItem.generalTab\">generalTab</span></div><div class=\"panel-body\"><div><div id=\"general\" class=\"\"><div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"vm.serviceItem.itemTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.minPrice\" for=\"field_minPrice\">Min Price</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"form-control\" name=\"minPrice\" id=\"field_minPrice\" ng-model=\"vm.serviceItem.minPrice\" min=\"0\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.serviceStatus\" for=\"field_serviceStatus\" eo-help-tooltip=\"tips.service_status\">Service Status</label><select class=\"form-control\" name=\"serviceStatus\" ng-model=\"vm.serviceItem.serviceStatus\" id=\"field_serviceStatus\"><option value=\"\" translate=\"global.pleaseSelectItem\"></option><option value=\"DISABLE\" translate=\"tikonApp.ServiceItemStatus.DISABLE\">DISABLE</option><option value=\"PUBLISH\" translate=\"tikonApp.ServiceItemStatus.PUBLISH\">PUBLISH</option><option value=\"RESERVE_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.RESERVE_JUST_PANEL\">RESERVE_JUST_PANEL</option><option value=\"PUBLISH_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.PUBLISH_JUST_PANEL\">PUBLISH_JUST_PANEL</option></select></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceItem.description\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.category\" required for=\"field_category\" eo-help-tooltip=\"tips.service_category\">Category</label><select class=\"form-control\" id=\"field_category\" name=\"category\" ng-model=\"vm.serviceItem.category.id\" ng-options=\"serviceCategory.id as vm.categoryName(serviceCategory.categoryName)  for serviceCategory in vm.servicecategories\"></select></div></div></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.serviceType\" for=\"field_serviceType\">Service--><!--Type</label>--><!--<select class=\"form-control\" name=\"serviceType\" ng-model=\"vm.serviceItem.serviceType\"--><!--id=\"field_serviceType\">--><!--<option value=\"INDEPENDENT_SERVICE\" translate=\"tikonApp.ServiceItemType.INDEPENDENT_SERVICE\">--><!--INDEPENDENT_SERVICE--><!--</option>--><!--<option value=\"SERVICE_PACKAGE\" translate=\"tikonApp.ServiceItemType.SERVICE_PACKAGE\">--><!--SERVICE_PACKAGE--><!--</option>--><!--<option value=\"DEPENDENT_SERVICE\" translate=\"tikonApp.ServiceItemType.DEPENDENT_SERVICE\">--><!--DEPENDENT_SERVICE--><!--</option>--><!--</select>--><!--</div>--><div class=\"row\"><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.maxDiscount\"--><!--for=\"field_maxDiscount\">Max--><!--Discount</label>--><!--<input type=\"number\" class=\"form-control\" name=\"maxDiscount\" id=\"field_maxDiscount\"--><!--ng-model=\"vm.serviceItem.maxDiscount\" min=\"0\"--><!--/>--><!--</div>--><!--</div>--></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\" style=\"float: right\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.scheduleType\" eo-help-tooltip=\"tips.schedule_type_selection\">Send Booking Confirmation Supplier</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.mainScheduleType\" layout=\"row\"><md-radio-button value=\"BASED_ON_COMPANY_SCHEDULE\" class=\"md-primary\"><span translate=\"tikonApp.serviceItem.scheduletype_repeated\"></span></md-radio-button><md-radio-button value=\"FIXED_TIME_SESSIONS\"><span translate=\"tikonApp.serviceItem.scheduletype_event\"></span></md-radio-button></md-radio-group></div></div><div class=\"col-sm-4\" ng-if=\"vm.mainScheduleType==\'BASED_ON_COMPANY_SCHEDULE\'\"><div class=\"form-group\" style=\"float: right ; width: 100%\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.duration\" required for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" eo-duration-validator eo-required=\"\" ng-model=\"vm.serviceItem.duration\"></div></div></div><div class=\"row\"><button type=\"button\" class=\"btn btn-success\" style=\"margin-right: 14px\" data-ng-click=\"vm.saveAndGotoScheduling()\"><span ng-switch=\"vm.mainScheduleType\"><span ng-switch-when=\"BASED_ON_COMPANY_SCHEDULE\"><i class=\"fa fa-gear\"></i> {{\'tikonApp.serviceItem.scheduletype_repeated_goto_setting\' | translate}} </span><span ng-switch-when=\"FIXED_TIME_SESSIONS\"><i class=\"fa fa-plus\"></i> {{\'tikonApp.serviceItem.scheduletype_event_goto_setting\' | translate}}</span></span></button></div><div class=\"row\"><br></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.tags\" for=\"field_tags\">Tags</label>--><!--<eo-multi-select id=\"field_tags\" list=\"vm.serviceItem.tags\" items=\"vm.metatags\" displaytag=\"tag\"--><!--displayitem=\"tag\">--><!--</eo-multi-select>--><!--</div>--><div class=\"form-group\"><a ng-click=\"vm.showFullDescription()\">درج توضیحات تکمیلی +</a><div ng-if=\"vm.fullDescription\"><label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.serviceItem.fullDescription\" for=\"field_fullDescription\">Full Description</label><div height=\"300\" type=\"text\" summernote class=\"form-control\" name=\"fullDescription\" id=\"field_fullDescription\" ng-model=\"vm.serviceItem.fullDescription\"></div></div></div></div></div></div></div></div><div id=\"gallerySection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.imageAlbumTab\" eo-help-tooltip=\"tips.service_images\">imageAlbumTab</span></div><div class=\"panel-body\"><eo-image-gallery-manager album-id=\"vm.serviceItem.imageAlbumId\" max-image-count=\"1\" crop-width=\"348\" crop-height=\"248\" album-caption=\"vm.serviceItem.item_title\"></eo-image-gallery-manager></div></div></div><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.servantTab\" eo-help-tooltip=\"tips.service_servants\">servantTab</span></div><div class=\"panel-body\"><div id=\"servants\"><pf-service-item-servants servants=\"vm.serviceItem.servants\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.servantFormState\"></pf-service-item-servants></div></div></div><div id=\"agreementSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.agreementTab\">agreementTab</span></div><div class=\"panel-body\"><pf-service-item-agreement-info agreement=\"vm.serviceItem.agreement\"></pf-service-item-agreement-info></div></div></div><!--<persian-datepicker-popup-wrap ng-model=\"vm.serviceItem.itemTitle\"></persian-datepicker-popup-wrap>--> <a ng-click=\"vm.showAdvancedSetting()\">تنظیمات پیشرفته +</a><div ng-if=\"vm.advancedSetting\"><div id=\"settingSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.settingTab\">settingTab</span></div><div class=\"panel-body\"><div id=\"setting\" class=\"\"><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.hasWaitingList\" for=\"field_hasWaitingList\">Has--><!--Waiting List</label>--><!--<input type=\"checkbox\" class=\"form-control\" name=\"hasWaitingList\" id=\"field_hasWaitingList\"--><!--ng-model=\"vm.serviceItem.hasWaitingList\"--><!--/>--><!--</div>--><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.confirmationType\" for=\"field_confirmationType\" eo-help-tooltip=\"tips.service_confirmation_type\">Confirmation Type</label><select class=\"form-control\" name=\"confirmationType\" ng-model=\"vm.serviceItem.confirmationType\" id=\"field_confirmationType\" ng-change=\"vm.confirmationType_Change()\"><option value=\"ONE_STEP\" translate=\"tikonApp.ServiceConfirmationType.ONE_STEP\">ONE_STEP</option><option value=\"TWO_STEP\" translate=\"tikonApp.ServiceConfirmationType.TWO_STEP\">TWO_STEP</option></select></div></div><div class=\"col-md-3\" ng-if=\"vm.serviceItem.confirmationType==\'TWO_STEP\'\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.customerConfirmationDeadline\" for=\"field_customerConfirmationDeadline\" eo-help-tooltip=\"tips.service_customer_confirmation_deadline\">customerConfirmationDeadline</label><input type=\"number\" class=\"form-control\" name=\"customerConfirmationDeadline\" id=\"field_customerConfirmationDeadline\" ng-model=\"vm.serviceItem.customerConfirmationDeadline\" min=\"1\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.paymentType\" for=\"field_paymentType\">Payment Type</label><select class=\"form-control\" name=\"paymentType\" ng-model=\"vm.serviceItem.paymentType\" ng-change=\"vm.paymentType_changed()\" id=\"field_paymentType\"><option value=\"PAYMENT_ALL\" translate=\"tikonApp.ServicePaymentType.PAYMENT_ALL\">PAYMENT_ALL</option><option value=\"PRE_PAYMENT\" translate=\"tikonApp.ServicePaymentType.PRE_PAYMENT\">PRE_PAYMENT</option></select></div></div><div class=\"col-md-3\" ng-if=\"vm.serviceItem.paymentType==\'PRE_PAYMENT\'\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.prePaymentAmount\" for=\"field_prePaymentAmount\">Pre Payment Amount</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"form-control\" name=\"prePaymentAmount\" id=\"field_prePaymentAmount\" ng-model=\"vm.serviceItem.prePaymentAmount\" min=\"0\"></div></div></div><div class=\"row\"><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<input type=\"checkbox\" name=\"mustGetParticipantInfo\"--><!--id=\"field_mustGetParticipantInfo\"--><!--ng-model=\"vm.serviceItem.mustGetParticipantInfo\"--><!--/>--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.mustGetParticipantInfo\"--><!--eo-help-tooltip=\"tips.must_get_participant_on_service_item\"--><!--for=\"field_mustGetParticipantInfo\">Must Get Participant Info</label>--><!--</div>--><!--</div>--><div class=\"col-md-4\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.minPreReserveTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"minPreReserveTime\" id=\"field_minPreReserveTime\" ng-model=\"vm.serviceItem.minPreReserveTime\" min=\"0\"> <span translate=\"tikonApp.serviceItem.minPreReserveTime2\" eo-help-tooltip=\"tips.min_pre_reserve_time\"></span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.maxPreReserveTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\" ng-model=\"vm.serviceItem.maxPreReserveTime\" min=\"0\"> <span translate=\"tikonApp.serviceItem.maxPreReserveTime2\" eo-help-tooltip=\"tips.max_pre_reserve_time\"></span><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.maxPreReserveTime\"--><!--for=\"field_maxPreReserveTime\">Max Pre Reserve Time</label>--><!--<input type=\"number\" class=\"form-control\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\"--><!--ng-model=\"vm.serviceItem.maxPreReserveTime\"--><!--placeholder=\"{{\'tikonApp.serviceItem.maxPreReserveTimeDescription\' | translate}}\"--><!--min=\"0\"--><!--/>--></div></div><!--commentec for now--><!--<div class=\"col-md-4\" ng-if=\"vm.serviceItem.paymentType==\'PAYMENT_ALL\'\">--><!--<div class=\"form-group\" style=\"padding-top: 30px\">--><!--<input type=\"checkbox\" name=\"inPlacePayment\"--><!--id=\"field_inPlacePayment\"--><!--ng-model=\"vm.serviceItem.inPlacePayment\"--><!--/>--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.inPlacePayment\" eo-help-tooltip=\"tips.in_place_payment_on_service_item\"--><!--for=\"field_inPlacePayment\">In Place Payment</label>--><!--</div>--><!--</div>--></div><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qty\" for=\"field_qty\" eo-help-tooltip=\"tips.service_capacity\">Qty</label><input type=\"number\" class=\"shortTextBox\" min=\"1\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.serviceItem.capacityInfo.qty\"></div></div></div><!--MULTI RESERVE MODE SETTING--><div class=\"row\" data-ng-if=\"vm.serviceItem.scheduleInfo.scheduleType==\'FLOAT_TIME_SESSIONS\'\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.consecutiveReserveMode\" eo-help-tooltip=\"tips.consecutiveReserveMode\">consecutiveReserveMode</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.consecutiveReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"ENABLE\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span></md-radio-button></md-radio-group></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveMode\" eo-help-tooltip=\"tips.multiReserveMode\">multiReserveMode</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"MANUAL\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.MANUAL\"></span></md-radio-button><md-radio-button value=\"AUTO\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.AUTO\"></span></md-radio-button></md-radio-group></div></div></div><div class=\"row\" data-ng-if=\"vm.serviceItem.multiReserveMode==\'AUTO\'\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveModeConfig\">multiReserveModeConfig</label></div></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatCount\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatCount\">repeatCount</label><input type=\"number\" class=\"shortTextBox\" min=\"1\" name=\"repeatCount\" id=\"repeatCount\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatCount\"></div></div></div><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatMode\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatMode\">repeatMode</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatMode\" layout=\"row\"><md-radio-button value=\"DAY_PERIOD\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.DAY_PERIOD\"></span></md-radio-button><md-radio-button value=\"WEEK_DAY\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.WEEK_DAY\"></span></md-radio-button></md-radio-group></div></div></div><!--<div class=\"row\" data-ng-if=\"vm.serviceItem.multiReserveConfig.repeatMode==\'WEEK_DAY\'\" >--><!--<div class=\"col-md-10\">--><!--<div class=\"form-group\">--><!--<fieldset class=\"standard\" >--><!--<legend>--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatOnWeekdays\"--><!--for=\"field_qty\"--><!--eo-help-tooltip=\"tips.multiReserveConfig_repeatOnWeekdays\"--><!--&gt;repeatMode</label>--><!--</legend>--><!--<div class=\"row\">--><!--<div class=\"col-sm-3\"  ng-repeat=\"weekDay in vm.weekDays\">--><!--<md-checkbox ng-checked=\"vm.weekDayExists(weekDay)\" ng-click=\"vm.toggleWeekDay(weekDay)\">--><!--{{ \'tikonApp.WeekDay.\'+weekDay | translate }}--><!--</md-checkbox>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--></div></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.canBeCanceled\" for=\"field_canBeCanceled\">Can--><!--Be Canceled</label>--><!--<input type=\"checkbox\" class=\"form-control\" name=\"canBeCanceled\" id=\"field_canBeCanceled\"--><!--ng-model=\"vm.serviceItem.canBeCanceled\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceItem.minPreCancelTime\"--><!--for=\"field_minPreCancelTime\">Min Pre Cancel Time</label>--><!--<input type=\"number\" class=\"form-control\" name=\"minPreCancelTime\" id=\"field_minPreCancelTime\"--><!--ng-model=\"vm.serviceItem.minPreCancelTime\"--><!--/>--><!--</div>--></div></div></div></div><div id=\"serviceOptionSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.optionTab\" eo-help-tooltip=\"tips.service_options\">optionTab</span></div><div class=\"panel-body\"><pf-service-item-option-info service-option-item=\"vm.serviceItem.serviceOptionItem\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.serviceOptionInfoFormState\"></pf-service-item-option-info></div></div></div><div id=\"priceInfoSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.priceTab\" eo-help-tooltip=\"tips.service_price_info\">priceTab</span></div><div class=\"panel-body\"><pf-service-item-price-info service-item-id=\"vm.serviceItem.id\" on-create-new-price-info=\"vm.onCreateNewPriceInfo\" on-selected-price-info-changed=\"vm.onSelectedPriceInfoChanged\" form-state=\"vm.priceInfoFormState\" new-price-info=\"vm.serviceItem.newPriceInfo\" reload=\"vm.priceInfoFormReload\" price-infos=\"vm.serviceItem.servicePriceInfo\" price-info-type=\"vm.priceInfoType\"></pf-service-item-price-info></div></div></div><!--<div id=\"amenitiesSection\" ng-if=\"\">--><!--<div class=\"panel \">--><!--<div class=\"panel-heading\">--><!--<span translate=\"supplierPanel.sideMenu.serviceItem.amenitiesTab\">amenitiesTab</span>--><!--</div>--><!--<div class=\"panel-body\">--><!--<pf-service-item-amenities amenities=\"vm.serviceItem.amenities.amenitiesList\">--><!--</pf-service-item-amenities>--><!--</div>--><!--</div>--><!--</div>--> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><!--<span class=\"glyphicon glyphicon-save\"></span>--> <i class=\"fa fa-floppy-o\" aria-hidden=\"true\"></i> &nbsp;<span translate=\"entity.action.save\">Save</span></button></div><div name=\"commentedCode\"><!--<div>--><!--&lt;!&ndash;<ul class=\"nav nav-tabs  nav-justified lightnav\">&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<li class=\"active\"><a data-toggle=\"tab\" data-target=\"#generalTab\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.generalTab\">generalTab </span>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#scheduleTab\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.scheduleTab\">scheduleTab </span>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#priceTab\">&ndash;&gt;--><!--&lt;!&ndash;<i class=\"fa fa-money\" aria-hidden=\"true\"></i>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.priceTab\">priceTab </span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;     <li><a data-toggle=\"tab\" data-target=\"#capacityTab\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.capacityTab\">capacityTab </span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;   <li><a data-toggle=\"tab\" data-target=\"#discountTab\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.discountTab\">discountTab </span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#imageAlbumTab\">&ndash;&gt;--><!--&lt;!&ndash;<i class=\"fa fa-file-image-o\" aria-hidden=\"true\"></i>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.imageAlbumTab\">imageAlbumTab </span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;--><!--&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#optionTab\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicons glyphicons-check\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.optionTab\">optionTab </span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#settingTab\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"fa fa-gear\" aria-hidden=\"true\"></i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<span translate=\"supplierPanel.sideMenu.serviceItem.settingTab\">settingTab </span>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#agreementTab\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicons glyphicons-notes-2\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"no-wrap\" translate=\"supplierPanel.sideMenu.serviceItem.agreementTab\">agreementTab </span>&ndash;&gt;--><!--&lt;!&ndash;</a></li>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#locationTab\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<span class=\"no-wrap\" translate=\"supplierPanel.sideMenu.serviceItem.locationTab\">Location Tab </span>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#servantTab\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"fa fa-users fa-fw\"></i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<span class=\"no-wrap\" translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">servantTab </span>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<li><a data-toggle=\"tab\" data-target=\"#amenitiesTab\" has-authority=\"ROLE_OFFICE_MANAGER\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<i class=\"fa fa-building fa-fw\"></i>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<span class=\"no-wrap\" translate=\"supplierPanel.sideMenu.serviceItem.amenitiesTab\">amenitiesTab </span>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</a></li>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</ul>&ndash;&gt;--><!--</div>--><!--<div class=\"tab-content panel panel-default\">--><!--<div id=\"generalTab\" class=\"tab-pane fade in active\">--><!--&lt;!&ndash;<div class=\"modal-body\">&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"form-group\" ng-show=\"vm.serviceItem.id\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label for=\"id\" translate=\"global.field.id\">ID</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;ng-model=\"vm.serviceItem.id\" readonly />&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<div class=\"row\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" required translate=\"tikonApp.serviceItem.itemTitle\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_itemTitle\">Item&ndash;&gt;--><!--&lt;!&ndash;Title</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.itemTitle\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.category\" required for=\"field_category\">Category</label>&ndash;&gt;--><!--&lt;!&ndash;<select class=\"form-control\" id=\"field_category\" name=\"category\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.category.id\"&ndash;&gt;--><!--&lt;!&ndash;ng-options=\"serviceCategory.id as vm.categoryName(serviceCategory.categoryName)  for serviceCategory in vm.servicecategories\"&ndash;&gt;--><!--&lt;!&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</select>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" required translate=\"tikonApp.serviceItem.serviceStatus\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_serviceStatus\">Service&ndash;&gt;--><!--&lt;!&ndash;Status</label>&ndash;&gt;--><!--&lt;!&ndash;<select class=\"form-control\" name=\"serviceStatus\" ng-model=\"vm.serviceItem.serviceStatus\"&ndash;&gt;--><!--&lt;!&ndash;id=\"field_serviceStatus\">&ndash;&gt;--><!--&lt;!&ndash;<option value=\"\" translate=\"global.pleaseSelectItem\">&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"DISABLE\" translate=\"tikonApp.ServiceItemStatus.DISABLE\">&ndash;&gt;--><!--&lt;!&ndash;DISABLE&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"PUBLISH\" translate=\"tikonApp.ServiceItemStatus.PUBLISH\">&ndash;&gt;--><!--&lt;!&ndash;PUBLISH&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"PUBLISH_JUST_PANEL\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"tikonApp.ServiceItemStatus.PUBLISH_JUST_PANEL\">&ndash;&gt;--><!--&lt;!&ndash;PUBLISH_JUST_PANEL&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;</select>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" required translate=\"tikonApp.serviceItem.description\" for=\"field_description\">Description</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.description\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.serviceType\" for=\"field_serviceType\">Service&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;Type</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<select class=\"form-control\" name=\"serviceType\" ng-model=\"vm.serviceItem.serviceType\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;id=\"field_serviceType\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<option value=\"INDEPENDENT_SERVICE\" translate=\"tikonApp.ServiceItemType.INDEPENDENT_SERVICE\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;INDEPENDENT_SERVICE&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</option>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<option value=\"SERVICE_PACKAGE\" translate=\"tikonApp.ServiceItemType.SERVICE_PACKAGE\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;SERVICE_PACKAGE&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</option>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<option value=\"DEPENDENT_SERVICE\" translate=\"tikonApp.ServiceItemType.DEPENDENT_SERVICE\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;DEPENDENT_SERVICE&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</option>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</select>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<div class=\"row\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" required translate=\"tikonApp.serviceCapacityInfo.qty\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_qty\">Qty</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"number\" class=\"form-control\" min=\"1\" name=\"qty\" id=\"field_qty\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.capacityInfo.qty\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" required translate=\"tikonApp.serviceItem.minPrice\" for=\"field_minPrice\">Min&ndash;&gt;--><!--&lt;!&ndash;Price</label>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"global.currencyBracket\"></span>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"number\" class=\"form-control\" name=\"minPrice\" id=\"field_minPrice\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.minPrice\" min=\"0\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.maxDiscount\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;for=\"field_maxDiscount\">Max&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;Discount</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<input type=\"number\" class=\"form-control\" name=\"maxDiscount\" id=\"field_maxDiscount\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;ng-model=\"vm.serviceItem.maxDiscount\" min=\"0\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;/>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.tags\" for=\"field_tags\">Tags</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<eo-multi-select id=\"field_tags\" list=\"vm.serviceItem.tags\" items=\"vm.metatags\" displaytag=\"tag\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;displayitem=\"tag\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</eo-multi-select>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.serviceItem.fullDescription\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_fullDescription\">Full Description</label>&ndash;&gt;--><!--&lt;!&ndash;<div height=\"300\" type=\"text\" summernote class=\"form-control\" name=\"fullDescription\"&ndash;&gt;--><!--&lt;!&ndash;id=\"field_fullDescription\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.fullDescription\"&ndash;&gt;--><!--&lt;!&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div id=\"scheduleTab\" class=\"tab-pane fade\">--><!--<div id=\"scheduleInfoList\">--><!--</div>--><!--</div>--><!--<div id=\"settingTab\" class=\"tab-pane fade\">--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.hasWaitingList\" for=\"field_hasWaitingList\">Has&ndash;&gt;--><!--&lt;!&ndash;Waiting List</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"checkbox\" class=\"form-control\" name=\"hasWaitingList\" id=\"field_hasWaitingList\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.hasWaitingList\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"row\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.confirmationType\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_confirmationType\">Confirmation Type</label>&ndash;&gt;--><!--&lt;!&ndash;<select class=\"form-control\" name=\"confirmationType\" ng-model=\"vm.serviceItem.confirmationType\"&ndash;&gt;--><!--&lt;!&ndash;id=\"field_confirmationType\">&ndash;&gt;--><!--&lt;!&ndash;<option value=\"ONE_STEP\" translate=\"tikonApp.ServiceConfirmationType.ONE_STEP\">&ndash;&gt;--><!--&lt;!&ndash;ONE_STEP&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"TWO_STEP\" translate=\"tikonApp.ServiceConfirmationType.TWO_STEP\">&ndash;&gt;--><!--&lt;!&ndash;TWO_STEP&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;</select>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-8\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<input type=\"checkbox\" name=\"mustGetParticipantInfo\"&ndash;&gt;--><!--&lt;!&ndash;id=\"field_mustGetParticipantInfo\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.mustGetParticipantInfo\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.mustGetParticipantInfo\"&ndash;&gt;--><!--&lt;!&ndash;eo-help-tooltip=\"tips.must_get_participant_on_service_item\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_mustGetParticipantInfo\">Must Get Participant Info</label>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"row\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.paymentType\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_paymentType\">Payment Type</label>&ndash;&gt;--><!--&lt;!&ndash;<select class=\"form-control\" name=\"paymentType\" ng-model=\"vm.serviceItem.paymentType\"&ndash;&gt;--><!--&lt;!&ndash;ng-change=\"vm.paymentType_changed()\"&ndash;&gt;--><!--&lt;!&ndash;id=\"field_paymentType\">&ndash;&gt;--><!--&lt;!&ndash;<option value=\"PAYMENT_ALL\" translate=\"tikonApp.ServicePaymentType.PAYMENT_ALL\">&ndash;&gt;--><!--&lt;!&ndash;PAYMENT_ALL&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"PRE_PAYMENT\" translate=\"tikonApp.ServicePaymentType.PRE_PAYMENT\">&ndash;&gt;--><!--&lt;!&ndash;PRE_PAYMENT&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;</select>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\" ng-if=\"vm.serviceItem.paymentType==\'PRE_PAYMENT\'\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.prePaymentAmount\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_prePaymentAmount\">Pre Payment Amount</label>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"global.currencyBracket\"></span>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"number\" class=\"form-control\" name=\"prePaymentAmount\" id=\"field_prePaymentAmount\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.prePaymentAmount\"&ndash;&gt;--><!--&lt;!&ndash;min=\"0\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;commentec for now&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-4\" ng-if=\"vm.serviceItem.paymentType==\'PAYMENT_ALL\'\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\" style=\"padding-top: 30px\">&ndash;&gt;--><!--&lt;!&ndash;<input type=\"checkbox\" name=\"inPlacePayment\"&ndash;&gt;--><!--&lt;!&ndash;id=\"field_inPlacePayment\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.inPlacePayment\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.inPlacePayment\" eo-help-tooltip=\"tips.in_place_payment_on_service_item\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_inPlacePayment\">In Place Payment</label>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.serviceItem.minPreReserveTime1\"></span>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"number\" class=\"shortTextBox\" name=\"minPreReserveTime\" id=\"field_minPreReserveTime\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.minPreReserveTime\"&ndash;&gt;--><!--&lt;!&ndash;min=\"0\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.serviceItem.minPreReserveTime2\"></span>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.serviceItem.maxPreReserveTime1\"></span>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"number\" class=\"shortTextBox\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.maxPreReserveTime\"&ndash;&gt;--><!--&lt;!&ndash;min=\"0\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.serviceItem.maxPreReserveTime2\"></span>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.maxPreReserveTime\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;for=\"field_maxPreReserveTime\">Max Pre Reserve Time</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<input type=\"number\" class=\"form-control\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;ng-model=\"vm.serviceItem.maxPreReserveTime\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;placeholder=\"{{\'tikonApp.serviceItem.maxPreReserveTimeDescription\' | translate}}\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;min=\"0\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;/>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.canBeCanceled\" for=\"field_canBeCanceled\">Can&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;Be Canceled</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<input type=\"checkbox\" class=\"form-control\" name=\"canBeCanceled\" id=\"field_canBeCanceled\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;ng-model=\"vm.serviceItem.canBeCanceled\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;/>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.serviceItem.minPreCancelTime\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;for=\"field_minPreCancelTime\">Min Pre Cancel Time</label>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<input type=\"number\" class=\"form-control\" name=\"minPreCancelTime\" id=\"field_minPreCancelTime\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"vm.serviceItem.minPreCancelTime\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div id=\"imageAlbumTab\" class=\"tab-pane fade\">--><!--&lt;!&ndash;<eo-image-gallery-manager album-id=\"vm.serviceItem.imageAlbumId\" crop-width=\"500\" crop-height=\"400\"&ndash;&gt;--><!--&lt;!&ndash;album-caption=\"vm.serviceItem.item_title\"></eo-image-gallery-manager>&ndash;&gt;--><!--&lt;!&ndash; <div class=\"form-group\">--><!--<label translate=\"tikonApp.serviceItem.imageAlbum\" for=\"field_imageAlbum\">Image Album</label>--><!--<select class=\"form-control\" id=\"field_imageAlbum\" name=\"imageAlbum\"--><!--ng-model=\"vm.serviceItem.imageAlbumId\"--><!--ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\">--><!--<option value=\"\"></option>--><!--</select>--><!--</div>&ndash;&gt;--><!--</div>--><!--<div id=\"optionTab\" class=\"tab-pane fade\">--><!--<div id=\"serviceOptionInfo\">--><!--<pf-service-item-option-info service-option-item=\"vm.serviceItem.serviceOptionItem\"--><!--service-item-id=\"vm.serviceItem.id\"--><!--form-state=\"vm.serviceOptionInfoFormState\">--><!--</pf-service-item-option-info>--><!--</div>--><!--</div>--><!--<div id=\"priceTab\" class=\"tab-pane fade\">--><!--<div id=\"priceInfo\">--><!--<pf-service-item-price-info service-item-id=\"vm.serviceItem.id\"--><!--on-create-new-price-info=\"vm.onCreateNewPriceInfo\"--><!--on-selected-price-info-changed=\"vm.onSelectedPriceInfoChanged\"--><!--form-state=\"vm.priceInfoFormState\"--><!--new-price-info=\"vm.serviceItem.newPriceInfo\"--><!--reload=\"vm.priceInfoFormReload\"--><!--price-infos=\"vm.serviceItem.servicePriceInfo\"--><!--price-info-type=\"vm.priceInfoType\"--><!--&gt;--><!--</pf-service-item-price-info>--><!--</div>--><!--</div>--><!--<div id=\"agreementTab\" class=\"tab-pane fade\">--><!--<div id=\"agreementInfo\">--><!--<pf-service-item-agreement-info agreement=\"vm.serviceItem.agreement\">--><!--</pf-service-item-agreement-info>--><!--</div>--><!--</div>--><!--<div id=\"locationTab\" class=\"tab-pane fade\">--><!--<div id=\"location\">--><!--<pf-location-info location-info=\"vm.serviceItem.location\">--><!--</pf-location-info>--><!--</div>--><!--</div>--><!--<div id=\"servantTab\" class=\"tab-pane fade\">--><!--&lt;!&ndash;<div id=\"servants\">&ndash;&gt;--><!--&lt;!&ndash;<pf-service-item-servants servants=\"vm.serviceItem.servants\" service-item-id=\"vm.serviceItem.id\"&ndash;&gt;--><!--&lt;!&ndash;form-state=\"vm.servantFormState\">&ndash;&gt;--><!--&lt;!&ndash;</pf-service-item-servants>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div id=\"amenitiesTab\" class=\"tab-pane fade\" has-authority=\"ROLE_OFFICE_MANAGER\">--><!--<div id=\"serviceItemAmenities\">--><!--<pf-service-item-amenities amenities=\"vm.serviceItem.amenities.amenitiesList\">--><!--</pf-service-item-amenities>--><!--</div>--><!--</div>--><!--</div>--></div><!--  <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span>\n          </button>\n          <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span>\n          </button>\n      </div>--></form>");
$templateCache.put("app/entities/service-item/service-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceItem.delete.question\" translate-values=\"{id: \'{{vm.serviceItem.id}}\'}\">Are you sure you want to delete this Service Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-item/service-item-detail.html","<div><h2><span translate=\"tikonApp.serviceItem.detail.title\">Service Item</span> {{vm.serviceItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span></dt><dd><span>{{vm.serviceItem.itemTitle}}</span></dd><dt><span translate=\"tikonApp.serviceItem.description\">Description</span></dt><dd><span>{{vm.serviceItem.description}}</span></dd><dt><span translate=\"tikonApp.serviceItem.minPreReserveTime\">Min Pre Reserve Time</span></dt><dd><span>{{vm.serviceItem.minPreReserveTime}}</span></dd><dt><span translate=\"tikonApp.serviceItem.maxPreReserveTime\">Max Pre Reserve Time</span></dt><dd><span>{{vm.serviceItem.maxPreReserveTime}}</span></dd><dt><span translate=\"tikonApp.serviceItem.hasWaitingList\">Has Waiting List</span></dt><dd><span>{{vm.serviceItem.hasWaitingList}}</span></dd><dt><span translate=\"tikonApp.serviceItem.mustGetParticipantInfo\">Must Get Participant Info</span></dt><dd><span>{{vm.serviceItem.mustGetParticipantInfo}}</span></dd><dt><span translate=\"tikonApp.serviceItem.canBeCanceled\">Can Be Canceled</span></dt><dd><span>{{vm.serviceItem.canBeCanceled}}</span></dd><dt><span translate=\"tikonApp.serviceItem.minPreCancelTime\">Min Pre Cancel Time</span></dt><dd><span>{{vm.serviceItem.minPreCancelTime}}</span></dd><dt><span translate=\"tikonApp.serviceItem.paymentType\">Payment Type</span></dt><dd><span>{{vm.serviceItem.paymentType}}</span></dd><dt><span translate=\"tikonApp.serviceItem.ownerType\">Service Type</span></dt><dd><span translate=\"{{\'tikonApp.ServiceItemType.\' + vm.serviceItem.ownerType}}\">{{vm.serviceItem.ownerType}}</span></dd><dt><span translate=\"tikonApp.serviceItem.options\">Options</span></dt><dd><span ng-repeat=\"options in vm.serviceItem.options\"><a ui-sref=\"service-option-info-detail({id: {{options.id}}})\">{{options.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.serviceItem.discountInfo\">Discount Info</span></dt><dd><a ui-sref=\"discount-info-detail({id:vm.serviceItem.discountInfoId})\">{{vm.serviceItem.discountInfoId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.location\">Location</span></dt><dd><a ui-sref=\"location-info-detail({id:vm.serviceItem.locationId})\">{{vm.serviceItem.locationId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.imageAlbum\">Image Album</span></dt><dd><a ui-sref=\"album-info-detail({id:vm.serviceItem.imageAlbumId})\">{{vm.serviceItem.imageAlbumId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.capacityInfo\">Capacity Info</span></dt><dd><a ui-sref=\"service-capacity-info-detail({id:vm.serviceItem.capacityInfoId})\">{{vm.serviceItem.capacityInfoId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.category\">Category</span></dt><dd><a ui-sref=\"service-category-detail({id:vm.serviceItem.categoryId})\">{{vm.serviceItem.categoryId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.priceinfo\">Priceinfo</span></dt><dd><a ui-sref=\"price-info-detail({id:vm.serviceItem.priceinfoId})\">{{vm.serviceItem.priceinfoId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.serviceTimes\">Service Times</span></dt><dd><span ng-repeat=\"serviceTimes in vm.serviceItem.serviceTimes\"><a ui-sref=\"schedule-info-detail({id: {{serviceTimes.id}}})\">{{serviceTimes.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.serviceItem.servants\">Servants</span></dt><dd><span ng-repeat=\"servants in vm.serviceItem.servants\"><a ui-sref=\"servant-detail({id: {{servants.id}}})\">{{servants.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.serviceItem.agreement\">Agreement</span></dt><dd><a ui-sref=\"agreement-info-detail({id:vm.serviceItem.agreementId})\">{{vm.serviceItem.agreementId}}</a></dd><dt><span translate=\"tikonApp.serviceItem.tags\">Tags</span></dt><dd><span ng-repeat=\"tags in vm.serviceItem.tags\"><a ui-sref=\"meta-tag-detail({id: {{tags.id}}})\">{{tags.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-item/service-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceItemLabel\" translate=\"tikonApp.serviceItem.home.createOrEditLabel\">Create or edit a Service Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"vm.serviceItem.itemTitle\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.intakeFields\" for=\"field_intakeFields\">IntakeFields</label><input type=\"text\" class=\"form-control\" name=\"intakeFields\" id=\"field_intakeFields\" ng-model=\"vm.serviceItem.intakeFields\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.customerSatisfactionMessage\" for=\"field_customerSatisfactionMessage\">CustomerSatisfactionMessage</label><input type=\"text\" class=\"form-control\" name=\"customerSatisfactionMessage\" id=\"field_customerSatisfactionMessage\" ng-model=\"vm.serviceItem.customSettingObject.customerSatisfactionMessage\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.isDeleted\">isDeleted</label><md-checkbox ng-model=\"vm.serviceItem.isDeleted\"></md-checkbox></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.orderNo\" for=\"field_orderNo\">orderNo</label><input type=\"text\" class=\"form-control\" name=\"orderNo\" id=\"field_orderNo\" ng-model=\"vm.serviceItem.orderNo\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceItem.tags\" for=\"field_tags\">Tags</label><select class=\"form-control\" id=\"field_tags\" multiple=\"multiple\" name=\"tags\" ng-model=\"vm.serviceItem.tags\" ng-options=\"metaTag as metaTag.id for metaTag in vm.metatags track by metaTag.id\"></select></div><div class=\"form-group\"><pf-sms-text-editor label=\"\'پیامک ثبت رزرو مشتری\'\" sms-text=\"vm.serviceItem.customSettingObject.customReservationMessage\"></pf-sms-text-editor></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-item/service-item-list.html","<div class=\"hidden-xs\"><h2 translate=\"tikonApp.serviceItem.home.title\">Service Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"supplierPanel.generalServiceItemV2()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.home.createLabel\">Create new Service Item</span></button></div></div></div><br><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceItems\" st-table=\"collection\" st-safe- class=\"jh-table table table-striped\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control\" placeholder=\"{{ \'tikonApp.serviceItem.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th st-sort=\"id\"><span translate=\"global.field.id\">ID</span></th><th st-sort=\"itemTitle\"><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span></th><th st-sort=\"categoryId\"><span translate=\"tikonApp.serviceItem.category\">Category</span></th><th st-sort=\"description\"><span translate=\"tikonApp.serviceItem.description\">Description</span></th><th st-sort=\"serviceStatus\"><span translate=\"tikonApp.serviceItem.serviceStatus\">Service Status</span></th><th></th><th></th></tr><!--<tr>--><!--<th></th>--><!--<th >--><!--<input st-search=\"itemTitle\" placeholder=\"جستجو بر اساس عنوان سرویس\" class=\"input-sm form-control\" type=\"search\"/>--><!--</th>--><!--</tr>--></thead><tbody><tr ng-repeat=\"serviceItem in collection track by serviceItem.id\"><td><a ui-sref=\"supplierPanel.generalServiceItemV2({id:serviceItem.id})\">{{serviceItem.id}}</a></td><td>{{serviceItem.itemTitle}}</td><!--<td>{{serviceItem.category.categoryName}}</td>--><td>{{vm.categoryName(serviceItem.category.categoryName)}}<!--<span translate=\"{{\'tikonApp.serviceItem.\' + serviceItem.category.categoryName}}\">{{serviceItem.category.categoryName}}</span>--></td><td>{{serviceItem.description}}</td><td ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></td><!--<td>{{serviceItem.minPreReserveTime}}</td>--><!--<td>{{serviceItem.maxPreReserveTime}}</td>--><!--<td>{{serviceItem.hasWaitingList}}</td>--><!--<td>{{serviceItem.mustGetParticipantInfo}}</td>--><!--<td>{{serviceItem.canBeCanceled}}</td>--><!--<td>{{serviceItem.minPreCancelTime}}</td>--><!--<td>{{serviceItem.paymentType}}</td>--><!--<td translate=\"{{\'tikonApp.ServiceItemType.\' + serviceItem.serviceType}}\">{{serviceItem.serviceType}}</td>--><!--<td>--><!--<a ui-sref=\"discount-info-detail({id:serviceItem.discountInfoId})\">{{serviceItem.discountInfoId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"location-info-detail({id:serviceItem.locationId})\">{{serviceItem.locationId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"album-info-detail({id:serviceItem.imageAlbumId})\">{{serviceItem.imageAlbumId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"service-capacity-info-detail({id:serviceItem.capacityInfoId})\">{{serviceItem.capacityInfoId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"service-category-detail({id:serviceItem.categoryId})\">{{serviceItem.categoryId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"price-info-detail({id:serviceItem.priceinfoId})\">{{serviceItem.priceinfoId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"agreement-info-detail({id:serviceItem.agreementId})\">{{serviceItem.agreementId}}</a>--><!--</td>--><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button class=\"btn btn-info btn-sm\" ui-sref=\"supplierPanel.scheduling({id:serviceItem.id})\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> <span translate=\"tikonApp.serviceItem.scheduling\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"supplierPanel.generalServiceItem({id:serviceItem.id})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>--> <button type=\"submit\" ui-sref=\"supplierPanel.generalServiceItemV2({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button><!--  <button type=\"submit\"\n                                  ui-sref=\"service-item.delete({id:serviceItem.id})\"\n                                  class=\"btn btn-danger btn-sm\">\n                              <span class=\"glyphicon glyphicon-remove-circle\"></span>\n                              <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>\n                          </button>--></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs\"><h4 style=\"padding-right: 10px\" translate=\"tikonApp.serviceItem.home.title\">Service Items</h4><jhi-alert></jhi-alert><div class=\"float-mobile-button\" ui-sref=\"supplierPanel.generalServiceItem()\"><i class=\"fa fa-plus fa-lg\" style=\"margin-top: 18px\"></i></div><div class=\"orderBag-mobile-block\" ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\" ui-sref=\"supplierPanel.generalServiceItem({id:serviceItem.id})\"><div class=\"row\"><div class=\"orderBag-mobile-float\">{{serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{serviceItem.category.categoryName}}</div></div></div></div></div>");
$templateCache.put("app/entities/service-item/service-items.html","<div><h2 translate=\"tikonApp.serviceItem.home.title\">Service Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.home.createLabel\">Create new Service Item</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceItem.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"itemTitle\"><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.serviceItem.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"categoryName\"><span translate=\"tikonApp.serviceItem.category\">Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderNo\"><span>Order No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"isDeleted\"><span>isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"maxPreReserveTime\"><span translate=\"tikonApp.serviceItem.maxPreReserveTime\">Max Pre Reserve Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"hasWaitingList\"><span translate=\"tikonApp.serviceItem.hasWaitingList\">Has Waiting List</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"mustGetParticipantInfo\"><span translate=\"tikonApp.serviceItem.mustGetParticipantInfo\">Must Get Participant Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"canBeCanceled\"><span translate=\"tikonApp.serviceItem.canBeCanceled\">Can Be Canceled</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"minPreCancelTime\"><span translate=\"tikonApp.serviceItem.minPreCancelTime\">Min Pre Cancel Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"paymentType\"><span translate=\"tikonApp.serviceItem.paymentType\">Payment Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"ownerType\"><span translate=\"tikonApp.serviceItem.ownerType\">Service Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"discountInfoId\"><span translate=\"tikonApp.serviceItem.discountInfo\">Discount Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"locationId\"><span translate=\"tikonApp.serviceItem.location\">Location</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"imageAlbumId\"><span translate=\"tikonApp.serviceItem.imageAlbum\">Image Album</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"capacityInfoId\"><span translate=\"tikonApp.serviceItem.capacityInfo\">Capacity Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"categoryId\"><span translate=\"tikonApp.serviceItem.category\">Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"priceinfoId\"><span translate=\"tikonApp.serviceItem.priceinfo\">Priceinfo</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"agreementId\"><span translate=\"tikonApp.serviceItem.agreement\">Agreement</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\"><td><a ui-sref=\"service-item-detail({id:serviceItem.id})\">{{serviceItem.id}}</a></td><td>{{serviceItem.itemTitle}}</td><td>{{serviceItem.description}}</td><td>{{serviceItem.category.categoryName}}</td><td>{{serviceItem.orderNo}}</td><td>{{serviceItem.isDeleted}}</td><!--<td>{{serviceItem.minPreReserveTime}}</td>--><!--<td>{{serviceItem.maxPreReserveTime}}</td>--><!--<td>{{serviceItem.hasWaitingList}}</td>--><!--<td>{{serviceItem.mustGetParticipantInfo}}</td>--><!--<td>{{serviceItem.canBeCanceled}}</td>--><!--<td>{{serviceItem.minPreCancelTime}}</td>--><!--<td>{{serviceItem.paymentType}}</td>--><!--<td translate=\"{{\'tikonApp.ServiceItemType.\' + serviceItem.ownerType}}\">{{serviceItem.ownerType}}</td>--><!--<td>--><!--<a ui-sref=\"discount-info-detail({id:serviceItem.discountInfoId})\">{{serviceItem.discountInfoId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"location-info-detail({id:serviceItem.locationId})\">{{serviceItem.locationId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"album-info-detail({id:serviceItem.imageAlbumId})\">{{serviceItem.imageAlbumId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"service-capacity-info-detail({id:serviceItem.capacityInfoId})\">{{serviceItem.capacityInfoId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"service-category-detail({id:serviceItem.categoryId})\">{{serviceItem.categoryId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"price-info-detail({id:serviceItem.priceinfoId})\">{{serviceItem.priceinfoId}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref=\"agreement-info-detail({id:serviceItem.agreementId})\">{{serviceItem.agreementId}}</a>--><!--</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-item-detail({id:serviceItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-item.edit({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-item.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-item-v2/event-item-list-v2.html","<style>.serviceColorCircle {\n        width: 15px;\n        height: 15px;\n        /*padding: 13px;*/\n        /* margin: 13px; */\n        min-width: 15px;\n        border-radius: 25px;\n    }\n\n    .modal-content {\n        border-radius: 4px;\n    }\n      @media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span translate=\"supplierPanel.sideMenu.eventItemList\">supplierPanel.sideMenu.eventItemList</span><div class=\"education-link\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body pl-panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary pl-btn-primary pl-btn\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel-v2.eventItemList.eventItem\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.eventItem.home.createLabel\">Create new Service Item</span></md-button><md-button class=\"md-raised md-secondary pl-btn-default pl-btn\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel-v2.companyServiceCategoryList\"><span class=\"hidden-xs\" translate=\"supplierPanel.sideMenu.eventCategory-v2\">serviceCategory</span></md-button><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceItem.home.searchPlaceHolder\'\" on-search=\"vm.searchServiceItem()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th><span></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"itemTitle\"><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span></th><th st-sort=\"categoryId\"><span translate=\"tikonApp.serviceItem.category\">Category</span></th><th st-sort=\"description\"><span translate=\"tikonApp.serviceItem.description\">Description</span></th><th st-sort=\"serviceStatus\"><span translate=\"tikonApp.serviceItem.serviceStatus\">Service Status</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceItem in collection track by serviceItem.id\"><td><md-icon ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px\">videocam</md-icon></td><td><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div></td><td><a ui-sref=\"supplierPanel-v2.eventItemList.eventItem({id:serviceItem.id})\">{{serviceItem.itemTitle}}</a></td><td>{{vm.categoryName(serviceItem.category.categoryName)}}</td><td>{{serviceItem.description}}</td><td ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel-v2.eventItemList.eventItem({id:serviceItem.id})\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.copyServiceItem(serviceItem.id)\" ui-sref=\"supplierPanel-v2.eventItemList.copy({id:serviceItem.id})\" class=\"btn btn-secondary pl-btn-default btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel-v2.eventItemList.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newServiceItem()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 service-item-title-container\"><div style=\"display: flex; align-items: center\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.eventItem.home.title\">title</h3><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.companyServiceCategoryList\"><md-icon style=\"color: #000\">folder_copy</md-icon><span class=\"\" translate=\"tikonApp.eventItem.category\">serviceCategory</span></md-button></div></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceItem.home.searchPlaceHolder\'\" on-search=\"vm.searchServiceItem()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\" class=\"customer-list-item\" ng-click=\"vm.editServiceItem(serviceItem)\"><div ng-class=\"serviceItem.color\" class=\"service-color-line\"></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-name\">{{serviceItem.itemTitle}}</div><div class=\"service-item-list-price-row\"><div>{{vm.categoryName(serviceItem.category.categoryName)}}</div><div ng-if=\"serviceItem.minPrice>0\" style=\"font-size: 12px\">{{serviceItem.minPrice | number}} <span translate=\"global.currency\"></span></div></div><div class=\"service-list-icons\"><div class=\"service-list-icons-video\" ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span style=\"height: 20px\" ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span style=\"color: #000\" translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></div><div class=\"service-list-icons-video\" ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\"><md-icon aria-hidden=\"true\" class=\"pl-icon\" style=\"font-size: 20px\">videocam</md-icon><div>تصویری</div></div></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div>");
$templateCache.put("app/entities/service-item-v2/general-service-item-v2.html","<form name=\"serviceItemForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><style>.shortTextBox {\n            width: 50px;\n            font-size: 16px;\n            font-weight: bold;\n            text-align: center;\n        }\n\n        .largeTextBox {\n            width: 100px;\n            font-size: 16px;\n            font-weight: bold;\n            text-align: center;\n        }\n\n        .serviceColorPick {\n            width: 100px;\n            height: 25px;\n            /*padding: 13px;*/\n            /* margin: 13px; */\n            margin: 0 5px 9px;\n            border-radius: 8px;\n        }\n\n        .payment-deadline {\n            display: flex;\n            gap: 5px;\n            align-items: baseline;\n        }\n\n        .auto-payment-switch {\n\n        }\n\n        .column-with-switch {\n            margin-top: -12px;\n            display: flex\n        }\n\n        .advanced-setting, .full-description {\n            border: 1px solid;\n            padding: 0px 20px 0 0px;\n            border-radius: 5px;\n            background-color: #f1f9f1;\n            color: green;\n            max-width: 155px;\n            margin-top: -10px;\n            display: flex;\n            align-items: center;\n\n        }\n\n        .full-description {\n            min-width: 200px !important;\n            background-color: #f2f3f1 !important;\n            color: #404040 !important;\n        }\n\n        .arrow-animate {\n            transform: rotate(0deg);\n            transition: transform 0.2s linear;\n        }\n\n        .arrow-animate-left {\n            transform: rotate(90deg);\n            transition: transform 0.2s linear;\n        }\n\n\n        @keyframes rotate90 {\n            50% {\n                transform: rotate(90deg);\n            }\n        }\n\n        @media screen and (max-width: 768px) {\n            .auto-payment-switch {\n                white-space: normal;\n            }\n\n            .column-with-switch {\n                margin-top: 0px;\n                display: flex\n            }\n        }</style><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button ng-disabled=\"serviceItemForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\" class=\"md-raised md-primary\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ng-click=\"vm.backToList()\"><span><md-icon>list</md-icon></span><span ng-if=\"!vm.isEventMode\" translate=\"entity.action.backToServiceList\">entity.action.backToServiceList </span><span ng-if=\"vm.isEventMode\" translate=\"entity.action.backToEventList\">entity.action.backToEventList</span></md-button></div><a ui-sref=\"supplierPanel.schedulingv2({id:vm.serviceItem.id})\"><md-button class=\"md-raised\" ng-if=\"vm.serviceItem.id && !vm.hasServants\"><span><md-icon>schedule</md-icon></span><span translate=\"tikonApp.serviceItem.scheduling\"></span></md-button></a></div><div id=\"generalSection\" class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.generalTab\">generalTab</span></div><div class=\"panel-body\"><div><div id=\"general\" class=\"\"><div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"vm.serviceItem.itemTitle\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.minPrice\" for=\"field_minPrice\">Min Price</label><!--<span translate=\"global.currencyBracket\"></span>--> <input type=\"number\" class=\"form-control\" name=\"minPrice\" id=\"field_minPrice\" ng-model=\"vm.serviceItem.minPrice\" min=\"0\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.category\" required for=\"field_category\" eo-help-tooltip=\"tips.service_category\">Category</label><!--<md-select class=\"rwMdSelect\"--><!--placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\"--><!--ng-model=\"vm.serviceItem.category.id\"--><!--style=\"min-width: 250px;margin-top: 6px;\"--><!--id=\"field_category\"--><!--&gt;--><!--<md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servicecategories\">--><!--{{si.categoryName}}--><!--</md-option>--><!--</md-select>--><select class=\"rwMdSelect plSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\" ng-model=\"vm.serviceItem.category\" id=\"field_category\" ng-options=\"si.categoryName for si in vm.servicecategories track by si.id\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"col-sm-6\" style=\"padding-right: 0\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.duration\" required for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" eo-required=\"\" ng-model=\"vm.serviceItem.duration\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Duration</label><input type=\"number\" id=\"field_gapTime\" class=\"form-control shortInput\" ng-model=\"vm.serviceItem.gaptime\"></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.serviceStatus\" for=\"field_serviceStatus\" eo-help-tooltip=\"tips.service_status\">Service Status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.serviceStatus\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_serviceStatus\"><md-option value=\"DISABLE\" translate=\"tikonApp.ServiceItemStatus.DISABLE\">DISABLE</md-option><md-option value=\"PUBLISH\" translate=\"tikonApp.ServiceItemStatus.PUBLISH\">PUBLISH</md-option><md-option value=\"RESERVE_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.RESERVE_JUST_PANEL\">RESERVE_JUST_PANEL</md-option><md-option value=\"PUBLISH_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.PUBLISH_JUST_PANEL\">PUBLISH_JUST_PANEL</md-option></md-select></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.serviceColor\" for=\"field_description\">Description</label><div><md-select class=\"rwMdSelect\" name=\"serviceColor\" ng-model=\"vm.serviceItem.color\" required><md-option ng-repeat=\"color in vm.serviceColors\" ng-value=\"color\"><div ng-class=\"color\" class=\"serviceColorPick\"></div></md-option></md-select></div></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceItem.description\"></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"padding-top: 32px\"><md-checkbox ng-model=\"vm.isVideoMeeting\" ng-change=\"vm.meetingCheckChange()\" eo-help-tooltip=\"tips.service_meeting_type\">{{\'tikonApp.serviceItem.meetingType.RW_VIDEO_CALL\' | translate}}<md-icon aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px;padding-top: 4px\">videocam</md-icon></md-checkbox></div></div></div></div><br></div><div class=\"form-group\"><div ng-click=\"vm.showFullDescription()\" class=\"full-description\"><span>درج توضیحات تکمیلی</span><!--<md-icon ></md-icon>--><md-icon ng-if=\"!vm.fullDescription\">add</md-icon><md-icon ng-if=\"vm.fullDescription\">remove</md-icon></div><div ng-if=\"vm.fullDescription\"><label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.serviceItem.fullDescription\" for=\"field_fullDescription\">Full Description</label><!--<div height=\"300\" type=\"text\" summernote class=\"form-control\" name=\"fullDescription\"--><!--id=\"field_fullDescription\"--><!--ng-model=\"vm.serviceItem.fullDescription\"--><!--&gt;--><!--</div>--><eo-rich-text-editor id=\"field_fullDescription\" input-value=\"vm.serviceItem.fullDescription\"></eo-rich-text-editor></div></div></div></div></div><div id=\"gallerySection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.imageAlbumTab\" eo-help-tooltip=\"tips.service_images\">imageAlbumTab</span></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel-body\"><eo-image-gallery-manager-v2 album-id=\"vm.serviceItem.imageAlbumId\" max-image-count=\"1\" crop-width=\"400\" crop-height=\"240\" album-caption=\"vm.serviceItem.item_title\"></eo-image-gallery-manager-v2></div></div></div></div></div><div id=\"servantSection\" class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">servantTab</span> <span translate=\"tikonApp.serviceItem.ServantSampleByActivityType.ActivityType.{{vm.currentCompany.activityType}}\" eo-help-tooltip=\"tips.service_servants\"></span></div><div class=\"panel-body\"><div id=\"servants\"><pf-service-item-servants servants=\"vm.serviceItem.servants\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.servantFormState\" activity-type=\"vm.currentCompany.activityType\" single-selection=\"vm.isEventMode\"></pf-service-item-servants></div><div ng-if=\"!vm.isEventMode\"><hr><div style=\"max-width: 400px\" ng-if=\"vm.serviceItem.servants && vm.serviceItem.servants.length>0\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.servantSelectMode\" for=\"field_servantSelectMode\">servantSelectMode</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.servantSelectMode\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_servantSelectMode\"><md-option value=\"SELECT_BY_CUSTOMER\" translate=\"tikonApp.ServantSelectMode.SELECT_BY_CUSTOMER\">SELECT_BY_CUSTOMER</md-option><md-option value=\"AUTO_SELECT_MOST_FREE_SERVANT\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_MOST_FREE_SERVANT\">AUTO_SELECT_MOST_FREE_SERVANT</md-option><md-option value=\"AUTO_SELECT_ROTATORY\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_ROTATORY\">AUTO_SELECT_ROTATORY</md-option><md-option value=\"AUTO_SELECT_RANDOM\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_RANDOM\">AUTO_SELECT_RANDOM</md-option></md-select></div></div></div></div></div><div id=\"timeSection\" ng-if=\"vm.isEventMode\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.eventItemSessions\">eventItemSessionsTab</span></div><div class=\"panel-body\"><div><div class=\"col-md-12\"><pf-event-item-schedules service-item-id=\"vm.serviceItemId\" selected-schedule-info=\"vm.serviceItem.scheduleInfo\" event-duration=\"vm.serviceItem.duration\"></pf-event-item-schedules></div></div></div></div></div><div id=\"agreementSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.agreementTab\">agreementTab</span></div><div class=\"panel-body\"><pf-service-item-agreement-info agreement=\"vm.serviceItem.agreement\"></pf-service-item-agreement-info></div></div></div><div ng-click=\"vm.showAdvancedSetting()\" class=\"advanced-setting\"><span>تنظیمات پیشرفته</span><!--<md-icon ></md-icon>--><md-icon ng-class=\"vm.getArrowClass()\">arrow_drop_down</md-icon></div><div ng-if=\"vm.advancedSetting\"><div id=\"settingSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.settingTab\">settingTab</span></div><div class=\"panel-body\"><div id=\"setting\" class=\"\"><fieldset class=\"standard-fieldset\"><legend><span eo-help-tooltip=\"tips.service_confirmation_type\" translate=\"tikonApp.serviceItem.confirmationTypeFieldSet\">Confirmation Type</span></legend><div class=\"row\"><div class=\"form-group col-md-4\"><md-radio-group ng-model=\"vm.serviceItem.confirmationType\" ng-change=\"vm.confirmationType_Change()\" layout=\"row\" class=\"setting-radio-box-inside\"><md-radio-button class=\"md-primary\" value=\"ONE_STEP\"><span translate=\"tikonApp.ServiceConfirmationType.ONE_STEP\">ONE_STEP</span></md-radio-button><md-radio-button eo-feature-checker=\"twoStepVerification\" class=\"md-primary\" value=\"TWO_STEP\"><span translate=\"tikonApp.ServiceConfirmationType.TWO_STEP\">TWO_STEP</span></md-radio-button></md-radio-group></div><div class=\"col-md-8 column-with-switch\" style=\"\"><span eo-help-tooltip=\"tips.service_auto_approve_for_payment\"><md-switch class=\"auto-payment-switch\" ng-disabled=\"!vm.hasAccesToTwoStpeFeature\" ng-model=\"vm.serviceItem.autoApproveForPayment\" ng-change=\"vm.autoApprove_Changed()\"><span translate=\"tikonApp.serviceItem.autoApproveForPayment\">Auto Send Payment Link َ</span></md-switch></span></div><!--content here --></div><div class=\"row\" ng-if=\"(vm.serviceItem.confirmationType==\'ONE_STEP\' && vm.serviceItem.autoApproveForPayment)||vm.serviceItem.confirmationType==\'TWO_STEP\' \"><div class=\"col-md-5 column-with-switch\"><span eo-help-tooltip=\"tips.payment_deadline\"><md-switch class=\"auto-payment-switch\" ng-model=\"vm.serviceItem.paymentDeadline\"><span translate=\"tikonApp.serviceItem.paymentDeadline\">Has Payment DeadLine َ</span></md-switch></span></div><div class=\"col-md-7\" ng-if=\"vm.serviceItem.paymentDeadline\"><div class=\"payment-deadline\"><span translate=\"tikonApp.serviceItem.customerConfirmationDeadline\">customerConfirmationDeadline</span> <input type=\"number\" class=\"shortTextBox\" name=\"customerConfirmationDeadline\" id=\"field_customerConfirmationDeadline\" ng-model=\"vm.serviceItem.customerConfirmationDeadline\" min=\"1\"> <span>(ساعت)</span><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.paymentDeadlineType\" style=\"min-width: 150px;margin-top: 6px\" id=\"field_paymentDeadlineType\"><md-option value=\"UNTIL_RESERVE_TIME\" translate=\"tikonApp.PaymentDeadlineType.UNTIL_RESERVE_TIME\">UNTIL_RESERVE_TIME</md-option><md-option value=\"FROM_RESERVE_CREATE_TIME\" translate=\"tikonApp.PaymentDeadlineType.FROM_RESERVE_CREATE_TIME\">FROM_RESERVE_CREATE_TIME</md-option></md-select></div></div></div></fieldset><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.serviceItem.paymentTypeFieldSet\">Payment Type</span></legend><div class=\"row\"><div class=\"col-md-5\"><div class=\"row\"><md-radio-group ng-model=\"vm.serviceItem.paymentType\" ng-change=\"vm.paymentType_changed()\"><div class=\"col-md-6\"><md-radio-button class=\"md-primary\" value=\"PAYMENT_ALL\"><span translate=\"tikonApp.ServicePaymentType.PAYMENT_ALL\">PAYMENT_ALL</span></md-radio-button></div><div class=\"col-md-6\"><md-radio-button class=\"md-primary\" value=\"PRE_PAYMENT\"><span translate=\"tikonApp.ServicePaymentType.PRE_PAYMENT\">PRE_PAYMENT</span></md-radio-button></div></md-radio-group></div></div><div class=\"col-md-5\" ng-if=\"vm.serviceItem.paymentType==\'PRE_PAYMENT\'\" style=\"margin-top: -5px\"><span translate=\"tikonApp.serviceItem.prePaymentAmount\" for=\"field_prePaymentAmount\">Pre Payment Amount</span> <span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"largeTextBox\" name=\"prePaymentAmount\" id=\"field_prePaymentAmount\" ng-model=\"vm.serviceItem.prePaymentAmount\" min=\"0\"></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"onlineReserveLimitFieldSet\"><legend><span translate=\"tikonApp.serviceItem.onlineReserveLimitFieldSet\">Online Reserve Limit</span></legend><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.minPreReserveTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"minPreReserveTime\" id=\"field_minPreReserveTime\" ng-model=\"vm.serviceItem.minPreReserveTime\" min=\"0\"> <span translate=\"tikonApp.serviceItem.minPreReserveTime2\" eo-help-tooltip=\"tips.min_pre_reserve_time\"></span></div></div><div class=\"col-md-5\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.maxPreReserveTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"maxPreReserveTime\" id=\"field_maxPreReserveTime\" ng-model=\"vm.serviceItem.maxPreReserveTime\" min=\"0\"> <span translate=\"tikonApp.serviceItem.maxPreReserveTime2\" eo-help-tooltip=\"tips.max_pre_reserve_time\"></span></div></div></div></fieldset><!--this line commented--><!--ng-if=\"vm.serviceItem.servants == null || vm.serviceItem.servants.length==0\"--><fieldset class=\"standard-fieldset\" name=\"capacity\"><legend><span translate=\"tikonApp.serviceItem.capacityFieldSet\">Capacity</span></legend><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qty\" for=\"field_qty\" eo-help-tooltip=\"tips.service_capacity\">Qty</label><input type=\"number\" class=\"shortTextBox\" min=\"1\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.serviceItem.capacityInfo.qty\"></div></div><div class=\"col-md-4\" ng-if=\"vm.serviceItem.capacityInfo.qty>1\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.maxQty\" for=\"field_maxQty\" eo-help-tooltip=\"tips.max_service_capacity\">Qty</label><input type=\"number\" class=\"shortTextBox\" min=\"1\" max=\"vm.serviceItem.capacityInfo.qty\" name=\"maxQty\" id=\"field_maxQty\" ng-model=\"vm.serviceItem.capacityInfo.maxQty\"></div><div class=\"col-md-4\" ng-if=\"vm.serviceItem.capacityInfo.qty>1\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qtyUnit\" for=\"field_qtyUnit\" eo-help-tooltip=\"tips.qty_unit\">qtyUnit</label><input type=\"text\" class=\"largeTextBox\" name=\"qtyUnit\" id=\"field_qtyUnit\" ng-model=\"vm.serviceItem.capacityInfo.qtyUnit\"></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"consecutiveReserveMode\"><legend><span translate=\"tikonApp.serviceItem.consecutiveReserveMode\" eo-help-tooltip=\"tips.consecutiveReserveMode\">Online Reserve Limit</span></legend><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.consecutiveReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"ENABLE\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span></md-radio-button></md-radio-group></div></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"cancellingSetting\"><legend><span translate=\"tikonApp.serviceItem.cancellingSetting\">Cancelling Setting</span></legend><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.canBeCanceled\" layout=\"row\"><md-radio-button ng-value=\"false\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span></md-radio-button><md-radio-button ng-value=\"true\" class=\"md-primary\" eo-feature-checker=\"cancelReserveByCustomer\"><span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span></md-radio-button></md-radio-group></div></div><div class=\"col-md-9\" ng-if=\"vm.serviceItem.canBeCanceled\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.minPreCancelTime1\"></span> <input type=\"number\" class=\"shortTextBox\" name=\"maxPreReserveTime\" id=\"field_minPreCancelTime\" ng-model=\"vm.serviceItem.minPreCancelTime\" min=\"0\"> <span translate=\"tikonApp.serviceItem.minPreCancelTime2\"></span></div></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"multiReserveMode\"><legend><span translate=\"tikonApp.serviceItem.multiReserveMode\" eo-help-tooltip=\"tips.multiReserveMode\">multiReserveMode</span></legend><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"MANUAL\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.MANUAL\"></span></md-radio-button><md-radio-button value=\"AUTO\" class=\"md-primary\" eo-feature-checker=\"autoMultiReserveMode\"><span translate=\"tikonApp.MultiReserveMode.AUTO\"></span></md-radio-button></md-radio-group></div></div></div><div class=\"row\" data-ng-if=\"vm.serviceItem.multiReserveMode==\'AUTO\'\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveModeConfig\">multiReserveModeConfig</label></div></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatCount\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatCount\">repeatCount</label><input type=\"number\" class=\"shortTextBox\" min=\"1\" name=\"repeatCount\" id=\"repeatCount\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatCount\"></div></div></div><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatMode\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatMode\">repeatMode</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatMode\" layout=\"row\"><md-radio-button value=\"DAY_PERIOD\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.DAY_PERIOD\"></span></md-radio-button><md-radio-button value=\"WEEK_DAY\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.WEEK_DAY\"></span></md-radio-button></md-radio-group></div></div></div></div></div></fieldset></div></div></div></div><div id=\"serviceOptionSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.optionTab\" eo-help-tooltip=\"tips.service_options\">optionTab</span></div><div class=\"panel-body\"><pf-service-item-option-info service-option-item=\"vm.serviceItem.serviceOptionItem\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.serviceOptionInfoFormState\"></pf-service-item-option-info></div></div></div><div id=\"priceInfoSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.priceTab\" eo-help-tooltip=\"tips.service_price_info\">priceTab</span></div><div class=\"panel-body\"><pf-service-item-price-info service-item-id=\"vm.serviceItem.id\" on-create-new-price-info=\"vm.onCreateNewPriceInfo\" on-selected-price-info-changed=\"vm.onSelectedPriceInfoChanged\" form-state=\"vm.priceInfoFormState\" new-price-info=\"vm.serviceItem.newPriceInfo\" reload=\"vm.priceInfoFormReload\" price-infos=\"vm.serviceItem.servicePriceInfo\" price-info-type=\"vm.priceInfoType\"></pf-service-item-price-info></div></div></div><div id=\"marketPlaceSection\" ng-if=\"vm.showMarketPlaceSection\"><div class=\"panel\"><div class=\"panel-heading\"><span translate=\"tikonApp.serviceItem.marketPlaceTab\">marketPlaceTab</span> <span ng-if=\"vm.serviceItem.marketPlacePublishStatus\" ng-class=\"vm.findMarketPlacePublishStatusStyle()\">- <span translate=\"{{\'tikonApp.MarketPlacePublishStatus.\' + vm.serviceItem.marketPlacePublishStatus}}\">{{vm.serviceItem.marketPlacePublishStatus}} </span><span ng-class=\"vm.findMarketPlacePublishStatusIcon(vm.serviceItem.marketPlacePublishStatus)\"></span></span></div><div class=\"panel-body\"><md-switch ng-model=\"vm.showOnMarketPlace\">نمایش در سایتهای دیگر (جذب مشتری)</md-switch></div></div></div><md-button ng-disabled=\"serviceItemForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\" class=\"md-raised md-primary\"><span><md-icon>save</md-icon></span><span translate=\"entity.action.save\">Save</span></md-button></div></form>");
$templateCache.put("app/entities/service-item-v2/service-item-copy-dialog-v2.html","<form name=\"copyForm\" ng-submit=\"vm.copyServiceItem(vm.serviceItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.copy.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceItem.copy.question\" translate-values=\"{itemTitle: \'{{vm.serviceItem.itemTitle}}\'}\">Are you sure you want to delete this Service Item?</p></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button type=\"submit\" ng-disabled=\"copyForm.$invalid\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-copy\"></span>&nbsp;<span translate=\"entity.action.copy\">Copy</span></md-button></div></form>");
$templateCache.put("app/entities/service-item-v2/service-item-delete-dialog-v2.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceItem.id)\"><div class=\"modal-header wrn\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceItem.delete.question\" translate-values=\"{itemTitle: \'{{vm.serviceItem.itemTitle}}\'}\">Are you sure you want to delete this Service Item?</p></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></md-button></div></form>");
$templateCache.put("app/entities/service-item-v2/service-item-event-list-v2.html","<style>.serviceColorCircle {\n        width: 15px;\n        height: 15px;\n        /*padding: 13px;*/\n        /* margin: 13px; */\n        min-width: 15px;\n        border-radius: 25px;\n    }\n\n    .modal-content {\n        border-radius: 4px;\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.eventItemList\">supplierPanel.sideMenu.eventItemList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.generalServiceItemEventV2()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.home.createEventLabel\">Create new Service Item</span></md-button><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.companyServiceCategoryList\"><span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.category\">serviceCategory</span></md-button><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control rwTableSearchBox\" placeholder=\"{{ \'tikonApp.serviceItem.home.searchEvent\' | translate }}\" type=\"text\"></th></tr><tr><th><span></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"itemTitle\"><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span></th><th st-sort=\"categoryId\"><span translate=\"tikonApp.serviceItem.category\">Category</span></th><th st-sort=\"description\"><span translate=\"tikonApp.serviceItem.description\">Description</span></th><th st-sort=\"serviceStatus\"><span translate=\"tikonApp.serviceItem.serviceStatus\">Service Status</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceItem in collection track by serviceItem.id\"><td><md-icon ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px\">videocam</md-icon></td><td><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div></td><td><a ui-sref=\"supplierPanel.generalServiceItemEventV2({id:serviceItem.id})\">{{serviceItem.itemTitle}}</a></td><td>{{vm.categoryName(serviceItem.category.categoryName)}}</td><td>{{serviceItem.description}}</td><td ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.generalServiceItemEventV2({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel.serviceItemEventListV2.copy({id:serviceItem.id})\" class=\"btn btn-secondary btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel.serviceItemEventListV2.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.eventItemList\">supplierPanel.sideMenu.eventItemList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.generalServiceItemEventV2()\"><i class=\"fa fa-plus fa-lg\"></i></md-button><md-button class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.companyServiceCategoryList\"><span class=\"\" translate=\"tikonApp.serviceItem.category\">category</span></md-button><md-content class=\"rwMdContent\"><div class=\"orderBag-mobile-block\" ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\"><div class=\"row\"><div class=\"com-sm-6 text-right\" ui-sref=\"supplierPanel.generalServiceItemEventV2({id:serviceItem.id})\"><div style=\"display: flex; gap: 5px\"><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div><div class=\"service-item-color-mobile\">{{serviceItem.itemTitle}}</div></div><div style=\"font-size: 10px;color: #8c8c8c\"><!--{{serviceItem.category.categoryName}}--> {{vm.categoryName(serviceItem.category.categoryName)}}</div><!--<div ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\">--><!--<span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span>--><!--<span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span>--><!--</div>--></div><div class=\"com-sm-3\" style=\"text-align: left;padding-left: 10px\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.generalServiceItemEventV2({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.copyServiceItem(serviceItem.id)\" ui-sref=\"supplierPanel.serviceItemListV2.copy({id:serviceItem.id})\" class=\"btn btn-secondary btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.serviceItemListV2.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></div></div></div></md-content></div></div></div></div></div>");
$templateCache.put("app/entities/service-item-v2/service-item-list-old.html","<style>.serviceColorCircle {\n        width: 15px;\n        height: 15px;\n        /*padding: 13px;*/\n        /* margin: 13px; */\n        min-width: 15px;\n        border-radius: 25px;\n    }\n\n    .modal-content {\n        border-radius: 4px;\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.serviceItem.serviceItemList\">supplierPanel.sideMenu.serviceItem.serviceItemList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.generalServiceItemV2()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.home.createLabel\">Create new Service Item</span></md-button><md-button class=\"md-raised md-secondary\" style=\"margin-bottom: 0\" ui-sref=\"supplierPanel.companyServiceCategoryList\"><span class=\"hidden-xs\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory\">serviceCategory</span></md-button><md-content class=\"rwMdContent\"><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><input st-search=\"\" class=\"form-control rwTableSearchBox\" placeholder=\"{{ \'tikonApp.serviceItem.home.search\' | translate }}\" type=\"text\"></th></tr><tr><th><span></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"itemTitle\"><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span></th><th st-sort=\"categoryId\"><span translate=\"tikonApp.serviceItem.category\">Category</span></th><th st-sort=\"description\"><span translate=\"tikonApp.serviceItem.description\">Description</span></th><th st-sort=\"serviceStatus\"><span translate=\"tikonApp.serviceItem.serviceStatus\">Service Status</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceItem in collection track by serviceItem.id\"><td><md-icon ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px\">videocam</md-icon></td><td><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div></td><td><a ui-sref=\"supplierPanel.generalServiceItemV2({id:serviceItem.id})\">{{serviceItem.itemTitle}}</a></td><td>{{vm.categoryName(serviceItem.category.categoryName)}}</td><td>{{serviceItem.description}}</td><td ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.generalServiceItemV2({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.copyServiceItem(serviceItem.id)\" ui-sref=\"supplierPanel.serviceItemListV2.copy({id:serviceItem.id})\" class=\"btn btn-secondary btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel.serviceItemListV2.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></md-content></div></div></div></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.serviceItem.serviceItemList\">supplierPanel.sideMenu.serviceItem.serviceItemList</div><div class=\"panel-body\"><jhi-alert></jhi-alert><md-button class=\"md-raised md-primary\" ui-sref=\"supplierPanel.generalServiceItemV2()\"><i class=\"fa fa-plus fa-lg\"></i></md-button><md-button class=\"md-raised md-secondary\" ui-sref=\"supplierPanel.companyServiceCategoryList\"><span class=\"\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory\">serviceCategory</span></md-button><md-content class=\"rwMdContent\"><div class=\"orderBag-mobile-block\" ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\"><div class=\"row\"><div class=\"com-sm-6 text-right\" ui-sref=\"supplierPanel.generalServiceItemV2({id:serviceItem.id})\"><div style=\"display: flex; gap: 5px\"><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div><div class=\"service-item-color-mobile\">{{serviceItem.itemTitle}}</div></div><div style=\"font-size: 10px;color: #8c8c8c\"><!--{{serviceItem.category.categoryName}}--> {{vm.categoryName(serviceItem.category.categoryName)}}</div><!--<div ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\">--><!--<span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span>--><!--<span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span>--><!--</div>--></div><div class=\"com-sm-3\" style=\"text-align: left;padding-left: 10px\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.generalServiceItemV2({id:serviceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.copyServiceItem(serviceItem.id)\" ui-sref=\"supplierPanel.serviceItemListV2.copy({id:serviceItem.id})\" class=\"btn btn-secondary btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"button\" ui-sref=\"supplierPanel.serviceItemListV2.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></div></div></div></md-content></div></div></div></div></div>");
$templateCache.put("app/entities/service-item-v2/service-item-list-v2.html","<style>.serviceColorCircle {\n        width: 15px;\n        height: 15px;\n        /*padding: 13px;*/\n        /* margin: 13px; */\n        min-width: 15px;\n        border-radius: 25px;\n    }\n\n    .modal-content {\n        border-radius: 4px;\n    }\n     @media (max-width: 768px) {\n        .md-button-xs-size {\n            min-width: 55px;\n        }\n    }</style><div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"row\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><div style=\"display: flex; align-items: center; justify-content: space-between\"><span translate=\"supplierPanel.sideMenu.serviceItem.title-v2\">supplierPanel.sideMenu.serviceItem.serviceItemList</span><div class=\"education-link\" ng-click=\"vm.showEducation()\"><span>آموزش تصویری</span><md-icon>play_circle_outline</md-icon></div></div></div><div class=\"panel-body pl-panel-body\"><jhi-alert></jhi-alert><md-button class=\"pl-btn-primary pl-btn\" ui-sref=\"supplierPanel-v2.serviceItemList.serviceItem\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.home.createLabel-v2\">Create new Service Item</span></md-button><md-button class=\"md-raised md-secondary pl-btn pl-btn-default\" ui-sref=\"supplierPanel-v2.companyServiceCategoryList\"><span class=\"hidden-xs\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory-v2\">serviceCategory</span></md-button><div class=\"table-responsive\"><table st-safe-src=\"vm.serviceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceItem.home.searchPlaceHolder\'\" on-search=\"vm.searchServiceItem()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr class=\"pl-table-header\"><th><span></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"itemTitle\"><span translate=\"tikonApp.serviceItem.itemTitle\">Item Title</span></th><th st-sort=\"categoryId\"><span translate=\"tikonApp.serviceItem.category\">Category</span></th><th st-sort=\"description\"><span translate=\"tikonApp.serviceItem.description\">Description</span></th><th st-sort=\"serviceStatus\"><span translate=\"tikonApp.serviceItem.serviceStatus\">Service Status</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceItem in collection track by serviceItem.id\"><td><md-icon ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\" aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px\">videocam</md-icon></td><td><div ng-class=\"serviceItem.color\" class=\"serviceColorCircle\"></div></td><td><a ui-sref=\"supplierPanel-v2.serviceItemList.serviceItem({id:serviceItem.id})\">{{serviceItem.itemTitle}}</a></td><td>{{vm.categoryName(serviceItem.category.categoryName)}}</td><td>{{serviceItem.description}}</td><td ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></td><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel-v2.serviceItemList.serviceItem({id:serviceItem.id})\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-click=\"vm.copyServiceItem(serviceItem.id)\" ui-sref=\"supplierPanel-v2.serviceItemList.copy({id:serviceItem.id})\" class=\"btn btn-secondary pl-btn-default btn-sm\"><span class=\"glyphicon glyphicon-copy\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.copy\"></span></button> <button type=\"submit\" ui-sref=\"supplierPanel-v2.serviceItemList.delete({id:serviceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div><!--<div class=\"text-center\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>--><!--</div>--></div><div class=\"visible-xs pl-form-container\"><eo-fixed-button on-click=\"vm.newServiceItem()\" label=\"افزودن\"></eo-fixed-button><div class=\"\"><div class=\"row\"><div class=\"col-xs-12 service-item-title-container\" style=\"justify-content: space-between\"><div style=\"display: flex; align-items: center\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\" translate=\"tikonApp.serviceItem.home.title-v2\">title-list</h3><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.companyServiceCategoryList\"><md-icon style=\"color: #000\">folder_copy</md-icon><span class=\"\" translate=\"supplierPanel.sideMenu.serviceItem.serviceCategory-v2\">serviceCategory</span></md-button></div></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\'tikonApp.serviceItem.home.searchPlaceHolder\'\" on-search=\"vm.searchServiceItem()\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box><div ng-repeat=\"serviceItem in vm.serviceItems track by serviceItem.id\" class=\"customer-list-item\" ng-click=\"vm.editServiceItem(serviceItem)\"><div ng-class=\"serviceItem.color\" class=\"service-color-line\"></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-name\">{{serviceItem.itemTitle}}</div><div class=\"service-item-list-price-row\"><div>{{vm.categoryName(serviceItem.category.categoryName)}}</div><div ng-if=\"serviceItem.minPrice>0\" style=\"font-size: 12px\">{{serviceItem.minPrice | number}} <span translate=\"global.currency\"></span></div></div><div class=\"service-list-icons\"><div class=\"service-list-icons-video\" ng-class=\"vm.findStatusStyle(serviceItem.serviceStatus)\"><span style=\"height: 20px\" ng-class=\"vm.findStatusIcon(serviceItem.serviceStatus)\"></span> <span style=\"color: #000\" translate=\"{{\'tikonApp.ServiceItemStatus.\' + serviceItem.serviceStatus}}\">{{serviceItem.serviceStatus}}</span></div><div class=\"service-list-icons-video\" ng-if=\"serviceItem.meetingType == \'RW_VIDEO_CALL\'\"><md-icon aria-hidden=\"true\" class=\"pl-icon\" style=\"font-size: 20px\">videocam</md-icon><div>تصویری</div></div></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div>");
$templateCache.put("app/entities/service-item-v2/service-item-v2.html","<eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"service-item-header-container\" ng-if=\"vm.serviceItem && vm.serviceItem.id \"><div class=\"customer-header-info\"><div><div class=\"customer-list-customer-name\">{{vm.serviceItem.itemTitle}}</div></div></div><div class=\"customer-header-buttons\"><div ng-click=\"vm.copyItem()\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">content_copy</md-icon></div><div class=\"customer-header-button-box-text\">کپی</div></div><div ng-click=\"vm.deleteItem()\"><div class=\"customer-header-button-box\"><md-icon style=\"color: #101928\">delete</md-icon></div><div class=\"customer-header-button-box-text\">حذف</div></div></div></div><div class=\"customer-component-container\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><jhi-alert-error></jhi-alert-error><style>.shortTextBox {\n                        width: 50px;\n                        font-size: 16px;\n                        font-weight: bold;\n                        text-align: center;\n                    }\n\n                    .largeTextBox {\n                        width: 100px;\n                        font-size: 16px;\n                        font-weight: bold;\n                        text-align: center;\n                    }\n\n                    .serviceColorPick {\n                        width: 100px;\n                        height: 25px;\n                        /*padding: 13px;*/\n                        /* margin: 13px; */\n                        margin: 0 5px 9px;\n                        border-radius: 8px;\n                    }\n\n                    .payment-deadline {\n                        display: flex;\n                        gap: 5px;\n                        align-items: baseline;\n                    }\n\n                    .auto-payment-switch {\n\n                    }\n\n                    .column-with-switch {\n                        margin-top: -12px;\n                        display: flex\n                    }\n\n                    .advanced-setting, .full-description {\n                        border: 1px solid;\n                        padding: 0px 20px 0 0px;\n                        border-radius: 5px;\n                        background-color: #f1f9f1;\n                        color: green;\n                        max-width: 155px;\n                        margin-top: -10px;\n                        display: flex;\n                        align-items: center;\n\n                    }\n\n                    .full-description {\n                        min-width: 200px !important;\n                        background-color: #f2f3f1 !important;\n                        color: #404040 !important;\n                    }\n\n                    .arrow-animate {\n                        transform: rotate(0deg);\n                        transition: transform 0.2s linear;\n                    }\n\n                    .arrow-animate-left {\n                        transform: rotate(90deg);\n                        transition: transform 0.2s linear;\n                    }\n\n\n                    @keyframes rotate90 {\n                        50% {\n                            transform: rotate(90deg);\n                        }\n                    }\n\n                    @media screen and (max-width: 768px) {\n                        .auto-payment-switch {\n                            white-space: normal;\n                        }\n\n                        .column-with-switch {\n                            margin-top: 0px;\n                            display: flex\n                        }\n                    }</style><ul class=\"pl-nav-tabs\"><li class=\"active\"><a data-target=\"#generalInfo\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">subject</md-icon>مشخصات عمومی</a></li><li><a data-target=\"#images\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">image</md-icon><span>تصاویر</span></a></li><li><a data-target=\"#description\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">description</md-icon><span>توضیحات تکمیلی</span></a></li><li><a data-target=\"#rules\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">gavel</md-icon><span>قوانین و مقررات</span></a></li><li ng-click=\"vm.tabChanged(\'advancedSetting\')\"><a style=\"width: 102%\" data-target=\"#advancedSetting\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">settings</md-icon><span>تنظیمات پیشرفته</span></a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"generalInfo\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.generalTab\">generalTab</span></div><div class=\"panel-body\"><div><div id=\"general\" class=\"\"><div><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"vm.serviceItem.itemTitle\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.minPrice\" for=\"field_minPrice\">Min Price</label><!--<span translate=\"global.currencyBracket\"></span>--><eo-numeric-input-v2 id=\"field_minPrice\" name=\"minPrice\" custom-class=\"form-control\" input-value=\"vm.serviceItem.minPrice\" is-required=\"true\" form-reference=\"editForm\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.category\" required for=\"field_category\" eo-help-tooltip=\"tips.service_category\">Category</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\" ng-model=\"vm.serviceItem.category.id\" style=\"margin-top: 6px\" id=\"field_category\"><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servicecategories\">{{si.categoryName}}</md-option></md-select><!--<select class=\"rwMdSelect plSelect\"--><!--placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\"--><!--ng-model=\"vm.serviceItem.category\"--><!--id=\"field_category\"--><!--ng-options=\"si.categoryName for si in vm.servicecategories track by si.id\"--><!--&gt;--><!--</select>--></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"col-sm-6\" style=\"padding-right: 0\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.duration\" required for=\"field_duration\">Duration</label><!--<input type=\"number\" id=\"field_duration\"--><!--class=\"form-control shortInput\"--><!--eo-required=\"\"--><!--pattern=\"[0-9]*\"--><!--ng-model=\"vm.serviceItem.duration\">--><eo-numeric-input id=\"field_duration\" name=\"duration\" input-value=\"vm.serviceItem.duration\" custom-class=\"form-control shortInput\" is-required=\"true\" form-reference=\"editForm\" min=\"10\"></eo-numeric-input></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Duration</label><!--<input type=\"number\" id=\"field_gapTime\"--><!--class=\"form-control shortInput\"--><!--pattern=\"[0-9]*\"--><!--ng-model=\"vm.serviceItem.gaptime\">--><eo-numeric-input id=\"field_gapTime\" name=\"gapTime\" input-value=\"vm.serviceItem.gaptime\" custom-class=\"form-control shortInput\" form-reference=\"editForm\"></eo-numeric-input></div></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.serviceStatus\" for=\"field_serviceStatus\" eo-help-tooltip=\"tips.service_status\">Service Status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.serviceStatus\" style=\"margin-top: 6px\" id=\"field_serviceStatus\"><md-option value=\"DISABLE\" translate=\"tikonApp.ServiceItemStatus.DISABLE\">DISABLE</md-option><md-option value=\"PUBLISH\" translate=\"tikonApp.ServiceItemStatus.PUBLISH\">PUBLISH</md-option><md-option value=\"RESERVE_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.RESERVE_JUST_PANEL\">RESERVE_JUST_PANEL</md-option><md-option value=\"PUBLISH_JUST_PANEL\" translate=\"tikonApp.ServiceItemStatus.PUBLISH_JUST_PANEL\">PUBLISH_JUST_PANEL</md-option></md-select></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.serviceColor\" for=\"field_description\">Description</label><div><md-select class=\"rwMdSelect\" name=\"serviceColor\" ng-model=\"vm.serviceItem.color\" required><md-option ng-repeat=\"color in vm.serviceColors\" ng-value=\"color\"><div ng-class=\"color\" class=\"serviceColorPick\"></div></md-option></md-select></div></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceItem.description\"></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"padding-top: 32px\"><md-checkbox ng-model=\"vm.isVideoMeeting\" ng-change=\"vm.meetingCheckChange()\" eo-help-tooltip=\"tips.service_meeting_type\">{{\'tikonApp.serviceItem.meetingType.RW_VIDEO_CALL\' | translate}}<md-icon aria-hidden=\"true\" style=\"color: #2b6b7f;font-size: 20px;padding-top: 4px\">videocam</md-icon></md-checkbox></div></div></div></div><br></div></div></div></div><div id=\"servantSection\" class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span ng-if=\"!vm.isWorkingSpace\" translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">ServantTab</span> <span ng-if=\"!vm.isWorkingSpace\" eo-help-tooltip=\"tips.service_servants-v2\">({{vm.activityTypeInfo.servantListTitle}}) </span><span ng-if=\"vm.isWorkingSpace\" translate=\"supplierPanel.sideMenu.serviceItem.servantTab-space\">servantTab</span> <span ng-if=\"vm.isWorkingSpace\">({{vm.activityTypeInfo.servantListTitle}})</span></div><div class=\"panel-body\"><div id=\"servants\"><pf-service-item-servants servants=\"vm.serviceItem.servants\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.servantFormState\" activity-type=\"vm.currentCompany.activityType\" single-selection=\"vm.isEventMode\" search-able=\"true\"></pf-service-item-servants></div><div ng-if=\"!vm.isEventMode\"><hr><div style=\"max-width: 400px\" ng-if=\"vm.serviceItem.servants && vm.serviceItem.servants.length>0\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.servantSelectMode\" for=\"field_servantSelectMode\">servantSelectMode</label><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.servantSelectMode\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_servantSelectMode\"><md-option value=\"SELECT_BY_CUSTOMER\" translate=\"tikonApp.ServantSelectMode.SELECT_BY_CUSTOMER\">SELECT_BY_CUSTOMER</md-option><md-option value=\"AUTO_SELECT_MOST_FREE_SERVANT\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_MOST_FREE_SERVANT\">AUTO_SELECT_MOST_FREE_SERVANT</md-option><md-option value=\"AUTO_SELECT_ROTATORY\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_ROTATORY\">AUTO_SELECT_ROTATORY</md-option><md-option value=\"AUTO_SELECT_RANDOM\" translate=\"tikonApp.ServantSelectMode.AUTO_SELECT_RANDOM\">AUTO_SELECT_RANDOM</md-option></md-select></div></div></div></div></div><div id=\"timeSection\" ng-if=\"vm.isEventMode\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.eventItemSessions\">eventItemSessionsTab</span></div><div class=\"panel-body\"><div><div class=\"col-md-12\"><pf-event-item-schedules service-item-id=\"vm.serviceItemId\" selected-schedule-info=\"vm.serviceItem.scheduleInfo\" event-duration=\"vm.serviceItem.duration\"></pf-event-item-schedules></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"description\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\">توضیحات تکمیلی</div><div class=\"panel-body\"><div class=\"form-group\"><!--<div ng-click=\"vm.showFullDescription()\" class=\"full-description\">--><!--<span>درج توضیحات تکمیلی</span>--><!--&lt;!&ndash;<md-icon ></md-icon>&ndash;&gt;--><!--<md-icon ng-if=\"!vm.fullDescription\">add</md-icon>--><!--<md-icon ng-if=\"vm.fullDescription\">remove</md-icon>--><!--</div>--><div><label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.serviceItem.fullDescription\" for=\"field_fullDescription\">Full Description</label><!--<div height=\"300\" type=\"text\" summernote class=\"form-control\" name=\"fullDescription\"--><!--id=\"field_fullDescription\"--><!--ng-model=\"vm.serviceItem.fullDescription\"--><!--&gt;--><!--</div>--><eo-rich-text-editor id=\"field_fullDescription\" input-value=\"vm.serviceItem.fullDescription\"></eo-rich-text-editor></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"rules\"><div id=\"agreementSection\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.agreementTab\">agreementTab</span></div><div class=\"panel-body\"><pf-service-item-agreement-info agreement=\"vm.serviceItem.agreement\"></pf-service-item-agreement-info></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"images\"><div id=\"gallerySection\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.imageAlbumTab\" eo-help-tooltip=\"tips.service_images\">imageAlbumTab</span></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel-body\"><eo-image-gallery-manager-v2 album-id=\"vm.serviceItem.imageAlbumId\" max-image-count=\"1\" crop-width=\"400\" crop-height=\"240\" album-caption=\"vm.serviceItem.item_title\"></eo-image-gallery-manager-v2></div></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"advancedSetting\"><div><div id=\"settingSection\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.settingTab\">settingTab</span></div><div class=\"panel-body\"><div id=\"setting\" class=\"\"><fieldset class=\"standard-fieldset\"><legend><span eo-help-tooltip=\"tips.service_confirmation_type\" translate=\"tikonApp.serviceItem.confirmationTypeFieldSet\">Confirmation Type</span></legend><div class=\"row\"><div class=\"form-group col-md-4\"><md-radio-group ng-model=\"vm.serviceItem.confirmationType\" ng-change=\"vm.confirmationType_Change()\" layout=\"row\" class=\"setting-radio-box-inside\"><md-radio-button class=\"md-primary\" value=\"ONE_STEP\"><span translate=\"tikonApp.ServiceConfirmationType.ONE_STEP\">ONE_STEP</span></md-radio-button><md-radio-button eo-feature-checker=\"twoStepVerification\" class=\"md-primary\" value=\"TWO_STEP\"><span translate=\"tikonApp.ServiceConfirmationType.TWO_STEP\">TWO_STEP</span></md-radio-button></md-radio-group></div><div class=\"col-md-8 column-with-switch\" style=\"\"><span eo-help-tooltip=\"tips.service_auto_approve_for_payment\"><md-switch class=\"auto-payment-switch\" ng-disabled=\"!vm.hasAccesToTwoStpeFeature\" ng-model=\"vm.serviceItem.autoApproveForPayment\" ng-change=\"vm.autoApprove_Changed()\"><span translate=\"tikonApp.serviceItem.autoApproveForPayment\">Auto Send Payment Link َ</span></md-switch></span></div><!--content here --></div><div class=\"row\" ng-if=\"(vm.serviceItem.confirmationType==\'ONE_STEP\' && vm.serviceItem.autoApproveForPayment)||vm.serviceItem.confirmationType==\'TWO_STEP\' \"><div class=\"col-md-5 column-with-switch\"><span eo-help-tooltip=\"tips.payment_deadline\"><md-switch class=\"auto-payment-switch\" ng-model=\"vm.serviceItem.paymentDeadline\"><span translate=\"tikonApp.serviceItem.paymentDeadline\">Has Payment DeadLine َ</span></md-switch></span></div><div class=\"col-md-7\" ng-if=\"vm.serviceItem.paymentDeadline\"><div class=\"payment-deadline\"><span translate=\"tikonApp.serviceItem.customerConfirmationDeadline\">customerConfirmationDeadline</span><!--<input type=\"number\" class=\"shortTextBox\"--><!--name=\"customerConfirmationDeadline\"--><!--id=\"field_customerConfirmationDeadline\"--><!--ng-model=\"vm.serviceItem.customerConfirmationDeadline\"--><!--pattern=\"[0-9]*\"--><!--min=\"1\"--><!--/>--><eo-numeric-input id=\"field_customerConfirmationDeadline\" name=\"customerConfirmationDeadline\" input-value=\"vm.serviceItem.customerConfirmationDeadline\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input><span>(ساعت)</span><md-select class=\"rwMdSelect\" ng-model=\"vm.serviceItem.paymentDeadlineType\" style=\"min-width: 150px;margin-top: 6px\" id=\"field_paymentDeadlineType\"><md-option value=\"UNTIL_RESERVE_TIME\" translate=\"tikonApp.PaymentDeadlineType.UNTIL_RESERVE_TIME\">UNTIL_RESERVE_TIME</md-option><md-option value=\"FROM_RESERVE_CREATE_TIME\" translate=\"tikonApp.PaymentDeadlineType.FROM_RESERVE_CREATE_TIME\">FROM_RESERVE_CREATE_TIME</md-option></md-select></div></div></div></fieldset><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.serviceItem.paymentTypeFieldSet\">Payment Type</span></legend><div class=\"row\"><div class=\"col-md-5\"><div class=\"row\"><md-radio-group ng-model=\"vm.serviceItem.paymentType\" ng-change=\"vm.paymentType_changed()\"><div class=\"col-md-6\"><md-radio-button class=\"md-primary\" value=\"PAYMENT_ALL\"><span translate=\"tikonApp.ServicePaymentType.PAYMENT_ALL\">PAYMENT_ALL</span></md-radio-button></div><div class=\"col-md-6\"><md-radio-button class=\"md-primary\" value=\"PRE_PAYMENT\"><span translate=\"tikonApp.ServicePaymentType.PRE_PAYMENT\">PRE_PAYMENT</span></md-radio-button></div></md-radio-group></div></div><div class=\"col-md-5\" ng-if=\"vm.serviceItem.paymentType==\'PRE_PAYMENT\'\" style=\"margin-top: -5px\"><span translate=\"tikonApp.serviceItem.prePaymentAmount\" for=\"field_prePaymentAmount\">Pre Payment Amount</span> <span translate=\"global.currencyBracket\"></span><!--<input type=\"number\" class=\"largeTextBox\"--><!--name=\"prePaymentAmount\"--><!--id=\"field_prePaymentAmount\"--><!--ng-model=\"vm.serviceItem.prePaymentAmount\"--><!--pattern=\"[0-9]*\"--><!--min=\"0\"--><!--/>--><eo-numeric-input id=\"field_prePaymentAmount\" name=\"prePaymentAmount\" input-value=\"vm.serviceItem.prePaymentAmount\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"5000\"></eo-numeric-input></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"onlineReserveLimitFieldSet\"><legend><span translate=\"tikonApp.serviceItem.onlineReserveLimitFieldSet\">Online Reserve Limit</span></legend><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.minPreReserveTime1\"></span><!--<input type=\"number\" class=\"shortTextBox\"--><!--name=\"minPreReserveTime\"--><!--id=\"field_minPreReserveTime\"--><!--ng-model=\"vm.serviceItem.minPreReserveTime\"--><!--pattern=\"[0-9]*\"--><!--min=\"0\"--><!--/>--><eo-numeric-input id=\"field_minPreReserveTime\" name=\"minPreReserveTime\" input-value=\"vm.serviceItem.minPreReserveTime\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"0\"></eo-numeric-input><span translate=\"tikonApp.serviceItem.minPreReserveTime2\" eo-help-tooltip=\"tips.min_pre_reserve_time\"></span></div></div><div class=\"col-md-5\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.maxPreReserveTime1\"></span><!--<input type=\"number\" class=\"shortTextBox\"--><!--name=\"maxPreReserveTime\"--><!--id=\"field_maxPreReserveTime\"--><!--ng-model=\"vm.serviceItem.maxPreReserveTime\"--><!--pattern=\"[0-9]*\"--><!--min=\"0\"--><!--/>--><eo-numeric-input id=\"field_maxPreReserveTime\" name=\"maxPreReserveTime\" input-value=\"vm.serviceItem.maxPreReserveTime\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input><span translate=\"tikonApp.serviceItem.maxPreReserveTime2\" eo-help-tooltip=\"tips.max_pre_reserve_time\"></span></div></div></div></fieldset><!--this line commented--><!--ng-if=\"vm.serviceItem.servants == null || vm.serviceItem.servants.length==0\"--><fieldset class=\"standard-fieldset\" name=\"capacity\"><legend><span translate=\"tikonApp.serviceItem.capacityFieldSet\">Capacity</span></legend><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qty-v2\" for=\"field_qty\" eo-help-tooltip=\"tips.service_capacity\">Qty</label><!--<input type=\"number\" class=\"shortTextBox\" min=\"1\" name=\"qty\"--><!--id=\"field_qty\"--><!--ng-model=\"vm.serviceItem.capacityInfo.qty\"--><!--ng-disabled=\"!vm.canEditCapacity\"--><!--pattern=\"[0-9]*\"--><!--/>--><eo-numeric-input id=\"field_qty\" name=\"qty\" input-value=\"vm.serviceItem.capacityInfo.qty\" custom-class=\"shortInput\" is-disabled=\"!vm.canEditCapacity\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input><span ng-if=\"!vm.canEditCapacity\">(امکان ویژه)</span></div></div><div class=\"col-md-4\" ng-if=\"vm.serviceItem.capacityInfo.qty>1\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.maxQty\" for=\"field_maxQty\" eo-help-tooltip=\"tips.max_service_capacity\">Qty</label><!--<input type=\"number\" class=\"shortTextBox\" min=\"1\"--><!--max=\"vm.serviceItem.capacityInfo.qty\" name=\"maxQty\"--><!--id=\"field_maxQty\"--><!--ng-model=\"vm.serviceItem.capacityInfo.maxQty\"--><!--pattern=\"[0-9]*\"--><!--/>--><eo-numeric-input id=\"field_maxQty\" name=\"maxQty\" input-value=\"vm.serviceItem.capacityInfo.maxQty\" disabled=\"!vm.canEditCapacity\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input></div><div class=\"col-md-4\" ng-if=\"vm.serviceItem.capacityInfo.qty>1\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qtyUnit\" for=\"field_qtyUnit\" eo-help-tooltip=\"tips.qty_unit\">qtyUnit</label><input type=\"text\" class=\"largeTextBox\" name=\"qtyUnit\" id=\"field_qtyUnit\" ng-model=\"vm.serviceItem.capacityInfo.qtyUnit\"></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"consecutiveReserveMode\"><legend><span translate=\"tikonApp.serviceItem.consecutiveReserveMode\" eo-help-tooltip=\"tips.consecutiveReserveMode\">Online Reserve Limit</span></legend><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.consecutiveReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"ENABLE\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span></md-radio-button></md-radio-group></div></div><div class=\"col-md-4\" ng-if=\"vm.serviceItem.consecutiveReserveMode==\'ENABLE\'\"><div class=\"form-group\"><!--<label class=\"control-label\"--><!--translate=\"tikonApp.serviceItem.minConsecutivePeriod\"--><!--for=\"field_minConsecutivePeriod\"--><!--eo-help-tooltip=\"tips.max_service_capacity\"--><!--&gt;Qty</label>--> <span translate=\"tikonApp.serviceItem.minConsecutivePeriod\"></span><eo-numeric-input id=\"field_minConsecutivePeriod\" name=\"minConsecutivePeriod\" input-value=\"vm.serviceItem.minConsecutivePeriod\" custom-class=\"veryShortInput\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input><span style=\"font-size: 10px\">X({{vm.serviceItem.duration}} دقیقه)</span></div></div><div class=\"col-md-4\" ng-if=\"vm.serviceItem.consecutiveReserveMode==\'ENABLE\'\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.maxConsecutivePeriod\"></span><eo-numeric-input id=\"field_maxConsecutivePeriod\" name=\"maxConsecutivePeriod\" input-value=\"vm.serviceItem.maxConsecutivePeriod\" custom-class=\"veryShortInput\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input><span style=\"font-size: 10px\">X({{vm.serviceItem.duration}} دقیقه)</span></div></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"cancellingSetting\"><legend><span translate=\"tikonApp.serviceItem.cancellingSetting\">Cancelling Setting</span></legend><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.canBeCanceled\" layout=\"row\"><md-radio-button ng-value=\"false\" class=\"md-primary\"><span translate=\"tikonApp.ConsecutiveReserveMode.DISABLE\"></span></md-radio-button><md-radio-button ng-value=\"true\" class=\"md-primary\" eo-feature-checker=\"cancelReserveByCustomer\"><span translate=\"tikonApp.ConsecutiveReserveMode.ENABLE\"></span></md-radio-button></md-radio-group></div></div><div class=\"col-md-9\" ng-if=\"vm.serviceItem.canBeCanceled\"><div class=\"form-group\"><span translate=\"tikonApp.serviceItem.minPreCancelTime1\"></span><!--<input type=\"number\" class=\"shortTextBox\"--><!--name=\"maxPreReserveTime\"--><!--id=\"field_minPreCancelTime\"--><!--ng-model=\"vm.serviceItem.minPreCancelTime\"--><!--pattern=\"[0-9]*\"--><!--min=\"0\"--><!--/>--><eo-numeric-input id=\"field_minPreCancelTime\" name=\"minPreCancelTime\" input-value=\"vm.serviceItem.minPreCancelTime\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"0\"></eo-numeric-input><span translate=\"tikonApp.serviceItem.minPreCancelTime2\"></span></div></div></div></fieldset><fieldset class=\"standard-fieldset\" name=\"multiReserveMode\" ng-if=\"!vm.isEventMode\"><legend><span translate=\"tikonApp.serviceItem.multiReserveMode\" eo-help-tooltip=\"tips.multiReserveMode\">multiReserveMode</span></legend><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveMode\" layout=\"row\"><md-radio-button value=\"DISABLE\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.DISABLE\"></span></md-radio-button><md-radio-button value=\"MANUAL\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveMode.MANUAL\"></span></md-radio-button><md-radio-button value=\"AUTO\" class=\"md-primary\" eo-feature-checker=\"autoMultiReserveMode\"><span translate=\"tikonApp.MultiReserveMode.AUTO\"></span></md-radio-button></md-radio-group></div></div></div><div class=\"row\" data-ng-if=\"vm.serviceItem.multiReserveMode==\'AUTO\'\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveModeConfig\">multiReserveModeConfig</label></div></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatCount\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatCount\">repeatCount</label><!--<input type=\"number\" class=\"shortTextBox\" min=\"1\"--><!--name=\"repeatCount\"--><!--id=\"repeatCount\"--><!--ng-model=\"vm.serviceItem.multiReserveConfig.repeatCount\"--><!--pattern=\"[0-9]*\"--><!--/>--><eo-numeric-input id=\"field_repeatCount\" name=\"repeatCount\" input-value=\"vm.serviceItem.multiReserveConfig.repeatCount\" custom-class=\"shortInput\" form-reference=\"editForm\" min=\"1\"></eo-numeric-input></div></div></div><div class=\"row\"><div class=\"col-md-10\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.multiReserveConfig.repeatMode\" for=\"field_qty\" eo-help-tooltip=\"tips.multiReserveConfig_repeatMode\">repeatMode</label><md-radio-group class=\"setting-radio-box-inside\" ng-model=\"vm.serviceItem.multiReserveConfig.repeatMode\" layout=\"row\"><md-radio-button value=\"DAY_PERIOD\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.DAY_PERIOD\"></span></md-radio-button><md-radio-button value=\"WEEK_DAY\" class=\"md-primary\"><span translate=\"tikonApp.MultiReserveRepeatMode.WEEK_DAY\"></span></md-radio-button></md-radio-group></div></div></div></div></div></fieldset></div></div></div></div><div id=\"serviceOptionSection\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.optionTab\" eo-help-tooltip=\"tips.service_options\">optionTab</span></div><div class=\"panel-body\"><pf-service-item-option-info service-option-item=\"vm.serviceItem.serviceOptionItem\" service-item-id=\"vm.serviceItem.id\" form-state=\"vm.serviceOptionInfoFormState\"></pf-service-item-option-info></div></div></div><div id=\"priceInfoSection\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"supplierPanel.sideMenu.serviceItem.priceTab\" eo-help-tooltip=\"tips.service_price_info\">priceTab</span></div><div class=\"panel-body\"><pf-service-item-price-info service-item-id=\"vm.serviceItem.id\" on-create-new-price-info=\"vm.onCreateNewPriceInfo\" on-selected-price-info-changed=\"vm.onSelectedPriceInfoChanged\" form-state=\"vm.priceInfoFormState\" new-price-info=\"vm.serviceItem.newPriceInfo\" reload=\"vm.priceInfoFormReload\" price-infos=\"vm.serviceItem.servicePriceInfo\" price-info-type=\"vm.priceInfoType\"></pf-service-item-price-info></div></div></div><div id=\"marketPlaceSection\" ng-if=\"vm.showMarketPlaceSection\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.serviceItem.marketPlaceTab\">marketPlaceTab</span> <span ng-if=\"vm.serviceItem.marketPlacePublishStatus\" ng-class=\"vm.findMarketPlacePublishStatusStyle()\">- <span translate=\"{{\'tikonApp.MarketPlacePublishStatus.\' + vm.serviceItem.marketPlacePublishStatus}}\">{{vm.serviceItem.marketPlacePublishStatus}} </span><span ng-class=\"vm.findMarketPlacePublishStatusIcon(vm.serviceItem.marketPlacePublishStatus)\"></span></span></div><div class=\"panel-body\"><md-switch ng-model=\"vm.showOnMarketPlace\">نمایش در سایتهای دیگر (جذب مشتری)</md-switch></div></div></div></div></div></div><!--<div ng-click=\"vm.showAdvancedSetting()\" class=\"advanced-setting\" style=\"margin-top:10px \">--><!--<span>تنظیمات پیشرفته</span>--><!--&lt;!&ndash;<md-icon ></md-icon>&ndash;&gt;--><!--<md-icon ng-class=\"vm.getArrowClass()\">arrow_drop_down</md-icon>--><!--</div>--></form></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/service-option-info/service-option-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceOptionInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceOptionInfo.delete.question\" translate-values=\"{id: \'{{vm.serviceOptionInfo.id}}\'}\">Are you sure you want to delete this Service Option Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-option-info/service-option-info-detail.html","<div><h2><span translate=\"tikonApp.serviceOptionInfo.detail.title\">Service Option Info</span> {{vm.serviceOptionInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceOptionInfo.title\">Title</span></dt><dd><span>{{vm.serviceOptionInfo.title}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-option-info/service-option-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceOptionInfoLabel\" translate=\"tikonApp.serviceOptionInfo.home.createOrEditLabel\">Create or edit a Service Option Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceOptionInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceOptionInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionInfo.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.serviceOptionInfo.title\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-option-info/service-option-infos.html","<div><h2 translate=\"tikonApp.serviceOptionInfo.home.title\">Service Option Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><md-button class=\"md-raised md-primary\" ui-sref=\"service-option-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceOptionInfo.home.createLabel\">Create new Service Option Info</span></md-button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceOptionInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.serviceOptionInfo.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceOptionInfo in vm.serviceOptionInfos track by serviceOptionInfo.id\"><td><a ui-sref=\"service-option-info-detail({id:serviceOptionInfo.id})\">{{serviceOptionInfo.id}}</a></td><td>{{serviceOptionInfo.title}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-option-info-detail({id:serviceOptionInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-option-info.edit({id:serviceOptionInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-option-info.delete({id:serviceOptionInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-option-item/service-option-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceOptionItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceOptionItem.delete.question\" translate-values=\"{id: \'{{vm.serviceOptionItem.id}}\'}\">Are you sure you want to delete this Service Option Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-option-item/service-option-item-detail.html","<div><h2><span translate=\"tikonApp.serviceOptionItem.detail.title\">Service Option Item</span> {{vm.serviceOptionItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceOptionItem.optionName\">Option Name</span></dt><dd><span>{{vm.serviceOptionItem.optionName}}</span></dd><dt><span translate=\"tikonApp.serviceOptionItem.description\">Description</span></dt><dd><span>{{vm.serviceOptionItem.description}}</span></dd><dt><span translate=\"tikonApp.serviceOptionItem.optionInfo\">Option Info</span></dt><dd><a ui-sref=\"service-option-info-detail({id:vm.serviceOptionItem.optionInfoId})\">{{vm.serviceOptionItem.optionInfoId}}</a></dd><dt><span translate=\"tikonApp.serviceOptionItem.priceInfo\">Price Info</span></dt><dd><a ui-sref=\"price-info-detail({id:vm.serviceOptionItem.priceInfoId})\">{{vm.serviceOptionItem.priceInfoId}}</a></dd><dt><span translate=\"tikonApp.serviceOptionItem.images\">Images</span></dt><dd><a ui-sref=\"album-info-detail({id:vm.serviceOptionItem.imagesId})\">{{vm.serviceOptionItem.imagesId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-option-item/service-option-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceOptionItemLabel\" translate=\"tikonApp.serviceOptionItem.home.createOrEditLabel\">Create or edit a Service Option Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceOptionItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceOptionItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionItem.optionName\" for=\"field_optionName\">Option Name</label><input type=\"text\" class=\"form-control\" name=\"optionName\" id=\"field_optionName\" ng-model=\"vm.serviceOptionItem.optionName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionItem.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.serviceOptionItem.description\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceOptionItem.optionInfo\" for=\"field_optionInfo\">Option Info</label><select class=\"form-control\" id=\"field_optionInfo\" name=\"optionInfo\" ng-model=\"vm.serviceOptionItem.optionInfoId\" ng-options=\"serviceOptionInfo.id as serviceOptionInfo.id for serviceOptionInfo in vm.serviceoptioninfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceOptionItem.priceInfo\" for=\"field_priceInfo\">Price Info</label><select class=\"form-control\" id=\"field_priceInfo\" name=\"priceInfo\" ng-model=\"vm.serviceOptionItem.priceInfoId\" ng-options=\"priceInfo.id as priceInfo.id for priceInfo in vm.priceinfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceOptionItem.images\" for=\"field_images\">Images</label><select class=\"form-control\" id=\"field_images\" name=\"images\" ng-model=\"vm.serviceOptionItem.imagesId\" ng-options=\"albumInfo.id as albumInfo.id for albumInfo in vm.albuminfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-option-item/service-option-items.html","<div><h2 translate=\"tikonApp.serviceOptionItem.home.title\">Service Option Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-option-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceOptionItem.home.createLabel\">Create new Service Option Item</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceOptionItem.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"optionName\"><span translate=\"tikonApp.serviceOptionItem.optionName\">Option Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.serviceOptionItem.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"optionInfoId\"><span translate=\"tikonApp.serviceOptionItem.optionInfo\">Option Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"priceInfoId\"><span translate=\"tikonApp.serviceOptionItem.priceInfo\">Price Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"imagesId\"><span translate=\"tikonApp.serviceOptionItem.images\">Images</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceOptionItem in vm.serviceOptionItems track by serviceOptionItem.id\"><td><a ui-sref=\"service-option-item-detail({id:serviceOptionItem.id})\">{{serviceOptionItem.id}}</a></td><td>{{serviceOptionItem.optionName}}</td><td>{{serviceOptionItem.description}}</td><td><a ui-sref=\"service-option-info-detail({id:serviceOptionItem.optionInfoId})\">{{serviceOptionItem.optionInfoId}}</a></td><td><a ui-sref=\"price-info-detail({id:serviceOptionItem.priceInfoId})\">{{serviceOptionItem.priceInfoId}}</a></td><td><a ui-sref=\"album-info-detail({id:serviceOptionItem.imagesId})\">{{serviceOptionItem.imagesId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-option-item-detail({id:serviceOptionItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-option-item.edit({id:serviceOptionItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-option-item.delete({id:serviceOptionItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-time-session/service-time-session-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceTimeSession.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceTimeSession.delete.question\" translate-values=\"{id: \'{{vm.serviceTimeSession.id}}\'}\">Are you sure you want to delete this Service Time Session?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-time-session/service-time-session-detail.html","<div><h2><span translate=\"tikonApp.serviceTimeSession.detail.title\">Service Time Session</span> {{vm.serviceTimeSession.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceTimeSession.startTime\">Start Time</span></dt><dd><span>{{vm.serviceTimeSession.startTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.endTime\">End Time</span></dt><dd><span>{{vm.serviceTimeSession.endTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.startDate\">Start Date</span></dt><dd><span>{{vm.serviceTimeSession.startDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.endDate\">End Date</span></dt><dd><span>{{vm.serviceTimeSession.endDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.capacity\">Capacity</span></dt><dd><span>{{vm.serviceTimeSession.capacity}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.comment\">Comment</span></dt><dd><span>{{vm.serviceTimeSession.comment}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.price\">Price</span></dt><dd><span>{{vm.serviceTimeSession.price}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.discount\">Discount</span></dt><dd><span>{{vm.serviceTimeSession.discount}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSession.serviceTimeSessionInfo\">Service Time Session Info</span></dt><dd><a ui-sref=\"service-time-session-info-detail({id:vm.serviceTimeSession.serviceTimeSessionInfoId})\">{{vm.serviceTimeSession.serviceTimeSessionInfoId}}</a></dd><dt><span translate=\"tikonApp.serviceTimeSession.sessionTimes\">Session Times</span></dt><dd><a ui-sref=\"service-time-session-info-detail({id:vm.serviceTimeSession.sessionTimesId})\">{{vm.serviceTimeSession.sessionTimesId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-time-session/service-time-session-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceTimeSessionLabel\" translate=\"tikonApp.serviceTimeSession.home.createOrEditLabel\">Create or edit a Service Time Session</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceTimeSession.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceTimeSession.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.startTime\" for=\"field_startTime\">Start Time</label><div class=\"input-group\"><input id=\"field_startTime\" type=\"text\" class=\"form-control\" name=\"startTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.serviceTimeSession.startTime\" is-open=\"vm.datePickerOpenStatus.startTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.endTime\" for=\"field_endTime\">End Time</label><div class=\"input-group\"><input id=\"field_endTime\" type=\"text\" class=\"form-control\" name=\"endTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.serviceTimeSession.endTime\" is-open=\"vm.datePickerOpenStatus.endTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.startDate\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.serviceTimeSession.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.endDate\" for=\"field_endDate\">End Date</label><div class=\"input-group\"><input id=\"field_endDate\" type=\"text\" class=\"form-control\" name=\"endDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.serviceTimeSession.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.capacity\" for=\"field_capacity\">Capacity</label><input type=\"number\" class=\"form-control\" name=\"capacity\" id=\"field_capacity\" ng-model=\"vm.serviceTimeSession.capacity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.comment\" for=\"field_comment\">Comment</label><input type=\"text\" class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.serviceTimeSession.comment\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.price\" for=\"field_price\">Price</label><input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"vm.serviceTimeSession.price\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSession.discount\" for=\"field_discount\">Discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.serviceTimeSession.discount\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSession.serviceTimeSessionInfo\" for=\"field_serviceTimeSessionInfo\">Service Time Session Info</label><select class=\"form-control\" id=\"field_serviceTimeSessionInfo\" name=\"serviceTimeSessionInfo\" ng-model=\"vm.serviceTimeSession.serviceTimeSessionInfoId\" ng-options=\"serviceTimeSessionInfo.id as serviceTimeSessionInfo.id for serviceTimeSessionInfo in vm.servicetimesessioninfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSession.sessionTimes\" for=\"field_sessionTimes\">Session Times</label><select class=\"form-control\" id=\"field_sessionTimes\" name=\"sessionTimes\" ng-model=\"vm.serviceTimeSession.sessionTimesId\" ng-options=\"serviceTimeSessionInfo.id as serviceTimeSessionInfo.id for serviceTimeSessionInfo in vm.servicetimesessioninfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-time-session/service-time-sessions.html","<div><h2 translate=\"tikonApp.serviceTimeSession.home.title\">Service Time Sessions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-time-session.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceTimeSession.home.createLabel\">Create new Service Time Session</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceTimeSession.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startTime\"><span translate=\"tikonApp.serviceTimeSession.startTime\">Start Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endTime\"><span translate=\"tikonApp.serviceTimeSession.endTime\">End Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"tikonApp.serviceTimeSession.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endDate\"><span translate=\"tikonApp.serviceTimeSession.endDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"capacity\"><span translate=\"tikonApp.serviceTimeSession.capacity\">Capacity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"comment\"><span translate=\"tikonApp.serviceTimeSession.comment\">Comment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"price\"><span translate=\"tikonApp.serviceTimeSession.price\">Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discount\"><span translate=\"tikonApp.serviceTimeSession.discount\">Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceTimeSessionInfoId\"><span translate=\"tikonApp.serviceTimeSession.serviceTimeSessionInfo\">Service Time Session Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sessionTimesId\"><span translate=\"tikonApp.serviceTimeSession.sessionTimes\">Session Times</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceTimeSession in vm.serviceTimeSessions track by serviceTimeSession.id\"><td><a ui-sref=\"service-time-session-detail({id:serviceTimeSession.id})\">{{serviceTimeSession.id}}</a></td><td>{{serviceTimeSession.startTime | date:\'medium\'}}</td><td>{{serviceTimeSession.endTime | date:\'medium\'}}</td><td>{{serviceTimeSession.startDate | date:\'mediumDate\'}}</td><td>{{serviceTimeSession.endDate | date:\'mediumDate\'}}</td><td>{{serviceTimeSession.capacity}}</td><td>{{serviceTimeSession.comment}}</td><td>{{serviceTimeSession.price}}</td><td>{{serviceTimeSession.discount}}</td><td><a ui-sref=\"service-time-session-info-detail({id:serviceTimeSession.serviceTimeSessionInfoId})\">{{serviceTimeSession.serviceTimeSessionInfoId}}</a></td><td><a ui-sref=\"service-time-session-info-detail({id:serviceTimeSession.sessionTimesId})\">{{serviceTimeSession.sessionTimesId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-time-session-detail({id:serviceTimeSession.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-time-session.edit({id:serviceTimeSession.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-time-session.delete({id:serviceTimeSession.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-time-session-info/service-time-session-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceTimeSessionInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceTimeSessionInfo.delete.question\" translate-values=\"{id: \'{{vm.serviceTimeSessionInfo.id}}\'}\">Are you sure you want to delete this Service Time Session Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-time-session-info/service-time-session-info-detail.html","<div><h2><span translate=\"tikonApp.serviceTimeSessionInfo.detail.title\">Service Time Session Info</span> {{vm.serviceTimeSessionInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceTimeSessionInfo.type\">Type</span></dt><dd><span>{{vm.serviceTimeSessionInfo.type}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSessionInfo.serviceItem\">Service Item</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.serviceTimeSessionInfo.serviceItemId})\">{{vm.serviceTimeSessionInfo.serviceItemId}}</a></dd><dt><span translate=\"tikonApp.serviceTimeSessionInfo.scheduleInfo\">Schedule Info</span></dt><dd><a ui-sref=\"schedule-info-detail({id:vm.serviceTimeSessionInfo.scheduleInfoId})\">{{vm.serviceTimeSessionInfo.scheduleInfoId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-time-session-info/service-time-session-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceTimeSessionInfoLabel\" translate=\"tikonApp.serviceTimeSessionInfo.home.createOrEditLabel\">Create or edit a Service Time Session Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceTimeSessionInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceTimeSessionInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSessionInfo.type\" for=\"field_type\">Type</label><input type=\"number\" class=\"form-control\" name=\"type\" id=\"field_type\" ng-model=\"vm.serviceTimeSessionInfo.type\"></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSessionInfo.serviceItem\" for=\"field_serviceItem\">Service Item</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.serviceTimeSessionInfo.serviceItemId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSessionInfo.scheduleInfo\" for=\"field_scheduleInfo\">Schedule Info</label><select class=\"form-control\" id=\"field_scheduleInfo\" name=\"scheduleInfo\" ng-model=\"vm.serviceTimeSessionInfo.scheduleInfoId\" ng-options=\"scheduleInfo.id as scheduleInfo.id for scheduleInfo in vm.scheduleinfos\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-time-session-info/service-time-session-infos.html","<div><h2 translate=\"tikonApp.serviceTimeSessionInfo.home.title\">Service Time Session Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-time-session-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceTimeSessionInfo.home.createLabel\">Create new Service Time Session Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceTimeSessionInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"tikonApp.serviceTimeSessionInfo.type\">Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceItemId\"><span translate=\"tikonApp.serviceTimeSessionInfo.serviceItem\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"scheduleInfoId\"><span translate=\"tikonApp.serviceTimeSessionInfo.scheduleInfo\">Schedule Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceTimeSessionInfo in vm.serviceTimeSessionInfos track by serviceTimeSessionInfo.id\"><td><a ui-sref=\"service-time-session-info-detail({id:serviceTimeSessionInfo.id})\">{{serviceTimeSessionInfo.id}}</a></td><td>{{serviceTimeSessionInfo.type}}</td><td><a ui-sref=\"service-item-detail({id:serviceTimeSessionInfo.serviceItemId})\">{{serviceTimeSessionInfo.serviceItemId}}</a></td><td><a ui-sref=\"schedule-info-detail({id:serviceTimeSessionInfo.scheduleInfoId})\">{{serviceTimeSessionInfo.scheduleInfoId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-time-session-info-detail({id:serviceTimeSessionInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-time-session-info.edit({id:serviceTimeSessionInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-time-session-info.delete({id:serviceTimeSessionInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/service-time-session-servant/service-time-session-servant-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceTimeSessionServant.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.serviceTimeSessionServant.delete.question\" translate-values=\"{id: \'{{vm.serviceTimeSessionServant.id}}\'}\">Are you sure you want to delete this Service Time Session Servant?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/service-time-session-servant/service-time-session-servant-detail.html","<div><h2><span translate=\"tikonApp.serviceTimeSessionServant.detail.title\">Service Time Session Servant</span> {{vm.serviceTimeSessionServant.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.serviceTimeSessionServant.capacity\">Capacity</span></dt><dd><span>{{vm.serviceTimeSessionServant.capacity}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSessionServant.reserveType\">Reserve Type</span></dt><dd><span translate=\"{{\'tikonApp.ReserveTypes.\' + vm.serviceTimeSessionServant.reserveType}}\">{{vm.serviceTimeSessionServant.reserveType}}</span></dd><dt><span translate=\"tikonApp.serviceTimeSessionServant.timeSession\">Time Session</span></dt><dd><a ui-sref=\"service-time-session-detail({id:vm.serviceTimeSessionServant.timeSessionId})\">{{vm.serviceTimeSessionServant.timeSessionId}}</a></dd><dt><span translate=\"tikonApp.serviceTimeSessionServant.conflictTo\">Conflict To</span></dt><dd><a ui-sref=\"service-time-session-servant-detail({id:vm.serviceTimeSessionServant.conflictToId})\">{{vm.serviceTimeSessionServant.conflictToId}}</a></dd><dt><span translate=\"tikonApp.serviceTimeSessionServant.servant\">Servant</span></dt><dd><a ui-sref=\"servant-detail({id:vm.serviceTimeSessionServant.servantId})\">{{vm.serviceTimeSessionServant.servantId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/service-time-session-servant/service-time-session-servant-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceTimeSessionServantLabel\" translate=\"tikonApp.serviceTimeSessionServant.home.createOrEditLabel\">Create or edit a Service Time Session Servant</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.serviceTimeSessionServant.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.serviceTimeSessionServant.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSessionServant.capacity\" for=\"field_capacity\">Capacity</label><input type=\"number\" class=\"form-control\" name=\"capacity\" id=\"field_capacity\" ng-model=\"vm.serviceTimeSessionServant.capacity\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceTimeSessionServant.reserveType\" for=\"field_reserveType\">Reserve Type</label><select class=\"form-control\" name=\"reserveType\" ng-model=\"vm.serviceTimeSessionServant.reserveType\" id=\"field_reserveType\"><option value=\"FREE\" translate=\"tikonApp.ReserveTypes.FREE\">FREE</option><option value=\"RESERVED\" translate=\"tikonApp.ReserveTypes.RESERVED\">RESERVED</option><option value=\"CONFLICTED\" translate=\"tikonApp.ReserveTypes.CONFLICTED\">CONFLICTED</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSessionServant.timeSession\" for=\"field_timeSession\">Time Session</label><select class=\"form-control\" id=\"field_timeSession\" name=\"timeSession\" ng-model=\"vm.serviceTimeSessionServant.timeSessionId\" ng-options=\"serviceTimeSession.id as serviceTimeSession.id for serviceTimeSession in vm.servicetimesessions\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSessionServant.conflictTo\" for=\"field_conflictTo\">Conflict To</label><select class=\"form-control\" id=\"field_conflictTo\" name=\"conflictTo\" ng-model=\"vm.serviceTimeSessionServant.conflictToId\" ng-options=\"serviceTimeSessionServant.id as serviceTimeSessionServant.id for serviceTimeSessionServant in vm.servicetimesessionservants\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.serviceTimeSessionServant.servant\" for=\"field_servant\">Servant</label><select class=\"form-control\" id=\"field_servant\" name=\"servant\" ng-model=\"vm.serviceTimeSessionServant.servantId\" ng-options=\"servant.id as servant.id for servant in vm.servants\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/service-time-session-servant/service-time-session-servants.html","<div><h2 translate=\"tikonApp.serviceTimeSessionServant.home.title\">Service Time Session Servants</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"service-time-session-servant.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceTimeSessionServant.home.createLabel\">Create new Service Time Session Servant</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.serviceTimeSessionServant.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"capacity\"><span translate=\"tikonApp.serviceTimeSessionServant.capacity\">Capacity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reserveType\"><span translate=\"tikonApp.serviceTimeSessionServant.reserveType\">Reserve Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"timeSessionId\"><span translate=\"tikonApp.serviceTimeSessionServant.timeSession\">Time Session</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"conflictToId\"><span translate=\"tikonApp.serviceTimeSessionServant.conflictTo\">Conflict To</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"servantId\"><span translate=\"tikonApp.serviceTimeSessionServant.servant\">Servant</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceTimeSessionServant in vm.serviceTimeSessionServants track by serviceTimeSessionServant.id\"><td><a ui-sref=\"service-time-session-servant-detail({id:serviceTimeSessionServant.id})\">{{serviceTimeSessionServant.id}}</a></td><td>{{serviceTimeSessionServant.capacity}}</td><td translate=\"{{\'tikonApp.ReserveTypes.\' + serviceTimeSessionServant.reserveType}}\">{{serviceTimeSessionServant.reserveType}}</td><td><a ui-sref=\"service-time-session-detail({id:serviceTimeSessionServant.timeSessionId})\">{{serviceTimeSessionServant.timeSessionId}}</a></td><td><a ui-sref=\"service-time-session-servant-detail({id:serviceTimeSessionServant.conflictToId})\">{{serviceTimeSessionServant.conflictToId}}</a></td><td><a ui-sref=\"servant-detail({id:serviceTimeSessionServant.servantId})\">{{serviceTimeSessionServant.servantId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-time-session-servant-detail({id:serviceTimeSessionServant.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"service-time-session-servant.edit({id:serviceTimeSessionServant.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"service-time-session-servant.delete({id:serviceTimeSessionServant.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/setting-info/company-setting-info-v2.html","<eo-pl-modal-header title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><jhi-alert-error></jhi-alert-error><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.setting\">supplierPanel.sideMenu.companyInfo.setting</div><div class=\"panel-body\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div id=\"settingInfoComp\"><pf-setting-info setting-info=\"vm.settingInfo\" is-in-market-place=\"vm.isInMarketPlace\" on-image-uploaded=\"vm.save\"></pf-setting-info></div></form></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/setting-info/company-setting-info.html","<div class=\"container-fluid\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.setting\">supplierPanel.sideMenu.companyInfo.setting</div><div class=\"panel-body\"><div class=\"row\" style=\"margin: auto\"><div class=\"pull-right\"><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div><div class=\"pull-right\" ng-if=\"vm.settingFormSection && vm.settingFormSection==\'themeSettingTab\' && vm.saveComplete\"><md-button class=\"md-raised\" ng-click=\"vm.goToWebSite()\"><span><md-icon>open_in_new</md-icon></span><span translate=\"entity.action.viewChanges\">entity.action.viewChanges</span></md-button></div></div><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><!--<h2 translate=\"tikonApp.settingInfo.home.title\">Setting Infos</h2>--><!--<action-bar></action-bar>--><md-content class=\"rwMdContent\"><div id=\"settingInfoComp\"><pf-setting-info setting-info=\"vm.settingInfo\" is-in-market-place=\"vm.isInMarketPlace\"></pf-setting-info></div></md-content></form></div></div></div></div>");
$templateCache.put("app/entities/setting-info/setting-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.settingInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.settingInfo.delete.question\" translate-values=\"{id: \'{{vm.settingInfo.id}}\'}\">Are you sure you want to delete this Setting Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/setting-info/setting-info-detail.html","<div><h2><span translate=\"tikonApp.settingInfo.detail.title\">Setting Info</span> {{vm.settingInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.settingInfo.settingName\">Setting Name</span></dt><dd><span>{{vm.settingInfo.settingName}}</span></dd><dt><span translate=\"tikonApp.settingInfo.themeSettingInfo\">Theme Setting Info</span></dt><dd><a ui-sref=\"theme-setting-info-detail({id:vm.settingInfo.themeSettingInfoId})\">{{vm.settingInfo.themeSettingInfoId}}</a></dd><dt><span translate=\"tikonApp.settingInfo.notificationSetting\">Notification Setting</span></dt><dd><a ui-sref=\"notification-setting-detail({id:vm.settingInfo.notificationSettingId})\">{{vm.settingInfo.notificationSettingId}}</a></dd><dt><span translate=\"tikonApp.settingInfo.financialSetting\">Financial Setting</span></dt><dd><a ui-sref=\"financial-setting-detail({id:vm.settingInfo.financialSettingId})\">{{vm.settingInfo.financialSettingId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/setting-info/setting-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySettingInfoLabel\" translate=\"tikonApp.settingInfo.home.createOrEditLabel\">Create or edit a Setting Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.settingInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.settingInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.settingInfo.settingName\" for=\"field_settingName\">Setting Name</label><input type=\"text\" class=\"form-control\" name=\"settingName\" id=\"field_settingName\" ng-model=\"vm.settingInfo.settingName\"></div><div class=\"form-group\"><label translate=\"tikonApp.settingInfo.themeSettingInfo\" for=\"field_themeSettingInfo\">Theme Setting Info</label><select class=\"form-control\" id=\"field_themeSettingInfo\" name=\"themeSettingInfo\" ng-model=\"vm.settingInfo.themeSettingInfoId\" ng-options=\"themeSettingInfo.id as themeSettingInfo.id for themeSettingInfo in vm.themesettinginfos\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.settingInfo.notificationSetting\" for=\"field_notificationSetting\">Notification Setting</label><select class=\"form-control\" id=\"field_notificationSetting\" name=\"notificationSetting\" ng-model=\"vm.settingInfo.notificationSettingId\" ng-options=\"notificationSetting.id as notificationSetting.id for notificationSetting in vm.notificationsettings\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"tikonApp.settingInfo.financialSetting\" for=\"field_financialSetting\">Financial Setting</label><select class=\"form-control\" id=\"field_financialSetting\" name=\"financialSetting\" ng-model=\"vm.settingInfo.financialSettingId\" ng-options=\"financialSetting.id as financialSetting.id for financialSetting in vm.financialsettings\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/setting-info/setting-infos.html","<div><h2 translate=\"tikonApp.settingInfo.home.title\">Setting Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"setting-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.settingInfo.home.createLabel\">Create new Setting Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.settingInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"settingName\"><span translate=\"tikonApp.settingInfo.settingName\">Setting Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"themeSettingInfoId\"><span translate=\"tikonApp.settingInfo.themeSettingInfo\">Theme Setting Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"notificationSettingId\"><span translate=\"tikonApp.settingInfo.notificationSetting\">Notification Setting</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"financialSettingId\"><span translate=\"tikonApp.settingInfo.financialSetting\">Financial Setting</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"settingInfo in vm.settingInfos track by settingInfo.id\"><td><a ui-sref=\"setting-info-detail({id:settingInfo.id})\">{{settingInfo.id}}</a></td><td>{{settingInfo.settingName}}</td><td><a ui-sref=\"theme-setting-info-detail({id:settingInfo.themeSettingInfoId})\">{{settingInfo.themeSettingInfoId}}</a></td><td><a ui-sref=\"notification-setting-detail({id:settingInfo.notificationSettingId})\">{{settingInfo.notificationSettingId}}</a></td><td><a ui-sref=\"financial-setting-detail({id:settingInfo.financialSettingId})\">{{settingInfo.financialSettingId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"setting-info-detail({id:settingInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"setting-info.edit({id:settingInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"setting-info.delete({id:settingInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sms-pattern/sms-pattern-detail.html","<div><h2><span>الگوی پیامکی </span>{{vm.smsPattern.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span>عنوان</span></dt><dd><span>{{vm.smsPattern.title}}</span></dd><dt><span>وضعیت</span></dt><dd><span>{{vm.smsPattern.status}}</span></dd><dt><span>وضعیت تایید</span></dt><dd><span>{{vm.smsPattern.approveStatus}}</span></dd><dt><span>نوع</span></dt><dd><span>{{vm.smsPattern.type}}</span></dd><dt><span>تعداد</span></dt><dd><span>{{vm.smsPattern.count}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sms-pattern/sms-pattern-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyLabel\">ویرایش الگوی پیامکی</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><md-content class=\"rwMdContent\"><ul class=\"nav nav-tabs lightnav\"><li class=\"active\"><a data-target=\"#mainInfoTab\" data-toggle=\"tab\"><md-icon>person_outline</md-icon>اطلاعات اصلی </a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"mainInfoTab\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-show=\"vm.smsPattern.id\"><label for=\"id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.smsPattern.id\" readonly=\"readonly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_approveStatus\">Approve Status</label><select class=\"form-control\" name=\"approveStatus\" ng-model=\"vm.smsPattern.approveStatus\" id=\"field_approveStatus\"><option value=\"APPROVED\">APPROVED</option><option value=\"DENIED\">DENIED</option><option value=\"CHECKING\">CHECKING</option></select></div></div><!-- <div class=\"col-md-4\">\n                               <div class=\"form-group\">\n                                   <label class=\"control-label\"\n                                          for=\"field_status\">Status</label>\n                                   <select class=\"form-control\" name=\"status\"\n                                           ng-model=\"vm.smsPattern.status\" id=\"field_status\">\n                                       <option value=\"ACTIVE\">ACTIVE\n                                       </option>\n                                       <option value=\"INACTIVE\">INACTIVE</option>\n                                   </select>\n                               </div>\n                           </div> --></div><!-- <div class=\"col-md-4\">\n                             <div class=\"form-group\">\n                                 <label class=\"control-label\"\n                                        for=\"field_type\">Type</label>\n                                 <select class=\"form-control\" name=\"type\"\n                                         ng-model=\"vm.smsPattern.type\" id=\"field_type\">\n                                     <option value=\"MANUAL\">MANUAL\n                                     </option>\n                                     <option value=\"AUTOMATIC\">AUTOMATIC</option>\n                                 </select>\n                             </div>\n                         </div> --><div class=\"row\"><!-- <div class=\"col-md-4\">\n                                <div class=\"form-group\">\n                                    <label class=\"control-label\"\n                                           for=\"field_count\">Count</label>\n                                    <input type=\"text\" class=\"form-control\" name=\"count\"\n                                           id=\"field_count\"\n                                           ng-model=\"vm.smsPattern.count\"\n                                    />\n                                </div>\n                            </div> --><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_template\">Template</label><textarea class=\"form-control\" rows=\"5\" id=\"field_template\" placeholder=\"\" ng-model=\"vm.smsPattern.notificationTemplate.template\"></textarea></div></div><div class=\"row\" ng-if=\"vm.smsPattern.approveStatus==\'DENIED\'\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_approveResult\">دلایل رد شدن</label><input type=\"text\" class=\"form-control\" id=\"field_approveResult\" name=\"field_approveResult\" ng-model=\"vm.smsPattern.approveResult\"></div></div></div><div style=\"color:darkorange\">**** حتما عبارت \"لغو11\" در انتهای متن باید قرارگیرد ****</div><div style=\"color:red\" ng-if=\"!vm.isTemplateValid()\">به ظاهر عبارت لغو11 در متن وجود ندارد!</div><div ng-if=\"vm.smsPattern.actionType == \'SMS_PANEL\'\"><pf-sms-panel-overview marketing-campaign=\"vm.smsPattern\" show-action-buttons=\"false\"></pf-sms-panel-overview></div><!-- <div class=\"col-md-4\">\n                                <div class=\"form-group\">\n                                    <label class=\"control-label\"\n                                           for=\"field_paymentGatewayAccess\">paymentGatewayAccess</label>\n                                    <select class=\"form-control\" name=\"paymentGatewayAccess\"\n                                            ng-model=\"vm.company.paymentGatewayAccess\" id=\"field_paymentGatewayAccess\">\n                                        <option value=\"ACCESS_JUST_PERSONAL_GATEWAY\">ACCESS_JUST_PERSONAL_GATEWAY\n                                        </option>\n                                        <option value=\"ACCESS_ALL\">ACCESS_ALL</option>\n                                        <option value=\"ACCESS_NOTHING\">ACCESS_NOTHING</option>\n                                    </select>\n                                </div>\n                            </div> --></div><!-- <div class=\"form-group\">\n                            <label class=\"control-label\"\n                                   for=\"field_customerIntakeFields\">CustomerIntakeFields</label>\n                            <input type=\"text\" class=\"form-control\" name=\"customerIntakeFields\"\n                                   id=\"field_customerIntakeFields\"\n                                   ng-model=\"vm.company.customerIntakeFields\"\n                            />\n                        </div>\n\n                        <div class=\"form-group\">\n                            <label class=\"control-label\"\n                                   for=\"field_clientBookingWidgetType\">clientBookingWidgetType</label>\n                            <select class=\"form-control\" name=\"clientBookingWidgetType\"\n                                    ng-model=\"vm.company.customSettingObject.clientBookingWidgetType\"\n                                    id=\"field_clientBookingWidgetType\">\n                                <option value=\"DEFAULT\">DEFAULT</option>\n                                <option value=\"VUE_COMPONENT\">VUE_COMPONENT</option>\n                            </select>\n                        </div> --></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"customSettingTab\"><!-- <div class=\"container-fluid\">\n                        <pf-sms-text-editor label=\"\'پیامک یادآوری\'\"\n                                            sms-text=\"vm.company.customSettingObject.customerFirstReminderMsg\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک  ثبت رزرو به مشتری\'\"\n                                            sms-text=\"vm.company.customSettingObject.clientConfirmMessageCustomEnding\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک تایید پرداخت\'\"\n                                            sms-text=\"vm.company.customSettingObject.requestConfirmationMsg\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک درخواست رزرو\'\"\n                                            sms-text=\"vm.company.customSettingObject.reserveRequestMsgToClient\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک لغو رزرو\'\"\n                                            sms-text=\"vm.company.customSettingObject.reserveCancelationEndingMsg\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک لغو درخواست رزرو\'\"\n                                            sms-text=\"vm.company.customSettingObject.reserveRequestCanceledMsg\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک ثبت رزرو به پرسنل\'\"\n                                            sms-text=\"vm.company.customSettingObject.supplierConfirmMsg\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک ویرایش رزرو به مشتری\'\"\n                                            sms-text=\"vm.company.customSettingObject.reservationEditedMsgFromSupplier\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک رزرو مجدد\'\"\n                                            sms-text=\"vm.company.customSettingObject.rebookMessage\"></pf-sms-text-editor>\n                        <pf-sms-text-editor label=\"\'پیامک بعد از خدمات\'\"\n                                            sms-text=\"vm.company.customSettingObject.customerSatisfactionMessage\"></pf-sms-text-editor>\n\n                        <div class=\"form-group\">\n                            <label for=\"id\">نمایش فوتر</label>\n                            <input type=\"text\" class=\"form-control\" id=\"footerViewMode\" name=\"footerViewMode\"\n                                   ng-model=\"vm.company.customSettingObject.footerViewMode\"/>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label\">IsParent</label>\n                            <md-checkbox ng-model=\"vm.company.customSettingObject.isParent\">\n                            </md-checkbox>\n                        </div>\n                        <div class=\"form-group\">\n                            <label for=\"id\">\n                                External Company Id\n                            </label>\n                            <input type=\"text\" class=\"form-control\" id=\"externalCompanyId\"\n                                   name=\"externalCompanyId\"\n                                   ng-model=\"vm.company.customSettingObject.externalCompanyId\"/>\n                        </div>\n\n\n                    </div> --></div></div></md-content></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sms-pattern/sms-patterns.html","<div><h2 translate=\"tikonApp.smsPattern.home.title\">Sms Patterns</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th colspan=\"5\"><div class=\"row\"><eo-pl-search-box search-query=\"vm.searchQuery\" search-place-holder=\"\" on-search=\"vm.search(vm.searchQuery)\" on-clear-search=\"vm.clearSearch()\"></eo-pl-search-box></div></th></tr><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.smsPattern.title\">عنوان</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.smsPattern.actionType\">نوع</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span>وضعیت</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"approveStatus\"><span>وضعیت تایید</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span>نوع</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"count\"><span>تعداد</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"count\"><span>تاریخ ثبت</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"count\"><span>نام شرکت</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"count\"><span>keyUrl</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"pattern in vm.patterns \"><td><a ui-sref=\"smsPatterns-detail({id:pattern.id})\">{{pattern.id}}</a></td><td>{{pattern.title}}</td><td>{{pattern.actionType}}</td><td>{{pattern.status}}</td><td>{{pattern.approveStatus}}</td><td>{{pattern.type}}</td><td>{{pattern.count}}</td><td><span ng-if=\"pattern.createDate\">{{pattern.createDate | toPersianDate}}</span></td><td>{{pattern.companyTitle}}</td><td>{{pattern.keyUrl}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"smsPatterns-detail({id:pattern.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"smsPatterns-edit({id:pattern.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button></div></td></tr></tbody></table><!-- {{vm.patterns[0].company}} --></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/social-network-info/social-network-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.socialNetworkInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.socialNetworkInfo.delete.question\" translate-values=\"{id: \'{{vm.socialNetworkInfo.id}}\'}\">Are you sure you want to delete this Social Network Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/social-network-info/social-network-info-detail.html","<div><h2><span translate=\"tikonApp.socialNetworkInfo.detail.title\">Social Network Info</span> {{vm.socialNetworkInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.socialNetworkInfo.socialNetworkType\">Social Network Type</span></dt><dd><span translate=\"{{\'tikonApp.SocialNetworkType.\' + vm.socialNetworkInfo.socialNetworkType}}\">{{vm.socialNetworkInfo.socialNetworkType}}</span></dd><dt><span translate=\"tikonApp.socialNetworkInfo.title\">Title</span></dt><dd><span>{{vm.socialNetworkInfo.title}}</span></dd><dt><span translate=\"tikonApp.socialNetworkInfo.url\">Url</span></dt><dd><span>{{vm.socialNetworkInfo.url}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/social-network-info/social-network-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySocialNetworkInfoLabel\" translate=\"tikonApp.socialNetworkInfo.home.createOrEditLabel\">Create or edit a Social Network Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.socialNetworkInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.socialNetworkInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.socialNetworkInfo.socialNetworkType\" for=\"field_socialNetworkType\">Social Network Type</label><select class=\"form-control\" name=\"socialNetworkType\" ng-model=\"vm.socialNetworkInfo.socialNetworkType\" id=\"field_socialNetworkType\"><option value=\"FACEBOOK\" translate=\"tikonApp.SocialNetworkType.FACEBOOK\">FACEBOOK</option><option value=\"TWITTER\" translate=\"tikonApp.SocialNetworkType.TWITTER\">TWITTER</option><option value=\"INSTAGRAM\" translate=\"tikonApp.SocialNetworkType.INSTAGRAM\">INSTAGRAM</option><option value=\"TELEGRAM\" translate=\"tikonApp.SocialNetworkType.TELEGRAM\">TELEGRAM</option><option value=\"GOOGLE\" translate=\"tikonApp.SocialNetworkType.GOOGLE\">GOOGLE</option><option value=\"YAHOO\" translate=\"tikonApp.SocialNetworkType.YAHOO\">YAHOO</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.socialNetworkInfo.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.socialNetworkInfo.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.socialNetworkInfo.url\" for=\"field_url\">Url</label><input type=\"text\" class=\"form-control\" name=\"url\" id=\"field_url\" ng-model=\"vm.socialNetworkInfo.url\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/social-network-info/social-network-infos.html","<div><h2 translate=\"tikonApp.socialNetworkInfo.home.title\">Social Network Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"social-network-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.socialNetworkInfo.home.createLabel\">Create new Social Network Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.socialNetworkInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"socialNetworkType\"><span translate=\"tikonApp.socialNetworkInfo.socialNetworkType\">Social Network Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.socialNetworkInfo.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"url\"><span translate=\"tikonApp.socialNetworkInfo.url\">Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"socialNetworkInfo in vm.socialNetworkInfos track by socialNetworkInfo.id\"><td><a ui-sref=\"social-network-info-detail({id:socialNetworkInfo.id})\">{{socialNetworkInfo.id}}</a></td><td translate=\"{{\'tikonApp.SocialNetworkType.\' + socialNetworkInfo.socialNetworkType}}\">{{socialNetworkInfo.socialNetworkType}}</td><td>{{socialNetworkInfo.title}}</td><td>{{socialNetworkInfo.url}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"social-network-info-detail({id:socialNetworkInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"social-network-info.edit({id:socialNetworkInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"social-network-info.delete({id:socialNetworkInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/subscription-package/subscription-package-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.subscriptionPackage.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.subscriptionPackage.delete.question\" translate-values=\"{id: \'{{vm.subscriptionPackage.id}}\'}\">Are you sure you want to delete this Subscription Package?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/subscription-package/subscription-package-detail.html","<div><h2><span translate=\"tikonApp.subscriptionPackage.detail.title\">Subscription Package</span> {{vm.subscriptionPackage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.subscriptionPackage.title\">Title</span></dt><dd><span>{{vm.subscriptionPackage.title}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.description\">Description</span></dt><dd><span>{{vm.subscriptionPackage.description}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.durationDays\">Duration Days</span></dt><dd><span>{{vm.subscriptionPackage.durationDays}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.chargeFee\">Charge Fee</span></dt><dd><span>{{vm.subscriptionPackage.chargeFee}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.startDate\">Start Date</span></dt><dd><span>{{vm.subscriptionPackage.startDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.endDate\">End Date</span></dt><dd><span>{{vm.subscriptionPackage.endDate | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.status\">Status</span></dt><dd><span translate=\"{{\'tikonApp.SubscriptionPackageStatus.\' + vm.subscriptionPackage.status}}\">{{vm.subscriptionPackage.status}}</span></dd><dt><span translate=\"tikonApp.subscriptionPackage.featureList\">Feature List</span></dt><dd><a ui-sref=\"package-feature-list-detail({id:vm.subscriptionPackage.featureListId})\">{{vm.subscriptionPackage.featureListId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/subscription-package/subscription-package-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySubscriptionPackageLabel\" translate=\"tikonApp.subscriptionPackage.home.createOrEditLabel\">Create or edit a Subscription Package</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.subscriptionPackage.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.subscriptionPackage.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.subscriptionPackage.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.subscriptionPackage.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.durationDays\" for=\"field_durationDays\">Duration Days</label><input type=\"number\" class=\"form-control\" name=\"durationDays\" id=\"field_durationDays\" ng-model=\"vm.subscriptionPackage.durationDays\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.chargeFee\" for=\"field_chargeFee\">Charge Fee</label><input type=\"number\" class=\"form-control\" name=\"chargeFee\" id=\"field_chargeFee\" ng-model=\"vm.subscriptionPackage.chargeFee\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.startDate\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.subscriptionPackage.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.endDate\" for=\"field_endDate\">End Date</label><div class=\"input-group\"><input id=\"field_endDate\" type=\"text\" class=\"form-control\" name=\"endDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.subscriptionPackage.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.subscriptionPackage.status\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.subscriptionPackage.status\" id=\"field_status\"><option value=\"ACTIVE\" translate=\"tikonApp.SubscriptionPackageStatus.ACTIVE\">ACTIVE</option><option value=\"INACTIVE\" translate=\"tikonApp.SubscriptionPackageStatus.INACTIVE\">INACTIVE</option></select></div><div class=\"form-group\"><label translate=\"tikonApp.subscriptionPackage.featureList\" for=\"field_featureList\">Feature List</label><select class=\"form-control\" id=\"field_featureList\" name=\"featureList\" ng-model=\"vm.subscriptionPackage.featureListId\" ng-options=\"packageFeatureList.id as packageFeatureList.id for packageFeatureList in vm.packagefeaturelists\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/subscription-package/subscription-packages.html","<div><h2 translate=\"tikonApp.subscriptionPackage.home.title\">Subscription Packages</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"subscription-package.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.subscriptionPackage.home.createLabel\">Create new Subscription Package</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.subscriptionPackage.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"tikonApp.subscriptionPackage.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.subscriptionPackage.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"durationDays\"><span translate=\"tikonApp.subscriptionPackage.durationDays\">Duration Days</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"chargeFee\"><span translate=\"tikonApp.subscriptionPackage.chargeFee\">Charge Fee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"tikonApp.subscriptionPackage.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endDate\"><span translate=\"tikonApp.subscriptionPackage.endDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.subscriptionPackage.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"featureListId\"><span translate=\"tikonApp.subscriptionPackage.featureList\">Feature List</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"subscriptionPackage in vm.subscriptionPackages track by subscriptionPackage.id\"><td><a ui-sref=\"subscription-package-detail({id:subscriptionPackage.id})\">{{subscriptionPackage.id}}</a></td><td>{{subscriptionPackage.title}}</td><td>{{subscriptionPackage.description}}</td><td>{{subscriptionPackage.durationDays}}</td><td>{{subscriptionPackage.chargeFee}}</td><td>{{subscriptionPackage.startDate | date:\'medium\'}}</td><td>{{subscriptionPackage.endDate | date:\'medium\'}}</td><td translate=\"{{\'tikonApp.SubscriptionPackageStatus.\' + subscriptionPackage.status}}\">{{subscriptionPackage.status}}</td><td><a ui-sref=\"package-feature-list-detail({id:subscriptionPackage.featureListId})\">{{subscriptionPackage.featureListId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"subscription-package-detail({id:subscriptionPackage.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"subscription-package.edit({id:subscriptionPackage.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"subscription-package.delete({id:subscriptionPackage.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/supplier-coupon/supplier-coupon-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.supplierCoupon.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.supplierCoupon.delete.question\" translate-values=\"{id: \'{{vm.supplierCoupon.id}}\'}\">Are you sure you want to delete this Supplier Coupon?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/supplier-coupon/supplier-coupon-dialog.html","<style>.form-field-description {\n        font-size: 10px;\n        color: #607d8b;\n    }\n\n    .usedCouponClass {\n        border: 1px solid #dee3e7;\n        border-radius: 5px;\n        padding: 9px;\n        margin-top: 5px;\n        background-color: antiquewhite;\n        color: #607d8b;\n        margin-right: 10px;\n    }</style><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySupplierCouponLabel\" translate=\"tikonApp.supplierCoupon.home.createOrEditLabel\">Create or edit a Subscription Package</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><style>.service-schedule-block {\n                        border-bottom: solid 1px #ff9d1a;\n                    }</style><div class=\"row\" style=\"margin: auto\"><div ng-if=\"vm.supplierCoupon.usedCouponCount != null\"><div class=\"pull-right usedCouponClass\"><div ng-if=\"vm.supplierCoupon.usedCouponCount>0\"><span>این کد تخفیف </span><span>{{vm.supplierCoupon.usedCouponCount}}</span> <span>بار استفاده شده است .</span></div><div ng-if=\"vm.supplierCoupon.usedCouponCount==0\"><span>از این کد هنوز استفاده نشده است.</span></div></div></div></div><md-content class=\"rwMdContent\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.supplierCoupon.couponCode\" for=\"field_couponCode\">couponCode</label><input type=\"text\" class=\"form-control\" name=\"couponCode\" id=\"field_couponCode\" ng-model=\"vm.supplierCoupon.couponCode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.supplierCoupon.generateType\" for=\"field_generateType\">generateType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.supplierCoupon.generateType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_generateType\"><md-option value=\"MANUAL\" translate=\"tikonApp.couponGenerateTypes.MANUAL\">MANUAL</md-option><md-option value=\"AUTOMATIC\" disabled=\"disabled\" translate=\"tikonApp.couponGenerateTypes.AUTOMATIC\">AUTOMATIC</md-option><md-option value=\"GENERATED_By_SYSTEM\" disabled=\"disabled\" translate=\"tikonApp.couponGenerateTypes.GENERATED_By_SYSTEM\">GENERATED_By_SYSTEM</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.supplierCoupon.status\" for=\"field_amountType\">status</label><md-select class=\"rwMdSelect\" ng-model=\"vm.supplierCoupon.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\"><md-option value=\"ACTIVE\" translate=\"tikonApp.couponStatus.ACTIVE\">ACTIVE</md-option><md-option value=\"INACTIVE\" translate=\"tikonApp.couponStatus.INACTIVE\">INACTIVE</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.supplierCoupon.amountType\" for=\"field_amountType\">amountType</label><md-select class=\"rwMdSelect\" ng-model=\"vm.supplierCoupon.amountType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_amountType\"><md-option value=\"PERCENT\" translate=\"tikonApp.amountTypes.PERCENT\">PERCENT</md-option><md-option value=\"CASH\" translate=\"tikonApp.amountTypes.CASH\">CASH</md-option></md-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.supplierCoupon.amount\" for=\"field_amount\">Amount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.supplierCoupon.amount\" min=\"0\"></div></div><div class=\"col-md-1\"><div class=\"\" style=\"margin-top: 46px; margin-right: -20px\"><div ng-if=\"vm.supplierCoupon.amountType==\'PERCENT\'\">%</div><div ng-if=\"vm.supplierCoupon.amountType==\'CASH\'\"><span translate=\"global.currencyBracket\"></span></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" style=\"margin-top: 20px\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.startDate\" for=\"field_startDate\">startDate</label><eo-date-picker id=\"field_startDate\" date-value=\"vm.supplierCoupon.startDate\"></eo-date-picker></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"margin-top: 20px\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.expireDate\" for=\"field_expireDate\">expireDate</label><eo-date-picker id=\"field_expireDate\" date-value=\"vm.supplierCoupon.expireDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.generalUseCount\" for=\"field_generalUseCount\">generalUseCount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_generalUseCount\" ng-model=\"vm.supplierCoupon.generalUseCount\" min=\"1\"><div class=\"form-field-description\" translate=\"tikonApp.supplierCoupon.fieldsDescription.generalUseCount\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.customerUseCount\" for=\"field_customerUseCount\">customerUseCount</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_customerUseCount\" ng-model=\"vm.supplierCoupon.customerUseCount\" min=\"1\"><div class=\"form-field-description\" translate=\"tikonApp.supplierCoupon.fieldsDescription.customerUseCount\"></div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\" style=\"margin-top: 20px;\">--><!--<label class=\"control-label\" translate=\"tikonApp.supplierCoupon.startDate\"--><!--for=\"field_startDate\">startDate--><!--</label>--><!--<eo-date-picker id=\"field_startDate\"--><!--date-value=\"vm.supplierCoupon.startDate\"></eo-date-picker>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.maxApplyAmount\" for=\"field_maxApplyAmount\">maxApplyAmount</label><input type=\"number\" class=\"form-control\" name=\"maxApplyAmount\" id=\"field_maxApplyAmount\" ng-model=\"vm.supplierCoupon.maxApplyAmount\" min=\"0\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.supplierCoupon.minPurchase\" for=\"field_minPurchase\">minPurchase</label><input type=\"number\" class=\"form-control\" name=\"minPurchase\" id=\"field_minPurchase\" ng-model=\"vm.supplierCoupon.minPurchase\" min=\"0\"></div></div></div><div id=\"services\"><div class=\"row\"><div class=\"form-group\"><div class=\"rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.forAllSubscriptionPackages\" aria-label=\"Switch 1\" ng-change=\"vm.switch_changed()\"><span translate=\"tikonApp.supplierCoupon.forAllSubscriptionPackages\"></span></md-switch></div></div></div></div></div><div class=\"row\" ng-if=\"!vm.forAllSubscriptionPackages\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"tikonApp.supplierCoupon.selectServicesForApply\"></span></legend><div class=\"col-md-3\" ng-repeat=\"subscriptionPackage in vm.allSubscriptionPackages\"><md-checkbox ng-model=\"subscriptionPackage.selected\" aria-label=\"Checkbox 1\">{{subscriptionPackage.title}}<div>( {{\'tikonApp.SubscriptionType.\'+ subscriptionPackage.subscriptionType | translate}} )</div></md-checkbox></div></fieldset></div></div></md-content></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/supplier-coupon/supplier-coupons.html","<div><h2 translate=\"tikonApp.supplierCoupon.home.title\">Supplier Coupon</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"supplier-coupon.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.supplierCoupon.home.createLabel\">Create new Supplier Coupon</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.supplierCoupon.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"couponCode\"><span translate=\"tikonApp.supplierCoupon.couponCode\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createDate\"><span translate=\"tikonApp.supplierCoupon.createDate\">Create Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"tikonApp.supplierCoupon.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expireDate\"><span translate=\"tikonApp.supplierCoupon.expireDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"tikonApp.supplierCoupon.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amountType\"><span translate=\"tikonApp.supplierCoupon.amountType\">amountType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amount\"><span translate=\"tikonApp.supplierCoupon.amount\">amount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"supplierCoupon in vm.supplierCoupons track by supplierCoupon.id\"><td><a ui-sref=\"supplier-coupon-detail({id:supplierCoupon.id})\">{{supplierCoupon.id}}</a></td><td>{{supplierCoupon.couponCode}}</td><td>{{supplierCoupon.createDate| toPersianDate}}</td><td>{{supplierCoupon.startDate | toPersianDate}}</td><td>{{supplierCoupon.expireDate | toPersianDate}}</td><td translate=\"{{\'tikonApp.couponStatus.\' + supplierCoupon.status}}\">{{supplierCoupon.status}}</td><td translate=\"{{\'tikonApp.amountTypes.\' + supplierCoupon.amountType}}\">{{supplierCoupon.amountType}}</td><td>{{supplierCoupon.amount}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplier-coupon.edit({id:supplierCoupon.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"supplier-coupon.delete({id:supplierCoupon.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/theme-setting-info/theme-setting-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.themeSettingInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.themeSettingInfo.delete.question\" translate-values=\"{id: \'{{vm.themeSettingInfo.id}}\'}\">Are you sure you want to delete this Theme Setting Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/theme-setting-info/theme-setting-info-detail.html","<div><h2><span translate=\"tikonApp.themeSettingInfo.detail.title\">Theme Setting Info</span> {{vm.themeSettingInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.themeSettingInfo.name\">Name</span></dt><dd><span>{{vm.themeSettingInfo.name}}</span></dd><dt><span translate=\"tikonApp.themeSettingInfo.logoImage\">Logo Image</span></dt><dd><a ui-sref=\"image-data-detail({id:vm.themeSettingInfo.logoImageId})\">{{vm.themeSettingInfo.logoImageId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/theme-setting-info/theme-setting-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myThemeSettingInfoLabel\" translate=\"tikonApp.themeSettingInfo.home.createOrEditLabel\">Create or edit a Theme Setting Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.themeSettingInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.themeSettingInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.themeSettingInfo.name\"></div><div class=\"form-group\"><label translate=\"tikonApp.themeSettingInfo.logoImage\" for=\"field_logoImage\">Logo Image</label><select class=\"form-control\" id=\"field_logoImage\" name=\"logoImage\" ng-model=\"vm.themeSettingInfo.logoImageId\" ng-options=\"imageData.id as imageData.id for imageData in vm.imagedata\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/theme-setting-info/theme-setting-infos.html","<div><h2 translate=\"tikonApp.themeSettingInfo.home.title\">Theme Setting Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"theme-setting-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.themeSettingInfo.home.createLabel\">Create new Theme Setting Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.themeSettingInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"tikonApp.themeSettingInfo.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"logoImageId\"><span translate=\"tikonApp.themeSettingInfo.logoImage\">Logo Image</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"themeSettingInfo in vm.themeSettingInfos track by themeSettingInfo.id\"><td><a ui-sref=\"theme-setting-info-detail({id:themeSettingInfo.id})\">{{themeSettingInfo.id}}</a></td><td>{{themeSettingInfo.name}}</td><td><a ui-sref=\"image-data-detail({id:themeSettingInfo.logoImageId})\">{{themeSettingInfo.logoImageId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"theme-setting-info-detail({id:themeSettingInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"theme-setting-info.edit({id:themeSettingInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"theme-setting-info.delete({id:themeSettingInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/time-period/time-period-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.timePeriod.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.timePeriod.delete.question\" translate-values=\"{id: \'{{vm.timePeriod.id}}\'}\">Are you sure you want to delete this Time Period?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/time-period/time-period-detail.html","<div><h2><span translate=\"tikonApp.timePeriod.detail.title\">Time Period</span> {{vm.timePeriod.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.timePeriod.startTime\">Start Time</span></dt><dd><span>{{vm.timePeriod.startTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.timePeriod.endTime\">End Time</span></dt><dd><span>{{vm.timePeriod.endTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.timePeriod.duration\">Duration</span></dt><dd><span>{{vm.timePeriod.duration}}</span></dd><dt><span translate=\"tikonApp.timePeriod.gaptime\">Gaptime</span></dt><dd><span>{{vm.timePeriod.gaptime}}</span></dd><dt><span translate=\"tikonApp.timePeriod.offtimes\">Offtimes</span></dt><dd><span ng-repeat=\"offtimes in vm.timePeriod.offtimes\"><a ui-sref=\"off-time-detail({id: {{offtimes.id}}})\">{{offtimes.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/time-period/time-period-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTimePeriodLabel\" translate=\"tikonApp.timePeriod.home.createOrEditLabel\">Create or edit a Time Period</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.timePeriod.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.timePeriod.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.timePeriod.startTime\" for=\"field_startTime\">Start Time</label><div class=\"input-group\"><input id=\"field_startTime\" type=\"text\" class=\"form-control\" name=\"startTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.timePeriod.startTime\" is-open=\"vm.datePickerOpenStatus.startTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.timePeriod.endTime\" for=\"field_endTime\">End Time</label><div class=\"input-group\"><input id=\"field_endTime\" type=\"text\" class=\"form-control\" name=\"endTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.timePeriod.endTime\" is-open=\"vm.datePickerOpenStatus.endTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.timePeriod.duration\" for=\"field_duration\">Duration</label><input type=\"number\" class=\"form-control\" name=\"duration\" id=\"field_duration\" ng-model=\"vm.timePeriod.duration\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.timePeriod.gaptime\" for=\"field_gaptime\">Gaptime</label><input type=\"number\" class=\"form-control\" name=\"gaptime\" id=\"field_gaptime\" ng-model=\"vm.timePeriod.gaptime\"></div><div class=\"form-group\"><label translate=\"tikonApp.timePeriod.offtimes\" for=\"field_offtimes\">Offtimes</label><select class=\"form-control\" id=\"field_offtimes\" multiple=\"multiple\" name=\"offtimes\" ng-model=\"vm.timePeriod.offtimes\" ng-options=\"offTime as offTime.id for offTime in vm.offtimes track by offTime.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/time-period/time-periods.html","<div><h2 translate=\"tikonApp.timePeriod.home.title\">Time Periods</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"time-period.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.timePeriod.home.createLabel\">Create new Time Period</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.timePeriod.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startTime\"><span translate=\"tikonApp.timePeriod.startTime\">Start Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endTime\"><span translate=\"tikonApp.timePeriod.endTime\">End Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"duration\"><span translate=\"tikonApp.timePeriod.duration\">Duration</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"gaptime\"><span translate=\"tikonApp.timePeriod.gaptime\">Gaptime</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"timePeriod in vm.timePeriods track by timePeriod.id\"><td><a ui-sref=\"time-period-detail({id:timePeriod.id})\">{{timePeriod.id}}</a></td><td>{{timePeriod.startTime | date:\'medium\'}}</td><td>{{timePeriod.endTime | date:\'medium\'}}</td><td>{{timePeriod.duration}}</td><td>{{timePeriod.gaptime}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"time-period-detail({id:timePeriod.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"time-period.edit({id:timePeriod.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"time-period.delete({id:timePeriod.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/waiting-list/waiting-list-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.waitingList.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.waitingList.delete.question\" translate-values=\"{id: \'{{vm.waitingList.id}}\'}\">Are you sure you want to delete this Waiting List?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/waiting-list/waiting-list-detail.html","<div><h2><span translate=\"tikonApp.waitingList.detail.title\">Waiting List</span> {{vm.waitingList.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.waitingList.qty\">Qty</span></dt><dd><span>{{vm.waitingList.qty}}</span></dd><dt><span translate=\"tikonApp.waitingList.reserveTime\">Reserve Time</span></dt><dd><span>{{vm.waitingList.reserveTime | date:\'medium\'}}</span></dd><dt><span translate=\"tikonApp.waitingList.description\">Description</span></dt><dd><span>{{vm.waitingList.description}}</span></dd><dt><span translate=\"tikonApp.waitingList.serviceIte\">Service Ite</span></dt><dd><a ui-sref=\"service-item-detail({id:vm.waitingList.serviceIteId})\">{{vm.waitingList.serviceIteId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/waiting-list/waiting-list-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myWaitingListLabel\" translate=\"tikonApp.waitingList.home.createOrEditLabel\">Create or edit a Waiting List</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.waitingList.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.waitingList.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.waitingList.qty\" for=\"field_qty\">Qty</label><input type=\"number\" class=\"form-control\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.waitingList.qty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.waitingList.reserveTime\" for=\"field_reserveTime\">Reserve Time</label><div class=\"input-group\"><input id=\"field_reserveTime\" type=\"text\" class=\"form-control\" name=\"reserveTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.waitingList.reserveTime\" is-open=\"vm.datePickerOpenStatus.reserveTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'reserveTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.waitingList.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.waitingList.description\"></div><div class=\"form-group\"><label translate=\"tikonApp.waitingList.serviceIte\" for=\"field_serviceIte\">Service Ite</label><select class=\"form-control\" id=\"field_serviceIte\" name=\"serviceIte\" ng-model=\"vm.waitingList.serviceIteId\" ng-options=\"serviceItem.id as serviceItem.id for serviceItem in vm.serviceitems\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/waiting-list/waiting-lists.html","<div><h2 translate=\"tikonApp.waitingList.home.title\">Waiting Lists</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"waiting-list.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.waitingList.home.createLabel\">Create new Waiting List</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.waitingList.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"qty\"><span translate=\"tikonApp.waitingList.qty\">Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reserveTime\"><span translate=\"tikonApp.waitingList.reserveTime\">Reserve Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.waitingList.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serviceIteId\"><span translate=\"tikonApp.waitingList.serviceIte\">Service Ite</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"waitingList in vm.waitingLists track by waitingList.id\"><td><a ui-sref=\"waiting-list-detail({id:waitingList.id})\">{{waitingList.id}}</a></td><td>{{waitingList.qty}}</td><td>{{waitingList.reserveTime | date:\'medium\'}}</td><td>{{waitingList.description}}</td><td><a ui-sref=\"service-item-detail({id:waitingList.serviceIteId})\">{{waitingList.serviceIteId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"waiting-list-detail({id:waitingList.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"waiting-list.edit({id:waitingList.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"waiting-list.delete({id:waitingList.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/weekly-schedule-info/weekly-schedule-info-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.weeklyScheduleInfo.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.weeklyScheduleInfo.delete.question\" translate-values=\"{id: \'{{vm.weeklyScheduleInfo.id}}\'}\">Are you sure you want to delete this Weekly Schedule Info?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/weekly-schedule-info/weekly-schedule-info-detail.html","<div><h2><span translate=\"tikonApp.weeklyScheduleInfo.detail.title\">Weekly Schedule Info</span> {{vm.weeklyScheduleInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.weeklyScheduleInfo.datePeriod\">Date Period</span></dt><dd><span ng-repeat=\"datePeriod in vm.weeklyScheduleInfo.datePeriods\"><a ui-sref=\"date-period-detail({id: {{datePeriod.id}}})\">{{datePeriod.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.weeklyScheduleInfo.dailyDuration\">Daily Duration</span></dt><dd><span ng-repeat=\"dailyDuration in vm.weeklyScheduleInfo.dailyDurations\"><a ui-sref=\"time-period-detail({id: {{dailyDuration.id}}})\">{{dailyDuration.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate=\"tikonApp.weeklyScheduleInfo.weekdays\">Weekdays</span></dt><dd><span ng-repeat=\"weekdays in vm.weeklyScheduleInfo.weekdays\"><a ui-sref=\"weekly-work-day-detail({id: {{weekdays.id}}})\">{{weekdays.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/weekly-schedule-info/weekly-schedule-info-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myWeeklyScheduleInfoLabel\" translate=\"tikonApp.weeklyScheduleInfo.home.createOrEditLabel\">Create or edit a Weekly Schedule Info</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.weeklyScheduleInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.weeklyScheduleInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"tikonApp.weeklyScheduleInfo.datePeriod\" for=\"field_datePeriod\">Date Period</label><select class=\"form-control\" id=\"field_datePeriod\" multiple=\"multiple\" name=\"datePeriod\" ng-model=\"vm.weeklyScheduleInfo.datePeriods\" ng-options=\"datePeriod as datePeriod.id for datePeriod in vm.dateperiods track by datePeriod.id\"></select></div><div class=\"form-group\"><label translate=\"tikonApp.weeklyScheduleInfo.dailyDuration\" for=\"field_dailyDuration\">Daily Duration</label><select class=\"form-control\" id=\"field_dailyDuration\" multiple=\"multiple\" name=\"dailyDuration\" ng-model=\"vm.weeklyScheduleInfo.dailyDurations\" ng-options=\"timePeriod as timePeriod.id for timePeriod in vm.timeperiods track by timePeriod.id\"></select></div><div class=\"form-group\"><label translate=\"tikonApp.weeklyScheduleInfo.weekdays\" for=\"field_weekdays\">Weekdays</label><select class=\"form-control\" id=\"field_weekdays\" multiple=\"multiple\" name=\"weekdays\" ng-model=\"vm.weeklyScheduleInfo.weekdays\" ng-options=\"weeklyWorkDay as weeklyWorkDay.id for weeklyWorkDay in vm.weeklyworkdays track by weeklyWorkDay.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/weekly-schedule-info/weekly-schedule-infos.html","<div><h2 translate=\"tikonApp.weeklyScheduleInfo.home.title\">Weekly Schedule Infos</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"weekly-schedule-info.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.weeklyScheduleInfo.home.createLabel\">Create new Weekly Schedule Info</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.weeklyScheduleInfo.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"weeklyScheduleInfo in vm.weeklyScheduleInfos track by weeklyScheduleInfo.id\"><td><a ui-sref=\"weekly-schedule-info-detail({id:weeklyScheduleInfo.id})\">{{weeklyScheduleInfo.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"weekly-schedule-info-detail({id:weeklyScheduleInfo.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"weekly-schedule-info.edit({id:weeklyScheduleInfo.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"weekly-schedule-info.delete({id:weeklyScheduleInfo.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/weekly-work-day/weekly-work-day-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.weeklyWorkDay.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"tikonApp.weeklyWorkDay.delete.question\" translate-values=\"{id: \'{{vm.weeklyWorkDay.id}}\'}\">Are you sure you want to delete this Weekly Work Day?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/weekly-work-day/weekly-work-day-detail.html","<div><h2><span translate=\"tikonApp.weeklyWorkDay.detail.title\">Weekly Work Day</span> {{vm.weeklyWorkDay.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"tikonApp.weeklyWorkDay.weekday\">Weekday</span></dt><dd><span translate=\"{{\'tikonApp.WeekDay.\' + vm.weeklyWorkDay.weekday}}\">{{vm.weeklyWorkDay.weekday}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/weekly-work-day/weekly-work-day-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myWeeklyWorkDayLabel\" translate=\"tikonApp.weeklyWorkDay.home.createOrEditLabel\">Create or edit a Weekly Work Day</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.weeklyWorkDay.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.weeklyWorkDay.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.weeklyWorkDay.weekday\" for=\"field_weekday\">Weekday</label><select class=\"form-control\" name=\"weekday\" ng-model=\"vm.weeklyWorkDay.weekday\" id=\"field_weekday\"><option value=\"SATURDAY\" translate=\"tikonApp.WeekDay.SATURDAY\">SATURDAY</option><option value=\"SUNDAY\" translate=\"tikonApp.WeekDay.SUNDAY\">SUNDAY</option><option value=\"MONDAY\" translate=\"tikonApp.WeekDay.MONDAY\">MONDAY</option><option value=\"TUESDAY\" translate=\"tikonApp.WeekDay.TUESDAY\">TUESDAY</option><option value=\"WEDNESDAY\" translate=\"tikonApp.WeekDay.WEDNESDAY\">WEDNESDAY</option><option value=\"THURSDAY\" translate=\"tikonApp.WeekDay.THURSDAY\">THURSDAY</option><option value=\"FRIDAY\" translate=\"tikonApp.WeekDay.FRIDAY\">FRIDAY</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/weekly-work-day/weekly-work-days.html","<div><h2 translate=\"tikonApp.weeklyWorkDay.home.title\">Weekly Work Days</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"weekly-work-day.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.weeklyWorkDay.home.createLabel\">Create new Weekly Work Day</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'tikonApp.weeklyWorkDay.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"weekday\"><span translate=\"tikonApp.weeklyWorkDay.weekday\">Weekday</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"weeklyWorkDay in vm.weeklyWorkDays track by weeklyWorkDay.id\"><td><a ui-sref=\"weekly-work-day-detail({id:weeklyWorkDay.id})\">{{weeklyWorkDay.id}}</a></td><td translate=\"{{\'tikonApp.WeekDay.\' + weeklyWorkDay.weekday}}\">{{weeklyWorkDay.weekday}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"weekly-work-day-detail({id:weeklyWorkDay.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"weekly-work-day.edit({id:weeklyWorkDay.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"weekly-work-day.delete({id:weeklyWorkDay.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"no-access img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/layouts/more/more.html","<div class=\"pl-container-flex user-profile-mobile-container\"><div class=\"customer-header-container\" style=\"padding-bottom: 10px;\n         align-self: flex-start\"><div class=\"customer-header-info\"><div><eo-avatar-name name=\"vm.currentUser.personInfo.fisrtName\"></eo-avatar-name></div><div><div class=\"customer-list-customer-name\" style=\"display: flex;flex-wrap: wrap\"><span>{{vm.currentPersonInfo.fisrtName}} {{vm.currentPersonInfo.lastName}} </span><span><a class=\"user-profile-password\" ui-sref=\"supplierPanel-v2.password\">تغییر کلمه عبور</a></span></div><div><a ui-sref=\"supplierPanel-v2.partialFormPersonInfo\">مشاهده پروفایل ></a></div></div></div></div><ul><li ng-click=\"vm.goToCurrentServant()\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_SERVANT_LOGIN\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"37.614\" viewBox=\"0 0 37.615 37.614\"><g data-name=\"Group 1052\"><path data-name=\"Path 2443\" d=\"M18.807 37.614a18.807 18.807 0 1 1 18.808-18.807 18.829 18.829 0 0 1-18.808 18.807m0-35.1A16.289 16.289 0 1 0 35.1 18.807 16.307 16.307 0 0 0 18.807 2.518\" style=\"fill:#101928\"/><path data-name=\"Path 2444\" d=\"M18.862 31.729a12.922 12.922 0 1 1 12.922-12.922 12.936 12.936 0 0 1-12.922 12.922m0-23.344a10.422 10.422 0 1 0 10.422 10.422A10.433 10.433 0 0 0 18.862 8.385\" style=\"fill:#101928\"/><path data-name=\"Path 2445\" d=\"M14.493 25.29a1.25 1.25 0 0 1-.884-2.134l3.948-3.948v-7.9a1.25 1.25 0 0 1 2.5 0v8.414a1.246 1.246 0 0 1-.366.883l-4.314 4.315a1.246 1.246 0 0 1-.884.366\" style=\"fill:#101928\"/></g></svg> </span><span translate=\"supplierPanel.sideMenu.servantTimeSchedule\">servantTimeSchedule</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyServants\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_SERVANT_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\" ng-if=\"!vm.isWorkSpace\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.365\" height=\"37.365\" viewBox=\"0 0 37.365 37.365\"><g data-name=\"Group 948\"><path data-name=\"Path 2335\" d=\"M31.049 129.66a14.448 14.448 0 0 0-7.46-6.28 7.7 7.7 0 1 0-9.59-.14 14.364 14.364 0 0 0-7.62 6.01 13.165 13.165 0 0 0-1.21 2.4 17.611 17.611 0 0 0 1.99 1.87 11.976 11.976 0 0 1 11.33-8.54h.1c.1 0 .2 0 .3.01a11.934 11.934 0 0 1 10.3 6.47 10.962 10.962 0 0 1 .93 2.45 16.892 16.892 0 0 0 2.06-1.81 13.889 13.889 0 0 0-1.13-2.44m-12.16-7.18a5.2 5.2 0 1 1 5.2-5.2 5.211 5.211 0 0 1-5.2 5.2\" transform=\"translate(-.203 -100.313)\" style=\"fill:#161615\"/><path data-name=\"Path 2336\" d=\"M18.886 137.678A18.682 18.682 0 1 1 37.568 119a18.7 18.7 0 0 1-18.682 18.682m0-34.862A16.18 16.18 0 1 0 35.066 119a16.2 16.2 0 0 0-16.18-16.18\" transform=\"translate(-.203 -100.313)\" style=\"fill:#161615\"/></g></svg> </span><span class=\"more-li-icon-box\" ng-if=\"vm.isWorkSpace\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.624\" height=\"37.623\" viewBox=\"0 0 37.624 37.623\"><defs><style>.cls-1 {\n                              fill: #161615;\n                          }</style></defs><g id=\"Group_957\" data-name=\"Group 957\" transform=\"translate(-1949.091 -699.681)\"><path id=\"Path_2337\" data-name=\"Path 2337\" class=\"cls-1\" d=\"M32.206,663.3H5.6A5.515,5.515,0,0,1,.091,657.8V631.189A5.515,5.515,0,0,1,5.6,625.681H32.206a5.515,5.515,0,0,1,5.509,5.508V657.8a5.515,5.515,0,0,1-5.509,5.508M5.6,628.2a2.994,2.994,0,0,0-2.99,2.99V657.8a2.994,2.994,0,0,0,2.99,2.99H32.206a2.993,2.993,0,0,0,2.989-2.99V631.189a2.993,2.993,0,0,0-2.989-2.99Z\" transform=\"translate(1949 74)\"/><path id=\"Path_2338\" data-name=\"Path 2338\" class=\"cls-1\" d=\"M16.559,657.519H6.609a1.26,1.26,0,0,1-1.26-1.259v-9.95a1.26,1.26,0,0,1,1.26-1.259h9.95a1.26,1.26,0,0,1,1.26,1.259v9.95a1.26,1.26,0,0,1-1.26,1.259M7.869,655H15.3V647.57H7.869Z\" transform=\"translate(1949 74)\"/><path id=\"Path_2339\" data-name=\"Path 2339\" class=\"cls-1\" d=\"M17.014,643.283a6.69,6.69,0,1,1,6.69-6.69,6.7,6.7,0,0,1-6.69,6.69m0-10.861a4.172,4.172,0,1,0,4.17,4.171,4.175,4.175,0,0,0-4.17-4.171\" transform=\"translate(1949 74)\"/><path id=\"Path_2340\" data-name=\"Path 2340\" class=\"cls-1\" d=\"M33.319,652.544H20.373a1.259,1.259,0,0,1-1.09-1.888l6.472-11.211a1.259,1.259,0,0,1,2.181,0l6.473,11.211a1.259,1.259,0,0,1-1.09,1.888m-10.764-2.518h8.582l-4.291-7.432Z\" transform=\"translate(1949 74)\"/></g></svg> </span><span>{{vm.servantTranslateFile | translate}}</span> <span style=\"font-size: 12px;padding-right: 5px\">({{vm.activityTypeInfo.servantListTitle}})</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.reserveServices\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_CATEGORY_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.705\" height=\"37.682\" viewBox=\"0 0 37.705 37.682\"><g data-name=\"Group 949\"><path data-name=\"Path 2294\" d=\"M32.167 201.7h-26.5A5.629 5.629 0 0 1 .12 196v-19.084a5.629 5.629 0 0 1 5.547-5.7h26.5a5.63 5.63 0 0 1 5.548 5.7V196a5.63 5.63 0 0 1-5.548 5.7m-26.5-27.758a2.943 2.943 0 0 0-2.9 2.977V196a2.942 2.942 0 0 0 2.9 2.977h26.5a2.942 2.942 0 0 0 2.9-2.977v-19.084a2.943 2.943 0 0 0-2.9-2.977z\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2295\" d=\"M26.463 173.939H11.371a1.342 1.342 0 0 1-1.324-1.359v-4.125a4.389 4.389 0 0 1 4.325-4.44h9.09a4.389 4.389 0 0 1 4.325 4.44v4.125a1.342 1.342 0 0 1-1.324 1.359m-13.768-2.718h12.444v-2.766a1.7 1.7 0 0 0-1.677-1.722h-9.09a1.7 1.7 0 0 0-1.677 1.722z\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2296\" d=\"M36.281 185.142H1.334a1.359 1.359 0 0 1 0-2.718h34.947a1.359 1.359 0 0 1 0 2.718\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2297\" d=\"M11.372 188.9a1.342 1.342 0 0 1-1.324-1.359v-7.52a1.324 1.324 0 1 1 2.648 0v7.52a1.342 1.342 0 0 1-1.324 1.359\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/><path data-name=\"Path 2298\" d=\"M26.463 188.9a1.342 1.342 0 0 1-1.324-1.359v-7.52a1.324 1.324 0 1 1 2.648 0v7.52a1.342 1.342 0 0 1-1.324 1.359\" transform=\"translate(-.01 -164.015)\" style=\"fill:#161615\"/></g></svg> </span><span>خدمات</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.eventItemList\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_EVENT_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.715\" height=\"37.595\" viewBox=\"0 0 37.715 37.595\"><g data-name=\"Group 950\"><path data-name=\"Path 2299\" d=\"M31.348 255.366H6.379A6.374 6.374 0 0 1 .012 249v-22.2a6.375 6.375 0 0 1 6.367-6.368h24.969a6.375 6.375 0 0 1 6.367 6.368V249a6.374 6.374 0 0 1-6.367 6.367m-24.969-32.4a3.835 3.835 0 0 0-3.83 3.83V249a3.835 3.835 0 0 0 3.83 3.83h24.969a3.835 3.835 0 0 0 3.829-3.83v-22.2a3.834 3.834 0 0 0-3.829-3.83z\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2300\" d=\"M36.446 232.128H1.263a1.263 1.263 0 0 1 0-2.526h35.183a1.263 1.263 0 0 1 0 2.526\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2301\" d=\"M12.991 225.769a1.263 1.263 0 0 1-1.264-1.263v-5.472a1.263 1.263 0 1 1 2.526 0v5.472a1.262 1.262 0 0 1-1.262 1.263\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2302\" d=\"M24.719 225.769a1.263 1.263 0 0 1-1.263-1.263v-5.472a1.263 1.263 0 1 1 2.526 0v5.472a1.263 1.263 0 0 1-1.263 1.263\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/><path data-name=\"Path 2303\" d=\"M17.089 248.138a1.258 1.258 0 0 1-.893-.37l-4.882-4.882A1.263 1.263 0 0 1 13.1 241.1l3.989 3.989 9.293-9.293a1.263 1.263 0 0 1 1.786 1.786l-10.186 10.186a1.258 1.258 0 0 1-.893.37\" transform=\"translate(0 -217.771)\" style=\"fill:#161615\"/></g></svg> </span><span>رویدادها</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.invoiceInfoList\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_COMPANY_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.623\" height=\"37.431\" viewBox=\"0 0 37.623 37.431\"><g data-name=\"Group 1042\"><path data-name=\"Path 2409\" d=\"M16.551 30.672a3.891 3.891 0 0 0-2.741-1.092 3.907 3.907 0 0 0-2.634 6.72 3.859 3.859 0 0 0 2.678 1.13h.061a4.018 4.018 0 0 0 2.793-1.238 3.829 3.829 0 0 0 1.106-2.734 3.994 3.994 0 0 0-1.263-2.788m-4.025 2.762a1.351 1.351 0 0 1 1.356-1.323h.039a1.415 1.415 0 0 1 1.366 1.4 1.346 1.346 0 0 1-.392.973 1.45 1.45 0 0 1-1.043.4 1.33 1.33 0 0 1-.969-.392 1.418 1.418 0 0 1-.357-1.056\" transform=\"translate(.001 -.001)\" style=\"fill:#101928\"/><path data-name=\"Path 2410\" d=\"M32.552 30.711a3.9 3.9 0 1 0-2.719 6.72h.031a3.838 3.838 0 0 0 2.714-1.131 3.905 3.905 0 0 0 1.171-2.791 3.969 3.969 0 0 0-1.2-2.8m-2.7 1.4a1.419 1.419 0 0 1 .995.433 1.384 1.384 0 0 1 .417.989 1.407 1.407 0 0 1-1.4 1.355 1.392 1.392 0 0 1-1.417-1.4 1.431 1.431 0 0 1 1.389-1.377z\" transform=\"translate(.001 -.001)\" style=\"fill:#101928\"/><path data-name=\"Path 2411\" d=\"M36.756 6.533a4.336 4.336 0 0 0-3.419-1.265q-8.207-.01-16.417 0H9.5L9.421 4.8a38.225 38.225 0 0 0-.28-1.623A3.478 3.478 0 0 0 6.19.1C5.329.015 2.233 0 1.216 0a1.221 1.221 0 0 0 0 2.441c.7 0 3.136.006 3.835.013 1.07.01 1.488.375 1.649 1.446l1.6 10.236c.663 4.231.556 5.534 1.19 9.769.415 2.762 1.869 4.049 4.578 4.051h17.514a1.243 1.243 0 1 0 0-2.486h-4.651q-6.511-.006-13.023.011h-.018c-.946 0-1.469-.315-1.693-1.02-.045-.14-.243-1.482-.5-3.334h20.517a4.051 4.051 0 0 0 4.321-3.8c.3-2.039-.083.262.231-1.776l.549-3.584c.061-.4.109-.8.158-1.2l.085-.682a4.324 4.324 0 0 0-.8-3.549M35.1 9.4c-.32 2.335-.977 7.218-1.055 7.7v.026a1.833 1.833 0 0 1-1.828 1.5H11.343c-.592-4.266-1.292-9.435-1.414-10.219a5.177 5.177 0 0 1-.046-.6H32.995a4.4 4.4 0 0 1 1.032.094c.911.225 1.192.617 1.071 1.494\" transform=\"translate(.001 -.001)\" style=\"fill:#101928\"/></g></svg> </span><span translate=\"supplierPanel.sideMenu.invoiceInfo\">invoiceInfo</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.reportExport\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_REPORT_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"33.615\" viewBox=\"0 0 37.614 33.615\"><g data-name=\"Group 953\"><path data-name=\"Path 2317\" d=\"M30.876 397.486H7.021a6.888 6.888 0 0 0-6.88 6.88v19.855a6.887 6.887 0 0 0 6.88 6.88h23.855a6.887 6.887 0 0 0 6.879-6.88v-19.855a6.888 6.888 0 0 0-6.879-6.88m4.352 26.735a4.357 4.357 0 0 1-4.352 4.352H7.021a4.357 4.357 0 0 1-4.353-4.352v-19.855a4.357 4.357 0 0 1 4.353-4.352h23.855a4.357 4.357 0 0 1 4.352 4.352z\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2318\" d=\"M7.7 417.934v3.559a1.264 1.264 0 1 0 2.527 0v-3.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2319\" d=\"M14.356 411.934v9.559a1.263 1.263 0 1 0 2.527 0v-9.559a1.263 1.263 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2320\" d=\"M21.012 413.934v7.559a1.264 1.264 0 1 0 2.527 0v-7.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/><path data-name=\"Path 2321\" d=\"M27.668 407.934v13.559a1.264 1.264 0 1 0 2.527 0v-13.559a1.264 1.264 0 1 0-2.527 0\" transform=\"translate(-.141 -397.486)\" style=\"fill:#161615\"/></g></svg> </span><span>گزارش ها</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.companyPaymentLogList\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.615\" viewBox=\"0 0 37.614 37.615\"><g data-name=\"Group 954\"><path data-name=\"Path 2322\" d=\"M18.908 490.979a18.807 18.807 0 1 1 18.807-18.808 18.829 18.829 0 0 1-18.807 18.808m0-35.1A16.3 16.3 0 1 0 35.2 472.171a16.314 16.314 0 0 0-16.295-16.295\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2323\" d=\"M18.907 485.562a1.3 1.3 0 0 1-1.3-1.3v-3.176a1.3 1.3 0 0 1 2.6 0v3.176a1.3 1.3 0 0 1-1.3 1.3\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2324\" d=\"M18.907 465.156a1.3 1.3 0 0 1-1.3-1.3v-3.177a1.3 1.3 0 0 1 2.6 0v3.177a1.3 1.3 0 0 1-1.3 1.3\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/><path data-name=\"Path 2325\" d=\"M18.651 481.675c3.738 0 6.348-2.224 6.348-5.407 0-2.3-1.18-3.849-3.713-4.884l-.01-.005-2.408-1.108c-1.51-.614-2.936-1.194-2.936-2.686 0-1.392 1.139-2.293 2.9-2.293a5.9 5.9 0 0 1 3.183.851 1.259 1.259 0 0 0 1.932-1.244 1.143 1.143 0 0 0-.457-.766 7.741 7.741 0 0 0-4.509-1.463c-3.444 0-5.943 2.149-5.943 5.109 0 2.16 1.26 3.823 3.646 4.808l2.669 1.23c1.578.7 2.714 1.211 2.714 2.861 0 1.464-1.238 2.374-3.233 2.374a6.887 6.887 0 0 1-3.882-1.273 1.4 1.4 0 0 0-.787-.248 1.263 1.263 0 0 0-.995.476l-.07.089a1.314 1.314 0 0 0-.274.99 1.221 1.221 0 0 0 .489.833 8.959 8.959 0 0 0 5.334 1.756\" transform=\"translate(-.101 -453.364)\" style=\"fill:#161615\"/></g></svg> </span><span>تراکنش های آنلاین</span> <span style=\"font-size: 12px;padding-right: 5px\">(درخواست تسویه)</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ui-sref=\"supplierPanel-v2.setting\" ng-if=\"vm.hasSubscription\" has-authority=\"ROLE_COMPANY_MANAGER\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.614\" height=\"37.636\" viewBox=\"0 0 37.614 37.636\"><g data-name=\"Group 955\"><path data-name=\"Path 2291\" d=\"M34.631 522.995H33.61a.613.613 0 0 1-.571-.4c-.118-.31-.243-.61-.373-.9a.613.613 0 0 1 .127-.692l.724-.725a3.083 3.083 0 0 0 0-4.351l-2.617-2.62a3.085 3.085 0 0 0-4.35 0l-.729.725a.606.606 0 0 1-.691.123c-.3-.132-.585-.253-.9-.378a.61.61 0 0 1-.4-.567v-1.018a3.081 3.081 0 0 0-3.078-3.079h-3.7a3.083 3.083 0 0 0-3.079 3.079v1.018a.609.609 0 0 1-.4.573c-.311.121-.611.245-.9.373a.618.618 0 0 1-.694-.127l-.724-.724a3.088 3.088 0 0 0-4.351 0l-2.623 2.628a3.081 3.081 0 0 0 0 4.351l.727.727a.613.613 0 0 1 .123.691c-.135.3-.257.585-.375.9a.617.617 0 0 1-.581.4h-1A3.084 3.084 0 0 0 .1 526.074v3.708a3.082 3.082 0 0 0 3.078 3.08h1.013a.608.608 0 0 1 .572.4q.162.424.373.9a.614.614 0 0 1-.125.693l-.724.725a3.084 3.084 0 0 0 0 4.35l2.622 2.623a3.084 3.084 0 0 0 4.352 0l.724-.724a.614.614 0 0 1 .693-.124c.3.134.583.255.895.381a.607.607 0 0 1 .4.567v1.017a3.084 3.084 0 0 0 3.079 3.08h3.7a3.081 3.081 0 0 0 3.078-3.08v-1.017a.607.607 0 0 1 .4-.573c.312-.121.6-.242.9-.374a.616.616 0 0 1 .692.127l.727.724a3.082 3.082 0 0 0 4.35 0l2.622-2.623a3.084 3.084 0 0 0 0-4.35l-.724-.725a.609.609 0 0 1-.126-.691c.121-.26.236-.534.381-.9a.61.61 0 0 1 .566-.4h1.02a3.083 3.083 0 0 0 3.078-3.08v-3.7a3.081 3.081 0 0 0-3.078-3.079m-3.892 9.391c-.1.257-.206.512-.314.757a3.115 3.115 0 0 0 .617 3.446l.726.727a.619.619 0 0 1 0 .876l-2.624 2.625a.616.616 0 0 1-.874 0l-.726-.724a3.1 3.1 0 0 0-3.446-.615 10.08 10.08 0 0 1-.754.309 3.071 3.071 0 0 0-1.983 2.874v1a.622.622 0 0 1-.622.623h-3.695a.625.625 0 0 1-.624-.623v-1.018a3.063 3.063 0 0 0-1.979-2.873c-.255-.1-.51-.206-.757-.312a3.073 3.073 0 0 0-1.267-.271 3.121 3.121 0 0 0-2.178.888l-.726.725a.64.64 0 0 1-.882 0l-2.621-2.612a.607.607 0 0 1-.18-.438.616.616 0 0 1 .182-.44l.724-.726a3.1 3.1 0 0 0 .615-3.444c-.122-.273-.224-.52-.307-.754a3.077 3.077 0 0 0-2.863-2H3.172a.623.623 0 0 1-.623-.622v-3.7a.623.623 0 0 1 .623-.621h1.019a3.1 3.1 0 0 0 2.87-1.978c.1-.258.206-.514.314-.758a3.11 3.11 0 0 0-.62-3.446l-.726-.726a.623.623 0 0 1 0-.879l2.621-2.622a.625.625 0 0 1 .879 0l.726.729a3.1 3.1 0 0 0 3.445.615c.272-.123.515-.224.747-.311a3.068 3.068 0 0 0 1.98-2.862V512.2a.623.623 0 0 1 .624-.621h3.7a.622.622 0 0 1 .622.621v1.02a3.068 3.068 0 0 0 1.98 2.871c.258.1.512.206.757.309a3.1 3.1 0 0 0 3.444-.612l.728-.725a.624.624 0 0 1 .883 0l2.621 2.619a.623.623 0 0 1 0 .879l-.727.726a3.108 3.108 0 0 0-.617 3.444c.121.264.222.509.312.755a3.065 3.065 0 0 0 2.872 1.983h1.019a.625.625 0 0 1 .621.623v2.863l-.012-.015v.837a.623.623 0 0 1-.621.622h-1.02a3.066 3.066 0 0 0-2.87 1.98\" transform=\"translate(-.101 -509.113)\" style=\"fill:#161615\"/><path data-name=\"Path 2292\" d=\"M27.513 527.543a8.583 8.583 0 0 0-.175-1.417c-.018-.086-.04-.17-.062-.254l-.057-.212a7.716 7.716 0 0 0-.181-.583c-.048-.132-.095-.26-.149-.4a9.715 9.715 0 0 0-.433-.918l-.024-.049a8.407 8.407 0 0 0-.857-1.25l-.092-.108a6.59 6.59 0 0 0-.41-.447l-.126-.12-.1-.094a5.984 5.984 0 0 0-.266-.245l-.029-.024c-.1-.085-.233-.2-.368-.3l-.15-.108a8.628 8.628 0 0 0-5.142-1.711 1.086 1.086 0 0 0-.186.011h-.09a5.665 5.665 0 0 0-.625.038c-.108.011-.22.024-.318.039a9.166 9.166 0 0 0-.932.175 8.63 8.63 0 0 0 .012 16.722h.036a9.021 9.021 0 0 0 1.006.192c.182.023.364.032.548.041h.137a2.068 2.068 0 0 1 .208.014c.072 0 .149.014.219.014.254 0 .539-.017.842-.045a.676.676 0 0 0 .1-.013c.233-.024.466-.062.7-.109a1.825 1.825 0 0 0 .185-.039l.133-.032c.157-.038.314-.076.476-.123.1-.03.195-.063.312-.1l.081-.03c.131-.044.266-.094.4-.15a2.974 2.974 0 0 0 .286-.128l.094-.046c.163-.075.323-.15.481-.233a11.224 11.224 0 0 0 2.435-1.759 3.3 3.3 0 0 0 .55-.669 10.188 10.188 0 0 0 1.43-3.92 8.719 8.719 0 0 0 .093-1.086v-.118a2.107 2.107 0 0 0 0-.337zm-2.447.457-.01.161a1.443 1.443 0 0 1-.011.208c-.013.206-.04.416-.076.639a6.156 6.156 0 0 1-3.1 4.322c-.107.057-.215.11-.329.163l-.071.034a6.477 6.477 0 0 1-1.609.488l-.12.018c-.109.017-.216.03-.322.038-.149.01-.285.019-.429.022h-.185a5.913 5.913 0 0 1-.625-.037l-.106-.011a6.435 6.435 0 0 1-.718-.136 6.173 6.173 0 0 1 0-11.96 6.052 6.052 0 0 1 2.309-.149l.112.016.087.015a5.172 5.172 0 0 1 .564.115l.181.046a6.31 6.31 0 0 1 1.344.563l.206.124c.138.088.273.175.422.291l.036.026a1.58 1.58 0 0 1 .161.121 6.021 6.021 0 0 1 .5.447c.032.03.062.063.108.115l.075.084c.1.109.2.221.3.339a5.68 5.68 0 0 1 .447.652l.132.215a6.12 6.12 0 0 1 .3.648c.016.04.03.079.045.121l.054.149a4.425 4.425 0 0 1 .149.488l.034.127c.011.042.023.082.032.129a5.756 5.756 0 0 1 .109.692 1.388 1.388 0 0 0 .01.214c0 .157.009.315 0 .467\" transform=\"translate(-.101 -509.113)\" style=\"fill:#161615\"/></g></svg> </span><span>تنظیمات</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div><div class=\"more-section-divider\" has-authority=\"ROLE_FINANCIAL_MANAGER\"></div><div class=\"pl-container-flex user-profile-mobile-container more-subscription\" has-authority=\"ROLE_FINANCIAL_MANAGER\"><ul><li ng-if=\"vm.isNativeApp != \'true\'\" ui-sref=\"supplierPanel-v2.companySubscriptionStatusV2\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.623\" height=\"37.431\" viewBox=\"0 0 37.623 37.431\"><g data-name=\"Group 1042\"><path data-name=\"Path 2409\" d=\"M16.551 30.672a3.891 3.891 0 0 0-2.741-1.092 3.907 3.907 0 0 0-2.634 6.72 3.859 3.859 0 0 0 2.678 1.13h.061a4.018 4.018 0 0 0 2.793-1.238 3.829 3.829 0 0 0 1.106-2.734 3.994 3.994 0 0 0-1.263-2.788m-4.025 2.762a1.351 1.351 0 0 1 1.356-1.323h.039a1.415 1.415 0 0 1 1.366 1.4 1.346 1.346 0 0 1-.392.973 1.45 1.45 0 0 1-1.043.4 1.33 1.33 0 0 1-.969-.392 1.418 1.418 0 0 1-.357-1.056\" transform=\"translate(.001 -.001)\" style=\"fill:#161615\"/><path data-name=\"Path 2410\" d=\"M32.552 30.711a3.9 3.9 0 1 0-2.719 6.72h.031a3.838 3.838 0 0 0 2.714-1.131 3.905 3.905 0 0 0 1.171-2.791 3.969 3.969 0 0 0-1.2-2.8m-2.7 1.4a1.419 1.419 0 0 1 .995.433 1.384 1.384 0 0 1 .417.989 1.407 1.407 0 0 1-1.4 1.355 1.392 1.392 0 0 1-1.417-1.4 1.431 1.431 0 0 1 1.389-1.377z\" transform=\"translate(.001 -.001)\" style=\"fill:#161615\"/><path data-name=\"Path 2411\" d=\"M36.756 6.533a4.336 4.336 0 0 0-3.419-1.265q-8.207-.01-16.417 0H9.5L9.421 4.8a38.225 38.225 0 0 0-.28-1.623A3.478 3.478 0 0 0 6.19.1C5.329.015 2.233 0 1.216 0a1.221 1.221 0 0 0 0 2.441c.7 0 3.136.006 3.835.013 1.07.01 1.488.375 1.649 1.446l1.6 10.236c.663 4.231.556 5.534 1.19 9.769.415 2.762 1.869 4.049 4.578 4.051h17.514a1.243 1.243 0 1 0 0-2.486h-4.651q-6.511-.006-13.023.011h-.018c-.946 0-1.469-.315-1.693-1.02-.045-.14-.243-1.482-.5-3.334h20.517a4.051 4.051 0 0 0 4.321-3.8c.3-2.039-.083.262.231-1.776l.549-3.584c.061-.4.109-.8.158-1.2l.085-.682a4.324 4.324 0 0 0-.8-3.549M35.1 9.4c-.32 2.335-.977 7.218-1.055 7.7v.026a1.833 1.833 0 0 1-1.828 1.5H11.343c-.592-4.266-1.292-9.435-1.414-10.219a5.177 5.177 0 0 1-.046-.6H32.995a4.4 4.4 0 0 1 1.032.094c.911.225 1.192.617 1.071 1.494\" transform=\"translate(.001 -.001)\" style=\"fill:#161615\"/></g></svg> </span><span>تمدید اشتراک</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li><li ng-if=\"vm.isNativeApp != \'true\'\" ui-sref=\"supplierPanel-v2.companySmsPackageStatus\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.625\" height=\"37.277\" viewBox=\"0 0 37.625 37.277\"><g data-name=\"Group 1050\"><path data-name=\"Path 2435\" d=\"M32.916 12.391h-2.759v2.533h2.759a2.177 2.177 0 0 1 2.175 2.176v15.468a2.177 2.177 0 0 1-2.175 2.176H9.642a2.177 2.177 0 0 1-2.175-2.176V22.353H4.934v10.215a4.712 4.712 0 0 0 4.708 4.709h23.274a4.712 4.712 0 0 0 4.709-4.709V17.1a4.712 4.712 0 0 0-4.709-4.709\" style=\"fill:#161615\"/><path data-name=\"Path 2436\" d=\"M27.982 0H4.709A4.712 4.712 0 0 0 0 4.709v15.468a4.712 4.712 0 0 0 4.709 4.709h9.85l6.988 6.575a1.281 1.281 0 0 0 .872.348 1.393 1.393 0 0 0 .507-.1 1.266 1.266 0 0 0 .76-1.163v-5.66h4.3a4.712 4.712 0 0 0 4.709-4.709V4.709A4.712 4.712 0 0 0 27.982 0m2.176 20.177a2.178 2.178 0 0 1-2.176 2.176h-5.563a1.261 1.261 0 0 0-1.266 1.267v3.986L15.937 22.7a1.282 1.282 0 0 0-.872-.347H4.709a2.178 2.178 0 0 1-2.176-2.176V4.709a2.186 2.186 0 0 1 2.176-2.186h23.273a2.186 2.186 0 0 1 2.176 2.186z\" style=\"fill:#161615\"/><path data-name=\"Path 2437\" d=\"M23.456 10.613H9.234a1.266 1.266 0 1 1 0-2.532h14.222a1.266 1.266 0 1 1 0 2.532\" style=\"fill:#161615\"/><path data-name=\"Path 2438\" d=\"M23.456 17.331H9.234a1.266 1.266 0 1 1 0-2.532h14.222a1.266 1.266 0 1 1 0 2.532\" style=\"fill:#161615\"/></g></svg> </span><span>بسته های پیامکی</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div><div class=\"more-section-divider\"></div><div class=\"pl-container-flex user-profile-mobile-container more-exit\"><ul><li ng-click=\"vm.logout()\"><div class=\"more-li-content\"><span class=\"more-li-icon-box\"><svg class=\"pl-svg-icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"37.615\" height=\"38.18\" viewBox=\"0 0 37.615 38.18\"><g data-name=\"Group 1045\"><path data-name=\"Path 2423\" d=\"M33.86 14.748H20.05a1.282 1.282 0 1 1 0-2.564h13.81a1.282 1.282 0 0 1 0 2.564\" style=\"fill:#161615\"/><path data-name=\"Path 2424\" d=\"M29.964 21.16a1.282 1.282 0 0 1-.907-2.189l5.462-5.461L29.4 8.391a1.282 1.282 0 1 1 1.813-1.812l6.026 6.021a1.281 1.281 0 0 1 0 1.813l-6.368 6.368a1.281 1.281 0 0 1-.907.375\" style=\"fill:#161615\"/><path data-name=\"Path 2425\" d=\"M22.528 0H1.282a1.175 1.175 0 0 0-.256.029A1.077 1.077 0 0 0 .57.218a1.163 1.163 0 0 0-.295.276A1.3 1.3 0 0 0 .18.636 1.1 1.1 0 0 0 .1.779a1.059 1.059 0 0 0-.076.247A1.116 1.116 0 0 0 0 1.282v26.384a1.119 1.119 0 0 0 .028.257.826.826 0 0 0 .067.218.452.452 0 0 0 .028.067 1.091 1.091 0 0 0 .077.142 1.6 1.6 0 0 0 .2.247.778.778 0 0 0 .171.133 1.218 1.218 0 0 0 .712.218h4.5l-3.22-1.994V2.564h18.683v23.82H14.92v2.564h7.608a1.276 1.276 0 0 0 1.282-1.282V1.282A1.277 1.277 0 0 0 22.528 0\" style=\"fill:#161615\"/><path data-name=\"Path 2426\" d=\"M16.877 9.421 5.794 2.564 1.957.189A1.238 1.238 0 0 0 1.283 0a1.183 1.183 0 0 0-.257.028A1.083 1.083 0 0 0 .7.145C.685.153.671.153.656.161L.57.218a1.172 1.172 0 0 0-.294.275 1.18 1.18 0 0 0-.095.143A.982.982 0 0 0 .1.778a1.074 1.074 0 0 0-.076.247A1.118 1.118 0 0 0 0 1.282v26.384a1.116 1.116 0 0 0 .029.256.843.843 0 0 0 .066.219.476.476 0 0 0 .029.066.991.991 0 0 0 .076.143 1.644 1.644 0 0 0 .2.247.864.864 0 0 0 .171.133c.01.009.029.019.038.028l14.92 9.232a1.292 1.292 0 0 0 1.3.028 1.3 1.3 0 0 0 .655-1.121V10.513a1.283 1.283 0 0 0-.608-1.092M14.921 34.6l-9.137-5.652-3.219-1.994V3.58l12.356 7.646z\" style=\"fill:#161615\"/></g></svg> </span><span>خروج</span></div><span><md-icon style=\"font-size: 30px; width: 30px; height: 30px; color: black\" class=\"material-icons\">chevron_left</md-icon></span></li></ul></div>");
$templateCache.put("app/layouts/navbar/my-website.html","<div id=\"reserveModal\" class=\"modal-header pl-modal-header pl-modal-border pl-modal-header-sm\" style=\"position: sticky\"><div id=\"website-modal-title\" class=\"pl-modal-title\">سایت من</div><div class=\"pl-modal-header-close-icon\" ng-click=\"vm.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid pl-container-flex\" style=\"padding: 20px\"><div class=\"website-link-desc\"><span>لینک سایت شما : </span><a href=\"{{vm.getUrl(vm.companyUrl)}}\" target=\"_blank\">{{vm.companyUrl}}</a></div><div class=\"website-link-desc\" ng-if=\"vm.company.hasDedicatedDomain\"><span>لینک سایت شما در پلنوین : </span><a href=\"{{vm.getUrl(vm.planovinUrl)}}\" target=\"_blank\">{{vm.planovinUrl}}</a></div><div class=\"website-desc-actions\"><div class=\"pl-my-site\" ng-click=\"vm.copyToClipboard()\"><md-icon style=\"color: black\">content_copy</md-icon><div class=\"pl-my-site-text\">کپی کردن</div></div><div class=\"pl-my-site\" style=\"padding-left: 5px\" ng-click=\"vm.gotoWebSite()\"><md-icon style=\"color: black\">visibility</md-icon><div class=\"pl-my-site-text\">مشاهده سایت</div></div></div><div class=\"website-bio-desc\">شما میتوانید لینک وبسایت را کپی کنید و برای مشتریان خود ارسال کنید . یا لینک را در bio اینستاگرام قرار دهید .</div></div></div><div class=\"pl-modal-footer-sm\"><md-button class=\"md-raised md-primary pl-btn-lg pl-btn-primary\" type=\"submit\" style=\"font-size: 18px\" ng-click=\"vm.closeModal()\"><span>بستن</span></md-button></div>");
$templateCache.put("app/layouts/navbar/navbar-section.html","<!--{{vm.appVersion}}--><div ui-view=\"navbar-v2\"></div><!--<div ui-view=\"navbar-v2\"></div>--> <!--<div ui-view=\"navbar\" ng-if=\"vm.appVersion != \'v3\'\" ng-cloak></div>-->");
$templateCache.put("app/layouts/navbar/navbar-v2.html","<!-- Global Site Tag (gtag.js) - Google Analytics --><!--<script async src=\"https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID\"></script>--><!--<script>--><!--window.dataLayer = window.dataLayer || [];--><!--function gtag() {--><!--dataLayer.push(arguments);--><!--}--><!--gtag(\'js\', new Date());--><!--gtag(\'config\', \'UA-173464459-1\');--><!--</script>--><!-- Google tag (gtag.js) --><script ng-if=\"vm.showGtag\" async src=\"https://www.googletagmanager.com/gtag/js?id=G-ED49RQWYNY\"></script><script ng-if=\"vm.showGtag\">window.dataLayer = window.dataLayer || [];\n\n    function gtag() {\n        dataLayer.push(arguments);\n    }\n\n    gtag(\'js\', new Date());\n\n    gtag(\'config\', \'G-ED49RQWYNY\');</script><style>select.form-control {\n        background: none;\n    }\n\n    .form-control:focus {\n        -webkit-box-shadow: none;\n        box-shadow: none;\n    }\n\n    .companyName {\n        margin: 20px 25px;\n        position: absolute;\n        cursor: default;\n    }\n\n    .companyName-v2 {\n        margin: 20px 25px;\n        /*position: absolute;*/\n        cursor: default;\n    }\n\n    .navbar .navbar-nav > li > a:hover {\n        background-color: hsla(0, 0%, 96%, .25);\n    }\n\n    .navbar-nav > li > .dropdown-menu {\n        margin-top: 3px;\n        right: -110px;\n    }\n\n    /*menuIcon*/\n    #menuHamburgerDesktopV2 {\n        cursor: pointer;\n\n        height: 65px;\n        padding: 20px 16px;\n    }\n\n    .bar1, .bar2, .bar3 {\n        width: 28px;\n        height: 3px;\n        /*background-color: #009688;*/\n        margin: 3px 0;\n        transition: 0.5s;\n    }\n\n    #menuHamburgerMobile {\n        display: none;\n    }\n\n    #desktop {\n        display: block;\n    }\n\n    #ellipsisMobile {\n        display: block;\n        padding: 10px 0;\n        position: fixed;\n        left: 0;\n        top: 0;\n        overflow-x: hidden;\n        white-space: nowrap;\n        height: 100vh;\n        width: 0px;\n        transition: 0.5s;\n        z-index: 1031;\n    }\n\n    #ellipsisMobile ul li {\n        padding: 7px 22px;\n    }\n\n    .change {\n        margin-top: -5px;\n    }\n\n    .dropdown-menu > li > a {\n        padding: 2px 15px;\n    }\n\n    .badge-position {\n        top: 3px;\n        position: absolute;\n        padding: 4px 5px;\n        font-size: 9px;\n    }\n\n    .companyDropdownV2 {\n        margin: 11px 50px 11px 10px;\n        position: absolute;\n        cursor: default;\n    }\n\n    .subscriptionExpired {\n        color: #d50a0a;\n    }\n\n    @media (min-width: 768px) {\n        #desktop {\n            height: 65px !important;\n        }\n\n        .navbar .navbar-nav > li > a {\n            padding-top: 20px !important;\n            padding-bottom: 20px !important;\n        }\n    }\n\n    @media (max-width: 767px) {\n        #menuHamburgerMobile {\n            display: inline-block;\n            cursor: pointer;\n            width: 35px;\n            padding: 18px 25px;\n            float: right;\n        }\n\n        .companyDropdownV2 {\n            margin: 9px 60px;\n        }\n\n        /*select.form-control {*/\n        /*background: none;*/\n        /*}*/\n        /*.form-control:focus {*/\n        /*-webkit-box-shadow: none;*/\n        /*box-shadow: none;*/\n        /*}*/\n        #desktop {\n            display: none;\n        }\n\n        .companyName {\n            position: absolute;\n            cursor: default;\n            top: 22px;\n            width: 40%;\n            margin: auto 30%;\n        }\n\n\n        .unread_counter {\n            background-color: #e60909;\n            padding: 3px 5px;\n            border-radius: 25px;\n            position: absolute;\n            top: -8px;\n            right: -8px;\n        }\n\n\n    }</style><div ng-show=\"vm.navBarShowV3()\"><div id=\"navbar-mobile\" ng-if=\"vm.showHeaderNavbar\" class=\"pl-navbar visible-xs\"><div class=\"pl-nav-container\"><div class=\"pl-nav-right\"><span ng-if=\"vm.company && vm.companies.length == 1\" class=\"\">{{vm.company.title}}</span> <span ng-if=\"vm.companies.length > 1\" class=\"\"><select class=\"form-control\" id=\"companySelectMobile\" style=\"margin-bottom: 0\" ng-change=\"vm.changeCCkey(vm.selectedCompany.keyUrl)\" name=\"companySelectMobile\" ng-model=\"vm.selectedCompany\" ng-options=\"company.title for company in vm.companies track by company.id\"></select></span></div><div class=\"pl-nav-left\"><div class=\"pl-my-site\" has-authority=\"ROLE_USER\" ng-click=\"vm.openMyWebsiteBox()\"><md-icon style=\"color: black\">language</md-icon><div class=\"pl-my-site-text\">سایت من</div></div><!--<div class=\"pl-help\" uib-dropdown>--><!--<img class=\"pl-help-icon\" uib-dropdown-toggle src=\"content/images/icon-help-64.png\">--><!--<ul class=\"pl-dropdown-menu\" uib-dropdown-menu>--><!--<li ng-click=\"vm.openChat()\">--><!--<div class=\"pl-help-item\">--><!--<md-icon>chat</md-icon>--><!--<span>پشتیبانی آنلاین</span>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"pl-help-item\">--><!--<md-icon>school</md-icon>--><!--<span>آموزش</span>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"pl-help-item\">--><!--<md-icon>videocam</md-icon>--><!--<span>آموزش تصویری</span>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"pl-help-item\" ng-click=\"vm.callSupport()\">--><!--<md-icon>phone_in_talk</md-icon>--><!--<div>--><!--<span>تماس با پشتبانی</span>--><!--<span>02144898931</span>--><!--</div>--><!--</div>--><!--</li>--><!--&lt;!&ndash;<li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\" uib-dropdown>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<a class=\"my-dropdown-menu\" ui-sref=\"userProfile\" ng-click=\"vm.collapseNavbar()\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<a class=\"my-dropdown-menu\" ui-sref=\"supplierPanel.partialFormPersonInfo\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"vm.collapseNavbar()\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"fa fa-user\"></span>&nbsp;&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"global.menu.account.userProfile\">User Profile</span>&ndash;&gt;--><!--&lt;!&ndash;</a>&ndash;&gt;--><!--&lt;!&ndash;</li>&ndash;&gt;--><!--</ul>--><!--</div>--><div class=\"pl-help\" uib-dropdown><!--<img class=\"pl-help-icon\" uib-dropdown-toggle src=\"content/images/icon-help-64.png\">--><div class=\"pl-help-icon\" uib-dropdown-toggle>?</div><ul class=\"pl-dropdown-menu\" uib-dropdown-menu><li ng-click=\"vm.openChat()\"><div class=\"pl-help-item\"><md-icon>chat</md-icon><span>پشتیبانی آنلاین</span></div></li><li ng-click=\"vm.goToHelp()\"><div class=\"pl-help-item\"><md-icon>school</md-icon><span>آموزش</span></div></li><li ng-click=\"vm.goToEducationLinks()\"><div class=\"pl-help-item\"><md-icon>videocam</md-icon><span>آموزش تصویری</span></div></li><li><div class=\"pl-help-item contact-with-us\" ng-click=\"vm.callSupport()\"><md-icon>phone_in_talk</md-icon><div><span>تماس با پشتیبانی</span> <span>02191690817</span></div></div></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\" uib-dropdown>--><!--&lt;!&ndash;<a class=\"my-dropdown-menu\" ui-sref=\"userProfile\" ng-click=\"vm.collapseNavbar()\">&ndash;&gt;--><!--<a class=\"my-dropdown-menu\" ui-sref=\"supplierPanel.partialFormPersonInfo\"--><!--ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"fa fa-user\"></span>&nbsp;--><!--<span translate=\"global.menu.account.userProfile\">User Profile</span>--><!--</a>--><!--</li>--></ul></div></div></div></div><div ng-if=\"vm.showHeaderNavbar\" class=\"pl-navbar hidden-xs\"><div id=\"navbar-desktop\" class=\"pl-nav-container\"><div class=\"pl-nav-right\"><div style=\"display: flex\"><div id=\"menuHamburgerDesktopV2\" ng-click=\"vm.toggleSideMenu()\"><div ng-if=\"vm.company\"><div class=\"bar1\"></div><div class=\"bar2\"></div><div class=\"bar3\"></div></div></div><div ng-if=\"vm.company && vm.companies.length == 1\" class=\"companyName-v2\">{{vm.company.title}}</div><div ng-if=\"vm.companies.length > 1\" class=\"companyDropdownV2\"><select class=\"form-control\" id=\"companySelectV2\" ng-change=\"vm.changeCCkey(vm.selectedCompany.keyUrl)\" name=\"companySelect\" ng-model=\"vm.selectedCompany\" required eo-required=\"\" ng-options=\"company.title for company in vm.companies track by company.id\"></select></div><!--<ul>--><!--<li has-authority=\"ROLE_ADMIN\">--><!--<a ui-sref=\"supplierPanel.testServices\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-cog\"></span>--><!--<span class=\"hidden-sm\">Test Services</span>--><!--</a>--><!--</li>--><!--<li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\"--><!--has-authority=\"ROLE_ADMIN\"--><!--uib-dropdown class=\"dropdown pointer\">--><!--<a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\">--><!--<span>--><!--<span class=\"glyphicon glyphicon-th-list\"></span>--><!--<span class=\"hidden-sm\" translate=\"global.menu.entities.main\">--><!--Entities--><!--</span>--><!--<b class=\"caret\"></b>--><!--</span>--><!--</a>--><!--<ul class=\"dropdown-menu\" uib-dropdown-menu--><!--style=\"overflow: scroll; max-height: 600px; width: 250px;\">--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"company\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.company\">Company</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.serviceItem\">Service Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"marketplace\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.marketplace\">Marketplace</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"news\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.news\">News</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"supplier-coupon\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.supplierCoupon\">SupplierCoupon</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"company-subscription-status\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.companySubscriptionStatus\">CompanySubscriptionStatus-package</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"companyRule\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.companyRule\">CompanyRule</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"meta-tag\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.metaTag\">Meta Tag</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"subscription-package\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.subscriptionPackage\">subscription-package</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"company-social-network-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.companySocialNetworkInfo\">Company Social Network Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"social-network-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.socialNetworkInfo\">Social Network Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"company-manager\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.companyManager\">Company Manager</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"selector-data\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.selectorData\">Selector Data</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"selector-data-type\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.selectorDataType\">Selector Data Type</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-category\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.serviceCategory\">Service Category</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"customer\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.customer\">Customer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.orderBag\">Order Bag</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag-service-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.orderBagServiceItem\">Order Bag Service Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag-service-item-dtail\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.orderBagServiceItemDtail\">Order Bag Service Item Dtail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"invoice-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.invoiceInfo\">Invoice Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag-item-option\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.orderBagItemOption\">Order Bag Item Option</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"payment-log\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.paymentLog\">Payment Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"location-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.locationInfo\">Location Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"person-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.personInfo\">Person Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"price-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.priceInfo\">Price Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"price-info-dtail\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.priceInfoDtail\">Price Info Dtail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"discount-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.discountInfo\">Discount Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"schedule-base-discount\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.scheduleBaseDiscount\">Schedule Base Discount</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-option-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.serviceOptionInfo\">Service Option Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-option-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.serviceOptionItem\">Service Option Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"servant\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.servant\">Servant</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"album-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.albumInfo\">Album Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"image-data\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.imageData\">Image Data</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"related-service-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.relatedServiceItem\">Related Service Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-capacity-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.serviceCapacityInfo\">Service Capacity Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"capacity-exception\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.capacityException\">Capacity Exception</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"date-period\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.datePeriod\">Date Period</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"off-day\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.offDay\">Off Day</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"off-time\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.offTime\">Off Time</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"weekly-work-day\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.weeklyWorkDay\">Weekly Work Day</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"time-period\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.timePeriod\">Time Period</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"weekly-schedule-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.weeklyScheduleInfo\">Weekly Schedule Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"schedule-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.scheduleInfo\">Schedule Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"setting-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.settingInfo\">Setting Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"theme-setting-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.themeSettingInfo\">Theme Setting Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"financial-setting\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.financialSetting\">Financial Setting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"notification-setting\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.notificationSetting\">Notification Setting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"extra-setting\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.extraSetting\">Extra Setting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"participant-person\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.participantPerson\">Participant Person</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"canceling-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.cancelingInfo\">Canceling Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"waiting-list\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.waitingList\">Waiting List</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"agreement-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.agreementInfo\">Agreement Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"customer-comment\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.customerComment\">Customer Comment</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"customer-rank\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.customerRank\">Customer Rank</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here &ndash;&gt;--><!--</ul>--><!--</li>--><!--<li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\"--><!--has-authority=\"ROLE_ADMIN\"--><!--uib-dropdown class=\"dropdown pointer\">--><!--<a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\">--><!--<span>--><!--<span class=\"glyphicon glyphicon-tower\"></span>--><!--<span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span>--><!--<b class=\"caret\"></b>--><!--</span>--><!--</a>--><!--<ul class=\"dropdown-menu\" uib-dropdown-menu>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-user\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.userManagement\">User management</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"jhi-tracker\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.tracker\">User tracker</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.metrics\">Metrics</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-heart\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.health\">Health</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.configuration\">Configuration</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-bell\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.audits\">Audits</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-tasks\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.logs\">Logs</span>--><!--</a>--><!--</li>--><!--<li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\">--><!--<a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-book\"></span>&nbsp;--><!--<span translate=\"global.menu.admin.apidocs\">API</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here &ndash;&gt;--><!--</ul>--><!--</li>--><!--<li ui-sref-active=\"active\" ng-switch-when=\"false\">--><!--<a href=\"\" ng-click=\"vm.login()\" id=\"login\">--><!--<span class=\"glyphicon glyphicon-log-in\"></span>&nbsp;--><!--<span translate=\"global.menu.account.login\">Sign in</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\" ng-switch-when=\"false\">--><!--<a ui-sref=\"createUserAccount\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp;--><!--<span translate=\"global.menu.account.register\">Register</span>--><!--</a>--><!--</li>--><!--</ul>--></div></div><div class=\"pl-nav-left\"><div class=\"downgrade-version\" ng-if=\"vm.canDowngradeVersion()\" ng-click=\"vm.downgradeVersion()\">بازگشت به نسخه قدیم !</div><div class=\"pl-help\" id=\"pl-help\" uib-dropdown><!--<img class=\"pl-help-icon\" uib-dropdown-toggle src=\"content/images/icon-help-64.png\">--><div class=\"pl-help-icon\" uib-dropdown-toggle>?</div><ul class=\"pl-dropdown-menu\" uib-dropdown-menu><li ng-click=\"vm.openChat()\"><div class=\"pl-help-item\"><md-icon>chat</md-icon><span>پشتیبانی آنلاین</span></div></li><li ng-click=\"vm.goToHelp()\"><div class=\"pl-help-item\"><md-icon>school</md-icon><span>آموزش</span></div></li><li ng-click=\"vm.goToEducationLinks()\"><div class=\"pl-help-item\"><md-icon>videocam</md-icon><span>آموزش تصویری</span></div></li><li><div class=\"pl-help-item contact-with-us\" ng-click=\"vm.callSupport()\"><md-icon>phone_in_talk</md-icon><div><span>تماس با پشتیبانی</span> <span>02191690817</span></div></div></li><li ng-click=\"vm.showWizard()\"><div class=\"pl-help-item getting-know\"><md-icon>play_circle_outline</md-icon><span>آشنایی با پنل کاربری</span></div></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\" uib-dropdown>--><!--&lt;!&ndash;<a class=\"my-dropdown-menu\" ui-sref=\"userProfile\" ng-click=\"vm.collapseNavbar()\">&ndash;&gt;--><!--<a class=\"my-dropdown-menu\" ui-sref=\"supplierPanel.partialFormPersonInfo\"--><!--ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"fa fa-user\"></span>&nbsp;--><!--<span translate=\"global.menu.account.userProfile\">User Profile</span>--><!--</a>--><!--</li>--></ul></div><div class=\"pl-my-site\" id=\"pl-my-site\" has-authority=\"ROLE_USER\" ng-click=\"vm.openMyWebsiteBox()\"><md-icon style=\"color: black\">language</md-icon><div class=\"pl-my-site-text\">سایت من</div></div><div class=\"\" uib-dropdown ng-if=\"vm.isAuthenticated()\"><div class=\"pl-profile\" id=\"pl-profile\" uib-dropdown-toggle><img class=\"pl-user-icon\" src=\"content/images/person-64.png\"><div class=\"user-profile-name\"><div>{{vm.userProfile.personInfo.fisrtName}} {{vm.userProfile.personInfo.lastName}}</div><div ng-if=\"vm.isNativeApp != \'true\'\" style=\"font-size: 9px\" ng-class=\"vm.subscriptionTitleStyle()\">{{vm.subscriptionStatusTitle}}</div></div><md-icon>expand_more</md-icon></div><ul class=\"pl-dropdown-menu\" uib-dropdown-menu><li has-authority=\"ROLE_SUPPLIER\"><div class=\"pl-menu-item\" ui-sref=\"supplierPanel-v2.partialFormPersonInfo\"><span class=\"fa fa-user\"></span>&nbsp; <span translate=\"global.menu.account.userProfile\">User Profile</span></div></li><li has-authority=\"ROLE_SUPPLIER\"><div class=\"pl-menu-item\" ui-sref=\"supplierPanel-v2.password\"><span class=\"fa fa-key\"></span> <span translate=\"global.menu.account.password\">Password</span></div></li><li ng-if=\"vm.isNativeApp != \'true\'\" has-not-authority=\"ROLE_SERVANT_LOGIN\" has-any-authority=\"ROLE_SUPPLIER\"><div class=\"pl-menu-item\" ui-sref=\"supplierPanel-v2.companySubscriptionStatusV2\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></div></li><li ng-if=\"vm.isNativeApp != \'true\'\" has-not-authority=\"ROLE_SERVANT_LOGIN\" has-any-authority=\"ROLE_SUPPLIER\"><div class=\"pl-menu-item\" ui-sref=\"supplierPanel-v2.companySmsPackageStatus\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.sms_package_status\">SMS Package</span></div></li><li><div class=\"pl-menu-item\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"fa fa-sign-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></div></li></ul></div></div></div></div></div><div ng-show=\"!vm.navBarShowV3()\"><div><div class=\"visible-xs\"><div class=\"upgrade-version-mobile\" ng-click=\"vm.upgradeVersion()\" has-authority=\"ROLE_SUPPLIER\"><span>بروز رسانی به نسخه جدید !</span></div></div><nav class=\"navbar navbar-fixed-top\" role=\"navigation\"><div class=\"container-fluid\"><div class=\"navbar-header text-center\"><div id=\"menuHamburgerMobile\"><div ng-if=\"vm.company\"><div class=\"bar1\"></div><div class=\"bar2\"></div><div class=\"bar3\"></div></div></div><span class=\"visible-xs companyName\" ng-if=\"vm.company && vm.companies.length == 1\">{{vm.company.title}}</span> <span ng-if=\"vm.companies.length > 1\" class=\"visible-xs companyDropdown\"><select class=\"form-control\" id=\"companySelect\" ng-change=\"vm.changeCCkey(vm.selectedCompany.keyUrl)\" name=\"companySelect\" ng-model=\"vm.selectedCompany\" required eo-required=\"\" ng-options=\"company.title for company in vm.companies track by company.id\"></select></span><button id=\"ellipsis\" type=\"button\" class=\"navbar-toggle\" style=\"margin-top: 12px; margin-bottom: 0\"><i style=\"font-size: 1.5em\" class=\"fa fa-ellipsis-v\" aria-hidden=\"true\" ng-if=\"vm.company\"></i></button><!--<a class=\"navbar-brand logo\" href=\"#/\" ng-click=\"vm.collapseNavbar()\">--><!--<img class=\"logo-img\" src=\"content/images/logo-4.png\"/>--><!--</a>--></div><div id=\"desktop\" class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-left\"><div has-not-authority=\"ROLE_SUPER_ADMIN_BASIC_ACCESS\"><li class=\"upgrade-version\" ng-click=\"vm.upgradeVersion()\" has-authority=\"ROLE_SUPPLIER\"><span>بروز رسانی به نسخه جدید !</span></li></div><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a id=\"onlineSupportBtn\" data-target=\"#\" data-toggle=\"tooltip\" ng-click=\"vm.supportButtonClick()\"><span class=\"fa fa-volume-control-phone fa-fw\"></span> <span class=\"badge badge-position\" style=\"left: 22px;\n                                         background-color:#2b6b7f\"><span id=\"unread_counter\" class=\"unread_counter\">0</span> {{\'supplierPanel.sideMenu.onlineSupport.title\' | translate}}</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a href=\"\" ng-click=\"vm.gotoReserwebHelp()\"><span class=\"fa fa-life-ring\"></span> <span class=\"badge badge-position\" style=\"left: 18px;\n                                         background-color: darkorange\">راهنما</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\"><a href=\"\" ng-click=\"vm.openInbox()\"><span ng-if=\"!vm.isInboxOpened\" class=\"fa fa-envelope\"></span> <span id=\"inboxBadge\" style=\"left: 23px;top: 11px;position: absolute; padding: 5px 6px\" class=\"badge badge-success\">5</span> <span ng-if=\"vm.isInboxOpened\" class=\"fa fa-envelope-open\"></span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a has-not-authority=\"ROLE_FREEMIUM_USER\" href=\"\" ng-click=\"vm.gotoWebSite()\"><span class=\"glyphicon glyphicon-globe\"></span> <span class=\"badge badge-position\" style=\"left: 18px;\n                                         background-color: deepskyblue\">سایت من</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\" has-authority=\"ROLE_USER\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"userProfile-menu\"><span class=\"glyphicon glyphicon-user\"></span> <span><span id=\"user_name\"><!--{{vm.userProfile.personInfo.fisrtName}} {{vm.userProfile.personInfo.lastName}}--> </span><span data-ng-if=\"vm.userProfile.personInfo.fisrtName\"><!--<script>--><!--window.smartlook || (function (d) {--><!--var o = smartlook = function () {--><!--o.api.push(arguments)--><!--}, h = d.getElementsByTagName(\'head\')[0];--><!--var c = d.createElement(\'script\');--><!--o.api = new Array();--><!--c.async = true;--><!--c.type = \'text/javascript\';--><!--c.charset = \'utf-8\';--><!--c.src = \'https://rec.smartlook.com/recorder.js\';--><!--h.appendChild(c);--><!--})(document);--><!--smartlook(\'init\', \'19b2dabb8703bf2555c0dc5fb5408d1ab86e2637\');--><!--smartlook(\'tag\', \'name\', document.getElementById(\'user_name\').innerHTML);--><!--</script>--> </span></span><b class=\"caret\"></b></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><!--<a class=\"my-dropdown-menu\" ui-sref=\"userProfile\" ng-click=\"vm.collapseNavbar()\">--> <a class=\"my-dropdown-menu\" ui-sref=\"supplierPanel.partialFormPersonInfo\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-user\"></span>&nbsp; <span translate=\"global.menu.account.userProfile\">User Profile</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.password\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-key\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\">--><!--<a ui-sref=\"supplierPanel.companySubscriptionStatus\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"fa fa-shopping-cart\"></span>--><!--<span translate=\"global.menu.account.subscription\">Subscription</span>--><!--</a>--><!--</li>--><li ng-if=\"vm.__config.appMode == \'reserve\' && vm.isNativeApp != \'true\'\" ui-sref-active=\"active\" ng-switch-when=\"true\" has-not-authority=\"ROLE_SERVANT_LOGIN\" has-any-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySubscriptionStatusV2\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></a></li><li ng-if=\"vm.__config.appMode == \'event\' && vm.isNativeApp != \'true\'\" ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySubscriptionStatusEvent\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-not-authority=\"ROLE_SERVANT_LOGIN\" has-any-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySmsPackageStatus\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.sms_package_status\">SMS Package</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"fa fa-sign-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right\"><li id=\"menuHamburgerDesktop\"><div ng-if=\"vm.company\"><div class=\"bar1\"></div><div class=\"bar2\"></div><div class=\"bar3\"></div></div></li><span ng-if=\"vm.company && vm.companies.length == 1\" class=\"companyName\">{{vm.company.title}}</span> <span ng-if=\"vm.companies.length > 1\" class=\"companyDropdown\"><select class=\"form-control\" id=\"companySelect\" ng-change=\"vm.changeCCkey(vm.selectedCompany.keyUrl)\" name=\"companySelect\" ng-model=\"vm.selectedCompany\" required eo-required=\"\" ng-options=\"company.title for company in vm.companies track by company.id\"></select></span><!--<md-input-container>--><!--<label>State</label>--><!--<md-select ng-model=\"ctrl.userState\">--><!--<md-option><em>None</em></md-option>--><!--<md-option ng-repeat=\"state in ctrl.states\" ng-value=\"state.abbrev\" ng-disabled=\"$index === 1\">--><!--{{state.abbrev}}--><!--</md-option>--><!--</md-select>--><!--</md-input-container>--><li has-authority=\"ROLE_ADMIN\"><a ui-sref=\"supplierPanel.testServices\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-cog\"></span> <span class=\"hidden-sm\">Test Services</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu style=\"overflow: scroll; max-height: 600px; width: 250px\"><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_BASIC_ACCESS\"><a ui-sref=\"company\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.company\">Company</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_BASIC_ACCESS\"><a ui-sref=\"smsPatterns\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span>الگو‌های پیامکی</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_BASIC_ACCESS\"><a ui-sref=\"package-feature-list\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span>امکانات ویژه</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\"><a ui-sref=\"supplier-coupon\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.supplierCoupon\">SupplierCoupon</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\"><a ui-sref=\"company-subscription-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companySubscriptionStatus\">CompanySubscriptionStatus-package</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_BASIC_ACCESS\"><a ui-sref=\"company-manager\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companyManager\">Company Manager</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"company-invoice-info\" ng-click=\"vm.collapseNavbar()\" has-authority=\"ROLE_SUPER_ADMIN_FULL_ACCESS\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companyInvoiceInfo\">companyInvoiceInfo</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\"><a ui-sref=\"service-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.serviceItem\">Service Item</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\"><a ui-sref=\"news\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.news\">News</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_FULL_ACCESS\"><a ui-sref=\"marketplace\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.marketplace\">Marketplace</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_FULL_ACCESS\"><a ui-sref=\"activity-type-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span>ActivityTypeInfo</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_FULL_ACCESS\"><a ui-sref=\"admin-test-services\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span>Admin Test Services</span></a></li><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"companyRule\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.companyRule\">CompanyRule</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"meta-tag\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.metaTag\">Meta Tag</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"subscription-package\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.subscriptionPackage\">subscription-package</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"company-social-network-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.companySocialNetworkInfo\">Company Social Network Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"social-network-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.socialNetworkInfo\">Social Network Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"selector-data\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.selectorData\">Selector Data</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"selector-data-type\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.selectorDataType\">Selector Data Type</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\">--><!--<a ui-sref=\"service-category\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.serviceCategory\">Service Category</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"customer\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.customer\">Customer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.orderBag\">Order Bag</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag-service-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.orderBagServiceItem\">Order Bag Service Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag-service-item-dtail\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.orderBagServiceItemDtail\">Order Bag Service Item Dtail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"invoice-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.invoiceInfo\">Invoice Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"order-bag-item-option\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.orderBagItemOption\">Order Bag Item Option</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"payment-log\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.paymentLog\">Payment Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"location-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.locationInfo\">Location Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"person-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.personInfo\">Person Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"price-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.priceInfo\">Price Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"price-info-dtail\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.priceInfoDtail\">Price Info Dtail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"discount-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.discountInfo\">Discount Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"schedule-base-discount\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span--><!--translate=\"global.menu.entities.scheduleBaseDiscount\">Schedule Base Discount</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-option-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.serviceOptionInfo\">Service Option Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-option-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.serviceOptionItem\">Service Option Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"servant\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.servant\">Servant</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"album-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.albumInfo\">Album Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"image-data\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.imageData\">Image Data</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"related-service-item\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.relatedServiceItem\">Related Service Item</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"service-capacity-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.serviceCapacityInfo\">Service Capacity Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"capacity-exception\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.capacityException\">Capacity Exception</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"date-period\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.datePeriod\">Date Period</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"off-day\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.offDay\">Off Day</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"off-time\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.offTime\">Off Time</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"weekly-work-day\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.weeklyWorkDay\">Weekly Work Day</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"time-period\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.timePeriod\">Time Period</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"weekly-schedule-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.weeklyScheduleInfo\">Weekly Schedule Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"schedule-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.scheduleInfo\">Schedule Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"setting-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.settingInfo\">Setting Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"theme-setting-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.themeSettingInfo\">Theme Setting Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"financial-setting\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.financialSetting\">Financial Setting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"notification-setting\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.notificationSetting\">Notification Setting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"extra-setting\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.extraSetting\">Extra Setting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"participant-person\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.participantPerson\">Participant Person</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"canceling-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.cancelingInfo\">Canceling Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"waiting-list\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.waitingList\">Waiting List</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"agreement-info\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.agreementInfo\">Agreement Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"customer-comment\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.customerComment\">Customer Comment</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active=\"active\">--><!--<a ui-sref=\"customer-rank\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;--><!--<span translate=\"global.menu.entities.customerRank\">Customer Rank</span>--><!--</a>--><!--</li>--><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPER_ADMIN_FULL_ACCESS\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"jhi-tracker\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-eye-open\"></span>&nbsp; <span translate=\"global.menu.admin.tracker\">User tracker</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"createUserAccount({ referralCode: vm.referralCode })\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; <span translate=\"global.menu.account.register\">Register</span></a></li></ul></div></div></nav><div id=\"ellipsisMobile\" ng-switch=\"vm.isAuthenticated()\" ng-if=\"vm.company\"><ul style=\"padding: 0px 10px\"><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a has-not-authority=\"ROLE_FREEMIUM_USER\" href=\"\" ng-click=\"vm.gotoWebSite()\" onclick=\"closeEllipsisMenu()\"><span class=\"glyphicon glyphicon-globe\"></span> <span translate=\"global.menu.account.myWebsite\">myWebsite</span></a></li><li ng-if=\"vm.isNativeApp != \'true\'\" ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a class=\"\" ui-sref=\"supplierPanel.companySubscriptionStatusV2\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></a></li><li ng-if=\"vm.isNativeApp != \'true\'\" ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySmsPackageStatus\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.sms_package_status\">SMS Package</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a href=\"\" ng-click=\"vm.gotoReserwebHelp()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-life-ring\"></span> <span translate=\"global.menu.account.tutorial\">tutorial</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a id=\"onlineSupportBtn1\" data-target=\"#\" data-toggle=\"tooltip\" ng-click=\"vm.openChat()\"><span class=\"fa fa-volume-control-phone fa-fw\"></span> <span translate=\"supplierPanel.sideMenu.onlineSupport.title\">onlineSupport</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\" has-authority=\"ROLE_USER\" style=\"padding-left: 70px\"><a class=\"dropdown-toggle\" style=\"text-decoration: none\" uib-dropdown-toggle href=\"\" id=\"userProfile-menu\"><span class=\"fa fa-cog fa-lg\"></span> <span translate=\"global.menu.account.mySetting\">mySetting</span> <span><span id=\"user_name\"><!--{{vm.userProfile.personInfo.fisrtName}} {{vm.userProfile.personInfo.lastName}}--> </span><span data-ng-if=\"vm.userProfile.personInfo.fisrtName\"><!--<script>--><!--window.smartlook || (function (d) {--><!--var o = smartlook = function () {--><!--o.api.push(arguments)--><!--}, h = d.getElementsByTagName(\'head\')[0];--><!--var c = d.createElement(\'script\');--><!--o.api = new Array();--><!--c.async = true;--><!--c.type = \'text/javascript\';--><!--c.charset = \'utf-8\';--><!--c.src = \'https://rec.smartlook.com/recorder.js\';--><!--h.appendChild(c);--><!--})(document);--><!--smartlook(\'init\', \'19b2dabb8703bf2555c0dc5fb5408d1ab86e2637\');--><!--smartlook(\'tag\', \'name\', document.getElementById(\'user_name\').innerHTML);--><!--</script>--> </span></span><b class=\"caret\"></b></a><ul class=\"dropdown-menu\" style=\"box-shadow: none\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a class=\"my-dropdown-menu linked\" ui-sref=\"supplierPanel.partialFormPersonInfo\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-user\"></span>&nbsp; <span translate=\"global.menu.account.userProfile\">User Profile</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a class=\"\" ui-sref=\"supplierPanel.password\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-key\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a class=\"\" href=\"\" ng-click=\"vm.logout()\" onclick=\"closeEllipsisMenu()\" id=\"logout\"><span class=\"fa fa-sign-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li></ul></li><!--<li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\">--><!--<a class=\"\" href=\"\" ng-click=\"vm.openInbox()\" onclick=\"closeEllipsisMenu()\">--><!--<span ng-if=\"!vm.isInboxOpened\" class=\"fa fa-envelope\"></span>--><!--<span ng-if=\"vm.isInboxOpened\" class=\"fa fa-envelope-open\"></span>--><!--<span translate=\"global.menu.account.myInbox\">myInbox</span>--><!--<span ng-if=\"!vm.isInboxOpened\" id=\"inboxBadge\" class=\"badge badge-success\">5</span>--><!--</a>--><!--</li>--></ul></div></div><script>$(document).ready(function () {\n            $(\'#ellipsis\').on(\'click\', function () {\n                $(\'#ellipsisMobile\').css(\'width\', \'180px\');\n                $(\'#overlay\').css(\'display\', \'block\');\n            })\n            $(\'#overlay\').on(\'click\', function () {\n\n            });\n\n            // $(document).on(\'click\',\'.linked\', function () { //it did not work until I used \'document.on\', so it should not change\n            //\n            //     $(\'#sidebar\').css(\'width\', \'0px\');\n            //     $(\'#ellipsisMobile\').css(\'width\', \'0px\');\n            //     // $(\'#overlay\').css(\'display\', \'none\');\n            //\n            // });\n        })\n\n        function closeEllipsisMenu() {\n            if (screen.width < 768) {\n                $(\'#sidebar\').css(\'width\', \'0px\');\n                $(\'#ellipsisMobile\').css(\'width\', \'0px\');\n                $(\'#overlay\').css(\'display\', \'none\');\n                $(\'.navbar-fixed-top\').removeClass(\'compact\');\n                $(\'#page-wrapper\').removeClass(\'compact\');\n            }\n        }</script></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<!-- Global Site Tag (gtag.js) - Google Analytics --><!--<script async src=\"https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID\"></script>--><!--<script>--><!--window.dataLayer = window.dataLayer || [];--><!--function gtag(){dataLayer.push(arguments);}--><!--gtag(\'js\', new Date());--><!--gtag(\'config\', \'UA-173464459-1\');--><!--</script>--><script ng-if=\"vm.showGtag\" async src=\"https://www.googletagmanager.com/gtag/js?id=G-ED49RQWYNY\"></script><script ng-if=\"vm.showGtag\">window.dataLayer = window.dataLayer || [];\n\n    function gtag() {\n        dataLayer.push(arguments);\n    }\n\n    gtag(\'js\', new Date());\n\n    gtag(\'config\', \'G-ED49RQWYNY\');</script><style>select.form-control {\n        background: none;\n    }\n\n    .form-control:focus {\n        -webkit-box-shadow: none;\n        box-shadow: none;\n    }\n\n    .companyDropdown {\n        margin: 11px 25px;\n        position: absolute;\n        cursor: default;\n    }\n\n    .companyName {\n        margin: 20px 25px;\n        position: absolute;\n        cursor: default;\n    }\n\n    .navbar .navbar-nav > li > a:hover {\n        background-color: hsla(0, 0%, 96%, .25);\n    }\n\n    .navbar-nav > li > .dropdown-menu {\n        margin-top: 3px;\n        right: -110px;\n    }\n\n    /*menuIcon*/\n    #menuHamburgerDesktop {\n        cursor: pointer;\n\n        height: 65px;\n        padding: 20px 16px;\n    }\n\n    .bar1, .bar2, .bar3 {\n        width: 28px;\n        height: 3px;\n        /*background-color: #009688;*/\n        margin: 3px 0;\n        transition: 0.5s;\n    }\n\n    #menuHamburgerMobile {\n        display: none;\n    }\n\n    #desktop {\n        display: block;\n    }\n\n    #ellipsisMobile {\n        display: block;\n        padding: 10px 0;\n        position: fixed;\n        left: 0;\n        top: 0;\n        overflow-x: hidden;\n        white-space: nowrap;\n        height: 100vh;\n        width: 0px;\n        transition: 0.5s;\n        z-index: 1031;\n    }\n\n    #ellipsisMobile ul li {\n        padding: 7px 22px;\n    }\n\n    .change {\n        margin-top: -5px;\n    }\n\n    .dropdown-menu > li > a {\n        padding: 2px 15px;\n    }\n\n    .badge-position {\n        top: 3px;\n        position: absolute;\n        padding: 4px 5px;\n        font-size: 9px;\n    }\n\n    @media (min-width: 768px) {\n        #desktop {\n            height: 65px !important;\n        }\n\n        .navbar .navbar-nav > li > a {\n            padding-top: 20px !important;\n            padding-bottom: 20px !important;\n        }\n    }\n\n    @media (max-width: 767px) {\n        #menuHamburgerMobile {\n            display: inline-block;\n            cursor: pointer;\n            width: 35px;\n            padding: 18px 25px;\n            float: right;\n        }\n\n        .companyDropdown {\n            margin: 9px 60px;\n        }\n\n        /*select.form-control {*/\n        /*background: none;*/\n        /*}*/\n        /*.form-control:focus {*/\n        /*-webkit-box-shadow: none;*/\n        /*box-shadow: none;*/\n        /*}*/\n        #desktop {\n            display: none;\n        }\n\n        .companyName {\n            position: absolute;\n            cursor: default;\n            top: 22px;\n            width: 40%;\n            margin: auto 30%;\n        }\n\n\n        .unread_counter {\n            background-color: #e60909;\n            padding: 3px 5px;\n            border-radius: 25px;\n            position: absolute;\n            top: -8px;\n            right: -8px;\n        }\n\n\n    }</style><div><nav class=\"navbar navbar-fixed-top\" role=\"navigation\"><div class=\"container-fluid\"><div class=\"navbar-header text-center\"><div id=\"menuHamburgerMobile\"><div ng-if=\"vm.company\"><div class=\"bar1\"></div><div class=\"bar2\"></div><div class=\"bar3\"></div></div></div><span class=\"visible-xs companyName\" ng-if=\"vm.company && vm.companies.length == 1\">{{vm.company.title}}</span> <span ng-if=\"vm.companies.length > 1\" class=\"visible-xs companyDropdown\"><select class=\"form-control\" id=\"companySelect\" ng-change=\"vm.changeCCkey(vm.selectedCompany.keyUrl)\" name=\"companySelect\" ng-model=\"vm.selectedCompany\" required eo-required=\"\" ng-options=\"company.title for company in vm.companies track by company.id\"></select></span><button id=\"ellipsis\" type=\"button\" class=\"navbar-toggle\" style=\"margin-top: 12px; margin-bottom: 0\"><i style=\"font-size: 1.5em\" class=\"fa fa-ellipsis-v\" aria-hidden=\"true\" ng-if=\"vm.company\"></i></button><!--<a class=\"navbar-brand logo\" href=\"#/\" ng-click=\"vm.collapseNavbar()\">--><!--<img class=\"logo-img\" src=\"content/images/logo-4.png\"/>--><!--</a>--></div><div id=\"desktop\" class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-left\"><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><!--<a id=\"onlineSupportBtn\" data-target=\"#\" data-toggle=\"tooltip\" onclick=\"$crisp.push([\'do\', \'chat:open\'])\">--><!--<span class=\"fa fa-volume-control-phone fa-fw\"></span>--><!--<span class=\"badge\"--><!--style=\"left: 30px;--><!--top: 10px;--><!--position: absolute;--><!--padding: 4px 5px;--><!--font-size: 7px;--><!--background-color:#2b6b7f;\">--><!--{{\'supplierPanel.sideMenu.onlineSupport.title\' | translate}}--><!--</span>--><!--</a>--> <a id=\"onlineSupportBtn\" data-target=\"#\" data-toggle=\"tooltip\" ng-click=\"vm.supportButtonClick()\"><span class=\"fa fa-volume-control-phone fa-fw\"></span> <span class=\"badge badge-position\" style=\"left: 22px;\n                                         background-color:#2b6b7f\"><span id=\"unread_counter\" class=\"unread_counter\">0</span> {{\'supplierPanel.sideMenu.onlineSupport.title\' | translate}}</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a href=\"\" ng-click=\"vm.gotoReserwebHelp()\"><span class=\"fa fa-life-ring\"></span> <span class=\"badge badge-position\" style=\"left: 18px;\n                                         background-color: darkorange\">راهنما</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\"><a href=\"\" ng-click=\"vm.openInbox()\"><span ng-if=\"!vm.isInboxOpened\" class=\"fa fa-envelope\"></span> <span id=\"inboxBadge\" style=\"left: 23px;top: 11px;position: absolute; padding: 5px 6px\" class=\"badge badge-success\">5</span> <span ng-if=\"vm.isInboxOpened\" class=\"fa fa-envelope-open\"></span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a has-not-authority=\"ROLE_FREEMIUM_USER\" href=\"\" ng-click=\"vm.gotoWebSite()\"><span class=\"glyphicon glyphicon-globe\"></span> <span class=\"badge badge-position\" style=\"left: 18px;\n                                         background-color: deepskyblue\">سایت من</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\" has-authority=\"ROLE_USER\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"userProfile-menu\"><span class=\"glyphicon glyphicon-user\"></span> <span><span id=\"user_name\"><!--{{vm.userProfile.personInfo.fisrtName}} {{vm.userProfile.personInfo.lastName}}--> </span><span data-ng-if=\"vm.userProfile.personInfo.fisrtName\"><!--<script>--><!--window.smartlook || (function (d) {--><!--var o = smartlook = function () {--><!--o.api.push(arguments)--><!--}, h = d.getElementsByTagName(\'head\')[0];--><!--var c = d.createElement(\'script\');--><!--o.api = new Array();--><!--c.async = true;--><!--c.type = \'text/javascript\';--><!--c.charset = \'utf-8\';--><!--c.src = \'https://rec.smartlook.com/recorder.js\';--><!--h.appendChild(c);--><!--})(document);--><!--smartlook(\'init\', \'19b2dabb8703bf2555c0dc5fb5408d1ab86e2637\');--><!--smartlook(\'tag\', \'name\', document.getElementById(\'user_name\').innerHTML);--><!--</script>--> </span></span><b class=\"caret\"></b></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><!--<a class=\"my-dropdown-menu\" ui-sref=\"userProfile\" ng-click=\"vm.collapseNavbar()\">--> <a class=\"my-dropdown-menu\" ui-sref=\"supplierPanel.partialFormPersonInfo\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-user\"></span>&nbsp; <span translate=\"global.menu.account.userProfile\">User Profile</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.password\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-key\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><!--<li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\">--><!--<a ui-sref=\"supplierPanel.companySubscriptionStatus\" ng-click=\"vm.collapseNavbar()\">--><!--<span class=\"fa fa-shopping-cart\"></span>--><!--<span translate=\"global.menu.account.subscription\">Subscription</span>--><!--</a>--><!--</li>--><li ng-if=\"vm.__config.appMode == \'reserve\'\" ui-sref-active=\"active\" ng-switch-when=\"true\" has-not-authority=\"ROLE_SERVANT_LOGIN\" has-any-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySubscriptionStatusV2\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></a></li><li ng-if=\"vm.__config.appMode == \'event\'\" ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySubscriptionStatusEvent\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-not-authority=\"ROLE_SERVANT_LOGIN\" has-any-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySmsPackageStatus\" ng-click=\"vm.collapseNavbar()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.sms_package_status\">SMS Package</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"fa fa-sign-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right\"><li id=\"menuHamburgerDesktop\"><div ng-if=\"vm.company\"><div class=\"bar1\"></div><div class=\"bar2\"></div><div class=\"bar3\"></div></div></li><span ng-if=\"vm.company && vm.companies.length == 1\" class=\"companyName\">{{vm.company.title}}</span> <span ng-if=\"vm.companies.length > 1\" class=\"companyDropdown\"><select class=\"form-control\" id=\"companySelect\" ng-change=\"vm.changeCCkey(vm.selectedCompany.keyUrl)\" name=\"companySelect\" ng-model=\"vm.selectedCompany\" required eo-required=\"\" ng-options=\"company.title for company in vm.companies track by company.id\"></select></span><!--<md-input-container>--><!--<label>State</label>--><!--<md-select ng-model=\"ctrl.userState\">--><!--<md-option><em>None</em></md-option>--><!--<md-option ng-repeat=\"state in ctrl.states\" ng-value=\"state.abbrev\" ng-disabled=\"$index === 1\">--><!--{{state.abbrev}}--><!--</md-option>--><!--</md-select>--><!--</md-input-container>--><li has-authority=\"ROLE_ADMIN\"><a ui-sref=\"supplierPanel.testServices\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-cog\"></span> <span class=\"hidden-sm\">Test Services</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu style=\"overflow: scroll; max-height: 600px; width: 250px\"><li ui-sref-active=\"active\"><a ui-sref=\"company\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.company\">Company</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"company-invoice-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companyInvoiceInfo\">companyInvoiceInfo</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"service-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.serviceItem\">Service Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"marketplace\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.marketplace\">Marketplace</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"news\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.news\">News</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"supplier-coupon\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.supplierCoupon\">SupplierCoupon</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"company-subscription-status\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companySubscriptionStatus\">CompanySubscriptionStatus-package</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"companyRule\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companyRule\">CompanyRule</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"meta-tag\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.metaTag\">Meta Tag</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"subscription-package\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.subscriptionPackage\">subscription-package</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"company-social-network-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companySocialNetworkInfo\">Company Social Network Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"social-network-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.socialNetworkInfo\">Social Network Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"company-manager\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.companyManager\">Company Manager</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"selector-data\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.selectorData\">Selector Data</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"selector-data-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.selectorDataType\">Selector Data Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"service-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.serviceCategory\">Service Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customer\">Customer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"order-bag\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.orderBag\">Order Bag</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"order-bag-service-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.orderBagServiceItem\">Order Bag Service Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"order-bag-service-item-dtail\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.orderBagServiceItemDtail\">Order Bag Service Item Dtail</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"invoice-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.invoiceInfo\">Invoice Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"order-bag-item-option\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.orderBagItemOption\">Order Bag Item Option</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"payment-log\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.paymentLog\">Payment Log</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"location-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.locationInfo\">Location Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"person-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.personInfo\">Person Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"price-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.priceInfo\">Price Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"price-info-dtail\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.priceInfoDtail\">Price Info Dtail</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"discount-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.discountInfo\">Discount Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"schedule-base-discount\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.scheduleBaseDiscount\">Schedule Base Discount</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"service-option-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.serviceOptionInfo\">Service Option Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"service-option-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.serviceOptionItem\">Service Option Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"servant\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.servant\">Servant</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"album-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.albumInfo\">Album Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"image-data\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.imageData\">Image Data</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"related-service-item\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.relatedServiceItem\">Related Service Item</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"service-capacity-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.serviceCapacityInfo\">Service Capacity Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"capacity-exception\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.capacityException\">Capacity Exception</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"date-period\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.datePeriod\">Date Period</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"off-day\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.offDay\">Off Day</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"off-time\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.offTime\">Off Time</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"weekly-work-day\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.weeklyWorkDay\">Weekly Work Day</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"time-period\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.timePeriod\">Time Period</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"weekly-schedule-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.weeklyScheduleInfo\">Weekly Schedule Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"schedule-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.scheduleInfo\">Schedule Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"setting-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.settingInfo\">Setting Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"theme-setting-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.themeSettingInfo\">Theme Setting Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"financial-setting\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.financialSetting\">Financial Setting</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"notification-setting\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.notificationSetting\">Notification Setting</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"extra-setting\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.extraSetting\">Extra Setting</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"participant-person\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.participantPerson\">Participant Person</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"canceling-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.cancelingInfo\">Canceling Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"waiting-list\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.waitingList\">Waiting List</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"agreement-info\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.agreementInfo\">Agreement Info</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-comment\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customerComment\">Customer Comment</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"customer-rank\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.customerRank\">Customer Rank</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-tracker\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-eye-open\"></span>&nbsp; <span translate=\"global.menu.admin.tracker\">User tracker</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"createUserAccount\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; <span translate=\"global.menu.account.register\">Register</span></a></li></ul></div></div></nav><div id=\"ellipsisMobile\" ng-switch=\"vm.isAuthenticated()\" ng-if=\"vm.company\"><ul style=\"padding: 0px 10px\"><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a has-not-authority=\"ROLE_FREEMIUM_USER\" href=\"\" ng-click=\"vm.gotoWebSite()\" onclick=\"closeEllipsisMenu()\"><span class=\"glyphicon glyphicon-globe\"></span> <span translate=\"global.menu.account.myWebsite\">myWebsite</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a class=\"\" ui-sref=\"supplierPanel.companySubscriptionStatusV2\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.subscription\">Subscription</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a ui-sref=\"supplierPanel.companySmsPackageStatus\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-shopping-cart\"></span> <span translate=\"global.menu.account.sms_package_status\">SMS Package</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a href=\"\" ng-click=\"vm.gotoReserwebHelp()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-life-ring\"></span> <span translate=\"global.menu.account.tutorial\">tutorial</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\" uib-dropdown><a id=\"onlineSupportBtn1\" data-target=\"#\" data-toggle=\"tooltip\" ng-click=\"vm.openChat()\"><span class=\"fa fa-volume-control-phone fa-fw\"></span> <span translate=\"supplierPanel.sideMenu.onlineSupport.title\">onlineSupport</span></a></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\" has-authority=\"ROLE_USER\" style=\"padding-left: 70px\"><a class=\"dropdown-toggle\" style=\"text-decoration: none\" uib-dropdown-toggle href=\"\" id=\"userProfile-menu\"><span class=\"fa fa-cog fa-lg\"></span> <span translate=\"global.menu.account.mySetting\">mySetting</span> <span><span id=\"user_name\"><!--{{vm.userProfile.personInfo.fisrtName}} {{vm.userProfile.personInfo.lastName}}--> </span><span data-ng-if=\"vm.userProfile.personInfo.fisrtName\"><!--<script>--><!--window.smartlook || (function (d) {--><!--var o = smartlook = function () {--><!--o.api.push(arguments)--><!--}, h = d.getElementsByTagName(\'head\')[0];--><!--var c = d.createElement(\'script\');--><!--o.api = new Array();--><!--c.async = true;--><!--c.type = \'text/javascript\';--><!--c.charset = \'utf-8\';--><!--c.src = \'https://rec.smartlook.com/recorder.js\';--><!--h.appendChild(c);--><!--})(document);--><!--smartlook(\'init\', \'19b2dabb8703bf2555c0dc5fb5408d1ab86e2637\');--><!--smartlook(\'tag\', \'name\', document.getElementById(\'user_name\').innerHTML);--><!--</script>--> </span></span><b class=\"caret\"></b></a><ul class=\"dropdown-menu\" style=\"box-shadow: none\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a class=\"my-dropdown-menu linked\" ui-sref=\"supplierPanel.partialFormPersonInfo\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-user\"></span>&nbsp; <span translate=\"global.menu.account.userProfile\">User Profile</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\" has-authority=\"ROLE_SUPPLIER\"><a class=\"\" ui-sref=\"supplierPanel.password\" ng-click=\"vm.collapseNavbar()\" onclick=\"closeEllipsisMenu()\"><span class=\"fa fa-key\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a class=\"\" href=\"\" ng-click=\"vm.logout()\" onclick=\"closeEllipsisMenu()\" id=\"logout\"><span class=\"fa fa-sign-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li></ul></li><!--<li ng-class=\"{active: vm.$state.includes(\'account\')}\" has-authority=\"ROLE_USER\">--><!--<a class=\"\" href=\"\" ng-click=\"vm.openInbox()\" onclick=\"closeEllipsisMenu()\">--><!--<span ng-if=\"!vm.isInboxOpened\" class=\"fa fa-envelope\"></span>--><!--<span ng-if=\"vm.isInboxOpened\" class=\"fa fa-envelope-open\"></span>--><!--<span translate=\"global.menu.account.myInbox\">myInbox</span>--><!--<span ng-if=\"!vm.isInboxOpened\" id=\"inboxBadge\" class=\"badge badge-success\">5</span>--><!--</a>--><!--</li>--></ul></div></div><script>$(document).ready(function () {\n        $(\'#ellipsis\').on(\'click\', function () {\n            $(\'#ellipsisMobile\').css(\'width\', \'180px\');\n            $(\'#overlay\').css(\'display\', \'block\');\n        })\n        $(\'#overlay\').on(\'click\', function () {\n\n        });\n\n        // $(document).on(\'click\',\'.linked\', function () { //it did not work until I used \'document.on\', so it should not change\n        //\n        //     $(\'#sidebar\').css(\'width\', \'0px\');\n        //     $(\'#ellipsisMobile\').css(\'width\', \'0px\');\n        //     // $(\'#overlay\').css(\'display\', \'none\');\n        //\n        // });\n    })\n\n    function closeEllipsisMenu() {\n        if (screen.width < 768) {\n            $(\'#sidebar\').css(\'width\', \'0px\');\n            $(\'#ellipsisMobile\').css(\'width\', \'0px\');\n            $(\'#overlay\').css(\'display\', \'none\');\n            $(\'.navbar-fixed-top\').removeClass(\'compact\');\n            $(\'#page-wrapper\').removeClass(\'compact\');\n        }\n    }</script>");
$templateCache.put("app/reports/company-customer-form-data-report/company-customer-form-data-report.html","<div class=\"hidden-xs\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"tikonApp.companyCustomer.companyCustomerFormData.home.title\">tikonApp.companyCustomer.companyCustomerFormData.home.searchPlaceHolder.title</div><div class=\"panel-body pl-panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right\"><md-button class=\"md-raised pl-btn-default pl-btn\" ui-sref=\"supplierPanel-v2.reportExport\"><span><i class=\"fa fa-undo\" aria-hidden=\"true\"></i> </span><span translate=\"entity.action.back\">entity.action.back</span></md-button></div></div></div><!--<div class=\"container-fluid\">--><jhi-alert></jhi-alert><div class=\"\"><!--<div>--><!--<div class=\"form-field-description\" style=\"padding-bottom: 10px;:\">--><!--<span>--><!--* برای اعمال فیلتر (جستجوی پیشرفته) گزینه--><!--</span>--><!--<span>--><!--<md-icon>filter_list</md-icon>--><!--</span>--><!--<span>--><!--را انتخاب کنید.--><!--</span>--><!--</div>--><!--</div>--><div class=\"row topOfList\" style=\"display: flex; align-items: center\"><div class=\"col-sm-10\"><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.companyCustomer.companyCustomerFormData.home.searchPlaceHolder\'\" on-search=\"vm.advancedSearch()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"true\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"global.pageSize\">pageSize</label><md-select class=\"rwMdSelect\" id=\"field_pageSize\" ng-model=\"vm.pageSize\" ng-change=\"vm.pageSizeChanged()\" style=\"min-width: 100px;margin-bottom: 5px !important\"><md-option ng-value=\"si\" ng-repeat=\"si in vm.pageSizeList\">{{si}}</md-option></md-select></div></div></div><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"vm.companyCustomerDatas\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><!--<tr>--><!--<th colspan=\"5\">--><!--<div class=\"row \" >--><!--<eo-pl-search-box search-query=\"vm.filterQuery.searchText\"--><!--search-place-holder=\"\'tikonApp.invoiceInfo.home.searchPlaceHolder\'\"--><!--on-search=\"vm.searchInvoiceInfos()\"--><!--on-clear-search=\"vm.clearSearch()\"--><!--&gt;</eo-pl-search-box>--><!--</div>--><!--</th>--><!--</tr>--><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th><span translate=\"tikonApp.companyCustomer.companyCustomerFormData.formId\">formId</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.companyCustomer.companyCustomerFormData.customerName\">customer</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.companyCustomer.companyCustomerFormData.formTitle\">formTitle</span></th><th class=\"hidden-xs\"><span translate=\"tikonApp.companyCustomer.companyCustomerFormData.data\">customerFormData</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"companyCustomerData in collection track by companyCustomerData.id\"><!--<td>{{invoiceInfo.id }} </td>--><td><a ng-click=\"vm.openEditDataDialog(companyCustomerData)\">{{companyCustomerData.id}}</a></td><td>{{companyCustomerData.companyCustomer.customerFullName}}</td><td><div>{{companyCustomerData.companyCustomForm.title }}</div></td><td><div class=\"\" ng-repeat=\"field in companyCustomerData.intakeDataDTO.fields\"><span ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \"><i class=\"fa fa-check\"></i> <span style=\"font-weight: bold\">{{field.label}} </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType ==\'File\' \"><span>{{field.label}} :</span> <span ng-if=\"field.value\"><i class=\"fa fa-file\"></i> <span>فایل</span> </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType ==\'Date\'\"><span>{{field.label}} :</span> <span ng-if=\"field.value\" style=\"font-weight: bold\">{{field.value | toPersianDate}}</span> </span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType !=\'Date\'\"><span>{{field.label}} :</span> <span style=\"font-weight: bold\">{{field.value}}</span></span></div></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.openEditDataDialog(companyCustomerData)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-click=\"vm.printItem(companyCustomerData)\" class=\"btn pl-btn-default pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-print\"></span> <span translate=\"entity.action.print\"></span></button></div></td></tr></tbody><!--<tfoot>--><!--<tr>--><!--<td colspan=\"5\" class=\"text-center\">--><!--<div st-pagination=\"\" st-items-by-page=\"10\"></div>--><!--</td>--><!--</tr>--><!--</tfoot>--></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.pageSize\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" items-per-page=\"vm.pageSize\"></uib-pagination></div></div><!--</div>--></div></div></div></div><div class=\"visible-xs pl-form-container\"><div class=\"\"><div class=\"\"><div class=\"col-xs-12 invoiceInfo-list-title\"><h3 class=\"\" style=\"padding-right: 7px;margin: 15px 0\">{{\'tikonApp.companyCustomer.companyCustomerFormData.home.title\' | translate}}</h3><div style=\"align-self: flex-end\"><md-button class=\"pl-btn-default\" style=\"border-radius: 10px\" ui-sref=\"supplierPanel-v2.reportExport\"><md-icon style=\"color: #000\">keyboard_backspace</md-icon>بازگشت</md-button></div></div><div class=\"row\"><jhi-alert></jhi-alert><eo-pl-search-box search-query=\"vm.filterQuery.searchText\" search-place-holder=\"\'tikonApp.companyCustomer.companyCustomerFormData.home.searchPlaceHolder\'\" on-search=\"vm.advancedSearch()\" on-clear-search=\"vm.clearSearch()\" can-filter=\"false\" on-filter-click=\"vm.showFilterDialog\" filter-count=\"vm.filterCount\"></eo-pl-search-box><div ng-repeat=\"companyCustomerData in vm.companyCustomerDatas track by companyCustomerData.id\" class=\"customer-list-item\" ng-click=\"vm.openEditDataDialog(companyCustomerData)\"><!--<eo-avatar-name name=\"{{invoiceInfo.invoiceInfoCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\" style=\"font-weight: bold;font-size: 16px\">{{companyCustomerData.id}}</div><div class=\"customer-list-customer-name\">{{companyCustomerData.companyCustomer.customerFullName}}</div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span>{{companyCustomerData.companyCustomForm.title}}</span></div><div class=\"customer-list-customer-phone\"><!--<span>--><!--&lt;!&ndash;{{companyCustomer.createDate | toPersianDate}}</td>&ndash;&gt;--><!--{{invoiceInfo.finalPrice}}--><!--<span translate=\"global.currencyBracket\"></span>--><!--</span>--></div></div><!--<div class=\"customer-list-item-detail\">--><!--<div class=\"customer-list-customer-phone\">--><!--<span ng-class=\"vm.findStatusStyle(invoiceInfo.status)\" style=\"font-size: 12px\"--><!--translate=\"{{\'tikonApp.invoiceStatus.\' + invoiceInfo.status}}\">{{invoiceInfo.status}}</span>--><!--</div>--><!--</div>--><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination></div></div>");
$templateCache.put("app/reports/company-customer-form-data-report/filter-company-customer-form-data-report-dialog.html","<style>.panel {\n        margin: 0;\n\n    }\n\n    .filter_by_select > md-select-value > span {\n        display: -webkit-inline-box;\n    }\n\n    .custom-panel-style {\n        min-height: 320px;\n    }\n\n    @media (max-width: 767px) {\n        .custom-panel-style {\n            min-height: 415px;\n        }\n    }</style><md-dialog class=\"pl-md-dialog\"><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div>اعمال فیلتر (جستجوی پیشرفته)</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><md-dialog-content class=\"pl-dialog-content\"><div class=\"\"><div class=\"panel-body custom-panel-style\"><div id=\"filters_content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label translate=\"tikonApp.companyCustomer.companyCustomerFormData.home.companyCustomFormName\">Status</label><md-select class=\"rwMdSelect filter_by_select pl-col-no-margin\" id=\"field_companyCustomFormId\" placeholder=\"{{\'tikonApp.companyCustomer.companyCustomerFormData.home.showAll\' | translate}}\" ng-model=\"$ctrl.data.filterQuery.companyCustomFormId\" style=\"min-width: 100px\"><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.data.companyCustomForms\">{{si.title}}</md-option></md-select></div></div></div></div></div></div></md-dialog-content><md-dialog-actions class=\"pl-dialog-actions\"><div class=\"pl-filter-dialog-footer\" style=\"width: 100%\"><div class=\"\" style=\"display: flex;justify-content: flex-end\"><a class=\"delete-filters\" ng-click=\"$ctrl.clearFilter()\"><i class=\"material-icons\" style=\"font-size: 12px\">cancel</i> حذف فیلترها</a><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default hidden-xs\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span>بازگشت</span><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--></md-button><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-click=\"$ctrl.okModal()\"><span>اعمال</span></md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/reports/company-customer-form-data-report/print-company-customer-form-data.html","<style>md-icon {\n        color: unset;\n    }\n\n    .customer-form-data-fields-table {\n        width: 100%;\n    }\n\n    .customer-form-data-fields-table > tbody > tr > td {\n        /*border: 1px solid;*/\n        padding: 0 5px;\n        width: 25%;\n    }\n\n    .invoice-item-table > thead {\n        customer-form-data-fields-table: 1px solid;\n    }\n\n\n    .customer-form-data-fields-table > thead > tr > th {\n        padding: 10px 5px;\n    }\n\n    .customer-form-data-fields-table > tbody > tr > td {\n\n        padding: 10px 5px;\n    }\n\n\n    .customer-form-data-fields-table-container {\n        /*padding: 10px;*/\n        border-top: 1px solid;\n    }\n\n    .customer-form-data-fields-table > tbody > tr {\n        border-top: 1px solid;\n        /*border-bottom: 6px solid;*/\n    }\n\n    .customer-form-data-fields-table > tbody > tr:first-child {\n        border-top: none;\n\n    }\n\n    .print-container {\n        padding: 0 0;\n        display: flex;\n        justify-content: center;\n    }\n\n    .print-content-lg {\n        border: 1px solid;\n        width: 100%;\n    }\n\n\n    .custom-form-title {\n        text-align: center;\n        padding: 10px 0;\n        font-weight: bold;\n        font-size: 16px;\n\n    }\n\n    .payment-amount {\n        font-weight: bold;\n        font-size: 18px;\n        text-align: center;\n        border: 1px solid;\n        padding: 10px;\n    }\n\n    .payment-summary {\n        padding: 10px 20px 20px 20px;\n        display: flex;\n        justify-content: center;\n        flex-flow: column;\n        align-items: center;\n    }\n\n    .footer-company-info {\n\n        border-top: 1px solid;\n        padding: 10px;\n        text-align: center;\n    }\n\n\n    @media print {\n        .noPrint {\n            display: none;\n        }\n\n        .pl-content {\n            padding: 0;\n        }\n\n        .print-container {\n            padding: 0 0;\n        }\n\n        .print-content {\n            border: 1px solid;\n            width: 100%;\n        }\n\n\n    }</style><eo-pl-modal-header class=\"noPrint\" title=\"vm.getModalTitle()\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\" ok-title=\"\'tikonApp.companyCustomer.companyCustomerFormData.print\'\"></eo-pl-modal-header><jhi-alert-error></jhi-alert-error><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"print-container\"><div class=\"print-content-lg\"><div class=\"custom-form-title\"><div>{{vm.customerFormData.companyCustomer.customerFullName}}</div><div style=\"font-weight: normal;font-size: 13px\">{{vm.customerFormData.companyCustomForm.title}}</div></div><div class=\"customer-form-data-fields-table-container\"><table class=\"customer-form-data-fields-table\"><tr ng-repeat=\"rows in vm.tableRows\"><!--<td ng-if=\"rows.isTextArea\" colspan=\"4\">--><!--<span--><!--ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType !=\'Date\'\">--><!--<span>{{field.label}} :</span>--><!--<span style=\"font-weight: bold\">{{field.value}}</span>--><!--</span>--><!--</td>--><td ng-repeat=\"field in rows\" colspan=\"{{field.field.fieldType == \'TextArea\' ? \'4\' : \'1\'}}\"><span ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \"><i class=\"fa fa-check\"></i> <span style=\"font-weight: bold\">{{field.label}} </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType ==\'File\' \"><span>{{field.label}} :</span> <span ng-if=\"field.value\"><i class=\"fa fa-check\"></i> <span>آپلود شده </span></span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType ==\'Date\'\"><span>{{field.label}} :</span> <span ng-if=\"field.value\" style=\"font-weight: bold\">{{field.value | toPersianDate}}</span> </span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType !=\'Date\'\"><span>{{field.label}} :</span> <span style=\"font-weight: bold\">{{field.value}}</span></span></td></tr></table></div></div></div></div></div><eo-pl-modal-footer class=\"noPrint\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/reports/company_form_data_list/company_form_data_list.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label for=\"field_companyCustomForm\">انتخاب فرم</label><select class=\"form-control\" id=\"field_companyCustomForm\" name=\"companyCustomForm\" ng-model=\"vm.selectedCompanyCustomForm\" ng-options=\"companyCustomForm.id as companyCustomForm.title for companyCustomForm in vm.companyCustomForms\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-10\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete></div></div></div><div class=\"row\"><div class=\"col-sm-10\"><div class=\"form-group\"><h4>** در صورت عدم انتخاب مشتری گزارش برای تمامی مشتریان ایجاد می گردد. **</h4></div></div></div></div><div class=\"action-bar\"><span data-ng-if=\"vm.waitOnCReatingReport\" class=\"status-message waitOnCReatingReport\">{{\'reportExport.creatinReportInProgress\' | translate}} </span><span data-ng-if=\"vm.reportCreatedAndDownload\" class=\"status-message reportCreated\">{{\'reportExport.reportCreatedAndDownload\' | translate}} <a class=\"link\" href=\"{{vm.downloadlink}}\">لینک دانلود فایل گزارش </a></span><span data-ng-if=\"vm.errorOnCreatingReport\" class=\"status-message errorOnCReatingReport\">{{\'reportExport.reportHasNoRecord\' | translate}} </span><span data-ng-if=\"vm.showFormIsMandatory\" class=\"status-message errorOnCReatingReport\">فرم انتخاب نشده است </span><button type=\"button\" data-ng-click=\"vm.confirm()\" class=\"btn btn-success\">{{\'reportExport.confirmAndDownload\' | translate}} <i class=\"fa fa-download\"></i></button> <button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"btn btn-danger\">{{\'reportExport.cancel\' | translate}} <i class=\"fa fa-close\"></i></button></div>");
$templateCache.put("app/reports/financial_by_customer/financial_by_customer.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-10\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.orderBag.searchCustomer\' | translate}}\" selected-item-change=\"vm.selectedCustomerChanged\" selected-item=\"vm.selectedCustomer\" search-method=\"vm.searchCustomer\"></eo-autocomplete></div></div></div><div class=\"row\"><div class=\"col-sm-10\"><div class=\"form-group\"><h4>** در صورت عدم انتخاب مشتری گزارش برای تمامی مشتریان ایجاد می گردد. **</h4></div></div></div></div><div class=\"action-bar\"><span data-ng-if=\"vm.waitOnCReatingReport\" class=\"status-message waitOnCReatingReport\">{{\'reportExport.creatinReportInProgress\' | translate}} </span><span data-ng-if=\"vm.reportCreatedAndDownload\" class=\"status-message reportCreated\">{{\'reportExport.reportCreatedAndDownload\' | translate}} <a class=\"link\" href=\"{{vm.downloadlink}}\">لینک دانلود فایل گزارش </a></span><span data-ng-if=\"vm.errorOnCreatingReport\" class=\"status-message errorOnCReatingReport\">{{\'reportExport.reportHasNoRecord\' | translate}} </span><button type=\"button\" data-ng-click=\"vm.confirm()\" class=\"btn btn-success\">{{\'reportExport.confirmAndDownload\' | translate}} <i class=\"fa fa-download\"></i></button> <button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"btn btn-danger\">{{\'reportExport.cancel\' | translate}} <i class=\"fa fa-close\"></i></button></div>");
$templateCache.put("app/reports/generic_report/generic_report.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }\n\n    .eoButtonPrimary {\n        background-color: var(--rw-btn-primary-color) !important;\n    }</style><jhi-alert></jhi-alert><!--<div class=\"action-bar\" >--> <span data-ng-if=\"$ctrl.waitOnCReatingReport\" class=\"status-message waitOnCReatingReport\">{{\'reportExport.creatinReportInProgress\' | translate}} </span><span data-ng-if=\"$ctrl.reportCreatedAndDownload\" class=\"status-message reportCreated\">{{\'reportExport.reportCreatedAndDownload\' | translate}} <a class=\"link\" href=\"{{$ctrl.downloadlink}}\">لینک دانلود فایل گزارش </a></span><span data-ng-if=\"$ctrl.errorOnCreatingReport\" class=\"status-message errorOnCReatingReport\">{{\'reportExport.reportHasNoRecord\' | translate}}</span><eo-button label=\"{{\'reportExport.confirmAndDownload\' | translate}}\" loading-label=\"{{\'reportExport.isGenerationReport\' | translate}}\" icon=\"get_app\" is-loading=\"$ctrl.isLoading\" on-click=\"$ctrl.confirm()\" type=\"1\"></eo-button><!--<button type=\"button\" data-ng-click=\"$ctrl.confirm()\" class=\"btn btn-success\" >--><!--{{\'reportExport.confirmAndDownload\' | translate}}--><!--<i class=\"fa fa-download\" ></i>--><!--</button>--><!--<button type=\"button\" data-ng-click=\"$ctrl.cancel()\" class=\"btn btn-danger\" >--><!--{{\'reportExport.cancel\' | translate}}--><!--<i class=\"fa fa-close\" ></i>--><!--</button>--> <!--</div>-->");
$templateCache.put("app/reports/invoice_info_item_report/invoice_info_item_report.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.filterStatus\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.invoiceInfoStatus\" id=\"field_status\"><option value=\"\" translate=\"tikonApp.invoiceInfo.showAll\"></option><option value=\"TEMP\">{{\'tikonApp.invoiceStatus.TEMP\'|translate}}</option><option value=\"SETTLEMENT\">{{\'tikonApp.invoiceStatus.SETTLEMENT\'|translate}}</option><option value=\"UNPAID\">{{\'tikonApp.invoiceStatus.UNPAID\'|translate}}</option><option value=\"VOID\">{{\'tikonApp.invoiceStatus.VOID\'|translate}}</option></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.filterServiceItem\" for=\"field_serviceItem\">ServiceItem</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.serviceItemId\" ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in vm.serviceItems\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.invoiceInfo.filterQuery\" for=\"field_query\">Query</label><input type=\"text\" class=\"form-control\" name=\"query\" id=\"field_query\" ng-model=\"vm.query\"></div></div></div></div><div class=\"action-bar\"><!--<div class=\"row\">--><!--<div class=\"col-md-7\">--><!--</div>--><!--<div class=\"col-md-5\">--><eo-generic-report do-before-export=\"vm.doBeforeExport\"></eo-generic-report><eo-button label=\"{{\'reportExport.cancel\' | translate}}\" icon=\"close\" on-click=\"vm.cancel()\" theme=\"accent\"></eo-button><!--</div>--><!--<div class=\"col-md-2\">--><!--<eo-button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"md-raised\">--><!--{{\'reportExport.cancel\' | translate}}--><!--<i class=\"fa fa-close\"></i>--><!--</eo-button>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/reports/orderbag_list_by_service/orderbag_list_by_service.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\" for=\"field_serviceItem\">ServiceItem</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.serviceItemId\" required eo-required=\"\" ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in vm.serviceItems\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.orderBagStatus\" id=\"field_status\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\"></option><option value=\"1\" translate=\"tikonApp.orderBag.status.1\">CONFIRMED</option><option value=\"4\" translate=\"tikonApp.orderBag.status.4\">CANCELED</option><option value=\"5\" translate=\"tikonApp.orderBag.status.5\">RESERVE_REQUEST</option><option value=\"6\" translate=\"tikonApp.orderBag.status.6\">REQUEST_CONFIRMED</option></select></div></div></div></div><div class=\"action-bar\"><span data-ng-if=\"vm.waitOnCReatingReport\" class=\"status-message waitOnCReatingReport\">{{\'reportExport.creatinReportInProgress\' | translate}} </span><span data-ng-if=\"vm.reportCreatedAndDownload\" class=\"status-message reportCreated\">{{\'reportExport.reportCreatedAndDownload\' | translate}}. <a class=\"link\" href=\"{{vm.downloadlink}}\">لینک دانلود فایل گزارش </a></span><span data-ng-if=\"vm.errorOnCreatingReport\" class=\"status-message errorOnCReatingReport\">{{\'reportExport.reportHasNoRecord\' | translate}} </span><button type=\"button\" data-ng-click=\"vm.confirm()\" class=\"btn btn-success\">{{\'reportExport.confirmAndDownload\' | translate}} <i class=\"fa fa-download\"></i></button> <button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"btn btn-danger\">{{\'reportExport.cancel\' | translate}} <i class=\"fa fa-close\"></i></button></div>");
$templateCache.put("app/reports/province_branch_service_date_count/province_branch_service_date_count.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterBranch\" for=\"field_branch\">ServiceItem</label><select class=\"form-control\" id=\"field_branch\" name=\"field_branch\" ng-model=\"vm.selectedCompanyId\" ng-options=\"c.id as c.title for c in vm.childCompanies\"></select></div></div></div></div><div class=\"action-bar\"><eo-generic-report do-before-export=\"vm.doBeforeExport\"></eo-generic-report><eo-button label=\"{{\'reportExport.cancel\' | translate}}\" icon=\"close\" on-click=\"vm.cancel()\" theme=\"accent\"></eo-button></div>");
$templateCache.put("app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\" for=\"field_serviceItem\">ServiceItem</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.serviceItemId\" required eo-required=\"\" ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in vm.serviceItems\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.orderBagStatus\" id=\"field_status\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\"></option><option value=\"1\" translate=\"tikonApp.orderBag.status.1\">CONFIRMED</option><option value=\"4\" translate=\"tikonApp.orderBag.status.4\">CANCELED</option><option value=\"5\" translate=\"tikonApp.orderBag.status.5\">RESERVE_REQUEST</option><option value=\"6\" translate=\"tikonApp.orderBag.status.6\">REQUEST_CONFIRMED</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterQuery\" for=\"field_query\">Query</label><input type=\"text\" class=\"form-control\" name=\"query\" id=\"field_query\" ng-model=\"vm.query\"></div></div></div></div><div class=\"action-bar\"><!--<div class=\"row\">--><!--<div class=\"col-md-7\">--><!--</div>--><!--<div class=\"col-md-5\">--><eo-generic-report do-before-export=\"vm.doBeforeExport\"></eo-generic-report><eo-button label=\"{{\'reportExport.cancel\' | translate}}\" icon=\"close\" on-click=\"vm.cancel()\" theme=\"accent\"></eo-button><!--</div>--><!--<div class=\"col-md-2\">--><!--<eo-button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"md-raised\">--><!--{{\'reportExport.cancel\' | translate}}--><!--<i class=\"fa fa-close\"></i>--><!--</eo-button>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/reports/reserve_list_summary_report/reserve_list_summary_report.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\" for=\"field_serviceItem\">ServiceItem</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.serviceItemId\" required eo-required=\"\" ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in vm.serviceItems\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.orderBagStatus\" id=\"field_status\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\"></option><option value=\"1\" translate=\"tikonApp.orderBag.status.1\">CONFIRMED</option><option value=\"4\" translate=\"tikonApp.orderBag.status.4\">CANCELED</option><option value=\"5\" translate=\"tikonApp.orderBag.status.5\">RESERVE_REQUEST</option><option value=\"6\" translate=\"tikonApp.orderBag.status.6\">REQUEST_CONFIRMED</option></select></div></div></div></div><div class=\"action-bar\"><!--<div class=\"row\">--><!--<div class=\"col-md-7\">--><!--</div>--><!--<div class=\"col-md-5\">--><eo-generic-report do-before-export=\"vm.doBeforeExport\"></eo-generic-report><eo-button label=\"{{\'reportExport.cancel\' | translate}}\" icon=\"close\" on-click=\"vm.cancel()\" theme=\"accent\"></eo-button><!--</div>--><!--<div class=\"col-md-2\">--><!--<eo-button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"md-raised\">--><!--{{\'reportExport.cancel\' | translate}}--><!--<i class=\"fa fa-close\"></i>--><!--</eo-button>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/reports/reserve_list_summary_with_payment_report/reserve_list_summary_with_payment_report.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterServiceItem\" for=\"field_serviceItem\">ServiceItem</label><select class=\"form-control\" id=\"field_serviceItem\" name=\"serviceItem\" ng-model=\"vm.serviceItemId\" required eo-required=\"\" ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in vm.serviceItems\"></select></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterStatus\" for=\"field_status\">Status</label><select class=\"form-control\" name=\"status\" ng-model=\"vm.orderBagStatus\" id=\"field_status\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.showAll\"></option><option value=\"1\" translate=\"tikonApp.orderBag.status.1\">CONFIRMED</option><option value=\"4\" translate=\"tikonApp.orderBag.status.4\">CANCELED</option><option value=\"5\" translate=\"tikonApp.orderBag.status.5\">RESERVE_REQUEST</option><option value=\"6\" translate=\"tikonApp.orderBag.status.6\">REQUEST_CONFIRMED</option></select></div></div></div></div><div class=\"action-bar\"><!--<div class=\"row\">--><!--<div class=\"col-md-7\">--><!--</div>--><!--<div class=\"col-md-5\">--><eo-generic-report do-before-export=\"vm.doBeforeExport\"></eo-generic-report><eo-button label=\"{{\'reportExport.cancel\' | translate}}\" icon=\"close\" on-click=\"vm.cancel()\" theme=\"accent\"></eo-button><!--</div>--><!--<div class=\"col-md-2\">--><!--<eo-button type=\"button\" data-ng-click=\"vm.cancel()\" class=\"md-raised\">--><!--{{\'reportExport.cancel\' | translate}}--><!--<i class=\"fa fa-close\"></i>--><!--</eo-button>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/reports/sum_of_reserve_count/sum_of_reserve_count.html","<style>.parameters {\n        padding: 21px;\n        margin: 10px;\n        min-height: 300px;\n    }\n\n    .action-bar {\n        border-top: solid 1px #eee;\n        text-align: left;\n        padding: 10px;\n    }\n\n    .status-message {\n        text-align: right;\n        font-size: 14px;\n        float: right;\n    }\n\n    .waitOnCReatingReport {\n        color: orange;\n    }\n\n    .errorOnCReatingReport {\n        color: #ff552b;\n    }\n\n    .reportCreated {\n        color: #00AA00;\n    }</style><!--ver2--><jhi-alert></jhi-alert><div class=\"parameters\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.fromDate\">fromDateFilter</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.fromDateFilter\"></eo-date-picker></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBag.toDate\">toDateFilter</label><eo-date-picker id=\"field_toDateFilter\" date-value=\"vm.toDateFilter\"></eo-date-picker></div></div></div><!--...--><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.filterBranch\" for=\"field_branch\">ServiceItem</label><select class=\"form-control\" id=\"field_branch\" name=\"field_branch\" ng-model=\"vm.selectedCompanyId\" ng-options=\"c.id as c.title for c in vm.childCompanies\"></select></div></div></div></div><div class=\"action-bar\"><eo-generic-report do-before-export=\"vm.doBeforeExport\"></eo-generic-report><eo-button label=\"{{\'reportExport.cancel\' | translate}}\" icon=\"close\" on-click=\"vm.cancel()\" theme=\"accent\"></eo-button></div>");
$templateCache.put("app/services/testServices/admin-test-services.html","<jhi-alert-error></jhi-alert-error><button type=\"button\" ui-sref=\"package-feature-list\" class=\"btn btn-primary btn-sm\">امکانات ویژه کسب و کار</button> <button type=\"button\" ng-click=\"vm.sendAutomaticMarketingCampaign()\" class=\"btn btn-primary btn-sm\">تست کمپین</button> <button type=\"button\" ng-click=\"vm.testCalculateCommission()\" class=\"btn btn-primary btn-sm\">تست کمیسیون</button> <button type=\"button\" ng-click=\"vm.sendTestSMS()\" class=\"btn btn-primary btn-sm\">ارسال پیامک تست</button> <button type=\"button\" ng-click=\"vm.sendTestAutomaticSubscriptionNearToExpireNotification()\" class=\"btn btn-primary btn-sm\">ارسال پیام در حال اتمام اشتراک (اتوماتیک)</button> <button type=\"button\" ng-click=\"vm.testSmsNearFinish()\" class=\"btn btn-primary btn-sm\">ارسال در حال اتمام پیامک</button> <button type=\"button\" ng-click=\"vm.sendTestAutomaticApproveReserveRequest()\" class=\"btn btn-primary btn-sm\">تایید اتوماتیک درخواستهای رزرو</button> <button type=\"button\" ng-click=\"vm.sendRebookNotification()\" class=\"btn btn-primary btn-sm\">ارسال rebook</button> <button type=\"button\" ng-click=\"vm.addSampleGtag()\" class=\"btn btn-primary btn-sm\">add Gtag</button> <button type=\"button\" ng-click=\"vm.sendAllSatisfactionNotification()\" class=\"btn btn-primary btn-sm\">ارسال تمامی نظرسنجی ها</button> <button type=\"button\" ng-click=\"vm.cancelAllExpireTwoStepReserve()\" class=\"btn btn-primary btn-sm\">Cancel All Expire Two Step</button><!--<button type=\"button\"--><!--ng-click=\"vm.testIcal()\"--><!--class=\"btn btn-primary btn-sm\"--><!--&gt;--><!--ICal Test--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.testToast()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Toast--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.getServantByMarketPlaceFilter()\"--><!--class=\"btn btn-primary btn-sm\">--><!--MarkerPlaceFilter--><!--</button>--><!--{{vm.marketPlaceServants}}--><!--<button type=\"button\"--><!--ng-click=\"vm.testReminder()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Test Reminder--><!--</button>--> <button type=\"button\" ng-click=\"vm.sendTestEmail()\" class=\"btn btn-primary btn-sm\">send TestEmail</button><jhi-alert></jhi-alert><!--<button type=\"button\"--><!--ng-click=\"vm.finalApproveOrderBagById()\"--><!--class=\"btn btn-primary btn-sm\">--><!--final approve orderbag--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.testSubscriptionNearToExpire()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Subscription Near To Expire--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.testUpdateExpireCompanyStatus()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Update Expire Company Status--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.insertNewConversation()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Insert New Conversation--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.insertNewMessage()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Insert New Message--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.exportOrderBagToExcel()\"--><!--class=\"btn btn-primary btn-sm\">--><!--Export OrderItem to Excel--><!--</button>--><fieldset class=\"standard-fieldset\"><legend>پیامک Rebook</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId_rebook\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId_rebook\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendRebookSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک نظرسنجی</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestCustomerSatisfactionSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک رزرو مشتری</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagsId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagsId\" id=\"field_orderBagsId\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestReservationConfirmedInfoMsg()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک یادآوری</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId_1\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestCustomerFirstReminderSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک یادآوری دوم</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId_12\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestCustomerSecondReminderSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>ارسال پیام در حال اتمام بسته پیامکی</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_keyUrl\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"keyUrl\" id=\"field_keyUrl\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestSMSPackageGoingToFinish()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>ارسال پیام اتمام بسته پیامکی</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_keyUrl_2\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"keyUrl_2\" id=\"field_keyUrl_2\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestSMSPackageFinished()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>ارسال پیام درحال اتمام اشتراک</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_keyUrl_3\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"keyUrl_3\" id=\"field_keyUrl_3\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestSubscriptionNearToExpireNotification()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>ارسال پیام اتمام اشتراک</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_keyUrl_4\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"keyUrl_4\" id=\"field_keyUrl_4\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestSubscriptionIsExpiredNotification()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>افزایش اشتراک کسب و کار</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_companyKeyUrl\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" id=\"field_companyKeyUrl\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_Days\">Days</label></div><div class=\"col-md-1\"><input type=\"number\" class=\"form-control\" name=\"field_Days\" id=\"field_Days\" ng-model=\"vm.daysToAdd\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.addDaysToSubscriptionByCompany()\" class=\"md-raised md-primary\"><span>اضافه به اشتراک</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>اضافه کردن بسته پیامکی رایگان</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_companyKeyUrl\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" ng-model=\"vm.smsPckCompanyUrl\"></div><div class=\"col-md-1\"><label class=\"control-label\">تاریخ شروع</label></div><div class=\"col-md-1\"><input class=\"form-control\" ng-model=\"vm.smsPckStartDate\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.addFreeSMSPackage()\" class=\"md-raised md-primary\"><span>اضافه کردن بسته پیامکی رایگان</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>اضافه کردن بسته پیامکی</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_companyKeyUrl\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" ng-model=\"vm.smsPckCompanyUrl\"></div><div class=\"col-md-1\"><md-select class=\"rwMdSelect\" ng-model=\"vm.selectedSMSPackage\" style=\"min-width: 100px\"><!--<md-option value=\"0\">--><!--<span translate=\"tikonApp.orderBagServiceItem.showAll\"></span>--><!--</md-option>--><md-option ng-value=\"si.id\" ng-repeat=\"si in vm.smsPackages\">{{si.title}}</md-option></md-select></div><div class=\"col-md-1\"><input class=\"form-control\" ng-model=\"vm.smsPckStartDate\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.addCustomSMSPackage()\" class=\"md-raised md-primary\"><span>اضافه کردن بسته پیامکی</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>ساخت یوزر برای پرسنل</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_servantPhoneNumber\">شماره موبایل</label></div><div class=\"col-md-3\"><input type=\"text\" id=\"field_servantPhoneNumber\" class=\"form-control\" name=\"servantPhoneNumber\" ng-model=\"vm.servantPhoneNumber\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.createUserAccessForServantByPhoneNumber()\" class=\"md-raised md-primary\"><span>ساخت یوزر پرسنل</span></md-button></div></div><!--content here --></fieldset><div><fieldset class=\"standard-fieldset\"><legend>تست فعال شدن فیچر</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_companySubsID\">CompanySubscriptionID></label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"companySubsID\" id=\"field_companySubsID\" ng-model=\"vm.companySubsID\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.setFeatureByCompanySubscriptionId()\" class=\"md-raised md-primary\"><span>درج فیچر</span></md-button></div></div><!--content here --></fieldset></div><fieldset class=\"standard-fieldset\"><legend>پیامک خوش آمد گویی شماره 1</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_phoneNumber1\">phoneNumber</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" id=\"field_phoneNumber1\" ng-model=\"vm.phoneNumber\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestSupplierFirstJourneyNotification()\" class=\"md-raised md-primary\"><span>ارسال</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>افزایش اشتراک کسب و کار (تامین)</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_category\">category</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"category\" id=\"field_category\" ng-model=\"vm.category\"></div><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_Days_2\">Days</label></div><div class=\"col-md-1\"><input type=\"number\" class=\"form-control\" name=\"field_Days\" id=\"field_Days_2\" ng-model=\"vm.daysToAdd\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.addDaysToSubscriptionByCompaniesCategory()\" class=\"md-raised md-primary\"><span>اضافه به اشتراک</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>ارسال پیامک تست</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_phoneNumber\">شماره موبایل</label></div><div class=\"col-md-2\"><input type=\"text\" id=\"field_phoneNumber\" class=\"form-control\" name=\"phoneNumber\" ng-model=\"vm.phoneNumber\"></div><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_keyUrlSMS\">key_url</label></div><div class=\"col-md-2\"><input type=\"text\" id=\"field_keyUrlSMS\" class=\"form-control\" name=\"keyUrlSMS\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestSMS()\" class=\"md-raised md-primary\"><span>ارسال پیامک</span></md-button></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendVerificationTestSMS()\" class=\"md-raised md-primary\"><span>ارسال پیامک اعتبارسنجی</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>بستن دسترسی کسب و کار</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_keyUrl_5\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"keyUrl_5\" id=\"field_keyUrl_5\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.deActiveCompany()\" class=\"md-raised md-primary\"><span>بستن دسترسی</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>کمپانی هایی که 2 روز به اتمام اشتراک مانده است</legend><div><md-button ng-click=\"vm.getCompaniesSubscriptionNearToExpire()\" class=\"md-raised md-primary\">دریافت لیست</md-button><md-button ng-click=\"vm.testSubscriptionNearToExpire()\" class=\"md-raised md-primary\">ارسال پیام اتمام اشتراک</md-button></div></fieldset><hr><div></div><div><button type=\"button\" ng-click=\"vm.testUpdateExpireCompanyStatus()\" class=\"btn btn-primary btn-sm\">Update Expire Company Status</button></div><h1>Reserweb Api Test</h1><hr><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\">تعداد مدیر کمپانی</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"recordCount\" ng-model=\"vm.recordCount\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.getTopNCompanyManager()\" class=\"md-raised md-primary\"><span>دریافت آخرین مدیران کمپانی</span></md-button></div></div><div ng-value=\"si.id\" ng-repeat=\"si in vm.companyManagers\">{{si.id}}</div><!--<button type=\"button\"--><!--ng-click=\"vm.getServiceAvailableDatesInNextDays()\"--><!--class=\"btn btn-primary btn-sm\">--><!--getServiceAvailableDatesInNextDays--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.getServiceAvailableTimesInOneDate()\"--><!--class=\"btn btn-primary btn-sm\">--><!--getServiceAvailableTimesInOneDate--><!--</button>--> <button type=\"button\" ng-click=\"vm.getToken()\" class=\"btn btn-primary btn-sm\">getToken</button> <button type=\"button\" ng-click=\"vm.getReserveListByCustomer()\" class=\"btn btn-primary btn-sm\">API getReserveListByCustomer</button> <button type=\"button\" ng-click=\"vm.getCustomerByMobileNumber()\" class=\"btn btn-primary btn-sm\">getCustomerByMobileNumber</button> <button type=\"button\" ng-click=\"vm.addTaminBranch()\" class=\"btn btn-primary btn-sm\"><stong>ADD NEW TAMIN BRANCH</stong></button><br><br><input type=\"text\" class=\"form-control\" ng-model=\"vm.branchlist\"> <button type=\"button\" ng-click=\"vm.addmultiplebranch()\" class=\"btn btn-primary btn-sm\"><stong>ADD MULTI BRANCH</stong></button> <input type=\"text\" class=\"form-control\" ng-model=\"vm.locationlist\"> <button type=\"button\" ng-click=\"vm.addLocationList()\" class=\"btn btn-primary btn-sm\"><stong>ADD COMPANY LOCATION FROM LIST</stong></button><div name=\"result\">{{vm.serviceCategories}} {{ vm.serviceItems }} {{vm.serviceCategory}} {{ vm.serviceItem }} {{vm.serviceTimeSessions}} {{vm.serviceTimeSessionTimes}} {{vm.priceInfoDtails}} {{vm.serviceItemOptions}} {{vm.serviceTimeSession}}<!--{{vm.company}}--> {{vm.imageData}} {{vm.orderBagVM}} {{vm.imageList}} {{vm.conversation}}<h4>Response</h4><hr>{{vm.message}}<h4>Body</h4><hr>{{vm.result}}</div><div id=\"addBatchCustomer\"><div>ترتیب فیلدهای اکسل : firstName ,lastName ,phoneNumber ,email ,nationalCode ,address</div><div style=\"color: red\">** حتما در کمپانی مورد نظر لاگین شود بعد این بخش استفاده شود | مشتریان در کمپانی جاری اضافه می شوند</div><div>فایل اکسل توسط ابزار های آنلاین به json تبدیل شود convert excel to json</div><input type=\"text\" class=\"form-control\" ng-model=\"vm.batchCompanyCustomer\"> <button type=\"button\" ng-click=\"vm.addBatchCompanyCustomer()\" class=\"btn btn-primary btn-sm\"><stong>درج گروهی مشتریان</stong></button></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><select class=\"rwMdSelect plSelect\" ng-model=\"vm.selectedItem\" id=\"field_select1\" ng-options=\"si.name for si in vm.selectItems track by si.id\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><select class=\"\" ng-model=\"vm.selectedItem\" id=\"field_select2\" ng-options=\"si.name for si in vm.selectItems track by si.id\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><select name=\"singleSelect\" ng-model=\"vm.singleSelect\"><option value=\"option-1\">Option 1</option><option value=\"option-2\">Option 2</option></select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><select name=\"singleSelect\" ng-model=\"vm.singleSelect\"><option value=\"option-1\">Option 1</option><option value=\"option-2\">Option 2</option></select></div></div><div id=\"addBatchInvoiceInfo\"><div>ترتیب فیلدهای اکسل : fullName ,phoneNumber ,invoiceNo ,invoiceDateTimeStr ,itemTitle , serviceItemId ,comment ,finalPrice , discount , payedAmount</div><div style=\"color: red\">** حتما در کمپانی مورد نظر لاگین شود بعد این بخش استفاده شود | فاکتورها در کمپانی جاری اضافه می شوند</div><div>فایل اکسل توسط ابزار های آنلاین به json تبدیل شود convert excel to json</div><input type=\"text\" class=\"form-control\" ng-model=\"vm.batchInvoiceInfo\"> <button type=\"button\" ng-click=\"vm.addBatchInvoiceInfo()\" class=\"btn btn-primary btn-sm\"><stong>درج گروهی فاکتور فروش</stong></button></div><!--<div id=\"demo-basic\"> </div>--><!--<script>--><!--var el = document.getElementById(\'demo-basic\');--><!--var vanilla = new Croppie(el, {--><!--viewport: { width: 100, height: 100 },--><!--boundary: { width: 300, height: 300 },--><!--showZoomer: true,--><!--enableOrientation: true--><!--});--><!--debugger;--><!--vanilla.bind({--><!--url: \'/content/images/home_slide1.jpg\',--><!--zoom:0.5--><!--});--><!--// vanilla.setZoom(0.5);--> <!--</script>-->");
$templateCache.put("app/services/testServices/test-services.html","<jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div has-authority=\"ROLE_SUPER_ADMIN_ADVANCED_ACCESS\"><button type=\"button\" ng-click=\"vm.sendTestEmail()\" class=\"btn btn-primary btn-sm\">send TestEmail</button><fieldset class=\"standard-fieldset\"><legend>تست ارسال پنل پیامکی</legend><div class=\"row\"><div class=\"col-md-2\"><label class=\"control-label\" for=\"field_marketingCampaignId\">marketingCampaignId</label></div><div class=\"col-md-3\"><input type=\"text\" id=\"field_marketingCampaignId\" class=\"form-control\" name=\"marketingCampaignId\" ng-model=\"vm.marketingCampaignId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendMarketingCampaign()\" class=\"md-raised md-primary\"><span>ارسال</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک نظرسنجی</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestCustomerSatisfactionSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک رزرو مشتری</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagsId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagsId\" id=\"field_orderBagsId\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestReservationConfirmedInfoMsg()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک یادآوری</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId_1\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestCustomerFirstReminderSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>پیامک یادآوری دوم</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_orderBagId\">OrderBagID</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"orderBagId\" id=\"field_orderBagId_12\" ng-model=\"vm.orderBagId\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.sendTestCustomerSecondReminderSMS()\" class=\"md-raised md-primary\"><span>Send</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>افزایش اشتراک کسب و کار</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_companyKeyUrl\">KeyUrl</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"companyKeyUrl\" id=\"field_companyKeyUrl\" ng-model=\"vm.companyKeyUrl\"></div><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_Days\">Days</label></div><div class=\"col-md-1\"><input type=\"number\" class=\"form-control\" name=\"field_Days\" id=\"field_Days\" ng-model=\"vm.daysToAdd\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.addDaysToSubscriptionByCompany()\" class=\"md-raised md-primary\"><span>اضافه به اشتراک</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>حذف شماره موبایل از سیستم</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_phoneNumber\">phone Number</label></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" id=\"field_phoneNumber\" ng-model=\"vm.phoneNumber\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.removePhoneNumber()\" class=\"md-raised md-primary\"><span>حذف</span></md-button></div></div><!--content here --></fieldset></div><fieldset class=\"standard-fieldset\"><legend>ساخت یوزر برای پرسنل</legend><div class=\"row\"><div class=\"col-md-1\"><label class=\"control-label\" for=\"field_servantPhoneNumber\">شماره موبایل</label></div><div class=\"col-md-3\"><input type=\"text\" id=\"field_servantPhoneNumber\" class=\"form-control\" name=\"servantPhoneNumber\" ng-model=\"vm.servantPhoneNumber\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.createUserAccessForServantByPhoneNumber()\" class=\"md-raised md-primary\"><span>ساخت یوزر پرسنل</span></md-button></div></div><!--content here --></fieldset><fieldset class=\"standard-fieldset\"><legend>مرج کردن مشتریان با شماره های یکسان</legend><div class=\"row\"><div class=\"col-md-2\"><label class=\"control-label\" for=\"field_companyCustomersId\">companyCutomersId</label></div><div class=\"col-md-3\"><input type=\"text\" id=\"field_companyCustomersId\" class=\"form-control\" name=\"companyCustomersId\" ng-model=\"vm.companyCustomerIds\"></div><div class=\"col-md-3\"><md-button ng-click=\"vm.mergeCompanyCustomers()\" class=\"md-raised md-primary\"><span>ادغام</span></md-button></div></div><!--content here --></fieldset><!--<button type=\"button\"--><!--ng-click=\"vm.getServiceAvailableDatesInNextDays()\"--><!--class=\"btn btn-primary btn-sm\">--><!--getServiceAvailableDatesInNextDays--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"vm.getServiceAvailableTimesInOneDate()\"--><!--class=\"btn btn-primary btn-sm\">--><!--getServiceAvailableTimesInOneDate--><!--</button>--><div id=\"addBatchCustomer\"><div>ترتیب فیلدهای اکسل : firstName ,lastName ,phoneNumber ,email ,nationalCode ,address</div><div style=\"color: red\">** حتما در کمپانی مورد نظر لاگین شود بعد این بخش استفاده شود | مشتریان در کمپانی جاری اضافه می شوند</div><div>فایل اکسل توسط ابزار های آنلاین به json تبدیل شود convert excel to json</div><input type=\"text\" class=\"form-control\" ng-model=\"vm.batchCompanyCustomer\"> <button type=\"button\" ng-click=\"vm.addBatchCompanyCustomer()\" class=\"btn btn-primary btn-sm\"><stong>درج گروهی مشتریان</stong></button></div><div id=\"addBatchInvoiceInfo\"><div>ترتیب فیلدهای اکسل : fullName ,phoneNumber ,invoiceNo ,invoiceDateTimeStr ,itemTitle , serviceItemId ,comment ,finalPrice , discount , payedAmount</div><div style=\"color: red\">** حتما در کمپانی مورد نظر لاگین شود بعد این بخش استفاده شود | فاکتورها در کمپانی جاری اضافه می شوند</div><div>فایل اکسل توسط ابزار های آنلاین به json تبدیل شود convert excel to json</div><input type=\"text\" class=\"form-control\" ng-model=\"vm.batchInvoiceInfo\"> <button type=\"button\" ng-click=\"vm.addBatchInvoiceInfo()\" class=\"btn btn-primary btn-sm\"><stong>درج گروهی فاکتور فروش</stong></button></div><fieldset class=\"standard-fieldset\"><legend>فرم های جدید</legend><div style=\"display: flex; justify-content: flex-start; align-items: center; flex-wrap: wrap\"><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.calendar-v2\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>تقویم</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.companyApprovalPaymentLogListV2\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>لیست تاییده تراکنش ها</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.companyBankAccountInfoV2\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>kyc</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.companyBlogs\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>بلاگ</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.baseComponentsShowCase\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>components showcase</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.reserveServices\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>services list</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.eventServices\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>event list</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.serviceCategories\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>services categories</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.metaTags\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>meta tags</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.formBuilder\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>form builder</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.companyBlogCategories\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>blog categories</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.coupons\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>coupons</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.reports\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>reports</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.reserveLimits\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>reserve limits</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.dynamicRules\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>dynamic rules</stong></button></a></div><div class=\"mx-5\"><a ui-sref=\"supplierPanel-v2.invoicePrint\"><button type=\"button\" class=\"btn btn-primary btn-sm\"><stong>print invoice</stong></button></a></div></div><!--content here --></fieldset><!--<div id=\"demo-basic\"> </div>--><!--<script>--><!--var el = document.getElementById(\'demo-basic\');--><!--var vanilla = new Croppie(el, {--><!--viewport: { width: 100, height: 100 },--><!--boundary: { width: 300, height: 300 },--><!--showZoomer: true,--><!--enableOrientation: true--><!--});--><!--debugger;--><!--vanilla.bind({--><!--url: \'/content/images/home_slide1.jpg\',--><!--zoom:0.5--><!--});--><!--// vanilla.setZoom(0.5);--> <!--</script>-->");
$templateCache.put("app/wizards/init-setup/init-setup.html","<style>.step-container {\n        width: 95%;\n        background-color: #ffffff;\n        min-height: 450px;\n\n        margin: 50px auto auto;\n        padding: 30px\n    }\n\n    .step-content {\n        min-height: 300px;\n        overflow: hidden;\n    }\n\n    .step-footer {\n        text-align: center;\n        width: 350px;\n        margin: auto;\n    }\n\n    .next-step-button {\n        float: left;\n        width: 45%;\n    }\n\n    .prev-step-button {\n        float: right;\n        width: 45%;\n    }\n\n    .step-header {\n        text-align: center;\n\n    }\n\n    .step-header .fa {\n        padding: 10px;\n        margin: 5px;\n    }</style><div class=\"\"><eo-progress-bar></eo-progress-bar><wizard on-finish=\"finishedWizard()\" indicators-position=\"top\" on-cancel=\"cancelledWizard()\"><wz-step wz-title=\"{{\'wizard.initsetup.step1\' | translate}}\"><div class=\"step-container\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"step-header\"><h3><i class=\"fa fa-building-o fa-2x\" style=\"color: #00b6ff\"></i><div style=\"color: grey\">مشخصات کسب و کار</div></h3></div></div><div class=\"col-md-10\"><div class=\"step-content wizard-steps-box\"><wzf-company-info company=\"vm.wizardData.company\" is-form-valid=\"vm.setCompanyInfoValid\"></wzf-company-info></div></div></div><hr><div class=\"step-footer\"><button type=\"button\" ng-disabled=\"!vm.isCompanyInfoValid\" ng-click=\"vm.nextFromStep()\" class=\"btn btn-info next-step-button\" type=\"button\" style=\"text-align: center\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></button><!--<button class=\"btn btn-success\" type=\"button\"  >--><!--<span translate=\"wizard.initsetup.save-step\"></span>--><!--<i class=\"glyphicon glyphicon-save\" >--><!--</i>--><!--</button>--><!--<button class=\"btn btn-primary prev-step-button \"  type=\"button\" ng-click=\"vm.prevFromStep()\" >--><!--<i class=\"glyphicon glyphicon-arrow-right\" ></i>--><!--</button>--></div></div></wz-step><wz-step wz-title=\"{{\'wizard.initsetup.step2\' | translate}}\"><div class=\"step-container\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"step-header\"><h3><i class=\"fa fa-clock-o fa-2x\" style=\"color: #00b6ff\"></i><div style=\"color: grey\">ساعت کاری</div></h3></div></div><div class=\"col-md-10\"><div class=\"step-content wizard-steps-box\"><wzf-company-schedule schedule=\"vm.wizardData.schedule\" is-form-valid=\"vm.setScheduleInfoValid\"></wzf-company-schedule></div></div></div><hr><div class=\"step-footer\"><button type=\"button\" ng-disabled=\"!vm.isScheduleInfoValid\" ng-click=\"vm.nextFromStep()\" class=\"btn btn-info next-step-button\" type=\"button\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></button><!--<button class=\"btn btn-success\" type=\"button\"  >--><!--<span translate=\"wizard.initsetup.save-step\"></span>--><!--<i class=\"glyphicon glyphicon-save\" >--><!--</i>--> <button class=\"btn btn-info prev-step-button\" type=\"button\" ng-click=\"vm.prevFromStep()\"><i class=\"glyphicon glyphicon-arrow-right\"></i> <span translate=\"wizard.back\"></span></button></div></div></wz-step><wz-step wz-title=\"{{\'wizard.initsetup.step3\' | translate}}\"><div class=\"step-container\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"step-header\"><h3><i class=\"fa fa-briefcase fa-2x\" style=\"color: #00b6ff\"></i><div style=\"color: grey\">تعریف سرویس یا خدمت</div></h3></div></div><div class=\"col-md-10\"><div class=\"step-content wizard-steps-box\"><wzf-service-item service-item=\"vm.wizardData.serviceItem\" is-form-valid=\"vm.setServiceItemValid\" servant=\"vm.wizardData.newServant\" company-activity-type=\"vm.wizardData.company.activityType\"></wzf-service-item></div></div></div><hr><div class=\"step-footer\"><button type=\"button\" ng-disabled=\"!vm.isServiceItemValid || vm.isBusy\" ng-click=\"vm.nextFromStep()\" class=\"btn btn-info next-step-button\" type=\"button\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></button><!--<button class=\"btn btn-success\" type=\"button\"  >--><!--<span translate=\"wizard.initsetup.save-step\"></span>--><!--<i class=\"glyphicon glyphicon-save\" >--><!--</i>--> <button class=\"btn btn-info prev-step-button\" type=\"button\" ng-click=\"vm.prevFromStep()\"><i class=\"glyphicon glyphicon-arrow-right\"></i> <span translate=\"wizard.back\"></span></button></div></div></wz-step><wz-step wz-title=\"{{\'wizard.initsetup.step4\' | translate}}\"><div class=\"step-container\"><div class=\"step-header\"></div><h3 style=\"color: #32a2bd; text-align: center\"></h3><div class=\"step-footer\"><button ui-sref=\"supplierPanel.dashboard\" class=\"btn btn-primary btn-xl\" style=\"text-align: center; width: 70%\" type=\"button\" translate=\"wizard.finish\"></button></div><hr><div class=\"step-content\"><wzf-last-step wizard-data=\"vm.wizardData\"></wzf-last-step></div></div></wz-step></wizard></div><!--<script>$crisp.push([\'do\', \'chat:open\']);</script>-->");
$templateCache.put("app/wizards/init-setup-event/init-setup-event.html","<style>.step-container {\n        width: 95%;\n        background-color: #ffffff;\n        min-height: 450px;\n\n        margin: 50px auto auto;\n        padding: 30px\n    }\n\n    .step-content {\n        min-height: 300px;\n        overflow: hidden;\n    }\n\n    .step-footer {\n        text-align: center;\n        width: 350px;\n        margin: auto;\n    }\n\n    .next-step-button {\n        float: left;\n        width: 45%;\n    }\n\n    .prev-step-button {\n        float: right;\n        width: 45%;\n    }\n\n    .step-header {\n        text-align: center;\n\n    }\n\n    .step-header .fa {\n        padding: 10px;\n        margin: 5px;\n    }</style><div class=\"\"><eo-progress-bar></eo-progress-bar><wizard on-finish=\"finishedWizard()\" indicators-position=\"top\" on-cancel=\"cancelledWizard()\"><wz-step wz-title=\"{{\'wizard.initsetup.step1\' | translate}}\"><div class=\"step-container\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"step-header\"><h3><i class=\"fa fa-building-o fa-2x\" style=\"color: #00b6ff\"></i><div style=\"color: grey;font-size: 20px\">مشخصات کسب و کار</div></h3></div></div><div class=\"col-md-10\"><div class=\"step-content wizard-steps-box\"><wzf-company-info company=\"vm.wizardData.company\" is-form-valid=\"vm.setCompanyInfoValid\"></wzf-company-info></div></div></div><hr><div class=\"step-footer\"><button type=\"button\" ng-disabled=\"!vm.isCompanyInfoValid\" ng-click=\"vm.nextFromStep()\" class=\"btn btn-info next-step-button\" type=\"button\" style=\"text-align: center\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></button><!--<button class=\"btn btn-success\" type=\"button\"  >--><!--<span translate=\"wizard.initsetup.save-step\"></span>--><!--<i class=\"glyphicon glyphicon-save\" >--><!--</i>--><!--</button>--><!--<button class=\"btn btn-primary prev-step-button \"  type=\"button\" ng-click=\"vm.prevFromStep()\" >--><!--<i class=\"glyphicon glyphicon-arrow-right\" ></i>--><!--</button>--></div></div></wz-step><!--<wz-step wz-title=\"{{\'wizard.initsetup.step2\' | translate}}\">--><!--<div class=\"step-container\">--><!--<div class=\"row\">--><!--<div class=\"col-md-2\">--><!--<div class=\"step-header\">--><!--<h3>--><!--<i class=\"fa fa-clock-o fa-2x\" style=\"color: #00b6ff\"></i>--><!--<div style=\"color: grey\">--><!--ساعت کاری--><!--</div>--><!--</h3>--><!--</div>--><!--</div>--><!--<div class=\"col-md-10\">--><!--<div class=\"step-content  wizard-steps-box\">--><!--<wzf-company-schedule schedule=\"vm.wizardData.schedule\"--><!--is-form-valid=\"vm.setScheduleInfoValid\"></wzf-company-schedule>--><!--</div>--><!--</div>--><!--</div>--><!--<hr>--><!--<div class=\"step-footer\">--><!--<button type=\"button\" ng-disabled=\"!vm.isScheduleInfoValid\" ng-click=\"vm.nextFromStep()\"--><!--class=\"btn btn-info next-step-button \" type=\"button\">--><!--<span translate=\"wizard.continue\"></span>--><!--<i class=\"glyphicon glyphicon-arrow-left\"></i>--><!--</button>--><!--&lt;!&ndash;<button class=\"btn btn-success\" type=\"button\"  >&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"wizard.initsetup.save-step\"></span>&ndash;&gt;--><!--&lt;!&ndash;<i class=\"glyphicon glyphicon-save\" >&ndash;&gt;--><!--&lt;!&ndash;</i>&ndash;&gt;--><!--</button>--><!--<button class=\"btn btn-info prev-step-button \" type=\"button\"--><!--ng-click=\"vm.prevFromStep()\">--><!--<i class=\"glyphicon glyphicon-arrow-right\"></i>--><!--<span translate=\"wizard.back\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--</wz-step>--><!--<wz-step wz-title=\"{{\'wizard.initsetup.step3\' | translate}}\">--><!--<div class=\"step-container\">--><!--<div class=\"row\">--><!--<div class=\"col-md-2\">--><!--<div class=\"step-header\">--><!--<h3>--><!--<i class=\"fa fa-briefcase fa-2x\" style=\"color: #00b6ff\"></i>--><!--<div style=\"color: grey\">--><!--<span translate=\"wizard.serviceItem\">--><!--</span>--><!--</div>--><!--</h3>--><!--</div>--><!--</div>--><!--<div class=\"col-md-10\">--><!--<div class=\"step-content wizard-steps-box\">--><!--<wzf-service-item service-item=\"vm.wizardData.serviceItem\"--><!--is-form-valid=\"vm.setServiceItemValid\"--><!--servant=\"vm.wizardData.newServant\"--><!--company-activity-type=\"vm.wizardData.company.activityType\"--><!--&gt;</wzf-service-item>--><!--</div>--><!--</div>--><!--</div>--><!--<hr>--><!--<div class=\"step-footer\">--><!--<button  type=\"button\" ng-disabled=\"!vm.isServiceItemValid || vm.isBusy\"--><!--ng-click=\"vm.nextFromStep()\" class=\"btn btn-info next-step-button \" type=\"button\">--><!--<span translate=\"wizard.continue\"></span>--><!--<i class=\"glyphicon glyphicon-arrow-left\"></i>--><!--</button>--><!--&lt;!&ndash;<button class=\"btn btn-success\" type=\"button\"  >&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"wizard.initsetup.save-step\"></span>&ndash;&gt;--><!--&lt;!&ndash;<i class=\"glyphicon glyphicon-save\" >&ndash;&gt;--><!--&lt;!&ndash;</i>&ndash;&gt;--><!--</button>--><!--<button class=\"btn btn-info prev-step-button \" type=\"button\"--><!--ng-click=\"vm.prevFromStep()\">--><!--<i class=\"glyphicon glyphicon-arrow-right\"></i>--><!--<span translate=\"wizard.back\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--</wz-step>--><wz-step wz-title=\"{{\'wizard.initsetup.step4\' | translate}}\"><div class=\"step-container\"><div class=\"step-header\"></div><h3 style=\"color: #32a2bd; text-align: center\"><span translate=\"wizard.lastStepSystemReady\"></span></h3><div class=\"step-footer\"><button ui-sref=\"supplierPanel.dashboard\" class=\"btn btn-primary btn-xl\" style=\"text-align: center; width: 70%\" type=\"button\" translate=\"wizard.finish\"></button></div><hr><div class=\"step-content\"><wzf-last-step wizard-data=\"vm.wizardData\"></wzf-last-step></div></div></wz-step></wizard></div><!--<script>$crisp.push([\'do\', \'chat:open\']);</script>-->");
$templateCache.put("app/wizards/init-setup-v2/init-setup-v2.html","<style>.step-container {\n        width: 95%;\n        background-color: #ffffff;\n        min-height: 450px;\n\n        margin: 50px auto auto;\n        padding: 30px\n    }\n\n    .step-content {\n        min-height: 300px;\n        overflow: hidden;\n    }\n\n    .step-footer {\n        text-align: center;\n        width: 350px;\n        margin: auto;\n    }\n\n    .next-step-button {\n        float: left;\n        width: 45%;\n    }\n\n    .prev-step-button {\n        float: right;\n        width: 45%;\n    }\n\n    .step-header {\n        text-align: center;\n\n    }\n\n    .step-header .fa {\n        padding: 10px;\n        margin: 5px;\n    }</style><div class=\"\"><eo-progress-bar></eo-progress-bar><wizard class=\"pl-steps-indicator\" on-finish=\"finishedWizard()\" indicators-position=\"top\" on-cancel=\"cancelledWizard()\"><wz-step wz-title=\"{{vm.getStepTitle(1) | translate}}\"><div id=\"companyStep\" class=\"pl-step-container\"><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"step-header\"><h4><div style=\"color: black\">اطلاعات کسب و کار خود را وارد کنید</div></h4></div><div class=\"step-content wizard-steps-box-v2\"><wzf-company-info-v2 company=\"vm.wizardData.company\" user-insight=\"vm.userInsight\" is-form-valid=\"vm.setCompanyInfoValid\"></wzf-company-info-v2></div></div></div><div class=\"pl-modal-footer init-setup-footer\"><div class=\"\" style=\"display: flex;justify-content: center\"><md-button type=\"button\" ng-disabled=\"!vm.isCompanyInfoValid\" ng-click=\"vm.nextFromStep()\" class=\"pl-btn pl-btn-primary pl-btn-lg next-step-button\" type=\"button\" style=\"text-align: center;font-size: 18px\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></md-button></div></div></div></wz-step><wz-step wz-title=\"{{vm.getStepTitle(2) | translate}}\"><div id=\"scheduleStep\" class=\"pl-step-container\"><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"step-header\"><h4><div style=\"color: black\">ساعت کاری را تنظیم کنید</div></h4></div><div class=\"step-content wizard-steps-box-v2\"><wzf-company-schedule-v2 schedule=\"vm.wizardData.schedule\" is-form-valid=\"vm.setScheduleInfoValid\"></wzf-company-schedule-v2></div></div></div><div class=\"pl-modal-footer init-setup-footer\"><div class=\"\" style=\"display: flex;justify-content: center\"><md-button class=\"pl-btn pl-btn-default pl-btn-lg prev-step-button\" type=\"button\" style=\"color: #000\" ng-click=\"vm.prevFromStep()\"><i class=\"glyphicon glyphicon-arrow-right\"></i> <span translate=\"wizard.back\"></span></md-button><md-button type=\"button\" ng-click=\"vm.nextFromStep()\" class=\"pl-btn pl-btn-primary pl-btn-lg next-step-button\" type=\"button\" style=\"text-align: center;font-size: 18px\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></md-button></div></div></div></wz-step><wz-step wz-title=\"{{vm.getStepTitle(3) | translate}}\"><div id=\"serviceStep\" class=\"pl-step-container\"><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"step-header\"><h4><div style=\"color: black\">اولین خدمت را تعریف کنید</div></h4></div><div class=\"step-content wizard-steps-box-v2\"><wzf-service-item-v2 service-item=\"vm.wizardData.serviceItem\" is-form-valid=\"vm.setServiceItemValid\" servant=\"vm.wizardData.newServant\" activity-type-info=\"vm.activityTypeInfo\"></wzf-service-item-v2></div></div></div><div class=\"pl-modal-footer init-setup-footer\"><div class=\"\" style=\"display: flex;justify-content: center\"><md-button class=\"pl-btn pl-btn-default pl-btn-lg prev-step-button\" type=\"button\" style=\"color: #000\" ng-click=\"vm.prevFromStep()\"><i class=\"glyphicon glyphicon-arrow-right\"></i> <span translate=\"wizard.back\"></span></md-button><md-button type=\"button\" ng-disabled=\"!vm.isServiceItemValid || vm.isBusy\" ng-click=\"vm.nextFromStep()\" class=\"pl-btn pl-btn-primary pl-btn-lg next-step-button\" type=\"button\"><span translate=\"wizard.continue\"></span> <i class=\"glyphicon glyphicon-arrow-left\"></i></md-button></div></div></div></wz-step><wz-step wz-title=\"{{vm.getStepTitle(4) | translate}}\"><div class=\"pl-step-container\"><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"step-header\" style=\"padding-top: 15px\"><h4 style=\"color: black\"><b>{{vm.personInfo.fisrtName}}</b> عزیز به شما بابت راه اندازی حساب خود در پلنوین تبریک می گوییم !</h4><md-button ng-click=\"vm.goToDashboard()\" class=\"pl-btn pl-btn-primary btn-xl\" style=\"text-align: center; width: 70%\" type=\"button\" translate=\"wizard.finish\"></md-button></div><div class=\"step-content\"><wzf-last-step-v2 wizard-data=\"vm.wizardData\"></wzf-last-step-v2></div></div></div></div></wz-step></wizard></div><!--<script>$crisp.push([\'do\', \'chat:open\']);</script>-->");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");
$templateCache.put("app/components/eyeson/autocomplete/eyeson.autocomplete.template.html","<!--md-no-cache=\"$ctrl.noCache\"--><style>.md-autocomplete-suggestions {\n        z-index: 555555555588888 !important;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n\n\n        z-index: 555555555588888 !important;\n\n    }</style><!--md-search-text-change=\"$ctrl.onSearchTextChange($ctrl.searchText)\"--><md-autocomplete md-no-cache=\"false\" ng-disabled=\"$ctrl.isDisabled\" md-selected-item=\"$ctrl.selectedItem\" md-delay=\"300\" md-search-text=\"$ctrl.searchText\" md-selected-item-change=\"$ctrl.onSelectedItemChange(item)\" md-items=\"item in $ctrl.searchMethod($ctrl.searchText)\" md-item-text=\"item.title\" md-min-length=\"0\" placeholder=\"{{$ctrl.placeholder}}\"><md-item-template><span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{item.title}}</span></md-item-template><md-not-found><span style=\"color:#3f5a54;font-size: 10px\">موردی پیدا نشد </span><!--No states matching \"{{$ctrl.searchText}}\" were found.--><!--<a ng-click=\"$ctrl.newState($ctrl.searchText)\">Create a new one!</a>--></md-not-found></md-autocomplete>");
$templateCache.put("app/components/eyeson/avatar-name/eyeson.avatar-name.template.html","<div class=\"pl-avatar-name\"><div class=\"pl-avatar-text\">{{$ctrl.getSummary()}}</div></div>");
$templateCache.put("app/components/eyeson/button/eyeson.button.template.html","<md-button ng-disabled=\"$ctrl.isValid || $ctrl.isLoading\" ng-click=\"$ctrl.onClick()\" class=\"md-raised {{$ctrl.buttonClass}}\" ng-class=\"$ctrl.customClass\"><div class=\"button-content\"><div class=\"pull-right\"><md-icon>{{$ctrl.icon}}</md-icon></div><div class=\"pull-right\"><span ng-if=\"!$ctrl.isLoading || !$ctrl.loadingLabel\">{{$ctrl.label}} </span><span ng-if=\"$ctrl.isLoading && $ctrl.loadingLabel\">{{$ctrl.loadingLabel}}</span></div><div class=\"pull-right isloadingimage\" data-ng-show=\"$ctrl.isLoading\"></div></div></md-button>");
$templateCache.put("app/components/eyeson/calendar/eyeson.calendar.template.html","<style>.sch-offDate {\n        background-color: rgba(255, 87, 34, 0.15);\n    }\n\n    .light-box-style {\n        position: absolute;\n        top: 100px;\n        left: 200px;\n        z-index: 100000001;\n        display: none;\n        background-color: white;\n        border: 2px outset gray;\n        padding: 20px;\n        font-family: Tahoma;\n        font-size: 10pt;\n    }\n\n    .dhx_cal_container {\n        width: 100% !important;\n        height: 80vh !important;\n    }\n\n    .event-box {\n        margin: 0 0px;\n        cursor: pointer;\n        transition: 500ms ease-in;\n        border-radius: 4px;\n        border: 1px solid #ffffff8f;\n        font-family: \'yekan\';\n    }\n\n    .event-box:hover {\n        transition: 500ms ease-in;\n\n        border: 1px solid #ffffff;\n    }\n\n    .pl-tooltip {\n        font-family: \"yekan\" !important;\n        color: #000000 !important;\n        border-radius: 5px;\n        min-width: 180px;\n        z-index: 1500 !important;\n    }\n\n    .pl-tooltip-header {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .pl-tooltip-status {\n        text-align: center;\n        font-weight: bold;\n        font-size: 10px;\n        padding: 2px 4px;\n    }\n\n    .pl-tooltip-status-1 {\n        background-color: #eafbe7;\n        color: #299905 !important;\n        border-radius: 3px;\n    }\n\n    .pl-tooltip-status-5 {\n        background-color: #fdefdd;\n        color: #c7610a !important;\n        border-radius: 3px;\n\n    }\n\n    .pl-tooltip-status-6 {\n        background-color: #e9fbfe;\n        color: #2398a5 !important;\n        border-radius: 3px;\n\n    }\n\n    .dhx_cal_event div {\n        line-height: normal;\n        margin: 1px 2px;\n        /*text-align: left;*/\n        /*color: white;*/\n        font-size: 10px;\n        max-height: 13px;\n        overflow: hidden;\n    }\n    .dhx_cal_event div.orderbag-tags{\n        max-height: 20px;\n        min-height: 20px;\n    }\n\n    .my_event_body {\n        max-height: 80px !important;\n        overflow: hidden;\n        padding-top: 5px;\n    }\n\n    .servant-title-on-event, .customer-title-on-event {\n        /*color: white;*/\n        font-size: 9px;\n        float: right;\n        /*font-weight: bold;*/\n        padding-right: 2px;\n        font-family: yekan;\n        /*background-color: rgba(210, 210, 210, 0.84);*/\n        border-radius: 5px;\n        padding: 0px 2px;\n\n    }\n\n    .customer-title-on-event {\n        max-width: 50px;\n        white-space: nowrap;\n        font-size: 10px;\n        font-weight: bold;\n    }\n\n    .servant-title-on-event, .servant-title-on-event-small {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n    }\n\n    .servant-title-on-event-small {\n        max-width: 49px;\n    }\n\n\n    .event_date {\n        padding-right: 4px;\n    }\n\n    .servant-section {\n        padding-top: 2px;\n    }\n\n    .hide-week-tab {\n        display: none;\n    }\n\n    .event_first_line {\n        /*display: flex;*/\n        /*align-items: center;*/\n        /*gap: 5px;*/\n    }\n\n    /*    .scheduler_no_capacity\n        {\n            background-color: rgba(255, 32, 13, 0.51) !important;\n\n        }\n        .scheduler_no_capacity .dhx_body\n        {\n            background-color: rgba(255, 32, 13, 0.51) !important;\n\n        }\n        .scheduler_no_capacity .dhx_header\n        {\n            background-color: rgba(255, 32, 13, 0.51) !important;\n        }\n        .scheduler_no_capacity .dhx_footer\n        {\n            background-color: rgba(255, 32, 13, 0.51) !important;\n        }\n        .scheduler_no_capacity .dhx_title\n        {\n            background-color: rgba(255, 32, 13, 0.51) !important;\n        }\n        .scheduler_hidden_event\n        {\n            display: none;\n        }\n        .scheduler_not_enable\n        {\n            background-color: rgba(180, 178, 178, 0.65) !important;\n\n        }\n        .scheduler_not_enable .dhx_body\n        {\n            background-color: rgba(180, 178, 178, 0.65) !important;\n\n        }\n        .scheduler_not_enable .dhx_header\n        {\n            background-color: rgba(180, 178, 178, 0.65) !important;\n        }\n        .scheduler_not_enable .dhx_footer\n        {\n            background-color: rgba(180, 178, 178, 0.65) !important;\n        }\n        .scheduler_not_enable .dhx_title\n        {\n            background-color: rgba(180, 178, 178, 0.65) !important;\n        }\n\n        .scheduler_available\n        {\n            background-color: rgba(9, 191, 26, 0.6);\n        }\n        .scheduler_available .dhx_body\n        {\n            background-color: rgba(9, 191, 26, 0.6); !important;\n\n        }\n        .scheduler_available .dhx_header\n        {\n            background-color: rgba(9, 191, 26, 0.6); !important;\n        }\n        .scheduler_available .dhx_footer\n        {\n            background-color: rgba(9, 191, 26, 0.6); !important;\n        }\n        .scheduler_available .dhx_title\n        {\n            background-color: rgba(9, 191, 26, 0.6); !important;\n        }\n\n        .scheduler_has_orders_to_confirm\n        {\n            background-color: rgba(255, 179, 25, 0.78) !important;\n\n        }\n        .scheduler_has_orders_to_confirm .dhx_body\n        {\n            background-color: rgba(255, 179, 25, 0.78) !important;\n\n        }\n        .scheduler_has_orders_to_confirm .dhx_header\n        {\n            background-color: rgba(255, 179, 25, 0.78) !important;\n        }\n        .scheduler_has_orders_to_confirm .dhx_footer\n        {\n            background-color: rgba(255, 179, 25, 0.78) !important;\n        }\n        .scheduler_has_orders_to_confirm .dhx_title\n        {\n            background-color: rgba(255, 179, 25, 0.78) !important;\n        }\n\n       !*scheduler_has_confirmed_orders*!\n        .scheduler_has_confirmed_orders\n        {\n            background-color: rgb(38, 160, 49) !important;\n\n        }\n        .scheduler_has_confirmed_orders .dhx_body\n        {\n            background-color: rgb(38, 160, 49) !important;\n\n        }\n        .scheduler_has_confirmed_orders .dhx_header\n        {\n            background-color: rgb(38, 160, 49) !important;\n        }\n        .scheduler_has_confirmed_orders .dhx_footer\n        {\n            background-color: rgb(38, 160, 49) !important;\n        }\n        .scheduler_has_confirmed_orders .dhx_title\n        {\n            background-color: rgb(38, 160, 49) !important;\n        }\n\n        !*!///wait to pay*!\n        .scheduler_has_orders_to_pay\n        {\n            background-color: rgba(32, 150, 255, 0.73) !important;\n\n        }\n        .scheduler_has_orders_to_pay .dhx_body\n        {\n            background-color: rgba(32, 150, 255, 0.73) !important;\n\n        }\n        .scheduler_has_orders_to_pay .dhx_header\n        {\n            background-color: rgba(32, 150, 255, 0.73) !important;\n        }\n        .scheduler_has_orders_to_pay .dhx_footer\n        {\n            background-color: rgba(32, 150, 255, 0.73) !important;\n        }\n        .scheduler_has_orders_to_pay .dhx_title\n        {\n            background-color: rgba(32, 150, 255, 0.73) !important;\n        }*/\n\n    .scheduler_tooltip {\n        direction: rtl;\n        min-width: 120px;\n        transition: 500ms;\n        opacity: 0.8;\n    }\n\n    .helper-box {\n\n\n        font-size: 12px;\n        text-align: right;\n    }\n\n    .color-box {\n        width: 10px;\n        height: 10px;\n        float: right;\n    }\n\n    .label-box {\n        float: right;\n        width: 100px;\n        text-align: right;\n        font-size: 9px;\n        color: #595959;\n        margin: -2px;\n        margin-right: 5px;\n    }\n\n    .schedule_container {\n        height: 1500px;\n    }\n\n    .full-height {\n        height: 100% !important;\n    }\n\n    @media (max-width: 767px) {\n        .current-date-style {\n            font-size: 12px !important;\n\n        }\n\n        .helper-box {\n            display: none;\n        }\n\n\n    }\n\n    @media (max-width: 590px) {\n        .current-date-style {\n            font-size: 12px !important;\n            margin-top: -25px;\n        }\n\n\n    }\n\n    .orderbag-tags {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        flex-wrap: wrap;\n    }\n\n    .orderbag-tags span {\n        background-color: #d7d7d7;\n        color: #000;\n        border-radius: 4px;\n        padding: 3px;\n        font-size: 8px;\n    }</style><div id=\"scheduler_here\" class=\"dhx_cal_container\" style=\"width:100%; height:100vh !important\"><div class=\"dhx_cal_navline\" style=\"position: absolute\"><div class=\"dhx_cal_next_button\">&nbsp;</div><div class=\"dhx_cal_prev_button\">&nbsp;</div><div class=\"dhx_cal_today_button\"></div><div class=\"dhx_cal_date current-date-style\"></div><div id=\"week_tab\" class=\"dhx_cal_tab\" name=\"week_tab\" style=\"right:140px\"></div><div class=\"dhx_cal_tab\" name=\"day_tab\" style=\"right:204px\"></div><!--<div class=\"dhx_cal_tab\" name=\"month_tab\" style=\"right:76px;\"></div>--></div></div><div class=\"dhx_cal_header\"></div><div class=\"dhx_cal_data\"></div><script>// $(window).load(function () {\n    $(\'.dhx_cal_data\').ready(function () {\n        setTimeout(function () {\n            var container = $(\'.dhx_cal_container\');\n            var hc = container.height();\n            var table = $(\'.dhx_cal_data\');\n            var ht = table.height();\n            // $(\'.dhx_cal_data\').ready(function () {\n            if (!table.hasClass(\'full-height\')) {\n                container.css(\'height\', table.height() + 500);\n                table.addClass(\'full-height\');\n            }\n        }, 500);\n\n    })\n    // })</script>");
$templateCache.put("app/components/eyeson/calendar/eyeson.scheduler-time-session-dialog.template.html","<style>.filter-dialog-content {\n        min-height: 250px;\n        min-width: 300px;\n        max-width: 600px;\n        padding: 10px;;\n    }\n\n    .demo-md-panel {\n        min-height: 500px;\n    }\n\n    .demo-dialog-example {\n        background: white;\n        border-radius: 4px;\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),\n        0 13px 19px 2px rgba(0, 0, 0, 0.14),\n        0 5px 24px 4px rgba(0, 0, 0, 0.12);\n        width: 500px;\n    }\n\n    .demo-dialog-content {\n        padding: 0 15px;\n        width: 100%;\n    }\n\n    .demo-dialog-content img {\n        height: 300px;\n        margin: auto;\n    }\n\n    .demo-dialog-button {\n        width: 100%;\n    }\n\n    .demo-dialog-custom-animation-open {\n        opacity: 1;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(390deg);\n    }\n\n    .demo-dialog-custom-animation-close {\n        opacity: 0;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(0deg);\n    }\n\n    .item-title {\n        font-size: 14px;\n        color: #009688;\n        padding: 10px;\n        text-align: right;\n    }\n\n    @media (width: 400px) {\n        .selected-date-on-dialog {\n            font-size: 12px;\n        }\n    }\n\n    .orderbag-tags-dialog {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    .orderbag-tags-dialog span {\n        background-color: #d7d7d7;\n        color: #000;\n        border-radius: 8px;\n        padding: 4px;\n        font-size: 10px;\n    }</style><md-dialog class=\"pl-md-dialog\"><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div>{{$ctrl.title}}</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.cancelDialog()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><div class=\"demo-dialog-content filter-dialog-content\"><div ng-if=\"$ctrl.dialogData \" class=\"modal-body\" style=\"min-height: 300px;max-width: 500px\"><div ng-if=\"!$ctrl.dialogData.isNew\"><div class=\"item-title\"><md-icon>schedule</md-icon><span>{{$ctrl.title}}</span></div><div class=\"item-title\" ng-if=\"$ctrl.dialogData.serviceTitle\"><md-icon>bookmark_border</md-icon><span>{{$ctrl.dialogData.serviceTitle}}</span></div><div class=\"item-title\"><md-icon>person</md-icon>{{$ctrl.dialogData.servantTitle}}</div><div ng-if=\"$ctrl.dialogData.tags && $ctrl.dialogData.tags.length\" class=\"orderbag-tags-dialog\"><span ng-if=\"$ctrl.dialogData.tags[0]\">{{$ctrl.dialogData.tags[0].tag}}</span> <span ng-if=\"$ctrl.dialogData.tags[1]\">{{$ctrl.dialogData.tags[1].tag}}</span> <span ng-if=\"$ctrl.dialogData.tags.length > 2\">+{{orderBagServiceItem.tags.length-2}}</span></div><div class=\"row\" ng-if=\"$ctrl.timeSessionDtail && $ctrl.timeSessionDtail.customerOrders && $ctrl.timeSessionDtail.customerOrders.length>0 \"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div><span translate=\"tikonApp.orderBag.currentSessionReservs\"></span></div></div><div class=\"panel-body\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" callback=\"vm.transition()\"><th><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th has-authority=\"ROLE_CUSTOMER_MANAGER\"><span translate=\"tikonApp.personInfo.phoneNumber\">phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.status.title\">status</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"order in $ctrl.timeSessionDtail.customerOrders \"><td><a ng-click=\"$ctrl.gotoOrderBag(order.orderBagId)\">{{order.orderBagId}}</a></td><td>{{order.customer.fisrtName}} {{order.customer.lastName}}</td><td has-authority=\"ROLE_CUSTOMER_MANAGER\">{{order.customer.phoneNumber}}</td><td><div>{{\'tikonApp.orderBag.status.\'+order.status | translate}}</div><div style=\"font-size: 10px;color: #2f96b4\">{{order.servantName}}</div></td></tr></tbody></table></div></div></div></div></div></div><div layout=\"row\" class=\"demo-dialog-button\"><div class=\"col-sm-12 text-center\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><!--<md-button ng-show=\"(!$ctrl.dialogData.isNew && $ctrl.dialogData.enable)\"--><!--ng-click=\"$ctrl.gotoNewReserve($ctrl.timeSessionDtail.serviceItemId)\"--><!--class=\"md-raised md-accent large-button\">--><!--<span><md-icon>add_circle_outline</md-icon></span>--><!--<span>--><!--<span translate=\"tikonApp.orderBag.newReserveForTimeSession\">--><!--Create new Order Bag Service Item--><!--</span>--><!--</span>--><!--</md-button>--></div><!-- <div  class=\"col-sm-6\"  >\n             <button ng-if=\"!$ctrl.dialogData.enable\" type=\"button\" style=\"float: left\" class=\"btn btn-success\" ng-click=\"$ctrl.changeEnable($ctrl.dialogData)\" >\n                 <i class=\"fa fa-circle-check\" aria-hidden=\"true\"></i>\n     <span  translate=\"tikonApp.serviceItem.makeEnable\">\n         Create new Order Bag Service Item\n     </span>\n             </button>\n             <button  ng-if=\"$ctrl.dialogData.enable\" type=\"button\" style=\"float: left\" class=\"btn btn-danger\" ng-click=\"$ctrl.changeEnable($ctrl.dialogData)\">\n                 <i class=\"fa fa-ban\" aria-hidden=\"true\"></i>\n     <span class=\"hidden-xs\"  translate=\"tikonApp.serviceItem.makeDisable\">\n         Create new Order Bag Service Item\n     </span>\n             </button>\n\n         </div>--></div><div layout=\"row\" class=\"demo-dialog-button\" ng-show=\"(!$ctrl.dialogData.enable && $ctrl.dialogData.capacity==null)\"><div class=\"col-sm-12 text-center\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><md-button ng-click=\"$ctrl.gotoNewReserve_flex($ctrl.timeSessionDtail.serviceItemId)\" class=\"md-raised md-accent large-button\"><span><md-icon>add_circle_outline</md-icon></span><span><span translate=\"tikonApp.orderBag.newReserveForTimeSession\">Create new Order Bag Service Item</span></span></md-button></div><!-- <div  class=\"col-sm-6\"  >\n             <button ng-if=\"!$ctrl.dialogData.enable\" type=\"button\" style=\"float: left\" class=\"btn btn-success\" ng-click=\"$ctrl.changeEnable($ctrl.dialogData)\" >\n                 <i class=\"fa fa-circle-check\" aria-hidden=\"true\"></i>\n     <span  translate=\"tikonApp.serviceItem.makeEnable\">\n         Create new Order Bag Service Item\n     </span>\n             </button>\n             <button  ng-if=\"$ctrl.dialogData.enable\" type=\"button\" style=\"float: left\" class=\"btn btn-danger\" ng-click=\"$ctrl.changeEnable($ctrl.dialogData)\">\n                 <i class=\"fa fa-ban\" aria-hidden=\"true\"></i>\n     <span class=\"hidden-xs\"  translate=\"tikonApp.serviceItem.makeDisable\">\n         Create new Order Bag Service Item\n     </span>\n             </button>\n\n         </div>--></div><md-dialog-actions class=\"pl-dialog-actions\"><div class=\"pl-filter-dialog-footer\" style=\"width: 100%\"><div class=\"\" style=\"display: flex;justify-content: flex-end\"><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancelDialog()\"><span>بازگشت</span><!--<md-icon style=\"color: #000;\">keyboard_backspace</md-icon>--></md-button></div></div></md-dialog-actions></md-dialog><!--<div class=\"filter-dialog-content\">--> <!--</div>-->");
$templateCache.put("app/components/eyeson/date-duration-selector/eyeson.date-duration-selector.template.html","<style>.vertical-mode {\n        /*max-width: 300px;*/\n    }</style><div class=\"row\"><div ng-class=\"$ctrl.getClass()\"><label class=\"control-label\" ng-if=\"$ctrl.showEndDate\">از تاریخ</label><label class=\"control-label\" ng-if=\"!$ctrl.showEndDate\">تاریخ</label><eo-date-picker id=\"field_startDate\" date-value=\"$ctrl.startDate\" min-date=\"$ctrl.minStartDate\"></eo-date-picker></div><div ng-class=\"$ctrl.getClass()\" ng-if=\"$ctrl.showEndDate\"><label class=\"control-label\">تا تاریخ</label><eo-date-picker id=\"field_endDate\" min-date=\"$ctrl.startDate\" date-value=\"$ctrl.endDate\"></eo-date-picker></div><div ng-if=\"!$ctrl.onlyShowStartDate\" ng-class=\"$ctrl.getClass()\" style=\"margin-top: 18px\"><md-switch ng-model=\"$ctrl.showEndDate\" ng-disabled=\"$ctrl.onlyShowStartDate\" ng-change=\"$ctrl.showEndDate_changed()\">بازه چند روزه</md-switch></div></div>");
$templateCache.put("app/components/eyeson/date-picker/eyeson.date-picker.template.html","<style>.select-date-btn {\n        position: absolute;\n    }\n\n    .calendarDiv {\n        border: 1px solid #eeeeee;\n        border-radius: 4px;\n        background-color: white;\n        height: 38px;\n        padding: 4px 2px;\n        display: flex;\n        /*max-width: 200px;*/\n    }\n\n    .date-picker {\n        width: 100% !important;\n    }\n\n    .input-section {\n        float: right;\n        /*width:80%;*/\n    }\n\n    /*.calendarDiv:after{*/\n    /*content: \"\\e878\";*/\n    /*font-family: \"Material Icons\";*/\n    /*!* margin: 0px 0; *!*/\n    /*background-color: white;*/\n    /*font-size: 1.8vw;*/\n    /*!* margin-top: -19px; *!*/\n    /*!* margin-bottom: 8px; *!*/\n    /*vertical-align: middle;*/\n    /*color: #2b6b7f;*/\n    /*}*/\n\n    .event-icon {\n        font-size: 2vw;\n    }\n\n    @media (max-width: 768px) {\n        /*.calendarDiv:after{*/\n        /*font-size: 22px;*/\n        /*}*/\n        .event-icon {\n            font-size: 22px;\n        }\n\n        .calendarDiv {\n            max-width: 200px;\n        }\n\n    }</style><md-input-container class=\"date-picker\" style=\"padding: 0; margin: 0 auto\"><label>{{$ctrl.label}}</label><div class=\"calendarDiv\"><div class=\"input-section\"><input id=\"{{$ctrl.id}}\" class=\"input\" ng-model=\"$ctrl.dateValue\" style=\"border: none;text-align: center;font-size: 1.1em; background-color: white\" ng-click=\"$ctrl.openPersian($event)\" is-open=\"$ctrl.persianIsOpen\" datepicker-options=\"$ctrl.dateOptions\" datepicker-popup-persian=\"yyyy/MM/dd\" ng-change=\"$ctrl.selectedTimeChanged()\" off-date-list=\"$ctrl.offDays\" min-date=\"$ctrl.minDate\" max-date=\"$ctrl.maxDate\" date-disabled=\"$ctrl.disabled(date, mode)\" eo-required=\"{{$ctrl.isRequired}}\" close-text=\"بستن\"></div><md-icon class=\"general-icon event-icon\" ng-click=\"$ctrl.openPersian($event)\">event</md-icon></div></md-input-container>");
$templateCache.put("app/components/eyeson/editable-input/eyeson.editable-input.html","<style>.inline-edit-btn {\n        font-size: 25px;\n        text-align: right;\n        color: #0e5a41;\n        margin-right: -1px;\n        opacity: 0.7;\n        cursor: pointer;\n    }\n\n    .inline-edit-btn:hover {\n        opacity: 1;\n    }\n\n    .inline-edit-btn .confirm {\n        color: #00AA00;\n    }\n\n    .inline-edit-btn .cancel {\n        color: #aa303b;\n    }</style><table style=\"width: 100%\"><tr><td style=\"width: 80%\"><input type=\"text\" ng-readonly=\"$ctrl.isReadonly\" class=\"form-control\" ng-model=\"$ctrl.value\"></td><td style=\"width: 20%\"><div ng-show=\"$ctrl.mode==0\" style=\"padding: 0px\"><span data-ng-if=\"$ctrl.isEditable\" class=\"inline-edit-btn\" ng-click=\"$ctrl.gotoEditMode()\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></span></div><div ng-show=\"$ctrl.mode==1\" style=\"padding: 0px\"><span class=\"inline-edit-btn\"><i class=\"fa fa-check-square-o confirm\" aria-hidden=\"true\" ng-click=\"$ctrl.confirmEdit()\"></i> <i class=\"fa fa-times cancel\" ng-click=\"$ctrl.cancelEdit()\" aria-hidden=\"true\"></i></span></div></td></tr></table><div class=\"row\"><div class=\"col-sm-9\"></div></div>");
$templateCache.put("app/components/eyeson/feature-checker/eyeson.feature-checker.html","<style>/*.triangle-border.right:after {*/\n    /*top: 16px;*/\n    /*bottom: auto;*/\n    /*left: auto;*/\n    /*right: -21px;*/\n    /*border-width: 9px 0 9px 21px;*/\n    /*border-color: transparent #fff;*/\n    /*}*/\n\n\n    /*.triangle-border:after {*/\n    /*content: \"\";*/\n    /*position: absolute;*/\n    /*bottom: -13px;*/\n    /*left: 47px;*/\n    /*border-width: 13px 13px 0;*/\n    /*border-style: solid;*/\n    /*border-color: #fff transparent;*/\n    /*display: block;*/\n    /*width: 0;*/\n    /*}*/\n    /*.triangle-border.right:before {*/\n    /*top: 10px;*/\n    /*bottom: auto;*/\n    /*left: auto;*/\n    /*right: -30px;*/\n    /*border-width: 15px 0 15px 30px;*/\n    /*border-color: transparent rgb(154, 186, 99);*/\n    /*}*/\n\n    /*.triangle-border:before {*/\n    /*content: \"\";*/\n    /*position: absolute;*/\n    /*bottom: -20px;*/\n    /*left: 40px;*/\n    /*border-width: 20px 20px 0;*/\n    /*border-style: solid;*/\n    /*border-color: rgb(154, 186, 99) transparent;*/\n    /*display: block;*/\n    /*width: 0;*/\n    /*}*/\n    .triangle-border.right {\n        margin-right: 3px;\n    }\n\n    .triangle-border {\n        position: relative;\n        padding: 12px;\n        margin: 1em 0 1em;\n        border: 2px solid #b1ca87;\n        color: rgb(79, 107, 33);\n        font-size: small;\n        background: rgba(150, 183, 93, 0.08);\n        -webkit-border-radius: 10px;\n        -moz-border-radius: 10px;\n        border-radius: 10px;\n    }</style><div class=\"triangle-border right\"><i style=\"font-size: medium\" class=\"fa fa-hand-o-left\" aria-hidden=\"true\"></i> <span class=\"text\">{{$ctrl.text}}</span><div style=\"float: right\"></div></div>");
$templateCache.put("app/components/eyeson/file-upload/eyeson.file-upload.html","<!--<div--><!--class=\"btn btn-primary btn-upload\"--><!--upload-button--><!--url=\"/api/uploadFile\"--><!--multiple=\"true\"--><!--param=\"uploadfile\"--><!--on-success=\"onSuccess(response)\"--><!--&gt;--><!--<span class=\"fa fa-upload\"></span>--><!--آپلود تصویر--><!--</div>--><style>input[type=\"file\"] {\n        display: none;\n    }\n\n    .custom-file-upload {\n        border: 1px solid #2b6b7f38;\n        display: inline-block;\n        padding: 6px 12px;\n        cursor: pointer;\n        box-shadow: 0px 0px 5px -3px;\n        border-radius: 5px;\n        color: #2b6b7f;\n        font-size: 14px !important;\n    }\n\n    .remove-icon {\n        color: red;\n        top: 2px;\n        font-size: 16px;\n        position: relative;\n    }\n\n    .loader,\n    .loader:before,\n    .loader:after {\n        border-radius: 50%;\n        width: 2.5em;\n        height: 2.5em;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        -webkit-animation: load7 1.8s infinite ease-in-out;\n        animation: load7 1.8s infinite ease-in-out;\n    }\n\n    .loader {\n        color: #2b6b7f;\n        font-size: 4px;\n        margin: 0 auto;\n        margin-bottom: 20px;\n        position: relative;\n        text-indent: -9999em;\n        -webkit-transform: translateZ(0);\n        -ms-transform: translateZ(0);\n        transform: translateZ(0);\n        -webkit-animation-delay: -0.16s;\n        animation-delay: -0.16s;\n    }\n\n    .loader:before,\n    .loader:after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n    }\n\n    .loader:before {\n        left: -3.5em;\n        -webkit-animation-delay: -0.32s;\n        animation-delay: -0.32s;\n    }\n\n    .loader:after {\n        left: 3.5em;\n    }\n\n    @-webkit-keyframes load7 {\n        0%,\n        80%,\n        100% {\n            box-shadow: 0 2.5em 0 -1.3em;\n        }\n        40% {\n            box-shadow: 0 2.5em 0 0;\n        }\n    }\n\n    @keyframes load7 {\n        0%,\n        80%,\n        100% {\n            box-shadow: 0 2.5em 0 -1.3em;\n        }\n        40% {\n            box-shadow: 0 2.5em 0 0;\n        }\n    }</style><div ng-if=\"!$ctrl.fileName && !$ctrl.isUploading\"><label for=\"{{ $ctrl.randomId}}\" class=\"custom-file-upload\"><i class=\"fa fa-cloud-upload\"></i> انتخاب فایل</label></div><div><input type=\"file\" id=\"{{ $ctrl.randomId}}\" on-file-change=\"$ctrl.handleFileSelect\"></div><div ng-if=\"$ctrl.fileName && !$ctrl.isUploading\" style=\"padding-bottom: 5px\"><div class=\"custom-file-upload\"><a ng-click=\"$ctrl.downloadFile()\" style=\"padding-left: 10px\"><i class=\"fa fa-download\"></i> مشاهده فایل </a><a ng-click=\"$ctrl.removeFile()\" class=\"remove-icon\"><i class=\"fa fa-remove\"></i></a></div></div><div ng-if=\"$ctrl.isUploading\"><div class=\"custom-file-upload\" style=\"width: 65%; padding: 0\"><div class=\"loader\"></div></div></div>");
$templateCache.put("app/components/eyeson/fixed-button/eyeson.fixed-button.template.html","<div id=\"fixedButton\" class=\"pl-fixed-button\" ng-click=\"$ctrl.onClick()\" style=\"left: 18px\"><md-icon style=\"color: white;font-size: 40px;width: 40px;height: 40px\">add</md-icon><div id=\"fixedButtonText\" style=\"color: white\">{{$ctrl.label}}</div></div>");
$templateCache.put("app/components/eyeson/help-tip/eyeson.help-tip.html","<style>/*.triangle-border.right:after {*/\n    /*top: 16px;*/\n    /*bottom: auto;*/\n    /*left: auto;*/\n    /*right: -21px;*/\n    /*border-width: 9px 0 9px 21px;*/\n    /*border-color: transparent #fff;*/\n    /*}*/\n\n\n    /*.triangle-border:after {*/\n    /*content: \"\";*/\n    /*position: absolute;*/\n    /*bottom: -13px;*/\n    /*left: 47px;*/\n    /*border-width: 13px 13px 0;*/\n    /*border-style: solid;*/\n    /*border-color: #fff transparent;*/\n    /*display: block;*/\n    /*width: 0;*/\n    /*}*/\n    /*.triangle-border.right:before {*/\n    /*top: 10px;*/\n    /*bottom: auto;*/\n    /*left: auto;*/\n    /*right: -30px;*/\n    /*border-width: 15px 0 15px 30px;*/\n    /*border-color: transparent rgb(154, 186, 99);*/\n    /*}*/\n\n    /*.triangle-border:before {*/\n    /*content: \"\";*/\n    /*position: absolute;*/\n    /*bottom: -20px;*/\n    /*left: 40px;*/\n    /*border-width: 20px 20px 0;*/\n    /*border-style: solid;*/\n    /*border-color: rgb(154, 186, 99) transparent;*/\n    /*display: block;*/\n    /*width: 0;*/\n    /*}*/\n    .triangle-border.right {\n        margin-right: 3px;\n    }\n\n    .triangle-border {\n        position: relative;\n        padding: 12px;\n        margin: 1em 0 1em;\n        border: 2px solid #b1ca87;\n        color: rgb(79, 107, 33);\n        font-size: small;\n        background: rgba(150, 183, 93, 0.08);\n        -webkit-border-radius: 10px;\n        -moz-border-radius: 10px;\n        border-radius: 10px;\n    }</style><div class=\"triangle-border right\"><i style=\"font-size: medium\" class=\"fa fa-hand-o-left\" aria-hidden=\"true\"></i> <span class=\"text\">{{$ctrl.text}}</span><div style=\"float: right\"></div></div>");
$templateCache.put("app/components/eyeson/image-gallery/eyeson.image-gallery.html","<!--methods=\"methods\"--><!--thumbnails=\"true | false | boolean-model\"--><!--inline=\"true | false | boolean-model\"--><!--img-bubbles=\"true | false | boolean-model\"--><!--bg-close=\"true | false | boolean-model\"--><!--bubbles=\"true | false | boolean-model\"--><!--img-anim=\"fadeup\"--><!--conf=\"conf\"--><!--on-open=\"opened();\"--><!--on-close=\"closed();\"--><style>.ng-image-gallery .ng-image-gallery-thumbnails .thumb {\n        border-radius: 50%;\n    }\n\n    .pl-image-thumb {\n        -webkit-border-radius: 50%;\n        -moz-border-radius: 50%;\n        border-radius: 50%;\n        width: 80px;\n        height: 80px;\n        background-size: cover;\n        background-position: bottom;\n    }</style><div style=\"padding: 10px; float: right; text-align: center\"><!--<div id=\"preview\" ng-click=\"$ctrl.openImage()\"></div>--><ng-image-gallery images=\"$ctrl.preparedImageList\" bubbles=\"true\" img-anim=\"pop\" bg-close=\"true\" img-bubbles=\"true\" methods=\"{delete:$ctrl.delete}\"></ng-image-gallery></div>");
$templateCache.put("app/components/eyeson/image-gallery-manager/eyeson.image-gallery-manager.html","<style type=\"text/css\">.album-image-list {\n        padding: 5px;\n        margin: auto;\n\n    }\n\n    .album-image-list :hover {\n        border: solid 1px #00b09f;\n\n    }\n\n    .modal-full-screen {\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 10000;\n        background-color: rgba(0, 0, 0, 0.6);\n        padding: 50px;\n        color: #ffffff !important;\n    }\n\n    .imageBottomText {\n        font-size: 12px;\n        margin: auto;\n        font-weight: bold;\n        color: rgb(63, 81, 181);\n        padding-right: 22px;\n        /*width: 120px;*/\n    }\n\n    #addPictureBtn {\n        margin: 10px 15px;\n        padding: 3px;\n        width: 80px;\n        min-width: unset;\n        height: 80px;\n        overflow: hidden;\n        border-radius: 50%;\n        background-size: cover;\n        background-position: center center;\n        /*background-image: url(\"/content/images/blank-profile-picture.png\");*/\n        cursor: pointer;\n        opacity: 0.4;\n        transition: 0.3s;\n    }\n\n    #addPictureBtn:before {\n        margin-top: -18px;\n        margin-right: -22px;\n        position: absolute;\n        content: \"\\e439\";\n        font-family: \"Material Icons\";\n        font-size: 46px;\n        color: #607d8b;\n    }\n\n    .img-cropper-container {\n        max-height: 550px;\n    }\n\n    /*.glyphicon-plus {*/\n    /*font-size: 40px;*/\n    /*background-color: rgba(0,0,0,0.2);*/\n    /*transition: 0.3s;*/\n    /*position: relative;*/\n    /*top: -3px;*/\n    /*right: -6px;*/\n    /*width: 114%;*/\n    /*height: 109%;*/\n    /*padding: 22px;*/\n    /*color: dimgrey;*/\n    /*opacity: 0.4;*/\n    /*}*/\n    #addPictureBtn:hover {\n        opacity: 0.8;\n        transition: 0.3s;\n    }</style><div ng-if=\"$ctrl.label\"><h4>{{$ctrl.label}}</h4><!--<hr/>--></div><div class=\"\"><div><div class=\"row form-group\"><div ng-if=\"$ctrl.imageList.length\"><eo-image-gallery image-list=\"$ctrl.imageList\" methods=\"{delete:$ctrl.deleteImage}\"></eo-image-gallery></div><div ng-if=\"$ctrl.maxImageCount !=1 || $ctrl.imageList.length == 0\"><!--<div style=\"text-align: center;\">--><div><md-button id=\"addPictureBtn\" type=\"button\" class=\"md-raised\" ng-disabled=\"$ctrl.canBeAdded()\" ng-click=\"$ctrl.addImage()\"><!--<div translate=\"tikonApp.personInfo.profileimage\"></div>--><!--<span class=\"glyphicon glyphicon-plus\" ></span>--></md-button><div class=\"imageBottomText\"><!--حداکثر--><!--{{$ctrl.maxImageCount}}--><div>انتخاب تصویر</div><div ng-if=\"$ctrl.cropWidth > 100\">( {{$ctrl.cropHeight}} * {{$ctrl.cropWidth}})</div></div></div></div><!--<div ng-repeat=\"imge in $ctrl.imageList\" class=\"col-sm-2\">--><!--<div class=\"album-image-list\">--><!--<img style=\"width: 100%\" ng-src=\"{{$ctrl.imagesrc(imge)}}\" />--><!--</div>--><!--</div>--></div><div ng-if=\"$ctrl.editMode\" class=\"modal-full-screen\"><div class=\"row rwMdContent img-cropper-container\"><div class=\"col-sm-2\" style=\"background-color: rgba(255,255,255,0.9)\"><!--<input type=\"file\" img-cropper-fileread image=\"$ctrl.file\" />--> <button type=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"2MB\" img-cropper-fileread image=\"$ctrl.file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"$ctrl.handleFileSelect($file)\"><span class=\"glyphicon glyphicon-picture\"></span> <span translate=\"entity.action.selectImage\"></span></button> <button type=\"button\" ng-disabled=\"$ctrl.file==null\" class=\"btn btn-default btn-block\" ng-click=\"$ctrl.uploadImage()\"><span class=\"glyphicon glyphicon-check\"></span> <span translate=\"entity.action.confirmImage\"></span></button> <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$ctrl.cancelEditing()\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span translate=\"entity.action.cancel\"></span></button><!--<div>--><!--<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.caption\" placeholder=\"عنوان تصویر\"/>--><!--</div>--><!--<div>--><!--<textarea class=\"form-control\" cols=\"10\" rows=\"20\" ng-model=\"$ctrl.description\"--><!--placeholder=\"شرح تصویر\">--><!--</textarea>--><!--</div>--><!--<div>--><!--<canvas width=\"1000\" height=\"700\" id=\"canvas\" ></canvas>--><!--</div>--><!--<img  ngf-size=\"{width: 100, height: 100, quality: 0.9}\"  ngf-thumbnail=\"vm.file1 || \'/thumb.jpg\'\"/>--></div><div class=\"col-sm-10\"><div ng-class=\"  {\'noimage imageholder \' :$ctrl.file==null,\'imageholder\':$ctrl.file!=null}\"><!--<img ng-show=\"!($ctrl.currentImage.fileData==null)\"  ng-src=\"{{$ctrl.imagesrc()}}\"   />--> <img ng-if=\"$ctrl.disableCropping\" class=\"img-responsive\" ng-show=\"$ctrl.file\" ng-src=\"{{$ctrl.file}}\"><div ng-if=\"!$ctrl.disableCropping\"><canvas width=\"700\" height=\"500\" id=\"canvas\" image-cropper image=\"$ctrl.file\" cropped-image=\"$ctrl.croppedDataUrl\" crop-width=\"$ctrl.cropWidth\" crop-height=\"$ctrl.cropHeight\" min-height=\"$ctrl.minWidth\" min-height=\"$ctrl.minHeight\" keep-aspect=\"$ctrl.keep_aspect\" touch-radius=\"30\" crop-area-bounds=\"$ctrl.bounds\"></canvas></div><!--<div ng-if=\"!$ctrl.disableCropping\">--><!--<canvas width=\"150\" height=\"150\" id=\"canvas2\" image-cropper image=\"$ctrl.croppedDataUrl\"--><!--cropped-image=\"$ctrl.croppedThumbDataUrl\" crop-width=\"150\" crop-height=\"150\"--><!--min-height=\"150\" min-height=\"150\" keep-aspect=\"true\" touch-radius=\"30\"--><!--crop-area-bounds=\"$ctrl.bounds\"></canvas>--><!--</div>--><!--<img-crop image=\"$ctrl.file\"--><!--area-type=\"square\"--><!--result-image=\"$ctrl.croppedDataUrl\"--><!--area-min-size=\"1000\"--><!--result-image-format=\"image/jpeg\">--><!--</img-crop>--><!--       <img-crop\n                                   image=\"{string}\"\n                                   result-image=\"{string}\"\n                                   [change-on-fly=\"{boolean}\"]\n                                   [area-type=\"{circle|square}\"]\n                                   [area-min-size=\"{number}\"]\n                                   [result-image-size=\"{number}\"]\n                                   [result-image-format=\"{string}\"]\n                                   [result-image-quality=\"{number}\"]\n                                   [on-change=\"{expression}\"]\n                                   [on-load-begin=\"{expression\"]\n                                   [on-load-done=\"{expression\"]\n                                   [on-load-error=\"{expression\"]\n                               ></img-crop>--></div></div></div></div></div></div>");
$templateCache.put("app/components/eyeson/image-gallery-manager-v2/eyeson.image-gallery-manager-v2.html","<!--<link rel=\"stylesheet\" href=\"../../../../js/tools/croppie/croppie.css\" />--><!--<script src=\"../../../../js/tools/croppie/croppie.js\"></script>--><style type=\"text/css\">.album-image-list {\n        padding: 5px;\n        margin: auto;\n\n    }\n\n    .album-image-list :hover {\n        border: solid 1px #00b09f;\n\n    }\n\n    .modal-full-screen {\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 10000;\n        background-color: rgba(0, 0, 0, 0.6);\n        padding: 25px;\n        color: #ffffff !important;\n\n    }\n\n    .cropper-container {\n        margin: auto;\n    }\n\n    .imageBottomText {\n        font-size: 12px;\n        margin: auto;\n        font-weight: bold;\n        color: rgb(63, 81, 181);\n        padding-right: 22px;\n        /*width: 120px;*/\n    }\n\n    #addPictureBtn {\n        margin: 10px 15px;\n        padding: 3px;\n        width: 80px;\n        min-width: unset;\n        height: 80px;\n        overflow: hidden;\n        border-radius: 50%;\n        background-size: cover;\n        background-position: center center;\n        /*background-image: url(\"/content/images/blank-profile-picture.png\");*/\n        cursor: pointer;\n        opacity: 0.4;\n        transition: 0.3s;\n    }\n\n    #addPictureBtn:before {\n        margin-top: -18px;\n        margin-right: -22px;\n        position: absolute;\n        content: \"\\e439\";\n        font-family: \"Material Icons\";\n        font-size: 46px;\n        color: #607d8b;\n    }\n\n    #addPictureBtn:hover {\n        opacity: 0.8;\n        transition: 0.3s;\n    }\n\n    .image-preview-container {\n        overflow-y: auto;\n        max-height: 450px;\n        max-width: 450px;\n\n    }\n\n    .image-container {\n\n        display: flex;\n        gap: 50px;\n        padding-right: 100px;\n        background-color: white;\n        padding-top: 50px;\n        max-height: 95%;\n        border-radius: 5px;\n        /*justify-content: space-between;*/\n        min-height: 550px;\n    }\n\n    .image-actions {\n        background-color: white;\n        padding: 15px;\n        border-radius: 5px;\n        max-height: 202px;\n        z-index: 10;\n        display: flex;\n        /* gap: 10px; */\n        align-items: baseline;\n        flex-direction: column;\n        border: 1px solid #e3e3e3;\n    }\n\n    .gallery-buttons {\n        height: 50px;\n    }\n\n    .image-button:hover {\n        background-color: white !important;\n        color: black !important;\n        box-shadow: 0px 0px 5px -3px;\n    }\n\n    .image-button:focus {\n        background-color: white !important;\n        outline: none !important;\n        color: black !important;\n    }\n\n\n    .upload-button:disabled,\n    .upload-button[disabled] {\n        background-color: #cfcfcf !important;\n        color: #666666 !important;\n    }\n\n\n    .no-image-text {\n        /*min-width: 400px;*/\n        /*min-height: 183px;*/\n        color: #a1a0a0;\n        text-align: center;\n        font-size: 20px;\n        border: 1px solid #e3e3e3;\n        min-width: 400px;\n        min-height: 185px;\n        margin-top: -18px;\n        padding: 32px 54px 45px;\n        border-radius: 5px;\n    }\n\n    .no-image-text:hover {\n        box-shadow: 1px 1px 1px;\n    }\n\n    @media (max-width: 767px) {\n        .image-actions {\n            position: fixed;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            gap: 2px;\n            flex-direction: row;\n            padding: 2px;\n        }\n\n        .image-container {\n\n            display: flex;\n            gap: 50px;\n            padding-right: 0px;\n            background-color: white;\n            justify-content: center;\n            /* max-height: 88%; */\n            padding-top: 15px;\n            height: 100%;\n            /*justify-content: space-between;*/\n        }\n\n        .modal-full-screen {\n            padding: 0px;\n        }\n\n        .image-preview-container {\n            overflow: auto;\n            max-height: 80%;\n            max-width: 95vw;\n        }\n\n        .no-image-text {\n            margin-top: 100px;\n            min-width: 200px;\n        }\n\n        .gallery-buttons {\n            /*height: 50px;*/\n            padding: 6px 12px !important;\n        }\n\n\n    }</style><div ng-if=\"$ctrl.label\"><h4>{{$ctrl.label}}</h4><!--<hr/>--></div><div class=\"\"><div><div class=\"row form-group\"><div ng-if=\"$ctrl.imageList.length\"><eo-image-gallery image-list=\"$ctrl.imageList\" methods=\"{delete:$ctrl.deleteImage}\"></eo-image-gallery></div><div ng-if=\"$ctrl.maxImageCount !=1 || $ctrl.imageList.length == 0\"><!--<div style=\"text-align: center;\">--><div><md-button id=\"addPictureBtn\" type=\"button\" class=\"md-raised\" ng-disabled=\"$ctrl.canBeAdded()\" ng-click=\"$ctrl.addImage()\"><!--<div translate=\"tikonApp.personInfo.profileimage\"></div>--><!--<span class=\"glyphicon glyphicon-plus\" ></span>--></md-button><div class=\"imageBottomText\"><!--حداکثر--><!--{{$ctrl.maxImageCount}}--><div>انتخاب تصویر</div><div ng-if=\"$ctrl.cropWidth > 100\">( {{$ctrl.cropHeight}} * {{$ctrl.cropWidth}})</div></div></div></div><!--<div ng-repeat=\"imge in $ctrl.imageList\" class=\"col-sm-2\">--><!--<div class=\"album-image-list\">--><!--<img style=\"width: 100%\" ng-src=\"{{$ctrl.imagesrc(imge)}}\" />--><!--</div>--><!--</div>--></div><div ng-if=\"$ctrl.editMode\" class=\"modal-full-screen\"><div class=\"image-container\"><div class=\"image-actions\"><!--<input type=\"file\" img-cropper-fileread image=\"$ctrl.file\" />--> <button type=\"file\" ngf-pattern=\"\'.jpeg,.jpg,.png\'\" ngf-accept=\"\'.jpeg,.jpg,.png\'\" id=\"fileSelector\" ngf-select=\"$ctrl.handleFileSelect($file)\" class=\"btn btn-default btn-block gallery-buttons image-button\" ngf-change=\"\"><span class=\"glyphicon glyphicon-picture\"></span> <span translate=\"entity.action.selectImage\"></span></button> <button type=\"button\" ng-disabled=\"$ctrl.file==null\" class=\"btn btn-primary btn-block gallery-buttons upload-button\" ng-click=\"$ctrl.uploadImage()\"><span class=\"glyphicon glyphicon-check\"></span> <span translate=\"entity.action.confirmImage\"></span></button> <button type=\"button\" class=\"btn btn-danger btn-block gallery-buttons\" ng-click=\"$ctrl.cancelEditing()\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span translate=\"entity.action.cancel\"></span></button></div><div class=\"\"><div class=\"image-preview-container\"><!--<div id=\"image-cropper\"></div>--> <img id=\"original-image\" src=\"\" ng-if=\"!$ctrl.islargeFile\"><div class=\"no-image-text\" ng-if=\"!$ctrl.file && !$ctrl.islargeFile\" ng-click=\"$ctrl.chooseImage()\"><i class=\"fa fa-cloud-upload\" style=\"font-size: 60px !important\" aria-hidden=\"true\"></i><div>تصویر را انتخاب کنید.</div><div style=\"font-size:12px\">فرمت های قابل قبول : jpg , png</div><div style=\"font-size:12px\">حداکثر حجم فایل : 2 مگابایت</div></div><div ng-if=\"$ctrl.islargeFile\" class=\"no-image-text\" style=\"color: red; padding: 75px 60px 40px\">حجم تصویر بیشتر از مقدار مجاز است.</div><!--<pf-image-upload-cropper crop-width=\"$ctrl.cropWidth\"--><!--crop-height=\"$ctrl.cropHeight\" ,--><!--min-width=\"$ctrl.minWidth\" ,--><!--min-height=\"$ctrl.minHeight\" ,--><!--cropped-image=\"$ctrl.file\">--><!--</pf-image-upload-cropper>--></div></div></div><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-sm-10\">&ndash;&gt;--><!--&lt;!&ndash;<div id=\"image-cropper\"></div>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;ng-class=\"  {\'noimage imageholder \' :$ctrl.file==null,\'imageholder\':$ctrl.file!=null}\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;<img ng-show=\"!($ctrl.currentImage.fileData==null)\"  ng-src=\"{{$ctrl.imagesrc()}}\"   />&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<img ng-if=\"$ctrl.disableCropping\" class=\"img-responsive\" ng-show=\"$ctrl.file\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;ng-src=\"{{$ctrl.file}}\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div ng-if=\"!$ctrl.disableCropping\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<canvas width=\"1000\" height=\"700\" id=\"canvas\" image-cropper image=\"$ctrl.file\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;cropped-image=\"$ctrl.croppedDataUrl\" crop-width=\"$ctrl.cropWidth\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;crop-height=\"$ctrl.cropHeight\" min-height=\"$ctrl.minWidth\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;min-height=\"$ctrl.minHeight\" keep-aspect=\"$ctrl.keep_aspect\" touch-radius=\"30\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;crop-area-bounds=\"$ctrl.bounds\"></canvas>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<div ng-if=\"!$ctrl.disableCropping\">&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<canvas width=\"150\" height=\"150\" id=\"canvas2\" image-cropper image=\"$ctrl.croppedDataUrl\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;cropped-image=\"$ctrl.croppedThumbDataUrl\" crop-width=\"150\" crop-height=\"150\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;min-height=\"150\" min-height=\"150\" keep-aspect=\"true\" touch-radius=\"30\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;crop-area-bounds=\"$ctrl.bounds\"></canvas>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;<img-crop image=\"$ctrl.file\"&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;area-type=\"square\"&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;result-image=\"$ctrl.croppedDataUrl\"&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;area-min-size=\"1000\"&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;result-image-format=\"image/jpeg\">&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;</img-crop>&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;       <img-crop&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;image=\"{string}\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;result-image=\"{string}\"&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[change-on-fly=\"{boolean}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[area-type=\"{circle|square}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[area-min-size=\"{number}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[result-image-size=\"{number}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[result-image-format=\"{string}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[result-image-quality=\"{number}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[on-change=\"{expression}\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[on-load-begin=\"{expression\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[on-load-done=\"{expression\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;[on-load-error=\"{expression\"]&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;&gt;</img-crop>&ndash;&gt;&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--></div></div></div>");
$templateCache.put("app/components/eyeson/image-upload/eyeson.image-upload.html","<!--<div--><!--class=\"btn btn-primary btn-upload\"--><!--upload-button--><!--url=\"/api/uploadFile\"--><!--multiple=\"true\"--><!--param=\"uploadfile\"--><!--on-success=\"onSuccess(response)\"--><!--&gt;--><!--<span class=\"fa fa-upload\"></span>--><!--آپلود تصویر--><!--</div>--><style>img {\n        display: block;\n\n        /* This rule is very important, please don\'t ignore this */\n        max-width: 100%;\n    }</style><div>Select an image file: <input type=\"file\" id=\"fileInput\"></div><div><img id=\"original-image\" src=\"content/images/homeImage.jpg\"></div><button ng-click=\"$ctrl.cropImage()\">Crop Image</button><div>Cropped Image:</div><div><img ng-src=\"{{$ctrl.myCroppedImage}}\"></div>");
$templateCache.put("app/components/eyeson/intake-data/eyeson.intake-data-viewer.template.html","<style>.intake-field-label {\n        width: 120px;\n        text-align: left;\n        margin: 7px;\n        padding: 10px;\n        background-color: #eeeeeee0;\n        color: #6b6a6a;\n        font-size: 12px;\n        font-weight: bold;\n    }\n\n    .intake-field-value {\n\n        text-align: right;\n        margin: 7px;\n        padding: 10px;\n\n        color: #1f1c1c;\n        font-size: 14px;\n\n    }\n\n    .intake-data-table {\n        width: 95%;\n        max-width: 400px;\n    }\n\n    .intake-data-tr {\n        border-bottom: solid 1px #d2cfcf;\n    }</style><div ng-if=\"$ctrl.intakeData\"><md-button ng-if=\"!$ctrl.isEditMode\" ng-click=\"$ctrl.gotoEditMode()\" class=\"md-raised md-primary\"><span class=\"\">ویرایش اطلاعات تکمیلی</span></md-button><md-button ng-if=\"$ctrl.isEditMode\" ng-click=\"$ctrl.save()\" class=\"md-raised md-primary\"><span class=\"\">ثبت تغییرات</span></md-button><md-button ng-if=\"$ctrl.isEditMode\" ng-click=\"$ctrl.cancelEditing()\" class=\"md-raised\"><span class=\"\">لغو</span></md-button><table class=\"intake-data-table\"><tr class=\"row intake-data-tr\" ng-repeat=\"field in $ctrl.intakeData.fields\"><td class=\"intake-field-label\">{{field.label}}</td><td class=\"intake-field-value\"><eo-intake-field field=\"field\" is-edit-mode=\"$ctrl.isEditMode\"></eo-intake-field></td></tr></table></div>");
$templateCache.put("app/components/eyeson/intake-data/eyeson.intake-field.template.html","<style>.intake-field-label {\n        width: 120px;\n        text-align: left;\n        margin: 7px;\n        padding: 10px;\n        background-color: #eeeeeee0;\n        color: #6b6a6a;\n        font-size: 12px;\n        font-weight: bold;\n    }\n\n    .intake-field-value {\n\n        text-align: right;\n        margin: 7px;\n        padding: 10px;\n\n        color: #1f1c1c;\n        font-size: 14px;\n\n    }\n\n    .intake-data-table {\n        width: 95%;\n        max-width: 400px;\n    }\n\n    .intake-data-tr {\n        border-bottom: solid 1px #d2cfcf;\n    }</style><div ng-if=\"$ctrl.field\"><div ng-if=\"!$ctrl.isEditMode\"><div ng-if=\"!$ctrl.field.isFile\">{{$ctrl.field.value}}</div><div ng-if=\"$ctrl.field.isFile\"><a href=\"{{$ctrl.field.href}}\" target=\"_blank\"><i class=\"fa fa-paperclip\" aria-hidden=\"true\"></i> دانلود فایل </a><!--<button type=\"button\" data-ng-click=\"$ctrl.downloadFile(field)\"  class=\"btn btn-primary\">--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-save\"></span>&ndash;&gt;--><!--<i class=\"fa fa-down\" aria-hidden=\"true\"></i>--><!--&nbsp;<span >دانلود فایل</span>--><!--</button>--></div></div><div ng-if=\"$ctrl.isEditMode\"><!--TextBox,--><!--TextArea,--><!--File,--><!--Dropdown,--><!--RadioButton,--><!--CheckBox--><div ng-if=\"$ctrl.field.field.fieldType==\'TextBox\' || $ctrl.field.field.fieldType==\'TextArea\'\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.field.value\"></div><div ng-if=\"$ctrl.field.field.fieldType==\'Number\'\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.field.value\"></div><div ng-if=\"$ctrl.field.field.fieldType==\'Dropdown\' || $ctrl.field.field.fieldType==\'RadioButton\'\"><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.field.value\"><!--style=\"min-width: 300px;\">--><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.selectableItems\">{{si}}</md-option></md-select></div><div ng-if=\"$ctrl.field.field.fieldType==\'File\'\">{{$ctrl.field.href}}</div><div ng-if=\"$ctrl.field.field.fieldType==\'Date\'\"><eo-date-picker id=\"dateField\" date-value=\"$ctrl.dateValue\"></eo-date-picker></div></div></div>");
$templateCache.put("app/components/eyeson/intake-data-component/component-intake-data-dialog.html","<style>md-dialog {\n        width: 80%;\n        /*min-width: 320px*/\n    }\n\n    md-dialog.content {\n        width: 80%;\n        /*min-width: 320px*/\n    }\n\n    .edittime-dialog-content {\n        min-height: 400px;\n        min-width: 400px;\n        max-width: 600px;\n        padding: 10px;;\n    }\n\n    .demo-md-panel {\n        min-height: 500px;\n    }\n\n    .demo-dialog-example {\n        background: white;\n        border-radius: 4px;\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),\n        0 13px 19px 2px rgba(0, 0, 0, 0.14),\n        0 5px 24px 4px rgba(0, 0, 0, 0.12);\n        width: 500px;\n    }\n\n    .demo-dialog-content {\n        padding: 0 15px;\n        width: 100%;\n    }\n\n    .demo-dialog-content img {\n        height: 300px;\n        margin: auto;\n    }\n\n    .demo-dialog-button {\n        width: 100%;\n    }\n\n    .demo-dialog-custom-animation-open {\n        opacity: 1;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(390deg);\n    }\n\n    .demo-dialog-custom-animation-close {\n        opacity: 0;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(0deg);\n    }\n\n    .container-wide {\n        width: 100%;\n    }\n\n    .container-small {\n        width: 70%;\n        right: 110px;\n    }\n\n\n    @media (max-width: 480px) {\n        h3, h4 {\n            font-size: medium;\n        }\n\n        md-dialog-content {\n            overflow-x: hidden !important;\n        }\n\n        eo-time-range > div {\n            display: grid;\n        }\n    }</style><md-dialog ng-class=\"$ctrl.getContainerClass()\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools pl-modal-header modal-header pl-modal-border\"><h5>{{$ctrl.customerFormData.companyCustomForm.title}} /</h5><h4>{{$ctrl.customerFormData.companyCustomer.customerFullName}}</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\"><i class=\"material-icons\">close</i></md-button></div></md-toolbar><md-dialog-content><component-intake-data-viewer intake-data=\"$ctrl.customerFormData.intakeDataDTO\" column-count=\"$ctrl.columnCount\"></component-intake-data-viewer></md-dialog-content><md-dialog-actions layout=\"row\" class=\"pl-dialog-actions\"><md-button class=\"md-raised md-primary pl-btn-primary\" ng-click=\"$ctrl.save()\">تایید</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/eyeson/intake-data-component/component-intake-data-viewer.template.html","<style>.intake-field-label {\n        width: 120px;\n        text-align: left;\n        margin: 7px;\n        padding: 10px;\n        background-color: #eeeeeee0;\n        color: #6b6a6a;\n        font-size: 12px;\n        font-weight: bold;\n    }\n\n    .intake-field-value {\n\n        text-align: right;\n        margin: 7px;\n        padding: 5px;\n\n        color: #1f1c1c;\n        font-size: 14px;\n\n    }\n\n    .intake-data-table-c {\n        /*width: 95%;*/\n        /*max-width: 400px;*/\n        margin: 20px 10px;\n    }\n\n    /*.intake-data-tr*/\n    /*{*/\n    /*border-bottom: solid 1px #d2cfcf;*/\n    /*}*/</style><div class=\"intake-viewer-container\" ng-if=\"$ctrl.intakeData\"><!--<md-button ng-if=\"!$ctrl.isEditMode\"--><!--ng-click=\"$ctrl.gotoEditMode()\"--><!--class=\"md-raised md-primary\">--><!--<span class=\"\" >--><!--ویرایش اطلاعات تکمیلی--><!--</span>--><!--</md-button>--><!--<md-button ng-if=\"$ctrl.isEditMode\"--><!--ng-click=\"$ctrl.save()\"--><!--class=\"md-raised md-primary\">--><!--<span class=\"\" >--><!--ثبت تغییرات--><!--</span>--><!--</md-butt0on>--><!--<md-button ng-if=\"$ctrl.isEditMode\"--><!--ng-click=\"$ctrl.cancelEditing()\"--><!--class=\"md-raised\">--><!--<span class=\"\" >--><!--لغو--><!--</span>--><!--</md-button>--><div class=\"intake-data-table-c\"><div ng-if=\"$ctrl.columnCount && $ctrl.columnCount > 1\"><div ng-repeat=\"field in $ctrl.intakeData.fields\"><div ng-if=\"!field.field.isConditional || (field.field.isConditional && field.field.conditionalParentValues.includes($ctrl.values[field.field.conditionalParentFieldName]))\" class=\"intake-field-value row\"><div ng-if=\"field.field.fieldType==\'TextArea\'\"><div class=\"col-sm-12\"><component-intake-field field=\"field\" is-edit-mode=\"$ctrl.isEditMode\"></component-intake-field></div></div><div ng-if=\"field.field.fieldType != \'TextArea\'\"><div ng-class=\"$ctrl.findColumnCountClass()\"><component-intake-field field=\"field\" is-edit-mode=\"$ctrl.isEditMode\"></component-intake-field></div></div></div></div></div><div ng-if=\"$ctrl.columnCount == null || $ctrl.columnCount == 1\"><div class=\"intake-data-tr\" ng-repeat=\"field in $ctrl.intakeData.fields\"><!--<td class=\"intake-field-label\">{{field.label}}</td>--><div class=\"col-sm-6 intake-field-value\"><component-intake-field field=\"field\" is-edit-mode=\"$ctrl.isEditMode\"></component-intake-field></div></div></div></div></div>");
$templateCache.put("app/components/eyeson/intake-data-component/component-intake-field.template.html","<style>.intake-field-label {\n        width: 120px;\n        text-align: left;\n        margin: 7px;\n        padding: 10px;\n        background-color: #eeeeeee0;\n        color: #6b6a6a;\n        font-size: 12px;\n        font-weight: bold;\n    }\n\n    .intake-field-value {\n\n        text-align: right;\n        margin: 7px;\n        padding: 10px 5px;\n\n        color: #1f1c1c;\n        font-size: 14px;\n\n    }\n\n    .intake-data-table {\n        width: 95%;\n        max-width: 400px;\n    }\n\n    .intake-data-tr {\n        /*border-bottom: solid 1px #d2cfcf;*/\n        border: none;\n    }\n\n    label {\n        font-size: 12px !important;\n        font-weight: bold !important;\n    }\n\n    textarea {\n        /*background-color: white !important;*/\n        border: 1px solid #eeeeee !important;\n    }</style><div ng-if=\"$ctrl.field\"><div ng-if=\"!$ctrl.isEditMode\"><div ng-if=\"!$ctrl.field.isFile\">{{$ctrl.field.value}}</div><div ng-if=\"$ctrl.field.isFile && $ctrl.field.isFile\"><a href=\"{{$ctrl.field.href}}\" target=\"_blank\"><i class=\"fa fa-paperclip\" aria-hidden=\"true\"></i> دانلود فایل </a><!--<button type=\"button\" data-ng-click=\"$ctrl.downloadFile(field)\"  class=\"btn btn-primary\">--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-save\"></span>&ndash;&gt;--><!--<i class=\"fa fa-down\" aria-hidden=\"true\"></i>--><!--&nbsp;<span >دانلود فایل</span>--><!--</button>--></div></div><div ng-if=\"$ctrl.isEditMode\"><!--TextBox,--><!--TextArea,--><!--File,--><!--Dropdown,--><!--RadioButton,--><!--CheckBox--><div ng-if=\"$ctrl.field.field.fieldType==\'TextBox\'\"><label for=\"textField\">{{$ctrl.field.label}}</label><input id=\"textField\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.field.value\"></div><div ng-if=\"$ctrl.field.field.fieldType==\'Number\'\"><label for=\"numberField\">{{$ctrl.field.label}}</label><input id=\"numberField\" type=\"number\" class=\"form-control\" ng-model=\"$ctrl.field.value\"></div><div ng-if=\"$ctrl.field.field.fieldType==\'TextArea\'\"><label for=\"textField\">{{$ctrl.field.label}}</label><textarea id=\"textField\" class=\"form-control\" ng-model=\"$ctrl.field.value\" rows=\"4\" cols=\"50\"></textarea></div><div ng-if=\"$ctrl.field.field.fieldType==\'Dropdown\' || $ctrl.field.field.fieldType==\'RadioButton\'\"><label for=\"dropdownField\">{{$ctrl.field.label}}</label><md-select id=\"dropdownField\" class=\"rwMdSelect\" ng-model=\"$ctrl.field.value\"><!--style=\"min-width: 300px;\">--><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.selectableItems\">{{si}}</md-option></md-select></div><div ng-if=\"$ctrl.field.field.fieldType==\'File\'\"><!--{{$ctrl.field.href}}--><label>{{$ctrl.field.label}}</label><eo-file-upload file-name=\"$ctrl.field.value\" label=\"$ctrl.field.label\"></eo-file-upload></div><div ng-if=\"$ctrl.field.field.fieldType==\'CheckBox\'\"><label for=\"dropdownField\"></label><md-checkbox id=\"checkBoxField\" ng-model=\"$ctrl.field.checkValue\" aria-label=\"\" class=\"form-control\" ng-change=\"$ctrl.checkChange()\">{{$ctrl.field.label}}</md-checkbox></div><div ng-if=\"$ctrl.field.field.fieldType==\'Date\'\"><label for=\"dateField\">{{$ctrl.field.label}}</label><div><eo-date-picker id=\"dateField\" date-value=\"$ctrl.field.value\"></eo-date-picker></div></div></div></div>");
$templateCache.put("app/components/eyeson/multi-select-autocomplete/eyeson.multi-select-autocomplete.template.html","<style type=\"text/css\">.multi-select {\n        padding: 20px;\n        /*max-width: 600px;*/\n    }\n\n    .multi-select ul.tags {\n        list-style: none;\n        border-bottom: 1px solid #aaa;\n        width: 100%;\n        padding: 5px;\n        margin-bottom: 0;\n        cursor: text;\n    }\n\n    .multi-select ul.tags.focused {\n        border-bottom: 1px solid #26a69a;\n        box-shadow: 0 1px 0 0 #26a69a;\n    }\n\n\n    .multi-select ul li.tag {\n        display: inline;\n        padding: 2px 2px 2px 5px;\n        border: 1px solid #aaa;\n        background-color: #eee;\n        border-radius: 5px;\n        margin-right: 5px;\n        color: #333;\n        cursor: pointer;\n    }\n\n    .multi-select ul li.inputtag {\n        display: inline;\n        margin-right: 5px;\n        color: #333;\n    }\n\n    .multi-select ul li.inputtag input {\n        border: none;\n        display: inline;\n        height: initial;\n        width: initial;\n        margin: initial;\n        background: none;\n    }\n\n    .multi-select ul li.inputtag input:focus {\n        border: none;\n        display: inline;\n        height: initial;\n        width: initial;\n        margin: initial;\n        border-bottom: none;\n        box-shadow: none;\n        background: none;\n    }\n\n    .multi-select ul li.inputtag input:focus {\n        outline: none;\n    }\n\n\n    .multi-select ul.list {\n        list-style: none;\n        border: 1px solid #aaa;\n        border: none;\n        width: 90%;\n        padding: 0;\n        margin: 0;\n        z-index: 1000;\n        position: absolute;\n        background-color: white;\n    }\n\n    .multi-select ul.list li {\n        padding: 5px;\n        cursor: pointer;\n    }\n\n    .multi-select ul.list li.active {\n        background-color: rgba(21, 91, 61, 0.2);\n    }\n\n\n    .multi-select ul li span {\n        padding-left: 5px;\n        padding-right: 2px;\n        font-weight: bold;\n        font-family: sans-serif;\n        color: rgba(0, 0, 0, 0.5);\n        text-transform: lowercase;\n        font-height: 10px;\n    }</style><div ng-cloak=\"\" class=\"multi-select\"><ul data-ng-class=\"{\'focused\': focused}\" class=\"form-control\" data-ng-click=\"$ctrl.focusIn()\"><li class=\"tag\" data-ng-repeat=\"s in $ctrl.list track by $index\">{{$ctrl.getDisplayTag(s)}} <span data-ng-click=\"$ctrl.removeItem(s)\">x</span></li><li class=\"inputtag\"><input data-ng-blur=\"$ctrl.focusOut()\" focus=\"{{$ctrl.focused}}\" data-ng-model-options=\"{debounce: 500}\" type=\"text\" data-ng-model=\"$ctrl.itemsearch\" data-ng-keydown=\"$ctrl.keyPress($event)\"></li></ul><ul class=\"list\" data-ng-show=\"$ctrl.focused\"><li data-ng-class=\"{\'active\': $ctrl.selPos == $index}\" data-ng-repeat=\"item in ($ctrl.filteredItems = ($ctrl.items | notin: $ctrl.list | filter: $ctrl.itemsearch | limitTo: 10)) track by $index\" data-ng-mousedown=\"$ctrl.addItem(item)\" data-ng-mouseover=\"$ctrl.hover($index)\">{{$ctrl.getDisplayItem(item)}}</li></ul></div>");
$templateCache.put("app/components/eyeson/no-data/eyeson.no-data.template.html","<style>.no-data-class {\n        text-align: center;\n        padding: 40px;\n    }\n\n    .no-data-title {\n        font-weight: bold;\n        padding: 40px;\n        color: #707070;\n    }\n\n    .no-data-icon {\n\n    }</style><div class=\"no-data-class\"><div class=\"no-data-icon\"><img src=\"content/images/no-data.png\" style=\"width: 90px\"></div><div class=\"no-data-title\">{{$ctrl.message}}</div></div>");
$templateCache.put("app/components/eyeson/numeric-input/eyeson.numeric-input-v2.template.html","<input type=\"text\" name=\"{{$ctrl.name}}\" ng-class=\"$ctrl.getClass()\" ng-model=\"$ctrl.inputValueCurrency\" ng-change=\"$ctrl.onValueChange()\" ng-disabled=\"$ctrl.isDisabled\" ng-required=\"$ctrl.isRequired\" placeholder=\"{{$ctrl.placeholder ? $ctrl.placeholder : \'\'}}\" maxlength=\"{{$ctrl.maxlength ? $ctrl.maxlength : 100}}\" min=\"{{$ctrl.min ? $ctrl.min : 0}}\" ng-attr-max=\"{{ $ctrl.max || undefined }}\" eo-min-length-validator=\"{{$ctrl.minlength}}\" eo-min-validator=\"{{$ctrl.min}}\"><div class=\"error-message\" ng-messages=\"$ctrl.formReference[$ctrl.name].$error\" ng-show=\"$ctrl.formReference[$ctrl.name].$touched\"><p ng-message=\"required\"><span translate=\"entity.validation.required\"></span></p><p ng-message=\"minValidator\"><span translate=\"entity.validation.min\" translate-values=\"{min: \'{{$ctrl.min}}\'}\"></span></p><!--<p ng-message=\"minLengthValidator\">--><!--<span translate=\"entity.validation.min\" translate-values=\"{min: \'{{$ctrl.min}}\'}\"></span>--><!--</p>--></div>");
$templateCache.put("app/components/eyeson/numeric-input/eyeson.numeric-input.template.html","<input type=\"text\" name=\"{{$ctrl.name}}\" ng-class=\"$ctrl.getClass()\" ng-model=\"$ctrl.inputValue\" ng-change=\"$ctrl.onValueChange()\" ng-disabled=\"$ctrl.isDisabled\" ng-required=\"$ctrl.isRequired\" placeholder=\"{{$ctrl.placeholder ? $ctrl.placeholder : \'\'}}\" maxlength=\"{{$ctrl.maxlength ? $ctrl.maxlength : 100}}\" eo-min-length-validator=\"{{$ctrl.minlength}}\" eo-min-validator=\"{{$ctrl.min}}\"><div class=\"error-message\" ng-messages=\"$ctrl.formReference[$ctrl.name].$error\" ng-show=\"$ctrl.formReference[$ctrl.name].$touched\"><p ng-message=\"required\"><span translate=\"entity.validation.required\"></span></p><p ng-message=\"minValidator\"><span translate=\"entity.validation.min\" translate-values=\"{min: \'{{$ctrl.min}}\'}\"></span></p><!--<p ng-message=\"minLengthValidator\">--><!--<span translate=\"entity.validation.min\" translate-values=\"{min: \'{{$ctrl.min}}\'}\"></span>--><!--</p>--></div>");
$templateCache.put("app/components/eyeson/persian-date/eyeson.persian-date.template.html","<p>تاریخ</p>");
$templateCache.put("app/components/eyeson/pl-general-actions/eyeson.pl-general-actions.template.html","<eo-fixed-button on-click=\"$ctrl.openActions()\" label=\"افزودن\"></eo-fixed-button>");
$templateCache.put("app/components/eyeson/pl-general-actions/general-actions-bottom-sheet-template.html","<div class=\"pl-bottom-sheet-container\"><div class=\"pl-bottom-sheet-content\"><ul><li ng-click=\"vm.itemClick(\'newReserve\')\">ثبت رزرو جدید</li><li ng-click=\"vm.itemClick(\'closeDates\')\">ثبت تعطیلی</li><li ng-click=\"vm.itemClick(\'openDates\')\">ثبت استثنا(باز)</li></ul></div><div class=\"pl-bottom-sheet-content\"><div class=\"pl-bottom-sheet-close-btn\" ng-click=\"vm.close()\">بستن</div></div></div>");
$templateCache.put("app/components/eyeson/pl-modal-footer/eyeson.pl-modal-footer.template.html","<div class=\"pl-modal-footer visible-xs\"><div class=\"\" style=\"display: flex\"><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" type=\"submit\" ng-disabled=\"$ctrl.isDisabled\" ng-click=\"$ctrl.okModal()\"><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;--> <span ng-if=\"!$ctrl.okTitle\" translate=\"entity.action.save\">Save</span> <span ng-if=\"$ctrl.okTitle\">{{$ctrl.okTitle | translate}}</span></md-button><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span>بازگشت</span><md-icon style=\"color: #000\">keyboard_backspace</md-icon></md-button></div></div>");
$templateCache.put("app/components/eyeson/pl-modal-header/eyeson.pl-modal-header.template.html","<div class=\"pl-modal-header modal-header pl-modal-border\"><div class=\"pl-modal-title\" ng-if=\"$ctrl.title\">{{$ctrl.title | translate}}</div><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"$ctrl.closeModal()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div><div class=\"hidden-xs\"><md-button type=\"button\" class=\"md-raised md-secondary pull-left pl-btn pl-btn-default\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><!--<span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span--><!--translate=\"entity.action.cancel\">Cancel</span>--> <span>بازگشت</span><md-icon style=\"color: #000\">keyboard_backspace</md-icon></md-button><md-button class=\"md-raised md-primary pull-left pl-btn pl-btn-primary\" type=\"submit\" ng-disabled=\"$ctrl.isDisabled\" ng-click=\"$ctrl.okModal()\"><!--<span class=\"glyphicon glyphicon-save\"></span>&nbsp;--> <span ng-if=\"!$ctrl.okTitle\" translate=\"entity.action.save\">Save</span> <span ng-if=\"$ctrl.okTitle\">{{$ctrl.okTitle | translate}}</span></md-button></div></div>");
$templateCache.put("app/components/eyeson/pl-search-box/eyeson.pl-search-box.template.html","<div class=\"form-group pl-customer-search-container\"><div class=\"pl-search-container\"><input class=\"form-control\" style=\"border:none !important\" ng-model=\"$ctrl.searchQuery\" placeholder=\"{{$ctrl.searchPlaceHolder | translate}}\" type=\"search\" ng-keypress=\"$ctrl.searchKeyPress($event)\"><md-icon ng-if=\"$ctrl.searchQuery\" ng-click=\"$ctrl.clearSearch()\" style=\"padding-left: 5px;font-weight: bold\">close</md-icon></div><div id=\"search-btn-xs\" class=\"pl-search-btn\" ng-click=\"$ctrl.search()\"><md-icon style=\"width: 33px; height: 35px; font-size: 35px; padding-top: 6px;color: #000\">search</md-icon></div><div id=\"filter-btn-xs\" class=\"pl-search-btn\" ng-if=\"$ctrl.canFilter\" ng-click=\"$ctrl.filterClick()\"><md-icon style=\"width: 33px; height: 35px; font-size: 35px; padding-top: 6px;color: #000\">filter_list</md-icon><div class=\"filter-btn-counter\" ng-if=\"$ctrl.filterCount && $ctrl.filterCount>0\">{{$ctrl.filterCount}}</div></div></div>");
$templateCache.put("app/components/eyeson/pl-select/eyeson.pl-select.template.html","<!--<style>--><!--</style>--><!--&lt;!&ndash;mobile view&ndash;&gt;--><!--<select class=\"rwMdSelect hidden-md hidden-lg hidden-sm\"--><!--placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\"--><!--ng-model=\"$ctrl.selectValue\"--><!--id=\"field_select_mobile\"--><!--&gt;--><!--<option ng-value=\"si.id\" ng-repeat=\"si in vm.servicecategories\">--><!--{{si.categoryName}}--><!--</option>--><!--</select>--><!--&lt;!&ndash;desktop view&ndash;&gt;--><!--<md-select class=\"rwMdSelect hidden-xs\"--><!--placeholder=\"{{\'tikonApp.serviceItem.selectCategory\' | translate}}\"--><!--ng-model=\"vm.serviceItem.category.id\"--><!--id=\"field_select\"--><!--&gt;--><!--<md-option ng-value=\"si.id\" ng-repeat=\"si in vm.servicecategories\">--><!--{{si.categoryName}}--><!--</md-option>--> <!--</md-select>-->");
$templateCache.put("app/components/eyeson/progress-bar/eyeson.progress-bar.template.html","<md-progress-circular ng-show=\"!$ctrl.disableProgress\" md-mode=\"indeterminate\" ng-disabled=\"$ctrl.disableProgress\"></md-progress-circular>");
$templateCache.put("app/components/eyeson/rich-text-editor/eyeson.rich-text-editor.template.html","<style>.rich-text-editor {\n        min-height: 150px;\n        width: 100%;\n    }</style><!--mobile view--><textarea ng-if=\"!$ctrl.hasHtmlTags\" ng-model=\"$ctrl.inputValue\" class=\"rich-text-editor visible-xs\"></textarea><div ng-if=\"$ctrl.hasHtmlTags\" class=\"visible-xs\"><div class=\"form-control\" height=\"200\" type=\"text\" summernote ng-model=\"$ctrl.inputValue\"></div></div><!--desktop view--><div class=\"hidden-xs\"><div id=\"summernoteId\" class=\"form-control\" height=\"200\" type=\"text\" summernote ng-model=\"$ctrl.inputValue\"></div></div>");
$templateCache.put("app/components/eyeson/scheduler/eyeson.scheduler-time-session-dialog.template.html","<style>@media (width: 400px) {\n        .selected-date-on-dialog {\n            font-size: 12px;\n        }\n    }</style><div style=\"z-index: 999999999999999999\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"$ctrl.cancelDialog()\">&times;</button><h4 class=\"modal-title selected-date-on-dialog\" id=\"myInvoiceInfoLabel\">{{$ctrl.title}}</h4></div><div ng-if=\"$ctrl.dialogData \" class=\"modal-body\" style=\"min-height: 300px;max-width: 500px\"><div ng-if=\"!$ctrl.dialogData.isNew\"><div has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><div class=\"row\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><div class=\"col-sm-6 text-right\"><a></a> <button ng-disabled=\"$ctrl.dialogData.capacity<=0 || !$ctrl.dialogData.enable\" type=\"button\" style=\"float: right\" class=\"btn btn-primary\" ng-click=\"$ctrl.gotoNewReserve($ctrl.timeSessionDtail.serviceItemId)\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.orderBag.newReserveForTimeSession\">Create new Order Bag Service Item</span></button></div><div class=\"col-sm-6\"><button ng-if=\"!$ctrl.dialogData.enable\" type=\"button\" style=\"float: left\" class=\"btn btn-success\" ng-click=\"$ctrl.changeEnable($ctrl.dialogData)\"><i class=\"fa fa-circle-check\" aria-hidden=\"true\"></i> <span translate=\"tikonApp.serviceItem.makeEnable\">Create new Order Bag Service Item</span></button> <button ng-if=\"$ctrl.dialogData.enable\" type=\"button\" style=\"float: left\" class=\"btn btn-danger\" ng-click=\"$ctrl.changeEnable($ctrl.dialogData)\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.makeDisable\">Create new Order Bag Service Item</span></button></div></div><div class=\"row\" has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.scheduleDialog.capacity\">Capacity</label><eo-editable-input type=\"number\" is-editable=\"$ctrl.dialogData.enable && !$ctrl.dialogData.floatTime \" readonly=\"readonly\" on-confirm-edit=\"$ctrl.updateCapacity(value)\" name=\"qty\" id=\"field_capacity\" value=\"$ctrl.dialogData.capacity\"><!--<span ng-repeat=\"ser in $ctrl.timeSessionDtail.servants\">--><!--<span >--><!--{{ser.servant.servantName}}--><!--</span>--><!--</span>--></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.scheduleDialog.price\">Capacity</label><input type=\"number\" readonly=\"readonly\" class=\"form-control\" name=\"qty\" id=\"field_price\" ng-model=\"$ctrl.dialogData.price\"></div></div><!--<div class=\"col-sm-3\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.serviceItem.scheduleDialog.discount\">Capacity</label>--><!--<eo-editable-input type=\"number\" readonly=\"readonly\" on-confirm-edit=\"$ctrl.updateDiscount(value)\"--><!--is-editable=\"$ctrl.dialogData.enable && !$ctrl.dialogData.floatTime \"--><!--name=\"qty\" id=\"field_capacity\"--><!--value=\"$ctrl.dialogData.discount\"--><!--/>--><!--&lt;!&ndash;<input type=\"number\" readonly=\"readonly\"  class=\"form-control\" name=\"qty\" id=\"field_discount\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.dialogData.discount\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--</div>--><!--</div>--><div class=\"col-sm-10\"><a has-any-authority=\"ROLE_COMPANY_MANAGER,ROLE_RESERVATION_MODIFIER\" data-ng-click=\"$ctrl.copyTSimilarTimes()\"><i class=\"fa fa-copy\" aria-hidden=\"true\"></i> <span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.copyToSimilarTimesessions\">Create new Order Bag Service Item</span></a></div></div><hr></div><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div><span translate=\"tikonApp.orderBag.currentSessionReservs\"></span></div></div><div class=\"panel-body\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" callback=\"vm.transition()\"><th><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th has-authority=\"ROLE_CUSTOMER_MANAGER\"><span translate=\"tikonApp.personInfo.phoneNumber\">phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.status.title\">status</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"order in $ctrl.timeSessionDtail.customerOrders \"><td><a ng-click=\"$ctrl.gotoOrderBag(order.orderBagId)\">{{order.orderBagId}}</a></td><td>{{order.customer.fisrtName}} {{order.customer.lastName}}</td><td has-authority=\"ROLE_CUSTOMER_MANAGER\">{{order.customer.phoneNumber}}</td><td><div>{{\'tikonApp.orderBag.status.\'+order.status | translate}}</div><div style=\"font-size: 10px;color: #2f96b4\">{{order.servantName}}</div></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"$ctrl.dialogData && $ctrl.dialogData.isNew\" style=\"min-height: 200px;max-width: 700px\">ثبت جدید</div><div class=\"modal-footer\"><!--  <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.cancelDialog()\">\n              <span class=\"glyphicon glyphicon-ban-circle\">\n\n              </span>&nbsp;\n              <span\n                  translate=\"entity.action.cancel\">Cancel\n              </span>\n          </button>\n          <button type=\"button\" ng-click=\"$ctrl.saveDialog()\" class=\"btn btn-default\">\n              <span class=\"glyphicon glyphicon-save\"></span>&nbsp;\n              <span translate=\"entity.action.save\">Save</span>\n          </button>--></div></div>");
$templateCache.put("app/components/eyeson/scheduler/eyeson.scheduler.template.html","<style>.sch-offDate {\n        background-color: rgba(255, 87, 34, 0.15);\n    }\n\n    .light-box-style {\n        position: absolute;\n        top: 100px;\n        left: 200px;\n        z-index: 100000001;\n        display: none;\n        background-color: white;\n        border: 2px outset gray;\n        padding: 20px;\n        font-family: Tahoma;\n        font-size: 10pt;\n    }\n\n    .scheduler_no_capacity {\n        background-color: rgba(255, 32, 13, 0.51) !important;\n\n    }\n\n    .scheduler_no_capacity .dhx_body {\n        background-color: rgba(255, 32, 13, 0.51) !important;\n\n    }\n\n    .scheduler_no_capacity .dhx_header {\n        background-color: rgba(255, 32, 13, 0.51) !important;\n    }\n\n    .scheduler_no_capacity .dhx_footer {\n        background-color: rgba(255, 32, 13, 0.51) !important;\n    }\n\n    .scheduler_no_capacity .dhx_title {\n        background-color: rgba(255, 32, 13, 0.51) !important;\n    }\n\n    .scheduler_hidden_event {\n        display: none;\n    }\n\n    .scheduler_not_enable {\n        background-color: rgba(180, 178, 178, 0.65) !important;\n\n    }\n\n    .scheduler_not_enable .dhx_body {\n        background-color: rgba(180, 178, 178, 0.65) !important;\n\n    }\n\n    .scheduler_not_enable .dhx_header {\n        background-color: rgba(180, 178, 178, 0.65) !important;\n    }\n\n    .scheduler_not_enable .dhx_footer {\n        background-color: rgba(180, 178, 178, 0.65) !important;\n    }\n\n    .scheduler_not_enable .dhx_title {\n        background-color: rgba(180, 178, 178, 0.65) !important;\n    }\n\n    .scheduler_available {\n        background-color: rgba(9, 191, 26, 0.6);\n    }\n\n    .scheduler_available .dhx_body {\n        background-color: rgba(9, 191, 26, 0.6);\n    !important;\n\n    }\n\n    .scheduler_available .dhx_header {\n        background-color: rgba(9, 191, 26, 0.6);\n    !important;\n    }\n\n    .scheduler_available .dhx_footer {\n        background-color: rgba(9, 191, 26, 0.6);\n    !important;\n    }\n\n    .scheduler_available .dhx_title {\n        background-color: rgba(9, 191, 26, 0.6);\n    !important;\n    }\n\n    .scheduler_has_orders_to_confirm {\n        background-color: rgba(255, 179, 25, 0.78) !important;\n\n    }\n\n    .scheduler_has_orders_to_confirm .dhx_body {\n        background-color: rgba(255, 179, 25, 0.78) !important;\n\n    }\n\n    .scheduler_has_orders_to_confirm .dhx_header {\n        background-color: rgba(255, 179, 25, 0.78) !important;\n    }\n\n    .scheduler_has_orders_to_confirm .dhx_footer {\n        background-color: rgba(255, 179, 25, 0.78) !important;\n    }\n\n    .scheduler_has_orders_to_confirm .dhx_title {\n        background-color: rgba(255, 179, 25, 0.78) !important;\n    }\n\n    /*scheduler_has_confirmed_orders*/\n    .scheduler_has_confirmed_orders {\n        background-color: rgb(38, 160, 49) !important;\n\n    }\n\n    .scheduler_has_confirmed_orders .dhx_body {\n        background-color: rgb(38, 160, 49) !important;\n\n    }\n\n    .scheduler_has_confirmed_orders .dhx_header {\n        background-color: rgb(38, 160, 49) !important;\n    }\n\n    .scheduler_has_confirmed_orders .dhx_footer {\n        background-color: rgb(38, 160, 49) !important;\n    }\n\n    .scheduler_has_confirmed_orders .dhx_title {\n        background-color: rgb(38, 160, 49) !important;\n    }\n\n    /*////wait to pay*/\n    .scheduler_has_orders_to_pay {\n        background-color: rgba(32, 150, 255, 0.73) !important;\n\n    }\n\n    .scheduler_has_orders_to_pay .dhx_body {\n        background-color: rgba(32, 150, 255, 0.73) !important;\n\n    }\n\n    .scheduler_has_orders_to_pay .dhx_header {\n        background-color: rgba(32, 150, 255, 0.73) !important;\n    }\n\n    .scheduler_has_orders_to_pay .dhx_footer {\n        background-color: rgba(32, 150, 255, 0.73) !important;\n    }\n\n    .scheduler_has_orders_to_pay .dhx_title {\n        background-color: rgba(32, 150, 255, 0.73) !important;\n    }\n\n    .scheduler_tooltip {\n        direction: rtl;\n        width: 200px;\n    }\n\n    .helper-box {\n\n\n        font-size: 12px;\n        text-align: right;\n    }\n\n    .color-box {\n        width: 10px;\n        height: 10px;\n        float: right;\n    }\n\n    .label-box {\n        float: right;\n        width: 100px;\n        text-align: right;\n        font-size: 9px;\n        color: #595959;\n        margin: -2px;\n        margin-right: 5px;\n    }\n\n    @media (max-width: 400px) {\n        .current-date-style {\n            font-size: 12px !important;\n        }\n\n        .helper-box {\n            display: none;\n        }\n\n\n    }</style><div class=\"helper-box\"><div class=\"color-box scheduler_available\"></div><div class=\"label-box\">قابل رزرو</div><div class=\"color-box scheduler_no_capacity\"></div><div class=\"label-box\">ظرفیت تکمیل شده</div><div class=\"color-box scheduler_has_orders_to_pay\"></div><div class=\"label-box\">رزروهای در انتظار پرداخت</div><div class=\"color-box scheduler_has_orders_to_confirm\"></div><div class=\"label-box\">رزروهای در انتظار تایید</div><div class=\"color-box scheduler_not_enable\"></div><div class=\"label-box\">غیرفعال</div></div><br><br><div class=\"dhx_cal_navline\"><div class=\"dhx_cal_next_button\">&nbsp;</div><div class=\"dhx_cal_prev_button\">&nbsp;</div><div class=\"dhx_cal_today_button hidden-xs\"></div><div class=\"dhx_cal_date current-date-style\"></div><div class=\"dhx_cal_tab\" name=\"week_tab\" style=\"right:140px\"></div><div class=\"dhx_cal_tab\" name=\"day_tab\" style=\"right:204px\"></div><!--<div class=\"dhx_cal_tab\" name=\"month_tab\" style=\"right:76px;\"></div>--></div><div class=\"dhx_cal_header\"></div><div class=\"dhx_cal_data\"></div>");
$templateCache.put("app/components/eyeson/tags/eyeson.tags.template.html","<!--md-no-cache=\"$ctrl.noCache\"--><style>.tag {\n        float: right;\n        font-family: \"IRANSansWeb Light\";\n    }\n\n    .md-chips .md-chip {\n        float: right !important;\n        font-family: inherit !important;\n    }\n\n    .md-chips {\n        font-family: inherit !important;\n    }</style><div class=\"tag\"><md-chips ng-model=\"$ctrl.selectedTagsArray\" md-autocomplete-snap md-require-match=\"true\" md-on-add=\"$ctrl.selectedTagsChange()\" md-on-remove=\"$ctrl.selectedTagsChange()\"><md-autocomplete md-selected-item=\"$ctrl.selectedItem\" md-search-text=\"$ctrl.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=\"item.name\" placeholder=\"انتخاب تگ\"><span md-highlight-text=\"$ctrl.searchText\">{{item.name}}</span></md-autocomplete><md-chip-template style=\"float: right\"><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips></div>");
$templateCache.put("app/components/eyeson/time-picker/eyeson.time-picker.template.html","<style>.time-picker-wrapper {\n        width: 150px;\n        z-index: 100000000;\n\n    }\n\n    .time-picker-icon {\n        font-size: 1.1em;\n        color: #a4a7a7;\n        padding: 5px;\n        width: 20%;\n    }\n\n    .time-picker-input {\n        width: 60%;\n        border: none;\n        font-size: 1em;\n        background: none;\n        text-align: center;\n        font-size: 1.1em;\n    }\n\n    .time-picker-container {\n        margin-bottom: 5px !important;\n        /*margin-top: 5px !important;*/\n    }\n\n    @media (max-width: 767px) {\n        .time-picker-container {\n            /*margin-top: 10px !important;*/\n            margin-bottom: 5px !important;\n        }\n    }</style><!--<div style=\"direction: ltr\">--><!--<md-time-picker ng-model=\"$ctrl.time\" message=\"$ctrl.message\" read-only=\"$ctrl.readonly\" mandatory=\"$ctrl.required\" no-meridiem no-auto-switch></md-time-picker>--><!--</div>--><!--<div class=\"form-control time-picker-wrapper \"\n     moment-picker=\"$ctrl.momentTime\"\n     min-date=\"$ctrl.minMomentTime\"\n     show-header=\"true\"\n     format=\"HH:mm\">\n\n    <input class=\" time-picker-input\"\n           placeholder=\"&#45;&#45;:&#45;&#45;\"\n           ng-model=\"$ctrl.momentTime\"\n\n           change=\"$ctrl.onChange(newValue, oldValue)\"\n           ng-model-options=\"{ updateOn: \'blur\' }\">\n      <span class=\"time-picker-icon\">\n        <i class=\"glyphicon glyphicon-time\"></i>\n    </span>\n</div>--><div class=\"time-picker-wrapper\"><!--  <div class=\"pull-right\" >\n          <span class=\"time-picker-icon\">\n          <i class=\"glyphicon glyphicon-time\"></i>\n      </span>\n      </div>--><div id=\"timePicker\" class=\"pull-right\"><md-input-container class=\"time-picker-container\"><md-icon class=\"general-icon\" style=\"margin-top: 3px\">schedule</md-icon><label>{{$ctrl.label}}</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.selectedTime\" ng-change=\"$ctrl.selectedTimeChanged()\" ng-disabled=\"$ctrl.lock\"><md-option ng-repeat=\"t in $ctrl.selectableTimes\" ng-value=\"t.value\"><div style=\"direction: ltr;text-align: center\"><small style=\"color: #949494\">{{t.title}} </small><span><span style=\"font-weight: 400\">{{t.text}}</span></span></div></md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/components/eyeson/time-range/eyeson.time-range.template.html","<div class=\"row\"><div style=\"float: right;padding-right: 10px\"><eo-time-picker label=\"\'از ساعت\'\" id=\"timePeriodOffTimeFromTime\" time-value=\"$ctrl.startTime\"></eo-time-picker></div><div style=\"float: right;padding-right: 10px\" ng-disabled=\"$ctrl.disableEndTime\"><eo-time-picker label=\"\'تا ساعت\'\" id=\"timePeriodOffTimtoTime\" min-value=\"$ctrl.startTime\" time-value=\"$ctrl.endTime\" lock=\"$ctrl.disableEndTime\"></eo-time-picker></div></div>");
$templateCache.put("app/components/eyeson/time-range-v2/eyeson.time-range-v2.template.html","<style>.all-day {\n        margin-top: 9px;\n    }\n\n    @media (max-width: 767px) {\n        .all-day {\n            margin-top: -9px;\n        }\n\n    }</style><div class=\"row\"><div class=\"col-md-4 col-sm-4 col-xs-6\" style=\"float: right;padding-right: 10px\"><eo-time-picker label=\"\'از ساعت\'\" id=\"timePeriodOffTimeFromTime\" time-value=\"$ctrl.startTime\" can-set-from-out-side=\"true\"></eo-time-picker></div><div class=\"col-md-4 col-sm-4 col-xs-6\" style=\"float: right;padding-right: 10px\" ng-disabled=\"$ctrl.disableEndTime\"><eo-time-picker label=\"\'تا ساعت\'\" id=\"timePeriodOffTimtoTime\" min-value=\"$ctrl.startTime\" time-value=\"$ctrl.endTime\" lock=\"$ctrl.disableEndTime\" can-set-from-out-side=\"true\"></eo-time-picker></div><div class=\"col-md-4 col-sm-4 col-xs-6 all-day\"><md-switch ng-model=\"$ctrl.allDay\" ng-change=\"$ctrl.allDay_changed()\">تمام روز</md-switch></div></div>");
$templateCache.put("app/components/partial-forms/activity-type-selector/partial-form.activity-type-selector.html","<md-select class=\"rwMdSelect\" name=\"activityType\" ng-model=\"$ctrl.activityType\" ng-required=\"$ctrl.isRequired\" eo-required=\"\"><md-optgroup ng-repeat=\"cat in $ctrl.typeCategories\" label=\"{{cat.title}}\"><md-option ng-value=\"item.type\" ng-repeat=\"item in cat.items\" class=\"activity-type-item\">{{item.title}}</md-option></md-optgroup></md-select>");
$templateCache.put("app/components/partial-forms/company-customer/partial-form.company-customer.html","<style>.action-button-custom {\n        float: left;\n        margin: 2px;\n    }</style><md-content class=\"rwMdContent\"><ul class=\"nav nav-tabs lightnav\"><li class=\"active\"><a data-target=\"#profileInfo\" data-toggle=\"tab\"><md-icon>person_outline</md-icon>{{\'tikonApp.companyCustomer.tabs.profileInfo\' | translate}} </a></li><li ng-if=\"!$ctrl.isPopUp\" class=\"\"><a data-target=\"#reserveHistory\" data-toggle=\"tab\"><md-icon>history</md-icon>{{\'tikonApp.companyCustomer.tabs.reserveHistory\' | translate}} </a></li><li ng-if=\"!$ctrl.isPopUp\" class=\"\"><a data-target=\"#complementaryInfo\" data-toggle=\"tab\"><md-icon>info_outline</md-icon>{{\'tikonApp.companyCustomer.tabs.complementaryInfo\' | translate}} </a></li><li ng-if=\"!$ctrl.isPopUp\" class=\"\"><a data-target=\"#experiences\" data-toggle=\"tab\"><md-icon>content_paste</md-icon>{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}} </a></li><li ng-if=\"!$ctrl.isPopUp && $ctrl.companyCustomer.id \" class=\"\"><a data-target=\"#createUser\" data-toggle=\"tab\"><md-icon>person_add</md-icon>{{\'tikonApp.companyCustomer.tabs.createUser\' | translate}} </a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"profileInfo\"><div class=\"container-fluid\"><div class=\"row\"><pf-person-info person-info=\"$ctrl.companyCustomer.customer.personalInfo\" user-account-id=\"$ctrl.companyCustomer.customer.userAccountId\" is-customer=\"true\" can-save=\"$ctrl.canSave\"></pf-person-info></div><div class=\"row\" style=\"margin-right: -28px\"><div class=\"col-md-2\"></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomer.customerGroup\" for=\"field_customerGroup\">Category</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.companyCustomer.withoutCustomerGroup\' | translate}}\" ng-model=\"$ctrl.companyCustomer.customerGroup.id\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_customerGroup\" ng-change=\"$ctrl.customerGroupChanged()\"><md-option value=\"1\">بدون گروه بندی</md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.customerGroups\">{{si.groupName}}</md-option></md-select></div></div><div class=\"col-md-3\" style=\"margin-right: 34px\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomer.status\" for=\"field_status\">Category</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.companyCustomer.notDefine\' | translate}}\" ng-model=\"$ctrl.companyCustomer.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\" ng-change=\"\"><md-option value=\"1\"><span><md-icon style=\"color: gray;margin-bottom: 7px\">error</md-icon></span>نامشخص</md-option><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.customerStatuses\"><span ng-if=\"si==\'BLOCKED_CUSTOMER\'\"><md-icon style=\"color: red;margin-bottom: 7px\">block</md-icon></span><span ng-if=\"si==\'VALID_CUSTOMER\'\"><md-icon style=\"color: green;margin-bottom: 7px\">person</md-icon></span><span ng-if=\"si==\'NEW_CUSTOMER\'\"><md-icon style=\"color: dodgerblue;margin-bottom: 7px\">person_add</md-icon></span>{{\"tikonApp.CustomerStatus.\"+ si | translate}}</md-option></md-select></div></div></div><div class=\"row\" ng-if=\" ($ctrl.companyCustomer.customerIntakeData!= undefined && $ctrl.companyCustomer.customerIntakeData!=\'\' && $ctrl.companyCustomer.customerIntakeData != null && $ctrl.companyCustomer.customerIntakeData.fields )\"><div class=\"col-md-2\"></div><fieldset class=\"standard-fieldset\"><legend><i class=\"fa fa-address-card fa-2x\" style=\"color: #bac6d1;margin-top: -6px\"><span style=\"font-size: 14px;font-family: yekan;color: #2b6b7f;padding-right: 5px\">اطلاعات تکمیلی</span></i></legend><div class=\"container-fluid\"><div class=\"col-md-10\" style=\"margin: 0\"><!--<hr>--><div id=\"company_customer_intakeformData\" class=\"row\"><component-intake-data-viewer intake-data=\"$ctrl.companyCustomer.customerIntakeData\" column-count=\"3\"></component-intake-data-viewer></div></div></div></fieldset></div></div></div><div ng-if=\"!$ctrl.isPopUp\" style=\"background: none\" class=\"tab-pane fade\" id=\"complementaryInfo\"><div ng-if=\"($ctrl.companyCustomer.singleRecordForms && $ctrl.companyCustomer.singleRecordForms.length>0) || ($ctrl.companyCustomer.singleRecordFormDatas && $ctrl.companyCustomer.singleRecordFormDatas.length>0)\"><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><div id=\"company_customer_single_form_buttons\"><div class=\"row\"><span ng-repeat=\"form in $ctrl.companyCustomer.singleRecordForms\"><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.getCompanyCustomerFormDataFunc(form.id, form.title)\">{{form.title}} +</md-button><!--<component-intake-data-viewer intake-data=\"$ctrl.customerFormData.intakeDataDTO\"></component-intake-data-viewer>--></span></div></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"$ctrl.companyCustomer.singleRecordFormDatas\" ng-repeat=\"formData in $ctrl.companyCustomer.singleRecordFormDatas\"><div class=\"exCards\"><div class=\"container-fluid\"><div class=\"row\" style=\"margin-top: -5px;    margin-right: -25px;    margin-bottom: 20px\"><span class=\"form-data-card-label\">{{formData.companyCustomForm.title}}</span></div><div class=\"row\"><div class=\"col-sm-9\" style=\"line-height: 1.5\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\"><div class=\"col-sm-6\" ng-repeat=\"field in formData.intakeDataDTO.fields\"><span ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \"><i class=\"fa fa-check\"></i> <span style=\"font-weight: bold\">{{field.label}} </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType ==\'File\' \"><span>{{field.label}} :</span> <span ng-if=\"field.value\"><i class=\"fa fa-file\"></i> <span>فایل</span> </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType != \'File\' \"><span>{{field.label}} :</span> <span style=\"font-weight: bold\">{{field.value}}</span></span></div></div><div class=\"col-sm-3\" style=\"margin-top: -20px\"><md-button class=\"btn btn-primary btn-sm action-button-custom\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\">{{\'tikonApp.companyCustomer.tabs.button.edit\' | translate}}</md-button><md-button class=\"btn btn-danger btn-sm action-button-custom\" ng-click=\"$ctrl.deleteCustomerFormData(formData)\">{{\'tikonApp.companyCustomer.tabs.button.delete\' | translate}}</md-button></div></div></div></div></div></div></div></div><div ng-if=\"!($ctrl.companyCustomer.singleRecordForms && $ctrl.companyCustomer.singleRecordForms.length>0) && !($ctrl.companyCustomer.singleRecordFormDatas && $ctrl.companyCustomer.singleRecordFormDatas.length>0)\"><eo-no-data></eo-no-data></div></div><div ng-if=\"!$ctrl.isPopUp\" style=\"background: none\" class=\"tab-pane fade\" id=\"experiences\"><div ng-if=\"$ctrl.companyCustomer.multiRecordForms && $ctrl.companyCustomer.multiRecordForms.length>0\"><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><div id=\"company_customer_form_data\"><div class=\"row\"><span ng-repeat=\"form in $ctrl.companyCustomer.multiRecordForms\"><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.getCompanyCustomerFormDataFunc(form.id, form.title)\">{{form.title}} +</md-button><!--<component-intake-data-viewer intake-data=\"$ctrl.customerFormData.intakeDataDTO\"></component-intake-data-viewer>--></span></div></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"$ctrl.companyCustomer.multiRecordFormDatas\" ng-repeat=\"formData in $ctrl.companyCustomer.multiRecordFormDatas\"><div class=\"exCards\"><div class=\"container-fluid\"><div class=\"row\" style=\"margin-top: -5px;    margin-right: -25px;    margin-bottom: 20px\"><span class=\"form-data-card-label\">{{formData.companyCustomForm.title}}</span></div><div class=\"row\"><div class=\"col-sm-9\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\"><div class=\"col-sm-6\" ng-repeat=\"field in formData.intakeDataDTO.fields\"><span ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \"><i class=\"fa fa-check\"></i> <span style=\"font-weight: bold\">{{field.label}} </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType ==\'File\' \"><span>{{field.label}} :</span> <span ng-if=\"field.value\"><i class=\"fa fa-file\"></i> <span>فایل</span> </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\'\"><span>{{field.label}} :</span> <span style=\"font-weight: bold\">{{field.value}}</span></span></div></div><div class=\"col-sm-3\" style=\"margin-top: -20px\"><md-button class=\"btn btn-primary btn-sm action-button-custom\" style=\"float: left\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\">{{\'tikonApp.companyCustomer.tabs.button.edit\' | translate}}</md-button><md-button class=\"btn btn-danger btn-sm action-button-custom\" style=\"float: left\" ng-click=\"$ctrl.deleteCustomerFormData(formData)\">{{\'tikonApp.companyCustomer.tabs.button.delete\' | translate}}</md-button></div></div></div></div></div></div></div></div><div ng-if=\"!$ctrl.companyCustomer.multiRecordForms.length || $ctrl.companyCustomer.multiRecordForms.length===0\"><eo-no-data></eo-no-data></div></div><div ng-if=\"!$ctrl.isPopUp\" style=\"background: none\" class=\"tab-pane fade\" id=\"reserveHistory\"><div ng-if=\"$ctrl.companyCustomer.customer.id\"><pf-reserve-list customer-id=\"$ctrl.companyCustomer.customer.id\"></pf-reserve-list></div><div ng-if=\"!$ctrl.companyCustomer.customer.id\"><eo-no-data></eo-no-data></div></div><div ng-if=\"!$ctrl.isPopUp && $ctrl.companyCustomer.id\" style=\"background: none\" class=\"tab-pane fade\" id=\"createUser\"><div ng-if=\"$ctrl.hasUser\"><div>این مشتری نام کاربری دارد</div><div>نام کاربری : {{$ctrl.existUser.login}}</div></div><div ng-if=\"!$ctrl.hasUser\"><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyCustomer.user.login\" for=\"field_login\">login</label><input type=\"text\" class=\"form-control\" name=\"login\" id=\"field_login\" ng-model=\"$ctrl.companyCustomer.user.login\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyCustomer.user.password\" for=\"field_password\">password</label><input type=\"text\" class=\"form-control\" name=\"password\" id=\"field_password\" ng-model=\"$ctrl.companyCustomer.user.password\"></div></div><div class=\"col-md-4\" style=\"padding-top: 25px\"><div class=\"form-group\"><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.createUser()\"><span translate=\"tikonApp.companyCustomer.user.createUser\">createUser</span></md-button></div></div></div></div></div></div></md-content>");
$templateCache.put("app/components/partial-forms/company-customer-v2/partial-form.company-customer-v2.html","<style>.action-button-custom {\n        float: left;\n        margin: 2px;\n    }</style><div class=\"\"><ul class=\"pl-nav-tabs\" ng-if=\"$ctrl.companyCustomer && $ctrl.companyCustomer.id\"><li class=\"active\"><a data-target=\"#profileInfo\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">person_outline</md-icon>{{\'tikonApp.companyCustomer.tabs.profileInfo\' | translate}} </a></li><li class=\"\"><a data-target=\"#reserveHistory\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">history</md-icon>{{\'tikonApp.companyCustomer.tabs.reserveHistory\' | translate}} </a></li><li class=\"\" ng-click=\"$ctrl.onInvoiceHistoryTabClick()\"><a data-target=\"#invoiceHistory\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">receipt</md-icon>{{\'tikonApp.companyCustomer.tabs.invoiceHistory\' | translate}} </a></li><li class=\"\"><a data-target=\"#complementaryInfo\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">info_outline</md-icon>{{\'tikonApp.companyCustomer.tabs.complementaryInfo\' | translate}} </a></li><li class=\"\"><a data-target=\"#experiences\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">content_paste</md-icon>{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}} </a></li><li class=\"\"><a data-target=\"#createUser\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">person_add</md-icon>{{\'tikonApp.companyCustomer.tabs.createUser\' | translate}} </a></li><li class=\"\"><a data-target=\"#anotherSettings\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">settings</md-icon>سایر عملیات </a></li><li class=\"\"><a data-target=\"#accountWallet\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">account_balance_wallet</md-icon>کیف پول </a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane pl-tab-pane active\" style=\"background: none\" id=\"profileInfo\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.companyCustomer.tabs.profileInfo\"></span></div><div class=\"panel-body\"><pf-person-info-v2 person-info=\"$ctrl.companyCustomer.customer.personalInfo\" user-account-id=\"$ctrl.companyCustomer.customer.userAccountId\" description=\"$ctrl.companyCustomer.description\" is-customer=\"true\" can-save=\"$ctrl.canSave\" show-image=\"false\"></pf-person-info-v2><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomer.customerGroup\" for=\"field_customerGroup\">Category</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.companyCustomer.withoutCustomerGroup\' | translate}}\" ng-model=\"$ctrl.companyCustomer.customerGroup.id\" id=\"field_customerGroup\" ng-change=\"$ctrl.customerGroupChanged()\"><md-option value=\"1\">بدون گروه بندی</md-option><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.customerGroups\">{{si.groupName}}</md-option></md-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.companyCustomer.status\" for=\"field_status\">Category</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.companyCustomer.notDefine\' | translate}}\" ng-model=\"$ctrl.companyCustomer.status\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_status\" ng-change=\"\"><md-option value=\"1\"><span><md-icon style=\"color: gray;margin-bottom: 7px\">error</md-icon></span>نامشخص</md-option><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.customerStatuses\"><span ng-if=\"si==\'BLOCKED_CUSTOMER\'\"><md-icon style=\"color: red;margin-bottom: 7px\">block</md-icon></span><span ng-if=\"si==\'VALID_CUSTOMER\'\"><md-icon style=\"color: green;margin-bottom: 7px\">person</md-icon></span><span ng-if=\"si==\'NEW_CUSTOMER\'\"><md-icon style=\"color: dodgerblue;margin-bottom: 7px\">person_add</md-icon></span>{{\"tikonApp.CustomerStatus.\"+ si | translate}}</md-option></md-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.description\" for=\"field_address\">Description</label><textarea type=\"text\" class=\"form-control\" name=\"description\" id=\"description\" ng-model=\"$ctrl.companyCustomer.description\"></textarea></div></div></div></div></div><div class=\"pl-panel\" ng-if=\" ($ctrl.companyCustomer.customerIntakeData!= undefined && $ctrl.companyCustomer.customerIntakeData!=\'\' && $ctrl.companyCustomer.customerIntakeData != null && $ctrl.companyCustomer.customerIntakeData.fields )\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.companyCustomer.customerIntakeFields\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"company_customer_intakeformData\" class=\"row\"><component-intake-data-viewer intake-data=\"$ctrl.companyCustomer.customerIntakeData\" column-count=\"3\"></component-intake-data-viewer></div></div></div></div></div></div></div><div ng-if=\"!$ctrl.isPopUp\" style=\"background: none\" class=\"tab-pane fade\" id=\"complementaryInfo\"><div ng-if=\"($ctrl.companyCustomer.singleRecordForms && $ctrl.companyCustomer.singleRecordForms.length>0) || ($ctrl.companyCustomer.singleRecordFormDatas && $ctrl.companyCustomer.singleRecordFormDatas.length>0)\"><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><div id=\"company_customer_single_form_buttons\"><div class=\"row\"><span ng-repeat=\"form in $ctrl.companyCustomer.singleRecordForms\"><md-button class=\"md-raised md-primary pl-btn-ordinary\" ng-click=\"$ctrl.getCompanyCustomerFormDataFunc(form.id, form.title)\">{{form.title}} +</md-button><!--<component-intake-data-viewer intake-data=\"$ctrl.customerFormData.intakeDataDTO\"></component-intake-data-viewer>--></span></div></div><div class=\"pl-container-fluid\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"$ctrl.companyCustomer.singleRecordFormDatas\" ng-repeat=\"formData in $ctrl.companyCustomer.singleRecordFormDatas\"><div class=\"exCards\"><div class=\"container-fluid\"><div class=\"row\" style=\"margin-top: -5px;    margin-right: -25px;    margin-bottom: 20px\"><span class=\"form-data-card-label\">{{formData.companyCustomForm.title}}</span></div><div class=\"row\"><div class=\"col-sm-9\" style=\"line-height: 1.5\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\"><div class=\"col-sm-6\" ng-repeat=\"field in formData.intakeDataDTO.fields\"><span ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \"><i class=\"fa fa-check\"></i> <span style=\"font-weight: bold\">{{field.label}} </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType ==\'File\' \"><span>{{field.label}} :</span> <span ng-if=\"field.value\"><i class=\"fa fa-file\"></i> <span>فایل</span> </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType ==\'Date\'\"><span>{{field.label}} :</span> <span ng-if=\"field.value\" style=\"font-weight: bold\">{{field.value | toPersianDate}}</span> </span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType !=\'Date\'\"><span>{{field.label}} :</span> <span style=\"font-weight: bold\">{{field.value}}</span></span></div></div><div class=\"col-sm-3\" style=\"margin-top: -20px\"><md-button class=\"btn btn-primary btn-sm action-button-custom\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\">{{\'tikonApp.companyCustomer.tabs.button.edit\' | translate}}</md-button><md-button class=\"btn btn-danger btn-sm action-button-custom\" ng-click=\"$ctrl.deleteCustomerFormData(formData)\">{{\'tikonApp.companyCustomer.tabs.button.delete\' | translate}}</md-button></div></div></div></div></div></div></div></div><div ng-if=\"!($ctrl.companyCustomer.singleRecordForms && $ctrl.companyCustomer.singleRecordForms.length>0) && !($ctrl.companyCustomer.singleRecordFormDatas && $ctrl.companyCustomer.singleRecordFormDatas.length>0)\"><eo-no-data></eo-no-data></div></div><div ng-if=\"!$ctrl.isPopUp\" style=\"background: none\" class=\"tab-pane fade\" id=\"experiences\"><div ng-if=\"$ctrl.companyCustomer.multiRecordForms && $ctrl.companyCustomer.multiRecordForms.length>0\"><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><div id=\"company_customer_form_data\"><div class=\"row\"><span ng-repeat=\"form in $ctrl.companyCustomer.multiRecordForms\"><md-button class=\"md-raised md-primary pl-btn-ordinary\" ng-click=\"$ctrl.getCompanyCustomerFormDataFunc(form.id, form.title)\">{{form.title}} +</md-button><!--<component-intake-data-viewer intake-data=\"$ctrl.customerFormData.intakeDataDTO\"></component-intake-data-viewer>--></span></div></div><div class=\"pl-container-fluid\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"$ctrl.companyCustomer.multiRecordFormDatas\" ng-repeat=\"formData in $ctrl.companyCustomer.multiRecordFormDatas\"><div class=\"exCards\"><div class=\"container-fluid\"><div class=\"row\" style=\"margin-top: -5px;    margin-right: -25px;    margin-bottom: 20px\"><span class=\"form-data-card-label\">{{formData.companyCustomForm.title}}</span></div><div class=\"row\"><div class=\"col-sm-9\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\"><div class=\"col-sm-6\" ng-repeat=\"field in formData.intakeDataDTO.fields\"><span ng-if=\"field.field.fieldType == \'CheckBox\' && field.value == \'true\' \"><i class=\"fa fa-check\"></i> <span style=\"font-weight: bold\">{{field.label}} </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType ==\'File\' \"><span>{{field.label}} :</span> <span ng-if=\"field.value\"><i class=\"fa fa-file\"></i> <span>فایل</span> </span></span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType ==\'Date\'\"><span>{{field.label}} :</span> <span ng-if=\"field.value\" style=\"font-weight: bold\">{{field.value | toPersianDate}}</span> </span><span ng-if=\"field.field.fieldType != \'CheckBox\' && field.field.fieldType !=\'File\' && field.field.fieldType !=\'Date\'\"><span>{{field.label}} :</span> <span style=\"font-weight: bold\">{{field.value}}</span></span></div></div><div class=\"col-sm-3\" style=\"margin-top: -20px\"><md-button class=\"btn btn-primary btn-sm action-button-custom\" style=\"float: left\" ng-click=\"$ctrl.editCompanyCustomerFormDataFunc(formData.companyCustomForm.id, formData.companyCustomForm.title, formData)\">{{\'tikonApp.companyCustomer.tabs.button.edit\' | translate}}</md-button><md-button class=\"btn btn-danger btn-sm action-button-custom\" style=\"float: left\" ng-click=\"$ctrl.deleteCustomerFormData(formData)\">{{\'tikonApp.companyCustomer.tabs.button.delete\' | translate}}</md-button></div></div></div></div></div></div></div></div><div ng-if=\"!$ctrl.companyCustomer.multiRecordForms.length || $ctrl.companyCustomer.multiRecordForms.length===0\"><eo-no-data></eo-no-data></div></div><div ng-if=\"!$ctrl.isPopUp\" style=\"background: none\" class=\"tab-pane fade\" id=\"reserveHistory\"><div ng-if=\"$ctrl.companyCustomer.customer.id\"><pf-reserve-list-v2 customer-id=\"$ctrl.companyCustomer.customer.id\"></pf-reserve-list-v2></div><div ng-if=\"!$ctrl.companyCustomer.customer.id\"><eo-no-data></eo-no-data></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"invoiceHistory\"><div ng-if=\"$ctrl.invoiceInfoList && $ctrl.invoiceInfoList.length > 0\"><pf-invoice-info-list invoice-info-list=\"$ctrl.invoiceInfoList\"></pf-invoice-info-list></div><div ng-if=\"!$ctrl.invoiceInfoList || $ctrl.invoiceInfoList.length == 0\"><eo-no-data></eo-no-data></div></div><div ng-if=\"!$ctrl.isPopUp && $ctrl.companyCustomer.id\" style=\"background: none\" class=\"tab-pane fade\" id=\"createUser\"><div ng-if=\"$ctrl.hasUser\"><div>این مشتری نام کاربری دارد</div><div>نام کاربری : {{$ctrl.existUser.login}}</div></div><div ng-if=\"!$ctrl.hasUser\"><!--<legend>--><!--{{\'tikonApp.companyCustomer.tabs.experiences\' | translate}}--><!--</legend>--><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyCustomer.user.login\" for=\"field_login\">login</label><input type=\"text\" class=\"form-control\" name=\"login\" id=\"field_login\" ng-model=\"$ctrl.companyCustomer.user.login\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.companyCustomer.user.password\" for=\"field_password\">password</label><input type=\"text\" class=\"form-control\" name=\"password\" id=\"field_password\" ng-model=\"$ctrl.companyCustomer.user.password\"></div></div><div class=\"col-md-4\" style=\"padding-top: 25px\"><div class=\"form-group\"><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.createUser()\"><span translate=\"tikonApp.companyCustomer.user.createUser\">createUser</span></md-button></div></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"anotherSettings\"><div class=\"row\"><md-button class=\"md-raised md-primary pl-btn-ordinary\" ng-click=\"$ctrl.sendWelcomeMessage()\" ng-disabled=\"$ctrl.sendWelcomeMessageLoading\"><span style=\"color: white\">ارسال پیامک خوشامدگویی <span ng-if=\"$ctrl.sendWelcomeMessageLoading\">...</span></span></md-button></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"accountWallet\"><div class=\"pl-container-fluid\"><!-- Wallet Balance Panel --><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><md-icon class=\"pl-icon\">account_balance_wallet</md-icon>کیف پول مشتری</div><div class=\"panel-body\"><div class=\"row\"><!-- Balance --><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">موجودی کیف پول</label><div style=\"font-size:20px;font-weight:bold;color:#2e7d32\">{{ $ctrl.totalBalance | number }} تومان</div></div></div><!-- Add Balance Button --><div class=\"col-md-6\" style=\"padding-top:25px\"><md-button has-authority=\"ROLE_FINANCIAL_MANAGER\" class=\"md-raised md-primary pl-btn-ordinary\" ng-click=\"$ctrl.openAddBalanceDialog()\"><md-icon class=\"pl-icon\">add_circle</md-icon>افزایش موجودی</md-button></div></div></div></div><!-- Wallet Transactions (optional but recommended) --><div class=\"pl-panel\" ng-if=\"$ctrl.walletTransactions && $ctrl.walletTransactions.length\"><div class=\"panel-heading pl-panel-heading\">اعتبارهای اضافه شده</div><div class=\"panel-body\"><table class=\"table table-striped table-hover\"><thead><tr><th>تاریخ ایجاد</th><th>منشأ افزایش</th><th>مبلغ</th><th></th></tr></thead><tbody><tr ng-repeat=\"tx in $ctrl.walletTransactions\"><td>{{tx.createdAt | toPersianDate}}</td><!-- <td>\n                                    <span ng-if=\"tx.type==\'CHARGE\'\" style=\"color:green\">\n                                        افزایش\n                                    </span>\n\n                                    <span ng-if=\"tx.type==\'DEBIT\'\" style=\"color:red\">\n                                        برداشت\n                                    </span>\n                                </td> --><td>{{\'tikonApp.wallet.sourceType.\' + tx.sourceType | translate}}</td><td>{{tx.amount | number}} تومان</td><td><md-button ng-click=\"$ctrl.deleteCredit(tx)\" ng-disabled=\"tx.sourceType != \'MANUAL\'\"><md-tooltip md-direction=\"top\">حذف اعتبار</md-tooltip><md-icon ng-style=\"getDynamicStyleRemoveIcon(tx)\" aria-hidden=\"true\">delete_forever</md-icon></md-button></td></tr></tbody></table></div></div><div ng-if=\"!$ctrl.walletTransactions || $ctrl.walletTransactions.length==0\"><eo-no-data></eo-no-data></div></div></div></div></div>");
$templateCache.put("app/components/partial-forms/company-schedules/partial-form.company-schedules.html","<style>/*md-content {*/\n    /*overflow: unset !important;*/\n    /*}*/\n    .form-field-description {\n        font-size: 12px;\n        color: #607d8b;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><div class=\"pull-right\"><md-button ng-click=\"$ctrl.saveSchedule()\" class=\"md-raised md-primary\">ثبت</md-button></div><div class=\"pull-right\"><md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\"><span><md-icon>settings</md-icon></span><span translate=\"entity.action.backToSetting\">entity.action.backToSetting</span></md-button></div></div><div class=\"row\" ng-show=\"$ctrl.selectedScheduleInfo\"><md-content class=\"rwMdContent\"><md-tabs md-border-bottom md-dynamic-height=\"true\" md-swipe-content=\"false\" md-stretch-tabs=\"auto\" md-selected=\"1\"><md-tab><md-tab-label><md-icon>event</md-icon><span>ساعت کاری <b>نامنظم</b></span></md-tab-label><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><!--<div class=\"hint-point\">--><!--بازه های زمانی استثناُ زمان هایی هستند که بدون در نظر گرفتن دیگر تنظیمات زمانی در نظر گرفته می شوند.--><!--</div>--><pf-exception-duration exdurations=\"$ctrl.selectedScheduleInfo.scheduleExceptionDurations\"></pf-exception-duration></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><md-icon>history</md-icon><span>ساعت کاری <b>منظم</b></span></md-tab-label><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><div class=\"row\"><eo-time-range start-time=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range></div><div class=\"row\"><div class=\"col-md-4\"><md-switch ng-model=\"$ctrl.showLimitDates\" ng-change=\"$ctrl.showLimitDateChange()\" style=\"padding-right: 23px;white-space: normal\">محدود سازی تاریخ شروع و پایان زمانبندی</md-switch></div><div class=\"col-md-4\" ng-if=\"$ctrl.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.fromDate\">fromDate</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div><div class=\"col-md-4\" ng-if=\"$ctrl.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.toDate\">toDate</label><eo-date-picker id=\"field_endDateFilter\" date-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker></div></div></div></fieldset></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری هفتگی</legend><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></fieldset></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>روزهای تعطیل</legend><div class=\"row rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.hasBaseOffDaySchedule\" aria-label=\"Switch 1\" ng-change=\"$ctrl.baseOffDayScheduleSwitch_changed()\"><span>تعطیلات رسمی تعطیل باشد</span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-field-description\">* شما میتوانید تعطیلات مخصوص به خود را در بخش زیر اضافه کنید</div><pf-date-period-off-days selected-date-period=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod\"></pf-date-period-off-days></div></div></fieldset></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت های تعطیل</legend><pf-time-period-off-times selected-time-period=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod\"></pf-time-period-off-times></fieldset></div></div></md-content></md-tab-body></md-tab></md-tabs><!--{{$ctrl.selectedScheduleInfo.wee}}--></md-content></div></div>");
$templateCache.put("app/components/partial-forms/customer-picker/partial-form.customer-picker.html","<form name=\"form\"><div name=\"findCustomer\"><div class=\"row\" ng-if=\"!$ctrl.readOnly\"><div class=\"col-sm-6\"><label translate=\"tikonApp.customer.picker.selectCustomer\">Phone Number</label><eo-autocomplete placeholder=\"{{\'tikonApp.customer.picker.searchCustomer\' | translate}}\" selected-item-change=\"$ctrl.selectedCustomerChanged\" selected-item=\"$ctrl.selectedCustomer\" search-method=\"$ctrl.searchCustomer\"></eo-autocomplete></div><div class=\"col-sm-6 col-xs-12\" style=\"padding-top: 26px;display: flex\"><md-button type=\"button\" ng-click=\"$ctrl.newCustomer()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.customer.picker.newCustomerSummary\">New customer</span></md-button><md-button type=\"button\" ng-click=\"$ctrl.newCustomerPopUp()\" class=\"md-raised md-primary pl-btn pl-btn-ordinary\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"tikonApp.customer.picker.newCustomerPopUp\">newCustomerPopUp</span></md-button></div></div><div class=\"row\" ng-if=\"$ctrl.customerMode == \'new\' || $ctrl.customer.personalInfo.fisrtName\"><div class=\"col-md-2\" ng-if=\"$ctrl.isCustomerManager || $ctrl.customerMode == \'new\' \"><div class=\"form-group\"><label class=\"control-label\" for=\"phoneNumber\" translate=\"tikonApp.personInfo.phoneNumber\">Phone Number</label><input type=\"phoneNumber\" class=\"form-control\" id=\"phoneNumber\" name=\"phoneNumber\" maxlength=\"11\" placeholder=\"{{\'tikonApp.personInfo.phoneNumber-placeHolder\' | translate}}\" ng-model=\"$ctrl.customer.personalInfo.phoneNumber\" required autocomplete=\"off\" ng-disabled=\"$ctrl.readOnly\" ng-change=\"$ctrl.searchCustomerByPhoneNumber()\"><div class=\"customer-search-list\" ng-if=\"$ctrl.existCustomerSearchResult && $ctrl.existCustomerSearchResult.length>0\"><div class=\"customer-search-item\" ng-repeat=\"item in $ctrl.existCustomerSearchResult track by item.id\" ng-click=\"$ctrl.selectedCustomerChanged(item)\"><span>{{item.title}}</span> <span style=\"font-size: smaller;color: #95999b\">({{item.description}})</span></div></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"$ctrl.customer.personalInfo.fisrtName\" ng-disabled=\"$ctrl.readOnly\"><div ng-if=\"form.fisrtName.$dirty && form.fisrtName.$invalid\"><p class=\"help-block\" ng-if=\"form.fisrtName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.fisrtName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"$ctrl.customer.personalInfo.lastName\" ng-disabled=\"$ctrl.readOnly\"><div ng-if=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-if=\"form.lastName.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-if=\"form.lastName.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"tikonApp.customer.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" style=\"direction: ltr\" placeholder=\"{{\'tikonApp.customer.email-placeholder\' | translate}}\" ng-model=\"$ctrl.customer.personalInfo.email\" ng-minlength=\"5\" ng-maxlength=\"100\" ng-disabled=\"$ctrl.readOnly\"><div ng-if=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-if=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-if=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-if=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-if=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div ng-if=\"$ctrl.selectedCustomer && $ctrl.showStatistic\" class=\"row\"><pf-customer-statistics selected-customer-id=\"$ctrl.selectedItem.id\"></pf-customer-statistics></div></div></form>");
$templateCache.put("app/components/partial-forms/customer-statistics/partial-form.customer-statistics.html","<div class=\"cont\"><div class=\"row\"><div class=\"col-md-12 inf\"><span translate=\"tikonApp.customerStatistics.totalReserveNumber\"></span>: <span class=\"\">{{$ctrl.customerStatisticsObject.totalReserveNumber}}</span> <span translate=\"tikonApp.customerStatistics.lastReserveStartTime\"></span>: <span class=\"\">{{$ctrl.customerStatisticsObject.lastReserveStartTime | toPersianTime}}</span> <span class=\"\">{{$ctrl.customerStatisticsObject.lastReserveStartTime | toFullPersianDate}}</span> <span class=\"\">{{$ctrl.customerStatisticsObject.lastServiceReservedTitle}}</span></div></div></div><style>div.cont {\n        border-radius: 7px;\n        max-width: 80%;\n        border: 3px solid #f6f7ff;\n        margin-right: 15px;\n        padding: 5px;\n    }\n\n    div.inf {\n        background-color: #f6f7ff;\n        color: #2b6b7f;\n        width: 96%;\n        margin-right: 2%;\n    }\n\n    div.inf > span {\n        margin: 0 6px;\n    }\n\n    .left {\n        float: left;\n    }</style>");
$templateCache.put("app/components/partial-forms/customer-statistics-v2/partial-form.customer-statistics-v2.html","<div class=\"\"><div><span translate=\"tikonApp.customerStatistics.totalReserveNumber\"></span> : <span>{{$ctrl.customerStatisticsObject.totalReserveNumber}}</span></div><div><span>تعداد کنسل شده </span>: <span class=\"\">{{$ctrl.customerStatisticsObject.totalCanceledNumber}}</span></div></div>");
$templateCache.put("app/components/partial-forms/date-period-off-days/partial-form.date-period-off-days.html","<style>.offDateBlock {\n        background-color: rgba(240, 120, 130, 0.33);\n        border-radius: 20px;\n        padding: 4px 16px;\n        margin: 3px;\n        width: 170px;\n        float: right;\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div style=\"float: right\"><eo-date-picker id=\"field_endDate\" date-value=\"$ctrl.newDate\"></eo-date-picker></div><div><md-button class=\"md-icon-button medium-icon\" style=\"margin-top: 0px\" ng-click=\"$ctrl.onAdddate()\"><i class=\"material-icons\">add_circle</i></md-button></div></div><div class=\"row\"><span ng-repeat=\"date in $ctrl.offDates\"><div class=\"offDateBlock\" ng-click=\"$ctrl.onRemoveDate(date)\"><span class=\"glyphicon glyphicon-remove\"></span> <span>{{date.name}}</span></div></span></div></div>");
$templateCache.put("app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item-v2.html","<eo-pl-modal-header title=\"\'tikonApp.orderBag.replaceTime\'\" is-disabled=\"editForm.$invalid || $ctrl.isSaving\" on-ok=\"$ctrl.okModal()\" on-close=\"$ctrl.closeModal()\"></eo-pl-modal-header><div class=\"pl-modal-content\"><div class=\"container-fluid pl-container-fluid\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBag.replaceTime\"></span></div><div class=\"panel-body\"><div><div class=\"row\"><div class=\"col-sm-6 col-xs-6\"><div style=\"line-height: 1.5\"><div>{{$ctrl.orderBagItem.serviceItem.itemTitle}}</div><div><i class=\"fa fa-user\"></i> {{$ctrl.orderBagItem.servant.personInfo.fullName }}</div></div></div><div class=\"col-sm-6 col-xs-6\"><div style=\"line-height: 1.5\"><div><i class=\"fa fa-calendar\"></i> {{$ctrl.orderBagItem.serviceTimeSession.startTime | toFullPersianDate}}</div><div><i class=\"fa fa-clock-o\"></i> {{$ctrl.orderBagItem.serviceTimeSession.endTime | toPersianTime}} - {{$ctrl.orderBagItem.serviceTimeSession.startTime | toPersianTime}}</div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><pf-reserve-service-item-v2 order-bag-service-item=\"$ctrl.editableOrderBagItem\" on-item-changed=\"$ctrl.onItemChanged(item)\" default-selected-service=\"$ctrl.editableOrderBagItem.serviceItem\" default-servant-id=\"$ctrl.orderBagItem.servant.id\" default-start-date=\"$ctrl.editableOrderBagItem.serviceTimeSession.startDate\" default-end-date=\"$ctrl.editableOrderBagItem.serviceTimeSession.endDate\" edit-mode=\"\'EDIT\'\" show-un-planned-time=\"false\" can-select-other-servant=\"true\" show-option-items=\"false\"></pf-reserve-service-item-v2></div></div></div><div class=\"row\"><div class=\"col-md-6\"><md-switch ng-model=\"$ctrl.editableOrderBagItem.notifyCustomer\" class=\"pl-switch\"><span translate=\"tikonApp.orderBag.notifyCustomer\"></span></md-switch></div></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || $ctrl.isSaving\" on-ok=\"$ctrl.okModal()\" on-close=\"$ctrl.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html","<md-content class=\"rwMdContent\"><div class=\"modal-header\"><h4 class=\"modal-title\" id=\"headerLabel\" translate=\"tikonApp.orderBag.replaceTime\"></h4><div class=\"row\"><div class=\"col-sm-6 col-xs-6\"><div style=\"line-height: 1.5\"><div>{{$ctrl.orderBagItem.serviceItem.itemTitle}}</div><div><i class=\"fa fa-user\"></i> {{$ctrl.orderBagItem.servant.personInfo.fullName }}</div></div></div><div class=\"col-sm-6 col-xs-6\"><div style=\"line-height: 1.5\"><div><i class=\"fa fa-calendar\"></i> {{$ctrl.orderBagItem.serviceTimeSession.startTime | toFullPersianDate}}</div><div><i class=\"fa fa-clock-o\"></i> {{$ctrl.orderBagItem.serviceTimeSession.endTime | toPersianTime}} - {{$ctrl.orderBagItem.serviceTimeSession.startTime | toPersianTime}}</div></div></div></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><!--<pf-reserve-service-item--><!--order-bag-service-item=\"$ctrl.editableOrderBagItem\"--><!--on-item-changed=\"$ctrl.onItemChanged(item)\"--><!--default-selected-service=\"$ctrl.editableOrderBagItem.serviceItem\"--><!--default-selected-servant=\"$ctrl.editableOrderBagItem.servant\"--><!--init-mode=\"\'DEFAULT\'\"--><!--edit-mode=\"\'REPLACE_TIME\'\"--><!--default-start-date=\"$ctrl.editableOrderBagItem.serviceTimeSession.startDate\"--><!--default-end-date= \'$ctrl.editableOrderBagItem.serviceTimeSession.endDate\'--><!--check-capacity=\"$ctrl.editableOrderBagItem.orderBag.checkCapacity\"--><!--&gt;--><!--</pf-reserve-service-item>--><pf-reserve-service-item-v2 order-bag-service-item=\"$ctrl.editableOrderBagItem\" on-item-changed=\"$ctrl.onItemChanged(item)\" default-selected-service=\"$ctrl.editableOrderBagItem.serviceItem\" default-servant-id=\"$ctrl.orderBagItem.servant.id\" default-start-date=\"$ctrl.editableOrderBagItem.serviceTimeSession.startDate\" default-end-date=\"$ctrl.editableOrderBagItem.serviceTimeSession.endDate\" edit-mode=\"\'EDIT\'\" show-un-planned-time=\"false\" can-select-other-servant=\"true\" show-option-items=\"false\"></pf-reserve-service-item-v2></div></div></div><div class=\"row\"><div class=\"col-md-6\"><md-switch ng-model=\"$ctrl.editableOrderBagItem.notifyCustomer\" class=\"pl-switch\"><span translate=\"tikonApp.orderBag.notifyCustomer\"></span></md-switch></div></div><!--<div class=\"row\"  >--><!--<div class=\"col-4-sm\" style=\"float: left\">--><!--<md-button class=\"md-raised md-primary\"--><!--ng-click=\"$ctrl.save()\">--><!--<md-icon aria-hidden=\"true\" >save</md-icon>--><!--<span translate=\"global.action.ok\">--><!--Create--><!--</span>--><!--</md-button>--><!--</div>--><!--<div class=\"col-4-sm\" style=\"float: left\">--><!--<md-button class=\"md-raised md-secondary\"--><!--ng-click=\"$ctrl.cancel()\">--><!--<md-icon aria-hidden=\"true\" >cancel</md-icon>--><!--<span translate=\"global.action.cancel\">--><!--Cancel--><!--</span>--><!--</md-button>--><!--</div>--><!--</div>--></div><div class=\"modal-footer\"><md-button type=\"button\" class=\"md-warn\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button style=\"margin: 0\" type=\"button\" class=\"md-raised md-primary\" ng-click=\"$ctrl.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div></md-content>");
$templateCache.put("app/components/partial-forms/event-exception-duration/partial-form.event-exception-duration.html","<style>md-select.rwMdSelect.padded {\n        min-width: 300px;\n    }\n\n    .OpenDurationBlock {\n        background-color: rgb(246, 247, 255);\n        border-radius: 5px;\n        padding: 4px 16px;\n        margin: 3px;\n        text-align: center;\n        border: 1px #607d8b solid;\n\n    }\n\n    .CloseDurationBlock {\n        background-color: rgba(240, 120, 130, 0.33);\n        border-radius: 4px;\n        padding: 4px 16px;\n        margin: 3px;\n        text-align: center;\n\n    }\n\n    .label-part {\n        padding: 5px;\n        margin: 5px;\n    }\n\n\n    .mdOpenParent, .mdCloseParent {\n        background-color: white !important;\n    }\n\n    .mdOpenParent:hover {\n        background-color: rgba(14, 122, 184, 0.33) !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .mdCloseParent:hover {\n        background-color: #ff000140 !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .OffOnText {\n        position: relative;\n        top: 3px;\n        padding-right: 5px;\n        color: #151515;\n    }\n\n    .OffOnIcon {\n        float: right;\n        margin-top: 0;\n    }\n\n    .removeExpButton {\n        font-size: 10px;\n        color: #de2d10;\n        background-color: #ff000017;\n        border: 1px #de2d10 solid;\n        border-radius: 10px;\n    }\n\n    .items-flex {\n\n        /*text-align: center;*/\n        align-items: center;\n    }\n\n    .add-button {\n        padding-top: 8px;\n    }\n\n    .event-items {\n        display: flex;\n        flex-flow: row;\n        flex-wrap: wrap;\n\n    }\n\n    @media screen and (min-width: 1024px) {\n\n        .OpenDurationBlock, .CloseDurationBlock {\n            max-width: 48%;\n            display: inline-block;\n        }\n\n    }\n\n    @media screen and (max-width: 480px) {\n        md-select.rwMdSelect.padded {\n            min-width: unset;\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        .add-button {\n            padding-top: 0px !important;\n            margin-top: -15px;\n            margin-bottom: 15px;\n        }\n\n        .items-flex {\n            display: flex;\n            flex-flow: column;\n            /* padding: 0 4px; */\n            text-align: center;\n            align-items: center;\n        }\n\n        .event-items {\n            justify-content: center;\n        }\n    }</style><div style=\"padding: 0 2px\"><div class=\"row items-flex\"><div class=\"pull-right col-lg-3 col-sm-3 col-xs-8\" style=\"padding-top: 19px\"><eo-date-picker id=\"field_startDate\" date-value=\"$ctrl.startDate\"></eo-date-picker></div><div class=\"pull-right col-lg-5 col-sm-6\"><eo-time-range start-time=\"$ctrl.startTime\" end-time=\"$ctrl.endTime\" duration=\"$ctrl.eventDuration\" lock-end-time=\"true\"></eo-time-range></div><div class=\"pull-right col-md-3 add-button\"><md-button id=\"addExceptionDuration\" class=\"md-raised md-primary\" style=\"margin-top: 12px\" ng-click=\"$ctrl.addDuration()\"><!--<i class=\"material-icons\">add</i>--> + اضافه</md-button></div></div></div><div class=\"row event-items\"><div class=\"OpenDurationBlock col-lg-2 col-md-3 col-sm-3 col-xs-5\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse | filter:{availablityMode:\'OPEN\'} \" ng-click=\"$ctrl.removeDuration(item)\"><div>{{item.startDate | toPersianDate}}<!-- -{{item.endDate | toPersianDate}}--></div><div>{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div><div class=\"removeExpButton\"><span class=\"glyphicon glyphicon-remove\"></span> <span>حذف</span></div></div></div>");
$templateCache.put("app/components/partial-forms/event-item-schedules/partial-form.event-item-schedules.html","<style>/*md-content {*/\n    /*overflow: unset !important;*/\n    /*}*/</style><div><div class=\"row\"><md-content class=\"rwMdContent\" style=\"background-color: white;overflow: inherit\"><div class=\"container-fluid\"><div class=\"row\"><!--<div class=\"hint-point\">--><!--بازه های زمانی استثناُ زمان هایی هستند که بدون در نظر گرفتن دیگر تنظیمات زمانی در نظر گرفته می شوند.--><!--</div>--><pf-event-exception-duration exdurations=\"$ctrl.selectedScheduleInfo.scheduleExceptionDurations\" event-duration=\"$ctrl.eventDuration\"></pf-event-exception-duration></div></div></md-content></div></div>");
$templateCache.put("app/components/partial-forms/exception-duration/partial-form.exception-duration.html","<style>md-select.rwMdSelect.padded {\n        min-width: 300px;\n    }\n\n    .OpenDurationBlock {\n        background-color: rgba(14, 122, 184, 0.33);\n        border-radius: 20px;\n        padding: 4px 16px;\n        margin: 3px;\n        text-align: center;\n\n    }\n\n    .CloseDurationBlock {\n        background-color: rgba(240, 120, 130, 0.33);\n        border-radius: 4px;\n        padding: 4px 16px;\n        margin: 3px;\n        text-align: center;\n\n    }\n\n    .label-part {\n        padding: 5px;\n        margin: 5px;\n    }\n\n\n    .mdOpenParent, .mdCloseParent {\n        background-color: white !important;\n    }\n\n    .mdOpenParent:hover {\n        background-color: rgba(14, 122, 184, 0.33) !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .mdCloseParent:hover {\n        background-color: #ff000140 !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .OffOnText {\n        position: relative;\n        top: 3px;\n        padding-right: 5px;\n        color: #151515;\n    }\n\n    .OffOnIcon {\n        float: right;\n        margin-top: 0;\n    }\n\n    @media screen and (min-width: 1024px) {\n\n        .OpenDurationBlock, .CloseDurationBlock {\n            max-width: 48%;\n            display: inline-block;\n        }\n\n    }\n\n    @media screen and (max-width: 480px) {\n        md-select.rwMdSelect.padded {\n            min-width: unset;\n        }\n    }</style><div style=\"padding: 0 2px; min-height: 282px\"><div class=\"row\"><div class=\"pull-right col-md-3\" style=\"padding-top: 20px\"><eo-date-picker id=\"field_startDate\" date-value=\"$ctrl.startDate\"></eo-date-picker></div><div class=\"pull-right col-md-8\"><eo-time-range start-time=\"$ctrl.startTime\" end-time=\"$ctrl.endTime\"></eo-time-range></div></div><div class=\"row\"><div class=\"pull-right\"><md-input-container style=\"margin-right: 10px\"><label class=\"control-label\" style=\"margin-bottom: 3px\">وضعیت</label><md-select class=\"rwMdSelect padded\" ng-model=\"$ctrl.availablityMode\"><md-option ng-value=\"\'OPEN\'\" class=\"mdOpenParent\"><span class=\"OffOnText\">باز است</span> <i class=\"material-icons OffOnIcon\" style=\"color: rgb(14, 122, 184)\">lock_open</i></md-option><md-option ng-value=\"\'CLOSE\'\" class=\"mdCloseParent\"><span class=\"OffOnText\">تعطیل است</span> <i class=\"material-icons OffOnIcon\" style=\"color: red\">lock</i></md-option></md-select></md-input-container></div><div class=\"pull-right\" style=\"padding-top: 8px\"><md-button id=\"addExceptionDuration\" class=\"md-raised md-primary\" style=\"margin-top: 12px\" ng-click=\"$ctrl.addDuration()\"><!--<i class=\"material-icons\">add</i>--> +اضافه شود</md-button></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"OpenDurationBlock\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse | filter:{availablityMode:\'OPEN\'} \" ng-click=\"$ctrl.removeDuration(item)\"><span class=\"glyphicon glyphicon-remove\"></span> <span>غیرتعطیل</span><div>{{item.startDate | toPersianDate}}<!-- -{{item.endDate | toPersianDate}}--></div><div>{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div><div class=\"col-sm-4\"><div class=\"CloseDurationBlock\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse | filter:{availablityMode:\'CLOSE\'} \" ng-click=\"$ctrl.removeDuration(item)\"><span class=\"glyphicon glyphicon-remove\"></span> <span>تعطیل</span><div>{{item.startDate | toPersianDate}}<!-- -{{item.endDate | toPersianDate}}--></div><div>{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div></div>");
$templateCache.put("app/components/partial-forms/exception-duration-v2/partial-form.exception-duration-v2.html","<style>md-select.rwMdSelect.padded {\n        min-width: 300px;\n    }\n\n    .OpenDurationBlock {\n        background-color: rgba(14, 122, 184, 0.33);\n        border-radius: 20px;\n        padding: 4px 16px;\n        margin: 3px;\n        text-align: center;\n\n    }\n\n    .CloseDurationBlock {\n        background-color: rgba(240, 120, 130, 0.33);\n        border-radius: 4px;\n        padding: 4px 16px;\n        margin: 3px;\n        text-align: center;\n\n    }\n\n    .label-part {\n        padding: 5px;\n        margin: 5px;\n    }\n\n\n    .mdOpenParent, .mdCloseParent {\n        background-color: white !important;\n    }\n\n    .mdOpenParent:hover {\n        background-color: rgba(14, 122, 184, 0.33) !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .mdCloseParent:hover {\n        background-color: #ff000140 !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .OffOnText {\n        position: relative;\n        top: 3px;\n        padding-right: 5px;\n        color: #151515;\n    }\n\n    .OffOnIcon {\n        float: right;\n        margin-top: 0;\n    }\n\n    @media screen and (min-width: 1024px) {\n\n        .OpenDurationBlock, .CloseDurationBlock {\n            max-width: 48%;\n            display: inline-block;\n        }\n\n    }\n\n    @media screen and (max-width: 480px) {\n        md-select.rwMdSelect.padded {\n            min-width: 200px;\n        }\n    }</style><div style=\"padding: 0 2px; min-height: 282px\"><div class=\"row\"><div class=\"pull-right col-md-3\" style=\"padding-top: 20px\"><eo-date-picker id=\"field_startDate\" date-value=\"$ctrl.startDate\"></eo-date-picker></div><div class=\"pull-right col-md-8\"><eo-time-range start-time=\"$ctrl.startTime\" end-time=\"$ctrl.endTime\"></eo-time-range></div></div><div class=\"row\"><div class=\"pull-right\"><md-input-container style=\"margin-right: 10px\"><label class=\"control-label\" style=\"margin-bottom: 3px\">وضعیت</label><md-select class=\"rwMdSelect padded\" ng-model=\"$ctrl.availablityMode\"><md-option ng-value=\"\'OPEN\'\" class=\"mdOpenParent\"><span class=\"OffOnText\">باز است</span> <i class=\"material-icons OffOnIcon\" style=\"color: rgb(14, 122, 184)\">lock_open</i></md-option><md-option ng-value=\"\'CLOSE\'\" class=\"mdCloseParent\"><span class=\"OffOnText\">تعطیل است</span> <i class=\"material-icons OffOnIcon\" style=\"color: red\">lock</i></md-option></md-select></md-input-container></div><div class=\"pull-right\" style=\"padding-top: 8px\"><md-button id=\"addExceptionDuration\" class=\"md-raised md-primary pl-btn-primary\" style=\"margin-top: 12px;width: 100%\" ng-click=\"$ctrl.addDuration()\"><!--<i class=\"material-icons\">add</i>--> +اضافه شود</md-button></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"OpenDurationBlock\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse | filter:{availablityMode:\'OPEN\'} \" ng-click=\"$ctrl.removeDuration(item)\"><span class=\"glyphicon glyphicon-remove\"></span> <span>غیرتعطیل</span><div>{{item.startDate | toPersianDate}}<!-- -{{item.endDate | toPersianDate}}--></div><div>{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div><div class=\"col-sm-4\"><div class=\"CloseDurationBlock\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse | filter:{availablityMode:\'CLOSE\'} \" ng-click=\"$ctrl.removeDuration(item)\"><span class=\"glyphicon glyphicon-remove\"></span> <span>تعطیل</span><div>{{item.startDate | toPersianDate}}<!-- -{{item.endDate | toPersianDate}}--></div><div>{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div></div>");
$templateCache.put("app/components/partial-forms/general-schedule/partial-form.general-schedules.html","");
$templateCache.put("app/components/partial-forms/invoice-info-list/partial-form.invoice-info-list.html","<div class=\"hidden-xs\"><div class=\"table-responsive over-flow-show-on-mobile\"><table st-safe-src=\"$ctrl.invoiceInfoList\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr class=\"pl-table-header\"><!--<th st-sort=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th st-sort=\"invoiceInfoId\"><span translate=\"tikonApp.invoiceInfo.id\">id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th st-sort=\"invoiceInfoId\"><span--><!--translate=\"tikonApp.invoiceInfo.invoiceNo\">invoiceNo</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th class=\"hidden-xs\" st-sort=\"customer\"><span translate=\"tikonApp.invoiceInfo.customer\">customer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"customer\"><span translate=\"tikonApp.invoiceInfo.invoiceDate\">invoiceDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"hidden-xs\" st-sort=\"finalPrice\"><span translate=\"tikonApp.invoiceInfo.finalPrice\">finalPrice</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.invoiceInfo.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"orderBagId\"><span translate=\"tikonApp.invoiceInfo.orderBagId\">orderBagId</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"invoiceInfo in collection track by invoiceInfo.id\"><!--<td>{{invoiceInfo.id }} </td>--><td><a ng-click=\"$ctrl.editInvoiceInfo(invoiceInfo)\">{{invoiceInfo.id}}</a></td><!--<td>--><!--{{invoiceInfo.invoiceNo}}--><!--</td>--><td>{{invoiceInfo.customer.personalInfo.fullName}}</td><td>{{invoiceInfo.invoiceDate | toPersianDate}}<!--{{invoiceInfo.invoiceDate | toPersianTime}}--></td><td>{{invoiceInfo.finalPrice | number}}</td><td><span ng-class=\"$ctrl.findStatusStyle(invoiceInfo.status)\" style=\"font-size: 12px\" translate=\"{{\'tikonApp.invoiceStatus.\' + invoiceInfo.status}}\">{{invoiceInfo.status}}</span></td><td>{{invoiceInfo.orderBagId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"$ctrl.editInvoiceInfo(invoiceInfo)\" class=\"btn btn-primary pl-btn-primary pl-btn-auto btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span translate=\"entity.action.view\"></span></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div><div ng-if=\"!$ctrl.invoiceInfoList || $ctrl.invoiceInfoList.length==0\"><eo-no-data></eo-no-data></div></div><div class=\"visible-xs pl-form-container\"><div class=\"\"><div class=\"\"><div class=\"row\"><div ng-repeat=\"invoiceInfo in $ctrl.invoiceInfoList track by invoiceInfo.id\" class=\"customer-list-item\" ng-click=\"$ctrl.editInvoiceInfo(invoiceInfo)\"><!--<eo-avatar-name name=\"{{invoiceInfo.invoiceInfoCode}}\"></eo-avatar-name>--><div class=\"customer-list-item-detail\" style=\"padding-right: 20px\"><div class=\"customer-list-customer-name\" style=\"font-weight: bold;font-size: 16px\">{{invoiceInfo.id}}</div><div class=\"customer-list-customer-name\">{{invoiceInfo.customer.personalInfo.fullName}}</div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span>{{invoiceInfo.invoiceDate | toPersianDate}}</span></div><div class=\"customer-list-customer-phone\"><span><!--{{companyCustomer.createDate | toPersianDate}}</td>--> {{invoiceInfo.finalPrice}} <span translate=\"global.currencyBracket\"></span></span></div></div><div class=\"customer-list-item-detail\"><div class=\"customer-list-customer-phone\"><span ng-class=\"$ctrl.findStatusStyle(invoiceInfo.status)\" style=\"font-size: 12px\" translate=\"{{\'tikonApp.invoiceStatus.\' + invoiceInfo.status}}\">{{invoiceInfo.status}}</span></div></div><md-icon style=\"font-size: 40px; width: 40px; height: 40px; color: black\">chevron_left</md-icon></div></div></div></div><!--<div class=\"\" style=\"padding-top: 20px;width: 80%;padding-right: 5px;\">--><!--<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\"--><!--ng-change=\"vm.transition()\" max-size=\"2\"></uib-pagination>--><!--</div>--></div>");
$templateCache.put("app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html","<md-content class=\"rwMdContent\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-sm-10\"><h4 class=\"modal-title\" id=\"headerLabel\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.startMeetingModalLabel\">Create or edit a Order Bag</h4></div></div></div><div class=\"modal-body\"><!--<div class=\"row\">--><!--<div class=\"col-sm-12\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.moderatorName\" for=\"field_moderatorName\">moderatorName</label>--><!--<input type=\"text\" class=\"form-control\" name=\"moderatorName\" id=\"field_moderatorName\"--><!--ng-model=\"$ctrl.moderatorName\"--><!--/>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row\" ng-if=\"$ctrl.successMsg\"><div class=\"col-sm-10\"><p style=\"color: green\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.msg.createSuccess\"></p></div></div><div class=\"row text-center\" ng-if=\"$ctrl.errorMsg\"><div class=\"col-sm-12\"><p style=\"color: red\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.msg.meetingLinkNotFound\"></p></div></div><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"$ctrl.joinMeetingURL\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.meetingLink\">meetingLink</label><span class=\"copyButton\" ng-click=\"$ctrl.copyMeetingLink()\"><md-icon style=\"color: #2b6b7f;font-size: 22px\">content_copy</md-icon><span>کپی</span></span><div><a ng-href=\"{{$ctrl.joinMeetingURL}}\" target=\"_blank\" style=\"overflow-wrap: break-word\">{{$ctrl.joinMeetingURL}}</a></div></div></div></div><div class=\"row\"><div class=\"col-12-sm pull-left\" ng-if=\"$ctrl.joinMeetingURL\"><md-button class=\"md-raised md-secondary\" ng-href=\"{{$ctrl.joinMeetingURL}}\" target=\"_blank\"><md-icon aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon><span translate=\"tikonApp.orderBagServiceItem.videoMeeting.startVideoCall\">Start</span></md-button></div><!--<div class=\"col-6-sm\" ng-if=\"!$ctrl.joinMeetingURL\">--><!--<md-button class=\"md-raised md-primary\"--><!--ng-click=\"$ctrl.createMeeting()\">--><!--<md-icon aria-hidden=\"true\" >add</md-icon>--><!--<span translate=\"tikonApp.orderBagServiceItem.videoMeeting.createMeeting\">--><!--Create--><!--</span>--><!--</md-button>--><!--</div>--></div></div></md-content>");
$templateCache.put("app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html","<md-content class=\"rwMdContent\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-sm-10\"><h4 class=\"modal-title\" id=\"headerLabel\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.startMeetingModalLabel\">Create or edit a Order Bag</h4></div></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.moderatorName\" for=\"field_moderatorName\">moderatorName</label><input type=\"text\" class=\"form-control\" name=\"moderatorName\" id=\"field_moderatorName\" ng-model=\"$ctrl.moderatorName\"></div></div></div><div class=\"row\" ng-if=\"$ctrl.successMsg\"><div class=\"col-sm-10\"><p style=\"color: green\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.msg.createSuccess\"></p></div></div><div class=\"row\" ng-if=\"$ctrl.errorMsg\"><div class=\"col-sm-10\"><p style=\"color: red\" translate=\"tikonApp.orderBagServiceItem.videoMeeting.msg.createError\"></p></div></div><div class=\"row\" style=\"float: left\"><div class=\"col-6-sm\" ng-if=\"$ctrl.joinMeetingURL\"><md-button class=\"md-raised md-secondary\" ng-click=\"$ctrl.goToMeetingRoom()\"><md-icon aria-hidden=\"true\" style=\"color: #2b6b7f\">videocam</md-icon><span translate=\"tikonApp.orderBagServiceItem.videoMeeting.startVideoCall\">Start</span></md-button></div><div class=\"col-6-sm\" ng-if=\"!$ctrl.joinMeetingURL\"><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.createMeeting()\"><md-icon aria-hidden=\"true\">add</md-icon><span translate=\"tikonApp.orderBagServiceItem.videoMeeting.createMeeting\">Create</span></md-button></div></div></div></md-content>");
$templateCache.put("app/components/partial-forms/location-info/partial-form.location-info.html","<style>.ng-map-info-window {\n        background-color: #5baace;\n        color: #fff;\n    }\n\n    .ng-map-info-window div:first-child > div:nth-child(1) {\n        border-top-color: #5baace !important;\n    }\n\n    .ng-map-info-window div:first-child > div:nth-child(3) div {\n        background-color: transparent !important;\n    }\n\n    .ng-map-info-window div:first-child > div:nth-child(4) {\n        background-color: transparent !important;\n    }\n\n    .current-location {\n        border: 1px solid #c1c1c1;\n        padding: 2px 10px;\n        border-radius: 5px;\n        background-color: #ffffff;\n        color: #424242;\n        /* margin-right: 20px; */\n        box-shadow: 0px 0px 7px -3px;\n        text-align: center;\n        max-width: 130px;\n        margin-top: 12px;\n    }\n\n    .current-location:hover {\n        box-shadow: 0px 0px 9px -3px;\n    }</style><div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.country\" for=\"field_country\">Country</label><md-select class=\"rwMdSelect\" id=\"field_country\" ng-change=\"$ctrl.country_changed()\" name=\"country\" ng-model=\"$ctrl.locationInfo.countryId\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><!--selectorData.id as selectorData.text for selectorData in $ctrl.countryList--><md-option ng-value=\"selectorData.id\" ng-repeat=\"selectorData in $ctrl.countryList\">{{selectorData.text}}</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.state\" for=\"field_state\">State</label><md-select class=\"rwMdSelect\" id=\"field_state\" name=\"state\" ng-change=\"$ctrl.province_changed()\" ng-model=\"$ctrl.locationInfo.stateId\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><!--ng-options=\"selectorData.id as selectorData.text for selectorData in $ctrl.provinceList\"--><md-option ng-value=\"selectorData.id\" ng-repeat=\"selectorData in $ctrl.provinceList\">{{selectorData.text}}</md-option></md-select><!--<select class=\"rwMdSelect plSelect\"--><!--placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"--><!--ng-model=\"$ctrl.state\"--><!--id=\"field_state\" name=\"state\"--><!--ng-change=\"$ctrl.province_changed()\"--><!--ng-options=\"option.text for option in $ctrl.provinceList  track by option.id\"--><!--&gt;--><!--</select>--></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.city\" for=\"field_city\">City</label><md-select class=\"rwMdSelect\" id=\"field_city\" name=\"city\" ng-model=\"$ctrl.locationInfo.cityId\" placeholder=\"{{\'global.pleaseSelectItem\' | translate}}\"><!--ng-options=\"selectorData.id as selectorData.text for selectorData in $ctrl.cityList\"--><md-option ng-value=\"selectorData.id\" ng-repeat=\"selectorData in $ctrl.cityList\">{{selectorData.text}}</md-option></md-select></div></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"$ctrl.locationInfo.address\"></div><div><div class=\"row\"><div class=\"col-md-4 col-sm-6 col-xs-7\" style=\"padding-bottom: 15px;color: #33b3ed;text-align: center\"><span>برای تعیین موقعیت ، علامت <i class=\"glyphicon glyphicon-map-marker\" style=\"color: #3c90ce;font-size: 30px\"></i> را جابجا کنید.</span></div><div class=\"col-md-2 col-xs-5 current-location\" ng-click=\"$ctrl.getCurrentLocation()\"><i class=\"glyphicon glyphicon-screenshot\" style=\"font-size: 15px;top: 4px;color: #3c90ce\"></i> موقعیت جاری</div></div></div><div id=\"mapid\" style=\"height: 400px; border: 4px groove ghostwhite; border-radius: 5px\"></div></div>");
$templateCache.put("app/components/partial-forms/orderbag-item-options/_copy_partial-form.orderbag-item-options.html","<div><span ng-repeat=\"option in $ctrl.allOptions\"><div><input type=\"checkbox\" class=\"form-group\" name=\"selected\" id=\"field_selected\" data-toggle=\"checkbox-x\" data-size=\"xs\" ng-model=\"option.selected\" ng-click=\"$ctrl.checkChanged()\"> {{option.optionName}} {{option.priceInfoDtail.price}}</div></span></div>");
$templateCache.put("app/components/partial-forms/orderbag-item-options/partial-form.orderbag-item-options.html","<div class=\"row\"><div class=\"col-md-6\" ng-repeat=\"option in $ctrl.optionsNoQty\"><div><input type=\"checkbox\" class=\"form-group\" name=\"selected\" id=\"field_selected\" data-toggle=\"checkbox-x\" data-size=\"xs\" ng-model=\"option.selected\" ng-click=\"$ctrl.checkChanged()\"> {{option.optionName}} ( <span><span class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.price\"></span></span> {{option.priceInfoDtail.price | number}} <span translate=\"global.currency\"></span> )</div></div></div><div class=\"row\" style=\"display: flex; align-items: center\" ng-repeat=\"option in $ctrl.optionsWithQty\"><div class=\"col-md-6\">{{option.optionName}} ( <span><span class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.price\"></span> </span>{{option.priceInfoDtail.price | number}} <span translate=\"global.currency\"></span> )</div><div class=\"col-sm-4 col-small-h\"><md-input-container class=\"full-width\"><label>تعداد</label><md-select class=\"rwMdSelect\" id=\"field_qty\" ng-change=\"$ctrl.onQtyChange()\" ng-model=\"option.qty\"><md-option ng-value=\"qty\" ng-repeat=\"qty in $ctrl.getQtyList(option) \">{{qty}}</md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/components/partial-forms/orderbag-service-item/_copy_partial-form.orderbag-service-item.html","<div><div id=\"orderBagServiceItemDtail\"><div data-ng-show=\"$ctrl.formState==\'orderbagitem\'\"><!--<div class=\"row\">--> <span ng-repeat=\"priceInfoDtail in $ctrl.priceInfoDtails\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Service Name</div><div class=\"panel-body\"><div class=\"form-group\"><div>{{priceInfoDtail.title}} : {{priceInfoDtail.priceWithDiscount}}<label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.gty\" for=\"field_qty\">QtyY</label><input type=\"number\" class=\"form-control-inline\" name=\"qty\" id=\"field_qty\" ng-model=\"priceInfoDtail.gty\"></div></div><div class=\"form-group\" id=\"pfOptions\"><pf-order-bag-item-options service-item-id=\"$ctrl.serviceItemId\" order-bag-service-item-dtail-id=\"priceInfoDtail.orderBagServiceItemDtailId\" service-option-items=\"priceInfoDtail.options\"></pf-order-bag-item-options></div></div></div></span><div><div class=\"panel panel-info\"><div class=\"panel-heading\">Price Summary</div><div class=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\" for=\"field_subtotalServicePrice\">subtotalServicePrice</label>{{$ctrl.orderBagServiceItem.subtotalServicePrice}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\" for=\"field_subtotalOptionPrice\">subtotalOptionPrice</label>{{$ctrl.orderBagServiceItem.subtotalOptionPrice}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\" for=\"field_subtotalOptionPrice\">subtotalDiscount</label>{{$ctrl.orderBagServiceItem.subtotalDiscount}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.subtotalVAT\" for=\"field_subtotalVAT\">subtotalDiscount</label>{{$ctrl.orderBagServiceItem.subtotalVAT}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItem.totalRowPrice\" for=\"field_subtotalVAT\">totalRowPrice</label>{{$ctrl.orderBagServiceItem.totalRowPrice}}</div></div></div></div></div><div id=\"participantPerson\" ng-if=\"$ctrl.formState==\'participant\'\"><span ng-repeat=\"participant in $ctrl.orderBagServiceItem.participantPersons\"><div class=\"form-group\" id=\"pfPersonInfo\"><pf-person-info person-info=\"participant.personInfo\"></pf-person-info></div></span></div><div><button ng-click=\"$ctrl.addPricesToOrderbag()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'orderbagitem\'\"><span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span></button> <button type=\"button\" ng-click=\"$ctrl.prev()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span></button> <button ng-click=\"$ctrl.FinalApprove()\" class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\"><span translate=\"tikonApp.orderBagServiceItem.approve\"></span></button></div><!--</div>--></div><!--<div class=\"text-center\">--><!--&lt;!&ndash; <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>&ndash;&gt;--><!--</div>--></div>");
$templateCache.put("app/components/partial-forms/orderbag-service-item/partial-form.orderbag-service-item.html","<style>.service-select {\n        background-color: #f8f8f8;\n        font-size: 15px;\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div><div class=\"panel-body\"><!--selecting service and time--><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><!--<label class=\"control-label hidden-xs\"--><!--translate=\"tikonApp.serviceItem.selectService\">selectService</label>--><md-select class=\"service-select rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectService\' | translate}}\" ng-model=\"$ctrl.orderBagServiceItem.serviceItemId\" ng-change=\"$ctrl.serviceItem_changed()\" style=\"min-width: 100px\"><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.serviceItems\"><small ng-if=\"si.category && si.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2\">{{si.category.categoryName}} - </small>{{si.itemTitle}}</md-option></md-select></div><!--<label translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_serviceItem\">ServiceItem</label>--><!--<select class=\"form-control\" id=\"field_serviceItem\" ng-change=\"$ctrl.serviceItem_changed()\"--><!--name=\"serviceItem\" ng-model=\"$ctrl.orderBagServiceItem.serviceItemId\" required--><!--eo-required=\"\"--><!--ng-options=\"serviceItem.id as serviceItem.itemTitle for serviceItem in $ctrl.serviceItems\">--><!--<option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\">--><!--</option>--><!--</select>--></div></div><div class=\"row\"><div id=\"floatingTimesMonthly\" ng-if=\"$ctrl.scheduleType == \'FLOAT_TIME_SESSIONS\' && $ctrl.floatingTimeType == \'MONTHLY\' \"><div class=\"col-sm-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableFloatMonthlyDates\">AvailableDates</label><select class=\"form-control\" id=\"field_availableFloatMonthlyDates\" ng-change=\"$ctrl.availableDynamicMonthlyDates_changed()\" name=\"availableDynamicMonthlyDates\" ng-model=\"$ctrl.selectedDynamicMonthlyDate\" required eo-required=\"\" ng-options=\"timeSpan as timeSpan.spanDate | toPersianDate   for timeSpan in $ctrl.availableDynamicMonthlyDates\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.monthQty\" for=\"field_timeUnitQty\">TimeUnitQty</label><select class=\"form-control\" id=\"field_timeUnitQty\" ng-change=\"$ctrl.timeUnitQty_Changed()\" name=\"timeUnitQty\" ng-model=\"$ctrl.timeUnitQty\" required eo-required=\"\" ng-options=\"timeQty  for timeQty in $ctrl.availableTimeUnitQty\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div></div><div id=\"preDefinedTimeSession\" ng-if=\"$ctrl.scheduleType != \'FLOAT_TIME_SESSIONS\'\"><div class=\"col-sm-4\" data-ng-show=\" $ctrl.orderBagServiceItem.serviceItemId!=null\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableDates\">AvailableDates</label><select class=\"form-control\" id=\"field_availableDates\" ng-change=\"$ctrl.availableDates_changed()\" name=\"availableDates\" ng-model=\"$ctrl.selectedDate\" required eo-required=\"\" ng-options=\"dates.date as dates.date | toPersianDate   for dates in $ctrl.availableDates\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div><div class=\"col-sm-4\" data-ng-show=\" $ctrl.orderBagServiceItem.serviceItemId!=null\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectTime\" for=\"field_availableTimes\">AvailableTimes</label><select class=\"form-control\" id=\"field_availableTimes\" ng-change=\"$ctrl.availableTimes_changed()\" name=\"availableTimes\" ng-model=\"$ctrl.orderBagServiceItem.serviceTimeSession.id\" required eo-required=\"\" ng-options=\"serviceTimeSession.id as serviceTimeSession.startTime | toPersianTime:\'hh:mm\'  for serviceTimeSession in $ctrl.availableTimes\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div></div><div id=\"floatingTimes\" ng-if=\"$ctrl.scheduleType == \'FLOAT_TIME_SESSIONS\' && $ctrl.floatingTimeType == \'HOURLY\' \"><div class=\"col-sm-3\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableFloatDates\">AvailableDates</label><select class=\"form-control\" id=\"field_availableFloatDates\" ng-change=\"$ctrl.availableDynamicDates_changed()\" name=\"availableDynamicDates\" ng-model=\"$ctrl.selectedDynamicDate\" required eo-required=\"\" ng-options=\"timeSpan.spanDate as timeSpan.spanDate | toPersianDate   for timeSpan in $ctrl.availableDynamicDates\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectFromTime\" for=\"field_availableFromTimes\">AvailableFromTimes</label><select class=\"form-control\" id=\"field_availableFromTimes\" ng-change=\"$ctrl.availableDynamicTimes_changed()\" name=\"availableDynamicTimes\" ng-model=\"$ctrl.selectedDynamicTime\" required eo-required=\"\" ng-options=\"timeSpan.startTime as timeSpan.startTime | toPersianTime:\'hh:mm\'   for timeSpan in $ctrl.availableDynamicTimes\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label translate=\"tikonApp.orderBagServiceItem.selectToTime\" for=\"field_availableToTimes\">AvailableToTimes</label><select class=\"form-control\" id=\"field_availableToTimes\" ng-change=\"$ctrl.ToTime_changed()\" name=\"availableToTimes\" ng-model=\"$ctrl.selectedToTime\" required eo-required=\"\" ng-options=\"timeSpan.endTime as timeSpan.endTime | toPersianTime:\'hh:mm\'   for timeSpan in $ctrl.toTimePeriodList\"><option value=\"\" translate=\"tikonApp.orderBagServiceItem.pleaseSelectItem\"></option></select></div></div></div><!--<div class=\"col-sm-4\" ng-if=\"$ctrl.servants!=null && $ctrl.servants.length>0\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.servant.home.title\" for=\"field_servant\">Servant</label>--><!--<select class=\"form-control\" id=\"field_servant\" ng-change=\"$ctrl.servant_changed()\"--><!--name=\"servant\" ng-model=\"$ctrl.orderBagServiceItem.servant\"--><!--ng-options=\"servant as (servant.personInfo.fisrtName + \' \'+ servant.personInfo.lastName)  for servant in $ctrl.servants\">--><!--</select>--><!--</div>--><!--</div>--></div><!--selecting Qty--><div class=\"row\" ng-if=\"$ctrl.showPrices()\"><div class=\"col-sm-6\" ng-repeat=\"orderBagItemDtail in $ctrl.orderBagServiceItem.orderBagServiceItemDtail\"><div class=\"form-group\"><table><tr><td><label class=\"control-label\">{{orderBagItemDtail.priceInfoDtail.title}} : <span ng-if=\"orderBagItemDtail.priceInfoDtail.priceWithDiscount !== 0\">( {{orderBagItemDtail.priceInfoDtail.priceWithDiscount | number}} <span translate=\"global.currency\"></span> )</span></label></td><td><label class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.gty\" for=\"field_qty\">QtyY</label><input type=\"number\" min=\"0\" ng-change=\"$ctrl.qtyChanged()\" class=\"form-control-inline\" name=\"qty\" id=\"field_qty\" ng-model=\"orderBagItemDtail.gty\" style=\"width: 50px ;text-align: center\"></td><td ng-if=\"$ctrl.scheduleType == \'FLOAT_TIME_SESSIONS\' && $ctrl.floatingTimeType == \'HOURLY\' \"><label class=\"control-label\">X</label></td><td ng-if=\"$ctrl.scheduleType == \'FLOAT_TIME_SESSIONS\' && $ctrl.floatingTimeType == \'HOURLY\' \"><label class=\"control-label\">{{$ctrl.timeUnitQty}} ساعت</label></td></tr></table><!--<div>--><!--تعداد واحد زمانی--><!--<input type=\"number\" min=\"0\" ng-change=\"$ctrl.timeUnitQtyChanged()\" class=\"form-control-inline\"--><!--name=\"timeUnitQty\" id=\"field_timeUnitQty\"--><!--ng-model=\"$ctrl.timeUnitQty\"--><!--style=\"width: 50px ;text-align: center  \"--><!--/>--><!--</div>--><!--<span  > <span class=\"control-label\" translate=\"tikonApp.orderBagServiceItemDtail.price\"></span></span>--></div></div></div></div><!--<div id=\"orderBagServiceItemDtail\">--><!--<div--><!--&gt;--><!--&lt;!&ndash;<div class=\"row\">&ndash;&gt;--><!----><!--<span >--><!----><!--</span>--><!--</div>--><!--</div>--><div ng-show=\"$ctrl.orderBagServiceItem.options && $ctrl.orderBagServiceItem.options.length>0 && $ctrl.orderBagServiceItem.serviceItemId!=null && $ctrl.orderBagServiceItem.serviceTimeSession.id!=undefined\" class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectOptions\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\" id=\"pfOptions\"><pf-order-bag-item-options service-item-id=\"$ctrl.orderBagServiceItem.serviceItemId\" service-option-items=\"$ctrl.orderBagServiceItem.options\" on-selected-change=\"$ctrl.computeTotalPrice()\"></pf-order-bag-item-options></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.participantList\"></span></div><div class=\"panel-body\"><button type=\"button\" ng-click=\"$ctrl.openPersonInfoModal()\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.orderBagServiceItem.addParticipant\">Add Participant</span></button><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th><span translate=\"tikonApp.personInfo.gender.title\">Gender</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat=\"participantPerson in $ctrl.orderBagServiceItem.participantPersons \"><td>{{participantPerson.personInfo.fisrtName}}</td><td>{{participantPerson.personInfo.lastName}}</td><!--<td translate=\"{{\'tikonApp.genderType.\' + participantPerson.personInfo.gender}}\">{{participantPerson.personInfo.gender}}</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" ng-click=\"$ctrl.removeParticipantPerson(participantPerson.personInfo)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div></div><div><style></style><div ng-show=\"$ctrl.orderBagServiceItem.totalRowPrice>0\" class=\"panel panel-success\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{$ctrl.orderBagServiceItem.subtotalServicePrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{$ctrl.orderBagServiceItem.subtotalOptionPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{$ctrl.orderBagServiceItem.subtotalDiscount | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"><table><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{$ctrl.orderBagServiceItem.subtotalVAT | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div><div class=\"col-sm-6\"></div><div class=\"col-sm-6\"><table class=\"text-success\"><tr><td class=\"td-label\"><span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span></td><td class=\"td-text\"><div class=\"text-input\">{{$ctrl.orderBagServiceItem.totalRowPrice | number}} <span translate=\"global.currency\"></span></div></td></tr></table></div></div></div></div></div></div><!--<div>--><!--<button--><!--ng-click=\"$ctrl.addPricesToOrderbag()\"--><!--class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'orderbagitem\'\">--><!--<span class=\"glyphicon glyphicon-menu-left\" translate=\"tikonApp.orderBagServiceItem.next\"></span>--><!--</span>--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"$ctrl.prev()\"--><!--class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\">--><!--<span class=\"glyphicon glyphicon-menu-right\" translate=\"tikonApp.orderBagServiceItem.prev\"></span>--><!--</button>--><!--<button--><!--ng-click=\"$ctrl.FinalApprove()\"--><!--class=\"btn btn-primary btn-sm\" ng-if=\"$ctrl.formState==\'participant\'\">--><!--<span translate=\"tikonApp.orderBagServiceItem.approve\"></span>--><!--</button>--><!--</div>--><!--</div>--><!--<div class=\"text-center\">--><!--&lt;!&ndash; <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>&ndash;&gt;--><!--</div>-->");
$templateCache.put("app/components/partial-forms/orderbag-service-item/partial-form.reserve-service-item-v2.html","<style>.service-select {\n        background-color: #f8f8f8;\n        font-size: 15px;\n    }\n\n    #serviceTitle, #serviceTitle > small {\n        position: absolute;\n        margin-right: 15px;\n    }\n\n    #serviceTitle > small {\n        top: 16px;\n    }\n\n    input[type=search] {\n        border: none;\n        padding-top: 10px;\n    }\n\n    .serviceColorCircle {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        margin-top: 18px;\n        position: absolute;\n    }</style><!--<div class=\"panel panel-default\">--><!--<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div>--><!--<div class=\"panel-body\">--><!--selecting service and time--><md-switch ng-model=\"$ctrl.showUnPlannedTime\" ng-if=\"!$ctrl.hasMultipleReserveTime\" ng-change=\"$ctrl.showUnPlannedTimeChange()\" class=\"col-small-h\" style=\"white-space: unset\">زمان دلخواه (بدون توجه به زمانبندی تعریف شده)</md-switch><div class=\"row\"><div class=\"col-sm-6 col-small-h\" ng-if=\"$ctrl.editMode==\'NONE\'\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.serviceItem.selectService\">selectService</label><md-autocomplete ng-disabled=\"$ctrl.isDisabled\" md-no-cache=\"$ctrl.noCache\" md-selected-item=\"$ctrl.selectedService\" md-selected-item-change=\"$ctrl.serviceItem_changed(item)\" md-search-text=\"$ctrl.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=\"item.itemTitle\" md-min-length=\"0\" placeholder=\"{{\'tikonApp.serviceItem.selectService\' | translate}}\" input-aria-labelledby=\"favoriteStateLabel\" input-aria-describedby=\"autocompleteDetailedDescription\"><md-item-template><!--<span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{item.itemTitle}}</span>--><div ng-class=\"item.color\" class=\"serviceColorCircle\"></div><div id=\"serviceTitle\">{{item.itemTitle}}<br><small ng-if=\"item.category && item.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2; font-size: 10px\">{{item.category.categoryName}}</small></div><div></div></md-item-template><md-not-found>{{\'tikonApp.serviceItem.noTitleFor\' | translate}} \"{{$ctrl.searchText}}\" {{\'tikonApp.serviceItem.notFound\' | translate}}.<!--<a ng-click=\"$ctrl.newState($ctrl.searchText)\">Create a new one!</a>--></md-not-found></md-autocomplete></md-input-container></div><div class=\"col-sm-4 col-small-h\" data-ng-if=\"$ctrl.servantList && $ctrl.servantList.length>0\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.serviceItem.selectServant-v2\" translate-values=\"{servantTitle: \'{{$ctrl.activityTypeInfo.servantTitle}}\'}\">selectServant</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectServant\' | translate}}\" ng-model=\"$ctrl.orderBagServiceItem.servant.id\" ng-change=\"$ctrl.servant_changed()\"><!--style=\"min-width: 300px;\"--><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.servantList\">{{si.servantName}}</md-option></md-select></md-input-container><!--<select>--><!--<option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.servantList\">--><!--{{si.servantName}}--><!--</option>--><!--</select>--></div></div><div class=\"row\"><div id=\"floatingTimes\"><div class=\"col-sm-4 col-small-h\"><md-input-container class=\"full-width\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableFloatDates\">AvailableDates</label><md-select class=\"rwMdSelect\" id=\"field_availableFloatDates\" ng-change=\"$ctrl.availableDynamicDates_changed()\" ng-model=\"$ctrl.selectedDynamicDate\" scroll-hit-bottom=\"$ctrl.loadMoreAvailableDates()\"><!--style=\"min-width: 150px;\"--><md-option ng-value=\"timeSpan.spanDate\" ng-repeat=\"timeSpan in $ctrl.availableDynamicDates\">{{timeSpan.spanDate | toFullPersianDate }}</md-option></md-select><!--{{$ctrl.selectedDynamicDate}}--></md-input-container></div><div class=\"col-sm-3 col-small-h\"><md-input-container class=\"full-width\"><label translate=\"tikonApp.orderBagServiceItem.selectFromTime\" for=\"field_availableFromTimes\">AvailableFromTimes</label><md-select class=\"rwMdSelect\" id=\"field_availableFromTimes\" ng-change=\"$ctrl.availableDynamicFromTime_changed()\" ng-model=\"$ctrl.selectedDynamicTime\"><!--style=\"min-width: 100px;\"--><md-option ng-value=\"timeSpan.startTime\" ng-repeat=\"timeSpan in $ctrl.availableDynamicTimes\">{{timeSpan.startTime | toPersianTime:\'hh:mm\' }}</md-option></md-select><!--{{$ctrl.selectedDynamicTime}}--></md-input-container></div><div class=\"col-sm-3 col-small-h\"><md-input-container class=\"full-width\"><label translate=\"tikonApp.orderBagServiceItem.selectToTime\" for=\"field_availableToTimes_1\">AvailableToTimes</label><md-select class=\"rwMdSelect\" id=\"field_availableToTimes_1\" ng-change=\"$ctrl.availableDynamicToTime_changed()\" ng-model=\"$ctrl.selectedToTime\"><!--style=\"min-width: 100px;\"--><md-option ng-value=\"timeSpan.endTime\" ng-repeat=\"timeSpan in $ctrl.toTimePeriodList\">{{timeSpan.endTime | toPersianTime:\'hh:mm\' }}</md-option></md-select><!--{{$ctrl.selectedToTime}}--></md-input-container></div></div></div><!--selecting Qty--><div class=\"row\" ng-if=\" $ctrl.orderBagServiceItem.orderBagServiceItemDtail && $ctrl.showCountBox && $ctrl.editMode==\'NONE\'\"><div class=\"col-sm-4 col-small-h\" ng-repeat=\"orderBagItemDtail in $ctrl.orderBagServiceItem.orderBagServiceItemDtail\"><md-input-container class=\"full-width\"><label>تعداد</label><md-select class=\"rwMdSelect\" id=\"field_availableToTimes\" ng-change=\"$ctrl.qtyChanged()\" ng-model=\"orderBagItemDtail.gty\"><md-option ng-value=\"qty\" ng-repeat=\"qty in $ctrl.availableQty \">{{qty}}</md-option></md-select><div class=\"hint\">{{orderBagItemDtail.priceInfoDtail.title}} <span ng-if=\"orderBagItemDtail.priceInfoDtail.priceWithDiscount\">: ( {{orderBagItemDtail.priceInfoDtail.priceWithDiscount | number}} <span translate=\"global.currency\"></span> )</span></div></md-input-container></div></div><!--</div>--><!--</div>--><div class=\"row\" ng-if=\"$ctrl.showUnPlannedTime && !$ctrl.isCapacityAvailable \"><div class=\"col-md-12\"><span style=\"color: red\">زمان مورد نظر تعطیل است یا رزرو ثبت شده است . </span><span>ولی همچنان شما میتوانید رزرو ثبت کنید (امکان تداخل زمانی)</span></div></div><div ng-show=\"$ctrl.orderBagServiceItem.options && $ctrl.orderBagServiceItem.options.length>0 && $ctrl.orderBagServiceItem.serviceItemId!=null && $ctrl.showOptionItems\" class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectOptions\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\" id=\"pfOptions\"><pf-order-bag-item-options service-item-id=\"$ctrl.orderBagServiceItem.serviceItemId\" service-option-items=\"$ctrl.orderBagServiceItem.options\" on-selected-change=\"$ctrl.computeTotalPrice()\"></pf-order-bag-item-options></div></div></div></div></div><!--<div--><!--ng-show=\"$ctrl.orderBagServiceItem.options && $ctrl.orderBagServiceItem.options.length>0 && $ctrl.orderBagServiceItem.serviceItemId!=null && $ctrl.orderBagServiceItem.serviceTimeSession.id!=undefined\"--><!--class=\"panel panel-default\">--><!--<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectOptions\"></span></div>--><!--<div class=\"panel-body\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" id=\"pfOptions\">--><!--<pf-order-bag-item-options service-item-id=\"$ctrl.orderBagServiceItem.serviceItemId\"--><!--service-option-items=\"$ctrl.orderBagServiceItem.options\"--><!--on-selected-change=\"$ctrl.computeTotalPrice()\"--><!--&gt;--><!--</pf-order-bag-item-options>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--&lt;!&ndash;<div class=\"panel panel-default\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.participantList\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"panel-body\">&ndash;&gt;--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"$ctrl.openPersonInfoModal()\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-primary btn-sm\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs\" translate=\"tikonApp.orderBagServiceItem.addParticipant\">&ndash;&gt;--><!--&lt;!&ndash;Add Participant&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"table-responsive\">&ndash;&gt;--><!--&lt;!&ndash;<table class=\"jh-table table table-striped\">&ndash;&gt;--><!--&lt;!&ndash;<thead>&ndash;&gt;--><!--&lt;!&ndash;<tr>&ndash;&gt;--><!--&lt;!&ndash;<th><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span&ndash;&gt;--><!--&lt;!&ndash;class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;<th><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span&ndash;&gt;--><!--&lt;!&ndash;class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<th><span translate=\"tikonApp.personInfo.gender.title\">Gender</span> <span&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<th></th>&ndash;&gt;--><!--&lt;!&ndash;</tr>&ndash;&gt;--><!--&lt;!&ndash;</thead>&ndash;&gt;--><!--&lt;!&ndash;<tbody>&ndash;&gt;--><!--&lt;!&ndash;<tr ng-repeat=\"participantPerson in $ctrl.orderBagServiceItem.participantPersons \">&ndash;&gt;--><!--&lt;!&ndash;<td>{{participantPerson.personInfo.fisrtName}}</td>&ndash;&gt;--><!--&lt;!&ndash;<td>{{participantPerson.personInfo.lastName}}</td>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<td translate=\"{{\'tikonApp.genderType.\' + participantPerson.personInfo.gender}}\">{{participantPerson.personInfo.gender}}</td>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<td class=\"text-right\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"btn-group flex-btn-group-container\">&ndash;&gt;--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"$ctrl.removeParticipantPerson(participantPerson.personInfo)\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-danger btn-sm\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-remove-circle\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--&lt;!&ndash;</tr>&ndash;&gt;--><!--&lt;!&ndash;</tbody>&ndash;&gt;--><!--&lt;!&ndash;</table>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><div><!--<div ng-show=\" $ctrl.orderBagServiceItem.totalRowPrice>0\" class=\"panel panel-success\">--><!--<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div>--><!--<div class=\"panel-body\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\">{{$ctrl.orderBagServiceItem.subtotalServicePrice | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.subtotalOptionPrice | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.subtotalDiscount | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.subtotalVAT | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\"></div>--><!--<div class=\"col-sm-6\">--><!--<table class=\"text-success\">--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.totalRowPrice | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/components/partial-forms/orderbag-service-item/partial-form.reserve-service-item.html","<style>.service-select {\n        background-color: #f8f8f8;\n        font-size: 15px;\n    }\n\n    #serviceTitle, #serviceTitle > small {\n        position: absolute;\n        margin-right: 15px;\n    }\n\n    #serviceTitle > small {\n        top: 16px;\n    }\n\n    input[type=search] {\n        border: none;\n        padding-top: 10px;\n    }\n\n    .serviceColorCircle {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        margin-top: 18px;\n        position: absolute;\n    }</style><!--<div class=\"panel panel-default\">--><!--<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectService\"></span></div>--><!--<div class=\"panel-body\">--><!--selecting service and time--><div class=\"row\" ng-if=\"$ctrl.editMode==\'NONE\'\"><div class=\"col-sm-6 col-small-h\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.serviceItem.selectService\">selectService</label><md-autocomplete ng-disabled=\"$ctrl.isDisabled\" md-no-cache=\"$ctrl.noCache\" md-selected-item=\"$ctrl.selectedService\" md-selected-item-change=\"$ctrl.serviceItem_changed(item)\" md-search-text=\"$ctrl.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=\"item.itemTitle\" md-min-length=\"0\" placeholder=\"{{\'tikonApp.serviceItem.selectService\' | translate}}\" input-aria-labelledby=\"favoriteStateLabel\" input-aria-describedby=\"autocompleteDetailedDescription\"><md-item-template><!--<span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{item.itemTitle}}</span>--><div ng-class=\"item.color\" class=\"serviceColorCircle\"></div><div id=\"serviceTitle\">{{item.itemTitle}}<br><small ng-if=\"item.category && item.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2; font-size: 10px\">{{item.category.categoryName}}</small></div><div></div></md-item-template><md-not-found>{{\'tikonApp.serviceItem.noTitleFor\' | translate}} \"{{$ctrl.searchText}}\" {{\'tikonApp.serviceItem.notFound\' | translate}}.<!--<a ng-click=\"$ctrl.newState($ctrl.searchText)\">Create a new one!</a>--></md-not-found></md-autocomplete></md-input-container></div><div class=\"col-sm-4 col-small-h\" data-ng-if=\"$ctrl.servantList && $ctrl.servantList.length>0 && $ctrl.editMode==\'NONE\'\"><md-input-container class=\"full-width\"><label class=\"hidden-xs\" translate=\"tikonApp.serviceItem.selectServant\">selectServant</label><md-select class=\"rwMdSelect\" placeholder=\"{{\'tikonApp.serviceItem.selectServant\' | translate}}\" ng-model=\"$ctrl.orderBagServiceItem.servant.id\" ng-change=\"$ctrl.servant_changed()\"><!--style=\"min-width: 300px;\"--><md-option ng-value=\"si.id\" ng-repeat=\"si in $ctrl.servantList\">{{si.servantName}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div id=\"floatingTimes\"><div class=\"col-sm-4 col-small-h\"><md-input-container class=\"full-width\"><label translate=\"tikonApp.orderBagServiceItem.selectDate\" for=\"field_availableFloatDates\">AvailableDates</label><md-select class=\"rwMdSelect\" id=\"field_availableFloatDates\" ng-change=\"$ctrl.availableDynamicDates_changed()\" ng-model=\"$ctrl.selectedDynamicDate\" scroll-hit-bottom=\"$ctrl.loadMoreAvailableDates()\"><!--style=\"min-width: 150px;\"--><md-option ng-value=\"timeSpan.spanDate\" ng-repeat=\"timeSpan in $ctrl.availableDynamicDates\">{{timeSpan.spanDate | toFullPersianDate }}</md-option></md-select><!--{{$ctrl.selectedDynamicDate}}--></md-input-container></div><div class=\"col-sm-3 col-small-h\"><md-input-container class=\"full-width\"><label translate=\"tikonApp.orderBagServiceItem.selectFromTime\" for=\"field_availableFromTimes\">AvailableFromTimes</label><md-select class=\"rwMdSelect\" id=\"field_availableFromTimes\" ng-change=\"$ctrl.availableDynamicFromTime_changed()\" ng-model=\"$ctrl.selectedDynamicTime\"><!--style=\"min-width: 100px;\"--><md-option ng-value=\"timeSpan.startTime\" ng-repeat=\"timeSpan in $ctrl.availableDynamicTimes\">{{timeSpan.startTime | toPersianTime:\'hh:mm\' }}</md-option></md-select><!--{{$ctrl.selectedDynamicTime}}--></md-input-container></div><div class=\"col-sm-3 col-small-h\"><md-input-container class=\"full-width\"><label translate=\"tikonApp.orderBagServiceItem.selectToTime\" for=\"field_availableToTimes\">AvailableToTimes</label><md-select class=\"rwMdSelect\" id=\"field_availableToTimes\" ng-change=\"$ctrl.availableDynamicToTime_changed()\" ng-model=\"$ctrl.selectedToTime\"><!--style=\"min-width: 100px;\"--><md-option ng-value=\"timeSpan.endTime\" ng-repeat=\"timeSpan in $ctrl.toTimePeriodList\">{{timeSpan.endTime | toPersianTime:\'hh:mm\' }}</md-option></md-select><!--{{$ctrl.selectedToTime}}--></md-input-container></div></div></div><!--selecting Qty--><div class=\"row\" ng-if=\" $ctrl.orderBagServiceItem.orderBagServiceItemDtail && $ctrl.showCountBox && $ctrl.editMode==\'NONE\'\"><div class=\"col-sm-4 col-small-h\" ng-repeat=\"orderBagItemDtail in $ctrl.orderBagServiceItem.orderBagServiceItemDtail\"><md-input-container class=\"full-width\"><label>تعداد</label><md-select class=\"rwMdSelect\" id=\"field_availableToTimes\" ng-change=\"$ctrl.qtyChanged()\" ng-model=\"orderBagItemDtail.gty\"><md-option ng-value=\"qty\" ng-repeat=\"qty in $ctrl.availableQty \">{{qty}}</md-option></md-select><div class=\"hint\">{{orderBagItemDtail.priceInfoDtail.title}} <span ng-if=\"orderBagItemDtail.priceInfoDtail.priceWithDiscount\">: ( {{orderBagItemDtail.priceInfoDtail.priceWithDiscount | number}} <span translate=\"global.currency\"></span> )</span></div></md-input-container></div></div><!--</div>--><!--</div>--><div ng-show=\"$ctrl.orderBagServiceItem.options && $ctrl.orderBagServiceItem.options.length>0 && $ctrl.orderBagServiceItem.serviceItemId!=null \" class=\"panel panel-default\"><div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectOptions\"></span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\" id=\"pfOptions\"><pf-order-bag-item-options service-item-id=\"$ctrl.orderBagServiceItem.serviceItemId\" service-option-items=\"$ctrl.orderBagServiceItem.options\" on-selected-change=\"$ctrl.computeTotalPrice()\"></pf-order-bag-item-options></div></div></div></div></div><!--<div--><!--ng-show=\"$ctrl.orderBagServiceItem.options && $ctrl.orderBagServiceItem.options.length>0 && $ctrl.orderBagServiceItem.serviceItemId!=null && $ctrl.orderBagServiceItem.serviceTimeSession.id!=undefined\"--><!--class=\"panel panel-default\">--><!--<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.selectOptions\"></span></div>--><!--<div class=\"panel-body\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" id=\"pfOptions\">--><!--<pf-order-bag-item-options service-item-id=\"$ctrl.orderBagServiceItem.serviceItemId\"--><!--service-option-items=\"$ctrl.orderBagServiceItem.options\"--><!--on-selected-change=\"$ctrl.computeTotalPrice()\"--><!--&gt;--><!--</pf-order-bag-item-options>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--&lt;!&ndash;<div class=\"panel panel-default\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.participantList\"></span></div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"panel-body\">&ndash;&gt;--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"$ctrl.openPersonInfoModal()\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-primary btn-sm\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-plus\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs\" translate=\"tikonApp.orderBagServiceItem.addParticipant\">&ndash;&gt;--><!--&lt;!&ndash;Add Participant&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"table-responsive\">&ndash;&gt;--><!--&lt;!&ndash;<table class=\"jh-table table table-striped\">&ndash;&gt;--><!--&lt;!&ndash;<thead>&ndash;&gt;--><!--&lt;!&ndash;<tr>&ndash;&gt;--><!--&lt;!&ndash;<th><span translate=\"tikonApp.personInfo.fisrtName\">Fisrt Name</span> <span&ndash;&gt;--><!--&lt;!&ndash;class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;<th><span translate=\"tikonApp.personInfo.lastName\">Last Name</span> <span&ndash;&gt;--><!--&lt;!&ndash;class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<th><span translate=\"tikonApp.personInfo.gender.title\">Gender</span> <span&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<th></th>&ndash;&gt;--><!--&lt;!&ndash;</tr>&ndash;&gt;--><!--&lt;!&ndash;</thead>&ndash;&gt;--><!--&lt;!&ndash;<tbody>&ndash;&gt;--><!--&lt;!&ndash;<tr ng-repeat=\"participantPerson in $ctrl.orderBagServiceItem.participantPersons \">&ndash;&gt;--><!--&lt;!&ndash;<td>{{participantPerson.personInfo.fisrtName}}</td>&ndash;&gt;--><!--&lt;!&ndash;<td>{{participantPerson.personInfo.lastName}}</td>&ndash;&gt;--><!--&lt;!&ndash;&lt;!&ndash;<td translate=\"{{\'tikonApp.genderType.\' + participantPerson.personInfo.gender}}\">{{participantPerson.personInfo.gender}}</td>&ndash;&gt;&ndash;&gt;--><!--&lt;!&ndash;<td class=\"text-right\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"btn-group flex-btn-group-container\">&ndash;&gt;--><!--&lt;!&ndash;<button type=\"button\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"$ctrl.removeParticipantPerson(participantPerson.personInfo)\"&ndash;&gt;--><!--&lt;!&ndash;class=\"btn btn-danger btn-sm\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-remove-circle\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--&lt;!&ndash;</tr>&ndash;&gt;--><!--&lt;!&ndash;</tbody>&ndash;&gt;--><!--&lt;!&ndash;</table>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><div><!--<div ng-show=\" $ctrl.orderBagServiceItem.totalRowPrice>0\" class=\"panel panel-success\">--><!--<div class=\"panel-heading\"><span translate=\"tikonApp.orderBagServiceItemDtail.totalPrices\"></span></div>--><!--<div class=\"panel-body\">--><!--<div class=\"row\">--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalServicePrice\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\">{{$ctrl.orderBagServiceItem.subtotalServicePrice | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalOptionPrice\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.subtotalOptionPrice | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalDiscount\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.subtotalDiscount | number}}--><!--<span translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\">--><!--<table>--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.subtotalVAT\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.subtotalVAT | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<div class=\"col-sm-6\"></div>--><!--<div class=\"col-sm-6\">--><!--<table class=\"text-success\">--><!--<tr>--><!--<td class=\"td-label\">--><!--<span translate=\"tikonApp.orderBagServiceItem.totalRowPrice\"></span>--><!--</td>--><!--<td class=\"td-text\">--><!--<div class=\"text-input\"> {{$ctrl.orderBagServiceItem.totalRowPrice | number}} <span--><!--translate=\"global.currency\"></span></div>--><!--</td>--><!--</tr>--><!--</table>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/components/partial-forms/person-info/partial-form.person-info.html","<div class=\"row\"><!--<div id=\"gallerySection\">--><!--<div class=\"panel \">--><!--<div class=\"panel-heading\">--><!--<span translate=\"tikonApp.personInfo.profileimage\"--><!--&gt;imageAlbumTab</span>--><!--</div>--><div class=\"col-md-2\"><!--<div class=\"col-md-6\">--><!--<div class=\"panel-body\">--><eo-image-gallery-manager-v2 album-id=\"$ctrl.personInfo.image\" max-image-count=\"1\" crop-width=\"250\" crop-height=\"250\" album-caption=\"\'\'\"></eo-image-gallery-manager-v2></div><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"$ctrl.personInfo.fisrtName\" required eo-required=\"\" ng-change=\"$ctrl.necessaryFieldsCheck()\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"$ctrl.personInfo.lastName\" required eo-required=\"\" ng-change=\"$ctrl.necessaryFieldsCheck()\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.gender.title\">Gender</label><div class=\"row\" style=\"margin-top: 8px;margin-right: 0px\"><md-radio-group ng-model=\"$ctrl.personInfo.gender\" layout><md-radio-button class=\"md-primary\" ng-value=\"true\"><span translate=\"tikonApp.personInfo.gender.male\">Male</span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"tikonApp.personInfo.gender.female\">Female</span></md-radio-button></md-radio-group></div></div><!--<div class=\"form-group\" ng-if=\"!$ctrl.blockedEdit\">--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.gender.title\">Gender</label>--><!--<div class=\"row\" style=\"margin-top: 8px;\">--><!--<md-radio-group ng-model=\"$ctrl.personInfo.gender\" ng-disabled=\"$ctrl.blockedEdit\">--><!--<div class=\"col-md-2\">--><!--<md-radio-button class=\"md-primary\" ng-value=\"true\">--><!--<span translate=\"tikonApp.personInfo.gender.male\">Male</span>--><!--</md-radio-button>--><!--</div>--><!--<div class=\"col-md-2\">--><!--<md-radio-button ng-value=\"false\">--><!--<span translate=\"tikonApp.personInfo.gender.female\">Female</span>--><!--</md-radio-button>--><!--</div>--><!--</md-radio-group>--><!--</div>--><!--</div>--></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\" ng-model=\"$ctrl.personInfo.phoneNumber\" ng-disabled=\"$ctrl.blockedEdit || $ctrl.blockEditPhoneNumber\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.email\" for=\"field_email\">email</label><input type=\"email\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"$ctrl.personInfo.email\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\" for=\"field_birthDate\">Birth Date</label><div><eo-date-picker id=\"field_birthDate\" date-value=\"$ctrl.personInfo.birthDate\"></eo-date-picker></div></div><!--<div class=\"form-group\" ng-if=\"!$ctrl.blockedEdit\"  style=\"margin-top: 20px;\">--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\"--><!--for=\"field_birthDate\">Birth--><!--Date</label>--><!--<eo-date-picker id=\"field_birthDate\"--><!--date-value=\"$ctrl.personInfo.birthDate\" ></eo-date-picker>--><!--</div>--></div></div><div class=\"row\"><!--<div class=\"col-md-4\" ng-if=\"$ctrl.isCustomer\">--><div class=\"col-md-4\" ng-if=\"$ctrl.isServant\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.servant.personnelCode\" for=\"field_personnelCode\">personelCode</label><input type=\"text\" class=\"form-control\" name=\"personnelCode\" id=\"field_personnelCode\" ng-model=\"$ctrl.servantCode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.nationalCode\" for=\"field_nationalCode\">National Code</label><input type=\"text\" class=\"form-control\" name=\"nationalCode\" id=\"field_nationalCode\" ng-model=\"$ctrl.personInfo.nationalCode\" maxlength=\"10\"></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"$ctrl.personInfo.location.address\"></div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.locationInfo.country\" for=\"field_country\">Country</label>--><!--<select class=\"form-control\" id=\"field_country\" ng-change=\"$ctrl.country_changed()\"--><!--name=\"country\"--><!--ng-model=\"$ctrl.personInfo.location.countryId\"--><!--ng-options=\"selectorData.id as selectorData.text for selectorData in $ctrl.countryList\">--><!--<option value=\"\" translate=\"global.pleaseSelectItem\">--><!--</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.locationInfo.state\" for=\"field_state\">State</label>--><!--<select class=\"form-control\" id=\"field_state\" name=\"state\" ng-change=\"$ctrl.province_changed()\"--><!--ng-model=\"$ctrl.personInfo.location.stateId\"--><!--ng-options=\"selectorData.id as selectorData.text for selectorData in $ctrl.provinceList\">--><!--<option value=\"\" translate=\"global.pleaseSelectItem\">--><!--</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label translate=\"tikonApp.locationInfo.city\" for=\"field_city\">City</label>--><!--<select class=\"form-control\" id=\"field_city\" name=\"city\"--><!--ng-model=\"$ctrl.personInfo.location.cityId\"--><!--ng-options=\"selectorData.id as selectorData.text for selectorData in $ctrl.cityList\">--><!--<option value=\"\" translate=\"global.pleaseSelectItem\">--><!--</option>--><!--</select>--><!--</div>--><!--</div>--><!--</div>--></div><!--<div>\n\n    &lt;!&ndash;<jhi-alert></jhi-alert>&ndash;&gt;\n    &lt;!&ndash;<div class=\"container-fluid\">&ndash;&gt;\n    &lt;!&ndash;<div class=\"row\">&ndash;&gt;\n    &lt;!&ndash;</div>&ndash;&gt;\n    &lt;!&ndash;</div>&ndash;&gt;\n    &lt;!&ndash;&ndash;&gt;\n    <ul class=\"nav nav-tabs  nav-justified lightnav\">\n        <li class=\"active\"><a data-toggle=\"tab\" data-target=\"#basicInfoTab\">\n            <span translate=\"tikonApp.personInfo.sections.generalTab\">generalTab </span>\n        </a></li>\n        <li><a data-toggle=\"tab\" data-target=\"#locationInfoTab\">\n            <span translate=\"tikonApp.personInfo.sections.locationTab\">Location Tab </span>\n        </a></li>\n    </ul>\n\n\n    <div id=\"personInfo\">\n\n        <div class=\"tab-content panel panel-default\">\n            <div id=\"basicInfoTab\" class=\"tab-pane fade in active\">\n\n\n            </div>\n            <div id=\"locationInfoTab\" class=\"tab-pane fade\">\n\n                <div>\n\n\n\n\n                </div>\n\n\n            </div>\n        </div>\n\n\n    </div>\n\n    <div class=\"text-center\">\n        &lt;!&ndash; <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>\n         <uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>&ndash;&gt;\n    </div>\n\n\n</div>-->");
$templateCache.put("app/components/partial-forms/person-info-space/partial-form.person-info-space.html","<div class=\"row\"><!--<div id=\"gallerySection\">--><!--<div class=\"panel \">--><!--<div class=\"panel-heading\">--><!--<span translate=\"tikonApp.personInfo.profileimage\"--><!--&gt;imageAlbumTab</span>--><!--</div>--><div class=\"col-md-2\"><!--<div class=\"col-md-6\">--><!--<div class=\"panel-body\">--><eo-image-gallery-manager-v2 album-id=\"$ctrl.personInfo.image\" max-image-count=\"1\" crop-width=\"250\" crop-height=\"250\" album-caption=\"\'\'\"></eo-image-gallery-manager-v2></div><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"$ctrl.personInfo.fisrtName\" required eo-required=\"\" ng-change=\"$ctrl.necessaryFieldsCheck()\"></div></div><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">Last--><!--Name</label>--><!--<input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\"--><!--ng-model=\"$ctrl.personInfo.lastName\" required eo-required=\"\"--><!--ng-change=\"$ctrl.necessaryFieldsCheck()\"--><!--/>--><!--</div>--><!--</div>--></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_phoneNumber\"><span translate=\"tikonApp.personInfo.phoneNumber\"></span> ( <span translate=\"tikonApp.personInfo.related-person\"></span> )</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\" ng-model=\"$ctrl.personInfo.phoneNumber\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_email\"><span translate=\"tikonApp.personInfo.email\"></span> ( <span translate=\"tikonApp.personInfo.related-person\"></span> )</label><input type=\"email\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"$ctrl.personInfo.email\"></div></div></div><!--<div class=\"row\">--><!--&lt;!&ndash;<div class=\"col-md-4\" ng-if=\"$ctrl.isServant\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.servant.personnelCode\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_personnelCode\">personelCode</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"personnelCode\" id=\"field_personnelCode\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.servantCode\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"col-md-8\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.locationInfo.address\"&ndash;&gt;--><!--&lt;!&ndash;for=\"field_address\">Address</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.personInfo.location.address\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--></div></div>");
$templateCache.put("app/components/partial-forms/person-info-v2/partial-form.person-info-v2.html","<div class=\"row\"><div class=\"col-md-2\" ng-if=\"$ctrl.showImage\"><eo-image-gallery-manager-v2 album-id=\"$ctrl.personInfo.image\" max-image-count=\"1\" crop-width=\"250\" crop-height=\"250\" album-caption=\"\'\'\"></eo-image-gallery-manager-v2></div><div ng-class=\"$ctrl.showImage ?  \'col-md-10\' : \'col-md-12\'\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.personInfo.fisrtName\" for=\"field_fisrtName\">Fisrt Name</label><input type=\"text\" class=\"form-control\" name=\"fisrtName\" id=\"field_fisrtName\" ng-model=\"$ctrl.personInfo.fisrtName\" required eo-required=\"\" ng-change=\"$ctrl.necessaryFieldsCheck()\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.personInfo.lastName\" for=\"field_lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" id=\"field_lastName\" ng-model=\"$ctrl.personInfo.lastName\" required eo-required=\"\" ng-change=\"$ctrl.necessaryFieldsCheck()\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.gender.title\">Gender</label><div class=\"row\" style=\"margin-top: 8px;margin-right: 0px\"><md-radio-group ng-model=\"$ctrl.personInfo.gender\" layout><md-radio-button class=\"md-primary\" ng-value=\"true\"><span translate=\"tikonApp.personInfo.gender.male\">Male</span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"tikonApp.personInfo.gender.female\">Female</span></md-radio-button></md-radio-group></div></div><!--<div class=\"form-group\" ng-if=\"!$ctrl.blockedEdit\">--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.gender.title\">Gender</label>--><!--<div class=\"row\" style=\"margin-top: 8px;\">--><!--<md-radio-group ng-model=\"$ctrl.personInfo.gender\" ng-disabled=\"$ctrl.blockedEdit\">--><!--<div class=\"col-md-2\">--><!--<md-radio-button class=\"md-primary\" ng-value=\"true\">--><!--<span translate=\"tikonApp.personInfo.gender.male\">Male</span>--><!--</md-radio-button>--><!--</div>--><!--<div class=\"col-md-2\">--><!--<md-radio-button ng-value=\"false\">--><!--<span translate=\"tikonApp.personInfo.gender.female\">Female</span>--><!--</md-radio-button>--><!--</div>--><!--</md-radio-group>--><!--</div>--><!--</div>--></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" maxlength=\"11\" id=\"field_phoneNumber\" ng-model=\"$ctrl.personInfo.phoneNumber\" ng-disabled=\"$ctrl.blockedEdit || $ctrl.blockEditPhoneNumber\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.email\" for=\"field_email\">email</label><input type=\"email\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"$ctrl.personInfo.email\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\" for=\"field_birthDate\">Birth Date</label><div><eo-date-picker id=\"field_birthDate\" date-value=\"$ctrl.personInfo.birthDate\"></eo-date-picker></div></div><!--<div class=\"form-group\" ng-if=\"!$ctrl.blockedEdit\"  style=\"margin-top: 20px;\">--><!--<label class=\"control-label\" translate=\"tikonApp.personInfo.birthDate\"--><!--for=\"field_birthDate\">Birth--><!--Date</label>--><!--<eo-date-picker id=\"field_birthDate\"--><!--date-value=\"$ctrl.personInfo.birthDate\" ></eo-date-picker>--><!--</div>--></div></div><div class=\"row\"><!--<div class=\"col-md-4\" ng-if=\"$ctrl.isCustomer\">--><div class=\"col-md-4\" ng-if=\"$ctrl.isServant\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.servant.personnelCode\" for=\"field_personnelCode\">personelCode</label><input type=\"text\" class=\"form-control\" name=\"personnelCode\" id=\"field_personnelCode\" ng-model=\"$ctrl.servantCode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.personInfo.nationalCode\" for=\"field_nationalCode\">National Code</label><input type=\"text\" class=\"form-control\" name=\"nationalCode\" id=\"field_nationalCode\" ng-model=\"$ctrl.personInfo.nationalCode\" maxlength=\"10\"></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.locationInfo.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"$ctrl.personInfo.location.address\"></div></div></div></div></div>");
$templateCache.put("app/components/partial-forms/pos-payment/pos-payment-dialog.html","<pf-pos-payment total-amount=\"totalAmount\" invoice-info-id=\"invoiceInfoId\" terminal-id=\"12710647\" payment-unit=\"\'TOMAN\'\"></pf-pos-payment>");
$templateCache.put("app/components/partial-forms/pos-payment/pos-payment.html","<form name=\"posForm\" class=\"pos-payment-dialog\" style=\"padding: 16px; direction: rtl\"><!-- هدر دیالوگ --><div layout=\"row\" layout-align=\"space-between center\" style=\"margin-bottom: 12px\"><div layout=\"row\" layout-align=\"start center\" style=\"gap: 8px\"><md-icon style=\"color: #455a64; font-size: 20px\">point_of_sale</md-icon><span style=\"font-weight: 700; font-size: 15px; color: #263238\">پرداخت با دستگاه کارتخوان (POS)</span></div><md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\" style=\"margin: 0\"><md-icon style=\"font-size: 20px\">close</md-icon></md-button></div><md-dialog-content class=\"md-dialog-content\" style=\"padding: 4px 0 16px 0\"><!-- ۱. مرحله وارد کردن و ویرایش مبلغ --><div ng-if=\"$ctrl.step === \'INPUT\'\" layout=\"column\"><!-- بنر راهنما --><div layout=\"row\" layout-align=\"start center\" class=\"pos-info-banner\" style=\"background: #eef5fc; border-radius: 8px; padding: 10px 14px; margin-bottom: 20px; gap: 8px; color: #1976d2\"><md-icon style=\"font-size: 18px; color: #1976d2\">info_outline</md-icon><span style=\"font-size: 12.5px\">مبلغ قابل پرداخت را بررسی کرده و در صورت نیاز ویرایش کنید.</span></div><!-- باکس مبلغ --><div layout=\"column\" layout-align=\"center center\" style=\"border: 1px solid #e0e0e0; border-radius: 10px; padding: 18px; position: relative\"><span style=\"font-size: 13px; color: #78909c; margin-bottom: 8px\">مبلغ قابل پرداخت به دستگاه (تومان)</span><div layout=\"row\" layout-align=\"center center\" style=\"gap: 8px; width: 100%\"><button type=\"button\" class=\"btn-clean\" ng-click=\"$ctrl.toggleEdit()\" style=\"border: none; background: none; cursor: pointer; color: #546e7a\"><md-icon style=\"font-size: 18px\">edit</md-icon></button><div ng-if=\"!$ctrl.isEditing\" style=\"font-size: 26px; font-weight: 800; color: #1e293b; letter-spacing: 0.5px\">{{ $ctrl.payableAmount | number }}</div><div ng-if=\"$ctrl.isEditing\" style=\"max-width: 180px\"><eo-numeric-input-v2 name=\"customPosAmount\" form-reference=\"posForm\" custom-class=\"form-control text-center\" input-value=\"$ctrl.payableAmount\" currency-format=\"true\" min=\"1000\" max=\"{{ $ctrl.totalAmount }}\" style=\"font-size: 20px; font-weight: bold\"></eo-numeric-input-v2></div><span style=\"font-size: 14px; color: #475569\">تومان</span></div><div layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%; border-top: 1px dashed #e2e8f0; margin-top: 14px; padding-top: 10px; font-size: 12px; color: #64748b\"><span>مبلغ فاکتور: {{ $ctrl.totalAmount | number }} تومان</span><!-- <button type=\"button\" class=\"btn-clean\" ng-click=\"$ctrl.toggleEdit()\" style=\"border: none; background: none; cursor: pointer; color: #546e7a;\">\n                        <md-icon style=\"font-size: 18px;\">edit</md-icon>\n                        <span style=\"color: #94a3b8; font-size: 11px;\">\n                        قابل ویرایش توسط شما\n                        </span>\n                    </button> --></div></div></div><!-- ۲. مرحله در انتظار پاسخ دستگاه --><div ng-if=\"$ctrl.step === \'PENDING\'\" layout=\"column\" layout-align=\"center center\" style=\"padding: 10px 0\"><div layout=\"row\" layout-align=\"start center\" class=\"pos-info-banner\" style=\"background: #eef5fc; border-radius: 8px; padding: 10px 14px; margin-bottom: 24px; width: 100%; gap: 8px; color: #1976d2\"><md-icon style=\"font-size: 18px; color: #1976d2\">info_outline</md-icon><span style=\"font-size: 12.5px\">مبلغ {{ $ctrl.payableAmount | number }} تومان به دستگاه کارتخوان ارسال شد.</span></div><div class=\"pos-spinner-wrapper\" style=\"position: relative; width: 140px; height: 140px; margin: 10px 0 20px 0\" layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"140\" style=\"position: absolute\"></md-progress-circular><md-icon style=\"font-size: 44px; width: 44px; height: 44px; color: #3b82f6\">point_of_sale</md-icon></div><h3 style=\"font-size: 16px; font-weight: 700; color: #1e293b; margin: 0 0 6px 0\">در انتظار پاسخ از دستگاه کارتخوان</h3><span style=\"font-size: 12px; color: #94a3b8\">لطفاً چند لحظه صبر کنید...</span></div><!-- ۳. مرحله پرداخت موفق --><div ng-if=\"$ctrl.step === \'SUCCESS\'\" layout=\"column\" layout-align=\"center center\" style=\"padding: 6px 0\"><div style=\"width: 60px; height: 60px; border-radius: 50%; background: #22c55e; color: #fff; margin-bottom: 14px\" layout=\"row\" layout-align=\"center center\"><md-icon style=\"color: #fff; font-size: 34px; width: 34px; height: 34px\">check</md-icon></div><h3 style=\"font-size: 18px; font-weight: 800; color: #16a34a; margin: 0 0 6px 0\">پرداخت با موفقیت انجام شد</h3><span style=\"font-size: 13px; color: #64748b; margin-bottom: 20px\">مبلغ {{ $ctrl.payableAmount | number }} تومان با موفقیت دریافت شد.</span><div layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 14px 16px\"><div layout=\"column\" layout-align=\"center center\"><span style=\"font-size: 11.5px; color: #94a3b8; margin-bottom: 4px\">مبلغ پرداختی</span> <span style=\"font-size: 13px; font-weight: 700; color: #16a34a\">{{ $ctrl.payableAmount | number }} تومان</span></div><div style=\"width: 1px; height: 28px; background: #e2e8f0\"></div><div layout=\"column\" layout-align=\"center center\"><span style=\"font-size: 11.5px; color: #94a3b8; margin-bottom: 4px\">شماره فاکتور</span> <span style=\"font-size: 13px; font-weight: 600; color: #334155\">{{ $ctrl.invoiceInfoId || $ctrl.receiptData.invoiceNumber || \'---\' }}</span></div><div style=\"width: 1px; height: 28px; background: #e2e8f0\"></div><div layout=\"column\" layout-align=\"center center\"><span style=\"font-size: 11.5px; color: #94a3b8; margin-bottom: 4px\">شماره تراکنش (POS)</span> <span style=\"font-size: 13px; font-weight: 600; color: #334155\">{{ $ctrl.receiptData.transactionId || $ctrl.receiptData.rrn || \'---\' }}</span></div></div></div><!-- ۴. مرحله پرداخت ناموفق --><div ng-if=\"$ctrl.step === \'FAILED\'\" layout=\"column\" layout-align=\"center center\" style=\"padding: 6px 0\"><div style=\"width: 60px; height: 60px; border-radius: 50%; background: #ef4444; color: #fff; margin-bottom: 14px\" layout=\"row\" layout-align=\"center center\"><md-icon style=\"color: #fff; font-size: 34px; width: 34px; height: 34px\">close</md-icon></div><h3 style=\"font-size: 18px; font-weight: 800; color: #dc2626; margin: 0 0 6px 0\">پرداخت انجام نشد</h3><span style=\"font-size: 13px; color: #64748b; margin-bottom: 18px\">تراکنش توسط دستگاه کارتخوان ناموفق بود.</span><div layout=\"column\" style=\"width: 100%; background: #fef2f2; border: 1px solid #fee2e2; border-radius: 8px; padding: 12px 16px; margin-bottom: 12px; align-items: flex-start\"><div layout=\"row\" layout-align=\"start center\" style=\"color: #991b1b; font-size: 12px; gap: 6px; margin-bottom: 4px\"><md-icon style=\"font-size: 16px; color: #ef4444\">error_outline</md-icon><span>علت خطا:</span></div><div style=\"color: #b91c1c; font-size: 13px; ; padding-right: 12px\">{{ $ctrl.errorMessage || \'تراکنش توسط مشتری لغو شد.\' }}</div></div><span style=\"font-size: 12px; color: #94a3b8\">لطفاً مجدداً تلاش کنید.</span></div><!-- ۵. مرحله عدم پاسخ دستگاه --><div ng-if=\"$ctrl.step === \'TIMEOUT\'\" layout=\"column\" layout-align=\"center center\" style=\"padding: 6px 0\"><div style=\"width: 60px; height: 60px; border-radius: 50%; background: #f59e0b; color: #fff; margin-bottom: 14px\" layout=\"row\" layout-align=\"center center\"><md-icon style=\"color: #fff; font-size: 34px; width: 34px; height: 34px\">warning</md-icon></div><h3 style=\"font-size: 18px; font-weight: 800; color: #d97706; margin: 0 0 6px 0\">پاسخی از دستگاه دریافت نشد</h3><span style=\"font-size: 13px; color: #64748b; margin-bottom: 18px\">دستگاه کارتخوان در دسترس نیست یا پاسخی ارسال نمی‌کند.</span><div layout=\"column\" style=\"width: 100%; background: #fffbeb; border: 1px solid #fef3c7; border-radius: 8px; padding: 14px 16px; font-size: 12.5px; color: #92400e; gap: 8px\"><div layout=\"row\" layout-align=\"start center\" style=\"gap: 8px\"><span style=\"width: 5px; height: 5px; background: #b45309; border-radius: 50%\"></span> <span>اتصال دستگاه را بررسی کنید.</span></div><div layout=\"row\" layout-align=\"start center\" style=\"gap: 8px\"><span style=\"width: 5px; height: 5px; background: #b45309; border-radius: 50%\"></span> <span>مطمئن شوید دستگاه روشن و متصل است.</span></div><div layout=\"row\" layout-align=\"start center\" style=\"gap: 8px\"><span style=\"width: 5px; height: 5px; background: #b45309; border-radius: 50%\"></span> <span>در صورت نیاز با پشتیبانی تماس بگیرید.</span></div></div></div></md-dialog-content><!-- فوتر و اکشن‌های دیالوگ بر اساس هر وضعیت --><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" style=\"padding-top: 10px; border-top: 1px solid #f1f5f9\"><!-- اکشن‌های مرحله ۱ (ورود مبلغ) --><ng-container ng-if=\"$ctrl.step === \'INPUT\'\"><md-button ng-click=\"$ctrl.cancel()\" style=\"color: #ef4444; border: 1px solid #fee2e2; border-radius: 6px; min-width: 100px\">انصراف</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.sendToPos()\" style=\"background-color: #0f172a; color: #fff; border-radius: 6px; min-width: 200px; margin: 0\">ارسال مبلغ به دستگاه و پرداخت</md-button></ng-container><!-- اکشن‌های مرحله ۲ (در حال انتظار) --><ng-container ng-if=\"$ctrl.step === \'PENDING\'\"><md-button ng-click=\"$ctrl.cancel()\" style=\"color: #ef4444; border: 1px solid #fee2e2; border-radius: 6px; width: 100%\"><!-- <md-icon style=\"font-size: 16px; color: #ef4444; vertical-align: middle;\">cancel</md-icon> --> انصراف</md-button></ng-container><!-- اکشن‌های مرحله ۳ (موفق) --><ng-container ng-if=\"$ctrl.step === \'SUCCESS\'\"><!-- <md-button ng-click=\"$ctrl.printReceipt()\" style=\"border: 1px solid #cbd5e1; border-radius: 6px; min-width: 120px; color: #334155;\">\n                <md-icon style=\"font-size: 16px; vertical-align: middle; margin-left: 4px;\">print</md-icon>\n                چاپ رسید\n            </md-button> --> <span></span><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.closeSuccess()\" style=\"background-color: #0f172a;\n                    color: #fff;\n                    border-radius: 6px;\n                    min-width: 120px;\n                    margin: 0\">بستن</md-button></ng-container><!-- اکشن‌های مرحله ۴ و ۵ (خطا و تایم‌اوت) --><ng-container ng-if=\"$ctrl.step === \'FAILED\' || $ctrl.step === \'TIMEOUT\'\"><md-button ng-click=\"$ctrl.cancel()\" style=\"color: #ef4444; border: 1px solid #fee2e2; border-radius: 6px; min-width: 100px\"><!-- <md-icon style=\"font-size: 16px; color: #ef4444; vertical-align: middle;\">cancel</md-icon> --> انصراف</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.retry()\" style=\"background-color: #0f172a; color: #fff; border-radius: 6px; min-width: 140px; margin: 0\">تلاش مجدد</md-button></ng-container></md-dialog-actions></form>");
$templateCache.put("app/components/partial-forms/quick-access-tools/partial-form.quick-access-tools.html","<div style=\"max-width: 500px ; margin: auto;padding-right: 38px\"><div id=\"orderBagList\" class=\"quick-access-box\" ui-sref=\"supplierPanel.orderBagList\"><i class=\"fa fa-list fa-2x\"></i><div>لیست رزروها</div></div><div id=\"timeBoard\" class=\"quick-access-box\" ui-sref=\"supplierPanel.timeBoard\"><i class=\"fa fa-calendar fa-2x\"></i><div>تقویم کاری</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"newServiceItem\" class=\"quick-access-box\" ui-sref=\"supplierPanel.generalServiceItem\"><i class=\"fa fa-briefcase fa-2x\"></i><div>درج سرویس جدید</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"newOrderBag\" class=\"quick-access-box\" ui-sref=\"supplierPanel.upsertOrderBagNew\"><i class=\"fa fa-calendar-plus-o fa-2x\"></i><div>ثبت رزرو جدید</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"customerList\" class=\"quick-access-box\" ui-sref=\"supplierPanel.companyCustomer\"><i class=\"fa fa-id-card-o fa-2x\"></i><div>لیست مشتریان</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"serviceItemList\" class=\"quick-access-box\" ui-sref=\"supplierPanel.reserveServices\"><i class=\"fa fa-list-alt fa-2x\"></i><div>لیست سرویسها</div></div></div><div id=\"quickAccessV2\" has-any-authority=\"ROLE_RESERVATION_MANAGER,ROLE_CUSTOMER_MANAGER,ROLE_CATEGORY_MANAGER,ROLE_COMPANY_MANAGER\"><div style=\"max-width: 500px ; margin: auto;padding-right: 38px\"><div id=\"orderBagListv2\" class=\"quick-access-box\" ui-sref=\"supplierPanel.reserveList\"><i class=\"fa fa-list fa-2x\"></i><div>لیست رزروها</div></div><div id=\"calendar\" class=\"quick-access-box\" ui-sref=\"supplierPanel.calendar\"><i class=\"fa fa-calendar fa-2x\"></i><div>تقویم کاری</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"newServiceItemV2\" class=\"quick-access-box\" ui-sref=\"supplierPanel.generalServiceItemV2\"><i class=\"fa fa-briefcase fa-2x\"></i><div>درج سرویس جدید</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"newReserve\" class=\"quick-access-box\" ui-sref=\"supplierPanel.reserve_v2\"><i class=\"fa fa-calendar-plus-o fa-2x\"></i><div>ثبت رزرو جدید</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"customerListV2\" class=\"quick-access-box\" ui-sref=\"supplierPanel.companyCustomer\"><i class=\"fa fa-id-card-o fa-2x\"></i><div>لیست مشتریان</div></div><div has-any-authority=\"ROLE_COMPANY_MANAGER\" id=\"serviceItemListV2\" class=\"quick-access-box\" ui-sref=\"supplierPanel.reserveServices\"><i class=\"fa fa-list-alt fa-2x\"></i><div>لیست سرویسها</div></div></div></div>");
$templateCache.put("app/components/partial-forms/reserve-list/partial-form.reserve-list.html","<style>.view-intake-data-link {\n        color: #00b09f;\n        cursor: pointer;\n    }\n\n    .serviceColorCircle {\n        width: 17px;\n        height: 17px;\n        border-radius: 50%;\n    }\n\n    #moreFilters_content {\n        display: none;\n    }\n\n    #moreFilters_btn {\n        margin-bottom: 20px;\n        cursor: pointer;\n    }\n\n    #filter_by_service > md-select-value > span, #filter_by_servant > md-select-value > span {\n        display: -webkit-inline-box;\n    }\n\n    md-select-menu md-option[selected] {\n        color: white;\n        background-color: rgb(96, 125, 139);\n    }\n\n    md-select-menu md-option[selected]:focus {\n        color: white;\n        background-color: rgb(96, 125, 139);\n    }\n\n    md-select-menu[multiple] md-option.md-checkbox-enabled .md-container {\n        background-color: white;\n    }\n\n    #search-btn {\n        margin-top: 25px;\n        border-radius: 50%;\n        min-width: unset;\n        width: 40px;\n        color: #2b6b7f !important;\n    }\n\n    .rwTable {\n        font-size: small;\n    }\n\n    .rwTable tr td {\n        max-width: 185px;\n        word-wrap: break-word;\n    }\n\n    .inline-divs > div {\n        display: inline;\n    }</style><md-content class=\"rwMdContent\"><div ng-if=\"$ctrl.orderBagServiceItems && $ctrl.orderBagServiceItems.length>0\" style=\"overflow: auto\"><table st-safe-src=\"$ctrl.orderBagServiceItems\" st-table=\"collection\" st-safe- class=\"jh-table table rwTable\"><thead><tr><th st-sort=\"orderBagId\" style=\"min-width: 104px\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"serviceItemTitle\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.orderBag.status.title\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.reserveType\">Reserve Type</span></th><th><span translate=\"tikonApp.orderBag.number\">number</span></th><!--<th>--><!--<span--><!--translate=\"tikonApp.orderBag.detailedDescription\">detailedDescription</span>--><!--</th>--><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><a ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a></td><td style=\"padding: 0\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"serviceColorCircle\"></div></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div><!--</div>--></td><td><md-tooltip md-direction=\"top\"><!--<div id=\"company_customer_intakeformData\" class=\"row\">--><!--<component-intake-data-viewer--><!--intake-data=\"vm.companyCustomer.customerIntakeData\"></component-intake-data-viewer>--><!--</div>--> <span ng-repeat=\"field in vm.companyCustomer.customerIntakeData.fields\" style=\"margin: 5px\">{{field.label}}: {{field.value}}</span></md-tooltip>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}<div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div>{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></td><td ng-class=\"$ctrl.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{$ctrl.findStatusTitle(orderBagServiceItem.orderBag.status)}}</td><td>{{orderBagServiceItem.orderBag.finalPrice | number}}</td><td><div>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}}</div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startTime\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td><td class=\"inline-divs\"><!--{{vm.reserveGatewayToPersian(orderBagServiceItem.orderBag.reserveGateway)}}--><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway !== \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.online\' | translate}}</md-tooltip><i class=\"fa fa-internet-explorer\" aria-hidden=\"true\"></i></div><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway == \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.panel\' | translate}}</md-tooltip><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.hasSomePayment\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.paymentLogs\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i></div></td><td class=\"text-center\"><span ng-if=\"orderBagServiceItem.orderBagServiceItemDtail[0]\">{{orderBagServiceItem.orderBagServiceItemDtail[0].gty}} </span><span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.checkedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: green\">alarm_on</i> </span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.notcheckedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'NOT_CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: red\">alarm_off</i></span></span></td><!--<td>--><!--<span class=\"view-intake-data-link\" data-ng-click=\"vm.showIntakeData(orderBagServiceItem.orderBag)\"--><!--ng-if=\"orderBagServiceItem.orderBag.intakeData\">--><!--<i class=\"fa fa-clone\"></i>--><!--مشاهده--><!--</span>--><!--</td>--><td></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"supplierPanel.editOrderBag({id:orderBagServiceItem.orderBag.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div><div ng-if=\"!$ctrl.orderBagServiceItems || $ctrl.orderBagServiceItems.length==0\"><eo-no-data></eo-no-data></div></md-content>");
$templateCache.put("app/components/partial-forms/reserve-list-v2/partial-form.reserve-list-v2.html","<style>.orderbag-tags {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    .orderbag-tags span {\n        background-color: #d7d7d7;\n        color: #000;\n        border-radius: 8px;\n        padding: 4px;\n        font-size: 10px;\n    }</style><div class=\"\"><div ng-if=\"$ctrl.orderBagServiceItems && $ctrl.orderBagServiceItems.length>0\" style=\"overflow: auto\"><table st-safe-src=\"$ctrl.orderBagServiceItems\" st-table=\"collection\" class=\"jh-table table rwTable\"><thead><tr class=\"pl-table-header\"><th st-sort=\"orderBagId\" style=\"min-width: 104px\"><span translate=\"tikonApp.orderBagServiceItem.orderBagId\">Order Bag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"color\"><span></span></th><th st-sort=\"serviceItemTitle\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBagServiceItem.serviceItemName\">Service Item</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"customerName\"><span translate=\"tikonApp.orderBag.customerName\">customerName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"status\"><span translate=\"tikonApp.orderBag.status.title\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"finalPrice\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.finalPrice\">Final Price</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th st-sort=\"serviceTime\" style=\"min-width: 106px\"><span translate=\"tikonApp.orderBag.serviceTime\">Service Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"tikonApp.orderBag.reserveType\">Reserve Type</span></th><th><span translate=\"tikonApp.orderBag.number\">number</span></th><!--<th>--><!--<span--><!--translate=\"tikonApp.orderBag.detailedDescription\">detailedDescription</span>--><!--</th>--><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderBagServiceItem in collection track by orderBagServiceItem.id\"><td><a ui-sref=\"supplierPanel-v2.editOrderBag({id:orderBagServiceItem.orderBag.id})\">{{orderBagServiceItem.orderBag.id}}</a></td><td style=\"padding: 0\"><div ng-class=\"orderBagServiceItem.serviceItem.color\" class=\"serviceColorCircle\"></div></td><td>{{orderBagServiceItem.serviceItem.itemTitle}}<div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.serviceItem.category.categoryName!=\'DEFAULT_CATEGORY\'\">{{orderBagServiceItem.serviceItem.category.categoryName}}</div><div style=\"font-size: 10px;color: #8c8c8c\" ng-if=\"orderBagServiceItem.servant\">{{orderBagServiceItem.servant.servantName}}</div><!--</div>--></td><td><md-tooltip md-direction=\"top\"><!--<div id=\"company_customer_intakeformData\" class=\"row\">--><!--<component-intake-data-viewer--><!--intake-data=\"vm.companyCustomer.customerIntakeData\"></component-intake-data-viewer>--><!--</div>--> <span ng-repeat=\"field in vm.companyCustomer.customerIntakeData.fields\" style=\"margin: 5px\">{{field.label}}: {{field.value}}</span></md-tooltip>{{orderBagServiceItem.orderBag.customer.personalInfo.fisrtName}} {{orderBagServiceItem.orderBag.customer.personalInfo.lastName}}<div has-authority=\"ROLE_CUSTOMER_MANAGER\">{{orderBagServiceItem.orderBag.customer.personalInfo.phoneNumber}}</div><div>{{orderBagServiceItem.orderBag.customer.personalInfo.email}}</div></td><td ng-class=\"$ctrl.findStatusStyle(orderBagServiceItem.orderBag.status)\"><span class=\"glyphicon glyphicon-stop\"></span> {{$ctrl.findStatusTitle(orderBagServiceItem.orderBag.status)}}</td><td>{{orderBagServiceItem.orderBag.finalPrice | number}}</td><td><div>{{orderBagServiceItem.serviceTimeSession.startTime | toPersianDate}}</div><div ng-if=\"orderBagServiceItem.serviceTimeSession.startTime\">{{orderBagServiceItem.serviceTimeSession.endTime | toPersianTime}} - {{orderBagServiceItem.serviceTimeSession.startTime | toPersianTime}}</div></td><td class=\"inline-divs\"><!--{{vm.reserveGatewayToPersian(orderBagServiceItem.orderBag.reserveGateway)}}--><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway !== \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.online\' | translate}}</md-tooltip><i class=\"fa fa-internet-explorer\" aria-hidden=\"true\"></i></div><div ng-if=\"orderBagServiceItem.orderBag.reserveGateway == \'SUPPLIER_PANEL_WEB\'\"><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.panel\' | translate}}</md-tooltip><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><div><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBagServiceItem.hasSomePayment\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.paymentLogs\" class=\"fa fa-dollar\" aria-hidden=\"true\"></i></div></td><td class=\"text-center\"><span ng-if=\"orderBagServiceItem.orderBagServiceItemDtail[0]\">{{orderBagServiceItem.orderBagServiceItemDtail[0].gty}} </span><span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.checkedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: green\">alarm_on</i> </span><span><md-tooltip md-direction=\"top\">{{\'tikonApp.orderBag.notcheckedin\' | translate}}</md-tooltip><i ng-if=\"orderBagServiceItem.checkinStatus == \'NOT_CHECKIN\'\" class=\"material-icons\" style=\"font-size: 23px;color: red\">alarm_off</i></span></span></td><!--<td>--><!--<span class=\"view-intake-data-link\" data-ng-click=\"vm.showIntakeData(orderBagServiceItem.orderBag)\"--><!--ng-if=\"orderBagServiceItem.orderBag.intakeData\">--><!--<i class=\"fa fa-clone\"></i>--><!--مشاهده--><!--</span>--><!--</td>--><td><div class=\"orderbag-tags\" ng-if=\"orderBagServiceItem.orderBag.tags && orderBagServiceItem.orderBag.tags.length\"><span ng-if=\"orderBagServiceItem.orderBag.tags[0] \">{{orderBagServiceItem.orderBag.tags[0].tag}}</span> <span ng-if=\"orderBagServiceItem.orderBag.tags[1]\">{{orderBagServiceItem.orderBag.tags[1].tag}}</span> <span ng-if=\"orderBagServiceItem.orderBag.tags.length > 2\">+{{orderBagServiceItem.orderBag.tags.length-2}}</span></div></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"$ctrl.editReserve(orderBagServiceItem)\" class=\"btn btn-primary pl-btn-primary btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"order-bag-service-item.delete({id:orderBagServiceItem.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table><div ng-ig=\"$ctrl.totalItems > 10\" style=\"display: flex; justify-content: center\"><uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\" max-size=\"5\" items-per-page=\"$ctrl.pageSize\"></uib-pagination></div></div></div><div ng-if=\"!$ctrl.orderBagServiceItems || $ctrl.orderBagServiceItems.length==0\"><eo-no-data></eo-no-data></div>");
$templateCache.put("app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html","<style>md-select.rwMdSelect.padded {\n        min-width: 300px;\n    }\n\n    .label-part {\n        padding: 5px;\n        margin: 5px;\n    }\n\n\n    .mdOpenParent, .mdCloseParent {\n        background-color: white !important;\n    }\n\n    .mdOpenParent:hover {\n        background-color: rgba(14, 122, 184, 0.33) !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .mdCloseParent:hover {\n        background-color: #ff000140 !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .OffOnText {\n        position: relative;\n        top: 3px;\n        padding-right: 5px;\n        color: #151515;\n    }\n\n    .OffOnIcon {\n        float: right;\n        margin-top: 0;\n    }\n\n    @media screen and (min-width: 1024px) {\n\n        .duration-block {\n            max-width: 90%;\n            display: inline-block;\n        }\n\n    }\n\n    @media screen and (max-width: 480px) {\n        md-select.rwMdSelect.padded {\n            min-width: unset;\n        }\n    }</style><div class=\"modal-header\"><div class=\"row\"><div class=\"col-sm-12\" style=\"display: flex\"><span><h4 class=\"modal-title\" id=\"headerLabel\"><div ng-if=\"$ctrl.availabilityMode==\'CLOSE\'\">{{\'tikonApp.scheduleInfo.servantExceptionDuration.closeTitle\'|translate}}</div><div ng-if=\"$ctrl.availabilityMode==\'OPEN\'\">{{\'tikonApp.scheduleInfo.servantExceptionDuration.openTitle\'|translate}}</div></h4><h4 class=\"modal-title\" id=\"headerLabel_open\" ng-if=\"$ctrl.availabilityMode==\'Open\'\" translate=\"tikonApp.scheduleInfo.servantExceptionDuration.openTitle\">Add Close Times</h4></span><span ng-if=\"$ctrl.selectedServant\" style=\"padding-right: 5px\"><h5 class=\"modal-title\">> {{$ctrl.selectedServant.personInfo.fullName}}</h5></span></div></div></div><md-content><div class=\"modal-body rwMdContent\" style=\"max-width: 500px\"><div class=\"row\" ng-if=\"$ctrl.canSelectServant\"><div class=\"col-md-6\"><label class=\"control-label\" style=\"margin-bottom: 3px\">انتخاب</label><md-select class=\"rwMdSelect\" name=\"servantList\" ng-model=\"$ctrl.selectedServant\"><md-option ng-repeat=\"srv in $ctrl.servantList\" ng-value=\"srv\">{{srv.personInfo.fullName}}</md-option></md-select></div></div><div class=\"row\"><div class=\"col-md-12\"><eo-date-duration-selector start-date=\"$ctrl.startDate\" end-date=\"$ctrl.endDate\" show-end-date=\"$ctrl.showEndDate\" only-show-start-date=\"true\"></eo-date-duration-selector></div></div><div class=\"row\" style=\"padding-left: 20px\"><div class=\"col-md-12\"><eo-time-range-v2 start-time=\"$ctrl.startTime\" end-time=\"$ctrl.endTime\"></eo-time-range-v2></div></div><div class=\"row\"><div class=\"col-md-12 text-center\" style=\"margin-top: -10px\"><md-button id=\"addExceptionDuration\" class=\"md-raised md-primary\" style=\"margin-top: 12px\" ng-click=\"$ctrl.addDuration()\"><!--<i class=\"material-icons\">add</i>--> +اضافه شود</md-button></div></div><div class=\"row\" id=\"errorMessageSection\" ng-if=\"$ctrl.errorMessage\"><div class=\"col-md-12 alert alert-warning fade in alert-dismissible show\">{{$ctrl.errorMessage}}</div></div><div class=\"row\" style=\"padding: 0 15px\"><div class=\"exception-duration-block col-sm-3 col-xs-12\" ng-class=\"$ctrl.getDurationBlockClass(item)\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse \" ng-click=\"$ctrl.removeDuration(item)\"><span class=\"glyphicon glyphicon-remove\" style=\"float: left; margin-left: -11px\"></span><div class=\"exception-duration-dates-text\"><div>{{item.startDate | toPersianDate}}</div><div ng-if=\"!$ctrl.isDateEqual(item.startDate,item.endDate) \">{{item.endDate | toPersianDate}}</div><div class=\"full-day\" ng-if=\"$ctrl.isFullDay(item)\">تمام روز</div><div ng-if=\"!$ctrl.isFullDay(item)\">{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-md-9\">--><!--</div>--><!--<div class=\"col-md-3\">--><!--</div>--><!--</div>--></div></md-content><div class=\"modal-footer\"><md-button type=\"button\" class=\"md-raised md-secondary\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeModal()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"$ctrl.okModal()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></md-button></div>");
$templateCache.put("app/components/partial-forms/servant-exception-duration-list/partial-form.servant-exception-duration-list.html","<style>md-select.rwMdSelect.padded {\n        min-width: 300px;\n    }\n\n\n    .label-part {\n        padding: 5px;\n        margin: 5px;\n    }\n\n\n    .mdOpenParent, .mdCloseParent {\n        background-color: white !important;\n    }\n\n    .mdOpenParent:hover {\n        background-color: rgba(14, 122, 184, 0.33) !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .mdCloseParent:hover {\n        background-color: #ff000140 !important;\n        transition-duration: 1s;\n        -moz-transition-duration: 1s;\n        -webkit-transition-duration: 1s;\n        -o-transition-duration: 1s;\n    }\n\n    .OffOnText {\n        position: relative;\n        top: 3px;\n        padding-right: 5px;\n        color: #151515;\n    }\n\n    .OffOnIcon {\n        float: right;\n        margin-top: 0;\n    }\n\n    .full-day {\n        padding: 5px;\n        font-size: smaller;\n    }\n\n    @media screen and (min-width: 1024px) {\n\n        .duration-block {\n            max-width: 90%;\n            display: inline-block;\n        }\n\n    }\n\n    @media screen and (max-width: 480px) {\n        md-select.rwMdSelect.padded {\n            min-width: unset;\n        }\n    }</style><div><div class=\"pl-container-light\"><div ng-if=\"!$ctrl.exdurations || $ctrl.exdurations.length == 0\"><eo-no-data message=\"$ctrl.noDataMessage\"></eo-no-data></div><div ng-if=\"$ctrl.exdurations || $ctrl.exdurations.length > 0\" class=\"row\" style=\"padding: 0 15px\"><div class=\"exception-duration-block col-sm-3 col-xs-12\" ng-class=\"$ctrl.getDurationBlockClass(item)\" ng-repeat=\"item in $ctrl.exdurations | orderBy: \'startDate\':reverse \" ng-click=\"$ctrl.removeDuration(item.id)\"><span class=\"glyphicon glyphicon-remove\" style=\"float: left; margin-left: -11px\"></span><div class=\"exception-duration-dates-text\"><div>{{item.startDate | toPersianDate}}</div><div ng-if=\"!$ctrl.isDateEqual(item.startDate,item.endDate) \">{{item.endDate | toPersianDate}}</div><div class=\"full-day\" ng-if=\"$ctrl.isFullDay(item)\">تمام روز</div><div ng-if=\"!$ctrl.isFullDay(item)\">{{item.startTime | toPersianTime}}-{{item.endTime | toPersianTime}}</div></div></div></div></div></div>");
$templateCache.put("app/components/partial-forms/service-item-agreement-info/partial-form.service-item-agreement-info.html","<div><!--<jhi-alert></jhi-alert>--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--</div>--><!--</div>--><!----><div id=\"agreementInfo\"><!--<div class=\"form-group\" ng-show=\"vm.agreementInfo.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"$ctrl.agreementInfo.id\" readonly />--><!--</div>--><div class=\"form-group\"><label style=\"padding: 10px\" active=\"active\" class=\"control-label\" translate=\"tikonApp.agreementInfo.rules\" for=\"field_rules\">Rules</label><!--<div height=\"150\" style=\"padding: 10px\"   type=\"text\" summernote class=\"form-control\" name=\"rules\" id=\"field_rules\"--><!--ng-model=\"$ctrl.agreement.rules\"--><!--&gt;--><!--</div>--><eo-rich-text-editor id=\"field_rules\" input-value=\"$ctrl.agreement.rules\"></eo-rich-text-editor></div><div class=\"form-group\" ng-if=\"$ctrl.__config.appMode==\'reserve\'\"><md-checkbox ng-model=\"$ctrl.agreement.mustConfirmAgreement\" eo-help-tooltip=\"tips.service_must_confirm_agreement\">{{\'tikonApp.agreementInfo.confirmAgreement\' | translate}}</md-checkbox><div ng-if=\"$ctrl.agreement.mustConfirmAgreement\"><label style=\"padding: 10px\" class=\"control-label\" translate=\"tikonApp.agreementInfo.agreement\" for=\"field_agreement\">Agreement</label><!--<div height=\"150\" style=\"padding: 10px\"   type=\"text\" summernote  class=\"form-control\" name=\"agreement\" id=\"field_agreement\"--><!--ng-model=\"$ctrl.agreement.agreement\" required--><!--&gt;--><!--</div>--><eo-rich-text-editor id=\"field_agreement\" input-value=\"$ctrl.agreement.agreement\"></eo-rich-text-editor><p ng-if=\"$ctrl.agreement.agreement == null\" style=\"color: red\" translate=\"tikonApp.agreementInfo.pleaseSetTheAgreement\"></p></div></div></div><div class=\"text-center\"><!-- <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>\n         <uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>--></div></div>");
$templateCache.put("app/components/partial-forms/service-item-amenities/partial-form.service-item-amenities.html","<div><!--<jhi-alert></jhi-alert>--><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-4\" ng-repeat=\"amenitiesItem in $ctrl.amenities\"><div style=\"border: solid 1px #d2d2d2 ;border-radius: 5px; padding: 10px\"><div class=\"row\"><div class=\"col-sm-2\"><img style=\"width: 100%\" src=\"/content/images/amenities/{{amenitiesItem.amenitiesType}}.png\"></div><div class=\"col-sm-10\"><!--<div class=\"form-group\">--><div><input type=\"checkbox\" name=\"selected\" id=\"field_selected\" ng-model=\"amenitiesItem.selected\"> <span translate=\"{{\'tikonApp.AmenitiesType.\' + amenitiesItem.amenitiesType}}\">></span></div><table><tr><td><div><label class=\"control-label\" translate=\"tikonApp.serviceItem.amenitiesQty\" for=\"field_qty\">Qty</label><input type=\"number\" name=\"qty\" id=\"field_qty\" style=\"width: 70px\" ng-model=\"amenitiesItem.qty\"></div></td><td><div><label class=\"control-label\" translate=\"tikonApp.serviceItem.amenitiesPrice\" for=\"field_price\">Price</label><input type=\"text\" name=\"price\" id=\"field_price\" style=\"width: 70px\" ng-model=\"amenitiesItem.price\"><!--<span class=\"control-label\" translate=\"global.currency\"></span>--></div></td></tr><tr><td colspan=\"2\"><div><label class=\"control-label\" translate=\"tikonApp.serviceItem.amenitiesComment\" for=\"field_comment\">Price</label><input type=\"text\" name=\"price\" id=\"field_comment\" style=\"width: 100%\" ng-model=\"amenitiesItem.comment\"><!--<span class=\"control-label\" translate=\"global.currency\"></span>--></div></td></tr></table></div></div></div></div><!--</div>--></div></div></div>");
$templateCache.put("app/components/partial-forms/service-item-capacity-info/partial-form.service-item-capacity-info.html","<div><!--<jhi-alert></jhi-alert>--><div class=\"container-fluid\"></div><br><div id=\"servicePriceInfo\"><div class=\"form-group\" ng-show=\"$ctrl.serviceCapacityInfo.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"$ctrl.serviceCapacityInfo.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceCapacityInfo.qty\" for=\"field_qty\">Qty</label><input type=\"number\" class=\"form-control\" name=\"qty\" id=\"field_qty\" ng-model=\"$ctrl.serviceCapacityInfo.qty\"></div></div><div class=\"text-center\"><!-- <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>\n         <uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>--></div></div>");
$templateCache.put("app/components/partial-forms/service-item-option-info/partial-form.service-item-option-info-old.html","<!--<div>--><!--&lt;!&ndash;<jhi-alert></jhi-alert>&ndash;&gt;--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-4 no-padding-left\" ng-if=\"$ctrl.formState==\'list\'\">--><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.newItem()\">--><!--<span class=\"glyphicon glyphicon-plus\"></span>--><!--<span class=\"hidden-xs\" translate=\"tikonApp.serviceOptionInfo.home.createLabel\">--><!--Create new Service Option Info--><!--</span>--><!--</button>--><!--</div>--><!--<div class=\"col-xs-4 no-padding-left\" ng-if=\"$ctrl.formState!=\'list\'\">--><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.backToList()\">--><!--<span class=\"glyphicon glyphicon-list\"></span>--><!--<span class=\"hidden-xs\" translate=\"tikonApp.priceInfo.home.backToPriceInfoList\">--><!--Back To Price Info--><!--</span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--<br/>--><!--<div id=\"priceInfoList\" ng-if=\"$ctrl.formState==\'list\'\">--><!--<div class=\"table-responsive\">--><!--<table class=\"jh-table table table-striped\">--><!--<thead>--><!--<tr jh-sort=\"$ctrl.predicate\" ascending=\"$ctrl.reverse\" callback=\"$ctrl.transition()\">--><!--<th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"optionName\"><span--><!--translate=\"tikonApp.serviceOptionItem.optionName\">Option Name</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"description\"><span--><!--translate=\"tikonApp.serviceOptionItem.description\">Description</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"price\"><span translate=\"tikonApp.priceInfoDtail.price\">Price Info</span>--><!--<span translate=\"global.currencyBracket\"></span>--><!--<span class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"serviceOptionItem in $ctrl.serviceOptionItems track by serviceOptionItem.id\">--><!--<td><a ng-click=\"$ctrl.editItem({id:serviceOptionItem.id})\">{{serviceOptionItem.id}}</a></td>--><!--&lt;!&ndash;<td>{{serviceOptionItem.priceInfo.fromValidDate | toPersianDate}}</td>&ndash;&gt;--><!--&lt;!&ndash;<td translate=\"{{\'tikonApp.PriceType.\' + priceInfo.priceType}}\">{{priceInfoDtail.priceInfo.priceType}}</td>&ndash;&gt;--><!--<td>{{serviceOptionItem.optionName}}</td>--><!--<td>{{serviceOptionItem.description}}</td>--><!--<td>{{serviceOptionItem.priceInfoDtail.price | number}}</td>--><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--&lt;!&ndash; <button type=\"submit\"--><!--ui-sref=\"schedule-info-detail({id:scheduleInfo.id})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>&ndash;&gt;--><!--<button type=\"button\"--><!--ng-click=\"$ctrl.editItem({id:serviceOptionItem.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"$ctrl.removeItem(serviceOptionItem.id)\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--<div id=\"optionInfoItemEdit\" ng-if=\"$ctrl.formState!=\'list\'\">--><!--&lt;!&ndash;<div class=\"form-group\" ng-show=\"$ctrl.serviceOptionItem.id\">&ndash;&gt;--><!--&lt;!&ndash;<label for=\"id\" translate=\"global.field.id\">ID</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.serviceOptionItem.id\" readonly />&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceOptionInfo.title\" ng-show=\"false\" for=\"field_title\">title</label>--><!--<input type=\"text\" class=\"form-control\" name=\"optionName\" id=\"field_title\" ng-show=\"false\"--><!--ng-model=\"$ctrl.serviceOptionItem.optionInfo.title\"--><!--ng-init=\"$ctrl.serviceOptionItem.optionInfo.title=\'ServiceOption\'\"--><!--/>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"col-md-4\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required translate=\"tikonApp.serviceOptionItem.optionName\"--><!--for=\"field_optionName\">Option Name</label>--><!--<input type=\"text\" class=\"form-control\" name=\"optionName\" id=\"field_optionName\"--><!--ng-model=\"$ctrl.serviceOptionItem.optionName\"--><!--/>--><!--</div>--><!--</div>--><!--<div class=\"col-md-3\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required translate=\"tikonApp.priceInfoDtail.price\" for=\"field_price\">Price</label>--><!--<span translate=\"global.currencyBracket\"></span>--><!--<input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\"--><!--ng-model=\"$ctrl.serviceOptionItem.priceInfoDtail.price\" min=\"0\"--><!--/>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.serviceOptionItem.description\" for=\"field_description\">Description</label>--><!--<input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\"--><!--ng-model=\"$ctrl.serviceOptionItem.description\"--><!--/>--><!--</div>--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.priceInfo.fromValidDate\" for=\"field_fromValidDate\">From&ndash;&gt;--><!--&lt;!&ndash;Valid Date</label>&ndash;&gt;--><!--&lt;!&ndash;<eo-date-picker id=\"field_fromValidDate\"&ndash;&gt;--><!--&lt;!&ndash;date-value=\"$ctrl.serviceOptionItem.priceInfoDtail.priceInfo.fromValidDate\"></eo-date-picker>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.priceInfo.priceType\" for=\"field_priceType\">Price&ndash;&gt;--><!--&lt;!&ndash;Type</label>&ndash;&gt;--><!--&lt;!&ndash;<select class=\"form-control\" name=\"priceType\" ng-model=\"$ctrl.serviceOptionItem.priceInfoDtail.priceInfo.priceType\" id=\"field_priceType\">&ndash;&gt;--><!--&lt;!&ndash;<option value=\"FIXED\" translate=\"tikonApp.PriceType.FIXED\">FIXED</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"SCHEDULE_BASED\" translate=\"tikonApp.PriceType.SCHEDULE_BASED\">SCHEDULE_BASED</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"ITEM_QUANTITY_BASED\" translate=\"tikonApp.PriceType.ITEM_QUANTITY_BASED\">&ndash;&gt;--><!--&lt;!&ndash;ITEM_QUANTITY_BASED&ndash;&gt;--><!--&lt;!&ndash;</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"CUSTOMER_BASED\" translate=\"tikonApp.PriceType.CUSTOMER_BASED\">CUSTOMER_BASED</option>&ndash;&gt;--><!--&lt;!&ndash;</select>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.title\" for=\"field_priceTitle\">Title</label>&ndash;&gt;--><!--&lt;!&ndash;<input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_priceTitle\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.serviceOptionItem.priceInfoDtail.title\" ng-init=\"Price\"&ndash;&gt;--><!--&lt;!&ndash;/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<div class=\"form-group\">--><!--<eo-image-gallery album-id=\"$ctrl.serviceOptionItem.imagesId\"--><!--album-caption=\"vm.serviceCategory.categoryName\"></eo-image-gallery>--><!--</div>--><!--</div>--><!--<div class=\"text-center\">--><!--&lt;!&ndash; <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>--><!--<uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>&ndash;&gt;--><!--</div>--> <!--</div>-->");
$templateCache.put("app/components/partial-forms/service-item-option-info/partial-form.service-item-option-info.html","<div><!--<jhi-alert></jhi-alert>--><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\" ng-if=\"$ctrl.formState==\'list\'\"><md-button type=\"button\" class=\"md-raised md-primary\" ng-click=\"$ctrl.newItem()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.serviceOptionInfo.home.createLabel\">Create new Service Option Info</span></md-button></div><div class=\"col-xs-4 no-padding-left\" ng-if=\"$ctrl.formState!=\'list\'\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.backToList()\"><span class=\"glyphicon glyphicon-list\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.priceInfo.home.backToPriceInfoList\">Back To Price Info</span></button></div></div></div><br><div id=\"priceInfoList\" ng-if=\"$ctrl.formState==\'list\'\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"$ctrl.predicate\" ascending=\"$ctrl.reverse\" callback=\"$ctrl.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"optionName\"><span translate=\"tikonApp.serviceOptionItem.optionName\">Option Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"tikonApp.serviceOptionItem.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"price\"><span translate=\"tikonApp.priceInfoDtail.price\">Price Info</span> <span translate=\"global.currencyBracket\"></span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceOptionItem in $ctrl.serviceOptionItems track by serviceOptionItem.id\"><td><a ng-click=\"$ctrl.editItem({id:serviceOptionItem.id})\">{{serviceOptionItem.id}}</a></td><!--<td>{{serviceOptionItem.priceInfo.fromValidDate | toPersianDate}}</td>--><!--<td translate=\"{{\'tikonApp.PriceType.\' + priceInfo.priceType}}\">{{priceInfoDtail.priceInfo.priceType}}</td>--><td>{{serviceOptionItem.optionName}}</td><td>{{serviceOptionItem.description}}</td><td>{{serviceOptionItem.priceInfoDtail.price | number}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><!-- <button type=\"submit\"\n                                     ui-sref=\"schedule-info-detail({id:scheduleInfo.id})\"\n                                     class=\"btn btn-info btn-sm\">\n                                 <span class=\"glyphicon glyphicon-eye-open\"></span>\n                                 <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>\n                             </button>--> <button type=\"button\" ng-click=\"$ctrl.editItem({id:serviceOptionItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-click=\"$ctrl.removeItem(serviceOptionItem)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div><div id=\"optionInfoItemEdit\" ng-if=\"$ctrl.formState!=\'list\'\"><!--<div class=\"form-group\" ng-show=\"$ctrl.serviceOptionItem.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"$ctrl.serviceOptionItem.id\" readonly />--><!--</div>--><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionInfo.title\" ng-show=\"false\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"optionName\" id=\"field_title\" ng-show=\"false\" ng-model=\"$ctrl.serviceOptionItem.optionInfo.title\" ng-init=\"$ctrl.serviceOptionItem.optionInfo.title=\'ServiceOption\'\"></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceOptionItem.optionName\" for=\"field_optionName\">Option Name</label><input type=\"text\" class=\"form-control\" name=\"optionName\" id=\"field_optionName\" ng-model=\"$ctrl.serviceOptionItem.optionName\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.priceInfoDtail.price\" for=\"field_price\">Price</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"$ctrl.serviceOptionItem.priceInfoDtail.price\" min=\"0\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceOptionItem.qtyType\" for=\"field_qtyType\">Service Status</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.serviceOptionItem.qtyType\" ng-change=\"$ctrl.onQtyType_Change()\" style=\"margin-top: 6px\" id=\"field_qtyType\"><md-option value=\"NONE\" translate=\"tikonApp.qtyType.NONE\">NONE</md-option><md-option value=\"HAS_QTY\" translate=\"tikonApp.qtyType.HAS_QTY\">HAS_QTY</md-option></md-select></div></div></div><div class=\"row\" ng-if=\"$ctrl.serviceOptionItem.qtyType == \'HAS_QTY\'\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionItem.minQty\" for=\"field_minQty\">MinQty</label><input type=\"number\" class=\"form-control\" name=\"minQty\" id=\"field_minQty\" ng-model=\"$ctrl.serviceOptionItem.minQty\" min=\"0\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionItem.maxQty\" for=\"field_maxQty\">MaxQty</label><input type=\"number\" class=\"form-control\" name=\"maxQty\" id=\"field_maxQty\" ng-model=\"$ctrl.serviceOptionItem.maxQty\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceOptionItem.qtyUnitType\" for=\"field_qtyUnitType\">Service Status</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.serviceOptionItem.qtyUnitType\" style=\"margin-top: 6px\" id=\"field_qtyUnitType\"><md-option value=\"QTY\" translate=\"tikonApp.qtyUnitType.QTY\">QTY</md-option><md-option value=\"PERSON\" translate=\"tikonApp.qtyUnitType.PERSON\">PERSON</md-option></md-select></div></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.serviceOptionItem.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"$ctrl.serviceOptionItem.description\"></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.priceInfo.fromValidDate\" for=\"field_fromValidDate\">From--><!--Valid Date</label>--><!--<eo-date-picker id=\"field_fromValidDate\"--><!--date-value=\"$ctrl.serviceOptionItem.priceInfoDtail.priceInfo.fromValidDate\"></eo-date-picker>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.priceInfo.priceType\" for=\"field_priceType\">Price--><!--Type</label>--><!--<select class=\"form-control\" name=\"priceType\" ng-model=\"$ctrl.serviceOptionItem.priceInfoDtail.priceInfo.priceType\" id=\"field_priceType\">--><!--<option value=\"FIXED\" translate=\"tikonApp.PriceType.FIXED\">FIXED</option>--><!--<option value=\"SCHEDULE_BASED\" translate=\"tikonApp.PriceType.SCHEDULE_BASED\">SCHEDULE_BASED</option>--><!--<option value=\"ITEM_QUANTITY_BASED\" translate=\"tikonApp.PriceType.ITEM_QUANTITY_BASED\">--><!--ITEM_QUANTITY_BASED--><!--</option>--><!--<option value=\"CUSTOMER_BASED\" translate=\"tikonApp.PriceType.CUSTOMER_BASED\">CUSTOMER_BASED</option>--><!--</select>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.title\" for=\"field_priceTitle\">Title</label>--><!--<input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_priceTitle\"--><!--ng-model=\"$ctrl.serviceOptionItem.priceInfoDtail.title\" ng-init=\"Price\"--><!--/>--><!--</div>--><div class=\"form-group\"><eo-image-gallery album-id=\"$ctrl.serviceOptionItem.imagesId\" album-caption=\"vm.serviceCategory.categoryName\"></eo-image-gallery></div></div><div class=\"text-center\"><!-- <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>\n         <uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>--></div></div>");
$templateCache.put("app/components/partial-forms/service-item-picker/partial-form.service-item-picker.html","<style>.ng-map-info-window {\n        background-color: #5baace;\n        color: #fff;\n    }\n\n    .ng-map-info-window div:first-child > div:nth-child(1) {\n        border-top-color: #5baace !important;\n    }\n\n    .ng-map-info-window div:first-child > div:nth-child(3) div {\n        background-color: transparent !important;\n    }\n\n    .ng-map-info-window div:first-child > div:nth-child(4) {\n        background-color: transparent !important;\n    }\n\n    .serviceColorCircle {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        margin-top: 18px;\n        position: absolute;\n    }\n\n    #serviceTitle, #serviceTitle > small {\n        position: absolute;\n        margin-right: 15px;\n    }\n\n    #serviceTitle > small {\n        top: 16px;\n    }\n\n    input[type=search] {\n        border: none;\n        padding-top: 10px;\n    }</style><div><md-autocomplete ng-disabled=\"$ctrl.isDisabled\" md-no-cache=\"true\" md-selected-item=\"$ctrl.selectedService\" md-selected-item-change=\"$ctrl.serviceItem_changed(item)\" md-search-text=\"$ctrl.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=\"item.itemTitle\" md-min-length=\"0\" placeholder=\"{{\'tikonApp.serviceItem.selectService\' | translate}}\" input-aria-labelledby=\"favoriteStateLabel\" input-aria-describedby=\"autocompleteDetailedDescription\"><md-item-template><!--<span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{item.itemTitle}}</span>--><div ng-class=\"item.color\" class=\"serviceColorCircle\"></div><div id=\"serviceTitle\">{{item.itemTitle}}<br><small ng-if=\"item.category && item.category.categoryName!=\'DEFAULT_CATEGORY\'\" style=\"color: #a2a2a2; font-size: 10px\">{{item.category.categoryName}}</small></div><div></div></md-item-template><md-not-found>{{\'tikonApp.serviceItem.noTitleFor\' | translate}} \"{{$ctrl.searchText}}\" {{\'tikonApp.serviceItem.notFound\' | translate}}.<!--<a ng-click=\"$ctrl.newState($ctrl.searchText)\">Create a new one!</a>--></md-not-found></md-autocomplete></div>");
$templateCache.put("app/components/partial-forms/service-item-price-info/partial-form.service-item-price-info.html","<div><div ng-if=\"$ctrl.priceInfoType !=\'fixed\'\"><!--<jhi-alert></jhi-alert>--><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\" ng-if=\"$ctrl.formState==\'list\'\"><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.newItem()\">--><!--<span class=\"glyphicon glyphicon-plus\"></span>--><!--<span class=\"hidden-xs\" translate=\"tikonApp.priceInfo.home.createLabel\">--><!--Create new Price Info--><!--</span>--><!--</button>--></div><div class=\"col-xs-4 no-padding-left\" ng-if=\"$ctrl.formState!=\'list\'\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.backToList()\"><span class=\"glyphicon glyphicon-list\"></span> <span class=\"hidden-xs\" translate=\"tikonApp.priceInfo.home.backToPriceInfoList\">Back To Price Info</span></button></div></div></div><br></div><div id=\"priceInfoList\" ng-if=\"$ctrl.formState==\'list\' && $ctrl.priceInfoType !=\'fixed\' \"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"$ctrl.predicate\" ascending=\"$ctrl.reverse\" callback=\"$ctrl.transition()\"><!--<th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--<th jh-sort-by=\"priceType\"><span translate=\"tikonApp.priceInfo.priceType\">Price Type</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"title\"><span translate=\"tikonApp.priceInfoDtail.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromValidDate\"><span translate=\"tikonApp.priceInfo.fromValidDate\">From Valid Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"priceInfo in $ctrl.priceInfos track by priceInfo.id\"><!--<td><a ng-click=\"$ctrl.editItem({id:priceInfoDtail.id})\">{{priceInfoDtail.id}}</a></td>--><!--<td translate=\"{{\'tikonApp.PriceType.\' + priceInfo.priceType}}\">{{priceInfoDtail.priceInfo.priceType}}</td>--><td><div ng-repeat=\"priceInfoDtail in priceInfo.priceInfoDtails track by priceInfoDtail.id\"><span>{{priceInfoDtail.title}} : </span><span>{{priceInfoDtail.price | number}} </span><span translate=\"global.currency\"></span></div></td><td>{{priceInfo.fromValidDate | toPersianDate}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\" ng-if=\"$ctrl.hasAdvancedPricingFeatureAccess\"><!-- <button type=\"submit\"\n                                     ui-sref=\"schedule-info-detail({id:scheduleInfo.id})\"\n                                     class=\"btn btn-info btn-sm\">\n                                 <span class=\"glyphicon glyphicon-eye-open\"></span>\n                                 <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>\n                             </button>--><!--ng-if=\"$ctrl.hasAdvancedPricingFeatureAccess\"--> <button type=\"button\" ng-click=\"$ctrl.editItem(priceInfo.id)\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"button\" ng-click=\"$ctrl.confirmDelete(priceInfo.id)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div><div ng-if=\"!$ctrl.hasAdvancedPricingFeatureAccess\"><button type=\"button\" ng-disabled=\"true\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-lock\"></span> <span class=\"hidden-xs hidden-sm\">امکان ویژه</span></button></div></td></tr></tbody></table></div></div><div id=\"priceInfoEdit\" ng-if=\"$ctrl.formState!=\'list\' && $ctrl.priceInfoType !=\'fixed\' \"><!--<div class=\"form-group\" ng-show=\"$ctrl.priceInfoDtail.priceInfo.id\">--><!--<label for=\"id\" translate=\"global.field.id\">ID</label>--><!--<input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"--><!--ng-model=\"$ctrl.priceInfoDtail.priceInfo.id\" readonly/>--><!--</div>--><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.priceInfo.fromValidDate\" for=\"field_fromValidDate\">From Valid Date</label><eo-date-picker id=\"field_fromValidDate\" date-value=\"$ctrl.newPriceInfo.fromValidDate\"></eo-date-picker><!--<div class=\"input-group\">--><!--<input id=\"field_fromValidDate\" type=\"text\" class=\"form-control\" name=\"fromValidDate\"--><!--datetime-picker=\"{{dateformat}}\" ng-model=\"$ctrl.priceInfoDtail.priceInfo.fromValidDate\"--><!--is-open=\"$ctrl.datePickerOpenStatus.fromValidDate\"--><!--/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openCalendar(\'fromValidDate\')\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</div>--></div></div></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.priceInfo.priceType\" for=\"field_priceType\">Price--><!--Type</label>--><!--<select class=\"form-control\" name=\"priceType\" ng-model=\"$ctrl.priceInfoDtail.priceInfo.priceType\" id=\"field_priceType\">--><!--<option value=\"FIXED\" translate=\"tikonApp.PriceType.FIXED\">FIXED</option>--><!--<option value=\"SCHEDULE_BASED\" translate=\"tikonApp.PriceType.SCHEDULE_BASED\">SCHEDULE_BASED</option>--><!--<option value=\"ITEM_QUANTITY_BASED\" translate=\"tikonApp.PriceType.ITEM_QUANTITY_BASED\">--><!--ITEM_QUANTITY_BASED--><!--</option>--><!--<option value=\"CUSTOMER_BASED\" translate=\"tikonApp.PriceType.CUSTOMER_BASED\">CUSTOMER_BASED</option>--><!--</select>--><!--</div>--><div class=\"form-group\" ng-repeat=\"priceInfoDtail in $ctrl.newPriceInfo.priceInfoDtails\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.priceInfoDtail.title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" placeholder=\"{{ \'tikonApp.priceInfoDtail.placeHolder.title\' | translate }}\" ng-model=\"priceInfoDtail.title\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.priceInfoDtail.price\" for=\"field_price\">Price</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_price\" ng-model=\"priceInfoDtail.price\" min=\"0\"></div></div><div class=\"col-md-4\" style=\"padding-top: 30px\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"$ctrl.addNewPriceInfoDtail()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\"></span></button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.removePriceInfoDtail(priceInfoDtail.title)\"><span class=\"glyphicon glyphicon-minus\"></span> <span class=\"hidden-xs\"></span></button></div></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.capacityRatio\" for=\"field_capacityRatio\">Capacity Ratio</label>--><!--<input type=\"number\" class=\"form-control\" name=\"capacityRatio\" id=\"field_capacityRatio\"--><!--ng-model=\"$ctrl.priceInfoDtail.capacityRatio\"--><!--/>--><!--</div>--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.coworkerPrice\" for=\"field_coworkerPrice\">Coworker Price</label>--><!--<input type=\"number\" class=\"form-control\" name=\"coworkerPrice\" id=\"field_coworkerPrice\"--><!--ng-model=\"$ctrl.priceInfoDtail.coworkerPrice\"--><!--/>--><!--</div>--></div><div class=\"text-center\"><!-- <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>\n             <uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>--></div></div><div id=\"fixedPriceInfo\" ng-if=\"$ctrl.priceInfoType ==\'fixed\'\"><div class=\"form-group\" ng-repeat=\"priceInfoDtail in $ctrl.fixedPriceInfoDetails\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><span translate=\"{{\'tikonApp.priceInfoDtail.fixedEnum.\' + priceInfoDtail.title}}\">{{priceInfoDtail.title}}</span><label class=\"control-label\" translate=\"tikonApp.priceInfoDtail.price\" for=\"field_fixedPrice\">Price</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" class=\"form-control\" name=\"price\" id=\"field_fixedPrice\" ng-model=\"priceInfoDtail.price\" min=\"0\"></div></div></div></div></div></div>");
$templateCache.put("app/components/partial-forms/service-item-schedules/partial-form.service-item-schedules-v2.html","<style>/*md-content {*/\n    /*overflow: unset !important;*/\n    /*}*/</style><div><div class=\"row\"><jhi-alert-error></jhi-alert-error><div class=\"pull-right\"><md-button ng-click=\"$ctrl.saveSchedule()\" class=\"md-raised md-primary\">ثبت</md-button></div><!--<div class=\"pull-right\">--><!--<md-button class=\"md-raised\" ui-sref=\"supplierPanel.setting\">--><!--<span>--><!--<md-icon>settings</md-icon>--><!--</span>--><!--<span translate=\"entity.action.backToSetting\">--><!--entity.action.backToSetting--><!--</span>--><!--</md-button>--><!--</div>--></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>مبنای زمانبندی</legend><md-radio-group ng-model=\"$ctrl.selectedScheduleInfo.baseScheduleMode\"><md-radio-button class=\"md-primary\" value=\"BASED_ON_COMPANY\">بر اساس زمانبندی کسب و کار است</md-radio-button><md-radio-button value=\"BASED_ON_RESOURCE\">بر اساس زمانبندی پرسنل ارائه دهنده سرویس است.</md-radio-button><md-radio-button value=\"BASED_ON_SERVICE\">زمانبندی مخصوص به خود را دارد</md-radio-button><!--<md-radio-button class=\"md-accent\"  value=\"FIXED_DURATIONS\" >--><!--زمانبندی منظمی ندارد--><!--</md-radio-button>--></md-radio-group></fieldset></div><div class=\"row\" ng-show=\"$ctrl.selectedScheduleInfo && $ctrl.selectedScheduleInfo.baseScheduleMode==\'BASED_ON_SERVICE\'\"><md-content class=\"rwMdContent\"><md-tabs md-border-bottom md-dynamic-height=\"true\" md-swipe-content=\"false\" md-stretch-tabs=\"auto\" md-selected=\"1\"><md-tab ng-if=\"$ctrl.showExceptionDurationTab\"><md-tab-label><md-icon>event</md-icon><span>ساعت کاری <b>نامنظم</b></span></md-tab-label><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><!--<div class=\"hint-point\">--><!--بازه های زمانی استثناُ زمان هایی هستند که بدون در نظر گرفتن دیگر تنظیمات زمانی در نظر گرفته می شوند.--><!--</div>--><pf-exception-duration exdurations=\"$ctrl.selectedScheduleInfo.scheduleExceptionDurations\"></pf-exception-duration></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><md-icon>history</md-icon><span>ساعت کاری <b>منظم</b></span></md-tab-label><md-tab-body><md-content class=\"rwMdContent\"><div class=\"container-fluid\"><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><eo-time-range start-time=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range></fieldset></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری هفتگی</legend><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></fieldset></div><div class=\"row\"><fieldset class=\"standard-fieldset\" style=\"padding-bottom: 20px\"><legend>روزهای تعطیل</legend><pf-date-period-off-days selected-date-period=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod\"></pf-date-period-off-days></fieldset></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend>ساعت های تعطیل</legend><pf-time-period-off-times selected-time-period=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod\"></pf-time-period-off-times></fieldset></div></div></md-content></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/components/partial-forms/service-item-schedules/partial-form.service-item-schedules.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"$ctrl.saveSchedule()\"><button type=\"submit\" ng-disabled=\"editForm.$invalid\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button><ul id=\"schedtabs\" class=\"nav nav-tabs lightnav\"><!--<li class=\"active\"><a data-target=\"#home\" data-toggle=\"pill\" href>{{\'tikonApp.serviceItem.scheduleList\' |--><!--translate}}</a></li>--><li><a data-target=\"#menu1\" data-toggle=\"pill\" href>{{\'tikonApp.serviceItem.basicScheduleInfo\' | translate}}</a></li><!--<li ng-show=\"$ctrl.schSelected==true && $ctrl.schSaved==true\"><a data-target=\"#menu2\" data-toggle=\"pill\" href>{{\'tikonApp.serviceItem.showOnScheduler\'--><!--| translate}}</a></li>--></ul><jhi-alert-error></jhi-alert-error><div class=\"tab-content\"><!--<div id=\"home\" class=\"tab-pane fade in active\">--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-4 no-padding-left\">--><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.newItem()\">--><!--<span class=\"glyphicon glyphicon-plus\"></span>--><!--<span class=\"hidden-xs\" translate=\"tikonApp.scheduleInfo.home.createLabel\">--><!--Create new Schedule Info--><!--</span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--<br/>--><!--<div class=\"table-responsive\">--><!--<table class=\"jh-table table table-striped\">--><!--<thead>--><!--<tr callback=\"$ctrl.transition()\">--><!--<th><span translate=\"global.field.id\">ID</span> <span--><!--class=\"glyphicon glyphicon-sort\"></span></th>--><!--&lt;!&ndash;<th ><span translate=\"tikonApp.scheduleInfo.weeklyScheduleInfo.DatePeriodDTO\">Schedule Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;<th ><span translate=\"tikonApp.scheduleInfo.scheduleType\">Schedule Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;<th ><span translate=\"tikonApp.scheduleInfo.weeklyScheduleInfo\">Weekly Schedule Info</span> <span class=\"glyphicon glyphicon-sort\"></span></th>&ndash;&gt;--><!--&lt;!&ndash;&ndash;&gt;--><!--<th><span translate=\"tikonApp.scheduleInfo.fromDate\">from Date</span></th>--><!--&lt;!&ndash;<th><span translate=\"tikonApp.scheduleInfo.toDate\">from Date</span></th>&ndash;&gt;--><!--<th><span translate=\"tikonApp.scheduleInfo.scheduleType\">from Date</span></th>--><!--<th><span translate=\"tikonApp.scheduleInfo.startTime\">from Date</span></th>--><!--<th><span translate=\"tikonApp.scheduleInfo.endTime\">from Date</span></th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"scheduleInfo in $ctrl.scheduleInfos track by scheduleInfo.id\">--><!--<td><a ng-click=\"$ctrl.editItem({id:scheduleInfo.id})\">{{scheduleInfo.id}}</a></td>--><!--<td>{{scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate | toPersianDate}}</td>--><!--&lt;!&ndash;<td>{{scheduleInfo.weeklyScheduleInfo.datePeriod.toDate | toPersianDate}}</td>&ndash;&gt;--><!--<td><span translate=\"tikonApp.ScheduleType.{{scheduleInfo.scheduleType}}\"></span></td>--><!--<td><span ng-if=\"scheduleInfo.scheduleType==\'PRIMARY\'\">{{scheduleInfo.weeklyScheduleInfo.timePeriod.startTime | toPersianTime}}</span>--><!--</td>--><!--<td><span ng-if=\"scheduleInfo.scheduleType==\'PRIMARY\'\">{{scheduleInfo.weeklyScheduleInfo.timePeriod.endTime | toPersianTime}}</span>--><!--</td>--><!--&lt;!&ndash;<td colspan=\"2\" ng-if=\"scheduleInfo.scheduleType==\'BASED_ON_COMPANY_SCHEDULE\'\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.ScheduleType.BASED_ON_COMPANY_SCHEDULE\" ></span>&ndash;&gt;--><!--&lt;!&ndash;</td> <td colspan=\"2\" ng-if=\"scheduleInfo.scheduleType==\'FIXED_TIME_SESSIONS\'\">&ndash;&gt;--><!--&lt;!&ndash;<span translate=\"tikonApp.ScheduleType.FIXED_TIME_SESSIONS\" ></span>&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--&lt;!&ndash;<td>&ndash;&gt;--><!--&lt;!&ndash;<a ui-sref=\"weekly-schedule-info-detail({id:scheduleInfo.weeklyScheduleInfoId})\">{{scheduleInfo.weeklyScheduleInfoId}}</a>&ndash;&gt;--><!--&lt;!&ndash;</td>&ndash;&gt;--><!--<td class=\"text-right\">--><!--<div class=\"btn-group flex-btn-group-container\">--><!--&lt;!&ndash; <button type=\"submit\"--><!--ui-sref=\"schedule-info-detail({id:scheduleInfo.id})\"--><!--class=\"btn btn-info btn-sm\">--><!--<span class=\"glyphicon glyphicon-eye-open\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>--><!--</button>&ndash;&gt;--><!--<button type=\"button\"--><!--ng-click=\"$ctrl.editItem({id:scheduleInfo.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"button\"--><!--ng-click=\"$ctrl.delete(scheduleInfo.id)\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><div id=\"menu1\" class=\"tab-pane fade\"><!--<div class=\"row\">--><!--<div class=\"col-sm-8\">--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"tikonApp.scheduleInfo.scheduleType\"--><!--for=\"field_scheduleType\"></label>--><!--<select class=\"form-control\" name=\"scheduleType\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.scheduleType\"--><!--id=\"field_scheduleType\"--><!--ng-change=\"$ctrl.scheduleType_changed()\"--><!--&gt;--><!--<option value=\"BASED_ON_COMPANY_SCHEDULE\">--><!--{{\'tikonApp.ScheduleType.BASED_ON_COMPANY_SCHEDULE\' | translate}}--><!--</option>--><!--<option value=\"PRIMARY\">--><!--{{\'tikonApp.ScheduleType.PRIMARY\' | translate}}--><!--</option>--><!--<option value=\"FIXED_TIME_SESSIONS\">--><!--{{\'tikonApp.ScheduleType.FIXED_TIME_SESSIONS\' | translate}}--><!--</option>--><!--<option value=\"FLOAT_TIME_SESSIONS\">--><!--{{\'tikonApp.ScheduleType.FLOAT_TIME_SESSIONS\' | translate}}--><!--</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--&lt;!&ndash;<eo-schedule-start-end-date-validator&ndash;&gt;--><!--&lt;!&ndash;start-date=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"&ndash;&gt;--><!--&lt;!&ndash;end-date=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"&ndash;&gt;--><!--&lt;!&ndash;service-item-id=\"$ctrl.selectedScheduleInfo.serviceItemId\"&ndash;&gt;--><!--&lt;!&ndash;schedule-info-id=\"$ctrl.selectedScheduleInfo.id\"&ndash;&gt;--><!--&lt;!&ndash;target-element-id=\"tikonApp-serviceItem-datePeriod\"&ndash;&gt;--><!--&lt;!&ndash;&gt;&ndash;&gt;--><!--</eo-schedule-start-end-date-validator>--><!--<label eo-help-tooltip=\"tips.schedule_start_date\" translate=\"tikonApp.serviceItem.startDate\"--><!--for=\"field_startDate\">Start--><!--Date</label>--><!--<eo-date-picker id=\"field_startDate\" is-required=\"true\"--><!--date-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker>--><!--</div>--><!--</div>--><!--</div>--><!--<md-radio-group ng-model=\"$ctrl.selectedScheduleInfo.scheduleType\" layout=\"row\">--><!--<md-radio-button eo-help-tooltip=\"tips.schedule_type_based_on_company_schedule\"--><!--value=\"BASED_ON_COMPANY_SCHEDULE\" class=\"md-primary\"><span--><!--translate=\"tikonApp.ScheduleType.BASED_ON_COMPANY_SCHEDULE\"></span></md-radio-button>--><!--<md-radio-button eo-help-tooltip=\"tips.schedule_type_primary\" value=\"PRIMARY\"><span--><!--translate=\"tikonApp.ScheduleType.PRIMARY\"></span></md-radio-button>--><!--<md-radio-button eo-help-tooltip=\"tips.schedule_type_fixed\" value=\"FIXED_TIME_SESSIONS\"><span--><!--translate=\"tikonApp.ScheduleType.FIXED_TIME_SESSIONS\"></span></md-radio-button>--><!--<md-radio-button eo-help-tooltip=\"tips.schedule_type_float\" value=\"FLOAT_TIME_SESSIONS\"><span--><!--translate=\"tikonApp.ScheduleType.FLOAT_TIME_SESSIONS\"></span></md-radio-button>--><!--</md-radio-group>--><!--<hr/>--><!--<div class=\"row\" id=\"scheduleStartDate\">--><!--&lt;!&ndash;<div class=\"col-sm-2\">&ndash;&gt;--><!--&lt;!&ndash;<label id=\"tikonApp-serviceItem-datePeriod\" class=\"group-label\"&ndash;&gt;--><!--&lt;!&ndash;translate=\"tikonApp.serviceItem.datePeriod\">datePeriod</label>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<div class=\"col-sm-3\">--><!--</div>--><!--<div class=\"col-sm-5\">--><!--&lt;!&ndash;<eo-help-tip text=\'{{\"tips.schedule_start_date\" | translate}}\' ></eo-help-tip>&ndash;&gt;--><!--</div>--><!--&lt;!&ndash;<div class=\"col-sm-4\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-group\" style=\"float: right ; width: 100%\">&ndash;&gt;--><!--&lt;!&ndash;<label translate=\"tikonApp.serviceItem.endDate\" for=\"field_endDate\">End Date</label>&ndash;&gt;--><!--&lt;!&ndash;<eo-date-picker id=\"field_endDate\" is-required=\"true\" eo-schedule-start-end-date-validator&ndash;&gt;--><!--&lt;!&ndash;date-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--selecting types--><div ng-if=\"$ctrl.selectedScheduleInfo.scheduleType!=\'FIXED_TIME_SESSIONS\'\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><input type=\"checkbox\" ng-change=\"$ctrl.scheduleType_changed()\" ng-model=\"$ctrl.hasDedicateSchedule\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.hasDedicateSchedule\" eo-help-tooltip=\"tips.hasDedicateSchedule\">hasDedicateSchedule</label></div></div><div data-ng-if=\"$ctrl.hasDedicateSchedule\"><div class=\"col-sm-2\"><label eo-help-tooltip=\"tips.schedule_start_date\" translate=\"tikonApp.serviceItem.startDate\">Start Date</label></div><div class=\"col-sm-2\"><eo-date-picker id=\"field_startDate\" is-required=\"true\" date-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div></div><div class=\"row\"><div class=\"col-sm-7\"><div class=\"form-group\" data-ng-if=\"$ctrl.hasDedicateSchedule\"><input type=\"checkbox\" ng-change=\"$ctrl.scheduleType_changed()\" ng-model=\"$ctrl.canSelectMultipleTimes\"><label class=\"control-label\" translate=\"tikonApp.serviceItem.canSelectMultipleTimes\" eo-help-tooltip=\"tips.canSelectMultipleTimes\">canSelectMultipleTimes</label></div></div></div></div><div ng-if=\"$ctrl.selectedScheduleInfo.scheduleType==\'BASED_ON_COMPANY_SCHEDULE\'\"><div class=\"row\"><!--<div class=\"col-sm-2\">--><!--<label class=\"group-label\" translate=\"tikonApp.serviceItem.durationInfo\">duration</label>--><!--</div>--><div class=\"col-sm-4\"><div class=\"form-group\" style=\"float: right ; width: 100%\"><label translate=\"tikonApp.serviceItem.duration\" for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.duration\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\" style=\"float: right ; width: 100%\"><label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label><input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\" ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"></div></div><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.discountAmount\"--><!--for=\"field_discount\">discountAmount</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.discountAmount\"/>--><!--</div>--><!--</div>--></div><!--<div class=\"row\">--><!--<div class=\"col-sm-2\">--><!--<label class=\"group-label\" translate=\"tikonApp.serviceItem.discountInfo\">discountInfo</label>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.discountAmount\"--><!--for=\"field_discount\">discountAmount</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.discountAmount\"/>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--&lt;!&ndash;<div class=\"form-group\" style=\"float: right ; width: 100%\">&ndash;&gt;--><!--&lt;!&ndash;<label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label>&ndash;&gt;--><!--&lt;!&ndash;<input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--></div><div ng-if=\"$ctrl.selectedScheduleInfo.scheduleType==\'PRIMARY\' || $ctrl.selectedScheduleInfo.scheduleType==\'FLOAT_TIME_SESSIONS\' \" id=\"primarySchedule\"><!--<div class=\"row\" ng-if=\"$ctrl.selectedScheduleInfo.scheduleType==\'FLOAT_TIME_SESSIONS\'\">--><!--<div class=\"col-md-12\">--><!--<eo-help-tip text=\'{{\"tips.select_floating_type\" | translate}}\'></eo-help-tip>--><!--<md-radio-group ng-model=\"$ctrl.selectedScheduleInfo.floatingTimeType\" layout=\"row\">--><!--<md-radio-button value=\"HOURLY\" class=\"md-primary\"><span--><!--translate=\"tikonApp.FloatingTimeType.HOURLY\"></span></md-radio-button>--><!--<md-radio-button value=\"DAILY\"><span translate=\"tikonApp.FloatingTimeType.DAILY\"></span>--><!--</md-radio-button>--><!--<md-radio-button value=\"MONTHLY\"><span--><!--translate=\"tikonApp.FloatingTimeType.MONTHLY\"></span></md-radio-button>--><!--</md-radio-group>--><!--</div>--><!--</div>--><!--<div ng-if=\"$ctrl.selectedScheduleInfo.scheduleType==\'PRIMARY\'\" class=\"row\">--><!--&lt;!&ndash;<div class=\"col-sm-2\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"group-label\" translate=\"tikonApp.serviceItem.durationInfo\">duration</label>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.duration\" for=\"field_duration\">Duration</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\"--><!--eo-duration-validator eo-required=\"\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.duration\">--><!--</input>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label>--><!--<input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"/>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.discountAmount\"--><!--for=\"field_discount\">discountAmount</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.discountAmount\"/>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row\"><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.timePeriod\">time period</label></div><div class=\"col-sm-6\"><eo-time-range start-time=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.startTime\" for=\"field_startTime\">Start--><!--Time</label>--><!--<eo-time-picker id=\"field_startTime\" time-value-in=\"field_startTime\"--><!--time-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.startTime\"></eo-time-picker>--><!--</div>--></div><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.endTime\" for=\"field_endTime\">End Time</label>--><!--<eo-time-picker id=\"field_endTime\" time-value-in=\"field_endTime\"--><!--time-value=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-picker>--><!--</div>--><!--</div>--></div><div class=\"row\"><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.workDays\">work days</label></div><div class=\"col-sm-10\"><pf-weekly-work-days selected-weekly-schedule-info=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days></div></div><div class=\"row\"><hr></div><div class=\"row\"><!--<div ng-switch=\"$ctrl.selectedScheduleInfo.floatingTimeType\">--><div><div><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.durationInfo\">duration</label></div><div class=\"col-sm-4\"><div class=\"form-group\" style=\"float: right ; width: 100%\"><label translate=\"tikonApp.serviceItem.duration\" for=\"field_duration\">Duration</label><input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" eo-duration-validator eo-required=\"\" ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.duration\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\" style=\"float: right ; width: 100%\"><label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label><input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\" ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"></div></div></div><!--<div ng-switch-when=\"DAILY\">--><!--</div>--><!--<div ng-switch-when=\"MONTHLY\">--><!--</div>--></div></div><!--<div class=\"row\">--><!--<div class=\"col-sm-2\">--><!--<label class=\"group-label\" translate=\"tikonApp.serviceItem.discountInfo\">discountInfo</label>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.discountAmount\"--><!--for=\"field_discount\">discountAmount</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.selectedScheduleInfo.discountAmount\"/>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--&lt;!&ndash;<div class=\"form-group\" style=\"float: right ; width: 100%\">&ndash;&gt;--><!--&lt;!&ndash;<label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label>&ndash;&gt;--><!--&lt;!&ndash;<input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.gaptime\"/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><div class=\"row\"><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.offDates\">Off days</label></div><div class=\"col-sm-10\"><pf-date-period-off-days selected-date-period=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod\"></pf-date-period-off-days></div></div><div class=\"row\"><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.offTimes\">Off times</label></div><div class=\"col-sm-10\"><pf-time-period-off-times selected-time-period=\"$ctrl.selectedScheduleInfo.weeklyScheduleInfo.timePeriod\"></pf-time-period-off-times></div></div></div><div ng-if=\"$ctrl.selectedScheduleInfo.scheduleType==\'FIXED_TIME_SESSIONS\'\"><!--<eo-help-tip text=\'{{\"tips.add_your_time_sessions\" | translate}}\'></eo-help-tip>--> <button type=\"button\" class=\"btn btn-info btn-lg\" data-toggle=\"modal\" data-target=\"#myModal\"><i class=\"fa fa-plus\"></i> اضافه کردن زمان رزرو جدید</button><div id=\"myModal\" class=\"modal fade\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><!-- Modal content--><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button><h4 class=\"modal-title\">تاریخ و ساعت را مشخص کنید</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-6\"><label eo-help-tooltip=\"tips.schedule_fixed_session_date\" translate=\"tikonApp.serviceItem.session_date\" for=\"session_date\">Start Date</label><eo-date-picker id=\"session_date\" date-value=\"$ctrl.session_date\"></eo-date-picker></div><div class=\"col-sm-3\"><label translate=\"tikonApp.serviceItem.startTime\" for=\"session_time\">Start Date</label><eo-time-picker time-value=\"$ctrl.from_session_time\"></eo-time-picker></div><div class=\"col-sm-3\"><label translate=\"tikonApp.serviceItem.endTime\" for=\"session_time\">Start Date</label><eo-time-picker time-value=\"$ctrl.to_session_time\"></eo-time-picker></div></div><div class=\"row\"><div class=\"col-sm-6\"></div><div class=\"col-sm-3\"><label eo-help-tooltip=\"tips.schedule_fixed_session_capacity\" translate=\"tikonApp.serviceItem.session_capacity\" for=\"session_capacity\">Start Date</label><input id=\"session_capacity\" max=\"999\" maxlength=\"3\" type=\"number\" class=\"form-control shortInput\" ng-model=\"$ctrl.session_capacity\"></div><div class=\"col-sm-3\"><label eo-help-tooltip=\"tips.schedule_fixed_session_discount\" translate=\"tikonApp.serviceItem.session_discount\" for=\"session_discount\">Start Date</label><input max=\"99\" maxlength=\"2\" id=\"session_discount\" type=\"number\" class=\"form-control shortInput\" ng-model=\"$ctrl.session_discount\"></div><a ng-click=\"$ctrl.showAdvanced()\" style=\"padding-right: 16px\" translate=\"tikonApp.serviceItem.divideToMultiEvent\"></a></div><div class=\"row\" ng-if=\"$ctrl.showAdvancedSetting\"><div class=\"col-sm-6\"></div><div class=\"col-sm-3\"><label eo-help-tooltip=\"tips.schedule_duration\" translate=\"tikonApp.serviceItem.duration\" for=\"session_duration\">Start Date</label><input id=\"session_duration\" max=\"999\" maxlength=\"3\" type=\"number\" class=\"form-control shortInput\" ng-model=\"$ctrl.duration\"></div><div class=\"col-sm-3\"><div class=\"form-group\" style=\"float: right ; width: 100%\"><label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime_1\">Gap Time</label><input id=\"field_gapTime_1\" type=\"number\" class=\"form-control shortInput\" ng-model=\"$ctrl.gapTime\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.add_session()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\">اضافه شود</span></button> <button id=\"closeDialog\" type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">بستن</button></div></div></div></div><div class=\"row\" style=\"min-height: 150px\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr callback=\"$ctrl.transition()\"><th></th><th><span translate=\"tikonApp.serviceItem.session_date\">from Date</span></th><!--<th><span translate=\"tikonApp.scheduleInfo.toDate\">from Date</span></th>--><th><span translate=\"tikonApp.serviceItem.startTime\">from Date</span></th><th><span translate=\"tikonApp.serviceItem.endTime\">from Date</span></th><th><span translate=\"tikonApp.serviceItem.session_capacity\">from Date</span></th><th><span translate=\"tikonApp.serviceItem.session_discount\">from Date</span></th><th><span translate=\"tikonApp.serviceItem.remove_session\">from Date</span></th></tr></thead><tbody><tr ng-repeat=\"timeSession in $ctrl.selectedScheduleInfo.timingInfo.fixedAvailableTimes \"><td><span data-ng-if=\"!timeSession.id\"><i class=\"fa fa-star\" style=\"color: yellow\"></i> </span><span data-ng-if=\"timeSession.id\"><i class=\"fa fa-check\" style=\"color: green\"></i></span></td><td>{{timeSession.spanDate | toPersianDate}}</td><td>{{timeSession.startTime | toPersianTime}}</td><td>{{timeSession.endTime | toPersianTime}}</td><td>{{timeSession.capacity }}</td><td>{{timeSession.discount}}</td><td><span style=\"color: #a0a0a0\" ng-if=\"timeSession.edited\" translate=\"tikonApp.serviceItem.session_edited\"></span> <a ng-if=\"!timeSession.edited\" ng-click=\"$ctrl.remove_session(timeSession)\"><i style=\"color: red\" class=\"fa fa-times\" aria-hidden=\"true\"></i></a></td></tr></tbody></table></div></div></div></div><!--<div id=\"menu2\" class=\"tab-pane fade\">--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-xs-4 no-padding-left\">--><!--&lt;!&ndash;<button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.generateTimesUntil()\">&ndash;&gt;--><!--&lt;!&ndash;<span class=\"glyphicon glyphicon-refresh\"></span>&ndash;&gt;--><!--&lt;!&ndash;<span class=\"hidden-xs\" translate=\"tikonApp.serviceItem.refreshScheduler\">&ndash;&gt;--><!--&lt;!&ndash;Create new Schedule Info&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div eo-scheduler scheduler-api=\"$ctrl.schedulerApi\"--><!--timing-info=\"$ctrl.selectedScheduleInfo.timingInfo\" style=\"width: 100%;height: 600px;\"></div>--><!--</div>--><!--</div>--><!--</div>--></div></form>");
$templateCache.put("app/components/partial-forms/service-item-servants/partial-form.service-item-servants.html","<style>.servant-items {\n        flex-wrap: wrap;\n        gap: 20px;\n        /*justify-content: space-around;*/\n        padding-bottom: 15px;\n    }\n\n    .servant-radio-button {\n        /*margin-left: auto !important;*/\n        margin-right: 18px !important;\n        min-width: 230px;\n    }</style><div><div class=\"row\" ng-if=\"!$ctrl.disableAddNew\"><div class=\"col-md-3\" style=\"padding-bottom: 15px\"><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.newServant()\"><md-icon class=\"material-icons\">add</md-icon><span class=\"hidden-xs\" translate=\"tikonApp.servant.newServant\"></span></md-button></div></div><div ng-if=\"$ctrl.searchAble\" class=\"row\" style=\"padding-bottom: 30px\"><eo-pl-search-box search-query=\"$ctrl.searchQuery\" search-place-holder=\"\'tikonApp.serviceItem.detail.servantsPlaceHoder\'\" on-search=\"$ctrl.searchServantItem()\" on-clear-search=\"$ctrl.clearSearch()\"></eo-pl-search-box></div><div class=\"row\" ng-if=\"!$ctrl.singleSelection\"><div class=\"col-md-3\" ng-repeat=\"servant in $ctrl.servantItems\"><md-checkbox ng-model=\"servant.selected\" aria-label=\"Checkbox 1\" ng-change=\"$ctrl.checkChange(servant)\">{{servant.personInfo.fisrtName}} {{servant.personInfo.lastName}}</md-checkbox></div></div><div class=\"\" ng-if=\"$ctrl.singleSelection\"><md-input-container><md-radio-group class=\"servant-items\" ng-model=\"$ctrl.rbSelectedServantId\" ng-change=\"$ctrl.radioButtonChange()\" layout=\"row\"><md-radio-button ng-repeat=\"servant in $ctrl.servantsByCompany track by servant.id\" ng-value=\"servant.id\" aria-label=\"\" class=\"servant-radio-button\">{{servant.personInfo.fisrtName}} {{servant.personInfo.lastName}}</md-radio-button></md-radio-group></md-input-container></div><div class=\"text-center\"><!-- <jhi-item-count page=\"$ctrl.page\" total=\"$ctrl.queryCount\"></jhi-item-count>\n         <uib-pagination class=\"pagination-sm\" total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.transition()\"></uib-pagination>--></div></div>");
$templateCache.put("app/components/partial-forms/setting-info/partial-form.setting-info.html","<style xmlns=\"http://www.w3.org/1999/html\">.rw-radioBtn {\n        position: relative;\n        bottom: 10px;\n    }\n\n    .color-title {\n        padding-right: 10px;\n    }\n\n    .color-set {\n        padding: 10px 10px;\n    }\n\n    .color-RED {\n        background-color: #e1655d;\n    }\n\n    .color-BLUE {\n        background-color: #00A4CC;\n    }\n\n    .color-GREEN {\n        background-color: #2BAE66FF;\n    }\n\n    .color-PINK {\n        background-color: #DF6589FF;\n    }\n\n    .color-PURPLE {\n        background-color: #5D4494;\n    }\n\n    .color-DARKBLUE {\n        background-color: #1A2238;\n    }\n\n    .color-ORANGE {\n        background-color: #F2AA4C;\n    }</style><!-- The Modal --><div class=\"modal fade\" id=\"sampleMSG\"><div class=\"modal-dialog modal-dialog-centered modal-sm\"><div class=\"modal-content\"><!-- Modal Header --><div class=\"modal-header\"><!--<h4 class=\"modal-title\">Modal Heading</h4>--> <button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button></div><!-- Modal body --><div class=\"modal-body\"><div ng-if=\"$ctrl.sendBookingConfirmationMSGsample\" translate=\"tikonApp.notificationSetting.sendBookingConfirmationMSGsample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendBookingConfirmationMSGsample</div><div ng-if=\"$ctrl.sendBookingConfirmationSupplierMSGsample\" translate=\"tikonApp.notificationSetting.sendBookingConfirmationSupplierMSGsample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendBookingConfirmationSupplierMSGsample</div><div ng-if=\"$ctrl.sendCustomerReminder\" translate=\"tikonApp.notificationSetting.sendCustomerReminderMSGsample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendCustomerReminderMSGsample</div><div ng-if=\"$ctrl.sendCustomerRebookReminder\" translate=\"tikonApp.notificationSetting.sendCustomerRebookReminderMSGsample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendCustomerRebookReminderMSGsample</div><div ng-if=\"$ctrl.sendCustomerSecondReminder\" translate=\"tikonApp.notificationSetting.sendCustomerSecondReminderMSGsample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendCustomerSecondReminderMSGsample</div><div ng-if=\"$ctrl.sendCustomerBirthdateNotice\" translate=\"tikonApp.notificationSetting.sendCustomerBirthdateNoticeMsgsample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendCustomerBirthdateNoticeMsgsample</div><div ng-if=\"$ctrl.sendCustomerWelcome\" translate=\"tikonApp.notificationSetting.sendCustomerWelcomeample\" style=\"white-space: pre-wrap\">tikonApp.notificationSetting.sendCustomerWelcomeample</div></div><!-- Modal footer --><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">{{\'tikonApp.notificationSetting.close\' | translate}}</button></div></div></div></div><div><div ng-if=\"$ctrl.settingFormSection == \'themeSettingTab\'\"><fieldset class=\"standard-fieldset\"><legend><md-icon>image</md-icon><span translate=\"tikonApp.settingInfo.sections.themeSettingTab\">themeSettingTab</span></legend><div class=\"container-fluid\"><div class=\"row\" ng-if=\"$ctrl.__config.appMode == \'reserve\'\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.themeType\" for=\"field_themeType\">themeType</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.themeType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_themeType\"><md-option value=\"DEFAULT_THEME\" disabled=\"true\" translate=\"tikonApp.themeType.DEFAULT_THEME\">DEFAULT_THEME</md-option><md-option value=\"MODERN_THEME\" translate=\"tikonApp.themeType.MODERN_THEME\">MODERN_THEME</md-option></md-select></div></div><div class=\"col-md-4\" ng-if=\"$ctrl.isModernTheme()\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.primaryColorSet.title\" for=\"field_primaryColorSet\">primaryColorSet</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.primaryColorSet\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_primaryColorSet\" ng-change=\"$ctrl.primaryColorSetChanged()\"><md-option ng-repeat=\"color in $ctrl.colorList\" ng-value=\"color\"><span ng-class=\"$ctrl.colorSetStyle(color)\" class=\"color-set\"></span> <span class=\"color-title\">{{\'tikonApp.themeSettingInfo.primaryColorSet.\'+color | translate}}</span></md-option></md-select></div></div><div class=\"col-md-4\" ng-if=\"$ctrl.primaryColorSet && $ctrl.primaryColorSet == \'CUSTOM\'\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.themePrimaryColor\" for=\"field_themePrimaryColor\">themePrimaryColor</label><input type=\"text\" class=\"form-control\" name=\"primaryColor\" id=\"field_themePrimaryColor\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.themePrimaryColor\" style=\"direction: ltr\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"\"><eo-image-gallery-manager-v2 disable-cropping=\"true\" label=\"\'tikonApp.themeSettingInfo.logoImage\' | translate\" max-image-count=\"1\" keep-aspect=\"false\" album-id=\"$ctrl.settingInfo.themeSettingInfo.logoImageId\" album-caption=\"$ctrl.settingInfo.themeSettingInfo.name\" on-image-uploaded=\"$ctrl.imageUploaded\"></eo-image-gallery-manager-v2></div></div><!--<hr/>--><div class=\"col-md-4\" ng-if=\"$ctrl.__config.appMode==\'reserve\' && !$ctrl.isModernTheme()\"><div class=\"form-group\"><eo-image-gallery-manager label=\"\'tikonApp.themeSettingInfo.sliderImages\' | translate\" max-image-count=\"1\" crop-width=\"348\" crop-height=\"248\" album-id=\"$ctrl.settingInfo.themeSettingInfo.albumInfoId\" album-caption=\"$ctrl.settingInfo.themeSettingInfo.name\"></eo-image-gallery-manager></div></div><div class=\"col-md-4\" ng-if=\"$ctrl.isModernTheme()\"><div ng-if=\"$ctrl.__config.appMode==\'reserve\'\" class=\"form-group\"><eo-image-gallery-manager-v2 label=\"\'tikonApp.themeSettingInfo.wideCoverImages\' | translate\" max-image-count=\"1\" crop-width=\"1100\" crop-height=\"300\" album-id=\"$ctrl.settingInfo.themeSettingInfo.albumInfoId\" album-caption=\"$ctrl.settingInfo.themeSettingInfo.name\" size-type=\"\'COVER_WIDE\'\" on-image-uploaded=\"$ctrl.imageUploaded\"></eo-image-gallery-manager-v2></div></div><div class=\"col-md-4\" ng-if=\"$ctrl.isModernTheme()\"><div ng-if=\"$ctrl.__config.appMode==\'reserve\' && $ctrl.isInMarketPlace\" class=\"form-group\"><!--if has access to set picture for marketPlace--><eo-image-gallery-manager-v2 label=\"\'tikonApp.themeSettingInfo.marketPlaceCardImage\' | translate\" max-image-count=\"1\" crop-width=\"400\" crop-height=\"240\" album-id=\"$ctrl.settingInfo.themeSettingInfo.albumInfoId\" album-caption=\"$ctrl.settingInfo.themeSettingInfo.name\" size-type=\"\'MARKETPLACE_COMPANY_CARD\'\"></eo-image-gallery-manager-v2></div></div><div class=\"col-md-4\"><div ng-if=\"$ctrl.__config.appMode==\'event\'\" class=\"form-group\"><eo-image-gallery-manager-v2 label=\"\'tikonApp.themeSettingInfo.meetingRoomImage\' | translate\" max-image-count=\"1\" crop-width=\"1120\" crop-height=\"600\" min-width=\"1120\" min-height=\"600\" album-id=\"$ctrl.settingInfo.themeSettingInfo.albumInfoId\" album-caption=\"$ctrl.settingInfo.themeSettingInfo.name\" size-type=\"\'MEETING_ROOM_SIZE\'\"></eo-image-gallery-manager-v2></div></div></div><div class=\"row\" ng-if=\"$ctrl.__config.appMode == \'reserve\' && $ctrl.isModernTheme()\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.themeHeaderType\" for=\"field_themeHeaderType\">themeHeaderType</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.themeHeaderType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_themeHeaderType\"><md-option value=\"NONE\" translate=\"tikonApp.themeHeaderType.NONE\">NONE</md-option><md-option value=\"MODERN_HEADER\" translate=\"tikonApp.themeHeaderType.MODERN_HEADER\">MODERN_HEADER</md-option><md-option value=\"MODERN_HEADER_NO_TEXT\" translate=\"tikonApp.themeHeaderType.MODERN_HEADER_NO_TEXT\">MODERN_HEADER_NO_TEXT</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.themeServiceListType\" for=\"field_themeServiceListType\">themeServiceListType</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.themeServiceListType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_themeServiceListType\"><md-option value=\"CARD\" translate=\"tikonApp.themeServiceListType.CARD\">CARD</md-option><md-option value=\"LIST\" translate=\"tikonApp.themeServiceListType.LIST\">LIST</md-option></md-select></div></div></div><div class=\"row\" ng-if=\"$ctrl.__config.appMode == \'reserve\' && $ctrl.isModernTheme()\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.mapVisibility\" for=\"field_mapVisibility\">mapVisibility</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.mapVisibility\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_mapVisibility\"><md-option value=\"SHOW\" translate=\"tikonApp.visibilityStatus.SHOW\">SHOW</md-option><md-option value=\"HIDE\" translate=\"tikonApp.visibilityStatus.HIDE\">HIDE</md-option></md-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.workingTimeVisibility\" for=\"field_workingTimeVisibility\">workingTimeVisibility</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.workingTimeVisibility\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_workingTimeVisibility\"><md-option value=\"SHOW\" translate=\"tikonApp.visibilityStatus.SHOW\">SHOW</md-option><md-option value=\"HIDE\" translate=\"tikonApp.visibilityStatus.HIDE\">HIDE</md-option></md-select></div></div><!--<img class=\"my-image\" src=\"/content/images/home_slide1.jpg\" />--><!--<div class=\"demo\"></div>--><!--<script>--><!--$(document).ready(function () {--><!--$(\'.demo\').croppie({--><!--url: \'/content/images/home_slide1.jpg\',--><!--})--><!--});--><!--</script>--></div><div ng-if=\"$ctrl.company.customSettingObject.clientBookingWidgetType === \'VUE_COMPONENT\'\" class=\"row\"><div class=\"col-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.themeSettingInfo.componentSetting\" for=\"field_componentSettingJson\">componentSetting</label><input type=\"text\" class=\"form-control\" id=\"field_componentSettingJson\" ng-model=\"$ctrl.settingInfo.themeSettingInfo.componentSettingJson\"></div></div></div></div></fieldset><!--<fieldset  class=\"standard-fieldset\">--><!--<legend>--><!--<md-icon> wallpaper</md-icon>--><!--<span translate=\"tikonApp.settingInfo.sections.imageGallery\">imageGallery</span>--><!--</legend>--><!--<div class=\"container-fluid\">--><!--<div class=\"row\">--><!--<div class=\"col-md-12\">--><!--<div class=\"\">--><!--<eo-image-gallery-manager--><!--label=\"\'tikonApp.settingInfo.sections.imageGallery\' | translate\"--><!--max-image-count=\"5\"--><!--album-id=\"$ctrl.settingInfo.themeSettingInfo.albumInfoId\"--><!--album-caption=\"$ctrl.settingInfo.themeSettingInfo.name\"--><!--size-type=\"\'MARKETPLACE_SIZE\'\"--><!--crop-width=\"1920\" crop-height=\"1080\"--><!--&gt;--><!--</eo-image-gallery-manager>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</fieldset>--></div><fieldset ng-if=\"$ctrl.settingFormSection == \'notificationSettingTab\'\" class=\"standard-fieldset\"><legend><md-icon>message</md-icon><span translate=\"tikonApp.settingInfo.sections.notificationSettingTab\">notificationSettingTab</span></legend><div class=\"container-fluid\"><div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendBookingConfirmation\" eo-help-tooltip=\"tips.send_booking_confirmation\">Send Booking Confirmation</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'sendBookingConfirmation\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendBookingConfirmationSMS\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendBookingConfirmationEMAIL\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.EMAIL\"></span></md-switch></div></div></div></div></div></div><div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendBookingConfirmationSupplier\" eo-help-tooltip=\"tips.send_booking_confirmation_supplier\">Send Booking Confirmation Supplier</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'sendBookingConfirmationSupplier\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendBookingConfirmationSupplierSMS\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendBookingConfirmationSupplierEMAIL\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.EMAIL\"></span></md-switch></div></div></div></div></div></div><!--<div class=\"\">--><!--<div class=\"form-group\">--><!--<div class=\"row\">--><!--<div class=\"col-md-5\">--><!--<label class=\"control-label\"--><!--translate=\"tikonApp.notificationSetting.sendUserRegistrationMessage\"--><!--eo-help-tooltip=\"tips.send_user_registration_message\"--><!--&gt;sendUserRegistrationMessage</label>--><!--</div>--><!--<div>--><!--<div class=\"col-md-1\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"$ctrl.sendUserRegistrationMessageSMS\"--><!--aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\">--><!--<span translate=\"tikonApp.NotificationType.SMS\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--><!--<div class=\"col-md-1\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"$ctrl.sendUserRegistrationMessageEMAIL\"--><!--aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\">--><!--<span translate=\"tikonApp.NotificationType.EMAIL\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendCustomerSatisfactionMessage\">sendCustomerSatisfactionMessage</label></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerSatisfactionMessageSMS\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\" eo-feature-checker=\"satisfactionMessage_SMS\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><!--<div class=\"col-md-1\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"$ctrl.sendCustomerSatisfactionMessageEMAIL\"--><!--aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"--><!--eo-feature-checker=\"satisfactionMessage_Email\"--><!--&gt;--><!----><!--<span translate=\"tikonApp.NotificationType.EMAIL\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--></div></div></div></div><div id=\"sendBookingCancellationSupplier\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendBookingCancellationSupplier\" eo-help-tooltip=\"tips.send_booking_cancellation_supplier\">Send Booking Confirmation Supplier</label><!--<span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\"--><!--ng-click=\"$ctrl.sampleCheck(\'sendBookingCancellationSupplier\')\"--><!--translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span>--></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendBookingCancellationSupplierSMS\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><!--<div class=\"col-md-2\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"$ctrl.sendBookingCancellationSupplierEMAIL\"--><!--aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\">--><!--<span translate=\"tikonApp.NotificationType.EMAIL\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--></div></div></div></div><hr><div class=\"\" id=\"firstReminder\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendCustomerReminder\" eo-help-tooltip=\"tips.send_customer_reminder\">sendCustomerReminder</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'sendCustomerReminder\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerReminderSMS\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerReminderEMAIL\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.EMAIL\"></span></md-switch></div></div></div></div></div><div style=\"padding-right : 15px\" class=\"row form-group\" ng-if=\"$ctrl.sendCustomerReminderSMS || $ctrl.sendCustomerReminderEMAIL\"><!--<div class=\"col-sm-3\">--><label class=\"control-label\" translate=\"tikonApp.notificationSetting.reminderTimeInAdvanced\" eo-help-tooltip=\"tips.reminder_time_in_advanced\" for=\"field_reminderTimeInAdvanced\">Reminder Time In Advanced</label><!--</div>--><!--<div class=\"col-md-2\" style=\"float: right\">--><div class=\"row\"><div class=\"col-md-2\"><input type=\"number\" class=\"form-control\" name=\"reminderTimeInAdvanced\" id=\"field_reminderTimeInAdvanced\" ng-model=\"$ctrl.settingInfo.notificationSetting.reminderTimeInAdvanced\" min=\"1\"></div></div><!--</div>--></div></div><hr><div id=\"sendCustomerRebookReminder\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendCustomerRebookReminder\" eo-help-tooltip=\"tips.send_customer_rebook_reminder\">sendCustomerRebookReminder</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'sendCustomerRebookReminder\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerRebookReminderSMS\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\" eo-feature-checker=\"customerRebookReminder_SMS\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><!--<div class=\"col-md-1\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"$ctrl.sendCustomerRebookReminderEMAIL\"--><!--aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"--><!--&gt;--><!--<span translate=\"tikonApp.NotificationType.EMAIL\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--></div></div></div><div style=\"padding-right : 15px\" class=\"row form-group\" ng-if=\"$ctrl.sendCustomerRebookReminderSMS\"><!--<div class=\"col-sm-3\">--><label class=\"control-label\" translate=\"tikonApp.notificationSetting.rebookReminderDayAfter\" eo-help-tooltip=\"tips.rebook_reminder_day_after\" for=\"field_rebookReminderDayAfter\">Reminder Time In Advanced</label><!--</div>--><!--<div class=\"col-md-2\" style=\"float: right\">--><div class=\"row\"><div class=\"col-md-2\"><input type=\"number\" class=\"form-control\" name=\"rebookReminderDayAfter\" id=\"field_rebookReminderDayAfter\" ng-model=\"$ctrl.settingInfo.notificationSetting.rebookReminderDayAfter\" min=\"5\"></div></div><!--</div>--></div></div><hr><div class=\"\" id=\"secondReminder\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.sendCustomerSecondReminder\" eo-help-tooltip=\"tips.send_customer_second_reminder\">sendCustomerSecondReminder</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'sendCustomerSecondReminder\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerSecondReminderSMS\" aria-label=\"Switch Happy Birthday SMS\" ng-change=\"$ctrl.switch_changed()\" eo-feature-checker=\"customerSecondReminder\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><!--<div class=\"col-md-1\">--><!--<div class=\"pull-right\">--><!--<md-switch ng-model=\"$ctrl.sendCustomerSecondReminderEMAIL\"--><!--aria-label=\"Switch Second Reminder Email\" ng-change=\"$ctrl.switch_changed()\"--><!--eo-feature-checker=\"customerSecondReminder\"--><!--&gt;--><!--<span translate=\"tikonApp.NotificationType.EMAIL\"> </span>--><!--</md-switch>--><!--</div>--><!--</div>--></div></div></div><div style=\"padding-right : 15px\" class=\"row form-group\" ng-if=\"$ctrl.sendCustomerSecondReminderSMS || $ctrl.sendCustomerSecondReminderEMAIL\"><!--<div class=\"col-sm-3\">--><label class=\"control-label\" translate=\"tikonApp.notificationSetting.secondReminderTimeInAdvanced\" eo-help-tooltip=\"tips.second_reminder_time_in_advanced\" for=\"field_secondReminderTimeInAdvanced\">Second Reminder Time In Advanced</label><!--</div>--><!--<div class=\"col-md-2\" style=\"float: right\">--><div class=\"row\"><div class=\"col-md-2\"><input type=\"number\" class=\"form-control\" name=\"secondReminderTimeInAdvanced\" id=\"field_secondReminderTimeInAdvanced\" ng-model=\"$ctrl.settingInfo.notificationSetting.secondReminderTimeInAdvanced\" min=\"1\"></div></div><!--</div>--></div></div><hr><div class=\"\" id=\"happy-birthday\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.customerBirthdateNoticeMsg\" eo-help-tooltip=\"tips.send_customer_birthday_notif\">customerBirthdateNoticeMsg</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'customerBirthdateNoticeMsg\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerBirthdateNoticeSMS\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div></div></div></div></div><hr><div class=\"\" id=\"welcom-field\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-5\"><label class=\"control-label\" translate=\"tikonApp.notificationSetting.customerWelcom\" eo-help-tooltip=\"tips.send_customer_birthday_notif\">customerWelcom</label><span class=\"rw-sampleMSG\" data-toggle=\"modal\" data-target=\"#sampleMSG\" ng-click=\"$ctrl.sampleCheck(\'customerWelcom\')\" translate=\"tikonApp.notificationSetting.sampleMSG\">tikonApp.notificationSetting.sampleMSG</span></div><div class=\"rw-radioBtn\"><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerWelcomeSMS\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.SMS\"></span></md-switch></div></div><div class=\"col-md-2\"><div class=\"pull-right\"><md-switch ng-model=\"$ctrl.sendCustomerWelcomeEMAIL\" aria-label=\"Switch 1\" ng-change=\"$ctrl.switch_changed()\"><span translate=\"tikonApp.NotificationType.EMAIL\"></span></md-switch></div></div></div></div></div></div></div></fieldset><fieldset ng-if=\"$ctrl.settingFormSection == \'financialSettingTab\'\" class=\"standard-fieldset\"><legend><md-icon>attach_money</md-icon><span translate=\"tikonApp.settingInfo.sections.financialSettingTab\">financialSettingTab</span></legend><div class=\"container-fluid\"><div class=\"row\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right: 7px\"><md-switch ng-model=\"$ctrl.settingInfo.financialSetting.inPlacePayment\" aria-label=\"Switch 1\"><span translate=\"tikonApp.financialSetting.inPlacePayment\"></span></md-switch></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.financialSetting.taxPercentage\" for=\"field_taxPercentage\">Tax Percentage</label><input type=\"number\" class=\"form-control\" style=\"max-width: 50%\" name=\"taxPercentage\" id=\"field_taxPercentage\" min=\"0\" ng-model=\"$ctrl.settingInfo.financialSetting.taxPercentage\"></div></div><div class=\"col-lg-3 col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.financialSetting.currency\" for=\"field_currency\">Currency</label><md-select class=\"rwMdSelect\" name=\"currency\" style=\"max-width: 50%\" ng-model=\"$ctrl.settingInfo.financialSetting.currency\" id=\"field_currency\"><md-option value=\"RIAL\" translate=\"tikonApp.Currency.RIAL\">RIAL</md-option></md-select></div></div></div></div></fieldset><fieldset ng-if=\"$ctrl.settingFormSection == \'videoCallSettingTab\'\" class=\"standard-fieldset\"><legend><md-icon>videocam</md-icon><span translate=\"tikonApp.settingInfo.sections.videoCallSettingTab\">videoCallSettingTab</span></legend><pf-video-call-setting video-call-setting-info=\"$ctrl.settingInfo.videoCallSettingInfo\" mode=\"COMPANY_SETTING\"></pf-video-call-setting></fieldset></div>");
$templateCache.put("app/components/partial-forms/sms-panel-overview/partial-form.sms-panel-overview.html","<md-content class=\"rwMdContent\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-sm-10\"><h4 class=\"modal-title\">خلاصه کمپین پیامکی</h4></div></div></div><div class=\"modal-body\"><div class=\"row text-center\" ng-if=\"$ctrl.loading\"><div class=\"col-sm-12\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular><p>در حال محاسبه اطلاعات کمپین...</p></div></div><div class=\"row text-center\" ng-if=\"$ctrl.error\"><div class=\"col-sm-12\"><p style=\"color: red\">دریافت اطلاعات کمپین با خطا مواجه شد.</p><md-button class=\"md-raised\" ng-click=\"$ctrl.getSmsPanelOverview()\">تلاش مجدد</md-button></div></div><div ng-if=\"!$ctrl.loading && !$ctrl.error && $ctrl.smsPanelOverview\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label>تعداد مشتریان دریافت کننده</label><div>{{$ctrl.smsPanelOverview.totalCompanyCustomersCount | number}}</div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label>تعداد کل پیامک</label><div>{{$ctrl.smsPanelOverview.totalSmsCount | number}}</div></div></div></div><!--            <div class=\"row\">--><!--                <div class=\"col-sm-12\">--><!--                    <div class=\"form-group\">--><!--                        <label>هزینه هر پیامک</label>--><!--                        <div>--><!--                            {{$ctrl.smsPanelOverview.defaultMarketingSmsPrice | number}}--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--            </div>--><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label>پیامک باقی‌مانده در بسته</label><div>{{$ctrl.smsPanelOverview.remainSmsInPackage | number}}</div></div></div></div><div class=\"alert alert-warning\" ng-if=\"$ctrl.smsPanelOverview.totalSmsCount >\n               $ctrl.smsPanelOverview.remainSmsInPackage\">تعداد پیامک‌های باقی‌مانده برای ارسال این کمپین کافی نیست.</div><div class=\"alert alert-warning\" ng-if=\"$ctrl.noCustomerSelected\">هیچ مشتری انتخاب نشده است.</div></div></div><div class=\"modal-footer\" ng-if=\"$ctrl.showActionButtons\"><md-button ng-if=\"$ctrl.onCancel\" ng-click=\"$ctrl.cancel()\">انصراف</md-button><md-button class=\"md-raised md-primary\" ng-if=\"$ctrl.onConfirm\" ng-disabled=\"\n                $ctrl.loading ||\n                $ctrl.error ||\n                !$ctrl.smsPanelOverview ||\n                $ctrl.noCustomerSelected\n            \" ng-click=\"$ctrl.confirm()\">تایید</md-button></div></md-content>");
$templateCache.put("app/components/partial-forms/sms-text-editor/partial-form.sms-text-editor.html","<style>.eq-box {\n        border: 1px solid #cbc9c9;\n        padding: 0 5px;\n        border-radius: 10px;\n        background-color: #b3b3b357;\n        color: black;\n        box-shadow: 0px 0 3px -2px;\n    }\n\n    .eq-box:hover {\n        box-shadow: 0px 0 5px -2px;\n    }\n\n    .eq-container {\n        border: 1px solid #e3e2e2;\n        padding: 3px;\n        border-radius: 5px;\n    }\n\n    @media screen and (max-width: 767px) {\n        .link-help {\n            padding-top: 0px;\n            padding-bottom: 5px;\n        }\n    }</style><div class=\"container-fluid eq-container\"><div class=\"row\"><div class=\"col-sm-12\" style=\"display: flex;flex-flow: wrap;gap: 5px\"><span class=\"eq-box\" ng-repeat=\"item in $ctrl.equivalentList \" ng-click=\"$ctrl.onEquivalentClick(item)\">{{item.title}}</span></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"{{$ctrl.id}}\">{{$ctrl.label}}</label><textarea style=\"max-height: 117px\" class=\"form-control\" rows=\"5\" id=\"{{$ctrl.id}}\" ng-model=\"$ctrl.smsText\"></textarea></div></div></div></div>");
$templateCache.put("app/components/partial-forms/time-period-off-times/partial-form.time-period-off-times.html","<style>.offTimeBlock {\n        background-color: rgba(240, 120, 130, 0.33);\n        border-radius: 20px;\n        padding: 4px 16px;\n        margin: 3px;\n        width: 130px;\n        float: right;\n\n    }\n\n    .adding-off-days {\n        margin-top: 18px;\n    }\n\n    @media (max-width: 480px) {\n        .adding-off-days {\n            margin-top: 118px !important;\n        }\n    }</style><div style=\"margin: 10px\"><div class=\"row\"><div style=\"float: right\"><eo-time-range start-time=\"$ctrl.fromTime\" end-time=\"$ctrl.toTime\"></eo-time-range></div><div><md-button class=\"md-icon-button medium-icon adding-off-days\" style=\"margin-top: 20px\" ng-click=\"$ctrl.onAddtime()\"><i class=\"material-icons\">add_circle</i></md-button></div></div><div class=\"row\"><div class=\"offTimeBlock\" ng-repeat=\"time in $ctrl.offTimes\"><span ng-click=\"$ctrl.onRemovetime(time)\"><span class=\"glyphicon glyphicon-remove\"></span> <span>{{time.name}}</span></span></div></div></div>");
$templateCache.put("app/components/partial-forms/video-call-setting/partial-form.video-call-setting.html","<style>.form-field-description {\n        font-size: 12px;\n        color: #607d8b;\n    }\n\n    .link-help {\n        padding-top: 38px;\n    }\n\n    @media screen and (max-width: 767px) {\n        .link-help {\n            padding-top: 0px;\n            padding-bottom: 5px;\n        }\n    }</style><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-6 col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.videoCallSettingInfo.platformType\" for=\"field_platformType\">platformType</label><md-select class=\"rwMdSelect\" ng-model=\"$ctrl.videoCallSettingInfo.platformType\" style=\"min-width: 250px;margin-top: 6px\" id=\"field_platformType\" ng-change=\"$ctrl.videoPlatformChanged()\"><md-option value=\"NONE\" translate=\"tikonApp.videoPlatformType.NONE\">NONE</md-option><md-option value=\"JITSI_MEET\" translate=\"tikonApp.videoPlatformType.JITSI_MEET\">JITSI_MEET</md-option><md-option value=\"GOOGLE_MEET\" translate=\"tikonApp.videoPlatformType.GOOGLE_MEET\">GOOGLE_MEET</md-option><md-option value=\"SKYPE\" translate=\"tikonApp.videoPlatformType.SKYPE\">SKYPE</md-option><md-option value=\"CUSTOM\" translate=\"tikonApp.videoPlatformType.CUSTOM\">CUSTOM</md-option><!--<md-option value=\"WEDOMEET\" translate=\"tikonApp.videoPlatformType.WEDOMEET\">--><!--WEDOMEET--><!--</md-option>--><!--<md-option value=\"GHARAR\" translate=\"tikonApp.videoPlatformType.GHARAR\">--><!--GHARAR--><!--</md-option>--></md-select></div></div><div class=\"col-sm-6 link-help\" ng-if=\"$ctrl.videoCallSettingInfo.platformType && $ctrl.videoCallSettingInfo.platformType !=\'NONE\'\"><a href=\"https://planovin.com/blog/kb/video-call\" target=\"_blank\"><md-icon>help</md-icon>آموزش نحوه ایجاد لینک اتاق</a></div></div><div ng-if=\"$ctrl.videoCallSettingInfo.platformType && $ctrl.videoCallSettingInfo.platformType !=\'NONE\'\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.videoCallSettingInfo.defaultRoomUrl\" for=\"field_defaultRoomUrl\">defaultRoomUrl</label><input type=\"text\" class=\"form-control\" name=\"defaultRoomUrl\" id=\"field_defaultRoomUrl\" ng-model=\"$ctrl.videoCallSettingInfo.defaultRoomUrl\"></div></div></div><div class=\"row\" ng-if=\"$ctrl.videoCallSettingInfo.platformType == \'GOOGLE_MEET\' && !$ctrl.videoCallSettingInfo.defaultRoomUrl\"><div class=\"col-md-12\"><p style=\"color: red\">وارد کردن لینک اتاق اجباری است و در صورت خالی گذاشتن این بخش جلسه برگزار نمی شود.</p></div></div><div class=\"row\" ng-if=\"$ctrl.videoCallSettingInfo.platformType == \'SKYPE\' && !$ctrl.videoCallSettingInfo.defaultRoomUrl\"><div class=\"col-md-12\"><p style=\"color: red\">وارد کردن لینک اتاق اجباری است و در صورت خالی گذاشتن این بخش جلسه برگزار نمی شود.</p></div></div><div class=\"row\" ng-if=\"$ctrl.videoCallSettingInfo.platformType == \'CUSTOM\' && !$ctrl.videoCallSettingInfo.defaultRoomUrl\"><div class=\"col-md-12\"><p style=\"color: red\">وارد کردن لینک اتاق اجباری است و در صورت خالی گذاشتن این بخش جلسه برگزار نمی شود.</p></div></div><div class=\"row\" ng-if=\"$ctrl.videoCallSettingInfo.platformType == \'JITSI_MEET\' \"><div class=\"col-md-12\"><p class=\"form-field-description\">*در صورت وارد نکردن لینک اتاق پیش فرض ، سیستم به صورت اتوماتیک لینک جلسه را ایجاد می کند و هر جلسه لینک مجزایی خواهد داشت.</p></div></div><div class=\"row\" ng-if=\"$ctrl.videoCallSettingInfo.platformType == \'CUSTOM\' \"><div class=\"col-md-12\"><p class=\"form-field-description\">*لینک برگزاری را از پلتفرم مورد نظر خود کپی کنید و در این قسمت وارد کنید.</p></div></div></div></div>");
$templateCache.put("app/components/partial-forms/wallet/add-balance-wallet.html","<!-- <md-dialog class=\"add-balance-dialog\" style=\"min-width:400px;\"> --><form name=\"addBalanceForm\" style=\"min-width: 320px\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>افزایش موجودی</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\"><md-icon md-svg-icon=\"md-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"max-width:600px;max-height:600px\"><div class=\"md-dialog-content\"><!-- <md-input-container class=\"md-block\"> --><label class=\"control-label\" required>مقدار</label><!-- <input \n                           ng-model=\"$ctrl.balance.amount\"\n                           min=\"1\"\n                           required> --><eo-numeric-input-v2 id=\"field_minPrice\" name=\"ammount\" custom-class=\"form-control\" input-value=\"$ctrl.balance.amount\" is-required=\"true\" form-reference=\"addBalanceForm\" currency-format=\"true\"></eo-numeric-input-v2><!-- </md-input-container> --><!-- <md-input-container class=\"md-block\">\n                    <label>Payment Method</label>\n                    <md-select ng-model=\"$ctrl.balance.method\" required>\n                        <md-option value=\"card\">Credit/Debit Card</md-option>\n                        <md-option value=\"paypal\">PayPal</md-option>\n                        <md-option value=\"bank\">Bank Transfer</md-option>\n                    </md-select>\n                </md-input-container> --><!-- <md-input-container class=\"md-block\">\n                    <label>Note (optional)</label>\n                    <textarea ng-model=\"$ctrl.balance.note\"\n                              columns=\"1\"\n                              md-maxlength=\"200\"></textarea>\n                </md-input-container> --></div></md-dialog-content><!-- Actions --><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"$ctrl.cancel()\">انصراف</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.addBalance()\" ng-disabled=\"addBalanceForm.$invalid\">افزایش موجودی</md-button></md-dialog-actions></form><!-- </md-dialog> -->");
$templateCache.put("app/components/partial-forms/wallet/wallet-add-balance-dialog.html","<pf-add-wallet-balance customer-id=\"customerId\"></pf-add-wallet-balance>");
$templateCache.put("app/components/partial-forms/wallet/wallet-withdraw-balance-dialog.html","<pf-withdraw-wallet-balance customer-id=\"customerId\" withdraw-amount=\"withdrawAmount\" order-bag-id=\"orderBagId\" invoice-info-id=\"invoiceInfoId\"></pf-withdraw-wallet-balance>");
$templateCache.put("app/components/partial-forms/wallet/withdraw-balance-wallet.html","<form name=\"withdrawForm\" style=\"min-width: 320px; padding: 15px\"><div style=\"display: flex; justify-content: space-between; align-items: center\"><h4 style=\"font-weight: bold\">پرداخت از کیف پول</h4><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.cancel()\"><md-icon>close</md-icon></md-button></div><md-dialog-content class=\"md-dialog-content\"><!-- Header Info --><div layout=\"column\" style=\"margin-bottom: 20px\"><div layout=\"row\" layout-align=\"space-between center\" style=\"padding: 8px 0\"><span>موجودی کیف پول:</span> <span style=\"color: #2e7d32; font-weight: bold\">{{ $ctrl.walletBalance | number }} تومان</span></div><div layout=\"row\" layout-align=\"space-between center\" style=\"padding: 8px 0\"><span>مبلغ باقیمانده تسویه:</span> <span style=\"font-weight: bold\">{{ $ctrl.withdrawAmount | number }} تومان</span></div></div><!-- Warning Box --><div ng-if=\"$ctrl.walletBalance < $ctrl.withdrawAmount\" style=\"background: #fff5f5; border: 1px solid #ffcdd2; color: #c62828; padding: 12px; border-radius: 4px; margin-bottom: 20px\">موجودی کیف پول کافی نیست.<br><small>می‌توانید بخشی از مبلغ را از کیف پول استفاده کنید و مابقی را از روش‌های دیگر پرداخت نمایید.</small></div><!-- Options --><md-radio-group ng-model=\"$ctrl.selectionMode\" ng-change=\"$ctrl.onModeChange()\"><div style=\"display: flex; align-items:center; gap:15px\"><md-radio-button value=\"all\" class=\"md-primary\" style=\"padding: 0; margin: 0\">استفاده از موجودی قابل استفاده ({{ $ctrl.getAppliedAmount() | number }} تومان)</md-radio-button><md-radio-button value=\"custom\" class=\"md-primary\" style=\"padding: 0; margin: 0\">استفاده از مبلغ دلخواه</md-radio-button></div></md-radio-group><!-- Custom Input --><div ng-if=\"$ctrl.selectionMode === \'custom\'\" style=\"margin-top: 15px\"><label id=\"field_customAmount\">مبلغ مورد استفاده از کیف پول:</label><div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 8px\"><eo-numeric-input-v2 id=\"field_customAmount\" name=\"customAmount\" form-reference=\"withdrawForm\" custom-class=\"form-control\" input-value=\"$ctrl.customAmount\" currency-format=\"true\" min=\"1\" max=\"{{ $ctrl.getAppliedAmount() }}\"></eo-numeric-input-v2><span>تومان</span></div></div><hr style=\"margin: 20px 0; border: 0; border-top: 1px solid #eee\"><!-- Summary --><div layout=\"column\" style=\"background: #f9f9f9; padding: 15px; border-radius: 4px\"><div layout=\"row\" layout-align=\"space-between center\" style=\"margin-bottom: 8px\"><span>مبلغ باقیمانده تسویه</span> <span>{{ $ctrl.withdrawAmount | number }} تومان</span></div><div layout=\"row\" layout-align=\"space-between center\" style=\"margin-bottom: 8px; color: #2e7d32\"><span>مبلغ استفاده شده از کیف پول</span> <span>{{ $ctrl.getAppliedAmount() | number }} تومان</span></div><div layout=\"row\" layout-align=\"space-between center\" style=\"font-weight: bold; border-top: 1px solid #ddd; padding-top: 8px; color: #c62828\"><span>مبلغ باقیمانده</span> <span>{{ $ctrl.getRemainingAmount() | number }} تومان</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"$ctrl.cancel()\">انصراف</md-button><md-button class=\"md-raised md-primary\" ng-click=\"$ctrl.approveWithdraw()\" ng-disabled=\"withdrawForm.$invalid\">تایید پرداخت</md-button></md-dialog-actions></form>");
$templateCache.put("app/components/partial-forms/weekly-day-select/partial-form.weekly-day-select.html","<style>.timePart {\n        font-size: 10px;\n        color: #868686;\n    }\n\n    .timeedited {\n        font-weight: bold;\n        color: #005fb3;\n    }\n\n    .timeedit {\n        color: #005fb3;\n        font-size: 14px;\n    }</style><div class=\"row\"><fieldset class=\"standard\"><div class=\"row\"><div class=\"col-sm-3 text-right\" ng-repeat=\"day in $ctrl.allWeekDays\"><span ng-class=\"{\'offDate\':!day.checked}\"><input type=\"checkbox\" ng-click=\"$ctrl.checkChanged()\" ng-model=\"day.checked\" ng-checked=\"day.checked\"> {{ day.name }}</span></div></div></fieldset></div>");
$templateCache.put("app/components/partial-forms/weekly-work-days/partial-form.weekly-work-days.html","<style>.timePart {\n        font-size: 10px;\n        color: #868686;\n    }\n\n    .timeedited {\n        font-weight: bold;\n        color: #005fb3;\n    }\n\n    .timeedit {\n        color: #005fb3;\n        font-size: 14px;\n    }</style><div class=\"row\"><fieldset class=\"standard\"><div class=\"row\"><div class=\"col-sm-3 text-right\" ng-repeat=\"day in $ctrl.allWeekDays\"><span ng-class=\"{\'offDate\':!day.checked}\"><input type=\"checkbox\" ng-click=\"$ctrl.checkChanged()\" ng-model=\"day.checked\" ng-checked=\"day.checked\"> {{ day.name }}<span ng-if=\"day.checked\"> <span ng-if=\" !day.timePeriod\" class=\"timePart\">({{$ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime| toPersianTime}}-{{$ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime| toPersianTime}} <i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i>)</span> <span ng-if=\"day.timePeriod\" class=\"timePart timeedited\">({{day.timePeriod.endTime| toPersianTime}}-{{day.timePeriod.startTime| toPersianTime}} <i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i>)</span> <span class=\"timeedit\" ng-click=\"$ctrl.open(day)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></span></span></span></div></div></fieldset></div>");
$templateCache.put("app/components/partial-forms/weekly-work-days/select-time-dialog.template.html","<div class=\"md-dialog-container\"><md-dialog layout-padding><div style=\"width: 500px\">ساعت کاری را مشخص کنید</div><div><eo-time-range start-time=\"startTime\" end-time=\"endTime\"></eo-time-range><button style=\"width: 80px\" type=\"button\" class=\"btn btn-success\" translate=\"global.action.ok\" ng-click=\"closeDialog()\"></button></div><!--<button type=\"button\" translate=\"global.action.cancel\" ng-click=\"cancel()\" ></button>--></md-dialog></div>");
$templateCache.put("app/components/partial-forms/weekly-work-days-v2/partial-form.weekly-work-days-v2.html","<style>.timePart {\n        font-size: 14px;\n        color: #868686;\n        direction: ltr;\n    }\n\n    .off-time {\n        font-size: 12px;\n        color: #bd2826;\n        direction: ltr;\n    }\n\n    .timeedited {\n        font-weight: bold;\n        color: #005fb3;\n    }\n\n    .timeedit {\n        color: #005fb3;\n        font-size: 16px;\n    }\n\n    .off-week-day {\n        text-align: center;\n        color: #7F8C8D;\n    }\n\n    .active-week-day {\n\n    }\n\n    .active-week-day:hover {\n        background-color: #eee;\n    }</style><div class=\"row\"><div class=\"col-sm-12 hidden-xs\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><tr><td ng-repeat=\"day in $ctrl.allWeekDays\"><md-checkbox ng-model=\"day.checked\" ng-change=\"$ctrl.checkChanged()\">{{ day.name }}</md-checkbox></td></tr><tr><td ng-repeat=\"day in $ctrl.allWeekDays\" style=\"text-align: center\" class=\"active-week-day\"><span ng-if=\"!day.checked\" class=\"off-week-day\">تعطیل</span><div ng-if=\"day.checked\" ng-click=\"$ctrl.open(day)\"><span ng-if=\" !day.timePeriod\" class=\"timePart\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> {{$ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime| toPersianTime}}-{{$ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime| toPersianTime}} <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> </span><span ng-if=\"day.timePeriod\" class=\"timePart timeedited\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> {{day.timePeriod.endTime| toPersianTime}}-{{day.timePeriod.startTime| toPersianTime}} <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></span><hr ng-if=\"day.timePeriod.offtimes && day.timePeriod.offtimes.length>0\"><div ng-repeat=\"offtime in day.timePeriod.offtimes\"><span class=\"off-time\">{{offtime.fromTime| toPersianTime}}- {{offtime.toTime | toPersianTime}} <i class=\"fa fa-ban\" aria-hidden=\"true\"></i></span></div></div></td></tr></table></div></div><div class=\"col-sm-12 visible-xs\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><tr ng-repeat=\"day in $ctrl.allWeekDays\"><td><md-checkbox ng-model=\"day.checked\" ng-change=\"$ctrl.checkChanged()\">{{ day.name }}</md-checkbox></td><td><span ng-if=\"!day.checked\" class=\"off-week-day\">تعطیل</span><div ng-if=\"day.checked\" ng-click=\"$ctrl.open(day)\"><span ng-if=\" !day.timePeriod\" class=\"timePart\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> {{$ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime| toPersianTime}}-{{$ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime| toPersianTime}} <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i> </span><span ng-if=\"day.timePeriod\" class=\"timePart timeedited\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> {{day.timePeriod.endTime| toPersianTime}}-{{day.timePeriod.startTime| toPersianTime}} <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></span><hr ng-if=\"day.timePeriod.offtimes && day.timePeriod.offtimes.length>0\"><div ng-repeat=\"offtime in day.timePeriod.offtimes\"><span class=\"off-time\">{{offtime.fromTime| toPersianTime}}- {{offtime.toTime | toPersianTime}} <i class=\"fa fa-ban\" aria-hidden=\"true\"></i></span></div></div></td></tr></table></div></div></div>");
$templateCache.put("app/components/partial-forms/weekly-work-days-v2/select-time-dialog-v2.template.html","<style>.edittime-dialog-content {\n        min-height: 400px;\n        min-width: 400px;\n        max-width: 600px;\n        padding: 10px;;\n    }\n\n    .demo-md-panel {\n        min-height: 500px;\n    }\n\n    .demo-dialog-example {\n        background: white;\n        border-radius: 4px;\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),\n        0 13px 19px 2px rgba(0, 0, 0, 0.14),\n        0 5px 24px 4px rgba(0, 0, 0, 0.12);\n        width: 500px;\n    }\n\n    .demo-dialog-content {\n        padding: 0 15px;\n        width: 100%;\n    }\n\n    .demo-dialog-content img {\n        height: 300px;\n        margin: auto;\n    }\n\n    .demo-dialog-button {\n        width: 100%;\n    }\n\n    .demo-dialog-custom-animation-open {\n        opacity: 1;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(390deg);\n    }\n\n    .demo-dialog-custom-animation-close {\n        opacity: 0;\n        transition: all 1s linear, opacity 1ms;\n        transform: rotate(0deg);\n    }\n\n    @media (max-width: 480px) {\n        h3, h4 {\n            font-size: medium;\n        }\n\n        md-dialog-content {\n            overflow-x: hidden !important;\n        }\n\n        eo-time-range > div {\n            display: grid;\n        }\n    }</style><md-dialog class=\"pl-md-dialog\"><form ng-cloak><md-toolbar><div class=\"pl-modal-header modal-header pl-modal-border\" style=\"align-items: center\"><div><span>ویرایش ساعت کاری </span><span><small>- {{vm.day.name}}</small></span></div><!--<md-button class=\"md-icon-button\" ng-click=\"vm.cancelDialog()\">--><!--<i class=\"material-icons\" >close</i>--><!--</span>--><!--</md-button>--><div class=\"visible-xs pl-modal-header-close-icon-container\"><div class=\"pl-modal-header-close-icon\" ng-click=\"vm.cancelDialog()\"><md-icon style=\"font-size: xx-large;width: 3rem; height: 3rem;color: black\">close</md-icon></div></div></div></md-toolbar><md-dialog-content><div class=\"edittime-dialog-content\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری روز <strong>{{vm.day.name}}</strong></legend><eo-time-range start-time=\"vm.tp.startTime\" end-time=\"vm.tp.endTime\"></eo-time-range></fieldset><fieldset class=\"standard-fieldset\"><legend>ساعت های تعطیل روز <strong>{{vm.day.name}}</strong></legend><pf-time-period-off-times selected-time-period=\"vm.tp\"></pf-time-period-off-times></fieldset></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"pl-dialog-actions\"><md-button type=\"button\" class=\"md-raised md-secondary pl-btn pl-btn-default hidden-xs\" data-dismiss=\"modal\" ng-click=\"vm.cancelDialog()\"><span>بازگشت</span></md-button><md-button class=\"md-raised md-primary pl-btn pl-btn-primary\" ng-click=\"vm.cancelDialog()\">تایید</md-button></md-dialog-actions></form></md-dialog><!--<div class=\"filter-dialog-content\">--><!--</div>--> <!--\n<div class=\"md-dialog-container\">\n    <md-dialog layout-padding>\n        <div style=\"width: 500px;\">\n            ساعت کاری را مشخص کنید\n\n   </div>\n        <div>\n\n        <eo-time-range start-time=\"startTime\"\n                       end-time=\"endTime\"\n        ></eo-time-range>\n            <button style=\"width: 80px\" type=\"button\" class=\"btn btn-success\" translate=\"global.action.ok\" ng-click=\"closeDialog()\" ></button>\n\n        </div>\n        &lt;!&ndash;<button type=\"button\" translate=\"global.action.cancel\" ng-click=\"cancel()\" ></button>&ndash;&gt;\n    </md-dialog>\n</div>\n-->");
$templateCache.put("app/entities/schedule-info/scheduling/company-scheduling-v2.html","<style>.rwMdContent {\n        overflow-x: hidden;\n    }</style><eo-pl-modal-header title=\"\'supplierPanel.sideMenu.companyInfo.companyWorkingTimes\'\" is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-header><div class=\"pl-content\"><div class=\"container-fluid pl-container-fluid\"><jhi-alert-error></jhi-alert-error><div ng-show=\"vm.selectedScheduleInfo\"><ul class=\"pl-nav-tabs\"><li class=\"active\"><a data-target=\"#workingTime\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">history</md-icon><span>ساعت کاری <b>منظم </b></span></a></li><li><a data-target=\"#exceptions\" data-toggle=\"tab\"><md-icon class=\"pl-icon\">event</md-icon><span>ساعت کاری <b>نامنظم</b></span></a></li></ul><div class=\"tab-content clearfix\"><div class=\"tab-pane active\" style=\"background: none\" id=\"workingTime\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companyWorkingTimes\">supplierPanel.sideMenu.companyInfo.companyWorkingTimes<!--{{vm.serviceItem.itemTitle}}--></div><div class=\"panel-body\"><div class=\"\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری کلی</legend><div class=\"\"><eo-time-range start-time=\"vm.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"vm.selectedScheduleInfo.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range></div><div class=\"row\"><div class=\"col-md-4\"><md-switch ng-model=\"vm.showLimitDates\" ng-change=\"vm.showLimitDateChange()\" style=\"padding-right: 23px;white-space: normal\">محدود سازی تاریخ شروع و پایان زمانبندی</md-switch></div><div class=\"col-md-4\" ng-if=\"vm.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.fromDate\">fromDate</label><eo-date-picker id=\"field_fromDateFilter\" date-value=\"vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate\"></eo-date-picker></div></div><div class=\"col-md-4\" ng-if=\"vm.showLimitDates\"><div class=\"form-group\"><label translate=\"tikonApp.servant.schedule.toDate\">toDate</label><eo-date-picker id=\"field_endDateFilter\" date-value=\"vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate\"></eo-date-picker></div></div></div></fieldset></div><div class=\"\"><fieldset class=\"standard-fieldset\"><legend>ساعت کاری هفتگی</legend><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"vm.selectedScheduleInfo.weeklyScheduleInfo\"></pf-weekly-work-days-v2></fieldset></div><div class=\"\"><fieldset class=\"standard-fieldset\"><legend>روزهای تعطیل</legend><div class=\"row rw-radioBtn\"><div class=\"col-md-4\"><div class=\"pull-right\"><md-switch ng-model=\"vm.hasBaseOffDaySchedule\" aria-label=\"Switch 1\" ng-change=\"vm.baseOffDayScheduleSwitch_changed()\"><span>تعطیلات رسمی تعطیل باشد</span></md-switch></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-field-description\">* شما میتوانید تعطیلات مخصوص به خود را در بخش زیر اضافه کنید</div><pf-date-period-off-days selected-date-period=\"vm.selectedScheduleInfo.weeklyScheduleInfo.datePeriod\"></pf-date-period-off-days></div></div></fieldset></div><div class=\"\"><fieldset class=\"standard-fieldset\"><legend>ساعت های تعطیل</legend><pf-time-period-off-times selected-time-period=\"vm.selectedScheduleInfo.weeklyScheduleInfo.timePeriod\"></pf-time-period-off-times></fieldset></div></div></div></div><div style=\"background: none\" class=\"tab-pane fade\" id=\"exceptions\"><div class=\"pl-panel\"><div class=\"panel-heading pl-panel-heading\">ساعت کاری نامنظم</div><div class=\"panel-body\"><pf-exception-duration-v2 exdurations=\"vm.selectedScheduleInfo.scheduleExceptionDurations\"></pf-exception-duration-v2></div></div></div></div></div></div></div><eo-pl-modal-footer is-disabled=\"editForm.$invalid || vm.isSaving\" on-ok=\"vm.okModal()\" on-close=\"vm.closeModal()\"></eo-pl-modal-footer>");
$templateCache.put("app/entities/schedule-info/scheduling/company-scheduling.html","<style>.rwMdContent {\n        overflow-x: hidden;\n    }</style><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"supplierPanel.sideMenu.companyInfo.companyWorkingTimes\">supplierPanel.sideMenu.companyInfo.companyWorkingTimes<!--{{vm.serviceItem.itemTitle}}--></div><div class=\"panel-body\"><pf-company-schedules company-id=\"vm.companyId\" selected-schedule-info=\"1\"></pf-company-schedules></div></div>");
$templateCache.put("app/entities/schedule-info/scheduling/scheduling-v2.html","<div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"form-title-bar\"><a ui-sref=\"supplierPanel.generalServiceItemV2({id:vm.serviceItem.id})\" style=\"text-decoration: underline\">{{vm.serviceItem.itemTitle}}</a></div></div><div class=\"panel-body\"><pf-service-item-schedules-v2 service-item-id=\"vm.serviceItemId\" selected-schedule-info=\"1\"></pf-service-item-schedules-v2></div></div>");
$templateCache.put("app/entities/schedule-info/scheduling/scheduling.html","<div class=\"panel panel-default\"><div class=\"panel-heading\">نام سرویس : <a ui-sref=\"supplierPanel.generalServiceItem({id:vm.serviceItem.id})\" style=\"text-decoration: underline\">{{vm.serviceItem.itemTitle}}</a></div><div class=\"panel-body\"><!--<pf-service-item-schedules service-item-id=\"vm.serviceItemId\" selected-schedule-info=\"1\">--><!--</pf-service-item-schedules>--><pf-service-item-schedules service-item-id=\"vm.serviceItemId\" selected-schedule-info=\"1\"></pf-service-item-schedules></div></div>");
$templateCache.put("app/components/partial-forms/wizard-forms/company-info/wizard-form.company-info.html","<style>.keyurl {\n        /*width: 100%;*/\n        text-align: center;\n        font-size: 1em;\n        font-weight: bold;\n        color: #1a2c51;\n        height: 38px;\n        padding-top: 6px;\n        background-color: rgb(247, 250, 250);\n        border-bottom: 1px solid #d2d2d2;\n    }\n\n    .keyurl input {\n        text-align: center;\n        width: 135px;\n        color: #04796e;\n        font-size: 1.1em;\n        border: solid 1px rgba(4, 121, 110, 0.65);\n\n    }</style><form name=\"companyinfoform\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\': companyinfoform.title.$touched && companyinfoform.title.$invalid }\"><label class=\"control-label\" translate=\"tikonApp.company.wizard_title\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"$ctrl.company.title\" required eo-required=\"\"><div class=\"error-message\" ng-messages=\"companyinfoform.title.$error\" ng-show=\"companyinfoform.title.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.title_isrequired\"></span></p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.activityType\" for=\"field_activityType\">Activity Type</label><md-select class=\"rwMdSelect\" name=\"activityType\" ng-model=\"$ctrl.company.activityType\" required eo-required=\"\" id=\"field_activityType\"><md-option ng-value=\"si\" ng-repeat=\"si in $ctrl.activityTypes\">{{\"tikonApp.ActivityType.\"+ si | translate}}</md-option><!--<md-optgroup label=\"items\" translate=\"tikonApp.ActivityType.PSYCHOLOGIST\">--><!--<md-option value=\"PSYCHOLOGIST\" translate=\"tikonApp.ActivityType.PSYCHOLOGIST\">PSYCHOLOGIST</md-option>--><!--<md-option value=\"BUSINESS_CONSULTING\" translate=\"tikonApp.ActivityType.BUSINESS_CONSULTING\">BUSINESS_CONSULTING</md-option>--><!--</md-optgroup>--><!--<md-option value=\"PSYCHOLOGIST\" translate=\"tikonApp.ActivityType.PSYCHOLOGIST\">PSYCHOLOGIST</md-option>--><!--<md-option value=\"BUSINESS_CONSULTING\" translate=\"tikonApp.ActivityType.BUSINESS_CONSULTING\">BUSINESS_CONSULTING</md-option>--><!--<md-option value=\"ATELIER\" translate=\"tikonApp.ActivityType.ATELIER\">ATELIER</md-option>--><!--<md-option value=\"MEN_SALON\" translate=\"tikonApp.ActivityType.MEN_SALON\">MEN_SALON</md-option>--><!--<md-option value=\"WOMEN_SALON\" translate=\"tikonApp.ActivityType.WOMEN_SALON\">WOMEN_SALON</md-option>--><!--<md-option value=\"SPA\" translate=\"tikonApp.ActivityType.SPA\">SPA</md-option>--><!--<md-option value=\"WORK_SPACE\" translate=\"tikonApp.ActivityType.WORK_SPACE\">WORK_SPACE</md-option>--><!--<md-option value=\"ACUPUNCTURE\" translate=\"tikonApp.ActivityType.ACUPUNCTURE\">ACUPUNCTURE</md-option>--><!--<md-option value=\"DOCTOR\" translate=\"tikonApp.ActivityType.DOCTOR\">ACUPUNCTURE</md-option>--><!--<md-option value=\"HOBBY\" translate=\"tikonApp.ActivityType.HOBBY\">HOBBY</md-option>--><!--<md-option value=\"BEAUTY\" translate=\"tikonApp.ActivityType.BEAUTY\">BEAUTY</md-option>--><!--<md-option value=\"TRAVEL\" translate=\"tikonApp.ActivityType.TRAVEL\">TRAVEL</md-option>--><!--<md-option value=\"HEALTH\" translate=\"tikonApp.ActivityType.HEALTH\">HEALTH</md-option>--><!--<md-option value=\"SPORT\" translate=\"tikonApp.ActivityType.SPORT\">SPORT</md-option>--><!--<md-option value=\"EDUCATION\" translate=\"tikonApp.ActivityType.EDUCATION\">EDUCATION</md-option>--><!--<md-option value=\"OTHER\" translate=\"tikonApp.ActivityType.OTHER\">OTHER</md-option>--></md-select><div class=\"error-message\" ng-messages=\"companyinfoform.activityType.$error\" ng-show=\"companyinfoform.activityType.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.activityType_isrequired\"></span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control text-ltr\" name=\"phoneNumber\" id=\"field_phoneNumber\" ng-model=\"$ctrl.company.phoneNumber\" required eo-required=\"\"><div class=\"error-message\" ng-messages=\"companyinfoform.phoneNumber.$error\" ng-show=\"companyinfoform.phoneNumber.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.phoneNumber_isrequired\"></span></p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.wizard_keyUrl\" for=\"field_keyUrl\">Key Url</label><div class=\"keyurl text-ltr\"><input type=\"text\" name=\"keyUrl\" id=\"field_keyUrl\" minlength=\"3\" maxlength=\"21\" pattern=\"[a-zA-Z0-9]{3,22}$\" ng-model=\"$ctrl.company.keyUrl\" required eo-required=\"\">.{{$ctrl.__config.domain}}</div><div class=\"error-message\" ng-messages=\"companyinfoform.keyUrl.$error\" ng-show=\"companyinfoform.keyUrl.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.keyUrl_isrequired\"></span></p><p ng-message=\"pattern\"><span translate=\"tikonApp.company.keyUrl_isnotvalid\"></span></p><p ng-message=\"maxlength\"><span translate=\"tikonApp.company.keyUrl_lengthisnotvalid\"></span></p><p ng-message=\"minlength\"><span translate=\"tikonApp.company.keyUrl_lengthisnotvalid\"></span></p></div><div class=\"error-message\" ng-if=\"$ctrl.isUrlValid == false\"><p><span translate=\"tikonApp.company.keyUrl_isexist\"></span></p></div></div></div></div><div class=\"row\"></div><!--<div class=\"form-group basic-textarea\">--><!--<label class=\"control-label\" translate=\"tikonApp.company.description\" for=\"field_description\">Description</label>--><!--<textarea class=\"form-control\" id=\"exampleFormControlTextarea2\" rows=\"3\" ng-model=\"$ctrl.company.description\"></textarea>--><!--</div>--></form>");
$templateCache.put("app/components/partial-forms/wizard-forms/company-schedule/wizard-form.company-schedule.html","<style></style><form name=\"CompanyScheduleform\"><div><div class=\"row\"><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.timePeriod\">time period</label></div><div class=\"col-sm-6\"><eo-time-range start-time=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.startTime\" for=\"field_startTime\">Start--><!--Time</label>--><!--<eo-time-picker id=\"field_startTime\" time-value-in=\"field_startTime\"--><!--time-value=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime\"></eo-time-picker>--><!--</div>--></div><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.endTime\" for=\"field_endTime\">End Time</label>--><!--<eo-time-picker id=\"field_endTime\" time-value-in=\"field_endTime\"--><!--time-value=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-picker>--><!--</div>--><!--</div>--></div><div class=\"row\"><!--<div class=\"col-sm-2\">--><!--<label class=\"group-label\" translate=\"tikonApp.serviceItem.workDays\">work days</label>--><!--</div>--><div class=\"col-sm-12\"><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"$ctrl.schedule.weeklyScheduleInfo\"></pf-weekly-work-days-v2></div></div><div class=\"row\"><!--<hr/>--></div><!--<div class=\"row\">--><!--<div class=\"col-sm-2\">--><!--<label class=\"group-label\" translate=\"tikonApp.serviceItem.durationInfo\">duration</label>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.duration\" for=\"field_duration\">Duration</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\" eo-duration-validator eo-required=\"\"--><!--ng-model=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.duration\">--><!--</input>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label>--><!--<input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.gaptime\"/>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row\">--><!--<div class=\"col-sm-2\">--><!--<label class=\"group-label\" translate=\"tikonApp.serviceItem.discountInfo\">discountInfo</label>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--<div class=\"form-group\" style=\"float: right ; width: 100%\">--><!--<label translate=\"tikonApp.serviceItem.discountAmount\" for=\"field_discount\">discountAmount</label>--><!--<input type=\"number\" id=\"field_duration\" class=\"form-control shortInput\"--><!--ng-model=\"$ctrl.schedule.discountAmount\"/>--><!--</div>--><!--</div>--><!--<div class=\"col-sm-4\">--><!--&lt;!&ndash;<div class=\"form-group\" style=\"float: right ; width: 100%\">&ndash;&gt;--><!--&lt;!&ndash;<label translate=\"tikonApp.serviceItem.gapTime\" for=\"field_gapTime\">Gap Time</label>&ndash;&gt;--><!--&lt;!&ndash;<input id=\"field_gapTime\" type=\"number\" class=\"form-control shortInput\"&ndash;&gt;--><!--&lt;!&ndash;ng-model=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.gaptime\"/>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--></div></form>");
$templateCache.put("app/components/partial-forms/wizard-forms/last-step/wizard-form.last-step.html","<style>.feature-box {\n        border: 1px solid darkgrey;\n        border-radius: 7px;\n        padding: 10px;\n        margin: 10px auto;\n        text-align: center;\n        max-width: 450px;\n    }\n\n    .feature-box .icon {\n        width: 150px;\n        height: 150px;\n        margin: auto;\n        background-size: contain;\n        background-position: center;\n        background-repeat: no-repeat;\n    }</style><div><div style=\"text-align: center\"><!--<h3 style=\"color: #32a2bd\">--><!--سیستم با موفقیت راه اندازی شد و آماده ی استفاده است .--><!--</h3>--><h5 style=\"color: #867f7f\"><span translate=\"wizard.lastStepWebSiteDesc\"></span></h5><h4><a ng-click=\"$ctrl.goToSite()\">{{$ctrl.getWebSiteUrl()}}</a></h4></div><hr><div style=\"padding-top: 20px;color: #867f7f\"><div class=\"row wizard-last-step-info\"><!--<div class=\"col-sm-1 wizard-last-step-info-icon\" >--><!--<i class=\"fa fa-instagram fa-2x socialNetwork-INSTAGRAM\" ></i>--><!--</div>--><!--<div class=\"col-md-5\">--><!--<span style=\"font-weight: bold\">--><!--اشتراک گذاری در شبکه های اجتماعی--><!--</span>--><!--<p>--><!--شما می توانید لینک را در کانال تلگرام یا اینستاگرام خود قرار دهید تا مشتریان به راحتی عملیات رزرو را انجام دهند .--><!--</p>--><!--</div>--><!--<div class=\"col-sm-1 wizard-last-step-info-icon\">--><!--<i class=\"fa fa-globe fa-2x wizard-last-step-info-icon-GLOBE\"></i>--><!--</div>--><!--<div class=\"col-md-5\">--><!--<span style=\"font-weight: bold\">--><!--اتصال به وبسایت شما--><!--</span>--><!--<p>--><!--می توانید سیستم را به سایت خودتون متصل کنید و مشتریان شما می توانند با ورود به سایت شما خدمات را مشاهده و رزرو کنند.--><!--</p>--><!--</div>--><div class=\"col-sm-6\"><div class=\"feature-box\"><a ng-href=\"{{$ctrl.getFeatureListUrl()}}\" target=\"_blank\"><div class=\"icon\"><img class=\"\" style=\"width: 100%\" src=\"content/images/features/feature-icon.svg\"></div><h4 translate=\"wizard.seeSystemFeatures\">wizard.seeSystemFeatures</h4></a></div></div><div class=\"col-sm-6\"><div class=\"feature-box\"><a ng-href=\"{{$ctrl.getHelpUrl()}}\" href=\"\" target=\"_blank\"><div class=\"icon\"><img class=\"\" style=\"width: 100%\" src=\"content/images/special-support.png\"></div><h4 translate=\"wizard.tutorialsAndSupport\">wizard.tutorialsAndSupport</h4></a></div></div></div><!--<div class=\"row wizard-last-step-info\">--><!--<div class=\"col-sm-1 wizard-last-step-info-icon\">--><!--<i class=\"fa fa-telegram fa-2x socialNetwork-TELEGRAM\"></i>--><!--</div>--><!--<div class=\"col-md-5\">--><!--<span style=\"font-weight: bold\">--><!--ربات تلگرام اختصاصی برای رزرو--><!--</span>--><!--<p>--><!--در صورت تمایل می توانیم ربات تلگرامی شخصی برای شما ایجاد کنیم که مشتریان شما از طریق ربات شخصی شما به راحتی خدمات شما را مشاهده و رزرو کنند. (برای درخواست ربات با یکی از راههای ارتباطی با ما تماس بگیرید)--><!--</p>--><!--</div>--><!--<div class=\"col-sm-1 wizard-last-step-info-icon\">--><!--<i class=\"fa fa-calendar fa-2x wizard-last-step-info-icon-TIMEBOARD\"></i>--><!--</div>--><!--<div class=\"col-md-5\">--><!--<span style=\"font-weight: bold\">--><!--مدیریت رزروها--><!--</span>--><!--<p>--><!--شما میتوانید رزروهای تلفنی یا حضوری را از طریق پنل و از قسمت--><!--<a  ui-sref=\"supplierPanel.timeBoard\" style=\"text-decoration: underline\" >--><!--تقویم کاری--><!--</a>--><!--انجام دهید . و میتوانید لیست رزروهای انجام شده را از طریق--><!--<a ui-sref=\"supplierPanel.orderBagList\" style=\"text-decoration: underline\" >--><!--لیست رزروها--><!--</a>--><!--مشاهده کنید.--><!--</p>--><!--</div>--><!--</div>--></div></div>");
$templateCache.put("app/components/partial-forms/wizard-forms/service-item/wizard-form.service-item.html","<style></style><form name=\"ServiceItemform\"><div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"wizard.firstServiceItem\"></span></legend><div class=\"col-md-4\"><div class=\"form-group\" ng-if=\"$ctrl.companyActivityType != \'WORK_SPACE\'\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" placeholder=\"{{\'tikonApp.serviceItem.ServiceItemSampleByActivityType.ActivityType.\'+$ctrl.companyActivityType | translate}} \" required class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"$ctrl.serviceItem.itemTitle\"><div class=\"error-message\" ng-messages=\"ServiceItemform.itemTitle.$error\" ng-show=\"ServiceItemform.itemTitle.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.serviceItem.itemTitle_isrequired\"></span></p></div></div><div class=\"form-group\" ng-if=\"$ctrl.companyActivityType == \'WORK_SPACE\'\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.wizardServantTitle\" for=\"field_wizardServantTitle\">Item Title</label><input type=\"text\" placeholder=\"{{\'tikonApp.serviceItem.ServiceItemSampleByActivityType.ActivityType.\'+$ctrl.companyActivityType | translate}} \" required class=\"form-control\" name=\"wizardServantTitle\" id=\"field_wizardServantTitle\" ng-model=\"$ctrl.servant.personInfo.fisrtName\"><div class=\"error-message\" ng-messages=\"ServiceItemform.wizardServantTitle.$error\" ng-show=\"ServiceItemform.wizardServantTitle.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.serviceItem.itemTitle_isrequired\"></span></p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.minPrice\" for=\"field_minPrice\">Min Price</label><span translate=\"global.currencyBracket\"></span> <input type=\"number\" required class=\"form-control\" name=\"minPrice\" id=\"field_minPrice\" ng-model=\"$ctrl.serviceItem.minPrice\" min=\"0\"><div class=\"error-message\" ng-messages=\"ServiceItemform.minPrice.$error\" ng-show=\"ServiceItemform.minPrice.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.serviceItem.minPrice_isrequired\"></span></p><p ng-message=\"type\"><span translate=\"tikonApp.serviceItem.minPrice_isnotvalid\"></span></p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.duration\" for=\"field_duration\">Duration</label><input type=\"number\" required class=\"form-control\" name=\"duration\" id=\"field_duration\" ng-model=\"$ctrl.serviceItem.duration\" min=\"15\"><div class=\"error-message\" ng-messages=\"ServiceItemform.duration.$error\" ng-show=\"ServiceItemform.duration.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.serviceItem.duration_isrequired\"></span></p><p ng-message=\"min\"><span translate=\"tikonApp.serviceItem.duration_isnotvalid\"></span></p><p ng-message=\"type\"><span translate=\"tikonApp.serviceItem.duration_isnotvalid\"></span></p></div></div></div><!--<div class=\"col-md-8\" >--><!--<div class=\"form-group\">--><!--<label class=\"control-label\" required translate=\"tikonApp.serviceItem.description\" for=\"field_description\">Description</label>--><!--<input type=\"text\" required  maxlength=\"250\" class=\"form-control\" name=\"description\" id=\"field_description\"--><!--ng-model=\"$ctrl.serviceItem.description\"--><!--/>--><!--<div class=\"error-message\" ng-messages=\"ServiceItemform.description.$error\" ng-show=\"ServiceItemform.description.$touched\">--><!--<p ng-message=\"required\">--><!--<span translate=\"tikonApp.serviceItem.description_isrequired\"></span>--><!--</p>--><!--</div>--><!--</div>--><!--</div>--></fieldset></div><div class=\"row\" ng-if=\"$ctrl.companyActivityType != \'WORK_SPACE\'\"><fieldset class=\"standard-fieldset\"><legend><span translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">servantTab</span> <span translate=\"tikonApp.serviceItem.ServantSampleByActivityType.ActivityType.{{$ctrl.companyActivityType}}\"></span></legend><!--<div class=\"panel \">--><!--<div class=\"panel-heading\">--><!--<span translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">servantTab</span>--><!--</div>--><!--<div class=\"panel-body\">--><div id=\"servants\"><pf-service-item-servants servants=\"$ctrl.serviceItem.servants\" service-item-id=\"$ctrl.serviceItem.id\" form-state=\"vm.servantFormState\" disable-add-new=\"true\"></pf-service-item-servants></div><!--</div>--><!--</div>--></fieldset></div></div></form>");
$templateCache.put("app/components/partial-forms/wizard-forms-v2/company-info-v2/wizard-form.company-info-v2.html","<style>.keyurl {\n        /*width: 100%;*/\n        text-align: center;\n        font-size: 1em;\n        font-weight: bold;\n        color: #1a2c51;\n        height: 38px;\n        padding-top: 6px;\n        background-color: rgb(247, 250, 250);\n        border-bottom: 1px solid #d2d2d2;\n    }\n\n    .keyurl input {\n        text-align: center;\n        /*width: 135px;*/\n        /*color: #04796e;*/\n        font-size: 1.1em;\n        border: solid 1px;\n\n    }</style><form name=\"companyinfoform\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{ \'has-error\': companyinfoform.title.$touched && companyinfoform.title.$invalid }\"><label class=\"control-label\" translate=\"tikonApp.company.wizard_title_v2\" for=\"field_title\">Title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"$ctrl.company.title\" required eo-required=\"\"><div class=\"error-message\" ng-messages=\"companyinfoform.title.$error\" ng-show=\"companyinfoform.title.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.title_isrequired\"></span></p></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.activityType\" for=\"field_activityType\">Activity Type</label><pf-activity-type-selector id=\"field_activityType\" activity-type=\"$ctrl.company.activityType\" is-required=\"true\"></pf-activity-type-selector><div class=\"error-message\" ng-messages=\"companyinfoform.activityType.$error\" ng-show=\"companyinfoform.activityType.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.activityType_isrequired\"></span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control text-ltr\" name=\"phoneNumber\" id=\"field_phoneNumber\" ng-model=\"$ctrl.company.phoneNumber\" required eo-required=\"\"><div class=\"error-message\" ng-messages=\"companyinfoform.phoneNumber.$error\" ng-show=\"companyinfoform.phoneNumber.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.phoneNumber_isrequired\"></span></p></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"tikonApp.company.wizard_keyUrl\" for=\"field_keyUrl\">Key Url</label><div class=\"keyurl text-ltr\"><input type=\"text\" name=\"keyUrl\" id=\"field_keyUrl\" minlength=\"3\" maxlength=\"21\" pattern=\"[a-zA-Z0-9]{3,22}$\" ng-model=\"$ctrl.company.keyUrl\" required eo-required=\"\">.{{$ctrl.__config.domain}}</div><div class=\"error-message\" ng-messages=\"companyinfoform.keyUrl.$error\" ng-show=\"companyinfoform.keyUrl.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.keyUrl_isrequired\"></span></p><p ng-message=\"pattern\"><span translate=\"tikonApp.company.keyUrl_isnotvalid\"></span></p><p ng-message=\"maxlength\"><span translate=\"tikonApp.company.keyUrl_lengthisnotvalid\"></span></p><p ng-message=\"minlength\"><span translate=\"tikonApp.company.keyUrl_lengthisnotvalid\"></span></p></div><div class=\"error-message\" ng-if=\"$ctrl.isUrlValid == false\"><p><span translate=\"tikonApp.company.keyUrl_isexist\"></span></p></div></div></div></div><div ng-if=\"$ctrl.company.activityType\" class=\"row\"><div class=\"col-md-6\"><label for=\"resourceCount\">تعداد {{ $ctrl.servant_label }}</label><md-select ng-model=\"$ctrl.userInsight.resourceCount\" ng-required=\"true\" class=\"rwMdSelect\" name=\"resourceCount\" id=\"resourceCount\"><md-option value=\"ONE\">1</md-option><md-option value=\"BETWEEN_TWO_AND_FIVE\">2-5</md-option><md-option value=\"BETWEEN_FIVE_AND_TEN\">5-10</md-option><md-option value=\"MORE_THAN_TEN\">بیشتر از 10</md-option></md-select><div class=\"error-message\" ng-messages=\"companyinfoform.resourceCount.$error\" ng-show=\"companyinfoform.resourceCount.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.company.resourceCount_isrequired\"></span></p></div></div></div></form>");
$templateCache.put("app/components/partial-forms/wizard-forms-v2/company-schedule-v2/wizard-form.company-schedule-v2.html","<style></style><form name=\"CompanyScheduleform\"><div><div class=\"row\"><div class=\"col-sm-2\"><label class=\"group-label\" translate=\"tikonApp.serviceItem.timePeriod\">time period</label></div><div class=\"col-sm-10\"><eo-time-range start-time=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime\" end-time=\"$ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime\"></eo-time-range></div></div><div class=\"row\"><div class=\"col-sm-12\"><pf-weekly-work-days-v2 selected-weekly-schedule-info=\"$ctrl.schedule.weeklyScheduleInfo\"></pf-weekly-work-days-v2></div></div></div></form>");
$templateCache.put("app/components/partial-forms/wizard-forms-v2/last-step-v2/wizard-form.last-step-v2.html","<style>.feature-box {\n        border: 1px solid darkgrey;\n        border-radius: 7px;\n        padding: 10px;\n        margin: 10px auto;\n        text-align: center;\n        max-width: 450px;\n    }\n\n    .feature-box .icon {\n        width: 150px;\n        height: 150px;\n        margin: auto;\n        background-size: contain;\n        background-position: center;\n        background-repeat: no-repeat;\n    }</style><div class=\"last-step-class\"><div style=\"text-align: center;padding-top: 30px\"><!--<h3 style=\"color: #32a2bd\">--><!--سیستم با موفقیت راه اندازی شد و آماده ی استفاده است .--><!--</h3>--><h4>از طریق لینک زیر می‌توانید سایت خود را مشاهده کنید:</h4><h4><a ng-click=\"$ctrl.goToSite()\"><md-icon>open_in_new</md-icon>{{$ctrl.getWebSiteUrl()}}</a></h4></div><hr><div style=\"padding-top: 20px;color: #867f7f\"><div class=\"row wizard-last-step-info\"><div class=\"col-sm-6\"><div class=\"feature-box\"><a ng-href=\"{{$ctrl.getFeatureListUrl()}}\" target=\"_blank\"><div class=\"icon\"><img class=\"\" style=\"width: 100%\" src=\"content/images/features/feature-icon.svg\"></div><h4 translate=\"wizard.seeSystemFeatures\">wizard.seeSystemFeatures</h4></a></div></div><div class=\"col-sm-6\"><div class=\"feature-box\"><a ng-href=\"{{$ctrl.getHelpUrl()}}\" href=\"\" target=\"_blank\"><div class=\"icon\"><img class=\"\" style=\"width: 100%\" src=\"content/images/special-support.png\"></div><h4 translate=\"wizard.tutorialsAndSupport\">wizard.tutorialsAndSupport</h4></a></div></div></div></div></div>");
$templateCache.put("app/components/partial-forms/wizard-forms-v2/service-item-v2/wizard-form.service-item-v2.html","<style></style><form name=\"ServiceItemform\"><div><fieldset class=\"standard-fieldset\"><legend><span translate=\"wizard.firstServiceItem\"></span></legend><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-if=\"$ctrl.companyActivityType != \'WORK_SPACE\'\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.itemTitle\" for=\"field_itemTitle\">Item Title</label><input type=\"text\" placeholder=\"{{$ctrl.activityTypeInfo.serviceSamplePlaceHolder}} \" required class=\"form-control\" name=\"itemTitle\" id=\"field_itemTitle\" ng-model=\"$ctrl.serviceItem.itemTitle\"><div class=\"error-message\" ng-messages=\"ServiceItemform.itemTitle.$error\" ng-show=\"ServiceItemform.itemTitle.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.serviceItem.itemTitle_isrequired\"></span></p></div></div><div class=\"form-group\" ng-if=\"$ctrl.companyActivityType == \'WORK_SPACE\'\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.wizardServantTitle\" for=\"field_wizardServantTitle\">Item Title</label><input type=\"text\" placeholder=\"{{\'tikonApp.serviceItem.ServiceItemSampleByActivityType.ActivityType.\'+$ctrl.companyActivityType | translate}} \" required class=\"form-control\" name=\"wizardServantTitle\" id=\"field_wizardServantTitle\" ng-model=\"$ctrl.servant.personInfo.fisrtName\"><div class=\"error-message\" ng-messages=\"ServiceItemform.wizardServantTitle.$error\" ng-show=\"ServiceItemform.wizardServantTitle.$touched\"><p ng-message=\"required\"><span translate=\"tikonApp.serviceItem.itemTitle_isrequired\"></span></p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.minPrice\" for=\"field_minPrice\">Min Price</label><span translate=\"global.currencyBracket\"></span><!--<input type=\"number\" required class=\"form-control\" name=\"minPrice\" id=\"field_minPrice\"--><!--ng-model=\"$ctrl.serviceItem.minPrice\" min=\"0\"--><!--/>--><eo-numeric-input-v2 id=\"field_minPrice\" name=\"minPrice\" custom-class=\"form-control\" input-value=\"$ctrl.serviceItem.minPrice\" is-required=\"true\" form-reference=\"ServiceItemform\" currency-format=\"true\"></eo-numeric-input-v2></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" required translate=\"tikonApp.serviceItem.duration\" for=\"field_duration\">Duration</label><!--<input type=\"number\" required class=\"form-control\" name=\"duration\" id=\"field_duration\"--><!--ng-model=\"$ctrl.serviceItem.duration\" min=\"15\"--><!--/>--><eo-numeric-input id=\"field_duration\" name=\"duration\" custom-class=\"form-control\" input-value=\"$ctrl.serviceItem.duration\" is-required=\"true\" form-reference=\"ServiceItemform\" min=\"10\"></eo-numeric-input></div></div></div><div class=\"row\"><fieldset class=\"standard-fieldset\"><legend><!--<span translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">--><!--servantTab</span>--><!--<span translate=\"tikonApp.serviceItem.ServantSampleByActivityType.ActivityType.{{$ctrl.companyActivityType}}\">--><!--</span>--> <span ng-if=\"$ctrl.activityTypeInfo.servantType !=\'RESOURCE\'\" translate=\"supplierPanel.sideMenu.serviceItem.servantTab\">ServantTab</span> <span ng-if=\"$ctrl.activityTypeInfo.servantType !=\'RESOURCE\'\" eo-help-tooltip=\"tips.service_servants-v2\">({{$ctrl.activityTypeInfo.servantListTitle}}) </span><span ng-if=\"$ctrl.activityTypeInfo.servantType ==\'RESOURCE\'\" translate=\"supplierPanel.sideMenu.serviceItem.servantTab-space\">servantTab</span> <span ng-if=\"$ctrl.activityTypeInfo.servantType ==\'RESOURCE\'\">({{$ctrl.activityTypeInfo.servantListTitle}})</span></legend><div style=\"padding: 10px 20px 20px\"><md-icon style=\"background-color: var(--rw-panel-border-color);\n                            border-radius: 3px\">check</md-icon>{{$ctrl.servant.personInfo.fisrtName}} {{$ctrl.servant.personInfo.lastName}}</div></fieldset></div></fieldset></div></form>");}]);})();